/** 
 * Flexmonster Pivot Table & Charts [https://www.flexmonster.com/]
 * March 2023 (v. 2.9.46)
 * Copyright (c) 2023 Flexmonster. All rights reserved.
 *
 * Flexmonster Pivot Table & Charts commercial licenses may be obtained at
 * https://www.flexmonster.com/pivot-table-editions-and-pricing/
 * If you do not own a commercial license, this file shall be governed by the trial license terms.
 */
(function (a, b) {
  "function" === typeof define && define.amd && define("flexmonster", [], b);
  a.Flexmonster = b();
})(window, function () {
  return function (a) {
    /*
    jsSHA | Copyright (c) 2008-2015 Brian Turek [https://caligatio.github.com/jsSHA/] | BSD License [https://github.com/Caligatio/jsSHA/blob/v2.3.1/LICENSE] */
    'use strict';

    var q;
    (function (e) {
      function k(f) {
        return "undefined" === typeof f || null === f;
      }
      class h {
        constructor() {}
        static cS(f, b) {
          if (f == b) return 0;
          f = f.split(".");
          b = b.split(".");
          if (f.length < b.length) return -1;
          if (f.length > b.length) return 1;
          for (var a = 0; a < f.length; a++) {
            var c = parseInt(f[a]),
              d = parseInt(b[a]);
            if (c < d) return -1;
            if (c > d) return 1;
          }
          return 0;
        }
        static Zc(f) {
          return void 0 !== f && null !== f && ("true" == f.toLowerCase() || "on" == f.toLowerCase());
        }
        static eM() {
          var f = new Date().getTime() - new Date(2012, 2, 8).getTime() * Math.round(123456789 * Math.random());
          if (h.wDa == f) return f.toString(35) + (h.Cfa++).toString();
          h.wDa = f;
          h.Cfa = 0;
          return f.toString(35);
        }
        static bind(f) {
          if (k(f)) return f;
          for (var _len = arguments.length, b = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            b[_key - 1] = arguments[_key];
          }
          for (var a = 0; a < b.length; a++) f = f.replace(new RegExp("\\{" + a + "\\}", "gi"), null == b[a] ? "" : b[a].toString());
          return f;
        }
        static Lx(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          return isNaN(f) ? e.model.B.j.Wn : u.Eh.Xya(f, b);
        }
        static Kx(f, b, a) {
          void 0 === b && (b = "dd/MM/yyyy");
          if (isNaN(f) || 0 === f) return e.model.B.j.Wn;
          f = new Date(f);
          return isNaN(f.getTime()) ? "" : u.Eh.format(f, b, a);
        }
        static iO(f, b, a) {
          void 0 === b && (b = "dd/MM/yyyy HH:mm:ss");
          return h.Kx(f, b, a);
        }
        static gU(f) {
          return Date.parse(f) && this.fEa(f);
        }
        static fEa(f) {
          return this.pDa.test(f);
        }
        static Ho(f) {
          if (k(f)) return 0;
          if ("#" === f.substr(0, 1)) return parseInt(f.substr(1), 16);
          "transparent" == f && (f = "rgb(255,255,255)");
          f = f.replace(/[^\d,]/g, "");
          f = f.split(",");
          var b = parseInt(f[0]),
            a = parseInt(f[1]),
            c = parseInt(f[2]);
          0 === parseInt(f[3]) && (b = a = c = 255);
          return c | a << 8 | b << 16;
        }
        static D5(f) {
          for (var b = new Uint8Array(f.length), a = 0, c = f.length; a < c; ++a) b[a] = f.charCodeAt(a);
          return b;
        }
        static $ba(f) {
          f = -1 !== f.split(",")[0].indexOf("base64") ? atob(f.split(",")[1]) : decodeURI(f.split(",")[1]);
          return h.D5(f);
        }
        static jxa(f) {
          for (var b = f.length, a = Array(b); b--;) a[b] = String.fromCharCode(f[b]);
          return a.join("");
        }
        static contains(f, b) {
          return k(f) ? !1 : -1 < f.toLowerCase().indexOf(b);
        }
        static J5(f) {
          if (null == f) return NaN;
          if ("number" === typeof f) return f;
          "string" !== typeof f && (f = f.toString());
          "," == e.model.ac.pj.pT().Kf && (f = f.replace(/,/gi, ""));
          f = f.replace(",", ".");
          f = f.replace(/[^[,|\.|\-|\d|e]]*/gi, "");
          return parseFloat(f);
        }
        static trim(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (null == f) return "";
          for (var a = 0; h.K2(f.charAt(a), b);) ++a;
          for (var c = f.length - 1; h.K2(f.charAt(c), b);) --c;
          return c >= a ? f.slice(a, c + 1) : "";
        }
        static trimLeft(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (null == f) return "";
          for (var a = 0; h.K2(f.charAt(a), b);) ++a;
          b = f.length - 1;
          return b >= a ? f.slice(a, b + 1) : "";
        }
        static K2(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (null != b && f == b) return !1;
          switch (f) {
            case " ":
            case "\t":
            case "\r":
            case "\n":
            case "\f":
              return !0;
          }
          return !1;
        }
        static ECa(f) {
          for (var b in h.UL) if (h.UL[b] == f) return !0;
          return !1;
        }
        static cH(f) {
          return "string" !== typeof f || "=" != f.charAt(0) && "@" != f.charAt(0) ? f : "'" + f;
        }
        static jya(f) {
          return f.replace(/[\s]{2,}/g, function (b) {
            let a = "";
            var c = 0;
            for (b = b.length; c < b; c++) a += "&nbsp;";
            return a;
          });
        }
        static Go(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          if (k(f)) return "";
          a && (f = h.jya("" + f));
          return b ? f.replace(/[<>"'\/]/g, c => h.UL[c]) : f.replace(/[&<>"'\/]/g, c => h.UL[c]);
        }
        static kya(f) {
          if (k(f)) return "";
          f = f.replace(/[&<>"']/g, b => h.UL[b]);
          return f.replace(/[\s]{2,}/g, b => {
            let a = "";
            var c = 0;
            for (b = b.length; c < b; c++) a += " ";
            return a;
          });
        }
        static Rza() {
          return new Uint8Array([239, 187, 191]);
        }
        static bca(f) {
          h.cca.innerHTML = f;
          return h.cca.value;
        }
      }
      h.Cfa = 0;
      h.pDa = /^(?:[\+-]?\d{4}(?!\d{2}\b))-(?:0[1-9]|1[0-2])(?:(-?)(?:(?:[12]\d|0[1-9]|3[01])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24:?00)(?:[\.,]\d+(?!:))?)?(?:\2[0-5]\d(?:[\.]\d+)?)?(?:[zZ]|(?:[\+-])(?:[01]\d|2[0-3]):?(?:[0-5]\d)?)?)?)?$/;
      h.UL = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&sol;"
      };
      h.cca = document.createElement("textarea");
      e.P = h;
      e.v = k;
      e.Kg = function (f) {
        return "function" === typeof f;
      };
      e.ia = function (f) {
        if (k(f)) return !0;
        "string" !== typeof f && (f = "" + f);
        return 0 === f.trim().length;
      };
      e.kPa = function (f) {
        return f.replace(/\|/g, "{%7C}");
      };
      e.jPa = function (f) {
        return f.replace(/{%7C}/g, "|");
      };
      e.RK = function (f, b) {
        var a = new Date(f.getTime()),
          c = b.match(/year|y|quarter|q|month|M|week|w|day|d|hour|h|minute|m|second|s/);
        if (!c) return a;
        c = c[0];
        if ("year" == c || "y" == c) return a.setUTCFullYear(f.getUTCFullYear() + 1), a;
        if ("quarter" == c || "q" == c) return a.setUTCMonth(f.getUTCMonth() + 3), a;
        if ("month" == c || "M" == c) return a.setUTCMonth(f.getUTCMonth() + 1), a;
        if ("week" == c || "w" == c) return a.setUTCDate(f.getUTCDate() + 7), a;
        if ("day" == c || "d" == c) return a.setUTCDate(f.getUTCDate() + 1), a;
        b = parseInt(b) || 1;
        if ("hour" == c || "h" == c) return a.setUTCHours(f.getUTCHours() + b), a;
        if ("minute" == c || "m" == c) return a.setUTCMinutes(f.getUTCMinutes() + b), a;
        "second" != c && "s" != c || a.setUTCSeconds(f.getUTCSeconds() + b);
        return a;
      };
      e.oIa = function (f) {
        var b = document.createElement("a");
        b.href = f;
        f = {
          protocol: b.protocol,
          host: b.host,
          hostname: b.hostname,
          port: b.port,
          pathname: b.pathname,
          search: b.search,
          hash: b.hash
        };
        -1 < f.protocol.indexOf(":") && (f.protocol = f.protocol.substr(0, f.protocol.length - 1));
        return f;
      };
    })(q || (q = {}));
    (function (e) {
      class k {
        constructor(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this.mi = 0;
          this.Fi = this.fi = this.Tu = !1;
          const b = void 0 === f.Gy ? !0 : f.Gy;
          h instanceof Date ? h = h.getTime() : void 0 === h && b ? h = e.v(window.flexmonster_test_now) ? Date.now() : new Date(window.flexmonster_test_now).getTime() : e.ia(h) || "null" === h ? (b ? this.Fi = !0 : this.fi = !0, h = NaN) : "number" === typeof h ? isNaN(h) && (this.fi = !0) : "string" === typeof h ? (e.ia(f.format) ? this.SCa(h) ? 10 == h.length ? h = Date.parse(h + "T00:00:00") : (h = new Date(h), h = h.getTime() + 6E4 * h.getTimezoneOffset()) : h = 8 > h.length || /\D+/.test(h.slice(1)) ? Date.parse(h) : parseInt(h) : h = this.KHa(h, f.format), isNaN(h) && (this.fi = !0)) : (this.Fi = !0, h = NaN);
          this.rc = isNaN(h) ? new Date(NaN) : new Date(h);
          this.uh(this.rc.getTimezoneOffset());
          this.Tu = !0;
        }
        SCa(h) {
          return 4 == h.length || 7 == h.length && "-" == h.charAt(4) || 10 == h.length && "-" == h.charAt(4) && "-" == h.charAt(7) ? !0 : !1;
        }
        round(h) {
          if (!e.ia(h)) {
            var f = h.match(/[s|M|m|w|q|h|d|y]$/);
            h = parseFloat(h.substring(0, h.length - 1));
            if (!isNaN(h) && null !== f) {
              switch (f[0]) {
                case "s":
                  var b = h;
                  break;
                case "m":
                  b = 60 * h;
                  break;
                case "h":
                  b = 3600 * h;
                  break;
                case "d":
                  b = 86400 * h;
                  break;
                case "w":
                  this.oja();
                  break;
                case "M":
                  this.II();
                  break;
                case "q":
                  this.nja();
                  break;
                case "y":
                  this.pja();
              }
              void 0 !== b && (b *= 1E3, this.rc.setTime(Math.floor(this.rc.getTime() / b) * b));
            }
          }
        }
        getDate() {
          if (!this.Fi && !this.fi) return this.rc.getUTCDate();
        }
        setDate(h) {
          if (!this.Fi && !this.fi) return this.rc.setUTCDate(h), this.Tu && this.uh(this.rc.getTimezoneOffset(), !1), this;
        }
        getDay() {
          if (!this.Fi && !this.fi) return this.rc.getUTCDay();
        }
        getFullYear() {
          if (!this.Fi && !this.fi) return this.rc.getUTCFullYear();
        }
        setFullYear(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          if (!this.Fi && !this.fi) return e.v(f) ? this.rc.setUTCFullYear(h) : e.v(b) ? this.rc.setUTCFullYear(h, f) : this.rc.setUTCFullYear(h, f, b), this;
        }
        getHours() {
          if (!this.Fi && !this.fi) return this.rc.getUTCHours();
        }
        setHours(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          let a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          if (!this.Fi && !this.fi) return e.v(f) ? this.rc.setUTCHours(h) : e.v(b) ? this.rc.setUTCHours(h, f) : e.v(a) ? this.rc.setUTCHours(h, f, b) : this.rc.setUTCHours(h, f, b, a), this.Tu && this.uh(this.rc.getTimezoneOffset(), !1), this;
        }
        getMilliseconds() {
          if (!this.Fi && !this.fi) return this.rc.getUTCMilliseconds();
        }
        setMilliseconds(h) {
          if (!this.Fi && !this.fi) return this.rc.setUTCMilliseconds(h), this.Tu && this.uh(this.rc.getTimezoneOffset(), !1), this;
        }
        getMinutes() {
          if (!this.Fi && !this.fi) return this.rc.getUTCMinutes();
        }
        setMinutes(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          if (!this.Fi && !this.fi) return e.v(f) ? this.rc.setUTCMinutes(h) : e.v(b) ? this.rc.setUTCMinutes(h, f) : this.rc.setUTCMinutes(h, f, b), this.Tu && this.uh(this.rc.getTimezoneOffset(), !1), this;
        }
        getMonth() {
          if (!this.Fi && !this.fi) return this.rc.getUTCMonth();
        }
        setMonth(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!this.Fi && !this.fi) return e.v(f) ? this.rc.setUTCMonth(h) : this.rc.setUTCMonth(h, f), this.Tu && this.uh(this.rc.getTimezoneOffset(), !1), this;
        }
        getSeconds() {
          if (!this.Fi && !this.fi) return this.rc.getUTCSeconds();
        }
        setSeconds(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!this.Fi && !this.fi) return e.v(f) ? this.rc.setUTCSeconds(h) : this.rc.setUTCSeconds(h, f), this.Tu && this.uh(this.rc.getTimezoneOffset(), !1), this;
        }
        getTimezoneOffset() {
          if (!this.Fi && !this.fi) return this.mi;
        }
        uh(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          if (!this.Fi && !this.fi) {
            if (isNaN(h) || e.v(h)) return this;
            this.Tu = !1;
            0 != h && 60 > Math.abs(h) && (h *= -60);
            h !== this.mi && (f && this.rc.setUTCMinutes(this.rc.getUTCMinutes() + (this.mi - h)), this.mi = h);
            return this;
          }
        }
        getTime() {
          return this.Fi || this.fi ? NaN : this.rc.getTime() + 6E4 * this.mi;
        }
        RZ(h) {
          this.setDate(this.getDate() + h);
          return this;
        }
        tta(h) {
          this.setMonth(this.getMonth() + h);
        }
        pja() {
          this.setMonth(0, 1);
          this.Pn();
        }
        nja() {
          9 <= this.getMonth() ? this.setMonth(9, 1) : 6 <= this.getMonth() ? this.setMonth(6, 1) : 3 <= this.getMonth() ? this.setMonth(3, 1) : 0 <= this.getMonth() && this.setMonth(0, 1);
          this.Pn();
        }
        II() {
          this.setDate(1);
          this.Pn();
          return this;
        }
        oja() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          this.setDate(this.getDate() - (this.getDay() - h + 7) % 7);
          this.Pn();
        }
        Pn() {
          this.setHours(0, 0, 0, 0);
          return this;
        }
        M5(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          "day" == h ? this.Pn() : "week" == h ? this.oja(f) : "month" == h ? this.II() : "quarter" == h ? this.nja() : "year" == h && this.pja();
        }
        $Ka() {
          this.setMonth(11, 31);
          this.pA();
          return this;
        }
        YKa() {
          9 <= this.getMonth() ? this.setMonth(11, 1) : 6 <= this.getMonth() ? this.setMonth(8, 1) : 3 <= this.getMonth() ? this.setMonth(5, 1) : 0 <= this.getMonth() && this.setMonth(2, 1);
          this.setDate(k.f0(this.getMonth(), this.getFullYear()));
          this.pA();
          return this;
        }
        XKa() {
          this.setDate(k.f0(this.getMonth(), this.getFullYear()));
          this.pA();
          return this;
        }
        ZKa() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          this.setDate(this.getDate() + (6 - this.getDay() + h) % 7);
          this.pA();
          return this;
        }
        pA() {
          this.setHours(23, 59, 59, 999);
          return this;
        }
        I5(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          return "day" == h ? this.pA() : "week" == h ? this.ZKa(f) : "month" == h ? this.XKa() : "quarter" == h ? this.YKa() : "year" == h ? this.$Ka() : this;
        }
        ah() {
          return this.Fi || this.fi ? !1 : !isNaN(this.rc.getTime());
        }
        format(h) {
          return this.fi ? e.model.B.j.Wn : this.Fi ? "" : this.dDa(h) ? u.Eh.format(this.Kx(), h) : u.Eh.format(this.rc, "UTC:" + h);
        }
        dDa(h) {
          return null !== u.Eh.qg(h);
        }
        toString() {
          return this.format("yyyy-MM-dd HH:mm:ss");
        }
        Kx() {
          return new Date(this.getTime());
        }
        clone() {
          var h = new k();
          this.fi || this.Fi || (h.rc = new Date(this.rc.getTime()));
          h.mi = this.mi;
          h.Tu = this.Tu;
          return h;
        }
        KHa(h, f) {
          var b = NaN;
          const a = "UTC" === f.slice(0, 3);
          if ("UTC" === f.slice(0, 3) || "GMT" === f.slice(0, 3)) f = f.split(":")[1];
          "dd/MM/yyyy" === f ? (f = h.split("/"), b = a ? Date.UTC(parseInt(f[2]), parseInt(f[1]) - 1, parseInt(f[0])) : new Date(parseInt(f[2]), parseInt(f[1]) - 1, parseInt(f[0])).getTime()) : "dd-MM-yyyy" === f ? (f = h.split("-"), b = a ? Date.UTC(parseInt(f[2]), parseInt(f[1]) - 1, parseInt(f[0])) : new Date(parseInt(f[2]), parseInt(f[1]) - 1, parseInt(f[0])).getTime()) : "dd/MM/yyyy HH:mm:ss" === f && (f = h.split(" "), h = f[0].split("/"), e.ia(f[1]) ? b = a ? Date.UTC(parseInt(h[2]), parseInt(h[1]) - 1, parseInt(h[0])) : new Date(parseInt(h[2]), parseInt(h[1]) - 1, parseInt(h[0])).getTime() : (f = e.ia(f[1]) ? [] : f[1].split(":"), b = a ? Date.UTC(parseInt(h[2]), parseInt(h[1]) - 1, parseInt(h[0]), parseInt(f[0]), parseInt(f[1]), parseInt(f[2])) : new Date(parseInt(h[2]), parseInt(h[1]) - 1, parseInt(h[0]), parseInt(f[0]), parseInt(f[1]), parseInt(f[2])).getTime()));
          return b;
        }
        static f0(h, f) {
          return k.Sra[h] + (1 == h && 0 == f % 4 ? 1 : 0);
        }
        static D0(h, f) {
          return h && f ? h.getTime() == f.getTime() : h == f;
        }
      }
      k.Sra = {
        0: 31,
        1: 28,
        2: 31,
        3: 30,
        4: 31,
        5: 30,
        6: 31,
        7: 31,
        8: 30,
        9: 31,
        10: 30,
        11: 31
      };
      e.gh = k;
    })(q || (q = {}));
    (function (e) {
      class k {
        constructor() {
          (this.isNative = e.Kg(Set)) ? this.WB = new Set() : this.sy = [];
        }
        add(h) {
          if (this.isNative) return this.WB.add(h), this;
          0 > this.sy.indexOf(h) && this.sy.push(h);
          return this;
        }
        clear() {
          if (this.isNative) return this.WB.clear();
          this.sy.length = 0;
        }
        delete(h) {
          if (this.isNative) return this.WB.delete(h);
          h = this.sy.indexOf(h);
          if (0 > h) return !1;
          this.sy.splice(h, 1);
          return !0;
        }
        has(h) {
          return this.isNative ? this.WB.has(h) : 0 <= this.sy.indexOf(h);
        }
        get size() {
          return this.isNative ? this.WB.size : this.sy.length;
        }
        Pc() {
          if (this.isNative) {
            if (e.Kg(Array.from)) return Array.from(this.WB);
            const h = [];
            this.WB.forEach(f => h.push(f));
            return h;
          }
          return this.sy;
        }
      }
      e.kF = k;
    })(q || (q = {}));
    (function (e) {
      class k {
        constructor() {
          this.nl = {};
        }
        get target() {
          return null;
        }
        vG(c, d) {
          return c.type === d.type && c.Jb === d.Jb && c.W5 === d.W5;
        }
        T1(c, d) {
          if (e.v(this.nl[c])) return !1;
          for (var g = 0; g < this.nl[c].length; g++) if (this.vG(this.nl[c][g], d)) return !0;
          return !1;
        }
        addEventListener(c, d, g) {
          var l = {
            type: c,
            Jb: d,
            W5: g
          };
          this.T1(c, l) || (e.v(this.nl[c]) && (this.nl[c] = []), this.nl[c].push(l), this.target.addEventListener(c, d, g));
        }
        removeEventListener(c, d, g) {
          d = {
            type: c,
            Jb: d,
            W5: g
          };
          for (c in this.nl) {
            for (var l = [], m = 0; m < this.nl[c].length; m++) this.vG(this.nl[c][m], d) ? "boolean" === typeof g ? this.target.removeEventListener(c, this.nl[c][m].Jb, g) : this.target.removeEventListener(c, this.nl[c][m].Jb) : l.push(this.nl[c][m]);
            this.nl[c] = l;
          }
        }
        dispose() {
          for (var c in this.nl) for (var d = 0; d < this.nl[c].length; d++) this.target.removeEventListener(c, this.nl[c][d].Jb, !0), this.target.removeEventListener(c, this.nl[c][d].Jb, !1);
          this.nl = {};
        }
      }
      class h extends k {
        static R() {
          null === h.instance && (h.instance = new h());
          return h.instance;
        }
        get target() {
          return document.body;
        }
      }
      h.instance = null;
      class f extends k {
        static R() {
          null === f.instance && (f.instance = new f());
          return f.instance;
        }
        get target() {
          return document;
        }
      }
      f.instance = null;
      class b extends k {
        static R() {
          null === b.instance && (b.instance = new b());
          return b.instance;
        }
        get target() {
          return window;
        }
      }
      b.instance = null;
      class a {
        static dispose() {
          for (; 0 < a.hO.length;) clearTimeout(a.hO.pop());
          for (; 0 < a.QM.length;) clearInterval(a.QM.pop());
        }
      }
      a.hO = [];
      a.QM = [];
      e.Uqa = a;
      e.Be = function (c, d) {
        c = setTimeout(c, d);
        a.hO.push(c);
        return c;
      };
      e.kr = function (c) {
        clearTimeout(c);
        a.hO.splice(a.hO.indexOf(c), 1);
      };
      e.jda = function (c, d) {
        c = setInterval(c, d);
        a.QM.push(c);
        return c;
      };
      e.P0 = function (c) {
        clearInterval(c);
        a.QM.splice(a.QM.indexOf(c), 1);
      };
      e.Hn = h.R();
      e.Dk = f.R();
      e.aM = b.R();
    })(q || (q = {}));
    var u;
    (function (e) {
      class k {
        constructor() {}
        static QCa(h) {
          return null != h && (0 == h.indexOf("http://") || 0 == h.indexOf("https://"));
        }
        static qCa(h) {
          return null != h && 0 == h.indexOf("blob:http");
        }
        static FH(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (!h) return "()";
          h = h.trim();
          if (0 == h.length) return "()";
          if (k.qCa(h)) return h;
          f && (h += (-1 < h.indexOf("?") ? "&" : "?") + Math.round(Date.now() / 3600));
          if (k.QCa(h) || 0 == h.indexOf("file") || "/" == h.substr(0, 1) || "./" == h.substr(0, 2)) return h;
          if (-1 != h.indexOf("..")) {
            f = k.G_.split("/");
            "" == f[f.length - 1] && f.pop();
            for (h = h.split("/"); ".." == h[0] && (0 < h.length && h.shift(), 0 < f.length && f.pop(), 0 != f.length););
            h = f.join("/") + "/" + h.join("/");
            "/" == h.substr(0, 1) && (h = h.substring(1));
            return h;
          }
          return k.G_ + h;
        }
        static Dta(h) {
          return h += (-1 < h.indexOf("?") ? "&" : "?") + Math.round(Date.now() / 3600);
        }
      }
      k.G_ = "";
      e.py = k;
    })(u || (u = {}));
    (function (e) {
      class k {
        constructor() {}
        static format(h, f, b) {
          var a = !1,
            c = this.qg(f);
          "UTC:" == f.slice(0, 4) ? (f = f.slice(4), a = !0) : q.v(c) ? q.v(b) || (h = new Date(h.getTime() + 36E5 * (b + h.getTimezoneOffset() / 60))) : (f = f.slice(f.indexOf(":") + 1), h = new Date(h.getTime() + 36E5 * (c + h.getTimezoneOffset() / 60)));
          var d = a ? "getUTC" : "get";
          b = h[d + "Date"]();
          c = h[d + "Day"]();
          var g = h[d + "Month"](),
            l = h[d + "FullYear"](),
            m = h[d + "Hours"](),
            n = h[d + "Minutes"](),
            p = h[d + "Seconds"]();
          d = h[d + "Milliseconds"]();
          var t = a ? 0 : h.getTimezoneOffset(),
            r = {
              d: b,
              dd: k.Mn(b),
              ddd: k.Mu.OG[c],
              dddd: k.Mu.OG[c + 7],
              D: b,
              DD: k.Mn(b),
              DDD: k.Mu.OG[c],
              DDDD: k.Mu.OG[c + 7],
              M: g + 1,
              MM: k.Mn(g + 1),
              MMM: k.Mu.WU[g],
              MMMM: k.Mu.WU[g + 12],
              yy: String(l).slice(2),
              yyyy: l,
              YY: String(l).slice(2),
              YYYY: l,
              h: m % 12 || 12,
              hh: k.Mn(m % 12 || 12),
              H: m,
              HH: k.Mn(m),
              k: 0 == m ? 24 : m,
              kk: 0 == m ? 24 : k.Mn(m),
              m: n,
              mm: k.Mn(n),
              s: p,
              ss: k.Mn(p),
              l: k.Mn(d, 3),
              L: k.Mn(Math.round(d / 10)),
              t: 12 > m ? "a" : "p",
              tt: 12 > m ? "am" : "pm",
              T: 12 > m ? "A" : "P",
              TT: 12 > m ? "AM" : "PM",
              Z: a ? "UTC" : (String(h).match(k.TKa) || [""]).pop().replace(k.UKa, ""),
              o: (0 < t ? "-" : "+") + k.Mn(100 * Math.floor(Math.abs(t) / 60) + Math.abs(t) % 60, 4),
              S: ["th", "st", "nd", "rd"][3 < b % 10 ? 0 : (10 != b % 100 - b % 10 ? 1 : 0) * b % 10]
            };
          return f.replace(k.uja, function (w) {
            return w in r ? r[w] : w.slice(1, w.length - 1);
          });
        }
        static Xya(h, f) {
          var b = 0 > h;
          0 > h && (h *= -1);
          var a = Math.floor(h / 86400);
          f = null == f || "" == f ? 0 < a && null == q.model.C.F.ep ? "d'd' " + this.jca : this.jca : f;
          h = Math.round(h);
          var c = h % 60;
          h = (h - c) / 60;
          var d = h % 60;
          h = (h - d) / 60;
          var g = h % 24;
          b && (f = "-" + f);
          var l = {
            d: a,
            dd: k.Mn(a),
            H: g,
            HH: k.Mn(g),
            HHH: h,
            m: d,
            mm: k.Mn(d),
            s: c,
            ss: k.Mn(c)
          };
          return f.replace(k.uja, function (m) {
            return m in l ? l[m] : m.slice(1, m.length - 1);
          });
        }
        static qg(h) {
          h = h.substr(0, h.indexOf(":"));
          return "UTC" === h.slice(0, 3) ? 0 : "GMT" === h.slice(0, 3) ? 4 < h.length ? parseInt(h.substr(3)) : 0 : this.HI.hasOwnProperty(h.slice(0, 2)) ? this.HI[h.slice(0, 2)] : this.HI.hasOwnProperty(h.slice(0, 3)) ? this.HI[h.slice(0, 3)] : this.HI.hasOwnProperty(h.slice(0, 4)) ? this.HI[h.slice(0, 4)] : null;
        }
        static Mn(h, f) {
          h = "" + h;
          for (f = f || 2; h.length < f;) h = "0" + h;
          return h;
        }
        static YJa(h, f) {
          k.Mu.OG = f.concat(h);
        }
        static jKa(h, f) {
          k.Mu.WU = f.concat(h);
        }
        static rAa() {
          return k.Mu.OG.slice(7, 14);
        }
        static VAa() {
          return k.Mu.WU.slice(12, 24);
        }
      }
      k.jca = "HH:mm:ss";
      k.HI = {
        CET: 1,
        EET: 2,
        EAT: 3,
        GET: 4,
        CXT: 7,
        CST: 8,
        JST: 9,
        SAKT: 11,
        IDLE: 12,
        WAT: -1,
        AT: -2,
        ART: -3,
        AST: -4,
        EST: -5,
        CT: -6,
        MST: -7,
        PST: -8,
        AKST: -9,
        YST: -9,
        HST: -10,
        NT: -11,
        IDLW: -12
      };
      k.uja = /d{1,4}|D{1,4}|m{1,4}|M{1,4}|yy(?:yy)?|YY(?:YY)?|H{1,3}|([HhkMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g;
      k.TKa = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
      k.UKa = /[^-+\dA-Z]/g;
      k.Mu = {
        OG: "Sun Mon Tue Wed Thu Fri Sat Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
        WU: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec January February March April May June July August September October November December".split(" ")
      };
      e.Eh = k;
    })(u || (u = {}));
    (function (e) {
      class k {
        constructor() {}
        static sort(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          let b = arguments.length > 2 ? arguments[2] : undefined;
          var a = 1 === f % 2;
          f >>= 1;
          var c = 1 === f % 2;
          f = f >> 1 >> 1;
          var d = 1 === (f >> 1) % 2 ? (g, l) => {
            if (void 0 !== b) {
              if (e.v(l)) return -1;
              if (e.v(g)) return 1;
              g = b(g);
              l = b(l);
            }
            return isNaN(l) || null === l ? -1 : isNaN(g) || null === g ? 1 : g - l;
          } : a ? (g, l) => {
            if (e.ia(l)) return -1;
            if (e.ia(g)) return 1;
            if (void 0 !== b) {
              g = b(g);
              l = b(l);
              if (e.ia(l)) return -1;
              if (e.ia(g)) return 1;
            }
            return k.localeCompare(g, l);
          } : (g, l) => {
            if (e.ia(l)) return -1;
            if (e.ia(g)) return 1;
            if (void 0 !== b) {
              g = b(g);
              l = b(l);
              if (e.ia(l)) return -1;
              if (e.ia(g)) return 1;
            }
            return k.localeCompare(g.toLocaleLowerCase(), l.toLocaleLowerCase());
          };
          if (1 === f % 2) {
            f = [];
            for (a = 0; a < h.length; a++) f[a] = a;
            f.sort((g, l) => d(h[g], h[l]));
            c && f.reverse();
            return f;
          }
          h.sort(d);
          c && h.reverse();
          return h;
        }
        static localeCompare(h, f) {
          return h && h.localeCompare ? h.localeCompare(f) : h === f ? 0 : h > f ? 1 : -1;
        }
        static insert(h, f, b) {
          for (var a = 0; a < f.length; a++) h.splice(b + a, 0, f[a]);
        }
        static Hr(h, f) {
          if (void 0 !== h.push) return h.push(f), h;
          var b = new h.constructor(h.length + 1);
          b.set(h, 0);
          b.set([f], h.length);
          return b;
        }
        static re(h, f, b) {
          if (b >= h.length) return k.Hr(h, f);
          if (Array.isArray(h)) return h.splice(b, 0, f), h;
          var a = new h.constructor(h.length + 1);
          a.set(h.subarray(0, b));
          a.set([f], b);
          a.set(h.subarray(b), b + 1);
          return a;
        }
        static Ir(h, f) {
          if (Array.isArray(h)) return h.splice(f, 1), h;
          if (h instanceof Uint8Array || h instanceof Int8Array || h instanceof Uint16Array || h instanceof Uint32Array) {
            const b = h.length - 1;
            let a = null;
            h instanceof Uint8Array ? a = new Uint8Array(b) : h instanceof Int8Array ? a = new Int8Array(b) : h instanceof Uint16Array ? a = new Uint16Array(b) : h instanceof Uint32Array && (a = new Uint32Array(b));
            if (null == a) return h;
            a.set(h.subarray(0, f), 0);
            a.set(h.subarray(f + 1, h.length), f);
            return a;
          }
          return h;
        }
        static j3(h, f, b) {
          h.splice(b, 0, h.splice(f, 1)[0]);
        }
      }
      k.Ux = 1;
      k.lp = 2;
      k.Fv = 8;
      k.Qi = 16;
      e.Ja = k;
    })(q || (q = {}));
    void 0 === Array.prototype.findIndex && (Array.prototype.findIndex = function (e, k) {
      if (null == this) throw new TypeError("Array is null or undefined");
      for (var h = Object(this), f = h.length >>> 0, b = 0; b < f; b++) if (e.call(k, h[b], b, h)) return b;
      return -1;
    });
    void 0 === Array.prototype.find && (Array.prototype.find = function (e, k) {
      if (null == this) throw new TypeError("Array is null or undefined");
      for (var h = Object(this), f = h.length >>> 0, b = 0; b < f; b++) {
        var a = h[b];
        if (e.call(k, a, b, h)) return a;
      }
    });
    void 0 === Uint16Array.prototype.slice && Object.defineProperty(Uint16Array.prototype, "slice", {
      value: function (e, k) {
        return new Uint16Array(Array.prototype.slice.call(this, e, k));
      }
    });
    (function (e) {
      class k {
        constructor() {
          this.values = new Map();
          this.keys = [];
        }
        Ua(h, f) {
          this.values.has(h) || this.keys.push(h);
          this.values.set(h, f);
        }
        lta(h) {
          if (null != h) for (var f in h) h.hasOwnProperty(f) && this.Ua(f, h[f]);
        }
        unshift(h, f) {
          this.keys.unshift(h);
          this.values.set(h, f);
        }
        SK(h, f, b) {
          null != this.getItem(h) && this.removeItem(h);
          this.keys.splice(b, 0, h);
          this.values.set(h, f);
        }
        removeItem(h) {
          null != this.getItem(h) && (this.keys.splice(this.indexOf(h), 1), this.values.delete(h));
        }
        K4(h) {
          var f = this.keys[h];
          null != f && (this.keys.splice(h, 1), this.values.delete(f));
        }
        set length(h) {}
        get length() {
          return this.keys.length;
        }
        indexOf(h) {
          return this.keys.indexOf(h);
        }
        Bb(h) {
          return this.values.has(h);
        }
        getItem(h) {
          return this.values.get(h);
        }
        ea(h) {
          return this.values.get(this.keys[h]);
        }
        Oh(h) {
          return this.keys[h];
        }
        vT() {
          return this.values.get(this.keys[this.keys.length - 1]);
        }
        l3(h, f) {
          this.keys.splice(f, 0, this.keys.splice(h, 1)[0]);
        }
        slice() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          0 == f && (f = this.length - h);
          for (var b = new k(), a = 0; a < f; a++) this.length > a + h && (e.v(this.ea(a + h)) || b.Ua(this.Oh(a + h), this.ea(a + h)));
          return b;
        }
        concat(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          if (!f) return this.Pra(h), null;
          var b = new k();
          for (f = 0; f < this.length; f++) b.Ua(this.Oh(f), this.ea(f));
          for (f = 0; f < h.length; f++) b.Ua(h.Oh(f), h.ea(f));
          return b;
        }
        Pra(h) {
          var f,
            b = h.length;
          for (f = 0; f < b; f++) this.Ua(h.Oh(f), h.ea(f));
        }
        splice(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var b = new k();
          h + f > this.length && (f = this.length - h);
          1 > f && (f = this.length);
          for (var a = 0; a < this.length; a++) (a < h || a >= h + f) && b.Ua(this.Oh(a), this.ea(a));
          return b;
        }
        reverse() {
          var h,
            f = new k();
          for (h = this.length - 1; -1 < h; h--) f.Ua(this.Oh(h), this.ea(h));
          return f;
        }
        Pc() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          if (h) return this.keys.slice(0);
          h = [];
          for (var f = 0; f < this.length; f++) h.push(this.ea(f));
          return h;
        }
        toString() {
          var h = [],
            f;
          for (f in this.keys) {
            var b = "{" + f + ": " + this.getItem(f) + "}";
            h.push(b);
          }
          return h.join(", ");
        }
        Sa() {
          for (var h = {}, f = 0; f < this.keys.length; f++) {
            var b = this.keys[f];
            h[b] = this.getItem(b);
          }
          return h;
        }
        clear() {
          this.values = new Map();
          this.keys.length = 0;
        }
      }
      e.ub = k;
    })(q || (q = {}));
    (function (e) {
      class k {
        constructor() {
          this.quotes = [];
        }
        parse(h) {
          try {
            this.quotes = [];
            for (var f = [], b = !1, a = "", c = 0; c < h.length; c++) {
              var d = h.charAt(c);
              '"' == d || "'" == d ? (b && (this.quotes.push(a), f.push(d), a = ""), b = !b) : b && (a += d);
            }
            h = "  " + h;
            for (c = 0; c < this.quotes.length; c++) if ("truestyle" != this.quotes[c].toLowerCase()) {
              var g = f[c] + this.quotes[c] + f[c],
                l = h.substring(0, h.indexOf(g) + g.length + 2);
              var m = /(\w\w\w\()['|"][^'|^"]*['|"]/i;
              if (m.test(l)) h = h.replace(g, "@" + c);else {
                m = /(\W)['|"][^'|^"]*['|"]/i;
                var n = (-1 != l.indexOf("#value") || -1 != l.indexOf("#updateDifference") || -1 != l.indexOf("#updatePercent")) && -1 != l.indexOf("if(");
                m.test(l) && !n ? h = h.replace(g, "sum(@" + c + ")") : (m = /(\W)['|"][^'|^"]*['|"]/i, h = h.replace(g, "@" + c));
              }
            }
            m = /#value/g;
            h = h.replace(m, "value()");
            m = /#updateDifference/g;
            h = h.replace(m, "updateDifference()");
            m = /#updatePercent/g;
            h = h.replace(m, "updatePercent()");
            h = h.toLocaleLowerCase();
            var p = this.X$(h);
            p = p[1][0];
          } catch (t) {
            return null;
          }
          return p;
        }
        X$(h) {
          for (var f = [], b = "", a = h.length, c = 0; c < h.length; c++) {
            var d = h.charAt(c);
            if ("(" == d) b += "$" + f.length + ";", d = this.X$(h.slice(c + 1)), f.push(d[1]), c = c + d[0] + 1;else if (")" == d) {
              a = c;
              break;
            } else b += d;
          }
          h = [];
          b = b.split(",");
          for (c = 0; c < b.length; c++) h.push(this.uZ(b[c], f));
          return [a, h];
        }
        uZ(h, f) {
          for (var b = [[" or ", " and "], "== != >= <= = > <".split(" "), ["-", "+"], ["/", "*"], ["^"]], a = 0; a < b.length; a++) {
            var c = Number.MIN_VALUE,
              d = b[a][0];
            if (3 == a) {
              c = h.indexOf(b[a][0]);
              var g = h.indexOf(b[a][1]);
              -1 != c && -1 != g ? d = c < g ? b[a][1] : b[a][0] : -1 != c ? d = b[a][0] : -1 != g && (d = b[a][1]);
            } else for (g = 0; g < b[a].length; g++) {
              var l = h.indexOf(b[a][g]);
              -1 != l && (l >= c || 2 == a) && (d = b[a][g], c = l + d.length);
            }
            c = h.split(d);
            2 < c.length && (g = c[c.length - 1], c.pop(), c = [c.join(d), g]);
            if (2 == c.length) return h = this.uZ(c[0], f), f = this.uZ(c[1], f), "-" == d && "string" == typeof h && 0 == h.trim().length ? [d.trim(), [0, f], !0] : [d.trim(), [h, f], !0];
          }
          return this.Dsa(h, f);
        }
        Dsa(h, f) {
          h = h.trim();
          if (-1 != h.indexOf("$")) {
            var b = h.split("$");
            h = b[0];
            b = parseInt(b[1]);
            if (0 < h.length) {
              var a = "string" != typeof f[b][0];
              ("min" == h || "max" == h) && 1 < f[b].length && (a = !0, "string" == typeof f[b][0] && (f[b][0] = ["sum", [f[b][0]], !1]), "string" == typeof f[b][1] && (f[b][1] = ["sum", [f[b][1]], !1]));
              if ("value" === h || "updatedifference" === h || "updatepercent" === h) a = !0;
              if ("round" == h || "abs" == h) a = !0, "string" == typeof f[b][0] && (f[b][0] = ["sum", [f[b][0]], !1]);
              return [h, f[b], a];
            }
            return f[b][0];
          }
          if (-1 != h.indexOf("@")) return f = parseInt(h.slice(1)), this.quotes[f];
          if ("truestyle" == h.toLowerCase() || "truestyle" == h.substring(1, h.length - 1).toLowerCase()) return "truestyle";
          f = parseFloat(h);
          return isNaN(f) ? h : f;
        }
      }
      e.IJ = k;
    })(u || (u = {}));
    (function (e) {
      class k {
        static get No() {
          return /Mac/i.test(navigator.platform);
        }
        static get JD() {
          return /(iPhone|iPod|iPad)/i.test(navigator.platform) || /(iPhone|iPod|iPad)/i.test(navigator.userAgent);
        }
      }
      e.qj = k;
    })(u || (u = {}));
    (function (e) {
      class k {
        constructor() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
          this.values = [];
          this.FR = [];
          this.root = new h("");
          this.KR = f;
        }
        get length() {
          return this.values.length;
        }
        add(f, b) {
          if (q.v(f) || 0 === f.length) return void 0 === this.hz && (this.hz = this.values.length, this.values.push(f)), this.hz;
          f = "" + f;
          if (this.KR) {
            const a = /[^\u0000-\u007F]+/.test(f) ? f.toLocaleLowerCase() : f.toLowerCase();
            return this.root.raa(f, a, a === f, this.values, this.FR, b);
          }
          return this.root.saa(f, this.values, b);
        }
        get(f) {
          return this.KR ? this.FR[f] || this.values[f] : this.values[f];
        }
        find(f) {
          if (q.v(f) || 0 === f.length) return void 0 !== this.hz ? this.hz : -1;
          f = "" + f;
          const b = /[^\u0000-\u007F]+/.test(f);
          this.KR && (f = b ? f.toLocaleLowerCase() : f.toLowerCase());
          return this.root.find(f, 0, this.values, b);
        }
        sort() {
          var f = this.root.sort(k.D_);
          void 0 !== this.hz && f.unshift(this.hz);
          return f;
        }
        clone() {
          var f = new k(this.KR);
          f.values = this.values.slice();
          f.FR = this.FR.slice();
          f.hz = this.hz;
          f.root = this.root.clone();
          return f;
        }
        static D_(f, b) {
          return f && f.localeCompare ? f.localeCompare(b) : f == b ? 0 : f > b ? 1 : -1;
        }
      }
      e.dQ = k;
      class h {
        constructor(f) {
          this.Xg = [];
          this.prefix = f;
        }
        saa(f, b, a) {
          var c = this.prefix.length;
          if (void 0 !== this.children && f.length > c) return c = f[c], this.children.has(c) || this.children.set(c, new h(this.prefix + c)), this.children.get(c).saa(f, b, a);
          for (var d = 0; d < this.Xg.length; d++) {
            c = b[this.Xg[d]];
            if (f < c) return this.qQ(f, b, a, d);
            if (f === c) {
              if (void 0 === a) return this.Xg[d];
              b[a] = f;
              this.Xg.splice(d, 0, a);
              return a;
            }
          }
          return this.qQ(f, b, a);
        }
        raa(f, b, a, c, d, g) {
          var l = this.prefix.length;
          if (void 0 !== this.children && b.length > l) return l = b[l], this.children.has(l) || this.children.set(l, new h(this.prefix + l)), this.children.get(l).raa(f, b, a, c, d, g);
          for (var m = 0; m < this.Xg.length; m++) {
            l = c[this.Xg[m]];
            if (b < l) return a ? this.qQ(f, c, g, m) : this.V9(f, b, c, d, g, m);
            if (b === l) {
              if (void 0 === g) return this.Xg[m];
              c[g] = b;
              a || (d[g] = f);
              this.Xg.splice(m, 0, g);
              return g;
            }
          }
          return a ? this.qQ(f, c, g) : this.V9(f, b, c, d, g);
        }
        V9(f, b, a, c, d) {
          let g = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : -1;
          void 0 === d ? (d = a.length, a.push(b), c[d] = f) : (a[d] = b, c[d] = f);
          -1 === g ? this.Xg.push(d) : this.Xg.splice(g, 0, d);
          this.Xg.length > h.w8 && this.jaa(a);
          return d;
        }
        qQ(f, b, a) {
          let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
          void 0 === a ? (a = b.length, b.push(f)) : b[a] = f;
          -1 === c ? this.Xg.push(a) : this.Xg.splice(c, 0, a);
          this.Xg.length > h.w8 && this.jaa(b);
          return a;
        }
        jaa(f) {
          if (!this.children) {
            this.children = new Map();
            for (var b, a = this.prefix.length, c = -1, d = 0, g = 0; g < this.Xg.length; g++) b = f[this.Xg[g]], b.length === a ? c = this.Xg[g] : (b = b[a], this.children.has(b) || (this.children.set(b, new h(this.prefix + b)), d++), this.children.get(b).Xg.push(this.Xg[g]));
            this.Xg = -1 === c ? [] : [c];
          }
        }
        sort(f) {
          var b = 0 < this.Xg.length ? this.Xg.slice() : [];
          if (void 0 !== this.children) {
            var a = [];
            for (var c of this.children.keys()) a.push(c);
            a = a.sort(f);
            for (c = 0; c < a.length; c++) {
              var d = this.children.get(a[c]).sort(f);
              b = b.concat(d);
            }
          }
          return b;
        }
        find(f, b, a, c) {
          if (void 0 !== this.children && f.length !== this.prefix.length) {
            var d = f[b];
            return this.children.has(d) ? this.children.get(d).find(f, b + 1, a, c) : -1;
          }
          return this.csa(f, a, c);
        }
        csa(f, b, a) {
          for (let d = 0; d < this.Xg.length; d++) {
            var c = b[this.Xg[d]];
            if (a) {
              if (c = c.localeCompare(f), 0 === c) return this.Xg[d];
            } else if (f === c) return this.Xg[d];
          }
          return -1;
        }
        clone() {
          var f = new h(this.prefix);
          f.Xg = this.Xg.slice();
          void 0 !== this.children && (f.children = new Map(this.children));
          return f;
        }
      }
      h.w8 = 16;
    })(u || (u = {}));
    (function (e) {
      class k {
        static Jg(h) {
          for (var f in h) if (!q.v(h[f]) && h.hasOwnProperty(f)) return !1;
          return !0;
        }
        static LG(h) {
          var f = {},
            b;
          for (b in h) f[b] = h[b];
          return f;
        }
        static vj(h, f) {
          if (q.v(h)) return null;
          if (Array.isArray(h)) return k.kxa(h);
          var b = {},
            a;
          for (a in h) b[a] = "object" != typeof h[a] || null == h[a] || null != f && -1 < f.indexOf(a) ? h[a] : k.vj(h[a]);
          return b;
        }
        static kxa(h) {
          for (var f = [], b = 0; b < h.length; b++) f[b] = "object" != typeof h[b] ? h[b] : k.vj(h[b]);
          return f;
        }
        static resolve(h, f) {
          return q.v(f) ? null : f.hasOwnProperty(h) ? f[h] : h.split(".").reduce((b, a) => b && b[a], f);
        }
      }
      e.Nc = k;
    })(u || (u = {}));
    var v;
    (function (e) {
      class k {
        constructor(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          this.J$ = !1;
          this.type = f;
          this.target = b;
          this.data = a;
        }
        static jfa(f) {
          return -1 < "fullscreenchange mozfullscreenchange webkitfullscreenchange MSFullscreenChange focusin focusout touchstart touchmove touchend touchenter touchleave touchcancel".split(" ").indexOf(f);
        }
        stopPropagation() {
          this.J$ = !0;
        }
        get eDa() {
          return this.J$;
        }
      }
      k.Qc = "event_complete";
      k.GA = "event_connected";
      k.te = "event_progress";
      k.ho = "event_select";
      k.Zd = "event_change";
      k.xa = "event_error";
      k.OPENED = "event_opened";
      k.CLOSED = "event_closed";
      k.aX = "event_cancel";
      k.OPEN = "event_open";
      k.G6 = "event_close";
      k.fY = "event_resize";
      k.kp = "event_clear";
      e.ga = k;
      class h {
        constructor() {
          this.AS = !1;
          this.wh = [];
          this.ln = [];
          this.Lt = [];
        }
        vG(f, b) {
          return f.type == b.type && f.Jb == b.Jb;
        }
        S1(f) {
          return !q.v(this.wh[f]);
        }
        T1(f, b) {
          if (q.v(this.wh[f])) return !1;
          for (var a = 0; a < this.wh[f].length; a++) if (this.vG(this.wh[f][a], b)) return !0;
          return !1;
        }
        N(f, b) {
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          b = {
            type: f,
            Jb: b,
            priority: a
          };
          if (!this.T1(f, b)) if (this.AS) q.v(this.ln[f]) && (this.ln[f] = []), this.ln[f].push(b);else if (q.v(this.wh[f]) && (this.wh[f] = []), 0 == this.wh[f].length) this.wh[f].push(b);else {
            this.wh[f][this.wh[f].length - 1].priority >= a && this.wh[f].push(b);
            for (var c = 0; c < this.wh[f].length; c++) if (this.wh[f][c].priority < a) {
              this.wh[f].splice(c, 0, b);
              break;
            }
          }
        }
        pb(f, b) {
          if (!q.v(this.wh[f])) {
            b = {
              type: f,
              Jb: b
            };
            for (var a = this.wh[f].slice(0), c = [], d = 0; d < a.length; d++) this.vG(a[d], b) ? this.AS && (q.v(this.Lt[f]) && (this.Lt[f] = []), this.Lt[f].push(a[d])) : c.push(a[d]);
            this.wh[f] = c;
          }
        }
        Td(f) {
          void 0 === f ? (this.wh = [], this.ln = [], this.Lt = []) : (q.v(this.wh) || (this.wh[f] = []), q.v(this.ln) || (this.ln[f] = []), q.v(this.Lt) || (this.Lt[f] = []));
        }
        Ea(f) {
          if (!q.v(this.wh[f.type])) {
            this.AS = !0;
            for (var b = this.wh[f.type].slice(0), a = 0; a < b.length; a++) {
              if (!q.v(this.Lt[f.type])) {
                var c = !1,
                  d;
                for (d in this.Lt[f.type]) this.vG(b[a], this.Lt[f.type][d]) && (c = !0);
                if (c) continue;
              }
              f instanceof q.model.hd ? b[a].Jb.call(this, f.data) : f instanceof k && f.eDa || b[a].Jb.call(this, f);
            }
            delete this.Lt[f.type];
            for (var g in this.ln) {
              if (q.v(this.wh[g])) b = [];else if (Array.isArray(this.wh[g])) b = this.wh[g].slice(0);else continue;
              if (!q.v(this.ln[g])) for (a = 0; a < this.ln[g].length; a++) if (0 == b.length) b.push(this.ln[g][a]);else for (b[b.length - 1].priority == this.ln[g][a].priority && b.push(this.ln[g][a]), f = 0; f < b.length; f++) if (b[f].priority < this.ln[g][a].priority) {
                b.splice(f, 0, this.ln[g][a]);
                break;
              }
              this.wh[g] = b;
              this.ln[g] = [];
            }
            this.AS = !1;
          }
        }
        Ya(f, b, a) {
          f = new e.ga(f, null == b ? this : b, a);
          this.Ea(f);
        }
      }
      e.Fh = h;
    })(v || (v = {}));
    (function (e) {
      e.requestIdleCallback = function (h) {
        let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        if (window.requestIdleCallback && !b) return window.requestIdleCallback(h, f);
        var a,
          c = e.Yf(),
          d;
        return q.Be(() => {
          h({
            didTimeout: !1,
            timeRemaining: () => void 0 === a ? (a = e.Yf(), d = Math.min(350, e.Yf() - c + 50)) : Math.max(0, d - (e.Yf() - a))
          });
        }, 1);
      };
      e.cancelIdleCallback = function (h) {
        if (window.cancelIdleCallback) return window.cancelIdleCallback(h);
        q.kr(h);
      };
      class k {
        constructor() {
          throw Error("Singleton");
        }
        static po(h) {
          k.rI.push(h);
          k.Xe();
        }
        static Xe() {
          q.v(k.iL) && 0 < k.rI.length && (3 < k.e2 && (k.Dea = !1), k.iL = e.requestIdleCallback(k.uJa, {
            timeout: 100
          }, !k.Dea));
        }
        static uJa(h) {
          if (h.didTimeout) k.e2++, k.Nha();else for (k.e2 = 0; 0 < h.timeRemaining() && 0 < k.rI.length && !k.Nha(););
          k.iL = null;
          k.Xe();
        }
        static Nha() {
          var h = k.rI.shift(),
            f = h.bp(h.k_);
          f ? h && h.ff && q.Be(h.ff, 1) : k.rI.push(h);
          return f;
        }
        static cancel() {
          null != k.iL && (e.cancelIdleCallback(k.iL), k.iL = null);
          k.rI = [];
        }
      }
      k.rI = [];
      k.Dea = !0;
      k.e2 = 0;
      e.Il = k;
    })(u || (u = {}));
    (function (e) {
      function k() {
        var h = navigator.userAgent.toLowerCase(),
          f = {};
        f.PH = /mozilla/.test(h) && /firefox/.test(h);
        f.cU = /webkit/.test(h) && /chrome/.test(h) && !/edge/.test(h);
        f.s2 = /edge/.test(h);
        f.jDa = /applewebkit/.test(h) && /safari/.test(h) && !/chrome/.test(h);
        f.mfa = /opera/.test(h);
        f.cj = /msie/.test(h);
        f.gDa = /ReactNative/i.test(navigator.product);
        f.Rm = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(h) || /iPad|iPhone|iPod|BlackBerry/i.test(navigator.platform) || f.gDa;
        f.version = NaN;
        f.cj || f.PH || f.cU || f.jDa || f.mfa || !/trident/.test(h) || (f.cj = !0, f.version = 11);
        if (isNaN(f.version)) for (var b = ["chrome", "firefox", "msie", "safari", "opera"], a = 0; a < b.length; a++) try {
          f.version = parseInt(h.match(new RegExp("(" + b[a] + ")( |/)([0-9]+)"))[3]);
          break;
        } catch (c) {}
        return f;
      }
      e.Jd = function () {
        return k();
      };
      e.yS = k;
      e.nU = function () {
        return null != document.fullscreenElement || null != document.mozFullScreenElement || null != document.webkitFullscreenElement || null != document.msFullscreenElement;
      };
      e.z2 = function () {
        return window != top;
      };
      e.Vea = function () {
        try {
          return !q.v(window.process.versions.electron);
        } catch (h) {
          return !1;
        }
      };
      e.MCa = function () {
        try {
          return void 0 !== ArrayBuffer && void 0 !== DataView && void 0 !== Uint8Array && (window.chrome && navigator.userAgent.match(/chrome.\d*/gi) ? 12 <= parseInt(navigator.userAgent.match(/chrome.\d*/gi)[0].replace(/[^\d]/g, "")) : !0) && (window.opera ? 15 <= window.opera.version() : !0) && (navigator.userAgent.match("Safari/") ? !navigator.userAgent.match("Version/5.") && !navigator.userAgent.match("Version/6.0") : !0);
        } catch (h) {
          return !1;
        }
      };
      e.aPa = function (h) {
        var f = document.cookie,
          b = f.indexOf(" " + h + "=");
        -1 == b && (b = f.indexOf(h + "="));
        -1 == b ? f = null : (b = f.indexOf("=", b) + 1, h = f.indexOf(";", b), -1 == h && (h = f.length), f = decodeURI(f.substring(b, h)));
        return f;
      };
      e.fPa = function (h, f) {
        var b = new Date();
        b.setDate(b.getDate() + 1825);
        f = encodeURI(f) + "; expires=" + b.toUTCString();
        document.cookie = h + "=" + f;
      };
      e.bPa = function () {
        return screen.orientation && -1 < screen.orientation.type.indexOf("landscape");
      };
      e.cPa = function () {
        return screen.orientation && -1 < screen.orientation.type.indexOf("portrait");
      };
      e.mPa = function () {
        return Math.max(document.documentElement.clientWidth);
      };
      e.lPa = function () {
        return Math.max(document.documentElement.clientHeight);
      };
    })(u || (u = {}));
    (function (e) {
      class k extends v.Fh {
        constructor(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          super();
          this.BQ = 0;
          this.EK = !1;
          this.Ura = f;
          this.daa = b;
        }
        rHa() {
          this.BQ++;
          this.Ea(new v.ga(h.Gl));
          0 < this.daa && this.BQ >= this.daa && (this.stop(), this.Ea(new v.ga(h.Hl)));
        }
        start() {
          this.EK || (this.F$ = q.jda(() => this.rHa(), this.Ura), this.EK = !0);
        }
        stop() {
          this.EK && !q.v(this.F$) && (q.P0(this.F$), this.EK = !1);
        }
        reset() {
          this.BQ = 0;
          this.stop();
        }
        set yw(f) {}
        get yw() {
          return this.BQ;
        }
        set wl(f) {}
        get wl() {
          return this.EK;
        }
      }
      e.Et = k;
      class h {}
      h.Gl = "timer";
      h.Hl = "complete";
      e.vf = h;
      e.Yf = function () {
        return "undefined" !== typeof performance && "function" === typeof window.performance.now ? performance.now() : new Date().getTime();
      };
    })(u || (u = {}));
    (function (e) {
      class k {
        static load(f, b, a) {
          if (PivotApi.libsIncluded) return b();
          f = new h(f, k.m_);
          this.ZH.push(f);
          f.Jb = b;
          f.bb = a;
          f.load();
        }
        static T2(f, b, a) {
          null == b && (b = {});
          f = new h(f, k.m_);
          this.ZH.push(f);
          f.eL = b.eL;
          f.xj = b.xj;
          f.Jb = a;
          f.bb = void 0;
          f.load();
        }
        static oLa() {
          var f = document.querySelector("link[data-fm-hc-theme]");
          f && (f.disabled = !0);
        }
        static dispose() {
          for (let f = 0; f < this.ZH.length; f++) this.ZH[f].dispose();
          this.ZH.length = 0;
          this.ZH = null;
        }
      }
      k.m_ = "";
      k.ZH = [];
      e.io = k;
      class h {
        constructor(f, b) {
          this.eL = null;
          this.xj = !1;
          this.total = this.loaded = 0;
          this.errors = [];
          this.S2 = this.KN = null;
          this.url = f;
          this.baseURI = b;
          this.total = "string" == typeof this.url ? 1 : this.url.length;
        }
        load() {
          0 == this.total && this.Fj();
          if ("string" == typeof this.url) this.xK(this.url, this.eL);else for (var f = this.url, b = 0; b < f.length; b++) this.xK(f[b], this.eL);
        }
        Fj() {
          this.loaded++;
          if (this.loaded == this.total || 0 == this.total) 0 == this.errors.length ? this.Jb && this.Jb() : this.bb && this.bb(this.errors), this.bb = this.Jb = null;
        }
        xK(f, b) {
          f = this.baseURI + f;
          f.lastIndexOf(".js") == f.length - 3 ? this.MDa(f) : f.lastIndexOf(".css") == f.length - 4 ? this.T2(f, b) : this.Fj();
        }
        MDa(f) {
          if (null == this.eda(f)) {
            const a = this.KN = document.createElement("script");
            a.type = "text/javascript";
            a.src = f + "?" + q.kh.Nr;
            a.async = !0;
            var b = () => {
              a.readystate = "loaded";
              this.Fj();
              if (a.onloadedlisteners) {
                for (var c = 0; c < a.onloadedlisteners.length; c++) a.onloadedlisteners[c]();
                delete a.onloadedlisteners;
              }
            };
            a.onreadystatechange = b;
            a.onload = b;
            a.onerror = () => {
              a.readystate = "error";
              this.errors.push(f);
              this.Fj();
            };
            document.head.appendChild(a);
          } else b = this.KN = this.eda(f), "error" == b.readystate ? (this.errors.push(f), this.Fj()) : !0 === b.async && "loaded" != b.readystate ? (null == b.onloadedlisteners && (b.onloadedlisteners = []), b.onloadedlisteners.push(() => this.Fj())) : this.Fj();
        }
        T2(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          const a = this.S2 = document.createElement("link");
          a.href = f + "?" + q.kh.Nr;
          a.rel = "stylesheet";
          a.type = "text/css";
          if (null != b) for (const c in b) b.hasOwnProperty(c) && a.setAttribute(c, b[c]);
          a.onerror = () => this.Sb(f);
          a.onreadystatechange = () => this.Fj();
          a.onload = () => this.Fj();
          this.xj ? document.body.appendChild(a) : document.head.appendChild(a);
        }
        eda(f) {
          for (var b = 0; b < document.head.children.length; b++) {
            var a = document.head.children.item(b);
            if (a.src && -1 < a.src.indexOf(f)) return a;
          }
          return null;
        }
        Sb(f) {
          this.errors.push(f);
          this.Fj();
        }
        dispose() {
          this.bb = this.Jb = this.S2 = this.KN = null;
        }
      }
    })(u || (u = {}));
    (function (e) {
      class k extends v.Fh {
        constructor(f) {
          super();
          this.eZ = !1;
          this.nsa = b => this.mq(b);
          this.osa = b => this.M3(b);
          this.uDa = 1E3;
          this.buffer = [];
          this.Fea = () => this.bGa();
          this.pQ = null;
          if (null != k.xe) throw Error("KeyboardListener is singleton");
          e.Jd().Rm || (q.Dk.addEventListener("keydown", this.nsa), q.Dk.addEventListener("keyup", this.osa), this.VF = new x.Ga("div"), this.VF.U("position", "fixed").U("left", "0px").U("top", "0px").U("opacity", "0").U("width", "0px").U("height", "0px"), this.VF.Za(), this.Tq = new x.Lv(), this.Tq.G.U("width", "1px").U("height", "1px").U("padding", "0px"), this.Tq.N("focusin", () => {
            this.eZ = !0;
          }), this.Tq.N("focusout", () => {
            this.eZ = !1;
          }), this.VF.append(this.Tq.G), f.append(this.VF));
        }
        static R() {
          null == k.xe && (k.xe = new k(q.K.Nb.Gb.G));
          return k.xe;
        }
        get $ea() {
          return this.eZ;
        }
        M3(f) {
          this.Baa(f.key, f.type);
        }
        mq(f) {
          var b = new h(h.oP);
          b.keyCode = f.keyCode;
          b.altKey = f.altKey;
          b.ctrlKey = f.ctrlKey;
          b.metaKey = f.metaKey;
          b.shiftKey = f.shiftKey;
          b.pq = f;
          this.Ea(b);
          this.Baa(f.key, f.type);
        }
        Baa(f, b) {
          f = f.toLowerCase();
          const a = Date.now();
          a - this.xDa > this.uDa && (this.buffer.length = 0);
          20 < this.buffer.length && this.buffer.splice(0, this.buffer.length - 6);
          this.buffer.push({
            key: f,
            type: b
          });
          this.xDa = a;
          this.Vua() && (this.buffer.length = 0, this.Ya(h.E9));
        }
        Vua() {
          if (6 > this.buffer.length) return !1;
          let f = 0,
            b = 0;
          for (const a of this.buffer) "shift" == a.key && ("keydown" == a.type ? f++ : "keyup" == a.type && b++);
          return 3 <= f && 3 <= b;
        }
        bGa() {
          this.VF.Za();
          this.Tq.Jj("");
          this.Tq.G.blur();
          this.Tq.pb("keyup", this.Fea);
          null != this.pQ && (this.pQ.focus({
            preventScroll: !0
          }), this.pQ = null);
        }
        LG(f) {
          this.pQ = document.activeElement;
          this.VF.show();
          this.Tq.Jj(f);
          this.Tq.G.focus({
            preventScroll: !0
          });
          this.Tq.selectAll();
          this.Tq.G.focus({
            preventScroll: !0
          });
          this.Tq.N("keyup", this.Fea);
        }
        static dispose() {
          k.xe = null;
        }
      }
      e.pP = k;
      class h extends v.ga {
        constructor(f) {
          super(f);
        }
      }
      h.oP = "event_keydown";
      h.E9 = "event_tripple_shift";
      e.KeyboardEvent = h;
      (function (f) {
        f[f.VLa = 8] = "BACKSPACE";
        f[f.LOa = 9] = "TAB";
        f[f.HMa = 13] = "ENTER";
        f[f.GOa = 16] = "SHIFT";
        f[f.xMa = 17] = "CTRL";
        f[f.QLa = 18] = "ALT";
        f[f.vOa = 19] = "PAUSE";
        f[f.sMa = 20] = "CAPS_LOCK";
        f[f.JMa = 27] = "ESCAPE";
        f[f.IOa = 32] = "SPACE";
        f[f.uOa = 33] = "PAGE_UP";
        f[f.tOa = 34] = "PAGE_DOWN";
        f[f.NA = 35] = "END";
        f[f.mNa = 36] = "HOME";
        f[f.ZNa = 37] = "LEFT_ARROW";
        f[f.UOa = 38] = "UP_ARROW";
        f[f.yOa = 39] = "RIGHT_ARROW";
        f[f.FMa = 40] = "DOWN_ARROW";
        f[f.nNa = 45] = "INSERT";
        f[f.e7 = 46] = "DELETE";
        f[f.pNa = 48] = "KEY_0";
        f[f.qNa = 49] = "KEY_1";
        f[f.rNa = 50] = "KEY_2";
        f[f.sNa = 51] = "KEY_3";
        f[f.tNa = 52] = "KEY_4";
        f[f.uNa = 53] = "KEY_5";
        f[f.vNa = 54] = "KEY_6";
        f[f.wNa = 55] = "KEY_7";
        f[f.xNa = 56] = "KEY_8";
        f[f.yNa = 57] = "KEY_9";
        f[f.zNa = 65] = "KEY_A";
        f[f.ANa = 66] = "KEY_B";
        f[f.BNa = 67] = "KEY_C";
        f[f.CNa = 68] = "KEY_D";
        f[f.DNa = 69] = "KEY_E";
        f[f.ENa = 70] = "KEY_F";
        f[f.FNa = 71] = "KEY_G";
        f[f.GNa = 72] = "KEY_H";
        f[f.HNa = 73] = "KEY_I";
        f[f.INa = 74] = "KEY_J";
        f[f.JNa = 75] = "KEY_K";
        f[f.KNa = 76] = "KEY_L";
        f[f.LNa = 77] = "KEY_M";
        f[f.MNa = 78] = "KEY_N";
        f[f.NNa = 79] = "KEY_O";
        f[f.ONa = 80] = "KEY_P";
        f[f.PNa = 81] = "KEY_Q";
        f[f.QNa = 82] = "KEY_R";
        f[f.RNa = 83] = "KEY_S";
        f[f.SNa = 84] = "KEY_T";
        f[f.TNa = 85] = "KEY_U";
        f[f.UNa = 86] = "KEY_V";
        f[f.VNa = 87] = "KEY_W";
        f[f.WNa = 88] = "KEY_X";
        f[f.XNa = 89] = "KEY_Y";
        f[f.YNa = 90] = "KEY_Z";
        f[f.$Na = 91] = "LEFT_META";
        f[f.zOa = 92] = "RIGHT_META";
        f[f.ho = 93] = "SELECT";
        f[f.hOa = 96] = "NUMPAD_0";
        f[f.iOa = 97] = "NUMPAD_1";
        f[f.jOa = 98] = "NUMPAD_2";
        f[f.kOa = 99] = "NUMPAD_3";
        f[f.lOa = 100] = "NUMPAD_4";
        f[f.mOa = 101] = "NUMPAD_5";
        f[f.nOa = 102] = "NUMPAD_6";
        f[f.oOa = 103] = "NUMPAD_7";
        f[f.pOa = 104] = "NUMPAD_8";
        f[f.qOa = 105] = "NUMPAD_9";
        f[f.KP = 106] = "MULTIPLY";
        f[f.wO = 107] = "ADD";
        f[f.aQ = 109] = "SUBTRACT";
        f[f.CMa = 110] = "DECIMAL";
        f[f.kJ = 111] = "DIVIDE";
        f[f.LMa = 112] = "F1";
        f[f.PMa = 113] = "F2";
        f[f.QMa = 114] = "F3";
        f[f.RMa = 115] = "F4";
        f[f.SMa = 116] = "F5";
        f[f.TMa = 117] = "F6";
        f[f.UMa = 118] = "F7";
        f[f.VMa = 119] = "F8";
        f[f.WMa = 120] = "F9";
        f[f.MMa = 121] = "F10";
        f[f.NMa = 122] = "F11";
        f[f.OMa = 123] = "F12";
        f[f.rOa = 144] = "NUM_LOCK";
        f[f.BOa = 145] = "SCROLL_LOCK";
        f[f.EOa = 186] = "SEMICOLON";
        f[f.IMa = 187] = "EQUALS";
        f[f.vMa = 188] = "COMMA";
        f[f.BMa = 189] = "DASH";
        f[f.wOa = 190] = "PERIOD";
        f[f.hNa = 191] = "FORWARD_SLASH";
        f[f.lNa = 192] = "GRAVE_ACCENT";
        f[f.sOa = 219] = "OPEN_BRACKET";
        f[f.WLa = 220] = "BACK_SLASH";
        f[f.uMa = 221] = "CLOSE_BRACKET";
        f[f.HOa = 222] = "SINGLE_QUOTE";
      })(e.Jna || (e.Jna = {}));
    })(u || (u = {}));
    (function (e) {
      class k extends v.Fh {
        constructor(f) {
          super();
          this.BZ = () => this.CJa();
          this.GQ = () => this.GQ();
          this.dG = "__FMResizeTriggersStorage__";
          this.Ml = f;
          this.gCa();
          this.Xq = new h(this.Ml.element, this.dG);
          this.MKa(this.Ml.element);
        }
        gCa() {
          !q.v(this.Ml) && q.v(this.Ml.element[this.dG]) && (this.Ml.element[this.dG] = {});
        }
        refresh() {
          this.M4(this.Xq);
        }
        M4(f) {
          var b = f.Q4;
          f = b.firstElementChild;
          b = b.lastElementChild;
          var a = f.firstElementChild;
          b.scrollLeft = b.scrollWidth;
          b.scrollTop = b.scrollHeight;
          a.style.width = f.offsetWidth + 1 + "px";
          a.style.height = f.offsetHeight + "px";
          f.scrollLeft = f.scrollWidth;
          f.scrollTop = f.scrollHeight;
        }
        Uua(f) {
          return f.offsetWidth != this.Xq.O4.width || f.offsetHeight != this.Xq.O4.height;
        }
        CJa() {
          if (this.Ml && this.Ml.element && !q.v(this.Ml.element[this.dG])) {
            const f = this.Ml.element,
              b = this.Xq.O4;
            this.M4(this.Xq);
            this.Xq.OV && this.Ml.cancelAnimationFrame(this.Xq.OV);
            this.Xq.OV = this.Ml.requestAnimationFrame(() => {
              q.v(b.width) && (b.width = f.offsetWidth);
              q.v(b.height) && (b.height = f.offsetHeight);
              this.Uua(f) && (b.width = f.offsetWidth, b.height = f.offsetHeight, this.yxa());
            });
          }
        }
        yxa() {
          this.Ya(v.ga.fY);
        }
        MKa(f) {
          f.attachEvent ? f.attachEvent("onresize", this.GQ) : q.v(f) || ("static" == getComputedStyle(f).position && (f.style.position = "relative"), f.appendChild(this.Xq.Q4), this.M4(this.Xq), f.addEventListener("scroll", this.BZ, !0));
        }
        OKa(f) {
          f.detachEvent ? f.detachEvent("onresize", this.GQ) : f.removeEventListener("scroll", this.BZ, !0);
        }
        lva() {
          const f = this.Ml.element[this.dG],
            b = Object.keys(f);
          for (let a = 0; a < b.length; a++) if (!q.v(f[b[a]])) return;
          this.Ml.element[this.dG] = null;
        }
        dispose() {
          this.Ml && this.Ml.element && (this.OKa(this.Ml.element), this.Xq.dispose(), this.Xq = null, this.lva());
          this.GQ = this.BZ = this.Ml = null;
        }
      }
      e.aqa = k;
      class h {
        constructor(f, b) {
          this.yZ = "__resizeLast__";
          this.faa = "__resizeListeners__";
          this.BK = "__resizeTriggers__";
          this.oR = "__resizeRAF__";
          this.Yra = "__resizeTrigger";
          this.cE = f;
          this.B5 = b;
          this.HS = this.Hza();
          q.v(this.cE) || this.eCa(this.B5);
        }
        get Q4() {
          return this.xM()[this.BK];
        }
        get O4() {
          return this.xM()[this.yZ];
        }
        get OV() {
          return this.xM()[this.oR];
        }
        set OV(f) {
          this.xM()[this.oR] = f;
        }
        Hza() {
          return this.Yra + q.K.Nb.Gb.qf.id;
        }
        eCa(f) {
          this.cE[f][this.HS] = {};
          f = this.cE[f][this.HS];
          f[this.yZ] = {};
          f[this.faa] = [];
          f[this.BK] = document.createElement("div");
          f[this.BK].className = "fm-resize-triggers";
          f[this.BK].innerHTML = '<div class="fm-expand-trigger"><div></div></div><div class="fm-contract-trigger"></div>';
          f[this.oR] = null;
        }
        xM() {
          return this.cE[this.B5][this.HS];
        }
        dispose() {
          if (!q.v(this.cE)) {
            this.cE.removeChild(this.Q4);
            const f = this.xM();
            f[this.yZ] = null;
            f[this.faa] = null;
            f[this.oR] = null;
            f[this.BK] = null;
            this.cE[this.B5][this.HS] = null;
          }
        }
      }
      e.AOa = h;
    })(u || (u = {}));
    (function (e) {
      class k {
        constructor() {
          this.gO = [];
        }
        add(h) {
          for (var _len2 = arguments.length, f = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            f[_key2 - 1] = arguments[_key2];
          }
          this.gO.push({
            Jb: h,
            k_: f
          });
        }
        pop() {
          return this.gO.pop();
        }
        Xe(h) {
          var f = () => {
            if (0 == this.gO.length) h();else {
              var b = this.gO.shift();
              e.requestIdleCallback(() => b.Jb(f, ...b.k_), {
                timeout: 100
              });
            }
          };
          f();
        }
        kb() {
          return 0 === this.gO.length;
        }
      }
      e.mB = k;
    })(u || (u = {}));
    (function (e) {
      function k(D, E, G) {
        var F = 0,
          J = [],
          H = 0,
          M,
          K,
          Q,
          N = !1,
          W = [],
          O = [],
          V = !1;
        G = G || {};
        var ca = G.encoding || "UTF8";
        var fa = G.dPa || 1;
        if (fa !== parseInt(fa, 10) || 1 > fa) throw Error("numRounds must a integer >= 1");
        if (0 === D.lastIndexOf("SHA-", 0)) {
          if (M = function (R, P) {
            return I(R, P, D);
          }, K = function (R, P, ba, Z) {
            if ("SHA-224" === D || "SHA-256" === D) {
              var X = (P + 65 >>> 9 << 4) + 15;
              var ja = 16;
            } else throw Error("Unexpected error in SHA-2 implementation");
            for (; R.length <= X;) R.push(0);
            R[P >>> 5] |= 128 << 24 - P % 32;
            P += ba;
            R[X] = P & 4294967295;
            R[X - 1] = P / 4294967296 | 0;
            ba = R.length;
            for (P = 0; P < ba; P += ja) Z = I(R.slice(P, P + ja), Z, D);
            if ("SHA-224" === D) R = [Z[0], Z[1], Z[2], Z[3], Z[4], Z[5], Z[6]];else if ("SHA-256" === D) R = Z;else throw Error("Unexpected error in SHA-2 implementation");
            return R;
          }, Q = function (R) {
            return R.slice();
          }, "SHA-224" === D) {
            var U = 512;
            var aa = 224;
          } else if ("SHA-256" === D) U = 512, aa = 256;else throw Error("Chosen SHA variant is not supported");
        } else throw Error("Chosen SHA variant is not supported");
        var ka = g(E, ca);
        var ha = C(D);
        this.setHMACKey = function (R, P, ba) {
          if (!0 === N) throw Error("HMAC key already set");
          if (!0 === V) throw Error("Cannot set HMAC key after calling update");
          ca = (ba || {}).encoding || "UTF8";
          P = g(P, ca)(R);
          R = P.yG;
          P = P.value;
          var Z = U >>> 3;
          ba = Z / 4 - 1;
          if (Z < R / 8) {
            for (P = K(P, R, 0, C(D)); P.length <= ba;) P.push(0);
            P[ba] &= 4294967040;
          } else if (Z > R / 8) {
            for (; P.length <= ba;) P.push(0);
            P[ba] &= 4294967040;
          }
          for (R = 0; R <= ba; R += 1) W[R] = P[R] ^ 909522486, O[R] = P[R] ^ 1549556828;
          ha = M(W, ha);
          F = U;
          N = !0;
        };
        this.update = function (R) {
          var P,
            ba = 0,
            Z = U >>> 5;
          var X = ka(R, J, H);
          R = X.yG;
          var ja = X.value;
          X = R >>> 5;
          for (P = 0; P < X; P += Z) ba + U <= R && (ha = M(ja.slice(P, P + Z), ha), ba += U);
          F += ba;
          J = ja.slice(ba >>> 5);
          H = R % U;
          V = !0;
        };
        this.getHash = function (R, P) {
          if (!0 === N) throw Error("Cannot call getHash after setting HMAC key");
          var ba = d(P);
          switch (R) {
            case "HEX":
              R = function (X) {
                return f(X, aa, ba);
              };
              break;
            case "B64":
              R = function (X) {
                return b(X, aa, ba);
              };
              break;
            case "BYTES":
              R = function (X) {
                return a(X, aa);
              };
              break;
            case "ARRAYBUFFER":
              try {
                P = new ArrayBuffer(0);
              } catch (X) {
                throw Error("ARRAYBUFFER not supported by this environment");
              }
              R = function (X) {
                return c(X, aa);
              };
              break;
            default:
              throw Error("format must be HEX, B64, BYTES, or ARRAYBUFFER");
          }
          var Z = K(J.slice(), H, F, Q(ha));
          for (P = 1; P < fa; P += 1) Z = K(Z, aa, 0, C(D));
          return R(Z);
        };
        this.getHMAC = function (R, P) {
          if (!1 === N) throw Error("Cannot call getHMAC without first setting HMAC key");
          var ba = d(P);
          switch (R) {
            case "HEX":
              R = function (X) {
                return f(X, aa, ba);
              };
              break;
            case "B64":
              R = function (X) {
                return b(X, aa, ba);
              };
              break;
            case "BYTES":
              R = function (X) {
                return a(X, aa);
              };
              break;
            case "ARRAYBUFFER":
              try {
                R = new ArrayBuffer(0);
              } catch (X) {
                throw Error("ARRAYBUFFER not supported by this environment");
              }
              R = function (X) {
                return c(X, aa);
              };
              break;
            default:
              throw Error("outputFormat must be HEX, B64, BYTES, or ARRAYBUFFER");
          }
          P = K(J.slice(), H, F, Q(ha));
          var Z = M(O, C(D));
          Z = K(P, aa, U, Z);
          return R(Z);
        };
      }
      function h() {}
      function f(D, E, G) {
        var F = "";
        E /= 8;
        var J;
        for (J = 0; J < E; J += 1) {
          var H = D[J >>> 2] >>> 8 * (3 + J % 4 * -1);
          F += "0123456789abcdef".charAt(H >>> 4 & 15) + "0123456789abcdef".charAt(H & 15);
        }
        return G.sV ? F.toUpperCase() : F;
      }
      function b(D, E, G) {
        var F = "",
          J = E / 8,
          H;
        for (H = 0; H < J; H += 3) {
          var M = H + 1 < J ? D[H + 1 >>> 2] : 0;
          var K = H + 2 < J ? D[H + 2 >>> 2] : 0;
          K = (D[H >>> 2] >>> 8 * (3 + H % 4 * -1) & 255) << 16 | (M >>> 8 * (3 + (H + 1) % 4 * -1) & 255) << 8 | K >>> 8 * (3 + (H + 2) % 4 * -1) & 255;
          for (M = 0; 4 > M; M += 1) 8 * H + 6 * M <= E ? F += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(K >>> 6 * (3 - M) & 63) : F += G.IR;
        }
        return F;
      }
      function a(D, E) {
        var G = "";
        E /= 8;
        var F;
        for (F = 0; F < E; F += 1) {
          var J = D[F >>> 2] >>> 8 * (3 + F % 4 * -1) & 255;
          G += String.fromCharCode(J);
        }
        return G;
      }
      function c(D, E) {
        E /= 8;
        var G,
          F = new ArrayBuffer(E);
        var J = new Uint8Array(F);
        for (G = 0; G < E; G += 1) J[G] = D[G >>> 2] >>> 8 * (3 + G % 4 * -1) & 255;
        return F;
      }
      function d(D) {
        var E = {
          sV: !1,
          IR: "=",
          gPa: -1
        };
        D = D || {};
        E.sV = D.sV || !1;
        !0 === D.hasOwnProperty("b64Pad") && (E.IR = D.IR);
        if ("boolean" !== typeof E.sV) throw Error("Invalid outputUpper formatting option");
        if ("string" !== typeof E.IR) throw Error("Invalid b64Pad formatting option");
        return E;
      }
      function g(D, E) {
        switch (E) {
          case "UTF8":
          case "UTF16BE":
          case "UTF16LE":
            break;
          default:
            throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");
        }
        switch (D) {
          case "HEX":
            D = function (G, F, J) {
              var H = G.length,
                M,
                K;
              if (0 !== H % 2) throw Error("String of HEX type must be in byte increments");
              F = F || [0];
              J = J || 0;
              var Q = J >>> 3;
              for (M = 0; M < H; M += 2) {
                var N = parseInt(G.substr(M, 2), 16);
                if (isNaN(N)) throw Error("String of HEX type contains invalid characters");
                var W = (M >>> 1) + Q;
                for (K = W >>> 2; F.length <= K;) F.push(0);
                F[K] |= N << 8 * (3 + W % 4 * -1);
              }
              return {
                value: F,
                yG: 4 * H + J
              };
            };
            break;
          case "TEXT":
            D = function (G, F, J) {
              var H = 0,
                M,
                K,
                Q;
              F = F || [0];
              J = J || 0;
              var N = J >>> 3;
              if ("UTF8" === E) {
                var W = 3;
                for (M = 0; M < G.length; M += 1) {
                  var O = G.charCodeAt(M);
                  var V = [];
                  128 > O ? V.push(O) : 2048 > O ? (V.push(192 | O >>> 6), V.push(128 | O & 63)) : 55296 > O || 57344 <= O ? V.push(224 | O >>> 12, 128 | O >>> 6 & 63, 128 | O & 63) : (M += 1, O = 65536 + ((O & 1023) << 10 | G.charCodeAt(M) & 1023), V.push(240 | O >>> 18, 128 | O >>> 12 & 63, 128 | O >>> 6 & 63, 128 | O & 63));
                  for (K = 0; K < V.length; K += 1) {
                    var ca = H + N;
                    for (Q = ca >>> 2; F.length <= Q;) F.push(0);
                    F[Q] |= V[K] << 8 * (W + ca % 4 * -1);
                    H += 1;
                  }
                }
              } else if ("UTF16BE" === E || "UTF16LE" === E) for (W = 2, V = "UTF16LE" === E && !0 || "UTF16LE" !== E && !1, M = 0; M < G.length; M += 1) {
                O = G.charCodeAt(M);
                !0 === V && (K = O & 255, O = K << 8 | O >>> 8);
                ca = H + N;
                for (Q = ca >>> 2; F.length <= Q;) F.push(0);
                F[Q] |= O << 8 * (W + ca % 4 * -1);
                H += 2;
              }
              return {
                value: F,
                yG: 8 * H + J
              };
            };
            break;
          case "B64":
            D = function (G, F, J) {
              var H = 0,
                M,
                K;
              if (-1 === G.search(/^[a-zA-Z0-9=+\/]+$/)) throw Error("Invalid character in base-64 string");
              var Q = G.indexOf("=");
              G = G.replace(/=/g, "");
              if (-1 !== Q && Q < G.length) throw Error("Invalid '=' found in base-64 string");
              F = F || [0];
              J = J || 0;
              var N = J >>> 3;
              for (Q = 0; Q < G.length; Q += 4) {
                var W = G.substr(Q, 4);
                for (M = K = 0; M < W.length; M += 1) {
                  var O = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(W[M]);
                  K |= O << 18 - 6 * M;
                }
                for (M = 0; M < W.length - 1; M += 1) {
                  var V = H + N;
                  for (O = V >>> 2; F.length <= O;) F.push(0);
                  F[O] |= (K >>> 16 - 8 * M & 255) << 8 * (3 + V % 4 * -1);
                  H += 1;
                }
              }
              return {
                value: F,
                yG: 8 * H + J
              };
            };
            break;
          case "BYTES":
            D = function (G, F, J) {
              var H;
              F = F || [0];
              J = J || 0;
              var M = J >>> 3;
              for (H = 0; H < G.length; H += 1) {
                var K = G.charCodeAt(H);
                var Q = H + M;
                var N = Q >>> 2;
                F.length <= N && F.push(0);
                F[N] |= K << 8 * (3 + Q % 4 * -1);
              }
              return {
                value: F,
                yG: 8 * G.length + J
              };
            };
            break;
          case "ARRAYBUFFER":
            try {
              D = new ArrayBuffer(0);
            } catch (G) {
              throw Error("ARRAYBUFFER not supported by this environment");
            }
            D = function (G, F, J) {
              var H;
              F = F || [0];
              J = J || 0;
              var M = J >>> 3;
              var K = new Uint8Array(G);
              for (H = 0; H < G.byteLength; H += 1) {
                var Q = H + M;
                var N = Q >>> 2;
                F.length <= N && F.push(0);
                F[N] |= K[H] << 8 * (3 + Q % 4 * -1);
              }
              return {
                value: F,
                yG: 8 * G.byteLength + J
              };
            };
            break;
          default:
            throw Error("format must be HEX, TEXT, B64, BYTES, or ARRAYBUFFER");
        }
        return D;
      }
      function l(D, E) {
        return D >>> E | D << 32 - E;
      }
      function m(D, E, G) {
        return D & E ^ ~D & G;
      }
      function n(D, E, G) {
        return D & E ^ D & G ^ E & G;
      }
      function p(D) {
        return l(D, 2) ^ l(D, 13) ^ l(D, 22);
      }
      function t(D) {
        return l(D, 6) ^ l(D, 11) ^ l(D, 25);
      }
      function r(D) {
        return l(D, 7) ^ l(D, 18) ^ D >>> 3;
      }
      function w(D) {
        return l(D, 17) ^ l(D, 19) ^ D >>> 10;
      }
      function y(D, E) {
        var G = (D & 65535) + (E & 65535);
        return ((D >>> 16) + (E >>> 16) + (G >>> 16) & 65535) << 16 | G & 65535;
      }
      function A(D, E, G, F) {
        var J = (D & 65535) + (E & 65535) + (G & 65535) + (F & 65535);
        return ((D >>> 16) + (E >>> 16) + (G >>> 16) + (F >>> 16) + (J >>> 16) & 65535) << 16 | J & 65535;
      }
      function B(D, E, G, F, J) {
        var H = (D & 65535) + (E & 65535) + (G & 65535) + (F & 65535) + (J & 65535);
        return ((D >>> 16) + (E >>> 16) + (G >>> 16) + (F >>> 16) + (J >>> 16) + (H >>> 16) & 65535) << 16 | H & 65535;
      }
      function C(D) {
        var E, G;
        if (0 === D.lastIndexOf("SHA-", 0)) switch (E = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428], G = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], D) {
          case "SHA-224":
            break;
          case "SHA-256":
            E = G;
            break;
          case "SHA-384":
            E = [new h(), new h(), new h(), new h(), new h(), new h(), new h(), new h()];
            break;
          case "SHA-512":
            E = [new h(), new h(), new h(), new h(), new h(), new h(), new h(), new h()];
            break;
          default:
            throw Error("Unknown SHA variant");
        } else throw Error("No SHA variants supported");
        return E;
      }
      function I(D, E, G) {
        var F,
          J,
          H,
          M = [];
        if ("SHA-224" === G || "SHA-256" === G) {
          var K = 64;
          var Q = 1;
          var N = Number;
          var W = y;
          var O = A;
          var V = B;
          var ca = r;
          var fa = w;
          var U = p;
          var aa = t;
          var ka = n;
          var ha = m;
          var R = Y;
        } else throw Error("Unexpected error in SHA-2 implementation");
        G = E[0];
        var P = E[1];
        var ba = E[2];
        var Z = E[3];
        var X = E[4];
        var ja = E[5];
        var sa = E[6];
        var va = E[7];
        for (H = 0; H < K; H += 1) 16 > H ? (J = H * Q, F = D.length <= J ? 0 : D[J], J = D.length <= J + 1 ? 0 : D[J + 1], M[H] = new N(F, J)) : M[H] = O(fa(M[H - 2]), M[H - 7], ca(M[H - 15]), M[H - 16]), F = V(va, aa(X), ha(X, ja, sa), R[H], M[H]), J = W(U(G), ka(G, P, ba)), va = sa, sa = ja, ja = X, X = W(Z, F), Z = ba, ba = P, P = G, G = W(F, J);
        E[0] = W(G, E[0]);
        E[1] = W(P, E[1]);
        E[2] = W(ba, E[2]);
        E[3] = W(Z, E[3]);
        E[4] = W(X, E[4]);
        E[5] = W(ja, E[5]);
        E[6] = W(sa, E[6]);
        E[7] = W(va, E[7]);
        return E;
      }
      class L {
        static hash(D) {
          var E = new k("SHA-256", "TEXT");
          E.update(D);
          return E.getHash("HEX");
        }
      }
      e.gqa = L;
      var Y = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
    })(q || (q = {}));
    (function (e) {
      class k {
        constructor(h) {
          this.hCa = h;
          this.IL = new e.ub();
          this.$Ha(this.hCa);
        }
        get(h) {
          return this.has(h) ? this.IL.getItem(h)[0] : null;
        }
        has(h) {
          return this.IL.Bb(h);
        }
        $Ha(h) {
          0 === h.indexOf("?") && (h = h.slice(1));
          h = h.split("&");
          for (let f = 0; f < h.length; f++) {
            const b = h[f],
              a = b.indexOf("=");
            -1 < a ? this.rha(this.decode(b.slice(0, a)), this.decode(b.slice(a + 1))) : b && this.rha(this.decode(b), "");
          }
        }
        rha(h, f) {
          this.IL.Bb(h) ? this.IL.getItem(h).push(f) : this.IL.Ua(h, [f]);
        }
        decode(h) {
          return h.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/ig, function (f) {
            return decodeURIComponent(f);
          });
        }
      }
      e.bna = k;
    })(q || (q = {}));
    (function (e) {
      class k {
        static g1() {
          return getComputedStyle(document.documentElement).getPropertyValue("--fm-version").trim().replace(/"/g, "");
        }
        static Jua(h) {
          return k.g1() === h;
        }
      }
      e.eX = k;
    })(u || (u = {}));
    var x;
    (function (e) {
      (function (k) {
        class h {
          constructor() {
            this.distance = 15;
            this.YQ = !1;
            this.IB = null;
            this.IE = !0;
            q.Dk.addEventListener("mousemove", f => this.ux(f));
            q.Dk.addEventListener("touchmove", f => this.l4(f), !1);
            q.Dk.addEventListener("mouseup", f => this.vr(f));
            q.Dk.addEventListener("touchend", f => this.qV(f));
            q.Dk.addEventListener("touchcancel", f => this.qV(f));
          }
          get CCa() {
            return this.YQ;
          }
          static R() {
            h.instance || (h.instance = new h());
            return h.instance;
          }
          static dispose() {
            h.instance = null;
          }
          $Da(f, b) {
            f.$("fm-draggable");
            var a = c => {
              b.LT && !c.target.matches(b.LT) || this.Pd == f || (null != this.Pd && this.A5(b, c), this.Pd = f, this.Eo = b, this.Wia = this.K1(c), this.Xia = this.L1(c), this.b6 = !1);
            };
            f.N("mousedown", a);
            f.N("touchstart", a);
          }
          K1(f) {
            return f instanceof MouseEvent ? f.clientX : f.changedTouches[0].clientX;
          }
          L1(f) {
            return f instanceof MouseEvent ? f.clientY : f.changedTouches[0].clientY;
          }
          ux(f) {
            1 == f.which && this.Pd && (this.Sg && this.Pd.Sc("fm-dragging") ? (this.dW(f.clientX, f.clientY), this.Eo.t3 && this.Eo.t3(this.Pd, f), f.preventDefault(), window.getSelection().removeAllRanges()) : q.v(this.Eo.sx) || this.Eo.sx(this.Pd, f) ? (this.YQ = !0, this.Sg = this.Eo.Ao(this.Pd), this.Sg.U("opacity", 0), q.K.Nb.Gb.G.X(this.Sg), this.dW(f.clientX, f.clientY, !0), this.Pd.$("fm-dragging")) : (this.Pd = null, q.v(this.Sg) || (this.Sg.Lg(!0), this.Sg = null)));
          }
          Rea(f, b) {
            return Math.abs(this.Wia - f) > this.distance || Math.abs(this.Xia - b) > this.distance ? !0 : !1;
          }
          dW(f, b) {
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            if (null != this.Sg) {
              const d = q.K.Nb.Gb.G.qg();
              this.Sg.U("margin-left");
              this.Sg.U("margin-top");
              if (a && null != this.Pd) {
                var c = this.Pd.qg();
                a = Math.max(0, Math.min(this.Pd.height, b - c.top));
                c = Math.max(0, Math.min(this.Pd.width, this.Sg.width, f - c.left));
                this.Sg.U("margin-top", -a + "px");
                this.Sg.U("margin-left", -c + "px");
              }
              this.Sg.position({
                top: b - d.top,
                left: f - d.left
              });
              this.Rea(f, b) && (this.Sg.U("opacity", 1), this.Pd.$("fm-dragging-move"), !this.b6 && q.Kg(this.Eo.cV) && this.Eo.cV(this.Pd), this.b6 = !0);
            }
          }
          l4(f) {
            if (this.Pd) {
              var b = f.touches[0];
              if (this.Sg && this.Pd.Sc("fm-dragging")) {
                this.dW(b.clientX, b.clientY);
                this.Eo.t3 && this.Eo.t3(this.Pd, f);
                f.preventDefault();
                b = f.changedTouches[0];
                var a = e.Ga.Xb(document.elementFromPoint(b.clientX, b.clientY));
                if (a) {
                  var c = a.closest(".fm-droppable");
                  c && !0 === c.vu.scroll && this.pea(c, b.clientY);
                  c && c.vu && c.vu.Tm && (c.vu.Tm(this.Pd, this.Sg, c, f), this.IB = c);
                }
                (null == a || null == c) && null != this.IB && this.IB.vu && this.IB.vu.em && this.IB.vu.em(this.Pd, this.Sg, this.IB, f);
              } else q.v(this.Eo.sx) || this.Eo.sx(this.Pd, f) ? (this.YQ = !0, this.Sg = this.Eo.Ao(this.Pd), this.Sg.U("opacity", 0), q.K.Nb.Gb.G.X(this.Sg), this.dW(b.clientX, b.clientY, !0), this.Pd.$("fm-dragging")) : (this.Pd = null, this.Sg.Lg(!0), this.Sg = null);
            }
          }
          vr(f) {
            this.A5(this.Eo, f);
          }
          qV(f) {
            for (var b = f.changedTouches[0], a = b = e.Ga.Xb(document.elementFromPoint(b.clientX, b.clientY)); b;) {
              if (b.Sc("fm-droppable")) {
                q.ia(b.vu.Iz) || (a = a.closest(b.vu.Iz));
                b.vu.Um(this.Pd, b, a, f);
                break;
              }
              b = b.parent;
            }
            this.A5(this.Eo, f);
          }
          A5(f, b) {
            this.YQ = !1;
            null != this.Sg && (this.Sg.Lg(!0), this.Sg = null);
            if (null != this.Pd) {
              this.Pd.Gd("fm-dragging");
              this.Pd.Gd("fm-dragging-move");
              if (this.b6 && this.Pd && this.Pd.element) {
                var a = this.Pd,
                  c = d => {
                    q.v(a) || (a.pb("click", c), a = null, d.stopImmediatePropagation());
                  };
                this.Pd.N("click", c);
              }
              f.ev && this.Rea(this.K1(b), this.L1(b)) && f.ev(this.Pd, b);
              this.Pd = null;
            }
            this.IB = null;
            this.Xia = this.Wia = NaN;
            this.IE = !0;
            clearTimeout(this.Tha);
          }
          aEa(f, b, a) {
            f.Sc("fm-droppable") || (f.$("fm-droppable"), f.N("mouseenter", c => {
              null != this.Pd && 1 == c.which && a.u3 && a.u3(this.Pd, this.Sg, b, c);
            }), f.N("mouseleave", c => {
              this.IE = !0;
              null != this.Pd && 1 == c.which && a.em && a.em(this.Pd, this.Sg, b, c);
            }), f.N("mouseover", c => {
              this.IE = !0;
              null != this.Pd && 1 == c.which && (!0 === a.scroll && this.pea(f, c.clientY), a.Tm && a.Tm(this.Pd, this.Sg, b, c));
            }), f.N("mouseup", c => {
              this.IE = !0;
              if (null != this.Pd && 1 == c.which) {
                var d = e.Ga.Xb(c.target);
                q.ia(a.Iz) || (d = d.closest(a.Iz));
                a.Um(this.Pd, f, d, c);
              }
            }));
          }
          pea(f, b) {
            const a = f.element.getBoundingClientRect(),
              c = Math.max(0, a.bottom - b);
            b = Math.max(0, b - a.top);
            30 > c ? (this.IE = !1, this.U4(f, Math.min(30 / c, 4))) : 30 > b && (this.IE = !1, this.U4(f, Math.min(-30 / b, 4)));
          }
          U4(f, b) {
            clearTimeout(this.Tha);
            q.v(f) || (f.Ex(f.element.scrollTop + b), 0 == this.IE && (this.Tha = setTimeout(() => this.U4(f, b), 20)));
          }
        }
        k.SO = h;
      })(e.ML || (e.ML = {}));
    })(x || (x = {}));
    (function (e) {
      class k extends v.Fh {
        constructor() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "div";
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
          super();
          this.G = new e.Ga(h);
          this.G.$("fm-ui " + f);
          u.Jd().Rm && this.G.$("fm-ui-mobile");
          this.validate();
        }
        validate() {
          this.h2 = {};
        }
        ne() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";
          this.h2[h] = !0;
          this.nb();
        }
        Ls() {
          if (this.h2.all) return !0;
          for (var _len3 = arguments.length, h = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            h[_key3] = arguments[_key3];
          }
          for (var f = 0; f < h.length; f++) if (this.h2[h[f]]) return !0;
          return !1;
        }
        nb() {
          this.validate();
        }
        Kr() {
          this.ne();
        }
        show() {
          this.G.show();
        }
        Za() {
          this.G.Za();
        }
        s1() {
          return this.G.attr("id");
        }
        pia(h) {
          this.G.attr("id", h);
        }
        xia() {
          this.pia("fm-" + Math.random().toString(36).substr(2, 9));
        }
        iD() {
          return this.name;
        }
        Je() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          this.G.Je(h);
        }
        Rk(h) {
          this.G.Rk(h);
        }
        get Pm() {
          return this.G.Pm;
        }
        get O1() {
          return this.G.O1;
        }
        html(h) {
          if (void 0 === h) return this.G.html();
          this.G.html(h);
          return this;
        }
        ki(h) {
          this.G.attr("title", h);
        }
        vq(h) {
          this.lua(!h);
          this.G.$a("fm-ui-disabled", !h);
        }
        oM() {
          return !this.G.Sc("fm-ui-disabled");
        }
        $() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          this.G.$(h);
        }
        Gd(h) {
          this.G.Gd(h);
        }
        $a(h, f) {
          this.G.$a(h, f);
        }
        Sc(h) {
          return this.G.Sc(h);
        }
        get padding() {
          return this.G.padding;
        }
        set padding(h) {}
        Zf(h) {
          return this.G.Zf(h);
        }
        Tk(h) {
          this.Zf() !== h && (this.G.Tk(h), this.ne("size"));
        }
        yd() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          return this.G.yd(h);
        }
        Er(h) {
          this.yd() !== h && (this.G.Er(h), this.ne("size"));
        }
        isVisible(h) {
          void 0 !== h && (h ? this.show() : this.Za());
          return this.G.visible;
        }
        position() {
          return this.G.position();
        }
        X(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          f ? this.G.prepend(h.G) : this.G.append(h.G);
        }
        Lg() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          h ? this.G.remove() : this.G.detach();
        }
        K1() {
          return this.G.left;
        }
        L1() {
          return this.G.top;
        }
        N(h, f) {
          this.G.N(h, f);
        }
        pb(h, f) {
          this.G.pb(h, f);
        }
        Ea(h) {
          this.G.Ea(h);
        }
        Ya(h, f, b) {
          this.G.Ya(h, f, b);
        }
        bC() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          h = h ? this.Zf(!0) : q.K.Nb.Hx;
          this.G.$a("fm-layout-tablet", 768 > h);
          this.G.$a("fm-layout-mobile", 580 > h);
          this.G.$a("fm-layout-mobile-small", 460 > h);
        }
        focus() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          this.G.focus(h);
        }
        blur() {
          this.G.blur();
        }
        Dg(h, f) {
          return this.G.Dg(h, f);
        }
        qc(h) {
          return this.G.Dg("label", h);
        }
        ro() {
          this.G.Dg("hidden", "true");
        }
        lua(h) {
          this.G.Dg("disabled", void 0 === h ? void 0 : `${h}`);
        }
        Yaa(h) {
          this.G.Dg("selected", void 0 === h ? void 0 : `${h}`);
        }
        kua(h) {
          this.G.Dg("checked", void 0 === h ? void 0 : `${h}`);
        }
        Xaa(h) {
          this.G.Dg("expanded", void 0 === h ? void 0 : `${h}`);
        }
        mua(h) {
          this.G.Dg("haspopup ", void 0 === h ? void 0 : `${h}`);
        }
      }
      e.Na = k;
    })(x || (x = {}));
    (function (e) {
      class k extends v.Fh {
        constructor() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "div";
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          super();
          this.display = "block";
          this.frames = [];
          this.Oq = {};
          this.element = "string" == typeof h ? document.createElement(h) : h;
          b && this.$("fm-ui-element");
          this.$(f);
        }
        set element(h) {
          (this.PF = h) && (this.PF.uielement = this);
        }
        get element() {
          return this.PF;
        }
        get id() {
          return this.element.id;
        }
        set id(h) {
          this.element.id = h;
        }
        get parent() {
          return k.Xb(this.element.parentElement);
        }
        get nodeName() {
          return this.PF.nodeName.toLowerCase();
        }
        X(h) {
          this.element.appendChild(h.element);
        }
        children() {
          for (var h = this.element.firstElementChild, f = []; h;) f.push(k.Xb(h)), h = h.nextElementSibling;
          return f;
        }
        contains(h) {
          return this.element.contains(h.element);
        }
        gS(h) {
          let f = this.N_(h.target);
          !f && h.path && (f = this.N_(h.path[0]));
          !f && h.composedPath && (h = h.composedPath()) && (f = this.N_(h[0]));
          return f;
        }
        N_(h) {
          if (null == h) return !1;
          for (; h != this.element && (h = h.parentElement, null != h););
          return null != h;
        }
        append(h) {
          h && this.X(h);
          return this;
        }
        prepend(h) {
          this.element.insertBefore(h.element, this.element.firstChild);
          return this;
        }
        before(h) {
          this.element.parentNode && this.element.parentNode.insertBefore(h.element, this.element);
          return this;
        }
        after(h) {
          this.element.parentNode && (this.element.nextElementSibling ? this.element.parentNode.insertBefore(h.element, this.element.nextElementSibling) : this.element.parentNode.appendChild(h.element));
          return this;
        }
        $B(h) {
          this.element.appendChild(h.G.element);
        }
        Lg() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
          h ? this.remove() : this.detach();
        }
        remove() {
          null != this.element && (this.element.parentNode && this.element.parentNode.removeChild(this.element), this.dispose());
        }
        detach() {
          if (null != this.element && this.element.parentNode) {
            var h = this.element.cloneNode(!0);
            this.element.parentNode.removeChild(this.element);
            this.element = h;
          }
        }
        xx() {
          for (; this.element && this.element.firstChild;) {
            var h = k.Xb(this.element.firstChild);
            h && h.dispose && h.dispose();
            this.element.removeChild(this.element.firstChild);
          }
        }
        clone() {
          return k.Xb(this.element.cloneNode(!0));
        }
        static Xb(h) {
          return h && h.nodeType == Node.ELEMENT_NODE ? q.v(h.uielement) ? new k(h, "", !1) : h.uielement : null;
        }
        get(h) {
          var f = this.children();
          return 0 < f.length ? f[h] : null;
        }
        find(h, f) {
          if (void 0 === f || 0 == f) return k.Xb(this.element.querySelector(h));
          h = this.element.querySelectorAll(h);
          f = [];
          for (var b = 0; b < h.length; b++) f.push(k.Xb(h[b]));
          return f;
        }
        closest(h) {
          if (!this.element) return null;
          for (var f = this.element; null != f;) {
            if (f.matches) {
              if (f.matches(h)) return f == this.element ? this : k.Xb(f);
            } else if (f.msMatchesSelector && f.msMatchesSelector(h)) return f == this.element ? this : k.Xb(f);
            f = f.parentElement;
          }
          return null;
        }
        $(h) {
          if (!this.element) return this;
          h = h.trim();
          for (var f = h.split(" "), b = 0; b < f.length; b++) 0 < f[b].length && (u.yS().cj ? (h = this.element.getAttribute("class"), q.v(h) ? this.element.setAttribute("class", f[b]) : -1 == h.split(" ").indexOf(f[b]) && this.element.setAttribute("class", h + " " + f[b])) : 0 == this.element.classList.contains(f[b]) && this.element.classList.add(f[b]));
          return this;
        }
        Gd(h) {
          if (this.element && (h = h.trim(), 0 < h.length)) if (u.yS().cj) {
            var f = this.element.getAttribute("class");
            q.v(f) || (f = f.split(" "), h = f.indexOf(h), -1 < h && (f.splice(h, 1), this.element.setAttribute("class", f.join(" "))));
          } else this.element.classList.contains(h) && this.element.classList.remove(h);
        }
        $a(h, f) {
          f ? this.$(h) : this.Gd(h);
        }
        Sc(h) {
          return this.element.classList.contains(h);
        }
        Ul() {
          this.$("fm-noselect");
        }
        gya() {
          this.$("fm-selectable");
        }
        Zf() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          if (!this.element) return 0;
          var f = this.Uy;
          return this.element.clientWidth - (h ? 0 : (parseFloat(f.paddingLeft) || 0) + (parseFloat(f.paddingRight) || 0));
        }
        Tk(h) {
          "number" === typeof h ? this.element.style.width = h + "px" : "string" === typeof h && (this.element.style.width = h);
          return this;
        }
        get width() {
          return this.Zf();
        }
        set width(h) {
          this.Tk(h);
        }
        get padding() {
          var h = this.Uy;
          return {
            left: parseFloat(h.paddingLeft) || 0,
            right: parseFloat(h.paddingRight) || 0,
            top: parseFloat(h.paddingTop) || 0,
            bottom: parseFloat(h.paddingBottom) || 0
          };
        }
        set padding(h) {}
        get borderWidth() {
          var h = this.Uy;
          return {
            left: parseFloat(h.borderLeftWidth || h.borderWidth) || 0,
            right: parseFloat(h.borderRightWidth || h.borderWidth) || 0,
            top: parseFloat(h.borderTopWidth || h.borderWidth) || 0,
            bottom: parseFloat(h.borderBottomWidth || h.borderWidth) || 0
          };
        }
        yd() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          if (!this.element) return 0;
          var f = this.Uy;
          h = h ? 0 : (parseFloat(f.paddingTop) || 0) + (parseFloat(f.paddingBottom) || 0);
          return 0 > this.element.clientHeight - h ? 0 : this.element.clientHeight - h;
        }
        Er(h) {
          "number" === typeof h ? this.element.style.height = h + "px" : "string" === typeof h && (this.element.style.height = h);
        }
        get height() {
          return this.yd();
        }
        set height(h) {
          this.Er(h);
        }
        get left() {
          return this.element.getBoundingClientRect().left;
        }
        set left(h) {
          this.element.style.left = h + "px";
        }
        get top() {
          return this.element.getBoundingClientRect().top;
        }
        set top(h) {
          this.element.style.top = h + "px";
        }
        get right() {
          return this.element.getBoundingClientRect().right;
        }
        set right(h) {
          this.element.style.right = h + "px";
        }
        get bottom() {
          return this.element.getBoundingClientRect().bottom;
        }
        set bottom(h) {
          this.element.style.bottom = h + "px";
        }
        html(h) {
          if (void 0 === h) return this.element.innerHTML;
          this.element.innerHTML = h;
          return this;
        }
        empty() {
          this.html("");
        }
        clear() {
          this.empty();
        }
        text(h) {
          if (void 0 === h) return this.element.textContent;
          "input" == this.element.tagName.toLowerCase() ? this.element.value = h : this.element.textContent = h;
          return this;
        }
        focus() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          this.element.focus(h);
          return this;
        }
        blur() {
          this.element.blur();
          return this;
        }
        show() {
          this.element.style.display = this.display;
        }
        Za() {
          this.element.style.display = "none";
        }
        get x() {
          return this.element.offsetLeft;
        }
        get y() {
          return this.element.offsetTop;
        }
        offset(h) {
          if (void 0 === h) return this.qg();
          this.U("left", h.left + "px");
          this.U("top", h.top + "px");
        }
        getBoundingClientRect() {
          return this.element.getBoundingClientRect();
        }
        position(h) {
          if (void 0 === h) return {
            top: this.y,
            left: this.x
          };
          this.offset(h);
        }
        attr(h, f) {
          if (void 0 === f) return this.element.getAttribute(h);
          try {
            this.element.setAttribute(h, f);
          } catch (b) {
            this.element && this.element.attributes && (this.element.attributes[h] = f);
          }
          return this;
        }
        G4(h) {
          this.element.removeAttribute(h);
        }
        U(h, f) {
          if (void 0 === f) return this.Uy[k.hja(h)];
          this.element.style[k.hja(h)] = f;
          return this;
        }
        Dg(h, f) {
          if (void 0 === f) return this.attr(`aria-${h}`);
          this.attr(`aria-${h}`, f);
        }
        static hja(h) {
          var f = h.split("-");
          if (1 < f.length) {
            for (h = 1; h < f.length; h++) f[h] = f[h].charAt(0).toUpperCase() + f[h].substr(1);
            return f.join("");
          }
          return h;
        }
        qO() {
          return "input" == this.element.tagName.toLowerCase() || "textarea" == this.element.tagName.toLowerCase() ? this.element.value : this.element.textContent;
        }
        get Uy() {
          q.v(this.GY) && (this.GY = window.getComputedStyle(this.element));
          return this.GY;
        }
        set Uy(h) {
          this.GY = h;
        }
        requestAnimationFrame(h) {
          var f = 0;
          this.Uy = null;
          window.requestAnimationFrame ? f = window.requestAnimationFrame(h) : window.msRequestAnimationFrame ? f = window.msRequestAnimationFrame(h) : window.mozRequestAnimationFrame ? f = window.mozRequestAnimationFrame(h) : window.webkitRequestAnimationFrame ? f = window.webkitRequestAnimationFrame(h) : h.call(null);
          this.frames.push(f);
          return f;
        }
        cancelAnimationFrame(h) {
          this.Uy = null;
          this.frames.splice(this.frames.indexOf(h), 1);
          0 != h && (null != window.cancelAnimationFrame ? window.cancelAnimationFrame(h) : null != window.msCancelRequestAnimationFrame ? window.msCancelRequestAnimationFrame(h) : null != window.mozCancelAnimationFrame ? window.mozCancelAnimationFrame(h) : null != window.webkitCancelAnimationFrame && window.webkitCancelAnimationFrame(h));
        }
        set visible(h) {
          h ? this.show() : this.Za();
        }
        get visible() {
          return this.element && "none" != this.U("display");
        }
        qg() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          if (null == h) return h = this.element.getBoundingClientRect(), {
            top: h.top,
            left: h.left
          };
          for (var f = 0, b = 0, a = this.element; a && a != h && !isNaN(a.offsetLeft) && !isNaN(a.offsetTop);) f += a.offsetLeft - a.scrollLeft, b += a.offsetTop - a.scrollTop, a = a.offsetParent;
          return {
            top: b,
            left: f
          };
        }
        Ex(h) {
          this.element.scrollTop = h;
        }
        lKa() {
          this.element.scrollLeft = 0;
        }
        N(h, f, b) {
          "undefined" !== typeof this.element["on" + h] || v.ga.jfa(h) ? (q.v(this.Oq[h]) && (this.Oq[h] = []), this.Oq[h][f.toString()] = a => {
            f(a);
          }, this.element.addEventListener(h, this.Oq[h][f.toString()], b)) : super.N(h, f, b);
        }
        pb(h, f) {
          "undefined" !== typeof this.element["on" + h] || v.ga.jfa(h) ? this.Oq[h] && this.element.removeEventListener(h, this.Oq[h][f.toString()], void 0) : super.pb(h, f);
        }
        Ea(h) {
          super.Ea(h);
        }
        Td(h) {
          for (var f in this.Oq) if (void 0 === h || h == f) for (var b in this.Oq[f]) if (this.Oq[f].hasOwnProperty(b)) try {
            this.element.removeEventListener(f, this.Oq[f][b], !0), this.element.removeEventListener(f, this.Oq[f][b], !1);
          } catch (a) {
            console.error(a);
          }
          this.Oq = {};
          super.Td(f);
        }
        dispose() {
          this.Td();
          this.xx();
          this.PF && (this.PF = this.PF.uielement = null);
          for (var h = 0; h < this.frames.length; h++) this.cancelAnimationFrame(this.frames[h]);
          this.frames.length = 0;
          this.eaa && this.eaa.dispose();
        }
        refresh() {
          this.html(this.html());
        }
        draggable(h) {
          e.ML.SO.R().$Da(this, h);
        }
        Ds(h, f) {
          this.Wra = h;
          e.ML.SO.R().aEa(this, f ? f : this, h);
        }
        get vu() {
          return this.Wra;
        }
        index() {
          for (var h = 0, f = this.element; f = f.previousElementSibling;) h++;
          return h;
        }
        fj(h) {
          this.eaa = new e.fj.$pa(this, h);
        }
        Je() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          this.attr("tabindex", h);
        }
        Rk(h) {
          this.attr("role", h);
        }
        get Pm() {
          return document.activeElement == this.element;
        }
        get O1() {
          let h = document.activeElement;
          for (; null != h;) {
            if (h == this.element) return !0;
            h = h.parentElement;
          }
          return !1;
        }
      }
      e.Ga = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Na {
        constructor() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "a";
          super(f, "fm-ui-btn");
          this.i3 = 0;
          this.$Ia = 50;
          this.$(h);
          this.G.N("click", b => this.Lk(b));
          this.G.N("mousedown", () => this.tx());
          this.G.N("mouseup", () => this.vr());
          this.G.N("mouseout", () => this.EGa());
          this.G.N("keydown", b => this.mq(b));
          this.G.display = "inline-block";
          this.Rk("button");
          this.Je(0);
        }
        Lk(h) {
          this.oM() && this.Ya(k.tf, this, h);
          h instanceof MouseEvent && h.stopImmediatePropagation();
        }
        mq(h) {
          if (13 == h.keyCode || 32 == h.keyCode) this.Lk(h), h.preventDefault();
        }
        tx() {
          this.G.$a("fm-ui-pressed", !0);
          this.i3 = q.jda(() => this.wxa(), this.$Ia);
        }
        wxa() {
          this.Ea(new v.ga(k.Xoa, this));
        }
        vr() {
          this.G.$a("fm-ui-pressed", !1);
          q.P0(this.i3);
        }
        EGa() {
          this.G.$a("fm-ui-pressed", !1);
          q.P0(this.i3);
        }
        J() {
          return this.label;
        }
        gb(h) {
          this.label != h && (this.label = h, this.G.text(this.label));
        }
      }
      k.Xoa = "buttonmousedown";
      k.tf = "buttonclick";
      e.Nd = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Nd {
        constructor() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          super(h, "button");
          this.G.attr("type", "button");
        }
      }
      e.Qg = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Na {
        constructor() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          super("span", "fm-ui fm-ui-label");
          this.G.display = "inline-block";
          this.gb(h);
        }
        J() {
          return this.label;
        }
        gb(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          this.label != h && (this.label = h, f ? this.G.html(this.label) : this.G.text(this.label));
        }
        jW(h) {
          h ? this.G.gya() : this.G.Ul();
        }
      }
      e.Vc = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Na {
        constructor() {
          super("textarea", "fm-ui-text-area");
          this.G.N("keypress", h => this.L3(h));
          this.G.N("keyup", h => this.M3(h));
          this.G.N("paste", () => this.I3());
          this.G.N("blur", () => this.JBa());
        }
        M3() {
          this.KL();
        }
        I3() {
          this.KL();
        }
        JBa() {
          this.Ya(k.qX);
        }
        KL() {
          this.Ea(new v.ga(e.Oj.Wx, this));
        }
        Zi() {
          return this.G.qO();
        }
        Jj(h) {
          this.Zi() != h && (this.G.element.value = h, this.KL());
        }
        clear() {
          this.Jj("");
        }
        Bz(h) {
          var f = this.G.element.selectionStart,
            b = this.G.element.selectionEnd,
            a = this.Zi();
          this.Jj(a.substr(0, f) + h + a.substr(f));
          this.Gf(f + h.length, b + h.length);
        }
        Gf(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
          this.G.element.focus();
          this.G.element.setSelectionRange(h, 0 > f ? h : f);
        }
        selectAll() {
          this.Gf(0, this.Zi().length);
        }
        L3(h) {
          h.ctrlKey ? (this.Ya(k.pX), h.preventDefault()) : 13 == h.keyCode && (this.Ya(k.OA), h.preventDefault());
        }
      }
      k.qX = "focus_off";
      k.OA = "ntr";
      k.pX = "ntl";
      e.Lv = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Na {
        constructor() {
          super("input", "fm-ui-text-input");
          this.prompt = this.text = "";
          this.p_ = 0;
          this.q_ = !0;
          this.G.display = "inline-block";
          this.G.attr("type", "text");
          this.G.attr("autocomplete", "off");
          this.G.attr("data-placeholder", "");
          this.G.N("change", () => this.vHa());
          this.G.N("focusin", () => this.A3());
          this.G.N("focusout", () => this.NFa());
          this.G.N("input", () => this.wHa());
          this.G.N("keypress", h => this.L3(h));
          this.G.N("paste", () => this.I3());
        }
        static Uza(h) {
          return null == h.which ? 32 > h.keyCode ? null : String.fromCharCode(h.keyCode) : 0 != h.which && 0 != h.charCode ? 32 > h.which ? null : String.fromCharCode(h.which) : null;
        }
        L3(h) {
          13 == h.keyCode && this.Ya(k.OA);
          if (!(q.v(this.Gha) || h.ctrlKey || h.altKey || h.metaKey)) {
            var f = k.Uza(h);
            null != f && !1 === this.Gha.test(f) && h.preventDefault();
          }
        }
        N1() {
          this.G.qO() !== this.text && (this.text = this.G.qO(), this.KL());
        }
        vHa() {
          this.N1();
        }
        wHa() {
          this.N1();
        }
        I3() {
          this.N1();
        }
        KL() {
          0 < this.p_ ? this.q_ && (this.q_ = !1, q.Be(() => this.MY(), this.p_)) : this.MY();
        }
        MY() {
          this.q_ = !0;
          this.Ea(new v.ga(k.Wx, this, this.text));
        }
        A3() {
          0 == this.text.length && (this.G.text(""), this.wu(!1));
        }
        NFa() {
          this.wu(0 == this.text.length);
        }
        Zi() {
          return this.text = this.G.qO() == this.prompt ? this.text : this.G.qO();
        }
        Jj(h) {
          this.text != h && (this.text = h, this.G.text(this.text), this.wu(0 == this.text.length));
        }
        clear() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
          this.Jj("");
          h && this.MY();
          this.Ya(k.r7);
        }
        xE(h) {
          h != this.prompt && (this.prompt = h, this.G.attr("data-placeholder", this.prompt), this.wu(0 == this.text.length));
        }
        wu(h) {
          this.G.text(h ? this.prompt : this.text);
          this.G.$a("fm-ui-prompt", h);
        }
        yE(h) {
          this.Gha = h;
        }
        YV(h) {
          this.p_ = h;
        }
        pKa() {
          this.G.attr("type", "number");
        }
      }
      k.Wx = "_";
      k.OA = "ntr";
      k.r7 = "clr";
      e.Oj = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Oj {
        constructor() {
          super();
          this.yE(k.Spa);
          this.pKa();
        }
        La() {
          return parseFloat(this.Zi());
        }
        li(h) {
          this.Jj(h.toString());
        }
      }
      k.Spa = /^\d+$/;
      k.CF = /[-\.\d]/;
      e.Nq = k;
    })(x || (x = {}));
    (function (e) {
      (function (h) {
        h[h.COa = 1] = "SELECTED";
        h[h.TOa = 0] = "UNSELECTED";
        h[h.FOa = -1] = "SEMI_SELECTED";
      })(e.Zqa || (e.Zqa = {}));
      class k extends e.Nd {
        constructor() {
          super();
          this.G.display = "inline-block";
          this.G.Sc("fm-ui-btn") && this.G.Gd("fm-ui-btn");
          this.G.$("fm-ui-toggle-btn");
          this.selected = 0;
        }
        Lk(h) {
          this.oM() && (this.toggle(), this.Ya(v.ga.Zd, this, h));
          h instanceof MouseEvent && h.stopImmediatePropagation();
        }
        toggle() {
          this.Gf(1 == this.selected ? 0 : 1);
        }
        Gf(h) {
          !0 === h && (h = 1);
          !1 === h && (h = 0);
          this.selected == h || 1 < h || -1 > h || (this.selected = h, this.G.$a("fm-selected", 1 == this.selected), 1 == this.selected ? this.Dg("checked", "true") : -1 == this.selected ? this.Dg("checked", "mixed") : this.Dg("checked", "false"));
        }
        getSelection() {
          return this.selected;
        }
      }
      e.uY = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Qg {
        constructor() {
          super();
          this.Rk("switch");
          this.G.display = "inline-block";
          this.G.Sc("fm-ui-btn") && this.G.Gd("fm-ui-btn");
          this.G.$("fm-ui-toggle-btn");
          this.Gf(0);
        }
        Lk(h) {
          this.oM() && (this.toggle(), this.Ya(v.ga.Zd, this, h));
        }
        toggle() {
          this.Gf(1 == this.selected ? 0 : 1);
        }
        Gf(h) {
          !0 === h && (h = 1);
          !1 === h && (h = 0);
          this.selected == h || 1 < h || -1 > h || (this.selected = h, this.G.$a("fm-selected", 1 == this.selected), this.kua(1 == this.selected));
        }
        getSelection() {
          return this.selected;
        }
      }
      e.jQ = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.uY {
        constructor() {
          super();
          this.G.display = "inline-block";
          this.G.Sc("fm-ui-toggle-btn") && this.G.Gd("fm-ui-toggle-btn");
          this.G.$("fm-ui-checkbox");
          this.TH = new e.Vc("Label");
          this.G.append(this.TH.G);
          this.Rk("checkbox");
        }
        toggle() {
          super.toggle();
          this.G.$a("fm-ui-semi-selected", -1 == this.getSelection());
        }
        gb(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          null != this.TH && this.TH.gb(h, f);
        }
        J() {
          return null != this.TH ? this.TH.J() : "";
        }
        Gf(h) {
          !0 === h && (h = 1);
          !1 === h && (h = 0);
          this.getSelection() == h || 1 < h || -1 > h || (super.Gf(h), this.G.$a("fm-ui-semi-selected", -1 == this.getSelection()));
        }
        get checked() {
          return 1 == this.getSelection();
        }
        set checked(h) {
          this.Gf(h ? 1 : 0);
        }
        ki(h) {
          this.TH.ki(h);
        }
      }
      e.cK = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Na {
        constructor() {
          super("div", "fm-ui-divider");
          this.iga = h => this.ux(h);
          this.uEa = h => this.tx(h);
          this.vEa = h => this.vr(h);
          this.direction = k.CJ;
          this.N("mousedown", this.uEa);
          q.Dk.addEventListener("mouseup", this.vEa);
          this.G.Ul();
        }
        tx(h) {
          this.Pt = this.direction == k.CJ ? this.yd() : this.Zf();
          this.sB = this.G.parent.qg();
          q.Dk.addEventListener("mousemove", this.iga);
          h.preventDefault();
          h.stopImmediatePropagation();
        }
        ux(h) {
          if (this.direction == k.CJ) {
            var f = h.clientY - this.sB.top;
            if (this.NF && (f < this.NF[1] || f > this.NF[3])) return;
            this.G.U("top", f - this.Pt / 2 + "px");
            this.Ya(k.rX, this, {
              top: f
            });
          }
          this.direction == k.wY && (h = h.clientX - this.sB.left, this.NF && (h < this.NF[0] || h > this.NF[2]) || (this.G.U("left", h - this.Pt / 2 + "px"), this.Ya(k.rX, this, {
            left: h
          })));
        }
        vr() {
          q.Dk.removeEventListener("mousemove", this.iga);
        }
        get direction() {
          return this.LY;
        }
        set direction(h) {
          this.LY = h;
          this.G.$a("fm-ui-horizontal", this.LY == k.CJ);
          this.G.$a("fm-ui-vertical", this.LY == k.wY);
          this.G.U("position", "absolute");
        }
        set jwa(h) {
          this.NF = h;
        }
      }
      k.CJ = 0;
      k.wY = 1;
      k.rX = "divider_moved_event";
      e.iQ = k;
    })(x || (x = {}));
    (function (e) {
      class k extends e.Na {
        constructor() {
          super("div", "fm-ui-modal-overlay");
        }
        kKa(h) {
          this.G.$a("fm-ui-transparent", !1);
          this.G.$a("fm-ui-opaque", h);
        }
      }
      e.Yqa = k;
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.Na {
          constructor() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "fm-ui-container";
            super("div", f);
          }
          removeChild(f) {
            this.contains(f) && f.G.detach();
          }
          contains(f) {
            return q.v(f) ? !1 : this.G.contains(f.G);
          }
          Zf() {
            return this.G.width;
          }
          yd() {
            return this.G.height;
          }
          xx() {
            for (var f = this.G.children(), b = f.length - 1; 0 <= b; b--) f[b].Lg();
          }
        }
        k.ik = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.ik {
          constructor() {
            super("fm-ui-border-container");
          }
        }
        k.F9 = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.ik {
          constructor() {
            super();
            this.G.$("fm-ui-window");
            this.Za();
          }
          setPosition(f, b) {
            this.G.offset({
              left: Math.floor(f),
              top: Math.floor(b)
            });
            this.G.U("position", "absolute");
          }
        }
        k.ara = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.ik {
          constructor() {
            super("fm-ui-hgroup");
          }
        }
        k.OOa = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.ik {
          constructor() {
            super("fm-ui-vgroup");
          }
        }
        k.SOa = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.ik {
          constructor() {
            super("fm-ui-panel");
          }
        }
        k.POa = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.ara {
          constructor(f) {
            super();
            this.Zv = !1;
            this.V$ = () => this.W3();
            this.Eha = b => this.m4(b);
            this.mG = this.C2 = !1;
            this.oZ = f;
            this.G.$("fm-ui-popup");
            this.Rk("dialog");
            this.Za();
            this.Vq = new e.Yqa();
            this.Vq.ro();
            this.Vq.N("click", this.V$);
            this.Vq.Za();
            this.oZ && this.oZ.X(this.Vq.G);
            this.Isa = new e.qG.Z7();
            this.Gra = new e.qG.Z7();
          }
          get Vu() {
            return this.Zv;
          }
          m4(f) {
            f.target === window && (this.G.requestAnimationFrame(() => this.Gp()), this.bC());
          }
          W3() {
            this.close();
          }
          open() {
            q.aM.addEventListener("resize", this.Eha);
            this.Vq.G.$a("fm-ui-opaque", this.C2);
            this.show();
            this.Gp();
            this.Ya(v.ga.OPENED);
            this.bC();
            this.Zv = !0;
            this.aw = document.activeElement;
            this.G.prepend(this.Isa);
            this.G.append(this.Gra);
          }
          show() {
            super.show();
            this.Vq && this.Vq.show();
          }
          Za() {
            super.Za();
            this.Vq && this.Vq.Za();
          }
          get JI() {
            return this.mG;
          }
          set JI(f) {
            this.mG = f;
            this.G.U("opacity", f ? 0 : null);
            this.Vq && this.Vq.G.U("opacity", f ? 0 : null);
          }
          close() {
            q.aM.removeEventListener("resize", this.Eha);
            this.Za();
            this.Ya(v.ga.CLOSED);
            this.Zv = !1;
            this.aw && (this.aw.focus({
              preventScroll: !0
            }), this.aw = null);
          }
          Gp() {
            var f = this.oZ,
              b = q.K.Nb.Gb.G.borderWidth,
              a = b ? Math.round(b.left) : 0;
            b = b ? Math.round(b.top) : 0;
            if (f) {
              var c = Math.max(a, (f.Zf(!0) - this.G.Zf(!0)) / 2);
              f = Math.max(b, (f.yd(!0) - this.G.yd(!0)) / 2);
              this.setPosition(c == a ? -1 * c : c, f == b ? -1 * f : f);
            }
          }
          get aE() {
            return this.Vq;
          }
        }
        k.oy = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.ik {
          constructor() {
            super("fm-ui-toolbar");
          }
        }
        k.QOa = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.ik {
          constructor() {
            super("fm-ui-toolbar-mobile");
            this.W1 = new e.Vc();
            this.W1.$("fm-ui-header-display");
            this.X(this.W1);
          }
          dKa(f) {
            this.$i != f && (this.$i = f, this.W1.gb(f));
          }
        }
        k.ROa = h;
      })(e.be || (e.be = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor() {
            this.items = [];
            this.ZK = [];
          }
          fW(f) {
            this.ZK = f;
          }
          v1(f, b) {
            if (0 > f || b > this.ZK.length + 1) return [];
            for (this.items.length = 0; f < b; f++) this.items.push(this.ZK[f]);
            return this.items;
          }
          getItem(f) {
            return this.ZK[f];
          }
          wH() {
            return this.ZK.length;
          }
        }
        k.KOa = h;
      })(e.fxa || (e.fxa = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.Na {
          constructor() {
            super("ul", "fm-ui-list");
            this.QV = NaN;
            this.h0 = u.Jd().Rm ? h.Bla : h.Ala;
            this.xI = [];
            this.uE = [];
            this.vi = 0;
            this.pl = !1;
            this.useCache = !0;
            this.IF = !1;
            this.I = [];
            this.Afa = [];
            this.vh = [];
            this.nf = "label";
            this.Yu = this.nxa;
            this.wR = this.G;
            this.Rk("list");
            this.xl = null;
            this.selectedIndex = -1;
            this.d5();
          }
          d5() {
            this.G.N("click", b => this.jV(b));
            this.G.N("mousedown", b => this.kV(b));
            this.G.N("keydown", b => this.VD(b));
          }
          Xd() {
            isNaN(this.QV) && 0 < this.vh.length && (this.QV = this.vh[0].yd(!0) + parseInt(this.vh[0].G.U("border-top-width")) + parseInt(this.vh[0].G.U("border-bottom-width")));
            return isNaN(this.QV) ? this.h0 : this.QV;
          }
          ZJa() {
            this.h0 = 37;
          }
          Sw() {
            return 0;
          }
          zH() {
            return this.I.length;
          }
          nb() {
            this.Ls("data") && this.Nxa();
            this.validate();
          }
          Nxa() {
            this.QIa();
            for (var b, a = this.Bc(), c = 0; c < a.length; c++) b = this.getItem(a[c], c), c == this.vi && (this.wR.Dg("activedescendant", b.s1()), b.G.$("fm-ui-active")), this.Ua(b);
            this.$a("fm-ui-empty", 0 == a.length);
            this.Qya && this.G.prepend(this.Qya);
            this.Pya && this.G.append(this.Pya);
            this.G.requestAnimationFrame(() => {
              0 < this.vh.length && (this.h0 = this.vh[0].yd());
            });
          }
          getItem(b, a) {
            if (this.useCache && 0 < this.Afa.length) {
              var c = this.Afa.pop();
              c.setData(b);
              c.Ym(a);
            } else c = this.Yu(b, a), this.nf && c.vg(this.nf), this.gx && c.gW(this.gx), this.Ep && c.ON(this.Ep);
            c.xia();
            return c;
          }
          Ua(b) {
            this.vh.push(b);
            this.X(b);
          }
          QIa() {
            for (; 0 < this.vh.length;) this.baa(this.vh.pop());
          }
          removeItem(b) {
            for (var a = 0; a < this.vh.length; a++) if (this.vh[a] === b) {
              this.vh.splice(a, 1);
              break;
            }
            this.baa(b);
          }
          baa(b) {
            null != this.G.find(b.G.element.nodeName) && b.G.remove();
          }
          VD(b) {
            if (32 == b.keyCode || 13 == b.keyCode) this.lV(this.vi, b), b.preventDefault();
            40 == b.keyCode && (this.Ki(this.vi + 1), b.preventDefault());
            38 == b.keyCode && (this.Ki(this.vi - 1), b.preventDefault());
          }
          Ki(b) {
            this.vi = Math.max(0, Math.min(this.vh.length - 1, b));
            for (var a of this.vh) a.Gd("fm-ui-active");
            this.wR.Dg("activedescendant", "");
            if (b = this.vh[this.vi]) {
              this.wR.Dg("activedescendant", b.s1());
              b.$("fm-ui-active");
              a = this.G.parent.getBoundingClientRect();
              const c = b.G.getBoundingClientRect().top + this.G.parent.element.scrollTop,
                d = c + b.yd();
              c < a.top ? b.G.element.scrollIntoView(!0) : d > a.bottom && b.G.element.scrollIntoView(!1);
            }
          }
          TC(b) {
            if (b = e.Ga.Xb(b).closest("li")) {
              const a = parseInt(b.attr("data-index"));
              return isNaN(a) ? null : {
                element: b,
                index: a,
                data: this.Bc()[a]
              };
            }
            return null;
          }
          Gu() {
            const b = this.Sw() + this.vi;
            return 0 <= b ? q.v(this.Bc()[b]) || q.v(this.vh[b]) ? null : {
              index: b,
              data: this.Bc()[b],
              element: this.vh[b].G
            } : null;
          }
          kV(b) {
            (b = this.TC(b.target)) && this.Ki(b.index);
          }
          jV(b) {
            const a = this.TC(b.target);
            a && this.lV(a.index, b);
          }
          lV(b, a) {
            if (!(0 > b)) {
              var c = this.Sw() + b,
                d = this.xl,
                g = this.selectedIndex;
              this.Sk(b);
              var l = new f();
              l.data = {
                xl: this.xl,
                selectedIndex: this.selectedIndex,
                PJa: this.vh[b].G,
                pq: a,
                JIa: c,
                AIa: d,
                zIa: g
              };
              this.Ea(l);
            }
          }
          Bc() {
            return this.I;
          }
          cg(b) {
            let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            this.I = b;
            this.vi = 0;
            a && this.ne("data");
          }
          gW(b) {
            this.gx != b && (this.gx = b, this.ne("data"));
          }
          mr() {
            return this.nf;
          }
          vg(b) {
            this.nf != b && (this.nf = b, this.ne("data"));
          }
          jH() {
            return this.Ep;
          }
          ON(b) {
            this.Ep != b && (this.Ep = b, this.ne("data"));
          }
          ji(b) {
            this.Yu = b;
            this.ne("data");
          }
          nt(b) {
            -1 < b && b < this.vh.length && this.vh[b].Kr();
          }
          Jr(b) {
            for (var a, c = 0; c < this.vh.length; c++) if (a = this.vh[c].getData(), q.Kg(b)) {
              if (b(a)) {
                this.vh[c].Kr();
                break;
              }
            } else if (a === b) {
              this.vh[c].Kr();
              break;
            }
          }
          DH() {
            return this.selectedIndex;
          }
          Sk(b) {
            var a = this.Bc();
            -1 < b && b < a.length ? this.JW(a[b], b) : this.JW(null, -1);
          }
          Ph() {
            return this.xl;
          }
          ft(b) {
            var a = this.Bc();
            if (q.Kg(b)) for (var c = 0; c < a.length; c++) {
              if (!q.v(a[c]) && b(a[c])) {
                this.JW(a[c], c);
                break;
              }
            } else a = a.indexOf(b), -1 < a && this.JW(b, a);
          }
          JW(b, a) {
            if (this.qo) {
              var c = -1 < this.uE.indexOf(a);
              !(c = !c) && 2 > this.uE.length || (c ? (this.uE.push(a), this.xI.push(b)) : (this.uE.splice(this.uE.indexOf(a), 1), this.xI.splice(this.xI.indexOf(b), 1)), this.pl && (b.isSelected = c, this.nt(a)));
            } else this.pl && null != this.xl && (this.xl.isSelected = !1, this.nt(this.selectedIndex)), this.xl = b, this.selectedIndex = a, this.pl && null != this.xl && (this.xl.isSelected = !0, this.nt(this.selectedIndex));
          }
          nxa(b, a) {
            var c = new e.Ii.nB();
            c.setData(b);
            c.Ym(a);
            return c;
          }
          sM() {
            return this.Xd() * this.Bc().length;
          }
          set qo(b) {
            this.IF = b;
          }
          get qo() {
            return this.IF;
          }
          SN(b) {
            this.uE = b;
            this.xI.length = 0;
            b = this.Bc();
            for (var a = 0; a < b.length; a++) -1 < this.uE.indexOf(a) ? (this.xI.push(b[a]), this.pl && (b[a].isSelected = !0, this.nt(a))) : this.pl && (b[a].isSelected = !1, this.nt(a));
          }
          AM() {
            return this.xI;
          }
          Ds(b) {
            this.G.Ds(b, this);
          }
          MN(b) {
            var a = this.Xd();
            b *= a;
            a = b + a;
            const c = this.G.element.scrollTop,
              d = this.G.yd();
            c > b ? this.G.Ex(b) : c + d < a && this.G.Ex(a - d);
          }
        }
        h.Ala = 21;
        h.Bla = 31;
        k.rj = h;
        class f extends v.ga {
          constructor() {
            super(v.ga.Zd);
          }
        }
        k.Xqa = f;
      })(e.Ad || (e.Ad = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.Na {
          constructor() {
            super("div", "fm-ui-dropdown");
            this.prompt = "Choose item";
            this.IF = this.iZ = this.Zv = !1;
            this.G.display = "inline-block";
            this.Wl = new k.Wqa();
            this.Wl.N("click", () => this.Vu ? this.close() : this.open());
            this.Wl.N("keydown", b => this.LEa(b));
            this.Wl.N("blur", () => this.close());
            this.PL = new e.Na("div", "fm-ui-dropdown-list");
            this.PL.Za();
            this.hf = new f(this, this.Wl);
            this.hf.xia();
            this.hf.pl = !0;
            this.hf.ji(this.Yu);
            this.hf.N(v.ga.Zd, b => this.fv(b));
            this.PL.X(this.hf);
            this.Wl.Dg("controls", this.hf.s1());
            this.X(this.Wl);
            this.X(this.PL);
          }
          get Vu() {
            return this.Zv;
          }
          Yu(b, a) {
            var c = new e.Ii.qY();
            c.setData(b);
            c.Ym(a);
            return c;
          }
          fv(b) {
            this.wu(null == b.data.xl);
            this.Ya(v.ga.Zd, this, b.data);
            this.Wl.focus({
              preventScroll: !0
            });
            this.qo || this.close();
          }
          LEa(b) {
            27 == b.keyCode && (this.close(), b.stopImmediatePropagation());
          }
          wu(b) {
            var a = this.hf.Ph();
            const c = b || this.qo || null == a ? this.prompt : a[this.mr()];
            a = b || this.qo || null == a || q.ia(this.hf.jH()) || q.v(a[this.jH()]) ? "" : a[this.jH()];
            this.Wl.gb(c);
            q.ia(a) || (this.Wl.aN.qc(a), this.Wl.aN.ki(a));
            this.G.$a("fm-ui-prompt", b);
          }
          xE(b) {
            this.prompt !== b && (this.prompt = b, this.wu(!0));
          }
          open() {
            !this.Zv && this.oM() && (this.Zv = !0, this.PL.show(), this.Wl.Gf(1));
          }
          close() {
            0 != this.Zv && this.oM() && (this.Zv = !1, this.PL.Za(), this.Wl.Gf(0));
          }
          Bc() {
            return this.hf.Bc();
          }
          cg(b) {
            const a = this.Gu();
            this.hf.cg(b);
            this.iZ && a && this.Ki(a.index);
          }
          mr() {
            return this.hf.mr();
          }
          vg(b) {
            this.hf.vg(b);
          }
          jH() {
            return this.hf.jH();
          }
          ON(b) {
            this.hf.ON(b);
          }
          ji(b) {
            this.hf.ji(b);
          }
          Kr() {
            this.hf.Kr();
          }
          nt(b) {
            this.hf.nt(b);
          }
          DH() {
            return this.hf.DH();
          }
          Sk(b) {
            this.hf.Sk(b);
            this.wu(null == this.hf.Ph());
          }
          SN(b) {
            this.hf.SN(b);
            this.wu(!0);
          }
          Ph() {
            return this.hf.Ph();
          }
          ft(b) {
            this.hf.ft(b);
            this.wu(null == this.hf.Ph());
          }
          AM() {
            return this.hf.AM();
          }
          show() {
            super.show();
          }
          Xd() {
            return this.hf.Xd();
          }
          zH() {
            return this.hf.zH();
          }
          Jr() {}
          sM() {
            return 0;
          }
          set qo(b) {
            this.IF = b;
            this.hf.qo = b;
            this.IF ? this.hf.G.$("fm-ui-dropdown-multiple-selection-list") : this.hf.G.Gd("fm-ui-dropdown-multiple-selection-list");
          }
          get qo() {
            return this.IF;
          }
          set pl(b) {
            this.hf.pl = b;
          }
          get Bfa() {
            return this.iZ;
          }
          set Bfa(b) {
            this.iZ = b;
          }
          Gu() {
            return this.hf.Gu();
          }
          Ki(b) {
            this.hf.Ki(b);
          }
          qc(b) {
            return this.Wl.qc(b);
          }
        }
        k.Yr = h;
        class f extends k.rj {
          constructor(b, a) {
            super();
            this.parent = b;
            this.Wl = a;
            this.wR = this.Wl.G;
            this.d5();
            this.Rk("listbox");
          }
          d5() {
            this.Wl && (this.N("mousedown", b => this.jV(b)), this.Wl.N("keydown", b => this.VD(b)));
          }
          VD(b) {
            if (this.parent.Vu) super.VD(b);else if (13 == b.keyCode || 32 == b.keyCode) this.parent.open(), b.preventDefault();
          }
        }
      })(e.Ad || (e.Ad = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.Na {
          constructor() {
            super();
            this.vi = 0;
            this.$("fm-ui-vlist");
            this.ui = new f();
            this.ui.ZJa();
            this.ui.N(v.ga.Zd, b => this.fv(b));
            this.X(this.ui);
            this.St = new e.Na("div", "fm-ui-vlist-placeholder");
            this.X(this.St);
            this.N("scroll", () => this.g4());
            this.N("mousedown", b => this.kV(b));
            this.N("keydown", b => this.VD(b));
          }
          kV(b) {
            (b = this.ui.TC(b.target)) && this.Ki(this.Sw() + b.index);
          }
          VD(b) {
            if (32 == b.keyCode || 13 == b.keyCode) this.lV(this.vi, b), b.preventDefault();
            40 == b.keyCode && (this.Ki(this.vi + 1), this.MN(this.vi), b.preventDefault());
            38 == b.keyCode && (this.Ki(this.vi - 1), this.MN(this.vi), b.preventDefault());
          }
          MN(b) {
            var a = this.Xd();
            b *= a;
            a = b + a;
            const c = this.G.element.scrollTop,
              d = this.G.yd();
            c > b ? this.G.Ex(b) : c + d < a && this.G.Ex(a - d);
          }
          Ki(b) {
            this.vi = Math.max(0, Math.min(this.rh().wH() - 1, b));
            this.vi >= this.Sw() && this.vi < this.Pda() && this.ui.Ki(this.vi - this.Sw());
          }
          Gu() {
            return this.ui.Gu();
          }
          lV(b, a) {
            if (!(0 > b)) {
              var c = this.Ph(),
                d = this.DH();
              this.Sk(b);
              var g = new k.Xqa();
              g.data = {
                xl: this.Ph(),
                selectedIndex: this.DH(),
                pq: a,
                JIa: b,
                AIa: c,
                zIa: d
              };
              this.Ea(g);
            }
          }
          fv(b) {
            this.Ea(b);
          }
          g4() {
            this.ne("data");
          }
          nb() {
            this.St.Er(Math.min(this.sM(), h.zP));
            if (this.Ls("data")) {
              this.ui.cg(this.Bc());
              const b = this.Sw() * this.Xd() * this.BH() - this.fea();
              this.ui.G.top = Math.min(b, this.St.yd() - this.ui.G.height);
              this.Ki(this.vi);
            }
            this.validate();
          }
          BH() {
            return this.sM() > h.zP ? h.zP / this.sM() : 1;
          }
          Sw() {
            return 1 != this.BH() ? Math.floor((this.G.element.scrollTop + this.fea()) / this.BH() / this.Xd()) : Math.max(0, Math.floor(this.G.element.scrollTop / this.Xd()) - 1);
          }
          Pda() {
            return this.Sw() + this.zH();
          }
          fea() {
            return 1 != this.BH() ? (this.yd() / this.BH() - this.yd()) * (this.G.element.scrollTop / h.zP) * this.BH() : 0;
          }
          get qo() {
            return this.ui.qo;
          }
          set qo(b) {
            this.ui.qo = b;
          }
          mr() {
            return this.ui.mr();
          }
          vg(b) {
            this.ui.vg(b);
          }
          ji(b) {
            this.ui.ji(b);
          }
          nt(b) {
            this.ui.nt(b);
          }
          Jr(b) {
            this.ui.Jr(b);
          }
          Xd() {
            return this.ui.Xd();
          }
          zH() {
            return 0 < this.Xd() ? Math.ceil(this.yd() / this.Xd()) + 3 : 0;
          }
          DH() {
            return this.ui.DH();
          }
          Sk(b) {
            this.ui.Sk(b);
          }
          SN(b) {
            this.ui.SN(b);
          }
          Ph() {
            return this.ui.Ph();
          }
          ft(b) {
            this.ui.ft(b);
          }
          AM() {
            return this.ui.AM();
          }
          sM() {
            return this.Xd() * this.rh().wH();
          }
          rh() {
            return this.AKa;
          }
          f5(b) {
            this.AKa = b;
          }
          mKa() {
            this.G.Ex(0);
          }
          cg(b) {
            this.rh() && (this.rh().fW(b), this.mKa(), this.ne("data"));
          }
          Bc() {
            return this.rh() ? this.rh().v1(this.Sw(), this.Pda()) : [];
          }
        }
        h.zP = 1E6;
        k.$qa = h;
        class f extends k.rj {
          constructor() {
            super();
            this.vi = -1;
          }
          kV() {}
          VD() {}
          cg(b) {
            let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            this.I = b;
            this.vi = -1;
            a && this.ne("data");
          }
          Ki(b) {
            this.vi = Math.max(0, Math.min(this.vh.length - 1, b));
            for (const a of this.vh) a.Gd("fm-ui-active");
            (b = this.vh[this.vi]) && b.$("fm-ui-active");
          }
        }
      })(e.Ad || (e.Ad = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.uY {
          constructor() {
            super();
            this.$("fm-ui-dropdown-btn");
            this.aN = new e.Vc();
            this.X(this.aN);
            this.G.Td();
            this.Rk("combobox");
            this.Dg("haspopup", "listbox");
            this.Xaa(!1);
          }
          gb(f) {
            this.aN.gb(f, !0);
            this.aN.ki(f);
          }
        }
        k.Wqa = h;
      })(e.Ad || (e.Ad = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.Na {
          constructor() {
            super("li");
            this.nf = "label";
            this.Rk("option");
          }
          getData() {
            return this.data;
          }
          setData(f) {
            null != f && (this.data = f, this.ne("data"));
          }
          Ym(f) {
            this.G.attr("data-index", f);
          }
          mr() {
            return this.nf;
          }
          vg(f) {
            this.nf != f && (this.nf = f, this.ne("data"));
          }
          jH() {
            return this.Ep;
          }
          ON(f) {
            this.Ep != f && (this.Ep = f, this.ne("data"));
          }
          gW(f) {
            this.gx != f && (this.gx = f, this.ne("data"));
          }
          J() {
            return this.gx ? this.gx(this.data) : this.data[this.nf];
          }
          nb() {
            this.Ls("data") && (this.G.text(this.data[this.nf]), q.ia(this.Ep) || q.v(this.data[this.Ep]) || this.qc(this.data[this.Ep]));
            this.validate();
          }
        }
        k.nB = h;
      })(e.Ii || (e.Ii = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends k.nB {
          nb() {
            var f = this.getData();
            null == this.label && (this.label = new e.Vc(), this.label.$("fm-text-display"), this.G.append(this.label.G));
            this.label.gb(f[this.mr()], !0);
            this.Yaa(!0 === f.isSelected);
            this.G.$a("fm-selected", !0 === f.isSelected);
            this.G.$a("fm-not-selected", !0 !== f.isSelected);
            q.ia(this.Ep) || q.v(this.data[this.Ep]) || this.label.qc(this.data[this.Ep]);
          }
        }
        k.qY = h;
      })(e.Ii || (e.Ii = {}));
    })(x || (x = {}));
    var da = x || (x = {}),
      ea = da.fj || (da.fj = {}),
      ia = ea.ri || (ea.ri = {});
    ia.Nj = "top";
    ia.ni = "bottom";
    ia.lF = "left";
    ia.DF = "right";
    (function (e) {
      (function (k) {
        class h {
          constructor(f, b) {
            this.zK = a => this.tx(a);
            this.Qt = a => this.vr(a);
            this.OB = a => this.ux(a);
            this.target = f;
            this.options = b;
            this.Kwa();
          }
          Kwa() {
            for (var f = 0; f < this.options.pW.length; f++) this.qu(this.options.pW[f]);
          }
          qu(f) {
            var b = new e.Ga("div", "fm-resizable-handle");
            b.$("fm-" + f);
            b.N("mousedown", this.zK);
            this.target.X(b);
            return b;
          }
          tx(f) {
            f = e.Ga.Xb(f.target);
            f.Sc("fm-left") ? this.vy = k.ri.lF : f.Sc("fm-right") ? this.vy = k.ri.DF : f.Sc("fm-top") ? this.vy = k.ri.Nj : f.Sc("fm-bottom") && (this.vy = k.ri.ni);
            this.dO();
          }
          vr(f) {
            this.Hga(f.clientX, f.clientY);
            this.eO();
          }
          ux(f) {
            this.Hga(f.clientX, f.clientY);
          }
          Hga(f, b) {
            this.lK && (f = Math.min(Math.max(this.lK.left, f), this.lK.right), b = Math.max(this.lK.top, b), !0 !== this.options.f_ && (b = Math.min(this.lK.bottom, b)));
            var a = {
                left: this.QB.left,
                top: this.QB.top
              },
              c = {
                width: this.rZ.width,
                height: this.rZ.height
              };
            this.vy == k.ri.lF && (a.left = f, c.width += this.QB.left - a.left);
            this.vy == k.ri.DF && (c.width = f - this.QB.left);
            this.vy == k.ri.Nj && (a.top = b, c.height += this.QB.top - a.top);
            this.vy == k.ri.ni && (c.height = b - this.QB.top);
            this.options.resize && this.options.resize({
              FE: this.vy,
              ePa: this.QB,
              o4: this.rZ,
              position: a,
              size: c
            });
          }
          dO() {
            document.addEventListener("mousemove", this.OB);
            document.addEventListener("mouseup", this.Qt);
            this.rZ = {
              width: this.target.Zf(!0),
              height: this.target.yd(!0)
            };
            this.QB = {
              left: this.target.qg().left,
              top: this.target.qg().top
            };
            this.lK = this.options.hS ? this.options.hS.getBoundingClientRect() : null;
          }
          eO() {
            document.removeEventListener("mousemove", this.OB);
            document.removeEventListener("mouseup", this.Qt);
            this.options.complete && this.options.complete();
          }
          dispose() {
            document.removeEventListener("mousemove", this.OB);
            document.removeEventListener("mouseup", this.Qt);
          }
        }
        k.$pa = h;
      })(e.fj || (e.fj = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.Ii.qY {
          nb() {
            super.nb();
            const f = this.data.submenu && 0 < this.data.submenu.length;
            this.G.$a("fm-has-submenu", f);
            this.mua(f);
          }
        }
        k.G9 = h;
      })(e.fr || (e.fr = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.be.F9 {
          constructor(b) {
            super();
            this.yW = a => this.oHa(a);
            this.parent = b;
            this.$("fm-ui-context-menu");
            this.list = new e.Ad.rj();
            this.list.ji((a, c) => this.Yu(a, c));
            this.list.vg("caption");
            this.list.Je();
            this.list.N(v.ga.Zd, a => this.fv(a));
            this.X(this.list);
            this.nA = new f(this);
            this.nA.list.N(v.ga.Zd, a => this.fv(a));
            this.nA.Za();
            this.X(this.nA);
            this.G.Ul();
            this.G.N("mouseleave", () => {
              this.oba = setTimeout(() => this.close(), 500);
            });
            this.G.N("mouseover", () => {
              clearTimeout(this.oba);
            });
            this.G.N("keydown", a => {
              27 == a.keyCode && (this.close(), a.stopImmediatePropagation());
            });
          }
          Xo(b, a, c) {
            let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            0 != a.length && (this.XK = g, this.setData(a), this.show(), this.aw = document.activeElement, this.list.focus({
              preventScroll: !0
            }), b = b.qg(), c.top -= b.top, c.top += d && !isNaN(d.top) ? d.top : -5, c.left -= b.left, c.left += d && !isNaN(d.left) ? d.left : -5, this.G.offset(c), d = this.G.getBoundingClientRect(), b = !1, d.right > window.innerWidth && (c.left -= d.width - 10, b = !0), d.bottom > window.innerHeight && (c.top -= d.height - 10, b = !0), b && (c.top = Math.max(-this.G.parent.top, c.top), c.left = Math.max(-this.G.parent.left, c.left), this.G.offset(c)), u.Jd().Rm ? q.K.Nb.Gb.N("touchstart", this.yW) : q.K.Nb.Gb.N("mousedown", this.yW), this.Eea = !0, q.Be(() => {
              this.Eea = !1;
            }, 100));
          }
          oHa(b) {
            this.G.gS(b) || this.close();
          }
          close() {
            let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            clearTimeout(this.oba);
            if (this.G.visible) {
              this.Za();
              this.nA.Za();
              q.K.Nb.Gb.pb("mousedown", this.yW);
              q.K.Nb.Gb.pb("touchstart", this.yW);
              var a = b && !0 === b.preventFocusRestore ? !1 : !0;
              this.XK && (a = this.XK(b), this.XK = null);
              this.aw && !1 !== a && this.aw.focus({
                preventScroll: !0
              });
            }
          }
          setData(b) {
            this.list.cg(b.slice());
          }
          fv(b) {
            const a = b.data.xl;
            a.submenu && 0 < a.submenu.length ? (this.nA.Xo(b.data.PJa, a), this.nA.list.focus()) : (null != a.handler && a.handler(a.data), b.data.pq && b.data.pq.stopImmediatePropagation(), this.close(a));
          }
          Yu(b, a) {
            var c = new k.G9();
            c.setData(b);
            c.Ym(a);
            q.ia(b["class"]) || c.$(b["class"]);
            c.N("mouseover", () => this.FGa(c, b));
            return c;
          }
          FGa(b, a) {
            this.Eea || (a.submenu && 0 < a.submenu.length ? this.nA.Xo(b.G, a) : this.nA.Za());
          }
          focus() {
            let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            this.list.focus(b);
          }
        }
        k.GF = h;
        class f extends e.be.F9 {
          constructor(b) {
            super();
            this.parent = b;
            this.$("fm-ui-context-submenu");
            this.N("keydown", a => this.mq(a));
            this.list = new e.Ad.rj();
            this.list.ji((a, c) => this.QKa(a, c));
            this.list.vg("caption");
            this.list.Je();
            this.X(this.list);
          }
          mq(b) {
            27 == b.keyCode && (this.parent && this.parent.focus(), this.Za(), b.stopImmediatePropagation());
          }
          QKa(b, a) {
            var c = new k.G9();
            c.setData(b);
            c.Ym(a);
            q.ia(b["class"]) || c.$(b["class"]);
            return c;
          }
          Xo(b, a) {
            if (a != this.Oga) {
              this.Oga = a;
              this.list.cg(a.submenu.slice());
              a = b.qg(this.parent.G.element);
              this.G.top = a.top - 1;
              this.G.left = b.Zf(!0) - 5;
              this.show();
              var c = this.G.getBoundingClientRect();
              c.right > window.innerWidth && (this.G.left = -c.width, 0 > this.G.left && (this.G.left = -this.G.left));
              c.bottom > window.innerHeight && (this.G.top = a.top - c.height + b.yd(!0) + 1, 0 > this.G.top && (this.G.top = -this.G.top));
            }
          }
          Za() {
            super.Za();
            this.Oga = null;
          }
        }
      })(e.fr || (e.fr = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor(f) {
            this.target = f;
            u.Jd().Rm ? new e.qG.Vna(this.target).FDa((b, a) => this.S3(b, a)) : q.Dk.addEventListener("contextmenu", b => this.zsa(b));
          }
          S3() {}
          f4() {}
          zsa(f) {
            this.target.gS(f) && this.f4(f);
          }
        }
        k.bqa = h;
      })(e.fr || (e.fr = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.Na {
          constructor() {
            super("div", "fm-ui-datepicker-input");
            this.ac = "dd/MM/yyyy";
            this.tsa = 1900;
            this.rsa = 2100;
            this.Kga = b => this.KGa(b);
            this.Zy = new e.Oj();
            this.Zy.G.N("click", () => this.open());
            this.Zy.N(e.Oj.Wx, b => this.$Fa(b));
            this.Zy.N(e.Oj.OA, () => this.aGa());
            this.X(this.Zy);
            var f = new e.Ga("i", "fm-ui-datepicker-icon");
            f.N("click", () => this.ZFa());
            this.G.X(f);
            this.Eca = new e.Ga("div", "fm-ui-datepicker-dropdown");
            this.G.X(this.Eca);
            this.Mp = new k.Vqa();
            this.Mp.N(v.ga.Zd, () => this.vFa());
            this.Eca.X(this.Mp.G);
            this.ne();
          }
          nb() {
            this.Ls("all", "date") && (this.Mp.tE ? this.Zy.Jj(this.Mp.tE.format(this.ac)) : this.Zy.Jj(""));
            this.Ls("timezone") && this.Zy.xE(this.IAa());
            super.nb();
          }
          open() {
            this.G.$a("fm-opened", !0);
            this.Mp.reset();
            document.body.addEventListener("mousedown", this.Kga);
          }
          close() {
            this.G.$a("fm-opened", !1);
            document.body.removeEventListener("mousedown", this.Kga);
            this.ne("date");
          }
          get rc() {
            return this.Mp.tE;
          }
          set rc(f) {
            this.Mp.tE = f;
            this.ne("date");
          }
          oKa() {
            this.rc = new q.gh().uh(this.mi);
          }
          PHa(f) {
            var b = "MM/dd/yyyy" == this.ac,
              a = f.split("/");
            f = parseInt(a[2]);
            isNaN(f) || (f = Math.min(this.rsa, Math.max(this.tsa, f)));
            var c = parseInt(a[b ? 0 : 1]) - 1;
            isNaN(c) || (c = Math.min(11, Math.max(0, c)));
            b = parseInt(a[b ? 1 : 0]);
            isNaN(b) || (b = Math.min(q.gh.f0(c, f), Math.max(1, b)));
            b = new q.gh().uh(this.mi).setFullYear(f, c, b);
            return b.ah() ? b : null;
          }
          ZFa() {
            this.G.Sc("fm-opened") ? this.close() : this.open();
          }
          $Fa(f) {
            f = this.PHa(f.data);
            q.v(f) || (this.Mp.tE = f, this.Ya(v.ga.Zd, this, this.rc));
          }
          aGa() {
            this.ne("date");
            this.close();
          }
          KGa(f) {
            this.G.gS(f) || this.close();
          }
          vFa() {
            this.Ya(v.ga.Zd, this, this.rc);
            this.ne("date");
            this.close();
          }
          get Qx() {
            return this.Mp.Qx;
          }
          set Qx(f) {
            this.Mp.Qx = f;
          }
          get mi() {
            return this.Mp.mi;
          }
          set mi(f) {
            this.Mp.mi = f;
            this.ne("timezone");
          }
          set JR(f) {
            this.Mp.JR = f;
          }
          get e0() {
            return this.ac;
          }
          set e0(f) {
            "dd/MM/yyyy" != f && "MM/dd/yyyy" != f || this.ac == f || (this.ac = f, this.Kr());
          }
          IAa() {
            var f = new q.gh();
            f.uh(this.mi);
            return f.format(this.ac);
          }
          qc(f) {
            return this.Zy.qc(f);
          }
        }
        k.H9 = h;
      })(e.GL || (e.GL = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h {}
        h.Qr = 0;
        h.MJ = 1;
        h.hK = 2;
        class f extends e.Na {
          constructor() {
            super();
            this.HLa = u.Eh.rAa();
            this.gga = u.Eh.VAa();
            this.Zq = this.nn = null;
            this.NK = 0;
            this.K = h.Qr;
            this.MZ = 1;
            this.KZ = null;
            this.$("fm-ui-datepicker");
            this.$("fm-noselect");
            this.nn = new q.gh().uh(this.mi).II();
            var b = new e.Ga("div", "fm-ui-dp-header");
            this.G.X(b);
            this.eba = new e.Qg("fm-prev-btn");
            this.eba.N(e.Nd.tf, () => this.pga(-1));
            b.X(this.eba.G);
            this.mN = new e.Vc();
            this.mN.$("fm-ui-dp-month");
            this.mN.N("click", () => this.DGa());
            b.X(this.mN.G);
            this.SI = new e.Vc();
            this.SI.$("fm-ui-dp-year");
            this.SI.N("click", () => this.CHa());
            b.X(this.SI.G);
            this.dba = new e.Qg("fm-next-btn");
            this.dba.N(e.Nd.tf, () => this.pga(1));
            b.X(this.dba.G);
            this.c6 = new e.Ga("div", "fm-ui-dp-week");
            this.G.X(this.c6);
            this.$y = new e.Ga("div", "fm-ui-dp-dates");
            this.$y.N("click", a => this.sFa(a));
            this.G.X(this.$y);
            b = new e.Ga("div", "fm-ui-dp-footer");
            this.G.X(b);
            this.Oe = new e.Nd("fm-ui-link-btn");
            this.Oe.$("fm-cancel-btn");
            this.Oe.$("fm-muted");
            this.Oe.Gd("fm-ui-btn");
            this.Oe.gb("Cancel");
            this.Oe.N(e.Nd.tf, () => this.Ts());
            b.X(this.Oe.G);
            this.ne();
          }
          nb() {
            this.Ls("all") && this.Wxa();
            this.Ls("date", "view") && this.Qxa();
            this.Ls("date", "view") && this.K == h.Qr && this.Fxa();
            this.Ls("view") && this.K == h.MJ && this.Rxa();
            this.Ls("view") && this.K == h.hK && this.Xxa();
            super.nb();
          }
          get tE() {
            return this.Zq;
          }
          set tE(b) {
            q.v(b) ? null != this.Zq && (this.Zq = null, this.ne("date")) : (b.uh(this.mi), b.setHours(0, 0, 0, 0), this.o2(this.Zq, b) || (this.Zq = b, this.nn = b.clone().II(), this.ne("date")));
          }
          get view() {
            return this.K;
          }
          set view(b) {
            this.K != b && (this.K = b, this.G.$a("fm-ui-dp-view-dates", this.view == h.Qr), this.G.$a("fm-ui-dp-view-months", this.view == h.MJ), this.G.$a("fm-ui-dp-view-years", this.view == h.hK), this.ne("view"));
          }
          reset() {
            this.nn = this.Zq ? this.Zq.clone().II() : new q.gh().uh(this.mi).II();
            this.NK = 0;
            this.view = h.Qr;
            this.ne("view");
          }
          Qxa() {
            if (this.view == h.Qr || this.view == h.MJ) this.mN.gb(this.gga[this.nn.getMonth()]), this.SI.gb(this.nn.getFullYear().toString());
            if (this.view == h.hK) {
              var b = this.nea();
              this.SI.gb(b + " \u2013 " + (b + 19));
            }
            this.SI.G.$a("fm-disabled", this.view != h.Qr);
            this.mN.G.$a("fm-disabled", this.view != h.Qr);
          }
          nea() {
            for (var b = this.nn.getFullYear() - 10; 0 != b % 10;) b++;
            return b += 20 * this.NK;
          }
          Wxa() {
            this.c6.empty();
            for (var b = 0; 7 > b; b++) {
              var a = new e.Vc(this.HLa[(b + this.Qx) % 7].substr(0, 2));
              a.$("fm-ui-dp-day-title");
              a.$("fm-ui-dp-col-7");
              this.c6.X(a.G);
            }
          }
          Xxa() {
            var b = this.nea();
            this.$y.empty();
            for (var a = 0; 20 > a; a++) {
              var c = new e.Vc(b.toString());
              c.$("fm-ui-dp-date-label");
              c.$("fm-ui-dp-col-5");
              this.Zq ? this.Zq.getFullYear() == b && c.$("fm-selected") : this.nn.getFullYear() == b && c.$("fm-highlighted");
              c.G.attr("data-year", b);
              this.$y.X(c.G);
              b++;
            }
          }
          Rxa() {
            this.$y.empty();
            this.gga.forEach((b, a) => {
              b = new e.Vc(b);
              b.$("fm-ui-dp-date-label");
              b.$("fm-ui-dp-col-3");
              this.Zq ? this.Zq.getMonth() == a && b.$("fm-selected") : this.nn.getMonth() == a && b.$("fm-highlighted");
              b.G.attr("data-month", a);
              this.$y.X(b.G);
            });
          }
          Fxa() {
            var b = this.nn.getDay() - this.Qx;
            0 > b && (b += 7);
            b = this.nn.clone().RZ(-b);
            var a = new q.gh().uh(this.mi);
            this.$y.empty();
            for (var c = 0; 42 > c; c++) {
              var d = new e.Vc(b.getDate().toString());
              d.$("fm-ui-dp-date-label");
              d.$("fm-ui-dp-col-7");
              b.getMonth() != this.nn.getMonth() && d.$("fm-muted");
              this.o2(this.Zq, b) && d.$("fm-selected");
              this.o2(a, b) && d.$("fm-highlighted");
              d.G.attr("data-date", b.getTime() / 1E3);
              this.$y.X(d.G);
              b.RZ(1);
            }
          }
          o2(b, a) {
            return q.v(b) || q.v(a) ? !1 : b.getFullYear() == a.getFullYear() && b.getMonth() == a.getMonth() && b.getDate() == a.getDate() ? !0 : !1;
          }
          DGa() {
            this.view = h.MJ;
          }
          CHa() {
            this.view != h.MJ && (this.view = h.hK);
          }
          sFa(b) {
            b = e.Ga.Xb(b.target);
            var a = b.attr("data-date");
            q.v(a) || (this.tE = new q.gh(1E3 * parseInt(a)), this.Ya(v.ga.Zd));
            a = b.attr("data-month");
            q.v(a) || (this.nn.setMonth(parseInt(a), 1), this.view = h.Qr);
            b = b.attr("data-year");
            q.v(b) || (this.nn.setFullYear(parseInt(b), this.nn.getMonth(), 1), this.view = h.Qr, this.NK = 0);
          }
          pga(b) {
            this.view == h.Qr ? this.nn.tta(b) : this.view == h.hK && (this.NK += b);
            this.ne("view");
          }
          Ts() {
            this.view = h.Qr;
          }
          get Qx() {
            return this.MZ;
          }
          set Qx(b) {
            this.MZ != b && (this.MZ = b, this.ne("all"));
          }
          get mi() {
            return this.KZ;
          }
          set mi(b) {
            this.KZ != b && (this.KZ = b, this.ne("all"));
          }
          set JR(b) {
            this.Oe.gb(b);
          }
        }
        k.Vqa = f;
      })(e.GL || (e.GL = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor(f) {
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1E3;
            this.wja = a => this.tHa(a);
            this.vja = a => this.qV(a);
            this.target = f;
            this.delay = b;
          }
          FDa(f) {
            this.Jb = f;
            this.target.N("touchstart", this.wja);
            this.target.N("touchend", this.vja);
          }
          stop() {
            this.target.pb("touchstart", this.wja);
            this.target.pb("touchend", this.vja);
          }
          tHa(f) {
            this.timer = q.Be(() => this.Dua(f), this.delay);
          }
          qV() {
            this.timer && q.kr(this.timer);
          }
          Dua(f) {
            e.Ga.Xb(f.target).Sc("fm-dragging") || this.Jb(f, f && 0 < f.changedTouches.length ? f.changedTouches[0] : null);
          }
        }
        k.Vna = h;
      })(e.qG || (e.qG = {}));
    })(x || (x = {}));
    (function (e) {
      (function (k) {
        class h extends e.Ga {
          constructor() {
            super();
            this.Je();
            this.Dg("hidden", "true");
            this.element.addEventListener("focus", f => this.z3(f));
          }
          z3(f) {
            f.relatedTarget && f.relatedTarget.focus();
          }
        }
        k.Z7 = h;
      })(e.qG || (e.qG = {}));
    })(x || (x = {}));
    (function (e) {
      class k {
        constructor(m) {
          let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          let p = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : k.Mna;
          this.Xra = !0;
          this.ty = 0;
          this.uB = n;
          this.buffer = m;
          this.position = 0;
          this.hya = p;
        }
        get byteOffset() {
          return this.uB;
        }
        set byteOffset(m) {
          this.uB = m;
          this.JY = new DataView(this.Pq, this.uB);
          this.ty = this.Pq.byteLength;
        }
        get byteLength() {
          return this.ty - this.uB;
        }
        get buffer() {
          this.Ksa();
          return this.Pq;
        }
        set buffer(m) {
          this.Pq = m;
          this.JY = 0 == this.uB ? new DataView(this.Pq) : new DataView(this.Pq, this.uB);
          this.ty = this.Pq.byteLength;
        }
        seek(m) {
          m = Math.max(0, Math.min(this.byteLength, m));
          this.position = isNaN(m) || !isFinite(m) ? 0 : m;
        }
        KLa(m) {
          this.MLa(h.encode(m));
        }
        LLa(m) {
          this.wZ(1);
          this.JY.setUint8(this.position, m);
          this.position += 1;
        }
        MLa(m) {
          this.wZ(1 * m.length);
          if (m instanceof Uint8Array && 0 == this.byteOffset + this.position % m.BYTES_PER_ELEMENT) this.mEa(this.Pq, this.byteOffset + this.position, m.buffer, m.byteLength), this.Wfa(m.length);else for (var n = 0; n < m.length; n++) this.LLa(m[n]);
        }
        IV(m) {
          return f.decode(this.Wfa(m));
        }
        uha() {
          var m = this.JY.getUint32(this.position, this.hya);
          this.position += 4;
          return m;
        }
        Wfa(m) {
          this.wZ(1 * m);
          var n = new Uint8Array(this.Pq, this.byteOffset + this.position, m);
          this.position += 1 * m;
          return n;
        }
        wZ(m) {
          if (this.Xra) {
            m = this.uB + this.position + m;
            var n = this.Pq.byteLength;
            if (m <= n) m > this.ty && (this.ty = m);else {
              for (1 > n && (n = 1); m > n;) n *= 2;
              n = new ArrayBuffer(n);
              var p = new Uint8Array(this.Pq);
              new Uint8Array(n, 0, p.length).set(p);
              this.buffer = n;
              this.ty = m;
            }
          }
        }
        Ksa() {
          if (this.ty != this.Pq.byteLength) {
            var m = new ArrayBuffer(this.ty),
              n = new Uint8Array(m),
              p = new Uint8Array(this.Pq, 0, n.length);
            n.set(p);
            this.buffer = m;
          }
        }
        mEa(m, n, p, t) {
          m = new Uint8Array(m, n, t);
          p = new Uint8Array(p, 0, t);
          m.set(p);
        }
      }
      k.ZI = !1;
      k.Mna = !0;
      e.Rr = k;
      class h {
        static encode(m) {
          m = m ? String(m) : "";
          var n = [],
            p = new d(n);
          m = new g(m);
          null == h.C0 && (h.C0 = new a());
          for (; m.get() !== h.gn;) h.C0.encode(p, m);
          do var t = h.C0.encode(p, m); while (t !== h.Sr);
          return new Uint8Array(n);
        }
      }
      h.Sr = -1;
      h.gn = -1;
      e.TextEncoder = h;
      class f {
        static decode(m) {
          m || (m = new Uint8Array(0));
          m = new Uint8Array(m.buffer, m.byteOffset, m.byteLength);
          m = new c(m);
          var n = new l();
          null == f.g0 && (f.g0 = new b());
          for (; m.get() !== f.Sr;) {
            var p = f.g0.decode(m);
            null !== p && p !== f.gn && n.$G(p);
          }
          do p = f.g0.decode(m), null !== p && p !== f.gn && n.$G(p); while (p !== f.gn);
          return n.cw;
        }
      }
      f.Sr = -1;
      f.gn = -1;
      e.TextDecoder = f;
      class b {
        constructor() {
          this.gn = this.Sr = -1;
          this.QI = this.OI = this.Px = this.ov = 0;
        }
        decode(m) {
          var n = m.get();
          if (n === this.Sr) return this.gn;
          m.offset(1);
          if (0 === this.Px) {
            if (this.inRange(n, 0, 127)) return n;
            if (this.inRange(n, 194, 223)) this.Px = 1, this.QI = 128, this.ov = n - 192;else if (this.inRange(n, 224, 239)) this.Px = 2, this.QI = 2048, this.ov = n - 224;else if (this.inRange(n, 240, 244)) this.Px = 3, this.QI = 65536, this.ov = n - 240;else return this.gn;
            this.ov *= Math.pow(64, this.Px);
            return null;
          }
          if (!this.inRange(n, 128, 191)) return this.QI = this.OI = this.Px = this.ov = 0, m.offset(-1), this.gn;
          this.OI += 1;
          this.ov += (n - 128) * Math.pow(64, this.Px - this.OI);
          if (this.OI !== this.Px) return null;
          m = this.ov;
          n = this.QI;
          this.QI = this.OI = this.Px = this.ov = 0;
          return this.inRange(m, n, 1114111) && !this.inRange(m, 55296, 57343) ? m : this.gn;
        }
        inRange(m, n, p) {
          return n <= m && m <= p;
        }
      }
      e.VOa = b;
      class a {
        constructor() {
          this.gn = this.Sr = -1;
        }
        inRange(m, n, p) {
          return n <= m && m <= p;
        }
        tca(m, n) {
          return Math.floor(m / n);
        }
        encode(m, n) {
          var p = n.get();
          if (p === this.gn) return this.Sr;
          n.offset(1);
          if (this.inRange(p, 55296, 57343)) return this.gn;
          if (this.inRange(p, 0, 127)) return m.$G(p);
          if (this.inRange(p, 128, 2047)) {
            var t = 1;
            var r = 192;
          } else this.inRange(p, 2048, 65535) ? (t = 2, r = 224) : this.inRange(p, 65536, 1114111) && (t = 3, r = 240);
          for (n = m.$G(this.tca(p, Math.pow(64, t)) + r); 0 < t;) n = m.$G(128 + this.tca(p, Math.pow(64, t - 1)) % 64), --t;
          return n;
        }
      }
      e.WOa = a;
      class c {
        constructor(m) {
          this.Sr = -1;
          this.hm = 0;
          this.gC = m;
        }
        get() {
          return this.hm >= this.gC.length ? this.Sr : Number(this.gC[this.hm]);
        }
        offset(m) {
          this.hm += m;
          if (0 > this.hm) throw Error("Seeking past start of the buffer");
          if (this.hm > this.gC.length) throw Error("Seeking past EOF");
        }
        match(m) {
          if (m.length > this.hm + this.gC.length) return !1;
          var n;
          for (n = 0; n < m.length; n += 1) if (Number(this.gC[this.hm + n]) !== m[n]) return !1;
          return !0;
        }
      }
      e.XLa = c;
      class d {
        constructor(m) {
          this.Sr = -1;
          this.hm = 0;
          this.gC = m;
        }
        $G(m) {
          var n = this.Sr,
            p;
          for (p = 0; p < arguments.length; ++p) n = Number(arguments[p]), this.gC[this.hm++] = n;
          return n;
        }
      }
      e.YLa = d;
      class g {
        constructor(m) {
          this.hm = 0;
          this.gn = -1;
          this.cw = m;
          this.S_ = this.hAa(this.cw);
        }
        hAa(m) {
          for (var n = [], p = 0, t = m.length; p < m.length;) {
            var r = m.charCodeAt(p);
            if (this.inRange(r, 55296, 57343)) {
              if (this.inRange(r, 56320, 57343)) n.push(65533);else if (p === t - 1) n.push(65533);else {
                var w = m.charCodeAt(p + 1);
                this.inRange(w, 56320, 57343) ? (r &= 1023, w &= 1023, p += 1, n.push(65536 + (r << 10) + w)) : n.push(65533);
              }
            } else n.push(r);
            p += 1;
          }
          return n;
        }
        inRange(m, n, p) {
          return n <= m && m <= p;
        }
        offset(m) {
          this.hm += m;
          if (0 > this.hm) throw Error("Seeking past start of the buffer");
          if (this.hm > this.S_.length) throw Error("Seeking past EOF");
        }
        get() {
          return this.hm >= this.S_.length ? this.gn : this.S_[this.hm];
        }
      }
      e.yMa = g;
      class l {
        constructor() {
          this.cw = "";
        }
        $G(m) {
          65535 >= m ? this.cw += String.fromCharCode(m) : (m -= 65536, this.cw += String.fromCharCode(55296 + (m >> 10 & 1023)), this.cw += String.fromCharCode(56320 + (m & 1023)));
        }
      }
      e.zMa = l;
    })(q || (q = {}));
    var z;
    (function (e) {
      class k extends v.Fh {
        constructor() {
          super(...arguments);
          this.responseType = "arraybuffer";
          this.connected = !1;
          this.uc = [];
        }
        load(h) {
          this.url = h;
          this.connected = !1;
          this.close();
          this.xhr = new XMLHttpRequest();
          this.xhr.open("GET", h, !0);
          this.xhr.responseType = this.responseType;
          this.xhr.onprogress = f => this.nq(f);
          this.xhr.onerror = f => this.Sb(f);
          this.xhr.onreadystatechange = f => this.gv(f);
          this.dL();
          this.xhr.send();
        }
        eAa() {
          if (void 0 !== this.xhr) {
            var h = this.xhr.getResponseHeader("Content-Type"),
              f = /charset=([^()<>@,;:"/[\]?.=\s]*)/i;
            return f.test(h) ? f.exec(h)[1] : "UTF-8";
          }
        }
        ur() {
          this.response = this.xhr.response;
          this.Ya(v.ga.Qc);
        }
        nq(h) {
          this.Ya(v.ga.te, this, h);
        }
        Sb() {
          q.v(this.xhr) || (this.response = this.xhr.response || this.xhr.responseText || this.xhr.statusText);
          this.Ea(new v.ga(v.ga.xa, this));
        }
        gv() {
          null != this.xhr && 4 === this.xhr.readyState && (200 === this.xhr.status ? this.ur() : this.Ya(v.ga.xa, this, this.xhr.statusText));
          null != this.xhr && 3 > this.xhr.readyState && !this.connected && (this.connected = !0, this.Ya(v.ga.GA));
        }
        dL() {
          if (!q.v(this.uc)) for (var h = 0; h < this.uc.length; h++) try {
            this.xhr.setRequestHeader(this.uc[h].$i, this.uc[h].value);
          } catch (f) {
            console.error("Request headers error:", f), q.Wa(f.message || f, q.model.B.j.xa, q.tb.xa);
          }
        }
        close() {
          null != this.xhr && this.xhr.abort();
        }
        dispose() {
          this.response = null;
          null != this.xhr && (this.xhr.abort(), this.xhr.onload = null, this.xhr.onprogress = null, this.xhr.onerror = null, this.xhr.onreadystatechange = null);
          this.uc = this.xhr = null;
        }
      }
      e.J9 = k;
    })(z || (z = {}));
    (function (e) {
      class k extends v.Fh {
        constructor() {
          super();
          this.dataType = h.kB;
          this.contentType = f.Fqa;
          this.Br = b.FX;
          this.naa = this.connected = !1;
          this.kZ = 0;
          this.JB = null;
          this.nha = 0;
          this.uc = [];
          this.data = {};
          this.Ui = 0;
        }
        load(d) {
          q.ia(d) || (this.url = d);
          this.Ui = 0;
          this.connected = !1;
          this.close();
          this.xhr = new XMLHttpRequest();
          try {
            this.xhr.open(this.Br, this.url, !0);
          } catch (g) {
            this.Sb(g);
            return;
          }
          this.xhr.withCredentials = this.naa;
          this.xhr.onerror = g => this.Sb(g);
          this.xhr.onreadystatechange = g => this.gv(g);
          this.xhr.onprogress = g => this.nq(g);
          this.Br == b.Dv && !1 !== this.contentType && this.xhr.setRequestHeader("Content-type", this.contentType);
          this.dL();
          this.xhr.send(this.data);
        }
        retry() {
          this.load(this.url);
        }
        set withCredentials(d) {
          this.naa = d;
        }
        dL() {
          if (!q.v(this.uc)) for (var d = 0; d < this.uc.length; d++) try {
            this.xhr.setRequestHeader(this.uc[d].$i, this.uc[d].value);
          } catch (g) {
            console.error("Request headers error:", g), q.Wa(g.message || g, q.model.B.j.xa, q.tb.xa);
          }
        }
        Vh(d) {
          if (!q.v(d)) {
            this.uc = [];
            for (let g in d) d.hasOwnProperty(g) && this.uc.push(new e.K9(g, d[g]));
          }
        }
        GI() {
          this.response = this.xhr.response || this.xhr.responseText;
          this.Ui = this.JB ? this.JB.loaded : this.response.length;
          null != this.JB && this.Ya(v.ga.te, this, this.JB);
          this.Ea(new v.ga(v.ga.Qc, this));
        }
        gv(d) {
          null != this.xhr && 4 === this.xhr.readyState && (200 === this.xhr.status ? this.GI() : this.Sb(d));
          null != this.xhr && 3 > this.xhr.readyState && !this.connected && (this.connected = !0, this.Ea(new v.ga(v.ga.GA)));
        }
        nq(d) {
          u.Yf() - this.kZ > this.nha ? (this.response = this.xhr.response || this.xhr.responseText, this.Ui = d.loaded, this.Ya(v.ga.te, this, d), this.kZ = u.Yf(), this.JB = null) : this.JB = d;
        }
        Sb() {
          q.v(this.xhr) || (this.response = this.xhr.response || this.xhr.responseText || this.xhr.statusText);
          this.Ea(new v.ga(v.ga.xa, this));
        }
        close() {
          null != this.xhr && (this.xhr.onprogress = null, this.xhr.onreadystatechange = null, this.xhr.abort());
        }
        dispose() {
          this.data = this.response = null;
          this.uc = [];
          null != this.xhr && (this.xhr.abort(), this.xhr.onprogress = null, this.xhr.onreadystatechange = null);
          this.kZ = this.JB = this.xhr = null;
        }
      }
      e.jk = k;
      class h {}
      h.kB = "text";
      h.ba = "xml";
      h.zv = "html";
      h.JSON = "json";
      e.KA = h;
      class f {}
      f.Fqa = "text/plain";
      f.eQ = "text/xml";
      f.k6 = "application/json";
      f.dka = "application/x-www-form-urlencoded";
      e.JA = f;
      class b {}
      b.Dv = "POST";
      b.FX = "GET";
      e.Ft = b;
      class a {
        constructor(d, g) {
          this.$i = d;
          this.value = g;
        }
      }
      e.K9 = a;
      class c {
        constructor() {
          this.data = {};
        }
        toString() {
          var d = [],
            g;
          for (g in this.data) this.data.hasOwnProperty(g) && d.push(g + "=" + this.data[g]);
          return d.join("&");
        }
      }
      e.dra = c;
    })(z || (z = {}));
    (function (e) {
      class k extends v.Fh {
        constructor() {
          super();
          this.zS = !1;
          this.Oja = () => this.z3();
          this.D4 = !1;
        }
        bba() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          this.input = document.createElement("input");
          this.input.setAttribute("type", "file");
          this.input.style.display = "none";
          document.body.appendChild(this.input);
          this.input.setAttribute("accept", f.join(","));
          this.input.addEventListener("change", () => this.QEa());
          this.zS = !0;
          this.D4 = window.location !== window.parent.location;
          q.aM.addEventListener("focus", this.Oja);
          this.input.click();
        }
        QEa() {
          this.zS = !1;
          q.v(this.input.files) || q.v(this.input.files[0]) || (this.file = this.input.files[0], this.Ya(v.ga.ho));
        }
        z3() {
          this.D4 ? this.D4 = !1 : this.zS && q.Be(() => {
            (q.v(this.input.files) || q.v(this.input.files[0])) && this.Ya(v.ga.aX);
            this.zS = !1;
          }, 500);
        }
        load() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : h.kB;
          null != this.file && (this.jE = new FileReader(), this.jE.onload = () => this.jGa(), this.jE.onprogress = b => this.nq(b), this.jE.onerror = b => this.Sb(b), f == h.ARRAY_BUFFER ? this.jE.readAsArrayBuffer(this.file) : this.jE.readAsText(this.file));
        }
        jGa() {
          this.response = this.jE.result;
          this.Ea(new v.ga(v.ga.Qc, this));
        }
        nq(f) {
          this.Ya(v.ga.te, this, f);
        }
        Sb(f) {
          this.Ea(f);
        }
        dispose() {
          this.jE = this.file = this.response = null;
          q.aM.removeEventListener("focus", this.Oja);
        }
      }
      e.V7 = k;
      class h {}
      h.kB = "TEXT";
      h.ARRAY_BUFFER = "ARRAY_BUFFER";
      e.Ypa = h;
      e.Qha = function (f, b) {
        if (window.navigator.msSaveOrOpenBlob) window.navigator.msSaveOrOpenBlob(f, b);else {
          var a = document.createElement("a"),
            c = window.URL.createObjectURL(f);
          a.href = c;
          a.download = b;
          a.target = "_blank";
          document.body.appendChild(a);
          a.click();
          q.Be(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(c);
          }, 0);
        }
      };
    })(z || (z = {}));
    (function (e) {
      class k {
        get item() {
          return this[0];
        }
        find(b) {
          return void 0 === this.item ? this : this.item.find(b);
        }
        text() {
          return void 0 === this.item ? "" : this.item.text();
        }
        attr(b, a) {
          if (void 0 !== this.item) return a ? this.item.attr(b, a) : this.item.attr(b);
        }
        children() {
          for (var b = new k(), a = 0; void 0 !== this[a];) b[a] = h.Xb(this[a]), a++;
          return b;
        }
        push(b) {
          this[this.length] = b;
          return this;
        }
        get length() {
          for (var b = 0; void 0 !== this[b];) b++;
          return b;
        }
      }
      e.XOa = k;
      class h extends Element {
        text(b) {
          return b || !1 === b ? (this.textContent = b.toString(), this) : b = q.v(this.textContent) ? "" : this.textContent;
        }
        append(b) {
          if (q.v(b) || "string" == typeof b && q.ia(b)) return this;
          (b instanceof CDATASection || "" != b.textContent) && this.appendChild(b);
          return this;
        }
        kb() {
          return "" == this.text();
        }
        find(b) {
          b = this.querySelectorAll(b);
          for (var a = new k(), c = 0; c < b.length; c++) a[c] = h.Xb(b[c]);
          return a;
        }
        attr(b, a) {
          if (a || !1 === a) return this.setAttribute(b, a), this;
          a = this.getAttribute(b);
          null == a && (a = void 0);
          return a;
        }
        Wza() {
          for (var b = new k(), a = this.firstElementChild; a;) a.nodeType === Node.ELEMENT_NODE && b.push(h.Xb(a)), a = a.nextElementSibling;
          return b;
        }
        get length() {
          return this.childNodes.length;
        }
        static Xb(b) {
          b.find = h.prototype.find;
          b.append = h.prototype.append;
          b.text = h.prototype.text;
          b.attr = h.prototype.attr;
          b.isEmpty = h.prototype.kb;
          b.getChildren = h.prototype.Wza;
          return b;
        }
      }
      e.yY = h;
      class f {
        constructor() {
          throw Error("Singleton");
        }
        static create(b) {
          if (null == b.firstChild) {
            b = new DOMParser().parseFromString(b, "text/xml");
            if (f.cDa(b)) return null;
            b = b.firstElementChild ? b.firstElementChild : b.firstChild;
          } else b = b.firstChild;
          return h.Xb(b);
        }
        static cDa(b) {
          return b.getElementsByTagName("parsererror") && b.getElementsByTagName("parsererror")[0] ? 0 < b.getElementsByTagNameNS(b.getElementsByTagName("parsererror")[0].namespaceURI, "parsererror").length : !1;
        }
        static $h(b) {
          return f.Axa.createCDATASection(b);
        }
        static Kc(b) {
          let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          null == f.cia && (f.cia = new XMLSerializer());
          b = f.cia.serializeToString(b);
          1 == a && (b = f.format(b));
          return b.trim();
        }
        static format(b) {
          b = b.replace(/>\s{0,}</g, "><").replace(/</g, "~::~<").replace(/\s*xmlns:/g, "~::~xmlns:").replace(/\s*xmlns=/g, "~::~xmlns=").split("~::~");
          var a = b.length,
            c = !1,
            d = 0,
            g = "",
            l,
            m = ["\n"];
          for (l = 0; 20 > l; l++) m.push(m[l] + "    ");
          for (l = 0; l < a; l++) if (-1 < b[l].search(/<!/)) {
            if (g += m[d] + b[l], c = !0, -1 < b[l].search(/--\x3e/) || -1 < b[l].search(/\]>/) || -1 < b[l].search(/!DOCTYPE/)) c = !1;
          } else -1 < b[l].search(/--\x3e/) || -1 < b[l].search(/\]>/) ? (g += b[l], c = !1) : /^<\w/.exec(b[l - 1]) && /^<\/\w/.exec(b[l]) && /^<[\w:\-\.,]+/.exec(b[l - 1])[0] == /^<\/[\w:\-\.,]+/.exec(b[l])[0].replace("/", "") ? (g += b[l], c || d--) : g = -1 < b[l].search(/<\w/) && -1 == b[l].search(/<\//) && -1 == b[l].search(/\/>/) ? c ? g += b[l] : g += m[d++] + b[l] : -1 < b[l].search(/<\w/) && -1 < b[l].search(/<\//) ? c ? g += b[l] : g += m[d] + b[l] : -1 < b[l].search(/<\//) ? c ? g += b[l] : g += m[--d] + b[l] : -1 < b[l].search(/\/>/) ? c ? g += b[l] : g += m[d] + b[l] : -1 < b[l].search(/<\?/) ? g + (m[d] + b[l]) : -1 < b[l].search(/xmlns:/) || -1 < b[l].search(/xmlns=/) ? g + (m[d] + b[l]) : g + b[l];
          b = "\n" == g[0] ? g.slice(1) : g;
          b = b.replace(/[\r\n\s]*<!\[CDATA\[/g, "<![CDATA[");
          return b = b.replace(/]]\x3e\s*/g, "]]\x3e");
        }
      }
      f.Axa = new DOMParser().parseFromString("<tmp/>", "text/xml");
      e.ba = f;
    })(z || (z = {}));
    (function (e) {
      class k {
        static print(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
          var a = "printer-" + new Date().getTime(),
            c = new x.Ga("iframe").attr("name", a);
          c.U("width", "1px").U("height", "1px").U("position", "absolute").U("left", "-9999px");
          q.K.Nb.Gb.G.append(c);
          a = window.frames[a];
          var d = a.document;
          d.open();
          d.write("<!DOCTYPE html>");
          d.write("<html>");
          d.write("<head>");
          d.write("<title>");
          d.write(b);
          d.write("</title>");
          d.write("<style>");
          d.write(f + "body{-webkit-print-color-adjust:exact;}");
          d.write("</style>");
          d.write("</head>");
          d.write("<body>");
          d.write(h);
          d.write("</body>");
          d.write("</html>");
          d.close();
          a.focus();
          a.print();
          q.Be(() => {
            c.remove();
          }, 2E3);
        }
      }
      e.h9 = k;
    })(z || (z = {}));
    (function (e) {
      class k {
        constructor() {
          this.table = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918E3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117];
        }
        async dwa(f) {
          var b = [],
            a = 0,
            c = 0,
            d = [];
          for (var g in f) f.hasOwnProperty(g) && d.push(g);
          for (const l of d) {
            d = this.E5(f[l]);
            g = await this.rxa(d);
            const m = d.length !== g.length;
            d = {
              nLa: d.length,
              T_: this.T_(g),
              yba: g.length,
              ewa: g,
              gwa: m ? "\b\x00" : "\x00\x00",
              rc: new Date()
            };
            g = this.Iza(l, d, a);
            a += g.Wca.length + d.yba;
            c += g.qca.length;
            b.push(g);
          }
          f = k.zka + "\x00\x00\x00\x00" + this.Im(b.length, 2) + this.Im(b.length, 2) + this.Im(c, 4) + this.Im(a, 4) + this.Im(0, 2);
          a = new h(a + c + f.length);
          for (c = 0; c < b.length; c++) a.append(b[c].Wca), a.append(b[c].fwa.ewa);
          for (c = 0; c < b.length; c++) a.append(b[c].qca);
          a.append(f);
          return a.getData();
        }
        async rxa(f) {
          try {
            if (void 0 !== window.CompressionStream) {
              const b = new Response(f).body.pipeThrough(new window.CompressionStream("deflate-raw")),
                a = await new Response(b).arrayBuffer();
              return new Uint8Array(a);
            }
            return f;
          } catch (b) {
            return f;
          }
        }
        T_(f) {
          var b = -1;
          for (var a = 0, c = f.length; a < c; a++) {
            var d = f[a];
            d = (b ^ d) & 255;
            d = this.table[d];
            b = b >>> 8 ^ d;
          }
          return b ^ -1;
        }
        Im(f, b) {
          for (var a = "", c = 0; c < b; c++) a += String.fromCharCode(f & 255), f >>>= 8;
          return a;
        }
        Iza(f, b, a) {
          var c = b.rc,
            d = c.getHours();
          d = d << 6 | c.getMinutes();
          d = d << 5 | c.getSeconds() / 2;
          var g = c.getFullYear() - 1980;
          g = g << 4 | c.getMonth() + 1;
          g = g << 5 | c.getDate();
          c = "\n\x00\x00\x00" + b.gwa;
          c += this.Im(d, 2);
          c += this.Im(g, 2);
          c += this.Im(b.T_, 4);
          c += this.Im(b.yba, 4);
          c += this.Im(b.nLa, 4);
          c += this.Im(f.length, 2);
          c += this.Im(0, 2);
          return {
            Wca: k.Nna + c + f,
            qca: k.Aka + this.Im(20, 2) + c + this.Im(0, 2) + "\x00\x00\x00\x00" + this.Im(0, 4) + this.Im(a, 4) + f,
            fwa: b
          };
        }
        E5(f) {
          var b = this.wwa(f),
            a = f.length,
            c = new Uint8Array(b),
            d,
            g = 0;
          for (d = 0; g < b; d++) {
            var l = f.charCodeAt(d);
            if (55296 === (l & 64512) && d + 1 < a) {
              var m = f.charCodeAt(d + 1);
              56320 === (m & 64512) && (l = 65536 + (l - 55296 << 10) + (m - 56320), d++);
            }
            128 > l ? c[g++] = l : (2048 > l ? c[g++] = 192 | l >>> 6 : (65536 > l ? c[g++] = 224 | l >>> 12 : (c[g++] = 240 | l >>> 18, c[g++] = 128 | l >>> 12 & 63), c[g++] = 128 | l >>> 6 & 63), c[g++] = 128 | l & 63);
          }
          return c;
        }
        wwa(f) {
          for (var b = 0, a = f.length, c, d, g = 0; g < a; g++) c = f.charCodeAt(g), 55296 === (c & 64512) && g + 1 < a && (d = f.charCodeAt(g + 1), 56320 === (d & 64512) && (c = 65536 + (c - 55296 << 10) + (d - 56320), g++)), b += 128 > c ? 1 : 2048 > c ? 2 : 65536 > c ? 3 : 4;
          return b;
        }
      }
      k.Nna = "PK\u0003\u0004";
      k.Aka = "PK\u0001\u0002";
      k.zka = "PK\u0005\u0006";
      e.ena = k;
      class h {
        constructor(f) {
          this.data = new Uint8Array(f);
          this.index = 0;
        }
        append(f) {
          0 !== f.length && (f = f instanceof Uint8Array ? f : this.E5(f), this.data.set(f, this.index), this.index += f.length);
        }
        getData() {
          return this.data;
        }
        E5(f) {
          for (var b = new Uint8Array(f.length), a = 0; a < f.length; ++a) b[a] = f.charCodeAt(a) & 255;
          return b;
        }
      }
    })(z || (z = {}));
    (function (e) {
      function k() {
        !1 !== e.p2 && (0 !== f.length && f.forEach(c => {
          var d = c.values[0];
          "string" === typeof d && "[!]" === d.substr(0, 3) && (d = JSON.parse(d.substr(3)));
          h(d);
          if (1 < c.values.length) for (var g = 1; g < c.values.length; g++) d = c.values[g], "string" === typeof d && "[!]" === d.substr(0, 3) && (d = JSON.parse(d.substr(3))), h(d);
        }), f = [], a());
      }
      function h(c) {
        return "string" === typeof c && "[Stack trace]" === c.substr(0, 13);
      }
      e.p2 = !1;
      var f = [],
        b,
        a = () => {
          !1 !== e.p2 && (b && e.kr(b), b = e.Be(k, 1E3));
        };
      a();
      e.debug = function () {
        if (!1 !== e.p2) {
          for (var _len4 = arguments.length, c = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            c[_key4] = arguments[_key4];
          }
          for (var d = [], g = 0; g < c.length; g++) if ("object" === typeof c[g]) try {
            d[g] = "[!]" + JSON.stringify(c[g]);
          } catch (l) {
            d[g] = "[Object]";
          } else d[g] = c[g];
          f.push({
            time: u.Yf(),
            values: d
          });
        }
      };
      e.$Oa = k;
      e.iPa = function () {
        var c = Error();
        return c && c.stack ? "[Stack trace] " + c.stack.substr(79) : "";
      };
    })(q || (q = {}));
    (function (e) {
      e.Wa = function (h) {
        let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : k.Dl;
        let a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        let c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        let d = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
        e.K.CO.R().Qo(h, f, b, a, c, d);
      };
      class k {}
      k.Dl = "alert";
      k.cn = "confirmation";
      k.xa = "error";
      k.lP = "info";
      e.tb = k;
    })(q || (q = {}));
    (function (e) {
      e.mLa = function () {
        let k = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        e.K.Npa.R().Qo("Please enter group name:", k);
      };
    })(q || (q = {}));
    (function (e) {
      e.Da = function () {
        let k = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        let h = arguments.length > 1 ? arguments[1] : undefined;
        let f = arguments.length > 2 ? arguments[2] : undefined;
        let b = arguments.length > 3 ? arguments[3] : undefined;
        let a = arguments.length > 4 ? arguments[4] : undefined;
        e.K.Mpa.R().show(k, h, f, b, a);
      };
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h extends v.Fh {
          constructor() {
            super();
            if (null != h.instance) throw Error("Singleton");
            this.ja = e.u.Ma.R();
            this.Fa = new k.Wb.zqa();
            this.RI = e.u.external.Fb.jj.O9.R();
            this.Qaa = e.u.external.pc.h6.R();
          }
          static R() {
            null == this.instance && (this.instance = new h());
            return this.instance;
          }
          yD(f) {
            this.Kb = f;
            h.id = f.id ? f.id : "";
            k.Xa.cKa(f);
            k.B.XA.R().reset();
            e.K.Y.W.le.zw = f.customizeCell;
            e.K.Cd.tv.EC = f.customizeChartElement;
            e.K.Y.MO.FL = f.customizeContextMenu;
            e.u.external.pc.zA.EL = f.customizeAPIRequest;
            e.K.od.np.OS = f.sortFieldsList;
            const b = new e.bna(location.search);
            if (b.has("flexmonsterreport")) {
              const a = this.z$(f);
              a ? this.Qaa.RDa("string" === typeof a ? {
                url: a.toLowerCase(),
                Yo: !1
              } : a, b.get("flexmonsterreport"), c => {
                void 0 !== c && (f.report = c);
                this.Fa.yD(f);
              }) : (e.Wa(e.P.bind(k.B.j.D8, "The URL to the server hasn't been found."), k.B.j.xa, e.tb.xa), console.error("Can't load the shared file. The URL to the server hasn't been found."), this.Fa.yD(f));
            } else this.Fa.yD(f);
          }
          z$(f) {
            return f.shareReportConnection || f.report && (f.report.shareReportConnection || f.report.dataSource && f.report.dataSource.url || f.report.url) || f.url || void 0;
          }
          open() {
            this.Fa.open();
          }
          load(f, b) {
            this.Fa.load(f, b);
          }
          save(f) {
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            let a = arguments.length > 2 ? arguments[2] : undefined;
            let c = arguments.length > 3 ? arguments[3] : undefined;
            let d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
            return this.Fa.save(f, b, a, c, d);
          }
          Cx(f) {
            this.Fa.Cx(f);
          }
          Is() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return this.Fa.Is(f);
          }
          kW(f) {
            f = k.hb.Kv.zb(k.hb.Kv.jm(f));
            k.size.ud.clear();
            k.size.ud.j_(f);
            this.refresh();
            this.eb();
          }
          EH() {
            return k.size.ud.EH().Sa(this.ja.pa.rja());
          }
          clear() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            this.Fa && this.Fa.clear(f);
          }
          iba(f) {
            var b = {};
            e.v(f.dataSourceType) || (b.dataSourceType = f.dataSourceType);
            e.v(f.type) || (b.dataSourceType = f.type);
            e.v(f.proxyUrl) || (b.proxyUrl = f.proxyUrl);
            e.v(f.dataSourceInfo) || (b.dataSourceInfo = f.dataSourceInfo);
            e.v(f.catalog) || (b.catalog = f.catalog);
            e.v(f.cube) || (b.cube = f.cube);
            e.v(f.subquery) || (b.subquery = f.subquery);
            e.v(f.localeIdentifier) || (b.localeIdentifier = f.localeIdentifier);
            e.v(f.effectiveUserName) || (b.effectiveUserName = f.effectiveUserName);
            e.v(f.customData) || (b.customData = f.customData);
            e.v(f.filename) || (b.filename = f.filename);
            e.v(f.requestHeader) || (b.requestHeaders = f.requestHeader);
            e.v(f.requestHeaders) || (b.requestHeaders = f.requestHeaders);
            e.v(f.fieldSeparator) || (b.fieldSeparator = f.fieldSeparator);
            e.v(f.thousandSeparator) || (b.thousandsSeparator = f.thousandSeparator);
            e.v(f.thousandsSeparator) || (b.thousandsSeparator = f.thousandsSeparator);
            e.v(f.recordsetDelimiter) || (b.recordsetDelimiter = f.recordsetDelimiter);
            e.v(f.browseForFile) || (b.browseForFile = f.browseForFile);
            e.v(f.data) || (b.data = f.data);
            e.v(f.binary) || (b.binary = f.binary);
            e.v(f.ignoreQuotedLineBreaks) || (b.ignoreQuotedLineBreaks = f.ignoreQuotedLineBreaks);
            e.v(f.roles) || (b.roles = f.roles);
            e.v(f.hash) || (b.hash = f.hash);
            e.v(f.username) || (b.username = f.username);
            e.v(f.password) || (b.password = f.password);
            e.v(f.host) || (b.host = f.host);
            e.v(f.node) || (b.node = f.node);
            e.v(f.index) || (b.index = f.index);
            e.v(f.mapping) || (b.mapping = f.mapping);
            e.v(f.useStreamLoader) || (b.useStreamLoader = f.useStreamLoader);
            e.v(f.url) || (b.url = f.url);
            e.v(f.withCredentials) || (b.withCredentials = f.withCredentials);
            return b;
          }
          KG(f) {
            this.Fa.KG(this.iba(f));
          }
          Ud(f, b) {
            b.partial ? this.Fa.sLa(f.data, b) : this.Fa.Ud(this.iba(f), b);
          }
          getData(f, b, a) {
            if (k.Ha.wc.Np || k.Ha.wc.qq || k.Ha.wc.Ky) {
              if (null != a && (e.kh.instance.on("update", function () {
                e.kh.instance.getData(f, a);
              }), this.N(k.ac.b8.U7, function () {
                e.kh.instance.getData(f, a);
              })), null != f && null != f.slice) {
                var c = f.slice instanceof k.hb.wp ? f.slice : k.hb.wp.zb(f.slice);
                k.zD.mP.R().LJa(c, b);
              } else c = k.zD.mP.R().getData(), k.zD.mP.R().sca(b, c);
            } else e.Wa(k.Ha.ra.J(k.Ha.ra.r_), k.Ha.ra.J(k.Ha.ra.PD));
          }
          b1() {
            return k.ua.dn.ZAa();
          }
          f1(f) {
            return (f = k.ua.dn.get(f)) ? f.Sa() : null;
          }
          xR(f) {
            k.ua.dn.add(k.ua.W.Z6.zb(f));
          }
          KV(f) {
            k.ua.dn.remove(f);
          }
          JV() {
            k.ua.dn.F4();
          }
          bu(f) {
            this.ja.bu(f);
          }
          $z(f) {
            this.ja.$z(f);
          }
          kE() {
            this.ja.kE();
          }
          JS() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "all";
            this.ja.PC(!0, f, b);
            e.u.Re.Ni.dispose();
            this.refresh();
            this.eb();
          }
          ZR() {
            this.ja.PC(!1, !1);
            e.u.Re.Ni.dispose();
            this.refresh();
            this.Ya("reset_grid");
            this.eb();
          }
          wq(f) {
            null != f.chartActiveMeasure && delete f.chartActiveMeasure;
            null != f.chartActiveTupleIndex && delete f.chartActiveTupleIndex;
            null != f.zoom && delete f.zoom;
            f.flatView && this.Fa.fa.Ic && this.Fa.fa.Ba !== e.u.i.qa.API && delete f.flatView;
            if (!e.v(f.useOlapFormatting) && this.Fa.fa.Ic && k.C.F.Rn != f.useOlapFormatting) {
              var b = this.Is({
                withDefaults: !0
              });
              b.options.SD(f);
              this.Cx({
                report: b
              });
            } else {
              b = k.C.F.tc;
              const a = k.C.F.it,
                c = k.C.F.ke;
              k.C.F.wq(k.C.Hq.zb(f), !1);
              a != k.C.F.it && this.Fa && this.Fa.fa && !this.Fa.fa.Ic && this.I.load();
              !e.v(this.Fa) && this.Fa.fa.Ba == e.u.i.qa.API && (b != k.C.F.tc || k.C.F.tc && c != k.C.F.ke) && (b = this.Is({
                withDefaults: !0
              }), b.options.SD(f), e.v(this.Fa.fa.uc) || (b.ka.uc = this.Fa.fa.uc), this.clear(!0), this.Cx({
                report: b
              }));
            }
          }
          print(f) {
            k.at.xF.R().print(f);
          }
          Bk(f) {
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            k.Dc.Yn.Bk(f, b, a);
          }
          oD(f, b) {
            return this.RI.oD(f, b);
          }
          GH(f, b) {
            this.RI.Eda(f, b);
          }
          EM(f, b, a) {
            this.RI.Sza(f, b, a);
          }
          FM(f, b, a, c) {
            this.RI.iAa(f, b, a, c);
          }
          VR(f, b, a, c, d) {
            this.RI.SR(f, b, a, c, d);
          }
          async TN(f) {
            return new Promise((b, a) => {
              var c = d => {
                let g;
                e.v(d) ? this.Fa.fa && this.Fa.fa.Ba == e.u.i.qa.API && (g = this.Fa.fa.Nw()) : g = new e.u.external.pc.zA(d);
                e.v(g) && (d = this.z$(this.Kb), e.v(d) || ("string" === typeof d && (d = {
                  url: d
                }), g = new e.u.external.pc.zA(d)));
                g ? this.Qaa.TN(g, this.Is()).then(l => {
                  b(l);
                }) : (e.Wa(e.P.bind(k.B.j.E8, "Can't find the valid connection options"), k.B.j.xa, e.tb.xa), a("Can't find the valid connection options"));
              };
              null == this.ja || null == this.ja.O ? this.Fa.N(k.Wb.Uc.pi, () => c(f)) : c(f);
            });
          }
          Mm(f) {
            return null == this.ja || null == this.ja.O ? [] : (f = this.ja.O.yc(!1).getItem(f)) && f.filter.zh ? f.filter.Sa() : null;
          }
          yl(f, b) {
            f = e.u.we.Wg(f);
            if (f = this.ja.O.yc(!1).getItem(f)) {
              f.mu();
              f.filter = k.hb.TA.zb(b, f);
              if (f.filter.ei && (f.filter.query.ua == e.u.i.Vb.Nj || f.filter.query.ua == e.u.i.Vb.ni)) if (k.C.F.tc) this.ja.pa.Ug = [{
                sort: f.filter.query.ua == e.u.i.Vb.Nj ? e.u.i.Aa.Mc : e.u.i.Aa.kc,
                measure: this.ja.O.fd(f.filter.measure.A)
              }];else {
                b = this.ja.pa.rd(e.u.i.ha.Ia);
                var a = this.ja.pa.rd(e.u.i.ha.Ra);
                b = -1 != b.Pa.indexOf(f.A) ? a : b;
                b.Zm = [];
                b.fg = f.filter.query.ua == e.u.i.Vb.Nj ? e.u.i.Aa.Mc : e.u.i.Aa.kc;
                b.Jf = this.ja.pa.Di(f.filter.measure);
              }
              this.Ya("reset_grid");
              this.ja.filter();
              this.eb();
            }
          }
          mu(f) {
            f = e.u.we.Wg(f);
            if (f = this.ja.O.yc(!1).getItem(f)) f.mu(), this.ja.select(), this.eb();
          }
          AH() {
            if (null == this.ja || null == this.ja.pa) return [];
            const f = [],
              b = this.ja.pa.rows;
            for (let a = 0; a < b.length; a++) f.push(b.ea(a).ij());
            return f;
          }
          pH() {
            if (null == this.ja || null == this.ja.pa) return [];
            const f = [],
              b = this.ja.pa.Ka;
            for (let a = 0; a < b.length; a++) f.push(b.ea(a).ij());
            return f;
          }
          jD() {
            if (null == this.ja || null == this.ja.pa) return [];
            const f = [],
              b = this.ja.pa.ob;
            for (let a = 0; a < b.length; a++) f.push(b.ea(a).ij());
            return f;
          }
          gd() {
            if (null == this.ja || null == this.ja.pa) return [];
            var f = [];
            if (k.C.F.tc) {
              for (var b = this.ja.pa.flatten(), a, c = 0; c < b.length; c++) a = b.ea(c), (a = this.ja.O.mf(a.A)) && f.push(a.ij());
              b = this.ja.pa.gd();
              for (c = 0; c < b.length; c++) b[c].Oa && f.push(b[c].ij());
            } else for (b = this.ja.pa.gd(), c = 0; c < b.length; c++) f.push(b[c].ij());
            return f;
          }
          Gs() {
            if (null == this.ja || null == this.ja.O) return [];
            for (var f = [], b = this.ja.O.Ca, a = 0; a < b.length; a++) f.push(b.ea(a).ij());
            return f;
          }
          NV(f) {
            this.ja.O.yc(!1).getItem(f.name).label = f.caption;
          }
          iH() {
            if (null == this.ja || null == this.ja.O) return [];
            const f = [],
              b = this.ja.O.yc(!1);
            for (let a = 0; a < b.length; a++) f.push(b.ea(a).ij());
            return f;
          }
          wW(f, b, a, c) {
            c = "string" == typeof c ? new k.hb.jh(e.u.we.Wg(c)) : k.hb.jh.zb(c);
            f = this.ja.pa.axes.getItem(f);
            if (null != f) {
              if (b == e.u.i.Aa.ed) f.qC();else if (c = this.ja.pa.Di(c)) f.fg = b, f.Zm = a, f.Jf = c;
              this.ja.sort();
              this.eb();
            }
          }
          AE(f, b) {
            f = e.u.we.Wg(f);
            if (f = this.ja.O.yc(!1).getItem(f)) {
              var a = this.ja.pa.axes.getItem(e.u.i.ha.Ra),
                c = this.ja.pa.axes.getItem(e.u.i.ha.Ia);
              -1 != a.Pa.indexOf(f.A) ? c.qC() : -1 != c.Pa.indexOf(f.A) && a.qC();
              f.eg = b;
              k.C.F.tc && (this.ja.pa.Ug = [{
                sort: b,
                measure: this.ja.O.mf(f.A)
              }]);
              this.eb();
            }
            this.ja.select();
          }
          cW(f) {
            this.ja.pa.Ug = e.u.O.Xr.gda(f, this.ja.pa.Yc);
            this.eb();
            this.ja.select();
          }
          eb() {
            this.Ya(k.Wb.Uc.hk, null, "");
          }
          tW(f) {
            e.K.od.np.OS = f;
          }
          xW(f, b) {
            f = e.u.we.Wg(f);
            if (f = this.ja.O.yc(!1).getItem(f)) f.nx = b;
            this.Fa.nc && this.ja.select();
          }
          F1(f) {
            if (null == this.ja || null == this.ja.O) return "";
            f = this.ja.O.yc(!1).getItem(f);
            return null != f ? f.eg : "";
          }
          o1() {
            return null == this.ja || null == this.ja.O ? null : this.ja.pa.hda();
          }
          yj(f, b, a) {
            if (null == this.ja || null == this.ja.O) return [];
            var c = [],
              d = this.ja.O.yc(!1).getItem(f);
            null == b && (b = "");
            d && (this.Fa.fa.Ic ? (f = "" == b ? d.wd : d.Ib(b), null == a || null == f && "" != b || (f && f.children && 0 < f.children.length && !f.zf ? (c = this.gT(d, b), a(c)) : this.ja.Ik(d, f, () => {
              c = this.gT(d, b);
              a(c);
            }))) : (c = this.$0(d.wd), null != a && a(c)));
            return c;
          }
          B1(f, b) {
            return new Promise((a, c) => {
              var d = (g, l) => {
                var m = [],
                  n = this.ja.O.yc(!1).getItem(g);
                e.v(l) && (l = "");
                if (n) {
                  if (this.Fa.fa.Ic) {
                    if (g = "" === l ? n.wd : n.Ib(l), null != g) {
                      if (g && g.children && 0 < g.children.length && !g.zf) m = this.gT(n, l), a(m);else {
                        this.ja.Ik(n, g, () => {
                          m = this.gT(n, l);
                          a(m);
                        });
                        return;
                      }
                    } else c(`Member "${l}" is not found!`);
                  } else m = this.$0(n.wd);
                  a(m);
                } else c(`Hierarchy "${g}" is not found!`);
              };
              null == this.ja || null == this.ja.O ? this.Fa.N(k.Wb.Uc.pi, () => d(f, b)) : d(f, b);
            });
          }
          gT(f, b) {
            var a = [];
            b = "" == b ? f.wd.children : f.Ib(b).children;
            for (var c = 0; c < b.length; c++) {
              var d = f.za(b[c]),
                g = d.Sa();
              g.isLeaf = d.level.yb == d.hierarchy.wa.length - 1;
              g.parentMember = d.parent.dc ? d.hierarchy.wd.Ci : d.parent.Ci;
              d.A != f.Am && a.push(g);
            }
            return a;
          }
          $0(f) {
            for (var b = [], a = f.hierarchy.ck(f, !1), c = 0; c < a.length; c++) {
              var d = f.hierarchy.za(a[c]),
                g = d.Sa();
              g.isLeaf = d.level.yb == d.hierarchy.wa.length - 1;
              g.uniqueName = d.Ci;
              g.parentMember = d.parent.dc ? d.hierarchy.wd.Ci : d.parent.Ci;
              if (1 != d.children.length || d.hierarchy.za(d.children[0]).caption != k.B.j.Fl) g.children = this.$0(d);
              b.push(g);
            }
            return b;
          }
          TV(f) {
            this.Fa.fe(e.u.O.Xr.zb(f, e.u.Ma.R().O));
          }
          fe(f) {
            this.Fa.fe(f);
          }
          Qw() {
            var f = k.C.F.Qw(!0, !0).Sa();
            null != f.chartActiveMeasure && delete f.chartActiveMeasure;
            null != f.chartActiveTupleIndex && delete f.chartActiveTupleIndex;
            return f;
          }
          ci(f, b) {
            const a = this.ja && this.ja.O ? this.ja.O.fd(f) : null;
            b = a && void 0 === b ? a.Bm : b;
            const c = a && k.C.F.tc && e.u.i.Qa.zc == a.type;
            return (a ? a.ci(f, b, c) : k.ac.pj.pT()).Sa(!0);
          }
          wE(f, b, a) {
            f.hasOwnProperty("name") || (f.name = e.P.eM());
            try {
              k.ac.pj.wE(f);
            } catch (d) {
              e.Wa("Can't add format. Component's configuration requires more parameters.");
              return;
            }
            try {
              let d = this.ja.O.fd(b);
              d && void 0 === a && k.ac.pj.wI(f.name, d.A, "");
              d && d.aa === a && (d.format = f.name, k.ac.pj.wI(f.name, d.A, a), f.label && (d.label = f.label));
              if ("" != f.name && ("" == b || null == b)) for (var c = 0; c < this.ja.O.Ca.length; c++) d = this.ja.O.Ca.ea(c), k.ac.pj.wI(f.name, d.A, ""), d.format = f.name;
              const g = this.ja.pa.gd();
              for (c = 0; c < g.length; c++) if (b === g[c].A && a === g[c].aa || void 0 === a && b === g[c].A) g[c].format = f.name, k.ac.pj.wI(f.name, g[c].A, g[c].aa), f.label && (d.label = f.label);
            } catch (d) {
              e.Wa("List of measures is empty. There is nothing to format.");
              return;
            }
            this.Ea(new v.ga(k.ac.b8.U7));
            this.eb();
          }
          refresh() {
            this.ja.filter();
          }
          E4() {
            var f = e.kh.instance.Is();
            e.kh.instance.clear();
            e.kh.instance.Cx(f);
          }
          dispose() {
            e.u.Re.Ni.dispose();
            e.K.Y.W.le.zw = null;
            e.K.Cd.tv.EC = null;
            e.K.Y.MO.FL = null;
            e.u.external.pc.zA.EL = null;
            e.u.Ma.dispose();
            this.Fa && this.Fa.dispose();
            this.RI = this.I = this.Fa = this.ja = null;
            h.instance = null;
          }
          l1(f, b) {
            e.u.external.Se.Yla.R().t1(f, (a, c) => {
              e.Kg(b) && b(a, c);
            });
          }
        }
        h.id = "flexmonster";
        k.Va = h;
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor(b) {
            let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            this.type = b;
            this.data = a;
          }
        }
        k.hd = h;
        class f extends v.Fh {
          constructor() {
            super();
            if (null != f.instance) throw Error("Singleton");
          }
          static R() {
            null == f.instance && (f.instance = new f());
            return f.instance;
          }
          static dispose() {
            f.instance = null;
          }
          static qja(b) {
            return f.J2(b) ? b : "";
          }
          static J2(b) {
            return -1 < f.types.indexOf(b);
          }
          N(b, a) {
            let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            b = f.qja(b);
            f.J2(b) && super.N(b, a, c);
          }
          pb(b, a) {
            b = f.qja(b);
            f.J2(b) && super.pb(b, a);
          }
          static cKa(b) {
            for (var a = 0; a < f.types.length; a++) {
              var c = f.types[a];
              f.bKa(c, b[c]);
            }
          }
          static bKa(b, a) {
            if (a) {
              "string" == typeof a && (a = f.Uda(a));
              var c = a;
              b != f.SW && b != f.Sx && b != f.ip && b != f.QW && (c = function () {
                for (var _len5 = arguments.length, d = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  d[_key5] = arguments[_key5];
                }
                e.Be(function () {
                  a.apply(null, d);
                }, 1);
              });
              f.R().N(b, c);
            }
          }
          static Uda(b) {
            var a = window;
            b = b.split(".");
            for (var c = b.pop(), d = 0; d < b.length; d++) {
              if (null == a) return null;
              a = a[b[d]];
            }
            return a[c];
          }
        }
        f.vF = "openingreportfile";
        f.gy = "loadingreportfile";
        f.eo = "reportfileloaded";
        f.WJ = "reportfileerror";
        f.Wr = "reportfilecancelled";
        f.mF = "loadingdata";
        f.gJ = "dataloaded";
        f.eJ = "dataerror";
        f.fJ = "datafilecancelled";
        f.b7 = "datachanged";
        f.r8 = "loadingolapstructure";
        f.b9 = "olapstructureloaded";
        f.a9 = "olapstructureerror";
        f.dK = "unauthorizederror";
        f.gB = "runningquery";
        f.al = "querycomplete";
        f.Dt = "queryerror";
        f.nF = "loadinglocalization";
        f.oF = "localizationloaded";
        f.HJ = "localizationerror";
        f.pi = "reportcomplete";
        f.RP = "reportchange";
        f.u7 = "exportstart";
        f.ig = "exportcomplete";
        f.e9 = "printstart";
        f.eB = "printcomplete";
        f.k9 = "ready";
        f.I9 = "update";
        f.Sx = "beforegriddraw";
        f.ip = "aftergriddraw";
        f.QW = "afterchartdraw";
        f.E6 = "chartclick";
        f.D6 = "cellclick";
        f.EO = "celldoubleclick";
        f.$x = "filteropen";
        f.AX = "filterclose";
        f.iF = "fieldslistopen";
        f.oJ = "fieldslistclose";
        f.U8 = "numberformatting";
        f.K6 = "conditionalformatting";
        f.SW = "beforetoolbarcreated";
        f.k7 = "drillthroughopen";
        f.i7 = "drillthroughclose";
        f.types = [f.k9, f.vF, f.gy, f.eo, f.WJ, f.Wr, f.mF, f.gJ, f.eJ, f.fJ, f.b7, f.r8, f.b9, f.a9, f.dK, f.gB, f.al, f.Dt, f.nF, f.oF, f.HJ, f.pi, f.RP, f.e9, f.eB, f.u7, f.ig, f.I9, f.Sx, f.ip, f.QW, f.E6, f.D6, f.EO, f.$x, f.AX, f.iF, f.oJ, f.U8, f.K6, f.SW, f.k7, f.i7];
        k.Xa = f;
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          static valid(f) {
            if (e.v(f) || "number" === typeof f) return !0;
            f = f.toLowerCase();
            return -1 === f.indexOf("<script") && -1 === f.indexOf("<svg") && -1 === f.indexOf("javascript:") && -1 === f.indexOf("<iframe") && -1 === f.indexOf("<object") && -1 === f.indexOf("expression(") && -1 === f.indexOf("onmouseover") && -1 === f.indexOf("onload=") && -1 === f.indexOf("onerror");
          }
          static validate(f) {
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            return e.P.Go(f, b);
          }
        }
        k.Tb = h;
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {}
            static R() {
              null == f.instance && (f.instance = new f());
              return f.instance;
            }
            static dispose() {
              f.instance = null;
            }
            getData() {
              if (k.Ha.wc.Np || k.Ha.wc.qq || k.Ha.wc.Ky) {
                var b = e.u.Re.Ni.d1(k.C.F.MR);
                return this.dS(b);
              }
              e.Wa(k.Ha.ra.J(k.Ha.ra.r_), k.Ha.ra.J(k.Ha.ra.PD));
            }
            LJa(b, a) {
              if (k.Ha.wc.Np || k.Ha.wc.qq || k.Ha.wc.Ky) {
                var c = e.u.Ma.R();
                if (void 0 != c.fa && !c.fa.Ic) {
                  b = e.u.O.Xr.zb(b, c.O, !0);
                  var d = e.u.local.vP.clone(c.ta);
                  d.slice = b;
                  d.select();
                  c = new e.u.Re.jma();
                  c.reset();
                  c.ta = d;
                  c.slice = b;
                  c.load();
                  b = this.dS(c);
                  this.sca(a, b);
                  c.reset();
                }
              } else e.Wa(k.Ha.ra.J(k.Ha.ra.r_), k.Ha.ra.J(k.Ha.ra.PD));
            }
            sca(b, a) {
              try {
                a.GCa() ? b({}, a.bH.Sa()) : b(a.Sa());
              } catch (c) {
                console.error(c);
              }
            }
            dS(b) {
              var a = new h.rpa();
              if (void 0 == b.slice) return a;
              a.slice = b.slice.Sa();
              a.ox = {
                caption: k.C.F.An,
                vAmount: b.slice.gd().length,
                formats: []
              };
              var c = 0,
                d = 0;
              if (b.Xi && !b.kb) {
                var g = "on" == k.C.F.Hf || "rows" == k.C.F.Hf ? b.Ed - 1 : b.Ed;
                var l = "on" == k.C.F.Hf || "columns" == k.C.F.Hf ? b.Dd - 1 : b.Dd;
                a.data = [];
                var m = [];
                var n = [];
                var p = {};
                for (var t = 0; t < b.Ca.length; t++) {
                  var r = b.Ca[t];
                  a.ox["v" + t + "Name"] = r.caption;
                  var w = k.Va.R().ci(r.A, r.aa);
                  a.ox.formats.push(w);
                  r = b.La(m, n, r);
                  p["v" + t] = r;
                }
                a.data.push(p);
                for (w = 0; w < l; w++) if (m = b.Jn(w), !e.v(m) && 0 != m.length) {
                  p = {};
                  c = Math.max(c, m.length);
                  n = [];
                  t = b.xb;
                  for (r = 0; r < m.length; r++) {
                    var y = r;
                    var A = t.ea(y);
                    var B = m[r];
                    B = A.za(B);
                    a.ox["r" + y + "Name"] = A.caption;
                    var C = this.fT(B);
                    p["r" + y] = C;
                    p[`r${y}_full`] = B.Ci;
                  }
                  for (t = 0; t < b.Ca.length; t++) r = b.Ca[t], r = b.La(m, n, r), p["v" + t] = r;
                  a.data.push(p);
                }
                for (var I = 0; I < g; I++) if (n = b.Vj(I), !e.v(n) && 0 != n.length) {
                  p = {};
                  m = [];
                  d = Math.max(d, n.length);
                  t = b.Db;
                  for (r = 0; r < n.length; r++) C = r, A = t.ea(C), B = n[r], B = A.za(B), a.ox["c" + C + "Name"] = A.caption, A = this.fT(B), p["c" + C] = A, p[`c${C}_full`] = B.Ci;
                  for (t = 0; t < b.Ca.length; t++) r = b.Ca[t], r = b.La(m, n, r), p["v" + t] = r;
                  a.data.push(p);
                }
                var L = !1,
                  Y = u.Yf();
                if (0 < b.Db.length && 0 < b.xb.length) for (w = 0; w < l; w++) {
                  m = b.Jn(w);
                  c = Math.max(c, m.length);
                  for (I = 0; I < g; I++) {
                    if (1E4 < u.Yf() - Y) {
                      L = !0;
                      break;
                    }
                    n = b.Vj(I);
                    d = Math.max(d, n.length);
                    p = {};
                    t = b.xb;
                    for (r = 0; r < m.length; r++) y = r, A = t.ea(y), B = m[r], B = A.za(B), C = this.fT(B), p["r" + y] = C, p[`r${y}_full`] = B.Ci;
                    t = b.Db;
                    for (r = 0; r < n.length; r++) C = r, A = t.ea(C), B = n[r], B = A.za(B), A = this.fT(B), p["c" + C] = A, p[`c${y}_full`] = B.Ci;
                    for (t = 0; t < b.Ca.length; t++) r = b.Ca[t], r = b.La(m, n, r), p["v" + t] = r;
                    a.data.push(p);
                  }
                  if (L) break;
                }
              }
              L ? (a.data = [], a.ox = {}, a.bH = new h.ima(), a.bH.Dd = l, a.bH.Ed = g, a.bH.errorMessage = k.B.j.C8 + ". " + k.B.j.B8) : (a.ox.rAmount = c, a.ox.cAmount = d);
              return a;
            }
            fT(b) {
              return b.level.type == e.u.i.ib.jb || b.level.type == e.u.i.ib.ic ? b.fc : b.level.type == e.u.i.ib.Lc ? b.fc : b.level.type == e.u.i.ib.en ? isNaN(parseFloat(b.caption)) ? b.caption : parseFloat(b.caption) : b.caption;
            }
          }
          h.mP = f;
        })(k.zD || (k.zD = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.slice = {};
              this.ox = {};
              this.data = [];
              this.bH = null;
            }
            Sa() {
              var a = {};
              a.meta = this.ox;
              a.data = this.data;
              return a;
            }
            GCa() {
              return null != this.bH;
            }
          }
          h.rpa = f;
          class b {
            constructor() {
              this.errorMessage = null;
            }
            Sa() {
              var a = {};
              a.errorMessage = this.errorMessage;
              a.dataH = this.Dd;
              a.dataW = this.Ed;
              return a;
            }
          }
          h.ima = b;
        })(k.zD || (k.zD = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    var la = q || (q = {}),
      ma = la.model || (la.model = {}),
      na = ma.B || (ma.B = {});
    class oa {}
    oa.iX = "Flexmonster Pivot Table";
    na.j = oa;
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            load(b, a, c) {
              this.Mb = a;
              this.bb = c;
              this.xhr = new XMLHttpRequest();
              this.xhr.open("GET", b, !0);
              this.xhr.onerror = d => this.Sb(d);
              this.xhr.onreadystatechange = d => this.gv(d);
              this.xhr.send();
            }
            gv() {
              null != this.xhr && 4 === this.xhr.readyState && (200 === this.xhr.status ? this.GI() : this.bb());
            }
            GI() {
              this.xhr.response && null == this.xhr.response.error ? null != this.Mb && this.Fj(this.xhr.response) : this.bb && this.bb();
            }
            Sb() {
              null != this.bb && this.bb();
            }
            Fj(b) {
              try {
                var a = JSON.parse(b);
                this.Mb(h.tP.zb(a));
              } catch (c) {
                console.error(c), this.bb();
              }
            }
            close() {
              null != this.xhr && (this.xhr.onprogress = null, this.xhr.onreadystatechange = null, this.xhr.abort());
            }
          }
          h.Pna = f;
        })(k.B || (k.B = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              if (null != f.instance) throw Error("Singleton");
              this.uu = new h.tP();
              this.uu.vE();
            }
            static R() {
              null == f.instance && (f.instance = new f());
              return f.instance;
            }
            static dispose() {
              null !== this.Jz && (this.Jz.close(), this.Jz = null);
              h.j.Ur = null;
              h.j.iy = null;
              h.j.oB = null;
              h.j.pB = null;
              h.j.j9 = null;
              f.instance.uu = null;
              f.instance.JT = null;
              f.instance.$H = null;
              f.instance = null;
            }
            updateLabels() {
              h.j.I7 = this.J("fieldsList/flatHierarchyBox");
              h.j.RA = this.J("fieldsList/values");
              h.j.QA = this.J("fieldsList/addCalculatedMeasure");
              h.j.nma = this.J("fieldsList/expandAll");
              h.j.H7 = this.J("fieldsList/collapseAll");
              h.j.J7 = this.J("fieldsList/formulasGroupName");
              h.j.vv = this.J("fieldsList/allFields");
              h.j.jF = this.J("fieldsList/rows");
              h.j.hF = this.J("fieldsList/columns");
              h.j.Tr = this.J("fieldsList/filters");
              h.j.Xx = this.J("fieldsList/dropField");
              h.j.Yx = this.J("fieldsList/title");
              h.j.L7 = this.J("fieldsList/subtitle");
              h.j.XO = this.J("fieldsList/search");
              h.j.K7 = this.J("fieldsList/searchClose");
              h.j.oJ = this.J("fieldsList/close");
              h.j.iF = this.J("fieldsList/open");
              h.j.mma = this.J("fieldsList/actions/select");
              h.j.xX = this.J("fieldsList/actions/deselect");
              h.j.lma = this.J("fieldsList/actions/expand");
              h.j.kma = this.J("fieldsList/actions/collapse");
              h.j.E7 = this.J("fieldsList/actions/move_to_rows");
              h.j.C7 = this.J("fieldsList/actions/move_to_columns");
              h.j.D7 = this.J("fieldsList/actions/move_to_filters");
              h.j.F7 = this.J("fieldsList/actions/move_to_values");
              h.j.G7 = this.J("fieldsList/actions/move_up");
              h.j.B7 = this.J("fieldsList/actions/move_down");
              h.j.yX = this.J("fieldsList/actions/edit_calculated_value");
              h.j.wX = this.J("fieldsList/actions/aggregation");
              h.j.rJ = this.J("filter/all");
              h.j.xJ = this.J("filter/multipleItems");
              h.j.xv = this.J("filter/selectAll");
              h.j.Sma = this.J("filter/selectAllResults");
              h.j.Lma = this.J("filter/top");
              h.j.Cma = this.J("filter/bottom");
              h.j.M7 = this.J("filter/ascSort");
              h.j.N7 = this.J("filter/ascSortTooltip");
              h.j.P7 = this.J("filter/descSort");
              h.j.Q7 = this.J("filter/descSortTooltip");
              h.j.BX = this.J("filter/search");
              h.j.pma = this.J("filter/amountSelected");
              h.j.oma = this.J("filter/amountFound");
              h.j.Tma = this.J("filter/sort");
              h.j.SA = this.J("filter/filterBy");
              h.j.eP = this.J("filter/labelsFilter");
              h.j.R7 = this.J("filter/numbersFilter");
              h.j.T7 = this.J("filter/valuesFilter");
              h.j.O7 = this.J("filter/datesFilter");
              h.j.S7 = this.J("filter/timeFilter");
              h.j.tJ = this.J("filter/equal");
              h.j.vJ = this.J("filter/notEqual");
              h.j.zma = this.J("filter/before");
              h.j.Ama = this.J("filter/beforeEqual");
              h.j.xma = this.J("filter/after");
              h.j.yma = this.J("filter/afterEqual");
              h.j.sJ = this.J("filter/between");
              h.j.uJ = this.J("filter/notBetween");
              h.j.Gma = this.J("filter/last");
              h.j.Ema = this.J("filter/current");
              h.j.Hma = this.J("filter/next");
              h.j.Bma = this.J("filter/begin");
              h.j.Ima = this.J("filter/notBegin");
              h.j.Fma = this.J("filter/end");
              h.j.Kma = this.J("filter/notEnd");
              h.j.Dma = this.J("filter/contain");
              h.j.Jma = this.J("filter/notContain");
              h.j.aP = this.J("filter/greater");
              h.j.bP = this.J("filter/greaterEqual");
              h.j.cP = this.J("filter/less");
              h.j.dP = this.J("filter/lessEqual");
              h.j.$ma = this.J("filter/seconds");
              h.j.Yma = this.J("filter/minutes");
              h.j.Wma = this.J("filter/hours");
              h.j.Uma = this.J("filter/days");
              h.j.ana = this.J("filter/secondsFull");
              h.j.Zma = this.J("filter/minutesFull");
              h.j.Xma = this.J("filter/hoursFull");
              h.j.Vma = this.J("filter/daysFull");
              h.j.Nma = this.J("filter/day");
              h.j.Qma = this.J("filter/week");
              h.j.Oma = this.J("filter/month");
              h.j.Pma = this.J("filter/quarter");
              h.j.Rma = this.J("filter/year");
              h.j.qma = this.J("filter/clearDateFilter");
              h.j.rma = this.J("filter/clearLabelFilter");
              h.j.sma = this.J("filter/clearNumberFilter");
              h.j.tma = this.J("filter/clearTimeFilter");
              h.j.uma = this.J("filter/clearValueFilter");
              h.j.Mma = this.J("filter/noAvailableValues");
              h.j.$O = this.J("filter/condition");
              h.j.Zx = this.J("filter/conditionValue");
              h.j.vma = this.J("filter/conditionMeasure");
              h.j.wma = this.J("filter/conditionTimeInterval");
              h.j.Nla = this.J("drillThrough/title");
              h.j.Mla = this.J("drillThrough/row");
              h.j.Lla = this.J("drillThrough/column");
              h.j.Ola = this.J("drillThrough/value");
              h.j.$W = this.J("calculatedView/title");
              h.j.rMa = this.J("calculatedView/measureBox");
              h.j.ZW = this.J("calculatedView/measureName");
              h.j.DO = this.J("calculatedView/formula");
              h.j.A6 = this.J("calculatedView/formulaPrompt");
              h.j.z6 = this.J("calculatedView/calculateIndividualValues");
              h.j.C6 = this.J("calculatedView/removeValue");
              h.j.yka = this.J("calculatedView/removeValueTitle");
              h.j.xka = this.J("calculatedView/removeValueMessage");
              h.j.wka = this.J("calculatedView/allValues");
              h.j.vka = this.J("calculatedView/actions/add_to_formula");
              h.j.$La = this.J("calculatedView/func/add");
              h.j.qMa = this.J("calculatedView/func/subtract");
              h.j.kMa = this.J("calculatedView/func/multiply");
              h.j.bMa = this.J("calculatedView/func/divide");
              h.j.nMa = this.J("calculatedView/func/power");
              h.j.cMa = this.J("calculatedView/func/equal");
              h.j.gMa = this.J("calculatedView/func/less");
              h.j.hMa = this.J("calculatedView/func/less_equal");
              h.j.dMa = this.J("calculatedView/func/greater");
              h.j.eMa = this.J("calculatedView/func/greater_equal");
              h.j.pMa = this.J("calculatedView/func/strict_equal");
              h.j.lMa = this.J("calculatedView/func/not_equal");
              h.j.mMa = this.J("calculatedView/func/or");
              h.j.aMa = this.J("calculatedView/func/and");
              h.j.fMa = this.J("calculatedView/func/if");
              h.j.ZLa = this.J("calculatedView/func/abs");
              h.j.oMa = this.J("calculatedView/func/round");
              h.j.jMa = this.J("calculatedView/func/min");
              h.j.iMa = this.J("calculatedView/func/max");
              h.j.HX = this.J("grid/total");
              h.j.pna = this.J("grid/totals");
              h.j.GX = this.J("grid/grandTotal");
              h.j.Fl = this.J("grid/blankMember");
              h.j.hX = this.J("grid/dateNullCaption");
              h.j.Wn = this.J("grid/dateInvalidCaption");
              h.j.gma = this.J("grid/reportInformation");
              h.j.Dka = this.J("charts/showLegend");
              h.j.Bka = this.J("charts/hideLegend");
              h.j.Cka = this.J("charts/selectMeasures");
              h.j.F6 = this.J("charts/noDataTitle");
              h.j.Eka = this.J("charts/noMeasuresTitle");
              h.j.Fka = this.J("charts/bigDataSetWarning");
              h.j.hQ = this.J("tooltips/fieldList");
              h.j.D9 = this.J("tooltips/selectAggregation");
              h.j.B9 = this.J("tooltips/editCalculatedMeasure");
              h.j.Mqa = this.J("tooltips/row");
              h.j.Lqa = this.J("tooltips/headerResize");
              h.j.C9 = this.J("tooltips/headerFit");
              h.j.lB = this.J("tooltips/filterIcon");
              h.j.tY = this.J("tooltips/filtered");
              h.j.gQ = this.J("tooltips/expandIcon");
              h.j.fQ = this.J("tooltips/collapseIcon");
              h.j.Jqa = this.J("tooltips/drillDown");
              h.j.Kqa = this.J("tooltips/drillUp");
              h.j.Pqa = this.J("tooltips/sortIcon");
              h.j.Oqa = this.J("tooltips/sortedDescIcon");
              h.j.Nqa = this.J("tooltips/sortedAscIcon");
              h.j.Qqa = this.J("tooltips/unsortedIcon");
              h.j.Iqa = this.J("tooltips/close");
              h.j.x9 = this.J("aggregations/sum/caption");
              h.j.aK = this.J("aggregations/sum/totalCaption");
              h.j.rqa = this.J("aggregations/sum/grandTotalCaption");
              h.j.R6 = this.J("aggregations/count/caption");
              h.j.FO = this.J("aggregations/count/totalCaption");
              h.j.ila = this.J("aggregations/count/grandTotalCaption");
              h.j.Hla = this.J("aggregations/distinctCount/caption");
              h.j.PO = this.J("aggregations/distinctCount/totalCaption");
              h.j.Ila = this.J("aggregations/distinctCount/grandTotalCaption");
              h.j.Tpa = this.J("aggregations/runningTotalsOfColumn/caption");
              h.j.SP = this.J("aggregations/runningTotalsOfColumn/totalCaption");
              h.j.Upa = this.J("aggregations/runningTotalsOfColumn/grandTotalCaption");
              h.j.Vpa = this.J("aggregations/runningTotalsOfRow/caption");
              h.j.UP = this.J("aggregations/runningTotalsOfRow/totalCaption");
              h.j.Wpa = this.J("aggregations/runningTotalsOfRow/grandTotalCaption");
              h.j.Dla = this.J("aggregations/differenceOfColumn/caption");
              h.j.iJ = this.J("aggregations/differenceOfColumn/totalCaption");
              h.j.Ela = this.J("aggregations/differenceOfColumn/grandTotalCaption");
              h.j.Fla = this.J("aggregations/differenceOfRow/caption");
              h.j.jJ = this.J("aggregations/differenceOfRow/totalCaption");
              h.j.Gla = this.J("aggregations/differenceOfRow/grandTotalCaption");
              h.j.vpa = this.J("aggregations/percentDifferenceOfColumn/caption");
              h.j.QJ = this.J("aggregations/percentDifferenceOfColumn/totalCaption");
              h.j.wpa = this.J("aggregations/percentDifferenceOfColumn/grandTotalCaption");
              h.j.xpa = this.J("aggregations/percentDifferenceOfRow/caption");
              h.j.RJ = this.J("aggregations/percentDifferenceOfRow/totalCaption");
              h.j.ypa = this.J("aggregations/percentDifferenceOfRow/grandTotalCaption");
              h.j.n6 = this.J("aggregations/average/caption");
              h.j.AO = this.J("aggregations/average/totalCaption");
              h.j.jka = this.J("aggregations/average/grandTotalCaption");
              h.j.roa = this.J("aggregations/median/caption");
              h.j.QX = this.J("aggregations/median/totalCaption");
              h.j.soa = this.J("aggregations/median/grandTotalCaption");
              h.j.mqa = this.J("aggregations/stdevp/caption");
              h.j.ZP = this.J("aggregations/stdevp/totalCaption");
              h.j.nqa = this.J("aggregations/stdevp/grandTotalCaption");
              h.j.oqa = this.J("aggregations/stdevs/caption");
              h.j.$P = this.J("aggregations/stdevs/totalCaption");
              h.j.pqa = this.J("aggregations/stdevs/grandTotalCaption");
              h.j.Gpa = this.J("aggregations/product/caption");
              h.j.QP = this.J("aggregations/product/totalCaption");
              h.j.Hpa = this.J("aggregations/product/grandTotalCaption");
              h.j.Voa = this.J("aggregations/min/caption");
              h.j.JP = this.J("aggregations/min/totalCaption");
              h.j.Woa = this.J("aggregations/min/grandTotalCaption");
              h.j.Xna = this.J("aggregations/max/caption");
              h.j.AP = this.J("aggregations/max/totalCaption");
              h.j.Yna = this.J("aggregations/max/grandTotalCaption");
              h.j.spa = this.J("aggregations/percent/caption");
              h.j.VJ = this.J("aggregations/percent/totalCaption");
              h.j.zpa = this.J("aggregations/percent/grandTotalCaption");
              h.j.tpa = this.J("aggregations/percentOfColumn/caption");
              h.j.PJ = this.J("aggregations/percentOfColumn/totalCaption");
              h.j.upa = this.J("aggregations/percentOfColumn/grandTotalCaption");
              h.j.Epa = this.J("aggregations/percentOfRow/caption");
              h.j.UJ = this.J("aggregations/percentOfRow/totalCaption");
              h.j.Fpa = this.J("aggregations/percentOfRow/grandTotalCaption");
              h.j.Apa = this.J("aggregations/percentOfParentColumnTotal/caption");
              h.j.SJ = this.J("aggregations/percentOfParentColumnTotal/totalCaption");
              h.j.Bpa = this.J("aggregations/percentOfParentColumnTotal/grandTotalCaption");
              h.j.Cpa = this.J("aggregations/percentOfParentRowTotal/caption");
              h.j.TJ = this.J("aggregations/percentOfParentRowTotal/totalCaption");
              h.j.Dpa = this.J("aggregations/percentOfParentRowTotal/grandTotalCaption");
              h.j.vna = this.J("aggregations/index/caption");
              h.j.DJ = this.J("aggregations/index/totalCaption");
              h.j.wna = this.J("aggregations/index/grandTotalCaption");
              h.j.fpa = this.J("aggregations/none/caption");
              h.j.xa = this.J("messages/error");
              h.j.M9 = this.J("messages/warning");
              h.j.rP = this.J("messages/limitation");
              h.j.pka = this.J("messages/browse");
              h.j.cn = this.J("messages/confirmation");
              h.j.Doa = this.J("messages/api/incorrectUrl");
              h.j.Coa = this.J("messages/api/errorZeroStatus");
              h.j.voa = this.J("messages/api/error404Status");
              h.j.uoa = this.J("messages/api/error400Status");
              h.j.woa = this.J("messages/api/error500Status");
              h.j.A8 = this.J("messages/api/selectRequestError");
              h.j.xoa = this.J("messages/api/selectDrillThroughError");
              h.j.aOa = this.J("messages/api/clientOutdated");
              h.j.Boa = this.J("messages/api/serverOutdated");
              h.j.Aoa = this.J("messages/api/fieldsRequestError");
              h.j.z8 = this.J("messages/api/membersRequestError");
              h.j.zoa = this.J("messages/api/expandDataError");
              h.j.yoa = this.J("messages/api/drillDataError");
              h.j.RX = this.J("messages/api/noGridChartsMode");
              h.j.rF = this.J("messages/loading");
              h.j.jg = this.J("messages/loadingData");
              h.j.WX = this.J("messages/loadingMapping");
              h.j.yt = this.J("messages/waiting");
              h.j.XX = this.J("messages/progress");
              h.j.sF = this.J("messages/progressKnown");
              h.j.om = this.J("messages/progressUnknown");
              h.j.Poa = this.J("messages/sortingMembers");
              h.j.CP = this.J("messages/analyzing");
              h.j.DP = this.J("messages/analyzingProgress");
              h.j.y8 = this.J("messages/analyzingRecords");
              h.j.toa = this.J("messages/analyzingRecordsWithAmount");
              h.j.L8 = this.J("messages/saving");
              h.j.KJ = this.J("messages/loadingDimensions");
              h.j.UX = this.J("messages/loadingHierarchies");
              h.j.GP = this.J("messages/loadingMeasures");
              h.j.I8 = this.J("messages/loadingKPIs");
              h.j.ao = this.J("messages/loadingMembers");
              h.j.VX = this.J("messages/loadingLevels");
              h.j.J8 = this.J("messages/loadingProperties");
              h.j.hy = this.J("messages/exportProgress");
              h.j.$n = this.J("messages/exportError");
              h.j.tF = this.J("messages/pleaseWait");
              h.j.K8 = this.J("messages/pagesWereGenerated");
              h.j.M8 = this.J("messages/uploading");
              h.j.EP = this.J("messages/cantSaveFile");
              h.j.SX = this.J("messages/cantSaveFileNoDetails");
              h.j.Noa = this.J("messages/saveReportToFile");
              h.j.Moa = this.J("messages/saveReportForSharing");
              h.j.E8 = this.J("messages/cantSaveReportForSharing");
              h.j.D8 = this.J("messages/cantLoadSharedReport");
              h.j.qF = this.J("messages/invalidDataSource");
              h.j.Foa = this.J("messages/dataStreamError");
              h.j.LJ = this.J("messages/unableToOpenFile");
              h.j.FP = this.J("messages/errorTextMessage");
              h.j.Koa = this.J("messages/inappropriateFileFormat");
              h.j.JJ = this.J("messages/invalidJSONdata");
              h.j.Soa = this.J("messages/wrongFormulaEmpty");
              h.j.N8 = this.J("messages/wrongFormulaFormat");
              h.j.Uoa = this.J("messages/wrongUniqueName");
              h.j.Roa = this.J("messages/wrongFormulaAggregation");
              h.j.Toa = this.J("messages/wrongFormulaRecursive");
              h.j.Hoa = this.J("messages/excelCsvChartsExportError");
              h.j.Bv = this.J("messages/noDataAvailable");
              h.j.TX = this.J("messages/dataWasUpdated");
              h.j.Eoa = this.J("messages/cantConnectToAccelerator");
              h.j.Loa = this.J("messages/ocsvIncompatible");
              h.j.HP = this.J("messages/unknownError");
              h.j.G8 = this.J("messages/invalidReportFormat");
              h.j.H8 = this.J("messages/invalidReportFormat2");
              h.j.F8 = this.J("messages/csvHeaderParsingError");
              h.j.Qoa = this.J("messages/tooManyColumnsInClassicMode");
              h.j.B8 = this.J("messages/cantExpand");
              h.j.C8 = this.J("messages/cantExpandTitle");
              h.j.Ooa = this.J("messages/selectFile");
              h.j.Joa = this.J("messages/flatTableIsNotSupported");
              h.j.Ioa = this.J("messages/exportFontLoadingError");
              h.j.Goa = this.J("messages/elastic/errorConnection");
              h.j.ey = this.J("kpis/kpis");
              h.j.m8 = this.J("kpis/value");
              h.j.i8 = this.J("kpis/goal");
              h.j.l8 = this.J("kpis/trend");
              h.j.k8 = this.J("kpis/status");
              h.j.UW = this.J("buttons/ok");
              h.j.t6 = this.J("buttons/copy");
              h.j.Tx = this.J("buttons/apply");
              h.j.El = this.J("buttons/cancel");
              h.j.v6 = this.J("buttons/save");
              h.j.qka = this.J("buttons/select");
              h.j.VE = this.J("buttons/yes");
              h.j.u6 = this.J("buttons/no");
              h.j.M6 = this.J("contextMenu/clearSorting");
              h.j.Kka = this.J("contextMenu/collapse");
              h.j.N6 = this.J("contextMenu/drillThrough");
              h.j.Qka = this.J("contextMenu/expand");
              h.j.Nka = this.J("contextMenu/drillUp");
              h.j.Mka = this.J("contextMenu/drillDown");
              h.j.P6 = this.J("contextMenu/openFilter");
              h.j.Rka = this.J("contextMenu/filterBy");
              h.j.Pka = this.J("contextMenu/exclude");
              h.j.Q6 = this.J("contextMenu/removeField");
              h.j.$ka = this.J("contextMenu/removeMeasure");
              h.j.cla = this.J("contextMenu/sortColumnAsc");
              h.j.dla = this.J("contextMenu/sortColumnDesc");
              h.j.ela = this.J("contextMenu/sortRowAsc");
              h.j.fla = this.J("contextMenu/sortRowDesc");
              h.j.L6 = this.J("contextMenu/aggregation");
              h.j.Zka = this.J("contextMenu/properties");
              h.j.Oka = this.J("contextMenu/editFormula");
              h.j.Xka = this.J("contextMenu/moveToRows");
              h.j.Vka = this.J("contextMenu/moveToColumns");
              h.j.Wka = this.J("contextMenu/moveToReportFilters");
              h.j.Yka = this.J("contextMenu/numberFormatting");
              h.j.Lka = this.J("contextMenu/conditionalFormatting");
              h.j.ala = this.J("contextMenu/showProperty");
              h.j.Tka = this.J("contextMenu/hideProperty");
              h.j.Ska = this.J("contextMenu/groupMembers");
              h.j.gla = this.J("contextMenu/ungroupMembers");
              h.j.bla = this.J("contextMenu/showSubtotals");
              h.j.Uka = this.J("contextMenu/hideSubtotals");
              h.j.Jl = this.J("date/year");
              h.j.Ct = this.J("date/quarter");
              h.j.ih = this.J("date/month");
              h.j.en = this.J("date/day");
              h.j.j9 = [this.J("quarters/q1"), this.J("quarters/q2"), this.J("quarters/q3"), this.J("quarters/q4")];
              h.j.Ur = [this.J("months/january"), this.J("months/february"), this.J("months/march"), this.J("months/april"), this.J("months/may"), this.J("months/june"), this.J("months/july"), this.J("months/august"), this.J("months/september"), this.J("months/october"), this.J("months/november"), this.J("months/december")];
              h.j.iy = [this.J("monthsShort/january"), this.J("monthsShort/february"), this.J("monthsShort/march"), this.J("monthsShort/april"), this.J("monthsShort/may"), this.J("monthsShort/june"), this.J("monthsShort/july"), this.J("monthsShort/august"), this.J("monthsShort/september"), this.J("monthsShort/october"), this.J("monthsShort/november"), this.J("monthsShort/december")];
              h.j.oB = [this.J("weekdays/first"), this.J("weekdays/second"), this.J("weekdays/third"), this.J("weekdays/fourth"), this.J("weekdays/fifth"), this.J("weekdays/sixth"), this.J("weekdays/seventh")];
              h.j.pB = [this.J("weekdaysShort/first"), this.J("weekdaysShort/second"), this.J("weekdaysShort/third"), this.J("weekdaysShort/fourth"), this.J("weekdaysShort/fifth"), this.J("weekdaysShort/sixth"), this.J("weekdaysShort/seventh")];
              u.Eh.YJa(h.j.oB, h.j.pB);
              u.Eh.jKa(h.j.Ur, h.j.iy);
            }
            J(b) {
              if (!e.v(this.$H)) {
                var a = this.$H.J(b);
                if (!e.v(a)) return a;
              }
              return e.v(this.JT) || (a = this.JT.J(b), e.v(a)) ? this.uu.J(b) : a;
            }
            reset() {
              this.$H = null;
              this.updateLabels();
            }
            load(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              "string" !== typeof b || e.ia(b) ? (b instanceof Object ? this.zga(h.tP.zb(b), c) : this.reset(), null != a && a(!0)) : (null !== f.Jz && (f.Jz.close(), f.Jz = null), f.Jz = new h.Pna(), f.Jz.load(u.py.FH(b, !0), d => {
                this.zga(d, c);
                null != a && a(!0);
              }, () => {
                null != a && a(!1);
              }));
            }
            zga(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              a ? this.JT = b : this.$H = b;
              this.updateLabels();
            }
            Bda() {
              var b = new h.tP();
              b.vE();
              b.merge(this.JT);
              this.$H && b.merge(this.$H);
              return b.Sa().toolbar;
            }
          }
          f.Jz = null;
          h.XA = f;
        })(k.B || (k.B = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.labels = {};
            }
            J(b) {
              var a = this.labels;
              b = b.split("/");
              for (var c = 0; c < b.length; c++) {
                if (void 0 === a[b[c]]) return;
                a = a[b[c]];
              }
              return a;
            }
            gb(b, a) {
              var c = this.labels;
              b = b.split("/");
              for (var d = 0; d < b.length - 1; d++) c = c[b[d]];
              c[b[b.length - 1]] = a;
            }
            vE() {
              this.labels.fieldsList = {};
              this.labels.fieldsList.flatHierarchyBox = "Select and arrange columns";
              this.labels.fieldsList.values = "Values";
              this.labels.fieldsList.allFields = "All fields";
              this.labels.fieldsList.rows = "Rows";
              this.labels.fieldsList.columns = "Columns";
              this.labels.fieldsList.filters = "Report filters";
              this.labels.fieldsList.dropField = "Drop field here";
              this.labels.fieldsList.addCalculatedMeasure = "Add calculated value";
              this.labels.fieldsList.expandAll = "Expand all";
              this.labels.fieldsList.collapseAll = "Collapse all";
              this.labels.fieldsList.formulasGroupName = "Calculated values";
              this.labels.fieldsList.title = "Fields";
              this.labels.fieldsList.subtitle = "Drag and drop fields to arrange";
              this.labels.fieldsList.search = "Search";
              this.labels.fieldsList.searchClose = "Close search";
              this.labels.fieldsList.open = "Open Field List";
              this.labels.fieldsList.close = "Close Field List";
              this.labels.fieldsList.actions = {};
              this.labels.fieldsList.actions.select = "Select";
              this.labels.fieldsList.actions.deselect = "Deselect";
              this.labels.fieldsList.actions.expand = "Expand";
              this.labels.fieldsList.actions.collapse = "Collapse";
              this.labels.fieldsList.actions.move_to_rows = "Move to rows";
              this.labels.fieldsList.actions.move_to_columns = "Move to columns";
              this.labels.fieldsList.actions.move_to_filters = "Move to report filters";
              this.labels.fieldsList.actions.move_to_values = "Move to values";
              this.labels.fieldsList.actions.move_up = "Move up";
              this.labels.fieldsList.actions.move_down = "Move down";
              this.labels.fieldsList.actions.edit_calculated_value = "Edit calculated value";
              this.labels.fieldsList.actions.aggregation = "Aggregation";
              this.labels.filter = {};
              this.labels.filter.ascSort = "Az";
              this.labels.filter.ascSortTooltip = "Sort ascending";
              this.labels.filter.descSort = "zA";
              this.labels.filter.descSortTooltip = "Sort descending";
              this.labels.filter.top = "Top";
              this.labels.filter.bottom = "Bottom";
              this.labels.filter.search = "Search";
              this.labels.filter.selectAll = "Select all";
              this.labels.filter.selectAllResults = "Select all results";
              this.labels.filter.amountSelected = "{0} of {1} selected";
              this.labels.filter.amountFound = "{0} of {1} found are selected";
              this.labels.filter.multipleItems = "Multiple items";
              this.labels.filter.all = "All";
              this.labels.filter.sort = "Sort:";
              this.labels.filter.filterBy = "Filter by:";
              this.labels.filter.labelsFilter = "Labels";
              this.labels.filter.numbersFilter = "Labels";
              this.labels.filter.valuesFilter = "Values";
              this.labels.filter.datesFilter = "Dates";
              this.labels.filter.timeFilter = "Time";
              this.labels.filter.equal = "Equal";
              this.labels.filter.notEqual = "Not equal";
              this.labels.filter.before = "Before";
              this.labels.filter.beforeEqual = "Before or equal";
              this.labels.filter.after = "After";
              this.labels.filter.afterEqual = "After or equal";
              this.labels.filter.between = "Between";
              this.labels.filter.notBetween = "Not between";
              this.labels.filter.last = "Last...";
              this.labels.filter.current = "Current...";
              this.labels.filter.next = "Next...";
              this.labels.filter.begin = "Begin";
              this.labels.filter.notBegin = "Not begin";
              this.labels.filter.end = "End";
              this.labels.filter.notEnd = "Not end";
              this.labels.filter.contain = "Contain";
              this.labels.filter.notContain = "Not contain";
              this.labels.filter.greater = "Greater";
              this.labels.filter.greaterEqual = "Greater or equal";
              this.labels.filter.less = "Less";
              this.labels.filter.lessEqual = "Less or equal";
              this.labels.filter.day = "Day";
              this.labels.filter.week = "Week";
              this.labels.filter.month = "Month";
              this.labels.filter.quarter = "Quarter";
              this.labels.filter.year = "Year";
              this.labels.filter.seconds = "sec.";
              this.labels.filter.secondsFull = "seconds";
              this.labels.filter.minutes = "min.";
              this.labels.filter.minutesFull = "minutes";
              this.labels.filter.hours = "hr.";
              this.labels.filter.hoursFull = "hours";
              this.labels.filter.days = "d.";
              this.labels.filter.daysFull = "days";
              this.labels.filter.clearDateFilter = "Clear date filter";
              this.labels.filter.clearLabelFilter = "Clear label filter";
              this.labels.filter.clearNumberFilter = "Clear label filter";
              this.labels.filter.clearTimeFilter = "Clear time filter";
              this.labels.filter.clearValueFilter = "Clear value filter";
              this.labels.filter.noAvailableValues = "No available values";
              this.labels.filter.condition = "Condition";
              this.labels.filter.conditionValue = "Condition value";
              this.labels.filter.conditionMeasure = "Measure";
              this.labels.filter.conditionTimeInterval = "Time interval";
              this.labels.drillThrough = {};
              this.labels.drillThrough.title = "Details";
              this.labels.drillThrough.row = "Row: <b>{0}</b>";
              this.labels.drillThrough.column = "Column: <b>{0}</b>";
              this.labels.drillThrough.value = "{0}: <b>{1}</b>";
              this.labels.calculatedView = {};
              this.labels.calculatedView.title = "Calculated value";
              this.labels.calculatedView.measureBox = "Drag values to formula";
              this.labels.calculatedView.measureName = "Value name";
              this.labels.calculatedView.formula = "Formula";
              this.labels.calculatedView.formulaPrompt = "Drop values and edit formula here";
              this.labels.calculatedView.calculateIndividualValues = "Calculate individual values";
              this.labels.calculatedView.removeValue = "Remove";
              this.labels.calculatedView.removeValueTitle = "Remove {0}?";
              this.labels.calculatedView.removeValueMessage = "Are you sure you want to remove this calculated value?";
              this.labels.calculatedView.allValues = "All values";
              this.labels.calculatedView.actions = {};
              this.labels.calculatedView.actions.add_to_formula = "Add to formula";
              this.labels.calculatedView.func = {};
              this.labels.calculatedView.func.add = "Add";
              this.labels.calculatedView.func.subtract = "Subtract";
              this.labels.calculatedView.func.multiply = "Multiply";
              this.labels.calculatedView.func.divide = "Divide";
              this.labels.calculatedView.func.power = "Power";
              this.labels.calculatedView.func.equal = "Equal";
              this.labels.calculatedView.func.less = "Less";
              this.labels.calculatedView.func.less_equal = "Less or equal";
              this.labels.calculatedView.func.greater = "Greater";
              this.labels.calculatedView.func.greater_equal = "Greater or equal";
              this.labels.calculatedView.func.strict_equal = "Strict equal";
              this.labels.calculatedView.func.not_equal = "Not equal";
              this.labels.calculatedView.func.or = "Or";
              this.labels.calculatedView.func.and = "And";
              this.labels.calculatedView.func["if"] = "If";
              this.labels.calculatedView.func.abs = "Absolute";
              this.labels.calculatedView.func.round = "Round";
              this.labels.calculatedView.func.min = "Minimum";
              this.labels.calculatedView.func.max = "Maximum";
              this.labels.grid = {};
              this.labels.grid.total = "Total";
              this.labels.grid.totals = "Totals";
              this.labels.grid.grandTotal = "Grand Total";
              this.labels.grid.blankMember = "(blank)";
              this.labels.grid.dateNullCaption = "null";
              this.labels.grid.dateInvalidCaption = "Invalid date";
              this.labels.grid.reportInformation = "Report information";
              this.labels.charts = {};
              this.labels.charts.showLegend = "Show legend";
              this.labels.charts.hideLegend = "Hide legend";
              this.labels.charts.selectMeasures = "Select measures";
              this.labels.charts.bigDataSetWarning = "The dataset is too big to be displayed. Data will be trimmed to fit into the chart.";
              this.labels.charts.noDataTitle = "No data to display.";
              this.labels.charts.noMeasuresTitle = "No measures to display. Add at least one measure in the Field List.";
              this.labels.tooltips = {};
              this.labels.tooltips.fieldList = "Click to open Fields";
              this.labels.tooltips.selectAggregation = "Select aggregation";
              this.labels.tooltips.editCalculatedMeasure = "Edit calculated value";
              this.labels.tooltips.row = "Row:";
              this.labels.tooltips.headerResize = "Drag to resize";
              this.labels.tooltips.headerFit = "Double click to fit";
              this.labels.tooltips.filterIcon = "Click to filter";
              this.labels.tooltips.filtered = "Filtered";
              this.labels.tooltips.expandIcon = "Click to expand";
              this.labels.tooltips.collapseIcon = "Click to collapse";
              this.labels.tooltips.drillDown = "Click to drill down";
              this.labels.tooltips.drillUp = "Click to drill up";
              this.labels.tooltips.sortIcon = "Click to sort";
              this.labels.tooltips.sortedDescIcon = "Click to sort descending";
              this.labels.tooltips.sortedAscIcon = "Click to sort ascending";
              this.labels.tooltips.unsortedIcon = "Click to unsort";
              this.labels.tooltips.close = "Click to close";
              this.labels.aggregations = {};
              this.labels.aggregations.sum = {};
              this.labels.aggregations.sum.caption = "Sum";
              this.labels.aggregations.sum.totalCaption = "Sum of {0}";
              this.labels.aggregations.sum.grandTotalCaption = "Total Sum of {0}";
              this.labels.aggregations.count = {};
              this.labels.aggregations.count.caption = "Count";
              this.labels.aggregations.count.totalCaption = "Count of {0}";
              this.labels.aggregations.count.grandTotalCaption = "Total Count of {0}";
              this.labels.aggregations.distinctCount = {};
              this.labels.aggregations.distinctCount.caption = "Distinct Count";
              this.labels.aggregations.distinctCount.totalCaption = "Distinct Count of {0}";
              this.labels.aggregations.distinctCount.grandTotalCaption = "Total Distinct Count of {0}";
              this.labels.aggregations.average = {};
              this.labels.aggregations.average.caption = "Average";
              this.labels.aggregations.average.totalCaption = "Average of {0}";
              this.labels.aggregations.average.grandTotalCaption = "Total Average of {0}";
              this.labels.aggregations.median = {};
              this.labels.aggregations.median.caption = "Median";
              this.labels.aggregations.median.totalCaption = "Median of {0}";
              this.labels.aggregations.median.grandTotalCaption = "Total Median of {0}";
              this.labels.aggregations.stdevp = {};
              this.labels.aggregations.stdevp.caption = "Population StDev";
              this.labels.aggregations.stdevp.totalCaption = "Population StDev of {0}";
              this.labels.aggregations.stdevp.grandTotalCaption = "Total Population StDev of {0}";
              this.labels.aggregations.stdevs = {};
              this.labels.aggregations.stdevs.caption = "Sample StDev";
              this.labels.aggregations.stdevs.totalCaption = "Sample StDev of {0}";
              this.labels.aggregations.stdevs.grandTotalCaption = "Total Sample StDev of {0}";
              this.labels.aggregations.product = {};
              this.labels.aggregations.product.caption = "Product";
              this.labels.aggregations.product.totalCaption = "Product of {0}";
              this.labels.aggregations.product.grandTotalCaption = "Total Product of {0}";
              this.labels.aggregations.min = {};
              this.labels.aggregations.min.caption = "Min";
              this.labels.aggregations.min.totalCaption = "Min of {0}";
              this.labels.aggregations.min.grandTotalCaption = "Total Min of {0}";
              this.labels.aggregations.max = {};
              this.labels.aggregations.max.caption = "Max";
              this.labels.aggregations.max.totalCaption = "Max of {0}";
              this.labels.aggregations.max.grandTotalCaption = "Total Max of {0}";
              this.labels.aggregations.percent = {};
              this.labels.aggregations.percent.caption = "% of Grand Total";
              this.labels.aggregations.percent.totalCaption = "% of Grand Total of {0}";
              this.labels.aggregations.percent.grandTotalCaption = "Total % of Grand Total of {0}";
              this.labels.aggregations.percentOfColumn = {};
              this.labels.aggregations.percentOfColumn.caption = "% of Column";
              this.labels.aggregations.percentOfColumn.totalCaption = "% of Column of {0}";
              this.labels.aggregations.percentOfColumn.grandTotalCaption = "Total % of Column of {0}";
              this.labels.aggregations.percentOfRow = {};
              this.labels.aggregations.percentOfRow.caption = "% of Row";
              this.labels.aggregations.percentOfRow.totalCaption = "% of Row of {0}";
              this.labels.aggregations.percentOfRow.grandTotalCaption = "Total % of Row of {0}";
              this.labels.aggregations.percentOfParentColumnTotal = {};
              this.labels.aggregations.percentOfParentColumnTotal.caption = "% of Parent Column Total";
              this.labels.aggregations.percentOfParentColumnTotal.totalCaption = "% of Parent Column Total of {0}";
              this.labels.aggregations.percentOfParentColumnTotal.grandTotalCaption = "% of Parent Column Total of {0}";
              this.labels.aggregations.percentOfParentRowTotal = {};
              this.labels.aggregations.percentOfParentRowTotal.caption = "% of Parent Row Total";
              this.labels.aggregations.percentOfParentRowTotal.totalCaption = "% of Parent Row Total of {0}";
              this.labels.aggregations.percentOfParentRowTotal.grandTotalCaption = "% of Parent Row Total of {0}";
              this.labels.aggregations.runningTotalsOfColumn = {};
              this.labels.aggregations.runningTotalsOfColumn.caption = "Running Totals of Column";
              this.labels.aggregations.runningTotalsOfColumn.totalCaption = "Running Totals of Column of {0}";
              this.labels.aggregations.runningTotalsOfColumn.grandTotalCaption = "Running Totals of Column of {0}";
              this.labels.aggregations.runningTotalsOfRow = {};
              this.labels.aggregations.runningTotalsOfRow.caption = "Running Totals of Row";
              this.labels.aggregations.runningTotalsOfRow.totalCaption = "Running Totals of Row of {0}";
              this.labels.aggregations.runningTotalsOfRow.grandTotalCaption = "Running Totals of Row of {0}";
              this.labels.aggregations.index = {};
              this.labels.aggregations.index.caption = "Index";
              this.labels.aggregations.index.totalCaption = "Index of {0}";
              this.labels.aggregations.index.grandTotalCaption = "Index of {0}";
              this.labels.aggregations.differenceOfColumn = {};
              this.labels.aggregations.differenceOfColumn.caption = "Difference of Column";
              this.labels.aggregations.differenceOfColumn.totalCaption = "Difference of Column of {0}";
              this.labels.aggregations.differenceOfColumn.grandTotalCaption = "Difference of Column of {0}";
              this.labels.aggregations.differenceOfRow = {};
              this.labels.aggregations.differenceOfRow.caption = "Difference of Row";
              this.labels.aggregations.differenceOfRow.totalCaption = "Difference of Row of {0}";
              this.labels.aggregations.differenceOfRow.grandTotalCaption = "Difference of Row of {0}";
              this.labels.aggregations.percentDifferenceOfColumn = {};
              this.labels.aggregations.percentDifferenceOfColumn.caption = "% Difference of Column";
              this.labels.aggregations.percentDifferenceOfColumn.totalCaption = "% Difference of Column of {0}";
              this.labels.aggregations.percentDifferenceOfColumn.grandTotalCaption = "% Difference of Column of {0}";
              this.labels.aggregations.percentDifferenceOfRow = {};
              this.labels.aggregations.percentDifferenceOfRow.caption = "% Difference of Row";
              this.labels.aggregations.percentDifferenceOfRow.totalCaption = "% Difference of Row of {0}";
              this.labels.aggregations.percentDifferenceOfRow.grandTotalCaption = "% Difference of Row of {0}";
              this.labels.aggregations.none = {};
              this.labels.aggregations.none.caption = "No calculation";
              this.labels.messages = {};
              this.labels.messages.error = "Error";
              this.labels.messages.warning = "Warning";
              this.labels.messages.limitation = "Limitation";
              this.labels.messages.browse = "Browse";
              this.labels.messages.confirmation = "Confirmation";
              this.labels.messages.loading = "Loading...";
              this.labels.messages.loadingData = "Loading data...";
              this.labels.messages.loadingMapping = "Loading mapping...";
              this.labels.messages.uploading = "Uploading...";
              this.labels.messages.waiting = "Waiting for the response {0} sec.";
              this.labels.messages.progress = "{0} rows";
              this.labels.messages.progressKnown = "{0} KB loaded of {1} KB ({2}%)";
              this.labels.messages.progressUnknown = "{0} KB loaded";
              this.labels.messages.sortingMembers = "Sorting members...";
              this.labels.messages.analyzing = "Analyzing data...";
              this.labels.messages.analyzingProgress = "{0} records of {1} ({2}%)";
              this.labels.messages.analyzingRecords = "{0}% of records";
              this.labels.messages.analyzingRecordsWithAmount = "{0} records ({1}%)";
              this.labels.messages.saving = "Saving...";
              this.labels.messages.loadingDimensions = "Loading dimensions...";
              this.labels.messages.loadingHierarchies = "Loading hierarchies...";
              this.labels.messages.loadingMeasures = "Loading measures...";
              this.labels.messages.loadingKPIs = "Loading KPIs...";
              this.labels.messages.loadingMembers = "Loading members...";
              this.labels.messages.loadingProperties = "Loading properties...";
              this.labels.messages.loadingLevels = "Loading levels...";
              this.labels.messages.pleaseWait = "Please wait.";
              this.labels.messages.pagesWereGenerated = "pages were generated.";
              this.labels.messages.exportProgress = "Export in progress...";
              this.labels.messages.exportError = "Failed to export. An unexpected error occurred.";
              this.labels.messages.cantSaveFile = "Can't save file. <br/>Details: {0}";
              this.labels.messages.cantSaveFileNoDetails = "Can't save file.";
              this.labels.messages.saveReportToFile = 'The report is ready to be saved to file. <br/>Please click the "Save" button to save the report.';
              this.labels.messages.saveReportForSharing = "Please copy the following link to share the report:<br/><u><div style='text-overflow: ellipsis; white-space: nowrap; overflow: hidden; font-style: italic;'>{0}</div></u>";
              this.labels.messages.cantSaveReportForSharing = "Can't save the report for sharing. <br/><br/> {0}";
              this.labels.messages.cantLoadSharedReport = "Can't load the shared report. <br/> {0}";
              this.labels.messages.invalidDataSource = "The data source or catalog is invalid. Please check the connection details. <br/><br/><u><a href='https://www.flexmonster.com/doc/typical-errors/#invalid-datasource' target='_blank'>Read more info about this error</a></u>";
              this.labels.messages.dataStreamError = "A stream error occurred while loading '{0}'<br/><br/><u><a href='https://www.flexmonster.com/doc/typical-errors/#stream-error' target='_blank'>Read more info about this error</a></u>";
              this.labels.messages.unableToOpenFile = "Unable to open the '{0}' file.<br/><br/>Check the following points to resolve the issue:<br/>- make sure the file exists<br/>- make sure the 'Access-Control-Allow-Origin' header is present in the requested resource<br/>- check the browser console for any errors<br/><br/><u><a href='https://www.flexmonster.com/doc/typical-errors/#unable-to-open-file' target='_blank'>Read more info about this error</a></u><br/>";
              this.labels.messages.wrongUniqueName = "The field with the <b>'{0}'</b> uniqueName is not defined.";
              this.labels.messages.wrongFormulaEmpty = "The formula can't be empty.";
              this.labels.messages.wrongFormulaFormat = "Wrong formula format. Please check formula details.";
              this.labels.messages.wrongFormulaRecursive = "The formula for the <b>'{0}'</b> measure calls itself recursively. Please remove recursion from the formula.";
              this.labels.messages.wrongFormulaAggregation = "The <b>'{0}'</b> aggregation in the <b>'{1}'</b> formula is not valid.";
              this.labels.messages.inappropriateFileFormat = "The data file is of inappropriate format.";
              this.labels.messages.invalidJSONdata = "The JSON data is invalid.";
              this.labels.messages.excelCsvChartsExportError = "The Microsoft Excel or CSV export is not available for charts.";
              this.labels.messages.noDataAvailable = "The data source is empty.";
              this.labels.messages.csvHeaderParsingError = "A CSV header parsing error occurred.";
              this.labels.messages.dataWasUpdated = "The data source has been updated on the server. Refresh the report?";
              this.labels.messages.cantConnectToAccelerator = "Can't connect to the data source. Please check if Flexmonster Accelerator is running.";
              this.labels.messages.ocsvIncompatible = "Unable to read the data source. The OCSV file might have been compressed with a newer version. Please update the component to version {0} or newer.";
              this.labels.messages.unknownError = "An unknown error occurred.";
              this.labels.messages.invalidReportFormat = "Invalid report format or access to the file is denied.";
              this.labels.messages.invalidReportFormat2 = "Invalid report format. The 'dataSource' property is required.";
              this.labels.messages.tooManyColumnsInClassicMode = "Too many columns for classic form. The layout was switched to compact form.";
              this.labels.messages.cantExpand = "Some fields can't be expanded. Please narrow down the dataset.";
              this.labels.messages.cantExpandTitle = "The dataset is too large";
              this.labels.messages.errorTextMessage = "</br>Details: '{0}'";
              this.labels.messages.selectFile = "Select a data file to upload.";
              this.labels.messages.flatTableIsNotSupported = "The flat form is not supported for the {0} data source.";
              this.labels.messages.exportFontLoadingError = "Failed to load the font. An unexpected error occurred.";
              this.labels.messages.api = {};
              this.labels.messages.api.incorrectUrl = "Custom data source API: incorrect type of the 'url' parameter.<br/><br/>";
              this.labels.messages.api.errorZeroStatus = "Unable to connect to the custom data source API endpoint '<u><a href='{0}'>{0}</a></u>'.<br/><br/>Check the following points to resolve the issue:<br/>- make sure that the URL is correct<br/>- enable CORS<br/>- check the browser console for any errors";
              this.labels.messages.api.error404Status = "Unable to connect to the custom data source API endpoint '<u><a href='{0}'>{0}</a></u>'.<br/><br/>Check the following points to resolve the issue:<br/>- make sure that the URL is correct<br/>- check that the endpoint is processing POST requests";
              this.labels.messages.api.error400Status = "Custom data source API: request error on '<u><a href='{0}'>{0}</a></u>'.<br/><br/>";
              this.labels.messages.api.error500Status = "Custom data source API: server error on '<u><a href='{0}'>{0}</a></u>'.<br/><br/>";
              this.labels.messages.api.selectRequestError = "Custom data source API: select request.<br/><br/>The format of the '<u><a href='{0}'>{0}</a></u>' endpoint response is incorrect.";
              this.labels.messages.api.selectDrillThroughError = "Custom data source API: select request for drill-through view.<br/><br/>The format of the '<u><a href='{0}'>{0}</a></u>' endpoint response is incorrect.";
              this.labels.messages.api.clientOutdated = "Custom data source API: the flexmonster.js and server API versions are not compatible.<br/><br/>The flexmonster.js file is outdated. Please update flexmonster.js to the minimum required version: {0}";
              this.labels.messages.api.serverOutdated = "Custom data source API: the flexmonster.js and server API versions are not compatible.<br/><br/>The server API is outdated. Please update the '<u><a href='{0}'>{0}</a></u>' server API to the minimum required version: {1}";
              this.labels.messages.api.fieldsRequestError = "Custom data source API: fields request.<br/><br/>The format of the '<u><a href='{0}'>{0}</a></u>' endpoint response is incorrect.";
              this.labels.messages.api.membersRequestError = "Custom data source API: members request.<br/><br/>The format of the '<u><a href='{0}'>{0}</a></u>' endpoint response is incorrect.";
              this.labels.messages.api.noGridChartsMode = "The grid and charts mode is not supported in flat form for the custom data source API.";
              this.labels.messages.api.expandDataError = "Custom data source API: the issue with expanding data.";
              this.labels.messages.api.drillDataError = "Custom data source API: the issue with drilling data.";
              this.labels.messages.elastic = {};
              this.labels.messages.elastic.errorConnection = "Unable to connect to the Elasticsearch endpoint '<u><a href='{0}'>{0}</a></u>'.<br/><br/>Check the following points to resolve the issue:<br/>- make sure that the URL is correct<br/>- enable CORS<br/>- check the browser console for any errors";
              this.labels.buttons = {};
              this.labels.buttons.ok = "OK";
              this.labels.buttons.apply = "Apply";
              this.labels.buttons.copy = "Copy";
              this.labels.buttons.cancel = "Cancel";
              this.labels.buttons.save = "Save";
              this.labels.buttons.select = "Select";
              this.labels.buttons.yes = "Yes";
              this.labels.buttons.no = "No";
              this.labels.kpis = {};
              this.labels.kpis.kpis = "KPIs";
              this.labels.kpis.value = "Value";
              this.labels.kpis.goal = "Goal";
              this.labels.kpis.trend = "Trend";
              this.labels.kpis.status = "Status";
              this.labels.contextMenu = {};
              this.labels.contextMenu.drillThrough = "Drill through";
              this.labels.contextMenu.openFilter = "Open filter";
              this.labels.contextMenu.filterBy = "Filter by <b>{0}</b>";
              this.labels.contextMenu.exclude = "Exclude <b>{0}</b>";
              this.labels.contextMenu.removeField = "Remove field";
              this.labels.contextMenu.removeMeasure = "Remove measure";
              this.labels.contextMenu.collapse = "Collapse";
              this.labels.contextMenu.expand = "Expand";
              this.labels.contextMenu.drillUp = "Drill up";
              this.labels.contextMenu.drillDown = "Drill down";
              this.labels.contextMenu.sortRowDesc = "Sort row descending";
              this.labels.contextMenu.sortRowAsc = "Sort row ascending";
              this.labels.contextMenu.clearSorting = "Clear sorting";
              this.labels.contextMenu.sortColumnDesc = "Sort column descending";
              this.labels.contextMenu.sortColumnAsc = "Sort column ascending";
              this.labels.contextMenu.aggregation = "Aggregation";
              this.labels.contextMenu.properties = "Properties";
              this.labels.contextMenu.showProperty = "Show <b>{0}</b>";
              this.labels.contextMenu.editFormula = "Edit <b>{0}</b>";
              this.labels.contextMenu.moveToRows = "Move to rows";
              this.labels.contextMenu.moveToColumns = "Move to columns";
              this.labels.contextMenu.moveToReportFilters = "Move to report filters";
              this.labels.contextMenu.conditionalFormatting = "Conditional formatting";
              this.labels.contextMenu.numberFormatting = "Number formatting";
              this.labels.contextMenu.hideProperty = "Hide <b>{0}</b>";
              this.labels.contextMenu.groupMembers = "Group members";
              this.labels.contextMenu.ungroupMembers = "Ungroup members";
              this.labels.contextMenu.showSubtotals = "Show subtotals";
              this.labels.contextMenu.hideSubtotals = "Hide subtotals";
              this.labels.date = {};
              this.labels.date.year = "Year";
              this.labels.date.quarter = "Quarter";
              this.labels.date.month = "Month";
              this.labels.date.day = "Day";
              this.labels.quarters = {};
              this.labels.quarters.q1 = "Quarter 1";
              this.labels.quarters.q2 = "Quarter 2";
              this.labels.quarters.q3 = "Quarter 3";
              this.labels.quarters.q4 = "Quarter 4";
              this.labels.months = {};
              this.labels.months.january = "January";
              this.labels.months.february = "February";
              this.labels.months.march = "March";
              this.labels.months.april = "April";
              this.labels.months.may = "May";
              this.labels.months.june = "June";
              this.labels.months.july = "July";
              this.labels.months.august = "August";
              this.labels.months.september = "September";
              this.labels.months.october = "October";
              this.labels.months.november = "November";
              this.labels.months.december = "December";
              this.labels.monthsShort = {};
              this.labels.monthsShort.january = "Jan";
              this.labels.monthsShort.february = "Feb";
              this.labels.monthsShort.march = "Mar";
              this.labels.monthsShort.april = "Apr";
              this.labels.monthsShort.may = "May";
              this.labels.monthsShort.june = "Jun";
              this.labels.monthsShort.july = "Jul";
              this.labels.monthsShort.august = "Aug";
              this.labels.monthsShort.september = "Sep";
              this.labels.monthsShort.october = "Oct";
              this.labels.monthsShort.november = "Nov";
              this.labels.monthsShort.december = "Dec";
              this.labels.weekdays = {};
              this.labels.weekdays.first = "Sunday";
              this.labels.weekdays.second = "Monday";
              this.labels.weekdays.third = "Tuesday";
              this.labels.weekdays.fourth = "Wednesday";
              this.labels.weekdays.fifth = "Thursday";
              this.labels.weekdays.sixth = "Friday";
              this.labels.weekdays.seventh = "Saturday";
              this.labels.weekdaysShort = {};
              this.labels.weekdaysShort.first = "Sun";
              this.labels.weekdaysShort.second = "Mon";
              this.labels.weekdaysShort.third = "Tue";
              this.labels.weekdaysShort.fourth = "Wed";
              this.labels.weekdaysShort.fifth = "Thu";
              this.labels.weekdaysShort.sixth = "Fri";
              this.labels.weekdaysShort.seventh = "Sat";
              this.labels.toolbar = {};
              this.labels.toolbar.connect = "Connect";
              this.labels.toolbar.connect_local_csv = "To local CSV";
              this.labels.toolbar.connect_local_json = "To local JSON";
              this.labels.toolbar.connect_remote_csv = "To remote CSV";
              this.labels.toolbar.connect_remote_csv_mobile = "CSV";
              this.labels.toolbar.connect_remote_json = "To remote JSON";
              this.labels.toolbar.connect_remote_json_mobile = "JSON";
              this.labels.toolbar.connect_olap = "To OLAP (XMLA)";
              this.labels.toolbar.connect_olap_mobile = "OLAP";
              this.labels.toolbar.connect_elastic = "To Elasticsearch";
              this.labels.toolbar.connect_elastic_mobile = "Elastic";
              this.labels.toolbar.open = "Open";
              this.labels.toolbar.local_report = "Local report";
              this.labels.toolbar.remote_report = "Remote report";
              this.labels.toolbar.remote_report_mobile = "Report";
              this.labels.toolbar.save = "Save";
              this.labels.toolbar.share = "Share";
              this.labels.toolbar.grid = "Grid";
              this.labels.toolbar.charts = "Charts";
              this.labels.toolbar.charts_column = "Column";
              this.labels.toolbar.charts_bar_horizontal = "Bar";
              this.labels.toolbar.charts_line = "Line";
              this.labels.toolbar.charts_scatter = "Scatter";
              this.labels.toolbar.charts_pie = "Pie";
              this.labels.toolbar.charts_stacked_column = "Stacked column";
              this.labels.toolbar.charts_column_line = "Column line";
              this.labels.toolbar.charts_multiple = "Multiple values";
              this.labels.toolbar.charts_multiple_disabled = "Mutltiple values do not apply to ";
              this.labels.toolbar.format = "Format";
              this.labels.toolbar.format_cells = "Format cells";
              this.labels.toolbar.format_cells_mobile = "Format";
              this.labels.toolbar.conditional_formatting = "Conditional formatting";
              this.labels.toolbar.conditional_formatting_mobile = "Conditional";
              this.labels.toolbar.options = "Options";
              this.labels.toolbar.fullscreen = "Fullscreen";
              this.labels.toolbar.minimize = "Minimize";
              this.labels.toolbar["export"] = "Export";
              this.labels.toolbar.export_print = "Print";
              this.labels.toolbar.export_html = "To HTML";
              this.labels.toolbar.export_csv = "To CSV";
              this.labels.toolbar.export_excel = "To Excel";
              this.labels.toolbar.export_image = "To Image";
              this.labels.toolbar.export_pdf = "To PDF";
              this.labels.toolbar.fields = "Fields";
              this.labels.toolbar.ok = "OK";
              this.labels.toolbar.apply = "Apply";
              this.labels.toolbar.cancel = "Cancel";
              this.labels.toolbar.value = "Value";
              this.labels.toolbar.open_remote_csv = "Open remote CSV";
              this.labels.toolbar.open_remote_json = "Open remote JSON";
              this.labels.toolbar.olap_connection_tool = "OLAP connection tool";
              this.labels.toolbar.select_data_source = "Select data source";
              this.labels.toolbar.select_catalog = "Select catalog";
              this.labels.toolbar.select_cube = "Select cube";
              this.labels.toolbar.proxy_url = "Proxy URL";
              this.labels.toolbar.data_source_info = "Data source info";
              this.labels.toolbar.catalog = "Catalog";
              this.labels.toolbar.cube = "Cube";
              this.labels.toolbar.connect_elastic_title = "Connect to Elasticsearch";
              this.labels.toolbar.host_url = "Host URL";
              this.labels.toolbar.index_name = "Index";
              this.labels.toolbar.select_index = "Select index";
              this.labels.toolbar.open_remote_report = "Open remote report";
              this.labels.toolbar.choose_value = "Choose value";
              this.labels.toolbar.text_align = "Text align";
              this.labels.toolbar.align_left = "left";
              this.labels.toolbar.align_right = "right";
              this.labels.toolbar.align_center = "center";
              this.labels.toolbar.none = "None";
              this.labels.toolbar.space = "(Space)";
              this.labels.toolbar.thousands_separator = "Thousands separator";
              this.labels.toolbar.decimal_separator = "Decimal separator";
              this.labels.toolbar.decimal_places = "Decimal places";
              this.labels.toolbar.currency_symbol = "Currency symbol";
              this.labels.toolbar.positive_currency_format = "Positive currency format";
              this.labels.toolbar.negative_currency_format = "Negative currency format";
              this.labels.toolbar.negative_number_format = "Negative number format";
              this.labels.toolbar.null_value = "Null value";
              this.labels.toolbar.is_percent = "Format as percent";
              this.labels.toolbar.true_value = "true";
              this.labels.toolbar.false_value = "false";
              this.labels.toolbar.confirm_title = "You have unsaved changes";
              this.labels.toolbar.confirm_message = "The current formatting is not saved yet and won't be applied. </br> Switch the value anyway?";
              this.labels.toolbar.conditional = "Conditional";
              this.labels.toolbar.less_than = "Less than";
              this.labels.toolbar.less_than_or_equal = "Less than or equal to";
              this.labels.toolbar.greater_than = "Greater than";
              this.labels.toolbar.greater_than_or_equal = "Greater than or equal to";
              this.labels.toolbar.equal_to = "Equal to";
              this.labels.toolbar.not_equal_to = "Not equal to";
              this.labels.toolbar.between = "Between";
              this.labels.toolbar.is_empty = "Empty";
              this.labels.toolbar.all_values = "All values";
              this.labels.toolbar.all = "All";
              this.labels.toolbar.default_value = "Default value";
              this.labels.toolbar.and_symbole = "&";
              this.labels.toolbar.no_active_conditions = "There are no active conditions.";
              this.labels.toolbar.add_condition_button = "Add condition";
              this.labels.toolbar.cp_text = "Text";
              this.labels.toolbar.cp_highlight = "Highlight";
              this.labels.toolbar.cp_hex_value = "HEX value";
              this.labels.toolbar.cp_shade = "Shade";
              this.labels.toolbar.layout_options = "Layout options";
              this.labels.toolbar.layout = "Layout";
              this.labels.toolbar.compact_view = "Compact form";
              this.labels.toolbar.classic_view = "Classic form";
              this.labels.toolbar.flat_view = "Flat form";
              this.labels.toolbar.grand_totals = "Grand totals";
              this.labels.toolbar.grand_totals_off = "Do not show grand totals";
              this.labels.toolbar.grand_totals_on = "Show grand totals";
              this.labels.toolbar.grand_totals_on_rows = "Show for rows only";
              this.labels.toolbar.grand_totals_on_columns = "Show for columns only";
              this.labels.toolbar.subtotals = "Subtotals";
              this.labels.toolbar.subtotals_off = "Do not show subtotals";
              this.labels.toolbar.subtotals_on = "Show subtotals";
              this.labels.toolbar.subtotals_on_rows = "Show for rows only";
              this.labels.toolbar.subtotals_on_columns = "Show for columns only";
              this.labels.toolbar.choose_page_orientation = "Choose page orientation";
              this.labels.toolbar.landscape = "Landscape";
              this.labels.toolbar.portrait = "Portrait";
              this.labels.toolbar.tooltips = {};
              this.labels.toolbar.tooltips.add_condition = "Add condition";
              this.labels.toolbar.tooltips.remove_condition = "Remove condition";
              this.labels.toolbar.tooltips.cp_text_color = "Text color";
              this.labels.toolbar.tooltips.condition = "Condition";
              this.labels.toolbar.tooltips.font = "Font";
              this.labels.toolbar.tooltips.font_size = "Font size";
              this.labels.toolbar.fullscreenErrorTitle = "Can't enter fullscreen";
              this.labels.toolbar.fullscreenErrorMessage = "It is not permitted to use the fullscreen feature on this page, either because of Feature Policy configuration or other access control features.<br/><br/><u><a href='https://www.flexmonster.com/doc/typical-errors/#cant-enter-fullscreen' target='_blank'>Read more info about this error</a></u>";
            }
            merge(b) {
              e.v(b) || (this.lga(b.labels, this.labels), this.validate());
            }
            Sa() {
              return this.labels;
            }
            static zb(b) {
              var a = new f();
              a.labels = b;
              return a;
            }
            lga(b, a) {
              if (!e.v(b) && !e.v(a) && b instanceof Object) for (var c in b) {
                var d = b[c];
                e.v(d) || "function" !== typeof d && ("string" === typeof d ? a[c] = d : d instanceof Object && this.lga(d, a[c]));
              }
            }
            validate() {
              e.v(this.labels) || (e.v(this.labels.toolbar.charts_bar_stack) || (this.labels.toolbar.charts_stacked_column = this.labels.toolbar.charts_bar_stack, delete this.labels.toolbar.charts_bar_stack), e.v(this.labels.toolbar.charts_bar_line) || (this.labels.toolbar.charts_column_line = this.labels.toolbar.charts_bar_line, delete this.labels.toolbar.charts_bar_line), e.v(this.labels.toolbar.charts_bar) || (this.labels.toolbar.charts_column = this.labels.toolbar.charts_bar, delete this.labels.toolbar.charts_bar), e.v(this.labels.toolbar.add_condition) || (e.v(this.labels.toolbar.tooltips) && (this.labels.toolbar.tooltips = {}), this.labels.toolbar.tooltips.add_condition = this.labels.toolbar.add_condition, delete this.labels.toolbar.add_condition));
            }
          }
          h.tP = f;
        })(k.B || (k.B = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {}
          f.eo = "load";
          f.XJ = "loading_report";
          f.Ev = "fail";
          f.Wr = "cancel";
          h.Jh = f;
          class b extends v.ga {
            constructor(c) {
              super(f.eo);
              this.hb = c;
            }
          }
          h.o9 = b;
          class a extends v.ga {
            constructor(c) {
              let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              super(f.Ev);
              this.errorMessage = "";
              this.message = c;
              this.errorMessage = d;
            }
          }
          h.WP = a;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor() {
              super();
              this.JSON = "json";
              this.ba = "xml";
              this.mxa = "report.";
              this.VV = null;
            }
            open() {
              this.rr = new h.Una();
              this.rr.N(h.Jh.XJ, () => this.c4());
              this.rr.N(h.Jh.eo, b => this.ZD(b));
              this.rr.N(h.Jh.Ev, b => this.tN(b));
              this.rr.N(h.Jh.Wr, () => this.sN());
              this.rr.load();
            }
            load(b, a) {
              e.Da(!0, k.B.j.rF);
              this.nv = new h.fra();
              this.nv.N(h.Jh.eo, c => this.ZD(c));
              this.nv.N(h.Jh.Ev, c => this.tN(c));
              this.nv.load(u.py.Dta(b), a);
            }
            cancel() {
              this.rr && (this.rr.Td(h.Jh.eo), this.rr.Td(h.Jh.Ev), this.rr = null);
              this.nv && (this.nv.Td(h.Jh.eo), this.nv.Td(h.Jh.Ev), this.nv = null);
              this.Td(h.Jh.eo);
              this.Td(h.Jh.Ev);
              this.Td(h.Jh.XJ);
              this.Td(h.Jh.Wr);
            }
            ZD(b) {
              this.Ea(new h.o9(b.hb));
            }
            tN(b) {
              e.Wa(b.message + b.errorMessage, k.B.j.xa, e.tb.xa);
              this.Ya(h.Jh.Ev);
            }
            c4() {
              this.Ya(h.Jh.XJ);
            }
            sN() {
              this.Ya(h.Jh.Wr);
            }
            save(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              let c = arguments.length > 2 ? arguments[2] : undefined;
              let d = arguments.length > 3 ? arguments[3] : undefined;
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
              let l = arguments.length > 5 ? arguments[5] : undefined;
              this.VV = c;
              c = !1;
              let m = "string" == typeof b ? b : null,
                n = d,
                p = this.JSON;
              d = g;
              let t = null;
              b instanceof Object && (b.hasOwnProperty("filename") && (m = b.filename), b.hasOwnProperty("destination") && (a = b.destination), b.hasOwnProperty("url") && (n = b.url), b.hasOwnProperty("reportType") && (p = b.reportType), b.hasOwnProperty("embedData") && (d = b.embedData), b.hasOwnProperty("requestHeaders") && (t = b.requestHeaders));
              if (null == m || "" == m) m = this.mxa, m = p == this.ba ? m + this.ba : m + this.JSON;
              l.ka.Ba != e.u.i.qa.Xh && l.ka.Ba != e.u.i.qa.Gq || !(l.ka instanceof e.u.local.uP && l.ka.Wd || l.ka instanceof e.u.local.csv.uF && l.ka.Ak || d) || l.options.V("gridType") == e.K.Y.se.Gh || (b = new e.u.local.json.nP(), l.ka = b, c = !0);
              a = null == a ? h.mp.YO : a.toLowerCase();
              switch (a) {
                case h.mp.kY:
                  c ? new e.u.local.json.MX().getData(r => {
                    l.ka.data = r;
                    this.XV(n, m, l, p, t);
                  }) : this.XV(n, m, l, p, t);
                  break;
                case h.mp.dB:
                  c ? new e.u.local.json.MX().getData(r => {
                    l.ka.data = r;
                    this.JC(l.Sa());
                  }) : this.JC(l.Sa());
                  break;
                default:
                  c ? new e.u.local.json.MX().getData(r => {
                    l.ka.data = r;
                    this.JN(m, l, p);
                  }) : this.JN(m, l, p);
              }
            }
            JC() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              null !== this.VV && this.VV(b, a);
            }
            lca(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              switch (b) {
                case this.JSON:
                  b = JSON.stringify(a.Sa(), null, 4);
                  break;
                case this.ba:
                  b = z.ba.Kc(a.gp(), !0);
                  break;
                default:
                  b = JSON.stringify(a.Sa(), null, 4);
              }
              c && (b = encodeURIComponent(b));
              return b;
            }
            JN(b, a, c) {
              const d = [this.lca(c, a)];
              try {
                const g = this;
                e.Wa(k.B.j.Noa, k.B.j.cn, e.tb.cn, [k.B.j.v6, k.B.j.El], [function () {
                  z.Qha(new Blob(d, {
                    type: "text/js;charset=utf-8"
                  }), b);
                  g.JC({
                    report: a.Sa()
                  });
                }, function () {
                  g.JC(null, {
                    message: k.B.j.SX
                  });
                }]);
              } catch (g) {
                e.Wa(k.B.j.SX, k.B.j.xa, e.tb.xa), this.JC(null, {
                  message: k.B.j.SX
                });
              }
            }
            XV(b, a, c, d, g) {
              e.ia(b) && e.Wa("Report cannot be saved. Save report url is empty.", k.B.j.M9, e.tb.xa);
              const l = new z.dra();
              l.data.name = a;
              l.data.report = this.lca(d, c, !0);
              l.data.type = d;
              a = new z.jk();
              a.data = l.toString();
              a.contentType = z.JA.dka;
              a.Br = z.Ft.Dv;
              a.N(v.ga.Qc, m => this.bHa(m, c.Sa()));
              a.N(v.ga.xa, m => this.Sb(m));
              a.Vh(g);
              this.L5 = a;
              a.load(b);
              e.Da(!0, k.B.j.M8);
            }
            static jha(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              const c = {};
              null != b && null != b.target && null != b.target.response && "" != b.target.response && null != b.target.xhr && (c.response = b.target.response, c.status = b.target.xhr.status);
              b.type == v.ga.xa && (c.message = k.B.j.EP);
              b.type != v.ga.xa && null != a && (c.report = a);
              return c;
            }
            bHa(b, a) {
              e.Da(!1);
              this.JC(f.jha(b, a));
            }
            Sb(b) {
              e.Da(!1);
              b = f.jha(b);
              let a = b.hasOwnProperty("response") ? k.Tb.validate(b.response) : "";
              a = 700 < a.length ? a.substr(0, 700) : a;
              e.Wa(e.P.bind(b.message, a), k.B.j.xa, e.tb.xa);
              this.JC(null, b);
            }
            dispose() {
              this.VV = null;
              this.rr && this.rr.dispose();
              this.nv && this.nv.dispose();
              this.L5 && this.L5.dispose();
              this.L5 = this.nv = this.rr = null;
            }
          }
          h.Zpa = f;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.wA = !1;
              this.ka = new e.u.O.PA();
              this.slice = new h.wp();
              this.options = new k.C.Hq();
              this.Ce = [];
              this.Xc = [];
              this.Gm = [];
              this.Jx = new h.Kv();
              this.labels = {};
              this.He = null;
              this.DL = this.version = "";
            }
            static zb(a) {
              if (null == a) return null;
              a = f.jm(a);
              var c = new f();
              c.ka = e.u.O.ut.zb(a.connectionInfo ? a.connectionInfo : a);
              c.options = k.C.Hq.zb(a.options ? a.options : a);
              c.slice = h.wp.zb(a.slice ? a.slice : a, c.ka, c.options.V("gridType") == e.K.Y.se.Gh);
              null != a.formats && a.formats.length && (c.Ce = a.formats);
              null != a.conditions && a.conditions.length && (c.Xc = a.conditions);
              null != a.customFields && (c.Gm = a.customFields);
              c.Jx = h.Kv.zb(a.tableSizes);
              null != a.localization && (c.He = a.localization);
              null != c.He && null != c.He.toolbar && (null != c.He.toolbar.charts_bar_stack && (c.He.toolbar.charts_stacked_column = c.He.toolbar.charts_bar_stack, delete c.He.toolbar.charts_bar_stack), null != c.He.toolbar.charts_bar_line && (c.He.toolbar.charts_column_line = c.He.toolbar.charts_bar_line, delete c.He.toolbar.charts_bar_line), null != c.He.toolbar.charts_bar && (c.He.toolbar.charts_column = c.He.toolbar.charts_bar, delete c.He.toolbar.charts_bar));
              null != a.version && 0 < a.version.length && (c.version = a.version);
              null != a.creationDate && 0 < a.creationDate.length && (c.DL = a.creationDate);
              return c;
            }
            static Ek(a) {
              var c = new f();
              if (null == a) return c;
              c.ka = e.u.O.ut.Ek(a);
              c.slice = h.wp.Ek(a);
              c.options = k.C.Hq.Ek(a);
              c.Ce = f.Yya(a.find("format"));
              c.Xc = f.iwa(a.find("conditions condition"));
              c.Jx = h.Kv.Ek(a);
              c.Gm = f.Zwa(a.find("customFields").children());
              c.labels = f.vDa(a.find("labels"));
              c.He = f.WDa(a.find("params"));
              return c;
            }
            static Zwa(a) {
              for (var c = [], d = 0; d < a.length; d++) {
                var g = {};
                g.name = a[d].attr("name");
                g.value = a[d].attr("value");
                c.push(g);
              }
              return c;
            }
            static Yya(a) {
              for (var c = [], d = 0; d < a.length; d++) {
                var g = f.Vya(a[d]);
                c.push(g);
              }
              return c;
            }
            static Vya(a) {
              var c = {};
              void 0 !== a.attr("name") && (c.name = a.attr("name"));
              0 != a.find("param[name=thousandsSeparator]").length && (c.thousandsSeparator = a.find("param[name=thousandsSeparator]").text());
              0 != a.find("param[name=decimalSeparator]").length && (c.decimalSeparator = a.find("param[name=decimalSeparator]").text());
              0 != a.find("param[name=decimalPlaces]").length && (c.decimalPlaces = parseInt(a.find("param[name=decimalPlaces]").text()));
              0 != a.find("param[name=maxDecimalPlaces]").length && (c.maxDecimalPlaces = parseInt(a.find("param[name=maxDecimalPlaces]").text()));
              0 != a.find("param[name=maxSymbols]").length && (c.maxSymbols = parseInt(a.find("param[name=maxSymbols]").text()));
              0 != a.find("param[name=currencySymbol]").length && (c.currencySymbol = a.find("param[name=currencySymbol]").text());
              0 != a.find("param[name=currencySymbolAlign]").length && (c.currencySymbolAlign = a.find("param[name=currencySymbolAlign]").text());
              0 != a.find("param[name=nullValue]").length && (c.nullValue = a.find("param[name=nullValue]").text());
              0 != a.find("param[name=infinityValue]").length && (c.infinityValue = a.find("param[name=infinityValue]").text());
              0 != a.find("param[name=divideByZeroValue]").length && (c.divideByZeroValue = a.find("param[name=divideByZeroValue]").text());
              0 != a.find("param[name=textAlign]").length && (c.textAlign = a.find("param[name=textAlign]").text());
              0 != a.find("param[name=isPercent]").length && (c.isPercent = e.P.Zc(a.find("param[name=isPercent]").text()));
              return c;
            }
            static vDa(a) {
              var c = {};
              if (0 < a.length) {
                for (var d = a.find("hierarchies").children(), g = 0; g < d.length; g++) {
                  var l = d[g].attr("name");
                  c[l] = d[g].text();
                }
                a = a.find("measures").children();
                for (g = 0; g < a.length; g++) l = a[g].attr("name"), c[l] = a[g].text();
              }
              return c;
            }
            static iwa(a) {
              for (var c = [], d = 0; d < a.length; d++) {
                var g = f.hwa(a[d]);
                c.push(g);
              }
              return c;
            }
            static hwa(a) {
              var c = {};
              c.id = e.P.eM();
              for (var d = 0; d < a.childNodes.length; d++) if (a.childNodes[d] instanceof CDATASection) {
                c.formula = a.childNodes[d].textContent.trim();
                break;
              }
              void 0 !== a.attr("hierarchy") && (c.hierarchy = a.attr("hierarchy"));
              void 0 !== a.attr("measure") && (c.measure = a.attr("measure"));
              void 0 !== a.attr("member") && (c.member = a.attr("member"));
              void 0 !== a.attr("row") && (c.row = a.attr("row"));
              void 0 !== a.attr("column") && (c.column = a.attr("column"));
              void 0 !== a.attr("isTotal") && (c.isTotal = e.P.Zc(a.attr("isTotal")));
              if (0 != a.find("trueStyle").length) try {
                c.format = JSON.parse(a.find("trueStyle").text());
              } catch (g) {
                c.format = a.find("trueStyle").text();
              }
              return c;
            }
            static WDa(a) {
              if (0 != a.find("param[name=localization]").length) return a.find("param[name=localization]").text();
            }
            Sva() {
              for (var a = z.ba.create("<labels/>"), c = e.u.Ma.R().O, d, g = z.ba.create("<hierarchies/>"), l = c.yc(), m = 0; m < l.length; m++) {
                var n = l.ea(m);
                n.V1 && (d = z.ba.create("<label/>").text(n.label), d.attr("name", n.A), g.append(d));
              }
              0 == g.kb() && a.append(g);
              g = z.ba.create("<measures/>");
              c = c.Ca;
              for (m = 0; m < c.length; m++) l = c.ea(m), l.V1 && (d = z.ba.create("<label/>").text(l.label), d.attr("name", l.A), g.append(d));
              0 == g.kb() && a.append(g);
              return a;
            }
            zva() {
              for (var a = z.ba.create("<conditions/>"), c = 0; c < this.Xc.length; c++) {
                var d = this.Xc[c],
                  g = z.ba.create("<condition/>");
                g.append(z.ba.$h(d.formula));
                -1 < d.row && g.attr("row", d.row);
                -1 < d.column && g.attr("column", d.column);
                -1 < d.isTotal && g.attr("isTotal", 1 == d.isTotal ? "true" : "false");
                d.measure && 0 < d.measure.length && g.attr("measure", d.measure);
                d.hierarchy && 0 < d.hierarchy.length && g.attr("hierarchy", d.hierarchy);
                d.member && 0 < d.member.length && g.attr("member", d.member);
                if (d.format && !u.Nc.Jg(d.format)) {
                  var l = z.ba.create("<trueStyle/>");
                  l.append(z.ba.$h(JSON.stringify(d.format)));
                  g.append(l);
                }
                a.append(g);
              }
              return a;
            }
            Mva(a) {
              var c = z.ba.create("<format/>");
              c.attr("name", a.name);
              a.hasOwnProperty("decimalPlaces") && c.append(z.ba.create("<param/>").attr("name", "decimalPlaces").text(a.decimalPlaces));
              a.hasOwnProperty("maxDecimalPlaces") && c.append(z.ba.create("<param/>").attr("name", "maxDecimalPlaces").text(a.maxDecimalPlaces));
              a.hasOwnProperty("maxSymbols") && c.append(z.ba.create("<param/>").attr("name", "maxSymbols").text(a.maxSymbols));
              a.hasOwnProperty("currencySymbolAlign") && c.append(z.ba.create("<param/>").attr("name", "currencySymbolAlign").text(a.currencySymbolAlign));
              a.hasOwnProperty("thousandsSeparator") && c.append(z.ba.create("<param/>").attr("name", "thousandsSeparator").append(z.ba.$h(a.thousandsSeparator)));
              a.hasOwnProperty("decimalSeparator") && c.append(z.ba.create("<param/>").attr("name", "decimalSeparator").append(z.ba.$h(a.decimalSeparator)));
              a.hasOwnProperty("currencySymbol") && c.append(z.ba.create("<param/>").attr("name", "currencySymbol").append(z.ba.$h(a.currencySymbol)));
              a.hasOwnProperty("nullValue") && c.append(z.ba.create("<param/>").attr("name", "nullValue").append(z.ba.$h(a.nullValue)));
              a.hasOwnProperty("infinityValue") && c.append(z.ba.create("<param/>").attr("name", "infinityValue").append(z.ba.$h(a.infinityValue)));
              a.hasOwnProperty("divideByZeroValue") && c.append(z.ba.create("<param/>").attr("name", "divideByZeroValue").append(z.ba.$h(a.divideByZeroValue)));
              a.hasOwnProperty("textAlign") && c.append(z.ba.create("<param/>").attr("name", "textAlign").text(a.textAlign));
              a.hasOwnProperty("isPercent") && c.append(z.ba.create("<param/>").attr("name", "isPercent").text(a.isPercent));
              return c;
            }
            gp() {
              var a = z.ba.create("<config/>"),
                c = this.ka.gp(this.wA);
              0 == c.kb() && a.append(c);
              c = this.slice.gp(this.wA);
              0 == c.kb() && a.append(c);
              c = this.Jx.gp();
              0 == c.kb() && a.append(c);
              c = this.Sva();
              0 == c.kb() && a.append(c);
              c = this.options.gp();
              "string" == typeof this.He && c.append(z.ba.create("<param/>").attr("name", "localization").append(z.ba.$h(this.He)));
              a.append(c);
              c = this.zva();
              0 == c.kb() && a.append(c);
              if (null != this.Ce) {
                c = !k.C.F.UV && 20 < this.Ce.length;
                for (var d = 0; d < this.Ce.length; d++) {
                  var g = this.Ce[d];
                  ("" == g.name || this.slice.In.Bb(g.name) && (!c || this.slice.In.getItem(g.name))) && a.append(this.Mva(g));
                }
              }
              return a;
            }
            Sa() {
              const a = {};
              var c = this.ka.Sa(this.wA);
              u.Nc.Jg(c) || (a.dataSource = c);
              c = this.slice.Sa(this.wA, this.ka.mapping);
              u.Nc.Jg(c) || (a.slice = c);
              c = this.options.Sa();
              u.Nc.Jg(c) || (a.options = c);
              c = this.yva();
              0 < c.length && (a.conditions = c);
              if (null != this.Ce && 0 != this.Ce.length) {
                c = [];
                const d = !k.C.F.UV && 20 < this.Ce.length;
                for (let g = 0; g < this.Ce.length; g++) {
                  const l = this.Ce[g];
                  ("" == l.name || this.slice.In.Bb(l.name) && (!d || this.slice.In.getItem(l.name))) && c.push(l);
                }
                a.formats = c;
              }
              c = this.Jx.Sa(this.slice);
              u.Nc.Jg(c) || (a.tableSizes = c);
              null != this.Gm && 0 != this.Gm.length && (a.customFields = this.Gm);
              null != this.He && "" != this.He && (a.localization = this.He);
              null != this.version && 0 < this.version.length && (a.version = this.version);
              null != this.DL && 0 < this.DL.length && (a.creationDate = this.DL);
              return a;
            }
            yva() {
              for (var a = [], c = 0; c < this.Xc.length; c++) {
                var d = this.Xc[c],
                  g = {};
                g.formula = d.formula;
                -1 < d.row && (g.row = d.row);
                -1 < d.column && (g.column = d.column);
                -1 < d.isTotal && (g.isTotal = 1 == d.isTotal ? !0 : !1);
                d.measure && 0 < d.measure.length && (g.measure = d.measure);
                d.aggregation && 0 < d.aggregation.length && "none" !== d.aggregation && (g.aggregation = d.aggregation);
                d.hierarchy && 0 < d.hierarchy.length && (g.hierarchy = d.hierarchy);
                d.member && 0 < d.member.length && (g.member = d.member);
                d.format && !u.Nc.Jg(d.format) && (g.format = d.format);
                a.push(g);
              }
              return a;
            }
            static jm(a) {
              var c = {};
              if (void 0 == a) return c;
              null != a.customFields && (c.customFields = a.customFields);
              null != a.labels && (c.labels = a.labels);
              null != a.slice && (a.options || (a.options = {}), void 0 == a.options.useOlapFormatting && void 0 != a.slice.useOlapFormatting && (a.options.useOlapFormatting = a.slice.useOlapFormatting), void 0 == a.options.showMemberProperties && void 0 != a.slice.showMemberProperties && (a.options.showMemberProperties = a.slice.showMemberProperties));
              null != a.dataSource && (a.options || (a.options = {}), void 0 == a.options.useOlapFormatting && void 0 != a.dataSource.useOlapFormatting && (a.options.useOlapFormatting = a.dataSource.useOlapFormatting), void 0 == a.options.showMemberProperties && void 0 != a.dataSource.showMemberProperties && (a.options.showMemberProperties = a.dataSource.showMemberProperties), a.slice && void 0 == a.slice.memberProperties && void 0 != a.dataSource.memberProperties && (a.slice.memberProperties = a.dataSource.memberProperties));
              c.connectionInfo = e.u.O.ut.jm(a.connectionInfo ? a.connectionInfo : a);
              c.slice = h.wp.jm(a.slice ? a.slice : a);
              c.options = k.C.Hq.jm(a.options ? a.options : a);
              c.tableSizes = h.Kv.jm(a.tableSizes ? a.tableSizes : a);
              null != a.formats && 0 < a.formats.length && (c.formats = a.formats);
              null != a.conditions && 0 < a.conditions.length && (c.conditions = a.conditions);
              null != a.localization && (c.localization = a.localization);
              null != a.version && 0 < a.version.length && (c.version = a.version);
              null != a.creationDate && 0 < a.creationDate.length && (c.creationDate = a.creationDate);
              return c;
            }
            merge(a) {
              if (e.v(a)) return this;
              a = f.jm(a);
              var c = f.jm(this),
                d;
              for (d in a) a.hasOwnProperty(d) && ("connectionInfo" == d ? e.u.O.ut.zb(a.connectionInfo).kb || (c[d] = a[d]) : "options" == d ? (this.options.SD(a[d]), c[d] = k.C.Hq.jm(this.options)) : c[d] = a[d]);
              return f.zb(c);
            }
            get kb() {
              return e.v(this.ka) || this.ka.kb;
            }
          }
          h.ly = f;
          class b {}
          b.Gm = [];
          h.dJ = b;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            rca(b) {
              b ? this.Ea(new h.o9(b)) : this.Ea(new h.WP(k.B.j.G8));
            }
            Wga(b) {
              try {
                var a = -1;
                if (-1 < (a = b.indexOf("</config>"))) {
                  var c = z.ba.create(b.substring(0, a + 9));
                  return c ? h.ly.Ek(c) : null;
                }
                a = b.indexOf("/**----**");
                return JSON.parse(-1 < a ? b.substring(0, a) : b);
              } catch (d) {
                return console.error(d), null;
              }
            }
            GT(b) {
              var a = new e.Rr(new ArrayBuffer(0), 0, e.Rr.ZI);
              a.KLa(b);
              return a.byteLength;
            }
          }
          h.p9 = f;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b) {
              this.type = e.u.i.rb.NONE;
              this.cfa = !1;
              this.mg = [];
              this.Qj = [];
              this.um = [];
              this.H$ = this.QF = this.$F = !1;
              this.Ac = b;
            }
            clear() {
              this.oC();
              this.gva();
            }
            oC() {
              this.type = e.u.i.rb.NONE;
              this.query = this.measure = null;
              this.um = [];
            }
            gva() {
              this.mg = [];
              this.Qj = [];
              this.QF = this.$F = !1;
              this.RB = [];
              this.kR = !1;
            }
            yj() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              if (b) return this.$F && (this.Qj = [], 0 < this.mg.length && (this.Qj = this.Nba(this.mg)), this.$F = !1), this.Qj;
              this.QF && (this.mg = [], 0 < this.Qj.length && (this.mg = this.Nba(this.Qj)), this.QF = !1);
              return this.mg;
            }
            iKa(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var c = this.Ac.wa.ea(1);
              c = this.Ac.av(c.A);
              a ? (this.E2(b, c) && (b = []), this.QF = !0, this.Qj = b, this.mg = []) : (this.E2(b, c) && (b = []), this.$F = !0, this.mg = b, this.Qj = []);
            }
            get v2() {
              return 0 < this.Qj.length;
            }
            get zh() {
              return this.Ei || this.ei || this.xz || this.Ww || this.LM || this.VT;
            }
            get Ei() {
              return 0 < this.mg.length || 0 < this.Qj.length;
            }
            get Ku() {
              return this.ei || this.xz || this.Ww || this.LM || this.VT;
            }
            get TBa() {
              return this.Ku && 0 < this.um.length;
            }
            get SBa() {
              return this.Ku && 0 < this.Qj.length;
            }
            get ei() {
              return this.type === e.u.i.rb.jo;
            }
            get xz() {
              return this.type === e.u.i.rb.Ta;
            }
            get Ww() {
              return this.type === e.u.i.rb.Zk;
            }
            get LM() {
              return this.type === e.u.i.rb.jb;
            }
            get VT() {
              return this.type === e.u.i.rb.ic;
            }
            get n2() {
              return this.H$;
            }
            set n2(b) {
              this.H$ = b;
            }
            clone() {
              var b = new f(this.Ac);
              b.type = this.type;
              b.measure = this.measure;
              b.query = this.query && this.query.clone ? this.query.clone() : u.Nc.vj(this.query);
              e.v(this.mg) || (b.mg = this.mg.slice());
              e.v(this.um) || (b.um = this.um.slice());
              b.$F = this.$F;
              e.v(this.Qj) || (b.Qj = this.Qj.slice());
              b.QF = this.QF;
              e.v(this.RB) || (b.RB = this.RB.slice());
              b.kR = this.kR;
              return b;
            }
            Sa() {
              var b = {};
              this.Ei && (this.n2 ? this.v2 ? b.exclude = this.Ac.nr(this.yj(!0)) : b.members = this.Ac.nr(this.yj()) : this.yj().length < this.Ac.Wi / 2 ? b.members = this.Ac.nr(this.yj()) : b.exclude = this.Ac.nr(this.yj(!0)));
              !e.v(this.measure) && this.ei && (b.measure = this.measure.Sa());
              !e.v(this.query) && this.Ku && (b.query = this.query.Sa());
              0 < this.um.length && this.Ku && (b.include = this.Ac.nr(this.um));
              return b;
            }
            static zb(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              if (e.v(b)) return null;
              f.sua(b);
              var d = new f(a);
              d.n2 = c;
              d.type = f.txa(b, a);
              d.type == e.u.i.rb.jo ? f.pIa(b, d) : d.type == e.u.i.rb.Ta ? f.QHa(b, d, a.getTimezoneOffset()) : d.type == e.u.i.rb.Zk ? f.bIa(b, d) : d.type == e.u.i.rb.jb ? f.iIa(b, d) : d.type == e.u.i.rb.ic && f.nIa(b, d);
              f.hIa(b, d, a);
              !e.v(b.include) && d.Ku && (d.um = a.Rd ? f.xV(b.include, a) : b.include);
              return d;
            }
            static sua(b) {
              if ("top" == b.type || "bottom" == b.type) b.query = {
                [b.type]: b.quantity
              }, b.type = e.u.i.rb.jo, delete b.quantity;
              !e.v(b.members) && b.negation && (b.exclude = b.members, delete b.members, delete b.negation);
            }
            static txa(b, a) {
              return e.v(b.type) ? e.v(b.query) ? e.u.i.rb.NONE : e.v(b.measure) ? f.tT(a) : e.u.i.rb.jo : e.u.i.rb.validate(b.type);
            }
            static xV(b, a) {
              if (e.v(b)) return null;
              for (var c = [], d = 0; d < b.length; d++) if ("number" == typeof b[d] && -1 < b[d]) c.push(b[d]);else {
                var g = "string" == typeof b[d] ? b[d] : b[d].uniqueName;
                g = e.u.we.Ps(g);
                g = a.sz(g);
                -1 < g && c.push(g);
              }
              return c;
            }
            static tT(b) {
              if (e.u.Ma.R().fa.Ic && e.u.Ma.R().fa.Ba !== e.u.i.qa.Cc && e.u.Ma.R().fa.Ba !== e.u.i.qa.API && e.u.Ma.R().fa.Ba !== e.u.i.qa.hg) return e.u.i.rb.NONE;
              if (e.u.Ma.R().fa.Ba === e.u.i.qa.API || e.u.Ma.R().fa.Ba === e.u.i.qa.hg) return b.type === e.u.i.Fc.qp ? e.u.i.rb.jb : b.type === e.u.i.Fc.Ta ? e.u.i.rb.Ta : e.u.i.rb.Zk;
              var a = b.wa.ea(1).type;
              return b.type === e.u.i.Fc.Ta ? 2 != b.wa.length || a !== e.u.i.ib.Jl && a !== e.u.i.ib.ih && a !== e.u.i.ib.kn ? e.u.i.rb.Ta : e.u.i.rb.NONE : a === e.u.i.ib.$c || e.u.Ma.R().fa.Ic ? e.u.i.rb.Zk : a === e.u.i.ib.jb ? e.u.i.rb.jb : a === e.u.i.ib.ic ? e.u.i.rb.ic : e.u.i.rb.NONE;
            }
            static hIa(b, a, c) {
              const d = b.members || b.exclude;
              if (!e.v(d)) {
                var g = [],
                  l = [];
                b = e.v(b.members);
                for (let m = 0; m < d.length; m++) {
                  if ("number" == typeof d[m] && -1 < d[m]) {
                    g.push(d[m]);
                    continue;
                  }
                  let n = "string" === typeof d[m] ? d[m] : d[m].A;
                  n = e.u.we.Ps(n);
                  l.push(n);
                  const p = c.Fha(n);
                  -1 < p && !g.some(t => t == p) ? g.push(p) : c.Rd && (c.Rd = !1, console.warn("Error in predefined filter or members have not been loaded yet: " + n));
                }
                e.u.Ma.R().fa.Ic && (a.oI = b, a.tl = l.length > g.length ? l : []);
                a.iKa(g, b);
              }
            }
            static pIa(b, a) {
              a.query = h.nm.zb(b.query, e.u.i.rb.jo);
              a.measure = "string" == typeof b.measure ? new h.jh(e.u.we.Wg(b.measure)) : h.jh.zb(b.measure);
              if (e.v(a.query) || e.v(a.measure)) a.type = e.u.i.rb.NONE, a.measure = null;
            }
            static QHa(b, a, c) {
              a.query = h.nm.zb(b.query, e.u.i.rb.Ta, c);
              e.v(a.query) && (a.type = e.u.i.rb.NONE);
            }
            static bIa(b, a) {
              a.query = h.nm.zb(b.query, e.u.i.rb.Zk);
              e.v(a.query) && (a.type = e.u.i.rb.NONE);
            }
            static iIa(b, a) {
              a.query = h.nm.zb(b.query, e.u.i.rb.jb);
              e.v(a.query) && (a.type = e.u.i.rb.NONE);
            }
            static nIa(b, a) {
              a.query = h.nm.zb(b.query, e.u.i.rb.ic);
              e.v(a.query) && (a.type = e.u.i.rb.NONE);
            }
            E2(b, a) {
              return 0 == a.length ? !1 : a.reduce((c, d) => {
                if (b.some(l => l == d)) return c;
                const g = this.Ac.za(d).children;
                return c && this.E2(b, g);
              }, !0);
            }
            Nba(b) {
              const a = new e.kF();
              for (var c = 1; c < this.Ac.Vm; c++) a.add(c);
              for (c = 0; c < b.length; c++) {
                const d = this.Ac.za(b[c]);
                a.delete(d.ordinal);
                this.MV(a, d);
                this.Aha(a, d.parent);
              }
              this.jba(a, this.Ac.wd);
              this.Ac.Ms && this.UIa(a);
              return a.Pc();
            }
            UIa(b) {
              for (let a = b.size - 1; 0 <= a; a--) {
                const c = this.Ac.za(b[a]);
                c.parent || b.delete(c.ordinal);
              }
            }
            jba(b, a) {
              for (let c = 0; c < a.children.length; c++) {
                const d = this.Ac.za(a.children[c]);
                0 < d.children.length && (b.has(d.ordinal) ? b.has(d.children[0]) && this.MV(b, d) : this.jba(b, d));
              }
            }
            MV(b, a) {
              if (a) {
                a = a.children;
                for (var c = 0; c < a.length; c++) b.delete(a[c]), this.MV(b, this.Ac.za(a[c]));
              }
            }
            Aha(b, a) {
              a && !a.dc && (b.delete(a.ordinal), a.parent && this.Aha(b, a.parent));
            }
            zya() {
              var b = null;
              this.xz && (b = this.wya(this.query));
              this.Ww && (b = this.Cya(this.query));
              this.LM && (b = this.Aya(this.query));
              this.VT && (b = this.Dya(this.query));
              if (!e.v(b) && 0 < this.um.length) for (var a = 0; a < this.um.length; a++) b.add(this.um[a]);
              if (!e.v(b) && 0 < this.Qj.length) for (a = 0; a < this.Qj.length; a++) b.delete(this.Qj[a]), this.MV(b, this.Ac.za(this.Qj[a]));
              return b.Pc();
            }
            wya(b) {
              b = b.iS(this.Ac.getTimezoneOffset());
              var a = new e.kF(),
                c = 0 < this.mg.length,
                d = 2 < this.Ac.wa.length,
                g = c ? this.mg : null;
              c && d && (g = this.Zda(g));
              for (var l = c ? g.length : this.Ac.Wi, m = 0; m < l; m++) {
                var n = c ? g[m] : m;
                if (d) {
                  var p = this.Ac.za(n);
                  if (p.level.type === e.u.i.ib.Jl || p.level.type === e.u.i.ib.Ct || p.level.type === e.u.i.ib.ih) continue;
                }
                b.ua === e.u.i.Cb.Un ? this.e3(this.Ac.gD(n).toLowerCase(), b) && a.add(n) : this.lEa(this.Ac.vM(n), b) && a.add(n);
              }
              return a;
            }
            Cya(b) {
              var a = new e.kF(),
                c = this.Ac.lc ? this.Ac.lc.yb : 1,
                d = 0 < this.mg.length,
                g = 2 < this.Ac.wa.length,
                l = d ? this.mg : null;
              d && g && (l = this.Zda(l));
              for (var m = d ? l.length : this.Ac.Wi, n = 0; n < m; n++) {
                var p = d ? l[n] : n;
                1 < c && g && this.Ac.za(d ? l[n] : n).level.yb < c || this.e3(this.Ac.gD(p).toLowerCase(), b) && a.add(p);
              }
              return a;
            }
            Aya(b) {
              for (var a = new e.kF(), c = 0 < this.mg.length, d = c ? this.mg : null, g = c ? d.length : this.Ac.Wi, l = 0; l < g; l++) {
                var m = c ? d[l] : l;
                this.UU(this.Ac.vM(m), b) && a.add(m);
              }
              return a;
            }
            Dya(b) {
              b = b.mwa();
              for (var a = new e.kF(), c = 0 < this.mg.length, d = c ? this.mg : null, g = c ? d.length : this.Ac.Wi, l = 0; l < g; l++) {
                var m = c ? d[l] : l;
                b.ua == e.u.i.Cb.Un ? this.e3(this.Ac.gD(m).toLowerCase(), b) && a.add(m) : this.UU(this.Ac.vM(m), b) && a.add(m);
              }
              return a;
            }
            e3(b, a) {
              if (e.v(a.value)) return !1;
              if (a.ua === e.u.i.Cb.EQUAL) return b === a.value.toLowerCase();
              if (a.ua === e.u.i.Cb.Pf) return b !== a.value.toLowerCase();
              if (a.ua === e.u.i.Cb.UE) return 0 == b.indexOf(a.value.toLowerCase());
              if (a.ua === e.u.i.Cb.ZA) return 0 != b.indexOf(a.value.toLowerCase());
              if (a.ua === e.u.i.Cb.NA) {
                var c = b.lastIndexOf(a.value.toLowerCase());
                return 0 <= c && c + a.value.length == b.length;
              }
              if (a.ua === e.u.i.Cb.aB) return c = b.lastIndexOf(a.value.toLowerCase()), 0 > c || c + a.value.length != b.length;
              if (a.ua === e.u.i.Cb.Un) return c = b.indexOf(a.value.toLowerCase()), 0 <= c;
              if (a.ua === e.u.i.Cb.$A) return c = b.indexOf(a.value.toLowerCase()), 0 > c;
              if (a.ua === e.u.i.Cb.GREATER) return b > a.value.toLowerCase();
              if (a.ua === e.u.i.Cb.Xk) return b >= a.value.toLowerCase();
              if (a.ua === e.u.i.Cb.LESS) return b < a.value.toLowerCase();
              if (a.ua === e.u.i.Cb.$k) return b <= a.value.toLowerCase();
              if (a.ua === e.u.i.Cb.fh) return c = a.value[0].toLowerCase(), a = a.value[1].toLowerCase(), c < a ? b >= c && b <= a : b >= a && b <= c;
              if (a.ua === e.u.i.Cb.Og) return c = a.value[0].toLowerCase(), a = a.value[1].toLowerCase(), c < a ? b < c || b > a : b < a || b > c;
            }
            UU(b, a) {
              if (e.v(a.value)) return !1;
              if (a.ua === e.u.i.Pg.EQUAL) return b === a.value;
              if (a.ua === e.u.i.Pg.Pf) return b !== a.value;
              if (a.ua === e.u.i.Pg.GREATER) return b > a.value;
              if (a.ua === e.u.i.Pg.Xk) return b >= a.value;
              if (a.ua === e.u.i.Pg.LESS) return b < a.value;
              if (a.ua === e.u.i.Pg.$k) return b <= a.value;
              if (a.ua === e.u.i.Pg.fh) {
                var c = Math.min(a.value[0], a.value[1]);
                a = Math.max(a.value[0], a.value[1]);
                return b >= c && b <= a;
              }
              if (a.ua === e.u.i.Pg.Og) return c = Math.min(a.value[0], a.value[1]), a = Math.max(a.value[0], a.value[1]), b < c || b > a;
            }
            lEa(b, a) {
              if (e.v(a.value)) return !1;
              if (a.ua === e.u.i.bc.SE) {
                var c = a.value.getTime();
                return b < c;
              }
              if (a.ua === e.u.i.bc.TE) return c = a.value.getTime(), b < c + 864E5;
              if (a.ua === e.u.i.bc.PE) return c = a.value.getTime(), b >= c + 864E5;
              if (a.ua === e.u.i.bc.QE) return c = a.value.getTime(), b >= c;
              if (a.ua === e.u.i.bc.fh) return c = Math.min(a.value[0].getTime(), a.value[1].getTime()), a = Math.max(a.value[0].getTime(), a.value[1].getTime()), b >= c && b <= a;
              if (a.ua === e.u.i.bc.Og) return c = Math.min(a.value[0].getTime(), a.value[1].getTime()), a = Math.max(a.value[0].getTime(), a.value[1].getTime()), b < c || b > a;
            }
            set tl(b) {
              this.RB = b;
            }
            get tl() {
              null == this.RB && (this.RB = []);
              return this.RB;
            }
            get oI() {
              return this.kR;
            }
            set oI(b) {
              this.kR = b;
            }
            tw() {
              if (0 < this.tl.length) {
                let c = e.u.Ma.R().fa;
                for (var b = 0; b < this.tl.length; b++) {
                  if (c.Ic && !1 === c.Cm || this.Ac.type !== e.u.i.Fc.Ta || this.Ac.wa.ea(1).type !== e.u.i.ib.Ta && this.Ac.wa.ea(1).type !== e.u.i.ib.Lc) var a = this.Ac.Ib(this.tl[b]);else {
                    if (k.C.F.ir && "null" === this.tl[b]) a = null;else if (8 > this.tl[b].length || /\D+/.test(this.tl[b].slice(1))) {
                      a = this.Ac.wa.ea(1).type === e.u.i.ib.Lc ? k.C.F.zk : k.C.F.Lp;
                      a = this.Ac.mapping.La(this.Ac.A, "format", a);
                      const d = new e.gh(this.tl[b], {
                        Gy: !1,
                        format: a
                      });
                      d.uh(u.Eh.qg(a));
                      a = d.getTime();
                    } else a = parseInt(this.tl[b]);
                    a = isNaN(a) ? this.Ac.Ib(this.tl[b]) : this.Ac.Du(a);
                  }
                  null != a && (this.oI ? this.Qj.push(a.ordinal) : this.mg.push(a.ordinal));
                }
                this.tl = [];
              }
              if (this.um || 0 < this.um.length) this.um = f.xV(this.um, this.Ac);
            }
            Zda(b) {
              for (var a = [], c = 0; c < b.length; c++) a.push(b[c]), this.qha(a, this.Ac.za(b[c]));
              return a;
            }
            qha(b, a) {
              if (a && a.children && 0 < a.children.length) {
                a = a.children;
                for (var c = 0; c < a.length; c++) b.push(a[c]), this.qha(b, this.Ac.za(a[c]));
              }
            }
          }
          h.TA = f;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              this.ua = b;
              this.value = a;
            }
            clone() {
              return new f(this.ua, this.value);
            }
            static zb(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              if (e.v(b)) return null;
              let d = null;
              a == e.u.i.rb.jo ? (e.u.i.Vb.si.some(g => {
                if (!e.v(b[g])) return d = new f(g, parseFloat(b[g])), !0;
              }), e.u.i.Vb.Qf.some(g => {
                if (!e.v(b[g])) return d = new f(g, [parseFloat(b[g][0]), parseFloat(b[g][1])]), !0;
              })) : a == e.u.i.rb.Ta ? (e.u.i.bc.si.some(g => {
                if (!e.v(b[g])) {
                  const l = new e.gh(b[g]);
                  l.uh(c, !1);
                  d = new f(g, l);
                  return !0;
                }
              }), e.u.i.bc.Qf.some(g => {
                if (!e.v(b[g])) {
                  const l = new e.gh(b[g][0]);
                  l.uh(c, !1);
                  const m = new e.gh(b[g][1]);
                  m.uh(c, !1);
                  if (l && m) return d = new f(g, l.getTime() < m.getTime() ? [l, m] : [m, l]), d.value[1] = d.value[1].I5("day", k.C.F.Lw), !0;
                }
              }), e.u.i.bc.jy.some(g => {
                if (e.u.i.LA.ah(b[g])) return d = new f(g, b[g].toLowerCase()), !0;
              }), e.v(b[e.u.i.Cb.Un]) || (d = new f(e.u.i.Cb.Un, b[e.u.i.Cb.Un]))) : a == e.u.i.rb.Zk ? (e.u.i.Cb.si.some(g => {
                if (!e.v(b[g])) return d = new f(g, b[g]), !0;
              }), e.u.i.Cb.Qf.some(g => {
                if (!e.v(b[g])) return d = new f(g, [b[g][0], b[g][1]]), !0;
              })) : a == e.u.i.rb.jb ? (e.u.i.Pg.si.some(g => {
                if (!e.v(b[g])) return d = new f(g, parseFloat(b[g])), !0;
              }), e.u.i.Pg.Qf.some(g => {
                if (!e.v(b[g])) return d = new f(g, [parseFloat(b[g][0]), parseFloat(b[g][1])]), !0;
              })) : a == e.u.i.rb.ic && (e.u.i.bl.si.some(g => {
                if (!e.v(b[g])) return d = new f(g, b[g]), !0;
              }), e.u.i.bl.Qf.some(g => {
                if (!e.v(b[g])) return d = new f(g, [b[g][0], b[g][1]]), !0;
              }), e.v(b[e.u.i.Cb.Un]) || (d = new f(e.u.i.Cb.Un, b[e.u.i.Cb.Un])));
              return d;
            }
            Sa() {
              let b = this.value;
              b instanceof e.gh && (b = b.format("yyyy-MM-dd"));
              Array.isArray(b) && b[0] instanceof e.gh && (b = [b[0].format("yyyy-MM-dd"), b[1].format("yyyy-MM-dd")]);
              return {
                [this.ua]: b
              };
            }
            iS(b) {
              if (this.ua == e.u.i.bc.EQUAL || this.ua == e.u.i.bc.Pf) {
                b = this.value.clone().Pn();
                var a = this.value.clone().pA();
                return new f(this.ua == e.u.i.bc.Pf ? e.u.i.bc.Og : e.u.i.bc.fh, [b, a]);
              }
              return 0 <= e.u.i.bc.jy.indexOf(this.ua) && e.u.i.LA.ah(this.value) ? (b = new e.gh().uh(b), this.ua == e.u.i.bc.HO ? b.M5(this.value, k.C.F.Lw) : this.ua == e.u.i.bc.LP ? (b.I5(this.value, k.C.F.Lw), b.setMilliseconds(1E3)) : this.ua == e.u.i.bc.qP && (b.M5(this.value, k.C.F.Lw), b.setMilliseconds(-1), b.M5(this.value, k.C.F.Lw)), a = b.clone().I5(this.value, k.C.F.Lw), new f(e.u.i.bc.fh, [b, a])) : this;
            }
            mwa() {
              return 0 <= e.u.i.bl.si.indexOf(this.ua) ? new f(this.ua, this.K5(this.value)) : 0 <= e.u.i.bl.Qf.indexOf(this.ua) ? new f(this.ua, [this.K5(this.value[0]), this.K5(this.value[1])]) : this;
            }
            K5(b) {
              const a = b.match(/[s|m|h|d]$/);
              if (!e.v(a)) {
                const c = parseFloat(b.substr(0, b.length - 1));
                if ("s" == a[0]) return c;
                if ("m" == a[0]) return 60 * c;
                if ("h" == a[0]) return 3600 * c;
                if ("d" == a[0]) return 86400 * c;
              }
              return parseInt(b);
            }
          }
          h.nm = f;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.p9 {
            constructor() {
              super();
              this.A0 = "\x3c!--";
              this.Gca = "/**----**";
            }
            load(b, a) {
              this.url = b;
              this.oa = new z.jk();
              this.oa.dataType = z.KA.kB;
              this.oa.N(v.ga.te, c => this.nq(c));
              this.oa.N(v.ga.Qc, () => this.Fj());
              this.oa.N(v.ga.xa, () => this.Sb());
              this.oa.Vh(a);
              this.oa.load(b);
            }
            nq() {
              var b = 0;
              null != this.oa && -1 < (b = this.oa.response.indexOf("</config>")) && b + this.Gca.length + 1 < this.oa.response.length && this.Fj();
            }
            Fj() {
              if (null != this.oa) {
                this.oa.Td(v.ga.Qc);
                var b = this.Wga(this.oa.response);
                if (b instanceof h.ly) {
                  if (b.ka instanceof e.u.local.csv.uF && 1 == b.ka.Ak) {
                    var a = b.ka;
                    a.filename = this.oa.url;
                    a.embeddedDataOffset = this.GT(this.oa.response.substring(0, this.oa.response.indexOf("</config>") + 9) + "\n");
                    var c = this.oa.response.indexOf(this.A0);
                    a.isOCSV2Data = this.oa.response.substring(c, c + this.A0.length) == this.A0;
                    b.ka = a;
                  }
                } else e.v(b) || e.v(b.dataSource) ? k.C.F.a6 && this.Sb(k.B.j.H8) : 1 == b.dataSource.embedded && (b.dataSource.filename = this.oa.url, b.dataSource.embeddedDataOffset = this.GT(this.oa.response.substring(0, this.oa.response.indexOf(this.Gca))), b.dataSource.isOCSV2Data = !0);
                this.rca(b);
                this.dispose();
              }
            }
            Sb() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              this.oa.Td(v.ga.te);
              this.oa.Td(v.ga.Qc);
              this.oa.Td(v.ga.xa);
              if (e.ia(b)) {
                var a = "";
                null != this.oa && null != this.oa.response && "" != this.oa.response && (a = k.Tb.validate(this.oa.response), a = 700 < a.length ? a.substr(0, 700) : a, a = e.P.bind(k.B.j.FP, a).replace(/'/g, ""));
                b = k.Tb.valid(this.url) ? this.url : k.Tb.validate(this.url);
                b = e.P.bind(k.B.j.LJ, b);
                this.Ea(new h.WP(b, a));
              } else this.Ea(new h.WP(b));
              this.dispose();
            }
            dispose() {
              null != this.oa && (this.oa.Td(), this.oa.dispose(), this.oa = null);
            }
          }
          h.fra = f;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.p9 {
            constructor() {
              super();
            }
            load() {
              this.file = new z.V7();
              this.file.N(v.ga.ho, () => this.iHa());
              this.file.N(v.ga.Qc, () => this.Fj());
              this.file.N(v.ga.aX, () => this.$U());
              this.file.N(v.ga.xa, () => this.Sb());
              this.file.bba([".json", ".js"]);
            }
            iHa() {
              null != this.file && this.file.load(z.Ypa.ARRAY_BUFFER);
            }
            Fj() {
              try {
                this.xxa();
                var b = new e.Rr(this.file.response, 0, e.Rr.ZI),
                  a = b.IV(b.byteLength),
                  c = this.Wga(a);
                if (c instanceof h.ly) {
                  if (c.ka instanceof e.u.local.csv.uF && 1 == c.ka.Ak) {
                    var d = c.ka;
                    d.Hca = this.file.response;
                    d.z0 = this.GT(a.substring(0, a.indexOf("</config>") + 9) + "\n");
                    c.ka = d;
                  }
                } else e.v(c) || e.v(c.dataSource) ? k.C.F.a6 && this.Sb(k.B.j.H8) : 1 == c.dataSource.Ak && (c.dataSource.embeddedDataToLoad = this.file.response, c.dataSource.embeddedDataOffset = this.GT(a.substring(0, a.indexOf("/**----**"))));
                this.rca(c);
                this.dispose();
              } catch (g) {
                console.error(g), this.Sb();
              }
            }
            Sb() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              e.ia(b) && (b = e.P.bind(k.B.j.LJ, ""));
              this.Ea(new h.WP(b));
              this.dispose();
            }
            xxa() {
              this.Ya(h.Jh.XJ);
            }
            $U() {
              this.Ya(h.Jh.Wr);
              this.dispose();
            }
            dispose() {
              null != this.file && (this.file.Td(), this.file.dispose(), this.file = null);
            }
          }
          h.Una = f;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static tA(b) {
              return b == f.YO || b == f.kY || b == f.s6 || b == f.dB;
            }
          }
          f.YO = "file";
          f.kY = "server";
          f.s6 = "binary";
          f.dB = "plain";
          h.mp = f;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(a, c, d) {
              this.lk = this.A = "";
              this.index = -1;
              this.label = "";
              void 0 != a && (this.A = a);
              void 0 != c && (this.aa = c);
              void 0 != d && (this.index = d);
            }
            get aa() {
              return this.lk;
            }
            set aa(a) {
              e.u.i.da.tA(a) && (this.lk = a);
            }
            static zb(a) {
              if (null == a) return null;
              var c = new f();
              void 0 != a.uniqueName && (c.A = a.uniqueName);
              void 0 != a.aggregation && (c.aa = a.aggregation);
              void 0 != a.index && (c.index = a.index);
              void 0 != a.label && (c.label = a.label);
              return c;
            }
            Sa() {
              var a = {};
              a.uniqueName = this.A;
              "" !== this.aa && (a.aggregation = this.aa);
              return a;
            }
          }
          h.jh = f;
          class b {
            constructor() {
              this.rows = [];
              this.Ka = [];
              this.ob = [];
              this.Ca = [];
              this.bk = {};
              this.Tj = {};
              this.Jw = [];
              this.Iw = [];
              this.Gw = [];
              this.Fw = [];
              this.Tf = this.gf = this.jf = this.kf = !1;
              this.Tg = [];
              this.Ug = null;
              this.bd = [];
              this.Ej = {};
              this.In = new e.ub();
            }
            static mga(a) {
              if (0 <= b.fd(a.rows)) {
                var c = b.fd(a.Ka);
                0 <= c && (a.Ka[c] = a.Ka[0], a.Ka.shift());
              }
            }
            static fd(a) {
              for (var c = 0; c < a.length; c++) if ("[Measures]" == a[c].uniqueName) return c;
              return -1;
            }
            static HV(a) {
              for (var c = [], d, g = 0; g < a.length; g++) {
                d = [];
                d.push(null != a[g].measure ? a[g].measure : "");
                if (null != a[g].tuple) for (var l = 0; l < a[g].tuple.length; l++) d.push(a[g].tuple[l]);
                c.push(d);
              }
              return c;
            }
            static GV(a) {
              for (var c = [], d, g = 0; g < a.length; g++) {
                d = [];
                d.push(null != a[g].level ? a[g].level : "");
                d.push(null != a[g].measure ? a[g].measure : -1);
                if (null != a[g].tuple) {
                  d.push(a[g].tuple[a[g].tuple.length - 1]);
                  for (var l = 0; l < a[g].tuple.length; l++) d.push(a[g].tuple[l]);
                }
                c.push(d);
              }
              return c;
            }
            static UR(a, c) {
              if (!e.v(c) && !c.kb) for (let g = 0; g < a.length; g++) {
                var d = a[g].uniqueName;
                let l = c.La(d, "caption");
                e.v(l) || delete a[g].caption;
                d = c.La(d, "aggregations");
                e.v(d) || delete a[g].availableAggregations;
              }
            }
            static zb(a) {
              let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              if (null == a) return null;
              a instanceof b || (a = b.jm(a));
              var d = new b();
              null != a.measures && a.measures.length && (d.Ca = a.measures);
              null == c && (c = k.Va.R().Fa.fa);
              null != a.pages && a.pages.length && (d.ob = b.Y1(a.pages));
              null != a.columns && a.columns.length && (d.Ka = b.Y1(a.columns));
              null != a.rows && a.rows.length && (d.rows = b.Y1(a.rows));
              null != a.flatOrder && a.flatOrder.length && (d.Tg = a.flatOrder);
              null != a.flatSort && a.flatSort.length && (d.Ug = a.flatSort);
              null != a.drillThrough && a.drillThrough.length && (d.bd = a.drillThrough);
              if (void 0 !== a.memberProperties && Array.isArray(a.memberProperties)) for (let g = 0; g < a.memberProperties.length; g++) {
                const l = a.memberProperties[g];
                null != l && (e.v(d.Ej) && (d.Ej = {}), d.Ej[l.levelName] = l.properties);
              }
              b.mga(d);
              b.UR(d.Ca, c.mapping);
              b.UR(d.ob, c.mapping);
              b.UR(d.Ka, c.mapping);
              b.UR(d.rows, c.mapping);
              null != a.rowSorting && (d.bk = a.rowSorting);
              null != a.columnSorting && (d.Tj = a.columnSorting);
              null != a.expandAll && (d.kf = d.jf = a.expandAll);
              null != a.expandAllRows && (d.kf = a.expandAllRows);
              null != a.expandAllColumns && (d.jf = a.expandAllColumns);
              null != a.expandedRows && a.expandedRows.length && (d.Jw = a.expandedRows);
              null != a.expandedColumns && a.expandedColumns.length && (d.Iw = a.expandedColumns);
              null != a.drillAll && (d.gf = d.Tf = a.drillAll);
              null != a.drillAllRows && (d.gf = a.drillAllRows);
              null != a.drillAllColumns && (d.Tf = a.drillAllColumns);
              null != a.drilledRows && a.drilledRows.length && (d.Gw = a.drilledRows);
              null != a.drilledColumns && a.drilledColumns.length && (d.Fw = a.drilledColumns);
              return d;
            }
            static Y1(a) {
              for (var c = [], d = 0; d < a.length; d++) {
                c[d] = {};
                for (var g in a[d]) "sort" == g ? c[d].sortName = a[d].sort : c[d][g] = a[d][g];
              }
              return c;
            }
            static Ek(a) {
              var c = new b(),
                d = a.find("defaultSlice axes axis[name=rows]");
              c.rows = b.Z1(d.find("hierarchy"));
              c.bk = b.Sia(d.find("sort"));
              c.Jw = b.Pca(d.find("expanded tuple"));
              c.Gw = b.Cca(d.find("drilled tuple"));
              d = a.find("defaultSlice axes axis[name=columns]");
              c.Ka = b.Z1(d.find("hierarchy"));
              c.Tj = b.Sia(d.find("sort"));
              c.Iw = b.Pca(d.find("expanded tuple"));
              c.Fw = b.Cca(d.find("drilled tuple"));
              b.mga(c);
              d = a.find("defaultSlice axes axis[name=pages]");
              c.ob = b.Z1(d.find("hierarchy"));
              c.Ca = b.kEa(a.find("defaultSlice measures measure"));
              c.Tg = b.Mya(a.find("defaultSlice flatOrder hierarchyName"));
              d = a.find("params");
              0 != d.find("param[name=expandAll]").length && (c.kf = c.jf = e.P.Zc(d.find("param[name=expandAll]").text()));
              0 != d.find("param[name=drillAll]").length && (c.gf = c.Tf = e.P.Zc(d.find("param[name=drillAll]").text()));
              a = a.find("defaultSlice");
              0 != a.find("expandAll").length && (c.kf = c.jf = e.P.Zc(a.find("expandAll").text()));
              0 != a.find("drillAll").length && (c.gf = c.Tf = e.P.Zc(a.find("drillAll").text()));
              return c;
            }
            static Z1(a) {
              for (var c = [], d = 0; d < a.length; d++) {
                var g = b.YBa(a[d]);
                c.push(g);
              }
              return c;
            }
            static YBa(a) {
              var c = {};
              c.dimensionName = a.find("dimensionName").text().trim();
              c.uniqueName = a.find("hierarchyName").text().trim();
              0 < a.find("levelName").length && (c.activeLevelName = a.find("levelName").text().trim());
              void 0 !== a.attr("sort") && (c.sortName = a.attr("sort"));
              void 0 !== a.attr("sortAs") && (c.sortAs = a.attr("sortAs"));
              var d = a.find("filter");
              if (0 < d.length) {
                for (var g = [], l = d.find("member"), m = 0; m < l.length; m++) {
                  var n = l[m].text().trim();
                  g.push(n);
                }
                m = void 0 !== d.attr("negation") ? e.P.Zc(d.attr("negation")) : !1;
                l = void 0 !== d.attr("type") ? d.attr("type") : e.u.i.rb.NONE;
                n = void 0 !== d.attr("quantity") ? parseInt(d.attr("quantity")) : -1;
                var p = void 0 !== d.attr("measure") ? d.attr("measure") : "";
                if (l != e.u.i.rb.NONE || 0 < g.length) c.filter = {};
                0 < g.length && (c.filter.members = g, c.filter.negation = m);
                l != e.u.i.rb.NONE && (c.filter.type = l, c.filter.quantity = n, c.filter.measure = p);
              }
              m = d.find("properties");
              if (0 < m.length) for (d = m.find("property"), c.predefinedProperties = [], m = 0; m < d.length; m++) g = d[m].find("propertyName").text(), l = d[m].find("levelName").text(), null == c.predefinedProperties[l] && (c.predefinedProperties[l] = []), c.predefinedProperties[l].push(g);
              d = [];
              l = a.find("sort member");
              for (m = 0; m < l.length; m++) d.push(l[m].text());
              c.customSorting = d;
              void 0 !== a.attr("filterEnabled") && (c.filterEnabled = "false" != a.attr("filterEnabled"));
              d = {};
              a = a.find("group");
              for (m = 0; m < a.length; m++) for (g = a[m].attr("name"), d[g] = [], l = a[m].find("member"), n = 0; n < l.length; n++) d[g].push(l[m].text());
              c.groups = d;
              return c;
            }
            static Sia(a) {
              var c = {};
              0 < a.length && (c.type = a.text(), c.tuple = void 0 !== a.attr("tuple") ? a.attr("tuple").split(",") : [], c.measure = new f(a.attr("measure")), void 0 !== a.attr("measureAggregation") && (c.measure.aa = a.attr("measureAggregation")));
              return c;
            }
            static Pca(a) {
              var c = [];
              if (0 < a.length) for (var d = 0; d < a.length; d++) {
                var g = a[d],
                  l = g.text().split(",");
                if (isNaN(parseInt(l[0]))) {
                  var m = void 0 !== g.attr("measure") ? new f(g.attr("measure")) : null;
                  void 0 !== g.attr("measureAggregation") && (m.aa = g.attr("measureAggregation"));
                  l.unshift(m);
                } else m = void 0 !== g.attr("measure") ? parseInt(g.attr("measure")) : -1, isNaN(m) && (m = -1), l.unshift(m);
                c.push(l);
              }
              return c;
            }
            static Cca(a) {
              var c = [];
              if (0 < a.length) for (var d = 0; d < a.length; d++) {
                var g = a[d],
                  l = b.cLa(g.text().split(","));
                var m = -1;
                void 0 !== g.attr("memberName") ? m = g.attr("memberName") : void 0 !== g.attr("member") && (m = parseInt(g.attr("member")));
                l.unshift(m);
                isNaN(parseInt(l[0])) ? (m = void 0 !== g.attr("measure") ? new f(g.attr("measure")) : null, void 0 !== g.attr("measureAggregation") && (m.aa = g.attr("measureAggregation")), l.unshift(m)) : (m = void 0 !== g.attr("measure") ? parseInt(g.attr("measure")) : -1, isNaN(m) && (m = -1), l.unshift(m));
                void 0 !== g.attr("levelName") && (g = g.attr("levelName"), l.unshift(g));
                c.push(l);
              }
              return c;
            }
            static cLa(a) {
              for (var c = 0; c < a.length; c++) a[c] = parseInt(a[c]);
              return a;
            }
            static kEa(a) {
              for (var c = [], d = 0; d < a.length; d++) {
                var g = b.gEa(a[d]);
                c.push(g);
              }
              return c;
            }
            static Mya(a) {
              for (var c = [], d = 0; d < a.length; d++) c.push(a[d].text());
              return c;
            }
            static gEa(a) {
              var c = {};
              c.uniqueName = a.text().trim();
              void 0 !== a.attr("calculated") && 0 < a.text().length && (c.uniqueName = a.attr("uniqueName"), c.formula = a.text(), c.individual = void 0 !== a.attr("individual") ? e.P.Zc(a.attr("individual")) : !1);
              void 0 !== a.attr("availableAggregations") && (c.availableAggregations = a.attr("availableAggregations").split(","));
              void 0 !== a.attr("aggregation") && (c.aggregation = a.attr("aggregation"));
              void 0 !== a.attr("caption") && (c.caption = a.attr("caption"));
              void 0 !== a.attr("grandTotalCaption") && (c.grandTotalCaption = a.attr("grandTotalCaption"));
              void 0 !== a.attr("format") && (c.format = a.attr("format"));
              c.active = void 0 !== a.attr("active") ? e.P.Zc(a.attr("active")) : !0;
              return c;
            }
            gp() {
              let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              var c = z.ba.create("<defaultSlice/>"),
                d = z.ba.create("<axes/>"),
                g = z.ba.create("<axis/>");
              g.attr("name", "rows");
              for (var l = 0; l < this.rows.length; l++) g.append(this.d2(this.rows[l], a));
              null != this.bk && null != this.bk.type && this.bk.type != e.u.i.Aa.ed && (l = z.ba.create("<sort/>").text(this.bk.type), l.attr("tuple", this.bk.tuple.join(",")), l.attr("measure", this.bk.measure.A), "" != this.bk.measure.aa && l.attr("measureAggregation", this.bk.measure.aa), g.append(l));
              if (0 < this.Jw.length) {
                var m = z.ba.create("<expanded/>");
                for (l = 0; l < this.Jw.length; l++) {
                  var n = this.Jw[l].slice(0);
                  var p = n.shift();
                  0 != n.length && (n = z.ba.create("<tuple/>").append(z.ba.$h(n.toString())), p && (n.attr("measure", p.A), "" != p.aa && n.attr("measureAggregation", p.aa)), m.append(n));
                }
                g.append(m);
              }
              if (0 < this.Gw.length) {
                var t = z.ba.create("<drilled/>");
                for (l = 0; l < this.Gw.length; l++) {
                  n = this.Gw[l].slice(0);
                  m = "string" == typeof n[0] ? n.shift() : "";
                  p = n.shift();
                  var r = n.shift();
                  null != r && 0 != n.length && (n = z.ba.create("<tuple/>").text(n.toString()), p && (n.attr("measure", p.A), "" != p.aa && n.attr("measureAggregation", p.aa)), 0 < r.length && n.attr("memberName", r), 0 < m.length && n.attr("levelName", m), t.append(n));
                }
                g.append(t);
              }
              m = z.ba.create("<axis/>");
              m.attr("name", "columns");
              for (l = 0; l < this.Ka.length; l++) m.append(this.d2(this.Ka[l], a));
              null != this.Tj && this.Tj.type && this.Tj.type != e.u.i.Aa.ed && (l = z.ba.create("<sort/>").text(this.Tj.type), l.attr("tuple", this.Tj.tuple.join(",")), l.attr("measure", this.Tj.measure.A), "" != this.Tj.measure.aa && l.attr("measureAggregation", this.Tj.measure.aa), m.append(l));
              if (0 < this.Iw.length) {
                r = z.ba.create("<expanded/>");
                for (l = 0; l < this.Iw.length; l++) n = this.Iw[l].slice(0), p = n.shift(), 0 != n.length && (n = z.ba.create("<tuple/>").append(z.ba.$h(n.toString())), p && (n.attr("measure", p.A), "" != p.aa && n.attr("measureAggregation", p.aa)), r.append(n));
                m.append(r);
              }
              if (0 < this.Fw.length) {
                t = z.ba.create("<drilled/>");
                for (l = 0; l < this.Fw.length; l++) n = this.Fw[l].slice(0), p = n.shift(), r = n.shift(), null != r && 0 != n.length && (n = z.ba.create("<tuple/>").text(n.toString()), p && (n.attr("measure", p.A), "" != p.aa && n.attr("measureAggregation", p.aa)), 0 < r.length && n.attr("memberName", r), t.append(n));
                m.append(t);
              }
              p = z.ba.create("<axis/>");
              p.attr("name", "pages");
              for (l = 0; l < this.ob.length; l++) p.append(this.d2(this.ob[l], a));
              this.In.clear();
              n = z.ba.create("<measures/>");
              for (l = 0; l < this.Ca.length; l++) r = this.Ca[l], t = z.ba.create("<measure/>").text(r.A), null != r.De && "" != r.De ? (t = z.ba.create("<measure/>").append(z.ba.$h(r.De)), r.Gk && t.attr("individual", "true"), t.attr("caption", r.caption)) : (a || r.aa != e.u.i.da.NONE) && t.attr("aggregation", r.aa), (a || 0 == r.active) && t.attr("active", r.active), null != r.format && "" != r.format && (t.attr("format", r.format), r.active ? this.In.Ua(r.format, !0) : this.In.Bb(r.format) && !0 === this.In.getItem(r.format) || this.In.Ua(r.format, !1)), null != r.Wc && 0 < r.Wc.length && t.attr("availableAggregations", r.Wc.join(",")), n.append(t);
              0 == g.kb() && d.append(g);
              0 == m.kb() && d.append(m);
              0 == p.kb() && d.append(p);
              0 == d.kb() && c.append(d);
              0 == n.kb() && c.append(n);
              if (0 < this.Tg.length) {
                d = z.ba.create("<flatOrder/>");
                for (l = 0; l < this.Tg.length; l++) d.append(z.ba.create("<hierarchyName/>").text(this.Tg[l]));
                c.append(d);
              }
              d = this.kf && this.jf;
              (a || d) && c.append(z.ba.create("<expandAll/>").text(d));
              d = this.gf && this.Tf;
              (a || d) && c.append(z.ba.create("<drillAll/>").text(d));
              return c;
            }
            Sa() {
              let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var d = {},
                g,
                l = [];
              for (g = 0; g < this.ob.length; g++) l.push(this.c2(this.ob[g], a, c));
              0 < l.length && (d.reportFilters = l);
              l = [];
              for (g = 0; g < this.rows.length; g++) l.push(this.c2(this.rows[g], a, c));
              0 < l.length && (d.rows = l);
              l = [];
              for (g = 0; g < this.Ka.length; g++) l.push(this.c2(this.Ka[g], a, c));
              0 < l.length && (d.columns = l);
              l = [];
              const m = new e.ub(),
                n = k.ac.pj.EAa();
              this.In.clear();
              for (g = 0; g < this.Ca.length; g++) {
                var p = this.Zfa(this.Ca[g], a, c);
                m.Bb(p.uniqueName) || m.Ua(p.uniqueName, new Map());
                m.getItem(p.uniqueName).set(p.aggregation, !0);
                l.push(p);
              }
              for (g = 0; g < n.length; g++) {
                var t = n.ea(g);
                p = n.Oh(g);
                t = t.keys();
                for (var r of t) t = n.getItem(p).get(r), (!m.Bb(p) || m.Bb(p) && !m.getItem(p).has(r)) && k.C.F.UV && (l.push({
                  uniqueName: p,
                  aggregation: r,
                  active: !1,
                  format: t
                }), this.In.Ua(t, !1));
              }
              0 < l.length && (d.measures = l);
              if (null != this.bk && null != this.bk.type && this.bk.type != e.u.i.Aa.ed || null != this.Tj && this.Tj.type && this.Tj.type != e.u.i.Aa.ed) d.sorting = {}, null != this.bk && null != this.bk.type && this.bk.type != e.u.i.Aa.ed && (d.sorting.row = this.bk), null != this.Tj && this.Tj.type && this.Tj.type != e.u.i.Aa.ed && (d.sorting.column = this.Tj);
              r = {};
              l = this.kf && this.jf;
              if (a || l) r.expandAll = l;
              if (a || this.kf && !l) r.expandAllRows = this.kf;
              if (a || this.jf && !l) r.expandAllColumns = this.jf;
              if (e.u.Ma.R().pa) {
                var w = e.u.Ma.R().pa.xb;
                var y = e.u.Ma.R().pa.Db;
              }
              0 < this.Jw.length && w && (r.rows = this.Oca(this.Jw, w, a, c));
              0 < this.Iw.length && y && (r.columns = this.Oca(this.Iw, y, a, c));
              u.Nc.Jg(r) || (d.expands = r);
              c = {};
              r = this.gf && this.Tf;
              if (a || r) c.drillAll = r;
              if (a || this.gf && !r) c.drillAllRows = this.gf;
              if (a || this.Tf && !r) c.drillAllColumns = this.Tf;
              0 < this.Gw.length && (c.rows = this.Bca(this.Gw, w));
              0 < this.Fw.length && (c.columns = this.Bca(this.Fw, y));
              u.Nc.Jg(c) || (d.drills = c);
              0 < this.Tg.length && (d.flatOrder = this.Tg);
              this.Ug && 0 < this.Ug.length && (d.flatSort = this.Ug);
              0 < this.bd.length && (d.drillThrough = this.bd);
              if (this.Ej) {
                a = [];
                for (let A in this.Ej) this.Ej.hasOwnProperty(A) && a.push({
                  levelName: A,
                  properties: this.Ej[A]
                });
                0 < a.length && (d.memberProperties = a);
              }
              return d;
            }
            Oca(a, c) {
              let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              for (var l = [], m, n, p, t = 0; t < a.length; t++) if (m = {}, n = a[t].slice(0), p = n.shift(), 0 != n.length) {
                for (var r = [], w = 0; w < n.length; w++) {
                  var y = c.ea(w).Ib(n[w]);
                  r.push(y.Ci);
                }
                m.tuple = r;
                p && (m.measure = this.Zfa(p.uniqueName ? p : p.Sa(), d, g));
                l.push(m);
              }
              return l;
            }
            Bca(a, c) {
              var d = [],
                g = 0;
              a: for (; g < a.length; g++) {
                var l = {};
                var m = a[g].slice(0);
                var n = m.shift();
                var p = m.shift();
                m.shift();
                if (0 != m.length) {
                  for (var t = [], r = 0; r < m.length; r++) {
                    var w = c.ea(r).Ib(m[r]);
                    if (w) t.push(w.Ci);else continue a;
                  }
                  l.tuple = t;
                  p && (l.measure = p.uniqueName ? p : p.Sa());
                  "" !== n && (l.level = n);
                  d.push(l);
                }
              }
              return d;
            }
            WCa(a) {
              return e.u.Ma.R().fa.Ba === e.u.i.qa.Cc || e.u.Ma.R().fa.Ba === e.u.i.qa.Md ? "[Measures].[" + a.name + "]" != a.uniqueName : e.u.Ma.R().O instanceof e.u.local.O.yP && void 0 !== e.u.Ma.R().O.Wz[a.uniqueName] ? !1 : a.name != a.uniqueName;
            }
            oCa(a) {
              if (e.u.Ma.R().fa.Ba == e.u.i.qa.API) return !1;
              if (a.dk.length !== a.Wc.length) return !0;
              for (var c = 0; c < a.Wc.length; c++) if (a.Wc[c] !== a.dk[c]) return !0;
              return !1;
            }
            Zfa(a, c) {
              let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var g = {};
              g.uniqueName = a.uniqueName;
              if (e.ia(a.formula)) {
                if (c || a.aggregation != e.u.i.da.NONE) g.aggregation = a.aggregation;
                var l = e.u.Ma.R().O.mx(a);
                if (c || this.oCa(l)) e.v(d) || d.kb ? g.availableAggregations = a.availableAggregations : null == d.La(a.uniqueName, "aggregations") && d.li(a.uniqueName, "aggregations", a.availableAggregations);
              } else g.formula = a.formula, a.individual && (g.individual = !0), a.calculateNaN ? a.calculateNaN && c && (g.calculateNaN = a.calculateNaN) : g.calculateNaN = a.calculateNaN, g.caption = a.caption;
              this.WCa(a) && (e.v(d) || d.kb ? g.caption = a.name : null == d.La(a.uniqueName, "caption") && void 0 === a.formula && d.li(a.uniqueName, "caption", a.name));
              e.u.O.Or.p1(a.aggregation, a.originalCaption) != a.grandTotalCaption && "" != a.grandTotalCaption && (g.grandTotalCaption = a.grandTotalCaption);
              if (c || 0 == a.active) g.active = a.active;
              null != a.format && "" != a.format && (g.format = a.format, a.active ? this.In.Ua(a.format, !0) : this.In.Bb(a.format) && !0 === this.In.getItem(a.format) || this.In.Ua(a.format, !1));
              a.filter && (g.filter = a.filter);
              return g;
            }
            OCa(a) {
              return "[Measures]" == a.uniqueName ? !1 : e.u.Ma.R().fa.Ba == e.u.i.qa.Cc || e.u.Ma.R().fa.Ba == e.u.i.qa.Md ? a.dimensionName + ".[" + a.caption + "]" != a.uniqueName : e.u.Ma.R().O instanceof e.u.local.O.yP && void 0 !== e.u.Ma.R().O.Wz[a.uniqueName] ? !1 : a.uniqueName != a.caption;
            }
            c2(a, c) {
              let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var g = {};
              g.uniqueName = a.uniqueName;
              this.OCa(a) && (e.v(d) || d.kb ? g.caption = a.caption : null == d.La(a.uniqueName, "caption") && d.li(a.uniqueName, "caption", a.caption));
              null != a.activeLevelName && (g.levelName = a.activeLevelName);
              e.v(a.filter) || (g.filter = {}, e.v(a.filter.measure) || (g.filter.measure = a.filter.measure), e.v(a.filter.query) || (g.filter.query = a.filter.query), e.v(a.filter.members) || (g.filter.members = a.filter.members), e.v(a.filter.exclude) || (g.filter.exclude = a.filter.exclude));
              a.filterEnabled || (g.filterEnabled = !0);
              u.Nc.Jg(a.groups) || (g.groups = a.groups);
              "[Measures]" != a.uniqueName && a.sortName && (c || a.sortName != e.u.O.rt.hJ) && (g.sort = a.sortName);
              "[Measures]" != a.uniqueName && a.sortAs && (g.sortAs = a.sortAs);
              null != a.customSorting && 0 < a.customSorting.length && (g.sortOrder = a.customSorting);
              void 0 !== a.showTotals && (g.showTotals = a.showTotals);
              return g;
            }
            d2(a, c) {
              var d = z.ba.create("<hierarchy/>");
              d.append(z.ba.create("<dimensionName/>").text(a.dimensionName));
              d.append(z.ba.create("<hierarchyName/>").text(a.uniqueName));
              null != a.activeLevelName && d.append(z.ba.create("<levelName/>").text(a.activeLevelName));
              if (null != a.filter && (null != a.filter.type && a.filter.type != e.u.i.rb.NONE && d.append(this.Eya(a.filter)), null != a.filter.members)) {
                var g = "string" == typeof a.filter.members ? a.filter.members.split(",") : a.filter.members;
                0 < g.length && (0 < d.find("filter").length ? this.cda(g, d.find("filter")[0]) : d.append(this.cda(g)), !0 === a.filter.negation && d.find("filter").attr("negation", a.filter.negation));
              }
              a.customSorting && 0 < a.customSorting.length && d.append(this.bxa(a.customSorting));
              a.groups && this.LBa(a.groups, d);
              a.filterEnabled || d.attr("filterEnabled", "true");
              "[Measures]" != a.uniqueName && a.sortName && (c || a.sortName != e.u.O.rt.hJ) && d.attr("sort", a.sortName);
              "[Measures]" != a.uniqueName && a.sortAs && d.attr("sortAs", a.sortAs);
              return d;
            }
            Eya(a) {
              var c = null;
              null == c && (c = z.ba.create("<filter/>"));
              c.attr("type", a.type);
              c.attr("quantity", a.quantity);
              c.attr("measure", a.measure);
              return c;
            }
            cda(a) {
              let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              null == c && (c = z.ba.create("<filter/>"));
              for (var d = 0; d < a.length; d++) {
                var g = a[d];
                c.append(z.ba.create("<member/>").append(z.ba.$h(g)));
              }
              return c;
            }
            bxa(a) {
              for (var c = z.ba.create("<sort/>"), d = 0; d < a.length; d++) {
                var g = a[d];
                c.append(z.ba.create("<member/>").append(z.ba.$h(g)));
              }
              return c;
            }
            LBa(a, c) {
              if (null != a) for (var d in a) {
                var g = z.ba.create("<group/>");
                g.attr("name", d);
                for (var l = 0; l < a[d].length; l++) {
                  var m = a[d][l];
                  g.append(z.ba.create("<member/>").append(z.ba.$h(m)));
                }
                c.append(g);
              }
            }
            static jm(a) {
              var c = {};
              if (void 0 == a) return c;
              null != a.pages && (c.pages = a.pages);
              null != a.reportFilters && (c.pages = a.reportFilters);
              null != a.rows && (c.rows = a.rows);
              null != a.columns && (c.columns = a.columns);
              null != a.measures && (c.measures = a.measures);
              null != a.rowSorting && (c.rowSorting = a.rowSorting, null != c.rowSorting.tuple && "string" == typeof c.rowSorting.tuple && (c.rowSorting.tuple = c.rowSorting.tuple.split(",")));
              null != a.sorting && null != a.sorting.row && (c.rowSorting = a.sorting.row);
              null != a.columnSorting && (c.columnSorting = a.columnSorting, null != c.columnSorting.tuple && "string" == typeof c.columnSorting.tuple && (c.columnSorting.tuple = c.columnSorting.tuple.split(",")));
              null != a.sorting && null != a.sorting.column && (c.columnSorting = a.sorting.column);
              null != a.expandAll && (c.expandAll = a.expandAll);
              null != a.expandAllRows && (c.expandAllRows = a.expandAllRows);
              null != a.expandAllColumns && (c.expandAllColumns = a.expandAllColumns);
              null != a.expandedRows && (c.expandedRows = a.expandedRows);
              null != a.expandedColumns && (c.expandedColumns = a.expandedColumns);
              null != a.expands && (null != a.expands.expandAll && (c.expandAll = a.expands.expandAll), null != a.expands.expandAllRows && (c.expandAllRows = a.expands.expandAllRows), null != a.expands.expandAllColumns && (c.expandAllColumns = a.expands.expandAllColumns), null != a.expands.rows && (c.expandedRows = b.HV(a.expands.rows)), null != a.expands.columns && (c.expandedColumns = b.HV(a.expands.columns)));
              null != a.drillAll && (c.drillAll = a.drillAll);
              null != a.drillAllRows && (c.drillAllRows = a.drillAllRows);
              null != a.drillAllColumns && (c.drillAllColumns = a.drillAllColumns);
              null != a.drilledRows && (c.drilledRows = a.drilledRows);
              null != a.drilledColumns && (c.drilledColumns = a.drilledColumns);
              null != a.drills && (null != a.drills.drillAll && (c.drillAll = a.drills.drillAll), null != a.drills.drillAllRows && (c.drillAllRows = a.drills.drillAllRows), null != a.drills.drillAllColumns && (c.drillAllColumns = a.drills.drillAllColumns), null != a.drills.rows && (c.drilledRows = b.GV(a.drills.rows)), null != a.drills.columns && (c.drilledColumns = b.GV(a.drills.columns)));
              null != a.flatOrder && (c.flatOrder = a.flatOrder);
              null != a.flatSort && (c.flatSort = a.flatSort);
              null != a.drillThrough && (c.drillThrough = a.drillThrough);
              null != a.memberProperties && (c.memberProperties = a.memberProperties);
              null != a.slice && (a = a.slice, null != a.pages && a.pages.length && (c.pages = a.pages), null != a.reportFilters && a.reportFilters.length && (c.pages = a.reportFilters), null != a.rows && a.rows.length && (c.rows = a.rows), null != a.columns && a.columns.length && (c.columns = a.columns), null != a.measures && a.measures.length && (c.measures = a.measures), null != a.sorting && null != a.sorting.row && (c.rowSorting = a.sorting.row), null != a.sorting && null != a.sorting.column && (c.columnSorting = a.sorting.column), null != a.expands && (null != a.expands.expandAll && (c.expandAll = a.expands.expandAll), null != a.expands.rows && (c.expandedRows = b.HV(a.expands.rows)), null != a.expands.columns && (c.expandedColumns = b.HV(a.expands.columns))), null != a.drills && (null != a.drills.drillAll && (c.drillAll = a.drills.drillAll), null != a.drills.rows && (c.drilledRows = b.GV(a.drills.rows)), null != a.drills.columns && (c.drilledColumns = b.GV(a.drills.columns))), null != a.flatOrder && a.flatOrder.length && (c.flatOrder = a.flatOrder), null != a.flatSort && a.flatSort.length && (c.flatSort = a.flatSort), null != a.drillThrough && a.drillThrough.length && (c.drillThrough = a.drillThrough), null != a.memberProperties && (c.memberProperties = a.memberProperties));
              return c;
            }
            PCa(a) {
              for (var c = 0; c < this.ob.length; c++) if (this.ob[c].uniqueName == a) return !0;
              for (c = 0; c < this.rows.length; c++) if (this.rows[c].uniqueName == a) return !0;
              for (c = 0; c < this.Ka.length; c++) if (this.Ka[c].uniqueName == a) return !0;
              return !1;
            }
          }
          h.wp = b;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.Ff = {};
              this.yf = {};
              this.ug = [];
              this.Fg = [];
              this.Hj = {};
              this.xk = {};
              this.sh = [];
              this.HE = 0;
            }
            static zb(b) {
              const a = new f();
              if (null == b) return a;
              null != b.columnSizes && "string" != typeof b.columnSizes && (a.yf = b.columnSizes);
              null != b.rowSizes && "string" != typeof b.rowSizes && (a.Ff = b.rowSizes);
              null != b.columnHeaderSizes && "string" != typeof b.columnHeaderSizes && (a.Fg = b.columnHeaderSizes);
              null != b.rowHeaderSizes && "string" != typeof b.rowHeaderSizes && (a.ug = b.rowHeaderSizes);
              null != b.rowFilterSizes && "string" != typeof b.rowFilterSizes && (a.sh = b.rowFilterSizes);
              null != b.columnSizesByIdx && (a.xk = b.columnSizesByIdx);
              null != b.rowSizesByIdx && (a.Hj = b.rowSizesByIdx);
              return a;
            }
            static jm(b) {
              var a = {};
              if (void 0 == b) return a;
              var c;
              if (null != b.columns) {
                var d = b.columns;
                for (c = 0; c < d.length; c++) if (null != d[c].idx && (null == a.columnSizesByIdx && (a.columnSizesByIdx = {}), a.columnSizesByIdx[parseInt(d[c].idx)] = parseInt(d[c].width)), null != d[c].tuple || null != d[c].measure) {
                  null == a.columnSizes && (a.columnSizes = {});
                  var g = null == d[c].tuple ? [] : d[c].tuple.slice();
                  null != d[c].measure && ("string" == typeof d[c].measure ? (g.push(d[c].measure), g.push("")) : (g.push(d[c].measure.uniqueName ? d[c].measure.uniqueName : ""), g.push(d[c].measure.aggregation ? d[c].measure.aggregation : "")));
                  a.columnSizes[g.join(",")] = parseInt(d[c].width);
                }
              }
              if (null != b.rows) for (d = b.rows, c = 0; c < d.length; c++) if (null != d[c].idx && (null == a.rowSizesByIdx && (a.rowSizesByIdx = {}), a.rowSizesByIdx[parseInt(d[c].idx)] = parseInt(d[c].height)), null != d[c].tuple || null != d[c].measure) null == a.rowSizes && (a.rowSizes = {}), g = null == d[c].tuple ? [] : d[c].tuple.slice(), null != d[c].measure && ("string" == typeof d[c].measure ? (g.push(d[c].measure), g.push("")) : (g.push(d[c].measure.uniqueName ? d[c].measure.uniqueName : ""), g.push(d[c].measure.aggregation ? d[c].measure.aggregation : ""))), a.rowSizes[g.join(",")] = parseInt(d[c].height);
              null != b.columnSizes && (a.columnSizes = b.columnSizes);
              null != b.rowSizes && (a.rowSizes = b.rowSizes);
              null != b.columnHeaderSizes && (a.columnHeaderSizes = b.columnHeaderSizes);
              null != b.rowHeaderSizes && (a.rowHeaderSizes = b.rowHeaderSizes);
              null != b.rowFilterSizes && (a.rowFilterSizes = b.rowFilterSizes);
              null != b.rowSizesByIdx && (a.rowSizesByIdx = b.rowSizesByIdx);
              null != b.columnSizesByIdx && (a.columnSizesByIdx = b.columnSizesByIdx);
              return a;
            }
            Sa(b) {
              const a = {};
              if (null != this.Fg && !u.Nc.Jg(this.Fg) || null != this.yf && !u.Nc.Jg(this.yf)) {
                a.columns = [];
                if (null != this.Fg && !u.Nc.Jg(this.Fg)) for (var c = 0; c < this.Fg.length; c++) null != this.Fg[c] && a.columns.push({
                  idx: c,
                  width: this.Fg[c]
                });
                if (null != this.xk && !u.Nc.Jg(this.xk)) for (var d in this.xk) c = parseInt(d), this.xk.hasOwnProperty(d) && !isNaN(c) && a.columns.push({
                  idx: c,
                  width: this.xk[d]
                });
                d = h.wp.fd(b.Ka);
                if (null != this.yf && !u.Nc.Jg(this.yf)) for (var g in this.yf) if (c = g.split(","), 0 <= d && 1 < c.length) {
                  const m = c.pop(),
                    n = c.pop();
                  a.columns.push({
                    tuple: c,
                    measure: new h.jh(n, m).Sa(),
                    width: this.yf[g]
                  });
                } else a.columns.push({
                  tuple: c,
                  width: this.yf[g]
                });
              }
              if (null != this.sh && !u.Nc.Jg(this.sh) || null != this.ug && !u.Nc.Jg(this.ug) || null != this.Ff && !u.Nc.Jg(this.Ff)) {
                a.rows = [];
                if (null != this.sh && !u.Nc.Jg(this.sh)) for (g = 0; g < this.sh.length; g++) null != this.sh[g] && a.rows.push({
                  idx: g,
                  height: this.sh[g]
                });
                if (null != this.ug && !u.Nc.Jg(this.ug)) for (g = 0; g < this.ug.length; g++) null != this.ug[g] && a.rows.push({
                  idx: g,
                  height: this.ug[g]
                });
                if (null != this.Hj && !u.Nc.Jg(this.Hj)) for (var l in this.Hj) g = parseInt(l), this.Hj.hasOwnProperty(l) && !isNaN(g) && a.rows.push({
                  idx: g,
                  width: this.Hj[l]
                });
                b = h.wp.fd(b.rows);
                if (null != this.Ff && !u.Nc.Jg(this.Ff)) for (const m in this.Ff) l = m.split(","), 0 <= b && 1 < l.length ? (g = l.pop(), d = l.pop(), a.rows.push({
                  tuple: l,
                  measure: new h.jh(d, g).Sa(),
                  height: this.Ff[m]
                })) : a.rows.push({
                  tuple: l,
                  height: this.Ff[m]
                });
              }
              return a;
            }
            gp() {
              var b = z.ba.create("<view/>"),
                a;
              if (null != this.Fg) for (a in this.Fg) if (null != this.Fg[a]) {
                var c = z.ba.create("<column/>").text(this.Fg[a]);
                c.attr("headerIdx", a);
                b.append(c);
              }
              if (null != this.yf) for (a in this.yf) null != this.yf[a] && (c = z.ba.create("<column/>").append(z.ba.$h(this.yf[a])), b.append(c));
              if (null != this.sh) for (a in this.sh) null != this.sh[a] && (c = z.ba.create("<row/>").text(this.sh[a]), c.attr("filterIdx", a), b.append(c));
              if (null != this.ug) for (a in this.ug) null != this.ug[a] && (c = z.ba.create("<row/>").text(this.ug[a]), c.attr("headerIdx", a), b.append(c));
              if (null != this.Ff) for (a in this.Ff) null != this.Ff[a] && (c = z.ba.create("<row/>").append(z.ba.$h(this.Ff[a])), b.append(c));
              return b;
            }
            clone() {
              const b = new f();
              var a = {};
              for (const n in this.yf) this.yf.hasOwnProperty(n) && (a[n] = this.yf[n]);
              b.yf = a;
              a = {};
              for (var c in this.xk) this.xk.hasOwnProperty(c) && (a[c] = this.xk[c]);
              b.xk = a;
              c = [];
              for (var d in this.Fg) this.Fg.hasOwnProperty(d) && (c[parseInt(d)] = this.Fg[d]);
              b.Fg = c;
              d = {};
              for (var g in this.Ff) this.Ff.hasOwnProperty(g) && (d[g] = this.Ff[g]);
              b.Ff = d;
              g = {};
              for (var l in this.Hj) this.Hj.hasOwnProperty(l) && (g[l] = this.Hj[l]);
              b.Hj = g;
              l = [];
              for (var m in this.ug) this.ug.hasOwnProperty(m) && (l[parseInt(m) + this.HE] = this.ug[m]);
              b.ug = l;
              m = [];
              if (0 != this.HE) for (const n in this.sh) this.ug.hasOwnProperty(n) && (m[parseInt(n)] = this.sh[n]);
              b.sh = m;
              return b;
            }
            static Ek(b) {
              const a = new f();
              a.Fg = f.yea(b.find("view column[headerIdx]"));
              a.yf = f.Nia(b.find("view column"));
              a.ug = f.yea(b.find("view row[headerIdx]"));
              a.Ff = f.Nia(b.find("view row"));
              a.sh = f.Bya(b.find("view row[filterIdx]"));
              return a;
            }
            static yea(b) {
              for (var a = [], c = 0; c < b.length; c++) {
                var d = b[c];
                a[parseInt(d.attr("headerIdx"))] = parseInt(d.text());
              }
              return a;
            }
            static Bya(b) {
              for (var a = [], c = 0; c < b.length; c++) {
                var d = b[c];
                a[parseInt(d.attr("filterIdx"))] = parseInt(d.text());
              }
              return a;
            }
            static Nia(b) {
              for (var a = [], c = 0; c < b.length; c++) {
                var d = b[c];
                e.v(d.attr("headerIdx")) && e.v(d.attr("filterIdx")) && 0 < d.text().length && a.push(d.text().split(","));
              }
              return a;
            }
          }
          h.Kv = f;
        })(k.hb || (k.hb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.Ce = new e.ub();
                this.Xc = new e.ub();
                this.Jx = new k.hb.Kv();
                this.He = null;
                this.labels = {};
                this.JLa = this.wA = !1;
                this.Gm = [];
              }
              static fLa(a) {
                if (null === a) return null;
                var c = new k.hb.ly();
                c.wA = a.wA;
                c.ka = a.Ab.clone();
                a.Qb && (c.slice = a.Qb.rja());
                c.options = a.C;
                var d = [];
                for (var g = 0; g < a.Ce.length; g++) d[g] = a.Ce.ea(g).Sa();
                c.Ce = d;
                d = [];
                for (g = 0; g < a.Xc.length; g++) d[g] = a.Xc.ea(g).Sa();
                c.Xc = d;
                c.Gm = a.Gm;
                c.labels = a.labels;
                c.Jx = a.Jx.clone();
                c.He = a.He;
                c.version = e.kh.Nr;
                c.DL = new Date().toISOString();
                return c;
              }
            }
            f.A9 = b;
          })(h.W || (h.W = {}));
        })(k.Wb || (k.Wb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.Wna = 35;
              this.nR = !1;
              this.Bsa = "a4";
              this.kha = () => this.Fga();
              this.Q0 = this.X1 = 0;
            }
            static R() {
              null == f.xe && (f.xe = new f());
              return f.xe;
            }
            static dispose() {
              f.xe = null;
            }
            print() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              this.nR || (this.nR = !0, this.C = b || new k.at.i9(), k.Va.R().N(e.bf.eB, this.kha), k.Va.R().Ya(e.bf.aY));
            }
            Fga() {
              k.Va.R().pb(e.bf.eB, this.kha);
              this.nR = !1;
            }
            Xe(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              this.Y = b;
              this.ma = null != b ? b.ma : null;
              this.Hua = a || "";
              this.start();
            }
            start() {
              this.sl = 0;
              var b = k.Dc.ky.yH(this.Bsa);
              this.hR = b.CBa();
              this.sZ = b.FAa();
              this.ob = new x.Ga("div");
              this.kt = [];
              this.vI = this.xo = 0;
              u.Il.po({
                bp: () => this.Lza(),
                ff: () => this.finish()
              });
            }
            clear() {
              this.nR = !1;
              this.xo = this.sl = this.vI = 0;
              this.ob = this.$s = null;
              this.Q0 = this.X1 = 0;
            }
            Lza() {
              return this.Tsa();
            }
            Tsa() {
              if (null == this.$s) this.$s = this.Oba(), this.CV = this.$s.find("table");else if (!(this.$s.Zf(!0) <= this.hR && 0 != this.xo) && (this.$s.Zf(!0) > this.hR && (this.xo--, this.VIa(this.$s)), this.Eaa(), this.$s = this.Oba(), this.CV = this.$s.find("table"), 0 == this.Y.aj)) {
                var b = this.xo;
                0 != this.xo && 0 < this.Y.vp && (this.xo = 0, this.uaa(), this.xo = b, this.xo + 1 <= this.ma.coords.Ql && (this.xo += 1));
              }
              this.uaa();
              if (1 == this.shift()) this.Eaa();else return !1;
              return !0;
            }
            VIa(b) {
              b = b.find("td:last-child", !0);
              for (let a = 0; a < b.length; a++) b[a].remove();
            }
            Oba() {
              var b = new x.Ga("div").$("page");
              b.U("position", "absolute").U("left", "-9999px");
              if (null != this.C.$i) {
                var a = this.AL(this.C.$i);
                b.append(a);
              }
              var c = new x.Ga("table");
              0 == this.sl && 0 < k.C.F.Yp.length && c.append(new x.Ga("caption").text(k.C.F.Yp));
              b.append(c);
              if (null != this.C.xj) {
                var d = this.AL(this.C.xj);
                b.append(d);
              }
              this.Y.G.append(b);
              this.X1 = null != a ? a.yd() : 0;
              this.Q0 = null != d ? d.yd() : 0;
              return b;
            }
            AL(b) {
              var a = new x.Ga("div");
              b = b.replace(/##PAGE-NUMBER##/gi, (this.sl + 1).toString());
              b = b.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString());
              a.html(b);
              return a;
            }
            Eaa() {
              this.sl++;
              e.Da(!0, k.B.j.tF, this.sl + " " + k.B.j.K8, !0);
              this.$s.detach();
              this.$s.U("position", "").U("left", "").U("padding-top", this.Wna.toString() + "px");
              this.ob.append(this.$s);
            }
            shift() {
              ++this.xo;
              this.xo >= this.Y.zg + this.ma.coords.Ql && (this.xo = 0, this.vI += this.Rf - this.Y.uf + 1);
              return 1E3 <= this.sl || this.vI >= this.ma.coords.Kp ? !0 : !1;
            }
            uaa() {
              this.RV = 0;
              var b = this.Y.vp + this.xo;
              if (!this.ma.coords.Lo(NaN, b)) {
                var a = this.sZ - this.X1 - this.Q0;
                for (this.Rf = this.Y.Ri; this.RV <= a && this.Rf < this.ma.coords.Kp + this.Y.uf - this.vI; this.Rf++) if (this.rowIndex = this.Rf < this.Y.uf ? this.Rf : this.Rf + this.vI, !this.ma.coords.Lo(this.rowIndex, b)) {
                  var c = this.ma.Xf(this.rowIndex, b, !0);
                  this.RV += this.Ssa(this.Rf, c);
                  if (this.RV >= a) break;
                }
              }
            }
            Ssa(b, a) {
              const c = e.K.Y.sheet.Hh.st;
              var d = this.CV.find("tr", !0);
              for (d = 0 < d.length ? d[b] : null; null == d;) this.CV.append(new x.Ga("tr")), d = this.CV.find("tr", !0)[b];
              d.height = e.K.Y.sheet.Hh.rv;
              b = "<td {0}>" + (a ? a.J(!0) : "") + "</td>";
              if (null == a) b = e.P.bind(b, "class='cell' style='width:" + c + "'");else {
                var g = "",
                  l = "";
                a.Pu && null != a.style && (l = a.style.HT(), g = a.style.nT(), this.i_(a.style.DC));
                g = a.gi ? g + (" rowHeaderCell level" + a.level) : a.Ah ? g + " columnHeaderCell" : a.ml ? g + " filterHeaderCell" : a.Dz && a.Hk && "" != a.J(!0) ? g + " grandTotalCell" : a.Hk && "" != a.J(!0) ? g + " totalCell" : g + " cell";
                "" != g.trim() && (g = "class='" + g.trim() + "'");
                l = "" != l.trim() ? "style='" + l.trim() + "max-width:200px'" : "style='width:" + c + "px;'";
                b = e.P.bind(b, g + " " + l);
              }
              d.element.innerHTML += b;
              return d.yd(!0);
            }
            i_(b) {
              for (var a = 0; a < b.length; a++) 0 > this.kt.indexOf(b[a]) && this.kt.push(b[a]);
            }
            finish() {
              e.Da(!0, k.B.j.tF, "Sending pages to printer...", !1, !0);
              z.h9.print(this.Hua + this.ob.html(), this.Y0(), k.C.F.Yp);
              e.Da(!1);
              k.Va.R().Ya(e.bf.eB);
              this.clear();
            }
            Y0() {
              var b = "",
                a = x.Ga.Xb(this.ma.element),
                c = a.find(".fm-data-sheet");
              b += e.P.bind("table{width:100%;border-collapse:collapse;{0}}\n", e.K.Y.W.cd.nz(a, ["font-family", "font-size"]));
              b += e.P.bind("caption{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.sY, a));
              b += e.P.bind("td{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;{0}}\n", u.Jd().cU ? "" : "border: 1px solid #eee;");
              b += e.P.bind(".cell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me, c));
              b += e.P.bind(".totalCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.Jv, c));
              b += e.P.bind(".grandTotalCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.Jv + " " + e.K.Y.W.ya.AJ, c));
              b += e.P.bind(".rowHeaderCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.yv, a));
              b += e.P.bind(".columnHeaderCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.UA, a));
              b += e.P.bind(".filterHeaderCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.Dq, a));
              for (c = 1; 20 >= c; c++) b += e.P.bind(".level{0}{{1}}\n", c, e.K.Y.W.cd.kl(e.K.Y.W.ya.yv + " " + e.K.Y.W.ya.Of + c, a, ["padding-left"]));
              for (c = 0; c < this.kt.length; c++) b += e.P.bind(".{0}{{1}}\n", this.kt[c], e.K.Y.W.cd.kl(this.kt[c], a));
              b = (b + ".page:not(:last-child), svg { page-break-after: always; }").replace(/background-color:rgb\(33, 33, 33\)/g, "background-color:rgb(255, 255, 255)");
              return b = b.replace(/background-color:rgb\(66, 66, 66\)/g, "background-color:rgb(247, 247, 247)");
            }
          }
          h.xF = f;
        })(k.at || (k.at = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static zb(b) {
              var a = new f();
              null != b && (null != b.header && (a.$i = b.header), null != b.footer && (a.xj = b.footer));
              return a;
            }
          }
          h.i9 = f;
        })(k.at || (k.at = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor() {
              super();
              f.Vd = new h.Hq();
              f.Vd.vE();
              f.C = new h.Hq();
              if (f.instance) throw Error("Singleton");
            }
            static R() {
              e.v(f.instance) && (f.instance = new f());
              return f.instance;
            }
            static dispose() {
              f.BB && (f.BB.Vd = null);
              f.BB = null;
              f.C = null;
              f.Vd = null;
              f.instance = null;
            }
            static aKa(b) {
              f.BB = b;
            }
            static Qw() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              const c = new h.Hq();
              b && c.SD(f.Vd);
              a && c.SD(f.BB);
              c.SD(f.C);
              !b && c.Zua();
              return c;
            }
            static clear() {
              this.C = new h.Hq();
            }
            static wq(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
              if (e.v(f.C) || a) a = f.Cn, f.C = new h.Hq(), f.C.na("configuratorOpened", a);
              b = h.Hq.jm(b);
              a = !1;
              f.m0 = !0;
              const d = f.Qw(!0, !0);
              for (let g in b) if (void 0 != d[g] && b[g] != d[g] && (a = !0, f.Vz(g))) {
                f.hv = !0;
                break;
              }
              f.C.SD(b);
              e.u.O.rt.hJ = f.gca;
              f.m0 = !1;
              a && c && f.eb();
            }
            static Vz(b) {
              return -1 < f.Asa.indexOf(b);
            }
            static V(b) {
              return f.C && null != f.C[b] ? f.C[b] : f.BB && null != f.BB[b] ? f.BB[b] : f.Vd ? f.Vd[b] : null;
            }
            static get Cn() {
              return f.C.V("configuratorOpened");
            }
            static set Cn(b) {
              f.C.na("configuratorOpened", b);
            }
            static get AC() {
              return f.V("configuratorActive");
            }
            static set AC(b) {
              if (f.C.V("configuratorActive") != b) {
                const a = !e.v(f.C.V("configuratorActive"));
                f.C.na("configuratorOpened", b);
                f.C.na("configuratorActive", b);
                a && f.eb();
              }
            }
            static get fS() {
              return this.readOnly ? this.SB.configuratorButton : f.V("configuratorButton");
            }
            static set fS(b) {
              if (f.C.V("configuratorButton") != b) {
                const a = !e.v(f.C.V("configuratorButton"));
                f.C.na("configuratorButton", b);
                a && f.eb();
              }
            }
            static get ke() {
              return f.V("viewType");
            }
            static set ke(b) {
              if (f.C.V("viewType") != b) {
                b = e.K.Id.ah(b) ? b : f.Vd.V("viewType");
                const a = !(e.v(f.C.V("viewType")) && f.Vd.V("viewType") == b);
                f.C.na("viewType", b);
                a && f.eb();
              }
            }
            static get An() {
              return f.V("chartTitle");
            }
            static set An(b) {
              if (f.C.V("chartTitle") != b) {
                const a = !e.v(f.C.V("chartTitle"));
                f.C.na("chartTitle", b);
                a && f.eb();
              }
            }
            static get uk() {
              return f.V("gridType") == e.K.Y.se.sv;
            }
            static set uk(b) {
              f.C.V("gridType") != e.K.Y.se.sv && (b = !e.v(f.C.V("gridType")), f.C.na("gridType", e.K.Y.se.sv), f.hv = f.Vz("gridType"), b && f.eb());
            }
            static get tc() {
              return f.V("gridType") == e.K.Y.se.Gh;
            }
            static set tc(b) {
              if (1 == b && f.C.V("gridType") != e.K.Y.se.Gh) {
                const a = !e.v(f.C.V("gridType"));
                f.C.na("gridType", e.K.Y.se.Gh);
                f.hv = f.Vz("gridType");
                a && f.eb();
              }
              0 == b && f.C.V("gridType") == e.K.Y.se.Gh && (f.C.na("gridType", e.K.Y.se.FA), f.hv = f.Vz("gridType"), f.eb());
            }
            static get rD() {
              return f.V("gridType");
            }
            static set rD(b) {
              if (f.C.V("gridType") != b) {
                const a = !e.v(f.C.V("gridType"));
                f.C.na("gridType", b);
                a && f.eb();
              }
            }
            static get Yp() {
              return f.V("gridTitle");
            }
            static set Yp(b) {
              if (f.C.V("gridTitle") != b) {
                const a = !e.v(f.C.V("gridTitle"));
                f.C.na("gridTitle", b);
                a && f.eb();
              }
            }
            static get kL() {
              return f.V("chartType");
            }
            static set kL(b) {
              b = e.K.Cd.Ne.validate(b);
              if (f.C.V("chartType") != b) {
                const a = !e.v(f.C.V("chartType"));
                f.C.na("chartType", b);
                a && f.eb();
              }
            }
            static get uo() {
              return f.V("chartOneLevel");
            }
            static set uo(b) {
              if (f.C.V("chartOneLevel") != b) {
                const a = !e.v(f.C.V("chartOneLevel"));
                f.C.na("chartOneLevel", b);
                a && f.eb();
              }
            }
            static get ku() {
              return f.V("chartOneLevelTuple");
            }
            static set ku(b) {
              if (f.C.V("chartOneLevelTuple") != b) {
                const a = !e.v(f.C.V("chartOneLevelTuple"));
                f.C.na("chartOneLevelTuple", b);
                a && f.eb();
              }
            }
            static get mC() {
              return f.V("chartOneLevelColumnTuple");
            }
            static set mC(b) {
              if (f.C.V("chartOneLevelColumnTuple") != b) {
                const a = !e.v(f.C.V("chartOneLevelColumnTuple"));
                f.C.na("chartOneLevelColumnTuple", b);
                a && f.eb();
              }
            }
            static get DG() {
              return f.V("chartMultipleMeasures");
            }
            static set DG(b) {
              if (f.C.V("chartMultipleMeasures") != b) {
                const a = !e.v(f.C.V("chartMultipleMeasures"));
                f.C.na("chartMultipleMeasures", b);
                a && f.eb();
              }
            }
            static get CG() {
              return f.V("chartActiveMeasures");
            }
            static set CG(b) {
              if (f.C.V("chartActiveMeasures") != b) {
                const a = !e.v(f.C.V("chartActiveMeasures"));
                f.C.na("chartActiveMeasures", b);
                a && f.eb();
              }
            }
            static get so() {
              return f.V("chartActiveMeasure");
            }
            static set so(b) {
              if (f.C.V("chartActiveMeasure") != b) {
                const a = !e.v(f.C.V("chartActiveMeasures"));
                f.C.na("chartActiveMeasure", b);
                a && f.eb();
              }
            }
            static get jL() {
              return f.V("chartActiveTupleIndex");
            }
            static set jL(b) {
              if (f.C.V("chartActiveTupleIndex") != b) {
                const a = !e.v(f.C.V("chartActiveTupleIndex"));
                f.C.na("chartActiveTupleIndex", b);
                a && f.eb();
              }
            }
            static get Qy() {
              return f.V("chartPosition");
            }
            static set Qy(b) {
              if (f.C.V("chartPosition") != b) {
                const a = !e.v(f.C.V("chartPosition"));
                f.C.na("chartPosition", b);
                a && f.eb();
              }
            }
            static get MR() {
              return f.V("chartReversedAxes");
            }
            static set MR(b) {
              if (f.C.V("chartReversedAxes") != b) {
                const a = !e.v(f.C.V("chartReversedAxes"));
                f.C.na("chartReversedAxes", b);
                a && f.eb();
              }
            }
            static get ju() {
              return f.V("chartAutoRange");
            }
            static set ju(b) {
              if (f.C.V("chartAutoRange") != b) {
                const a = !e.v(f.C.V("chartAutoRange"));
                f.C.na("chartAutoRange", b);
                a && f.eb();
              }
            }
            static get lC() {
              return f.V("chartAxisShortNumberFormat");
            }
            static set lC(b) {
              if (f.C.V("chartAxisShortNumberFormat") != b) {
                const a = !e.v(f.C.V("chartAxisShortNumberFormat"));
                f.C.na("chartAxisShortNumberFormat", b);
                a && f.eb();
              }
            }
            static get Gx() {
              return this.readOnly ? this.SB.showFilter : f.V("showFilter");
            }
            static set Gx(b) {
              if (f.C.V("showFilter") != b) {
                const a = !e.v(f.C.V("showFilter"));
                f.C.na("showFilter", b);
                a && f.eb();
              }
            }
            static get Hia() {
              return this.readOnly ? this.SB.showFilterInCharts : f.V("showFilterInCharts");
            }
            static set Hia(b) {
              if (f.C.V("showFilterInCharts") != b) {
                const a = !e.v(f.C.V("showFilterInCharts"));
                f.C.na("showFilterInCharts", b);
                a && f.eb();
              }
            }
            static get m5() {
              return f.V("showDefaultSlice");
            }
            static set m5(b) {
              if (f.C.V("showDefaultSlice") != b) {
                const a = !e.v(f.C.V("showDefaultSlice"));
                f.C.na("showDefaultSlice", b);
                a && f.eb();
              }
            }
            static get Rn() {
              return f.V("useOlapFormatting");
            }
            static set Rn(b) {
              if (f.C.V("useOlapFormatting") != b) {
                const a = !e.v(f.C.V("useOlapFormatting"));
                f.C.na("useOlapFormatting", b);
                a && f.eb();
              }
            }
            static get BI() {
              return f.V("showMemberProperties");
            }
            static set BI(b) {
              if (f.C.V("showMemberProperties") != b) {
                const a = !e.v(f.C.V("showMemberProperties"));
                f.C.na("showMemberProperties", b);
                a && f.eb();
              }
            }
            static get CE() {
              return f.V("showEmptyData");
            }
            static set CE(b) {
              if (f.C.V("showEmptyData") != b) {
                const a = !e.v(f.C.V("showEmptyData"));
                f.C.na("showEmptyData", b);
                a && f.eb();
              }
            }
            static get Bia() {
              return f.V("showChartDataLabels");
            }
            static set Bia(b) {
              if (f.C.V("showChartDataLabels") != b) {
                const a = !e.v(f.C.V("showChartDataLabels"));
                f.C.na("showChartDataLabels", b);
                a && f.eb();
              }
            }
            static get zia() {
              return f.V("showAllChartLabels");
            }
            static set zia(b) {
              if (f.C.V("showAllChartLabels") != b) {
                const a = !e.v(f.C.V("showAllChartLabels"));
                f.C.na("showAllChartLabels", b);
                a && f.eb();
              }
            }
            static get zl() {
              return f.V("showAggregations");
            }
            static set zl(b) {
              if (f.C.V("showAggregations") != b) {
                const a = !e.v(f.C.V("showAggregations"));
                f.C.na("showAggregations", b);
                a && f.eb();
              }
            }
            static get jt() {
              return f.V("showHierarchyCaptions");
            }
            static set jt(b) {
              if (f.C.V("showHierarchyCaptions") != b) {
                const a = !e.v(f.C.V("showHierarchyCaptions"));
                f.C.na("showHierarchyCaptions", b);
                a && f.eb();
              }
            }
            static get ZG() {
              return f.V("drillThroughMaxRows");
            }
            static set ZG(b) {
              if (f.C.V("drillThroughMaxRows") != b) {
                const a = !e.v(f.C.V("drillThroughMaxRows"));
                f.C.na("drillThroughMaxRows", b);
                a && f.eb();
              }
            }
            static get h5() {
              return f.V("showAllFieldsDrillThrough");
            }
            static set h5(b) {
              if (f.C.V("showAllFieldsDrillThrough") != b) {
                const a = !e.v(f.C.V("showAllFieldsDrillThrough"));
                f.C.na("showAllFieldsDrillThrough", b);
                a && f.eb();
              }
            }
            static get n5() {
              return f.V("showFieldListSearch");
            }
            static set n5(b) {
              if (f.C.V("showFieldListSearch") != b) {
                const a = !e.v(f.C.V("showFieldListSearch"));
                f.C.na("showFieldListSearch", b);
                a && f.eb();
              }
            }
            static get AI() {
              return f.V("showExtraTotalLabels");
            }
            static set AI(b) {
              if (f.C.V("showExtraTotalLabels") != b) {
                const a = !e.v(f.C.V("showExtraTotalLabels"));
                f.C.na("showExtraTotalLabels", b);
                a && f.eb();
              }
            }
            static get Al() {
              return f.V("showHeaders");
            }
            static set Al(b) {
              if (f.C.V("showHeaders") != b) {
                const a = !e.v(f.C.V("showHeaders"));
                f.C.na("showHeaders", b);
                a && f.eb();
              }
            }
            static get Kj() {
              return this.readOnly ? this.SB.sorting : f.V("sorting");
            }
            static set Kj(b) {
              if (f.C.V("sorting") != b) {
                const a = !e.v(f.C.V("sorting"));
                f.C.na("sorting", b);
                a && f.eb();
              }
            }
            static get KT() {
              return e.u.Ma.R().fa.Ba === e.u.i.qa.API || e.u.Ma.R().fa.Ic ? !1 : f.V("grouping");
            }
            static set KT(b) {
              if (f.C.V("grouping") != b) {
                const a = !e.v(f.C.V("grouping"));
                f.C.na("grouping", b);
                a && f.eb();
              }
            }
            static get OC() {
              return f.V("editing");
            }
            static set OC(b) {
              if (f.C.V("editing") != b) {
                const a = !e.v(f.C.V("editing"));
                f.C.na("editing", b);
                a && f.eb();
              }
            }
            static get bd() {
              return this.readOnly ? this.SB.drillThrough : f.V("drillThrough");
            }
            static set bd(b) {
              if (f.C.V("drillThrough") != b) {
                const a = !e.v(f.C.V("drillThrough"));
                f.C.na("drillThrough", b);
                a && f.eb();
              }
            }
            static get Gia() {
              return f.V("showDrillThroughConfigurator");
            }
            static set Gia(b) {
              if (f.C.V("showDrillThroughConfigurator") != b) {
                const a = !e.v(f.C.V("showDrillThroughConfigurator"));
                f.C.na("showDrillThroughConfigurator", b);
                a && f.eb();
              }
            }
            static get DE() {
              return f.V("showHierarchies");
            }
            static set DE(b) {
              if (f.C.V("showHierarchies") != b) {
                const a = !e.v(f.C.V("showHierarchies"));
                f.C.na("showHierarchies", b);
                a && f.eb();
              }
            }
            static get Eia() {
              return f.V("showChartsWarning");
            }
            static set Eia(b) {
              if (f.C.V("showChartsWarning") != b) {
                const a = !e.v(f.C.V("showChartsWarning"));
                f.C.na("showChartsWarning", b);
                a && f.eb();
              }
            }
            static get Cia() {
              return f.V("showChartLegend");
            }
            static set Cia(b) {
              if (f.C.V("showChartLegend") != b) {
                const a = !e.v(f.C.V("showChartLegend"));
                f.C.na("showChartLegend", b);
                a && f.eb();
              }
            }
            static get j5() {
              return f.V("showChartLegendButton");
            }
            static set j5(b) {
              if (f.C.V("showChartLegendButton") != b) {
                const a = !e.v(f.C.V("showChartLegendButton"));
                f.C.na("showChartLegendButton", b);
                a && f.eb();
              }
            }
            static get UV() {
              return f.V("saveAllFormats");
            }
            static set UV(b) {
              if (f.C.V("saveAllFormats") != b) {
                const a = !e.v(f.C.V("saveAllFormats"));
                f.C.na("saveAllFormats", b);
                a && f.eb();
              }
            }
            static get iu() {
              return f.V("calculatedValuesOLAP");
            }
            static set iu(b) {
              if (f.C.V("calculatedValuesOLAP") != b) {
                const a = !e.v(f.C.V("calculatedValuesOLAP"));
                f.C.na("calculatedValuesOLAP", b);
                a && f.eb();
              }
            }
            static get f2() {
              return f.V("includeEmptySubtotalsOLAP");
            }
            static set f2(b) {
              if (f.C.V("includeEmptySubtotalsOLAP") != b) {
                const a = !e.v(f.C.V("includeEmptySubtotalsOLAP"));
                f.C.na("includeEmptySubtotalsOLAP", b);
                a && f.eb();
              }
            }
            static get k5() {
              return f.V("showChartOneMeasureSelection");
            }
            static set k5(b) {
              if (f.C.V("showChartOneMeasureSelection") != b) {
                const a = !e.v(f.C.V("showChartOneMeasureSelection"));
                f.C.na("showChartOneMeasureSelection", b);
                a && f.eb();
              }
            }
            static get Dia() {
              return this.readOnly ? this.SB.showChartMeasures : f.V("showChartMeasures");
            }
            static set Dia(b) {
              if (f.C.V("showChartMeasures") != b) {
                const a = !e.v(f.C.V("showChartMeasures"));
                f.C.na("showChartMeasures", b);
                a && f.eb();
              }
            }
            static get If() {
              return f.V("showTotals");
            }
            static set If(b) {
              if (f.C.V("showTotals") != b) {
                const a = !e.v(f.C.V("showTotals"));
                f.C.na("showTotals", b);
                f.hv = f.Vz("showTotals");
                a && f.eb();
              }
            }
            static get Aia() {
              return f.V("showAutoCalculationBar");
            }
            static set Aia(b) {
              if (f.C.V("showAutoCalculationBar") != b) {
                const a = !e.v(f.C.V("showAutoCalculationBar"));
                f.C.na("showAutoCalculationBar", b);
                a && f.eb();
              }
            }
            static get Hf() {
              return f.V("showGrandTotals");
            }
            static set Hf(b) {
              if (f.C.V("showGrandTotals") != b) {
                const a = !e.v(f.C.V("showGrandTotals"));
                f.C.na("showGrandTotals", b);
                f.hv = f.Vz("showGrandTotals");
                a && f.eb();
              }
            }
            static get Ke() {
              return f.V("strictDataTypes");
            }
            static set Ke(b) {
              if (f.C.V("strictDataTypes") !== b) {
                const a = !e.v(f.C.V("strictDataTypes"));
                f.C.na("strictDataTypes", b);
                a && f.eb();
              }
            }
            static get HL() {
              return f.V("defaultDateType");
            }
            static set HL(b) {
              if (f.C.V("defaultDateType") != b && e.u.i.input.sa.valid(b)) {
                const a = !e.v(f.C.V("defaultDateType"));
                f.C.na("defaultDateType", b);
                a && f.eb();
              }
            }
            static get Lp() {
              return f.V("datePattern");
            }
            static set Lp(b) {
              if (f.C.V("datePattern") != b) {
                const a = !e.v(f.C.V("datePattern"));
                f.C.na("datePattern", b);
                a && f.eb();
              }
            }
            static get zk() {
              return f.V("dateTimePattern");
            }
            static set zk(b) {
              if (f.C.V("dateTimePattern") != b) {
                const a = !e.v(f.C.V("dateTimePattern"));
                f.C.na("dateTimePattern", b);
                a && f.eb();
              }
            }
            static get ep() {
              return f.V("timePattern");
            }
            static set ep(b) {
              if (f.C.V("timePattern") != b) {
                const a = !e.v(f.C.V("timePattern"));
                f.C.na("timePattern", b);
                a && f.eb();
              }
            }
            static get Uj() {
              return f.V("dateTimezoneOffset");
            }
            static set Uj(b) {
              if (f.C.V("dateTimezoneOffset") != b) {
                const a = !e.v(f.C.V("dateTimezoneOffset"));
                f.C.na("dateTimezoneOffset", b);
                a && f.eb();
              }
            }
            static get i5() {
              return f.V("showCalculatedValuesButton");
            }
            static set i5(b) {
              if (f.C.V("showCalculatedValuesButton") != b) {
                const a = !e.v(f.C.V("showCalculatedValuesButton"));
                f.C.na("showCalculatedValuesButton", b);
                a && f.eb();
              }
            }
            static get oW() {
              return f.V("showOutdatedDataAlert");
            }
            static set oW(b) {
              if (f.C.V("showOutdatedDataAlert") != b) {
                const a = !e.v(f.C.V("showOutdatedDataAlert"));
                f.C.na("showOutdatedDataAlert", b);
                a && f.eb();
              }
            }
            static get gca() {
              return f.V("defaultHierarchySortName");
            }
            static set gca(b) {
              if (f.C.V("defaultHierarchySortName") != b) {
                const a = !e.v(f.C.V("defaultHierarchySortName"));
                f.C.na("defaultHierarchySortName", b);
                a && f.eb();
              }
            }
            static get Fx() {
              return f.V("showAggregationLabels");
            }
            static set Fx(b) {
              if (f.C.V("showAggregationLabels") != b) {
                const a = !e.v(f.C.V("showAggregationLabels"));
                f.C.na("showAggregationLabels", b);
                a && f.eb();
              }
            }
            static get IH() {
              return f.V("grandTotalsPosition");
            }
            static set IH(b) {
              if (f.C.V("grandTotalsPosition") != b) {
                const a = !e.v(f.C.V("grandTotalsPosition"));
                f.C.na("grandTotalsPosition", b);
                f.hv = f.Vz("grandTotalsPosition");
                a && f.eb();
              }
            }
            static get pL() {
              return f.V("columnTotalsPosition");
            }
            static set pL(b) {
              if (f.C.V("columnTotalsPosition") != b) {
                const a = !e.v(f.C.V("columnTotalsPosition"));
                f.C.na("columnTotalsPosition", b);
                f.hv = f.Vz("columnTotalsPosition");
                a && f.eb();
              }
            }
            static get CI() {
              return f.V("showReportFiltersArea");
            }
            static set CI(b) {
              if (f.C.V("showReportFiltersArea") != b) {
                const a = !e.v(f.C.V("showReportFiltersArea"));
                f.C.na("showReportFiltersArea", b);
                a && f.eb();
              }
            }
            static get cz() {
              return this.readOnly ? this.SB.dragging : f.V("dragging");
            }
            static set cz(b) {
              if (f.C.V("dragging") != b) {
                const a = !e.v(f.C.V("dragging"));
                f.C.na("dragging", b);
                a && f.eb();
              }
            }
            static get Lw() {
              return f.V("filterWeekOffset");
            }
            static set Lw(b) {
              if (f.C.V("filterWeekOffset") != b) {
                const a = !e.v(f.C.V("filterWeekOffset"));
                f.C.na("filterWeekOffset", b);
                a && f.eb();
              }
            }
            static get N0() {
              return f.V("filterDateFormat");
            }
            static set N0(b) {
              if (f.C.V("filterDateFormat") != b) {
                const a = !e.v(f.C.V("filterDateFormat"));
                f.C.na("filterDateFormat", b);
                a && f.eb();
              }
            }
            static get US() {
              return f.V("filterLiveSearch");
            }
            static set US(b) {
              if (f.C.V("filterLiveSearch") != b) {
                const a = !e.v(f.C.V("filterLiveSearch"));
                f.C.na("filterLiveSearch", b);
                a && f.eb();
              }
            }
            static get Sm() {
              return f.V("liveFiltering");
            }
            static set Sm(b) {
              if (f.C.V("liveFiltering") != b) {
                const a = !e.v(f.C.V("liveFiltering"));
                f.C.na("liveFiltering", b);
                a && f.eb();
              }
            }
            static get QC() {
              return f.V("fieldListPosition");
            }
            static set QC(b) {
              if (f.C.V("fieldListPosition") != b) {
                const a = !e.v(f.C.V("fieldListPosition"));
                f.C.na("fieldListPosition", b);
                a && f.eb();
              }
            }
            static get sO() {
              return f.V("validateFormulas");
            }
            static set sO(b) {
              if (f.C.V("validateFormulas") != b) {
                const a = !e.v(f.C.V("validateFormulas"));
                f.C.na("validateFormulas", b);
                a && f.eb();
              }
            }
            static get nw() {
              return f.V("caseSensitiveMembers");
            }
            static set nw(b) {
              if (f.C.V("caseSensitiveMembers") != b) {
                const a = !e.v(f.C.V("caseSensitiveMembers"));
                f.C.na("caseSensitiveMembers", b);
                a && f.eb();
              }
            }
            static get Mia() {
              return f.V("simplifyFieldListFolders");
            }
            static set Mia(b) {
              if (f.C.V("simplifyFieldListFolders") != b) {
                const a = !e.v(f.C.V("simplifyFieldListFolders"));
                f.C.na("simplifyFieldListFolders", b);
                a && f.eb();
              }
            }
            static get a6() {
              return f.V("validateReportFiles");
            }
            static set a6(b) {
              if (f.C.V("validateReportFiles") != b) {
                const a = !e.v(f.C.V("validateReportFiles"));
                f.C.na("validateReportFiles", b);
                a && f.eb();
              }
            }
            static get ER() {
              return f.V("allowBrowsersCache");
            }
            static set ER(b) {
              if (f.C.V("allowBrowsersCache") != b) {
                const a = !e.v(f.C.V("allowBrowsersCache"));
                f.C.na("allowBrowsersCache", b);
                a && f.eb();
              }
            }
            static get it() {
              return f.V("showEmptyValues");
            }
            static set it(b) {
              if (f.C.V("showEmptyValues") != b) {
                const a = !e.v(f.C.V("showEmptyValues"));
                f.C.na("showEmptyValues", b);
                a && f.eb();
              }
            }
            static get ir() {
              return f.V("distinguishNullUndefinedEmpty");
            }
            static set ir(b) {
              if (f.C.V("distinguishNullUndefinedEmpty") != b) {
                const a = !e.v(f.C.V("distinguishNullUndefinedEmpty"));
                f.C.na("distinguishNullUndefinedEmpty", b);
                a && f.eb();
              }
            }
            static get LW() {
              return f.V("useCaptionsInCalculatedValueEditor");
            }
            static set LW(b) {
              if (f.C.V("useCaptionsInCalculatedValueEditor") != b) {
                const a = !e.v(f.C.V("useCaptionsInCalculatedValueEditor"));
                f.C.na("useCaptionsInCalculatedValueEditor", b);
                a && f.eb();
              }
            }
            static get LS() {
              return f.V("expandExecutionTimeout");
            }
            static set LS(b) {
              if (f.C.V("expandExecutionTimeout") != b) {
                const a = !e.v(f.C.V("expandExecutionTimeout"));
                f.C.na("expandExecutionTimeout", b);
                a && f.eb();
              }
            }
            static get readOnly() {
              return f.V("readOnly");
            }
            static set readOnly(b) {
              if (f.C.V("readOnly") != b) {
                const a = !e.v(f.C.V("readOnly"));
                f.C.na("readOnly", b);
                a && f.eb();
              }
            }
            static eb() {
              f.m0 || f.R().Ea(new v.ga(k.Wb.Uc.hk));
            }
          }
          f.hv = !1;
          f.m0 = !1;
          f.Asa = ["gridType", "showTotals", "showGrandTotals", "grandTotalsPosition", "columnTotalsPosition"];
          f.SB = {
            showFilter: !1,
            dragging: !1,
            showFilterInCharts: !1,
            showChartMeasures: !1,
            configuratorButton: !1,
            sorting: "off",
            drillThrough: !1
          };
          h.F = f;
        })(k.C || (k.C = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.Vd = {
                configuratorActive: !1,
                configuratorOpened: !1,
                configuratorButton: !0,
                viewType: e.K.Id.xt,
                chartTitle: "",
                gridType: e.K.Y.se.FA,
                gridTitle: "",
                chartType: e.K.Cd.Ne.EA,
                chartOneLevel: !1,
                chartOneLevelTuple: [],
                chartOneLevelColumnTuple: [],
                chartMultipleMeasures: !1,
                chartActiveMeasure: {},
                chartActiveMeasures: [],
                chartActiveTupleIndex: 0,
                chartPosition: "bottom",
                chartAutoRange: !1,
                chartReversedAxes: !1,
                chartAxisShortNumberFormat: null,
                showFilter: !0,
                showFilterInCharts: !0,
                showDefaultSlice: !0,
                useOlapFormatting: !1,
                showMemberProperties: !1,
                showEmptyData: !0,
                showAggregations: !0,
                showHierarchyCaptions: !0,
                drillThroughMaxRows: 1E3,
                showAllFieldsDrillThrough: !1,
                showChartDataLabels: !1,
                showAllChartLabels: !1,
                showHeaders: !0,
                showReportFiltersArea: !0,
                showExtraTotalLabels: !1,
                showFieldListSearch: !1,
                drillThrough: !0,
                showDrillThroughConfigurator: !0,
                editing: !1,
                grouping: !1,
                sorting: "on",
                dragging: !0,
                showHierarchies: !0,
                showChartsWarning: !0,
                showChartLegend: !0,
                showChartLegendButton: !1,
                saveAllFormats: !1,
                calculatedValuesOLAP: !1,
                includeEmptySubtotalsOLAP: !1,
                showChartOneMeasureSelection: !0,
                showChartMeasures: !0,
                showTotals: "on",
                showGrandTotals: "on",
                strictDataTypes: !1,
                defaultDateType: e.u.i.input.sa.Ta,
                datePattern: "dd/MM/yyyy",
                dateTimePattern: "dd/MM/yyyy HH:mm:ss",
                dateTimezoneOffset: null,
                timePattern: null,
                showCalculatedValuesButton: !0,
                showOutdatedDataAlert: !1,
                defaultHierarchySortName: e.u.i.Aa.kc,
                showAggregationLabels: !0,
                grandTotalsPosition: "top",
                columnTotalsPosition: "before",
                showAutoCalculationBar: !0,
                filterWeekOffset: 1,
                filterDateFormat: "dd/MM/yyyy",
                filterLiveSearch: !0,
                liveFiltering: !1,
                fieldListPosition: null,
                validateFormulas: !0,
                caseSensitiveMembers: !1,
                simplifyFieldListFolders: !1,
                validateReportFiles: !0,
                allowBrowsersCache: !1,
                showEmptyValues: !1,
                distinguishNullUndefinedEmpty: !1,
                useCaptionsInCalculatedValueEditor: !1,
                expandExecutionTimeout: 9E3,
                readOnly: !1
              };
            }
            na(b, a) {
              this[b] = a;
            }
            V(b) {
              return this[b];
            }
            vE() {
              for (var b in this.Vd) this[b] = this.Vd[b];
            }
            Zua() {
              if (!e.v(void 0)) for (var b = 0; b < (void 0).length; b++) {
                var a = (void 0)[b];
                void 0 != this[a] && (this[a] == this.Vd[a] || "object" == typeof this[a] && u.Nc.Jg(this[a]) && u.Nc.Jg(this.Vd[a])) && (this[a] = void 0);
              } else for (a in this.Vd) if (this[a] == this.Vd[a] || "object" == typeof this[a] && u.Nc.Jg(this[a]) && u.Nc.Jg(this.Vd[a])) this[a] = void 0;
            }
            static zb(b) {
              var a = new f();
              if (void 0 == b) return a;
              null != b.options && (b = b.options);
              b instanceof f || (b = f.jm(b));
              null != b.configuratorActive && a.na("configuratorActive", b.configuratorActive);
              null != b.configuratorButton && a.na("configuratorButton", b.configuratorButton);
              null != b.viewType && e.K.Id.ah(b.viewType) && a.na("viewType", b.viewType);
              null != b.chartTitle && a.na("chartTitle", b.chartTitle);
              null != b.gridTitle && a.na("gridTitle", b.gridTitle);
              null != b.chartType && a.na("chartType", e.K.Cd.Ne.validate(b.chartType));
              null != b.chartOneLevel && a.na("chartOneLevel", b.chartOneLevel);
              null != b.chartOneLevelTuple && a.na("chartOneLevelTuple", b.chartOneLevelTuple);
              null != b.chartOneLevelColumnTuple && a.na("chartOneLevelColumnTuple", b.chartOneLevelColumnTuple);
              null != b.chartActiveMeasure && a.na("chartActiveMeasure", b.chartActiveMeasure);
              null != b.chartActiveMeasures && a.na("chartActiveMeasures", b.chartActiveMeasures);
              null != b.chartActiveTupleIndex && a.na("chartActiveTupleIndex", b.chartActiveTupleIndex);
              null != b.chartAutoRange && a.na("chartAutoRange", b.chartAutoRange);
              null != b.chartReversedAxes && a.na("chartReversedAxes", b.chartReversedAxes);
              null != b.chartPosition && a.na("chartPosition", b.chartPosition);
              null != b.chartAxisShortNumberFormat && a.na("chartAxisShortNumberFormat", b.chartAxisShortNumberFormat);
              null != b.classicView && 1 == b.classicView && a.na("gridType", e.K.Y.se.sv);
              null != b.tableType && b.tableType == e.K.Y.se.Gh && a.na("gridType", e.K.Y.se.Gh);
              null != b.flatView && 1 == b.flatView && a.na("gridType", e.K.Y.se.Gh);
              null != b.gridType && a.na("gridType", b.gridType);
              null != b.showAutoCalculationBar && a.na("showAutoCalculationBar", b.showAutoCalculationBar);
              null != b.liveFiltering && a.na("liveFiltering", b.liveFiltering);
              null != b.fieldListPosition && a.na("fieldListPosition", b.fieldListPosition);
              null != b.showFilter && a.na("showFilter", b.showFilter);
              null != b.showDefaultSlice && a.na("showDefaultSlice", b.showDefaultSlice);
              null != b.useOlapFormatting && a.na("useOlapFormatting", b.useOlapFormatting);
              null != b.showMemberProperties && a.na("showMemberProperties", b.showMemberProperties);
              null != b.showEmptyData && a.na("showEmptyData", b.showEmptyData);
              null != b.showFilterInCharts && a.na("showFilterInCharts", b.showFilterInCharts);
              null != b.showAggregations && a.na("showAggregations", b.showAggregations);
              null != b.showHierarchyCaptions && a.na("showHierarchyCaptions", b.showHierarchyCaptions);
              null != b.drillthroughMaxRows && a.na("drillThroughMaxRows", b.drillthroughMaxRows);
              null != b.drillThroughMaxRows && a.na("drillThroughMaxRows", b.drillThroughMaxRows);
              null != b.showAllFieldsDrillThrough && a.na("showAllFieldsDrillThrough", b.showAllFieldsDrillThrough);
              null != b.showFieldListSearch && a.na("showFieldListSearch", b.showFieldListSearch);
              null != b.showChartDataLabels && a.na("showChartDataLabels", b.showChartDataLabels);
              null != b.showAllChartLabels && a.na("showAllChartLabels", b.showAllChartLabels);
              null != b.chartMultipleMeasures && a.na("chartMultipleMeasures", b.chartMultipleMeasures);
              null != b.showHeaders && a.na("showHeaders", b.showHeaders);
              null != b.showReportFiltersArea && a.na("showReportFiltersArea", b.showReportFiltersArea);
              null != b.showExtraTotalLabels && a.na("showExtraTotalLabels", b.showExtraTotalLabels);
              null != b.grouping && a.na("grouping", b.grouping);
              null != b.editing && a.na("editing", b.editing);
              null != b.drillThrough && a.na("drillThrough", b.drillThrough);
              null != b.showDrillThroughConfigurator && a.na("showDrillThroughConfigurator", b.showDrillThroughConfigurator);
              null != b.sorting && (a.na("sorting", b.sorting), "true" == a.V("sorting").toString().toLowerCase() && a.na("sorting", "on"), "false" == a.V("sorting").toString().toLowerCase() && a.na("sorting", "off"));
              null != b.dragging && a.na("dragging", b.dragging);
              null != b.showHierarchies && a.na("showHierarchies", b.showHierarchies);
              null != b.showChartsWarning && a.na("showChartsWarning", b.showChartsWarning);
              null != b.showChartLegend && a.na("showChartLegend", b.showChartLegend);
              null != b.showChartLegendButton && a.na("showChartLegendButton", b.showChartLegendButton);
              null != b.saveAllFormats && a.na("saveAllFormats", b.saveAllFormats);
              null != b.calculatedValuesOLAP && a.na("calculatedValuesOLAP", b.calculatedValuesOLAP);
              null != b.includeEmptySubtotalsOLAP && a.na("includeEmptySubtotalsOLAP", b.includeEmptySubtotalsOLAP);
              null != b.showChartOneMeasureSelection && a.na("showChartOneMeasureSelection", b.showChartOneMeasureSelection);
              null != b.showChartMeasures && a.na("showChartMeasures", b.showChartMeasures);
              null != b.showTotals && (a.na("showTotals", b.showTotals), "true" == a.V("showTotals").toString().toLowerCase() && a.na("showTotals", "on"), "false" == a.V("showTotals").toString().toLowerCase() && a.na("showTotals", "off"));
              null != b.showGrandTotals && (a.na("showGrandTotals", b.showGrandTotals), "true" == a.V("showGrandTotals").toString().toLowerCase() && a.na("showGrandTotals", "on"), "false" == a.V("showGrandTotals").toString().toLowerCase() && a.na("showGrandTotals", "off"));
              null != b.defaultDateType && a.na("defaultDateType", b.defaultDateType);
              null != b.strictDataTypes && a.na("strictDataTypes", b.strictDataTypes);
              null != b.datePattern && a.na("datePattern", b.datePattern);
              null != b.dateTimePattern && a.na("dateTimePattern", b.dateTimePattern);
              null != b.dateTimezoneOffset && a.na("dateTimezoneOffset", b.dateTimezoneOffset);
              null != b.timePattern && a.na("timePattern", b.timePattern);
              null != b.showCalculatedValuesButton && a.na("showCalculatedValuesButton", b.showCalculatedValuesButton);
              null != b.showOutdatedDataAlert && a.na("showOutdatedDataAlert", b.showOutdatedDataAlert);
              null != b.defaultHierarchySortName && a.na("defaultHierarchySortName", b.defaultHierarchySortName);
              null != b.showAggregationLabels && a.na("showAggregationLabels", b.showAggregationLabels);
              null != b.grandTotalsPosition && a.na("grandTotalsPosition", b.grandTotalsPosition);
              null != b.columnTotalsPosition && a.na("columnTotalsPosition", b.columnTotalsPosition);
              e.v(b.filterWeekOffset) || a.na("filterWeekOffset", b.filterWeekOffset);
              e.v(b.filterDateFormat) || a.na("filterDateFormat", b.filterDateFormat);
              e.v(b.filterLiveSearch) || a.na("filterLiveSearch", b.filterLiveSearch);
              e.v(b.caseSensitiveMembers) || a.na("caseSensitiveMembers", b.caseSensitiveMembers);
              e.v(b.validateFormulas) || a.na("validateFormulas", b.validateFormulas);
              e.v(b.simplifyFieldListFolders) || a.na("simplifyFieldListFolders", b.simplifyFieldListFolders);
              e.v(b.validateReportFiles) || a.na("validateReportFiles", b.validateReportFiles);
              e.v(b.allowBrowsersCache) || a.na("allowBrowsersCache", b.allowBrowsersCache);
              e.v(b.showEmptyValues) || a.na("showEmptyValues", b.showEmptyValues);
              e.v(b.distinguishNullUndefinedEmpty) || a.na("distinguishNullUndefinedEmpty", b.distinguishNullUndefinedEmpty);
              e.v(b.useCaptionsInCalculatedValueEditor) || a.na("useCaptionsInCalculatedValueEditor", b.useCaptionsInCalculatedValueEditor);
              !e.v(b.expandExecutionTimeout) && b.expandExecutionTimeout > a.Vd.expandExecutionTimeout && a.na("expandExecutionTimeout", parseInt(b.expandExecutionTimeout));
              e.v(b.readOnly) || a.na("readOnly", b.readOnly);
              return a;
            }
            static jm(b) {
              var a = {};
              if (void 0 == b) return a;
              null != b.viewType && (a.viewType = b.viewType);
              null != b.configuratorActive && (a.configuratorActive = b.configuratorActive);
              null != b.configuratorButton && (a.configuratorButton = b.configuratorButton);
              null != b.showAggregations && (a.showAggregations = b.showAggregations);
              null != b.showCalculatedValuesButton && (a.showCalculatedValuesButton = b.showCalculatedValuesButton);
              null != b.grouping && (a.grouping = b.grouping);
              null != b.editing && (a.editing = b.editing);
              null != b.drillThrough && (a.drillThrough = b.drillThrough);
              null != b.showDrillThroughConfigurator && (a.showDrillThroughConfigurator = b.showDrillThroughConfigurator);
              null != b.sorting && (a.sorting = b.sorting);
              null != b.strictDataTypes && (a.strictDataTypes = b.strictDataTypes);
              null != b.defaultDateType && (a.defaultDateType = b.defaultDateType);
              null != b.datePattern && (a.datePattern = b.datePattern);
              null != b.dateTimePattern && (a.dateTimePattern = b.dateTimePattern);
              null != b.dateTimezoneOffset && (a.dateTimezoneOffset = b.dateTimezoneOffset);
              null != b.timePattern && (a.timePattern = b.timePattern);
              null != b.saveAllFormats && (a.saveAllFormats = b.saveAllFormats);
              null != b.showDefaultSlice && (a.showDefaultSlice = b.showDefaultSlice);
              null != b.useOlapFormatting && (a.useOlapFormatting = b.useOlapFormatting);
              null != b.showMemberProperties && (a.showMemberProperties = b.showMemberProperties);
              null != b.showEmptyData && (a.showEmptyData = b.showEmptyData);
              null != b.defaultHierarchySortName && (a.defaultHierarchySortName = b.defaultHierarchySortName);
              null != b.calculatedValuesOLAP && (a.calculatedValuesOLAP = b.calculatedValuesOLAP);
              null != b.includeEmptySubtotalsOLAP && (a.includeEmptySubtotalsOLAP = b.includeEmptySubtotalsOLAP);
              null != b.showOutdatedDataAlert && (a.showOutdatedDataAlert = b.showOutdatedDataAlert);
              null != b.showAggregationLabels && (a.showAggregationLabels = b.showAggregationLabels);
              null != b.liveFiltering && (a.liveFiltering = b.liveFiltering);
              null != b.fieldListPosition && (a.fieldListPosition = b.fieldListPosition);
              null != b.classicView && (a.classicView = b.classicView);
              null != b.flatView && (a.flatView = b.flatView);
              null != b.gridType && (a.gridType = b.gridType);
              null != b.gridTitle && (a.gridTitle = b.gridTitle);
              null != b.showFilter && (a.showFilter = b.showFilter);
              null != b.showHeaders && (a.showHeaders = b.showHeaders);
              null != b.showTotals && (a.showTotals = b.showTotals);
              null != b.showGrandTotals && (a.showGrandTotals = b.showGrandTotals);
              null != b.columnTotalsPosition && (a.columnTotalsPosition = b.columnTotalsPosition);
              null != b.grandTotalsPosition && (a.grandTotalsPosition = b.grandTotalsPosition);
              null != b.showExtraTotalLabels && (a.showExtraTotalLabels = b.showExtraTotalLabels);
              null != b.showHierarchies && (a.showHierarchies = b.showHierarchies);
              null != b.showHierarchyCaptions && (a.showHierarchyCaptions = b.showHierarchyCaptions);
              null != b.drillthroughMaxRows && (a.drillThroughMaxRows = b.drillthroughMaxRows);
              null != b.drillThroughMaxRows && (a.drillThroughMaxRows = b.drillThroughMaxRows);
              null != b.showAllFieldsDrillThrough && (a.showAllFieldsDrillThrough = b.showAllFieldsDrillThrough);
              null != b.showReportFiltersArea && (a.showReportFiltersArea = b.showReportFiltersArea);
              null != b.dragging && (a.dragging = b.dragging);
              null != b.showAutoCalculationBar && (a.showAutoCalculationBar = b.showAutoCalculationBar);
              null != b.showFieldListSearch && (a.showFieldListSearch = b.showFieldListSearch);
              null != b.chartType && (a.chartType = b.chartType);
              null != b.chartTitle && (a.chartTitle = b.chartTitle);
              null != b.showFilterInCharts && (a.showFilterInCharts = b.showFilterInCharts);
              null != b.chartMultipleMeasures && (a.chartMultipleMeasures = b.chartMultipleMeasures);
              null != b.chartOneLevel && (a.chartOneLevel = b.chartOneLevel);
              null != b.chartOneLevelTuple && (a.chartOneLevelTuple = b.chartOneLevelTuple);
              null != b.chartOneLevelColumnTuple && (a.chartOneLevelColumnTuple = b.chartOneLevelColumnTuple);
              null != b.chartAutoRange && (a.chartAutoRange = b.chartAutoRange);
              null != b.chartReversedAxes && (a.chartReversedAxes = b.chartReversedAxes);
              null != b.chartAxisShortNumberFormat && (a.chartAxisShortNumberFormat = b.chartAxisShortNumberFormat);
              null != b.showChartLegend && (a.showChartLegend = b.showChartLegend);
              null != b.showChartLegendButton && (a.showChartLegendButton = b.showChartLegendButton);
              null != b.showChartDataLabels && (a.showChartDataLabels = b.showChartDataLabels);
              null != b.showAllChartLabels && (a.showAllChartLabels = b.showAllChartLabels);
              null != b.showChartMeasures && (a.showChartMeasures = b.showChartMeasures);
              null != b.showChartOneMeasureSelection && (a.showChartOneMeasureSelection = b.showChartOneMeasureSelection);
              null != b.showChartsWarning && (a.showChartsWarning = b.showChartsWarning);
              null != b.chartPosition && (a.chartPosition = b.chartPosition);
              null != b.chartActiveTupleIndex && (a.chartActiveTupleIndex = b.chartActiveTupleIndex);
              null != b.chartActiveMeasure && (a.chartActiveMeasure = b.chartActiveMeasure);
              null != b.chartActiveMeasures && (a.chartActiveMeasures = b.chartActiveMeasures);
              e.v(b.filterWeekOffset) || (a.filterWeekOffset = b.filterWeekOffset);
              e.v(b.filterDateFormat) || (a.filterDateFormat = b.filterDateFormat);
              e.v(b.filterLiveSearch) || (a.filterLiveSearch = b.filterLiveSearch);
              e.v(b.validateFormulas) || (a.validateFormulas = b.validateFormulas);
              e.v(b.caseSensitiveMembers) || (a.caseSensitiveMembers = b.caseSensitiveMembers);
              e.v(b.simplifyFieldListFolders) || (a.simplifyFieldListFolders = b.simplifyFieldListFolders);
              e.v(b.validateReportFiles) || (a.validateReportFiles = b.validateReportFiles);
              e.v(b.allowBrowsersCache) || (a.allowBrowsersCache = b.allowBrowsersCache);
              e.v(b.showEmptyValues) || (a.showEmptyValues = b.showEmptyValues);
              e.v(b.distinguishNullUndefinedEmpty) || (a.distinguishNullUndefinedEmpty = b.distinguishNullUndefinedEmpty);
              e.v(b.useCaptionsInCalculatedValueEditor) || (a.useCaptionsInCalculatedValueEditor = b.useCaptionsInCalculatedValueEditor);
              e.v(b.expandExecutionTimeout) || (a.expandExecutionTimeout = b.expandExecutionTimeout);
              e.v(b.readOnly) || (a.readOnly = b.readOnly);
              if (null != b.grid) {
                var c = b.grid;
                null != c.type && (a.gridType = c.type);
                null != c.title && (a.gridTitle = c.title);
                null != c.showFilter && (a.showFilter = c.showFilter);
                null != c.showHeaders && (a.showHeaders = c.showHeaders);
                null != c.showAutoCalculationBar && (a.showAutoCalculationBar = c.showAutoCalculationBar);
                null != c.showTotals && (a.showTotals = c.showTotals, "true" == a.showTotals.toString().toLowerCase() && (a.showTotals = "on"), "false" == a.showTotals.toString().toLowerCase() && (a.showTotals = "off"));
                null != c.showGrandTotals && (a.showGrandTotals = c.showGrandTotals, "true" == a.showGrandTotals.toString().toLowerCase() && (a.showGrandTotals = "on"), "false" == a.showGrandTotals.toString().toLowerCase() && (a.showGrandTotals = "off"));
                null != c.grandTotalsPosition && (a.grandTotalsPosition = c.grandTotalsPosition);
                null != c.columnTotalsPosition && (a.columnTotalsPosition = c.columnTotalsPosition);
                null != c.showExtraTotalLabels && (a.showExtraTotalLabels = c.showExtraTotalLabels);
                null != c.showHierarchies && (a.showHierarchies = c.showHierarchies);
                null != c.showHierarchyCaptions && (a.showHierarchyCaptions = c.showHierarchyCaptions);
                null != c.drillthroughMaxRows && (a.drillThroughMaxRows = c.drillthroughMaxRows);
                null != c.drillThroughMaxRows && (a.drillThroughMaxRows = c.drillThroughMaxRows);
                null != c.showReportFiltersArea && (a.showReportFiltersArea = c.showReportFiltersArea);
                null != c.dragging && (a.dragging = c.dragging);
                null != c.showEmptyValues && (a.showEmptyValues = c.showEmptyValues);
                null != c.distinguishNullUndefinedEmpty && (a.distinguishNullUndefinedEmpty = c.distinguishNullUndefinedEmpty);
              }
              if (null != b.chart) {
                c = b.chart;
                null != c.type && (a.chartType = c.type);
                null != c.title && (a.chartTitle = c.title);
                null != c.showFilter && (a.showFilterInCharts = c.showFilter);
                null != c.multipleMeasures && (a.chartMultipleMeasures = c.multipleMeasures);
                null != c.oneLevel && (a.chartOneLevel = c.oneLevel);
                null != c.autoRange && (a.chartAutoRange = c.autoRange);
                null != c.reversedAxes && (a.chartReversedAxes = c.reversedAxes);
                null != c.showLegend && (a.showChartLegend = c.showLegend);
                null != c.showLegendButton && (a.showChartLegendButton = c.showLegendButton);
                null != c.showDataLabels && (a.showChartDataLabels = c.showDataLabels);
                null != c.showAllLabels && (a.showAllChartLabels = c.showAllLabels);
                null != c.showMeasures && (a.showChartMeasures = c.showMeasures);
                null != c.showOneMeasureSelection && (a.showChartOneMeasureSelection = c.showOneMeasureSelection);
                null != c.showWarning && (a.showChartsWarning = c.showWarning);
                null != c.position && (a.chartPosition = c.position);
                null != c.pieDataIndex && (a.chartActiveTupleIndex = parseInt(c.pieDataIndex));
                null != c.axisShortNumberFormat && (a.chartAxisShortNumberFormat = c.axisShortNumberFormat);
                if (null != c.activeMeasure) if (a.chartMultipleMeasures) {
                  a.chartActiveMeasures = [];
                  let l;
                  Array.isArray(c.activeMeasure) ? l = c.activeMeasure : "object" === typeof c.activeMeasure ? l = [c.activeMeasure] : "string" === typeof c.activeMeasure && (l = c.activeMeasure.split(","));
                  if (!e.v(l)) for (var d = 0; d < l.length; d++) if (null != l[d].uniqueName) {
                    var g = new k.hb.jh(l[d].uniqueName);
                    null != l[d].aggregation && (g.aa = l[d].aggregation);
                    a.chartActiveMeasures.push(g);
                  } else a.chartActiveMeasures.push(new k.hb.jh(l[d]));
                } else a.chartActiveMeasure = new k.hb.jh(), null != c.activeMeasure.uniqueName ? (a.chartActiveMeasure.A = c.activeMeasure.uniqueName, null != c.activeMeasure.aggregation && (a.chartActiveMeasure.aa = c.activeMeasure.aggregation)) : a.chartActiveMeasure.A = c.activeMeasure;
                null != c.oneLevelTuple && (a.chartOneLevelTuple = 0 < c.oneLevelTuple.length ? c.oneLevelTuple.split(",") : void 0);
                null != c.oneLevelColumnTuple && (a.chartOneLevelColumnTuple = 0 < c.oneLevelColumnTuple.length ? c.oneLevelColumnTuple.split(",") : void 0);
              }
              e.v(b.filter) || (b = b.filter, e.v(b.weekOffset) || (a.filterWeekOffset = b.weekOffset), e.v(b.dateFormat) || (a.filterDateFormat = b.dateFormat), e.v(b.liveSearch) || (a.filterLiveSearch = b.liveSearch));
              return a;
            }
            Sa() {
              var b = {};
              null != this.viewType && (b.viewType = this.viewType);
              var a = {};
              this.gridType === e.K.Y.se.FA ? a.type = e.K.Y.se.FA : this.gridType === e.K.Y.se.sv ? a.type = e.K.Y.se.sv : this.gridType === e.K.Y.se.Gh && (a.type = e.K.Y.se.Gh);
              null != this.gridTitle && (a.title = this.gridTitle);
              null != this.showFilter && (a.showFilter = this.showFilter);
              null != this.showHeaders && (a.showHeaders = this.showHeaders);
              null != this.showTotals && (a.showTotals = this.showTotals);
              null != this.showGrandTotals && (a.showGrandTotals = this.showGrandTotals);
              null != this.columnTotalsPosition && (a.columnTotalsPosition = this.columnTotalsPosition);
              null != this.grandTotalsPosition && (a.grandTotalsPosition = this.grandTotalsPosition);
              null != this.showExtraTotalLabels && (a.showExtraTotalLabels = this.showExtraTotalLabels);
              null != this.showHierarchies && (a.showHierarchies = this.showHierarchies);
              null != this.showHierarchyCaptions && (a.showHierarchyCaptions = this.showHierarchyCaptions);
              null != this.drillThroughMaxRows && (a.drillThroughMaxRows = this.drillThroughMaxRows);
              null != this.showReportFiltersArea && (a.showReportFiltersArea = this.showReportFiltersArea);
              null != this.dragging && (a.dragging = this.dragging);
              null != this.showAutoCalculationBar && (a.showAutoCalculationBar = this.showAutoCalculationBar);
              u.Nc.Jg(a) || (b.grid = a);
              a = {};
              null != this.chartType && (a.type = this.chartType);
              null != this.chartTitle && (a.title = this.chartTitle);
              null != this.showFilterInCharts && (a.showFilter = this.showFilterInCharts);
              null != this.chartMultipleMeasures && (a.multipleMeasures = this.chartMultipleMeasures);
              null != this.chartOneLevel && (a.oneLevel = this.chartOneLevel);
              null != this.chartAutoRange && (a.autoRange = this.chartAutoRange);
              null != this.chartReversedAxes && (a.reversedAxes = this.chartReversedAxes);
              null != this.showChartLegend && (a.showLegend = this.showChartLegend);
              null != this.showChartLegendButton && (a.showLegendButton = this.showChartLegendButton);
              null != this.showChartDataLabels && (a.showDataLabels = this.showChartDataLabels);
              null != this.showAllChartLabels && (a.showAllLabels = this.showAllChartLabels);
              null != this.showChartMeasures && (a.showMeasures = this.showChartMeasures);
              null != this.showChartOneMeasureSelection && (a.showOneMeasureSelection = this.showChartOneMeasureSelection);
              null != this.showChartsWarning && (a.showWarning = this.showChartsWarning);
              null != this.chartAxisShortNumberFormat && (a.axisShortNumberFormat = this.chartAxisShortNumberFormat);
              this.viewType == e.K.Id.Zn && null != this.chartPosition && (a.position = this.chartPosition);
              this.chartType == e.K.Cd.Ne.Cv && null != this.chartActiveTupleIndex && (a.pieDataIndex = this.chartActiveTupleIndex.toString());
              if (1 == this.chartMultipleMeasures) {
                if (null != this.chartActiveMeasures) {
                  for (var c = [], d = 0; d < this.chartActiveMeasures.length; d++) {
                    var g = {};
                    g.uniqueName = this.chartActiveMeasures[d].A;
                    null != this.chartActiveMeasures[d].aa && "" !== this.chartActiveMeasures[d].aa && (g.aggregation = this.chartActiveMeasures[d].aa);
                    c.push(g);
                  }
                  0 < c.length && (a.activeMeasure = c);
                }
              } else null != this.chartActiveMeasure && (g = {}, g.uniqueName = this.chartActiveMeasure.A, null != this.chartActiveMeasure.aa && "" != this.chartActiveMeasure.aa && (g.aggregation = this.chartActiveMeasure.aa), a.activeMeasure = g);
              !0 === this.chartOneLevel && null != this.chartOneLevelTuple && 0 < this.chartOneLevelTuple.length && (a.oneLevelTuple = this.chartOneLevelTuple.join(","));
              !0 === this.chartOneLevel && null != this.chartOneLevelColumnTuple && 0 < this.chartOneLevelColumnTuple.length && (a.oneLevelColumnTuple = this.chartOneLevelColumnTuple.join(","));
              u.Nc.Jg(a) || (b.chart = a);
              a = {};
              e.v(this.filterWeekOffset) || (a.weekOffset = this.filterWeekOffset);
              e.v(this.filterDateFormat) || (a.dateFormat = this.filterDateFormat);
              e.v(this.filterLiveSearch) || (a.liveSearch = this.filterLiveSearch);
              u.Nc.Jg(a) || (b.filter = a);
              null != this.configuratorActive && (b.configuratorActive = this.configuratorActive);
              null != this.configuratorButton && (b.configuratorButton = this.configuratorButton);
              null != this.showAggregations && (b.showAggregations = this.showAggregations);
              null != this.showCalculatedValuesButton && (b.showCalculatedValuesButton = this.showCalculatedValuesButton);
              null != this.grouping && (b.grouping = this.grouping);
              null != this.editing && (b.editing = this.editing);
              null != this.drillThrough && (b.drillThrough = this.drillThrough);
              null != this.showDrillThroughConfigurator && (b.showDrillThroughConfigurator = this.showDrillThroughConfigurator);
              null != this.sorting && (b.sorting = this.sorting);
              null != this.defaultDateType && (b.defaultDateType = this.defaultDateType);
              null != this.strictDataTypes && (b.strictDataTypes = this.strictDataTypes);
              null != this.datePattern && (b.datePattern = this.datePattern);
              null != this.dateTimePattern && (b.dateTimePattern = this.dateTimePattern);
              null != this.dateTimezoneOffset && (b.dateTimezoneOffset = this.dateTimezoneOffset);
              null != this.timePattern && (b.timePattern = this.timePattern);
              null != this.saveAllFormats && (b.saveAllFormats = this.saveAllFormats);
              null != this.showDefaultSlice && (b.showDefaultSlice = this.showDefaultSlice);
              null != this.useOlapFormatting && (b.useOlapFormatting = this.useOlapFormatting);
              null != this.showMemberProperties && (b.showMemberProperties = this.showMemberProperties);
              null != this.showEmptyData && (b.showEmptyData = this.showEmptyData);
              null != this.defaultHierarchySortName && (b.defaultHierarchySortName = this.defaultHierarchySortName);
              !0 === this.calculatedValuesOLAP && (b.calculatedValuesOLAP = this.calculatedValuesOLAP);
              !0 === this.includeEmptySubtotalsOLAP && (b.includeEmptySubtotalsOLAP = this.includeEmptySubtotalsOLAP);
              null != this.showOutdatedDataAlert && (b.showOutdatedDataAlert = this.showOutdatedDataAlert);
              null != this.showAggregationLabels && (b.showAggregationLabels = this.showAggregationLabels);
              null != this.showAllFieldsDrillThrough && (b.showAllFieldsDrillThrough = this.showAllFieldsDrillThrough);
              null != this.liveFiltering && (b.liveFiltering = this.liveFiltering);
              null != this.fieldListPosition && (b.fieldListPosition = this.fieldListPosition);
              null != this.showFieldListSearch && (b.showFieldListSearch = this.showFieldListSearch);
              e.v(this.validateFormulas) || (b.validateFormulas = this.validateFormulas);
              e.v(this.caseSensitiveMembers) || (b.caseSensitiveMembers = this.caseSensitiveMembers);
              e.v(this.simplifyFieldListFolders) || (b.simplifyFieldListFolders = this.simplifyFieldListFolders);
              e.v(this.validateReportFiles) || (b.validateReportFiles = this.validateReportFiles);
              e.v(this.allowBrowsersCache) || (b.allowBrowsersCache = this.allowBrowsersCache);
              e.v(this.showEmptyValues) || (b.showEmptyValues = this.showEmptyValues);
              e.v(this.distinguishNullUndefinedEmpty) || (b.distinguishNullUndefinedEmpty = this.distinguishNullUndefinedEmpty);
              e.v(this.useCaptionsInCalculatedValueEditor) || (b.useCaptionsInCalculatedValueEditor = this.useCaptionsInCalculatedValueEditor);
              !e.v(this.expandExecutionTimeout) && this.expandExecutionTimeout > this.Vd.expandExecutionTimeout && (b.expandExecutionTimeout = this.expandExecutionTimeout);
              e.v(this.readOnly) || (b.readOnly = this.readOnly);
              return b;
            }
            static Ek(b) {
              var a = b.find("params"),
                c = new f();
              0 != a.find("param[name=configuratorActive]").length && c.na("configuratorActive", e.P.Zc(a.find("param[name=configuratorActive]").text()));
              0 != a.find("param[name=configuratorButton]").length && c.na("configuratorButton", e.P.Zc(a.find("param[name=configuratorButton]").text()));
              0 != a.find("param[name=viewType]").length && c.na("viewType", a.find("param[name=viewType]").text());
              0 != a.find("param[name=gridTitle]").length && c.na("gridTitle", a.find("param[name=gridTitle]").text());
              0 != a.find("param[name=showFilter]").length && c.na("showFilter", e.P.Zc(a.find("param[name=showFilter]").text()));
              0 != a.find("param[name=showFilterInCharts]").length && c.na("showFilterInCharts", e.P.Zc(a.find("param[name=showFilterInCharts]").text()));
              0 != a.find("param[name=showAggregations]").length && c.na("showAggregations", e.P.Zc(a.find("param[name=showAggregations]").text()));
              0 != a.find("param[name=showHierarchyCaptions]").length && c.na("showHierarchyCaptions", e.P.Zc(a.find("param[name=showHierarchyCaptions]").text()));
              0 != a.find("param[name=showHeaders]").length && c.na("showHeaders", e.P.Zc(a.find("param[name=showHeaders]").text()));
              0 != a.find("param[name=showReportFiltersArea]").length && c.na("showReportFiltersArea", e.P.Zc(a.find("param[name=showReportFiltersArea]").text()));
              0 != a.find("param[name=showExtraTotalLabels]").length && c.na("showExtraTotalLabels", e.P.Zc(a.find("param[name=showExtraTotalLabels]").text()));
              0 != a.find("param[name=editing]").length && c.na("editing", e.P.Zc(a.find("param[name=editing]").text()));
              0 != a.find("param[name=grouping]").length && c.na("grouping", e.P.Zc(a.find("param[name=grouping]").text()));
              0 != a.find("param[name=drillThrough]").length && c.na("drillThrough", e.P.Zc(a.find("param[name=drillThrough]").text()));
              0 != a.find("param[name=showDrillThroughConfigurator]").length && c.na("showDrillThroughConfigurator", e.P.Zc(a.find("param[name=showDrillThroughConfigurator]").text()));
              0 != a.find("param[name=sorting]").length && c.na("sorting", a.find("param[name=sorting]").text());
              0 != a.find("param[name=showHierarchies]").length && c.na("showHierarchies", e.P.Zc(a.find("param[name=showHierarchies]").text()));
              0 != a.find("param[name=showTotals]").length && (c.na("showTotals", a.find("param[name=showTotals]").text()), "true" == c.V("showTotals").toString().toLowerCase() && c.na("showTotals", "on"), "false" == c.V("showTotals").toString().toLowerCase() && c.na("showTotals", "off"));
              0 != a.find("param[name=showGrandTotals]").length && (c.na("showGrandTotals", a.find("param[name=showGrandTotals]").text()), "true" == c.V("showGrandTotals").toString().toLowerCase() && c.na("showGrandTotals", "on"), "false" == c.V("showGrandTotals").toString().toLowerCase() && c.na("showGrandTotals", "off"));
              0 != a.find("param[name=showDefaultSlice]").length && c.na("showDefaultSlice", e.P.Zc(a.find("param[name=showDefaultSlice]").text()));
              0 != a.find("param[name=useOlapFormatting]").length && c.na("useOlapFormatting", e.P.Zc(a.find("param[name=useOlapFormatting]").text()));
              0 != a.find("param[name=showMemberProperties]").length && c.na("showMemberProperties", e.P.Zc(a.find("param[name=showMemberProperties]").text()));
              0 != a.find("param[name=showEmptyData]").length && c.na("showEmptyData", e.P.Zc(a.find("param[name=showEmptyData]").text()));
              0 != a.find("param[name=showChartDataLabels]").length && c.na("showChartDataLabels", e.P.Zc(a.find("param[name=showChartDataLabels]").text()));
              0 != a.find("param[name=showAllChartLabels]").length && c.na("showAllChartLabels", e.P.Zc(a.find("param[name=showAllChartLabels]").text()));
              0 != a.find("param[name=strictDataTypes]").length && c.na("strictDataTypes", e.P.Zc(a.find("param[name=strictDataTypes]").text()));
              0 != a.find("param[name=defaultDateType]").length && c.na("defaultDateType", a.find("param[name = defaultDateType]").text());
              0 != a.find("param[name=datePattern]").length && c.na("datePattern", a.find("param[name = datePattern]").text());
              0 != a.find("param[name=dateTimePattern]").length && c.na("dateTimePattern", a.find("param[name = dateTimePattern]").text());
              0 != a.find("param[name=classicView]").length && 1 == e.P.Zc(a.find("param[name=classicView]").text()) && c.na("gridType", e.K.Y.se.sv);
              b = b.find("dataSource");
              void 0 !== b.attr("tableType") && b.attr("tableType") == e.K.Y.se.Gh && c.na("gridType", e.K.Y.se.Gh);
              0 != a.find("param[name=flatView]").length && 1 == e.P.Zc(a.find("param[name=flatView]").text()) && c.na("gridType", e.K.Y.se.Gh);
              0 != a.find("param[name=defaultHierarchySortName]").length ? c.na("defaultHierarchySortName", e.u.i.Aa.ah(a.find("param[name = defaultHierarchySortName]").text()) ? a.find("param[name=defaultHierarchySortName]").text() : e.u.i.Aa.kc) : c.na("defaultHierarchySortName", c.V("gridType") == e.K.Y.se.Gh ? e.u.i.Aa.ed : e.u.i.Aa.kc);
              0 != a.find("param[name=showCalculatedValuesButton]").length && c.na("showCalculatedValuesButton", e.P.Zc(a.find("param[name = showCalculatedValuesButton]").text()));
              0 != a.find("param[name=showOutdatedDataAlert]").length && c.na("showOutdatedDataAlert", e.P.Zc(a.find("param[name = showOutdatedDataAlert]").text()));
              if (0 != a.find("param[name=chartType]").length) {
                var d = a.find("param[name=chartType]");
                c.na("chartType", d.text());
                if (void 0 !== d.attr("activeMeasure")) {
                  c.na("chartActiveMeasure", new k.hb.jh(d.attr("activeMeasure")));
                  void 0 !== d.attr("activeMeasureAggregation") && c.na("chartActiveMeasure.aggregation", d.attr("activeMeasureAggregation"));
                  var g = [],
                    l = d.attr("activeMeasure").split(","),
                    m = void 0 !== d.attr("activeMeasureAggregation") ? d.attr("activeMeasureAggregation").split(",") : [];
                  for (b = 0; b < l.length; b++) {
                    var n = new k.hb.jh(l[b]);
                    m[b] && (n.aa = m[b]);
                    g.push(n);
                  }
                  0 < g.length && c.na("chartActiveMeasures", g);
                }
                void 0 !== d.attr("pieDataIndex") && c.na("chartActiveTupleIndex", parseInt(d.attr("pieDataIndex")));
                void 0 !== d.attr("position") && c.na("chartPosition", d.attr("position"));
                if (void 0 !== d.attr("chartOneLevelTuple")) {
                  d = d.attr("chartOneLevelTuple").split(",");
                  c.na("chartOneLevelTuple", []);
                  g = [];
                  for (b = 0; b < d.length; b++) g[b] = parseInt(d[b]);
                  c.na("chartOneLevelTuple", g);
                }
              }
              0 != a.find("param[name=chartOneLevel]").length && c.na("chartOneLevel", e.P.Zc(a.find("param[name=chartOneLevel]").text()));
              0 != a.find("param[name=chartTitle]").length && c.na("chartTitle", a.find("param[name=chartTitle]").text());
              0 != a.find("param[name=chartMultipleMeasures]").length && c.na("chartMultipleMeasures", e.P.Zc(a.find("param[name=chartMultipleMeasures]").text()));
              0 != a.find("param[name=chartAutoRange]").length && c.na("chartAutoRange", e.P.Zc(a.find("param[name=chartAutoRange]").text()));
              0 != a.find("param[name=chartReversedAxes]").length && c.na("chartReversedAxes", e.P.Zc(a.find("param[name=chartReversedAxes]").text()));
              0 != a.find("param[name=showChartsWarning]").length && c.na("showChartsWarning", e.P.Zc(a.find("param[name=showChartsWarning]").text()));
              0 != a.find("param[name=showChartOneMeasureSelection]").length && c.na("showChartOneMeasureSelection", e.P.Zc(a.find("param[name=showChartOneMeasureSelection]").text()));
              0 != a.find("param[name=showChartMeasures]").length && c.na("showChartMeasures", e.P.Zc(a.find("param[name=showChartMeasures]").text()));
              0 != a.find("param[name=showChartLegendButton]").length && c.na("showChartLegendButton", e.P.Zc(a.find("param[name=showChartLegendButton]").text()));
              0 != a.find("param[name=saveAllFormats]").length && c.na("saveAllFormats", e.P.Zc(a.find("param[name=saveAllFormats]").text()));
              0 != a.find("param[name=calculatedValuesOLAP]").length && c.na("calculatedValuesOLAP", e.P.Zc(a.find("param[name=calculatedValuesOLAP]").text()));
              0 != a.find("param[name=includeEmptySubtotalsOLAP]").length && c.na("includeEmptySubtotalsOLAP", e.P.Zc(a.find("param[name=includeEmptySubtotalsOLAP]").text()));
              return c;
            }
            gp() {
              var b = z.ba.create("<params/>");
              null != this.V("configuratorActive") && b.append(z.ba.create("<param/>").attr("name", "configuratorActive").text(this.V("configuratorActive")));
              null != this.V("configuratorButton") && b.append(z.ba.create("<param/>").attr("name", "configuratorButton").text(this.V("configuratorButton")));
              null != this.V("viewType") && b.append(z.ba.create("<param/>").attr("name", "viewType").text(this.V("viewType")));
              null != this.V("gridTitle") && b.append(z.ba.create("<param/>").attr("name", "gridTitle").text(this.V("gridTitle")));
              null != this.V("chartTitle") && b.append(z.ba.create("<param/>").attr("name", "chartTitle").text(this.V("chartTitle")));
              null != this.V("showFilter") && b.append(z.ba.create("<param/>").attr("name", "showFilter").text(this.V("showFilter")));
              null != this.V("showFilterInCharts") && b.append(z.ba.create("<param/>").attr("name", "showFilterInCharts").text(this.V("showFilterInCharts")));
              null != this.V("showAggregations") && b.append(z.ba.create("<param/>").attr("name", "showAggregations").text(this.V("showAggregations")));
              null != this.V("showHierarchyCaptions") && b.append(z.ba.create("<param/>").attr("name", "showHierarchyCaptions").text(this.V("showHierarchyCaptions")));
              null != this.V("chartOneLevel") && b.append(z.ba.create("<param/>").attr("name", "chartOneLevel").text(this.V("chartOneLevel")));
              null != this.V("chartAutoRange") && b.append(z.ba.create("<param/>").attr("name", "chartAutoRange").text(this.V("chartAutoRange")));
              null != this.V("chartReversedAxes") && b.append(z.ba.create("<param/>").attr("name", "chartReversedAxes").text(this.V("chartReversedAxes")));
              null != this.V("chartMultipleMeasures") && b.append(z.ba.create("<param/>").attr("name", "chartMultipleMeasures").text(this.V("chartMultipleMeasures")));
              null != this.V("showHeaders") && b.append(z.ba.create("<param/>").attr("name", "showHeaders").text(this.V("showHeaders")));
              null != this.V("showReportFiltersArea") && b.append(z.ba.create("<param/>").attr("name", "showReportFiltersArea").text(this.V("showReportFiltersArea")));
              null != this.V("showExtraTotalLabels") && b.append(z.ba.create("<param/>").attr("name", "showExtraTotalLabels").text(this.V("showExtraTotalLabels")));
              null != this.V("editing") && b.append(z.ba.create("<param/>").attr("name", "editing").text(this.V("editing")));
              null != this.V("grouping") && b.append(z.ba.create("<param/>").attr("name", "grouping").text(this.V("grouping")));
              null != this.V("drillThrough") && b.append(z.ba.create("<param/>").attr("name", "drillThrough").text(this.V("drillThrough")));
              null != this.V("showDrillThroughConfigurator") && b.append(z.ba.create("<param/>").attr("name", "showDrillThroughConfigurator").text(this.V("showDrillThroughConfigurator")));
              null != this.V("sorting") && b.append(z.ba.create("<param/>").attr("name", "sorting").text(this.V("sorting")));
              null != this.V("showTotals") && b.append(z.ba.create("<param/>").attr("name", "showTotals").text(this.V("showTotals")));
              null != this.V("showHierarchies") && b.append(z.ba.create("<param/>").attr("name", "showHierarchies").text(this.V("showHierarchies")));
              null != this.V("showGrandTotals") && b.append(z.ba.create("<param/>").attr("name", "showGrandTotals").text(this.V("showGrandTotals")));
              null != this.V("defaultDateType") && b.append(z.ba.create("<param/>").attr("name", "defaultDateType").text(this.V("defaultDateType")));
              null != this.V("strictDataTypes") && b.append(z.ba.create("<param/>").attr("name", "strictDataTypes").text(this.V("strictDataTypes")));
              null != this.V("datePattern") && b.append(z.ba.create("<param/>").attr("name", "datePattern").text(this.V("datePattern")));
              null != this.V("dateTimePattern") && b.append(z.ba.create("<param/>").attr("name", "dateTimePattern").text(this.V("dateTimePattern")));
              null != this.V("showChartsWarning") && b.append(z.ba.create("<param/>").attr("name", "showChartsWarning").text(this.V("showChartsWarning")));
              null != this.V("showChartOneMeasureSelection") && b.append(z.ba.create("<param/>").attr("name", "showChartOneMeasureSelection").text(this.V("showChartOneMeasureSelection")));
              null != this.V("showChartMeasures") && b.append(z.ba.create("<param/>").attr("name", "showChartMeasures").text(this.V("showChartMeasures")));
              null != this.V("showChartLegendButton") && b.append(z.ba.create("<param/>").attr("name", "showChartLegendButton").text(this.V("showChartLegendButton")));
              null != this.V("saveAllFormats") && b.append(z.ba.create("<param/>").attr("name", "saveAllFormats").text(this.V("saveAllFormats")));
              1 == this.V("calculatedValuesOLAP") && b.append(z.ba.create("<param/>").attr("name", "calculatedValuesOLAP").text(this.V("calculatedValuesOLAP")));
              1 == this.V("includeEmptySubtotalsOLAP") && b.append(z.ba.create("<param/>").attr("name", "includeEmptySubtotalsOLAP").text(this.V("includeEmptySubtotalsOLAP")));
              null != this.V("defaultHierarchySortName") && b.append(z.ba.create("<param/>").attr("name", "defaultHierarchySortName").text(this.V("defaultHierarchySortName")));
              null != this.V("gridType") && this.V("gridType") == e.K.Y.se.sv && b.append(z.ba.create("<param/>").attr("name", "classicView").text(!0));
              null != this.V("gridType") && this.V("gridType") == e.K.Y.se.Gh && b.append(z.ba.create("<param/>").attr("name", "flatView").text(!0));
              null != this.V("showDefaultSlice") && b.append(z.ba.create("<param/>").attr("name", "showDefaultSlice").text(this.V("showDefaultSlice")));
              null != this.V("showEmptyData") && b.append(z.ba.create("<param/>").attr("name", "showEmptyData").text(this.V("showEmptyData")));
              null != this.V("showMemberProperties") && b.append(z.ba.create("<param/>").attr("name", "showMemberProperties").text(this.V("showMemberProperties")));
              null != this.V("useOlapFormatting") && b.append(z.ba.create("<param/>").attr("name", "useOlapFormatting").text(this.V("useOlapFormatting")));
              null != this.V("showChartDataLabels") && b.append(z.ba.create("<param/>").attr("name", "showChartDataLabels").text(this.V("showChartDataLabels")));
              null != this.V("showAllChartLabels") && b.append(z.ba.create("<param/>").attr("name", "showAllChartLabels").text(this.V("showAllChartLabels")));
              null != this.V("showCalculatedValuesButton") && b.append(z.ba.create("<param/>").attr("name", "showCalculatedValuesButton").text(this.V("showCalculatedValuesButton")));
              null != this.V("showOutdatedDataAlert") && b.append(z.ba.create("<param/>").attr("name", "showOutdatedDataAlert").text(this.V("showOutdatedDataAlert")));
              var a = z.ba.create("<param/>").attr("name", "chartType").text(null != this.V("chartType") ? this.V("chartType") : this.Vd.chartType);
              null != this.V("chartActiveTupleIndex") && a.attr("pieDataIndex", this.V("chartActiveTupleIndex").toString());
              a.attr("position", this.V("chartPosition"));
              if (this.V("chartMultipleMeasures") && null != this.V("chartActiveMeasures")) {
                for (var c = [], d = [], g = 0; g < this.V("chartActiveMeasures").length; g++) c.push(this.V("chartActiveMeasures")[g].A), d.push(this.V("chartActiveMeasures")[g].aa);
                0 < c.length && a.attr("activeMeasure", c.join(","));
                0 < d.length && a.attr("activeMeasureAggregation", d.join(","));
              } else null != this.V("chartActiveMeasure") && (a.attr("activeMeasure", this.V("chartActiveMeasure").A), null != this.V("chartActiveMeasure").aa && "" != this.V("chartActiveMeasure").aa && a.attr("activeMeasureAggregation", this.V("chartActiveMeasure").aa));
              this.V("chartOneLevel") && 0 < this.V("chartOneLevelTuple").length && a.attr("chartOneLevelTuple", this.V("chartOneLevelTuple").join(","));
              b.append(a);
              return b;
            }
            SD(b) {
              for (var a in b) this.Vd.hasOwnProperty(a) && void 0 != b[a] && (this[a] = b[a]);
            }
          }
          h.Hq = f;
        })(k.C || (k.C = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor() {
              super();
              if (null != f.instance) throw Error("Singleton");
            }
            static R() {
              null == f.instance && (f.instance = new f());
              return f.instance;
            }
            static dispose() {
              f.Xc = null;
              f.instance = null;
            }
            static add(b) {
              null != b && (f.Xc.Ua(b.id, b), this.eb());
            }
            static get(b) {
              return f.Xc.getItem(b);
            }
            static remove(b) {
              f.Xc.removeItem(b);
              this.eb();
            }
            static F4() {
              f.Xc = new e.ub();
              this.eb();
            }
            static ZAa() {
              for (var b = [], a = 0; a < f.Xc.length; a++) {
                var c = f.Xc.ea(a);
                c.H2 || b.push(c.Sa());
              }
              return b;
            }
            static eb() {
              f.R().Ya(k.Wb.Uc.hk);
            }
          }
          f.Xc = new e.ub();
          h.dn = f;
        })(k.ua || (k.ua = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.id = "";
                this.pu = this.bt = -1;
                this.De = this.hierarchy = this.Zb = this.aa = this.measure = "";
                this.Sd = [];
                this.fH = null;
              }
              get H2() {
                return -1 < this.De.toLowerCase().indexOf(e.u.i.sc.kQ) || -1 < this.De.toLowerCase().indexOf(e.u.i.sc.lQ);
              }
              Sa() {
                var c = {};
                c.id = this.id;
                c.row = this.bt;
                c.column = this.pu;
                void 0 !== this.Hk && (c.isTotal = this.Hk);
                c.measure = this.measure;
                c.aggregation = this.aa;
                c.member = this.Zb;
                c.hierarchy = this.hierarchy;
                c.formula = this.De;
                null != this.format && (c.format = this.format.Sa(), c.formatCSS = this.format.toString());
                return c;
              }
              static zb(c) {
                var d = new b();
                d.id = null != c.id ? c.id : e.P.eM();
                null != c.row && (d.bt = c.row);
                null != c.column && (d.pu = c.column);
                if (null != c.isTotal) {
                  if (1 == c.isTotal || 1 == c.isTotal) d.Hk = !0;
                  if (0 == c.isTotal || 0 == c.isTotal) d.Hk = !1;
                }
                null != c.measure && (d.measure = c.measure);
                null != c.aggregation && (d.aa = c.aggregation);
                null != c.member && (d.Zb = e.u.we.Ps(c.member));
                null != c.hierarchy && (d.hierarchy = e.u.we.Wg(c.hierarchy));
                d.De = c.formula;
                null != c.format && (d.format = "string" === typeof c.format ? a.bT(c.format) : a.zb(c.format));
                c = new u.IJ();
                d.Sd = c.parse(d.De);
                return null == d.Sd ? null : d;
              }
            }
            f.Z6 = b;
            class a {
              static zb(c) {
                var d = new a();
                if (null == c) return d;
                null != c.backgroundColor && (d.backgroundColor = a.color(c.backgroundColor));
                null != c.color && (d.color = a.color(c.color));
                null != c.fontFamily && (d.fontFamily = c.fontFamily);
                null != c.fontSize && (d.fontSize = a.size(c.fontSize));
                null != c.italic && c.italic && (d.fontStyle = "italic");
                null != c.fontStyle && (d.fontStyle = c.fontStyle);
                null != c.bold && c.bold && (d.fontWeight = "bold");
                null != c.fontWeight && (d.fontWeight = c.fontWeight);
                null != c.padding && (d.padding = a.size(Math.round(1.5 * c.padding)));
                null != c.textAlign && (d.textAlign = c.textAlign);
                null != c.textIndent && (d.textIndent = a.size(c.textIndent));
                return d;
              }
              static bT(c) {
                var d = {};
                c = c.split(";");
                if (null != c) for (var g = 0; g < c.length; g++) {
                  var l = c[g].split(":")[0];
                  "" != l && (d[l] = c[g].split(":")[1]);
                }
                return a.zb(d);
              }
              Sa() {
                var c = {};
                null != this.backgroundColor && (c.backgroundColor = this.backgroundColor);
                null != this.color && (c.color = this.color);
                null != this.fontFamily && (c.fontFamily = this.fontFamily);
                null != this.fontSize && (c.fontSize = this.fontSize);
                null != this.fontStyle && (c.fontStyle = this.fontStyle);
                null != this.fontWeight && (c.fontWeight = this.fontWeight);
                null != this.padding && (c.padding = this.padding);
                null != this.textAlign && (c.textAlign = this.textAlign);
                null != this.textIndent && (c.textIndent = this.textIndent);
                return c;
              }
              gja() {
                var c = {};
                null != this.backgroundColor && (c["background-color"] = this.backgroundColor);
                null != this.color && (c.color = this.color);
                null != this.fontFamily && (c["font-family"] = this.fontFamily);
                null != this.fontSize && (c["font-size"] = this.fontSize);
                null != this.fontStyle && (c["font-style"] = this.fontStyle);
                null != this.fontWeight && (c["font-weight"] = this.fontWeight);
                null != this.padding && (c.padding = this.padding);
                null != this.textAlign && (c["text-align"] = this.textAlign);
                null != this.textIndent && (c["text-indent"] = this.textIndent);
                return c;
              }
              toString() {
                var c = "",
                  d = this.gja(),
                  g;
                for (g in d) c += g + ":" + d[g] + ";";
                return c;
              }
              static color(c) {
                return c.replace("0x", "#");
              }
              static size(c) {
                return "number" == typeof c ? c + "px" : "string" == typeof c && 0 > c.indexOf("px") ? c.trim() + "px" : c;
              }
            }
            f.wMa = a;
          })(h.W || (h.W = {}));
        })(k.ua || (k.ua = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        var h;
        (function (f) {
          class b extends v.Fh {
            constructor() {
              super();
              if (null != b.instance) throw Error("Singleton");
            }
            static R() {
              null == b.instance && (b.instance = new b());
              return b.instance;
            }
            static dispose() {
              b.sh = null;
              b.ug = null;
              b.Ff = null;
              b.Hj = null;
              b.qR = null;
              b.gG = null;
              b.Fg = null;
              b.yf = null;
              b.xk = null;
              b.yQ = null;
              b.MF = null;
              b.instance = null;
            }
            static get Iha() {
              return this.qR = b.Sa(e.u.i.ha.Ia);
            }
            static get sba() {
              return this.yQ = b.Sa(e.u.i.ha.Ra);
            }
            static clear() {
              b.Ff = {};
              b.yf = {};
              b.gG = {};
              b.qR = {};
              b.MF = {};
              b.yQ = {};
              b.Hj = {};
              b.xk = {};
              b.ug = [];
              b.Fg = [];
              b.sh = [];
            }
            static j_(a) {
              if (b.$aa(a.Ff) || b.$aa(a.yf)) b.gG = b.Bba(a.Ff), b.MF = b.Bba(a.yf), b.lha();else if (b.aba(a.Ff) || b.aba(a.yf)) b.gG = a.Ff, b.MF = a.yf, b.lha();
              b.Hj = a.Hj;
              b.xk = a.xk;
              b.ug = a.ug;
              b.Fg = a.Fg;
              b.sh = a.sh;
            }
            static lha() {
              k.Va.R().Fa.nE == k.Wb.Uc.pi ? this.kq() : e.u.Ma.R().N(e.u.yg.al, b.kq, 1);
            }
            static $aa(a) {
              var c = /[A-Za-z]+/,
                d;
              for (d in a) if (-1 < a[d].toString().search(c)) return !0;
              return !1;
            }
            static aba(a) {
              var c = /[A-Za-z]+/,
                d;
              for (d in a) if (-1 < d.toString().search(c)) return !0;
              return !1;
            }
            static Bba(a) {
              var c = {};
              if (null != a) for (var d in a) {
                var g = a[d];
                if (Array.isArray(g) && 0 < g.length) {
                  var l = parseInt(g.pop());
                  c[g.toString()] = l;
                }
              }
              return c;
            }
            static kq() {
              e.u.Ma.R().pb(e.u.yg.al, b.kq);
              b.Ff = b.zb(e.u.i.ha.Ia);
              b.gG = {};
              b.yf = b.zb(e.u.i.ha.Ra);
              b.MF = {};
            }
            static zb(a) {
              var c = {},
                d = a == e.u.i.ha.Ia ? b.gG : b.MF,
                g = e.u.Ma.R().pa.gd(),
                l;
              for (l in d) {
                var m = l.split(","),
                  n = d[l],
                  p = e.u.Ma.R().pa.axes.getItem(a).ab;
                if (p && !k.C.F.tc) if (e.u.i.da.tA(m[m.length - 1]) || "" == m[m.length - 1] && ("" == m[m.length - 2] || null != g.find(C => C.A === m[m.length - 2]))) {
                  var t = new k.hb.jh(m[m.length - 2], m[m.length - 1]);
                  m.splice(m.length - 2, 2);
                } else t = new k.hb.jh(m[m.length - 1]), m.splice(m.length - 1, 1);
                for (var r = !1, w = [], y = 0; y < m.length; y++) if (k.C.F.tc) {
                  if (a == e.u.i.ha.Ia) w.push(m[y]);else {
                    var A = m[y];
                    A = e.u.Ma.R().ta.je.indexOf(A);
                    if (-1 == A) {
                      r = !0;
                      break;
                    }
                    w.push(A);
                  }
                } else {
                  A = e.u.we.Ps(m[y]);
                  var B = a == e.u.i.ha.Ia ? e.u.Ma.R().pa.xb.ea(y) : e.u.Ma.R().pa.Db.ea(y);
                  if (void 0 == B) {
                    r = !0;
                    break;
                  }
                  A = B.Ib(A);
                  if (null == A) {
                    r = !0;
                    break;
                  }
                  A.dc ? w.push("") : w.push(A.ordinal.toString());
                }
                if (!r) {
                  if (p && !k.C.F.tc) {
                    p = (p = e.u.Ma.R().pa.Di(t)) ? p.index : -1;
                    if (-1 == p && "" != t.A) continue;
                    w.push(p);
                  }
                  c[w.toString()] = n;
                }
              }
              return c;
            }
            static Sa(a) {
              var c = {},
                d = a == e.u.i.ha.Ia ? b.Ff : b.yf,
                g = e.v(e.u.Ma.R().pa) ? [] : e.u.Ma.R().pa.gd(),
                l;
              for (l in d) {
                var m = l.split(","),
                  n = d[l],
                  p = e.u.Ma.R().pa.axes.getItem(a).ab;
                if (p && !k.C.F.tc) {
                  var t = parseInt(m[m.length - 1]);
                  m.splice(m.length - 1, 1);
                }
                for (var r = !1, w = [], y = 0; y < m.length; y++) if (k.C.F.tc) {
                  if (a == e.u.i.ha.Ia) w.push(m[y]);else {
                    var A = "" === m[y] ? 0 : parseInt(m[y]);
                    A = e.u.Ma.R().ta.je[A];
                    if (null == A) {
                      r = !0;
                      break;
                    }
                    w.push(A);
                  }
                } else {
                  A = "" === m[y] ? 0 : parseInt(m[y]);
                  var B = a == e.u.i.ha.Ia ? e.u.Ma.R().pa.xb.ea(y) : e.u.Ma.R().pa.Db.ea(y);
                  if (null == B) {
                    r = !0;
                    break;
                  }
                  A = B.za(A);
                  if (null == A) {
                    r = !0;
                    break;
                  }
                  w.push(A.Ci);
                }
                if (!r) {
                  if (p && !k.C.F.tc) {
                    if (t >= g.length) continue;
                    -1 == t && 1 == g.length && (t = 0);
                    m = g[t];
                    w.push(m ? m.A : "");
                    w.push(m ? m.aa : "");
                  }
                  c[w.toString()] = n;
                }
              }
              return c;
            }
            static EH() {
              const a = new k.hb.Kv();
              a.Ff = h.ud.Iha;
              a.yf = h.ud.sba;
              a.ug = h.ud.ug;
              a.Fg = h.ud.Fg;
              a.Hj = h.ud.Hj;
              a.xk = h.ud.xk;
              a.sh = h.ud.sh;
              a.HE = h.ud.HE;
              return a;
            }
          }
          b.Ff = {};
          b.yf = {};
          b.HE = 0;
          b.Hj = {};
          b.xk = {};
          b.ug = [];
          b.Fg = [];
          b.sh = [];
          b.gG = {};
          b.qR = {};
          b.MF = {};
          b.yQ = {};
          f.ud = b;
        })(h = k.size || (k.size = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static load(b, a) {
              if (!e.v(f.YS[b])) return a(null, f.YS[b]);
              var c = new z.J9();
              c.N(v.ga.Qc, () => {
                try {
                  var d = e.P.jxa(new Uint8Array(c.response)),
                    g = window.btoa(d);
                  f.YS[b] = {
                    name: b.substring(b.lastIndexOf("/") + 1, b.lastIndexOf(".")),
                    filename: b.substr(b.lastIndexOf("/") + 1),
                    content: g
                  };
                  a(null, f.YS[b]);
                } catch (l) {
                  a(l);
                }
              });
              c.N(v.ga.xa, () => {
                a({
                  message: k.B.j.Ioa,
                  name: null
                });
              });
              c.load(b);
            }
          }
          f.YS = {};
          h.a8 = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b, a) {
              this.hR = b;
              this.sZ = a;
            }
            get Nk() {
              return this.hR;
            }
            get Ch() {
              return this.sZ;
            }
            CBa() {
              return Math.round(this.Nk * f.h$ / f.U$);
            }
            FAa() {
              return Math.round(this.Ch * f.h$ / f.U$);
            }
            static get oxa() {
              return f.Tra;
            }
            static Kja(b) {
              return void 0 != b && f.W$.hasOwnProperty(b.toLocaleLowerCase()) ? b.toLocaleLowerCase() : f.oxa;
            }
            static yH(b) {
              return this.W$[b];
            }
          }
          f.U$ = 25.4;
          f.Tra = "a4";
          f.h$ = 72;
          f.W$ = {
            a0: new f(841, 1189),
            a1: new f(594, 841),
            a2: new f(420, 594),
            a3: new f(297, 420),
            a4: new f(210, 297),
            a5: new f(148, 210)
          };
          h.ky = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              throw Error("Singleton");
            }
            static Xe(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              switch (a.type) {
                case h.nj.zv:
                  f.MS(b, a, c, d);
                  break;
                case h.nj.VA:
                  f.Tca(b, a, c, d);
                  break;
                case h.nj.cB:
                  f.pya(b, a, c, d);
              }
            }
            static R_(b) {
              var a = b.find("line", !0);
              a = a.concat(b.find("path", !0));
              a = a.concat(b.find("circle", !0));
              for (var c = 0; c < a.length; c++) if (null != a[c]) {
                var d = e.K.Y.W.cd.nz(a[c], ["fill", "stroke", "shape-rendering", "stroke-width"]);
                u.Jd().cj && (d += "stroke-width: 1px");
                a[c].attr("style", d);
                a[c].attr("class", "");
              }
              a = b.find("text", !0);
              for (c = 0; c < a.length; c++) b = parseInt(a[c].U("font-size")), a[c].attr("style", e.K.Y.W.cd.nz(a[c], "font-family font-weight fill color text-anchor text-rendering".split(" ")) + ";white-space:pre"), a[c].attr("font-size", b), a[c].attr("class", "");
            }
            static Dba(b) {
              b.element.querySelectorAll("text").forEach(a => {
                a.innerHTML = a.innerHTML.replace(/\s/g, "<tspan> </tspan>");
              });
            }
            static Saa(b, a) {
              b.U("font-family", a.U("font-family"));
              b.U("font-size", a.U("font-size"));
              b.U("color", a.U("color"));
              b.U("border-top", a.U("border-top"));
              b.U("background", a.U("background"));
              b.U("padding-top", a.U("padding-top"));
              b.U("padding-left", a.U("padding-left"));
              b.U("padding-right", a.U("padding-right"));
              b.U("padding-bottom", a.U("padding-bottom"));
              b.U("overflow", "auto");
              for (var c = a.find(".fm-icon-display"), d = b.find(".fm-icon-display", !0), g = 0; g < d.length; g++) d[g].U("display", c.U("display")), d[g].U("width", c.U("width")), d[g].U("height", c.U("height")), d[g].U("margin-right", c.U("margin-right")), d[g].U("vertical-align", c.U("vertical-align")), d[g].U("border-radius", c.U("border-radius")), d[g].text("");
              c = a.find(".fm-text-display");
              d = b.find(".fm-text-display", !0);
              for (g = 0; g < d.length; g++) d[g].U("color", c.U("color")), d[g].U("font-family", c.U("font-family")), d[g].U("font-size", c.U("font-size")), d[g].U("vertical-align", c.U("vertical-align")), d[g].U("margin-bottom", c.U("margin-bottom") || 0);
              c = a.find("ul");
              d = b.find("ul", !0);
              for (g = 0; g < d.length; g++) d[g].U("list-style-type", c.U("list-style-type")), d[g].U("padding-top", c.U("padding-top") || 0), d[g].U("padding-right", c.U("padding-right") || 0), d[g].U("padding-bottom", c.U("padding-bottom") || 0), d[g].U("padding-left", c.U("padding-left") || 0), d[g].U("margin-top", c.U("margin-top") || 0), d[g].U("margin-right", c.U("margin-right") || 0), d[g].U("margin-bottom", c.U("margin-bottom") || 0), d[g].U("margin-left", c.U("margin-left") || 0);
              c = a.find("td");
              d = b.find("td", !0);
              for (g = 0; g < d.length; g++) d[g].U("padding-top", c.U("padding-top")), d[g].U("padding-right", c.U("padding-right")), d[g].U("padding-bottom", c.U("padding-bottom")), d[g].U("padding-left", c.U("padding-left")), d[g].U("vertical-align", c.U("vertical-align"));
              a = a.find("li", !0);
              d = b.find("li", !0);
              for (g = 0; g < d.length; g++) d[g].U("padding-left", a[g].U("padding-left")), d[g].U("padding-top", a[g].U("padding-top")), d[g].U("padding-bottom", a[g].U("padding-bottom")), d[g].U("white-space", "nowrap");
              b.find("table").U("width", "initial");
            }
            static AL(b) {
              var a = "";
              e.ia(b) || (a = b.replace(/##PAGE-NUMBER##/gi, f.sl++ + ""), a = a.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString()));
              return a;
            }
            static MS(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var g = b.vs.us.G.find("svg").clone();
              try {
                c || f.cC(k.C.F.An, g, b.vs.Fr.G);
                c && (g.attr("viewBox", "0 0 " + g.attr("width") + " " + g.attr("height")), g.U("width", "100%"));
                b.G.append(g);
                f.R_(g);
                g.G4("class");
                var l = z.ba.Kc(z.yY.Xb(g.element));
                g.remove();
                if (b.vs.sg) {
                  var m = b.vs.sg.G.clone();
                  f.Saa(m, b.vs.sg.G);
                  c && (m.U("max-width", ""), m.U("padding-bottom", "20px"));
                  l += m.element.outerHTML;
                }
                if (c) return null != d && d(l), l;
                b = "<!DOCTYPE html><html><head><meta charset='UTF-8'/><title>{0}</title></head><body>{1}{2}{3}</body></html>";
                m = "";
                e.ia(a.$i) || (m = a.$i, m = m.replace(/##PAGE-NUMBER##/gi, ""), m = m.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString()));
                var n = "";
                e.ia(a.xj) || (n = a.xj, n = n.replace(/##PAGE-NUMBER##/gi, ""), n = n.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString()));
                b = e.P.bind(b, e.ia(k.C.F.An) ? k.B.j.iX : k.C.F.An, m, l, n);
                b = z.ba.format(b);
                0 == a.filename.length && (a.filename = "pivotchart.html");
                h.Yn.save(b, a);
                k.Va.R().Ea(new v.ga(e.bf.ig));
              } catch (p) {
                console.error("Export Charts error:", p);
                g.remove();
                e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa);
                if (c) return null != d && d(""), "";
                k.Va.R().Ea(new v.ga(e.bf.ig));
              }
            }
            static nS(b) {
              if (null == b) return null;
              b = b.replace(/##PAGE-NUMBER##/gi, "");
              b = b.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString());
              return new x.Ga("div").U("background", "white").U("text-align", "left").U("z-index", -1).html(b);
            }
            static uya(b) {
              const a = b.find(".fm-charts-layout");
              b = b.find(".fm-chart-legend-container");
              const c = a.parent,
                d = c.parent;
              d.element.style.border = "0px";
              b && (b.element.style.backgroundColor = "transparent", b.element.style.border = "0px");
              d.element.innerHTML = "";
              d.append(c);
              a.find(".fm-header-toolbar") && a.find(".fm-header-toolbar").remove();
            }
            static Tca(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              const g = ["lib/html2canvas.v1.min.js", "lib/canvg.min.js"];
              u.Jd().cj && g.unshift("lib/promise.min.js");
              u.io.load(g, () => {
                const l = document.createElement("canvas"),
                  m = b.vs.us.G.find("svg").clone(),
                  n = e.K.Nb.Gb.G.clone();
                let p = null;
                try {
                  m.prepend(new x.Ga("rect").U("width", "100%").U("height", "100%").U("fill", "white"));
                  f.xha(m);
                  b.G.append(m);
                  f.R_(m);
                  f.Dba(m);
                  const t = z.ba.Kc(z.yY.Xb(m.element));
                  canvg(l, t);
                  m.remove();
                  const r = new x.Ga("img").attr("src", l.toDataURL());
                  c && r.U("max-width", "100%");
                  n.find("svg").before(r);
                  n.find("svg").remove();
                  f.uya(n);
                  p = new x.Ga("div");
                  e.ia(a.$i) || p.append(this.nS(a.$i));
                  p.append(n);
                  p.U("padding-top", "10px");
                  p.U("padding-bottom", "10px");
                  e.ia(a.xj) || p.append(this.nS(a.xj));
                  const w = window.getComputedStyle(b.G.element);
                  if (c) return null != d && (p.U("position", b.G.U("position")), p.U("top", b.G.U("top")), p.U("bottom", b.G.U("bottom")), p.U("left", b.G.U("left")), p.U("right", b.G.U("right")), p.U("width", w.width), p.U("height", w.height), d(p)), p.html();
                  p.U("position", "absolute").U("top", 0).U("left", 0).U("overflow", "hidden").U("text-align", "center").U("background", "white").U("z-index", -1).U("width", w.width).U("height", w.height);
                  e.K.Nb.Gb.G.element.ownerDocument.body.append(p.element);
                  p.U("left", -p.left - p.width + "px");
                  html2canvasV1(p.element).then(y => {
                    n.remove();
                    p.remove();
                    a.IC == k.hb.mp.dB ? h.Yn.save(y, a) : (y = e.P.$ba(y.toDataURL()), 0 == a.filename.length && (a.filename = "pivotchart.png"), h.Yn.save(y, a));
                    k.Va.R().Ea(new v.ga(e.bf.ig));
                    f.clear();
                  }).catch(y => {
                    console.error("Export Charts error:", y);
                    m.remove();
                    n.remove();
                    null != p && p.remove();
                    e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa);
                    c && null != d ? d("") : k.Va.R().Ea(new v.ga(e.bf.ig));
                    f.clear();
                  });
                } catch (t) {
                  console.error("Export Charts error:", t), n.remove(), m.remove(), null != p && p.remove(), e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), c && null != d ? d("") : k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear();
                }
              });
            }
            static cC(b, a, c) {
              if (0 < b.length) {
                var d = e.K.Y.W.cd.nz(c, ["font-family", "font-size", "font-weight", "color"]);
                b = new x.Ga("text").attr("x", "50%").attr("style", "text-anchor:middle;" + d).text(b);
                a.prepend(b);
                b.attr("y", c.height);
                b = a.find("g");
                d = d3v3.transform(b.attr("transform"));
                d.translate[1] += c.height;
                b.attr("transform", d.toString());
                a.attr("height", parseInt(a.attr("height")) + c.height);
              }
            }
            static get WC() {
              var b = h.ky.yH(f.xr);
              return "portrait" === f.sb.bE ? b.Ch : b.Nk;
            }
            static get XC() {
              var b = h.ky.yH(f.xr);
              return "portrait" === f.sb.bE ? b.Nk : b.Ch;
            }
            static pya(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              e.Da(!0, k.B.j.tF, "...", !0, !0);
              const g = ["lib/html2canvas.v1.min.js", "lib/jspdf.min.js"];
              u.Jd().cj && g.unshift("lib/promise.min.js");
              u.io.load(g, () => {
                f.sb = a;
                f.xr = h.ky.Kja(a.xr);
                f.Fd = new jspdf.jsPDF(a.bE, "mm", f.xr, !u.Jd().cj);
                f.ff = d;
                f.us = b;
                f.A4 = c;
                f.Ch = f.WC - 2 * f.Yh;
                f.Nk = f.XC - 2 * f.Yh;
                f.og = f.Yh;
                try {
                  f.Y2(() => {
                    f.pS(this.sb.$i, this.sb.xj, () => this.D3());
                  });
                } catch (l) {
                  console.error("Export PDF error:", l), e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), e.Da(!1), k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear();
                }
              });
            }
            static Y2(b) {
              e.v(f.sb.XS) ? b() : h.a8.load(f.sb.XS, (a, c) => {
                e.v(a) ? e.v(c) || (f.font = c, f.Fd.addFileToVFS(c.filename, c.content), f.Fd.addFont(c.filename, c.name, "normal")) : e.Wa(a.message, k.B.j.xa, e.tb.xa);
                b();
              });
            }
            static pS(b, a, c) {
              var d = null == b,
                g = null == a,
                l = !1;
              if (d && g) c();else {
                if (!d) {
                  b = b.replace(/##PAGE-NUMBER##/gi, (f.sl + 1).toString());
                  b = b.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString());
                  var m = new x.Ga("div");
                  m.U("position", "absolute");
                  m.U("background", "white");
                  m.Tk(h.$e.Oz(f.XC - 2 * f.Oi));
                  m.html(b);
                  e.K.Nb.Gb.G.element.ownerDocument.body.append(m.element);
                  html2canvasV1(m.element, {
                    scale: h.$e.Ih
                  }).then(p => {
                    m.remove();
                    f.Nm = p;
                    d = !0;
                    g && c();
                  }).catch(p => {
                    console.error("Export Charts error:", p);
                    m.remove();
                    l || (l = !0, e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear());
                  });
                }
                if (!g) {
                  a = a.replace(/##PAGE-NUMBER##/gi, (f.sl + 1).toString());
                  a = a.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString());
                  var n = new x.Ga("div");
                  n.U("position", "absolute");
                  n.U("background", "white");
                  n.Tk(h.$e.Oz(f.XC - 2 * f.Oi));
                  n.html(a);
                  e.K.Nb.Gb.G.element.ownerDocument.body.append(n.element);
                  html2canvasV1(n.element, {
                    scale: h.$e.Ih
                  }).then(p => {
                    n.remove();
                    f.Tp = p;
                    g = !0;
                    d && c();
                  }).catch(p => {
                    console.error("Export Charts error:", p);
                    m.remove();
                    l || (l = !0, e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear());
                  });
                }
              }
            }
            static VZ(b, a) {
              b.addImage(a, "JPEG", f.Oi, f.Oi, h.$e.bg(a.width / h.$e.Ih), h.$e.bg(a.height / h.$e.Ih));
            }
            static UZ(b, a) {
              b.addImage(a, "JPEG", f.Oi, f.WC - h.$e.bg(f.Tp.height / h.$e.Ih) - f.Oi, h.$e.bg(a.width / h.$e.Ih), h.$e.bg(a.height / h.$e.Ih));
            }
            static AR() {
              null != f.Nm && f.VZ(f.Fd, f.Nm);
              null != f.Tp && f.UZ(f.Fd, f.Tp);
              f.Ch = f.WC;
              f.Ch -= e.v(f.Nm) ? f.Yh : h.$e.bg(f.Nm.height / h.$e.Ih) + 2 * f.Oi;
              f.Ch -= e.v(f.Tp) ? f.Yh : h.$e.bg(f.Tp.height / h.$e.Ih) + 2 * f.Oi;
              f.og = e.v(f.Nm) ? f.Yh : h.$e.bg(f.Nm.height / h.$e.Ih) + 2 * f.Oi;
            }
            static D3() {
              f.AR();
              f.sJa();
            }
            static Gua(b) {
              var a = f.us.vs.us.G.find("svg").clone(),
                c = document.createElement("canvas");
              a.prepend(new x.Ga("rect").U("width", "100%").U("height", "100%").U("fill", "white"));
              f.xha(a);
              a.attr("width", parseInt(a.attr("width")) * h.$e.Ih);
              a.attr("height", parseInt(a.attr("height")) * h.$e.Ih);
              f.us.G.append(a);
              f.R_(a);
              f.Dba(a);
              canvg(c, z.ba.Kc(z.yY.Xb(a.element)), {
                scaleWidth: a.width * h.$e.Ih,
                scaleHeight: a.height * h.$e.Ih
              });
              a.detach();
              b(c);
            }
            static yDa(b) {
              if (e.v(f.us.vs.sg)) b(null);else {
                var a = f.us.vs.sg.G.clone();
                a.width = f.us.vs.width;
                f.Saa(a, f.us.vs.sg.G);
                a.U("border", "none").U("position", "absolute").U("top", 0).U("left", 0).U("overflow", "hidden").U("background", "white").U("z-index", -1);
                f.A4 && a.U("width", "100%").U("max-width", "");
                e.K.Nb.Gb.G.element.ownerDocument.body.append(a.element);
                html2canvasV1(a.element, {
                  scale: h.$e.Ih
                }).then(c => {
                  a.remove();
                  b(c);
                }).catch(c => {
                  console.error("Export Charts error:", c);
                  a.remove();
                  e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa);
                  k.Va.R().Ea(new v.ga(e.bf.ig));
                  f.clear();
                });
              }
            }
            static sJa() {
              const b = ["lib/html2canvas.v1.min.js", "lib/canvg.min.js"];
              u.Jd().cj && b.unshift("lib/promise.min.js");
              u.io.load(b, () => {
                try {
                  f.Gua(a => {
                    f.yDa(c => {
                      var d = document.createElement("canvas");
                      d.width = a.width;
                      d.height = a.height + (c ? h.$e.Oz(f.Yh) / 2 + c.height : 0);
                      var g = d.getContext("2d");
                      g.fillStyle = "#FFFFFF";
                      g.fillRect(0, 0, d.width, d.height);
                      g.drawImage(a, 0, 0);
                      c && g.drawImage(c, 0, d.height - c.height);
                      f.A4 && null != f.ff ? (k.C.F.ke == e.K.Id.kj && 0 == f.sb.filename.length && (f.sb.filename = "pivotcharts.pdf"), f.ff(d)) : (f.og += h.$e.cC(k.C.F.An, f.Fd, f.og, f.font), c = f.Sha(h.$e.bg(d.width), h.$e.bg(d.height), f.Nk, f.Ch), f.Fd.addImage(d, "JPEG", f.Yh + c.x, f.og, c.width, c.height), 0 == f.sb.filename.length && (f.sb.filename = "pivotcharts.pdf"), f.sb.IC == k.hb.mp.dB ? h.Yn.save(f.Fd, f.sb) : h.Yn.save(e.P.D5(f.Fd.output()), f.sb), f.clear(), k.Va.R().Ea(new v.ga(e.bf.ig)));
                    });
                  });
                } catch (a) {
                  console.error("Export Charts error:", a), e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), f.A4 && null != f.ff ? f.ff(null) : k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear();
                }
              });
            }
            static clear() {
              f.us = null;
              f.sb = null;
              f.Fd = null;
              f.og = 0;
              f.Ch = 0;
              f.Nk = 0;
              f.sl = 0;
              f.Nm = null;
              f.Tp = null;
            }
            static xha(b) {
              b = b.find("title", !0);
              for (var a = 0; a < b.length; a++) b[a].remove();
            }
            static Sha(b, a, c, d) {
              var g = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
              };
              if (b > c - 0 || a > d - 0) d = Math.min((c - 0) / b, (d - 0) / a), b *= d, a *= d;
              g.x = (c - 0 - b) / 2;
              g.y = 0;
              g.width = b;
              g.height = a;
              return g;
            }
          }
          f.font = null;
          f.ff = null;
          f.Oi = 5;
          f.Yh = 15;
          f.xr = "a4";
          f.sl = 0;
          h.IA = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              throw Error("Singleton");
            }
            static Xe(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              b = ["lib/html2canvas.v1.min.js"];
              u.Jd().cj && b.unshift("lib/promise.min.js");
              u.io.load(b, () => {
                f.sb = a;
                this.Hwa();
                var d = e.K.Nb.Gb.G;
                const g = d.clone(),
                  l = this.nS(g, c);
                d.element.ownerDocument.body.appendChild(l.element);
                d = window.getComputedStyle(d.element);
                l.Er(d.height);
                l.Tk(d.width);
                l.U("left", -l.left - l.width + "px");
                html2canvasV1(l.element).then(m => {
                  f.NEa(m);
                  l.Lg();
                }).catch(m => {
                  console.error("Export Image error:", m);
                  e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa);
                  l.Lg();
                  k.Va.R().Ea(new v.ga(e.bf.ig));
                  f.clear();
                });
              }, () => {
                k.Va.R().Ea(new v.ga(e.bf.ig));
                f.clear();
              });
            }
            static nS(b, a) {
              a = new x.Ga("div").U("position", "absolute").U("top", "0px").U("left", "0px").U("overflow", "hidden").U("text-align", "center").U("background", "white").Tk(e.K.Nb.Hx).U("z-index", -1).append(a);
              null != f.zz && a.append(f.zz);
              b.find(".fm-fields-view-wrap").remove();
              a.append(b.U("position", "relative"));
              null != f.kz && a.append(f.kz);
              return a;
            }
            static Hwa() {
              const b = h.ky.yH("a4");
              let a = this.sb.$i,
                c = this.sb.xj,
                d = null == a,
                g = null == c;
              d && g || (d || (a = a.replace(/##PAGE-NUMBER##/gi, ""), a = a.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString()), this.zz = new x.Ga("div"), this.zz.U("background", "white"), this.zz.U("text-align", "left"), this.zz.U("z-index", -1), this.zz.Tk(h.$e.Oz(b.Nk - 2 * this.Oi)), this.zz.html(a)), g || (c = c.replace(/##PAGE-NUMBER##/gi, ""), c = c.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString()), this.kz = new x.Ga("div"), this.kz.U("background", "white"), this.kz.U("text-align", "left"), this.kz.U("z-index", -1), this.kz.Tk(h.$e.Oz(b.Nk - 2 * this.Oi)), this.kz.html(c)));
            }
            static NEa(b) {
              if (f.sb.IC == k.hb.mp.dB) h.Yn.save(b, f.sb);else try {
                var a = e.P.$ba(b.toDataURL());
                0 == f.sb.filename.length && (f.sb.filename = "pivotgrid.png");
                e.v(a) || h.Yn.save(a, f.sb);
              } catch (c) {
                e.Wa("Due to security reason export to image cannot be completed when you run the component from the local folder.", k.B.j.xa, e.tb.xa);
              }
              k.Va.R().Ea(new v.ga(e.bf.ig));
              f.clear();
            }
            static clear() {
              f.sb = null;
              f.zz = null;
              f.kz = null;
            }
          }
          f.Oi = 5;
          h.x7 = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static Xe(b, a, c, d) {
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              e.Da(!0, k.B.j.tF, "...", !0, !0);
              const l = ["lib/html2canvas.v1.min.js", "lib/jspdf.min.js"];
              u.Jd().cj && l.unshift("lib/promise.min.js");
              u.io.load(l, () => {
                f.clear();
                f.QH = k.C.F.tc;
                f.kU = b instanceof e.K.Uf.eF;
                f.Y = b;
                f.Dd = d;
                f.Ed = c;
                f.coords = b.ma.coords;
                f.sb = a;
                f.xr = h.ky.Kja(a.xr);
                f.Fd = new jspdf.jsPDF(a.bE, "mm", f.xr, !u.Jd().cj);
                f.pw = g;
                f.n4 = null != g && k.C.F.ke == e.K.Id.kj;
                f.Ch = f.WC - 2 * f.Yh;
                f.Nk = f.XC - 2 * f.Yh;
                f.P5 = f.Y.zg + c;
                f.Q5 = f.Y.uf + d;
                f.vA = {};
                f.og = f.Yh;
                try {
                  f.fba(), f.G1(), f.Y2(() => {
                    f.pS(f.sb.$i, f.sb.xj, () => this.D3());
                  });
                } catch (m) {
                  console.error("Export PDF error:", m), e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), e.Da(!1), k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear();
                }
              });
            }
            static Y2(b) {
              e.v(f.sb.XS) ? b() : h.a8.load(f.sb.XS, (a, c) => {
                e.v(a) ? e.v(c) || (f.font = c, f.Fd.addFileToVFS(c.filename, c.content), f.Fd.addFont(c.filename, c.name, "normal")) : e.Wa(a.message, k.B.j.xa, e.tb.xa);
                b();
              });
            }
            static pS(b, a, c) {
              let d = null == b || null != f.Nm && -1 == b.search(f.NP),
                g = null == a || null != f.Tp && -1 == a.search(f.NP);
              if (d && g) c();else {
                if (!d) {
                  b = b.replace(f.NP, (f.sl + 1).toString());
                  b = b.replace(f.T6, new Date().toLocaleString());
                  var l = new x.Ga("div");
                  l.U("position", "absolute");
                  l.U("background", "white");
                  l.Tk(f.Oz(f.XC - 2 * f.Oi));
                  l.html(b);
                  e.K.Nb.Gb.G.prepend(l);
                  html2canvasV1(l.element, {
                    scale: f.Ih
                  }).then(n => {
                    l.remove();
                    f.Nm = n;
                    d = !0;
                    g && c();
                  });
                }
                if (!g) {
                  a = a.replace(f.NP, (f.sl + 1).toString());
                  a = a.replace(f.T6, new Date().toLocaleString());
                  var m = new x.Ga("div");
                  m.U("position", "absolute");
                  m.U("background", "white");
                  m.Tk(f.Oz(f.XC - 2 * f.Oi));
                  m.html(a);
                  e.K.Nb.Gb.G.prepend(m);
                  html2canvasV1(m.element, {
                    scale: f.Ih
                  }).then(n => {
                    m.remove();
                    f.Tp = n;
                    g = !0;
                    d && c();
                  });
                }
              }
            }
            static VZ(b, a) {
              b.addImage(a, "JPEG", f.Oi, f.Oi, f.bg(a.width / f.Ih), f.bg(a.height / f.Ih));
            }
            static UZ(b, a) {
              b.addImage(a, "JPEG", f.Oi, f.WC - f.bg(a.height / f.Ih) - f.Oi, f.bg(a.width / f.Ih), f.bg(a.height / f.Ih));
            }
            static AR() {
              null != f.Nm && f.VZ(f.Fd, f.Nm);
              null != f.Tp && f.UZ(f.Fd, f.Tp);
              f.Ch = f.WC;
              f.Ch -= e.v(f.Nm) ? f.Yh : f.bg(f.Nm.height / f.Ih) + 2 * f.Oi;
              f.Ch -= e.v(f.Tp) ? f.Yh : f.bg(f.Tp.height / f.Ih) + 2 * f.Oi;
              f.og = e.v(f.Nm) ? f.Yh : f.bg(f.Nm.height / f.Ih) + 2 * f.Oi;
            }
            static get WC() {
              var b = h.ky.yH(f.xr);
              return "portrait" === f.sb.bE ? b.Ch : b.Nk;
            }
            static get XC() {
              var b = h.ky.yH(f.xr);
              return "portrait" === f.sb.bE ? b.Nk : b.Ch;
            }
            static D3() {
              f.AR();
              if (null != f.pw) {
                f.og += f.cC(k.C.F.An, f.Fd, f.og, f.font);
                var b = h.IA.Sha(f.bg(f.pw.width), f.bg(f.pw.height), f.Nk, f.Ch),
                  a = e.ia(k.C.F.An) ? f.og : f.og + 5;
                f.Fd.addImage(f.pw, "JPEG", f.Yh, a, b.width, b.height);
                f.n4 || this.Daa();
              }
              f.n4 ? f.Ega() : (f.og += f.cC(k.C.F.Yp, f.Fd, f.og, f.font), f.xIa(), k.C.F.CI && f.dM(), u.Il.po({
                bp: () => f.X0(),
                ff: () => f.Ega()
              }));
            }
            static cC(b, a, c, d) {
              if (e.ia(b)) return 0;
              e.v(d) ? (d = a.getFont(), a.setFont(d.Rya, "bold")) : a.setFont(d.name, "normal");
              a.setTextColor(0, 0, 0);
              a.setFontSize(12);
              d = 12 * a.getStringUnitWidth(b) / a.internal.scaleFactor;
              d = (a.internal.pageSize.getWidth() - d) / 2;
              a.text(b, d, c);
              return f.bg(12);
            }
            static uba(b, a, c) {
              var d = .8 * Math.max(f.bg(30), 6),
                g = .9 * f.nI(f.fca);
              b = f.Fd.splitTextToSize(b, g, f.Iu(c));
              a = f.Fd.splitTextToSize(a, g, f.Iu(c));
              c = 1 < b.length ? f.bg(b.length * (11 + 2 * f.oi) - 2 * f.oi) : f.bg(11 * b.length - f.oi);
              a = 1 < a.length ? f.bg(a.length * (11 + 2 * f.oi) - 2 * f.oi) : f.bg(11 * a.length - f.oi);
              a = (c > a ? c : a) / d;
              return 1 > a ? d : (a + 1) * d;
            }
            static dM() {
              if (!(f.Y instanceof e.K.Uf.eF || 0 == e.u.Ma.R().pa.ob.length)) {
                var b = k.Va.R().ja.pa.yc(),
                  a = e.u.Ma.R().pa.ob,
                  c = f.Yh,
                  d = .9 * f.nI(f.fca);
                var g = !0;
                var l = f.Y.ma.Xf(0, 0, !0),
                  m = f.SS.clone();
                m = f.fA(l, m);
                for (var n = m.fontSize, p = 0; p < b.length; p++) {
                  var t = b.ea(p);
                  if (a.Bb(t.A) && t.filter.zh) {
                    var r = f.qz(t);
                    g && (g = f.uba("", k.B.j.Tr, m), f.cM(f.Fd.splitTextToSize("", d, f.Iu(m)), l, m, c, d, g), c += d, m.fontSize = n, f.cM(f.Fd.splitTextToSize(k.B.j.Tr, d, f.Iu(m)), l, m, c, d, g), m.fontSize = n, c = f.Yh, f.og += g, f.ct += g);
                    g = f.uba(t.caption, r, m);
                    f.cM(f.Fd.splitTextToSize(f.Y5(t.caption), d, f.Iu(m)), l, m, c, d, g);
                    c += d;
                    m.fontSize = n;
                    f.cM(f.Fd.splitTextToSize(f.Y5(r), d, f.Iu(m)), l, m, c, d, g);
                    m.fontSize = n;
                    c = f.Yh;
                    f.og += g;
                    f.ct += g;
                    g = !1;
                  }
                }
                f.og = f.og > f.Yh ? f.og + 2 * f.nI(f.eca) : f.og;
                f.ct = f.og > f.Yh ? f.ct + 2 * f.nI(f.eca) : f.ct;
              }
            }
            static Y5(b) {
              b = b.replace(/<(?:.|\n)*?>/gi, "");
              var a = b.match(/&#(\d{3,4});/gi);
              if (a) for (var c, d = 0; d < a.length; d++) c = parseInt(a[d].substring(2, a[d].length - 1)), b = b.replace(a[d], String.fromCharCode(c));
              return b;
            }
            static cM(b, a, c, d, g, l) {
              var m = b.length,
                n = 1 < m ? f.bg(b.length * (c.fontSize + 2 * f.oi) - 2 * f.oi) : f.bg(b.length * c.fontSize - f.oi);
              n > f.Ch / 2 && (n = (f.Ch - 20) / 2, m = Math.floor(f.Oz(n) / (c.fontSize + 2 * f.oi)));
              c.fontSize *= .7;
              var p = e.K.Y.W.cd.t4(c.backgroundColor);
              f.Fd.setFillColor(p[0], p[1], p[2], 0 != p[3] ? void 0 : 0);
              p = e.K.Y.W.cd.t4(c.borderColor);
              f.Fd.setDrawColor(p[0], p[1], p[2], 0 != p[3] ? void 0 : 0);
              p = e.K.Y.W.cd.t4(c.color);
              f.Fd.setTextColor(p[0], p[1], p[2]);
              e.v(f.font) ? (p = f.Fd.getFont(), f.Fd.setFont(p.Rya, "bold" === c.fontWeight ? "bold" : "normal")) : f.Fd.setFont(f.font.name, "normal");
              f.Fd.setFontSize(c.fontSize);
              f.Fd.rect(d, f.og, g, l, "FD");
              l = f.og + (l - n) / 2 + f.oi;
              if ("right" == c.textAlign) {
                if (1 < b.length) for (c = 0; c < m; c++) f.Fd.text(b[c], d + g - f.oi, l, {
                  align: "right"
                }), l += 2 * f.oi;else f.Fd.text(b[0], d + g - f.oi + ("(" == b[0].charAt(0) && ")" == b[0].charAt(b[0].length - 1) ? 1.5 : 0), l, {
                  align: "right"
                });
              } else if ("center" == c.textAlign) {
                if (1 < b.length) for (a = 0; a < m; a++) f.Fd.text(b[a], d + g / 2, l, {
                  align: "center"
                }), l += 2 * f.oi;else f.Fd.text(b[0], d + g / 2, l, {
                  align: "center"
                });
              } else if (1 < b.length) for (c = 0; c < m; c++) g = !k.C.F.uk && null != a && 0 < a.level ? (a.level + 1) * f.oi : f.oi, f.Fd.text(b[c], d + g, l), l += 2 * f.oi;else g = !k.C.F.uk && null != a && 0 < a.level ? (a.level + 1) * f.oi : f.oi, f.Fd.text(b[0], d + g, l);
            }
            static qz(b) {
              var a = k.B.j.rJ;
              b.filter.zh && (a = 1 == b.cb.length ? b.za(b.cb[0]).caption : k.B.j.xJ);
              return a;
            }
            static G1() {
              var b = f.Y.ma,
                a = b.find(".fm-data-sheet");
              f.LR = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me, a);
              f.O5 = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.Jv, a);
              f.M1 = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.Jv + " " + e.K.Y.W.ya.AJ, a);
              f.R4 = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.yv, x.Ga.Xb(b.element));
              f.C_ = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.UA, x.Ga.Xb(b.element));
              f.SS = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.Dq, x.Ga.Xb(b.element));
            }
            static oH(b) {
              b = f.nI(f.Y.ma.coords.yh(b));
              b = b < f.Nk ? b : f.Nk - 1;
              return .9 * b;
            }
            static fA(b, a) {
              null != b && b.Pu && null != b.style && (b = 0 < b.style.DC.length ? e.K.Y.W.cd.Yl(b.style.nT()) : e.K.Y.W.cd.bT(b.style.HT()), b.merge(a), a = b);
              a.color = a.color || "rgb(0,0,0)";
              "rgb(33, 33, 33)" == a.backgroundColor && (a.color = "rgb(242, 242, 242)");
              a.backgroundColor = a.backgroundColor || "rgb(0,0,0,0)";
              a.borderColor = a.borderColor || "rgb(222,222,222)";
              a.fontSize = a.fontSize || 11;
              return a;
            }
            static Iu(b) {
              return {
                fontSize: .85 * b.fontSize,
                fontName: null == b.fontFamily ? f.cna : b.fontFamily,
                fontStyle: e.K.Y.W.mna.BAa(parseFloat(b.fontWeight))
              };
            }
            static xIa() {
              f.WT = Array(f.Q5);
              for (var b, a = 0, c, d; a < f.Q5;) {
                f.Y.ma.coords.Lo(a, NaN) && (f.WT[a] = 0, a++);
                c = b = 0;
                for (var g = .8 * Math.max(f.bg(f.coords.Xd(a)), 6); b < f.P5;) {
                  f.Y.ma.coords.Lo(NaN, b) && (f.vA[b] = 0, b++);
                  d = f.Y.ma.Xf(a, b, !0);
                  new e.K.Y.W.cd();
                  var l = f.LR.clone();
                  l = f.fA(d, l);
                  if (null != d) {
                    var m = d.J();
                    "number" === typeof m && (d.value = m, m += "", d.numeric = !0);
                    m = m.replace(/<(?:.|\n)*?>/gi, "");
                    d = f.Fd.splitTextToSize(m, null != f.vA && null != f.vA[b] ? f.vA[b] : f.oH(b), f.Iu(l));
                    d = (1 < d.length ? f.bg(d.length * (11 + 2 * f.oi) - 2 * f.oi) : f.bg(11 * d.length - f.oi)) / g;
                    d = 1 > d ? g : (d + 1) * g;
                    d = d > f.Ch / 2 ? (f.Ch - 1) / 2 : d;
                    c = d > c ? d : c;
                  }
                  b++;
                }
                f.WT[a] = c;
                a++;
              }
            }
            static X0() {
              if (f.rQ) return !1;
              for (var b = 0; b < f.Mr; b++) {
                if (f.yN && (f.Daa(), f.rQ)) return !1;
                var a,
                  c = f.Yh,
                  d = f.zs - f.sS < f.Y.uf && f.zs > f.Y.vp ? f.zs - f.sS : f.zs;
                if (f.Y.ma.coords.Lo(d, NaN)) f.zs++;else {
                  var g = f.WT[d];
                  for (f.ru = f.As; f.ru < f.Wy + f.As;) {
                    var l = (a = f.QH || f.kU ? !1 : f.ru == f.As && f.ru > f.Y.vp) ? f.Y.vp : f.ru;
                    if (f.Y.ma.coords.Lo(NaN, l)) f.ru++;else if (!f.$K() && f.ct + g <= f.Ch) {
                      a = null != f.vA && null != f.vA[l] ? f.vA[l] : f.oH(l);
                      if (.9 * (c + a) > f.Nk) break;
                      l = f.Y.ma.Xf(d, l, !0);
                      var m = e.v(l) ? "" : l.J();
                      "number" === typeof m && (l.value = m, m += "", l.numeric = !0);
                      m = f.Y5(m);
                      var n = [m];
                      new e.K.Y.W.cd();
                      if (null != l && l.gi) {
                        var p = f.R4.clone();
                        p = f.fA(l, p);
                        n = f.Fd.splitTextToSize(m, a, f.Iu(p));
                      } else null != l && l.Ah ? (p = f.C_.clone(), p = f.fA(l, p), n = f.Fd.splitTextToSize(m, a, f.Iu(p))) : null != l && l.ml ? (p = f.SS.clone(), p = f.fA(l, p)) : null != l && l.Dz && l.Hk && "" != l.J() ? (p = f.M1.clone(), p = f.fA(l, p)) : null != l && l.Hk && "" != l.J() ? (p = f.O5.clone(), p = f.fA(l, p)) : (p = f.LR.clone(), p = f.fA(l, p), n = f.Fd.splitTextToSize(m, a, f.Iu(p)));
                      f.cM(n, l, p, c, a, g);
                      f.ru++;
                      c += a;
                    } else {
                      f.yN = !0;
                      break;
                    }
                  }
                  f.yN || (f.og += g, f.ct += g, f.zs++);
                  if (f.DR() && f.$K()) break;
                }
              }
              return f.DR() && f.$K();
            }
            static DR() {
              return f.As + f.Wy >= f.Ed + f.Y.zg;
            }
            static $K() {
              return f.zs >= f.Dd + f.Y.uf;
            }
            static Daa() {
              f.Fd.addPage();
              f.sl++;
              f.yN = !1;
              f.rQ = !0;
              f.pS(f.sb.$i, f.sb.xj, () => {
                f.rQ = !1;
                f.AR();
              });
              f.ct = 0;
              if (null == f.pw || 1 < f.sl) f.rKa(), f.qKa();
              e.Da(!0, k.B.j.tF, f.sl + 1 + " " + k.B.j.K8, !0);
            }
            static rKa() {
              f.DR() && !f.$K() ? (f.zs -= f.Y.uf, f.sS = f.zs) : f.zs = f.sS;
            }
            static qKa() {
              f.DR() ? f.$K() || (f.As = 0, f.ru = 0) : (f.As += f.Wy, f.ru = f.As);
              f.fba();
            }
            static fba() {
              f.Wy = 0;
              var b = f.As,
                a = 0;
              if (f.QH || f.kU ? 0 : f.As >= f.Y.zg) {
                var c = f.oH(f.Y.vp);
                a += c;
                f.Wy++;
                f.As--;
                f.ru--;
              }
              for (; b < f.P5;) if (c = f.oH(b), c > f.Nk / 2 - f.Yh && (c = (f.Nk + f.Yh) / 2, f.vA[b] = c), a += c, a <= f.Nk) f.Wy++, b++;else {
                0 == f.Wy && (f.Wy = 1);
                break;
              }
            }
            static Ega() {
              0 == f.sb.filename.length && (f.sb.filename = "pivot.pdf");
              if (f.sb.IC == k.hb.mp.dB) h.Yn.save(f.Fd, f.sb);else {
                var b = f.Fd.output();
                b = e.P.D5(b);
                h.Yn.save(b, f.sb);
              }
              f.clear();
              k.Va.R().Ea(new v.ga(e.bf.ig));
            }
            static clear() {
              f.Y = null;
              f.sb = null;
              f.Fd = null;
              f.font = null;
              f.Ed = 0;
              f.Dd = 0;
              f.P5 = 0;
              f.Q5 = 0;
              f.Wy = 0;
              f.ru = 0;
              f.As = 0;
              f.zs = 0;
              f.sS = 0;
              f.ct = 0;
              f.og = 0;
              f.yN = !1;
              f.sl = 0;
              f.Ch = 0;
              f.Nk = 0;
              f.Nm = null;
              f.Tp = null;
              f.WT = null;
              f.QH = !1;
              f.kU = !1;
            }
            static nI(b) {
              return .264 * b;
            }
            static Oz(b) {
              return 3.779 * b;
            }
            static bg(b) {
              return b / 3.779;
            }
          }
          f.Yh = 15;
          f.yN = !1;
          f.sl = 0;
          f.n4 = !1;
          f.cna = "Helvetica";
          f.font = null;
          f.xr = "a4";
          f.fca = 100;
          f.eca = 30;
          f.NP = /##PAGE-NUMBER##/gi;
          f.T6 = /##CURRENT-DATE##/gi;
          f.QH = !1;
          f.kU = !1;
          f.Ih = 4;
          f.Oi = 5;
          f.rQ = !1;
          f.Mr = 5;
          f.oi = f.nI(8);
          h.$e = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              throw Error("Singleton");
            }
            static Xe(b, a, c, d) {
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
              f.Y = b;
              f.Ed = c;
              f.Dd = d;
              f.sb = a;
              f.pw = g || "";
              try {
                f.MS();
              } catch (l) {
                console.error("Export HTML error:", l), e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), e.Da(!1), k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear();
              }
            }
            static MS() {
              e.Da(!0, k.B.j.hy);
              f.Km = u.Yf();
              f.Lu = "";
              f.lb = f.Y.Ri;
              f.kt = [];
              k.C.F.CI && f.dM();
              u.Il.po({
                bp: () => f.X0(),
                ff: () => f.VFa()
              });
            }
            static Y0() {
              var b = "",
                a = f.Y.ma,
                c = a.find(".fm-data-sheet");
              b += e.P.bind("body{{0}}\n", e.K.Y.W.cd.nz(x.Ga.Xb(a.element), ["font-family"]));
              b += e.P.bind(".grid{border-collapse:collapse;{0}border-top:1px solid #e9e9e9;border-left:1px solid #e9e9e9;}\n", e.K.Y.W.cd.nz(x.Ga.Xb(a.element), ["font-family", "font-size", "color"]));
              b += e.P.bind(".title{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.sY, x.Ga.Xb(a.element)));
              b += e.P.bind(".cell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me, c));
              b += e.P.bind(".totalCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.Jv, c));
              b += e.P.bind(".grandTotalCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.Jv + " " + e.K.Y.W.ya.AJ, c));
              b += e.P.bind(".rowHeaderCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.yv, x.Ga.Xb(a.element)));
              b += e.P.bind(".columnHeaderCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.UA, x.Ga.Xb(a.element)));
              b += e.P.bind(".filterHeaderCell{{0}}\n", e.K.Y.W.cd.kl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.Dq, x.Ga.Xb(a.element)));
              for (c = 1; 20 >= c; c++) b += e.P.bind(".level{0}{{1}}\n", c, e.K.Y.W.cd.kl(e.K.Y.W.ya.yv + " " + e.K.Y.W.ya.Of + c, x.Ga.Xb(a.element), ["padding-left"]));
              for (c = 0; c < f.kt.length; c++) b += e.P.bind(".{0}{{1}}\n", f.kt[c], e.K.Y.W.cd.kl(f.kt[c], x.Ga.Xb(a.element)));
              return b;
            }
            static i_(b) {
              for (var a = 0; a < b.length; a++) 0 > f.kt.indexOf(b[a]) && f.kt.push(b[a]);
            }
            static dM() {
              if (!(f.Y instanceof e.K.Uf.eF || 0 == e.u.Ma.R().pa.ob.length)) for (var b = k.Va.R().ja.pa.yc(), a = e.u.Ma.R().pa.ob, c, d, g = !0, l, m = "style='min-width:" + f.rEa + "px;'", n = 0; n < b.length; n++) d = b.ea(n), l = "", a.Bb(d.A) && d.filter.zh && (c = f.qz(d), g && (l += "<td {0}></td>", l = e.P.bind(l, "class='filterHeaderCell' " + m), l += "<td {0}>" + k.B.j.Tr + "</td>", l = e.P.bind(l, "class='filterHeaderCell' " + m), f.SC += "<tr>" + l + "</tr>", l = ""), l += "<td {0}>" + d.caption + "</td>", l = e.P.bind(l, "class='filterHeaderCell' " + m), l += "<td {0}>" + c + "</td>", l = e.P.bind(l, "class='filterHeaderCell' " + m), f.SC += "<tr>" + l + "</tr>", g = !1);
            }
            static qz(b) {
              var a = k.B.j.rJ;
              b.filter.zh && (a = 1 == b.cb.length ? b.za(b.cb[0]).caption : k.B.j.xJ);
              return a;
            }
            static X0() {
              var b = "";
              if (f.Y.ma.coords.Lo(f.lb, NaN)) return f.lb++ >= f.Dd + f.Y.uf;
              for (var a = f.Y.vp; a < f.Ed + f.Y.zg; a++) if (!f.Y.ma.coords.Lo(NaN, a)) {
                var c = f.Y.ma.Xf(f.lb, a, !0);
                b += "<td {0}>" + (c ? c.J(!0) : "") + "</td>";
                if (null == c) b = e.P.bind(b, "class='cell'");else {
                  var d = "",
                    g = "";
                  c.Pu && null != c.style && (g = c.style.HT(), d = c.style.nT(), f.i_(c.style.DC));
                  d = c.gi ? d + (" rowHeaderCell level" + c.level) : c.Ah ? d + " columnHeaderCell" : c.ml ? d + " filterHeaderCell" : c.Dz && c.Hk && "" != c.J(!0) ? d + " grandTotalCell" : c.Hk && "" != c.J(!0) ? d + " totalCell" : d + " cell";
                  null != c && c.ml && (d += " level" + c.level);
                  "" != d.trim() && (d = "class='" + d.trim() + "'");
                  g += "width:" + f.Y.ma.coords.yh(a) + "px;";
                  "" != g.trim() && (g = "style='" + g.trim() + "'");
                  b = e.P.bind(b, d + " " + g);
                }
              }
              f.HN += "<tr>" + b + "</tr>";
              200 < u.Yf() - f.Km && (e.Da(!0, k.B.j.hy, e.P.bind("{0}%", (f.lb / (f.Dd + f.Y.uf) * 100).toFixed(0))), f.Km = u.Yf());
              return ++f.lb >= f.Dd + f.Y.uf;
            }
            static VFa() {
              e.Da(!1);
              f.xJa();
              f.clear();
            }
            static xJa() {
              0 == f.sb.filename.length && (f.sb.filename = "pivotgrid.html");
              var b = "";
              if (!e.ia(f.sb.$i)) {
                var a = f.sb.$i;
                a = a.replace(/##PAGE-NUMBER##/gi, "");
                a = a.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString());
                b += a;
              }
              e.ia(f.pw) || (e.ia(k.C.F.An) || (b += "<div class='title'>" + k.C.F.An + "</div>"), b += f.pw);
              b += "<div class='title'>" + k.C.F.Yp + "</div>";
              b += 0 < f.SC.length ? "<table class='grid'>" + f.SC + "</table><br><br><table class='grid'>" + f.HN + "</table>" : "<table class='grid'>" + f.HN + "</table>";
              e.ia(f.sb.xj) || (a = f.sb.xj, a = a.replace(/##PAGE-NUMBER##/gi, ""), a = a.replace(/##CURRENT-DATE##/gi, new Date().toLocaleString()), b += a);
              f.Lu = "<!DOCTYPE html><html><head><meta charset='UTF-8'/>";
              f.Lu += "<title>" + (e.ia(k.C.F.Yp) ? k.B.j.iX : k.C.F.Yp) + "</title>";
              f.Lu += "<style>" + f.Y0() + "</style></head>";
              f.Lu += "<body>" + b + "</body></html>";
              h.Yn.save(f.Lu, f.sb);
              k.Va.R().Ea(new v.ga(e.bf.ig));
            }
            static clear() {
              f.lb = 0;
              f.Lu = "";
              f.SC = "";
              f.HN = "";
              f.Ed = 0;
              f.Dd = 0;
              f.Y = null;
              f.sb = null;
              f.pw = "";
            }
          }
          f.lb = 0;
          f.Km = 0;
          f.Lu = "";
          f.SC = "";
          f.HN = "";
          f.rEa = 100;
          f.Mr = 10;
          h.w7 = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              throw Error("Singleton");
            }
            static Xe(b, a, c, d) {
              f.Y = b;
              f.Ed = c;
              f.Dd = d;
              f.sb = a;
              try {
                f.qya();
              } catch (g) {
                console.error("Export XLS error:", g), e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), e.Da(!1), k.Va.R().Ea(new v.ga(e.bf.ig));
              }
            }
            static qya() {
              e.Da(!0, k.B.j.hy);
              f.lb = f.Y.Ri;
              f.Le = 0;
              f.Km = u.Yf();
              f.IN = [];
              f.Nf = new S.qra();
              var b = k.B.j.iX;
              e.ia(f.sb.E0) ? e.ia(k.C.F.Yp) || (b = k.C.F.Yp) : b = f.sb.E0;
              b = new S.rra(b);
              f.Nf.eh.push(b);
              f.G1();
              this.sb.$i ? f.zaa(this.sb.$i) : f.Fta();
              f.cC();
              k.C.F.CI && f.fta();
              u.Il.po({
                bp: () => f.Mza(),
                ff: () => f.BHa()
              });
            }
            static G1() {
              var b = f.Y.ma.element;
              f.LR = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me, x.Ga.Xb(b), !1);
              f.O5 = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.Jv, x.Ga.Xb(b), !1);
              f.M1 = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.Jv + " " + e.K.Y.W.ya.AJ, x.Ga.Xb(b), !1);
              f.R4 = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.yv, x.Ga.Xb(b), !1);
              f.C_ = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.UA, x.Ga.Xb(b), !1);
              f.SS = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.Dq, x.Ga.Xb(b), !1);
              for (var a = 1; 20 >= a; a++) f.S4[a] = e.K.Y.W.cd.Yl(e.K.Y.W.ya.Me + " " + e.K.Y.W.ya.gk + " " + e.K.Y.W.ya.yv + " " + e.K.Y.W.ya.Of + a, x.Ga.Xb(b), !1);
            }
            static BHa() {
              f.zaa(this.sb.xj, !0);
              f.qEa();
              e.Da(!1);
              f.BJa();
            }
            static BJa() {
              f.lb = f.Y.Ri;
              0 == f.sb.filename.length && (f.sb.filename = "pivot.xlsx");
              f.Nf.iLa().then(b => {
                h.Yn.save(b, f.sb);
                f.Nf = null;
                f.sb = null;
                k.Va.R().Ea(new v.ga(e.bf.ig));
              });
            }
            static ALa(b) {
              return e.v(b) || e.v(b.measure) || b.measure.type != e.u.i.Qa.Ta ? !1 : e.u.i.da.NE(b.measure.aa) || k.C.F.rD == e.K.Y.se.Gh && !b.Hk ? !0 : !1;
            }
            static NE(b) {
              return e.v(b) || e.v(b.measure) || b.measure.type != e.u.i.Qa.Lc ? !1 : e.u.i.da.NE(b.measure.aa) || k.C.F.rD == e.K.Y.se.Gh && !b.Hk ? !0 : !1;
            }
            static hp(b) {
              return e.v(b) || e.v(b.measure) || b.measure.type != e.u.i.Qa.ic ? !1 : e.u.i.da.hp(b.measure.aa) || k.C.F.rD == e.K.Y.se.Gh && !b.Hk ? !0 : !1;
            }
            static Mza() {
              for (var b = f.Dd + f.Y.uf, a = f.Y.vp; a < f.Ed + f.Y.zg; a++) {
                var c = f.Y.ma.Xf(f.lb, a, !0);
                let t = e.v(c) ? "" : c.J();
                t = t ? t : "";
                let r;
                var d = f.ALa(c);
                const w = f.NE(c),
                  y = f.hp(c);
                e.v(c) || isNaN(c.value) || (d ? r = f.owa(c.value, c.hierarchy.getTimezoneOffset()) : w ? r = f.pwa(c.value, c.hierarchy.getTimezoneOffset()) : y && (r = f.qwa(c.value)));
                "number" === typeof t && (c.value = t, t += "", c.numeric = !0);
                var g = null != c && (c.gi || c.Ah);
                f.sb.Lca && "" == t && null != c && null != c.Zb && (t = c.Zb.caption);
                if ("" != t.trim() || g) {
                  new e.K.Y.W.cd();
                  g = null != c && c.gi ? 0 < c.level && f.S4[c.level] ? f.S4[c.level].clone() : f.R4.clone() : null != c && c.Ah ? f.C_.clone() : null != c && c.ml ? f.SS.clone() : null != c && c.Dz && c.Hk && "" != c.J() ? f.M1.clone() : null != c && c.Hk && "" != c.J() ? f.O5.clone() : f.LR.clone();
                  if (null != c && c.Pu && null != c.style) {
                    var l = 0 < c.style.DC.length ? e.K.Y.W.cd.Yl(c.style.nT()) : e.K.Y.W.cd.bT(c.style.HT());
                    l.merge(g);
                    g = l;
                  }
                  g.color = g.color || "rgb(0,0,0)";
                  "rgb(33, 33, 33)" == g.backgroundColor && (g.color = "rgb(242, 242, 242)");
                  g.backgroundColor = g.backgroundColor || "rgb(255,255,255)";
                  g.fontSize = g.fontSize ? f.IIa(g.fontSize) : 8;
                  var m = new S.td.fonts.Mv(e.v(g.fontFamily) ? "Tahoma" : g.fontFamily, g.fontSize, e.P.Ho(g.color));
                  m.bold = "bold" == g.fontWeight || 700 <= parseInt(g.fontWeight);
                  m.OD = !1;
                  var n = null,
                    p = l = !1;
                  if (c.numeric) {
                    if (null != c.measure) {
                      const A = c.measure.ci(c.measure.A, c.measure.aa).clone();
                      p = "" != A.TD ? !0 : p;
                      l = e.u.i.da.ce(c.measure.aa);
                      A.Fe = e.u.i.da.Fe(c.measure.aa);
                      n = A.sja();
                      if (l || A.ce) A.xd = "%", n = A.sja();
                      n = new S.td.format.Gt("" == n ? 0 : -1, n);
                    }
                  } else d || w ? n = c.measure.type == e.u.i.Qa.Lc ? new S.td.format.Gt(164, "dd.mm.yyyy h:mm:ss") : new S.td.format.Gt(14, "") : y && (0 <= r ? n = new S.td.format.Gt(165, f.ep) : (r = Math.abs(r), n = new S.td.format.Gt(166, "-" + f.ep)));
                  n && f.Nf.styleSheet.gta(n);
                  m = new S.td.qB(m, e.P.Ho(g.backgroundColor), n, c.Pu && void 0 == g.textAlign && c.hi ? "right" : g.textAlign);
                  !k.C.F.uk && c && c.gi && 0 < c.level && (m.textIndent = c.level);
                  f.Nf.styleSheet.fw(m);
                  n = null != c.measure ? c.measure.ci(c.measure.A, c.measure.aa) : null;
                  t = e.P.cH(t);
                  c.numeric ? null == n || c.label != n.xD && c.label != n.KC ? c.Pu && f.wCa() && f.sb.Ija ? (d = c.J(), f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, !isNaN(c.value) && c.label == d && c.numeric ? f.lda(c.value, n, l) : e.P.cH(d), m)) : (r = f.lda(c.value, n, l), f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, isNaN(c.value) && p ? c.J() : r, m)) : f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, c.J(), m) : f.sb.sA || !c.hi || null == c.measure || c.measure.type != e.u.i.Qa.Ta && c.measure.type != e.u.i.Qa.Lc ? !f.sb.sA && c.hi && null != c.measure && c.measure.aa == e.u.i.da.NONE ? f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, c.value, m) : !f.sb.sA && c.hi && null != c.measure && c.measure.type == e.u.i.Qa.ic ? y ? f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, r, m) : f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, c.value, m) : f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, t, m) : d || w ? f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, r, m) : f.Nf.eh[0].Li(f.lb - f.Y.Ri + f.Le, a, c.value, m);
                  null != c && (0 == f.Nf.eh[0].oH(a) && f.Nf.eh[0].gia(a, f.nwa(f.Y.ma.coords.yh(a))), a != f.Y.vp || f.Y.ma.coords.iDa(f.lb) || (c = f.yL(f.Y.ma.coords.Xd(f.lb)), f.Nf.eh[0].Dx(f.lb + f.Le, c)), t.length > g.width && f.Nf.eh[0].gia(a, f.yL(t.length + f.cellPadding) > f.yL(f.c7) ? f.yL(f.c7) : f.yL(t.length + f.cellPadding)));
                }
              }
              200 < u.Yf() - f.Km && (e.Da(!0, k.B.j.hy, e.P.bind("{1}% (" + k.B.j.XX + ")", f.lb.toString(), (f.lb / b * 100).toFixed(0))), f.Km = u.Yf());
              return f.lb++ >= b;
            }
            static lda(b, a, c) {
              return null == a || !c && "%" != a.xd ? b : b / 100;
            }
            static owa(b, a) {
              b = -f.vda(b, a) + b;
              return Math.floor(b / 864E5);
            }
            static pwa(b, a) {
              return (-f.vda(b, a) + b) / 864E5;
            }
            static vda(b, a) {
              return null != a ? Date.parse("1899-12-30") - 36E5 * a : Date.parse("1899-12-30") + 36E5 * (new Date(b).getTimezoneOffset() / 60);
            }
            static qwa(b) {
              return 1E3 * b / 864E5;
            }
            static IIa(b) {
              return .75 * b;
            }
            static yL(b) {
              return 0 >= b ? 0 : f.lxa / f.dca * b * (f.dca / e.K.Y.sheet.Hh.rv);
            }
            static nwa(b) {
              return 0 >= b ? 0 : ((b - 5) / 7 * 100 + .5) / 100;
            }
            static Fta() {
              var b = k.hb.dJ.Gm;
              if (0 < b.length) {
                var a = getComputedStyle(e.K.Nb.Gb.G.find("." + e.K.Y.W.ya.UA).element),
                  c = new S.td.fonts.Mv(a.fontFamily, parseInt(a.fontSize) - 2, e.P.Ho(a.color));
                c.bold = "bold" === a.fontWeight;
                c.OD = "italic" === a.fontStyle;
                c = new S.td.qB(c, e.P.Ho(a.backgroundColor));
                c.textAlign = a.textAlign;
                f.Nf.styleSheet.fw(c);
                f.Nf.eh[0].Li(f.Le, 0, k.B.j.gma, c);
                f.Nf.eh[0].Li(f.Le, 1, "", c);
                a = getComputedStyle(e.K.Nb.Gb.G.find("." + e.K.Y.W.ya.Me).element);
                var d = new S.td.fonts.Mv(a.fontFamily, parseInt(a.fontSize) - 2, e.P.Ho(a.color));
                d.bold = "bold" === a.fontWeight;
                d.OD = "italic" === a.fontStyle;
                d = new S.td.qB(d, e.P.Ho(a.backgroundColor));
                d.textAlign = a.textAlign;
                f.Nf.styleSheet.fw(d);
                for (a = 0; a < b.length; a++) f.Nf.eh[0].Li(a + 1 + f.Le, 0, e.P.cH(String(b[a].name)), c), f.Nf.eh[0].Li(a + 1 + f.Le, 1, e.P.cH(String(b[a].value)), c);
              }
              f.Le += 0 == b.length ? 0 : b.length + 2;
            }
            static zaa(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              if (null != b && 0 != b.length) {
                var c = 0;
                a && (f.Le += 1, c = f.Dd + f.Y.uf);
                b = b.split("\n");
                var d = getComputedStyle(e.K.Nb.Gb.G.find("." + e.K.Y.W.ya.UA).element),
                  g = new S.td.fonts.Mv(d.fontFamily, parseInt(d.fontSize) - 2, e.P.Ho(d.color));
                g.bold = "bold" === d.fontWeight;
                g.OD = "italic" === d.fontStyle;
                g = new S.td.qB(g, e.P.Ho(d.backgroundColor));
                g.textAlign = d.textAlign;
                f.Nf.styleSheet.fw(g);
                d = f.Nf.eh[0];
                for (var l = 0; l < b.length; l++) {
                  const m = c + l + f.Le;
                  d.Li(m, 0, e.P.cH(String(b[l])), g);
                  f.IN.push(m);
                }
                f.Le += b.length + (a ? 0 : 1);
              }
            }
            static cC() {
              var b = k.C.F.Yp;
              if (0 != b.length) {
                var a = getComputedStyle(e.K.Nb.Gb.G.find("." + e.K.Y.W.ya.sY).element),
                  c = new S.td.fonts.Mv(a.fontFamily, parseInt(a.fontSize) - 2, e.P.Ho(a.color));
                c.bold = "bold" === a.fontWeight;
                c.OD = "italic" === a.fontStyle;
                a = new S.td.qB(c, e.P.Ho(a.backgroundColor));
                a.textAlign = "center";
                f.Nf.styleSheet.fw(a);
                c = f.Le;
                f.Nf.eh[0].Li(c, 0, b, a);
                f.IN.push(c);
                f.Le += 1;
              }
            }
            static qEa() {
              const b = f.Nf.eh[0];
              for (var a = 0; a < f.IN.length; a++) b.cga(f.IN[a], 0, Math.min(b.tva, 10));
            }
            static wCa() {
              return !e.v(e.K.Y.W.le.zw);
            }
            static fta() {
              if (!(f.Y instanceof e.K.Uf.eF || 0 == e.u.Ma.R().pa.ob.length)) {
                var b = k.Va.R().ja.pa.yc(),
                  a = e.u.Ma.R().pa.ob,
                  c = !0,
                  d = getComputedStyle(e.K.Nb.Gb.G.find("." + e.K.Y.W.ya.gk).element),
                  g = new S.td.fonts.Mv(d.fontFamily, parseInt(d.fontSize) - 2, e.P.Ho(d.color));
                g.bold = "bold" === d.fontWeight;
                g.OD = "italic" === d.fontStyle;
                g = new S.td.qB(g, e.P.Ho(d.backgroundColor));
                g.textAlign = d.textAlign;
                f.Nf.styleSheet.fw(g);
                d = getComputedStyle(e.K.Nb.Gb.G.find("." + e.K.Y.W.ya.Me).element);
                var l = new S.td.fonts.Mv(d.fontFamily, parseInt(d.fontSize) - 2, e.P.Ho("rgb(0,0,0)"));
                l.bold = "bold" === d.fontWeight;
                l.OD = "italic" === d.fontStyle;
                d = new S.td.qB(l, e.P.Ho(d.backgroundColor));
                d.textAlign = "left";
                f.Nf.styleSheet.fw(d);
                l = f.Nf.eh[0];
                var m = 0;
                for (let t = 0; t < b.length; t++) {
                  var n = b.ea(t);
                  var p = n.zi.type == e.u.i.MA.YA;
                  (a.Bb(n.A) || f.sb.lW) && n.filter.zh && (p = p ? f.Fva(n) : f.sb.lW ? f.Rda(n) : f.qz(n), c && (l.Li(m + f.Le, 0, "", g), l.Li(m + f.Le, 1, k.B.j.Tr, g), m++), l.Li(m + f.Le, 0, n.caption, g), l.Li(m + f.Le, 1, p, d), m++, c = !1);
                }
                if (k.C.F.rD == e.K.Y.se.Gh) for (b = k.Va.R().ja.pa.Sf, a = 0; a < b.length; a++) (n = k.Va.R().ja.pa.Kk(b[a].A)) && n.filter.zh && (p = f.sb.lW ? f.Rda(n) : f.qz(n), c && (l.Li(m + f.Le, 0, "", g), l.Li(m + f.Le, 1, "Filters", g), m++), l.Li(m + f.Le, 0, n.caption, g), l.Li(m + f.Le, 1, p, d), m++, c = !1);
                f.Le += c ? 0 : m + 1;
              }
            }
            static Rda(b) {
              for (var a = [], c = 0; c < b.cb.length; c++) a.push(b.gD(b.cb[c]));
              return a.join(", ");
            }
            static qz(b) {
              var a = k.B.j.rJ;
              b.filter.zh && (a = 1 == b.cb.length ? b.za(b.cb[0]).caption : k.B.j.xJ);
              return a;
            }
            static Fva(b) {
              var a,
                c = [];
              null != f.lA && (f.lA.length = 0);
              f.Ria(b.wd);
              for (var d = f.Kva(b), g = !1, l = 0; l < f.lA.length; l++) {
                var m = b.za(f.lA[l]);
                var n = l == f.lA.length - 1;
                if (!g && -1 < b.cb.indexOf(m.ordinal)) {
                  g = !0;
                  var p = m;
                }
                g && (-1 < b.cb.indexOf(m.ordinal) && (a = m), -1 < d.indexOf(m.ordinal) && !n || (a = null != a ? a : p, m = f.wba(p), n = a.A != p.A ? ":" + f.wba(a, !0) : "", a = p = null, g = !1, c.push(m + n)));
              }
              return c.join(", ");
            }
            static Ria(b) {
              null == f.lA && (f.lA = []);
              b.dc || f.lA.push(b.ordinal);
              for (var a = b.hierarchy.ck(b, !1, e.u.i.Aa.kc), c = a.length, d, g = 0; g < c; g++) d = b.hierarchy.za(a[g]), 0 < d.children.length ? f.Ria(d) : f.lA.push(d.ordinal);
            }
            static wba(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var c = b,
                d = [];
              for (d.push(b.caption); c && c.A != b.A && !c.level.Su && 0 < c.children.length;) d.push(c.caption), c = c.hierarchy.ck(c, !1, e.u.i.Aa.kc), c = b.hierarchy.za(a ? c[c.length - 1] : c[0]);
              for (c = b.parent; c && !c.dc;) d.unshift(c.caption), c = c.parent;
              return d.join("-");
            }
            static Kva(b) {
              for (var a = [], c = b.cb, d, g = 0; g < c.length; g++) if (d = b.za(c[g]), a.push(d.ordinal), a = a.concat(d.Bw), !(d.parent && !d.parent.dc && -1 < a.indexOf(d.parent.ordinal))) for (; d.parent && !d.parent.dc;) d = d.parent, a.push(d.ordinal);
              return a;
            }
          }
          f.lb = 0;
          f.Le = 0;
          f.cellPadding = 3;
          f.c7 = 100;
          f.ep = "[h]:mm:ss";
          f.S4 = [];
          f.lxa = 14.3;
          f.dca = 38;
          f.IN = [];
          h.A7 = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {}
            static Bk(c) {
              let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              f.UY ? this.l0.push({
                type: c,
                options: d,
                ff: g
              }) : (c = c.toLowerCase(), c = a.tA(c) ? c : a.Xh, k.C.F.ke == e.K.Id.kj && c == a.JSON ? (e.Wa(k.B.j.Hoa, k.B.j.xa), this.Zia()) : (k.Va.R().N(e.bf.ig, f.Rca), f.UY = !0, f.Fp = g, e.v(d) && (d = new h.z7()), d.type = c, c = new b(c, d, g), k.Va.R().Ea(c)));
            }
            static Zia() {
              e.Da(!1);
              k.Va.R().pb(e.bf.ig, f.Rca);
              f.UY = !1;
            }
            static FFa() {
              f.Zia();
              if (0 < f.l0.length) {
                var c = f.l0.shift();
                this.Bk(c.type, c.options, c.ff);
              }
            }
            static save(c, d) {
              switch (d.IC.toLowerCase()) {
                case k.hb.mp.YO:
                  f.JN(c, d);
                  break;
                case k.hb.mp.kY:
                  f.XV(c, d);
                  break;
                case k.hb.mp.s6:
                  break;
                case k.hb.mp.dB:
                  f.zJa(c, d);
                  break;
                default:
                  f.JN(c, d);
              }
            }
            static XV(c, d) {
              switch (d.type) {
                case a.zv:
                case a.fF:
                case a.cB:
                case a.VA:
                case a.JSON:
                case a.Xh:
                  f.AJa(c, d);
                  break;
                default:
                  c = k.Tb.validate(d.type), e.Wa("Unknown type of export: '" + c + "'", k.B.j.xa);
              }
            }
            static JN(c, d) {
              switch (d.type) {
                case a.zv:
                  var g = "text/html;charset=utf-8";
                  d.filename = f.bL(d.filename, ".html");
                  break;
                case a.fF:
                  g = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                  d.filename = f.bL(d.filename, ".xlsx");
                  break;
                case a.cB:
                  g = "application/pdf";
                  d.filename = f.bL(d.filename, ".pdf");
                  break;
                case a.VA:
                  g = "image/png";
                  d.filename = f.bL(d.filename, ".png");
                  break;
                case a.Xh:
                  g = "text/csv;charset=utf-8";
                  d.filename = f.bL(d.filename, ".csv");
                  break;
                default:
                  g = "text/plain;charset=utf-8";
              }
              var l = [c];
              d.type == a.Xh && l.unshift(e.P.Rza());
              try {
                z.Qha(new Blob(l, {
                  type: g
                }), d.filename), f.kO({
                  data: c,
                  filename: d.filename,
                  type: d.type
                });
              } catch (m) {
                e.Wa(k.B.j.EP, k.B.j.xa, e.tb.xa), f.kO(null, {
                  message: k.B.j.EP
                });
              }
            }
            static bL(c, d) {
              c.indexOf(d) != c.length - d.length && (c += d);
              return c;
            }
            static vIa(c) {
              var d = {};
              null != c && null != c.target && null != c.target.response && "" != c.target.response && null != c.target.xhr && (d.response = c.target.response, d.status = c.target.xhr.status);
              d.message = k.B.j.EP;
              return d;
            }
            static AJa(c, d) {
              var g = new u.Et(500);
              g.N(u.vf.Gl, function () {
                e.Da(!0, k.B.j.M8, (g.yw / 10).toString() + " sec");
              });
              var l = new z.jk();
              l.N(v.ga.xa, t => {
                t = f.vIa(t);
                var r = t.hasOwnProperty("response") ? k.Tb.validate(t.response) : "";
                r = 700 < r.length ? r.substr(0, 700) : r;
                e.Wa(e.P.bind(t.message, r), k.B.j.xa, e.tb.xa);
                g.stop();
                e.Da(!1);
                f.kO(null, t);
              });
              l.N(v.ga.Qc, function () {
                g.stop();
                e.Da(!1);
                f.kO({
                  data: c,
                  filename: d.filename,
                  type: d.type,
                  response: l.response
                });
              });
              var m = new Blob([c], {
                  type: "application/octet-binary"
                }),
                n = new FormData();
              n.append("filedata", m, d.filename);
              for (var p in d.K0) n.append(p, d.K0[p]);
              l.Br = z.Ft.Dv;
              l.data = n;
              l.contentType = !1;
              l.Vh(d.uc);
              l.load(d.url);
              g.start();
            }
            static zJa(c, d) {
              f.kO({
                data: c,
                filename: d.filename,
                type: d.type
              });
            }
            static kO() {
              let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              null != f.Fp && f.Fp.call(null, c, d);
            }
          }
          f.UY = !1;
          f.l0 = [];
          f.Rca = () => f.FFa();
          h.Yn = f;
          class b extends v.ga {
            constructor(c, d, g) {
              super(e.bf.uX);
              this.zu = c;
              this.sb = d;
              this.Fp = g;
            }
          }
          h.KMa = b;
          class a {
            static tA(c) {
              return c === a.VA || c === a.fF || c === a.zv || c === a.Xh || c === a.JSON || c === a.cB;
            }
          }
          a.VA = "image";
          a.fF = "excel";
          a.zv = "html";
          a.Xh = "csv";
          a.JSON = "json";
          a.cB = "pdf";
          h.nj = a;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "file";
              this.Al = !0;
              this.IC = e.model.hb.mp.YO;
              this.filename = "";
              this.url = "()";
              this.uc = null;
              this.type = h.nj.zv;
              this.bE = "portrait";
              this.E0 = "";
              this.lW = this.Lca = !1;
              this.sA = !0;
              this.K0 = {};
              this.Wf = ",";
              this.Ija = !0;
              this.Paa = !1;
              this.IC = b;
            }
            static zb(b) {
              var a = new f();
              if (e.v(b)) return a;
              e.v(b.showHeaders) || (a.Al = "true" === b.showHeaders || !0 === b.showHeaders);
              e.v(b.filename) || (a.filename = b.filename);
              e.v(b.url) || (a.url = b.url);
              e.v(b.excelSheetName) || (a.E0 = b.excelSheetName);
              e.v(b.excelExportAll) || (a.Lca = b.excelExportAll);
              e.v(b.pageOrientation) || "portrait" !== b.pageOrientation.toLowerCase() && "landscape" !== b.pageOrientation.toLowerCase() || (a.bE = b.pageOrientation.toLowerCase());
              !e.v(b.destinationType) && e.model.hb.mp.tA(b.destinationType.toString().toLowerCase()) && (a.IC = b.destinationType.toString().toLowerCase());
              e.ia(b.pageFormat) || (a.xr = b.pageFormat);
              e.ia(b.fieldSeparator) || (a.Wf = b.fieldSeparator);
              e.v(b.showFilters) || (a.lW = b.showFilters);
              e.v(b.useOlapFormattingInExcel) || (a.sA = b.useOlapFormattingInExcel);
              e.v(b.extendedParameters) || (a.K0 = b.extendedParameters);
              e.v(b.header) || (a.$i = b.header);
              e.v(b.footer) || (a.xj = b.footer);
              e.v(b.fontUrl) || (a.XS = b.fontUrl);
              e.v(b.useCustomizeCellForData) || (a.Ija = b.useCustomizeCellForData);
              e.v(b.requestHeader) || (a.uc = b.requestHeader);
              e.v(b.requestHeaders) || (a.uc = b.requestHeaders);
              e.v(b.alwaysEnclose) || (a.Paa = b.alwaysEnclose);
              return a;
            }
          }
          h.z7 = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              throw Error("Singleton");
            }
            static Xe(b, a, c, d) {
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              if (!e.v(b)) {
                f.Y = b;
                f.Ed = c;
                f.Dd = d;
                f.sb = a;
                f.Fp = g;
                try {
                  f.nya();
                } catch (l) {
                  console.error("Export CSV error:", l), e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), e.Da(!1), k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear();
                }
              }
            }
            static rda(b, a) {
              if (null != b && 0 != b.length) {
                0 < f.gr.length && f.gr.push([].join(f.sb.Wf));
                b = b.split("\n");
                for (let d = 0; d < b.length; d++) {
                  var c = [];
                  c.push('"' + b[d] + '"');
                  f.gr.push(c.join(f.sb.Wf));
                }
                0 < f.gr.length && !a && f.gr.push([].join(f.sb.Wf));
              }
            }
            static dM() {
              if (!(f.Y instanceof e.K.Uf.eF || 0 == e.u.Ma.R().pa.ob.length)) {
                for (var b, a = k.Va.R().ja.pa.yc(), c = e.u.Ma.R().pa.ob, d, g, l = !0, m = 0; m < a.length; m++) g = a.ea(m), b = [], c.Bb(g.A) && g.filter.zh && (d = f.qz(g), l && (b.push('""'), b.push('"' + k.B.j.Tr + '"'), f.gr.push(b.join(f.sb.Wf)), b = []), b.push('"' + g.caption + '"'), b.push('"' + d + '"'), f.gr.push(b.join(f.sb.Wf)), l = !1);
                0 < f.gr.length && f.gr.push([].join(f.sb.Wf));
              }
            }
            static qz(b) {
              var a = k.B.j.rJ;
              b.filter.zh && (a = 1 == b.cb.length ? b.za(b.cb[0]).caption : k.B.j.xJ);
              return a;
            }
            static nya() {
              e.Da(!0, k.B.j.hy);
              f.lb = 0;
              f.Km = u.Yf();
              f.rda(this.sb.$i);
              k.C.F.CI && f.dM();
              u.Il.po({
                bp: () => f.Fza(),
                ff: () => f.MEa()
              });
            }
            static Fza() {
              if (f.Y.ma.coords.Lo(f.lb, NaN)) return f.lb >= f.Dd + f.Y.uf;
              var b = [];
              for (var a = 0; a < f.Ed + f.Y.zg; a++) if (!f.Y.ma.coords.Lo(NaN, a)) for (b = [], a = 0; a < f.Ed + f.Y.zg; a++) {
                if (f.Y.ma.coords.Lo(NaN, a)) continue;
                let c = "";
                const d = f.Y.ma.Xf(f.lb, a, !0);
                d && (c = d.J());
                "number" === typeof c && (d.value = c, c += "", d.numeric = !0);
                c = e.P.cH(c);
                0 <= c.indexOf(f.sb.Wf) || this.sb.Paa || -1 < c.search(/\n|\r/gi) ? (c = c.replace(/["]/gi, '""'), b.push(`"${c}"`)) : b.push(c);
              }
              f.gr.push(b.join(f.sb.Wf));
              200 < u.Yf() - f.Km && (b = f.lb / (f.Dd + f.Y.uf) * 100, 100 < b && (b = 100), e.Da(!0, k.B.j.hy, e.P.bind("{1}% (" + k.B.j.XX + ")", f.lb.toString(), b.toFixed(0))), f.Km = u.Yf());
              return ++f.lb >= f.Dd + f.Y.uf;
            }
            static vJa() {
              var b = f.gr.join("\r\n");
              0 == f.sb.filename.length && (f.sb.filename = "pivot.csv");
              h.Yn.save(b, f.sb);
              k.Va.R().Ea(new v.ga(e.bf.ig));
              f.clear();
            }
            static MEa() {
              e.Da(!1);
              f.rda(this.sb.xj, !0);
              f.vJa();
            }
            static clear() {
              f.Y = null;
              f.lb = 0;
              f.Km = 0;
              f.gr = [];
              f.sb = null;
              f.Fp = null;
              f.Ed = 0;
              f.Dd = 0;
            }
          }
          f.lb = 0;
          f.Km = 0;
          f.gr = [];
          h.v7 = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              throw Error("Singleton");
            }
            static Xe(b, a, c, d) {
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              if (!e.v(b)) {
                f.Y = b;
                f.Ed = c;
                f.Dd = d;
                f.sb = a;
                f.Fp = g;
                try {
                  f.oya();
                } catch (l) {
                  console.error("Export JSON error:", l), e.Wa(k.B.j.$n, k.B.j.xa, e.tb.xa), e.Da(!1), k.Va.R().Ea(new v.ga(e.bf.ig)), f.clear();
                }
              }
            }
            static oya() {
              e.Da(!0, k.B.j.hy);
              f.mc = 0;
              f.Km = f.startTime = u.Yf();
              u.Il.po({
                bp: () => f.Jza(),
                ff: () => () => f.cGa()
              });
            }
            static Jza() {
              for (var b = Math.min(f.mc + f.Mr, f.Ed + f.Y.zg), a; f.mc < b; f.mc++) {
                a = [];
                for (var c = 0; c < f.Dd + f.Y.uf; c++) {
                  var d = "",
                    g = f.Y.ma.Xf(c, f.mc, !0);
                  g && (d = g.label);
                  a.push(d);
                }
                f.L2.push(JSON.stringify(a));
              }
              if (50 < u.Yf() - f.Km) {
                b = f.mc / (f.Ed + f.Y.zg) * 100;
                if (100 < b) return !0;
                f.uKa(b);
                f.Km = u.Yf();
              }
              return f.mc >= f.Ed + f.Y.zg;
            }
            static uKa(b) {
              e.Da(!0, k.B.j.hy, e.P.bind("{0}% ({1} rows)", b.toFixed(0), f.mc.toString()));
            }
            static yJa() {
              var b = "[" + f.L2.join(",\n") + "]";
              0 == f.sb.filename.length && (f.sb.filename = "pivot.json");
              h.Yn.save(b, f.sb);
              k.Va.R().Ea(new v.ga(e.bf.ig));
              f.clear();
            }
            static cGa() {
              e.Da(!1);
              f.yJa();
            }
            static clear() {
              f.Y = null;
              f.mc = 0;
              f.startTime = 0;
              f.Km = 0;
              f.Ed = 0;
              f.Dd = 0;
              f.L2 = [];
              f.cells = [];
              f.sb = null;
              f.Fp = null;
            }
          }
          f.mc = 0;
          f.startTime = 0;
          f.Km = 0;
          f.cells = [];
          f.L2 = [];
          f.Mr = 10;
          h.y7 = f;
        })(k.Dc || (k.Dc = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {}
          f.U7 = "formatchange";
          h.b8 = f;
          class b {
            static ci(a, c) {
              a = b.CAa(a, c);
              return b.y$(a);
            }
            static CAa(a, c) {
              let d = void 0;
              b.lr.Bb(a) && (d = b.lr.getItem(a).has(c) ? b.lr.getItem(a).get(c) : b.lr.getItem(a).values().next().value);
              return d;
            }
            static wI(a, c, d) {
              b.lr.Bb(c) || b.lr.Ua(c, new Map());
              b.lr.getItem(c).set(d, a);
            }
            static wE(a) {
              const c = h.W.af.zb(a);
              b.RR.Ua(c.name, c);
              if (null != b.QG && "" != c.name) c.dga(b.QG);else if ("" == c.name) for (b.QG = a, a = 0; a < b.Ce.length; a++) b.Ce.ea(a).dga(b.QG);
              b.Ce.Ua(c.name, c);
            }
            static y$(a) {
              return b.Ce.Bb(a) ? b.Ce.getItem(a) : "" != a && b.Ce.Bb("") ? b.Ce.getItem("") : b.wda();
            }
            static Oza() {
              return b.RR.slice();
            }
            static clear() {
              b.Ce = new e.ub();
              b.RR = new e.ub();
              b.QG = null;
              b.lr = new e.ub();
            }
            static pT() {
              return b.y$("");
            }
            static wda() {
              return new h.W.af();
            }
            static Uya(a, c) {
              return b.lr.Bb(a) && b.lr.getItem(a).has(c);
            }
            static EAa() {
              return b.lr;
            }
            static dispose() {
              b.Ce = null;
              b.RR = null;
              b.QG = null;
              b.lr = null;
            }
          }
          b.Ce = new e.ub();
          b.RR = new e.ub();
          b.lr = new e.ub();
          b.QG = null;
          h.pj = b;
        })(k.ac || (k.ac = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                this.name = "";
                this.Kb = {};
                this.Vd = {
                  thousandsSeparator: " ",
                  decimalSeparator: ".",
                  decimalPlaces: -1,
                  maxDecimalPlaces: -1,
                  maxSymbols: 20,
                  currencySymbol: "",
                  positiveCurrencyFormat: b.Xz.$1,
                  negativeCurrencyFormat: b.iq["-$1"],
                  negativeNumberFormat: b.fI["-1"],
                  nullValue: "",
                  infinityValue: "Infinity",
                  divideByZeroValue: "Infinity",
                  textAlign: b.textAlign.RIGHT,
                  isPercent: !1,
                  isCount: !1,
                  beautifyFloatingPoint: !0
                };
                this.name = a;
              }
              get Sd() {
                return this.Kb;
              }
              get Kf() {
                return void 0 != this.Kb.thousandsSeparator ? this.Kb.thousandsSeparator : this.Vd.thousandsSeparator;
              }
              set Kf(a) {
                this.Kb.thousandsSeparator = a;
              }
              get HC() {
                return void 0 != this.Kb.decimalSeparator ? this.Kb.decimalSeparator : this.Vd.decimalSeparator;
              }
              set HC(a) {
                this.Kb.decimalSeparator = a;
              }
              get Sl() {
                return void 0 != this.Kb.decimalPlaces ? this.Kb.decimalPlaces : this.Vd.decimalPlaces;
              }
              set Sl(a) {
                this.Kb.decimalPlaces = a;
              }
              get $u() {
                return void 0 != this.Kb.maxDecimalPlaces ? this.Kb.maxDecimalPlaces : this.Vd.maxDecimalPlaces;
              }
              set $u(a) {
                this.Kb.maxDecimalPlaces = a;
              }
              get lx() {
                return void 0 != this.Kb.maxSymbols ? this.Kb.maxSymbols : this.Vd.maxSymbols;
              }
              set lx(a) {
                this.Kb.maxSymbols = a;
              }
              get xd() {
                return void 0 != this.Kb.currencySymbol ? this.Kb.currencySymbol : this.Vd.currencySymbol;
              }
              set xd(a) {
                this.Kb.currencySymbol = a;
              }
              get Zs() {
                return void 0 != this.Kb.positiveCurrencyFormat ? this.Kb.positiveCurrencyFormat : this.Vd.positiveCurrencyFormat;
              }
              set Zs(a) {
                this.Kb.positiveCurrencyFormat = a;
              }
              get Ss() {
                return void 0 != this.Kb.negativeCurrencyFormat ? this.Kb.negativeCurrencyFormat : this.Vd.negativeCurrencyFormat;
              }
              set Ss(a) {
                this.Kb.negativeCurrencyFormat = a;
              }
              get Qz() {
                return void 0 != this.Kb.negativeNumberFormat ? this.Kb.negativeNumberFormat : this.Vd.negativeNumberFormat;
              }
              set Qz(a) {
                this.Kb.negativeNumberFormat = a;
              }
              get TD() {
                return void 0 != this.Kb.nullValue ? this.Kb.nullValue : this.Vd.nullValue;
              }
              set TD(a) {
                this.Kb.nullValue = a;
              }
              get xD() {
                return void 0 != this.Kb.infinityValue ? this.Kb.infinityValue : this.Vd.infinityValue;
              }
              set xD(a) {
                this.Kb.infinityValue = a;
              }
              get KC() {
                return void 0 != this.Kb.divideByZeroValue ? this.Kb.divideByZeroValue : this.Vd.divideByZeroValue;
              }
              set KC(a) {
                this.Kb.divideByZeroValue = a;
              }
              get textAlign() {
                return void 0 != this.Kb.textAlign ? this.Kb.textAlign : this.Vd.textAlign;
              }
              set textAlign(a) {
                this.Kb.textAlign = a;
              }
              get ce() {
                return void 0 != this.Kb.isPercent ? this.Kb.isPercent : this.Vd.isPercent;
              }
              set ce(a) {
                this.Kb.isPercent = a;
              }
              get Fe() {
                return void 0 != this.Kb.isCount ? this.Kb.isCount : this.Vd.isCount;
              }
              set Fe(a) {
                this.Kb.isCount = a;
              }
              get xG() {
                return void 0 != this.Kb.beautifyFloatingPoint ? this.Kb.beautifyFloatingPoint : this.Vd.beautifyFloatingPoint;
              }
              set xG(a) {
                this.Kb.beautifyFloatingPoint = a;
              }
              set c0(a) {}
              get c0() {
                return 1 < this.xd.length && "&" == this.xd.charAt(0) && ";" == this.xd.charAt(this.xd.length - 1) ? 1 : this.xd.length;
              }
              sja() {
                var a;
                if ("%" == this.xd) {
                  var c = -1 == this.Sl || this.Fe ? 0 : this.Sl;
                  var d = 0 < c ? "0." : "0";
                  for (a = 0; a < c; a++) d += "0";
                  return d += this.xd;
                }
                d = "" != this.Kf ? "#,##0" : "###0";
                if (!this.Fe) if (0 < this.Sl) for (d += ".", a = 0; a < this.Sl; a++) d += "0";else 0 > this.Sl && (d += ".0#########");
                "" != this.xd ? (a = this.xd, d = 1 < a.length ? this.Zs == b.Xz.$1 ? "[$" + a + "]\\ " + d + ";" + u.cc.bM(d, "[$" + a + "]", this.Ss) : d + "\\ [$" + a + "];" + u.cc.bM(d, "[$" + a + "]", this.Ss) : this.Zs == b.Xz.$1 ? "\\" + this.xd + d + ";" + u.cc.bM(d, this.xd, this.Ss) : d + "\\" + this.xd + ";" + u.cc.bM(d, this.xd, this.Ss)) : "" == this.xd && (d = d + ";" + u.cc.S0(d, this.Qz));
                return d;
              }
              Sa() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = {};
                c.name = this.name;
                if (a) c.thousandsSeparator = this.Kf, c.decimalSeparator = this.HC, c.decimalPlaces = this.Sl, c.maxDecimalPlaces = this.$u, c.maxSymbols = this.lx, c.currencySymbol = this.xd, c.positiveCurrencyFormat = this.Zs, c.negativeCurrencyFormat = this.Ss, c.negativeNumberFormat = this.Qz, c.nullValue = this.TD, c.infinityValue = this.xD, c.divideByZeroValue = this.KC, c.textAlign = "" !== this.textAlign ? this.textAlign : b.textAlign.RIGHT, c.isPercent = this.ce, c.isCount = this.Fe, c.beautifyFloatingPoint = this.xG;else for (var d in this.Kb) c[d] = "textAlign" === d ? "" === this.textAlign ? b.textAlign.RIGHT : this.textAlign : this.Kb[d];
                return c;
              }
              static zb(a) {
                var c = new b();
                null != a.name && (c.name = a.name);
                null != a.thousandsSeparator && k.Tb.valid(a.thousandsSeparator) && (c.Kf = k.Tb.validate(a.thousandsSeparator, !0));
                null != a.decimalSeparator && k.Tb.valid(a.decimalSeparator) && (c.HC = k.Tb.validate(a.decimalSeparator, !0));
                null != a.decimalPlaces && -1 <= parseInt(a.decimalPlaces) && (c.Sl = isNaN(parseInt(a.decimalPlaces)) ? -1 : parseInt(a.decimalPlaces));
                null != a.maxDecimalPlaces && -1 <= parseInt(a.maxDecimalPlaces) && (c.$u = isNaN(parseInt(a.maxDecimalPlaces)) ? -1 : parseInt(a.maxDecimalPlaces));
                null != a.maxSymbols && 1 <= parseInt(a.maxSymbols) && (c.lx = a.maxSymbols);
                null != a.currencySymbol && k.Tb.valid(a.currencySymbol) && (c.xd = k.Tb.validate(a.currencySymbol, !0));
                if (null != a.currencySymbolAlign && k.Tb.valid(a.currencySymbolAlign)) {
                  var d = k.Tb.validate(a.currencySymbolAlign);
                  d == b.Uba.LEFT ? c.Zs = b.Xz.$1 : d == b.Uba.RIGHT && (c.Zs = b.Xz["1$"]);
                }
                null != a.positiveCurrencyFormat && k.Tb.valid(a.positiveCurrencyFormat) && (c.Zs = k.Tb.validate(a.positiveCurrencyFormat, !0));
                null != a.negativeCurrencyFormat && k.Tb.valid(a.negativeCurrencyFormat) && (c.Ss = k.Tb.validate(a.negativeCurrencyFormat, !0));
                null != a.negativeNumberFormat && k.Tb.valid(a.negativeNumberFormat) && (c.Qz = k.Tb.validate(a.negativeNumberFormat));
                null != a.nullValue && k.Tb.valid(a.nullValue) && (c.TD = k.Tb.validate(a.nullValue, !0));
                null != a.infinityValue && k.Tb.valid(a.infinityValue) && (c.xD = k.Tb.validate(a.infinityValue, !0));
                null != a.divideByZeroValue && k.Tb.valid(a.divideByZeroValue) && (c.KC = k.Tb.validate(a.divideByZeroValue, !0));
                null != a.textAlign && k.Tb.valid(a.textAlign) && (c.textAlign = k.Tb.validate(a.textAlign));
                null != a.isPercent && (c.ce = 1 == a.isPercent);
                null != a.isCount && (c.Fe = 1 == a.isCount);
                null != a.beautifyFloatingPoint && (c.xG = 1 == a.beautifyFloatingPoint);
                return c;
              }
              clone() {
                var a = new b();
                a.name = this.name;
                this.Kb.hasOwnProperty("thousandsSeparator") && (a.Kf = this.Kf);
                this.Kb.hasOwnProperty("decimalSeparator") && (a.HC = this.HC);
                this.Kb.hasOwnProperty("decimalPlaces") && (a.Sl = this.Sl);
                this.Kb.hasOwnProperty("maxDecimalPlaces") && (a.$u = this.$u);
                this.Kb.hasOwnProperty("maxSymbols") && (a.lx = this.lx);
                this.Kb.hasOwnProperty("currencySymbol") && (a.xd = this.xd);
                this.Kb.hasOwnProperty("positiveCurrencyFormat") && (a.Zs = this.Zs);
                this.Kb.hasOwnProperty("negativeCurrencyFormat") && (a.Ss = this.Ss);
                this.Kb.hasOwnProperty("negativeNumberFormat") && (a.Qz = this.Qz);
                this.Kb.hasOwnProperty("nullValue") && (a.TD = this.TD);
                this.Kb.hasOwnProperty("infinityValue") && (a.xD = this.xD);
                this.Kb.hasOwnProperty("divideByZeroValue") && (a.KC = this.KC);
                this.Kb.hasOwnProperty("textAlign") && (a.textAlign = this.textAlign);
                this.Kb.hasOwnProperty("isPercent") && (a.ce = this.ce);
                this.Kb.hasOwnProperty("isPercent") && (a.Fe = this.Fe);
                this.Kb.hasOwnProperty("beautifyFloatingPoint") && (a.xG = this.xG);
                var c = {},
                  d;
                for (d in this.Vd) c[d] = this.Vd[d];
                a.Vd = c;
                return a;
              }
              dga(a) {
                for (var c in a) this.Vd[c] = a[c];
              }
            }
            b.Uba = {
              LEFT: "left",
              RIGHT: "right"
            };
            b.iq = {
              "-$1": "-$1",
              "-1$": "-1$",
              "$-1": "$-1",
              "$1-": "$1-",
              "1-$": "1-$",
              "1$-": "1$-",
              "($1)": "($1)",
              "(1$)": "(1$)",
              "$(1)": "$(1)",
              "(1)$": "(1)$"
            };
            b.Xz = {
              $1: "$1",
              "1$": "1$"
            };
            b.fI = {
              "-1": "-1",
              "- 1": "- 1",
              "1-": "1-",
              "1 -": "1 -",
              "(1)": "(1)"
            };
            b.textAlign = {
              LEFT: "left",
              CENTER: "center",
              RIGHT: "right"
            };
            f.af = b;
          })(h.W || (h.W = {}));
        })(k.ac || (k.ac = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static valid(b) {
              return b == f.hg || b == f.Cc || b == f.Md || b == f.API || b == f.JSON || b == f.Xh || b == f.Gq || b == f.EMPTY;
            }
            static Ic(b) {
              return this.valid(b) && (b == f.Md || b == f.Cc || b == f.hg || b == f.API);
            }
            static J(b) {
              return b == f.Xh ? "CSV" : b == f.Gq ? "OCSV" : b == f.JSON ? "JSON" : b == f.Cc ? "Microsoft Analysis Services" : b == f.Md ? "Mondrian" : b == f.hg ? "Elasticsearch" : b == f.API ? "Flexmonster Custom API" : "";
            }
          }
          f.Cc = "microsoft analysis services";
          f.Md = "mondrian";
          f.Xh = "csv";
          f.Gq = "ocsv";
          f.JSON = "json";
          f.hg = "elasticsearch";
          f.API = "api";
          f.EMPTY = "";
          h.qa = f;
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static validate(m) {
              if (e.ia(m)) return f.NONE;
              m = m.toLowerCase();
              return 0 <= f.types.indexOf(m) ? m : f.NONE;
            }
            static Kea(m, n) {
              switch (m) {
                case h.ib.$c:
                  return c.ah(n);
                case h.ib.jb:
                  return b.ah(n);
                case h.ib.Ta:
                  return d.ah(n);
              }
              return !1;
            }
          }
          f.NONE = "none";
          f.Zk = "label";
          f.Ta = "date";
          f.jb = "number";
          f.jo = "value";
          f.ic = "time";
          f.types = [f.NONE, f.Zk, f.Ta, f.jb, f.jo, f.ic];
          h.rb = f;
          class b {
            static ah(m) {
              return e.v(m) ? !1 : 0 <= b.Aq.indexOf(m.toLowerCase());
            }
          }
          b.EQUAL = "equal";
          b.Pf = "not_equal";
          b.GREATER = "greater";
          b.Xk = "greater_equal";
          b.LESS = "less";
          b.$k = "less_equal";
          b.fh = "between";
          b.Og = "not_between";
          b.si = [b.EQUAL, b.Pf, b.GREATER, b.Xk, b.LESS, b.$k];
          b.Qf = [b.fh, b.Og];
          b.Aq = [b.EQUAL, b.Pf, b.GREATER, b.Xk, b.LESS, b.$k, b.fh, b.Og];
          h.Pg = b;
          class a extends b {}
          h.bl = a;
          class c {
            static ah(m) {
              return e.v(m) ? !1 : 0 <= c.Aq.indexOf(m.toLowerCase());
            }
          }
          c.EQUAL = "equal";
          c.Pf = "not_equal";
          c.UE = "begin";
          c.ZA = "not_begin";
          c.NA = "end";
          c.aB = "not_end";
          c.Un = "contain";
          c.$A = "not_contain";
          c.GREATER = "greater";
          c.Xk = "greater_equal";
          c.LESS = "less";
          c.$k = "less_equal";
          c.fh = "between";
          c.Og = "not_between";
          c.si = [c.EQUAL, c.Pf, c.UE, c.ZA, c.NA, c.aB, c.Un, c.$A, c.GREATER, c.Xk, c.LESS, c.$k];
          c.Qf = [c.fh, c.Og];
          c.Aq = [c.EQUAL, c.Pf, c.UE, c.ZA, c.NA, c.aB, c.Un, c.$A, c.GREATER, c.Xk, c.LESS, c.$k, c.fh, c.Og];
          h.Cb = c;
          class d {
            static ah(m) {
              return e.v(m) ? !1 : 0 <= d.Aq.indexOf(m.toLowerCase());
            }
          }
          d.EQUAL = "equal";
          d.Pf = "not_equal";
          d.SE = "before";
          d.TE = "before_equal";
          d.PE = "after";
          d.QE = "after_equal";
          d.fh = "between";
          d.Og = "not_between";
          d.qP = "last";
          d.HO = "current";
          d.LP = "next";
          d.si = [d.EQUAL, d.Pf, d.SE, d.TE, d.PE, d.QE];
          d.Qf = [d.fh, d.Og];
          d.jy = [d.qP, d.HO, d.LP];
          d.Aq = [d.EQUAL, d.Pf, d.SE, d.TE, d.PE, d.QE, d.fh, d.Og, d.qP, d.HO, d.LP];
          h.bc = d;
          class g {
            static ah(m) {
              return e.v(m) ? !1 : 0 <= g.types.indexOf(m.toLowerCase());
            }
          }
          g.en = "day";
          g.fK = "week";
          g.ih = "month";
          g.Ct = "quarter";
          g.Jl = "year";
          g.types = [g.en, g.fK, g.ih, g.Ct, g.Jl];
          h.LA = g;
          class l extends b {
            static ah(m) {
              return e.v(m) ? !1 : 0 <= l.Aq.indexOf(m.toLowerCase());
            }
          }
          l.Nj = "top";
          l.ni = "bottom";
          l.si = [l.Nj, l.ni, l.EQUAL, l.Pf, l.GREATER, l.Xk, l.LESS, l.$k];
          l.Qf = [l.fh, l.Og];
          l.Aq = [l.Nj, l.ni, l.EQUAL, l.Pf, l.GREATER, l.Xk, l.LESS, l.$k, l.fh, l.Og];
          h.Vb = l;
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static ah(b) {
              return b == f.ed || b == f.kc || b == f.Mc;
            }
            static xT() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              return c ? b == k.i.Aa.kc ? a ? k.i.Aa.ed : k.i.Aa.Mc : b == k.i.Aa.Mc ? a ? k.i.Aa.kc : k.i.Aa.ed : a ? k.i.Aa.Mc : k.i.Aa.kc : b == k.i.Aa.Mc ? k.i.Aa.kc : k.i.Aa.Mc;
            }
          }
          f.ed = "unsorted";
          f.kc = "asc";
          f.Mc = "desc";
          f.ipa = "numericRange";
          h.Aa = f;
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {}
          }
          f.Ia = "rows";
          f.Ra = "columns";
          f.At = "pages";
          h.ha = f;
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    var pa = q || (q = {}),
      qa = pa.u || (pa.u = {}),
      ra = qa.i || (qa.i = {});
    class ta {}
    ta.YA = 1;
    ta.BP = 2;
    ra.MA = ta;
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static UC(b) {
              var a = f.uv;
              switch (b) {
                case h.input.Df.h8.BP:
                  a = f.qp;
                  break;
                case h.input.Df.h8.YA:
                  a = f.Ta;
              }
              return a;
            }
            static U0(b) {
              return 0 <= h.Qa.RL.indexOf(b) ? f.qp : "date" == b ? f.Ta : f.uv;
            }
            static $S(b) {
              var a = f.uv;
              switch (b) {
                case h.input.sa.jb:
                case h.input.sa.ic:
                  a = f.qp;
                  break;
                case h.input.sa.lj:
                case h.input.sa.Fq:
                case h.input.sa.op:
                case h.input.sa.Lc:
                case h.input.sa.Ta:
                  a = f.Ta;
              }
              return a;
            }
            static oA(b) {
              var a = h.input.sa.$c;
              switch (b) {
                case f.qp:
                  a = h.input.sa.jb;
                  break;
                case f.Ta:
                  a = h.input.sa.Ta;
              }
              return a;
            }
          }
          f.uv = 0;
          f.Ta = 1;
          f.qp = 2;
          f.RL = ["keyword", "date", "boolean"];
          h.Fc = f;
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static UC(b) {
              switch (b) {
                case h.input.Df.WA.$c:
                case h.input.Df.WA.gra:
                  return f.$c;
                case h.input.Df.WA.jp:
                  return f.jp;
                case h.input.Df.WA.Ta:
                  return f.Ta;
                case h.input.Df.WA.Lc:
                  return f.Lc;
                case h.input.Df.WA.Hqa:
                  return f.ic;
                case h.input.Df.WA.zc:
                  return f.zc;
              }
              return f.jb;
            }
            static gza(b) {
              b = b.toLowerCase();
              switch (b) {
                case "string":
                  return f.Ta;
                case "integer":
                case "number":
                case "double":
                  return f.jb;
                default:
                  return f.jb;
              }
            }
            static dza(b) {
              switch (b) {
                case 13:
                  return f.ic;
                case 15:
                  return f.Lc;
                case 3:
                  return f.jp;
                case 12:
                  return f.jb;
              }
              return f.zc;
            }
            static fza(b) {
              var a = f.zc;
              switch (b) {
                case "number":
                  a = f.jb;
                  break;
                case "string":
                  a = f.$c;
                  break;
                case "boolean":
                  a = f.jp;
                  break;
                case "date":
                  a = f.Ta;
                  break;
                case "timestamp":
                  a = f.ic;
                  break;
                case "count":
                  a = f.zc;
              }
              return a;
            }
            static U0(b) {
              return 0 <= h.Fc.RL.indexOf(b) ? f.zc : f.jb;
            }
            static oA(b) {
              switch (b) {
                case f.$c:
                  return h.input.sa.$c;
                case f.jp:
                  return h.input.sa.jp;
                case f.Ta:
                  return h.input.sa.Ta;
                case f.Lc:
                  return h.input.sa.Lc;
                case f.ic:
                  return h.input.sa.ic;
                case f.zc:
                  return h.input.sa.$c;
              }
              return h.input.sa.jb;
            }
          }
          f.jb = 1;
          f.$c = 2;
          f.jp = 3;
          f.Ta = 4;
          f.ic = 5;
          f.Lc = 6;
          f.zc = 7;
          f.RL = "long integer short byte double float half_float scaled_float".split(" ");
          h.Qa = f;
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static sU(b) {
              return b === f.jb || b === f.Jl || b === f.en || b === f.jP || b === f.IP || b === f.jY || b === f.O8 || b === f.Lc || b === f.ic || b === f.Ta || b === f.lj;
            }
            static yCa(b) {
              return b === f.Ta || b === f.Lc || b === f.lj;
            }
            static eza(b) {
              switch (b) {
                case 2:
                case 4:
                case 5:
                case 6:
                case 14:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                case 21:
                  return f.jb;
              }
              return f.$c;
            }
            static UC(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              if (a) return f.eza(c);
              switch (b) {
                case h.input.Df.Yk.Zna:
                  return f.Wja;
                case h.input.Df.Yk.$na:
                case 4178:
                case 4561:
                case 4562:
                  return f.jb;
                case h.input.Df.Yk.aoa:
                case h.input.Df.Yk.moa:
                  return f.ic;
                case h.input.Df.Yk.eoa:
                case h.input.Df.Yk.doa:
                case h.input.Df.Yk.foa:
                  return f.en;
                case h.input.Df.Yk.goa:
                case 4385:
                case 4328:
                case 4329:
                  return f.IX;
                case h.input.Df.Yk.hoa:
                  return f.jP;
                case h.input.Df.Yk.ioa:
                  return f.IP;
                case h.input.Df.Yk.joa:
                  return f.ih;
                case h.input.Df.Yk.koa:
                case 4336:
                case 4337:
                case 4578:
                  return f.Ct;
                case h.input.Df.Yk.loa:
                  return f.jY;
                case h.input.Df.Yk.noa:
                case 4345:
                case h.input.Df.Yk.ooa:
                case 4344:
                  return f.fK;
                case h.input.Df.Yk.poa:
                case 4759:
                case 4345:
                case 4346:
                  return f.Jl;
                case h.input.Df.Yk.coa:
                case h.input.Df.Yk.boa:
                case 4657:
                case 4659:
                case 4292:
                case 4294:
                  return f.Ta;
              }
              return f.$c;
            }
            static oA(b) {
              switch (b) {
                case f.jb:
                case f.jP:
                case f.IP:
                case f.jY:
                case f.O8:
                  return h.input.sa.jb;
                case f.Ta:
                case f.Jl:
                case f.Jl:
                case f.en:
                  return h.input.sa.Ta;
                case f.jp:
                  return h.input.sa.jp;
                case f.ih:
                  return h.input.sa.ih;
                case f.kn:
                  return h.input.sa.kn;
                case f.ic:
                  return h.input.sa.ic;
                case f.Lc:
                  return h.input.sa.Lc;
                case f.lj:
                  return h.input.sa.lj;
                default:
                  return h.input.sa.$c;
              }
            }
            static $S(b) {
              switch (b) {
                case h.input.sa.$c:
                  return f.$c;
                case h.input.sa.jb:
                  return f.jb;
                case h.input.sa.jp:
                  return f.jp;
                case h.input.sa.ih:
                  return f.ih;
                case h.input.sa.kn:
                  return f.kn;
                case h.input.sa.Ta:
                case h.input.sa.Fq:
                case h.input.sa.op:
                  return f.Ta;
                case h.input.sa.lj:
                  return f.lj;
                case h.input.sa.ic:
                  return f.ic;
                case h.input.sa.Lc:
                  return f.Lc;
                default:
                  return f.$c;
              }
            }
          }
          f.Wja = 0;
          f.$c = 1;
          f.jb = 2;
          f.jp = 3;
          f.Ta = 4;
          f.ic = 5;
          f.Jl = 6;
          f.IX = 7;
          f.Ct = 8;
          f.ih = 9;
          f.fK = 10;
          f.kn = 11;
          f.en = 12;
          f.jP = 13;
          f.IP = 14;
          f.jY = 15;
          f.O8 = 16;
          f.Lc = 17;
          f.lj = 18;
          h.ib = f;
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      e = e.u || (e.u = {});
      e = e.i || (e.i = {});
      e = e.input || (e.input = {});
      e = e.Df || (e.Df = {});
      class k {}
      k.YA = 1;
      k.BP = 2;
      e.h8 = k;
    })(q || (q = {}));
    (function (e) {
      e = e.u || (e.u = {});
      e = e.i || (e.i = {});
      e = e.input || (e.input = {});
      e = e.Df || (e.Df = {});
      class k {}
      k.jb = 1;
      k.$c = 2;
      k.jp = 3;
      k.Ta = 4;
      k.gra = 5;
      k.Hqa = 6;
      k.zc = 7;
      k.Lc = 8;
      e.WA = k;
    })(q || (q = {}));
    (function (e) {
      e = e.u || (e.u = {});
      e = e.i || (e.i = {});
      e = e.input || (e.input = {});
      e = e.Df || (e.Df = {});
      class k {}
      k.Zna = 1;
      k.$na = 2;
      k.aoa = 4;
      k.coa = 516;
      k.goa = 36;
      k.hoa = 772;
      k.ioa = 1028;
      k.joa = 132;
      k.koa = 68;
      k.loa = 2052;
      k.moa = 4100;
      k.noa = 260;
      k.poa = 20;
      k.boa = 4289;
      k.doa = 4296;
      k.eoa = 4301;
      k.foa = 4302;
      k.ooa = 4759;
      e.Yk = k;
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              static valid(a) {
                return -1 < b.aL.indexOf(a);
              }
              static T5(a) {
                return "" === a ? b.$c : "number" != typeof a && isNaN(Number(a)) ? e.P.gU(a) ? e.model.C.F.HL : b.$c : b.jb;
              }
              static bza(a) {
                a = a.trim();
                var c = b.$c;
                "+" == a.charAt(0) ? c = b.$c : "t+" == a.substr(0, 2) ? c = b.ic : "dt+" == a.substr(0, 3) ? c = b.Lc : "n+" == a.substr(0, 2) ? c = b.jb : "-" == a.charAt(0) ? c = b.jb : "ds+" == a.substr(0, 3) ? c = b.lj : "d+" == a.substr(0, 2) ? c = b.Ta : "m+" == a.substr(0, 2) ? c = b.ih : "w+" == a.substr(0, 2) ? c = b.kn : "D+" == a.substr(0, 2) ? c = b.Fq : "D4+" == a.substr(0, 3) ? c = b.op : "id+" == a.substr(0, 3) && (c = b.ay);
                return c;
              }
            }
            b.jb = "number";
            b.$c = "string";
            b.jp = "boolean";
            b.Of = "level";
            b.ih = "month";
            b.kn = "weekday";
            b.Ta = "date";
            b.lj = "date string";
            b.Fq = "year/month/day";
            b.op = "year/quarter/month/day";
            b.ic = "time";
            b.Lc = "datetime";
            b.ay = "id";
            b.e7 = "delete";
            b.g8 = "hidden";
            b.wF = "property";
            b.VI = "any";
            b.aL = "number;string;boolean;level;month;weekday;date;date string;year/month/day;year/quarter/month/day;time;datetime;id;delete;hidden;property;array;any".split(";");
            f.sa = b;
          })(h.input || (h.input = {}));
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static get UI() {
              return f.xA.concat(f.yA);
            }
            static get ika() {
              0 === f.DY.length && (f.DY = f.Tja.concat(f.yA));
              return f.DY;
            }
            static get fka() {
              0 === f.CY.length && (f.CY = f.Sja);
              return f.CY;
            }
            static get m6() {
              0 === f.BY.length && (f.BY = [f.NONE].concat(f.yA));
              return f.BY;
            }
            static tG(b) {
              return b === f.Mq ? e.model.B.j.x9 : b === f.zc ? e.model.B.j.R6 : b === f.mj || b === f.OO ? e.model.B.j.Hla : b === f.Bq ? e.model.B.j.n6 : b === f.Av ? e.model.B.j.roa : b === f.Gv ? e.model.B.j.mqa : b === f.Hv ? e.model.B.j.oqa : b === f.Bt ? e.model.B.j.Gpa : b === f.MIN ? e.model.B.j.Voa : b === f.MAX ? e.model.B.j.Xna : b === f.Vr ? e.model.B.j.spa : b === f.tp || b === f.OP ? e.model.B.j.tpa : b === f.Kq ? e.model.B.j.Epa : b === f.Iq ? e.model.B.j.Apa : b === f.Jq ? e.model.B.j.Cpa : b === f.Pi ? e.model.B.j.vna : b === f.Xn || b === f.NO ? e.model.B.j.Dla : b === f.fn ? e.model.B.j.Fla : b === f.co || b === f.PP ? e.model.B.j.vpa : b === f.hn ? e.model.B.j.xpa : b === f.jn || b === f.TP ? e.model.B.j.Tpa : b === f.fo ? e.model.B.j.Vpa : b === f.NONE ? e.model.B.j.fpa : b;
            }
            static e_() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var a = [];
              b = b ? b : f.UI;
              for (var c = 0; c < b.length; c++) a.push(f.tG(b[c]));
              return a;
            }
            static Naa() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var a = [];
              b = b ? b : f.UI;
              for (var c = 0; c < b.length; c++) b[c] === f.Mq ? a.push(e.model.B.j.aK) : b[c] === f.zc ? a.push(e.model.B.j.FO) : b[c] === f.mj || b[c] === f.OO ? a.push(e.model.B.j.PO) : b[c] === f.Bq ? a.push(e.model.B.j.AO) : b[c] === f.Av ? a.push(e.model.B.j.QX) : b[c] === f.Gv ? a.push(e.model.B.j.ZP) : b[c] === f.Hv ? a.push(e.model.B.j.$P) : b[c] === f.Bt ? a.push(e.model.B.j.QP) : b[c] === f.MIN ? a.push(e.model.B.j.JP) : b[c] === f.MAX ? a.push(e.model.B.j.AP) : b[c] === f.Vr ? a.push(e.model.B.j.VJ) : b[c] === f.tp || b[c] === f.OP ? a.push(e.model.B.j.PJ) : b[c] === f.Kq ? a.push(e.model.B.j.UJ) : b[c] === f.Iq ? a.push(e.model.B.j.SJ) : b[c] === f.Jq ? a.push(e.model.B.j.TJ) : b[c] === f.Pi ? a.push(e.model.B.j.DJ) : b[c] === f.Xn || b[c] === f.NO ? a.push(e.model.B.j.iJ) : b[c] === f.fn ? a.push(e.model.B.j.jJ) : b[c] === f.co || b[c] === f.PP ? a.push(e.model.B.j.QJ) : b[c] === f.hn ? a.push(e.model.B.j.RJ) : b[c] === f.jn || b[c] === f.TP ? a.push(e.model.B.j.SP) : b[c] === f.fo ? a.push(e.model.B.j.UP) : b[c] === f.NONE ? a.push("{0}") : -1 < f.xA.indexOf(b[c]) && a.push(`{0} (${b[c]})`);
              return a;
            }
            static tA(b) {
              return -1 !== f.UI.indexOf(b) || b === f.NONE;
            }
            static BLa(b) {
              return -1 !== f.m6.indexOf(b);
            }
            static NE(b) {
              return -1 !== f.Qja.indexOf(b) || b === f.NONE;
            }
            static hp(b) {
              return -1 !== f.Rja.indexOf(b) || b === f.NONE;
            }
            static Fe(b) {
              return -1 !== f.Uja.indexOf(b);
            }
            static ce(b) {
              return -1 !== f.Vja.indexOf(b);
            }
            static SM(b) {
              return b === f.Xn || b === f.fn || b === f.co || b === f.hn;
            }
            static YM(b) {
              return b === f.jn || b === f.fo;
            }
            static az(b) {
              return b === f.OO || b === f.OP || b === f.NO || b === f.PP || b === f.TP;
            }
            static mz(b) {
              switch (b) {
                case f.OO:
                  return f.mj;
                case f.OP:
                  return f.tp;
                case f.NO:
                  return f.Xn;
                case f.PP:
                  return f.co;
                case f.TP:
                  return f.jn;
                default:
                  return "";
              }
            }
            static aU(b) {
              return -1 !== f.xA.indexOf(b) || b === f.NONE;
            }
          }
          f.Mq = "sum";
          f.zc = "count";
          f.mj = "distinctcount";
          f.OO = "distinct count";
          f.Bq = "average";
          f.Av = "median";
          f.Gv = "stdevp";
          f.Hv = "stdevs";
          f.Vr = "percent";
          f.tp = "percentofcolumn";
          f.Kq = "percentofrow";
          f.Iq = "percentofparentcolumntotal";
          f.Jq = "percentofparentrowtotal";
          f.OP = "percent of column";
          f.Bt = "product";
          f.Pi = "index";
          f.jn = "runningtotalsofcolumn";
          f.fo = "runningtotalsofrow";
          f.TP = "runningtotals";
          f.MIN = "min";
          f.MAX = "max";
          f.NONE = "none";
          f.Xn = "differenceofcolumn";
          f.fn = "differenceofrow";
          f.NO = "difference";
          f.co = "%differenceofcolumn";
          f.hn = "%differenceofrow";
          f.PP = "%difference";
          f.xA = [f.Mq, f.zc, f.mj, f.Bq, f.Av, f.Bt, f.MIN, f.MAX, f.Gv, f.Hv];
          f.yA = [f.Vr, f.tp, f.Kq, f.Iq, f.Jq, f.Pi, f.Xn, f.fn, f.co, f.hn, f.jn, f.fo];
          f.IO = [];
          f.Tja = [f.zc, f.mj];
          f.DY = [];
          f.Sja = [f.MAX, f.MIN, f.zc, f.mj];
          f.CY = [];
          f.BY = [];
          f.gka = [f.Mq, f.zc, f.mj, f.Bq, f.MIN, f.MAX];
          f.hka = [f.zc, f.mj];
          f.Uja = [f.zc, f.mj];
          f.Vja = [f.Vr, f.tp, f.Kq, f.Iq, f.Jq, f.co, f.hn];
          f.Qja = [f.Mq, f.Bq, f.Av, f.Bt, f.MIN, f.MAX];
          f.Rja = [f.Mq, f.Bq, f.Av, f.Bt, f.MIN, f.MAX, f.Gv, f.Hv, f.Xn, f.fn, f.jn, f.fo];
          h.da = f;
        })(k.i || (k.i = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    var ua = q || (q = {}),
      wa = ua.u || (ua.u = {}),
      xa = wa.i || (wa.i = {});
    class ya {}
    ya.wO = "+";
    ya.aQ = "-";
    ya.KP = "*";
    ya.kJ = "/";
    ya.$X = "^";
    ya.LESS = "<";
    ya.GREATER = ">";
    ya.EQUAL = "=";
    ya.Xla = "==";
    ya.Pf = "!=";
    ya.p8 = "<=";
    ya.c8 = ">=";
    ya.d9 = "or";
    ya.e6 = "and";
    ya.kP = "if";
    ya.PW = "abs";
    ya.gY = "round";
    ya.MIN = "min";
    ya.MAX = "max";
    ya.nka = "isnan";
    ya.hpa = "!isnan";
    ya.jo = "value";
    ya.kQ = "updatedifference";
    ya.lQ = "updatepercent";
    xa.sc = ya;
    var za = q || (q = {}),
      Aa = za.u || (za.u = {}),
      Ba = Aa.i || (Aa.i = {});
    class Ca {}
    Ca.ho = "select";
    Ca.gF = "expand";
    Ca.H6 = "collapse";
    Ca.lX = "drillUp";
    Ca.Vx = "drillDown";
    Ca.jX = "drillDownTo";
    Ca.lJ = "drillThrough";
    Ca.ZO = "filter";
    Ca.iY = "search";
    Ba.$d = Ca;
    var Da = q || (q = {}),
      Ea = Da.u || (Da.u = {}),
      Fa = Ea.i || (Ea.i = {});
    class Ga {}
    Ga.QO = Number.NEGATIVE_INFINITY;
    Fa.RO = Ga;
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.Bl = () => this.Ws();
              this.Lj = () => this.oq();
            }
            NDa(b, a, c) {
              try {
                this.dispose(), this.Mb = c, this.GC = this.tk = 0, this.kx = u.py.FH(b), this.cO(this.kx, a);
              } catch (d) {
                this.Sb(d);
              }
            }
            ur() {
              e.Da(!1);
              let b;
              try {
                b = JSON.parse(this.oa.response);
              } catch (a) {
                b = null;
              }
              null != this.Mb && (this.Mb(b), this.dispose());
            }
            fFa() {
              e.Da(!0, e.model.B.j.WX, "");
            }
            nq(b) {
              const a = b.data;
              if (404 == a.target.status) this.Sb(b);else if (!e.v(this.oa)) try {
                const d = this.oa.response;
                if (null != d && 0 != d.length && (this.tk != a.loaded || this.GC != d.length)) {
                  this.tk = a.loaded;
                  this.GC = d.length;
                  var c = 0 == a.total ? e.P.bind(e.model.B.j.om, u.cc.Vg(a.loaded)) : e.P.bind(e.model.B.j.sF, u.cc.Vg(a.loaded), u.cc.Vg(a.total), (a.loaded / a.total * 100).toFixed(0));
                  e.Da(!0, e.model.B.j.WX, c);
                }
              } catch (d) {
                console.error(d.stack), this.Sb(d);
              }
            }
            Sb() {
              e.Da(!1);
              null != this.Mb && (this.Mb(null), this.dispose());
            }
            cO(b, a) {
              this.timer = new u.Et(100, 1E5);
              this.timer.N(u.vf.Gl, this.Bl);
              this.timer.N(u.vf.Hl, this.Lj);
              this.timer.start();
              var c = new z.jk();
              c.dataType = z.KA.kB;
              c.N(v.ga.Qc, () => this.ur());
              c.N(v.ga.GA, () => this.fFa());
              c.N(v.ga.te, d => this.nq(d));
              c.N(v.ga.xa, d => this.Sb(d));
              c.Vh(a);
              c.load(b);
              this.oa = c;
            }
            Ws() {
              0 < this.tk ? this.wg() : null != this.timer && this.timer.wl && e.Da(!0, e.model.B.j.WX, e.P.bind(e.model.B.j.yt, u.cc.format(this.timer.yw / 10, new e.model.ac.W.af(), !1, !1, 1)));
            }
            oq() {
              this.timer.wl && this.wg();
            }
            wg() {
              this.timer && this.timer.wl && (this.timer.stop(), this.timer.pb(u.vf.Gl, this.Bl), this.timer.pb(u.vf.Hl, this.Lj));
            }
            dispose() {
              this.wg();
              null != this.oa && (this.oa.Td(), this.oa.dispose(), this.oa = null);
              this.Mb = null;
            }
          }
          h.Yoa = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (b) {
            b.fNa = "visible";
            b.ZMa = "caption";
            b.TYPE = "type";
            b.JX = "hierarchy";
            b.Of = "level";
            b.dNa = "parent";
            b.XMa = "aggregations";
            b.aNa = "format";
            b.bNa = "interval";
            b.YMa = "calendar_interval";
            b.$Ma = "fixed_interval";
            b.eNa = "time_zone";
            b.cNa = "min_doc_count";
            b.oNa = "isMeasure";
            b.gNa = "filters";
          })(h.Zoa || (h.Zoa = {}));
          class f {
            constructor() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              this.kx = this.mapping = null;
              this.uu = {};
              this.RU = null;
              "string" == typeof b ? this.kx = b : (this.mapping = b, this.MW());
              this.uu.filters = !0;
            }
            MW() {
              for (var b in this.mapping) if ("aggregations" === b) this.Bp = this.mapping[b], delete this.mapping[b];else if (!e.v(this.mapping[b]) && "object" !== typeof this.mapping[b]) {
                let a = k.i.input.sa.T5(this.mapping[b]);
                this.mapping[b] = {
                  uniqueName: b,
                  caption: b,
                  type: a
                };
              }
            }
            La(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              b = u.Nc.resolve(b, this.mapping);
              var d = null;
              e.v(b) || (d = b[a]);
              e.v(d) && (d = c);
              e.v(d) && (d = this.uu[a]);
              return d;
            }
            MH(b, a) {
              b = u.Nc.resolve(b, this.mapping);
              return e.v(b) || e.v(b[a]) ? !1 : !0;
            }
            li(b, a, c) {
              var d = u.Nc.resolve(b, this.mapping);
              e.v(d) && (this.mapping[b] = {}, d = this.mapping[b]);
              e.v(d) || (d[a] = c);
            }
            Sa() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              if (b && this.Po) return this.kx;
              b && this.Bp && (this.mapping.aggregations = this.Bp);
              return this.mapping;
            }
            bEa(b) {
              switch (b) {
                case k.i.qa.API:
                  b = new k.external.pc.yO();
                  break;
                case k.i.qa.hg:
                  b = new k.external.Se.UO();
                  break;
                case k.i.qa.Md:
                case k.i.qa.Cc:
                  new k.external.Fb.MP();
                default:
                  b = new f();
              }
              return b;
            }
            clone() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              b = this.bEa(b);
              b.mapping = u.Nc.vj(this.mapping);
              b.kx = this.kx;
              b.Bp = this.Bp;
              return b;
            }
            isEqual(b) {
              return JSON.stringify(this.Sa(!0)) === JSON.stringify(b.Sa(!0)) && b.Po || JSON.stringify(this.mapping) === JSON.stringify(b.Sa());
            }
            get kb() {
              return !this.Xea && e.v(this.Bp);
            }
            get Xea() {
              return !e.v(this.mapping) && 0 < Object.keys(this.mapping).length;
            }
            get Po() {
              return null !== this.kx && 0 < this.kx.length;
            }
            ODa(b, a) {
              this.ff = a;
              this.Po && this.kb ? (this.RU = new h.Yoa(), this.RU.NDa(this.kx, b, c => this.oGa(c))) : (this.ff(), this.ff = null);
            }
            oGa(b) {
              null !== b && (this.mapping = b, this.MW());
              this.ff();
              this.ff = null;
              this.RU.dispose();
              this.RU = null;
            }
            static rU(b) {
              if (e.v(b)) return !1;
              if (!e.v(b.aggregations)) return !0;
              for (var a in b) if (!e.v(b[a]) && (Array.isArray(b[a]) && f.rU(b[a]) || b[a].hasOwnProperty("type") || b[a].hasOwnProperty("caption") || b[a].hasOwnProperty("hierarchy") || b[a].hasOwnProperty("level") || b[a].hasOwnProperty("parent") || b[a].hasOwnProperty("dimensionUniqueName") || b[a].hasOwnProperty("dimensionCaption") || b[a].hasOwnProperty("folder") || b[a].hasOwnProperty("aggregations") || b[a].hasOwnProperty("visible"))) return !0;
              return !1;
            }
            f3(b, a) {
              const c = u.Nc.resolve(b, this.mapping);
              e.v(a) && (a = {});
              if (Array.isArray(c)) {
                let d = [],
                  g = [],
                  l = [],
                  m;
                for (let n = 0; n < c.length; n++) m = this.R$(c[n], a), e.ia(m.uniqueName) && (m.uniqueName = b), e.ia(m.caption) && (m.caption = b), -1 !== g.indexOf(m.uniqueName) && (m.uniqueName = `${b}.${n}`), -1 !== l.indexOf(m.caption) && (m.caption = `${m.caption} ${n}`), g.push(m.uniqueName), l.push(m.caption), d.push(m);
                return d;
              }
              return this.R$(c, a);
            }
            R$(b, a) {
              a = u.Nc.vj(a);
              for (var c in b) a[c] = b[c], "aggregations" === c && (a.availableAggregations = b[c]);
              return a;
            }
          }
          h.pm = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.uc = null;
              this.withCredentials = !1;
              this.ko = k.i.qa.EMPTY;
              this.nDa = !1;
            }
            get Ba() {
              return this.ko;
            }
            set Ba(b) {
              this.ko = b.toLowerCase();
            }
            get Ic() {
              return k.i.qa.Ic(this.ko);
            }
            set Ic(b) {}
            get VM() {
              return !1;
            }
            set VM(b) {}
            isEqual(b) {
              return b && this.Ba == b.Ba && this.withCredentials == b.withCredentials;
            }
            get kb() {
              return this.ko == k.i.qa.EMPTY;
            }
            set kb(b) {}
            get RM() {
              return this.ko === k.i.qa.Xh && "this" === this.filename;
            }
            get Ru() {
              return !1;
            }
            set Ru(b) {}
            get RH() {
              return !0;
            }
            get jU() {
              return !0;
            }
            get iU() {
              return !0;
            }
            static zb(b) {
              if (void 0 == b || e.model.Ha.wc.Wj() == e.model.Ha.pp.qm) return new h.PA();
              e.v(b.connectionInfo) || (b = b.connectionInfo);
              b instanceof f || b instanceof k.local.csv.GO || b instanceof k.local.csv.uF || b instanceof k.local.json.nP || b instanceof k.external.Fb.sp || b instanceof k.external.Se.o7 || b instanceof k.external.pc.g6 || (b = f.jm(b));
              e.v(b.dataSourceType) || (b.dataSourceType = b.dataSourceType.toLowerCase());
              b.dataSourceType && -1 < b.dataSourceType.indexOf("pentaho") && (b.dataSourceType = k.i.qa.Md);
              "msolap" == b.dataSourceType && (b.dataSourceType = k.i.qa.Cc);
              !k.i.qa.valid(b.dataSourceType) && b.proxyUrl && (b.dataSourceType = k.i.qa.Cc);
              if ("es" == b.dataSourceType || "elastic" == b.dataSourceType) b.dataSourceType = k.i.qa.hg;
              !k.i.qa.valid(b.dataSourceType) && (b.host || b.node) && b.index && (b.dataSourceType = k.i.qa.hg);
              !k.i.qa.valid(b.dataSourceType) && (b.url || b.discover && b.select) && (b.dataSourceType = k.i.qa.API);
              if (!e.v(b.filename) && e.v(b.dataSourceType)) {
                var a = b.filename.split("?")[0].toLowerCase();
                b.dataSourceType = ".csv" == a.substr(-4) ? k.i.qa.Xh : ".ocsv" == a.substr(-5) ? k.i.qa.Gq : ".json" == a.substr(-5) || ".js" == a.substr(-3) ? k.i.qa.JSON : k.i.qa.Xh;
              }
              !e.v(b.data) && Array.isArray(b.data) && (b.dataSourceType = k.i.qa.JSON, b.data = b.data.slice());
              if (b.dataSourceType == k.i.qa.hg && e.model.Ha.wc.Wj() != e.model.Ha.pp.hg && e.model.Ha.wc.Wj() != e.model.Ha.pp.TO) return e.model.Ha.wc.Wj() != e.model.Ha.pp.qm && e.Wa(e.model.Ha.ra.J(e.model.Ha.ra.lya), e.model.Ha.ra.J(e.model.Ha.ra.PD)), new h.PA();
              if (b.dataSourceType == k.i.qa.Cc && e.model.Ha.wc.Wj() != e.model.Ha.pp.Xja && e.model.Ha.wc.Wj() != e.model.Ha.pp.TO) return e.model.Ha.wc.Wj() != e.model.Ha.pp.qm && e.Wa(e.model.Ha.ra.J(e.model.Ha.ra.BEa), e.model.Ha.ra.J(e.model.Ha.ra.PD)), new h.PA();
              if (b.dataSourceType == k.i.qa.Md && e.model.Ha.wc.Wj() != e.model.Ha.pp.Md && e.model.Ha.wc.Wj() != e.model.Ha.pp.TO) return e.model.Ha.wc.Wj() != e.model.Ha.pp.qm && e.Wa(e.model.Ha.ra.J(e.model.Ha.ra.tEa), e.model.Ha.ra.J(e.model.Ha.ra.PD)), new h.PA();
              if ((b.dataSourceType == k.i.qa.Xh || b.dataSourceType == k.i.qa.Gq || b.dataSourceType == k.i.qa.JSON) && e.model.Ha.wc.Wj() != e.model.Ha.pp.jla && e.model.Ha.wc.Wj() != e.model.Ha.pp.TO) return e.model.Ha.wc.Wj() != e.model.Ha.pp.qm && e.Wa(e.model.Ha.ra.J(e.model.Ha.ra.FEa), e.model.Ha.ra.J(e.model.Ha.ra.PD)), new h.PA();
              switch (b.dataSourceType) {
                case k.i.qa.Gq:
                  return k.local.csv.uF.zb(b);
                case k.i.qa.Xh:
                  return k.local.csv.GO.zb(b);
                case k.i.qa.JSON:
                  return k.local.json.nP.zb(b);
                case k.i.qa.Cc:
                case k.i.qa.Md:
                  return k.external.Fb.sp.zb(b);
                case k.i.qa.hg:
                  return k.external.Se.o7.zb(b);
                case k.i.qa.API:
                  return k.external.pc.g6.zb(b);
                default:
                  return new h.PA();
              }
            }
            static jm(b) {
              var a = {};
              e.ia(b.type) || (a.dataSourceType = b.type);
              e.ia(b.dataSourceType) || (a.dataSourceType = b.dataSourceType);
              e.ia(b.filename) || (a.filename = b.filename);
              e.ia(b.requestHeader) || (a.requestHeaders = b.requestHeader);
              e.ia(b.requestHeaders) || (a.requestHeaders = b.requestHeaders);
              e.ia(b.browseForFile) || (a.browseForFile = b.browseForFile);
              e.ia(b.requestPermission) || (a.requestPermission = b.requestPermission);
              e.ia(b.thousandSeparator) || (a.thousandsSeparator = b.thousandSeparator);
              e.ia(b.thousandsSeparator) || (a.thousandsSeparator = b.thousandsSeparator);
              e.ia(b.fieldSeparator) || (a.fieldSeparator = b.fieldSeparator);
              e.ia(b.recordsetDelimiter) || (a.recordsetDelimiter = b.recordsetDelimiter);
              e.ia(b.ignoreQuotedLineBreaks) || (a.ignoreQuotedLineBreaks = b.ignoreQuotedLineBreaks);
              e.ia(b.embedded) || (a.embedded = b.embedded);
              e.ia(b.embeddedDataOffset) || (a.embeddedDataOffset = b.embeddedDataOffset);
              e.ia(b.embeddedDataToLoad) || (a.embeddedDataToLoad = b.embeddedDataToLoad);
              e.ia(b.isOCSV2Data) || (a.isOCSV2Data = b.isOCSV2Data);
              e.v(b.data) || (a.data = b.data);
              e.ia(b.checkUpdates) || (a.checkUpdates = b.checkUpdates);
              e.ia(b.proxyUrl) || (a.proxyUrl = b.proxyUrl);
              e.ia(b.dataSourceInfo) || (a.dataSourceInfo = b.dataSourceInfo);
              e.ia(b.catalog) || (a.catalog = b.catalog);
              e.ia(b.cube) || (a.cube = b.cube);
              e.ia(b.subquery) || (a.subquery = b.subquery);
              e.ia(b.binary) || (a.binary = b.binary);
              e.ia(b.withCredentials) || (a.withCredentials = b.withCredentials);
              e.ia(b.roles) || (a.roles = b.roles);
              e.ia(b.localeIdentifier) || (a.localeIdentifier = b.localeIdentifier);
              e.ia(b.effectiveUserName) || (a.effectiveUserName = b.effectiveUserName);
              e.ia(b.customData) || (a.customData = b.customData);
              e.ia(b.url) || (a.url = b.url);
              e.ia(b.handshakingUrl) || (a.handshakingUrl = b.handshakingUrl);
              e.ia(b.dimensionsUrl) || (a.dimensionsUrl = b.dimensionsUrl);
              e.ia(b.hierarchiesUrl) || (a.hierarchiesUrl = b.hierarchiesUrl);
              e.ia(b.levelsUrl) || (a.levelsUrl = b.levelsUrl);
              e.ia(b.measuresUrl) || (a.measuresUrl = b.measuresUrl);
              e.ia(b.membersUrl) || (a.membersUrl = b.membersUrl);
              e.ia(b.dataUrl) || (a.dataUrl = b.dataUrl);
              e.ia(b.drillThroughUrl) || (a.drillThroughUrl = b.drillThroughUrl);
              e.ia(b.host) || (a.host = b.host);
              e.ia(b.node) || (a.node = b.node);
              e.ia(b.connection) || (a.connection = b.connection);
              e.ia(b.index) || (a.index = b.index);
              e.ia(b.mapping) || (a.mapping = b.mapping);
              e.ia(b.singleEndpoint) || (a.singleEndpoint = b.singleEndpoint);
              e.ia(b.concurrentRequests) || (a.concurrentRequests = b.concurrentRequests);
              e.ia(b.useSockets) || (a.useSockets = b.useSockets);
              e.ia(b.useStreamLoader) || (a.useStreamLoader = b.useStreamLoader);
              e.ia(b.useGranularityNamesForDateFilters) || (a.useGranularityNamesForDateFilters = b.useGranularityNamesForDateFilters);
              e.ia(b.dataRootPath) || (a.dataRootPath = b.dataRootPath);
              e.ia(b.hash) || (a.hash = b.hash);
              e.ia(b.username) || (a.username = b.username);
              e.ia(b.password) || (a.password = b.password);
              e.ia(b.dataSource) || (b = b.dataSource, e.ia(b.type) || (a.dataSourceType = b.type), e.ia(b.dataSourceType) || (a.dataSourceType = b.dataSourceType), e.ia(b.filename) || (a.filename = b.filename), e.ia(b.requestHeader) || (a.requestHeaders = b.requestHeader), e.ia(b.requestHeaders) || (a.requestHeaders = b.requestHeaders), e.ia(b.browseForFile) || (a.browseForFile = b.browseForFile), e.ia(b.requestPermission) || (a.requestPermission = b.requestPermission), e.ia(b.fieldSeparator) || (a.fieldSeparator = b.fieldSeparator), e.ia(b.thousandSeparator) || (a.thousandsSeparator = b.thousandSeparator), e.ia(b.thousandsSeparator) || (a.thousandsSeparator = b.thousandsSeparator), e.ia(b.recordsetDelimiter) || (a.recordsetDelimiter = b.recordsetDelimiter), e.ia(b.ignoreQuotedLineBreaks) || (a.ignoreQuotedLineBreaks = b.ignoreQuotedLineBreaks), e.ia(b.embedded) || (a.embedded = b.embedded), e.ia(b.embeddedDataOffset) || (a.embeddedDataOffset = b.embeddedDataOffset), e.ia(b.embeddedDataToLoad) || (a.embeddedDataToLoad = b.embeddedDataToLoad), e.ia(b.isOCSV2Data) || (a.isOCSV2Data = b.isOCSV2Data), e.v(b.data) || (a.data = b.data), e.ia(b.proxyUrl) || (a.proxyUrl = b.proxyUrl), e.ia(b.dataSourceInfo) || (a.dataSourceInfo = b.dataSourceInfo), e.ia(b.catalog) || (a.catalog = b.catalog), e.ia(b.cube) || (a.cube = b.cube), e.ia(b.subquery) || (a.subquery = b.subquery), e.ia(b.binary) || (a.binary = b.binary), e.ia(b.withCredentials) || (a.withCredentials = b.withCredentials), e.ia(b.roles) || (a.roles = b.roles), e.ia(b.localeIdentifier) || (a.localeIdentifier = b.localeIdentifier), e.ia(b.effectiveUserName) || (a.effectiveUserName = b.effectiveUserName), e.ia(b.customData) || (a.customData = b.customData), e.ia(b.url) || (a.url = b.url), e.ia(b.handshakingUrl) || (a.handshakingUrl = b.handshakingUrl), e.ia(b.dimensionsUrl) || (a.dimensionsUrl = b.dimensionsUrl), e.ia(b.hierarchiesUrl) || (a.hierarchiesUrl = b.hierarchiesUrl), e.ia(b.levelsUrl) || (a.levelsUrl = b.levelsUrl), e.ia(b.measuresUrl) || (a.measuresUrl = b.measuresUrl), e.ia(b.membersUrl) || (a.membersUrl = b.membersUrl), e.ia(b.dataUrl) || (a.dataUrl = b.dataUrl), e.ia(b.drillThroughUrl) || (a.drillThroughUrl = b.drillThroughUrl), e.ia(b.host) || (a.host = b.host), e.ia(b.node) || (a.node = b.node), e.ia(b.connection) || (a.connection = b.connection), e.ia(b.index) || (a.index = b.index), e.ia(b.mapping) || (a.mapping = b.mapping), e.ia(b.singleEndpoint) || (a.singleEndpoint = b.singleEndpoint), e.ia(b.concurrentRequests) || (a.concurrentRequests = b.concurrentRequests), e.ia(b.useStreamLoader) || (a.useStreamLoader = b.useStreamLoader), e.ia(b.useGranularityNamesForDateFilters) || (a.useGranularityNamesForDateFilters = b.useGranularityNamesForDateFilters), e.ia(b.dataRootPath) || (a.dataRootPath = b.dataRootPath), b = b.credentials, null != b && (e.ia(b.hash) || (a.hash = b.hash), e.ia(b.username) || (a.username = b.username), e.ia(b.password) || (a.password = b.password)));
              return a;
            }
            static Ek(b) {
              var a = b.find("dataSource"),
                c = a.attr("type");
              void 0 !== c && (c = c.toLowerCase());
              "msolap" == c && (c = k.i.qa.Cc);
              c && -1 < c.indexOf("pentaho") && (c = k.i.qa.Md);
              var d = a.find("filename");
              if (!k.i.qa.valid(c)) {
                var g = a.find("proxyUrl");
                0 < g.length && 0 < g.text().length && (c = k.i.qa.Cc);
                0 < d.length && 0 < d.text().length && (c = k.i.qa.Xh);
              }
              0 < d.length && 0 < d.text().length && ".ocsv" == d.text().toLocaleLowerCase().substr(-5) && (c = k.i.qa.Gq);
              0 < d.length && 0 < d.text().length && ".json" == d.text().toLocaleLowerCase().substr(-5) && (c = k.i.qa.JSON);
              0 < d.length && 0 < d.text().length && ".csv" == d.text().toLocaleLowerCase().substr(-4) && (c = k.i.qa.Xh);
              switch (c) {
                case k.i.qa.Gq:
                  return k.local.csv.uF.Ek(a[0]);
                case k.i.qa.Xh:
                  return k.local.csv.GO.Ek(b);
                case k.i.qa.JSON:
                  return k.local.json.nP.Ek(a[0]);
                case k.i.qa.Cc:
                case k.i.qa.Md:
                  return k.external.Fb.sp.Ek(b);
                default:
                  return k.local.csv.GO.Ek(b);
              }
            }
            gp() {
              var b = z.ba.create("<dataSource/>");
              this.Ba != k.i.qa.EMPTY && b.attr("type", this.Ba);
              return b;
            }
          }
          h.ut = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor(f) {
            this.vb = [];
            this.Hc = [];
            this.mh = [];
            this.cb = [];
            this.Bd = [];
            this.Od = [];
            this.je = [];
            this.wa = [];
            this.Vl = [];
            this.oh = [];
            this.xg = [];
            this.Bp = [];
            this.hu = [];
            this.Xw = [];
            this.Kn = [];
            this.jpa = 0;
            this.Lga = [];
            this.wk = [];
            this.Uh = [];
            this.sizes = [];
            this.filters = [];
            this.Ix = [];
            this.Au = [];
            this.values = [];
            this.RQ = [];
            this.va = f;
          }
          rC() {
            this.Kn = [];
            this.cb = [];
            this.vb = [];
            this.Hc = [];
            this.Vl = [];
            this.wa = [];
            this.values = [];
            this.mh = [];
            this.filters = [];
          }
          z_() {
            this.je = [];
            this.oh = [];
            this.xg = [];
            this.Bp = [];
            this.hu = [];
            this.Xw = [];
          }
          lu() {
            this.rC();
            this.z_();
            this.Bd = [];
            this.Od = [];
            this.sizes = [];
            this.mh = [];
          }
          clearData() {
            this.rC();
            this.Bd = [];
            this.Od = [];
            this.sizes = [];
            this.mh = [];
          }
          get slice() {
            return null != this.Qb ? this.Qb : this.va.pa;
          }
          set slice(f) {
            this.Qb = f;
          }
          yza(f) {
            return isNaN(f[0]);
          }
          Aza(f) {
            return !isNaN(f[0]);
          }
          mza(f) {
            return void 0 === f[0] || "string" === typeof f[0] || void 0 === f[1] || "string" === typeof f[1] ? (null == f[0] || "number" === typeof f[0] && isNaN(f[0]) ? "" : f[0]) + (null == f[1] || "number" === typeof f[1] && isNaN(f[1]) ? "" : f[1]) : f[0] + f[1];
          }
          Eza(f) {
            return f[0] - f[1];
          }
          xza(f) {
            return f[0] * f[1];
          }
          oza(f) {
            return 0 == f[1] || isNaN(f[1]) ? k.i.RO.QO : f[0] / f[1];
          }
          Cza(f) {
            return Math.pow(f[0], f[1]);
          }
          tza(f) {
            return f[0] < f[1];
          }
          qza(f) {
            return f[0] > f[1];
          }
          pza(f) {
            return f[0] == f[1];
          }
          zza(f) {
            return f[0] != f[1];
          }
          uza(f) {
            return f[0] <= f[1];
          }
          rza(f) {
            return f[0] >= f[1];
          }
          Bza(f) {
            return f[0] || f[1];
          }
          nza(f) {
            return f[0] && f[1];
          }
          sza(f) {
            return f[0] ? f[1] : f[2];
          }
          lza(f) {
            return Math.abs(f[0]);
          }
          Dza(f) {
            const b = f[1];
            if (isNaN(b) || 0 === b) return Math.round(f[0]);
            f = f[0];
            f = Math.round(Number(f + "e" + b));
            return Number(f + "e" + -b);
          }
          wza(f) {
            return Math.min(f[0], f[1]);
          }
          vza(f) {
            return Math.max(f[0], f[1]);
          }
          ts(f, b) {
            for (var a = 1, c = 0, d, g, l = this.wk.length - 1; 0 <= l; l--) g = this.sizes[this.Uh.length + l], 0 < g && (d = void 0 === b[l] ? 0 : b[l], c += d * a, a *= g);
            for (b = this.Uh.length - 1; 0 <= b; b--) g = this.sizes[b], 0 < g && (d = f && void 0 !== f[b] ? f[b] : 0, Math.abs(d * a) > 9007199254740991 - c && (a = -a % 1E6, 0 == a && (a = -g)), c += d * a, a *= g);
            return c;
          }
          H1(f, b) {
            for (var a = 0, c = !0, d = 0; d < f.length; d++) {
              var g = this.Hc[b][f[d]];
              isNaN(g) || (a += g, c = !1);
            }
            return c ? NaN : a;
          }
          UAa(f, b) {
            for (var a = Number.MAX_VALUE, c = !0, d = 0; d < f.length; d++) {
              var g = this.Hc[b][f[d]];
              isNaN(g) || (g < a && (a = g), c = !1);
            }
            return c ? NaN : a;
          }
          NAa(f, b) {
            for (var a = Number.NEGATIVE_INFINITY, c = !0, d = 0; d < f.length; d++) {
              var g = this.Hc[b][f[d]];
              isNaN(g) || (g > a && (a = g), c = !1);
            }
            return c ? NaN : a;
          }
          hBa(f, b) {
            for (var a = 1, c = !0, d = 0; d < f.length; d++) {
              var g = this.Hc[b][f[d]];
              isNaN(g) || (a *= g, c = !1);
            }
            return c ? NaN : a;
          }
          uda(f, b) {
            let a = 0,
              c = 0;
            for (let d = 0; d < f.length; d++) {
              const g = this.Hc[b][f[d]];
              isNaN(g) || (a += g, c++);
            }
            return 0 == c ? NaN : a / c;
          }
          RAa(f, b) {
            for (var a = [], c = 0; c < f.length; c++) {
              var d = this.Hc[b][f[c]];
              isNaN(d) || a.push(d);
            }
            if (0 === a.length) return NaN;
            e.Ja.sort(a, e.Ja.Qi);
            if (1 === a.length % 2) return a[Math.floor(a.length / 2)];
            f = a.length / 2;
            return (a[f] + a[f - 1]) / 2;
          }
          Hda(f, b) {
            for (var a = this.uda(f, b), c = 0, d = 0, g = 0; g < f.length; g++) {
              var l = this.Hc[b][f[g]];
              isNaN(l) || (c += Math.pow(l - a, 2), d++);
            }
            return {
              nca: c,
              count: d
            };
          }
          xBa(f, b) {
            f = this.Hda(f, b);
            return 0 == f.count ? NaN : Math.sqrt(f.nca / f.count);
          }
          yBa(f, b) {
            f = this.Hda(f, b);
            return 0 == f.count ? NaN : 1 == f.count ? 0 : Math.sqrt(f.nca / (f.count - 1));
          }
          dBa(f, b) {
            null == this.RQ[b] && (this.RQ[b] = this.H1(this.cb, b));
            return Math.abs(100 * this.H1(f, b) / this.RQ[b]);
          }
          gAa(f, b) {
            for (var a = 0, c = 0; c < f.length; c++) {
              var d = this.Hc[b][f[c]];
              isNaN(d) || this.Hc[b] instanceof Uint8Array && 0 == d || a++;
            }
            return a;
          }
          sAa(f, b, a) {
            return k.Re.Ni.Bc("", !1).La(f, b, a);
          }
          eBa(f, b, a) {
            return k.Re.Ni.Bc("", !1).La(f, b, a);
          }
          ld(f, b) {
            for (var a = 0; a < f.length; a++) {
              if (void 0 === b) return;
              b = b[f[a]];
            }
            return b;
          }
          aW(f, b) {
            for (let a = 0; a < f.length; a++) void 0 === b[f[a]] && (b[f[a]] = [[[]], [], [], void 0, void 0, !1]), b = b[f[a]];
            return b;
          }
          get result() {
            return [this.Bd, this.Od];
          }
          set result(f) {}
          Th(f, b) {
            if (0 === f.length) return !0;
            var a = -1;
            void 0 !== b && (a = "number" === typeof b ? -1 === b ? -1 : this.Au[b] : this.di(b));
            f = this.ld(f, this.Bd);
            return void 0 === f || void 0 === f[0] || void 0 === f[0][3] ? !1 : -1 === a || void 0 === f[0][3][a] ? f[0][3][this.xg.length] : f[0][3][a];
          }
          di(f, b, a) {
            "string" !== typeof f && (b = f.aa, f = f.A);
            if (e.model.C.F.tc && !a || void 0 === b || b === k.i.da.NONE) for (a = 0; a < this.xg.length; a++) {
              if (this.xg[a] === f) return a;
            } else for (a = 0; a < this.xg.length; a++) if (this.xg[a] === f && (void 0 === this.Bp[a] || this.Bp[a] === b)) return a;
            return -1;
          }
          Xj(f, b) {
            if (0 === f.length) return !0;
            var a = -1;
            void 0 !== b && (a = "number" === typeof b ? this.Au[b] : this.di(b));
            f = this.ld(f, this.Od);
            return void 0 === f || void 0 === f[0] || void 0 === f[0][3] ? !1 : -1 === a || void 0 === f[0][3][a] ? f[0][3][this.xg.length] : f[0][3][a];
          }
          collapse(f, b, a) {
            0 === this.Bd.length && (this.Bd = [[this.cb, [], [], void 0, void 0]]);
            0 === this.Od.length && (this.Od = [[this.cb, [], [], void 0, void 0]]);
            1 === this.Au.length && (a = void 0);
            b === k.i.ha.Ia && this.rva(f, a);
            b === k.i.ha.Ra && this.pva(f, a);
          }
          rva(f, b) {
            this.e$(this.ld(f, this.Bd), b);
          }
          pva(f, b) {
            this.e$(this.ld(f, this.Od), b);
          }
          e$(f, b) {
            void 0 !== f && (void 0 === f[0][3] && (f[0][3] = []), void 0 !== b ? f[0][3][this.di(b)] = !1 : f[0][3][this.xg.length] = !1);
          }
          expand(f, b, a) {
            0 !== this.cb.length && (1 === this.Au.length && (a = void 0), 0 === this.Bd.length && (this.Bd = [[this.cb, [], [], void 0, void 0]], this.I0([], a)), 0 === this.Od.length && (this.Od = [[this.cb, [], [], void 0, void 0]], this.F0([], a)), b === k.i.ha.Ia && this.I0(f, a), b === k.i.ha.Ra && this.F0(f, a));
          }
          I0(f, b) {
            var a = this.ld(f, this.Bd);
            void 0 === a && this.dC() && (a = this.aW(f, this.Bd));
            if (void 0 !== a) {
              var c = this.Uh[f.length];
              f.length < this.Uh.length && this.xB(a, c, b);
            }
          }
          F0(f, b) {
            var a = this.ld(f, this.Od);
            void 0 === a && this.uG() && (a = this.aW(f, this.Od));
            if (void 0 !== a) {
              var c = this.wk[f.length];
              f.length < this.wk.length && this.xB(a, c, b);
            }
          }
          xB(f, b, a) {
            if (void 0 !== f) {
              var c = f[0][0];
              if (0 < c.length && !isNaN(b)) for (var d = 0; d < c.length; d++) {
                var g = this.wa[b][1] < this.vb.length ? this.vb[this.wa[b][1]][c[d]] : 0;
                0 !== g && void 0 !== g && (void 0 === f[g] ? (f[g] = [[[c[d]], [], [], void 0, void 0, !1]], f[0][1].push(g)) : f[0][5] || f[g][0][0].push(c[d]));
              }
              void 0 === f[0][3] && (f[0][3] = []);
              void 0 === a ? f[0][3][this.xg.length] = !0 : f[0][3][this.di(a)] = !0;
              f[0][5] = !0;
            }
          }
          Pp(f, b, a, c) {
            1 === this.Au.length && (c = void 0);
            a === k.i.ha.Ia && this.dya(f, c);
            a === k.i.ha.Ra && this.cya(f, c);
          }
          dya(f, b) {
            var a = this.ld(f, this.Bd);
            f = f.slice(0, -1);
            this.QY(this.ld(f, this.Bd), a, b);
          }
          cya(f, b) {
            var a = this.ld(f, this.Od);
            f = f.slice(0, -1);
            this.QY(this.ld(f, this.Od), a, b);
          }
          Ae(f, b, a, c) {
            0 !== b.children.length && (1 === this.Au.length && (c = void 0), 0 === this.Bd.length && (this.Bd = [[this.cb, [], [], void 0, void 0]], this.I0([], c)), 0 === this.Od.length && (this.Od = [[this.cb, [], [], void 0, void 0]], this.F0([], c)), a === k.i.ha.Ia && this.Zxa(f, b, c), a === k.i.ha.Ra && this.Yxa(f, b, c));
          }
          Zxa(f, b, a) {
            var c = this.ld(f, this.Bd);
            void 0 === c && this.dC() && (c = this.aW(f, this.Bd));
            if (void 0 !== c) {
              f = f.slice(0, -1);
              var d = this.Uh[f.length];
              this.HQ(this.ld(f, this.Bd), c, d, this.wa[d][b.level.yb + 1], a);
            }
          }
          HQ(f, b, a, c, d) {
            if (void 0 !== b && void 0 !== b[0]) {
              var g = b[0][0];
              if (0 < g.length && !isNaN(c)) {
                void 0 === f.indiciesMap && (f.indiciesMap = {});
                for (let m = 0; m < g.length; m++) {
                  var l = this.vb[c][g[m]];
                  0 !== l && void 0 !== l && (void 0 === f[l] ? (f[l] = [[[g[m]], [], [], void 0, void 0]], b[0][2].push(l), this.Vl[a][l] = c, f.indiciesMap[l] = {
                    [g[m]]: 1
                  }) : 1 !== f.indiciesMap[l][g[m]] && (f[l][0][0].push(g[m]), f.indiciesMap[l][g[m]] = 1));
                }
              }
              void 0 === b[0][4] && (b[0][4] = []);
              void 0 === d ? b[0][4][this.xg.length] = !0 : b[0][4][this.di(d)] = !0;
            }
          }
          Yxa(f, b, a) {
            var c = this.ld(f, this.Od);
            void 0 === c && this.uG() && (c = this.aW(f, this.Od));
            f = f.slice(0, -1);
            var d = this.wk[f.length];
            this.HQ(this.ld(f, this.Od), c, d, this.wa[d][b.level.yb + 1], a);
          }
          QY(f, b, a) {
            const c = b[0][2];
            if (void 0 !== c && 0 < c.length) for (var d = 0; d < c.length; d++) {
              let g = c[d];
              void 0 !== f[g][0][4] && this.QY(f, f[g], a);
              f[g] = void 0;
            }
            b[0][2] = [];
            b[0][4][this.xg.length] = !1;
            void 0 !== a && (b[0][4][this.di(a)] = !1);
          }
          Bh(f, b, a) {
            b = this.xg.length;
            void 0 !== a && (b = "number" === typeof a ? -1 === a ? -1 : this.Au[a] : this.di(a));
            -1 === b && (b = this.xg.length);
            f = this.ld(f, this.Bd);
            return void 0 !== f && void 0 !== f[0] && void 0 !== f[0][4] && (f[0][4][b] || f[0][4][this.xg.length]);
          }
          Bj(f, b, a) {
            b = this.xg.length;
            void 0 !== a && (b = "number" === typeof a ? -1 === a ? -1 : this.Au[a] : this.di(a));
            -1 === b && (b = this.xg.length);
            f = this.ld(f, this.Od);
            return void 0 !== f && void 0 !== f[0] && void 0 !== f[0][4] && (f[0][4][b] || f[0][4][this.xg.length]);
          }
          PM(f, b, a) {
            var c = this.je.indexOf(b.hierarchy.A),
              d = b.dc ? f.slice(0, -1) : f.slice(0);
            const g = a === k.i.ha.Ia ? this.ld(d, this.Bd) : this.ld(d, this.Od);
            1 < f.length ? (d = f.slice(0, -1), f = (a === k.i.ha.Ia ? this.ld(d, this.Bd) : this.ld(d, this.Od))[0][0]) : f = this.cb;
            c = this.wa[c][b.level.yb + 1];
            a = {};
            for (d = 0; d < g[0][0].length; d++) a[g[0][0][d]] = 1;
            d = [];
            for (let l = 0; l < b.children.length; l++) {
              const m = this.Rp(f, [b.children[l]], [c]);
              for (let n = 0; n < m.length; n++) 1 !== a[m[n]] && (d.push(m[n]), a[m[n]] = 1);
            }
            for (b = 0; b < d.length; b++) g[0][0].push(d[b]);
          }
          Rp(f, b, a) {
            for (let l = 0; l < b.length; l++) {
              const m = b[l];
              var c = a[l];
              if (e.model.C.F.KT) {
                var d = this.slice.yc().getItem(this.je[c]),
                  g = d.za(m);
                e.v(d.vz) || e.v(this.wa) || e.v(a[l]) || e.v(this.wa[a[l]]) || (c = this.wa[a[l]][g.level.yb]);
              }
              c = e.v(this.Vl[c]) || e.v(this.Vl[c][m]) ? c : this.Vl[c][m];
              d = [];
              for (g = 0; g < f.length; g++) e.v(this.vb[c]) || this.vb[c][f[g]] !== m || d.push(f[g]);
              f = d;
            }
            return f;
          }
          QQ(f, b, a) {
            let c = this.La(f, b, a);
            this.va.fa.Ba !== k.i.qa.Cc && this.va.fa.Ba !== k.i.qa.Md || !e.model.C.F.Rn || (f = this.La(f, b, a), c = k.zt.R().U1(f) ? k.zt.R().C1(f) : f);
            return c;
          }
          eea(f, b, a) {
            return a.aa === k.i.da.jn ? this.rBa(f, b, a) : a.aa === k.i.da.fo ? this.sBa(f, b, a) : NaN;
          }
          rBa(f, b, a) {
            var c = a.Oa ? this.slice.gd().findIndex(r => r.A === a.A) + this.xg.length : this.di(a);
            null == this.values[c] && (this.values[c] = []);
            var d = this.ts(f, b);
            if (null == this.values[c][d]) {
              a.aa = a.Bm;
              if (f && 0 != f.length) {
                var g = this.slice.xb.ea(f.length - 1),
                  l = g.za(f[f.length - 1]);
                if (null == l || null == l.parent) return null;
                g = null == g.lc || l.level.yb > g.lc.yb ? g.ck(l.parent, !0) : g.av(g.xf);
                f = f.slice(0, -1);
                l = this.ld(f, this.Bd);
                if (l[0] && l[0][1]) for (var m = 0, n = 0; n < g.length; n++) {
                  var p = g[n];
                  if (null != l[p]) {
                    f.push(p);
                    p = this.ts(f, b);
                    if (null == this.values[c][p]) {
                      var t = this.QQ(f, b, a);
                      isNaN(t) || (m += t);
                      this.values[c][p] = m;
                    } else m = this.values[c][p];
                    f.pop();
                  }
                }
              } else this.values[c][d] = this.QQ(f, b, a);
              a.aa = k.i.da.jn;
            }
            return this.values[c][d];
          }
          sBa(f, b, a) {
            var c = a.Oa ? this.slice.gd().findIndex(r => r.A === a.A) + this.xg.length : this.di(a);
            null == this.values[c] && (this.values[c] = []);
            var d = this.ts(f, b);
            if (null == this.values[c][d]) {
              a.aa = a.Bm;
              if (0 === b.length) this.values[c][d] = this.QQ(f, b, a);else {
                var g = this.slice.Db.ea(b.length - 1),
                  l = g.za(b[b.length - 1]);
                if (null === l || null === l.parent) return null;
                g = null === g.lc || l.level.yb > g.lc.yb ? g.ck(l.parent, !0) : g.av(g.xf);
                b = b.slice(0, -1);
                l = this.ld(b, this.Od);
                if (l[0] && l[0][1]) for (var m = 0, n = 0; n < g.length; n++) {
                  var p = g[n];
                  if (void 0 !== l[p]) {
                    b.push(p);
                    p = this.ts(f, b);
                    if (null == this.values[c][p]) {
                      var t = this.QQ(f, b, a);
                      isNaN(t) || (m += t);
                      this.values[c][p] = m;
                    } else m = this.values[c][p];
                    b.pop();
                  }
                }
              }
              a.aa = k.i.da.fo;
            }
            return this.values[c][d];
          }
          Mda(f, b, a, c, d, g) {
            if (!e.v(f) && 0 != f.length) if (this.Uh.length == b.length) this.Lda(f, c, d, g);else {
              var l = [],
                m = {},
                n = this.Uh[b.length];
              for (var p = 0; p < f.length; p++) {
                const t = this.vb[n][f[p]];
                m[t] || 0 == t || (l.push(t), m[t] = !0);
              }
              for (m = 0; m < l.length; m++) n = b.slice(0), n.push(l[m]), p = this.Rp(f, n, this.Uh), this.Mda(p, n, a, c, d, g);
            }
          }
          Kda(f, b, a, c) {
            const d = [];
            this.Mda(f, b, a, c, d, {});
            return d.length;
          }
          kM(f, b) {
            if (e.v(f) || 0 == f.length) return 0;
            var a = this.va.O.Kk(b.A);
            a = this.je.indexOf(2 < a.wa.length ? a.wa.Oh(a.wa.length - 1) : a.A);
            b = this.oh.indexOf(b.A);
            for (var c = [], d = [], g, l = 0; l < f.length; l++) g = this.vb[a][f[l]], d[g] || (d[g] = !0, this.Hc[b] && isNaN(this.Hc[b][f[l]]) || this.Hc[b] instanceof Uint8Array && 0 == this.Hc[b][f[l]] || c.push(g));
            return c.length;
          }
          kw(f, b, a, c) {
            var d = this.ld(f, this.Bd),
              g = this.ld(b, this.Od),
              l = [];
            d && 0 < d.length && g && 0 < g.length && (l = f.length * g[0][0].length < b.length * d[0][0].length ? this.Rp(g[0][0], f, this.Uh) : this.Rp(d[0][0], b, this.wk));
            return this.Up(l, a, !1, c);
          }
          yua(f, b, a) {
            return this.Up([this.cb[f[0]]], b, !1, a);
          }
          HAa(f, b) {
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            let d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            for (var g = 0, l = !0, m = 0; m < f.length; m++) a = this.Up([f[m]], b, !1, a, c, d, !0), isNaN(a) || (g += a, l = !1);
            return l ? NaN : g;
          }
          Up(f, b) {
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            let d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            let g = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            let l = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !0;
            if (a) return this.HAa(f, b, c, d, g);
            if (b[2]) {
              var m = [],
                n;
              for (n in b[1]) {
                var p = b[1][n],
                  t = p;
                Array.isArray(p) && (t = this.Up(f, p, a, c, d, g, l), t = isNaN(t) && l && (b[0] === k.i.sc.wO || b[0] === k.i.sc.aQ || b[0] === k.i.sc.KP || b[0] === k.i.sc.$X || b[0] === k.i.sc.kJ) ? this.jpa : t);
                m.push(t);
              }
              if (b[0] === k.i.sc.jo || b[0] === k.i.sc.lQ || b[0] === k.i.sc.kQ) return c;
              if (b[0] === k.i.sc.nka) return this.yza(m);
              if (b[0] === k.i.sc.hpa) return this.Aza(m);
              if (b[0] === k.i.sc.wO) return this.mza(m);
              if (b[0] === k.i.sc.aQ) return this.Eza(m);
              if (b[0] === k.i.sc.KP) return this.xza(m);
              if (b[0] === k.i.sc.$X) return this.Cza(m);
              if (b[0] === k.i.sc.kJ) return this.oza(m);
              if (b[0] === k.i.sc.LESS) return this.tza(m);
              if (b[0] === k.i.sc.GREATER) return this.qza(m);
              if (b[0] === k.i.sc.EQUAL || b[0] == k.i.sc.Xla) return this.pza(m);
              if (b[0] === k.i.sc.Pf) return this.zza(m);
              if (b[0] === k.i.sc.p8) return this.uza(m);
              if (b[0] === k.i.sc.c8) return this.rza(m);
              if (b[0] === k.i.sc.e6) return this.nza(m);
              if (b[0] === k.i.sc.d9) return this.Bza(m);
              if (b[0] === k.i.sc.kP) return this.sza(m);
              if (b[0] === k.i.sc.gY) return this.Dza(m);
              if (b[0] === k.i.sc.PW) return this.lza(m);
              if (b[0] === k.i.sc.MIN) return this.wza(m);
              if (b[0] === k.i.sc.MAX) return this.vza(m);
            } else {
              a = this.m1(b[1][0], b[0]);
              if (void 0 !== this.hu[a]) return this.Up(f, this.hu[a], this.Xw[a], 0, d, g, l);
              l = b[0];
              k.i.da.az(l) && (l = k.i.da.mz(l));
              switch (l) {
                case k.i.da.tp:
                  if (null != g && (c = this.va.O.fd(b[1][0]), !e.v(c))) return f = this.La([], g, c), c = this.La(d, g, c), 100 * c / f;
                  break;
                case k.i.da.Kq:
                  if (null != d && (c = this.va.O.fd(b[1][0]), !e.v(c))) return f = this.La(d, [], c), c = this.La(d, g, c), 100 * c / f;
                  break;
                case k.i.da.Pi:
                  if (null != d && null != g && (c = this.va.O.fd(b[1][0]), !e.v(c))) return f = this.La([], [], c), b = this.La(d, [], c), l = this.La([], g, c), c = this.La(d, g, c), Math.abs(f * c / (l * b));
                  break;
                case k.i.da.jn:
                case k.i.da.fo:
                  c = this.va.O.fd(b[1][0]);
                  if (!e.v(c)) return f = c.aa, c.aa = l, d = this.eea(d, g, c), c.aa = f, d;
                  break;
                case k.i.da.mj:
                  c = this.va.O.fd(b[1][0]);
                  if (!e.v(c) && c.type == k.i.Qa.zc) return this.kM(f, c);
                  break;
                case k.i.da.Xn:
                case k.i.da.fn:
                case k.i.da.co:
                case k.i.da.hn:
                  c = this.va.O.fd(b[1][0]);
                  if (!e.v(c)) return f = c.aa, c.aa = l, d = this.sAa(d, g, c), c.aa = f, d;
                  break;
                case k.i.da.Iq:
                case k.i.da.Jq:
                  if (c = this.va.O.fd(b[1][0]), !e.v(c)) return f = c.aa, c.aa = l, d = this.eBa(d, g, c), c.aa = f, d;
              }
              return this.Rg(f, a, l);
            }
          }
          m1(f) {
            var b = this.oh.indexOf(f);
            -1 === b && -1 != f.indexOf("[Measures]") && (f = f.slice(12, -1), b = this.oh.indexOf(f));
            return b;
          }
          filter() {}
          select() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            this.pI();
            this.filter();
            var b;
            this.Lga = [];
            this.Uh = [];
            this.wk = [];
            this.sizes = [];
            this.Vl = [];
            this.Au = [];
            this.lI = this.slice.axes.getItem(k.i.ha.At);
            this.hc = this.slice.axes.getItem(k.i.ha.Ia);
            this.Rb = this.slice.axes.getItem(k.i.ha.Ra);
            for (b = 0; b < this.hc.Pa.length; b++) {
              var a = this.hc.Pa.ea(b);
              if (!a.Ue) {
                var c = this.je.indexOf(a.A);
                this.Uh.push(c);
                this.sizes.push(a.Vm);
                this.Vl[c] = [];
              }
            }
            this.Qk = this.Uh.length;
            for (b = 0; b < this.Rb.Pa.length; b++) a = this.Rb.Pa.ea(b), a.Ue || (c = this.je.indexOf(a.A), this.wk.push(c), this.sizes.push(a.Vm), this.Vl[c] = []);
            this.vk = this.wk.length;
            if (f) for (b = 0; b < this.lI.Pa.length; b++) a = this.lI.Pa.ea(b), c = this.je.indexOf(a.A), this.Lga.push(c);else this.cb = this.mh;
            f = this.slice.gd();
            for (b = 0; b < f.length; b++) c = this.di(f[b]), this.Au.push(c);
          }
          PY(f, b, a, c) {
            try {
              if (0 === b.children.length || 1 === b.children.length && (b.hierarchy.za(b.children[0]).caption === e.model.B.j.Fl || b.hierarchy.za(b.children[0]).caption === e.model.B.j.Wn)) return;
              this.PM(f, b, c);
              this.Ae(f, b, c, void 0);
            } catch (p) {}
            for (var d = this.ld(f, this.Bd), g = 0; g < b.children.length; g++) {
              var l = b.hierarchy.za(b.children[g]);
              try {
                if (l.Sh) {
                  f.length < this.Uh.length && this.xB(d, this.Uh[a], void 0);
                  var m = f.slice(0);
                  m[m.length - 1] = l.ordinal;
                  this.TY(m, a + 1, !0);
                } else {
                  var n = f.slice(0, -1);
                  n.push(l.ordinal);
                  this.PY(n, l, a, c);
                }
              } catch (p) {}
            }
          }
          kf(f) {
            if (0 === this.Bd.length || 0 < this.Bd.length && this.Bd[0][0].length !== this.cb.length) this.Bd = [[this.cb, [], [], void 0, void 0]];
            this.TY([], 0, f);
          }
          jf(f) {
            if (0 === this.Od.length || 0 < this.Od.length && this.Od[0][0].length !== this.cb.length) this.Od = [[this.cb, [], [], void 0, void 0]];
            this.r$([], 0, f);
          }
          TY(f, b, a) {
            if (void 0 !== this.Uh[b]) {
              var c = this.Uh[b],
                d = this.ld(f, this.Bd),
                g;
              f.length < this.Uh.length && this.xB(d, c, void 0);
              a && (g = this.hc.Pa.getItem(this.je[c]));
              if (a && g && g.Bf) {
                var l = g.wd.children;
                for (d = 0; d < l.length; d++) a = g.za(l[d]), c = f.slice(0), c.push(a.ordinal), this.PY(c, a, b, k.i.ha.Ia);
              } else for (g = d[0][1], d = 0; d < g.length; d++) c = f.slice(0), c.push(g[d]), this.TY(c, b + 1, a);
            }
          }
          r$(f, b, a) {
            if (void 0 !== this.wk[b]) {
              var c = this.wk[b],
                d = this.ld(f, this.Od),
                g;
              f.length < this.wk.length && this.xB(d, c, void 0);
              a && (g = this.Rb.Pa.getItem(this.je[c]));
              if (a && g.Bf) for (c = 0; c < g.wd.children.length; c++) a = g.za(g.wd.children[c]), d = f.slice(0), d.push(a.ordinal), this.PY(d, a, b, k.i.ha.Ra);else for (g = d[0][1], c = 0; c < g.length; c++) d = f.slice(0), d.push(g[c]), this.r$(d, b + 1, a);
            }
          }
          Jm(f, b, a, c) {
            0 === this.Bd.length && (this.expand([], k.i.ha.Ia, void 0), this.expand([], k.i.ha.Ra, void 0));
            try {
              if (0 != b.children.length && (1 != b.children.length || b.hierarchy.za(b.children[0]).caption != e.model.B.j.Fl && b.hierarchy.za(b.children[0]).caption != e.model.B.j.Wn)) {
                this.PM(f, b, a);
                b.dc || this.Ae(f, b, a, void 0);
                for (var d = b.hierarchy.wa.getItem(c), g = 0; g < b.children.length; g++) {
                  var l = b.hierarchy.za(b.children[g]);
                  if (!l.Sh && l.level.yb < d.yb) {
                    var m = f.slice(0, -1);
                    m.push(l.ordinal);
                    var n = this.ld(m, a === k.i.ha.Ra ? this.Od : this.Bd);
                    void 0 !== n && void 0 !== n[0] && this.Jm(m, l, a, c);
                  }
                }
              }
            } catch (p) {}
          }
          La() {
            return 0;
          }
          Rg(f, b) {
            f = this.values && this.values[f[0]] ? this.values[f[0]][b] : NaN;
            this.va.fa.Ba !== k.i.qa.Cc && this.va.fa.Ba !== k.i.qa.Md || !e.model.C.F.Rn || (f = k.zt.R().U1(f) ? k.zt.R().C1(f) : f);
            return f;
          }
          Lda() {}
          zH() {
            return this.cb.length;
          }
          get Nx() {
            return this.vb && this.vb[0] ? this.vb[0].length : this.vb[1] ? this.vb[1].length : 0;
          }
          ym(f, b) {
            if (-1 !== this.je.indexOf(f)) return this.je.indexOf(f);
            if (void 0 === b) this.wa[this.je.length] = [-1, this.je.length];else {
              var a = this.je.indexOf(b);
              if (-1 === a) return this.ym(b), this.ym(f, b);
              this.wa[a] ? this.wa[a].push(this.je.length) : this.wa[this.je.length] = [-1, this.je.length];
            }
            this.je.push(f);
            return this.je.length - 1;
          }
          QK(f) {
            -1 === this.oh.indexOf(f.A) && this.oh.push(f.A);
          }
          Fy(f, b) {
            var a = !1;
            if ("string" === typeof f) var c = f;else if (c = f.A, b = f.aa, a = f.Oa) {
              var d = f.Sd;
              var g = f.Gk;
            }
            f = this.xg.indexOf(c);
            if (-1 !== f) {
              if (void 0 !== b && b !== k.i.da.NONE) {
                if (this.Bp[f] === b) return;
                f = this.xg.length;
                this.Bp[f] = b;
                this.xg[f] = c;
              }
            } else f = this.xg.length, void 0 !== b && b !== k.i.da.NONE && (this.Bp[f] = b), this.xg.push(c);
            a && (this.hu[f] = d, this.Xw[f] = g);
          }
          dC() {
            return !0 === e.model.C.F.it || "rows" === e.model.C.F.it;
          }
          uG() {
            return !0 === e.model.C.F.it || "columns" === e.model.C.F.it;
          }
        }
        k.w6 = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor() {}
          static BBa(f) {
            var b = null;
            switch (f.Ba) {
              case k.i.qa.Cc:
                b = f.Cm ? new k.external.Fb.Ap.p6(f) : new k.external.Fb.GE.kqa(f);
                break;
              case k.i.qa.Md:
                b = f.Cm ? new k.external.Fb.Ap.p6(f) : new k.external.Fb.hq.epa(f);
                break;
              case k.i.qa.Xh:
                b = new k.local.csv.fX();
                break;
              case k.i.qa.Gq:
                b = new k.local.csv.lpa();
                break;
              case k.i.qa.JSON:
                b = !f.NI || f.Ru || f.Wd ? new k.local.json.xna() : new k.local.json.yna();
                break;
              case k.i.qa.hg:
                b = new k.external.Se.fma(f);
                break;
              case k.i.qa.API:
                b = new k.external.pc.cka(f);
            }
            return b;
          }
        }
        k.Cqa = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            this.type = f;
            this.iw = k.i.ha.Ia;
            this.gg = [];
          }
        }
        k.yF = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          static eD(f, b) {
            switch (b.Ba) {
              case k.i.qa.hg:
                f = new k.external.Se.dma(f, b);
                break;
              case k.i.qa.API:
                f = new k.external.pc.bka(f, b);
                break;
              case k.i.qa.Md:
                f = new k.external.Fb.hq.PX(f, b);
                break;
              default:
                f = new k.external.Fb.GE.PX(f, b);
            }
            return f;
          }
        }
        k.fB = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    var Ha = q || (q = {}),
      Ia = Ha.u || (Ha.u = {});
    class Ja {}
    Ja.pF = "members";
    Ja.l6 = "ascendants";
    Ja.Cla = "descendants";
    Ja.v9 = "siblings";
    Ja.iY = "search";
    Ia.rp = Ja;
    (function (e) {
      (function (k) {
        class h {
          constructor() {}
          static i1(f) {
            var b = null;
            switch (f.Ba) {
              case k.i.qa.hg:
                b = new k.external.Se.Zla();
                break;
              case k.i.qa.API:
                b = new k.external.pc.Yja();
                break;
              case k.i.qa.Cc:
                b = f.Cm ? new k.external.Fb.Ap.o6() : new k.external.Fb.jj.Q9();
                break;
              case k.i.qa.Md:
                b = f.Cm ? new k.external.Fb.Ap.o6() : new k.external.Fb.jj.Q9();
            }
            return b;
          }
        }
        k.nX = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor() {
            this.values = [];
            this.values.push("");
            if (null != h.instance) throw Error("Singleton");
          }
          static R() {
            null == h.instance && (h.instance = new h());
            return h.instance;
          }
          static dispose() {
            h.instance = null;
          }
          li(f) {
            var b = this.values.indexOf(f);
            -1 == b && (b = this.values.push(f) - 1);
            return b;
          }
          La(f) {
            return f >= this.values.length ? "out of bounce: " + f + " of " + this.values.length : this.values[f];
          }
        }
        k.rY = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {}
        h.oY = "STRUCTURE_CONNECTED";
        h.Iv = "STRUCTURE_LOADED";
        h.nY = "STRUCTURE_CANCELLED";
        h.pY = "STRUCTURE_LOADING_FAILED";
        h.YI = "BEFORE_QUERY";
        h.al = "QUERY_COMPLETE";
        h.Dt = "QUERY_ERROR";
        k.yg = h;
        class f {}
        f.$J = "SLICE_CHANGED";
        k.bK = f;
        class b extends v.ga {
          constructor(c) {
            super(h.YI);
            this.Ro = c;
          }
        }
        k.YE = b;
        class a extends v.ga {
          constructor(c) {
            super(h.al);
            this.Ro = c;
          }
        }
        k.cY = a;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor() {
            this.nN = [NaN];
            this.EI = [""];
            if (null != h.instance) throw Error("Singleton");
          }
          static R() {
            null == h.instance && (h.instance = new h());
            return h.instance;
          }
          static dispose() {
            h.instance = null;
          }
          kA(f, b) {
            var a = this.EI.indexOf(f);
            -1 == a && (this.EI.push(f), a = this.nN.push(b) - 1);
            return a;
          }
          zBa(f) {
            return isNaN(f) || f >= this.EI.length || void 0 == this.EI[f] ? "" : this.EI[f];
          }
          C1(f) {
            return isNaN(f) || f >= this.nN.length ? NaN : this.nN[f];
          }
          U1(f) {
            return !(isNaN(f) || void 0 === this.nN[f]);
          }
          clear() {
            this.nN.length = 1;
            this.EI.length = 1;
          }
        }
        k.zt = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          static Wg(f, b) {
            if (f === b) return f;
            if (h.LE && "[" === f.slice(0, 1) && "]" === f.slice(-1)) {
              b = f.split("].");
              1 < b.length && b.shift();
              f = "";
              for (var a = 0; a < b.length; a++) {
                var c = b[a];
                "[Measures]" != c && ("[" == c.slice(0, 1) && (c = c.slice(1, c.length)), "]" == c.slice(-1) && (c = c.slice(0, c.length - 1)));
                f = "" == f ? c : f + "." + c;
              }
            }
            return f;
          }
          static Os(f) {
            if ("[" == f.slice(0, 1) && "]" == f.slice(-1) && h.LE) {
              var b = f.split("].");
              if (2 > b.length) return h.MI && !e.model.C.F.nw ? f.toLocaleLowerCase() : f;
              1 < b.length && b.shift();
              f = "";
              for (var a = 0; a < b.length - 1; a++) {
                var c = b[a];
                "[Measures]" != c && ("[" == c.slice(0, 1) && (c = c.slice(1, c.length)), "]" == c.slice(-1) && (c = c.slice(0, c.length - 1)));
                f = "" == f ? c : f + "." + c;
              }
              f = f + "." + b[b.length - 1];
            }
            return h.MI && !e.model.C.F.nw ? f.toLocaleLowerCase() : f;
          }
          static Ps(f) {
            if ("[Measures]" == f.slice(0, 10)) return h.Os(f, void 0);
            h.LE && (f = f.split(".["), 2 < f.length ? (f.shift(), f = "[" + f.join(".[")) : (f = f.pop(), "]" == f.slice(-1) && (f = f.slice(0, f.length - 1))));
            return h.MI && !e.model.C.F.nw ? f.toLocaleLowerCase() : f;
          }
          static type(f) {
            return k.i.input.sa.valid(f) ? f : "hierarchical date" === f ? k.i.input.sa.Fq : "measure" === f ? k.i.input.sa.jb : k.i.input.sa.$c;
          }
        }
        h.LE = !1;
        h.MI = !1;
        k.we = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor() {
              super();
              this.Lb = [];
              this.Bg = [];
              this.ad = [];
              this.lg = [];
              this.Jc = [];
              this.Ec = [];
              this.Ji = [];
              this.Gc = [];
              this.gz = [];
              this.SV = [];
              this.YR = [];
              this.PB = "";
              this.Ge = !1;
              this.FN = [];
              this.bw = [];
              this.qL = [];
              this.Jt = [];
              this.Zz = b => this.YD(b);
              this.gL = b => this.p3(b);
              this.fO = () => this.wr();
              this.un = new e.ub();
              this.pR = [];
              this.xQ = [];
              this.sm = new e.ub();
              this.iR = new e.ub();
              this.mb = [];
              this.Rj = 0;
              this.OF = !1;
              this.MB = this.uy = this.eG = 0;
              this.Ro = k.i.$d.ho;
              this.sR = !1;
              this.WY = 0;
              f.counter++;
              this.ja = k.Ma.R();
            }
            static R() {
              null == f.instance && (f.instance = new f(), f.instance.PB = "grid" + f.counter);
              return f.instance;
            }
            zR() {
              this.ja.N(k.yg.al, this.Zz, 1);
              this.ja.N(k.yg.YI, this.gL);
              this.ja.N(k.yg.Iv, this.fO, 1);
            }
            aA() {
              this.ja.pb(k.yg.al, this.Zz);
              this.ja.pb(k.yg.YI, this.gL);
              this.ja.pb(k.yg.Iv, this.fO);
            }
            get ta() {
              return null != this.rK ? this.rK : this.ja.ta;
            }
            set ta(b) {
              this.rK = b;
            }
            get slice() {
              return null != this.Qb ? this.Qb : this.ja.pa;
            }
            set slice(b) {
              this.Qb = b;
            }
            get Aj() {
              return e.model.C.F.uk;
            }
            set Aj(b) {}
            get rows() {
              return this.un;
            }
            set rows(b) {}
            get xb() {
              return this.slice.xb;
            }
            set xb(b) {}
            get vl() {
              return this.pR;
            }
            set vl(b) {}
            get tC() {
              return this.xQ;
            }
            set tC(b) {}
            get Ka() {
              return this.sm;
            }
            set Ka(b) {}
            get Db() {
              return this.slice.Db;
            }
            set Db(b) {}
            get ob() {
              return this.iR;
            }
            set ob(b) {}
            get Ca() {
              return this.mb;
            }
            set Ca(b) {}
            get ie() {
              return this.Rj;
            }
            set ie(b) {}
            get Xi() {
              return this.slice && this.OF;
            }
            set Xi(b) {
              this.OF = b;
            }
            get uI() {
              return this.eG;
            }
            set uI(b) {}
            get Bn() {
              return this.uy;
            }
            set Bn(b) {}
            get Mz() {
              return this.MB;
            }
            set Mz(b) {}
            get hc() {
              return this.Pb;
            }
            set hc(b) {}
            get Rb() {
              return this.Ob;
            }
            set Rb(b) {}
            get Qk() {
              return this.Pb ? this.Pb.ab ? this.Pb.Pa.length - 1 : this.Pb.Pa.length : 0;
            }
            set Qk(b) {}
            get vk() {
              return this.Ob ? this.Ob.ab ? this.Ob.Pa.length - 1 : this.Ob.Pa.length : 0;
            }
            set vk(b) {}
            get dm() {
              return 1 < this.mb.length || this.Ob.ab && e.model.C.F.AI;
            }
            set dm(b) {}
            qM() {
              return this.Pb && !this.ED ? this.Pb.kd : [];
            }
            oia(b) {
              this.Pb && !this.ED && (this.Pb.kd = b);
            }
            pM() {
              return this.Ob && !this.BD ? this.Ob.kd : [];
            }
            nia(b) {
              this.Ob && !this.BD && (this.Ob.kd = b);
            }
            mH() {
              return this.Pb && this.ED ? this.Pb.kd : [];
            }
            X4(b) {
              this.Pb && this.ED && (this.Pb.kd = b);
            }
            $C() {
              return this.Ob && this.BD ? this.Ob.kd : [];
            }
            fia(b) {
              this.Ob && this.BD && (this.Ob.kd = b);
            }
            tH() {
              return this.Pb && !this.CD ? this.Pb.ue : [];
            }
            c5(b) {
              this.Pb && !this.CD && (this.Pb.ue = b);
            }
            sH() {
              return this.Ob && !this.AD ? this.Ob.ue : [];
            }
            b5(b) {
              this.Ob && !this.AD && (this.Ob.ue = b);
            }
            mM() {
              return this.Pb && this.CD ? this.Pb.ue : [];
            }
            lia(b) {
              this.Pb && this.CD && (this.Pb.ue = b);
            }
            lM() {
              return this.Ob && this.AD ? this.Ob.ue : [];
            }
            kia(b) {
              this.Ob && this.AD && (this.Ob.ue = b);
            }
            get CD() {
              return this.slice.gf;
            }
            get AD() {
              return this.slice.Tf;
            }
            get ED() {
              return this.slice.kf;
            }
            get BD() {
              return this.slice.jf;
            }
            set ak(b) {
              this.Pb && (this.Pb.fg = b);
            }
            get ak() {
              var b = k.i.Aa.ed;
              this.Pb && (b = this.Pb.fg, b == k.i.Aa.ed && this.Pb.mt && this.Pb.Gr != k.i.Aa.ed && (b = this.Pb.Gr));
              return b;
            }
            set Ij(b) {
              this.Pb && (this.Pb.Zm = b);
            }
            get Ij() {
              if (this.Pb) {
                var b = this.Pb.Zm;
                this.Pb.fg == k.i.Aa.ed && this.Pb.mt && this.Pb.Gr != k.i.Aa.ed && (b = []);
              }
              return b;
            }
            set To(b) {
              this.Pb && (this.Pb.Jf = b);
            }
            get To() {
              if (this.Pb) {
                var b = this.Pb.Jf;
                this.Pb.fg == k.i.Aa.ed && this.Pb.mt && this.Pb.Gr != k.i.Aa.ed && (b = this.Pb.mt);
              }
              return b;
            }
            get tD() {
              if (this.ak == k.i.Aa.ed || null == this.Ij) return !1;
              if (1 > this.Ij.length) return !0;
              var b = !1;
              try {
                b = this.Th(this.Ij.slice(0, this.Ij.length - 1), this.To);
              } catch (a) {}
              return b;
            }
            set tD(b) {}
            set Nh(b) {
              this.Ob && (this.Ob.fg = b);
            }
            get Nh() {
              var b = k.i.Aa.ed;
              this.Ob && (b = this.Ob.fg, b == k.i.Aa.ed && this.Ob.mt && this.Ob.Gr != k.i.Aa.ed && (b = this.Ob.Gr));
              return b;
            }
            set Nl(b) {
              this.Ob && (this.Ob.Zm = b);
            }
            get Nl() {
              if (this.Ob) {
                var b = this.Ob.Zm;
                this.Ob.fg == k.i.Aa.ed && this.Ob.mt && this.Ob.Gr != k.i.Aa.ed && (b = []);
              }
              return b;
            }
            set er(b) {
              this.Ob && (this.Ob.Jf = b);
            }
            get er() {
              if (this.Ob) {
                var b = this.Ob.Jf;
                this.Ob.fg == k.i.Aa.ed && this.Ob.mt && this.Ob.Gr != k.i.Aa.ed && (b = this.Ob.mt);
              }
              return b;
            }
            get wz() {
              if (this.Nh == k.i.Aa.ed || null == this.Nl) return !1;
              if (1 > this.Nl.length) return !0;
              var b = !1;
              try {
                b = this.Xj(this.Nl.slice(0, this.Nl.length - 1), this.er);
              } catch (a) {}
              return b;
            }
            set wz(b) {}
            set yi(b) {}
            get yi() {
              return null;
            }
            kT() {
              return null;
            }
            reset() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              this.Ge = this.Xi = !1;
              this.mb = [];
              this.un = new e.ub();
              this.sm = new e.ub();
              this.iR = new e.ub();
              this.pR = [];
              this.xQ = [];
              this.Bg = [];
              this.lg = [];
              this.Lb = [];
              this.ad = [];
              this.Jc = [];
              this.Ec = [];
              this.Gc = [];
              this.uy = this.eG = 0;
              this.Ji = [];
              this.gz = [];
              this.SV = [];
              this.YR = [];
              b && (this.Ob && (this.Ob.kd = []), this.Pb && (this.Pb.kd = []), this.Ob && (this.Ob.ue = []), this.Pb && (this.Pb.ue = []));
            }
            p3(b) {
              b.Ro != k.i.$d.lJ && (this.Ro = b.Ro, this.Xi = !1, b.Ro == k.i.$d.ho && this.reset(), b.Ro != k.i.$d.lX && b.Ro != k.i.$d.Vx || this.reset(!1));
            }
            YD(b) {
              b.Ro != k.i.$d.lJ && this.load();
            }
            wr() {
              this.Xi = !1;
              this.Ge || this.reset();
            }
            load() {
              if (null == this.ta && (this.ta = this.ja.ta, null == this.ta)) return;
              if (this.slice) {
                this.Ob = this.slice.rd(k.i.ha.Ra);
                this.Pb = this.slice.rd(k.i.ha.Ia);
                if (0 == this.ad.length && 0 == this.Lb.length || this.Ro == k.i.$d.ZO) this.ED ? this.ta.kf(this.slice.gf) : this.ta.expand([], k.i.ha.Ia, void 0), this.BD ? this.ta.jf(this.slice.Tf) : this.ta.expand([], k.i.ha.Ra, void 0), (0 < this.tH().length || 0 < this.mM().length) && this.m$(), (0 < this.sH().length || 0 < this.lM().length) && this.l$(), (0 < this.qM().length || 0 < this.mH().length || 0 < this.pM().length || 0 < this.$C().length) && this.s$(), (0 < this.tH().length || 0 < this.mM().length) && this.m$(), (0 < this.sH().length || 0 < this.lM().length) && this.l$(), (0 < this.qM().length || 0 < this.mH().length || 0 < this.pM().length || 0 < this.$C().length) && this.s$();
                this.AV();
                this.Xi = !0;
              } else this.Pb = this.Ob = null;
            }
            s$() {
              var b = this.slice.gd();
              if (this.Ro == k.i.$d.ZO || this.Ro == k.i.$d.ho) {
                if (this.slice.kf) {
                  var a = this.mH();
                  if (0 < a.length) for (var c = 0; c < a.length; c++) try {
                    var d = b[a[c][0]];
                    var g = a[c].slice(1);
                    this.ta.collapse(g, k.i.ha.Ia, d);
                  } catch (l) {}
                } else if (a = this.qM(), 0 < a.length) for (c = 0; c < a.length; c++) try {
                  d = b[a[c][0]], g = a[c].slice(1), this.ta.expand(g, k.i.ha.Ia, d);
                } catch (l) {}
                if (this.slice.jf) {
                  if (a = this.$C(), 0 < this.$C().length) for (c = 0; c < this.$C().length; c++) try {
                    d = b[a[c][0]], g = a[c].slice(1), this.ta.collapse(g, k.i.ha.Ra, d);
                  } catch (l) {}
                } else if (a = this.pM(), 0 < a.length) for (c = 0; c < a.length; c++) try {
                  d = b[a[c][0]], g = a[c].slice(1), this.ta.expand(g, k.i.ha.Ra, d);
                } catch (l) {}
              }
            }
            m$() {
              var b = this.hc.Pa.slice();
              b.removeItem("[Measures]");
              var a = this.slice.gd();
              if (this.CD) for (var c = this.mM(), d = 0; d < c.length; d++) try {
                var g = a[c[d][0]];
                var l = c[d].slice(2);
                var m = b.ea(l.length - 1);
                var n = m.Ib(c[d][1]);
                this.ta.Bh(l, n, g) && this.ta.Pp(l, n, k.i.ha.Ia, g);
              } catch (r) {} else for (c = this.tH(), d = 0; d < c.length; d++) try {
                if ("string" == typeof c[d][0]) {
                  var p = c[d][0];
                  g = a[c[d][1]];
                  l = c[d].slice(3);
                  m = b.ea(l.length - 1);
                  n = m.Ib(c[d][2]);
                } else g = a[c[d][0]], l = c[d].slice(2), m = b.ea(l.length - 1), n = m.Ib(c[d][1]);
                if (void 0 !== p) {
                  if (m.Cu(p).yb < n.level.yb) {
                    var t = this.oua(n, p);
                    l[l.length - 1] = t.ordinal;
                    m.y0(t);
                    this.ta.Pp(l, t, k.i.ha.Ia, g);
                  } else this.ta.Bh(l, n, g) || (this.ta.PM(l, n, k.i.ha.Ia), this.ta.Ae(l, n, k.i.ha.Ia, g));
                } else n.hierarchy.lc && n.hierarchy.wd && this.ta.Jm(l.slice(0, -1), n.hierarchy.wd, k.i.ha.Ia, n.hierarchy.xf), this.ta.Bh(l, n, g) || (this.ta.PM(l, n, k.i.ha.Ia), this.ta.Ae(l, n, k.i.ha.Ia, g));
              } catch (r) {}
            }
            l$() {
              var b = this.Rb.Pa.slice();
              b.removeItem("[Measures]");
              var a = this.slice.gd();
              if (this.AD) for (var c = this.lM(), d = 0; d < c.length; d++) try {
                var g = a[c[d][0]];
                var l = c[d].slice(2);
                var m = b.ea(l.length - 1);
                var n = m.Ib(c[d][1]);
                this.ta.Bj(l, n, g) && this.ta.Pp(l, n, k.i.ha.Ra, g);
              } catch (p) {} else for (c = this.sH(), d = 0; d < c.length; d++) try {
                g = a[c[d][0]], l = c[d].slice(2), m = b.ea(l.length - 1), n = m.Ib(c[d][1]), n.hierarchy.lc && n.hierarchy.wd && this.ta.Jm(l.slice(0, -1), n.hierarchy.wd, k.i.ha.Ra, n.hierarchy.xf), this.ta.Bj(l, n, g) || (this.ta.PM(l, n, k.i.ha.Ra), this.ta.Ae(l, n, k.i.ha.Ra, g));
              } catch (p) {}
            }
            ACa(b) {
              if (!b.Oa) return !1;
              b = u.wt.uM(b.Sd, this.ja.O.Ca);
              const a = new Map();
              for (let c = 0; c < b.length; c++) a.set(b[c].aa, !0);
              return a.has(k.i.da.fn) || a.has(k.i.da.hn);
            }
            AV() {
              this.sR = !1;
              this.slice ? (this.mb = this.slice.gd(), this.Rj = this.Pb.ab ? this.Pb.ie : this.Ob.ie, this.un = this.slice.rows, this.sm = this.slice.Ka, this.iR = this.slice.ob) : (this.mb = [], this.Rj = 0, this.un = new e.ub(), this.sm = new e.ub(), this.iR = new e.ub());
              this.pR = [];
              this.xQ = [];
              this.Ge ? (this.pLa(), this.bw = this.br(this.Bg), this.FN = this.br(this.Lb), this.Jt = this.br(this.lg), this.qL = this.br(this.ad)) : (this.Bg = [], this.Lb = [], this.lg = [], this.ad = [], this.Jc = [], this.Ec = [], this.Ji = [], this.Gc = []);
              this.gz = [];
              this.uy = this.eG = 0;
              this.SV = [];
              this.YR = [];
              if (!e.v(this.slice) && !this.slice.kb) {
                this.MB = -1;
                e.v(this.Ob.Jf) || this.Ob.Jf.aa !== k.i.da.fn && this.Ob.Jf.aa !== k.i.da.hn && !this.ACa(this.Rb.Jf) ? (this.iha(), this.fha()) : (this.fha(), this.iha());
                for (var b = 0; b < this.Ec.length; b++) this.Ec[b] > this.eG && (this.eG = this.Ec[b]);
                this.eG++;
                for (b = 0; b < this.Gc.length; b++) this.Gc[b] > this.uy && (this.uy = this.Gc[b]);
                0 < this.ad.length && this.uy++;
                !this.kb && 0 < this.slice.Db.length && this.Ob.ab && this.dm && this.uy++;
                -1 == this.MB ? this.MB = 0 == this.ie ? 0 : this.uy : this.MB++;
                this.Ge && (this.TIa(), this.SIa(), this.bw = [], this.FN = [], this.Jt = [], this.qL = []);
                this.Ge || this.pack();
                this.sR && e.Wa(e.model.B.j.B8, e.model.B.j.C8, e.tb.Dl);
              }
            }
            SIa() {
              if (this.Ob.ab) {
                var b = this.lg[0].length;
                for (--b; 0 <= b; b--) {
                  var a = this.Vj(b, !0);
                  if (null === a || 0 == a.length) continue;
                  const c = this.La([], a, this.mb[0]);
                  isNaN(c) && (a = this.ZL(this.ad, a), 0 <= a && this.bA(this.ad, a), this.bA(this.lg, b), this.Gc = e.Ja.Ir(this.Gc, b), this.Jc = e.Ja.Ir(this.Jc, b));
                }
              } else for (b = this.ad[0].length, --b; 0 <= b; b--) a = this.Vj(b), null !== a && 0 != a.length && (a = this.La([], a, this.mb[0]), isNaN(a) && (this.bA(this.ad, b), this.Gc = e.Ja.Ir(this.Gc, b)));
            }
            TIa() {
              if (this.Ob.ab) {
                var b = this.Lb[0].length;
                for (--b; 0 <= b; b--) {
                  var a = this.Jn(b);
                  null !== a && 0 != a.length && (a = this.La(a, [], this.mb[0]), isNaN(a) && (this.bA(this.Lb, b), this.Ec = e.Ja.Ir(this.Ec, b), this.Ji.splice(b, 1)));
                }
              } else for (b = this.Bg[0].length, --b; 0 <= b; b--) {
                a = this.Jn(b, !0);
                if (null === a || 0 == a.length) continue;
                const c = this.La(a, [], this.mb[0]);
                isNaN(c) && (a = this.ZL(this.Lb, a), 0 <= a && this.bA(this.Lb, a), this.bA(this.Bg, b), this.Ec = e.Ja.Ir(this.Ec, b), this.Jc = e.Ja.Ir(this.Jc, b), this.Ji.splice(b, 1));
              }
            }
            bA(b, a) {
              for (let c = 0; c < b.length; c++) b[c] = e.Ja.Ir(b[c], a);
            }
            iha() {
              var b = this.ta.result[0];
              if (!this.Pb.ab || 1 < this.un.length || this.Aj) this.M0(b, [], 0), this.Ge && this.ZIa(this.Lb);
              if (this.l5 || this.Pb.ab && 1 == this.un.length) {
                var a = this.xb.ea(0);
                if (!a || a.Rh) if (0 == this.Lb.length && (this.Lb[0] = []), !this.Ge) {
                  for (a = 0; a < this.Lb.length; a++) this.Lb[a].push(0);
                  this.Ec.push(0);
                }
              }
              if (!this.Aj) if (this.Pb.ab && this.dm) {
                this.Ge || (this.Ec = [], this.Ji = []);
                if (1 < this.un.length) for (0 != this.ie && this.YL(b, [], -1, 0), a = 0; a < this.mb.length; a++) {
                  if (this.l5) {
                    if (this.Ge) {
                      var c = this.zj(this.Bg, [], this.bw);
                      0 <= c && (this.Ec = e.Ja.re(this.Ec, 0, c), this.Jc = e.Ja.re(this.Jc, a, c));
                    } else this.tj(this.Bg, [], a), this.Ec.push(0);
                  } else 0 != this.Rj || "off" != e.model.C.F.Hf && "rows" != e.model.C.F.Hf || (this.Ge ? (c = this.zj(this.Bg, [], this.bw), 0 <= c && (this.Ec = e.Ja.re(this.Ec, 0, c), this.Jc = e.Ja.re(this.Jc, a, c))) : (this.tj(this.Bg, [], a), this.Ec.push(0)));
                  0 == this.ie && this.YL(b, [], a, 1);
                }
                if (0 == this.ie && (this.l5 || this.Pb.ab && 1 == this.un.length)) for (b = 0; b < this.mb.length; b++) this.Ge ? (a = this.zj(this.Bg, [], this.bw), 0 <= a && (this.Ec = e.Ja.re(this.Ec, 0, a), this.Jc = e.Ja.re(this.Jc, b, a))) : (this.tj(this.Bg, [], b), this.Ec.push(0));
              } else this.Bg = this.Lb;
            }
            fha() {
              var b = this.ta.result[1];
              (!this.Ob.ab || 1 < this.sm.length) && this.Yca(b, [], 0);
              if (this.s5 || this.Ob.ab && 1 == this.sm.length) {
                var a = this.Db.ea(0);
                if (!a || a.Rh) if (0 == this.ad.length && (this.ad[0] = []), !this.Ge) {
                  for (a = 0; a < this.ad.length; a++) this.ad[a].push(0);
                  this.Gc.push(0);
                }
              }
              if (this.Ob.ab && this.dm) {
                this.Ge || (this.Gc = []);
                if (1 < this.sm.length) for (this.gz = [], 0 != this.Rj && this.WL(b, [], -1, 0), a = 0; a < this.mb.length; a++) {
                  if (this.s5) {
                    if (this.Ge) {
                      var c = this.zj(this.lg, [], this.Jt);
                      0 <= c && (this.Gc = e.Ja.re(this.Gc, 0, c), this.Jc = e.Ja.re(this.Jc, a, c));
                    } else this.tj(this.lg, [], a), this.Gc.push(0);
                  } else 0 != this.Rj || "off" != e.model.C.F.Hf && "columns" != e.model.C.F.Hf || (this.Ge ? (c = this.zj(this.lg, [], this.Jt), 0 <= c && (this.Gc = e.Ja.re(this.Gc, 0, c), this.Jc = e.Ja.re(this.Jc, a, c))) : (this.tj(this.lg, [], a), this.Gc.push(0)));
                  0 == this.Rj && this.WL(b, [], a, 0);
                }
                if (0 == this.Rj && (this.s5 || this.Ob.ab && 1 == this.sm.length)) for (b = 0; b < this.mb.length; b++) this.Ge ? (a = this.zj(this.lg, [], this.Jt), 0 <= a && (this.Gc = e.Ja.re(this.Gc, 0, a), this.Jc = e.Ja.re(this.Jc, b, a))) : (this.tj(this.lg, [], b), this.Gc.push(0));
              } else this.lg = this.ad;
            }
            pLa() {
              this.IW(this.Lb);
              this.IW(this.Bg);
              this.IW(this.ad);
              this.IW(this.lg);
              Array.isArray(this.Jc) || (this.Jc = Array.from(this.Jc));
              Array.isArray(this.Ec) || (this.Ec = Array.from(this.Ec));
              Array.isArray(this.Gc) || (this.Gc = Array.from(this.Gc));
            }
            IW(b) {
              for (var a = 0; a < b.length; a++) Array.isArray(b[a]) || (b[a] = Array.from(b[a]));
            }
            pack() {
              this.tV(this.Lb);
              this.tV(this.Bg);
              this.tV(this.ad);
              this.tV(this.lg);
              15 < this.Jc.length && (this.Jc = new Int8Array(this.Jc));
              15 < this.Ec.length && (this.Ec = new Uint8Array(this.Ec));
              15 < this.Gc.length && "after" !== e.model.C.F.pL && (this.Gc = new Uint8Array(this.Gc));
            }
            br(b) {
              b = b.slice();
              for (let a = 0; a < b.length; a++) b[a] = b[a].slice();
              return b;
            }
            tV(b) {
              for (var a = 0; a < b.length; a++) if (15 < b[a].length) {
                for (var c = 0, d = 0; d < b[a].length; d++) c = b[a][d] > c ? b[a][d] : c;
                256 > c ? b[a] = new Uint8Array(b[a]) : 65536 > c ? b[a] = new Uint16Array(b[a]) : 4294967296 > c && (b[a] = new Uint32Array(b[a]));
              }
            }
            M0(b, a, c) {
              var d = a.length;
              if (d = this.Pb.ab && a.length >= this.Rj ? this.un.ea(d + 1) : this.un.ea(d)) 0 == c && (this.WY = Date.now()), this.Aj ? this.u$(d, d.wd, b, a, c) : this.$ca(d, d.wd, b, a, c);
            }
            efa(b) {
              if (0 == b.hierarchy.cb.length) return !0;
              let a = b;
              for (; !e.v(a);) {
                if (0 <= b.hierarchy.cb.indexOf(a.ordinal)) return !0;
                a = a.parent;
              }
              for (const c of b.hierarchy.cb) if (0 <= b.Bw.indexOf(c)) return !0;
              return !1;
            }
            u2(b, a, c, d) {
              if (this.ja.fa.Ic && this.ja.fa.Ba !== k.i.qa.API || this.ja.fa.RM) return !1;
              if (!0 === e.model.C.F.it || "rows" === e.model.C.F.it) return !this.efa(a);
              if (void 0 !== c && void 0 !== d && !k.i.da.SM(d.aa) && (d = d.clone(), d.aa = c.measure.aa, a = this.La(b, [], d), !c.UU(a, c.query))) return !0;
              for (c = 0; c < this.Ca.length; c++) if (0 === c && this.Ca[c].Oa || !isNaN(this.La(b, [], this.Ca[c])) || k.i.da.SM(this.Ca[c].aa)) return !1;
              return !0;
            }
            Wea(b, a, c, d) {
              if (this.ja.fa.Ic && this.ja.fa.Ba !== k.i.qa.API || this.ja.fa.RM) return !1;
              if (!0 === e.model.C.F.it || "columns" === e.model.C.F.it) return !this.efa(a);
              if (void 0 !== c && void 0 !== d && !k.i.da.SM(d.aa) && (d = d.clone(), d.aa = c.measure.aa, a = this.La([], b, d), !c.UU(a, c.query))) return !0;
              for (c = 0; c < this.Ca.length; c++) if (0 === c && this.Ca[c].Oa || !isNaN(this.La([], b, this.Ca[c])) || k.i.da.SM(this.Ca[c].aa)) return !1;
              return !0;
            }
            $ca(b, a, c, d, g) {
              if (null != a) {
                if (null != b.lc && !this.ta.Bh(d, a)) {
                  if (0 < d.length) {
                    var l = d.slice(0);
                    l.push(a.ordinal);
                  } else l = d.slice(0);
                  this.ta.Jm(l, a, k.i.ha.Ia, b.xf);
                }
                a = null == b.lc || a.level.yb >= b.lc.yb ? b.ck(a, !1, "") : b.av(b.xf);
                a = this.x5(b, a, c, d);
                if (b.filter.ei && b.filter.query.ua != k.i.Vb.Nj && b.filter.query.ua != k.i.Vb.ni) {
                  var m = b.filter;
                  var n = this.slice.fd(m.measure.A);
                }
                l = this.xb.indexOf(b.A) < this.xb.length - 1;
                for (var p = this.ta.dC(b), t = 0; t < a.length; t++) {
                  var r = b.za(a[t]);
                  0 === t && this.ada(r);
                  if (void 0 === c[r.ordinal] && !p || r.dc) continue;
                  var w = d.slice(0);
                  w.push(r.ordinal);
                  if (this.u2(w, r, m, n)) continue;
                  const y = l && this.ta.Th(w),
                    A = !r.Sh && this.ta.Bh(w, r);
                  if (this.Ge) {
                    const B = this.zj(this.Lb, w, this.FN);
                    0 <= B && !this.hc.ab && (this.Ec = e.Ja.re(this.Ec, g, B));
                    y || this.hc.ab || this.J4(this.Lb, w);
                  } else this.tj(this.Lb, w), this.Ec.push(g);
                  if (Date.now() - this.WY < e.model.C.F.LS) A ? this.$ca(b, r, c, d, g + 1) : y && this.M0(c[r.ordinal], w, g + 1);else if (A || y) this.sR = !0;
                }
              }
            }
            J4(b, a) {
              var c = b[0].length;
              for (--c; 0 <= c; c--) {
                var d = !0;
                for (var g = 0; g < a.length; g++) if (b[g][c] != a[g]) {
                  d = !1;
                  break;
                }
                if (d) {
                  d = !0;
                  for (g = a.length; g < b.length; g++) if (0 != b[g][c]) {
                    d = !1;
                    break;
                  }
                  d ? this.Aj && 2 == this.Ji[c] && (this.Ji[c] = 3) : (this.bA(b, c), this.Ec = e.Ja.Ir(this.Ec, c), this.Ji.splice(c, 1), this.Pb.ab && (this.Jc = e.Ja.Ir(this.Jc, c)));
                }
              }
              if (this.Aj) for (b = b[0].length, a = 0; a < b; a++) 3 == this.Ji[a] && (this.Ji[a] = 1, this.Ec[a] = this.zda(this.Lb, a));
            }
            ZIa(b) {
              if (b && 0 != b.length) {
                var a = b[0].length;
                for (let c = b.length - 1; 0 <= c; c--) {
                  for (let d = 0; d < a; d++) if (0 != b[c][d]) return;
                  --b.length;
                }
              }
            }
            yha(b, a) {
              var c = b[0].length;
              for (--c; 0 <= c; c--) {
                var d = !0;
                for (var g = 0; g < a.length; g++) if (b[g][c] != a[g]) {
                  d = !1;
                  break;
                }
                if (d) {
                  d = !0;
                  for (g = a.length; g < b.length; g++) if (0 != b[g][c]) {
                    d = !1;
                    break;
                  }
                  d || (this.bA(b, c), this.Gc = e.Ja.Ir(this.Gc, c), this.Ob.ab && (this.Jc = e.Ja.Ir(this.Jc, c)));
                }
              }
            }
            tj(b, a, c) {
              0 === b.length && (b[0] = []);
              if (a.length > b.length) for (var d = b.length; d < a.length; d++) {
                b[d] = [];
                for (let g = 0; g < b[0].length; g++) b[d].push(0);
              }
              for (d = 0; d < a.length; d++) b[d].push(a[d]);
              if (b.length > a.length) for (a = a.length; a < b.length; a++) b[a].push(0);
              void 0 !== c && this.Jc.push(c);
            }
            zj(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
              if (a.length < b.length) {
                a = a.slice(0);
                for (var g = a.length; g < b.length; g++) a.push(0);
              }
              if (a.length > b.length) for (g = b.length; g < a.length; g++) {
                b[g] = [];
                for (let l = 0; l < b[0].length; l++) b[g].push(0);
              }
              return this.Aba(null !== c ? c : b, a) ? -1 : (c = this.Jya(b, a) + d, this.jCa(b, a, c), c);
            }
            Jya(b, a) {
              var c = 0;
              let d = b[0].indexOf(0);
              0 > d && (d = b[0].length - 1);
              for (let g = 0; g < b.length; g++) {
                c = b[g].indexOf(a[g], c);
                if (-1 === c) break;
                if (c < d) d = b[g].lastIndexOf(a[g], d - 1) + 1;else break;
              }
              return d;
            }
            jCa(b, a, c) {
              for (let d = 0; d < b.length; d++) b[d] = e.Ja.re(b[d], void 0 !== a[d] ? a[d] : 0, c);
            }
            Aba(b, a) {
              if (a.length < b.length) {
                a = a.slice(0);
                for (var c = a.length; c < b.length; c++) a.push(0);
              }
              if (a.length > b.length) {
                c = !0;
                for (let d = b.length; d < a.length; d++) if (0 != a[d]) {
                  c = !1;
                  break;
                }
                if (!c) return !1;
                a = a.slice(0, b.length);
              }
              return 0 <= this.ZL(b, a);
            }
            ZL(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
              const d = b[0].length;
              for (; !c && a.length < d;) a.push(0);
              for (c = 0; c < d; c++) {
                let g = !0;
                for (let l = 0; l < b.length; l++) if (b[l][c] != a[l]) {
                  g = !1;
                  break;
                }
                if (g) return c;
              }
              return -1;
            }
            mD(b, a) {
              if (0 == b.length || void 0 == b[0][a]) return null;
              for (var c = [], d = 0; d < b.length; d++) 0 != b[d][a] && c.push(b[d][a]);
              return c;
            }
            YL(b, a, c, d) {
              if (!this.Aj) {
                var g = a.length;
                (g = this.Pb.ab && a.length >= this.Rj ? this.un.ea(g + 1) : this.un.ea(g)) && this.QS(g, g.wd, b, a, c, d);
              }
            }
            QS(b, a, c, d, g, l) {
              if (null != a) {
                if (null != b.lc && !this.ta.Bh(d, a)) {
                  if (0 < d.length) {
                    var m = d.slice(0, -1);
                    m.push(a.ordinal);
                  } else m = d.slice(0);
                  this.ta.Jm(m, a, k.i.ha.Ia, b.xf);
                }
                m = d.length;
                a = null == b.lc || a.level.yb >= b.lc.yb ? b.ck(a, !1, "") : b.av(b.xf);
                a = this.x5(b, a, c, d);
                if (b.filter.ei && b.filter.query.ua != k.i.Vb.Nj && b.filter.query.ua != k.i.Vb.ni) {
                  var n = b.filter;
                  var p = this.slice.fd(n.measure.A);
                }
                for (var t, r, w = this.ta.dC(b), y = 0; y < a.length; y++) {
                  t = b.za(a[y]);
                  if (null == c[t.ordinal] && !w || t.dc) continue;
                  var A = d.slice(0);
                  A.push(t.ordinal);
                  if (this.u2(A, t, n, p)) continue;
                  var B = this.ta.Th(A, g);
                  const C = this.ta.Bh(A, t);
                  if (m < this.Rj) {
                    if (this.Ge ? (r = this.zj(this.Bg, A, this.bw), 0 <= r && (this.Ec = e.Ja.re(this.Ec, l, r), this.Jc = e.Ja.re(this.Jc, -1, r))) : (this.tj(this.Bg, A, -1), this.Ec.push(l)), m == this.Rj - 1 && B) for (r = 0; r < this.mb.length; r++) this.ta.Bh(A, t, r) ? this.QS(b, t, c, d, r, l + 2) : (this.Ge ? (B = this.zj(this.Bg, A, this.bw), 0 <= B && (this.Ec = e.Ja.re(this.Ec, l + 1, B), this.Jc = e.Ja.re(this.Jc, r, B))) : (this.tj(this.Bg, A, r), this.Ec.push(l + 1)), this.ta.Th(A) && this.YL(c[t.ordinal], A, r, l + 2));else {
                      for (r = 0; r < this.mb.length; r++) if (this.Lia(b) || !B && !C || this.Eu) if (this.Ge) {
                        const I = this.zj(this.Bg, A, this.bw);
                        0 <= I && (this.Ec = e.Ja.re(this.Ec, l + 1, I), this.Jc = e.Ja.re(this.Jc, r, I));
                        B || this.J4(this.Bg, A);
                      } else this.tj(this.Bg, A, r), this.Ec.push(l + 1);
                      this.ta.Bh(A, t, g) ? this.QS(b, t, c, d, g, l + 2) : this.ta.Th(A, g) && this.YL(c[t.ordinal], A, g, l + 2);
                    }
                  } else this.Ge ? (r = this.zj(this.Bg, A, this.bw), 0 <= r && (this.Ec = e.Ja.re(this.Ec, l, r), this.Jc = e.Ja.re(this.Jc, g, r))) : (this.tj(this.Bg, A, g), this.Ec.push(l)), this.ta.Bh(A, t, g) ? this.QS(b, t, c, d, g, l + 1) : B && this.YL(c[t.ordinal], A, g, l + 1);
                }
              }
            }
            u$(b, a, c, d, g) {
              if (null != a) {
                if (null != b.lc && !this.ta.Bh(d, a)) {
                  if (0 < d.length) {
                    var l = d.slice(0);
                    l.push(a.ordinal);
                  } else l = d.slice(0);
                  this.ta.Jm(l, a, k.i.ha.Ia, b.xf);
                }
                a = null == b.lc || a.level.yb >= b.lc.yb ? b.ck(a, !1, "") : b.av(a.hierarchy.xf);
                a = this.x5(b, a, c, d);
                if (b.filter.ei && b.filter.query.ua != k.i.Vb.Nj && b.filter.query.ua != k.i.Vb.ni) {
                  var m = b.filter;
                  var n = this.slice.fd(m.measure.A);
                }
                l = this.ta.dC(b);
                for (var p = !1, t = 0; t < a.length; t++) {
                  var r = b.za(a[t]);
                  0 === t && this.ada(r);
                  if (null == c[r.ordinal] && !l || r.dc) continue;
                  var w = d.slice(0);
                  w.push(r.ordinal);
                  if (this.u2(w, r, m, n)) continue;
                  var y = this.ta.Bh(w, r),
                    A = this.ta.Th(w);
                  r.Zg && A && !y && (A = !1);
                  var B = 0 < this.Lb.length ? this.Lb[0].length : 0;
                  !this.Ge && this.Qk > w.length && (this.Ji[B] = 1, void 0 == this.Ec[B] && (this.Ec[B] = g));
                  const C = Date.now() - this.WY;
                  if (C < e.model.C.F.LS || C >= e.model.C.F.LS && 0 < g) y ? this.u$(b, r, c, d, g + 1) : A && this.M0(c[r.ordinal], w, g + 1);else if (y || A) this.sR = !0, 0 === g && A && (this.pJa(w, B), A = !1);
                  y || A ? (this.Lia(b) && (this.Ge ? (A = this.zj(this.Lb, w, this.FN), 0 <= A ? (this.Ji.splice(A, 0, 2), this.Ec = e.Ja.re(this.Ec, g, A)) : (w = this.ZL(this.Lb, w, !1), 0 <= w && (this.Ji[w] = 2))) : (this.tj(this.Lb, w), this.Ec[this.Lb[0].length - 1] = g, this.Ji[this.Lb[0].length - 1] = 2)), y && this.Ec[B] > g && (this.Ec[B] = g, this.Ji[B] = 0)) : this.Ge ? (y = 1 < w.length && this.kwa(this.Lb, d), y = this.zj(this.Lb, w, this.FN, y ? -1 : 0), 0 <= y && (this.Ji.splice(y, 0, g == this.Qk - 1 ? 0 : 1), this.Ec = e.Ja.re(this.Ec, g, y), 1 < w.length && (0 == t && (this.Ji[y] = 1, this.Ec[y] = this.zda(this.Lb, y)), 0 == p && (y = d.slice(0), y.push(0), y = this.ZL(this.Lb, y), 0 <= y && 2 != this.Ji[y] && (p = !0, this.Ji[y] = 2, this.Ec[y] = g - 1)))), A || this.hc.ab || this.J4(this.Lb, w)) : (this.tj(this.Lb, w), void 0 == this.Ji[this.Lb[0].length - 1] && (this.Ji[this.Lb[0].length - 1] = 0, this.Ec[this.Lb[0].length - 1] = g));
                }
              }
            }
            zda(b, a) {
              if (0 == a) return 0;
              let c = 0;
              for (let d = 0; d < b.length && b[d][a] == b[d][a - 1]; d++) c++;
              return c;
            }
            kwa(b, a) {
              a = a.slice(0);
              a.push(0);
              let c = 1;
              for (; c < a.length;) {
                if (this.Aba(b, a)) return !0;
                c++;
                a[a.length - c] = 0;
              }
              return !1;
            }
            pJa(b, a) {
              this.Ec[a] = 0;
              this.ta.collapse(b, this.Pb.A, void 0);
              b = [-1, b[0]];
              a = this.mH().slice(0);
              a.push(b);
              this.X4(a);
            }
            ada(b) {
              this.Zca(this.pR, b);
            }
            sya(b) {
              this.Zca(this.xQ, b);
            }
            Zca(b, a) {
              -1 === b.indexOf(a.level.A) && (1 >= (null != a.hierarchy.lc ? a.level.yb - a.hierarchy.lc.yb + 1 : a.level.yb) ? b.push(a.level.A) : b.splice(b.indexOf(a.parent.level.A) + 1, 0, a.level.A));
            }
            wfa(b, a) {
              for (let c = 0; c < b.length; c++) {
                const d = a.ea(c),
                  g = this.GAa(d, b[c]);
                if (d.filter.zh) {
                  let l = -1;
                  for (let m = 0; m < g.length; m++) {
                    if (0 > d.cb.indexOf(g[m]) && 1 === g.length) return !1;
                    const n = d.cb.indexOf(g[m]);
                    l = n > l ? n : l;
                  }
                  if (-1 === l) return !1;
                }
              }
              return !0;
            }
            GAa(b, a) {
              const c = [];
              for (b = b.za(a); 0 !== b.ordinal;) c.push(b.ordinal), b = b.parent;
              return c;
            }
            x5(b, a, c, d) {
              if (!this.wz) return a;
              var g = this.Nl;
              if (!this.wfa(g, this.Db)) return a;
              for (var l = [], m = [], n = [], p = [], t, r = this.ta.dC(b), w = 0; w < a.length; w++) if (t = b.za(a[w]), (null != c[t.ordinal] || r) && !t.dc) {
                var y = d.slice(0);
                y.push(t.ordinal);
                y = this.La(y, g, this.er);
                isNaN(y) ? n.push(t.ordinal) : (l.push(y), m.push(t.ordinal));
              }
              b = this.Nh !== k.i.Aa.Mc ? e.Ja.sort(l, e.Ja.Qi | e.Ja.Fv) : e.Ja.sort(l, e.Ja.Qi | e.Ja.lp | e.Ja.Fv);
              for (w = 0; w < b.length; w++) a = m[b[w]], null != a && p.push(a);
              for (w = 0; w < n.length; w++) a = n[w], this.Nh == k.i.Aa.Mc ? p.push(a) : p.splice(w, 0, a);
              return p;
            }
            Qia(b, a, c, d) {
              if (!this.tD) return a;
              var g = this.Ij;
              if (!this.wfa(g, this.xb)) return a;
              for (var l = [], m = [], n = [], p = [], t, r = this.ta.uG(b), w = 0; w < a.length; w++) if (t = b.za(a[w]), (null != c[t.ordinal] || r) && !t.dc) {
                var y = d.slice(0);
                y.push(t.ordinal);
                y = this.La(g, y, this.To);
                isNaN(y) ? n.push(t.ordinal) : (l.push(y), m.push(t.ordinal));
              }
              b = this.ak !== k.i.Aa.Mc ? e.Ja.sort(l, e.Ja.Qi | e.Ja.Fv) : e.Ja.sort(l, e.Ja.Qi | e.Ja.lp | e.Ja.Fv);
              for (w = 0; w < b.length; w++) a = m[b[w]], null != a && p.push(a);
              for (w = 0; w < n.length; w++) a = n[w], this.ak == k.i.Aa.Mc ? p.push(a) : p.splice(w, 0, a);
              return p;
            }
            Yca(b, a, c) {
              var d = a.length;
              (d = this.Ob.ab && a.length >= this.Rj ? this.sm.ea(d + 1) : this.sm.ea(d)) && this.Xca(d, d.wd, b, a, c);
            }
            Xca(b, a, c, d, g) {
              if (null != b.lc && !this.ta.Bj(d, a)) {
                if (0 < d.length) {
                  var l = d.slice(0);
                  l.push(a.ordinal);
                } else l = d.slice(0);
                this.ta.Jm(l, a, k.i.ha.Ra, b.xf);
              }
              a = null == a.hierarchy.lc || a.level.yb >= b.lc.yb ? b.ck(a, !1, "") : b.av(b.xf);
              a = this.Qia(b, a, c, d);
              if (b.filter.ei && b.filter.query.ua != k.i.Vb.Nj && b.filter.query.ua != k.i.Vb.ni) {
                var m = b.filter;
                var n = this.slice.fd(m.measure.A);
              }
              l = this.ta.uG(b);
              for (var p = 0; p < a.length; p++) {
                var t = b.za(a[p]);
                0 == p && this.sya(t);
                if (null == c[t.ordinal] && !l || t.dc) continue;
                var r = d.slice(0);
                r.push(t.ordinal);
                if (this.Wea(r, t, m, n)) continue;
                const w = this.ta.Xj(r),
                  y = this.ta.Bj(r, t);
                if (this.zI(w, y) && !y) this.aC(d.length);else if (this.ht(b) || !w || this.Eu) {
                  if (this.Ge) {
                    const A = this.zj(this.ad, r, this.qL);
                    0 <= A && !this.Rb.ab && (this.Gc = e.Ja.re(this.Gc, g, A));
                    w || this.Rb.ab || this.yha(this.ad, r);
                  } else this.tj(this.ad, r), this.Gc.push(g);
                } else this.ht(b) || this.aC(d.length);
                y ? this.Xca(b, t, c, d, g + 1) : w && this.Yca(c[t.ordinal], r, g + 1);
                this.zI(w, y) && (this.ht(b) || !w || this.Eu) && (this.Ge ? (t = this.zj(this.ad, r, this.qL), 0 <= t && (this.Gc = e.Ja.re(this.Gc, -1, t))) : (this.tj(this.ad, r), this.Gc.push(-1)));
              }
            }
            WL(b, a, c, d) {
              var g = a.length;
              (g = this.Ob.ab && a.length >= this.Rj ? this.sm.ea(g + 1) : this.sm.ea(g)) && this.PS(g, g.wd, b, a, c, d);
            }
            get l5() {
              return "on" === e.model.C.F.Hf || "columns" === e.model.C.F.Hf || 0 === this.rows.length;
            }
            get s5() {
              return "on" === e.model.C.F.Hf || "rows" === e.model.C.F.Hf || 0 === this.Ka.length;
            }
            ht(b) {
              return e.model.C.F.uk && void 0 !== b && void 0 !== b.If ? b.If : "on" === e.model.C.F.If || "columns" === e.model.C.F.If;
            }
            zI(b, a) {
              return !b && !a || this.Eu ? !1 : "after" === e.model.C.F.pL;
            }
            Lia(b) {
              return e.model.C.F.uk && void 0 !== b && void 0 !== b.If ? b.If : "on" === e.model.C.F.If || "rows" === e.model.C.F.If;
            }
            get Eu() {
              return !1;
            }
            PS(b, a, c, d, g, l) {
              if (null != b.lc && !this.ta.Bj(d, a)) {
                if (0 < d.length) {
                  var m = d.slice(0, -1);
                  m.push(a.ordinal);
                } else m = d.slice(0);
                this.ta.Jm(m, a, k.i.ha.Ra, b.xf);
              }
              m = d.length;
              var n = null == b.lc || a.level.yb >= b.lc.yb ? b.ck(a, !1, "") : b.av(b.xf);
              n = this.Qia(a.hierarchy, n, c, d);
              if (b.filter.ei && b.filter.query.ua != k.i.Vb.Nj && b.filter.query.ua != k.i.Vb.ni) {
                var p = a.hierarchy.filter;
                var t = this.slice.fd(p.measure.A);
              }
              var r;
              a = this.ta.uG(b);
              for (var w = 0; w < n.length; w++) {
                var y = b.za(n[w]);
                if ((null != c[y.ordinal] || a) && !y.dc) {
                  var A = d.slice(0);
                  A.push(y.ordinal);
                  if (!this.Wea(A, y, p, t)) {
                    var B = this.ta.Xj(A, g),
                      C = this.ta.Bj(A, y);
                    if (m < this.Rj) {
                      if (this.Ob.ab && this.MB < l + 1 && (this.MB = l + 1), m == this.Rj - 1 && B) {
                        if (C) {
                          for (r = 0; r < this.mb.length; r++) this.Ge ? (B = this.zj(this.lg, A, this.Jt), 0 <= B && (this.Gc = e.Ja.re(this.Gc, l, B), this.Jc = e.Ja.re(this.Jc, g, B))) : (this.tj(this.lg, A, r), this.Gc.push(l));
                          this.PS(b, y, c, d, g, l + 1);
                        } else for (r = 0; r < this.mb.length; r++) this.ht(b) || !B || this.Eu ? this.Ge ? (C = this.zj(this.lg, A, this.Jt), 0 <= C && (this.Gc = e.Ja.re(this.Gc, l, C), this.Jc = e.Ja.re(this.Jc, r, C))) : (this.tj(this.lg, A, r), this.Gc.push(l)) : this.ht(b) || this.aC(m), this.ta.Xj(A, r) && this.WL(c[y.ordinal], A, r, l + 1);
                      } else {
                        if (this.zI(B, C) && !C) this.aC(m);else if (this.ht(b) || !B || this.Eu) {
                          for (r = 0; r < this.mb.length; r++) if (this.Ge) {
                            const I = this.zj(this.lg, A, this.Jt);
                            0 <= I && (this.Gc = e.Ja.re(this.Gc, l, I), this.Jc = e.Ja.re(this.Jc, r, I));
                            B || this.yha(this.lg, A);
                          } else this.tj(this.lg, A, r), this.Gc.push(l);
                        } else this.ht(b) || this.aC(m);
                        this.ta.Bj(A, y, g) ? this.PS(b, y, c, d, g, l + 1) : B && this.WL(c[y.ordinal], A, g, l + 1);
                        if (this.zI(B, C) && (this.ht(b) || !B || this.Eu)) for (r = 0; r < this.mb.length; r++) this.Ge ? (y = this.zj(this.lg, A, this.Jt), 0 <= y && (this.Gc = e.Ja.re(this.Gc, -1, y), this.Jc = e.Ja.re(this.Jc, r, y))) : (this.tj(this.lg, A, r), this.Gc.push(-1));
                      }
                    } else this.zI(B, C) && !C ? this.aC(m) : this.ht(b) || !B || this.Eu ? this.Ge ? (r = this.zj(this.lg, A, this.Jt), 0 <= r && (this.Gc = e.Ja.re(this.Gc, l, r), this.Jc = e.Ja.re(this.Jc, g, r))) : (this.tj(this.lg, A, g), this.Gc.push(l)) : this.ht(b) || this.aC(m), this.ta.Bj(A, y, g) ? this.PS(b, y, c, d, g, l + 1) : B && this.WL(c[y.ordinal], A, g, l + 1), this.zI(B, C) && (this.ht(b) || !B || this.Eu) && (this.Ge ? (A = this.zj(this.ad, A, this.qL), 0 <= A && (this.Gc = e.Ja.re(this.Gc, -1, A))) : (this.tj(this.ad, A), this.Gc.push(-1)));
                  }
                }
              }
            }
            aC(b) {
              void 0 === this.gz[this.Gc.length] && (this.gz[this.Gc.length] = []);
              -1 == this.gz[this.Gc.length].indexOf(b) && this.gz[this.Gc.length].push(b);
            }
            get kb() {
              return 0 == this.ad.length && 0 == this.Lb.length;
            }
            set kb(b) {}
            yT(b) {
              return this.Aj ? this.Ec[this.Pb.ab ? Math.floor(b / this.mb.length) : b] : this.Ec[b];
            }
            FT(b) {
              return this.Aj ? this.Ji[this.Pb.ab ? Math.floor(b / this.mb.length) : b] : this.Ji[b];
            }
            Mw() {
              return 1;
            }
            iM(b) {
              return this.Gc[b];
            }
            t2(b) {
              return this.gz[b];
            }
            BT(b) {
              return this.Pb.ab && (b.length > this.Rj || 0 == this.Rj) ? b.length : b.length - 1;
            }
            zT(b) {
              return this.un.ea(this.BT(b));
            }
            iT(b) {
              return this.Ob.ab && (b.length > this.Rj || 0 == this.Rj) ? b.length : b.length - 1;
            }
            nH(b) {
              return this.sm.ea(this.iT(b));
            }
            get Ed() {
              return 0 < this.ad.length ? this.ad[0].length : 0;
            }
            set Ed(b) {}
            get Dd() {
              return 0 < this.Lb.length ? this.Lb[0].length : 0;
            }
            set Dd(b) {}
            get Gn() {
              return 0 < this.lg.length ? this.lg[0].length : 0;
            }
            set Gn(b) {}
            get Fn() {
              return this.Aj ? (this.hc && this.hc.ab ? this.mb.length : 1) * (0 < this.Lb.length ? this.Lb[0].length : 0) : this.Bg && 0 < this.Bg.length ? this.Bg[0].length : 0;
            }
            set Fn(b) {}
            Th(b, a) {
              return this.ta.Th(b, a);
            }
            Xj(b, a) {
              return this.ta.Xj(b, a);
            }
            Bh(b, a, c) {
              return this.ta.Bh(b, a, c);
            }
            Bj(b, a, c) {
              return this.ta.Bj(b, a, c);
            }
            aD(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              b = b.slice(0);
              var c = (a = a && this.Ob.ab) ? b.pop() : -1,
                d = this.lg;
              if (0 < d.length) for (var g = 0; g < d[0].length; g++) {
                var l = !0;
                if (!a || !this.dm || c == this.Jc[g]) {
                  var m = this.mD(d, g);
                  if (m.length == b.length) {
                    for (var n = 0; n < m.length; n++) if (m[n] != b[n]) {
                      l = !1;
                      break;
                    }
                    if (l) return g;
                  }
                }
              }
              return -1;
            }
            kD(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              b = b.slice(0);
              var c = (a = a && this.Pb.ab) ? b.pop() : -1,
                d = this.Aj ? this.Lb : this.Bg;
              if (0 < d.length) for (var g = 0; g < d[0].length; g++) {
                var l = !0;
                if (!a || !this.dm || c == this.Jc[g]) {
                  var m = this.mD(d, g);
                  if (m.length == b.length) {
                    for (var n = 0; n < m.length; n++) if (m[n] != b[n]) {
                      l = !1;
                      break;
                    }
                    if (l) return g;
                  }
                }
              }
              return -1;
            }
            Jn(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              return 0 > b || null == this.Pb || null == this.mb ? null : a && this.Pb.ab && this.dm ? this.Aj ? (b = Math.floor(b / this.mb.length), void 0 == this.Lb[0][b] ? null : this.mD(this.Lb, b)) : void 0 == this.Bg[0][b] ? null : this.mD(this.Bg, b) : e.v(this.Lb[0]) || e.v(this.Lb[0][b]) ? null : this.mD(this.Lb, b);
            }
            Vj(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              return 0 > b || null == this.Ob || null == this.mb ? null : a && this.Ob.ab && this.dm ? void 0 == this.lg[0][b] ? null : this.mD(this.lg, b) : void 0 == this.ad[0] ? [0] : void 0 == this.ad[0][b] ? null : this.mD(this.ad, b);
            }
            e1() {
              return null;
            }
            ET(b) {
              return this.Aj && this.Pb.ab ? void 0 == this.Lb[0][Math.floor(b / this.Ca.length)] ? -1 : b % this.mb.length : void 0 == this.Jc[b] ? -1 : this.Pb.ab && this.dm ? this.Jc[b] : -1;
            }
            jT(b) {
              return void 0 === this.Jc[b] ? -1 : this.Ob.ab && this.dm ? this.Jc[b] : -1;
            }
            Di(b, a) {
              if (void 0 !== this.mb && void 0 !== this.Pb && void 0 !== this.Ob) return this.dm ? this.Pb.ab ? this.Aj ? (a = b % this.mb.length, void 0 == this.Lb[0][Math.floor(b / this.Ca.length)] ? this.mb[0] : this.mb[a]) : void 0 === this.Jc[b] ? this.mb[0] : this.mb[this.Jc[b]] : void 0 === this.Jc[a] ? this.mb[0] : this.mb[this.Jc[a]] : this.mb[0];
            }
            bd(b, a, c) {
              return this.ta.bd(b, a, c);
            }
            save(b, a, c, d, g) {
              return this.ta.save(b, a, c, d, g);
            }
            nD(b, a, c) {
              return this.ta.nD(b, a, c);
            }
            Hs(b, a) {
              return this.ja.fa.Ic ? null : null == b && null == a ? null : this.ta.jBa(b, a);
            }
            Rg(b, a, c) {
              b = this.ta.La(b, a, c);
              this.ja.fa.Ba !== k.i.qa.Cc && this.ja.fa.Ba !== k.i.qa.Md || !e.model.C.F.Rn || (b = !c.Oa && k.zt.R().U1(b) ? k.zt.R().C1(b) : b);
              return b;
            }
            La(b, a, c) {
              if (c.aa === k.i.da.Vr) return b = this.Rg(b, a, c), c = this.Rg([], [], c), isNaN(b) && !isNaN(c) ? 0 : Math.abs(100 * b / c);
              if (c.aa === k.i.da.tp) return b = this.Rg(b, a, c), c = this.Rg([], a, c), isNaN(b) && !isNaN(c) ? 0 : 100 * b / c;
              if (c.aa === k.i.da.Kq) return a = this.Rg(b, a, c), c = this.Rg(b, [], c), isNaN(a) && !isNaN(c) ? 0 : 100 * a / c;
              if (c.aa === k.i.da.Jq) {
                var d = this.Rg(b, a, c);
                b = b.slice(0, b.length - 1);
                c = this.Rg(b, a, c);
                return isNaN(d) && !isNaN(c) ? 0 : 100 * d / c;
              }
              if (c.aa === k.i.da.Iq) return d = this.Rg(b, a, c), a = a.slice(0, a.length - 1), c = this.Rg(b, a, c), isNaN(d) && !isNaN(c) ? 0 : 100 * d / c;
              if (c.aa === k.i.da.Pi) {
                d = this.Rg([], [], c);
                const g = this.Rg(b, [], c),
                  l = this.Rg([], a, c);
                c = this.Rg(b, a, c);
                return Math.abs(d * c / (l * g));
              }
              return c.aa === k.i.da.Xn ? this.Ida(b, a, c, !1) : c.aa === k.i.da.fn ? this.Jda(b, a, c, !1) : c.aa === k.i.da.co ? this.Ida(b, a, c, !0) : c.aa === k.i.da.hn ? this.Jda(b, a, c, !0) : c.aa === k.i.da.jn || c.aa === k.i.da.fo ? this.ta.eea(b, a, c) : this.Rg(b, a, c);
            }
            Jda(b, a, c, d) {
              var g = -1;
              if (0 < this.Ka.length) {
                var l = this.Ob.ab && 1 < this.mb.length;
                g = a.slice();
                l && g.push(0);
                g = this.aD(g, l);
                if (0 == g || 0 == a.length) return NaN;
                if (0 > g) return 0;
                l = this.Vj(l && a.length <= this.Ob.ie ? g - this.mb.length : g - 1, l);
                if (null == l || a.length != l.length && 1 != a.length) return NaN;
                a.length != l.length && 1 == a.length && (l = this.fBa(g, a.length));
                if (null == l) return NaN;
                l = this.Rg(b, l, c);
                isNaN(l) && !d && (l = 0);
              }
              b = this.Rg(b, a, c);
              isNaN(b) && 0 < g && !d && (b = 0);
              return d ? (b - l) / l * 100 : b - l;
            }
            Ida(b, a, c, d) {
              var g = -1;
              if (0 < this.rows.length) {
                var l = this.Pb.ab && 1 < this.mb.length;
                g = b.slice();
                l && g.push(0);
                g = this.kD(g, l);
                if (0 == g || 0 == b.length) return NaN;
                if (0 > g) return 0;
                l = this.Jn(l && b.length <= this.Pb.ie ? g - (this.mb.length + 1) : g - 1, l);
                if (null == l || b.length != l.length && 1 != b.length) return NaN;
                b.length != l.length && 1 == b.length && (l = this.gBa(g, b.length));
                if (null == l) return NaN;
                l = this.Rg(l, a, c);
                isNaN(l) && !d && (l = 0);
              }
              b = this.Rg(b, a, c);
              isNaN(b) && 0 < g && !d && (b = 0);
              return d ? (b - l) / l * 100 : b - l;
            }
            gBa(b, a) {
              if (0 > b || null == this.Pb || null == this.mb || e.v(this.Lb[0]) || e.v(this.Lb[0][b])) return null;
              b = this.Vha(this.Lb, a, b);
              return 0 <= b && 0 == this.Lb[a][b] ? this.cea(b, a, this.Lb) : null;
            }
            fBa(b, a) {
              if (0 > b || null == this.Pb || null == this.mb) return null;
              if (void 0 == this.ad[0]) return [0];
              if (void 0 == this.ad[0][b]) return null;
              b = this.Vha(this.ad, a, b);
              return 0 <= b && 0 == this.ad[a][b] ? this.cea(b, a, this.ad) : null;
            }
            cea(b, a, c) {
              let d = [];
              for (let g = 0; g < a; g++) d.push(c[g][b]);
              return d;
            }
            Vha(b, a, c) {
              if (b[a] && 0 == b[a][c]) {
                for (c--; 0 != b[a][c] && 0 <= c;) c--;
                return c;
              }
              return -1;
            }
            Wp(b, a, c) {
              b = this.ta.La(b, a, c);
              return k.zt.R().zBa(b);
            }
            kw(b, a, c, d) {
              return this.ta.kw(b, a, c, d);
            }
            Hw(b) {
              this.Xi && (this.ja.fa.Ic || this.mya(b));
            }
            mya(b) {
              var a = this.slice.rows.Bb(b.A) ? k.i.ha.Ia : k.i.ha.Ra;
              b = a == k.i.ha.Ia ? this.slice.xb.indexOf(b.A) : this.slice.Db.indexOf(b.A);
              if (b + 1 != (a == k.i.ha.Ia ? this.slice.xb.length : this.slice.Db.length)) {
                var c = [],
                  d = (a == k.i.ha.Ia ? this.slice.xb : this.slice.Db).slice(0, b + 1);
                this.DM([], d, c);
                d = a == this.slice.rs.A ? this.slice.rs.ie : -1;
                for (var g = this.slice.gd(), l = 0; l < c.length; l++) if (0 <= d && d <= b && 1 < g.length) for (var m = 0; m < g.length; m++) {
                  var n = g[m];
                  c[l].length > d ? this.expand(c[l], a, n, !1) : this.expand(c[l], a, void 0, !1);
                } else this.expand(c[l], a, void 0, !1);
                this.ja.Ea(new k.cY(k.i.$d.gF));
                this.ja.Ya(e.model.Wb.Uc.hk);
              }
            }
            DM(b, a, c) {
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
              if (0 != a.length) {
                var g = a.ea(0);
                var l = g.filter.Ei ? g.cb.length : g.Wi;
                for (var m = 0; m < l; m++) {
                  var n = g.filter.Ei ? g.za(g.cb[m]) : g.za(m);
                  if (!n.dc) {
                    var p = b.slice(0);
                    p.push(n.ordinal);
                    (d || !d && 1 == a.length) && c.push(p.slice(0));
                    this.DM(p.slice(0), a.slice(1), c, d);
                  }
                }
              }
            }
            sw(b) {
              this.Xi && (this.ja.fa.Ic || this.qva(b));
            }
            qva(b) {
              var a = this.slice.rows.Bb(b.A) ? k.i.ha.Ia : k.i.ha.Ra;
              b = a == k.i.ha.Ia ? this.slice.xb.indexOf(b.A) : this.slice.Db.indexOf(b.A);
              if (b + 1 != (a == k.i.ha.Ia ? this.slice.xb.length : this.slice.Db.length)) {
                var c = [],
                  d = (a == k.i.ha.Ia ? this.slice.xb : this.slice.Db).slice(0, b + 1);
                this.DM([], d, c, !1);
                d = a == this.slice.rs.A ? this.slice.rs.ie : -1;
                for (var g = this.slice.gd(), l = 0; l < c.length; l++) if (0 <= d && d <= b && 1 < g.length) for (var m = 0; m < g.length; m++) {
                  var n = g[m];
                  c[l].length > d ? this.collapse(c[l], a, n, !1) : this.collapse(c[l], a, void 0, !1);
                } else this.collapse(c[l], a, void 0, !1);
                this.ja.Ea(new k.cY(k.i.$d.H6));
                this.ja.Ya(e.model.Wb.Uc.hk);
              }
            }
            sort() {
              this.Ge = !1;
              this.AV();
              this.ja.Ya(e.model.Wb.Uc.hk);
            }
            get DU() {
              return this.P$;
            }
            get CU() {
              return this.O$;
            }
            expand(b, a, c) {
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
              a == k.i.ha.Ia && (this.P$ = b);
              a == k.i.ha.Ra && (this.O$ = b);
              var g = this.slice.rd(a),
                l = b.slice(0);
              l.unshift(c && g.ab ? c.index : -1);
              if (a == k.i.ha.Ia) if (this.ED) {
                g = this.mH();
                var m = l.toString().toLocaleLowerCase(),
                  n = -1;
                for (let p = 0; p < g.length; p++) if (m === g[p].toString().toLocaleLowerCase()) {
                  n = p;
                  break;
                }
                0 <= n && g.splice(n, 1);
                this.X4(g);
              } else g = this.qM().slice(0), g.push(l), this.oia(g);
              if (a == k.i.ha.Ra) if (this.BD) {
                g = this.$C();
                l = l.toString().toLocaleLowerCase();
                m = -1;
                for (n = 0; n < g.length; n++) if (l === g[n].toString().toLocaleLowerCase()) {
                  m = n;
                  break;
                }
                0 <= m && g.splice(m, 1);
                this.fia(g);
              } else g = this.pM().slice(0), g.push(l), this.nia(g);
              this.ja.expand(b, a, c, d);
            }
            collapse(b, a, c) {
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
              a == k.i.ha.Ia && (this.P$ = b.slice(0, b.length - 1));
              a == k.i.ha.Ra && (this.O$ = b.slice(0, b.length - 1));
              var g = this.slice.rd(a),
                l = b.slice(0);
              l.unshift(c && g.ab ? c.index : -1);
              if (a == k.i.ha.Ia) if (this.ED) g = this.mH().slice(0), g.push(l), this.X4(g);else {
                g = this.qM();
                var m = l.toString().toLocaleLowerCase(),
                  n = -1;
                for (let p = 0; p < g.length; p++) if (m === g[p].toString().toLocaleLowerCase()) {
                  n = p;
                  break;
                }
                0 <= n && g.splice(n, 1);
                this.oia(g);
              }
              if (a == k.i.ha.Ra) if (this.BD) g = this.$C().slice(0), g.push(l), this.fia(g);else {
                g = this.pM();
                l = l.toString().toLocaleLowerCase();
                m = -1;
                for (n = 0; n < g.length; n++) if (l === g[n].toString().toLocaleLowerCase()) {
                  m = n;
                  break;
                }
                0 <= m && g.splice(m, 1);
                this.nia(g);
              }
              this.ja.collapse(b, a, c, d);
              d && this.ja.Ya(e.model.Wb.Uc.hk);
            }
            Pp(b, a, c, d) {
              var g = this.slice.rd(c),
                l = [],
                m = b.slice(0);
              m.unshift(a.A);
              m.unshift(d && g.ab ? d.index : -1);
              if (c == k.i.ha.Ia) if (this.CD) l = this.mM().slice(0), l.push(m), this.lia(l);else {
                g = this.tH();
                for (var n = 0; n < g.length; n++) {
                  var p = g[n];
                  "string" == typeof p[0] && (p = p.slice(1));
                  p.toString().toLocaleLowerCase() != m.toString().toLocaleLowerCase() && l.push(p);
                }
                this.c5(l);
              }
              if (c == k.i.ha.Ra) if (this.AD) l = this.lM().slice(0), l.push(m), this.kia(l);else {
                g = this.sH();
                for (n = 0; n < g.length; n++) p = g[n], "string" == typeof p[0] && (p = p.slice(1)), p.toString().toLocaleLowerCase() != m.toString().toLocaleLowerCase() && l.push(p);
                this.b5(l);
              }
              this.ja.Pp(b, a, c, d);
              this.ja.Ya(e.model.Wb.Uc.hk);
            }
            oua(b, a) {
              for (; void 0 !== b && b.level.A != a;) b = b.parent;
              return b;
            }
            Ae(b, a, c, d) {
              var g = this.slice.rd(c),
                l = [],
                m = b.slice(0);
              m.unshift(a.A);
              m.unshift(d && g.ab ? d.index : -1);
              if (c == k.i.ha.Ia) if (this.CD) {
                g = this.mM();
                for (var n in g) {
                  var p = g[n];
                  p.toString().toLocaleLowerCase() != m.toString().toLocaleLowerCase() && l.push(p);
                }
                this.lia(l);
              } else l = this.tH().slice(0), l.push(m), this.c5(l);
              if (c == k.i.ha.Ra) if (this.AD) {
                g = this.lM();
                for (n in g) p = g[n], p.toString().toLocaleLowerCase() != m.toString().toLocaleLowerCase() && l.push(p);
                this.kia(l);
              } else l = this.sH().slice(0), l.push(m), this.b5(l);
              this.ja.Ae(b, a, c, d);
              this.ja.Ya(e.model.Wb.Uc.hk);
            }
            Jm(b, a, c, d, g) {
              var l = this.slice.rd(c),
                m = b.slice(0);
              m.unshift(a.A);
              m.unshift(d && l.ab ? d.index : -1);
              m.unshift(g);
              c == k.i.ha.Ia ? (l = this.tH().slice(0), l.push(m), this.c5(l)) : (l = this.sH().slice(0), l.push(m), this.b5(l));
              this.ja.Jm(b, a, c, d, g);
            }
            F2(b) {
              return !0 === this.SV[b];
            }
            iW(b) {
              this.SV[b] = !0;
            }
            l2(b) {
              return !0 === this.YR[b];
            }
            Y4(b) {
              this.YR[b] = !0;
            }
            static dispose() {
              f.instance && (f.instance.aA(), f.instance.Td());
              f.instance = null;
            }
          }
          f.counter = 0;
          h.mQ = f;
        })(k.Re || (k.Re = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static get Zba() {
              if (f.I) return f.I instanceof h.EX ? "flat" : f.I instanceof h.JO ? "chart" : "pivot";
            }
            static ija(b) {
              var a = b.V("gridType");
              return b.V("viewType") === e.K.Id.kj ? "chart" : a === e.K.Y.se.Gh ? "flat" : "pivot";
            }
            static Bc() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              "" == b && (b = e.model.C.F.ke == e.K.Id.kj ? "chart" : e.model.C.F.tc ? "flat" : "pivot");
              b = "flat" == b ? h.EX.R() : "chart" == b ? h.JO.R() : h.mQ.R();
              b.zR();
              f.I != b ? (f.I && f.I.aA(), b.load()) : a && e.model.C.F.hv && (b.load(), e.model.C.F.hv = !1);
              f.I = b;
              return f.I;
            }
            static d1(b) {
              f.Bc("chart");
              return b ? h.r9.R(f.I) : f.I;
            }
            static dispose() {
              h.EX.dispose();
              h.JO.dispose();
              h.mQ.dispose();
              h.r9.dispose();
              f.I = null;
            }
          }
          f.I = null;
          h.Ni = f;
          (function (b) {
            b.xOa = "pivot";
            b.Gh = "flat";
            b.tMa = "chart";
          })(h.Pla || (h.Pla = {}));
        })(k.Re || (k.Re = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor() {
              super();
              this.mb = [];
              this.OF = !1;
              this.Zz = () => this.YD();
              this.FZ = !1;
              this.Nu = [];
              this.hl = [];
              this.va = k.Ma.R();
            }
            get ta() {
              return null != this.rK ? this.rK : this.va.ta;
            }
            set ta(b) {
              this.rK = b;
            }
            get slice() {
              return null != this.Qb ? this.Qb : this.va.pa;
            }
            set slice(b) {
              this.Qb = b;
            }
            get Ca() {
              return this.mb;
            }
            set Ca(b) {}
            get dm() {
              return 1 < this.mb.length;
            }
            set dm(b) {}
            get Xi() {
              return this.slice && this.OF;
            }
            set Xi(b) {}
            static R() {
              null == f.instance && (f.instance = new f());
              return f.instance;
            }
            zR() {
              this.va.N(k.yg.al, this.Zz, 1);
            }
            aA() {
              this.va.pb(k.yg.al, this.Zz);
            }
            load() {
              if (null == this.ta && (this.ta = this.va.ta, null == this.ta)) return;
              this.slice && (this.va.fa.Ic || (this.ta.expand([], k.i.ha.Ia, void 0), this.ta.expand([], k.i.ha.Ra, void 0)), this.AV(), this.OF = !0);
            }
            YD() {
              this.reset();
              this.load();
            }
            AV() {
              var b,
                a = this.slice ? this.slice.flatten(!0, !0) : new e.ub();
              this.hl.length = 0;
              this.oL = new e.ub();
              this.yc = this.va.O.yc();
              this.mb = [];
              for (b = 0; b < a.length; b++) {
                var c = a.ea(b);
                var d = a.ea(b) instanceof k.O.rt ? this.va.O.mf(c.A) : a.ea(b);
                void 0 === d && (d = this.va.O.$q.getItem(c.A));
                d && this.mb.push(d);
                d = this.ta.oh.indexOf(c.A);
                if (c.Bf) for (var g = 1; g < c.wa.length; g++) this.hl.push([d, g]), this.oL.Ua(c.A, this.hl.length - 1);else this.hl.push(d), this.oL.Ua(c.A, this.hl.length - 1);
                this.yi = this.slice.Ug;
              }
              this.sort();
            }
            get ie() {
              return 0;
            }
            set ie(b) {}
            get uI() {
              return 0;
            }
            set uI(b) {}
            get Bn() {
              return 0;
            }
            set Bn(b) {}
            get Mz() {
              return 0;
            }
            set Mz(b) {}
            get rows() {
              return new e.ub();
            }
            set rows(b) {}
            get xb() {
              return new e.ub();
            }
            set xb(b) {}
            get vl() {
              return [];
            }
            set vl(b) {}
            get tC() {
              return [];
            }
            set tC(b) {}
            get Ka() {
              return new e.ub();
            }
            set Ka(b) {}
            get Db() {
              return new e.ub();
            }
            set Db(b) {}
            get ob() {
              return new e.ub();
            }
            set ob(b) {}
            get hc() {
              return new k.O.Lr(k.i.ha.Ia);
            }
            set hc(b) {}
            get Rb() {
              return new k.O.Lr(k.i.ha.Ra);
            }
            set Rb(b) {}
            get Qk() {
              return 1;
            }
            set Qk(b) {}
            get vk() {
              return 0;
            }
            set vk(b) {}
            set ak(b) {}
            get ak() {
              return null;
            }
            set Ij(b) {}
            get Ij() {
              return null;
            }
            set To(b) {}
            get To() {
              return null;
            }
            get tD() {
              return !1;
            }
            set tD(b) {}
            set Nh(b) {}
            get Nh() {
              return null;
            }
            set Nl(b) {}
            get Nl() {
              return null;
            }
            set er(b) {}
            get er() {
              return null;
            }
            get wz() {
              return !e.v(this.yi) && 0 < this.yi.length;
            }
            set wz(b) {}
            set yi(b) {
              b !== this.slice.Ug && (this.FZ = !0);
              this.slice.Ug = b;
            }
            get yi() {
              return this.slice.Ug;
            }
            kT(b) {
              if (e.v(this.yi)) return null;
              for (var a = 0; a < this.yi.length; a++) {
                var c = this.yi[a];
                if (c.measure.A == b) return c;
              }
            }
            reset() {
              this.OF = !1;
              this.mb = [];
              this.Nu.length = 0;
              this.hl.length = 0;
              this.oL = new e.ub();
              this.yc = null;
            }
            get kb() {
              return 0 == this.hl.length;
            }
            set kb(b) {}
            t2() {
              return null;
            }
            yT() {
              return 0;
            }
            FT() {
              return 0;
            }
            Mw() {
              return 0;
            }
            iM() {
              return 1;
            }
            BT() {
              return 0;
            }
            zT(b) {
              return this.nH(b);
            }
            iT() {
              return 0;
            }
            nH(b) {
              e.v(this.yc) && (this.yc = this.va.O.yc());
              return this.yc.getItem(this.ta.oh[b[0]]);
            }
            get Ed() {
              return this.hl.length;
            }
            set Ed(b) {}
            get Dd() {
              return this.ta ? this.ta.result[0] : 0;
            }
            set Dd(b) {}
            get Gn() {
              return this.hl.length;
            }
            set Gn(b) {}
            get Fn() {
              return this.ta.zH();
            }
            set Fn(b) {}
            Th() {
              return !1;
            }
            Xj() {
              return !1;
            }
            Bh() {
              return !1;
            }
            Bj() {
              return !1;
            }
            aD(b) {
              for (var a = 0; a < this.hl.length; a++) if (this.hl[a] instanceof Array) {
                if (this.hl[a][0].toString() == b.toString()) return a;
              } else if (this.hl[a].toString() == b.toString()) return a;
              return -1;
            }
            kD(b) {
              if (0 < this.Nu.length && b[0] < this.Nu.length) for (var a = 0; a < this.Nu.length; a++) {
                if (this.Nu[a].toString() == b.toString()) return a;
              } else return b[0];
              return -1;
            }
            Jn(b) {
              return 0 > b ? null : 0 < this.Nu.length && b < this.Nu.length ? [this.Nu[b]] : [b];
            }
            Vj(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              return 0 > b ? null : 0 < this.hl.length && b < this.hl.length ? !c && this.hl[b] instanceof Array ? [this.hl[b][0]] : [this.hl[b]] : [b];
            }
            e1(b) {
              b = this.oL.getItem(b);
              return this.Vj(b, !1);
            }
            ET() {
              return 0;
            }
            jT() {
              return 0;
            }
            Di(b, a) {
              b = this.Vj(a);
              var c = this.ta.oh[b[0]];
              return this.mb.find(d => d.A === c);
            }
            nD(b, a, c) {
              return null == b ? this.ta.Sda(null, c) : this.ta.Sda(b[0], c);
            }
            La(b, a, c, d) {
              if (null == a && null == b) return this.ta.La([], [], c, !0);
              if (this.ta instanceof k.local.vP || this.ta instanceof k.external.pc.i6) return this.ta.rT(b[0], a[0], c, c.type != k.i.Qa.zc, d);
            }
            Hs(b, a) {
              return (null != b || null != a) && this.ta instanceof k.local.vP ? this.ta.Hs(b[0]) : null;
            }
            sort() {
              this.EZ();
              this.FZ && (this.FZ = !1, this.va.Ya(e.model.Wb.Uc.hk));
            }
            EZ() {
              if (this.wz) {
                for (var b = [], a = null, c = null, d = 0; d < this.yi.length; d++) {
                  var g = this.yi[d];
                  g.hierarchy = this.va.O.Kk(g.measure.A);
                  c = void 0 !== g.hierarchy ? g.hierarchy.A : g.measure.A;
                  a = void 0 !== g.hierarchy ? g.hierarchy.P1 : !1;
                  if (-1 != this.oL.indexOf(c)) {
                    g.gg = this.e1(c);
                    if (g.measure.type == k.i.Qa.zc || a) g.tS = this.oAa(g.hierarchy);
                    b.push(g);
                  }
                }
                this.yi = b;
                b = [];
                for (a = 0; a < this.Fn; a++) {
                  c = [];
                  for (d = 0; d < this.yi.length; d++) g = this.yi[d], c[d] = this.pBa(a, g.gg, g.measure, g.hierarchy, !e.v(g.tS));
                  b[a] = [c, a];
                }
                b.sort((l, m) => this.EKa(l[0], m[0]));
                this.Nu = b.map(l => l[1]);
              } else this.Nu.length = 0;
            }
            oAa(b) {
              var a = !1;
              b.type == k.i.Fc.Ta && 2 < b.wa.length && (a = !0);
              if (b.P1 || !a) {
                a = {};
                const c = b.ck(b.wd, !1, k.i.Aa.kc);
                for (let d = 0; d < c.length; d++) {
                  const g = b.za(c[d]);
                  a[g.A] = d;
                }
                return a;
              }
              return null;
            }
            pBa(b, a, c, d, g) {
              if (null != d && d.type == k.i.Fc.Ta && 2 < d.wa.length) return g = this.La([b], a, c, d.wa.length - 1), d.za(g).fc;
              b = this.La([b], a, c);
              if (c.type != k.i.Qa.zc) return isNaN(b) ? Number.NEGATIVE_INFINITY : b;
              d = d.za(b);
              return g ? d.A : d.caption;
            }
            EKa(b, a) {
              let c = 0;
              for (let d = 0; d < this.yi.length; d++) {
                const g = this.yi[d];
                if (b[d] != a[d]) {
                  c = e.v(g.tS) ? "number" == typeof b[d] && "number" == typeof a[d] ? b[d] - a[d] : e.Ja.localeCompare(b[d], a[d]) : g.tS[b[d]] - g.tS[a[d]];
                  g.sort == k.i.Aa.Mc && (c *= -1);
                  break;
                }
              }
              return c;
            }
            kw(b, a, c, d) {
              return this.ta.yua(b, c, d);
            }
            Wp() {
              return null;
            }
            Hw() {}
            sw() {}
            get DU() {
              return null;
            }
            get CU() {
              return null;
            }
            expand() {}
            collapse() {}
            Pp() {}
            Ae() {}
            bd() {
              return [];
            }
            save(b, a, c, d) {
              return this.ta.wJa(b, a, c, d);
            }
            get Aj() {
              return !1;
            }
            set Aj(b) {}
            static dispose() {
              f.instance && (f.instance.Td(), f.instance.aA());
              f.instance = null;
            }
            F2() {
              return !1;
            }
            iW() {}
            l2() {
              return !1;
            }
            Y4() {}
          }
          h.EX = f;
        })(k.Re || (k.Re = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.mQ {
            constructor() {
              super();
            }
            static R() {
              null == f.xe && (f.xe = new f(), f.xe.PB = "chart" + h.mQ.counter);
              return f.xe;
            }
            get Aj() {
              return !1;
            }
            set Aj(b) {}
            get Eu() {
              return !0;
            }
            static dispose() {
              f.xe && (f.xe.aA(), f.xe.Td());
              f.xe = null;
            }
          }
          h.JO = f;
        })(k.Re || (k.Re = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor(b) {
              super();
              this.I = b;
            }
            static R(b) {
              null == f.instance && (f.instance = new f(b));
              return f.instance;
            }
            static dispose() {
              f.instance && (f.instance.Td(), f.instance.aA());
              f.instance = null;
            }
            get ta() {
              return this.I.ta;
            }
            set ta(b) {
              this.I.ta = b;
            }
            get slice() {
              return this.I.slice;
            }
            set slice(b) {
              this.I.slice = b;
            }
            get Ca() {
              return this.I.Ca;
            }
            set Ca(b) {}
            get Xi() {
              return this.I.Xi;
            }
            set Xi(b) {}
            zR() {
              this.I.zR();
            }
            aA() {
              this.I.aA();
            }
            load() {
              this.I.load();
            }
            get ie() {
              return this.I.ie;
            }
            set ie(b) {}
            get uI() {
              return this.I.Bn;
            }
            set uI(b) {}
            get dm() {
              return 1 < this.Ca.length;
            }
            set dm(b) {}
            get Bn() {
              return this.I.uI;
            }
            set Bn(b) {}
            get Mz() {
              return this.I.Mz;
            }
            set Mz(b) {}
            get rows() {
              return this.I.Ka;
            }
            set rows(b) {}
            get xb() {
              return this.I.Db;
            }
            set xb(b) {}
            get vl() {
              return this.I.tC;
            }
            set vl(b) {}
            get tC() {
              return this.I.vl;
            }
            set tC(b) {}
            get Ka() {
              return this.I.rows;
            }
            set Ka(b) {}
            get Db() {
              return this.I.xb;
            }
            set Db(b) {}
            get ob() {
              return this.I.ob;
            }
            set ob(b) {}
            get hc() {
              return this.I.Rb;
            }
            set hc(b) {}
            get Rb() {
              return this.I.hc;
            }
            set Rb(b) {}
            get Qk() {
              return this.I.vk;
            }
            set Qk(b) {}
            get vk() {
              return this.I.Qk;
            }
            set vk(b) {}
            set ak(b) {}
            get ak() {
              return this.I.Nh;
            }
            set Ij(b) {}
            get Ij() {
              return this.I.Nl;
            }
            set To(b) {}
            get To() {
              return this.I.er;
            }
            get tD() {
              return this.I.wz;
            }
            set tD(b) {}
            set Nh(b) {}
            get Nh() {
              return this.I.ak;
            }
            set Nl(b) {}
            get Nl() {
              return this.I.Ij;
            }
            set er(b) {}
            get er() {
              return this.I.To;
            }
            get wz() {
              return this.I.tD;
            }
            set wz(b) {}
            set yi(b) {}
            get yi() {
              return null;
            }
            kT() {
              return null;
            }
            reset() {}
            get kb() {
              return this.I.kb;
            }
            set kb(b) {}
            t2() {
              return null;
            }
            yT(b) {
              return this.I.iM(b);
            }
            FT(b) {
              return this.I.Mw(b);
            }
            iM(b) {
              return this.I.yT(b);
            }
            Mw(b) {
              return this.I.FT(b);
            }
            BT(b) {
              return this.I.BT(b);
            }
            zT(b) {
              return this.I.zT(b);
            }
            iT(b) {
              return this.I.iT(b);
            }
            nH(b) {
              return this.I.nH(b);
            }
            get Ed() {
              return this.I.Dd;
            }
            set Ed(b) {}
            get Dd() {
              return this.I.Ed;
            }
            set Dd(b) {}
            get Gn() {
              return this.I.Fn;
            }
            set Gn(b) {}
            get Fn() {
              return this.I.Gn;
            }
            set Fn(b) {}
            Th(b, a) {
              return this.I.Xj(b, a);
            }
            Xj(b, a) {
              return this.I.Th(b, a);
            }
            Bh(b, a, c) {
              return this.I.Bj(b, a, c);
            }
            Bj(b, a, c) {
              return this.I.Bh(b, a, c);
            }
            aD(b) {
              return this.I.kD(b);
            }
            kD(b) {
              return this.I.aD(b);
            }
            Jn(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              return this.I.Vj(b, a);
            }
            Vj(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              return this.I.Jn(b, a);
            }
            ET(b) {
              return this.I.jT(b);
            }
            jT(b) {
              return this.I.ET(b);
            }
            Di(b, a) {
              return this.I.Di(b, a);
            }
            nD(b, a, c) {
              return this.I.nD(b, a, c);
            }
            Hs() {
              return null;
            }
            La(b, a, c) {
              return this.I.La(a, b, c);
            }
            sort() {
              return this.I.sort();
            }
            kw(b, a, c, d) {
              return this.I.kw(b, a, c, d);
            }
            Wp(b, a, c) {
              return this.I.Wp(b, a, c);
            }
            Hw(b) {
              this.I.Hw(b);
            }
            sw(b) {
              this.I.sw(b);
            }
            get DU() {
              return null;
            }
            get CU() {
              return null;
            }
            expand(b, a, c) {
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
              a = a == k.i.ha.Ra ? k.i.ha.Ia : k.i.ha.Ra;
              this.I.expand(b, a, c, d);
            }
            collapse(b, a, c) {
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
              a = a == k.i.ha.Ra ? k.i.ha.Ia : k.i.ha.Ra;
              this.I.collapse(b, a, c, d);
            }
            Pp(b, a, c, d) {
              c = c == k.i.ha.Ra ? k.i.ha.Ia : k.i.ha.Ra;
              this.I.Pp(b, a, c, d);
            }
            Ae(b, a, c, d) {
              c = c == k.i.ha.Ra ? k.i.ha.Ia : k.i.ha.Ra;
              this.I.Ae(b, a, c, d);
            }
            bd(b, a, c) {
              return this.I.bd(b, a, c);
            }
            save(b, a, c, d, g) {
              return this.I.save(b, a, c, d, g);
            }
            e1() {
              return null;
            }
            get Aj() {
              return this.I.Aj;
            }
            set Aj(b) {}
            F2() {
              return !1;
            }
            iW() {}
            l2() {
              return !1;
            }
            Y4() {}
          }
          h.r9 = f;
        })(k.Re || (k.Re = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.JO {
            constructor() {
              super();
            }
          }
          h.jma = f;
        })(k.Re || (k.Re = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b) {
              void 0 !== b.A && (this.A = b.A);
              void 0 !== b.caption && (this.caption = b.caption);
              void 0 !== b.Hi && (this.Hi = b.Hi);
              void 0 !== b.parent && (this.parent = b.parent);
              void 0 !== b.fc && (this.fc = b.fc);
              void 0 !== b.level && (this.level = b.level);
              void 0 !== b.ordinal && (this.ordinal = b.ordinal);
              void 0 !== b.Zg && (this.Zg = b.Zg);
              void 0 !== b.dc && (this.dc = b.dc);
              void 0 !== b.zf && (this.zf = b.zf);
              void 0 !== b.value && (this.value = b.value);
              void 0 !== b.We && (this.We = b.We);
            }
            get G2() {
              return void 0 !== this.parent || void 0 !== this.dc || void 0 !== this.We || void 0 !== this.Yg || void 0 !== this.zf || void 0 !== this.Zg ? !1 : !0;
            }
            clone() {
              return new f(this);
            }
          }
          h.ae = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            AB(b) {
              if (this.nk(b)) return this.data[b];
            }
            Vt(b, a) {
              this.data || (this.data = {});
              this.data[b] = a;
            }
            Ora() {
              this.data && delete this.data._descendants_;
            }
            nk(b) {
              return this.data && this.data.hasOwnProperty(b);
            }
            zb(b) {
              for (var a in b) null != this[a] && (this[a] = b[a]);
            }
          }
          h.L9 = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.L9 {
            constructor(b, a) {
              super();
              this.A = b;
              this.caption = a;
            }
            set A(b) {
              this.KK = b;
            }
            get A() {
              return this.KK;
            }
            set caption(b) {
              e.v(b) && (b = "");
              b = "" + b;
              "" === b.trim() ? this.xc = e.model.B.j.Fl : this.xc = b;
            }
            get caption() {
              return e.model.Tb.valid(this.xc) ? this.xc : e.model.Tb.validate(this.xc);
            }
            get label() {
              return this.nk("_label") ? this.AB("_label") : this.caption;
            }
            set label(b) {
              "" != b.trim() && this.Vt("_label", b);
            }
            get V1() {
              return this.nk("_label");
            }
            toString() {
              return `{uniqueName: "${this.A}", caption: "${this.caption}"`;
            }
            Sa() {
              var b = {};
              b.uniqueName = this.A;
              b.caption = this.caption;
              return b;
            }
          }
          h.WE = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.WE {
            constructor(b, a, c) {
              super(b, a);
              this.U9 = !1;
              this.rO = c;
            }
            get rO() {
              return this.Msa;
            }
            set rO(b) {
              this.Msa = b;
            }
            get active() {
              return this.U9;
            }
            set active(b) {
              this.U9 = b;
            }
          }
          h.XW = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.WE {
            constructor(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              super(b, a);
              this.Cg = k.i.Fc.uv;
              this.gR = 0;
              this.$r = this.FQ = this.Ot = "";
              this.DB = !0;
              this.Lh = f.hJ;
              this.tR = null;
              this.mg = [];
              this.Kl = new u.dQ(!e.model.C.F.nw);
              this.Nv = new u.dQ(!e.model.C.F.nw);
              this.Zt = [];
              this.Wq = [];
              this.GB = !1;
              this.wy = {};
              this.sn = new e.ub();
              this.gZ = !1;
              this.MQ = !0;
              this.bR = this.aR = !1;
              this.mR = [];
              this.DQ = [];
              this.Cy = [];
              this.CB = {};
              this.lR = {};
              this.Pj = null;
              this.cache = [];
              this.fl = [];
              this.SF = [];
            }
            set zi(b) {
              this.KY = b;
            }
            get zi() {
              return this.KY;
            }
            get type() {
              return this.Cg;
            }
            set type(b) {
              this.Cg = b;
            }
            get origin() {
              return this.gR;
            }
            set origin(b) {
              this.gR = b;
              this.gZ = 1 == (b & 1);
            }
            get Vm() {
              return this.Kl.length;
            }
            set Vm(b) {}
            get Wi() {
              return this.Kl.length;
            }
            get Rd() {
              return this.GB;
            }
            set Rd(b) {
              this.GB = b;
            }
            get Oc() {
              return this.Ot;
            }
            set Oc(b) {
              "undefined" == b ? this.Ot = "" : this.Ot = b;
            }
            get Rh() {
              return this.DB;
            }
            set Rh(b) {}
            get mapping() {
              return k.Ma.R().fa.mapping;
            }
            get wa() {
              return this.sn;
            }
            set wa(b) {}
            get If() {
              return this.DZ;
            }
            set If(b) {
              this.DZ = b;
            }
            get description() {
              return this.Pj;
            }
            set description(b) {
              this.Pj = b;
            }
            get ZM() {
              const b = 2 < this.wa.length && this.type !== k.i.Fc.Ta ? this.wa.ea(1).A : this.zi.type === k.i.MA.YA ? this.zi.A : this.A;
              return e.model.Va.R().ja.fa.mapping.La(b, "filters");
            }
            Mh(b) {
              b.hierarchy = this;
              this.DB || b.yb++;
              this.sn.Ua(b.A, b);
              this.wy[b.A] = [];
            }
            nta(b) {
              b.hierarchy = this;
              this.DB || b.yb++;
              this.sn.SK(b.A, b, 1);
              for (var a = 2; a < this.sn.length; a++) {
                var c = this.sn.ea(a);
                c && c.yb++;
              }
              this.wy[b.A] = [];
            }
            Cu(b) {
              return this.sn.getItem(b);
            }
            get Bf() {
              return this.Ms || (this.Rh ? 2 < this.wa.length : 1 < this.wa.length);
            }
            set Bf(b) {}
            get Ue() {
              return "[Measures]" == this.A;
            }
            set Ue(b) {}
            get Ms() {
              return this.aR;
            }
            set Ms(b) {
              this.aR = b;
            }
            get XM() {
              return this.bR;
            }
            set XM(b) {
              this.bR = b;
            }
            get RS() {
              return this.MQ;
            }
            set RS(b) {
              this.MQ = b;
            }
            fz(b) {
              null != b && (b.Yg = !0, this.wy[b.level.A].push(b.ordinal));
            }
            y0(b) {
              b.Yg = !1;
              this.wy[b.level.A].splice(b.ordinal, 1);
              b = b.Bw;
              for (var a = 0; a < b.length; a++) {
                var c = this.za(b[a]);
                c.Yg && this.y0(c);
              }
            }
            OL(b) {
              return this.wy[b.A];
            }
            get Aca() {
              for (var b = 1; b < this.wa.length; b++) {
                var a = this.wa.ea(b);
                if (!(this.lc && a.yb < this.lc.yb) && 0 === this.OL(a).length) return b;
              }
              return 1;
            }
            set Aca(b) {}
            yta(b) {
              var a = void 0 === b.ordinal ? this.Kl.add(b.A) : this.Kl.add(b.A, b.ordinal);
              if (e.v(b.parent)) {
                if (e.v(b.Hi)) var c = this.wd;else c = this.Ib(b.Hi), null !== c ? this.Wq[a] = c.ordinal : c = this.wd;
              } else c = b.parent, this.Wq[a] = c.ordinal;
              void 0 !== b.fc && (this.Zt[a] = b.fc);
              void 0 !== b.caption && b.caption !== b.A && this.Nv.add(b.caption, a);
              c.X(a);
              this.WV(c);
              this.cache = [];
              this.fl = [];
              return a;
            }
            hD() {
              return new h.aJ(this);
            }
            oc(b) {
              if (b.G2) {
                var a = this.yta(b);
                return this.za(a);
              }
              var c = this.hD();
              void 0 !== b.parent && (c.parent = b.parent);
              void 0 === b.dc && void 0 === c.parent && (c.parent = e.ia(b.Hi) ? this.wd : this.Ib(b.Hi));
              c.parent && (e.v(c.level) || c.level.yb <= c.parent.level.yb) && (a = c.parent.level.yb + 1, a = new h.qv(c.parent.level.A + " " + a, this.caption + " " + a, a), this.Mh(a), this.Ms = !0);
              void 0 !== b.ordinal ? (this.Kl.add(b.A, b.ordinal), c.ordinal = b.ordinal) : (a = this.Kl.add(b.A), c.ordinal = a);
              void 0 !== b.fc && (this.Zt[c.ordinal] = b.fc, c.fc = b.fc);
              this.mg[c.ordinal] = c;
              void 0 !== b.caption && this.Nv.add(b.caption, c.ordinal);
              null != c.parent && (c.parent.X(c), this.Wq[c.ordinal] = c.parent.ordinal, this.WV(c.parent));
              e.v(b.Zg) || (c.Zg = b.Zg);
              this.cache = [];
              this.fl = [];
              return c;
            }
            WV(b) {
              this.mg[b.ordinal] = b;
            }
            Rha(b) {
              null != b && void 0 !== b.ordinal && (void 0 !== b.fc && (this.Zt[b.ordinal] = b.fc), void 0 !== b.caption && this.Nv.add(b.caption, b.ordinal), void 0 !== b.A && this.Kl.add(b.A, b.ordinal));
            }
            VS(b) {
              b = this.Nv.find(b);
              return -1 === b ? null : this.za(b);
            }
            Ib(b) {
              b = this.sz("" + b);
              return -1 < b ? this.za(b) : null;
            }
            sz(b) {
              var a = this.Kl.find(b);
              -1 === a && this.Bf && (a = this.Kl.find(`[${b}]`));
              return a;
            }
            za(b) {
              if (void 0 === this.mg[b]) {
                var a = this.hD();
                a.ordinal = b;
                a.fc = this.Zt[b];
                a.parent = this.Wq[b] ? this.za(this.Wq[b]) : this.wd;
                return a;
              }
              return this.mg[b];
            }
            vM(b) {
              return this.Zt[b];
            }
            Du(b) {
              if (e.model.C.F.ir && (null === b || "null" === b)) return b = this.sz("null"), 0 <= b ? this.za(b) : null;
              "number" !== typeof b && (b = parseFloat(b));
              if (isNaN(b)) for (var a = 1; a < this.Zt.length; a++) if (isNaN(this.Zt[a])) return this.za(a);
              b = this.Zt.indexOf(b);
              return 0 <= b ? this.za(b) : null;
            }
            nr(b) {
              for (var a = [], c, d = 0; d < b.length; d++) c = this.za(b[d]), e.v(c) || e.ia(c.Ci) || a.push(c.Ci);
              return a;
            }
            A1(b) {
              return this.Kl.get(b);
            }
            gD(b) {
              var a = this.Nv.get(b);
              void 0 === a && (a = this.Kl.get(b));
              e.model.Tb.valid(a) || (a = e.model.Tb.validate(a));
              return a;
            }
            Fha(b) {
              let a;
              a = this.type !== k.i.Fc.Ta || this.wa.ea(1).type !== k.i.ib.Ta && this.wa.ea(1).type !== k.i.ib.Lc ? this.wa.ea(1).type === k.i.ib.ic ? this.nJa(b) : this.sz(b) : this.mJa(b);
              -1 === a && !e.v(b) && 0 < b.indexOf(".") && (b = b.substring(b.lastIndexOf(".") + 1), a = this.sz(b));
              return a;
            }
            mJa(b) {
              if (e.model.C.F.ir && "null" === b) b = null;else if (8 > b.length || /\D+/.test(b.slice(1))) {
                var a = this.wa.ea(1).type === k.i.ib.Lc ? e.model.C.F.zk : e.model.C.F.Lp;
                a = this.mapping.La(this.A, "format", a);
                b = new e.gh(b, {
                  Gy: !1,
                  format: a
                });
                b.uh(u.Eh.qg(a));
                b = b.getTime();
              } else b = parseInt(b);
              b = this.Du(b);
              return null === b ? -1 : b.ordinal;
            }
            nJa(b) {
              if (e.model.C.F.ir && "null" === b) var a = null;else if (0 <= b.indexOf(":")) {
                if (b = b.split(":"), 3 == b.length) {
                  a = 0;
                  if (0 <= b[0].indexOf("d")) {
                    var c = b[0].split("d");
                    const d = parseInt(c[0]);
                    isNaN(d) || (a += 86400 * d);
                    c = parseInt(c[1]);
                    isNaN(c) || (a += 3600 * c);
                  } else c = parseInt(b[0]), isNaN(c) || (a += 3600 * c);
                  c = parseInt(b[1]);
                  isNaN(c) || (a += 60 * c);
                  b = parseInt(b[2]);
                  isNaN(b) || (a += b);
                }
              } else a = parseFloat(b);
              b = this.Du(a);
              return null === b ? -1 : b.ordinal;
            }
            w_() {
              this.eg = f.hJ;
              this.IK = null;
            }
            x_() {
              this.cache = [];
            }
            get eg() {
              return this.Lh;
            }
            set eg(b) {
              this.Lh = b;
            }
            get rW() {
              return this.tR;
            }
            set rW(b) {
              this.tR = b;
            }
            sort() {
              return this.ck(this.wd);
            }
            ck(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
              if (null == b) return [];
              k.i.Aa.ah(c) || (c = this.Lh);
              if (a) {
                if (null != this.fl[b.ordinal]) {
                  if (null != this.fl[b.ordinal][c]) return this.fl[b.ordinal][c];
                  if (!this.Bf) {
                    if (c == k.i.Aa.Mc && null != this.fl[b.ordinal][k.i.Aa.kc]) return a = this.fl[b.ordinal][k.i.Aa.kc].slice(), this.fl[b.ordinal][k.i.Aa.Mc] = a.reverse(), this.fl[b.ordinal][k.i.Aa.Mc];
                    if (c == k.i.Aa.kc && null != this.fl[b.ordinal][k.i.Aa.Mc]) return a = this.fl[b.ordinal][k.i.Aa.Mc].slice(), this.fl[b.ordinal][k.i.Aa.kc] = a.reverse(), this.fl[b.ordinal][k.i.Aa.kc];
                  }
                }
              } else if (null != this.cache[b.ordinal]) {
                if (null != this.cache[b.ordinal][c]) return this.cache[b.ordinal][c];
                if (!this.Bf) {
                  if (c == k.i.Aa.Mc && null != this.cache[b.ordinal][k.i.Aa.kc]) return a = this.cache[b.ordinal][k.i.Aa.kc].slice(), this.cache[b.ordinal][k.i.Aa.Mc] = a.reverse(), this.cache[b.ordinal][k.i.Aa.Mc];
                  if (c == k.i.Aa.kc && null != this.cache[b.ordinal][k.i.Aa.Mc]) return a = this.cache[b.ordinal][k.i.Aa.Mc].slice(), this.cache[b.ordinal][k.i.Aa.kc] = a.reverse(), this.cache[b.ordinal][k.i.Aa.kc];
                }
              }
              var d = this.Lh;
              this.Lh = c;
              if (this.Lh == k.i.Aa.ed) {
                var g = a ? b.Bw : b.children;
                g = g.slice();
                0 < g.length && this.za(g[0]).dc && g.splice(0, 1);
              } else g = this.sW(b, a);
              a ? (null == this.fl[b.ordinal] && (this.fl[b.ordinal] = []), this.fl[b.ordinal][c] = g) : (null == this.cache[b.ordinal] && (this.cache[b.ordinal] = []), this.cache[b.ordinal][c] = g);
              this.Lh = d;
              return g;
            }
            hsa(b) {
              for (var a = [[]], c, d = 0; d < b.length; d++) 0 !== b[d] && (c = this.Wq[b[d]], void 0 === c ? a[0].push(b[d]) : (void 0 === a[c] && (a[c] = []), a[c].push(b[d])));
              return a;
            }
            Gsa(b, a) {
              if (e.v(this.IK) || void 0 === this.IK[b.ordinal] || b.children.length != this.IK[b.ordinal].length) {
                var c = this.Kl.sort();
                this.IK = this.hsa(c);
              }
              b = this.IK[b.ordinal];
              c = [];
              for (var d = 0; d < b.length; d++) {
                var g = this.za(b[d]);
                c.push(g.ordinal);
                a && !g.Sh && (g = this.ck(g), 0 < g.length && (c = c.concat(g)));
              }
              return c;
            }
            Pua(b) {
              try {
                if ("month" === b.level.caption.toLowerCase()) return !0;
                if (12 < b.children.length) return !1;
                for (var a = 0; a < b.children.length; a++) {
                  var c = this.za(b.children[a]).caption.split(" ")[0];
                  if (-1 === e.model.B.j.Ur.indexOf(c) && -1 === e.model.B.j.iy.indexOf(c)) return !1;
                }
                var d = b.hierarchy.wa.indexOf(b.level.A);
                if (b.hierarchy.wa.length < d + 2) return !1;
                b.hierarchy.wa.ea(d + 1).type = k.i.ib.ih;
                return !0;
              } catch (g) {}
              return !1;
            }
            sW(b, a) {
              var c = this.wa.ea(b.level.yb + 1),
                d = c && c.type === k.i.ib.Jl,
                g = c && c.type === k.i.ib.IX,
                l = c && c.type === k.i.ib.Ct,
                m = c && c.type === k.i.ib.ih,
                n = c && c.type === k.i.ib.fK,
                p = c && (c.type === k.i.ib.en || c.type === k.i.ib.kn),
                t = c && c.type === k.i.ib.jP,
                r = c && c.type === k.i.ib.IP,
                w = c && c.type === k.i.ib.jb,
                y = c && c.type === k.i.ib.ic || c && c.type === k.i.ib.Ta,
                A = c && c.type === k.i.ib.Lc,
                B = this.rW === k.i.Aa.ipa;
              if (!(l || m || n || y || p || t || r || w || A || 0 !== this.Co.length || e.Kg(this.nx))) {
                if (1E3 < b.children.length) return this.Gsa(b, a);
                this.Pua(b) && (m = !0);
              }
              var C = this.lja(b.children);
              e.Kg(this.nx) ? C = this.Pia(C) : l || m || n || p || t || r || A || g || d ? C = this.GKa(C, c ? c.type : -1) : y ? 0 < this.Co.length ? C.sort((I, L) => this.axa(I, L)) : C = this.DKa(C) : 0 < this.Co.length ? C.sort((I, L) => this.$wa(I, L)) : w ? (this.Lh === k.i.Aa.kc && e.Ja.sort(C, e.Ja.Qi, I => I.fc), this.Lh === k.i.Aa.Mc && e.Ja.sort(C, e.Ja.lp | e.Ja.Qi, I => I.fc)) : B ? C.sort(this.EEa) : (this.Lh === k.i.Aa.kc && e.Ja.sort(C, e.Ja.Ux, I => I.caption), this.Lh === k.i.Aa.Mc && e.Ja.sort(C, e.Ja.lp | e.Ja.Ux, I => I.caption));
              c = [];
              g = C.length;
              for (l = 0; l < g; l++) c.push(C[l].ordinal), a && !b.Sh && (d = this.ck(C[l], a), 0 < d.length && (c = c.concat(d)));
              return c;
            }
            lja(b) {
              for (var a = [], c = 0; c < b.length; c++) a.push(this.za(b[c]));
              return a;
            }
            GKa(b, a) {
              a === k.i.ib.ih ? b = this.FKa(b) : a === k.i.ib.en || a === k.i.ib.kn ? b = this.HKa(b) : a === k.i.ib.Ct || a === k.i.ib.IX || a === k.i.ib.Jl ? (this.eg === k.i.Aa.kc && e.Ja.sort(b, e.Ja.Ux, c => c.caption), this.eg === k.i.Aa.Mc && e.Ja.sort(b, e.Ja.lp | e.Ja.Ux, c => c.caption)) : (this.eg === k.i.Aa.kc && e.Ja.sort(b, e.Ja.Qi, c => c.fc), this.eg === k.i.Aa.Mc && e.Ja.sort(b, e.Ja.lp | e.Ja.Qi, c => c.fc));
              return b;
            }
            FKa(b) {
              for (var a = [], c = [], d = 0; d < b.length; ++d) this.Lra(b[d].caption) ? c.push(b[d]) : a.push(b[d]);
              this.eg === k.i.Aa.kc && e.Ja.sort(a, e.Ja.Ux, g => g.caption);
              this.eg === k.i.Aa.Mc && e.Ja.sort(a, e.Ja.lp | e.Ja.Ux, g => g.caption);
              c.sort((g, l) => this.ixa(g, l));
              return c.concat(a);
            }
            HKa(b) {
              for (var a = [], c = [], d = 0; d < b.length; ++d) this.Mra(b[d].caption) ? c.push(b[d]) : a.push(b[d]);
              this.eg === k.i.Aa.kc && e.Ja.sort(a, e.Ja.Ux | e.Ja.Qi, g => g.caption);
              this.eg === k.i.Aa.Mc && e.Ja.sort(a, e.Ja.lp | e.Ja.Ux | e.Ja.Qi, g => g.caption);
              c.sort((g, l) => this.GLa(g, l));
              return c.concat(a);
            }
            Lra(b) {
              return -1 !== e.model.B.j.Ur.indexOf(b) || -1 !== e.model.B.j.iy.indexOf(b);
            }
            Mra(b) {
              return -1 !== e.model.B.j.oB.indexOf(b) || -1 !== e.model.B.j.pB.indexOf(b);
            }
            ixa(b, a) {
              var c = this.eg === k.i.Aa.kc ? e.model.B.j.Ur.indexOf(b.caption) : e.model.B.j.Ur.indexOf(a.caption);
              -1 === c && (c = this.eg == k.i.Aa.kc ? e.model.B.j.iy.indexOf(b.caption) : e.model.B.j.iy.indexOf(a.caption));
              var d = this.eg === k.i.Aa.kc ? e.model.B.j.Ur.indexOf(a.caption) : e.model.B.j.Ur.indexOf(b.caption);
              -1 === d && (d = this.eg === k.i.Aa.kc ? e.model.B.j.iy.indexOf(a.caption) : e.model.B.j.iy.indexOf(b.caption));
              return c > d ? 1 : c < d ? -1 : 0;
            }
            GLa(b, a) {
              var c = this.eg === k.i.Aa.kc ? e.model.B.j.oB.indexOf(b.caption) : e.model.B.j.oB.indexOf(a.caption);
              -1 === c && (c = this.eg === k.i.Aa.kc ? e.model.B.j.pB.indexOf(b.caption) : e.model.B.j.pB.indexOf(a.caption));
              var d = this.eg === k.i.Aa.kc ? e.model.B.j.oB.indexOf(a.caption) : e.model.B.j.oB.indexOf(b.caption);
              -1 === d && (d = this.eg === k.i.Aa.kc ? e.model.B.j.pB.indexOf(a.caption) : e.model.B.j.pB.indexOf(b.caption));
              return c > d ? 1 : c < d ? -1 : 0;
            }
            DKa(b) {
              this.Lh === k.i.Aa.kc && e.Ja.sort(b, e.Ja.Qi, a => a.fc);
              this.Lh === k.i.Aa.Mc && e.Ja.sort(b, e.Ja.Qi | e.Ja.lp, a => a.fc);
              return b;
            }
            uT(b) {
              return e.model.C.F.nw ? this.Co.indexOf(b) : this.Co.indexOf(b.toLocaleLowerCase());
            }
            $wa(b, a) {
              const c = this.Lh === k.i.Aa.kc ? this.uT(b.caption) : this.uT(a.caption);
              b = this.Lh === k.i.Aa.kc ? this.uT(a.caption) : this.uT(b.caption);
              return c > b ? 1 : c < b ? -1 : 0;
            }
            axa(b, a) {
              const c = this.Lh === k.i.Aa.kc ? this.Co.indexOf(b.fc.toString()) : this.Co.indexOf(a.fc.toString());
              b = this.Lh === k.i.Aa.kc ? this.Co.indexOf(a.fc.toString()) : this.Co.indexOf(b.fc.toString());
              return c > b ? 1 : c < b ? -1 : 0;
            }
            Pia(b) {
              if (e.Kg(this.nx)) {
                var a = this.Lh === k.i.Aa.Mc ? -1 : 1;
                b.sort((c, d) => this.nx(c.caption, d.caption) * a);
              }
              return b;
            }
            EEa(b, a) {
              b = b.caption.match(/(?:\d*\.)?\d+/);
              a = a.caption.match(/(?:\d*\.)?\d+/);
              b = b && 0 < b.length ? parseFloat(b[0]) : Number.POSITIVE_INFINITY;
              a = a && 0 < a.length ? parseFloat(a[0]) : Number.POSITIVE_INFINITY;
              return b > a ? 1 : b < a ? -1 : 0;
            }
            av(b) {
              b = this.sn.getItem(b).yb;
              for (var a = [], c = this.sort(), d = 0; d < c.length; d++) {
                var g = this.za(c[d]);
                g && g.level.yb === b && a.push(c[d]);
              }
              return a;
            }
            get filter() {
              e.v(this.Sv) && (this.Sv = new e.model.hb.TA(this));
              return this.Sv;
            }
            set filter(b) {
              this.Sv = b;
              this.SF = [];
            }
            get cb() {
              return 0 < this.SF.length ? this.SF : this.SF = this.filter.xz || this.filter.Ww || this.filter.LM || this.filter.VT ? this.filter.zya() : this.filter.yj();
            }
            set cb(b) {
              this.SF = b;
            }
            mu() {
              this.filter.clear();
              this.cb = [];
            }
            oC() {
              this.filter.oC();
              this.cb = [];
            }
            tya() {
              for (var b = [], a = this.cb, c = 0; c < a.length; c++) {
                var d = this.za(a[c]);
                1 === d.level.yb && b.push(d.ordinal);
              }
              return b;
            }
            set Am(b) {
              "" !== b && !e.v(b) || this.Ue ? this.$r = b : (this.$r = this.A + ".[(All)]", this.Mh(new h.qv(this.A, this.caption + " (All)")), this.oc(new h.ae({
                A: this.caption + " (All)",
                dc: !0
              })), this.DB = !1);
            }
            get Am() {
              return this.$r;
            }
            zm() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "(Total)";
              return b;
            }
            get wd() {
              this.AY || (this.AY = this.Ib(this.$r), this.fz(this.AY));
              return this.AY;
            }
            set wd(b) {}
            get Bs() {
              return this.FQ;
            }
            set Bs(b) {
              this.FQ = b;
            }
            tw() {
              this.Raa(this.y4);
              this.filter.tw();
            }
            vba() {
              if (0 < this.Cy.length) {
                for (var b = 0; b < this.Cy.length; b++) {
                  var a = this.za(parseInt(this.Cy[b]));
                  null == a || a.Yg || this.fz(a);
                }
                this.Cy = [];
              }
            }
            set y4(b) {
              this.lR = b;
            }
            get y4() {
              return this.lR;
            }
            set cha(b) {
              this.mR = b;
            }
            get cha() {
              return this.mR;
            }
            set Co(b) {
              this.x_();
              this.DQ = b;
            }
            get Co() {
              return this.DQ;
            }
            set kv(b) {
              this.Cy = b;
            }
            get kv() {
              return this.Cy;
            }
            set groups(b) {
              this.CB = b;
            }
            get groups() {
              return this.CB;
            }
            Raa(b) {
              if (this.groups) for (var a in this.groups) this.mO(a);
              for (a in b) this.yaa(a, b[a]);
            }
            mO(b) {
              var a = this.Ib(this.zm("Others"));
              if ((b = "string" == typeof b ? this.Ib(this.zm(b)) : b) && a) {
                var c,
                  d = b.children;
                for (c = 0; c < d.length; c++) {
                  var g = this.za(d[c]);
                  a.X(g);
                  this.Wq[g.ordinal] = a.ordinal;
                }
                this.wd.removeChild(b.ordinal);
                this.mg[b.ordinal] = null;
                delete this.CB[b.caption];
                if (1 == this.av(this.vz.A).length) {
                  d = a.children;
                  for (c = 0; c < d.length; c++) g = this.za(d[c]), this.wd.X(g), this.Wq[g.ordinal] = this.wd.ordinal;
                  this.wd.removeChild(a.ordinal);
                  this.mg[a.ordinal] = null;
                  this.sn = this.sn.splice(1, 1);
                  for (c = 1; c < this.sn.length; c++) this.sn.ea(c).yb--;
                }
                this.cache = [];
                this.fl = [];
              }
            }
            yaa(b, a) {
              null != this.groups[b] && this.mO(b);
              if (null == this.vz) {
                var c = new h.qv(this.caption + ".groups", "Groups", 1);
                c.Zg = !0;
                this.nta(c);
                var d = this.wd.children.slice(0),
                  g = this.oc(new h.ae({
                    A: "others",
                    caption: "Others"
                  }));
                for (c = 0; c < d.length; c++) {
                  var l = this.za(d[c]);
                  this.wd.removeChild(l.ordinal);
                  g.X(l.ordinal);
                  l.parent = g;
                  this.Wq[l.ordinal] = g.ordinal;
                }
              } else this.wa.ea(1);
              d = this.oc(new h.ae({
                A: b,
                Zg: !0
              }));
              this.CB[b] = [];
              for (c = 0; c < this.Kl.length; c++) g = this.za(c), g.hierarchy = this, !g.dc && -1 < a.indexOf(g.ordinal) && (g.Zg ? this.mO(g) : (g.parent && g.parent.removeChild(g.ordinal), d.X(g), this.CB[b].push(g.ordinal), this.Wq[g.ordinal] = d.ordinal));
              for (var m in this.groups) this.groups.hasOwnProperty(m) || (g = this.Ib(this.zm(m))) && 0 == g.children.length && this.mO(g);
              this.fz(d);
              this.cache = [];
              this.fl = [];
            }
            get vz() {
              for (var b = 0; b < this.wa.length; b++) if (this.wa.ea(b).Zg) return this.wa.ea(b);
              return null;
            }
            set vz(b) {}
            get LU() {
              for (var b = new e.ub(), a = 0; a < this.sn.length; a++) {
                var c = this.sn.ea(a).We;
                b = b.concat(c);
              }
              return b;
            }
            set LU(b) {}
            set xf(b) {
              this.iK = b;
            }
            get xf() {
              return this.iK;
            }
            set lc(b) {}
            get lc() {
              return null != this.iK ? this.Cu(this.iK) : null;
            }
            get nx() {
              return this.ssa;
            }
            set nx(b) {
              this.x_();
              this.ssa = b;
            }
            get P1() {
              return e.Kg(this.nx) || 0 < this.Co.length;
            }
            get qs() {
              for (var b = [], a = 0; a < this.Wi; a++) b.push(a);
              return b;
            }
            Sa() {
              var b = {};
              b.uniqueName = this.A;
              b.dimensionName = this.zi.A;
              b.activeLevelName = this.xf;
              b.caption = this.caption;
              b.filterEnabled = this.RS;
              b.sortName = this.eg;
              b.sortAs = this.rW;
              b.type = this.type;
              b.groups = this.groups;
              b.customSorting = this.Co;
              this.filter.zh && !this.filter.cfa && (b.filter = this.filter.Sa());
              void 0 !== this.If && (b.showTotals = this.If);
              return b;
            }
            ij() {
              const b = {};
              b.caption = this.caption;
              b.dimensionCaption = this.zi.caption;
              b.dimensionUniqueName = this.zi.A;
              b.folder = this.Oc;
              b.label = this.label;
              if (2 < this.wa.length) {
                b.levels = [];
                for (let a = 1; a < this.wa.length; a++) b.levels.push(this.wa.ea(a).Sa());
              }
              b.sort = this.Lh;
              b.uniqueName = this.A;
              return b;
            }
            static zb(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var c = b.uniqueName;
              c = k.we.Wg(c, b.caption);
              null == a && (a = new k.local.O.wP(c));
              b.hasOwnProperty("caption") && (a.caption = b.caption);
              b.hasOwnProperty("groups") && f.KBa(b.groups, a);
              b.hasOwnProperty("sortName") && (a.eg = b.sortName);
              b.hasOwnProperty("sortAs") && (a.rW = b.sortAs);
              b.hasOwnProperty("filterEnabled") && (a.RS = b.filterEnabled);
              b.hasOwnProperty("type") && (a.type = b.type);
              b.hasOwnProperty("origin") && (a.origin = b.origin);
              b.hasOwnProperty("folder") && (a.Oc = b.folder);
              b.hasOwnProperty("filter") && (a.filter = e.model.hb.TA.zb(b.filter, a, !0));
              b.hasOwnProperty("defaultMemberName") && (a.Bs = b.defaultMemberName);
              b.hasOwnProperty("allMemberName") && (a.Am = b.allMemberName);
              b.hasOwnProperty("activeLevelName") && (a.xf = b.activeLevelName);
              b.hasOwnProperty("predefinedProperties") && (a.cha = b.predefinedProperties);
              b.hasOwnProperty("customSorting") && f.Vba(b.customSorting, a);
              b.hasOwnProperty("sortOrder") && f.Vba(b.sortOrder, a);
              b.hasOwnProperty("showTotals") && (a.If = !0 === b.showTotals);
              return a;
            }
            static KBa(b, a) {
              var c = {},
                d;
              for (d in b) {
                var g = b[d];
                c[d] = [];
                for (var l = 0; l < g.length; l++) {
                  var m = k.we.Ps(g[l]);
                  (m = a.Ib(m)) && c[d].push(m.ordinal);
                }
              }
              a.Rd ? a.Raa(c) : a.y4 = c;
            }
            static Vba(b, a) {
              a.Co = [];
              for (var c = 0; c < b.length; c++) a.Co.push(k.we.Ps(b[c]));
            }
            clone() {
              var b = new f(this.A);
              b.data = this.data;
              b.KK = this.KK;
              b.KY = this.KY;
              b.Cg = this.Cg;
              b.gR = this.gR;
              b.Ot = this.Ot;
              b.FQ = this.FQ;
              b.$r = this.$r;
              b.DB = this.DB;
              b.Lh = this.Lh;
              b.tR = this.tR;
              e.v(this.Sv) || (b.Sv = this.Sv.clone());
              b.mg = this.mg.slice();
              b.Kl = this.Kl.clone();
              b.Nv = this.Nv.clone();
              b.Zt = this.Zt.slice();
              b.Wq = this.Wq.slice();
              var a = {},
                c;
              for (c in this.wy) a[c] = this.wy[c].slice();
              b.wy = a;
              b.sn = this.sn.slice();
              b.gZ = this.gZ;
              b.MQ = this.MQ;
              b.Rd = this.Rd;
              b.aR = this.aR;
              b.bR = this.bR;
              b.mR = this.mR.slice();
              b.DQ = this.DQ.slice();
              b.Cy = this.Cy.slice();
              b.iK = this.iK;
              b.CB = this.CB;
              b.lR = this.lR;
              b.DZ = this.DZ;
              return b;
            }
            getTimezoneOffset() {
              return null;
            }
          }
          f.hJ = "asc";
          h.rt = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.WE {
            constructor(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              super(b, a);
              this.Cg = k.i.ib.$c;
              this.Z$ = new e.ub();
              this.Pj = null;
              this.pZ = c;
            }
            set yb(b) {
              this.pZ = b;
            }
            get yb() {
              return this.pZ;
            }
            set type(b) {
              this.Cg = b;
            }
            get type() {
              return this.Cg;
            }
            set Zg(b) {
              this.jsa = b;
            }
            get Zg() {
              return this.jsa;
            }
            get Su() {
              return this.Ac.wa.length - 1 == this.pZ;
            }
            set Su(b) {}
            set hierarchy(b) {
              this.Ac = b;
            }
            get hierarchy() {
              return this.Ac;
            }
            get We() {
              return this.Z$;
            }
            set We(b) {}
            get description() {
              return this.Pj;
            }
            set description(b) {
              this.Pj = b;
            }
            $Z(b) {
              this.Z$.Ua(b.A, b);
            }
          }
          h.qv = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.L9 {
            constructor(b) {
              super();
              this.qZ = 1;
              this.Q$ = 0;
              this.fR = -1;
              this.Ac = b;
            }
            get ordinal() {
              return this.qZ;
            }
            set ordinal(b) {
              this.qZ = b;
            }
            get fc() {
              return this.Q$;
            }
            set fc(b) {
              this.Q$ = b;
            }
            get hierarchy() {
              return this.Ac;
            }
            set hierarchy(b) {}
            get parent() {
              return this.Csa;
            }
            set parent(b) {
              this.Csa = b;
            }
            get root() {
              if (2 > this.level.yb) return this;
              var b = this;
              do b = b.parent; while (1 < b.level.yb);
              return b;
            }
            set root(b) {}
            set caption(b) {}
            get caption() {
              var b = this.Ac.gD(this.ordinal);
              if (this.level.type === k.i.ib.Ta || this.level.type === k.i.ib.lj || this.level.type === k.i.ib.Lc || this.level.type === k.i.ib.ic) {
                let a = this.Ac.vM(this.ordinal);
                e.v(a) ? b = e.model.B.j.hX : this.level.type === k.i.ib.Ta || this.level.type === k.i.ib.lj ? (b = this.hierarchy.zk || this.hierarchy.mapping.La(this.hierarchy.A, "format", e.model.C.F.Lp), b = e.P.Kx(a, b, e.model.C.F.Uj)) : this.level.type === k.i.ib.Lc ? (b = this.hierarchy.zk || this.hierarchy.mapping.La(this.hierarchy.A, "format", e.model.C.F.zk), b = e.P.iO(a, b, e.model.C.F.Uj)) : this.level.type === k.i.ib.ic && (b = this.hierarchy.zk || this.hierarchy.mapping.La(this.hierarchy.A, "format", e.model.C.F.ep), b = e.P.Lx(a, b));
              }
              return b;
            }
            get A() {
              return this.iD();
            }
            set A(b) {}
            iD() {
              return this.Ac.A1(this.ordinal);
            }
            get Ci() {
              var b = this.Ac.Bf ? 2 > this.level.yb ? `[${this.iD()}]` : this.iD() : `[${this.iD()}]`;
              return e.model.C.F.nw ? `${this.hierarchy.A}.${b}` : `${this.hierarchy.A}.${b}`.toLocaleLowerCase();
            }
            get level() {
              return e.v(this.parent) ? this.hierarchy.wa.ea(0) : this.hierarchy.wa.ea(this.parent.level.yb + 1);
            }
            set level(b) {}
            get dc() {
              return null != this.hierarchy.wd && this.hierarchy.wd.ordinal == this.ordinal;
            }
            set dc(b) {}
            set Yg(b) {
              this.Vt("_isDrilledDown_", b);
            }
            get Yg() {
              return this.nk("_isDrilledDown_") ? this.AB("_isDrilledDown_") : !1;
            }
            set Zg(b) {
              this.Vt("_isGroup_", b);
            }
            get Zg() {
              return this.nk("_isGroup_") ? this.AB("_isGroup_") : !1;
            }
            get children() {
              return this.nk("_children_") ? this.AB("_children_") : [];
            }
            set children(b) {}
            set Bw(b) {}
            get Bw() {
              if (this.nk("_descendants_")) return this.AB("_descendants_");
              var b = [];
              b.push(this.ordinal);
              if (0 == this.XU) return b;
              for (var a = this.children.length, c, d = 0; d < a; d++) c = this.hierarchy.za(this.children[d]), c.Sh ? b.push(c.ordinal) : 0 < c.XU ? b = b.concat(c.Bw) : b.push(c.ordinal);
              0 < b.length && this.Vt("_descendants_", b);
              return b;
            }
            set XU(b) {}
            get XU() {
              if (-1 < this.fR) return this.fR;
              if (!this.nk("_children_")) return this.fR = 0;
              for (var b = this.children.length, a = b, c = 0; c < b; c++) {
                var d = this.hierarchy.za(this.children[c]);
                a += d.XU;
              }
              return a;
            }
            u_() {
              this.nk("_descendants_") && this.Ora();
              this.parent && this.parent.u_();
            }
            X(b) {
              var a = this.children;
              b.constructor === Number ? a.push(b) : a.push(b.ordinal);
              this.Vt("_children_", a);
              b.constructor !== Number && (b.parent = this);
              this.fR = -1;
              this.u_();
            }
            removeChild(b) {
              var a = this.children.indexOf(b);
              -1 < a && this.children.splice(a, 1);
              this.Vt("_children_", this.children);
              this.hierarchy.za(b).parent = null;
              this.u_();
            }
            toString() {
              return this.A + " : " + this.qZ;
            }
            set We(b) {
              this.Vt("_properties_", b);
            }
            get We() {
              this.nk("_properties_") || (this.We = new e.ub());
              return this.AB("_properties_");
            }
            setProperty(b, a) {
              this.We.Ua(b, a);
            }
            iBa(b) {
              return this.We.getItem(b);
            }
            get Sh() {
              return !this.nk("_children_") || 0 == this.children.length;
            }
            set Sh(b) {}
            get zf() {
              return this.nk("_hasMissingChildren_") ? this.AB("_hasMissingChildren_") : !1;
            }
            set zf(b) {
              this.Vt("_hasMissingChildren_", b);
            }
            set Kaa(b) {}
            get Kaa() {
              return this.hierarchy.Ms ? this.A : this.A + ".[(Total" + (0 == this.ordinal ? "" : this.ordinal) + ")]";
            }
            Vt(b, a) {
              super.Vt(b, a);
              this.G2 || e.v(this.hierarchy) || this.hierarchy.WV(this);
            }
            get G2() {
              if (this.nk("_children_") || this.nk("_descendants_") || this.nk("_caption_") || this.nk("_isDrilledDown_") || this.nk("_hasMissingChildren_") || this.nk("_properties_") || this.nk("_isGroup_")) return !1;
            }
            Sa() {
              var b = {};
              b.uniqueName = this.A;
              b.caption = this.caption;
              b.dimensionName = this.hierarchy.zi.A;
              b.hierarchyName = this.hierarchy.A;
              b.hierarchyCaption = this.hierarchy.caption;
              this.parent && (b.parentMember = this.parent.A);
              0 < this.We.length && (b.properties = this.We.Sa());
              return b;
            }
            aH(b) {
              return e.v(b) ? !1 : e.model.C.F.nw ? this.A == b : this.A.toLocaleLowerCase() == b.toLocaleLowerCase();
            }
          }
          h.aJ = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.WE {
            constructor(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              super(b, a);
              this.ac = this.Ot = this.UQ = "";
              this.Cg = k.i.Qa.jb;
              this.lk = this.JF = this.Tv = "";
              this.Kb = [];
              this.PQ = "";
              this.VQ = this.WQ = !1;
              this.ZF = "";
              this.E$ = -1;
              this.$Q = this.ZQ = !1;
              this.sQ = !0;
              this.Pj = this.Xv = null;
              this.mn = [];
            }
            get rl() {
              return this.xc;
            }
            set rl(b) {}
            get Ig() {
              return this.UQ;
            }
            set Ig(b) {
              this.UQ = b;
            }
            get Oc() {
              return this.Ot;
            }
            set Oc(b) {
              this.Ot = b;
            }
            get mapping() {
              return k.Ma.R().fa.mapping;
            }
            get format() {
              return this.ci(this.A, this.aa).name;
            }
            set format(b) {
              this.ac = b;
            }
            get Gk() {
              return this.WQ;
            }
            set Gk(b) {
              this.WQ = b;
            }
            get hidden() {
              return this.VQ;
            }
            set hidden(b) {
              this.VQ = b;
            }
            get index() {
              return this.E$;
            }
            set index(b) {
              this.E$ = b;
            }
            get type() {
              return this.Cg;
            }
            get Pm() {
              return this.Xv;
            }
            set Pm(b) {
              this.Xv = b;
            }
            set type(b) {
              this.Cg = b;
            }
            get description() {
              return this.Pj;
            }
            set description(b) {
              this.Pj = b;
            }
            get dk() {
              if (this.Oa || this.$g) return [];
              const b = this.mapping.Bp;
              if (e.v(b)) return this.Cg != k.i.Qa.jb && this.Cg != k.i.Qa.ic ? this.Cg == k.i.Qa.Ta || this.Cg == k.i.Qa.Lc ? k.i.da.fka : k.i.da.ika : k.i.da.UI;
              const a = k.i.Qa.oA(this.Cg);
              return void 0 !== b[a] ? b[a] : void 0 !== b.any ? b.any : Array.isArray(b) ? b : k.i.da.UI;
            }
            set dk(b) {}
            set Xp(b) {
              this.Tv = b;
            }
            get Xp() {
              return this.Tv ? this.Tv : 0 == e.model.C.F.Fx ? this.xc : k.i.da.NONE === this.lk ? this.xc : f.p1(this.aa, this.xc);
            }
            static p1(b, a) {
              switch (b) {
                case k.i.da.Mq:
                  return e.P.bind(e.model.B.j.rqa, a);
                case k.i.da.zc:
                  return e.P.bind(e.model.B.j.ila, a);
                case k.i.da.Bt:
                  return e.P.bind(e.model.B.j.Hpa, a);
                case k.i.da.mj:
                  return e.P.bind(e.model.B.j.Ila, a);
                case k.i.da.Bq:
                  return e.P.bind(e.model.B.j.jka, a);
                case k.i.da.Av:
                  return e.P.bind(e.model.B.j.soa, a);
                case k.i.da.Gv:
                  return e.P.bind(e.model.B.j.nqa, a);
                case k.i.da.Hv:
                  return e.P.bind(e.model.B.j.pqa, a);
                case k.i.da.MAX:
                  return e.P.bind(e.model.B.j.Yna, a);
                case k.i.da.MIN:
                  return e.P.bind(e.model.B.j.Woa, a);
                case k.i.da.Vr:
                  return e.P.bind(e.model.B.j.zpa, a);
                case k.i.da.tp:
                  return e.P.bind(e.model.B.j.upa, a);
                case k.i.da.Kq:
                  return e.P.bind(e.model.B.j.Fpa, a);
                case k.i.da.Iq:
                  return e.P.bind(e.model.B.j.Bpa, a);
                case k.i.da.Jq:
                  return e.P.bind(e.model.B.j.Dpa, a);
                case k.i.da.Pi:
                  return e.P.bind(e.model.B.j.wna, a);
                case k.i.da.jn:
                  return e.P.bind(e.model.B.j.Upa, a);
                case k.i.da.fo:
                  return e.P.bind(e.model.B.j.Wpa, a);
                case k.i.da.Xn:
                  return e.P.bind(e.model.B.j.Ela, a);
                case k.i.da.fn:
                  return e.P.bind(e.model.B.j.Gla, a);
                case k.i.da.co:
                  return e.P.bind(e.model.B.j.wpa, a);
                case k.i.da.hn:
                  return e.P.bind(e.model.B.j.ypa, a);
              }
              return a;
            }
            get Bm() {
              if ("" == this.JF) if (k.i.da.aU(this.aa)) this.JF = this.aa;else if (-1 != this.Wc.indexOf(k.i.da.Mq)) this.JF = k.i.da.Mq;else for (let b = 0; b < this.Wc.length; b++) if (k.i.da.aU(this.Wc[b])) {
                this.JF = this.Wc[b];
                break;
              }
              return this.JF;
            }
            get aa() {
              return "" === this.lk ? this.Wc[0] : this.lk;
            }
            set aa(b) {
              b && b.toLowerCase() !== this.lk ? (b = b.toLowerCase(), k.i.da.az(b) && (b = k.i.da.mz(b)), k.i.da.tA(b) || this.Oa && b == k.i.da.NONE ? (this.JF = "", this.lk = b, this.Oa || -1 != this.Wc.indexOf(b) || (this.lk = this.Wc[0])) : this.PV()) : "" == b && this.PV();
            }
            PV() {
              this.Tv = void 0;
              this.lk = this.Wc[0];
            }
            set Wc(b) {
              if (e.v(b)) this.mn = this.dk;else {
                for (var a = [], c = 0; c < b.length; c++) {
                  var d = b[c].trim().toLowerCase();
                  k.i.da.az(d) && (d = k.i.da.mz(d));
                  -1 !== this.dk.indexOf(d) && a.push(d);
                }
                this.mn = 0 < a.length ? a : this.dk;
              }
            }
            get Wc() {
              return 0 < this.mn.length ? this.mn : this.dk;
            }
            get Sd() {
              return this.Kb;
            }
            set Sd(b) {
              this.Kb = b;
            }
            get Oa() {
              return !e.ia(this.De);
            }
            set Oa(b) {}
            get De() {
              return this.PQ;
            }
            set De(b) {
              this.PQ = b;
            }
            get qr() {
              return this.ZF;
            }
            set qr(b) {
              this.ZF = b;
            }
            get $g() {
              return !e.v(this.ZF) && "" != this.ZF;
            }
            get Ez() {
              return this.ZQ;
            }
            set Ez(b) {
              this.ZQ = b;
            }
            get Fz() {
              return this.$Q;
            }
            set Fz(b) {
              this.$Q = b;
            }
            get zn() {
              return this.sQ;
            }
            set zn(b) {
              this.sQ = b;
            }
            Sa() {
              var b = {};
              b.uniqueName = this.A;
              b.name = this.rl;
              this.Oa && (b.formula = this.De.trim());
              b.format = this.format;
              b.individual = this.Gk;
              b.supportedAggregations = this.dk;
              b.availableAggregations = this.Wc;
              b.aggregation = this.aa;
              b.caption = this.caption;
              b.label = this.label;
              b.originalCaption = this.rl;
              b.grandTotalCaption = this.Xp;
              b.groupName = this.Ig;
              b.folder = this.Oc;
              b.type = this.type;
              b.kpi = this.qr;
              b.calculated = this.Oa;
              b.calculateNaN = this.zn;
              b.hidden = this.hidden;
              return b;
            }
            R1() {
              var b = new f("", "");
              return this.Gk !== b.Gk || this.De !== b.De || this.format !== b.format || !1 === this.Pm || "" !== this.aa && (this.Xp !== f.p1(this.aa, this.xc) && e.model.C.F.Fx || !e.model.C.F.Fx && this.Xp !== this.caption) ? !1 : !0;
            }
            ci(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let d = e.model.ac.pj.ci(b, a);
              e.model.ac.pj.Uya(b, a) || (d = e.model.ac.pj.ci(b, ""));
              c && e.v(d.Sd.textAlign) && this.type != k.i.Qa.jb && this.type != k.i.Qa.ic && this.type != k.i.Qa.Lc && (d = d.clone(), d.textAlign = e.model.ac.W.af.textAlign.LEFT);
              return d;
            }
            clone() {
              var b = new f(this.A);
              this.zL(b);
              return b;
            }
            zL(b) {
              b.data = this.data;
              b.xc = this.xc;
              b.UQ = this.UQ;
              b.Ot = this.Ot;
              b.ac = this.ac;
              b.Cg = this.Cg;
              void 0 != this.Tv && (b.Tv = this.Tv);
              b.lk = this.lk;
              b.mn = this.mn.slice();
              b.Kb = this.Kb.slice();
              b.PQ = this.PQ;
              b.WQ = this.WQ;
              b.VQ = this.VQ;
              b.ZF = this.ZF;
              b.ZQ = this.ZQ;
              b.$Q = this.$Q;
              b.sQ = this.sQ;
              b.Pj = this.Pj;
            }
            ax() {
              return 0 < this.Wc.length || this.Oa || this.$g;
            }
            ij() {
              const b = {};
              b.aggregation = this.aa;
              b.availableAggregations = this.Wc;
              b.availableAggregationsCaptions = k.i.da.e_(this.Wc);
              b.caption = this.caption;
              if (b.calculated = this.Oa) b.calculateNaN = this.zn, b.formula = this.De.trim(), b.individual = this.Gk;
              b.folder = this.Oc;
              b.format = this.format;
              b.grandTotalCaption = this.Xp;
              b.label = this.label;
              b.name = this.rl;
              b.uniqueName = this.A;
              b.groupName = this.Ig;
              return b;
            }
          }
          h.Or = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.WE {
            constructor(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              super(b, a);
              this.Pj = null;
            }
            get value() {
              return this.MK;
            }
            set value(b) {
              this.MK = b;
            }
            get status() {
              return this.Hsa;
            }
            set status(b) {
              this.Hsa = b;
            }
            get Uw() {
              return this.gsa;
            }
            set Uw(b) {
              this.gsa = b;
            }
            get Mx() {
              return this.Jsa;
            }
            set Mx(b) {
              this.Jsa = b;
            }
            get description() {
              return this.Pj;
            }
            set description(b) {
              this.Pj = b;
            }
          }
          h.uka = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.WE {
            constructor(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              super(b, a);
              this.Pj = null;
              this.Pa = new e.ub();
            }
            set Pa(b) {
              this.wb = b;
            }
            get Pa() {
              return this.wb;
            }
            get type() {
              return this.Cg;
            }
            set type(b) {
              this.Cg = b;
            }
            set pD(b) {
              this.B$ = b;
            }
            get pD() {
              return this.B$ ? this.B$ : [];
            }
            get Yc() {
              return this.O;
            }
            set Yc(b) {
              this.O = b;
            }
            get description() {
              return this.Pj;
            }
            set description(b) {
              this.Pj = b;
            }
            wi(b) {
              b.zi = this;
              this.wb.Ua(b.A, b);
            }
            ph(b) {
              return this.wb.getItem(b);
            }
            static zb(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var c = b.uniqueName;
              c = k.we.Wg(c, b.caption);
              null == a && (a = new k.local.O.t8(c));
              e.ia(b.caption) ? a.caption = b.uniqueName : a.caption = b.caption;
              return a;
            }
          }
          h.AA = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.K$ = this.GB = !1;
              this.i$ = new e.ub();
              this.mb = new e.ub();
              this.jZ = new e.ub();
              this.hH = new h.WW();
            }
            get Rd() {
              return this.GB;
            }
            set Rd(b) {
              this.GB = b;
            }
            get Wu() {
              return this.K$;
            }
            set Wu(b) {
              this.K$ = b;
            }
            get kb() {
              return 0 < this.Cw.length - (this.Cw.Bb("[Measures]") ? 1 : 0) || 0 < this.Ca.length || 0 < this.M2.length ? !1 : !0;
            }
            get Cw() {
              return this.i$;
            }
            set Cw(b) {}
            get Ca() {
              return this.mb;
            }
            set Ca(b) {}
            set $q(b) {}
            get $q() {
              for (var b = new e.ub(), a = 0; a < this.mb.length; a++) {
                var c = this.mb.ea(a);
                c.Oa && b.Ua(c.A, c);
              }
              return b;
            }
            set Ar(b) {}
            get Ar() {
              for (var b = [], a = 0; a < this.mb.length; a++) {
                var c = this.mb.ea(a);
                c.Oa || b.push(c);
              }
              return b;
            }
            set cI(b) {}
            get cI() {
              var b = this.Sp("[Measures]");
              null == b && (b = this.YZ());
              return b.ph("[Measures]");
            }
            YZ() {
              var b = new h.rt("[Measures]", "Measures"),
                a = new h.AA("[Measures]", "Measures");
              a.type = k.i.MA.BP;
              a.wi(b);
              this.cu(a);
              return a;
            }
            cu(b) {
              null == this.Sp(b.A) && (b.Yc = this, this.Cw.Ua(b.A, b));
            }
            Sp(b) {
              return this.Cw.getItem(b);
            }
            yc() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              for (var a = new e.ub(), c = 0; c < this.Cw.length; c++) {
                var d = this.Cw.ea(c);
                if (b || d.type != k.i.MA.BP) a = a.concat(d.Pa);
              }
              return a;
            }
            ph(b) {
              for (let a = 0; a < this.Cw.length; a++) {
                const c = this.Cw.ea(a);
                if (c.Pa.Bb(b)) return c.Pa.getItem(b);
              }
            }
            rk(b) {
              this.Ca.Ua(b.A, b);
            }
            fd(b) {
              return this.Ca.getItem(b);
            }
            lE(b) {
              this.Ca.removeItem(b);
            }
            clear() {
              this.i$ = new e.ub();
              this.mb = new e.ub();
              this.jZ = new e.ub();
              this.Rd = !1;
            }
            Kk() {
              return null;
            }
            mf() {
              return null;
            }
            TK() {}
            get M2() {
              return this.jZ;
            }
            set M2(b) {}
            WZ(b, a) {
              this.jZ.Ua(b.A, b);
              if (0 == e.ia(b.value)) {
                var c = new h.Or(b.value, this.rz(b.value, b.caption, e.model.B.j.m8, a));
                c.Ig = e.model.B.j.ey;
                c.Oc = b.caption;
                c.type = k.i.Qa.jb;
                c.qr = b.A;
                this.rk(c);
              }
              0 == e.ia(b.Uw) && (c = new h.Or(b.Uw, this.rz(b.Uw, b.caption, e.model.B.j.i8, a)), c.Ig = e.model.B.j.ey, c.Oc = b.caption, c.type = k.i.Qa.jb, c.qr = b.A, this.rk(c));
              0 == e.ia(b.status) && (c = new h.Or(b.status, this.rz(b.status, b.caption, e.model.B.j.k8, a)), c.Ig = e.model.B.j.ey, c.Oc = b.caption, c.type = k.i.Qa.jb, c.qr = b.A, c.Ez = !0, this.rk(c));
              0 == e.ia(b.Mx) && (a = new h.Or(b.Mx, this.rz(b.Mx, b.caption, e.model.B.j.l8, a)), a.Ig = e.model.B.j.ey, a.Oc = b.caption, a.type = k.i.Qa.jb, a.qr = b.A, a.Fz = !0, this.rk(a));
            }
            rz(b, a, c, d) {
              d = d.La(b, "caption");
              return e.v(d) ? 0 == b.indexOf("[Measures]") ? b.substring(12, b.length - 1) : a + " " + c : d;
            }
            mx(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              c = e.v(a) || c;
              var d = b.uniqueName;
              e.ia(b.formula) && (d = k.we.Wg(d, b.caption));
              e.v(a) && (a = new k.local.O.u8(d));
              b.hasOwnProperty("type") && (a.type = "string" === typeof b.type ? k.i.Qa.dza(parseInt(b.type)) : b.type);
              if (c || a.Oa) b.hasOwnProperty("formula") && (a.De = b.formula), b.hasOwnProperty("individual") && (a.Gk = b.individual), b.hasOwnProperty("calculateNaN") && (a.zn = b.calculateNaN);
              b.hasOwnProperty("supportedAggregations") && (a.dk = b.supportedAggregations);
              b.hasOwnProperty("availableAggregations") && (a.Wc = b.availableAggregations);
              if (b.hasOwnProperty("aggregation")) {
                if (b.aggregation !== k.i.da.NONE || k.Ma.R().fa.Ic || a.Oa) a.aa = b.aggregation;
              } else a.aa = a.Oa ? k.i.da.NONE : "";
              b.hasOwnProperty("format") && (a.format = b.format, e.model.ac.pj.wI(b.format, a.A, a.aa));
              b.hasOwnProperty("caption") && (a.caption = b.caption);
              b.hasOwnProperty("name") && (a.caption = b.name);
              b.hasOwnProperty("grandTotalCaption") && (a.Xp = b.grandTotalCaption);
              b.hasOwnProperty("groupName") && (a.Ig = b.groupName);
              b.hasOwnProperty("folder") && (a.Oc = b.folder);
              b.hasOwnProperty("active") ? a.Pm = b.active : b.hasOwnProperty("uniqueName") && b.hasOwnProperty("caption") && b.uniqueName != b.caption && !b.hasOwnProperty("formula") && (a.Pm = !1);
              a.Oa && (!b.hasOwnProperty("caption") && c && (a.caption = a.A), b = new u.IJ(), a.Sd = b.parse(a.De));
              return a;
            }
            hKa(b) {
              this.mapping = b;
            }
          }
          h.YW = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {}
            static ABa(b) {
              switch (b) {
                case k.i.qa.Cc:
                case k.i.qa.Md:
                  return new k.external.Fb.O.qpa();
                case k.i.qa.hg:
                  return new k.external.Se.O.ema();
                case k.i.qa.API:
                  return new k.external.pc.O.WI();
              }
              return new k.local.O.yP();
            }
          }
          h.Bqa = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b) {
              this.wb = new e.ub();
              this.Gr = k.i.Aa.ed;
              this.Wt = this.oQ = null;
              this.uK = [];
              this.LQ = [];
              this.JQ = [];
              this.wB = [];
              this.GZ = k.i.Aa.ed;
              this.PB = b;
            }
            set Zm(b) {
              this.Wt = b;
              this.oQ = null;
            }
            get Zm() {
              if (null != this.oQ) return this.oQ;
              var b = null;
              if (null != this.Wt) {
                var a = 0;
                b = [];
                for (var c = 0; c < this.wb.length; c++) {
                  var d = this.Pa.ea(c);
                  if (!d.Ue) {
                    if (!this.Wt[a]) break;
                    if ("number" == typeof this.Wt[a]) {
                      b = this.Wt;
                      break;
                    } else {
                      var g = this.Wt[a].toString().trim();
                      if (!/\D/.test(g)) {
                        b = this.Wt;
                        break;
                      }
                    }
                    d = d.Ib(k.we.Ps(this.Wt[a].toString().trim()));
                    if (null != d) b.push(d.ordinal);else if (this.Wt[a]) {
                      b = null;
                      break;
                    }
                    a++;
                  }
                }
              }
              return this.oQ = b;
            }
            set vW(b) {
              this.Zm = b;
            }
            get vW() {
              var b = null,
                a = this.Zm;
              if (null != a) {
                var c = 0;
                b = [];
                for (var d = 0; d < this.wb.length; d++) {
                  var g = this.Pa.ea(d);
                  if (!g.Ue) {
                    if (!a[c]) break;
                    g = g.za("" === a[c] ? 0 : parseInt(a[c]));
                    if (null != g) b.push(g.Ci);else if (a[c]) {
                      b = null;
                      break;
                    }
                    c++;
                  }
                }
              }
              return b;
            }
            get kd() {
              return this.uK;
            }
            set kd(b) {
              if (null == b) this.uK = [];else if (this.ab) this.uK = b;else {
                this.uK = [];
                for (var a = 0; a < b.length; a++) {
                  var c = b[a];
                  c[0] = -1;
                  this.uK.push(c);
                }
              }
            }
            get Qca() {
              for (var b = [], a, c, d, g, l, m = 0; m < this.kd.length; m++) {
                a = this.kd[m].slice(0);
                c = [];
                d = a.shift();
                g = null;
                -1 < d && (g = (g = this.Di(d)) ? g.Sa() : null);
                for (var n = d = 0; n < a.length; n++) l = this.Pa.ea(d), l.Ue && (d++, l = this.Pa.ea(d)), l && l.za(a[n]) && c.push(l.za(a[n]).A), d++;
                c.unshift(g);
                b.push(c);
              }
              return b;
            }
            Tga(b) {
              for (var a = [], c, d, g, l, m, n, p = 0; p < b.length; p++) {
                c = b[p].slice(0);
                d = [];
                l = -1;
                g = c.shift();
                g = "string" == typeof g ? new e.model.hb.jh(g) : e.model.hb.jh.zb(g);
                m = 0;
                if (0 < this.Pa.length) for (var t = 0; t < c.length; t++) {
                  n = this.Pa.ea(m);
                  if (e.v(n)) return [];
                  if (!n.Rd && !n.Ue) return this.LQ = b.slice(0), [];
                  n.Ue && (l = (l = this.Di(g)) ? l.index : -1, m++, n = this.Pa.ea(m));
                  if (n) if (n = n.Fha(c[t]), 0 > n) {
                    d = null;
                    break;
                  } else d.push(n);
                  m++;
                }
                null !== d && (d.unshift(l), a.push(d));
              }
              return a;
            }
            r4() {
              0 < this.LQ.length && (this.kd = this.Tga(this.LQ), this.LQ = []);
              0 < this.JQ.length && (this.ue = this.Sga(this.JQ), this.JQ = []);
            }
            get ue() {
              return this.wB;
            }
            set ue(b) {
              if (e.v(b) || 0 === b.length) this.wB = [];else {
                if (this.ab) this.wB = b;else {
                  this.wB = [];
                  for (var a = 0; a < b.length; a++) {
                    var c = b[a];
                    "string" === typeof c[0] ? c[1] = -1 : c[0] = -1;
                    this.wB.push(c);
                  }
                }
                this.v5(this.wB);
                this.ria(this.wB);
              }
            }
            v5(b) {
              b.sort((a, c) => {
                if (a.length !== c.length) return 0;
                var d = a.length - 1;
                a = a[d];
                c = c[d];
                return -1 === a ? 1 : -1 === c || a < c ? -1 : a > c ? 1 : 0;
              });
            }
            ria(b) {
              let a;
              const c = this.wb.slice();
              c.removeItem("[Measures]");
              let d;
              for (let g = 0; g < b.length; g++) {
                a = b[g].slice(0);
                "string" === typeof a[0] && (d = a.shift());
                const l = c.ea(a.length - 3);
                if (null == l) break;
                let m = a[1],
                  n;
                "string" === typeof a[1] && (n = l.Ib(m), !n && !isNaN(parseInt(a[1])) && 8 > a[1].length && (m = parseInt(a[1])));
                -1 == l.kv.indexOf(m) && l.kv.push([d, m]);
              }
            }
            get Dca() {
              for (var b = [], a, c, d, g, l, m, n, p = 0; p < this.ue.length; p++) {
                a = this.ue[p].slice(0);
                c = [];
                d = "";
                l = null;
                "string" == typeof a[0] && (d = a.shift());
                g = a.shift();
                m = a.shift();
                -1 < g && (l = (l = this.Di(g)) ? l.Sa() : null);
                for (var t = g = 0; t < a.length; t++) n = this.Pa.ea(g), n.Ue && (g++, n = this.Pa.ea(g)), (n = n.za(a[t])) && c.push(n.A), g++;
                c.unshift(m);
                c.unshift(l);
                c.unshift(d);
                b.push(c);
              }
              return b;
            }
            Sga(b) {
              const a = [];
              let c, d;
              for (var g, l, m, n, p, t = 0; t < b.length; t++) {
                var r = b[t].slice(0);
                c = [];
                g = -1;
                d = r.shift();
                m = r.shift();
                l = "string" == typeof m ? new e.model.hb.jh(m) : e.model.hb.jh.zb(m);
                m = r.shift();
                n = 0;
                if (0 < this.Pa.length) for (var w = 0; w < r.length; w++) {
                  p = this.Pa.ea(n);
                  if (e.v(p)) return [];
                  p.Ue && (g = (g = this.Di(l)) ? g.index : -1, n++, p = this.Pa.ea(n));
                  if (!p.Rd && !p.Ue) return this.JQ = b.slice(0), this.ria(b), [];
                  if (p) {
                    if (p.type !== k.i.Fc.Ta || p.wa.ea(1).type !== k.i.ib.Ta && p.wa.ea(1).type !== k.i.ib.Lc) p = p.Ib(r[w]);else {
                      if (e.model.C.F.ir && "null" === r[w]) var y = null;else if (8 > r[w].length || /\D+/.test(r[w].slice(1))) {
                        y = p.wa.ea(1).type === k.i.ib.Lc ? e.model.C.F.zk : e.model.C.F.Lp;
                        y = p.mapping.La(p.A, "format", y);
                        const B = new e.gh(r[w], {
                          Gy: !1,
                          format: y
                        });
                        B.uh(u.Eh.qg(y));
                        y = B.getTime();
                      } else y = parseInt(r[w]);
                      p = p.Du(y);
                    }
                    p ? c.push(p.ordinal) : c.push(-1);
                  }
                  n++;
                }
                if ((p = this.Pa.ea(r.length - 1)) && p.Rd && null !== p.lc && null == p.Ib(m)) for (r = m.slice(1, -1).split("].["); 1 < r.length;) {
                  r.pop();
                  var A = 1 < r.length ? `[${r.join("].[")}]` : r[0];
                  null == b.find(B => B[c.length + 2] === A) && (l = c.slice(0, -1), n = p.Ib(A), null != n && (l.push(n.ordinal), l.unshift(A), l.unshift(g), "" != d && l.unshift(d), a.push(l)));
                }
                c.unshift(m);
                c.unshift(g);
                "" != d && c.unshift(d);
                a.push(c);
              }
              return a;
            }
            set fg(b) {
              b = b.toLowerCase();
              this.GZ = b == k.i.Aa.kc || b == k.i.Aa.Mc ? b : k.i.Aa.ed;
            }
            get fg() {
              return this.GZ;
            }
            get A() {
              return this.PB;
            }
            set A(b) {
              this.PB = b;
            }
            get caption() {
              return this.xc;
            }
            set caption(b) {
              this.xc = b;
            }
            get Pa() {
              return this.wb;
            }
            set Pa(b) {
              this.kd = [];
              this.ue = [];
              this.Wt = null;
              this.GZ = k.i.Aa.ed;
              this.Jf = null;
              this.wb = b;
            }
            get ie() {
              return this.wb.indexOf("[Measures]");
            }
            set ie(b) {}
            get cI() {
              return this.wb.getItem("[Measures]");
            }
            set cI(b) {}
            get ab() {
              return -1 < this.ie;
            }
            set ab(b) {}
            get depth() {
              for (var b = 0, a = 0; a < this.wb.length; a++) {
                var c = this.wb.ea(a);
                b += c.Aca;
              }
              return b;
            }
            set depth(b) {}
            toString() {
              return "[Axis:" + this.PB + " ]";
            }
            static XDa(b, a, c) {
              "[Measures]" !== b.A && (c = c.Ca.getItem(b.A), void 0 === c || c.xc === b.caption && !a.hasOwnProperty("caption") || (c.xc !== b.caption ? a.caption = c.xc : a.hasOwnProperty("caption") && a.caption !== c.xc && (c.xc = a.caption)));
            }
            static zb(b, a, c, d, g, l) {
              let m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
              let n = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : !1;
              b = new f(b);
              m && (b.Di = t => m(t));
              b.Pa = new e.ub();
              if (a) for (let t = 0; t < a.length; t++) if (null != a[t].uniqueName) {
                a[t].uniqueName = k.we.Wg(a[t].uniqueName, a[t].caption);
                let r = l.ph(a[t].uniqueName);
                if (null != r) {
                  n && (r = r.clone(), r.x_(), r.filter.clear());
                  this.XDa(r, a[t], l);
                  h.rt.zb(a[t], r);
                  if (r.Ue && b.A === k.i.ha.At) continue;
                  const w = e.v(a[t].levelName) ? e.v(a[t].activeLevelName) ? null : a[t].activeLevelName : a[t].levelName;
                  r.xf = w;
                  b.Pa.Ua(r.A, r);
                }
              }
              if (c) {
                if (null != c.measure) {
                  a = "string" === typeof c.measure ? new e.model.hb.jh(k.we.Wg(c.measure)) : e.model.hb.jh.zb(c.measure);
                  var p = b.Di(a);
                }
                null != p && null != c.tuple ? b.AE(p, c.tuple, c.type) : b.hPa = c;
              }
              if (d && 0 < d.length) {
                c = [];
                for (a = 0; a < d.length; a++) {
                  l = d[a];
                  n = [];
                  0 < l.length && n.push(f.Bea(l[0]));
                  for (p = 1; p < l.length; p++) n.push(f.bga(l[p]));
                  c.push(n);
                }
                d = c;
              }
              b.kd = d ? b.Tga(d) : [];
              if (g && 0 < g.length) {
                d = [];
                for (c = 0; c < g.length; c++) {
                  a = g[c];
                  l = [];
                  0 < a.length && l.push(f.Bea(a[0]));
                  for (n = 1; n < a.length; n++) l.push(f.bga(a[n]));
                  d.push(l);
                }
                g = d;
              }
              b.ue = g ? b.Sga(g) : [];
              return b;
            }
            static Bea(b) {
              if ("string" === typeof b) {
                const a = parseInt(b);
                if (isNaN(a) || a.toString() !== b) return k.we.Wg(b);
              }
              return b;
            }
            static bga(b) {
              if ("string" === typeof b) {
                const a = parseInt(b);
                if (isNaN(a) || a.toString() !== b) return k.we.Ps(b);
              }
              return b;
            }
            Sa() {
              for (var b = {}, a = [], c = 0; c < this.Pa.length; c++) {
                var d = this.Pa.ea(c).Sa();
                a.push(d);
              }
              b.hierarchies = a;
              this.fg == k.i.Aa.ed || e.v(this.Zm) || e.v(this.Jf) || (b.sort = {
                type: this.fg,
                tuple: this.vW,
                measure: {
                  uniqueName: this.Jf.A,
                  aggregation: this.Jf.aa
                }
              });
              return b;
            }
            AE(b, a, c) {
              this.Jf = b;
              this.Zm = a;
              this.fg = c;
              0 == a.length && (this.Gr = this.fg, this.mt = this.Jf);
            }
            qC() {
              this.Zm = this.Jf = null;
              this.Gr = this.fg = k.i.Aa.ed;
              this.mt = null;
            }
            clone() {
              var b = new f(this.PB);
              b.caption = this.caption;
              b.Pa = this.Pa.slice(0);
              b.mt = this.mt;
              b.Gr = this.Gr;
              b.Jf = this.Jf;
              b.Zm = this.Zm;
              b.fg = this.fg;
              b.kd = this.br(this.kd);
              b.ue = this.br(this.ue);
              return b;
            }
            br(b) {
              for (var a = [], c = 0; c < b.length; c++) a.push(b[c].slice());
              return a;
            }
          }
          h.Lr = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b) {
              this.bs = new e.ub();
              this.mb = [];
              this.j$ = this.k$ = this.p$ = this.q$ = !1;
              this.zB = [];
              this.NQ = [];
              this.IQ = [];
              this.Ej = {};
              this.d3 = !0;
              this.Yc = b;
              this.au(new k.O.Lr(k.i.ha.Ia));
              this.au(new k.O.Lr(k.i.ha.Ra));
              this.au(new k.O.Lr(k.i.ha.At));
            }
            get axes() {
              return this.bs;
            }
            set axes(b) {}
            au(b) {
              this.bs.Ua(b.A, b);
              b.ab && (this.rB = b);
            }
            rd(b) {
              return this.bs.getItem(b);
            }
            Fya(b) {
              if (-1 != this.hc.Pa.indexOf(b)) return this.hc;
              if (-1 != this.Rb.Pa.indexOf(b)) return this.Rb;
              if (-1 != this.lI.Pa.indexOf(b)) return this.lI;
            }
            set rs(b) {}
            get rs() {
              this.Jja();
              return this.rB;
            }
            Jja() {
              if (null == this.rB) {
                for (var b = 0; b < this.bs.length; b++) {
                  var a = this.bs.ea(b);
                  if (a.ab) {
                    this.rB = a;
                    break;
                  }
                }
                null == this.rB && (this.rB = this.rd(k.i.ha.Ra));
              }
              this.rB.ab || (b = this.Yc.cI) && this.rB.Pa.Ua(b.A, b);
            }
            get Ar() {
              const b = [],
                a = {};
              for (var c = 0; c < this.mb.length; c++) {
                var d = this.mb[c];
                d.Oa || void 0 !== a[d.A] || (b.push(d), a[d.A] = 1);
              }
              return b;
            }
            set Ar(b) {}
            get $q() {
              for (var b = new e.ub(), a = 0; a < this.mb.length; a++) {
                var c = this.mb[a];
                c.Oa && b.Ua(c.A, c);
              }
              return b;
            }
            set $q(b) {}
            get Sf() {
              return this.mb;
            }
            set Sf(b) {
              this.iA(b);
            }
            gd() {
              for (var b = [], a = 0; a < this.mb.length; a++) {
                var c = this.mb[a];
                c.hidden || b.push(c);
              }
              return b;
            }
            iA(b) {
              this.mb = b;
            }
            Di(b) {
              for (var a = 0; a < this.mb.length; a++) if (b.A == this.mb[a].A && ("" == b.aa || b.aa === this.mb[a].aa)) return this.mb[a];
              return null;
            }
            Pw(b) {
              return b instanceof e.model.hb.jh ? this.Di(b) : isNaN(b) ? null : this.mb[b];
            }
            Vda(b, a) {
              for (var c = 0; c < this.mb.length; c++) if (b == this.mb[c].A && (void 0 == a || a == this.mb[c].aa)) return c;
              return -1;
            }
            yc() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
              let g = new e.ub();
              for (let l = 0; l < this.bs.length; l++) {
                const m = this.bs.ea(l);
                g = g.concat(m.Pa);
              }
              b || g.removeItem(this.Yc.cI.A);
              if (!a) for (b = 0; b < this.ob.length; b++) g.removeItem(this.ob.Oh(b));
              if (c) for (c = 0; c < this.mb.length; c++) b = this.mb[c], b.Oa || b.hidden && !d || (b = this.Yc.Kk(b.A), e.v(b) || g.Ua(b.A, b));
              return g;
            }
            clear() {
              for (var b = 0; b < this.bs.length; b++) this.bs.ea(b).Pa = new e.ub();
              this.mb = [];
            }
            get rows() {
              return this.rd(k.i.ha.Ia).Pa;
            }
            set rows(b) {
              var a = this.rd(k.i.ha.Ia);
              null == a && (a = new h.Lr(k.i.ha.Ia));
              a.Pa = b;
              null == b && (a.Pa = new e.ub());
              a.Di = c => this.Pw(c);
              this.au(a);
            }
            get Ka() {
              return this.rd(k.i.ha.Ra).Pa;
            }
            set Ka(b) {
              var a = this.rd(k.i.ha.Ra);
              null == a && (a = new h.Lr(k.i.ha.Ra));
              a.Pa = b;
              null == b && (a.Pa = new e.ub());
              a.Di = c => this.Pw(c);
              this.au(a);
            }
            get ob() {
              return this.rd(k.i.ha.At).Pa;
            }
            set ob(b) {
              var a = this.rd(k.i.ha.At);
              null == a && (a = new h.Lr(k.i.ha.At));
              a.Pa = b;
              null == b && (a.Pa = new e.ub());
              this.au(a);
            }
            set xb(b) {}
            get xb() {
              return this.rs.A == k.i.ha.Ia ? this.rows.splice(this.rs.ie, 1) : this.rows;
            }
            set Db(b) {}
            get Db() {
              return this.rs.A == k.i.ha.Ra ? this.Ka.splice(this.rs.ie, 1) : this.Ka;
            }
            clone() {
              var b = new f(this.Yc);
              b.rows = this.rows.slice();
              b.Ka = this.Ka.slice();
              b.ob = this.ob.slice();
              b.iA(this.gd());
              b.Tg = this.Tg.slice(0);
              b.Ug = this.Ug.slice(0);
              b.bd = this.bd.slice(0);
              b.au(this.hc.clone());
              b.hc.Di = a => this.Pw(a);
              b.au(this.Rb.clone());
              b.Rb.Di = a => this.Pw(a);
              b.kf = this.kf;
              b.jf = this.jf;
              b.gf = this.gf;
              b.Tf = this.Tf;
              return b;
            }
            static Waa(b, a) {
              if (null == a) return !0;
              var c = b.rows.length != a.rows.length;
              if (!c) for (var d = 0; d < b.rows.length; d++) if (b.rows.ea(d).A != a.rows.ea(d).A) {
                c = !0;
                break;
              }
              return c;
            }
            static Vaa(b, a) {
              if (null == a) return !0;
              var c = b.Ka.length != a.Ka.length;
              if (!c) for (var d = 0; d < b.Ka.length; d++) if (b.Ka.ea(d).A != a.Ka.ea(d).A) {
                c = !0;
                break;
              }
              return c;
            }
            static iua(b, a) {
              if (null == a) return !0;
              b = b.gd();
              a = a.gd();
              var c = b.length != a.length;
              if (!c) for (var d = 0; d < b.length; d++) if (b[d].A != a[d].A) {
                c = !0;
                break;
              }
              return c;
            }
            static cua(b, a) {
              void 0 !== a.caption && null != b && (b.caption = a.caption);
            }
            static XCa(b) {
              return void 0 === b.formula ? !0 : e.model.C.F.iu && k.Ma.R().fa.Ba === k.i.qa.Cc || !k.Ma.R().fa.Ic || k.Ma.R().fa.Ba === k.i.qa.API;
            }
            static zb(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
              const g = new f(a);
              var l = [],
                m = a.yc(),
                n = b.Ca.map(r => r.uniqueName);
              for (var p = 0; p < b.Ca.length; p++) if (void 0 !== b.Ca[p].uniqueName && this.XCa(b.Ca[p])) {
                e.ia(b.Ca[p].formula) && (a.fd(b.Ca[p].uniqueName) || (b.Ca[p].uniqueName = k.we.Wg(b.Ca[p].uniqueName)));
                var t = a.Ca.getItem(b.Ca[p].uniqueName);
                if (null != t || !e.ia(b.Ca[p].formula)) {
                  this.cua(m.getItem(b.Ca[p].uniqueName), b.Ca[p]);
                  t = a.mx(b.Ca[p], t);
                  t.hidden = !1;
                  if (t.Oa && !a.Ca.Bb(t.A)) {
                    if (e.model.C.F.sO && !g.CLa(t, n)) continue;
                    a.rk(t);
                  }
                  if (null == b.Ca[p].active || b.Ca[p].active) t = t.clone(), t.index = l.length, l.push(t);
                }
                e.model.C.F.tc && !e.v(b.Ca[p].filter) && (t = m.getItem(b.Ca[p].uniqueName), e.v(t) || (t.filter = e.model.hb.TA.zb(b.Ca[p].filter, t)));
              }
              g.Z5(l);
              l = k.O.Lr.zb(k.i.ha.Ia, b.rows, b.bk, b.Jw, b.Gw, a, r => g.Pw(r), c);
              m = k.O.Lr.zb(k.i.ha.Ra, b.Ka, b.Tj, b.Iw, b.Fw, a, r => g.Pw(r), c);
              c = k.O.Lr.zb(k.i.ha.At, b.ob, null, [], [], a, null, c);
              g.rows = l.Pa;
              g.Ka = m.Pa;
              g.ob = c.Pa;
              g.kf = b.kf;
              g.jf = b.jf;
              g.gf = b.gf;
              g.Tf = b.Tf;
              if (k.Ma.R().fa && k.Ma.R().fa.RH) if (g.Tg = b.Tg, e.v(b.Ug)) {
                if (m.fg == k.i.Aa.ed || e.v(m.Jf)) for (c = b.rows.concat(b.Ka.concat(b.ob)), n = 0; n < c.length; n++) {
                  if (t = c[n], p = t.sortName, t = a.fd(t.uniqueName), !e.v(p) && !e.v(t) && k.i.Aa.ah(p) && p != k.i.Aa.ed) {
                    g.Ug = [{
                      sort: p,
                      measure: t
                    }];
                    break;
                  }
                } else g.Ug = [{
                  sort: m.fg,
                  measure: m.Jf
                }];
              } else g.Ug = f.gda(b.Ug, a);
              g.bd = b.bd;
              g.Ej = b.Ej;
              g.au(l);
              g.au(m);
              g.Jja();
              g.Lja();
              d || g.oJa(g);
              return g;
            }
            static gda(b, a) {
              if (e.v(b)) return null;
              const c = [];
              for (var d = 0; d < b.length; d++) {
                var g = b[d];
                const l = a.fd(g && g.uniqueName ? g.uniqueName : g.measure.uniqueName);
                g = String(g.sort).toLowerCase();
                !e.v(l) && k.i.Aa.ah(g) && c.push({
                  measure: l,
                  sort: g
                });
              }
              return c;
            }
            Lja() {
              const b = e.model.C.F.tc,
                a = this.mb.filter(l => -1 < k.i.da.yA.indexOf(l.aa));
              for (var c = 0; c < this.rows.length; c++) {
                var d = this.rows.ea(c),
                  g = d.filter.measure;
                b && d.filter.ei && !e.v(this.Yc.fd(g.A)) || this.yfa(d, g, a) || d.filter.oC();
              }
              for (c = 0; c < this.Ka.length; c++) d = this.Ka.ea(c), g = d.filter.measure, b && d.filter.ei && !e.v(this.Yc.fd(g.A)) || this.yfa(d, g, a) || d.filter.oC();
            }
            yfa(b, a, c) {
              c = c.find(d => a && d.A === a.A);
              return !(b.filter.ei && null == this.fd(b.filter.measure.A) || a && k.Ma.R().fa.Ic && void 0 !== c);
            }
            CLa(b, a) {
              b = u.iP.NR(b.De, b.A, a);
              return 0 == b.Zw ? (e.Wa(b.errorMessage), !1) : !0;
            }
            oJa(b) {
              if (null != k.Ma.R().pa) {
                var a = k.Ma.R().pa.rs,
                  c = b.rs;
                null != a && null != c && a.A != c.A || null == a.Jf || null == b.Di(new e.model.hb.jh(a.Jf.A, a.Jf.aa, a.Jf.index)) || null != c.Jf || (c.Jf = a.Jf, c.vW = a.vW, c.Zm = a.Zm, c.fg = a.fg);
              }
            }
            rja() {
              const b = new e.model.hb.wp(),
                a = this.rd(k.i.ha.Ia).Sa(),
                c = this.rd(k.i.ha.Ra).Sa();
              var d = this.rd(k.i.ha.At).Sa();
              b.rows = a.hierarchies;
              b.Ka = c.hierarchies;
              b.ob = d.hierarchies;
              b.Ca = [];
              d = this.Yc.Ca;
              const g = this.gd();
              for (var l = 0; l < g.length; l++) {
                var m = g[l],
                  n = m.Sa();
                n.caption = m.rl;
                n.active = !0;
                e.model.C.F.tc && (m = this.Yc.Kk(m.A)) && m.filter.zh && !b.PCa(m.A) && (n.filter = m.filter.Sa());
                b.Ca.push(n);
              }
              for (l = 0; l < d.length; l++) {
                const p = d.ea(l);
                p.hidden && !p.Oa || p.R1() || g.find(t => t.A === p.A) || (n = p.Sa(), n.active = !1, b.Ca.push(n));
              }
              b.bk = a.sort;
              b.Tj = c.sort;
              b.kf = this.kf;
              b.jf = this.jf;
              b.Jw = this.axes.getItem(k.i.ha.Ia).Qca;
              b.Iw = this.axes.getItem(k.i.ha.Ra).Qca;
              b.gf = this.gf;
              b.Tf = this.Tf;
              b.Gw = this.axes.getItem(k.i.ha.Ia).Dca;
              b.Fw = this.axes.getItem(k.i.ha.Ra).Dca;
              b.Tg = this.Tg;
              b.Ug = this.hda();
              b.bd = this.bd;
              b.Ej = this.Ej;
              return b;
            }
            hda() {
              if (e.v(this.Ug)) return null;
              const b = [];
              for (var a = 0; a < this.Ug.length; a++) {
                var c = this.Ug[a];
                b.push({
                  uniqueName: c.measure.A,
                  sort: c.sort
                });
              }
              return b;
            }
            Sa() {
              var b = {};
              b.rows = [];
              for (var a = 0; a < this.rows.length; a++) {
                var c = this.rows.ea(a).Sa();
                b.rows[a] = c;
              }
              b.columns = [];
              for (a = 0; a < this.Ka.length; a++) c = this.Ka.ea(a).Sa(), b.columns[a] = c;
              b.pages = [];
              for (a = 0; a < this.ob.length; a++) c = this.ob.ea(a).Sa(), b.pages[a] = c;
              b.measures = [];
              for (a = 0; a < this.mb.length; a++) this.mb[a].hidden || (c = this.mb[a].Sa(), b.measures[a] = c);
              return b;
            }
            r4() {
              for (var b = 0; b < this.bs.length; b++) this.bs.ea(b).r4();
            }
            flatten() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              const c = this.yc(!1);
              for (let d = 0; d < this.mb.length; d++) {
                if (this.mb[d].hidden) continue;
                const g = this.mb[d];
                if (a) g.type === k.i.Qa.zc ? c.Bb(g.A) || c.Ua(g.A, g) : c.Ua(g.A, g);else {
                  let l = this.Kk(g.A);
                  null != l && c.Ua(l.A, l);
                  g.Oa && b && (l = new h.rt(g.A, g.caption), c.Ua(g.A, l));
                }
              }
              return this.Vta(c, this.Tg);
            }
            Vta(b, a) {
              const c = new e.ub();
              for (let d = 0; d < a.length; d++) {
                const g = a[d];
                b.Bb(g) && (c.Ua(g, b.getItem(g)), b.removeItem(g));
              }
              for (a = 0; a < b.length; a++) c.Ua(b.Oh(a), b.ea(a));
              return c;
            }
            isEqual(b) {
              if (null == b) return !1;
              var a = this.gd(),
                c = b.gd();
              if (this.ob.length != b.ob.length || this.rows.length != b.rows.length || this.Ka.length != b.Ka.length || a.length != c.length) return !1;
              for (var d = 0; d < this.ob.length; d++) if (this.ob.Oh(d) != b.ob.Oh(d)) return !1;
              for (d = 0; d < this.rows.length; d++) if (this.rows.Oh(d) != b.rows.Oh(d)) return !1;
              for (d = 0; d < this.Ka.length; d++) if (this.Ka.Oh(d) != b.Ka.Oh(d)) return !1;
              for (d = 0; d < a.length; d++) if (a[d].A != c[d].A || a[d].aa != c[d].aa) return !1;
              return !0;
            }
            Kk(b) {
              return this.Yc.Kk(b);
            }
            mf(b) {
              return this.Yc.mf(b);
            }
            get kb() {
              return 0 == this.yc(!1).length && 0 == this.mb.length;
            }
            ZDa() {
              if (e.model.C.F.tc) {
                this.rows = new e.ub();
                this.Ka = new e.ub();
                this.ob = new e.ub();
                for (var b = [], a = [], c = 0; c < this.Yc.Ca.length; c++) {
                  var d = this.Yc.Ca.ea(c);
                  a.push(d.A);
                  d.type == k.i.Qa.zc ? (d = this.Yc.Kk(d.A)) && this.rows.Ua(d.A, d) : (d.index = 0, b.push(d));
                }
                if (e.v(this.zB) || 0 == this.zB.length) this.zB = a;
                this.mb = b;
              } else {
                for (c = 0; c < this.Yc.Ca.length && (d = this.Yc.Ca.ea(c), d.type != k.i.Qa.jb ? null == a && (a = this.Yc.Kk(d.A)) : null == b && (b = d), null == a || null == b); c++);
                null == b ? b = this.Yc.Ca.ea(0) : null == a ? (d = this.Yc.Ca.ea(0), a = this.Yc.Kk(d.A)) : null == a && null == b && 0 < this.Yc.Ca.length && (b = this.Yc.Ca.ea(0), a = this.Yc.Kk(b.A));
                null != a && null != b && (this.ob = new e.ub(), this.rows = new e.ub(), this.Ka = new e.ub(), this.rows.Ua(a.A, a), c = [], b.index = 0, c.push(b), this.mb = c);
              }
            }
            get kf() {
              return this.q$;
            }
            set kf(b) {
              this.q$ = b;
            }
            get jf() {
              return this.p$;
            }
            set jf(b) {
              this.p$ = b;
            }
            get gf() {
              return this.k$;
            }
            set gf(b) {
              this.k$ = b;
            }
            get Tf() {
              return this.j$;
            }
            set Tf(b) {
              this.j$ = b;
            }
            jva() {
              this.hc.kd = [];
            }
            eva() {
              this.Rb.kd = [];
            }
            iva() {
              this.hc.ue = [];
            }
            dva() {
              this.Rb.ue = [];
            }
            get Tg() {
              null == this.zB && (this.zB = []);
              return this.zB;
            }
            set Tg(b) {
              this.zB = b;
            }
            get Ug() {
              null == this.NQ && (this.NQ = []);
              return this.NQ;
            }
            set Ug(b) {
              this.NQ = b;
            }
            get bd() {
              null == this.IQ && (this.IQ = []);
              return this.IQ;
            }
            set bd(b) {
              this.IQ = b;
            }
            get hc() {
              return this.axes.getItem(k.i.ha.Ia);
            }
            get Rb() {
              return this.axes.getItem(k.i.ha.Ra);
            }
            get lI() {
              return this.axes.getItem(k.i.ha.At);
            }
            Z5(b) {
              void 0 === b && (b = this.mb);
              const a = [];
              if (this.Yc instanceof k.external.pc.O.WI && 0 < e.model.ua.dn.Xc.length) for (var c = 0; c < e.model.ua.dn.Xc.length; c++) {
                var d = e.model.ua.dn.Xc.ea(c);
                if ((d = u.wt.uM(d.Sd, this.Yc.Ca)) && 0 < d.length) for (var g = 0; g < d.length; g++) {
                  var l = d[g];
                  let n = this.Yc.Ca.getItem(l.A);
                  if (null != n) {
                    var m = b.find(p => p.A === n.A);
                    if (null == m || !m.Oa && m.aa != l.aa) m = n.clone(), m.aa = l.aa, m.hidden = !0, a.push(m);
                  }
                }
              }
              c = null;
              for (d = 0; d < b.length; d++) if (c = b[d], c.format = this.Yc.Ca.getItem(c.A).format, a.push(c), c.Oa) {
                if ((g = u.wt.uM(c.Sd, this.Yc.Ca)) && 0 < g.length) for (l = 0; l < g.length; l++) {
                  m = g[l];
                  let n = this.Yc.Ca.getItem(m.A);
                  if (null != n) {
                    let p = b.find(t => t.A === n.A);
                    if (null == p || !p.Oa && p.aa != m.aa) p = n.clone(), p.aa = m.aa, p.hidden = !0, a.push(p);
                  }
                }
                this.Yc instanceof k.external.pc.O.WI && (c.Sd = u.wt.uH(c.Sd, this.Yc.Ca));
              }
              this.iA(a);
            }
            oEa(b) {
              e.v(b) || (this.kf = b.kf, this.jf = b.jf, this.gf = b.gf, this.Tf = b.Tf, f.Waa(this, b) ? (this.hc.kd = this.vS(b.hc.kd, this.mT(this.hc.Pa, b.hc.Pa)), this.hc.ue = this.vS(b.hc.ue, this.mT(this.hc.Pa, b.hc.Pa) + 2)) : (this.hc.kd = this.br(b.hc.kd), this.hc.ue = this.br(b.hc.ue)), f.Vaa(this, b) ? (this.Rb.kd = this.vS(b.Rb.kd, this.mT(this.Rb.Pa, b.Rb.Pa)), this.Rb.ue = this.vS(b.Rb.ue, this.mT(this.Rb.Pa, b.Rb.Pa) + 2)) : (this.Rb.kd = this.br(b.Rb.kd), this.Rb.ue = this.br(b.Rb.ue)));
            }
            lE(b, a) {
              const c = [];
              for (let d = 0; d < this.mb.length; d++) (this.mb[d].A !== b || this.mb[d].aa !== a && void 0 !== a) && c.push(this.mb[d]);
              this.mb = c;
            }
            zha(b) {
              b.index < this.mb.length && this.mb[b.index].A === b.A && this.mb[b.index].aa === b.aa ? this.mb.splice(b.index, 1) : this.lE(b.A, b.aa);
            }
            fd(b) {
              for (var a = 0; a < this.mb.length; a++) if (this.mb[a].A == b) return this.mb[a];
            }
            mT(b, a) {
              for (var c = 0, d = Math.min(b.length, a.length), g = 0; g < d; g++) {
                var l = b.ea(g),
                  m = a.ea(g);
                if (l.A != m.A) break;
                l.Ue || c++;
              }
              return c;
            }
            vS(b, a) {
              var c = [];
              if (1 < a) for (var d = 0; d < b.length; d++) {
                var g = b[d];
                g.length <= a && c.push(g.slice());
              }
              return c;
            }
            br(b) {
              for (var a = [], c = 0; c < b.length; c++) a.push(b[c].slice());
              return a;
            }
            Q_(b) {
              return this.Cba(b, this.xb);
            }
            P_(b) {
              return this.Cba(b, this.Db);
            }
            Cba(b, a) {
              var c = [];
              if (e.v(b)) return c;
              for (var d = 0; d < b.length; d++) {
                var g = a.ea(d);
                e.v(g) || (g = g.za(b[d]), e.v(g) || c.push(g.Sa()));
              }
              return c;
            }
            RBa() {
              let b = this.yc();
              for (let a = 0; a < b.length; a++) if (b.ea(a).Bf) return !0;
              return !1;
            }
          }
          h.Xr = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            get YK() {
              return !0;
            }
            set YK(c) {}
            Iaa() {
              throw "Not Implemented";
            }
            jta(c, d) {
              e.v(this.xy) && (this.xy = new e.ub());
              this.xy.Ua(c, d);
            }
            iea(c, d) {
              return !e.v(this.xy) && this.xy.Bb(c.A) ? this.lS(this.xy.getItem(c.A), d) : this.rH(d);
            }
            lS(c, d) {
              if ("boolean" === typeof c) return !0 === c ? this.rH(d) : null;
              const g = new a();
              d = this.rH(d);
              e.v(c.md) || (g.md = c.md);
              e.v(c.query) || (g.query = "boolean" === typeof c.query ? !0 === c.query ? d.query : [] : c.query.slice());
              e.v(c.km) || (g.km = "boolean" === typeof c.km ? !0 === c.km ? d.km : [] : c.km.slice());
              return g;
            }
            rH(c) {
              var d = new a();
              d.md = !0;
              d.km = k.i.Vb.Aq;
              switch (c) {
                case k.i.rb.Zk:
                  d.query = k.i.Cb.Aq;
                  break;
                case k.i.rb.Ta:
                  d.query = k.i.bc.Aq;
                  break;
                case k.i.rb.jb:
                  d.query = k.i.Pg.Aq;
                  break;
                case k.i.rb.ic:
                  d.query = k.i.bl.Aq;
              }
              return d;
            }
          }
          h.WW = f;
          class b {}
          h.Eqa = b;
          class a {
            get gfa() {
              return 1 == this.md;
            }
            get WM() {
              return !e.v(this.query) && 0 < this.query.length;
            }
            get zfa() {
              return !e.v(this.km) && 0 < this.km.length;
            }
            merge(c) {
              void 0 === this.md && (this.md = c.md);
              void 0 === this.query && (this.query = c.query);
              void 0 === this.km && (this.km = c.km);
            }
          }
          h.Dqa = a;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.ut {
            isEqual(b) {
              return b.Ba == k.i.qa.EMPTY;
            }
            clone() {
              return new f();
            }
            Sa() {
              return {};
            }
          }
          h.PA = f;
        })(k.O || (k.O = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends k.O.ut {
            constructor() {
              super(...arguments);
              this.requestPermission = this.Wd = !1;
              this.mapping = new k.O.pm();
            }
            isEqual(b) {
              return super.isEqual(b) && this.filename === b.filename && !1 === this.Wd && !1 === b.Wd && this.mapping.isEqual(b.mapping);
            }
          }
          h.uP = f;
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends k.w6 {
            constructor() {
              super(...arguments);
              this.Dh = [];
              this.Qn = [];
              this.zY = [{
                value: "Chrome",
                DN: .76
              }, {
                value: "Firefox",
                DN: .11
              }, {
                value: "Safari",
                DN: .05
              }, {
                value: "Edge/IE",
                DN: .06
              }, {
                value: "Opera",
                DN: .02
              }];
            }
            rC() {
              super.rC();
              this.Dh = [];
              this.Qn = [];
            }
            mva() {
              this.Dh = [];
              this.Qn = [];
              this.values = [];
            }
            static clone(b) {
              var a = new f(b.va);
              a.mh = b.mh.slice(0);
              a.Kn = b.Kn.slice(0);
              a.vb = b.vb.slice(0);
              a.Hc = b.Hc.slice(0);
              a.wa = b.wa.slice(0);
              a.je = b.je.slice(0);
              a.oh = b.oh.slice(0);
              a.xg = b.xg.slice(0);
              a.hu = b.hu.slice(0);
              a.Xw = b.Xw.slice(0);
              return a;
            }
            sxa(b) {
              var a = this.Kn.indexOf(b);
              if (!e.v(b) && -1 < a) {
                for (b = 0; b < this.oh.length; b++) void 0 === this.Dh[b] && (this.Dh[b] = []), void 0 !== this.Hc[b] ? (this.Hc[b][a] = NaN, this.Dh[b][a] = {
                  Op: -this.Hc[b][a],
                  Ys: -1
                }) : this.Dh[b][a] = {
                  Op: 0,
                  Ys: 0
                };
                this.mh = e.Ja.Ir(this.mh, this.mh.indexOf(a));
                this.Kn[a] = null;
              }
            }
            update(b, a, c) {
              var d = this.Kn.indexOf(c);
              if (!e.v(c) && -1 < d) {
                for (c = 0; c < this.oh.length; c++) if (this.Hc[c] && this.Hc[c][d] !== a[c]) {
                  var g = a[c] - this.Hc[c][d];
                  isNaN(g) || (null == this.Dh[c] && (this.Dh[c] = []), this.Dh[c][d] = {
                    Op: g,
                    Ys: g / this.Hc[c][d]
                  });
                }
                for (c = 0; c < a.length; c++) this.Hc[c][d] = a[c];
                for (c = 0; c < b.length; c++) this.vb[c][d] = b[c];
              } else {
                d = this.Nx;
                e.v(c) || (this.Kn[d] = c);
                for (c = 0; c < this.oh.length; c++) g = a[c], isNaN(g) || (null == this.Dh[c] && (this.Dh[c] = []), this.Dh[c][d] = {
                  Op: g,
                  Ys: 1
                });
                this.mh = e.Ja.Hr(this.mh, d);
                for (c = 0; c < b.length; c++) this.vb[c] = e.Ja.Hr(this.vb[c], b[c]);
                for (c = 0; c < a.length; c++) this.Hc[c] = e.Ja.Hr(this.Hc[c], a[c]);
              }
            }
            insert(b, a, c) {
              if (!(-1 < b.indexOf(0))) {
                var d;
                if (0 === this.vb.length) for (d = 0; d < b.length; d++) this.vb[d] = [];
                this.mh = e.Ja.Hr(this.mh, this.Nx);
                e.v(c) || (this.Kn[this.Nx] = c);
                for (d = 0; d < b.length; d++) this.vb[d] = e.Ja.Hr(this.vb[d], b[d]);
                if (0 === this.Hc.length) for (d = 0; d < a.length; d++) this.Hc[d] = [];
                for (d = 0; d < a.length; d++) this.Hc[d] = e.Ja.Hr(this.Hc[d], a[d]);
              }
            }
            Lda(b, a, c, d) {
              if (0 != b.length) {
                var g = this.Hc[a] instanceof Uint8Array;
                for (let m = 0; m < b.length; m++) {
                  var l = this.Hc[a][b[m]];
                  isNaN(l) || g && 0 == l || d[l] || (c.push(l), d[l] = !0);
                }
              }
            }
            wJa(b, a, c, d) {
              b = this.cb[b[0]];
              a = a[0];
              var g = [];
              this.Dh = [];
              this.Dh[b] = [];
              this.values = [];
              this.Qn = [];
              if (null != c) {
                var l = c.VS(d);
                var m = this.aea(c.za(this.vb[a][b]), "string" == typeof d);
                if (null == l) if (1 == this.Gba(a, this.vb[a][b])) {
                  l = c.za(this.vb[a][b]);
                  var n = this.j1(c, d);
                  n.ordinal = l.ordinal;
                  c.Rha(n);
                } else l = null != c.Ib(d) ? c.oc(new k.O.ae({
                  A: e.P.eM(),
                  caption: d
                })) : c.oc(new k.O.ae({
                  A: d,
                  caption: d
                }));
                this.vb[a][b] = l.ordinal;
                n = null != this.Kn[b] ? this.Kn[b] : b;
                g.push({
                  id: n,
                  field: c.A,
                  value: d,
                  oldValue: m
                });
                c = parseFloat(d) - this.Hc[a][b];
                this.Dh[b][a] = {
                  Op: c,
                  Ys: c / this.Hc[a][b]
                };
                this.Hc[a][b] = parseFloat(d);
                0 < g.length && this.va.bia(g);
                return l.ordinal;
              }
            }
            aea(b, a) {
              return null == b ? "" : a ? b.caption : b.fc;
            }
            save(b, a, c, d, g) {
              var l = this.ld(b, this.Bd),
                m = this.ld(a, this.Od);
              g = (b.length * m[0][0].length < a.length * l[0][0].length ? this.Rp(m[0][0], b, this.Uh) : this.Rp(l[0][0], a, this.wk))[g];
              b = [];
              a = this.oh.indexOf(this.va.O.mf(c.A).A);
              this.Dh = [];
              this.Dh[a] = [];
              l = parseFloat(d) - this.Hc[a][g];
              this.Dh[a][g] = {
                Op: l,
                Ys: l / this.Hc[a][g]
              };
              this.Hc[a][g] = parseFloat(d);
              this.values = [];
              this.Qn = [];
              if (null != c) {
                m = this.je.indexOf(c.A);
                var n = this.Gba(m, this.vb[m][g]);
                l = c.VS(d);
                l = null === l ? c.Ib(d) : l;
                a = this.aea(c.za(this.vb[m][g]), "string" == typeof d);
                null == l && (1 == n ? (l = c.za(this.vb[m][g]), n = this.j1(c, d), n.ordinal = l.ordinal, c.Rha(n)) : l = c.oc(this.j1(c, d)));
                l.fc = d;
                this.vb[m][g] = l.ordinal;
                g = null != this.Kn[g] ? this.Kn[g] : g;
                b.push({
                  id: g,
                  field: c.A,
                  value: d,
                  oldValue: a
                });
                0 < b.length && this.va.bia(b);
                return l.ordinal;
              }
            }
            j1(b, a) {
              b = this.va.O.mf(b.A);
              k.i.Qa.Ta == b.type ? (b = e.P.Kx(a, e.model.C.F.Lp, e.model.C.F.Uj), a = new k.O.ae({
                A: b,
                caption: b,
                fc: a
              })) : k.i.Qa.zc == b.type ? a = new k.O.ae({
                A: a.toString(),
                caption: a.toString()
              }) : k.i.Qa.ic == b.type ? (b = e.P.Lx(a, e.model.C.F.ep), a = new k.O.ae({
                A: b,
                fc: a
              })) : a = new k.O.ae({
                A: a.toString(),
                caption: a.toString(),
                fc: a
              });
              return a;
            }
            Gba(b, a) {
              for (var c = 0, d = 0; d < this.Nx; d++) this.vb[b][d] == a && c++;
              return c;
            }
            bd(b, a) {
              const c = [];
              c.push(this.je);
              var d = this.ld(b, this.Bd);
              if (e.v(d) || e.v(d[0]) || e.v(d[0][0])) return c;
              var g = this.ld(a, this.Od);
              if (e.v(g) || e.v(g[0]) || e.v(g[0][0])) return c;
              b = b.length * g[0][0].length < a.length * d[0][0].length ? this.Rp(g[0][0], b, this.Uh) : this.Rp(d[0][0], a, this.wk);
              for (a = 0; a < b.length; a++) {
                d = [];
                for (g = 0; g < this.vb.length; g++) d.push(this.vb[g][b[a]]);
                c.push(d);
              }
              return c;
            }
            nD(b, a, c) {
              b = this.ts(b, a);
              a = c.Oa ? this.slice.gd().findIndex(d => d.A === c.A) + this.oh.length : this.oh.indexOf(c.A);
              return void 0 == this.Qn[b] ? null : this.Qn[b][a];
            }
            Sda(b, a) {
              if (a.Oa) return null;
              a = this.oh.indexOf(a.A);
              return null == b ? this.s_(this.cb, a) : void 0 == this.Qn[b] ? null : this.Qn[b][a];
            }
            Hs(b) {
              return null == this.cb[b] || null == this.vb[0][this.cb[b]] || "" == this.va.O.id ? null : this.Kn[this.cb[b]];
            }
            jBa(b, a) {
              if (0 == this.Kn.length) return null;
              var c = this.ld(b, this.Bd);
              if (e.v(c) || e.v(c[0]) || e.v(c[0][0])) return null;
              const d = this.ld(a, this.Od);
              if (e.v(d) || e.v(d[0]) || e.v(d[0][0])) return null;
              b = b.length * d[0][0].length < a.length * c[0][0].length ? this.Rp(d[0][0], b, this.Uh) : this.Rp(c[0][0], a, this.wk);
              a = [];
              for (c = 0; c < b.length; c++) a.push(this.Kn[b[c]]);
              return 0 == a.length ? null : a;
            }
            rT(b, a, c, d, g) {
              if (this.va.fa.RM) return 0 === this.vb[0][b] && this.Gza(b), this.vb[a][b];
              if (null == this.cb[b] || null == this.vb[0][this.cb[b]]) return NaN;
              if (d) return !c.Oa && this.Dh.length && (d = this.oh.indexOf(c.A), null == this.Qn[b] && (this.Qn[b] = []), this.Qn[b][d] = this.s_([this.cb[b]], d)), c.Oa ? this.Up([this.cb[b]], c.Sd, c.Gk, 0, null, null, c.zn) : this.Hc[a][this.cb[b]];
              this.Hc.length != this.vb.length && (a = this.je.indexOf(this.oh[a]), void 0 !== g && (a = this.wa[a][g]));
              return this.vb[a][this.cb[b]];
            }
            La(b, a, c) {
              var d = this.ts(b, a),
                g = this.di(c);
              if (e.v(this.values[g]) || -1 == g) this.values[g] = [];
              g = this.values[g];
              if (!g[d]) {
                var l = this.ld(b, this.Bd),
                  m = this.ld(a, this.Od);
                if (null == l || null == l[0] || null == m || null == m[0]) return NaN;
                var n = [],
                  p = this.oh.indexOf(c.A);
                0 < m.length && 0 < l.length && b.length * m[0][0].length < a.length * l[0][0].length ? n = this.Rp(m[0][0], b, this.Uh) : 0 < l.length && (n = this.Rp(l[0][0], a, this.wk));
                if (c.Oa) {
                  if (b = this.Up(n, c.Sd, c.Gk, 0, b, a, c.zn), !0 === b || !1 === b) b = !0 === b ? 1 : 0;
                } else b = c.aa == k.i.da.mj ? c.type == k.i.Qa.zc ? this.kM(n, c) : this.Kda(n, b, a, p) : this.Rg(n, p, c.aa);
                g[d] = b;
                0 < this.Dh.length && (null == this.Qn[d] && (this.Qn[d] = []), this.Qn[d][p] = this.s_(n, p));
                return b;
              }
              return g[d];
            }
            s_(b, a) {
              if (void 0 == this.Dh[a]) return null;
              for (var c = !1, d = {
                  Op: 0,
                  Ys: 0
                }, g = 0; g < b.length; g++) this.Dh[a][b[g]] && 0 != this.Dh[a][b[g]].Op && !isNaN(this.Dh[a][b[g]].Op) && (d.Op += this.Dh[a][b[g]].Op, d.Ys += this.Dh[a][b[g]].Ys, c = !0);
              return c ? d : null;
            }
            pack() {
              if (!this.va.fa.RM) {
                var b = this.va.O.yc(!1);
                65536 > this.mh.length ? this.mh = new Uint16Array(this.mh) : 4294967296 > this.mh.length && (this.mh = new Uint32Array(this.mh));
                var a;
                for (a = 0; a < b.length; a++) {
                  var c = b.ea(a),
                    d = this.je.indexOf(c.A);
                  -1 === d && (d = this.je.indexOf(c.caption));
                  for (var g = 1; g < this.wa[d].length; g++) 256 > c.Wi && this.vb.hasOwnProperty(this.wa[d][g]) ? this.vb[this.wa[d][g]] = new Uint8Array(this.vb[this.wa[d][g]]) : 65536 > c.Wi && this.vb.hasOwnProperty(this.wa[d][g]) ? this.vb[this.wa[d][g]] = new Uint16Array(this.vb[this.wa[d][g]]) : 4294967296 > c.Wi && this.vb.hasOwnProperty(this.wa[d][g]) && (this.vb[this.wa[d][g]] = new Uint32Array(this.vb[this.wa[d][g]]));
                }
                for (a = 0; a < this.oh.length; a++) c = b.getItem(this.oh[a]), null != c && (c = this.va.O.dD(c.A), c !== k.i.input.sa.jb && c !== k.i.input.sa.lj && c !== k.i.input.sa.Lc && c !== k.i.input.sa.ic && (this.Hc[a] = new Uint8Array(this.Hc[a])));
              }
            }
            filter() {
              this.Od = [];
              this.Bd = [];
              this.values = [];
              this.RQ = [];
              this.Vl = [];
              this.Qn = [];
              this.$ta();
              this.pack();
              var b = e.model.C.F.tc && e.model.C.F.ke != e.K.Id.kj,
                a = this.slice.yc(!1, !0, b),
                c = new e.ub(),
                d = new e.ub(),
                g,
                l,
                m = this.slice.gd();
              for (g = 0; g < a.length; g++) (l = a.ea(g)) && l.filter.zh && (l.filter.ei ? (b ? d.Ua(l.A, l) : m.find(n => n.A === l.filter.measure.A) && !this.slice.ob.Bb(l.A) && d.Ua(l.A, l), l.filter.Ei && c.Ua(l.A, l)) : c.Ua(l.A, l));
              this.Sv(c, this.mh);
              for (g = 0; g < d.length; g++) l = d.ea(g), !b || l.filter.Ku && l.filter.measure && this.va.O.$q.Bb(l.filter.measure.A) ? this.hua(l) : this.Xta(l);
              this.Sv(d, this.cb);
              if (0 < d.length && !b) for (b = [], g = 0; g < a.length; g++) c = a.ea(g), d = this.je.indexOf(c.A), -1 === d && (d = this.je.indexOf(c.caption)), b.push(d), c.filter.ei && (d = this.va.O.Ca.getItem(c.filter.measure.A), void 0 !== d && (m = this.oh.indexOf(d.A), this.cb = this.laa(b, 0, this.cb.slice(), m, d, c.filter, [])));
            }
            laa(b, a, c, d, g, l, m) {
              let n = b[a],
                p = [],
                t;
              for (let r = 0; r < c.length; r++) t = this.vb[n][c[r]], void 0 === p[t] && (p[t] = []), p[t].push(c[r]);
              for (let r in p) this.Bra(p[r], d, g, l) && (m = a === b.length - 1 ? m.concat(p[r]) : this.laa(b, a + 1, p[r], d, g, l, m));
              return m;
            }
            Bra(b, a, c, d) {
              if (c.Oa) {
                var g = e.v(this.hu[a]) ? c.Sd : this.hu[a];
                a = e.v(this.Xw[a]) ? c.Gk : this.Xw[a];
                b = this.Up(b, g, a, 0, null, null, c.zn);
              } else b = c.aa == k.i.da.mj ? this.kM(b, c) : this.Rg(b, a, c.aa);
              if (d.query.ua === k.i.Vb.Nj || d.query.ua === k.i.Vb.ni) return !0;
              if (d.query.ua === k.i.Vb.EQUAL) return b === d.query.value;
              if (d.query.ua === k.i.Vb.Pf) return b !== d.query.value;
              if (d.query.ua === k.i.Vb.GREATER) return b > d.query.value;
              if (d.query.ua === k.i.Vb.Xk) return b >= d.query.value;
              if (d.query.ua === k.i.Vb.LESS) return b < d.query.value;
              if (d.query.ua === k.i.Vb.$k) return b <= d.query.value;
              if (d.query.ua === k.i.Vb.fh) return b >= d.query.value[0] && b <= d.query.value[1];
              if (d.query.ua === k.i.Vb.Og) return b < d.query.value[0] || b > d.query.value[1];
            }
            Sv(b, a) {
              for (var c = [], d = [], g = 0; g < b.length; g++) {
                var l = b.ea(g),
                  m = this.je.indexOf(l.A);
                if (l.filter.zh) {
                  c.push(m);
                  d.push(l.tya().length / l.wd.children.length);
                  this.filters[m] = [];
                  this.Ix[m] = [];
                  for (var n = 0; n < l.cb.length; n++) {
                    var p = l.za(l.cb[n]);
                    1 === p.level.yb ? this.filters[m][p.ordinal] = !0 : (void 0 === this.Ix[m][p.root.ordinal] && (this.Ix[m][p.root.ordinal] = []), void 0 === this.Ix[m][p.root.ordinal][p.level.yb] && (this.Ix[m][p.root.ordinal][p.level.yb] = []), this.Ix[m][p.root.ordinal][p.level.yb][p.ordinal] = !0);
                  }
                }
              }
              d = e.Ja.sort(d, e.Ja.Fv | e.Ja.Qi);
              if (0 < c.length) for (g = 0; g < c.length; g++) {
                b = c[d[g]];
                l = [];
                for (m = 0; m < a.length; m++) if (n = this.vb[this.wa[b][1]][a[m]], !0 === this.filters[b][n]) l.push(a[m]);else if (void 0 !== this.Ix[b][n]) for (p = 2; p < this.wa[b].length; p++) if (void 0 !== this.Ix[b][n][p] && !0 === this.Ix[b][n][p][this.vb[this.wa[b][p]][a[m]]]) {
                  l.push(a[m]);
                  break;
                }
                a = l;
              }
              this.cb = a;
            }
            Fra(b) {
              var a = this.je.indexOf(b.vz.A),
                c = this.je.indexOf(b.A);
              -1 === a && (a = this.ym(b.vz.A, b.A), this.wa[c].pop(), this.wa[c].splice(1, 0, a));
              var d = [],
                g;
              for (g in b.groups) for (var l = b.Ib(b.zm(g)), m = 0; m < b.groups[g].length; m++) {
                var n = b.za(b.groups[g][m]);
                null !== n && (d[n.ordinal] = l.ordinal);
              }
              b = b.Ib(b.zm("Others"));
              void 0 === this.vb[a] && (this.vb[a] = []);
              for (g = 0; g < this.Nx; g++) n = this.vb[c][g], this.vb[a][g] = void 0 !== d[n] ? d[n] : b.ordinal;
            }
            Nra(b) {
              var a = this.je.indexOf(b.A);
              if (this.wa[a] && this.wa[a].length > b.wa.length) for (var c = 0; c < this.wa[a].length; c++) if (!b.wa.Bb(this.je[this.wa[a][c]])) {
                this.wa[a].splice(c, 1);
                break;
              }
            }
            $ta() {
              var b,
                a,
                c = this.slice.yc(!1);
              for (b = 0; b < c.length; b++) (a = c.ea(b)) && (null != a.vz ? this.Fra(a) : this.Nra(a));
            }
            Xta(b) {
              if (b.filter.ei) {
                var a = this.va.O.Ca.getItem(b.filter.measure.A);
                if (void 0 !== a) {
                  for (var c = [], d = [], g = this.oh.indexOf(a.A), l = 0; l < this.cb.length; l++) c.push(this.rT(l, g, a, !0)), d.push(this.rT(l, g, a, !1));
                  b.filter.query.ua == k.i.Vb.Nj ? b.cb = this.Wta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.ni ? b.cb = this.Nta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.EQUAL ? b.cb = this.Ota(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.Pf ? b.cb = this.Uta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.GREATER ? b.cb = this.Qta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.Xk ? b.cb = this.Pta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.LESS ? b.cb = this.Sta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.$k ? b.cb = this.Rta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.fh ? b.cb = this.Mta(c, d, Math.min(b.filter.query.value[0], b.filter.query.value[1]), Math.max(b.filter.query.value[0], b.filter.query.value[1])) : b.filter.query.ua == k.i.Vb.Og && (b.cb = this.Tta(c, d, Math.min(b.filter.query.value[0], b.filter.query.value[1]), Math.max(b.filter.query.value[0], b.filter.query.value[1])));
                }
              }
            }
            Wta(b, a, c) {
              var d = [];
              b = e.Ja.sort(b, e.Ja.lp | e.Ja.Fv | e.Ja.Qi);
              c = Math.min(c, a.length);
              for (var g = 0; g < c; g++) d.push(a[b[g]]);
              return d;
            }
            Nta(b, a, c) {
              var d = [];
              b = e.Ja.sort(b, e.Ja.Fv | e.Ja.Qi);
              c = Math.min(c, a.length);
              for (var g = 0; g < c; g++) d.push(a[b[g]]);
              return d;
            }
            Ota(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] == c && d.push(a[l]);
              return d;
            }
            Uta(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] != c && d.push(a[l]);
              return d;
            }
            Qta(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] > c && d.push(a[l]);
              return d;
            }
            Pta(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] >= c && d.push(a[l]);
              return d;
            }
            Sta(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] < c && d.push(a[l]);
              return d;
            }
            Rta(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] <= c && d.push(a[l]);
              return d;
            }
            Mta(b, a, c, d) {
              for (var g = [], l = a.length, m = 0; m < l; m++) b[m] >= c && b[m] <= d && g.push(a[m]);
              return g;
            }
            Tta(b, a, c, d) {
              for (var g = [], l = a.length, m = 0; m < l; m++) (b[m] < c || b[m] > d) && g.push(a[m]);
              return g;
            }
            hua(b) {
              if (b.filter.ei) {
                var a = this.slice.Di(b.filter.measure);
                if (void 0 !== a) {
                  var c = [],
                    d = [],
                    g = [],
                    l = this.je.indexOf(b.A);
                  l = this.wa[l][b.lc ? b.lc.yb : 1];
                  if (this.Vl[l]) for (var m in this.Vl[l]) g.push(this.Vl[l][m]);else g = [l];
                  l = [];
                  for (m = 0; m < g.length; m++) for (var n = 0; n < this.cb.length; n++) {
                    var p = this.vb[g[m]][this.cb[n]];
                    null == l[p] && (l[p] = []);
                    l[p].push(this.cb[n]);
                  }
                  g = this.oh.indexOf(a.A);
                  n = b.filter.Ei ? b.filter.yj() : b.qs;
                  p = a.Oa;
                  var t = b.lc ? b.lc.yb : 1;
                  for (m = 0; m < n.length; m++) {
                    var r = b.za(n[m]);
                    if (!r.dc && r.level.yb == t && void 0 !== l[r.ordinal]) {
                      if (p) {
                        var w = e.v(this.hu[g]) ? a.Sd : this.hu[g];
                        var y = e.v(this.Xw[g]) ? a.Gk : this.Xw[g];
                        w = this.Up(l[r.ordinal], w, y, 0, null, null, a.zn);
                      } else w = l[r.ordinal], w = a.aa == k.i.da.mj ? this.kM(w, a) : this.Rg(w, g, a.aa);
                      isNaN(w) && (w = Number.MIN_VALUE);
                      c.push(w);
                      d.push(r.ordinal);
                    }
                  }
                  b.filter.query.ua == k.i.Vb.Nj ? b.cb = this.gua(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.ni ? b.cb = this.Jta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.EQUAL ? b.cb = this.Kta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.Pf ? b.cb = this.eua(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.GREATER ? b.cb = this.Zta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.Xk ? b.cb = this.Yta(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.LESS ? b.cb = this.bua(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.$k ? b.cb = this.aua(c, d, b.filter.query.value) : b.filter.query.ua == k.i.Vb.fh ? b.cb = this.Ita(c, d, Math.min(b.filter.query.value[0], b.filter.query.value[1]), Math.max(b.filter.query.value[0], b.filter.query.value[1])) : b.filter.query.ua == k.i.Vb.Og && (b.cb = this.dua(c, d, Math.min(b.filter.query.value[0], b.filter.query.value[1]), Math.max(b.filter.query.value[0], b.filter.query.value[1])));
                }
              }
            }
            gua(b, a, c) {
              var d = [];
              b = e.Ja.sort(b, e.Ja.lp | e.Ja.Fv | e.Ja.Qi);
              c = Math.min(c, a.length);
              for (var g = 0; g < c; g++) d.push(a[b[g]]);
              return d;
            }
            Jta(b, a, c) {
              var d = [];
              b = e.Ja.sort(b, e.Ja.Fv | e.Ja.Qi);
              c = Math.min(c, a.length);
              for (var g = 0; g < c; g++) d.push(a[b[g]]);
              return d;
            }
            Kta(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] == c && d.push(a[l]);
              return d;
            }
            eua(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] != c && d.push(a[l]);
              return d;
            }
            Zta(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] > c && d.push(a[l]);
              return d;
            }
            Yta(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] >= c && d.push(a[l]);
              return d;
            }
            bua(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] < c && d.push(a[l]);
              return d;
            }
            aua(b, a, c) {
              for (var d = [], g = a.length, l = 0; l < g; l++) b[l] <= c && d.push(a[l]);
              return d;
            }
            Ita(b, a, c, d) {
              for (var g = [], l = a.length, m = 0; m < l; m++) b[m] >= c && b[m] <= d && g.push(a[m]);
              return g;
            }
            dua(b, a, c, d) {
              for (var g = [], l = a.length, m = 0; m < l; m++) (b[m] < c || b[m] > d) && g.push(a[m]);
              return g;
            }
            Rg(b, a, c) {
              return null === b || -1 === a ? NaN : 0 === b.length ? c === k.i.da.zc ? 0 : NaN : c === k.i.da.NONE ? this.Hc[a][b[0]] : c === k.i.da.zc ? this.gAa(b, a) : c === k.i.da.mj ? this.Kda(b, [], [], a) : c === k.i.da.Vr ? this.dBa(b, a) : c === k.i.da.Gv ? this.xBa(b, a) : c === k.i.da.Hv ? this.yBa(b, a) : 1 === b.length ? this.Hc && this.Hc[a] ? this.Hc[a][b[0]] : NaN : c === k.i.da.Mq || c === k.i.da.tp || c === k.i.da.Kq || c === k.i.da.Iq || c === k.i.da.Jq || c === k.i.da.Pi || c === k.i.da.Xn || c === k.i.da.fn || c === k.i.da.co || c === k.i.da.hn || c === k.i.da.jn || c === k.i.da.fo ? this.H1(b, a) : c === k.i.da.Bt ? this.hBa(b, a) : c === k.i.da.Bq ? this.uda(b, a) : c === k.i.da.Av ? this.RAa(b, a) : c === k.i.da.MAX ? this.NAa(b, a) : c === k.i.da.MIN ? this.UAa(b, a) : 0;
            }
            DM() {
              return this.vb;
            }
            pI() {
              this.z_();
              for (var b, a = this.va.O.h1(), c = 0; c < a.length; c++) {
                var d = a[c];
                b = this.va.O.bD(d);
                if (b instanceof h.O.t8) k.i.MA.YA == b.type ? (this.ym(d + ".Year"), this.yn(this.va.O.mf(d + ".Year")), this.ym(d + ".Month"), this.yn(this.va.O.mf(d + ".Month")), this.ym(d + ".Day"), this.yn(this.va.O.mf(d + ".Day"))) : b.Pa.Bb(d) && (this.ym(d), this.yn(this.va.O.mf(d)));else if (b instanceof h.O.wP) for (this.ym(d), this.yn(this.va.O.mf(d)), d = 2; d < b.wa.length; d++) {
                  var g = b.wa.ea(d);
                  this.ym(g.A, b.A);
                } else b instanceof h.O.xP && (1 === b.yb ? (this.ym(b.hierarchy.A), this.yn(this.va.O.mf(b.hierarchy.A))) : this.ym(b.A, b.hierarchy.A));
              }
              if (this.slice) {
                for (c = 0; c < this.va.O.Ca.length; c++) b = this.va.O.Ca.ea(c), this.ym(b.A), this.yn(b);
                for (c = 0; c < this.slice.Sf.length; c++) b = this.slice.Sf[c], this.ym(b.A), this.yn(b);
              }
            }
            yn(b) {
              b && (this.QK(b), this.Fy(b));
            }
            xaa(b) {
              for (var a = this.va.O.bD("Browser"), c = 0; c < b.length; c++) a.oc(new k.O.ae({
                A: b[c].value
              }));
            }
            Gza(b) {
              var a = this.Zga(b, {
                  from: 0,
                  fp: 500,
                  px: 30
                }) + 1,
                c = this.Zga(b, {
                  from: 0,
                  fp: 30,
                  px: 0
                }) + 1,
                d = .3 > Math.abs(Math.sin(7 * b)) ? 1 : 0;
              this.vb[0][b] = this.qIa(5 * b, this.zY) + 1;
              this.vb[1][b] = a * (4 > c ? c : 10 > c ? Math.round(c / 3) : Math.round(c / 7));
              this.vb[2][b] = c;
              this.vb[3][b] = d;
            }
            W0(b) {
              this.xaa(this.zY);
              var a = u.Jd().Rm ? 5E5 : 1E6;
              this.vb = [];
              this.vb[0] = new Uint8Array(a);
              this.vb[1] = new Uint16Array(a);
              this.vb[2] = new Uint8Array(a);
              this.vb[3] = new Uint8Array(a);
              this.mh[a - 1] = a;
              this.Bd = [];
              this.Bd = [[this.cb, [], [], void 0, void 0]];
              this.Od = [[this.cb, [], [], void 0, void 0]];
              this.xaa(this.zY);
              b();
            }
            Zga(b, a) {
              b = Math.abs(Math.sin(1.17 * b)) * (a.fp - a.from) + a.from;
              if (b >= a.px) {
                var c = (b - a.px) / (5 * (a.fp - a.px));
                a = (b - a.px) * c + a.px;
              } else c = (a.px - b) / (5 * (a.px - a.from)), a = (a.px - b) * c + a.from;
              return Math.round(a);
            }
            qIa(b, a) {
              b = Math.abs(Math.sin(b));
              for (var c = 0, d = 0; d < a.length; d++) if (c += a[d].DN, c > b) return d;
              return a.length - 1;
            }
          }
          h.vP = f;
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.rt {
              constructor(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                super(a, c);
                this.Ke = e.model.C.F.Ke;
                a = new f.xP(a + ".[(all)]", "All", 0);
                this.Mh(a);
                this.Bs = this.Am = "(all member)";
                a = new k.O.ae({
                  A: "(all member)",
                  caption: "All",
                  dc: !0
                });
                super.oc(a);
              }
              oc(a, c, d) {
                if (void 0 === c) return super.oc(a);
                e.ia(a.value) || "null" === a.value || "undefined" === a.value ? (e.model.C.F.ir ? a.A = a.value + "" : (a.A = void 0 === a.parent ? "" : ("[" === a.parent.A.substr(0, 1) ? a.parent.A : "[" + a.parent.A + "]") + ".[]", a.caption = a.value = ""), "" === a.caption && (a.caption = e.model.B.j.Fl)) : d === k.i.input.sa.jb && (a.fc = a.value);
                if (c === k.i.input.sa.jb) c = this.vta(a);else if (c === k.i.input.sa.$c || c === k.i.input.sa.kn || c === k.i.input.sa.ih) c = this.Haa(a);else if (c === k.i.input.sa.Ta) c = this.Ysa(a);else if (c === k.i.input.sa.Of) c = this.ota(a, a.level);else if (c === k.i.input.sa.Fq) c = this.Aaa(a, !1);else if (c === k.i.input.sa.op) c = this.Aaa(a, !0);else if (c === k.i.input.sa.lj) c = this.$sa(a);else if (c === k.i.input.sa.Lc) c = this.bta(a);else if (c === k.i.input.sa.ic) c = this.Cta(a);else {
                  if (c === k.i.input.sa.ay || c === k.i.input.sa.g8 || c === k.i.input.sa.wF) return null;
                  c = this.Haa(a);
                }
                void 0 !== a.We && c.We.lta(a.We);
                return c;
              }
              hD() {
                return new f.Tna(this);
              }
              zm() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "(Total)";
                return a.toLocaleLowerCase();
              }
              get interval() {
                return this.type === k.i.Fc.Ta ? this.XQ : null;
              }
              set interval(a) {
                if (this.type === k.i.Fc.Ta) {
                  const c = a.substr(-1);
                  if ("y" === c || "q" === c || "M" === c || "w" === c) a = "1" + c;
                  this.XQ = a;
                } else this.XQ = null;
              }
              get zk() {
                return this.Rra;
              }
              set zk(a) {
                this.Rra = a;
              }
              getTimezoneOffset() {
                if (this.type !== k.i.Fc.Ta) return null;
                if (!e.v(this.zk)) return u.Eh.qg(this.zk);
                var a = this.mapping.La(this.A, "format");
                if (!e.v(a)) return u.Eh.qg(a);
                a = this.wa.ea(1);
                if (a.type === k.i.ib.Ta || a.type === k.i.ib.lj) {
                  if (a = u.Eh.qg(e.model.C.F.Lp), null !== a) return a;
                } else if (a.type === k.i.ib.Lc && (a = u.Eh.qg(e.model.C.F.zk), null !== a)) return a;
                return e.v(e.model.C.F.Uj) || isNaN(e.model.C.F.Uj) ? null : e.model.C.F.Uj;
              }
              get inputType() {
                return this.WF;
              }
              set inputType(a) {
                this.WF = a;
              }
              get Rd() {
                return !0;
              }
              set Rd(a) {}
              Haa(a) {
                var c = void 0 === a.A ? a.value + "" : a.A,
                  d = this.Ib(c);
                null === d && (a.A = c, void 0 === a.caption && (a.caption = a.value + ""), d = super.oc(a));
                return d;
              }
              vta(a) {
                var c = void 0 === a.A ? a.value + "" : a.A;
                if (!this.Ke) {
                  var d = this.Ib(c);
                  null === d && (a.A = c, void 0 === a.caption && (a.caption = a.value + ""), a.fc = e.model.C.F.ir && e.v(a.value) ? a.value : e.P.J5(a.value), d = super.oc(a));
                }
                return d;
              }
              bta(a) {
                var c = new e.gh(a.value, {
                  Gy: !1
                });
                c.uh(this.getTimezoneOffset());
                this instanceof k.external.pc.O.xO || c.round(this.interval);
                c = c.getTime();
                let d = a.A;
                if (void 0 === a.A || e.v(a.parent) && e.v(a.Hi)) d = isNaN(c) ? e.model.B.j.Wn : "" + c;
                var g = this.Ib(d);
                null === g && (a.A = d, a.fc = c, g = super.oc(a));
                return g;
              }
              Cta(a) {
                const c = parseFloat(a.value);
                var d = this.mapping.La(this.A, "format", e.model.C.F.ep),
                  g = isNaN(c) || "" === String(a.value).trim() || c.toString() !== a.value.toString();
                d = g ? "" : e.P.Lx(c, d);
                g = g ? "" : `${c}`;
                let l = this.Ib(g);
                null === l && (a.A = g, a.caption = d, a.fc = c, l = super.oc(a));
                return l;
              }
              $sa(a) {
                var c = new e.gh(a.value, {
                  Gy: !1
                });
                c.uh(this.getTimezoneOffset());
                this instanceof k.external.pc.O.xO || c.round(this.interval);
                var d = c.getTime();
                c = d;
                let g = a.A;
                if (void 0 === a.A || e.v(a.parent) && e.v(a.Hi)) g = isNaN(d) ? e.model.B.j.Wn : "" + d;
                !e.model.C.F.ir || null !== a.value && "null" !== a.value || (g = "null", c = null);
                d = this.Ib(g);
                null === d && (a.A = g, a.fc = c, d = super.oc(a));
                return d;
              }
              Aaa(a, c) {
                var d = new e.gh(a.value, {
                  Gy: !1
                });
                e.v(e.model.C.F.Uj) || d.uh(e.model.C.F.Uj);
                var g = "";
                if (null != d && !isNaN(d.getTime()) && d.ah()) {
                  var l = e.model.B.j.j9[Math.floor(d.getMonth() / 3)];
                  var m = e.model.B.j.Ur[d.getMonth()];
                  var n = d.getDate().toString();
                  var p = d.getFullYear().toString();
                  d = d.getTime();
                } else return n = e.model.B.j.Wn, p = this.Ib(n), null === p && (a.A = n, a.caption = n, p = super.oc(a)), p;
                var t = "" + p,
                  r = p;
                p = this.Ib(t);
                null === p && (a.A = t, a.caption = r, p = super.oc(a));
                c && (c = `[${t}].[${l}]`, r = l, g = p, p = this.Ib(c), null === p && (a.A = c, a.caption = r, a.parent = g, p = super.oc(a)), g = `.[${l}]`);
                l = m;
                m = `[${t}]${g}.[${m}]`;
                g = p;
                p = this.Ib(m);
                null === p && (a.A = m, a.caption = l, a.parent = g, p = super.oc(a));
                l = n;
                n = `${m}.[${n}]`;
                g = p;
                p = this.Ib(n);
                null === p && (a.A = n, a.caption = l, a.parent = g, a.fc = d, p = super.oc(a));
                return p;
              }
              Ysa(a) {
                var c = [],
                  d = new e.gh(a.value, {
                    Gy: !1
                  });
                e.v(e.model.C.F.Uj) || d.uh(e.model.C.F.Uj);
                if (null !== d && !isNaN(d.getTime()) && d.ah()) {
                  var g = e.model.B.j.Ur[d.getMonth()];
                  var l = d.getDate().toString();
                  var m = d.getFullYear().toString();
                  var n = d.getTime();
                } else {
                  l = e.model.B.j.Wn;
                  for (n = 0; 3 > n; n++) {
                    a = this.zi.Pa.ea(n);
                    var p = a.Ib(l);
                    null === p && (p = a.oc(new k.O.ae({
                      A: l
                    })));
                    c.push(p);
                  }
                  return c;
                }
                a = this.zi.Pa.ea(0);
                var t = this.BW(m);
                p = a.Ib(t);
                null === p && (p = a.oc(new k.O.ae({
                  A: m,
                  caption: t,
                  fc: d.getFullYear()
                })));
                c.push(p);
                a = this.zi.Pa.ea(1);
                m = this.BW(g);
                p = a.Ib(m);
                null === p && (p = a.oc(new k.O.ae({
                  A: g,
                  caption: m
                })));
                c.push(p);
                a = this.zi.Pa.ea(2);
                g = this.BW(l);
                p = a.Ib(g);
                null === p && (p = a.oc(new k.O.ae({
                  A: l,
                  caption: g,
                  fc: n
                })));
                c.push(p);
                return c;
              }
              BW(a) {
                return a && 0 < a.length && "NaN" != a ? a : e.model.B.j.Wn;
              }
              ota(a, c) {
                var d = void 0 === a.parent ? this.Ib(a.Hi) : a.parent;
                null === d && void 0 !== a.Hi && (d = this.VS(a.Hi));
                var g = e.v(a.A) || !e.v(a.Hi) && "[" === a.Hi.substr(0, 1) || !e.v(a.A) && "[" === a.A.substr(0, 1) ? a.value + "" : a.A;
                if (1 < c.yb) {
                  var l = c.hierarchy.wa.ea(c.yb - 1);
                  null === d && (d = c.hierarchy.Ib(e.model.B.j.Fl), null === d && (d = l.hierarchy.oc(new k.O.ae({
                    A: e.model.B.j.Fl,
                    caption: e.model.B.j.Fl
                  }))));
                  g = 1 === l.yb ? `[${d.A}].[${g}]` : `${d.A}.[${g}]`;
                }
                l = c.hierarchy.Ib(g);
                null === l && (a.A = g, a.caption = e.v(a.caption) ? a.value : a.caption, a.parent = 1 < c.yb ? d : void 0, l = this.oc(a, k.i.ib.oA(c.type), k.i.ib.oA(c.inputType)));
                return l;
              }
              ij() {
                const a = super.ij();
                a.type = this.inputType;
                return a;
              }
              clone() {
                var a = super.clone();
                a.XQ = this.XQ;
                return a;
              }
            }
            f.wP = b;
          })(h.O || (h.O = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.qv {
              constructor(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                super(a, c, d);
              }
              get inputType() {
                return this.WF;
              }
              set inputType(a) {
                this.WF = a;
              }
            }
            f.xP = b;
          })(h.O || (h.O = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.aJ {
              Sa() {
                var a = super.Sa();
                a.uniqueName = this.Ci;
                this.parent && (a.parentMember = this.parent.Ci);
                return a;
              }
            }
            f.Tna = b;
          })(h.O || (h.O = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.Or {
              constructor(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                super(a, c);
              }
              get jc() {
                return e.model.Tb.valid(this.xc) ? this.xc : e.model.Tb.validate(this.xc);
              }
              get caption() {
                if (!1 === e.model.C.F.Fx || this.Oa) return this.jc;
                switch (this.aa) {
                  case k.i.da.zc:
                    return e.P.bind(e.model.B.j.FO, this.jc);
                  case k.i.da.Bt:
                    return e.P.bind(e.model.B.j.QP, this.jc);
                  case k.i.da.mj:
                    return e.P.bind(e.model.B.j.PO, this.jc);
                  case k.i.da.Bq:
                    return e.P.bind(e.model.B.j.AO, this.jc);
                  case k.i.da.Av:
                    return e.P.bind(e.model.B.j.QX, this.jc);
                  case k.i.da.Gv:
                    return e.P.bind(e.model.B.j.ZP, this.jc);
                  case k.i.da.Hv:
                    return e.P.bind(e.model.B.j.$P, this.jc);
                  case k.i.da.MAX:
                    return e.P.bind(e.model.B.j.AP, this.jc);
                  case k.i.da.MIN:
                    return e.P.bind(e.model.B.j.JP, this.jc);
                  case k.i.da.Vr:
                    return e.P.bind(e.model.B.j.VJ, this.jc);
                  case k.i.da.tp:
                    return e.P.bind(e.model.B.j.PJ, this.jc);
                  case k.i.da.Kq:
                    return e.P.bind(e.model.B.j.UJ, this.jc);
                  case k.i.da.Iq:
                    return e.P.bind(e.model.B.j.SJ, this.jc);
                  case k.i.da.Jq:
                    return e.P.bind(e.model.B.j.TJ, this.jc);
                  case k.i.da.Pi:
                    return e.P.bind(e.model.B.j.DJ, this.jc);
                  case k.i.da.jn:
                    return e.P.bind(e.model.B.j.SP, this.jc);
                  case k.i.da.fo:
                    return e.P.bind(e.model.B.j.UP, this.jc);
                  case k.i.da.Xn:
                    return e.P.bind(e.model.B.j.iJ, this.jc);
                  case k.i.da.fn:
                    return e.P.bind(e.model.B.j.jJ, this.jc);
                  case k.i.da.co:
                    return e.P.bind(e.model.B.j.QJ, this.jc);
                  case k.i.da.hn:
                    return e.P.bind(e.model.B.j.RJ, this.jc);
                  case k.i.da.NONE:
                    return this.jc;
                }
                return e.P.bind(e.model.B.j.aK, this.jc);
              }
              set caption(a) {
                this.xc = a;
              }
              get rl() {
                return this.xc;
              }
              set rl(a) {}
              clone() {
                var a = new b(this.A);
                this.zL(a);
                return a;
              }
              ij() {
                const a = super.ij(),
                  c = k.Ma.R().O.Kk(this.A);
                e.v(c) ? a.type = k.i.input.sa.jb : a.type = c.inputType;
                return a;
              }
            }
            f.u8 = b;
          })(h.O || (h.O = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.AA {
              constructor(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                super(a, c);
              }
            }
            f.t8 = b;
          })(h.O || (h.O = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.YW {
              constructor() {
                super();
                this.id = this.xS = "";
                this.wa = [];
                this.Q1 = !1;
                this.NB = {};
                this.EB = {};
                this.YZ();
                this.lf = new e.ub();
                this.lw = {};
                this.Wz = {};
                this.dl = new e.ub();
                this.types = {};
                this.We = [];
                this.id = this.xS = "";
                this.Ke = e.model.C.F.Ke;
              }
              clear() {
                this.NB = {};
                this.EB = {};
                this.lf = new e.ub();
                this.lw = {};
                this.Wz = {};
                this.dl = new e.ub();
                this.types = {};
                this.id = this.xS = "";
                super.clear();
              }
              Jo(a, c) {
                return new f.wP(a, c);
              }
              Yda(a, c) {
                return new f.u8(a, c);
              }
              Zl(a, c, d) {
                return new f.xP(a, c, d);
              }
              Kk(a) {
                return this.NB[a];
              }
              mf(a) {
                return this.EB[a];
              }
              dD(a) {
                if (void 0 !== this.types[a]) return this.types[a];
                a = this.Wz[a];
                if (!e.v(a)) return this.types[a];
              }
              Dda(a) {
                return this.We[a];
              }
              bD(a) {
                let c = this.lf.getItem(a);
                if (e.v(c)) {
                  if (a = this.lw[a], Array.isArray(a)) {
                    let d = [];
                    for (let g = 0; g < a.length; g++) c = this.lf.getItem(a[g]), e.v(c) || d.push(c);
                    return d;
                  }
                } else return c;
              }
              h1() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                let c = this.lf.Pc(!0);
                if (a || 0 === Object.keys(this.lw).length) return c;
                a = [];
                for (let d = 0; d < c.length; d++) void 0 !== this.Wz[c[d]] ? -1 === a.indexOf(this.Wz[c[d]]) && a.push(this.Wz[c[d]]) : a.push(c[d]);
                return a;
              }
              TK(a, c) {
                this.Ke || (this.NB[a] = this.ph(c), this.EB[c] = this.fd(a));
              }
              xp(a, c, d, g) {
                c = this.Yda(a, c);
                c.type = d;
                g.hasOwnProperty("supportedAggregations") && (c.dk = g.supportedAggregations);
                c.Wc = g.availableAggregations;
                this.rk(c);
                this.TK(c.A, a);
                return c;
              }
              Gaa(a, c, d) {
                var g = c.uniqueName,
                  l = e.ia(c.caption) ? d : c.caption,
                  m = this.Jo(g, l);
                m.type = k.i.Fc.uv;
                void 0 !== c.folder && (m.Oc = c.folder);
                a.wi(m);
                a = this.Zl(m.caption == e.model.B.j.Fl ? g + ".[]" : g, m.caption, 1);
                a.type = k.i.ib.$c;
                m.Mh(a);
                this.Ke || this.xp(g, l, k.i.Qa.zc, c);
                this.lf.Ua(d, m);
                this.dl.Ua(d, m);
                m.inputType = c.type;
              }
              hta(a, c, d) {
                var g = c.uniqueName,
                  l = e.ia(c.caption) ? d : c.caption;
                a.type = k.i.MA.YA;
                var m = this.Jo(g, l);
                m.type = k.i.Fc.Ta;
                void 0 !== c.folder && (m.Oc = c.folder);
                a.wi(m);
                var n = g + ".Year";
                a = this.Zl(n, e.model.B.j.Jl, m.wa.length);
                a.type = k.i.ib.Jl;
                m.Mh(a);
                this.dl.Ua(n, a);
                c.type == k.i.input.sa.op && (n = g + ".Quarter", a = this.Zl(n, e.model.B.j.Ct, m.wa.length), a.type = k.i.ib.Ct, m.Mh(a), this.dl.Ua(n, a));
                n = g + ".Month";
                a = this.Zl(n, e.model.B.j.ih, m.wa.length);
                a.type = k.i.ib.ih;
                m.Mh(a);
                this.dl.Ua(n, a);
                n = g + ".Day";
                a = this.Zl(n, e.model.B.j.en, m.wa.length);
                a.type = k.i.ib.en;
                m.Mh(a);
                this.dl.Ua(n, a);
                this.Ke || this.xp(g, l, k.i.Qa.zc, c);
                e.v(c.interval) ? m.interval = this.mapping.La(g, "interval", "1d") : m.interval = c.interval;
                this.lf.Ua(d, m);
                m.inputType = c.type;
              }
              Caa(a, c, d) {
                var g = c.hasOwnProperty("hierarchy") ? c.hierarchy : c.uniqueName,
                  l = a.ph(g);
                void 0 === l && (l = this.Jo(g, g), void 0 !== c.folder && (l.Oc = c.folder), a.wi(l));
                var m = 0;
                if (c.hasOwnProperty("parent")) {
                  m = l.Cu(c.parent);
                  void 0 === m && (m = l.Cu(c.parent.toLowerCase()));
                  if (void 0 === m) {
                    void 0 === this.wa[l.A] && (this.wa[l.A] = []);
                    this.wa[l.A][c.parent] = [c, d];
                    return;
                  }
                  m = l.wa.indexOf(m.A);
                } else l.type = k.i.Fc.$S(c.levelType);
                var n = c.hasOwnProperty("caption") ? c.caption : c.hasOwnProperty("level") ? c.level : d;
                m = this.Zl(d, n, m + 1);
                m.type = k.i.ib.$S(c.levelType);
                m.inputType = k.i.ib.$S(c.inputType);
                l.Mh(m);
                this.Ke || e.v(this.fd(g)) && this.xp(g, g, k.i.Qa.zc, c);
                this.lf.Ua(d, m);
                this.dl.Ua(d, m);
                this.wa[l.A] && this.wa[l.A][d] && this.Caa(a, this.wa[l.A][d][0], this.wa[l.A][d][1]);
                e.v(l.inputType) && (l.inputType = c.type);
              }
              Xsa(a, c, d) {
                var g = c.uniqueName,
                  l = e.ia(c.caption) ? d : c.caption;
                a.type = k.i.MA.YA;
                var m = g + ".Year",
                  n = l + "." + e.model.B.j.Jl;
                var p = this.Jo(m, n);
                p.type = k.i.Fc.Ta;
                void 0 !== c.folder && (p.Oc = c.folder);
                e.v(c.interval) ? p.interval = this.mapping.La(g, "interval", "1d") : p.interval = c.interval;
                a.wi(p);
                var t = this.Zl(m + "." + n, n, 1);
                t.type = k.i.ib.Jl;
                p.Mh(t);
                this.dl.Ua(m, t);
                this.Ke || this.xp(m, n, k.i.Qa.zc, c);
                p.inputType = c.type;
                m = g + ".Month";
                n = l + "." + e.model.B.j.ih;
                p = this.Jo(m, n);
                void 0 !== c.folder && (p.Oc = c.folder);
                e.v(c.interval) ? p.interval = this.mapping.La(g, "interval", "1d") : p.interval = c.interval;
                a.wi(p);
                var r = this.Zl(m + "." + n, n, 1);
                r.type = k.i.ib.ih;
                p.Mh(r);
                this.dl.Ua(m, t);
                this.Ke || this.xp(m, n, k.i.Qa.zc, c);
                p.inputType = c.type;
                m = g + ".Day";
                l = l + "." + e.model.B.j.en;
                p = this.Jo(m, l);
                void 0 !== c.folder && (p.Oc = c.folder);
                e.v(c.interval) ? p.interval = this.mapping.La(g, "interval", "1d") : p.interval = c.interval;
                a.wi(p);
                g = this.Zl(m + "." + l, l, 1);
                g.type = k.i.ib.en;
                p.Mh(g);
                this.dl.Ua(m, t);
                this.Ke || this.xp(m, l, k.i.Qa.zc, c);
                p.inputType = c.type;
                this.lf.Ua(d, a);
              }
              uta(a, c, d, g) {
                var l = c.uniqueName;
                const m = e.ia(c.caption) ? d : c.caption;
                this.Ke ? g ? (l = this.xp(l, m, k.i.Qa.jb, c), e.ia(c.folder) ? e.ia(c.dimensionCaption) ? e.ia(c.dimensionUniqueName) || (l.Ig = c.dimensionUniqueName) : l.Ig = c.dimensionCaption : l.Ig = c.folder, this.lf.Ua(d, l)) : (g = this.Jo(l, m), g.type = k.i.Fc.qp, void 0 !== c.folder && (g.Oc = c.folder), a.wi(g), l = this.Zl(l, m, 1), l.type = k.i.ib.jb, g.Mh(l), this.lf.Ua(d, g), this.dl.Ua(d, g), g.inputType = c.type) : (g = this.Jo(l, m), g.type = k.i.Fc.qp, void 0 !== c.folder && (g.Oc = c.folder), a.wi(g), a = this.Zl(l, m, 1), a.type = k.i.ib.jb, g.Mh(a), this.xp(l, m, k.i.Qa.jb, c), this.lf.Ua(d, g), this.dl.Ua(d, g), g.inputType = c.type);
              }
              sta(a, c, d) {
                var g = c.uniqueName,
                  l = e.ia(c.caption) ? d : c.caption,
                  m = this.Jo(g, l);
                m.type = k.i.Fc.Ta;
                void 0 !== c.folder && (m.Oc = c.folder);
                a.wi(m);
                a = this.Zl(g, l, 1);
                a.type = k.i.ib.ih;
                m.Mh(a);
                this.Ke || this.xp(g, l, k.i.Qa.zc, c);
                this.lf.Ua(d, m);
                this.dl.Ua(d, m);
                m.inputType = c.type;
              }
              Eta(a, c, d) {
                var g = c.uniqueName,
                  l = e.ia(c.caption) ? d : c.caption,
                  m = this.Jo(g, l);
                m.type = k.i.Fc.uv;
                void 0 !== c.folder && (m.Oc = c.folder);
                a.wi(m);
                a = this.Zl(g, l, 1);
                a.type = k.i.ib.en;
                m.Mh(a);
                this.Ke || this.xp(g, l, k.i.Qa.zc, c);
                this.lf.Ua(d, m);
                this.dl.Ua(d, m);
                m.inputType = c.type;
              }
              Zsa(a, c, d) {
                var g = c.uniqueName,
                  l = e.ia(c.caption) ? d : c.caption,
                  m = this.Jo(g, l);
                m.type = k.i.Fc.Ta;
                void 0 !== c.folder && (m.Oc = c.folder);
                a.wi(m);
                a = this.Zl(g, l, 1);
                a.type = k.i.ib.Ta;
                m.Mh(a);
                this.Ke || this.xp(g, l, k.i.Qa.Ta, c);
                e.v(c.interval) ? m.interval = this.mapping.La(g, "interval", "1d") : m.interval = c.interval;
                e.v(c.format) || (m.zk = c.format);
                this.lf.Ua(d, m);
                this.dl.Ua(d, m);
                m.inputType = c.type;
              }
              Bta(a, c, d) {
                var g = c.uniqueName,
                  l = e.ia(c.caption) ? d : c.caption,
                  m = this.Jo(g, l);
                m.type = k.i.Fc.qp;
                void 0 !== c.folder && (m.Oc = c.folder);
                a.wi(m);
                a = this.Zl(g, l, 1);
                a.type = k.i.ib.ic;
                m.Mh(a);
                this.Ke || this.xp(g, l, k.i.Qa.ic, c);
                this.lf.Ua(d, m);
                this.dl.Ua(d, m);
                m.inputType = c.type;
              }
              ata(a, c, d) {
                var g = c.uniqueName,
                  l = e.ia(c.caption) ? d : c.caption,
                  m = this.Jo(g, l);
                m.type = k.i.Fc.Ta;
                void 0 !== c.folder && (m.Oc = c.folder);
                a.wi(m);
                a = this.Zl(g, l, 1);
                a.type = k.i.ib.Lc;
                m.Mh(a);
                this.Ke || this.xp(g, l, k.i.Qa.Lc, c);
                e.v(c.interval) ? m.interval = this.mapping.La(g, "interval", "1s") : m.interval = c.interval;
                e.v(c.format) || (m.zk = c.format);
                this.lf.Ua(d, m);
                this.dl.Ua(d, m);
                m.inputType = c.type;
              }
              Kra(a, c) {
                for (var d = 0; d < a.length; d++) if ("string" !== typeof a[d]) return !1;
                for (var g in c) if (-1 === a.indexOf(g)) return !1;
                return !0;
              }
              yR(a, c) {
                if (a instanceof k.O.pm) {
                  var d = a;
                  a = a.mapping;
                } else !e.v(c) && k.O.pm.rU(a) && (d = new k.O.pm(a));
                if (void 0 !== d) {
                  var g = {};
                  if (Array.isArray(c)) {
                    if (this.Kra(c, a)) for (var l = 0; l < c.length; l++) {
                      const p = c[l];
                      g[p] = d.f3(p, a[p]);
                    }
                    for (var m in a) void 0 === g[m] && (g[m] = a[m]);
                  } else {
                    for (m in a) g[m] = a[m];
                    for (m in c) g[m] = "object" !== typeof a[m] ? {
                      uniqueName: m,
                      caption: m,
                      type: k.i.input.sa.T5(c[m])
                    } : a[m];
                  }
                }
                void 0 === g && (g = a);
                for (m in g) if (void 0 !== d || "string" !== typeof g[m] && "number" !== typeof g[m]) {
                  if (void 0 === d && e.v(g[m])) this.PZ(m, k.i.input.sa.$c);else if (void 0 === d && g[m] instanceof Date) this.PZ(m, e.model.C.F.HL);else if (void 0 === d && Array.isArray(g[m])) this.Dy(a[m], m);else if (g[m].hasOwnProperty("formula")) e.ia(g[m].formula) || this.bu(g[m], m);else if (Array.isArray(g[m])) this.Dy(g[m], m);else {
                    l = k.i.input.sa.$c;
                    g[m].hasOwnProperty("type") && (c = String(g[m].type).trim().toLowerCase(), k.i.input.sa.valid(c), l = k.we.type(c));
                    l !== k.i.input.sa.jb && (a[m] && delete a[m].isMeasure, delete g[m].isMeasure);
                    g[m].hasOwnProperty("isMeasure") && String(g[m].isMeasure).trim();
                    c = {};
                    for (var n in g[m]) c[n] = g[m][n];
                    c.type = l;
                    this.Dy(c, m);
                  }
                } else c = k.i.input.sa.T5(g[m]), this.PZ(m, c);
                this.Rd = !0;
              }
              bu(a, c) {
                c = new k.O.Or(c, void 0 == a.caption ? c : a.caption);
                c.De = a.formula;
                c.zn = void 0 == a.calculateNaN ? c.zn : a.calculateNaN;
                a.hasOwnProperty("grandTotalCaption") && (c.Xp = a.grandTotalCaption);
                e.model.C.F.sO && (a = u.iP.NR(c.De, c.A), 0 == a.Zw && e.Wa(a.errorMessage));
                e.model.Va.R().bu(c);
              }
              PZ(a, c) {
                this.Dy({
                  A: a,
                  caption: a,
                  JL: a,
                  type: c
                }, a);
              }
              Dy(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                if (!Array.isArray(a)) {
                  var d = {},
                    g;
                  for (g in a) d[g] = a[g];
                  d.hasOwnProperty("uniqueName") || (d.uniqueName = c);
                  d.hasOwnProperty("type") && (d.inputType = d.type);
                  a = this.mapping.f3(c, d);
                }
                if (!a.hasOwnProperty("visible") || !1 !== a.visible) if (Array.isArray(a)) for (this.lw[c] = [], d = 0; d < a.length; d++) void 0 === a[d].uniqueName && (a[d].uniqueName = `${c}.${d}`), this.W9(a[d]), this.lw[c].push(a[d].uniqueName), this.Wz[a[d].uniqueName] = c;else this.W9(a);
              }
              W9(a) {
                var c = a.uniqueName;
                "[Measures]" === c.substr(0, 10) && (k.we.LE = !1);
                e.v(a.hierarchy) || a.type === k.i.input.sa.wF || (a.levelType = a.type === k.i.input.sa.Of ? k.i.input.sa.$c : a.type, a.type = k.i.input.sa.Of);
                a.type === k.i.input.sa.Of && !1 === k.external.pc.O.Tn.KH && (a.type = k.i.input.sa.$c, a.hasOwnProperty("level") && (a.caption = a.level), delete a.hierarchy, delete a.level, delete a.parent);
                let d = k.i.input.sa.$c;
                k.i.input.sa.valid(a.type) && (d = a.type);
                var g;
                a.hasOwnProperty("dimensionUniqueName") ? g = this.Sp(a.dimensionUniqueName) : d === k.i.input.sa.Of && a.hasOwnProperty("hierarchy") && (g = this.Sp(a.hierarchy));
                let l = !1;
                a.hasOwnProperty("isMeasure") && (l = e.P.Zc(String(a.isMeasure).trim()));
                this.Ke && l || void 0 !== g || (g = k.O.AA.zb(a), a.uniqueName = k.we.Wg(a.uniqueName, a.caption), a.hasOwnProperty("dimensionUniqueName") && (g.caption = g.A = a.dimensionUniqueName), a.hasOwnProperty("dimensionCaption") && (g.caption = a.dimensionCaption), d === k.i.input.sa.Of && a.hasOwnProperty("hierarchy") && !a.hasOwnProperty("dimensionUniqueName") && (g.A = a.hierarchy), this.cu(g));
                this.types[c] = d;
                switch (d) {
                  case k.i.input.sa.$c:
                    this.Gaa(g, a, c);
                    break;
                  case k.i.input.sa.jb:
                    this.uta(g, a, c, l);
                    break;
                  case k.i.input.sa.ih:
                    this.sta(g, a, c);
                    break;
                  case k.i.input.sa.kn:
                    this.Eta(g, a, c);
                    break;
                  case k.i.input.sa.Ta:
                    this.Xsa(g, a, c);
                    break;
                  case k.i.input.sa.Lc:
                    this.ata(g, a, c);
                    break;
                  case k.i.input.sa.ic:
                    this.Bta(g, a, c);
                    break;
                  case k.i.input.sa.Of:
                    this.Caa(g, a, c);
                    break;
                  case k.i.input.sa.Fq:
                  case k.i.input.sa.op:
                    this.hta(g, a, c);
                    break;
                  case k.i.input.sa.lj:
                    this.Zsa(g, a, c);
                    break;
                  case k.i.input.sa.ay:
                    this.id = c;
                    this.lf.Ua(c, null);
                    break;
                  case k.i.input.sa.e7:
                    this.xS = c;
                    break;
                  case k.i.input.sa.g8:
                    break;
                  case k.i.input.sa.wF:
                    this.Wsa(a, c);
                    break;
                  default:
                    this.Gaa(g, a, c);
                }
              }
              oc(a, c, d, g, l) {
                if (Array.isArray(this.lw[c])) for (d = 0; d < this.lw[c].length; d++) this.X9(a, this.lw[c][d], this.dD(this.lw[c][d]), g, l);else return this.X9(a, c, d, g, l);
              }
              X9(a, c, d, g, l) {
                a = a.clone();
                if (this.Ke && d === k.i.input.sa.jb) l.push(e.P.J5(a.value));else {
                  var m = c = this.bD(c);
                  if (!e.v(m)) {
                    switch (d) {
                      case k.i.input.sa.Ta:
                        m = c.Pa.ea(0);
                        var n = m.oc(a, d);
                        break;
                      case k.i.input.sa.Of:
                        var p = c.hierarchy.wa.ea(c.yb - 1);
                        0 < p.yb && e.v(a.parent) && e.v(a.Hi) && (a.parent = c.hierarchy.za(g[this.dl.indexOf(p.A)]));
                        a.level = c;
                        p = c.hierarchy.oc(a, d);
                        break;
                      default:
                        p = m.oc(a, d);
                    }
                    switch (d) {
                      case k.i.input.sa.jb:
                        this.Ke || g.push(p.ordinal);
                        l.push(e.P.J5(a.value));
                        break;
                      case k.i.input.sa.Lc:
                      case k.i.input.sa.lj:
                        g.push(p.ordinal);
                        this.Ke || l.push(p.fc);
                        break;
                      case k.i.input.sa.Fq:
                        1 === p.level.yb ? (g.push(p.ordinal), g.push(NaN), g.push(NaN)) : (g.push(p.parent.parent.ordinal), g.push(p.parent.ordinal), g.push(p.ordinal));
                        this.Ke || l.push(1);
                        break;
                      case k.i.input.sa.op:
                        1 === p.level.yb ? (g.push(p.ordinal), g.push(NaN), g.push(NaN), g.push(NaN)) : (g.push(p.parent.parent.parent.ordinal), g.push(p.parent.parent.ordinal), g.push(p.parent.ordinal), g.push(p.ordinal));
                        this.Ke || l.push(1);
                        break;
                      case k.i.input.sa.Ta:
                        for (d = 0; d < n.length; d++) g.push(n[d].ordinal), this.Ke || l.push(1);
                        break;
                      case k.i.input.sa.ic:
                        g.push(p.ordinal);
                        this.Ke || l.push(p.fc);
                        break;
                      case k.i.input.sa.Of:
                        g.push(p.ordinal);
                        this.Ke || 1 === p.level.yb && l.push(1);
                        break;
                      default:
                        g.push(p.ordinal), this.Ke || (e.ia(a.value) ? l.push(NaN) : l.push(1));
                    }
                    return p;
                  }
                }
              }
              Wsa(a, c) {
                this.Q1 = !0;
                a = a.hierarchy;
                e.v(this.We[a]) && (this.We[a] = []);
                this.lf.Ua(c, null);
                this.We[a].push(c);
              }
            }
            f.yP = b;
          })(h.O || (h.O = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.cJ = 1048576;
              this.qU = !1;
              this.hC = this.tk = this.hL = 0;
              this.encoding = "UTF-8";
              this.fja = () => this.sHa();
              this.Lj = () => this.oq();
            }
            cO(b, a) {
              this.timer = new u.Et(100, 1E5);
              this.timer.N(u.vf.Gl, this.fja);
              this.timer.N(u.vf.Hl, this.Lj);
              this.timer.start();
              this.oa = new z.J9();
              this.oa.responseType = "blob";
              this.oa.N(v.ga.GA, () => this.gFa());
              this.oa.N(v.ga.te, c => this.xsa(c));
              this.oa.N(v.ga.Qc, () => this.vsa());
              this.oa.N(v.ga.xa, c => this.wsa(c));
              this.Vh(this.oa, a);
              this.oa.load(b);
            }
            xsa(b) {
              const a = b.data;
              404 == a.target.status ? this.Q3(b) : (this.tk = a.loaded, this.hL = a.total, this.mGa(a));
            }
            vsa() {
              if (!e.v(this.oa) && !e.v(this.oa.response)) {
                this.qU = !0;
                this.hC = 0;
                this.hL = this.oa.response.size;
                this.encoding = this.oa.eAa();
                var b = new FileReader();
                b.addEventListener("loadend", () => c());
                var a = null,
                  c = () => {
                    this.UGa(b.result, () => {
                      this.hC += a.size;
                      d();
                    }, a.size == this.hL);
                  },
                  d = () => {
                    this.hC >= this.hL ? this.TGa() : (a = this.oa.response.slice(this.hC, this.hC + this.cJ), b.readAsText(a, this.encoding));
                  };
                d();
              }
            }
            wsa(b) {
              this.wg();
              this.Q3(b);
            }
            Vh(b, a) {
              if (!e.v(a)) for (var c in a) a.hasOwnProperty(c) && b.uc.push(new z.K9(c, a[c]));
            }
            sHa() {
              0 < this.tk || this.qU ? this.wg() : null != this.timer && e.Da(!0, e.model.B.j.jg, e.P.bind(e.model.B.j.yt, u.cc.format(this.timer.yw / 10, new e.model.ac.W.af(), !1, !1, 1)));
            }
            oq() {
              this.timer.wl && this.wg();
            }
            wg() {
              this.timer && this.timer.wl && (this.timer.stop(), this.timer.pb(u.vf.Gl, this.fja), this.timer.pb(u.vf.Hl, this.Lj));
            }
          }
          h.Aqa = f;
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.uP {
              constructor() {
                super();
                this.Wf = null;
                this.Kf = "";
                this.Wm = "\n";
                this.$p = !0;
                this.Ba = k.i.qa.Xh;
              }
              get kb() {
                return e.ia(this.filename) && (null == this.Wd || 0 == this.Wd);
              }
              set kb(a) {}
              get Ru() {
                return !e.v(this.data);
              }
              set Ru(a) {}
              isEqual(a) {
                return a == this ? !0 : super.isEqual(a);
              }
              static zb(a) {
                var c = new b();
                e.v(a.browseForFile) || (c.Wd = a.browseForFile);
                e.v(a.requestPermission) || (c.requestPermission = a.requestPermission);
                e.v(a.filename) || "" == a.filename || (c.filename = a.filename);
                e.v(a.fieldSeparator) || (c.Wf = a.fieldSeparator);
                e.v(a.thousandSeparator) || (c.Kf = a.thousandSeparator);
                e.v(a.thousandsSeparator) || (c.Kf = a.thousandsSeparator);
                e.v(a.recordsetDelimiter) || (c.Wm = a.recordsetDelimiter);
                e.v(a.requestHeaders) || (c.uc = a.requestHeaders);
                e.v(a.ignoreQuotedLineBreaks) || (c.$p = a.ignoreQuotedLineBreaks);
                e.v(a.mapping) || (c.mapping = a.mapping instanceof k.O.pm ? a.mapping : new k.O.pm(a.mapping));
                e.v(a.withCredentials) || (c.withCredentials = a.withCredentials);
                return c;
              }
              static Ek(a) {
                var c = new b(),
                  d = a.find("params");
                0 != d.find("param[name=ignoreQuotedLineBreaks]").length && (c.$p = e.P.Zc(d.find("param[name=ignoreQuotedLineBreaks]").text()));
                a = a.find("dataSource");
                0 != a.find("browseForFile").length && (c.Wd = e.P.Zc(a.find("browseForFile").text()));
                0 != a.find("filename").length && (c.filename = a.find("filename").text());
                0 != a.find("fieldSeparator").length && (c.Wf = a.find("fieldSeparator").text());
                0 != a.find("thousandSeparator").length && (c.Kf = a.find("thousandSeparator").text());
                0 != a.find("thousandsSeparator").length && (c.Kf = a.find("thousandsSeparator").text());
                0 != a.find("recordsetDelimiter").length && (c.Wm = a.find("recordsetDelimiter").text());
                0 != a.find("ignoreQuotedLineBreaks").length && (c.$p = e.P.Zc(a.find("ignoreQuotedLineBreaks").text()));
                return c;
              }
              gp() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = z.ba.create("<dataSource/>");
                c.attr("type", this.Ba);
                (a || this.Wd) && c.append(z.ba.create("<browseForFile/>").text(this.Wd));
                this.filename && c.append(z.ba.create("<filename/>").append(z.ba.$h(this.filename)));
                this.Wf && c.append(z.ba.create("<fieldSeparator/>").append(z.ba.$h(this.Wf)));
                this.Kf && c.append(z.ba.create("<thousandsSeparator/>").append(z.ba.$h(this.Kf)));
                this.Wm && "\n" != this.Wm && c.append(z.ba.create("<recordsetDelimiter/>").append(z.ba.$h(this.Wm)));
                (a || 0 == this.$p) && c.append(z.ba.create("<ignoreQuotedLineBreaks/>").text(this.$p));
                return c;
              }
              Sa() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = {};
                c.type = this.Ba;
                if (a || this.Wd) c.browseForFile = this.Wd;
                this.filename && (c.filename = this.filename);
                this.Wf && (c.fieldSeparator = this.Wf);
                this.Kf && (c.thousandsSeparator = this.Kf);
                this.Wm && "\n" != this.Wm && (c.recordsetDelimiter = this.Wm);
                if (a || 0 == this.$p) c.ignoreQuotedLineBreaks = this.$p;
                if (!this.mapping.kb || this.mapping.Po) c.mapping = this.mapping.Sa(!0);
                if (a || this.withCredentials) c.withCredentials = this.withCredentials;
                return c;
              }
              clone() {
                var a = new b();
                a.Ba = this.Ba;
                this.Wd && (a.Wd = this.Wd);
                this.filename && (a.filename = this.filename);
                this.Wf && (a.Wf = this.Wf);
                this.Kf && (a.Kf = this.Kf);
                this.Wm && "\n" != this.Wm && (a.Wm = this.Wm);
                0 == this.$p && (a.$p = this.$p);
                if (!this.mapping.kb || this.mapping.Po) a.mapping = this.mapping.clone(this.Ba);
                this.withCredentials && (a.withCredentials = this.withCredentials);
                return a;
              }
            }
            f.GO = b;
          })(h.csv || (h.csv = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.uP {
              constructor() {
                super();
                this.lfa = this.Ak = !1;
                this.z0 = 0;
                this.Ba = k.i.qa.Gq;
              }
              get kb() {
                return e.ia(this.filename) && (null == this.Wd || 0 == this.Wd) && (null == this.Ak || 0 == this.Ak);
              }
              set kb(a) {}
              get Ru() {
                return this.Ak;
              }
              set Ru(a) {}
              isEqual(a) {
                return super.isEqual(a) && 0 == this.Ak && 0 == a.Ak;
              }
              static zb(a) {
                var c = new b();
                e.v(a.browseForFile) || (c.Wd = a.browseForFile);
                e.v(a.filename) || "" == a.filename || (c.filename = a.filename);
                e.v(a.requestHeaders) || (c.uc = a.requestHeaders);
                e.v(a.embedded) || (c.Ak = a.embedded);
                e.v(a.embeddedDataOffset) || (c.z0 = a.embeddedDataOffset);
                e.v(a.embeddedDataToLoad) || (c.Hca = a.embeddedDataToLoad);
                e.v(a.isOCSV2Data) || (c.lfa = a.isOCSV2Data);
                e.v(a.mapping) || (c.mapping = a.mapping instanceof k.O.pm ? a.mapping : new k.O.pm(a.mapping));
                return c;
              }
              gp() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = z.ba.create("<dataSource/>");
                c.attr("type", this.Ba);
                (a || this.Wd) && c.append(z.ba.create("<browseForFile/>").text(this.Wd));
                this.filename && c.append(z.ba.create("<filename/>").append(z.ba.$h(this.filename)));
                this.Ak && c.append(z.ba.create("<embedded/>").text(this.Ak));
                return c;
              }
              static Ek(a) {
                var c = new b();
                0 != a.find("browseForFile").length && (c.Wd = e.P.Zc(a.find("browseForFile").text()));
                0 != a.find("filename").length && (c.filename = a.find("filename").text());
                0 != a.find("embedded").length && (c.Ak = e.P.Zc(a.find("embedded").text()));
                return c;
              }
              Sa() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = {};
                c.type = this.Ba;
                if (a || this.Wd) c.browseForFile = this.Wd;
                this.filename && (c.filename = this.filename);
                this.Ak && (c.embedded = this.Ak);
                return c;
              }
              clone() {
                var a = new b();
                a.Ba = this.Ba;
                this.Wd && (a.Wd = this.Wd);
                this.filename && (a.filename = this.filename);
                this.Ak && (a.Ak = this.Ak);
                return a;
              }
            }
            f.uF = b;
          })(h.csv || (h.csv = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.Kf = "";
                this.L0 = [".csv"];
                this.Dxa = RegExp('""', "g");
                this.qfa = !1;
                this.tua = () => this.a$();
                this.Bl = () => this.Ws();
                this.Lj = () => this.oq();
                this.ii = 0;
                this.Xu = !1;
                this.H5 = null;
                this.eha = 0;
                this.va = k.Ma.R();
                this.L0 = [".csv"];
              }
              clear() {
                this.data = [];
                this.qw = this.ii = this.GC = this.tk = 0;
                this.Wm = "\n";
                this.NS = '"';
                this.uC = [];
                this.Ue = [];
                this.NM = this.TM = this.Mo = this.oU = !1;
                this.oe = "";
                this.lb = 0;
                this.Mr = 100;
                null != this.oa && (this.oa.Td(), this.oa.dispose(), this.oa = null);
                this.wg();
                e.Da(!1);
              }
              load(c, d, g, l, m) {
                try {
                  this.clear(), this.filename = c.filename, this.Mb = d, this.bb = g, this.Pe = l, this.BG = m, this.Wf = c.Wf, this.Kf = c.Kf, this.$p = c.$p, c.RM ? this.W0() : (void 0 !== this.filename && "" != this.filename && "()" != this.filename.substr(-2) || !1 !== c.Wd ? this.filename = u.py.FH(this.filename, !e.model.C.F.ER) : this.fm(), !0 === c.Wd ? this.cba(c) : (e.Da(!0, e.model.B.j.jg), this.X2(this.filename, c.uc, c.withCredentials)));
                } catch (n) {
                  console.error(n.stack), this.fm();
                }
              }
              W0() {
                this.et();
                this.Wf = ",";
                this.dE("Browser, Duration, Page Views, New Session", "Chrome, 100, 3, true", new k.O.pm({
                  Browser: {
                    type: "string"
                  },
                  Duration: {
                    type: "time"
                  },
                  "Page Views": {
                    type: "number"
                  },
                  "New Session": {
                    type: "number"
                  }
                }));
                this.oU = !0;
                this.va.ta.W0(() => {
                  this.Sz();
                });
              }
              requestPermission() {
                e.Wa(e.model.B.j.Ooa, e.model.B.j.pka, e.tb.lP, [e.model.B.j.El, e.model.B.j.qka], [this.tua]);
              }
              cba(c) {
                !0 === c.requestPermission ? this.requestPermission() : this.a$();
              }
              a$() {
                this.Kw = new z.V7();
                this.Kw.N(v.ga.ho, () => this.JFa());
                this.Kw.N(v.ga.Qc, () => this.pN());
                this.Kw.N(v.ga.te, c => this.qN(c));
                this.Kw.N(v.ga.aX, () => this.HFa());
                this.Kw.N(v.ga.xa, () => this.fm());
                this.Kw.bba(this.L0);
              }
              JFa() {
                e.Da(!0, e.model.B.j.jg, "", !0, !0);
                this.oa = this.Kw;
                this.Kw.load();
                this.Kw = null;
              }
              X2(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                this.timer = new u.Et(100, 1E5);
                this.timer.N(u.vf.Gl, this.Bl);
                this.timer.N(u.vf.Hl, this.Lj);
                this.timer.start();
                var l = new z.jk();
                l.dataType = z.KA.kB;
                l.N(v.ga.Qc, () => this.pN());
                l.N(v.ga.GA, () => this.y3());
                l.N(v.ga.te, m => this.qN(m));
                l.N(v.ga.xa, m => this.fm(m));
                l.Vh(d);
                l.withCredentials = g;
                l.load(c);
                this.oa = l;
              }
              Ws() {
                0 < this.tk || this.Mo || this.TM ? this.wg() : null != this.timer && e.Da(!0, e.model.B.j.jg, e.P.bind(e.model.B.j.yt, u.cc.format(this.timer.yw / 10, new e.model.ac.W.af(), !1, !1, 1)));
              }
              oq() {
                this.timer.wl && this.wg();
              }
              wg() {
                this.timer && this.timer.wl && (this.timer.stop(), this.timer.pb(u.vf.Gl, this.Bl), this.timer.pb(u.vf.Hl, this.Lj));
              }
              HFa() {
                null != this.BG && (this.BG(), this.BG = null);
                this.clear();
              }
              fm() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                e.Da(!1);
                var d = "",
                  g = "";
                null != c && null != c.target && null != c.target.response && "" != c.target.response && (g = e.model.Tb.validate(c.target.response), d = g = 700 < g.length ? g.substr(0, 700) : g, g = e.P.bind(e.model.B.j.FP, g).replace(/'/g, ""));
                0 == this.TM && (this.TM = !0, c = e.model.Tb.valid(this.filename) ? this.filename : e.model.Tb.validate(this.filename), e.Wa(e.P.bind(e.model.B.j.LJ, c) + g, e.model.B.j.xa, e.tb.xa));
                null != this.bb && (this.bb(d), this.bb = null);
                this.wg();
              }
              E3() {
                e.Da(!1);
                e.Wa(e.P.bind(e.model.B.j.F8), e.model.B.j.xa, e.tb.xa);
              }
              qN(c) {
                var d = c.data;
                if (404 == d.target.status) this.fm(c);else if (!e.v(this.oa)) try {
                  var g = this.oa.response;
                  if (null != g && 0 != g.length && (this.tk != d.loaded || this.GC != g.length) && (this.NM = 0 < d.total && d.lengthComputable, this.GC = g.length, this.tk = d.loaded, 1E4 < g.length - this.ii || d.loaded == d.total)) {
                    this.Mo = d.loaded == d.total && d.loaded >= this.oa.response.length;
                    void 0 === g || u.Jd().cj || this.yr(g.substring(this.ii, g.length));
                    this.ii = g.length;
                    var l = 0 == d.total ? e.P.bind(e.model.B.j.om, u.cc.Vg(d.loaded)) : e.P.bind(e.model.B.j.sF, u.cc.Vg(d.loaded), u.cc.Vg(d.total), (d.loaded / d.total * 100).toFixed(0));
                    e.Da(!0, e.model.B.j.jg, l);
                  }
                } catch (m) {
                  console.error(m.stack), this.fm();
                }
              }
              y3() {
                e.Da(!0, e.model.B.j.jg, "");
              }
              et() {
                null != this.Pe && (this.Pe(), this.Pe = null);
              }
              pN() {
                if (!e.v(this.oa)) {
                  try {
                    if (0 == this.ii || !this.NM || u.Jd().cj || this.ii <= this.oa.response.length) {
                      var c = this.oa.response;
                      e.ia(c) && !this.Xu ? this.Sz() : (this.Mo = !0, this.Xu) ? this.NM || (this.ii < c.length ? (this.yr(c.substring(this.ii, c.length)), this.ii = c.length) : this.data.push(this.oe)) : this.yr(c);
                    }
                  } catch (d) {
                    console.error(d.stack), this.fm();
                  }
                  this.oa = null;
                }
              }
              static Lea(c) {
                c = c.toLowerCase();
                return -1 != c.indexOf("<html>") || -1 != c.indexOf("<config>") || 0 == c.trim().length || -1 != c.indexOf("<!doctype") ? (e.Wa(e.model.B.j.Koa, e.model.B.j.xa, e.tb.xa), !1) : !0;
              }
              yr(c) {
                this.Xu = !0;
                this.et();
                0 === this.qw && -1 === c.indexOf("\n") && -1 !== c.indexOf("\r") && (this.Wm = "\r");
                e.v(this.Wf) && (this.Wf = this.Yua(-1 == c.indexOf("\n") && -1 == c.indexOf("\r") ? c : c.substring(0, c.indexOf(this.Wm))));
                this.appendData(c);
                !1 === this.oU && (1 < this.data.length || e.model.C.F.CE) && (this.qfa && this.data.shift(), this.dE(this.data.shift(), this.data[0], this.va.fa.mapping), this.va.ta.pI(), this.oU = !0);
                0 !== this.ii && !u.Jd().cj || this.TM || u.Il.po({
                  bp: () => this.jv(),
                  ff: () => this.Sz()
                });
              }
              Sz() {
                e.Da(!1);
                this.oU ? null != this.Mb && this.Mb() : (e.model.C.F.CE || e.Wa(e.model.B.j.Bv, e.model.B.j.xa, e.tb.Dl), null != this.bb && (this.bb(e.model.B.j.Bv), this.bb = null));
                this.clear();
              }
              dE(c, d, g) {
                if ("string" == typeof c && !b.Lea(c) || "object" == typeof c && !b.Lea(c.toString())) this.fm();else try {
                  e.v(this.Wf) && (this.Wf = ",");
                  var l = "string" == typeof c ? b.Tia(c, this.Wf) : c,
                    m = "string" == typeof d ? b.Tia(d, this.Wf) : e.v(d) ? [] : d;
                  this.Em = [];
                  for (c = 0; c < l.length; c++) {
                    var n = this.lT(m[c]),
                      p = this.Mw(l[c], n, 0 == m.length),
                      t = this.u1(l[c], n, 0 == m.length),
                      r = this.jM(l[c]),
                      w = this.hM(r),
                      y = {
                        type: p,
                        uniqueName: r,
                        caption: this.aAa(l[c]) || w,
                        isMeasure: t
                      };
                    void 0 !== g && (y = g.f3(r, y), e.v(g.La(r, "hierarchy")) || y.type === k.i.input.sa.wF || (y.type = "level"));
                    if (!y.hasOwnProperty("visible") || !1 !== y.visible) {
                      this.uC[c] = y.type;
                      this.Ue[c] = y.isMeasure;
                      this.Em[c] = r;
                      if (p === k.i.input.sa.Of) {
                        var A = r.split(":");
                        y.hierarchy = A[0];
                        y.level = A.pop();
                        y.parent = A.join(":");
                      }
                      this.va.O.Dy(y, r);
                    }
                  }
                } catch (B) {
                  console.error(B.stack), this.E3();
                }
              }
              lT(c) {
                void 0 !== c && null !== c && "string" == typeof c && (this.Kf && 0 < this.Kf.length && (e.v(this.H5) && (this.H5 = new RegExp(this.Kf, "g")), c = c.replace(this.H5, "")), c = c.replace(",", "."));
                return c;
              }
              hM(c) {
                var d = c.split(a.TI);
                if (1 < d.length) return d[1];
                this.yz(c) && (d = c.split(":"));
                return d[d.length - 1];
              }
              jM(c) {
                c = c.trim().split(a.TI)[0];
                c = this.H4(c);
                if (-1 < this.Em.indexOf(c)) {
                  for (var d = 1, g = c; -1 < this.Em.indexOf(g);) g = c + d, d++;
                  c = g;
                }
                return c;
              }
              aAa(c) {
                c = c.split(a.TI);
                return 1 < c.length ? c[1] : null;
              }
              H4(c) {
                return c.replace(/^(\+|dt\+|t\+|n\+|-|ds\+|d\+|m\+|w\+|D\+|D4\+|url\+|img\+|id\+)/, "");
              }
              Mw(c, d, g) {
                var l = k.i.input.sa.jb;
                c = c.trim();
                if (e.v(d) && !g) return k.i.input.sa.$c;
                "+" === c.charAt(0) ? l = k.i.input.sa.$c : "t+" === c.substr(0, 2) ? l = k.i.input.sa.ic : "dt+" === c.substr(0, 3) ? l = k.i.input.sa.Lc : "n+" === c.substr(0, 2) ? l = k.i.input.sa.jb : "-" === c.charAt(0) ? l = k.i.input.sa.jb : "ds+" === c.substr(0, 3) ? l = k.i.input.sa.lj : "d+" === c.substr(0, 2) ? l = k.i.input.sa.Ta : "m+" === c.substr(0, 2) ? l = k.i.input.sa.ih : "w+" === c.substr(0, 2) ? l = k.i.input.sa.kn : "D+" === c.substr(0, 2) ? l = k.i.input.sa.Fq : "D4+" === c.substr(0, 3) ? l = k.i.input.sa.op : "id+" === c.substr(0, 3) ? l = k.i.input.sa.ay : "" === d || void 0 === d ? l = k.i.input.sa.$c : isNaN(Number(d)) && (l = e.P.gU(d) ? e.model.C.F.HL : k.i.input.sa.$c);
                l === k.i.input.sa.$c && this.yz(c) && (l = k.i.input.sa.Of);
                return l;
              }
              u1(c, d, g) {
                return !e.model.C.F.Ke || e.v(d) && !g ? !1 : "-" === c.trim().charAt(0);
              }
              yz(c) {
                "+" === c.charAt(0) && (c = c.substr(1));
                return 1 < c.split(":").length && -1 < this.Em.indexOf(c.split(":")[0].trim());
              }
              jv() {
                if (this.lb >= this.data.length) return this.Mo;
                var c = this.data[this.lb];
                if (!e.ia(c) && this.Em) {
                  for (var d = !1, g = "", l = 0, m = [], n = [], p, t = 0; t < c.length; t++) {
                    var r = c.charAt(t);
                    if (t === c.length - 1 || r === this.Wf && !d) {
                      if (t === c.length - 1 && r !== this.Wf && (g += r), g = g.trim(), g = g.replace("\r", ""), g.charAt(0) === this.NS && g.charAt(g.length - 1) === this.NS && (g = g.slice(1, g.length - 1), g = g.replace(this.Dxa, '"')), this.uC[l] === k.i.input.sa.ay && (p = g), void 0 !== this.Em[l] && (this.uC[l] === k.i.input.sa.jb && (g = this.lT(g)), d = new k.O.ae({
                        value: g
                      }), this.va.O.oc(d, this.Em[l], this.uC[l], m, n)), d = !1, g = "", l++, l >= this.Em.length) break;
                    } else r === this.NS ? (g += r, d = !d) : g += r;
                  }
                  if (l < this.Em.length) for (c = l; c < this.Em.length; c++) d = new k.O.ae({
                    value: void 0
                  }), this.va.O.oc(d, this.Em[c], this.uC[c], m, n);
                  this.va.ta.insert(m, n, p);
                  0 === this.lb % 1E3 && this.Mo && 200 < u.Yf() - this.eha && (m = e.model.B.j.CP, n = (this.lb / this.data.length * 100).toFixed(0), n = e.P.bind(e.model.B.j.DP, u.cc.lz(this.lb.toFixed(0)), u.cc.lz(this.data.length.toFixed(0)), n), e.Da(!0, m, n), this.eha = u.Yf());
                }
                this.lb++;
                return this.Mo && this.lb >= this.data.length;
              }
              appendData(c) {
                void 0 !== this.oe && 0 < this.oe.length && (c = this.oe + c);
                c = this.IKa(c);
                for (var d = 0; d < c.length; d++) this.data.push(c[d]);
                1 != this.Mo && (this.oe = this.data.pop());
              }
              IKa(c) {
                var d = !1;
                c = c.split(this.Wm);
                if (0 == this.$p) for (var g = 0; g < c.length; g++) d ? (this.pfa(c[g]) && (d = !1), c[g - 1] += "<br/>" + c[g], c.splice(g, 1), g--) : this.pfa(c[g]) && (d = !0);
                return c;
              }
              pfa(c) {
                return 1 == this.uwa(c, this.NS) % 2;
              }
              uwa(c, d) {
                var g = 0;
                if (c) for (var l = 0; l < c.length; l++) c.charAt(l) == d && g++;
                return g;
              }
              Yua(c) {
                if (void 0 == this.Wf) {
                  var d = c.indexOf("sep=");
                  if (-1 < d) {
                    const g = '"' === c[0];
                    c = c.trim();
                    c = c.substring(d + 4, g ? c.length - 1 : c.length);
                    this.qfa = !0;
                    return c.trim();
                  }
                  return c.split(",").length > c.split(";").length ? "," : ";";
                }
              }
              static Tia(c, d) {
                if (null === c) return [];
                for (var g = "", l = !1, m = !1, n = [], p = 0; p < c.length; p++) {
                  var t = c.charAt(p);
                  p === c.length - 1 || t === d && !l ? (p === c.length - 1 && t === d ? (n.push(g), g = "") : p === c.length - 1 && (g += t), g = g.trim(), '"' === g.charAt(0) && '"' === g.charAt(g.length - 1) && (g = g.slice(1, g.length - 1)), l = m = !1, n.push(g), g = "") : '"' === t ? (m || (g += t), l = !l, m = !0) : (g += t, m = !1);
                }
                return n;
              }
              static BW(c) {
                return c && 0 < c.length ? c : e.model.B.j.Wn;
              }
              ol() {}
              Ik() {}
              Lz() {}
              uq() {}
              iC() {
                return !1;
              }
              cancel() {
                this.clear();
                this.Pe = this.bb = this.Mb = null;
              }
            }
            f.fX = b;
            class a {}
            a.FLOAT = "F";
            a.TI = "+T+";
            f.a7 = a;
          })(h.csv || (h.csv = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.RY = !1;
                this.f$ = 0;
                this.pJ = ",";
                this.dY = "\n";
                this.df = k.Ma.R();
                this.Uq = 0;
                this.M$ = this.L$ = !1;
                this.$ra = "\x3c!--";
                this.asa = "--\x3e";
                this.SY = "/**----**";
                this.Zra = "**--!--**/";
                this.CQ = this.fs = "";
                this.Y$ = 0;
                this.Bl = () => this.Ws();
                this.Lj = () => this.oq();
                this.NIa = RegExp("%d%", "g");
                this.PIa = RegExp("%q%", "g");
                this.OIa = RegExp("%n%", "g");
              }
              load(a, c, d, g, l) {
                try {
                  this.clear(), this.Ab = a, this.JZ = c, this.Pe = g, this.BG = l, this.KQ = d, this.RF = this.Ab.filename, this.RY = this.Ab.Ak, this.f$ = this.Ab.z0, this.g$ = this.Ab.Hca, this.o$ = !1, 0 == this.RY && (this.RF = u.py.FH(this.RF, !e.model.C.F.ER)), this.RY && null != this.g$ ? this.KDa(this.g$) : (e.Da(!0, e.model.B.j.jg), this.X2(this.RF, this.Ab.uc));
                } catch (m) {
                  console.error(m.stack), this.fm(null, m.message ? "Error: " + m.message : "");
                }
              }
              X2(a, c) {
                this.wm = new u.Et(100, 1E5);
                this.wm.N(u.vf.Gl, this.Bl);
                this.wm.N(u.vf.Hl, this.Lj);
                this.wm.start();
                var d = new z.jk();
                d.dataType = z.KA.kB;
                d.N(v.ga.Qc, () => this.pN());
                d.N(v.ga.GA, () => this.y3());
                d.N(v.ga.te, g => this.qN(g));
                d.N(v.ga.xa, g => this.fm(g));
                d.Vh(c);
                d.load(a);
                this.vm = d;
              }
              oq() {
                this.wm.wl && this.wg();
              }
              wg() {
                this.wm && this.wm.wl && (this.wm.stop(), this.wm.pb(u.vf.Gl, this.Bl), this.wm.pb(u.vf.Hl, this.Lj));
              }
              kca(a) {
                this.fs = -1 < a.indexOf(this.SY) ? this.SY : this.$ra;
                this.CQ = this.fs == this.SY ? this.Zra : this.asa;
              }
              KDa(a) {
                this.Mr = 100;
                this.Ui = 0;
                try {
                  var c = new e.Rr(a, this.f$, e.Rr.ZI),
                    d = c.byteLength > this.Mr ? this.Mr : c.byteLength,
                    g = c.IV(d);
                  this.kca(g);
                  g.substr(0, this.fs.length) == this.fs && (this.sK = "", this.sK += g.substring(this.fs.length), this.Ui += d, this.nK = c.byteLength, this.Ui < this.nK ? u.Il.po({
                    bp: () => this.HDa(c),
                    ff: () => this.ur(),
                    k_: c
                  }) : this.ur());
                } catch (l) {
                  console.error(l.stack), this.fm(null, l.message ? "Parsing error: " + l.message : "");
                }
              }
              HDa(a) {
                var c = this.nK - this.Ui > this.Mr ? this.Mr : this.nK - this.Ui;
                a = a.IV(c);
                this.Ui += c;
                this.sK += a;
                this.r5(this.Ui, this.nK);
                return this.Ui >= this.nK;
              }
              r5(a, c) {
                a = e.P.bind(e.model.B.j.y8, (a / c * 100).toFixed(0));
                e.Da(!0, e.model.B.j.rF, a);
              }
              ur() {
                e.Da(!1);
                this.Ay = !0;
                this.FIa(this.sK);
              }
              et() {
                null != this.Pe && (this.Pe(), this.Pe = null);
              }
              FIa(a) {
                a = e.P.trimLeft(a);
                this.lba(a) || this.yr(a);
              }
              Ws() {
                if (0 < this.Ui || this.Ay || this.dZ) this.wg();else {
                  var a = this.wm.yw / 10;
                  this.bZ ? (196 < a && (a = 196), a = u.cc.format(a / 2, new e.model.ac.W.af(), !1, !1, 1) + "%") : a = e.P.bind(e.model.B.j.yt, u.cc.format(a, new e.model.ac.W.af(), !1, !1, 1));
                  e.Da(!0, e.model.B.j.jg, a);
                }
              }
              fm() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                e.Da(!1);
                var d = "";
                "" == c && null != a && null != a.target && null != a.target.response && "" != a.target.response && (d = e.model.Tb.validate(a.target.response), c = d = 700 < d.length ? d.substr(0, 700) : d, d = e.P.bind(e.model.B.j.FP, d).replace(/'/g, ""));
                0 == this.dZ && (this.dZ = !0, a = e.model.Tb.valid(this.RF) ? this.RF : e.model.Tb.validate(this.RF), e.Wa(e.P.bind(e.model.B.j.LJ, a) + d, e.model.B.j.xa, e.tb.xa));
                null != this.bb && (this.bb(c), this.bb = null);
                this.clear();
              }
              lba(a) {
                if (0 == this.M$ && 22 < a.length) {
                  if (this.$Ca(a)) {
                    if (0 == this.uCa(a.substr(0, a.indexOf(this.dY)))) return this.eFa(), !0;
                    this.M$ = !0;
                    return !1;
                  }
                  this.pCa(a) ? (u.Il.cancel(), null != this.vm && (this.vm.Td(), this.vm.dispose(), this.vm = null), e.Wa("OCSV data format is deprecated. Please contact the support team for more information."), this.clear()) : (this.clear(), new f.fX().load(this.Ab, this.JZ, this.KQ, this.Pe, null));
                  return !0;
                }
                return !1;
              }
              qN(a) {
                if (null != this.vm && !(null != a.data && a.data.target && 400 <= a.data.target.status)) {
                  a = a.data;
                  try {
                    var c = this.vm.response;
                    if (this.Ui != a.loaded && null != c && 0 != c.length) {
                      this.aZ = 0 < a.total && a.lengthComputable;
                      this.Ui = a.loaded;
                      "" == this.fs && this.kca(c);
                      var d = 0;
                      if (-1 < (d = c.indexOf(this.fs))) c = c.substring(d + this.fs.length + 1), this.o$ = !0;else if (this.Ab.lfa && !this.o$) return;
                      c = e.P.trimLeft(c);
                      if (!this.lba(c) && (1E4 < c.length - this.Uq || a.loaded == a.total)) {
                        this.Ay = a.loaded == a.total && a.loaded >= this.vm.response.length;
                        void 0 === c || u.Jd().s2 || this.yr(c.substring(this.Uq, c.length));
                        this.Uq = c.length;
                        var g = 0 == a.total ? e.P.bind(e.model.B.j.om, u.cc.Vg(a.loaded)) : e.P.bind(e.model.B.j.sF, u.cc.Vg(a.loaded), u.cc.Vg(a.total));
                        e.Da(!0, e.model.B.j.jg, g);
                      }
                    }
                  } catch (l) {
                    console.error(l.stack), this.fm(null, l.message ? "File loading error: " + l.message : "");
                  }
                }
              }
              y3() {
                this.bZ = !0;
                e.Da(!0, e.model.B.j.jg, "");
              }
              pN() {
                if (null != this.vm) try {
                  if (0 == this.Uq || !this.aZ || u.Jd().s2 || this.Uq <= this.vm.response.length) {
                    var a = this.vm.response,
                      c = 0;
                    -1 < (c = a.indexOf(this.fs)) && (a = a.substring(c + this.fs.length + 1));
                    if (this.vm.response instanceof ArrayBuffer) {
                      var d = new e.Rr(this.vm.response, 0, e.Rr.ZI);
                      a = d.IV(d.byteLength);
                    }
                    this.Ay = this.bZ = !0;
                    this.L$ ? this.aZ ? this.Uq < a.length && (this.yr(a.substring(this.Uq, a.length)), this.Uq = a.length) : this.Uq < a.length ? (this.yr(a.substring(this.Uq, a.length)), this.Uq = a.length) : this.cl.push(this.By) : this.yr(a);
                  }
                } catch (g) {
                  console.error(g.stack), this.fm(null, g.message ? "ERROR: " + g.message : "");
                }
              }
              yr(a) {
                this.L$ = !0;
                this.et();
                this.appendData(a);
                0 == this.fZ && 1 < this.cl.length && (this.cl.shift(), this.dE(this.cl.shift()), this.fZ = !0, u.Il.po({
                  bp: () => this.jv(),
                  ff: () => this.Sz()
                }));
              }
              $Ca(a) {
                return "string" == typeof a && "___ocsv2___" == a.substr(0, 11);
              }
              pCa(a) {
                try {
                  if ("string" == typeof a) for (var c = 0; c < a.length; c++) {
                    if (10 > a.charCodeAt(c) || 255 < a.charCodeAt(c)) return !0;
                    if (50 < c) return !1;
                  }
                  if (a instanceof ArrayBuffer) return 1600085871 != new e.Rr(a, 0, e.Rr.ZI).uha();
                  if (a instanceof e.Rr) return 1600085871 != a.uha();
                } catch (d) {}
                return !1;
              }
              appendData(a) {
                void 0 !== this.By && 0 < this.By.length && (a = this.By + a);
                a = 0 <= a.indexOf(this.dY) ? a.split(this.dY) : [];
                for (var c = 0; c < a.length; c++) e.ia(a[c]) || this.cl.push(a[c]);
                1 != this.Ay && (this.By = e.ia(a[a.length - 1]) ? a.pop() : this.cl.pop(), this.By = this.By == this.CQ ? this.cl.pop() : this.By);
              }
              uCa(a) {
                this.FY = a.replace("___ocsv2___", "").split("/")[1];
                return void 0 != this.FY && 1 == e.P.cS(this.FY, e.kh.Nr) ? !1 : !0;
              }
              dE(a) {
                a = a.split(this.pJ);
                this.es = [];
                for (var c = 0; c < a.length; c++) {
                  var d = this.Mw(a[c]),
                    g = this.jM(a[c]),
                    l = this.hM(g);
                  this.Kt[c] = d;
                  this.es.push(g);
                  l = {
                    type: d,
                    caption: l,
                    A: g
                  };
                  d === k.i.input.sa.Of && (d = g.split(":"), l.hierarchy = d[0], l.level = d.pop(), l.parent = d.join(":"));
                  this.df.O.Dy(l, g);
                }
                this.df.ta.pI();
              }
              Mw(a) {
                var c = k.i.input.sa.bza(a);
                c === k.i.input.sa.$c && this.yz(a) && (c = k.i.input.sa.Of);
                return c;
              }
              hM(a) {
                var c = a.split(f.a7.TI);
                if (1 < c.length) return c[1];
                this.yz(a) && (c = a.split(":"));
                return c[c.length - 1];
              }
              yz(a) {
                "+" == a.charAt(0) && (a = a.substr(1));
                return 1 < a.split(":").length && -1 < this.es.indexOf(a.split(":")[0].trim());
              }
              jM(a) {
                a = a.trim().split(f.a7.TI)[0];
                a = this.H4(a);
                a = this.aca(a);
                if (-1 < this.es.indexOf(a)) {
                  for (var c = 1, d = a; -1 < this.es.indexOf(d);) d = a + c, c++;
                  a = d;
                }
                return a;
              }
              H4(a) {
                return a.replace(/^(\+|dt\+|t\+|n\+|-|ds\+|d\+|m\+|w\+|D\+|D4\+|url\+|img\+|id\+)/, "");
              }
              jv() {
                if (this.Rf >= this.cl.length) return this.Ay;
                var a = this.cl[this.Rf];
                if (!e.ia(a) && void 0 !== this.es) {
                  if (a == this.CQ) return !0;
                  if (a.split(this.pJ).length < this.es.length) for (var c = a.split(this.pJ).length; c < this.es.length; c++) a = a.concat(this.pJ);
                  var d = [],
                    g = [];
                  a = a.split(this.pJ);
                  for (c = 0; c < this.es.length; c++) this.OHa(a[c], c, d, g);
                  this.df.ta.insert(d, g);
                }
                this.Ay && 200 < u.Yf() - this.Y$ && (c = e.model.B.j.CP, d = (this.Rf / this.cl.length * 100).toFixed(0), d = e.P.bind(e.model.B.j.DP, u.cc.lz(this.Rf.toFixed(0)), u.cc.lz(this.cl.length.toFixed(0)), d), e.Da(!0, c, d), this.Y$ = u.Yf());
                this.cl[this.Rf] = "";
                this.Rf++;
                return this.Ay && this.Rf >= this.cl.length;
              }
              OHa(a, c, d, g) {
                var l = !0,
                  m = this.df.O.bD(this.es[c]);
                if (null !== this.es[c]) {
                  if (this.Kt[c] === k.i.input.sa.$c || this.Kt[c] === k.i.input.sa.kn || this.Kt[c] === k.i.input.sa.ih) {
                    if ("^" === a.charAt(0)) {
                      var n = parseInt(a.substring(1));
                      !1 === isNaN(n) && (m = m.za(n + 1), null != m && (a = m.caption == e.model.B.j.Fl ? "" : m.caption, l = !1));
                    }
                  } else if (this.Kt[c] == k.i.input.sa.Of) "^" === a.charAt(0) && (n = parseInt(a.substring(1)), !1 === isNaN(n) && (m = m.hierarchy.za(n + 1), null != m && (a = m.caption == e.model.B.j.Fl ? "" : m.caption, l = !1)));else if (this.Kt[c] === k.i.input.sa.Ta || this.Kt[c] === k.i.input.sa.lj || this.Kt[c] === k.i.input.sa.Fq || this.Kt[c] === k.i.input.sa.op) a = 1E3 * parseInt(a), l = !1;
                  l && (a = this.aca(a));
                  a = new k.O.ae({
                    value: a
                  });
                  this.df.O.oc(a, this.es[c], this.Kt[c], d, g);
                }
              }
              aca(a) {
                return a.replace(this.NIa, ",").replace(this.PIa, '"').replace(this.OIa, "\n");
              }
              Sz() {
                e.Da(!1);
                this.fZ ? this.Mb() : (e.Wa(e.model.B.j.Bv, e.model.B.j.xa, e.tb.Dl), this.bb(), this.KQ = null);
                this.clear();
              }
              eFa() {
                e.Da(!1);
                e.Wa(e.P.bind(e.model.B.j.Loa, this.FY), e.model.B.j.xa, e.tb.xa);
                this.bb();
                this.clear();
              }
              clear() {
                e.Da(!1);
                this.cl = [];
                this.CQ = this.fs = "";
                this.Ui = 0;
                this.bZ = !1;
                this.Uq = 0;
                this.Kt = [];
                this.aZ = this.dZ = this.Ay = this.fZ = !1;
                this.By = "";
                this.Rf = 0;
                this.Mr = 100;
                null != this.vm && (this.vm.Td(), this.vm.dispose(), this.vm = null);
                this.wg();
              }
              Mb() {
                null != this.JZ && this.JZ();
              }
              bb(a) {
                null != this.KQ && this.KQ(a);
              }
              ol() {}
              Ik() {}
              Lz() {}
              uq() {}
              iC() {
                return !1;
              }
              cancel() {
                this.clear();
                this.Pe = this.bb = this.Mb = null;
              }
            }
            f.lpa = b;
          })(h.csv || (h.csv = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.uP {
              constructor() {
                super();
                this.NI = this.Wua = !1;
                this.hr = null;
                this.Ba = k.i.qa.JSON;
              }
              get kb() {
                return e.ia(this.filename) && (null == this.Wd || 0 == this.Wd) && e.v(this.data);
              }
              set kb(a) {}
              get Ru() {
                return !e.v(this.data);
              }
              set Ru(a) {}
              isEqual(a) {
                return a == this ? !0 : super.isEqual(a) && e.v(a.data);
              }
              static zb(a) {
                var c = new b();
                e.v(a.browseForFile) || (c.Wd = a.browseForFile);
                e.v(a.requestPermission) || (c.requestPermission = a.requestPermission);
                e.ia(a.filename) || (c.filename = a.filename);
                e.v(a.data) || (c.data = a.data);
                e.v(a.checkUpdates) || (c.Wua = a.checkUpdates);
                e.v(a.requestHeaders) || (c.uc = a.requestHeaders);
                e.v(a.mapping) || (c.mapping = a.mapping instanceof k.O.pm ? a.mapping : new k.O.pm(a.mapping));
                e.v(a.useStreamLoader) || (c.NI = a.useStreamLoader);
                e.v(a.withCredentials) || (c.withCredentials = a.withCredentials);
                e.v(a.dataRootPath) || (c.hr = a.dataRootPath);
                return c;
              }
              static Ek(a) {
                var c = new b();
                0 != a.find("browseForFile").length && (c.Wd = e.P.Zc(a.find("browseForFile").text()));
                0 != a.find("filename").length && (c.filename = a.find("filename").text());
                return c;
              }
              gp() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = z.ba.create("<dataSource/>");
                c.attr("type", this.Ba);
                (a || this.Wd) && c.append(z.ba.create("<browseForFile/>").text(this.Wd));
                this.filename && c.append(z.ba.create("<filename/>").append(z.ba.$h(this.filename)));
                return c;
              }
              Sa() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = {};
                c.type = this.Ba;
                if (a || this.Wd) c.browseForFile = this.Wd;
                this.filename && (c.filename = this.filename);
                e.v(this.data) || (c.data = this.data);
                if (!this.mapping.kb || this.mapping.Po) c.mapping = this.mapping.Sa(!0);
                if (a || this.NI) c.useStreamLoader = this.NI;
                if (a || this.withCredentials) c.withCredentials = this.withCredentials;
                if (a || !e.v(this.hr)) c.dataRootPath = this.hr;
                return c;
              }
              clone() {
                var a = new b();
                a.Ba = this.Ba;
                this.Wd && (a.Wd = this.Wd);
                this.filename && (a.filename = this.filename);
                e.v(this.data) || (a.data = this.data);
                if (!this.mapping.kb || this.mapping.Po) a.mapping = this.mapping.clone(this.Ba);
                this.withCredentials && (a.withCredentials = this.withCredentials);
                a.NI = this.NI;
                a.hr = this.hr;
                return a;
              }
            }
            f.nP = b;
          })(h.json || (h.json = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.csv.fX {
              constructor() {
                super();
                this.cJ = 6553600;
                this.$w = !0;
                this.hr = null;
                this.v4 = () => this.LGa();
                this.isArray = !1;
                this.Gj = this.zN = 0;
                this.L0 = [".js", ".json"];
              }
              load(a, c, d, g, l) {
                this.clear();
                this.FC = this.NG = this.Dn = null;
                this.Gj = 0;
                this.$w = !0;
                this.hr = a.hr;
                this.Mb = c;
                this.bb = d;
                this.Pe = g;
                this.BG = l;
                !0 === a.Wd ? this.cba(a) : void 0 !== a.filename && "" != a.filename && "()" != a.filename.substr(-2) ? super.load(a, c, d, g, l) : (this.Mo = !0, this.PK(a.data));
              }
              LGa() {
                if (!(e.v(this.oa) || e.v(this.oa.response) || !this.$w && this.oa.response.length < this.cJ / 100)) {
                  var a = this.oa.response.substr(this.ii, this.cJ);
                  this.yr(a);
                  this.ii += a.length;
                }
              }
              qN(a) {
                var c = a.data;
                if (404 == c.target.status) this.fm(a);else if (!e.v(this.oa) && !e.v(this.oa.response)) try {
                  if (0 !== this.oa.response.length && (this.tk != c.loaded || this.GC != this.oa.response.length)) {
                    this.NM = 0 < c.total && c.lengthComputable;
                    this.GC = this.oa.response.length;
                    this.tk = c.loaded;
                    this.Mo = c.loaded == c.total;
                    var d = 0 == c.total ? e.P.bind(e.model.B.j.om, u.cc.Vg(c.loaded)) : e.P.bind(e.model.B.j.sF, u.cc.Vg(c.loaded), u.cc.Vg(c.total), (c.loaded / c.total * 100).toFixed(0));
                    e.Da(!0, e.model.B.j.jg, d);
                    this.NM && c.total < 5 * this.cJ || u.Jd().cj || !e.v(this.hr) ? this.$w = !0 : this.Xu || (this.$w = !1, this.v4());
                  }
                } catch (g) {
                  console.error(g.stack), this.fm();
                }
              }
              pN() {
                if (!e.v(this.oa) && !e.v(this.oa.response)) try {
                  if (this.Mo = !0, 0 == this.ii || !this.Xu || this.$w) {
                    const a = this.oa.response;
                    e.ia(a) && !this.Xu ? this.dV() : this.yr(a);
                    this.oa = null;
                  }
                } catch (a) {
                  console.error(a.stack), this.fm();
                }
              }
              pAa(a) {
                return this.$w && !e.v(this.hr) && 0 < this.hr.length ? u.Nc.resolve(this.hr, a) : a;
              }
              yr(a) {
                let c = null;
                try {
                  if (!this.$w) {
                    if (0 == a.length) {
                      this.Mo ? this.PK([]) : e.Be(this.v4, 100);
                      return;
                    }
                    a = this.h_(a);
                  }
                  c = this.pAa(JSON.parse(a));
                  e.v(c.items) || (c = c.items);
                  if (e.v(c.length)) {
                    this.rN();
                    return;
                  }
                } catch (d) {
                  this.rN();
                  return;
                }
                this.PK(c);
              }
              h_(a) {
                void 0 !== this.oe && 0 < this.oe.length && (a = this.oe + a);
                a = a.trim();
                if ("[" === a[0]) {
                  a = a.substr(1).trim();
                  var c = a[0];
                  a = "[" !== c && "{" !== c ? "[" + a : a;
                } else c = a.trim(), "]" === c[c.length - 1] && (c = c.slice(0, -1).trim(), a = c[c.length - 1], a = "]" !== a && "}" !== a ? c + "]" : c);
                c = a.lastIndexOf("},");
                var d = a.lastIndexOf("],");
                e.ia(this.oe) && -1 === c && -1 === d ? a = "[" + a : (c = c < d ? d : c, this.oe = a.substr(c + 2), a = "[" + a.substr(0, c + 1) + "]");
                return a;
              }
              PK(a) {
                e.v(a.items) || (a = a.items);
                (e.v(a) || 1 > a.length) && !e.model.C.F.CE ? !this.Xu && this.Mo && this.dV() : Array.isArray(a) ? (this.Xu ? this.data = this.data.concat(a.slice()) : (this.Xu = !0, this.et(), (this.isArray = !e.v(a[1]) && Array.isArray(a[1])) && this.XJa(a[0]), a[0] && Array.isArray(a[0]) ? this.dE(a[0], a[1], this.va.fa.mapping) : this.va.fa.mapping.Xea ? this.va.O.yR(this.va.fa.mapping, a[0]) : this.va.O.yR(a[0], a[1]), this.data = a.slice(), (k.O.pm.rU(a[0]) || this.isArray) && this.data.shift()), 0 == this.data.length ? this.$w ? this.iI() : this.Sz(!0) : this.$w ? u.Il.po({
                  bp: () => this.jv(),
                  ff: () => this.iI()
                }) : this.TM || u.Il.po({
                  bp: () => this.jv(),
                  ff: () => this.Sz()
                })) : e.Wa(e.model.B.j.JJ, e.model.B.j.xa);
              }
              Sz() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                a || e.v(this.oa) || !(this.oa.response.length > this.ii) && this.Mo ? (this.Xu ? (e.ia(this.oe) || ("]" == this.oe.substr(-1) && (this.oe = this.oe.substr(0, this.oe.length - 1).trim(), a = this.oe.substr(this.oe.length - 1), this.oe = "]" != a && "}" != a ? this.oe + "]" : this.oe), a = JSON.parse(this.oe), this.data.push(a), this.jv()), null != this.Mb && (this.clear(), this.Mb())) : (e.Wa(e.model.B.j.Bv, e.model.B.j.xa, e.tb.Dl), null != this.bb && (this.bb(e.model.B.j.Bv), this.bb = null)), this.clear()) : e.Be(this.v4, 1);
              }
              Ud(a) {
                if (!(e.v(a) || 1 > a.length)) {
                  this.va.ta.mva();
                  for (var c = 1 < a.length ? a[1] && Array.isArray(a[1]) : a[0] && Array.isArray(a[0]), d = 0; d < a.length; d++) this.insertData(a[d], !0, c);
                }
              }
              iI() {
                this.data = null;
                e.Da(!1);
                e.Kg(this.Mb) && this.Mb();
                this.clear();
              }
              D1() {
                return u.Jd().cj ? 0 == this.data.length ? e.P.bind(e.model.B.j.XX, this.Gj) : e.P.bind(e.model.B.j.DP, this.Gj, this.data.length, (this.Gj / this.data.length * 100).toFixed(0)) : 0 != this.tk ? e.P.bind(e.model.B.j.sF, u.cc.Vg(this.ii), u.cc.Vg(this.tk), (this.ii / this.tk * 100).toFixed(0)) : 0 == this.tk && 0 < this.data.length ? e.P.bind(e.model.B.j.DP, this.Gj, this.data.length, (this.Gj / this.data.length * 100).toFixed(0)) : e.P.bind(e.model.B.j.om, u.cc.Vg(this.ii));
              }
              jv() {
                if (0 === this.Gj % 100 && 200 < u.Yf() - this.zN) {
                  var a = e.model.B.j.CP,
                    c = this.D1();
                  1 == this.Mo && e.Da(!0, a, c);
                  this.zN = u.Yf();
                }
                if (this.Gj >= this.data.length) return !0;
                e.v(this.data[this.Gj]) || this.insertData(this.data[this.Gj], !1, this.isArray);
                this.Gj++;
                return this.Gj >= this.data.length;
              }
              Z4() {
                this.Dn = this.va.O.h1(!1);
                this.NG = [];
                for (var a = 0; a < this.Dn.length; a++) this.NG[a] = this.va.O.dD(this.Dn[a]);
                this.va.ta.pI();
              }
              XJa(a) {
                this.FC = new e.ub();
                if (Array.isArray(a)) for (var c = 0; c < a.length; c++) this.FC.Ua(a[c], c);else {
                  c = 0;
                  for (let d in a) a.hasOwnProperty(d) && (e.v(a[d]) || e.ia(a[d].uniqueName) ? this.FC.Ua(d, c) : this.FC.Ua(a[d].uniqueName, c), c++);
                }
              }
              insertData(a, c, d) {
                null === this.Dn && this.Z4();
                var g = [],
                  l = [],
                  m = !1,
                  n = new Map();
                if (c) {
                  var p = this.va.O.xS;
                  "" !== p && (d ? (m = this.FC.getItem(p), m = !e.v(a[m])) : m = !e.v(a[p]));
                }
                for (var t = 0; t < this.Dn.length; t++) {
                  p = this.Dn[t];
                  var r = this.NG[t];
                  if (d) {
                    var w = this.FC.getItem(p);
                    var y = a.hasOwnProperty("" + w);
                    w = a[w];
                  } else y = a.hasOwnProperty(p), w = a[p];
                  if (r !== k.i.input.sa.wF) if (r === k.i.input.sa.ay) var A = w;else if (!m) {
                    var B = void 0;
                    this.va.O.Q1 && (B = this.n1(a, p, d));
                    y = y ? new k.O.ae({
                      We: B,
                      value: w,
                      caption: "" + w
                    }) : new k.O.ae({
                      We: B
                    });
                    r === k.i.input.sa.Of && (w = this.va.O.bD(p), w = w.hierarchy.wa.ea(w.yb - 1).A, n.has(w) ? y.parent = n.get(w) : void 0 !== a[w] && (y.Hi = a[w]));
                    n.set(p, this.va.O.oc(y, p, r, g, l));
                  }
                }
                c ? m ? this.va.ta.sxa(A) : this.va.ta.update(g, l, A) : this.va.ta.insert(g, l, A);
              }
              n1(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var g = void 0;
                (c = this.va.O.Dda(c)) && 0 < c.length && c.forEach(l => {
                  if (d) {
                    var m = this.FC.getItem(l);
                    m = a[m];
                  } else m = a[l];
                  e.v(m) || (e.v(g) && (g = {}), g[l] = m);
                });
                return g;
              }
              rN() {
                e.Wa(e.model.B.j.JJ, e.model.B.j.xa);
                e.Da(!1);
                e.Kg(this.bb) && this.bb(e.model.B.j.JJ);
                this.Mb = this.bb = null;
                this.clear();
              }
              dV() {
                e.model.C.F.CE || e.Wa(e.model.B.j.Bv, e.model.B.j.xa, e.tb.Dl);
                e.Da(!1);
                e.Kg(this.bb) && this.bb(e.model.B.j.Bv);
                this.Mb = this.bb = null;
                this.clear();
              }
            }
            f.xna = b;
          })(h.json || (h.json = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.nZ = null;
                this.Rf = 0;
                this.Zr = this.EQ = this.cl = null;
                this.wf = 0;
              }
              getData(c) {
                this.b$ = c;
                e.Da(!0, e.model.B.j.L8);
                this.yIa();
                this.dS();
              }
              yIa() {
                this.Zr = k.Ma.R().O.yc();
                this.nZ = {};
                this.tm = [];
                for (this.wf = 0; this.wf < this.Zr.length;) {
                  var c = this.Zr.ea(this.wf);
                  var d = k.Ma.R().O.mf(c.A).type;
                  d != k.i.Qa.zc && d != k.i.Qa.Ta ? this.EIa(k.Ma.R().O.mf(c.A)) : this.CIa(c);
                  this.wf++;
                }
                this.uva(this.tm);
              }
              uva(c) {
                for (var d, g = 0; g < c.length; g++) d = {}, c[g].type != k.i.input.sa.Of && (d.caption = c[g].caption), d.type = c[g].type, c[g].type == k.i.input.sa.Of && this.cIa(c[g], d), this.nZ[c[g].A] = d;
              }
              cIa(c, d) {
                var g = c.A.split(":");
                1 == g.length ? (d.hierarchy = g[0], d.level = g[0]) : (d.hierarchy = g[0], d.level = g[g.length - 1], d.parent = g[g.length - 2], c.A = d.level);
              }
              dS() {
                this.Rf = 0;
                this.cl = [];
                this.cl.push(this.nZ);
                this.mo = k.Ma.R().ta.DM();
                u.Il.po({
                  bp: () => this.Uva(),
                  ff: () => this.nFa()
                });
              }
              Uva() {
                var c = u.Yf();
                this.EQ = [];
                this.mk = this.wf = 0;
                for (var d = this.mo && this.mo[0] ? this.mo[0].length : 0; this.Rf < d;) {
                  for (this.EQ = []; this.wf + this.mk < this.mo.length && this.wf < this.tm.length;) this.oc(this.Wva()), this.wf++;
                  this.Rf++;
                  this.cl.push(this.EQ);
                  this.mk = this.wf = 0;
                  if (100 < u.Yf() - c) break;
                }
                this.wKa(this.Rf, d);
                return this.Rf >= d;
              }
              CIa(c) {
                var d = c.inputType;
                (d == k.i.input.sa.Of || 2 < c.wa.length) && d != k.i.input.sa.Fq && d != k.i.input.sa.op ? this.DIa(c) : d == k.i.input.sa.Ta ? (this.tm.push(this.mS(d, c.zi.caption, !1, c.zi.A)), this.wf += 2) : this.tm.push(this.mS(d, c.caption, !1, c.A));
              }
              DIa(c) {
                c = c.wa;
                for (var d, g, l, m = 1; m < c.length; m++) {
                  l = m;
                  d = c.getItem(c.Oh(m));
                  for (g = d.caption; 1 < l;) l--, g = c.getItem(c.Oh(l)).A + ":" + g;
                  this.tm.push(this.mS(k.i.input.sa.Of, d.caption, !1, g));
                }
              }
              oc(c) {
                this.EQ.push(c);
              }
              Wva() {
                var c = this.tm[this.wf].type;
                if (c != k.i.input.sa.Ta) var d = this.Zr.getItem(this.tm[this.wf].A).za(this.mo[this.wf + this.mk][this.Rf]).caption;
                if (c == k.i.input.sa.jb) return null != d ? parseFloat(d) : "";
                if (c == k.i.input.sa.$c || c == k.i.input.sa.kn || c == k.i.input.sa.ih) return null != d && d != e.model.B.j.Fl ? d.toString() : "";
                if (c == k.i.input.sa.Of) {
                  c = this.Zr.getItem(this.tm[this.wf].caption);
                  for (var g = 0; g < c.wa.length - 2; g++) this.oc(d), this.tm[this.wf], this.wf++, d = null == this.mo[this.wf + this.mk][this.Rf] || "" == this.mo[this.wf + this.mk][this.Rf] + "" ? "" : c.za(this.mo[this.wf + this.mk][this.Rf]).caption;
                } else {
                  if (c == k.i.input.sa.lj) return this.Zr.getItem(this.tm[this.wf].caption).za(this.mo[this.wf + this.mk][this.Rf]).fc;
                  if (c == k.i.input.sa.Ta) return d = "", c = this.Zr.getItem(this.tm[this.wf].caption + ".Year").za(this.mo[this.wf + this.mk][this.Rf]), d += c.caption + "-", this.mk++, c = this.Zr.getItem(this.tm[this.wf].caption + ".Month").za(this.mo[this.wf + this.mk][this.Rf]), d += e.model.B.j.Ur.indexOf(c.caption) + 1 + "-", this.mk++, c = this.Zr.getItem(this.tm[this.wf].caption + ".Day").za(this.mo[this.wf + this.mk][this.Rf]), d += c.caption;
                  if (c == k.i.input.sa.Fq || c == k.i.input.sa.op) return this.Nva(c);
                  if (c == k.i.input.sa.Lc || c == k.i.input.sa.ic) return this.Zr.getItem(this.tm[this.wf].A).za(this.mo[this.wf + this.mk][this.Rf]).fc;
                }
                return d;
              }
              nFa() {
                e.Da(!1);
                null != this.b$ && this.b$(this.cl);
              }
              Nva(c) {
                this.mk += 2;
                this.mk = c == k.i.input.sa.op ? this.mk + 1 : this.mk;
                return this.Zr.getItem(this.tm[this.wf].caption).vM(this.mo[this.wf + this.mk][this.Rf]);
              }
              EIa(c) {
                this.tm.push(this.mS(k.i.Qa.oA(c.type), c.rl, !0, c.A));
              }
              wKa(c, d) {
                c = e.P.bind(e.model.B.j.y8, (c / d * 100).toFixed(0));
                e.Da(!0, e.model.B.j.L8, c);
              }
              mS(c, d) {
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                let l = arguments.length > 3 ? arguments[3] : undefined;
                var m = new a();
                m.caption = d;
                m.type = c;
                m.rg = g;
                m.A = l;
                return m;
              }
            }
            f.MX = b;
            class a {
              constructor() {}
              get type() {
                return this.Cg;
              }
              set type(c) {
                this.Cg = c;
              }
              get caption() {
                return this.xc;
              }
              get rg() {
                return this.ksa;
              }
              set rg(c) {
                this.ksa = c;
              }
              set caption(c) {
                this.xc = c;
              }
              get A() {
                return this.KK;
              }
              set A(c) {
                this.KK = c;
              }
            }
            f.AMa = a;
          })(h.json || (h.json = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.Aqa {
              constructor() {
                super(...arguments);
                this.Gj = this.zN = 0;
                this.Dn = null;
                this.isArray = this.B2 = this.uU = !1;
              }
              load(a, c, d, g, l) {
                this.clear();
                this.Mb = c;
                this.bb = d;
                this.Pe = g;
                this.BG = l;
                this.ka = a;
                this.filename = a.filename;
                !e.ia(this.filename) && "()" != this.filename.substr(-2) || !1 !== a.Wd ? (this.filename = u.py.FH(this.filename, !e.model.C.F.ER), e.Da(!0, e.model.B.j.jg), this.cO(this.filename, a.uc)) : this.Q3();
              }
              gFa() {
                e.Da(!0, e.model.B.j.jg, "");
              }
              mGa(a) {
                a = 0 == a.total ? e.P.bind(e.model.B.j.om, u.cc.Vg(a.loaded)) : e.P.bind(e.model.B.j.sF, u.cc.Vg(a.loaded), u.cc.Vg(a.total), (a.loaded / a.total * 100).toFixed(0));
                e.Da(!0, e.model.B.j.jg, a);
              }
              Q3() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                e.Da(!1);
                var c = "",
                  d = "";
                null != a && null != a.target && null != a.target.response && "" != a.target.response && (d = e.model.Tb.validate(a.target.response), c = d = 700 < d.length ? d.substr(0, 700) : d, d = e.P.bind(e.model.B.j.FP, d).replace(/'/g, ""));
                0 == this.B2 && (this.B2 = !0, a = e.model.Tb.valid(this.filename) ? this.filename : e.model.Tb.validate(this.filename), e.Wa(e.P.bind(e.model.B.j.LJ, a) + d, e.model.B.j.xa, e.tb.xa));
                null != this.bb && (this.bb(c), this.bb = null);
                this.wg();
              }
              UGa(a, c, d) {
                try {
                  const g = d ? JSON.parse(a) : JSON.parse(this.h_(a));
                  Array.isArray(g) ? (this.PK(g), u.Il.po({
                    bp: () => this.jv(),
                    ff: c
                  })) : this.rN();
                } catch (g) {
                  this.rN();
                }
              }
              h_(a) {
                void 0 !== this.oe && 0 < this.oe.length && (a = this.oe + a);
                a = a.replace(/^\s+/, "");
                if ("[" == a[0]) {
                  a = a.substr(1).replace(/^\s+/, "");
                  var c = a[0];
                  a = "[" != c && "{" != c ? "[" + a : a;
                } else c = a.replace(/\s+$/, ""), "]" == c[c.length - 1] && (c = c.substr(0, c.length - 1).replace(/\s+$/, ""), a = c[c.length - 1], a = "]" != a && "}" != a ? c + "]" : c);
                c = a.lastIndexOf("},");
                var d = a.lastIndexOf("],");
                c = c < d ? d : c;
                this.oe = a.substr(c + 2);
                return a = "[" + a.substr(0, c + 1) + "]";
              }
              PK(a) {
                e.v(a.items) || (a = a.items);
                (e.v(a) || 1 > a.length) && !e.model.C.F.CE ? !this.uU && this.qU && this.dV() : Array.isArray(a) ? (this.uU ? this.data = this.data.concat(a.slice()) : (this.uU = !0, this.et(), this.ee = k.Ma.R().O, this.ta = k.Ma.R().ta, this.isArray = a[1] && Array.isArray(a[1]), this.ka.mapping.kb ? a[0] && Array.isArray(a[0]) ? this.dE(a[0], a[1]) : this.ee.yR(a[0]) : this.ee.yR(this.ka.mapping.Sa()), this.data = a.slice(), (k.O.pm.rU(a[0]) || this.isArray) && this.data.shift()), 0 == this.data.length && this.iI()) : e.Wa(e.model.B.j.JJ, e.model.B.j.xa);
              }
              dE(a, c) {
                try {
                  var d = e.v(c) ? [] : c;
                  this.Em = [];
                  for (c = 0; c < a.length; c++) {
                    var g = this.lT(d[c]),
                      l = this.Mw(a[c], g, 0 == d.length),
                      m = this.u1(a[c], g, 0 == d.length),
                      n = this.jM(a[c]),
                      p = this.hM(n),
                      t = {
                        type: l,
                        uniqueName: n,
                        caption: p,
                        isMeasure: m
                      };
                    if (!t.hasOwnProperty("visible") || !1 !== t.visible) {
                      this.uC[c] = t.type;
                      this.Ue[c] = t.isMeasure;
                      this.Em[c] = n;
                      if (l === k.i.input.sa.Of) {
                        var r = n.split(":");
                        t.hierarchy = r[0];
                        t.level = r.pop();
                        t.parent = r.join(":");
                      }
                      this.ee.Dy(t, n);
                    }
                  }
                } catch (w) {
                  console.error(w.stack), this.E3();
                }
              }
              E3() {
                e.Da(!1);
                e.Wa(e.P.bind(e.model.B.j.F8), e.model.B.j.xa, e.tb.xa);
              }
              lT(a) {
                void 0 !== a && null !== a && "string" == typeof a && (a = a.replace(",", "."));
                return a;
              }
              jM(a) {
                a = a.trim();
                if (-1 < this.Em.indexOf(a)) {
                  for (var c = 1, d = a; -1 < this.Em.indexOf(d);) d = a + c, c++;
                  a = d;
                }
                return a;
              }
              hM(a) {
                return this.yz(a) ? (a = a.split(":"), a[a.length - 1]) : a;
              }
              u1(a, c, d) {
                return !e.model.C.F.Ke || e.v(c) && !d ? !1 : "-" === a.trim().charAt(0);
              }
              Mw(a, c, d) {
                var g = k.i.input.sa.jb;
                a = a.trim();
                if (e.v(c) && !d) return k.i.input.sa.$c;
                "+" === a.charAt(0) ? g = k.i.input.sa.$c : "t+" === a.substr(0, 2) ? g = k.i.input.sa.ic : "dt+" === a.substr(0, 3) ? g = k.i.input.sa.Lc : "n+" === a.substr(0, 2) ? g = k.i.input.sa.jb : "-" === a.charAt(0) ? g = k.i.input.sa.jb : "ds+" === a.substr(0, 3) ? g = k.i.input.sa.lj : "d+" === a.substr(0, 2) ? g = k.i.input.sa.Ta : "m+" === a.substr(0, 2) ? g = k.i.input.sa.ih : "w+" === a.substr(0, 2) ? g = k.i.input.sa.kn : "D+" === a.substr(0, 2) ? g = k.i.input.sa.Fq : "D4+" === a.substr(0, 3) ? g = k.i.input.sa.op : "id+" === a.substr(0, 3) ? g = k.i.input.sa.ay : "" == c || void 0 === c ? g = k.i.input.sa.$c : isNaN(Number(c)) && (g = e.P.gU(c) ? e.model.C.F.HL : k.i.input.sa.$c);
                g === k.i.input.sa.$c && this.yz(a) && (g = k.i.input.sa.Of);
                return g;
              }
              yz(a) {
                "+" === a.charAt(0) && (a = a.substr(1));
                return 1 < a.split(":").length && -1 < this.Em.indexOf(a.split(":")[0].trim());
              }
              jv() {
                if (0 === this.Gj % 100 && 200 < u.Yf() - this.zN) {
                  var a = e.model.B.j.CP,
                    c = this.D1();
                  1 == this.qU && e.Da(!0, a, c);
                  this.zN = u.Yf();
                }
                if (this.Gj >= this.data.length) return !0;
                e.v(this.data[this.Gj]) || this.insertData(this.data[this.Gj], this.isArray);
                this.data[this.Gj] = void 0;
                this.Gj++;
                return this.Gj >= this.data.length;
              }
              Z4() {
                this.Dn = this.ee.h1(!1);
                this.NG = [];
                for (var a = 0; a < this.Dn.length; a++) this.NG[a] = this.ee.dD(this.Dn[a]);
                this.ta.pI();
              }
              insertData(a, c) {
                null === this.Dn && this.Z4();
                for (var d, g, l = [], m = [], n, p, t, r = 0; r < this.Dn.length; r++) if (d = this.Dn[r], g = this.NG[r], c ? (t = a.hasOwnProperty("" + r), p = a[r]) : (t = a.hasOwnProperty(d), p = a[d]), g !== k.i.input.sa.wF) if (g === k.i.input.sa.ay) n = p;else {
                  var w = void 0;
                  this.ee.Q1 && (w = this.n1(a, d, c));
                  p = t ? new k.O.ae({
                    We: w,
                    value: p,
                    caption: String(p)
                  }) : new k.O.ae({
                    We: w
                  });
                  g === k.i.input.sa.Of && (t = this.ee.bD(d), t = t.hierarchy.wa.ea(t.yb - 1).A, p.Hi = a[t]);
                  this.ee.oc(p, d, g, l, m);
                }
                this.ta.insert(l, m, n);
              }
              n1(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var g = void 0;
                (c = this.ee.Dda(c)) && 0 < c.length && c.forEach(l => {
                  var m = d ? a[this.Dn.indexOf(l)] : a[l];
                  e.v(m) || (e.v(g) && (g = {}), g[l] = m);
                });
                return g;
              }
              D1() {
                return e.P.bind(e.model.B.j.toa, u.cc.lz(this.Gj.toString()), (this.hC / this.hL * 100).toFixed(0));
              }
              iI() {
                this.data = null;
                e.Da(!1);
                e.Kg(this.Mb) && this.Mb();
                this.clear();
              }
              et() {
                null != this.Pe && (this.Pe(), this.Pe = null);
              }
              TGa() {
                e.Da(!1);
                if (this.uU) {
                  if (!e.ia(this.oe)) {
                    if ("]" == this.oe.substr(-1)) {
                      this.oe = this.oe.substr(0, this.oe.length - 1).trim();
                      var a = this.oe.substr(this.oe.length - 1);
                      this.oe = "]" != a && "}" != a ? this.oe + "]" : this.oe;
                    }
                    a = JSON.parse(this.oe);
                    this.data.push(a);
                    this.jv();
                  }
                  null != this.Mb && (this.clear(), this.Mb());
                } else e.Wa(e.model.B.j.Bv, e.model.B.j.xa, e.tb.Dl), null != this.bb && (this.bb(), this.bb = null);
                this.clear();
              }
              rN() {
                e.Wa(e.model.B.j.JJ, e.model.B.j.xa);
                e.Da(!1);
                e.Kg(this.bb) && this.bb();
                this.Mb = this.bb = null;
                this.clear();
              }
              dV() {
                e.model.C.F.CE || e.Wa(e.model.B.j.Bv, e.model.B.j.xa, e.tb.Dl);
                e.Da(!1);
                e.Kg(this.bb) && this.bb();
                this.Mb = this.bb = null;
                this.clear();
              }
              clear() {
                this.data = [];
                this.tk = 0;
                this.uC = [];
                this.Ue = [];
                this.B2 = !1;
                this.oe = "";
                null != this.oa && (this.oa.Td(), this.oa.dispose(), this.oa = null);
                this.wg();
              }
              cancel() {
                this.clear();
                this.Pe = this.bb = this.Mb = null;
              }
              ol() {
                throw Error("Method not implemented.");
              }
              Ik() {
                throw Error("Method not implemented.");
              }
              Lz() {
                throw Error("Method not implemented.");
              }
              uq() {
                throw Error("Method not implemented.");
              }
              iC() {
                return !1;
              }
            }
            f.yna = b;
          })(h.json || (h.json = {}));
        })(k.local || (k.local = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends k.w6 {
            pI() {
              this.z_();
              const b = [];
              for (var a = this.slice.yc(!1), c = 0; c < a.length; c++) {
                const g = a.ea(c);
                this.ym(g.A, g.A);
                e.model.C.F.tc && this.yn(this.va.O.mf(g.A));
                for (var d = 1; d < g.wa.length; d++) {
                  const l = g.wa.ea(d);
                  this.ym(l.A, g.A);
                }
              }
              a = e.u.i.qa.Cc === this.va.fa.Ba ? this.yya(this.slice.Sf) : this.slice.Sf;
              for (c = 0; c < a.length; c++) this.yn(a[c], b);
              if (e.u.i.qa.Cc === this.va.fa.Ba) for (c = 0; c < a.length; c++) d = a[c], d.Oa && (this.Fy(d.A, d.Bm), this.QK(d));
              this.slice.iA(b);
            }
            yya(b) {
              const a = [],
                c = {};
              if (void 0 !== b) {
                let l, m, n;
                for (var d = 0; d < b.length; d++) {
                  var g = b[d].aa;
                  l = b[d].A;
                  m = b[d].hidden;
                  void 0 === c[l + "_" + g] ? (n = a.length, c[l + "_" + g] = {
                    RD: n,
                    afa: m
                  }, a.push(b[d])) : (g = c[l + "_" + g], g.afa && !m && (a.splice(g.RD, 1), g.RD = a.length, g.afa = b[d].hidden, a.push(b[d])));
                }
              }
              return a;
            }
            di(b, a, c) {
              let d, g;
              "string" !== typeof b ? (d = b.A, g = k.i.da.YM(b.aa) ? b.aa : b.Bm) : d = b;
              e.v(a) || (g = a);
              return super.di(d, g, c);
            }
            yn(b, a) {
              b && (e.u.i.qa.Cc === this.va.fa.Ba && b.Oa || (this.Fy(b.A, b.Bm), k.i.da.YM(b.aa) && this.Fy(b.A, b.aa), this.QK(b)), b.Oa && this.qaa(b, this.slice.Yc.Ca, a), void 0 !== a && a.push(b));
            }
            qaa(b, a, c) {
              if ((a = u.wt.uM(b.Sd, a)) && 0 < a.length) for (let l = 0; l < a.length; l++) {
                var d = a[l],
                  g = this.va.O.fd(d.A);
                if (null != g) {
                  let m = this.slice.Di(d);
                  if (null == m) {
                    m = g.clone();
                    m.aa = d.aa;
                    d = m.hidden = !0;
                    if (void 0 !== c) for (g = 0; g < c.length; g++) c[g].A === m.A && (m.aa === k.i.da.NONE || c[g].aa === b.aa && c[g].Bm === b.Bm) && (d = !1);
                    d && (c.push(m), this.QK(m), this.Fy(m.A, m.Bm), k.i.da.YM(m.aa) && this.Fy(m.A, m.aa));
                  }
                }
              }
            }
            dC(b) {
              return this.va.fa.Ba == k.i.qa.hg && b && 0 == this.va.fa.mapping.La(b.A, "min_doc_count");
            }
            uG(b) {
              return this.va.fa.Ba == k.i.qa.hg && b && 0 == this.va.fa.mapping.La(b.A, "min_doc_count");
            }
          }
          h.vX = f;
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    var Ka = q || (q = {}),
      La = Ka.u || (Ka.u = {}),
      Ma = La.external || (La.external = {}),
      Na = Ma.Fb || (Ma.Fb = {});
    class Oa {}
    Oa.NONE = 0;
    Oa.dX = 1;
    Oa.hY = 2;
    Oa.mY = 3;
    Oa.bJ = 4;
    Oa.mX = 5;
    Na.Mj = Oa;
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.pm {
              constructor() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                super(a);
              }
            }
            f.MP = b;
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.ut {
              constructor() {
                super(...arguments);
                this.Cm = !1;
                this.wj = this.Dj = this.Pk = this.rf = this.Ze = this.df = this.c$ = this.ai = "";
                this.mapping = new f.MP();
                this.Ox = !0;
                this.Pv = "";
                this.version = 0;
              }
              get ze() {
                return this.c$;
              }
              set ze(a) {
                a = a.replace("[", "");
                this.c$ = a = a.replace("]", "");
              }
              get va() {
                return this.df;
              }
              set va(a) {
                a = a.replace("[", "");
                this.df = a = a.replace("]", "");
              }
              get Fm() {
                return this.Ba != k.i.qa.Cc ? "" : "" == this.Pv && null != this.credentials && this.credentials.Qm ? "credentials=" + this.credentials.hash : this.Pv;
              }
              set Fm(a) {
                this.Pv = a;
              }
              get VM() {
                return this.Cm;
              }
              get kb() {
                return e.ia(this.rf);
              }
              set kb(a) {}
              get Ru() {
                return !1;
              }
              set Ru(a) {}
              get RH() {
                return !1;
              }
              get jU() {
                return this.Ba != k.i.qa.Md || this.VM ? !0 : !1;
              }
              get iU() {
                return this.Ba == k.i.qa.Cc && this.VM;
              }
              isEqual(a) {
                return super.isEqual(a) && this.rf === a.rf && this.ze === a.ze && this.va === a.va && this.ai === a.ai && this.Cm === a.Cm && this.Ze === a.Ze && this.mapping.isEqual(a.mapping) && this.Ox === a.Ox && (this.Ba != k.i.qa.Md ? this.Ze === a.Ze : !0) && (this.Ba === k.i.qa.Cc ? this.Dj === a.Dj : !0) && (this.Ba === k.i.qa.Cc ? this.wj === a.wj : !0) && (this.Ba === k.i.qa.Cc ? this.Fm === a.Fm : !0);
              }
              static zb(a) {
                var c = new b();
                e.v(a.dataSourceType) || (c.Ba = a.dataSourceType);
                e.v(a.dataSourceInfo) || (c.ai = a.dataSourceInfo);
                e.v(a.catalog) || (c.ze = a.catalog);
                e.v(a.cube) || (c.va = a.cube);
                e.v(a.roles) || (c.Pk = a.roles);
                e.v(a.proxyUrl) || (c.rf = a.proxyUrl);
                e.v(a.localeIdentifier) || (c.Dj = a.localeIdentifier);
                e.v(a.subquery) || (c.Ze = a.subquery);
                e.v(a.effectiveUserName) || (c.wj = a.effectiveUserName);
                e.v(a.customData) || (c.Fm = a.customData);
                e.v(a.binary) || (c.Cm = a.binary);
                e.v(a.requestHeaders) || (c.uc = a.requestHeaders);
                e.v(a.mapping) || (c.mapping = a.mapping instanceof f.MP ? a.mapping : new f.MP(a.mapping));
                e.v(a.useGranularityNamesForDateFilters) || (c.Ox = a.useGranularityNamesForDateFilters);
                c.credentials = f.jj.P9.zb(a);
                e.v(a.withCredentials) || (c.withCredentials = a.withCredentials);
                return c;
              }
              static Ek(a) {
                var c = new b();
                a = a.find("dataSource");
                var d = a.attr("type");
                void 0 !== d && (d = d.toLowerCase());
                "msolap" == d && (d = k.i.qa.Cc);
                d && -1 < d.indexOf("pentaho") && (d = k.i.qa.Md);
                if (!k.i.qa.valid(d)) {
                  var g = a.find("proxyUrl");
                  0 < g.length && 0 < g.text().length && (d = k.i.qa.Cc);
                }
                c.Ba = d;
                0 != a.find("dataSourceInfo").length && (c.ai = a.find("dataSourceInfo").text());
                0 != a.find("catalog").length && (c.ze = a.find("catalog").text());
                0 != a.find("cube").length && (c.va = a.find("cube").text());
                0 != a.find("subquery").length && (c.Ze = a.find("subquery").text());
                0 != a.find("roles").length && (c.Pk = a.find("roles").text());
                0 != a.find("proxyUrl").length && (c.rf = a.find("proxyUrl").text());
                0 != a.find("localeIdentifier").length && (c.Dj = a.find("localeIdentifier").text());
                0 != a.find("effectiveUserName").length && (c.wj = a.find("effectiveUserName").text());
                0 != a.find("customData").length && (c.Fm = a.find("customData").text());
                0 != a.find("binary").length && (c.Cm = e.P.Zc(a.find("binary").text()));
                0 != a.find("credentials").length && (d = {}, 0 != a.find("credentials").find("hash").length && (d.hash = a.find("credentials").find("hash").text()), 0 != a.find("credentials").find("username").length && (d.username = a.find("credentials").find("username").text()), 0 != a.find("credentials").find("password").length && (d.password = a.find("credentials").find("password").text()), c.credentials = f.jj.P9.zb(d));
                return c;
              }
              gp() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = z.ba.create("<dataSource/>");
                c.attr("type", this.Ba);
                switch (this.Ba) {
                  case k.i.qa.Cc:
                    (a || "" != this.Dj) && c.append(z.ba.create("<localeIdentifier/>").text(this.Dj)), (a || "" != this.wj) && c.append(z.ba.create("<effectiveUserName/>").text(this.wj)), (a || "" != this.Pv) && c.append(z.ba.create("<customData/>").text(this.Pv));
                  case k.i.qa.Md:
                    c.append(z.ba.create("<proxyUrl/>").append(z.ba.$h(this.rf))), (a || "" != this.ai) && c.append(z.ba.create("<dataSourceInfo/>").text(this.ai)), c.append(z.ba.create("<catalog/>").text(this.ze)), c.append(z.ba.create("<cube/>").text(this.va)), c.append(z.ba.create("<binary/>").text(this.Cm)), (a || "" != this.Pk) && c.append(z.ba.create("<roles/>").text(this.Pk)), this.credentials && this.credentials.Qm && (a = z.ba.create("<hash/>").text(this.credentials.hash), c.append(z.ba.create("<credentials/>").append(a)));
                }
                return c;
              }
              Sa() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = {};
                c.type = this.Ba;
                switch (this.Ba) {
                  case k.i.qa.Cc:
                    if (a || "" != this.Dj) c.localeIdentifier = this.Dj;
                    if (a || "" != this.wj) c.effectiveUserName = this.wj;
                    if (a || "" != this.Pv) c.customData = this.Pv;
                    if (a || this.withCredentials) c.withCredentials = this.withCredentials;
                    if (a || 1 != this.Ox) c.useGranularityNamesForDateFilters = this.Ox;
                  case k.i.qa.Md:
                    c.proxyUrl = this.rf;
                    if (a || "" != this.ai) c.dataSourceInfo = this.ai;
                    c.catalog = this.ze;
                    c.cube = this.va;
                    c.binary = this.Cm;
                    if (a || "" != this.Pk) c.roles = this.Pk;
                    this.credentials && this.credentials.Qm && (c.credentials = {
                      hash: this.credentials.hash
                    });
                }
                if (!this.mapping.kb || this.mapping.Po) c.mapping = this.mapping.Sa(!0);
                return c;
              }
              clone() {
                var a = new b();
                a.Ba = this.Ba;
                switch (this.Ba) {
                  case k.i.qa.Cc:
                    "" !== this.Dj && (a.Dj = this.Dj), "" !== this.wj && (a.wj = this.wj), "" !== this.Pv && (a.Fm = this.Pv), this.withCredentials && (a.withCredentials = this.withCredentials), 1 != this.Ox && (a.Ox = this.Ox);
                  case k.i.qa.Md:
                    a.rf = this.rf, "" !== this.ai && (a.ai = this.ai), a.ze = this.ze, a.va = this.va, a.Cm = this.Cm, "" !== this.Pk && (a.Pk = this.Pk), this.credentials && this.credentials.Qm && (a.credentials = {
                      hash: this.credentials.hash
                    });
                }
                if (!this.mapping.kb || this.mapping.Po) a.mapping = this.mapping.clone(this.Ba);
                return a;
              }
            }
            b.sessionId = 0;
            f.sp = b;
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.vX {
              $T(a, c, d, g, l, m) {
                for (var n = [], p = [], t = 0; t < a.length; t++) {
                  if (-1 === a[t][1]) return;
                  p[t] = a[t][1];
                  n[this.wa[this.Uh[t]][a[t][0]]] = p[t];
                }
                a = [];
                for (t = 0; t < c.length; t++) {
                  if (-1 === c[t][1]) return;
                  a[t] = c[t][1];
                  n[this.wa[this.wk[t]][c[t][0]]] = a[t];
                }
                c = this.ts(p, a);
                p = this.vb.length;
                void 0 !== this.values[c] ? p = this.Iya(n) : (this.mh.push(p), this.vb.push(n));
                0 < g.length && (n = l === k.i.ha.Ia ? this.ld(g, this.Bd) : this.ld(g, this.Od), -1 === n[0][0].indexOf(p) && n[0][0].push(p), m === k.i.$d.jX && (g = g.slice(0, -1), l = l === k.i.ha.Ia ? this.ld(g, this.Bd) : this.ld(g, this.Od), -1 === l[0][0].indexOf(p) && l[0][0].push(p)));
                this.values[c] = d;
              }
              Iya(a) {
                for (var c, d = 0; d < this.vb.length; d++) if (a.length === this.vb[d].length) {
                  c = !0;
                  for (var g = 0; g < a.length; g++) if (a[g] !== this.vb[d][g]) {
                    c = !1;
                    break;
                  }
                  if (c) return d;
                }
                return this.vb.length;
              }
              La(a, c, d) {
                var g = this.ts(a, c),
                  l = this.di(d);
                void 0 === this.values[g] && (this.values[g] = []);
                if (!e.model.C.F.iu || !d.Oa) return e.v(this.values[g][l]) ? NaN : this.values[g][l];
                if (void 0 == this.values[g][l]) {
                  var m = this.ld(a, this.Bd),
                    n = this.ld(c, this.Od);
                  if (void 0 === m || void 0 === m[0] || void 0 === n || void 0 === n[0]) return NaN;
                  a = this.Up([g], d.Sd, d.Gk, 0, a, c, d.zn);
                  if (!0 === a || !1 === a) a = !0 === a ? 1 : 0;
                  this.values[g][l] = a;
                }
                return e.v(this.values[g][l]) ? NaN : this.values[g][l];
              }
              xB(a, c, d) {
                if (void 0 !== a) {
                  var g = a[0][0];
                  if (0 < g.length && !isNaN(c)) for (var l = 0; l < g.length; l++) {
                    var m = this.vb[g[l]][this.wa[c][1]];
                    0 !== m && void 0 !== m && (void 0 === a[m] ? (a[m] = [[[g[l]], [], [], void 0, void 0, !1]], a[0][1].push(m)) : a[0][5] || a[m][0][0].push(g[l]));
                  }
                  void 0 === a[0][3] && (a[0][3] = []);
                  void 0 === d ? a[0][3][this.xg.length] = !0 : a[0][3][this.di(d)] = !0;
                  a[0][5] = !0;
                }
              }
              HQ(a, c, d, g, l) {
                var m = c[0][0];
                if (0 < m.length && !isNaN(g)) for (var n = 0; n < m.length; n++) {
                  var p = this.vb[m[n]][g];
                  0 !== p && void 0 !== p && (void 0 === a[p] ? (a[p] = [[[m[n]], [], [], void 0, void 0]], c[0][2].push(p), this.Vl[d][p] = g) : -1 === a[p][0][0].indexOf(m[n]) && a[p][0][0].push(m[n]));
                }
                void 0 === c[0][4] && (c[0][4] = []);
                void 0 === l ? c[0][4][this.xg.length] = !0 : c[0][4][this.di(l)] = !0;
              }
              Rp(a, c, d) {
                for (var g = 0; g < c.length; g++) {
                  var l = c[g],
                    m = d[g];
                  if (e.model.C.F.KT) {
                    var n = this.slice.yc().getItem(this.je[m]),
                      p = n.za(l);
                    e.v(n.vz) || e.v(this.wa) || e.v(d[g]) || e.v(this.wa[d[g]]) || (m = this.wa[d[g]][p.level.yb]);
                  }
                  m = e.v(this.Vl[m]) || e.v(this.Vl[m][l]) ? m : this.Vl[m][l];
                  n = [];
                  for (p = 0; p < a.length; p++) this.vb[a[p]][m] === l && n.push(a[p]);
                  a = n;
                }
                return a;
              }
              yn(a, c) {
                a && super.yn(a, c);
              }
              qaa(a, c, d) {
                a = u.wt.uM(a.Sd, c);
                for (var g = 0; g < a.length; g++) {
                  var l = this.va.O.fd(a[g].A);
                  null == l || c.Bb(l.A) || (l.hidden = !0, d.push(l), this.QK(l), this.Fy(l.A, l.Bm), k.i.da.YM(l.aa) && this.Fy(l.A, l.aa));
                }
              }
            }
            f.mpa = b;
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.uka {
                constructor(c, d) {
                  super(c, d);
                }
              }
              b.W8 = a;
            })(f.O || (f.O = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.Or {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                }
                get dk() {
                  return this.Oa || this.$g ? [] : k.i.da.m6;
                }
                set dk(c) {}
                get aa() {
                  return "" == this.lk ? this.Wc[0] : this.lk;
                }
                set aa(c) {
                  c && c.toLowerCase() != this.lk ? (c = c.toLowerCase(), k.i.da.az(c) && (c = k.i.da.mz(c)), k.i.da.BLa(c) || this.Oa && c == k.i.da.NONE ? (this.Tv = void 0, this.lk = c, -1 == this.Wc.indexOf(c) && (this.lk = this.Wc[0])) : this.PV()) : "" == c && this.PV();
                }
                get jc() {
                  return e.model.Tb.valid(this.xc) ? this.xc : e.model.Tb.validate(this.xc);
                }
                get caption() {
                  if (0 == e.model.C.F.Fx) return this.jc;
                  switch (this.aa) {
                    case k.i.da.Vr:
                      return e.P.bind(e.model.B.j.VJ, this.jc);
                    case k.i.da.tp:
                      return e.P.bind(e.model.B.j.PJ, this.jc);
                    case k.i.da.Kq:
                      return e.P.bind(e.model.B.j.UJ, this.jc);
                    case k.i.da.Iq:
                      return e.P.bind(e.model.B.j.SJ, this.jc);
                    case k.i.da.Jq:
                      return e.P.bind(e.model.B.j.TJ, this.jc);
                    case k.i.da.Pi:
                      return e.P.bind(e.model.B.j.DJ, this.jc);
                    case k.i.da.Xn:
                      return e.P.bind(e.model.B.j.iJ, this.jc);
                    case k.i.da.fn:
                      return e.P.bind(e.model.B.j.jJ, this.jc);
                    case k.i.da.co:
                      return e.P.bind(e.model.B.j.QJ, this.jc);
                    case k.i.da.hn:
                      return e.P.bind(e.model.B.j.RJ, this.jc);
                  }
                  return this.jc;
                }
                set caption(c) {
                  "" == c.trim() ? this.xc = e.model.B.j.Fl : this.xc = c;
                }
                get rl() {
                  return this.jc;
                }
                set rl(c) {}
                clone() {
                  var c = new a(this.A);
                  this.zL(c);
                  return c;
                }
              }
              b.bB = a;
            })(f.O || (f.O = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.aJ {
                get caption() {
                  return this.hierarchy.gD(this.ordinal);
                }
                set caption(c) {}
                get Sh() {
                  return this.level.Su ? !0 : this.hierarchy.XM || this.hierarchy.Ms || this.level.Su ? (this.Yg || !this.zf) && 0 == this.children.length : !1;
                }
                set Sh(c) {}
                get Ci() {
                  return this.A;
                }
              }
              b.X8 = a;
            })(f.O || (f.O = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.qv {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  super(c, d, g);
                }
              }
              b.ppa = a;
            })(f.O || (f.O = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.rt {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                  this.aaa = 0;
                }
                get Vm() {
                  return this.aaa;
                }
                set Vm(c) {
                  this.Rh || (c += 1);
                  this.aaa = c;
                }
                oc(c) {
                  c.A == this.$r && (c.dc = !0);
                  return super.oc(c);
                }
                set Am(c) {
                  "" != c && !e.v(c) || this.Ue ? this.$r = c : (this.$r = this.A + ".[(All)]", this.Mh(new k.O.qv(this.A, this.caption + " (All)")), this.oc(new k.O.ae({
                    A: this.$r,
                    caption: this.caption + " (All)",
                    dc: !0
                  })), this.DB = !1);
                }
                get Am() {
                  return this.$r;
                }
                zm() {
                  let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "(Total)";
                  if (this.Rh) return this.Am + ".[" + c + "]";
                  var d = this.Bs.split("].");
                  d.pop();
                  d.push("[" + c + "]");
                  return d.join("].");
                }
                sW(c, d) {
                  var g = this.lja(c.children);
                  g = e.Kg(this.nx) ? this.Pia(g) : this.EZ(g);
                  for (var l = [], m = 0; m < g.length; m++) if (l.push(g[m].ordinal), d && !c.Sh) {
                    var n = this.ck(g[m], d);
                    0 < n.length && (l = l.concat(n));
                  }
                  return l;
                }
                EZ(c) {
                  this.eg === k.i.Aa.kc && e.Ja.sort(c, e.Ja.Qi, d => d.fc);
                  this.eg === k.i.Aa.Mc && e.Ja.sort(c, e.Ja.lp | e.Ja.Qi, d => d.fc);
                  return c;
                }
                VS(c) {
                  c = this.Nv.find(c);
                  return this.za(c);
                }
                hD() {
                  return new b.X8(this);
                }
              }
              b.ZX = a;
            })(f.O || (f.O = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.AA {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                }
              }
              b.npa = a;
            })(f.O || (f.O = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.YW {
                constructor() {
                  super();
                  this.hH = new b.opa();
                }
                WZ(c, d) {
                  this.M2.Ua(c.A, c);
                  if (0 == e.ia(c.value)) {
                    var g = new b.bB(c.value, this.rz(c.value, c.caption, e.model.B.j.m8, d));
                    g.Ig = e.model.B.j.ey;
                    g.Oc = c.caption;
                    g.type = k.i.Qa.jb;
                    g.qr = c.A;
                    this.rk(g);
                  }
                  0 == e.ia(c.Uw) && (g = new b.bB(c.Uw, this.rz(c.Uw, c.caption, e.model.B.j.i8, d)), g.Ig = e.model.B.j.ey, g.Oc = c.caption, g.type = k.i.Qa.jb, g.qr = c.A, this.rk(g));
                  0 == e.ia(c.status) && (g = new b.bB(c.status, this.rz(c.status, c.caption, e.model.B.j.k8, d)), g.Ig = e.model.B.j.ey, g.Oc = c.caption, g.type = k.i.Qa.jb, g.qr = c.A, g.Ez = !0, this.rk(g));
                  0 == e.ia(c.Mx) && (d = new b.bB(c.Mx, this.rz(c.Mx, c.caption, e.model.B.j.l8, d)), d.Ig = e.model.B.j.ey, d.Oc = c.caption, d.type = k.i.Qa.jb, d.qr = c.A, d.Fz = !0, this.rk(d));
                }
                mx(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  var l = d ? d : new b.bB(c.uniqueName);
                  return super.mx(c, l, e.v(d) || g);
                }
              }
              b.qpa = a;
            })(f.O || (f.O = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.WW {
                rH(c) {
                  var d = super.rH(c);
                  c != k.i.rb.NONE && (d.km = [k.i.Vb.Nj, k.i.Vb.ni]);
                  return d;
                }
              }
              b.opa = a;
            })(f.O || (f.O = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                constructor() {
                  this.ny = 20;
                  this.Qpa = RegExp("<Tuple>(.|\n|\r)*?</Tuple>", "gi");
                  this.Opa = RegExp("<Cell (.|\n|\r)*?</Cell>", "gi");
                  this.Ppa = RegExp("<row>(.|\n|\r)*?</row>", "g");
                  this.m9 = RegExp("<soap:Fault(.|\n|\r)*?</soap:Fault>", "gi");
                  this.l9 = RegExp("<SOAP-ENV:Fault(.|\n|\r)*?</SOAP-ENV:Fault>", "gi");
                  this.ja = k.Ma.R();
                  this.V5 = !0;
                  this.HB = !1;
                  this.Bl = () => this.Ws();
                  this.Lj = () => this.oq();
                  this.Vca = () => this.IFa();
                  this.Yz = c => this.nq(c);
                  this.bb = () => this.Sb();
                }
                load(c, d, g) {
                  this.fa = c;
                  this.pk = d;
                  this.Jb = g;
                  this.HB = !1;
                  this.jx();
                }
                bd(c, d, g, l, m, n) {
                  this.fa = c;
                  this.pk = d;
                  this.Jb = n;
                  this.HB = !0;
                  this.jx();
                }
                jx() {
                  e.Da(!0, e.model.B.j.jg, e.P.bind(e.model.B.j.yt, "0.5"));
                  this.Vh();
                  this.yD();
                  b.kg.Ab = this.fa;
                  this.oa.data = z.ba.Kc(b.kg.uw(this.pk.body));
                  this.oa.load(this.fa.rf);
                  this.timer = new u.Et(500, 1E5);
                  this.timer.N(u.vf.Gl, this.Bl);
                  this.timer.N(u.vf.Hl, this.Lj);
                  this.timer.start();
                }
                SL() {
                  e.v(this.fa.withCredentials) || (this.oa.withCredentials = this.fa.withCredentials);
                }
                Vh() {
                  this.oa = new z.jk();
                  this.oa.nha = 100;
                  this.oa.contentType = z.JA.eQ;
                  this.oa.dataType = z.KA.ba;
                  this.oa.Br = z.Ft.Dv;
                  const c = JSON.parse(JSON.stringify(e.v(this.fa.uc) ? {} : this.fa.uc));
                  this.V5 && (c.Accept = "application/xml");
                  this.SL();
                  this.fa.credentials && this.fa.credentials.Qm && (c.Authorization = "Basic " + this.fa.credentials.hash, this.oa.withCredentials = !0);
                  this.oa.Vh(c);
                }
                Ws() {
                  null != this.timer && e.Da(!0, e.model.B.j.jg, e.P.bind(e.model.B.j.yt, u.cc.format(this.timer.yw / 2, new e.model.ac.W.af(), !1, !1, 1)));
                }
                oq() {
                  this.timer.wl && e.Wa("Can't connect to data source!", e.model.B.j.xa);
                }
                wg() {
                  this.timer && this.timer.wl && (this.timer.stop(), this.timer.pb(u.vf.Gl, this.Bl), this.timer.pb(u.vf.Hl, this.Lj));
                }
                yD() {
                  this.oa.N(v.ga.Qc, this.Vca);
                  this.oa.N(v.ga.te, this.Yz);
                  this.oa.N(v.ga.xa, this.bb);
                  this.$j = f.Mj.NONE;
                  this.ad = [];
                  this.Lb = [];
                  this.kC = [];
                  this.MC = [];
                  this.LC = [];
                  this.YG = [];
                  this.lZ = "";
                  this.eR = 0;
                  this.Ka = [];
                  this.rows = [];
                  this.Ca = [];
                  this.yc = this.ja.O.yc();
                  this.Sf = this.ja.pa.Ar;
                  this.VY = this.jG = !1;
                  this.hE = this.gE = -1;
                  this.Hc = [];
                }
                IFa() {
                  var c = z.ba.Kc(z.ba.create(this.oa.response));
                  this.VY = !0;
                  this.ysa(c);
                }
                nq(c) {
                  c = c.data;
                  c.loaded !== this.tk && (this.wg(), this.tk = c.loaded, this.r5(c.loaded));
                }
                ysa(c) {
                  this.Ud(c);
                  !this.jG && this.$j > f.Mj.NONE && this.NKa();
                }
                Ud(c) {
                  if (0 != c.length && this.eR != c.length) {
                    var d = this.lZ + c.substring(this.eR);
                    if (this.$j === f.Mj.NONE) {
                      if (this.fa.Ba == k.i.qa.Cc) {
                        if (this.m9.test(d)) {
                          this.VHa(d.match(this.m9)[0]);
                          this.ur();
                          return;
                        }
                      } else if (this.fa.Ba == k.i.qa.Md && this.l9.test(d)) {
                        this.WHa(d.match(this.l9)[0]);
                        this.ur();
                        return;
                      }
                      var g = this.KW(d);
                      -1 < g && (d = d.substr(g));
                    }
                    this.$j == f.Mj.mX && (g = this.KW(d), 0 > g && (g = d.lastIndexOf("</row>") + 6), 5 != g && (this.tLa(d.substring(0, g), this.MC), d = d.substr(g)));
                    this.$j == f.Mj.dX && (g = this.KW(d), 0 > g && (g = d.lastIndexOf("</Tuple>") + 8), 7 != g && (this.Gja(d.substring(0, g), this.ad), d = d.substr(g)));
                    this.$j == f.Mj.hY && (g = this.KW(d), 0 > g && (g = d.lastIndexOf("</Tuple>") + 8), 7 != g && (this.Gja(d.substring(0, g), this.Lb), d = d.substr(g)));
                    this.$j == f.Mj.mY && (g = d.indexOf("<CellData>"), -1 < g && (this.$j = f.Mj.bJ, d = d.substr(g)));
                    this.$j == f.Mj.bJ && (g = d.indexOf("</CellData>"), 0 > g && (g = d.lastIndexOf("</Cell>") + 7), 6 != g && (this.rLa(d.substring(0, g), this.kC), d = d.substr(g)));
                    this.eR = c.length;
                    this.lZ = d;
                  }
                }
                WHa(c) {
                  c = c.replace(/SOAP-ENV:Fault/gi, "Fault");
                  c = c.replace(/XA:error/gi, "error");
                  c = z.ba.create(c);
                  null != c.find("faultstring") && (c = c.find("faultstring").text(), e.Wa(c, e.model.B.j.xa, e.tb.xa));
                }
                VHa(c) {
                  c = c.replace(/soap:Fault/gi, "Fault");
                  c = z.ba.create(c);
                  null != c.find("faultstring") && (c = c.find("faultstring").text(), e.Wa(c, e.model.B.j.xa, e.tb.xa));
                }
                KW(c) {
                  var d = -1;
                  if (this.HB && this.$j < f.Mj.mX) {
                    d = c.indexOf("<row>");
                    this.$j = f.Mj.mX;
                    if (-1 < d) return d;
                    e.Wa("No data received from the server.", e.model.B.j.xa);
                  }
                  if (this.$j < f.Mj.dX && (d = c.indexOf('<Axis name="Axis0">'), -1 < d)) return this.$j = f.Mj.dX, d;
                  if (this.$j < f.Mj.hY && (d = c.indexOf('<Axis name="Axis1">'), -1 < d)) return this.$j = f.Mj.hY, d;
                  if (this.$j < f.Mj.mY && (d = c.indexOf('<Axis name="SlicerAxis">'), -1 < d)) return this.$j = f.Mj.mY, d;
                  this.$j < f.Mj.bJ && (d = c.indexOf("<CellData>"), -1 < d && (this.$j = f.Mj.bJ));
                  return d;
                }
                tLa(c, d) {
                  c = c.match(this.Ppa);
                  for (var g = 0; g < c.length; g++) {
                    var l = c[g].replace(/xsi:/g, "");
                    l = l.replace(/xsd:/g, "");
                    d.push(z.ba.create(l));
                  }
                }
                Gja(c, d) {
                  c = c.match(this.Qpa);
                  if (!e.v(d) && !e.v(c)) for (var g = 0; g < c.length; g++) {
                    var l = c[g].replace(/xsi:/g, "");
                    d.push(z.ba.create(l));
                  }
                }
                rLa(c, d) {
                  c = c.match(this.Opa);
                  if (!e.v(c) && !e.v(d)) for (var g = 0; g < c.length; g++) e.v(c[g]) || e.ia(c[g]) || d.push(c[g]);
                }
                NKa() {
                  this.jG = !0;
                  u.Il.po({
                    bp: () => this.parse(),
                    ff: () => this.ur()
                  });
                }
                parse() {
                  0 < this.ad.length && this.vV();
                  0 < this.Lb.length && this.yV();
                  this.$j == f.Mj.bJ && (0 == this.Ka.length && (this.Ka = [[[0, 0]]]), 0 == this.rows.length && (this.rows = [[]]));
                  0 < this.kC.length && this.LHa();
                  0 < this.MC.length && this.RHa();
                  return this.VY && 0 == this.ad.length && 0 == this.Lb.length && 0 == this.kC.length && 0 == this.MC.length;
                }
                LHa() {
                  for (var c, d, g, l, m, n = this.ny > this.kC.length ? this.kC.length : this.ny, p = this.kC.splice(0, n), t = e.model.C.F.Rn && this.fa.Ba === k.i.qa.Cc, r = 0; r < n; r++) c = p[r], g = null === c.match(/<Value.*>(.*)<\/Value>/) ? 0 : parseFloat(c.match(/<Value.*>(.*)<\/Value>/)[1]), t && (l = c.match(/<FmtValue.*>(.*)<\/FmtValue>/), l = null != l && 1 < l.length ? l[1] : ""), d = parseInt(c.match(/CellOrdinal="(.*)"/)[1]), c = this.kD(d), d = this.aD(d), m = this.Ca[d], c == this.hE && this.Ka[this.gE].toString() == this.Ka[d].toString() || -1 == this.hE || -1 == this.gE || (this.ja.ta.$T(this.rows[this.hE], this.Ka[this.gE], this.Hc, this.pk.gg, this.pk.iw, this.pk.type), this.Hc = []), this.Hc[m] = t && this.Sf[m].aa == k.i.da.NONE ? k.zt.R().kA(l, g) : g, this.hE = c, this.gE = d;
                  -1 != this.hE && -1 != this.gE && this.ja.ta.$T(this.rows[this.hE], this.Ka[this.gE], this.Hc, this.pk.gg, this.pk.iw, this.pk.type);
                }
                RHa() {
                  for (var c, d, g = this.ny > this.MC.length ? this.MC.length : this.ny; 0 < g;) {
                    c = this.MC.shift();
                    d = [];
                    for (var l = 0; l < c.getChildren().length; l++) this.THa(c.getChildren()[l], d, l);
                    this.LC.push(d);
                    g--;
                  }
                }
                THa(c, d, g) {
                  d[c.localName] = c.text();
                  0 > this.YG.indexOf(c.localName) && this.YG.splice(g, 0, c.localName);
                }
                rIa() {
                  for (var c = [], d = 0; d < this.YG.length; d++) c[this.YG[d]] = d;
                  for (d = 0; d < this.LC.length; d++) {
                    var g = this.LC[d],
                      l = [],
                      m;
                    for (m in g) l[c[m]] = g[m];
                    this.LC[d] = l;
                  }
                  c = this.YG.map(n => this.SHa(n));
                  this.LC.unshift(c);
                }
                SHa(c) {
                  c = c.replace(/_x005B_/g, "[");
                  c = c.replace(/_x005D_/g, "]");
                  c = c.replace(/_x0020_/g, " ");
                  c = c.replace(/_x0024_/g, "");
                  var d = this.yc.getItem(c);
                  if (null != d) return d.caption;
                  d = this.Sf.find(g => g.A === c);
                  if (null != d) return d.caption;
                  d = c.split("].[");
                  1 < d.length && (c = d[d.length - 1].substr(0, d[d.length - 1].length - 1));
                  return c;
                }
                aD(c) {
                  return c % this.Ka.length;
                }
                kD(c) {
                  return Math.floor(c / this.Ka.length);
                }
                yV() {
                  for (var c, d, g = this.ny > this.Lb.length ? this.Lb.length : this.ny; 0 < g;) {
                    this.rowIndex = 0;
                    d = [];
                    c = this.Lb.shift();
                    var l = c.find("Member");
                    for (c = 0; c < l.length; c++) this.kIa(l[c], d);
                    this.rows.push(d);
                    g--;
                  }
                }
                kIa(c, d) {
                  var g = c.find("HIERARCHY_UNIQUE_NAME").text();
                  g = this.yc.getItem(g);
                  null != g && (c = this.Ib(c, g), d.push([c.level.yb, c.ordinal]), this.rowIndex++);
                }
                vV() {
                  for (var c, d, g = this.ny > this.ad.length ? this.ad.length : this.ny; 0 < g;) {
                    this.sva = 0;
                    c = [];
                    d = this.ad.shift();
                    d = d.find("Member");
                    for (var l = 0; l < d.length; l++) this.NHa(d[l], c);
                    this.Ka.push(c);
                    g--;
                  }
                }
                NHa(c, d) {
                  var g = c.find("HIERARCHY_UNIQUE_NAME").text();
                  if ("Measures" != g && "[Measures]" != g) {
                    var l = this.yc.getItem(g);
                    null == l && (l = this.yc.getItem("[" + g + "]"));
                    null != l && (c = this.Ib(c, l), d.push([c.level.yb, c.ordinal]), this.sva++);
                  } else {
                    var m = c.find("UName").text();
                    d = this.Sf.findIndex(n => n.A === m);
                    this.Ca.push(d);
                  }
                }
                Ib(c, d) {
                  var g = c.find("UName").text(),
                    l = d.Ib(g);
                  if (e.v(l)) {
                    var m = c.find("Caption").text();
                    -1 < m.indexOf("(Total") && (d.Rh ? g = g.substring(0, g.lastIndexOf(".[(")) : (g = g.substring(0, g.lastIndexOf(".[(")) + ".[(All)]", null == d.Ib(g) && (g = g.substring(0, g.length - 8))), l = d.Ib(g));
                  }
                  e.v(l) && (m = c.find("Caption").text(), c = c.find("PARENT_UNIQUE_NAME").text(), l = d.oc(new k.O.ae({
                    A: g,
                    caption: m,
                    zf: !0,
                    Hi: c
                  })));
                  return l;
                }
                r5(c) {
                  c = u.cc.Vg(c);
                  e.Da(!0, e.model.B.j.jg, e.P.bind(e.model.B.j.om, c));
                }
                ur() {
                  e.Da(!1);
                  this.Jb && (this.HB ? (this.rIa(), this.Jb(this.LC)) : this.Jb());
                  this.clear();
                }
                Sb() {}
                clear() {
                  this.oa && (this.oa.pb(v.ga.Qc, this.Vca), this.oa.pb(v.ga.te, this.Yz), this.oa.pb(v.ga.xa, this.bb), this.oa.close(), this.oa = null);
                  this.timer && this.timer.wl && this.timer.stop();
                  this.$j = 0;
                  this.ad = [];
                  this.Lb = [];
                  this.kC = [];
                  this.MC = [];
                  this.LC = [];
                  this.YG = [];
                  this.eR = 0;
                  this.lZ = "";
                  this.Ka = [];
                  this.rows = [];
                  this.Ca = [];
                  this.Sf = this.yc = null;
                  this.VY = this.jG = !1;
                  this.hE = this.gE = -1;
                  this.Hc = [];
                }
                cancel() {
                  this.clear();
                  this.Jb = null;
                }
              }
              b.Q9 = a;
            })(f.jj || (f.jj = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                constructor(c) {
                  this.bm = this.ql = this.gI = 0;
                  this.ar = 5E3;
                  this.fga = 1E3;
                  this.state = k.rp.pF;
                  this.sd = "";
                  this.bv = !1;
                  this.Ffa = "";
                  this.Eba = () => this.iFa();
                  this.Hba = () => this.kFa();
                  this.Tfa = () => this.Fj();
                  this.Yz = d => this.nq(d);
                  this.Wha = () => this.gHa();
                  this.Xha = d => this.hHa(d);
                  this.Uha = () => this.cHa();
                  this.Fba = d => this.jFa(d);
                  this.Ai = d => this.Sb(d);
                  b.kg.Ab = this.fa = c;
                }
                Om() {
                  this.oa = new z.jk();
                  this.oa.contentType = z.JA.eQ;
                  this.oa.dataType = z.KA.ba;
                  this.oa.Br = z.Ft.Dv;
                  this.SL();
                  const c = JSON.parse(JSON.stringify(e.v(this.fa.uc) ? {} : this.fa.uc));
                  this.fa.credentials && this.fa.credentials.Qm && (c.Authorization = "Basic " + this.fa.credentials.hash, this.oa.withCredentials = !0);
                  this.oa.Vh(c);
                }
                SL() {
                  e.v(this.fa.withCredentials) || (this.oa.withCredentials = this.fa.withCredentials);
                }
                SH() {
                  return e.ia(this.hierarchy.xf) ? this.hierarchy.Vm < this.fga : this.hierarchy.Vm < 10 * this.fga;
                }
                yo() {
                  return e.ia(this.fa.Ze) ? "[" + this.fa.va + "]" : "(" + this.fa.Ze + ")";
                }
                twa(c, d) {
                  this.vwa = c;
                  this.bb = d;
                  c = this.yo();
                  c = e.P.bind("with member [Measures].[CountAllMembers] as Count({0}.allmembers) select NON EMPTY {[Measures].[CountAllMembers]} ON columns FROM {1}", this.hierarchy.A, c);
                  this.Om();
                  this.oa.data = z.ba.Kc(b.kg.uw(c));
                  this.oa.N(v.ga.Qc, this.Eba);
                  this.oa.N(v.ga.xa, this.Ai);
                  this.oa.load(this.fa.rf);
                }
                iFa() {
                  var c = z.ba.create(this.oa.response);
                  this.uA(c) && (this.hierarchy.Vm = parseInt(c.find("root CellData Cell Value").text()));
                  this.vwa();
                }
                uA(c) {
                  return 0 == c.length ? (e.Wa(e.model.B.j.qF, "", e.tb.xa), e.Da(!1), !1) : 0 < c.find("root Fault").length ? (e.Wa(z.ba.Kc(c.find("root Fault faultstring")), "Query error!", e.tb.xa), !1) : !0;
                }
                load(c, d, g) {
                  this.sd = "";
                  this.qE && (this.qE.length = 0);
                  this.bm = this.ql = this.gI = 0;
                  this.Jb = d;
                  this.bb = g;
                  this.Zb = c;
                  this.SH() ? this.ol() : this.count();
                }
                count() {
                  var c = this.yo();
                  c = null == this.Zb ? e.P.bind("with member [Measures].[CountMembers] as Count({0}.levels(1).allmembers) select  NON EMPTY {[Measures].[CountMembers]} ON columns FROM {1}", this.hierarchy.A, c) : e.P.bind("with member [Measures].[CountMembers] as Count({0}.children) select NON EMPTY {[Measures].[CountMembers]} ON columns FROM {1}", this.Zb.A, c);
                  this.Om();
                  this.oa.data = z.ba.Kc(b.kg.uw(c));
                  this.oa.N(v.ga.Qc, this.Hba);
                  this.oa.N(v.ga.xa, this.Ai);
                  this.oa.load(this.fa.rf);
                }
                kFa() {
                  var c = z.ba.create(this.oa.response);
                  this.uA(c) && (this.gI = parseInt(c.find("root CellData Cell Value").text()), this.ol());
                }
                xC() {
                  return "";
                }
                J_() {
                  return "";
                }
                ol() {
                  var c = this.J_();
                  this.state = k.rp.pF;
                  this.Om();
                  this.oa.data = z.ba.Kc(b.kg.uw(c));
                  this.oa.N(v.ga.Qc, this.Tfa);
                  this.oa.N(v.ga.te, this.Yz);
                  this.oa.N(v.ga.xa, this.Ai);
                  this.oa.load(this.fa.rf);
                }
                Fj() {
                  this.bm += this.oa.Ui;
                  var c = z.ba.create(this.oa.response);
                  this.oa.close();
                  this.oa = null;
                  this.uA(c) && this.eE(c);
                  this.ql += this.ar;
                  this.ql < this.gI && !this.SH() ? this.ol() : this.ZU();
                }
                eE(c) {
                  var d = c.find("root");
                  if (0 < d.find("Fault").length) e.Wa(z.ba.Kc(d.find("Fault faultstring")), "Query error!", e.tb.xa);else {
                    c = [];
                    d = d.find('Axes Axis[name="Axis0"] Tuples Tuple Member');
                    for (var g = this.hierarchy.Wi, l = 0; l < d.length; l++) c.push(this.wV(d[l], l + g));
                    return c;
                  }
                }
                wV() {
                  return null;
                }
                ZU() {
                  e.Da(!1);
                  this.Jb(this.hierarchy);
                }
                nq(c) {
                  c = u.cc.Vg(c.data.loaded + this.bm);
                  e.Da(!0, e.model.B.j.ao, this.hierarchy.caption + ", " + e.P.bind(e.model.B.j.om, c));
                }
                Sb(c) {
                  e.Wa(c.message, "Error", e.tb.xa);
                  null != this.bb && (this.bb(c.message), this.bb = null);
                }
                l_(c, d, g, l, m) {
                  this.Jb = l;
                  this.bb = m;
                  this.bv = g;
                  this.hierarchy = c;
                  this.state = k.rp.l6;
                  c = [];
                  for (g = 0; g < d.length; g++) c.push(e.P.bind("Ascendants({0})", d[g]));
                  d = "{" + c.join(", ") + "}";
                  this.bm = 0;
                  this.Om();
                  c = this.yo();
                  d = e.P.bind("SELECT Hierarchize(Distinct({0})) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", d, c);
                  this.oa.data = z.ba.Kc(b.kg.uw(d));
                  this.oa.N(v.ga.Qc, () => this.o3());
                  this.oa.N(v.ga.te, this.Yz);
                  this.oa.N(v.ga.xa, this.Ai);
                  this.oa.load(this.fa.rf);
                }
                o3() {
                  this.bm += this.oa.Ui;
                  var c = z.ba.create(this.oa.response);
                  this.oa.close();
                  this.oa = null;
                  if (this.uA(c)) {
                    c = this.eE(c);
                    for (var d = 0; d < c.length; d++) this.hierarchy.za(c[d]).zf = !0;
                    this.bv ? this.t5(c, this.bb) : this.hierarchy.tw();
                  }
                  this.bv || this.Jb(this.hierarchy);
                }
                Bw(c, d, g, l, m) {
                  this.Jb = l;
                  this.bb = m;
                  this.hierarchy = c;
                  this.Ffa = g;
                  this.state = k.rp.Cla;
                  this.bm = 0;
                  this.Om();
                  c = this.yo();
                  d = e.P.bind("SELECT Hierarchize(Distinct(Descendants({0}, {1}, SELF_AND_BEFORE))) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {2}", d.A, g, c);
                  this.oa.data = z.ba.Kc(b.kg.uw(d));
                  this.oa.N(v.ga.Qc, () => this.wFa());
                  this.oa.N(v.ga.te, this.Yz);
                  this.oa.N(v.ga.xa, this.Ai);
                  this.oa.load(this.fa.rf);
                }
                wFa() {
                  this.bm += this.oa.Ui;
                  var c = z.ba.create(this.oa.response);
                  this.oa.close();
                  this.oa = null;
                  if (this.uA(c)) {
                    c = this.eE(c);
                    for (var d = 0; d < c.length; d++) {
                      var g = this.hierarchy.za(c[d]);
                      g.level.A == this.Ffa ? g.zf = !0 : this.hierarchy.fz(g);
                    }
                  }
                  this.Jb(this.hierarchy);
                }
                t5(c, d) {
                  this.bb = d;
                  d = [];
                  for (var g = 0; g < c.length; g++) d.push(e.P.bind("{0}.Siblings", this.hierarchy.za(c[g]).A));
                  c = "{" + d.join(", ") + "}";
                  this.state = k.rp.v9;
                  this.bm = 0;
                  this.Om();
                  d = this.yo();
                  c = e.P.bind("SELECT Hierarchize(Distinct({0})) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", c, d);
                  this.oa.data = z.ba.Kc(b.kg.uw(c));
                  this.oa.N(v.ga.Qc, () => this.j4());
                  this.oa.N(v.ga.te, this.Yz);
                  this.oa.N(v.ga.xa, this.Ai);
                  this.oa.load(this.fa.rf);
                }
                j4() {
                  this.bm += this.oa.Ui;
                  var c = z.ba.create(this.oa.response);
                  this.oa.close();
                  this.oa = null;
                  this.bv = !1;
                  if (this.uA(c)) {
                    c = this.eE(c);
                    for (var d = 0; d < c.length; d++) this.hierarchy.za(c[d]).zf = !0;
                    this.hierarchy.tw();
                  }
                  this.Jb(this.hierarchy);
                }
                search(c, d, g) {
                  this.sd = c.toLowerCase().replace(RegExp('"', "g"), '""').replace(RegExp("'", "g"), "''");
                  this.Jb = d;
                  this.bb = g;
                  this.bm = this.ql = this.gI = 0;
                  this.state = k.rp.iY;
                  this.qE && 0 < this.qE.length ? this.qE.length = 0 : this.qE = [];
                  this.ywa();
                }
                M_() {
                  var c = e.P.bind("SET [SearchMembersSet] AS 'FILTER(EXCEPT({0}.allmembers, {1}), (INSTR(1, {0}.CurrentMember.member_caption, {2}) > 0))'", this.hierarchy.A, this.hierarchy.Am, '"' + this.sd + '"');
                  var d = e.P.bind("SET [SearchParentsSet] AS 'EXCEPT(GENERATE([SearchMembersSet], ASCENDANTS([SearchMembersSet].Current)), {0})'", this.hierarchy.Am);
                  return c + "\n" + d + "\nSET [SearchSet] AS 'HIERARCHIZE(DISTINCT({[SearchMembersSet], [SearchParentsSet]}))'";
                }
                ywa() {
                  var c = this.yo(),
                    d = "MEMBER [Measures].[CountSearchSet] AS 'COUNT([SearchSet])'\nSELECT NON EMPTY {[Measures].[CountSearchSet]} ON COLUMNS FROM {0}";
                  d = "WITH " + this.M_() + "\n" + e.P.bind(d, c);
                  this.Om();
                  this.oa.data = z.ba.Kc(b.kg.uw(d));
                  this.oa.N(v.ga.Qc, this.Uha);
                  this.oa.N(v.ga.te, this.Fba);
                  this.oa.N(v.ga.xa, this.Ai);
                  this.oa.load(this.fa.rf);
                }
                cHa() {
                  var c = z.ba.create(this.oa.response);
                  this.uA(c) && (this.gI = parseInt(c.find("root CellData Cell Value").text()), this.uq());
                }
                jFa(c) {
                  e.Da(!0, "Counting members...", this.hierarchy.caption + ", " + Math.round(c.data.loaded / 1E3) + "K loaded");
                }
                uq() {
                  var c = this.yo(),
                    d = "SELECT SUBSET([SearchSet], {0}, {1}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME ON COLUMNS FROM {2}";
                  d = "WITH " + this.M_() + "\n" + e.P.bind(d, this.ql, this.ar, c);
                  this.Om();
                  this.oa.data = z.ba.Kc(b.kg.uw(d));
                  this.oa.N(v.ga.Qc, this.Wha);
                  this.oa.N(v.ga.te, this.Xha);
                  this.oa.N(v.ga.xa, this.Ai);
                  this.oa.load(this.fa.rf);
                }
                hHa(c) {
                  c = u.cc.Vg(c.data.loaded + this.bm);
                  e.Da(!0, e.model.B.j.ao, this.hierarchy.caption + ", " + e.P.bind(e.model.B.j.om, c));
                }
                gHa() {
                  this.bm += this.oa.Ui;
                  var c = z.ba.create(this.oa.response);
                  this.oa.close();
                  this.oa = null;
                  this.uA(c) && this.mIa(c);
                  this.ql += this.ar;
                  this.ql < this.gI ? this.uq() : this.$D();
                }
                mIa(c) {
                  c = c.find("root");
                  if (0 < c.find("Fault").length) e.Wa(z.ba.Kc(c.find("Fault faultstring")), "Query error!", e.tb.xa);else {
                    c = c.find('Axes Axis[name="Axis0"] Tuples Tuple Member');
                    for (var d = 0; d < c.length; d++) this.lIa(c[d]);
                  }
                }
                lIa(c) {
                  var d = c.find("PARENT_UNIQUE_NAME").text();
                  var g = c.find("Caption").text(),
                    l = c.find("UName").text(),
                    m = parseInt(c.find("MEMBER_ORDINAL").text()),
                    n = this.hierarchy.Ib(l);
                  if (null == n && (n = this.hierarchy.oc(new k.O.ae({
                    A: l,
                    caption: g,
                    fc: m,
                    Hi: d
                  })), n.level && 0 < n.level.We.length)) for (g = 0; g < n.level.We.length; g++) d = n.level.We.ea(g), n.setProperty(d.A, c.find(d.rO).text());
                  n.parent && !n.parent.dc && (n.parent.zf = !0);
                  this.qE.push(n.ordinal);
                }
                $D() {
                  e.Da(!1);
                  this.Jb(this.qE);
                }
                cancel() {
                  this.oa && (this.oa.pb(v.ga.Qc, this.Eba), this.oa.pb(v.ga.Qc, this.Hba), this.oa.pb(v.ga.Qc, this.Tfa), this.oa.pb(v.ga.te, this.Yz), this.oa.pb(v.ga.Qc, this.Wha), this.oa.pb(v.ga.te, this.Xha), this.oa.pb(v.ga.Qc, this.Uha), this.oa.pb(v.ga.te, this.Fba), this.oa.pb(v.ga.xa, this.Ai), this.oa.close());
                  this.bb = this.oa = null;
                }
              }
              b.R9 = a;
            })(f.jj || (f.jj = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                constructor(c) {
                  this.va = k.Ma.R();
                  this.V5 = !0;
                  this.oca = () => this.aV();
                  this.pca = d => this.xFa(d);
                  this.hEa = () => this.uGa();
                  this.jEa = d => this.wGa(d);
                  this.Ai = d => this.Sb(d);
                  this.zea = () => this.F3();
                  this.Aea = d => this.YFa(d);
                  this.Hfa = () => this.N3();
                  this.Ifa = d => this.hGa(d);
                  this.oha = () => this.QGa();
                  this.pha = d => this.SGa(d);
                  this.$fa = () => this.T3();
                  this.aga = d => this.yGa(d);
                  this.n8 = () => this.J3();
                  this.o8 = d => this.dGa(d);
                  this.fa = c;
                  this.Tl = new z.jk();
                  this.QD = new z.jk();
                  this.Zp = new z.jk();
                  this.fq = new z.jk();
                  this.aq = new z.jk();
                  this.eq = new z.jk();
                  this.rq = new z.jk();
                }
                Vp(c) {
                  return c.find("row");
                }
                load(c, d, g, l) {
                  this.Mb = d;
                  this.bb = g;
                  this.Pe = l;
                  this.V2(this.s3);
                }
                Om(c) {
                  this.SL(c);
                  this.Vh(c);
                }
                SL(c) {
                  e.v(this.fa.withCredentials) || (c.withCredentials = this.fa.withCredentials);
                }
                Vh(c) {
                  c.contentType = z.JA.eQ;
                  c.dataType = z.KA.ba;
                  c.Br = z.Ft.Dv;
                  const d = JSON.parse(JSON.stringify(e.v(this.fa.uc) ? {} : this.fa.uc));
                  this.V5 && (d.Accept = "application/xml");
                  this.fa.credentials && this.fa.credentials.Qm && (d.Authorization = "Basic " + this.fa.credentials.hash, c.withCredentials = !0);
                  c.Vh(d);
                  return c;
                }
                Sb(c) {
                  this.Tl.Td(v.ga.xa);
                  this.Tl.Td(v.ga.Qc);
                  this.Tl.Td(v.ga.te);
                  c = c.target.url.trim();
                  c = e.model.B.j.Foa.replace("{0}", '<u><a href="' + c + '">' + c + "</a></u>");
                  e.Wa(c, "", e.tb.xa);
                  this.bb(c);
                }
                et() {
                  null != this.Pe && (this.Pe(), this.Pe = null);
                }
                V2(c) {
                  e.Da(!0, e.model.B.j.KJ);
                  this.UG = c;
                  this.Om(this.Tl);
                  b.kg.Ab = this.fa;
                  this.Tl.data = z.ba.Kc(b.kg.Gva());
                  this.Tl.N(v.ga.Qc, this.oca);
                  this.Tl.N(v.ga.te, this.pca);
                  this.Tl.N(v.ga.xa, this.Ai);
                  this.Tl.load(this.fa.rf);
                }
                xFa(c) {
                  c = u.cc.Vg(c.data.loaded);
                  e.Da(!0, e.model.B.j.KJ, e.P.bind(e.model.B.j.om, c));
                }
                aV() {
                  this.et();
                  var c = z.ba.create(this.Tl.response);
                  c = this.Vp(c);
                  if (0 < c.length) {
                    for (var d = 0; d < c.length; d++) this.Rga(c[d]);
                    this.UG();
                  } else e.Wa(e.model.B.j.qF, "", e.tb.xa), e.Da(!1);
                }
                Rga(c) {
                  var d = c.find("DIMENSION_UNIQUE_NAME").text(),
                    g = this.fa.mapping.La(d, "caption", c.find("DIMENSION_CAPTION").text());
                  c = parseInt(c.find("DIMENSION_TYPE").text());
                  d = new k.O.AA(d, g);
                  d.type = c;
                  this.va.O.cu(d);
                }
                s3() {
                  this.fa.Ba == k.i.qa.Cc ? this.PDa(this.vGa) : this.MU(this.iV);
                }
                PDa(c) {
                  e.Da(!0, e.model.B.j.KJ);
                  this.iEa = c;
                  this.Om(this.QD);
                  b.kg.Ab = this.fa;
                  this.QD.data = z.ba.Kc(b.kg.Vva());
                  this.QD.N(v.ga.Qc, this.hEa);
                  this.QD.N(v.ga.te, this.jEa);
                  this.QD.N(v.ga.xa, this.Ai);
                  this.QD.load(this.fa.rf);
                }
                wGa(c) {
                  c = u.cc.Vg(c.data.loaded);
                  e.Da(!0, e.model.B.j.KJ, e.P.bind(e.model.B.j.om, c));
                }
                uGa() {
                  this.et();
                  var c = z.ba.create(this.QD.response);
                  c = this.Vp(c);
                  for (var d = 0; d < c.length; d++) this.eIa(c[d]);
                  this.iEa();
                }
                eIa(c) {
                  var d = c.find("DIMENSION_UNIQUE_NAME").text(),
                    g = c.find("MEASUREGROUP_NAME").text();
                  c = c.find("DIMENSION_GRANULARITY").text();
                  d = this.va.O.Sp(d);
                  if (null != d) {
                    d.pD || (d.pD = []);
                    var l = d.pD;
                    l[g] = c;
                    d.pD = l;
                  }
                }
                vGa() {
                  this.MU(this.iV);
                }
                MU(c) {
                  e.Da(!0, e.model.B.j.UX);
                  this.OM = c;
                  this.Om(this.Zp);
                  this.Zp.data = z.ba.Kc(b.kg.vw());
                  this.Zp.N(v.ga.Qc, this.zea);
                  this.Zp.N(v.ga.te, this.Aea);
                  this.Zp.N(v.ga.xa, this.Ai);
                  this.Zp.load(this.fa.rf);
                }
                F3() {
                  var c = z.ba.create(this.Zp.response);
                  c = this.Vp(c);
                  if (0 == c.length) e.Wa(e.model.B.j.qF, "", e.tb.xa), e.Da(!1);else {
                    for (var d = 0; d < c.length; d++) this.ZHa(c[d]);
                    this.OM();
                  }
                }
                ZHa(c) {
                  var d = c.find("DIMENSION_UNIQUE_NAME").text(),
                    g = c.find("HIERARCHY_UNIQUE_NAME").text(),
                    l = this.fa.mapping.La(g, "caption", c.find("HIERARCHY_CAPTION").text()),
                    m = parseInt(c.find("DIMENSION_TYPE").text()),
                    n = c.find("HIERARCHY_DISPLAY_FOLDER").text(),
                    p = c.find("ALL_MEMBER").text(),
                    t = c.find("DEFAULT_MEMBER").text();
                  c = parseInt(c.find("STRUCTURE").text());
                  d = this.va.O.Sp(d);
                  null != d && (g = this.fa.Ba == k.i.qa.Cc ? new f.O.ZX(g, l) : new f.hq.O.S8(g, l), g.origin = 1, g.Oc = n, g.type = k.i.Fc.UC(m), g.Am = p, g.Bs = t, 1 == c && (g.XM = !0), 2 == c && (g.Ms = !0), d.wi(g));
                }
                YFa(c) {
                  c = u.cc.Vg(c.data.loaded);
                  e.Da(!0, e.model.B.j.UX, e.P.bind(e.model.B.j.om, c));
                }
                iV() {
                  this.iN(this.O3);
                }
                iN(c) {
                  e.Da(!0, e.model.B.j.VX);
                  this.gN = c;
                  this.Om(this.eq);
                  this.eq.data = z.ba.Kc(b.kg.Tva());
                  this.eq.N(v.ga.Qc, this.Hfa);
                  this.eq.N(v.ga.te, this.Ifa);
                  this.eq.N(v.ga.xa, this.Ai);
                  this.eq.load(this.fa.rf);
                }
                hGa(c) {
                  c = u.cc.Vg(c.data.loaded);
                  e.Da(!0, e.model.B.j.VX, e.P.bind(e.model.B.j.om, c));
                }
                N3() {
                  var c = z.ba.create(this.eq.response);
                  c = this.Vp(c);
                  if (0 == c.length) e.Wa(e.model.B.j.qF, "", e.tb.xa), e.Da(!1);else {
                    for (var d = 0; d < c.length; d++) this.Vga(c[d]);
                    this.gN();
                  }
                }
                O3() {
                  e.model.C.F.BI ? this.QDa(this.RGa) : this.OU(this.oV);
                }
                Vga(c) {
                  var d = c.find("DIMENSION_UNIQUE_NAME").text(),
                    g = c.find("HIERARCHY_UNIQUE_NAME").text(),
                    l = c.find("LEVEL_CAPTION").text(),
                    m = parseInt(c.find("LEVEL_TYPE").text()),
                    n = c.find("LEVEL_UNIQUE_NAME").text();
                  c = parseInt(c.find("LEVEL_NUMBER").text());
                  d = this.va.O.Sp(d);
                  null != d && (g = d.ph(g), null != g && (l = new k.O.qv(n, l, c), l.type = k.i.ib.UC(m), g.Mh(l), d.wi(g)));
                }
                QDa(c) {
                  e.Da(!0, e.model.B.j.J8);
                  this.GIa = c;
                  this.Om(this.rq);
                  this.rq.data = z.ba.Kc(b.kg.Yva());
                  this.rq.N(v.ga.Qc, this.oha);
                  this.rq.N(v.ga.te, this.pha);
                  this.rq.N(v.ga.xa, this.Ai);
                  this.rq.load(this.fa.rf);
                }
                SGa(c) {
                  c = u.cc.Vg(c.data.loaded);
                  e.Da(!0, e.model.B.j.J8, e.P.bind(e.model.B.j.om, c));
                }
                QGa() {
                  var c = z.ba.create(this.rq.response);
                  c = this.Vp(c);
                  if (0 != c.length) for (var d = 0; d < c.length; d++) this.s4(c[d]);
                  this.GIa();
                }
                s4() {}
                RGa() {
                  this.OU(this.oV);
                }
                OU(c) {
                  e.Da(!0, e.model.B.j.GP);
                  this.jN = c;
                  this.Om(this.fq);
                  this.fq.data = z.ba.Kc(b.kg.zo());
                  this.fq.N(v.ga.Qc, this.$fa);
                  this.fq.N(v.ga.te, this.aga);
                  this.fq.N(v.ga.xa, this.Ai);
                  this.fq.load(this.fa.rf);
                }
                yGa(c) {
                  c = u.cc.Vg(c.data.loaded);
                  e.Da(!0, e.model.B.j.GP, e.P.bind(e.model.B.j.om, c));
                }
                T3() {
                  var c = z.ba.create(this.fq.response);
                  c = this.Vp(c);
                  if (0 == c.length) e.Wa(e.model.B.j.qF, "", e.tb.xa), e.Da(!1);else {
                    for (var d = 0; d < c.length; d++) this.fIa(c[d]);
                    this.jN();
                  }
                }
                fIa(c) {
                  var d = c.find("MEASURE_UNIQUE_NAME").text(),
                    g = this.fa.mapping.La(d, "caption", c.find("MEASURE_CAPTION").text()),
                    l = c.find("MEASUREGROUP_NAME").text();
                  c = c.find("MEASURE_DISPLAY_FOLDER").text() || "";
                  g = new f.O.bB(d, g);
                  g.type = 1;
                  g.Ig = l;
                  g.Oc = c;
                  g.Wc = this.fa.mapping.La(d, "aggregations");
                  this.va.O.rk(g);
                }
                oV() {
                  this.NU(this.K3);
                }
                NU(c) {
                  e.Da(!0, e.model.B.j.I8);
                  this.$M = c;
                  this.Om(this.aq);
                  this.aq.data = z.ba.Kc(b.kg.Pva());
                  this.aq.N(v.ga.Qc, this.n8);
                  this.aq.N(v.ga.te, this.o8);
                  this.aq.N(v.ga.xa, this.Ai);
                  this.aq.load(this.fa.rf);
                }
                dGa(c) {
                  c = u.cc.Vg(c.data.loaded);
                  e.Da(!0, e.model.B.j.GP, e.P.bind(e.model.B.j.om, c));
                }
                J3() {
                  var c = z.ba.create(this.aq.response);
                  c = this.Vp(c);
                  if (0 != c.length) for (var d = 0; d < c.length; d++) this.aIa(c[d]);
                  this.$M();
                }
                aIa(c) {
                  var d = c.find("KPI_NAME").text(),
                    g = this.fa.mapping.La(d, "caption", c.find("KPI_CAPTION").text()),
                    l = c.find("KPI_VALUE").text(),
                    m = c.find("KPI_STATUS").text(),
                    n = c.find("KPI_GOAL").text();
                  c = c.find("KPI_TREND").text();
                  d = new f.O.W8(d, g);
                  d.value = l;
                  d.status = m;
                  d.Uw = n;
                  d.Mx = c;
                  this.va.O.WZ(d, this.fa.mapping);
                }
                K3() {
                  e.Da(!1);
                  null != this.Mb && this.Mb();
                }
                ol(c, d, g) {
                  e.Da(!0, e.model.B.j.ao, c.caption);
                  this.Mb = d;
                  this.bb = g;
                  this.cm.hierarchy = c;
                  this.cm.twa(() => {
                    this.Ik(c, null, l => this.Zj(l), g);
                  }, this.bb);
                }
                Zj(c) {
                  var d = c.kv;
                  if (0 < c.filter.tl.length) this.hN(c, c.filter.tl, c.filter.oI, l => this.Zj(l), this.bb);else if (0 < d.length) {
                    var g = d.shift();
                    c.kv = d;
                    d = c.Ib(g[1]);
                    c.fz(d);
                    null != g[0] && "" != g[0] ? this.Lz(d, g[0], l => this.Zj(l), this.bb) : this.Ik(c, d, l => this.Zj(l), this.bb);
                  } else this.Mb(c);
                }
                Ik(c, d, g, l) {
                  e.Da(!0, e.model.B.j.ao, c.caption);
                  this.cm.hierarchy = c;
                  this.cm.load(d, g, l);
                }
                hN(c, d, g, l, m) {
                  this.cm.hierarchy = c;
                  this.cm.l_(c, d, g, l, m);
                }
                Lz(c, d, g, l) {
                  this.cm.hierarchy = c.hierarchy;
                  this.cm.Bw(c.hierarchy, c, d, g, l);
                }
                uq(c, d, g, l) {
                  this.cm.hierarchy = c;
                  this.cm.search(d, g, l);
                }
                iC() {
                  return !0;
                }
                cancel() {
                  this.Tl && (this.Tl.pb(v.ga.Qc, this.oca), this.Tl.pb(v.ga.te, this.pca), this.Tl.pb(v.ga.xa, this.Ai), this.Tl.close(), this.Tl = null);
                  this.Zp && (this.Zp.pb(v.ga.Qc, this.zea), this.Zp.pb(v.ga.te, this.Aea), this.Zp.pb(v.ga.xa, this.Ai), this.Zp.close(), this.Zp = null);
                  this.eq && (this.eq.pb(v.ga.Qc, this.Hfa), this.eq.pb(v.ga.te, this.Ifa), this.eq.pb(v.ga.xa, this.Ai), this.eq.close(), this.eq = null);
                  this.rq && (this.rq.pb(v.ga.Qc, this.oha), this.rq.pb(v.ga.te, this.pha), this.rq.pb(v.ga.xa, this.Ai), this.rq.close(), this.rq = null);
                  this.fq && (this.fq.pb(v.ga.Qc, this.$fa), this.fq.pb(v.ga.te, this.aga), this.fq.pb(v.ga.xa, this.Ai), this.fq.close(), this.fq = null);
                  this.aq && (this.aq.pb(v.ga.Qc, this.n8), this.aq.pb(v.ga.te, this.o8), this.aq.pb(v.ga.xa, this.Ai), this.aq.close(), this.aq = null);
                  this.cm && (this.cm.cancel(), this.cm = null);
                  this.Pe = this.bb = this.Mb = null;
                }
              }
              b.S9 = a;
            })(f.jj || (f.jj = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                static uw(c) {
                  var d = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    g = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    l = z.ba.create("<AxisFormat/>").text("TupleFormat"),
                    m = z.ba.create("<Content/>").text("Data"),
                    n = z.ba.create("<Format/>").text("Multidimensional");
                  d = a.xs([d, g, l, m, n]);
                  c = z.ba.create('<Execute xmlns="urn:schemas-microsoft-com:xml-analysis"><Command><Statement><![CDATA[' + c + "]]\x3e</Statement></Command>" + z.ba.Kc(d) + "</Execute>");
                  return a.Qp(c);
                }
                static Cva() {
                  return a.Qp(a.ws(z.ba.create("<RequestType/>").text("DISCOVER_DATASOURCES"), z.ba.create("<Restrictions/>"), z.ba.create("<Properties/>")));
                }
                static awa() {
                  var c = z.ba.create("<Content/>").text("Data"),
                    d = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai);
                  c = a.xs([c, d]);
                  return a.Qp(a.ws(z.ba.create("<RequestType/>").text("DISCOVER_PROPERTIES"), z.ba.create("<Restrictions/>").append(z.ba.create("<RestrictionList/>").append(z.ba.create("<PropertyName/>").text("DBMSVersion"))), c));
                }
                static wva() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d]);
                  d = z.ba.create("<RequestType/>").text("DBSCHEMA_CATALOGS");
                  var g = z.ba.create("<Restrictions/>");
                  return a.Qp(a.ws(d, g, c));
                }
                static Bva() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    g = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d, g]);
                  d = z.ba.create("<CATALOG_NAME/>").text(this.Ab.ze);
                  d = a.Ty([d]);
                  g = z.ba.create("<RequestType/>").text("MDSCHEMA_CUBES");
                  return a.Qp(a.ws(g, d, c));
                }
                static Gva() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    g = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d, g]);
                  d = z.ba.create("<CATALOG_NAME/>").text(this.Ab.ze);
                  g = z.ba.create("<CUBE_NAME/>").text(this.Ab.va);
                  d = a.Ty([d, g]);
                  g = z.ba.create("<RequestType/>").text("MDSCHEMA_DIMENSIONS");
                  return a.Qp(a.ws(g, d, c));
                }
                static Vva() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    g = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d, g]);
                  d = z.ba.create("<CATALOG_NAME/>").text(this.Ab.ze);
                  g = z.ba.create("<CUBE_NAME/>").text(this.Ab.va);
                  d = a.Ty([d, g]);
                  g = z.ba.create("<RequestType/>").text("MDSCHEMA_MEASUREGROUP_DIMENSIONS");
                  return a.Qp(a.ws(g, d, c));
                }
                static vw() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    g = z.ba.create("<Cube/>").text(this.Ab.va),
                    l = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d, g, l]);
                  d = z.ba.create("<CATALOG_NAME/>").text(this.Ab.ze);
                  g = z.ba.create("<CUBE_NAME/>").text(this.Ab.va);
                  d = a.Ty([d, g]);
                  g = z.ba.create("<RequestType/>").text("MDSCHEMA_HIERARCHIES");
                  return a.Qp(a.ws(g, d, c));
                }
                static Tva() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    g = z.ba.create("<Cube/>").text(this.Ab.va),
                    l = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d, g, l]);
                  d = z.ba.create("<CATALOG_NAME/>").text(this.Ab.ze);
                  g = z.ba.create("<CUBE_NAME/>").text(this.Ab.va);
                  d = a.Ty([d, g]);
                  g = z.ba.create("<RequestType/>").text("MDSCHEMA_LEVELS");
                  return a.Qp(a.ws(g, d, c));
                }
                static Yva() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    g = z.ba.create("<Cube/>").text(this.Ab.va),
                    l = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d, g, l]);
                  d = z.ba.create("<CATALOG_NAME/>").text(this.Ab.ze);
                  g = z.ba.create("<CUBE_NAME/>").text(this.Ab.va);
                  d = a.Ty([d, g]);
                  g = z.ba.create("<RequestType/>").text("MDSCHEMA_PROPERTIES");
                  return a.Qp(a.ws(g, d, c));
                }
                static Pva() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    g = z.ba.create("<Cube/>").text(this.Ab.va),
                    l = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d, g, l]);
                  d = z.ba.create("<CATALOG_NAME/>").text(this.Ab.ze);
                  g = z.ba.create("<CUBE_NAME/>").text(this.Ab.va);
                  d = a.Ty([d, g]);
                  g = z.ba.create("<RequestType/>").text("MDSCHEMA_KPIS");
                  return a.Qp(a.ws(g, d, c));
                }
                static zo() {
                  var c = z.ba.create("<DataSourceInfo/>").text(this.Ab.ai),
                    d = z.ba.create("<Catalog/>").text(this.Ab.ze),
                    g = z.ba.create("<Cube/>").text(this.Ab.va),
                    l = z.ba.create("<Format/>").text("Tabular");
                  c = a.xs([c, d, g, l]);
                  d = z.ba.create("<CATALOG_NAME/>").text(this.Ab.ze);
                  g = z.ba.create("<CUBE_NAME/>").text(this.Ab.va);
                  d = a.Ty([d, g]);
                  g = z.ba.create("<RequestType/>").text("MDSCHEMA_MEASURES");
                  return a.Qp(a.ws(g, d, c));
                }
                static Qp(c) {
                  var d = z.ba.create('<SOAP-ENV:Envelope xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/" SOAP-ENV:encodingStyle="http://schemas.xmlsoap.org/soap/encoding/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" flexmonster="true"><SOAP-ENV:Body></SOAP-ENV:Body></SOAP-ENV:Envelope>');
                  d.firstElementChild.appendChild(c);
                  return d;
                }
                static xs(c) {
                  var d = z.ba.create("<PropertyList/>").attr("flexmonster", "true"),
                    g = z.ba.create("<Properties/>");
                  if ("" != a.Ab.Pk) {
                    var l = z.ba.create("<Roles/>").text(a.Ab.Pk);
                    c.push(l);
                  }
                  "" != a.Ab.wj && (l = z.ba.create("<EffectiveUserName/>").text(a.Ab.wj), c.push(l));
                  "" != a.Ab.Dj && (l = z.ba.create("<LocaleIdentifier/>").text(a.Ab.Dj), c.push(l));
                  "" != a.Ab.Fm && (l = z.ba.create("<CustomData/>").text(a.Ab.Fm), c.push(l));
                  for (l = 0; l < c.length; l++) d.append(c[l]);
                  g.append(d);
                  return g;
                }
                static Ty(c) {
                  for (var d = z.ba.create("<RestrictionList/>"), g = z.ba.create("<Restrictions/>"), l = 0; l < c.length; l++) d.append(c[l]);
                  g.append(d);
                  return g;
                }
                static ws(c, d, g) {
                  return z.ba.create('<Discover xmlns="urn:schemas-microsoft-com:xml-analysis">' + z.ba.Kc(c) + z.ba.Kc(d) + z.ba.Kc(g) + "</Discover>");
                }
                static xva(c, d, g) {
                  var l = z.ba.create('<ClearCache xmlns="http://schemas.microsoft.com/analysisservices/2003/engine"/>'),
                    m = z.ba.create("<Object/>");
                  null != c && m.append(z.ba.create("<DatabaseID/>").text(c));
                  null != d && m.append(z.ba.create("<CubeID/>").text(d));
                  null != g && m.append(z.ba.create("<MeasureGroupID/>").text(g));
                  l.append(m);
                  return a.Qp(z.ba.create('<Execute xmlns="urn:schemas-microsoft-com:xml-analysis"/>').append(z.ba.create("<Command/>").append(l)).append(z.ba.create("<Properties/>")));
                }
              }
              b.kg = a;
            })(f.jj || (f.jj = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                constructor() {
                  this.EN = this.DV = "";
                  if (null != a.instance) throw Error("Singleton");
                }
                static R() {
                  null == a.instance && (a.instance = new a());
                  return a.instance;
                }
                static dispose() {
                  a.instance = null;
                }
                Vp(c) {
                  return c.find("row");
                }
                hW() {
                  this.oa = new z.jk();
                  this.oa.contentType = z.JA.eQ;
                  this.oa.Br = z.Ft.Dv;
                }
                oD(c, d) {
                  this.Jb = d;
                  this.EN != c ? this.Eda(c, () => function () {
                    d(this.DV);
                  }) : this.Jb && this.Jb(this.DV);
                  return this.DV;
                }
                Eda(c, d) {
                  this.Jb = d;
                  this.EN = c;
                  this.hW();
                  this.oa.data = z.ba.Kc(b.kg.Cva());
                  this.oa.N(v.ga.Qc, () => this.qFa());
                  this.oa.N(v.ga.xa, () => this.rFa());
                  this.oa.load(c);
                }
                qFa() {
                  if (!e.ia(this.oa.response)) {
                    var c = z.ba.create(this.oa.response);
                    c = this.Vp(c);
                    for (var d = [], g = 0; g < c.length; g++) {
                      var l = c[g].find("DataSourceName").text();
                      this.DV = c[g].find("ProviderName").text();
                      d.push(l);
                    }
                    this.Jb && this.Jb(d);
                  }
                }
                rFa() {
                  const c = e.model.Tb.valid(this.EN) ? this.EN : e.model.Tb.validate(this.EN);
                  e.Wa("Error opening URL <u>" + c + "</u><br/>Please check your Internet connection.<br/><br/><u><a href='https://www.flexmonster.com/doc/typical-errors/#url-error' target='_blank'>Read more info about this error</a></u>", e.model.B.j.xa, e.tb.xa);
                  this.Jb && this.Jb([]);
                }
                Sza(c, d, g) {
                  this.Jb = g;
                  b.kg.Ab = new f.sp();
                  b.kg.Ab.ai = d;
                  this.hW();
                  this.oa.data = z.ba.Kc(b.kg.wva());
                  this.oa.N(v.ga.Qc, () => this.OEa());
                  this.oa.N(v.ga.xa, () => this.PEa());
                  this.oa.load(c);
                }
                OEa() {
                  var c = z.ba.create(this.oa.response);
                  c = this.Vp(c);
                  for (var d = [], g = 0; g < c.length; g++) {
                    var l = c[g].find("CATALOG_NAME").text();
                    d.push(l);
                  }
                  this.Jb && this.Jb(d);
                }
                PEa() {
                  e.Wa("Error discovering catalogs", e.model.B.j.xa, e.tb.xa);
                  this.Jb && this.Jb([]);
                }
                iAa(c, d, g, l) {
                  this.Jb = l;
                  b.kg.Ab = new f.sp();
                  b.kg.Ab.ai = d;
                  b.kg.Ab.ze = g;
                  this.hW();
                  this.oa.data = z.ba.Kc(b.kg.Bva());
                  this.oa.N(v.ga.Qc, () => this.lFa());
                  this.oa.N(v.ga.xa, () => this.mFa());
                  this.oa.load(c);
                }
                lFa() {
                  var c = z.ba.create(this.oa.response);
                  c = this.Vp(c);
                  for (var d = [], g = 0; g < c.length; g++) {
                    var l = c[g].find("CUBE_NAME").text();
                    d.push(l);
                  }
                  this.Jb && this.Jb(d);
                }
                mFa() {
                  e.Wa("Error discovering cubes", e.model.B.j.xa, e.tb.xa);
                  this.Jb && this.Jb([]);
                }
                SR(c, d, g, l, m) {
                  this.hW();
                  this.oa.data = z.ba.Kc(b.kg.xva(d, g, l));
                  this.oa.N(v.ga.Qc, () => this.VEa(m));
                  this.oa.N(v.ga.xa, () => this.WEa(m));
                  this.oa.load(c);
                }
                VEa(c) {
                  null != c && c({
                    complete: !0,
                    response: this.oa.response
                  });
                }
                WEa(c) {
                  null != c && c({
                    complete: !1
                  });
                }
              }
              b.O9 = a;
            })(f.jj || (f.jj = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  this.vZ = this.LK = this.TF = "";
                  null == d ? this.TF = c : (this.LK = c, this.vZ = d);
                }
                set hash(c) {}
                get hash() {
                  return 0 < this.TF.length ? this.TF : u.ska.encode(this.LK + ":" + this.vZ);
                }
                set Qm(c) {}
                get Qm() {
                  return this.TF && 0 < this.TF.length || this.LK && 0 < this.LK.length;
                }
                static zb(c) {
                  var d = new a("");
                  c.hasOwnProperty("hash") && (d.TF = c.hash ? c.hash : "");
                  c.hasOwnProperty("username") && (d.LK = c.username ? c.username : "");
                  c.hasOwnProperty("password") && (d.vZ = c.password ? c.password : "");
                  return d;
                }
              }
              b.P9 = a;
            })(f.jj || (f.jj = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                gm(c) {
                  if (e.model.Xa.R().S1(e.model.Xa.dK)) {
                    const d = new e.model.hd(e.model.Xa.dK, g => {
                      if (!e.v(g) && !e.v(g.requestHeaders)) {
                        const l = this.ka.uc || {};
                        for (let m in g.requestHeaders) g.requestHeaders.hasOwnProperty(m) && (l[m] = g.requestHeaders[m]);
                        this.ka.uc = l;
                        this.sf.uc = l;
                      }
                      c(!0);
                    });
                    e.model.Xa.R().Ea(d);
                  } else c(!1);
                }
              }
              b.RW = a;
            })(f.Ap || (f.Ap = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends b.RW {
                constructor(c) {
                  super();
                  this.va = k.Ma.R();
                  this.ka = c;
                  this.oa = new b.kka(c);
                }
                load(c, d, g, l) {
                  this.ka = c;
                  this.Mb = d;
                  this.Pe = l;
                  this.bb = g;
                  this.sf = new b.VP(this.ka.rf, e.model.Ha.ra.J(e.model.Ha.ra.EV), !0, this.ka.uc, this.ka.withCredentials);
                  this.rea = () => this.cO();
                  this.NBa();
                }
                NBa() {
                  e.Da(!0, e.model.B.j.rF);
                  null != this.sf && this.sf.call("Handshaking", {
                    componentVersion: e.kh.Nr,
                    acceleratorMinVersion: a.Pja
                  }, () => this.rea(), c => this.Sb(c), c => this.gm(c));
                }
                cO() {
                  null != this.Pe && (this.Pe(), this.Pe = null);
                  this.UG = () => this.s3();
                  this.V2();
                }
                V2() {
                  null != this.sf && (e.Da(!0, e.model.B.j.KJ), this.sf.call("DiscoverDimensions", {
                    catalog: this.ka.ze,
                    cubeUniqueName: this.ka.va,
                    credentials: this.ka.credentials && this.ka.credentials.Qm ? this.ka.credentials.hash : null,
                    customData: this.ka.Fm,
                    localeIdentifier: this.ka.Dj,
                    effectiveUserName: this.ka.wj,
                    roles: this.ka.Pk
                  }, (c, d) => this.aV(c, d), c => this.Sb(c), c => this.gm(c)));
                }
                aV(c, d) {
                  if (null != this.UG) {
                    null != d && 0 < d.sessionId && (f.sp.sessionId = d.sessionId);
                    for (d = 0; d < c.length; d++) {
                      var g = c[d];
                      var l = g.uniqueName;
                      var m = this.ka.mapping.La(l, "caption", g.caption),
                        n = g.type;
                      l = new f.O.npa(l, m);
                      l.type = n;
                      l.pD = g.granularityNames;
                      l.description = g.description;
                      this.va.O.cu(l);
                    }
                    this.UG();
                  }
                }
                s3() {
                  this.OM = () => this.iV();
                  this.MU();
                }
                MU() {
                  null != this.sf && (e.Da(!0, e.model.B.j.UX), this.sf.call("DiscoverHierarchies", {
                    catalog: this.ka.ze,
                    cubeUniqueName: this.ka.va,
                    credentials: this.ka.credentials && this.ka.credentials.Qm ? this.ka.credentials.hash : null,
                    sessionId: f.sp.sessionId,
                    customData: this.ka.Fm,
                    localeIdentifier: this.ka.Dj,
                    effectiveUserName: this.ka.wj,
                    roles: this.ka.Pk
                  }, c => this.F3(c), c => this.Sb(c), c => this.gm(c)));
                }
                F3(c) {
                  if (null != this.OM) {
                    for (var d = 0; d < c.length; d++) {
                      var g = c[d],
                        l = g.dimensionUniqueName,
                        m = g.uniqueName,
                        n = this.ka.mapping.La(m, "caption", g.caption),
                        p = g.type,
                        t = g.allMemberName,
                        r = g.defaultMemberName,
                        w = g.displayFolder || "",
                        y = g.isParentChild || !1,
                        A = g.isRagged || !1;
                      l = this.va.O.Sp(l);
                      null != l && (m = this.ka.Ba == k.i.qa.Cc ? new f.O.ZX(m, n) : new f.hq.O.S8(m, n), m.origin = 1, m.type = k.i.Fc.UC(p), m.Am = t, m.Bs = r, m.Oc = w, m.Ms = y, m.XM = A, m.description = g.description, l.wi(m));
                    }
                    this.OM();
                  }
                }
                iV() {
                  this.gN = () => this.O3();
                  this.iN();
                }
                iN() {
                  null != this.sf && (e.Da(!0, e.model.B.j.VX), this.sf.call("DiscoverLevels", {
                    catalog: this.ka.ze,
                    cubeUniqueName: this.ka.va,
                    credentials: this.ka.credentials && this.ka.credentials.Qm ? this.ka.credentials.hash : null,
                    sessionId: f.sp.sessionId,
                    customData: this.ka.Fm,
                    localeIdentifier: this.ka.Dj,
                    effectiveUserName: this.ka.wj,
                    roles: this.ka.Pk
                  }, c => this.N3(c), c => this.Sb(c), c => this.gm(c)));
                }
                N3(c) {
                  if (null != this.gN) {
                    for (var d = 0; d < c.length; d++) {
                      var g = c[d],
                        l = g.hierarchyUniqueName,
                        m = g.caption,
                        n = g.type,
                        p = g.dbType,
                        t = g.uniqueName,
                        r = g.levelNumber,
                        w = g.properties,
                        y = this.va.O.Sp(g.dimensionUniqueName);
                      if (null != y && (l = y.ph(l), null != l && (m = new f.O.ppa(t, m, r), m.type = e.v(n) ? k.i.ib.$c : k.i.ib.UC(n, !e.v(p) && 0 == n, p), m.description = g.description, l.Mh(m), y.wi(l), e.model.C.F.BI && null != w && 0 < w.length))) for (n = 0; n < w.length; n++) g = e.v(w[n].item) ? w[n] : w[n].item, g = new k.O.XW(g[0], g[1]), m.$Z(g);
                    }
                    this.gN();
                  }
                }
                O3() {
                  this.jN = () => this.oV();
                  this.OU();
                }
                OU() {
                  null != this.sf && (e.Da(!0, e.model.B.j.GP), this.sf.call("DiscoverMeasures", {
                    catalog: this.ka.ze,
                    cubeUniqueName: this.ka.va,
                    credentials: this.ka.credentials && this.ka.credentials.Qm ? this.ka.credentials.hash : null,
                    sessionId: f.sp.sessionId,
                    customData: this.ka.Fm,
                    localeIdentifier: this.ka.Dj,
                    effectiveUserName: this.ka.wj,
                    roles: this.ka.Pk
                  }, c => this.T3(c), c => this.Sb(c), c => this.gm(c)));
                }
                T3(c) {
                  if (null != this.jN) {
                    for (var d, g = 0; g < c.length; g++) {
                      var l = c[g],
                        m = l.uniqueName;
                      d = this.ka.mapping.La(m, "caption", l.caption);
                      var n = "String" == typeof l.type ? k.i.Qa.gza(l.type) : k.i.Qa.jb,
                        p = l.groupCaption || l.groupName || "",
                        t = l.displayFolder || "";
                      d = new f.O.bB(m, d);
                      d.type = n;
                      d.Ig = p;
                      d.Oc = t;
                      d.Wc = this.ka.mapping.La(m, "aggregations");
                      d.description = l.description;
                      this.va.O.rk(d);
                    }
                    this.jN();
                  }
                }
                oV() {
                  this.ka.Ba == k.i.qa.Cc ? (this.$M = () => this.K3(), this.NU()) : this.wr();
                }
                NU() {
                  null != this.sf && (e.Da(!0, e.model.B.j.I8), this.sf.call("DiscoverKpis", {
                    catalog: this.ka.ze,
                    cubeUniqueName: this.ka.va,
                    credentials: this.ka.credentials && this.ka.credentials.Qm ? this.ka.credentials.hash : null,
                    sessionId: f.sp.sessionId,
                    customData: this.ka.Fm,
                    localeIdentifier: this.ka.Dj,
                    effectiveUserName: this.ka.wj,
                    roles: this.ka.Pk
                  }, c => this.J3(c), c => this.Sb(c), c => this.gm(c)));
                }
                J3(c) {
                  if (null != this.$M) {
                    for (var d = 0; d < c.length; d++) {
                      var g = c[d],
                        l = g.uniqueName,
                        m = this.ka.mapping.La(l, "caption", g.caption),
                        n = g.value,
                        p = g.status,
                        t = g.goal,
                        r = g.trend;
                      l = new f.O.W8(l, m);
                      l.value = n;
                      l.status = p;
                      l.Uw = t;
                      l.Mx = r;
                      l.description = g.description;
                      this.va.O.WZ(l, this.ka.mapping);
                    }
                    this.$M();
                  }
                }
                K3() {
                  this.wr();
                }
                ol(c, d) {
                  e.Da(!0, e.model.B.j.ao, c.caption);
                  this.Mb = d;
                  this.Ik(c, null, g => this.Zj(g));
                }
                Ik(c, d, g) {
                  this.oa.hierarchy = c;
                  this.oa.PC = this.va.pa.kf || this.va.pa.jf;
                  this.oa.ES = this.va.pa.gf || this.va.pa.Tf;
                  this.oa.children(c, d, g, this.bb);
                }
                Zj(c) {
                  if (null != this.Mb) {
                    var d = c.kv;
                    if (0 < c.filter.tl.length) c.Wi < c.Vm ? this.hN(c, c.filter.tl, c.filter.oI, l => this.Zj(l)) : (c.tw(), this.Zj(c));else if (0 < d.length) {
                      var g = d.shift();
                      0 == d.length && c.vba();
                      c.kv = d;
                      d = c.Ib(g[1]);
                      c.fz(d);
                      this.Ik(c, d, l => this.Zj(l));
                    } else c.Rd = !0, this.Mb(c);
                  }
                }
                hN(c, d, g, l) {
                  this.oa.hierarchy = c;
                  this.oa.PC = this.va.pa.kf || this.va.pa.jf;
                  this.oa.ES = this.va.pa.gf || this.va.pa.gf;
                  this.oa.l_(c, d, g, l);
                }
                Lz() {}
                uq(c, d, g) {
                  this.oa.hierarchy = c;
                  this.oa.PC = this.va.pa.kf || this.va.pa.jf;
                  this.oa.ES = this.va.pa.gf || this.va.pa.Tf;
                  this.oa.search(d, g);
                }
                iC() {
                  return !0;
                }
                cancel() {
                  this.$M = this.jN = this.gN = this.OM = this.UG = this.rea = null;
                  null != this.sf && this.sf.cancel();
                  this.sf = null;
                  null != this.cm && this.cm.cancel();
                  this.cm = null;
                  null != this.oa && this.oa.cancel();
                  this.Pe = this.bb = this.Mb = this.oa = null;
                }
                wr() {
                  e.Da(!1);
                  null != this.Mb && this.Mb();
                }
                Sb(c) {
                  e.Da(!1);
                  let d = null;
                  e.v(c) ? (d = `Cannot connect to ${e.model.Tb.valid(this.ka.rf) ? this.ka.rf : e.model.Tb.validate(this.ka.rf)}`, e.Wa(d, e.model.B.j.xa)) : (d = e.ia(c.message) ? e.model.B.j.HP : c.message, "Unknown error." == d ? e.Wa(e.model.B.j.Eoa, e.model.B.j.xa) : "ERROR_SESSION_EXPIRED" == d ? e.model.C.F.oW ? e.Wa(e.model.B.j.TX, e.model.B.j.cn, e.tb.cn, [e.model.B.j.VE, e.model.B.j.El], [() => this.Tz(), null]) : this.Tz() : -1 < d.indexOf("2.416") || -1 < d.indexOf("2.400") ? e.Wa("Your current version of Flexmonster Pivot Table & Charts is not compatible with Flexmonster Accelerator. Please update both products to the latest available version.", e.model.B.j.xa) : e.Wa(d, e.model.B.j.xa));
                  null != this.bb && this.bb(d);
                }
                Tz() {
                  e.model.Va.R().E4();
                }
              }
              a.Pja = "2.7.11";
              b.p6 = a;
            })(f.Ap || (f.Ap = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends b.RW {
                constructor(c) {
                  super();
                  this.qw = this.dI = 0;
                  this.sd = "";
                  this.state = k.rp.pF;
                  this.Bl = () => this.Ws();
                  this.Lj = () => this.oq();
                  this.lN = [];
                  this.Nz = [];
                  this.kN = 0;
                  this.ka = c;
                  this.sf = new b.VP(this.ka.rf, e.model.Ha.ra.J(e.model.Ha.ra.EV), !0, this.ka.uc, this.ka.withCredentials);
                }
                reset() {
                  this.sd = "";
                  this.qw = this.kN = this.dI = 0;
                  this.Nz = [];
                  this.bb = this.bv = this.HK = this.jK = this.Zb = this.E_ = this.Jb = null;
                  this.state = "";
                }
                search(c, d) {
                  this.reset();
                  this.state = k.rp.iY;
                  this.Jb = d;
                  this.sd = c.toLowerCase();
                  this.load(() => this.$D());
                }
                $D() {
                  for (var c = [], d = 0; d < this.Nz.length; d++) {
                    var g = this.Nz[d];
                    g.zf = !0;
                    c.push(g.ordinal);
                  }
                  e.Da(!1);
                  this.Jb(c);
                }
                children(c, d, g, l) {
                  this.reset();
                  this.state = k.rp.pF;
                  this.Jb = g;
                  this.bb = l;
                  this.Zb = d;
                  this.hierarchy = c;
                  null == this.Zb || this.Zb.zf ? this.load(() => this.Zj()) : g(this.hierarchy);
                }
                Zj() {
                  null != this.Zb && (this.Zb.zf = !1);
                  this.Jb(this.hierarchy);
                }
                l_(c, d, g, l) {
                  this.reset();
                  this.state = k.rp.l6;
                  this.Jb = l;
                  this.jK = d;
                  this.bv = g;
                  this.hierarchy = c;
                  this.load(() => this.o3());
                }
                o3() {
                  for (var c = [], d = 0; d < this.Nz.length; d++) {
                    var g = this.Nz[d];
                    g.zf = !0;
                    c.push(g.A);
                  }
                  this.bv ? this.t5(c, this.Jb) : (this.hierarchy.tw(), this.Jb(this.hierarchy));
                }
                t5(c, d) {
                  this.reset();
                  this.state = k.rp.v9;
                  this.Jb = d;
                  this.HK = c;
                  this.load(() => this.j4());
                }
                j4() {
                  for (var c = this.Nz, d = 0; d < c.length; d++) this.hierarchy.za(c[d]).zf = !0;
                  this.hierarchy.tw();
                  this.Jb(this.hierarchy);
                }
                load(c) {
                  this.E_ = c;
                  e.Da(!0, e.model.B.j.ao);
                  this.ol();
                  this.timer = new u.Et(500, 1E4);
                  this.timer.N(u.vf.Gl, this.Bl);
                  this.timer.N(u.vf.Hl, this.Lj);
                  this.timer.start();
                }
                xC() {
                  for (var c = this.hierarchy.LU, d = [], g = 0; g < c.length; g++) d.push(this.hierarchy.A + ".[" + c.ea(g).A + "]");
                  return 0 < d.length ? ", " + d.join(",") : "";
                }
                ol() {
                  if (null != this.sf) {
                    var c = this.xC(this.hierarchy);
                    this.sf.call("DiscoverMembers", {
                      catalog: this.ka.ze,
                      cubeUniqueName: this.ka.va,
                      subquery: this.ka.Ze,
                      hierarchyUniqueName: this.hierarchy.A,
                      properties: c,
                      memberUniqueName: this.Zb ? this.Zb.A : "",
                      allMemberName: this.hierarchy.Am,
                      hasAllMember: this.hierarchy.Rh,
                      loadAll: this.ES,
                      searchPhrase: this.sd,
                      chunkIndex: this.qw,
                      ascendants: null == this.jK ? "" : this.jK.join(",,"),
                      siblings: null == this.HK ? "" : this.HK.join(",,"),
                      activeLevel: null == this.hierarchy.xf ? "" : this.hierarchy.xf,
                      credentials: this.ka.credentials && this.ka.credentials.Qm ? this.ka.credentials.hash : null,
                      sessionId: f.sp.sessionId,
                      customData: this.ka.Fm,
                      localeIdentifier: this.ka.Dj,
                      effectiveUserName: this.ka.wj,
                      roles: this.ka.Pk
                    }, d => this.Fj(d), d => this.Sb(d), d => this.gm(d));
                    this.qw++;
                  }
                }
                Ws() {
                  if (null != this.timer) {
                    var c = this.timer.yw / 2;
                    2 < c && e.Da(!0, e.model.B.j.ao, e.P.bind(e.model.B.j.yt, u.cc.format(c, new e.model.ac.W.af(), !1, !1, 1)));
                  }
                }
                oq() {
                  this.timer.wl && e.Wa("Can't connect to data source!", e.model.B.j.xa);
                }
                wg() {
                  this.timer && this.timer.wl && (this.timer.stop(), this.timer.pb(u.vf.Gl, this.Bl), this.timer.pb(u.vf.Hl, this.Lj));
                }
                Fj(c) {
                  null != this.sf && (this.wg(), 1 == this.qw && (this.dI = c.count), 1 > this.hierarchy.Vm && (this.hierarchy.Vm = c.all), this.eE(c.members, () => this.iI()));
                }
                eE(c, d) {
                  if (e.v(c)) d();else if (this.lN = c, 0 == this.lN.length) this.ZU();else {
                    for (c = this.hierarchy.Wi; !this.gIa(c);) c++;
                    d();
                  }
                }
                gIa(c) {
                  var d = this.lN.shift();
                  if (null != d) {
                    var g = d.parentUniqueName,
                      l = d.caption,
                      m = d.uniqueName,
                      n = d.ordinal,
                      p = d.properties;
                    var t = this.hierarchy.Ib(m);
                    if (null == t && (d = new k.O.ae({
                      A: m,
                      caption: l,
                      Hi: g,
                      ordinal: n
                    }), "" === this.sd && null == this.jK && null == this.HK && (d.fc = c), t = this.hierarchy.oc(d), null != p && 0 < p.length)) for (g = 0; g < p.length; g++) d = e.v(p[g].item) ? p[g] : p[g].item, t.setProperty(d[0], d[1]);
                    "" != this.sd || null != this.jK || null != this.HK ? this.Nz.push(t) : t.fc = c;
                    null != t && !t.dc && 1E3 < this.hierarchy.Vm && !this.ES && (t.zf = !0);
                    this.kN++;
                  }
                  return 0 >= this.lN.length;
                }
                iI() {
                  var c = 0 == this.dI ? 100 : Math.round(this.kN / this.dI * 100);
                  100 < c && (c = 100);
                  e.Da(!0, e.model.B.j.ao, this.hierarchy.caption + " - " + c + "% (" + this.kN + " of " + this.dI + ")");
                  this.kN >= this.dI ? this.ZU() : this.ol();
                }
                ZU() {
                  e.Da(!1);
                  this.wg();
                  this.E_();
                  this.lN = [];
                  this.Nz = [];
                }
                Sb(c) {
                  this.wg();
                  e.Da(!1);
                  c = e.ia(c.message) ? e.model.B.j.HP : c.message;
                  "ERROR_SESSION_EXPIRED" == c ? e.model.C.F.oW ? e.Wa(e.model.B.j.TX, e.model.B.j.cn, e.tb.cn, [e.model.B.j.VE, e.model.B.j.El], [() => this.Tz(), null]) : this.Tz() : (e.Wa(c, e.model.B.j.xa), null != this.bb && (this.bb(c), this.bb = null));
                }
                Tz() {
                  e.model.Va.R().E4();
                }
                SH() {
                  return !1;
                }
                cancel() {
                  null != this.sf && this.sf.cancel();
                  this.sf = null;
                  null != this.timer && this.wg();
                  this.E_ = this.bb = this.Jb = this.timer = null;
                }
              }
              b.kka = a;
            })(f.Ap || (f.Ap = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends b.RW {
                constructor() {
                  super(...arguments);
                  this.df = k.Ma.R();
                  this.Lb = [];
                  this.ad = [];
                  this.Bl = () => this.Ws();
                  this.Lj = () => this.oq();
                }
                load(c, d, g) {
                  e.Da(!0, e.model.B.j.jg, e.P.bind(e.model.B.j.yt, "0.5"));
                  this.ka = c;
                  this.pk = d;
                  this.Jb = g;
                  this.Xi = this.qw = 0;
                  this.Sf = this.df.pa.Ar;
                  this.sf = new b.VP(this.ka.rf, e.model.Ha.ra.J(e.model.Ha.ra.EV), !0, this.ka.uc, this.ka.withCredentials);
                  this.requestId = e.P.eM();
                  this.jx();
                  this.timer = new u.Et(500, 1E4);
                  this.timer.N(u.vf.Gl, this.Bl);
                  this.timer.N(u.vf.Hl, this.Lj);
                  this.timer.start();
                }
                jx() {
                  if (null != this.sf) {
                    for (var c = [], d = this.df.pa.Ar, g = 0; g < d.length; g++) c.push(d[g].A);
                    this.sf.call("Execute", {
                      catalog: this.ka.ze,
                      cubeUniqueName: this.ka.va,
                      subquery: this.ka.Ze,
                      queryString: this.pk.body,
                      columns: this.df.pa.Db.Pc(!0),
                      rows: this.df.pa.xb.Pc(!0),
                      measures: c,
                      chunkIndex: this.qw,
                      credentials: this.ka.credentials && this.ka.credentials.Qm ? this.ka.credentials.hash : null,
                      sessionId: f.sp.sessionId,
                      customData: this.ka.Fm,
                      localeIdentifier: this.ka.Dj,
                      effectiveUserName: this.ka.wj,
                      roles: this.ka.Pk,
                      expandAll: this.pk.type == k.i.$d.ho && (this.df.pa.kf || this.df.pa.jf),
                      formatted: e.model.C.F.Rn,
                      requestId: this.requestId
                    }, l => this.kq(l), l => this.Sb(l), l => this.gm(l));
                    this.qw++;
                  }
                }
                Ws() {
                  null != this.timer && e.Da(!0, e.model.B.j.jg, e.P.bind(e.model.B.j.yt, u.cc.format(this.timer.yw / 2, new e.model.ac.W.af(), !1, !1, 1)));
                }
                oq() {
                  this.timer.wl && e.Wa("Can't connect to data source!", e.model.B.j.xa);
                }
                wg() {
                  this.timer && this.timer.wl && (this.timer.stop(), this.timer.pb(u.vf.Gl, this.Bl), this.timer.pb(u.vf.Hl, this.Lj));
                }
                bd(c, d, g, l, m, n) {
                  e.Da(!0, e.model.B.j.jg, e.P.bind(e.model.B.j.yt, "0.5"));
                  this.ka = c;
                  this.pk = d;
                  this.Jb = n;
                  this.Sf = this.df.pa.Ar;
                  this.sf = new b.VP(this.ka.rf, e.model.Ha.ra.J(e.model.Ha.ra.EV), !0, this.ka.uc, this.ka.withCredentials);
                  c = this.uAa(this.df.pa, g, l);
                  m = {
                    catalog: this.ka.ze,
                    cubeUniqueName: this.ka.va,
                    subquery: this.ka.Ze,
                    measureUniqueName: m.A,
                    members: c,
                    credentials: this.ka.credentials && this.ka.credentials.Qm ? this.ka.credentials.hash : null,
                    sessionId: f.sp.sessionId,
                    customData: this.ka.Fm,
                    localeIdentifier: this.ka.Dj,
                    effectiveUserName: this.ka.wj,
                    roles: this.ka.Pk
                  };
                  this.ka.Ba == k.i.qa.Cc && (m.drillThroughMaxRows = e.model.C.F.ZG);
                  this.sf.call("DrillThrough", m, p => this.yFa(p), p => this.Sb(p), p => this.gm(p));
                  this.timer = new u.Et(500, 1E4);
                  this.timer.N(u.vf.Gl, this.Bl);
                  this.timer.N(u.vf.Hl, this.Lj);
                  this.timer.start();
                }
                uAa(c, d, g) {
                  for (var l = [], m, n, p = 0; p < c.Db.length; p++) {
                    var t = c.Db.ea(p);
                    m = [];
                    n = !1;
                    if (!t.Ue) {
                      if (null != g[p]) {
                        var r = t.za(g[p]);
                        e.v(r) || e.ia(r.A) || (m.push(r.A), n = !0);
                      }
                      if (t.filter.Ei && !n) for (n = 0; n < t.cb.length; n++) r = t.za(t.cb[n]), e.v(r) || e.ia(r.A) || -1 == m.indexOf(r.A) && m.push(r.A);
                      0 < m.length && (this.ka.Ba == k.i.qa.Md ? l.push(m.join(",")) : l.push("{" + m.join(",") + "}"));
                    }
                  }
                  for (p = 0; p < c.xb.length; p++) if (t = c.xb.ea(p), n = !1, m = [], !t.Ue) {
                    null != d[p] && (r = t.za(d[p]), e.v(r) || e.ia(r.A) || (m.push(r.A), n = !0));
                    if (t.filter.Ei && !n) for (n = 0; n < t.cb.length; n++) r = t.za(t.cb[n]), e.v(r) || e.ia(r.A) || -1 == m.indexOf(r.A) && m.push(r.A);
                    0 < m.length && (this.ka.Ba == k.i.qa.Md ? l.push(m.join(",")) : l.push("{" + m.join(",") + "}"));
                  }
                  for (p = 0; p < c.ob.length; p++) {
                    t = c.ob.ea(p);
                    m = [];
                    if (t.filter.Ei) for (n = 0; n < t.cb.length; n++) r = t.za(t.cb[n]), e.v(r) || e.ia(r.A) || -1 == m.indexOf(r.A) && m.push(r.A);
                    0 < m.length && (this.ka.Ba == k.i.qa.Md ? l.push(m.join(",")) : l.push("{" + m.join(",") + "}"));
                  }
                  return l;
                }
                yFa(c) {
                  if (null != this.sf) {
                    c = c.cellData;
                    if (null != c && 0 < c.length && null != c[0].item) for (var d = 0; d < c.length; d++) c[d] = c[d].item;
                    this.wg();
                    e.Da(!1);
                    this.Jb(c);
                  }
                }
                cancel() {
                  this.ka = this.df = null;
                  this.Lb = [];
                  this.ad = [];
                  this.Jb = this.pk = null;
                  null != this.sf && this.sf.cancel();
                  this.sf = null;
                  this.wg();
                  this.timer = null;
                }
                kq(c) {
                  null != this.sf && (c.isComplete || this.jx(), this.wg(), this.ka.Ba == k.i.qa.Md ? (this.vV(c.columnsList ? JSON.parse(c.columnsList) : []), this.yV(c.rowsList ? JSON.parse(c.rowsList) : []), this.Pga(c.cellData ? JSON.parse(c.cellData) : [], c.cellDataFmt ? JSON.parse(c.cellDataFmt) : [])) : (this.vV(c.columnsList), this.yV(c.rowsList), this.Pga(c.cellData, c.cellDataFmt)), this.Xi += this.Lb.length * this.ad.length, c.isComplete ? (e.Da(!1), this.Jb()) : (c = null != c.percent ? Math.round(1E4 * c.percent) / 100 : NaN, e.Da(!0, e.model.B.j.jg, this.Xi + " items " + (isNaN(c) || 0 >= c ? "" : "(" + (100 < c ? 100 : c) + "%)"))));
                }
                vV(c) {
                  this.ad = c;
                  if (e.v(c) || 0 == this.ad.length) this.ad = [[[0, 0]]];
                }
                yV(c) {
                  this.Lb = [[]];
                  e.v(c) ? this.Lb = [[]] : (this.Lb = c, 0 == this.Lb.length && (this.Lb = [[]]));
                }
                FCa(c, d) {
                  if (c.length != d.length) return !1;
                  for (var g = 0; g < c.length; g++) if (1 < c[g].length && c[g][1] != d[g][1]) return !1;
                  return !0;
                }
                Pga(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  e.v(c) && (c = []);
                  var g = this.Lb.length,
                    l = this.ad.length;
                  var m = this.df.pa.Ar;
                  for (var n = [], p = 0; p < m.length; p++) n[p] = m[p].type;
                  var t = k.rY.R();
                  this.df.pa.rows.ea(1);
                  for (p = 0; p < g; p++) if (void 0 != c[p] && null != this.Lb[p]) {
                    m = [];
                    for (var r = [], w, y, A = !1, B = 0; B < l; B++) null != this.ad[B] && (w = r, r = this.ad[B].slice(0), y = r.pop()[0], this.FCa(r, w) || (A && this.df.ta.$T(this.Lb[p], w, m, this.pk.gg, this.pk.iw, this.pk.type), A = !1, m = []), void 0 != c[p][B] && (A = !0), e.model.C.F.Rn && null != d && this.Sf[y].aa == k.i.da.NONE ? m[y] = k.zt.R().kA(d[p][B], c[p][B]) : n[y] == k.i.Qa.jb ? m[y] = c[p][B] : n[y] == k.i.Qa.Ta && (w = c[p][B] ? t.li(c[p][B].toString()) : 0, m[y] = w));
                    A && this.df.ta.$T(this.Lb[p], r, m, this.pk.gg, this.pk.iw, this.pk.type);
                  }
                }
                Sb(c) {
                  this.wg();
                  e.Da(!1);
                  c = e.ia(c.message) ? e.model.B.j.HP : c.message;
                  "ERROR_SESSION_EXPIRED" == c ? e.model.C.F.oW ? e.Wa(e.model.B.j.TX, e.model.B.j.cn, e.tb.cn, [e.model.B.j.VE, e.model.B.j.El], [() => this.Tz(), null]) : this.Tz() : e.Wa(c, e.model.B.j.xa);
                }
                Tz() {
                  e.model.Va.R().E4();
                }
              }
              b.o6 = a;
            })(f.Ap || (f.Ap = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                  let l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  let m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
                  this.lv = null;
                  this.withCredentials = !1;
                  this.uc = null;
                  this.url = c;
                  this.url.lastIndexOf("/") == this.url.length - 1 && (this.url = this.url.substr(0, this.url.length - 1));
                  g && 0 > this.url.indexOf("/FlexmonsterProxy") && this.url.lastIndexOf(":") > this.url.lastIndexOf("/") && (this.url += "/FlexmonsterProxy");
                  this.uc = l;
                  this.lv = d;
                  this.withCredentials = m;
                }
                call(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  let l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  let m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                  this.action = c;
                  this.Mb = g;
                  this.bb = l;
                  this.lO = m;
                  this.Sd = d;
                  u.io.load("lib/sha1.min.js", () => {
                    this.xhr = new XMLHttpRequest();
                    this.xhr.open("POST", this.url + "/" + c, !0);
                    this.xhr.withCredentials = this.withCredentials;
                    this.xhr.onreadystatechange = n => this.gv(n);
                    this.xhr.setRequestHeader("Content-type", "application/json; charset=UTF-8");
                    this.xhr.setRequestHeader("Accept", "application/json");
                    this.dL(this.uc);
                    this.xhr.send(this.yKa(d));
                  });
                }
                dL(c) {
                  if (!e.v(c)) for (var d in c) c.hasOwnProperty(d) && this.xhr.setRequestHeader(d, c[d]);
                }
                yKa(c) {
                  if (null != this.lv) {
                    delete c.signature;
                    var d = this.getHash(c);
                    d = d.replace(/[^a-zA-Z0-9]/gm, "");
                    var g = new jsSHA("SHA-1", "TEXT");
                    g.setHMACKey(this.lv, "TEXT");
                    g.update(d);
                    c.signature = g.getHMAC("B64");
                  }
                  return JSON.stringify(c);
                }
                getHash(c) {
                  var d = [];
                  for (g in c) d.push(g);
                  d.sort();
                  var g = "";
                  for (var l = 0; l < d.length; l++) {
                    var m = c[d[l]];
                    e.v(m) || "string" == typeof m && e.ia(m) || Array.isArray(m) && 0 == m.length || ("sessionId" != d[l] || 0 != m) && "customData" != d[l] && "localeIdentifier" != d[l] && "effectiveUserName" != d[l] && (g += d[l] + ":" + m);
                  }
                  return g.toLowerCase();
                }
                gv() {
                  if (null != this.xhr && 4 === this.xhr.readyState) {
                    if (200 === this.xhr.status) return this.GI();
                    if (401 === this.xhr.status && e.Kg(this.lO)) return this.lO(c => {
                      c ? this.call(this.action, this.Sd, this.Mb, this.bb) : this.bb({
                        message: this.xhr.statusText
                      });
                    });
                    this.bb({
                      message: this.xhr.statusText
                    });
                  }
                }
                GI() {
                  var c = JSON.parse(this.xhr.response);
                  c && null == c.error ? null != this.Mb && this.Mb(c.data, c) : this.bb && c && this.bb(c.error);
                }
                cancel() {
                  null != this.xhr && (this.xhr.onerror = null, this.xhr.onreadystatechange = null, this.xhr.abort());
                  this.lv = this.url = this.Mb = this.xhr = this.uc = null;
                }
              }
              b.VP = a;
            })(f.Ap || (f.Ap = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends f.jj.R9 {
                constructor(c) {
                  super(c);
                }
                xC() {
                  for (var c = this.hierarchy.LU, d = [], g = 0; g < c.length; g++) d.push(this.hierarchy.A + ".[" + c.ea(g).A + "]");
                  return 0 < d.length ? ", " + d.join(",") : "";
                }
                J_() {
                  var c = this.xC(this.hierarchy),
                    d = this.yo();
                  return null == this.Zb ? this.SH() ? e.P.bind("SELECT DISTINCT({{0}.allmembers}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME{1} on columns FROM {2}", this.hierarchy.A, c, d) : this.hierarchy.Rh ? e.P.bind("SELECT Subset(DISTINCT({{0}.levels(0).allmembers, {0}.levels(1).allmembers}), {3}, {4}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME{2} on 0 FROM {1}", this.hierarchy.A, d, c, this.ql.toString(), this.ar.toString()) : e.P.bind("SELECT Subset(DISTINCT({{0}.levels(0).allmembers}), {3}, {4}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME{2} on 0 FROM {1}", this.hierarchy.A, d, c, this.ql.toString(), this.ar.toString()) : e.P.bind("SELECT Subset({0}.children, {3}, {4}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME {2} on columns FROM {1}", this.Zb.A, d, c, this.ql.toString(), this.ar.toString(), this.hierarchy.A);
                }
                wV(c, d) {
                  var g = c.find("PARENT_UNIQUE_NAME").text();
                  var l = c.find("Caption").text(),
                    m = c.find("UName").text(),
                    n = parseInt(c.find("MEMBER_ORDINAL").text());
                  var p = this.hierarchy.Ib(m);
                  if (null == p) {
                    p = this.hierarchy.oc(new k.O.ae({
                      A: m,
                      caption: l,
                      Hi: g
                    }));
                    if (p.level && 0 < p.level.We.length) for (l = 0; l < p.level.We.length; l++) {
                      g = p.level.We.ea(l);
                      p.setProperty(g.A, c.find(g.rO).text());
                      m = c.getChildren();
                      for (var t = 0; t < m.length; t++) {
                        var r = m[t];
                        r.nodeName.toLowerCase() == g.rO.toLowerCase() && (r = r.text(), p.setProperty(g.A, r));
                      }
                    }
                    p.fc = isNaN(n) ? d : n;
                  } else this.state == k.rp.pF && (p.fc = isNaN(n) ? d : n);
                  null == p || p.dc || (p.zf = !0);
                  p.parent && !p.parent.dc && (p.parent.zf = !1);
                  return p.ordinal;
                }
              }
              b.jqa = a;
            })(f.GE || (f.GE = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends f.jj.S9 {
                constructor(c) {
                  super(c);
                  this.cm = new b.jqa(c);
                }
                aV() {
                  var c = z.ba.create(this.Tl.response);
                  c = this.Vp(c);
                  if (0 < c.length) {
                    this.et();
                    for (var d = 0; d < c.length; d++) this.Rga(c[d]);
                    this.VDa();
                    this.UG();
                  } else c = e.model.B.j.qF, e.Wa(c, "", e.tb.xa), e.Da(!1), this.bb(c);
                }
                VDa() {
                  this.OE = new z.jk();
                  this.OE = this.Vh(this.OE);
                  this.OE.data = z.ba.Kc(f.jj.kg.awa());
                  this.OE.N(v.ga.Qc, () => this.zHa());
                  this.OE.N(v.ga.xa, c => this.Sb(c));
                  this.OE.load(this.fa.rf);
                }
                zHa() {
                  var c = z.ba.create(this.OE.response);
                  c = this.Vp(c);
                  this.fa.version = parseFloat(c.find("Value").text().substr(0, 5));
                }
                Vga(c) {
                  var d = c.find("DIMENSION_UNIQUE_NAME").text(),
                    g = c.find("HIERARCHY_UNIQUE_NAME").text(),
                    l = c.find("LEVEL_CAPTION").text(),
                    m = c.find("LEVEL_UNIQUE_NAME").text(),
                    n = parseInt(c.find("LEVEL_NUMBER").text());
                  c = parseInt(c.find("LEVEL_TYPE").text());
                  d = this.va.O.Sp(d);
                  null != d && (g = d.ph(g), null != g && (l = new k.O.qv(m, l, n), l.type = k.i.ib.UC(c), g.Mh(l), d.wi(g)));
                }
                s4(c) {
                  var d = c.find("DIMENSION_UNIQUE_NAME").text(),
                    g = c.find("HIERARCHY_UNIQUE_NAME").text(),
                    l = c.find("LEVEL_UNIQUE_NAME").text(),
                    m = c.find("PROPERTY_CAPTION").text();
                  c.find("PROPERTY_TYPE").text();
                  c = c.find("PROPERTY_NAME").text();
                  var n = (g + ".[" + c + "]").replace(/\[/g, "_x005B_").replace(/\]/g, "_x005D_").replace(/\s/g, "_x0020_");
                  "NAME" != c && "KEY0" != c && "KEY1" != c && "KEY2" != c && "TRAN0" != c && "TRAN1" != c && "TRAN2" != c && "MEMBER_VALUE" != c && "CUSTOM_ROLLUP" != c && "UNARY_OPERATOR" != c && (d = this.va.O.Sp(d), null != d && (g = d.ph(g), null != g && (l = g.Cu(l), null != l && (m = new k.O.XW(c, m, n), l.$Z(m)))));
                }
              }
              b.kqa = a;
            })(f.GE || (f.GE = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                constructor(c, d) {
                  this.slice = c;
                  this.fa = d;
                }
                get ME() {
                  return this.fa && this.fa.Cm && !e.model.C.F.f2 ? !0 : !1;
                }
                eT(c) {
                  return c.Ms ? "members" : "allmembers";
                }
                dT(c) {
                  return c.Rh ? c.Am : e.P.bind("{0}.levels(0).{1}", c.A, this.eT(c));
                }
                PT() {
                  return 0 < this.slice.rd(k.i.ha.Ra).kd.length;
                }
                QT() {
                  return 0 < this.slice.rd(k.i.ha.Ia).kd.length;
                }
                zo() {
                  const c = [],
                    d = this.slice.Ar;
                  for (var g = 0; g < d.length; g++) c.push(d[g].A);
                  return "{" + c.join(", ") + "}";
                }
                vC() {
                  var c = this.zo();
                  if (0 < this.slice.Db.length) {
                    var d = this.rL(this.slice.Db),
                      g = "";
                    this.PT() && (g = this.Sy(this.slice.rd(k.i.ha.Ra).kd, this.slice.Db));
                    return "Crossjoin(" + (0 < g.length ? "Union(" + d + ", " + g + ")" : d) + ", " + c + ")";
                  }
                  return c;
                }
                yC() {
                  if (0 < this.slice.xb.length) {
                    var c = this.rL(this.slice.xb),
                      d = "";
                    this.QT() && (d = this.Sy(this.slice.rd(k.i.ha.Ia).kd, this.slice.xb));
                    return 0 < d.length ? "Union(" + c + ", " + d + ")" : c;
                  }
                  return "";
                }
                rL(c) {
                  for (var d = [], g = 0; g < c.length; g++) {
                    var l = c.ea(g);
                    l = this.I_(l, this.slice.kf || this.slice.jf || 0 == g, this.slice.gf || this.slice.Tf);
                    0 < l.length && d.push(l);
                  }
                  if (1 < d.length) {
                    c = this.zo();
                    l = d[0];
                    for (g = 1; g < d.length; g++) l = e.model.C.F.f2 ? e.P.bind("Crossjoin({0}, {1})", l, d[g]) : e.P.bind("NonEmpty(Crossjoin({0}, {1}), {2})", l, d[g], c);
                    return l;
                  }
                  return d[0];
                }
                I_(c, d, g) {
                  var l = this.dT(c);
                  if (g) d = "Hierarchize({" + c.A + "." + this.eT(c) + "})";else if (d) for (d = null != c.lc ? "Hierarchize({Descendants({" + c.A + ".levels(0)." + this.eT(c) + "}, " + c.lc.A + ", SELF_AND_BEFORE)})" : c.Rh ? "Hierarchize({DrilldownLevel({" + l + "})})" : "{{" + c.zm() + "," + l + "}}", g = 1; g < c.wa.length; g++) l = c.wa.ea(g), l = c.OL(l), 0 != l.length && (l = c.nr(l).join(","), d = 10.5 < this.fa.version ? "DrilldownMember({{" + d + "}}, {" + l + "},,INCLUDE_CALC_MEMBERS)" : "DrilldownMember({{" + d + "}}, {" + l + "})");else {
                    if (c.Rh) return l;
                    d = "{{" + c.zm() + "," + l + "}}";
                  }
                  return d;
                }
                qW(c) {
                  return c = c.replace(/[\]|\[]/g, "");
                }
                Jp(c, d, g) {
                  for (var l = [], m, n = 0; n < d.length; n++) {
                    var p = d.ea(n);
                    if (n == c.length - 1) m = p.za(c[n]), m.dc ? (this.I_(p, !0, !1), l.push(this.I_(p, !0, !1))) : void 0 !== g && null != p.Cu(g) ? l.push("Descendants(" + m.A + ", " + g + ", SELF_AND_BEFORE)") : m.Yg ? l.push(m.A + ".CHILDREN") : l.push(m.A);else if (n < c.length) {
                      m = p.za(c[n]);
                      if (null == m) return "";
                      p = p.nr(m.children);
                      m = m.Zg ? "{" + p.join(",") + "}" : m.A;
                      l.push(m);
                    } else l.push(this.dT(p));
                  }
                  return 1 < l.length ? "Crossjoin({" + l.join("}, {") + "})" : l[0];
                }
                Sy(c, d) {
                  for (var g, l = 0; l < c.length; l++) {
                    var m = c[l].slice(1);
                    m.push(0);
                    m = this.Jp(m, d);
                    g = g && !e.ia(m) ? e.P.bind("Union({0}, {1})", m, g) : m;
                  }
                  return g;
                }
                u0(c, d) {
                  return 0 < this.slice.xb.length ? this.Jp(c, this.slice.xb, d) : "";
                }
                t0(c, d) {
                  var g = this.zo();
                  return 0 < this.slice.Db.length ? "Crossjoin(" + this.Jp(c, this.slice.Db, d) + ", " + g + ")" : g;
                }
                G0(c) {
                  var d = this.zo();
                  return 0 < this.slice.Db.length ? (c = c.slice(0), c.push(0), "Crossjoin(" + this.Jp(c, this.slice.Db) + ", " + d + ")") : d;
                }
                J0(c) {
                  return 0 < this.slice.xb.length ? (c = c.slice(0), c.push(0), this.Jp(c, this.slice.xb)) : "";
                }
                Dva(c, d) {
                  0 <= k.i.bc.jy.indexOf(d.ua) && (d = d.iS(c.getTimezoneOffset()));
                  if (d.ua == k.i.bc.EQUAL) {
                    var g = "Filter({0}.levels({3}), ({0}.CurrentMember.MemberValue>=CDate('{1}') AND {0}.CurrentMember.MemberValue<CDate('{2}')))";
                    var l = d.value.clone().Pn();
                    var m = l.clone().RZ(1).Pn();
                  }
                  d.ua == k.i.bc.Pf && (g = "Filter({0}.levels({3}), ({0}.CurrentMember.MemberValue<CDate('{1}') OR {0}.CurrentMember.MemberValue>CDate('{2}')))", l = d.value.clone().Pn(), m = l.clone());
                  d.ua == k.i.bc.SE && (l = d.value.clone().Pn(), g = "Filter({0}.levels({3}), ({0}.CurrentMember.MemberValue<CDate('{1}')))");
                  d.ua == k.i.bc.TE && (l = d.value.clone().Pn(), g = "Filter({0}.levels({3}), ({0}.CurrentMember.MemberValue<=CDate('{1}')))");
                  d.ua == k.i.bc.PE && (l = d.value.clone().Pn(), g = "Filter({0}.levels({3}), ({0}.CurrentMember.MemberValue>CDate('{1}')))");
                  d.ua == k.i.bc.QE && (l = d.value.clone().Pn(), g = "Filter({0}.levels({3}), ({0}.CurrentMember.MemberValue>=CDate('{1}')))");
                  d.ua == k.i.bc.fh && (l = d.value[0].clone().Pn(), m = d.value[1].clone().pA(), g = "Filter({0}.levels({3}), ({0}.CurrentMember.MemberValue>=CDate('{1}') AND {0}.CurrentMember.MemberValue<=CDate('{2}')))");
                  d.ua == k.i.bc.Og && (l = d.value[0].clone().Pn(), m = d.value[1].clone().pA(), g = "Filter({0}.levels({3}), ({0}.CurrentMember.MemberValue<CDate('{1}') OR {0}.CurrentMember.MemberValue>CDate('{2}')))");
                  d = this.slice.Ar[0].Ig;
                  let n;
                  this.fa.Ox && (n = c.zi.pD[d]);
                  e.ia(n) && (n = c.A);
                  g = e.P.bind(g, n, l.format("yyyy-MM-dd"), m ? m.format("yyyy-MM-dd") : "", c.Rh ? 1 : 0);
                  return [g];
                }
                Qva(c, d) {
                  var g,
                    l = d.value,
                    m = l.length;
                  d.ua == k.i.Cb.EQUAL && (g = "Filter({0}.levels({1}), ({0}.CurrentMember.member_caption='{2}'))");
                  d.ua == k.i.Cb.Pf && (g = "Filter({0}.levels({1}), ({0}.CurrentMember.member_caption<>'{2}'))");
                  d.ua == k.i.Cb.UE && (g = "Filter({0}.levels({1}), (Left({0}.CurrentMember.member_caption,{3})='{2}'))");
                  d.ua == k.i.Cb.ZA && (g = "Filter({0}.levels({1}), (Left({0}.CurrentMember.member_caption,{3})<>'{2}'))");
                  d.ua == k.i.Cb.NA && (g = "Filter({0}.levels({1}), (Right({0}.CurrentMember.member_caption,{3})='{2}'))");
                  d.ua == k.i.Cb.aB && (g = "Filter({0}.levels({1}), (Right({0}.CurrentMember.member_caption,{3})<>'{2}'))");
                  d.ua == k.i.Cb.Un && (g = "Filter({0}.levels({1}), (InStr(1, {0}.CurrentMember.member_caption,'{2}')>0))");
                  d.ua == k.i.Cb.$A && (g = "Filter({0}.levels({1}), (InStr(1, {0}.CurrentMember.member_caption,'{2}')=0))");
                  d.ua == k.i.Cb.GREATER && (g = "Filter({0}.levels({1}), ({0}.CurrentMember.member_caption>'{2}'))");
                  d.ua == k.i.Cb.Xk && (g = "Filter({0}.levels({1}), ({0}.CurrentMember.member_caption>='{2}'))");
                  d.ua == k.i.Cb.LESS && (g = "Filter({0}.levels({1}), ({0}.CurrentMember.member_caption<'{2}'))");
                  d.ua == k.i.Cb.$k && (g = "Filter({0}.levels({1}), ({0}.CurrentMember.member_caption<='{2}'))");
                  if (d.ua == k.i.Cb.fh) {
                    g = "Filter({0}.levels({1}), ({0}.CurrentMember.member_caption>='{2}'  AND {0}.CurrentMember.member_caption<='{4}'))";
                    l = d.value[0];
                    var n = d.value[1];
                  }
                  d.ua == k.i.Cb.Og && (g = "Filter({0}.levels({1}), ({0}.CurrentMember.member_caption<='{2}'  OR {0}.CurrentMember.member_caption>='{4}'))", l = d.value[0], n = d.value[1]);
                  g = e.P.bind(g, c.A, c.Rh ? 1 : 0, l, m, n);
                  return [g];
                }
                Ip(c) {
                  for (var d = [], g = "", l = 0; l < c.length; l++) {
                    var m = c.ea(l),
                      n = [];
                    m.filter.Ei && (n = m.nr(m.cb));
                    m.filter.xz && (n = this.Dva(m, m.filter.query));
                    m.filter.Ww && (n = this.Qva(m, m.filter.query));
                    if (!m.Rh) {
                      var p = m.zm();
                      this.md.Bb(p) || this.md.Ua(p, this.dT(m));
                    }
                    0 < n.length && d.push("{" + n.join(",") + "}");
                  }
                  0 < d.length && (g = "(" + d.join(", ") + ")");
                  return g;
                }
                $va(c, d, g) {
                  for (var l = [], m = c.indexOf(d.A), n = 0; n < m; n++) {
                    var p = c.ea(n);
                    l.push("Hierarchize(" + p.A + ".levels(" + (p.Rh ? 1 : 0) + ")." + this.eT(d) + ")");
                  }
                  c = "Hierarchize({" + this.dT(d) + "})";
                  0 < l.length && (c = "CrossJoin(" + l.join(",") + ", " + c + ")");
                  return e.P.bind("( SELECT Generate({0} AS {1}, {7}( Filter( Except(  DrilldownLevel({1}.Current AS {2}, , {5}{8} ), {2}), Not IsEmpty({3})), {4}, {3})) ON COLUMNS FROM {6})", c, "[" + d.caption + "___0___0]", "[" + d.caption + "_1_1_1]", d.filter.measure.A, d.filter.query.value, "" + m, g, d.filter.query.ua == k.i.Vb.Nj ? "TopCount" : "BottomCount", ", INCLUDE_CALC_MEMBERS");
                }
                xba(c, d) {
                  for (var g = 0; g < c.length; g++) {
                    var l = c.ea(g);
                    l.filter.ei && this.slice.Sf.find(m => m.A === l.filter.measure.A) && (d = this.$va(c, l, d));
                  }
                  return d;
                }
                zC() {
                  if (0 == this.md.length) return "";
                  for (var c = "with", d = 0; d < this.md.length; d++) c += e.P.bind(" member {0} as IIF(IsError(Aggregate({{1}})), null, Aggregate({{1}}))", this.iE(this.md.Oh(d)), this.iE(this.md.ea(d)));
                  return c;
                }
                yo() {
                  let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                  var d = e.ia(this.fa.Ze) ? "[" + this.fa.va + "]" : "(" + this.fa.Ze + ")";
                  var g = this.Ip(this.slice.Db),
                    l = this.Ip(this.slice.xb),
                    m = "";
                  let n = "";
                  if (0 !== this.slice.ob.length) for (let t = 0; t < this.slice.ob.length; t++) {
                    const r = this.slice.ob.ea(t);
                    if (r.filter && r.filter.Ei) {
                      var p = r.filter.yj();
                      1 == p.length && c ? n = 0 === n.length ? ` WHERE (${r.A1(p[0])})` : n.substring(0, n.length - 1) + `, ${r.A1(p[0])})` : 1 < p.length && c && (n = 0 === n.length ? ` WHERE (${r.A + ".CurrentMember"})` : n.substring(0, n.length - 1) + `, ${r.A + ".CurrentMember"})`);
                    }
                  }
                  0 < this.slice.ob.length && (m = this.Ip(this.slice.ob));
                  0 == g.length && 0 == l.length && 0 == m.length ? c = d : (0 < g.length && (g += " ON COLUMNS"), 0 < l.length && (0 < g.length ? l = ", " + l + " ON ROWS" : (g = l + " ON COLUMNS", l = "")), 0 < m.length && (m = "SELECT " + m + " ON COLUMNS FROM " + d), 0 < g.length || 0 < l.length ? (c = "SELECT " + g + l + " FROM ", c = 0 < m.length ? c + ("(" + m + ")") : c + d) : c = m, c = "(" + c + ")");
                  c = this.xba(this.slice.xb, c);
                  c = this.xba(this.slice.Db, c);
                  0 < n.length && (c += n);
                  return c;
                }
                iE(c) {
                  -1 < c.indexOf("'") && (c = c.replace(RegExp("'", "g"), "''"));
                  return c;
                }
                expand(c, d) {
                  this.md = new e.ub();
                  c == k.i.ha.Ia ? (c = this.vC(), d = this.J0(d)) : (c = this.G0(d), d = this.yC());
                  var g = this.yo();
                  c = "NON EMPTY " + c + " DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON COLUMNS";
                  d = this.ME ? 0 < d.length ? ", NON EMPTY _ROWS_TOKEN_START_" + d + "_ROWS_TOKEN_END_ DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "" : 0 < d.length ? ", NON EMPTY " + d + " DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "";
                  var l = this.zC();
                  return e.P.bind("{4} Select {0} {1} FROM {2} CELL PROPERTIES {3}", c, d, g, this.H_(), l);
                }
                Ae(c, d, g, l) {
                  this.md = new e.ub();
                  c == k.i.ha.Ia ? (c = this.vC(), d = this.u0(d, l)) : (c = this.t0(d, l), d = this.yC());
                  l = this.yo();
                  c = "NON EMPTY " + c + " DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON COLUMNS";
                  d = this.ME ? 0 < d.length ? ", NON EMPTY _ROWS_TOKEN_START_" + d + "_ROWS_TOKEN_END_ DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "" : 0 < d.length ? ", NON EMPTY " + d + " DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "";
                  g = this.zC();
                  return e.P.bind("{4} Select {0} {1} FROM {2} CELL PROPERTIES {3}", c, d, l, this.H_(), g);
                }
                select() {
                  this.md = new e.ub();
                  var c = this.vC(),
                    d = this.yC(),
                    g = this.yo();
                  c = "NON EMPTY " + c + " DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON COLUMNS";
                  d = this.ME ? 0 < d.length ? ", NON EMPTY _ROWS_TOKEN_START_" + d + "_ROWS_TOKEN_END_ DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "" : 0 < d.length ? ", NON EMPTY " + d + " DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "";
                  var l = this.zC();
                  return e.P.bind("{4} Select {0} {1} FROM {2} CELL PROPERTIES {3}", c, d, g, this.H_(), l);
                }
                H_() {
                  return 0 == e.model.C.F.Rn || this.fa.Ba != k.i.qa.Cc ? "VALUE" : "VALUE, FORMATTED_VALUE";
                }
                bd(c, d, g) {
                  this.md = new e.ub();
                  for (var l = "DRILLTHROUGH MAXROWS " + e.model.C.F.ZG + " SELECT {0} ON 0 FROM {1} {2}", m, n = [], p = 0; p < this.slice.Db.length; p++) m = this.slice.Db.ea(p), m.Ue || null == d[p] || (m = m.za(d[p]), null != m && n.push(m.A));
                  for (p = 0; p < this.slice.xb.length; p++) m = this.slice.xb.ea(p), m.Ue || null == c[p] || (m = m.za(c[p]), null != m && n.push(m.A));
                  c = 0 < n.length ? "where (" + n.join(",") + ")" : "";
                  d = this.yo(!1);
                  return e.P.bind(l, g.A, d, c);
                }
              }
              b.PX = a;
            })(f.GE || (f.GE = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends f.jj.R9 {
                constructor(c) {
                  super(c);
                  this.qI = [];
                }
                M_() {
                  var c = e.P.bind("SET [SearchMembersSet] AS 'FILTER(EXCEPT({0}.members, {{1}}), (INSTR(lcase({0}.CurrentMember.Caption), {2}) > 0))'", this.hierarchy.A, this.hierarchy.Bs, '"' + this.sd + '"');
                  var d = e.P.bind("SET [SearchParentsSet] AS 'EXCEPT(GENERATE([SearchMembersSet], ASCENDANTS([SearchMembersSet].Current)), {{0}})'", this.hierarchy.Bs);
                  return c + "\n" + d + "\nSET [SearchSet] AS 'HIERARCHIZE(DISTINCT({[SearchMembersSet], [SearchParentsSet]}))'";
                }
                J_() {
                  var c = this.hierarchy.LU,
                    d = [],
                    g = [];
                  if (0 < c.length) for (var l = 0; l < c.length; l++) {
                    var m = c.ea(l).A;
                    g.push("[Measures].[" + m + "]");
                    d.push(e.P.bind('member [Measures].[{0}] as {1}.CurrentMember.Properties("{0}")', m, this.hierarchy.A));
                  }
                  c = this.yo();
                  0 < g.length ? (g = 0 < g.length ? g.join(", ") : "", d = 0 < d.length ? "with " + d.join(" ") : "", d = null == this.Zb ? this.SH() ? e.P.bind("{3} SELECT crossjoin(DISTINCT({{0}.allmembers}), {{2}}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", this.hierarchy.A, c, g, d) : this.hierarchy.Rh ? e.P.bind("{5} SELECT crossjoin(Subset(DISTINCT({{0}.levels(0).allmembers, {0}.levels(1).allmembers}), {2}, {3}), {{4}}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", this.hierarchy.A, c, this.ql.toString(), this.ar.toString(), g, d) : e.P.bind("{5} SELECT crossjoin(Subset(DISTINCT({{0}.levels(0).allmembers}), {2}, {3}), {{4}}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", this.hierarchy.A, c, this.ql.toString(), this.ar.toString(), g, d) : e.P.bind("{5} SELECT crossjoin(Subset({0}.children, {2}, {3}), {{4}}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", this.Zb.A, c, this.ql.toString(), this.ar.toString(), g, d)) : d = null == this.Zb ? this.SH() ? e.P.bind("SELECT DISTINCT({{0}.allmembers}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", this.hierarchy.A, c) : this.hierarchy.Rh ? e.P.bind("SELECT Subset(DISTINCT({{0}.levels(0).allmembers, {0}.levels(1).allmembers}), {2}, {3}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", this.hierarchy.A, c, this.ql.toString(), this.ar.toString()) : e.P.bind("SELECT Subset(DISTINCT({{0}.levels(0).allmembers}), {2}, {3}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", this.hierarchy.A, c, this.ql.toString(), this.ar.toString()) : e.P.bind("SELECT Subset({0}.children, {2}, {3}) DIMENSION PROPERTIES PARENT_UNIQUE_NAME on columns FROM {1}", this.Zb.A, c, this.ql.toString(), this.ar.toString());
                  return d;
                }
                eE(c) {
                  var d = c.find("root");
                  if (0 < d.find("Fault").length) e.Wa(z.ba.Kc(d.find("Fault faultstring")), "Query error!", e.tb.xa);else {
                    this.qI = [];
                    c = [];
                    for (var g = d.find('Axes Axis[name="Axis0"] Tuples Tuple Member'), l = this.hierarchy.Wi, m = 0; m < g.length; m++) c.push(this.wV(g[m], m + l));
                    d = d.find("CellData Cell");
                    for (m = 0; m < d.length; m++) if (l = d[m], g = parseInt(l.attr("CellOrdinal")), l = l.find("Value").text(), 0 > l.indexOf("MondrianEvaluationException") && !e.v(this.qI) && !e.v(this.qI[g])) {
                      var n = this.qI[g][1];
                      g = this.hierarchy.Ib(this.qI[g][0]);
                      null != g && g.setProperty(n, l);
                    }
                    return c;
                  }
                }
                wV(c, d) {
                  var g = c.find("PARENT_UNIQUE_NAME").text();
                  var l = c.find("LName").text();
                  var m = c.find("Caption").text(),
                    n = c.find("UName").text();
                  c = parseInt(c.find("MEMBER_ORDINAL").text());
                  if ("[Measures].[MeasuresLevel]" == l) null != this.Dfa && this.qI.push([this.Dfa.A, m]);else return l = this.hierarchy.Ib(n), null == l ? (l = this.hierarchy.oc(new k.O.ae({
                    A: n,
                    caption: m,
                    Hi: g
                  })), l.fc = isNaN(c) ? d : c) : this.state == k.rp.pF && (l.fc = isNaN(c) ? d : c), this.Dfa = l, null == l || l.dc || (l.zf = !0), l.parent && !l.parent.dc && (l.parent.zf = !1), l.ordinal;
                }
              }
              b.dpa = a;
            })(f.hq || (f.hq = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends f.jj.S9 {
                constructor(c) {
                  super(c);
                  this.cm = new b.dpa(c);
                }
                NU() {
                  e.Da(!1);
                  null != this.Mb && this.Mb();
                }
                s4(c) {
                  var d = c.find("DIMENSION_UNIQUE_NAME").text(),
                    g = c.find("HIERARCHY_UNIQUE_NAME").text(),
                    l = c.find("LEVEL_UNIQUE_NAME").text(),
                    m = c.find("PROPERTY_CAPTION").text();
                  c.find("PROPERTY_TYPE").text();
                  c = c.find("PROPERTY_NAME").text();
                  d = this.va.O.Sp(d);
                  null != d && (g = d.ph(g), null != g && (l = g.Cu(l), null != l && (m = new k.O.XW(c, m), l.$Z(m))));
                }
              }
              b.epa = a;
            })(f.hq || (f.hq = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a {
                constructor(c, d) {
                  this.slice = c;
                  this.Ab = d;
                }
                get ME() {
                  return this.Ab && this.Ab.Cm ? !0 : !1;
                }
                PT() {
                  return 0 < this.slice.rd(k.i.ha.Ra).kd.length;
                }
                QT() {
                  return 0 < this.slice.rd(k.i.ha.Ia).kd.length;
                }
                qW(c) {
                  return c = c.replace(/[\]|\[]/g, "");
                }
                iE(c) {
                  -1 < c.indexOf("'") && (c = c.replace(RegExp("'", "g"), "''"));
                  return c;
                }
                tL(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                  var g = [];
                  var l = 0 != c.cb.length || c.Rh ? c.cb : c.av(c.wa.ea(1).A);
                  for (var m = c.nr(l), n = [], p, t = 0; t < l.length; t++) if (p = c.za(l[t]), !e.ia(p.A)) {
                    g.push(p.A);
                    if (p.Yg || this.slice.gf || this.slice.Tf) d ? g.push(e.P.bind("Descendants({0})", p.A)) : g.push(e.P.bind("{0}.CHILDREN", p.A));
                    for (; null != p.parent;) {
                      p = p.parent;
                      for (var r = p.Bw, w = [], y = 0; y < r.length; y++) {
                        var A = c.za(r[y]).A;
                        -1 < m.indexOf(A) && w.push(A);
                      }
                      r = !c.Rh && p.dc ? c.zm() : p.Kaa;
                      if (c.type == k.i.Fc.Ta && !c.Rh) {
                        if (p.dc) continue;
                        r = p.A;
                      }
                      -1 == n.indexOf(r) && n.push(r);
                      this.md.Bb(r) || c.Ms || this.md.Ua(r, w.join(","));
                    }
                  }
                  d = this.qW(c.A) + "FilterSet";
                  this.Mg.Ua(d, g.join(", "));
                  c = this.qW(c.A) + "CalculatedSet";
                  this.Mg.Ua(c, n.join(", "));
                  return ["[" + d + "]", "[" + c + "]"];
                }
                uL(c, d, g) {
                  if (g) {
                    if (c.filter.Ei) {
                      var l = this.tL(c, !0);
                      g = l[0];
                      l = l[1];
                      d = e.P.bind("Hierarchize(Distinct(Union({0}, {1})))", g, l);
                    } else d = "Hierarchize({" + c.A + ".AllMembers})";
                  } else {
                    var m = c.Rh ? e.P.bind("Union({{0}}, {1}.levels(1).AllMembers)", c.Am, c.A) : c.type == k.i.Fc.Ta ? e.P.bind("{0}.levels(0).AllMembers", c.A) : e.P.bind("Union({{0}}, {1}.levels(0).AllMembers)", c.zm(), c.A);
                    var n = this.Jva(c);
                    c.filter.Ei || !c.Rh && c.type != k.i.Fc.Ta ? (l = this.tL(c, d && 0 < n.length), g = l[0], l = l[1], d = d ? 0 < n.length ? e.P.bind("Hierarchize(Distinct(Union(Intersect({0}, Union({1}, {3})), {2})))", g, n, l, m) : e.P.bind("Hierarchize(Distinct(Union({0}, {1})))", g, l) : c.zm()) : d = d ? 0 < n.length ? e.P.bind("Hierarchize(Distinct(Union({0}, {1})))", m, n) : m : e.P.bind("{0}.levels(0).AllMembers", c.A);
                  }
                  c = "set_" + this.slice.yc().indexOf(c.A) + "_set";
                  this.Mg.Ua(c, d);
                  return "[" + c + "]";
                }
                Jva(c) {
                  for (var d = [], g = 1; g < c.wa.length; g++) {
                    var l = c.wa.ea(g);
                    c.lc && c.lc.A == l.A && d.push(e.P.bind("Descendants({{0}}, {1}, SELF_AND_BEFORE)", c.Bs, c.lc.A));
                    l = c.OL(l);
                    if (0 != l.length) for (var m = 0; m < l.length; m++) {
                      var n = c.za(l[m]);
                      c.type != k.i.Fc.Ta || c.Rh ? d.push(e.P.bind("{0}.CHILDREN", n.A)) : (n = c.nr(n.children), d.push(e.P.bind("{" + n.join(",")) + "}"));
                    }
                  }
                  return 0 < d.length ? (c = this.qW(c.A) + "DrilledSet", this.Mg.Ua(c, d.join(",")), "[" + c + "]") : "";
                }
                Sy(c, d) {
                  for (var g = "", l = 0; l < c.length; l++) {
                    var m = c[l].slice(1);
                    m = this.Jp(m, d);
                    "" != m && (g = g ? e.P.bind("Union({0}, {1})", m, g) : m);
                  }
                  return g;
                }
                Jp(c, d) {
                  for (var g = "", l = d.length - 1; 0 <= l; l--) {
                    var m = d.ea(l);
                    if (null != c[l]) {
                      var n = m.za(c[l]);
                      if (null == n) {
                        g = "";
                        break;
                      }
                      m.filter.Ei ? (m = this.tL(m, !0), n = e.P.bind("Hierarchize(Distinct(Union(Intersect({{0}}, {1}), {2})))", n.A, m[0], m[1])) : n = "{" + n.A + "}";
                    } else n = c.length == l ? this.uL(m, !0, !1) : this.uL(m, !1, !1);
                    g = l == d.length - 1 ? n : e.P.bind("CrossJoin({{0}}, {{1}})", n, g);
                  }
                  return g;
                }
                rL(c) {
                  var d = [];
                  for (var g = this.slice.gd(), l = 0; l < g.length; l++) d.push("isEmpty(" + g[l].A + ")");
                  d = d.join(" and ");
                  g = "";
                  for (l = 0; l < c.length; l++) {
                    var m = c.ea(l);
                    m = this.uL(m, this.slice.kf || this.slice.jf || 0 == l, this.slice.gf || this.slice.Tf);
                    m = "Filter(" + m + ", not (" + d + "))";
                    g = 0 < l ? "Crossjoin(" + g + "," + m + ")" : m;
                  }
                  return g;
                }
                vC() {
                  if (0 < this.slice.Db.length) {
                    var c = this.rL(this.slice.Db);
                    this.Mg.Ua("columnHierarchiesSet", c);
                    c = "";
                    this.PT() && (c = this.Sy(this.slice.rd(k.i.ha.Ra).kd, this.slice.Db), 0 < c.length && this.Mg.Ua("columnExpandedSet", c));
                    this.Mg.Ua("columnSet", "Crossjoin(" + (0 < c.length ? "Union([columnHierarchiesSet], [columnExpandedSet])" : "[columnHierarchiesSet]") + ", [measureSet])");
                  } else this.Mg.Ua("columnSet", "[measureSet]");
                }
                yC() {
                  if (0 < this.slice.xb.length) {
                    var c = this.rL(this.slice.xb);
                    this.Mg.Ua("rowHierarchiesSet", c);
                    c = "";
                    this.QT() && (c = this.Sy(this.slice.rd(k.i.ha.Ia).kd, this.slice.xb), 0 < c.length && this.Mg.Ua("rowExpandedSet", c));
                    this.Mg.Ua("rowSet", 0 < c.length ? "Union([rowHierarchiesSet], [rowExpandedSet])" : "[rowHierarchiesSet]");
                  }
                }
                G0(c) {
                  0 < this.slice.Db.length ? (c = this.Jp(c, this.slice.Db), this.Mg.Ua("columnSet", "Crossjoin(" + c + ", [measureSet])")) : this.Mg.Ua("columnSet", "[measureSet]");
                }
                J0(c) {
                  0 < this.slice.xb.length && (c = this.Jp(c, this.slice.xb), this.Mg.Ua("rowSet", c));
                }
                t0(c, d) {
                  0 < this.slice.Db.length ? (c = this.zca(c, d, this.slice.Db), this.Mg.Ua("columnSet", "Crossjoin(" + c + ", [measureSet])")) : this.Mg.Ua("columnSet", "[measureSet]");
                }
                u0(c, d) {
                  0 < this.slice.xb.length && (c = this.zca(c, d, this.slice.xb), this.Mg.Ua("rowSet", c));
                }
                zca(c, d, g) {
                  var l = [];
                  for (var m = this.slice.gd(), n = 0; n < m.length; n++) l.push("isEmpty(" + m[n].A + ")");
                  l = l.join(" and ");
                  m = "";
                  for (n = g.length - 1; 0 <= n; n--) {
                    var p = g.ea(n);
                    if (d.hierarchy.A == p.A) {
                      if (p.filter.Ei) {
                        var t = this.tL(p, !0);
                        p = t[0];
                        t = t[1];
                        var r = e.P.bind("Hierarchize(Distinct(Union(Intersect({0}.CHILDREN, {1}), {2})))", d.A, p, t);
                      } else r = this.uL(p, !0, !1), r = e.P.bind("Intersect({0}.CHILDREN, {{1}})", d.A, r);
                    } else if (null != c[n]) {
                      r = p.za(c[n]);
                      if (null == r) {
                        m = "";
                        break;
                      }
                      p.filter.Ei ? (t = this.tL(p, !0), p = t[0], t = t[1], r = e.P.bind("Hierarchize(Distinct(Union(Intersect({{0}}, {1}), {2})))", r.A, p, t)) : r = "{" + r.A + "}";
                    } else r = this.uL(p, !1, !1);
                    r = "Filter(" + r + ", not (" + l + "))";
                    m = n == g.length - 1 ? r : e.P.bind("CrossJoin({{0}}, {{1}})", r, m);
                  }
                  return m;
                }
                K_() {
                  for (var c = "", d = [], g = 0; g < this.slice.ob.length; g++) {
                    var l = this.slice.ob.ea(g);
                    l.filter.Ei && (this.md.Ua(l.zm(), l.nr(l.cb).join(",")), d.push(l.zm()));
                  }
                  0 < d.length && (c = e.P.bind("where ({0})", d.join(", ")));
                  return c;
                }
                zo() {
                  for (var c = [], d = 0; d < this.slice.Ar.length; d++) c.push(this.slice.Ar[d].A);
                  this.Mg.Ua("measureSet", c.join(", "));
                }
                zC() {
                  for (var c = "with", d = 0; d < this.Mg.length; d++) c += e.P.bind(" set [{0}] as '{{1}}'", this.iE(this.Mg.Oh(d)), this.iE(this.Mg.ea(d)));
                  for (d = 0; d < this.md.length; d++) c += e.P.bind(" member {0} as 'Aggregate({{1}})'", this.iE(this.md.Oh(d)), this.iE(this.md.ea(d)));
                  return c;
                }
                select() {
                  this.Mg = new e.ub();
                  this.md = new e.ub();
                  this.zo();
                  this.vC();
                  this.yC();
                  var c = this.K_();
                  var d = this.ME ? this.Mg.Bb("rowSet") ? ", NON EMPTY _ROWS_TOKEN_START_[rowSet]_ROWS_TOKEN_END_ DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "" : this.Mg.Bb("rowSet") ? ", NON EMPTY [rowSet] DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "";
                  var g = this.zC();
                  return e.P.bind("{0} Select {1} {2} FROM [{3}] {4} CELL PROPERTIES VALUE", g, "NON EMPTY [columnSet] DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON COLUMNS", d, this.Ab.va, c);
                }
                expand(c, d) {
                  this.Mg = new e.ub();
                  this.md = new e.ub();
                  this.zo();
                  c == k.i.ha.Ia ? (this.vC(), this.J0(d)) : (this.G0(d), this.yC());
                  c = this.K_();
                  d = this.ME ? this.Mg.Bb("rowSet") ? ", NON EMPTY _ROWS_TOKEN_START_[rowSet]_ROWS_TOKEN_END_ DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "" : this.Mg.Bb("rowSet") ? ", NON EMPTY [rowSet] DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "";
                  var g = this.zC();
                  return e.P.bind("{0} Select {1} {2} FROM [{3}] {4} CELL PROPERTIES VALUE", g, "NON EMPTY [columnSet] DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON COLUMNS", d, this.Ab.va, c);
                }
                Ae(c, d, g) {
                  this.Mg = new e.ub();
                  this.md = new e.ub();
                  this.zo();
                  c == k.i.ha.Ia ? (this.vC(), this.u0(d, g)) : (this.t0(d, g), this.yC());
                  c = this.K_();
                  d = this.ME ? this.Mg.Bb("rowSet") ? ", NON EMPTY _ROWS_TOKEN_START_[rowSet]_ROWS_TOKEN_END_ DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "" : this.Mg.Bb("rowSet") ? ", NON EMPTY [rowSet] DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON ROWS" : "";
                  g = this.zC();
                  return e.P.bind("{0} Select {1} {2} FROM [{3}] {4} CELL PROPERTIES VALUE", g, "NON EMPTY [columnSet] DIMENSION PROPERTIES PARENT_UNIQUE_NAME, HIERARCHY_UNIQUE_NAME, MEMBER_TYPE ON COLUMNS", d, this.Ab.va, c);
                }
                bd() {
                  return "";
                }
              }
              b.PX = a;
            })(f.hq || (f.hq = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              (function (a) {
                class c extends f.O.ZX {
                  constructor() {
                    super(...arguments);
                    this.Kl = new u.dQ(!1);
                    this.Nv = new u.dQ();
                  }
                  zm() {
                    let d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "(Total)";
                    if (this.Rh) return this.Am + ".[" + d + "]";
                    var g = this.Bs.split("].");
                    g.pop();
                    g.push("[" + d + "]");
                    return g.join("].");
                  }
                  hD() {
                    return new a.cpa(this);
                  }
                  Ib(d) {
                    d = this.Kl.find(d);
                    return -1 == d ? null : this.za(d);
                  }
                }
                a.S8 = c;
              })(b.O || (b.O = {}));
            })(f.hq || (f.hq = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              (function (a) {
                class c extends f.O.X8 {
                  get Sh() {
                    return this.level.Su ? !0 : this.hierarchy.XM || this.hierarchy.Ms || this.level.Su ? (this.Yg || !this.zf) && 0 == this.children.length : !1;
                  }
                  set Sh(d) {}
                }
                a.cpa = c;
              })(b.O || (b.O = {}));
            })(f.hq || (f.hq = {}));
          })(h.Fb || (h.Fb = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.AA {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                }
              }
              b.ama = a;
            })(f.O || (f.O = {}));
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.rt {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                  this.hfa = !1;
                  this.WF = this.Nga = "";
                  c = new b.p7(c + ".[(all)]", "All", 0);
                  this.Mh(c);
                  this.Bs = this.Am = "(all member)";
                  c = new k.O.ae({
                    A: "(all member)",
                    caption: "All",
                    dc: !0
                  });
                  this.oc(c);
                }
                hD() {
                  return new b.cma(this);
                }
                oc(c) {
                  void 0 !== c.caption && e.ia(c.caption) ? c.caption = e.model.B.j.Fl : e.ia(c.A) && (c.caption = e.model.B.j.Fl);
                  return super.oc(c);
                }
                za(c) {
                  return super.za(c);
                }
                get inputType() {
                  return this.WF;
                }
                set inputType(c) {
                  this.WF = c;
                }
                ij() {
                  const c = super.ij();
                  c.type = this.inputType;
                  return c;
                }
              }
              b.bma = a;
            })(f.O || (f.O = {}));
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.qv {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  super(c, d, g);
                }
              }
              b.p7 = a;
            })(f.O || (f.O = {}));
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.Or {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                }
                get dk() {
                  return this.Oa ? [] : this.type == k.i.Qa.jb ? k.i.da.gka : k.i.da.hka;
                }
                set dk(c) {}
                get caption() {
                  if (0 == e.model.C.F.Fx) return this.xc;
                  switch (this.aa) {
                    case k.i.da.zc:
                      return e.P.bind(e.model.B.j.FO, this.xc);
                    case k.i.da.Bt:
                      return e.P.bind(e.model.B.j.QP, this.xc);
                    case k.i.da.mj:
                      return e.P.bind(e.model.B.j.PO, this.xc);
                    case k.i.da.Bq:
                      return e.P.bind(e.model.B.j.AO, this.xc);
                    case k.i.da.Gv:
                      return e.P.bind(e.model.B.j.ZP, this.xc);
                    case k.i.da.Hv:
                      return e.P.bind(e.model.B.j.$P, this.xc);
                    case k.i.da.MAX:
                      return e.P.bind(e.model.B.j.AP, this.xc);
                    case k.i.da.MIN:
                      return e.P.bind(e.model.B.j.JP, this.xc);
                    case k.i.da.Vr:
                      return e.P.bind(e.model.B.j.VJ, this.xc);
                    case k.i.da.tp:
                      return e.P.bind(e.model.B.j.PJ, this.xc);
                    case k.i.da.Kq:
                      return e.P.bind(e.model.B.j.UJ, this.xc);
                    case k.i.da.Iq:
                      return e.P.bind(e.model.B.j.SJ, this.xc);
                    case k.i.da.Jq:
                      return e.P.bind(e.model.B.j.TJ, this.xc);
                    case k.i.da.Pi:
                      return e.P.bind(e.model.B.j.DJ, this.xc);
                    case k.i.da.jn:
                      return e.P.bind(e.model.B.j.SP, this.xc);
                    case k.i.da.fo:
                      return e.P.bind(e.model.B.j.UP, this.xc);
                    case k.i.da.Xn:
                      return e.P.bind(e.model.B.j.iJ, this.xc);
                    case k.i.da.fn:
                      return e.P.bind(e.model.B.j.jJ, this.xc);
                    case k.i.da.co:
                      return e.P.bind(e.model.B.j.QJ, this.xc);
                    case k.i.da.hn:
                      return e.P.bind(e.model.B.j.RJ, this.xc);
                    case k.i.da.NONE:
                      return this.xc;
                  }
                  return e.P.bind(e.model.B.j.aK, this.xc);
                }
                set caption(c) {
                  "" == c.trim() ? this.xc = e.model.B.j.Fl : this.xc = c;
                }
                get rl() {
                  return this.xc;
                }
                set rl(c) {}
                R1() {
                  var c = new a("", "");
                  return this.format != c.format || 0 == this.Pm ? !1 : !0;
                }
                clone() {
                  var c = new a(this.A);
                  this.zL(c);
                  return c;
                }
                ij() {
                  const c = super.ij(),
                    d = k.Ma.R().O.Kk(this.A);
                  e.v(d) ? c.type = k.i.input.sa.jb : c.type = d.inputType;
                  return c;
                }
              }
              b.q7 = a;
            })(f.O || (f.O = {}));
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.aJ {
                Sa() {
                  var c = super.Sa();
                  c.uniqueName = this.Ci;
                  this.parent && (c.parentMember = this.parent.Ci);
                  return c;
                }
                set caption(c) {}
                get caption() {
                  return this.hierarchy.gD(this.ordinal);
                }
              }
              b.cma = a;
            })(f.O || (f.O = {}));
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.YW {
                constructor() {
                  super();
                  this.NB = {};
                  this.EB = {};
                  this.YZ();
                }
                TK(c, d) {
                  this.NB[c] = this.ph(d);
                  this.EB[d] = this.fd(c);
                }
                Kk(c) {
                  return this.NB[c];
                }
                mf(c) {
                  return this.EB[c];
                }
                mx(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  var l = d ? d : new b.q7(c.uniqueName);
                  return super.mx(c, l, e.v(d) || g);
                }
                clear() {
                  this.NB = {};
                  this.EB = {};
                  super.clear();
                }
              }
              b.ema = a;
            })(f.O || (f.O = {}));
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.ut {
              constructor() {
                super();
                this.node = null;
                this.index = "";
                this.mapping = new f.UO();
                this.Ze = null;
                this.Ba = k.i.qa.hg;
              }
              isEqual(a) {
                return a.connection && a.connection === this.connection && this.index == a.index ? !0 : super.isEqual(a) && JSON.stringify(this.node) == JSON.stringify(a.node) && this.index == a.index && this.mapping.isEqual(a.mapping) && JSON.stringify(this.Ze) == JSON.stringify(a.Ze);
              }
              get RH() {
                return !1;
              }
              Nw(a) {
                if (!e.v(this.connection)) return a(this.connection);
                var c = new Pa.W6({
                  host: this.node,
                  headers: this.uc,
                  withCredentials: this.withCredentials
                });
                a(c);
              }
              static zb(a) {
                var c = new b();
                e.v(a.host) || (c.node = a.host);
                e.v(a.node) || (c.node = a.node);
                e.v(a.index) || (c.index = a.index);
                e.v(a.mapping) || (c.mapping = a.mapping instanceof f.UO ? a.mapping : new f.UO(a.mapping));
                e.v(a.subquery) || (c.Ze = a.subquery);
                e.v(a.connection) || (c.connection = a.connection);
                e.v(a.requestHeaders) || (c.uc = a.requestHeaders);
                e.v(a.withCredentials) || (c.withCredentials = a.withCredentials);
                return c;
              }
              Sa() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = {};
                c.type = this.Ba;
                e.v(this.node) || (c.node = this.node);
                e.v(this.index) || (c.index = this.index);
                if (!this.mapping.kb || this.mapping.Po) c.mapping = this.mapping.Sa(!0);
                e.v(this.Ze) || (c.subquery = this.Ze);
                if (a || this.withCredentials) c.withCredentials = this.withCredentials;
                return c;
              }
              clone() {
                var a = new b();
                a.Ba = this.Ba;
                e.v(this.node) || (a.node = this.node);
                e.v(this.index) || (a.index = this.index);
                if (!this.mapping.kb || this.mapping.Po) a.mapping = this.mapping.clone(this.Ba);
                e.v(this.Ze) || (a.Ze = this.Ze);
                e.v(this.withCredentials) || (a.withCredentials = this.withCredentials);
                return a;
              }
            }
            f.o7 = b;
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(a, c) {
                this.slice = a;
                this.ka = c;
              }
              select() {
                var a = {
                  size: 0
                };
                e.v(this.ka.Ze) || (a.query = u.Nc.vj(this.ka.Ze));
                var c = this.slice.xb.Pc(),
                  d = this.slice.Db.Pc();
                this.slice.kf || (c = c.slice(0, 1));
                this.slice.jf || (d = d.slice(0, 1));
                this.Ip(a);
                0 == c.length && 0 == d.length ? this.zo(a, this.slice.gd(), !0) : this.vw(a, c.concat(d));
                0 < d.length && this.vw(a, d.concat(c), !0);
                return a;
              }
              expand(a, c) {
                var d = {
                  size: 0
                };
                e.v(this.ka.Ze) || (d.query = u.Nc.vj(this.ka.Ze));
                var g = a == k.i.ha.Ia;
                a = this.slice.xb.Pc();
                var l = this.slice.Db.Pc();
                this.Ip(d);
                this.Jp(d, c, g ? a : l);
                if (this.slice.kf || this.slice.jf) return this.vw(d, a.concat(l)), 0 < l.length && this.vw(d, l.concat(a), !0), d;
                var m = [];
                if (g) {
                  c = c.length + 1;
                  var n = this.Qda(k.i.ha.Ra),
                    p = this.oea(this.slice.rd(k.i.ha.Ra).kd);
                  for (g = 1; g <= n; g++) if (!e.v(p[g]) || 1 == g) {
                    var t = u.Nc.vj(d);
                    1 != g && this.Sy(t, p[g], l);
                    var r = a.slice(0, c),
                      w = l.slice(0, g);
                    this.vw(t, r.concat(w));
                    m.push(t);
                  }
                } else for (g = c.length + 1, n = this.Qda(k.i.ha.Ia), p = this.oea(this.slice.rd(k.i.ha.Ia).kd), c = 1; c <= n; c++) e.v(p[c]) && 1 != c || (t = u.Nc.vj(d), 1 != c && this.Sy(t, p[c], a), r = a.slice(0, c), w = l.slice(0, g), this.vw(t, r.concat(w)), 0 < w.length && this.vw(t, w.concat(r), !0), m.push(t));
                return m;
              }
              oea(a) {
                for (var c = {}, d = 0; d < a.length; d++) {
                  var g = a[d].length;
                  e.v(c[g]) && (c[g] = []);
                  c[g].push(a[d]);
                }
                return c;
              }
              bd(a, c, d) {
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                d = {
                  size: e.model.C.F.ZG
                };
                e.v(this.ka.Ze) || (d.query = u.Nc.vj(this.ka.Ze));
                d._source = g.map(l => {
                  let m = this.slice.Yc.ph(l);
                  return m && m.hfa ? m.Nga : l;
                });
                this.Ip(d);
                this.Jp(d, a, this.slice.xb.Pc());
                this.Jp(d, c, this.slice.Db.Pc());
                return d;
              }
              $_(a) {
                e.v(a.query) && (a.query = {});
                e.v(a.query.bool) && (a.query.bool = {});
                e.v(a.query.bool.must) ? a.query.bool.must = [] : Array.isArray(a.query.bool.must) || (a.query.bool.must = [a.query.bool.must]);
                e.v(a.query.bool.must_not) ? a.query.bool.must_not = [] : Array.isArray(a.query.bool.must_not) || (a.query.bool.must_not = [a.query.bool.must_not]);
              }
              Jp(a, c, d) {
                this.$_(a);
                c.forEach((g, l) => {
                  l = d[l];
                  g = l.za(g);
                  a.query.bool.must.push(this.vL(l, g));
                });
              }
              Ae() {
                return null;
              }
              Qda(a) {
                a = this.slice.rd(a).kd;
                return 0 < a.length ? Math.max.apply(Math, a.map(c => c.length)) : 1;
              }
              Sy(a, c, d) {
                var g = {
                  bool: {
                    should: []
                  }
                };
                c.forEach(l => {
                  l = l.slice(1);
                  d.forEach((m, n) => {
                    null != l[n] && (n = m.za(l[n]), g.bool.should.push(this.vL(m, n)));
                  });
                });
                a.query.bool.must.push(g);
              }
              PT() {
                return 0 < this.slice.rd(k.i.ha.Ra).kd.length;
              }
              QT() {
                return 0 < this.slice.rd(k.i.ha.Ia).kd.length;
              }
              vw(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                for (var g = this.slice.gd(), l = 0; l < c.length; l++) if (this.zo(a, g, !0), !d || l != c.length - 1) {
                  var m = c[l];
                  this.Ova(a, m);
                  a = a.aggs[m.A];
                }
                d || this.zo(a, g);
              }
              Ova(a, c) {
                e.v(a.aggs) && (a.aggs = {});
                e.v(a.aggs[c.A]) && (a.aggs[c.A] = {});
                if (c.type == k.i.Fc.Ta) {
                  const d = {
                    field: c.A,
                    min_doc_count: this.ka.mapping.La(c.A, "min_doc_count"),
                    time_zone: this.ka.mapping.La(c.A, "time_zone"),
                    format: this.ka.mapping.La(c.A, "format", e.model.C.F.Lp)
                  };
                  this.ka.mapping.MH(c.A, "interval") ? d.interval = this.ka.mapping.La(c.A, "interval") : this.ka.mapping.MH(c.A, "fixed_interval") ? d.fixed_interval = this.ka.mapping.La(c.A, "fixed_interval") : d.calendar_interval = this.ka.mapping.La(c.A, "calendar_interval");
                  a.aggs[c.A].date_histogram = d;
                } else a.aggs[c.A].terms = {
                  field: c.A,
                  size: c.Vm
                };
              }
              zo(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                e.v(a.aggs) && (a.aggs = {});
                c.forEach(g => {
                  a.aggs[(d ? "total_" : "") + (g.aa + "_") + g.A] = {
                    [this.Nza(g)]: {
                      field: g.A
                    }
                  };
                });
              }
              Nza(a) {
                if (a.aa != k.i.da.Mq) {
                  if (a.aa == k.i.da.Bq) return "avg";
                  if (a.aa == k.i.da.zc) return "value_count";
                  if (a.aa == k.i.da.mj) return "cardinality";
                  if (a.aa == k.i.da.MIN) return "min";
                  if (a.aa == k.i.da.MAX) return "max";
                }
                return "sum";
              }
              Ip(a) {
                this.slice.ob.Pc().forEach(c => this.sL(a, c));
                this.slice.Db.Pc().forEach(c => this.sL(a, c));
                this.slice.xb.Pc().forEach(c => this.sL(a, c));
              }
              sL(a, c) {
                if (c.filter.Ei) {
                  this.$_(a);
                  const m = {
                    bool: {
                      should: []
                    }
                  };
                  for (var d = c.filter.yj(c.filter.v2), g = 0; g < d.length; g++) {
                    var l = c.za(d[g]);
                    m.bool.should.push(this.vL(c, l));
                  }
                  a.query.bool[c.filter.v2 ? "must_not" : "must"].push(m);
                } else if (c.filter.Ww || c.filter.LM || c.filter.xz) this.$_(a), d = {
                  bool: {
                    should: []
                  }
                }, c = c.filter.xz ? this.Eva(c) : this.Rva(c), d.bool.should.push(c), a.query.bool[c.isExclude ? "must_not" : "must"].push(d), delete c.isExclude;
              }
              Eva(a) {
                const c = {},
                  d = 0 <= k.i.bc.jy.indexOf(a.filter.query.ua) ? a.filter.query.iS(a.getTimezoneOffset()) : a.filter.query;
                if (k.i.bc.EQUAL === d.ua || k.i.bc.Pf === d.ua) {
                  var g = d.value;
                  c.range = {
                    [a.A]: {
                      gte: g.format("yyyy-MM-dd"),
                      lt: g.format("yyyy-MM-dd") + "||+1d/d"
                    }
                  };
                  c.isExclude = k.i.bc.Pf === d.ua;
                } else if (k.i.bc.SE === d.ua) c.range = {
                  [a.A]: {
                    lt: d.value.format("yyyy-MM-dd")
                  }
                }, c.isExclude = !1;else if (k.i.bc.TE === d.ua) c.range = {
                  [a.A]: {
                    lt: d.value.format("yyyy-MM-dd") + "||+1d/d"
                  }
                }, c.isExclude = !1;else if (k.i.bc.PE === d.ua) c.range = {
                  [a.A]: {
                    gte: d.value.format("yyyy-MM-dd") + "||+1d/d"
                  }
                }, c.isExclude = !1;else if (k.i.bc.QE === d.ua) c.range = {
                  [a.A]: {
                    gte: d.value.format("yyyy-MM-dd")
                  }
                }, c.isExclude = !1;else if (k.i.bc.fh === d.ua || k.i.bc.Og === d.ua) g = d.value[1], c.range = {
                  [a.A]: {
                    gte: d.value[0].format("yyyy-MM-dd"),
                    lte: g.format("yyyy-MM-dd")
                  }
                }, c.isExclude = k.i.bc.Og === d.ua;
                return c;
              }
              Rva(a) {
                const c = {},
                  d = a.filter.query;
                if (k.i.Cb.UE === d.ua || k.i.Cb.ZA === d.ua) c.prefix = {
                  [a.A]: d.value
                }, c.isExclude = k.i.Cb.ZA === d.ua;else if (k.i.Cb.EQUAL === d.ua || k.i.Cb.Pf === d.ua) c.match = {
                  [a.A]: d.value
                }, c.isExclude = k.i.Cb.Pf === d.ua;else if (k.i.Cb.NA === d.ua || k.i.Cb.aB === d.ua) c.wildcard = {
                  [a.A]: "*" + d.value
                }, c.isExclude = k.i.Cb.aB === d.ua;else if (k.i.Cb.Un === d.ua || k.i.Cb.$A === d.ua) c.wildcard = {
                  [a.A]: "*" + d.value + "*"
                }, c.isExclude = k.i.Cb.$A === d.ua;else if (k.i.Cb.GREATER === d.ua) c.range = {
                  [a.A]: {
                    gt: d.value
                  }
                }, c.isExclude = !1;else if (k.i.Cb.Xk === d.ua) c.range = {
                  [a.A]: {
                    gte: d.value
                  }
                }, c.isExclude = !1;else if (k.i.Cb.LESS === d.ua) c.range = {
                  [a.A]: {
                    lt: d.value
                  }
                }, c.isExclude = !1;else if (k.i.Cb.$k === d.ua) c.range = {
                  [a.A]: {
                    lte: d.value
                  }
                }, c.isExclude = !1;else if (k.i.Cb.fh === d.ua || k.i.Cb.Og === d.ua) c.range = {
                  [a.A]: {
                    gte: d.value[0],
                    lte: d.value[1]
                  }
                }, c.isExclude = k.i.Cb.Og === d.ua;
                return c;
              }
              vL(a, c) {
                if (a.type == k.i.Fc.Ta) {
                  let d = this.ka.mapping.La(a.A, "calendar_interval");
                  this.ka.mapping.MH(a.A, "interval") ? d = this.ka.mapping.La(a.A, "interval") : this.ka.mapping.MH(a.A, "fixed_interval") && (d = this.ka.mapping.La(a.A, "fixed_interval"));
                  return {
                    range: {
                      [a.A]: {
                        gte: c.fc,
                        lt: e.RK(new Date(c.fc), d).getTime()
                      }
                    }
                  };
                }
                return {
                  term: {
                    [a.A]: c.caption
                  }
                };
              }
            }
            f.dma = b;
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    var Pa;
    (function (e) {
      class k extends z.jk {
        constructor(f) {
          super();
          f || (f = {
            host: "http://localhost:9200"
          });
          this.host = "string" === typeof f.host ? new h(f.host) : h.zb(f.host);
          f.headers && (this.host.headers = f.headers);
          this.contentType = z.JA.k6;
          this.withCredentials = f.withCredentials;
        }
        OZ(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : q.model.B.j.HP;
          this.bja = () => {
            this.pb(v.ga.Qc, this.bja);
            f(null, JSON.parse(this.response));
          };
          this.N(v.ga.Qc, this.bja);
          this.Kca = () => {
            this.pb(v.ga.xa, this.Kca);
            let a = b;
            try {
              const c = JSON.parse(this.response);
              c && c.message ? a = c.message : c && c.error && c.error.reason && (a = c.error.reason);
            } catch (c) {}
            a = q.model.Tb.valid(a) ? a : q.model.Tb.validate(a);
            f({
              message: a
            }, null);
          };
          this.N(v.ga.xa, this.Kca);
        }
        search(f, b) {
          this.OZ(b);
          this.Br = z.Ft.Dv;
          this.Vh(this.host.headers);
          this.data = "string" === typeof f.body ? f.body : JSON.stringify(f.body);
          this.load(this.host.QU(`/${f.index}/_search`));
          this.data = null;
        }
        t1(f) {
          this.OZ(f, this.Ada());
          this.Br = z.Ft.FX;
          this.Vh(this.host.headers);
          this.load(this.host.QU("/_cat/indices?format=json"));
        }
        MAa(f, b) {
          this.OZ(b, this.Ada());
          this.Br = z.Ft.FX;
          this.Vh(this.host.headers);
          this.load(this.host.QU(`/${f}/_mapping`));
        }
        Ada() {
          const f = q.model.B.j.Goa;
          let b = this.host.QU();
          b = q.model.Tb.valid(b) ? b : q.model.Tb.validate(b);
          return q.P.bind(f, b);
        }
      }
      e.W6 = k;
      class h {
        constructor(f) {
          q.ia(f) || this.pda(f);
        }
        pda(f) {
          f = q.oIa(f);
          this.host = f.hostname;
          this.protocol = f.protocol;
          this.port = f.port;
          this.path = f.pathname;
        }
        QU() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          this.host && -1 < this.host.indexOf("http") && this.pda(this.host);
          var b = "";
          this.port !== h.pxa[this.protocol] && (b = ":" + this.port);
          var a = q.ia(this.path) ? "" : this.path;
          "/" !== a.charAt(0) && (a = "/" + a);
          var c = q.ia(this.protocol) ? "http" : this.protocol;
          b = this.host ? c + "://" + this.host + b + a : a;
          "/" == b.charAt(b.length - 1) && (b = b.substr(0, b.length - 1));
          return b + f;
        }
        static zb(f) {
          var b = new h();
          b.headers = f.headers;
          b.host = f.host;
          b.path = f.path;
          b.port = f.port;
          b.protocol = f.protocol;
          return b;
        }
      }
      h.pxa = {
        http: 80,
        https: 443
      };
    })(Pa || (Pa = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                if (null != b.instance) throw Error("Singleton");
              }
              static R() {
                null == b.instance && (b.instance = new b());
                return b.instance;
              }
              static dispose() {
                b.instance = null;
              }
              t1(a, c) {
                new Pa.W6(a).t1((d, g) => {
                  if (d) return e.Wa(d.message, e.model.B.j.xa, e.tb.xa), c(d, g);
                  if (e.v(g)) return console.warn("ESConnector: empty response"), c(d, g);
                  d = g.map(l => l.index).filter(l => 0 > l.indexOf(".kibana") && 0 > l.indexOf(".security"));
                  c(null, d);
                });
              }
            }
            f.Yla = b;
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.va = k.Ma.R();
                this.ta = this.va.ta;
              }
              load(a, c, d, g) {
                this.ka = a;
                this.query = c;
                this.Mb = d;
                this.bb = g;
                this.ka.Nw(l => {
                  this.Fo = l;
                  this.jx();
                });
              }
              z5(a, c, d) {
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                for (var l in c) {
                  var m = this.va.O.ph(l),
                    n = Math.ceil(m.Vm / b.OJ);
                  if (1 == n) m = u.Nc.LG(c), delete m[l], this.z5(a, m, d);else for (var p = 0; p < n; p++) c[l].forEach(t => {
                    t.include = {
                      partition: p,
                      num_partitions: n
                    };
                  }), d.push(JSON.stringify(a)), m = u.Nc.LG(c), delete m[l], this.z5(a, m, d);
                  if (g) break;
                }
                return d;
              }
              fda(a, c) {
                for (var d in a) {
                  var g = this.va.O.ph(d);
                  e.v(g) || (e.v(a[d].terms) || (e.v(c[d]) && (c[d] = []), c[d].push(a[d].terms)), a[d].aggs && this.fda(a[d].aggs, c));
                }
                return c;
              }
              jx() {
                e.Da(!0, e.model.B.j.jg);
                if (this.query.type == k.i.$d.ho) {
                  var a = this.fda(this.query.body.aggs, {}),
                    c = this.z5(this.query.body, a, [], !0);
                  0 == c.length && c.push(JSON.stringify(this.query.body));
                  var d = new u.mB();
                  c.forEach((g, l) => {
                    d.add(m => this.U2(g, l, c.length, m));
                  });
                  d.Xe(() => {
                    null != this.Mb && this.Mb();
                    e.Da(!1);
                  });
                } else Array.isArray(this.query.body) ? (d = new u.mB(), this.query.body.forEach(g => {
                  d.add(l => this.U2(g, 0, 0, l));
                }), d.Xe(() => {
                  null != this.Mb && this.Mb();
                  e.Da(!1);
                })) : this.U2(this.query.body, 0, 0, () => {
                  null != this.Mb && this.Mb();
                  e.Da(!1);
                });
              }
              U2(a, c, d, g) {
                0 < c && e.Da(!0, e.model.B.j.jg, (c / d * 100).toFixed(0) + "%");
                this.Fo.search({
                  index: this.ka.index,
                  body: a
                }, (l, m) => {
                  if (l) return this.Sb(l.message, this.bb), g();
                  l = this.va.pa.xb.Pc();
                  var n = this.va.pa.Db.Pc();
                  this.query.type == k.i.$d.ho && (this.va.pa.kf || (l = l.slice(0, 1)), this.va.pa.jf || (n = n.slice(0, 1)));
                  var p = this.va.pa.gd();
                  this.p4(m.aggregations, l.concat(n), p, 0, [], []);
                  0 < n.length && this.Qga(m.aggregations, n.concat(l), p, 0, [], []);
                  g();
                });
              }
              p4(a, c, d, g, l, m) {
                const n = c[g];
                if (n && a.hasOwnProperty(n.A)) a[n.A].buckets.forEach(t => {
                  var r = null;
                  n.type == k.i.Fc.Ta && (r = n.Du(t.key));
                  e.v(r) && (r = n.Ib(t.key_as_string || "" + t.key));
                  const w = l.slice(),
                    y = m.slice();
                  r && this.va.pa.rows.Bb(n.A) ? w.push(r.ordinal) : r && y.push(r.ordinal);
                  this.xea(t, d) ? (r = d.map(A => this.u4(t, A)), this.ta.insert(w, y, r)) : this.p4(t, c, d, g + 1, w, y);
                });else if (g < c.length) {
                  var p = l.slice();
                  const t = m.slice();
                  this.va.pa.rows.Bb(n.A) ? p.push(null) : t.push(null);
                  this.p4(a, c, d, g + 1, p, t);
                }
                p = d.map(t => this.u4(a, t, !0));
                this.ta.kA(l, m, p);
              }
              u4(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                if (0 == a.doc_count) return c.aa == k.i.da.zc || c.aa == k.i.da.mj ? 0 : NaN;
                c = (d ? "total_" : "") + c.aa + "_" + c.A;
                return e.v(a[c]) ? NaN : a[c].value;
              }
              Qga(a, c, d, g, l, m) {
                const n = c[g];
                e.v(a[n.A]) || a[n.A].buckets.forEach(p => {
                  const t = k.i.Fc.Ta == n.type ? n.Ib("" + p.key) : n.Ib(p.key_as_string || "" + p.key),
                    r = l.slice(),
                    w = m.slice();
                  this.va.pa.rows.Bb(n.A) ? r.push(t.ordinal) : w.push(t.ordinal);
                  let y;
                  this.xea(p, d, !0) && (y = d.map(A => this.u4(p, A, !0)));
                  this.ta.kA(r, w, y);
                  g < c.length - 2 && this.Qga(p, c, d, g + 1, r, w);
                });
              }
              RT(a, c) {
                return c && a.hasOwnProperty(c.A);
              }
              xea(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                return (c = c[0]) && a.hasOwnProperty((d ? "total_" : "") + c.aa + "_" + c.A);
              }
              bd(a, c, d, g, l, m, n) {
                e.Da(!0, e.model.B.j.jg, e.model.B.j.jg);
                a.Nw(p => {
                  this.Fo = p;
                  this.Fo.search({
                    index: a.index,
                    body: c.body
                  }, (t, r) => {
                    if (t) return this.Sb(t.message, n);
                    var w = r.hits.hits.map(A => A._source),
                      y = c.body._source;
                    w.forEach((A, B) => {
                      w[B] = y.map(C => u.Nc.resolve(C, A));
                    });
                    w.unshift(y);
                    m(w);
                  });
                });
              }
              cancel() {
                this.Fo && this.ka && !this.ka.connection && this.Fo.close();
                this.bb = this.Mb = this.ka = this.va = this.Fo = null;
              }
              Sb(a, c) {
                console.error(a);
                e.Da(!1);
                e.Wa(a, e.model.B.j.xa, e.tb.xa);
                e.Kg(c) && c(a);
              }
            }
            b.OJ = 5E4;
            f.Zla = b;
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.vX {
              La(a, c, d) {
                a = this.ts(a, c);
                d = this.di(d);
                return e.v(this.values[a]) ? NaN : e.v(this.values[a][d]) ? NaN : this.values[a][d];
              }
              kA(a, c, d) {
                a = this.ts(a, c);
                e.v(this.values[a]) && (this.values[a] = d);
              }
              Rg(a, c) {
                return null == a || 0 == a.length ? NaN : this.Hc[c][a[0]];
              }
              bea(a, c) {
                var d = a.slice(0);
                a = a.indexOf(null);
                0 < a && (d.length = a);
                d[d.length - 1] = 0;
                return this.ld(d, c);
              }
              insert(a, c, d) {
                for (; a.length < this.Uh.length;) a.push(null);
                for (; c.length < this.wk.length;) c.push(null);
                var g = a.concat(c);
                if (!(-1 < g.indexOf(0))) {
                  if (0 == this.vb.length) for (var l = 0; l < g.length; l++) this.vb[l] = [];
                  (l = this.bea(a, this.Bd)) && l[0] && l[0].push(this.Nx);
                  (l = this.bea(c, this.Od)) && l[0] && l[0].push(this.Nx);
                  this.mh = e.Ja.Hr(this.mh, this.Nx);
                  for (l = 0; l < g.length; l++) this.vb[l] = e.Ja.Hr(this.vb[l], g[l]);
                  if (0 == this.Hc.length) for (l = 0; l < d.length; l++) this.Hc[l] = [];
                  for (l = 0; l < d.length; l++) this.Hc[l] = e.Ja.Hr(this.Hc[l], d[l]);
                  this.values[this.ts(a, c)] = d;
                }
              }
              filter() {}
            }
            f.$la = b;
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.pm {
              constructor() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                super(a);
                this.uu = {};
                this.uu.calendar_interval = "day";
                this.uu.min_doc_count = 1;
                this.uu.filters = !0;
              }
            }
            f.UO = b;
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(a) {
                this.va = k.Ma.R();
                this.OJ = 1E5;
                this.ka = a;
              }
              load(a, c, d, g) {
                this.Mb = c;
                this.Pe = g;
                this.bb = d;
                e.Da(!0, e.model.B.j.rF);
                a.Nw(l => {
                  this.Fo = l;
                  this.c3();
                });
              }
              c3() {
                this.Fo.MAa(this.ka.index, (a, c) => {
                  if (a) return this.Sb(a.message, this.bb);
                  e.Kg(this.Pe) && this.Pe();
                  for (var d in c) {
                    a = c[d].mappings;
                    for (var g in a) "properties" == g ? this.mI(a[g]) : this.mI(a[g].properties);
                  }
                  this.wr();
                });
              }
              mI(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
                let l = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
                for (var m in a) if (this.ka.mapping.La(d + m, "visible", !0)) {
                  var n = a[m];
                  if (this.BCa(n)) {
                    var p = c ? c : this.cu(m, m);
                    this.mI(n.properties, p, d + m + ".", g, l + m + "/");
                  } else if (this.rg(n)) {
                    p = c ? c : this.cu(m, m);
                    p = this.wi(p, d + m, m, n, l);
                    var t = this.rk(d + m, m, n);
                    this.va.O.TK(t.A, p.A);
                  } else if (this.Bf(n)) {
                    p = c ? c : this.cu(m, m);
                    t = m;
                    var r = !e.ia(g);
                    r && (t = "keyword" == m ? g : g + " (" + m + ")");
                    p = this.wi(p, d + m, t, n, l);
                    r && (p.hfa = !0, p.Nga = d.substr(0, d.length - 1));
                    t = this.rk(d + m, t, n);
                    this.va.O.TK(t.A, p.A);
                  }
                  e.v(n.fields) || (p = c ? c : this.cu(m, m), this.mI(n.fields, p, d + m + ".", m, l + m + "/"));
                }
              }
              cu(a, c) {
                var d = this.va.O.Sp(a);
                e.v(d) && (c = this.ka.mapping.La(a, "caption", c), d = new f.O.ama(a, c), this.va.O.cu(d));
                return d;
              }
              wi(a, c, d, g) {
                let l = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                var m = a.ph(c);
                e.v(m) && (d = this.ka.mapping.La(c, "caption", d), m = new f.O.bma(c, d), m.type = k.i.Fc.U0(g.type), m.inputType = g.type, a.wi(m), e.ia(l) ? m.Oc = a.caption : ("/" == l.charAt(l.length - 1) && (l = l.substr(0, l.length - 1)), m.Oc = l), a = new f.O.p7(c, c, 1), m.type == k.i.Fc.Ta ? a.type = k.i.ib.Lc : m.type == k.i.Fc.qp && (a.type = k.i.ib.jb), m.Mh(a));
                return m;
              }
              rk(a, c, d) {
                var g = this.va.O.fd(a);
                e.v(g) && (c = this.ka.mapping.La(a, "caption", c), g = new f.O.q7(a, c), g.type = k.i.Qa.U0(d.type), g.Wc = this.ka.mapping.La(a, "aggregations"), this.va.O.rk(g));
                return g;
              }
              rg(a) {
                return 0 <= k.i.Qa.RL.indexOf(a.type);
              }
              BCa(a) {
                return !e.v(a.properties);
              }
              Bf(a) {
                return 0 <= k.i.Fc.RL.indexOf(a.type);
              }
              wr() {
                e.Da(!1);
                null != this.Mb && this.Mb();
              }
              ol(a, c, d) {
                e.Da(!0, e.model.B.j.ao, a.caption);
                a.type == k.i.Fc.Ta ? this.IDa(a, g => {
                  if (g) return this.Sb(g, d);
                  a.Rd = !0;
                  e.Da(!1);
                  c(a);
                }) : this.xwa(a, (g, l) => {
                  if (g) return this.Sb(g, d);
                  0 == l ? (a.Rd = !0, c(a)) : this.Sfa(a, 0, Math.ceil(l / this.OJ), l, m => {
                    if (m) return this.Sb(m, d);
                    a.Rd = !0;
                    e.Da(!1);
                    c(a);
                  });
                });
              }
              xwa(a, c) {
                a = {
                  size: 0,
                  aggs: {
                    count: {
                      cardinality: {
                        field: a.A
                      }
                    }
                  }
                };
                e.v(this.ka.Ze) || (a.query = u.Nc.vj(this.ka.Ze));
                this.Fo.search({
                  index: this.ka.index,
                  body: a
                }, (d, g) => {
                  if (d) return c(d.message);
                  c(null, g.aggregations.count.value);
                });
              }
              Sfa(a, c, d, g, l) {
                var m = {
                  size: 0,
                  aggs: {
                    [a.A]: {
                      terms: {
                        field: a.A,
                        include: {
                          partition: c,
                          num_partitions: d
                        },
                        size: 2 * this.OJ
                      }
                    }
                  }
                };
                e.v(this.ka.Ze) || (m.query = u.Nc.vj(this.ka.Ze));
                this.Fo.search({
                  index: this.ka.index,
                  body: m
                }, (n, p) => {
                  if (n) return l(n.message);
                  n = p.aggregations[a.A].buckets;
                  for (p = 0; p < n.length; p++) this.oc(a, n[p].key_as_string || n[p].key, n[p].key);
                  c < d - 1 ? (e.Da(!0, e.model.B.j.ao, e.P.bind("{0}: {1} of {2} loaded", a.caption, (c + 1) * this.OJ, g)), this.Sfa(a, c + 1, d, g, l)) : l();
                });
              }
              IDa(a, c) {
                var d = {
                  field: a.A,
                  min_doc_count: this.ka.mapping.La(a.A, "min_doc_count"),
                  time_zone: this.ka.mapping.La(a.A, "time_zone"),
                  format: this.ka.mapping.La(a.A, "format", e.model.C.F.Lp)
                };
                this.ka.mapping.MH(a.A, "interval") ? d.interval = this.ka.mapping.La(a.A, "interval") : this.ka.mapping.MH(a.A, "fixed_interval") ? d.fixed_interval = this.ka.mapping.La(a.A, "fixed_interval") : d.calendar_interval = this.ka.mapping.La(a.A, "calendar_interval");
                d = {
                  size: 0,
                  aggs: {
                    [a.A]: {
                      date_histogram: d
                    }
                  }
                };
                e.v(this.ka.Ze) || (d.query = u.Nc.vj(this.ka.Ze));
                this.Fo.search({
                  index: this.ka.index,
                  body: d
                }, (g, l) => {
                  if (g) return c(g.message);
                  g = l.aggregations[a.A].buckets;
                  for (l = 0; l < g.length; l++) this.oc(a, g[l].key_as_string, g[l].key);
                  c();
                });
              }
              oc(a, c, d) {
                "string" != typeof c && (c = "" + c);
                const g = "number" === typeof d ? d : null;
                let l = a.type !== k.i.Fc.Ta ? a.Ib(c) : a.Du(g);
                null == l ? (c = a.type == k.i.Fc.Ta ? new k.O.ae({
                  A: String(g),
                  caption: c,
                  fc: g
                }) : new k.O.ae({
                  A: c,
                  fc: g
                }), l = a.oc(c)) : l.fc != d && a.type == k.i.Fc.Ta && (l = a.oc(new k.O.ae({
                  A: `${c}-${d}`,
                  caption: c,
                  fc: g
                })));
                return l;
              }
              Ik(a, c, d, g) {
                this.ol(a, d, g);
              }
              Lz() {
                throw "Not Implemented";
              }
              uq() {
                throw "Not Implemented";
              }
              iC() {
                return !1;
              }
              cancel() {
                this.Fo && this.ka && !this.ka.connection && this.Fo.close();
                this.Pe = this.bb = this.Mb = this.ka = this.va = this.Fo = null;
              }
              Sb(a, c) {
                console.error(a);
                e.Da(!1);
                e.Wa(a, e.model.B.j.xa, e.tb.xa);
                e.Kg(c) && c(a);
              }
            }
            f.fma = b;
          })(h.Se || (h.Se = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.O.ut {
              constructor() {
                super();
                this.index = this.url = null;
                this.Yo = !1;
                this.mapping = new f.yO();
                this.dia = "2.8.5";
                this.ww = !1;
                this.Ba = k.i.qa.API;
              }
              isEqual(a) {
                return super.isEqual(a) && this.url == a.url && this.index == a.index && this.Yo == a.Yo && this.ww == a.ww && this.mapping.isEqual(a.mapping);
              }
              get RH() {
                return !0;
              }
              static zb(a) {
                var c = new b();
                e.v(a.url) || "" == a.url || (c.url = a.url);
                e.v(a.index) || (c.index = a.index.toString());
                e.v(a.requestHeaders) || (c.uc = a.requestHeaders);
                e.v(a.mapping) || (c.mapping = a.mapping instanceof f.yO ? a.mapping : new f.yO(a.mapping));
                e.v(a.withCredentials) || (c.withCredentials = a.withCredentials);
                e.v(a.singleEndpoint) || (c.Yo = a.singleEndpoint);
                e.v(a.concurrentRequests) || (c.ww = a.concurrentRequests);
                return c;
              }
              Sa() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = {};
                c.type = this.Ba;
                e.v(this.url) || (c.url = this.url);
                e.v(this.index) || (c.index = this.index);
                if (a || this.Yo) c.singleEndpoint = this.Yo;
                if (!this.mapping.kb || this.mapping.Po) c.mapping = this.mapping.Sa(!0);
                if (a || this.withCredentials) c.withCredentials = this.withCredentials;
                if (a || this.ww) c.concurrentRequests = this.ww;
                return c;
              }
              Nw() {
                return new f.zA({
                  url: this.url,
                  Yo: this.Yo,
                  uc: this.uc,
                  withCredentials: this.withCredentials
                });
              }
              clone() {
                var a = new b();
                a.Ba = this.Ba;
                e.v(this.url) || (a.url = this.url);
                e.v(this.index) || (a.index = this.index);
                e.v(this.Yo) || (a.Yo = this.Yo);
                if (!this.mapping.kb || this.mapping.Po) a.mapping = this.mapping.clone(this.Ba);
                this.withCredentials && (a.withCredentials = this.withCredentials);
                this.ww && (a.ww = this.ww);
                return a;
              }
            }
            f.g6 = b;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.AA {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                }
              }
              b.RLa = a;
            })(f.O || (f.O = {}));
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.local.O.wP {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                  this.Wu = !1;
                }
                hD() {
                  return new b.aka(this);
                }
                get P1() {
                  return e.Kg(this.nx) || this.Wu;
                }
                sW(c, d) {
                  return this.Wu ? 0 < c.t_.length ? this.BKa(c.t_.slice()) : this.CKa(c.children) : super.sW(c, d);
                }
                BKa(c) {
                  return this.Lh === k.i.Aa.kc ? c : this.Lh === k.i.Aa.Mc ? c.reverse() : c;
                }
                CKa(c) {
                  this.Lh === k.i.Aa.kc && e.Ja.sort(c, e.Ja.Qi);
                  this.Lh === k.i.Aa.Mc && e.Ja.sort(c, e.Ja.lp | e.Ja.Qi);
                  return c;
                }
                clone() {
                  var c = super.clone();
                  c.Wu = this.Wu;
                  return c;
                }
                get Rd() {
                  return this.GB;
                }
                set Rd(c) {
                  this.GB = c;
                }
              }
              b.xO = a;
            })(f.O || (f.O = {}));
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.local.O.xP {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                  super(c, d, g);
                }
              }
              b.$ja = a;
            })(f.O || (f.O = {}));
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.Or {
                constructor(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                  super(c, d);
                  this.kG = [];
                  this.Vv = void 0;
                }
                get jc() {
                  return e.model.Tb.valid(this.xc) ? this.xc : e.model.Tb.validate(this.xc);
                }
                get caption() {
                  if (0 == e.model.C.F.Fx) return this.jc;
                  switch (this.aa) {
                    case k.i.da.Mq:
                      return e.P.bind(e.model.B.j.aK, this.jc);
                    case k.i.da.zc:
                      return e.P.bind(e.model.B.j.FO, this.jc);
                    case k.i.da.Bt:
                      return e.P.bind(e.model.B.j.QP, this.jc);
                    case k.i.da.mj:
                      return e.P.bind(e.model.B.j.PO, this.jc);
                    case k.i.da.Bq:
                      return e.P.bind(e.model.B.j.AO, this.jc);
                    case k.i.da.Av:
                      return e.P.bind(e.model.B.j.QX, this.jc);
                    case k.i.da.Gv:
                      return e.P.bind(e.model.B.j.ZP, this.jc);
                    case k.i.da.Hv:
                      return e.P.bind(e.model.B.j.$P, this.jc);
                    case k.i.da.MAX:
                      return e.P.bind(e.model.B.j.AP, this.jc);
                    case k.i.da.MIN:
                      return e.P.bind(e.model.B.j.JP, this.jc);
                    case k.i.da.Vr:
                      return e.P.bind(e.model.B.j.VJ, this.jc);
                    case k.i.da.tp:
                      return e.P.bind(e.model.B.j.PJ, this.jc);
                    case k.i.da.Kq:
                      return e.P.bind(e.model.B.j.UJ, this.jc);
                    case k.i.da.Iq:
                      return e.P.bind(e.model.B.j.SJ, this.jc);
                    case k.i.da.Jq:
                      return e.P.bind(e.model.B.j.TJ, this.jc);
                    case k.i.da.Pi:
                      return e.P.bind(e.model.B.j.DJ, this.jc);
                    case k.i.da.jn:
                      return e.P.bind(e.model.B.j.SP, this.jc);
                    case k.i.da.fo:
                      return e.P.bind(e.model.B.j.UP, this.jc);
                    case k.i.da.Xn:
                      return e.P.bind(e.model.B.j.iJ, this.jc);
                    case k.i.da.fn:
                      return e.P.bind(e.model.B.j.jJ, this.jc);
                    case k.i.da.co:
                      return e.P.bind(e.model.B.j.QJ, this.jc);
                    case k.i.da.hn:
                      return e.P.bind(e.model.B.j.RJ, this.jc);
                    case k.i.da.NONE:
                      return this.jc;
                  }
                  return -1 < k.i.da.IO.indexOf(this.aa) ? `${this.jc} (${this.aa})` : e.P.bind(e.model.B.j.aK, this.jc);
                }
                set Xp(c) {
                  this.Tv = c;
                }
                get Xp() {
                  return -1 < k.i.da.IO.indexOf(this.lk) ? `${this.jc} (${this.lk})` : super.Xp;
                }
                set caption(c) {
                  this.xc = c;
                }
                get rl() {
                  return this.xc;
                }
                set rl(c) {}
                get dk() {
                  return this.kG;
                }
                set dk(c) {
                  this.kG = [];
                  if (!e.v(c)) for (var d = 0; d < c.length; d++) if ("string" == typeof c[d]) {
                    var g = c[d].trim().toLowerCase();
                    k.i.da.az(g) && (g = k.i.da.mz(g));
                    k.i.da.tA(g) && this.kG.push(g);
                  }
                }
                set Wc(c) {
                  if (e.v(c)) this.mn = this.dk, this.type == k.i.Qa.jb && 0 < this.mn.length && (this.mn = this.mn.concat(k.i.da.yA));else {
                    for (var d = [], g = 0; g < c.length; g++) {
                      var l = c[g].trim().toLowerCase();
                      k.i.da.az(l) && (l = k.i.da.mz(l));
                      (-1 !== this.dk.indexOf(l) || this.type == k.i.Qa.jb && -1 !== k.i.da.yA.indexOf(l)) && d.push(l);
                    }
                    this.mn = 0 < d.length ? d : this.dk;
                  }
                  this.Vv = void 0;
                  this.OBa(this.mn) || (this.mn = []);
                }
                get Wc() {
                  return !1 === this.Vv || 0 < this.mn.length ? this.mn : this.dk;
                }
                OBa(c) {
                  if (void 0 === this.Vv) {
                    this.Vv = !1;
                    for (var d = 0; d < c.length; d++) if (k.i.da.aU(c[d])) {
                      this.Vv = !0;
                      break;
                    }
                  }
                  return this.Vv;
                }
                R1() {
                  var c = new a("", "");
                  return this.De != c.De || this.format != c.format || 0 == this.Pm ? !1 : !0;
                }
                clone() {
                  var c = new a(this.A);
                  this.zL(c);
                  void 0 != this.kG && (c.kG = this.kG.slice());
                  void 0 != this.Vv && (c.Vv = this.Vv);
                  return c;
                }
              }
              b.j6 = a;
            })(f.O || (f.O = {}));
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.aJ {
                constructor() {
                  super(...arguments);
                  this.t_ = [];
                }
                get Sh() {
                  return this.level.Su ? !0 : !(this.Yg || this.zf) && 0 === this.children.length;
                }
              }
              b.aka = a;
            })(f.O || (f.O = {}));
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.local.O.yP {
                constructor() {
                  super();
                  this.hH = new b.Tn();
                }
                Jo(c, d) {
                  return new b.xO(c, d);
                }
                Yda(c, d) {
                  return new b.j6(c, d);
                }
                Zl(c, d, g) {
                  return new b.$ja(c, d, g);
                }
                mx(c) {
                  let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                  var l = d ? d : new b.j6(c.uniqueName);
                  return super.mx(c, l, e.v(d) || g);
                }
              }
              b.WI = a;
            })(f.O || (f.O = {}));
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends k.O.WW {
                constructor() {
                  super(...arguments);
                  this.Y9 = !1;
                }
                get YK() {
                  return this.Y9;
                }
                set YK(c) {
                  this.Y9 = c;
                }
                Iaa(c, d) {
                  e.v(this.yB) && (this.yB = new e.ub());
                  this.yB.Ua(c, d);
                }
                iea(c, d) {
                  let g = void 0;
                  if (!e.v(this.yB)) {
                    const l = k.i.Fc.oA(c.type);
                    this.yB.Bb(l) ? g = this.lS(this.yB.getItem(l), d) : this.yB.Bb(k.i.input.sa.VI) && (g = this.lS(this.yB.getItem(k.i.input.sa.VI), d));
                  }
                  return !e.v(this.xy) && this.xy.Bb(c.A) ? (c = this.lS(this.xy.getItem(c.A), d), void 0 !== g && c.merge(g), c) : g ? g : this.YK ? this.rH(d) : null;
                }
              }
              a.LH = !1;
              b.Tn = a;
            })(f.O || (f.O = {}));
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.interval = this.A = void 0;
              }
            }
            f.SLa = b;
            class a {
              constructor() {
                this.Fk = void 0;
                this.ZOa = null;
              }
            }
            f.TLa = a;
            class c {
              constructor(d) {
                this.rows = {};
                this.Ka = {};
                this.values = {};
                this.filters = {};
                this.slice = d;
              }
              select() {
                var d = this.wC(k.i.ha.Ia),
                  g = this.wC(k.i.ha.Ra),
                  l = this.eS(),
                  m = this.Ip(),
                  n = {
                    aggs: {}
                  };
                !m || Array.isArray(m) && 0 === m.length || (n.filter = m);
                if (0 < d.length || 0 < g.length) n.aggs = {
                  by: {}
                }, 0 < d.length && (n.aggs.by.rows = d), 0 < g.length && (n.aggs.by.cols = g);
                n.aggs.values = l;
                return n;
              }
              MJa() {
                var d = this.wC(k.i.ha.Ia),
                  g = this.eS(),
                  l = this.Ip(!1),
                  m = {
                    aggs: {}
                  };
                !l || Array.isArray(l) && 0 === l.length || (m.filter = l);
                m.fields = d;
                m.aggs.values = g;
                return m;
              }
              Ae(d, g) {
                var l = this.wC(k.i.ha.Ia),
                  m = this.wC(k.i.ha.Ra),
                  n = this.eS(),
                  p = this.Ip();
                d = {
                  type: k.i.$d.Vx,
                  axisName: d,
                  dataKeys: g,
                  aggs: {}
                };
                !p || Array.isArray(p) && 0 === p.length || (d.filter = p);
                if (0 < l.length || 0 < m.length) d.aggs = {
                  by: {}
                }, 0 < l.length && (d.aggs.by.rows = l), 0 < m.length && (d.aggs.by.cols = m);
                0 < n.length && (d.aggs.values = n);
                return d;
              }
              expand(d, g) {
                var l = this.wC(k.i.ha.Ia),
                  m = this.wC(k.i.ha.Ra),
                  n = this.eS(),
                  p = this.Ip();
                d = {
                  type: k.i.$d.gF,
                  axisName: d,
                  dataKeys: g,
                  aggs: {}
                };
                !p || Array.isArray(p) && 0 === p.length || (d.filter = p);
                if (0 < l.length || 0 < m.length) d.aggs = {
                  by: {}
                }, 0 < l.length && (d.aggs.by.rows = l), 0 < m.length && (d.aggs.by.cols = m);
                0 < n.length && (d.aggs.values = n);
                return d;
              }
              bd(d, g) {
                let l = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                return l ? this.aya(d) : this.w0(d, g);
              }
              aya(d) {
                d = this.Hva(d);
                var g = this.Ip(),
                  l = {};
                l.limit = e.model.C.F.ZG;
                !g || Array.isArray(g) && 0 === g.length || (l.filter = g);
                l.fields = d;
                return l;
              }
              w0(d, g) {
                var l,
                  m = [];
                const n = this.slice.yc(!1, !0, !0, !0).Pc();
                var p = [];
                for (let y = 0; y < d.length; y++) {
                  var t = {
                      uniqueName: d[y]
                    },
                    r = n.find(A => A.A === d[y]);
                  if (r) {
                    var w = r.wa.ea(1);
                    this.RK(w, r.interval, t);
                  }
                  m.push(t);
                  if (void 0 !== g[d[y]]) {
                    r = {};
                    r.field = {
                      uniqueName: d[y]
                    };
                    t = g[d[y]];
                    let A = null !== (l = w.inputType) && void 0 !== l ? l : w.type;
                    k.i.ib.sU(A) && !isNaN(t) && null !== t ? t = +t : w.type === k.i.ib.$c && (t = "" + t);
                    r.include = [{
                      member: t
                    }];
                    p.push(r);
                  }
                }
                e.v(this.filters) || p.push(...this.Iva());
                g = {};
                g.limit = e.model.C.F.ZG;
                0 < p.length && (g.filter = p);
                g.fields = m;
                return g;
              }
              Hva(d) {
                const g = [],
                  l = this.slice.Yc.yc(!1).Pc();
                for (var m = 0; m < d.length; m++) {
                  const p = {
                    uniqueName: d[m]
                  };
                  var n = l.find(t => t.A === d[m]);
                  n && this.RK(n.wa.ea(1), n.interval, p);
                  g.push(p);
                }
                return g;
              }
              wC(d) {
                const g = [],
                  l = this.slice.yc(!1, !0, !0, !0).Pc();
                d = d === k.i.ha.Ia ? this.rows : this.Ka;
                for (var m = 0; m < l.length; m++) {
                  const t = l[m].A;
                  if (void 0 !== d[t]) if (0 === d[t].length) {
                    var n = {
                      uniqueName: t
                    };
                    this.RK(l[m].wa.ea(1), l[m].interval, n);
                    g.push(n);
                  } else for (n = 0; n < l[m].wa.length; n++) {
                    var p = l[m].wa.ea(n).A;
                    -1 !== d[t].indexOf(p) && g.push({
                      uniqueName: p
                    });
                  }
                }
                return g;
              }
              RK(d, g, l) {
                if (d.type === k.i.ib.Ta || d.type === k.i.ib.Lc) l.interval = g;
              }
              eS() {
                let d = [];
                for (let g in this.values) for (let l = 0; l < this.values[g].length; l++) d.push({
                  func: this.values[g][l],
                  field: {
                    uniqueName: g
                  }
                });
                return d;
              }
              sL(d) {
                var g = d.A,
                  l = d.Bf ? d.wa.ea(1).A : g,
                  m = {};
                m.field = {
                  uniqueName: l
                };
                if (void 0 !== this.filters[g].query) if (f.O.Tn.LH) Array.isArray(this.filters[g].query) ? m = {
                  type: "or",
                  value: this.filters[g].query
                } : m.query = this.filters[g].query;else if (d.Bf) {
                  var n = Object.keys(this.filters[g].query)[0];
                  k.i.rb.Kea(d.wa.ea(1).type, n) && (m.query = this.filters[g].query);
                } else m.query = this.filters[g].query;
                void 0 !== this.filters[g].value && (m.value = this.filters[g].value);
                if (void 0 !== this.filters[g].include) {
                  n = [];
                  for (var p = 0; p < this.filters[g].include.length; p++) n.push(this.filters[g].include[p]);
                  m.query ? m = {
                    type: "or",
                    value: [m, {
                      field: {
                        uniqueName: l
                      },
                      include: n
                    }]
                  } : m.include = n;
                }
                if (void 0 !== this.filters[g].exclude) {
                  n = [];
                  for (p = 0; p < this.filters[g].exclude.length; p++) n.push(this.filters[g].exclude[p]);
                  m.query ? m = {
                    type: "and",
                    value: [m, {
                      field: {
                        uniqueName: l
                      },
                      exclude: n
                    }]
                  } : m.exclude = n;
                }
                if (void 0 !== this.filters[g].intersect) if (f.O.Tn.LH) void 0 !== m.include ? m = {
                  type: "and",
                  value: [{
                    field: {
                      uniqueName: l
                    },
                    include: this.filters[g].intersect
                  }, {
                    field: {
                      uniqueName: l
                    },
                    include: this.filters[g].include
                  }]
                } : void 0 !== m.query || void 0 !== m.exclude || void 0 === m.field ? m = {
                  type: "and",
                  value: [{
                    field: {
                      uniqueName: l
                    },
                    include: this.filters[g].intersect
                  }, m]
                } : m.include = this.filters[g].intersect;else {
                  l = {};
                  l.field = {
                    uniqueName: d.Bf ? d.wa.ea(1).A : g
                  };
                  l.include = [this.filters[g].intersect[0]];
                  if (void 0 !== m.include || void 0 !== m.exclude || void 0 !== m.query) l.include[0].filter = m;
                  m = l;
                }
                return m;
              }
              Iva() {
                for (var d = [], g = this.slice.yc(!1, !0, !0).Pc(), l = 0; l < g.length; l++) if (void 0 !== this.filters[g[l].A]) {
                  var m = {};
                  if (this.filters[g[l].A].intersect) m.include = this.filters[g[l].A].intersect;else if (this.filters[g[l].A]) {
                    var n = Object.keys(this.filters[g[l].A]),
                      p = n[0];
                    m[p] = this.filters[g[l].A][p];
                    n[1] && (p = n[1], m[p] = this.filters[g[l].A][p]);
                  } else continue;
                  m.field = {
                    uniqueName: g[l].Bf ? g[l].wa.ea(1).A : g[l].A
                  };
                  d.push(m);
                }
                return d;
              }
              Ip() {
                let d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                for (var g = [], l = this.slice.yc(!1, !0, !0).Pc(), m = 0; m < l.length; m++) {
                  var n = l[m];
                  this.SZ(n, !1, !1, d);
                  void 0 !== this.filters[n.A] && g.push(this.sL(n));
                }
                if (!f.O.Tn.LH) return g;
                if (0 < g.length) return {
                  type: "and",
                  value: g
                };
              }
              xm(d, g) {
                this.Ey(this.rows, d, g);
              }
              oo(d, g) {
                this.Ey(this.Ka, d, g);
              }
              Ey(d, g, l) {
                var m = g.A;
                void 0 === d[m] && (d[m] = []);
                var n = this.slice.rows.Bb(g.A),
                  p = this.slice.Ka.Bb(g.A);
                n = this.slice.gf && n || this.slice.Tf && p;
                if (void 0 === l && g.Bf) {
                  if (null != g.lc || n) {
                    for (l = 1; l < g.wa.length && (p = g.wa.ea(l), -1 === d[m].indexOf(p.A) && d[m].push(p.A), p != g.lc || n); l++);
                    return;
                  }
                  l = g.wa.ea(1);
                }
                void 0 !== l && (g = l.A, -1 === d[m].indexOf(g) && d[m].push(g));
              }
              Faa(d) {
                d.forEach(g => {
                  this.xm(g);
                });
              }
              taa(d) {
                d.forEach(g => {
                  this.oo(g);
                });
              }
              UK(d) {
                if ("" !== d.Bm) {
                  var g = d.A,
                    l = d.Bm;
                  void 0 === this.values[g] && (this.values[g] = []);
                  d.Oa || -1 !== this.values[g].indexOf(l) || this.values[g].push(l);
                }
              }
              dta(d, g) {
                void 0 === this.filters[d.A] && (this.filters[d.A] = {});
                d.filter.xz && (g.query = g.query.iS(d.getTimezoneOffset()));
                var l = this.tha(g.query);
                if (f.O.Tn.LH && d.Bf) {
                  let t = [];
                  for (var m = 1; m < d.wa.length; m++) {
                    var n = Object.keys(l)[0],
                      p = d.wa.ea(m);
                    k.i.rb.Kea(p.type, n) && t.push({
                      field: {
                        uniqueName: p.A
                      },
                      query: l
                    });
                  }
                  this.filters[d.A].query = t;
                } else this.filters[d.A].query = l;
                if (g.TBa) {
                  l = g.um;
                  m = [];
                  for (n = 0; n < l.length; n++) (p = d.za(l[n])) && m.push({
                    member: p.A
                  });
                  this.filters[d.A].include = m;
                }
                if (g.SBa) {
                  g = g.Qj;
                  l = [];
                  for (m = 0; m < g.length; m++) (n = d.za(g[m])) && l.push({
                    member: n.A
                  });
                  this.filters[d.A].exclude = l;
                }
              }
              eta(d, g, l) {
                d = d.A;
                void 0 === this.filters[d] && (this.filters[d] = {});
                this.filters[d].query = this.tha(g);
                this.filters[d].value = {
                  field: {
                    uniqueName: l.A
                  },
                  func: l.aa
                };
              }
              tha(d) {
                let g = d.value;
                g instanceof e.gh && (g = g.getTime());
                Array.isArray(g) && g[0] instanceof e.gh && (g = [g[0].getTime(), g[1].getTime()]);
                return {
                  [d.ua]: g
                };
              }
              ps(d, g, l, m) {
                var n,
                  p = d.A;
                f.O.Tn.KH || "intersect" !== l || (l = "include");
                void 0 === this.filters[p] && (this.filters[p] = {});
                void 0 === this.filters[p][l] && (this.filters[p][l] = []);
                for (var t, r, w; !g.dc && void 0 !== g.parent;) {
                  var y = g.level.A;
                  r = g.A;
                  e.model.C.F.ir && ("null" === r && (r = null), "undefined" === r && (r = void 0), "(blank)" === r && (r = ""));
                  e.ia(r) || (r = null !== (n = g.level.inputType) && void 0 !== n ? n : g.level.type, r = k.i.ib.sU(r) && !isNaN(g.fc) ? g.fc : 1 < g.level.yb ? g.A.substr(1, g.A.length - 2).split("].[").pop() : g.A);
                  w = {};
                  g.parent.dc ? (w.member = r, void 0 !== t && (w.filter = t)) : (m ? this.xm(d, g.level) : this.oo(d, g.level), w.field = {
                    uniqueName: y
                  }, w.include = [{
                    member: r
                  }], void 0 !== t && (w.include[0].filter = t));
                  t = w;
                  g = g.parent;
                }
                this.filters[p][l].push(t);
              }
              SZ(d) {
                let g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                let l = arguments.length > 2 ? arguments[2] : undefined;
                let m = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                var n = d.filter.clone();
                if (n.Ei && !g) {
                  var p = n.yj().length < d.Wi / 2;
                  g = p ? n.yj() : n.yj(!0);
                  for (var t = 0; t < g.length; t++) {
                    var r = d.za(g[t]);
                    this.ps(d, r, p ? "include" : "exclude", l);
                  }
                }
                !e.v(n.query) && n.Ku && (e.v(n.measure) || !n.ei || !m && d.type === e.u.i.Fc.qp ? this.dta(d, n) : (l = this.slice.Yc.fd(n.measure.A)) && !0 !== l.Oa && (k.i.da.aU(n.measure.aa) || (n.measure.aa = l.Bm), this.eta(d, n.query, n.measure)));
              }
              clone() {
                var d = new c(this.slice);
                d.rows = u.Nc.vj(this.rows);
                d.Ka = u.Nc.vj(this.Ka);
                d.values = u.Nc.vj(this.values);
                d.filters = u.Nc.vj(this.filters);
                return d;
              }
            }
            c.LX = ["type", "axisName", "dataKeys"];
            f.pv = c;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(c) {
                this.slice = c;
              }
              get kCa() {
                return h.pc.O.Tn.KH;
              }
              select() {
                return e.model.C.F.tc && e.model.C.F.ke !== e.K.Id.kj ? this.Lva() : this.Xva();
              }
              Lva() {
                for (var c = new f.pv(this.slice), d = this.slice.yc(!1, !0, !0, !0), g = 0; g < d.length; g++) {
                  var l = this.slice.mf(d.ea(g).A);
                  this.dfa(l) && c.UK(l);
                  l = d.ea(g);
                  if (l.Bf) for (var m = 1; m < l.wa.length; m++) c.xm(l, l.wa.ea(m));else c.xm(l);
                }
                for (g = 0; g < this.slice.Sf.length; g++) d = this.slice.Sf[g], this.dfa(d) && c.UK(d);
                return c.MJa();
              }
              dfa(c) {
                return c.type !== k.i.Qa.zc && c.type !== k.i.Qa.Ta;
              }
              Xva() {
                var c = new f.pv(this.slice),
                  d = this.slice.xb.Pc(),
                  g = this.slice.Db.Pc();
                this.slice.kf ? 0 < d.length && c.Faa(d) : 0 < d.length && c.xm(d[0]);
                this.slice.jf ? 0 < g.length && c.taa(g) : 0 < g.length && c.oo(g[0]);
                for (d = 0; d < this.slice.Sf.length; d++) g = this.slice.Sf[d], g.Oa || c.UK(g);
                return c.select();
              }
              expand(c, d) {
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                const l = new f.pv(this.slice),
                  m = c == k.i.ha.Ia;
                var n = this.slice.xb.Pc(),
                  p = this.slice.Db.Pc();
                if (m) {
                  0 < p.length && l.oo(p[0]);
                  for (p = 0; p < d.length; p++) for (var t = n[p].za(d[p]); !t.dc;) l.xm(t.hierarchy, t.level), l.ps(n[p], t, "intersect", !0), t = t.parent;
                  n = n[d.length];
                  if (null == n.lc) l.xm(n, n.wa.ea(1));else for (t = 1; t < n.wa.length && (p = n.wa.ea(t), l.xm(n, p), p != n.lc); t++);
                } else {
                  0 < n.length && l.xm(n[0]);
                  for (n = 0; n < d.length; n++) for (t = p[n].za(d[n]); !t.dc;) l.oo(t.hierarchy, t.level), l.ps(p[n], t, "intersect", !1), t = t.parent;
                  n = p[d.length];
                  if (null == n.lc) l.oo(n, n.wa.ea(1));else for (t = 1; t < n.wa.length && (p = n.wa.ea(t), l.oo(n, p), p != n.lc); t++);
                }
                for (t = 0; t < this.slice.Sf.length; t++) n = this.slice.Sf[t], n.Oa || l.UK(n);
                t = this.oaa(l, m ? k.i.ha.Ra : k.i.ha.Ia, g);
                g = this.paa(l, m ? k.i.ha.Ra : k.i.ha.Ia, g);
                t = t.concat(g);
                g = {};
                this.S5(g, d, c);
                t.unshift(l.expand(c, g));
                return t;
              }
              bya(c, d, g) {
                c[d.Bf ? g.level.A : d.A] = g.A;
              }
              S5(c, d, g) {
                g = g === k.i.ha.Ia ? this.slice.xb : this.slice.Db;
                -1 === d[0] && (d = d.slice(1));
                for (let l = 0; l < d.length; l++) {
                  let m = g.ea(l),
                    n = m.za(d[l]);
                  c[m.Bf ? n.level.A : m.A] = n.A;
                }
              }
              Ae(c, d, g) {
                var l = {},
                  m = new f.pv(this.slice),
                  n = c == k.i.ha.Ia,
                  p = this.slice.xb.Pc(),
                  t = this.slice.Db.Pc();
                if (n) for (m.Faa(p.slice(0, d.length)), 0 < t.length && m.oo(t[0]), t = 0; t < d.length - 1; t++) m.ps(p[t], p[t].za(d[t]), "intersect", !0);else for (m.taa(t.slice(0, d.length)), 0 < p.length && m.xm(p[0]), p = 0; p < d.length - 1; p++) m.ps(t[p], t[p].za(d[p]), "intersect", !1);
                p = g;
                t = p.hierarchy.wa.ea(p.level.yb + 1);
                if (n) for (m.xm(p.hierarchy, t); !p.dc;) m.xm(p.hierarchy, p.level), p = p.parent;else for (m.oo(p.hierarchy, t); !p.dc;) m.oo(p.hierarchy, p.level), p = p.parent;
                m.ps(g.hierarchy, g, "intersect", n);
                for (g = 0; g < this.slice.Sf.length; g++) p = this.slice.Sf[g], p.Oa || m.UK(p);
                g = this.oaa(m, n ? k.i.ha.Ra : k.i.ha.Ia, l);
                l = this.paa(m, n ? k.i.ha.Ra : k.i.ha.Ia, l);
                g = g.concat(l);
                l = {};
                this.S5(l, d, c);
                g.unshift(m.Ae(c, l));
                return g;
              }
              paa(c, d, g) {
                const l = [],
                  m = d === k.i.ha.Ia,
                  n = this.slice.xb.Pc(),
                  p = this.slice.Db.Pc(),
                  t = m ? this.slice.hc.kd : this.slice.Rb.kd;
                for (let y = 0; y < t.length; y++) {
                  const A = t[y];
                  var r = c.clone();
                  if (m) {
                    for (var w = 0; w < A.length - 1; w++) r.xm(n[w]), r.ps(n[w], n[w].za(A[w + 1]), "intersect", !0);
                    r.xm(n[A.length - 1]);
                  } else {
                    for (w = 0; w < A.length - 1; w++) r.oo(p[w]), r.ps(p[w], p[w].za(A[w + 1]), "intersect", !1);
                    r.oo(p[A.length - 1]);
                  }
                  this.S5(g, A, d);
                  l.push(r.expand(d, g));
                }
                return l;
              }
              oaa(c, d, g) {
                const l = [],
                  m = d === k.i.ha.Ia,
                  n = this.slice.xb.Pc(),
                  p = this.slice.Db.Pc(),
                  t = m ? this.slice.hc.ue : this.slice.Rb.ue;
                for (let w = 0; w < t.length; w++) {
                  var r = t[w].slice();
                  const y = m ? n[r.length - 3] : p[r.length - 3],
                    A = c.clone();
                  r = r.pop();
                  let B = r = y.za(r);
                  const C = y.wa.ea(r.level.yb + 1);
                  if (m) for (A.ps(y, r, "intersect", m), A.xm(y, C); !B.dc;) A.xm(y, B.level), B = B.parent;else for (A.ps(y, r, "intersect", m), A.oo(y, C); !B.dc;) A.oo(y, B.level), B = B.parent;
                  this.bya(g, y, r);
                  l.push(A.Ae(d, g));
                }
                return l;
              }
              bd(c, d, g) {
                let l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                return this.kCa ? this.$xa(c, d, l) : this.w0(c, d, l);
              }
              $xa(c, d) {
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                const l = new f.pv(this.slice),
                  m = this.slice.ob.Pc(),
                  n = this.slice.xb.Pc(),
                  p = this.slice.Db.Pc(),
                  t = this.slice.Sf;
                this.v0(m, [], l, g, !1);
                this.v0(n, c, l, g, !0);
                this.v0(p, d, l, g, !1);
                for (c = 0; c < t.length; c++) -1 === g.indexOf(t[c].A) && g.push(t[c].A);
                return l.bd(g, !0);
              }
              v0(c, d, g, l, m) {
                for (var n, p = 0; p < c.length; p++) if (g.SZ(c[p], !e.v(d[p]), m), d[p] && (n = c[p].za(d[p])) && g.ps(c[p], n, "intersect", m), c[p].Bf) {
                  let r = l.indexOf(c[p].A);
                  -1 !== r && l.splice(r, 1);
                  for (n = 1; n < c[p].wa.length; n++) {
                    var t = c[p].wa.ea(n);
                    -1 === l.indexOf(t.A) && (-1 === r ? l.push(t.A) : l.splice(r++, 0, t.A));
                  }
                } else -1 === l.indexOf(c[p].A) && l.push(c[p].A);
              }
              w0(c, d) {
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                const l = new f.pv(this.slice),
                  m = this.slice.ob.Pc(),
                  n = this.slice.xb.Pc(),
                  p = this.slice.Db.Pc(),
                  t = this.slice.Sf,
                  r = {};
                this.x0(m, [], r, l, g);
                this.x0(n, c, r, l, g);
                this.x0(p, d, r, l, g);
                for (c = 0; c < t.length; c++) -1 === g.indexOf(t[c].A) && g.push(t[c].A);
                return l.bd(g, r, !1);
              }
              x0(c, d, g, l, m) {
                var n;
                let p, t;
                for (var r = 0; r < c.length; r++) {
                  t = c[r].A;
                  l.SZ(c[r], !e.v(d[r]));
                  if (d[r] && (p = c[r].za(d[r]))) {
                    let w = null !== (n = p.level.inputType) && void 0 !== n ? n : p.level.type;
                    g[t] = k.i.ib.sU(w) ? p.fc : p.A;
                  }
                  -1 === m.indexOf(t) && m.push(t);
                }
              }
            }
            f.bka = b;
            class a {
              constructor(c) {
                this.page = 0;
                this.vx = null;
                this.cL = d => {
                  null != this.vx ? d.pageToken = this.vx : d.page = this.page;
                };
                e.v(c.vx) || (this.vx = c.vx);
                e.v(c.page) || (this.page = c.page);
              }
            }
            f.bn = a;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(c) {
                this.YH = [];
                this.withCredentials = this.closed = !1;
                "string" === typeof c.url ? this.url = c.url : e.Kg(c.url) && (this.Hja = (d, g, l) => c.url(d, g, l));
                this.Yo = c.Yo;
                this.uc = c.uc;
                this.withCredentials = c.withCredentials;
              }
              Vh(c) {
                this.uc = c;
                for (const d of this.YH) d.Vh(this.uc);
              }
              wx(c, d, g) {
                let l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (e.v(this.url)) e.v(this.Hja) ? e.Be(() => {
                  g(e.model.B.j.Doa, null);
                }, 1) : e.Be(() => {
                  d = this.Wba(d);
                  this.Hja(JSON.stringify(d), n => {
                    if (!this.closed) if ("object" == typeof n) g(null, n);else if ("string" == typeof n) try {
                      var p = JSON.parse(n);
                      g(null, p);
                    } catch (t) {
                      g(t, null);
                    }
                  }, n => {
                    if (!this.closed) if ("object" == typeof n) g(n.message || n, null);else if ("string" == typeof n) try {
                      var p = JSON.parse(n);
                      g(p.message || p, null);
                    } catch (t) {
                      g(t, null);
                    }
                  });
                }, 1);else {
                  var m = this.Rwa();
                  m.ff = g;
                  m.lO = l;
                  d = this.Wba(d, m);
                  m.data = JSON.stringify(d);
                  m.load(this.Yo ? this.url : `${this.url}/${c}`);
                }
              }
              Rwa() {
                var c = z.Ft.Dv,
                  d = new a();
                d.contentType = z.JA.k6;
                d.Br = c;
                d.withCredentials = this.withCredentials;
                d.Vh(this.uc);
                d.N(v.ga.Qc, () => this.ur(d));
                d.N(v.ga.xa, g => this.Sb(g, d));
                this.YH.push(d);
                return d;
              }
              Wba(c, d) {
                if (!e.v(b.EL)) {
                  var g = JSON.parse(JSON.stringify(c));
                  g.requestHeaders = e.v(this.uc) ? {} : this.uc;
                  g = b.EL(g);
                  e.v(g) || (e.v(g.requestHeaders) || (e.v(d) || d.Vh(g.requestHeaders), delete g.requestHeaders), c = g);
                }
                return c;
              }
              A_(c) {
                c.close();
                this.YH.splice(this.YH.indexOf(c), 1);
              }
              ur(c) {
                if ("object" == typeof c.response) c.ff(null, c.response);else if ("string" == typeof c.response) try {
                  var d = JSON.parse(c.response);
                  c.ff(null, d);
                } catch (g) {
                  c.ff(g, null);
                }
                this.A_(c);
              }
              Sb(c, d) {
                d.ff(this.parseError(c.data, d), null);
                this.A_(d);
              }
              parseError(c, d) {
                let g = e.v(c) ? "" : c;
                if ("object" == typeof d.response) g += d.response.message || d.response;else if ("string" == typeof d.response) try {
                  var l = JSON.parse(d.response);
                  g += l.message || l;
                } catch (m) {
                  g = e.v(c) ? m : c;
                }
                return g;
              }
              close() {
                for (this.closed = !0; 0 < this.YH.length;) this.A_(this.YH[0]);
              }
            }
            b.EL = null;
            f.zA = b;
            class a extends z.jk {
              gv(c) {
                if (null != this.xhr && 4 === this.xhr.readyState) {
                  if (200 === this.xhr.status) return this.GI();
                  if (401 === this.xhr.status && e.Kg(this.lO)) return this.lO(d => {
                    d ? this.retry() : this.Sb(c);
                  });
                  this.Sb(c);
                }
                null != this.xhr && 3 > this.xhr.readyState && !this.connected && (this.connected = !0, this.Ea(new v.ga(v.ga.GA)));
              }
              Sb() {
                var c;
                0 === this.xhr.status ? c = e.P.bind(e.model.B.j.Coa, this.url) : 404 === this.xhr.status ? c = e.P.bind(e.model.B.j.voa, this.url) : 400 === this.xhr.status ? c = e.P.bind(e.model.B.j.uoa, this.url) : 500 === this.xhr.status && (c = e.P.bind(e.model.B.j.woa, this.url));
                this.response = this.xhr.response || this.xhr.responseText || this.xhr.statusText;
                this.Ea(new v.ga(v.ga.xa, this, c));
              }
            }
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              gm(a) {
                if (e.model.Xa.R().S1(e.model.Xa.dK)) {
                  const c = new e.model.hd(e.model.Xa.dK, d => {
                    if (!e.v(d) && !e.v(d.requestHeaders)) {
                      const g = this.ka.uc || {};
                      for (let l in d.requestHeaders) d.requestHeaders.hasOwnProperty(l) && (g[l] = d.requestHeaders[l]);
                      this.ka.uc = g;
                      this.client.Vh(g);
                    }
                    a(!0);
                  });
                  e.model.Xa.R().Ea(c);
                } else a(!1);
              }
            }
            f.f6 = b;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.f6 {
              constructor(a) {
                super();
                this.va = k.Ma.R();
                this.ka = a;
                this.client = this.ka.Nw();
              }
              load(a, c, d, g) {
                this.Mb = c;
                this.bb = d;
                this.Pe = g;
                this.$ia = !1;
                this.MBa();
              }
              MBa() {
                this.client.wx("handshake", {
                  type: "handshake",
                  version: e.kh.Nr
                }, (a, c) => {
                  a = !0;
                  let d;
                  e.v(c) || (this.client.close(), d = c.version, a = this.Xua(d), this.ka.dia = d, this.client = this.ka.Nw());
                  if (a && !this.$ia) this.c3();else if (!e.v(d) && this.kDa(d)) return this.Sb(e.P.bind(e.model.B.j.Boa, this.ka.url, b.lY));
                }, a => this.gm(a));
                e.Da(!0, e.model.B.j.rF);
              }
              Xua(a) {
                return e.ia(a) ? !0 : -1 != e.P.cS(a, b.lY);
              }
              kDa(a) {
                return -1 == e.P.cS(a, b.lY);
              }
              c3() {
                this.$ia = !0;
                this.client.wx("fields", {
                  index: this.ka.index,
                  type: "fields"
                }, (a, c) => {
                  if (a) return this.Sb(a);
                  this.wr(c);
                }, a => this.gm(a));
                e.Da(!0, e.model.B.j.rF);
              }
              wr(a) {
                e.Da(!1);
                null != this.Pe && this.Pe();
                if (e.v(a) || e.v(a.fields)) return this.Sb(e.P.bind(e.model.B.j.Aoa, this.ka.url));
                a.sorted && (this.va.O.Wu = !0);
                let c;
                e.v(a.aggregations) || (c = this.IHa(a.aggregations));
                e.v(a.filters) || this.XHa(a.filters);
                this.mI(a.fields, c);
                null != this.Mb && this.Mb();
              }
              IHa(a) {
                let c = {};
                if (Array.isArray(a)) c[k.i.input.sa.VI] = a.map(n => n.toString());else for (var d = 0; d < k.i.input.sa.aL.length; d++) {
                  var g = k.i.input.sa.aL[d];
                  if (!e.v(a[g]) && Array.isArray(a[g])) {
                    e.v(c[g]) && (c[g] = []);
                    for (var l = 0; l < a[g].length; l++) {
                      var m = a[g][l].toLowerCase();
                      c[g].push(m);
                      -1 === k.i.da.xA.indexOf(m) && m !== k.i.da.NONE && (k.i.da.xA.push(m), k.i.da.IO.push(m));
                    }
                  }
                }
                return c;
              }
              hxa(a) {
                let c;
                switch (a) {
                  case k.i.input.sa.$c:
                    c = k.i.rb.Zk;
                    break;
                  case k.i.input.sa.jb:
                    c = k.i.rb.jb;
                    break;
                  case k.i.input.sa.Ta:
                    c = k.i.rb.Ta;
                }
                return c;
              }
              XHa(a) {
                if (!0 === a || !1 === a) this.va.O.hH.YK = a;else {
                  for (var c = 0; c < k.i.input.sa.aL.length; c++) {
                    var d = k.i.input.sa.aL[c];
                    if (!e.v(a[d])) {
                      const g = this.Uga(a[d], this.hxa(d));
                      this.va.O.hH.Iaa(d, g);
                    }
                  }
                  f.O.Tn.KH = !0 === a.advanced;
                  f.O.Tn.KH && (f.O.Tn.LH = 1 == e.P.cS(this.ka.dia, "2.8.21"));
                }
              }
              Uga(a, c) {
                if (!0 === a || !1 === a) return a;
                let d = new k.O.Eqa();
                e.v(a.members) || (d.md = !0 === a.members);
                if (!e.v(a.query)) if ("boolean" === typeof a.query) d.query = a.query;else if (Array.isArray(a.query)) for (let g of a.query) if (c == k.i.rb.Zk && k.i.Cb.ah(g) || c == k.i.rb.jb && k.i.Pg.ah(g) || c == k.i.rb.Ta && k.i.bc.ah(g) || e.v(c) && k.i.Cb.ah(g) && k.i.Pg.ah(g) && k.i.bc.ah(g)) e.v(d.query) && (d.query = []), d.query.push(g);
                if (!e.v(a.valueQuery)) if ("boolean" === typeof a.valueQuery) d.km = a.valueQuery;else if (Array.isArray(a.valueQuery)) for (let g of a.valueQuery) k.i.Vb.ah(g) && (e.v(d.km) && (d.km = []), d.km.push(g));
                return d;
              }
              mI(a, c) {
                for (let m = 0; m < a.length; m++) {
                  var d = a[m],
                    g = d.type;
                  if (!d.hasOwnProperty("uniqueName") || e.v(d.uniqueName) || "string" !== typeof d.uniqueName) continue;
                  var l = d.uniqueName;
                  let n = void 0;
                  if (!e.v(d.aggregations) && Array.isArray(d.aggregations)) {
                    const p = d.aggregations;
                    n = [];
                    for (let t = 0; t < p.length; t++) {
                      const r = p[t].toLowerCase();
                      n.push(r);
                      -1 === k.i.da.xA.indexOf(r) && r !== k.i.da.NONE && (k.i.da.xA.push(r), k.i.da.IO.push(r));
                    }
                  }
                  void 0 !== n && 0 < n.length ? d.supportedAggregations = n : e.v(c) || (e.v(c[g]) ? e.v(c[k.i.input.sa.VI]) || (d.supportedAggregations = c[k.i.input.sa.VI]) : d.supportedAggregations = c[g]);
                  d.type === k.i.input.sa.Ta && (d.type = k.i.input.sa.lj);
                  this.va.O.Dy(d, l);
                  g = this.va.O.bD(l);
                  g instanceof f.O.xO && !e.v(d.filters) && (l = e.model.hb.TA.tT(g), d = this.Uga(d.filters, l), this.va.O.hH.jta(g.A, d));
                }
              }
              Sb(a) {
                console.error(a);
                e.Da(!1);
                a = a.message || a;
                e.Wa(a, e.model.B.j.xa, e.tb.xa);
                this.bb && e.Kg(this.bb) && (this.bb(a), this.bb = null);
              }
              ol(a, c, d) {
                var g = this.va.fa.mapping.La(a.A, "filters");
                !1 === g || !1 === g.members ? setTimeout(c, 1, a) : (this.bb = d, e.Da(!0, e.model.B.j.ao, a.caption), a.Bf ? (d = this.va.pa.rows.Bb(a.A), g = this.va.pa.Ka.Bb(a.A), d = this.va.pa.gf && d || this.va.pa.Tf && g, null !== a.lc || d ? this.iN(a, l => this.Zj(l, c)) : this.Ik(a, a.wd, l => this.Zj(l, c))) : this.b3(a, new f.bn({
                  page: 0
                }), l => this.Zj(l, c)));
              }
              b3(a, c, d) {
                var g = {};
                if (a.wa.ea(1).type === k.i.ib.Ta || a.wa.ea(1).type === k.i.ib.Lc) g.interval = a.interval;
                g.uniqueName = a.A;
                g = {
                  index: this.ka.index,
                  type: "members",
                  field: g
                };
                c.cL(g);
                this.client.wx("members", g, (l, m) => {
                  if (l) return this.Sb(l);
                  if (!this.xV(a, m)) return this.Sb(e.P.bind(e.model.B.j.z8, this.ka.url));
                  e.v(m.nextPageToken) ? !e.v(m.pageTotal) && c.page + 1 < m.pageTotal ? (e.Da(!0, e.model.B.j.ao, `${a.caption} - ${Math.round((c.page + 1) / m.pageTotal * 100)}%`), this.b3(a, new f.bn({
                    page: c.page + 1
                  }), d)) : (a.Rd = !0, d(a)) : (e.Da(!0, e.model.B.j.ao, a.caption), this.b3(a, new f.bn({
                    vx: m.nextPageToken
                  }), d));
                }, l => this.gm(l));
              }
              vL(a) {
                for (var c, d; !a.dc;) {
                  var g = {};
                  if (a.level.type === k.i.ib.Ta || a.level.type === k.i.ib.Lc) g.interval = a.level.hierarchy.interval;
                  g.uniqueName = a.level.A;
                  var l = a.A,
                    m = null !== (c = a.level.inputType) && void 0 !== c ? c : a.level.type;
                  k.i.ib.sU(m) && !isNaN(a.fc) ? l = a.fc : 1 < a.level.yb && (l = a.A.substr(1, a.A.length - 2).split("].[").pop());
                  m = d;
                  d = {
                    field: g,
                    include: [{
                      member: l
                    }]
                  };
                  m && (d.include[0].filter = m);
                  a = a.parent;
                }
                return d;
              }
              Rfa(a, c, d, g) {
                var l = {};
                if (a.type === k.i.ib.Ta || a.type === k.i.ib.Lc) l.interval = a.hierarchy.interval;
                l.uniqueName = a.A;
                l = {
                  index: this.ka.index,
                  type: "members",
                  field: l
                };
                var m = this.vL(c);
                m && (l.filter = f.O.Tn.LH ? {
                  type: "and",
                  value: [m]
                } : m);
                d.cL(l);
                this.client.wx("members", l, (n, p) => {
                  if (n) return this.Sb(n);
                  if (!this.MHa(c, p)) return this.Sb(e.P.bind(e.model.B.j.z8, this.ka.url));
                  !e.v(p.pageTotal) && d.page + 1 < p.pageTotal ? (e.Da(!0, e.model.B.j.ao, a.caption + " - " + (d.page + 1) + "/" + p.pageTotal), this.Rfa(a, c, new f.bn({
                    page: d.page + 1
                  }), g)) : (c.zf = !1, g(a.hierarchy));
                }, n => this.gm(n));
              }
              Zj(a, c) {
                var d = a.kv;
                this.v5(d);
                if (0 < a.filter.tl.length) this.hN(a, a.filter.tl, a.filter.oI, l => {
                  l.tw();
                  this.Zj(l, c);
                });else if (0 < d.length) {
                  var g = d.shift();
                  0 == d.length && a.vba();
                  a.kv = d;
                  d = a.Ib(g[1]);
                  a.fz(d);
                  this.Ik(a, d, l => this.Zj(l, c));
                } else a.Rd = !0, c(a);
              }
              v5(a) {
                a.sort((c, d) => {
                  if (c.length !== d.length) return 0;
                  var g = c.length - 1;
                  c = c[g];
                  d = d[g];
                  return e.v(d) || void 0 === d.indexOf ? 1 : e.v(c) || void 0 === c.indexOf || -1 !== d.indexOf(c) ? -1 : -1 !== c.indexOf(d) ? 1 : 0;
                });
              }
              MHa(a, c) {
                if (e.v(c) || e.v(c.members)) return !1;
                if (0 === c.members.length || 1 === c.members.length && e.ia(c.members[0].value)) return a.zf = !1, a.Yg = !1, !0;
                for (var d = c.members, g = 0; g < d.length; g++) {
                  var l = this.oc(a.hierarchy, a, d[g]);
                  c.sorted && a.t_.push(l.ordinal);
                  l.zf = !l.level.Su;
                }
                c.sorted && (a.hierarchy.Wu = !0);
                return !0;
              }
              xV(a, c) {
                if (e.v(c) || e.v(c.members)) return !1;
                for (var d = c.members, g = 0; g < d.length; g++) this.oc(a, null, d[g]);
                c.sorted && (a.Wu = !0);
                return !0;
              }
              oc(a, c, d) {
                var g = String(d.value);
                var l = a.type === k.i.Fc.uv && void 0 !== d.id ? String(d.id) : c && !c.dc ? ("[" === c.A.substr(0, 1) ? c.A : "[" + c.A + "]") + ".[" + g + "]" : g;
                var m = a.Ib(l);
                e.v(m) && (g = new k.O.ae({
                  A: l,
                  caption: g
                }), e.v(c) || (g.parent = c), g.value = d.value, a.Bf ? (c = a.wa.ea(c.level.yb + 1), d = c.A, g.level = c, c = c.inputType, d = this.va.O.dD(d)) : (d = this.va.O.dD(a.A), c = a.inputType), m = a.oc(g, d, c));
                a.WV(m);
                return m;
              }
              Ik(a, c, d) {
                null == c || !c.dc && !c.zf || c.Sh ? d(a) : this.Rfa(a.wa.ea(c.level.yb + 1), c, new f.bn({
                  page: 0
                }), () => {
                  c.zf = !1;
                  d(a);
                });
              }
              iN(a, c) {
                this.Z2(a, new f.bn({
                  page: 0
                }), () => {
                  c(a);
                });
              }
              Z2(a, c, d) {
                for (var g = [], l = 1; l < a.wa.length; l++) {
                  var m = a.wa.ea(l);
                  g.push({
                    uniqueName: m.A
                  });
                  if (m == a.lc) break;
                }
                m = [];
                for (l = 0; l < g.length; l++) m.push({
                  field: g[l],
                  func: "count"
                });
                g = {
                  type: "select",
                  index: this.ka.index,
                  query: {
                    aggs: {
                      by: {
                        rows: g
                      },
                      values: m
                    }
                  }
                };
                c.cL(g);
                this.client.wx("select", g, (n, p) => {
                  n ? (this.Sb(n), d(a)) : this.dIa(p, a) ? e.v(p.nextPageToken) ? !e.v(p.pageTotal) && c.page + 1 < p.pageTotal ? this.Z2(a, new f.bn({
                    page: c.page + 1
                  }), d) : d(a) : this.Z2(a, new f.bn({
                    vx: p.nextPageToken
                  }), d) : (this.Sb(e.P.bind(e.model.B.j.A8, this.ka.url)), d(a));
                }, n => this.gm(n));
              }
              dIa(a, c) {
                if (e.v(a) || e.v(a.aggs)) return !1;
                a = a.aggs;
                for (var d, g, l, m, n, p, t = 0; t < a.length; t++) if (d = a[t].keys, !e.v(d)) {
                  n = void 0;
                  g = [];
                  for (let r = 1; r < c.wa.length; r++) {
                    l = c.wa.ea(r).A;
                    if (!d.hasOwnProperty(l)) break;
                    m = d[l];
                    g.push(m);
                    l = 1 === g.length ? m : `[${g.join("].[")}]`;
                    p = c.Ib(l);
                    null == p && (p = this.oc(c, null !== n && void 0 !== n ? n : c.wd, {
                      A: l,
                      caption: m,
                      parent: n,
                      value: m
                    }), p.zf = !p.level.Su);
                    n = p;
                  }
                }
                return !0;
              }
              hN(a, c, d, g) {
                this.Sya(a, c, g);
              }
              Sya(a, c, d) {
                new Promise(async g => {
                  for (let l = 0; l < c.length; l++) await this.Tya(a, "[" === c[l].substr(0, 1) ? c[l].substr(1, c[l].length - 2).split("].[") : [c[l]]);
                  g(null);
                }).then(() => {
                  d(a);
                });
              }
              async Tya(a, c) {
                for (let g = 0; g < c.length; g++) {
                  var d = "";
                  if (0 < g) {
                    d = [];
                    for (let m = 0; m <= g; m++) d.push("[" + c[m] + "]");
                    d = d.join(".");
                  } else d = c[0];
                  let l;
                  a.type === k.i.Fc.Ta ? (d = new e.gh(d).getTime(), l = a.Du(d)) : l = a.Ib(d);
                  await new Promise(m => {
                    this.Ik(a, l, m);
                  });
                }
              }
              Lz() {}
              uq(a, c, d, g) {
                d && (this.Mb = d);
                g && (this.bb = g);
                throw "Not Implemented";
              }
              iC() {
                return !1;
              }
              cancel() {
                this.Pe = this.bb = this.Mb = this.ka = this.va = null;
                this.client && (this.client.close(), this.client = null);
              }
            }
            b.lY = "2.8.5";
            f.cka = b;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.f6 {
              constructor() {
                super(...arguments);
                this.va = k.Ma.R();
                this.ta = this.va.ta;
              }
              load(a, c, d, g) {
                this.ka = a;
                this.query = c;
                this.Mb = d;
                this.bb = g;
                this.client = this.ka.Nw();
                this.jx();
              }
              jx() {
                e.Da(!0, e.model.B.j.jg);
                this.z4 = 0;
                if (Array.isArray(this.query.body)) {
                  const a = new u.mB();
                  this.query.body.forEach(c => {
                    a.add(d => this.PU(c, this.query.type, new f.bn({
                      page: 0
                    }), d));
                  });
                  a.Xe(() => {
                    null != this.Mb && this.Mb();
                  });
                } else this.PU(this.query.body, this.query.type, new f.bn({
                  page: 0
                }), () => {
                  null != this.Mb && this.Mb();
                });
              }
              PU(a, c, d, g) {
                let l = this.$ua(a);
                a = {
                  type: "select",
                  index: this.ka.index,
                  query: l
                };
                e.model.C.F.tc || (a.querytype = c);
                d.cL(a);
                this.client.wx("select", a, (m, n) => {
                  if (m) return this.Sb(m, this.bb), g();
                  if (!this.jIa(n)) return this.Sb(e.P.bind(e.model.B.j.A8, this.ka.url), this.bb), g();
                  e.v(n.nextPageToken) ? !e.v(n.pageTotal) && d.page + 1 < n.pageTotal ? (e.Da(!0, e.model.B.j.jg, `${Math.round((d.page + 1) / n.pageTotal * 100)}%`), this.PU(l, c, new f.bn({
                    page: d.page + 1
                  }), g)) : g() : this.PU(l, c, new f.bn({
                    vx: n.nextPageToken
                  }), g);
                }, m => this.gm(m));
              }
              $ua(a) {
                a = u.Nc.vj(a);
                for (let c = 0; c < f.pv.LX.length; c++) a[f.pv.LX[c]] && delete a[f.pv.LX[c]];
                return a;
              }
              jIa(a) {
                if (e.v(a)) return !1;
                a.aggs && (this.JHa(a.aggs, this.QH()), (e.v(a.nextPageToken) && e.v(a.pageTotal) || 1 >= a.pageTotal - a.page) && this.z4++);
                a.hits && this.YHa(a.fields, a.hits);
                return !0;
              }
              QH() {
                return e.model.C.F.tc && e.model.C.F.ke !== e.K.Id.kj;
              }
              YHa(a, c) {
                for (var d = this.w1(this.va.pa.yc(!1, !0, !0, !0)), g = 0; g < c.length; g++) {
                  for (var l = [], m = [], n, p = 0; p < a.length; p++) {
                    n = a[p].uniqueName;
                    var t = this.ta.di(n),
                      r = c[g][p];
                    n = d.getItem(n);
                    var w = n.hierarchy;
                    if (w.type === k.i.Fc.Ta) {
                      var y = w.Du(r);
                      y = e.v(y) ? -1 : y.ordinal;
                    } else w.type !== k.i.Fc.uv ? (y = w.Du(parseFloat(r)), y = null !== y ? y.ordinal : -1) : y = w.sz(e.ia(r) ? "" : "" + r);
                    if (-1 === y) if (w.Bf) {
                      var A = n.uV;
                      y = [];
                      for (var B = 1; B < w.wa.length; B++) {
                        var C = w.wa.ea(B),
                          I = a.findIndex(L => L.uniqueName === C.A);
                        y.push(c[g][I]);
                        if (A === C.A) break;
                      }
                      A = "[" + y.join("].[") + "]";
                      B = A + ".[" + r + "]";
                      1 === y.length && (A = y[0]);
                      y = w.sz(B);
                      -1 === y && (C = n.level, A = w.oc(new k.O.ae({
                        A: B,
                        caption: r,
                        value: r,
                        level: C,
                        Hi: A
                      }), k.i.ib.oA(C.type)), null != A && (y = A.ordinal));
                    } else A = this.va.O.dD(w.A), A = w.oc(new k.O.ae({
                      A: String(r),
                      caption: String(r),
                      value: r
                    }), A), null != A && (y = A.ordinal);
                    l[n.fc] = y;
                    m[t] = w.type === k.i.Fc.qp ? "number" === typeof r ? r : NaN : w.type === k.i.Fc.Ta ? !e.model.C.F.ir || null !== r && "null" !== r ? "number" === typeof r ? r : NaN : null : 1;
                  }
                  this.ta.iCa(l, m);
                }
              }
              w1(a) {
                for (var c, d = new e.ub(), g = 0, l = 0, m = 0; m < a.length; m++) {
                  c = a.ea(m);
                  if (c.Bf) {
                    l++;
                    for (var n = 1; n < c.wa.length; n++) d.Ua(c.wa.ea(n).A, {
                      hierarchy: c,
                      ordinal: g,
                      level: c.wa.ea(n),
                      uV: c.wa.ea(n - 1).A,
                      lc: c.lc,
                      fc: l++
                    });
                  } else n = this.va.fa.mapping.La(c.A, "filters"), d.Ua(c.A, {
                    hierarchy: c,
                    ordinal: g,
                    level: c.wa.ea(1),
                    fc: l++,
                    Ei: !1 !== n && !1 !== n.members
                  });
                  g++;
                }
                return d;
              }
              JHa(a, c) {
                const d = this.w1(this.va.pa.xb),
                  g = this.w1(this.va.pa.Db);
                let l = !1,
                  m,
                  n;
                m = this.query.gg;
                if (Array.isArray(this.query.body)) {
                  var p = this.query.body[this.z4];
                  n = p.dataKeys;
                  0 < this.z4 && (l = !0);
                } else p = this.query.body, n = this.query.Dn;
                p = p.type;
                for (let r = 0; r < a.length; r++) if (c) {
                  var t = this.Yga(a[r].values);
                  this.ta.kA(t);
                } else {
                  if (p === k.i.$d.gF || p === k.i.$d.Vx) {
                    if (e.v(a[r].keys)) continue;
                    if (!this.DLa(a[r].keys, n)) continue;
                  }
                  t = this.Yga(a[r].values);
                  const w = this.Xga(a[r].keys, d),
                    y = this.Xga(a[r].keys, g);
                  this.xfa(w) && this.xfa(y) && this.ta.insert(w, y, t, m, this.query.iw, !l);
                }
              }
              DLa(a, c) {
                if (c) for (let d in c) if (void 0 === a[d] && a[d] !== c[d]) return !1;
                return !0;
              }
              xfa(a) {
                for (let c = 0; c < a.length; c++) if (e.v(a[c])) return !1;
                return !0;
              }
              Yga(a) {
                var c = [],
                  d;
                for (d in a) if (a.hasOwnProperty(d)) for (var g in a[d]) if (a[d].hasOwnProperty(g)) {
                  var l = this.ta.di(d, g, !0);
                  c[l] = a[d][g];
                }
                return c;
              }
              Xga(a, c) {
                const d = [];
                if (e.v(a)) return d;
                const g = c.length;
                for (let w = 0; w < g; w++) {
                  var l = c.Oh(w);
                  if (void 0 !== a[l]) {
                    var m = a[l];
                    "string" !== typeof m && (m = "" + m);
                    var n = c.getItem(l);
                    const y = [];
                    if (n.level) {
                      var p = n.uV;
                      for (1 < n.level.yb && (m = `[${m}]`); void 0 !== a[p];) m = `[${a[p]}].${m}`, p = c.getItem(p).uV;
                    }
                    n.hierarchy.type === k.i.Fc.uv || n.level.type !== k.i.ib.Ta && n.level.type !== k.i.ib.Lc && n.level.type !== k.i.ib.ic && n.level.type !== k.i.ib.Jl ? p = n.hierarchy.sz(m) : (p = n.hierarchy.Du(a[l]), p = e.v(p) ? -1 : p.ordinal);
                    const A = c.getItem(n.hierarchy.wa.ea(1).A).ordinal;
                    var t = this.va.pa.rows.Bb(n.hierarchy.A),
                      r = this.va.pa.Ka.Bb(n.hierarchy.A);
                    if (n.lc || this.va.pa.gf && t || this.va.pa.Tf && r) {
                      if (-1 === p) {
                        t = n.uV;
                        m = [];
                        for (r = 1; r < n.hierarchy.wa.length; r++) {
                          const B = n.hierarchy.wa.ea(r);
                          m.push(a[B.A]);
                          if (t === B.A) break;
                        }
                        t = "[" + m.join("].[") + "]";
                        r = t + ".[" + a[l] + "]";
                        1 === m.length && (t = m[0]);
                        l = n.hierarchy.oc(new k.O.ae({
                          A: r,
                          caption: a[l],
                          level: n.level,
                          Hi: t
                        }));
                        null != l && (p = l.ordinal);
                      }
                      y.push(n.level.yb);
                      y.push(p);
                      void 0 === d[A] && (d[A] = [n.lc ? n.hierarchy.wa.length - n.lc.yb : 0]);
                      d[A].push(y);
                    } else n.level ? (-1 === p && !1 === n.Ei && (l = n.hierarchy.oc(new k.O.ae({
                      A: m,
                      caption: a[l]
                    })), null != l && (p = l.ordinal)), y.push(n.level.yb), y.push(p), d[A] = y) : (-1 === p && !1 === n.Ei && (n = n.hierarchy.oc(new k.O.ae({
                      A: m,
                      caption: a[l]
                    })), null != n && (p = n.ordinal)), y.push(1), y.push(p), d.push(y));
                  }
                }
                return d;
              }
              Sb(a, c) {
                console.error(a);
                e.Da(!1);
                e.Wa(a.message || a, e.model.B.j.xa, e.tb.xa);
                e.Kg(c) && c();
              }
              bd(a, c, d, g, l, m) {
                e.Da(!0, e.model.B.j.jg);
                this.ka = a;
                e.v(this.client) && (this.client = this.ka.Nw());
                this.NC = [];
                this.W2(c, new f.bn({
                  page: 0
                }), m);
              }
              W2(a, c, d) {
                const g = {
                  type: "select",
                  index: this.ka.index,
                  query: a.body
                };
                c.cL(g);
                this.client.wx("select", g, (l, m) => {
                  if (l) return this.Sb(l, d);
                  if (!this.UHa(m)) return this.Sb(e.P.bind(e.model.B.j.xoa, this.ka.url), d);
                  e.v(m.nextPageToken) ? !e.v(m.pageTotal) && c.page + 1 < m.pageTotal ? this.W2(a, new f.bn({
                    page: c.page + 1
                  }), d) : d(this.NC) : this.W2(a, new f.bn({
                    vx: m.nextPageToken
                  }), d);
                }, l => this.gm(l));
              }
              UHa(a) {
                if (e.v(a)) return !1;
                if (a.fields && 0 == this.NC.length) {
                  var c = a.fields.map(d => d.A);
                  this.NC.push(c);
                }
                if (a.hits) for (c = 0; c < a.hits.length; c++) this.NC.push(a.hits[c]);
                return !0;
              }
              cancel() {
                this.bb = this.query = this.Mb = this.ka = this.ta = this.va = null;
                this.client && (this.client.close(), this.client = null);
                this.NC && (this.NC.length = 0, this.NC = null);
              }
            }
            f.Yja = b;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.vX {
              constructor() {
                super(...arguments);
                this.R5 = new e.ub();
              }
              rC() {
                this.R5.clear();
                super.rC();
              }
              La(a, c, d) {
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                g = g ? 0 : this.XY(a, c);
                const l = this.di(d);
                if (e.v(this.values[g])) return k.i.da.Fe(d.aa) ? 0 : NaN;
                if (d.Oa) {
                  this.XF = !1;
                  a = this.Up([g], d.Sd, d.Gk, 0, a, c, d.zn);
                  if (!0 === a || !1 === a) a = !0 === a ? 1 : 0;
                  this.values[g][l] = a;
                }
                return e.v(this.values[g][l]) ? k.i.da.Fe(d.aa) ? 0 : NaN : this.values[g][l];
              }
              kw(a, c, d, g) {
                return this.Up([this.XY(a, c)], d, !1, g);
              }
              XY(a, c) {
                return a + " " + c;
              }
              kA(a) {
                this.values[0] = a;
              }
              Rg(a, c) {
                return null === a || 0 === a.length ? NaN : this.values[a[0]] ? this.values[a[0]][c] : NaN;
              }
              m1(a, c) {
                const d = this.slice.Di(new e.model.hb.jh(a, c));
                null != d && (c = k.i.da.YM(d.aa) ? d.aa : d.Bm);
                return this.di(a, c, !this.XF);
              }
              kM(a, c) {
                const d = k.i.da.mj;
                c = this.m1(c.A, d);
                return this.Rg(a, c, d);
              }
              yn(a, c) {
                super.yn(a, c);
                this.ym(a.A);
              }
              insert(a, c, d, g, l, m) {
                var n = [],
                  p = [];
                const t = [];
                for (var r = 0; r < a.length; r++) if (Array.isArray(a[r][1])) {
                  p[r] = a[r][a[r].length - 1][1];
                  if (a[r].length > a[r][0]) {
                    var w = [];
                    g && (w = g.slice());
                    w.concat(n.slice());
                    0 < w.length && t.push(w);
                  }
                  for (w = 1; w < a[r].length; w++) n[this.wa[this.Uh[r]][a[r][w][0]]] = a[r][w][1];
                } else {
                  if (-1 === a[r][1]) return;
                  p[r] = a[r][1];
                  n[this.wa[this.Uh[r]][a[r][0]]] = p[r];
                }
                a = [];
                for (r = 0; r < c.length; r++) if (Array.isArray(c[r][1])) for (a[r] = c[r][c[r].length - 1][1], w = [], g && (w = g.slice()), w.concat(n.slice()), 0 < w.length && t.push(w), w = 1; w < c[r].length; w++) n[this.wa[this.wk[r]][c[r][w][0]]] = c[r][w][1];else {
                  if (-1 === c[r][1]) return;
                  a[r] = c[r][1];
                  n[this.wa[this.wk[r]][c[r][0]]] = a[r];
                }
                p = this.XY(p, a);
                c = this.vb.length;
                void 0 !== this.values[p] ? (n = this.R5.getItem(n.join("-")), void 0 !== n && (c = n), m && (this.values[p] = d)) : (this.mh.push(c), this.vb.push(n), this.R5.Ua(n.join("-"), this.vb.length - 1), this.values[p] = d);
                0 < g.length && (0 === this.Bd.length && (this.expand([], k.i.ha.Ia, void 0), this.expand([], k.i.ha.Ra, void 0)), d = l === k.i.ha.Ia ? this.ld(g, this.Bd) : this.ld(g, this.Od), void 0 != d && -1 === d[0][0].indexOf(c) && d[0][0].push(c));
                if (0 < t.length) for (d = 0; d < t.length; d++) {
                  g = l === k.i.ha.Ia ? this.ld(t[d], this.Bd) : this.ld(t[d], this.Od);
                  if (void 0 === g) {
                    g = [];
                    m = void 0;
                    for (n = 0; n < t[d].length; n++) g.push(t[d][n]), m = l === k.i.ha.Ia ? this.ld(g, this.Bd) : this.ld(g, this.Od), void 0 !== m && void 0 !== m[0] && void 0 !== m[0][0] && (p = t[d][n + 1]) && (m[p] = [[[c], [], [], void 0, void 0]]);
                    g = m;
                  }
                  void 0 !== g && void 0 !== g[0] && void 0 !== g[0][0] && -1 === g[0][0].indexOf(c) && g[0][0].push(c);
                }
              }
              iCa(a, c) {
                let d;
                if (0 === this.vb.length) for (d = 0; d < a.length; d++) this.vb[d] = [];
                this.mh = e.Ja.Hr(this.mh, this.Nx);
                for (d = 0; d < a.length; d++) this.vb[d] = e.Ja.Hr(this.vb[d], a[d]);
                0 === this.values.length && this.kA([]);
                this.values.push(c);
              }
              rT(a, c, d, g, l) {
                if (void 0 === this.cb[a]) return NaN;
                if (g) return this.XF = !0, d.Oa ? this.Up([this.cb[a] + 1], d.Sd, d.Gk, 0, null, null, d.zn) : this.values[this.cb[a] + 1][c];
                c = this.je.indexOf(this.oh[c]);
                void 0 !== l && (c = this.wa[c][l + 1]);
                return void 0 === this.vb[c] ? NaN : this.vb[c][this.cb[a]];
              }
              filter() {}
              xB(a, c, d) {
                if (null !== a) {
                  var g = a[0][0];
                  if (0 < g.length && !isNaN(c)) {
                    for (let l = 0; l < g.length; l++) {
                      const m = this.vb[g[l]][this.wa[c][1]];
                      0 !== m && void 0 !== m && (void 0 === a[m] ? (a[m] = [[[g[l]], [], [], void 0, void 0, !1]], a[0][1].push(m)) : a[0][5] || a[m][0][0].push(g[l]));
                    }
                    void 0 === a[0][3] && (a[0][3] = []);
                    void 0 === d ? a[0][3][this.xg.length] = !0 : a[0][3][this.di(d)] = !0;
                    a[0][5] = !0;
                  }
                }
              }
              HQ(a, c, d, g, l) {
                if (void 0 !== c && void 0 !== c[0]) {
                  var m = c[0][0];
                  if (0 < m.length && !isNaN(g)) {
                    for (let n = 0; n < m.length; n++) {
                      const p = this.vb[m[n]][g];
                      0 !== p && void 0 !== p && (void 0 === a[p] ? (a[p] = [[[m[n]], [], [], void 0, void 0]], c[0][2].push(p), this.Vl[d][p] = g) : -1 === a[p][0][0].indexOf(m[n]) && a[p][0][0].push(m[n]));
                    }
                    void 0 === c[0][4] && (c[0][4] = []);
                    void 0 === l ? c[0][4][this.xg.length] = !0 : c[0][4][this.di(l)] = !0;
                  }
                }
              }
            }
            f.i6 = b;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {}
            b.y9 = {
              date: "date string",
              "year/month/day": "date string",
              "year/quarter/month/day": "date string"
            };
            class a extends k.O.pm {
              constructor() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                super(c);
                this.MW();
              }
              MW() {
                this.Osa();
                this.Nsa();
              }
              Nsa() {
                for (let c in this.mapping) Array.isArray(this.mapping[c]) && (this.mapping[c] = this.mapping[c][0]);
              }
              Osa() {
                var c = this.mapping;
                for (let d in c) c = this.La(d, "type"), null != c && b.y9.hasOwnProperty(c) && this.li(d, "type", b.y9[c]);
              }
            }
            f.yO = a;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                if (null != b.instance) throw Error("Singleton");
              }
              static R() {
                null == b.instance && (b.instance = new b());
                return b.instance;
              }
              static dispose() {
                b.instance = null;
              }
              async TN(a, c) {
                return new Promise((d, g) => {
                  u.io.load("lib/sha1.min.js", () => {
                    var l = e.model.Ha.ra.J(e.model.Ha.ra.cJa);
                    if (null != l) {
                      var m = JSON.stringify(c.Sa());
                      var n = new jsSHA("SHA-1", "TEXT");
                      n.setHMACKey(l, "TEXT");
                      n.update(m);
                      m = n.getHMAC("B64");
                    }
                    a.Vh({
                      "x-flexmonster": m
                    });
                    a.wx("save", null !== c ? c.Sa() : {}, (p, t) => {
                      if (e.v(t)) p && (e.Wa(e.P.bind(e.model.B.j.E8, p), e.model.B.j.xa, e.tb.xa), a.close(), g(p));else {
                        p = new URL(location.href);
                        p.searchParams.set("flexmonsterreport", t);
                        var r = p.href;
                        e.Wa(e.P.bind(e.model.B.j.Moa, r), e.model.B.j.cn, e.tb.cn, [e.model.B.j.t6, e.model.B.j.El], [() => {
                          const w = document.createElement("textarea");
                          w.value = r;
                          w.setAttribute("readonly", "");
                          w.style.position = "fixed";
                          w.style.left = "-9999px";
                          document.body.appendChild(w);
                          w.select();
                          document.execCommand("copy");
                          document.body.removeChild(w);
                        }, () => {}]);
                        a.close();
                        d(r);
                      }
                    });
                  });
                });
              }
              RDa(a, c, d) {
                var g = new f.zA(a);
                g.wx("load", c, (l, m) => {
                  e.v(m) || d && d(m);
                  l && (e.Wa(e.P.bind(e.model.B.j.D8, l), e.model.B.j.xa, e.tb.xa), console.error("Can't load the shared file. The URL to the server hasn't been found. " + l), d && d());
                  g.close();
                });
              }
            }
            f.h6 = b;
          })(h.pc || (h.pc = {}));
        })(k.external || (k.external = {}));
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h extends x.be.ik {
          constructor(f, b) {
            var _this;
            super();
            _this = this;
            this.pU = this.A2 = !1;
            this.Cea = "theme/accessible/flexmonster.min.css";
            this.ufa = !1;
            this.la = e.model.Va.R();
            this.eH = null;
            this.O2 = this.P2 = this.height = this.width = 0;
            this.jO = !1;
            this.t$ = 0;
            this.SG = [];
            this.nga = 0;
            this.yca = !1;
            this.Ny = d => this.cv(d);
            this.Oy = d => this.dv(d);
            this.Py = () => this.oN();
            this.My = null;
            this.Sca = () => {
              h.Gb.pb(k.Si.ip, this.Sca);
              this.Yb.Bk(this.eH.zu, this.eH.sb, function () {
                _this.Yb.I = null;
                _this.la.I = e.u.Re.Ni.Bc("chart");
                for (var _len6 = arguments.length, d = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                  d[_key6] = arguments[_key6];
                }
                null != _this.eH.Fp && _this.eH.Fp.apply(null, d);
                _this.eH = null;
              });
            };
            this.pia("fm-pivot-view");
            null != this.qf && this.qf.dispose();
            f.empty();
            this.qf = f;
            h.Gb = this;
            var a = b.width ? "number" === typeof b.width ? b.width + "px" : -1 < b.width.indexOf("px") || b.width.indexOf("%") == b.width.length - 1 ? b.width : b.width + "px" : "100%";
            f = b.height ? "number" === typeof b.height ? b.height + "px" : -1 < b.height.indexOf("px") || b.height.indexOf("%") == b.height.length - 1 ? b.height : b.height + "px" : "500px";
            var c = /\d+(?=px|%)/;
            a = a.match(c) ? a : "100%";
            f = f.match(c) ? f : "500px";
            this.qf.U("width", a);
            this.qf.U("height", f);
            this.G.U("width", a);
            this.G.U("height", f);
            this.qf.append(this.G);
            f = [];
            b.toolbar ? (f = ["toolbar/flexmonster.toolbar.js"], this.jO = !0) : this.jO = !1;
            u.eX.g1() || (c = new x.Ga("div", "fm-csscheck"), this.qf.append(c), "flexmonster" != window.getComputedStyle(c.element).getPropertyValue("font-family") && '"flexmonster"' != window.getComputedStyle(c.element).getPropertyValue("font-family") && f.unshift("flexmonster.css"), c.remove());
            u.io.load(f, () => {
              this.G.requestAnimationFrame(() => {
                if (!u.Jd().cj && !u.eX.Jua(e.kh.Nr)) {
                  const d = `Flexmonster: CSS version mismatch.\nVersions of Flexmonster specified in the CSS and JS files do not match.\nThe version of Javascript: ${e.kh.Nr}, the version of CSS: ${u.eX.g1()}.\nTo fix the issue, please try the following:\n1. Clear your browser cache to make sure the latest files are loaded.\n2. Check if the CSS file was updated correctly along with Flexmonster.\n3. Ask the tech team for help (https://www.flexmonster.com/technical-support/).`;
                  console.warn(d);
                }
                this.toolbar = b.toolbar ? new FlexmonsterToolbar(this.qf.element, e.kh.instance.pc, "html5", a, e.model.B.XA.R().Bda(), e.model.Ha.wc.Wj()) : null;
                e.kh.instance.pc.toolbar = this.toolbar;
                this.wea && (e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.SW, this.toolbar)), this.toolbar.create());
                this.jO = !1;
                this.Ie();
                this.nb();
              });
            }, () => {
              this.jO = !1;
            });
            this.la.Fa.N(e.model.Wb.Uc.gy, () => this.R3());
            this.la.Fa.N(e.model.Wb.Uc.NX, () => this.GGa());
            this.la.Fa.N(e.model.Wb.Uc.oX, () => this.v3());
            this.la.Fa.N(e.model.Wb.Uc.mF, () => this.P3());
            this.la.Fa.N(e.model.Wb.Uc.gB, () => {});
            this.la.Fa.N(e.model.Wb.Uc.al, d => this.oFa(d));
            this.la.Fa.N(e.model.Wb.Uc.pi, () => this.Z3());
            this.la.Fa.N(e.model.Wb.Uc.zF, () => this.b4());
            this.la.Fa.N(e.model.Wb.Uc.oF, () => this.hI());
            this.la.N(e.bf.uX, d => this.DFa(d));
            this.la.N(e.bf.aY, () => this.NGa());
            this.la.N(k.Oa.fk.B6, d => this.HGa(d));
            this.la.N(k.Si.O6, d => this.IGa(d));
            this.N(k.Si.ip, () => this.HEa());
            e.Dk.addEventListener("fullscreenchange", () => this.bV(), !1);
            e.Dk.addEventListener("mozfullscreenchange", () => this.bV(), !1);
            e.Dk.addEventListener("webkitfullscreenchange", () => this.bV(), !1);
            e.Dk.addEventListener("MSFullscreenChange", () => this.bV(), !1);
            this.qf.N("fullscreenchange", d => this.hV(d), !1);
            this.qf.N("mozfullscreenchange", d => this.hV(d), !1);
            this.qf.N("webkitfullscreenchange", d => this.hV(d), !1);
            this.qf.N("MSFullscreenChange", d => this.hV(d), !1);
            u.pP.R().N(u.KeyboardEvent.E9, () => this.uHa());
          }
          get wea() {
            return this.toolbar && null != this.toolbar.create;
          }
          uHa() {
            this.qia(!this.A2);
          }
          qia(f) {
            this.A2 = f;
            this.qf.$a("fm-keyboard-mode", this.A2);
          }
          get JE() {
            if (this.toolbar) {
              var f = x.Ga.Xb(this.qf.element.querySelector("#fm-toolbar-wrapper"));
              return null == f ? 0 : f.height;
            }
            return 0;
          }
          static get Hx() {
            var f = h.Gb.G.borderWidth;
            return h.Gb.qf.Zf(u.nU()) - f.left - f.right;
          }
          static get Via() {
            var f = h.Gb.G.borderWidth;
            return h.Gb.qf.yd(u.nU()) - f.top - f.bottom;
          }
          static get vo() {
            return e.model.C.F.ke == k.Id.Zn ? h.uQ : h.Hx - h.Gb.RC;
          }
          static get to() {
            return e.model.C.F.ke == k.Id.Zn ? h.oK : h.Gb.zr();
          }
          static get KM() {
            return e.model.C.F.ke == k.Id.Zn ? h.TQ : h.Hx - h.Gb.RC;
          }
          static get qD() {
            return e.model.C.F.ke == k.Id.Zn ? h.SQ : h.Gb.zr();
          }
          get RC() {
            return "right" == e.model.C.F.QC && e.model.C.F.Cn ? this.t$ : 0;
          }
          set RC(f) {
            this.t$ = f;
          }
          zr() {
            return this.MT() && null != this.Dm ? h.Via - (this.Dm.yd() + this.Dm.G.borderWidth.top) - h.Gb.JE : h.Via - h.Gb.JE;
          }
          Cr(f) {
            this.Yb && this.Yb.ma && this.Yb.ma.Cr(f);
          }
          dt(f) {
            this.Yb && this.Yb.ma && this.Yb.ma.dt(f);
          }
          nb() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            this.mba();
            if (this.yca || this.ufa && (e.model.Ha.wc.error || !e.ia(e.model.Ha.wc.Xy))) {
              var b = this.G.requestAnimationFrame(() => {
                this.mba();
                this.NY(f);
              });
              this.SG.push(b);
            } else 500 > this.nga++ || (this.jO || e.ia(e.model.Ha.wc.Xy)) && 5E3 > this.nga ? this.DEa = e.Be(() => {
              this.nb(f);
            }, 10) : this.qf.visible && (console.error("Something went wrong.\nTo fix the issue please try the following:\n1. Check if the componentFolder parameter is defined correctly.\n2. Check if the path to the css file is valid.\n3. Check if DevTools (press F12) has an exception.\n4. Ask the support team for help (https://www.flexmonster.com/technical-support/)"), "hidden" != document.visibilityState && (e.model.Ha.wc.qq || alert("Something went wrong.\nTo fix the issue please try the following:\n1. Check if the componentFolder parameter is defined correctly.\n2. Check if the path to the css file is valid.\n3. Check if DevTools (press F12) has an exception.\n4. Ask the support team for help (https://www.flexmonster.com/technical-support/)")));
          }
          mba() {
            for (; 0 < this.SG.length;) this.G.cancelAnimationFrame(this.SG.pop());
            this.SG = [];
            e.kr(this.DEa);
            e.kr(this.Bha);
          }
          Aja() {
            if (!this.qf) return !1;
            var f = u.nU(),
              b = this.qf.Zf(),
              a = this.qf.yd();
            a -= this.JE;
            if (this.P2 !== b || this.O2 !== a) this.G.U("width", b + "px"), f ? this.G.U("height", "calc(100% - " + this.JE + "px)") : this.G.U("height", a + "px");
            return this.P2 !== b || this.O2 !== a;
          }
          m4() {
            this.toolbar && null != this.toolbar.applyToolbarLayoutClasses && this.toolbar.applyToolbarLayoutClasses();
            this.nb(!0);
          }
          R3() {
            this.la.Fa.Ef == e.model.Wb.up.INIT && this.VG();
          }
          v3() {
            null != this.Yb && this.Yb.nu();
            this.nb();
          }
          P3() {
            this.la.Fa.Ef != e.model.Wb.up.eK && this.la.Fa.Ef != e.model.Wb.up.HA && this.VG();
          }
          GGa() {
            this.VG();
          }
          Dga() {
            this.la.Fa.fa.Ic && (null != this.Yb && this.Yb.nu(), this.nb());
          }
          Cga() {
            this.la.Fa.Ef != e.model.Wb.up.eK && this.la.Fa.Ef != e.model.Wb.up.HA && this.VG();
          }
          rga() {
            this.la.Fa.Ef != e.model.Wb.up.eK && this.la.Fa.Ef != e.model.Wb.up.HA && this.VG();
          }
          oFa(f) {
            this.la.Fa.Ef == e.model.Wb.up.INIT || this.la.Fa.Ef == e.model.Wb.up.q8 || null == this.Yb || f.data != e.u.i.$d.ho && f.data != e.u.i.$d.ZO || (this.Yb.nu(), this.nb());
          }
          hI() {
            null != this.toolbar && this.toolbar.updateLabels(e.model.B.XA.R().Bda());
            null != this.Bi && this.Bi.updateLabels();
          }
          Hw(f) {
            f = this.la.ja.pa.yc().getItem(f);
            null != f && this.bfa(f) && (this.Yb.nu(), this.la.I.Hw(f));
          }
          uR(f, b) {
            f = this.la.ja.pa.rd(f);
            let a = [],
              c = 0;
            for (let g = 0; g < b.length; g++) {
              let l = f.Pa.ea(c);
              l.Ue && (c++, l = f.Pa.ea(c));
              var d = l.Ib(b[g]);
              e.v(d) && (d = l.Ib(e.u.we.Ps(b[g])));
              if (e.v(d)) return [];
              a.push(d.ordinal);
              c++;
            }
            return a;
          }
          KS(f, b, a) {
            this.Yb.nu();
            this.la.I.expand(this.uR(f, b), f, this.la.ja.pa.fd(a));
          }
          $R(f, b, a) {
            this.Yb.nu();
            this.la.I.collapse(this.uR(f, b), f, this.la.ja.pa.fd(a));
          }
          GS(f, b, a, c) {
            this.Yb.nu();
            var d = this.la.ja.pa.rd(f);
            const g = d.ab && d.ie <= b.length ? d.Pa.ea(b.length + 1) : d.Pa.ea(b.length);
            d = g.Ib(c);
            e.v(d) && (c = e.u.we.Ps(c), d = g.Ib(c));
            e.v(d) || (b = this.uR(f, b), b.push(d.ordinal), this.la.I.Pp(b, d, f, this.la.ja.pa.fd(a)));
          }
          FS(f, b, a, c) {
            this.Yb.nu();
            var d = this.la.ja.pa.rd(f);
            const g = d.ab && d.ie <= b.length ? d.Pa.ea(b.length + 1) : d.Pa.ea(b.length);
            d = g.Ib(c);
            e.v(d) && (c = e.u.we.Ps(c), d = g.Ib(c));
            e.v(d) || (b = this.uR(f, b), b.push(d.ordinal), this.la.I.Ae(b, d, f, this.la.ja.pa.fd(a)));
          }
          sw(f) {
            f = this.la.ja.pa.yc().getItem(f);
            null != f && this.bfa(f) && (this.Yb.nu(), this.la.I.sw(f));
          }
          bfa(f) {
            const b = this.la.ja.pa,
              a = b.rows.Bb(f.A) ? e.u.i.ha.Ia : e.u.i.ha.Ra;
            return (a == e.u.i.ha.Ia ? b.xb.indexOf(f.A) : b.Db.indexOf(f.A)) + 1 < (a == e.u.i.ha.Ia ? b.xb.length : b.Db.length);
          }
          Z3() {
            this.la.Fa.Ef == e.model.Wb.up.kp ? this.VG() : this.qf && this.nb();
          }
          b4() {
            this.nva();
          }
          bV() {
            this.qea();
          }
          hV(f) {
            f.stopPropagation();
            this.qea();
          }
          qea() {
            var f = u.nU();
            null != e.model.Xa.jsFullScreenHandler && e.model.Xa.jsFullScreenHandler.call(null, f);
            var b = 0,
              a = () => {
                this.qf.yd() != parseInt(this.qf.element.style.height) && 5 > b ? (b++, this.qf.requestAnimationFrame(a)) : this.Aja() && this.nb(!0);
              };
            this.qf.requestAnimationFrame(a);
          }
          Ie() {
            this.toolbar && (this.G.height -= this.JE);
            this.Yb = new k.Y.qna();
            this.Yb.N(k.Si.$x, f => this.MFa(f));
            this.Yb.N(k.Si.kX, f => this.sga(f));
            this.X(this.Yb);
            this.Bi = new k.od.np();
            this.Bi.N(v.ga.OPENED, () => {});
            this.Bi.N(v.ga.CLOSED, () => {});
            this.Bi.N(k.od.np.WO, () => this.x3());
            this.Bi.N(k.od.np.mJ, f => this.w3(f));
            this.X(this.Bi);
            e.Dk.addEventListener("keydown", f => this.mq(f));
            this.cG = new u.aqa(this.qf.parent);
            this.cG.N(v.ga.fY, f => this.m4(f));
            this.ufa = !0;
          }
          MIa() {
            k.CO.R().Vu && k.CO.R().Gp();
          }
          NY() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            null == this.la || 0 == this.qf.width || f && x.ML.SO.R().CCa || (this.Aja(), this.MIa(), 1 > e.model.Ha.wc.Wj() || (this.yca = !0, this.cG.refresh(), this.MT() && this.Exa(), this.VBa() && (this.X(this.NW), this.NW.nb()), e.model.C.F.tc && this.la.ja.fa && !this.la.ja.fa.RH && (e.model.C.F.tc = !1, e.Wa(e.P.bind(e.model.B.j.Joa, e.u.i.qa.J(this.la.ja.fa.Ba)), e.model.B.j.rP)), e.model.C.F.tc && e.model.C.F.ke == k.Id.Zn && this.la.ja.fa && this.la.ja.fa.Ba == e.u.i.qa.API && (e.model.C.F.ke = k.Id.xt, e.Wa(e.P.bind(e.model.B.j.RX), e.model.B.j.rP, e.tb.Dl)), null != this.Ck && this.Ck.nb(), e.v(this.la.Fa.fa) || this.la.Fa.fa.kb || !e.model.C.F.fS ? this.Bi.Za() : this.Bi.show(), f || e.model.C.F.AC || k.Oa.cF.VK || (e.model.C.F.Cn = !1), e.v(this.la.ja.pa) || e.v(this.la.ja.O) || this.la.ja.O.kb || !this.la.ja.pa.kb || (e.model.C.F.Cn = !0), e.model.C.F.Cn && null != this.la.Fa.fa && !this.la.Fa.fa.kb ? this.Bi.open(this.la.ja.O, this.la.ja.pa, this.la.Fa.fa.Ba) : this.Bi.close(), e.model.C.F.ke == k.Id.kj ? this.o0(f) : e.model.C.F.ke == k.Id.Zn ? this.q0(f) : this.p0(f), null != this.il && this.il.isVisible() && (e.model.C.F.tc && e.model.C.F.ke === k.Id.xt ? this.il.close() : this.il.B4()), this.P2 = this.Zf(), this.O2 = this.yd()));
          }
          VG() {
            e.model.C.F.ke == k.Id.kj ? this.o0(!1, !0) : e.model.C.F.ke == k.Id.Zn ? this.q0(!1) : this.p0(!1, !0);
            e.v(this.Bi) || (this.Bi.close(), this.Bi.Za());
          }
          mW() {
            if (this.la.Fa.fa.Ba == e.u.i.qa.API && e.model.C.F.tc && e.model.C.F.ke == k.Id.kj) {
              const f = e.model.C.F.Qw(!1, !0);
              f.na("viewType", k.Id.xt);
              this.la.wq(f.Sa());
            } else e.model.C.F.ke = k.Id.xt, e.model.C.F.tc && this.Bi && this.Bi.Vu && this.Bi.open(this.la.ja.O, this.la.ja.pa, this.la.Fa.fa.Ba), this.p0();
          }
          p0() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            null != this.Yb && (null != this.jd && this.jd.Za(), null != this.Wk && this.Wk.Za(), f || null == this.Ck || this.Ck.close(), this.Yb.I = b ? null : this.la.I = e.u.Re.Ni.Bc(), this.Yb.G.U("top", "").U("left", "").U("right", "").U("bottom", ""), this.Yb.G.U("position", "absolute"), this.Yb.show(), this.Yb.G.U("height", h.qD + "px"), this.Yb.G.U("width", h.Hx + "px"), b && this.Yb.nu(), this.Yb.nb());
          }
          VN() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            if (this.la.Fa.fa.Ba == e.u.i.qa.API && e.model.C.F.tc && e.model.C.F.ke == k.Id.xt) {
              const a = e.model.C.F.Qw(!1, !0);
              a.na("viewType", k.Id.kj);
              a.na("chartType", f);
              a.na("chartMultipleMeasures", k.Cd.Ne.ifa(f) ? b : !1);
              this.la.wq(a.Sa());
            } else e.model.C.F.ke = k.Id.kj, e.model.C.F.kL = f, e.model.C.F.DG = k.Cd.Ne.ifa(f) ? b : !1, this.o0();
          }
          o0() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            u.io.load("lib/d3.v3.min.js", () => {
              f || null == this.Ck || this.Ck.close();
              null != this.Yb && this.Yb.Za();
              null != this.Wk && this.Wk.Za();
              null == this.jd && this.rG();
              this.jd.G.U("top", "").U("left", "").U("right", "").U("bottom", "");
              this.jd.G.U("position", "absolute");
              this.jd.show();
              this.jd.G.U("height", h.to + "px");
              this.jd.G.U("width", h.vo + "px");
              this.jd.I = b ? null : this.la.I = e.u.Re.Ni.d1(e.model.C.F.MR);
              this.jd.nb();
              e.model.C.F.tc && this.Bi && this.Bi.Vu && this.Bi.open(this.la.ja.O, this.la.ja.pa, this.la.Fa.fa.Ba);
              b || 0 != this.SG.length || (this.Bha = e.Be(() => {
                this.Ya(k.Si.eY);
              }, 1));
            });
          }
          nW() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "bottom";
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            this.la.Fa.fa.Ba == e.u.i.qa.API && e.model.C.F.tc ? e.Wa(e.P.bind(e.model.B.j.RX), e.model.B.j.rP, e.tb.Dl) : (e.model.C.F.ke = k.Id.Zn, e.model.C.F.kL = f, e.model.C.F.Qy = b, e.model.C.F.DG = a, this.q0());
          }
          q0() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            u.io.load("lib/d3.v3.min.js", () => {
              f || null == this.Ck || this.Ck.close();
              null != this.Yb && (this.Yb.show(), this.Yb.I = this.la.I = e.u.Re.Ni.Bc(), null == this.jd && this.rG(), this.jd.show(), this.jd.I = e.u.Re.Ni.d1(e.model.C.F.MR), null == this.Wk && this.Ata(), this.Wk.show(), this.Wk.direction = "left" == e.model.C.F.Qy || "right" == e.model.C.F.Qy ? x.iQ.wY : x.iQ.CJ, this.Wk.jwa = [150, 150, h.Hx - 150, this.zr() - 150], this.xca(e.model.C.F.Qy));
            });
          }
          nHa(f) {
            var b = e.model.C.F.Qy;
            this.xca(b, "left" == b || "right" == b ? f.data.left : f.data.top);
          }
          xca() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "bottom";
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
            var a = h.Hx - h.Gb.RC;
            isNaN(b) && (b = "left" == f || "right" == f ? Math.round(a / 2) : Math.round(this.zr() / 2));
            switch (f) {
              case "bottom":
                h.TQ = a;
                h.SQ = b;
                this.Yb.G.U("width", h.KM + "px");
                this.Yb.G.U("height", h.qD + "px");
                this.Yb.G.U("top", 0).U("left", 0).U("right", "").U("bottom", "");
                h.uQ = a;
                h.oK = this.zr() - this.Yb.G.yd() - this.Wk.yd();
                this.jd.G.U("width", h.vo + "px");
                this.jd.G.U("height", h.oK + "px");
                this.jd.G.U("bottom", this.MT() && !e.v(this.Dm) ? this.Dm.yd() + "px" : 0).U("left", 0).U("right", "").U("top", "");
                this.Wk.G.U("top", b + "px").U("left", "").U("right", "").U("bottom", "");
                break;
              case "top":
                h.uQ = a;
                h.oK = b;
                this.jd.G.U("width", h.vo + "px");
                this.jd.G.U("height", h.to + "px");
                this.jd.G.U("top", 0).U("left", 0).U("right", "").U("bottom", "");
                h.TQ = a;
                h.SQ = this.zr() - this.jd.G.yd() - this.Wk.yd();
                this.Yb.G.U("width", h.KM + "px");
                this.Yb.G.U("height", h.qD + "px");
                this.Yb.G.U("bottom", this.MT() && !e.v(this.Dm) ? this.Dm.yd() + "px" : 0).U("left", 0).U("right", "").U("top", "");
                this.Wk.G.U("top", b + "px").U("left", "").U("right", "").U("bottom", "");
                break;
              case "left":
                h.uQ = b;
                h.oK = this.zr();
                this.jd.G.U("width", h.vo + "px");
                this.jd.G.U("height", h.to + "px");
                this.jd.G.U("top", 0).U("left", 0).U("right", "").U("bottom", "");
                h.TQ = a - this.jd.G.Zf() - this.Wk.Zf();
                h.SQ = this.zr();
                this.Yb.G.U("width", h.KM + "px");
                this.Yb.G.U("height", h.qD + "px");
                this.Yb.G.U("top", 0).U("right", h.Gb.RC + "px").U("left", "").U("bottom", "");
                this.Wk.G.U("left", b + "px").U("top", "").U("right", "").U("bottom", "");
                break;
              case "right":
                h.TQ = b, h.SQ = this.zr(), this.Yb.G.U("width", h.KM + "px"), this.Yb.G.U("height", h.qD + "px"), this.Yb.G.U("top", 0).U("left", 0).U("right", "").U("bottom", ""), h.uQ = a - this.Yb.G.Zf() - this.Wk.Zf(), h.oK = this.zr(), this.jd.G.U("width", h.vo + "px"), this.jd.G.U("height", h.to + "px"), this.jd.G.U("top", 0).U("right", h.Gb.RC + "px").U("left", "").U("bottom", ""), this.Wk.G.U("left", b + "px").U("top", "").U("right", "").U("bottom", "");
            }
            this.Yb.G.U("position", "absolute");
            this.jd.G.U("position", "absolute");
            this.Yb.nb();
            this.jd.nb();
          }
          sga(f) {
            null == this.il && this.cta();
            for (var b, a = this.la.ja.pa.gd(), c = 0; c < a.length; c++) {
              var d = a[c];
              d.A == f.measure.A && d.aa == f.measure.aa && (b = d);
            }
            this.il.Qo(this.la.I, this.la.ja.pa, f.Gg, f.th, b, f.cell);
          }
          FHa(f) {
            if (null != this.la.ja && null != this.la.ja.O) {
              var b = this.la.ja.O.yc(!1).getItem(f),
                a = this.la.ja.pa;
              null != b && (a.ob.Bb(f) || a.rows.Bb(f) || a.Ka.Bb(f)) && (f = {
                hierarchy: b.ij()
              }, e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.$x, f)), this.kI(b));
            }
          }
          rV() {
            e.v(this.la.Fa.fa) || this.la.Fa.fa.kb || ("right" == e.model.C.F.QC ? (e.model.C.F.AC = !0, e.model.C.F.Cn = !0, this.nb()) : this.Bi.open(this.la.ja.O, this.la.ja.pa, this.la.Fa.fa.Ba));
          }
          nL() {
            "right" == e.model.C.F.QC ? (e.model.C.F.AC = !1, e.model.C.F.Cn = !1, this.nb()) : this.Bi.close();
          }
          w3(f) {
            if (!u.Nc.Jg(this.la.ja.pa.Ej)) {
              var b = new e.model.hb.wp();
              b.Ej = this.la.ja.pa.Ej;
              f.data.Ej = b.Ej;
            }
            this.la.fe(f.data);
          }
          rCa() {
            return !e.v(this.la.Fa.fa) && (!this.la.Fa.fa.Ic || this.la.Fa.fa.Ba === e.u.i.qa.API) && !this.la.ja.O.kb || e.model.C.F.iu && this.la.Fa.fa.Ba === e.u.i.qa.Cc;
          }
          xN() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            e.v(this.la.Fa.fa) || this.la.Fa.fa.kb || !this.rCa() || (e.v(b) || (this.My = "string" == typeof b ? e.model.Xa.Uda(b) : b), e.ia(f) || e.model.Va.R().N(k.Oa.fk.CA, this.Oy), e.model.Va.R().Ea(new k.Oa.gX(f)), e.model.Va.R().N(k.Oa.fk.BA, this.Ny), e.model.Va.R().N(k.Oa.fk.DA, this.Py));
          }
          cv(f) {
            e.model.Va.R().pb(k.Oa.fk.BA, this.Ny);
            e.v(this.My) || this.My({
              uniqueName: f.Os,
              isRemoved: !1
            });
            this.My = null;
          }
          dv(f) {
            e.model.Va.R().pb(k.Oa.fk.CA, this.Oy);
            e.v(this.My) || this.My({
              uniqueName: f.Os,
              isRemoved: !0
            });
            this.My = null;
          }
          oN() {
            e.model.Va.R().pb(k.Oa.fk.DA, this.Py);
            this.My = null;
          }
          LFa(f) {
            null == this.Ck && this.TZ();
            this.Ck.G.$a("fm-charts-filter", !0);
            this.gV(f);
          }
          MFa(f) {
            null == this.Ck && this.TZ();
            this.Ck.G.$a("fm-charts-filter", !1);
            this.gV(f);
          }
          gV(f) {
            var b = {
              hierarchy: f.hierarchy.ij()
            };
            e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.$x, b));
            this.kI(f.hierarchy);
          }
          kI(f) {
            null == this.Ck && this.TZ();
            this.Ck.Qo(f);
          }
          nva() {
            null != this.il && this.il.close();
          }
          Exa() {
            null != this.Dm && null != this.HW || this.Psa();
            this.X(this.Dm);
            this.Dm.$a("fm-layout-660", 660 > this.Dm.Zf());
            this.Dm.$a("fm-layout-520", 520 > this.Dm.Zf());
            var f = "";
            e.model.Ha.wc.mv && (f = e.model.Ha.ra.J(e.model.Ha.ra.xja) + "(" + u.Eh.format(e.model.Ha.wc.dH, "MM/dd/yyyy") + ")", new Date(Date.now() + 432E6) > e.model.Ha.wc.dH && (f += e.model.Ha.ra.J(e.model.Ha.ra.rya)));
            e.model.Ha.wc.Np && (u.Vea() || e.model.Ha.wc.mca || (f = e.model.Ha.ra.J(e.model.Ha.ra.vxa) + e.model.Ha.wc.R2 + ")"));
            this.HW.gb(f, !0);
          }
          x3() {
            this.rV();
          }
          mq(f) {
            if (this.Pm || this.O1) 73 === f.keyCode && (f.ctrlKey || f.metaKey) && f.altKey && this.Kia(), 72 === f.keyCode && (f.ctrlKey || f.metaKey) && f.altKey && this.eKa(!this.pU), 27 === f.keyCode && (null != this.Ck && this.Ck.close(), null != this.il && (this.il.Mt.Vu ? this.il.Mt.close() : this.il.close()), null != this.zG && this.zG.isVisible() ? this.zG.close() : this.Bi.close());
          }
          eKa(f) {
            f ? (f = document.querySelector("link[data-fm-hc-theme]")) ? (f.disabled = !1, this.pU = !0, this.nb()) : u.io.T2(this.Cea, {
              eL: {
                "data-fm-hc-theme": ""
              },
              xj: !0
            }, () => {
              this.pU = !0;
              this.nb();
            }) : (u.io.oLa(), this.nb(), this.pU = !1);
          }
          fKa(f) {
            this.Cea = f;
          }
          DFa(f) {
            this.il && this.il.isVisible() ? this.il.Bk(f.zu, f.sb, f.Fp) : e.model.C.F.ke == k.Id.xt ? (this.Yb.I = e.u.Re.Ni.Bc(e.model.C.F.rD == k.Y.se.Gh ? "flat" : "pivot"), this.Yb.Bk(f.zu, f.sb, f.Fp)) : e.model.C.F.ke != k.Id.kj || f.zu != e.model.Dc.nj.Xh && f.zu != e.model.Dc.nj.fF ? e.model.C.F.ke == k.Id.kj ? (null == this.jd && this.rG(), this.jd.Bk(f.sb)) : e.model.C.F.ke == k.Id.Zn && (f.zu == e.model.Dc.nj.VA || f.zu == e.model.Dc.nj.zv || f.zu == e.model.Dc.nj.cB ? (null == this.jd && this.rG(), this.jd.Bk(f.sb, !0, b => {
              this.Yb.Bk(f.zu, f.sb, f.Fp, b);
            })) : this.Yb.Bk(f.zu, f.sb, f.Fp)) : (this.Yb.I = e.u.Re.Ni.Bc(e.model.C.F.rD == k.Y.se.Gh ? "flat" : "pivot"), this.eH = f, h.Gb.N(k.Si.ip, this.Sca), this.Yb.nb());
          }
          NGa() {
            e.model.C.F.ke == k.Id.xt ? this.Yb.print() : e.model.C.F.ke == k.Id.kj ? (null == this.jd && this.rG(), this.jd.print()) : e.model.C.F.ke == k.Id.Zn && (null == this.jd && this.rG(), this.jd.print(f => this.UEa(f)));
          }
          UEa(f) {
            this.Yb.print(f);
          }
          MT() {
            e.model.Ha.wc.Wj();
            return e.model.Ha.wc.Ky || e.model.Ha.wc.qq ? !1 : !0;
          }
          VBa() {
            return !e.model.Ha.wc.qq && !e.model.Ha.wc.Np && !e.model.Ha.wc.Ky;
          }
          Kia() {
            var f = new Date(parseFloat(e.kh.TW) / 61);
            let b = u.Eh.format(f, "MMMM yyyy") + " (v. " + e.kh.Nr + ")";
            b += e.model.Ha.ra.J(e.model.Ha.ra.eC);
            b += e.P.bind(e.model.Ha.ra.J(e.model.Ha.ra.vua), u.Eh.format(f, "MM/dd/yyyy HH:mm:ss"));
            b += e.model.Ha.ra.J(e.model.Ha.ra.eC);
            b += e.model.Ha.ra.J(e.model.Ha.ra.gxa) + e.model.Ha.wc.EDa();
            e.model.Ha.wc.Np ? b += e.model.Ha.ra.J(e.model.Ha.ra.HHa) + e.model.Ha.wc.R2 : e.model.Ha.wc.qq && (b += e.model.Ha.ra.J(e.model.Ha.ra.Bxa) + e.model.Ha.wc.Jfa);
            f = !1;
            e.model.Ha.wc.mv ? e.model.Ha.wc.Np || e.model.Ha.wc.qq ? b += e.model.Ha.ra.J(e.model.Ha.ra.ADa) + u.Eh.format(e.model.Ha.wc.dH, "MM/dd/yyyy") : (f = !0, b += e.model.Ha.ra.J(e.model.Ha.ra.jLa) + u.Eh.format(e.model.Ha.wc.dH, "MM/dd/yyyy")) : b += e.model.Ha.ra.J(e.model.Ha.ra.BDa);
            f || (b += e.model.Ha.ra.J(e.model.Ha.ra.cja) + u.Eh.format(e.model.Ha.wc.AW, "MM/dd/yyyy"));
            b += e.model.Ha.ra.J(e.model.Ha.ra.DDa) + e.model.Ha.wc.Xy;
            b += e.model.Ha.ra.J(e.model.Ha.ra.info);
            e.Wa(b, e.model.Ha.ra.J(e.model.Ha.ra.vva), e.tb.lP);
          }
          Xf(f, b) {
            return this.Yb.Xf(f, b);
          }
          sT(f, b) {
            return this.Yb.sT(f, b);
          }
          CH() {
            return this.Yb.CH();
          }
          jA(f, b) {
            this.Yb.jA(f, b);
          }
          mE() {
            this.Yb.mE();
          }
          get JM() {
            return this.Yb.JM;
          }
          get IM() {
            return this.Yb.IM;
          }
          HGa(f) {
            null == this.zG && this.Rsa();
            this.zG.Qo(f.Os);
          }
          IGa(f) {
            null == this.contextMenu && this.Usa();
            var b = f.data.nEa;
            b && 0 < b.length && this.contextMenu.Xo(this.G, b, f.data.coords, null, f.data.XK);
          }
          HEa() {
            0 == this.SG.length && (this.Bha = e.Be(() => {
              this.Ya(k.Si.eY);
            }, 1));
          }
          Rsa() {
            this.zG = new k.Oa.cF();
            this.X(this.zG);
          }
          rG() {
            this.jd = new k.Cd.tv();
            this.jd.N(k.Si.$x, f => this.LFa(f));
            this.jd.N(k.Si.kX, f => this.sga(f));
            this.X(this.jd);
          }
          cta() {
            this.il = new k.Uf.eF();
            this.X(this.il);
          }
          TZ() {
            this.Ck = new k.filter.hna();
            this.Ck.N(v.ga.OPENED, () => {});
            this.Ck.N(v.ga.CLOSED, () => {});
            this.X(this.Ck);
          }
          Ata() {
            this.Wk = new x.iQ();
            this.Wk.Za();
            this.Wk.N(x.iQ.rX, f => this.nHa(f));
            this.X(this.Wk);
          }
          Usa() {
            this.contextMenu = new x.fr.GF(h.Gb.G);
            this.contextMenu.$("fm-context-menu");
            this.contextMenu.Za();
            this.X(this.contextMenu);
          }
          Psa() {
            this.Dm = new x.be.ik();
            this.Dm.$("fm-branding-bar");
            this.HW = new x.Vc();
            this.HW.$("fm-version-label");
            this.Dm.X(this.HW);
            this.GW = new x.Vc();
            this.GW.$("fm-link");
            this.GW.gb(e.model.Ha.ra.J(e.model.Ha.ra.$ga), !0);
            this.Dm.X(this.GW);
            var f = new x.Ga("span", "fm-info-icon");
            f.N("click", () => this.Kia());
            this.GW.G.append(f);
            this.NW = new k.pra();
          }
          dispose() {
            this.la = null;
            this.Yb && this.Yb.dispose();
            this.jd && this.jd.dispose();
            this.il && this.il.dispose();
            this.G.dispose();
            this.qf.dispose();
            k.CO.dispose();
            k.filter.W7.dispose();
            k.bY.dispose();
            x.ML.SO.dispose();
            u.pP.dispose();
            h.Gb = null;
            this.toolbar && (this.toolbar.dispose && this.toolbar.dispose(), this.toolbar = null);
            this.cG && (this.cG.Td(v.ga.fY), this.cG.dispose(), this.cG = null);
          }
        }
        k.Nb = h;
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          static ah(f) {
            if (e.v(f) || "string" != typeof f) return !1;
            f = f.toLowerCase();
            return f == h.xt || f == h.kj || f == h.Zn;
          }
        }
        h.xt = "grid";
        h.kj = "charts";
        h.Zn = "grid_charts";
        k.Id = h;
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor() {
            this.wm = 0;
            this.iG = !1;
            this.tK = this.aG = "";
            this.mG = !1;
          }
          show(f, b, a) {
            let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
            let d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
            f ? (d && this.o5(f, b, a, c), 0 == this.iG ? (this.iG = f, this.aG = b, this.tK = a, this.mG = c, this.wm = e.Be(() => this.eja(), h.d7)) : 0 == this.wm ? this.o5(f, b, a, c) : (this.iG = f, this.aG = b, this.tK = a, this.mG = c)) : (d && this.o5(f, b, a, c), 1 == this.iG && (this.iG = f, this.wm = e.Be(() => this.eja(), h.d7)));
          }
          o5(f, b, a, c) {
            this.Dha();
            this.dha(f, b, a, c);
          }
          eja() {
            this.Dha();
            this.dha(this.iG, this.aG, this.tK, this.mG);
          }
          Dha() {
            e.kr(this.wm);
            this.wm = 0;
          }
          dha(f, b, a, c) {
            k.bY.R() && k.bY.R().Qo(f, b, a, c);
          }
          static R() {
            null == h.xe && (h.xe = new h());
            return h.xe;
          }
          static dispose() {
            h.xe = null;
          }
        }
        h.d7 = 250;
        k.Mpa = h;
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h extends x.be.oy {
          constructor() {
            if (null != h.xe) throw Error("Singleton");
            super(k.Nb.Gb.G);
            this.$("fm-preloader-view");
            this.Rk("status");
            this.Ie();
          }
          Qo() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
            let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
            this.aG = b;
            this.tK = a;
            this.msa = c;
            f ? this.open() : this.close();
          }
          open() {
            super.open();
            this.nb();
          }
          Ie() {
            this.aE.$("fm-overlay-preloader");
            this.aE.pb("click", this.V$);
            this.D$ = new x.Na("div", "fm-spinner");
            this.D$.ro();
            this.X(this.D$);
            this.ms = new x.Vc();
            this.ms.ro();
            this.ms.$("fm-message-label");
            this.X(this.ms);
            this.vR = new x.Vc();
            this.vR.ro();
            this.vR.$("fm-details-label");
            this.X(this.vR);
            this.Za();
            k.Nb.Gb.X(this);
          }
          nb() {
            this.aE.kKa(!this.msa);
            this.yI(this.aG);
            this.$Ja(this.tK);
            this.qc(this.aG);
            this.validate();
          }
          yI(f) {
            this.ms.gb(f);
          }
          $Ja(f) {
            this.vR.gb(f);
          }
          close() {
            super.close();
            this.clear();
          }
          clear() {
            this.yI("");
            this.yI("");
          }
          static R() {
            if (null == k.Nb.Gb) return null;
            null == h.xe && (h.xe = new h());
            return h.xe;
          }
          static dispose() {
            h.xe = null;
          }
        }
        k.bY = h;
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Ga {
            constructor() {
              super("div", "fm-charts-layout");
              this.q5 = !0;
              this.Ul();
              this.Ie();
            }
            Ie() {
              this.b0();
              this.Lwa();
            }
            b0() {
              this.zp = new x.Vc();
              this.zp.G.display = "block";
              this.zp.$("fm-chart-title");
              this.zp.$("fm-pivot-title");
              this.zp.jW(!0);
              this.zp.G.U("position", "relative");
              this.zp.Za();
              this.$B(this.zp);
            }
            Lwa() {
              this.Sq = new x.Na("div", "fm-ui-row fm-header-toolbar");
              this.$B(this.Sq);
              this.$v = new x.Na("div", "fm-ui-col-2");
              this.$v.G.display = "inline-block";
              this.Sq.X(this.$v);
              this.el = new x.Ad.Yr();
              this.el.$("fm-chart-measures-dropdown");
              this.el.N(v.ga.Zd, a => this.pGa(a));
              this.el.Za();
              this.$v.X(this.el);
              this.hs = new x.Ad.Yr();
              this.hs.$("fm-chart-pie-dropdown");
              this.hs.N(v.ga.Zd, a => this.MGa(a));
              this.hs.Za();
              this.$v.X(this.hs);
              this.Yq = new x.Na("div", "fm-ui-col-2 fm-charts-filters-container");
              this.Yq.G.display = "inline-block";
              this.Sq.X(this.Yq);
              this.gs = new x.Ad.Yr();
              this.gs.pl = !1;
              this.gs.$("fm-charts-filters-btn");
              this.gs.ki(e.model.B.j.lB);
              this.gs.N(v.ga.Zd, a => this.uga(a));
              this.gs.ji(this.xya);
              this.Sq.X(this.gs);
            }
            xya(a, c) {
              var d = new b();
              d.setData(a);
              d.Ym(c);
              d.$("fm-charts-filter");
              d.G.attr("title", e.model.B.j.lB);
              return d;
            }
            get Fr() {
              return this.zp;
            }
            get sg() {
              return this.rn;
            }
            get us() {
              return this.yp;
            }
            resize(a, c) {
              this.LB = a;
              this.KB = c;
            }
            NCa() {
              return !this.gs.isVisible() && !this.Yq.isVisible() && !this.el.isVisible() && !this.hs.isVisible();
            }
            nb() {
              this.width = this.LB;
              this.height = this.KB;
              e.v(this.I) || this.I.kb ? this.tKa && this.Vxa() : (e.ia(e.model.C.F.An) || this.s0(), null != this.Eb && (this.Sq.G.$a("fm-fields-list-padding", this.QBa), this.el.Za(), this.hs.Za(), e.model.C.F.Gx && e.model.C.F.Hia && this.Hxa(), this.Eb.type != h.Ne.bF && e.model.C.F.Dia && this.Oxa(), this.Eb.type == h.Ne.Cv && 1 < this.Eb.Cl.length && this.Sxa(), this.NCa() && this.Sq.Za(), e.model.C.F.Cia && this.Eb.sg && 0 < this.Eb.sg.length && this.wca(), this.uca(), e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.QW))));
            }
            get QBa() {
              return e.model.C.F.fS && !(e.model.C.F.Cn && "right" == e.model.C.F.QC) && !(e.model.C.F.ke == k.Id.Zn && ("bottom" == e.model.C.F.Qy || "left" == e.model.C.F.Qy));
            }
            clear() {
              this.zp.Za();
              this.Sq.Za();
              this.el.Za();
              this.hs.Za();
              this.Yq.Za();
              this.gs.Za();
              this.$v.Gd("fm-wide");
              this.yp && (this.yp.Lg(!0), this.yp = null);
              this.rn && (this.rn.Lg(!0), this.rn = null);
              this.XB && this.XB.Za();
            }
            get tKa() {
              return e.model.Va.R().Fa.nE == e.model.Wb.Uc.pi && (e.v(this.I) || this.I.kb && !e.model.C.F.m5);
            }
            Vxa() {
              null == this.XB && (this.XB = new x.Vc(e.model.B.j.F6), this.XB.$("fm-charts-msg"), this.$B(this.XB));
              this.XB.gb(e.model.B.j.F6);
              this.XB.show();
            }
            s0() {
              this.zp.gb(e.model.C.F.An);
              this.zp.show();
            }
            Oxa() {
              var a = [],
                c = this.I.Ca;
              const d = this.Eb.OK;
              for (var g = 0; g < c.length; g++) {
                var l = c[g],
                  m = new e.model.hb.jh(l.A, l.aa, l.index);
                m.label = e.P.Go(l.label, !0, !0);
                a.push(m);
              }
              if (e.model.C.F.k5 || !e.model.C.F.k5 && 1 < a.length) {
                this.el.xE(e.model.B.j.Cka);
                this.el.Bfa = this.el.qo && this.Eb.Pz;
                this.el.qo = this.Eb.Pz;
                this.el.cg(a);
                if (this.Eb.Pz) {
                  c = [];
                  for (g = 0; g < a.length; g++) for (l = a[g], m = 0; m < d.length; m++) if (l.A == d[m].A && (l.aa == d[m].aa || e.ia(d[m].aa)) && (l.index == d[m].index || -1 == d[m].index)) {
                    c.push(g);
                    break;
                  }
                  this.el.SN(c);
                } else {
                  a = d[0];
                  const n = new e.model.hb.jh(a.A, a.aa, a.index);
                  this.el.ft(p => p.index === n.index);
                }
                this.el.show();
                this.Sq.show();
                this.Eb.type == h.Ne.Cv && 1 < this.Eb.Cl.length ? this.el.Tk(this.$v.Zf() / 2 - 10) : this.el.Tk(this.$v.Zf() - 10);
              }
            }
            Sxa() {
              for (var a = [], c = 0; c < this.Eb.Cl.length; c++) a.push({
                label: e.P.Go(this.Eb.Cl[c].label, !0, !0)
              });
              this.hs.cg(a);
              this.hs.Sk(e.model.C.F.jL);
              this.hs.show();
              this.Sq.show();
              this.hs.Tk(this.$v.Zf() / 2 - 10);
            }
            Hxa() {
              this.Yq.G.xx();
              if (null != e.u.Ma.R().pa) {
                var a = e.u.Ma.R().pa.yc(!1),
                  c = [];
                for (var d = 0; d < a.length; d++) {
                  var g = a.ea(d);
                  this.Yea(g) && (g = this.Iwa(a.ea(d)), c.push(g), this.Yq.X(g));
                }
                0 === c.length ? this.Yq.Za() : this.Yq.show();
                this.Sq.show();
                a = 0;
                for (c = 0; c < this.Yq.G.element.children.length; c++) d = this.Yq.G.element.children.item(c), a += d.offsetWidth;
                a > this.Yq.Zf() && this.Ixa();
              }
            }
            Yea(a) {
              return e.u.Ma.R().fa.mapping.La(a.A, "filters");
            }
            Ixa() {
              const a = [],
                c = e.u.Ma.R().pa.yc(!1);
              for (let d = 0; d < c.length; d++) {
                const g = c.ea(d);
                this.Yea(g) && a.push({
                  label: g.caption,
                  A: g.A,
                  mU: g.filter.zh
                });
              }
              this.gs.cg(a);
              0 === a.length ? this.gs.Za() : this.gs.show();
              this.Yq.Za();
              this.$v.$("fm-wide");
            }
            Iwa(a) {
              var c = new x.Qg();
              c.$("fm-ui-btn-superlight");
              c.$("fm-charts-filter");
              c.G.$a("fm-filtered", a.filter.zh);
              c.N(x.Nd.tf, d => this.uga(d));
              c.gb(a.label);
              c.G.attr("data-hierarchy", a.A);
              c.G.attr("title", e.model.B.j.lB);
              return c;
            }
            uca() {
              null != this.yp && this.yp.Lg(!0);
              this.yp = h.qla.Vza(this.Eb.type);
              this.$B(this.yp);
              this.yp.g5((c, d, g) => this.AHa(c, d, g));
              var a = this.KB - this.zp.yd(!0) - this.Sq.yd(!0) - this.yp.padding.top - this.yp.padding.bottom;
              this.rn && (a -= this.rn.G.element.offsetHeight);
              this.yp.Ud(this.Eb, this.LB - 20, a);
              this.yp.G.U("max-width", this.LB + "px");
              this.yp.G.U("max-height", a + "px");
            }
            wca() {
              null != this.rn && this.rn.Lg(!0);
              this.rn = new h.sg.rla(this.q5);
              this.rn.$("fm-chart-legend");
              this.rn.VJa((a, c, d) => this.gGa(a, c, d));
              this.rn.N(v.ga.Zd, () => this.fGa());
              this.rn.WJa(this.Eb.Hp);
              this.rn.Ud(this.Eb.sg);
              this.rn.WH.U("max-height", (this.KB - this.zp.yd(!0) - this.Sq.yd()) / 2 + "px");
              this.$B(this.rn);
            }
            fGa() {
              this.q5 = !this.q5;
              this.wca();
              this.uca();
            }
            ez(a, c, d) {
              null == d || d.dc || d.Sh || ((a == e.u.i.ha.Ia ? this.I.Bh(c, d) : this.I.Bj(c, d)) ? this.I.Pp(c, d, a) : this.I.Ae(c, d, a));
            }
            yu(a, c) {
              a == e.u.i.ha.Ia ? this.I.Th(c) ? this.I.collapse(c, e.u.i.ha.Ia) : this.I.expand(c, e.u.i.ha.Ia) : this.I.Xj(c) ? this.I.collapse(c, e.u.i.ha.Ra) : this.I.expand(c, e.u.i.ha.Ra);
            }
            Mca(a, c) {
              a == e.u.i.ha.Ia ? c.length <= e.model.C.F.ku.length ? this.I.collapse(c, e.u.i.ha.Ia) : this.I.expand(c, e.u.i.ha.Ia) : c.length <= e.model.C.F.mC.length ? this.I.collapse(c, e.u.i.ha.Ra) : this.I.expand(c, e.u.i.ha.Ra);
            }
            uga(a) {
              a = a.type == v.ga.Zd ? a.data.xl.A : a.target.G.attr("data-hierarchy");
              a = e.u.Ma.R().O.ph(a);
              this.Ea(new k.hP(a));
            }
            gGa(a, c, d) {
              e.model.C.F.uo ? "expand" == a ? this.Mca(this.Eb.VH, c) : "drill" == a && this.ez(this.Eb.VH, c, d) : "expand" == a ? this.yu(this.Eb.VH, c) : "drill" == a && this.ez(this.Eb.VH, c, d);
            }
            AHa(a, c, d) {
              var g = this.Eb.VH == e.u.i.ha.Ra ? e.u.i.ha.Ia : e.u.i.ha.Ra;
              e.model.C.F.uo ? "expand" == a ? this.Mca(g, c) : "drill" == a && this.ez(g, c, d) : "expand" == a ? this.yu(g, c) : "drill" == a && this.ez(g, c, d);
            }
            pGa(a) {
              if (this.Eb.Pz) {
                for (var c = [], d = this.el.AM().slice(), g = 0; g < d.length; g++) (a = d[g]) && c.push(a);
                e.model.C.F.CG = c;
              } else e.model.C.F.so = a.data.xl;
              this.Ya("chart_changed");
            }
            MGa(a) {
              e.model.C.F.jL = a.data.selectedIndex;
              this.Ya("chart_changed");
            }
          }
          h.ula = f;
          class b extends x.Ii.nB {
            nb() {
              var a = this.getData();
              null == this.label && (this.label = new x.Vc(), this.label.$("fm-text-display"), this.G.append(this.label.G));
              this.label.gb(a[this.mr()], !0);
              this.G.$a("fm-filtered", !0 === a.mU);
              this.G.attr("data-hierarchy", a.A);
            }
          }
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static validate(a) {
              return a == f.EA || a == f.RE || a == f.EJ || a == f.Cv || a == f.ZJ || a == f.jB || a == f.bF ? a : a == f.lqa ? f.jB : a == f.Gka ? f.bF : a == f.r6 ? f.RE : f.EA;
            }
            static ifa(a) {
              if ("string" != typeof a || e.ia(a)) return !1;
              a = a.toLowerCase();
              return a == f.EA || a == f.RE || a == f.r6 || a == f.EJ || a == f.ZJ ? !0 : !1;
            }
          }
          f.EA = "column";
          f.RE = "bar_h";
          f.r6 = "bar_horizontal";
          f.EJ = "line";
          f.Cv = "pie";
          f.ZJ = "scatter";
          f.jB = "stacked_column";
          f.lqa = "bar_stack";
          f.bF = "column_line";
          f.Gka = "bar_line";
          h.Ne = f;
          class b {}
          b.hB = "series";
          b.EF = "series_label";
          b.Lna = "legend";
          h.Vn = b;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(c) {
                if (!e.v(c)) for (let d in c) c.hasOwnProperty(d) && (this[d] = c[d]);
              }
              Sa() {
                const c = {};
                e.v(this.label) || (c.label = this.label);
                e.v(this.color) || (c.color = this.color);
                e.v(this.Zb) || (c.member = this.Zb.Sa());
                e.v(this.gg) || (c.tuple = this.lLa == e.u.i.ha.Ia ? e.model.Va.R().ja.pa.Q_(this.gg) : e.model.Va.R().ja.pa.P_(this.gg));
                e.v(this.measure) || (c.measure = {
                  uniqueName: this.measure.A,
                  caption: this.measure.caption,
                  aggregation: this.measure.aa
                });
                e.v(this.level) || (c.level = this.level);
                e.v(this.$f) || (c.isExpanded = this.$f);
                e.v(this.isCollapsed) || (c.isCollapsed = this.isCollapsed);
                e.v(this.Yg) || (c.isDrilledDown = this.Yg);
                e.v(this.OH) || (c.isDrilledUp = this.OH);
                return c;
              }
            }
            f.s8 = b;
            class a {
              constructor() {
                this.Pz = !1;
                this.Rx = this.qt = this.pt = "";
                this.Cl = [];
                this.Mi = [];
                this.VH = e.u.i.ha.Ra;
                this.Vw = [];
                this.data = [];
                this.Aw = [];
                this.BE = this.ju = this.tfa = this.nfa = this.Pea = this.bx = this.ce = this.Fe = !1;
              }
            }
            f.sla = a;
          })(h.W || (h.W = {}));
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.be.ik {
            constructor() {
              super();
              this.vo = 600;
              this.to = 400;
              this.ega = 15;
              this.g3 = 3;
              this.$("fm-chart");
            }
            Ud(b, a, c) {
              this.vo = a;
              this.to = c;
              this.Eb = b;
              this.fCa(this.vo, this.to);
            }
            fCa(b, a) {
              d3v3.select(k.Nb.Gb.qf.element).select(".fm-chart").selectAll("svg").remove();
              this.svg = d3v3.select(k.Nb.Gb.qf.element).select(".fm-chart").append("svg").attr("width", b).attr("height", a).append("g");
            }
            g5() {}
            B0(b) {
              this.G.U("overflow-y", "auto");
              d3v3.select(k.Nb.Gb.qf.element).select(".fm-chart").selectAll("svg").attr("height", b);
            }
            Ica(b) {
              this.G.U("overflow-x", "auto");
              d3v3.select(k.Nb.Gb.qf.element).select(".fm-chart").selectAll("svg").attr("width", b);
            }
            Pl(b, a) {
              if (e.Kg(h.tv.EC)) {
                var c = h.tv.EC,
                  d = h.tv.hba,
                  g = this.Eb.type;
                b.each(function (l) {
                  l = d(l.data ? l.data : l);
                  l.type = a;
                  l.chartType = g;
                  c(this, l);
                });
              }
            }
            vQ(b) {
              b.forEach(a => {
                Infinity === Math.abs(a.value) && (a.value = 0);
                a.Wh && this.vQ(a.Wh);
              });
            }
          }
          h.VW = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.VW {
            constructor() {
              super();
              this.Rx = this.qt = this.pt = "";
              this.vO = 0;
              this.Uia = !1;
              this.qA = 10;
              this.wG = 200;
              this.g_ = [0, 15, 30, 45, 60, 75, 90];
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.pt = b.pt;
              this.qt = b.qt;
              this.Rx = b.Rx;
            }
            sk(b, a) {
              this.dw = this.vo;
              this.Pt = this.to;
              this.qA = this.Eb.BE ? 20 : 10;
              this.wG = this.dw / 5;
              this.vQ(b);
              this.NZ(b, a);
              this.svg.attr("transform", "translate(" + this.OW + ", " + this.qA + ")");
            }
            tM(b) {
              return d3v3.max(b, function (a) {
                return d3v3.max(a.Wh, function (c) {
                  return c.value;
                });
              });
            }
            wM(b) {
              return d3v3.min(b, function (a) {
                return d3v3.min(a.Wh, function (c) {
                  return c.value;
                });
              });
            }
            g5(b) {
              this.ou = b;
            }
            yu(b) {
              if (!e.v(b) && this.ou) {
                var a = b.data,
                  c = b.Aw,
                  d = b.nh || b.Hg;
                b.collapsed || b.Vf ? this.ou("expand", a, c) : d && this.ou("drill", a, c);
              }
            }
            NZ(b, a) {
              var c = this.vo,
                d = this.to,
                g = this.tM(b),
                l = this.wM(b);
              g = 0 > g && (!this.Eb.ju || l == g) ? 0 : g;
              l = 0 > l || this.Eb.ju && l != g ? l : 0;
              this.lm = d3v3.scale.linear().range([d, 0]).domain([l, g]).nice();
              var m = this.Eb.Fu,
                n = this.Eb.Fe,
                p = this.Eb.ce,
                t = this.Eb.bx,
                r = !0 === e.model.C.F.lC || null === e.model.C.F.lC && 1E7 < g,
                w = this.Eb.nda,
                y = d3v3.svg.axis().scale(this.lm).orient("left").tickFormat(function (aa) {
                  return e.P.bca(w(aa, m, n, p, t, r));
                }),
                A = 0,
                B = 0,
                C = 0;
              b = this.svg.append("g").attr("class", "fm-y fm-axis").call(y).each(function () {
                A = this.getBBox().width;
              });
              b.append("text").attr("class", "fm-y fm-axis fm-axis-label fm-title").text(this.qt).each(function () {
                B = this.getBBox().width;
              }).style("text-anchor", "end").attr("dy", "-0.5em").attr("transform", "translate(-" + A + ", 0) rotate(-90)");
              b.each(function () {
                A = this.getBBox().width;
                c -= A;
              });
              this.OW = A;
              var I = !e.v(a) && 0 < a.length;
              if (I) {
                var L = this.tM(a),
                  Y = this.wM(a);
                L = 0 > L && (!this.Eb.ju || Y == L) ? 0 : L;
                Y = 0 > Y || this.Eb.ju && Y != L ? Y : 0;
                var D = !0 === e.model.C.F.lC || null === e.model.C.F.lC && 1E7 < L;
                this.uO = d3v3.scale.linear().range([d, 0]).domain([Y, L]).nice();
                var E = this.Eb.T0,
                  G = this.Eb.Pea,
                  F = this.Eb.nfa,
                  J = this.Eb.tfa,
                  H = d3v3.svg.axis().scale(this.uO).orient("right").tickFormat(function (aa) {
                    return e.P.bca(w(aa, E, G, F, J, D));
                  }),
                  M = 0,
                  K = this.svg.append("g").attr("class", "fm-y fm-axis fm-axis-2").call(H).each(function () {
                    M = this.getBBox().width;
                  });
                K.append("text").attr("class", "fm-y fm-axis fm-axis-label-2 fm-title").text(this.Rx).each(function () {
                  C = this.getBBox().width;
                }).attr("dy", "1.3em").attr("transform", "translate(" + (M + 20) + ", 0) rotate(90)");
                K.each(function () {
                  M = this.getBBox().width + 2;
                  c -= M;
                }).attr("transform", "translate(" + c + ", 0)");
              }
              var Q = this.Eb.Cl,
                N = Math.max(Q.length * Math.max(this.Uia ? this.g3 : this.Eb.Vw.length * this.g3, this.ega), c);
              I && K.attr("transform", "translate(" + N + ", 0)");
              a = N > c;
              this.ek = d3v3.scale.ordinal().rangeRoundBands([0, N], a ? 0 : .1).domain(Q.map(function (aa) {
                return aa.id;
              }));
              Q = d3v3.svg.axis().scale(this.ek).tickFormat(function () {
                return "";
              }).orient("bottom");
              Q = this.svg.append("g").attr("class", "fm-x fm-axis").call(Q);
              this.c_(Q);
              var W,
                O = Q.each(function () {
                  W = this.getBBox().height;
                }).append("text").attr("class", "fm-x fm-axis fm-title").attr("dy", "1.2em").style("text-anchor", a ? "start" : "middle").text(this.pt).attr("transform", "translate(" + (a ? 0 : N / 2) + ", " + W + ")"),
                V = this.pt;
              O.each(function () {
                this.getBBox().width >= N && O.append("svg:title").text(V);
              });
              d -= this.qA;
              d = a ? d - 16 : d;
              var ca = !1;
              Q.each(function () {
                W = this.getBBox().height;
                d = (ca = W > 4 * d / 5) ? 1 * d / 5 : d - W;
              }).attr("transform", "translate(0," + d + ")");
              b.select(".fm-y.fm-axis-label").style("text-anchor", B < d ? "middle" : "end").attr("transform", "translate(-" + (A - 20) + "," + (B < d ? d / 2 : 0) + ") rotate(-90)");
              I && K.select(".fm-y.fm-axis-label-2").style("text-anchor", C < d ? "middle" : "start").attr("transform", "translate(" + (M + 5) + "," + (C < d ? d / 2 : 0) + ") rotate(90)");
              ca && this.B0(d + W + this.qA);
              var fa = Math.min(60, d / 2);
              b.select(".tick").each(function () {
                var aa = this.getBBox().height;
                fa = Math.max(fa, aa);
              });
              Q = Math.floor(d / fa);
              n && 1 > (g - l) / Q && (Q = g - l);
              y.ticks(Q);
              this.lm.range([d, 0]);
              b.call(y);
              I && (H.ticks(Q), this.uO.range([d, 0]), K.call(H));
              this.vO = 0 < l && 0 < g ? this.lm.domain()[0] : 0 > l && 0 > g ? this.lm.domain()[1] : 0;
              I && (0 < Y && 0 < L ? this.uO.domain() : 0 > Y && 0 > L && this.uO.domain());
              this.dw = c;
              this.Pt = d;
              var U = this.lm;
              g = U.ticks(Q);
              g.shift();
              b.selectAll(".refline").data(g).enter().append("line").attr("class", "fm-refline").attr("x1", 0).attr("x2", N).attr("y1", function (aa) {
                return U(aa);
              }).attr("y2", function (aa) {
                return U(aa);
              });
              a && this.Ica(I ? A + N + M : A + N);
            }
            c_(b) {
              var a = b.append("g").attr("class", "fm-axis-dividers");
              b = b.selectAll(".level").data(this.Eb.Mi).enter().append("g").attr("class", "fm-level");
              var c = b.selectAll("text").data(function (A) {
                return A;
              }).enter().append("text").on("click", A => this.yu(A)).attr("class", "fm-label").style("text-anchor", "middle").text(function (A) {
                return A.Vf || A.Hg ? "- " + A.label : A.collapsed || A.nh ? "+ " + A.label : A.label;
              }).style("cursor", function (A) {
                return A.collapsed || A.Vf || A.Hg || A.nh ? "pointer" : "auto";
              });
              b.selectAll("text").filter(function (A) {
                return A.Lf && 0 < A.Lf.length || A.collapsed || A.Vf || A.Hg || A.nh;
              }).append("svg:title").text(function (A) {
                return A.Lf && 0 < A.Lf.length ? A.Lf : A.collapsed || A.nh ? e.model.B.j.gQ : A.Vf || A.Hg ? e.model.B.j.fQ : "";
              });
              var d = 0;
              for (d = 0; d < c.length; d++) this.AN(c[d], 0);
              var g = Math.floor(this.ek.rangeBand()),
                l = [],
                m = 0;
              for (d = 0; d < c.length; d++) {
                var n = this.KAa(c[d], g);
                l.push(n);
                m = Math.max(m, n);
              }
              for (d = 0; d < c.length; d++) 0 != l[d] && this.AN(c[d], -m);
              for (d = 0; d < c.length; d++) 0 != l[d] && this.AN(c[d], -m);
              var p = [],
                t = 6;
              b.each(function () {
                t += this.getBBox().height + 6;
                p.push(this.getBBox().height);
              });
              b.attr("transform", function (A, B) {
                t -= p[B] + 6;
                return "translate(0, " + t + ")";
              });
              p = p.reverse();
              for (var r = this.ek, w = 1 < r.range().length ? (r.range()[1] - r.range()[0] - r.rangeBand()) / 2 : 0, y = 0; y < this.Eb.Mi.length; y++) a.selectAll(".refline").data(this.Eb.Mi[y].slice(1)).enter().append("line").attr("class", "fm-refline").attr("x1", function (A) {
                return r(A.id) - w;
              }).attr("x2", function (A) {
                return r(A.id) - w;
              }).attr("y1", function () {
                return 0;
              }).attr("y2", function () {
                for (var A = 0, B = p.length - y, C = 0; C < B; C++) A += p[C] + 6;
                return A;
              });
            }
            AN(b, a) {
              for (var c = 0; c < b.length; c++) x.Ga.Xb(b[c]).U("text-anchor", "middle"), x.Ga.Xb(b[c]).attr("dy", "0.38em"), x.Ga.Xb(b[c]).attr("transform", this.I1(b[c]) + (0 != a ? " rotate(" + a + ")" : ""));
            }
            I1(b) {
              var a = b.getBoundingClientRect().height / 2;
              b = b.__data__;
              var c = 1 < this.ek.range().length ? (this.ek.range()[1] - this.ek.range()[0] - this.ek.rangeBand()) / 2 : 0;
              return "translate(" + (this.ek(b.id) + this.ek.rangeBand() * b.sC / 2 + c * (b.sC - 1)) + ", " + a + ")";
            }
            KAa(b, a) {
              var c = 0,
                d = 0;
              b.forEach(function (g) {
                g = g.getBBox();
                c < g.width && (c = g.width, d = g.height);
              });
              return this.xua(a, Math.sqrt(c * c + d * d), this.jja(Math.atan(d / c)));
            }
            xua(b, a, c) {
              b = Math.min(90, this.jja(Math.acos(b / a)) + c || 0);
              if (0 == b) return 0;
              for (a = 0; a < this.g_.length; a++) if (this.g_[a] > b) return this.g_[a];
              return b;
            }
            jja(b) {
              return 180 * b / Math.PI;
            }
            DS(b, a) {
              var c = this.Eb.Hp,
                d = this.ek,
                g = 0;
              if (0 < this.Eb.Vw.length) {
                var l = this.Eb.Vw;
                var m = d3v3.scale.ordinal().rangeRoundBands([0, d.rangeBand()], .1).domain(l);
                l = m.rangeBand();
                var n = Math.min(l, this.wG);
                g = l != n ? (l - n) / 2 : 0;
              }
              b = this.svg.selectAll(".state").data(b).enter().append("g").attr("transform", function (r) {
                return "translate(" + (d(r.id) + g) + ",0)";
              });
              var p = this.vO;
              l = b.selectAll("rect").data(function (r) {
                return r.Wh;
              }).enter().append("rect");
              l.attr("class", "fm-bar").attr("x", function (r) {
                return m(r.id);
              }).attr("width", n).attr("y", function (r) {
                return 0 < r.value ? Math.floor(100 * a(r.value)) / 100 : Math.floor(100 * a(p)) / 100;
              }).attr("height", function (r) {
                return Math.floor(100 * Math.abs(a(p) - a(r.value))) / 100;
              }).style("fill", function (r) {
                return e.v(r.dr) ? c(r.id) : c(r.dr);
              }).append("title").text(function (r) {
                return r.Lf;
              });
              this.Pl(l, h.Vn.hB);
              if (this.Eb.BE) {
                var t = 0;
                b = b.selectAll("text").data(function (r) {
                  return r.Wh;
                }).enter().append("text").attr("class", "fm-data-label").text(function (r) {
                  return r.Es;
                }).each(function () {
                  t = Math.max(t, this.getBBox().width);
                });
                t > n ? b.attr("y", function (r) {
                  return m(r.id) + n / 2;
                }).attr("x", function (r) {
                  var w = 0 < r.value ? -Math.floor(100 * a(r.value)) / 100 : -Math.floor(100 * a(p)) / 100;
                  this.getBBox().width + 3 > Math.abs(w) && (w -= Math.min(this.getBBox().width, Math.floor(100 * Math.abs(a(p) - a(r.value))) / 100));
                  return w;
                }).attr("dx", function (r) {
                  var w = 0 < r.value ? -Math.floor(100 * a(r.value)) / 100 : -Math.floor(100 * a(p)) / 100;
                  return this.getBBox().width + 3 > Math.abs(w) && this.getBBox().width + 3 < Math.floor(100 * Math.abs(a(p) - a(r.value))) / 100 ? "-3px" : "3px";
                }).attr("dy", "0.38em").attr("transform", "rotate(-90)") : b.style("text-anchor", "middle").attr("x", function (r) {
                  return m(r.id) + n / 2;
                }).attr("y", function (r) {
                  return 0 < r.value ? Math.floor(100 * a(r.value)) / 100 : Math.floor(100 * a(p)) / 100;
                }).attr("dy", "-3px");
                b.append("title").text(function (r) {
                  return r.Lf;
                });
                this.Pl(b, h.Vn.EF);
              }
            }
            r0(b, a) {
              for (var c = this.ek, d = d3v3.svg.line().interpolate("linear").x(function (n) {
                  return c(n.id) + c.rangeBand() / 2;
                }).y(function (n) {
                  return a(n.value);
                }), g = 0; g < b.length; g++) {
                var l = e.v(b[g].dr) ? this.Eb.Hp(b[g].id) : this.Eb.Hp(b[g].dr),
                  m = this.svg.append("g");
                const n = m.append("path").datum(b[g]).attr("class", "fm-line").style("stroke", l).attr("d", function (p) {
                  return d(p.Wh);
                });
                this.Pl(n, h.Vn.hB);
                l = m.selectAll("circle").data(b[g].Wh).enter().append("circle").attr("class", "fm-circle").style("stroke", l).attr("cx", function (p) {
                  return c(p.id) + c.rangeBand() / 2;
                }).attr("cy", function (p) {
                  return a(p.value);
                }).attr("r", 4);
                l.append("title").text(function (p) {
                  return p.Lf;
                });
                this.Pl(l, h.Vn.hB);
                this.Eb.BE && (m = m.selectAll("text").data(b[g].Wh).enter().append("text").attr("class", "fm-data-label").text(function (p) {
                  return p.Es;
                }), m.style("text-anchor", "middle").attr("x", function (p) {
                  return c(p.id) + c.rangeBand() / 2;
                }).attr("y", function (p) {
                  p = Math.floor(100 * a(p.value)) / 100 - 8;
                  return Math.max(-10, p);
                }), m.append("title").text(function (p) {
                  return p.Lf;
                }), this.Pl(m, h.Vn.EF));
              }
            }
          }
          h.$I = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.VW {
            constructor() {
              super();
              this.Rx = this.qt = this.pt = "";
              this.vO = 0;
              this.qA = 10;
              this.wG = 200;
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.pt = b.pt;
              this.qt = b.qt;
              this.Rx = b.Rx;
            }
            sk(b, a) {
              this.dw = this.vo;
              this.Pt = this.to;
              this.wG = this.dw / 5;
              this.vQ(b);
              this.NZ(b, a);
              this.svg.attr("transform", "translate(" + this.OW + ", " + this.qA + ")");
            }
            tM(b) {
              return d3v3.max(b, function (a) {
                return d3v3.max(a.Wh, function (c) {
                  return c.value;
                });
              });
            }
            wM(b) {
              return d3v3.min(b, function (a) {
                return d3v3.min(a.Wh, function (c) {
                  return c.value;
                });
              });
            }
            g5(b) {
              this.ou = b;
            }
            yu(b) {
              if (!e.v(b) && this.ou) {
                var a = b.data,
                  c = b.Aw,
                  d = b.nh || b.Hg;
                b.collapsed || b.Vf ? this.ou("expand", a, c) : d && this.ou("drill", a, c);
              }
            }
            NZ(b) {
              var a = this.vo,
                c = this.to,
                d = this.tM(b),
                g = this.wM(b);
              d = 0 > d && (!this.Eb.ju || g == d) ? 0 : d;
              g = 0 > g || this.Eb.ju && g != d ? g : 0;
              this.lm = d3v3.scale.linear().range([0, a]).domain([g, d]).nice();
              var l = this.Eb.Fu,
                m = this.Eb.Fe,
                n = this.Eb.ce,
                p = this.Eb.bx,
                t = !0 === e.model.C.F.lC || null === e.model.C.F.lC && 1E7 < d,
                r = this.Eb.nda,
                w = d3v3.svg.axis().scale(this.lm).orient("bottom").tickFormat(function (H) {
                  return r(H, l, m, n, p, t);
                }),
                y = this.svg.append("g").attr("class", "fm-y fm-axis").call(w),
                A,
                B;
              y.each(function () {
                B = A = this.getBBox().height;
              }).append("text").attr("class", "fm-x fm-axis fm-title").attr("dy", "1.2em").style("text-anchor", "middle").text(this.qt).attr("transform", "translate(" + a / 2 + ", " + B + ")");
              c -= this.qA;
              y.each(function () {
                A = this.getBBox().height;
                c -= A;
              });
              var C = this.Eb.Cl,
                I = Math.max(C.length * Math.max(this.Eb.Vw.length * this.g3, this.ega), c);
              y.attr("transform", "translate(0," + I + ")");
              b = I > c;
              this.ek = d3v3.scale.ordinal().rangeRoundBands([0, I], b ? 0 : .1).domain(C.map(function (H) {
                return H.id;
              }));
              C = d3v3.svg.axis().scale(this.ek).orient("left").tickFormat(function () {
                return "";
              });
              var L = 0;
              C = this.svg.append("g").attr("class", "fm-x fm-axis").call(C).each(function () {
                L = this.getBBox().width;
                a -= L;
              });
              this.OW = L;
              this.c_(C);
              C.each(function () {
                L = this.getBBox().width;
              });
              var Y = C.append("text").attr("class", "fm-x fm-axis fm-axis-label fm-title").text(this.pt).style("text-anchor", b ? "end" : "middle").attr("dy", "-0.5em").attr("transform", "translate(-" + L + ", " + (b ? 0 : I / 2) + ") rotate(-90)"),
                D = this.pt;
              Y.each(function () {
                this.getBBox().width >= I && Y.append("svg:title").text(D);
              });
              a = b ? a - 16 : a;
              var E = !1;
              C.each(function () {
                L = this.getBBox().width;
                a = (E = L > 4 * a / 5) ? 1 * a / 5 : a - L;
              });
              E && this.Ica(a + L);
              this.OW = L;
              C = 10;
              var G = 20,
                F = 0;
              y.selectAll(".tick").each(function () {
                G = this.getBBox().width;
                F = Math.max(F, G);
              });
              a -= G / 2;
              F *= 1.8;
              a / C < F && (C = Math.floor(a / F));
              m && 1 > (d - g) / C && (C = d - g);
              w.ticks(C);
              this.lm.range([0, a]);
              y.call(w);
              y.select(".fm-title").attr("transform", "translate(" + a / 2 + ", " + B + ")");
              this.vO = 0 < g && 0 < d ? this.lm.domain()[0] : 0 > g && 0 > d ? this.lm.domain()[1] : 0;
              this.dw = a;
              this.Pt = c;
              var J = this.lm;
              d = J.ticks(C);
              d.shift();
              y.selectAll(".refline").data(d).enter().append("line").attr("class", "fm-refline").attr("y1", 0).attr("y2", -I).attr("x1", function (H) {
                return J(H);
              }).attr("x2", function (H) {
                return J(H);
              });
              d = A + I + this.qA;
              b && this.B0(d);
            }
            c_(b) {
              var a = b.append("g").attr("class", "fm-axis-dividers");
              b = b.selectAll(".level").data(this.Eb.Mi).enter().append("g").attr("class", "fm-level");
              var c = b.selectAll("text").data(function (t) {
                return t;
              }).enter().append("text").on("click", t => this.yu(t)).attr("class", "fm-label").style("text-anchor", "middle").text(function (t) {
                return t.Vf || t.Hg ? "- " + t.label : t.collapsed || t.nh ? "+ " + t.label : t.label;
              }).style("cursor", function (t) {
                return t.collapsed || t.Vf || t.Hg || t.nh ? "pointer" : "auto";
              });
              b.selectAll("text").filter(function (t) {
                return t.Lf && 0 < t.Lf.length || t.collapsed || t.Vf || t.Hg || t.nh;
              }).append("svg:title").text(function (t) {
                return t.Lf && 0 < t.Lf.length ? t.Lf : t.collapsed || t.nh ? e.model.B.j.gQ : t.Vf || t.Hg ? e.model.B.j.fQ : "";
              });
              var d = 0;
              for (d = 0; d < c.length; d++) this.AN(c[d], 0);
              var g = [],
                l = 6;
              b.each(function () {
                l += this.getBBox().width + 6;
                g.push(this.getBBox().width);
              });
              b.attr("transform", function (t, r) {
                l -= g[r];
                t = "translate(" + -l + ", 0)";
                l -= 6;
                return t;
              });
              g = g.reverse();
              for (var m = this.ek, n = 1 < m.range().length ? (m.range()[1] - m.range()[0] - m.rangeBand()) / 2 : 0, p = 0; p < this.Eb.Mi.length; p++) a.selectAll(".refline").data(this.Eb.Mi[p].slice(1)).enter().append("line").attr("class", "fm-refline").attr("y1", function (t) {
                return m(t.id) - n;
              }).attr("y2", function (t) {
                return m(t.id) - n;
              }).attr("x1", function () {
                return 0;
              }).attr("x2", function () {
                for (var t = 0, r = g.length - p, w = 0; w < r; w++) t += g[w] + 6;
                return -t;
              });
            }
            AN(b, a) {
              for (var c = 0; c < b.length; c++) x.Ga.Xb(b[c]).U("text-anchor", "end"), x.Ga.Xb(b[c]).attr("dy", "0.38em"), x.Ga.Xb(b[c]).attr("transform", this.I1(b[c]) + (0 != a ? " rotate(" + a + ")" : ""));
            }
            I1(b) {
              var a = b.getBoundingClientRect().height / 2;
              b = b.__data__;
              b = this.ek(b.id) + this.ek.rangeBand() * b.sC / 2;
              return "translate(" + a + ", " + b + ")";
            }
            DS(b, a) {
              var c = this.Eb.Hp,
                d = this.ek,
                g = 0;
              if (0 < this.Eb.Vw.length) {
                var l = this.Eb.Vw;
                var m = d3v3.scale.ordinal().rangeRoundBands([0, d.rangeBand()], .1).domain(l);
                l = m.rangeBand();
                var n = Math.min(l, this.wG);
                g = l != n ? (l - n) / 2 : 0;
              }
              b = this.svg.selectAll(".state").data(b).enter().append("g").attr("transform", function (t) {
                return "translate(0," + (d(t.id) + g) + ")";
              });
              var p = this.vO;
              l = b.selectAll("rect").data(function (t) {
                return t.Wh;
              }).enter().append("rect").attr("class", "fm-bar").attr("y", function (t) {
                return m(t.id);
              }).attr("height", n).attr("x", function (t) {
                return 0 > t.value ? Math.floor(100 * a(t.value)) / 100 : Math.floor(100 * a(p)) / 100;
              }).attr("width", function (t) {
                return Math.floor(100 * Math.abs(a(p) - a(t.value))) / 100;
              }).style("fill", function (t) {
                return e.v(t.dr) ? c(t.id) : c(t.dr);
              });
              l.append("title").text(function (t) {
                return t.Lf;
              });
              this.Pl(l, h.Vn.hB);
              if (this.Eb.BE) {
                const t = this.G.find("svg").getBoundingClientRect();
                b = b.selectAll("text").data(function (r) {
                  return r.Wh;
                }).enter().append("text").attr("class", "fm-data-label").text(function (r) {
                  return r.Es;
                }).attr("x", function (r) {
                  return Math.floor(100 * a(r.value)) / 100;
                }).attr("y", function (r) {
                  return m(r.id) + n / 2;
                }).attr("dx", function () {
                  const r = this.getBoundingClientRect();
                  return r.right > t.right ? `${t.right - r.right}px` : "2px";
                }).attr("dy", "0.38em");
                b.append("title").text(function (r) {
                  return r.Lf;
                });
                this.Pl(b, h.Vn.EF);
              }
            }
            r0(b, a) {
              for (var c = this.ek, d = d3v3.svg.line().interpolate("linear").x(function (n) {
                  return c(n.id) + c.rangeBand() / 2;
                }).y(function (n) {
                  return a(n.value);
                }), g = 0; g < b.length; g++) {
                var l = e.v(b[g].dr) ? this.Eb.Hp(b[g].id) : this.Eb.Hp(b[g].dr),
                  m = this.svg.append("g");
                m.append("path").datum(b[g]).attr("class", "fm-line").style("stroke", l).attr("d", function (n) {
                  return d(n.Wh);
                });
                m.selectAll("circle").data(b[g].Wh).enter().append("circle").attr("class", "fm-circle").style("stroke", l).attr("cx", function (n) {
                  return c(n.id) + c.rangeBand() / 2;
                }).attr("cy", function (n) {
                  return a(n.value);
                }).attr("r", 4).append("title").text(function (n) {
                  return n.Lf;
                });
              }
            }
          }
          h.tka = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.$I {
            constructor() {
              super();
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.sk(b.data);
            }
            sk(b) {
              super.sk(b);
              this.DS(b, this.lm);
            }
          }
          h.X6 = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.$I {
            constructor() {
              super();
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.sk(b.data);
            }
            sk(b) {
              super.sk(b);
              this.r0(b, this.lm);
            }
          }
          h.Rna = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.$I {
            constructor() {
              super();
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.sk(b.data);
            }
            sk(b) {
              super.sk(b);
              for (var a = this.ek, c = this.lm, d = "triangle-up cross circle square triangle-down diamond".split(" "), g = 0; g < b.length; g++) {
                var l = e.v(b[g].dr) ? this.Eb.Hp(b[g].id) : this.Eb.Hp(b[g].dr),
                  m = d[g % d.length],
                  n = this.svg.append("g");
                m = d3v3.svg.symbol().type(m);
                m = n.selectAll(".scatter-point").data(b[g].Wh).enter().append("path").attr("class", "fm-scatter-point").attr("d", m).style("stroke", function () {
                  return l;
                }).attr("transform", function (p) {
                  return "translate(" + Math.round(a(p.id) + a.rangeBand() / 2) + "," + Math.round(c(p.value)) + ")";
                });
                m.append("title").text(function (p) {
                  return p.Lf;
                });
                this.Pl(m, h.Vn.hB);
                this.Eb.BE && (n = n.selectAll("text").data(b[g].Wh).enter().append("text").attr("class", "fm-data-label").text(function (p) {
                  return p.Es;
                }), n.style("text-anchor", "middle").attr("x", function (p) {
                  return a(p.id) + a.rangeBand() / 2;
                }).attr("y", function (p) {
                  return Math.floor(100 * c(p.value)) / 100;
                }).attr("dy", "-8px"), n.append("title").text(function (p) {
                  return p.Lf;
                }), this.Pl(n, h.Vn.EF));
              }
            }
          }
          h.sqa = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.VW {
            constructor() {
              super();
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.update(b.data);
            }
            update(b) {
              if (0 != b.length) {
                var a = this.vo,
                  c = Math.max(this.to, 70),
                  d = Math.min(a, c) / 2;
                c > this.to && this.B0(c);
                var g = this.Eb.Hp,
                  l = d3v3.svg.arc().outerRadius(d - 20).innerRadius(0),
                  m = d3v3.layout.pie().sort(null).value(function (y) {
                    return Math.abs(y.value);
                  });
                this.svg.attr("transform", "translate(" + a / 2 + "," + c / 2 + ")");
                b = this.svg.selectAll(".arc").data(m(b[0].Wh)).enter().append("g").attr("class", "fm-arc");
                b.append("path").attr("d", l).style("fill", function (y) {
                  return g(y.data.id);
                }).append("title").text(function (y) {
                  return y.data.Lf;
                });
                var n = d3v3.svg.arc().outerRadius(d - 20).innerRadius(d),
                  p = 0;
                d = this.svg.append("g").attr("class", "fm-pie-label");
                d.append("text").text("Test").each(function () {
                  p = this.getBBox().height;
                });
                d.remove();
                var t = [],
                  r = [],
                  w = [];
                b.each(function (y) {
                  var A = n.centroid(y);
                  if (e.model.C.F.zia || 0 == r.length || 2 == r.length && Math.abs(A[1] - r[1]) > p || 0 <= r[0] && 0 >= A[0]) w.push(y), t.push(A), r = A;
                });
                d = this.svg.selectAll(".pie-label").data(w).enter().append("g").attr("class", "fm-pie-label");
                d.append("text").text(function (y) {
                  return y.data.label + " (" + y.data.Es + ")";
                }).attr("transform", function (y, A) {
                  return "translate(" + t[A] + ")";
                }).attr("class", "fm-label").attr("dy", ".35em").style("text-anchor", function (y, A) {
                  return 0 < t[A][0] ? "start" : "end";
                });
                d.selectAll("text").filter(function (y) {
                  return y.data.N2 && 0 < y.data.N2.length;
                }).append("svg:title").text(function (y) {
                  return y.data.N2;
                });
                this.Pl(b, h.Vn.hB);
                this.Pl(d, h.Vn.EF);
                b = this.svg[0][0].getBBox();
                if (b.x + b.width > a / 2 || b.x < -a / 2) d = x.Ga.Xb(this.svg[0][0]), l = d3v3.transform(d.attr("transform")), a = a / 2 / (a / 2 + Math.max(-a / 2 - b.x, b.x + b.width - a / 2)), l.scale = [a, a], d.attr("transform", l.toString());
              }
            }
          }
          h.Jpa = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.$I {
            constructor() {
              super();
              this.Uia = !0;
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.sk(b.data);
            }
            tM(b) {
              return d3v3.max(b, function (a) {
                return a.PLa;
              });
            }
            wM(b) {
              return d3v3.min(b, function (a) {
                return a.OLa;
              });
            }
            sk(b) {
              this.vQ(b);
              b.forEach(function (p) {
                var t = 0,
                  r = 0;
                p.Wh.forEach(function (w) {
                  0 <= w.value ? (w.d6 = t, t += w.value, w.y1 = t) : (w.y1 = r, r += w.value, w.d6 = r);
                });
                p.OLa = r;
                p.PLa = t;
              });
              super.sk(b);
              var a = this.Eb.Hp,
                c = this.ek,
                d = this.lm;
              var g = c.rangeBand();
              0 < this.Eb.Vw.length && (g = this.Eb.Vw, g = d3v3.scale.ordinal().rangeRoundBands([0, c.rangeBand()], .1).domain([g[0]]), g = g.rangeBand());
              var l = Math.min(g, this.wG),
                m = g != l ? (g - l) / 2 : 0;
              m += (c.rangeBand() - g) / 2;
              b = this.svg.selectAll(".state").data(b).enter().append("g").attr("class", "fm-bar-stack").attr("transform", function (p) {
                return "translate(" + (c(p.id) + m) + ",0)";
              });
              g = b.selectAll("rect").data(function (p) {
                return p.Wh;
              }).enter().append("rect").attr("width", l).attr("y", function (p) {
                return Math.round(100 * d(p.y1)) / 100;
              }).attr("height", function (p) {
                return Math.round(100 * Math.abs(d(p.d6) - d(p.y1))) / 100;
              }).style("fill", function (p) {
                return a(p.id);
              });
              g.append("title").text(function (p) {
                return p.Lf;
              });
              b.selectAll("path").data(function (p) {
                return p.Wh;
              }).enter().append("path").attr("d", function (p) {
                return "M0 " + Math.round(100 * d(p.y1)) / 100 + " l" + l + " 0";
              });
              this.Pl(g, h.Vn.hB);
              if (this.Eb.BE) {
                var n = 0;
                b = b.selectAll("text").data(function (p) {
                  return p.Wh;
                }).enter().append("text").attr("class", "fm-data-label").text(function (p) {
                  return p.Es;
                }).each(function () {
                  n = Math.max(n, this.getBBox().height);
                });
                b.text(function (p) {
                  return n + 1 > Math.round(100 * Math.abs(d(p.d6) - d(p.y1))) / 100 ? "" : p.Es;
                });
                g = Math.floor(n);
                b.style("text-anchor", "middle").attr("x", function () {
                  return l / 2;
                }).attr("y", function (p) {
                  return Math.round(100 * d(p.y1)) / 100;
                }).attr("dy", g + "px");
                b.append("title").text(function (p) {
                  return p.Lf;
                });
                this.Pl(b, h.Vn.EF);
              }
            }
          }
          h.yqa = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.$I {
            constructor() {
              super();
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.sk(b.data, b.Aw);
            }
            sk(b, a) {
              super.sk(b, a);
              this.DS(b, this.lm);
              this.r0(a, this.uO);
            }
          }
          h.wla = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.tka {
            constructor() {
              super();
            }
            Ud(b, a, c) {
              super.Ud(b, a, c);
              this.sk(b.data);
            }
            sk(b) {
              super.sk(b);
              this.DS(b, this.lm);
            }
          }
          h.rka = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Ii.nB {
              constructor() {
                super();
                this.Z_();
                this.BL();
              }
              Z_() {
                null == this.wD && (this.wD = new x.Ga("span", "fm-icon-display"));
              }
              BL() {
                null == this.cp && (this.cp = new x.Ga("span", "fm-text-display"));
              }
              nb() {
                var a = this.getData();
                this.G.empty();
                0 == a.$f && this.wD.U("background-color", a.color);
                this.G.append(this.wD);
                this.cp.html(a[this.mr()]);
                var c = a.Lf;
                c && 0 < c.length && this.cp.attr("title", c);
                a.isCollapsed || a.OH ? this.G.attr("title", e.model.B.j.gQ) : (a.$f || a.Yg) && this.G.attr("title", e.model.B.j.fQ);
                this.G.$("fm-level-" + a.level);
                this.G.append(this.cp);
                e.v(a.measure) || isNaN(a.measure.index) || this.G.attr("data-measure-index", a.measure.index);
                this.G.$a(k.Y.W.ya.cX, a.isCollapsed || a.OH);
                this.G.$a(k.Y.W.ya.tX, a.$f || a.Yg);
                this.Pl(this.G.element, h.Vn.Lna);
              }
              Pl(a, c) {
                if (e.Kg(h.tv.EC)) {
                  var d = this.getData().Sa();
                  d.type = c;
                  d.chartType = e.model.C.F.kL;
                  h.tv.EC(a, d);
                }
              }
            }
            f.Qna = b;
          })(h.sg || (h.sg = {}));
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.be.ik {
              constructor(a) {
                super();
                this.WN = !0;
                this.WN = a;
                this.G.Ul();
                this.color = d3v3.scale.category20c();
                e.model.C.F.j5 && (this.UN = new x.Qg(), this.WN ? this.UN.$("fm-chart-legend-btn fm-hide") : this.UN.$("fm-chart-legend-btn fm-show"), this.UN.G.attr("title", this.WN ? e.model.B.j.Bka : e.model.B.j.Dka), this.UN.N(x.Nd.tf, () => this.kHa()), this.X(this.UN));
                this.WH = new x.Ga("div");
                this.WH.$("fm-chart-legend-container");
                this.WN && this.G.append(this.WH);
              }
              kHa() {
                this.Ya(v.ga.Zd);
              }
              WJa(a) {
                this.color = a;
              }
              Ud(a) {
                if (this.WN) {
                  this.WH.xx();
                  this.WH.$a("fm-legend-btn-shown", e.model.C.F.j5);
                  for (var c = new x.Ga("table"), d = new x.Ga("tr"), g = 0; g < a.length; g++) {
                    for (var l = 0; l < a[g].length; l++) a[g][l].$f || a[g][l].Yg || (a[g][l].color = this.color(a[g][l].id));
                    l = new x.Ga("td");
                    var m = new x.Ad.rj();
                    m.$("fm-legend-lst-" + g);
                    m.ji(this.Yu);
                    m.vg("label");
                    m.useCache = !1;
                    m.cg(a[g]);
                    m.N(v.ga.Zd, n => this.jV(n));
                    l.append(m.G);
                    d.append(l);
                  }
                  c.append(d);
                  this.WH.append(c);
                }
              }
              VJa(a) {
                this.ou = a;
              }
              Yu(a, c) {
                var d = new f.Qna();
                d.setData(a);
                d.Ym(c);
                return d;
              }
              jV(a) {
                a = a.data.xl;
                var c = a.OH || a.Yg;
                a.isCollapsed || a.$f ? this.ou("expand", a.gg, a.Zb) : c && this.ou("drill", a.gg, a.Zb);
              }
            }
            f.rla = b;
          })(h.sg || (h.sg = {}));
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {}
            static Vza(b) {
              switch (b) {
                case h.Ne.EA:
                  b = new h.X6();
                  break;
                case h.Ne.RE:
                  b = new h.rka();
                  break;
                case h.Ne.EJ:
                  b = new h.Rna();
                  break;
                case h.Ne.ZJ:
                  b = new h.sqa();
                  break;
                case h.Ne.Cv:
                  b = new h.Jpa();
                  break;
                case h.Ne.jB:
                  b = new h.yqa();
                  break;
                case h.Ne.bF:
                  b = new h.wla();
                  break;
                default:
                  b = new h.X6();
              }
              return b;
            }
          }
          h.qla = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.be.ik {
            constructor() {
              super();
              this.v8 = 50;
              this.model = e.model.Va.R();
              this.$("fm-charts-view");
              this.Je();
              new h.tla(this);
            }
            dispose() {
              this.model = this.I = null;
              this.Rq && this.Rq.dispose();
              this.Rq = null;
            }
            nb() {
              if (!(1 > e.model.Ha.wc.Wj())) {
                null == this.Rq && (this.Rq = this.Bwa(), this.G.X(this.Rq));
                this.Rq.clear();
                this.Rq.I = this.I;
                this.Rq.resize(k.Nb.vo, k.Nb.to);
                this.Rq.Eb = null;
                if (this.I && this.I.Xi) {
                  if (null == this.Z0()) {
                    e.Wa(e.model.B.j.Eka, e.model.B.j.xa);
                    return;
                  }
                  this.Rq.Eb = this.Awa();
                }
                this.Rq.nb();
              }
            }
            Bwa() {
              var b = new h.ula();
              b.N("chart_changed", () => this.REa());
              b.N(k.Si.$x, a => this.gV(a));
              b.N("dblclick", a => this.TEa(a));
              b.N("click", a => this.SEa(a));
              return b;
            }
            get vs() {
              return this.Rq;
            }
            REa() {
              this.nb();
            }
            gV(b) {
              this.Ea(b);
            }
            JCa(b) {
              b = x.Ga.Xb(b);
              return b.closest(".fm-charts-filters-container") || b.closest(".fm-charts-filters-btn") ? !0 : !1;
            }
            kI(b) {
              b = x.Ga.Xb(b).closest(".fm-charts-filter");
              null != b && (b = e.u.Ma.R().O.ph(b.attr("data-hierarchy")), null != b && this.Ea(new k.hP(b)));
            }
            Bk(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              e.model.Dc.IA.Xe(this, b, a, c);
            }
            print() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              if (this.sfa) {
                var a = e.model.Dc.IA.MS(this, null, !0);
                a = e.model.Dc.IA.AL(e.model.at.xF.R().C.$i) + a + e.model.Dc.IA.AL(e.model.at.xF.R().C.xj);
              } else a = e.model.Dc.IA.Tca(this, null, !0);
              !e.ia(e.model.C.F.An) && this.sfa && (a = "<center><div style='" + k.Y.W.cd.nz(this.G.find(".fm-chart-title")) + "'>" + e.model.C.F.An + "</div></center>" + a);
              null != b ? b(a) : (z.h9.print(a, "", e.model.C.F.An), e.model.at.xF.R().Fga());
              e.model.Dc.IA.clear();
            }
            get sfa() {
              var b = new x.Ga("div");
              b.text("FM");
              b.U("font-size", "10px");
              b.Za();
              document.body.appendChild(b.element);
              var a = "10px" == b.U("font-size");
              b.remove();
              return a;
            }
            Awa() {
              var b = new h.W.sla();
              b.type = e.model.C.F.kL;
              b.ju = e.model.C.F.ju;
              b.BE = e.model.C.F.Bia;
              b.$t = this.Z0();
              b.Pz = e.model.C.F.DG && (b.type == h.Ne.EA || b.type == h.Ne.RE || b.type == h.Ne.EJ || b.type == h.Ne.ZJ);
              b.Fu = b.$t.ci(b.$t.A, b.$t.aa).clone();
              b.Fe = e.u.i.da.Fe(b.$t.aa);
              b.ce = e.u.i.da.ce(b.$t.aa);
              b.Fu.xd = b.$t.aa == e.u.i.da.Pi ? "" : b.Fu.xd;
              b.bx = b.$t.type == e.u.i.Qa.ic && e.u.i.da.hp(b.$t.aa);
              b.nda = this.mda;
              var a = "on" == e.model.C.F.Hf || "rows" == e.model.C.F.Hf ? this.I.Ed - 1 : this.I.Ed,
                c = "on" == e.model.C.F.Hf || "columns" == e.model.C.F.Hf ? this.I.Dd - 1 : this.I.Dd;
              0 == a && (a = 1);
              0 == c && (c = 1);
              var d = 3E3 < c * a ? 3E3 : -1;
              b.OK = b.Pz ? this.tda() : [b.$t];
              e.model.C.F.uo && (null != this.I.DU && (e.model.C.F.ku = this.I.DU), null != this.I.CU && (e.model.C.F.mC = this.I.CU), 0 == this.$Aa(e.model.C.F.ku) && (e.model.C.F.ku = []), 0 == this.aBa(e.model.C.F.mC) && (e.model.C.F.mC = []));
              var g = !1;
              switch (b.type) {
                case h.Ne.EA:
                case h.Ne.RE:
                case h.Ne.jB:
                  g = this.gha(b, a, c, b.OK, b.data, b.Pz && 1 < b.OK.length, void 0, d);
                  break;
                case h.Ne.EJ:
                case h.Ne.ZJ:
                  g = this.hha(b, a, c, b.OK, b.data, b.Pz && 1 < b.OK.length, void 0, d);
                  break;
                case h.Ne.Cv:
                  g = this.uIa(b, a, c, b.$t, void 0, d);
                  break;
                case h.Ne.bF:
                  g = 0 < this.I.Ca.length ? this.I.Ca[0] : null;
                  var l = 1 < this.I.Ca.length ? this.I.Ca[1] : null;
                  b.Fu = g.ci(g.A, g.aa).clone();
                  b.Fe = e.u.i.da.Fe(g.aa);
                  b.ce = e.u.i.da.ce(g.aa);
                  b.Fu.xd = g.aa == e.u.i.da.Pi ? "" : b.Fu.xd;
                  b.bx = g.type == e.u.i.Qa.ic && e.u.i.da.hp(g.aa);
                  e.v(l) || (b.T0 = l.ci(l.A, l.aa).clone(), b.Pea = e.u.i.da.Fe(l.aa), b.nfa = e.u.i.da.ce(l.aa), b.T0.xd = l.aa == e.u.i.da.Pi ? "" : b.T0.xd, b.tfa = l.type == e.u.i.Qa.ic && e.u.i.da.hp(l.aa));
                  g = this.tIa(b, a, c, g, l, d);
              }
              e.model.C.F.Eia && g && e.Wa(e.model.B.j.Fka, e.model.B.j.M9, e.tb.Dl);
              this.sIa(b);
              b.type != h.Ne.Cv && (b.pt = this.EBa(), b.type == h.Ne.bF ? (g = 0 < this.I.Ca.length ? this.I.Ca[0] : null, l = 1 < this.I.Ca.length ? this.I.Ca[1] : null, b.qt = null != g ? g.label : "", b.Rx = null != l ? l.label : "") : (e.model.C.F.DG ? (a = this.tda(), b.qt = 1 == a.length ? a[0].label : "") : b.qt = this.Z0().label, b.Rx = ""));
              return b;
            }
            sIa(b) {
              if (e.v(this.u5) || 0 == this.u5.length) this.u5 = this.$za();
              b.Hp = d3v3.scale.ordinal().range(this.u5);
              if (b.sg && 0 < b.sg.length) {
                var a = [],
                  c = [],
                  d,
                  g;
                for (d = 0; d < b.sg.length; d++) {
                  var l = b.sg[d][0].id;
                  var m = b.Hp(l);
                  b.sg[d][0].$f || (a.push(l), c.push(m));
                  l = [];
                  for (g = 1; g < b.sg[d].length; g++) b.sg[d][g].$f || l.push(b.sg[d][g].id);
                  a = a.concat(l);
                  g = d3v3.rgb(m);
                  g = d3v3.rgb(g.r - 25, g.g - 25, g.b - 25);
                  m = d3v3.rgb("#EEEEEE");
                  m = d3v3.scale.linear().domain([0, l.length + 1]).range([g, m]);
                  g = 1;
                  for (l = 0; g < b.sg[d].length; g++) b.sg[d][g].$f || (c.push(m(l).toString()), l++);
                }
                b.Hp = d3v3.scale.ordinal().domain(a).range(c);
              }
            }
            $za() {
              var b = [],
                a = 1,
                c = new x.Ga("div");
              c.Za();
              for (k.Nb.Gb.G.X(c); 100 > a;) {
                c.G4("class");
                c.$("fm-charts-color-" + a);
                var d = window.getComputedStyle(c.element).fill;
                e.ia(d) && (d = "#000");
                if ("none" != d) b.push(d);else break;
                a++;
              }
              c.remove();
              return b;
            }
            Z0() {
              var b = this.I.Ca.find(l => l.A === e.model.C.F.so.A);
              if (null != b && ("" != e.model.C.F.so.aa || e.model.C.F.so.index)) {
                var a = !0,
                  c = !0;
                for (g = 0; g < this.I.Ca.length; g++) {
                  var d = this.I.Ca[g];
                  if (d.A == e.model.C.F.so.A) if ("" == e.model.C.F.so.aa) {
                    b = d;
                    break;
                  } else if (d.aa == e.model.C.F.so.aa) if (a = !1, null == e.model.C.F.so.index || -1 == e.model.C.F.so.index) {
                    b = d;
                    break;
                  } else if (d.index == e.model.C.F.so.index) {
                    b = d;
                    c = !1;
                    break;
                  }
                }
                a && (e.model.C.F.so.aa = "");
                c && (e.model.C.F.so.index = -1);
              }
              if (null == b) if (e.model.C.F.tc) for (var g = 0; g < this.I.Ca.length && (b = this.I.Ca[g], b.type == e.u.i.Qa.zc || b.type == e.u.i.Qa.Ta); g++);else b = this.I.Ca[0];
              return b;
            }
            tda() {
              var b = [],
                a = e.model.C.F.CG;
              if (0 < a.length) for (var c = [], d = 0; d < a.length; d++) {
                for (var g = a[d], l, m = !0, n = !0, p = 0; p < this.I.Ca.length; p++) {
                  var t = this.I.Ca[p];
                  if (t.A == g.A) if (-1 == c.indexOf(t.index) && (l = t), "" == g.aa) break;else if (t.aa == g.aa) if (m = !1, null == g.index || -1 == g.index) {
                    if (-1 == c.indexOf(t.index)) {
                      l = t;
                      break;
                    }
                  } else if (t.index == g.index) {
                    l = t;
                    n = !1;
                    break;
                  }
                }
                m && (e.model.C.F.CG[d].aa = "");
                n && (e.model.C.F.CG[d].index = -1);
                null != l && (c.push(l.index), b.push(l));
              } else b = this.I.Ca.slice();
              0 == b.length && (b = this.I.Ca.slice(), e.model.C.F.CG = []);
              return b;
            }
            $Aa(b) {
              for (var a = 0, c, d = 0; d < this.I.Dd; d++) c = this.I.Jn(d), this.PR(b, c) && a++;
              return a;
            }
            aBa(b) {
              for (var a = 0, c, d = 0; d < this.I.Ed; d++) c = this.I.Vj(d), this.QR(b, c) && a++;
              return a;
            }
            PR(b, a) {
              return a.length != b.length + 1 || 0 != b.length && 0 != a.join(",").indexOf(b.join(",") + ",") ? !1 : !0;
            }
            QR(b, a) {
              return a.join() == b.join() || a.length == b.length + 1 && (0 == b.length || 0 == a.join(",").indexOf(b.join(",") + ",")) ? !0 : !1;
            }
            EBa() {
              for (var b = [], a = 0; a < this.I.rows.length; a++) b.push(this.I.rows.ea(a).label);
              return b.join(" / ");
            }
            Tda(b) {
              for (var a = [], c, d = 0; d < b.length; d++) c = b[d], c = c.ci(c.A, c.aa).clone(), a.push(c);
              return a;
            }
            CM(b, a, c, d, g) {
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
              a = c + ": " + a;
              b.type == h.Ne.Cv && 0 < l.length && (a += " of " + l);
              c = this.I.Rb.ab && 1 == this.I.Ka.length;
              d = this.I.hc.ab && 1 == this.I.rows.length ? "" : this.J1(d, e.u.i.ha.Ia, !1, null, !0);
              g = c ? "" : this.J1(g, e.u.i.ha.Ra, !1, null, !0);
              d = this.Rw(d);
              g = this.Rw(g);
              0 < d.length && (a = a + "\n" + d);
              0 < g.length && (a = a + "\n" + g);
              b.type != h.Ne.Cv && 0 < l.length && (a = a + "\nTotal: " + l);
              return a;
            }
            J1(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
              if (c && a == e.u.i.ha.Ia) return null != d ? d.hierarchy.label + ": " + d.caption : e.model.B.j.Mqa + " " + (b[0] + 1).toString();
              c = [];
              a = a == e.u.i.ha.Ra ? this.I.Db : this.I.xb;
              for (var l, m = 0; m < b.length; m++) d = a.ea(m), null != d && (l = b[m], c.push(this.Vfa(d.za(l), g)));
              return c.join(" - ");
            }
            TEa(b) {
              this.Sea(b.target) && this.bd(b.target);
            }
            SEa(b) {
              b = this.oT(b.target, !0);
              e.v(b) || e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.E6, b));
            }
            Sea(b) {
              if (e.v(e.u.Ma.R().fa) || !e.u.Ma.R().fa.jU || !e.model.C.F.bd) return !1;
              b = b.__data__;
              null != b && b.data && (b = b.data);
              return b && b.measure && null == this.model.ja.O.fd(b.measure.A) ? !1 : b && b.measure && b.Gg && b.th;
            }
            bd(b) {
              var a = b.__data__;
              null != a && a.data && (a = a.data);
              b = new k.m7(a.measure, a.Gg, a.th, this.oT(b, !0));
              this.Ea(b);
            }
            Vfa(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var c = "";
              if (!e.v(b)) {
                for (var d = []; !e.v(b.parent);) d.unshift(b.caption), b = b.parent;
                c = a ? b.hierarchy.label + ": " : "";
                c += d.join("/");
              }
              return c;
            }
            Rw(b) {
              return b = b.length <= this.v8 ? b : b.substr(0, this.v8) + "...";
            }
            Yg(b, a) {
              if (0 == b.length) return !1;
              var c = a == e.u.i.ha.Ra ? this.I.Ka : this.I.rows;
              if (0 == c.length) return !1;
              c = c.ea((a == e.u.i.ha.Ra ? this.I.Rb : this.I.hc).ab && (0 == b.length || b.length > this.I.ie) ? b.length : b.length - 1).za(b[b.length - 1]);
              return a == e.u.i.ha.Ra ? this.I.Bj(b, c) : this.I.Bh(b, c);
            }
            XZ(b, a, c) {
              if (0 != a.length) {
                var d = c == e.u.i.ha.Ra ? this.I.Rb : this.I.hc,
                  g = c == e.u.i.ha.Ra ? this.I.Ka : this.I.rows;
                if (0 != g.length) {
                  var l = d.ab && 1 == g.length,
                    m = g.ea(d.ab && a.length > this.I.ie ? a.length : a.length - 1);
                  d = m.za(a[a.length - 1]);
                  var n = g = l ? m.label : d.caption;
                  g = this.Rw(g);
                  n = g != n ? n : "";
                  g = e.P.Go(g, !0, !0);
                  l = l ? "" : d.level.A;
                  l = c == e.u.i.ha.Ra ? this.I.tC.indexOf(l) : this.I.vl.indexOf(l);
                  var p = this.pr(a),
                    t = c == e.u.i.ha.Ra ? this.I.Xj(a) : this.I.Th(a),
                    r = c == e.u.i.ha.Ra ? this.I.Bj(a, d) : this.I.Bh(a, d),
                    w = a.length < (c == e.u.i.ha.Ra ? this.I.vk : this.I.Qk) && !t && !r;
                  m = m.Bf && !d.Sh && !d.dc && !d.Zg && !t && !r;
                  0 != l && 0 != b.length || b.push([]);
                  b[b.length - 1].push(new h.W.s8({
                    label: g,
                    id: p,
                    gg: a,
                    lLa: c,
                    Zb: d,
                    level: l,
                    $f: t,
                    isCollapsed: w,
                    Yg: r,
                    OH: m,
                    Lf: n
                  }));
                }
              }
            }
            pr(b) {
              return b.join("-");
            }
            b_(b, a, c) {
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
              var m = c == e.u.i.ha.Ra ? this.I.Rb : this.I.hc,
                n = c == e.u.i.ha.Ra ? this.I.Db : this.I.xb,
                p = m.ab && 1 == n.length,
                t = a.length - 1,
                r = n.ea(t);
              if (null == r) return b.Cl.push({
                label: "",
                id: this.pr(a)
              }), "";
              t = a[a.length - 1];
              t = r.za(t);
              var w = "";
              if (0 < a.length) if (d) w = null != g ? g.caption : (a[0] + 1).toString();else if (0 < n.length) {
                w = p ? r.label : t.caption;
                var y = p ? "" : t.level.A;
              }
              g = this.pr(a);
              var A = this.Rw(p ? "" : w);
              b.Cl.push({
                label: A,
                id: g
              });
              y = this.I.vl.indexOf(y);
              null == b.Mi[y] && (b.Mi[y] = []);
              var B = e.model.C.F.uo ? a.length <= e.model.C.F.ku.length : p ? !1 : c == e.u.i.ha.Ra ? this.I.Xj(a) : this.I.Th(a);
              var C = c == e.u.i.ha.Ra ? this.I.vk : this.I.Qk;
              b.Mi[y].push({
                label: A,
                id: g,
                data: a,
                Aw: t,
                Vf: B,
                collapsed: p ? !1 : !B && a.length < C,
                Hg: !1,
                nh: p ? !1 : r.Bf && !t.Sh && !t.dc && !t.Zg,
                sC: 1,
                Lf: A != w ? w : ""
              });
              this.a_(b, a, t, c, g);
              for (d = d ? 0 : a.length - 1; 0 < d;) d--, t = m.ab && d + 1 > this.I.ie ? d + 1 : d, r = n.ea(t), t = a[d], t = r.za(t), y = t.level.A, y = this.I.vl.indexOf(y), null == b.Mi[y] && (b.Mi[y] = []), r = p ? r.label : t.caption, A = this.Rw(r), r = A != r ? r : "", B = l.pop(), void 0 === B ? b.Mi[y][b.Mi[y].length - 1].sC++ : b.Mi[y].push({
                label: A,
                id: g,
                data: B,
                Aw: t,
                Vf: !0,
                collapsed: !1,
                Hg: !1,
                nh: !1,
                sC: 1,
                Lf: r
              }), this.a_(b, a, t, c, g);
              return w;
            }
            a_(b, a, c, d, g) {
              try {
                c.level.yb;
              } catch (r) {
                c.level.yb;
              }
              if (c && 1 < c.level.yb) {
                var l = this.I.vl.indexOf(c.parent.level.A);
                null == b.Mi[l] && (b.Mi[l] = []);
                var m = c.parent.caption,
                  n = m;
                m = this.Rw(m);
                n = m != n ? n : "";
                if (m === (0 < b.Mi[l].length ? b.Mi[l][b.Mi[l].length - 1].label : "")) b.Mi[l][b.Mi[l].length - 1].sC++;else {
                  var p = (d == e.u.i.ha.Ra ? this.I.Db : this.I.xb).indexOf(c.hierarchy.A),
                    t = a.slice(0, p);
                  t[p] = c.parent.ordinal;
                  b.Mi[l].push({
                    label: m,
                    id: g,
                    data: t,
                    Aw: c.parent,
                    Vf: !1,
                    collapsed: !1,
                    Hg: !0,
                    nh: !1,
                    sC: 1,
                    Lf: n
                  });
                }
                this.a_(b, a, c.parent, d, g);
              }
            }
            J(b, a) {
              if (0 == b.length) return "";
              var c = a == e.u.i.ha.Ra ? this.I.Rb : this.I.hc,
                d = a == e.u.i.ha.Ra ? this.I.Ka : this.I.rows;
              if (0 == d.length) return "";
              a = c.ab && 1 == d.length;
              c = d.ea(c.ab && (0 == b.length || b.length > this.I.ie) ? b.length : b.length - 1);
              b = b[b.length - 1];
              return a ? c.label : this.Vfa(c.za(b));
            }
            BR(b, a, c) {
              b.push([]);
              b[b.length - 1].push(new h.W.s8({
                label: a.label,
                id: c,
                measure: a,
                level: 0,
                $f: !1,
                isCollapsed: !1,
                Yg: !1,
                OH: !1,
                Lf: ""
              }));
            }
            Wp(b, a, c, d, g, l, m, n) {
              return this.model.Fa.fa.Ba != e.u.i.qa.Cc && this.model.Fa.fa.Ba != e.u.i.qa.Md || !e.model.C.F.Rn || d.aa != e.u.i.da.NONE ? this.mda(b, g, l, m, n) : this.I.Wp(a, c, d);
            }
            mda(b, a, c, d, g) {
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
              return g ? e.P.Lx(b, e.model.C.F.ep) : d ? u.cc.format(b, a, c, d) : l ? u.cc.sKa(b, a, c, d) : u.cc.format(b, a, c, d);
            }
            hha(b, a, c, d, g) {
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
              let m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
              let n = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : -1;
              var p = !0,
                t = !0,
                r = [],
                w = this.I.Rb.ab && 1 == this.I.Ka.length,
                y = this.I.hc.ab && 1 == this.I.rows.length;
              var A = "";
              var B = NaN,
                C,
                I = d[0],
                L = this.Tda(d),
                Y = L[0],
                D = e.u.i.da.Fe(I.aa),
                E = e.u.i.da.ce(I.aa);
              Y.xd = I.aa == e.u.i.da.Pi ? "" : Y.xd;
              var G = I.type == e.u.i.Qa.ic && e.u.i.da.hp(I.aa);
              if (null != m) var F = this.I.Vj(this.model.ja.pa.rows.indexOf(m.A)),
                J = this.model.ja.O.mf(m.A);
              var H = !1,
                M = c;
              for (c = 0; c < a; c++) {
                var K = c;
                K = this.I.Vj(K);
                if (!e.model.C.F.uo || this.QR(e.model.C.F.mC, K) || w || 0 == this.I.Ka.length) {
                  var Q = this.Yg(K, e.u.i.ha.Ra);
                  l || w || this.XZ(r, K, e.u.i.ha.Ra);
                  if (!Q) {
                    if (0 < this.I.Ka.length && 0 < K.length) {
                      var N = [];
                      if (!l && (B = this.I.La(N, K, I), 0 == this.Hz(B) && this.model.Fa.fa.Ba != e.u.i.qa.Cc && this.model.Fa.fa.Ba != e.u.i.qa.Md)) continue;
                      A = this.I.Rb.ab && (0 == K.length || K.length > this.I.ie) ? K.length : K.length - 1;
                      A = this.I.Ka.ea(A);
                      var W = K[K.length - 1];
                      A = w ? A.label : A.za(W).caption;
                    }
                    Q = 0 == K.length ? !1 : this.I.Xj(K);
                    if (!Q) {
                      W = [];
                      var O = [];
                      if (l) {
                        for (var V = 0; V < d.length; V++) {
                          I = d[V];
                          D = e.u.i.da.Fe(I.aa);
                          E = e.u.i.da.ce(I.aa);
                          L[V].xd = I.aa == e.u.i.da.Pi ? "" : L[V].xd;
                          G = I.type == e.u.i.Qa.ic && e.u.i.da.hp(I.aa);
                          t && this.BR(r, I, V.toString());
                          W = [];
                          for (C = 0; C < M; C++) {
                            N = this.I.Jn(C);
                            var ca = this.pr(N);
                            if (Q = 0 == N.length ? !1 : this.I.Th(N)) if (O.push(N), !e.model.C.F.uo) continue;
                            Q = this.Yg(N, e.u.i.ha.Ia);
                            if (!Q && (!e.model.C.F.uo || this.PR(e.model.C.F.ku, N) || y || 0 == this.I.rows.length)) {
                              Q = p ? this.b_(b, N, e.u.i.ha.Ia, null, null, O.splice(0)) : this.J(N, e.u.i.ha.Ia);
                              O = [];
                              var fa = this.I.La(N, K, I);
                              if (this.Hz(fa)) {
                                var U = this.Wp(fa, N, K, I, L[V], D, E, G);
                                var aa = this.CM(b, U, I.label, N, K);
                                W.push({
                                  label: Q,
                                  value: fa,
                                  Es: U,
                                  id: ca,
                                  Lf: aa,
                                  measure: {
                                    A: I.A,
                                    aa: I.aa,
                                    index: I.index
                                  },
                                  th: N,
                                  Gg: K
                                });
                              }
                              if (p && 0 < b.Cl.length && (ca = b.Cl.length, -1 < n && ca >= n)) {
                                M = C + 1;
                                H = !0;
                                break;
                              }
                            }
                          }
                          p = !1;
                          ca = this.pr(K) + "-" + V;
                          C = V.toString();
                          g.push({
                            label: A,
                            value: B,
                            id: ca,
                            dr: C,
                            Wh: W
                          });
                        }
                        t = !1;
                      } else {
                        for (C = 0; C < M; C++) {
                          N = this.I.Jn(C) || [];
                          ca = this.pr(N);
                          if (Q = 0 == N.length ? !1 : this.I.Th(N)) if (O.push(N), !e.model.C.F.uo) continue;
                          Q = this.Yg(N, e.u.i.ha.Ia);
                          if (!Q && (!e.model.C.F.uo || this.PR(e.model.C.F.ku, N) || y || 0 == this.I.rows.length)) {
                            if (p) {
                              if (null != m) {
                                var ka = this.I.La(N, F, J);
                                ka = m.za(ka);
                              }
                              Q = this.b_(b, N, e.u.i.ha.Ia, !1, ka, O.slice(0));
                            } else Q = this.J(N, e.u.i.ha.Ia);
                            O = [];
                            fa = this.I.La(N, K, I);
                            this.Hz(fa) && (U = this.Wp(fa, N, K, I, Y, D, E, G), aa = this.CM(b, U, I.label, N, K, ""), W.push({
                              label: Q,
                              value: fa,
                              Es: U,
                              id: ca,
                              Lf: aa,
                              measure: {
                                A: I.A,
                                aa: I.aa,
                                index: I.index
                              },
                              th: N,
                              Gg: K
                            }));
                            if (p && 0 < b.Cl.length && (ca = b.Cl.length, -1 < n && ca >= n)) {
                              M = C + 1;
                              H = !0;
                              break;
                            }
                          }
                        }
                        p = !1;
                        ca = this.pr(K);
                        g.push({
                          label: A,
                          value: B,
                          id: ca,
                          Gg: K,
                          Wh: W
                        });
                      }
                    }
                  }
                }
              }
              b.sg = r;
              return H;
            }
            gha(b, a, c, d, g) {
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
              let m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
              let n = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : -1;
              var p = !0,
                t = !0,
                r = [],
                w = [],
                y = this.I.hc.ab && 1 == this.I.rows.length,
                A = this.I.Rb.ab && 1 == this.I.Ka.length;
              var B = "";
              var C = NaN,
                I,
                L,
                Y,
                D = d[0],
                E = this.Tda(d),
                G = E[0],
                F = e.u.i.da.Fe(D.aa),
                J = e.u.i.da.ce(D.aa);
              G.xd = D.aa == e.u.i.da.Pi ? "" : G.xd;
              var H = D.type == e.u.i.Qa.ic && e.u.i.da.hp(D.aa);
              if (null != m) var M = this.I.Vj(this.model.ja.pa.rows.indexOf(m.A)),
                K = this.model.ja.O.mf(m.A);
              var Q = !1,
                N = a,
                W = [];
              for (L = 0; L < c; L++) {
                var O = this.I.Jn(L) || [];
                if (I = 0 == O.length ? !1 : this.I.Th(O)) if (W.push(O), !e.model.C.F.uo) continue;
                var V = this.Yg(O, e.u.i.ha.Ia);
                if (!V && (!e.model.C.F.uo || this.PR(e.model.C.F.ku, O) || y || 0 == this.I.rows.length)) {
                  if (null != m) {
                    V = this.I.La(O, M, K);
                    var ca = m.za(V);
                  }
                  var fa = this.b_(b, O, e.u.i.ha.Ia, !1, ca, W.slice(0));
                  W = [];
                  var U = [];
                  if (!l && (C = this.I.La(O, U, D), !1 === this.Hz(C) && !1 === e.u.i.da.SM(D.aa) && this.model.Fa.fa.Ba != e.u.i.qa.Cc && this.model.Fa.fa.Ba != e.u.i.qa.Md)) continue;
                  var aa = [];
                  var ka = this.Wp(C, O, U, D, b.Fu, b.Fe, b.ce, b.bx);
                  for (Y = 0; Y < N; Y++) if (U = Y, U = this.I.Vj(U), !e.model.C.F.uo || this.QR(e.model.C.F.mC, U) || A || 0 == this.I.Ka.length) {
                    var ha = this.pr(U);
                    I = 0 == U.length ? !1 : this.I.Xj(U);
                    V = this.Yg(U, e.u.i.ha.Ra);
                    l || (p && !A && this.XZ(r, U, e.u.i.ha.Ra), t && (I || V || w.push(ha)));
                    if (!V && (0 < this.I.Ka.length && 0 < U.length && (B = this.I.Rb.ab && (0 == U.length || U.length > this.I.ie) ? U.length : U.length - 1, B = this.I.Ka.ea(B), V = U[U.length - 1], B = A ? B.label : B.za(V).caption), !I)) if (l) {
                      for (var R, P = 0; P < d.length; P++) {
                        D = d[P];
                        F = e.u.i.da.Fe(D.aa);
                        J = e.u.i.da.ce(D.aa);
                        E[P].xd = D.aa == e.u.i.da.Pi ? "" : E[P].xd;
                        H = D.type == e.u.i.Qa.ic && e.u.i.da.hp(D.aa);
                        R = ha + "-" + P;
                        var ba = P.toString();
                        p && this.BR(r, D, P.toString());
                        t && (I || w.push(R));
                        V = this.I.La(O, U, D);
                        if (this.Hz(V)) {
                          var Z = this.Wp(V, O, U, D, E[P], F, J, H);
                          var X = b.type == h.Ne.jB ? ka : "";
                          X = this.CM(b, Z, D.label, O, U, X);
                          aa.push({
                            label: B,
                            value: V,
                            Es: Z,
                            id: R,
                            dr: ba,
                            Lf: X,
                            measure: {
                              A: D.A,
                              aa: D.aa,
                              index: D.index
                            },
                            th: O,
                            Gg: U
                          });
                        }
                        if (-1 < n && w.length >= n) {
                          N = Y + 1;
                          break;
                        }
                      }
                      p = !1;
                    } else if (V = this.I.La(O, U, D), this.Hz(V) && (Z = this.Wp(V, O, U, D, G, F, J, H), X = b.type == h.Ne.jB ? ka : "", X = this.CM(b, Z, D.label, O, U, X), aa.push({
                      label: B,
                      value: V,
                      Es: Z,
                      id: ha,
                      Lf: X,
                      measure: {
                        A: D.A,
                        aa: D.aa,
                        index: D.index
                      },
                      th: O,
                      Gg: U
                    })), -1 < n && w.length >= n) {
                      N = Y + 1;
                      break;
                    }
                  }
                  t = p = !1;
                  ha = this.pr(O);
                  g.push({
                    label: fa,
                    value: C,
                    id: ha,
                    Wh: aa
                  });
                  O = b.type == h.Ne.jB ? b.Cl.length : b.Cl.length * a;
                  if (-1 < n && O >= n) {
                    Q = !0;
                    break;
                  }
                }
              }
              b.sg = r;
              b.Vw = w;
              return Q;
            }
            uIa(b, a, c, d) {
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : -1;
              b.VH = e.u.i.ha.Ia;
              var m = !0,
                n = [],
                p = this.I.Rb.ab && 1 == this.I.Ka.length,
                t;
              var r = t = "";
              var w,
                y = e.model.C.F.jL;
              if (y >= a || -1 == y) y = e.model.C.F.jL = 0;
              null != g && this.I.Vj(this.model.ja.pa.rows.indexOf(g.A));
              var A = !1;
              for (g = 0; g < a; g++) {
                var B = g;
                B = this.I.Vj(B);
                var C = [];
                var I = this.I.La(C, B, d);
                if (0 < this.I.Ka.length && 0 < B.length) {
                  var L = this.I.Rb.ab && (0 == B.length || B.length > this.I.ie) ? B.length : B.length - 1;
                  r = this.I.Ka.ea(L);
                  L = B[B.length - 1];
                  r = p ? r.label : r.za(L).caption;
                  r = this.Rw(r);
                }
                var Y = p ? "" : this.J1(B, e.u.i.ha.Ra);
                Y = this.Rw(Y);
                b.Cl.push({
                  label: Y,
                  id: this.pr(B)
                });
                if (0 != this.Hz(I) || this.model.Fa.fa.Ba == e.u.i.qa.Cc || this.model.Fa.fa.Ba == e.u.i.qa.Md) if (b.Cl.length - 1 == y || 1 == a) {
                  var D = [];
                  var E = this.Wp(I, C, B, d, b.Fu, b.Fe, b.ce, b.bx);
                  Y = this.I.hc.ab && 1 == this.I.rows.length;
                  for (w = 0; w < c; w++) if (C = this.I.Jn(w) || [], !e.model.C.F.uo || this.QR(e.model.C.F.ku, C) || Y || 0 == this.I.rows.length) {
                    var G = this.I.La(C, B, d);
                    if (this.Hz(G) && (L = this.Yg(C, e.u.i.ha.Ia), m && !Y && this.XZ(n, C, e.u.i.ha.Ia), !L && (L = 0 == C.length ? !1 : this.I.Th(C), !L))) {
                      0 < this.I.rows.length && (L = this.I.hc.ab && (0 == C.length || C.length > this.I.ie) ? C.length : C.length - 1, t = this.I.rows.ea(L), L = C[C.length - 1], t = Y ? t.label : t.za(L).caption);
                      L = this.pr(C);
                      var F = this.Wp(G, C, B, d, b.Fu, b.Fe, b.ce, b.bx);
                      var J = this.CM(b, F, d.label, C, B, E);
                      var H = t;
                      t = this.Rw(t);
                      H = Y || H == t ? "" : H;
                      D.push({
                        label: Y ? "" : t,
                        value: G,
                        Es: F,
                        id: L,
                        Lf: J,
                        measure: {
                          A: d.A,
                          aa: d.aa,
                          index: d.index
                        },
                        th: C,
                        Gg: B,
                        N2: H
                      });
                      C = D.length;
                      if (-1 < l && C >= l) {
                        A = !0;
                        break;
                      }
                    }
                  }
                  m = !1;
                  L = this.pr(B);
                  b.data.push({
                    label: r,
                    value: I,
                    id: L,
                    Gg: B,
                    Wh: D
                  });
                }
              }
              b.sg = n;
              return A;
            }
            tIa(b, a, c, d, g) {
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : -1;
              l = this.gha(b, a, c, [d], b.data, !1, null, l);
              if (!e.v(g)) {
                var m = -1;
                l && (m = b.Cl.length);
                b.Cl = [];
                b.Mi = [];
                var n = b.sg;
                b.sg = [];
                this.hha(b, a, c, [g], b.Aw, !1, null, m);
                0 == n.length && (this.BR(n, d, "0"), this.BR(n, g, "1"));
                b.sg = n;
                1 == b.Aw.length && (b.Aw[0].dr = "2");
              }
              return l;
            }
            oT(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              var c = b.__data__;
              null != c && c.data && (c = c.data);
              if (e.v(c) && e.model.C.F.DG) {
                var d = x.Ga.Xb(b).closest("li.fm-ui-element");
                !e.v(d) && d.attr("data-measure-index") && (c = {
                  RD: parseInt(d.attr("data-measure-index"))
                });
              }
              d = c;
              a && (d = f.hba(c), e.v(d) || (d.element = b));
              return d;
            }
            Hz(b) {
              return !isNaN(b) && e.u.i.RO.QO != b;
            }
            static hba(b) {
              if (e.v(b)) return null;
              var a = {};
              e.v(b.id) || (a.id = b.id);
              e.v(b.label) || (a.label = b.label);
              e.v(b.value) || (a.value = b.value);
              e.v(b.measure) || (a.measure = e.model.Va.R().ja.pa.fd(b.measure.A).ij());
              e.v(b.RD) || (a.measureIndex = b.RD);
              e.v(b.th) || (a.rows = e.model.Va.R().ja.pa.Q_(b.th));
              e.v(b.Gg) || (a.columns = e.model.Va.R().ja.pa.P_(b.Gg));
              return a;
            }
          }
          f.EC = null;
          h.tv = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.fr.bqa {
            constructor(a) {
              super(a);
              this.Hb = e.model.Va.R();
            }
            oz(a) {
              var c = [];
              a.Wc.forEach(d => {
                c.push({
                  id: `aggregation_${d}`,
                  label: e.u.i.da.tG(d),
                  isSelected: d == a.aa,
                  handler: () => this.qga(a, d)
                });
              });
              return c;
            }
            qga(a, c) {
              const d = this.Hb.ja.pa.clone();
              a = d.gd()[a.index];
              e.v(a) || (a.aa = c, this.Hb.fe(d));
            }
            uS(a, c, d) {
              e.Kg(f.FL) && (a = f.FL(a.slice(), c, d) || a);
              return a;
            }
            BS(a, c) {
              let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              this.Hb.Ya(e.K.Si.O6, this, {
                nEa: a,
                coords: c,
                XK: d
              });
            }
          }
          f.FL = null;
          h.MO = f;
          class b extends f {
            constructor(a) {
              super(a.G);
              this.K = a;
              this.K.N(h.vc.BJ, () => this.TFa());
              this.K.N(h.vc.vt, c => this.KFa(c));
            }
            TFa() {
              const a = this.K.ma.Dr;
              if (0 != a.length) {
                var c = a[0];
                const d = this.K.G.qg(),
                  g = d.left + this.K.ma.coords.$l(c.mc, this.K.ma.ec) + this.K.ma.coords.yh(c.mc);
                c = d.top + this.K.ma.coords.Ko(c.lb, this.K.ma.ec) + this.K.ma.coords.Xd(c.lb);
                1 == a.length ? this.show(a[0], {
                  left: g,
                  top: c
                }) : this.Iia(a, {
                  left: g,
                  top: c
                });
              }
            }
            KFa(a) {
              if (a.L4) {
                var c = this.K.ma.Hu(a.L4.G.element);
                a = a.L4.G.getBoundingClientRect();
                this.show(c, {
                  left: a.right,
                  top: a.bottom
                });
              } else {
                c = this.K.ma.Xf(a.lb, a.mc, !0);
                c.lb = a.lb;
                c.mc = a.mc;
                var d = this.K.G.qg();
                a = d.left + this.K.ma.coords.$l(c.mc, this.K.ma.ec) + this.K.ma.coords.yh(c.mc);
                d = d.top + this.K.ma.coords.Ko(c.lb, this.K.ma.ec) + this.K.ma.coords.Xd(c.lb);
                this.show(c, {
                  left: a,
                  top: d
                });
              }
            }
            S3(a, c) {
              a = this.K.ma.Hu(a.target) || this.K.ma.yda(c.clientX, c.clientY);
              null == a || e.ia(a.label) && isNaN(a.value) || (this.show(a, {
                left: c.clientX,
                top: c.clientY
              }), this.K.ma.Cs());
            }
            f4(a) {
              var c = this.K.G.qg(),
                d = a.clientX - c.left,
                g = a.clientY - c.top,
                l = a.clientX,
                m = a.clientY;
              if (!(0 > d || 0 > g || d > this.K.Zf() || g > this.K.yd())) {
                d = this.K.ma.Hu(a.target) || this.K.ma.yda(a.clientX, a.clientY);
                g = this.K.ma.Dr;
                0 == a.which && 0 != g.length && (d = g[0], l = c.left + this.K.ma.coords.$l(d.mc, this.K.ma.ec) + this.K.ma.coords.yh(d.mc), m = c.top + this.K.ma.coords.Ko(d.lb, this.K.ma.ec) + this.K.ma.coords.Xd(d.lb));
                c = !1;
                if (1 < g.length) for (var n = 0; n < g.length; n++) if (g[n].lb == d.lb && g[n].mc == d.mc) {
                  c = !0;
                  break;
                }
                (1 < g.length && c ? this.Iia(g, {
                  left: l,
                  top: m
                }) : this.show(d, {
                  left: l,
                  top: m
                })) && a.preventDefault();
              }
            }
            Iia(a, c) {
              if (e.model.C.F.readOnly) return !1;
              var d = [],
                g = this.K;
              if (this.LCa(a)) {
                var l = a[0].hierarchy,
                  m = a.map(n => n.Zb.ordinal);
                d.push({
                  id: "group",
                  label: e.model.B.j.Ska,
                  handler: () => {
                    e.mLa({
                      Iga: n => {
                        l.yaa(n, m);
                        this.Hb.ja.select();
                        this.K.ma.Cs();
                      },
                      $U: () => {
                        this.K.ma.Cs();
                      }
                    });
                  }
                });
              }
              d = this.uS(d, a.map(n => n.Sa()), g.aj ? "flat" : "pivot");
              return 0 < d.length ? (this.BS(d, c), !0) : !1;
            }
            LCa(a) {
              if (!e.model.C.F.KT) return !1;
              var c = a[0].hierarchy;
              if (e.v(c)) return !1;
              for (var d = 0; d < a.length; d++) {
                var g = a[d];
                if (g.hierarchy != c || e.v(g.Zb)) return !1;
              }
              return !0;
            }
            show(a, c) {
              if (e.model.C.F.readOnly) return !1;
              let d = [];
              const g = this.K;
              var l = e.v(a) || e.ia(a.label) && isNaN(a.value);
              !l && a.hi && !isNaN(a.value) && e.model.C.F.bd && !e.model.C.F.tc && e.u.Ma.R().fa && e.u.Ma.R().fa.jU && d.push({
                id: "drillthrough",
                label: e.model.B.j.N6,
                handler: () => {
                  g.bd(a);
                }
              });
              const m = this.Hb.ja.pa;
              if (!e.v(m)) {
                !l && a.ml && e.model.C.F.Gx && d.push({
                  id: "open_filter",
                  label: e.model.B.j.P6,
                  handler: () => {
                    this.K.Ea(new k.hP(a.hierarchy));
                  }
                });
                if (!l && a.ml && !e.model.C.F.tc) {
                  var n = m.Fya(a.hierarchy.A);
                  e.v(n) || (n.A != e.u.i.ha.Ia && d.push({
                    id: "move_to_rows",
                    label: e.model.B.j.Xka,
                    handler: () => {
                      n.Pa.removeItem(a.hierarchy.A);
                      m.hc.Pa.Ua(a.hierarchy.A, a.hierarchy);
                      this.Hb.fe(m);
                    }
                  }), n.A != e.u.i.ha.Ra && d.push({
                    id: "move_to_columns",
                    label: e.model.B.j.Vka,
                    handler: () => {
                      n.Pa.removeItem(a.hierarchy.A);
                      m.Rb.Pa.Ua(a.hierarchy.A, a.hierarchy);
                      this.Hb.fe(m);
                    }
                  }), n.A != e.u.i.ha.At && d.push({
                    id: "move_to_report_filters",
                    label: e.model.B.j.Wka,
                    handler: () => {
                      n.Pa.removeItem(a.hierarchy.A);
                      m.lI.Pa.Ua(a.hierarchy.A, a.hierarchy);
                      this.Hb.fe(m);
                    }
                  }), d.push({
                    id: "remove_field",
                    label: e.P.bind(e.model.B.j.Q6, a.hierarchy.caption),
                    handler: () => {
                      n.Pa.removeItem(a.hierarchy.A);
                      this.Hb.fe(m);
                    }
                  }));
                }
                l || !a.gi && !a.Ah || (a.Vf && d.push({
                  id: "collapse",
                  label: e.model.B.j.Kka,
                  handler: () => {
                    g.yu(a);
                  }
                }), a.collapsed && d.push({
                  id: "expand",
                  label: e.model.B.j.Qka,
                  handler: () => {
                    g.yu(a);
                  }
                }), !(a.hierarchy && 2 < a.hierarchy.wa.length) || m.gf && a.gi || m.Tf && a.Ah || (a.Hg || a.nh) && d.push({
                  id: a.Hg ? "drill_up" : "drill_down",
                  label: a.Hg ? e.model.B.j.Nka : e.model.B.j.Mka,
                  handler: () => {
                    g.ez(a);
                  }
                }));
                !l && (a.gi || a.Ah) && a.Zb && a.Zb.Zg && d.push({
                  id: "ungroup",
                  label: e.model.B.j.gla,
                  handler: () => {
                    a.hierarchy.mO(a.Zb);
                    this.Hb.ja.select();
                  }
                });
                !l && a.gi && !a.ml && a.On && (a.$o || d.push({
                  id: "sort_row_desc",
                  label: e.model.B.j.fla,
                  handler: () => {
                    g.w5(a, e.u.i.Aa.Mc);
                  }
                }), a.Zo || d.push({
                  id: "sort_row_asc",
                  label: e.model.B.j.ela,
                  handler: () => {
                    g.w5(a, e.u.i.Aa.kc);
                  }
                }), (a.Zo || a.$o) && d.push({
                  id: "clear_sorting",
                  label: e.model.B.j.M6,
                  handler: () => {
                    g.kva();
                  }
                }));
                !l && a.Ah && !a.ml && a.On && (a.$o || d.push({
                  id: "sort_column_desc",
                  label: e.model.B.j.dla,
                  handler: () => {
                    g.aO(a, e.u.i.Aa.Mc);
                  }
                }), a.Zo || d.push({
                  id: "sort_column_asc",
                  label: e.model.B.j.cla,
                  handler: () => {
                    g.aO(a, e.u.i.Aa.kc);
                  }
                }), (a.Zo || a.$o) && d.push({
                  id: "clear_sorting",
                  label: e.model.B.j.M6,
                  handler: () => {
                    g.fva();
                  }
                }));
                if (!l && (a.gi || a.Ah)) {
                  if (e.model.C.F.BI && a.hierarchy && a.Zb && 0 < a.Zb.level.We.length) {
                    var p = this.TAa(a.Zb.level.We, a.Zb.level.A);
                    0 < p.length && d.push({
                      id: "member_properties",
                      label: e.model.B.j.Zka,
                      submenu: p
                    });
                  }
                  a.Zb && e.model.C.F.Gx && 1 !== a.Zb.hierarchy.cb.length && (d.push({
                    id: "filter_by",
                    label: e.P.bind(e.model.B.j.Rka, a.Zb.caption),
                    handler: () => {
                      this.Hb.yl(a.hierarchy.A, {
                        members: [a.Zb.Ci]
                      });
                    }
                  }), d.push({
                    id: "exclude",
                    label: e.P.bind(e.model.B.j.Pka, a.Zb.caption),
                    handler: () => {
                      var r = a.hierarchy.nr(a.hierarchy.filter.yj(!0));
                      r = 0 === a.hierarchy.cb.length ? [a.Zb.Ci] : r.concat(a.Zb.Ci);
                      this.Hb.yl(a.hierarchy.A, {
                        exclude: r
                      });
                    }
                  }));
                }
                l || !this.mCa(a) && !this.lCa(a) || (p = this.oz(a.measure), 0 < p.length && d.push({
                  id: "aggregation",
                  label: e.model.B.j.L6,
                  submenu: p
                }));
                !l && a.measure && k.Nb.Gb.wea && (d.push({
                  id: "number_formatting",
                  label: e.model.B.j.Yka,
                  handler: () => {
                    this.GHa(a.measure);
                  }
                }), d.push({
                  id: "conditional_formatting",
                  label: e.model.B.j.Lka,
                  handler: () => {
                    this.EHa(a.measure);
                  }
                }));
                !l && a.measure && a.measure.Oa && d.push({
                  id: "edit_calculated_value",
                  label: e.P.bind(e.model.B.j.Oka, a.measure.caption),
                  handler: () => {
                    k.Nb.Gb.xN(a.measure.A);
                  }
                });
                var t = m.gd();
                !l && a.measure && 1 < t.length && !e.model.C.F.tc && d.push({
                  id: "remove_measure",
                  label: e.model.B.j.$ka,
                  handler: () => {
                    m.zha(a.measure);
                    this.Hb.fe(m);
                  }
                });
                !l && a.ml && e.model.C.F.tc && (e.v(a.measure) && e.v(a.hierarchy) || d.push({
                  id: "remove_field",
                  label: e.P.bind(e.model.B.j.Q6, a.hierarchy ? a.hierarchy.caption : a.measure.caption),
                  handler: () => {
                    a.hierarchy && m.Ka.Bb(a.hierarchy.A) ? m.Ka.removeItem(a.hierarchy.A) : a.hierarchy && m.rows.Bb(a.hierarchy.A) ? m.rows.removeItem(a.hierarchy.A) : a.hierarchy && m.ob.Bb(a.hierarchy.A) && m.ob.removeItem(a.hierarchy.A);
                    a.measure && t.find(r => r.A === a.measure.A) && m.zha(a.measure);
                    this.Hb.fe(m);
                  }
                }));
                if (!l && a.ml && !e.v(a.hierarchy) && e.model.C.F.uk && (l = m.rows.Bb(a.hierarchy.A), p = m.Ka.Bb(a.hierarchy.A), (l ? m.xb.indexOf(a.hierarchy.A) != m.xb.length - 1 : m.Db.indexOf(a.hierarchy.A) != m.Db.length - 1) && (l || p))) {
                  let r = !0 === a.hierarchy.If;
                  void 0 === a.hierarchy.If && (!l || "on" != e.model.C.F.If && "rows" != e.model.C.F.If || (r = !0), !p || "on" != e.model.C.F.If && "columns" != e.model.C.F.If || (r = !0));
                  d.push({
                    id: r ? "hide_hierarchy_totals" : "show_hierarchy_totals",
                    label: r ? e.model.B.j.Uka : e.model.B.j.bla,
                    handler: () => {
                      a.hierarchy.If = !r;
                      this.Hb.fe(m);
                    }
                  });
                }
                d = this.uS(d, a ? a.Sa() : null, g.aj ? "flat" : "pivot");
                return 0 < d.length ? (this.BS(d, c, r => this.Gta(r, a)), !0) : !1;
              }
            }
            Gta(a, c) {
              var d = ["open_filter", "drillthrough", "number_formatting", "conditional_formatting", "edit_calculated_value"];
              if (a && 0 <= d.indexOf(a.id)) return !1;
              d = ["move_to_rows", "move_to_columns", "move_to_report_filters", "remove_field"];
              if (a && 0 <= d.indexOf(a.id)) return !0;
              this.K.jA(c.lb, c.mc);
              return !1;
            }
            GHa() {
              let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.U8, {
                measureName: a.A,
                aggregation: a.aa
              }));
            }
            EHa() {
              let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.K6, {
                measureName: a.A
              }));
            }
            mCa(a) {
              return !e.model.C.F.tc && e.model.C.F.zl && a.measure && !a.measure.Oa && !a.measure.$g;
            }
            lCa(a) {
              return e.model.C.F.tc && e.model.C.F.zl && a.measure && !a.measure.Oa && a.Dz && a.Ks && 0 <= a.measure.index;
            }
            TAa(a, c) {
              for (var d = [], g = 0; g < a.length; g++) {
                var l = a.ea(g);
                if (l) {
                  var m = this.Hb.ja.pa.Ej;
                  m && m[c] && -1 < m[c].indexOf(l.A) ? d.push({
                    id: "hide_member_property",
                    label: e.P.bind(e.model.B.j.Tka, l.caption),
                    data: {
                      levelName: c,
                      propertyName: l.A
                    },
                    handler: n => {
                      this.K.Jia(n, !1);
                    }
                  }) : d.push({
                    id: "show_member_property",
                    label: e.P.bind(e.model.B.j.ala, l.caption),
                    data: {
                      levelName: c,
                      propertyName: l.A
                    },
                    handler: n => {
                      this.K.Jia(n, !0);
                    }
                  });
                }
              }
              return d;
            }
          }
          h.e8 = b;
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.be.ik {
            constructor() {
              super();
              this.zg = this.uf = this.vp = this.my = this.Ri = 0;
              this.Hb = e.model.Va.R();
              this.Xc = [];
              this.C$ = () => this.UFa();
              this.BU = b => this.mq(b);
              this.$("fm-grid-view");
              this.Je();
              this.Rk("grid");
              new h.e8(this);
              this.Hb.N("reset_grid", this.C$);
              this.Zu = u.pP.R();
              this.Zu.N(u.KeyboardEvent.oP, this.BU);
            }
            dispose() {
              this.I = null;
              this.Hb.pb("reset_grid", this.C$);
              this.Hb = null;
              this.ma && this.ma.dispose();
              this.ef = null;
            }
            mq(b) {
              if (this.Pm && null != this.Zu && null != this.ef) {
                var a = b.ctrlKey || b.metaKey;
                switch (b.keyCode) {
                  case 37:
                    this.scroll("left", a);
                    b.pq.preventDefault();
                    break;
                  case 38:
                    this.scroll("up", a);
                    b.pq.preventDefault();
                    break;
                  case 39:
                    this.scroll("right", a);
                    b.pq.preventDefault();
                    break;
                  case 40:
                    this.scroll("down", a);
                    b.pq.preventDefault();
                    break;
                  case 13:
                  case 32:
                    null != this.CH() ? this.ma.focus() : this.jA(this.ma.coords.qh, this.ma.coords.pg), b.stopPropagation();
                }
              }
            }
            scroll(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              switch (b) {
                case "up":
                  a ? this.ef.GJa() : this.ef.Cr(this.ef.coords.qh - 1);
                  break;
                case "down":
                  a ? this.ef.DJa() : this.ef.Cr(this.ef.coords.qh + 1);
                  break;
                case "left":
                  a ? this.ef.EJa() : this.ef.dt(this.ef.coords.pg - 1);
                  break;
                case "right":
                  a ? this.ef.FJa() : this.ef.dt(this.ef.coords.pg + 1);
              }
            }
            Fwa() {
              var b = new h.sheet.LO();
              b.cD = (a, c) => this.getData(a, c);
              b.N(h.vc.bo, a => this.UD(a));
              b.N(h.vc.NJ, a => this.C3(a));
              b.N(h.vc.wv, a => this.lq(a));
              b.N(h.vc.AF, a => this.d4(a));
              b.N(h.vc.BF, a => this.e4(a));
              b.N(h.vc.BJ, a => this.Ea(a));
              b.N(h.vc.vt, a => this.Ea(a));
              this.G.append(b);
              return b;
            }
            Cwa() {
              var b = new h.sheet.nC.KO();
              b.cD = (a, c) => this.getData(a, c);
              b.N(h.vc.bo, a => this.UD(a));
              b.N(h.vc.NJ, a => this.C3(a));
              b.N(h.vc.wv, a => this.lq(a));
              b.N(h.vc.AF, a => this.d4(a));
              b.N(h.vc.BF, a => this.e4(a));
              b.N(h.vc.BJ, a => this.Ea(a));
              b.N(h.vc.vt, a => this.Ea(a));
              this.G.append(b);
              return b;
            }
            Jwa() {
              var b = new h.sheet.flat.zJ();
              b.cD = (a, c) => this.getData(a, c);
              b.N(h.vc.bo, a => this.UD(a));
              b.N(h.vc.NJ, a => this.C3(a));
              b.N(h.vc.wv, a => this.lq(a));
              b.N(h.vc.AF, a => this.d4(a));
              b.N(h.vc.BF, a => this.e4(a));
              b.N(h.vc.BJ, a => this.Ea(a));
              b.N(h.vc.vt, a => this.Ea(a));
              this.G.append(b);
              return b;
            }
            lAa() {
              if (e.model.C.F.uk) {
                if (this.ma && this.ma.type == h.sheet.nC.KO.TYPE) return this.ma;
                null != this.ma && this.ma.Lg(!0);
                return this.Cwa();
              }
              if (e.model.C.F.tc) {
                if (this.ma && this.ma.type == h.sheet.flat.zJ.TYPE) return this.ma;
                null != this.ma && this.ma.Lg(!0);
                return this.Jwa();
              }
              if (this.ma && this.ma.type == h.sheet.LO.TYPE) return this.ma;
              null != this.ma && this.ma.Lg(!0);
              return this.Fwa();
            }
            nb() {
              if (!(1 > e.model.Ha.wc.Wj()) && (this.ef = this.lAa(), null != this.ma)) {
                this.ef.slice = e.u.Ma.R().pa;
                this.ma.Oia = this.Hb.Fa.KE ? 100 : 1E3;
                if (this.I && this.I.Xi) {
                  this.ma.clearData();
                  this.my = this.vp = this.Ri = 0;
                  var b = this.I.Bn,
                    a = e.model.C.F.uk ? 0 < this.I.xb.length ? 1 : 0 : this.I.Qk;
                  if (a >= b + 1) {
                    var c = 0;
                    var d = c + a;
                    var g = c + (a - b) - 1;
                  } else g = 0, c = 0 < this.I.vk ? g + (b - a) + 1 : g, 0 == this.I.Db.length && 0 == this.I.xb.length && (c += 1), d = c + a;
                  var l = g;
                  this.Ri = Math.min(c, l);
                  this.my = l;
                  this.vp = 0;
                  this.uf = d;
                  this.zg = this.aj ? 0 : e.model.C.F.uk ? this.I.hc.ab && this.I.dm ? this.I.vl.length + 1 : this.I.vl.length : 0 == this.I.rows.length ? 0 : 1;
                  e.model.C.F.jt || (this.my = 1 == a && 0 == this.I.vk ? 0 : -1, this.uf = b);
                  this.aj && (this.ma.QL.Pha = (m, n, p) => this.saveData(m, n, p), this.ma.QL.mia(e.model.C.F.OC));
                  this.aj && "on" == e.model.C.F.Hf && "top" == e.model.C.F.IH && this.uf++;
                  d = this.I.Fn;
                  this.aj && "on" == e.model.C.F.Hf && "bottom" == e.model.C.F.IH && (d += 1);
                  l = this.I.Gn;
                  0 == l && (l = this.I.Ka.length - (this.I.Rb.ab ? 1 : 0));
                  this.ma.jia(d, l);
                  this.ma.aza(this.zg);
                  this.ma.oda(this.uf);
                  if (this.ma instanceof h.sheet.LO && (this.ma.coords.HG = this.uf - this.I.Bn - 1, this.ma.aS.rowIndex = this.ma.coords.HG, this.ma.aS.gA(this.I.Db), this.ma.Jha.gA(this.I.xb), this.ma.Mga.gA(this.I.ob), e.model.C.F.Sm)) {
                    d = this.I.xb.length;
                    for (l = 1; l <= d; l++) this.ma.coords.Dx(this.ma.coords.ge - l, 52);
                    this.ma.coords.Dx(this.ma.coords.HG, 52);
                  }
                  this.ma instanceof h.sheet.nC.KO && (this.ma.coords.HG = this.uf - this.I.Bn - 1, this.ma.aS.rowIndex = this.ma.coords.HG, this.ma.aS.gA(this.I.Db), this.ma.Jha.gA(this.I.xb), this.ma.Mga.gA(this.I.ob));
                  (1 < this.I.Ka.length || !this.I.Rb.ab) && e.model.C.F.jt && this.waa(g, this.zg, e.u.i.ha.Ra);
                  (1 < this.I.rows.length || !this.I.hc.ab) && e.model.C.F.jt && (e.model.C.F.uk ? this.Dra(c) : this.waa(c, 0, e.u.i.ha.Ia));
                  this.hJa();
                  this.iJa();
                  this.gJa();
                  this.lJa();
                  this.jJa();
                  this.kJa();
                  this.G.Dg("rowcount", `${this.ma.coords.Jk}`);
                  this.G.Dg("colcount", `${this.ma.coords.dj}`);
                } else this.ma.lu();
                this.Xc = e.model.ua.dn.Xc.Pc();
                this.ma.resize(k.Nb.KM, k.Nb.qD);
                this.ma.nb();
              }
            }
            nu() {
              e.v(this.ma) || this.Hb.Fa.KE || (this.ma.FG(0), this.ma.pC(0));
            }
            getData(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              if (null == this.I || !this.I.Xi || b < this.my || a < this.vp) return null;
              var d = b - this.uf,
                g = a - this.zg;
              if ((d > this.I.Fn - 1 || g > this.I.Gn - 1) && !(this.aj && "on" == e.model.C.F.Hf && "bottom" == e.model.C.F.IH && d == this.I.Fn && g <= this.I.Gn - 1)) return null;
              var l = this.I.Jn(d, !0),
                m = this.I.Vj(g, !0);
              if (null == l && null == m) return null;
              var n = this.I.Di(d, g),
                p;
              if (this.aj) {
                var t = this.I.Vj(g, !0, !0);
                t instanceof Array && (p = t[0][1]);
              }
              if (this.aj && "on" == e.model.C.F.Hf && "top" == e.model.C.F.IH && (e.model.C.F.jt && 1 == b || !e.model.C.F.jt && 0 == b) || this.aj && "on" == e.model.C.F.Hf && "bottom" == e.model.C.F.IH && (e.model.C.F.jt && b == this.I.Fn + 1 || !e.model.C.F.jt && b == this.I.Fn)) return this.zAa(l, m, n);
              if (null == l) return c = 1 == (e.model.C.F.uk ? 1 : this.I.xb.length) && 0 == this.I.vk ? b - this.my : b - this.my - 1, 0 == this.I.xb.length && 0 == this.I.Db.length && (c = b - this.my), g = this.I.iM(g), this.bAa(m, n, g, c, a, p);
              t = this.I.yT(d);
              d = this.I.FT(d);
              g = this.I.iM(g);
              return null == m ? e.model.C.F.uk ? this.fsa(l, n, t, b, a, d) : this.lBa(l, n, t, b) : this.qH(l, m, n, b, a, c, t, g, d, p);
            }
            qH(b, a, c, d, g) {
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
              let m = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : NaN;
              let n = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : NaN;
              let p = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : -1;
              let t = arguments.length > 9 ? arguments[9] : undefined;
              if (e.v(c)) {
                var r = new h.W.le();
                r.hi = !0;
                r.Gg = a;
                r.th = b;
                r.am = this.I.Qk > b.length;
                r.ex = this.I.vk > a.length;
                r.ID = 0 == a.length;
                r.Ks = 0 == b.length;
                return r;
              }
              var w = c.ci(c.A, c.aa).clone();
              c.aa == e.u.i.da.Pi ? w.xd = "" : e.u.i.da.Fe(c.aa) ? w.Fe = !0 : e.u.i.da.ce(c.aa) && (w.ce = !0, w.xd = "%");
              r = new h.W.le();
              r.hi = !0;
              r.Gg = a;
              r.measure = c;
              r.hierarchy = this.Hb.ja.O.Kk(c.A);
              r.th = b;
              e.model.C.F.uk ? 0 == b.length ? r.level = 0 : (m = this.z1(b), -1 < m && (r.level = m)) : e.model.C.F.tc || (r.level = m);
              t = this.I.La(b, a, c, t);
              r.value = t;
              this.aj ? (w = c.type != e.u.i.Qa.zc ? c.ci(c.A, c.aa).clone() : c.ci(c.A, c.aa, !0).clone(), c.type == e.u.i.Qa.zc ? (m = this.I.nH(a).za(t), null != m && (r.Zb = m, r.label = m.caption)) : c.type == e.u.i.Qa.jb ? "string" === typeof t ? r.label = t : (r.label = u.cc.format(t, w), r.numeric = !0) : c.type == e.u.i.Qa.Ta ? null === t ? r.label = e.model.B.j.hX : (m = this.Hb.ja.fa.mapping.La(c.A, "format", e.model.C.F.Lp), r.label = e.P.Kx(t, m, e.model.C.F.Uj)) : c.type == e.u.i.Qa.ic ? isNaN(t) || (m = this.Hb.ja.fa.mapping.La(c.A, "format", e.model.C.F.ep), r.label = e.P.Lx(t, m)) : c.type != e.u.i.Qa.Lc || isNaN(t) || (m = this.Hb.ja.fa.mapping.La(c.A, "format", e.model.C.F.zk), r.label = e.P.iO(t, m, e.model.C.F.Uj))) : (m = (this.Hb.Fa.fa.Ba == e.u.i.qa.Cc || this.Hb.Fa.fa.Ba == e.u.i.qa.Md) && e.model.C.F.Rn && c.aa == e.u.i.da.NONE, m || c.type != e.u.i.Qa.jb && c.type != e.u.i.Qa.zc) ? m || c.type != e.u.i.Qa.Ta ? m || c.type != e.u.i.Qa.ic ? m || c.type != e.u.i.Qa.Lc ? (r.label = m ? this.I.Wp(b, a, c) : e.u.rY.R().La(t), r.numeric = m && e.u.i.Qa.jb === c.type) : isNaN(r.value) || (e.u.i.da.NE(c.aa) ? (m = this.Hb.ja.fa.mapping.La(c.A, "format", e.model.C.F.zk), r.label = e.P.iO(t, m, e.model.C.F.Uj)) : r.label = u.cc.format(t, w)) : isNaN(t) || (e.u.i.da.hp(c.aa) ? (m = this.Hb.ja.fa.mapping.La(c.A, "format", e.model.C.F.ep), r.label = e.P.Lx(t, m)) : r.label = u.cc.format(t, w)) : isNaN(t) || (e.u.i.da.NE(c.aa) ? (m = this.Hb.ja.fa.mapping.La(c.A, "format", e.model.C.F.Lp), r.label = e.P.Kx(r.value, m, e.model.C.F.Uj)) : r.label = u.cc.format(t, w)) : "string" === typeof t ? r.label = t : (r.label = u.cc.format(t, w), r.numeric = !0);
              r.sI = this.I.Hs(b, a);
              m = !1;
              var y = this.I.Bh(b, void 0, c);
              if (this.I.Qk > b.length || y || this.I.vk > a.length) {
                m = !0;
                r.am = this.I.Qk > b.length || y;
                r.ex = this.I.vk > a.length;
                if ("on" != e.model.C.F.If && !e.model.C.F.uk) {
                  var A = this.I.Mz;
                  if (0 != b.length && (this.I.Th(b) || this.I.Th(b, c) || y) && ("off" == e.model.C.F.If || "columns" == e.model.C.F.If) || 0 != a.length && (this.I.Xj(a) || this.I.Xj(a, c)) && ("off" == e.model.C.F.If || "rows" == e.model.C.F.If)) return null;
                  if (0 == A && 1 < this.I.Ca.length) if (this.I.hc.ab && ("off" == e.model.C.F.If || "columns" == e.model.C.F.If)) {
                    if (d < ("on" == e.model.C.F.Hf || "columns" == e.model.C.F.Hf ? this.uf + this.I.Fn - this.I.Ca.length : this.uf + this.I.Fn) && this.I.Th(b, c)) return null;
                  } else if (this.I.Rb.ab && ("off" == e.model.C.F.If || "rows" == e.model.C.F.If) && g < ("on" == e.model.C.F.Hf || "rows" == e.model.C.F.Hf ? this.zg + this.I.Gn - this.I.Ca.length : this.zg + this.I.Gn) && this.I.Xj(a, c)) return null;
                }
                r.Ks = 0 == b.length;
                r.ID = 0 == a.length;
                r.dU = r.am && 2 == p && !r.Ks;
                if (e.model.C.F.uk && r.Dz && "on" != e.model.C.F.Hf && 0 != this.I.vk && 0 != this.I.Qk && ("off" == e.model.C.F.Hf || "rows" == e.model.C.F.Hf && r.Ks || "columns" == e.model.C.F.Hf && r.ID)) return null;
              }
              this.I.F2(d) && (m = !0, r.am = !0);
              this.I.l2(g) && (m = !0, r.ex = !0);
              r.measure && (r.measure.Fz || r.measure.Ez) && !isNaN(r.value) && (r.label = "", r.Fz = r.measure.Fz, r.Ez = r.measure.Ez);
              if (l) return r;
              "" != w.textAlign && r.Yy({
                "text-align": w.textAlign
              });
              if (0 < this.Xc.length && r.measure) for (l = 0; l < this.Xc.length; l++) (p = this.Xc[l], p.bt != d && -1 != p.bt || p.pu != g && -1 != p.pu || !(p.measure == c.A && "" === p.aa || "" == p.measure && r.numeric || p.measure == "[Measures].[" + c.A + "]" || p.measure == c.A && p.aa === r.measure.aa) || p.Hk !== m && void 0 !== p.Hk || "" != p.hierarchy && !this.Nua(b, a, p.hierarchy, p.Zb)) || ((this.Hb.Fa.fa.Ba == e.u.i.qa.API ? (e.v(p.fH) && (p.fH = u.wt.uH(p.Sd, this.Hb.ja.O.Ca)), y = p.fH.slice(0)) : y = p.Sd.slice(0), p.H2) ? this.Hb.Fa.KE && (w = this.I.nD(b, a, c)) && (-1 < p.De.toLowerCase().indexOf(e.u.i.sc.kQ) ? t = w.Op : -1 < p.De.toLowerCase().indexOf(e.u.i.sc.lQ) && (t = 100 * w.Ys), w = this.I.kw(b, a, y, t), null != w && r.Xba(w)) : (w = this.I.kw(b, a, y, t), e.v(p.format) || !0 !== w && "truestyle" !== w || (r.Yy(p.format.gja()), r.Xc.push(p.id)), r.xKa = !0));
              "after" === e.model.C.F.pL && this.I.Bj(a, void 0, c) && -1 !== n && (r.label = "");
              return r;
            }
            zAa(b, a, c) {
              if (e.v(c)) return null;
              var d = new h.W.le();
              d.hi = !0;
              d.Gg = a;
              d.measure = c;
              d.hierarchy = this.Hb.ja.O.Kk(c.A);
              d.th = b;
              if (c.type == e.u.i.Qa.jb || c.type == e.u.i.Qa.ic || c.type == e.u.i.Qa.Lc) {
                var g = c.ci(c.A, c.aa).clone();
                if (c.aa == e.u.i.da.Pi) g.xd = "";else if (e.u.i.da.Fe(c.aa)) g.Fe = !0;else if (e.u.i.da.ce(c.aa) || c.Oa && -1 < c.De.indexOf("percent")) g.ce = !0, g.xd = "%";
                d.value = this.I.La(null, null, c);
                if (c.type == e.u.i.Qa.jb) d.label = u.cc.format(d.value, g), d.numeric = !0;else if (c.type == e.u.i.Qa.ic) isNaN(d.value) || (d.label = e.u.i.da.hp(c.aa) ? e.P.Lx(d.value, e.model.C.F.ep) : u.cc.format(d.value, g));else if (c.type == e.u.i.Qa.Lc && !isNaN(d.value)) {
                  var l = this.Hb.ja.fa.mapping.La(c.A, "format", e.model.C.F.zk);
                  d.label = e.u.i.da.NE(c.aa) ? e.P.iO(d.value, l, e.model.C.F.Uj) : u.cc.format(d.value, g);
                }
                d.Ks = !0;
                d.am = !0;
                "" != g.textAlign && d.Yy({
                  "text-align": g.textAlign
                });
                if (0 < this.Xc.length) for (g = 0; g < this.Xc.length; g++) {
                  l = this.Xc[g];
                  let p;
                  this.Hb.Fa.fa.Ba == e.u.i.qa.API ? (e.v(l.fH) && (l.fH = u.wt.uH(l.Sd, this.Hb.ja.O.Ca)), p = l.fH.slice(0)) : p = l.Sd.slice(0);
                  if (l.measure == c.A && l.H2 && this.Hb.Fa.KE) {
                    var m = this.I.nD(b, a, c);
                    if (m) {
                      var n;
                      -1 < l.De.toLowerCase().indexOf(e.u.i.sc.kQ) ? n = m.Op : -1 < l.De.toLowerCase().indexOf(e.u.i.sc.lQ) && (n = 100 * m.Ys);
                      l = this.I.kw(b, a, p, n);
                      null != l && d.Xba(l);
                    }
                  }
                }
              }
              return d;
            }
            Nua(b, a, c, d) {
              var g = this.I.Ka.indexOf(c);
              if (-1 < g) {
                if (g < a.length) return b = this.I.Ka.getItem(c), a[g] && b.za(a[g]).aH(d);
              } else if (a = this.I.rows.indexOf(c), -1 < a && a < b.length) return c = this.I.rows.getItem(c), b[a] && c.za(b[a]).aH(d);
              return !1;
            }
            bAa(b, a, c, d, g, l) {
              return this.aj ? this.esa(b, a, l) : this.dsa(b, a, c, d, g);
            }
            wQ(b) {
              if (b.Sh) return !0;
              if (1 < b.children.length) return !1;
              b = b.hierarchy.za(b.children[0]);
              return b.caption !== e.model.B.j.Fl && b.caption !== e.model.B.j.Wn ? !1 : this.wQ(b);
            }
            dsa(b, a, c, d, g) {
              if (0 == b.length) {
                if (this.I.hc.ab && d == this.I.Bn - 1) return this.vH(a, e.u.i.ha.Ra);
                b = this.I.Gn - this.I.Ca.length + 1;
                if (this.I.Rb.ab && d == this.I.Bn - 1 && g >= b && 1 == this.I.Ca.length) return this.vH(a, e.u.i.ha.Ra);
                b = "on" == e.model.C.F.Hf || "rows" == e.model.C.F.Hf ? this.zg + this.I.Gn - this.I.Ca.length : this.zg + this.I.Gn;
                if (this.I.Rb.ab && 0 == d && g >= b && 1 < this.I.Bn) {
                  if (g == b) {
                    var l = this.fD();
                    l.label = e.model.B.j.pna;
                    return l;
                  }
                  return this.nM();
                }
                return this.I.Rb.ab && 0 == d && 1 < this.I.Bn ? this.vH(a, e.u.i.ha.Ra) : this.I.Rb.ab && d == this.I.Bn - 1 ? g >= b || 1 == this.I.Rb.Pa.length ? this.vH(a, e.u.i.ha.Ra) : this.fD() : this.I.Rb.ab && 0 < d && g <= b ? this.fD() : 0 <= d ? this.nM() : null;
              }
              var m = this.I.Rb.ab && (b.length > this.I.ie || 0 == this.I.ie) ? b.length : b.length - 1,
                n = this.I.Ka.ea(m),
                p,
                t = this.I.t2(g - this.zg);
              void 0 !== t && -1 < d && (m = p = d, this.I.Rb.ab && m >= this.I.ie && 1 < this.I.Ca.length && (p--, m++), p < t[0] && (t = void 0));
              this.I.Rb.ab && m > this.I.ie && (1 == this.I.Ca.length ? m-- : c++);
              if (c > d && void 0 === t || 0 > d) return 0 <= d ? this.nM() : null;
              l = new h.W.le();
              l.Ah = !0;
              l.measure = this.I.Rb.ab && (1 < this.I.Ca.length || e.model.C.F.AI) ? a : void 0;
              var r = !1,
                w = this.I.Mz;
              if (void 0 !== t) {
                if (e.v(b[p])) {
                  if (d == w - 1) l.label = void 0 !== a ? a.caption : e.model.B.j.HX, l.UM = !0;else return this.nM();
                } else {
                  var y = b[p];
                  n = this.I.Db.ea(p);
                }
              } else y = b[b.length - 1];
              y = n.za(y);
              l.sI = this.I.Hs([], b);
              if (this.I.Rb.ab && 1 < this.I.Ca.length && d == w - 1 || this.I.Rb.ab && e.model.C.F.AI && d == w - 1 && 1 != w || this.I.Rb.ab && e.model.C.F.AI && d == w && 1 == w && 2 > this.I.Ca.length) l.label = a.label, l.UM = !0, y = null;else {
                if (this.I.Rb.ab && void 0 !== a && 0 < a.index && d < w) return this.nM();
                c < d ? m == d ? (r = b.length - 1 != this.I.vk - 1 && !y.dc, l.label = y.caption) : (l.label = this.I.Bn - 1 == d && e.model.C.F.AI ? void 0 !== a ? a.caption : e.model.B.j.HX : "", y = null) : (r = b.length - 1 != this.I.vk - 1 && !y.dc, l.label = y.caption, this.I.Rb.ab && d < w && 1 < this.I.Ca.length && (l.measure = a = void 0));
                void 0 !== t && (t[t.length - 1] >= p && (r = !0), e.v(b[p]) && (r = !1));
              }
              d = null == y ? !1 : this.I.Bj(b, y, a);
              !y || this.wQ(y) || y.dc || y.Sh || !y.hierarchy.Bf || y.level.Su || (r || e.model.C.F.DE ? d ? l.Hg = !0 : l.nh = !0 : d ? l.Vf = !0 : l.collapsed = !0);
              r && !d && (this.I.Xj(b, a) || void 0 !== t && -1 < t.indexOf(p) ? l.Vf = !0 : l.collapsed = !0);
              if ("on" == e.model.C.F.Kj || "columns" == e.model.C.F.Kj) {
                l.On = !0;
                if (e.ia(l.label) || e.v(a)) l.On = !1;
                "off" != e.model.C.F.If && "rows" != e.model.C.F.If || !l.Vf || (l.On = !1);
                l.On && this.I.Nl && this.I.Nl.toString() == b.toString() && this.I.er == a && (this.I.Nh == e.u.i.Aa.Mc ? l.$o = !0 : this.I.Nh == e.u.i.Aa.kc && (l.Zo = !0));
              }
              l.ex = this.I.vk > b.length || l.nh || l.Hg || !e.model.C.F.DE && (l.Vf || l.collapsed);
              l.ex && this.I.Y4(g);
              "after" !== e.model.C.F.pL || -1 !== c || l.UM || (l.On = !1, l.label = "", l.Vf = !1, l.collapsed = !1, l.Hg = !1, l.nh = !1);
              l.gg = void 0 !== t ? b.slice(0, p + 1) : b;
              l.hierarchy = n;
              l.Zb = y;
              return l;
            }
            esa(b, a, c) {
              const d = this.I.nH(b);
              if (void 0 === d) {
                if (e.v(a)) return null;
                b = new h.W.le();
                b.Ah = !0;
                b.label = a.caption;
                b.measure = a;
                this.Uaa(b, a);
                return b;
              }
              let g;
              void 0 !== c && (g = d.wa.ea(c));
              const l = new h.W.le();
              l.Ah = !0;
              l.ml = !0;
              l.ST = d.RS;
              l.cb = d.filter.zh;
              l.label = void 0 === g ? d.label : d.label + "." + g.caption;
              l.gg = b;
              l.hierarchy = d;
              l.level = c;
              l.Zb = null;
              l.measure = a;
              l.draggable = !0;
              this.Uaa(l, a);
              return l;
            }
            Uaa(b, a) {
              if ("on" === e.model.C.F.Kj || "columns" === e.model.C.F.Kj) {
                b.On = !0;
                const c = this.I.kT(a.A);
                !e.v(c) && c.measure && c.measure.A == a.A && (c.sort == e.u.i.Aa.Mc ? b.$o = !0 : c.sort == e.u.i.Aa.kc && (b.Zo = !0), 1 < this.I.yi.length && (b.y5 = this.I.yi.indexOf(c)));
              }
            }
            fD() {
              var b = new h.W.le();
              b.Ah = !0;
              return b;
            }
            nM() {
              var b = this.fD();
              b.kb = !0;
              return b;
            }
            vH(b, a) {
              var c = new h.W.le();
              c.label = void 0 === b ? e.model.B.j.GX : b.Xp;
              c.UM = void 0 !== b;
              void 0 !== b && b.V1 && (c.label = b.label);
              if (a == e.u.i.ha.Ra) {
                c.Ah = !0;
                c.ex = c.ID = !0;
                if ("on" === e.model.C.F.Kj || "columns" === e.model.C.F.Kj) c.On = !0, !this.I.Nl || "" !== this.I.Nl.toString() || void 0 !== b && this.I.er !== b || (this.I.Nh === e.u.i.Aa.Mc ? c.$o = !0 : this.I.Nh === e.u.i.Aa.kc && (c.Zo = !0));
                this.I.Rb.ab ? c.measure = b : c.label = e.model.B.j.GX;
              } else {
                c.gi = !0;
                c.am = c.Ks = !0;
                if ("on" === e.model.C.F.Kj || "rows" === e.model.C.F.Kj) c.On = !0, !this.I.Ij || "" !== this.I.Ij.toString() || void 0 !== b && this.I.To !== b || (this.I.ak === e.u.i.Aa.Mc ? c.$o = !0 : this.I.ak === e.u.i.Aa.kc && (c.Zo = !0));
                this.I.hc.ab ? c.measure = b : c.label = e.model.B.j.GX;
                c.level = 0;
              }
              c.gg = [];
              return c;
            }
            lBa(b, a, c, d) {
              if (0 == b.length) return this.vH(a, e.u.i.ha.Ia);
              var g = this.I.hc.ab && b.length > this.I.ie ? b.length : b.length - 1,
                l = b[b.length - 1],
                m = this.I.rows.ea(g),
                n = new h.W.le();
              n.gi = !0;
              var p = !1;
              l = m.za(l);
              n.level = c;
              void 0 !== a && this.I.hc.ab && this.I.dm && g <= this.I.ie ? (n.label = a.label, l = null) : l && (p = this.xC(l), n.UT = "" != p, n.label = l.caption + p, p = b.length != this.I.Qk && !l.dc && !l.Zg);
              c = null == l ? !1 : this.I.Bh(b, l, a);
              !l || l.dc || !l.hierarchy.Bf || l.Sh || this.wQ(l) || (e.model.C.F.DE ? c ? n.Hg = !0 : n.nh = !0 : c ? n.Vf = !0 : n.collapsed = !0);
              p && !c && (this.I.Th(b, a) ? n.Vf = !0 : n.collapsed = !0);
              if ("on" == e.model.C.F.Kj || "rows" == e.model.C.F.Kj) if (!(this.I.hc.ab && 1 < this.I.Ca.length && this.I.ie >= b.length) || a && n.label == a.caption) n.On = !0, this.I.Ij && this.I.Ij.toString() == b.toString() && this.I.To == a && (this.I.ak == e.u.i.Aa.Mc ? n.$o = !0 : this.I.ak == e.u.i.Aa.kc && (n.Zo = !0));
              n.am = this.I.Qk > b.length || n.Hg || n.nh || !e.model.C.F.DE && (n.Vf || n.collapsed);
              n.gg = b;
              n.hierarchy = m;
              n.Zb = l;
              n.measure = this.I.hc.ab && 1 < this.I.Ca.length ? a : void 0;
              n.sI = this.I.Hs(b, []);
              n.am && this.I.iW(d);
              return n;
            }
            fsa(b, a, c, d, g, l) {
              if (0 === b.length) {
                if (0 === g) return this.vH(a, e.u.i.ha.Ia);
                var m = new h.W.le();
                m.gi = !0;
                m.am = m.Ks = !0;
                m.kb = !0;
                m.level = c;
                return m;
              }
              var n = g;
              m = this.I.vl[g];
              for (var p, t, r = 0; r < this.I.xb.length; r++) {
                var w = this.I.xb.ea(r);
                p = w.Cu(m);
                if (null != p) {
                  var y = w;
                  n = r;
                  break;
                }
              }
              r = null == b[n] ? 0 : b[n];
              m = new h.W.le();
              m.gi = !0;
              m.am = this.I.Qk > b.length;
              m.dU = m.am && 2 == l;
              p = !1;
              c > g && (p = !0);
              c > g && 2 == l && (p = !0);
              c + 1 < g && 2 == l && (p = !0);
              m.level = Math.min(b.length - 1, g);
              var A = b.slice(0);
              w = !1;
              if (g == this.I.vl.length) m.label = a.label, w = !0;else {
                var B = !1;
                A = void 0 === a ? 0 : a.index;
                var C = y.za(r);
                t = this.I.vl.indexOf(C.level.A) - g;
                var I = null != C && (C.Zg || 2 != l);
                if (0 > t) {
                  if (C.dc) w = !0;else return m;
                } else if (0 < t) for (r = 0; r < t; r++) C = C.parent;
                C && (r = this.I.vl.indexOf(C.level.A), -1 < r && (m.level = r));
                m.Zb = C;
                if (2 == l) C && c == g && (m.label = this.I.hc.ab && 1 < this.I.Ca.length ? C.caption + " " + a.label : C.caption + " " + e.model.B.j.HX, w = !0);else {
                  if (0 > t) return e.ia(m.label) && (m.kb = !0), r = this.z1(b), -1 < r && (m.level = r), m;
                  0 < A && (C = null);
                  C && 0 != C.ordinal && (r = this.xC(C), m.UT = "" != r, m.label = C.caption + r);
                  B = 1 == l && n < this.I.xb.length - 1 && 0 >= A && !C.Zg;
                }
                m.sI = this.I.Hs(b, []);
                A = b.slice(0, n + 1);
                if (I && C) {
                  A[n] = C.ordinal;
                  var L = this.I.Bh(A, C, a);
                  C.dc || !C.hierarchy.Bf || C.Sh || 2 == l && (!C.Zg || L) || this.wQ(C) || (e.model.C.F.DE ? L ? m.Hg = !0 : (m.nh = !0, m.am = !0) : L ? m.Vf = !0 : (m.collapsed = !0, m.am = !0));
                }
                B && !L && (this.I.Th(A, a) ? m.Vf = !0 : m.collapsed = !0);
              }
              if (p) m.label = "", m.Zo = m.$o = m.collapsed = m.Vf = m.Hg = m.nh = !1;else if (m.gg = A, m.hierarchy = y, m.measure = this.I.hc.ab && 1 < this.I.Ca.length ? a : void 0, "on" == e.model.C.F.Kj || "rows" == e.model.C.F.Kj) m.On = !0, !this.I.Ij || this.I.Ij.toString() != A.toString() || this.I.To != a || m.Vf || m.Hg || this.I.hc.ab && 1 < this.I.Ca.length && (!(this.I.hc.ab && 1 < this.I.Ca.length) || null != m.Zb && !m.dU) || (this.I.ak == e.u.i.Aa.Mc ? m.$o = !0 : this.I.ak == e.u.i.Aa.kc && (m.Zo = !0));
              w && (r = this.z1(b), -1 < r && (m.level = r));
              e.ia(m.label) && (m.kb = !0, m.HCa = 2 == l && C && g - 1 > c ? !1 : !0);
              m.am && this.I.iW(d);
              return m;
            }
            z1(b) {
              return (b = this.I.zT(b).za(b[b.length - 1])) ? this.I.vl.indexOf(b.level.A) : -1;
            }
            xC(b) {
              if (this.Hb.Fa.fa.Ba !== e.u.i.qa.Cc && this.Hb.Fa.fa.Ba !== e.u.i.qa.Md || !e.model.C.F.BI) return "";
              var a = this.Hb.ja.pa.Ej[b.level.A];
              if (void 0 === a || 0 === a.length) return "";
              for (var c = [], d = 0; d < a.length; d++) {
                var g = b.level.We.getItem(a[d]),
                  l = b.iBa(a[d]);
                e.ia(l) || null == g || c.push('<br/><span class="fm-member-property-label">' + g.caption + ':</span> <span class="fm-member-property-value">' + l + "</span>");
              }
              return 0 < c.length ? c.join("") + "<br/>" : "";
            }
            UD(b) {
              e.v(b.cell) || e.model.C.F.readOnly || !b.cell.Ah && !b.cell.gi || (b.cell.ZB == h.W.Eq.h7 ? this.ez(b.cell) : b.cell.ZB == h.W.Eq.sP && b.cell.UCa || (e.v(b.cell.Zb) || b.cell.ZB == h.W.Eq.YJ ? b.cell.ZB == h.W.Eq.YJ && (b.cell.Ah && this.aO(b.cell, null, !u.qj.No && b.pq.ctrlKey || u.qj.No && b.pq.metaKey), b.cell.gi && this.w5(b.cell)) : e.model.C.F.DE || b.cell.Zb.Sh ? this.yu(b.cell) : this.ez(b.cell)));
            }
            lq(b) {
              e.model.C.F.Gx && b.hierarchy.ZM && this.Ea(new k.hP(b.hierarchy));
            }
            ez(b) {
              if (b.nh || b.Hg || b.Vf || b.collapsed) {
                var a = b.gg,
                  c = e.model.C.F.uk ? void 0 : b.measure,
                  d = b.Zb;
                if (null != d && !d.dc && !d.Sh) {
                  if (b.gi) {
                    b = e.u.i.ha.Ia;
                    var g = this.I.Bh(a, d, c);
                  } else b = e.u.i.ha.Ra, g = this.I.Bj(a, d, c);
                  g ? this.I.Pp(a, d, b, c) : this.I.Ae(a, d, b, c);
                }
              }
            }
            yu(b) {
              if (!e.v(this.ma) && (b.Vf || b.collapsed)) {
                var a = b.gg,
                  c = b.Ah ? e.u.i.ha.Ra : e.u.i.ha.Ia,
                  d = e.model.C.F.uk && c == e.u.i.ha.Ia ? void 0 : b.measure;
                b.Vf ? (this.ma.clearData(), this.I.collapse(a, c, d)) : b.collapsed && (this.ma.clearData(), this.I.expand(a, c, d));
                b.Ah ? this.ma.FG(b.mc + 1) : this.ma.pC(b.lb + 1);
              }
            }
            C3(b) {
              b.rfa ? this.zKa(b.cell) : (e.model.C.F.bd && !e.model.C.F.tc && this.Hb.ja.fa && this.Hb.ja.fa.jU && this.bd(b.cell), this.Cxa(b.cell));
            }
            bd(b) {
              b.hi && void 0 !== b.measure && (b = new k.m7({
                A: b.measure.A,
                aa: b.measure.aa
              }, b.Gg, b.th, b.Sa()), this.Ea(b));
            }
            zKa(b) {
              var a = b.Sa();
              this.ZV(a, b.mc, b.lb);
              e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.D6, a));
            }
            Cxa(b) {
              var a = b.Sa();
              this.ZV(a, b.mc, b.lb);
              e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.EO, a));
            }
            ZV(b, a, c) {
              b.x = this.ma.coords.$l(a, this.ma.ec);
              b.y = this.ma.coords.Ko(c, this.ma.ec);
              b.width = this.ma.coords.yh(a);
              b.height = this.ma.coords.Xd(c);
            }
            w5(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              var c = b.gg;
              b = b.measure;
              void 0 === b && (b = this.I.Ca[0]);
              this.I.Ij && this.I.Ij.toString() == c.toString() && this.I.To == b ? this.I.ak = this.I.ak == e.u.i.Aa.Mc ? e.u.i.Aa.kc : e.u.i.Aa.Mc : (this.I.ak = e.u.i.Aa.Mc, this.I.Ij = c, this.I.To = b);
              "" != a && (this.I.ak = a);
              this.I.sort();
              this.ma.FG(0);
              this.nb();
            }
            aO(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              if (e.model.C.F.tc) {
                let d = this.I.kT(b.measure.A);
                a = this.I.yi.slice(0);
                e.v(d) ? (b = {
                  measure: b.measure,
                  sort: e.u.i.Aa.xT("", b.measure.type != e.u.i.Qa.zc, !0)
                }, !e.v(a) && c ? a.push(b) : a = [b]) : (d.sort = e.u.i.Aa.xT(d.sort, b.measure.type != e.u.i.Qa.zc, !0), d.sort == e.u.i.Aa.ed ? a.splice(this.I.yi.indexOf(d), 1) : c || (a = [d]));
                this.I.yi = a;
              } else this.I.Nl = b.gg, this.I.er = e.v(b.measure) ? this.I.Ca[0] : b.measure, this.I.Nh = e.ia(a) ? e.u.i.Aa.xT(this.I.Nh) : a;
              this.I.sort();
              this.ma.pC(0);
              this.nb();
            }
            fva() {
              this.I.Nh = e.u.i.Aa.ed;
              this.I.Nl = null;
              this.I.er = void 0;
              this.I.Rb.qC();
              this.I.sort();
              this.ma.pC(0);
              this.nb();
            }
            kva() {
              this.I.ak = e.u.i.Aa.ed;
              this.I.Ij = null;
              this.I.To = void 0;
              this.I.hc.qC();
              this.I.sort();
              this.ma.FG(0);
              this.nb();
            }
            Jia(b, a) {
              var c = this.Hb.ja.pa.Ej;
              c || (c = {});
              c[b.levelName] || (c[b.levelName] = []);
              var d = c[b.levelName].indexOf(b.propertyName);
              a ? -1 == d && (c[b.levelName].push(b.propertyName), this.Hb.ja.pa.Ej = c) : -1 < d && c[b.levelName].splice(d, 1);
              this.ma.clearData();
              this.ma.pC(0);
              this.nb();
            }
            saveData(b, a, c) {
              b = this.getData(b, a);
              b.label != c && b.value != c && (this.I.save(b.th, b.Gg, b.hierarchy, c), this.aj && this.nb());
            }
            waa(b, a, c) {
              for (var d = c == e.u.i.ha.Ra ? this.I.Db : this.I.xb, g, l = 0, m = 0; m < d.length; m++) {
                var n = d.ea(m);
                n.Ue || (g = new h.W.le(), g.label = n.label, g.ml = !0, g.draggable = !0, g.ST = !0, g.cb = n.filter.zh, g.level = l, g.hierarchy = n, c == e.u.i.ha.Ra ? (g.isFrozen = !this.aj, this.ma.I.$V(b, a + m, g)) : (g.gi = !0, this.ma.I.$V(b + l, a, g), l++));
              }
            }
            Dra(b) {
              for (var a = this.I.xb, c, d = 0, g = this.I.hc.ab && 1 < this.I.Ca.length ? this.zg - 1 : this.zg, l = 0; l < a.length; l++) {
                var m = a.ea(l);
                c = new h.W.le();
                c.label = m.label;
                c.ml = !0;
                c.draggable = !0;
                c.ST = !0;
                c.cb = m.filter.zh;
                c.hierarchy = m;
                this.ma.I.$V(b, 0 + d, c);
                d++;
                if (2 < m.wa.length) for (var n = null == m.lc ? 2 : m.lc.yb + 1; n < m.wa.length; n++) {
                  var p = m.wa.ea(n);
                  -1 != this.I.vl.indexOf(p.A) && (c = new h.W.le(), c.label = p.caption, c.gi = !0, c.ST = !0, this.ma.I.$V(b, 0 + d, c), d++);
                  if (d >= g) break;
                }
                if (d >= g) break;
              }
            }
            get aj() {
              return e.model.C.F.tc;
            }
            get ma() {
              return this.ef;
            }
            Bk(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              b == e.model.Dc.nj.VA && e.model.Dc.x7.Xe(this, a, d);
              b == e.model.Dc.nj.zv && e.model.Dc.w7.Xe(this, a, this.ma.coords.Ql, this.ma.coords.Kp, d);
              b == e.model.Dc.nj.Xh && e.model.Dc.v7.Xe(this, a, this.ma.coords.Ql, this.ma.coords.Kp, c);
              b == e.model.Dc.nj.JSON && e.model.Dc.y7.Xe(this, a, this.ma.coords.Ql, this.ma.coords.Kp, c);
              b == e.model.Dc.nj.cB && e.model.Dc.$e.Xe(this, a, this.ma.coords.Ql, this.ma.coords.Kp, d);
              b == e.model.Dc.nj.fF && (a.sA = a.sA && (this.Hb.Fa.fa.Ba == e.u.i.qa.Cc || this.Hb.Fa.fa.Ba == e.u.i.qa.Md) && e.model.C.F.Rn, e.model.Dc.A7.Xe(this, a, this.ma.coords.Ql, this.ma.coords.Kp));
            }
            print() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              e.model.at.xF.R().Xe(this, b);
            }
            Xf(b, a) {
              b = this.sT(b, a);
              a = b.Sa();
              this.ZV(a, b.mc, b.lb);
              return a;
            }
            sT(b, a) {
              let c = null;
              this.ma && (c = this.ma.Xf(b, a, !0));
              if (null == c) {
                c = new h.W.le();
                c.lb = b;
                c.mc = a;
                const d = this.getData(b, a, !0);
                c.value = d ? d.value : NaN;
                isNaN(c.value) || (c.label = u.cc.format(c.value));
              }
              -1 == c.lb && (c.lb = b);
              -1 == c.mc && (c.mc = a);
              return c;
            }
            CH() {
              if (e.v(this.ma)) return null;
              var b = this.ma.Dr.map(a => a.Sa());
              if (0 == b.length) return null;
              if (1 < b.length) return b;
              b = b[0];
              this.ZV(b, b.columnIndex, b.rowIndex);
              return b;
            }
            jA(b, a) {
              e.v(this.ma) || this.ma.select(b, a, b, a);
            }
            mE() {
              e.v(this.ma) || this.ma.Cs();
            }
            get JM() {
              return this.I.Xi ? this.I.Fn + this.uf : 0;
            }
            get IM() {
              return this.I.Xi ? this.I.Gn + this.zg : 0;
            }
            d4(b) {
              this.S$(b.data.mc, b.data.width);
            }
            e4(b) {
              this.T$(b.data.lb, b.data.height);
            }
            S$(b, a) {
              if (b < this.zg) 0 < a ? e.model.size.ud.Fg[b] = a : delete e.model.size.ud.Fg[b];else {
                var c = this.I.Vj(b - this.zg, !0);
                null != c && (b = this.I.jT(b - this.zg), this.I.Rb.ab && c.push(b), 0 < a ? e.model.size.ud.yf[c.join(",")] = a : delete e.model.size.ud.yf[c.join(",")]);
              }
            }
            hJa() {
              const b = e.model.size.ud.xk;
              e.model.size.ud.xk = {};
              const a = [];
              for (let c in b) !isNaN(b[c]) && b.hasOwnProperty(c) && (a[parseInt(c)] = b[c]);
              for (let c in a) a.hasOwnProperty(c) && (this.ma.N4(parseInt(c), a[c]), this.S$(parseInt(c), a[c]));
            }
            iJa() {
              var b = e.model.size.ud.Fg;
              const a = [];
              for (let c in b) !isNaN(b[c]) && b.hasOwnProperty(c) && (a[c] = b[c]);
              for (let c in a) b = parseInt(c), b < this.zg && a.hasOwnProperty(c) && this.ma.N4(b, a[b]);
            }
            gJa() {
              const b = e.model.size.ud.yf,
                a = [];
              for (let d in b) if (!isNaN(b[d]) && b.hasOwnProperty(d)) {
                var c = this.I.aD("" == d ? [] : d.split(","));
                -1 != c && (c += this.zg, a[c] = b[d]);
              }
              for (let d in a) a.hasOwnProperty(d) && this.ma.N4(parseInt(d), a[d]);
            }
            lJa() {
              const b = e.model.size.ud.Hj;
              e.model.size.ud.Hj = {};
              const a = [];
              for (let c in b) !isNaN(b[c]) && b.hasOwnProperty(c) && (a[parseInt(c)] = b[c]);
              for (let c in a) a.hasOwnProperty(c) && (this.ma.P4(parseInt(c), a[c]), this.T$(parseInt(c), a[c]));
            }
            jJa() {
              e.model.size.ud.HE = this.Ri;
              const b = e.model.size.ud.ug,
                a = [];
              for (let c in b) !isNaN(b[c]) && b.hasOwnProperty(c) && (a[parseInt(c) + this.Ri] = b[c]);
              for (let c in a) parseInt(c) < this.uf && a.hasOwnProperty(c) && this.ma.P4(parseInt(c), a[c]);
            }
            kJa() {
              const b = e.model.size.ud.Ff,
                a = [];
              for (let c in b) if (!isNaN(b[c]) && b.hasOwnProperty(c)) {
                let d = this.I.kD("" == c ? [] : c.split(","));
                -1 != d && (d += this.uf, a[d] = b[c]);
              }
              for (let c in a) a.hasOwnProperty(c) && this.ma.P4(parseInt(c), a[c]);
            }
            T$(b, a) {
              e.model.size.ud.HE = this.Ri;
              if (b < this.Ri) 0 < a ? e.model.size.ud.sh[b] = a : delete e.model.size.ud.sh[b];else if (b < this.uf) 0 < a ? e.model.size.ud.ug[b - this.Ri] = a : delete e.model.size.ud.ug[b - this.Ri];else {
                var c = this.I.Jn(b - this.uf, !0);
                null != c && (b = this.I.ET(b - this.uf), this.I.hc.ab && c.push(b), 0 < a ? e.model.size.ud.Ff[c.join(",")] = a : delete e.model.size.ud.Ff[c.join(",")]);
              }
            }
            UFa() {
              this.ma && (this.ma.Cr(0), this.ma.dt(0), this.ma.Cs());
            }
          }
          h.qna = f;
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {}
          f.bo = "mclick";
          f.NJ = "singledoubleclick";
          f.j7 = "dthclosed";
          f.wv = "filter_click";
          f.GJ = "live_filter_change";
          f.AF = "resize_c";
          f.BF = "resize_r";
          f.Rpa = "request_data_doubleclick";
          f.g7 = "dragndrop_remove";
          f.f7 = "dragndrop_move";
          f.vt = "filter_keyboard_select";
          f.BJ = "grid_keyboard_select";
          h.vc = f;
          class b extends v.ga {
            constructor(l) {
              let m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              super(f.bo);
              this.cell = l;
              this.element = m;
              this.pq = n;
            }
          }
          h.d8 = b;
          class a extends v.ga {
            constructor(l, m) {
              let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              super(f.NJ);
              this.cell = l;
              this.rfa = m;
              this.element = n;
            }
          }
          h.f8 = a;
          class c extends v.ga {
            constructor(l, m) {
              let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              super(f.wv);
              this.hierarchy = l;
              this.cell = m;
              this.element = n;
            }
          }
          h.fP = c;
          class d extends v.ga {
            constructor(l, m) {
              let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              super(f.vt);
              this.lb = l;
              this.mc = m;
              this.L4 = n;
            }
          }
          h.gP = d;
          class g extends v.ga {
            constructor(l, m) {
              super(f.GJ);
              this.Wg = l;
              this.value = m;
            }
          }
          h.Sna = g;
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            static validate(b) {
              return b == f.FA || b == f.sv || b == f.Gh ? b : f.FA;
            }
          }
          f.FA = "compact";
          f.sv = "classic";
          f.Gh = "flat";
          h.se = f;
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h extends x.be.oy {
          constructor() {
            if (null != h.xe) throw Error("Singleton");
            super(k.Nb.Gb.G);
            this.$("fm-alert-view");
            this.Rk("alertdialog");
            this.Ie();
          }
          static R() {
            null == h.xe && (h.xe = new h());
            return h.xe;
          }
          static dispose() {
            h.xe = null;
          }
          Ie() {
            this.aE.$("fm-overlay-alert");
            this.mK = [];
            var f = new x.Na("div", "fm-content");
            this.X(f);
            this.os = new x.Vc();
            this.os.$("fm-popup-title");
            f.X(this.os);
            this.ms = new x.Vc();
            f.X(this.ms);
            this.Yt = new x.Na("div", "fm-ui-btns-row");
            f.X(this.Yt);
            this.FB = new x.Na("div", "fm-alert-icon");
            this.FB.ro();
            this.X(this.FB);
            e.Dk.addEventListener("keydown", b => this.mq(b));
          }
          Qo() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.tb.Dl;
            let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            let d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            let g = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
            this.clear();
            this.wia(b);
            this.yI(f);
            this.gKa(a);
            this.TJa(c, d);
            k.Nb.Gb.X(this);
            this.C2 = g;
            this.open();
            this.Nya();
            this.Gp();
          }
          Nya() {
            let f = this.Yt.G.find(".fm-ui-btn-dark");
            null == f && (f = this.Yt.G.find(".fm-ui-btn"));
            f && f.focus({
              preventScroll: !0
            });
          }
          clear() {
            this.wia("");
            for (this.yI(""); 0 < this.mK.length;) this.mK.pop().Lg();
            this.G.$a("fm-alert", !1);
            this.G.$a("fm-confirmation", !1);
            this.G.$a("fm-error", !1);
            this.G.$a("fm-info", !1);
            this.G.$a("fm-question", !1);
          }
          wia(f) {
            this.os.jW(!1);
            this.os.gb(f);
          }
          yI(f) {
            this.ms.gb(f, !0);
          }
          TJa(f, b) {
            null == f && (f = [e.model.B.j.UW]);
            f.reverse();
            null != b && b.reverse();
            this.$Y = b;
            for (var a = 0; a < f.length; a++) b = new x.Qg(), b.gb(f[a]), b.N(x.Nd.tf, c => this.wua(c)), this.mK.push(b), this.isPrimary(f[a]) && b.$("fm-ui-btn-dark"), this.isPrimary(f[a]) && (u.qj.No || u.qj.JD) ? this.Yt.X(b) : this.isPrimary(f[a]) ? this.Yt.G.prepend(b.G) : this.Yt.X(b);
          }
          isPrimary(f) {
            switch (f) {
              case e.model.B.j.UW:
              case e.model.B.j.v6:
              case e.model.B.j.t6:
              case e.model.B.j.VE:
                return !0;
            }
            return !1;
          }
          wua(f) {
            f = f.target;
            for (var b = -1, a = 0; a < this.mK.length; a++) if (this.mK[a] == f) {
              b = a;
              break;
            }
            if (!(0 > b) && (this.close(), null != this.$Y && null != this.$Y[b])) this.$Y[b]();
          }
          gKa(f) {
            this.FB.G.xx();
            f == e.tb.Dl ? this.FB.G.X(this.Mwa()) : f == e.tb.cn ? this.FB.G.X(this.Nwa()) : f == e.tb.xa ? this.FB.G.X(this.Owa()) : f == e.tb.lP && this.FB.G.X(this.Pwa());
          }
          Nwa() {
            var f = new x.Ga("span", "fm-circle");
            f.X(new x.Ga("span", "fm-ui-icon fm-icon-notif_confirm"));
            return f;
          }
          Pwa() {
            var f = new x.Ga("span", "fm-circle");
            f.X(new x.Ga("span", "fm-ui-icon fm-icon-notif_info"));
            return f;
          }
          Mwa() {
            var f = new x.Ga("span", "fm-triangle-wrap");
            f.X(new x.Ga("span", "fm-triangle"));
            f.X(new x.Ga("span", "fm-ui-icon fm-icon-notif_warning"));
            return f;
          }
          Owa() {
            var f = new x.Ga("span", "fm-hexagon");
            f.X(new x.Ga("span", "fm-ui-icon fm-icon-notif_arrow"));
            return f;
          }
          close() {
            super.close();
            this.clear();
          }
          W3() {
            this.C2 || super.W3();
          }
          mq(f) {
            27 === f.keyCode && (super.close(), this.clear());
          }
        }
        k.CO = h;
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h extends x.be.oy {
          constructor() {
            if (null != h.xe) throw Error("Singleton");
            super(k.Nb.Gb.G);
            this.$("fm-prompt-view");
            this.Ie();
          }
          static R() {
            null == h.xe && (h.xe = new h());
            return h.xe;
          }
          static dispose() {
            h.xe = null;
          }
          Ie() {
            this.aE.$("fm-overlay-alert");
            var f = new x.Na("div", "fm-content");
            this.X(f);
            this.ms = new x.Vc();
            this.ms.$("fm-message-label");
            f.X(this.ms);
            this.JK = new x.Oj();
            this.JK.$("fm-prompt-input");
            f.X(this.JK);
            this.Yt = new x.Na("div", "fm-ui-btns-row");
            f.X(this.Yt);
            f = new x.Qg("fm-ui-btn-dark");
            f.gb(e.model.B.j.UW);
            f.N(x.Nd.tf, () => this.XD());
            this.Yt.X(f);
            f = new x.Qg();
            f.gb(e.model.B.j.El);
            f.N(x.Nd.tf, () => this.Ts());
            this.Yt.X(f, u.qj.No || u.qj.JD);
          }
          Qo() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            this.C = b;
            this.ms.gb(f);
            this.JK.Jj(b && b.defaultValue ? b.defaultValue : "");
            k.Nb.Gb.X(this);
            this.open();
            this.Gp();
            this.JK.G.element.focus();
          }
          XD() {
            this.C && this.C.Iga && this.C.Iga(this.JK.Zi());
            this.close();
          }
          Ts() {
            this.C && this.C.$U && this.C.$U();
            this.close();
          }
        }
        k.Npa = h;
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.value = NaN;
                this.label = "";
                this.level = NaN;
                this.$o = this.Zo = this.On = this.Hg = this.nh = this.draggable = this.collapsed = this.Vf = this.cb = this.UT = this.ST = this.xKa = this.UCa = this.hi = this.dU = this.ID = this.Ks = this.ex = this.am = this.UM = this.Ah = this.gi = this.isFrozen = this.ml = this.Pu = this.numeric = !1;
                this.mc = this.lb = this.y5 = -1;
                this.sI = null;
                this.ll = this.HCa = this.kb = !1;
                this.Xc = [];
                this.Ez = this.Fz = !1;
                this.ZB = f.Eq.q6;
              }
              get IS() {
                return this.UT ? this.label : e.P.Go(this.label, !0, !0);
              }
              get Hk() {
                return this.am || this.ex;
              }
              get Dz() {
                return this.Ks || this.ID;
              }
              tAa() {
                return this.Hg || this.nh ? this.hierarchy.wa.ea(this.Zb.level.yb + 1).caption : "";
              }
              J() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                if (null != b.zw) {
                  var c = new Qa();
                  c.clear();
                  c.tag = "div";
                  c.text += this.IS;
                  b.zw(c.node, this.Sa());
                  var d = c.text;
                  d = e.model.Tb.valid(d) ? d : e.model.Tb.validate(d);
                  this.Pu = d != this.label ? !0 : this.Pu;
                  c.clear();
                  c = document.createElement("div");
                  c.innerHTML = d;
                  d = c.textContent && "number" != typeof d ? c.textContent.trim() : d;
                  a && !this.UT && (d = e.P.Go(d, !0, !0));
                  return d;
                }
                return a ? this.IS : this.label;
              }
              Yy(a) {
                this.Pu = !0;
                null == this.style && (this.style = new f.U6());
                this.style.Qsa(a);
              }
              Xba(a) {
                this.Pu = !0;
                null == this.style && (this.style = new f.U6());
                this.style.fw(a);
                this.style.Vsa(a);
              }
              Sa() {
                if (this.oga) return this.oga;
                var a = e.model.Va.R().ja.pa,
                  c = [];
                e.model.C.F.tc || e.v(a) || (c = a.P_(this.Ah && this.gg ? this.gg : this.Gg));
                var d = [];
                e.model.C.F.tc || e.v(a) || (d = a.Q_(this.gi && this.gg ? this.gg : this.th));
                a = {
                  columnIndex: this.mc,
                  columns: c,
                  label: this.label,
                  escapedLabel: this.IS,
                  measure: this.measure ? this.measure.ij() : null,
                  hierarchy: this.hierarchy ? this.hierarchy.ij() : null,
                  member: this.Zb ? this.Zb.Sa() : null,
                  rowIndex: this.lb,
                  rows: d,
                  type: this.Ah || this.gi || this.ml ? "header" : "value",
                  value: this.value,
                  expanded: this.Vf,
                  collapsed: this.collapsed,
                  drilledUp: this.nh,
                  drilledDown: this.Hg,
                  recordId: this.sI,
                  isTotal: this.Hk,
                  isTotalRow: this.am,
                  isTotalColumn: this.ex,
                  isClassicTotalRow: this.dU,
                  isGrandTotal: this.Dz,
                  isGrandTotalRow: this.Ks,
                  isGrandTotalColumn: this.ID,
                  isDrillThrough: this.ll
                };
                isNaN(this.level) || (a.level = this.level);
                0 < this.Xc.length && (a.conditions = this.Xc);
                return this.oga = a;
              }
            }
            b.zw = null;
            f.le = b;
          })(h.W || (h.W = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.zW = [];
                this.DC = [];
                this.U = {};
              }
              fw(a) {
                -1 == this.zW.indexOf(a) && this.zW.push(a);
              }
              Vsa(a) {
                -1 == this.DC.indexOf(a) && this.DC.push(a);
              }
              Qsa(a) {
                for (var c in a) this.U[c] = a[c];
              }
              nT() {
                return this.DC.join(" ");
              }
              HT() {
                var a = "",
                  c;
                for (c in this.U) a += c + ":" + this.U[c] + ";";
                return a;
              }
            }
            f.U6 = b;
          })(h.W || (h.W = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {}
              static BAa(c) {
                return 500 < c ? b.oka : b.gpa;
              }
            }
            b.gpa = "";
            b.oka = "Bold";
            f.mna = b;
            class a {
              merge(c) {
                this.color = this.color || c.color;
                this.backgroundColor = this.backgroundColor || c.backgroundColor;
                this.backgroundImage = this.backgroundImage || c.backgroundImage;
                this.borderColor = this.borderColor || c.borderColor;
                this.fontSize = this.fontSize || c.fontSize;
                this.fontWeight = this.fontWeight || c.fontWeight;
                this.textAlign = this.textAlign || c.textAlign;
                this.fontFamily = this.fontFamily || c.fontFamily;
                this.width = this.width || c.width;
                this.maxWidth = this.maxWidth || c.maxWidth;
                this.minWidth = this.minWidth || c.minWidth;
                this.height = this.height || c.height;
                this.maxHeight = this.maxHeight || c.maxHeight;
                this.minHeight = this.minHeight || c.minHeight;
              }
              clone() {
                var c = new a();
                c.color = this.color;
                c.backgroundColor = this.backgroundColor;
                c.backgroundImage = this.backgroundImage;
                c.borderColor = this.borderColor;
                c.fontSize = this.fontSize;
                c.fontWeight = this.fontWeight;
                c.textAlign = this.textAlign;
                c.fontFamily = this.fontFamily;
                c.width = this.width;
                c.maxWidth = this.maxWidth;
                c.minWidth = this.minWidth;
                c.height = this.height;
                c.maxHeight = this.maxHeight;
                c.minHeight = this.minHeight;
                return c;
              }
              static jza(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var g = new a();
                if (null == d || null != d && d.U("color") != c.U("color")) g.color = c.U("color");
                if (null == d || null != d && d.U("background-color") != c.U("background-color")) g.backgroundColor = c.U("background-color");
                if (null == d || null != d && d.U("background-image") != c.U("background-image")) g.backgroundImage = c.U("background-image");
                if (null == d || null != d && d.U("border-color") != c.U("border-color")) g.borderColor = c.U("border-color");
                if (null == d || null != d && d.U("font-size") != c.U("font-size")) g.fontSize = parseInt(c.U("font-size"));
                if (null == d || null != d && d.U("font-weight") != c.U("font-weight")) g.fontWeight = c.U("font-weight");
                if (null == d || null != d && d.U("fill") != c.U("fill")) g.fill = c.U("fill");
                if (null == d || null != d && d.U("text-align") != c.U("text-align")) g.textAlign = c.U("text-align");
                if (null == d || null != d && d.U("font-family") != c.U("font-family")) g.fontFamily = c.U("font-family");
                if (null == d || null != d && d.U("width") != c.U("width")) g.width = parseInt(c.U("width"));
                if (null == d || null != d && d.U("max-width") != c.U("max-width")) g.maxWidth = parseInt(c.U("max-width"));
                if (null == d || null != d && d.U("min-width") != c.U("min-width")) g.minWidth = parseInt(c.U("min-width"));
                if (null == d || null != d && d.U("height") != c.U("height")) g.height = parseInt(c.U("height"));
                if (null == d || null != d && d.U("max-height") != c.U("max-height")) g.maxHeight = parseInt(c.U("max-height"));
                if (null == d || null != d && d.U("min-height") != c.U("min-height")) g.minHeight = parseInt(c.U("min-height"));
                return g;
              }
              static Yl(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                var l = new x.Ga("div");
                l.$(c).Za();
                c = new x.Ga("div");
                null == d ? k.Nb.Gb.G.append(l).append(c) : d.append(l).append(c);
                d = a.jza(l, g ? c : null);
                l.remove();
                c.remove();
                return d;
              }
              static bT(c) {
                var d = new a(),
                  g;
                for (c = c.replace(/ /g, ";"); -1 < (g = c.indexOf(";"));) this.qxa(c.substring(0, g), d), c = c.substring(g + 1);
                return d;
              }
              static YT(c) {
                c = c.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (d, g, l, m) {
                  return g + g + l + l + m + m;
                });
                c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(c);
                return null == c ? "" : "rgb(" + parseInt(c[1], 16) + "," + parseInt(c[2], 16) + "," + parseInt(c[3], 16) + ")";
              }
              static qxa(c, d) {
                -1 < c.indexOf("background-color") ? d.backgroundColor = this.YT(c.substring(17, c.length)) : -1 < c.indexOf("background-image") ? d.backgroundImage = c.substring(17, c.length) : -1 < c.indexOf("border-color") ? d.borderColor = this.YT(c.substring(13, c.length)) : -1 < c.indexOf("color") ? d.color = this.YT(c.substring(6, c.length)) : -1 < c.indexOf("font-size") ? d.fontSize = parseInt(c.substring(10, c.length)) : -1 < c.indexOf("fill") ? d.fill = this.YT(c.substring(5, c.length)) : -1 < c.indexOf("text-align") ? d.textAlign = c.substring(11, c.length) : -1 < c.indexOf("max-width") ? d.maxWidth = parseInt(c.substring(10, c.length)) : -1 < c.indexOf("max-height") ? d.maxHeight = parseInt(c.substring(11, c.length)) : -1 < c.indexOf("width") && (d.width = parseInt(c.substring(6, c.length)));
              }
              static nz(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var l = "";
                null == d && (d = a.zla);
                for (var m = 0; m < d.length; m++) if (null == g || null != g && c.U(d[m]) != g.U(d[m])) l += d[m] + ":" + c.U(d[m]) + ";";
                return l;
              }
              static kl(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var l = new x.Ga("div");
                l.$(c).Za();
                if (void 0 === m) {
                  var m = new x.Ga("div");
                  m.Za();
                }
                null == d ? k.Nb.Gb.G.append(l).append(m) : d.append(l).append(m);
                c = a.nz(l, g, m);
                l.remove();
                null != m && m.remove();
                return c;
              }
              static t4(c) {
                var d = [],
                  g = c.split("rgb");
                2 < g.length && (c = g[2]);
                c = c.replace(/[^\d,]/g, "");
                c = c.split(",");
                for (g = 0; g < c.length; g++) d[g] = parseInt(c[g]);
                void 0 == d[3] && (d[3] = 1);
                return d;
              }
            }
            a.zla = "background-color background-image color font-family font-size font-weight text-align padding-top padding-left padding-right padding-bottom border border-top-width border-top-color border-top-style border-bottom-width border-bottom-color border-bottom-style border-left-width border-left-color border-left-style border-right-width border-right-color border-right-style".split(" ");
            f.cd = a;
          })(h.W || (h.W = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    var Ra = q || (q = {}),
      Sa = Ra.K || (Ra.K = {}),
      Ta = Sa.Y || (Sa.Y = {}),
      Ua = Ta.W || (Ta.W = {});
    class T {}
    T.sY = "fm-pivot-title";
    T.Me = "fm-cell";
    T.bX = "fm-empty";
    T.YP = "fm-sheet-header";
    T.gk = "fm-header";
    T.UA = "fm-header-c";
    T.yv = "fm-header-r";
    T.qoa = "fm-measure-header";
    T.Dq = "fm-filter-header";
    T.FJ = "fm-live-filtering-header";
    T.wJ = "fm-filter-icon";
    T.zX = "fm-filtered";
    T.qJ = "fm-filtered-icon";
    T.Jv = "fm-total";
    T.Sqa = "fm-total-r";
    T.Rqa = "fm-total-c";
    T.AJ = "fm-grand-total";
    T.ona = "fm-grand-total-r";
    T.nna = "fm-grand-total-c";
    T.JX = "fm-hierarchy-link";
    T.sP = "fm-link";
    T.hra = "fm-v-sort";
    T.kra = "fm-v-sort-icon";
    T.ira = "fm-v-sort-asc";
    T.jra = "fm-v-sort-desc";
    T.rna = "fm-h-sort";
    T.una = "fm-h-sort-icon";
    T.sna = "fm-h-sort-asc";
    T.tna = "fm-h-sort-desc";
    T.iB = "fm-sort-icon";
    T.w9 = "fm-with-order";
    T.tX = "fm-expanded";
    T.t7 = "fm-expanded-icon";
    T.cX = "fm-collapsed";
    T.I6 = "fm-collapsed-icon";
    T.Of = "fm-level-";
    T.Kla = "fm-drilled-up";
    T.Jla = "fm-drilled-down";
    T.KX = "fm-icon";
    T.j8 = "fm-kpi";
    T.zna = "fm-kpi-status-bad-icon";
    T.Dna = "fm-kpi-status-risk-icon";
    T.Bna = "fm-kpi-status-ok-icon";
    T.Cna = "fm-kpi-status-rising-icon";
    T.Ana = "fm-kpi-status-good-icon";
    T.Ena = "fm-kpi-trend-bad-icon";
    T.Ina = "fm-kpi-trend-risk-icon";
    T.Gna = "fm-kpi-trend-ok-icon";
    T.Hna = "fm-kpi-trend-rising-icon";
    T.Fna = "fm-kpi-trend-good-icon";
    Ua.ya = T;
    var Va = q || (q = {}),
      Wa = Va.K || (Va.K = {}),
      Xa = Wa.Y || (Wa.Y = {}),
      Ya = Xa.W || (Xa.W = {});
    class Za {}
    Za.Kna = "left icon";
    Za.YJ = "right icon";
    Za.Zk = "label";
    Za.h7 = "drill";
    Za.sP = "link";
    Za.q6 = "backgroud";
    Ya.Eq = Za;
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends k.Y.MO {
            constructor(b) {
              super(b.G);
              this.jd = b;
            }
            S3(b, a) {
              this.show(b.target, {
                left: a.clientX,
                top: a.clientY
              }, b);
            }
            f4(b) {
              this.show(b.target, {
                left: b.clientX,
                top: b.clientY
              }, b);
            }
            OAa(b) {
              b = this.jd.oT(b);
              var a = this.Hb.ja.pa.gd();
              if (b && !isNaN(b.RD)) return a[b.RD];
              if (b && b.measure) for (var c = 0; c < a.length; c++) if (a[c].A == b.measure.A && a[c].aa == b.measure.aa && a[c].index == b.measure.index) return a[c];
              return null;
            }
            show(b, a, c) {
              if (!e.model.C.F.readOnly) {
                var d = [];
                this.jd.Sea(c.target) && d.push({
                  id: "drillthrough",
                  label: e.model.B.j.N6,
                  handler: () => {
                    this.jd.bd(c.target);
                  }
                });
                this.jd.JCa(c.target) && d.push({
                  id: "open_filter",
                  label: e.model.B.j.P6,
                  handler: () => {
                    this.jd.kI(c.target);
                  }
                });
                var g = this.OAa(b);
                g && !g.Oa && !g.$g && e.model.C.F.zl && (g = this.oz(g), 0 < g.length && d.push({
                  id: "aggregation",
                  label: e.model.B.j.L6,
                  submenu: g
                }));
                d = this.uS(d, this.jd.oT(b, !0), "charts");
                0 < d.length && c.preventDefault();
                this.BS(d, a);
              }
            }
            qga(b, a) {
              var c = this.Hb.ja.pa.clone();
              b = c.gd()[b.index];
              b.aa = a;
              e.model.C.F.so.aa = b.aa;
              this.Hb.fe(c);
            }
          }
          h.tla = f;
        })(k.Cd || (k.Cd = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.Qv = this.Rv = -1;
                this.HG = this.O0 = this.DW = this.$N = this.scrollLeft = this.scrollTop = this.pg = this.qh = this.ge = this.Qd = this.Kp = this.Ql = this.CZ = this.rR = 0;
                this.TB = 15E5;
                this.VB = this.UB = 1;
                this.sj = [];
                this.It = [];
                this.Tt = [];
                this.ds = [];
                this.Ut = [];
                this.LF = [];
                this.hG = [];
                this.TB = this.tBa();
                this.rR = b.u9;
                this.CZ = b.t9;
                this.vE();
                this.tia();
              }
              get ve() {
                return this.DW + this.O0;
              }
              tia() {
                if (void 0 === this.AZ || void 0 === this.zZ) {
                  var c = this.uBa();
                  c && (this.AZ = c.width, this.zZ = c.height);
                }
              }
              uBa() {
                return u.Jd().Rm ? this.gba() : u.Jd().s2 ? {
                  width: 15,
                  height: 15
                } : u.qj.No || u.Jd().cU || u.Jd().mfa || u.Jd().PH ? this.gba() : {
                  width: 17,
                  height: 17
                };
              }
              gba() {
                if (null == k.Nb.Gb.G.element.offsetParent) return null;
                var c = document.createElement("div");
                c.style.width = "100%";
                c.style.height = "100px";
                var d = document.createElement("div");
                u.qj.No && d.classList.add("fm-scrollbars");
                d.style.position = "absolute";
                d.style.top = "0px";
                d.style.left = "0px";
                d.style.visibility = "hidden";
                d.style.width = "50px";
                d.style.height = "50px";
                d.style.overflow = "hidden";
                d.appendChild(c);
                k.Nb.Gb.G.element.appendChild(d);
                let g = c.offsetWidth;
                d.style.overflow = "scroll";
                let l = c.offsetWidth;
                g == l && (l = d.clientWidth);
                c.style.width = "100px";
                c.style.height = "100%";
                d.style.overflow = "hidden";
                var m = c.offsetHeight;
                d.style.overflow = "scroll";
                c = c.offsetHeight;
                m == c && (c = d.clientHeight);
                k.Nb.Gb.G.element.removeChild(d);
                d = g - l;
                m -= c;
                u.Jd().PH && (m = d);
                return {
                  width: d,
                  height: m
                };
              }
              tBa() {
                return u.yS().cU || u.yS().PH ? 1E7 : 15E5;
              }
              FG(c) {
                this.It.length - 1 >= c && (this.It.length = c);
                this.ds.length - 1 >= c && (this.ds.length = c);
                this.LF.length - 1 >= c && (this.LF.length = c);
                for (let d in this.sj) this.sj.hasOwnProperty(d) && !e.v(this.sj[d]) && this.sj[d].length - 1 >= c && (this.sj[d].length = c);
                this.Rv = -1;
              }
              pC(c) {
                this.Tt.length - 1 >= c && (this.Tt.length = c);
                this.Ut.length - 1 >= c && (this.Ut.length = c);
                this.hG.length - 1 >= c && (this.hG.length = c);
                this.sj.length - 1 >= c && (this.sj.length = c);
                this.Qv = -1;
              }
              reset() {
                this.It.length = 0;
                this.Tt.length = 0;
                this.ds.length = 0;
                this.Ut.length = 0;
                this.LF.length = 0;
                this.hG.length = 0;
                this.Qv = this.Rv = -1;
                this.O0 = this.DW = this.scrollLeft = this.scrollTop = this.pg = this.qh = this.ge = this.Qd = this.Kp = this.Ql = 0;
                this.rR = b.u9;
                this.CZ = b.t9;
                this.VB = this.UB = 1;
                this.$N = this.sj.length = 0;
                this.vE();
              }
              vE() {
                var c = k.Y.W.cd.Yl(u.Jd().Rm ? "fm-grid-column-mobile" : "fm-grid-column");
                isNaN(c.minWidth) || (b.aF = c.minWidth);
                isNaN(c.width) || (b.st = Math.max(b.aF, c.width));
                isNaN(c.maxWidth) || (b.Cq = 0 >= c.maxWidth ? 0 : Math.max(b.aF, c.maxWidth));
                var d = k.Y.W.cd.Yl(u.Jd().Rm ? "fm-grid-row-mobile" : "fm-grid-row");
                isNaN(d.minHeight) || (b.$E = d.minHeight);
                isNaN(d.height) || (b.rv = Math.max(b.$E, d.height));
                isNaN(d.maxHeight) || (b.Pr = 0 >= c.maxHeight ? 0 : Math.max(b.$E, d.maxHeight));
              }
              setScale() {
                var c = this.fu(this.ge, this.ge + this.Kp);
                this.VB = c > this.TB ? this.TB / c : 1;
                c = this.gu(this.Qd, this.Qd + this.Ql);
                this.UB = c > this.TB ? this.TB / c : 1;
              }
              resize(c, d) {
                this.LB = c;
                this.KB = d;
              }
              get pE() {
                return this.uD ? this.AZ : 0;
              }
              get oE() {
                return this.sD ? this.zZ : 0;
              }
              get cq() {
                return this.LB;
              }
              get Ns() {
                return this.KB;
              }
              get Iy() {
                return this.KB - this.oE - this.ve;
              }
              get du() {
                return this.LB - this.pE;
              }
              get Ed() {
                return this.LB - this.tq;
              }
              get Dd() {
                return this.KB - this.cr - this.ve;
              }
              get dj() {
                return this.Qd + this.Ql;
              }
              get Jk() {
                return this.ge + this.Kp;
              }
              Xd(c) {
                var d = isNaN(this.Tt[c]) ? b.rv : this.Tt[c];
                return 0 < b.Pr && !this.MD(c) ? Math.min(b.Pr, d) : d;
              }
              Dx(c, d) {
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                let l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                0 != d && (d = Math.max(d, b.$E));
                if (g) {
                  if (isNaN(this.Ut[c]) || d > this.Ut[c]) this.Ut[c] = d;
                } else this.Tt[c] = d, this.Qv = -1;
                l && (this.hG[c] = !0);
              }
              fJa(c) {
                if (this.MD(c)) {
                  delete this.Tt[c];
                  delete this.Ut[c];
                  delete this.hG[c];
                  this.Qv = -1;
                  for (let d in this.sj) this.sj.hasOwnProperty(d) && delete this.sj[d];
                }
              }
              yh(c) {
                if (-1 == c) return this.Js();
                if (c >= this.dj) return Math.max(100, b.st);
                var d = isNaN(this.It[c]) ? b.st : this.It[c];
                return 0 < b.Cq && !this.GD(c) ? Math.min(b.Cq, d) : d;
              }
              $L(c, d, g) {
                return 0 >= g ? Math.max(d, c) : Math.min(g, Math.max(d, c));
              }
              PN(c, d) {
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                let l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                0 != d && (d = this.$L(d, b.aF, b.Cq));
                if (g) {
                  if (isNaN(this.ds[c]) || d > this.ds[c]) this.ds[c] = d;
                } else -1 == c ? this.rR = d : this.It[c] = d, this.Rv = -1;
                l && (this.LF[c] = !0);
              }
              dJa(c) {
                if (this.GD(c)) {
                  delete this.It[c];
                  delete this.ds[c];
                  delete this.LF[c];
                  this.Rv = -1;
                  for (let d in this.sj) this.sj.hasOwnProperty(d) && (e.v(this.sj[d]) || delete this.sj[d][c]);
                }
              }
              GD(c) {
                return !0 === this.LF[c];
              }
              MD(c) {
                return !0 === this.hG[c];
              }
              HR() {
                const c = new a();
                for (var d in this.Ut) {
                  var g = parseInt(d);
                  if (!isNaN(g) && !this.MD(g)) {
                    var l = this.Ut[g];
                    !isNaN(l) && l > this.Xd(g) && (this.Dx(g, l), c.rows.push(g));
                  }
                }
                this.Ut.length = 0;
                for (var m in this.ds) d = parseInt(m), isNaN(d) || this.GD(d) || (g = this.ds[d], !isNaN(g) && g > this.yh(d) && (this.PN(d, g), c.Ka.push(d)));
                this.ds.length = 0;
                return c;
              }
              zM(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var g = c / this.su * (this.Ns / this.VB - this.Ns) * this.VB;
                if (1 != this.VB && c + g >= this.su - this.Ns) {
                  d = this.Jk;
                  for (g = this.su; g > c;) g -= this.Xd(d), d--;
                  return d + 1;
                }
                d = d ? 0 : this.ge;
                for (var l = 0; l < c + g;) l += this.Xd(d) * this.VB, d++;
                return d;
              }
              gM(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var g = c / this.tu * (this.cq / this.UB - this.cq) * this.UB;
                if (1 != this.UB && c + g >= this.tu - this.cq) {
                  d = this.dj;
                  for (g = this.tu; g > c;) g -= this.yh(d), d--;
                  return d + 1;
                }
                d = d ? 0 : this.Qd;
                for (var l = 0; l < c + g;) l += this.yh(d) * this.UB, d++;
                return d;
              }
              lea(c) {
                for (var d = 0, g = 0, l = this.Dd; g < l;) g += this.Xd(c + d), d++;
                return d;
              }
              kea(c) {
                for (var d = 0, g = 0, l = this.Ed; g < l;) g += this.yh(c + d), d++;
                return d;
              }
              get tu() {
                return 0 <= this.Rv ? this.Rv : this.Rv = 1 > this.UB ? this.TB : this.gu(this.Qd, this.Qd + this.Ql);
              }
              gu(c, d) {
                if (c >= d) return 0;
                var g = 0,
                  l = 0,
                  m;
                for (m in this.It) {
                  var n = parseInt(m);
                  !isNaN(n) && !isNaN(this.It[n]) && n >= c && n < d && (l++, g += this.yh(n));
                }
                g += (Math.min(d, this.dj) - c - l) * (0 < b.Cq ? Math.min(b.Cq, b.st) : b.st);
                d >= this.dj && (g += (d - this.dj) * this.yh(d));
                return g;
              }
              get su() {
                return 0 <= this.Qv ? this.Qv : this.Qv = 1 > this.VB ? this.TB : this.fu(this.ge, this.ge + this.Kp);
              }
              fu(c, d) {
                if (c >= d) return 0;
                var g = 0,
                  l = 0,
                  m;
                for (m in this.Tt) {
                  var n = parseInt(m);
                  !isNaN(n) && !isNaN(this.Tt[n]) && n >= c && n < d && (l++, g += this.Xd(n));
                }
                return g += (d - c - l) * (0 < b.Pr ? Math.min(b.Pr, b.rv) : b.rv);
              }
              cva() {
                this.sj.length = 0;
              }
              Mea(c, d) {
                return e.v(this.sj[c]) ? !1 : !0 === this.sj[c][d];
              }
              UJa(c, d) {
                e.v(this.sj[c]) && (this.sj[c] = []);
                this.sj[c][d] = !0;
              }
              SR() {
                this.Rv = this.Qv = -1;
              }
              get sEa() {
                for (var c = 0, d = this.Qd + this.Ql, g = this.Qd; g < d; g++) if (c += this.yh(g), c > b.P8) return b.P8;
                return c;
              }
              get tq() {
                for (var c = this.Js(), d = 0; d < this.Qd; d++) c += this.yh(d);
                return c;
              }
              get cr() {
                for (var c = this.Ju(), d = 0; d < this.ge; d++) c += this.Xd(d);
                return c;
              }
              Js() {
                return e.model.C.F.Al ? this.rR : 0;
              }
              Ju() {
                return e.model.C.F.Al ? this.CZ : 0;
              }
              Yza() {
                for (var c = [], d = this.Qd; d < this.Ql && (this.Nea(d) || (c.push(d), !(50 <= c.length))); d++);
                return c;
              }
              Zza(c) {
                var d = [];
                c.bottom = Math.min(c.bottom, this.Jk);
                for (var g = c.left; g <= c.right; g++) for (var l = c.top; l <= c.bottom; l++) if (!this.Mea(l, g)) {
                  d.push(g);
                  break;
                }
                return d;
              }
              Nea(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                return !isNaN(this.It[c]) || (d ? !isNaN(this.ds[c]) : !1);
              }
              get sD() {
                return this.tu + (this.su > this.Dd ? this.AZ : 0) > this.Ed;
              }
              get uD() {
                return this.su + (this.tu > this.Ed ? this.zZ : 0) > this.Dd;
              }
              lD(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var g = e.model.C.F.Al && d ? this.Ju() : 0;
                return g += this.fu(d ? 0 : this.ge, c);
              }
              ZC(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var g = e.model.C.F.Al && d ? this.Js() : 0;
                return g += this.gu(d ? 0 : this.Qd, c);
              }
              get mw() {
                return u.Jd().cj ? !1 : 500 > Math.max(this.dj, this.du / b.st) * Math.max(this.Jk, this.Iy / b.rv);
              }
              get Eua() {
                return u.Jd().cj ? !1 : (this.uD || this.sD) && 1E5 > this.dj * this.Jk;
              }
              Io() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                return new f.ZE(this.kH(c), this.lH(c), this.YC(c), this.pz(c));
              }
              lH() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                return this.mw ? this.ge : c ? Math.max(this.ge, this.qh - b.n9) : Math.max(this.ge, this.qh);
              }
              kH() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                return this.mw ? this.Qd : c ? Math.max(this.Qd, this.pg - b.J6) : Math.max(this.Qd, this.pg);
              }
              pz() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var d = this.lea(this.qh);
                return this.mw ? this.uD ? this.Jk : this.qh + d : c ? Math.min(this.qh + d + (this.uD ? b.n9 : 0), this.uD ? this.Jk : Number.MAX_VALUE) : this.qh + d;
              }
              YC() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var d = this.kea(this.pg);
                return this.mw ? this.sD ? this.dj : this.pg + d : c ? Math.min(this.pg + d + (this.sD ? b.J6 : 0), this.sD ? this.dj : Number.MAX_VALUE) : this.pg + d;
              }
              KD() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                isNaN(c) && (c = this.YC());
                return 0 < this.scrollLeft && c >= this.dj;
              }
              LD() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                isNaN(c) && (c = this.pz());
                return 0 < this.scrollTop && c >= this.Jk;
              }
              fM() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                isNaN(c) && (c = this.pg);
                return this.KD() ? this.tu - this.scrollLeft - this.gu(c, this.dj) : 0;
              }
              yM() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                isNaN(c) && (c = this.qh);
                return this.LD() ? this.su - this.scrollTop - this.fu(c, this.Jk) : 0;
              }
              DT(c, d) {
                if (c < this.ve) return NaN;
                if (e.model.C.F.Al && c < this.ve + this.Ju()) return -1;
                var g = 0,
                  l = this.ve + this.Ju();
                c > this.cr && (g = this.qh, l = this.ve + this.cr, d && g > this.ge ? (d = this.scrollTop - this.lD(g - 1), 0 < d && (l -= d, g--)) : d || (c -= this.yM()));
                for (; l < c;) l += this.Xd(g), g++;
                return g - 1;
              }
              hT(c, d) {
                if (e.model.C.F.Al && c < this.Js()) return -1;
                var g = 0,
                  l = this.Js();
                c > this.tq && (g = this.pg, l = this.tq, d && g > this.Qd ? (d = this.scrollLeft - this.ZC(g - 1) + this.$N, 0 < d && (l -= d, g--)) : d || (c -= this.fM()));
                for (; l < c;) l += this.yh(g), g++;
                return g - 1;
              }
              Ko(c, d) {
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                var l = 0,
                  m = (g ? this.ve : 0) + this.Ju();
                c > this.ge && (l = this.qh, m = (g ? this.ve : 0) + this.cr, l <= c && (m += d ? this.lD(this.qh) - this.scrollTop : this.yM()));
                return m += this.fu(l, c);
              }
              $l(c, d) {
                var g = 0,
                  l = this.Js();
                c > this.Qd && (g = this.pg, l = this.tq, g <= c && (l += d ? this.ZC(this.pg) - this.scrollLeft - this.$N : this.fM()));
                return l += this.gu(g, c);
              }
              iDa(c) {
                return isNaN(this.Tt[c]);
              }
              get $ya() {
                return this.scrollLeft + this.Ed - this.tu - this.pE;
              }
              get Zya() {
                return this.scrollTop + this.Dd - this.su - this.oE;
              }
              Lo(c, d) {
                return !isNaN(c) && 0 == this.Xd(c) || !isNaN(d) && 0 == this.yh(d) ? !0 : !1;
              }
            }
            b.n9 = 5;
            b.J6 = 5;
            b.st = 100;
            b.aF = 50;
            b.Cq = 480;
            b.rv = 30;
            b.$E = 30;
            b.Pr = 100;
            b.t9 = 25;
            b.u9 = 25;
            b.P8 = 200;
            f.Hh = b;
            class a {
              constructor() {
                this.rows = [];
                this.Ka = [];
              }
            }
            f.JOa = a;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Ga {
              constructor(a, c) {
                super("div");
                this.cZ = !1;
                this.cell = new Qa();
                this.ca = a;
                this.qn = c;
                this.element.addEventListener("click", d => this.pV(d));
              }
              Ly() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                for (var c = !1, d = this.element.children, g = 0; g < d.length; g++) {
                  var l = d.item(g);
                  c = this.Eja(l, !0) || c;
                  l = l.children;
                  for (var m = 0; m < l.length; m++) {
                    const n = l.item(m);
                    c = this.nO(n, a) || c;
                  }
                }
                this.cZ = c;
              }
              get HD() {
                return this.cZ;
              }
              Eja(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                if (null != this.ca) {
                  var d = !1,
                    g = parseInt(a.getAttribute("data-r"));
                  if (isNaN(g) || this.ca.MD(g)) return !1;
                  var l = a.clientHeight;
                  a = a.offsetHeight;
                  var m = a - l;
                  a - this.ca.Xd(g) > m ? (this.ca.Dx(g, Math.ceil(a), c), d = !0) : l <= f.Hh.rv && this.ca.Dx(g, f.Hh.rv, c);
                  return d;
                }
              }
              nO(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                if (null != this.ca) {
                  var g = !1,
                    l = parseInt(a.getAttribute("data-c")),
                    m = parseInt(a.getAttribute("data-r"));
                  if (isNaN(l) || a.classList.contains(h.W.ya.YP) && 0 <= l || this.ca.GD(l) || this.ca.Mea(m, l) && !d) return !1;
                  a = a.offsetWidth;
                  if (a > this.ca.yh(l)) {
                    if (1 < a - this.ca.yh(l) || 1 == window.devicePixelRatio || 1 != window.devicePixelRatio && this.ca.yh(l) == f.Hh.st) this.ca.PN(l, Math.ceil(a + 3), c), g = !0;
                  } else -1 != l && a <= f.Hh.st && !this.ca.Nea(l, !0) && this.ca.PN(l, f.Hh.st, c);
                  this.ca.UJa(m, l);
                  return g;
                }
              }
              Vy(a, c) {
                var d = this.qn ? this.qn(a, c) : null;
                this.cell.clear();
                this.cell.tag = "div";
                if (this.ca.Lo(a, c)) return this.cell.style.display = "none", this.cell;
                this.cell.$(h.W.ya.Me);
                var g = a >= this.ca.Jk || c >= this.ca.dj;
                !d && g ? this.cell.$(h.W.ya.bX) : (this.cell.attr.role = "gridcell", this.cell.attr["aria-rowindex"] = a + 1, this.cell.attr["aria-colindex"] = c + 1);
                d && !isNaN(d.level) && this.cell.$(h.W.ya.Of + d.level);
                d && d.gi && (this.cell.$(h.W.ya.gk), this.cell.$(h.W.ya.yv), this.cell.$(h.W.ya.Of + d.level), this.cell.attr.role = "rowheader");
                d && d.Ah && (this.cell.$(h.W.ya.gk), this.cell.$(h.W.ya.UA), this.cell.attr.role = "columnheader");
                d && d.UM && this.cell.$(h.W.ya.qoa);
                d && d.Hk && this.cell.$(h.W.ya.Jv);
                d && d.ex && this.cell.$(h.W.ya.Rqa);
                d && d.am && this.cell.$(h.W.ya.Sqa);
                d && d.Dz && this.cell.$(h.W.ya.AJ);
                d && d.ID && this.cell.$(h.W.ya.nna);
                d && d.Ks && this.cell.$(h.W.ya.ona);
                d && d.Vf && (this.cell.$(h.W.ya.tX), this.cell.text += this.Bo(h.W.ya.t7, e.model.B.j.fQ));
                d && d.collapsed && (this.cell.$(h.W.ya.cX), this.cell.text += this.Bo(h.W.ya.I6, e.model.B.j.gQ));
                d && d.Fz && (this.cell.$(h.W.ya.j8), -.75 >= d.value ? this.cell.$(h.W.ya.Ena) : -.25 >= d.value ? this.cell.$(h.W.ya.Ina) : .25 > d.value ? this.cell.$(h.W.ya.Gna) : .75 > d.value ? this.cell.$(h.W.ya.Hna) : 1 >= d.value && this.cell.$(h.W.ya.Fna));
                d && d.Ez && (this.cell.$(h.W.ya.j8), -.75 >= d.value ? this.cell.$(h.W.ya.zna) : -.25 >= d.value ? this.cell.$(h.W.ya.Dna) : .25 > d.value ? this.cell.$(h.W.ya.Bna) : .75 > d.value ? this.cell.$(h.W.ya.Cna) : 1 >= d.value && this.cell.$(h.W.ya.Ana));
                this.cell.text += d ? d.IS : "";
                d && (d.nh || d.Hg) && (this.cell.text += '<span class="' + h.W.ya.JX + '" title="' + (d.nh ? e.model.B.j.Jqa : e.model.B.j.Kqa) + '">' + d.tAa() + "</span>", d.nh && this.cell.$(h.W.ya.Kla), d.Hg && this.cell.$(h.W.ya.Jla));
                if (d && d.Ah) {
                  if (d.On && !d.kb) {
                    var l = "";
                    0 <= d.y5 && (l = "<span>" + (d.y5 + 1) + "</span>");
                    const n = e.v(d.measure) || d.measure.type != e.u.i.Qa.zc;
                    this.cell.text = d.Zo ? this.cell.text + this.Bo([h.W.ya.iB, h.W.ya.ira, e.ia(l) ? "" : h.W.ya.w9], this.xH(e.u.i.Aa.kc, n, e.model.C.F.tc), l) : d.$o ? this.cell.text + this.Bo([h.W.ya.iB, h.W.ya.jra, e.ia(l) ? "" : h.W.ya.w9], this.xH(e.u.i.Aa.Mc, n, e.model.C.F.tc), l) : this.cell.text + this.Bo([h.W.ya.iB, h.W.ya.kra], this.xH(e.u.i.Aa.ed, n, e.model.C.F.tc));
                  }
                  d.kb && this.cell.$(h.W.ya.bX);
                  d.kb || this.cell.$(h.W.ya.hra);
                }
                d && d.gi && (d.On && !d.kb && (this.cell.text = d.Zo ? this.cell.text + this.Bo([h.W.ya.iB, h.W.ya.sna], this.xH(e.u.i.Aa.kc)) : d.$o ? this.cell.text + this.Bo([h.W.ya.iB, h.W.ya.tna], this.xH(e.u.i.Aa.Mc)) : this.cell.text + this.Bo([h.W.ya.iB, h.W.ya.una], this.xH(e.u.i.Aa.ed))), this.cell.$(h.W.ya.rna));
                this.cell.attr["data-c"] = c;
                this.cell.attr["data-r"] = a;
                this.cell.attr["data-n"] = 0 == a % 2 ? "even" : "odd";
                0 != c || e.model.C.F.Al || (this.cell.style.height = this.ca.Xd(a) + "px");
                if (d && d.style) {
                  for (l = 0; l < d.style.zW.length; l++) this.cell.$(d.style.zW[l]);
                  l = d.style.U;
                  for (var m in l) this.cell.style[m] = l[m];
                }
                this.eia(this.cell, a, c, d && d.hi);
                null == h.W.le.zw || g || (null == d && (d = new h.W.le(), d.lb = a, d.mc = c), h.W.le.zw(this.cell.node, d.Sa()));
                return this.cell;
              }
              xH(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                a = e.u.i.Aa.xT(a, c, d);
                return a == e.u.i.Aa.kc ? e.model.B.j.Nqa : a == e.u.i.Aa.Mc ? e.model.B.j.Oqa : a == e.u.i.Aa.ed ? e.model.B.j.Qqa : e.model.B.j.Pqa;
              }
              i2(a, c) {
                return this.qn ? (a = this.qn(a, c), e.v(a) || e.ia(a.label)) : !0;
              }
              eia(a, c, d) {
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                this.ca.GD(d) || this.ca.MD(c) ? (a.style.width = this.ca.yh(d) + "px", a.style.height = this.ca.Xd(c) + "px") : (a.style["min-width"] = this.ca.yh(d) + "px", a.style[g ? "height" : "min-height"] = this.ca.Xd(c) + "px");
                !this.ca.GD(d) && 0 < f.Hh.Cq && (a.style["max-width"] = f.Hh.Cq + "px");
                !this.ca.MD(c) && 0 < f.Hh.Pr && (a.style["max-height"] = f.Hh.Pr + "px");
              }
              Bo(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                Array.isArray(a) && (a = a.join(" "));
                a = '<i aria-hidden="true" class="' + h.W.ya.KX + " " + a + '"';
                c && (a += 'title="' + c + '"');
                return a + (">" + d + "</i>");
              }
              Wwa() {
                this.cell.clear();
                this.cell.tag = "div";
                this.cell.$(h.W.ya.Me);
                this.cell.$(h.W.ya.YP);
                this.cell.style.width = this.ca.Js() + "px";
                this.cell.style.height = this.ca.Ju() + "px";
                this.cell.attr["aria-hidden"] = "true";
                return this.cell;
              }
              Lba(a) {
                this.cell.clear();
                this.cell.tag = "div";
                if (this.ca.Lo(-1, a)) return this.cell.style.display = "none", this.cell;
                this.cell.$(h.W.ya.Me);
                this.cell.$(h.W.ya.YP);
                this.cell.text += a + 1;
                this.cell.style.width = this.ca.yh(a) + "px";
                0 < f.Hh.Cq && !this.ca.GD(a) && (this.cell.style["max-width"] = f.Hh.Cq + "px");
                this.cell.style.height = this.ca.Ju() + "px";
                this.cell.attr["data-r"] = -1;
                this.cell.attr["data-c"] = a;
                this.cell.attr["aria-hidden"] = "true";
                return this.cell;
              }
              rS(a) {
                this.cell.clear();
                this.cell.tag = "div";
                if (this.ca.Lo(a, -1)) return this.cell.style.display = "none", this.cell;
                this.cell.$(h.W.ya.Me);
                this.cell.$(h.W.ya.YP);
                this.cell.text += a + 1;
                this.cell.style["min-width"] = this.ca.Js() + "px";
                this.cell.style.height = this.ca.Xd(a) + "px";
                this.cell.style["line-height"] = this.ca.Xd(a) - 2 + "px";
                0 < f.Hh.Pr && !this.ca.MD(a) && (this.cell.style["max-height"] = f.Hh.Pr + "px");
                this.cell.attr["data-r"] = a;
                this.cell.attr["data-c"] = -1;
                this.cell.attr["aria-hidden"] = "true";
                return this.cell;
              }
              c1(a, c) {
                a = this.ca.gM(a) - 1;
                c = this.ca.zM(c) - 1;
                var d = null;
                null != this.qn && (d = this.qn(c, a));
                null == d && (d = new h.W.le(), d.lb = c, d.mc = a);
                return d;
              }
              Hu(a) {
                for (; !a.Sc(h.W.ya.Me);) if (a = a.parent, null == a) return null;
                var c = parseInt(a.attr("data-c"));
                a = parseInt(a.attr("data-r"));
                var d = null != this.qn ? this.qn(a, c) : k.Nb.Gb.sT(a, c);
                null == d && (d = new h.W.le(), d.lb = a, d.mc = c);
                return d;
              }
              pV(a) {
                var c = x.Ga.Xb(a.target),
                  d = this.Hu(c) || this.c1(a.offsetX, a.offsetY);
                switch (a.type) {
                  case "click":
                    var g = new h.d8(d, c, a);
                }
                g && this.Ea(g);
              }
              dispose() {
                super.dispose();
                this.ca = this.qn = null;
              }
            }
            f.BO = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.BO {
              constructor(a, c) {
                super(a, c);
                this.dR = !1;
                this.$("fm-sheet-canvas");
                this.Ll = new $a();
                this.X(this.Ll);
                this.rm = new f.ZE();
                this.ti = new f.ZE();
              }
              nb() {}
              dz() {}
              get ec() {
                return this.dR;
              }
              set ec(a) {
                this.dR != a && (this.dR = a, this.Ya(this.ec ? b.s7 : b.sX));
              }
              dja() {
                0 != this.ec && (this.rm.reset(), this.ti.reset(), this.nb());
              }
              EG() {
                this.rm.reset();
              }
              ava() {
                this.ti.reset();
              }
              rw() {
                this.EG();
                this.ava();
              }
              Ly() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                for (var c = !1, d = this.Ll.content.element.children, g = 0; g < d.length; g++) {
                  var l = d.item(g);
                  c = this.Eja(l, a) || c;
                  l = l.children;
                  for (var m = 0; m < l.length; m++) {
                    var n = l.item(m);
                    c = this.nO(n, a) || c;
                  }
                }
                this.cZ = c;
              }
              eA() {
                this.Ll.content.width = this.dw - this.ca.pE;
                this.Ll.content.height = this.Pt - this.ca.oE;
              }
              get qb() {
                return this.Ll;
              }
              get width() {
                return this.dw;
              }
              set width(a) {
                this.dw != a && (this.element.style.minWidth = a + "px", this.dw = a, this.Ll.width = a);
              }
              get height() {
                return this.Pt;
              }
              set height(a) {
                this.Pt != a && (this.element.style.height = a + "px", this.Pt = a, this.Ll.height = a);
              }
              Tza(a, c) {
                a = this.ca.hT(a, this.ec);
                c = this.ca.DT(c, this.ec);
                var d = null;
                null != this.qn && (d = this.qn(c, a));
                null == d && (d = new h.W.le(), d.lb = c, d.mc = a);
                return d;
              }
              pV(a) {
                var c = this.parent.qg();
                var d = a.clientX - c.left;
                var g = a.clientY - c.top;
                c = a.target;
                c == this.qb.placeholder.element && (this.qb.placeholder.U("pointer-events", "none"), c = document.elementFromPoint(a.clientX, a.clientY), this.qb.placeholder.U("pointer-events", ""));
                c = x.Ga.Xb(c);
                d = this.Hu(c) || this.Tza(d, g);
                null != d && null != c && (g = h.W.Eq.q6, c.Sc(h.W.ya.JX) ? g = h.W.Eq.h7 : c.Sc(h.W.ya.t7) || c.Sc(h.W.ya.I6) ? g = h.W.Eq.Kna : c.Sc(h.W.ya.iB) ? g = h.W.Eq.YJ : c.Sc(h.W.ya.sP) && (g = h.W.Eq.sP), d.ZB = g);
                switch (a.type) {
                  case "click":
                    var l = new h.d8(d, c, a);
                }
                l && this.Ea(l);
              }
              MG(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var g = [],
                  l = new Qa();
                d && g.push(this.Dwa(a));
                for (d = a.top; d < a.bottom; d++) {
                  l.tag = "div";
                  l.$("fm-row");
                  l.attr["data-r"] = d;
                  d < this.ca.Jk && this instanceof f.l7 && (l.attr.role = "row");
                  c && (l.text += ab(this.rS(d)));
                  for (var m = a.left; m < a.right; ++m) l.text += ab(this.Vy(d, m));
                  g.push(ab(l));
                }
                return g.join("");
              }
              Dwa(a) {
                for (var c = "", d = a.left; d < a.right; ++d) c += ab(this.Lba(d));
                a = new Qa();
                a.tag = "div";
                a.$("fm-row");
                a.text = c;
                return c = ab(a);
              }
              hea() {
                var a = this.ca.lH();
                return this.ec ? this.ca.fu(this.ti.top, a) - this.qb.BC : this.ca.yM(a);
              }
              gea() {
                var a = this.ca.kH();
                return this.ec ? this.ca.gu(this.ti.left, a) - this.qb.ys : this.ca.fM(a);
              }
              dispose() {
                this.qb.dispose();
                super.dispose();
              }
            }
            b.s7 = "switched_to_smooth";
            b.sX = "switched_to_simple";
            f.XE = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                this.left = a;
                this.top = c;
                this.right = d;
                this.bottom = g;
              }
              set(a) {
                this.left = a.left;
                this.top = a.top;
                this.right = a.right;
                this.bottom = a.bottom;
              }
              reset() {
                this.bottom = this.right = this.top = this.left = 0;
              }
              contains(a) {
                return this.left <= a.left && this.top <= a.top && this.right >= a.right && this.bottom >= a.bottom;
              }
              clone() {
                return new b(this.left, this.top, this.right, this.bottom);
              }
            }
            f.ZE = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(a) {
                this.VC = [];
                this.data = [];
                this.coords = a;
              }
              reset() {
                this.data = [];
                this.VC = [];
              }
              setData(a, c, d) {
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                d.lb = a;
                d.mc = c;
                if (c < this.coords.Qd || g) null == this.data[a] && (this.data[a] = []), this.data[a][c] = d;
              }
              $V(a, c, d) {
                null == this.VC[a] && (this.VC[a] = []);
                this.VC[a][c] = d;
              }
              Fua(a, c) {
                void 0 === this.data[a] && (this.data[a] = []);
                return void 0 !== this.data[a][c];
              }
              getData(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
                if (0 == this.Fua(a, c)) {
                  var g = this.cD(a, c);
                  null != g && (g.lb = a, g.mc = c);
                  if (d) this.data[a][c] = g;else return g;
                }
                if (null !== this.data[a][c]) return this.data[a][c];
              }
              qAa(a, c) {
                return this.VC[a] && this.VC[a][c] ? this.VC[a][c] : null;
              }
              bva(a, c) {
                null != this.data[a] && (this.data[a][c] = this.getData(a, c));
              }
              dispose() {
                this.reset();
                this.cD = null;
              }
            }
            f.vqa = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(c) {
                this.lG = this.zy = null;
                this.Cj = new e.ub();
                this.DK = {};
                this.qK = {};
                this.BU = d => this.mq(d);
                this.ma = c;
                this.coords = this.ma.coords;
                this.Xm = new f.tqa(this, this.ma);
                this.OJa = new f.mka();
                this.Zu = u.pP.R();
                this.Zu.N(u.KeyboardEvent.oP, this.BU);
              }
              dispose() {
                null != this.Cj && 0 < this.Cj.length && this.v_();
                this.Zu.pb(u.KeyboardEvent.oP, this.BU);
                this.Zu = this.ma = null;
                this.Xm.dispose();
              }
              nb() {
                this.Xm.B4();
              }
              aha(c, d) {
                this.Xm.wU ? this.tJa(c, d) : this.Oha(c, d);
                this.nb();
              }
              bha(c, d) {
                this.Xm.fU || (null == this.Xm.Vo && (this.Xm.Vo = new f.z9(this.ma)), this.Xm.Vo.ow = c.toString() + "|" + d.toString(), this.nb());
              }
              select(c, d) {
                this.Cs();
                this.zy = c;
                this.lG = d;
                this.aha(c, d);
              }
              tJa(c, d) {
                this.Oea(c, d) && !this.Cj.Bb(this.IG(c, d)) && (this.v_(), this.Oha(c, d));
              }
              Oha(c, d) {
                null != this.Xm.Vo && (this.Xm.Vo.remove(), this.Xm.Vo = null);
                if (!this.Xm.fU || this.Oea(c, d)) if (this.Cj.Bb(this.IG(c, d))) g = this.Cj.getItem(this.IG(c, d)), null != g.So && delete this.DK[c.y.toString()], null != g.wo && delete this.qK[c.x.toString()], g.remove(), this.Cj.removeItem(this.IG(c, d));else if (null != c && null != d) {
                  var g = new f.z9(this.ma);
                  g.ow = this.IG(c, d);
                  this.Cj.Ua(g.ow, g);
                }
              }
              v_() {
                for (; 0 < this.Cj.length;) this.Cj.ea(0).remove(), this.Cj.K4(0);
                this.DK = {};
                this.qK = {};
              }
              IG(c, d) {
                return c.x.toString() + "|" + c.y.toString() + "|" + d.x.toString() + "|" + d.y.toString();
              }
              PG(c) {
                c = c.split("|");
                var d = {};
                4 == c.length ? (d.from = new e.K.Y.sheet.Lq(parseInt(c[0]), parseInt(c[1])), d.fp = new e.K.Y.sheet.Lq(parseInt(c[2]), parseInt(c[3]))) : 2 == c.length && (d.bt = parseInt(c[0]), d.pu = parseInt(c[1]));
                return d;
              }
              ofa(c) {
                return this.DK.hasOwnProperty(c.y.toString()) && this.qK.hasOwnProperty(c.x.toString()) && this.DK[c.y.toString()] == f.V6.zO && this.qK[c.x.toString()] == f.V6.zO;
              }
              Oea(c, d) {
                return null == c || null == d || !c.aH(d) || this.ofa(c) || this.ofa(d) || 0 > c.x * c.y || 0 > d.x * d.y ? !1 : !0;
              }
              selectAll() {
                this.select(new a(0, 0), new a(this.coords.Ql + this.coords.Qd - 1, this.coords.Kp + this.coords.ge - 1));
              }
              aia(c) {
                if (!(null == this.zy || this.zy.aH(c) && this.Cj.Bb(this.IG(this.zy, c)))) {
                  var d = this.zy;
                  this.Cs();
                  this.zy = d;
                  this.lG = c;
                  this.aha(d, c);
                }
              }
              NJa(c) {
                this.Cs();
                this.bha(c, -1);
              }
              KJa(c) {
                this.Cs();
                this.bha(-1, c);
              }
              Cs() {
                !this.Xm.fU && 0 < this.Cj.length && !this.Xm.wU && this.v_();
                null != this.Xm.Vo && (this.Xm.Vo.remove(), this.Xm.Vo = null);
                this.lG = this.zy = null;
              }
              clear() {
                this.Cs();
                this.nb();
              }
              sCa(c) {
                return c.hi && !isNaN(c.value) || c.ll && c.hi && "" != c.label;
              }
              jua(c) {
                if (null == c) return !1;
                let d = 0;
                for (let g = 0; g < c.length; g++) if (this.sCa(c[g]) && d++, 2 <= d) return !0;
                return !1;
              }
              get Dr() {
                return this.Cj;
              }
              get fp() {
                return this.lG;
              }
              set fp(c) {
                this.lG = c;
              }
              get from() {
                return this.lG;
              }
              set from(c) {
                this.zy = c;
              }
              cza(c, d) {
                return c && d ? Math.min(c.x, d.x) : -1;
              }
              WKa(c, d) {
                return c && d ? Math.max(c.x, d.x) : -1;
              }
              kza(c, d) {
                return c && d ? Math.min(c.y, d.y) : -1;
              }
              gLa(c, d) {
                return c && d ? Math.max(c.y, d.y) : -1;
              }
              move(c, d) {
                let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                switch (c) {
                  case 37:
                    this.xEa(g);
                    break;
                  case 38:
                    this.AEa(g);
                    break;
                  case 39:
                    this.yEa(g);
                    break;
                  case 40:
                    this.wEa(g);
                }
              }
              get Kha() {
                return this.DK;
              }
              get tba() {
                return this.qK;
              }
              xEa() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                this.jga(-1, c);
              }
              yEa() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                this.jga(1, c);
              }
              AEa() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                this.kga(-1, c);
              }
              wEa() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                this.kga(1, c);
              }
              jga(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                if (1 == this.Cj.length) {
                  var g = this.PG(this.Cj.ea(0).ow),
                    l = g.from,
                    m = g.fp;
                  g = d ? m.x : l.x;
                  var n = d ? m.x : l.x;
                  g = this.Kya(g + c, d ? m.y : l.y);
                  g < this.coords.pg ? (c = Math.max(g, this.coords.Qd), this.ma.dt(c)) : g >= this.coords.kea(this.coords.pg) + this.coords.pg - 1 && (c = this.coords.pg + (g - n), this.ma.dt(c + 1));
                  c = d ? m.y : l.y;
                  m = g;
                  this.select(new a(d ? l.x : g, l.y), new a(m, c));
                }
              }
              kga(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                if (1 == this.Cj.length) {
                  var g = this.PG(this.Cj.ea(0).ow),
                    l = g.from,
                    m = g.fp;
                  g = d ? m.y : l.y;
                  var n = d ? m.y : l.y;
                  g = this.Lya(g + c, d ? m.x : l.x);
                  g < this.coords.qh ? (c = Math.max(g, this.coords.ge), this.ma.Cr(c)) : g >= this.coords.lea(this.coords.qh) + this.coords.qh - 1 && (c = this.coords.qh + (g - n), this.ma.Cr(c + 1));
                  c = g;
                  m = d ? m.x : l.x;
                  this.select(new a(l.x, d ? l.y : g), new a(m, c));
                }
              }
              Lya(c, d) {
                return Math.max(d < this.coords.Qd ? this.coords.ge : this.coords.HG + 1, Math.min(c, this.coords.Jk - 1));
              }
              Kya(c, d) {
                return Math.max(d < this.coords.ge ? this.coords.Qd : this.coords.Qd - 1, Math.min(c, this.coords.dj - 1));
              }
              get qua() {
                return this.OJa;
              }
              mq(c) {
                if (null != this.Zu && (this.ma.Pm || this.Zu.$ea)) {
                  var d = c.ctrlKey || c.metaKey;
                  switch (c.keyCode) {
                    case 13:
                    case 32:
                      d || this.ma.Ya(h.vc.BJ);
                      break;
                    case 65:
                      d && (this.selectAll(), c.pq.preventDefault());
                      break;
                    case 37:
                    case 39:
                    case 38:
                    case 40:
                      this.move(c.keyCode, c.ctrlKey, c.shiftKey), c.pq.preventDefault();
                  }
                  !d || c.altKey || c.shiftKey || this.Zu.$ea || 67 !== c.keyCode || this.LG();
                }
              }
              LG() {
                var c = "";
                if (0 < this.Cj.length) for (var d, g = 0; g < this.Cj.length; g++) d = this.Cj.ea(g), null != d.Sj && (d = this.PG(d.ow), c += this.rwa(d.from, d.fp), g < this.Cj.length - 1 && (c += "\n"));
                0 < c.length && this.Zu.LG(c);
              }
              rwa(c, d) {
                var g = "";
                if (null == c || null == d) return g;
                var l = Math.min(c.x, d.x),
                  m = Math.max(c.x, d.x),
                  n = Math.max(c.y, d.y);
                for (d = Math.min(c.y, d.y); d <= n; d++) {
                  for (var p = l; p <= m; p++) {
                    p > l && (g += "\t");
                    c = this.ma.Xf(d, p, !0);
                    if (null == c && (c = d < this.coords.qh && p >= this.coords.pg ? this.ma.Xf(d, p - this.coords.pg + this.coords.Qd, !0) : null, null == c)) continue;
                    g += null == c ? "" : c.J();
                  }
                  d < n && (g += "\n");
                }
                return g;
              }
            }
            f.uqa = b;
            class a {
              constructor() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                this.x = c;
                this.y = d;
              }
              aH(c) {
                return c.x == this.x && c.y == this.y;
              }
            }
            f.Lq = a;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(d, g) {
                this.jG = this.fU = !1;
                this.Qq = this.iaa = null;
                this.Zaa = 5;
                this.HJa = 17;
                this.wU = !1;
                this.eI = l => this.pV(l);
                this.hga = l => this.U3(l);
                this.Gi = d;
                this.ma = g;
                this.coords = this.ma.coords;
                this.Qq = new f.lka();
                this.Qq.Za();
                this.ma.X(this.Qq);
                this.ma.element.addEventListener("mousedown", this.eI);
                this.ma.element.addEventListener("mouseup", this.eI);
              }
              get mA() {
                return this.jG;
              }
              set mA(d) {
                this.jG = d;
                this.mA || (this.ma.element.removeEventListener("mousemove", this.eI), document.removeEventListener("mousemove", this.hga));
              }
              get Vo() {
                return this.iaa;
              }
              set Vo(d) {
                this.iaa = d;
              }
              pV(d) {
                if (1 == d.which || 3 == d.which) {
                  var g = x.Ga.Xb(d.target);
                  if ("mousedown" != d.type || !(g.Sc(h.W.ya.Dq) || g.Sc(h.W.ya.wJ) || g.Sc(h.W.ya.qJ) || null != g.closest(".fm-filters") || null != g.closest("." + h.W.ya.FJ))) {
                    var l = this.ma.qg();
                    g = d.clientX - l.left;
                    l = d.clientY - l.top;
                    if (!(g > this.coords.du || l > this.coords.ve + this.coords.Iy || (l = this.coords.DT(l, this.ma.ec), g = this.coords.hT(g, this.ma.ec), isNaN(l) || isNaN(g)))) switch (this.fU = !u.qj.No && d.ctrlKey || u.qj.No && d.metaKey, this.wU = 3 == d.which, d.type) {
                      case "mousedown":
                        this.tx(l, g);
                        break;
                      case "mousemove":
                        this.ux(l, g);
                        break;
                      case "mouseup":
                        this.vr(l, g);
                    }
                  }
                }
              }
              U3(d) {
                var g = x.Ga.Xb(this.ma.element),
                  l = d.clientX;
                d = d.clientY;
                (l < g.left || d < g.top || l > g.left + this.ma.width || d > g.top + this.ma.height) && this.PKa();
              }
              select(d, g, l, m) {
                this.mA = !1;
                this.Gi.select(new f.Lq(g, d), new f.Lq(m, l));
              }
              PKa() {
                this.mA = !1;
              }
              tx(d, g) {
                this.mA = !0;
                this.Gi.select(new f.Lq(g, d), new f.Lq(g, d));
                this.ma.element.addEventListener("mousemove", this.eI);
                e.Dk.addEventListener("mousemove", this.hga);
              }
              vr(d, g) {
                this.mA && (this.mA = !1, this.wU || (-1 == d ? this.Gi.KJa(g) : -1 == g ? this.Gi.NJa(d) : this.Gi.from && !this.Gi.from.aH(new f.Lq(g, d)) && this.Gi.aia(new f.Lq(g, d))));
              }
              ux(d, g) {
                this.mA && (!this.Gi.fp || this.Gi.fp.x == g && this.Gi.fp.y == d || this.Gi.aia(new f.Lq(g, d)));
              }
              dispose() {
                this.ma.element && this.ma.element.removeEventListener("mousedown", this.eI);
                this.ma.element && this.ma.element.removeEventListener("mouseup", this.eI);
                this.Qq.dispose();
                this.coords = this.ma = this.Gi = null;
                null != this.Vo && (this.Vo.remove(), this.Vo = null);
              }
              B4() {
                this.Qq.eJa();
                for (var d = 0; d < this.Gi.Dr.length; d++) {
                  var g = this.Gi.Dr.ea(d);
                  var l = this.Gi.PG(this.Gi.Dr.Oh(d));
                  this.Esa(g, l.from, l.fp);
                }
                this.Fsa(this.Qq);
                this.Jxa(this.Vo);
              }
              Jxa(d) {
                if (null != d) {
                  d.Za();
                  var g = this.Gi.PG(d.ow);
                  -1 != g.bt && this.Uxa(g.bt, d);
                  -1 != g.pu && this.Txa(g.pu, d);
                }
              }
              Fsa(d) {
                d.Za();
                if (e.model.C.F.Aia && d.vCa() && null != e.u.Ma.R() && null != e.u.Ma.R().O) {
                  var g = this.ma.Dr;
                  if (this.Gi.jua(g) && (d.YDa(), this.qLa(d, g), !d.nCa())) {
                    d.show();
                    d.ew.Tk("auto");
                    d.top = d.Ol.bottom;
                    g = this.coords.$l(this.coords.Qd, this.ma.ec);
                    for (var l = 0, m = 0; m < d.Cp.length; m++) l += d.Cp.ea(m).width;
                    l = l + 2 * this.Zaa + 2 * (d.Cp.length - 1) * this.Zaa;
                    d.ew.width = l;
                    g - d.Ol.right + l > this.coords.scrollLeft ? d.Ol.right = d.Ol.left + l : g > d.Ol.right - l ? (d.ew.U("left", "auto"), d.ew.right = 0, l = d.Ol.right - g) : d.Ol.Hha >= this.coords.du && (d.ew.U("left", "right"), d.ew.left = 0, l = l - (d.Ol.Hha - this.coords.du) - 1, l = 0 > l ? 0 : l);
                    this.coords.ve + this.coords.Iy <= d.Ol.bottom + d.height && (d.top = d.Ol.bottom - this.HJa);
                    d.left = d.Ol.right - l;
                    d.vha.width = l;
                    d.width = l;
                  }
                }
              }
              qLa(d, g) {
                this.Gi.qua.LIa(d, g);
              }
              Esa(d, g, l) {
                d.Za();
                var m = Math.min(g.x, l.x),
                  n = Math.min(g.y, l.y),
                  p = Math.max(g.x, l.x);
                g = Math.max(g.y, l.y);
                this.BIa(m, p, n, g, d);
                e.model.C.F.Al && this.Mxa(m, p, n, g, d);
                l = this.coords.du;
                var t = this.coords.ve + this.coords.Iy,
                  r = Math.max(this.coords.ve, this.coords.Ko(n, this.ma.ec) - 1),
                  w = this.coords.Ko(g + 1, this.ma.ec),
                  y = Math.min(t, w),
                  A = Math.max(0, this.coords.$l(m, this.ma.ec) - 1),
                  B = this.coords.$l(p + 1, this.ma.ec),
                  C = Math.min(l, B),
                  I = y - r,
                  L = C - A;
                2 >= L || 2 >= I ? null != d.Sj && d.Sj.Za() : A < l && r < t ? (null != d.Sj && (d.Sj.show(), d.Sj.top = r, d.Sj.left = A, d.Sj.width = L, d.Sj.height = I, this.Qq.Ol.bottom * this.Qq.Ol.right <= C * y && (this.Qq.Ol.left = A, this.Qq.Ol.right = C, this.Qq.Ol.bottom = y, this.Qq.Ol.Hha = B)), n < this.coords.ge && B > C && (d.Iba(), d.gl.top = r, d.gl.left = C, d.gl.width = Math.min(B, this.coords.cq) - C, d.gl.height = Math.min(y, this.coords.ve + this.coords.cr) - r, d.gl.$a("fm-clear-border-bottom", g > this.coords.ge), d.gl.$a("fm-clear-border-right", B > this.coords.cq), d.gl.Gd("fm-clear-border"), d.gl.show()), m < this.coords.Qd && w > y && (d.Pba(), d.ul.top = y, d.ul.left = A, d.ul.width = Math.min(C, this.coords.tq) - A, d.ul.height = Math.min(w, this.coords.Ns) - y, d.ul.$a("fm-clear-border-bottom", w > this.coords.Ns), d.ul.$a("fm-clear-border-right", p > this.coords.Qd), d.ul.Gd("fm-clear-border"), d.ul.show()), null != d.Sj && (d.Sj.$a("fm-clear-border-right", B > C), d.Sj.$a("fm-clear-border-bottom", w > y))) : null != d.Sj && d.Sj.Za();
              }
              Uxa(d, g) {
                if (!isNaN(d)) {
                  null == g.So && g.Qba();
                  var l = this.coords.Ko(d, this.ma.ec);
                  d = this.coords.Ko(d + 1, this.ma.ec);
                  var m = Math.min(this.coords.ve + this.coords.Iy, d);
                  l < this.coords.ve + this.coords.Iy ? (g.So.left = 0, g.So.top = l, g.So.width = this.coords.du, g.So.height = m - l, g.So.show(), d > m && (g.Pba(), g.ul.top = m, g.ul.left = 0, g.ul.width = this.coords.tq, g.ul.height = Math.min(d, this.coords.Ns) - m, g.ul.$("fm-clear-border"), g.ul.show())) : g.So.Za();
                }
              }
              Txa(d, g) {
                if (!isNaN(d)) {
                  null == g.wo && g.Jba();
                  var l = this.coords.$l(d, this.ma.ec);
                  d = this.coords.$l(d + 1, this.ma.ec);
                  var m = Math.min(this.coords.du, d);
                  l < this.coords.du ? (g.wo.left = l, g.wo.top = this.coords.ve, g.wo.width = m - l, g.wo.height = this.coords.Iy, g.wo.show(), d > m && (g.Iba(), g.gl.top = this.coords.ve, g.gl.left = m, g.gl.width = Math.min(d, this.coords.cq) - m, g.gl.height = this.coords.cr, g.gl.$("fm-clear-border"), g.gl.show())) : g.wo.Za();
                }
              }
              Mxa(d, g, l, m, n) {
                this.Kxa(n.wo, d, g);
                this.Lxa(n.So, l, m);
              }
              BIa(d, g, l, m, n) {
                if (!this.Gi.Kha.hasOwnProperty(l.toString())) {
                  n.Qba();
                  for (var p = l; p <= m; p++) this.Gi.Kha[p.toString()] = l == m && d == g ? a.c9 : a.zO;
                }
                if (!this.Gi.tba.hasOwnProperty(d.toString())) for (n.Jba(), p = d; p <= g; p++) this.Gi.tba[p.toString()] = l == m && d == g ? a.c9 : a.zO;
              }
              Kxa(d, g, l) {
                null != d && (g = this.coords.$l(g, this.ma.ec), l = Math.min(this.coords.cq, this.coords.$l(l + 1, this.ma.ec)), g < this.coords.cq ? (d.left = g, d.top = this.coords.ve, d.width = l - g, d.height = this.coords.Ju(), d.show()) : d.Za());
              }
              Lxa(d, g, l) {
                null != d && (g = this.coords.Ko(g, this.ma.ec), l = Math.min(this.coords.Ns, this.coords.Ko(l + 1, this.ma.ec)), d.left = 0, d.top = g, d.width = this.coords.Js(), d.height = l - g, d.show());
              }
            }
            f.tqa = b;
            class a {}
            a.c9 = 1;
            a.zO = 2;
            f.V6 = a;
            class c {
              constructor(d) {
                this.ma = this.CK = this.pK = this.fG = this.KF = this.tQ = null;
                this.ma = d;
                this.tQ = this.CL();
              }
              CL() {
                var d = new x.Ga("div", "fm-sheet-selection-canvas");
                d.Za();
                this.ma.X(d);
                return d;
              }
              Jba() {
                null == this.KF && (this.KF = this.CL(), this.KF.$("fm-sheet-selection-header"));
              }
              Qba() {
                null == this.fG && (this.fG = this.CL(), this.fG.$("fm-sheet-selection-header"));
              }
              Pba() {
                null == this.CK && (this.CK = this.CL(), this.CK.$("fm-clear-border-top"));
              }
              Iba() {
                null == this.pK && (this.pK = this.CL(), this.pK.$("fm-clear-border-left"));
              }
              get ow() {
                return this.Hra;
              }
              set ow(d) {
                this.Hra = d;
              }
              get ul() {
                return this.CK;
              }
              get gl() {
                return this.pK;
              }
              get So() {
                return this.fG;
              }
              set So(d) {
                this.fG = d;
              }
              get wo() {
                return this.KF;
              }
              set wo(d) {
                this.KF = d;
              }
              get Sj() {
                return this.tQ;
              }
              set Sj(d) {
                this.tQ = d;
              }
              Za() {
                this.wo && this.wo.Za();
                this.So && this.So.Za();
                this.gl && this.gl.Za();
                this.ul && this.ul.Za();
                this.Sj && this.Sj.Za();
              }
              remove() {
                null != this.Sj && (this.Sj.remove(), this.tQ = null);
                null != this.wo && (this.wo.remove(), this.KF = null);
                null != this.So && (this.So.remove(), this.fG = null);
                null != this.gl && (this.gl.remove(), this.pK = null);
                null != this.ul && (this.ul.remove(), this.CK = null);
                this.ma = null;
              }
            }
            f.z9 = c;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.x$ = null;
              }
              LIa(a, c) {
                this.Lm = this.Hya(c);
                const d = null == this.Lm ? e.model.ac.pj.pT().clone() : this.Lm.ci(this.Lm.A, this.Lm.aa).clone();
                d.Sl = d.Sl == e.model.ac.pj.wda().Sl ? 2 : d.Sl;
                for (var g = 0; g < a.Kz.length; g++) {
                  var l = this.zua(a.Kz[g], c);
                  0 != l ? a.li(a.Kz[g], this.DAa(l, a.Kz[g], d.clone())) : a.WBa(a.Kz[g]);
                }
                this.Lm = null;
              }
              DAa(a, c, d) {
                var g = "count" == c || null != this.Lm && e.u.i.da.Fe(this.Lm.aa),
                  l = "count" != c && null != this.Lm && e.u.i.da.ce(this.Lm.aa),
                  m = null != this.Lm && this.Lm.type == e.u.i.Qa.ic && e.u.i.da.hp(this.Lm.aa);
                d.ce = "count" == c ? !1 : d.ce;
                d.xd = null != this.Lm && this.Lm.aa == e.u.i.da.Pi ? "" : d.xd;
                return m && !isNaN(a) && "count" != c ? e.P.Lx(a, e.model.C.F.ep) : u.cc.format(a, d, g, l);
              }
              zua(a, c) {
                switch (a) {
                  case "sum":
                    return this.Cua(c);
                  case "average":
                    return this.Aua(c);
                  case "count":
                    return this.Bua(c);
                }
                return 0;
              }
              Cua(a) {
                for (var c = 0, d = 0; d < a.length; d++) c += a[d].hi && !isNaN(a[d].value) && this.tU(a[d]) ? a[d].value : 0;
                return c;
              }
              Aua(a) {
                for (var c = 0, d = 0, g = 0; g < a.length; g++) a[g].hi && !isNaN(a[g].value) && this.tU(a[g]) && (c += a[g].value, d++);
                return 0 == d ? 0 : c / d;
              }
              Bua(a) {
                for (var c = 0, d = 0; d < a.length; d++) (a[d].hi && !isNaN(a[d].value) || a[d].ll && a[d].hi && "" != a[d].label) && c++;
                return c;
              }
              Hya(a) {
                for (var c = null, d = 0; d < a.length; d++) if (this.tU(a[d]) && null == c && !e.v(a[d].measure)) c = a[d].measure;else if (this.tU(a[d]) && null != c && c.A != a[d].measure.A) {
                  c = null;
                  break;
                }
                return c;
              }
              tU(a) {
                return a.ll && a.hi && !isNaN(a.value) || a.hi && null != a.measure && !isNaN(a.value) && e.u.i.Qa.zc != a.measure.type && e.u.i.Qa.Ta != a.measure.type && e.u.i.Qa.Lc != a.measure.type;
              }
              get Lm() {
                return this.x$;
              }
              set Lm(a) {
                this.x$ = a;
              }
            }
            f.mka = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Ga {
              constructor() {
                let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                super("div", "fm-auto-calculation-bar");
                this.mZ = ["average", "count", "sum"];
                this.CR = {};
                this.AQ = {
                  right: -1E3,
                  bottom: 1E3
                };
                this.Era = new e.ub();
                this.mZ = null == c ? this.mZ : c;
                this.dCa();
                this.Ie();
              }
              dCa() {
                this.CR.average = e.model.B.j.n6;
                this.CR.sum = e.model.B.j.x9;
                this.CR.count = e.model.B.j.R6;
              }
              get Cp() {
                return this.Era;
              }
              Ie() {
                this.xZ = new x.Ga("div");
                this.xZ.U("position", "relative");
                this.X(this.vha);
                this.Cra = new x.Ga("div", "fm-auto-calculation-bar-conainer");
                this.ew.U("position", "absolute");
                this.xZ.X(this.ew);
                for (var c, d = 0; d < this.Kz.length; d++) c = new a(), c.QJa(this.CR[this.Kz[d]]), this.ew.X(c), this.Cp.Ua(this.Kz[d], c);
              }
              vCa() {
                return -1E3 != this.AQ.right && 1E3 != this.AQ.bottom;
              }
              li(c, d) {
                this.Cp.getItem(c).RJa(d);
              }
              WBa(c) {
                this.Cp.getItem(c).Za();
              }
              get ew() {
                return this.Cra;
              }
              get vha() {
                return this.xZ;
              }
              YDa() {
                for (var c, d = 0; d < this.Cp.length; d++) c = this.Cp.ea(d), c.visible || c.show();
              }
              nCa() {
                for (var c = 0; c < this.Cp.length; c++) if (this.Cp.ea(c).visible) return !1;
                return !0;
              }
              get Ol() {
                return this.AQ;
              }
              get Kz() {
                return this.mZ;
              }
              eJa() {
                this.AQ = {
                  right: -1E3,
                  bottom: 1E3
                };
              }
              clear() {
                for (; 0 < this.Cp.length;) this.Cp.ea(0).dispose(), this.Cp.K4(0);
                this.dispose();
              }
            }
            f.lka = b;
            class a extends x.Ga {
              constructor() {
                super("div", "fm-auto-calculation-bar-content");
                this.display = "inline-block";
                this.Ie();
              }
              Ie() {
                this.Laa = new x.Ga("div", "fm-auto-calculation-bar-content-text");
                this.X(this.Laa);
                this.Maa = new x.Ga("div", "fm-auto-calculation-bar-content-results");
                this.X(this.Maa);
              }
              show() {
                this.element.style.display = this.display;
              }
              QJa(c) {
                this.Laa.text(c + ":");
              }
              RJa(c) {
                this.Maa.text(c);
              }
            }
            f.ULa = a;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    class $a extends x.Ga {
      constructor() {
        super("div", "fm-scroll-pane");
        this.haa = () => this.g4();
        this.bG = !1;
        this.IY = this.HY = 0;
        u.qj.No && this.$("fm-scrollbars");
        this.St = new x.Ga("div", "fm-scroll-placeholder");
        this.zQ = new x.Ga("div", "fm-scroll-content");
        this.X(this.St);
        this.X(this.zQ);
        this.element.addEventListener("scroll", this.haa, !0);
      }
      g4() {
        if (this.bG) return this.bG = !1;
        this.Ya(bb);
      }
      get CC() {
        return this.St.width;
      }
      set CC(e) {
        this.St.width = e;
      }
      get O_() {
        return this.St.height;
      }
      set O_(e) {
        this.St.height = e;
      }
      get scrollLeft() {
        return this.element.scrollLeft;
      }
      set scrollLeft(e) {
        this.bG = !1;
        this.element.scrollLeft = Math.max(0, e);
      }
      set LN(e) {
        this.bG = !0;
        this.element.scrollLeft = Math.max(0, e);
      }
      get scrollTop() {
        return this.element.scrollTop;
      }
      set scrollTop(e) {
        this.bG = !1;
        this.element.scrollTop = Math.max(0, e);
      }
      set NN(e) {
        this.bG = !0;
        this.element.scrollTop = Math.max(0, e);
      }
      get placeholder() {
        return this.St;
      }
      get content() {
        return this.zQ;
      }
      get ys() {
        return this.HY;
      }
      set ys(e) {
        this.HY = e;
        this.zQ.left = -this.HY;
      }
      get BC() {
        return this.IY;
      }
      set BC(e) {
        this.IY = e;
        this.zQ.top = -this.IY;
      }
      set ZBa(e) {
        this.element.style.overflowX = e ? "scroll" : "hidden";
      }
      set ELa(e) {
        this.element.style.overflowY = e ? "scroll" : "hidden";
      }
      dispose() {
        this.element && this.element.removeEventListener("scroll", this.haa);
        super.dispose();
      }
    }
    var bb = "fm_scroll_event";
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.BO {
              constructor(a) {
                super(a, null);
                this.ca = a;
              }
              nb() {
                var a = [],
                  c = new Qa();
                if (e.model.C.F.Al) {
                  c.tag = "div";
                  c.$("fm-row");
                  c.text += ab(this.Wwa());
                  for (var d = 0; d < this.ca.Qd; d++) c.text += ab(this.Lba(d));
                  a.push(ab(c));
                  for (d = 0; d < this.ca.ge; d++) c.text = ab(this.rS(d)), a.push(ab(c));
                }
                a = a.join("");
                this.element.innerHTML != a && this.html(a);
              }
              clear() {}
            }
            f.wqa = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    class cb {
      constructor() {
        this.text = this.tag = "";
        this.style = {};
        this.attr = {};
        this.classes = [];
        this.addClass = function (e) {
          0 > this.classes.indexOf(e) && this.classes.push(e);
        };
        this.toHtml = function () {
          var e = "<" + this.tag,
            k = [],
            h;
          for (h in this.style) k.push(h + ":" + this.style[h]);
          0 < k.length && (e += ' style="' + k.join(";") + ';"');
          0 < this.classes.length && (e += ' class="' + this.classes.join(" ") + '"');
          for (var f in this.attr) e += " " + f + '="' + this.attr[f] + '"';
          return e += ">" + (this.text || "") + "</" + this.tag + ">";
        };
        this.tag = "div";
      }
    }
    function ab(e) {
      let k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var h = e.node.toHtml();
      k && e.clear();
      null != q.K.Y.W.le.zw && (h = q.model.Tb.valid(h) ? h : q.model.Tb.validate(h));
      return h;
    }
    class Qa {
      constructor() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "div";
        this.usa = new cb();
        this.clear();
        this.tag = e;
      }
      get node() {
        return this.usa;
      }
      get tag() {
        return this.node.tag;
      }
      set tag(e) {
        this.node.tag = e;
      }
      get text() {
        return this.node.text;
      }
      set text(e) {
        this.node.text = e;
      }
      get style() {
        return this.node.style;
      }
      set style(e) {
        this.node.style = e;
      }
      get attr() {
        return this.node.attr;
      }
      set attr(e) {
        this.node.attr = e;
      }
      $(e) {
        this.node.addClass(e);
      }
      clear() {
        this.tag = "div";
        this.text = "";
        this.style = {};
        this.attr = {};
        this.node.classes = [];
      }
    }
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.XE {
              nb() {
                this.eA();
                var a = this.Io();
                if (this.ec || this.ca.LD(a.bottom) || this.ca.KD(a.right) || !this.rm.contains(a)) {
                  var c = a.clone();
                  0 != this.ca.dj && (c.right = Math.min(c.right, this.ca.dj));
                  0 != this.ca.Jk && (c.bottom = Math.min(c.bottom, this.ca.Jk));
                  if (!this.ec || !this.ti.contains(c) || !this.ca.mw && (a.left > this.ca.Qd && a.left <= this.ti.left || a.top > this.ca.ge && a.top <= this.ti.top)) this.ca.KD(a.right) && (a.left = Math.max(a.left - 1, this.ca.Qd)), this.ca.LD(a.bottom) && (a.top = Math.max(a.top - 1, this.ca.ge)), this.qb.content.html(this.MG(a)), this.ec = !1, this.rm.set(a);
                }
              }
              WK() {
                this.ec ? (this.qb.BC = this.ca.scrollTop - this.ca.fu(this.ca.ge, this.ti.top), this.qb.ys = this.ca.scrollLeft - this.ca.gu(this.ca.Qd, this.ti.left)) : (this.qb.BC = -this.ca.yM(this.rm.top), this.qb.ys = -this.ca.fM(this.rm.left));
              }
              dz() {
                var a = this.qb.CC;
                this.eA();
                a = this.qb.CC - a;
                var c = this.Io(!0);
                if (!(this.ec && this.ca.mw && this.ti.contains(c))) {
                  var d = this.hea(),
                    g = this.gea(),
                    l = this.Io();
                  this.ti = c;
                  this.qb.content.html(this.MG(c));
                  this.qb.BC = this.ca.fu(this.ti.top, l.top) - d;
                  this.qb.ys = this.ca.gu(this.ti.left, l.left) - g;
                  this.ec || this.ca.LD(this.rm.bottom) || (this.qb.NN = this.ca.lD(this.ca.qh, !1));
                  this.ec || (this.ca.KD(this.rm.right) ? (this.ca.$N = a, this.qb.ys += a) : this.qb.LN = this.ca.ZC(this.ca.pg, !1));
                  this.ec = !0;
                }
              }
              Io() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = new f.ZE();
                c.top = this.ca.lH(a);
                c.left = this.ca.kH(a);
                c.bottom = this.ca.pz(a);
                c.right = this.ca.YC(a);
                return c;
              }
              eA() {
                this.qb.CC = Math.max(this.ca.tu, this.ca.Ed - this.ca.pE);
                this.qb.O_ = Math.max(this.ca.su, this.ca.Dd - this.ca.oE);
                this.qb.content.right = this.ca.pE;
                this.qb.content.bottom = this.ca.oE;
                this.qb.ZBa = this.ca.sD;
                this.qb.ELa = this.ca.uD;
              }
              CN(a, c) {
                for (var d = [], g = this.Io(!0), l = g.top; l < g.bottom; l++) for (var m = 0; m < a.length; m++) {
                  var n = a[m];
                  this.i2(l, n) || (n = this.Vy(l, n), delete n.attr.tabindex, d.push(ab(n)));
                }
                var p = this.Ll.content.element.querySelector(".fm-row-hidden");
                null == p && (p = document.createElement("div"), p.classList.add("fm-row"), p.classList.add("fm-row-hidden"), this.Ll.content.element.appendChild(p), this.Ll.content.element.insertBefore(p, this.Ll.content.element.childNodes[0]));
                p.innerHTML = d.join("");
                this.requestAnimationFrame(() => {
                  for (var t = 0; t < p.children.length; t++) this.nO(p.children.item(t), !1, !0);
                  c();
                });
              }
              dispose() {
                super.dispose();
                this.qb.dispose();
              }
            }
            f.l7 = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.XE {
              nb() {
                this.eA();
                var a = this.Io();
                if (this.ec || this.ca.LD(a.bottom) || !this.rm.contains(a)) {
                  var c = a.clone();
                  0 != this.ca.Jk && (c.bottom = Math.min(c.bottom, this.ca.Jk));
                  this.ec && this.ti.contains(c) || (this.ca.LD(a.bottom) && (a.top = Math.max(a.top - 1, this.ca.ge)), this.qb.content.html(this.MG(a, e.model.C.F.Al)), this.dR = !1, this.rm.set(a));
                }
              }
              rS(a) {
                this.cell = super.rS(a);
                this.cell.style["min-height"] = this.cell.style.height;
                delete this.cell.style.height;
                delete this.cell.style["line-height"];
                return this.cell;
              }
              WK() {
                this.qb.BC = this.ec ? this.ca.scrollTop - this.ca.fu(this.ca.ge, this.ti.top) : -this.ca.yM(this.rm.top);
              }
              Io() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = new f.ZE();
                c.top = this.ca.lH(a);
                c.left = 0;
                c.bottom = this.ca.pz(a);
                c.right = this.ca.Qd;
                a && c.bottom == this.ca.Jk && c.bottom++;
                return c;
              }
              dz() {
                var a = this.Io(!0);
                if (!(this.ec && this.ca.mw && this.ti.contains(a))) {
                  var c = this.hea(),
                    d = this.Io();
                  this.ti = a;
                  this.qb.content.html(this.MG(a, e.model.C.F.Al));
                  this.qb.BC = this.ca.fu(this.ti.top, d.top) - c;
                  this.ec || this.ca.LD(this.rm.bottom) || (this.ca.scrollTop = this.qb.NN = this.ca.lD(this.ca.qh, !1));
                  this.ec = !0;
                }
              }
              xLa(a) {
                for (var c = 0; c < a.Ka.length; c++) {
                  const d = this.qb.content.element.querySelectorAll(`[data-c="${c}"]`);
                  for (let g = 0; g < d.length; g++) d.item(g).style.minWidth = this.ca.yh(c) + "px";
                }
              }
              eA() {
                this.qb.O_ = this.ca.su + this.ca.oE;
                this.qb.content.bottom = 0;
                this.qb.scrollTop = this.ca.scrollTop;
              }
              c1(a, c) {
                a = this.ca.gM(a, !0) - 1;
                c = this.ca.zM(c) - 1;
                var d = this.qn(c, a);
                null == d && (d = new h.W.le(), d.lb = c, d.mc = a);
                return d;
              }
            }
            f.cqa = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.XE {
              constructor(a, c) {
                super(a, c);
                this.tn = new f.OX(this);
                this.OQ = new f.lna(this);
              }
              nb() {
                u.cancelIdleCallback(this.kK);
                this.eA();
                var a = this.Io();
                if (this.ec || this.ca.KD(a.right) || !this.rm.contains(a)) {
                  var c = a.clone();
                  0 != this.ca.dj && (c.right = Math.min(c.right, this.ca.dj));
                  this.ec && this.ti.contains(c) || (this.ca.KD(a.right) && (a.left = Math.max(a.left - 1, this.ca.Qd)), this.tn.zx(), this.OQ.zx(), this.qb.content.html(this.MG(a, !1, e.model.C.F.Al)), this.tn.cA(), this.OQ.cA(), this.ec = !1, this.rm.set(a));
                }
              }
              WK() {
                this.qb.ys = this.ec ? this.ca.scrollLeft - this.ca.gu(this.ca.Qd, this.ti.left) : -this.ca.fM(this.rm.left);
              }
              Io() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                var c = new f.ZE();
                c.top = 0;
                c.left = this.ca.kH(a);
                c.bottom = this.ca.ge;
                c.right = this.ca.YC(a);
                a && c.right == this.ca.dj && c.right++;
                return c;
              }
              dz() {
                var a = this.qb.CC;
                this.eA();
                a = this.qb.CC - a;
                var c = this.Io(!0);
                if (!(this.ec && this.ca.mw && this.ti.contains(c))) {
                  u.cancelIdleCallback(this.kK);
                  var d = this.gea(),
                    g = this.Io();
                  this.ti = c;
                  this.tn.zx();
                  this.OQ.zx();
                  this.qb.content.html(this.MG(c, !1, e.model.C.F.Al));
                  this.tn.cA();
                  this.OQ.cA();
                  this.qb.ys = this.ca.gu(this.ti.left, g.left) - d;
                  this.ec || (this.ca.KD(this.rm.right) ? this.qb.ys += a : this.qb.LN = this.ca.ZC(this.ca.pg, !1));
                  this.ec = !0;
                }
              }
              eA() {
                this.qb.CC = this.ca.tu + this.ca.pE;
                this.qb.content.right = 0;
              }
              rua() {
                u.cancelIdleCallback(this.kK);
                this.kK = u.requestIdleCallback(() => this.Z9());
              }
              Z9() {
                var a = this.ca.Yza();
                if (0 != a.length) {
                  for (var c = [], d = 0; d < this.ca.ge; d++) for (var g = 0; g < a.length; g++) {
                    var l = a[g];
                    this.i2(d, l) || (l = this.Vy(d, l), delete l.attr.tabindex, c.push(ab(l)));
                  }
                  var m = this.Ll.content.element.querySelector(".fm-row-hidden");
                  null == m && (m = document.createElement("div"), m.classList.add("fm-row"), m.classList.add("fm-row-hidden"), this.Ll.content.element.insertBefore(m, this.Ll.content.element.childNodes[0]));
                  m.innerHTML = c.join("");
                  this.requestAnimationFrame(() => {
                    for (var n = 0; n < m.children.length; n++) this.nO(m.children.item(n), !1, !0);
                    this.kK = u.requestIdleCallback(() => this.Z9());
                  });
                }
              }
              CN(a, c) {
                for (var d = [], g = 0; g < this.ca.ge; g++) for (var l = 0; l < a.length; l++) {
                  var m = a[l];
                  this.i2(g, m) || (m = this.Vy(g, m), delete m.attr.tabindex, d.push(ab(m)));
                }
                var n = this.Ll.content.element.querySelector(".fm-row-hidden");
                null == n && (n = document.createElement("div"), n.classList.add("fm-row"), n.classList.add("fm-row-hidden"), this.Ll.content.element.insertBefore(n, this.Ll.content.element.childNodes[0]));
                n.innerHTML = d.join("");
                this.requestAnimationFrame(() => {
                  for (var p = 0; p < n.children.length; p++) this.nO(n.children.item(p), !1, !0);
                  c();
                });
              }
              c1(a, c) {
                a = this.ca.gM(a) - 1;
                c = this.ca.zM(c, !0) - 1;
                var d = this.qn(c, a);
                null == d && (d = new h.W.le(), d.lb = c, d.mc = a);
                return d;
              }
              lL() {
                u.cancelIdleCallback(this.kK);
              }
              dispose() {
                this.lL();
                super.dispose();
              }
            }
            f.Y6 = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Ga {
              constructor() {
                super("div", "fm-grid-layout");
                this.Oia = 1E3;
                this.Hy = [];
                this.wK = !1;
                this.B_ = a => this.dFa(a);
                this.Lha = a => this.$Ga(a);
                this.yia = a => this.jHa(a);
                this.mL = 0;
                this.Ul();
                this.ca = new f.Hh();
                this.pn = new f.vqa(this.ca);
                this.wn = new f.uqa(this);
                this.Ie();
                this.Je(-1);
                this.preventScroll();
              }
              Ie() {
                this.b0();
                this.Xwa();
                this.Kba();
                this.Vwa();
                this.Gwa();
                this.Uwa();
              }
              b0() {
                this.ls = new x.Vc();
                this.ls.G.display = "block";
                this.ls.$("fm-grid-title");
                this.ls.$("fm-pivot-title");
                this.ls.jW(!0);
                this.ls.G.U("position", "relative");
                this.ls.Za();
                this.$B(this.ls);
              }
              Xwa() {
                this.ks = new f.wqa(this.ca);
                this.ks.$("fm-sheet-headers");
                this.X(this.ks);
              }
              Kba() {
                this.nd = new f.Y6(this.ca, (a, c) => this.Xf(a, c));
                this.nd.$("fm-cols-sheet");
                this.nd.qb.element.addEventListener("wheel", this.B_);
                this.nd.N(h.vc.bo, a => this.Lk(a));
                u.Jd().Rm && (this.nd.qb.U("overflow", "scroll"), this.nd.qb.placeholder.U("z-index", "1"), this.nd.qb.N(bb, () => this.bFa(), !0));
                this.X(this.nd);
              }
              Vwa() {
                this.ye = new f.cqa(this.ca, (a, c) => this.Xf(a, c));
                this.ye.$("fm-rows-sheet");
                this.ye.qb.element.addEventListener("wheel", this.Lha);
                this.ye.N(h.vc.bo, a => this.Lk(a));
                u.Jd().Rm && (this.ye.qb.U("overflow", "scroll"), this.ye.qb.placeholder.U("z-index", "1"), this.ye.qb.N(bb, () => this.ZGa(), !0));
                this.X(this.ye);
              }
              Gwa() {
                this.Tc = new f.l7(this.ca, (a, c) => this.Xf(a, c));
                this.Tc.$("fm-data-sheet");
                this.Tc.qb.N(bb, () => this.pFa(), !0);
                this.Tc.N(f.XE.sX, a => this.Bga(a));
                this.Tc.N(f.XE.s7, a => this.Bga(a));
                this.Tc.N(h.vc.bo, a => this.Lk(a));
                this.X(this.Tc);
              }
              Uwa() {
                this.cs = new f.xla(this);
                this.cs.$("fm-cols-resize");
                this.cs.N(h.vc.AF, a => this.ZEa(a));
                this.X(this.cs);
                this.js = new f.dqa(this);
                this.js.$("fm-rows-resize");
                this.js.N(h.vc.BF, a => this.YGa(a));
                this.X(this.js);
                this.element.addEventListener("dblclick", this.yia);
              }
              nb() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                this.ca.tia();
                this.ca.SR();
                this.Tc.width && this.Tc.height || this.XG();
                this.ca.setScale();
                this.ca.$N = 0;
                this.Jaa();
                e.kr(this.OY);
                this.n0();
                this.Hy.push(this.requestAnimationFrame(() => this.NY(a)));
              }
              n0() {
                for (; 0 < this.Hy.length;) this.cancelAnimationFrame(this.Hy.pop());
              }
              NY() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                this.Ya(k.Si.Sx, this, {
                  smooth: !1
                });
                k.Nb.Gb.Ya(k.Si.Sx, this, {
                  smooth: !1
                });
                const c = this.ca.HR();
                this.ec && this.ye.xLa(c);
                this.WG();
                this.wK && (this.o_() && (this.ca.HR(), this.nd.EG(), this.ye.EG(), this.WG()), this.wK = !1);
                this.NL();
                e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.ip, {
                  smooth: !1
                }));
                this.Hy.push(this.requestAnimationFrame(() => {
                  this.XG();
                  this.wn.nb();
                }));
                this.Hy.push(this.requestAnimationFrame(() => {
                  var d = !a && this.n_();
                  d ? (this.nd.EG(), this.ye.EG(), this.Tc.EG(), this.nb(!0)) : this.ca.Eua && (e.kr(this.OY), this.OY = e.Be(() => this.dz(), this.Oia));
                  !d && e.model.C.F.cz && this.aI();
                }));
                this.Hy.push(this.requestAnimationFrame(() => {
                  this.Ya(k.Si.ip, this, {
                    smooth: !1
                  });
                  k.Nb.Gb.Ya(k.Si.ip, this, {
                    smooth: !1
                  });
                }));
              }
              WG() {
                this.s0();
                this.ca.DW = this.vea() ? this.ls.yd(!0) : 0;
                this.nd.nb();
                this.nd.WK();
                this.ye.nb();
                this.ye.WK();
              }
              NL() {
                this.ks.nb();
                this.wn.nb();
                this.cs.nb();
                this.js.nb();
                this.Tc.nb();
                this.Tc.WK();
              }
              s0() {
                this.vea() ? (this.ls.gb(e.model.C.F.Yp), this.ls.show()) : this.ls.Za();
              }
              vea() {
                return !(e.ia(e.model.C.F.Yp) || this instanceof f.flat.zJ && this.ll);
              }
              o_() {
                this.nd.Ly(!0);
                this.ye.Ly(!0);
                return this.nd.HD || this.ye.HD;
              }
              n_() {
                this.Tc.Ly(!0);
                this.nd.Ly(!0);
                this.ye.Ly(!0);
                return this.Tc.HD || this.nd.HD || this.ye.HD;
              }
              dz() {
                this.n0();
                this.Hy.push(this.requestAnimationFrame(() => this.Vra()));
              }
              Vra() {
                this.CN(() => {
                  k.Nb.Gb.Ya(k.Si.Sx, this, {
                    smooth: !0
                  });
                  this.nd.dz();
                  this.ye.dz();
                  this.Tc.dz();
                  this.ca.scrollLeft = this.Tc.qb.scrollLeft;
                  this.ca.scrollTop = this.Tc.qb.scrollTop;
                  e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.ip, {
                    smooth: !0
                  }));
                  this.type == f.flat.zJ.TYPE && e.model.C.F.cz && this.aI();
                  this.ca.mw || 0 != this.ca.scrollLeft || this.nd.rua();
                  this.Hy.push(this.requestAnimationFrame(() => {
                    k.Nb.Gb.Ya(k.Si.ip, this, {
                      smooth: !0
                    });
                  }));
                });
              }
              CN(a) {
                var c = this.ca.Zza(this.ca.Io(!0));
                0 == c.length ? a() : this.nd.CN(c, () => {
                  this.Tc.CN(c, a);
                });
              }
              Bga(a) {
                a.type == f.XE.sX && this.requestAnimationFrame(() => {
                  this.nd.dja();
                  this.ye.dja();
                });
              }
              pFa() {
                this.e5(this.Tc.qb.scrollTop, this.Tc.qb.scrollLeft);
              }
              ZGa() {
                this.e5(this.ye.qb.scrollTop);
              }
              bFa() {
                this.e5(NaN, this.nd.qb.scrollLeft);
              }
              $Ga(a) {
                if (this.coords.uD) {
                  var c = a.wheelDeltaY || a.deltaY || a.wheelDelta || 0;
                  u.Jd().PH && (c *= -40);
                  u.Jd().cj && (c *= -1);
                  isNaN(c) || 0 == c || (this.Tc.qb.scrollTop = this.ca.scrollTop - c);
                  a.preventDefault();
                }
              }
              dFa(a) {
                if (this.coords.sD) {
                  var c = a.wheelDeltaX || a.deltaX || 0;
                  u.Jd().PH && (c *= -40);
                  u.Jd().cj && (c *= -1);
                  0 != c && (this.Tc.qb.scrollLeft = this.ca.scrollLeft - c);
                  a.preventDefault();
                }
              }
              preventScroll() {
                this.element.addEventListener("scroll", a => {
                  a.target.scrollTo(0, 0);
                });
              }
              get slice() {
                return this.Qb;
              }
              set slice(a) {
                this.Qb = a;
              }
              get type() {
                return this.Cg;
              }
              get coords() {
                return this.ca;
              }
              XG() {
                this.width = this.coords.cq;
                this.height = this.coords.Ns;
                this.cs.left = 0;
                this.cs.top = this.coords.ve;
                this.cs.right = 0;
                this.cs.height = this.coords.Ju();
                this.js.left = 0;
                this.js.top = this.coords.ve;
                this.js.bottom = 0;
                this.js.width = this.coords.Js();
              }
              get Dr() {
                var a = [];
                if (0 < this.W4.Dr.length) for (var c, d = 0; d < this.wn.Dr.length; d++) null != this.wn.Dr.ea(d).Sj && (c = this.wn.PG(this.wn.Dr.ea(d).ow), this.vBa(a, c.from, c.fp));
                return a;
              }
              vBa(a, c, d) {
                if (c && d) for (var g = this.wn.kza(c, d); g <= this.wn.gLa(c, d); g++) for (var l = this.wn.cza(c, d); l <= this.wn.WKa(c, d); l++) {
                  var m = this.Xf(g, l, !0);
                  null == m && (m = new h.W.le(), m.lb = g, m.mc = l);
                  a.push(m);
                }
              }
              Xf(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                var g = this.pn.getData(a, c, !d);
                return d && null == g ? this.pn.qAa(a, c) : g;
              }
              insertCell(a, c, d) {
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                this.pn.setData(a, c, d, g);
              }
              resize(a, c) {
                this.ca.resize(a, c, !0);
              }
              set cD(a) {
                this.pn.cD = a;
              }
              jia(a, c) {
                this.ca.Kp = a;
                this.ca.Ql = c;
              }
              oda(a) {
                a != this.ca.ge && (this.ca.qh = a + (this.ca.qh - this.ca.ge));
                this.ca.ge = a;
              }
              aza(a) {
                a != this.ca.Qd && (this.ca.pg = a + (this.ca.pg - this.ca.Qd));
                this.ca.pg < a && (this.ca.pg = a);
                this.ca.Qd = a;
              }
              lu() {
                this.wK = !0;
                this.pn.reset();
                this.ca.reset();
                this.nd.rw();
                this.ye.rw();
                this.Tc.rw();
                this.wn.clear();
                this.Tc.qb.scrollTop = 0;
                this.Tc.qb.scrollLeft = 0;
                this.lL();
              }
              clearData() {
                this.pn.reset();
                this.nd.rw();
                this.ye.rw();
                this.Tc.rw();
                this.ca.SR();
                this.ca.cva();
              }
              FG(a) {
                this.wK = !0;
                this.ca.FG(a);
              }
              pC(a) {
                this.wK = !0;
                this.ca.pC(a);
              }
              select(a, c, d, g) {
                this.wn.select(new f.Lq(c, a), new f.Lq(g, d));
                this.element.focus({
                  preventScroll: !0
                });
              }
              Cs() {
                this.wn.clear();
                this.element.blur();
              }
              lL() {
                this.n0();
                e.kr(this.OY);
                e.kr(this.nba);
                this.nd.lL();
              }
              dispose() {
                this.pn.dispose();
                this.wn.dispose();
                this.lL();
                this.nd.qb.element && this.nd.qb.element.removeEventListener("wheel", this.B_);
                this.nd.dispose();
                this.ye.qb.element && this.ye.qb.element.removeEventListener("wheel", this.Lha);
                this.ye.dispose();
                this.Tc.dispose();
                this.cs.dispose();
                this.js.dispose();
                this.element && this.element.removeEventListener("dbclick", this.yia);
                super.dispose();
              }
              Lk(a) {
                null != a.cell && this.Ea(a);
                this.XEa(a);
              }
              lq(a) {
                this.Ea(a);
              }
              XEa(a) {
                !a.cell || void 0 == this.WR || a.cell.lb == this.WR.y && a.cell.mc == this.WR.x ? this.mL++ : (e.kr(this.nba), this.mL = 1);
                1 == this.mL && (this.nba = e.Be(() => {
                  if (1 == this.mL) {
                    if (a.cell) {
                      var c = new h.f8(a.cell, !0, a.element);
                      this.Ea(c);
                    }
                  } else a.cell && (c = new h.f8(a.cell, !1, a.element), this.Ea(c));
                  this.mL = 0;
                  this.WR = void 0;
                }, 300), a.cell && (this.WR = new f.Lq(a.cell.mc, a.cell.lb)));
              }
              e5() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
                var d = !1;
                isNaN(a) || a == this.coords.scrollTop || (this.coords.scrollTop = a, this.coords.qh = this.coords.zM(a), this.ye.qb.NN = a, d = !0);
                isNaN(c) || c == this.coords.scrollLeft || (this.coords.scrollLeft = c, this.coords.pg = this.coords.gM(c), this.nd.qb.LN = c, d = !0);
                d && this.nb();
              }
              ZEa(a) {
                this.Ea(a);
                this.ca.HR();
                0 < a.data.width ? this.ca.PN(a.data.mc, a.data.width, !1, !0) : this.ca.dJa(a.data.mc);
                this.CS();
              }
              YGa(a) {
                this.Ea(a);
                this.ca.HR();
                0 < a.data.height ? this.ca.Dx(a.data.lb, a.data.height, !1, !0) : this.ca.fJa(a.data.lb);
                this.CS();
              }
              jHa(a) {
                if (0 != e.model.C.F.Al) {
                  var c = this.qg(),
                    d = a.clientX - c.left;
                  a = a.clientY - c.top;
                  d > this.coords.Js() && a > this.coords.ve + this.coords.Ju() || (a = this.coords.DT(a, this.ec), d = this.coords.hT(d, this.ec), -1 != a || isNaN(d) || this.cs.Ya(h.vc.AF, this, {
                    width: -1,
                    mc: d
                  }), -1 != d || isNaN(a) || (this.js.Ya(h.vc.BF, this, {
                    height: -1,
                    lb: a
                  }), this.Ya(h.vc.Rpa, this, {
                    height: -1,
                    lb: a
                  })));
                }
              }
              CS() {
                this.nd.rw();
                this.ye.rw();
                this.Tc.rw();
                this.Jaa();
                this.nb();
              }
              Jaa() {
                if (0 < this.coords.scrollLeft && 0 < this.coords.$ya) {
                  var a = Math.max(0, this.coords.tu - this.coords.Ed + this.coords.pE);
                  this.coords.scrollLeft = a;
                  this.coords.pg = this.coords.gM(a);
                  this.Tc.qb.LN = a;
                  this.nd.qb.LN = a;
                }
                0 < this.coords.scrollTop && 0 < this.coords.Zya && (a = Math.max(0, this.coords.su - this.coords.Dd + this.coords.oE), this.coords.scrollTop = a, this.coords.qh = this.coords.zM(a), this.Tc.qb.NN = a, this.ye.qb.NN = a);
              }
              Hu(a) {
                var c = x.Ga.Xb(a);
                a = c.closest(".fm-cell");
                return null != a ? (c = parseInt(a.attr("data-r")), a = parseInt(a.attr("data-c")), this.Xf(c, a, !0)) : null != c.closest(".fm-page-filter") && null != c.closest(".fm-filter-header") ? (a = c.closest(".fm-filter-header"), a = parseInt(a.attr("data-h")), a = this.slice.ob.ea(a), c = new h.W.le(), c.label = a.caption, c.ml = !0, c.hierarchy = a, c) : null;
              }
              yda(a, c) {
                c = this.coords.DT(c - this.offset().top, !1);
                a = this.coords.hT(a - this.offset().left, !1);
                let d = this.Xf(c, a, !0);
                e.v(d) && (d = new h.W.le(), d.lb = c, d.mc = a);
                return d;
              }
              get ec() {
                return this.Tc.ec;
              }
              Cr(a) {
                a = Math.min(a, this.coords.Jk);
                this.Tc.qb.scrollTop = this.coords.lD(a);
              }
              dt(a) {
                a = Math.min(a, this.coords.dj);
                this.Tc.qb.scrollLeft = this.coords.ZC(a);
              }
              DJa() {
                this.Tc.qb.scrollTop += this.coords.Dd;
              }
              GJa() {
                this.Tc.qb.scrollTop -= this.coords.Dd;
              }
              FJa() {
                this.Tc.qb.scrollLeft += this.coords.Ed;
              }
              EJa() {
                this.Tc.qb.scrollLeft -= this.coords.Ed;
              }
              get I() {
                return this.pn;
              }
              get W4() {
                return this.wn;
              }
              N4(a, c) {
                this.coords.PN(a, c, !1, !0);
              }
              P4(a, c) {
                this.coords.Dx(a, c, !1, !0);
              }
              aI() {
                this.Ds({
                  Um: (a, c, d, g) => this.Um(a, c, d, g),
                  Tm: (a, c, d, g) => this.Tm(a, c, d, g),
                  em: (a, c, d, g) => this.em(a, c, d, g)
                });
              }
              Mba(a) {
                var c = new x.Ga("span");
                c.$("fm-helper");
                c.$("fm-draggable");
                c.$("fm-header-helper");
                c.U("position", "absolute");
                c.U("z-index", 100);
                c.text(a.element.firstChild.textContent);
                a = new x.Ga("i", "fm-remove-icon");
                c.X(a);
                return c;
              }
              Tm(a, c, d, g) {
                a && a.$a("fm-drag-remove", !1);
                c && c.$a("fm-drag-remove", !1);
                a = x.Ga.Xb(g.target);
                a.Sc("fm-header-drop-indicator") || this.EE(a, a);
              }
              em(a, c) {
                this.im();
                a && a.$a("fm-drag-remove", !0);
                c && c.$a("fm-drag-remove", !0);
              }
              Um() {}
              EE() {}
              xw() {
                return this.vd ? this.vd : new x.Ga("div", "fm-header-drop-indicator");
              }
              im() {
                this.vd && (this.vd.Lg(!0), this.vd = null);
              }
              nV(a) {
                e.kr(this.GDa);
                var c = this.slice.Yc.ph(a.Wg);
                if (!e.v(c)) {
                  var d = this.Qwa(c, a.value);
                  if (c.filter.Ku || null != d) c.filter.Ku && a.value == c.filter.query.value || (this.GDa = e.Be(() => {
                    e.model.Va.R().yl(c.A, d);
                    c.filter.cfa = !0;
                  }, 300));
                }
              }
              Qwa(a, c) {
                var d = {};
                if (e.model.hb.TA.tT(a) == e.u.i.rb.jb) {
                  a = parseFloat(c);
                  if (isNaN(a)) return null;
                  d.query = {
                    equal: a
                  };
                } else {
                  if (e.ia(c)) return null;
                  d.query = {
                    contain: c
                  };
                }
                return d;
              }
            }
            f.y6 = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.BO {
              constructor(a) {
                super(a, null);
                this.ca = a;
                this.wb = [];
                this.$("fm-filters");
                this.N(h.vc.bo, c => this.Lk(c));
                this.N("keydown", c => this.WD(c));
                this.tn = new f.OX(this);
              }
              nb() {
                for (var a = [], c = new Qa(), d = 0; d < this.ca.ge; d++) {
                  c.tag = "div";
                  c.$("fm-row");
                  for (var g = 0; g < this.ca.Qd; g++) if (e.model.C.F.jt) {
                    var l = d - this.ca.ge + this.wb.length;
                    c.text += ab(this.oS(d, g, 0 <= l ? this.wb[l] : null));
                  } else c.text += ab(this.Vy(d, g));
                  a.push(ab(c));
                }
                a = a.join("");
                this.element.innerHTML != a && (this.tn.zx(), this.html(a), this.tn.cA());
              }
              oS(a, c, d) {
                var g = this.wb.indexOf(d);
                this.cell.clear();
                this.cell.tag = "div";
                this.cell.$(h.W.ya.Me);
                this.cell.$(h.W.ya.gk);
                this.cell.$(h.W.ya.yv);
                d ? (this.cell.$(h.W.ya.Of + g), this.cell.text = e.P.Go(d.caption, !0, !0).replace(/\n/g, "<br>"), d.ZM && (e.model.C.F.Sm ? (this.Az(this.cell, d), this.cell.$(h.W.ya.FJ), this.cell.attr["data-h-name"] = d.A, this.cell.text += this.tn.Y_(d)) : e.model.C.F.Gx && (this.cell.attr.title = e.model.B.j.lB, this.Az(this.cell, d)))) : this.cell.$(h.W.ya.bX);
                this.eia(this.cell, a, c);
                this.cell.attr["data-c"] = c;
                this.cell.attr["data-r"] = a;
                0 <= g && (this.cell.attr["data-h"] = g, this.cell.attr.tabindex = "0");
                return this.cell;
              }
              Az(a, c) {
                a.$(h.W.ya.Dq);
                c.filter.zh && (a.$(h.W.ya.zX), a.text += this.Bo(h.W.ya.qJ, e.model.B.j.tY));
                a.text += this.Bo(h.W.ya.wJ);
              }
              gA(a) {
                for (var c = this.wb.length = 0; c < a.length; c++) {
                  var d = a.ea(c);
                  0 == d.Ue && this.wb.push(d);
                }
              }
              Lk(a) {
                if (!e.model.C.F.Sm) {
                  var c = a.element;
                  c.Sc(h.W.ya.Dq) && (c = parseInt(c.attr("data-h")), isNaN(c) || this.Ea(new h.fP(this.wb[c], a.cell)));
                }
              }
              WD(a) {
                if (!e.model.C.F.Sm && (32 == a.keyCode || 13 == a.keyCode)) {
                  var c = a.target;
                  a = parseInt(c.getAttribute("data-r"));
                  c = parseInt(c.getAttribute("data-c"));
                  isNaN(a) || isNaN(c) || this.Ea(new h.gP(a, c));
                }
              }
              clear() {
                this.wb.length = 0;
                this.nb();
              }
            }
            f.s9 = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.BO {
              constructor(a) {
                super(a, null);
                this.rowIndex = 0;
                this.ca = a;
                this.wb = [];
                this.$("fm-filters");
                this.Za();
                this.N(h.vc.bo, c => this.Lk(c));
                this.N("keydown", c => this.WD(c));
                this.tn = new f.OX(this);
              }
              nb() {
                this.tn.zx();
                this.xx();
                if (e.model.C.F.jt) {
                  var a = new Qa("div");
                  a.$("fm-row");
                  a.style.height = this.ca.Xd(this.rowIndex) + "px";
                  for (var c = 0; c < this.wb.length; c++) a.text += ab(this.oS(this.rowIndex, c, this.wb[c]));
                  this.html(ab(a));
                  this.tn.cA();
                  0 == this.wb.length ? this.Za() : this.show();
                } else this.Za();
              }
              oS(a, c, d) {
                this.cell.clear();
                this.cell.tag = "div";
                this.cell.$(h.W.ya.Me);
                this.cell.$(h.W.ya.gk);
                d && (this.cell.text = e.P.Go(d.caption, !0, !0).replace(/\n/g, "<br>"), d.ZM && (e.model.C.F.Sm ? (this.Az(this.cell, d), this.cell.$(h.W.ya.FJ), this.cell.attr["data-h-name"] = d.A, this.cell.text += this.tn.Y_(d)) : e.model.C.F.Gx && (this.cell.attr.title = e.model.B.j.lB, this.Az(this.cell, d))));
                this.cell.style["min-height"] = this.ca.Xd(a) + "px";
                this.cell.style["max-height"] = this.ca.Xd(a) + "px";
                this.cell.attr["data-r"] = a;
                this.cell.attr["data-c"] = this.ca.pg + c;
                this.cell.attr["data-h"] = c;
                this.cell.attr.tabindex = "0";
                return this.cell;
              }
              Az(a, c) {
                a.$(h.W.ya.Dq);
                c.filter.zh && (a.$(h.W.ya.zX), a.text += this.Bo(h.W.ya.qJ, e.model.B.j.tY));
                a.text += this.Bo(h.W.ya.wJ);
              }
              gA(a) {
                for (var c = this.wb.length = 0; c < a.length; c++) {
                  var d = a.ea(c);
                  0 == d.Ue && this.wb.push(d);
                }
                0 == this.wb.length ? this.Za() : this.show();
              }
              Lk(a) {
                if (!e.model.C.F.Sm && (a = a.element, a.Sc(h.W.ya.Dq))) {
                  var c = parseInt(a.attr("data-h"));
                  isNaN(c) || this.Ea(new h.fP(this.wb[c], null, a));
                }
              }
              WD(a) {
                if (!e.model.C.F.Sm && (32 == a.keyCode || 13 == a.keyCode)) {
                  var c = a.target;
                  a = parseInt(c.getAttribute("data-r"));
                  c = parseInt(c.getAttribute("data-c"));
                  isNaN(a) || isNaN(c) || this.Ea(new h.gP(a, c));
                }
              }
              clear() {
                this.wb.length = 0;
                this.nb();
              }
            }
            f.yla = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Ga {
              constructor() {
                super();
                this.wb = [];
                this.$("fm-ui-hgroup");
                this.$("fm-filters");
                this.Za();
              }
              nb() {
                this.xx();
                if (e.model.C.F.Gx && e.model.C.F.CI) {
                  var c = [];
                  for (let d = 0; d < this.wb.length; d++) {
                    const g = this.wb[d];
                    if (!g.ZM) {
                      c.push(d);
                      continue;
                    }
                    const l = new a(g, !0);
                    l.G.attr("data-h", d);
                    l.N("click", () => this.Lk(l));
                    l.N("keydown", m => this.WD(m, l));
                    this.X(l.G);
                  }
                  0 == this.wb.length || c.length == this.wb.length ? this.Za() : this.show();
                } else this.Za();
              }
              gA(c) {
                for (var d = this.wb.length = 0; d < c.length; d++) {
                  var g = c.ea(d);
                  0 == g.Ue && this.wb.push(g);
                }
                this.nb();
              }
              Lk(c) {
                this.Ea(new h.fP(c.hierarchy, null, c.G));
              }
              WD(c, d) {
                e.model.C.F.Sm || 32 != c.keyCode && 13 != c.keyCode || this.Ea(new h.gP(0, 0, d));
              }
              clear() {
                this.wb.length = 0;
                this.nb();
              }
              get kb() {
                return 0 == this.wb.length;
              }
            }
            f.Ipa = b;
            class a extends x.Nd {
              constructor(c) {
                let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                super();
                this.I$ = !1;
                this.G.Td();
                this.Ac = c;
                this.I$ = d;
                this.gb(this.Ac.caption);
                this.Gd("fm-ui-btn");
                this.$(h.W.ya.Dq);
                this.$(h.W.ya.gk);
                this.G.attr("title", e.model.B.j.lB);
                this.v$ = new x.Ga("i", h.W.ya.KX);
                this.v$.$(h.W.ya.wJ);
                this.G.append(this.v$);
                this.w$ = new x.Ga("i", h.W.ya.KX);
                this.w$.$(h.W.ya.qJ);
                this.G.append(this.w$);
                this.mU = this.Ac.filter.zh;
                this.I$ && (this.Pj = new x.Vc(), this.Pj.gb(this.yAa()), this.Pj.$("fm-filter-desc"), this.X(this.Pj));
              }
              get hierarchy() {
                return this.Ac;
              }
              get mU() {
                return this.G.Sc("fm-filtered");
              }
              set mU(c) {
                this.G.$a("fm-filtered", c);
              }
              yAa() {
                var c = e.model.B.j.rJ;
                this.hierarchy.filter.zh && (c = 1 == this.hierarchy.cb.length ? this.hierarchy.za(this.hierarchy.cb[0]).caption : e.model.B.j.xJ);
                return c;
              }
            }
            f.iNa = a;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.y6 {
              constructor() {
                super();
                this.Cg = b.TYPE;
                this.$("fm-compact-view");
              }
              Ie() {
                super.Ie();
                this.Twa();
                this.Rba();
                this.Ewa();
              }
              Ewa() {
                this.lh = new f.yla(this.ca);
                this.lh.$("fm-cols-filter");
                this.lh.N(h.vc.wv, a => this.lq(a));
                this.lh.N(h.vc.GJ, a => this.nV(a));
                this.lh.N(h.vc.vt, a => this.Ea(a));
                this.X(this.lh);
              }
              Rba() {
                this.me = new f.s9(this.ca);
                this.me.$("fm-rows-filter");
                this.me.N(h.vc.wv, a => this.lq(a));
                this.me.N(h.vc.bo, a => this.Lk(a));
                this.me.N(h.vc.GJ, a => this.nV(a));
                this.me.N(h.vc.vt, a => this.Ea(a));
                this.X(this.me);
              }
              Twa() {
                this.Vi = new f.Ipa();
                this.Vi.$("fm-page-filter");
                this.Vi.N(h.vc.wv, a => this.lq(a));
                this.Vi.N(h.vc.vt, a => this.Ea(a));
                this.X(this.Vi);
              }
              WG() {
                this.ca.O0 = this.Vi.kb ? 0 : this.Vi.element.offsetHeight;
                super.WG();
                this.me.nb();
              }
              NL() {
                super.NL();
                this.lh.nb();
              }
              o_() {
                this.me.Ly(!0);
                return super.o_() || this.me.HD;
              }
              n_() {
                this.me.Ly(!0);
                return super.n_() || this.me.HD;
              }
              XG() {
                super.XG();
                this.Vi.kb || (this.Vi.top = this.ca.DW, this.Vi.left = 0, this.Vi.right = 0);
                this.ks.top = this.ca.ve;
                this.ks.left = 0;
                this.ks.width = this.ca.tq;
                this.ks.height = this.ca.cr;
                this.me.left = this.ca.ZC(0, !0);
                this.me.top = this.ca.ve + this.ca.lD(0, !0);
                this.lh.top = this.ca.ve + this.ca.lD(this.lh.rowIndex, !0);
                this.lh.left = this.ca.tq;
                this.lh.right = Math.max(0, this.ca.cq - this.ca.$l(this.ca.dj, this.ec));
                this.cs.top = this.HIa() ? this.ca.ve : this.lh.yd();
                this.js.top = this.ca.ve;
                this.nd.left = this.ca.tq;
                this.nd.top = this.ca.ve;
                this.nd.width = this.ca.Ed;
                this.nd.height = this.ca.Ns - this.ca.ve;
                this.ye.left = 0;
                this.ye.top = this.ca.cr + this.ca.ve;
                this.ye.width = this.ca.cq;
                this.ye.height = this.ca.Dd;
                this.Tc.left = this.ca.tq - parseInt(this.Tc.U("border-left-width"));
                this.Tc.top = this.ca.cr + this.ca.ve - parseInt(this.Tc.U("border-top-width"));
                this.Tc.width = this.ca.Ed;
                this.Tc.height = this.ca.Dd;
              }
              HIa() {
                return !(this.lh.visible && !e.model.C.F.Al);
              }
              CS() {
                super.CS();
                this.me.nb();
                this.lh.nb();
              }
              aI() {
                super.aI();
                for (var a = {
                    Ao: g => this.Mba(g),
                    ev: g => this.ev(g)
                  }, c = this.lh.find(".fm-header:not(.fm-empty)", !0), d = 0; d < c.length; d++) c[d].draggable(a);
                c = this.me.find(".fm-header:not(.fm-empty)", !0);
                for (d = 0; d < c.length; d++) c[d].draggable(a);
                c = this.Vi.find(".fm-header:not(.fm-empty)", !0);
                for (d = 0; d < c.length; d++) c[d].draggable(a);
              }
              ev(a) {
                if (a.Sc("fm-drag-remove")) {
                  var c = parseInt(a.attr("data-h"));
                  const d = a.closest(".fm-filters");
                  a = this.slice.clone();
                  d == this.lh ? (c = a.Db.ea(c).A, a.Ka.removeItem(c)) : d == this.me ? (c = a.xb.ea(c).A, a.rows.removeItem(c)) : d == this.Vi && a.ob.K4(c);
                  e.model.Va.R().fe(a);
                }
              }
              Um(a, c, d) {
                d = this.Oda(d);
                if (null == d) this.im();else {
                  var g = this.vAa(d, this.vd);
                  this.im();
                  if (!isNaN(g)) {
                    var l = parseInt(a.attr("data-h")),
                      m = a.closest(".fm-filters");
                    c = this.slice.clone();
                    if (m == this.lh) {
                      var n = c.Db.ea(l);
                      l = c.Ka.indexOf(n.A);
                    } else m == this.me ? (n = c.xb.ea(l), l = c.rows.indexOf(n.A)) : m == this.Vi && (n = c.ob.ea(l), l = c.ob.indexOf(n.A));
                    null != n && (d == m && l < g && g--, d != m || l != g) && (a.Za(), d == m ? d == this.lh ? (g = 0 < c.Ka.length && c.Ka.vT().Ue && g >= c.Ka.length - 1 ? c.Ka.length - 2 : g, c.Ka.l3(l, g)) : d == this.me ? (g = 0 < c.rows.length && c.rows.vT().Ue && g >= c.rows.length - 1 ? c.rows.length - 2 : g, c.rows.l3(l, g)) : d == this.Vi && c.ob.l3(l, g) : (c.Ka.removeItem(n.A), c.rows.removeItem(n.A), c.ob.removeItem(n.A), d == this.lh ? (g = 0 < c.Ka.length && c.Ka.vT().Ue && g >= c.Ka.length ? c.Ka.length - 1 : g, c.Ka.SK(n.A, n, g)) : d == this.me ? (g = 0 < c.rows.length && c.rows.vT().Ue && g >= c.rows.length ? c.rows.length - 1 : g, c.rows.SK(n.A, n, g)) : d == this.Vi && c.ob.SK(n.A, n, g)), 1 < c.Ka.length && c.Ka.ea(0).Ue && (a = c.Ka.ea(0), c.Ka.splice(0, 1), c.Ka.SK(a.A, a, c.Ka.length)), e.model.Va.R().fe(c));
                  }
                }
              }
              vAa(a, c) {
                return a == this.lh ? this.cAa(c) : a == this.me ? this.dea(c) : a == this.Vi ? this.bBa(c) : NaN;
              }
              cAa(a) {
                if (null != a) {
                  a = a.index();
                  if (a > this.slice.Ka.length) return this.slice.Ka.length;
                  var c = this.slice.Ka.indexOf("[Measures]");
                  0 <= c && c <= a && 0 != a && a++;
                  return a;
                }
                return NaN;
              }
              dea(a) {
                if (null != a) {
                  a = a.parent.Sc("fm-filters") ? this.slice.rows.length : (a = a.parent.find(".fm-header")) ? parseInt(a.attr("data-h")) : 0;
                  if (a > this.slice.rows.length) return this.slice.rows.length;
                  var c = this.slice.rows.indexOf("[Measures]");
                  0 <= c && c <= a && 0 != a && a++;
                  return a;
                }
                return NaN;
              }
              bBa(a) {
                return null != a ? (a = a.index(), a > this.slice.ob.length ? this.slice.ob.length : a) : NaN;
              }
              Oda(a) {
                var c = a.closest(".fm-filters");
                if (null == c) {
                  var d = a.closest(".fm-cell");
                  null != d ? (d.attr("data-r"), a = parseInt(d.attr("data-c")), this.aDa(a) ? c = this.lh : this.bDa(a) && (c = this.me)) : (a = a.closest(".fm-resize-handles"), null != a && (a.Sc("fm-cols-resize") ? c = this.lh : a.Sc("fm-rows-resize") && (c = this.me)));
                }
                return c;
              }
              aDa(a) {
                return a >= this.coords.Qd;
              }
              bDa(a) {
                return a <= this.coords.Qd;
              }
              EE(a, c) {
                a = this.Oda(a);
                if (null == a) this.im();else {
                  var d = c.closest(".fm-header:not(.fm-empty)");
                  null != c.closest(".fm-filters") && null != d ? (this.vd = this.xw(), a == this.Vi ? d.before(this.vd) : c.before(this.vd)) : (this.vd = this.xw(), a == this.lh ? this.lh.find(".fm-row").append(this.vd) : a == this.me ? null != c.closest(".fm-filters") ? this.me.find(".fm-header").before(this.vd) : this.Cg == f.nC.KO.TYPE ? this.me.find(".fm-header").parent.append(this.vd) : this.me.append(this.vd) : a == this.Vi && this.Vi.append(this.vd));
                }
              }
              lu() {
                super.lu();
                this.lh.clear();
                this.Vi.clear();
                this.me.clear();
              }
              get aS() {
                return this.lh;
              }
              get Jha() {
                return this.me;
              }
              get Mga() {
                return this.Vi;
              }
              dispose() {
                this.lh.Td();
                this.lh.dispose();
                this.me.Td();
                this.me.dispose();
                this.Vi.Td();
                super.dispose();
              }
            }
            b.TYPE = "compact";
            f.LO = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Ga {
              constructor(a) {
                super("div", "fm-resize-handles");
                this.zK = c => this.tx(c);
                this.Qt = c => this.vr(c);
                this.OB = c => this.ux(c);
                this.LZ = c => this.l4(c);
                this.Uv = new Qa();
                this.ef = a;
                this.ca = a.coords;
                this.element.addEventListener("mousedown", this.zK);
                this.element.addEventListener("touchstart", this.zK);
                e.Hn.addEventListener("mouseup", this.Qt);
                e.Hn.addEventListener("touchend", this.Qt);
                e.Hn.addEventListener("touchcancel", this.Qt);
                this.Wv = new x.Ga("div", "fm-indicator");
                this.Wv.Za();
                this.X(this.Wv);
                this.YB = new x.Ga("div", "fm-wrapper");
                this.YB.attr("title", e.model.B.j.C9);
                this.X(this.YB);
                u.Jd().Rm && this.$("fm-pointer-events-none");
                this.Dg("hidden", "true");
              }
              nb() {
                this.YB.attr("title", e.model.B.j.C9);
              }
              qu(a) {
                this.Uv.tag = "div";
                this.Uv.$("fm-handle");
                this.Uv.attr["data-idx"] = a;
                this.Uv.attr.title = e.model.B.j.Lqa;
                return this.Uv;
              }
              tx(a) {
                if (a.target.classList.contains("fm-handle")) {
                  this.Ov = a.target;
                  this.Ov.classList.add("fm-active");
                  this.sB = this.qg();
                  e.Hn.addEventListener("mousemove", this.OB);
                  e.Hn.addEventListener("touchmove", this.LZ);
                  a.stopImmediatePropagation();
                  var c = parseInt(this.Ov.getAttribute("data-idx"));
                  this.dO(c);
                  a.preventDefault();
                  a.stopImmediatePropagation();
                }
              }
              dO() {}
              vr() {
                e.Hn.removeEventListener("mousemove", this.OB);
                e.Hn.removeEventListener("touchmove", this.LZ);
                if (this.Ov) {
                  this.Ov.classList.remove("fm-active");
                  var a = parseInt(this.Ov.getAttribute("data-idx"));
                  this.eO(this.Ov, a);
                  this.Ov = null;
                  this.Wv.Za();
                }
              }
              eO() {}
              l4(a) {
                a = a.touches[0];
                this.zV(this.Ov, a.clientX - this.sB.left, a.clientY - this.sB.top);
                this.Wv.show();
              }
              ux(a) {
                var c = a.clientX - this.sB.left,
                  d = a.clientY - this.sB.top;
                0 > c || 0 > d || c > this.ca.cq || d > this.ca.Ns ? this.vr(a) : (this.zV(this.Ov, c, d), this.Wv.show());
              }
              zV() {}
              dispose() {
                this.element && this.element.removeEventListener("mousedown", this.zK);
                e.Hn.removeEventListener("mousemove", this.OB);
                e.Hn.removeEventListener("mouseup", this.Qt);
                e.Hn.removeEventListener("touchmove", this.LZ);
                e.Hn.removeEventListener("touchend", this.Qt);
                e.Hn.removeEventListener("touchcancel", this.Qt);
                super.dispose();
              }
            }
            f.q9 = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.q9 {
              nb() {
                super.nb();
                this.YB.xx();
                let a = "";
                for (var c = 0; c < this.ca.ge; c++) a += ab(this.qu(c), !0);
                var d = this.ca.qh;
                for (c = Math.min(this.ca.Jk, this.ca.pz()); d < c; d++) a += ab(this.qu(d), !0);
                this.YB.html(a);
              }
              qu(a) {
                super.qu(a);
                this.Uv.style.top = this.ca.Ko(a, this.ef.ec, !1) + this.ca.Xd(a) + "px";
                return this.Uv;
              }
              dO(a) {
                this.IZ = this.ca.Ko(a, this.ef.ec, !1);
              }
              eO(a, c) {
                a = Math.round(a.offsetTop + a.clientHeight / 2 - this.IZ);
                a = this.ca.$L(a, f.Hh.$E, f.Hh.Pr);
                this.Ya(h.vc.BF, this, {
                  height: a,
                  lb: c
                });
              }
              zV(a, c, d) {
                d = this.ca.$L(d, this.IZ + f.Hh.$E, this.IZ + f.Hh.Pr);
                a.style.top = d + "px";
                this.Wv.top = d;
                this.Wv.width = this.ca.du;
              }
            }
            f.dqa = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.q9 {
              nb() {
                super.nb();
                this.YB.xx();
                let a = "";
                for (var c = 0; c < this.ca.Qd; c++) a += ab(this.qu(c), !0);
                c = Math.min(this.ca.dj, this.ca.YC());
                for (var d = this.ca.pg; d < c; d++) a += ab(this.qu(d), !0);
                this.YB.html(a);
              }
              qu(a) {
                super.qu(a);
                this.Uv.style.left = this.ca.$l(a, this.ef.ec) + this.ca.yh(a) + "px";
                return this.Uv;
              }
              dO(a) {
                this.HZ = this.ca.$l(a, this.ef.ec);
              }
              eO(a, c) {
                a = Math.round(a.offsetLeft + a.clientWidth / 2 - this.HZ);
                a = this.ca.$L(a, f.Hh.aF, f.Hh.Cq);
                this.Ya(h.vc.AF, this, {
                  width: a,
                  mc: c
                });
              }
              zV(a, c) {
                c = this.ca.$L(c, this.HZ + f.Hh.aF, this.HZ + f.Hh.Cq);
                a.style.left = c + "px";
                this.Wv.left = c;
                this.Wv.height = this.ca.Iy;
              }
            }
            f.xla = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(a) {
                this.G$ = !1;
                this.sm = [];
                this.un = [];
                this.Jca = () => this.AFa();
                this.Tba = () => this.zFa();
                this.kda = () => this.BFa();
                this.ef = a;
                this.ca = a.coords;
                this.ef.N(h.vc.bo, c => this.UD(c));
              }
              nb() {
                this.vca(this.Kh);
              }
              set Pha(a) {
                this.gaa = a;
              }
              mia() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                this.G$ = a;
              }
              Yia() {
                this.T4();
                null != this.Kh && (this.Kh.Lg(!0), this.Kh = null);
              }
              UD(a) {
                this.stop();
                this.DCa(a.cell.mc) && a.cell.hi && this.Fca(a.cell);
              }
              DCa(a) {
                return this.G$ || -1 < this.sm.indexOf(a);
              }
              clear() {
                this.sm = [];
                this.un = [];
                this.pd = null;
              }
              Fca(a) {
                !e.model.C.F.OC || null != this.pd && this.pd.lb == a.lb && this.pd.mc == a.mc || (this.pd = a, this.Gxa(), this.ef.W4.nb());
              }
              pta(a) {
                this.pd.label = a + "\n";
              }
              get Uea() {
                return null != this.pd;
              }
              stop() {
                e.model.C.F.OC && (this.Yia(), this.pd = null);
              }
              save(a) {
                if ((e.model.C.F.OC || this.Uea) && null != this.pd) {
                  a = a.replace(/\n/gi, "<br>");
                  if (this.pd.measure.type == e.u.i.Qa.Ta) this.pd.value = Date.parse(a);else if (this.pd.measure.type != e.u.i.Qa.zc) {
                    a = a.replace(/,/gi, ".");
                    a = a.replace(/[^\d|\.|\-]/gi, "");
                    this.pd.value = parseFloat(a);
                    const c = this.pd.measure.ci(this.pd.measure.A, this.pd.measure.aa).clone();
                    this.pd.label = u.cc.format(this.pd.value, c);
                  } else this.pd.label = a;
                  null != this.gaa && this.gaa(this.pd.lb, this.pd.mc, this.pd.measure.type != e.u.i.Qa.zc ? this.pd.value : a);
                  null != this.pd && this.ef.I.bva(this.pd.lb, this.pd.mc);
                }
              }
              Gxa() {
                null != this.pd && this.pd.hi && (null != this.Kh && (this.Kh.Td(), this.Kh.Lg(), this.Kh = null), this.pd.lb < this.ca.lH() || this.pd.mc < this.ca.kH() || this.pd.lb > this.ca.pz() || this.pd.mc > this.ca.YC() || (this.Kh = new x.Lv(), this.Kh.$("fm-editing-cell"), this.ef.$B(this.Kh), this.vca(this.Kh), this.pd.label = this.pd.label.replace(/<br\s*[\/]?>/gi, "\n"), this.Kh.Jj(this.wAa(this.pd)), this.Kh.N(x.Lv.OA, this.Jca), this.Kh.N(x.Lv.pX, this.Tba), this.Kh.N(x.Lv.qX, this.kda), this.Kh.G.focus(), this.Kh.selectAll(), this.Kh.show()));
              }
              wAa(a) {
                return a.measure.type == e.u.i.Qa.zc ? a.label : isNaN(a.value) ? "" : a.measure.type == e.u.i.Qa.Ta ? new Date(a.value).toISOString().substr(0, 10) : a.value.toString();
              }
              vca(a) {
                if (a) {
                  this.pd.lb < this.ca.lH() || this.pd.mc < this.ca.kH() || this.pd.lb > this.ca.pz() || this.pd.mc > this.ca.YC() ? a.Za() : a.show();
                  var c = Math.min(this.ca.yh(this.pd.mc), this.ca.du - this.ca.$l(this.pd.mc, this.ef.ec));
                  a.G.U("left", this.ca.$l(this.pd.mc, this.ef.ec) - 1 + "px");
                  a.G.U("top", this.ca.Ko(this.pd.lb, this.ef.ec) - 1 + "px");
                  a.Tk(c + 1);
                  a.Er(this.ca.Xd(this.pd.lb) + 1);
                }
              }
              AFa() {
                this.wha();
                this.T4();
                var a = this.ef.Xf(this.pd.lb + 1, this.pd.mc);
                this.stop();
                null != a ? (a.lb > this.ca.pz() - 3 && this.ef.Cr(this.ca.qh + 1), this.Fca(a)) : this.stop();
              }
              BFa() {
                this.wha();
                this.T4();
                this.stop();
              }
              zFa() {
                this.Uea && this.pta(this.Kh.Zi());
                this.Kh.Jj(this.pd.label);
              }
              T4() {
                null != this.Kh && this.save(this.Kh.Zi());
                null != this.pd && (this.ef.clearData(), this.ef.nb());
              }
              wha() {
                this.Kh.pb(x.Lv.OA, this.Jca);
                this.Kh.pb(x.Lv.pX, this.Tba);
                this.Kh.pb(x.Lv.qX, this.kda);
              }
            }
            f.hma = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(a) {
                this.focused = null;
                this.ND = !1;
                this.target = a;
                this.target.N("keyup", c => this.vga(c));
                this.target.N("paste", c => this.vga(c));
                this.target.N("focusout", () => this.B3());
              }
              Y_(a) {
                return "<div><input type='text' class='fm-ui-text-input' value='" + ((a.filter.Ku ? a.filter.query.value : "") + "'></div>");
              }
              zx() {
                if (e.model.C.F.Sm && (this.ND = !0, document.activeElement && "input" == document.activeElement.tagName.toLowerCase())) {
                  var a = document.activeElement,
                    c = a.parentElement.parentElement.getAttribute("data-h-name");
                  e.ia(c) ? this.focused = null : this.focused = {
                    Wg: c,
                    selectionStart: a.selectionStart,
                    selectionEnd: a.selectionEnd,
                    value: a.value
                  };
                }
              }
              cA() {
                if (e.model.C.F.Sm) {
                  if (null != this.focused) {
                    var a = this.target.element.querySelector("." + h.W.ya.FJ + '[data-h-name="' + this.focused.Wg + '"] input');
                    a && (a.focus(), a.value = this.focused.value, a.selectionStart = this.focused.selectionStart, a.selectionEnd = this.focused.selectionEnd);
                  }
                  this.ND = !1;
                }
              }
              B3() {
                this.ND || (this.focused = null);
              }
              vga(a) {
                a = a.target;
                var c = a.parentElement.parentElement.getAttribute("data-h-name");
                this.target.Ea(new h.Sna(c, a.value));
              }
            }
            f.OX = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(a) {
                this.focused = null;
                this.ND = !1;
                this.target = a;
                this.target.N("focusin", () => this.zx());
                this.target.N("focusout", () => this.B3());
              }
              zx() {
                if (!e.model.C.F.Sm && (this.ND = !0, document.activeElement && "columnheader" == document.activeElement.getAttribute("role"))) {
                  var a = document.activeElement;
                  const c = a.getAttribute("data-c");
                  this.focused = (a = a.getAttribute("data-r")) || c ? {
                    YOa: c,
                    bt: a
                  } : null;
                }
              }
              cA() {
                if (!e.model.C.F.Sm) {
                  if (null != this.focused) {
                    const a = document.querySelector("." + h.W.ya.Dq + `[data-c="${this.focused.col}"][data-r="${this.focused.row}"]`);
                    a && a.focus();
                  }
                  this.ND = !1;
                }
              }
              B3() {
                this.ND || (this.focused = null);
              }
            }
            f.lna = b;
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends f.LO {
                constructor() {
                  super();
                  this.Cg = a.TYPE;
                  this.Gd("fm-compact-view");
                  this.$("fm-classic-view");
                }
                Rba() {
                  this.me = new b.vla(this.ca);
                  this.me.$("fm-rows-filter");
                  this.me.N(h.vc.wv, c => this.lq(c));
                  this.me.N(h.vc.bo, c => this.Lk(c));
                  this.me.N(h.vc.GJ, c => this.nV(c));
                  this.me.N(h.vc.vt, c => this.Ea(c));
                  this.X(this.me);
                }
                WG() {
                  this.tCa ? super.WG() : (e.Wa(e.model.B.j.Qoa, e.model.B.j.cn, e.tb.cn), e.model.Va.R().wq({
                    gridType: h.se.FA
                  }), e.model.Va.R().refresh());
                }
                get tCa() {
                  return this.ca.Ed > this.ca.sEa;
                }
                dea(c) {
                  var d = this.slice;
                  if (null != c) {
                    c = c.index();
                    if (c > d.rows.length) return d.rows.length;
                    d = d.rows.indexOf("[Measures]");
                    0 <= d && d <= c && 0 != c && c++;
                    return c;
                  }
                  return NaN;
                }
              }
              a.TYPE = "classic";
              b.KO = a;
            })(f.nC || (f.nC = {}));
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends f.s9 {
                constructor(c) {
                  super(c);
                }
                nb() {
                  for (var c = [], d = new Qa(), g = 0; g < this.ca.ge; g++) {
                    d.tag = "div";
                    d.$("fm-row");
                    for (var l = 0; l < this.ca.Qd; l++) d.text = e.model.C.F.jt ? d.text + ab(this.oS(g, l, g == this.ca.ge - 1 ? this.wb[l] : null)) : d.text + ab(this.Vy(g, l));
                    c.push(ab(d));
                  }
                  this.tn.zx();
                  this.html(c.join(""));
                  this.tn.cA();
                }
              }
              b.vla = a;
            })(f.nC || (f.nC = {}));
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends f.y6 {
                constructor() {
                  super();
                  this.cz = this.HB = !1;
                  this.Cg = a.TYPE;
                  this.$("fm-flat-view");
                  this.n$ = new f.hma(this);
                }
                Kba() {
                  this.nd = new b.jna(this.ca, (c, d) => this.Xf(c, d));
                  this.nd.$("fm-cols-sheet");
                  this.nd.qb.element.addEventListener("wheel", this.B_);
                  this.nd.qb.N(bb, () => this.cFa());
                  this.nd.N(h.vc.bo, c => this.Lk(c));
                  this.nd.N(h.vc.wv, c => this.lq(c));
                  this.nd.N(h.vc.GJ, c => this.nV(c));
                  this.nd.N(h.vc.vt, c => this.Ea(c));
                  this.X(this.nd);
                }
                cFa() {
                  this.Tc.qb.scrollLeft = this.nd.qb.scrollLeft;
                }
                Lk(c) {
                  this.cz || super.Lk(c);
                }
                lq(c) {
                  this.cz || super.lq(c);
                }
                XG() {
                  super.XG();
                  this.ks.top = this.ca.ve;
                  this.ks.left = 0;
                  this.ks.width = this.ca.tq;
                  this.ks.height = this.ca.cr;
                  this.nd.left = this.ca.tq;
                  this.nd.top = this.ca.ve;
                  this.nd.width = this.ca.Ed;
                  this.nd.height = this.ca.Ns - this.ca.ve;
                  this.ye.left = 0;
                  this.ye.top = this.ca.cr + this.ca.ve;
                  this.ye.width = this.ca.cq;
                  this.ye.height = this.ca.Dd;
                  this.Tc.left = this.ca.tq - parseInt(this.Tc.U("border-left-width"));
                  this.Tc.top = this.ca.cr + this.ca.ve - parseInt(this.Tc.U("border-top-width"));
                  this.Tc.width = this.ca.Ed;
                  this.Tc.height = this.ca.Dd + parseInt(this.Tc.U("border-top-width"));
                }
                NL() {
                  super.NL();
                  this.n$.nb();
                }
                get QL() {
                  return this.n$;
                }
                get ll() {
                  return this.HB;
                }
                set ll(c) {
                  this.HB = c;
                }
                aI() {
                  if (!this.ll || e.u.Ma.R().fa.iU) {
                    super.aI();
                    for (var c = {
                        Ao: l => this.Mba(l),
                        ev: l => this.ev(l),
                        sx: (l, m) => this.sx(l, m),
                        cV: l => this.cV(l)
                      }, d = this.nd.find(".fm-header", !0), g = 0; g < d.length; g++) d[g].draggable(c);
                  }
                }
                Tea(c) {
                  if (e.v(c)) return !1;
                  c = this.Hu(c.element);
                  return e.v(c) ? !0 : 1 === c.level || void 0 === c.level;
                }
                EE(c, d) {
                  c = d.closest(".fm-cell");
                  this.Tea(c) ? (c = parseInt(c.attr("data-c")), c = Math.min(c, this.coords.Ql), this.vd = this.xw(), this.vd.left = this.coords.$l(c, this.ec) - (c == this.coords.Ql ? 0 : this.vd.width), this.vd.top = this.ca.ve + this.coords.Ko(0, this.ec) - 1, this.vd.height = this.coords.Xd(0) + 1, this.append(this.vd)) : this.im();
                }
                sx(c, d) {
                  return "input" == d.target.tagName.toLowerCase() || 1 < this.Hu(c.element).level ? !1 : !0;
                }
                cV() {
                  this.W4.clear();
                  this.cz = !0;
                }
                ev(c) {
                  setTimeout(() => {
                    this.cz = !1;
                  }, 100);
                  if (c.Sc("fm-drag-remove")) if (this.ll) {
                    var d = parseInt(c.attr("data-c"));
                    this.Ya(h.vc.g7, this, {
                      index: d
                    });
                  } else {
                    d = this.slice.clone();
                    var g = parseInt(c.attr("data-r"));
                    c = parseInt(c.attr("data-c"));
                    const l = (g = this.Xf(g, c)) ? g.hierarchy : null;
                    e.v(l) || (g = d.flatten(!0), g.removeItem(l.A), d.Ka.Bb(l.A) ? d.Ka.removeItem(l.A) : d.rows.Bb(l.A) ? d.rows.removeItem(l.A) : d.ob.Bb(l.A) && d.ob.removeItem(l.A), d.gd().find(m => m.A === l.A) && d.lE(l.A), d.Tg = g.Pc(!0), e.model.Va.R().fe(d));
                  }
                }
                Um(c, d, g) {
                  this.im();
                  var l = g.closest(".fm-cell");
                  if (null != l) {
                    d = parseInt(c.attr("data-c"));
                    g = parseInt(l.attr("data-c"));
                    c = this.Hu(c.element);
                    var m = this.Hu(l.element),
                      n = c.hierarchy ? c.hierarchy.wa.length : 0;
                    g = g > d ? g - (0 < n ? n - 2 : 0) : g;
                    d !== g && (this.ll ? this.Ya(h.vc.f7, this, {
                      iza: d,
                      bLa: g
                    }) : this.Tea(l) && (l = this.slice.clone(), 0 == l.Tg.length && (l.Tg = l.flatten(!0).Pc(!0)), l.RBa && void 0 === c.level && (n = d > g ? 1 : -1, d = l.Tg.indexOf(c.hierarchy.A), g = null === m ? g : l.Tg.indexOf(m.hierarchy.A), g = d === g ? g + n : g), g = Math.max(0, Math.min(g, l.Tg.length)), d < g && g--, e.Ja.j3(l.Tg, d, g), e.model.Va.R().fe(l)));
                  }
                }
              }
              a.TYPE = "flat";
              b.zJ = a;
            })(f.flat || (f.flat = {}));
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            (function (b) {
              class a extends f.Y6 {
                constructor(c, d) {
                  super(c, d);
                  this.N(h.vc.bo, g => this.lq(g));
                  this.N("keydown", g => this.WD(g));
                  this.N("focusin", g => this.A3(g));
                }
                A3(c) {
                  const d = this.qb.content.element.scrollLeft;
                  0 != d ? (this.qb.content.lKa(), this.qb.scrollLeft = this.qb.element.scrollLeft + d) : (c = parseInt(c.target.getAttribute("data-c")), !isNaN(c) && this.ca.ZC(c, this.ec) < this.ca.scrollLeft && (this.qb.scrollLeft -= this.ca.Ed / 2));
                }
                lq(c) {
                  null != c.cell && c.cell.ml && null != c.cell.hierarchy && c.cell.ZB != h.W.Eq.YJ && (e.model.C.F.Sm || this.Ea(new h.fP(c.cell.hierarchy, c.cell)));
                }
                WD(c) {
                  if (!e.model.C.F.Sm && (32 == c.keyCode || 13 == c.keyCode)) {
                    var d = c.target;
                    c = parseInt(d.getAttribute("data-r"));
                    d = parseInt(d.getAttribute("data-c"));
                    isNaN(c) || isNaN(d) || this.Ea(new h.gP(c, d));
                  }
                }
                Vy(c, d) {
                  this.cell = super.Vy(c, d);
                  (c = this.qn ? this.qn(c, d) : null) && c.ml && c.hierarchy.ZM && (e.model.C.F.Sm ? (this.Az(this.cell, c.hierarchy), this.cell.$(h.W.ya.FJ), this.cell.text += this.tn.Y_(c.hierarchy), this.cell.attr["data-h-name"] = c.hierarchy.A) : e.model.C.F.Gx && (this.Az(this.cell, c.hierarchy), this.cell.attr.title = e.model.B.j.lB, this.cell.attr.tabindex = "0", this.cell.text += this.Bo(h.W.ya.wJ)));
                  return this.cell;
                }
                Az(c, d) {
                  c.$(h.W.ya.Dq);
                  d.filter.zh && (c.$(h.W.ya.zX), c.text += this.Bo(h.W.ya.qJ, e.model.B.j.tY));
                }
              }
              b.jna = a;
            })(f.flat || (f.flat = {}));
          })(h.sheet || (h.sheet = {}));
        })(k.Y || (k.Y = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      e = e.K || (e.K = {});
      e = e.od || (e.od = {});
      e = e.Qra || (e.Qra = {});
      e = e.dna || (e.dna = {});
      e[e.DMa = 0] = "DESELECT";
      e[e.EMa = 1] = "DESELECT_ALL";
      e[e.MOa = 2] = "TOGGLE_EXPANDED";
      e[e.NOa = 3] = "TOGGLE_SELECTED";
      e[e.gOa = 4] = "MOVE_UP";
      e[e.bOa = 5] = "MOVE_DOWN";
      e[e.eOa = 6] = "MOVE_TO_ROWS";
      e[e.cOa = 7] = "MOVE_TO_COLUMNS";
      e[e.dOa = 8] = "MOVE_TO_FILTERS";
      e[e.fOa = 9] = "MOVE_TO_VALUES";
      e[e.GMa = 10] = "EDIT_CALCULATED_VALUE";
      e[e.DOa = 11] = "SELECT_AGGREGATION";
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor() {
              super("div");
              this.KU = a => this.U3(a);
              this.list = new x.Ad.rj();
              this.list.pl = !0;
              this.list.ji(this.Yu);
              this.list.vg("caption");
              this.list.Je();
              this.list.N(v.ga.Zd, a => this.fv(a));
              this.X(this.list);
              this.G.Ul();
              this.G.N("keydown", a => {
                27 == a.keyCode && (this.close(), a.stopImmediatePropagation());
              });
              var b = new x.Ga("div", "fm-arrow");
              this.G.X(b);
            }
            Xo(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
              this.origin = a;
              this.VL = b;
              this.Uca = c;
              this.setData(b);
              this.show();
              this.G.N("mouseleave", this.KU);
              e.Hn.addEventListener("mousedown", this.KU);
              b = a.qg(this.G.element.offsetParent);
              this.G.U("right", this.G.element.offsetParent.clientWidth - b.left + "px");
              this.G.U("top", b.top - this.yd() / 2 + a.yd() / 2 + "px");
              this.aw = document.activeElement;
              this.list.focus();
            }
            U3(b) {
              "mousedown" == b.type && this.G.gS(b) || (this.G.pb("mouseleave", this.KU), e.Hn.removeEventListener("mousedown", this.KU), this.close());
            }
            setData(b) {
              let a = 0;
              const c = [];
              for (let d = 0; d < b.Wc.length; d++) {
                const g = {
                  caption: b.fL[d],
                  aa: b.Wc[d]
                };
                void 0 != b.hw && (g.FW = b.hw[d]);
                c.push(g);
                b.Wc[d] == b.aa && (a = d);
              }
              this.list.cg(c);
              this.list.Sk(a);
              this.list.G.Ex(0);
            }
            fv(b) {
              this.close();
              this.Ya(v.ga.Zd, this, {
                VL: this.VL,
                Uca: this.Uca,
                d_: b.data.xl,
                origin: this.origin
              });
            }
            Yu(b, a) {
              var c = new x.Ii.qY();
              c.setData(b);
              c.Ym(a);
              return c;
            }
            close() {
              this.Za();
              this.aw && this.aw.focus({
                preventScroll: !0
              });
            }
          }
          h.XI = f;
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.Nt = this.xn = null;
              }
              update(a, c, d, g) {
                this.ee = a;
                this.Qb = c;
                this.ko = d;
                this.Nt = g;
                this.Ry();
                this.zq();
                this.pO();
              }
              zq() {
                this.ob = this.jD();
                this.rows = this.AH();
                this.Xfa(this.rows);
                this.Ka = this.pH();
                this.Xfa(this.Ka);
                this.Ca = this.gd();
                this.cEa(this.Ca);
                this.y_();
              }
              pO() {
                this.wb = [];
                this.cf = [];
                this.ita(this.wb, this.iH());
                this.hDa && this.XIa(this.wb);
                this.rta(this.wb, this.Gs());
                e.model.C.F.Mia && this.YIa(this.wb);
                this.DI(this.wb);
                if (b.H0) {
                  b.H0 = !1;
                  var a = this.wb.find(c => c.A === "/" + e.model.B.j.J7);
                  null != a && this.Nca(a);
                }
                this.pl(this.ob);
                this.pl(this.Ka);
                this.pl(this.rows);
                this.pl(this.Ca);
              }
              cv(a) {
                if (null != this.ee) {
                  var c = this.Gs().find(g => g.A === a);
                  if (null != c) {
                    c.rg = !0;
                    c.zl = this.Gz;
                    var d = this.Ca.findIndex(g => g.A === a);
                    0 <= d ? (c.j2 = !0, this.Ca[d] = c) : this.Ca.push(c);
                  }
                  this.pO();
                }
              }
              dv(a) {
                if (null != this.Qb && null != this.ee) {
                  const c = this.Ca.findIndex(d => d.A === a);
                  -1 < c && this.Ca.splice(c, 1);
                  this.C5();
                  this.pO();
                }
              }
              y_() {
                this.xn = null;
              }
              C5() {
                this.xn = {
                  pages: this.ob,
                  rows: this.rows,
                  columns: this.Ka,
                  measures: this.Ca
                };
              }
              Xfa(a) {
                a = a.find(c => "[Measures]" === c.A);
                null != a && (a.caption = e.model.B.j.RA, a.AU = !0);
              }
              cEa(a) {
                for (var c = 0; c < a.length; c++) a[c].rg = !0, a[c].zl = e.model.C.F.zl && !a[c].$g;
              }
              pl(a) {
                for (var c, d = 0; d < a.length; d++) {
                  a[d].zd = !0;
                  c = this.dda(a[d].A, a[d].rg);
                  var g = this.Qb.yc().getItem(a[d].A);
                  if (null != c && (this.hj(c, !0), c.bj)) for (var l = 0; l < c.children.length; l++) g.xf == c.children[l].A && this.hj(c.children[l], !0);
                  a[d].bj && null != g.lc && (a[d].caption = a[d].caption + " / " + g.lc.caption);
                }
              }
              hj(a, c) {
                a.zd = c;
                null != a.parent && a.parent.zd != c && (1 == c ? this.hj(a.parent, c) : 0 == this.UBa(a.parent.children) && this.hj(a.parent, c));
                if (a.bj && 0 == c) for (var d = 0; d < a.children.length; d++) this.hj(a.children[d], c);
              }
              UBa(a) {
                for (var c = 0; c < a.length; c++) if (!0 === a[c].zd) return !0;
                return !1;
              }
              kta(a, c) {
                var d = null;
                c = c.split(/[\/\\]/);
                for (var g = "", l = null, m = 0; m < c.length; m++) {
                  var n = c[m];
                  if (!e.ia(n)) {
                    g = g + (e.ia(g) ? "" : "/") + n;
                    var p = "[Folder]." + g;
                    (d = this.cf.find(t => t.A === p)) ? l = d : (d = new h.W.oj(), d.Af = !0, d.A = p, d.caption = n, d.children = [], this.cf.push(d), l ? (d.level = l.level + 1, d.parent = l, l.children.push(d)) : (d.level = 0, a.push(d)), l = d);
                  }
                }
                return d;
              }
              ita(a, c) {
                for (var d, g, l, m = 0; m < c.length; m++) {
                  l = this.ee.mf(c[m].A);
                  var n = null != l && l.type != e.u.i.Qa.zc,
                    p = this.ko == e.u.i.qa.hg || this.ko == e.u.i.qa.API || this.ko == e.u.i.qa.JSON || this.ko == e.u.i.qa.Xh || this.ko == e.u.i.qa.Gq;
                  c[m].kfa = null != l && l.type == e.u.i.Qa.jb;
                  c[m].bx = null != l && l.type == e.u.i.Qa.ic;
                  c[m].zCa = null != l && l.type == e.u.i.Qa.Lc;
                  e.ia(c[m].Oc) || !n && !p ? (d = a.find(t => t.A === c[m].JL), null == d && (d = new h.W.oj(), d.Af = !0, d.A = c[m].JL, d.caption = c[m].TG, d.children = [], d.level = 0, d.description = d.description, a.push(d), this.cf.push(d)), c[m].Yj ? (l = e.ia(c[m].Oc) ? d : g, l = l.children.find(t => t.A === c[m].Wg), c[m].level = l.level + 1, c[m].parent = l, null == l.children && (l.children = []), l.children.push(c[m]), l.bj = !0) : e.ia(c[m].Oc) ? (c[m].level = 1, c[m].parent = d, d.children.push(c[m])) : (g = d.children.find(t => t.A === d.A + c[m].Oc), null == g && (g = new h.W.oj(), g.Af = !0, g.A = d.A + c[m].Oc, g.caption = c[m].Oc, g.children = [], g.level = 1, g.parent = d, g.description = d.description, d.children.push(g), this.cf.push(g)), c[m].level = 2, c[m].parent = g, g.children.push(c[m]))) : (g = c[m].Yj ? this.cf.find(t => t.A === c[m].Wg) : this.cf.find(t => t.A === "[Folder]." + c[m].Oc), null == g && (g = this.kta(a, c[m].Oc)), c[m].level = g.level + 1, c[m].parent = g, e.v(g.children) && (g.children = []), g.children.push(c[m]));
                  this.cf.push(c[m]);
                }
              }
              rta(a, c) {
                for (let l = 0; l < c.length; l++) {
                  c[l].rg = !0;
                  c[l].zl = e.model.C.F.zl && !c[l].$g;
                  c[l].Oa && (c[l].Ig = e.model.B.j.J7);
                  var d = null;
                  if (this.Gz) {
                    var g = this.kja(c[l].A);
                    d = this.cf.find(m => m.A === g && !m.Af);
                  }
                  this.Gz && null != d ? (d.bh = c[l], d.bh.ZT = d, c[l].parent = d.parent) : "" !== c[l].Ig ? (d = this.cf.find(m => m.A === "[Folder]." + c[l].Ig + "/" + c[l].Oc), null == d && (d = this.qta(a, c[l].Ig, c[l].Oc, c[l].$g, c[l].Oa)), c[l].level = d.level + 1, c[l].parent = d, d.children.push(c[l])) : (c[l].level = 0, a.push(c[l]));
                  this.cf.push(c[l]);
                }
              }
              qta(a, c, d) {
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
                let l = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
                var m = null;
                d = d.split(/[\/\\]/);
                d.unshift(c);
                c = "";
                for (var n = null, p = 0; p < d.length; p++) {
                  var t = d[p];
                  if (!e.ia(t)) {
                    c = c + (e.ia(c) ? "" : "/") + t;
                    var r = "[Folder]." + c;
                    m = this.cf.find(w => w.A === r);
                    e.v(m) && 0 == p && (m = this.cf.find(w => w.caption === t)) && !m.Af && (m = null);
                    m ? n = m : (m = new h.W.oj(), m.Af = !0, m.A = r, m.caption = t, m.children = [], m.Uu = !0, m.$g = g, m.NH = l, this.cf.push(m), n ? (m.level = n.level + 1, m.parent = n, n.children.push(m)) : (m.level = 0, a.push(m)), n = m);
                  }
                }
                return m;
              }
              XIa(a) {
                for (var c, d = 0; d < a.length; d++) if (!0 === a[d].Af && 1 == a[d].children.length && !0 !== a[d].children[0].Af && !a[d].children[0].Oa && (c = a[d].children[0], c.level = 0, c.parent = null, a.splice(d, 1, c), c.children)) for (var g = 0; g < c.children.length; g++) --c.children[g].level;
              }
              YIa(a) {
                for (var c = 0; c < a.length; c++) !0 === a[c].Af && !0 !== a[c].NH && (a[c] = this.caa(a[c].children, a[c]));
              }
              caa(a, c) {
                for (var d = 0; d < a.length; d++) !0 === a[d].Af && (a[d] = this.caa(a[d].children, a[d]));
                return 1 == a.length && !0 !== a[0].Af ? (a = a[0], a.level = c.level, a.parent = c.parent, a) : c;
              }
              DI(a) {
                this.ee.Wu || (e.v(this.Nt) ? a.sort((c, d) => {
                  var g = this.rM(c),
                    l = this.rM(d);
                  return g == l ? c.caption.localeCompare(d.caption) : l - g;
                }) : a.sort((c, d) => this.Nt(h.W.oj.EW(c), h.W.oj.EW(d), "pivot")));
              }
              rM(a) {
                return !0 === a.Yj ? 0 : e.model.C.F.Ke ? a.NH ? -1 : 0 : !0 === a.Af && !0 !== a.Uu ? 3 : !0 !== a.Af && !0 !== a.rg ? 2 : !0 === a.Af && !0 === a.Uu ? 1 : 0;
              }
              qba(a) {
                if (!this.Oo) {
                  for (var c = this.wb.indexOf(a) + 1, d = 0; d < a.children.length; d++) !0 === a.children[d].$f && this.qba(a.children[d]);
                  this.wb.splice(c, a.children.length);
                  a.$f = !1;
                }
              }
              Nca(a) {
                if (!this.Oo) {
                  var c = this.wb.indexOf(a) + 1;
                  a.bj && e.v(this.Nt) || this.DI(a.children);
                  e.Ja.insert(this.wb, a.children, c);
                  a.$f = !0;
                }
              }
              kja(a) {
                a = this.ee.Kk(a);
                return null != a ? a.A : "";
              }
              dLa(a) {
                a = this.ee.mf(a);
                return null != a ? a.A : "";
              }
              ph(a) {
                for (var c = 0; c < this.cf.length; c++) if (!this.cf[c].rg && !this.cf[c].Af && this.cf[c].A == a) return this.cf[c];
              }
              fd(a) {
                for (var c = 0; c < this.cf.length; c++) if (this.cf[c].rg && !this.cf[c].Af && this.cf[c].A == a) return this.cf[c];
              }
              dda(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                return c ? this.fd(a) : this.ph(a);
              }
              I2() {
                return 0 < this.Ca.length;
              }
              BM() {
                const a = new h.W.xqa();
                a.ob = this.ob.map(d => h.W.cQ.aT(d));
                a.rows = this.rows.map(d => h.W.cQ.aT(d));
                a.Ka = this.Ka.map(d => h.W.cQ.aT(d));
                a.Ca = this.Ca.map(d => h.W.cQ.aT(d));
                a.Tg = this.Qb ? this.Qb.Tg : [];
                a.Ug = this.Qb ? this.Qb.Ug : [];
                if (this.Qb) {
                  if (this.Qb.hc.Jf) {
                    var c = this.Qb.hc.Sa();
                    void 0 === a.Kj && (a.Kj = {});
                    a.Kj.row = c.sort;
                  }
                  this.Qb.Rb.Jf && (c = this.Qb.Rb.Sa(), void 0 === a.Kj && (a.Kj = {}), a.Kj.column = c.sort);
                }
                return a;
              }
              yU(a) {
                return null == this.Qb ? !0 : this.hU(a.ob, this.Qb.ob.Pc()) || this.hU(a.rows, this.Qb.rows.Pc()) || this.hU(a.Ka, this.Qb.Ka.Pc()) || this.hU(a.Ca, this.Qb.gd());
              }
              hU(a, c) {
                if (a.length != c.length) return !0;
                for (var d = 0; d < c.length; d++) if (a[d].A != c[d].A || a[d].aa != c[d].aa || a[d].xf != c[d].xf || a[d].j2) return !0;
                return !1;
              }
              get Gz() {
                var a = this.ko;
                return a == e.u.i.qa.Xh && !e.model.C.F.Ke || a == e.u.i.qa.Gq && !e.model.C.F.Ke || a == e.u.i.qa.JSON && !e.model.C.F.Ke || a == e.u.i.qa.hg || a == e.u.i.qa.API;
              }
              get lU() {
                for (var a = 0; a < this.wb.length; a++) if ((this.wb[a].Af || this.wb[a].Uu || this.wb[a].bj) && !this.wb[a].$f) return !0;
                return !1;
              }
              get sea() {
                for (var a = 0; a < this.wb.length; a++) if (this.wb[a].Af || this.wb[a].Uu || this.wb[a].bj) return !0;
                return !1;
              }
              pba() {
                if (!this.Oo) {
                  for (var a = 0; a < this.wb.length; a++) if (this.wb[a].Af || this.wb[a].Uu || this.wb[a].bj) this.wb[a].$f = !1;
                  var c = [];
                  for (a = 0; a < this.wb.length; a++) 0 == this.wb[a].level && c.push(this.wb[a]);
                  this.wb.splice(0, this.wb.length);
                  e.Ja.insert(this.wb, c, 0);
                }
              }
              PC() {
                if (!this.Oo) {
                  this.pba();
                  for (var a = 0; a < this.wb.length; a++) (this.wb[a].Af || this.wb[a].bj) && this.bsa(this.wb[a], a + 1);
                }
              }
              bsa(a, c) {
                a.$f = !0;
                null != a.children && 0 < a.children.length && (this.DI(a.children), e.Ja.insert(this.wb, a.children, c));
              }
              jD() {
                return null !== this.xn ? this.xn.pages : null != this.Qb ? this.jS(this.Qb.ob) : [];
              }
              AH() {
                return null !== this.xn ? this.xn.rows : null != this.Qb ? this.jS(this.Qb.rows) : [];
              }
              pH() {
                return null !== this.xn ? this.xn.columns : null != this.Qb ? this.jS(this.Qb.Ka) : [];
              }
              gd() {
                return null !== this.xn ? this.xn.measures : null != this.Qb ? h.W.oj.xL(this.Qb.gd()) : [];
              }
              iH() {
                return null != this.ee ? this.jS(this.ee.yc(!1), !0) : [];
              }
              Gs() {
                return null != this.ee ? h.W.oj.xL(this.ee.Ca.Pc()) : [];
              }
              jS(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                for (var d = [], g = 0; g < a.length; g++) {
                  var l = a.ea(g),
                    m = this.ee.mf(l.A),
                    n = new h.W.oj();
                  c || null == l.lc ? (n.A = l.A, n.caption = l.caption, n.JL = l.zi.A, n.TG = l.zi.caption, n.Oc = l.Oc, n.Yj = !1, n.bj = l.Bf && c) : (n.A = l.lc.A, n.caption = l.lc.caption, n.JL = l.zi.A, n.TG = l.zi.caption, n.Wg = l.A, n.b2 = l.caption, n.Yj = !0, n.bj = !1);
                  n.ax = m ? m.ax() : !1;
                  n.description = l.description;
                  d.push(n);
                  if (l.Bf && c) for (m = 0; m < l.wa.length; m++) if (0 != m) {
                    var p = l.wa.ea(m);
                    n = new h.W.oj();
                    n.A = p.A;
                    n.caption = p.caption;
                    n.JL = l.zi.A;
                    n.TG = l.zi.caption;
                    n.Oc = l.Oc;
                    n.Wg = l.A;
                    n.b2 = l.caption;
                    n.Yj = !0;
                    n.bj = !1;
                    n.ax = !1;
                    n.description = p.description;
                    d.push(n);
                  }
                }
                return d;
              }
              search(a) {
                a = a.toLowerCase();
                if (this.sd != a) {
                  this.sd = a;
                  this.dA = [];
                  for (var c = this.cf.length, d = 0; d < c; d++) {
                    var g = this.cf[d];
                    g.Af || g.rg && this.Gz && !g.Oa || !e.P.contains(g.caption, a) || (g.sd = a, this.xta(g, this.dA), this.dA.push(g));
                  }
                }
              }
              xta(a, c) {
                if (a.parent && 0 > c.indexOf(a.parent)) {
                  for (var d = []; null != a.parent;) d.push(a.parent), a = a.parent;
                  d = d.reverse();
                  for (a = 0; a < d.length; a++) 0 > c.indexOf(d[a]) && c.push(d[a]);
                }
              }
              Ry() {
                this.sd = "";
                this.dA = null;
              }
              get hDa() {
                return e.model.Va.R().Fa.fa.Ba != e.u.i.qa.Cc;
              }
              get Oo() {
                return !e.ia(this.sd);
              }
              get xU() {
                return e.model.C.F.n5 || this.cf && 50 < this.cf.length;
              }
              get FD() {
                return (!e.model.Va.R().Fa.fa.Ic || e.model.Va.R().Fa.fa.Ba === e.u.i.qa.API) && e.model.C.F.i5 || e.model.C.F.iu && e.model.Va.R().Fa.fa.Ba === e.u.i.qa.Cc;
              }
              get bU() {
                return this.FD && !this.Yc.kb;
              }
              get Pa() {
                return this.Oo ? this.dA : this.wb;
              }
              get Yc() {
                return this.ee;
              }
              zE(a) {
                this.Qb = a;
              }
            }
            b.H0 = !1;
            f.g9 = b;
          })(h.Rt || (h.Rt = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends v.Fh {
              constructor(a, c) {
                super();
                this.type = "pivot";
                this.Yv = !1;
                this.ZN = () => {
                  const d = e.u.Ma.R();
                  this.update(d.O, d.pa, d.fa.Ba);
                };
                this.Ny = d => this.cv(d);
                this.Oy = d => this.dv(d);
                this.Py = () => this.oN();
                this.model = new f.g9();
                this.Yv = c;
                this.view = this.Te ? new f.Lpa() : new f.Kpa(this, a);
                this.view.N(v.ga.CLOSED, d => this.Ea(d));
                this.Ad = [this.view.tg, this.view.Cf, this.view.ag, this.view.Ub];
                this.view.Zh && this.view.Zh.N(x.Nd.tf, () => this.XD());
                this.view.Oe && this.view.Oe.N(x.Nd.tf, () => this.Ts());
                null != this.view.ng && this.view.ng.N(v.ga.Zd, d => this.m3(d));
                this.view.fb && (this.view.fb.G.N("click", d => this.G3(d)), this.view.fb.G.N("keydown", d => this.H3(d)), this.view.fb.Ds({
                  Um: d => this.WFa(d),
                  u3: (d, g) => this.yga(d, g),
                  Tm: (d, g) => this.yga(d, g),
                  em: (d, g, l, m) => this.em(d, g, l, m),
                  Iz: "li"
                }), this.view.fb.G.Ul());
                a = {
                  Um: (d, g, l, m) => this.Um(d, g, l, m),
                  Tm: (d, g, l, m) => this.Tm(d, g, l, m),
                  em: (d, g, l, m) => this.em(d, g, l, m),
                  Iz: "li",
                  scroll: !0
                };
                this.view.tg && (this.view.tg.Ds(a), this.view.tg.G.N("dblclick", d => this.eV(d)), this.view.tg.G.N("keydown", d => this.fV(d, this.view.tg)), this.view.tg.G.Ul());
                this.view.Cf && (this.view.Cf.Ds(a), this.view.Cf.G.N("dblclick", d => this.eV(d)), this.view.Cf.G.N("keydown", d => this.fV(d, this.view.Cf)), this.view.Cf.G.Ul());
                this.view.ag && (this.view.ag.Ds(a), this.view.ag.G.N("dblclick", d => this.eV(d)), this.view.ag.G.N("keydown", d => this.fV(d, this.view.ag)), this.view.ag.G.Ul());
                this.view.Ub && (this.view.Ub.G.N("click", d => this.tGa(d)), this.view.Ub.G.N("dblclick", d => this.eV(d)), this.view.Ub.G.N("keydown", d => this.fV(d, this.view.Ub)), this.view.Ub.Ds(a), this.view.Ub.G.Ul());
                this.view.xi && this.view.xi.N(x.Nd.tf, () => this.YU());
                this.view.fC && this.view.fC.N(x.Nd.tf, () => this.YU());
                this.view.eu && this.view.eu.N(x.Nd.tf, () => this.aFa());
                this.view.he && (this.view.he.YV(500), this.view.he.N(x.Oj.Wx, () => this.uN()));
                this.view.pe && (this.view.pe.N("click", () => this.Us()), this.view.pe.N("keydown", d => this.Uz(d, !1)));
                this.view.gj && (this.view.gj.N("click", () => this.Vs()), this.view.gj.N("keydown", d => this.Uz(d, !0)));
              }
              get Te() {
                return this.Yv;
              }
              Ts() {
                this.Te ? e.kh.instance.nL() : this.GG();
              }
              XD() {
                this.fe();
                this.GG();
              }
              Uz(a, c) {
                if (32 === a.keyCode || 13 === a.keyCode) c ? this.Vs() : this.Us();
              }
              Us() {
                this.view.Ye.$("fm-search-opened");
                this.view.he.G.focus();
              }
              Vs() {
                this.view.Ye.Gd("fm-search-opened");
                this.view.he.clear();
                this.view.pe.G.focus();
              }
              uN() {
                this.model.search(this.view.he.Zi());
                this.view.fb.G.$a("fm-searched", this.model.Oo);
                this.view.fb.cg(this.model.Pa);
                this.Sn(this.view.fb);
                this.view.eu && this.view.eu.isVisible(this.model.sea && !this.model.Oo);
              }
              YN() {
                this.Yv && e.u.Ma.R().N(e.u.bK.$J, this.ZN);
              }
              XN() {
                this.Yv && e.u.Ma.R().pb(e.u.bK.$J, this.ZN);
              }
              Qo() {
                this.view.open();
                this.YN();
              }
              GG() {
                this.view.close();
                this.XN();
              }
              fe() {
                var a = this.model.BM();
                this.model.yU(a) && (a = e.u.O.Xr.zb(e.model.hb.wp.zb(a.Sa()), this.model.Yc), this.Te && (a.d3 = !1, e.kh.instance.mE(), this.model.zE(a)), this.XN(), e.model.Va.R().fe(a), this.YN());
              }
              cv(a) {
                e.model.Va.R().pb(k.Oa.fk.BA, this.Ny);
                this.model.cv(a.Os);
                this.$m();
                this.Te && this.fe();
              }
              dv(a) {
                e.model.Va.R().pb(k.Oa.fk.CA, this.Oy);
                this.model.dv(a.Os);
                this.$m();
                this.Te && this.fe();
              }
              oN() {
                this.view.JI = !1;
                e.model.Va.R().pb(k.Oa.fk.DA, this.Py);
                this.view.fb.focus({
                  preventScroll: !0
                });
              }
              YU() {
                this.jI();
              }
              aFa() {
                this.model.lU ? this.model.PC() : this.model.pba();
                this.Sn(this.view.fb);
                this.view.dg();
              }
              eV(a) {
                var c = x.Ga.Xb(a.target).closest("ul");
                null != c && (c = this.Ow(c), a = x.Ga.Xb(a.target).closest("li"), null != a && (a = parseInt(a.attr("data-index")), this.LV(c, a)));
              }
              tGa(a) {
                a = x.Ga.Xb(a.target);
                var c = a.closest("li");
                if (null != c) {
                  c = parseInt(c.attr("data-index"));
                  var d = this.model.Ca[c];
                  a.Sc("fm-aggr-display") ? this.view.ng.Xo(d, a, c) : a.Sc("fm-calc-display") && this.jI(d.A);
                }
              }
              m3(a) {
                this.hA(a.data.VL, a.data.d_);
              }
              hA(a, c) {
                a.aa = c.aa;
                a.caption = e.model.C.F.Fx ? e.P.bind(c.FW, a.name) : a.name;
                this.view.Ub.Jr(a);
                let d = this.model.Pa.find(g => g.A === a.A);
                null != d && (this.model.Gz && null != d.bh && (d = d.bh), d.aa = a.aa, d.caption = a.caption, this.view.fb.Jr(g => g.A === d.A));
                this.Te && this.fe();
              }
              jI() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                this.view.JI = !0;
                e.model.Va.R().Ea(new k.Oa.gX(a));
                e.model.Va.R().N(k.Oa.fk.BA, this.Ny);
                e.model.Va.R().N(k.Oa.fk.DA, this.Py);
                e.ia(a) || e.model.Va.R().N(k.Oa.fk.CA, this.Oy);
              }
              oz(a) {
                const c = [];
                for (let d = 0; d < a.Wc.length; d++) {
                  const g = {
                    caption: a.fL[d],
                    aa: a.Wc[d]
                  };
                  void 0 != a.hw && (g.FW = a.hw[d]);
                  c.push({
                    label: e.u.i.da.tG(a.Wc[d]),
                    isSelected: a.Wc[d] == a.aa,
                    handler: () => this.hA(a, g)
                  });
                }
                return c;
              }
              fV(a, c) {
                if (32 === a.keyCode || 13 === a.keyCode) {
                  if (this.view.Yi) {
                    const d = c.Gu();
                    if (e.v(d)) return;
                    const g = [];
                    !0 !== d.data.AU && g.push({
                      label: e.model.B.j.xX,
                      handler: () => this.Qh(0, d.data, d.index, c)
                    });
                    0 < d.index && g.push({
                      label: e.model.B.j.G7,
                      handler: () => this.Qh(4, d.data, d.index, c)
                    });
                    d.index < c.Bc().length - 1 && g.push({
                      label: e.model.B.j.B7,
                      handler: () => this.Qh(5, d.data, d.index, c)
                    });
                    d.data.rg && !d.data.Oa && g.push({
                      label: e.model.B.j.wX,
                      submenu: this.oz(d.data)
                    });
                    c != this.view.Cf && this.Qu(d.data, c, this.view.Cf) && g.push({
                      label: e.model.B.j.E7,
                      handler: () => this.Qh(6, d.data, d.index, c)
                    });
                    c != this.view.ag && this.Qu(d.data, c, this.view.ag) && g.push({
                      label: e.model.B.j.C7,
                      handler: () => this.Qh(7, d.data, d.index, c)
                    });
                    c != this.view.tg && this.Qu(d.data, c, this.view.tg) && g.push({
                      label: e.model.B.j.D7,
                      handler: () => this.Qh(8, d.data, d.index, c)
                    });
                    c != this.view.Ub && this.Qu(d.data, c, this.view.Ub) && g.push({
                      label: e.model.B.j.F7,
                      handler: () => this.Qh(9, d.data.bh, d.index, c)
                    });
                    d.data.Oa && g.push({
                      label: e.model.B.j.yX,
                      handler: () => this.Qh(10, d.data, d.index),
                      preventFocusRestore: !0
                    });
                    this.view.Yi.Xo(this.view.G, g, d.element.qg(), {
                      top: 10,
                      left: 10
                    });
                  }
                  a.preventDefault();
                }
              }
              H3(a) {
                if (32 === a.keyCode || 13 === a.keyCode) {
                  if (this.view.Yi) {
                    const c = this.view.fb.Gu();
                    if (e.v(c)) return;
                    if (c.data.Af) {
                      this.Qh(2, c.data, c.index);
                      return;
                    }
                    const d = [];
                    c.data.bj && d.push({
                      label: c.data.$f ? e.model.B.j.kma : e.model.B.j.lma,
                      handler: () => this.Qh(2, c.data, c.index)
                    });
                    this.w2(c.data) && d.push({
                      label: e.model.B.j.xX,
                      handler: () => this.Qh(1, c.data, c.index)
                    });
                    this.Qu(c.data, this.view.fb, this.view.Cf) && d.push({
                      label: e.model.B.j.E7,
                      handler: () => this.Qh(6, c.data, c.index, this.view.fb)
                    });
                    this.Qu(c.data, this.view.fb, this.view.ag) && d.push({
                      label: e.model.B.j.C7,
                      handler: () => this.Qh(7, c.data, c.index, this.view.fb)
                    });
                    this.Qu(c.data, this.view.fb, this.view.tg) && d.push({
                      label: e.model.B.j.D7,
                      handler: () => this.Qh(8, c.data, c.index, this.view.fb)
                    });
                    if (this.Qu(c.data, this.view.fb, this.view.Ub)) {
                      const g = {
                        label: e.model.B.j.F7,
                        handler: () => this.Qh(9, c.data.bh, c.index, this.view.fb)
                      };
                      c.data.kfa ? d.splice(this.w2(c.data) ? 1 : 0, 0, g) : d.push(g);
                    }
                    c.data.Oa && d.push({
                      label: e.model.B.j.yX,
                      handler: () => this.Qh(10, c.data, c.index),
                      preventFocusRestore: !0
                    });
                    this.view.Yi.Xo(this.view.G, d, c.element.qg(), {
                      top: 10,
                      left: 10
                    });
                  }
                  a.preventDefault();
                }
              }
              Qh(a, c, d) {
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                1 == a ? (1 == c.zd && (this.model.hj(c, !1), this.Bu(c)), null != c.bh && 1 == c.bh.zd && (this.model.hj(c.bh, !1), this.Bu(c.bh)), this.X5(this.view.fb, d), this.ot(), this.Te && this.fe()) : 0 == a ? (this.LV(g, d), g.Ki(Math.min(d, g.Bc().length - 1))) : 6 == a ? (g == this.view.fb ? this.Ey(g, this.view.Cf, d, this.model.rows.length) : this.Rs(g, this.view.Cf, d, this.model.rows.length), g.Ki(Math.min(d, g.Bc().length - 1))) : 7 == a ? (g == this.view.fb ? this.Ey(g, this.view.ag, d, this.model.Ka.length) : this.Rs(g, this.view.ag, d, this.model.Ka.length), g.Ki(Math.min(d, g.Bc().length - 1))) : 8 == a ? (g == this.view.fb ? this.Ey(g, this.view.tg, d, this.model.ob.length) : this.Rs(g, this.view.tg, d, this.model.ob.length), g.Ki(Math.min(d, g.Bc().length - 1))) : 9 == a ? (g == this.view.fb ? this.Ey(g, this.view.Ub, d, this.model.Ca.length) : this.Rs(g, this.view.Ub, d, this.model.Ca.length), g.Ki(Math.min(d, g.Bc().length - 1))) : 4 == a ? (this.Rs(g, g, d, d - 1), g.Ki(d - 1)) : 5 == a ? (this.Rs(g, g, d, d + 2), g.Ki(d + 1)) : 2 == a ? (c.$f ? this.model.qba(c) : this.model.Nca(c), this.Sn(this.view.fb), this.view.dg()) : 10 == a ? this.jI(c.A) : 11 == a && this.view.ng.Xo(c, null.find(".fm-aggr-display"));
              }
              G3(a) {
                const c = this.view.fb.TC(a.target);
                if (!e.v(c)) if (a = x.Ga.Xb(a.target), a.Sc("fm-aggr-display")) this.view.ng.Xo(c.data, a);else if (a.Sc("fm-calc-display")) this.Qh(10, c.data, c.index);else if (c.data.Af || c.data.bj && !a.Sc("fm-moreicon-display")) this.Qh(2, c.data, c.index);else {
                  if (this.w2(c.data)) 1 == c.data.zd && (this.model.hj(c.data, !1), this.Bu(c.data)), null != c.data.bh && 1 == c.data.bh.zd && (this.model.hj(c.data.bh, !1), this.Bu(c.data.bh));else if (c.data.rg && c.data.ax) {
                    this.model.hj(c.data, !0);
                    a = [];
                    for (var d in c.data) c.data[d] instanceof h.W.oj && a.push(d);
                    d = u.Nc.vj(c.data, a);
                    this.model.Ca.push(d);
                    this.Sn(this.view.Ub);
                  } else if (c.data.bh && c.data.ax && c.data.bh.type != e.u.i.Qa.zc && c.data.bh.type != e.u.i.Qa.Ta) {
                    this.model.hj(c.data.bh, !0);
                    a = [];
                    for (d in c.data.bh) c.data.bh[d] instanceof h.W.oj && a.push(d);
                    d = u.Nc.vj(c.data.bh, a);
                    this.model.Ca.push(d);
                    this.Sn(this.view.Ub);
                  } else {
                    if (c.data.Yj) for (c.data.parent.zd && this.Bu(c.data.parent), d = 0; d < c.data.parent.children.length; d++) a = c.data.parent.children[d], a.A != c.data.A && (a.zd && this.Bu(a), a.zd = !1);
                    this.model.hj(c.data, !0);
                    this.model.rows.push(c.data);
                    this.Sn(this.view.Cf);
                  }
                  this.X5(this.view.fb, c.index);
                  this.ot();
                  this.Te && this.fe();
                }
              }
              X5(a, c) {
                a.nt(c);
                c = a.Bc()[c];
                null != c.parent && this.tO(a, c.parent);
                if (c.bj) for (var d = 0; d < c.children.length; d++) a.Jr(c.children[d]);
                if (c.Yj) for (d = 0; d < c.parent.children.length; d++) a.Jr(c.parent.children[d]);
              }
              tO(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                a.Jr(d || c);
                c.parent && this.tO(a, c.parent);
                if (c.bj) for (d = 0; d < c.children.length; d++) a.Jr(c.children[d]);
                if (c.Yj) for (d = 0; d < c.parent.children.length; d++) a.Jr(c.parent.children[d]);
              }
              sx() {
                return !0;
              }
              WFa(a) {
                if (a && a.closest("ul")) {
                  var c = parseInt(a.attr("data-index"));
                  a = this.Ow(a.closest("ul"));
                  a != this.view.fb && this.LV(a, c);
                }
              }
              yga(a, c) {
                a && a.closest("ul") && (a = this.Ow(a.closest("ul")), a != this.view.fb && (c && c.$("fm-drag-remove"), a.G.Sc("fm-droppable") ? c && c.$("fm-droppable-valid") : c && c.$("fm-droppable-invalid")));
              }
              Tm(a, c, d, g) {
                let l;
                g instanceof MouseEvent ? (l = x.Ga.Xb(g.target), g = g.clientY) : (g = g.changedTouches[0], l = x.Ga.Xb(document.elementFromPoint(g.clientX, g.clientY)), g = g.clientY);
                if (!l.Sc("fm-drop-indicator") && (this.im(), c && (c.Gd("fm-no-drop"), c.Gd("fm-drag-remove")), a && a.closest("ul"))) {
                  d instanceof x.Ad.rj || (d = this.Ow(d));
                  var m = this.Ow(a.closest("ul"));
                  m.G.Sc("fm-droppable") && (this.Qu(this.Cda(a, m), m, d) ? this.EE(l, g) : c.$("fm-no-drop"));
                }
              }
              w2(a) {
                return a.zd || a.bh && a.bh.zd;
              }
              Qu(a, c, d) {
                return a.AU && d != this.view.ag && d != this.view.Cf || !1 === a.ax && d == this.view.Ub || 0 == this.model.Gz && (d != this.view.Ub && (a.rg || a.$g) || d == this.view.Ub && !a.rg && !a.$g) || a.Oa && d != this.view.Ub || a.children && 0 < a.children.length && d == this.view.Ub ? !1 : a.Oa && d == this.view.Ub && c == this.view.Ub ? !0 : a.Oa && d == this.view.Ub ? e.v(this.view.Ub.Bc().find(g => g.A === a.A)) : c == this.view.fb && null != d.Bc().find(g => g.A === a.A) && d != this.view.Ub ? !1 : !0;
              }
              Cda(a, c) {
                a = parseInt(a.attr("data-index"));
                return c.Bc()[a];
              }
              em(a, c) {
                this.im();
                c && (c.Gd("fm-no-drop"), c.Gd("fm-drag-remove"));
                if (a && a.closest("ul") && c) {
                  c.Gd("fm-droppable-valid");
                  c.Gd("fm-droppable-invalid");
                  const d = this.Ow(a.closest("ul"));
                  a.Sc("fm-values") || d == this.view.fb || c.$("fm-drag-remove");
                }
              }
              Um(a, c) {
                if (null != this.vd) if (a && a.closest("ul")) {
                  c = c instanceof x.Ad.rj ? c : this.Ow(c);
                  var d = this.Ow(a.closest("ul"));
                  if (0 == this.Qu(this.Cda(a, d), d, c)) this.im();else {
                    var g = c.Bc().length;
                    this.vd.element.previousElementSibling ? g = parseInt(this.vd.element.previousElementSibling.getAttribute("data-index")) + 1 : this.vd.element.nextElementSibling && (g = parseInt(this.vd.element.nextElementSibling.getAttribute("data-index")));
                    this.im();
                    a = parseInt(a.attr("data-index"));
                    d == this.view.fb && c != this.view.fb ? this.Ey(d, c, a, g) : this.Rs(d, c, a, g);
                    a = c.G.element.scrollTop;
                    this.Mja();
                    c.G.Ex(a);
                    c.MN(g);
                  }
                } else this.im();
              }
              ev(a) {
                if (a && a.closest("ul")) {
                  var c = parseInt(a.attr("data-index"));
                  a = this.Ow(a.closest("ul"));
                  a != this.view.fb && this.LV(a, c);
                }
              }
              EE(a, c) {
                const d = a.closest("li");
                null != d ? (this.vd = this.xw(), a = d.getBoundingClientRect(), c > a.top + .75 * a.height ? d.after(this.vd) : d.before(this.vd)) : (c = a.closest("ul"), null != c && (this.vd = this.xw(), c.append(this.vd)));
              }
              xw() {
                return new x.Ga("div", "fm-drop-indicator");
              }
              im() {
                this.vd && (this.vd.Lg(!0), this.vd = null);
              }
              Rs(a, c, d, g) {
                var l = a.Bc()[d];
                a == c ? (a = c.Bc(), d < g && --g, a.splice(g, 0, a.splice(d, 1)[0])) : (l = a.Bc()[d], a.Bc().splice(d, 1), a.Kr(), c == this.view.Ub && (this.model.hj(l, !1), l = this.model.fd(this.model.dLa(l.Yj ? l.Wg : l.A)), null != l.ZT && this.model.hj(l.ZT, !1)), a == this.view.Ub && (-1 == a.Bc().findIndex(m => m.A === l.A) && this.model.hj(l, !1), l = this.model.ph(this.model.kja(l.A)), null != l.bh && this.model.hj(l.bh, !1)), null != l && (this.model.hj(l, !0), this.Bu(l, null, !0), c.Bc().splice(g, 0, l)));
                this.Sn(c);
                this.ot();
                this.Te && this.fe();
              }
              Ey(a, c, d, g) {
                var l = a.Bc()[d];
                if (l.Yj) {
                  l.parent.zd && this.Bu(l.parent);
                  for (d = 0; d < l.parent.children.length; d++) {
                    var m = l.parent.children[d];
                    m.A != l.A && (m.zd && this.Bu(m), m.zd = !1);
                  }
                  this.tO(this.view.fb, l);
                }
                this.model.Gz && c == this.view.Ub && null != l.bh && (l = l.bh);
                l.zd && !l.rg ? (this.model.hj(l, !1), this.Bu(l, a, !0), this.model.hj(l, !0)) : (this.model.hj(l, !0), a = this.view.fb.Bc().findIndex(p => p.A === l.A), this.X5(this.view.fb, a));
                if (this.model.Gz && c == this.view.Ub && l.rg) {
                  a = [];
                  for (var n in l) l[n] instanceof h.W.oj && a.push(n);
                  l = u.Nc.vj(l, a);
                }
                c.Bc().splice(g, 0, l);
                this.Sn(c);
                this.ot();
                this.Te && this.fe();
              }
              LV(a, c) {
                if (!(a.Bc().length <= c)) {
                  var d = a.Bc()[c];
                  if (!d.AU) {
                    a.Bc().splice(c, 1);
                    this.Sn(a);
                    if (!(d.rg && -1 < this.view.Ub.Bc().findIndex(g => g.A === d.A))) {
                      a = this.model.dda(d.A, d.rg);
                      if (null != a) {
                        this.model.hj(a, !1);
                        const g = null != a.ZT ? a.ZT : a;
                        this.tO(this.view.fb, g, l => l.A === g.A);
                        a.Yj && (this.model.hj(a.parent, !1), this.tO(this.view.fb, a.parent));
                      }
                      this.ot();
                    }
                    this.Te && this.fe();
                  }
                }
              }
              Bu(a) {
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
                for (var g = -1, l = 0; l < this.Ad.length; l++) if (this.Ad[l] != c && (this.Ad[l] != this.view.Ub || !d)) for (var m = !0; m || -1 < g;) m = !1, g = this.Ad[l].Bc().findIndex(n => n.A === a.A || n.Wg === a.A), -1 == g && (g = this.Ad[l].Bc().findIndex(n => n.A === a.A || n.Wg === a.A)), -1 < g && (this.Ad[l].Bc().splice(g, 1), this.Sn(this.Ad[l]));
              }
              Ow(a) {
                return a.element == this.view.fb.G.element ? this.view.fb : a.element == this.view.tg.G.element ? this.view.tg : a.element == this.view.Cf.G.element ? this.view.Cf : a.element == this.view.ag.G.element ? this.view.ag : a.element == this.view.Ub.G.element ? this.view.Ub : null;
              }
              update(a, c) {
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
                g && this.model.update(a, c, d, h.np.OS);
                this.$m(!0);
              }
              ot() {
                this.view.Zh && this.view.Zh.vq(this.model.I2());
              }
              get lU() {
                return this.model.lU;
              }
              $m() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                this.view.reset && this.view.reset();
                this.view.xi && (this.view.xi.isVisible(this.model.FD), this.view.xi.vq(this.model.bU));
                this.view.fC && (this.view.fC.isVisible(this.model.FD), this.view.fC.vq(this.model.bU));
                this.view.fb && this.view.fb.cg(this.model.Pa, !1);
                this.view.tg && this.view.tg.cg(this.model.ob, !1);
                this.view.Cf && this.view.Cf.cg(this.model.rows, !1);
                this.view.ag && this.view.ag.cg(this.model.Ka, !1);
                this.view.Ub && this.view.Ub.cg(this.model.Ca, !1);
                this.view.eu && this.view.eu.isVisible(this.model.sea);
                this.view.Ye && this.view.Ye.isVisible(this.model.xU);
                this.view.he && (this.view.he.clear(!1), this.model.Ry());
                this.view.dg();
                this.view.G.requestAnimationFrame(() => {
                  this.Mja();
                  a && e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.iF));
                });
              }
              Sn(a) {
                a.Kr();
                var c = {
                  sx: g => this.sx(g),
                  Ao: g => this.view.Ao(g)
                };
                u.Jd().Rm && (c.LT = ".fm-drag-handle");
                var d = a.G.find("li", !0);
                if (a == this.view.fb) for (a = 0; a < d.length; a++) d[a].Sc("fm-folder") && !d[a].Sc("fm-level-folder") || d[a].draggable(c);else for (a.Ds({
                  Um: (g, l, m, n) => this.Um(g, l, m, n),
                  Tm: (g, l, m, n) => this.Tm(g, l, m, n),
                  em: (g, l, m, n) => this.em(g, l, m, n),
                  Iz: "li",
                  scroll: !0
                }), c.ev = g => this.ev(g), a = 0; a < d.length; a++) d[a].draggable(c);
              }
              Mja() {
                try {
                  this.ot(), this.Sn(this.view.fb), this.Sn(this.view.tg), this.Sn(this.view.Cf), this.Sn(this.view.ag), this.Sn(this.view.Ub);
                } catch (a) {}
              }
            }
            f.f9 = b;
          })(h.Rt || (h.Rt = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.be.oy {
              constructor(a, c) {
                super(c);
                this.JE = 0;
                this.controller = a;
                this.$("fm-pivot-fields");
                this.Ie();
                this.G.Ul();
                this.G.fj({
                  pW: [x.fj.ri.ni, x.fj.ri.lF, x.fj.ri.DF],
                  hS: k.Nb.Gb.G,
                  f_: !0,
                  resize: d => this.wN(d),
                  complete: () => this.Gp()
                });
              }
              wN(a) {
                a.FE == x.fj.ri.lF || a.FE == x.fj.ri.DF ? (this.Tk(a.size.width + (a.size.width - a.o4.width)), this.Gp()) : a.FE == x.fj.ri.ni && this.Er(a.size.height);
                this.bC();
              }
              Ie() {
                var a = new x.Na("div", "fm-popup-header fm-ui-row");
                this.X(a);
                var c = new x.Na("div", "fm-ui-col fm-vam");
                a.X(c);
                this.ix = new x.Vc(e.model.B.j.Yx);
                this.ix.$("fm-popup-title");
                c.X(this.ix);
                this.hx = new x.Vc(e.model.B.j.L7);
                this.hx.$("fm-popup-subtitle");
                c.X(this.hx);
                c = new x.Na("div", "fm-ui-col fm-vam fm-tar fm-ui-btns-row");
                a.X(c);
                this.xi = new x.Qg("fm-btn-add-measure fm-ui-btn-light fm-icon-act_calc");
                this.xi.gb(e.model.B.j.QA);
                c.X(this.xi);
                this.Oe = new x.Qg();
                this.Oe.gb(e.model.B.j.El);
                this.Zh = new x.Qg("fm-ui-btn-dark");
                this.Zh.gb(e.model.B.j.Tx);
                u.qj.JD || u.qj.No ? (c.X(this.Oe), c.X(this.Zh)) : (c.X(this.Zh), c.X(this.Oe));
                a = new x.Na("div", "fm-popup-content");
                this.X(a);
                var d = new x.Na("div", "fm-ui-row");
                a.X(d);
                c = new x.Na("div", "fm-ui-col-3");
                d.X(c);
                var g = new x.Na("div", "fm-list-wrap fm-list-wrap-all");
                c.X(g);
                var l = new x.Na("div", "fm-list-header fm-list-header-wide");
                g.X(l);
                c = new x.Na("div", "fm-list-header-label-wrap");
                l.X(c);
                this.cN = new x.Vc(e.model.B.j.vv);
                c.X(this.cN);
                this.eu = new x.Nd("fm-ui-link-btn fm-btn-collapse-expand-all");
                this.eu.Gd("fm-ui-btn");
                this.eu.gb(e.model.B.j.H7);
                c.X(this.eu);
                this.Ye = new x.Na("div", "fm-search-wrap");
                l.X(this.Ye);
                this.pe = new x.Na("a", "fm-search-btn");
                this.pe.Je(0);
                this.pe.Rk("button");
                this.Ye.X(this.pe);
                c = new x.Na("span", "fm-ui-icon fm-icon-act_search");
                this.pe.X(c);
                this.he = new x.Oj();
                this.he.$("fm-search-inp");
                this.Ye.X(this.he);
                this.gj = new x.Na("span", "fm-close-search fm-ui-icon fm-icon-act_close");
                this.gj.Je(0);
                this.gj.Rk("button");
                this.Ye.X(this.gj);
                l = new x.Na("div", "fm-list-content");
                g.X(l);
                this.fb = new x.Ad.rj();
                this.fb.Je();
                this.fb.$("fm-lst-hierarchies");
                this.fb.ji((m, n) => this.rE(m, n));
                this.fb.gW(m => m.caption);
                l.X(this.fb);
                c = new x.Na("div", "fm-ui-col-3");
                d.X(c);
                g = new x.Na("div", "fm-list-wrap fm-list-wrap-pages");
                c.X(g);
                l = new x.Na("div", "fm-list-header");
                g.X(l);
                this.eN = new x.Vc(e.model.B.j.Tr);
                l.X(this.eN);
                l = new x.Na("div", "fm-list-content");
                g.X(l);
                this.tg = new x.Ad.rj();
                this.tg.Je();
                this.tg.$("fm-lst-pages");
                this.tg.ji((m, n) => this.Fs(m, n));
                this.tg.vg("caption");
                l.X(this.tg);
                this.IU = new x.Vc(e.model.B.j.Xx);
                this.IU.$("fm-prompt");
                this.IU.ro();
                g.X(this.IU);
                g = new x.Na("div", "fm-list-wrap fm-list-wrap-rows");
                c.X(g);
                l = new x.Na("div", "fm-list-header");
                g.X(l);
                this.fN = new x.Vc(e.model.B.j.jF);
                l.X(this.fN);
                l = new x.Na("div", "fm-list-content");
                g.X(l);
                this.Cf = new x.Ad.rj();
                this.Cf.Je();
                this.Cf.$("fm-lst-rows");
                this.Cf.ji((m, n) => this.Fs(m, n));
                this.Cf.vg("caption");
                l.X(this.Cf);
                this.JU = new x.Vc(e.model.B.j.Xx);
                this.JU.$("fm-prompt");
                this.JU.ro();
                g.X(this.JU);
                c = new x.Na("div", "fm-ui-col-3");
                d.X(c);
                g = new x.Na("div", "fm-list-wrap fm-list-wrap-columns");
                c.X(g);
                l = new x.Na("div", "fm-list-header");
                g.X(l);
                this.bN = new x.Vc(e.model.B.j.hF);
                l.X(this.bN);
                l = new x.Na("div", "fm-list-content");
                g.X(l);
                this.ag = new x.Ad.rj();
                this.ag.Je();
                this.ag.$("fm-lst-columns");
                this.ag.ji((m, n) => this.Fs(m, n));
                this.ag.vg("caption");
                l.X(this.ag);
                this.FU = new x.Vc(e.model.B.j.Xx);
                this.FU.$("fm-prompt");
                this.FU.ro();
                g.X(this.FU);
                g = new x.Na("div", "fm-list-wrap fm-list-wrap-measures");
                c.X(g);
                l = new x.Na("div", "fm-list-header");
                g.X(l);
                this.dN = new x.Vc(e.model.B.j.RA);
                l.X(this.dN);
                this.fC = new x.Qg("fm-btn-add-measure-2 fm-icon-act_calc");
                l.X(this.fC);
                l = new x.Na("div", "fm-list-content");
                g.X(l);
                this.Ub = new x.Ad.rj();
                this.Ub.Je();
                this.Ub.$("fm-lst-measures");
                this.Ub.ji((m, n) => this.Fs(m, n));
                this.Ub.vg("caption");
                l.X(this.Ub);
                this.HU = new x.Vc(e.model.B.j.Xx);
                this.HU.$("fm-prompt");
                this.HU.ro();
                g.X(this.HU);
                this.ng = new h.XI();
                this.ng.$("fm-aggregations-view");
                this.ng.Za();
                a.X(this.ng);
                this.Yi = new x.fr.GF(a.G);
                this.Yi.Za();
                a.X(this.Yi);
              }
              dg() {
                this.ix.gb(e.model.B.j.Yx);
                this.hx.gb(e.model.B.j.L7);
                this.Oe.gb(e.model.B.j.El);
                this.Zh.gb(e.model.B.j.Tx);
                this.cN.gb(e.model.B.j.vv);
                this.eN.gb(e.model.B.j.Tr);
                this.fN.gb(e.model.B.j.jF);
                this.bN.gb(e.model.B.j.hF);
                this.dN.gb(e.model.B.j.RA);
                this.xi.gb(e.model.B.j.QA);
                this.xi.ki(e.model.B.j.QA);
                this.fC.ki(e.model.B.j.QA);
                this.IU.gb(e.model.B.j.Xx);
                this.JU.gb(e.model.B.j.Xx);
                this.FU.gb(e.model.B.j.Xx);
                this.HU.gb(e.model.B.j.Xx);
                this.eu.gb(this.controller.lU ? e.model.B.j.nma : e.model.B.j.H7);
                this.qc(e.model.B.j.Yx);
                this.ix.ro();
                this.hx.ro();
                this.fb.qc(e.model.B.j.vv);
                this.tg.qc(e.model.B.j.Tr);
                this.Cf.qc(e.model.B.j.jF);
                this.ag.qc(e.model.B.j.hF);
                this.Ub.qc(e.model.B.j.RA);
                this.pe.qc(e.model.B.j.XO);
                this.he.qc(e.model.B.j.XO);
                this.gj.qc(e.model.B.j.K7);
              }
              Fs(a, c) {
                var d = new h.Ii.CX();
                d.setData(a);
                d.Ym(c);
                return d;
              }
              rE(a, c) {
                a = new h.Ii.bQ(a, c);
                a.Ym(c);
                return a;
              }
              reset() {
                this.Ye.Gd("fm-search-opened");
                this.he.clear(!1);
              }
              Ao(a) {
                const c = new x.Ga("span");
                c.$("fm-drag-handle");
                c.$("fm-helper");
                c.$("fm-draggable");
                c.$a("fm-values", a.Sc("fm-values"));
                c.U("width", a.U("width"));
                c.U("position", "absolute");
                c.U("z-index", 100);
                c.attr("data-index", a.attr("data-index"));
                const d = new x.Ga("span", "fm-label");
                d.text(a.text());
                c.X(d);
                c.X(new x.Ga("i", "fm-drag-icon"));
                return c;
              }
              bC() {
                super.bC(!0);
              }
            }
            f.Kpa = b;
          })(h.Rt || (h.Rt = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.be.ik {
              constructor() {
                super();
                this.JE = 0;
                this.$("fm-pivot-fields");
                this.$("fm-instant-view");
                this.Ie();
                this.G.Ul();
              }
              Ie() {
                var a = new x.Na("div", "fm-popup-content");
                this.X(a);
                var c = new x.Na("div", "fm-list-wrap fm-list-wrap-all");
                a.X(c);
                var d = new x.Na("div", "fm-list-header fm-list-header-wide");
                c.X(d);
                var g = new x.Na("div", "fm-list-header-label-wrap");
                d.X(g);
                this.cN = new x.Vc(e.model.B.j.vv);
                g.X(this.cN);
                this.xi = new x.Qg("fm-btn-add-measure");
                d.X(this.xi);
                this.Oe = new x.Qg("fm-btn-close-fields");
                d.X(this.Oe);
                d = new x.Na("div", "fm-list-content");
                c.X(d);
                this.fb = new x.Ad.rj();
                this.fb.$("fm-lst-hierarchies");
                this.fb.Je();
                this.fb.ji((l, m) => this.rE(l, m));
                this.fb.vg("caption");
                d.X(this.fb);
                g = new x.Na("div", "fm-ui-row");
                a.X(g);
                d = new x.Na("div", "fm-ui-col-2");
                g.X(d);
                c = new x.Na("div", "fm-list-wrap fm-list-wrap-pages");
                d.X(c);
                d = new x.Na("div", "fm-list-header");
                c.X(d);
                this.eN = new x.Vc(e.model.B.j.Tr);
                d.X(this.eN);
                d = new x.Na("div", "fm-list-content");
                c.X(d);
                this.tg = new x.Ad.rj();
                this.tg.$("fm-lst-pages");
                this.tg.Je();
                this.tg.ji((l, m) => this.Fs(l, m));
                this.tg.vg("caption");
                d.X(this.tg);
                d = new x.Na("div", "fm-ui-col-2");
                g.X(d);
                c = new x.Na("div", "fm-list-wrap fm-list-wrap-columns");
                d.X(c);
                d = new x.Na("div", "fm-list-header");
                c.X(d);
                this.bN = new x.Vc(e.model.B.j.hF);
                d.X(this.bN);
                d = new x.Na("div", "fm-list-content");
                c.X(d);
                this.ag = new x.Ad.rj();
                this.ag.$("fm-lst-columns");
                this.ag.Je();
                this.ag.ji((l, m) => this.Fs(l, m));
                this.ag.vg("caption");
                d.X(this.ag);
                g = new x.Na("div", "fm-ui-row");
                a.X(g);
                c = new x.Na("div", "fm-list-wrap fm-list-wrap-rows");
                g.X(c);
                d = new x.Na("div", "fm-list-header");
                c.X(d);
                this.fN = new x.Vc(e.model.B.j.jF);
                d.X(this.fN);
                d = new x.Na("div", "fm-list-content");
                c.X(d);
                this.Cf = new x.Ad.rj();
                this.Cf.$("fm-lst-rows");
                this.Cf.Je();
                this.Cf.ji((l, m) => this.Fs(l, m));
                this.Cf.vg("caption");
                d.X(this.Cf);
                g = new x.Na("div", "fm-ui-row");
                a.X(g);
                c = new x.Na("div", "fm-list-wrap fm-list-wrap-measures");
                g.X(c);
                d = new x.Na("div", "fm-list-header");
                c.X(d);
                this.dN = new x.Vc(e.model.B.j.RA);
                d.X(this.dN);
                d = new x.Na("div", "fm-list-content");
                c.X(d);
                this.Ub = new x.Ad.rj();
                this.Ub.$("fm-lst-measures");
                this.Ub.Je();
                this.Ub.ji((l, m) => this.Fs(l, m));
                this.Ub.vg("caption");
                d.X(this.Ub);
                this.ng = new h.XI();
                this.ng.$("fm-aggregations-view");
                this.ng.Za();
                a.X(this.ng);
                this.Yi = new x.fr.GF(a.G);
                this.Yi.Za();
                a.X(this.Yi);
              }
              dg() {
                this.cN.gb(e.model.B.j.vv);
                this.eN.gb(e.model.B.j.Tr);
                this.fN.gb(e.model.B.j.jF);
                this.bN.gb(e.model.B.j.hF);
                this.dN.gb(e.model.B.j.RA);
                this.xi.ki(e.model.B.j.QA);
                this.qc(e.model.B.j.Yx);
                this.fb.qc(e.model.B.j.vv);
                this.tg.qc(e.model.B.j.Tr);
                this.Cf.qc(e.model.B.j.jF);
                this.ag.qc(e.model.B.j.hF);
                this.Ub.qc(e.model.B.j.RA);
                this.Oe.qc(e.model.B.j.oJ);
              }
              Fs(a, c) {
                var d = new h.Ii.CX();
                d.setData(a);
                d.Ym(c);
                return d;
              }
              rE(a, c) {
                a = new h.Ii.bQ(a, c);
                a.Ym(c);
                return a;
              }
              Ao(a) {
                const c = new x.Ga("span");
                c.$("fm-drag-handle");
                c.$("fm-helper");
                c.$("fm-draggable");
                c.$a("fm-values", a.Sc("fm-values"));
                c.U("width", a.U("width"));
                c.U("position", "absolute");
                c.U("z-index", 100);
                c.attr("data-index", a.attr("data-index"));
                const d = new x.Ga("span", "fm-label");
                d.text(a.text());
                c.X(d);
                c.X(new x.Ga("i", "fm-drag-icon"));
                return c;
              }
              open() {
                this.show();
                this.Ya(v.ga.OPENED);
              }
              close() {
                this.Za();
                this.Ya(v.ga.CLOSED);
              }
              reset() {}
            }
            f.Lpa = b;
          })(h.Rt || (h.Rt = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor() {
              super();
              this.XR = () => this.vN();
              this.$("fm-fields-view-wrap");
              this.Ie();
            }
            Ie() {
              this.Xs = new x.Qg("fm-btn-open-fields");
              this.Xs.ki(e.model.B.j.hQ);
              this.Xs.qc(e.model.B.j.iF);
              this.Xs.N(x.Nd.tf, () => this.V3());
              this.X(this.Xs);
            }
            updateLabels() {
              this.Xs.ki(e.model.B.j.hQ);
              this.Xs.qc(e.model.B.j.iF);
            }
            open(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
              !this.Te || this.Jea || this.Zea || this.Qea || e.v(this.AK) ? (this.controller && this.controller.pb(v.ga.CLOSED, this.XR), this.close(), this.controller && this.controller.N(v.ga.CLOSED, this.XR), this.G.$a("fm-fields-opened", !0), this.G.$a("fm-fields-instant", this.Te), this.Te && this.G.Er(k.Nb.Gb.zr()), e.model.C.F.Cn = !0, this.controller = this.fAa(), this.controller.update(b, a, c, this.PBa), this.controller.view.$("fm-fields-view"), this.X(this.controller.view), this.isVisible() || this.show(), this.controller.Qo(), !this.controller.view.JI && this.controller.view.fb && this.controller.view.fb.focus({
                preventScroll: !0
              }), k.Nb.Gb.RC = this.Te ? this.controller.view.Zf() : 0, this.Xv = !0, this.AK = e.u.Ma.R().pa ? e.u.Ma.R().pa.clone() : null, this.Ab = e.u.Ma.R().fa, this.lsa = e.u.Ma.R().O && e.u.Ma.R().O.Rd, this.XF = e.model.C.F.tc, this.isa = e.model.C.F.ke == k.Id.kj, this.XF && e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.iF))) : this.G.Er(k.Nb.Gb.zr());
            }
            get Te() {
              return "right" == e.model.C.F.QC;
            }
            get Zea() {
              return this.XF != e.model.C.F.tc || e.model.C.F.tc && this.isa != (e.model.C.F.ke == k.Id.kj);
            }
            get Jea() {
              return this.Xv != e.model.C.F.Cn;
            }
            get Qea() {
              return null == this.Ab || null == e.u.Ma.R().O || this.lsa != e.u.Ma.R().O.Rd || !this.Ab.isEqual(e.u.Ma.R().fa);
            }
            get lDa() {
              return null == e.u.Ma.R().pa && null != this.AK || null != e.u.Ma.R().pa && null == this.AK || e.u.Ma.R().pa && this.AK && !e.u.Ma.R().pa.isEqual(this.AK);
            }
            get PBa() {
              return this.Jea || this.Qea || this.lDa || this.Zea;
            }
            fAa() {
              var b = null,
                a = e.model.C.F.tc && e.model.C.F.ke != k.Id.kj,
                c = k.Nb.Gb.G;
              null == this.controller ? b = a ? new h.flat.DX(c, this.Te) : new h.Rt.f9(c, this.Te) : !a || "flat" == this.controller.type && this.controller.Te == this.Te ? a || "pivot" == this.controller.type && this.controller.Te == this.Te || (b = new h.Rt.f9(c, this.Te)) : b = new h.flat.DX(c, this.Te);
              if (null == b) return this.controller;
              this.controller && this.controller.Td();
              b.N(v.ga.CLOSED, this.XR);
              b.N(f.mJ, d => this.n3(d));
              return b;
            }
            n3(b) {
              this.Ea(b);
            }
            vN() {
              this.Xv = void 0;
              this.Ab = null;
              this.XF = void 0;
              this.controller.pb(v.ga.CLOSED, this.XR);
              e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.oJ));
              e.model.C.F.R();
              e.model.C.F.fS ? this.show() : this.Za();
              e.model.C.F.Cn = !1;
              this.Ya(v.ga.CLOSED);
              this.G.$a("fm-fields-opened", !1);
              this.G.Er("");
            }
            close() {
              this.controller && this.controller.GG();
            }
            V3() {
              this.Ya(f.WO);
            }
            get Vu() {
              return this.Xv;
            }
          }
          f.mJ = "EVENT_APPLY_SLICE";
          f.WO = "EVENT_OPEN";
          h.np = f;
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Ii.nB {
              constructor() {
                super();
                this.BL();
              }
              BL() {
                null == this.cp && (this.cp = new x.Ga("span", "fm-text-display"));
              }
              U_() {
                null == this.gw && (this.gw = new x.Ga("span", "fm-aggr-display"), this.gw.attr("title", e.model.B.j.D9), this.gw.Dg("hidden", "true"));
              }
              V_() {
                null == this.jw && (this.jw = new x.Ga("span", "fm-calc-display"), this.jw.attr("title", e.model.B.j.B9), this.jw.Dg("hidden", "true"));
              }
              W_() {
                null == this.Dw && (this.Dw = new x.Ga("span", "fm-drag-handle"), this.Dw.Dg("hidden", "true"));
              }
              G5(a, c) {
                return null == a ? a : a.replace(new RegExp("(" + c.sd + ")", "i"), '<b class="fm-search-highlight">$&</b>');
              }
              nb() {
                const a = this.getData();
                this.G.empty();
                var c = null != this.gx ? (0, this.gx)(a) : a.Yj ? a.b2 + " / " + a[this.mr()] : a[this.mr()];
                this.cp.html(void 0 !== a.sd ? this.G5(c, a) : c);
                this.cp.attr("title", c + (e.ia(a.description) ? "" : `\n${a.description}`));
                this.qc(c);
                this.G.append(this.cp);
                1 == a.rg && !a.$g && 1 == a.zl && 1 < a.Wc.length && e.model.C.F.zl && (this.U_(), this.G.append(this.gw));
                !0 === a.rg && !0 === a.Oa && (this.V_(), this.G.append(this.jw));
                this.W_();
                this.G.append(this.Dw);
                this.G.$a("fm-measure", !0 === a.rg);
                this.G.$a("fm-values", !0 === a.AU);
                this.G.$a("fm-selected", !0 === a.zd);
                this.G.$a("fm-level", !0 === a.Yj);
              }
            }
            f.CX = b;
          })(h.Ii || (h.Ii = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Ii.nB {
              constructor() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                super();
                this.data = a;
                this.Z_();
                this.BL();
              }
              Z_() {
                null == this.wD && (this.wD = new x.Ga("span", "fm-icon-display"), this.wD.Dg("hidden", "true"));
              }
              Swa() {
                null == this.h3 && (this.h3 = new x.Ga("span", "fm-moreicon-display"), this.h3.Dg("hidden", "true"));
              }
              BL() {
                null == this.cp && (this.cp = new x.Ga("span", "fm-text-display"));
              }
              U_() {
                null == this.gw && (this.gw = new x.Ga("span", "fm-aggr-display"), this.gw.attr("title", e.model.B.j.D9), this.gw.Dg("hidden", "true"));
              }
              V_() {
                null == this.jw && (this.jw = new x.Ga("span", "fm-calc-display"), this.jw.attr("title", e.model.B.j.B9), this.jw.Dg("hidden", "true"));
              }
              W_() {
                null == this.Dw && (this.Dw = new x.Ga("span", "fm-drag-handle"), this.Dw.Dg("hidden", "true"));
              }
              G5(a, c) {
                return null == a ? a : a.replace(new RegExp("(" + c.sd + ")", "i"), '<b class="fm-search-highlight">$&</b>');
              }
              nb() {
                const a = this.getData();
                this.G.empty();
                this.G.append(this.wD);
                a.bj && (this.Swa(), this.G.append(this.h3));
                var c = this.J();
                this.cp.html(void 0 !== a.sd ? this.G5(c, a) : c);
                this.cp.attr("title", this.J() + (e.ia(a.description) ? "" : `\n${a.description}`));
                this.G.append(this.cp);
                !0 === a.rg && !a.$g && !0 !== a.Oa && 1 < a.Wc.length && e.model.C.F.zl && "right" != e.model.C.F.QC && (this.U_(), this.G.$("fm-has-aggs"), this.G.append(this.gw));
                !0 !== a.rg || !0 !== a.Oa || !0 !== a.zl && !e.model.C.F.iu || (this.V_(), this.G.append(this.jw));
                a.Af || a.Uu ? null != this.Dw && this.Dw.remove() : (this.W_(), this.G.append(this.Dw));
                c = !0 === a.zd || null != a.bh && !0 === a.bh.zd;
                for (var d = 1; 10 > d; d++) this.G.$a("fm-level-" + d, a.level === d);
                this.G.$a("fm-selected", !0 === c);
                this.G.$a("fm-checked", !0 !== a.Af && !0 !== a.Yj && !0 === c || 1 == a.Yj && !0 === c);
                this.G.$a("fm-unchecked", !0 !== a.Af && !0 !== a.Yj && !0 !== c || 1 == a.Yj && !0 !== c);
                this.G.$a("fm-measure", a.ax && (!0 === a.rg && !0 !== a.$g || a.kfa || a.bx || a.zCa));
                this.G.$a("fm-folder", !0 === a.Af || !0 === a.bj);
                this.G.$a("fm-level-folder", !0 === a.bj);
                this.G.$a("fm-level", !0 === a.Yj);
                this.G.$a("fm-measures-folder", !0 === a.Uu && !0 !== a.$g);
                this.G.$a("fm-measures-calculated-folder", !0 === a.Uu && !0 !== a.$g && !0 === a.NH);
                this.G.$a("fm-kpis-folder", !0 === a.$g && !0 === a.Af);
                this.G.$a("fm-kpi", !0 === a.$g && !0 !== a.Af);
                this.G.$a("fm-calculated", !0 === a.Oa);
                this.G.$a(k.Y.W.ya.cX, (!0 === a.Af || !0 === a.bj) && !0 !== a.$f);
                this.G.$a(k.Y.W.ya.tX, (!0 === a.Af || !0 === a.bj) && !0 === a.$f);
                this.qc(this.J());
                this.Yaa(!0 === c);
                !0 !== a.Af && !0 !== a.bj || this.Xaa(!0 === a.$f);
              }
            }
            f.bQ = b;
          })(h.Ii || (h.Ii = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              Sa() {
                const d = {};
                e.v(this.ob) || (d.pages = this.ob.map(g => g.Sa()));
                e.v(this.rows) || (d.rows = this.rows.map(g => g.Sa()));
                e.v(this.Ka) || (d.columns = this.Ka.map(g => g.Sa()));
                e.v(this.Ca) || (d.measures = this.Ca.map(g => g.Sa()));
                e.v(this.Tg) || (d.flatOrder = this.Tg.slice());
                e.v(this.Ug) || (d.flatSort = this.Ug.slice());
                e.v(this.Kj) || (d.sorting = this.Kj);
                return d;
              }
            }
            f.xqa = b;
            class a {
              Sa() {
                const d = {};
                e.v(this.A) || (d.uniqueName = this.A);
                e.v(this.aa) || (d.aggregation = this.aa);
                e.v(this.xf) || (d.activeLevelName = this.xf);
                return d;
              }
              static aT(d) {
                const g = new a();
                g.A = d.A;
                d.rg && (g.aa = d.aa, g.j2 = d.j2);
                d.Yj && (g.xf = d.A, g.A = d.Wg);
                return g;
              }
            }
            f.cQ = a;
            class c {
              static xL(d) {
                const g = [];
                for (let l = 0; l < d.length; l++) g.push(c.kS(d[l]));
                return g;
              }
              static EW(d) {
                return d.bj || d.Af ? c.aLa(d) : c.hLa(d);
              }
              static aLa(d) {
                const g = {
                  caption: d.caption,
                  isFolder: !0
                };
                void 0 !== d.NH && d.NH && (g.isCalculated = d.NH);
                void 0 !== d.Uu && (g.isMeasureFolder = d.Uu);
                e.v(d.parent) || (g.folder = void 0 !== d.TG ? d.TG : d.parent.caption);
                void 0 !== d.$g && d.$g && (g.isKPI = d.$g);
                return g;
              }
              static hLa(d) {
                const g = {
                  caption: d.caption,
                  isFolder: !1
                };
                void 0 !== d.Oa && d.Oa && (g.isCalculated = d.Oa);
                void 0 !== d.$g && d.$g && (g.isKPI = d.$g);
                void 0 !== d.Ig && void 0 !== d.Oc && d.$g ? g.folder = d.Ig + "/" + d.Oc : void 0 !== d.Ig ? g.folder = d.Ig : void 0 !== d.Oc && 0 < d.Oc.length ? g.folder = d.Oc : !e.v(d.parent) && d.parent.Yj ? g.folder = d.b2 : e.v(d.parent) || (g.folder = d.TG);
                return g;
              }
              static kS(d) {
                const g = d.Wc,
                  l = new f.oj();
                l.A = d.A;
                l.caption = d.caption;
                l.name = d.rl;
                l.type = d.type;
                l.aa = d.aa;
                l.Oa = d.Oa;
                l.Oc = d.Oc;
                l.Ig = d.Ig;
                l.qr = d.qr;
                l.$g = d.$g;
                l.Wc = g;
                l.fL = e.u.i.da.e_(g);
                l.hw = e.u.i.da.Naa(g);
                l.ax = d.ax();
                l.description = d.description;
                return l;
              }
            }
            f.oj = c;
          })(h.W || (h.W = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor(a) {
                this.eqa = 40;
                this.Nt = null;
                this.ko = a;
              }
              get Yc() {
                return this.ee;
              }
              set Yc(a) {
                this.ee = a;
              }
              get Pa() {
                return this.Oo ? this.dA : this.wb;
              }
              set Pa(a) {
                this.wb = a;
              }
              I2() {
                return 0 < this.wBa().length;
              }
              Ry() {
                this.sd = "";
                this.dA = null;
              }
              get xU() {
                return (e.model.C.F.n5 || this.Pa && this.Pa.length > this.eqa) && this.ko != e.u.i.qa.Cc;
              }
              get Oo() {
                return !e.ia(this.sd);
              }
              search(a) {
                a = a.toLowerCase();
                if (this.sd != a) {
                  this.sd = a;
                  this.dA = [];
                  for (var c = 0; c < this.wb.length; c++) {
                    var d = this.wb[c];
                    e.P.contains(d.caption, a) && (d.sd = this.sd, this.dA.push(d));
                  }
                }
              }
              E1() {
                for (var a = 0, c = 0; c < this.Pa.length; c++) this.Pa[c].zd && a++;
                return 0 == a ? 0 : a == this.Pa.length ? 1 : -1;
              }
              wBa() {
                const a = [];
                if (!e.v(this.wb)) for (let c = 0; c < this.wb.length; c++) this.wb[c].zd && a.push(this.wb[c]);
                return a;
              }
              get FD() {
                return (!e.model.Va.R().Fa.fa.Ic || e.model.Va.R().Fa.fa.Ba === e.u.i.qa.API) && e.model.C.F.i5 || e.model.C.F.iu && e.model.Va.R().Fa.fa.Ba === e.u.i.qa.Cc;
              }
              get bU() {
                return this.FD && !this.Yc.kb;
              }
              DI(a, c) {
                if (0 !== c.length || !e.v(this.Nt)) if (e.v(this.Nt)) a.sort((d, g) => this.ica(d, g, c));else {
                  const d = [];
                  let g = [];
                  if (0 < c.length) {
                    for (let m = 0; m < a.length; m++) a[m].zd ? d.push(a[m]) : g.push(a[m]);
                    d.sort((m, n) => this.ica(m, n, c));
                  } else g = a;
                  const l = this.xAa();
                  g.sort((m, n) => this.Nt(h.W.oj.EW(m), h.W.oj.EW(n), l));
                  this.Pa = [...d, ...g];
                }
              }
              xAa() {
                return this instanceof f.X7 ? "flat" : "drillThrough";
              }
              ica(a, c, d) {
                const g = this.rM(a, d);
                d = this.rM(c, d);
                return g == d ? a.caption.localeCompare(c.caption) : d - g;
              }
              rM(a, c) {
                return a.zd ? c.length - c.indexOf(a.A) : 0;
              }
              pl(a) {
                for (var c = 0; c < this.Pa.length; c++) this.Pa[c].zd = 0 <= a.indexOf(this.Pa[c].A);
              }
              AAa(a) {
                return this.eLa(this.Pa, a);
              }
              eLa(a, c) {
                for (var d = [], g = 0; g < c.length; g++) {
                  var l = a[c[g]];
                  l.zd && d.push({
                    A: l.A,
                    aa: l.aa
                  });
                }
                return d;
              }
              mja(a, c) {
                for (var d = [], g = 0; g < c.length; g++) {
                  var l = a[c[g]];
                  l.zd && d.push(l);
                }
                return d;
              }
            }
            f.x6 = b;
          })(h.flat || (h.flat = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.x6 {
              constructor(a) {
                super(a);
                this.xn = null;
              }
              update(a, c, d) {
                this.ee = a;
                this.Qb = c;
                this.Nt = d;
                this.pO();
                this.zq();
              }
              pO() {
                this.Pa = [];
                for (var a = this.ee.yc(!1), c = 0; c < a.length; c++) {
                  var d = a.ea(c),
                    g = this.ee.mf(d.A);
                  e.v(g) || g.type == e.u.i.Qa.zc || g.type == e.u.i.Qa.Ta || this.Qb.rows.Bb(g.A) || this.Qb.Ka.Bb(g.A) || this.Qb.ob.Bb(g.A) ? this.Pa.push(this.lwa(d)) : this.Pa.push(this.kS(g));
                }
                a = this.ee.$q;
                for (c = 0; c < a.length; c++) g = a.ea(c), this.Pa.push(this.kS(g));
              }
              zq() {
                if (null !== this.xn) this.Pa = this.xn.hierarchies, this.y_();else {
                  var a = this.Qb.flatten(!0, !0).Pc(!0);
                  this.pl(a);
                  this.SJa(this.Qb.gd());
                  this.DI(this.Pa, a);
                }
              }
              SJa(a) {
                for (var c = 0; c < a.length; c++) {
                  var d = this.Gya(a[c].A);
                  e.v(d) || (d.aa = a[c].aa);
                }
              }
              Gya(a) {
                for (var c = 0; c < this.wb.length; c++) if (this.wb[c].A == a) return this.wb[c];
                return null;
              }
              kS(a) {
                var c = new h.W.oj();
                c.A = a.A;
                c.caption = a.rl;
                c.aa = a.aa;
                c.Oa = a.Oa;
                a = a.Wc;
                c.Wc = a;
                c.fL = e.u.i.da.e_(a);
                c.hw = e.u.i.da.Naa(a);
                c.rg = !0;
                c.zl = e.model.C.F.zl;
                return c;
              }
              lwa(a) {
                var c = new h.W.oj();
                c.A = a.A;
                c.caption = a.caption;
                return c;
              }
              BM(a) {
                var c = this.Qb.clone(),
                  d = this.mja(this.Pa, a),
                  g = d.map(r => r.A),
                  l = c.flatten(!0, !0);
                a = c.gd();
                for (var m = 0; m < l.length; m++) {
                  var n = l.ea(m).A;
                  if (0 > g.indexOf(n)) {
                    c.ob.Bb(n) && c.ob.removeItem(n);
                    c.Ka.Bb(n) && c.Ka.removeItem(n);
                    c.rows.Bb(n) && c.rows.removeItem(n);
                    let r = this.ee.mf(n);
                    e.v(r) && (r = this.ee.$q.getItem(n));
                    e.v(r) || (n = a.findIndex(w => w.A === r.A), -1 < n && a.splice(n, 1));
                  }
                }
                for (m = 0; m < d.length; m++) if (n = d[m].A, !l.Bb(n)) {
                  var p = this.ee.ph(n),
                    t = this.ee.fd(n);
                  e.v(t) || e.v(p) || t.type == e.u.i.Qa.zc || p.type == e.u.i.Fc.Ta ? e.v(p) ? this.ee.$q.Bb(n) && a.push(this.ee.$q.getItem(n)) : c.rows.Ua(n, p) : a.push(t);
                }
                for (m = 0; m < d.length; m++) if (l = d[m], l.aa) for (n = 0; n < a.length; n++) a[n].A == l.A && (a[n].aa = l.aa);
                c.Tg = g;
                for (d = 0; d < a.length; d++) a[d].index = d;
                c.iA(a);
                return c;
              }
              Gs() {
                return null != this.ee ? h.W.oj.xL(this.ee.Ca.Pc()) : [];
              }
              cv(a) {
                if (null != this.Qb && null != this.ee) {
                  const c = this.Gs().find(d => d.A === a);
                  if (null != c) {
                    c.zd = !0;
                    let d = 0;
                    for (let g = 0; g < this.Pa.length; g++) this.Pa[g].zd && (d = g);
                    this.Pa = [...this.Pa.slice(0, d + 1), c, ...this.Pa.slice(d + 1)];
                  }
                }
              }
              dv(a) {
                if (null != this.Qb && null != this.ee) {
                  const c = this.Pa.findIndex(d => d.A === a);
                  this.Pa.splice(c, 1);
                  this.C5();
                }
              }
              y_() {
                this.xn = null;
              }
              C5() {
                this.xn = {
                  hierarchies: this.Pa
                };
              }
              yU(a) {
                var c = this.Qb.flatten(!0, !0).Pc();
                if (a.length != c.length) return !0;
                for (var d = 0; d < a.length; d++) {
                  var g = a[d],
                    l = c[d];
                  if (g.A != l.A || void 0 != g.aa && void 0 != l.aa && g.aa != l.aa) return !0;
                }
                return !1;
              }
              zE(a) {
                this.Qb = a;
              }
            }
            f.X7 = b;
          })(h.flat || (h.flat = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends v.Fh {
              constructor(a, c) {
                super();
                this.type = "flat";
                this.Yv = !1;
                this.ZN = () => {
                  const d = e.u.Ma.R();
                  this.update(d.O, d.pa, d.fa.Ba);
                };
                this.Ny = d => this.cv(d);
                this.Oy = d => this.dv(d);
                this.Py = () => this.oN();
                this.Hb = this.qS(e.u.Ma.R().fa.Ba);
                this.Yv = c;
                this.view = this.Sba(a);
                this.view.N(v.ga.CLOSED, d => this.Ea(d));
                this.view.Zh && this.view.Zh.N(x.Nd.tf, () => this.XD());
                this.view.Oe && this.view.Oe.N(x.Nd.tf, () => this.Ts());
                null != this.view.ng && this.view.ng.N(v.ga.Zd, d => this.m3(d));
                this.view.fb && (this.view.fb.G.N("click", d => this.G3(d)), this.view.fb.G.N("keydown", d => this.H3(d)), this.view.fb.G.Ds({
                  Um: (d, g, l, m) => this.Um(d, g, l, m),
                  Tm: (d, g, l, m) => this.Tm(d, g, l, m),
                  em: (d, g, l, m) => this.em(d, g, l, m),
                  Iz: "li",
                  scroll: !0
                }));
                this.view.Yd && this.view.Yd.N(v.ga.Zd, () => this.i4());
                this.view.xi && this.view.xi.N(x.Nd.tf, () => this.YU());
                this.view.he && (this.view.he.YV(500), this.view.he.N(x.Oj.Wx, () => this.uN()));
                this.view.pe && (this.view.pe.N("click", () => this.Us()), this.view.pe.N("keydown", d => this.Uz(d, !1)));
                this.view.gj && (this.view.gj.N("click", () => this.Vs()), this.view.gj.N("keydown", d => this.Uz(d, !0)));
              }
              get Te() {
                return this.Yv;
              }
              Sba(a) {
                return this.Te ? new f.kna() : new f.Y7(a);
              }
              qS(a) {
                return new f.X7(a);
              }
              Uz(a, c) {
                if (32 === a.keyCode || 13 === a.keyCode) c ? this.Vs() : this.Us();
              }
              Us() {
                this.view.Ye.$("fm-search-opened-flat");
                this.view.he.G.focus();
              }
              Vs() {
                this.view.Ye.Gd("fm-search-opened-flat");
                this.view.he.clear();
                this.view.pe.G.focus();
              }
              Tm(a, c, d, g) {
                g instanceof MouseEvent ? (d = x.Ga.Xb(g.target), g = g.clientY) : (g = g.changedTouches[0], d = x.Ga.Xb(document.elementFromPoint(g.clientX, g.clientY)), g = g.clientY);
                d.Sc("fm-drop-indicator") || (this.im(), a && a.closest("ul") && (c && c.$("fm-droppable-valid"), a.$("fm-drag-over"), this.EE(d, g)));
              }
              em(a, c) {
                this.im();
                a && a.closest("ul") && (c && c.Gd("fm-droppable-valid"), c && c.Gd("fm-droppable-invalid"), a.Gd("fm-drag-over"));
              }
              uN() {
                this.Hb.search(this.view.he.Zi());
                this.view.fb.G.$a("fm-searched", this.Hb.Oo);
                this.view.fb.cg(this.Hb.Pa);
                this.TL();
              }
              m3(a) {
                this.hA(a.data.VL, a.data.d_);
              }
              hA(a, c) {
                a.aa = c.aa;
                a.caption = a.name;
                this.view.fb.Jr(a);
                c = this.Hb.Pa.find(d => d.A === a.A);
                null != c && (c.aa = a.aa, c.caption = a.caption);
                this.Te && this.fe();
              }
              Um(a) {
                if (null != this.vd) if (a && a.closest("ul")) {
                  a = parseInt(a.attr("data-index"));
                  var c = this.view.fb.Bc()[a],
                    d = this.view.fb.Bc().length;
                  this.vd.element.previousElementSibling ? d = parseInt(this.vd.element.previousElementSibling.getAttribute("data-index")) + 1 : this.vd.element.nextElementSibling && (d = parseInt(this.vd.element.nextElementSibling.getAttribute("data-index")));
                  this.im();
                  this.Rs(a, d);
                  this.view.fb.Ki(this.view.fb.Bc().indexOf(c));
                  this.view.fb.G.Ex(this.view.fb.G.element.scrollTop);
                  this.view.fb.MN(d);
                } else this.im();
              }
              Rs(a, c) {
                if (a != c) {
                  var d = this.view.fb.Bc();
                  a < c && --c;
                  d.splice(c, 0, d.splice(a, 1)[0]);
                  this.view.fb.Kr();
                  this.ot();
                  this.TL();
                  this.Te && this.fe();
                }
              }
              YN() {
                this.Yv && e.u.Ma.R().N(e.u.bK.$J, this.ZN);
              }
              XN() {
                this.Yv && e.u.Ma.R().pb(e.u.bK.$J, this.ZN);
              }
              Qo() {
                this.view.open();
                this.YN();
              }
              GG() {
                this.view.close();
                this.XN();
              }
              Ts() {
                this.Te ? e.kh.instance.nL() : this.GG();
              }
              XD() {
                this.view.he && this.Hb.Oo && (this.view.he.clear(!1), this.Hb.Ry(), this.view.fb.cg(this.Hb.Pa), this.TL());
                this.fe();
                this.GG();
              }
              i4() {
                for (var a = this.view.Yd.checked, c = this.Hb.Pa, d = 0; d < c.length; d++) c[d].zd = a;
                this.view.fb.Kr();
                this.ot();
                this.TL();
                this.Te && this.fe();
              }
              H3(a) {
                if (32 === a.keyCode || 13 === a.keyCode) {
                  if (this.view.Yi) {
                    const c = this.view.fb.Gu();
                    if (e.v(c)) return;
                    const d = [];
                    d.push({
                      label: c.data.zd ? e.model.B.j.xX : e.model.B.j.mma,
                      handler: () => this.Qh(3, c.data, c.index)
                    });
                    0 < c.index && d.push({
                      label: e.model.B.j.G7,
                      handler: () => this.Qh(4, c.data, c.index)
                    });
                    c.index < this.view.fb.Bc().length - 1 && d.push({
                      label: e.model.B.j.B7,
                      handler: () => this.Qh(5, c.data, c.index)
                    });
                    c.data.rg && d.push({
                      label: e.model.B.j.wX,
                      submenu: this.oz(c.data)
                    });
                    c.data.Oa && d.push({
                      label: e.model.B.j.yX,
                      handler: () => this.Qh(10, c.data, c.index)
                    });
                    this.view.Yi.Xo(this.view.G, d, c.element.qg(), {
                      top: 10,
                      left: 10
                    });
                  }
                  a.preventDefault();
                }
              }
              oz(a) {
                const c = [];
                for (let d = 0; d < a.Wc.length; d++) {
                  const g = {
                    caption: a.fL[d],
                    aa: a.Wc[d]
                  };
                  void 0 != a.hw && (g.FW = a.hw[d]);
                  c.push({
                    label: e.u.i.da.tG(a.Wc[d]),
                    isSelected: a.Wc[d] == a.aa,
                    handler: () => this.hA(a, g)
                  });
                }
                return c;
              }
              Qh(a, c, d) {
                3 == a ? (c.zd = !c.zd, this.view.fb && this.view.fb.nt(d), this.view.Yd && this.view.Yd.Gf(this.Hb.E1()), this.ot(), this.Te && this.fe()) : 4 == a ? (this.Rs(d, d - 1), this.view.fb.Ki(d - 1)) : 5 == a ? (this.Rs(d, d + 2), this.view.fb.Ki(d + 1)) : 10 == a && this.jI(c.A);
              }
              G3(a) {
                const c = this.view.fb.TC(a.target);
                e.v(c) || (a = x.Ga.Xb(a.target), a.Sc("fm-aggr-display") ? this.view.ng.Xo(c.data, a) : a.Sc("fm-calc-display") ? this.Qh(10, c.data, c.index) : this.Qh(3, c.data, c.index));
              }
              jI() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                this.view.JI = !0;
                e.model.Va.R().Ea(new k.Oa.gX(a));
                e.model.Va.R().N(k.Oa.fk.DA, this.Py);
                e.model.Va.R().N(k.Oa.fk.BA, this.Ny);
                e.model.Va.R().N(k.Oa.fk.CA, this.Oy);
              }
              YU() {
                this.jI();
              }
              cv(a) {
                e.model.Va.R().pb(k.Oa.fk.BA, this.Ny);
                this.Hb.cv(a.Os);
                this.$m();
                this.Te && this.fe();
              }
              dv(a) {
                e.model.Va.R().pb(k.Oa.fk.CA, this.Oy);
                this.Hb.dv(a.Os);
                this.$m();
                this.Te && this.fe();
              }
              oN() {
                this.view.JI = !1;
                e.model.Va.R().pb(k.Oa.fk.DA, this.Py);
                this.view.fb.focus({
                  preventScroll: !0
                });
              }
              $m() {
                this.view.reset && this.view.reset();
                this.view.Ye && this.view.Ye.isVisible(this.Hb.xU);
                this.view.he && (this.view.he.clear(!1), this.Hb.Ry());
                this.view.fb && (this.view.fb.cg(this.Hb.Pa), this.ot(), this.TL());
                this.view.xi && (this.view.xi.isVisible(this.Hb.FD), this.view.xi.vq(this.Hb.bU));
              }
              TL() {
                var a = {
                  Ao: g => this.view.Ao(g)
                };
                u.Jd().Rm && (a.LT = ".fm-drag-handle");
                for (var c = this.view.fb.G.find("li", !0), d = 0; d < c.length; d++) c[d].draggable(a);
              }
              update(a, c) {
                e.v(a) || e.v(c) || (this.Hb.update(a, c, h.np.OS), this.$m(), this.view.Yd && this.view.Yd.Gf(this.Hb.E1()), this.view.dg());
              }
              ot() {
                this.view.Zh && this.view.Zh.vq(this.Hb.I2());
              }
              fe() {
                for (var a = [], c = this.view.fb.G.find("li", !0), d = 0; d < c.length; d++) {
                  var g = parseInt(c[d].attr("data-index"));
                  a.push(g);
                }
                c = this.Hb.AAa(a);
                this.Hb.yU(c) && (a = this.Hb.BM(a), this.Te && a instanceof e.u.O.Xr && (a.d3 = !1, e.kh.instance.mE(), this.Hb.zE(a)), this.XN(), e.model.Va.R().fe(a), this.YN());
              }
              EE(a, c) {
                const d = a.closest("li");
                null != d ? (this.vd = this.xw(), a = d.getBoundingClientRect(), c > a.top + a.height / 2 ? d.after(this.vd) : d.before(this.vd)) : (c = a.closest("ul"), null != c && (this.vd = this.xw(), c.append(this.vd)));
              }
              xw() {
                return new x.Ga("div", "fm-drop-indicator");
              }
              im() {
                this.vd && (this.vd.Lg(!0), this.vd = null);
              }
            }
            f.DX = b;
          })(h.flat || (h.flat = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.be.oy {
              constructor(a) {
                super(a);
                this.$("fm-flat-fields");
                this.Ie();
                this.G.Ul();
                this.G.fj({
                  pW: [x.fj.ri.ni],
                  hS: k.Nb.Gb.G,
                  f_: !0,
                  resize: c => this.wN(c),
                  complete: () => this.Gp()
                });
              }
              wN(a) {
                a.FE == x.fj.ri.ni && this.Er(a.size.height);
              }
              Ie() {
                var a = new x.Na("div", "fm-popup-header fm-ui-row");
                this.X(a);
                var c = new x.Na("div", "fm-ui-col fm-vam");
                a.X(c);
                this.ix = new x.Vc(e.model.B.j.Yx);
                this.ix.$("fm-popup-title");
                c.X(this.ix);
                this.hx = new x.Vc(e.model.B.j.I7);
                this.hx.$("fm-popup-subtitle");
                c.X(this.hx);
                c = new x.Na("div", "fm-ui-col fm-vam fm-tar fm-ui-btns-row");
                a.X(c);
                this.xi = new x.Qg("fm-btn-add-measure fm-ui-btn-light fm-icon-act_calc");
                c.X(this.xi);
                this.Oe = new x.Qg();
                this.Oe.gb(e.model.B.j.El);
                this.Zh = new x.Qg("fm-ui-btn-dark");
                this.Zh.gb(e.model.B.j.Tx);
                u.qj.JD || u.qj.No ? (c.X(this.Oe), c.X(this.Zh)) : (c.X(this.Zh), c.X(this.Oe));
                a = new x.Na("div", "fm-popup-content");
                this.X(a);
                c = new x.Na("div", "fm-list-wrap");
                a.X(c);
                var d = new x.Na("div", "fm-list-header");
                c.X(d);
                this.Yd = new x.cK();
                this.Yd.$("fm-select-all-cbx");
                this.Yd.gb(e.model.B.j.xv);
                d.X(this.Yd);
                this.Ye = new x.Na("div", "fm-search-wrap");
                d.X(this.Ye);
                this.pe = new x.Na("a", "fm-search-btn");
                this.pe.Je(0);
                this.pe.Rk("button");
                this.Ye.X(this.pe);
                d = new x.Na("span", "fm-ui-icon fm-icon-act_search");
                this.pe.X(d);
                this.he = new x.Oj();
                this.he.$("fm-search-inp-flat");
                this.Ye.X(this.he);
                this.gj = new x.Na("span", "fm-close-search fm-ui-icon fm-icon-act_close");
                this.gj.Je(0);
                this.gj.Rk("button");
                this.Ye.X(this.gj);
                d = new x.Na("div", "fm-list-content");
                c.X(d);
                this.fb = new x.Ad.rj();
                this.fb.$("fm-lst-hierarchies");
                this.fb.Je();
                this.fb.ji(this.rE);
                this.fb.vg("caption");
                d.X(this.fb);
                this.ng = new h.XI();
                this.ng.$("fm-aggregations-view");
                this.ng.Za();
                a.X(this.ng);
                this.Yi = new x.fr.GF(a.G);
                this.Yi.Za();
                a.X(this.Yi);
              }
              rE(a, c) {
                var d = new h.Ii.bQ(a, c);
                d.setData(a);
                d.Ym(c);
                return d;
              }
              dg() {
                this.ix.gb(e.model.B.j.Yx);
                this.hx.gb(e.model.B.j.I7);
                this.Oe.gb(e.model.B.j.El);
                this.Zh.gb(e.model.B.j.Tx);
                this.Yd.gb(e.model.B.j.xv);
                this.xi.ki(e.model.B.j.QA);
                this.qc(e.model.B.j.Yx);
                this.ix.ro();
                this.hx.ro();
                this.fb.qc(e.model.B.j.vv);
                this.pe.qc(e.model.B.j.XO);
                this.he.qc(e.model.B.j.XO);
                this.gj.qc(e.model.B.j.K7);
              }
              reset() {
                this.Ye.Gd("fm-search-opened-flat");
                this.he.clear(!1);
              }
              Ao(a) {
                var c = new x.Ga("span");
                c.$("fm-drag-handle");
                c.$("fm-helper");
                c.$("fm-draggable");
                c.$a("fm-values", a.Sc("fm-values"));
                c.U("width", a.U("width"));
                c.U("position", "absolute");
                c.U("z-index", 100);
                c.attr("data-index", a.attr("data-index"));
                c.text(a.text());
                return c;
              }
            }
            f.Y7 = b;
          })(h.flat || (h.flat = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.be.ik {
              constructor() {
                super();
                this.$("fm-flat-fields");
                this.$("fm-instant-view");
                this.Ie();
              }
              Ie() {
                var a = new x.Na("div", "fm-popup-content");
                this.X(a);
                var c = new x.Na("div", "fm-list-wrap fm-list-wrap-all");
                a.X(c);
                var d = new x.Na("div", "fm-list-header");
                c.X(d);
                this.Yd = new x.cK();
                this.Yd.$("fm-select-all-cbx");
                this.Yd.gb(e.model.B.j.xv);
                d.X(this.Yd);
                this.xi = new x.Qg("fm-btn-add-measure");
                d.X(this.xi);
                this.Oe = new x.Qg("fm-btn-close-fields");
                d.X(this.Oe);
                d = new x.Na("div", "fm-list-content");
                c.X(d);
                this.fb = new x.Ad.rj();
                this.fb.$("fm-lst-hierarchies");
                this.fb.Je();
                this.fb.ji(this.rE);
                this.fb.vg("caption");
                d.X(this.fb);
                this.ng = new h.XI();
                this.ng.$("fm-aggregations-view");
                this.ng.Za();
                a.X(this.ng);
                this.Yi = new x.fr.GF(a.G);
                this.Yi.Za();
                a.X(this.Yi);
              }
              rE(a, c) {
                var d = new h.Ii.bQ(a, c);
                d.setData(a);
                d.Ym(c);
                return d;
              }
              dg() {
                this.Yd.gb(e.model.B.j.xv);
                this.xi.ki(e.model.B.j.QA);
                this.qc(e.model.B.j.Yx);
                this.fb.qc(e.model.B.j.vv);
                this.Oe.qc(e.model.B.j.oJ);
              }
              Ao(a) {
                var c = new x.Ga("span");
                c.$("fm-drag-handle");
                c.$("fm-helper");
                c.$("fm-draggable");
                c.$a("fm-values", a.Sc("fm-values"));
                c.U("width", a.U("width"));
                c.U("position", "absolute");
                c.U("z-index", 100);
                c.attr("data-index", a.attr("data-index"));
                c.text(a.text());
                return c;
              }
              open() {
                this.show();
                this.Ya(v.ga.OPENED);
              }
              close() {
                this.Za();
                this.Ya(v.ga.CLOSED);
              }
            }
            f.kna = b;
          })(h.flat || (h.flat = {}));
        })(k.od || (k.od = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.be.oy {
            constructor() {
              super(k.Nb.Gb.G);
              this.FLa = () => this.vN();
              this.$("fm-calculated-view");
              this.G.Ul();
              this.aE.$("fm-calculated-view-overlay");
              this.Qe = new h.kla();
              this.Qe.N(v.ga.G6, () => this.close());
              this.X(this.Qe.view);
              this.N(v.ga.CLOSED, this.FLa);
            }
            vN() {
              e.model.Va.R().Ea(new k.Oa.ola());
            }
            Qo(b) {
              this.Qe.update(b);
              this.open();
              this.Qe.view.tr.focus({
                preventScroll: !0
              });
              this.dg();
            }
            dg() {
              this.qc(e.model.B.j.$W);
            }
            close() {
              super.close();
              this.Qe.clear();
            }
          }
          f.VK = !1;
          h.cF = f;
        })(k.Oa || (k.Oa = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {}
          f.BA = "event_calculated_value_added";
          f.CA = "event_calculated_value_removed";
          f.B6 = "calculated_view_open";
          f.DA = "calculated_view_close";
          h.fk = f;
          class b extends v.ga {
            constructor(g) {
              super(f.BA);
              this.Os = g;
            }
          }
          h.mla = b;
          class a extends v.ga {
            constructor(g) {
              super(f.CA);
              this.Os = g;
            }
          }
          h.nla = a;
          class c extends v.ga {
            constructor() {
              let g = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              super(f.B6);
              this.Os = g;
            }
          }
          h.gX = c;
          class d extends v.ga {
            constructor() {
              super(f.DA);
            }
          }
          h.ola = d;
        })(k.Oa || (k.Oa = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.Lsa = "- 2";
              this.la = e.model.Va.R();
              this.V0 = [{
                name: "_addBtn",
                label: "+",
                nf: "CALCULATED_VIEW_FUNC_ADD",
                Fk: e.u.i.sc.wO
              }, {
                name: "_subtractBtn",
                label: "-",
                nf: "CALCULATED_VIEW_FUNC_SUBTRACT",
                Fk: e.u.i.sc.aQ
              }, {
                name: "_multiplyBtn",
                label: "\u00d7",
                nf: "CALCULATED_VIEW_FUNC_MULTIPLY",
                Fk: e.u.i.sc.KP
              }, {
                name: "_divideBtn",
                label: "\u00f7",
                nf: "CALCULATED_VIEW_FUNC_DIVIDE",
                Fk: e.u.i.sc.kJ
              }, {
                name: "_powerBtn",
                label: "^",
                nf: "CALCULATED_VIEW_FUNC_POWER",
                Fk: e.u.i.sc.$X
              }, {
                name: "_equalBtn",
                label: "=",
                nf: "CALCULATED_VIEW_FUNC_EQUAL",
                Fk: e.u.i.sc.EQUAL
              }, {
                name: "_lessBtn",
                label: "<",
                nf: "CALCULATED_VIEW_FUNC_LESS",
                Fk: e.u.i.sc.LESS
              }, {
                name: "_greaterBtn",
                label: ">",
                nf: "CALCULATED_VIEW_FUNC_GREATER",
                Fk: e.u.i.sc.GREATER
              }, {
                name: "_lessOrEqualBtn",
                label: "\u2264",
                nf: "CALCULATED_VIEW_FUNC_LESS_EQUAL",
                Fk: e.u.i.sc.p8
              }, {
                name: "_greaterOrEqualBtn",
                label: "\u2265",
                nf: "CALCULATED_VIEW_FUNC_GREATER_EQUAL",
                Fk: e.u.i.sc.c8
              }, {
                name: "_notEqualBtn",
                label: "!=",
                nf: "CALCULATED_VIEW_FUNC_NOT_EQUAL",
                Fk: e.u.i.sc.Pf
              }, {
                name: "_orBtn",
                label: "OR",
                nf: "CALCULATED_VIEW_FUNC_OR",
                Fk: e.u.i.sc.d9
              }, {
                name: "_andBtn",
                label: "AND",
                nf: "CALCULATED_VIEW_FUNC_AND",
                Fk: e.u.i.sc.e6
              }, {
                name: "_ifBtn",
                label: "IF",
                nf: "CALCULATED_VIEW_FUNC_IF",
                Fk: e.u.i.sc.kP
              }, {
                name: "_absBtn",
                label: "ABS",
                nf: "CALCULATED_VIEW_FUNC_ABS",
                Fk: e.u.i.sc.PW
              }, {
                name: "_roundBtn",
                label: "RD",
                nf: "CALCULATED_VIEW_FUNC_ROUND",
                Fk: e.u.i.sc.gY
              }, {
                name: "_minBtn",
                label: "MIN",
                nf: "CALCULATED_VIEW_FUNC_MIN",
                Fk: e.u.i.sc.MIN
              }, {
                name: "_maxBtn",
                label: "MAX",
                nf: "CALCULATED_VIEW_FUNC_MAX",
                Fk: e.u.i.sc.MAX
              }];
            }
            search(b) {
              b = b.toLowerCase().trim();
              if (this.sd !== b) {
                this.sd = b;
                this.V4 = [];
                var a = this.cf.length;
                for (let c = 0; c < a; c++) {
                  const d = this.cf[c];
                  e.P.contains(d.caption, b) && (d.sd = b, this.V4.push(d));
                }
              }
            }
            get Oo() {
              return !e.ia(this.sd);
            }
            Ry() {
              this.sd = "";
              this.V4 = null;
            }
            update(b) {
              this.cf = k.od.W.oj.xL(this.la.ja.O.Ca.Pc());
              this.Ry();
              e.ia(b) || (this.uj = this.la.ja.O.fd(b));
            }
            get zl() {
              return !this.la.ja.fa.Ic || this.la.ja.fa.Ba == e.u.i.qa.API;
            }
            get p5() {
              return this.la.ja.fa.Ba != e.u.i.qa.API;
            }
            Gs() {
              e.v(this.cf) && (this.cf = k.od.W.oj.xL(this.la.ja.O.Ca.Pc()));
              return this.Oo ? this.V4 : this.cf;
            }
            lE(b) {
              h.cF.VK = !0;
              this.la.$z(b.A);
              this.la.Ea(new h.nla(b.A));
              e.Be(() => {
                h.cF.VK = !1;
              }, 1E3);
            }
            rk(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              a = a.trim();
              a = 0 < a.length ? a : this.Kza();
              let d;
              if (null != this.uj) {
                if (this.uj.caption != a || this.uj.De != b || this.uj.Gk != c) d = {
                  uniqueName: this.uj.A,
                  caption: a,
                  formula: b,
                  individual: c,
                  type: this.uj.type
                };
              } else {
                do a = null != this.la.ja.O.Ca.getItem(a) ? a + " " + this.Lsa : a; while (null != this.la.ja.O.Ca.getItem(a));
                d = {
                  uniqueName: a,
                  caption: a,
                  formula: b,
                  individual: c,
                  type: e.u.i.Qa.jb
                };
              }
              null != d && (h.cF.VK = !0, k.od.Rt.g9.H0 = !0, this.la.ja.bu(d, !1), this.la.Ea(new h.mla(d.uniqueName)), e.Be(() => {
                h.cF.VK = !1;
              }, 1E3));
            }
            Kza() {
              let b = e.model.B.j.DO + " #",
                a = 0;
              const c = this.la.ja.O.$q,
                d = new RegExp(e.model.B.j.DO + " #");
              for (let g = 0; g < c.length; g++) {
                const l = c.ea(g).A;
                d.test(l) && (a = Math.max(a, Number(l.substr(e.model.B.j.DO.length + 2))));
              }
              return b + (a + 1);
            }
          }
          h.lla = f;
        })(k.Oa || (k.Oa = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor() {
              super();
              this.$$ = new RegExp(/(["])(?:(?=(\\?))\2.)*?\1/g);
              this.la = new h.lla();
              this.view = new h.pla(this);
              this.view.yx && this.view.yx.N(x.Nd.tf, () => this.VGa());
              this.view.he && (this.view.he.YV(500), this.view.he.N(x.Oj.Wx, () => this.uN()));
              this.view.pe && (this.view.pe.N("click", () => this.Us()), this.view.pe.N("keydown", b => this.Uz(b, !1)));
              this.view.gj && (this.view.gj.N("click", () => this.Vs()), this.view.gj.N("keydown", b => this.Uz(b, !0)));
              this.view.Ub && (this.view.Ub.G.N("click", b => this.qGa(b)), this.view.Ub.G.N("dblclick", b => this.rGa(b)), this.view.Ub.G.N("keydown", b => this.xGa(b)), this.view.Ub.ji((b, a) => this.Fs(b, a)));
              this.view.bi && this.view.bi.G.Ds({
                Um: b => this.sGa(b),
                u3: () => this.wga(),
                Tm: () => this.wga(),
                em: () => this.PFa(),
                Iz: "li"
              });
              this.view.Zh && this.view.Zh.N(x.Nd.tf, () => this.XD());
              this.view.Oe && this.view.Oe.N(x.Nd.tf, () => this.Ts());
              this.view.ng && this.view.ng.N(v.ga.Zd, b => this.IEa(b));
              if (this.view.cT) for (const b of this.view.cT) b.N(x.Nd.tf, () => this.QFa(b));
            }
            uN() {
              this.la.search(this.view.he.Zi());
              this.view.Ub.G.$a("fm-searched", this.la.Oo);
              this.Dja();
            }
            Us() {
              this.view.Ye.$("fm-search-opened");
              this.view.he.G.focus();
            }
            Uz(b, a) {
              if (32 === b.keyCode || 13 === b.keyCode) a ? this.Vs() : this.Us();
            }
            Vs() {
              this.view.Ye.Gd("fm-search-opened");
              this.view.he.clear();
              this.view.pe.G.focus();
            }
            qGa(b) {
              const a = x.Ga.Xb(b.target);
              a.Sc("fm-aggr-display") && (b = this.view.Ub.TC(b.target), e.v(b) || this.view.ng.Xo(b.data, a));
            }
            rGa(b) {
              b = this.view.Ub.TC(b.target);
              e.v(b) || this.ZZ(b.data);
            }
            xGa(b) {
              if (32 === b.keyCode || 13 === b.keyCode) {
                if (this.view.Yi) {
                  const a = this.view.Ub.Gu();
                  if (e.v(a)) return;
                  const c = [];
                  c.push({
                    label: e.model.B.j.vka,
                    handler: () => {
                      this.ZZ(a.data);
                    }
                  });
                  c.push({
                    label: e.model.B.j.wX,
                    submenu: this.oz(a.data)
                  });
                  this.view.Yi.Xo(this.view.content.G, c, a.element.qg(), {
                    top: 10,
                    left: 10
                  });
                }
                b.preventDefault();
              }
            }
            oz(b) {
              const a = [];
              for (let c = 0; c < b.Wc.length; c++) {
                const d = {
                  caption: b.fL[c],
                  aa: b.Wc[c]
                };
                void 0 != b.hw && (d.FW = b.hw[c]);
                a.push({
                  label: e.u.i.da.tG(b.Wc[c]),
                  isSelected: b.Wc[c] == b.aa,
                  handler: () => this.hA(b, d)
                });
              }
              return a;
            }
            wga() {
              this.view.bi.$("fm-droppable-over");
            }
            PFa() {
              this.view.bi.Gd("fm-droppable-over");
            }
            sGa(b) {
              this.view.bi.Gd("fm-droppable-over");
              b = parseInt(b.attr("data-index"));
              b = this.view.Ub.Bc()[b];
              this.ZZ(b);
            }
            Fs(b, a) {
              var c = new k.od.Ii.CX();
              c.setData(b);
              c.Ym(a);
              c.gW(function (d) {
                return d.name + " (" + e.u.i.da.tG(d.aa) + ")";
              });
              return c;
            }
            get V0() {
              return this.la.V0;
            }
            update(b) {
              this.la.update(b);
              this.view.jC.isVisible(this.la.p5);
              null != this.la.uj ? (this.view.G.$a("fm-with-delete-btn", !0), this.view.tr && this.view.tr.Jj(this.la.uj.caption), this.view.bi && (b = e.model.C.F.LW ? this.bJa(this.la.uj.De) : this.la.uj.De, this.view.bi.Jj(b)), this.view.yx && this.view.yx.isVisible(!0)) : (this.view.G.$a("fm-with-delete-btn", !1), this.view.yx && this.view.yx.isVisible(!1));
              this.view.jC && this.la.p5 && (this.view.jC.checked = this.la.uj ? this.la.uj.Gk : !1);
              this.view.he && (this.view.Ye.Gd("fm-search-opened"), this.view.he.clear(!1), this.la.Ry());
              this.view.dg();
              this.Dja();
            }
            Dja() {
              for (var b = this.la.Gs(), a = [], c = 0; c < b.length; c++) null != this.la.uj && this.la.uj.A == b[c].A || b[c].$g || (b[c].rg = !0, b[c].zl = this.la.zl && !b[c].Oa, a.push(b[c]));
              a.sort(this.D_);
              if (this.view.Ub) for (this.view.Ub.cg(a), b = {
                Ao: d => this.view.Ao(d)
              }, u.Jd().Rm && (b.LT = ".fm-drag-handle"), a = this.view.Ub.G.find("li", !0), c = 0; c < a.length; c++) a[c].draggable(b);
            }
            clear() {
              this.view.tr && this.view.tr.Jj("");
              this.view.bi && this.view.bi.Jj("");
              this.la.uj = null;
            }
            D_(b, a) {
              return b.name > a.name ? 1 : -1;
            }
            VGa() {
              u.Jd().Rm ? this.Y3() : this.vKa();
            }
            vKa() {
              if (u.qj.JD || u.qj.No) {
                var b = [e.model.B.j.u6, e.model.B.j.VE];
                var a = [null, () => this.Y3()];
              } else b = [e.model.B.j.VE, e.model.B.j.u6], a = [() => this.Y3(), null];
              var c = e.model.Tb.valid(this.la.uj.caption) ? this.la.uj.caption : e.model.Tb.validate(this.la.uj.caption);
              e.Wa(e.model.B.j.xka, e.P.bind(e.model.B.j.yka, c), e.tb.Dl, b, a);
            }
            Y3() {
              this.la.lE(this.la.uj);
              this.close();
            }
            ZZ(b) {
              if (void 0 !== b) {
                var a = e.model.C.F.LW ? b.name : b.A;
                b.aa === e.u.i.da.NONE || void 0 === b.aa ? this.Bz(e.P.bind('"{0}"', a)) : this.Bz(e.P.bind('{0}("{1}")', b.aa, a));
              }
            }
            IEa(b) {
              this.hA(b.data.VL, b.data.d_);
            }
            hA(b, a) {
              b.aa = a.aa;
              b.caption = a.caption + " of " + b.name;
              this.view.Ub.Jr(b);
            }
            QFa(b) {
              b = b.data.Fk;
              b == e.u.i.sc.kP || b == e.u.i.sc.PW || b == e.u.i.sc.MIN || b == e.u.i.sc.MAX || b == e.u.i.sc.jo || b == e.u.i.sc.gY ? this.zta(b) : this.wta(b);
            }
            Ts() {
              this.close();
            }
            XD() {
              const b = e.model.C.F.LW ? this.aJa(this.view.bi.Zi()) : this.view.bi.Zi();
              if (e.model.C.F.sO) {
                var a = u.iP.NR(b, this.la.uj ? this.la.uj.A : this.view.tr.Zi());
                if (0 == a.Zw) {
                  e.Wa(a.errorMessage);
                  return;
                }
              }
              a = this.la.p5 ? this.view.jC.checked : !1;
              this.la.rk(b, this.view.tr.Zi(), a);
              this.close();
            }
            aJa(b) {
              b = b.slice(0);
              const a = b.match(this.$$),
                c = e.u.Ma.R().O.Ca;
              let d, g;
              for (let l = 0; l < a.length; l++) {
                d = a[l].substring(1, a[l].length - 1);
                for (g = 0; g < c.length && d !== c.ea(g).rl; g++);
                g < c.length && (b = b.replace('"' + d + '"', '"' + c.ea(g).A + '"'));
              }
              return b;
            }
            bJa(b) {
              b = b.slice(0);
              const a = b.match(this.$$),
                c = e.u.Ma.R().O.Ca;
              let d;
              for (let g = 0; g < a.length; g++) d = a[g].substring(1, a[g].length - 1), b = b.replace('"' + d + '"', '"' + c.getItem(d).rl + '"');
              return b;
            }
            close() {
              this.Ya(v.ga.G6);
            }
            Bz(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var c = this.view.bi.G.element.selectionStart,
                d = this.view.bi.Zi();
              -1 == c && (c = this.ii);
              0 == c || " " == d.charAt(c - 1) ? (this.view.bi.Bz(b + " "), this.ii = c + b.length + 1) : (this.view.bi.Bz(" " + b + " "), this.ii = c + b.length + 2);
              this.ii -= a;
              this.view.bi.Gf(this.ii);
            }
            wta(b) {
              this.Bz(b);
            }
            zta(b) {
              const a = this.view.bi.G.element.selectionStart,
                c = this.view.bi.G.element.selectionEnd,
                d = this.view.bi.Zi();
              if (e.u.i.sc.kP == b) this.Bz(b + "(" + d.slice(a, c) + ", , )", 6);else {
                let g = e.u.i.sc.MIN == b || e.u.i.sc.MAX == b ? "," : "";
                this.Bz(b + "(" + d.slice(a, c) + g + ")", 2 + g.length);
              }
            }
          }
          h.kla = f;
        })(k.Oa || (k.Oa = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor(a) {
              super();
              this.controller = a;
              this.Ie();
            }
            Ie() {
              var a = new x.Na("div", "fm-popup-header fm-ui-row");
              this.X(a);
              var c = new x.Na("div", "fm-ui-col fm-vam");
              a.X(c);
              this.Fr = new x.Vc(e.model.B.j.$W);
              this.Fr.$("fm-popup-title");
              c.X(this.Fr);
              c = new x.Na("div", "fm-ui-col fm-vam fm-tar fm-ui-btns-row");
              a.X(c);
              this.yx = new x.Qg("fm-ui-btn-light fm-icon-act_trash fm-remove-btn");
              this.yx.G.attr("title", e.model.B.j.C6);
              c.X(this.yx);
              this.Oe = new x.Qg("fm-ui-btn");
              this.Oe.gb(e.model.B.j.El);
              this.Zh = new x.Qg("fm-ui-btn-dark");
              this.Zh.gb(e.model.B.j.Tx);
              u.qj.JD || u.qj.No ? (c.X(this.Oe), c.X(this.Zh)) : (c.X(this.Zh), c.X(this.Oe));
              this.content = a = new x.Na("div", "fm-popup-content");
              this.X(a);
              this.tr = new x.Oj();
              this.tr.$("fm-name-input");
              this.tr.xE(e.model.B.j.ZW);
              a.X(this.tr);
              c = new x.Na("div", "fm-list-header fm-list-header-wide");
              a.X(c);
              var d = new x.Na("div", "fm-list-header-label-wrap");
              c.X(d);
              var g = new x.Vc(e.model.B.j.vv);
              d.X(g);
              this.Ye = new x.Na("div", "fm-search-wrap");
              c.X(this.Ye);
              this.pe = new x.Na("a", "fm-search-btn");
              this.pe.Je(0);
              this.pe.Rk("button");
              this.Ye.X(this.pe);
              c = new x.Na("span", "fm-ui-icon fm-icon-act_search");
              this.pe.X(c);
              this.he = new x.Oj();
              this.he.$("fm-search-inp");
              this.Ye.X(this.he);
              this.gj = new x.Na("span", "fm-close-search fm-ui-icon fm-icon-act_close");
              this.gj.Je(0);
              this.gj.Rk("button");
              this.Ye.X(this.gj);
              c = new x.Na("div", "fm-list-content");
              a.X(c);
              this.Ub = new x.Ad.rj();
              this.Ub.$("fm-lst-measures");
              this.Ub.Je();
              this.Ub.useCache = !1;
              this.Ub.vg("caption");
              c.X(this.Ub);
              this.jC = new x.cK();
              this.jC.gb(e.model.B.j.z6);
              a.X(this.jC);
              this.qda = new x.Na("div", "fm-ui-row fm-func-btn-group");
              a.X(this.qda);
              this.cT = [];
              c = this.controller.V0;
              for (d = 0; d < c.length; d++) g = new b(), g.data = c[d], g.G.attr("data-index", d), g.gb(c[d].label), g.ki(e.model.B.j[g.data.nf]), g.qc(e.model.B.j[g.data.nf]), this.qda.X(g), this.cT.push(g);
              c = new x.Na("div", "fm-formula-wrap");
              a.X(c);
              this.bi = new x.Lv();
              this.bi.$("fm-formula-input");
              this.bi.N(x.Oj.Wx, () => this.OFa());
              c.X(this.bi);
              this.GU = new x.Vc(e.model.B.j.A6);
              this.GU.$("fm-prompt");
              c.X(this.GU);
              this.ng = new k.od.XI();
              this.ng.$("fm-aggregations-view");
              this.ng.Za();
              a.X(this.ng);
              this.Yi = new x.fr.GF(a.G);
              this.Yi.Za();
              a.X(this.Yi);
            }
            dg() {
              this.Fr.gb(e.model.B.j.$W);
              this.Zh.gb(e.model.B.j.Tx);
              this.Oe.gb(e.model.B.j.El);
              this.tr.xE(e.model.B.j.ZW);
              this.jC.gb(e.model.B.j.z6);
              this.GU.gb(e.model.B.j.A6);
              this.yx.ki(e.model.B.j.C6);
              this.Fr.ro();
              this.tr.qc(e.model.B.j.ZW);
              this.Ub.qc(e.model.B.j.wka);
              this.bi.qc(e.model.B.j.DO);
              for (const a of this.cT) a.ki(e.model.B.j[a.data.nf]), a.qc(e.model.B.j[a.data.nf]);
            }
            Ao(a) {
              var c = new x.Ga("span");
              c.$("fm-drag-handle");
              c.$("fm-helper");
              c.$("fm-draggable");
              c.U("width", a.U("width"));
              c.U("position", "absolute");
              c.U("z-index", 100);
              c.attr("data-index", a.attr("data-index"));
              c.text(a.text());
              return c;
            }
            OFa() {
              this.GU.isVisible(0 == this.bi.Zi().length);
            }
          }
          h.pla = f;
          class b extends x.Qg {
            constructor() {
              super("fm-ui-col-9 fm-calc-action");
              this.Gd("fm-ui-btn");
            }
          }
          h.kNa = b;
        })(k.Oa || (k.Oa = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.be.oy {
            constructor() {
              super(k.Nb.Gb.G);
              this.zg = this.uf = this.vp = this.my = this.Ri = 0;
              this.$("fm-drillthrough-view");
              this.Ie();
            }
            Ie() {
              this.UF = new x.be.ik("fm-header-container");
              this.X(this.UF);
              this.os = new x.Vc();
              this.os.$("fm-popup-title");
              this.os.jW(!1);
              this.UF.X(this.os);
              this.tB = new x.Qg();
              this.tB.$("fm-ui-btn-close");
              this.tB.ki(e.model.B.j.Iqa);
              this.tB.N(x.Nd.tf, () => this.close());
              this.UF.X(this.tB);
              this.vB = new x.be.ik("fm-details-container");
              this.X(this.vB);
              this.pG = new x.Vc();
              this.pG.$("fm-ui-label-light");
              this.vB.X(this.pG);
              this.nG = new x.Vc();
              this.nG.$("fm-ui-label-light");
              this.vB.X(this.nG);
              this.oG = new x.Vc();
              this.oG.$("fm-ui-label-light");
              this.vB.X(this.oG);
              this.GK = new x.be.ik("fm-grid-container");
              this.X(this.GK);
              this.ma = new k.Y.sheet.flat.zJ();
              this.ma.Je(-1);
              this.ma.ll = !0;
              this.GK.G.X(this.ma);
              new h.Rla(this);
              this.Mt = new h.jr.Tla();
              this.GK.X(this.Mt);
            }
            B4() {
              e.v(this.Qe) || this.Qe.$m();
            }
            Qo() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              let l = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
              this.I = b;
              e.v(this.Qe) && (this.Qe = new h.Sla(this));
              this.Qe.update(a, c, d, g, l);
            }
            close() {
              super.close();
              this.Ya(k.Y.vc.j7);
              e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.i7));
            }
            Bk(b, a) {
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              e.v(this.Qe) || this.Qe.Bk(b, a, c, d);
            }
            dispose() {
              this.I = null;
              this.ma && (this.ma.dispose(), this.ma = null);
              this.Qe && (this.Qe.dispose(), this.Qe = null);
              this.Mt.Td();
              this.Mt.Lg();
              this.Mt = null;
              this.os.Lg();
              this.os = null;
              this.pG.Lg();
              this.pG = null;
              this.nG.Lg();
              this.nG = null;
              this.oG.Lg();
              this.oG = null;
              this.UF.Lg();
              this.UF = null;
              this.GK.Lg();
              this.GK = null;
              this.vB.Lg();
              this.vB = null;
              this.tB.Lg();
              this.tB.Td();
              this.tB = null;
              this.Td();
            }
          }
          h.eF = f;
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b) {
              this.view = b;
              this.view.N(k.Y.vc.j7, () => this.YEa());
              this.view.ma.N(k.Y.vc.NJ, a => this.UD(a));
              this.view.ma.N(k.Y.vc.g7, a => this.SFa(a));
              this.view.ma.N(k.Y.vc.f7, a => this.RFa(a));
              this.view.Mt.N(k.od.np.WO, () => this.x3());
              this.view.Mt.N(k.od.np.mJ, a => this.w3(a));
            }
            qS(b) {
              return e.model.Va.R().Fa.fa.Ic ? e.model.Va.R().Fa.fa.Ba == e.u.i.qa.Cc ? new h.Qs.Q8(b) : e.model.Va.R().Fa.fa.Ba == e.u.i.qa.API ? new h.Qs.Zja(b) : e.model.Va.R().Fa.fa.Ba == e.u.i.qa.Md ? new h.Qs.bpa(b) : new h.Qs.V8(b) : new h.dF(b);
            }
            update() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              e.v(this.model) || this.model.dispose();
              this.model = this.qS(this.view.I);
              this.model.cell = g;
              this.model.N(h.dF.VO, () => this.kq());
              this.model.update(b, a, c, d);
              this.view.ma.slice = b;
              this.view.ma.cD = (l, m) => this.model.getData(l, m);
              this.view.ma.QL.Pha = (l, m, n) => this.saveData(l, m, n);
            }
            kq() {
              this.view.open();
              const b = () => {
                this.view.ma.pb(k.Si.ip, b);
                e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.k7, this.model.cell));
              };
              this.view.ma.N(k.Si.ip, b);
              this.$m();
            }
            $m() {
              this.model.C4();
              this.Cja();
              this.view.Mt.isVisible(this.model.ICa);
              this.view.Tk(k.Nb.Hx - 70);
              const b = k.Nb.Gb.G.yd(!0) - this.view.vB.G.yd(!0) - this.view.UF.G.yd(!0) - 30 - this.view.G.padding.top - this.view.G.padding.bottom - 40,
                a = this.view.Zf() - (parseInt(this.view.G.U("border-left-width")) + parseInt(this.view.G.U("border-right-width")));
              this.view.ma.lu();
              this.view.ma.resize(a, b);
              this.view.ma.width = a;
              this.view.ma.height = b;
              this.view.ma.oda(1);
              this.view.ma.QL.mia(e.model.C.F.OC && !e.u.Ma.R().fa.Ic);
              this.view.ma.jia(this.model.GN, this.model.rba);
              this.view.ma.nb();
              this.view.Gp();
            }
            Cja() {
              this.view.os.gb(e.model.B.j.Nla);
              var b = this.model.oBa();
              this.view.pG.gb(b, !0);
              this.view.pG.isVisible(!e.ia(b));
              b = this.model.Xza();
              this.view.nG.gb(b, !0);
              this.view.nG.isVisible(!e.ia(b));
              b = this.model.PAa();
              this.view.oG.gb(b, !0);
              this.view.oG.isVisible(!e.ia(b));
            }
            UD(b) {
              e.model.Va.R().Fa.fa.Ic || b.rfa || this.zxa(b.cell);
              b.cell && b.cell.Ah && b.cell.ZB == k.Y.W.Eq.YJ && (this.model.aO(b.cell), this.view.ma.clearData(), this.view.ma.nb());
            }
            zxa(b) {
              if (e.model.Xa.R().S1(e.model.Xa.EO) && !e.v(b)) {
                var a = this.model.mBa(b.lb);
                e.v(a) || (b.ll = !0, b = b.Sa(), b.rowData = a, e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.EO, b)));
              }
            }
            SFa(b) {
              this.model.Ew.WIa(b.data.index);
              this.model.zq(this.model.Ew);
            }
            RFa(b) {
              let a = b.data.iza;
              b = b.data.bLa;
              b = Math.max(0, Math.min(b, this.model.Ew.selected.length));
              a < b && b--;
              a != b && (this.model.Ew.zEa(a, b), this.model.zq(this.model.Ew));
            }
            x3() {
              this.view.Mt.open(this.model.Ew);
            }
            w3(b) {
              this.model.zq(b.data);
            }
            Bk(b, a, c, d) {
              const g = this.model.rba,
                l = 0 < this.model.GN ? this.model.GN + 1 : 0;
              b == e.model.Dc.nj.VA && e.model.Dc.x7.Xe(this.view, a, d);
              b == e.model.Dc.nj.zv && e.model.Dc.w7.Xe(this.view, a, g, l, d);
              b == e.model.Dc.nj.Xh && e.model.Dc.v7.Xe(this.view, a, g, l, c);
              b == e.model.Dc.nj.JSON && e.model.Dc.y7.Xe(this.view, a, g, l, c);
              b == e.model.Dc.nj.cB && e.model.Dc.$e.Xe(this.view, a, g, l, d);
              b == e.model.Dc.nj.fF && (a.sA = a.sA && (e.model.Va.R().Fa.fa.Ba == e.u.i.qa.Cc || e.model.Va.R().Fa.fa.Ba == e.u.i.qa.Md) && e.model.C.F.Rn, e.model.Dc.A7.Xe(this.view, a, g, l));
            }
            saveData(b, a, c) {
              this.timer && this.timer.wl && this.timer.stop();
              null == this.timer && (this.timer = new u.Et(1E3, 1));
              this.timer.N(u.vf.Hl, () => this.qHa());
              this.timer.start();
              this.model.saveData(b, a, c);
              this.$m();
            }
            qHa() {
              this.Cja();
              this.timer.stop();
            }
            YEa() {
              this.view.ma.QL.Yia();
              e.model.C.F.OC && this.model.d0 && (this.model.d0 = !1, e.u.Ma.R().refresh());
            }
            dispose() {
              this.timer && (this.timer.stop(), this.timer = null);
              this.model && (this.model.dispose(), this.model = null);
              this.view = null;
            }
          }
          h.Sla = f;
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor(b) {
              super();
              this.tI = NaN;
              this.bI = {};
              this.d0 = !1;
              this.cell = null;
              this.pn = b;
            }
            update() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              this.Qb = b;
              this.Ag = this.X_(b);
              this.th = c;
              this.Gg = a;
              this.measure = d;
              this.bI = {};
              this.Ud();
            }
            zq(b) {
              this.Ag = b;
              b = [];
              if (this.Ag.Wo && 0 < this.Ag.Wo.length) {
                for (var a = 0; a < this.Ag.Wo.length; a++) {
                  var c = this.Ag.Wo[a].level;
                  b.push(void 0 === c ? this.Ag.Wo[a].hierarchy : c);
                }
                this.Qb.bd = b;
              } else this.Qb.bd = this.Ag.selected;
              this.Ud();
            }
            get Ew() {
              return this.Ag;
            }
            X_(b) {
              const a = new h.jr.n7();
              var c = this.Qb.Yc.yc(!1);
              for (var d = 0; d < c.length; d++) {
                var g = c.ea(d);
                a.lf.Ua(g.A, {
                  A: g.A,
                  caption: g.caption,
                  wa: g.wa.Pc(!0).slice(1)
                });
              }
              d = null != b.bd && 0 < b.bd.length ? b.bd : null != e.model.Va.R().Fa.GM && 0 < e.model.Va.R().Fa.GM.length ? e.model.Va.R().Fa.GM : b.flatten().Pc(!0);
              for (c = 0; c < d.length; c++) g = d[c], a.lf.Bb(g) && a.sG(g);
              d = {};
              for (c = 0; c < b.Sf.length; c++) g = b.Sf[c], g.Oa && 0 < g.Sd.length && this.xda(g.Sd, d);
              for (const l in d) c = b.Yc.fd(l), e.v(c) || c.Oa || a.sG(l);
              return a;
            }
            xda(b, a) {
              if (void 0 !== b[2]) {
                var c, d;
                for (d in b[1]) {
                  var g = c = b[1][d];
                  Array.isArray(c) && (g = this.xda(c, a));
                  if (g == e.u.i.RO.QO && b[0] == e.u.i.sc.kJ) break;
                  void 0 !== g && (a[g] = 1);
                }
              }
            }
            C4() {
              this.Ud(!1);
            }
            Ud() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
              this.data = this.pn.bd(this.th, this.Gg, this.measure);
              this.keys = this.data.shift();
              const a = this.pn.Hs(this.th, this.Gg);
              this.pEa(a);
              this.w_();
              b && this.Ya(f.VO);
            }
            pEa(b) {
              this.tI = NaN;
              if (!e.v(b)) if (Array.isArray(b)) {
                this.tI = this.data[0].length;
                for (let a = 0; a < b.length; a++) this.data[a].push(b[a]);
              } else e.v(this.data[0]) || (this.tI = this.data[0].length, this.data[0].push(b));
            }
            aO(b) {
              const a = b.measure && b.measure.type == e.u.i.Qa.zc ? e.u.i.Aa.kc : e.u.i.Aa.Mc;
              let c = !0;
              this.bS == b.hierarchy ? (this.Nh = this.Nh == e.u.i.Aa.kc ? e.u.i.Aa.Mc : this.Nh == e.u.i.Aa.Mc ? e.u.i.Aa.kc : a, c = !0) : (this.Nh = a, c = !1);
              this.bS = b.hierarchy;
              const d = this.Wda(b.hierarchy),
                g = b.hierarchy.ck(b.hierarchy.wd, !0, this.Nh);
              c ? this.data.reverse() : this.data.sort((l, m) => g.indexOf(l[d]) - g.indexOf(m[d]));
            }
            mBa(b) {
              if (e.v(this.data) || e.v(this.data[b - 1])) return null;
              const a = [];
              for (let c = 0; c < this.Ew.lf.length; c++) {
                const d = this.nBa(b, this.Ag.lf.Oh(c));
                a.push(null == d ? d : d.Sa());
              }
              return a;
            }
            nBa(b, a) {
              a = this.Qb.Yc.ph(a);
              if (null == a) return null;
              const c = this.Qb.mf(a.A);
              return null == c ? null : this.Nda(b, -1, a, c);
            }
            w_() {
              this.Nh = this.bS = null;
            }
            get rba() {
              return e.v(this.Ew) ? 0 : this.Ew.Wo.length;
            }
            get GN() {
              return e.v(this.data) ? 0 : this.data.length;
            }
            oBa() {
              for (var b, a = [], c = 0; c < this.th.length; c++) {
                b = this.Qb.xb.ea(c);
                if (null == b) return null;
                b = b.za(this.th[c]);
                a.push(e.P.Go(b.caption, !0, !0));
              }
              a = 0 < a.length ? e.P.bind(e.model.B.j.Mla, a.join(" - ")) : "";
              return a = a.replace(/<br\s*[\/]?>/gi, " ");
            }
            Xza() {
              for (var b, a = [], c = 0; c < this.Gg.length; c++) {
                b = this.Qb.Db.ea(c);
                if (null == b) return null;
                b = b.za(this.Gg[c]);
                a.push(e.P.Go(b.caption, !0, !0));
              }
              a = 0 < a.length ? e.P.bind(e.model.B.j.Lla, a.join(" - ")) : "";
              return a = a.replace(/<br\s*[\/]?>/gi, " ");
            }
            PAa() {
              var b = this.measure.ci(this.measure.A, this.measure.aa).clone();
              const a = this.pn.La(this.th, this.Gg, this.measure);
              this.measure.aa == e.u.i.da.Pi ? b.xd = "" : e.u.i.da.Fe(this.measure.aa) ? b.Fe = !0 : e.u.i.da.ce(this.measure.aa) && (b.ce = !0, b.xd = "%");
              const c = e.u.i.Qa.ic == this.measure.type && e.u.i.da.hp(this.measure.aa),
                d = e.u.i.Qa.Ta == this.measure.type || e.u.i.Qa.Lc == this.measure.type;
              b = c ? e.P.Lx(a, e.model.C.F.ep) : d ? this.cell.label : u.cc.format(a, b);
              b = e.P.bind(e.model.B.j.Ola, e.P.Go(this.measure.label, !0, !0), b);
              return b = b.replace(/<br\s*[\/]?>/gi, " ");
            }
            get ICa() {
              return e.model.C.F.Gia ? e.u.Ma.R().fa.iU : !1;
            }
            get mDa() {
              return !e.model.Va.R().Fa.fa.Ic && e.model.Va.R().Fa.fa.Ba != e.u.i.qa.hg && e.model.Va.R().Fa.fa.Ba != e.u.i.qa.API;
            }
            getData(b, a) {
              return e.v(this.Ag) ? null : 0 == b ? this.fD(a) : 0 > a || a >= this.Ag.Wo.length ? null : this.qH(b, a);
            }
            fD(b) {
              const a = new k.Y.W.le();
              a.ll = !0;
              a.Ah = !0;
              if (0 > b || b >= this.Ag.Wo.length) return null;
              var c = this.Ag.Wo[b].level;
              b = this.Qb.Yc.ph(this.Ag.Wo[b].hierarchy);
              if (null == b) return null;
              void 0 !== c && (c = b.Cu(c), null != c && (a.label = b.caption + " / " + c.caption));
              e.ia(a.label) && (a.label = b.caption);
              a.hierarchy = b;
              a.measure = this.Qb.Yc.mf(b.A);
              this.mDa && (a.On = !0, a.hierarchy == this.bS && (a.Zo = this.Nh == e.u.i.Aa.kc, a.$o = this.Nh == e.u.i.Aa.Mc));
              return a;
            }
            qH(b, a) {
              if (e.v(this.data) || e.v(this.data[b - 1])) return null;
              var c = this.Qb.Yc.ph(this.Ag.Wo[a].hierarchy);
              if (null == c) return null;
              const d = this.Qb.mf(c.A);
              return null == d ? null : this.Nda(b, a, c, d);
            }
            Nda(b, a, c, d) {
              const g = new k.Y.W.le();
              g.lb = b;
              g.mc = a;
              g.ll = !0;
              g.hi = !0;
              const l = c.za(this.YAa(b, this.Wda(c)));
              g.label = this.SAa(l, -1 != a ? this.Ag.Wo[a].level : void 0);
              g.hierarchy = c;
              a = this.wT(d);
              d.type != e.u.i.Qa.jb && d.type != e.u.i.Qa.ic && d.type != e.u.i.Qa.Ta && d.type != e.u.i.Qa.Lc || e.v(l) || (g.value = l.fc, g.label = d.type == e.u.i.Qa.jb ? u.cc.format(g.value, a) : l.caption, g.numeric = g.numeric || d.type != e.u.i.Qa.jb ? g.numeric : !0);
              e.ia(a.textAlign) || g.Yy({
                "text-align": a.textAlign
              });
              g.sI = this.Hs(b);
              g.measure = d;
              return g;
            }
            Hs(b) {
              return isNaN(this.tI) ? void 0 : this.data[b - 1][this.tI];
            }
            wT(b) {
              e.v(this.bI[b.A]) && (this.bI[b.A] = b.ci(b.A, b.aa, !0).clone());
              return this.bI[b.A];
            }
            YAa(b, a) {
              for (; null == this.data[b - 1][a];) a--;
              return this.data[b - 1][a];
            }
            SAa(b, a) {
              let c = "";
              if (e.v(b)) return c;
              c = b.caption;
              if (!e.ia(a)) for (; b;) {
                if (b.level.A == a) {
                  c = b.caption;
                  break;
                }
                b = b.parent;
              }
              return c;
            }
            Wda(b) {
              var a = this.keys.indexOf(b.A);
              2 < b.wa.length && (a = this.keys.indexOf(b.wa.Oh(b.wa.length - 1)));
              return a;
            }
            saveData(b, a, c) {
              (a = this.getData(b, a)) && a.label != c && a.value != c && (c = this.pn.save(this.th, this.Gg, a.hierarchy, c, b - 1), this.data[b - 1][this.keys.indexOf(a.hierarchy.A)] = c, this.d0 = !0);
            }
            dispose() {
              this.keys = this.data = this.measure = this.th = this.Gg = this.Ag = this.Qb = this.pn = null;
              this.tI = NaN;
              this.bI = this.Nh = this.bS = null;
            }
          }
          f.VO = "dataloaded";
          h.dF = f;
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends k.Y.e8 {
            show(b, a) {
              var c = [];
              c = this.uS(c, b ? b.Sa() : null, "drillthrough");
              return 0 < c.length ? (this.BS(c, a), !0) : !1;
            }
          }
          h.Rla = f;
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b {
              constructor() {
                this.qk = [];
                this.vn = [];
                this.lf = new e.ub();
              }
              get selected() {
                return this.qk;
              }
              set selected(a) {
                e.v(a) || (this.qk = a, this.vn = null);
              }
              sG(a) {
                this.zd(a) || (this.qk.push(a), this.vn = null);
              }
              WIa(a) {
                this.RT ? this.vn.splice(a, 1) : (this.qk.splice(a, 1), this.vn = null);
              }
              get RT() {
                return !e.v(this.vn) && this.qk.length !== this.vn.length;
              }
              zEa(a, c) {
                this.RT ? e.Ja.j3(this.vn, a, c) : (e.Ja.j3(this.qk, a, c), this.vn = null);
              }
              zd(a) {
                return this.RT ? 0 <= this.vn.findIndex(c => void 0 !== c.level ? c.level === a : c.hierarchy === a) : 0 <= this.qk.indexOf(a);
              }
              get Wo() {
                if (!e.v(this.vn)) return this.vn;
                this.vn = [];
                for (let d = 0; d < this.qk.length; d++) {
                  var a = this.lf.getItem(this.qk[d]);
                  if (!e.v(a)) if (a = a.wa, void 0 !== a && 1 < a.length) for (var c = 0; c < a.length; c++) this.vn.push({
                    hierarchy: this.qk[d],
                    level: a[c]
                  });else this.vn.push({
                    hierarchy: this.qk[d]
                  });
                }
                return this.vn;
              }
              isEqual(a) {
                if (e.v(a) || e.v(a.qk) || this.qk.length != a.qk.length) return !1;
                for (let c = 0; c < this.qk.length; c++) if (this.qk[c] != a.qk[c]) return !1;
                return !0;
              }
              clone() {
                const a = new b();
                a.lf = this.lf.slice();
                a.qk = a.qk.slice();
                return a;
              }
            }
            f.n7 = b;
          })(h.jr || (h.jr = {}));
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends x.Na {
              constructor() {
                super();
                this.$("fm-fields-view-wrap");
                this.Ie();
                this.Qe = new f.Ula(k.Nb.Gb.G);
                this.Qe.N(v.ga.CLOSED, () => this.vN());
                this.Qe.N(k.od.np.mJ, a => this.n3(a));
              }
              Ie() {
                this.Xs = new x.Qg("fm-btn-open-fields");
                this.Xs.ki(e.model.B.j.hQ);
                this.Xs.N(x.Nd.tf, () => this.V3());
                this.X(this.Xs);
              }
              updateLabels() {
                this.Xs.ki(e.model.B.j.hQ);
              }
              open(a) {
                this.G.$a("fm-fields-opened", !0);
                this.Qe.zq(a);
                this.Qe.view.open();
                this.Xv = !0;
              }
              close() {
                this.Qe.view.Za();
                this.Qe.view.close();
              }
              V3() {
                this.Ya(k.od.np.WO);
              }
              vN() {
                this.Xv = !1;
                this.G.$a("fm-fields-opened", !1);
              }
              n3(a) {
                this.Ea(a);
              }
              get Vu() {
                return this.Xv;
              }
            }
            f.Tla = b;
          })(h.jr || (h.jr = {}));
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.od.flat.x6 {
              constructor(a) {
                super(a);
              }
              zq(a, c) {
                this.Qb = a;
                this.Nt = c;
                this.Pa = a.lf.Pc();
                this.pl(a.selected);
                this.DI(this.Pa, a.selected);
              }
              get slice() {
                return this.Qb;
              }
              get FD() {
                return !1;
              }
              get xU() {
                return !1;
              }
              BM(a) {
                const c = this.Qb.clone();
                c.selected = this.mja(this.Pa, a).map(d => d.A);
                return c;
              }
              yU() {
                return !1;
              }
              cv() {}
              dv() {}
              update() {}
              zE() {}
            }
            f.Vla = b;
          })(h.jr || (h.jr = {}));
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.od.flat.Y7 {
              constructor(a) {
                super(a);
                this.$("fm-fields-view");
                this.$("fm-dt-fields");
                this.aE.$("fm-dt-fields-overlay");
                k.Nb.Gb.G.X(this.G);
              }
            }
            f.Wla = b;
          })(h.jr || (h.jr = {}));
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends k.od.flat.DX {
              constructor(a) {
                super(a, !1);
                this.model = this.Hb;
              }
              qS(a) {
                return new f.Vla(a);
              }
              Sba(a) {
                return new f.Wla(a);
              }
              zq(a) {
                this.model.zq(a, k.od.np.OS);
                this.$m();
                this.view.Yd && this.view.Yd.Gf(this.Hb.E1());
                this.view.dg();
              }
              fe() {
                var a = [];
                const c = this.view.fb.G.find("li", !0);
                for (let d = 0; d < c.length; d++) {
                  const g = parseInt(c[d].attr("data-index"));
                  a.push(g);
                }
                a = this.Hb.BM(a);
                this.model.slice.isEqual(a) || this.Ya(k.od.np.mJ, this, a);
              }
            }
            f.Ula = b;
          })(h.jr || (h.jr = {}));
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.dF {
              constructor(a) {
                super(a);
                this.df = e.u.Ma.R();
              }
              get GN() {
                return e.v(this.data) ? 0 : this.data.length - 1;
              }
              C4() {}
              Ud() {
                this.data = [];
                this.df.bd(this.th, this.Gg, this.measure, a => this.kq(a), this.Ag.selected);
              }
              kq(a) {
                this.data = a;
                e.Da(!1);
                this.Ya(h.dF.VO);
              }
              Gda(a) {
                a = this.df.fa.mapping.La(a, "time_zone");
                return e.v(a) ? e.model.C.F.Uj : (a = Number(a.split(":", 1)[0]), isNaN(a) ? e.model.C.F.Uj : a);
              }
              qH(a, c) {
                if (e.v(this.data) || e.v(this.data[a])) return null;
                var d = this.Qb.Yc.ph(this.Ag.selected[c]);
                if (null == d) return null;
                var g = this.Qb.mf(d.A);
                if (null == g) return null;
                const l = this.data[a][c];
                g = this.wT(g);
                const m = new k.Y.W.le();
                m.lb = a;
                m.mc = c;
                m.ll = !0;
                m.hi = !0;
                if (d.type == e.u.i.Fc.qp) "number" == typeof l && (m.label = u.cc.format(l, g), m.value = l);else if (d.type == e.u.i.Fc.Ta) {
                  if ("number" === typeof l) a = this.Fda(d.A), d = this.Gda(d.A), m.label = e.P.Kx(l, a, d), m.value = l;else if ("string" !== typeof l || e.ia(l)) m.label = e.model.B.j.Wn;else try {
                    const n = e.P.gU(l),
                      p = this.Fda(d.A),
                      t = this.Gda(d.A);
                    m.label = n ? u.Eh.format(new Date(l), p, t) : l;
                  } catch (n) {
                    m.label = l;
                  }
                } else m.label = l;
                e.ia(g.textAlign) || m.Yy({
                  "text-align": g.textAlign
                });
                return m;
              }
              Fda(a) {
                return this.df.fa.mapping.La(a, "format", e.model.C.F.Lp);
              }
              dispose() {
                super.dispose();
                this.df = null;
              }
            }
            f.V8 = b;
          })(h.Qs || (h.Qs = {}));
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends h.dF {
              constructor(a) {
                super(a);
                this.df = e.u.Ma.R();
              }
              update() {
                let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                let g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                this.Qb = a;
                this.th = d;
                this.Gg = c;
                this.measure = g;
                this.bI = {};
                this.Ud();
              }
              C4() {}
              Ud() {
                this.data = [];
                this.df.bd(this.th, this.Gg, this.measure, a => this.kq(a));
              }
              zq(a) {
                this.Ag = a;
                this.EY = {};
                for (a = 0; a < this.Ag.selected.length; a++) {
                  var c = this.Ag.selected[a];
                  this.EY[c] = this.Ag.lf.indexOf(c);
                }
                this.Ya(h.dF.VO);
              }
              kq(a) {
                e.Da(!1);
                this.data = a;
                this.zq(this.X_(this.Qb));
              }
              X_(a) {
                const c = new h.jr.n7();
                for (var d of this.data[0]) d = d.replace("$", ""), c.lf.Ua(d, {
                  A: d,
                  caption: this.XAa(d)
                });
                if (!e.model.C.F.h5 && this.df.fa.iU) {
                  var g = a.flatten();
                  d = c.lf.Pc(!0);
                  for (var l = 0; l < g.length; l++) {
                    var m = g.ea(l);
                    if (2 >= m.wa.length) m = this.dEa(m, d), e.ia(m) || c.sG(m);else if (null != m.lc) m = m.xf.split("."), m = 0 < m.length ? m[0] + "." + m[m.length - 1] : null, -1 < d.indexOf(m) && c.sG(m);else {
                      m = m.A.split(".");
                      for (let n = 0; n < d.length; n++) -1 < (m[0] == d[n].split(".")[0] ? n : -1) && c.sG(d[n]);
                    }
                  }
                  for (g = 0; g < a.Sf.length; g++) l = this.eEa(a.Sf[g], d), e.ia(l) || c.sG(l);
                }
                if (e.model.C.F.h5 || 0 == c.selected.length) c.selected = c.lf.Pc(!0);
                return c;
              }
              XAa(a) {
                a = a.split("].[").pop();
                a = "]" == a.charAt(a.length - 1) ? a.substr(0, a.length - 1) : a;
                return a = "[" == a.charAt(0) ? a.substr(1) : a;
              }
              dEa(a, c) {
                for (var d = 0; d < c.length; d++) {
                  var g = c[d];
                  if (g == a.A || 0 <= g.indexOf(`[${a.caption}]`)) return g;
                }
                return null;
              }
              eEa(a, c) {
                for (var d = 0; d < c.length; d++) {
                  var g = c[d];
                  if (g == a.A) return g;
                  var l = a.A.split(".");
                  if (g == `[${a.Ig}].${l[l.length - 1]}`) return g;
                  l = g;
                  l = "[" == l.charAt(0) ? l.substr(1) : l;
                  if (0 <= a.A.indexOf(l)) return g;
                }
                return null;
              }
              fD(a) {
                const c = new k.Y.W.le();
                c.ll = !0;
                c.Ah = !0;
                a = this.Ag.selected[a];
                if (e.v(a)) return null;
                c.label = this.Ag.lf.getItem(a).caption;
                return c;
              }
              qH(a, c) {
                if (e.v(this.data) || e.v(this.data[a])) return null;
                var d = this.Ag.selected[c];
                const g = "[Measures].[" + this.Ag.lf.getItem(d).caption + "]",
                  l = this.pn.Ca.find(n => n.A === g);
                d = this.data[a][this.EY[d]];
                const m = new k.Y.W.le();
                m.lb = a;
                m.mc = c;
                m.ll = !0;
                m.hi = !0;
                e.model.C.F.Rn || null == l ? "number" == typeof d ? (m.label = e.model.C.F.Rn || null != l ? u.cc.format(d) : u.cc.format(d, e.model.ac.pj.pT()), m.value = d) : (m.label = d, null == l && m.Yy({
                  "text-align": "left"
                })) : (a = this.wT(l), m.label = u.cc.format(d, a), m.value = d, "" != a.textAlign && m.Yy({
                  "text-align": a.textAlign
                }));
                return m;
              }
              dispose() {
                super.dispose();
                this.EY = this.df = null;
              }
            }
            f.Q8 = b;
          })(h.Qs || (h.Qs = {}));
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    var db = q || (q = {}),
      eb = db.K || (db.K = {}),
      fb = eb.Uf || (eb.Uf = {}),
      gb = fb.Qs || (fb.Qs = {});
    class hb extends gb.Q8 {}
    gb.bpa = hb;
    (function (e) {
      (function (k) {
        (function (h) {
          (function (f) {
            class b extends f.V8 {
              qH(a, c) {
                if (e.v(this.data) || e.v(this.data[a])) return null;
                var d = this.Ag.Wo[c].level,
                  g = this.Qb.Yc.ph(this.Ag.Wo[c].hierarchy);
                if (null == g) return null;
                var l = d ? g.Cu(d) : null,
                  m = this.Qb.mf(g.A);
                if (null == m) return null;
                d = this.data[a][c];
                m = this.wT(m);
                const n = new k.Y.W.le();
                n.lb = a;
                n.mc = c;
                n.ll = !0;
                n.hi = !0;
                g.type === e.u.i.Fc.qp ? (n.label = "number" === typeof d ? u.cc.format(d, m) : d, n.value = d) : g.type === e.u.i.Fc.Ta || l && e.u.i.ib.yCa(l.type) ? "number" == typeof d ? (l && l.type === e.u.i.ib.Lc ? (a = this.df.fa.mapping.La(g.A, "format", e.model.C.F.zk), n.label = e.P.iO(d, a, e.model.C.F.Uj)) : (a = this.df.fa.mapping.La(g.A, "format", e.model.C.F.Lp), n.label = e.P.Kx(d, a, e.model.C.F.Uj)), n.value = d) : "string" !== typeof d || e.ia(d) || "null" === d ? n.label = !e.model.C.F.ir || null !== d && "null" !== d ? e.model.B.j.Wn : e.model.B.j.hX : n.label = d : n.label = d;
                e.ia(m.textAlign) || n.Yy({
                  "text-align": m.textAlign
                });
                return n;
              }
            }
            f.Zja = b;
          })(h.Qs || (h.Qs = {}));
        })(k.Uf || (k.Uf = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h {}
        h.$x = "FILTER_OPEN";
        h.AX = "FILTER_CLOSE";
        h.kX = "DRILL_THROUGH_OPEN";
        h.O6 = "CONTEXT_MENU_OPEN";
        h.eY = "RENDER_COMPLETE";
        h.Sx = "beforegriddraw";
        h.ip = "aftergriddraw";
        k.Si = h;
        class f extends v.ga {
          constructor(a) {
            super(h.$x);
            this.hierarchy = a;
          }
        }
        k.hP = f;
        class b extends v.ga {
          constructor(a, c, d, g) {
            super(h.kX);
            this.measure = a;
            this.Gg = c;
            this.th = d;
            this.cell = g;
          }
        }
        k.m7 = b;
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.qs = [];
              this.Hd = new e.kF();
              this.qe = [];
              this.sd = "";
              this.Ee = !0;
            }
            eW(b) {
              this.xh = b;
            }
            via(b) {
              this.fg = b;
              this.qs = this.xh.ck(this.xh.wd, !1, this.fg);
            }
            $ha(b, a) {
              var c = this.Ve() ? this.qe : this.qs;
              b = c.indexOf(b.ordinal);
              a = c.indexOf(a.ordinal);
              for (a < b && (b = a + (a = b, 0)); b <= a; b++) this.select(c[b], !0);
            }
            select(b, a) {
              this.Ee != a ? this.Hd.add(b) : this.Hd.delete(b);
              this.Hd.size != this.qs.length || this.Ve || this.selectAll(!this.Ee);
            }
            search(b, a) {
              b = b.toLowerCase();
              this.sd === b ? a(this.qe) : (this.sd = b, 0 == this.sd.length ? a() : e.u.Ma.R().uq(this.xh, b, a));
            }
            uia(b) {
              null != b ? this.qe = b : this.qe.length = 0;
            }
            selectAll(b) {
              if (this.Ve()) for (var a = this.qe.length, c = 0; c < a; c++) e.P.contains(this.xh.za(this.qe[c]).caption, this.sd) && this.select(this.qe[c], b);else this.Ee = b, this.Hd.clear();
            }
            Yha() {}
            Tw() {
              var b = this.Ee || this.Ve() ? this.Ee && this.Ve() ? this.qe.length + this.zwa() - this.Hd.size : this.Ee || 0 != this.Hd.size ? this.qs.length == this.Hd.size ? this.qe.length : this.qs.length - this.Hd.size : this.Hd.size : this.Hd.size;
              return 0 < b ? b : 0;
            }
            zwa() {
              let b = 0;
              for (let a = 0; a < this.qe.length; a++) this.Hd.has(this.qe[a]) && b++;
              return this.Hd.size - b;
            }
            uz() {
              if (this.Ve()) {
                for (var b = 0, a = 0; a < this.qe.length; a++) !this.Hd.has(this.qe[a]) == this.Ee && b++;
                return b;
              }
              return this.Tw();
            }
            bW(b) {
              this.Hd.clear();
              var a = b.length;
              this.Ee = 0 == a;
              if (!this.Ee) for (let c = 0; c < a; c++) this.Hd.add(b[c]);
            }
            qT() {
              const b = [];
              var a = this.Ve() && this.Ee ? this.qe : this.Hd.Pc();
              const c = a.length;
              if (this.Ve() && this.Ee) for (a = 0; a < this.qe.length; a++) this.Hd.has(this.qe[a]) || b.push(this.qe[a]);else for (let d = 0; d < c; d++) b[d] = a[d];
              a = this.Ve() && this.Ee ? !1 : 0 == b.length ? !1 : this.Ee;
              return {
                items: b,
                bv: a
              };
            }
            fW(b) {
              this.qs = b;
              this.sd = "";
              this.qe.length = 0;
            }
            v1(b, a) {
              const c = [];
              let d = b;
              var g = e.P.Go(this.sd.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), !0, !0);
              g = new RegExp("(" + g + ")", "ig");
              const l = this.Ve() ? this.qe : this.qs;
              let m;
              for (; d < a && !(d > l.length - 1); d++) {
                var n = this.xh.za(l[d]);
                m = e.P.Go(n.caption, !0, !0);
                n = {
                  Zb: n,
                  label: this.Ve() ? m.replace(g, '<b class="fm-search-highlight">$&</b>') : m,
                  zd: (this.Hd.has(n.ordinal) ? !this.Ee : this.Ee) ? 1 : 0,
                  Gfa: 0,
                  rJa: a - b < l.length - 1 ? 15 : 0,
                  Zg: n.Zg && "Others" !== m
                };
                c.push(n);
              }
              return c;
            }
            getItem(b) {
              return (this.Ve() ? this.qe : this.qs)[b];
            }
            wH() {
              return this.Ve() ? this.qe.length : this.qs.length;
            }
            getTotalLength() {
              return this.wH();
            }
            Ve() {
              return 0 < this.sd.length;
            }
            expand() {}
            collapse() {}
          }
          h.YX = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              this.md = [];
              this.Hd = [];
              this.qe = [];
              this.Ok = [];
              this.jz = [];
              this.sd = "";
              this.Ee = !0;
              this.fg = e.u.i.Aa.ed;
            }
            eW(b) {
              this.xh = b;
              this.md.length = 0;
            }
            via(b) {
              this.fg = b;
              this.md.length = 0;
              this.g2(this.xh.wd, -1);
            }
            fW(b) {
              for (var a = 0, c = b.length, d; a < c; a++) d = this.xh.za(b[a]), d.dc || (this.md.push(b[a]), d.Yg && d.children && 0 < d.children.length && (this.jz.push(b[a]), this.fW(this.fg === e.u.i.Aa.ed ? d.children.slice() : this.xh.ck(d, !1, this.fg))));
            }
            v1(b, a) {
              var c = b,
                d = [],
                g = new RegExp("(" + this.sd + ")", "i"),
                l = this.Ve() ? this.qe : this.md;
              let m;
              for (; c < a && !(c > l.length - 1); c++) {
                var n = this.xh.za(l[c]);
                m = e.P.Go(n.caption, !0, !0);
                n = {
                  Zb: n,
                  Gfa: n.level.yb,
                  label: this.Ve() ? m.replace(g, '<b class="fm-search-highlight">$&</b>') : m,
                  zd: this.zd(n),
                  Ve: this.Ve(),
                  $f: this.$f(n),
                  rJa: a - b < l.length - 1 ? 17 : 0,
                  Zg: n.Zg && "Others" != n.caption,
                  OT: this.OT(n)
                };
                d.push(n);
              }
              return d;
            }
            getItem(b) {
              return (this.Ve() ? this.qe : this.md)[b];
            }
            zd(b) {
              var a = (-1 == this.Hd.indexOf(b.ordinal) ? this.Ee : !this.Ee) ? 1 : 0;
              0 < this.Hd.length && -1 != this.Ok.indexOf(b.ordinal) && (a = -1);
              return a;
            }
            OT(b) {
              return this.Ve() ? !1 : !b.Sh;
            }
            $f(b) {
              return this.Ve() || b.Sh ? void 0 : -1 != this.jz.indexOf(b.ordinal) ? !0 : !1;
            }
            wH() {
              return this.Ve() ? this.qe.length : this.md.length;
            }
            getTotalLength() {
              if (this.Ve()) {
                let c = 0;
                if (e.u.Ma.R().fa.Ic) for (var b = this.qe.length, a = 0; a < b; a++) e.P.contains(this.xh.za(this.qe[a]).caption, this.sd) || c++;
                return this.qe.length - c;
              }
              return this.xh ? this.xh.Wi - 1 : 0;
            }
            $ha(b, a) {
              var c = this.Ve() ? this.qe : this.md;
              b = c.indexOf(b.ordinal);
              a = c.indexOf(a.ordinal);
              for (a < b && (b = a + (a = b, 0)); b <= a; b++) this.select(this.xh.za(c[b]), !0);
            }
            select(b, a) {
              var c = this.Hd.indexOf(b.ordinal);
              this.Ee !== a ? (-1 == c && this.Hd.push(b.ordinal), 0 < b.children.length && this.FV(b)) : (-1 != c && this.Hd.splice(c, 1), 0 < b.children.length && this.I4(b));
              a = this.Ok.indexOf(b.ordinal);
              -1 != a && this.Ok.splice(a, 1);
              this.Zha(b);
              this.Hd.length === this.xh.Wi - 1 && (this.Hd.length = 0, this.Ok.length = 0, this.Ee = !this.Ee);
            }
            Yha(b) {
              -1 == this.Ok.indexOf(b.ordinal) && (-1 == this.Hd.indexOf(b.ordinal) ? this.I4(b) : this.FV(b));
            }
            Zha(b) {
              var a = b.parent;
              if (a && !a.dc) {
                b = this.Hd.indexOf(a.ordinal);
                var c = this.Ok.indexOf(a.ordinal);
                var d = -1 != b;
                this.tea(a, !1) ? (this.tea(a) ? (-1 == c && this.Ok.push(a.ordinal), this.Ee && d && this.Hd.splice(b, 1)) : (-1 != c && this.Ok.splice(c, 1), this.Ee && !d && this.Hd.push(a.ordinal)), !this.Ee && d && this.Hd.splice(b, 1)) : (-1 != c && this.Ok.splice(c, 1), this.Ee && d ? this.Hd.splice(b, 1) : this.Ee || d || this.Hd.push(a.ordinal));
                this.Zha(a);
              }
            }
            tea(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              var c = 0;
              b = b.children;
              for (var d = b.length; c < d; c++) if (-1 == this.Hd.indexOf(b[c]) == this.Ee == a || -1 != this.Ok.indexOf(b[c])) return !0;
              return !1;
            }
            FV(b) {
              var a = 0;
              b = b.children;
              for (var c = b.length; a < c; a++) {
                var d = this.Hd.indexOf(b[a]);
                var g = this.Ok.indexOf(b[a]);
                -1 == d && this.Hd.push(b[a]);
                -1 != g && this.Ok.splice(g, 1);
                d = this.xh.za(b[a]);
                0 < d.children.length && this.FV(d);
              }
            }
            I4(b) {
              for (var a = 0, c, d, g = b.children, l = g.length; a < l; a++) d = this.xh.za(g[a]), b = this.Hd.indexOf(g[a]), c = this.Ok.indexOf(g[a]), -1 != b && this.Hd.splice(b, 1), -1 != c && this.Ok.splice(c, 1), 0 < d.children.length && this.I4(d);
            }
            selectAll(b) {
              if (this.Ve()) for (var a = this.qe.length, c, d = 0; d < a; d++) c = this.xh.za(this.qe[d]), e.P.contains(c.caption, this.sd) && this.select(c, b);else this.Ee = b, this.Hd.length = 0, this.Ok.length = 0;
            }
            uz() {
              if (this.Ve()) {
                for (var b = 0, a = this.qe.length, c, d = 0; d < a; d++) c = this.xh.za(this.qe[d]), e.P.contains(c.caption, this.sd) && 0 > this.Hd.indexOf(this.qe[d]) == this.Ee && b++;
                return b;
              }
              return this.Tw();
            }
            Tw() {
              var b = this.Ee ? this.xh.Wi - this.Hd.length - this.Ok.length - 1 : this.Hd.length;
              return 0 > b ? 0 : b;
            }
            bW(b) {
              var a = b.length;
              this.Hd.length = 0;
              this.Ok.length = 0;
              if (0 == a) this.Ee = !0;else {
                this.Ee = !1;
                for (var c, d = 0; d < a; d++) for (c = this.xh.za(b[d]), this.Hd.push(c.ordinal), 0 < c.children.length && this.FV(c); c.parent && !c.parent.dc;) c = c.parent, -1 == this.Ok.indexOf(c.ordinal) && this.Ok.push(c.ordinal);
              }
            }
            qT() {
              var b = [];
              var a = this.Ve() && this.Ee ? this.qe : this.Hd;
              for (var c = 0, d = a.length; c < d; c++) {
                var g = this.xh.za(a[c]);
                var l = g.parent;
                var m = -1;
                e.v(l) || (m = a.indexOf(l.ordinal));
                -1 === m && b.push(g.ordinal);
              }
              g = this.Ve() && this.Ee ? !1 : 0 == b.length ? !1 : this.Ee;
              return {
                items: b,
                bv: g
              };
            }
            search(b, a) {
              b = b.toLowerCase();
              this.sd === b ? a() : (this.sd = b, 0 == this.sd.length ? a() : e.u.Ma.R().uq(this.xh, b, a));
            }
            uia(b) {
              null != b ? this.qe = b : this.qe.length = 0;
            }
            Ve() {
              return 0 < this.sd.length;
            }
            expand(b) {
              -1 == this.jz.indexOf(b.ordinal) && this.jz.push(b.ordinal);
              this.Fia(b, !0);
            }
            collapse(b) {
              var a = this.jz.indexOf(b.ordinal);
              -1 != a && this.jz.splice(a, 1);
              this.Fia(b, !1);
            }
            Fia(b, a) {
              var c = this.md.indexOf(b.ordinal);
              a ? this.g2(b, c) : this.md.splice(c + 1, this.$da(b));
            }
            g2(b, a) {
              b = this.fg === e.u.i.Aa.ed ? b.children : this.xh.ck(b, !1, this.fg);
              for (var c = b.length - 1, d = a + 1; -1 < c; c--) a = this.xh.za(b[c]), this.md.splice(d, 0, b[c]), -1 < this.jz.indexOf(b[c]) && this.g2(a, d);
            }
            $da(b) {
              b = b.children;
              for (var a = b.length, c = a, d, g = 0; g < a; g++) d = this.xh.za(b[g]), -1 < this.jz.indexOf(b[g]) && (c += this.$da(d));
              return c;
            }
          }
          h.apa = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.be.ik {
            constructor() {
              super();
              this.$("fm-filter-view-content");
              this.Ie();
            }
            Ie() {
              var b = new x.Na("div", "fm-popup-header fm-ui-row");
              this.X(b);
              var a = new x.Na("div", "fm-ui-col-2 fm-vam");
              b.X(a);
              this.Fr = new x.Vc();
              this.Fr.$("fm-popup-title");
              a.X(this.Fr);
              a = new x.Na("div", "fm-ui-col fm-vam fm-ui-btns-row");
              b.X(a);
              this.AG = new x.Qg("fm-ui-btn");
              this.AG.gb(e.model.B.j.El);
              this.Dp = new x.Qg("fm-ui-btn-dark");
              this.Dp.gb(e.model.B.j.Tx);
              u.qj.JD || u.qj.No ? (a.X(this.AG), a.X(this.Dp)) : (a.X(this.Dp), a.X(this.AG));
              b = new x.Na("div", "fm-ui-row fm-filter-sort-row");
              this.X(b);
              this.gH = new x.Na("div", "fm-ui-col fm-filters-col");
              b.X(this.gH);
              this.TS = new x.Vc();
              this.TS.$("fm-filter-label");
              this.TS.$("fm-ui-label-light");
              this.gH.X(this.TS);
              this.pf = new x.jQ();
              this.pf.$("fm-labels-filter-btn");
              this.pf.$("fm-filter-btn");
              this.UH = new x.Vc();
              this.pf.X(this.UH);
              this.pf.G.X(new x.Ga("div", "fm-ui-arrow-up", !1));
              this.gH.X(this.pf);
              this.Mf = new x.jQ();
              this.Mf.$("fm-values-filter-btn");
              this.Mf.$("fm-filter-btn");
              this.Nja = new x.Vc();
              this.Mf.X(this.Nja);
              this.Mf.G.X(new x.Ga("div", "fm-ui-arrow-up", !1));
              this.gH.X(this.Mf);
              this.an = new h.lra();
              this.an.$("fm-values-filter-view");
              this.an.Za();
              this.X(this.an);
              this.Do = new h.Qla();
              this.Do.$("fm-dates-filter-view");
              this.Do.Za();
              this.X(this.Do);
              this.bq = new h.Ona();
              this.bq.$("fm-labels-filter-view");
              this.bq.Za();
              this.X(this.bq);
              this.jq = new h.kpa();
              this.jq.$("fm-numbers-filter-view");
              this.jq.Za();
              this.X(this.jq);
              this.yq = new h.Tqa();
              this.yq.$("fm-time-filter-view");
              this.yq.Za();
              this.X(this.yq);
              this.bO = new x.Na("div", "fm-ui-col fm-sort-col");
              b.X(this.bO);
              this.uW = new x.Vc();
              this.uW.$("fm-sort-label");
              this.uW.$("fm-ui-label-light");
              this.uW.gb(e.model.B.j.Tma);
              this.bO.X(this.uW);
              b = new x.Na("div", "fm-sort-btns");
              this.bO.X(b);
              this.Uk = new x.jQ();
              this.Uk.$("fm-sort-btn");
              this.Uk.gb(e.model.B.j.M7);
              b.X(this.Uk);
              this.Vk = new x.jQ();
              this.Vk.$("fm-sort-btn");
              this.Vk.gb(e.model.B.j.P7);
              b.X(this.Vk);
              this.$b = new h.$oa();
              this.X(this.$b);
            }
            get Yd() {
              return this.$b.Yd;
            }
            get Ax() {
              return this.$b.Ax;
            }
            get Nn() {
              return this.$b.Nn;
            }
            dg() {
              this.Dp.gb(e.model.B.j.Tx);
              this.AG.gb(e.model.B.j.El);
              this.Uk.gb(e.model.B.j.M7);
              this.Uk.ki(e.model.B.j.N7);
              this.Uk.qc(e.model.B.j.N7);
              this.Vk.gb(e.model.B.j.P7);
              this.Vk.ki(e.model.B.j.Q7);
              this.Vk.qc(e.model.B.j.Q7);
              this.TS.gb(e.model.B.j.SA);
              this.UH.gb(e.model.B.j.eP);
              this.pf.qc(e.model.B.j.SA + " " + e.model.B.j.eP);
              this.Nja.gb(e.model.B.j.T7);
              this.Mf.qc(e.model.B.j.SA + " " + e.model.B.j.T7);
              this.Do.dg();
              this.bq.dg();
              this.jq.dg();
              this.yq.dg();
              this.an.dg();
              this.$b.dg();
            }
          }
          h.ina = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Ii.nB {
            constructor() {
              super();
              this.zDa = 20;
              this.xu = new x.uY();
              this.xu.Gd("fm-ui-toggle-btn");
              this.xu.$("fm-expand-toggle-btn");
              this.xu.N(v.ga.Zd, () => this.$Ea());
              this.xu.Je(-1);
              this.G.append(this.xu.G);
              this.sE = new x.cK();
              this.sE.G.G4("tabindex");
              this.sE.N(v.ga.Zd, b => this.h4(b.data));
              this.G.append(this.sE.G);
              this.ne("all");
            }
            $Ea() {
              var b = this.getData();
              b.$f = 1 == this.xu.getSelection();
              this.G.Ya(h.yJ.nJ, this, b);
            }
            h4(b) {
              var a = this.getData();
              a.zd = this.sE.getSelection();
              this.G.Ya(h.yJ.XP, this, {
                Zb: a,
                shiftKey: b.shiftKey
              });
            }
            nb() {
              if (this.Ls("data")) {
                const a = this.getData();
                if (this.xu && this.sE && a) {
                  this.G.U("padding-left", "");
                  var b = this.zDa * (a.Gfa - 1);
                  a.Ve || void 0 !== a.$f || (b += 30);
                  0 < b && this.G.U("padding-left", b + "px");
                  a.OT ? (this.xu.show(), this.xu.Gf(a.$f)) : this.xu.Za();
                  this.sE.gb(a[this.mr()], !0);
                  this.sE.Gf(a.zd);
                }
              }
            }
          }
          h.gna = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Ad.$qa {
            constructor() {
              super();
              this.EU = null;
              this.Je();
              this.ji((b, a) => this.JAa(b, a));
            }
            JAa(b, a) {
              var c = new h.gna();
              c.setData(b);
              c.Ym(a);
              c.N(f.XP, d => this.h4(d));
              c.N(f.nJ, d => this.CFa(d));
              return c;
            }
            fv(b) {
              super.fv(b);
              b = b.data.xl;
              b.zd = 1 == b.zd ? 0 : 1;
              this.N5(b);
            }
            h4(b) {
              this.N5(b.data.Zb, b.data.shiftKey);
            }
            N5(b) {
              let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              1 == b.zd && a && this.EU && this.rh().$ha(this.EU.Zb, b.Zb);
              this.nKa(b, 1 == b.zd);
              this.Ea(new v.ga(f.XP, this));
            }
            CFa(b) {
              this.tja(b.data);
            }
            tja(b) {
              b.$f ? 0 === b.Zb.children.length || b.Zb.zf ? e.model.Va.R().ja.Ik(b.Zb.hierarchy, b.Zb, () => this.Zj(b)) : this.Zj(b) : (this.rh().collapse(b.Zb), this.ne("data"), this.Ea(new v.ga(f.nJ, this)));
            }
            Zj(b) {
              e.Da(!1);
              this.rh().Yha(b.Zb);
              this.rh().expand(b.Zb);
              this.ne("data");
              this.Ea(new v.ga(f.nJ, this));
            }
            rh() {
              return this.vya;
            }
            f5(b) {
              this.vya = b;
            }
            qT() {
              return this.rh().qT();
            }
            bW(b) {
              this.rh().bW(b);
              this.ne("data");
            }
            uz() {
              return this.rh().uz();
            }
            Tw() {
              return this.rh().Tw();
            }
            getTotalLength() {
              return this.rh().wH();
            }
            IT() {
              return this.rh().getTotalLength();
            }
            nKa(b, a) {
              this.rh() instanceof h.YX ? this.rh().select(b.Zb.ordinal, a) : this.rh().select(b.Zb, a);
              this.EU = a ? b : null;
              this.ne("data");
            }
            selectAll(b) {
              this.rh().selectAll(b);
              this.EU = null;
              this.ne("data");
            }
            search(b, a) {
              this.rh().search(b, c => {
                this.rh().uia(c);
                this.ne("data");
                a();
              });
              this.G.$a("fm-is-searched", this.Ve());
            }
            Ve() {
              return this.rh().Ve();
            }
            eW(b) {
              this.rh().eW(b);
            }
            sort(b) {
              b !== this.rh().fg && (this.rh().via(b), this.ne("data"));
            }
          }
          f.XP = "_";
          f.nJ = "__";
          h.yJ = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              if (null != f.instance) throw "FilterModel is singleton!";
              this.gq = e.model.Va.R();
            }
            static R() {
              null == f.instance && (f.instance = new f());
              return f.instance;
            }
            static dispose() {
              f.instance = null;
            }
            update(b) {
              this.Ca = [];
              const a = this.gq.ja.pa.gd();
              for (let c = 0; c < a.length; c++) {
                const d = a[c],
                  g = new e.model.hb.jh(d.A, d.aa, d.index);
                g.label = d.caption;
                !b.filter.measure || -1 != b.filter.measure.index || g.A != b.filter.measure.A || "" != b.filter.measure.aa && g.aa != b.filter.measure.aa || (b.filter.measure.index = g.index);
                this.Ca.push(g);
              }
              this.jl = {};
              this.iia(b);
            }
            iia(b) {
              (this.hierarchy = b) ? (this.hierarchy.filter.zh && (this.jl.type = this.hierarchy.filter.type, this.hierarchy.filter.measure && (this.jl.measure = this.hierarchy.filter.measure.Sa()), this.hierarchy.filter.query && (this.jl.query = this.hierarchy.filter.query.clone())), this.md = this.hierarchy.eg !== e.u.i.Aa.ed ? this.hierarchy.ck(this.hierarchy.wd, !1, this.hierarchy.eg) : this.hierarchy.wd.children.slice(), this.N$ = e.model.hb.TA.tT(this.hierarchy)) : this.N$ = e.u.i.rb.NONE;
              this.kaa = this.gq.ja.O.hH.iea(this.hierarchy, this.Ln);
            }
            gd() {
              if (this.aj) {
                var b = this.gq.ja.O.mf(this.hierarchy.A),
                  a = new e.model.hb.jh(b.A, b.aa, b.index);
                a.label = b.caption;
                return [a];
              }
              return this.gq.ja.fa.Ic ? this.Ca.filter(c => {
                const d = this.gq.ja.O.fd(c.A);
                c = -1 < e.u.i.da.yA.indexOf(c.aa);
                return d && !d.Oa && !c;
              }) : this.Ca;
            }
            Lta(b) {
              var a = !1,
                c = !1;
              !e.v(this.hierarchy.filter.query) && e.v(b.query) ? (a = !0, this.hierarchy.oC(), this.gq.eb()) : e.v(b.query) || (c = this.fDa(b));
              var d = this.ffa(b);
              if (c || d) return a = {}, c && !e.v(b.measure) && (a.measure = b.measure), c && !e.v(b.query) && (a.query = b.query.Sa()), d && !e.v(b.md) && (a.members = b.md), d && !e.v(b.iz) && (a.exclude = b.iz), this.gq.yl(this.hierarchy.A, a), !0;
              a && this.gq.refresh();
              return !1;
            }
            mu() {
              this.gq.mu(this.hierarchy.A);
            }
            fDa(b) {
              if (b.type == e.u.i.rb.Ta) return this.xCa(b);
              if (b.type == e.u.i.rb.Zk) return this.TCa(b);
              if (b.type == e.u.i.rb.jb || b.type == e.u.i.rb.ic) return this.ZCa(b);
              if (b.type == e.u.i.rb.jo) return this.oDa(b);
            }
            xCa(b) {
              return this.hierarchy.filter.type !== b.type || this.hierarchy.filter.query.ua != b.query.ua ? !0 : 0 <= e.u.i.bc.si.indexOf(b.query.ua) ? !e.gh.D0(this.hierarchy.filter.query.value, b.query.value) : 0 <= e.u.i.bc.Qf.indexOf(b.query.ua) ? this.hierarchy.filter.query.value && b.query.value ? !e.gh.D0(this.hierarchy.filter.query.value[0], b.query.value[0]) || !e.gh.D0(this.hierarchy.filter.query.value[1], b.query.value[1]) : !0 : 0 <= e.u.i.bc.jy.indexOf(b.query.ua) ? this.hierarchy.filter.query.value !== b.query.value : !1;
            }
            TCa(b) {
              return this.hierarchy.filter.type !== b.type || this.hierarchy.filter.query.ua != b.query.ua ? !0 : 0 <= e.u.i.Cb.si.indexOf(b.query.ua) ? this.hierarchy.filter.query.value !== b.query.value : 0 <= e.u.i.Cb.Qf.indexOf(b.query.ua) ? e.v(this.hierarchy.filter.query.value) || e.v(b.query.value) ? !0 : this.hierarchy.filter.query.value[0] !== b.query.value[0] || this.hierarchy.filter.query.value[1] !== b.query.value[1] : !1;
            }
            ZCa(b) {
              return this.hierarchy.filter.type !== b.type || this.hierarchy.filter.query.ua !== b.query.ua ? !0 : 0 <= e.u.i.Pg.si.indexOf(b.query.ua) ? this.hierarchy.filter.query.value !== b.query.value : 0 <= e.u.i.Pg.Qf.indexOf(b.query.ua) ? e.v(this.hierarchy.filter.query.value) || e.v(b.query.value) ? !0 : this.hierarchy.filter.query.value[0] !== b.query.value[0] || this.hierarchy.filter.query.value[1] !== b.query.value[1] : !1;
            }
            oDa(b) {
              return this.hierarchy.filter.type !== b.type || this.hierarchy.filter.measure.A !== b.measure.uniqueName || this.hierarchy.filter.measure.aa !== b.measure.aggregation || this.hierarchy.filter.query.ua != b.query.ua ? !0 : 0 <= e.u.i.Vb.si.indexOf(b.query.ua) ? this.hierarchy.filter.query.value !== b.query.value : 0 <= e.u.i.Vb.Qf.indexOf(b.query.ua) ? e.v(this.hierarchy.filter.query.value) || e.v(b.query.value) ? !0 : this.hierarchy.filter.query.value[0] !== b.query.value[0] || this.hierarchy.filter.query.value[1] !== b.query.value[1] : !1;
            }
            ffa(b) {
              if (null == b) return this.hierarchy.filter.Ei;
              if (null == b.md && null == b.iz) return !1;
              var a = this.hierarchy.filter.yj();
              if (b.md) {
                var c = b.md;
                if (c.length != a.length) return !0;
                for (var d = 0, g = c.length; d < g; d++) if (-1 == a.indexOf(c[d])) return !0;
              }
              if (b.iz) {
                b = b.iz;
                if (a.length + b.length !== this.hierarchy.Wi - 1) return !0;
                d = 0;
                for (g = b.length; d < g; d++) if (-1 == a.indexOf(b[d])) return !0;
              }
              return !1;
            }
            fua(b) {
              b != this.hierarchy.eg && this.gq.AE(this.hierarchy.A, b);
            }
            get D2() {
              return !this.aj && this.gq.ja.pa.ob.Bb(this.hierarchy.A);
            }
            get Ic() {
              return this.gq.Fa.fa.Ic;
            }
            get aj() {
              return e.model.C.F.tc && e.model.C.F.ke != k.Id.kj;
            }
            get Ln() {
              return this.N$;
            }
            get ap() {
              return this.kaa ? this.kaa : new e.u.O.Dqa();
            }
            get Ww() {
              return this.jl.type == e.u.i.rb.Ta || this.jl.type == e.u.i.rb.Zk || this.jl.type == e.u.i.rb.jb || this.jl.type == e.u.i.rb.ic;
            }
            get ei() {
              return this.jl.type == e.u.i.rb.jo;
            }
          }
          h.W7 = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends v.Fh {
            constructor() {
              super();
              this.model = h.W7.R();
              this.view = new h.ina();
              null != this.view.XBa && this.view.XBa.N(v.ga.Zd, b => this.XFa(b));
              null != this.view.Nn && (this.view.Nn.N(x.Oj.Wx, b => this.dHa(b.data)), this.view.Nn.N(x.Oj.OA, () => this.fHa()), this.view.Nn.N(x.Oj.r7, () => this.eHa()));
              this.view.$b && this.view.$b.Kd && (this.view.$b.Kd.N(h.yJ.XP, () => this.BGa()), this.view.$b.Kd.N(h.yJ.nJ, () => this.zGa()), this.view.$b.Kd.N("keydown", b => this.AGa(b)));
              null != this.view.Yd && this.view.Yd.N(v.ga.Zd, () => this.i4());
              null != this.view.Uk && this.view.Uk.N(v.ga.Zd, () => this.lHa());
              null != this.view.Vk && this.view.Vk.N(v.ga.Zd, () => this.mHa());
              null != this.view.pf && this.view.pf.N(v.ga.Zd, () => this.eGa());
              null != this.view.Do && this.view.Do.N(v.ga.kp, () => this.mV());
              null != this.view.bq && this.view.bq.N(v.ga.kp, () => this.mV());
              null != this.view.jq && this.view.jq.N(v.ga.kp, () => this.mV());
              null != this.view.yq && this.view.yq.N(v.ga.kp, () => this.mV());
              null != this.view.Mf && this.view.Mf.N(v.ga.Zd, () => this.yHa());
              null != this.view.an && this.view.an.N(v.ga.kp, () => this.xHa());
              null != this.view.Dp && this.view.Dp.N(x.Nd.tf, () => this.JEa());
              null != this.view.AG && this.view.AG.N(x.Nd.tf, () => this.Ts());
            }
            xHa() {
              this.view.Mf && (this.view.Mf.Gd("fm-has-filter"), this.view.Mf.Gf(0), this.QN(), this.LI());
            }
            mV() {
              this.view.pf && (this.view.pf.Gd("fm-has-filter"), this.view.pf.Gf(0), this.QN(), this.LI());
            }
            eGa() {
              this.view.Mf && this.view.Mf.Gf(0);
              this.QN();
              this.LI();
            }
            yHa() {
              this.view.pf && this.view.pf.Gf(0);
              this.QN();
              this.LI();
            }
            JEa() {
              var b = this.model.Lta(this.kAa());
              this.model.fua(this.mAa());
              b || this.Ya("close");
            }
            QN() {
              this.view.Do && this.view.Do.isVisible(this.Yw && 1 === this.view.pf.getSelection() && this.model.Ln == e.u.i.rb.Ta);
              this.view.bq && this.view.bq.isVisible(this.Yw && 1 === this.view.pf.getSelection() && this.model.Ln == e.u.i.rb.Zk);
              this.view.jq && this.view.jq.isVisible(this.Yw && 1 === this.view.pf.getSelection() && this.model.Ln == e.u.i.rb.jb);
              this.view.yq && this.view.yq.isVisible(this.Yw && 1 === this.view.pf.getSelection() && this.model.Ln == e.u.i.rb.ic);
              this.view.an && this.view.an.isVisible(this.Cz && 1 === this.view.Mf.getSelection());
              this.view.$b && (this.view.$b.isVisible(this.model.ap.gfa && 0 == this.view.Mf.getSelection() && 0 == this.view.pf.getSelection()), this.view.$b.isVisible() && this.view.$b.Kd.Kr());
              this.view.$a("fm-query-filter-opened", !1);
              this.view.pf && 1 === this.view.pf.getSelection() && this.view.$a("fm-query-filter-opened", !0);
              this.view.Mf && 1 === this.view.Mf.getSelection() && this.view.$a("fm-query-filter-opened", !0);
              this.view.$a("fm-no-query-filters", !this.Yw && !this.Cz);
              this.view.$a("fm-no-member-filters", !this.model.ap.gfa);
              this.Ya("center");
            }
            LI() {
              this.view.Dp && (this.view.$b && this.view.$b.isVisible() ? this.view.Dp.vq(0 < this.view.$b.Kd.Tw()) : this.view.Dp.vq(!0));
            }
            mAa() {
              return this.view.Uk && 1 == this.view.Uk.getSelection() ? e.u.i.Aa.kc : this.view.Vk && 1 == this.view.Vk.getSelection() ? e.u.i.Aa.Mc : this.view.Uk && this.view.Vk ? e.u.i.Aa.ed : this.model.hierarchy.eg;
            }
            Xda() {
              return this.model.Ln == e.u.i.rb.Ta ? this.view.Do.Mm() : this.model.Ln == e.u.i.rb.Zk ? this.view.bq.Mm() : this.model.Ln == e.u.i.rb.jb ? this.view.jq.Mm() : this.model.Ln == e.u.i.rb.ic ? this.view.yq.Mm() : null;
            }
            kAa() {
              var b = null,
                a = null;
              1 == this.view.pf.getSelection() ? b = this.Xda() : 1 == this.view.Mf.getSelection() ? b = this.view.an.Mm() : (a = this.view.$b.Mm(), this.model.ffa(a) || (a = null));
              null == a && null == b && (this.view.pf.Sc("fm-has-filter") ? b = this.Xda() : this.view.Mf.Sc("fm-has-filter") && (b = this.view.an.Mm()));
              var c = {};
              b && (c.type = b.type, c.query = b.query, c.measure = b.measure);
              a && (e.v(a.md) || (c.md = a.md), e.v(a.iz) || (c.iz = a.iz));
              return c;
            }
            Ts() {
              this.Ya("close");
            }
            lHa() {
              1 === this.view.Uk.getSelection() && (this.view.Vk.Gf(0), this.view.$b && this.view.$b.Kd.sort(e.u.i.Aa.kc));
              0 === this.view.Uk.getSelection() && 0 === this.view.Vk.getSelection() && this.view.$b && this.view.$b.Kd.sort(e.u.i.Aa.ed);
            }
            mHa() {
              1 === this.view.Vk.getSelection() && (this.view.Uk.Gf(0), this.view.$b && this.view.$b.Kd.sort(e.u.i.Aa.Mc));
              0 === this.view.Uk.getSelection() && 0 === this.view.Vk.getSelection() && this.view.$b && this.view.$b.Kd.sort(e.u.i.Aa.ed);
            }
            i4() {
              this.view.$b && (this.view.$b.Kd.selectAll(1 == this.view.Yd.getSelection()), this.view.Dp.vq(0 < this.view.$b.Kd.Tw()));
              this.oO();
            }
            AGa(b) {
              if (32 === b.keyCode || 13 === b.keyCode) {
                var a = this.view.$b.Kd.Gu();
                e.v(a) || (a = a.data, !a.OT || b.ctrlKey || b.metaKey ? (a.zd = 1 == a.zd ? 0 : 1, this.view.$b.Kd.N5(a)) : (a.$f = !a.$f, this.view.$b.Kd.tja(a)));
              }
            }
            BGa() {
              this.view.Dp.vq(0 < this.view.$b.Kd.Tw());
              this.zja();
              this.oO();
            }
            zGa() {
              this.U5();
              this.oO();
            }
            zja() {
              0 == this.view.$b.Kd.uz() ? this.view.Yd.Gf(0) : this.view.$b.Kd.IT() > this.view.$b.Kd.uz() ? this.view.Yd.Gf(-1) : this.view.$b.Kd.IT() == this.view.$b.Kd.uz() && this.view.Yd.Gf(1);
            }
            update(b) {
              0 != this.view.isVisible() && (1E4 < b.Wi ? (e.Da(!0, e.model.B.j.tF, e.model.B.j.Poa, !0, !0), setTimeout(() => {
                this.model.update(b);
                this.$m();
                e.Da(!1);
              }, 50)) : (this.model.update(b), this.$m()));
            }
            dHa(b) {
              e.model.C.F.US && b.trim() == b && this.view.$b && this.view.$b.Kd.search(b, () => this.$D());
            }
            fHa() {
              var b = this.view.Nn.Zi();
              !e.model.C.F.US && b.trim() == b && this.view.$b && this.view.$b.Kd.search(b, () => this.$D());
            }
            eHa() {
              !e.model.C.F.US && this.view.$b && this.view.$b.Kd.search("", () => this.$D());
            }
            $D() {
              this.U5();
              this.oO();
              this.zja();
              this.view.Dp.vq(0 < this.view.$b.Kd.Tw());
            }
            $m() {
              this.view.dg();
              this.view.$a("fm-filter-pages-layout", this.model.D2);
              this.view.$a("fm-filter-flat-layout", this.model.aj);
              this.view.$b && this.view.$b.reset();
              this.view.Nn && (this.view.Nn.clear(), this.view.Nn.YV(e.model.Va.R().Fa.fa.Ic ? 1E3 : 0));
              this.view.Mf && (e.u.i.Qa.$c == e.u.i.Qa.fza(this.model.hierarchy.zi.type + "") && e.model.C.F.tc ? this.view.Mf.Za() : this.view.Mf.show());
              this.zLa();
              this.vLa();
              this.wLa();
              this.uLa();
              this.U5();
              this.oO();
              this.yLa();
              this.LI();
              this.Oya();
            }
            Oya() {
              this.view.$b && this.view.$b.isVisible() ? this.view.$b.Kd.focus({
                preventScroll: !0
              }) : this.view.pf && 1 == this.view.pf.getSelection() ? this.view.pf.focus({
                preventScroll: !0
              }) : this.view.Mf && 1 == this.view.Mf.getSelection() ? this.view.Mf.focus({
                preventScroll: !0
              }) : this.view.Dp.focus({
                preventScroll: !0
              });
            }
            yLa() {
              var b = !this.model.D2 && !e.model.C.F.tc;
              this.view.Uk && this.view.Uk.isVisible(b);
              this.view.Vk && this.view.Vk.isVisible(b);
              this.view.bO && this.view.bO.isVisible(b);
              this.view.$a("fm-sort-only", !this.Yw && !this.Cz);
            }
            get Cz() {
              if (e.u.Ma.R().fa.Ba == e.u.i.qa.API && !this.model.ap.zfa) return !1;
              if (this.model.aj) {
                var b = this.model.gq.ja.O.mf(this.model.hierarchy.A);
                return !e.v(b) && b.type == e.u.i.Qa.jb;
              }
              return this.model.D2 || e.u.Ma.R().fa.Ba == e.u.i.qa.Md || e.u.Ma.R().fa.Ba == e.u.i.qa.hg || !this.YCa() ? !1 : !0;
            }
            YCa() {
              return 0 < this.model.gd().length;
            }
            get Yw() {
              return this.model.ap.WM && e.u.Ma.R().fa.Ba != e.u.i.qa.Md && !(this.model.aj && this.model.Ln == e.u.i.rb.jb);
            }
            wLa() {
              var b = this.model.hierarchy;
              this.view.Yd && this.view.Yd.Gf(0 < b.filter.yj().length ? -1 : 1);
              if (this.view.$b) {
                var a = 2 < b.wa.length;
                this.view.$b.Kd.$a("fm-tree-list", a);
                this.view.$b.Kd.f5(a ? new h.apa() : new h.YX());
                this.view.$b.Kd.eW(b);
                this.view.$b.Kd.cg(this.model.md);
                this.view.$b.Kd.bW(b.filter.yj());
                this.view.$b.Kd.sort(b.eg);
              }
            }
            vLa() {
              this.view.Fr && (this.view.Fr.gb(this.model.hierarchy.caption), this.view.Fr.ki(this.model.hierarchy.caption));
              this.view.toolbar && this.view.toolbar.dKa(this.model.hierarchy.caption);
            }
            U5() {
              this.view.$b && 0 < this.view.$b.Kd.getTotalLength() ? this.view.Yd && this.view.Yd.show() : this.view.Yd && this.view.Yd.Za();
            }
            zLa() {
              this.view.Uk && this.view.Uk.Gf(this.model.hierarchy.eg == e.u.i.Aa.kc ? 1 : 0);
              this.view.Vk && this.view.Vk.Gf(this.model.hierarchy.eg == e.u.i.Aa.Mc ? 1 : 0);
            }
            uLa() {
              this.view.gH && this.view.gH.isVisible(this.Yw || this.Cz);
              this.view.pf && (this.model.Ln == e.u.i.rb.Ta ? (this.view.UH.gb(e.model.B.j.O7), this.view.pf.qc(e.model.B.j.SA + " " + e.model.B.j.O7)) : this.model.Ln == e.u.i.rb.Zk ? (this.view.UH.gb(e.model.B.j.eP), this.view.pf.qc(e.model.B.j.SA + " " + e.model.B.j.eP)) : this.model.Ln == e.u.i.rb.jb ? (this.view.UH.gb(e.model.B.j.R7), this.view.pf.qc(e.model.B.j.SA + " " + e.model.B.j.R7)) : this.model.Ln == e.u.i.rb.ic && (this.view.UH.gb(e.model.B.j.S7), this.view.pf.qc(e.model.B.j.SA + " " + e.model.B.j.S7)), this.view.pf.isVisible(this.Yw && this.model.Ln != e.u.i.rb.NONE), this.view.pf.$a("fm-has-filter", this.model.Ww), this.view.pf.Gf(this.model.Ww));
              this.view.Mf && (this.model.aj && !this.Cz && this.model.hierarchy.filter.ei ? (this.view.Mf.isVisible(!0), this.view.Mf.vq(!1)) : (this.view.Mf.isVisible(this.Cz), this.view.Mf.vq(this.Cz)), this.view.Mf.$a("fm-has-filter", this.model.ei), this.view.Mf.Gf(this.Cz && this.model.ei));
              this.view.Do && (this.view.Do.Bx(this.model.ap.WM ? this.model.ap.query : []), this.view.Do.reset(), this.model.jl.type == e.u.i.rb.Ta && (this.view.Do.yl(this.model.jl), this.view.Do.uh(this.model.hierarchy.getTimezoneOffset())));
              this.view.bq && (this.view.bq.Bx(this.model.ap.WM ? this.model.ap.query : []), this.view.bq.reset(), this.model.jl.type == e.u.i.rb.Zk && this.view.bq.yl(this.model.jl));
              this.view.jq && (this.view.jq.Bx(this.model.ap.WM ? this.model.ap.query : []), this.view.jq.reset(), this.model.jl.type == e.u.i.rb.jb && this.view.jq.yl(this.model.jl));
              this.view.yq && (this.view.yq.Bx(this.model.ap.WM ? this.model.ap.query : []), this.view.yq.reset(), this.model.jl.type == e.u.i.rb.ic && this.view.yq.yl(this.model.jl));
              this.view.an && (this.view.an.Bx(this.model.ap.zfa ? this.model.ap.km : []), this.view.an.reset(), this.view.an.iA(this.model.gd()), this.model.jl.type == e.u.i.rb.jo && this.view.an.yl(this.model.jl), this.view.an.$a("fm-arrow-first", !this.Yw));
              this.QN();
              this.LI();
            }
            oO() {
              var b = "";
              this.view.$b && (b = this.view.$b.Kd.Ve() ? e.P.bind(e.model.B.j.oma, this.view.$b.Kd.uz(), this.view.$b.Kd.IT()) : e.P.bind(e.model.B.j.pma, this.view.$b.Kd.uz(), this.view.$b.Kd.IT()));
              this.view.Ax && (this.view.Ax.gb(b), this.view.Ax.ki(b));
              this.view.Yd && this.view.Yd.gb(this.view.$b && this.view.$b.Kd.Ve() ? e.model.B.j.Sma : e.model.B.j.xv);
            }
            XFa(b) {
              var a = b.data.xl;
              -1 < b.data.selectedIndex && (this.model.iia(a), this.$m());
            }
          }
          h.fna = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.be.oy {
            constructor() {
              super(k.Nb.Gb.G);
              this.$("fm-filter-view");
              this.$("fm-noselect");
              this.Qe = new h.fna();
              this.Qe.N("close", () => this.close());
              this.Qe.N("center", () => this.Gp());
              this.X(this.Qe.view);
              this.Qe.view.show();
              this.G.fj({
                pW: [x.fj.ri.ni, x.fj.ri.lF, x.fj.ri.DF],
                hS: k.Nb.Gb.G,
                f_: !0,
                resize: b => this.wN(b),
                complete: () => this.Gp()
              });
            }
            wN(b) {
              b.FE == x.fj.ri.lF || b.FE == x.fj.ri.DF ? (this.Qe.view.Tk(b.size.width + (b.size.width - b.o4.width)), this.Gp()) : b.FE == x.fj.ri.ni && (this.Qe.view.Er(b.size.height), b.size.height > b.o4.height && this.Pxa());
              this.bC();
            }
            Pxa() {
              this.Qe.view.$b && this.Qe.view.$b.isVisible() && this.Qe.view.G.requestAnimationFrame(() => {
                this.Qe.view.$b.Kd.Kr();
              });
            }
            Qo(b) {
              this.open();
              this.Qe.update(b);
              this.Gp();
              this.Ya(v.ga.OPENED);
            }
            close() {
              this.Vu && (super.close(), this.Ya(v.ga.CLOSED), e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.AX)));
            }
            bC() {
              this.G.$a("fm-layout-mobile-small", 460 > this.G.Zf(!0));
            }
          }
          h.hna = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor() {
              super("div", "fm-filters-table");
              var b = new x.Na("div", "fm-filters-table-header fm-fth-withsearch");
              this.X(b);
              var a = new x.Na("div", "fm-select-all-wrapper");
              a.$("fm-ui-col");
              this.Yd = new x.cK();
              this.Yd.$("fm-select-all-label");
              this.Yd.gb(e.model.B.j.xv);
              this.Yd.ki(e.model.B.j.xv);
              a.X(this.Yd);
              var c = new x.Na("div", "fm-select-counter-wrap");
              c.$("fm-ui-col");
              this.Ax = new x.Vc();
              this.Ax.$("fm-select-counter");
              c.X(this.Ax);
              b.X(a);
              b.X(c);
              this.Ye = new x.Na("div", "fm-search-wrap");
              b.X(this.Ye);
              this.pe = new x.Na("a", "fm-search-btn");
              this.pe.G.text(e.model.B.j.BX);
              this.pe.Je();
              this.pe.N("click", () => this.Us());
              this.pe.N("focus", () => this.Us());
              this.Ye.X(this.pe);
              this.Nn = new x.Oj();
              this.Nn.$("fm-search-inp");
              this.Ye.X(this.Nn);
              b = new x.Nd("fm-close-search");
              b.N(x.Nd.tf, () => this.Vs());
              this.Ye.X(b);
              b = new x.Na("div", "fm-filters-table-content");
              this.X(b);
              this.Kd = new h.yJ();
              this.Kd.$("fm-members-filter-list");
              this.Kd.f5(new h.YX());
              b.X(this.Kd);
            }
            dg() {
              this.Nn.xE(e.model.B.j.BX);
              this.Yd.gb(e.model.B.j.xv);
              this.Yd.ki(e.model.B.j.xv);
              this.pe.G.text(e.model.B.j.BX);
            }
            Us() {
              this.pe.Je(-1);
              this.Ye.$("fm-search-opened");
              this.Nn.G.focus();
              this.Ax.Za();
            }
            Vs() {
              this.pe.Je(0);
              this.Ye.Gd("fm-search-opened");
              this.Nn.clear();
              this.Ax.show();
            }
            Mm() {
              var b = this.Kd.qT();
              return b.items ? b.bv ? {
                iz: b.items
              } : {
                md: b.items
              } : null;
            }
            reset() {
              this.Vs();
            }
          }
          h.$oa = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor() {
              super("div", "fm-filters-subview-wrap");
              this.Xc = [];
              var b = new x.Na("div", "fm-filters-subview");
              this.X(b);
              this.sr = new x.Ad.Yr();
              this.sr.$("fm-measures-dropdown");
              this.sr.vg("label");
              this.sr.xE(e.model.B.j.Mma);
              b.X(this.sr);
              this.Rc = new x.Ad.Yr();
              this.Rc.$("fm-conditions-dropdown");
              this.Rc.vg("label");
              this.Rc.N(v.ga.Zd, () => this.Mk());
              b.X(this.Rc);
              this.dh = new x.Nq();
              this.dh.$("fm-num-input-1");
              this.dh.yE(x.Nq.CF);
              b.X(this.dh);
              this.ej = new x.Nq();
              this.ej.$("fm-num-input-2");
              this.ej.yE(x.Nq.CF);
              b.X(this.ej);
              var a = new x.Ga("div", "fm-buttons-bar");
              b.G.X(a);
              this.Eg = new x.Nd("fm-ui-link-btn");
              this.Eg.$("fm-muted");
              this.Eg.Gd("fm-ui-btn");
              this.Eg.N(x.Nd.tf, () => this.qx());
              a.X(this.Eg.G);
            }
            qx() {
              this.Za();
              this.Ya(v.ga.kp);
            }
            Mk() {
              let b = this.Rc.Ph();
              e.v(b) || this.G.$a("fm-range", 0 <= e.u.i.Vb.Qf.indexOf(b.value));
            }
            iA(b) {
              this.sr.cg(b);
              this.sr.Sk(0);
              this.vq(0 < b.length);
            }
            reset() {
              this.sr.Sk(0);
              this.Rc.Sk(0);
              this.Mk();
              this.dh.li(10);
              this.ej.li(0);
            }
            Mm() {
              if (e.v(this.sr.Ph())) return null;
              var b = {
                type: e.u.i.rb.jo
              };
              b.measure = this.sr.Ph().Sa();
              var a = this.Rc.Ph().value;
              if (0 <= e.u.i.Vb.si.indexOf(a)) {
                var c = this.dh.La();
                !isNaN(c) || a != e.u.i.Vb.Nj && a != e.u.i.Vb.ni || (c = 0);
                b.query = new e.model.hb.nm(a, c);
              }
              0 <= e.u.i.Vb.Qf.indexOf(a) && (b.query = new e.model.hb.nm(a, [this.dh.La(), this.ej.La()]));
              return b;
            }
            yl(b) {
              this.Rc.ft(c => c.value === b.query.ua);
              this.Mk();
              const a = this.sr.Bc();
              for (let c = 0; c < a.length; c++) if (a[c].A == b.measure.uniqueName && a[c].aa == b.measure.aggregation) {
                this.sr.Sk(c);
                break;
              }
              0 <= e.u.i.Vb.si.indexOf(b.query.ua) && this.dh.li(b.query.value);
              0 <= e.u.i.Vb.Qf.indexOf(b.query.ua) && (this.dh.li(b.query.value[0]), this.ej.li(b.query.value[1]));
            }
            Bx(b) {
              this.Xc = b;
              this.dg();
            }
            J(b) {
              switch (b) {
                case e.u.i.Vb.Nj:
                  return e.model.B.j.Lma;
                case e.u.i.Vb.ni:
                  return e.model.B.j.Cma;
                case e.u.i.Vb.EQUAL:
                  return e.model.B.j.tJ;
                case e.u.i.Vb.Pf:
                  return e.model.B.j.vJ;
                case e.u.i.Vb.GREATER:
                  return e.model.B.j.aP;
                case e.u.i.Vb.Xk:
                  return e.model.B.j.bP;
                case e.u.i.Vb.LESS:
                  return e.model.B.j.cP;
                case e.u.i.Vb.$k:
                  return e.model.B.j.dP;
                case e.u.i.Vb.fh:
                  return e.model.B.j.sJ;
                case e.u.i.Vb.Og:
                  return e.model.B.j.uJ;
              }
            }
            dg() {
              this.sr.qc(e.model.B.j.vma);
              this.Rc.qc(e.model.B.j.$O);
              this.dh.qc(e.model.B.j.Zx);
              this.ej.qc(e.model.B.j.Zx);
              this.Rc.cg(this.Xc.map(b => ({
                value: b,
                label: this.J(b)
              })));
              this.Eg.gb(e.model.B.j.uma);
            }
          }
          h.lra = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor() {
              super("div", "fm-filters-subview-wrap");
              this.Xc = [];
              var b = new x.Na("div", "fm-filters-subview");
              this.X(b);
              this.Rc = new x.Ad.Yr();
              this.Rc.$("fm-conditions-dropdown");
              this.Rc.vg("label");
              this.Rc.N(v.ga.Zd, () => this.Mk());
              b.X(this.Rc);
              this.yk = new x.GL.H9();
              this.yk.$("fm-datepicker-1");
              this.yk.N(v.ga.Zd, () => this.tFa());
              b.X(this.yk);
              this.Rl = new x.GL.H9();
              this.Rl.$("fm-datepicker-2");
              this.Rl.N(v.ga.Zd, () => this.uFa());
              b.X(this.Rl);
              this.fE = new x.Ad.Yr();
              this.fE.$("fm-periods-dropdown");
              this.fE.vg("label");
              b.X(this.fE);
              var a = new x.Ga("div", "fm-buttons-bar");
              b.G.X(a);
              this.Eg = new x.Nd("fm-ui-link-btn");
              this.Eg.$("fm-muted");
              this.Eg.Gd("fm-ui-btn");
              this.Eg.N(x.Nd.tf, () => this.qx());
              a.X(this.Eg.G);
            }
            Bx(b) {
              this.Xc = b;
              this.dg();
            }
            J(b) {
              switch (b) {
                case e.u.i.bc.EQUAL:
                  return e.model.B.j.tJ;
                case e.u.i.bc.Pf:
                  return e.model.B.j.vJ;
                case e.u.i.bc.SE:
                  return e.model.B.j.zma;
                case e.u.i.bc.TE:
                  return e.model.B.j.Ama;
                case e.u.i.bc.PE:
                  return e.model.B.j.xma;
                case e.u.i.bc.QE:
                  return e.model.B.j.yma;
                case e.u.i.bc.fh:
                  return e.model.B.j.sJ;
                case e.u.i.bc.Og:
                  return e.model.B.j.uJ;
                case e.u.i.bc.qP:
                  return e.model.B.j.Gma;
                case e.u.i.bc.HO:
                  return e.model.B.j.Ema;
                case e.u.i.bc.LP:
                  return e.model.B.j.Hma;
              }
            }
            dg() {
              this.Rc.qc(e.model.B.j.$O);
              this.yk.qc(e.model.B.j.Zx);
              this.Rl.qc(e.model.B.j.Zx);
              this.Rc.cg(this.Xc.map(b => ({
                value: b,
                label: this.J(b)
              })));
              this.fE.cg([{
                value: e.u.i.LA.en,
                label: e.model.B.j.Nma
              }, {
                value: e.u.i.LA.fK,
                label: e.model.B.j.Qma
              }, {
                value: e.u.i.LA.ih,
                label: e.model.B.j.Oma
              }, {
                value: e.u.i.LA.Ct,
                label: e.model.B.j.Pma
              }, {
                value: e.u.i.LA.Jl,
                label: e.model.B.j.Rma
              }]);
              this.Eg.gb(e.model.B.j.qma);
              this.yk.Qx = e.model.C.F.Lw;
              this.Rl.Qx = e.model.C.F.Lw;
              this.yk.e0 = e.model.C.F.N0;
              this.Rl.e0 = e.model.C.F.N0;
              this.yk.JR = e.model.B.j.El;
              this.Rl.JR = e.model.B.j.El;
            }
            Mm() {
              var b = {
                  type: e.u.i.rb.Ta
                },
                a = this.Rc.Ph().value;
              0 <= e.u.i.bc.si.indexOf(a) && (b.query = new e.model.hb.nm(a, this.yk.rc));
              if (0 <= e.u.i.bc.Qf.indexOf(a)) {
                var c = this.yk.rc,
                  d = this.Rl.rc;
                b.query = new e.model.hb.nm(a, c.getTime() < d.getTime() ? [c, d] : [d, c]);
              }
              0 <= e.u.i.bc.jy.indexOf(a) && (b.query = new e.model.hb.nm(a, this.fE.Ph().value));
              return b;
            }
            yl(b) {
              this.Rc.ft(a => a.value === b.query.ua);
              this.Mk();
              0 <= e.u.i.bc.si.indexOf(b.query.ua) && (this.yk.rc = b.query.value);
              0 <= e.u.i.bc.Qf.indexOf(b.query.ua) && (this.yk.rc = b.query.value[0], this.Rl.rc = b.query.value[1]);
              0 <= e.u.i.bc.jy.indexOf(b.query.ua) && this.fE.ft(a => a.value === b.query.value);
            }
            uh(b) {
              this.yk.mi = b;
              this.Rl.mi = b;
            }
            reset() {
              this.Rc.Sk(0);
              this.fE.Sk(0);
              this.Mk();
              this.yk.oKa();
              this.Rl.rc = null;
              this.yk.mi = null;
              this.Rl.mi = null;
            }
            Mk() {
              var b = this.Rc.Ph();
              e.v(b) || (b = b.value, this.G.$a("fm-date-range", 0 <= e.u.i.bc.Qf.indexOf(b)), this.G.$a("fm-date-period", 0 <= e.u.i.bc.jy.indexOf(b)), 0 <= e.u.i.bc.Qf.indexOf(b) && null == this.Rl.rc && null != this.yk.rc && (this.Rl.rc = this.yk.rc.clone()));
            }
            tFa() {
              null == this.Rl.rc && 0 <= e.u.i.bc.Qf.indexOf(this.Rc.Ph().value) && (this.Rl.rc = this.yk.rc.clone());
            }
            uFa() {
              null == this.yk.rc && 0 <= e.u.i.bc.Qf.indexOf(this.Rc.Ph().value) && (this.yk.rc = this.Rl.rc.clone());
            }
            qx() {
              this.reset();
              this.Za();
              this.Ya(v.ga.kp);
            }
          }
          h.Qla = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor() {
              super("div", "fm-filters-subview-wrap");
              this.Xc = [];
              var b = new x.Na("div", "fm-filters-subview");
              this.X(b);
              this.Rc = new x.Ad.Yr();
              this.Rc.$("fm-conditions-dropdown");
              this.Rc.vg("label");
              this.Rc.N(v.ga.Zd, () => this.Mk());
              b.X(this.Rc);
              this.rA = new x.Oj();
              this.rA.$("fm-txt-input-1");
              b.X(this.rA);
              this.KI = new x.Oj();
              this.KI.$("fm-txt-input-2");
              b.X(this.KI);
              var a = new x.Ga("div", "fm-buttons-bar");
              b.G.X(a);
              this.Eg = new x.Nd("fm-ui-link-btn");
              this.Eg.$("fm-muted");
              this.Eg.Gd("fm-ui-btn");
              this.Eg.N(x.Nd.tf, () => this.qx());
              a.X(this.Eg.G);
            }
            Bx(b) {
              this.Xc = b;
              this.dg();
            }
            J(b) {
              switch (b) {
                case e.u.i.Cb.EQUAL:
                  return e.model.B.j.tJ;
                case e.u.i.Cb.Pf:
                  return e.model.B.j.vJ;
                case e.u.i.Cb.UE:
                  return e.model.B.j.Bma;
                case e.u.i.Cb.ZA:
                  return e.model.B.j.Ima;
                case e.u.i.Cb.NA:
                  return e.model.B.j.Fma;
                case e.u.i.Cb.aB:
                  return e.model.B.j.Kma;
                case e.u.i.Cb.Un:
                  return e.model.B.j.Dma;
                case e.u.i.Cb.$A:
                  return e.model.B.j.Jma;
                case e.u.i.Cb.GREATER:
                  return e.model.B.j.aP;
                case e.u.i.Cb.Xk:
                  return e.model.B.j.bP;
                case e.u.i.Cb.LESS:
                  return e.model.B.j.cP;
                case e.u.i.Cb.$k:
                  return e.model.B.j.dP;
                case e.u.i.Cb.fh:
                  return e.model.B.j.sJ;
                case e.u.i.Cb.Og:
                  return e.model.B.j.uJ;
              }
            }
            dg() {
              this.Rc.qc(e.model.B.j.$O);
              this.rA.qc(e.model.B.j.Zx);
              this.KI.qc(e.model.B.j.Zx);
              this.Rc.cg(this.Xc.map(b => ({
                value: b,
                label: this.J(b)
              })));
              this.Eg.gb(e.model.B.j.rma);
            }
            Mm() {
              var b = {
                  type: e.u.i.rb.Zk
                },
                a = this.Rc.Ph().value;
              0 <= e.u.i.Cb.si.indexOf(a) && (b.query = new e.model.hb.nm(a, this.rA.Zi()));
              0 <= e.u.i.Cb.Qf.indexOf(a) && (b.query = new e.model.hb.nm(a, [this.rA.Zi(), this.KI.Zi()]));
              return b;
            }
            yl(b) {
              this.Rc.ft(a => a.value === b.query.ua);
              this.Mk();
              0 <= e.u.i.Cb.si.indexOf(b.query.ua) && this.rA.Jj(b.query.value);
              0 <= e.u.i.Cb.Qf.indexOf(b.query.ua) && (this.rA.Jj(b.query.value[0]), this.KI.Jj(b.query.value[1]));
            }
            reset() {
              this.Rc.Sk(0);
              this.Mk();
              this.rA.Jj("");
              this.KI.Jj("");
            }
            Mk() {
              let b = this.Rc.Ph();
              e.v(b) || this.G.$a("fm-range", 0 <= e.u.i.Cb.Qf.indexOf(b.value));
            }
            qx() {
              this.reset();
              this.Za();
              this.Ya(v.ga.kp);
            }
          }
          h.Ona = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor() {
              super("div", "fm-filters-subview-wrap");
              this.Xc = [];
              var b = new x.Na("div", "fm-filters-subview");
              this.X(b);
              this.Rc = new x.Ad.Yr();
              this.Rc.$("fm-conditions-dropdown");
              this.Rc.vg("label");
              this.Rc.N(v.ga.Zd, () => this.Mk());
              b.X(this.Rc);
              this.dh = new x.Nq();
              this.dh.$("fm-num-input-1");
              this.dh.yE(x.Nq.CF);
              b.X(this.dh);
              this.ej = new x.Nq();
              this.ej.$("fm-num-input-2");
              this.ej.yE(x.Nq.CF);
              b.X(this.ej);
              var a = new x.Ga("div", "fm-buttons-bar");
              b.G.X(a);
              this.Eg = new x.Nd("fm-ui-link-btn");
              this.Eg.$("fm-muted");
              this.Eg.Gd("fm-ui-btn");
              this.Eg.N(x.Nd.tf, () => this.qx());
              a.X(this.Eg.G);
            }
            Bx(b) {
              this.Xc = b;
              this.dg();
            }
            J(b) {
              switch (b) {
                case e.u.i.Pg.EQUAL:
                  return e.model.B.j.tJ;
                case e.u.i.Pg.Pf:
                  return e.model.B.j.vJ;
                case e.u.i.Pg.GREATER:
                  return e.model.B.j.aP;
                case e.u.i.Pg.Xk:
                  return e.model.B.j.bP;
                case e.u.i.Pg.LESS:
                  return e.model.B.j.cP;
                case e.u.i.Pg.$k:
                  return e.model.B.j.dP;
                case e.u.i.Pg.fh:
                  return e.model.B.j.sJ;
                case e.u.i.Pg.Og:
                  return e.model.B.j.uJ;
              }
            }
            dg() {
              this.Rc.cg(this.Xc.map(b => ({
                value: b,
                label: this.J(b)
              })));
              this.Eg.gb(e.model.B.j.sma);
            }
            Mm() {
              var b = {
                  type: e.u.i.rb.jb
                },
                a = this.Rc.Ph().value;
              0 <= e.u.i.Pg.si.indexOf(a) && (b.query = new e.model.hb.nm(a, this.dh.La()));
              0 <= e.u.i.Pg.Qf.indexOf(a) && (b.query = new e.model.hb.nm(a, [this.dh.La(), this.ej.La()]));
              return b;
            }
            yl(b) {
              this.Rc.ft(a => a.value === b.query.ua);
              this.Mk();
              0 <= e.u.i.Pg.si.indexOf(b.query.ua) && this.dh.li(b.query.value);
              0 <= e.u.i.Pg.Qf.indexOf(b.query.ua) && (this.dh.li(b.query.value[0]), this.ej.li(b.query.value[1]));
            }
            reset() {
              this.Rc.Sk(0);
              this.Mk();
              this.dh.li(0);
              this.ej.li(0);
            }
            Mk() {
              let b = this.Rc.Ph();
              e.v(b) || this.G.$a("fm-range", 0 <= e.u.i.Pg.Qf.indexOf(b.value));
            }
            qx() {
              this.reset();
              this.Za();
              this.Ya(v.ga.kp);
            }
          }
          h.kpa = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends x.Na {
            constructor() {
              super("div", "fm-filters-subview-wrap");
              this.Xc = [];
              var b = new x.Na("div", "fm-filters-subview");
              this.X(b);
              this.Rc = new x.Ad.Yr();
              this.Rc.$("fm-conditions-dropdown");
              this.Rc.vg("label");
              this.Rc.N(v.ga.Zd, () => this.Mk());
              b.X(this.Rc);
              this.dh = new x.Nq();
              this.dh.$("fm-num-input-1");
              this.dh.yE(x.Nq.CF);
              b.X(this.dh);
              this.ej = new x.Nq();
              this.ej.$("fm-num-input-2");
              this.ej.yE(x.Nq.CF);
              b.X(this.ej);
              this.Ou = new x.Ad.Yr();
              this.Ou.$("fm-interval-dropdown");
              this.Ou.vg("label");
              this.Ou.ON("ariaLabel");
              b.X(this.Ou);
              b = new x.Ga("div", "fm-buttons-bar");
              this.G.X(b);
              this.Eg = new x.Nd("fm-ui-link-btn");
              this.Eg.$("fm-muted");
              this.Eg.Gd("fm-ui-btn");
              this.Eg.N(x.Nd.tf, () => this.qx());
              b.X(this.Eg.G);
            }
            Bx(b) {
              this.Xc = b;
              this.dg();
            }
            J(b) {
              switch (b) {
                case e.u.i.bl.EQUAL:
                  return e.model.B.j.tJ;
                case e.u.i.bl.Pf:
                  return e.model.B.j.vJ;
                case e.u.i.bl.GREATER:
                  return e.model.B.j.aP;
                case e.u.i.bl.Xk:
                  return e.model.B.j.bP;
                case e.u.i.bl.LESS:
                  return e.model.B.j.cP;
                case e.u.i.bl.$k:
                  return e.model.B.j.dP;
                case e.u.i.bl.fh:
                  return e.model.B.j.sJ;
                case e.u.i.bl.Og:
                  return e.model.B.j.uJ;
              }
            }
            dg() {
              this.Rc.qc(e.model.B.j.$O);
              this.dh.qc(e.model.B.j.Zx);
              this.ej.qc(e.model.B.j.Zx);
              this.Rc.cg(this.Xc.map(b => ({
                value: b,
                label: this.J(b)
              })));
              this.Ou.qc(e.model.B.j.wma);
              this.Ou.cg([{
                value: "s",
                label: e.model.B.j.$ma,
                ariaLabel: e.model.B.j.ana
              }, {
                value: "m",
                label: e.model.B.j.Yma,
                ariaLabel: e.model.B.j.Zma
              }, {
                value: "h",
                label: e.model.B.j.Wma,
                ariaLabel: e.model.B.j.Xma
              }, {
                value: "d",
                label: e.model.B.j.Uma,
                ariaLabel: e.model.B.j.Vma
              }]);
              this.Eg.gb(e.model.B.j.tma);
            }
            Mm() {
              var b = {
                  type: e.u.i.rb.ic
                },
                a = this.Rc.Ph().value,
                c = this.Ou.Ph().value;
              0 <= e.u.i.bl.si.indexOf(a) && (b.query = new e.model.hb.nm(a, this.dh.La() + c));
              0 <= e.u.i.bl.Qf.indexOf(a) && (b.query = new e.model.hb.nm(a, [this.dh.La() + c, this.ej.La() + c]));
              return b;
            }
            yl(b) {
              this.Rc.ft(g => g.value === b.query.ua);
              this.Mk();
              for (var a = this.Ou.Bc(), c = 0; c < a.length; c++) {
                var d = a[c].value;
                if (0 <= b.query.value.indexOf(d)) {
                  this.Ou.Sk(c);
                  break;
                }
              }
              0 <= e.u.i.bl.si.indexOf(b.query.ua) && (a = parseFloat(b.query.value.replace(d, "")), this.dh.li(a));
              0 <= e.u.i.bl.Qf.indexOf(b.query.ua) && (a = parseFloat(b.query.value[0].replace(d, "")), d = parseFloat(b.query.value[1].replace(d, "")), this.dh.li(a), this.ej.li(d));
            }
            reset() {
              this.Rc.Sk(0);
              this.Mk();
              this.dh.li(0);
              this.ej.li(0);
              this.Ou.Sk(0);
            }
            Mk() {
              let b = this.Rc.Ph();
              e.v(b) || this.G.$a("fm-range", 0 <= e.u.i.bl.Qf.indexOf(b.value));
            }
            qx() {
              this.reset();
              this.Za();
              this.Ya(v.ga.kp);
            }
          }
          h.Tqa = f;
        })(k.filter || (k.filter = {}));
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    var S;
    (function (e) {
      class k {
        constructor() {
          this.styleSheet = new e.td.vra();
          this.eh = [];
          e.td.format.Gt.Efa = e.td.format.Gt.hca;
          e.HF.FI = [];
        }
        async iLa() {
          var h = {};
          h["[Content_Types].xml"] = e.Ti.Ht + this.Ava();
          h["_rels/.rels"] = e.Ti.Ht + e.Ti.yra;
          h["xl/_rels/workbook.xml.rels"] = e.Ti.Ht + this.bwa();
          h["xl/workbook.xml"] = e.Ti.Ht + this.cwa();
          h["xl/theme/theme1.xml"] = e.Ti.Ht + e.Ti.Gqa;
          for (var f = 0; f < this.eh.length; f++) {
            var b = this.eh[f].Kc();
            h["xl/worksheets/sheet" + (f + 1) + ".xml"] = e.Ti.Ht + b;
          }
          f = this.Zva();
          h["xl/sharedStrings.xml"] = e.Ti.Ht + f;
          h["xl/styles.xml"] = e.Ti.Ht + this.styleSheet.Kc();
          h["docProps/app.xml"] = e.Ti.Ht + e.Ti.eka;
          h["docProps/core.xml"] = e.Ti.Ht + e.Ti.hla;
          return await new z.ena().dwa(h);
        }
        Zva() {
          let h = "";
          z.ba.create("<axis/>").attr("name", "rows");
          for (let f = 0; f < e.HF.FI.length; f++) {
            const b = q.P.kya(e.HF.FI[f]);
            h += "<si><t>" + b + "</t></si>";
          }
          return e.Ti.hqa.replace("{0}", h);
        }
        cwa() {
          for (var h = "", f = 0; f < this.eh.length; f++) h += q.P.bind('<sheet name="{0}" sheetId="{1}" r:id="{2}"/>', this.eh[f].name, f + 1, "rId" + (f + 4));
          return q.P.bind(e.Ti.mra, h);
        }
        bwa() {
          for (var h = "", f = 0; f < this.eh.length; f++) h += q.P.bind(e.Ti.ora, "rId" + (f + 4), "worksheets/sheet" + (f + 1) + ".xml");
          return q.P.bind(e.Ti.nra, h);
        }
        Ava() {
          for (var h = "", f = 0; f < this.eh.length; f++) h += q.P.bind(e.Ti.Jka, "/xl/worksheets/sheet" + (f + 1) + ".xml");
          return q.P.bind(e.Ti.Ika, h);
        }
      }
      e.qra = k;
    })(S || (S = {}));
    (function (e) {
      class k {
        constructor() {
          let h = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
          let a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
          this.bt = h;
          this.pu = f;
          this.value = b;
          this.F5 = a;
        }
        get type() {
          return this.Cg;
        }
        set value(h) {
          "number" === typeof h && isNaN(h) && (h = "");
          if ("string" === typeof h) {
            h = h.replace(RegExp("<br/?>", "gmi"), "\n");
            h = h.replace("/&/gmi", "");
            h = h.replace(RegExp("<[^<]+?>", "gmi"), "");
            var f = e.HF.FI.indexOf(h);
            -1 == f ? (this.MK = e.HF.FI.length, e.HF.FI.push(h)) : this.MK = f;
            this.Cg = e.qy.$c;
          } else this.MK = h, this.Cg = "number" === typeof h ? e.qy.jb : null === h ? e.qy.T8 : !1 === h ? e.qy.x8 : e.qy.bra;
        }
        get value() {
          return this.MK;
        }
        set id(h) {}
        get id() {
          let h = "",
            f = this.pu;
          for (; 0 <= f;) h = String.fromCharCode(f % 26 + 65) + h, f = Math.floor(f / 26) - 1;
          return h + (this.bt + 1);
        }
        toString() {
          return "XLSCell {row: " + this.bt + ", column: " + this.pu + ", type: " + this.type + ", id: " + this.id + ", value: " + this.value + "}";
        }
      }
      e.nQ = k;
    })(S || (S = {}));
    var ib = S || (S = {});
    class jb {}
    jb.FI = [];
    ib.HF = jb;
    (function (e) {
      class k {
        constructor(h) {
          this.cells = [];
          this.SU = this.TU = 0;
          this.Ka = [];
          this.rows = [];
          this.VU = [];
          this.name = this.iya(h);
        }
        iya(h) {
          h = h.replace(/[\\/*[\]:?]/g, "");
          "'" == h.charAt(0) && (h = h.substr(1));
          h = h.replace(/&/g, "&amp;");
          h = h.replace(/'/g, "&apos;");
          h = h.replace(/"/g, "&quot;");
          h = h.replace(/</g, "&lt;");
          h = h.replace(/>/g, "&gt;");
          30 < h.length && (h = h.substr(0, 27) + "...");
          return h;
        }
        get Yfa() {
          return this.Xf(this.TU, this.SU);
        }
        set Yfa(h) {}
        get tva() {
          return this.SU + 1;
        }
        get GN() {
          return this.TU + 1;
        }
        gia(h, f) {
          this.Ka[h] = f;
        }
        oH(h) {
          return this.Ka[h] ? this.Ka[h] : 0;
        }
        Dx(h, f) {
          this.rows[h] = f;
        }
        Xd(h) {
          return this.rows[h] ? this.rows[h] : 0;
        }
        Li(h, f, b) {
          let a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          null == this.cells[h] && (this.cells[h] = []);
          this.cells[h][f] = b instanceof e.nQ ? b : new e.nQ(h, f, b, null == a ? 0 : a.index);
          this.TU < h && (this.TU = h);
          this.SU < f && (this.SU = f);
        }
        Xf(h, f) {
          var b;
          null != this.cells[h] && (b = this.cells[h][f]);
          null == b && (b = new e.nQ(h, f, null));
          return b;
        }
        cga(h, f, b) {
          var a = this.Xf(h, f);
          if (null != a) {
            for (var c = a.id, d, g = f + 1; g < f + b; g++) d = new e.nQ(h, g, !1, a.F5), this.cells[h][g] = d;
            c += ":" + (d ? d.id : a.id);
            this.VU.push(c);
          }
        }
        Kc() {
          for (var h = "", f = 0; f < this.cells.length; f++) {
            var b = this.cells[f];
            if (null != b && 0 != b.length) {
              for (var a = "", c = 0; c < b.length; c++) {
                var d = b[c];
                null != d && d.type != e.qy.T8 && (a = d.type == e.qy.x8 ? a + ('<c r="' + d.id + '" s="' + d.F5.toString() + '" />') : a + ('<c r="' + d.id + '" s="' + d.F5.toString() + '"' + (d.type == e.qy.$c ? ' t="s"' : "") + "><v>" + d.value + "</v></c>"));
              }
              h = isNaN(this.rows[f]) ? h + q.P.bind('<row spans="1:3" r="{0}"  >{1}</row>', f + 1, a) : h + q.P.bind('<row spans="1:3" r="{0}" x14ac:dyDescent="0.25" ht="{1}" customHeight="1">{2}</row>', f + 1, this.rows[f], a);
            }
          }
          f = "";
          for (b = 0; b < this.Ka.length; b++) isNaN(this.Ka[b]) || (f += q.P.bind('<col min="{0}" max="{1}" width="{2}" customWidth="1" />', b + 1, b + 1, this.Ka[b]));
          a = "";
          for (b = 0; b < this.VU.length; b++) a += q.P.bind('<mergeCell ref="{0}"/>', this.VU[b]);
          b = 0 < this.VU.length ? q.P.bind('<mergeCells count="{0}">{1}</mergeCells>', this.cga.length, a) : "";
          return q.P.bind(e.Ti.iqa, this.Xf(0, 0).id + ":" + this.Yfa.id, f, h, b);
        }
      }
      e.rra = k;
    })(S || (S = {}));
    var kb = S || (S = {});
    class lb {}
    lb.T8 = 0;
    lb.jb = 1;
    lb.$c = 2;
    lb.x8 = 98;
    lb.bra = 99;
    kb.qy = lb;
    (function (e) {
      (function (k) {
        class h {
          constructor(f, b) {
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            this.index = 0;
            this.fill = b instanceof k.Xl.gK ? b : !isNaN(b) && -1 < b ? new k.Xl.gK(b) : new k.Xl.gK();
            this.font = f instanceof k.fonts.Mv ? f : new k.fonts.Mv(f);
            this.format = a && a instanceof k.format.Gt ? a : new k.format.Gt(0, "");
            null != c && (this.textAlign = c);
          }
          set id(f) {}
          get id() {
            return this.fill.id + ":" + this.font.id + ":" + this.textIndent + ":" + this.textAlign + ":" + this.format.id;
          }
          Kc() {
            var f = this.textIndent || this.textAlign ? q.P.bind('<alignment vertical="center" horizontal="{0}" wrapText="1"{1}/>', q.v(this.textAlign) ? "left" : this.textAlign, q.v(this.textIndent) ? "" : ' indent="' + this.textIndent + '"') : '<alignment vertical="center" wrapText="1"/>';
            return q.P.bind('<xf numFmtId="{0}"{1} fontId="{2}" fillId="{3}" borderId="1" xfId="0" applyFont="1" applyFill="1"{4}>{5}</xf>', this.format.Rz, 0 < this.format.Rz ? ' applyNumberFormat = "1"' : "", this.font.WS, this.fill.XL, 0 < f.length ? ' applyAlignment="1"' : "", f);
          }
        }
        k.qB = h;
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      (function (k) {
        class h {
          constructor() {
            this.td = new q.ub();
            this.Xl = new q.ub();
            this.fonts = new q.ub();
            this.Ce = new q.ub();
            this.vaa(new k.Xl.gK());
            var f = new k.Xl.gK();
            f.w4.x4 = "solid";
            f.XL = 1;
            this.Xl.Ua("solid", f);
          }
          fw(f) {
            this.td.Bb(f.id) ? f.index = this.td.getItem(f.id).index : (this.vaa(f.fill), this.addFont(f.font), this.td.Ua(f.id, f), f.index = this.td.length);
          }
          vaa(f) {
            this.Xl.Bb(f.id) ? f.XL = this.Xl.getItem(f.id).XL : (f.XL = this.Xl.length, this.Xl.Ua(f.id, f));
          }
          addFont(f) {
            this.fonts.Bb(f.id) ? f.WS = this.fonts.getItem(f.id).WS : (this.fonts.Ua(f.id, f), f.WS = this.fonts.length);
          }
          gta(f) {
            this.Ce.Bb(f.id) ? f.Rz = this.Ce.getItem(f.id).Rz : (-1 == f.Rz && (f.Rz = k.format.Gt.WAa()), this.Ce.Ua(f.id, f));
          }
          Kc() {
            var f = "",
              b = "",
              a = "",
              c = "",
              d;
            if (0 < this.Ce.length) {
              var g = 0,
                l = "";
              for (d = 0; d < this.Ce.length; d++) {
                var m = this.Ce.ea(d);
                "" != m.ZS && (m = m.Kc(), l += m, g++);
              }
              0 < g && (f = '<numFmts count="' + g + '">' + l + "</numFmts>");
            }
            for (d = 0; d < this.Xl.length; d++) g = this.Xl.ea(d), b += g.Kc();
            for (d = 0; d < this.fonts.length; d++) g = this.fonts.ea(d), a += g.Kc();
            for (d = 0; d < this.td.length; d++) g = this.td.ea(d), c += g.Kc();
            return q.P.bind(e.Ti.qqa, f, this.fonts.length + 1, a, this.Xl.length, b, this.td.length + 1, c);
          }
        }
        k.vra = h;
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b) {
              this.rgb = b;
            }
            set id(b) {}
            get id() {
              return this.rgb.toString(16);
            }
            Kc() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
              0 == b.length && (b = "color");
              b = "<" + b;
              this.pua && (b += ' auto="' + this.pua + '"');
              this.RKa && (b += ' theme="' + this.RKa + '"');
              this.VKa && (b += ' tint="' + this.VKa + '"');
              this.cCa && (b += ' indexed="' + this.cCa + '"');
              for (var a = this.rgb.toString(16).toUpperCase(); 6 > a.length;) a = "0" + a;
              return b + (' rgb="FF' + a + '"/>');
            }
          }
          h.xY = f;
        })(k.color || (k.color = {}));
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.xY {
            constructor(b) {
              super(b);
            }
            Kc() {
              return super.Kc("bgColor");
            }
          }
          h.sra = f;
        })(k.color || (k.color = {}));
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f extends h.xY {
            constructor(b) {
              super(b);
            }
            Kc() {
              return super.Kc("fgColor");
            }
          }
          h.tra = f;
        })(k.color || (k.color = {}));
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
              this.XL = 0;
              this.w4 = new h.ura(b);
            }
            Kc() {
              return "<fill>" + this.w4.Kc() + "</fill>";
            }
            set id(b) {}
            get id() {
              return this.w4.id;
            }
          }
          h.gK = f;
        })(k.Xl || (k.Xl = {}));
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {
              let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
              this.x4 = "solid";
              -1 < b ? (this.fgColor = new k.color.tra(b), this.bgColor = new k.color.sra(b)) : this.x4 = "none";
            }
            get id() {
              return q.v(this.fgColor) ? "none" : this.fgColor.id;
            }
            Kc() {
              return q.P.bind('<patternFill patternType="{0}">{1}{2}</patternFill>', this.x4, q.v(this.fgColor) ? "" : this.fgColor.Kc(), q.v(this.bgColor) ? "" : this.bgColor.Kc());
            }
          }
          h.ura = f;
        })(k.Xl || (k.Xl = {}));
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b, a, c) {
              this.WS = 0;
              q.v(b) || (this.name = b.replace(/"/g, "").trim());
              q.v(a) || (this.size = a);
              q.v(c) || (this.XT = new k.color.xY(c));
            }
            set id(b) {}
            get id() {
              return this.name + "," + this.size + "," + (q.v(this.XT) ? "" : this.XT.id) + "," + this.bold + "," + this.OD;
            }
            Kc() {
              var b = "<font>";
              this.bold && (b += "<b/>");
              this.size && (b += '<sz val="' + this.size + '"/>');
              this.XT && (b += this.XT.Kc());
              if (this.name) {
                var a = this.name;
                this.name.indexOf(",") && (a = this.name.split(",")[0].trim());
                b += '<name val="' + a + '"/>';
              }
              return b + "</font>";
            }
          }
          h.Mv = f;
        })(k.fonts || (k.fonts = {}));
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor(b, a) {
              this.Rz = b;
              this.ZS = a;
            }
            Kc() {
              return '<numFmt numFmtId="' + this.Rz + '" formatCode="' + this.ZS + '"/>';
            }
            get id() {
              return "" != this.ZS ? this.ZS : this.Rz.toString();
            }
            set id(b) {}
            static WAa() {
              return f.Efa++;
            }
          }
          f.hca = 1;
          f.Efa = f.hca;
          h.Gt = f;
        })(k.format || (k.format = {}));
      })(e.td || (e.td = {}));
    })(S || (S = {}));
    (function (e) {
      class k {
        static format(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          let a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          let c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
          null == f && (f = k.wS);
          if (isNaN(h) || q.v(h)) return f.TD;
          if (Infinity == h) return f.xD;
          if (h == q.u.i.RO.QO) return f.KC;
          b || (b = f.Fe);
          h = f.ce && "%" != f.xd ? 100 * h : h;
          h = k.hva(h);
          var d = a || f.ce ? "%" : f.xd,
            g = a || f.ce ? q.model.ac.W.af.Xz["1$"] : f.Zs;
          a = a || f.ce ? q.model.ac.W.af.iq["-1$"] : f.Ss;
          var l = b ? 0 : f.Sl;
          if (0 == h && 0 > l) {
            var m = "0";
            !b && 0 < d.length && (m = k.R0(m, d, g, a));
            return m;
          }
          m = 0 > h ? f.lx - 1 : f.lx;
          1 < f.Kf.length && !q.P.ECa(f.Kf) && (m -= Math.floor(m / 3) * f.Kf.length);
          !b && 0 < f.c0 && (m -= f.c0);
          f.Kf = "&#39;" == f.Kf ? "'" : f.Kf;
          var n = h.toString().split(".");
          if (1 < n.length && 10 <= n[1].length && f.xG) {
            n = n[1];
            for (var p = 0, t = 0, r = n.length - 2; 0 <= r; r--) if ("9" != n.charAt(r) && "0" != n.charAt(r) || n.charAt(r) != n.charAt(r + 1)) {
              if (4 > p) p = 0;else {
                t = r + 1;
                break;
              }
            } else p++;
            4 <= p && (n = Math.pow(10, t), h = 0 == Math.round(h * n) / n ? h : Math.round(h * n) / n);
          }
          n = 4 < l ? Math.pow(10, m - l - 1) : Math.pow(10, m - 4);
          p = Math.pow(10, -(m - 4));
          -1 < c && (l = c);
          Math.abs(h) > n ? (c = Math.round(Math.log(h) / Math.LN10), c = Math.round(Math.log(c) / Math.LN10 + 1), m = 0 > h ? f.lx - c - 5 : f.lx - c - 4, 0 <= f.Sl && (m = Math.min(m, f.Sl)), 0 <= f.$u && (m = Math.min(m, f.$u)), m = Math.max(1, Math.min(20, m)), m = h.toExponential(m)) : Math.abs(h) < p && 0 > l ? (c = Math.round(Math.log(h) / Math.LN10), c = Math.round(Math.log(-c) / Math.LN10 + 1), m = m - 4 - c, 20 < m && (m = 20), 1 > m && (m = 1), m = h.toExponential(m)) : 0 > l && 0 > f.$u ? m = h.toString() : 0 == l || 0 == f.$u ? m = Math.round(h).toString() : (m = f.$u, 0 < l && m > l && (m = l), 0 < l && 0 < m && m < l && (l = m), m = k.toFixed(h, l, m));
          c = m.split(".");
          m = k.lz(c[0], f);
          c = 1 < c.length ? c[1] : "";
          m = 0 < c.length ? m + f.HC + c : m;
          !b && 0 < d.length ? m = k.R0(m, d, g, a) : 0 == d.length && 0 > h && (m = k.S0(m, f.Qz));
          return m = k.kba(m, h);
        }
        static toFixed(h, f) {
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
          if (0 >= f && 0 >= b) return h.toFixed(0);
          0 > f && (f = 0);
          0 > b && (b = f);
          h = h.toLocaleString("en-US", {
            minimumFractionDigits: f,
            maximumFractionDigits: b
          });
          f = h.indexOf(".");
          return 0 <= f ? h.substr(0, f).replace(/[,\s\.]/g, "") + "." + h.substr(f + 1) : h.replace(/[,\s\.]/g, "");
        }
        static sKa(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          let b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          let a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          var c = 0 > h;
          h = Math.abs(h);
          if (1E3 > h) return k.format(h, f, b, a);
          if (1E6 > h) {
            h /= 1E3;
            var d = "K";
          } else 1E9 > h ? (h /= 1E6, d = "M") : 1E12 > h ? (h /= 1E9, d = "B") : (h /= 1E12, d = "T");
          var g = (c ? "-" : "") + k.toFixed(h, 0 == h % 1 ? 0 : 1),
            l = g.split(".");
          g = k.lz(l[0], f);
          l = 1 < l.length ? l[1] : "";
          g = 0 < l.length ? g + f.HC + l : g;
          g += d;
          d = a || f.ce ? "%" : f.xd;
          l = a || f.ce ? q.model.ac.W.af.Xz["1$"] : f.Zs;
          a = a || f.ce ? q.model.ac.W.af.iq["-1$"] : f.Ss;
          !b && 0 < d.length ? g = k.R0(g, d, l, a) : 0 == d.length && c && (g = k.S0(g, f.Qz));
          return g = k.kba(g, h);
        }
        static lz(h) {
          let f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var b = 0 > parseFloat(h);
          b && (h = h.substr(1));
          var a = h;
          if (3 < h.length) {
            null == f && (null == k.wS && (k.wS = new q.model.ac.W.af("")), f = k.wS);
            a = Math.floor(h.length / 3);
            var c = [],
              d = h.length % 3;
            0 < d && c.push(h.substr(0, d));
            for (var g = 0; g < a; g++) c.push(h.substr(d + 3 * g, 3));
            a = c.join(f.Kf);
          }
          b && (a = "-" + a);
          return a;
        }
        static R0(h, f, b, a) {
          return 0 == h.indexOf("-") ? this.bM(h, f, a) : this.Wya(h, f, b);
        }
        static bM(h, f, b) {
          h = 0 == h.indexOf("-") ? h.substr(1) : h;
          switch (b) {
            case q.model.ac.W.af.iq["-$1"]:
              h = "-" + f + h;
              break;
            case q.model.ac.W.af.iq["$1-"]:
              h = f + h + "-";
              break;
            case q.model.ac.W.af.iq["($1)"]:
              h = "(" + f + h + ")";
              break;
            case q.model.ac.W.af.iq["(1$)"]:
              h = "(" + h + f + ")";
              break;
            case q.model.ac.W.af.iq["-1$"]:
              h = "-" + h + f;
              break;
            case q.model.ac.W.af.iq["$-1"]:
              h = f + "-" + h;
              break;
            case q.model.ac.W.af.iq["1-$"]:
              h = h + "-" + f;
              break;
            case q.model.ac.W.af.iq["1$-"]:
              h = h + f + "-";
              break;
            case q.model.ac.W.af.iq["$(1)"]:
              h = f + "(" + h + ")";
              break;
            case q.model.ac.W.af.iq["(1)$"]:
              h = "(" + h + ")" + f;
          }
          return h;
        }
        static Wya(h, f, b) {
          switch (b) {
            case q.model.ac.W.af.Xz.$1:
              h = f + h;
              break;
            default:
              h += f;
          }
          return h;
        }
        static S0(h, f) {
          h = 0 == h.indexOf("-") ? h.substr(1) : h;
          switch (f) {
            case q.model.ac.W.af.fI["-1"]:
              h = "-" + h;
              break;
            case q.model.ac.W.af.fI["- 1"]:
              h = "- " + h;
              break;
            case q.model.ac.W.af.fI["1-"]:
              h += "-";
              break;
            case q.model.ac.W.af.fI["1 -"]:
              h += " -";
              break;
            case q.model.ac.W.af.fI["(1)"]:
              h = "(" + h + ")";
              break;
            default:
              h = "-" + h;
          }
          return h;
        }
        static kba(h, f) {
          return 0 <= f || -1 == h.indexOf("-") || -1 < h.search("[1-9]+") ? h : h.replace("-", "");
        }
        static Vg(h) {
          return k.lz((h / 1024).toFixed(0));
        }
        static hva(h) {
          const f = Math.abs(h);
          f < k.EPSILON ? h = Math.floor(f) : f - Math.floor(f) < k.EPSILON && (h = 0 > h ? Math.ceil(h) : Math.floor(h));
          return h;
        }
      }
      k.wS = new q.model.ac.W.af();
      k.EPSILON = "undefined" === typeof Number.EPSILON ? 2.220446049250313E-16 : Number.EPSILON;
      e.cc = k;
    })(u || (u = {}));
    window["FM-DIVIDER"] = "FM-DIVIDER";
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {}
            static J(b) {
              b = f.nua[b];
              for (var a = "", c = 0; c < b.length; c++) a += String.fromCharCode(b[c] + 101);
              return a;
            }
          }
          f.nua = [[7, 4, -2, 0, 9, 14, 0, -26, 0, 20], [11, 13, 10, -1, 16, -2, 15, -26, 0, 20], [2, 0, 9, 0, 13, -4, 15, 0, -1, -26, 0, 20], [7, 4, -2, 0, 9, 14, 0, -31, 4, 7, 0, -21, -4, 15, 3], [-28, -31, 13, -4, 8, 0, -69, -1, 0, 15, 0, -2, 15, 0, -1, -55, -41, -3, 13, -54, -39, -21, 7, 0, -4, 14, 0, -69, -2, 10, 9, 15, -4, -2, 15, -69, -2, 7, 4, 0, 9, 15, 14, -69, 14, 16, 11, 11, 10, 13, 15, -69, 4, 1, -69, 20, 10, 16, -69, 3, -4, 17, 0, -69, -4, 9, 20, -69, 11, 13, 10, -3, 7, 0, 8, -69, 18, 4, 15, 3, -69, 15, 3, 0, -69, 7, 4, -2, 0, 9, 14, 0, -69, 6, 0, 20, -55], [-12, 10, 16, -69, -4, 13, 0, -69, 15, 13, 20, 4, 9, 2, -69, 15, 10, -69, 16, 14, 0, -69, -4, -69, -1, 0, 17, 0, 7, 10, 11, 8, 0, 9, 15, -69, 6, 0, 20, -69, 10, 9, -69, -4, -69, 13, 0, -4, 7, -69, -1, 10, 8, -4, 4, 9, -69, -61, 22, -53, 24, -60, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, -1, 0, 17, -56, 6, 0, 20, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [7, 10, -2, -4, 7, 3, 10, 14, 15], [-28, 9, 17, -4, 7, 4, -1, -69, 7, 4, -2, 0, 9, 14, 0, -69, 6, 0, 20, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, 4, 9, 17, -4, 7, 4, -1, -56, 7, 4, -2, 0, 9, 14, 0, -56, 6, 0, 20, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-12, 10, 16, -69, -4, 13, 0, -69, 15, 13, 20, 4, 9, 2, -69, 15, 10, -69, 16, 14, 0, -69, 15, 3, 0, -69, 1, 10, 7, 7, 10, 18, 4, 9, 2, -69, 6, 0, 20, -43, -41, -3, 13, -54, -39], [1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, 11, 4, 17, 10, 15, 15, -4, -3, 7, 0, 6, 0, 20, -55, 15, 19, 15], [-38, 15, 4, 8, 0, -40], [-25, 4, -2, 0, 9, 14, 0, -69, 6, 0, 20, -69, 9, 10, 15, -69, 1, 10, 16, 9, -1, -55, -41, -3, 13, -54, -39, -21, 7, 0, -4, 14, 0, -69, 14, 0, 15, -69, 20, 10, 16, 13, -69, 6, 0, 20, -69, 1, 10, 13, -69, 15, 3, 0, -69, -2, 10, 8, 11, 10, 9, 0, 9, 15, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, -68, 7, 4, -2, 0, 9, 14, 0, -56, 9, 16, 8, -3, 0, 13, -56, 9, 10, 15, -56, 1, 10, 16, 9, -1, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-25, 4, -2, 0, 9, 14, 0, -69, 6, 0, 20, -69, 4, 14, -69, 0, 8, 11, 15, 20, -55], [-12, 10, 16, 13, -69, 7, 4, -2, 0, 9, 14, 0, -69, 6, 0, 20, -69, 4, 14, -69, 10, 16, 15, -1, -4, 15, 0, -1, -69, -4, 9, -1, -69, 18, 4, 7, 7, -69, 9, 10, 15, -69, 1, 16, 9, -2, 15, 4, 10, 9, -69, 18, 4, 15, 3, -69, 15, 3, 0, -69, -2, 16, 13, 13, 0, 9, 15, -69, 17, 0, 13, 14, 4, 10, 9, -55, -69, -21, 7, 0, -4, 14, 0, -69, -2, 10, 9, 15, -4, -2, 15, -69, 10, 16, 13, -69, 15, 0, -4, 8, -69, 15, 10, -69, 1, 4, 9, -1, -69, 10, 16, 15, -69, -4, -3, 10, 16, 15, -69, 16, 11, 2, 13, -4, -1, 0, -69, 10, 11, 15, 4, 10, 9, 14, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, 10, 16, 15, -1, -4, 15, 0, -1, -56, 6, 0, 20, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-11, -13], [-11, -20], [-13, -30], [-11, -48], [-25, 4, -2, 0, 9, 14, 0, -69, 6, 0, 20, -69, 4, 14, -69, -2, 10, 13, 13, 16, 11, 15, 0, -1, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, -68, 7, 4, -2, 0, 9, 14, 0, -56, 9, 16, 8, -3, 0, 13, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [18, 18, 18, -55], [7, 10, -2, -4, 15, 4, 10, 9], [3, 10, 14, 15, 9, -4, 8, 0], [-12, 10, 16, 13, -69, 7, 4, -2, 0, 9, 14, 0, -69, 11, 0, 13, 4, 10, -1, -69, 3, -4, 14, -69, 0, 19, 11, 4, 13, 0, -1, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, 7, 4, -2, 0, 9, 14, 0, -56, 0, 19, 11, 4, 13, 0, -1, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-12, 10, 16, 13, -69, 15, 13, 4, -4, 7, -69, 11, 0, 13, 4, 10, -1, -69, 3, -4, 14, -69, 0, 19, 11, 4, 13, 0, -1, -55, -41, -3, 13, -39, -41, -3, 13, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -67, 3, 15, 15, 11, 14, -43, -54, -54, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -2, 10, 9, 15, -4, -2, 15, -54, -38, 13, -40, 15, 0, 19, -67, -69, 15, -4, 13, 2, 0, 15, -40, -67, -6, -3, 7, -4, 9, 6, -67, -39, -17, 10, -69, -2, 10, 9, 15, 4, 9, 16, 0, -69, 15, 3, 0, -69, 0, 17, -4, 7, 16, -4, 15, 4, 10, 9, -69, 10, 1, -69, 10, 16, 13, -69, -2, 10, 8, 11, 10, 9, 0, 9, 15, -69, 11, 7, 0, -4, 14, 0, -69, -2, 10, 9, 15, -4, -2, 15, -69, 10, 16, 13, -69, 14, -4, 7, 0, 14, -69, 15, 0, -4, 8, -69, 1, 10, 13, -69, 15, 13, 4, -4, 7, -69, 0, 19, 15, 0, 9, 14, 4, 10, 9, -55, -41, -54, -4, -39, -41, -54, 16, -39], [-13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13], [-12, 10, 16, -69, -4, 13, 0, -69, 15, 13, 20, 4, 9, 2, -69, 15, 10, -69, 16, 14, 0, -69, -4, -69, 15, 0, 8, 11, 7, -4, 15, 0, -69, 7, 4, -2, 0, 9, 14, 0, -69, 10, 13, -69, 15, 13, 4, -4, 7, -69, 6, 0, 20, -43, -69, -67, -13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13, -67, -55, -41, -3, 13, -39, -41, -3, 13, -39, -91, -21, 7, 0, -4, 14, 0, -69, 13, 0, 11, 7, -4, -2, 0, -69, -67, -13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13, -56, -13, -13, -13, -13, -67, -69, 18, 4, 15, 3, -69, -4, 9, -69, -4, -2, 15, 16, -4, 7, -69, 6, 0, 20, -55], [-16, 9, 7, 4, -2, 0, 9, 14, 0, -1], [-31, 13, 0, 0], [-18, 15, -4, 9, -1, -4, 13, -1], [-34, -18, -15, -54, -27, -18, -22, -23, -54, -18, -20, -25, -69, 7, 4, 8, 4, 15, 0, -1], [-34, -18, -15, -54, -27, -18, -22, -23, -54, -18, -20, -25], [-24, 10, 9, -1, 13, 4, -4, 9], [-36, 9, -4, 7, 20, 14, 4, 14, -69, -18, 0, 13, 17, 4, -2, 0, 14], [-4, 7, 7], [-41, -3, 13, -39, -33, -4, 15, -4, -69, 14, 10, 16, 13, -2, 0, 14, -43, -69], [-41, -3, 13, -39, -17, 13, 4, -4, 7, -69, 11, 0, 13, 4, 10, -1, -69, 0, 19, 11, 4, 13, -4, 15, 4, 10, 9, -43, -69], [-41, -3, 13, -39, -25, 4, -2, 0, 9, 14, 0, -69, 17, -4, 7, 4, -1, -69, 15, 4, 7, 7, -43, -69], [-41, -3, 13, -39, -25, 4, -2, 0, 9, 14, 0, 0, -43, -69], [-41, -3, 13, -39, -33, 10, 8, -4, 4, 9, -43, -69], [-41, -3, 13, -39, -41, -3, 13, -39, -25, 4, -2, 0, 9, 14, 0, -69, 6, 0, 20, -43, -69], [-41, -3, 13, -39, -41, -3, 13, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -41, -54, -4, -39, -41, -54, 16, -39, -69, -56, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, 13, 8, -4, 15, 4, 10, 9, -69, -4, -3, 10, 16, 15, -69, -31, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -69, -21, 4, 17, 10, 15, -69, -17, -4, -3, 7, 0, -69, -63, -69, -34, 3, -4, 13, 15, 14], [-31, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -69, -21, 4, 17, 10, 15, -69, -17, -4, -3, 7, 0, -69, -63, -69, -34, 3, -4, 13, 15, 14], [-17, 13, 4, -4, 7, -69, 17, 0, 13, 14, 4, 10, 9, -69], [3, 15, 15, 11, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, 4, -2, 10, 9, 14, -55, -4, 14, 3, 19, -38, 13, -40, 1, 13, 0, 0, -63, -1, -40], [-33, 0, 17, 0, 7, 10, 11, 0, 13, -62, 14, -69, 17, 0, 13, 14, 4, 10, 9, -69, -61], [-21, 10, 18, 0, 13, 0, -1, -69, -3, 20, -69, -41, -4, -69, 3, 13, 0, 1, -40, -67, 3, 15, 15, 11, 14, -43, -54, -54, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -38, 13, -40, -3, 13, -67, -69, 15, -4, 13, 2, 0, 15, -40, -67, -6, -3, 7, -4, 9, 6, -67, -39, -31, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -41, -54, -4, -39, -69, -21, 4, 17, 10, 15, -69, -17, -4, -3, 7, 0, -69, -63, -69, -34, 3, -4, 13, 15, 14], [-25, 4, 8, 4, 15, -4, 15, 4, 10, 9, -55], [-31, 4, 7, 0, -69, 4, 14, -69, 15, 10, 10, -69, 7, -4, 13, 2, 0, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, 7, -4, 13, 2, 0, -56, 1, 4, 7, 0, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-24, -18, -69, -22, -25, -36, -21, -69, 14, 16, 11, 11, 10, 13, 15, -69, 4, 14, -69, 9, 10, 15, -69, -4, 17, -4, 4, 7, -4, -3, 7, 0, -69, 4, 9, -69, 15, 3, 0, -69, -2, 16, 13, 13, 0, 9, 15, -69, 0, -1, 4, 15, 4, 10, 9, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, 8, 14, -4, 14, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-24, 10, 9, -1, 13, 4, -4, 9, -69, 14, 16, 11, 11, 10, 13, 15, -69, 4, 14, -69, 9, 10, 15, -69, -4, 17, -4, 4, 7, -4, -3, 7, 0, -69, 4, 9, -69, 15, 3, 0, -69, -2, 16, 13, 13, 0, 9, 15, -69, 0, -1, 4, 15, 4, 10, 9, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, 8, 10, 9, -1, 13, 4, -4, 9, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-69, -41, -4, -69, 3, 13, 0, 1, -40, -67, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -2, 10, 9, 15, -4, -2, 15, -54, -38, 13, -40, 15, 0, 19, -67, -69, 15, -4, 13, 2, 0, 15, -40, -67, -6, -3, 7, -4, 9, 6, -67, -39, -32, 19, 15, 0, 9, -1, -69, 8, 20, -69, 15, 13, 4, -4, 7, -41, -54, -4, -39], [], [], [-34, -18, -15, -57, -69, -22, -34, -18, -15, -57, -69, -4, 9, -1, -69, -27, -18, -22, -23, -69, 14, 16, 11, 11, 10, 13, 15, -69, 4, 14, -69, 9, 10, 15, -69, -4, 17, -4, 4, 7, -4, -3, 7, 0, -69, 4, 9, -69, 15, 3, 0, -69, -2, 16, 13, 13, 0, 9, 15, -69, 0, -1, 4, 15, 4, 10, 9, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, -2, 14, 17, -56, 5, 14, 10, 9, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-41, -3, 13, -39, -25, 4, -2, 0, 9, 14, 0, -43, -69, 11, 0, 13, 11, 0, 15, 16, -4, 7], [-41, -3, 13, -39, -31, 13, 0, 0, -69, 16, 11, -1, -4, 15, 0, 14, -69, 15, 4, 7, 7, -43, -69], [-28, 9, 15, 0, 2, 13, -4, 15, 4, 10, 9, -69, 18, 4, 15, 3, -69, 15, 3, 4, 13, -1, -56, 11, -4, 13, 15, 20, -69, -2, 3, -4, 13, 15, 4, 9, 2, -69, 7, 4, -3, 13, -4, 13, 4, 0, 14, -69, 4, 14, -69, 9, 10, 15, -69, -4, 17, -4, 4, 7, -4, -3, 7, 0, -69, 4, 9, -69, 15, 3, 0, -69, 15, 13, 4, -4, 7, -69, 17, 0, 13, 14, 4, 10, 9, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, 15, 3, 4, 13, -1, -56, 11, -4, 13, 15, 20, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [], [], [], [], [], [-31, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -69, -21, 4, 17, 10, 15, -69, -17, -4, -3, 7, 0, -41, -3, 13, -54, -39, -61, 15, 13, 4, -4, 7, -69, 17, 0, 13, 14, 4, 10, 9, -60], [-34, 16, 13, 13, 0, 9, 15, -69, 6, 0, 20, -69, 4, 14, -69, -4, 11, 11, 7, 4, -2, -4, -3, 7, 0, -69, 10, 9, 7, 20, -69, 15, 10, -69, -41, -3, -39, 22, -53, 24, -41, -54, -3, -39, -55, -41, -3, 13, -54, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -62, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, -2, 16, 13, 13, 0, 9, 15, -56, 6, 0, 20, -62, -69, 15, -4, 13, 2, 0, 15, -40, -62, -6, -3, 7, -4, 9, 6, -62, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-16, 16, -27, -1, -28, 8, -51, 8, -26, 16, -17, -48, -13, -2, -22, -15, -17, -12, 14, 10, 0, 21, -26, -14, -47, -33, 6, -13, 17, 15, -21, -17], [-2, 10, -1, 0, 11, 0, 9, -55, 4, 10], [1, 4, -1, -1, 7, 0, -55, 5, 14, 3, 0, 7, 7, -55, 9, 0, 15], [3, 15, 15, 11, -43, -54, -54], [3, 15, 15, 11, 14, -43, -54, -54], [13, 0, 1, 0, 13, 13, 0, 13], [-32, 7, -4, 14, 15, 4, -2, 14, 0, -4, 13, -2, 3, -69, 14, 16, 11, 11, 10, 13, 15, -69, 4, 14, -69, 9, 10, 15, -69, -4, 17, -4, 4, 7, -4, -3, 7, 0, -69, 4, 9, -69, 15, 3, 0, -69, -2, 16, 13, 13, 0, 9, 15, -69, 0, -1, 4, 15, 4, 10, 9, -55, -41, -3, 13, -39, -41, 16, -39, -41, -4, -69, 3, 13, 0, 1, -40, -67, 3, 15, 15, 11, 14, -43, -54, -54, 18, 18, 18, -55, 1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, -55, -2, 10, 8, -54, -1, 10, -2, -54, 15, 20, 11, 4, -2, -4, 7, -56, 0, 13, 13, 10, 13, 14, -54, -66, 0, 14, -67, -69, 15, -4, 13, 2, 0, 15, -40, -67, -6, -3, 7, -4, 9, 6, -67, -39, -19, 0, -4, -1, -69, 8, 10, 13, 0, -69, 4, 9, 1, 10, -69, -4, -3, 10, 16, 15, -69, 15, 3, 4, 14, -69, 0, 13, 13, 10, 13, -41, -54, -4, -39, -41, -54, 16, -39], [-32, 7, -4, 14, 15, 4, -2, 14, 0, -4, 13, -2, 3], [1, 7, 0, 19, 8, 10, 9, 14, 15, 0, 13, 11, 4, 17, 10, 15, 15, -4, -3, 7, 0, 6, 0, 20], [14, 15, -4, -2, 6, -3, 7, 4, 15, 21, -55, -2, 10, 8], [14, 15, -4, -2, 6, -3, 7, 4, 15, 21, -55, 4, 10], [-30, 17, 5, -20, 2, -31, 5, -28, -17, -12, -48, 8, -15, -36, -34, 12, 14, -26, -32, -48, -18, -3, -29, -31, -13, -27, 19, -3, -48, 9, -20, -23], [-11, -46, -30, -19, -56, -13, -34, -51, -33, -47, -35, -56, -49, -44, -51, -20, -46, -53, -56, -53, -34, -47, -14, -53, -13], [-34, 16, 13, 13, 0, 9, 15, -69, 17, 0, 13, 14, 4, 10, 9, -43, -69], [-35, -16, -28, -25, -33, -6, -15, -32, -19, -18, -28, -22, -23], [-35, -16, -28, -25, -33, -6, -33, -36, -17, -32], [-41, -3, 13, -54, -39], [-3, 16, 4, 7, -1], [-41, 14, 11, -4, 9, -69, -2, 7, -4, 14, 14, -40, -62, 1, 8, -56, -3, 16, 4, 7, -1, -56, 17, 0, 13, 14, 4, 10, 9, -62, -39, -3, 16, 4, 7, -1, -69, 22, -53, 24, -41, -54, 14, 11, -4, 9, -39]];
          f.Kfa = 0;
          f.mha = 1;
          f.sda = 2;
          f.Q2 = 3;
          f.bCa = 4;
          f.uxa = 5;
          f.Ufa = 6;
          f.Iea = 7;
          f.kLa = 8;
          f.rDa = 9;
          f.SKa = 10;
          f.CEa = 11;
          f.fya = 12;
          f.Jga = 13;
          f.T9 = 14;
          f.xra = 15;
          f.N9 = 16;
          f.wra = 17;
          f.swa = 18;
          f.NLa = 19;
          f.yK = 20;
          f.vK = 21;
          f.CDa = 22;
          f.yja = 23;
          f.sDa = 24;
          f.tDa = 25;
          f.advanced = 31;
          f.all = 33;
          f.gxa = 34;
          f.jLa = 35;
          f.ADa = 36;
          f.BDa = 54;
          f.cja = 55;
          f.HHa = 37;
          f.Bxa = 38;
          f.DDa = 39;
          f.info = 40;
          f.vva = 41;
          f.xja = 42;
          f.ida = 43;
          f.vxa = 44;
          f.$ga = 45;
          f.PD = 46;
          f.BEa = 48;
          f.tEa = 49;
          f.rya = 50;
          f.FEa = 53;
          f.r_ = 56;
          f.NW = 62;
          f.DHa = 63;
          f.EV = 64;
          f.ova = 65;
          f.qDa = 66;
          f.$Ba = 67;
          f.aCa = 68;
          f.referrer = 69;
          f.lya = 70;
          f.eya = 71;
          f.Lfa = 72;
          f.KKa = 73;
          f.LKa = 74;
          f.cJa = 75;
          f.ILa = 76;
          f.Ywa = 77;
          f.eC = 80;
          f.uua = 81;
          f.vua = 82;
          h.ra = f;
        })(k.Ha || (k.Ha = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      class k {
        static encode(h) {
          var f = "",
            b = 0;
          for (h = k.Ara(h); b < h.length;) {
            var a = h.charCodeAt(b++);
            var c = h.charCodeAt(b++);
            var d = h.charCodeAt(b++);
            var g = a >> 2;
            a = (a & 3) << 4 | c >> 4;
            var l = (c & 15) << 2 | d >> 6;
            var m = d & 63;
            isNaN(c) ? l = m = 64 : isNaN(d) && (m = 64);
            f = f + this.Jy.charAt(g) + this.Jy.charAt(a) + this.Jy.charAt(l) + this.Jy.charAt(m);
          }
          return f;
        }
        static decode(h) {
          var f = "",
            b = 0;
          for (h = h.replace(/[^A-Za-z0-9\+\/=]/g, ""); b < h.length;) {
            var a = this.Jy.indexOf(h.charAt(b++));
            var c = this.Jy.indexOf(h.charAt(b++));
            var d = this.Jy.indexOf(h.charAt(b++));
            var g = this.Jy.indexOf(h.charAt(b++));
            a = a << 2 | c >> 4;
            c = (c & 15) << 4 | d >> 2;
            var l = (d & 3) << 6 | g;
            f += String.fromCharCode(a);
            64 != d && (f += String.fromCharCode(c));
            64 != g && (f += String.fromCharCode(l));
          }
          return f = k.zra(f);
        }
        static Ara(h) {
          h = h.replace(/\r\n/g, "\n");
          for (var f = "", b = 0; b < h.length; b++) {
            var a = h.charCodeAt(b);
            128 > a ? f += String.fromCharCode(a) : (127 < a && 2048 > a ? f += String.fromCharCode(a >> 6 | 192) : (f += String.fromCharCode(a >> 12 | 224), f += String.fromCharCode(a >> 6 & 63 | 128)), f += String.fromCharCode(a & 63 | 128));
          }
          return f;
        }
        static zra(h) {
          for (var f = "", b = 0, a, c, d; b < h.length;) a = h.charCodeAt(b), 128 > a ? (f += String.fromCharCode(a), b++) : 191 < a && 224 > a ? (c = h.charCodeAt(b + 1), f += String.fromCharCode((a & 31) << 6 | c & 63), b += 2) : (c = h.charCodeAt(b + 1), d = h.charCodeAt(b + 2), f += String.fromCharCode((a & 15) << 12 | (c & 63) << 6 | d & 63), b += 3);
          return f;
        }
      }
      k.Jy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      e.ska = k;
    })(u || (u = {}));
    (function (e) {
      class k {
        static NR(f, b) {
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          if (0 == f.trim().length) return {
            Zw: !1,
            errorMessage: q.model.B.j.Soa
          };
          const c = new e.IJ().parse(f),
            d = new h();
          return null == c || void 0 == c.length || "string" === typeof c ? (d.Zw = !1, d.errorMessage = h.mea(f), d) : this.Mua(c, b, a, d);
        }
        static Mua(f, b, a, c) {
          k.d$(f, b, a, c);
          return c;
        }
        static d$(f, b, a, c) {
          const d = f[1];
          for (var g = 0; g < d.length; g++) {
            var l = d[g],
              m = q.u.Ma.R().O.Ca;
            if ("string" === typeof l || Array.isArray(l) && 1 === l.length) {
              const n = "string" !== typeof l ? l[0] : l;
              if (n === b && "" !== n) {
                c.Zw = !1;
                c.errorMessage = h.kBa(n);
                break;
              }
              l = m.getItem(n);
              q.v(l) && 0 <= n.indexOf("[Measures].") && (l = m.getItem(q.u.we.Wg(n)));
              if (q.v(l)) {
                if (q.v(a) || 0 > a.indexOf(n)) c.Zw = !1, c.errorMessage = h.mea(n);
                break;
              }
              m = f[0];
              if ("string" === typeof m && !k.Iua(m, l)) {
                c.Zw = !1;
                c.errorMessage = h.DBa(m, b);
                break;
              }
            } else Array.isArray(l) && void 0 != l.length && this.d$(l, b, a, c);
          }
        }
        static Iua(f, b) {
          if (q.v(b)) return !1;
          q.u.i.da.az(f) && (f = q.u.i.da.mz(f));
          q.u.i.qa.Cc === q.u.Ma.R().fa.Ba && -1 === b.Wc.indexOf(f) && q.u.i.da.NONE === b.Bm && (f = b.Bm);
          return b.Oa || -1 !== b.Wc.indexOf(f);
        }
      }
      e.iP = k;
      class h {
        constructor() {
          this.Zw = !0;
          this.errorMessage = null;
        }
        static mea(f) {
          return q.model.B.j.N8 + " <br> " + q.P.bind(q.model.B.j.Uoa, q.model.Tb.validate(f));
        }
        static DBa(f, b) {
          return q.model.B.j.N8 + " <br> " + q.P.bind(q.model.B.j.Roa, q.model.Tb.validate(f), q.model.Tb.validate(b));
        }
        static kBa(f) {
          return q.P.bind(q.model.B.j.Toa, f);
        }
      }
      e.jNa = h;
    })(u || (u = {}));
    (function (e) {
      class k {
        static uM(h, f) {
          if (!q.v(h) && 0 != h.length) {
            var b = [];
            k.tZ(h, f, b);
            return b;
          }
        }
        static uH(h, f) {
          return q.v(h) || 0 == h.length ? h : k.jR(h, f);
        }
        static jR(h, f) {
          var b = [];
          Array.isArray(h[0]) ? b[0] = this.jR(h[0], f) : void 0 !== h[0] && (b[0] = h[0]);
          if (Array.isArray(h[1])) {
            if ("string" === typeof h[1][0]) {
              const a = f.getItem(h[1][0]);
              if (!q.v(a) && a.Oa) return k.uH(a.Sd, f);
            }
            b[1] = this.jR(h[1], f);
          } else void 0 !== h[1] && (b[1] = h[1]);
          Array.isArray(h[2]) ? b[2] = this.jR(h[2], f) : void 0 !== h[2] && (b[2] = h[2]);
          return b;
        }
        static tZ(h, f, b) {
          if (!0 === h[2]) for (var a in h[1]) this.tZ(h[1][a], f, b);else if (!1 === h[2]) {
            a = h[1][0];
            h = h[0];
            const c = f.getItem(a);
            c && c.Oa ? this.tZ(c.Sd, f, b) : b.push(new q.model.hb.jh(a, h));
          }
        }
      }
      e.wt = k;
    })(u || (u = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {}
          f.vY = "UNDEFINED";
          f.FF = "START_REPORT";
          f.vF = "OPENING_REPORT_FILE";
          f.gy = "LOADING_REPORT_FILE";
          f.eo = "REPORT_FILE_LOADED";
          f.WJ = "REPORT_FILE_ERROR";
          f.Wr = "REPORT_FILE_CANCELLED";
          f.hk = "REPORT_CHANGED";
          f.zF = "REPORT_DEFINED";
          f.mF = "LOADING_DATA";
          f.gJ = "DATA_LOADED";
          f.eJ = "DATA_ERROR";
          f.fJ = "DATA_FILE_CANCELLED";
          f.Iv = "STRUCTURE_LOADED";
          f.NX = "LOADING_OLAP_STRUCTURE";
          f.Z8 = "OLAPstructure__LOADED";
          f.Y8 = "OLAPstructure__ERROR";
          f.Hka = "CONNECTED_TO_DATA_SOURCE";
          f.oX = "EMPTY_SLICE";
          f.gB = "RUNNING_QUERY";
          f.al = "QUERY_COMPLETE";
          f.Dt = "QUERY_ERROR";
          f.nF = "LOADING_LOCALIZATION";
          f.oF = "LOCALIZATION_LOADED";
          f.HJ = "LOCALIZATION_ERROR";
          f.pi = "REPORT_COMPLETE";
          f.S6 = "CREATION_COMPLETE";
          h.Uc = f;
          class b {}
          b.vY = "UNDEFINED";
          b.INIT = "INIT";
          b.kp = "CLEAR";
          b.fqa = "SET_REPORT";
          b.Xpa = "RUN_QUERY";
          b.eK = "UPDATE_DATA";
          b.cra = "UPDATE_DATA_PARTIAL";
          b.HA = "CONNECT_TO";
          b.q8 = "LOAD";
          b.OPEN = "OPEN";
          b.Qc = "COMPLETE";
          h.up = b;
          class a extends v.Fh {
            constructor() {
              super();
              this.ja = e.u.Ma.R();
              this.ZY = null;
              this.Ef = b.vY;
              this.nE = f.vY;
              this.KE = this.maa = this.hZ = this.cR = this.YF = !1;
              this.zba = () => this.hFa();
              this.fO = () => this.wr();
              this.Yba = () => this.r3();
              this.aja = c => this.pHa(c);
              this.gL = () => this.p3();
              this.Zz = c => this.YD(c);
              this.sha = c => this.X3(c);
              this.Cha = () => this.eb();
              this.sq = new k.hb.Zpa();
              k.C.F.R();
            }
            get fa() {
              return e.v(this.Ab) || this.Ab.kb ? this.lo : this.Ab;
            }
            set fa(c) {
              this.Ab = c;
            }
            get nc() {
              return this.YF;
            }
            get vU() {
              return this.cR;
            }
            get zU() {
              return this.hZ;
            }
            yD(c) {
              e.v(c) && (c = {});
              this.Ef = b.INIT;
              k.Ha.wc.R().Qua(c, d => {
                if (d) if (this.de(f.FF), this.HM = k.hb.ly.zb(c.global ? c.global : {}), k.C.F.R().N(f.hk, () => this.eb()), k.size.ud.R().N(f.hk, () => this.eb()), k.ua.dn.R().N(f.hk, () => this.eb()), this.JKa(this.HM), this.GR(), "string" === typeof c.report) this.xK(c.report);else {
                  var g = c.report || {};
                  this.sia(g);
                  k.C.F.wq(g.options || g, !0, !1);
                  e.Be(() => {
                    this.Ef === b.INIT && this.FK(g);
                  }, 1);
                }
              });
            }
            de(c) {
              let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
              this.nE = c;
              if (c == f.FF || c == f.vF || c == f.gy) this.hZ = this.cR = this.YF = !1;
              c == f.gB && (this.maa = this.YF, this.YF = !1);
              c != f.al && c != f.Dt || !0 !== this.maa || (this.YF = !0);
              c == f.pi && (this.cR = this.YF = !0);
              c == f.zF && (this.cR = !0);
              c == f.Iv && (this.hZ = !0);
              g && this.Ya(c, null, d);
            }
            Cx(c) {
              e.v(c) && (c = {});
              this.Ef = b.fqa;
              this.cancel();
              this.de(f.FF);
              this.FK(c.report || {});
            }
            fe(c) {
              this.Ef = b.Xpa;
              c = c instanceof e.u.O.Xr ? c : e.u.O.Xr.zb(k.hb.wp.zb(c), this.ja.O);
              var d = e.u.O.Xr.Waa(c, this.ja.pa),
                g = e.u.O.Xr.Vaa(c, this.ja.pa);
              if (e.u.O.Xr.iua(c, this.ja.pa) && !d && !g) {
                const l = new k.hb.Kv();
                l.Ff = k.size.ud.Iha;
                l.yf = k.size.ud.sba;
                l.Hj = k.size.ud.Hj;
                l.ug = k.size.ud.ug;
                l.Fg = k.size.ud.Fg;
                l.sh = k.size.ud.sh;
                k.size.ud.j_(l);
              }
              d && (k.size.ud.Ff = {});
              g && (k.size.ud.yf = {});
              c.oEa(this.ja.pa);
              c.Z5();
              c.Lja();
              k.Va.R().Ya("reset_grid");
              e.u.Re.Ni.Bc().Ge = !1;
              this.ja.zE(c);
              this.ja.filter();
              k.Xa.R().Ea(new k.hd(k.Xa.RP));
            }
            Ud(c, d) {
              this.Ef = b.eK;
              this.cancel();
              this.de(f.FF);
              const g = this.Is();
              d.ignoreSorting && (g.slice.Tj = {}, g.slice.bk = {});
              d.ignoreScroll && k.Va.R().Ya("reset_grid");
              e.ia(g.He) || delete g.He;
              const l = g.ka.mapping;
              g.ka = e.u.O.ut.zb(c);
              g.ka.mapping = g.ka.kb || g.ka.mapping.kb && !g.ka.mapping.Po && void 0 !== l ? l : g.ka.mapping;
              c = g.Sa();
              null == g.ka.uc || e.v(c.dataSource) || (c.dataSource.requestHeaders = g.ka.uc);
              this.FK(c, !0, d);
            }
            sLa(c, d) {
              this.Ef = b.cra;
              var g = this.ja.pa.clone();
              this.cancel();
              this.hia();
              this.de(f.FF);
              d.ignoreSorting && (g.Rb.qC(), g.hc.qC());
              d.ignoreScroll && k.Va.R().Ya("reset_grid");
              this.Ld.ka.data && (d = this.Ld.ka.data, d = d.concat(c), this.Ld.ka.data = d);
              this.ja.Ud(c);
              this.QZ();
              e.u.Re.Ni.Bc().reset(!1);
              this.KE = !0;
              e.Be(() => {
                this.KE = !1;
              }, 500);
              this.ja.pa = g;
              this.ja.filter();
            }
            KG(c) {
              this.Ef = b.HA;
              this.cancel();
              this.de(f.FF);
              this.FK(c);
            }
            load(c, d) {
              this.Ef = b.q8;
              this.cancel();
              this.xK(c, d);
            }
            xK(c, d) {
              this.de(f.gy);
              this.sq.N(k.hb.Jh.eo, g => this.ZD(g));
              this.sq.N(k.hb.Jh.Ev, () => this.tN());
              this.sq.load(c, d);
            }
            open() {
              this.Ef = b.OPEN;
              this.de(f.vF);
              this.sq.cancel();
              this.sq.N(k.hb.Jh.XJ, () => this.c4());
              this.sq.N(k.hb.Jh.eo, c => this.ZD(c));
              this.sq.N(k.hb.Jh.Ev, () => this.tN());
              this.sq.N(k.hb.Jh.Wr, () => this.sN());
              this.sq.open();
            }
            sia(c) {
              null != c && c.hasOwnProperty("dataSource") && c.dataSource.hasOwnProperty("browseForFile") && c.dataSource.browseForFile && (c.dataSource.requestPermission = !0);
            }
            ZD(c) {
              this.sia(c.hb);
              e.Da(!1);
              this.de(f.eo);
              this.FK(c.hb);
            }
            tN() {
              e.Da(!1);
              this.de(f.WJ);
              this.de(f.zF);
              this.de(f.pi);
            }
            c4() {
              this.Ya(f.gy, null, "");
            }
            sN() {
              this.de(f.Wr);
              this.de(f.zF);
              this.de(f.pi);
            }
            eb() {
              this.Ya(f.hk, null, "");
            }
            FK(c) {
              let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
              let g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              1 > k.Ha.wc.Wj() || (this.Ld = c instanceof k.hb.ly ? c : k.hb.ly.zb(c), this.Ld.ka.nDa = d, this.Ld.ka.Bja = g, d || k.Va.R().Ya("reset_grid"), this.Oua(this.Ld), this.hia(), this.Ld.ka.kb ? this.Qfa() : this.Ld.ka.mapping.ODa(this.Ld.ka.uc, () => this.Qfa()));
            }
            hia() {
              this.Ld.ka.kb ? this.lo && !this.lo.kb && (e.u.we.LE = !this.lo.Ic || this.lo.Ba == e.u.i.qa.hg || this.lo.Ba == e.u.i.qa.API, e.u.we.MI = !this.lo.Ic || this.lo.Ba == e.u.i.qa.hg || this.lo.Ba == e.u.i.qa.API) : (e.u.we.LE = !this.Ld.ka.Ic || this.Ld.ka.Ba == e.u.i.qa.hg || this.Ld.ka.Ba == e.u.i.qa.API, e.u.we.MI = !this.Ld.ka.Ic || this.Ld.ka.Ba == e.u.i.qa.hg || this.Ld.ka.Ba == e.u.i.qa.API);
            }
            Oua(c) {
              "flat" != c.options.V("gridType") || c.options.V("viewType") != e.K.Id.Zn || c.ka.kb || c.ka.Ba != e.u.i.qa.API || (c.options.na("viewType", e.K.Id.xt), e.Wa(e.P.bind(k.B.j.RX), k.B.j.rP, e.tb.Dl));
            }
            Is() {
              let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return h.W.A9.fLa(this.nAa(c));
            }
            clear() {
              let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              this.cancel();
              this.Ef = b.kp;
              this.GR();
              c ? this.ja.clearData() : this.ja.cancel();
              this.de(f.pi);
            }
            cancel() {
              this.sq.cancel();
              this.RIa();
              this.KE = !1;
              e.u.we.LE = !1;
              e.u.we.MI = !1;
              e.Da(!1);
            }
            Qfa() {
              e.ia(this.HM.He) ? this.xga(null) : (this.de(f.nF), k.B.XA.R().load(this.HM.He, c => this.xga(c), !0), this.HM.He = null);
            }
            xga(c) {
              e.ia(this.Ld.He) ? (k.B.XA.R().reset(), this.hI(c)) : (this.de(f.nF), k.B.XA.R().load(this.Ld.He, d => this.hI(d)));
            }
            hI(c) {
              c ? this.de(f.oF) : !1 === c && this.de(f.HJ);
              this.UDa();
            }
            UDa() {
              this.Ef != b.HA && this.Ef != b.eK && (this.Ef != b.OPEN && this.GR(), k.C.F.wq(this.Ld.options, !0, !1), this.Ef != b.OPEN && (k.C.F.Cn = k.C.F.AC));
              var c = this.Ef;
              this.de(f.zF);
              c == this.Ef && ((c = this.Ld.ka, !e.v(this.fa) && !this.fa.kb && this.fa.isEqual(c) && !k.C.F.BI && this.ja.fa && this.ja.O && this.ja.O.Rd) ? (this.fa.Ba === e.u.i.qa.API && this.Ld.ka.Ba === e.u.i.qa.API && e.u.Re.Ni.Zba !== e.u.Re.Ni.ija(this.Ld.options) && this.ja.ta.clearData(), c = e.u.Re.Ni.Bc(), this.Ld.ka.Bja && this.Ld.ka.Bja.keepMembersOrder ? c.Ge = !0 : c.reset(), this.QZ(), this.ja.KIa()) : (c.kb && this.lo && !this.lo.kb && (c = this.lo), c.kb) ? (this.fa = c, this.ja.cancel(), this.de(f.pi), e.Da(!1)) : (c.Ic ? this.de(f.NX) : this.de(f.mF), null !== this.ja.ta && (this.Ef == b.HA || this.Ef == b.OPEN || e.v(this.fa) || this.fa.kb || c.Ba === this.fa.Ba ? this.fa.Ba === e.u.i.qa.API && this.Ld.ka.Ba === e.u.i.qa.API && e.u.Re.Ni.Zba !== e.u.Re.Ni.ija(this.Ld.options) && (this.ja.ta.lu(), this.ja.ta = null) : (this.ja.ta.lu(), this.ja.ta = null)), this.Lua(c), e.u.Re.Ni.Bc(), this.QZ(), this.ja.connect(c)));
            }
            Lua(c) {
              !k.C.F.tc || e.v(c) || c.kb || c.RH || (k.C.F.tc = !1);
            }
            hFa() {
              this.Ef === b.HA ? (this.GR(), this.ja.pa && this.ja.pa.clear(), this.ja.O && this.ja.O.clear()) : this.Taa(!1);
              this.de(f.Hka);
              this.fa = this.Ld.ka;
            }
            wr() {
              this.de(f.Iv);
              const c = e.u.O.Xr.zb(this.Ld.slice, this.ja.O, !1, e.u.i.qa.API !== this.Ld.ka.Ba);
              this.Taa(!0);
              this.ja.zE(c);
              this.fa.Ic ? (this.de(f.Z8), c.kb ? (this.de(f.oX), this.de(f.pi)) : (k.C.F.Cn = k.C.F.AC, this.ja.filter())) : (this.de(f.gJ), k.C.F.Cn = k.C.F.AC, this.ja.filter());
            }
            r3() {
              this.de(f.fJ);
              this.de(f.pi);
            }
            pHa(c) {
              var d = this.Ld.ka;
              k.C.F.wq(this.Ld.options);
              this.ja.cancel();
              e.Da(!1);
              d.Ic ? this.de(f.Y8, c.data) : this.de(f.eJ, c.data);
              this.de(f.pi);
            }
            p3() {
              this.de(f.gB);
            }
            YD(c) {
              this.de(f.al, c.Ro);
              this.nE != f.pi && this.de(f.pi, null, c.Ro != e.u.i.$d.lJ);
            }
            X3(c) {
              this.de(f.Dt, c.data);
              this.nE != f.pi && this.de(f.pi);
            }
            QZ() {
              this.ja.N(e.u.yg.oY, this.zba);
              this.ja.N(e.u.yg.Iv, this.fO);
              this.ja.N(e.u.yg.nY, this.Yba);
              this.ja.N(e.u.yg.pY, this.aja);
              this.ja.N(e.u.yg.YI, this.gL);
              this.ja.N(e.u.yg.al, this.Zz);
              this.ja.N(e.u.yg.Dt, this.sha);
              this.ja.N(f.hk, this.Cha);
            }
            RIa() {
              this.ja.pb(e.u.yg.oY, this.zba);
              this.ja.pb(e.u.yg.Iv, this.fO);
              this.ja.pb(e.u.yg.nY, this.Yba);
              this.ja.pb(e.u.yg.pY, this.aja);
              this.ja.pb(e.u.yg.YI, this.gL);
              this.ja.pb(e.u.yg.al, this.Zz);
              this.ja.pb(e.u.yg.Dt, this.sha);
              this.ja.pb(f.hk, this.Cha);
            }
            save(c, d, g, l) {
              let m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
              return this.sq.save(c, d, g, l, m, this.Is(c instanceof Object ? c : {}));
            }
            nAa(c) {
              if (void 0 === this.Ab && void 0 === this.ja.O && void 0 === this.ja.pa) return null;
              var d = c.hasOwnProperty("withDefaults") ? 1 == c.withDefaults : !1;
              c = c.hasOwnProperty("withGlobals") ? 1 == c.withGlobals : !1;
              var g = new h.W.A9();
              g.wA = d;
              g.JLa = c;
              g.Ab = c && this.Ab.kb && !this.lo.kb ? this.lo : this.Ab;
              g.O = this.ja.O;
              g.Qb = this.ja.pa;
              g.C = k.C.F.Qw(d, c);
              g.Ce = k.ac.pj.Oza();
              g.Xc = k.ua.dn.Xc;
              g.Gm = k.hb.dJ.Gm;
              g.Jx = k.size.ud.EH();
              this.Ld && (g.He = c && null == this.Ld.He && null != this.ZY ? this.ZY : this.Ld.He);
              return g;
            }
            get GM() {
              return this.A$;
            }
            set GM(c) {
              this.A$ = c;
            }
            JKa(c) {
              this.lo = c.ka;
              this.GM = c.slice.bd;
              k.C.F.aKa(c.options);
              this.ZY = c.He;
            }
            GR() {
              e.u.Re.Ni.dispose();
              k.size.ud.clear();
              k.ua.dn.F4();
              k.ac.pj.clear();
              k.hb.dJ.Gm = [];
              k.C.F.clear();
            }
            Taa() {
              let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              k.C.F.wq(this.Ld.options, !1);
              c && (k.size.ud.clear(), k.size.ud.j_(this.Ld.Jx));
              k.ua.dn.F4();
              for (c = 0; c < this.Ld.Xc.length; c++) {
                var d = k.ua.W.Z6.zb(this.Ld.Xc[c]);
                k.ua.dn.add(d);
              }
              k.ac.pj.clear();
              for (c = 0; c < this.Ld.Ce.length; c++) k.ac.pj.wE(this.Ld.Ce[c]);
              for (c = 0; c < this.Ld.slice.Ca.length; c++) if (d = this.Ld.slice.Ca[c], void 0 !== d.format) {
                let g = void 0 === d.aggregation ? "" : d.aggregation;
                g = e.u.i.da.az(g) ? e.u.i.da.mz(g) : g;
                k.ac.pj.wI(d.format, d.uniqueName, g);
              }
              k.hb.dJ.Gm = this.Ld.Gm;
            }
            dispose() {
              this.cancel();
              k.ua.dn.dispose();
              k.C.F.dispose();
              k.at.xF.dispose();
              k.zD.mP.dispose();
              k.B.XA.dispose();
              k.Ha.wc.dispose();
              k.size.ud.dispose();
              k.ac.pj.dispose();
              this.sq.dispose();
              k.hb.dJ.Gm = [];
              this.ja = this.Ld = this.A$ = this.HM = this.Ab = this.sq = null;
            }
          }
          h.zqa = a;
        })(k.Wb || (k.Wb = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        (function (h) {
          class f {
            constructor() {}
            static iD(a) {
              return a == f.hg ? h.ra.J(h.ra.eya) : h.ra.J(a + 28);
            }
          }
          f.qm = 0;
          f.jla = 2;
          f.Md = 3;
          f.Xja = 4;
          f.TO = 5;
          f.hg = 6;
          h.pp = f;
          class b {
            constructor() {
              b.lv = [123, 11, 92, 19, 144, 53, 22, 7, 190, 81, 45, 201, 45, 88, 130, 173, 165, 9, 34, 54, 31, 233, 245, 40, 65, 55, 23, 183, 102, 109, 34, 45, 177, 103, 51, 20, 119, 17, 3, 49, 90, 92, 90, 134, 182, 199, 92, 230, 241, 2, 117, 108, 124, 54, 32, 190, 251, 16, 4, 5, 231, 253, 201, 2, 39, 96, 91, 55, 82, 160, 32, 84, 193, 149, 189, 152, 29, 102, 119, 234];
            }
            static R() {
              null == b.instance && (b.instance = new b());
              return b.instance;
            }
            static dispose() {
              b.AW = null;
              b.dH = null;
              b.Jfa = null;
              b.R2 = null;
              b.Xy = null;
              b.lv = null;
              b.instance = null;
            }
            Qua(a, c) {
              this.Jb = c;
              a[h.ra.J(h.ra.Kfa)] ? this.RN(a[h.ra.J(h.ra.Kfa)]) : a[h.ra.J(h.ra.mha)] ? this.RN(a[h.ra.J(h.ra.mha)]) : a[h.ra.J(h.ra.sda)] ? this.RN(a[h.ra.J(h.ra.sda)]) : a[h.ra.J(h.ra.Q2)] ? this.Pfa(a[h.ra.J(h.ra.Q2)]) : window[h.ra.J(h.ra.Lfa)] ? this.RN(window[h.ra.J(h.ra.Lfa)]) : this.Pfa(a[h.ra.J(h.ra.Q2)]);
            }
            RN(a) {
              a = k.Tb.validate(a);
              b.Xy = b[h.ra.J(h.ra.ida) + h.ra.J(h.ra.N9)] = a;
              b.error = !1;
              this.Jb(!0);
            }
            Rua(a) {
              if (void 0 == a) return f.qm;
              if (a.trim() == h.ra.J(h.ra.ILa)) return this.Uo(h.ra.J(h.ra.yja)), f.qm;
              a = a.trim();
              var c = this.KCa(a);
              c && (a = this.hza(a));
              if (!this.vfa(a)) return f.qm;
              a = this.qJa(a);
              var d = this.LAa(a);
              c && (b.Ky = !0);
              var g = this.jAa(),
                l = this.VCa(g),
                m = this.RCa(g);
              if (!b.Oaa && this.z2()) return this.Uo(h.ra.J(h.ra.bCa)), f.qm;
              if (c && b.mv) if (this.OR(a)) b.Np = !0;else return;
              if (b.mv && !this.OR(a)) return f.qm;
              if (b.Np) if (l || m || c) {
                if (!this.Kua(a)) return f.qm;
              } else return this.Uo(e.P.bind(h.ra.J(h.ra.uxa), g)), f.qm;
              if (b.qq && !this.Sua(a, l || m ? h.ra.J(h.ra.Ufa) : g)) return f.qm;
              if (d == f.qm || e.v(d)) this.Uo(h.ra.J(h.ra.Iea));else if (!this.Tua(a)) return f.qm;
              b.mv || b.Np || b.qq || (d = f.qm);
              return d;
            }
            static Wj() {
              var a = [h.ra.J(h.ra.ida), "G"].join("X");
              return b.R().Rua(b[a]);
            }
            Uo(a) {
              let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              let d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
              c && null != b.Xy && 0 < b.Xy.length && (a += h.ra.J(h.ra.eC) + h.ra.J(h.ra.eC) + h.ra.J(h.ra.kLa) + b.Xy);
              d && (a += h.ra.J(h.ra.eC) + h.ra.J(h.ra.cja) + u.Eh.format(b.AW, "MM/dd/yyyy"));
              c = new Date(parseFloat(e.kh.TW) / 61);
              a += h.ra.J(h.ra.eC) + h.ra.J(h.ra.eC) + h.ra.J(h.ra.Ywa) + e.kh.Nr + ` (${h.ra.J(h.ra.uua)} ${u.Eh.format(c, "MM/dd/yyyy")})`;
              b.error = !0;
              e.Da(!1);
              this.Jb(!1);
              e.Wa(a, k.B.j.xa, e.tb.xa, [], null, !0);
            }
            Pfa(a) {
              a || (a = u.py.FH(h.ra.J(h.ra.rDa)));
              a = a + h.ra.J(h.ra.SKa) + Date.now();
              this.xhr = new XMLHttpRequest();
              this.xhr.open("GET", a, !0);
              this.xhr.onerror = () => this.tga();
              this.xhr.onreadystatechange = c => this.gv(c);
              this.xhr.send();
            }
            gv() {
              null != this.xhr && 4 === this.xhr.readyState && (200 === this.xhr.status ? this.iGa(this.xhr.responseText) : this.tga());
            }
            iGa(a) {
              this.RN(a);
            }
            tga() {
              this.Uo(h.ra.J(h.ra.CEa));
            }
            VCa(a) {
              return null == a || -1 == a.indexOf(".") ? !0 : !1;
            }
            RCa(a) {
              return /^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))*$/.test(a);
            }
            KCa(a) {
              return a.substr(0, 2) == h.ra.J(h.ra.N9);
            }
            hza(a) {
              a = a.substr(2);
              var c = Math.floor(new Date().getTime() / 6048E5),
                d = parseInt(a.substr(0, 2), 16);
              a = a.replace(RegExp("-", "g"), "").substr(2);
              for (var g = 0; 2 > g; g++) {
                for (var l = 0; 5 > l; l++) {
                  for (var m = d * c * l, n = "", p = 0; p < a.length; p += 2) {
                    var t = m % 256;
                    m = (m - t) / 256;
                    n += String.fromCharCode(parseInt(a.charAt(p) + a.charAt(p + 1), 16) ^ t);
                    256 > m && (m *= c);
                  }
                  if (this.vfa(n, !1)) return n;
                }
                c++;
              }
              return "-";
            }
            z2() {
              if (self == top || -1 < window[h.ra.J(h.ra.yK)][h.ra.J(h.ra.vK)].toLowerCase().indexOf(h.ra.J(h.ra.ova)) || -1 < window[h.ra.J(h.ra.yK)][h.ra.J(h.ra.vK)].toLowerCase().indexOf(h.ra.J(h.ra.qDa)) || -1 < window[h.ra.J(h.ra.yK)][h.ra.J(h.ra.vK)].toLowerCase().indexOf(h.ra.J(h.ra.KKa)) || -1 < window[h.ra.J(h.ra.yK)][h.ra.J(h.ra.vK)].toLowerCase().indexOf(h.ra.J(h.ra.LKa))) return !1;
              try {
                window.parent.document;
              } catch (a) {
                return !0;
              }
              return !1;
            }
            vfa(a) {
              let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
              if (null == a || 0 == a.length) return c && this.Uo(h.ra.J(h.ra.fya)), !1;
              if (a.trim() == h.ra.J(h.ra.sDa)) return c && this.Uo(h.ra.J(h.ra.tDa), !1), !1;
              a = a.trim().replace(/-/gi, "");
              if (a.substr(0, 2) == h.ra.J(h.ra.T9).substr(0, 1) + 7) {
                var d = parseInt(a.substr(2, 2), 36);
                var g = a.substr(4, 4);
                "X" == g.substr(0, 1) && (g = g.substr(1, 3));
                g = parseInt(g, 20) - 3227;
                a = a.substring(8).toLowerCase();
              } else return a.substr(0, 2) == h.ra.J(h.ra.T9) || a.substr(0, 2) == h.ra.J(h.ra.xra) || a.substr(0, 2) == h.ra.J(h.ra.wra) ? c && this.Uo(h.ra.J(h.ra.Jga), !0, !0) : c && this.Uo(h.ra.J(h.ra.Iea)), !1;
              for (var l = 0; l < a.length; l += 2) {
                var m = parseInt(a.substr(l, 2), 36);
                isNaN(m) || (d += m);
              }
              return g != d || 1 > g ? (c && this.Uo(h.ra.J(h.ra.swa)), !1) : !0;
            }
            qJa(a) {
              a = a.trim().replace(/-/gi, "");
              var c = parseInt(a.substring(2, 4), 36);
              a = a.substring(8).toLowerCase();
              for (var d = "", g = 0; g < a.length; g += 2) d += String.fromCharCode(parseInt(a.substr(g, 2), 36) ^ Math.abs(Math.sin(g / 2 + 2) * c * (g / 2 + 7)) % 256);
              return d;
            }
            LAa(a) {
              b.mca = u.Vea();
              a = a.charCodeAt(0);
              b.Oaa = 256 <= a;
              a %= 256;
              b.Np = 128 <= a;
              a %= 128;
              b.uea = 64 <= a;
              a %= 64;
              b.qq = 32 <= a;
              a %= 32;
              b.Ky = 16 <= a;
              a %= 16;
              b.mv = 8 <= a;
              return a % 8;
            }
            jAa() {
              var a;
              if (this.z2()) {
                if (a = document[h.ra.J(h.ra.referrer)]) a = a.replace(h.ra.J(h.ra.$Ba), ""), a = a.replace(h.ra.J(h.ra.aCa), ""), a = a.split("/")[0];
              } else {
                a = h.ra.J(h.ra.yK);
                var c = h.ra.J(h.ra.vK);
                a = window[a][c];
              }
              if (null == a) return null;
              a = a.replace(h.ra.J(h.ra.NLa), "");
              return a = a.split(":")[0];
            }
            Tua(a) {
              var c = b.mv ? a.substr(-6, 3) : a.substr(-3);
              a = new Uint8Array(c.length);
              for (var d = 0; d < c.length; d++) a[d] = c.charCodeAt(d) ^ b.lv[d];
              c = "";
              for (d = 0; d < a.byteLength; d++) c += String.fromCharCode(a[d]);
              a = new Date(864E5 * (parseInt(c, 34) + 17002) + 6E4 * new Date().getTimezoneOffset());
              b.AW = a;
              d = new Date(parseFloat(e.kh.TW) / 61);
              return !a || isNaN(a.getTime()) || a < d ? (this.Uo(h.ra.J(h.ra.Jga), !0, !0), !1) : !0;
            }
            OR(a) {
              var c = a.substr(-3);
              a = new Uint8Array(c.length);
              for (var d = 0; d < c.length; d++) a[d] = c.charCodeAt(d) ^ b.lv[d];
              c = "";
              for (d = 0; d < a.byteLength; d++) c += String.fromCharCode(a[d]);
              a = new Date(864E5 * (parseInt(c, 34) + 17001) + 6E4 * new Date().getTimezoneOffset());
              b.dH = a;
              a = new Date(864E5 * (parseInt(c, 34) + 17002) + 6E4 * new Date().getTimezoneOffset());
              return !a || isNaN(a.getTime()) || a < new Date() ? (b.qq || b.Np ? this.Uo(h.ra.J(h.ra.CDa)) : this.Uo(h.ra.J(h.ra.yja)), !1) : !0;
            }
            Kua(a) {
              var c = a;
              a = a.substr(1);
              for (var d = new Uint8Array(a.length), g = 0; g < a.length; g++) d[g] = a.charCodeAt(g) ^ b.lv[g];
              a = "";
              for (g = 0; g < d.byteLength; g++) a += String.fromCharCode(d[g]);
              b.R2 = a.split(String.fromCharCode(224))[0];
              return b.mv && !this.OR(c) ? !1 : !0;
            }
            Sua(a, c) {
              var d = a;
              a = a.substr(1);
              for (var g = new Uint8Array(a.length), l = 0; l < a.length; l++) g[l] = a.charCodeAt(l) ^ b.lv[l];
              a = "";
              for (l = 0; l < g.byteLength; l++) a += String.fromCharCode(g[l]);
              g = a.split(String.fromCharCode(224));
              a = g[0];
              b.Jfa = g.shift();
              if (b.mv && !this.OR(d)) return !1;
              if (c == h.ra.J(h.ra.Ufa)) return !0;
              d = " ";
              b.uea && c.length >= a.length - 2 && (d = "*." + c.substring(c.length - a.length + 2));
              return a != c && a != d && a != e.gqa.hash(c) ? (this.Uo(e.P.bind(h.ra.J(h.ra.DHa), a)), !1) : !0;
            }
            static EDa() {
              return f.iD(b.Wj());
            }
          }
          b.error = !1;
          b.mv = !1;
          b.qq = !1;
          b.Np = !1;
          b.mca = !1;
          b.dH = new Date(2009, 9, 30);
          b.AW = new Date(2009, 9, 30);
          b.Ky = !1;
          b.Xy = "";
          b.uea = !1;
          b.Oaa = !1;
          h.wc = b;
        })(k.Ha || (k.Ha = {}));
      })(e.model || (e.model = {}));
    })(q || (q = {}));
    var mb = S || (S = {});
    class nb {}
    nb.Ika = '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/theme/theme1.xml" ContentType="application/vnd.openxmlformats-officedocument.theme+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/><Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"/><Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml"/><Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml"/>{0}</Types>';
    nb.Jka = '<Override PartName="{0}" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>';
    nb.yra = '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>';
    nb.eka = '<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"><Application>Flexmonster Pivot Table</Application><DocSecurity>0</DocSecurity><ScaleCrop>false</ScaleCrop><HeadingPairs><vt:vector size="2" baseType="variant"><vt:variant><vt:lpstr>Worksheets</vt:lpstr></vt:variant><vt:variant><vt:i4>3</vt:i4></vt:variant></vt:vector></HeadingPairs><TitlesOfParts><vt:vector size="3" baseType="lpstr"><vt:lpstr>Sheet1</vt:lpstr><vt:lpstr>Sheet2</vt:lpstr><vt:lpstr>Sheet3</vt:lpstr></vt:vector></TitlesOfParts><LinksUpToDate>false</LinksUpToDate><SharedDoc>false</SharedDoc><HyperlinksChanged>false</HyperlinksChanged><AppVersion>14.0300</AppVersion></Properties>';
    nb.hla = '<cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><dc:creator></dc:creator><cp:lastModifiedBy></cp:lastModifiedBy></cp:coreProperties>';
    nb.mra = '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="9302"/><workbookPr defaultThemeVersion="124226"/><bookViews><workbookView xWindow="360" yWindow="210" windowWidth="16860" windowHeight="9150"/></bookViews><sheets>{0}</sheets><calcPr calcId="144525"/></workbook>';
    nb.nra = '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme" Target="theme/theme1.xml"/>{0}</Relationships>';
    nb.ora = '<Relationship Id="{0}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="{1}"/>';
    nb.Gqa = '<a:theme name="Office Theme" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="1F497D"/></a:dk2><a:lt2><a:srgbClr val="EEECE1"/></a:lt2><a:accent1><a:srgbClr val="4F81BD"/></a:accent1><a:accent2><a:srgbClr val="C0504D"/></a:accent2><a:accent3><a:srgbClr val="9BBB59"/></a:accent3><a:accent4><a:srgbClr val="8064A2"/></a:accent4><a:accent5><a:srgbClr val="4BACC6"/></a:accent5><a:accent6><a:srgbClr val="F79646"/></a:accent6><a:hlink><a:srgbClr val="0000FF"/></a:hlink><a:folHlink><a:srgbClr val="800080"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Cambria"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/><a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/><a:font script="Hans" typeface="\u5b8b\u4f53"/><a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/><a:font script="Arab" typeface="Times New Roman"/><a:font script="Hebr" typeface="Times New Roman"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="MoolBoran"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface ="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Times New Roman"/><a:font script="Uigh" typeface="Microsoft Uighur"/></a:majorFont><a:minorFont><a:latin typeface="Calibri"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/><a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/><a:font script="Hans" typeface="\u5b8b\u4f53"/><a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/><a:font script="Arab" typeface="Arial"/><a:font script="Hebr" typeface="Arial"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="DaunPenh"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface ="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Arial"/><a:font script="Uigh" typeface="Microsoft Uighur"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="1"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:shade val="51000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="80000"><a:schemeClr val="phClr"><a:shade val="93000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="94000"/><a:satMod val="135000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst><a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d><a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults><a:spDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style></a:spDef><a:lnDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style></a:lnDef></a:objectDefaults><a:extraClrSchemeLst/></a:theme>';
    nb.qqa = '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">{0}<fonts count="{1}" x14ac:knownFonts="1"><font><sz val="11"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font>{2}</fonts><fills count="{3}">{4}</fills><borders count="2"><border><left/><right/><top/><bottom/><diagonal/></border><border><left style="thin"><color theme="0" tint="-0.14996795556505021"/></left><right style="thin"><color theme="0" tint="-0.14996795556505021"/></right><top style="thin"><color theme="0" tint="-0.14996795556505021"/></top><bottom style="thin"><color theme="0" tint="-0.14996795556505021"/></bottom><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="{5}"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>{6}</cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles><dxfs count="0"/><tableStyles count="0" defaultTableStyle="TableStyleMedium2" defaultPivotStyle="PivotStyleLight16"/><extLst><ext uri="{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"><x14:slicerStyles defaultSlicerStyle="SlicerStyleLight1"/></ext></extLst></styleSheet>';
    nb.hqa = '<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="5" uniqueCount="5">{0}</sst>';
    nb.iqa = '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"><dimension ref="{0}"/><sheetViews><sheetView tabSelected="1" workbookViewId="0"><selection activeCell="A1" sqref="A1"/></sheetView></sheetViews><sheetFormatPr defaultRowHeight="15" defaultColWidth="15" x14ac:dyDescent="0.25"/><cols>{1}</cols><sheetData>{2}</sheetData>{3}<pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3"/></worksheet>';
    nb.Ht = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';
    mb.Ti = nb;
    (function (e) {
      (function (k) {
        class h extends v.Fh {
          constructor() {
            super();
            this.wL = [];
            this.vD = new e.ub();
            this.JH = new e.ub();
            this.F_ = 0;
            if (null != h.instance) throw Error("Singleton");
          }
          static R() {
            void 0 == h.instance && (h.instance = new h());
            return h.instance;
          }
          zE(f) {
            this.fa.Ic || f.kb && e.model.C.F.m5 && f.d3 && f.ZDa();
            for (var b = 0; b < f.ob.length; b++) {
              var a = f.ob.ea(b);
              a.filter.ei && a.filter.oC();
            }
            var c = f.yc(!1, !1);
            for (b = 0; b < c.length; b++) if (a = c.ea(b), a.cb = [], a.filter.ei && a.filter.measure) {
              var d = f.Pw(a.filter.measure.index);
              if (-1 == a.filter.measure.index || d && d.A !== a.filter.measure.A) if (a.filter.measure.index = f.Vda(a.filter.measure.A, a.filter.measure.aa), d = f.Pw(a.filter.measure.index), -1 == a.filter.measure.index || d && d.A !== a.filter.measure.A) a.filter.measure.index = f.Vda(a.filter.measure.A);
              -1 != a.filter.measure.index && (d = f.Pw(a.filter.measure.index), e.v(d) || d.A !== a.filter.measure.A || (a.filter.measure.aa = d.aa));
            }
            this.pa = f;
            this.Ya(k.bK.$J);
          }
          KIa() {
            !this.fa.Ic && this.O && (this.O.Rd = !1, this.kE());
            for (var f = this.O.yc(!1), b = 0; b < f.length; b++) {
              var a = f.ea(b);
              a.mu();
              a.w_();
              this.fa.Ic ? 0 < a.OL.length && (a.Rd = !1) : a.Rd = !1;
            }
            this.pa && this.pa.clear();
            this.LL();
          }
          connect(f) {
            e.v(this.Xt) || this.Xt.cancel();
            this.Xt = k.Cqa.BBa(f);
            this.Xt.load(f, () => this.LL(), b => {
              this.Ya(k.yg.pY, null, {
                error: b
              });
            }, () => {
              this.cancel(!1);
              this.fa = f;
              this.xq = this.Xt;
              this.ta = this.fa.Ba == k.i.qa.hg ? new k.external.Se.$la(this) : this.fa.Ba == k.i.qa.API ? new k.external.pc.i6(this) : this.fa.Ic ? new k.external.Fb.mpa(this) : new k.local.vP(this);
              this.Xt = null;
              this.Hm = k.nX.i1(this.fa);
              null != this.O && this.O.clear();
              this.O = k.O.Bqa.ABa(this.fa.Ba);
              this.O.hKa(f.mapping);
              this.Ya(k.yg.oY);
            }, () => {
              this.Ya(k.yg.nY);
            });
          }
          LL() {
            this.O.Rd = !0;
            this.Ya(k.yg.Iv);
          }
          cancel() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            u.Il.cancel();
            this.xq && (this.xq.cancel(), this.xq = null);
            this.Hm && (this.TR(), this.Hm.cancel(), this.Hm = null);
            this.vD = new e.ub();
            this.JH = new e.ub();
            f && this.O && (this.O.clear(), this.O = null);
            f && this.pa && (this.pa.clear(), this.pa = null);
            f && this.ta && (this.ta.lu(), this.ta = null);
            f && this.Xt && (this.Xt.cancel(), this.Xt = null);
            this.F_ = 0;
          }
          clearData() {
            this.TR();
            this.Hm && (this.Hm.cancel(), this.Hm = null);
            this.ta && this.ta.clearData();
          }
          XH(f, b) {
            if (null != f) {
              var a = this.m2(this.fa);
              this.ta.select(!1);
              null === this.Hm || a || this.Hm.cancel();
              this.Hm = k.nX.i1(this.fa);
              a && this.wL.push(this.Hm);
              this.Hm.load(this.fa, f, b, c => this.bz(c));
            }
          }
          En() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            e.Da(!1);
            this.TR();
            this.Ea(new k.cY(f));
          }
          bz(f) {
            e.Da(!1);
            this.Ya(k.yg.Dt, null, {
              error: f
            });
          }
          filter() {
            this.select(k.i.$d.ZO);
          }
          sort() {
            this.En();
          }
          expand(f, b, a) {
            let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
            this.Ea(new k.YE(k.i.$d.gF));
            this.BN(f, b, a, () => {
              this.ta.expand(f, b, a);
              c && (this.En(k.i.$d.gF), e.Be(() => {
                this.Ya(e.model.Wb.Uc.hk);
              }, 1));
            });
          }
          Jra(f, b, a) {
            a = e.v(a) ? this.pa.Sf : [a];
            for (var c = !0, d = 0; d < a.length; d++) {
              var g = b === k.i.ha.Ia ? this.ta.La(f, [], a[d]) : this.ta.La([], f, a[d]);
              if (!isNaN(g)) {
                c = !1;
                break;
              }
            }
            return c;
          }
          BN(f, b, a, c) {
            this.fa.Ic ? this.Jra(f, b, a) ? c(!0) : (a = new k.yF(k.i.$d.gF), a.gg = f, a.iw = b, a.body = k.fB.eD(this.pa, this.fa).expand(b, f), void 0 === a.body ? c(!0) : this.XH(a, c)) : c(!0);
          }
          Ira(f, b, a) {
            if (null != b.hierarchy.lc) return !1;
            var c = e.v(void 0) ? this.pa.Sf : [void 0],
              d = !0;
            f = f.slice(0);
            f[f.length - 1] = b.ordinal;
            for (b = 0; b < c.length; b++) {
              var g = a === k.i.ha.Ia ? this.ta.La(f, [], c[b]) : this.ta.La([], f, c[b]);
              if (!isNaN(g)) {
                d = !1;
                break;
              }
            }
            return d;
          }
          BV(f, b, a, c) {
            if (this.fa.Ic) {
              if (this.Ira(f, b, a)) c(!0);else {
                var d = new k.yF(k.i.$d.Vx);
                d.gg = f;
                d.iw = a;
                d.body = k.fB.eD(this.pa, this.fa).Ae(a, f, b, b.level.A);
                void 0 === d.body ? c(!0) : this.XH(d, c);
              }
            } else c(!0);
          }
          collapse(f, b, a) {
            let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
            this.ta.collapse(f, b, a);
            c && this.En(k.i.$d.H6);
          }
          bd(f, b, a, c) {
            let d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var g = new k.yF(k.i.$d.lJ);
            g.body = k.fB.eD(this.pa, this.fa).bd(f, b, a, d ? d.slice(0) : null);
            e.Da(!0, e.model.B.j.jg);
            d = new k.YE(k.i.$d.lJ);
            this.Ea(d);
            this.Hm.cancel();
            this.Hm = k.nX.i1(this.fa);
            this.Hm.bd(this.fa, g, f, b, a, l => {
              c(l);
              this.En(g.type);
            }, () => {
              c();
              this.En(g.type);
            });
          }
          PC(f, b) {
            let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "all";
            if ("all" == a || "rows" == a) this.pa.kf = f, this.pa.gf = b, this.pa.jva(), this.pa.iva();
            if ("all" == a || "columns" == a) this.pa.jf = f, this.pa.Tf = b, this.pa.eva(), this.pa.dva();
            this.fa.Ic && this.ta.rC();
          }
          Ae(f, b, a, c) {
            b.hierarchy.fz(b);
            var d = new k.YE(k.i.$d.Vx);
            this.Ea(d);
            this.fa.Ic ? b.Zg ? (this.ta.Ae(f, b, a, c), this.En(k.i.$d.Vx)) : this.Ik(b.hierarchy, b, () => {
              var g = new k.yF(k.i.$d.Vx);
              g.gg = f;
              g.iw = a;
              g.body = k.fB.eD(this.pa, this.fa).Ae(a, f, b);
              this.XH(g, () => {
                this.ta.Ae(f, b, a, c);
                for (var l = [], m = b.level.yb + 1; m < b.hierarchy.wa.length; m++) {
                  var n = b.hierarchy.wa.ea(m);
                  n && (l = l.concat(b.hierarchy.OL(n)));
                }
                if (0 < l.length) {
                  n = [];
                  var p, t;
                  for (m = 0; m < l.length; m++) for (t = p = b.hierarchy.za(l[m]); void 0 !== p && void 0 !== p.parent;) {
                    if (p.parent.ordinal === b.ordinal) {
                      n.push(t);
                      break;
                    }
                    p = p.parent;
                  }
                  this.Mfa(g, f, a, n, c);
                } else this.En(g.type);
              });
            }) : (this.ta.Ae(f, b, a, c), this.En(k.i.$d.Vx));
          }
          Mfa(f, b, a, c, d) {
            if (0 < c.length) {
              var g = c.shift(),
                l = b.slice(0);
              l[l.length - 1] = g.ordinal;
              f.gg = l;
              f.body = k.fB.eD(this.pa, this.fa).Ae(a, l, g);
              this.XH(f, () => {
                this.ta.Ae(l, g, a, d);
                this.Mfa(f, b, a, c, d);
              });
            } else this.En(f.type);
          }
          Jm(f, b, a, c, d) {
            var g = k.fB.eD(this.pa, this.fa);
            c = new k.YE(k.i.$d.jX);
            this.Ea(c);
            this.xq.Lz(b, d, () => {
              var l = new k.yF();
              l.type = k.i.$d.jX;
              l.gg = f;
              l.iw = a;
              l.body = g.Ae(a, f, b, d);
              this.XH(l, () => {
                this.ta.Jm(f, b, a, d);
                this.En(l.type);
              });
            }, l => this.bz(l));
          }
          Pp(f, b, a, c) {
            b.hierarchy.y0(b);
            this.ta.Pp(f, b, a, c);
            f = new k.YE(k.i.$d.lX);
            this.Ea(f);
            this.En(k.i.$d.lX);
          }
          select() {
            let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : k.i.$d.ho;
            !e.model.Ha.wc.mv || e.model.Ha.wc.qq || e.model.Ha.wc.Np || e.model.Ha.wc.Ky || 0 == new Date().getTime() % 378 && e.Wa(e.model.Ha.ra.J(e.model.Ha.ra.$ga), e.model.Ha.ra.J(e.model.Ha.ra.xja));
            var b = new k.YE(f);
            this.Ea(b);
            this.fa.Ic ? (this.ta.lu(), this.wIa()) : (this.ta.select(), this.En(f));
          }
          bu(f) {
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            f = f instanceof k.O.Or ? f : this.O.mx(f);
            if (e.model.C.F.sO) {
              var a = u.iP.NR(f.De, f.A);
              0 == a.Zw && e.Wa(a.errorMessage);
            }
            if (!this.fa.Ic || !f.Oa || e.model.C.F.iu || this.fa.Ba === k.i.qa.API) {
              if (null == this.O.fd(f.A)) {
                f.Oa && (a = new u.IJ(), f.Sd = a.parse(f.De), this.O instanceof k.external.pc.O.WI && (f.Sd = u.wt.uH(f.Sd, this.O.Ca)));
                if (f.Oa && null == f.Sd) return;
                this.O.cI && this.O.rk(f);
                null != this.pa && !this.pa.$q.Bb(f.A) && f.Pm && this.Gea(f);
                b && (this.O.Rd && !this.fa.Ic || this.O.Rd && this.fa.Ba == e.u.i.qa.API || this.O.Rd && this.fa.VM && this.fa.Ba == e.u.i.qa.Cc && e.model.C.F.iu) && this.refresh();
              } else {
                a = new u.IJ();
                f.Sd = a.parse(f.De);
                this.O instanceof k.external.pc.O.WI && (f.Sd = u.wt.uH(f.Sd, this.O.Ca));
                if (f.Oa && null == f.Sd) return;
                b = this.O.fd(f.A);
                b.caption = f.caption;
                b.Xp = f.Xp;
                b.De = f.De;
                b.Gk = f.Gk;
                b.Sd = f.Sd;
                b.zn = f.zn;
                b.Pm = f.Pm;
                (this.pa.$q.Bb(b.A) || b.Pm) && this.Gea(b);
                (this.O.Rd && !this.fa.Ic || this.O.Rd && this.fa.Ba == e.u.i.qa.API || this.fa.Ba == e.u.i.qa.Cc && e.model.C.F.iu) && this.refresh();
              }
              this.eb();
            }
          }
          Gea(f) {
            let b = -1;
            const a = this.pa.gd();
            for (let c = 0; c < a.length; c++) if (f.A == a[c].A) {
              b = c;
              break;
            }
            0 <= b ? (f.index = b, a[b] = f) : (a.push(f), f.index = a.length);
            this.pa.iA(a);
            this.pa.Z5();
            this.Fja(this.pa.Rb, f);
            this.Fja(this.pa.hc, f);
          }
          Fja(f, b) {
            null != f.Jf && f.Jf.A == b.A && (f.Jf = b);
          }
          $z(f) {
            let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            var a = this.O.fd(f);
            a && a.Oa && (this.O.lE(f), this.pa.lE(f), b && this.O.Rd && this.refresh(), this.eb());
          }
          kE() {
            for (var f = 0; f < this.O.Ca.length;) {
              var b = this.O.Ca.ea(f);
              b.Oa ? this.$z(b.A, !1) : f++;
            }
            this.O.Rd && this.refresh();
            this.eb();
          }
          eb() {
            e.model.Xa.R().Ya(e.model.Xa.RP);
          }
          refresh() {
            this.O.Rd ? (this.fa.Ba == k.i.qa.EMPTY && e.v(this.pa) && this.LL(), this.filter()) : this.fa.Ba == k.i.qa.EMPTY && this.LL();
          }
          ol(f, b) {
            (0 < f.kv.length || this.pa.gf && this.pa.rows.Bb(f.A) || this.pa.Tf && this.pa.Ka.Bb(f.A)) && f.Vm != f.Wi && (f.Rd = !1);
            if (!f.Ue && !f.Rd || null != f.lc) {
              0 == this.vD.length && this.xq.ol(f, c => this.Aga(c), c => this.bz(c));
              this.vD.Ua(f.A, f);
              var a = null != this.JH.getItem(f.A) ? this.JH.getItem(f.A) : [];
              a.push(b);
              this.JH.Ua(f.A, a);
            } else b(f);
          }
          Ik(f, b, a) {
            this.xq.Ik(f, b, a, c => this.bz(c));
          }
          uq(f, b, a) {
            this.xq.iC() ? this.xq.uq(f, b, a, c => this.bz(c)) : (f = 2 < f.wa.length ? this.JJa(f, b) : this.IJa(f, b), a(f));
          }
          IJa(f, b) {
            const a = [],
              c = f.Wi;
            let d;
            for (d = 0; d < c; d++) {
              if (f.wd.ordinal == d) continue;
              const g = f.za(d);
              void 0 !== g && e.P.contains(g.caption, b) && a.push(d);
            }
            return a;
          }
          JJa(f, b) {
            var a = [];
            this.bda(a, f.wd, b);
            var c;
            for (c = 0; c < a.length; c++) b = this.Hea(a, f.za(a[c]), c), c += b;
            return a;
          }
          Hea(f, b, a) {
            b = b.parent;
            var c = 0;
            e.v(b) || b.dc || (-1 == f.indexOf(b.ordinal) && (c++, f.splice(a, 0, b.ordinal)), c += this.Hea(f, b, a));
            return c;
          }
          bda(f, b, a) {
            for (var c = b.children, d = c.length, g = b.hierarchy, l = 0; l < d; l++) b = g.za(c[l]), e.P.contains(b.caption, a) && f.push(b.ordinal), this.bda(f, b, a);
          }
          Aga(f) {
            f.tw();
            f.Rd = !0;
            this.vD.removeItem(f.A);
            var b = this.JH.getItem(f.A);
            if (null != b) for (var a = 0; a < b.length; a++) (0, b[a])(f);
            this.JH.removeItem(f.A);
            0 < this.vD.length && (f = this.vD.ea(0), null != this.xq ? this.xq.ol(f, c => this.Aga(c), c => this.bz(c)) : this.vD = null);
          }
          m2(f) {
            return f.Ba === k.i.qa.API && f.ww;
          }
          wIa() {
            if (this.pa.kb) this.En();else {
              var f = this.pa.yc(!0, !0, e.model.C.F.tc);
              this.F_ = f.length;
              for (var b = 0; b < f.length; b++) {
                var a = f.ea(b);
                this.ol(a, () => this.CGa());
              }
            }
          }
          Ofa(f) {
            try {
              this.m2(this.fa) ? this.LDa(f) : this.qsa(f);
            } catch (b) {
              e.Wa(e.model.B.j.zoa + "<br/>" + b.message || b, e.model.B.j.xa, e.tb.xa), this.bz(b);
            }
          }
          CGa() {
            if (0 == --this.F_) {
              this.fa.Ic && this.pa.r4();
              var f = new k.yF(k.i.$d.ho);
              f.body = k.fB.eD(this.pa, this.fa).select();
              this.XH(f, () => {
                e.model.C.F.tc || this.fa.Ba != k.i.qa.hg && this.fa.Ba != k.i.qa.API ? this.En(f.type) : (e.Da(!0, e.model.B.j.jg), this.Nfa(() => {
                  this.Ofa(() => {
                    this.Nfa(() => {
                      this.Ofa(() => {
                        this.En(f.type);
                      });
                    });
                  });
                }));
              });
            }
          }
          LDa(f) {
            var b = this.pa.rd(k.i.ha.Ia).kd;
            const a = this.pa.rd(k.i.ha.Ra).kd,
              c = {
                cols: [],
                rows: []
              };
            let d = 0;
            for (var g = 0; g < b.length; g++) {
              const n = b[g].length - 1;
              d = n > d ? n : d;
              void 0 == c.rows[n] && (c.rows[n] = []);
              c.rows[n].push(g);
            }
            for (b = 0; b < a.length; b++) g = a[b].length - 1, d = g > d ? g : d, void 0 == c.cols[g] && (c.cols[g] = []), c.cols[g].push(b);
            let l = 0;
            const m = () => {
              l++;
              l > d ? f() : this.TDa(c, l, m);
            };
            m();
          }
          TDa(f, b, a) {
            var _this2 = this;
            const c = new u.mB();
            var d = this.pa.rd(k.i.ha.Ia).kd;
            const g = this.pa.rd(k.i.ha.Ra).kd;
            var l = f.rows[b];
            f = f.cols[b];
            let m = (l ? l.length : 0) + (f ? f.length : 0);
            if (l) for (b = 0; b < l.length; b++) {
              const n = d[l[b]].slice(1),
                p = this.pa.xb.ea(n.length - 1);
              if (p && null != p.lc) {
                const t = p.za(n[n.length - 1]);
                null != t && this.ta.Jm(n.slice(0, -1), t.parent, k.i.ha.Ia, p.xf);
              }
              this.ta.Th(n) ? m-- : (c.add((t, r) => {
                this.ta.expand(r, k.i.ha.Ia, void 0);
                t();
              }, n), this.BN(n, k.i.ha.Ia, void 0, function () {
                let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                t ? (c.pop(), _this2.ta.expand(n, k.i.ha.Ia, void 0), --m) : (1 === m && c.Xe(a), m--);
              }));
            }
            if (f) for (d = 0; d < f.length; d++) {
              const n = g[f[d]].slice(1);
              (l = this.pa.Db.ea(n.length - 1)) && null != l.lc && (b = l.za(n[n.length - 1]), null != b && this.ta.Jm(n.slice(0, -1), b.parent, k.i.ha.Ra, l.xf));
              this.ta.Xj(n) ? --m : (c.add((p, t) => {
                this.ta.expand(t, k.i.ha.Ra, void 0);
                p();
              }, n), this.BN(n, k.i.ha.Ra, void 0, function () {
                let p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                p ? (c.pop(), _this2.ta.expand(n, k.i.ha.Ra, void 0), --m) : (1 === m && c.Xe(a), m--);
              }));
            }
            (c.kb() || 0 === m) && a();
          }
          qsa(f) {
            const b = new u.mB();
            for (var a = this.pa.rd(k.i.ha.Ia).kd, c = 0; c < a.length; c++) {
              var d = a[c];
              b.add((g, l) => {
                var m = this.pa.xb.ea(l.length - 1);
                if (m && null != m.lc) {
                  var n = m.za(l[l.length - 1]);
                  null != n && this.ta.Jm(l.slice(0, -1), n.parent, k.i.ha.Ia, m.xf);
                }
                this.ta.Th(l) ? g() : this.BN(l, k.i.ha.Ia, void 0, () => {
                  this.ta.expand(l, k.i.ha.Ia, void 0);
                  g();
                });
              }, d.slice(1));
            }
            a = this.pa.rd(k.i.ha.Ra).kd;
            for (c = 0; c < a.length; c++) d = a[c], b.add((g, l) => {
              var m = this.pa.Db.ea(l.length - 1);
              if (m && null != m.lc) {
                var n = m.za(l[l.length - 1]);
                null != n && this.ta.Jm(l.slice(0, -1), n.parent, k.i.ha.Ra, m.xf);
              }
              this.ta.Xj(l) ? g() : this.BN(l, k.i.ha.Ra, void 0, () => {
                this.ta.expand(l, k.i.ha.Ra, void 0);
                g();
              });
            }, d.slice(1));
            b.Xe(f);
          }
          Nfa(f) {
            try {
              this.m2(this.fa) ? this.JDa(f) : this.psa(f);
            } catch (b) {
              e.Wa(e.model.B.j.yoa + "<br/>" + b.message || b, e.model.B.j.xa, e.tb.xa), this.bz(b);
            }
          }
          JDa(f) {
            if (this.fa.Ba !== k.i.qa.API || k.external.pc.O.Tn.KH) {
              var b = this.pa.rd(k.i.ha.Ia).ue;
              const c = this.pa.rd(k.i.ha.Ra).ue,
                d = {
                  cols: [],
                  rows: []
                };
              let g = 0;
              for (var a = 0; a < b.length; a++) {
                const n = b[a][1].split("].[").length;
                g = n > g ? n : g;
                void 0 == d.rows[n] && (d.rows[n] = []);
                d.rows[n].push(a);
              }
              for (b = 0; b < c.length; b++) a = c[b][1].split("].[").length, g = a > g ? a : g, void 0 == d.cols[a] && (d.cols[a] = []), d.cols[a].push(b);
              let l = 0;
              const m = () => {
                l++;
                l > g ? f() : this.SDa(d, l, m);
              };
              m();
            } else f();
          }
          SDa(f, b, a) {
            var _this3 = this;
            const c = new u.mB();
            var d = this.pa.rd(k.i.ha.Ia).ue;
            const g = this.pa.rd(k.i.ha.Ra).ue;
            var l = f.rows[b];
            f = f.cols[b];
            let m = (l ? l.length : 0) + (f ? f.length : 0);
            if (l) for (b = 0; b < l.length; b++) {
              let n = d[l[b]].slice(0);
              const p = this.pa.xb.ea(n.length - 3);
              if (e.v(p)) {
                m--;
                continue;
              }
              const t = p.Ib(n[1]);
              null == t ? m-- : (n = n.slice(2), this.ta.Bh(n, t) || (c.add((r, w) => {
                this.ta.Ae(w, t, k.i.ha.Ia, void 0);
                r();
              }, n), this.BV(n, t, k.i.ha.Ia, function () {
                let r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
                r ? (c.pop(), _this3.ta.Ae(n, t, k.i.ha.Ia, void 0)) : 1 === m && c.Xe(a);
                m--;
              })));
            }
            if (f) for (d = 0; d < f.length; d++) {
              let n = g[f[d]].slice(0);
              l = this.pa.Db.ea(n.length - 3);
              if (e.v(l)) {
                m--;
                continue;
              }
              const p = l.Ib(n[1]);
              null == p ? m-- : (n = n.slice(2), this.ta.Bj(n, p) || (c.add((t, r) => {
                this.ta.Ae(r, p, k.i.ha.Ra, void 0);
                t();
              }, n), this.BV(n, p, k.i.ha.Ra, t => {
                t ? (c.pop(), this.ta.Ae(n, p, k.i.ha.Ra, void 0)) : 1 === m && c.Xe(a);
                m--;
              })));
            }
            (c.kb() || 0 === m) && a();
          }
          psa(f) {
            if (this.fa.Ba !== k.i.qa.API || k.external.pc.O.Tn.KH) {
              for (var b = new u.mB(), a = this.pa.rd(k.i.ha.Ia).ue, c = 0; c < a.length; c++) b.add((d, g) => {
                var l = this.pa.xb.ea(g.length - 3);
                if (e.v(l)) d();else {
                  var m = l.Ib(g[1]);
                  g = g.slice(2);
                  null == m ? d() : this.ta.Bh(g, m) ? d() : this.BV(g, m, k.i.ha.Ia, () => {
                    this.ta.Ae(g, m, k.i.ha.Ia, void 0);
                    d();
                  });
                }
              }, a[c].slice(0));
              a = this.pa.rd(k.i.ha.Ra).ue;
              for (c = 0; c < a.length; c++) b.add((d, g) => {
                var l = this.pa.Db.ea(g.length - 3);
                if (e.v(l)) d();else {
                  var m = l.Ib(g[1]);
                  g = g.slice(2);
                  null == m ? d() : this.ta.Bj(g, m) ? d() : this.BV(g, m, k.i.ha.Ra, () => {
                    this.ta.Ae(g, m, k.i.ha.Ra, void 0);
                    d();
                  });
                }
              }, a[c].slice(0));
              b.Xe(f);
            } else f();
          }
          bia(f) {
            e.Be(() => {
              e.model.Xa.R().Ya(e.model.Xa.b7, null, f);
            }, 1);
          }
          Ud(f) {
            this.xq.Ud(f);
            this.LL();
          }
          TR() {
            if (0 < this.wL.length) {
              for (let f = 0; f < this.wL.length; f++) this.wL[f].cancel();
              this.wL = [];
            }
          }
          static dispose() {
            k.zt.dispose();
            k.rY.dispose();
            k.external.Fb.jj.O9.dispose();
            k.external.pc.h6.dispose();
            u.Il.cancel();
            if (h.instance) {
              h.instance.pa = null;
              try {
                h.instance.ta.lu();
              } catch (f) {}
              h.instance.ta = null;
              try {
                h.instance.TR(), h.instance.Hm.cancel();
              } catch (f) {}
              h.instance.Hm = null;
              try {
                h.instance.xq.cancel();
              } catch (f) {}
              h.instance.xq = null;
              try {
                h.instance.Xt.cancel();
              } catch (f) {}
              h.instance.Xt = null;
              try {
                h.instance.O.clear();
              } catch (f) {}
              h.instance.Td();
              h.instance.O = null;
              h.instance = null;
            }
          }
        }
        k.Ma = h;
      })(e.u || (e.u = {}));
    })(q || (q = {}));
    (function (e) {
      (function (k) {
        class h extends x.Na {
          constructor() {
            super("div");
            this.G.Ul();
          }
          nb() {
            this.G.html(e.model.Ha.ra.J(e.model.Ha.ra.NW));
            this.G.element.setAttribute("style", `z-index:1!important;left:${(k.Nb.Hx - this.Zf()) / 2}px!important;top:${(k.Nb.qD - this.yd()) / 2}px!important;color:#ffffff!important;position:absolute!important;pointer-events:none;display:block!important;font-size:60px!important;text-shadow:0 0 10px #000000 !important;text-align:center!important;opacity:0.2!important;`);
          }
        }
        k.pra = h;
      })(e.K || (e.K = {}));
    })(q || (q = {}));
    (function (e) {
      class k {
        constructor(f, b) {
          this.eU = !1;
          this.pc = null;
          this.i0 = [];
          this.k0 = [];
          this.j0 = [];
          k.instance = this;
          this.pc = b;
          e.v(f) && (f = {});
          if (0 != u.MCa() || 0 != confirm("Flexmonster Pivot Table is not completely supported by this version of browser. Please update your browser. Continue anyway?")) {
            var a = "flexmonster/";
            void 0 !== f.componentFolder && (a = f.componentFolder);
            u.py.G_ = a;
            u.io.m_ = a;
            var c;
            f.container instanceof HTMLElement ? c = f.container : e.v(f.container) || (c = document.getElementById("#" == f.container.substr(0, 1) ? f.container.substring(1) : f.container));
            null == c ? (f = 0 == e.ia(f.container) ? "Flexmonster:\nUnable to create the component. DOM element with id '" + f.container + "' is not found." : "Flexmonster:\nUnable to create the component. DOM element is null.", console.error(f), alert(f)) : (a = this.jea(c), e.v(a) || void 0 === a.flexmonster || (a.flexmonster.dispose(), a.flexmonster = void 0), this.la = e.model.Va.R(), this.la.Fa.N(e.model.Wb.Uc.vF, () => this.JGa()), this.la.Fa.N(e.model.Wb.Uc.gy, () => this.R3()), this.la.Fa.N(e.model.Wb.Uc.eo, () => this.ZD()), this.la.Fa.N(e.model.Wb.Uc.WJ, () => this.XGa()), this.la.Fa.N(e.model.Wb.Uc.Wr, () => this.sN()), this.la.Fa.N(e.model.Wb.Uc.zF, () => this.b4()), this.la.Fa.N(e.model.Wb.Uc.mF, () => this.P3()), this.la.Fa.N(e.model.Wb.Uc.gJ, () => this.kq()), this.la.Fa.N(e.model.Wb.Uc.eJ, d => this.rga(d)), this.la.Fa.N(e.model.Wb.Uc.fJ, () => this.r3()), this.la.Fa.N(e.model.Wb.Uc.Iv, () => this.wr()), this.la.Fa.N(e.model.Wb.Uc.NX, () => this.lGa()), this.la.Fa.N(e.model.Wb.Uc.Z8, () => this.Dga()), this.la.Fa.N(e.model.Wb.Uc.Y8, d => this.Cga(d)), this.la.Fa.N(e.model.Wb.Uc.nF, () => this.kGa()), this.la.Fa.N(e.model.Wb.Uc.oF, () => this.hI()), this.la.Fa.N(e.model.Wb.Uc.HJ, () => this.nGa()), this.la.Fa.N(e.model.Wb.Uc.oX, () => this.v3()), this.la.Fa.N(e.model.Wb.Uc.gB, () => this.aHa()), this.la.Fa.N(e.model.Wb.Uc.al, () => this.YD()), this.la.Fa.N(e.model.Wb.Uc.Dt, d => this.X3(d)), this.la.N(e.model.Wb.Uc.hk, () => this.Gga()), this.la.Fa.N(e.model.Wb.Uc.hk, () => this.Gga()), this.la.Fa.N(e.model.Wb.Uc.pi, () => this.Z3()), this.la.N(h.uX, () => this.GFa()), this.la.N(h.ig, () => this.EFa()), this.la.N(h.aY, () => this.PGa()), this.la.N(h.eB, () => this.OGa()), this.Ng = new e.K.Nb(x.Ga.Xb(c), f), this.Ng.N(e.K.Si.Sx, d => this.KEa(d)), this.Ng.N(e.K.Si.eY, () => this.WGa()), this.la.yD(f), this.Hta(f.accessibility), this.eU = !0, this.jea(this.Ng.qf.element).flexmonster = b, this.la.Fa.Ya(e.model.Wb.Uc.S6));
          }
        }
        Hta(f) {
          e.v(f) || "object" !== typeof f || (e.v(f.keyboardMode) || this.Ng.qia(!0 === f.keyboardMode), e.v(f.highContrastTheme) || this.Ng.fKa(f.highContrastTheme));
        }
        jea(f) {
          return void 0 === f.uielement ? f : f.uielement;
        }
        get nc() {
          return this.la && this.la.Fa && this.la.Fa.nc;
        }
        get vU() {
          return this.la && this.la.Fa && this.la.Fa.vU;
        }
        get zU() {
          return this.la && this.la.Fa && this.la.Fa.zU;
        }
        Mha() {
          e.Be(() => {
            for (; 0 < this.j0.length;) this.j0.shift().call(this);
          }, 1);
        }
        qd(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
          e.Be(() => {
            0 == b ? this.i0.push(f) : 1 == b ? this.k0.push(f) : this.j0.push(f);
          }, 1);
        }
        JGa() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.vF));
        }
        R3() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.gy));
        }
        ZD() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.eo));
        }
        XGa() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.WJ));
        }
        sN() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.Wr));
        }
        b4() {
          for (this.la && this.la.Fa && this.la.Fa.Ef == e.model.Wb.up.INIT && e.Be(() => {
            e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.k9));
          }, 1); 0 < this.i0.length;) this.i0.shift().call(this);
        }
        kGa() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.nF));
        }
        hI() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.oF));
        }
        nGa() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.HJ));
        }
        P3() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.mF));
        }
        kq() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.gJ));
        }
        r3() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.fJ));
        }
        rga(f) {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.eJ, f.data));
        }
        wr() {
          for (; 0 < this.k0.length;) this.k0.shift().call(this);
        }
        lGa() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.r8));
        }
        Dga() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.b9));
        }
        Cga(f) {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.a9, f.data));
        }
        v3() {}
        aHa() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.gB));
        }
        YD() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.al));
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.I9));
        }
        X3(f) {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.Dt, f.data));
        }
        Z3() {}
        Gga() {
          this.la && this.la.Fa && (this.la.Fa.nE == e.model.Wb.Uc.pi || this.la.Fa.nE == e.model.Wb.Uc.al) && e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.RP));
        }
        KEa(f) {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.Sx, f.data));
        }
        WGa() {
          this.nc && (this.la.Fa.Ef !== e.model.Wb.up.Qc ? (this.la.Fa.Ef = e.model.Wb.up.Qc, e.Be(() => {
            this.Mha();
            e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.pi));
          }, 1)) : e.Be(() => {
            this.Mha();
          }, 1));
        }
        GFa() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.u7));
        }
        EFa() {
          e.Be(() => {
            e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.ig));
          }, 1);
        }
        PGa() {
          e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.e9));
        }
        OGa() {
          e.Be(() => {
            e.model.Xa.R().Ea(new e.model.hd(e.model.Xa.eB));
          }, 1);
        }
        b1() {
          return this.nc ? this.la.b1() : null;
        }
        f1(f) {
          return this.nc ? this.la.f1(f) : null;
        }
        xR(f) {
          this.nc ? null != f && this.la.xR(f) : this.qd(() => this.xR(f));
        }
        KV(f) {
          this.nc ? this.la.KV(f) : this.qd(() => this.KV(f));
        }
        JV() {
          this.nc ? this.la.JV() : this.qd(() => this.JV());
        }
        open() {
          this.la.open();
        }
        load(f, b) {
          this.la.load(f, b);
        }
        Is() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "object";
          let b = "object";
          f instanceof Object ? f.hasOwnProperty("type") && (b = f.type, b = b.toLowerCase()) : f && (b = f.toLowerCase());
          f = this.la.Is(f instanceof Object ? f : {});
          return e.v(f) || f.kb ? null : "xmlstring" == b ? z.ba.Kc(f.gp(), !0) : f.Sa();
        }
        Cx(f) {
          if (this.nc) {
            if ("string" == typeof f) try {
              if (-1 < f.indexOf("<config>")) {
                var b = z.ba.create(f);
                f = e.model.hb.ly.Ek(b);
              } else f = JSON.parse(f);
            } catch (a) {
              e.Wa(e.model.B.j.G8, e.model.B.j.xa, e.tb.xa);
              return;
            }
            this.la.Cx({
              report: f
            });
          } else this.qd(() => this.Cx(f));
        }
        getData(f, b, a) {
          this.nc ? this.la.getData(f, b, a) : this.qd(() => this.getData(f, b, a));
        }
        save() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            filename: "report.json"
          };
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          let d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
          var g = a;
          this.nc ? (f instanceof Object && f.hasOwnProperty("callbackHandler") && (g = f.callbackHandler), this.la.save(f, b, null != g ? (l, m) => g(l, m) : null, c, d)) : this.qd(() => this.save(f, b, a, c, d));
        }
        Ud(f, b) {
          null != f && (e.v(b) ? b = {
            partial: !1
          } : "boolean" === typeof b && (b = {
            partial: b
          }), this.vU ? this.la.Ud(f, b) : this.qd(() => this.Ud(f, b), 0));
        }
        KG(f) {
          null != f && (this.vU ? this.la.KG(f) : this.qd(() => this.KG(f), 0));
        }
        mta(f) {
          this.Ud({
            data: f
          });
        }
        bu(f) {
          this.nc ? null != f && this.la.bu(f) : this.qd(() => this.bu(f));
        }
        $z(f) {
          this.nc ? this.la.$z(f) : this.qd(() => this.$z(f));
        }
        kE() {
          this.nc ? this.la.kE() : this.qd(() => this.kE());
        }
        clear() {
          this.la && this.la.clear();
        }
        dispose() {
          e.Hn.dispose();
          e.Dk.dispose();
          e.aM.dispose();
          e.Uqa.dispose();
          u.io.dispose();
          this.pc = null;
          this.la.dispose();
          this.Ng.dispose();
          this.la = this.Ng = null;
          k.instance = null;
          e.model.Xa.dispose();
        }
        refresh() {
          this.nc ? this.Ng.nb() : this.qd(() => this.refresh());
        }
        mW() {
          this.nc ? this.Ng.mW() : this.qd(() => this.mW());
        }
        VN() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "column";
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          this.nc ? this.Ng.VN(f, b) : this.qd(() => this.VN(f, b));
        }
        nW() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "column";
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "bottom";
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          this.nc ? this.Ng.nW(f, b, a) : this.qd(() => this.nW(f, b, a));
        }
        JS() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "all";
          this.nc ? this.la.JS(f, b) : this.qd(() => this.JS(f, b));
        }
        Hw(f) {
          this.nc ? this.Ng.Hw(f) : this.qd(() => this.Hw(f));
        }
        ZR() {
          this.nc ? this.la.ZR() : this.qd(() => this.ZR());
        }
        sw(f) {
          this.nc ? this.Ng.sw(f) : this.qd(() => this.sw(f));
        }
        print() {
          let f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          this.nc ? this.la.print(e.model.at.i9.zb(f)) : this.qd(() => this.print(f));
        }
        Bk(f) {
          let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          if (this.nc) {
            if (null != f) {
              var c = null != a ? function () {
                for (var _len7 = arguments.length, d = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                  d[_key7] = arguments[_key7];
                }
                return a.apply(null, d);
              } : null;
              this.la.Bk(f, e.model.Dc.z7.zb(b), c);
            }
          } else this.qd(() => this.Bk(f, b, a));
        }
        Mm(f) {
          return this.nc ? this.la.Mm(f) : null;
        }
        kI(f) {
          this.nc && this.Ng.FHa(f);
        }
        yl(f, b) {
          this.nc ? this.la.yl(f, b) : this.qd(() => this.yl(f, b));
        }
        mu(f) {
          this.nc ? this.la.mu(f) : this.qd(() => this.mu(f));
        }
        on(f, b) {
          e.model.Xa.R().N(f, b);
        }
        GEa(f, b) {
          null == b ? e.model.Xa.R().Td(f) : e.model.Xa.R().pb(f, b);
        }
        AH() {
          return this.nc ? this.la.AH() : null;
        }
        L_(f) {
          new Promise(b => {
            this.eU ? b(f()) : this.la.Fa.N(e.model.Wb.Uc.S6, () => {
              b(f());
            });
          });
        }
        JG(f) {
          return new Promise(b => {
            this.nc ? b(f()) : this.la.Fa.N(e.model.Wb.Uc.pi, () => {
              b(f());
            });
          });
        }
        qBa() {
          return this.JG(() => this.la.AH());
        }
        pH() {
          return this.nc ? this.la.pH() : null;
        }
        dAa() {
          return this.JG(() => this.la.pH());
        }
        jD() {
          return this.nc ? this.la.jD() : null;
        }
        cBa() {
          return this.JG(() => this.la.jD());
        }
        gd() {
          return this.nc ? this.la.gd() : null;
        }
        QAa() {
          return this.JG(() => this.la.gd());
        }
        Gs() {
          return this.nc ? this.la.Gs() : null;
        }
        Qza() {
          return this.JG(() => this.la.Gs());
        }
        JM() {
          return this.Ng.JM;
        }
        IM() {
          return this.Ng.IM;
        }
        tW(f) {
          this.zU ? this.la.tW(f) : this.qd(() => this.tW(f), 1);
        }
        wW(f, b, a, c) {
          this.nc ? this.la.wW(f, b, a, c) : this.qd(() => this.wW(f, b, a, c));
        }
        xW(f, b) {
          this.zU ? this.la.xW(f, b) : this.qd(() => this.xW(f, b), 1);
        }
        AE(f, b) {
          let a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          this.nc ? this.la.AE(f, b) : this.qd(() => this.AE(f, b, a));
        }
        cW(f) {
          this.nc ? this.la.cW(f) : this.qd(() => this.cW(f));
        }
        xN(f, b) {
          this.nc ? this.Ng.xN(f, b) : this.qd(() => this.xN(f, b));
        }
        F1(f) {
          return this.nc ? this.la.F1(f) : null;
        }
        o1() {
          return this.nc ? this.la.o1() : null;
        }
        Qw() {
          return this.nc ? this.la.Qw() : null;
        }
        wq(f) {
          e.v(f) || (this.nc ? this.la.wq(f) : this.qd(() => this.wq(f)));
        }
        yj(f, b, a) {
          if (this.nc) return this.la.yj(f, b, a);
          this.qd(() => this.yj(f, b, a));
        }
        B1(f, b) {
          return this.la.B1(f, b);
        }
        oD(f, b) {
          if (this.nc) return this.la.oD(f, b);
          this.qd(() => this.oD(f, b));
        }
        IBa(f) {
          return new Promise(b => {
            this.la.GH(f, () => {
              this.la.oD(f, a => b(a));
            });
          });
        }
        GH(f, b) {
          this.nc ? this.la.GH(f, b) : this.qd(() => this.GH(f, b));
        }
        HBa(f) {
          return new Promise(b => {
            this.la.GH(f, a => b(a));
          });
        }
        EM(f, b, a) {
          this.nc ? this.la.EM(f, b, a) : this.qd(() => this.EM(f, b, a));
        }
        FBa(f, b) {
          return new Promise(a => {
            this.la.EM(f, b, c => a(c));
          });
        }
        FM(f, b, a, c) {
          this.nc ? this.la.FM(f, b, a, c) : this.qd(() => this.FM(f, b, a, c));
        }
        GBa(f, b, a) {
          return new Promise(c => {
            this.la.FM(f, b, a, d => c(d));
          });
        }
        VR(f, b, a) {
          let c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          let d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
          this.nc ? this.la.VR(f, b, c, d, a) : this.qd(() => this.VR(f, b, c, d, a));
        }
        TN(f) {
          return this.la.TN(f);
        }
        TV(f) {
          this.nc ? null != f && this.la.TV(e.model.hb.wp.zb(f)) : this.qd(() => this.TV(f));
        }
        iH() {
          return this.nc ? this.la.iH() : null;
        }
        Pza() {
          return this.JG(() => this.la.iH());
        }
        NV(f) {
          this.nc ? this.la.NV(f) : this.qd(() => this.NV(f));
        }
        ci(f, b) {
          return this.nc ? this.la.ci(f, b) : null;
        }
        wE(f, b, a) {
          this.nc ? null != f && this.la.wE(f, b, a) : this.qd(() => this.wE(f, b));
        }
        Xf(f, b) {
          return this.nc ? this.Ng.Xf(f, b) : null;
        }
        CH() {
          return this.nc ? this.Ng.CH() : null;
        }
        jA(f, b) {
          this.nc ? this.Ng.jA(f, b) : this.qd(() => this.jA(f, b));
        }
        EH() {
          return this.nc ? this.la.EH() : null;
        }
        kW(f) {
          this.nc ? this.la.kW(f) : this.qd(() => this.kW(f));
        }
        mE() {
          this.L_(() => this.Ng.mE());
        }
        rV() {
          this.L_(() => this.Ng.rV());
        }
        nL() {
          this.L_(() => this.Ng.nL());
        }
        dxa(f) {
          e.K.Y.W.le.zw = f;
          this.eU && this.refresh();
        }
        Pl(f) {
          e.K.Cd.tv.EC = f;
          this.eU && this.refresh();
        }
        exa(f) {
          e.K.Y.MO.FL = f;
        }
        cxa(f) {
          e.u.external.pc.zA.EL = f;
        }
        l1(f, b) {
          this.la.l1(f, b);
        }
        Cr(f) {
          this.nc ? this.Ng.Cr(f) : this.qd(() => this.Cr(f));
        }
        dt(f) {
          this.nc ? this.Ng.dt(f) : this.qd(() => this.dt(f));
        }
        KS(f, b, a) {
          this.nc ? this.Ng.KS(f, b, a) : this.qd(() => this.KS(f, b, a));
        }
        $R(f, b, a) {
          this.nc ? this.Ng.$R(f, b, a) : this.qd(() => this.$R(f, b, a));
        }
        GS(f, b, a, c) {
          this.nc ? this.Ng.GS(f, b, a, c) : this.qd(() => this.GS(f, b, a, c));
        }
        FS(f, b, a, c) {
          this.nc ? this.Ng.FS(f, b, a, c) : this.qd(() => this.FS(f, b, a, c));
        }
      }
      k.Nr = "2.9.46";
      k.TW = "102364851260994";
      e.kh = k;
      class h {}
      h.aY = "print";
      h.eB = "printcomplete";
      h.uX = "export";
      h.ig = "exportcomplete";
      e.bf = h;
    })(q || (q = {}));
    function PivotApi(e) {
      q.v(window.flexmonster) || (window.flexmonster = null);
      var k = {
          version: q.kh.Nr
        },
        h = new q.kh(e, k);
      k.alert = b => {
        if (void 0 != b.message && "" != b.message || void 0 != b.title && "" != b.title) {
          var a = void 0 != b.message ? q.model.Tb.valid(b.message) ? b.message : q.model.Tb.validate(b.message) : "",
            c = void 0 != b.title ? q.model.Tb.valid(b.title) ? b.title : q.model.Tb.validate(b.title) : "",
            d = b.type == q.tb.Dl || b.type == q.tb.cn || b.type == q.tb.xa || b.type == q.tb.lP ? b.type : q.tb.Dl,
            g = null,
            l = null;
          if (void 0 != b.buttons) for (var m = 0; m < b.buttons.length; m++) {
            var n = b.buttons[m],
              p = n.label;
            p = q.model.Tb.valid(p) ? p : q.model.Tb.validate(p);
            null == g && (g = []);
            g.push(p);
            n = "function" == typeof n.handler ? n.handler : null;
            null == l && (l = []);
            l.push(n);
          }
          q.Wa(a, c, d, g, l, void 0 == b.blocking || 1 != b.blocking && 0 != b.blocking ? !1 : b.blocking);
        }
      };
      k.openCalculatedValueEditor = (b, a) => h.xN(b, a);
      k.getAllConditions = () => h.b1();
      k.getCondition = b => h.f1(b);
      k.addCondition = b => h.xR(b);
      k.removeCondition = b => h.KV(b);
      k.removeAllConditions = () => h.JV();
      k.open = () => h.open();
      k.load = (b, a) => h.load(b, a);
      k.getReport = function () {
        let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "object";
        return h.Is(b);
      };
      k.setReport = b => h.Cx(b);
      k.getData = (b, a, c) => h.getData(b, a, c);
      k.save = function () {
        let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          filename: "report.json"
        };
        let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
        return h.save(b, a, c, d, g);
      };
      k.updateData = (b, a) => h.Ud(b, a);
      k.connectTo = b => h.KG(b);
      k.addJSON = b => h.mta(b);
      k.addCalculatedMeasure = b => h.bu(b);
      k.removeCalculatedMeasure = b => h.$z(b);
      k.removeAllCalculatedMeasures = () => h.kE();
      k.clear = () => h.clear();
      k.dispose = () => {
        q.v(window.flexmonster) || (window.flexmonster = null);
        h.dispose();
      };
      k.refresh = () => h.refresh();
      k.showGrid = () => h.mW();
      k.showCharts = function () {
        let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "column";
        let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return h.VN(b, a);
      };
      k.showChart = function () {
        let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "column";
        let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return h.VN(b, a);
      };
      k.showGridAndCharts = function () {
        let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "column";
        let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "bottom";
        let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        return h.nW(b, a, c);
      };
      k.expandAllData = function () {
        let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "all";
        return h.JS(b, a);
      };
      k.expandData = b => h.Hw(b);
      k.collapseAllData = () => h.ZR();
      k.collapseData = b => h.sw(b);
      k.expandCell = (b, a, c) => h.KS(b, a, c);
      k.collapseCell = (b, a, c) => h.$R(b, a, c);
      k.drillUpCell = (b, a, c, d) => h.GS(b, a, c, d);
      k.drillDownCell = (b, a, c, d) => h.FS(b, a, c, d);
      k.print = function () {
        let b = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return h.print(b);
      };
      k.exportTo = function (b) {
        let a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        return h.Bk(b, a, c);
      };
      k.openFilter = b => h.kI(b);
      k.getFilter = b => h.Mm(b);
      k.setFilter = (b, a) => h.yl(b, a);
      k.clearFilter = b => h.mu(b);
      k.on = (b, a) => h.on(b, a);
      k.off = (b, a) => h.GEa(b, a);
      k.getRows = () => h.AH();
      k.getRowsAsync = () => h.qBa();
      k.getColumns = () => h.pH();
      k.getColumnsAsync = () => h.dAa();
      k.getPages = () => h.jD();
      k.getReportFilters = () => h.jD();
      k.getReportFiltersAsync = () => h.cBa();
      k.getMeasures = () => h.gd();
      k.getMeasuresAsync = () => h.QAa();
      k.getAllMeasures = () => h.Gs();
      k.getAllMeasuresAsync = () => h.Qza();
      k.sortFieldsList = b => h.tW(b);
      k.sortValues = (b, a, c, d) => h.wW(b, a, c, d);
      k.sortingMethod = (b, a) => h.xW(b, a);
      k.setSort = function (b, a) {
        let c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        return h.AE(b, a, c);
      };
      k.getSort = b => h.F1(b);
      k.setFlatSort = b => h.cW(b);
      k.getFlatSort = () => h.o1();
      k.getOptions = () => h.Qw();
      k.setOptions = b => h.wq(b);
      k.getMembers = (b, a, c) => h.yj(b, a, c);
      k.getMembersAsync = (b, a) => h.B1(b, a);
      k.gridRowCount = () => h.JM();
      k.gridColumnCount = () => h.IM();
      k.getXMLAProviderName = (b, a) => h.oD(b, a);
      k.getXMLAProviderNameAsync = b => h.IBa(b);
      k.getXMLADataSources = (b, a) => h.GH(b, a);
      k.getXMLADataSourcesAsync = b => h.HBa(b);
      k.getXMLACatalogs = (b, a, c) => h.EM(b, a, c);
      k.getXMLACatalogsAsync = (b, a) => h.FBa(b, a);
      k.getXMLACubes = (b, a, c, d) => h.FM(b, a, c, d);
      k.getXMLACubesAsync = (b, a, c) => h.GBa(b, a, c);
      k.clearXMLACache = function (b, a, c) {
        let d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        let g = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        return h.VR(b, a, c, d, g);
      };
      k.shareReport = b => h.TN(b);
      k.getElasticIndices = (b, a) => h.l1(b, a);
      k.runQuery = b => h.TV(b);
      k.getAllHierarchies = () => h.iH();
      k.getAllHierarchiesAsync = () => h.Pza();
      k.replaceHierarchyCaption = b => h.NV(b);
      k.getFormat = (b, a) => h.ci(b, a);
      k.setFormat = (b, a, c) => h.wE(b, a, c);
      k.getCell = (b, a) => h.Xf(b, a);
      k.getSelectedCell = () => h.CH();
      k.setSelectedCell = (b, a) => h.jA(b, a);
      k.removeSelection = () => h.mE();
      k.getTableSizes = () => h.EH();
      k.setTableSizes = b => h.kW(b);
      k.openFieldsList = () => h.rV();
      k.closeFieldsList = () => h.nL();
      k.scrollToRow = b => h.Cr(b);
      k.scrollToColumn = b => h.dt(b);
      k.customizeCell = b => h.dxa(b);
      k.customizeChartElement = b => h.Pl(b);
      k.customizeContextMenu = b => h.exa(b);
      k.customizeAPIRequest = b => h.cxa(b);
      if (void 0 !== window.FlexmonsterHighcharts) {
        k.highcharts = {
          instance: k
        };
        for (var f in window.FlexmonsterHighcharts) k.highcharts[f] = window.FlexmonsterHighcharts[f];
      }
      if (void 0 !== window.FlexmonsterFusioncharts) for (f in k.fusioncharts = {
        instance: k
      }, window.FlexmonsterFusioncharts) k.fusioncharts[f] = window.FlexmonsterFusioncharts[f];
      if (void 0 !== window.FlexmonsterGooglecharts) for (f in k.googlecharts = {
        instance: k
      }, window.FlexmonsterGooglecharts) k.googlecharts[f] = window.FlexmonsterGooglecharts[f];
      if (void 0 !== window.FlexmonsterAmcharts) for (f in k.amcharts = {
        instance: k
      }, window.FlexmonsterAmcharts) k.amcharts[f] = window.FlexmonsterAmcharts[f];
      q.v(window.flexmonster) || q.v(window.flexmonster.embedPivotComponent) || (k.embedPivotComponent = window.flexmonster.embedPivotComponent);
      return window.flexmonster = k;
    }
    ;
    PivotApi["libsIncluded"] = true;
    ;
    return PivotApi(a);
  };
});
void 0 !== window.jQuery && (window.jQuery.fn.flexmonster = function (a) {
  a = a || {};
  a.container = this.get(0);
  a = window.Flexmonster ? window.Flexmonster(a) : window.PivotApi(a);
  this.data("flexmonster", a);
  return a;
});
void 0 !== window.angular && window.angular.module("flexmonster", []).directive("fmPivot", function () {
  function g(a, d) {
    void 0 !== a.fmComponentFolder && (d.componentFolder = a.fmComponentFolder);
    void 0 !== a.fmWidth && (d.width = a.fmWidth);
    void 0 !== a.fmHeight && (d.height = a.fmHeight);
    if (void 0 !== a.fmToolbar) {
      var e = a.fmToolbar;
      d.toolbar = !0 === e || "true" == e || "on" == e;
    }
    void 0 !== a.fmLicenseKey && (d.licenseKey = a.fmLicenseKey);
  }
  return {
    restrict: "A",
    scope: {
      report: "=fmReport",
      global: "=fmGlobal",
      accessibility: "=fmAccessibility",
      customizeAPIRequest: "&fmCustomizeAPIRequest",
      customizeCell: "&fmCustomizeCell",
      customizeChartElement: "&fmCustomizeChartElement",
      customizeContextMenu: "&fmCustomizeContextMenu",
      cellclick: "&fmCellClick",
      celldoubleclick: "&fmCellDoubleClick",
      dataerror: "&fmDataError",
      datafilecancelled: "&fmDataFileCancelled",
      dataloaded: "&fmDataLoaded",
      datachanged: "&fmDataChanged",
      fieldslistclose: "&fmFieldsListClose",
      fieldslistopen: "&fmFieldsListOpen",
      filteropen: "&fmFilteropen",
      fullscreen: "&fmFullscreen",
      loadingdata: "&fmLoadingData",
      loadinglocalization: "&fmLoadingLocalization",
      loadingolapstructure: "&fmLoadingOlapStructure",
      loadingreportfile: "&fmLoadingReportFile",
      localizationerror: "&fmLocalizationError",
      localizationloaded: "&fmLocalizationLoaded",
      olapstructureerror: "&fmOlapStructureError",
      olapstructureloaded: "&fmOlapStructureLoaded",
      openingreportfile: "&fmOpeningReportFile",
      querycomplete: "&fmQueryComplete",
      queryerror: "&fmQueryError",
      ready: "&fmReady",
      reportchange: "&fmReportChange",
      reportcomplete: "&fmReportComplete",
      reportfilecancelled: "&fmReportFileCancelled",
      reportfileerror: "&fmReportFileError",
      reportfileloaded: "&fmReportFileLoaded",
      runningquery: "&fmRunningQuery",
      unauthorizederror: "&fmUnauthorizedError",
      update: "&fmUpdate",
      beforetoolbarcreated: "&fmBeforeToolbarCreated",
      beforegriddraw: "&fmBeforeGridDraw",
      aftergriddraw: "&fmAfterGridDraw",
      afterchartdraw: "&fmAfterChartDraw",
      chartclick: "&fmChartClick",
      drillthroughopen: "&fmDrillThroughOpen",
      drillthroughclose: "&fmDrillThroughClose"
    },
    link: function (a, d, e, b) {
      b = {};
      b.container = d[0];
      g(e, b);
      a.customizeAPIRequest && (b.customizeAPIRequest = function (c) {
        return a.customizeAPIRequest({
          request: c
        });
      });
      a.customizeCell && (b.customizeCell = function (c, f) {
        return a.customizeCell({
          html: c,
          data: f
        });
      });
      a.customizeChartElement && (b.customizeChartElement = function (c, f) {
        return a.customizeChartElement({
          element: c,
          data: f
        });
      });
      a.customizeContextMenu && (b.customizeContextMenu = function (c, f, h) {
        return a.customizeContextMenu({
          items: c,
          data: f,
          viewType: h
        });
      });
      a.cellclick && (b.cellclick = function (c) {
        a.cellclick({
          cell: c
        });
      });
      a.celldoubleclick && (b.celldoubleclick = function (c) {
        a.celldoubleclick({
          cell: c
        });
      });
      b.dataerror && (b.dataerror = function (c) {
        a.dataerror({
          event: c
        });
      });
      b.datafilecancelled = a.datafilecancelled;
      b.dataloaded = a.dataloaded;
      b.datachanged && (b.datachanged = function (c) {
        a.datachanged({
          event: c
        });
      });
      b.fieldslistclose = a.fieldslistclose;
      b.fieldslistopen = a.fieldslistopen;
      b.filterclose = a.filterclose;
      b.filteropen && (b.filteropen = function (c) {
        a.filteropen({
          params: c
        });
      });
      b.drillthroughclose = a.drillthroughclose;
      b.drillthroughopen && (b.drillthroughopen = function (c) {
        a.drillthroughopen({
          cell: c
        });
      });
      b.fullscreen && (b.fullscreen = function (c) {
        a.fullscreen({
          fullScreenMode: c
        });
      });
      b.loadingdata = a.loadingdata;
      b.loadinglocalization = a.loadinglocalization;
      b.loadingolapstructure = a.loadingolapstructure;
      b.loadingreportfile = a.loadingreportfile;
      b.localizationerror = a.localizationerror;
      b.localizationloaded = a.localizationloaded;
      b.olapstructureerror && (b.olapstructureerror = function (c) {
        a.olapstructureerror({
          event: c
        });
      });
      b.olapstructureloaded = a.olapstructureloaded;
      b.openingreportfile = a.openingreportfile;
      b.querycomplete = a.querycomplete;
      b.queryerror && (b.queryerror = function (c) {
        a.queryerror({
          event: c
        });
      });
      a.ready && (b.ready = function () {
        a.ready({
          pivot: k
        });
      });
      b.reportchange = a.reportchange;
      b.reportcomplete = a.reportcomplete;
      b.reportfilecancelled = a.reportfilecancelled;
      b.reportfileerror = a.reportfileerror;
      b.reportfileloaded = a.reportfileloaded;
      b.runningquery = a.runningquery;
      b.loadingdata = a.loadingdata;
      b.loadingdata = a.loadingdata;
      b.loadingdata = a.loadingdata;
      a.unauthorizederror && (b.unauthorizederror = function (c) {
        a.unauthorizederror({
          done: c
        });
      });
      b.update = a.update;
      a.beforetoolbarcreated && (b.beforetoolbarcreated = function (c) {
        a.beforetoolbarcreated({
          toolbar: c
        });
      });
      a.beforegriddraw && (b.beforegriddraw = function (c) {
        a.beforegriddraw({
          params: c
        });
      });
      a.aftergriddraw && (b.aftergriddraw = function (c) {
        a.aftergriddraw({
          params: c
        });
      });
      b.afterchartdraw = a.afterchartdraw;
      a.chartclick && (b.chartclick = function (c) {
        a.chartclick({
          data: c
        });
      });
      a.report && (b.report = a.report);
      a.global && (b.global = a.global);
      a.accessibility && (b.accessibility = a.accessibility);
      var k = new Flexmonster(b);
    }
  };
});
if (void 0 !== window.React && void 0 !== window.React.createClass && (void 0 !== window.React.PropTypes || void 0 !== window.PropTypes)) {
  var React_PropTypes = void 0 !== window.React.PropTypes ? window.React.PropTypes : window.PropTypes;
  window.FlexmonsterReact = {
    Pivot: React.createClass({
      propTypes: {
        componentFolder: React_PropTypes.string,
        global: React_PropTypes.object,
        width: React_PropTypes.oneOfType([React_PropTypes.string, React_PropTypes.number]),
        height: React_PropTypes.oneOfType([React_PropTypes.string, React_PropTypes.number]),
        report: React_PropTypes.oneOfType([React_PropTypes.string, React_PropTypes.object]),
        licenseKey: React_PropTypes.string,
        toolbar: React_PropTypes.bool,
        customizeAPIRequest: React_PropTypes.func,
        customizeCell: React_PropTypes.func,
        customizeChartElement: React_PropTypes.func,
        customizeContextMenu: React_PropTypes.func,
        accessibility: React_PropTypes.object,
        cellclick: React_PropTypes.func,
        celldoubleclick: React_PropTypes.func,
        dataerror: React_PropTypes.func,
        datafilecancelled: React_PropTypes.func,
        dataloaded: React_PropTypes.func,
        datachanged: React_PropTypes.func,
        fieldslistclose: React_PropTypes.func,
        fieldslistopen: React_PropTypes.func,
        filteropen: React_PropTypes.func,
        filterclose: React_PropTypes.func,
        fullscreen: React_PropTypes.func,
        loadingdata: React_PropTypes.func,
        loadinglocalization: React_PropTypes.func,
        loadingolapstructure: React_PropTypes.func,
        loadingreportfile: React_PropTypes.func,
        localizationerror: React_PropTypes.func,
        localizationloaded: React_PropTypes.func,
        olapstructureerror: React_PropTypes.func,
        olapstructureloaded: React_PropTypes.func,
        openingreportfile: React_PropTypes.func,
        querycomplete: React_PropTypes.func,
        queryerror: React_PropTypes.func,
        ready: React_PropTypes.func,
        reportchange: React_PropTypes.func,
        reportcomplete: React_PropTypes.func,
        reportfilecancelled: React_PropTypes.func,
        reportfileerror: React_PropTypes.func,
        reportfileloaded: React_PropTypes.func,
        runningquery: React_PropTypes.func,
        unauthorizederror: React_PropTypes.func,
        update: React_PropTypes.func,
        beforetoolbarcreated: React_PropTypes.func,
        beforegriddraw: React_PropTypes.func,
        aftergriddraw: React_PropTypes.func,
        afterchartdraw: React_PropTypes.func,
        chartclick: React_PropTypes.func,
        drillthroughopen: React_PropTypes.func,
        drillthroughclose: React_PropTypes.func
      },
      render: function () {
        return React.DOM.div();
      },
      componentDidMount: function () {
        var a = {};
        a.container = ReactDOM.findDOMNode(this);
        this.parseProps(a);
        this.flexmonster = new window.Flexmonster(a);
      },
      shouldComponentUpdate: function () {
        return !1;
      },
      componentWillUnmount: function () {
        this.flexmonster.dispose();
      },
      parseProps: function (a) {
        for (var b in this.props) a[b] = this.props[b];
      }
    })
  };
}
;
window.flexmonster = {
  embedPivotComponent: function (d, e, f, g, a, b, h) {
    var c = b;
    "string" == typeof b && (c = h);
    config = {};
    config.componentFolder = d;
    config.container = e;
    config.width = f;
    config.height = parseInt(g);
    config.toolbar = c;
    config.report = a;
    a.hasOwnProperty("configUrl") && (config.configUrl = a.configUrl);
    a.hasOwnProperty("licenseKey") && (config.licenseKey = a.licenseKey);
    a.hasOwnProperty("jsCellClickHandler") && (config.cellclick = a.jsCellClickHandler);
    a.hasOwnProperty("jsCellDoubleClickHandler") && (config.celldoubleclick = a.jsCellDoubleClickHandler);
    a.hasOwnProperty("jsFullScreenHandler") && (config.fullscreen = a.jsFullScreenHandler);
    a.hasOwnProperty("jsFilterOpenHandler") && (config.filteropen = a.jsFilterOpenHandler);
    a.hasOwnProperty("jsFieldsListCloseHandler") && (config.fieldslistclose = a.jsFieldsListCloseHandler);
    a.hasOwnProperty("jsFieldsListOpenHandler") && (config.fieldslistopen = a.jsFieldsListOpenHandler);
    a.hasOwnProperty("jsPivotCreationCompleteHandler") && (config.ready = a.jsPivotCreationCompleteHandler);
    a.hasOwnProperty("jsPivotUpdateHandler") && (config.update = a.jsPivotUpdateHandler);
    a.hasOwnProperty("jsReportChangeHandler") && (config.reportchange = a.jsReportChangeHandler);
    a.hasOwnProperty("jsReportLoadedHandler") && (config.reportcomplete = a.jsReportLoadedHandler);
    a.hasOwnProperty("beforetoolbarcreated") && (config.beforetoolbarcreated = a.beforetoolbarcreated);
    a.hasOwnProperty("beforegriddraw") && (config.beforegriddraw = a.beforegriddraw);
    a.hasOwnProperty("aftergriddraw") && (config.aftergriddraw = a.aftergriddraw);
    a.hasOwnProperty("afterchartdraw") && (config.afterchartdraw = a.afterchartdraw);
    a.hasOwnProperty("customizeCell") && (config.customizeCell = a.customizeCell);
    a.hasOwnProperty("customizeContextMenu") && (config.customizeContextMenu = a.customizeContextMenu);
    return Flexmonster(config);
  }
};
/** @license canvg.js v2.0.0 | Copyright (c) 2010 - present Gabe Lerner (gabelerner@gmail.com) - https://github.com/canvg/canvg | MIT License [https://github.com/canvg/canvg/blob/master/LICENSE] */
!function (t, e) {
  t.canvg = e(t.RGBColor, t.StackBlur);
}(window, function (y, v) {
  "use strict";

  var t;
  return y = y && y.hasOwnProperty("default") ? y.default : y, v = v && v.hasOwnProperty("default") ? v.default : v, function (t) {
    var l;
    t.exports;
    (l = window).DOMParser = window.DOMParser;
    var c = l.document;
    function d(t, e) {
      var i;
      return (i = c.createElement("canvas")).width = t, i.height = e, i;
    }
    var f,
      p = function (t, e, i) {
        if (null != t || null != e || null != i) {
          var n = m(i || {});
          "string" == typeof t && (t = c.getElementById(t)), null != t.svg && t.svg.stop(), t.childNodes && 1 == t.childNodes.length && "OBJECT" == t.childNodes[0].nodeName || (t.svg = n);
          var s = t.getContext("2d");
          void 0 !== e.documentElement ? n.loadXmlDoc(s, e) : "<" == e.substr(0, 1) ? n.loadXml(s, e) : n.load(s, e);
        } else for (var a = c.querySelectorAll("svg"), r = 0; r < a.length; r++) {
          var o = a[r],
            h = c.createElement("canvas");
          if (void 0 !== o.clientWidth && void 0 !== o.clientHeight) h.width = o.clientWidth, h.height = o.clientHeight;else {
            var l = o.getBoundingClientRect();
            h.width = l.width, h.height = l.height;
          }
          o.parentNode.insertBefore(h, o), o.parentNode.removeChild(o);
          var u = c.createElement("div");
          u.appendChild(o), p(h, u.innerHTML);
        }
      };
    "undefined" == typeof Element || (void 0 !== Element.prototype.matches ? f = function (t, e) {
      return t.matches(e);
    } : void 0 !== Element.prototype.webkitMatchesSelector ? f = function (t, e) {
      return t.webkitMatchesSelector(e);
    } : void 0 !== Element.prototype.mozMatchesSelector ? f = function (t, e) {
      return t.mozMatchesSelector(e);
    } : void 0 !== Element.prototype.msMatchesSelector ? f = function (t, e) {
      return t.msMatchesSelector(e);
    } : void 0 !== Element.prototype.oMatchesSelector ? f = function (t, e) {
      return t.oMatchesSelector(e);
    } : ("function" != typeof jQuery && "function" != typeof Zepto || (f = function (t, e) {
      return $(t).is(e);
    }), void 0 === f && "undefined" != typeof Sizzle && (f = Sizzle.matchesSelector)));
    var e = /(\[[^\]]+\])/g,
      i = /(#[^\s\+>~\.\[:]+)/g,
      a = /(\.[^\s\+>~\.\[:]+)/g,
      r = /(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi,
      o = /(:[\w-]+\([^\)]*\))/gi,
      h = /(:[^\s\+>~\.\[:]+)/g,
      u = /([^\s\+>~\.\[:]+)/g;
    function P(n) {
      var s = [0, 0, 0],
        t = function (t, e) {
          var i = n.match(t);
          null != i && (s[e] += i.length, n = n.replace(t, " "));
        };
      return n = (n = n.replace(/:not\(([^\)]*)\)/g, "     $1 ")).replace(/{[\s\S]*/gm, " "), t(e, 1), t(i, 0), t(a, 1), t(r, 2), t(o, 1), t(h, 1), n = (n = n.replace(/[\*\s\+>~]/g, " ")).replace(/[#\.]/g, " "), t(u, 2), s.join("");
    }
    function m(s) {
      var D = {
        opts: s,
        FRAMERATE: 30,
        MAX_VIRTUAL_PIXELS: 3e4,
        rootEmSize: 12,
        emSize: 12,
        log: function () {}
      };
      D.init = function (t) {
        var e = 0;
        D.UniqueId = function () {
          return "canvg" + ++e;
        }, D.Definitions = {}, D.Styles = {}, D.StylesSpecificity = {}, D.Animations = [], D.Images = [], D.ctx = t, D.ViewPort = new function () {
          this.viewPorts = [], this.Clear = function () {
            this.viewPorts = [];
          }, this.SetCurrent = function (t, e) {
            this.viewPorts.push({
              width: t,
              height: e
            });
          }, this.RemoveCurrent = function () {
            this.viewPorts.pop();
          }, this.Current = function () {
            return this.viewPorts[this.viewPorts.length - 1];
          }, this.width = function () {
            return this.Current().width;
          }, this.height = function () {
            return this.Current().height;
          }, this.ComputeSize = function (t) {
            return null != t && "number" == typeof t ? t : "x" == t ? this.width() : "y" == t ? this.height() : Math.sqrt(Math.pow(this.width(), 2) + Math.pow(this.height(), 2)) / Math.sqrt(2);
          };
        }();
      }, D.init(), D.ImagesLoaded = function () {
        for (var t = 0; t < D.Images.length; t++) if (!D.Images[t].loaded) return !1;
        return !0;
      }, D.trim = function (t) {
        return t.replace(/^\s+|\s+$/g, "");
      }, D.compressSpaces = function (t) {
        return t.replace(/(?!\u3000)\s+/gm, " ");
      }, D.ajax = function (t) {
        var e;
        return (e = l.XMLHttpRequest ? new l.XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP")) ? (e.open("GET", t, !1), e.send(null), e.responseText) : null;
      }, D.parseXml = function (e) {
        if ("undefined" != typeof Windows && void 0 !== Windows.Data && void 0 !== Windows.Data.Xml) {
          var t = new Windows.Data.Xml.Dom.XmlDocument(),
            i = new Windows.Data.Xml.Dom.XmlLoadSettings();
          return i.prohibitDtd = !1, t.loadXml(e, i), t;
        }
        if (!l.DOMParser) return e = e.replace(/<!DOCTYPE svg[^>]*>/, ""), (t = new ActiveXObject("Microsoft.XMLDOM")).async = "false", t.loadXML(e), t;
        try {
          var n = s.xmldom ? new l.DOMParser(s.xmldom) : new l.DOMParser();
          return n.parseFromString(e, "image/svg+xml");
        } catch (t) {
          return (n = s.xmldom ? new l.DOMParser(s.xmldom) : new l.DOMParser()).parseFromString(e, "text/xml");
        }
      }, D.Property = function (t, e) {
        this.name = t, this.value = e;
      }, D.Property.prototype.getValue = function () {
        return this.value;
      }, D.Property.prototype.hasValue = function () {
        return null != this.value && "" !== this.value;
      }, D.Property.prototype.numValue = function () {
        if (!this.hasValue()) return 0;
        var t = parseFloat(this.value);
        return (this.value + "").match(/%$/) && (t /= 100), t;
      }, D.Property.prototype.valueOrDefault = function (t) {
        return this.hasValue() ? this.value : t;
      }, D.Property.prototype.numValueOrDefault = function (t) {
        return this.hasValue() ? this.numValue() : parseFloat(t);
      }, D.Property.prototype.addOpacity = function (t) {
        var e = this.value;
        if (null != t.value && "" != t.value && "string" == typeof this.value) {
          var i = new y(this.value);
          i.ok && (e = "rgba(" + i.r + ", " + i.g + ", " + i.b + ", " + t.numValue() + ")");
        }
        return new D.Property(this.name, e);
      }, D.Property.prototype.getDefinition = function () {
        var t = this.value.match(/#([^\)'"]+)/);
        return t && (t = t[1]), t || (t = this.value), D.Definitions[t];
      }, D.Property.prototype.isUrlDefinition = function () {
        return 0 == this.value.indexOf("url(");
      }, D.Property.prototype.getFillStyleDefinition = function (t, e) {
        var i = this.getDefinition();
        if (null != i && i.createGradient) return i.createGradient(D.ctx, t, e);
        if (null != i && i.createPattern) {
          if (i.getHrefAttribute().hasValue()) {
            var n = i.attribute("patternTransform");
            i = i.getHrefAttribute().getDefinition(), n.hasValue() && (i.attribute("patternTransform", !0).value = n.value);
          }
          return i.createPattern(D.ctx, t, e);
        }
        return null;
      }, D.Property.prototype.getDPI = function () {
        return 96;
      }, D.Property.prototype.getREM = function () {
        return D.rootEmSize;
      }, D.Property.prototype.getEM = function () {
        return D.emSize;
      }, D.Property.prototype.getUnits = function () {
        return (this.value + "").replace(/[0-9\.\-]/g, "");
      }, D.Property.prototype.isPixels = function () {
        if (!this.hasValue()) return !1;
        var t = this.value + "";
        return !!t.match(/px$/) || !!t.match(/^[0-9]+$/);
      }, D.Property.prototype.toPixels = function (t, e) {
        if (!this.hasValue()) return 0;
        var i = this.value + "";
        if (i.match(/rem$/)) return this.numValue() * this.getREM(t);
        if (i.match(/em$/)) return this.numValue() * this.getEM(t);
        if (i.match(/ex$/)) return this.numValue() * this.getEM(t) / 2;
        if (i.match(/px$/)) return this.numValue();
        if (i.match(/pt$/)) return this.numValue() * this.getDPI(t) * (1 / 72);
        if (i.match(/pc$/)) return 15 * this.numValue();
        if (i.match(/cm$/)) return this.numValue() * this.getDPI(t) / 2.54;
        if (i.match(/mm$/)) return this.numValue() * this.getDPI(t) / 25.4;
        if (i.match(/in$/)) return this.numValue() * this.getDPI(t);
        if (i.match(/%$/)) return this.numValue() * D.ViewPort.ComputeSize(t);
        var n = this.numValue();
        return e && n < 1 ? n * D.ViewPort.ComputeSize(t) : n;
      }, D.Property.prototype.toMilliseconds = function () {
        return this.hasValue() ? (this.value + "").match(/ms$/) ? this.numValue() : 1e3 * this.numValue() : 0;
      }, D.Property.prototype.toRadians = function () {
        if (!this.hasValue()) return 0;
        var t = this.value + "";
        return t.match(/deg$/) ? this.numValue() * (Math.PI / 180) : t.match(/grad$/) ? this.numValue() * (Math.PI / 200) : t.match(/rad$/) ? this.numValue() : this.numValue() * (Math.PI / 180);
      };
      var t = {
        baseline: "alphabetic",
        "before-edge": "top",
        "text-before-edge": "top",
        middle: "middle",
        central: "middle",
        "after-edge": "bottom",
        "text-after-edge": "bottom",
        ideographic: "ideographic",
        alphabetic: "alphabetic",
        hanging: "hanging",
        mathematical: "alphabetic"
      };
      return D.Property.prototype.toTextBaseline = function () {
        return this.hasValue() ? t[this.value] : null;
      }, D.Font = new function () {
        this.Styles = "normal|italic|oblique|inherit", this.Variants = "normal|small-caps|inherit", this.Weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit", this.CreateFont = function (t, e, i, n, s, a) {
          var r = null != a ? this.Parse(a) : this.CreateFont("", "", "", "", "", D.ctx.font);
          return {
            fontFamily: s = s || r.fontFamily,
            fontSize: n || r.fontSize,
            fontStyle: t || r.fontStyle,
            fontWeight: i || r.fontWeight,
            fontVariant: e || r.fontVariant,
            toString: function () {
              return [this.fontStyle, this.fontVariant, this.fontWeight, this.fontSize, this.fontFamily].join(" ");
            }
          };
        };
        var r = this;
        this.Parse = function (t) {
          for (var e = {}, i = D.trim(D.compressSpaces(t || "")).split(" "), n = {
              fontSize: !1,
              fontStyle: !1,
              fontWeight: !1,
              fontVariant: !1
            }, s = "", a = 0; a < i.length; a++) n.fontStyle || -1 == r.Styles.indexOf(i[a]) ? n.fontVariant || -1 == r.Variants.indexOf(i[a]) ? n.fontWeight || -1 == r.Weights.indexOf(i[a]) ? n.fontSize ? "inherit" != i[a] && (s += i[a]) : ("inherit" != i[a] && (e.fontSize = i[a].split("/")[0]), n.fontStyle = n.fontVariant = n.fontWeight = n.fontSize = !0) : ("inherit" != i[a] && (e.fontWeight = i[a]), n.fontStyle = n.fontVariant = n.fontWeight = !0) : ("inherit" != i[a] && (e.fontVariant = i[a]), n.fontStyle = n.fontVariant = !0) : ("inherit" != i[a] && (e.fontStyle = i[a]), n.fontStyle = !0);
          return "" != s && (e.fontFamily = s), e;
        };
      }(), D.ToNumberArray = function (t) {
        for (var e = (t || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [], i = 0; i < e.length; i++) e[i] = parseFloat(e[i]);
        return e;
      }, D.Point = function (t, e) {
        this.x = t, this.y = e;
      }, D.Point.prototype.angleTo = function (t) {
        return Math.atan2(t.y - this.y, t.x - this.x);
      }, D.Point.prototype.applyTransform = function (t) {
        var e = this.x * t[0] + this.y * t[2] + t[4],
          i = this.x * t[1] + this.y * t[3] + t[5];
        this.x = e, this.y = i;
      }, D.CreatePoint = function (t) {
        var e = D.ToNumberArray(t);
        return new D.Point(e[0], e[1]);
      }, D.CreatePath = function (t) {
        for (var e = D.ToNumberArray(t), i = [], n = 0; n < e.length; n += 2) i.push(new D.Point(e[n], e[n + 1]));
        return i;
      }, D.BoundingBox = function (t, e, i, n) {
        this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN, this.x = function () {
          return this.x1;
        }, this.y = function () {
          return this.y1;
        }, this.width = function () {
          return this.x2 - this.x1;
        }, this.height = function () {
          return this.y2 - this.y1;
        }, this.addPoint = function (t, e) {
          null != t && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = t, this.x2 = t), t < this.x1 && (this.x1 = t), t > this.x2 && (this.x2 = t)), null != e && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = e, this.y2 = e), e < this.y1 && (this.y1 = e), e > this.y2 && (this.y2 = e));
        }, this.addX = function (t) {
          this.addPoint(t, null);
        }, this.addY = function (t) {
          this.addPoint(null, t);
        }, this.addBoundingBox = function (t) {
          this.addPoint(t.x1, t.y1), this.addPoint(t.x2, t.y2);
        }, this.addQuadraticCurve = function (t, e, i, n, s, a) {
          var r = t + 2 / 3 * (i - t),
            o = e + 2 / 3 * (n - e),
            h = r + 1 / 3 * (s - t),
            l = o + 1 / 3 * (a - e);
          this.addBezierCurve(t, e, r, h, o, l, s, a);
        }, this.addBezierCurve = function (t, e, i, n, s, a, r, o) {
          var h = [t, e],
            l = [i, n],
            u = [s, a],
            c = [r, o];
          this.addPoint(h[0], h[1]), this.addPoint(c[0], c[1]);
          for (var f = 0; f <= 1; f++) {
            var p = function (t) {
                return Math.pow(1 - t, 3) * h[f] + 3 * Math.pow(1 - t, 2) * t * l[f] + 3 * (1 - t) * Math.pow(t, 2) * u[f] + Math.pow(t, 3) * c[f];
              },
              d = 6 * h[f] - 12 * l[f] + 6 * u[f],
              m = -3 * h[f] + 9 * l[f] - 9 * u[f] + 3 * c[f],
              y = 3 * l[f] - 3 * h[f];
            if (0 != m) {
              var v = Math.pow(d, 2) - 4 * y * m;
              if (!(v < 0)) {
                var g = (-d + Math.sqrt(v)) / (2 * m);
                0 < g && g < 1 && (0 == f && this.addX(p(g)), 1 == f && this.addY(p(g)));
                var x = (-d - Math.sqrt(v)) / (2 * m);
                0 < x && x < 1 && (0 == f && this.addX(p(x)), 1 == f && this.addY(p(x)));
              }
            } else {
              if (0 == d) continue;
              var b = -y / d;
              0 < b && b < 1 && (0 == f && this.addX(p(b)), 1 == f && this.addY(p(b)));
            }
          }
        }, this.isPointInBox = function (t, e) {
          return this.x1 <= t && t <= this.x2 && this.y1 <= e && e <= this.y2;
        }, this.addPoint(t, e), this.addPoint(i, n);
      }, D.Transform = function (t) {
        var e = this;
        this.Type = {}, this.Type.translate = function (t) {
          this.p = D.CreatePoint(t), this.apply = function (t) {
            t.translate(this.p.x || 0, this.p.y || 0);
          }, this.unapply = function (t) {
            t.translate(-1 * this.p.x || 0, -1 * this.p.y || 0);
          }, this.applyToPoint = function (t) {
            t.applyTransform([1, 0, 0, 1, this.p.x || 0, this.p.y || 0]);
          };
        }, this.Type.rotate = function (t) {
          var e = D.ToNumberArray(t);
          this.angle = new D.Property("angle", e[0]), this.cx = e[1] || 0, this.cy = e[2] || 0, this.apply = function (t) {
            t.translate(this.cx, this.cy), t.rotate(this.angle.toRadians()), t.translate(-this.cx, -this.cy);
          }, this.unapply = function (t) {
            t.translate(this.cx, this.cy), t.rotate(-1 * this.angle.toRadians()), t.translate(-this.cx, -this.cy);
          }, this.applyToPoint = function (t) {
            var e = this.angle.toRadians();
            t.applyTransform([1, 0, 0, 1, this.p.x || 0, this.p.y || 0]), t.applyTransform([Math.cos(e), Math.sin(e), -Math.sin(e), Math.cos(e), 0, 0]), t.applyTransform([1, 0, 0, 1, -this.p.x || 0, -this.p.y || 0]);
          };
        }, this.Type.scale = function (t) {
          this.p = D.CreatePoint(t), this.apply = function (t) {
            t.scale(this.p.x || 1, this.p.y || this.p.x || 1);
          }, this.unapply = function (t) {
            t.scale(1 / this.p.x || 1, 1 / this.p.y || this.p.x || 1);
          }, this.applyToPoint = function (t) {
            t.applyTransform([this.p.x || 0, 0, 0, this.p.y || 0, 0, 0]);
          };
        }, this.Type.matrix = function (t) {
          this.m = D.ToNumberArray(t), this.apply = function (t) {
            t.transform(this.m[0], this.m[1], this.m[2], this.m[3], this.m[4], this.m[5]);
          }, this.unapply = function (t) {
            var e = this.m[0],
              i = this.m[2],
              n = this.m[4],
              s = this.m[1],
              a = this.m[3],
              r = this.m[5],
              o = 1 / (e * (1 * a - 0 * r) - i * (1 * s - 0 * r) + n * (0 * s - 0 * a));
            t.transform(o * (1 * a - 0 * r), o * (0 * r - 1 * s), o * (0 * n - 1 * i), o * (1 * e - 0 * n), o * (i * r - n * a), o * (n * s - e * r));
          }, this.applyToPoint = function (t) {
            t.applyTransform(this.m);
          };
        }, this.Type.SkewBase = function (t) {
          this.base = e.Type.matrix, this.base(t), this.angle = new D.Property("angle", t);
        }, this.Type.SkewBase.prototype = new this.Type.matrix(), this.Type.skewX = function (t) {
          this.base = e.Type.SkewBase, this.base(t), this.m = [1, 0, Math.tan(this.angle.toRadians()), 1, 0, 0];
        }, this.Type.skewX.prototype = new this.Type.SkewBase(), this.Type.skewY = function (t) {
          this.base = e.Type.SkewBase, this.base(t), this.m = [1, Math.tan(this.angle.toRadians()), 0, 1, 0, 0];
        }, this.Type.skewY.prototype = new this.Type.SkewBase(), this.transforms = [], this.apply = function (t) {
          for (var e = 0; e < this.transforms.length; e++) this.transforms[e].apply(t);
        }, this.unapply = function (t) {
          for (var e = this.transforms.length - 1; 0 <= e; e--) this.transforms[e].unapply(t);
        }, this.applyToPoint = function (t) {
          for (var e = 0; e < this.transforms.length; e++) this.transforms[e].applyToPoint(t);
        };
        for (var i = D.trim(D.compressSpaces(t)).replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/), n = 0; n < i.length; n++) if ("none" !== i[n]) {
          var s = D.trim(i[n].split("(")[0]),
            a = i[n].split("(")[1].replace(")", ""),
            r = this.Type[s];
          if (void 0 !== r) {
            var o = new r(a);
            o.type = s, this.transforms.push(o);
          }
        }
      }, D.AspectRatio = function (t, e, i, n, s, a, r, o, h, l) {
        var u = (e = (e = D.compressSpaces(e)).replace(/^defer\s/, "")).split(" ")[0] || "xMidYMid",
          c = e.split(" ")[1] || "meet",
          f = i / n,
          p = s / a,
          d = Math.min(f, p),
          m = Math.max(f, p);
        "meet" == c && (n *= d, a *= d), "slice" == c && (n *= m, a *= m), h = new D.Property("refX", h), l = new D.Property("refY", l), h.hasValue() && l.hasValue() ? t.translate(-d * h.toPixels("x"), -d * l.toPixels("y")) : (u.match(/^xMid/) && ("meet" == c && d == p || "slice" == c && m == p) && t.translate(i / 2 - n / 2, 0), u.match(/YMid$/) && ("meet" == c && d == f || "slice" == c && m == f) && t.translate(0, s / 2 - a / 2), u.match(/^xMax/) && ("meet" == c && d == p || "slice" == c && m == p) && t.translate(i - n, 0), u.match(/YMax$/) && ("meet" == c && d == f || "slice" == c && m == f) && t.translate(0, s - a)), "none" == u ? t.scale(f, p) : "meet" == c ? t.scale(d, d) : "slice" == c && t.scale(m, m), t.translate(null == r ? 0 : -r, null == o ? 0 : -o);
      }, D.Element = {}, D.EmptyProperty = new D.Property("EMPTY", ""), D.Element.ElementBase = function (a) {
        this.attributes = {}, this.styles = {}, this.stylesSpecificity = {}, this.children = [], this.attribute = function (t, e) {
          var i = this.attributes[t];
          return null != i ? i : (1 == e && (i = new D.Property(t, ""), this.attributes[t] = i), i || D.EmptyProperty);
        }, this.getHrefAttribute = function () {
          for (var t in this.attributes) if ("href" == t || t.match(/:href$/)) return this.attributes[t];
          return D.EmptyProperty;
        }, this.style = function (t, e, i) {
          var n = this.styles[t];
          if (null != n) return n;
          var s = this.attribute(t);
          if (null != s && s.hasValue()) return this.styles[t] = s;
          if (1 != i) {
            var a = this.parent;
            if (null != a) {
              var r = a.style(t);
              if (null != r && r.hasValue()) return r;
            }
          }
          return 1 == e && (n = new D.Property(t, ""), this.styles[t] = n), n || D.EmptyProperty;
        }, this.render = function (t) {
          if ("none" != this.style("display").value && "hidden" != this.style("visibility").value) {
            if (t.save(), this.style("mask").hasValue()) {
              var e = this.style("mask").getDefinition();
              null != e && e.apply(t, this);
            } else if (this.style("filter").hasValue()) {
              var i = this.style("filter").getDefinition();
              null != i && i.apply(t, this);
            } else this.setContext(t), this.renderChildren(t), this.clearContext(t);
            t.restore();
          }
        }, this.setContext = function () {}, this.clearContext = function () {}, this.renderChildren = function (t) {
          for (var e = 0; e < this.children.length; e++) this.children[e].render(t);
        }, this.addChild = function (t, e) {
          var i = t;
          e && (i = D.CreateElement(t)), i.parent = this, "title" != i.type && this.children.push(i);
        }, this.addStylesFromStyleDefinition = function () {
          for (var t in D.Styles) if ("@" != t[0] && f(a, t)) {
            var e = D.Styles[t],
              i = D.StylesSpecificity[t];
            if (null != e) for (var n in e) {
              var s = this.stylesSpecificity[n];
              void 0 === s && (s = "000"), s <= i && (this.styles[n] = e[n], this.stylesSpecificity[n] = i);
            }
          }
        };
        var t,
          e = new RegExp("^[A-Z-]+$");
        if (null != a && 1 == a.nodeType) {
          for (var i = 0; i < a.attributes.length; i++) {
            var n = a.attributes[i],
              s = (t = n.nodeName, e.test(t) ? t.toLowerCase() : t);
            this.attributes[s] = new D.Property(s, n.value);
          }
          if (this.addStylesFromStyleDefinition(), this.attribute("style").hasValue()) {
            var r = this.attribute("style").value.split(";");
            for (i = 0; i < r.length; i++) if ("" != D.trim(r[i])) {
              var o = r[i].split(":"),
                h = D.trim(o[0]),
                l = D.trim(o[1]);
              this.styles[h] = new D.Property(h, l);
            }
          }
          this.attribute("id").hasValue() && null == D.Definitions[this.attribute("id").value] && (D.Definitions[this.attribute("id").value] = this);
          for (i = 0; i < a.childNodes.length; i++) {
            var u = a.childNodes[i];
            if (1 == u.nodeType && this.addChild(u, !0), this.captureTextNodes && (3 == u.nodeType || 4 == u.nodeType)) {
              var c = u.value || u.text || u.textContent || "";
              "" != D.compressSpaces(c) && this.addChild(new D.Element.tspan(u), !1);
            }
          }
        }
      }, D.Element.RenderedElementBase = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.calculateOpacity = function () {
          for (var t = 1, e = this; null != e;) {
            var i = e.style("opacity", !1, !0);
            i.hasValue() && (t *= i.numValue()), e = e.parent;
          }
          return t;
        }, this.setContext = function (t, e) {
          if (!e) {
            var i;
            if (this.style("fill").isUrlDefinition()) null != (i = this.style("fill").getFillStyleDefinition(this, this.style("fill-opacity"))) && (t.fillStyle = i);else if (this.style("fill").hasValue()) {
              var n;
              "currentColor" == (n = this.style("fill")).value && (n.value = this.style("color").value), "inherit" != n.value && (t.fillStyle = "none" == n.value ? "rgba(0,0,0,0)" : n.value);
            }
            if (this.style("fill-opacity").hasValue()) n = (n = new D.Property("fill", t.fillStyle)).addOpacity(this.style("fill-opacity")), t.fillStyle = n.value;
            if (this.style("stroke").isUrlDefinition()) null != (i = this.style("stroke").getFillStyleDefinition(this, this.style("stroke-opacity"))) && (t.strokeStyle = i);else if (this.style("stroke").hasValue()) {
              var s;
              "currentColor" == (s = this.style("stroke")).value && (s.value = this.style("color").value), "inherit" != s.value && (t.strokeStyle = "none" == s.value ? "rgba(0,0,0,0)" : s.value);
            }
            if (this.style("stroke-opacity").hasValue()) s = (s = new D.Property("stroke", t.strokeStyle)).addOpacity(this.style("stroke-opacity")), t.strokeStyle = s.value;
            if (this.style("stroke-width").hasValue()) {
              var a = this.style("stroke-width").toPixels();
              t.lineWidth = 0 == a ? .001 : a;
            }
            if (this.style("stroke-linecap").hasValue() && (t.lineCap = this.style("stroke-linecap").value), this.style("stroke-linejoin").hasValue() && (t.lineJoin = this.style("stroke-linejoin").value), this.style("stroke-miterlimit").hasValue() && (t.miterLimit = this.style("stroke-miterlimit").value), this.style("paint-order").hasValue() && (t.paintOrder = this.style("paint-order").value), this.style("stroke-dasharray").hasValue() && "none" != this.style("stroke-dasharray").value) {
              var r = D.ToNumberArray(this.style("stroke-dasharray").value);
              void 0 !== t.setLineDash ? t.setLineDash(r) : void 0 !== t.webkitLineDash ? t.webkitLineDash = r : void 0 === t.mozDash || 1 == r.length && 0 == r[0] || (t.mozDash = r);
              var o = this.style("stroke-dashoffset").toPixels();
              void 0 !== t.lineDashOffset ? t.lineDashOffset = o : void 0 !== t.webkitLineDashOffset ? t.webkitLineDashOffset = o : void 0 !== t.mozDashOffset && (t.mozDashOffset = o);
            }
          }
          if (void 0 !== t.font) if (this.style("font").hasValue()) t.font = this.style("font").value;else {
            t.font = D.Font.CreateFont(this.style("font-style").value, this.style("font-variant").value, this.style("font-weight").value, this.style("font-size").hasValue() ? this.style("font-size").toPixels() + "px" : "", this.style("font-family").value).toString();
            var h = this.style("font-size", !1, !1);
            h.isPixels() && (D.emSize = h.toPixels());
          }
          this.style("transform", !1, !0).hasValue() && new D.Transform(this.style("transform", !1, !0).value).apply(t);
          if (this.style("clip-path", !1, !0).hasValue()) {
            var l = this.style("clip-path", !1, !0).getDefinition();
            null != l && l.apply(t);
          }
          t.globalAlpha = this.calculateOpacity();
        };
      }, D.Element.RenderedElementBase.prototype = new D.Element.ElementBase(), D.Element.PathElementBase = function (t) {
        this.base = D.Element.RenderedElementBase, this.base(t), this.path = function (t) {
          return null != t && t.beginPath(), new D.BoundingBox();
        }, this.renderChildren = function (t) {
          this.path(t), D.Mouse.checkPath(this, t), "" != t.fillStyle && ("inherit" != this.style("fill-rule").valueOrDefault("inherit") ? t.fill(this.style("fill-rule").value) : t.fill()), "" != t.strokeStyle && t.stroke();
          var e = this.getMarkers();
          if (null != e) {
            if (this.style("marker-start").isUrlDefinition()) (i = this.style("marker-start").getDefinition()).render(t, e[0][0], e[0][1]);
            if (this.style("marker-mid").isUrlDefinition()) for (var i = this.style("marker-mid").getDefinition(), n = 1; n < e.length - 1; n++) i.render(t, e[n][0], e[n][1]);
            if (this.style("marker-end").isUrlDefinition()) (i = this.style("marker-end").getDefinition()).render(t, e[e.length - 1][0], e[e.length - 1][1]);
          }
        }, this.getBoundingBox = function () {
          return this.path();
        }, this.getMarkers = function () {
          return null;
        };
      }, D.Element.PathElementBase.prototype = new D.Element.RenderedElementBase(), D.SetDefaults = function (t) {
        t.strokeStyle = "rgba(0,0,0,0)", t.lineCap = "butt", t.lineJoin = "miter", t.miterLimit = 4;
      }, D.Element.svg = function (t) {
        this.base = D.Element.RenderedElementBase, this.base(t), this.baseClearContext = this.clearContext, this.clearContext = function (t) {
          this.baseClearContext(t), D.ViewPort.RemoveCurrent();
        }, this.baseSetContext = this.setContext, this.setContext = function (t) {
          if (D.SetDefaults(t), t.canvas.style && void 0 !== t.font && void 0 !== l.getComputedStyle) {
            t.font = l.getComputedStyle(t.canvas).getPropertyValue("font");
            var e = new D.Property("fontSize", D.Font.Parse(t.font).fontSize);
            e.hasValue() && (D.rootEmSize = D.emSize = e.toPixels("y"));
          }
          this.baseSetContext(t), this.attribute("x").hasValue() || (this.attribute("x", !0).value = 0), this.attribute("y").hasValue() || (this.attribute("y", !0).value = 0), t.translate(this.attribute("x").toPixels("x"), this.attribute("y").toPixels("y"));
          var i = D.ViewPort.width(),
            n = D.ViewPort.height();
          if (this.attribute("width").hasValue() || (this.attribute("width", !0).value = "100%"), this.attribute("height").hasValue() || (this.attribute("height", !0).value = "100%"), void 0 === this.root) {
            i = this.attribute("width").toPixels("x"), n = this.attribute("height").toPixels("y");
            var s = 0,
              a = 0;
            this.attribute("refX").hasValue() && this.attribute("refY").hasValue() && (s = -this.attribute("refX").toPixels("x"), a = -this.attribute("refY").toPixels("y")), "visible" != this.attribute("overflow").valueOrDefault("hidden") && (t.beginPath(), t.moveTo(s, a), t.lineTo(i, a), t.lineTo(i, n), t.lineTo(s, n), t.closePath(), t.clip());
          }
          if (D.ViewPort.SetCurrent(i, n), this.attribute("viewBox").hasValue()) {
            var r = D.ToNumberArray(this.attribute("viewBox").value),
              o = r[0],
              h = r[1];
            i = r[2], n = r[3], D.AspectRatio(t, this.attribute("preserveAspectRatio").value, D.ViewPort.width(), i, D.ViewPort.height(), n, o, h, this.attribute("refX").value, this.attribute("refY").value), D.ViewPort.RemoveCurrent(), D.ViewPort.SetCurrent(r[2], r[3]);
          }
        };
      }, D.Element.svg.prototype = new D.Element.RenderedElementBase(), D.Element.rect = function (t) {
        this.base = D.Element.PathElementBase, this.base(t), this.path = function (t) {
          var e = this.attribute("x").toPixels("x"),
            i = this.attribute("y").toPixels("y"),
            n = this.attribute("width").toPixels("x"),
            s = this.attribute("height").toPixels("y"),
            a = this.attribute("rx").toPixels("x"),
            r = this.attribute("ry").toPixels("y");
          if (this.attribute("rx").hasValue() && !this.attribute("ry").hasValue() && (r = a), this.attribute("ry").hasValue() && !this.attribute("rx").hasValue() && (a = r), a = Math.min(a, n / 2), r = Math.min(r, s / 2), null != t) {
            var o = (Math.sqrt(2) - 1) / 3 * 4;
            t.beginPath(), 0 < s && 0 < n && (t.moveTo(e + a, i), t.lineTo(e + n - a, i), t.bezierCurveTo(e + n - a + o * a, i, e + n, i + r - o * r, e + n, i + r), t.lineTo(e + n, i + s - r), t.bezierCurveTo(e + n, i + s - r + o * r, e + n - a + o * a, i + s, e + n - a, i + s), t.lineTo(e + a, i + s), t.bezierCurveTo(e + a - o * a, i + s, e, i + s - r + o * r, e, i + s - r), t.lineTo(e, i + r), t.bezierCurveTo(e, i + r - o * r, e + a - o * a, i, e + a, i), t.closePath());
          }
          return new D.BoundingBox(e, i, e + n, i + s);
        };
      }, D.Element.rect.prototype = new D.Element.PathElementBase(), D.Element.circle = function (t) {
        this.base = D.Element.PathElementBase, this.base(t), this.path = function (t) {
          var e = this.attribute("cx").toPixels("x"),
            i = this.attribute("cy").toPixels("y"),
            n = this.attribute("r").toPixels();
          return null != t && 0 < n && (t.beginPath(), t.arc(e, i, n, 0, 2 * Math.PI, !1), t.closePath()), new D.BoundingBox(e - n, i - n, e + n, i + n);
        };
      }, D.Element.circle.prototype = new D.Element.PathElementBase(), D.Element.ellipse = function (t) {
        this.base = D.Element.PathElementBase, this.base(t), this.path = function (t) {
          var e = (Math.sqrt(2) - 1) / 3 * 4,
            i = this.attribute("rx").toPixels("x"),
            n = this.attribute("ry").toPixels("y"),
            s = this.attribute("cx").toPixels("x"),
            a = this.attribute("cy").toPixels("y");
          return null != t && (t.beginPath(), t.moveTo(s + i, a), t.bezierCurveTo(s + i, a + e * n, s + e * i, a + n, s, a + n), t.bezierCurveTo(s - e * i, a + n, s - i, a + e * n, s - i, a), t.bezierCurveTo(s - i, a - e * n, s - e * i, a - n, s, a - n), t.bezierCurveTo(s + e * i, a - n, s + i, a - e * n, s + i, a), t.closePath()), new D.BoundingBox(s - i, a - n, s + i, a + n);
        };
      }, D.Element.ellipse.prototype = new D.Element.PathElementBase(), D.Element.line = function (t) {
        this.base = D.Element.PathElementBase, this.base(t), this.getPoints = function () {
          return [new D.Point(this.attribute("x1").toPixels("x"), this.attribute("y1").toPixels("y")), new D.Point(this.attribute("x2").toPixels("x"), this.attribute("y2").toPixels("y"))];
        }, this.path = function (t) {
          var e = this.getPoints();
          return null != t && (t.beginPath(), t.moveTo(e[0].x, e[0].y), t.lineTo(e[1].x, e[1].y)), new D.BoundingBox(e[0].x, e[0].y, e[1].x, e[1].y);
        }, this.getMarkers = function () {
          var t = this.getPoints(),
            e = t[0].angleTo(t[1]);
          return [[t[0], e], [t[1], e]];
        };
      }, D.Element.line.prototype = new D.Element.PathElementBase(), D.Element.polyline = function (t) {
        this.base = D.Element.PathElementBase, this.base(t), this.points = D.CreatePath(this.attribute("points").value), this.path = function (t) {
          var e = new D.BoundingBox(this.points[0].x, this.points[0].y);
          null != t && (t.beginPath(), t.moveTo(this.points[0].x, this.points[0].y));
          for (var i = 1; i < this.points.length; i++) e.addPoint(this.points[i].x, this.points[i].y), null != t && t.lineTo(this.points[i].x, this.points[i].y);
          return e;
        }, this.getMarkers = function () {
          for (var t = [], e = 0; e < this.points.length - 1; e++) t.push([this.points[e], this.points[e].angleTo(this.points[e + 1])]);
          return 0 < t.length && t.push([this.points[this.points.length - 1], t[t.length - 1][1]]), t;
        };
      }, D.Element.polyline.prototype = new D.Element.PathElementBase(), D.Element.polygon = function (t) {
        this.base = D.Element.polyline, this.base(t), this.basePath = this.path, this.path = function (t) {
          var e = this.basePath(t);
          return null != t && (t.lineTo(this.points[0].x, this.points[0].y), t.closePath()), e;
        };
      }, D.Element.polygon.prototype = new D.Element.polyline(), D.Element.path = function (t) {
        this.base = D.Element.PathElementBase, this.base(t);
        var e = this.attribute("d").value;
        e = e.replace(/,/gm, " ");
        for (var i = 0; i < 2; i++) e = e.replace(/([MmZzLlHhVvCcSsQqTtAa])([^\s])/gm, "$1 $2");
        e = (e = e.replace(/([^\s])([MmZzLlHhVvCcSsQqTtAa])/gm, "$1 $2")).replace(/([0-9])([+\-])/gm, "$1 $2");
        for (i = 0; i < 2; i++) e = e.replace(/(\.[0-9]*)(\.)/gm, "$1 $2");
        e = e.replace(/([Aa](\s+[0-9]+){3})\s+([01])\s*([01])/gm, "$1 $3 $4 "), e = D.compressSpaces(e), e = D.trim(e), this.PathParser = new function (t) {
          this.tokens = t.split(" "), this.reset = function () {
            this.i = -1, this.command = "", this.previousCommand = "", this.start = new D.Point(0, 0), this.control = new D.Point(0, 0), this.current = new D.Point(0, 0), this.points = [], this.angles = [];
          }, this.isEnd = function () {
            return this.i >= this.tokens.length - 1;
          }, this.isCommandOrEnd = function () {
            return !!this.isEnd() || null != this.tokens[this.i + 1].match(/^[A-Za-z]$/);
          }, this.isRelativeCommand = function () {
            switch (this.command) {
              case "m":
              case "l":
              case "h":
              case "v":
              case "c":
              case "s":
              case "q":
              case "t":
              case "a":
              case "z":
                return !0;
            }
            return !1;
          }, this.getToken = function () {
            return this.i++, this.tokens[this.i];
          }, this.getScalar = function () {
            return parseFloat(this.getToken());
          }, this.nextCommand = function () {
            this.previousCommand = this.command, this.command = this.getToken();
          }, this.getPoint = function () {
            var t = new D.Point(this.getScalar(), this.getScalar());
            return this.makeAbsolute(t);
          }, this.getAsControlPoint = function () {
            var t = this.getPoint();
            return this.control = t;
          }, this.getAsCurrentPoint = function () {
            var t = this.getPoint();
            return this.current = t;
          }, this.getReflectedControlPoint = function () {
            return "c" != this.previousCommand.toLowerCase() && "s" != this.previousCommand.toLowerCase() && "q" != this.previousCommand.toLowerCase() && "t" != this.previousCommand.toLowerCase() ? this.current : new D.Point(2 * this.current.x - this.control.x, 2 * this.current.y - this.control.y);
          }, this.makeAbsolute = function (t) {
            return this.isRelativeCommand() && (t.x += this.current.x, t.y += this.current.y), t;
          }, this.addMarker = function (t, e, i) {
            null != i && 0 < this.angles.length && null == this.angles[this.angles.length - 1] && (this.angles[this.angles.length - 1] = this.points[this.points.length - 1].angleTo(i)), this.addMarkerAngle(t, null == e ? null : e.angleTo(t));
          }, this.addMarkerAngle = function (t, e) {
            this.points.push(t), this.angles.push(e);
          }, this.getMarkerPoints = function () {
            return this.points;
          }, this.getMarkerAngles = function () {
            for (var t = 0; t < this.angles.length; t++) if (null == this.angles[t]) for (var e = t + 1; e < this.angles.length; e++) if (null != this.angles[e]) {
              this.angles[t] = this.angles[e];
              break;
            }
            return this.angles;
          };
        }(e), this.path = function (t) {
          var e = this.PathParser;
          e.reset();
          var i = new D.BoundingBox();
          for (null != t && t.beginPath(); !e.isEnd();) switch (e.nextCommand(), e.command) {
            case "M":
            case "m":
              var n = e.getAsCurrentPoint();
              for (e.addMarker(n), i.addPoint(n.x, n.y), null != t && t.moveTo(n.x, n.y), e.start = e.current; !e.isCommandOrEnd();) {
                n = e.getAsCurrentPoint();
                e.addMarker(n, e.start), i.addPoint(n.x, n.y), null != t && t.lineTo(n.x, n.y);
              }
              break;
            case "L":
            case "l":
              for (; !e.isCommandOrEnd();) {
                var s = e.current;
                n = e.getAsCurrentPoint();
                e.addMarker(n, s), i.addPoint(n.x, n.y), null != t && t.lineTo(n.x, n.y);
              }
              break;
            case "H":
            case "h":
              for (; !e.isCommandOrEnd();) {
                var a = new D.Point((e.isRelativeCommand() ? e.current.x : 0) + e.getScalar(), e.current.y);
                e.addMarker(a, e.current), e.current = a, i.addPoint(e.current.x, e.current.y), null != t && t.lineTo(e.current.x, e.current.y);
              }
              break;
            case "V":
            case "v":
              for (; !e.isCommandOrEnd();) {
                a = new D.Point(e.current.x, (e.isRelativeCommand() ? e.current.y : 0) + e.getScalar());
                e.addMarker(a, e.current), e.current = a, i.addPoint(e.current.x, e.current.y), null != t && t.lineTo(e.current.x, e.current.y);
              }
              break;
            case "C":
            case "c":
              for (; !e.isCommandOrEnd();) {
                var r = e.current,
                  o = e.getPoint(),
                  h = e.getAsControlPoint(),
                  l = e.getAsCurrentPoint();
                e.addMarker(l, h, o), i.addBezierCurve(r.x, r.y, o.x, o.y, h.x, h.y, l.x, l.y), null != t && t.bezierCurveTo(o.x, o.y, h.x, h.y, l.x, l.y);
              }
              break;
            case "S":
            case "s":
              for (; !e.isCommandOrEnd();) {
                r = e.current, o = e.getReflectedControlPoint(), h = e.getAsControlPoint(), l = e.getAsCurrentPoint();
                e.addMarker(l, h, o), i.addBezierCurve(r.x, r.y, o.x, o.y, h.x, h.y, l.x, l.y), null != t && t.bezierCurveTo(o.x, o.y, h.x, h.y, l.x, l.y);
              }
              break;
            case "Q":
            case "q":
              for (; !e.isCommandOrEnd();) {
                r = e.current, h = e.getAsControlPoint(), l = e.getAsCurrentPoint();
                e.addMarker(l, h, h), i.addQuadraticCurve(r.x, r.y, h.x, h.y, l.x, l.y), null != t && t.quadraticCurveTo(h.x, h.y, l.x, l.y);
              }
              break;
            case "T":
            case "t":
              for (; !e.isCommandOrEnd();) {
                r = e.current, h = e.getReflectedControlPoint();
                e.control = h;
                l = e.getAsCurrentPoint();
                e.addMarker(l, h, h), i.addQuadraticCurve(r.x, r.y, h.x, h.y, l.x, l.y), null != t && t.quadraticCurveTo(h.x, h.y, l.x, l.y);
              }
              break;
            case "A":
            case "a":
              for (; !e.isCommandOrEnd();) {
                r = e.current;
                var u = e.getScalar(),
                  c = e.getScalar(),
                  f = e.getScalar() * (Math.PI / 180),
                  p = e.getScalar(),
                  d = e.getScalar(),
                  m = (l = e.getAsCurrentPoint(), new D.Point(Math.cos(f) * (r.x - l.x) / 2 + Math.sin(f) * (r.y - l.y) / 2, -Math.sin(f) * (r.x - l.x) / 2 + Math.cos(f) * (r.y - l.y) / 2)),
                  y = Math.pow(m.x, 2) / Math.pow(u, 2) + Math.pow(m.y, 2) / Math.pow(c, 2);
                1 < y && (u *= Math.sqrt(y), c *= Math.sqrt(y));
                var v = (p == d ? -1 : 1) * Math.sqrt((Math.pow(u, 2) * Math.pow(c, 2) - Math.pow(u, 2) * Math.pow(m.y, 2) - Math.pow(c, 2) * Math.pow(m.x, 2)) / (Math.pow(u, 2) * Math.pow(m.y, 2) + Math.pow(c, 2) * Math.pow(m.x, 2)));
                isNaN(v) && (v = 0);
                var g = new D.Point(v * u * m.y / c, v * -c * m.x / u),
                  x = new D.Point((r.x + l.x) / 2 + Math.cos(f) * g.x - Math.sin(f) * g.y, (r.y + l.y) / 2 + Math.sin(f) * g.x + Math.cos(f) * g.y),
                  b = function (t) {
                    return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2));
                  },
                  P = function (t, e) {
                    return (t[0] * e[0] + t[1] * e[1]) / (b(t) * b(e));
                  },
                  E = function (t, e) {
                    return (t[0] * e[1] < t[1] * e[0] ? -1 : 1) * Math.acos(P(t, e));
                  },
                  w = E([1, 0], [(m.x - g.x) / u, (m.y - g.y) / c]),
                  C = [(m.x - g.x) / u, (m.y - g.y) / c],
                  B = [(-m.x - g.x) / u, (-m.y - g.y) / c],
                  M = E(C, B);
                P(C, B) <= -1 && (M = Math.PI), 1 <= P(C, B) && (M = 0);
                var T = 1 - d ? 1 : -1,
                  S = w + T * (M / 2),
                  V = new D.Point(x.x + u * Math.cos(S), x.y + c * Math.sin(S));
                if (e.addMarkerAngle(V, S - T * Math.PI / 2), e.addMarkerAngle(l, S - T * Math.PI), i.addPoint(l.x, l.y), null != t && !isNaN(w) && !isNaN(M)) {
                  P = c < u ? u : c;
                  var k = c < u ? 1 : u / c,
                    A = c < u ? c / u : 1;
                  t.translate(x.x, x.y), t.rotate(f), t.scale(k, A), t.arc(0, 0, P, w, w + M, 1 - d), t.scale(1 / k, 1 / A), t.rotate(-f), t.translate(-x.x, -x.y);
                }
              }
              break;
            case "Z":
            case "z":
              null != t && i.x1 !== i.x2 && i.y1 !== i.y2 && t.closePath(), e.current = e.start;
          }
          return i;
        }, this.getMarkers = function () {
          for (var t = this.PathParser.getMarkerPoints(), e = this.PathParser.getMarkerAngles(), i = [], n = 0; n < t.length; n++) i.push([t[n], e[n]]);
          return i;
        };
      }, D.Element.path.prototype = new D.Element.PathElementBase(), D.Element.pattern = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.createPattern = function (t, e, i) {
          var n = this.attribute("width").toPixels("x", !0),
            s = this.attribute("height").toPixels("y", !0),
            a = new D.Element.svg();
          a.attributes.viewBox = new D.Property("viewBox", this.attribute("viewBox").value), a.attributes.width = new D.Property("width", n + "px"), a.attributes.height = new D.Property("height", s + "px"), a.attributes.transform = new D.Property("transform", this.attribute("patternTransform").value), a.children = this.children;
          var r = d(n, s),
            o = r.getContext("2d");
          this.attribute("x").hasValue() && this.attribute("y").hasValue() && o.translate(this.attribute("x").toPixels("x", !0), this.attribute("y").toPixels("y", !0)), i.hasValue() ? this.styles["fill-opacity"] = i : delete this.styles["fill-opacity"];
          for (var h = -1; h <= 1; h++) for (var l = -1; l <= 1; l++) o.save(), a.attributes.x = new D.Property("x", h * r.width), a.attributes.y = new D.Property("y", l * r.height), a.render(o), o.restore();
          return t.createPattern(r, "repeat");
        };
      }, D.Element.pattern.prototype = new D.Element.ElementBase(), D.Element.marker = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.baseRender = this.render, this.render = function (t, e, i) {
          if (e) {
            t.translate(e.x, e.y), "auto" == this.attribute("orient").valueOrDefault("auto") && t.rotate(i), "strokeWidth" == this.attribute("markerUnits").valueOrDefault("strokeWidth") && t.scale(t.lineWidth, t.lineWidth), t.save();
            var n = new D.Element.svg();
            n.attributes.viewBox = new D.Property("viewBox", this.attribute("viewBox").value), n.attributes.refX = new D.Property("refX", this.attribute("refX").value), n.attributes.refY = new D.Property("refY", this.attribute("refY").value), n.attributes.width = new D.Property("width", this.attribute("markerWidth").value), n.attributes.height = new D.Property("height", this.attribute("markerHeight").value), n.attributes.fill = new D.Property("fill", this.attribute("fill").valueOrDefault("black")), n.attributes.stroke = new D.Property("stroke", this.attribute("stroke").valueOrDefault("none")), n.children = this.children, n.render(t), t.restore(), "strokeWidth" == this.attribute("markerUnits").valueOrDefault("strokeWidth") && t.scale(1 / t.lineWidth, 1 / t.lineWidth), "auto" == this.attribute("orient").valueOrDefault("auto") && t.rotate(-i), t.translate(-e.x, -e.y);
          }
        };
      }, D.Element.marker.prototype = new D.Element.ElementBase(), D.Element.defs = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.render = function () {};
      }, D.Element.defs.prototype = new D.Element.ElementBase(), D.Element.GradientBase = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.stops = [];
        for (var e = 0; e < this.children.length; e++) {
          var i = this.children[e];
          "stop" == i.type && this.stops.push(i);
        }
        this.getGradient = function () {}, this.gradientUnits = function () {
          return this.attribute("gradientUnits").valueOrDefault("objectBoundingBox");
        }, this.attributesToInherit = ["gradientUnits"], this.inheritStopContainer = function (t) {
          for (var e = 0; e < this.attributesToInherit.length; e++) {
            var i = this.attributesToInherit[e];
            !this.attribute(i).hasValue() && t.attribute(i).hasValue() && (this.attribute(i, !0).value = t.attribute(i).value);
          }
        }, this.createGradient = function (t, e, i) {
          var n = this;
          this.getHrefAttribute().hasValue() && (n = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(n));
          var s = function (t) {
              return i.hasValue() ? new D.Property("color", t).addOpacity(i).value : t;
            },
            a = this.getGradient(t, e);
          if (null == a) return s(n.stops[n.stops.length - 1].color);
          for (var r = 0; r < n.stops.length; r++) a.addColorStop(n.stops[r].offset, s(n.stops[r].color));
          if (this.attribute("gradientTransform").hasValue()) {
            var o = D.ViewPort.viewPorts[0],
              h = new D.Element.rect();
            h.attributes.x = new D.Property("x", -D.MAX_VIRTUAL_PIXELS / 3), h.attributes.y = new D.Property("y", -D.MAX_VIRTUAL_PIXELS / 3), h.attributes.width = new D.Property("width", D.MAX_VIRTUAL_PIXELS), h.attributes.height = new D.Property("height", D.MAX_VIRTUAL_PIXELS);
            var l = new D.Element.g();
            l.attributes.transform = new D.Property("transform", this.attribute("gradientTransform").value), l.children = [h];
            var u = new D.Element.svg();
            u.attributes.x = new D.Property("x", 0), u.attributes.y = new D.Property("y", 0), u.attributes.width = new D.Property("width", o.width), u.attributes.height = new D.Property("height", o.height), u.children = [l];
            var c = d(o.width, o.height),
              f = c.getContext("2d");
            return f.fillStyle = a, u.render(f), f.createPattern(c, "no-repeat");
          }
          return a;
        };
      }, D.Element.GradientBase.prototype = new D.Element.ElementBase(), D.Element.linearGradient = function (t) {
        this.base = D.Element.GradientBase, this.base(t), this.attributesToInherit.push("x1"), this.attributesToInherit.push("y1"), this.attributesToInherit.push("x2"), this.attributesToInherit.push("y2"), this.getGradient = function (t, e) {
          var i = "objectBoundingBox" == this.gradientUnits() ? e.getBoundingBox(t) : null;
          this.attribute("x1").hasValue() || this.attribute("y1").hasValue() || this.attribute("x2").hasValue() || this.attribute("y2").hasValue() || (this.attribute("x1", !0).value = 0, this.attribute("y1", !0).value = 0, this.attribute("x2", !0).value = 1, this.attribute("y2", !0).value = 0);
          var n = "objectBoundingBox" == this.gradientUnits() ? i.x() + i.width() * this.attribute("x1").numValue() : this.attribute("x1").toPixels("x"),
            s = "objectBoundingBox" == this.gradientUnits() ? i.y() + i.height() * this.attribute("y1").numValue() : this.attribute("y1").toPixels("y"),
            a = "objectBoundingBox" == this.gradientUnits() ? i.x() + i.width() * this.attribute("x2").numValue() : this.attribute("x2").toPixels("x"),
            r = "objectBoundingBox" == this.gradientUnits() ? i.y() + i.height() * this.attribute("y2").numValue() : this.attribute("y2").toPixels("y");
          return n == a && s == r ? null : t.createLinearGradient(n, s, a, r);
        };
      }, D.Element.linearGradient.prototype = new D.Element.GradientBase(), D.Element.radialGradient = function (t) {
        this.base = D.Element.GradientBase, this.base(t), this.attributesToInherit.push("cx"), this.attributesToInherit.push("cy"), this.attributesToInherit.push("r"), this.attributesToInherit.push("fx"), this.attributesToInherit.push("fy"), this.attributesToInherit.push("fr"), this.getGradient = function (t, e) {
          var i = e.getBoundingBox(t);
          this.attribute("cx").hasValue() || (this.attribute("cx", !0).value = "50%"), this.attribute("cy").hasValue() || (this.attribute("cy", !0).value = "50%"), this.attribute("r").hasValue() || (this.attribute("r", !0).value = "50%");
          var n = "objectBoundingBox" == this.gradientUnits() ? i.x() + i.width() * this.attribute("cx").numValue() : this.attribute("cx").toPixels("x"),
            s = "objectBoundingBox" == this.gradientUnits() ? i.y() + i.height() * this.attribute("cy").numValue() : this.attribute("cy").toPixels("y"),
            a = n,
            r = s;
          this.attribute("fx").hasValue() && (a = "objectBoundingBox" == this.gradientUnits() ? i.x() + i.width() * this.attribute("fx").numValue() : this.attribute("fx").toPixels("x")), this.attribute("fy").hasValue() && (r = "objectBoundingBox" == this.gradientUnits() ? i.y() + i.height() * this.attribute("fy").numValue() : this.attribute("fy").toPixels("y"));
          var o = "objectBoundingBox" == this.gradientUnits() ? (i.width() + i.height()) / 2 * this.attribute("r").numValue() : this.attribute("r").toPixels(),
            h = this.attribute("fr").toPixels();
          return t.createRadialGradient(a, r, h, n, s, o);
        };
      }, D.Element.radialGradient.prototype = new D.Element.GradientBase(), D.Element.stop = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.offset = this.attribute("offset").numValue(), this.offset < 0 && (this.offset = 0), 1 < this.offset && (this.offset = 1);
        var e = this.style("stop-color", !0);
        "" === e.value && (e.value = "#000"), this.style("stop-opacity").hasValue() && (e = e.addOpacity(this.style("stop-opacity"))), this.color = e.value;
      }, D.Element.stop.prototype = new D.Element.ElementBase(), D.Element.AnimateBase = function (t) {
        this.base = D.Element.ElementBase, this.base(t), D.Animations.push(this), this.duration = 0, this.begin = this.attribute("begin").toMilliseconds(), this.maxDuration = this.begin + this.attribute("dur").toMilliseconds(), this.getProperty = function () {
          var t = this.attribute("attributeType").value,
            e = this.attribute("attributeName").value;
          return "CSS" == t ? this.parent.style(e, !0) : this.parent.attribute(e, !0);
        }, this.initialValue = null, this.initialUnits = "", this.removed = !1, this.calcValue = function () {
          return "";
        }, this.update = function (t) {
          if (null == this.initialValue && (this.initialValue = this.getProperty().value, this.initialUnits = this.getProperty().getUnits()), this.duration > this.maxDuration) {
            if ("indefinite" == this.attribute("repeatCount").value || "indefinite" == this.attribute("repeatDur").value) this.duration = 0;else if ("freeze" != this.attribute("fill").valueOrDefault("remove") || this.frozen) {
              if ("remove" == this.attribute("fill").valueOrDefault("remove") && !this.removed) return this.removed = !0, this.getProperty().value = this.parent.animationFrozen ? this.parent.animationFrozenValue : this.initialValue, !0;
            } else this.frozen = !0, this.parent.animationFrozen = !0, this.parent.animationFrozenValue = this.getProperty().value;
            return !1;
          }
          this.duration = this.duration + t;
          var e = !1;
          if (this.begin < this.duration) {
            var i = this.calcValue();
            if (this.attribute("type").hasValue()) i = this.attribute("type").value + "(" + i + ")";
            this.getProperty().value = i, e = !0;
          }
          return e;
        }, this.from = this.attribute("from"), this.to = this.attribute("to"), this.values = this.attribute("values"), this.values.hasValue() && (this.values.value = this.values.value.split(";")), this.progress = function () {
          var t = {
            progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
          };
          if (this.values.hasValue()) {
            var e = t.progress * (this.values.value.length - 1),
              i = Math.floor(e),
              n = Math.ceil(e);
            t.from = new D.Property("from", parseFloat(this.values.value[i])), t.to = new D.Property("to", parseFloat(this.values.value[n])), t.progress = (e - i) / (n - i);
          } else t.from = this.from, t.to = this.to;
          return t;
        };
      }, D.Element.AnimateBase.prototype = new D.Element.ElementBase(), D.Element.animate = function (t) {
        this.base = D.Element.AnimateBase, this.base(t), this.calcValue = function () {
          var t = this.progress(),
            e = t.from.numValue() + (t.to.numValue() - t.from.numValue()) * t.progress;
          return "%" === this.initialUnits && (e *= 100), e + this.initialUnits;
        };
      }, D.Element.animate.prototype = new D.Element.AnimateBase(), D.Element.animateColor = function (t) {
        this.base = D.Element.AnimateBase, this.base(t), this.calcValue = function () {
          var t = this.progress(),
            e = new y(t.from.value),
            i = new y(t.to.value);
          if (e.ok && i.ok) {
            var n = e.r + (i.r - e.r) * t.progress,
              s = e.g + (i.g - e.g) * t.progress,
              a = e.b + (i.b - e.b) * t.progress;
            return "rgb(" + parseInt(n, 10) + "," + parseInt(s, 10) + "," + parseInt(a, 10) + ")";
          }
          return this.attribute("from").value;
        };
      }, D.Element.animateColor.prototype = new D.Element.AnimateBase(), D.Element.animateTransform = function (t) {
        this.base = D.Element.AnimateBase, this.base(t), this.calcValue = function () {
          for (var t = this.progress(), e = D.ToNumberArray(t.from.value), i = D.ToNumberArray(t.to.value), n = "", s = 0; s < e.length; s++) n += e[s] + (i[s] - e[s]) * t.progress + " ";
          return n;
        };
      }, D.Element.animateTransform.prototype = new D.Element.animate(), D.Element.font = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.horizAdvX = this.attribute("horiz-adv-x").numValue(), this.isRTL = !1, this.isArabic = !1, this.fontFace = null, this.missingGlyph = null, this.glyphs = [];
        for (var e = 0; e < this.children.length; e++) {
          var i = this.children[e];
          "font-face" == i.type ? (this.fontFace = i).style("font-family").hasValue() && (D.Definitions[i.style("font-family").value] = this) : "missing-glyph" == i.type ? this.missingGlyph = i : "glyph" == i.type && ("" != i.arabicForm ? (this.isRTL = !0, this.isArabic = !0, void 0 === this.glyphs[i.unicode] && (this.glyphs[i.unicode] = []), this.glyphs[i.unicode][i.arabicForm] = i) : this.glyphs[i.unicode] = i);
        }
        this.render = function () {};
      }, D.Element.font.prototype = new D.Element.ElementBase(), D.Element.fontface = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.ascent = this.attribute("ascent").value, this.descent = this.attribute("descent").value, this.unitsPerEm = this.attribute("units-per-em").numValue();
      }, D.Element.fontface.prototype = new D.Element.ElementBase(), D.Element.missingglyph = function (t) {
        this.base = D.Element.path, this.base(t), this.horizAdvX = 0;
      }, D.Element.missingglyph.prototype = new D.Element.path(), D.Element.glyph = function (t) {
        this.base = D.Element.path, this.base(t), this.horizAdvX = this.attribute("horiz-adv-x").numValue(), this.unicode = this.attribute("unicode").value, this.arabicForm = this.attribute("arabic-form").value;
      }, D.Element.glyph.prototype = new D.Element.path(), D.Element.text = function (t) {
        this.captureTextNodes = !0, this.base = D.Element.RenderedElementBase, this.base(t), this.baseSetContext = this.setContext, this.setContext = function (t) {
          this.baseSetContext(t);
          var e = this.style("dominant-baseline").toTextBaseline();
          null == e && (e = this.style("alignment-baseline").toTextBaseline()), null != e && (t.textBaseline = e);
        }, this.initializeCoordinates = function (t) {
          this.x = this.attribute("x").toPixels("x"), this.y = this.attribute("y").toPixels("y"), this.attribute("dx").hasValue() && (this.x += this.attribute("dx").toPixels("x")), this.attribute("dy").hasValue() && (this.y += this.attribute("dy").toPixels("y")), this.x += this.getAnchorDelta(t, this, 0);
        }, this.getBoundingBox = function (t) {
          this.initializeCoordinates(t);
          for (var e = null, i = 0; i < this.children.length; i++) {
            var n = this.getChildBoundingBox(t, this, this, i);
            null == e ? e = n : e.addBoundingBox(n);
          }
          return e;
        }, this.renderChildren = function (t) {
          this.initializeCoordinates(t);
          for (var e = 0; e < this.children.length; e++) this.renderChild(t, this, this, e);
          D.Mouse.checkBoundingBox(this, this.getBoundingBox(t));
        }, this.getAnchorDelta = function (t, e, i) {
          var n = this.style("text-anchor").valueOrDefault("start");
          if ("start" == n) return 0;
          for (var s = 0, a = i; a < e.children.length; a++) {
            var r = e.children[a];
            if (i < a && r.attribute("x").hasValue()) break;
            s += r.measureTextRecursive(t);
          }
          return -1 * ("end" == n ? s : s / 2);
        }, this.adjustChildCoordinates = function (t, e, i, n) {
          var s = i.children[n];
          if ("function" != typeof s.measureText) return s;
          if (s.attribute("x").hasValue()) {
            s.x = s.attribute("x").toPixels("x") + e.getAnchorDelta(t, i, n);
            var a = s.attribute("text-anchor").valueOrDefault("start");
            if ("start" !== a) {
              var r = s.measureTextRecursive(t);
              s.x += -1 * ("end" == a ? r : r / 2);
            }
            s.attribute("dx").hasValue() && (s.x += s.attribute("dx").toPixels("x"));
          } else s.attribute("dx").hasValue() && (e.x += s.attribute("dx").toPixels("x")), s.x = e.x;
          return e.x = s.x + s.measureText(t), s.attribute("y").hasValue() ? (s.y = s.attribute("y").toPixels("y"), s.attribute("dy").hasValue() && (s.y += s.attribute("dy").toPixels("y"))) : (s.attribute("dy").hasValue() && (e.y += s.attribute("dy").toPixels("y")), s.y = e.y), e.y = s.y, s;
        }, this.getChildBoundingBox = function (t, e, i, n) {
          var s = this.adjustChildCoordinates(t, e, i, n),
            a = s.getBoundingBox(t);
          for (n = 0; n < s.children.length; n++) {
            var r = e.getChildBoundingBox(t, e, s, n);
            a.addBoundingBox(r);
          }
          return a;
        }, this.renderChild = function (t, e, i, n) {
          var s = this.adjustChildCoordinates(t, e, i, n);
          s.render(t);
          for (n = 0; n < s.children.length; n++) e.renderChild(t, e, s, n);
        };
      }, D.Element.text.prototype = new D.Element.RenderedElementBase(), D.Element.TextElementBase = function (t) {
        this.base = D.Element.RenderedElementBase, this.base(t), this.getGlyph = function (t, e, i) {
          var n = e[i],
            s = null;
          if (t.isArabic) {
            var a = "isolated";
            (0 == i || " " == e[i - 1]) && i < e.length - 2 && " " != e[i + 1] && (a = "terminal"), 0 < i && " " != e[i - 1] && i < e.length - 2 && " " != e[i + 1] && (a = "medial"), 0 < i && " " != e[i - 1] && (i == e.length - 1 || " " == e[i + 1]) && (a = "initial"), void 0 !== t.glyphs[n] && null == (s = t.glyphs[n][a]) && "glyph" == t.glyphs[n].type && (s = t.glyphs[n]);
          } else s = t.glyphs[n];
          return null == s && (s = t.missingGlyph), s;
        }, this.renderChildren = function (t) {
          var e = this.parent.style("font-family").getDefinition();
          if (null == e) "stroke" == t.paintOrder ? ("" != t.strokeStyle && t.strokeText(D.compressSpaces(this.getText()), this.x, this.y), "" != t.fillStyle && t.fillText(D.compressSpaces(this.getText()), this.x, this.y)) : ("" != t.fillStyle && t.fillText(D.compressSpaces(this.getText()), this.x, this.y), "" != t.strokeStyle && t.strokeText(D.compressSpaces(this.getText()), this.x, this.y));else {
            var i = this.parent.style("font-size").numValueOrDefault(D.Font.Parse(D.ctx.font).fontSize),
              n = this.parent.style("font-style").valueOrDefault(D.Font.Parse(D.ctx.font).fontStyle),
              s = this.getText();
            e.isRTL && (s = s.split("").reverse().join(""));
            for (var a = D.ToNumberArray(this.parent.attribute("dx").value), r = 0; r < s.length; r++) {
              var o = this.getGlyph(e, s, r),
                h = i / e.fontFace.unitsPerEm;
              t.translate(this.x, this.y), t.scale(h, -h);
              var l = t.lineWidth;
              t.lineWidth = t.lineWidth * e.fontFace.unitsPerEm / i, "italic" == n && t.transform(1, 0, .4, 1, 0, 0), o.render(t), "italic" == n && t.transform(1, 0, -.4, 1, 0, 0), t.lineWidth = l, t.scale(1 / h, -1 / h), t.translate(-this.x, -this.y), this.x += i * (o.horizAdvX || e.horizAdvX) / e.fontFace.unitsPerEm, void 0 === a[r] || isNaN(a[r]) || (this.x += a[r]);
            }
          }
        }, this.getText = function () {}, this.measureTextRecursive = function (t) {
          for (var e = this.measureText(t), i = 0; i < this.children.length; i++) e += this.children[i].measureTextRecursive(t);
          return e;
        }, this.measureText = function (t) {
          var e = this.parent.style("font-family").getDefinition();
          if (null != e) {
            var i = this.parent.style("font-size").numValueOrDefault(D.Font.Parse(D.ctx.font).fontSize),
              n = 0,
              s = this.getText();
            e.isRTL && (s = s.split("").reverse().join(""));
            for (var a = D.ToNumberArray(this.parent.attribute("dx").value), r = 0; r < s.length; r++) {
              n += (this.getGlyph(e, s, r).horizAdvX || e.horizAdvX) * i / e.fontFace.unitsPerEm, void 0 === a[r] || isNaN(a[r]) || (n += a[r]);
            }
            return n;
          }
          var o = D.compressSpaces(this.getText());
          if (!t.measureText) return 10 * o.length;
          t.save(), this.setContext(t, !0);
          var h = t.measureText(o).width;
          return t.restore(), h;
        }, this.getBoundingBox = function (t) {
          var e = this.parent.style("font-size").numValueOrDefault(D.Font.Parse(D.ctx.font).fontSize);
          return new D.BoundingBox(this.x, this.y - e, this.x + this.measureText(t), this.y);
        };
      }, D.Element.TextElementBase.prototype = new D.Element.RenderedElementBase(), D.Element.tspan = function (t) {
        this.captureTextNodes = !0, this.base = D.Element.TextElementBase, this.base(t), this.text = D.compressSpaces(t.value || t.text || t.textContent || ""), this.getText = function () {
          return 0 < this.children.length ? "" : this.text;
        };
      }, D.Element.tspan.prototype = new D.Element.TextElementBase(), D.Element.tref = function (t) {
        this.base = D.Element.TextElementBase, this.base(t), this.getText = function () {
          var t = this.getHrefAttribute().getDefinition();
          if (null != t) return t.children[0].getText();
        };
      }, D.Element.tref.prototype = new D.Element.TextElementBase(), D.Element.a = function (t) {
        this.base = D.Element.TextElementBase, this.base(t), this.hasText = 0 < t.childNodes.length;
        for (var e = 0; e < t.childNodes.length; e++) 3 != t.childNodes[e].nodeType && (this.hasText = !1);
        this.text = this.hasText ? t.childNodes[0].value || t.childNodes[0].data : "", this.getText = function () {
          return this.text;
        }, this.baseRenderChildren = this.renderChildren, this.renderChildren = function (t) {
          if (this.hasText) {
            this.baseRenderChildren(t);
            var e = new D.Property("fontSize", D.Font.Parse(D.ctx.font).fontSize);
            D.Mouse.checkBoundingBox(this, new D.BoundingBox(this.x, this.y - e.toPixels("y"), this.x + this.measureText(t), this.y));
          } else if (0 < this.children.length) {
            var i = new D.Element.g();
            i.children = this.children, i.parent = this, i.render(t);
          }
        }, this.onclick = function () {
          l.open(this.getHrefAttribute().value);
        }, this.onmousemove = function () {
          D.ctx.canvas.style.cursor = "pointer";
        };
      }, D.Element.a.prototype = new D.Element.TextElementBase(), D.Element.textPath = function (t) {
        this.base = D.Element.TextElementBase, this.base(t);
        var e = this.getHrefAttribute().getDefinition();
        this.text = D.compressSpaces(t.value || t.text || t.textContent || ""), this.renderChildren = function (t) {
          this.setTextData(t), t.save();
          var e = this.parent.style("text-decoration").value,
            i = this.fontSize(),
            n = this.glyphInfo,
            s = t.fillStyle;
          "underline" === e && t.beginPath();
          for (var a = 0; a < n.length; a++) {
            var r = n[a].p0,
              o = n[a].p1,
              h = n[a].text;
            t.save(), t.translate(r.x, r.y), t.rotate(n[a].rotation), "" != t.fillStyle && t.fillText(D.compressSpaces(h), 0, 0), "" != t.strokeStyle && t.strokeText(D.compressSpaces(h), 0, 0), t.restore(), "underline" === e && (0 === a && t.moveTo(r.x, r.y + i / 8), t.lineTo(o.x, o.y + i / 5));
          }
          "underline" === e && (t.lineWidth = i / 20, t.strokeStyle = s, t.stroke(), t.closePath()), t.restore();
        }, this.path = function (t) {
          var e = this.dataArray;
          null != t && t.beginPath();
          for (var i = 0; i < e.length; i++) {
            var n = e[i].command,
              s = e[i].points;
            switch (n) {
              case "L":
                null != t && t.lineTo(s[0], s[1]);
                break;
              case "M":
                null != t && t.moveTo(s[0], s[1]);
                break;
              case "C":
                null != t && t.bezierCurveTo(s[0], s[1], s[2], s[3], s[4], s[5]);
                break;
              case "Q":
                null != t && t.quadraticCurveTo(s[0], s[1], s[2], s[3]);
                break;
              case "A":
                var a = s[0],
                  r = s[1],
                  o = s[2],
                  h = s[3],
                  l = s[4],
                  u = s[5],
                  c = s[6],
                  f = s[7],
                  p = h < o ? o : h,
                  d = h < o ? 1 : o / h,
                  m = h < o ? h / o : 1;
                null != t && (t.translate(a, r), t.rotate(c), t.scale(d, m), t.arc(0, 0, p, l, l + u, 1 - f), t.scale(1 / d, 1 / m), t.rotate(-c), t.translate(-a, -r));
                break;
              case "z":
                null != t && t.closePath();
            }
          }
        }, this.getText = function () {
          return this.text;
        }, this.fontSize = function () {
          return this.parent.style("font-size").numValueOrDefault(D.Font.Parse(D.ctx.font).fontSize);
        }, this.measureText = function (t, e) {
          var i = this.parent.style("font-family").getDefinition();
          if (e = e || this.getText(), null != i) {
            var n = this.fontSize(),
              s = 0;
            i.isRTL && (e = e.split("").reverse().join(""));
            for (var a = D.ToNumberArray(this.parent.attribute("dx").value), r = 0; r < e.length; r++) {
              s += (this.getGlyph(i, e, r).horizAdvX || i.horizAdvX) * n / i.fontFace.unitsPerEm, void 0 === a[r] || isNaN(a[r]) || (s += a[r]);
            }
            return s;
          }
          var o = D.compressSpaces(e);
          if (!t.measureText) return 10 * o.length;
          t.save(), this.setContext(t);
          var h = t.measureText(o).width;
          return t.restore(), h;
        }, this.setTextData = function (r) {
          if (!this.hasOwnProperty("glyphInfo")) {
            var o = this,
              t = this.getText().split(""),
              h = this.getText().split(" ").length - 1,
              e = D.ToNumberArray(this.parent.attribute("dx").valueOrDefault("0")),
              i = 0,
              l = this.parent.style("text-anchor").valueOrDefault("start"),
              n = this.style("letter-spacing"),
              s = this.parent.style("letter-spacing");
            n.hasValue() && "inherit" !== n.getValue() ? n.hasValue() && "initial" !== n.getValue() && "unset" !== n.getValue() && (i = n.toPixels()) : i = s.toPixels(), this.letterSpacingCache = [];
            for (var a = 0; a < this.getText().length; a++) this.letterSpacingCache.push(void 0 !== e[a] ? e[a] : i);
            var u = this.letterSpacingCache.reduce(function (t, e) {
              return t + e || 0;
            }, 0);
            this.textWidth = this.measureText(r), this.textHeight = this.fontSize();
            var c = Math.max(this.textWidth + u, 0);
            this.glyphInfo = [];
            var f = this.getPathLength(),
              p = this.style("startOffset").numValueOrDefault(0) * f,
              d = 0;
            "middle" !== l && "center" !== l || (d = -c / 2), "end" !== l && "right" !== l || (d = -c), d += p;
            var m = function (t, e) {
              var i,
                n = o.measureText(r, t);
              " " === t && "justify" === l && c < f && (n += (f - c) / h), -1 < e && (d += (i = (i = e) || 0, o.letterSpacingCache[i] || 0));
              var s = o.textHeight / 20,
                a = {
                  p0: o.getEquidistantPointOnPath(d, s),
                  p1: o.getEquidistantPointOnPath(d + n, s)
                };
              return d += n, a;
            };
            for (a = 0; a < t.length; a++) {
              var y = m(t[a], a);
              if (void 0 !== y.p0 && void 0 !== y.p1) {
                var v = o.getLineLength(y.p0.x, y.p0.y, y.p1.x, y.p1.y),
                  g = o.getPointOnLine(0 + v / 2, y.p0.x, y.p0.y, y.p1.x, y.p1.y),
                  x = Math.atan2(y.p1.y - y.p0.y, y.p1.x - y.p0.x);
                this.glyphInfo.push({
                  transposeX: g.x,
                  transposeY: g.y,
                  text: t[a],
                  rotation: x,
                  p0: y.p0,
                  p1: y.p1
                });
              }
            }
          }
        }, this.parsePathData = function (t) {
          if (this.pathLength = void 0, !t) return [];
          var e = [],
            i = t.PathParser;
          for (i.reset(); !i.isEnd();) {
            var n = [],
              s = null,
              a = i.current ? i.current.x : 0,
              r = i.current ? i.current.y : 0;
            i.nextCommand();
            var o = i.command.toUpperCase();
            switch (i.command) {
              case "M":
              case "m":
                var h = i.getAsCurrentPoint();
                for (n.push(h.x, h.y), i.start = i.current; !i.isCommandOrEnd();) {
                  h = i.getAsCurrentPoint();
                  n.push(h.x, h.y), s = "L";
                }
                break;
              case "L":
              case "l":
                for (; !i.isCommandOrEnd();) {
                  h = i.getAsCurrentPoint();
                  n.push(h.x, h.y);
                }
                s = "L";
                break;
              case "H":
              case "h":
                for (; !i.isCommandOrEnd();) {
                  var l = new D.Point((i.isRelativeCommand() ? i.current.x : 0) + i.getScalar(), i.current.y);
                  n.push(l.x, l.y), i.current = l;
                }
                s = "L";
                break;
              case "V":
              case "v":
                for (; !i.isCommandOrEnd();) {
                  l = new D.Point(i.current.x, (i.isRelativeCommand() ? i.current.y : 0) + i.getScalar());
                  n.push(l.x, l.y), i.current = l;
                }
                s = "L";
                break;
              case "C":
              case "c":
                for (; !i.isCommandOrEnd();) {
                  var u = i.getPoint(),
                    c = i.getAsControlPoint(),
                    f = i.getAsCurrentPoint();
                  n.push(u.x, u.y, c.x, c.y, f.x, f.y);
                }
                break;
              case "S":
              case "s":
                for (; !i.isCommandOrEnd();) {
                  u = i.getReflectedControlPoint(), c = i.getAsControlPoint(), f = i.getAsCurrentPoint();
                  n.push(u.x, u.y, c.x, c.y, f.x, f.y);
                }
                s = "C";
                break;
              case "Q":
              case "q":
                for (; !i.isCommandOrEnd();) {
                  c = i.getAsControlPoint(), f = i.getAsCurrentPoint();
                  n.push(c.x, c.y, f.x, f.y);
                }
                break;
              case "T":
              case "t":
                for (; !i.isCommandOrEnd();) {
                  c = i.getReflectedControlPoint();
                  i.control = c;
                  f = i.getAsCurrentPoint();
                  n.push(c.x, c.y, f.x, f.y);
                }
                s = "Q";
                break;
              case "A":
              case "a":
                for (; !i.isCommandOrEnd();) {
                  var p = i.current,
                    d = i.getScalar(),
                    m = i.getScalar(),
                    y = i.getScalar() * (Math.PI / 180),
                    v = i.getScalar(),
                    g = i.getScalar(),
                    x = (f = i.getAsCurrentPoint(), new D.Point(Math.cos(y) * (p.x - f.x) / 2 + Math.sin(y) * (p.y - f.y) / 2, -Math.sin(y) * (p.x - f.x) / 2 + Math.cos(y) * (p.y - f.y) / 2)),
                    b = Math.pow(x.x, 2) / Math.pow(d, 2) + Math.pow(x.y, 2) / Math.pow(m, 2);
                  1 < b && (d *= Math.sqrt(b), m *= Math.sqrt(b));
                  var P = (v == g ? -1 : 1) * Math.sqrt((Math.pow(d, 2) * Math.pow(m, 2) - Math.pow(d, 2) * Math.pow(x.y, 2) - Math.pow(m, 2) * Math.pow(x.x, 2)) / (Math.pow(d, 2) * Math.pow(x.y, 2) + Math.pow(m, 2) * Math.pow(x.x, 2)));
                  isNaN(P) && (P = 0);
                  var E = new D.Point(P * d * x.y / m, P * -m * x.x / d),
                    w = new D.Point((p.x + f.x) / 2 + Math.cos(y) * E.x - Math.sin(y) * E.y, (p.y + f.y) / 2 + Math.sin(y) * E.x + Math.cos(y) * E.y),
                    C = function (t) {
                      return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2));
                    },
                    B = function (t, e) {
                      return (t[0] * e[0] + t[1] * e[1]) / (C(t) * C(e));
                    },
                    M = function (t, e) {
                      return (t[0] * e[1] < t[1] * e[0] ? -1 : 1) * Math.acos(B(t, e));
                    },
                    T = M([1, 0], [(x.x - E.x) / d, (x.y - E.y) / m]),
                    S = [(x.x - E.x) / d, (x.y - E.y) / m],
                    V = [(-x.x - E.x) / d, (-x.y - E.y) / m],
                    k = M(S, V);
                  B(S, V) <= -1 && (k = Math.PI), 1 <= B(S, V) && (k = 0), 0 === g && 0 < k && (k -= 2 * Math.PI), 1 === g && k < 0 && (k += 2 * Math.PI), n = [w.x, w.y, d, m, T, k, y, g];
                }
                break;
              case "Z":
              case "z":
                i.current = i.start;
            }
            "Z" !== o ? e.push({
              command: s || o,
              points: n,
              start: {
                x: a,
                y: r
              },
              pathLength: this.calcLength(a, r, s || o, n)
            }) : e.push({
              command: "z",
              points: [],
              start: void 0,
              pathLength: 0
            });
          }
          return e;
        }, this.getPathLength = function () {
          if (void 0 === this.pathLength || null === this.pathLength || isNaN(this.pathLength)) for (var t = this.pathLength = 0; t < this.dataArray.length; t++) 0 < this.dataArray[t].pathLength && (this.pathLength += this.dataArray[t].pathLength);
          return this.pathLength;
        }, this.getPointOnPath = function (t) {
          var e = 0,
            i = this.getPathLength(),
            n = void 0;
          if (!(t < -5e-5 || i < t - 5e-5)) for (var s = 0; s < this.dataArray.length; s++) {
            var a = this.dataArray[s];
            if (!a || !(a.pathLength < 5e-5 || e + a.pathLength + 5e-5 < t)) {
              var r = t - e,
                o = void 0;
              switch (a.command) {
                case "L":
                  n = this.getPointOnLine(r, a.start.x, a.start.y, a.points[0], a.points[1], a.start.x, a.start.y);
                  break;
                case "A":
                  var h = a.points[4],
                    l = a.points[5],
                    u = a.points[4] + l;
                  if (o = h + r / a.pathLength * l, l < 0 && o < u || 0 <= l && u < o) break;
                  n = this.getPointOnEllipticalArc(a.points[0], a.points[1], a.points[2], a.points[3], o, a.points[6]);
                  break;
                case "C":
                  1 < (o = r / a.pathLength) && (o = 1), n = this.getPointOnCubicBezier(o, a.start.x, a.start.y, a.points[0], a.points[1], a.points[2], a.points[3], a.points[4], a.points[5]);
                  break;
                case "Q":
                  1 < (o = r / a.pathLength) && (o = 1), n = this.getPointOnQuadraticBezier(o, a.start.x, a.start.y, a.points[0], a.points[1], a.points[2], a.points[3]);
              }
              if (void 0 !== n && n !== {}) return n;
              break;
            }
            e += a.pathLength;
          }
        }, this.buildEquidistantCache = function (t, e) {
          var i = this.getPathLength();
          if (e = e || .25, t = t || i / 100, this.equidistantCache = this.equidistantCache || {}, !this.equidistantCache.hasOwnProperty("points") || this.equidistantCache.step != t || this.equidistantCache.precision != e) {
            this.equidistantCache = {
              step: t,
              precision: e,
              points: []
            };
            for (var n = 0, s = 0; s <= i; s += e) {
              var a = this.getPointOnPath(s),
                r = this.getPointOnPath(s + e);
              void 0 !== a && void 0 !== r && t <= (n += this.getLineLength(a.x, a.y, r.x, r.y)) && (this.equidistantCache.points.push({
                x: a.x,
                y: a.y,
                distance: s
              }), n -= t);
            }
          }
        }, this.getEquidistantPointOnPath = function (t, e, i) {
          if (this.buildEquidistantCache(e, i), !(t < 0 || 5e-5 < t - this.getPathLength())) {
            var n = Math.round(t / this.getPathLength() * (this.equidistantCache.points.length - 1));
            return this.equidistantCache.points[n] || void 0;
          }
        }, this.getLineLength = function (t, e, i, n) {
          return Math.sqrt((i - t) * (i - t) + (n - e) * (n - e));
        }, this.getPointOnLine = function (t, e, i, n, s, a, r) {
          void 0 === a && (a = e), void 0 === r && (r = i);
          var o = (s - i) / (n - e + 1e-8),
            h = Math.sqrt(t * t / (1 + o * o));
          n < e && (h *= -1);
          var l,
            u = o * h;
          if (n === e) l = {
            x: a,
            y: r + u
          };else if ((r - i) / (a - e + 1e-8) === o) l = {
            x: a + h,
            y: r + u
          };else {
            var c,
              f,
              p = this.getLineLength(e, i, n, s);
            if (p < 1e-8) return;
            var d = (a - e) * (n - e) + (r - i) * (s - i);
            c = e + (d /= p * p) * (n - e), f = i + d * (s - i);
            var m = this.getLineLength(a, r, c, f),
              y = Math.sqrt(t * t - m * m);
            h = Math.sqrt(y * y / (1 + o * o)), n < e && (h *= -1), l = {
              x: c + h,
              y: f + (u = o * h)
            };
          }
          return l;
        }, this.getPointOnCubicBezier = function (t, e, i, n, s, a, r, o, h) {
          function l(t) {
            return t * t * t;
          }
          function u(t) {
            return 3 * t * t * (1 - t);
          }
          function c(t) {
            return 3 * t * (1 - t) * (1 - t);
          }
          function f(t) {
            return (1 - t) * (1 - t) * (1 - t);
          }
          return {
            x: o * l(t) + a * u(t) + n * c(t) + e * f(t),
            y: h * l(t) + r * u(t) + s * c(t) + i * f(t)
          };
        }, this.getPointOnQuadraticBezier = function (t, e, i, n, s, a, r) {
          function o(t) {
            return t * t;
          }
          function h(t) {
            return 2 * t * (1 - t);
          }
          function l(t) {
            return (1 - t) * (1 - t);
          }
          return {
            x: a * o(t) + n * h(t) + e * l(t),
            y: r * o(t) + s * h(t) + i * l(t)
          };
        }, this.getPointOnEllipticalArc = function (t, e, i, n, s, a) {
          var r = Math.cos(a),
            o = Math.sin(a),
            h = i * Math.cos(s),
            l = n * Math.sin(s);
          return {
            x: t + (h * r - l * o),
            y: e + (h * o + l * r)
          };
        }, this.calcLength = function (t, e, i, n) {
          var s, a, r, o;
          switch (i) {
            case "L":
              return this.getLineLength(t, e, n[0], n[1]);
            case "C":
              for (s = 0, a = this.getPointOnCubicBezier(0, t, e, n[0], n[1], n[2], n[3], n[4], n[5]), o = .01; o <= 1; o += .01) r = this.getPointOnCubicBezier(o, t, e, n[0], n[1], n[2], n[3], n[4], n[5]), s += this.getLineLength(a.x, a.y, r.x, r.y), a = r;
              return s;
            case "Q":
              for (s = 0, a = this.getPointOnQuadraticBezier(0, t, e, n[0], n[1], n[2], n[3]), o = .01; o <= 1; o += .01) r = this.getPointOnQuadraticBezier(o, t, e, n[0], n[1], n[2], n[3]), s += this.getLineLength(a.x, a.y, r.x, r.y), a = r;
              return s;
            case "A":
              s = 0;
              var h = n[4],
                l = n[5],
                u = n[4] + l,
                c = Math.PI / 180;
              if (Math.abs(h - u) < c && (c = Math.abs(h - u)), a = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], h, 0), l < 0) for (o = h - c; u < o; o -= c) r = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), s += this.getLineLength(a.x, a.y, r.x, r.y), a = r;else for (o = h + c; o < u; o += c) r = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], o, 0), s += this.getLineLength(a.x, a.y, r.x, r.y), a = r;
              return r = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], u, 0), s += this.getLineLength(a.x, a.y, r.x, r.y);
          }
          return 0;
        }, this.dataArray = this.parsePathData(e);
      }, D.Element.textPath.prototype = new D.Element.TextElementBase(), D.Element.image = function (t) {
        this.base = D.Element.RenderedElementBase, this.base(t);
        var e = this.getHrefAttribute().value;
        if ("" != e) {
          var a = e.match(/\.svg$/);
          if (D.Images.push(this), this.loaded = !1, a) this.img = D.ajax(e), this.loaded = !0;else {
            this.img = c.createElement("img"), 1 == D.opts.useCORS && (this.img.crossOrigin = "Anonymous");
            var r = this;
            this.img.onload = function () {
              r.loaded = !0;
            }, this.img.onerror = function () {
              D.log('ERROR: image "' + e + '" not found'), r.loaded = !0;
            }, this.img.src = e;
          }
          this.renderChildren = function (t) {
            var e = this.attribute("x").toPixels("x"),
              i = this.attribute("y").toPixels("y"),
              n = this.attribute("width").toPixels("x"),
              s = this.attribute("height").toPixels("y");
            0 != n && 0 != s && (t.save(), a ? t.drawSvg(this.img, e, i, n, s) : (t.translate(e, i), D.AspectRatio(t, this.attribute("preserveAspectRatio").value, n, this.img.width, s, this.img.height, 0, 0), r.loaded && (void 0 === this.img.complete || this.img.complete) && t.drawImage(this.img, 0, 0)), t.restore());
          }, this.getBoundingBox = function () {
            var t = this.attribute("x").toPixels("x"),
              e = this.attribute("y").toPixels("y"),
              i = this.attribute("width").toPixels("x"),
              n = this.attribute("height").toPixels("y");
            return new D.BoundingBox(t, e, t + i, e + n);
          };
        }
      }, D.Element.image.prototype = new D.Element.RenderedElementBase(), D.Element.g = function (t) {
        this.base = D.Element.RenderedElementBase, this.base(t), this.getBoundingBox = function (t) {
          for (var e = new D.BoundingBox(), i = 0; i < this.children.length; i++) e.addBoundingBox(this.children[i].getBoundingBox(t));
          return e;
        };
      }, D.Element.g.prototype = new D.Element.RenderedElementBase(), D.Element.symbol = function (t) {
        this.base = D.Element.RenderedElementBase, this.base(t), this.render = function () {};
      }, D.Element.symbol.prototype = new D.Element.RenderedElementBase(), D.ParseExternalUrl = function (t) {
        var e = t.match(/url\(('([^']+)'|"([^"]+)"|([^'"\)]+))\)/) || [];
        return e[2] || e[3] || e[4];
      }, D.Element.style = function (t) {
        this.base = D.Element.ElementBase, this.base(t);
        for (var e = "", i = 0; i < t.childNodes.length; i++) e += t.childNodes[i].data;
        e = e.replace(/(\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "");
        var n = (e = D.compressSpaces(e)).split("}");
        for (i = 0; i < n.length; i++) if ("" != D.trim(n[i])) for (var s = n[i].split("{"), a = s[0].split(","), r = s[1].split(";"), o = 0; o < a.length; o++) {
          var h = D.trim(a[o]);
          if ("" != h) {
            for (var l = D.Styles[h] || {}, u = 0; u < r.length; u++) {
              var c = r[u].indexOf(":"),
                f = r[u].substr(0, c),
                p = r[u].substr(c + 1, r[u].length - c);
              null != f && null != p && (l[D.trim(f)] = new D.Property(D.trim(f), D.trim(p)));
            }
            if (D.Styles[h] = l, D.StylesSpecificity[h] = P(h), "@font-face" == h) for (var d = l["font-family"].value.replace(/"/g, ""), m = l.src.value.split(","), y = 0; y < m.length; y++) if (0 < m[y].indexOf('format("svg")')) {
              var v = D.ParseExternalUrl(m[y]);
              if (v) for (var g = D.parseXml(D.ajax(v)).getElementsByTagName("font"), x = 0; x < g.length; x++) {
                var b = D.CreateElement(g[x]);
                D.Definitions[d] = b;
              }
            }
          }
        }
      }, D.Element.style.prototype = new D.Element.ElementBase(), D.Element.use = function (t) {
        this.base = D.Element.RenderedElementBase, this.base(t), this.baseSetContext = this.setContext, this.setContext = function (t) {
          this.baseSetContext(t), this.attribute("x").hasValue() && t.translate(this.attribute("x").toPixels("x"), 0), this.attribute("y").hasValue() && t.translate(0, this.attribute("y").toPixels("y"));
        };
        var n = this.getHrefAttribute().getDefinition();
        this.path = function (t) {
          null != n && n.path(t);
        }, this.elementTransform = function () {
          if (null != n && n.style("transform", !1, !0).hasValue()) return new D.Transform(n.style("transform", !1, !0).value);
        }, this.getBoundingBox = function (t) {
          if (null != n) return n.getBoundingBox(t);
        }, this.renderChildren = function (t) {
          if (null != n) {
            var e = n;
            "symbol" == n.type && ((e = new D.Element.svg()).type = "svg", e.attributes.viewBox = new D.Property("viewBox", n.attribute("viewBox").value), e.attributes.preserveAspectRatio = new D.Property("preserveAspectRatio", n.attribute("preserveAspectRatio").value), e.attributes.overflow = new D.Property("overflow", n.attribute("overflow").value), e.children = n.children), "svg" == e.type && (this.attribute("width").hasValue() && (e.attributes.width = new D.Property("width", this.attribute("width").value)), this.attribute("height").hasValue() && (e.attributes.height = new D.Property("height", this.attribute("height").value)));
            var i = e.parent;
            e.parent = null, e.render(t), e.parent = i;
          }
        };
      }, D.Element.use.prototype = new D.Element.RenderedElementBase(), D.Element.mask = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.apply = function (t, e) {
          var i = this.attribute("x").toPixels("x"),
            n = this.attribute("y").toPixels("y"),
            s = this.attribute("width").toPixels("x"),
            a = this.attribute("height").toPixels("y");
          if (0 == s && 0 == a) {
            for (var r = new D.BoundingBox(), o = 0; o < this.children.length; o++) r.addBoundingBox(this.children[o].getBoundingBox(t));
            i = Math.floor(r.x1), n = Math.floor(r.y1), s = Math.floor(r.width()), a = Math.floor(r.height());
          }
          var h = e.style("mask").value;
          e.style("mask").value = "";
          var l = d(i + s, n + a),
            u = l.getContext("2d");
          D.SetDefaults(u), this.renderChildren(u), new D.Element.feColorMatrix({
            nodeType: 1,
            childNodes: [],
            attributes: [{
              nodeName: "type",
              value: "luminanceToAlpha"
            }, {
              nodeName: "includeOpacity",
              value: "true"
            }]
          }).apply(u, 0, 0, i + s, n + a);
          var c = d(i + s, n + a),
            f = c.getContext("2d");
          D.SetDefaults(f), e.render(f), f.globalCompositeOperation = "destination-in", f.fillStyle = u.createPattern(l, "no-repeat"), f.fillRect(0, 0, i + s, n + a), t.fillStyle = f.createPattern(c, "no-repeat"), t.fillRect(0, 0, i + s, n + a), e.style("mask").value = h;
        }, this.render = function () {};
      }, D.Element.mask.prototype = new D.Element.ElementBase(), D.Element.clipPath = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.apply = function (t) {
          var e = "undefined" != typeof CanvasRenderingContext2D,
            i = t.beginPath,
            n = t.closePath;
          e && (CanvasRenderingContext2D.prototype.beginPath = function () {}, CanvasRenderingContext2D.prototype.closePath = function () {}), i.call(t);
          for (var s = 0; s < this.children.length; s++) {
            var a = this.children[s];
            if (void 0 !== a.path) {
              var r = void 0 !== a.elementTransform && a.elementTransform();
              !r && a.style("transform", !1, !0).hasValue() && (r = new D.Transform(a.style("transform", !1, !0).value)), r && r.apply(t), a.path(t), e && (CanvasRenderingContext2D.prototype.closePath = n), r && r.unapply(t);
            }
          }
          n.call(t), t.clip(), e && (CanvasRenderingContext2D.prototype.beginPath = i, CanvasRenderingContext2D.prototype.closePath = n);
        }, this.render = function () {};
      }, D.Element.clipPath.prototype = new D.Element.ElementBase(), D.Element.filter = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.apply = function (t, e) {
          var i = e.getBoundingBox(t),
            n = Math.floor(i.x1),
            s = Math.floor(i.y1),
            a = Math.floor(i.width()),
            r = Math.floor(i.height()),
            o = e.style("filter").value;
          e.style("filter").value = "";
          for (var h = 0, l = 0, u = 0; u < this.children.length; u++) {
            var c = this.children[u].extraFilterDistance || 0;
            h = Math.max(h, c), l = Math.max(l, c);
          }
          var f = d(a + 2 * h, r + 2 * l),
            p = f.getContext("2d");
          D.SetDefaults(p), p.translate(-n + h, -s + l), e.render(p);
          for (u = 0; u < this.children.length; u++) "function" == typeof this.children[u].apply && this.children[u].apply(p, 0, 0, a + 2 * h, r + 2 * l);
          t.drawImage(f, 0, 0, a + 2 * h, r + 2 * l, n - h, s - l, a + 2 * h, r + 2 * l), e.style("filter", !0).value = o;
        }, this.render = function () {};
      }, D.Element.filter.prototype = new D.Element.ElementBase(), D.Element.feDropShadow = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.addStylesFromStyleDefinition(), this.apply = function () {};
      }, D.Element.feDropShadow.prototype = new D.Element.ElementBase(), D.Element.feMorphology = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.apply = function () {};
      }, D.Element.feMorphology.prototype = new D.Element.ElementBase(), D.Element.feComposite = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.apply = function () {};
      }, D.Element.feComposite.prototype = new D.Element.ElementBase(), D.Element.feColorMatrix = function (t) {
        this.base = D.Element.ElementBase, this.base(t);
        var n = D.ToNumberArray(this.attribute("values").value);
        switch (this.attribute("type").valueOrDefault("matrix")) {
          case "saturate":
            var e = n[0];
            n = [.213 + .787 * e, .715 - .715 * e, .072 - .072 * e, 0, 0, .213 - .213 * e, .715 + .285 * e, .072 - .072 * e, 0, 0, .213 - .213 * e, .715 - .715 * e, .072 + .928 * e, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
            break;
          case "hueRotate":
            var s = n[0] * Math.PI / 180,
              i = function (t, e, i) {
                return t + Math.cos(s) * e + Math.sin(s) * i;
              };
            n = [i(.213, .787, -.213), i(.715, -.715, -.715), i(.072, -.072, .928), 0, 0, i(.213, -.213, .143), i(.715, .285, .14), i(.072, -.072, -.283), 0, 0, i(.213, -.213, -.787), i(.715, -.715, .715), i(.072, .928, .072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
            break;
          case "luminanceToAlpha":
            n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, .2125, .7154, .0721, 0, 0, 0, 0, 0, 0, 1];
        }
        function d(t, e, i, n, s, a) {
          return t[i * n * 4 + 4 * e + a];
        }
        function m(t, e, i, n, s, a, r) {
          t[i * n * 4 + 4 * e + a] = r;
        }
        function y(t, e) {
          var i = n[t];
          return i * (i < 0 ? e - 255 : e);
        }
        var v = this.attribute("includeOpacity").hasValue();
        this.apply = function (t, e, i, n, s) {
          var a = t.getImageData(0, 0, n, s);
          for (i = 0; i < s; i++) for (e = 0; e < n; e++) {
            var r = d(a.data, e, i, n, 0, 0),
              o = d(a.data, e, i, n, 0, 1),
              h = d(a.data, e, i, n, 0, 2),
              l = d(a.data, e, i, n, 0, 3),
              u = y(0, r) + y(1, o) + y(2, h) + y(3, l) + y(4, 1),
              c = y(5, r) + y(6, o) + y(7, h) + y(8, l) + y(9, 1),
              f = y(10, r) + y(11, o) + y(12, h) + y(13, l) + y(14, 1),
              p = y(15, r) + y(16, o) + y(17, h) + y(18, l) + y(19, 1);
            v && (u = c = f = 0, p *= l / 255), m(a.data, e, i, n, 0, 0, u), m(a.data, e, i, n, 0, 1, c), m(a.data, e, i, n, 0, 2, f), m(a.data, e, i, n, 0, 3, p);
          }
          t.clearRect(0, 0, n, s), t.putImageData(a, 0, 0);
        };
      }, D.Element.feColorMatrix.prototype = new D.Element.ElementBase(), D.Element.feGaussianBlur = function (t) {
        this.base = D.Element.ElementBase, this.base(t), this.blurRadius = Math.floor(this.attribute("stdDeviation").numValue()), this.extraFilterDistance = this.blurRadius, this.apply = function (t, e, i, n, s) {
          v && void 0 !== v.canvasRGBA ? (t.canvas.id = D.UniqueId(), t.canvas.style.display = "none", c.body.appendChild(t.canvas), v.canvasRGBA(t.canvas, e, i, n, s, this.blurRadius), c.body.removeChild(t.canvas)) : D.log("ERROR: StackBlur.js must be included for blur to work");
        };
      }, D.Element.feGaussianBlur.prototype = new D.Element.ElementBase(), D.Element.title = function () {}, D.Element.title.prototype = new D.Element.ElementBase(), D.Element.desc = function () {}, D.Element.desc.prototype = new D.Element.ElementBase(), D.Element.MISSING = function (t) {
        D.log("ERROR: Element '" + t.nodeName + "' not yet implemented.");
      }, D.Element.MISSING.prototype = new D.Element.ElementBase(), D.CreateElement = function (t) {
        var e = t.nodeName.replace(/^[^:]+:/, "");
        e = e.replace(/\-/g, "");
        var i = null;
        return (i = void 0 !== D.Element[e] ? new D.Element[e](t) : new D.Element.MISSING(t)).type = t.nodeName, i;
      }, D.load = function (t, e) {
        D.loadXml(t, D.ajax(e));
      }, D.loadXml = function (t, e) {
        D.loadXmlDoc(t, D.parseXml(e));
      }, D.loadXmlDoc = function (a, r) {
        D.init(a);
        var i = function (t) {
          for (var e = a.canvas; e;) t.x -= e.offsetLeft, t.y -= e.offsetTop, e = e.offsetParent;
          return l.scrollX && (t.x += l.scrollX), l.scrollY && (t.y += l.scrollY), t;
        };
        1 != D.opts.ignoreMouse && (a.canvas.onclick = function (t) {
          var e = i(new D.Point(null != t ? t.clientX : event.clientX, null != t ? t.clientY : event.clientY));
          D.Mouse.onclick(e.x, e.y);
        }, a.canvas.onmousemove = function (t) {
          var e = i(new D.Point(null != t ? t.clientX : event.clientX, null != t ? t.clientY : event.clientY));
          D.Mouse.onmousemove(e.x, e.y);
        });
        var o = D.CreateElement(r.documentElement);
        o.root = !0, o.addStylesFromStyleDefinition();
        var h = !0,
          n = function () {
            D.ViewPort.Clear(), a.canvas.parentNode ? D.ViewPort.SetCurrent(a.canvas.parentNode.clientWidth, a.canvas.parentNode.clientHeight) : D.ViewPort.SetCurrent(800, 600), 1 != D.opts.ignoreDimensions && (h || null == D.opts.scaleWidth && null == D.opts.scaleHeight) && (o.style("width").hasValue() && (a.canvas.width = o.style("width").toPixels("x"), a.canvas.style && (a.canvas.style.width = a.canvas.width + "px")), o.style("height").hasValue() && (a.canvas.height = o.style("height").toPixels("y"), a.canvas.style && (a.canvas.style.height = a.canvas.height + "px")));
            var t = a.canvas.clientWidth || a.canvas.width,
              e = a.canvas.clientHeight || a.canvas.height;
            if (1 == D.opts.ignoreDimensions && o.style("width").hasValue() && o.style("height").hasValue() && (t = o.style("width").toPixels("x"), e = o.style("height").toPixels("y")), D.ViewPort.SetCurrent(t, e), null != D.opts.offsetX && (o.attribute("x", !0).value = D.opts.offsetX), null != D.opts.offsetY && (o.attribute("y", !0).value = D.opts.offsetY), null != D.opts.scaleWidth || null != D.opts.scaleHeight) {
              var i = null,
                n = null,
                s = D.ToNumberArray(o.attribute("viewBox").value);
              null != D.opts.scaleWidth && (o.attribute("width").hasValue() ? i = o.attribute("width").toPixels("x") / D.opts.scaleWidth : isNaN(s[2]) || (i = s[2] / D.opts.scaleWidth)), null != D.opts.scaleHeight && (o.attribute("height").hasValue() ? n = o.attribute("height").toPixels("y") / D.opts.scaleHeight : isNaN(s[3]) || (n = s[3] / D.opts.scaleHeight)), null == i && (i = n), null == n && (n = i), o.attribute("width", !0).value = D.opts.scaleWidth, o.attribute("height", !0).value = D.opts.scaleHeight, o.style("transform", !0, !0).value += " scale(" + 1 / i + "," + 1 / n + ")";
            }
            1 != D.opts.ignoreClear && a.clearRect(0, 0, t, e), o.render(a), h && (h = !1, "function" == typeof D.opts.renderCallback && D.opts.renderCallback(r));
          },
          s = !0;
        D.ImagesLoaded() && (s = !1, n()), D.intervalID = setInterval(function () {
          var t = !1;
          if (s && D.ImagesLoaded() && (t = !(s = !1)), 1 != D.opts.ignoreMouse && (t = t || D.Mouse.hasEvents()), 1 != D.opts.ignoreAnimation) for (var e = 0; e < D.Animations.length; e++) {
            var i = D.Animations[e].update(1e3 / D.FRAMERATE);
            t = t || i;
          }
          "function" == typeof D.opts.forceRedraw && 1 == D.opts.forceRedraw() && (t = !0), t && (n(), D.Mouse.runEvents());
        }, 1e3 / D.FRAMERATE);
      }, D.stop = function () {
        D.intervalID && clearInterval(D.intervalID);
      }, D.Mouse = new function () {
        this.events = [], this.hasEvents = function () {
          return 0 != this.events.length;
        }, this.onclick = function (t, e) {
          this.events.push({
            type: "onclick",
            x: t,
            y: e,
            run: function (t) {
              t.onclick && t.onclick();
            }
          });
        }, this.onmousemove = function (t, e) {
          this.events.push({
            type: "onmousemove",
            x: t,
            y: e,
            run: function (t) {
              t.onmousemove && t.onmousemove();
            }
          });
        }, this.eventElements = [], this.checkPath = function (t, e) {
          for (var i = 0; i < this.events.length; i++) {
            var n = this.events[i];
            e.isPointInPath && e.isPointInPath(n.x, n.y) && (this.eventElements[i] = t);
          }
        }, this.checkBoundingBox = function (t, e) {
          if (e) for (var i = 0; i < this.events.length; i++) {
            var n = this.events[i];
            e.isPointInBox(n.x, n.y) && (this.eventElements[i] = t);
          }
        }, this.runEvents = function () {
          D.ctx.canvas.style.cursor = "";
          for (var t = 0; t < this.events.length; t++) for (var e = this.events[t], i = this.eventElements[t]; i;) e.run(i), i = i.parent;
          this.events = [], this.eventElements = [];
        };
      }(), D;
    }
    "undefined" != typeof CanvasRenderingContext2D && (CanvasRenderingContext2D.prototype.drawSvg = function (t, e, i, n, s, a) {
      var r = {
        ignoreMouse: !0,
        ignoreAnimation: !0,
        ignoreDimensions: !0,
        ignoreClear: !0,
        offsetX: e,
        offsetY: i,
        scaleWidth: n,
        scaleHeight: s
      };
      for (var o in a) a.hasOwnProperty(o) && (r[o] = a[o]);
      p(this.canvas, t, r);
    }), p._build = m, t.exports = p;
  }(t = {
    exports: {}
  }, t.exports), t.exports;
});
/** @license d3.js v3.5.12 | Copyright (c) 2010-2017 Mike Bostock [https://github.com/d3/d3] | BSD License [https://github.com/d3/d3/blob/master/LICENSE] */
!function () {
  function n(n) {
    return n && (n.ownerDocument || n.document || n).documentElement;
  }
  function t(n) {
    return n && (n.ownerDocument && n.ownerDocument.defaultView || n.document && n || n.defaultView);
  }
  function e(n, t) {
    return t > n ? -1 : n > t ? 1 : n >= t ? 0 : NaN;
  }
  function r(n) {
    return null === n ? NaN : +n;
  }
  function u(n) {
    return !isNaN(n);
  }
  function i(n) {
    return {
      left: function (t, e, r, u) {
        for (arguments.length < 3 && (r = 0), arguments.length < 4 && (u = t.length); u > r;) {
          var i = r + u >>> 1;
          n(t[i], e) < 0 ? r = i + 1 : u = i;
        }
        return r;
      },
      right: function (t, e, r, u) {
        for (arguments.length < 3 && (r = 0), arguments.length < 4 && (u = t.length); u > r;) {
          var i = r + u >>> 1;
          n(t[i], e) > 0 ? u = i : r = i + 1;
        }
        return r;
      }
    };
  }
  function a(n) {
    return n.length;
  }
  function o(n) {
    for (var t = 1; n * t % 1;) t *= 10;
    return t;
  }
  function l(n, t) {
    for (var e in t) Object.defineProperty(n.prototype, e, {
      value: t[e],
      enumerable: !1
    });
  }
  function c() {
    this._ = Object.create(null);
  }
  function s(n) {
    return (n += "") === xa || n[0] === ba ? ba + n : n;
  }
  function f(n) {
    return (n += "")[0] === ba ? n.slice(1) : n;
  }
  function h(n) {
    return s(n) in this._;
  }
  function g(n) {
    return (n = s(n)) in this._ && delete this._[n];
  }
  function p() {
    var n = [];
    for (var t in this._) n.push(f(t));
    return n;
  }
  function v() {
    var n = 0;
    for (var t in this._) ++n;
    return n;
  }
  function d() {
    for (var n in this._) return !1;
    return !0;
  }
  function m() {
    this._ = Object.create(null);
  }
  function y(n) {
    return n;
  }
  function M(n, t, e) {
    return function () {
      var r = e.apply(t, arguments);
      return r === t ? n : r;
    };
  }
  function x(n, t) {
    if (t in n) return t;
    t = t.charAt(0).toUpperCase() + t.slice(1);
    for (var e = 0, r = _a.length; r > e; ++e) {
      var u = _a[e] + t;
      if (u in n) return u;
    }
  }
  function b() {}
  function _() {}
  function w(n) {
    function t() {
      for (var t, r = e, u = -1, i = r.length; ++u < i;) (t = r[u].on) && t.apply(this, arguments);
      return n;
    }
    var e = [],
      r = new c();
    return t.on = function (t, u) {
      var i,
        a = r.get(t);
      return arguments.length < 2 ? a && a.on : (a && (a.on = null, e = e.slice(0, i = e.indexOf(a)).concat(e.slice(i + 1)), r.remove(t)), u && e.push(r.set(t, {
        on: u
      })), n);
    }, t;
  }
  function S() {
    oa.event.preventDefault();
  }
  function k() {
    for (var n, t = oa.event; n = t.sourceEvent;) t = n;
    return t;
  }
  function N(n) {
    for (var t = new _(), e = 0, r = arguments.length; ++e < r;) t[arguments[e]] = w(t);
    return t.of = function (e, r) {
      return function (u) {
        try {
          var i = u.sourceEvent = oa.event;
          u.target = n, oa.event = u, t[u.type].apply(e, r);
        } finally {
          oa.event = i;
        }
      };
    }, t;
  }
  function E(n) {
    return Sa(n, Aa), n;
  }
  function A(n) {
    return "function" == typeof n ? n : function () {
      return ka(n, this);
    };
  }
  function C(n) {
    return "function" == typeof n ? n : function () {
      return Na(n, this);
    };
  }
  function z(n, t) {
    function e() {
      this.removeAttribute(n);
    }
    function r() {
      this.removeAttributeNS(n.space, n.local);
    }
    function u() {
      this.setAttribute(n, t);
    }
    function i() {
      this.setAttributeNS(n.space, n.local, t);
    }
    function a() {
      var e = t.apply(this, arguments);
      null == e ? this.removeAttribute(n) : this.setAttribute(n, e);
    }
    function o() {
      var e = t.apply(this, arguments);
      null == e ? this.removeAttributeNS(n.space, n.local) : this.setAttributeNS(n.space, n.local, e);
    }
    return n = oa.ns.qualify(n), null == t ? n.local ? r : e : "function" == typeof t ? n.local ? o : a : n.local ? i : u;
  }
  function L(n) {
    return n.trim().replace(/\s+/g, " ");
  }
  function q(n) {
    return new RegExp("(?:^|\\s+)" + oa.requote(n) + "(?:\\s+|$)", "g");
  }
  function T(n) {
    return (n + "").trim().split(/^|\s+/);
  }
  function R(n, t) {
    function e() {
      for (var e = -1; ++e < u;) n[e](this, t);
    }
    function r() {
      for (var e = -1, r = t.apply(this, arguments); ++e < u;) n[e](this, r);
    }
    n = T(n).map(D);
    var u = n.length;
    return "function" == typeof t ? r : e;
  }
  function D(n) {
    var t = q(n);
    return function (e, r) {
      if (u = e.classList) return r ? u.add(n) : u.remove(n);
      var u = e.getAttribute("class") || "";
      r ? (t.lastIndex = 0, t.test(u) || e.setAttribute("class", L(u + " " + n))) : e.setAttribute("class", L(u.replace(t, " ")));
    };
  }
  function P(n, t, e) {
    function r() {
      this.style.removeProperty(n);
    }
    function u() {
      this.style.setProperty(n, t, e);
    }
    function i() {
      var r = t.apply(this, arguments);
      null == r ? this.style.removeProperty(n) : this.style.setProperty(n, r, e);
    }
    return null == t ? r : "function" == typeof t ? i : u;
  }
  function j(n, t) {
    function e() {
      delete this[n];
    }
    function r() {
      this[n] = t;
    }
    function u() {
      var e = t.apply(this, arguments);
      null == e ? delete this[n] : this[n] = e;
    }
    return null == t ? e : "function" == typeof t ? u : r;
  }
  function U(n) {
    function t() {
      var t = this.ownerDocument,
        e = this.namespaceURI;
      return e ? t.createElementNS(e, n) : t.createElement(n);
    }
    function e() {
      return this.ownerDocument.createElementNS(n.space, n.local);
    }
    return "function" == typeof n ? n : (n = oa.ns.qualify(n)).local ? e : t;
  }
  function F() {
    var n = this.parentNode;
    n && n.removeChild(this);
  }
  function H(n) {
    return {
      __data__: n
    };
  }
  function O(n) {
    return function () {
      return Ea(this, n);
    };
  }
  function I(n) {
    return arguments.length || (n = e), function (t, e) {
      return t && e ? n(t.__data__, e.__data__) : !t - !e;
    };
  }
  function Y(n, t) {
    for (var e = 0, r = n.length; r > e; e++) for (var u, i = n[e], a = 0, o = i.length; o > a; a++) (u = i[a]) && t(u, a, e);
    return n;
  }
  function Z(n) {
    return Sa(n, za), n;
  }
  function V(n) {
    var t, e;
    return function (r, u, i) {
      var a,
        o = n[i].update,
        l = o.length;
      for (i != e && (e = i, t = 0), u >= t && (t = u + 1); !(a = o[t]) && ++t < l;);
      return a;
    };
  }
  function X(n, t, e) {
    function r() {
      var t = this[a];
      t && (this.removeEventListener(n, t, t.$), delete this[a]);
    }
    function u() {
      var u = l(t, ca(arguments));
      r.call(this), this.addEventListener(n, this[a] = u, u.$ = e), u._ = t;
    }
    function i() {
      var t,
        e = new RegExp("^__on([^.]+)" + oa.requote(n) + "$");
      for (var r in this) if (t = r.match(e)) {
        var u = this[r];
        this.removeEventListener(t[1], u, u.$), delete this[r];
      }
    }
    var a = "__on" + n,
      o = n.indexOf("."),
      l = $;
    o > 0 && (n = n.slice(0, o));
    var c = La.get(n);
    return c && (n = c, l = B), o ? t ? u : r : t ? b : i;
  }
  function $(n, t) {
    return function (e) {
      var r = oa.event;
      oa.event = e, t[0] = this.__data__;
      try {
        n.apply(this, t);
      } finally {
        oa.event = r;
      }
    };
  }
  function B(n, t) {
    var e = $(n, t);
    return function (n) {
      var t = this,
        r = n.relatedTarget;
      r && (r === t || 8 & r.compareDocumentPosition(t)) || e.call(t, n);
    };
  }
  function W(e) {
    var r = ".dragsuppress-" + ++Ta,
      u = "click" + r,
      i = oa.select(t(e)).on("touchmove" + r, S).on("dragstart" + r, S).on("selectstart" + r, S);
    if (null == qa && (qa = "onselectstart" in e ? !1 : x(e.style, "userSelect")), qa) {
      var a = n(e).style,
        o = a[qa];
      a[qa] = "none";
    }
    return function (n) {
      if (i.on(r, null), qa && (a[qa] = o), n) {
        var t = function () {
          i.on(u, null);
        };
        i.on(u, function () {
          S(), t();
        }, !0), setTimeout(t, 0);
      }
    };
  }
  function J(n, e) {
    e.changedTouches && (e = e.changedTouches[0]);
    var r = n.ownerSVGElement || n;
    if (r.createSVGPoint) {
      var u = r.createSVGPoint();
      if (0 > Ra) {
        var i = t(n);
        if (i.scrollX || i.scrollY) {
          r = oa.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var a = r[0][0].getScreenCTM();
          Ra = !(a.f || a.e), r.remove();
        }
      }
      return Ra ? (u.x = e.pageX, u.y = e.pageY) : (u.x = e.clientX, u.y = e.clientY), u = u.matrixTransform(n.getScreenCTM().inverse()), [u.x, u.y];
    }
    var o = n.getBoundingClientRect();
    return [e.clientX - o.left - n.clientLeft, e.clientY - o.top - n.clientTop];
  }
  function G() {
    return oa.event.changedTouches[0].identifier;
  }
  function K(n) {
    return n > 0 ? 1 : 0 > n ? -1 : 0;
  }
  function Q(n, t, e) {
    return (t[0] - n[0]) * (e[1] - n[1]) - (t[1] - n[1]) * (e[0] - n[0]);
  }
  function nn(n) {
    return n > 1 ? 0 : -1 > n ? ja : Math.acos(n);
  }
  function tn(n) {
    return n > 1 ? Ha : -1 > n ? -Ha : Math.asin(n);
  }
  function en(n) {
    return ((n = Math.exp(n)) - 1 / n) / 2;
  }
  function rn(n) {
    return ((n = Math.exp(n)) + 1 / n) / 2;
  }
  function un(n) {
    return ((n = Math.exp(2 * n)) - 1) / (n + 1);
  }
  function an(n) {
    return (n = Math.sin(n / 2)) * n;
  }
  function on() {}
  function ln(n, t, e) {
    return this instanceof ln ? (this.h = +n, this.s = +t, void (this.l = +e)) : arguments.length < 2 ? n instanceof ln ? new ln(n.h, n.s, n.l) : _n("" + n, wn, ln) : new ln(n, t, e);
  }
  function cn(n, t, e) {
    function r(n) {
      return n > 360 ? n -= 360 : 0 > n && (n += 360), 60 > n ? i + (a - i) * n / 60 : 180 > n ? a : 240 > n ? i + (a - i) * (240 - n) / 60 : i;
    }
    function u(n) {
      return Math.round(255 * r(n));
    }
    var i, a;
    return n = isNaN(n) ? 0 : (n %= 360) < 0 ? n + 360 : n, t = isNaN(t) ? 0 : 0 > t ? 0 : t > 1 ? 1 : t, e = 0 > e ? 0 : e > 1 ? 1 : e, a = .5 >= e ? e * (1 + t) : e + t - e * t, i = 2 * e - a, new yn(u(n + 120), u(n), u(n - 120));
  }
  function sn(n, t, e) {
    return this instanceof sn ? (this.h = +n, this.c = +t, void (this.l = +e)) : arguments.length < 2 ? n instanceof sn ? new sn(n.h, n.c, n.l) : n instanceof hn ? pn(n.l, n.a, n.b) : pn((n = Sn((n = oa.rgb(n)).r, n.g, n.b)).l, n.a, n.b) : new sn(n, t, e);
  }
  function fn(n, t, e) {
    return isNaN(n) && (n = 0), isNaN(t) && (t = 0), new hn(e, Math.cos(n *= Oa) * t, Math.sin(n) * t);
  }
  function hn(n, t, e) {
    return this instanceof hn ? (this.l = +n, this.a = +t, void (this.b = +e)) : arguments.length < 2 ? n instanceof hn ? new hn(n.l, n.a, n.b) : n instanceof sn ? fn(n.h, n.c, n.l) : Sn((n = yn(n)).r, n.g, n.b) : new hn(n, t, e);
  }
  function gn(n, t, e) {
    var r = (n + 16) / 116,
      u = r + t / 500,
      i = r - e / 200;
    return u = vn(u) * Ka, r = vn(r) * Qa, i = vn(i) * no, new yn(mn(3.2404542 * u - 1.5371385 * r - .4985314 * i), mn(-.969266 * u + 1.8760108 * r + .041556 * i), mn(.0556434 * u - .2040259 * r + 1.0572252 * i));
  }
  function pn(n, t, e) {
    return n > 0 ? new sn(Math.atan2(e, t) * Ia, Math.sqrt(t * t + e * e), n) : new sn(NaN, NaN, n);
  }
  function vn(n) {
    return n > .206893034 ? n * n * n : (n - 4 / 29) / 7.787037;
  }
  function dn(n) {
    return n > .008856 ? Math.pow(n, 1 / 3) : 7.787037 * n + 4 / 29;
  }
  function mn(n) {
    return Math.round(255 * (.00304 >= n ? 12.92 * n : 1.055 * Math.pow(n, 1 / 2.4) - .055));
  }
  function yn(n, t, e) {
    return this instanceof yn ? (this.r = ~~n, this.g = ~~t, void (this.b = ~~e)) : arguments.length < 2 ? n instanceof yn ? new yn(n.r, n.g, n.b) : _n("" + n, yn, cn) : new yn(n, t, e);
  }
  function Mn(n) {
    return new yn(n >> 16, n >> 8 & 255, 255 & n);
  }
  function xn(n) {
    return Mn(n) + "";
  }
  function bn(n) {
    return 16 > n ? "0" + Math.max(0, n).toString(16) : Math.min(255, n).toString(16);
  }
  function _n(n, t, e) {
    var r,
      u,
      i,
      a = 0,
      o = 0,
      l = 0;
    if (r = /([a-z]+)\((.*)\)/.exec(n = n.toLowerCase())) switch (u = r[2].split(","), r[1]) {
      case "hsl":
        return e(parseFloat(u[0]), parseFloat(u[1]) / 100, parseFloat(u[2]) / 100);
      case "rgb":
        return t(Nn(u[0]), Nn(u[1]), Nn(u[2]));
    }
    return (i = ro.get(n)) ? t(i.r, i.g, i.b) : (null == n || "#" !== n.charAt(0) || isNaN(i = parseInt(n.slice(1), 16)) || (4 === n.length ? (a = (3840 & i) >> 4, a = a >> 4 | a, o = 240 & i, o = o >> 4 | o, l = 15 & i, l = l << 4 | l) : 7 === n.length && (a = (16711680 & i) >> 16, o = (65280 & i) >> 8, l = 255 & i)), t(a, o, l));
  }
  function wn(n, t, e) {
    var r,
      u,
      i = Math.min(n /= 255, t /= 255, e /= 255),
      a = Math.max(n, t, e),
      o = a - i,
      l = (a + i) / 2;
    return o ? (u = .5 > l ? o / (a + i) : o / (2 - a - i), r = n == a ? (t - e) / o + (e > t ? 6 : 0) : t == a ? (e - n) / o + 2 : (n - t) / o + 4, r *= 60) : (r = NaN, u = l > 0 && 1 > l ? 0 : r), new ln(r, u, l);
  }
  function Sn(n, t, e) {
    n = kn(n), t = kn(t), e = kn(e);
    var r = dn((.4124564 * n + .3575761 * t + .1804375 * e) / Ka),
      u = dn((.2126729 * n + .7151522 * t + .072175 * e) / Qa),
      i = dn((.0193339 * n + .119192 * t + .9503041 * e) / no);
    return hn(116 * u - 16, 500 * (r - u), 200 * (u - i));
  }
  function kn(n) {
    return (n /= 255) <= .04045 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4);
  }
  function Nn(n) {
    var t = parseFloat(n);
    return "%" === n.charAt(n.length - 1) ? Math.round(2.55 * t) : t;
  }
  function En(n) {
    return "function" == typeof n ? n : function () {
      return n;
    };
  }
  function An(n) {
    return function (t, e, r) {
      return 2 === arguments.length && "function" == typeof e && (r = e, e = null), Cn(t, e, n, r);
    };
  }
  function Cn(n, t, e, r) {
    function u() {
      var n,
        t = l.status;
      if (!t && Ln(l) || t >= 200 && 300 > t || 304 === t) {
        try {
          n = e.call(i, l);
        } catch (r) {
          return void a.error.call(i, r);
        }
        a.load.call(i, n);
      } else a.error.call(i, l);
    }
    var i = {},
      a = oa.dispatch("beforesend", "progress", "load", "error"),
      o = {},
      l = new XMLHttpRequest(),
      c = null;
    return !this.XDomainRequest || "withCredentials" in l || !/^(http(s)?:)?\/\//.test(n) || (l = new XDomainRequest()), "onload" in l ? l.onload = l.onerror = u : l.onreadystatechange = function () {
      l.readyState > 3 && u();
    }, l.onprogress = function (n) {
      var t = oa.event;
      oa.event = n;
      try {
        a.progress.call(i, l);
      } finally {
        oa.event = t;
      }
    }, i.header = function (n, t) {
      return n = (n + "").toLowerCase(), arguments.length < 2 ? o[n] : (null == t ? delete o[n] : o[n] = t + "", i);
    }, i.mimeType = function (n) {
      return arguments.length ? (t = null == n ? null : n + "", i) : t;
    }, i.responseType = function (n) {
      return arguments.length ? (c = n, i) : c;
    }, i.response = function (n) {
      return e = n, i;
    }, ["get", "post"].forEach(function (n) {
      i[n] = function () {
        return i.send.apply(i, [n].concat(ca(arguments)));
      };
    }), i.send = function (e, r, u) {
      if (2 === arguments.length && "function" == typeof r && (u = r, r = null), l.open(e, n, !0), null == t || "accept" in o || (o.accept = t + ",*/*"), l.setRequestHeader) for (var s in o) l.setRequestHeader(s, o[s]);
      return null != t && l.overrideMimeType && l.overrideMimeType(t), null != c && (l.responseType = c), null != u && i.on("error", u).on("load", function (n) {
        u(null, n);
      }), a.beforesend.call(i, l), l.send(null == r ? null : r), i;
    }, i.abort = function () {
      return l.abort(), i;
    }, oa.rebind(i, a, "on"), null == r ? i : i.get(zn(r));
  }
  function zn(n) {
    return 1 === n.length ? function (t, e) {
      n(null == t ? e : null);
    } : n;
  }
  function Ln(n) {
    var t = n.responseType;
    return t && "text" !== t ? n.response : n.responseText;
  }
  function qn(n, t, e) {
    var r = arguments.length;
    2 > r && (t = 0), 3 > r && (e = Date.now());
    var u = e + t,
      i = {
        c: n,
        t: u,
        n: null
      };
    return io ? io.n = i : uo = i, io = i, ao || (oo = clearTimeout(oo), ao = 1, lo(Tn)), i;
  }
  function Tn() {
    var n = Rn(),
      t = Dn() - n;
    t > 24 ? (isFinite(t) && (clearTimeout(oo), oo = setTimeout(Tn, t)), ao = 0) : (ao = 1, lo(Tn));
  }
  function Rn() {
    for (var n = Date.now(), t = uo; t;) n >= t.t && t.c(n - t.t) && (t.c = null), t = t.n;
    return n;
  }
  function Dn() {
    for (var n, t = uo, e = 1 / 0; t;) t.c ? (t.t < e && (e = t.t), t = (n = t).n) : t = n ? n.n = t.n : uo = t.n;
    return io = n, e;
  }
  function Pn(n, t) {
    return t - (n ? Math.ceil(Math.log(n) / Math.LN10) : 1);
  }
  function jn(n, t) {
    var e = Math.pow(10, 3 * Ma(8 - t));
    return {
      scale: t > 8 ? function (n) {
        return n / e;
      } : function (n) {
        return n * e;
      },
      symbol: n
    };
  }
  function Un(n) {
    var t = n.decimal,
      e = n.thousands,
      r = n.grouping,
      u = n.currency,
      i = r && e ? function (n, t) {
        for (var u = n.length, i = [], a = 0, o = r[0], l = 0; u > 0 && o > 0 && (l + o + 1 > t && (o = Math.max(1, t - l)), i.push(n.substring(u -= o, u + o)), !((l += o + 1) > t));) o = r[a = (a + 1) % r.length];
        return i.reverse().join(e);
      } : y;
    return function (n) {
      var e = so.exec(n),
        r = e[1] || " ",
        a = e[2] || ">",
        o = e[3] || "-",
        l = e[4] || "",
        c = e[5],
        s = +e[6],
        f = e[7],
        h = e[8],
        g = e[9],
        p = 1,
        v = "",
        d = "",
        m = !1,
        y = !0;
      switch (h && (h = +h.substring(1)), (c || "0" === r && "=" === a) && (c = r = "0", a = "="), g) {
        case "n":
          f = !0, g = "g";
          break;
        case "%":
          p = 100, d = "%", g = "f";
          break;
        case "p":
          p = 100, d = "%", g = "r";
          break;
        case "b":
        case "o":
        case "x":
        case "X":
          "#" === l && (v = "0" + g.toLowerCase());
        case "c":
          y = !1;
        case "d":
          m = !0, h = 0;
          break;
        case "s":
          p = -1, g = "r";
      }
      "$" === l && (v = u[0], d = u[1]), "r" != g || h || (g = "g"), null != h && ("g" == g ? h = Math.max(1, Math.min(21, h)) : ("e" == g || "f" == g) && (h = Math.max(0, Math.min(20, h)))), g = fo.get(g) || Fn;
      var M = c && f;
      return function (n) {
        var e = d;
        if (m && n % 1) return "";
        var u = 0 > n || 0 === n && 0 > 1 / n ? (n = -n, "-") : "-" === o ? "" : o;
        if (0 > p) {
          var l = oa.formatPrefix(n, h);
          n = l.scale(n), e = l.symbol + d;
        } else n *= p;
        n = g(n, h);
        var x,
          b,
          _ = n.lastIndexOf(".");
        if (0 > _) {
          var w = y ? n.lastIndexOf("e") : -1;
          0 > w ? (x = n, b = "") : (x = n.substring(0, w), b = n.substring(w));
        } else x = n.substring(0, _), b = t + n.substring(_ + 1);
        !c && f && (x = i(x, 1 / 0));
        var S = v.length + x.length + b.length + (M ? 0 : u.length),
          k = s > S ? new Array(S = s - S + 1).join(r) : "";
        return M && (x = i(k + x, k.length ? s - b.length : 1 / 0)), u += v, n = x + b, ("<" === a ? u + n + k : ">" === a ? k + u + n : "^" === a ? k.substring(0, S >>= 1) + u + n + k.substring(S) : u + (M ? n : k + n)) + e;
      };
    };
  }
  function Fn(n) {
    return n + "";
  }
  function Hn() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  function On(n, t, e) {
    function r(t) {
      var e = n(t),
        r = i(e, 1);
      return r - t > t - e ? e : r;
    }
    function u(e) {
      return t(e = n(new go(e - 1)), 1), e;
    }
    function i(n, e) {
      return t(n = new go(+n), e), n;
    }
    function a(n, r, i) {
      var a = u(n),
        o = [];
      if (i > 1) for (; r > a;) e(a) % i || o.push(new Date(+a)), t(a, 1);else for (; r > a;) o.push(new Date(+a)), t(a, 1);
      return o;
    }
    function o(n, t, e) {
      try {
        go = Hn;
        var r = new Hn();
        return r._ = n, a(r, t, e);
      } finally {
        go = Date;
      }
    }
    n.floor = n, n.round = r, n.ceil = u, n.offset = i, n.range = a;
    var l = n.utc = In(n);
    return l.floor = l, l.round = In(r), l.ceil = In(u), l.offset = In(i), l.range = o, n;
  }
  function In(n) {
    return function (t, e) {
      try {
        go = Hn;
        var r = new Hn();
        return r._ = t, n(r, e)._;
      } finally {
        go = Date;
      }
    };
  }
  function Yn(n) {
    function t(n) {
      function t(t) {
        for (var e, u, i, a = [], o = -1, l = 0; ++o < r;) 37 === n.charCodeAt(o) && (a.push(n.slice(l, o)), null != (u = vo[e = n.charAt(++o)]) && (e = n.charAt(++o)), (i = A[e]) && (e = i(t, null == u ? "e" === e ? " " : "0" : u)), a.push(e), l = o + 1);
        return a.push(n.slice(l, o)), a.join("");
      }
      var r = n.length;
      return t.parse = function (t) {
        var r = {
            y: 1900,
            m: 0,
            d: 1,
            H: 0,
            M: 0,
            S: 0,
            L: 0,
            Z: null
          },
          u = e(r, n, t, 0);
        if (u != t.length) return null;
        "p" in r && (r.H = r.H % 12 + 12 * r.p);
        var i = null != r.Z && go !== Hn,
          a = new (i ? Hn : go)();
        return "j" in r ? a.setFullYear(r.y, 0, r.j) : "W" in r || "U" in r ? ("w" in r || (r.w = "W" in r ? 1 : 0), a.setFullYear(r.y, 0, 1), a.setFullYear(r.y, 0, "W" in r ? (r.w + 6) % 7 + 7 * r.W - (a.getDay() + 5) % 7 : r.w + 7 * r.U - (a.getDay() + 6) % 7)) : a.setFullYear(r.y, r.m, r.d), a.setHours(r.H + (r.Z / 100 | 0), r.M + r.Z % 100, r.S, r.L), i ? a._ : a;
      }, t.toString = function () {
        return n;
      }, t;
    }
    function e(n, t, e, r) {
      for (var u, i, a, o = 0, l = t.length, c = e.length; l > o;) {
        if (r >= c) return -1;
        if (u = t.charCodeAt(o++), 37 === u) {
          if (a = t.charAt(o++), i = C[a in vo ? t.charAt(o++) : a], !i || (r = i(n, e, r)) < 0) return -1;
        } else if (u != e.charCodeAt(r++)) return -1;
      }
      return r;
    }
    function r(n, t, e) {
      _.lastIndex = 0;
      var r = _.exec(t.slice(e));
      return r ? (n.w = w.get(r[0].toLowerCase()), e + r[0].length) : -1;
    }
    function u(n, t, e) {
      x.lastIndex = 0;
      var r = x.exec(t.slice(e));
      return r ? (n.w = b.get(r[0].toLowerCase()), e + r[0].length) : -1;
    }
    function i(n, t, e) {
      N.lastIndex = 0;
      var r = N.exec(t.slice(e));
      return r ? (n.m = E.get(r[0].toLowerCase()), e + r[0].length) : -1;
    }
    function a(n, t, e) {
      S.lastIndex = 0;
      var r = S.exec(t.slice(e));
      return r ? (n.m = k.get(r[0].toLowerCase()), e + r[0].length) : -1;
    }
    function o(n, t, r) {
      return e(n, A.c.toString(), t, r);
    }
    function l(n, t, r) {
      return e(n, A.x.toString(), t, r);
    }
    function c(n, t, r) {
      return e(n, A.X.toString(), t, r);
    }
    function s(n, t, e) {
      var r = M.get(t.slice(e, e += 2).toLowerCase());
      return null == r ? -1 : (n.p = r, e);
    }
    var f = n.dateTime,
      h = n.date,
      g = n.time,
      p = n.periods,
      v = n.days,
      d = n.shortDays,
      m = n.months,
      y = n.shortMonths;
    t.utc = function (n) {
      function e(n) {
        try {
          go = Hn;
          var t = new go();
          return t._ = n, r(t);
        } finally {
          go = Date;
        }
      }
      var r = t(n);
      return e.parse = function (n) {
        try {
          go = Hn;
          var t = r.parse(n);
          return t && t._;
        } finally {
          go = Date;
        }
      }, e.toString = r.toString, e;
    }, t.multi = t.utc.multi = ct;
    var M = oa.map(),
      x = Vn(v),
      b = Xn(v),
      _ = Vn(d),
      w = Xn(d),
      S = Vn(m),
      k = Xn(m),
      N = Vn(y),
      E = Xn(y);
    p.forEach(function (n, t) {
      M.set(n.toLowerCase(), t);
    });
    var A = {
        a: function (n) {
          return d[n.getDay()];
        },
        A: function (n) {
          return v[n.getDay()];
        },
        b: function (n) {
          return y[n.getMonth()];
        },
        B: function (n) {
          return m[n.getMonth()];
        },
        c: t(f),
        d: function (n, t) {
          return Zn(n.getDate(), t, 2);
        },
        e: function (n, t) {
          return Zn(n.getDate(), t, 2);
        },
        H: function (n, t) {
          return Zn(n.getHours(), t, 2);
        },
        I: function (n, t) {
          return Zn(n.getHours() % 12 || 12, t, 2);
        },
        j: function (n, t) {
          return Zn(1 + ho.dayOfYear(n), t, 3);
        },
        L: function (n, t) {
          return Zn(n.getMilliseconds(), t, 3);
        },
        m: function (n, t) {
          return Zn(n.getMonth() + 1, t, 2);
        },
        M: function (n, t) {
          return Zn(n.getMinutes(), t, 2);
        },
        p: function (n) {
          return p[+(n.getHours() >= 12)];
        },
        S: function (n, t) {
          return Zn(n.getSeconds(), t, 2);
        },
        U: function (n, t) {
          return Zn(ho.sundayOfYear(n), t, 2);
        },
        w: function (n) {
          return n.getDay();
        },
        W: function (n, t) {
          return Zn(ho.mondayOfYear(n), t, 2);
        },
        x: t(h),
        X: t(g),
        y: function (n, t) {
          return Zn(n.getFullYear() % 100, t, 2);
        },
        Y: function (n, t) {
          return Zn(n.getFullYear() % 1e4, t, 4);
        },
        Z: ot,
        "%": function () {
          return "%";
        }
      },
      C = {
        a: r,
        A: u,
        b: i,
        B: a,
        c: o,
        d: tt,
        e: tt,
        H: rt,
        I: rt,
        j: et,
        L: at,
        m: nt,
        M: ut,
        p: s,
        S: it,
        U: Bn,
        w: $n,
        W: Wn,
        x: l,
        X: c,
        y: Gn,
        Y: Jn,
        Z: Kn,
        "%": lt
      };
    return t;
  }
  function Zn(n, t, e) {
    var r = 0 > n ? "-" : "",
      u = (r ? -n : n) + "",
      i = u.length;
    return r + (e > i ? new Array(e - i + 1).join(t) + u : u);
  }
  function Vn(n) {
    return new RegExp("^(?:" + n.map(oa.requote).join("|") + ")", "i");
  }
  function Xn(n) {
    for (var t = new c(), e = -1, r = n.length; ++e < r;) t.set(n[e].toLowerCase(), e);
    return t;
  }
  function $n(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 1));
    return r ? (n.w = +r[0], e + r[0].length) : -1;
  }
  function Bn(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e));
    return r ? (n.U = +r[0], e + r[0].length) : -1;
  }
  function Wn(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e));
    return r ? (n.W = +r[0], e + r[0].length) : -1;
  }
  function Jn(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 4));
    return r ? (n.y = +r[0], e + r[0].length) : -1;
  }
  function Gn(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 2));
    return r ? (n.y = Qn(+r[0]), e + r[0].length) : -1;
  }
  function Kn(n, t, e) {
    return /^[+-]\d{4}$/.test(t = t.slice(e, e + 5)) ? (n.Z = -t, e + 5) : -1;
  }
  function Qn(n) {
    return n + (n > 68 ? 1900 : 2e3);
  }
  function nt(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 2));
    return r ? (n.m = r[0] - 1, e + r[0].length) : -1;
  }
  function tt(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 2));
    return r ? (n.d = +r[0], e + r[0].length) : -1;
  }
  function et(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 3));
    return r ? (n.j = +r[0], e + r[0].length) : -1;
  }
  function rt(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 2));
    return r ? (n.H = +r[0], e + r[0].length) : -1;
  }
  function ut(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 2));
    return r ? (n.M = +r[0], e + r[0].length) : -1;
  }
  function it(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 2));
    return r ? (n.S = +r[0], e + r[0].length) : -1;
  }
  function at(n, t, e) {
    mo.lastIndex = 0;
    var r = mo.exec(t.slice(e, e + 3));
    return r ? (n.L = +r[0], e + r[0].length) : -1;
  }
  function ot(n) {
    var t = n.getTimezoneOffset(),
      e = t > 0 ? "-" : "+",
      r = Ma(t) / 60 | 0,
      u = Ma(t) % 60;
    return e + Zn(r, "0", 2) + Zn(u, "0", 2);
  }
  function lt(n, t, e) {
    yo.lastIndex = 0;
    var r = yo.exec(t.slice(e, e + 1));
    return r ? e + r[0].length : -1;
  }
  function ct(n) {
    for (var t = n.length, e = -1; ++e < t;) n[e][0] = this(n[e][0]);
    return function (t) {
      for (var e = 0, r = n[e]; !r[1](t);) r = n[++e];
      return r[0](t);
    };
  }
  function st() {}
  function ft(n, t, e) {
    var r = e.s = n + t,
      u = r - n,
      i = r - u;
    e.t = n - i + (t - u);
  }
  function ht(n, t) {
    n && _o.hasOwnProperty(n.type) && _o[n.type](n, t);
  }
  function gt(n, t, e) {
    var r,
      u = -1,
      i = n.length - e;
    for (t.lineStart(); ++u < i;) r = n[u], t.point(r[0], r[1], r[2]);
    t.lineEnd();
  }
  function pt(n, t) {
    var e = -1,
      r = n.length;
    for (t.polygonStart(); ++e < r;) gt(n[e], t, 1);
    t.polygonEnd();
  }
  function vt() {
    function n(n, t) {
      n *= Oa, t = t * Oa / 2 + ja / 4;
      var e = n - r,
        a = e >= 0 ? 1 : -1,
        o = a * e,
        l = Math.cos(t),
        c = Math.sin(t),
        s = i * c,
        f = u * l + s * Math.cos(o),
        h = s * a * Math.sin(o);
      So.add(Math.atan2(h, f)), r = n, u = l, i = c;
    }
    var t, e, r, u, i;
    ko.point = function (a, o) {
      ko.point = n, r = (t = a) * Oa, u = Math.cos(o = (e = o) * Oa / 2 + ja / 4), i = Math.sin(o);
    }, ko.lineEnd = function () {
      n(t, e);
    };
  }
  function dt(n) {
    var t = n[0],
      e = n[1],
      r = Math.cos(e);
    return [r * Math.cos(t), r * Math.sin(t), Math.sin(e)];
  }
  function mt(n, t) {
    return n[0] * t[0] + n[1] * t[1] + n[2] * t[2];
  }
  function yt(n, t) {
    return [n[1] * t[2] - n[2] * t[1], n[2] * t[0] - n[0] * t[2], n[0] * t[1] - n[1] * t[0]];
  }
  function Mt(n, t) {
    n[0] += t[0], n[1] += t[1], n[2] += t[2];
  }
  function xt(n, t) {
    return [n[0] * t, n[1] * t, n[2] * t];
  }
  function bt(n) {
    var t = Math.sqrt(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
    n[0] /= t, n[1] /= t, n[2] /= t;
  }
  function _t(n) {
    return [Math.atan2(n[1], n[0]), tn(n[2])];
  }
  function wt(n, t) {
    return Ma(n[0] - t[0]) < Da && Ma(n[1] - t[1]) < Da;
  }
  function St(n, t) {
    n *= Oa;
    var e = Math.cos(t *= Oa);
    kt(e * Math.cos(n), e * Math.sin(n), Math.sin(t));
  }
  function kt(n, t, e) {
    ++No, Ao += (n - Ao) / No, Co += (t - Co) / No, zo += (e - zo) / No;
  }
  function Nt() {
    function n(n, u) {
      n *= Oa;
      var i = Math.cos(u *= Oa),
        a = i * Math.cos(n),
        o = i * Math.sin(n),
        l = Math.sin(u),
        c = Math.atan2(Math.sqrt((c = e * l - r * o) * c + (c = r * a - t * l) * c + (c = t * o - e * a) * c), t * a + e * o + r * l);
      Eo += c, Lo += c * (t + (t = a)), qo += c * (e + (e = o)), To += c * (r + (r = l)), kt(t, e, r);
    }
    var t, e, r;
    jo.point = function (u, i) {
      u *= Oa;
      var a = Math.cos(i *= Oa);
      t = a * Math.cos(u), e = a * Math.sin(u), r = Math.sin(i), jo.point = n, kt(t, e, r);
    };
  }
  function Et() {
    jo.point = St;
  }
  function At() {
    function n(n, t) {
      n *= Oa;
      var e = Math.cos(t *= Oa),
        a = e * Math.cos(n),
        o = e * Math.sin(n),
        l = Math.sin(t),
        c = u * l - i * o,
        s = i * a - r * l,
        f = r * o - u * a,
        h = Math.sqrt(c * c + s * s + f * f),
        g = r * a + u * o + i * l,
        p = h && -nn(g) / h,
        v = Math.atan2(h, g);
      Ro += p * c, Do += p * s, Po += p * f, Eo += v, Lo += v * (r + (r = a)), qo += v * (u + (u = o)), To += v * (i + (i = l)), kt(r, u, i);
    }
    var t, e, r, u, i;
    jo.point = function (a, o) {
      t = a, e = o, jo.point = n, a *= Oa;
      var l = Math.cos(o *= Oa);
      r = l * Math.cos(a), u = l * Math.sin(a), i = Math.sin(o), kt(r, u, i);
    }, jo.lineEnd = function () {
      n(t, e), jo.lineEnd = Et, jo.point = St;
    };
  }
  function Ct(n, t) {
    function e(e, r) {
      return e = n(e, r), t(e[0], e[1]);
    }
    return n.invert && t.invert && (e.invert = function (e, r) {
      return e = t.invert(e, r), e && n.invert(e[0], e[1]);
    }), e;
  }
  function zt() {
    return !0;
  }
  function Lt(n, t, e, r, u) {
    var i = [],
      a = [];
    if (n.forEach(function (n) {
      if (!((t = n.length - 1) <= 0)) {
        var t,
          e = n[0],
          r = n[t];
        if (wt(e, r)) {
          u.lineStart();
          for (var o = 0; t > o; ++o) u.point((e = n[o])[0], e[1]);
          return void u.lineEnd();
        }
        var l = new Tt(e, n, null, !0),
          c = new Tt(e, null, l, !1);
        l.o = c, i.push(l), a.push(c), l = new Tt(r, n, null, !1), c = new Tt(r, null, l, !0), l.o = c, i.push(l), a.push(c);
      }
    }), a.sort(t), qt(i), qt(a), i.length) {
      for (var o = 0, l = e, c = a.length; c > o; ++o) a[o].e = l = !l;
      for (var s, f, h = i[0];;) {
        for (var g = h, p = !0; g.v;) if ((g = g.n) === h) return;
        s = g.z, u.lineStart();
        do {
          if (g.v = g.o.v = !0, g.e) {
            if (p) for (var o = 0, c = s.length; c > o; ++o) u.point((f = s[o])[0], f[1]);else r(g.x, g.n.x, 1, u);
            g = g.n;
          } else {
            if (p) {
              s = g.p.z;
              for (var o = s.length - 1; o >= 0; --o) u.point((f = s[o])[0], f[1]);
            } else r(g.x, g.p.x, -1, u);
            g = g.p;
          }
          g = g.o, s = g.z, p = !p;
        } while (!g.v);
        u.lineEnd();
      }
    }
  }
  function qt(n) {
    if (t = n.length) {
      for (var t, e, r = 0, u = n[0]; ++r < t;) u.n = e = n[r], e.p = u, u = e;
      u.n = e = n[0], e.p = u;
    }
  }
  function Tt(n, t, e, r) {
    this.x = n, this.z = t, this.o = e, this.e = r, this.v = !1, this.n = this.p = null;
  }
  function Rt(n, t, e, r) {
    return function (u, i) {
      function a(t, e) {
        var r = u(t, e);
        n(t = r[0], e = r[1]) && i.point(t, e);
      }
      function o(n, t) {
        var e = u(n, t);
        d.point(e[0], e[1]);
      }
      function l() {
        y.point = o, d.lineStart();
      }
      function c() {
        y.point = a, d.lineEnd();
      }
      function s(n, t) {
        v.push([n, t]);
        var e = u(n, t);
        x.point(e[0], e[1]);
      }
      function f() {
        x.lineStart(), v = [];
      }
      function h() {
        s(v[0][0], v[0][1]), x.lineEnd();
        var n,
          t = x.clean(),
          e = M.buffer(),
          r = e.length;
        if (v.pop(), p.push(v), v = null, r) if (1 & t) {
          n = e[0];
          var u,
            r = n.length - 1,
            a = -1;
          if (r > 0) {
            for (b || (i.polygonStart(), b = !0), i.lineStart(); ++a < r;) i.point((u = n[a])[0], u[1]);
            i.lineEnd();
          }
        } else r > 1 && 2 & t && e.push(e.pop().concat(e.shift())), g.push(e.filter(Dt));
      }
      var g,
        p,
        v,
        d = t(i),
        m = u.invert(r[0], r[1]),
        y = {
          point: a,
          lineStart: l,
          lineEnd: c,
          polygonStart: function () {
            y.point = s, y.lineStart = f, y.lineEnd = h, g = [], p = [];
          },
          polygonEnd: function () {
            y.point = a, y.lineStart = l, y.lineEnd = c, g = oa.merge(g);
            var n = Ot(m, p);
            g.length ? (b || (i.polygonStart(), b = !0), Lt(g, jt, n, e, i)) : n && (b || (i.polygonStart(), b = !0), i.lineStart(), e(null, null, 1, i), i.lineEnd()), b && (i.polygonEnd(), b = !1), g = p = null;
          },
          sphere: function () {
            i.polygonStart(), i.lineStart(), e(null, null, 1, i), i.lineEnd(), i.polygonEnd();
          }
        },
        M = Pt(),
        x = t(M),
        b = !1;
      return y;
    };
  }
  function Dt(n) {
    return n.length > 1;
  }
  function Pt() {
    var n,
      t = [];
    return {
      lineStart: function () {
        t.push(n = []);
      },
      point: function (t, e) {
        n.push([t, e]);
      },
      lineEnd: b,
      buffer: function () {
        var e = t;
        return t = [], n = null, e;
      },
      rejoin: function () {
        t.length > 1 && t.push(t.pop().concat(t.shift()));
      }
    };
  }
  function jt(n, t) {
    return ((n = n.x)[0] < 0 ? n[1] - Ha - Da : Ha - n[1]) - ((t = t.x)[0] < 0 ? t[1] - Ha - Da : Ha - t[1]);
  }
  function Ut(n) {
    var t,
      e = NaN,
      r = NaN,
      u = NaN;
    return {
      lineStart: function () {
        n.lineStart(), t = 1;
      },
      point: function (i, a) {
        var o = i > 0 ? ja : -ja,
          l = Ma(i - e);
        Ma(l - ja) < Da ? (n.point(e, r = (r + a) / 2 > 0 ? Ha : -Ha), n.point(u, r), n.lineEnd(), n.lineStart(), n.point(o, r), n.point(i, r), t = 0) : u !== o && l >= ja && (Ma(e - u) < Da && (e -= u * Da), Ma(i - o) < Da && (i -= o * Da), r = Ft(e, r, i, a), n.point(u, r), n.lineEnd(), n.lineStart(), n.point(o, r), t = 0), n.point(e = i, r = a), u = o;
      },
      lineEnd: function () {
        n.lineEnd(), e = r = NaN;
      },
      clean: function () {
        return 2 - t;
      }
    };
  }
  function Ft(n, t, e, r) {
    var u,
      i,
      a = Math.sin(n - e);
    return Ma(a) > Da ? Math.atan((Math.sin(t) * (i = Math.cos(r)) * Math.sin(e) - Math.sin(r) * (u = Math.cos(t)) * Math.sin(n)) / (u * i * a)) : (t + r) / 2;
  }
  function Ht(n, t, e, r) {
    var u;
    if (null == n) u = e * Ha, r.point(-ja, u), r.point(0, u), r.point(ja, u), r.point(ja, 0), r.point(ja, -u), r.point(0, -u), r.point(-ja, -u), r.point(-ja, 0), r.point(-ja, u);else if (Ma(n[0] - t[0]) > Da) {
      var i = n[0] < t[0] ? ja : -ja;
      u = e * i / 2, r.point(-i, u), r.point(0, u), r.point(i, u);
    } else r.point(t[0], t[1]);
  }
  function Ot(n, t) {
    var e = n[0],
      r = n[1],
      u = [Math.sin(e), -Math.cos(e), 0],
      i = 0,
      a = 0;
    So.reset();
    for (var o = 0, l = t.length; l > o; ++o) {
      var c = t[o],
        s = c.length;
      if (s) for (var f = c[0], h = f[0], g = f[1] / 2 + ja / 4, p = Math.sin(g), v = Math.cos(g), d = 1;;) {
        d === s && (d = 0), n = c[d];
        var m = n[0],
          y = n[1] / 2 + ja / 4,
          M = Math.sin(y),
          x = Math.cos(y),
          b = m - h,
          _ = b >= 0 ? 1 : -1,
          w = _ * b,
          S = w > ja,
          k = p * M;
        if (So.add(Math.atan2(k * _ * Math.sin(w), v * x + k * Math.cos(w))), i += S ? b + _ * Ua : b, S ^ h >= e ^ m >= e) {
          var N = yt(dt(f), dt(n));
          bt(N);
          var E = yt(u, N);
          bt(E);
          var A = (S ^ b >= 0 ? -1 : 1) * tn(E[2]);
          (r > A || r === A && (N[0] || N[1])) && (a += S ^ b >= 0 ? 1 : -1);
        }
        if (!d++) break;
        h = m, p = M, v = x, f = n;
      }
    }
    return (-Da > i || Da > i && 0 > So) ^ 1 & a;
  }
  function It(n) {
    function t(n, t) {
      return Math.cos(n) * Math.cos(t) > i;
    }
    function e(n) {
      var e, i, l, c, s;
      return {
        lineStart: function () {
          c = l = !1, s = 1;
        },
        point: function (f, h) {
          var g,
            p = [f, h],
            v = t(f, h),
            d = a ? v ? 0 : u(f, h) : v ? u(f + (0 > f ? ja : -ja), h) : 0;
          if (!e && (c = l = v) && n.lineStart(), v !== l && (g = r(e, p), (wt(e, g) || wt(p, g)) && (p[0] += Da, p[1] += Da, v = t(p[0], p[1]))), v !== l) s = 0, v ? (n.lineStart(), g = r(p, e), n.point(g[0], g[1])) : (g = r(e, p), n.point(g[0], g[1]), n.lineEnd()), e = g;else if (o && e && a ^ v) {
            var m;
            d & i || !(m = r(p, e, !0)) || (s = 0, a ? (n.lineStart(), n.point(m[0][0], m[0][1]), n.point(m[1][0], m[1][1]), n.lineEnd()) : (n.point(m[1][0], m[1][1]), n.lineEnd(), n.lineStart(), n.point(m[0][0], m[0][1])));
          }
          !v || e && wt(e, p) || n.point(p[0], p[1]), e = p, l = v, i = d;
        },
        lineEnd: function () {
          l && n.lineEnd(), e = null;
        },
        clean: function () {
          return s | (c && l) << 1;
        }
      };
    }
    function r(n, t, e) {
      var r = dt(n),
        u = dt(t),
        a = [1, 0, 0],
        o = yt(r, u),
        l = mt(o, o),
        c = o[0],
        s = l - c * c;
      if (!s) return !e && n;
      var f = i * l / s,
        h = -i * c / s,
        g = yt(a, o),
        p = xt(a, f),
        v = xt(o, h);
      Mt(p, v);
      var d = g,
        m = mt(p, d),
        y = mt(d, d),
        M = m * m - y * (mt(p, p) - 1);
      if (!(0 > M)) {
        var x = Math.sqrt(M),
          b = xt(d, (-m - x) / y);
        if (Mt(b, p), b = _t(b), !e) return b;
        var _,
          w = n[0],
          S = t[0],
          k = n[1],
          N = t[1];
        w > S && (_ = w, w = S, S = _);
        var E = S - w,
          A = Ma(E - ja) < Da,
          C = A || Da > E;
        if (!A && k > N && (_ = k, k = N, N = _), C ? A ? k + N > 0 ^ b[1] < (Ma(b[0] - w) < Da ? k : N) : k <= b[1] && b[1] <= N : E > ja ^ (w <= b[0] && b[0] <= S)) {
          var z = xt(d, (-m + x) / y);
          return Mt(z, p), [b, _t(z)];
        }
      }
    }
    function u(t, e) {
      var r = a ? n : ja - n,
        u = 0;
      return -r > t ? u |= 1 : t > r && (u |= 2), -r > e ? u |= 4 : e > r && (u |= 8), u;
    }
    var i = Math.cos(n),
      a = i > 0,
      o = Ma(i) > Da,
      l = ve(n, 6 * Oa);
    return Rt(t, e, l, a ? [0, -n] : [-ja, n - ja]);
  }
  function Yt(n, t, e, r) {
    return function (u) {
      var i,
        a = u.a,
        o = u.b,
        l = a.x,
        c = a.y,
        s = o.x,
        f = o.y,
        h = 0,
        g = 1,
        p = s - l,
        v = f - c;
      if (i = n - l, p || !(i > 0)) {
        if (i /= p, 0 > p) {
          if (h > i) return;
          g > i && (g = i);
        } else if (p > 0) {
          if (i > g) return;
          i > h && (h = i);
        }
        if (i = e - l, p || !(0 > i)) {
          if (i /= p, 0 > p) {
            if (i > g) return;
            i > h && (h = i);
          } else if (p > 0) {
            if (h > i) return;
            g > i && (g = i);
          }
          if (i = t - c, v || !(i > 0)) {
            if (i /= v, 0 > v) {
              if (h > i) return;
              g > i && (g = i);
            } else if (v > 0) {
              if (i > g) return;
              i > h && (h = i);
            }
            if (i = r - c, v || !(0 > i)) {
              if (i /= v, 0 > v) {
                if (i > g) return;
                i > h && (h = i);
              } else if (v > 0) {
                if (h > i) return;
                g > i && (g = i);
              }
              return h > 0 && (u.a = {
                x: l + h * p,
                y: c + h * v
              }), 1 > g && (u.b = {
                x: l + g * p,
                y: c + g * v
              }), u;
            }
          }
        }
      }
    };
  }
  function Zt(n, t, e, r) {
    function u(r, u) {
      return Ma(r[0] - n) < Da ? u > 0 ? 0 : 3 : Ma(r[0] - e) < Da ? u > 0 ? 2 : 1 : Ma(r[1] - t) < Da ? u > 0 ? 1 : 0 : u > 0 ? 3 : 2;
    }
    function i(n, t) {
      return a(n.x, t.x);
    }
    function a(n, t) {
      var e = u(n, 1),
        r = u(t, 1);
      return e !== r ? e - r : 0 === e ? t[1] - n[1] : 1 === e ? n[0] - t[0] : 2 === e ? n[1] - t[1] : t[0] - n[0];
    }
    return function (o) {
      function l(n) {
        for (var t = 0, e = d.length, r = n[1], u = 0; e > u; ++u) for (var i, a = 1, o = d[u], l = o.length, c = o[0]; l > a; ++a) i = o[a], c[1] <= r ? i[1] > r && Q(c, i, n) > 0 && ++t : i[1] <= r && Q(c, i, n) < 0 && --t, c = i;
        return 0 !== t;
      }
      function c(i, o, l, c) {
        var s = 0,
          f = 0;
        if (null == i || (s = u(i, l)) !== (f = u(o, l)) || a(i, o) < 0 ^ l > 0) {
          do c.point(0 === s || 3 === s ? n : e, s > 1 ? r : t); while ((s = (s + l + 4) % 4) !== f);
        } else c.point(o[0], o[1]);
      }
      function s(u, i) {
        return u >= n && e >= u && i >= t && r >= i;
      }
      function f(n, t) {
        s(n, t) && o.point(n, t);
      }
      function h() {
        C.point = p, d && d.push(m = []), S = !0, w = !1, b = _ = NaN;
      }
      function g() {
        v && (p(y, M), x && w && E.rejoin(), v.push(E.buffer())), C.point = f, w && o.lineEnd();
      }
      function p(n, t) {
        n = Math.max(-Fo, Math.min(Fo, n)), t = Math.max(-Fo, Math.min(Fo, t));
        var e = s(n, t);
        if (d && m.push([n, t]), S) y = n, M = t, x = e, S = !1, e && (o.lineStart(), o.point(n, t));else if (e && w) o.point(n, t);else {
          var r = {
            a: {
              x: b,
              y: _
            },
            b: {
              x: n,
              y: t
            }
          };
          A(r) ? (w || (o.lineStart(), o.point(r.a.x, r.a.y)), o.point(r.b.x, r.b.y), e || o.lineEnd(), k = !1) : e && (o.lineStart(), o.point(n, t), k = !1);
        }
        b = n, _ = t, w = e;
      }
      var v,
        d,
        m,
        y,
        M,
        x,
        b,
        _,
        w,
        S,
        k,
        N = o,
        E = Pt(),
        A = Yt(n, t, e, r),
        C = {
          point: f,
          lineStart: h,
          lineEnd: g,
          polygonStart: function () {
            o = E, v = [], d = [], k = !0;
          },
          polygonEnd: function () {
            o = N, v = oa.merge(v);
            var t = l([n, r]),
              e = k && t,
              u = v.length;
            (e || u) && (o.polygonStart(), e && (o.lineStart(), c(null, null, 1, o), o.lineEnd()), u && Lt(v, i, t, c, o), o.polygonEnd()), v = d = m = null;
          }
        };
      return C;
    };
  }
  function Vt(n) {
    var t = 0,
      e = ja / 3,
      r = oe(n),
      u = r(t, e);
    return u.parallels = function (n) {
      return arguments.length ? r(t = n[0] * ja / 180, e = n[1] * ja / 180) : [t / ja * 180, e / ja * 180];
    }, u;
  }
  function Xt(n, t) {
    function e(n, t) {
      var e = Math.sqrt(i - 2 * u * Math.sin(t)) / u;
      return [e * Math.sin(n *= u), a - e * Math.cos(n)];
    }
    var r = Math.sin(n),
      u = (r + Math.sin(t)) / 2,
      i = 1 + r * (2 * u - r),
      a = Math.sqrt(i) / u;
    return e.invert = function (n, t) {
      var e = a - t;
      return [Math.atan2(n, e) / u, tn((i - (n * n + e * e) * u * u) / (2 * u))];
    }, e;
  }
  function $t() {
    function n(n, t) {
      Oo += u * n - r * t, r = n, u = t;
    }
    var t, e, r, u;
    Xo.point = function (i, a) {
      Xo.point = n, t = r = i, e = u = a;
    }, Xo.lineEnd = function () {
      n(t, e);
    };
  }
  function Bt(n, t) {
    Io > n && (Io = n), n > Zo && (Zo = n), Yo > t && (Yo = t), t > Vo && (Vo = t);
  }
  function Wt() {
    function n(n, t) {
      a.push("M", n, ",", t, i);
    }
    function t(n, t) {
      a.push("M", n, ",", t), o.point = e;
    }
    function e(n, t) {
      a.push("L", n, ",", t);
    }
    function r() {
      o.point = n;
    }
    function u() {
      a.push("Z");
    }
    var i = Jt(4.5),
      a = [],
      o = {
        point: n,
        lineStart: function () {
          o.point = t;
        },
        lineEnd: r,
        polygonStart: function () {
          o.lineEnd = u;
        },
        polygonEnd: function () {
          o.lineEnd = r, o.point = n;
        },
        pointRadius: function (n) {
          return i = Jt(n), o;
        },
        result: function () {
          if (a.length) {
            var n = a.join("");
            return a = [], n;
          }
        }
      };
    return o;
  }
  function Jt(n) {
    return "m0," + n + "a" + n + "," + n + " 0 1,1 0," + -2 * n + "a" + n + "," + n + " 0 1,1 0," + 2 * n + "z";
  }
  function Gt(n, t) {
    Ao += n, Co += t, ++zo;
  }
  function Kt() {
    function n(n, r) {
      var u = n - t,
        i = r - e,
        a = Math.sqrt(u * u + i * i);
      Lo += a * (t + n) / 2, qo += a * (e + r) / 2, To += a, Gt(t = n, e = r);
    }
    var t, e;
    Bo.point = function (r, u) {
      Bo.point = n, Gt(t = r, e = u);
    };
  }
  function Qt() {
    Bo.point = Gt;
  }
  function ne() {
    function n(n, t) {
      var e = n - r,
        i = t - u,
        a = Math.sqrt(e * e + i * i);
      Lo += a * (r + n) / 2, qo += a * (u + t) / 2, To += a, a = u * n - r * t, Ro += a * (r + n), Do += a * (u + t), Po += 3 * a, Gt(r = n, u = t);
    }
    var t, e, r, u;
    Bo.point = function (i, a) {
      Bo.point = n, Gt(t = r = i, e = u = a);
    }, Bo.lineEnd = function () {
      n(t, e);
    };
  }
  function te(n) {
    function t(t, e) {
      n.moveTo(t + a, e), n.arc(t, e, a, 0, Ua);
    }
    function e(t, e) {
      n.moveTo(t, e), o.point = r;
    }
    function r(t, e) {
      n.lineTo(t, e);
    }
    function u() {
      o.point = t;
    }
    function i() {
      n.closePath();
    }
    var a = 4.5,
      o = {
        point: t,
        lineStart: function () {
          o.point = e;
        },
        lineEnd: u,
        polygonStart: function () {
          o.lineEnd = i;
        },
        polygonEnd: function () {
          o.lineEnd = u, o.point = t;
        },
        pointRadius: function (n) {
          return a = n, o;
        },
        result: b
      };
    return o;
  }
  function ee(n) {
    function t(n) {
      return (o ? r : e)(n);
    }
    function e(t) {
      return ie(t, function (e, r) {
        e = n(e, r), t.point(e[0], e[1]);
      });
    }
    function r(t) {
      function e(e, r) {
        e = n(e, r), t.point(e[0], e[1]);
      }
      function r() {
        M = NaN, S.point = i, t.lineStart();
      }
      function i(e, r) {
        var i = dt([e, r]),
          a = n(e, r);
        u(M, x, y, b, _, w, M = a[0], x = a[1], y = e, b = i[0], _ = i[1], w = i[2], o, t), t.point(M, x);
      }
      function a() {
        S.point = e, t.lineEnd();
      }
      function l() {
        r(), S.point = c, S.lineEnd = s;
      }
      function c(n, t) {
        i(f = n, h = t), g = M, p = x, v = b, d = _, m = w, S.point = i;
      }
      function s() {
        u(M, x, y, b, _, w, g, p, f, v, d, m, o, t), S.lineEnd = a, a();
      }
      var f,
        h,
        g,
        p,
        v,
        d,
        m,
        y,
        M,
        x,
        b,
        _,
        w,
        S = {
          point: e,
          lineStart: r,
          lineEnd: a,
          polygonStart: function () {
            t.polygonStart(), S.lineStart = l;
          },
          polygonEnd: function () {
            t.polygonEnd(), S.lineStart = r;
          }
        };
      return S;
    }
    function u(t, e, r, o, l, c, s, f, h, g, p, v, d, m) {
      var y = s - t,
        M = f - e,
        x = y * y + M * M;
      if (x > 4 * i && d--) {
        var b = o + g,
          _ = l + p,
          w = c + v,
          S = Math.sqrt(b * b + _ * _ + w * w),
          k = Math.asin(w /= S),
          N = Ma(Ma(w) - 1) < Da || Ma(r - h) < Da ? (r + h) / 2 : Math.atan2(_, b),
          E = n(N, k),
          A = E[0],
          C = E[1],
          z = A - t,
          L = C - e,
          q = M * z - y * L;
        (q * q / x > i || Ma((y * z + M * L) / x - .5) > .3 || a > o * g + l * p + c * v) && (u(t, e, r, o, l, c, A, C, N, b /= S, _ /= S, w, d, m), m.point(A, C), u(A, C, N, b, _, w, s, f, h, g, p, v, d, m));
      }
    }
    var i = .5,
      a = Math.cos(30 * Oa),
      o = 16;
    return t.precision = function (n) {
      return arguments.length ? (o = (i = n * n) > 0 && 16, t) : Math.sqrt(i);
    }, t;
  }
  function re(n) {
    var t = ee(function (t, e) {
      return n([t * Ia, e * Ia]);
    });
    return function (n) {
      return le(t(n));
    };
  }
  function ue(n) {
    this.stream = n;
  }
  function ie(n, t) {
    return {
      point: t,
      sphere: function () {
        n.sphere();
      },
      lineStart: function () {
        n.lineStart();
      },
      lineEnd: function () {
        n.lineEnd();
      },
      polygonStart: function () {
        n.polygonStart();
      },
      polygonEnd: function () {
        n.polygonEnd();
      }
    };
  }
  function ae(n) {
    return oe(function () {
      return n;
    })();
  }
  function oe(n) {
    function t(n) {
      return n = o(n[0] * Oa, n[1] * Oa), [n[0] * h + l, c - n[1] * h];
    }
    function e(n) {
      return n = o.invert((n[0] - l) / h, (c - n[1]) / h), n && [n[0] * Ia, n[1] * Ia];
    }
    function r() {
      o = Ct(a = fe(m, M, x), i);
      var n = i(v, d);
      return l = g - n[0] * h, c = p + n[1] * h, u();
    }
    function u() {
      return s && (s.valid = !1, s = null), t;
    }
    var i,
      a,
      o,
      l,
      c,
      s,
      f = ee(function (n, t) {
        return n = i(n, t), [n[0] * h + l, c - n[1] * h];
      }),
      h = 150,
      g = 480,
      p = 250,
      v = 0,
      d = 0,
      m = 0,
      M = 0,
      x = 0,
      b = Uo,
      _ = y,
      w = null,
      S = null;
    return t.stream = function (n) {
      return s && (s.valid = !1), s = le(b(a, f(_(n)))), s.valid = !0, s;
    }, t.clipAngle = function (n) {
      return arguments.length ? (b = null == n ? (w = n, Uo) : It((w = +n) * Oa), u()) : w;
    }, t.clipExtent = function (n) {
      return arguments.length ? (S = n, _ = n ? Zt(n[0][0], n[0][1], n[1][0], n[1][1]) : y, u()) : S;
    }, t.scale = function (n) {
      return arguments.length ? (h = +n, r()) : h;
    }, t.translate = function (n) {
      return arguments.length ? (g = +n[0], p = +n[1], r()) : [g, p];
    }, t.center = function (n) {
      return arguments.length ? (v = n[0] % 360 * Oa, d = n[1] % 360 * Oa, r()) : [v * Ia, d * Ia];
    }, t.rotate = function (n) {
      return arguments.length ? (m = n[0] % 360 * Oa, M = n[1] % 360 * Oa, x = n.length > 2 ? n[2] % 360 * Oa : 0, r()) : [m * Ia, M * Ia, x * Ia];
    }, oa.rebind(t, f, "precision"), function () {
      return i = n.apply(this, arguments), t.invert = i.invert && e, r();
    };
  }
  function le(n) {
    return ie(n, function (t, e) {
      n.point(t * Oa, e * Oa);
    });
  }
  function ce(n, t) {
    return [n, t];
  }
  function se(n, t) {
    return [n > ja ? n - Ua : -ja > n ? n + Ua : n, t];
  }
  function fe(n, t, e) {
    return n ? t || e ? Ct(ge(n), pe(t, e)) : ge(n) : t || e ? pe(t, e) : se;
  }
  function he(n) {
    return function (t, e) {
      return t += n, [t > ja ? t - Ua : -ja > t ? t + Ua : t, e];
    };
  }
  function ge(n) {
    var t = he(n);
    return t.invert = he(-n), t;
  }
  function pe(n, t) {
    function e(n, t) {
      var e = Math.cos(t),
        o = Math.cos(n) * e,
        l = Math.sin(n) * e,
        c = Math.sin(t),
        s = c * r + o * u;
      return [Math.atan2(l * i - s * a, o * r - c * u), tn(s * i + l * a)];
    }
    var r = Math.cos(n),
      u = Math.sin(n),
      i = Math.cos(t),
      a = Math.sin(t);
    return e.invert = function (n, t) {
      var e = Math.cos(t),
        o = Math.cos(n) * e,
        l = Math.sin(n) * e,
        c = Math.sin(t),
        s = c * i - l * a;
      return [Math.atan2(l * i + c * a, o * r + s * u), tn(s * r - o * u)];
    }, e;
  }
  function ve(n, t) {
    var e = Math.cos(n),
      r = Math.sin(n);
    return function (u, i, a, o) {
      var l = a * t;
      null != u ? (u = de(e, u), i = de(e, i), (a > 0 ? i > u : u > i) && (u += a * Ua)) : (u = n + a * Ua, i = n - .5 * l);
      for (var c, s = u; a > 0 ? s > i : i > s; s -= l) o.point((c = _t([e, -r * Math.cos(s), -r * Math.sin(s)]))[0], c[1]);
    };
  }
  function de(n, t) {
    var e = dt(t);
    e[0] -= n, bt(e);
    var r = nn(-e[1]);
    return ((-e[2] < 0 ? -r : r) + 2 * Math.PI - Da) % (2 * Math.PI);
  }
  function me(n, t, e) {
    var r = oa.range(n, t - Da, e).concat(t);
    return function (n) {
      return r.map(function (t) {
        return [n, t];
      });
    };
  }
  function ye(n, t, e) {
    var r = oa.range(n, t - Da, e).concat(t);
    return function (n) {
      return r.map(function (t) {
        return [t, n];
      });
    };
  }
  function Me(n) {
    return n.source;
  }
  function xe(n) {
    return n.target;
  }
  function be(n, t, e, r) {
    var u = Math.cos(t),
      i = Math.sin(t),
      a = Math.cos(r),
      o = Math.sin(r),
      l = u * Math.cos(n),
      c = u * Math.sin(n),
      s = a * Math.cos(e),
      f = a * Math.sin(e),
      h = 2 * Math.asin(Math.sqrt(an(r - t) + u * a * an(e - n))),
      g = 1 / Math.sin(h),
      p = h ? function (n) {
        var t = Math.sin(n *= h) * g,
          e = Math.sin(h - n) * g,
          r = e * l + t * s,
          u = e * c + t * f,
          a = e * i + t * o;
        return [Math.atan2(u, r) * Ia, Math.atan2(a, Math.sqrt(r * r + u * u)) * Ia];
      } : function () {
        return [n * Ia, t * Ia];
      };
    return p.distance = h, p;
  }
  function _e() {
    function n(n, u) {
      var i = Math.sin(u *= Oa),
        a = Math.cos(u),
        o = Ma((n *= Oa) - t),
        l = Math.cos(o);
      Wo += Math.atan2(Math.sqrt((o = a * Math.sin(o)) * o + (o = r * i - e * a * l) * o), e * i + r * a * l), t = n, e = i, r = a;
    }
    var t, e, r;
    Jo.point = function (u, i) {
      t = u * Oa, e = Math.sin(i *= Oa), r = Math.cos(i), Jo.point = n;
    }, Jo.lineEnd = function () {
      Jo.point = Jo.lineEnd = b;
    };
  }
  function we(n, t) {
    function e(t, e) {
      var r = Math.cos(t),
        u = Math.cos(e),
        i = n(r * u);
      return [i * u * Math.sin(t), i * Math.sin(e)];
    }
    return e.invert = function (n, e) {
      var r = Math.sqrt(n * n + e * e),
        u = t(r),
        i = Math.sin(u),
        a = Math.cos(u);
      return [Math.atan2(n * i, r * a), Math.asin(r && e * i / r)];
    }, e;
  }
  function Se(n, t) {
    function e(n, t) {
      a > 0 ? -Ha + Da > t && (t = -Ha + Da) : t > Ha - Da && (t = Ha - Da);
      var e = a / Math.pow(u(t), i);
      return [e * Math.sin(i * n), a - e * Math.cos(i * n)];
    }
    var r = Math.cos(n),
      u = function (n) {
        return Math.tan(ja / 4 + n / 2);
      },
      i = n === t ? Math.sin(n) : Math.log(r / Math.cos(t)) / Math.log(u(t) / u(n)),
      a = r * Math.pow(u(n), i) / i;
    return i ? (e.invert = function (n, t) {
      var e = a - t,
        r = K(i) * Math.sqrt(n * n + e * e);
      return [Math.atan2(n, e) / i, 2 * Math.atan(Math.pow(a / r, 1 / i)) - Ha];
    }, e) : Ne;
  }
  function ke(n, t) {
    function e(n, t) {
      var e = i - t;
      return [e * Math.sin(u * n), i - e * Math.cos(u * n)];
    }
    var r = Math.cos(n),
      u = n === t ? Math.sin(n) : (r - Math.cos(t)) / (t - n),
      i = r / u + n;
    return Ma(u) < Da ? ce : (e.invert = function (n, t) {
      var e = i - t;
      return [Math.atan2(n, e) / u, i - K(u) * Math.sqrt(n * n + e * e)];
    }, e);
  }
  function Ne(n, t) {
    return [n, Math.log(Math.tan(ja / 4 + t / 2))];
  }
  function Ee(n) {
    var t,
      e = ae(n),
      r = e.scale,
      u = e.translate,
      i = e.clipExtent;
    return e.scale = function () {
      var n = r.apply(e, arguments);
      return n === e ? t ? e.clipExtent(null) : e : n;
    }, e.translate = function () {
      var n = u.apply(e, arguments);
      return n === e ? t ? e.clipExtent(null) : e : n;
    }, e.clipExtent = function (n) {
      var a = i.apply(e, arguments);
      if (a === e) {
        if (t = null == n) {
          var o = ja * r(),
            l = u();
          i([[l[0] - o, l[1] - o], [l[0] + o, l[1] + o]]);
        }
      } else t && (a = null);
      return a;
    }, e.clipExtent(null);
  }
  function Ae(n, t) {
    return [Math.log(Math.tan(ja / 4 + t / 2)), -n];
  }
  function Ce(n) {
    return n[0];
  }
  function ze(n) {
    return n[1];
  }
  function Le(n) {
    for (var t = n.length, e = [0, 1], r = 2, u = 2; t > u; u++) {
      for (; r > 1 && Q(n[e[r - 2]], n[e[r - 1]], n[u]) <= 0;) --r;
      e[r++] = u;
    }
    return e.slice(0, r);
  }
  function qe(n, t) {
    return n[0] - t[0] || n[1] - t[1];
  }
  function Te(n, t, e) {
    return (e[0] - t[0]) * (n[1] - t[1]) < (e[1] - t[1]) * (n[0] - t[0]);
  }
  function Re(n, t, e, r) {
    var u = n[0],
      i = e[0],
      a = t[0] - u,
      o = r[0] - i,
      l = n[1],
      c = e[1],
      s = t[1] - l,
      f = r[1] - c,
      h = (o * (l - c) - f * (u - i)) / (f * a - o * s);
    return [u + h * a, l + h * s];
  }
  function De(n) {
    var t = n[0],
      e = n[n.length - 1];
    return !(t[0] - e[0] || t[1] - e[1]);
  }
  function Pe() {
    rr(this), this.edge = this.site = this.circle = null;
  }
  function je(n) {
    var t = ll.pop() || new Pe();
    return t.site = n, t;
  }
  function Ue(n) {
    Be(n), il.remove(n), ll.push(n), rr(n);
  }
  function Fe(n) {
    var t = n.circle,
      e = t.x,
      r = t.cy,
      u = {
        x: e,
        y: r
      },
      i = n.P,
      a = n.N,
      o = [n];
    Ue(n);
    for (var l = i; l.circle && Ma(e - l.circle.x) < Da && Ma(r - l.circle.cy) < Da;) i = l.P, o.unshift(l), Ue(l), l = i;
    o.unshift(l), Be(l);
    for (var c = a; c.circle && Ma(e - c.circle.x) < Da && Ma(r - c.circle.cy) < Da;) a = c.N, o.push(c), Ue(c), c = a;
    o.push(c), Be(c);
    var s,
      f = o.length;
    for (s = 1; f > s; ++s) c = o[s], l = o[s - 1], nr(c.edge, l.site, c.site, u);
    l = o[0], c = o[f - 1], c.edge = Ke(l.site, c.site, null, u), $e(l), $e(c);
  }
  function He(n) {
    for (var t, e, r, u, i = n.x, a = n.y, o = il._; o;) if (r = Oe(o, a) - i, r > Da) o = o.L;else {
      if (u = i - Ie(o, a), !(u > Da)) {
        r > -Da ? (t = o.P, e = o) : u > -Da ? (t = o, e = o.N) : t = e = o;
        break;
      }
      if (!o.R) {
        t = o;
        break;
      }
      o = o.R;
    }
    var l = je(n);
    if (il.insert(t, l), t || e) {
      if (t === e) return Be(t), e = je(t.site), il.insert(l, e), l.edge = e.edge = Ke(t.site, l.site), $e(t), void $e(e);
      if (!e) return void (l.edge = Ke(t.site, l.site));
      Be(t), Be(e);
      var c = t.site,
        s = c.x,
        f = c.y,
        h = n.x - s,
        g = n.y - f,
        p = e.site,
        v = p.x - s,
        d = p.y - f,
        m = 2 * (h * d - g * v),
        y = h * h + g * g,
        M = v * v + d * d,
        x = {
          x: (d * y - g * M) / m + s,
          y: (h * M - v * y) / m + f
        };
      nr(e.edge, c, p, x), l.edge = Ke(c, n, null, x), e.edge = Ke(n, p, null, x), $e(t), $e(e);
    }
  }
  function Oe(n, t) {
    var e = n.site,
      r = e.x,
      u = e.y,
      i = u - t;
    if (!i) return r;
    var a = n.P;
    if (!a) return -(1 / 0);
    e = a.site;
    var o = e.x,
      l = e.y,
      c = l - t;
    if (!c) return o;
    var s = o - r,
      f = 1 / i - 1 / c,
      h = s / c;
    return f ? (-h + Math.sqrt(h * h - 2 * f * (s * s / (-2 * c) - l + c / 2 + u - i / 2))) / f + r : (r + o) / 2;
  }
  function Ie(n, t) {
    var e = n.N;
    if (e) return Oe(e, t);
    var r = n.site;
    return r.y === t ? r.x : 1 / 0;
  }
  function Ye(n) {
    this.site = n, this.edges = [];
  }
  function Ze(n) {
    for (var t, e, r, u, i, a, o, l, c, s, f = n[0][0], h = n[1][0], g = n[0][1], p = n[1][1], v = ul, d = v.length; d--;) if (i = v[d], i && i.prepare()) for (o = i.edges, l = o.length, a = 0; l > a;) s = o[a].end(), r = s.x, u = s.y, c = o[++a % l].start(), t = c.x, e = c.y, (Ma(r - t) > Da || Ma(u - e) > Da) && (o.splice(a, 0, new tr(Qe(i.site, s, Ma(r - f) < Da && p - u > Da ? {
      x: f,
      y: Ma(t - f) < Da ? e : p
    } : Ma(u - p) < Da && h - r > Da ? {
      x: Ma(e - p) < Da ? t : h,
      y: p
    } : Ma(r - h) < Da && u - g > Da ? {
      x: h,
      y: Ma(t - h) < Da ? e : g
    } : Ma(u - g) < Da && r - f > Da ? {
      x: Ma(e - g) < Da ? t : f,
      y: g
    } : null), i.site, null)), ++l);
  }
  function Ve(n, t) {
    return t.angle - n.angle;
  }
  function Xe() {
    rr(this), this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function $e(n) {
    var t = n.P,
      e = n.N;
    if (t && e) {
      var r = t.site,
        u = n.site,
        i = e.site;
      if (r !== i) {
        var a = u.x,
          o = u.y,
          l = r.x - a,
          c = r.y - o,
          s = i.x - a,
          f = i.y - o,
          h = 2 * (l * f - c * s);
        if (!(h >= -Pa)) {
          var g = l * l + c * c,
            p = s * s + f * f,
            v = (f * g - c * p) / h,
            d = (l * p - s * g) / h,
            f = d + o,
            m = cl.pop() || new Xe();
          m.arc = n, m.site = u, m.x = v + a, m.y = f + Math.sqrt(v * v + d * d), m.cy = f, n.circle = m;
          for (var y = null, M = ol._; M;) if (m.y < M.y || m.y === M.y && m.x <= M.x) {
            if (!M.L) {
              y = M.P;
              break;
            }
            M = M.L;
          } else {
            if (!M.R) {
              y = M;
              break;
            }
            M = M.R;
          }
          ol.insert(y, m), y || (al = m);
        }
      }
    }
  }
  function Be(n) {
    var t = n.circle;
    t && (t.P || (al = t.N), ol.remove(t), cl.push(t), rr(t), n.circle = null);
  }
  function We(n) {
    for (var t, e = rl, r = Yt(n[0][0], n[0][1], n[1][0], n[1][1]), u = e.length; u--;) t = e[u], (!Je(t, n) || !r(t) || Ma(t.a.x - t.b.x) < Da && Ma(t.a.y - t.b.y) < Da) && (t.a = t.b = null, e.splice(u, 1));
  }
  function Je(n, t) {
    var e = n.b;
    if (e) return !0;
    var r,
      u,
      i = n.a,
      a = t[0][0],
      o = t[1][0],
      l = t[0][1],
      c = t[1][1],
      s = n.l,
      f = n.r,
      h = s.x,
      g = s.y,
      p = f.x,
      v = f.y,
      d = (h + p) / 2,
      m = (g + v) / 2;
    if (v === g) {
      if (a > d || d >= o) return;
      if (h > p) {
        if (i) {
          if (i.y >= c) return;
        } else i = {
          x: d,
          y: l
        };
        e = {
          x: d,
          y: c
        };
      } else {
        if (i) {
          if (i.y < l) return;
        } else i = {
          x: d,
          y: c
        };
        e = {
          x: d,
          y: l
        };
      }
    } else if (r = (h - p) / (v - g), u = m - r * d, -1 > r || r > 1) {
      if (h > p) {
        if (i) {
          if (i.y >= c) return;
        } else i = {
          x: (l - u) / r,
          y: l
        };
        e = {
          x: (c - u) / r,
          y: c
        };
      } else {
        if (i) {
          if (i.y < l) return;
        } else i = {
          x: (c - u) / r,
          y: c
        };
        e = {
          x: (l - u) / r,
          y: l
        };
      }
    } else if (v > g) {
      if (i) {
        if (i.x >= o) return;
      } else i = {
        x: a,
        y: r * a + u
      };
      e = {
        x: o,
        y: r * o + u
      };
    } else {
      if (i) {
        if (i.x < a) return;
      } else i = {
        x: o,
        y: r * o + u
      };
      e = {
        x: a,
        y: r * a + u
      };
    }
    return n.a = i, n.b = e, !0;
  }
  function Ge(n, t) {
    this.l = n, this.r = t, this.a = this.b = null;
  }
  function Ke(n, t, e, r) {
    var u = new Ge(n, t);
    return rl.push(u), e && nr(u, n, t, e), r && nr(u, t, n, r), ul[n.i].edges.push(new tr(u, n, t)), ul[t.i].edges.push(new tr(u, t, n)), u;
  }
  function Qe(n, t, e) {
    var r = new Ge(n, null);
    return r.a = t, r.b = e, rl.push(r), r;
  }
  function nr(n, t, e, r) {
    n.a || n.b ? n.l === e ? n.b = r : n.a = r : (n.a = r, n.l = t, n.r = e);
  }
  function tr(n, t, e) {
    var r = n.a,
      u = n.b;
    this.edge = n, this.site = t, this.angle = e ? Math.atan2(e.y - t.y, e.x - t.x) : n.l === t ? Math.atan2(u.x - r.x, r.y - u.y) : Math.atan2(r.x - u.x, u.y - r.y);
  }
  function er() {
    this._ = null;
  }
  function rr(n) {
    n.U = n.C = n.L = n.R = n.P = n.N = null;
  }
  function ur(n, t) {
    var e = t,
      r = t.R,
      u = e.U;
    u ? u.L === e ? u.L = r : u.R = r : n._ = r, r.U = u, e.U = r, e.R = r.L, e.R && (e.R.U = e), r.L = e;
  }
  function ir(n, t) {
    var e = t,
      r = t.L,
      u = e.U;
    u ? u.L === e ? u.L = r : u.R = r : n._ = r, r.U = u, e.U = r, e.L = r.R, e.L && (e.L.U = e), r.R = e;
  }
  function ar(n) {
    for (; n.L;) n = n.L;
    return n;
  }
  function or(n, t) {
    var e,
      r,
      u,
      i = n.sort(lr).pop();
    for (rl = [], ul = new Array(n.length), il = new er(), ol = new er();;) if (u = al, i && (!u || i.y < u.y || i.y === u.y && i.x < u.x)) (i.x !== e || i.y !== r) && (ul[i.i] = new Ye(i), He(i), e = i.x, r = i.y), i = n.pop();else {
      if (!u) break;
      Fe(u.arc);
    }
    t && (We(t), Ze(t));
    var a = {
      cells: ul,
      edges: rl
    };
    return il = ol = rl = ul = null, a;
  }
  function lr(n, t) {
    return t.y - n.y || t.x - n.x;
  }
  function cr(n, t, e) {
    return (n.x - e.x) * (t.y - n.y) - (n.x - t.x) * (e.y - n.y);
  }
  function sr(n) {
    return n.x;
  }
  function fr(n) {
    return n.y;
  }
  function hr() {
    return {
      leaf: !0,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function gr(n, t, e, r, u, i) {
    if (!n(t, e, r, u, i)) {
      var a = .5 * (e + u),
        o = .5 * (r + i),
        l = t.nodes;
      l[0] && gr(n, l[0], e, r, a, o), l[1] && gr(n, l[1], a, r, u, o), l[2] && gr(n, l[2], e, o, a, i), l[3] && gr(n, l[3], a, o, u, i);
    }
  }
  function pr(n, t, e, r, u, i, a) {
    var o,
      l = 1 / 0;
    return function c(n, s, f, h, g) {
      if (!(s > i || f > a || r > h || u > g)) {
        if (p = n.point) {
          var p,
            v = t - n.x,
            d = e - n.y,
            m = v * v + d * d;
          if (l > m) {
            var y = Math.sqrt(l = m);
            r = t - y, u = e - y, i = t + y, a = e + y, o = p;
          }
        }
        for (var M = n.nodes, x = .5 * (s + h), b = .5 * (f + g), _ = t >= x, w = e >= b, S = w << 1 | _, k = S + 4; k > S; ++S) if (n = M[3 & S]) switch (3 & S) {
          case 0:
            c(n, s, f, x, b);
            break;
          case 1:
            c(n, x, f, h, b);
            break;
          case 2:
            c(n, s, b, x, g);
            break;
          case 3:
            c(n, x, b, h, g);
        }
      }
    }(n, r, u, i, a), o;
  }
  function vr(n, t) {
    n = oa.rgb(n), t = oa.rgb(t);
    var e = n.r,
      r = n.g,
      u = n.b,
      i = t.r - e,
      a = t.g - r,
      o = t.b - u;
    return function (n) {
      return "#" + bn(Math.round(e + i * n)) + bn(Math.round(r + a * n)) + bn(Math.round(u + o * n));
    };
  }
  function dr(n, t) {
    var e,
      r = {},
      u = {};
    for (e in n) e in t ? r[e] = Mr(n[e], t[e]) : u[e] = n[e];
    for (e in t) e in n || (u[e] = t[e]);
    return function (n) {
      for (e in r) u[e] = r[e](n);
      return u;
    };
  }
  function mr(n, t) {
    return n = +n, t = +t, function (e) {
      return n * (1 - e) + t * e;
    };
  }
  function yr(n, t) {
    var e,
      r,
      u,
      i = fl.lastIndex = hl.lastIndex = 0,
      a = -1,
      o = [],
      l = [];
    for (n += "", t += ""; (e = fl.exec(n)) && (r = hl.exec(t));) (u = r.index) > i && (u = t.slice(i, u), o[a] ? o[a] += u : o[++a] = u), (e = e[0]) === (r = r[0]) ? o[a] ? o[a] += r : o[++a] = r : (o[++a] = null, l.push({
      i: a,
      x: mr(e, r)
    })), i = hl.lastIndex;
    return i < t.length && (u = t.slice(i), o[a] ? o[a] += u : o[++a] = u), o.length < 2 ? l[0] ? (t = l[0].x, function (n) {
      return t(n) + "";
    }) : function () {
      return t;
    } : (t = l.length, function (n) {
      for (var e, r = 0; t > r; ++r) o[(e = l[r]).i] = e.x(n);
      return o.join("");
    });
  }
  function Mr(n, t) {
    for (var e, r = oa.interpolators.length; --r >= 0 && !(e = oa.interpolators[r](n, t)););
    return e;
  }
  function xr(n, t) {
    var e,
      r = [],
      u = [],
      i = n.length,
      a = t.length,
      o = Math.min(n.length, t.length);
    for (e = 0; o > e; ++e) r.push(Mr(n[e], t[e]));
    for (; i > e; ++e) u[e] = n[e];
    for (; a > e; ++e) u[e] = t[e];
    return function (n) {
      for (e = 0; o > e; ++e) u[e] = r[e](n);
      return u;
    };
  }
  function br(n) {
    return function (t) {
      return 0 >= t ? 0 : t >= 1 ? 1 : n(t);
    };
  }
  function _r(n) {
    return function (t) {
      return 1 - n(1 - t);
    };
  }
  function wr(n) {
    return function (t) {
      return .5 * (.5 > t ? n(2 * t) : 2 - n(2 - 2 * t));
    };
  }
  function Sr(n) {
    return n * n;
  }
  function kr(n) {
    return n * n * n;
  }
  function Nr(n) {
    if (0 >= n) return 0;
    if (n >= 1) return 1;
    var t = n * n,
      e = t * n;
    return 4 * (.5 > n ? e : 3 * (n - t) + e - .75);
  }
  function Er(n) {
    return function (t) {
      return Math.pow(t, n);
    };
  }
  function Ar(n) {
    return 1 - Math.cos(n * Ha);
  }
  function Cr(n) {
    return Math.pow(2, 10 * (n - 1));
  }
  function zr(n) {
    return 1 - Math.sqrt(1 - n * n);
  }
  function Lr(n, t) {
    var e;
    return arguments.length < 2 && (t = .45), arguments.length ? e = t / Ua * Math.asin(1 / n) : (n = 1, e = t / 4), function (r) {
      return 1 + n * Math.pow(2, -10 * r) * Math.sin((r - e) * Ua / t);
    };
  }
  function qr(n) {
    return n || (n = 1.70158), function (t) {
      return t * t * ((n + 1) * t - n);
    };
  }
  function Tr(n) {
    return 1 / 2.75 > n ? 7.5625 * n * n : 2 / 2.75 > n ? 7.5625 * (n -= 1.5 / 2.75) * n + .75 : 2.5 / 2.75 > n ? 7.5625 * (n -= 2.25 / 2.75) * n + .9375 : 7.5625 * (n -= 2.625 / 2.75) * n + .984375;
  }
  function Rr(n, t) {
    n = oa.hcl(n), t = oa.hcl(t);
    var e = n.h,
      r = n.c,
      u = n.l,
      i = t.h - e,
      a = t.c - r,
      o = t.l - u;
    return isNaN(a) && (a = 0, r = isNaN(r) ? t.c : r), isNaN(i) ? (i = 0, e = isNaN(e) ? t.h : e) : i > 180 ? i -= 360 : -180 > i && (i += 360), function (n) {
      return fn(e + i * n, r + a * n, u + o * n) + "";
    };
  }
  function Dr(n, t) {
    n = oa.hsl(n), t = oa.hsl(t);
    var e = n.h,
      r = n.s,
      u = n.l,
      i = t.h - e,
      a = t.s - r,
      o = t.l - u;
    return isNaN(a) && (a = 0, r = isNaN(r) ? t.s : r), isNaN(i) ? (i = 0, e = isNaN(e) ? t.h : e) : i > 180 ? i -= 360 : -180 > i && (i += 360), function (n) {
      return cn(e + i * n, r + a * n, u + o * n) + "";
    };
  }
  function Pr(n, t) {
    n = oa.lab(n), t = oa.lab(t);
    var e = n.l,
      r = n.a,
      u = n.b,
      i = t.l - e,
      a = t.a - r,
      o = t.b - u;
    return function (n) {
      return gn(e + i * n, r + a * n, u + o * n) + "";
    };
  }
  function jr(n, t) {
    return t -= n, function (e) {
      return Math.round(n + t * e);
    };
  }
  function Ur(n) {
    var t = [n.a, n.b],
      e = [n.c, n.d],
      r = Hr(t),
      u = Fr(t, e),
      i = Hr(Or(e, t, -u)) || 0;
    t[0] * e[1] < e[0] * t[1] && (t[0] *= -1, t[1] *= -1, r *= -1, u *= -1), this.rotate = (r ? Math.atan2(t[1], t[0]) : Math.atan2(-e[0], e[1])) * Ia, this.translate = [n.e, n.f], this.scale = [r, i], this.skew = i ? Math.atan2(u, i) * Ia : 0;
  }
  function Fr(n, t) {
    return n[0] * t[0] + n[1] * t[1];
  }
  function Hr(n) {
    var t = Math.sqrt(Fr(n, n));
    return t && (n[0] /= t, n[1] /= t), t;
  }
  function Or(n, t, e) {
    return n[0] += e * t[0], n[1] += e * t[1], n;
  }
  function Ir(n) {
    return n.length ? n.pop() + "," : "";
  }
  function Yr(n, t, e, r) {
    if (n[0] !== t[0] || n[1] !== t[1]) {
      var u = e.push("translate(", null, ",", null, ")");
      r.push({
        i: u - 4,
        x: mr(n[0], t[0])
      }, {
        i: u - 2,
        x: mr(n[1], t[1])
      });
    } else (t[0] || t[1]) && e.push("translate(" + t + ")");
  }
  function Zr(n, t, e, r) {
    n !== t ? (n - t > 180 ? t += 360 : t - n > 180 && (n += 360), r.push({
      i: e.push(Ir(e) + "rotate(", null, ")") - 2,
      x: mr(n, t)
    })) : t && e.push(Ir(e) + "rotate(" + t + ")");
  }
  function Vr(n, t, e, r) {
    n !== t ? r.push({
      i: e.push(Ir(e) + "skewX(", null, ")") - 2,
      x: mr(n, t)
    }) : t && e.push(Ir(e) + "skewX(" + t + ")");
  }
  function Xr(n, t, e, r) {
    if (n[0] !== t[0] || n[1] !== t[1]) {
      var u = e.push(Ir(e) + "scale(", null, ",", null, ")");
      r.push({
        i: u - 4,
        x: mr(n[0], t[0])
      }, {
        i: u - 2,
        x: mr(n[1], t[1])
      });
    } else (1 !== t[0] || 1 !== t[1]) && e.push(Ir(e) + "scale(" + t + ")");
  }
  function $r(n, t) {
    var e = [],
      r = [];
    return n = oa.transform(n), t = oa.transform(t), Yr(n.translate, t.translate, e, r), Zr(n.rotate, t.rotate, e, r), Vr(n.skew, t.skew, e, r), Xr(n.scale, t.scale, e, r), n = t = null, function (n) {
      for (var t, u = -1, i = r.length; ++u < i;) e[(t = r[u]).i] = t.x(n);
      return e.join("");
    };
  }
  function Br(n, t) {
    return t = (t -= n = +n) || 1 / t, function (e) {
      return (e - n) / t;
    };
  }
  function Wr(n, t) {
    return t = (t -= n = +n) || 1 / t, function (e) {
      return Math.max(0, Math.min(1, (e - n) / t));
    };
  }
  function Jr(n) {
    for (var t = n.source, e = n.target, r = Kr(t, e), u = [t]; t !== r;) t = t.parent, u.push(t);
    for (var i = u.length; e !== r;) u.splice(i, 0, e), e = e.parent;
    return u;
  }
  function Gr(n) {
    for (var t = [], e = n.parent; null != e;) t.push(n), n = e, e = e.parent;
    return t.push(n), t;
  }
  function Kr(n, t) {
    if (n === t) return n;
    for (var e = Gr(n), r = Gr(t), u = e.pop(), i = r.pop(), a = null; u === i;) a = u, u = e.pop(), i = r.pop();
    return a;
  }
  function Qr(n) {
    n.fixed |= 2;
  }
  function nu(n) {
    n.fixed &= -7;
  }
  function tu(n) {
    n.fixed |= 4, n.px = n.x, n.py = n.y;
  }
  function eu(n) {
    n.fixed &= -5;
  }
  function ru(n, t, e) {
    var r = 0,
      u = 0;
    if (n.charge = 0, !n.leaf) for (var i, a = n.nodes, o = a.length, l = -1; ++l < o;) i = a[l], null != i && (ru(i, t, e), n.charge += i.charge, r += i.charge * i.cx, u += i.charge * i.cy);
    if (n.point) {
      n.leaf || (n.point.x += Math.random() - .5, n.point.y += Math.random() - .5);
      var c = t * e[n.point.index];
      n.charge += n.pointCharge = c, r += c * n.point.x, u += c * n.point.y;
    }
    n.cx = r / n.charge, n.cy = u / n.charge;
  }
  function uu(n, t) {
    return oa.rebind(n, t, "sort", "children", "value"), n.nodes = n, n.links = su, n;
  }
  function iu(n, t) {
    for (var e = [n]; null != (n = e.pop());) if (t(n), (u = n.children) && (r = u.length)) for (var r, u; --r >= 0;) e.push(u[r]);
  }
  function au(n, t) {
    for (var e = [n], r = []; null != (n = e.pop());) if (r.push(n), (i = n.children) && (u = i.length)) for (var u, i, a = -1; ++a < u;) e.push(i[a]);
    for (; null != (n = r.pop());) t(n);
  }
  function ou(n) {
    return n.children;
  }
  function lu(n) {
    return n.value;
  }
  function cu(n, t) {
    return t.value - n.value;
  }
  function su(n) {
    return oa.merge(n.map(function (n) {
      return (n.children || []).map(function (t) {
        return {
          source: n,
          target: t
        };
      });
    }));
  }
  function fu(n) {
    return n.x;
  }
  function hu(n) {
    return n.y;
  }
  function gu(n, t, e) {
    n.y0 = t, n.y = e;
  }
  function pu(n) {
    return oa.range(n.length);
  }
  function vu(n) {
    for (var t = -1, e = n[0].length, r = []; ++t < e;) r[t] = 0;
    return r;
  }
  function du(n) {
    for (var t, e = 1, r = 0, u = n[0][1], i = n.length; i > e; ++e) (t = n[e][1]) > u && (r = e, u = t);
    return r;
  }
  function mu(n) {
    return n.reduce(yu, 0);
  }
  function yu(n, t) {
    return n + t[1];
  }
  function Mu(n, t) {
    return xu(n, Math.ceil(Math.log(t.length) / Math.LN2 + 1));
  }
  function xu(n, t) {
    for (var e = -1, r = +n[0], u = (n[1] - r) / t, i = []; ++e <= t;) i[e] = u * e + r;
    return i;
  }
  function bu(n) {
    return [oa.min(n), oa.max(n)];
  }
  function _u(n, t) {
    return n.value - t.value;
  }
  function wu(n, t) {
    var e = n._pack_next;
    n._pack_next = t, t._pack_prev = n, t._pack_next = e, e._pack_prev = t;
  }
  function Su(n, t) {
    n._pack_next = t, t._pack_prev = n;
  }
  function ku(n, t) {
    var e = t.x - n.x,
      r = t.y - n.y,
      u = n.r + t.r;
    return .999 * u * u > e * e + r * r;
  }
  function Nu(n) {
    function t(n) {
      s = Math.min(n.x - n.r, s), f = Math.max(n.x + n.r, f), h = Math.min(n.y - n.r, h), g = Math.max(n.y + n.r, g);
    }
    if ((e = n.children) && (c = e.length)) {
      var e,
        r,
        u,
        i,
        a,
        o,
        l,
        c,
        s = 1 / 0,
        f = -(1 / 0),
        h = 1 / 0,
        g = -(1 / 0);
      if (e.forEach(Eu), r = e[0], r.x = -r.r, r.y = 0, t(r), c > 1 && (u = e[1], u.x = u.r, u.y = 0, t(u), c > 2)) for (i = e[2], zu(r, u, i), t(i), wu(r, i), r._pack_prev = i, wu(i, u), u = r._pack_next, a = 3; c > a; a++) {
        zu(r, u, i = e[a]);
        var p = 0,
          v = 1,
          d = 1;
        for (o = u._pack_next; o !== u; o = o._pack_next, v++) if (ku(o, i)) {
          p = 1;
          break;
        }
        if (1 == p) for (l = r._pack_prev; l !== o._pack_prev && !ku(l, i); l = l._pack_prev, d++);
        p ? (d > v || v == d && u.r < r.r ? Su(r, u = o) : Su(r = l, u), a--) : (wu(r, i), u = i, t(i));
      }
      var m = (s + f) / 2,
        y = (h + g) / 2,
        M = 0;
      for (a = 0; c > a; a++) i = e[a], i.x -= m, i.y -= y, M = Math.max(M, i.r + Math.sqrt(i.x * i.x + i.y * i.y));
      n.r = M, e.forEach(Au);
    }
  }
  function Eu(n) {
    n._pack_next = n._pack_prev = n;
  }
  function Au(n) {
    delete n._pack_next, delete n._pack_prev;
  }
  function Cu(n, t, e, r) {
    var u = n.children;
    if (n.x = t += r * n.x, n.y = e += r * n.y, n.r *= r, u) for (var i = -1, a = u.length; ++i < a;) Cu(u[i], t, e, r);
  }
  function zu(n, t, e) {
    var r = n.r + e.r,
      u = t.x - n.x,
      i = t.y - n.y;
    if (r && (u || i)) {
      var a = t.r + e.r,
        o = u * u + i * i;
      a *= a, r *= r;
      var l = .5 + (r - a) / (2 * o),
        c = Math.sqrt(Math.max(0, 2 * a * (r + o) - (r -= o) * r - a * a)) / (2 * o);
      e.x = n.x + l * u + c * i, e.y = n.y + l * i - c * u;
    } else e.x = n.x + r, e.y = n.y;
  }
  function Lu(n, t) {
    return n.parent == t.parent ? 1 : 2;
  }
  function qu(n) {
    var t = n.children;
    return t.length ? t[0] : n.t;
  }
  function Tu(n) {
    var t,
      e = n.children;
    return (t = e.length) ? e[t - 1] : n.t;
  }
  function Ru(n, t, e) {
    var r = e / (t.i - n.i);
    t.c -= r, t.s += e, n.c += r, t.z += e, t.m += e;
  }
  function Du(n) {
    for (var t, e = 0, r = 0, u = n.children, i = u.length; --i >= 0;) t = u[i], t.z += e, t.m += e, e += t.s + (r += t.c);
  }
  function Pu(n, t, e) {
    return n.a.parent === t.parent ? n.a : e;
  }
  function ju(n) {
    return 1 + oa.max(n, function (n) {
      return n.y;
    });
  }
  function Uu(n) {
    return n.reduce(function (n, t) {
      return n + t.x;
    }, 0) / n.length;
  }
  function Fu(n) {
    var t = n.children;
    return t && t.length ? Fu(t[0]) : n;
  }
  function Hu(n) {
    var t,
      e = n.children;
    return e && (t = e.length) ? Hu(e[t - 1]) : n;
  }
  function Ou(n) {
    return {
      x: n.x,
      y: n.y,
      dx: n.dx,
      dy: n.dy
    };
  }
  function Iu(n, t) {
    var e = n.x + t[3],
      r = n.y + t[0],
      u = n.dx - t[1] - t[3],
      i = n.dy - t[0] - t[2];
    return 0 > u && (e += u / 2, u = 0), 0 > i && (r += i / 2, i = 0), {
      x: e,
      y: r,
      dx: u,
      dy: i
    };
  }
  function Yu(n) {
    var t = n[0],
      e = n[n.length - 1];
    return e > t ? [t, e] : [e, t];
  }
  function Zu(n) {
    return n.rangeExtent ? n.rangeExtent() : Yu(n.range());
  }
  function Vu(n, t, e, r) {
    var u = e(n[0], n[1]),
      i = r(t[0], t[1]);
    return function (n) {
      return i(u(n));
    };
  }
  function Xu(n, t) {
    var e,
      r = 0,
      u = n.length - 1,
      i = n[r],
      a = n[u];
    return i > a && (e = r, r = u, u = e, e = i, i = a, a = e), n[r] = t.floor(i), n[u] = t.ceil(a), n;
  }
  function $u(n) {
    return n ? {
      floor: function (t) {
        return Math.floor(t / n) * n;
      },
      ceil: function (t) {
        return Math.ceil(t / n) * n;
      }
    } : wl;
  }
  function Bu(n, t, e, r) {
    var u = [],
      i = [],
      a = 0,
      o = Math.min(n.length, t.length) - 1;
    for (n[o] < n[0] && (n = n.slice().reverse(), t = t.slice().reverse()); ++a <= o;) u.push(e(n[a - 1], n[a])), i.push(r(t[a - 1], t[a]));
    return function (t) {
      var e = oa.bisect(n, t, 1, o) - 1;
      return i[e](u[e](t));
    };
  }
  function Wu(n, t, e, r) {
    function u() {
      var u = Math.min(n.length, t.length) > 2 ? Bu : Vu,
        l = r ? Wr : Br;
      return a = u(n, t, l, e), o = u(t, n, l, Mr), i;
    }
    function i(n) {
      return a(n);
    }
    var a, o;
    return i.invert = function (n) {
      return o(n);
    }, i.domain = function (t) {
      return arguments.length ? (n = t.map(Number), u()) : n;
    }, i.range = function (n) {
      return arguments.length ? (t = n, u()) : t;
    }, i.rangeRound = function (n) {
      return i.range(n).interpolate(jr);
    }, i.clamp = function (n) {
      return arguments.length ? (r = n, u()) : r;
    }, i.interpolate = function (n) {
      return arguments.length ? (e = n, u()) : e;
    }, i.ticks = function (t) {
      return Qu(n, t);
    }, i.tickFormat = function (t, e) {
      return ni(n, t, e);
    }, i.nice = function (t) {
      return Gu(n, t), u();
    }, i.copy = function () {
      return Wu(n, t, e, r);
    }, u();
  }
  function Ju(n, t) {
    return oa.rebind(n, t, "range", "rangeRound", "interpolate", "clamp");
  }
  function Gu(n, t) {
    return Xu(n, $u(Ku(n, t)[2])), Xu(n, $u(Ku(n, t)[2])), n;
  }
  function Ku(n, t) {
    null == t && (t = 10);
    var e = Yu(n),
      r = e[1] - e[0],
      u = Math.pow(10, Math.floor(Math.log(r / t) / Math.LN10)),
      i = t / r * u;
    return .15 >= i ? u *= 10 : .35 >= i ? u *= 5 : .75 >= i && (u *= 2), e[0] = Math.ceil(e[0] / u) * u, e[1] = Math.floor(e[1] / u) * u + .5 * u, e[2] = u, e;
  }
  function Qu(n, t) {
    return oa.range.apply(oa, Ku(n, t));
  }
  function ni(n, t, e) {
    var r = Ku(n, t);
    if (e) {
      var u = so.exec(e);
      if (u.shift(), "s" === u[8]) {
        var i = oa.formatPrefix(Math.max(Ma(r[0]), Ma(r[1])));
        return u[7] || (u[7] = "." + ti(i.scale(r[2]))), u[8] = "f", e = oa.format(u.join("")), function (n) {
          return e(i.scale(n)) + i.symbol;
        };
      }
      u[7] || (u[7] = "." + ei(u[8], r)), e = u.join("");
    } else e = ",." + ti(r[2]) + "f";
    return oa.format(e);
  }
  function ti(n) {
    return -Math.floor(Math.log(n) / Math.LN10 + .01);
  }
  function ei(n, t) {
    var e = ti(t[2]);
    return n in Sl ? Math.abs(e - ti(Math.max(Ma(t[0]), Ma(t[1])))) + +("e" !== n) : e - 2 * ("%" === n);
  }
  function ri(n, t, e, r) {
    function u(n) {
      return (e ? Math.log(0 > n ? 0 : n) : -Math.log(n > 0 ? 0 : -n)) / Math.log(t);
    }
    function i(n) {
      return e ? Math.pow(t, n) : -Math.pow(t, -n);
    }
    function a(t) {
      return n(u(t));
    }
    return a.invert = function (t) {
      return i(n.invert(t));
    }, a.domain = function (t) {
      return arguments.length ? (e = t[0] >= 0, n.domain((r = t.map(Number)).map(u)), a) : r;
    }, a.base = function (e) {
      return arguments.length ? (t = +e, n.domain(r.map(u)), a) : t;
    }, a.nice = function () {
      var t = Xu(r.map(u), e ? Math : Nl);
      return n.domain(t), r = t.map(i), a;
    }, a.ticks = function () {
      var n = Yu(r),
        a = [],
        o = n[0],
        l = n[1],
        c = Math.floor(u(o)),
        s = Math.ceil(u(l)),
        f = t % 1 ? 2 : t;
      if (isFinite(s - c)) {
        if (e) {
          for (; s > c; c++) for (var h = 1; f > h; h++) a.push(i(c) * h);
          a.push(i(c));
        } else for (a.push(i(c)); c++ < s;) for (var h = f - 1; h > 0; h--) a.push(i(c) * h);
        for (c = 0; a[c] < o; c++);
        for (s = a.length; a[s - 1] > l; s--);
        a = a.slice(c, s);
      }
      return a;
    }, a.tickFormat = function (n, e) {
      if (!arguments.length) return kl;
      arguments.length < 2 ? e = kl : "function" != typeof e && (e = oa.format(e));
      var r = Math.max(1, t * n / a.ticks().length);
      return function (n) {
        var a = n / i(Math.round(u(n)));
        return t - .5 > a * t && (a *= t), r >= a ? e(n) : "";
      };
    }, a.copy = function () {
      return ri(n.copy(), t, e, r);
    }, Ju(a, n);
  }
  function ui(n, t, e) {
    function r(t) {
      return n(u(t));
    }
    var u = ii(t),
      i = ii(1 / t);
    return r.invert = function (t) {
      return i(n.invert(t));
    }, r.domain = function (t) {
      return arguments.length ? (n.domain((e = t.map(Number)).map(u)), r) : e;
    }, r.ticks = function (n) {
      return Qu(e, n);
    }, r.tickFormat = function (n, t) {
      return ni(e, n, t);
    }, r.nice = function (n) {
      return r.domain(Gu(e, n));
    }, r.exponent = function (a) {
      return arguments.length ? (u = ii(t = a), i = ii(1 / t), n.domain(e.map(u)), r) : t;
    }, r.copy = function () {
      return ui(n.copy(), t, e);
    }, Ju(r, n);
  }
  function ii(n) {
    return function (t) {
      return 0 > t ? -Math.pow(-t, n) : Math.pow(t, n);
    };
  }
  function ai(n, t) {
    function e(e) {
      return i[((u.get(e) || ("range" === t.t ? u.set(e, n.push(e)) : NaN)) - 1) % i.length];
    }
    function r(t, e) {
      return oa.range(n.length).map(function (n) {
        return t + e * n;
      });
    }
    var u, i, a;
    return e.domain = function (r) {
      if (!arguments.length) return n;
      n = [], u = new c();
      for (var i, a = -1, o = r.length; ++a < o;) u.has(i = r[a]) || u.set(i, n.push(i));
      return e[t.t].apply(e, t.a);
    }, e.range = function (n) {
      return arguments.length ? (i = n, a = 0, t = {
        t: "range",
        a: arguments
      }, e) : i;
    }, e.rangePoints = function (u, o) {
      arguments.length < 2 && (o = 0);
      var l = u[0],
        c = u[1],
        s = n.length < 2 ? (l = (l + c) / 2, 0) : (c - l) / (n.length - 1 + o);
      return i = r(l + s * o / 2, s), a = 0, t = {
        t: "rangePoints",
        a: arguments
      }, e;
    }, e.rangeRoundPoints = function (u, o) {
      arguments.length < 2 && (o = 0);
      var l = u[0],
        c = u[1],
        s = n.length < 2 ? (l = c = Math.round((l + c) / 2), 0) : (c - l) / (n.length - 1 + o) | 0;
      return i = r(l + Math.round(s * o / 2 + (c - l - (n.length - 1 + o) * s) / 2), s), a = 0, t = {
        t: "rangeRoundPoints",
        a: arguments
      }, e;
    }, e.rangeBands = function (u, o, l) {
      arguments.length < 2 && (o = 0), arguments.length < 3 && (l = o);
      var c = u[1] < u[0],
        s = u[c - 0],
        f = u[1 - c],
        h = (f - s) / (n.length - o + 2 * l);
      return i = r(s + h * l, h), c && i.reverse(), a = h * (1 - o), t = {
        t: "rangeBands",
        a: arguments
      }, e;
    }, e.rangeRoundBands = function (u, o, l) {
      arguments.length < 2 && (o = 0), arguments.length < 3 && (l = o);
      var c = u[1] < u[0],
        s = u[c - 0],
        f = u[1 - c],
        h = Math.floor((f - s) / (n.length - o + 2 * l));
      return i = r(s + Math.round((f - s - (n.length - o) * h) / 2), h), c && i.reverse(), a = Math.round(h * (1 - o)), t = {
        t: "rangeRoundBands",
        a: arguments
      }, e;
    }, e.rangeBand = function () {
      return a;
    }, e.rangeExtent = function () {
      return Yu(t.a[0]);
    }, e.copy = function () {
      return ai(n, t);
    }, e.domain(n);
  }
  function oi(n, t) {
    function i() {
      var e = 0,
        r = t.length;
      for (o = []; ++e < r;) o[e - 1] = oa.quantile(n, e / r);
      return a;
    }
    function a(n) {
      return isNaN(n = +n) ? void 0 : t[oa.bisect(o, n)];
    }
    var o;
    return a.domain = function (t) {
      return arguments.length ? (n = t.map(r).filter(u).sort(e), i()) : n;
    }, a.range = function (n) {
      return arguments.length ? (t = n, i()) : t;
    }, a.quantiles = function () {
      return o;
    }, a.invertExtent = function (e) {
      return e = t.indexOf(e), 0 > e ? [NaN, NaN] : [e > 0 ? o[e - 1] : n[0], e < o.length ? o[e] : n[n.length - 1]];
    }, a.copy = function () {
      return oi(n, t);
    }, i();
  }
  function li(n, t, e) {
    function r(t) {
      return e[Math.max(0, Math.min(a, Math.floor(i * (t - n))))];
    }
    function u() {
      return i = e.length / (t - n), a = e.length - 1, r;
    }
    var i, a;
    return r.domain = function (e) {
      return arguments.length ? (n = +e[0], t = +e[e.length - 1], u()) : [n, t];
    }, r.range = function (n) {
      return arguments.length ? (e = n, u()) : e;
    }, r.invertExtent = function (t) {
      return t = e.indexOf(t), t = 0 > t ? NaN : t / i + n, [t, t + 1 / i];
    }, r.copy = function () {
      return li(n, t, e);
    }, u();
  }
  function ci(n, t) {
    function e(e) {
      return e >= e ? t[oa.bisect(n, e)] : void 0;
    }
    return e.domain = function (t) {
      return arguments.length ? (n = t, e) : n;
    }, e.range = function (n) {
      return arguments.length ? (t = n, e) : t;
    }, e.invertExtent = function (e) {
      return e = t.indexOf(e), [n[e - 1], n[e]];
    }, e.copy = function () {
      return ci(n, t);
    }, e;
  }
  function si(n) {
    function t(n) {
      return +n;
    }
    return t.invert = t, t.domain = t.range = function (e) {
      return arguments.length ? (n = e.map(t), t) : n;
    }, t.ticks = function (t) {
      return Qu(n, t);
    }, t.tickFormat = function (t, e) {
      return ni(n, t, e);
    }, t.copy = function () {
      return si(n);
    }, t;
  }
  function fi() {
    return 0;
  }
  function hi(n) {
    return n.innerRadius;
  }
  function gi(n) {
    return n.outerRadius;
  }
  function pi(n) {
    return n.startAngle;
  }
  function vi(n) {
    return n.endAngle;
  }
  function di(n) {
    return n && n.padAngle;
  }
  function mi(n, t, e, r) {
    return (n - e) * t - (t - r) * n > 0 ? 0 : 1;
  }
  function yi(n, t, e, r, u) {
    var i = n[0] - t[0],
      a = n[1] - t[1],
      o = (u ? r : -r) / Math.sqrt(i * i + a * a),
      l = o * a,
      c = -o * i,
      s = n[0] + l,
      f = n[1] + c,
      h = t[0] + l,
      g = t[1] + c,
      p = (s + h) / 2,
      v = (f + g) / 2,
      d = h - s,
      m = g - f,
      y = d * d + m * m,
      M = e - r,
      x = s * g - h * f,
      b = (0 > m ? -1 : 1) * Math.sqrt(Math.max(0, M * M * y - x * x)),
      _ = (x * m - d * b) / y,
      w = (-x * d - m * b) / y,
      S = (x * m + d * b) / y,
      k = (-x * d + m * b) / y,
      N = _ - p,
      E = w - v,
      A = S - p,
      C = k - v;
    return N * N + E * E > A * A + C * C && (_ = S, w = k), [[_ - l, w - c], [_ * e / M, w * e / M]];
  }
  function Mi(n) {
    function t(t) {
      function a() {
        c.push("M", i(n(s), o));
      }
      for (var l, c = [], s = [], f = -1, h = t.length, g = En(e), p = En(r); ++f < h;) u.call(this, l = t[f], f) ? s.push([+g.call(this, l, f), +p.call(this, l, f)]) : s.length && (a(), s = []);
      return s.length && a(), c.length ? c.join("") : null;
    }
    var e = Ce,
      r = ze,
      u = zt,
      i = xi,
      a = i.key,
      o = .7;
    return t.x = function (n) {
      return arguments.length ? (e = n, t) : e;
    }, t.y = function (n) {
      return arguments.length ? (r = n, t) : r;
    }, t.defined = function (n) {
      return arguments.length ? (u = n, t) : u;
    }, t.interpolate = function (n) {
      return arguments.length ? (a = "function" == typeof n ? i = n : (i = ql.get(n) || xi).key, t) : a;
    }, t.tension = function (n) {
      return arguments.length ? (o = n, t) : o;
    }, t;
  }
  function xi(n) {
    return n.length > 1 ? n.join("L") : n + "Z";
  }
  function bi(n) {
    return n.join("L") + "Z";
  }
  function _i(n) {
    for (var t = 0, e = n.length, r = n[0], u = [r[0], ",", r[1]]; ++t < e;) u.push("H", (r[0] + (r = n[t])[0]) / 2, "V", r[1]);
    return e > 1 && u.push("H", r[0]), u.join("");
  }
  function wi(n) {
    for (var t = 0, e = n.length, r = n[0], u = [r[0], ",", r[1]]; ++t < e;) u.push("V", (r = n[t])[1], "H", r[0]);
    return u.join("");
  }
  function Si(n) {
    for (var t = 0, e = n.length, r = n[0], u = [r[0], ",", r[1]]; ++t < e;) u.push("H", (r = n[t])[0], "V", r[1]);
    return u.join("");
  }
  function ki(n, t) {
    return n.length < 4 ? xi(n) : n[1] + Ai(n.slice(1, -1), Ci(n, t));
  }
  function Ni(n, t) {
    return n.length < 3 ? bi(n) : n[0] + Ai((n.push(n[0]), n), Ci([n[n.length - 2]].concat(n, [n[1]]), t));
  }
  function Ei(n, t) {
    return n.length < 3 ? xi(n) : n[0] + Ai(n, Ci(n, t));
  }
  function Ai(n, t) {
    if (t.length < 1 || n.length != t.length && n.length != t.length + 2) return xi(n);
    var e = n.length != t.length,
      r = "",
      u = n[0],
      i = n[1],
      a = t[0],
      o = a,
      l = 1;
    if (e && (r += "Q" + (i[0] - 2 * a[0] / 3) + "," + (i[1] - 2 * a[1] / 3) + "," + i[0] + "," + i[1], u = n[1], l = 2), t.length > 1) {
      o = t[1], i = n[l], l++, r += "C" + (u[0] + a[0]) + "," + (u[1] + a[1]) + "," + (i[0] - o[0]) + "," + (i[1] - o[1]) + "," + i[0] + "," + i[1];
      for (var c = 2; c < t.length; c++, l++) i = n[l], o = t[c], r += "S" + (i[0] - o[0]) + "," + (i[1] - o[1]) + "," + i[0] + "," + i[1];
    }
    if (e) {
      var s = n[l];
      r += "Q" + (i[0] + 2 * o[0] / 3) + "," + (i[1] + 2 * o[1] / 3) + "," + s[0] + "," + s[1];
    }
    return r;
  }
  function Ci(n, t) {
    for (var e, r = [], u = (1 - t) / 2, i = n[0], a = n[1], o = 1, l = n.length; ++o < l;) e = i, i = a, a = n[o], r.push([u * (a[0] - e[0]), u * (a[1] - e[1])]);
    return r;
  }
  function zi(n) {
    if (n.length < 3) return xi(n);
    var t = 1,
      e = n.length,
      r = n[0],
      u = r[0],
      i = r[1],
      a = [u, u, u, (r = n[1])[0]],
      o = [i, i, i, r[1]],
      l = [u, ",", i, "L", Ri(Dl, a), ",", Ri(Dl, o)];
    for (n.push(n[e - 1]); ++t <= e;) r = n[t], a.shift(), a.push(r[0]), o.shift(), o.push(r[1]), Di(l, a, o);
    return n.pop(), l.push("L", r), l.join("");
  }
  function Li(n) {
    if (n.length < 4) return xi(n);
    for (var t, e = [], r = -1, u = n.length, i = [0], a = [0]; ++r < 3;) t = n[r], i.push(t[0]), a.push(t[1]);
    for (e.push(Ri(Dl, i) + "," + Ri(Dl, a)), --r; ++r < u;) t = n[r], i.shift(), i.push(t[0]), a.shift(), a.push(t[1]), Di(e, i, a);
    return e.join("");
  }
  function qi(n) {
    for (var t, e, r = -1, u = n.length, i = u + 4, a = [], o = []; ++r < 4;) e = n[r % u], a.push(e[0]), o.push(e[1]);
    for (t = [Ri(Dl, a), ",", Ri(Dl, o)], --r; ++r < i;) e = n[r % u], a.shift(), a.push(e[0]), o.shift(), o.push(e[1]), Di(t, a, o);
    return t.join("");
  }
  function Ti(n, t) {
    var e = n.length - 1;
    if (e) for (var r, u, i = n[0][0], a = n[0][1], o = n[e][0] - i, l = n[e][1] - a, c = -1; ++c <= e;) r = n[c], u = c / e, r[0] = t * r[0] + (1 - t) * (i + u * o), r[1] = t * r[1] + (1 - t) * (a + u * l);
    return zi(n);
  }
  function Ri(n, t) {
    return n[0] * t[0] + n[1] * t[1] + n[2] * t[2] + n[3] * t[3];
  }
  function Di(n, t, e) {
    n.push("C", Ri(Tl, t), ",", Ri(Tl, e), ",", Ri(Rl, t), ",", Ri(Rl, e), ",", Ri(Dl, t), ",", Ri(Dl, e));
  }
  function Pi(n, t) {
    return (t[1] - n[1]) / (t[0] - n[0]);
  }
  function ji(n) {
    for (var t = 0, e = n.length - 1, r = [], u = n[0], i = n[1], a = r[0] = Pi(u, i); ++t < e;) r[t] = (a + (a = Pi(u = i, i = n[t + 1]))) / 2;
    return r[t] = a, r;
  }
  function Ui(n) {
    for (var t, e, r, u, i = [], a = ji(n), o = -1, l = n.length - 1; ++o < l;) t = Pi(n[o], n[o + 1]), Ma(t) < Da ? a[o] = a[o + 1] = 0 : (e = a[o] / t, r = a[o + 1] / t, u = e * e + r * r, u > 9 && (u = 3 * t / Math.sqrt(u), a[o] = u * e, a[o + 1] = u * r));
    for (o = -1; ++o <= l;) u = (n[Math.min(l, o + 1)][0] - n[Math.max(0, o - 1)][0]) / (6 * (1 + a[o] * a[o])), i.push([u || 0, a[o] * u || 0]);
    return i;
  }
  function Fi(n) {
    return n.length < 3 ? xi(n) : n[0] + Ai(n, Ui(n));
  }
  function Hi(n) {
    for (var t, e, r, u = -1, i = n.length; ++u < i;) t = n[u], e = t[0], r = t[1] - Ha, t[0] = e * Math.cos(r), t[1] = e * Math.sin(r);
    return n;
  }
  function Oi(n) {
    function t(t) {
      function l() {
        v.push("M", o(n(m), f), s, c(n(d.reverse()), f), "Z");
      }
      for (var h, g, p, v = [], d = [], m = [], y = -1, M = t.length, x = En(e), b = En(u), _ = e === r ? function () {
          return g;
        } : En(r), w = u === i ? function () {
          return p;
        } : En(i); ++y < M;) a.call(this, h = t[y], y) ? (d.push([g = +x.call(this, h, y), p = +b.call(this, h, y)]), m.push([+_.call(this, h, y), +w.call(this, h, y)])) : d.length && (l(), d = [], m = []);
      return d.length && l(), v.length ? v.join("") : null;
    }
    var e = Ce,
      r = Ce,
      u = 0,
      i = ze,
      a = zt,
      o = xi,
      l = o.key,
      c = o,
      s = "L",
      f = .7;
    return t.x = function (n) {
      return arguments.length ? (e = r = n, t) : r;
    }, t.x0 = function (n) {
      return arguments.length ? (e = n, t) : e;
    }, t.x1 = function (n) {
      return arguments.length ? (r = n, t) : r;
    }, t.y = function (n) {
      return arguments.length ? (u = i = n, t) : i;
    }, t.y0 = function (n) {
      return arguments.length ? (u = n, t) : u;
    }, t.y1 = function (n) {
      return arguments.length ? (i = n, t) : i;
    }, t.defined = function (n) {
      return arguments.length ? (a = n, t) : a;
    }, t.interpolate = function (n) {
      return arguments.length ? (l = "function" == typeof n ? o = n : (o = ql.get(n) || xi).key, c = o.reverse || o, s = o.closed ? "M" : "L", t) : l;
    }, t.tension = function (n) {
      return arguments.length ? (f = n, t) : f;
    }, t;
  }
  function Ii(n) {
    return n.radius;
  }
  function Yi(n) {
    return [n.x, n.y];
  }
  function Zi(n) {
    return function () {
      var t = n.apply(this, arguments),
        e = t[0],
        r = t[1] - Ha;
      return [e * Math.cos(r), e * Math.sin(r)];
    };
  }
  function Vi() {
    return 64;
  }
  function Xi() {
    return "circle";
  }
  function $i(n) {
    var t = Math.sqrt(n / ja);
    return "M0," + t + "A" + t + "," + t + " 0 1,1 0," + -t + "A" + t + "," + t + " 0 1,1 0," + t + "Z";
  }
  function Bi(n) {
    return function () {
      var t, e, r;
      (t = this[n]) && (r = t[e = t.active]) && (r.timer.c = null, r.timer.t = NaN, --t.count ? delete t[e] : delete this[n], t.active += .5, r.event && r.event.interrupt.call(this, this.__data__, r.index));
    };
  }
  function Wi(n, t, e) {
    return Sa(n, Il), n.namespace = t, n.id = e, n;
  }
  function Ji(n, t, e, r) {
    var u = n.id,
      i = n.namespace;
    return Y(n, "function" == typeof e ? function (n, a, o) {
      n[i][u].tween.set(t, r(e.call(n, n.__data__, a, o)));
    } : (e = r(e), function (n) {
      n[i][u].tween.set(t, e);
    }));
  }
  function Gi(n) {
    return null == n && (n = ""), function () {
      this.textContent = n;
    };
  }
  function Ki(n) {
    return null == n ? "__transition__" : "__transition_" + n + "__";
  }
  function Qi(n, t, e, r, u) {
    function i(n) {
      var t = v.delay;
      return s.t = t + l, n >= t ? a(n - t) : void (s.c = a);
    }
    function a(e) {
      var u = p.active,
        i = p[u];
      i && (i.timer.c = null, i.timer.t = NaN, --p.count, delete p[u], i.event && i.event.interrupt.call(n, n.__data__, i.index));
      for (var a in p) if (r > +a) {
        var c = p[a];
        c.timer.c = null, c.timer.t = NaN, --p.count, delete p[a];
      }
      s.c = o, qn(function () {
        return s.c && o(e || 1) && (s.c = null, s.t = NaN), 1;
      }, 0, l), p.active = r, v.event && v.event.start.call(n, n.__data__, t), g = [], v.tween.forEach(function (e, r) {
        (r = r.call(n, n.__data__, t)) && g.push(r);
      }), h = v.ease, f = v.duration;
    }
    function o(u) {
      for (var i = u / f, a = h(i), o = g.length; o > 0;) g[--o].call(n, a);
      return i >= 1 ? (v.event && v.event.end.call(n, n.__data__, t), --p.count ? delete p[r] : delete n[e], 1) : void 0;
    }
    var l,
      s,
      f,
      h,
      g,
      p = n[e] || (n[e] = {
        active: 0,
        count: 0
      }),
      v = p[r];
    v || (l = u.time, s = qn(i, 0, l), v = p[r] = {
      tween: new c(),
      time: l,
      timer: s,
      delay: u.delay,
      duration: u.duration,
      ease: u.ease,
      index: t
    }, u = null, ++p.count);
  }
  function na(n, t, e) {
    n.attr("transform", function (n) {
      var r = t(n);
      return "translate(" + (isFinite(r) ? r : e(n)) + ",0)";
    });
  }
  function ta(n, t, e) {
    n.attr("transform", function (n) {
      var r = t(n);
      return "translate(0," + (isFinite(r) ? r : e(n)) + ")";
    });
  }
  function ea(n) {
    return n.toISOString();
  }
  function ra(n, t, e) {
    function r(t) {
      return n(t);
    }
    function u(n, e) {
      var r = n[1] - n[0],
        u = r / e,
        i = oa.bisect(Gl, u);
      return i == Gl.length ? [t.year, Ku(n.map(function (n) {
        return n / 31536e6;
      }), e)[2]] : i ? t[u / Gl[i - 1] < Gl[i] / u ? i - 1 : i] : [nc, Ku(n, e)[2]];
    }
    return r.invert = function (t) {
      return ua(n.invert(t));
    }, r.domain = function (t) {
      return arguments.length ? (n.domain(t), r) : n.domain().map(ua);
    }, r.nice = function (n, t) {
      function e(e) {
        return !isNaN(e) && !n.range(e, ua(+e + 1), t).length;
      }
      var i = r.domain(),
        a = Yu(i),
        o = null == n ? u(a, 10) : "number" == typeof n && u(a, n);
      return o && (n = o[0], t = o[1]), r.domain(Xu(i, t > 1 ? {
        floor: function (t) {
          for (; e(t = n.floor(t));) t = ua(t - 1);
          return t;
        },
        ceil: function (t) {
          for (; e(t = n.ceil(t));) t = ua(+t + 1);
          return t;
        }
      } : n));
    }, r.ticks = function (n, t) {
      var e = Yu(r.domain()),
        i = null == n ? u(e, 10) : "number" == typeof n ? u(e, n) : !n.range && [{
          range: n
        }, t];
      return i && (n = i[0], t = i[1]), n.range(e[0], ua(+e[1] + 1), 1 > t ? 1 : t);
    }, r.tickFormat = function () {
      return e;
    }, r.copy = function () {
      return ra(n.copy(), t, e);
    }, Ju(r, n);
  }
  function ua(n) {
    return new Date(n);
  }
  function ia(n) {
    return JSON.parse(n.responseText);
  }
  function aa(n) {
    var t = sa.createRange();
    return t.selectNode(sa.body), t.createContextualFragment(n.responseText);
  }
  var oa = {
      version: "3.5.12"
    },
    la = [].slice,
    ca = function (n) {
      return la.call(n);
    },
    sa = window.document;
  if (sa) try {
    ca(sa.documentElement.childNodes)[0].nodeType;
  } catch (fa) {
    ca = function (n) {
      for (var t = n.length, e = new Array(t); t--;) e[t] = n[t];
      return e;
    };
  }
  if (Date.now || (Date.now = function () {
    return +new Date();
  }), sa) try {
    sa.createElement("DIV").style.setProperty("opacity", 0, "");
  } catch (ha) {
    var ga = this.Element.prototype,
      pa = ga.setAttribute,
      va = ga.setAttributeNS,
      da = this.CSSStyleDeclaration.prototype,
      ma = da.setProperty;
    ga.setAttribute = function (n, t) {
      pa.call(this, n, t + "");
    }, ga.setAttributeNS = function (n, t, e) {
      va.call(this, n, t, e + "");
    }, da.setProperty = function (n, t, e) {
      ma.call(this, n, t + "", e);
    };
  }
  oa.ascending = e, oa.descending = function (n, t) {
    return n > t ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
  }, oa.min = function (n, t) {
    var e,
      r,
      u = -1,
      i = n.length;
    if (1 === arguments.length) {
      for (; ++u < i;) if (null != (r = n[u]) && r >= r) {
        e = r;
        break;
      }
      for (; ++u < i;) null != (r = n[u]) && e > r && (e = r);
    } else {
      for (; ++u < i;) if (null != (r = t.call(n, n[u], u)) && r >= r) {
        e = r;
        break;
      }
      for (; ++u < i;) null != (r = t.call(n, n[u], u)) && e > r && (e = r);
    }
    return e;
  }, oa.max = function (n, t) {
    var e,
      r,
      u = -1,
      i = n.length;
    if (1 === arguments.length) {
      for (; ++u < i;) if (null != (r = n[u]) && r >= r) {
        e = r;
        break;
      }
      for (; ++u < i;) null != (r = n[u]) && r > e && (e = r);
    } else {
      for (; ++u < i;) if (null != (r = t.call(n, n[u], u)) && r >= r) {
        e = r;
        break;
      }
      for (; ++u < i;) null != (r = t.call(n, n[u], u)) && r > e && (e = r);
    }
    return e;
  }, oa.extent = function (n, t) {
    var e,
      r,
      u,
      i = -1,
      a = n.length;
    if (1 === arguments.length) {
      for (; ++i < a;) if (null != (r = n[i]) && r >= r) {
        e = u = r;
        break;
      }
      for (; ++i < a;) null != (r = n[i]) && (e > r && (e = r), r > u && (u = r));
    } else {
      for (; ++i < a;) if (null != (r = t.call(n, n[i], i)) && r >= r) {
        e = u = r;
        break;
      }
      for (; ++i < a;) null != (r = t.call(n, n[i], i)) && (e > r && (e = r), r > u && (u = r));
    }
    return [e, u];
  }, oa.sum = function (n, t) {
    var e,
      r = 0,
      i = n.length,
      a = -1;
    if (1 === arguments.length) for (; ++a < i;) u(e = +n[a]) && (r += e);else for (; ++a < i;) u(e = +t.call(n, n[a], a)) && (r += e);
    return r;
  }, oa.mean = function (n, t) {
    var e,
      i = 0,
      a = n.length,
      o = -1,
      l = a;
    if (1 === arguments.length) for (; ++o < a;) u(e = r(n[o])) ? i += e : --l;else for (; ++o < a;) u(e = r(t.call(n, n[o], o))) ? i += e : --l;
    return l ? i / l : void 0;
  }, oa.quantile = function (n, t) {
    var e = (n.length - 1) * t + 1,
      r = Math.floor(e),
      u = +n[r - 1],
      i = e - r;
    return i ? u + i * (n[r] - u) : u;
  }, oa.median = function (n, t) {
    var i,
      a = [],
      o = n.length,
      l = -1;
    if (1 === arguments.length) for (; ++l < o;) u(i = r(n[l])) && a.push(i);else for (; ++l < o;) u(i = r(t.call(n, n[l], l))) && a.push(i);
    return a.length ? oa.quantile(a.sort(e), .5) : void 0;
  }, oa.variance = function (n, t) {
    var e,
      i,
      a = n.length,
      o = 0,
      l = 0,
      c = -1,
      s = 0;
    if (1 === arguments.length) for (; ++c < a;) u(e = r(n[c])) && (i = e - o, o += i / ++s, l += i * (e - o));else for (; ++c < a;) u(e = r(t.call(n, n[c], c))) && (i = e - o, o += i / ++s, l += i * (e - o));
    return s > 1 ? l / (s - 1) : void 0;
  }, oa.deviation = function () {
    var n = oa.variance.apply(this, arguments);
    return n ? Math.sqrt(n) : n;
  };
  var ya = i(e);
  oa.bisectLeft = ya.left, oa.bisect = oa.bisectRight = ya.right, oa.bisector = function (n) {
    return i(1 === n.length ? function (t, r) {
      return e(n(t), r);
    } : n);
  }, oa.shuffle = function (n, t, e) {
    (i = arguments.length) < 3 && (e = n.length, 2 > i && (t = 0));
    for (var r, u, i = e - t; i;) u = Math.random() * i-- | 0, r = n[i + t], n[i + t] = n[u + t], n[u + t] = r;
    return n;
  }, oa.permute = function (n, t) {
    for (var e = t.length, r = new Array(e); e--;) r[e] = n[t[e]];
    return r;
  }, oa.pairs = function (n) {
    for (var t, e = 0, r = n.length - 1, u = n[0], i = new Array(0 > r ? 0 : r); r > e;) i[e] = [t = u, u = n[++e]];
    return i;
  }, oa.zip = function () {
    if (!(r = arguments.length)) return [];
    for (var n = -1, t = oa.min(arguments, a), e = new Array(t); ++n < t;) for (var r, u = -1, i = e[n] = new Array(r); ++u < r;) i[u] = arguments[u][n];
    return e;
  }, oa.transpose = function (n) {
    return oa.zip.apply(oa, n);
  }, oa.keys = function (n) {
    var t = [];
    for (var e in n) t.push(e);
    return t;
  }, oa.values = function (n) {
    var t = [];
    for (var e in n) t.push(n[e]);
    return t;
  }, oa.entries = function (n) {
    var t = [];
    for (var e in n) t.push({
      key: e,
      value: n[e]
    });
    return t;
  }, oa.merge = function (n) {
    for (var t, e, r, u = n.length, i = -1, a = 0; ++i < u;) a += n[i].length;
    for (e = new Array(a); --u >= 0;) for (r = n[u], t = r.length; --t >= 0;) e[--a] = r[t];
    return e;
  };
  var Ma = Math.abs;
  oa.range = function (n, t, e) {
    if (arguments.length < 3 && (e = 1, arguments.length < 2 && (t = n, n = 0)), (t - n) / e === 1 / 0) throw new Error("infinite range");
    var r,
      u = [],
      i = o(Ma(e)),
      a = -1;
    if (n *= i, t *= i, e *= i, 0 > e) for (; (r = n + e * ++a) > t;) u.push(r / i);else for (; (r = n + e * ++a) < t;) u.push(r / i);
    return u;
  }, oa.map = function (n, t) {
    var e = new c();
    if (n instanceof c) n.forEach(function (n, t) {
      e.set(n, t);
    });else if (Array.isArray(n)) {
      var r,
        u = -1,
        i = n.length;
      if (1 === arguments.length) for (; ++u < i;) e.set(u, n[u]);else for (; ++u < i;) e.set(t.call(n, r = n[u], u), r);
    } else for (var a in n) e.set(a, n[a]);
    return e;
  };
  var xa = "__proto__",
    ba = "\x00";
  l(c, {
    has: h,
    get: function (n) {
      return this._[s(n)];
    },
    set: function (n, t) {
      return this._[s(n)] = t;
    },
    remove: g,
    keys: p,
    values: function () {
      var n = [];
      for (var t in this._) n.push(this._[t]);
      return n;
    },
    entries: function () {
      var n = [];
      for (var t in this._) n.push({
        key: f(t),
        value: this._[t]
      });
      return n;
    },
    size: v,
    empty: d,
    forEach: function (n) {
      for (var t in this._) n.call(this, f(t), this._[t]);
    }
  }), oa.nest = function () {
    function n(t, a, o) {
      if (o >= i.length) return r ? r.call(u, a) : e ? a.sort(e) : a;
      for (var l, s, f, h, g = -1, p = a.length, v = i[o++], d = new c(); ++g < p;) (h = d.get(l = v(s = a[g]))) ? h.push(s) : d.set(l, [s]);
      return t ? (s = t(), f = function (e, r) {
        s.set(e, n(t, r, o));
      }) : (s = {}, f = function (e, r) {
        s[e] = n(t, r, o);
      }), d.forEach(f), s;
    }
    function t(n, e) {
      if (e >= i.length) return n;
      var r = [],
        u = a[e++];
      return n.forEach(function (n, u) {
        r.push({
          key: n,
          values: t(u, e)
        });
      }), u ? r.sort(function (n, t) {
        return u(n.key, t.key);
      }) : r;
    }
    var e,
      r,
      u = {},
      i = [],
      a = [];
    return u.map = function (t, e) {
      return n(e, t, 0);
    }, u.entries = function (e) {
      return t(n(oa.map, e, 0), 0);
    }, u.key = function (n) {
      return i.push(n), u;
    }, u.sortKeys = function (n) {
      return a[i.length - 1] = n, u;
    }, u.sortValues = function (n) {
      return e = n, u;
    }, u.rollup = function (n) {
      return r = n, u;
    }, u;
  }, oa.set = function (n) {
    var t = new m();
    if (n) for (var e = 0, r = n.length; r > e; ++e) t.add(n[e]);
    return t;
  }, l(m, {
    has: h,
    add: function (n) {
      return this._[s(n += "")] = !0, n;
    },
    remove: g,
    values: p,
    size: v,
    empty: d,
    forEach: function (n) {
      for (var t in this._) n.call(this, f(t));
    }
  }), oa.behavior = {}, oa.rebind = function (n, t) {
    for (var e, r = 1, u = arguments.length; ++r < u;) n[e = arguments[r]] = M(n, t, t[e]);
    return n;
  };
  var _a = ["webkit", "ms", "moz", "Moz", "o", "O"];
  oa.dispatch = function () {
    for (var n = new _(), t = -1, e = arguments.length; ++t < e;) n[arguments[t]] = w(n);
    return n;
  }, _.prototype.on = function (n, t) {
    var e = n.indexOf("."),
      r = "";
    if (e >= 0 && (r = n.slice(e + 1), n = n.slice(0, e)), n) return arguments.length < 2 ? this[n].on(r) : this[n].on(r, t);
    if (2 === arguments.length) {
      if (null == t) for (n in this) this.hasOwnProperty(n) && this[n].on(r, null);
      return this;
    }
  }, oa.event = null, oa.requote = function (n) {
    return n.replace(wa, "\\$&");
  };
  var wa = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g,
    Sa = {}.__proto__ ? function (n, t) {
      n.__proto__ = t;
    } : function (n, t) {
      for (var e in t) n[e] = t[e];
    },
    ka = function (n, t) {
      return t.querySelector(n);
    },
    Na = function (n, t) {
      return t.querySelectorAll(n);
    },
    Ea = function (n, t) {
      var e = n.matches || n[x(n, "matchesSelector")];
      return (Ea = function (n, t) {
        return e.call(n, t);
      })(n, t);
    };
  "function" == typeof Sizzle && (ka = function (n, t) {
    return Sizzle(n, t)[0] || null;
  }, Na = Sizzle, Ea = Sizzle.matchesSelector), oa.selection = function () {
    return oa.select(sa.documentElement);
  };
  var Aa = oa.selection.prototype = [];
  Aa.select = function (n) {
    var t,
      e,
      r,
      u,
      i = [];
    n = A(n);
    for (var a = -1, o = this.length; ++a < o;) {
      i.push(t = []), t.parentNode = (r = this[a]).parentNode;
      for (var l = -1, c = r.length; ++l < c;) (u = r[l]) ? (t.push(e = n.call(u, u.__data__, l, a)), e && "__data__" in u && (e.__data__ = u.__data__)) : t.push(null);
    }
    return E(i);
  }, Aa.selectAll = function (n) {
    var t,
      e,
      r = [];
    n = C(n);
    for (var u = -1, i = this.length; ++u < i;) for (var a = this[u], o = -1, l = a.length; ++o < l;) (e = a[o]) && (r.push(t = ca(n.call(e, e.__data__, o, u))), t.parentNode = e);
    return E(r);
  };
  var Ca = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: "http://www.w3.org/1999/xhtml",
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  oa.ns = {
    prefix: Ca,
    qualify: function (n) {
      var t = n.indexOf(":"),
        e = n;
      return t >= 0 && "xmlns" !== (e = n.slice(0, t)) && (n = n.slice(t + 1)), Ca.hasOwnProperty(e) ? {
        space: Ca[e],
        local: n
      } : n;
    }
  }, Aa.attr = function (n, t) {
    if (arguments.length < 2) {
      if ("string" == typeof n) {
        var e = this.node();
        return n = oa.ns.qualify(n), n.local ? e.getAttributeNS(n.space, n.local) : e.getAttribute(n);
      }
      for (t in n) this.each(z(t, n[t]));
      return this;
    }
    return this.each(z(n, t));
  }, Aa.classed = function (n, t) {
    if (arguments.length < 2) {
      if ("string" == typeof n) {
        var e = this.node(),
          r = (n = T(n)).length,
          u = -1;
        if (t = e.classList) {
          for (; ++u < r;) if (!t.contains(n[u])) return !1;
        } else for (t = e.getAttribute("class"); ++u < r;) if (!q(n[u]).test(t)) return !1;
        return !0;
      }
      for (t in n) this.each(R(t, n[t]));
      return this;
    }
    return this.each(R(n, t));
  }, Aa.style = function (n, e, r) {
    var u = arguments.length;
    if (3 > u) {
      if ("string" != typeof n) {
        2 > u && (e = "");
        for (r in n) this.each(P(r, n[r], e));
        return this;
      }
      if (2 > u) {
        var i = this.node();
        return t(i).getComputedStyle(i, null).getPropertyValue(n);
      }
      r = "";
    }
    return this.each(P(n, e, r));
  }, Aa.property = function (n, t) {
    if (arguments.length < 2) {
      if ("string" == typeof n) return this.node()[n];
      for (t in n) this.each(j(t, n[t]));
      return this;
    }
    return this.each(j(n, t));
  }, Aa.text = function (n) {
    return arguments.length ? this.each("function" == typeof n ? function () {
      var t = n.apply(this, arguments);
      this.textContent = null == t ? "" : t;
    } : null == n ? function () {
      this.textContent = "";
    } : function () {
      this.textContent = n;
    }) : this.node().textContent;
  }, Aa.html = function (n) {
    return arguments.length ? this.each("function" == typeof n ? function () {
      var t = n.apply(this, arguments);
      this.innerHTML = null == t ? "" : t;
    } : null == n ? function () {
      this.innerHTML = "";
    } : function () {
      this.innerHTML = n;
    }) : this.node().innerHTML;
  }, Aa.append = function (n) {
    return n = U(n), this.select(function () {
      return this.appendChild(n.apply(this, arguments));
    });
  }, Aa.insert = function (n, t) {
    return n = U(n), t = A(t), this.select(function () {
      return this.insertBefore(n.apply(this, arguments), t.apply(this, arguments) || null);
    });
  }, Aa.remove = function () {
    return this.each(F);
  }, Aa.data = function (n, t) {
    function e(n, e) {
      var r,
        u,
        i,
        a = n.length,
        f = e.length,
        h = Math.min(a, f),
        g = new Array(f),
        p = new Array(f),
        v = new Array(a);
      if (t) {
        var d,
          m = new c(),
          y = new Array(a);
        for (r = -1; ++r < a;) (u = n[r]) && (m.has(d = t.call(u, u.__data__, r)) ? v[r] = u : m.set(d, u), y[r] = d);
        for (r = -1; ++r < f;) (u = m.get(d = t.call(e, i = e[r], r))) ? u !== !0 && (g[r] = u, u.__data__ = i) : p[r] = H(i), m.set(d, !0);
        for (r = -1; ++r < a;) r in y && m.get(y[r]) !== !0 && (v[r] = n[r]);
      } else {
        for (r = -1; ++r < h;) u = n[r], i = e[r], u ? (u.__data__ = i, g[r] = u) : p[r] = H(i);
        for (; f > r; ++r) p[r] = H(e[r]);
        for (; a > r; ++r) v[r] = n[r];
      }
      p.update = g, p.parentNode = g.parentNode = v.parentNode = n.parentNode, o.push(p), l.push(g), s.push(v);
    }
    var r,
      u,
      i = -1,
      a = this.length;
    if (!arguments.length) {
      for (n = new Array(a = (r = this[0]).length); ++i < a;) (u = r[i]) && (n[i] = u.__data__);
      return n;
    }
    var o = Z([]),
      l = E([]),
      s = E([]);
    if ("function" == typeof n) for (; ++i < a;) e(r = this[i], n.call(r, r.parentNode.__data__, i));else for (; ++i < a;) e(r = this[i], n);
    return l.enter = function () {
      return o;
    }, l.exit = function () {
      return s;
    }, l;
  }, Aa.datum = function (n) {
    return arguments.length ? this.property("__data__", n) : this.property("__data__");
  }, Aa.filter = function (n) {
    var t,
      e,
      r,
      u = [];
    "function" != typeof n && (n = O(n));
    for (var i = 0, a = this.length; a > i; i++) {
      u.push(t = []), t.parentNode = (e = this[i]).parentNode;
      for (var o = 0, l = e.length; l > o; o++) (r = e[o]) && n.call(r, r.__data__, o, i) && t.push(r);
    }
    return E(u);
  }, Aa.order = function () {
    for (var n = -1, t = this.length; ++n < t;) for (var e, r = this[n], u = r.length - 1, i = r[u]; --u >= 0;) (e = r[u]) && (i && i !== e.nextSibling && i.parentNode.insertBefore(e, i), i = e);
    return this;
  }, Aa.sort = function (n) {
    n = I.apply(this, arguments);
    for (var t = -1, e = this.length; ++t < e;) this[t].sort(n);
    return this.order();
  }, Aa.each = function (n) {
    return Y(this, function (t, e, r) {
      n.call(t, t.__data__, e, r);
    });
  }, Aa.call = function (n) {
    var t = ca(arguments);
    return n.apply(t[0] = this, t), this;
  }, Aa.empty = function () {
    return !this.node();
  }, Aa.node = function () {
    for (var n = 0, t = this.length; t > n; n++) for (var e = this[n], r = 0, u = e.length; u > r; r++) {
      var i = e[r];
      if (i) return i;
    }
    return null;
  }, Aa.size = function () {
    var n = 0;
    return Y(this, function () {
      ++n;
    }), n;
  };
  var za = [];
  oa.selection.enter = Z, oa.selection.enter.prototype = za, za.append = Aa.append, za.empty = Aa.empty, za.node = Aa.node, za.call = Aa.call, za.size = Aa.size, za.select = function (n) {
    for (var t, e, r, u, i, a = [], o = -1, l = this.length; ++o < l;) {
      r = (u = this[o]).update, a.push(t = []), t.parentNode = u.parentNode;
      for (var c = -1, s = u.length; ++c < s;) (i = u[c]) ? (t.push(r[c] = e = n.call(u.parentNode, i.__data__, c, o)), e.__data__ = i.__data__) : t.push(null);
    }
    return E(a);
  }, za.insert = function (n, t) {
    return arguments.length < 2 && (t = V(this)), Aa.insert.call(this, n, t);
  }, oa.select = function (t) {
    var e;
    return "string" == typeof t ? (e = [ka(t, sa)], e.parentNode = sa.documentElement) : (e = [t], e.parentNode = n(t)), E([e]);
  }, oa.selectAll = function (n) {
    var t;
    return "string" == typeof n ? (t = ca(Na(n, sa)), t.parentNode = sa.documentElement) : (t = ca(n), t.parentNode = null), E([t]);
  }, Aa.on = function (n, t, e) {
    var r = arguments.length;
    if (3 > r) {
      if ("string" != typeof n) {
        2 > r && (t = !1);
        for (e in n) this.each(X(e, n[e], t));
        return this;
      }
      if (2 > r) return (r = this.node()["__on" + n]) && r._;
      e = !1;
    }
    return this.each(X(n, t, e));
  };
  var La = oa.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  sa && La.forEach(function (n) {
    "on" + n in sa && La.remove(n);
  });
  var qa,
    Ta = 0;
  oa.mouse = function (n) {
    return J(n, k());
  };
  var Ra = window.navigator && /WebKit/.test(window.navigator.userAgent) ? -1 : 0;
  oa.touch = function (n, t, e) {
    if (arguments.length < 3 && (e = t, t = k().changedTouches), t) for (var r, u = 0, i = t.length; i > u; ++u) if ((r = t[u]).identifier === e) return J(n, r);
  }, oa.behavior.drag = function () {
    function n() {
      this.on("mousedown.drag", i).on("touchstart.drag", a);
    }
    function e(n, t, e, i, a) {
      return function () {
        function o() {
          var n,
            e,
            r = t(h, v);
          r && (n = r[0] - M[0], e = r[1] - M[1], p |= n | e, M = r, g({
            type: "drag",
            x: r[0] + c[0],
            y: r[1] + c[1],
            dx: n,
            dy: e
          }));
        }
        function l() {
          t(h, v) && (m.on(i + d, null).on(a + d, null), y(p), g({
            type: "dragend"
          }));
        }
        var c,
          s = this,
          f = oa.event.target,
          h = s.parentNode,
          g = r.of(s, arguments),
          p = 0,
          v = n(),
          d = ".drag" + (null == v ? "" : "-" + v),
          m = oa.select(e(f)).on(i + d, o).on(a + d, l),
          y = W(f),
          M = t(h, v);
        u ? (c = u.apply(s, arguments), c = [c.x - M[0], c.y - M[1]]) : c = [0, 0], g({
          type: "dragstart"
        });
      };
    }
    var r = N(n, "drag", "dragstart", "dragend"),
      u = null,
      i = e(b, oa.mouse, t, "mousemove", "mouseup"),
      a = e(G, oa.touch, y, "touchmove", "touchend");
    return n.origin = function (t) {
      return arguments.length ? (u = t, n) : u;
    }, oa.rebind(n, r, "on");
  }, oa.touches = function (n, t) {
    return arguments.length < 2 && (t = k().touches), t ? ca(t).map(function (t) {
      var e = J(n, t);
      return e.identifier = t.identifier, e;
    }) : [];
  };
  var Da = 1e-6,
    Pa = Da * Da,
    ja = Math.PI,
    Ua = 2 * ja,
    Fa = Ua - Da,
    Ha = ja / 2,
    Oa = ja / 180,
    Ia = 180 / ja,
    Ya = Math.SQRT2,
    Za = 2,
    Va = 4;
  oa.interpolateZoom = function (n, t) {
    var e,
      r,
      u = n[0],
      i = n[1],
      a = n[2],
      o = t[0],
      l = t[1],
      c = t[2],
      s = o - u,
      f = l - i,
      h = s * s + f * f;
    if (Pa > h) r = Math.log(c / a) / Ya, e = function (n) {
      return [u + n * s, i + n * f, a * Math.exp(Ya * n * r)];
    };else {
      var g = Math.sqrt(h),
        p = (c * c - a * a + Va * h) / (2 * a * Za * g),
        v = (c * c - a * a - Va * h) / (2 * c * Za * g),
        d = Math.log(Math.sqrt(p * p + 1) - p),
        m = Math.log(Math.sqrt(v * v + 1) - v);
      r = (m - d) / Ya, e = function (n) {
        var t = n * r,
          e = rn(d),
          o = a / (Za * g) * (e * un(Ya * t + d) - en(d));
        return [u + o * s, i + o * f, a * e / rn(Ya * t + d)];
      };
    }
    return e.duration = 1e3 * r, e;
  }, oa.behavior.zoom = function () {
    function n(n) {
      n.on(L, f).on($a + ".zoom", g).on("dblclick.zoom", p).on(R, h);
    }
    function e(n) {
      return [(n[0] - k.x) / k.k, (n[1] - k.y) / k.k];
    }
    function r(n) {
      return [n[0] * k.k + k.x, n[1] * k.k + k.y];
    }
    function u(n) {
      k.k = Math.max(A[0], Math.min(A[1], n));
    }
    function i(n, t) {
      t = r(t), k.x += n[0] - t[0], k.y += n[1] - t[1];
    }
    function a(t, e, r, a) {
      t.__chart__ = {
        x: k.x,
        y: k.y,
        k: k.k
      }, u(Math.pow(2, a)), i(d = e, r), t = oa.select(t), C > 0 && (t = t.transition().duration(C)), t.call(n.event);
    }
    function o() {
      b && b.domain(x.range().map(function (n) {
        return (n - k.x) / k.k;
      }).map(x.invert)), w && w.domain(_.range().map(function (n) {
        return (n - k.y) / k.k;
      }).map(_.invert));
    }
    function l(n) {
      z++ || n({
        type: "zoomstart"
      });
    }
    function c(n) {
      o(), n({
        type: "zoom",
        scale: k.k,
        translate: [k.x, k.y]
      });
    }
    function s(n) {
      --z || (n({
        type: "zoomend"
      }), d = null);
    }
    function f() {
      function n() {
        o = 1, i(oa.mouse(u), h), c(a);
      }
      function r() {
        f.on(q, null).on(T, null), g(o), s(a);
      }
      var u = this,
        a = D.of(u, arguments),
        o = 0,
        f = oa.select(t(u)).on(q, n).on(T, r),
        h = e(oa.mouse(u)),
        g = W(u);
      Ol.call(u), l(a);
    }
    function h() {
      function n() {
        var n = oa.touches(p);
        return g = k.k, n.forEach(function (n) {
          n.identifier in d && (d[n.identifier] = e(n));
        }), n;
      }
      function t() {
        var t = oa.event.target;
        oa.select(t).on(x, r).on(b, o), _.push(t);
        for (var e = oa.event.changedTouches, u = 0, i = e.length; i > u; ++u) d[e[u].identifier] = null;
        var l = n(),
          c = Date.now();
        if (1 === l.length) {
          if (500 > c - M) {
            var s = l[0];
            a(p, s, d[s.identifier], Math.floor(Math.log(k.k) / Math.LN2) + 1), S();
          }
          M = c;
        } else if (l.length > 1) {
          var s = l[0],
            f = l[1],
            h = s[0] - f[0],
            g = s[1] - f[1];
          m = h * h + g * g;
        }
      }
      function r() {
        var n,
          t,
          e,
          r,
          a = oa.touches(p);
        Ol.call(p);
        for (var o = 0, l = a.length; l > o; ++o, r = null) if (e = a[o], r = d[e.identifier]) {
          if (t) break;
          n = e, t = r;
        }
        if (r) {
          var s = (s = e[0] - n[0]) * s + (s = e[1] - n[1]) * s,
            f = m && Math.sqrt(s / m);
          n = [(n[0] + e[0]) / 2, (n[1] + e[1]) / 2], t = [(t[0] + r[0]) / 2, (t[1] + r[1]) / 2], u(f * g);
        }
        M = null, i(n, t), c(v);
      }
      function o() {
        if (oa.event.touches.length) {
          for (var t = oa.event.changedTouches, e = 0, r = t.length; r > e; ++e) delete d[t[e].identifier];
          for (var u in d) return void n();
        }
        oa.selectAll(_).on(y, null), w.on(L, f).on(R, h), N(), s(v);
      }
      var g,
        p = this,
        v = D.of(p, arguments),
        d = {},
        m = 0,
        y = ".zoom-" + oa.event.changedTouches[0].identifier,
        x = "touchmove" + y,
        b = "touchend" + y,
        _ = [],
        w = oa.select(p),
        N = W(p);
      t(), l(v), w.on(L, null).on(R, t);
    }
    function g() {
      var n = D.of(this, arguments);
      y ? clearTimeout(y) : (Ol.call(this), v = e(d = m || oa.mouse(this)), l(n)), y = setTimeout(function () {
        y = null, s(n);
      }, 50), S(), u(Math.pow(2, .002 * Xa()) * k.k), i(d, v), c(n);
    }
    function p() {
      var n = oa.mouse(this),
        t = Math.log(k.k) / Math.LN2;
      a(this, n, e(n), oa.event.shiftKey ? Math.ceil(t) - 1 : Math.floor(t) + 1);
    }
    var v,
      d,
      m,
      y,
      M,
      x,
      b,
      _,
      w,
      k = {
        x: 0,
        y: 0,
        k: 1
      },
      E = [960, 500],
      A = Ba,
      C = 250,
      z = 0,
      L = "mousedown.zoom",
      q = "mousemove.zoom",
      T = "mouseup.zoom",
      R = "touchstart.zoom",
      D = N(n, "zoomstart", "zoom", "zoomend");
    return $a || ($a = "onwheel" in sa ? (Xa = function () {
      return -oa.event.deltaY * (oa.event.deltaMode ? 120 : 1);
    }, "wheel") : "onmousewheel" in sa ? (Xa = function () {
      return oa.event.wheelDelta;
    }, "mousewheel") : (Xa = function () {
      return -oa.event.detail;
    }, "MozMousePixelScroll")), n.event = function (n) {
      n.each(function () {
        var n = D.of(this, arguments),
          t = k;
        Fl ? oa.select(this).transition().each("start.zoom", function () {
          k = this.__chart__ || {
            x: 0,
            y: 0,
            k: 1
          }, l(n);
        }).tween("zoom:zoom", function () {
          var e = E[0],
            r = E[1],
            u = d ? d[0] : e / 2,
            i = d ? d[1] : r / 2,
            a = oa.interpolateZoom([(u - k.x) / k.k, (i - k.y) / k.k, e / k.k], [(u - t.x) / t.k, (i - t.y) / t.k, e / t.k]);
          return function (t) {
            var r = a(t),
              o = e / r[2];
            this.__chart__ = k = {
              x: u - r[0] * o,
              y: i - r[1] * o,
              k: o
            }, c(n);
          };
        }).each("interrupt.zoom", function () {
          s(n);
        }).each("end.zoom", function () {
          s(n);
        }) : (this.__chart__ = k, l(n), c(n), s(n));
      });
    }, n.translate = function (t) {
      return arguments.length ? (k = {
        x: +t[0],
        y: +t[1],
        k: k.k
      }, o(), n) : [k.x, k.y];
    }, n.scale = function (t) {
      return arguments.length ? (k = {
        x: k.x,
        y: k.y,
        k: null
      }, u(+t), o(), n) : k.k;
    }, n.scaleExtent = function (t) {
      return arguments.length ? (A = null == t ? Ba : [+t[0], +t[1]], n) : A;
    }, n.center = function (t) {
      return arguments.length ? (m = t && [+t[0], +t[1]], n) : m;
    }, n.size = function (t) {
      return arguments.length ? (E = t && [+t[0], +t[1]], n) : E;
    }, n.duration = function (t) {
      return arguments.length ? (C = +t, n) : C;
    }, n.x = function (t) {
      return arguments.length ? (b = t, x = t.copy(), k = {
        x: 0,
        y: 0,
        k: 1
      }, n) : b;
    }, n.y = function (t) {
      return arguments.length ? (w = t, _ = t.copy(), k = {
        x: 0,
        y: 0,
        k: 1
      }, n) : w;
    }, oa.rebind(n, D, "on");
  };
  var Xa,
    $a,
    Ba = [0, 1 / 0];
  oa.color = on, on.prototype.toString = function () {
    return this.rgb() + "";
  }, oa.hsl = ln;
  var Wa = ln.prototype = new on();
  Wa.brighter = function (n) {
    return n = Math.pow(.7, arguments.length ? n : 1), new ln(this.h, this.s, this.l / n);
  }, Wa.darker = function (n) {
    return n = Math.pow(.7, arguments.length ? n : 1), new ln(this.h, this.s, n * this.l);
  }, Wa.rgb = function () {
    return cn(this.h, this.s, this.l);
  }, oa.hcl = sn;
  var Ja = sn.prototype = new on();
  Ja.brighter = function (n) {
    return new sn(this.h, this.c, Math.min(100, this.l + Ga * (arguments.length ? n : 1)));
  }, Ja.darker = function (n) {
    return new sn(this.h, this.c, Math.max(0, this.l - Ga * (arguments.length ? n : 1)));
  }, Ja.rgb = function () {
    return fn(this.h, this.c, this.l).rgb();
  }, oa.lab = hn;
  var Ga = 18,
    Ka = .95047,
    Qa = 1,
    no = 1.08883,
    to = hn.prototype = new on();
  to.brighter = function (n) {
    return new hn(Math.min(100, this.l + Ga * (arguments.length ? n : 1)), this.a, this.b);
  }, to.darker = function (n) {
    return new hn(Math.max(0, this.l - Ga * (arguments.length ? n : 1)), this.a, this.b);
  }, to.rgb = function () {
    return gn(this.l, this.a, this.b);
  }, oa.rgb = yn;
  var eo = yn.prototype = new on();
  eo.brighter = function (n) {
    n = Math.pow(.7, arguments.length ? n : 1);
    var t = this.r,
      e = this.g,
      r = this.b,
      u = 30;
    return t || e || r ? (t && u > t && (t = u), e && u > e && (e = u), r && u > r && (r = u), new yn(Math.min(255, t / n), Math.min(255, e / n), Math.min(255, r / n))) : new yn(u, u, u);
  }, eo.darker = function (n) {
    return n = Math.pow(.7, arguments.length ? n : 1), new yn(n * this.r, n * this.g, n * this.b);
  }, eo.hsl = function () {
    return wn(this.r, this.g, this.b);
  }, eo.toString = function () {
    return "#" + bn(this.r) + bn(this.g) + bn(this.b);
  };
  var ro = oa.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  ro.forEach(function (n, t) {
    ro.set(n, Mn(t));
  }), oa.functor = En, oa.xhr = An(y), oa.dsv = function (n, t) {
    function e(n, e, i) {
      arguments.length < 3 && (i = e, e = null);
      var a = Cn(n, t, null == e ? r : u(e), i);
      return a.row = function (n) {
        return arguments.length ? a.response(null == (e = n) ? r : u(n)) : e;
      }, a;
    }
    function r(n) {
      return e.parse(n.responseText);
    }
    function u(n) {
      return function (t) {
        return e.parse(t.responseText, n);
      };
    }
    function i(t) {
      return t.map(a).join(n);
    }
    function a(n) {
      return o.test(n) ? '"' + n.replace(/\"/g, '""') + '"' : n;
    }
    var o = new RegExp('["' + n + "\n]"),
      l = n.charCodeAt(0);
    return e.parse = function (n, t) {
      var r;
      return e.parseRows(n, function (n, e) {
        if (r) return r(n, e - 1);
        var u = new Function("d", "return {" + n.map(function (n, t) {
          return JSON.stringify(n) + ": d[" + t + "]";
        }).join(",") + "}");
        r = t ? function (n, e) {
          return t(u(n), e);
        } : u;
      });
    }, e.parseRows = function (n, t) {
      function e() {
        if (s >= c) return a;
        if (u) return u = !1, i;
        var t = s;
        if (34 === n.charCodeAt(t)) {
          for (var e = t; e++ < c;) if (34 === n.charCodeAt(e)) {
            if (34 !== n.charCodeAt(e + 1)) break;
            ++e;
          }
          s = e + 2;
          var r = n.charCodeAt(e + 1);
          return 13 === r ? (u = !0, 10 === n.charCodeAt(e + 2) && ++s) : 10 === r && (u = !0), n.slice(t + 1, e).replace(/""/g, '"');
        }
        for (; c > s;) {
          var r = n.charCodeAt(s++),
            o = 1;
          if (10 === r) u = !0;else if (13 === r) u = !0, 10 === n.charCodeAt(s) && (++s, ++o);else if (r !== l) continue;
          return n.slice(t, s - o);
        }
        return n.slice(t);
      }
      for (var r, u, i = {}, a = {}, o = [], c = n.length, s = 0, f = 0; (r = e()) !== a;) {
        for (var h = []; r !== i && r !== a;) h.push(r), r = e();
        t && null == (h = t(h, f++)) || o.push(h);
      }
      return o;
    }, e.format = function (t) {
      if (Array.isArray(t[0])) return e.formatRows(t);
      var r = new m(),
        u = [];
      return t.forEach(function (n) {
        for (var t in n) r.has(t) || u.push(r.add(t));
      }), [u.map(a).join(n)].concat(t.map(function (t) {
        return u.map(function (n) {
          return a(t[n]);
        }).join(n);
      })).join("\n");
    }, e.formatRows = function (n) {
      return n.map(i).join("\n");
    }, e;
  }, oa.csv = oa.dsv(",", "text/csv"), oa.tsv = oa.dsv("	", "text/tab-separated-values");
  var uo,
    io,
    ao,
    oo,
    lo = window[x(window, "requestAnimationFrame")] || function (n) {
      setTimeout(n, 17);
    };
  oa.timer = function () {
    qn.apply(this, arguments);
  }, oa.timer.flush = function () {
    Rn(), Dn();
  }, oa.round = function (n, t) {
    return t ? Math.round(n * (t = Math.pow(10, t))) / t : Math.round(n);
  };
  var co = ["y", "z", "a", "f", "p", "n", "\xb5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"].map(jn);
  oa.formatPrefix = function (n, t) {
    var e = 0;
    return (n = +n) && (0 > n && (n *= -1), t && (n = oa.round(n, Pn(n, t))), e = 1 + Math.floor(1e-12 + Math.log(n) / Math.LN10), e = Math.max(-24, Math.min(24, 3 * Math.floor((e - 1) / 3)))), co[8 + e / 3];
  };
  var so = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i,
    fo = oa.map({
      b: function (n) {
        return n.toString(2);
      },
      c: function (n) {
        return String.fromCharCode(n);
      },
      o: function (n) {
        return n.toString(8);
      },
      x: function (n) {
        return n.toString(16);
      },
      X: function (n) {
        return n.toString(16).toUpperCase();
      },
      g: function (n, t) {
        return n.toPrecision(t);
      },
      e: function (n, t) {
        return n.toExponential(t);
      },
      f: function (n, t) {
        return n.toFixed(t);
      },
      r: function (n, t) {
        return (n = oa.round(n, Pn(n, t))).toFixed(Math.max(0, Math.min(20, Pn(n * (1 + 1e-15), t))));
      }
    }),
    ho = oa.time = {},
    go = Date;
  Hn.prototype = {
    getDate: function () {
      return this._.getUTCDate();
    },
    getDay: function () {
      return this._.getUTCDay();
    },
    getFullYear: function () {
      return this._.getUTCFullYear();
    },
    getHours: function () {
      return this._.getUTCHours();
    },
    getMilliseconds: function () {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function () {
      return this._.getUTCMinutes();
    },
    getMonth: function () {
      return this._.getUTCMonth();
    },
    getSeconds: function () {
      return this._.getUTCSeconds();
    },
    getTime: function () {
      return this._.getTime();
    },
    getTimezoneOffset: function () {
      return 0;
    },
    valueOf: function () {
      return this._.valueOf();
    },
    setDate: function () {
      po.setUTCDate.apply(this._, arguments);
    },
    setDay: function () {
      po.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function () {
      po.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function () {
      po.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function () {
      po.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function () {
      po.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function () {
      po.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function () {
      po.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function () {
      po.setTime.apply(this._, arguments);
    }
  };
  var po = Date.prototype;
  ho.year = On(function (n) {
    return n = ho.day(n), n.setMonth(0, 1), n;
  }, function (n, t) {
    n.setFullYear(n.getFullYear() + t);
  }, function (n) {
    return n.getFullYear();
  }), ho.years = ho.year.range, ho.years.utc = ho.year.utc.range, ho.day = On(function (n) {
    var t = new go(2e3, 0);
    return t.setFullYear(n.getFullYear(), n.getMonth(), n.getDate()), t;
  }, function (n, t) {
    n.setDate(n.getDate() + t);
  }, function (n) {
    return n.getDate() - 1;
  }), ho.days = ho.day.range, ho.days.utc = ho.day.utc.range, ho.dayOfYear = function (n) {
    var t = ho.year(n);
    return Math.floor((n - t - 6e4 * (n.getTimezoneOffset() - t.getTimezoneOffset())) / 864e5);
  }, ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].forEach(function (n, t) {
    t = 7 - t;
    var e = ho[n] = On(function (n) {
      return (n = ho.day(n)).setDate(n.getDate() - (n.getDay() + t) % 7), n;
    }, function (n, t) {
      n.setDate(n.getDate() + 7 * Math.floor(t));
    }, function (n) {
      var e = ho.year(n).getDay();
      return Math.floor((ho.dayOfYear(n) + (e + t) % 7) / 7) - (e !== t);
    });
    ho[n + "s"] = e.range, ho[n + "s"].utc = e.utc.range, ho[n + "OfYear"] = function (n) {
      var e = ho.year(n).getDay();
      return Math.floor((ho.dayOfYear(n) + (e + t) % 7) / 7);
    };
  }), ho.week = ho.sunday, ho.weeks = ho.sunday.range, ho.weeks.utc = ho.sunday.utc.range, ho.weekOfYear = ho.sundayOfYear;
  var vo = {
      "-": "",
      _: " ",
      0: "0"
    },
    mo = /^\s*\d+/,
    yo = /^%/;
  oa.locale = function (n) {
    return {
      numberFormat: Un(n),
      timeFormat: Yn(n)
    };
  };
  var Mo = oa.locale({
    decimal: ".",
    thousands: ",",
    grouping: [3],
    currency: ["$", ""],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  });
  oa.format = Mo.numberFormat, oa.geo = {}, st.prototype = {
    s: 0,
    t: 0,
    add: function (n) {
      ft(n, this.t, xo), ft(xo.s, this.s, this), this.s ? this.t += xo.t : this.s = xo.t;
    },
    reset: function () {
      this.s = this.t = 0;
    },
    valueOf: function () {
      return this.s;
    }
  };
  var xo = new st();
  oa.geo.stream = function (n, t) {
    n && bo.hasOwnProperty(n.type) ? bo[n.type](n, t) : ht(n, t);
  };
  var bo = {
      Feature: function (n, t) {
        ht(n.geometry, t);
      },
      FeatureCollection: function (n, t) {
        for (var e = n.features, r = -1, u = e.length; ++r < u;) ht(e[r].geometry, t);
      }
    },
    _o = {
      Sphere: function (n, t) {
        t.sphere();
      },
      Point: function (n, t) {
        n = n.coordinates, t.point(n[0], n[1], n[2]);
      },
      MultiPoint: function (n, t) {
        for (var e = n.coordinates, r = -1, u = e.length; ++r < u;) n = e[r], t.point(n[0], n[1], n[2]);
      },
      LineString: function (n, t) {
        gt(n.coordinates, t, 0);
      },
      MultiLineString: function (n, t) {
        for (var e = n.coordinates, r = -1, u = e.length; ++r < u;) gt(e[r], t, 0);
      },
      Polygon: function (n, t) {
        pt(n.coordinates, t);
      },
      MultiPolygon: function (n, t) {
        for (var e = n.coordinates, r = -1, u = e.length; ++r < u;) pt(e[r], t);
      },
      GeometryCollection: function (n, t) {
        for (var e = n.geometries, r = -1, u = e.length; ++r < u;) ht(e[r], t);
      }
    };
  oa.geo.area = function (n) {
    return wo = 0, oa.geo.stream(n, ko), wo;
  };
  var wo,
    So = new st(),
    ko = {
      sphere: function () {
        wo += 4 * ja;
      },
      point: b,
      lineStart: b,
      lineEnd: b,
      polygonStart: function () {
        So.reset(), ko.lineStart = vt;
      },
      polygonEnd: function () {
        var n = 2 * So;
        wo += 0 > n ? 4 * ja + n : n, ko.lineStart = ko.lineEnd = ko.point = b;
      }
    };
  oa.geo.bounds = function () {
    function n(n, t) {
      M.push(x = [s = n, h = n]), f > t && (f = t), t > g && (g = t);
    }
    function t(t, e) {
      var r = dt([t * Oa, e * Oa]);
      if (m) {
        var u = yt(m, r),
          i = [u[1], -u[0], 0],
          a = yt(i, u);
        bt(a), a = _t(a);
        var l = t - p,
          c = l > 0 ? 1 : -1,
          v = a[0] * Ia * c,
          d = Ma(l) > 180;
        if (d ^ (v > c * p && c * t > v)) {
          var y = a[1] * Ia;
          y > g && (g = y);
        } else if (v = (v + 360) % 360 - 180, d ^ (v > c * p && c * t > v)) {
          var y = -a[1] * Ia;
          f > y && (f = y);
        } else f > e && (f = e), e > g && (g = e);
        d ? p > t ? o(s, t) > o(s, h) && (h = t) : o(t, h) > o(s, h) && (s = t) : h >= s ? (s > t && (s = t), t > h && (h = t)) : t > p ? o(s, t) > o(s, h) && (h = t) : o(t, h) > o(s, h) && (s = t);
      } else n(t, e);
      m = r, p = t;
    }
    function e() {
      b.point = t;
    }
    function r() {
      x[0] = s, x[1] = h, b.point = n, m = null;
    }
    function u(n, e) {
      if (m) {
        var r = n - p;
        y += Ma(r) > 180 ? r + (r > 0 ? 360 : -360) : r;
      } else v = n, d = e;
      ko.point(n, e), t(n, e);
    }
    function i() {
      ko.lineStart();
    }
    function a() {
      u(v, d), ko.lineEnd(), Ma(y) > Da && (s = -(h = 180)), x[0] = s, x[1] = h, m = null;
    }
    function o(n, t) {
      return (t -= n) < 0 ? t + 360 : t;
    }
    function l(n, t) {
      return n[0] - t[0];
    }
    function c(n, t) {
      return t[0] <= t[1] ? t[0] <= n && n <= t[1] : n < t[0] || t[1] < n;
    }
    var s,
      f,
      h,
      g,
      p,
      v,
      d,
      m,
      y,
      M,
      x,
      b = {
        point: n,
        lineStart: e,
        lineEnd: r,
        polygonStart: function () {
          b.point = u, b.lineStart = i, b.lineEnd = a, y = 0, ko.polygonStart();
        },
        polygonEnd: function () {
          ko.polygonEnd(), b.point = n, b.lineStart = e, b.lineEnd = r, 0 > So ? (s = -(h = 180), f = -(g = 90)) : y > Da ? g = 90 : -Da > y && (f = -90), x[0] = s, x[1] = h;
        }
      };
    return function (n) {
      g = h = -(s = f = 1 / 0), M = [], oa.geo.stream(n, b);
      var t = M.length;
      if (t) {
        M.sort(l);
        for (var e, r = 1, u = M[0], i = [u]; t > r; ++r) e = M[r], c(e[0], u) || c(e[1], u) ? (o(u[0], e[1]) > o(u[0], u[1]) && (u[1] = e[1]), o(e[0], u[1]) > o(u[0], u[1]) && (u[0] = e[0])) : i.push(u = e);
        for (var a, e, p = -(1 / 0), t = i.length - 1, r = 0, u = i[t]; t >= r; u = e, ++r) e = i[r], (a = o(u[1], e[0])) > p && (p = a, s = e[0], h = u[1]);
      }
      return M = x = null, s === 1 / 0 || f === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[s, f], [h, g]];
    };
  }(), oa.geo.centroid = function (n) {
    No = Eo = Ao = Co = zo = Lo = qo = To = Ro = Do = Po = 0, oa.geo.stream(n, jo);
    var t = Ro,
      e = Do,
      r = Po,
      u = t * t + e * e + r * r;
    return Pa > u && (t = Lo, e = qo, r = To, Da > Eo && (t = Ao, e = Co, r = zo), u = t * t + e * e + r * r, Pa > u) ? [NaN, NaN] : [Math.atan2(e, t) * Ia, tn(r / Math.sqrt(u)) * Ia];
  };
  var No,
    Eo,
    Ao,
    Co,
    zo,
    Lo,
    qo,
    To,
    Ro,
    Do,
    Po,
    jo = {
      sphere: b,
      point: St,
      lineStart: Nt,
      lineEnd: Et,
      polygonStart: function () {
        jo.lineStart = At;
      },
      polygonEnd: function () {
        jo.lineStart = Nt;
      }
    },
    Uo = Rt(zt, Ut, Ht, [-ja, -ja / 2]),
    Fo = 1e9;
  oa.geo.clipExtent = function () {
    var n,
      t,
      e,
      r,
      u,
      i,
      a = {
        stream: function (n) {
          return u && (u.valid = !1), u = i(n), u.valid = !0, u;
        },
        extent: function (o) {
          return arguments.length ? (i = Zt(n = +o[0][0], t = +o[0][1], e = +o[1][0], r = +o[1][1]), u && (u.valid = !1, u = null), a) : [[n, t], [e, r]];
        }
      };
    return a.extent([[0, 0], [960, 500]]);
  }, (oa.geo.conicEqualArea = function () {
    return Vt(Xt);
  }).raw = Xt, oa.geo.albers = function () {
    return oa.geo.conicEqualArea().rotate([96, 0]).center([-.6, 38.7]).parallels([29.5, 45.5]).scale(1070);
  }, oa.geo.albersUsa = function () {
    function n(n) {
      var i = n[0],
        a = n[1];
      return t = null, e(i, a), t || (r(i, a), t) || u(i, a), t;
    }
    var t,
      e,
      r,
      u,
      i = oa.geo.albers(),
      a = oa.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
      o = oa.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
      l = {
        point: function (n, e) {
          t = [n, e];
        }
      };
    return n.invert = function (n) {
      var t = i.scale(),
        e = i.translate(),
        r = (n[0] - e[0]) / t,
        u = (n[1] - e[1]) / t;
      return (u >= .12 && .234 > u && r >= -.425 && -.214 > r ? a : u >= .166 && .234 > u && r >= -.214 && -.115 > r ? o : i).invert(n);
    }, n.stream = function (n) {
      var t = i.stream(n),
        e = a.stream(n),
        r = o.stream(n);
      return {
        point: function (n, u) {
          t.point(n, u), e.point(n, u), r.point(n, u);
        },
        sphere: function () {
          t.sphere(), e.sphere(), r.sphere();
        },
        lineStart: function () {
          t.lineStart(), e.lineStart(), r.lineStart();
        },
        lineEnd: function () {
          t.lineEnd(), e.lineEnd(), r.lineEnd();
        },
        polygonStart: function () {
          t.polygonStart(), e.polygonStart(), r.polygonStart();
        },
        polygonEnd: function () {
          t.polygonEnd(), e.polygonEnd(), r.polygonEnd();
        }
      };
    }, n.precision = function (t) {
      return arguments.length ? (i.precision(t), a.precision(t), o.precision(t), n) : i.precision();
    }, n.scale = function (t) {
      return arguments.length ? (i.scale(t), a.scale(.35 * t), o.scale(t), n.translate(i.translate())) : i.scale();
    }, n.translate = function (t) {
      if (!arguments.length) return i.translate();
      var c = i.scale(),
        s = +t[0],
        f = +t[1];
      return e = i.translate(t).clipExtent([[s - .455 * c, f - .238 * c], [s + .455 * c, f + .238 * c]]).stream(l).point, r = a.translate([s - .307 * c, f + .201 * c]).clipExtent([[s - .425 * c + Da, f + .12 * c + Da], [s - .214 * c - Da, f + .234 * c - Da]]).stream(l).point, u = o.translate([s - .205 * c, f + .212 * c]).clipExtent([[s - .214 * c + Da, f + .166 * c + Da], [s - .115 * c - Da, f + .234 * c - Da]]).stream(l).point, n;
    }, n.scale(1070);
  };
  var Ho,
    Oo,
    Io,
    Yo,
    Zo,
    Vo,
    Xo = {
      point: b,
      lineStart: b,
      lineEnd: b,
      polygonStart: function () {
        Oo = 0, Xo.lineStart = $t;
      },
      polygonEnd: function () {
        Xo.lineStart = Xo.lineEnd = Xo.point = b, Ho += Ma(Oo / 2);
      }
    },
    $o = {
      point: Bt,
      lineStart: b,
      lineEnd: b,
      polygonStart: b,
      polygonEnd: b
    },
    Bo = {
      point: Gt,
      lineStart: Kt,
      lineEnd: Qt,
      polygonStart: function () {
        Bo.lineStart = ne;
      },
      polygonEnd: function () {
        Bo.point = Gt, Bo.lineStart = Kt, Bo.lineEnd = Qt;
      }
    };
  oa.geo.path = function () {
    function n(n) {
      return n && ("function" == typeof o && i.pointRadius(+o.apply(this, arguments)), a && a.valid || (a = u(i)), oa.geo.stream(n, a)), i.result();
    }
    function t() {
      return a = null, n;
    }
    var e,
      r,
      u,
      i,
      a,
      o = 4.5;
    return n.area = function (n) {
      return Ho = 0, oa.geo.stream(n, u(Xo)), Ho;
    }, n.centroid = function (n) {
      return Ao = Co = zo = Lo = qo = To = Ro = Do = Po = 0, oa.geo.stream(n, u(Bo)), Po ? [Ro / Po, Do / Po] : To ? [Lo / To, qo / To] : zo ? [Ao / zo, Co / zo] : [NaN, NaN];
    }, n.bounds = function (n) {
      return Zo = Vo = -(Io = Yo = 1 / 0), oa.geo.stream(n, u($o)), [[Io, Yo], [Zo, Vo]];
    }, n.projection = function (n) {
      return arguments.length ? (u = (e = n) ? n.stream || re(n) : y, t()) : e;
    }, n.context = function (n) {
      return arguments.length ? (i = null == (r = n) ? new Wt() : new te(n), "function" != typeof o && i.pointRadius(o), t()) : r;
    }, n.pointRadius = function (t) {
      return arguments.length ? (o = "function" == typeof t ? t : (i.pointRadius(+t), +t), n) : o;
    }, n.projection(oa.geo.albersUsa()).context(null);
  }, oa.geo.transform = function (n) {
    return {
      stream: function (t) {
        var e = new ue(t);
        for (var r in n) e[r] = n[r];
        return e;
      }
    };
  }, ue.prototype = {
    point: function (n, t) {
      this.stream.point(n, t);
    },
    sphere: function () {
      this.stream.sphere();
    },
    lineStart: function () {
      this.stream.lineStart();
    },
    lineEnd: function () {
      this.stream.lineEnd();
    },
    polygonStart: function () {
      this.stream.polygonStart();
    },
    polygonEnd: function () {
      this.stream.polygonEnd();
    }
  }, oa.geo.projection = ae, oa.geo.projectionMutator = oe, (oa.geo.equirectangular = function () {
    return ae(ce);
  }).raw = ce.invert = ce, oa.geo.rotation = function (n) {
    function t(t) {
      return t = n(t[0] * Oa, t[1] * Oa), t[0] *= Ia, t[1] *= Ia, t;
    }
    return n = fe(n[0] % 360 * Oa, n[1] * Oa, n.length > 2 ? n[2] * Oa : 0), t.invert = function (t) {
      return t = n.invert(t[0] * Oa, t[1] * Oa), t[0] *= Ia, t[1] *= Ia, t;
    }, t;
  }, se.invert = ce, oa.geo.circle = function () {
    function n() {
      var n = "function" == typeof r ? r.apply(this, arguments) : r,
        t = fe(-n[0] * Oa, -n[1] * Oa, 0).invert,
        u = [];
      return e(null, null, 1, {
        point: function (n, e) {
          u.push(n = t(n, e)), n[0] *= Ia, n[1] *= Ia;
        }
      }), {
        type: "Polygon",
        coordinates: [u]
      };
    }
    var t,
      e,
      r = [0, 0],
      u = 6;
    return n.origin = function (t) {
      return arguments.length ? (r = t, n) : r;
    }, n.angle = function (r) {
      return arguments.length ? (e = ve((t = +r) * Oa, u * Oa), n) : t;
    }, n.precision = function (r) {
      return arguments.length ? (e = ve(t * Oa, (u = +r) * Oa), n) : u;
    }, n.angle(90);
  }, oa.geo.distance = function (n, t) {
    var e,
      r = (t[0] - n[0]) * Oa,
      u = n[1] * Oa,
      i = t[1] * Oa,
      a = Math.sin(r),
      o = Math.cos(r),
      l = Math.sin(u),
      c = Math.cos(u),
      s = Math.sin(i),
      f = Math.cos(i);
    return Math.atan2(Math.sqrt((e = f * a) * e + (e = c * s - l * f * o) * e), l * s + c * f * o);
  }, oa.geo.graticule = function () {
    function n() {
      return {
        type: "MultiLineString",
        coordinates: t()
      };
    }
    function t() {
      return oa.range(Math.ceil(i / d) * d, u, d).map(h).concat(oa.range(Math.ceil(c / m) * m, l, m).map(g)).concat(oa.range(Math.ceil(r / p) * p, e, p).filter(function (n) {
        return Ma(n % d) > Da;
      }).map(s)).concat(oa.range(Math.ceil(o / v) * v, a, v).filter(function (n) {
        return Ma(n % m) > Da;
      }).map(f));
    }
    var e,
      r,
      u,
      i,
      a,
      o,
      l,
      c,
      s,
      f,
      h,
      g,
      p = 10,
      v = p,
      d = 90,
      m = 360,
      y = 2.5;
    return n.lines = function () {
      return t().map(function (n) {
        return {
          type: "LineString",
          coordinates: n
        };
      });
    }, n.outline = function () {
      return {
        type: "Polygon",
        coordinates: [h(i).concat(g(l).slice(1), h(u).reverse().slice(1), g(c).reverse().slice(1))]
      };
    }, n.extent = function (t) {
      return arguments.length ? n.majorExtent(t).minorExtent(t) : n.minorExtent();
    }, n.majorExtent = function (t) {
      return arguments.length ? (i = +t[0][0], u = +t[1][0], c = +t[0][1], l = +t[1][1], i > u && (t = i, i = u, u = t), c > l && (t = c, c = l, l = t), n.precision(y)) : [[i, c], [u, l]];
    }, n.minorExtent = function (t) {
      return arguments.length ? (r = +t[0][0], e = +t[1][0], o = +t[0][1], a = +t[1][1], r > e && (t = r, r = e, e = t), o > a && (t = o, o = a, a = t), n.precision(y)) : [[r, o], [e, a]];
    }, n.step = function (t) {
      return arguments.length ? n.majorStep(t).minorStep(t) : n.minorStep();
    }, n.majorStep = function (t) {
      return arguments.length ? (d = +t[0], m = +t[1], n) : [d, m];
    }, n.minorStep = function (t) {
      return arguments.length ? (p = +t[0], v = +t[1], n) : [p, v];
    }, n.precision = function (t) {
      return arguments.length ? (y = +t, s = me(o, a, 90), f = ye(r, e, y), h = me(c, l, 90), g = ye(i, u, y), n) : y;
    }, n.majorExtent([[-180, -90 + Da], [180, 90 - Da]]).minorExtent([[-180, -80 - Da], [180, 80 + Da]]);
  }, oa.geo.greatArc = function () {
    function n() {
      return {
        type: "LineString",
        coordinates: [t || r.apply(this, arguments), e || u.apply(this, arguments)]
      };
    }
    var t,
      e,
      r = Me,
      u = xe;
    return n.distance = function () {
      return oa.geo.distance(t || r.apply(this, arguments), e || u.apply(this, arguments));
    }, n.source = function (e) {
      return arguments.length ? (r = e, t = "function" == typeof e ? null : e, n) : r;
    }, n.target = function (t) {
      return arguments.length ? (u = t, e = "function" == typeof t ? null : t, n) : u;
    }, n.precision = function () {
      return arguments.length ? n : 0;
    }, n;
  }, oa.geo.interpolate = function (n, t) {
    return be(n[0] * Oa, n[1] * Oa, t[0] * Oa, t[1] * Oa);
  }, oa.geo.length = function (n) {
    return Wo = 0, oa.geo.stream(n, Jo), Wo;
  };
  var Wo,
    Jo = {
      sphere: b,
      point: b,
      lineStart: _e,
      lineEnd: b,
      polygonStart: b,
      polygonEnd: b
    },
    Go = we(function (n) {
      return Math.sqrt(2 / (1 + n));
    }, function (n) {
      return 2 * Math.asin(n / 2);
    });
  (oa.geo.azimuthalEqualArea = function () {
    return ae(Go);
  }).raw = Go;
  var Ko = we(function (n) {
    var t = Math.acos(n);
    return t && t / Math.sin(t);
  }, y);
  (oa.geo.azimuthalEquidistant = function () {
    return ae(Ko);
  }).raw = Ko, (oa.geo.conicConformal = function () {
    return Vt(Se);
  }).raw = Se, (oa.geo.conicEquidistant = function () {
    return Vt(ke);
  }).raw = ke;
  var Qo = we(function (n) {
    return 1 / n;
  }, Math.atan);
  (oa.geo.gnomonic = function () {
    return ae(Qo);
  }).raw = Qo, Ne.invert = function (n, t) {
    return [n, 2 * Math.atan(Math.exp(t)) - Ha];
  }, (oa.geo.mercator = function () {
    return Ee(Ne);
  }).raw = Ne;
  var nl = we(function () {
    return 1;
  }, Math.asin);
  (oa.geo.orthographic = function () {
    return ae(nl);
  }).raw = nl;
  var tl = we(function (n) {
    return 1 / (1 + n);
  }, function (n) {
    return 2 * Math.atan(n);
  });
  (oa.geo.stereographic = function () {
    return ae(tl);
  }).raw = tl, Ae.invert = function (n, t) {
    return [-t, 2 * Math.atan(Math.exp(n)) - Ha];
  }, (oa.geo.transverseMercator = function () {
    var n = Ee(Ae),
      t = n.center,
      e = n.rotate;
    return n.center = function (n) {
      return n ? t([-n[1], n[0]]) : (n = t(), [n[1], -n[0]]);
    }, n.rotate = function (n) {
      return n ? e([n[0], n[1], n.length > 2 ? n[2] + 90 : 90]) : (n = e(), [n[0], n[1], n[2] - 90]);
    }, e([0, 0, 90]);
  }).raw = Ae, oa.geom = {}, oa.geom.hull = function (n) {
    function t(n) {
      if (n.length < 3) return [];
      var t,
        u = En(e),
        i = En(r),
        a = n.length,
        o = [],
        l = [];
      for (t = 0; a > t; t++) o.push([+u.call(this, n[t], t), +i.call(this, n[t], t), t]);
      for (o.sort(qe), t = 0; a > t; t++) l.push([o[t][0], -o[t][1]]);
      var c = Le(o),
        s = Le(l),
        f = s[0] === c[0],
        h = s[s.length - 1] === c[c.length - 1],
        g = [];
      for (t = c.length - 1; t >= 0; --t) g.push(n[o[c[t]][2]]);
      for (t = +f; t < s.length - h; ++t) g.push(n[o[s[t]][2]]);
      return g;
    }
    var e = Ce,
      r = ze;
    return arguments.length ? t(n) : (t.x = function (n) {
      return arguments.length ? (e = n, t) : e;
    }, t.y = function (n) {
      return arguments.length ? (r = n, t) : r;
    }, t);
  }, oa.geom.polygon = function (n) {
    return Sa(n, el), n;
  };
  var el = oa.geom.polygon.prototype = [];
  el.area = function () {
    for (var n, t = -1, e = this.length, r = this[e - 1], u = 0; ++t < e;) n = r, r = this[t], u += n[1] * r[0] - n[0] * r[1];
    return .5 * u;
  }, el.centroid = function (n) {
    var t,
      e,
      r = -1,
      u = this.length,
      i = 0,
      a = 0,
      o = this[u - 1];
    for (arguments.length || (n = -1 / (6 * this.area())); ++r < u;) t = o, o = this[r], e = t[0] * o[1] - o[0] * t[1], i += (t[0] + o[0]) * e, a += (t[1] + o[1]) * e;
    return [i * n, a * n];
  }, el.clip = function (n) {
    for (var t, e, r, u, i, a, o = De(n), l = -1, c = this.length - De(this), s = this[c - 1]; ++l < c;) {
      for (t = n.slice(), n.length = 0, u = this[l], i = t[(r = t.length - o) - 1], e = -1; ++e < r;) a = t[e], Te(a, s, u) ? (Te(i, s, u) || n.push(Re(i, a, s, u)), n.push(a)) : Te(i, s, u) && n.push(Re(i, a, s, u)), i = a;
      o && n.push(n[0]), s = u;
    }
    return n;
  };
  var rl,
    ul,
    il,
    al,
    ol,
    ll = [],
    cl = [];
  Ye.prototype.prepare = function () {
    for (var n, t = this.edges, e = t.length; e--;) n = t[e].edge, n.b && n.a || t.splice(e, 1);
    return t.sort(Ve), t.length;
  }, tr.prototype = {
    start: function () {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function () {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  }, er.prototype = {
    insert: function (n, t) {
      var e, r, u;
      if (n) {
        if (t.P = n, t.N = n.N, n.N && (n.N.P = t), n.N = t, n.R) {
          for (n = n.R; n.L;) n = n.L;
          n.L = t;
        } else n.R = t;
        e = n;
      } else this._ ? (n = ar(this._), t.P = null, t.N = n, n.P = n.L = t, e = n) : (t.P = t.N = null, this._ = t, e = null);
      for (t.L = t.R = null, t.U = e, t.C = !0, n = t; e && e.C;) r = e.U, e === r.L ? (u = r.R, u && u.C ? (e.C = u.C = !1, r.C = !0, n = r) : (n === e.R && (ur(this, e), n = e, e = n.U), e.C = !1, r.C = !0, ir(this, r))) : (u = r.L, u && u.C ? (e.C = u.C = !1, r.C = !0, n = r) : (n === e.L && (ir(this, e), n = e, e = n.U), e.C = !1, r.C = !0, ur(this, r))), e = n.U;
      this._.C = !1;
    },
    remove: function (n) {
      n.N && (n.N.P = n.P), n.P && (n.P.N = n.N), n.N = n.P = null;
      var t,
        e,
        r,
        u = n.U,
        i = n.L,
        a = n.R;
      if (e = i ? a ? ar(a) : i : a, u ? u.L === n ? u.L = e : u.R = e : this._ = e, i && a ? (r = e.C, e.C = n.C, e.L = i, i.U = e, e !== a ? (u = e.U, e.U = n.U, n = e.R, u.L = n, e.R = a, a.U = e) : (e.U = u, u = e, n = e.R)) : (r = n.C, n = e), n && (n.U = u), !r) {
        if (n && n.C) return void (n.C = !1);
        do {
          if (n === this._) break;
          if (n === u.L) {
            if (t = u.R, t.C && (t.C = !1, u.C = !0, ur(this, u), t = u.R), t.L && t.L.C || t.R && t.R.C) {
              t.R && t.R.C || (t.L.C = !1, t.C = !0, ir(this, t), t = u.R), t.C = u.C, u.C = t.R.C = !1, ur(this, u), n = this._;
              break;
            }
          } else if (t = u.L, t.C && (t.C = !1, u.C = !0, ir(this, u), t = u.L), t.L && t.L.C || t.R && t.R.C) {
            t.L && t.L.C || (t.R.C = !1, t.C = !0, ur(this, t), t = u.L), t.C = u.C, u.C = t.L.C = !1, ir(this, u), n = this._;
            break;
          }
          t.C = !0, n = u, u = u.U;
        } while (!n.C);
        n && (n.C = !1);
      }
    }
  }, oa.geom.voronoi = function (n) {
    function t(n) {
      var t = new Array(n.length),
        r = o[0][0],
        u = o[0][1],
        i = o[1][0],
        a = o[1][1];
      return or(e(n), o).cells.forEach(function (e, o) {
        var l = e.edges,
          c = e.site,
          s = t[o] = l.length ? l.map(function (n) {
            var t = n.start();
            return [t.x, t.y];
          }) : c.x >= r && c.x <= i && c.y >= u && c.y <= a ? [[r, a], [i, a], [i, u], [r, u]] : [];
        s.point = n[o];
      }), t;
    }
    function e(n) {
      return n.map(function (n, t) {
        return {
          x: Math.round(i(n, t) / Da) * Da,
          y: Math.round(a(n, t) / Da) * Da,
          i: t
        };
      });
    }
    var r = Ce,
      u = ze,
      i = r,
      a = u,
      o = sl;
    return n ? t(n) : (t.links = function (n) {
      return or(e(n)).edges.filter(function (n) {
        return n.l && n.r;
      }).map(function (t) {
        return {
          source: n[t.l.i],
          target: n[t.r.i]
        };
      });
    }, t.triangles = function (n) {
      var t = [];
      return or(e(n)).cells.forEach(function (e, r) {
        for (var u, i, a = e.site, o = e.edges.sort(Ve), l = -1, c = o.length, s = o[c - 1].edge, f = s.l === a ? s.r : s.l; ++l < c;) u = s, i = f, s = o[l].edge, f = s.l === a ? s.r : s.l, r < i.i && r < f.i && cr(a, i, f) < 0 && t.push([n[r], n[i.i], n[f.i]]);
      }), t;
    }, t.x = function (n) {
      return arguments.length ? (i = En(r = n), t) : r;
    }, t.y = function (n) {
      return arguments.length ? (a = En(u = n), t) : u;
    }, t.clipExtent = function (n) {
      return arguments.length ? (o = null == n ? sl : n, t) : o === sl ? null : o;
    }, t.size = function (n) {
      return arguments.length ? t.clipExtent(n && [[0, 0], n]) : o === sl ? null : o && o[1];
    }, t);
  };
  var sl = [[-1e6, -1e6], [1e6, 1e6]];
  oa.geom.delaunay = function (n) {
    return oa.geom.voronoi().triangles(n);
  }, oa.geom.quadtree = function (n, t, e, r, u) {
    function i(n) {
      function i(n, t, e, r, u, i, a, o) {
        if (!isNaN(e) && !isNaN(r)) if (n.leaf) {
          var l = n.x,
            s = n.y;
          if (null != l) {
            if (Ma(l - e) + Ma(s - r) < .01) c(n, t, e, r, u, i, a, o);else {
              var f = n.point;
              n.x = n.y = n.point = null, c(n, f, l, s, u, i, a, o), c(n, t, e, r, u, i, a, o);
            }
          } else n.x = e, n.y = r, n.point = t;
        } else c(n, t, e, r, u, i, a, o);
      }
      function c(n, t, e, r, u, a, o, l) {
        var c = .5 * (u + o),
          s = .5 * (a + l),
          f = e >= c,
          h = r >= s,
          g = h << 1 | f;
        n.leaf = !1, n = n.nodes[g] || (n.nodes[g] = hr()), f ? u = c : o = c, h ? a = s : l = s, i(n, t, e, r, u, a, o, l);
      }
      var s,
        f,
        h,
        g,
        p,
        v,
        d,
        m,
        y,
        M = En(o),
        x = En(l);
      if (null != t) v = t, d = e, m = r, y = u;else if (m = y = -(v = d = 1 / 0), f = [], h = [], p = n.length, a) for (g = 0; p > g; ++g) s = n[g], s.x < v && (v = s.x), s.y < d && (d = s.y), s.x > m && (m = s.x), s.y > y && (y = s.y), f.push(s.x), h.push(s.y);else for (g = 0; p > g; ++g) {
        var b = +M(s = n[g], g),
          _ = +x(s, g);
        v > b && (v = b), d > _ && (d = _), b > m && (m = b), _ > y && (y = _), f.push(b), h.push(_);
      }
      var w = m - v,
        S = y - d;
      w > S ? y = d + w : m = v + S;
      var k = hr();
      if (k.add = function (n) {
        i(k, n, +M(n, ++g), +x(n, g), v, d, m, y);
      }, k.visit = function (n) {
        gr(n, k, v, d, m, y);
      }, k.find = function (n) {
        return pr(k, n[0], n[1], v, d, m, y);
      }, g = -1, null == t) {
        for (; ++g < p;) i(k, n[g], f[g], h[g], v, d, m, y);
        --g;
      } else n.forEach(k.add);
      return f = h = n = s = null, k;
    }
    var a,
      o = Ce,
      l = ze;
    return (a = arguments.length) ? (o = sr, l = fr, 3 === a && (u = e, r = t, e = t = 0), i(n)) : (i.x = function (n) {
      return arguments.length ? (o = n, i) : o;
    }, i.y = function (n) {
      return arguments.length ? (l = n, i) : l;
    }, i.extent = function (n) {
      return arguments.length ? (null == n ? t = e = r = u = null : (t = +n[0][0], e = +n[0][1], r = +n[1][0], u = +n[1][1]), i) : null == t ? null : [[t, e], [r, u]];
    }, i.size = function (n) {
      return arguments.length ? (null == n ? t = e = r = u = null : (t = e = 0, r = +n[0], u = +n[1]), i) : null == t ? null : [r - t, u - e];
    }, i);
  }, oa.interpolateRgb = vr, oa.interpolateObject = dr, oa.interpolateNumber = mr, oa.interpolateString = yr;
  var fl = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    hl = new RegExp(fl.source, "g");
  oa.interpolate = Mr, oa.interpolators = [function (n, t) {
    var e = typeof t;
    return ("string" === e ? ro.has(t.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(t) ? vr : yr : t instanceof on ? vr : Array.isArray(t) ? xr : "object" === e && isNaN(t) ? dr : mr)(n, t);
  }], oa.interpolateArray = xr;
  var gl = function () {
      return y;
    },
    pl = oa.map({
      linear: gl,
      poly: Er,
      quad: function () {
        return Sr;
      },
      cubic: function () {
        return kr;
      },
      sin: function () {
        return Ar;
      },
      exp: function () {
        return Cr;
      },
      circle: function () {
        return zr;
      },
      elastic: Lr,
      back: qr,
      bounce: function () {
        return Tr;
      }
    }),
    vl = oa.map({
      "in": y,
      out: _r,
      "in-out": wr,
      "out-in": function (n) {
        return wr(_r(n));
      }
    });
  oa.ease = function (n) {
    var t = n.indexOf("-"),
      e = t >= 0 ? n.slice(0, t) : n,
      r = t >= 0 ? n.slice(t + 1) : "in";
    return e = pl.get(e) || gl, r = vl.get(r) || y, br(r(e.apply(null, la.call(arguments, 1))));
  }, oa.interpolateHcl = Rr, oa.interpolateHsl = Dr, oa.interpolateLab = Pr, oa.interpolateRound = jr, oa.transform = function (n) {
    var t = sa.createElementNS(oa.ns.prefix.svg, "g");
    return (oa.transform = function (n) {
      if (null != n) {
        t.setAttribute("transform", n);
        var e = t.transform.baseVal.consolidate();
      }
      return new Ur(e ? e.matrix : dl);
    })(n);
  }, Ur.prototype.toString = function () {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  var dl = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  oa.interpolateTransform = $r, oa.layout = {}, oa.layout.bundle = function () {
    return function (n) {
      for (var t = [], e = -1, r = n.length; ++e < r;) t.push(Jr(n[e]));
      return t;
    };
  }, oa.layout.chord = function () {
    function n() {
      var n,
        c,
        f,
        h,
        g,
        p = {},
        v = [],
        d = oa.range(i),
        m = [];
      for (e = [], r = [], n = 0, h = -1; ++h < i;) {
        for (c = 0, g = -1; ++g < i;) c += u[h][g];
        v.push(c), m.push(oa.range(i)), n += c;
      }
      for (a && d.sort(function (n, t) {
        return a(v[n], v[t]);
      }), o && m.forEach(function (n, t) {
        n.sort(function (n, e) {
          return o(u[t][n], u[t][e]);
        });
      }), n = (Ua - s * i) / n, c = 0, h = -1; ++h < i;) {
        for (f = c, g = -1; ++g < i;) {
          var y = d[h],
            M = m[y][g],
            x = u[y][M],
            b = c,
            _ = c += x * n;
          p[y + "-" + M] = {
            index: y,
            subindex: M,
            startAngle: b,
            endAngle: _,
            value: x
          };
        }
        r[y] = {
          index: y,
          startAngle: f,
          endAngle: c,
          value: v[y]
        }, c += s;
      }
      for (h = -1; ++h < i;) for (g = h - 1; ++g < i;) {
        var w = p[h + "-" + g],
          S = p[g + "-" + h];
        (w.value || S.value) && e.push(w.value < S.value ? {
          source: S,
          target: w
        } : {
          source: w,
          target: S
        });
      }
      l && t();
    }
    function t() {
      e.sort(function (n, t) {
        return l((n.source.value + n.target.value) / 2, (t.source.value + t.target.value) / 2);
      });
    }
    var e,
      r,
      u,
      i,
      a,
      o,
      l,
      c = {},
      s = 0;
    return c.matrix = function (n) {
      return arguments.length ? (i = (u = n) && u.length, e = r = null, c) : u;
    }, c.padding = function (n) {
      return arguments.length ? (s = n, e = r = null, c) : s;
    }, c.sortGroups = function (n) {
      return arguments.length ? (a = n, e = r = null, c) : a;
    }, c.sortSubgroups = function (n) {
      return arguments.length ? (o = n, e = null, c) : o;
    }, c.sortChords = function (n) {
      return arguments.length ? (l = n, e && t(), c) : l;
    }, c.chords = function () {
      return e || n(), e;
    }, c.groups = function () {
      return r || n(), r;
    }, c;
  }, oa.layout.force = function () {
    function n(n) {
      return function (t, e, r, u) {
        if (t.point !== n) {
          var i = t.cx - n.x,
            a = t.cy - n.y,
            o = u - e,
            l = i * i + a * a;
          if (l > o * o / m) {
            if (v > l) {
              var c = t.charge / l;
              n.px -= i * c, n.py -= a * c;
            }
            return !0;
          }
          if (t.point && l && v > l) {
            var c = t.pointCharge / l;
            n.px -= i * c, n.py -= a * c;
          }
        }
        return !t.charge;
      };
    }
    function t(n) {
      n.px = oa.event.x, n.py = oa.event.y, l.resume();
    }
    var e,
      r,
      u,
      i,
      a,
      o,
      l = {},
      c = oa.dispatch("start", "tick", "end"),
      s = [1, 1],
      f = .9,
      h = ml,
      g = yl,
      p = -30,
      v = Ml,
      d = .1,
      m = .64,
      M = [],
      x = [];
    return l.tick = function () {
      if ((u *= .99) < .005) return e = null, c.end({
        type: "end",
        alpha: u = 0
      }), !0;
      var t,
        r,
        l,
        h,
        g,
        v,
        m,
        y,
        b,
        _ = M.length,
        w = x.length;
      for (r = 0; w > r; ++r) l = x[r], h = l.source, g = l.target, y = g.x - h.x, b = g.y - h.y, (v = y * y + b * b) && (v = u * a[r] * ((v = Math.sqrt(v)) - i[r]) / v, y *= v, b *= v, g.x -= y * (m = h.weight + g.weight ? h.weight / (h.weight + g.weight) : .5), g.y -= b * m, h.x += y * (m = 1 - m), h.y += b * m);
      if ((m = u * d) && (y = s[0] / 2, b = s[1] / 2, r = -1, m)) for (; ++r < _;) l = M[r], l.x += (y - l.x) * m, l.y += (b - l.y) * m;
      if (p) for (ru(t = oa.geom.quadtree(M), u, o), r = -1; ++r < _;) (l = M[r]).fixed || t.visit(n(l));
      for (r = -1; ++r < _;) l = M[r], l.fixed ? (l.x = l.px, l.y = l.py) : (l.x -= (l.px - (l.px = l.x)) * f, l.y -= (l.py - (l.py = l.y)) * f);
      c.tick({
        type: "tick",
        alpha: u
      });
    }, l.nodes = function (n) {
      return arguments.length ? (M = n, l) : M;
    }, l.links = function (n) {
      return arguments.length ? (x = n, l) : x;
    }, l.size = function (n) {
      return arguments.length ? (s = n, l) : s;
    }, l.linkDistance = function (n) {
      return arguments.length ? (h = "function" == typeof n ? n : +n, l) : h;
    }, l.distance = l.linkDistance, l.linkStrength = function (n) {
      return arguments.length ? (g = "function" == typeof n ? n : +n, l) : g;
    }, l.friction = function (n) {
      return arguments.length ? (f = +n, l) : f;
    }, l.charge = function (n) {
      return arguments.length ? (p = "function" == typeof n ? n : +n, l) : p;
    }, l.chargeDistance = function (n) {
      return arguments.length ? (v = n * n, l) : Math.sqrt(v);
    }, l.gravity = function (n) {
      return arguments.length ? (d = +n, l) : d;
    }, l.theta = function (n) {
      return arguments.length ? (m = n * n, l) : Math.sqrt(m);
    }, l.alpha = function (n) {
      return arguments.length ? (n = +n, u ? n > 0 ? u = n : (e.c = null, e.t = NaN, e = null, c.end({
        type: "end",
        alpha: u = 0
      })) : n > 0 && (c.start({
        type: "start",
        alpha: u = n
      }), e = qn(l.tick)), l) : u;
    }, l.start = function () {
      function n(n, r) {
        if (!e) {
          for (e = new Array(u), l = 0; u > l; ++l) e[l] = [];
          for (l = 0; c > l; ++l) {
            var i = x[l];
            e[i.source.index].push(i.target), e[i.target.index].push(i.source);
          }
        }
        for (var a, o = e[t], l = -1, s = o.length; ++l < s;) if (!isNaN(a = o[l][n])) return a;
        return Math.random() * r;
      }
      var t,
        e,
        r,
        u = M.length,
        c = x.length,
        f = s[0],
        v = s[1];
      for (t = 0; u > t; ++t) (r = M[t]).index = t, r.weight = 0;
      for (t = 0; c > t; ++t) r = x[t], "number" == typeof r.source && (r.source = M[r.source]), "number" == typeof r.target && (r.target = M[r.target]), ++r.source.weight, ++r.target.weight;
      for (t = 0; u > t; ++t) r = M[t], isNaN(r.x) && (r.x = n("x", f)), isNaN(r.y) && (r.y = n("y", v)), isNaN(r.px) && (r.px = r.x), isNaN(r.py) && (r.py = r.y);
      if (i = [], "function" == typeof h) for (t = 0; c > t; ++t) i[t] = +h.call(this, x[t], t);else for (t = 0; c > t; ++t) i[t] = h;
      if (a = [], "function" == typeof g) for (t = 0; c > t; ++t) a[t] = +g.call(this, x[t], t);else for (t = 0; c > t; ++t) a[t] = g;
      if (o = [], "function" == typeof p) for (t = 0; u > t; ++t) o[t] = +p.call(this, M[t], t);else for (t = 0; u > t; ++t) o[t] = p;
      return l.resume();
    }, l.resume = function () {
      return l.alpha(.1);
    }, l.stop = function () {
      return l.alpha(0);
    }, l.drag = function () {
      return r || (r = oa.behavior.drag().origin(y).on("dragstart.force", Qr).on("drag.force", t).on("dragend.force", nu)), arguments.length ? void this.on("mouseover.force", tu).on("mouseout.force", eu).call(r) : r;
    }, oa.rebind(l, c, "on");
  };
  var ml = 20,
    yl = 1,
    Ml = 1 / 0;
  oa.layout.hierarchy = function () {
    function n(u) {
      var i,
        a = [u],
        o = [];
      for (u.depth = 0; null != (i = a.pop());) if (o.push(i), (c = e.call(n, i, i.depth)) && (l = c.length)) {
        for (var l, c, s; --l >= 0;) a.push(s = c[l]), s.parent = i, s.depth = i.depth + 1;
        r && (i.value = 0), i.children = c;
      } else r && (i.value = +r.call(n, i, i.depth) || 0), delete i.children;
      return au(u, function (n) {
        var e, u;
        t && (e = n.children) && e.sort(t), r && (u = n.parent) && (u.value += n.value);
      }), o;
    }
    var t = cu,
      e = ou,
      r = lu;
    return n.sort = function (e) {
      return arguments.length ? (t = e, n) : t;
    }, n.children = function (t) {
      return arguments.length ? (e = t, n) : e;
    }, n.value = function (t) {
      return arguments.length ? (r = t, n) : r;
    }, n.revalue = function (t) {
      return r && (iu(t, function (n) {
        n.children && (n.value = 0);
      }), au(t, function (t) {
        var e;
        t.children || (t.value = +r.call(n, t, t.depth) || 0), (e = t.parent) && (e.value += t.value);
      })), t;
    }, n;
  }, oa.layout.partition = function () {
    function n(t, e, r, u) {
      var i = t.children;
      if (t.x = e, t.y = t.depth * u, t.dx = r, t.dy = u, i && (a = i.length)) {
        var a,
          o,
          l,
          c = -1;
        for (r = t.value ? r / t.value : 0; ++c < a;) n(o = i[c], e, l = o.value * r, u), e += l;
      }
    }
    function t(n) {
      var e = n.children,
        r = 0;
      if (e && (u = e.length)) for (var u, i = -1; ++i < u;) r = Math.max(r, t(e[i]));
      return 1 + r;
    }
    function e(e, i) {
      var a = r.call(this, e, i);
      return n(a[0], 0, u[0], u[1] / t(a[0])), a;
    }
    var r = oa.layout.hierarchy(),
      u = [1, 1];
    return e.size = function (n) {
      return arguments.length ? (u = n, e) : u;
    }, uu(e, r);
  }, oa.layout.pie = function () {
    function n(a) {
      var o,
        l = a.length,
        c = a.map(function (e, r) {
          return +t.call(n, e, r);
        }),
        s = +("function" == typeof r ? r.apply(this, arguments) : r),
        f = ("function" == typeof u ? u.apply(this, arguments) : u) - s,
        h = Math.min(Math.abs(f) / l, +("function" == typeof i ? i.apply(this, arguments) : i)),
        g = h * (0 > f ? -1 : 1),
        p = oa.sum(c),
        v = p ? (f - l * g) / p : 0,
        d = oa.range(l),
        m = [];
      return null != e && d.sort(e === xl ? function (n, t) {
        return c[t] - c[n];
      } : function (n, t) {
        return e(a[n], a[t]);
      }), d.forEach(function (n) {
        m[n] = {
          data: a[n],
          value: o = c[n],
          startAngle: s,
          endAngle: s += o * v + g,
          padAngle: h
        };
      }), m;
    }
    var t = Number,
      e = xl,
      r = 0,
      u = Ua,
      i = 0;
    return n.value = function (e) {
      return arguments.length ? (t = e, n) : t;
    }, n.sort = function (t) {
      return arguments.length ? (e = t, n) : e;
    }, n.startAngle = function (t) {
      return arguments.length ? (r = t, n) : r;
    }, n.endAngle = function (t) {
      return arguments.length ? (u = t, n) : u;
    }, n.padAngle = function (t) {
      return arguments.length ? (i = t, n) : i;
    }, n;
  };
  var xl = {};
  oa.layout.stack = function () {
    function n(o, l) {
      if (!(h = o.length)) return o;
      var c = o.map(function (e, r) {
          return t.call(n, e, r);
        }),
        s = c.map(function (t) {
          return t.map(function (t, e) {
            return [i.call(n, t, e), a.call(n, t, e)];
          });
        }),
        f = e.call(n, s, l);
      c = oa.permute(c, f), s = oa.permute(s, f);
      var h,
        g,
        p,
        v,
        d = r.call(n, s, l),
        m = c[0].length;
      for (p = 0; m > p; ++p) for (u.call(n, c[0][p], v = d[p], s[0][p][1]), g = 1; h > g; ++g) u.call(n, c[g][p], v += s[g - 1][p][1], s[g][p][1]);
      return o;
    }
    var t = y,
      e = pu,
      r = vu,
      u = gu,
      i = fu,
      a = hu;
    return n.values = function (e) {
      return arguments.length ? (t = e, n) : t;
    }, n.order = function (t) {
      return arguments.length ? (e = "function" == typeof t ? t : bl.get(t) || pu, n) : e;
    }, n.offset = function (t) {
      return arguments.length ? (r = "function" == typeof t ? t : _l.get(t) || vu, n) : r;
    }, n.x = function (t) {
      return arguments.length ? (i = t, n) : i;
    }, n.y = function (t) {
      return arguments.length ? (a = t, n) : a;
    }, n.out = function (t) {
      return arguments.length ? (u = t, n) : u;
    }, n;
  };
  var bl = oa.map({
      "inside-out": function (n) {
        var t,
          e,
          r = n.length,
          u = n.map(du),
          i = n.map(mu),
          a = oa.range(r).sort(function (n, t) {
            return u[n] - u[t];
          }),
          o = 0,
          l = 0,
          c = [],
          s = [];
        for (t = 0; r > t; ++t) e = a[t], l > o ? (o += i[e], c.push(e)) : (l += i[e], s.push(e));
        return s.reverse().concat(c);
      },
      reverse: function (n) {
        return oa.range(n.length).reverse();
      },
      "default": pu
    }),
    _l = oa.map({
      silhouette: function (n) {
        var t,
          e,
          r,
          u = n.length,
          i = n[0].length,
          a = [],
          o = 0,
          l = [];
        for (e = 0; i > e; ++e) {
          for (t = 0, r = 0; u > t; t++) r += n[t][e][1];
          r > o && (o = r), a.push(r);
        }
        for (e = 0; i > e; ++e) l[e] = (o - a[e]) / 2;
        return l;
      },
      wiggle: function (n) {
        var t,
          e,
          r,
          u,
          i,
          a,
          o,
          l,
          c,
          s = n.length,
          f = n[0],
          h = f.length,
          g = [];
        for (g[0] = l = c = 0, e = 1; h > e; ++e) {
          for (t = 0, u = 0; s > t; ++t) u += n[t][e][1];
          for (t = 0, i = 0, o = f[e][0] - f[e - 1][0]; s > t; ++t) {
            for (r = 0, a = (n[t][e][1] - n[t][e - 1][1]) / (2 * o); t > r; ++r) a += (n[r][e][1] - n[r][e - 1][1]) / o;
            i += a * n[t][e][1];
          }
          g[e] = l -= u ? i / u * o : 0, c > l && (c = l);
        }
        for (e = 0; h > e; ++e) g[e] -= c;
        return g;
      },
      expand: function (n) {
        var t,
          e,
          r,
          u = n.length,
          i = n[0].length,
          a = 1 / u,
          o = [];
        for (e = 0; i > e; ++e) {
          for (t = 0, r = 0; u > t; t++) r += n[t][e][1];
          if (r) for (t = 0; u > t; t++) n[t][e][1] /= r;else for (t = 0; u > t; t++) n[t][e][1] = a;
        }
        for (e = 0; i > e; ++e) o[e] = 0;
        return o;
      },
      zero: vu
    });
  oa.layout.histogram = function () {
    function n(n, i) {
      for (var a, o, l = [], c = n.map(e, this), s = r.call(this, c, i), f = u.call(this, s, c, i), i = -1, h = c.length, g = f.length - 1, p = t ? 1 : 1 / h; ++i < g;) a = l[i] = [], a.dx = f[i + 1] - (a.x = f[i]), a.y = 0;
      if (g > 0) for (i = -1; ++i < h;) o = c[i], o >= s[0] && o <= s[1] && (a = l[oa.bisect(f, o, 1, g) - 1], a.y += p, a.push(n[i]));
      return l;
    }
    var t = !0,
      e = Number,
      r = bu,
      u = Mu;
    return n.value = function (t) {
      return arguments.length ? (e = t, n) : e;
    }, n.range = function (t) {
      return arguments.length ? (r = En(t), n) : r;
    }, n.bins = function (t) {
      return arguments.length ? (u = "number" == typeof t ? function (n) {
        return xu(n, t);
      } : En(t), n) : u;
    }, n.frequency = function (e) {
      return arguments.length ? (t = !!e, n) : t;
    }, n;
  }, oa.layout.pack = function () {
    function n(n, i) {
      var a = e.call(this, n, i),
        o = a[0],
        l = u[0],
        c = u[1],
        s = null == t ? Math.sqrt : "function" == typeof t ? t : function () {
          return t;
        };
      if (o.x = o.y = 0, au(o, function (n) {
        n.r = +s(n.value);
      }), au(o, Nu), r) {
        var f = r * (t ? 1 : Math.max(2 * o.r / l, 2 * o.r / c)) / 2;
        au(o, function (n) {
          n.r += f;
        }), au(o, Nu), au(o, function (n) {
          n.r -= f;
        });
      }
      return Cu(o, l / 2, c / 2, t ? 1 : 1 / Math.max(2 * o.r / l, 2 * o.r / c)), a;
    }
    var t,
      e = oa.layout.hierarchy().sort(_u),
      r = 0,
      u = [1, 1];
    return n.size = function (t) {
      return arguments.length ? (u = t, n) : u;
    }, n.radius = function (e) {
      return arguments.length ? (t = null == e || "function" == typeof e ? e : +e, n) : t;
    }, n.padding = function (t) {
      return arguments.length ? (r = +t, n) : r;
    }, uu(n, e);
  }, oa.layout.tree = function () {
    function n(n, u) {
      var s = a.call(this, n, u),
        f = s[0],
        h = t(f);
      if (au(h, e), h.parent.m = -h.z, iu(h, r), c) iu(f, i);else {
        var g = f,
          p = f,
          v = f;
        iu(f, function (n) {
          n.x < g.x && (g = n), n.x > p.x && (p = n), n.depth > v.depth && (v = n);
        });
        var d = o(g, p) / 2 - g.x,
          m = l[0] / (p.x + o(p, g) / 2 + d),
          y = l[1] / (v.depth || 1);
        iu(f, function (n) {
          n.x = (n.x + d) * m, n.y = n.depth * y;
        });
      }
      return s;
    }
    function t(n) {
      for (var t, e = {
          A: null,
          children: [n]
        }, r = [e]; null != (t = r.pop());) for (var u, i = t.children, a = 0, o = i.length; o > a; ++a) r.push((i[a] = u = {
        _: i[a],
        parent: t,
        children: (u = i[a].children) && u.slice() || [],
        A: null,
        a: null,
        z: 0,
        m: 0,
        c: 0,
        s: 0,
        t: null,
        i: a
      }).a = u);
      return e.children[0];
    }
    function e(n) {
      var t = n.children,
        e = n.parent.children,
        r = n.i ? e[n.i - 1] : null;
      if (t.length) {
        Du(n);
        var i = (t[0].z + t[t.length - 1].z) / 2;
        r ? (n.z = r.z + o(n._, r._), n.m = n.z - i) : n.z = i;
      } else r && (n.z = r.z + o(n._, r._));
      n.parent.A = u(n, r, n.parent.A || e[0]);
    }
    function r(n) {
      n._.x = n.z + n.parent.m, n.m += n.parent.m;
    }
    function u(n, t, e) {
      if (t) {
        for (var r, u = n, i = n, a = t, l = u.parent.children[0], c = u.m, s = i.m, f = a.m, h = l.m; a = Tu(a), u = qu(u), a && u;) l = qu(l), i = Tu(i), i.a = n, r = a.z + f - u.z - c + o(a._, u._), r > 0 && (Ru(Pu(a, n, e), n, r), c += r, s += r), f += a.m, c += u.m, h += l.m, s += i.m;
        a && !Tu(i) && (i.t = a, i.m += f - s), u && !qu(l) && (l.t = u, l.m += c - h, e = n);
      }
      return e;
    }
    function i(n) {
      n.x *= l[0], n.y = n.depth * l[1];
    }
    var a = oa.layout.hierarchy().sort(null).value(null),
      o = Lu,
      l = [1, 1],
      c = null;
    return n.separation = function (t) {
      return arguments.length ? (o = t, n) : o;
    }, n.size = function (t) {
      return arguments.length ? (c = null == (l = t) ? i : null, n) : c ? null : l;
    }, n.nodeSize = function (t) {
      return arguments.length ? (c = null == (l = t) ? null : i, n) : c ? l : null;
    }, uu(n, a);
  }, oa.layout.cluster = function () {
    function n(n, i) {
      var a,
        o = t.call(this, n, i),
        l = o[0],
        c = 0;
      au(l, function (n) {
        var t = n.children;
        t && t.length ? (n.x = Uu(t), n.y = ju(t)) : (n.x = a ? c += e(n, a) : 0, n.y = 0, a = n);
      });
      var s = Fu(l),
        f = Hu(l),
        h = s.x - e(s, f) / 2,
        g = f.x + e(f, s) / 2;
      return au(l, u ? function (n) {
        n.x = (n.x - l.x) * r[0], n.y = (l.y - n.y) * r[1];
      } : function (n) {
        n.x = (n.x - h) / (g - h) * r[0], n.y = (1 - (l.y ? n.y / l.y : 1)) * r[1];
      }), o;
    }
    var t = oa.layout.hierarchy().sort(null).value(null),
      e = Lu,
      r = [1, 1],
      u = !1;
    return n.separation = function (t) {
      return arguments.length ? (e = t, n) : e;
    }, n.size = function (t) {
      return arguments.length ? (u = null == (r = t), n) : u ? null : r;
    }, n.nodeSize = function (t) {
      return arguments.length ? (u = null != (r = t), n) : u ? r : null;
    }, uu(n, t);
  }, oa.layout.treemap = function () {
    function n(n, t) {
      for (var e, r, u = -1, i = n.length; ++u < i;) r = (e = n[u]).value * (0 > t ? 0 : t), e.area = isNaN(r) || 0 >= r ? 0 : r;
    }
    function t(e) {
      var i = e.children;
      if (i && i.length) {
        var a,
          o,
          l,
          c = f(e),
          s = [],
          h = i.slice(),
          p = 1 / 0,
          v = "slice" === g ? c.dx : "dice" === g ? c.dy : "slice-dice" === g ? 1 & e.depth ? c.dy : c.dx : Math.min(c.dx, c.dy);
        for (n(h, c.dx * c.dy / e.value), s.area = 0; (l = h.length) > 0;) s.push(a = h[l - 1]), s.area += a.area, "squarify" !== g || (o = r(s, v)) <= p ? (h.pop(), p = o) : (s.area -= s.pop().area, u(s, v, c, !1), v = Math.min(c.dx, c.dy), s.length = s.area = 0, p = 1 / 0);
        s.length && (u(s, v, c, !0), s.length = s.area = 0), i.forEach(t);
      }
    }
    function e(t) {
      var r = t.children;
      if (r && r.length) {
        var i,
          a = f(t),
          o = r.slice(),
          l = [];
        for (n(o, a.dx * a.dy / t.value), l.area = 0; i = o.pop();) l.push(i), l.area += i.area, null != i.z && (u(l, i.z ? a.dx : a.dy, a, !o.length), l.length = l.area = 0);
        r.forEach(e);
      }
    }
    function r(n, t) {
      for (var e, r = n.area, u = 0, i = 1 / 0, a = -1, o = n.length; ++a < o;) (e = n[a].area) && (i > e && (i = e), e > u && (u = e));
      return r *= r, t *= t, r ? Math.max(t * u * p / r, r / (t * i * p)) : 1 / 0;
    }
    function u(n, t, e, r) {
      var u,
        i = -1,
        a = n.length,
        o = e.x,
        c = e.y,
        s = t ? l(n.area / t) : 0;
      if (t == e.dx) {
        for ((r || s > e.dy) && (s = e.dy); ++i < a;) u = n[i], u.x = o, u.y = c, u.dy = s, o += u.dx = Math.min(e.x + e.dx - o, s ? l(u.area / s) : 0);
        u.z = !0, u.dx += e.x + e.dx - o, e.y += s, e.dy -= s;
      } else {
        for ((r || s > e.dx) && (s = e.dx); ++i < a;) u = n[i], u.x = o, u.y = c, u.dx = s, c += u.dy = Math.min(e.y + e.dy - c, s ? l(u.area / s) : 0);
        u.z = !1, u.dy += e.y + e.dy - c, e.x += s, e.dx -= s;
      }
    }
    function i(r) {
      var u = a || o(r),
        i = u[0];
      return i.x = i.y = 0, i.value ? (i.dx = c[0], i.dy = c[1]) : i.dx = i.dy = 0, a && o.revalue(i), n([i], i.dx * i.dy / i.value), (a ? e : t)(i), h && (a = u), u;
    }
    var a,
      o = oa.layout.hierarchy(),
      l = Math.round,
      c = [1, 1],
      s = null,
      f = Ou,
      h = !1,
      g = "squarify",
      p = .5 * (1 + Math.sqrt(5));
    return i.size = function (n) {
      return arguments.length ? (c = n, i) : c;
    }, i.padding = function (n) {
      function t(t) {
        var e = n.call(i, t, t.depth);
        return null == e ? Ou(t) : Iu(t, "number" == typeof e ? [e, e, e, e] : e);
      }
      function e(t) {
        return Iu(t, n);
      }
      if (!arguments.length) return s;
      var r;
      return f = null == (s = n) ? Ou : "function" == (r = typeof n) ? t : "number" === r ? (n = [n, n, n, n], e) : e, i;
    }, i.round = function (n) {
      return arguments.length ? (l = n ? Math.round : Number, i) : l != Number;
    }, i.sticky = function (n) {
      return arguments.length ? (h = n, a = null, i) : h;
    }, i.ratio = function (n) {
      return arguments.length ? (p = n, i) : p;
    }, i.mode = function (n) {
      return arguments.length ? (g = n + "", i) : g;
    }, uu(i, o);
  }, oa.random = {
    normal: function (n, t) {
      var e = arguments.length;
      return 2 > e && (t = 1), 1 > e && (n = 0), function () {
        var e, r, u;
        do e = 2 * Math.random() - 1, r = 2 * Math.random() - 1, u = e * e + r * r; while (!u || u > 1);
        return n + t * e * Math.sqrt(-2 * Math.log(u) / u);
      };
    },
    logNormal: function () {
      var n = oa.random.normal.apply(oa, arguments);
      return function () {
        return Math.exp(n());
      };
    },
    bates: function (n) {
      var t = oa.random.irwinHall(n);
      return function () {
        return t() / n;
      };
    },
    irwinHall: function (n) {
      return function () {
        for (var t = 0, e = 0; n > e; e++) t += Math.random();
        return t;
      };
    }
  }, oa.scale = {};
  var wl = {
    floor: y,
    ceil: y
  };
  oa.scale.linear = function () {
    return Wu([0, 1], [0, 1], Mr, !1);
  };
  var Sl = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  oa.scale.log = function () {
    return ri(oa.scale.linear().domain([0, 1]), 10, !0, [1, 10]);
  };
  var kl = oa.format(".0e"),
    Nl = {
      floor: function (n) {
        return -Math.ceil(-n);
      },
      ceil: function (n) {
        return -Math.floor(-n);
      }
    };
  oa.scale.pow = function () {
    return ui(oa.scale.linear(), 1, [0, 1]);
  }, oa.scale.sqrt = function () {
    return oa.scale.pow().exponent(.5);
  }, oa.scale.ordinal = function () {
    return ai([], {
      t: "range",
      a: [[]]
    });
  }, oa.scale.category10 = function () {
    return oa.scale.ordinal().range(El);
  }, oa.scale.category20 = function () {
    return oa.scale.ordinal().range(Al);
  }, oa.scale.category20b = function () {
    return oa.scale.ordinal().range(Cl);
  }, oa.scale.category20c = function () {
    return oa.scale.ordinal().range(zl);
  };
  var El = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(xn),
    Al = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(xn),
    Cl = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(xn),
    zl = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(xn);
  oa.scale.quantile = function () {
    return oi([], []);
  }, oa.scale.quantize = function () {
    return li(0, 1, [0, 1]);
  }, oa.scale.threshold = function () {
    return ci([.5], [0, 1]);
  }, oa.scale.identity = function () {
    return si([0, 1]);
  }, oa.svg = {}, oa.svg.arc = function () {
    function n() {
      var n = Math.max(0, +e.apply(this, arguments)),
        c = Math.max(0, +r.apply(this, arguments)),
        s = a.apply(this, arguments) - Ha,
        f = o.apply(this, arguments) - Ha,
        h = Math.abs(f - s),
        g = s > f ? 0 : 1;
      if (n > c && (p = c, c = n, n = p), h >= Fa) return t(c, g) + (n ? t(n, 1 - g) : "") + "Z";
      var p,
        v,
        d,
        m,
        y,
        M,
        x,
        b,
        _,
        w,
        S,
        k,
        N = 0,
        E = 0,
        A = [];
      if ((m = (+l.apply(this, arguments) || 0) / 2) && (d = i === Ll ? Math.sqrt(n * n + c * c) : +i.apply(this, arguments), g || (E *= -1), c && (E = tn(d / c * Math.sin(m))), n && (N = tn(d / n * Math.sin(m)))), c) {
        y = c * Math.cos(s + E), M = c * Math.sin(s + E), x = c * Math.cos(f - E), b = c * Math.sin(f - E);
        var C = Math.abs(f - s - 2 * E) <= ja ? 0 : 1;
        if (E && mi(y, M, x, b) === g ^ C) {
          var z = (s + f) / 2;
          y = c * Math.cos(z), M = c * Math.sin(z), x = b = null;
        }
      } else y = M = 0;
      if (n) {
        _ = n * Math.cos(f - N), w = n * Math.sin(f - N), S = n * Math.cos(s + N), k = n * Math.sin(s + N);
        var L = Math.abs(s - f + 2 * N) <= ja ? 0 : 1;
        if (N && mi(_, w, S, k) === 1 - g ^ L) {
          var q = (s + f) / 2;
          _ = n * Math.cos(q), w = n * Math.sin(q), S = k = null;
        }
      } else _ = w = 0;
      if (h > Da && (p = Math.min(Math.abs(c - n) / 2, +u.apply(this, arguments))) > .001) {
        v = c > n ^ g ? 0 : 1;
        var T = p,
          R = p;
        if (ja > h) {
          var D = null == S ? [_, w] : null == x ? [y, M] : Re([y, M], [S, k], [x, b], [_, w]),
            P = y - D[0],
            j = M - D[1],
            U = x - D[0],
            F = b - D[1],
            H = 1 / Math.sin(Math.acos((P * U + j * F) / (Math.sqrt(P * P + j * j) * Math.sqrt(U * U + F * F))) / 2),
            O = Math.sqrt(D[0] * D[0] + D[1] * D[1]);
          R = Math.min(p, (n - O) / (H - 1)), T = Math.min(p, (c - O) / (H + 1));
        }
        if (null != x) {
          var I = yi(null == S ? [_, w] : [S, k], [y, M], c, T, g),
            Y = yi([x, b], [_, w], c, T, g);
          p === T ? A.push("M", I[0], "A", T, ",", T, " 0 0,", v, " ", I[1], "A", c, ",", c, " 0 ", 1 - g ^ mi(I[1][0], I[1][1], Y[1][0], Y[1][1]), ",", g, " ", Y[1], "A", T, ",", T, " 0 0,", v, " ", Y[0]) : A.push("M", I[0], "A", T, ",", T, " 0 1,", v, " ", Y[0]);
        } else A.push("M", y, ",", M);
        if (null != S) {
          var Z = yi([y, M], [S, k], n, -R, g),
            V = yi([_, w], null == x ? [y, M] : [x, b], n, -R, g);
          p === R ? A.push("L", V[0], "A", R, ",", R, " 0 0,", v, " ", V[1], "A", n, ",", n, " 0 ", g ^ mi(V[1][0], V[1][1], Z[1][0], Z[1][1]), ",", 1 - g, " ", Z[1], "A", R, ",", R, " 0 0,", v, " ", Z[0]) : A.push("L", V[0], "A", R, ",", R, " 0 0,", v, " ", Z[0]);
        } else A.push("L", _, ",", w);
      } else A.push("M", y, ",", M), null != x && A.push("A", c, ",", c, " 0 ", C, ",", g, " ", x, ",", b), A.push("L", _, ",", w), null != S && A.push("A", n, ",", n, " 0 ", L, ",", 1 - g, " ", S, ",", k);
      return A.push("Z"), A.join("");
    }
    function t(n, t) {
      return "M0," + n + "A" + n + "," + n + " 0 1," + t + " 0," + -n + "A" + n + "," + n + " 0 1," + t + " 0," + n;
    }
    var e = hi,
      r = gi,
      u = fi,
      i = Ll,
      a = pi,
      o = vi,
      l = di;
    return n.innerRadius = function (t) {
      return arguments.length ? (e = En(t), n) : e;
    }, n.outerRadius = function (t) {
      return arguments.length ? (r = En(t), n) : r;
    }, n.cornerRadius = function (t) {
      return arguments.length ? (u = En(t), n) : u;
    }, n.padRadius = function (t) {
      return arguments.length ? (i = t == Ll ? Ll : En(t), n) : i;
    }, n.startAngle = function (t) {
      return arguments.length ? (a = En(t), n) : a;
    }, n.endAngle = function (t) {
      return arguments.length ? (o = En(t), n) : o;
    }, n.padAngle = function (t) {
      return arguments.length ? (l = En(t), n) : l;
    }, n.centroid = function () {
      var n = (+e.apply(this, arguments) + +r.apply(this, arguments)) / 2,
        t = (+a.apply(this, arguments) + +o.apply(this, arguments)) / 2 - Ha;
      return [Math.cos(t) * n, Math.sin(t) * n];
    }, n;
  };
  var Ll = "auto";
  oa.svg.line = function () {
    return Mi(y);
  };
  var ql = oa.map({
    linear: xi,
    "linear-closed": bi,
    step: _i,
    "step-before": wi,
    "step-after": Si,
    basis: zi,
    "basis-open": Li,
    "basis-closed": qi,
    bundle: Ti,
    cardinal: Ei,
    "cardinal-open": ki,
    "cardinal-closed": Ni,
    monotone: Fi
  });
  ql.forEach(function (n, t) {
    t.key = n, t.closed = /-closed$/.test(n);
  });
  var Tl = [0, 2 / 3, 1 / 3, 0],
    Rl = [0, 1 / 3, 2 / 3, 0],
    Dl = [0, 1 / 6, 2 / 3, 1 / 6];
  oa.svg.line.radial = function () {
    var n = Mi(Hi);
    return n.radius = n.x, delete n.x, n.angle = n.y, delete n.y, n;
  }, wi.reverse = Si, Si.reverse = wi, oa.svg.area = function () {
    return Oi(y);
  }, oa.svg.area.radial = function () {
    var n = Oi(Hi);
    return n.radius = n.x, delete n.x, n.innerRadius = n.x0, delete n.x0, n.outerRadius = n.x1, delete n.x1, n.angle = n.y, delete n.y, n.startAngle = n.y0, delete n.y0, n.endAngle = n.y1, delete n.y1, n;
  }, oa.svg.chord = function () {
    function n(n, o) {
      var l = t(this, i, n, o),
        c = t(this, a, n, o);
      return "M" + l.p0 + r(l.r, l.p1, l.a1 - l.a0) + (e(l, c) ? u(l.r, l.p1, l.r, l.p0) : u(l.r, l.p1, c.r, c.p0) + r(c.r, c.p1, c.a1 - c.a0) + u(c.r, c.p1, l.r, l.p0)) + "Z";
    }
    function t(n, t, e, r) {
      var u = t.call(n, e, r),
        i = o.call(n, u, r),
        a = l.call(n, u, r) - Ha,
        s = c.call(n, u, r) - Ha;
      return {
        r: i,
        a0: a,
        a1: s,
        p0: [i * Math.cos(a), i * Math.sin(a)],
        p1: [i * Math.cos(s), i * Math.sin(s)]
      };
    }
    function e(n, t) {
      return n.a0 == t.a0 && n.a1 == t.a1;
    }
    function r(n, t, e) {
      return "A" + n + "," + n + " 0 " + +(e > ja) + ",1 " + t;
    }
    function u(n, t, e, r) {
      return "Q 0,0 " + r;
    }
    var i = Me,
      a = xe,
      o = Ii,
      l = pi,
      c = vi;
    return n.radius = function (t) {
      return arguments.length ? (o = En(t), n) : o;
    }, n.source = function (t) {
      return arguments.length ? (i = En(t), n) : i;
    }, n.target = function (t) {
      return arguments.length ? (a = En(t), n) : a;
    }, n.startAngle = function (t) {
      return arguments.length ? (l = En(t), n) : l;
    }, n.endAngle = function (t) {
      return arguments.length ? (c = En(t), n) : c;
    }, n;
  }, oa.svg.diagonal = function () {
    function n(n, u) {
      var i = t.call(this, n, u),
        a = e.call(this, n, u),
        o = (i.y + a.y) / 2,
        l = [i, {
          x: i.x,
          y: o
        }, {
          x: a.x,
          y: o
        }, a];
      return l = l.map(r), "M" + l[0] + "C" + l[1] + " " + l[2] + " " + l[3];
    }
    var t = Me,
      e = xe,
      r = Yi;
    return n.source = function (e) {
      return arguments.length ? (t = En(e), n) : t;
    }, n.target = function (t) {
      return arguments.length ? (e = En(t), n) : e;
    }, n.projection = function (t) {
      return arguments.length ? (r = t, n) : r;
    }, n;
  }, oa.svg.diagonal.radial = function () {
    var n = oa.svg.diagonal(),
      t = Yi,
      e = n.projection;
    return n.projection = function (n) {
      return arguments.length ? e(Zi(t = n)) : t;
    }, n;
  }, oa.svg.symbol = function () {
    function n(n, r) {
      return (Pl.get(t.call(this, n, r)) || $i)(e.call(this, n, r));
    }
    var t = Xi,
      e = Vi;
    return n.type = function (e) {
      return arguments.length ? (t = En(e), n) : t;
    }, n.size = function (t) {
      return arguments.length ? (e = En(t), n) : e;
    }, n;
  };
  var Pl = oa.map({
    circle: $i,
    cross: function (n) {
      var t = Math.sqrt(n / 5) / 2;
      return "M" + -3 * t + "," + -t + "H" + -t + "V" + -3 * t + "H" + t + "V" + -t + "H" + 3 * t + "V" + t + "H" + t + "V" + 3 * t + "H" + -t + "V" + t + "H" + -3 * t + "Z";
    },
    diamond: function (n) {
      var t = Math.sqrt(n / (2 * Ul)),
        e = t * Ul;
      return "M0," + -t + "L" + e + ",0 0," + t + " " + -e + ",0Z";
    },
    square: function (n) {
      var t = Math.sqrt(n) / 2;
      return "M" + -t + "," + -t + "L" + t + "," + -t + " " + t + "," + t + " " + -t + "," + t + "Z";
    },
    "triangle-down": function (n) {
      var t = Math.sqrt(n / jl),
        e = t * jl / 2;
      return "M0," + e + "L" + t + "," + -e + " " + -t + "," + -e + "Z";
    },
    "triangle-up": function (n) {
      var t = Math.sqrt(n / jl),
        e = t * jl / 2;
      return "M0," + -e + "L" + t + "," + e + " " + -t + "," + e + "Z";
    }
  });
  oa.svg.symbolTypes = Pl.keys();
  var jl = Math.sqrt(3),
    Ul = Math.tan(30 * Oa);
  Aa.transition = function (n) {
    for (var t, e, r = Fl || ++Yl, u = Ki(n), i = [], a = Hl || {
        time: Date.now(),
        ease: Nr,
        delay: 0,
        duration: 250
      }, o = -1, l = this.length; ++o < l;) {
      i.push(t = []);
      for (var c = this[o], s = -1, f = c.length; ++s < f;) (e = c[s]) && Qi(e, s, u, r, a), t.push(e);
    }
    return Wi(i, u, r);
  }, Aa.interrupt = function (n) {
    return this.each(null == n ? Ol : Bi(Ki(n)));
  };
  var Fl,
    Hl,
    Ol = Bi(Ki()),
    Il = [],
    Yl = 0;
  Il.call = Aa.call, Il.empty = Aa.empty, Il.node = Aa.node, Il.size = Aa.size, oa.transition = function (n, t) {
    return n && n.transition ? Fl ? n.transition(t) : n : oa.selection().transition(n);
  }, oa.transition.prototype = Il, Il.select = function (n) {
    var t,
      e,
      r,
      u = this.id,
      i = this.namespace,
      a = [];
    n = A(n);
    for (var o = -1, l = this.length; ++o < l;) {
      a.push(t = []);
      for (var c = this[o], s = -1, f = c.length; ++s < f;) (r = c[s]) && (e = n.call(r, r.__data__, s, o)) ? ("__data__" in r && (e.__data__ = r.__data__), Qi(e, s, i, u, r[i][u]), t.push(e)) : t.push(null);
    }
    return Wi(a, i, u);
  }, Il.selectAll = function (n) {
    var t,
      e,
      r,
      u,
      i,
      a = this.id,
      o = this.namespace,
      l = [];
    n = C(n);
    for (var c = -1, s = this.length; ++c < s;) for (var f = this[c], h = -1, g = f.length; ++h < g;) if (r = f[h]) {
      i = r[o][a], e = n.call(r, r.__data__, h, c), l.push(t = []);
      for (var p = -1, v = e.length; ++p < v;) (u = e[p]) && Qi(u, p, o, a, i), t.push(u);
    }
    return Wi(l, o, a);
  }, Il.filter = function (n) {
    var t,
      e,
      r,
      u = [];
    "function" != typeof n && (n = O(n));
    for (var i = 0, a = this.length; a > i; i++) {
      u.push(t = []);
      for (var e = this[i], o = 0, l = e.length; l > o; o++) (r = e[o]) && n.call(r, r.__data__, o, i) && t.push(r);
    }
    return Wi(u, this.namespace, this.id);
  }, Il.tween = function (n, t) {
    var e = this.id,
      r = this.namespace;
    return arguments.length < 2 ? this.node()[r][e].tween.get(n) : Y(this, null == t ? function (t) {
      t[r][e].tween.remove(n);
    } : function (u) {
      u[r][e].tween.set(n, t);
    });
  }, Il.attr = function (n, t) {
    function e() {
      this.removeAttribute(o);
    }
    function r() {
      this.removeAttributeNS(o.space, o.local);
    }
    function u(n) {
      return null == n ? e : (n += "", function () {
        var t,
          e = this.getAttribute(o);
        return e !== n && (t = a(e, n), function (n) {
          this.setAttribute(o, t(n));
        });
      });
    }
    function i(n) {
      return null == n ? r : (n += "", function () {
        var t,
          e = this.getAttributeNS(o.space, o.local);
        return e !== n && (t = a(e, n), function (n) {
          this.setAttributeNS(o.space, o.local, t(n));
        });
      });
    }
    if (arguments.length < 2) {
      for (t in n) this.attr(t, n[t]);
      return this;
    }
    var a = "transform" == n ? $r : Mr,
      o = oa.ns.qualify(n);
    return Ji(this, "attr." + n, t, o.local ? i : u);
  }, Il.attrTween = function (n, t) {
    function e(n, e) {
      var r = t.call(this, n, e, this.getAttribute(u));
      return r && function (n) {
        this.setAttribute(u, r(n));
      };
    }
    function r(n, e) {
      var r = t.call(this, n, e, this.getAttributeNS(u.space, u.local));
      return r && function (n) {
        this.setAttributeNS(u.space, u.local, r(n));
      };
    }
    var u = oa.ns.qualify(n);
    return this.tween("attr." + n, u.local ? r : e);
  }, Il.style = function (n, e, r) {
    function u() {
      this.style.removeProperty(n);
    }
    function i(e) {
      return null == e ? u : (e += "", function () {
        var u,
          i = t(this).getComputedStyle(this, null).getPropertyValue(n);
        return i !== e && (u = Mr(i, e), function (t) {
          this.style.setProperty(n, u(t), r);
        });
      });
    }
    var a = arguments.length;
    if (3 > a) {
      if ("string" != typeof n) {
        2 > a && (e = "");
        for (r in n) this.style(r, n[r], e);
        return this;
      }
      r = "";
    }
    return Ji(this, "style." + n, e, i);
  }, Il.styleTween = function (n, e, r) {
    function u(u, i) {
      var a = e.call(this, u, i, t(this).getComputedStyle(this, null).getPropertyValue(n));
      return a && function (t) {
        this.style.setProperty(n, a(t), r);
      };
    }
    return arguments.length < 3 && (r = ""), this.tween("style." + n, u);
  }, Il.text = function (n) {
    return Ji(this, "text", n, Gi);
  }, Il.remove = function () {
    var n = this.namespace;
    return this.each("end.transition", function () {
      var t;
      this[n].count < 2 && (t = this.parentNode) && t.removeChild(this);
    });
  }, Il.ease = function (n) {
    var t = this.id,
      e = this.namespace;
    return arguments.length < 1 ? this.node()[e][t].ease : ("function" != typeof n && (n = oa.ease.apply(oa, arguments)), Y(this, function (r) {
      r[e][t].ease = n;
    }));
  }, Il.delay = function (n) {
    var t = this.id,
      e = this.namespace;
    return arguments.length < 1 ? this.node()[e][t].delay : Y(this, "function" == typeof n ? function (r, u, i) {
      r[e][t].delay = +n.call(r, r.__data__, u, i);
    } : (n = +n, function (r) {
      r[e][t].delay = n;
    }));
  }, Il.duration = function (n) {
    var t = this.id,
      e = this.namespace;
    return arguments.length < 1 ? this.node()[e][t].duration : Y(this, "function" == typeof n ? function (r, u, i) {
      r[e][t].duration = Math.max(1, n.call(r, r.__data__, u, i));
    } : (n = Math.max(1, n), function (r) {
      r[e][t].duration = n;
    }));
  }, Il.each = function (n, t) {
    var e = this.id,
      r = this.namespace;
    if (arguments.length < 2) {
      var u = Hl,
        i = Fl;
      try {
        Fl = e, Y(this, function (t, u, i) {
          Hl = t[r][e], n.call(t, t.__data__, u, i);
        });
      } finally {
        Hl = u, Fl = i;
      }
    } else Y(this, function (u) {
      var i = u[r][e];
      (i.event || (i.event = oa.dispatch("start", "end", "interrupt"))).on(n, t);
    });
    return this;
  }, Il.transition = function () {
    for (var n, t, e, r, u = this.id, i = ++Yl, a = this.namespace, o = [], l = 0, c = this.length; c > l; l++) {
      o.push(n = []);
      for (var t = this[l], s = 0, f = t.length; f > s; s++) (e = t[s]) && (r = e[a][u], Qi(e, s, a, i, {
        time: r.time,
        ease: r.ease,
        delay: r.delay + r.duration,
        duration: r.duration
      })), n.push(e);
    }
    return Wi(o, a, i);
  }, oa.svg.axis = function () {
    function n(n) {
      n.each(function () {
        var n,
          c = oa.select(this),
          s = this.__chart__ || e,
          f = this.__chart__ = e.copy(),
          h = null == l ? f.ticks ? f.ticks.apply(f, o) : f.domain() : l,
          g = null == t ? f.tickFormat ? f.tickFormat.apply(f, o) : y : t,
          p = c.selectAll(".tick").data(h, f),
          v = p.enter().insert("g", ".domain").attr("class", "tick").style("opacity", Da),
          d = oa.transition(p.exit()).style("opacity", Da).remove(),
          m = oa.transition(p.order()).style("opacity", 1),
          M = Math.max(u, 0) + a,
          x = Zu(f),
          b = c.selectAll(".domain").data([0]),
          _ = (b.enter().append("path").attr("class", "domain"), oa.transition(b));
        v.append("line"), v.append("text");
        var w,
          S,
          k,
          N,
          E = v.select("line"),
          A = m.select("line"),
          C = p.select("text").text(g),
          z = v.select("text"),
          L = m.select("text"),
          q = "top" === r || "left" === r ? -1 : 1;
        if ("bottom" === r || "top" === r ? (n = na, w = "x", k = "y", S = "x2", N = "y2", C.attr("dy", 0 > q ? "0em" : ".71em").style("text-anchor", "middle"), _.attr("d", "M" + x[0] + "," + q * i + "V0H" + x[1] + "V" + q * i)) : (n = ta, w = "y", k = "x", S = "y2", N = "x2", C.attr("dy", ".32em").style("text-anchor", 0 > q ? "end" : "start"), _.attr("d", "M" + q * i + "," + x[0] + "H0V" + x[1] + "H" + q * i)), E.attr(N, q * u), z.attr(k, q * M), A.attr(S, 0).attr(N, q * u), L.attr(w, 0).attr(k, q * M), f.rangeBand) {
          var T = f,
            R = T.rangeBand() / 2;
          s = f = function (n) {
            return T(n) + R;
          };
        } else s.rangeBand ? s = f : d.call(n, f, s);
        v.call(n, s, f), m.call(n, f, f);
      });
    }
    var t,
      e = oa.scale.linear(),
      r = Zl,
      u = 6,
      i = 6,
      a = 3,
      o = [10],
      l = null;
    return n.scale = function (t) {
      return arguments.length ? (e = t, n) : e;
    }, n.orient = function (t) {
      return arguments.length ? (r = t in Vl ? t + "" : Zl, n) : r;
    }, n.ticks = function () {
      return arguments.length ? (o = ca(arguments), n) : o;
    }, n.tickValues = function (t) {
      return arguments.length ? (l = t, n) : l;
    }, n.tickFormat = function (e) {
      return arguments.length ? (t = e, n) : t;
    }, n.tickSize = function (t) {
      var e = arguments.length;
      return e ? (u = +t, i = +arguments[e - 1], n) : u;
    }, n.innerTickSize = function (t) {
      return arguments.length ? (u = +t, n) : u;
    }, n.outerTickSize = function (t) {
      return arguments.length ? (i = +t, n) : i;
    }, n.tickPadding = function (t) {
      return arguments.length ? (a = +t, n) : a;
    }, n.tickSubdivide = function () {
      return arguments.length && n;
    }, n;
  };
  var Zl = "bottom",
    Vl = {
      top: 1,
      right: 1,
      bottom: 1,
      left: 1
    };
  oa.svg.brush = function () {
    function n(t) {
      t.each(function () {
        var t = oa.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", i).on("touchstart.brush", i),
          a = t.selectAll(".background").data([0]);
        a.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), t.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var o = t.selectAll(".resize").data(v, y);
        o.exit().remove(), o.enter().append("g").attr("class", function (n) {
          return "resize " + n;
        }).style("cursor", function (n) {
          return Xl[n];
        }).append("rect").attr("x", function (n) {
          return /[ew]$/.test(n) ? -3 : null;
        }).attr("y", function (n) {
          return /^[ns]/.test(n) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), o.style("display", n.empty() ? "none" : null);
        var l,
          f = oa.transition(t),
          h = oa.transition(a);
        c && (l = Zu(c), h.attr("x", l[0]).attr("width", l[1] - l[0]), r(f)), s && (l = Zu(s), h.attr("y", l[0]).attr("height", l[1] - l[0]), u(f)), e(f);
      });
    }
    function e(n) {
      n.selectAll(".resize").attr("transform", function (n) {
        return "translate(" + f[+/e$/.test(n)] + "," + h[+/^s/.test(n)] + ")";
      });
    }
    function r(n) {
      n.select(".extent").attr("x", f[0]), n.selectAll(".extent,.n>rect,.s>rect").attr("width", f[1] - f[0]);
    }
    function u(n) {
      n.select(".extent").attr("y", h[0]), n.selectAll(".extent,.e>rect,.w>rect").attr("height", h[1] - h[0]);
    }
    function i() {
      function i() {
        32 == oa.event.keyCode && (C || (M = null, L[0] -= f[1], L[1] -= h[1], C = 2), S());
      }
      function v() {
        32 == oa.event.keyCode && 2 == C && (L[0] += f[1], L[1] += h[1], C = 0, S());
      }
      function d() {
        var n = oa.mouse(b),
          t = !1;
        x && (n[0] += x[0], n[1] += x[1]), C || (oa.event.altKey ? (M || (M = [(f[0] + f[1]) / 2, (h[0] + h[1]) / 2]), L[0] = f[+(n[0] < M[0])], L[1] = h[+(n[1] < M[1])]) : M = null), E && m(n, c, 0) && (r(k), t = !0), A && m(n, s, 1) && (u(k), t = !0), t && (e(k), w({
          type: "brush",
          mode: C ? "move" : "resize"
        }));
      }
      function m(n, t, e) {
        var r,
          u,
          i = Zu(t),
          l = i[0],
          c = i[1],
          s = L[e],
          v = e ? h : f,
          d = v[1] - v[0];
        return C && (l -= s, c -= d + s), r = (e ? p : g) ? Math.max(l, Math.min(c, n[e])) : n[e], C ? u = (r += s) + d : (M && (s = Math.max(l, Math.min(c, 2 * M[e] - r))), r > s ? (u = r, r = s) : u = s), v[0] != r || v[1] != u ? (e ? o = null : a = null, v[0] = r, v[1] = u, !0) : void 0;
      }
      function y() {
        d(), k.style("pointer-events", "all").selectAll(".resize").style("display", n.empty() ? "none" : null), oa.select("body").style("cursor", null), q.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), z(), w({
          type: "brushend"
        });
      }
      var M,
        x,
        b = this,
        _ = oa.select(oa.event.target),
        w = l.of(b, arguments),
        k = oa.select(b),
        N = _.datum(),
        E = !/^(n|s)$/.test(N) && c,
        A = !/^(e|w)$/.test(N) && s,
        C = _.classed("extent"),
        z = W(b),
        L = oa.mouse(b),
        q = oa.select(t(b)).on("keydown.brush", i).on("keyup.brush", v);
      if (oa.event.changedTouches ? q.on("touchmove.brush", d).on("touchend.brush", y) : q.on("mousemove.brush", d).on("mouseup.brush", y), k.interrupt().selectAll("*").interrupt(), C) L[0] = f[0] - L[0], L[1] = h[0] - L[1];else if (N) {
        var T = +/w$/.test(N),
          R = +/^n/.test(N);
        x = [f[1 - T] - L[0], h[1 - R] - L[1]], L[0] = f[T], L[1] = h[R];
      } else oa.event.altKey && (M = L.slice());
      k.style("pointer-events", "none").selectAll(".resize").style("display", null), oa.select("body").style("cursor", _.style("cursor")), w({
        type: "brushstart"
      }), d();
    }
    var a,
      o,
      l = N(n, "brushstart", "brush", "brushend"),
      c = null,
      s = null,
      f = [0, 0],
      h = [0, 0],
      g = !0,
      p = !0,
      v = $l[0];
    return n.event = function (n) {
      n.each(function () {
        var n = l.of(this, arguments),
          t = {
            x: f,
            y: h,
            i: a,
            j: o
          },
          e = this.__chart__ || t;
        this.__chart__ = t, Fl ? oa.select(this).transition().each("start.brush", function () {
          a = e.i, o = e.j, f = e.x, h = e.y, n({
            type: "brushstart"
          });
        }).tween("brush:brush", function () {
          var e = xr(f, t.x),
            r = xr(h, t.y);
          return a = o = null, function (u) {
            f = t.x = e(u), h = t.y = r(u), n({
              type: "brush",
              mode: "resize"
            });
          };
        }).each("end.brush", function () {
          a = t.i, o = t.j, n({
            type: "brush",
            mode: "resize"
          }), n({
            type: "brushend"
          });
        }) : (n({
          type: "brushstart"
        }), n({
          type: "brush",
          mode: "resize"
        }), n({
          type: "brushend"
        }));
      });
    }, n.x = function (t) {
      return arguments.length ? (c = t, v = $l[!c << 1 | !s], n) : c;
    }, n.y = function (t) {
      return arguments.length ? (s = t, v = $l[!c << 1 | !s], n) : s;
    }, n.clamp = function (t) {
      return arguments.length ? (c && s ? (g = !!t[0], p = !!t[1]) : c ? g = !!t : s && (p = !!t), n) : c && s ? [g, p] : c ? g : s ? p : null;
    }, n.extent = function (t) {
      var e, r, u, i, l;
      return arguments.length ? (c && (e = t[0], r = t[1], s && (e = e[0], r = r[0]), a = [e, r], c.invert && (e = c(e), r = c(r)), e > r && (l = e, e = r, r = l), (e != f[0] || r != f[1]) && (f = [e, r])), s && (u = t[0], i = t[1], c && (u = u[1], i = i[1]), o = [u, i], s.invert && (u = s(u), i = s(i)), u > i && (l = u, u = i, i = l), (u != h[0] || i != h[1]) && (h = [u, i])), n) : (c && (a ? (e = a[0], r = a[1]) : (e = f[0], r = f[1], c.invert && (e = c.invert(e), r = c.invert(r)), e > r && (l = e, e = r, r = l))), s && (o ? (u = o[0], i = o[1]) : (u = h[0], i = h[1], s.invert && (u = s.invert(u), i = s.invert(i)), u > i && (l = u, u = i, i = l))), c && s ? [[e, u], [r, i]] : c ? [e, r] : s && [u, i]);
    }, n.clear = function () {
      return n.empty() || (f = [0, 0], h = [0, 0], a = o = null), n;
    }, n.empty = function () {
      return !!c && f[0] == f[1] || !!s && h[0] == h[1];
    }, oa.rebind(n, l, "on");
  };
  var Xl = {
      n: "ns-resize",
      e: "ew-resize",
      s: "ns-resize",
      w: "ew-resize",
      nw: "nwse-resize",
      ne: "nesw-resize",
      se: "nwse-resize",
      sw: "nesw-resize"
    },
    $l = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []],
    Bl = ho.format = Mo.timeFormat,
    Wl = Bl.utc,
    Jl = Wl("%Y-%m-%dT%H:%M:%S.%LZ");
  Bl.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? ea : Jl, ea.parse = function (n) {
    var t = new Date(n);
    return isNaN(t) ? null : t;
  }, ea.toString = Jl.toString, ho.second = On(function (n) {
    return new go(1e3 * Math.floor(n / 1e3));
  }, function (n, t) {
    n.setTime(n.getTime() + 1e3 * Math.floor(t));
  }, function (n) {
    return n.getSeconds();
  }), ho.seconds = ho.second.range, ho.seconds.utc = ho.second.utc.range, ho.minute = On(function (n) {
    return new go(6e4 * Math.floor(n / 6e4));
  }, function (n, t) {
    n.setTime(n.getTime() + 6e4 * Math.floor(t));
  }, function (n) {
    return n.getMinutes();
  }), ho.minutes = ho.minute.range, ho.minutes.utc = ho.minute.utc.range, ho.hour = On(function (n) {
    var t = n.getTimezoneOffset() / 60;
    return new go(36e5 * (Math.floor(n / 36e5 - t) + t));
  }, function (n, t) {
    n.setTime(n.getTime() + 36e5 * Math.floor(t));
  }, function (n) {
    return n.getHours();
  }), ho.hours = ho.hour.range, ho.hours.utc = ho.hour.utc.range, ho.month = On(function (n) {
    return n = ho.day(n), n.setDate(1), n;
  }, function (n, t) {
    n.setMonth(n.getMonth() + t);
  }, function (n) {
    return n.getMonth();
  }), ho.months = ho.month.range, ho.months.utc = ho.month.utc.range;
  var Gl = [1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6],
    Kl = [[ho.second, 1], [ho.second, 5], [ho.second, 15], [ho.second, 30], [ho.minute, 1], [ho.minute, 5], [ho.minute, 15], [ho.minute, 30], [ho.hour, 1], [ho.hour, 3], [ho.hour, 6], [ho.hour, 12], [ho.day, 1], [ho.day, 2], [ho.week, 1], [ho.month, 1], [ho.month, 3], [ho.year, 1]],
    Ql = Bl.multi([[".%L", function (n) {
      return n.getMilliseconds();
    }], [":%S", function (n) {
      return n.getSeconds();
    }], ["%I:%M", function (n) {
      return n.getMinutes();
    }], ["%I %p", function (n) {
      return n.getHours();
    }], ["%a %d", function (n) {
      return n.getDay() && 1 != n.getDate();
    }], ["%b %d", function (n) {
      return 1 != n.getDate();
    }], ["%B", function (n) {
      return n.getMonth();
    }], ["%Y", zt]]),
    nc = {
      range: function (n, t, e) {
        return oa.range(Math.ceil(n / e) * e, +t, e).map(ua);
      },
      floor: y,
      ceil: y
    };
  Kl.year = ho.year, ho.scale = function () {
    return ra(oa.scale.linear(), Kl, Ql);
  };
  var tc = Kl.map(function (n) {
      return [n[0].utc, n[1]];
    }),
    ec = Wl.multi([[".%L", function (n) {
      return n.getUTCMilliseconds();
    }], [":%S", function (n) {
      return n.getUTCSeconds();
    }], ["%I:%M", function (n) {
      return n.getUTCMinutes();
    }], ["%I %p", function (n) {
      return n.getUTCHours();
    }], ["%a %d", function (n) {
      return n.getUTCDay() && 1 != n.getUTCDate();
    }], ["%b %d", function (n) {
      return 1 != n.getUTCDate();
    }], ["%B", function (n) {
      return n.getUTCMonth();
    }], ["%Y", zt]]);
  tc.year = ho.year.utc, ho.scale.utc = function () {
    return ra(oa.scale.linear(), tc, ec);
  }, oa.text = An(function (n) {
    return n.responseText;
  }), oa.json = function (n, t) {
    return Cn(n, "application/json", ia, t);
  }, oa.html = function (n, t) {
    return Cn(n, "text/html", aa, t);
  }, oa.xml = An(function (n) {
    return n.responseXML;
  }), "function" == typeof define && define.amd ? define('d3v3', oa) : "object" == typeof module && module.exports ? module.exports = oa : this.d3v3 = oa;
  window.d3v3 = oa;
}();
/*! html2canvas 1.3.2 <https://html2canvas.hertzen.com> Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com> Released under MIT License  */
!function (A, e) {
  "object" == typeof exports && "undefined" != typeof module ? A["html2canvasV1"] = e() : "function" == typeof define && define.amd ? (A = "undefined" != typeof globalThis ? globalThis : A || self).html2canvasV1 = e() : (A = "undefined" != typeof globalThis ? globalThis : A || self).html2canvasV1 = e();
}(window, function () {
  "use strict";

  var B = function (A, e) {
    return (B = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (A, e) {
      A.__proto__ = e;
    } || function (A, e) {
      for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && (A[t] = e[t]);
    })(A, e);
  };
  function A(A, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function t() {
      this.constructor = A;
    }
    B(A, e), A.prototype = null === e ? Object.create(e) : (t.prototype = e.prototype, new t());
  }
  var h = function () {
    return (h = Object.assign || function (A) {
      for (var e, t = 1, B = arguments.length; t < B; t++) for (var r in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, r) && (A[r] = e[r]);
      return A;
    }).apply(this, arguments);
  };
  function a(A, s, o, i) {
    return new (o = o || Promise)(function (t, e) {
      function B(A) {
        try {
          n(i.next(A));
        } catch (A) {
          e(A);
        }
      }
      function r(A) {
        try {
          n(i.throw(A));
        } catch (A) {
          e(A);
        }
      }
      function n(A) {
        var e;
        A.done ? t(A.value) : ((e = A.value) instanceof o ? e : new o(function (A) {
          A(e);
        })).then(B, r);
      }
      n((i = i.apply(A, s || [])).next());
    });
  }
  function H(t, B) {
    var r,
      n,
      s,
      o = {
        label: 0,
        sent: function () {
          if (1 & s[0]) throw s[1];
          return s[1];
        },
        trys: [],
        ops: []
      },
      A = {
        next: e(0),
        throw: e(1),
        return: e(2)
      };
    return "function" == typeof Symbol && (A[Symbol.iterator] = function () {
      return this;
    }), A;
    function e(e) {
      return function (A) {
        return function (e) {
          if (r) throw new TypeError("Generator is already executing.");
          for (; o;) try {
            if (r = 1, n && (s = 2 & e[0] ? n.return : e[0] ? n.throw || ((s = n.return) && s.call(n), 0) : n.next) && !(s = s.call(n, e[1])).done) return s;
            switch (n = 0, (e = s ? [2 & e[0], s.value] : e)[0]) {
              case 0:
              case 1:
                s = e;
                break;
              case 4:
                return o.label++, {
                  value: e[1],
                  done: !1
                };
              case 5:
                o.label++, n = e[1], e = [0];
                continue;
              case 7:
                e = o.ops.pop(), o.trys.pop();
                continue;
              default:
                if (!(s = 0 < (s = o.trys).length && s[s.length - 1]) && (6 === e[0] || 2 === e[0])) {
                  o = 0;
                  continue;
                }
                if (3 === e[0] && (!s || e[1] > s[0] && e[1] < s[3])) {
                  o.label = e[1];
                  break;
                }
                if (6 === e[0] && o.label < s[1]) {
                  o.label = s[1], s = e;
                  break;
                }
                if (s && o.label < s[2]) {
                  o.label = s[2], o.ops.push(e);
                  break;
                }
                s[2] && o.ops.pop(), o.trys.pop();
                continue;
            }
            e = B.call(t, o);
          } catch (A) {
            e = [6, A], n = 0;
          } finally {
            r = s = 0;
          }
          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, A]);
      };
    }
  }
  function t(A, e, t) {
    if (t || 2 === arguments.length) for (var B, r = 0, n = e.length; r < n; r++) !B && r in e || ((B = B || Array.prototype.slice.call(e, 0, r))[r] = e[r]);
    return A.concat(B || e);
  }
  var d = (r.prototype.add = function (A, e, t, B) {
    return new r(this.left + A, this.top + e, this.width + t, this.height + B);
  }, r.fromClientRect = function (A, e) {
    return new r(e.left + A.windowBounds.left, e.top + A.windowBounds.top, e.width, e.height);
  }, r.fromDOMRectList = function (A, e) {
    e = e[0];
    return e ? new r(e.x + A.windowBounds.left, e.y + A.windowBounds.top, e.width, e.height) : r.EMPTY;
  }, r.EMPTY = new r(0, 0, 0, 0), r);
  function r(A, e, t, B) {
    this.left = A, this.top = e, this.width = t, this.height = B;
  }
  for (var E = function (A, e) {
      return d.fromClientRect(A, e.getBoundingClientRect());
    }, Q = function (A) {
      for (var e = [], t = 0, B = A.length; t < B;) {
        var r,
          n = A.charCodeAt(t++);
        55296 <= n && n <= 56319 && t < B ? 56320 == (64512 & (r = A.charCodeAt(t++))) ? e.push(((1023 & n) << 10) + (1023 & r) + 65536) : (e.push(n), t--) : e.push(n);
      }
      return e;
    }, g = function () {
      for (var A = [], e = 0; e < arguments.length; e++) A[e] = arguments[e];
      if (String.fromCodePoint) return String.fromCodePoint.apply(String, A);
      var t = A.length;
      if (!t) return "";
      for (var B = [], r = -1, n = ""; ++r < t;) {
        var s = A[r];
        s <= 65535 ? B.push(s) : (s -= 65536, B.push(55296 + (s >> 10), s % 1024 + 56320)), (r + 1 === t || 16384 < B.length) && (n += String.fromCharCode.apply(String, B), B.length = 0);
      }
      return n;
    }, e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), n = 0; n < e.length; n++) c[e.charCodeAt(n)] = n;
  function s(A, e, t) {
    return A.slice ? A.slice(e, t) : new Uint16Array(Array.prototype.slice.call(A, e, t));
  }
  var o = (i.prototype.get = function (A) {
    var e;
    if (0 <= A) {
      if (A < 55296 || 56319 < A && A <= 65535) return e = this.index[A >> 5], this.data[e = (e << 2) + (31 & A)];
      if (A <= 65535) return e = this.index[2048 + (A - 55296 >> 5)], this.data[e = (e << 2) + (31 & A)];
      if (A < this.highStart) return e = this.index[e = 2080 + (A >> 11)], e = this.index[e += A >> 5 & 63], this.data[e = (e << 2) + (31 & A)];
      if (A <= 1114111) return this.data[this.highValueIndex];
    }
    return this.errorValue;
  }, i);
  function i(A, e, t, B, r, n) {
    this.initialValue = A, this.errorValue = e, this.highStart = t, this.highValueIndex = B, this.index = r, this.data = n;
  }
  function w(A, e, t, B) {
    var r = B[t];
    if (Array.isArray(A) ? -1 !== A.indexOf(r) : A === r) for (var n = t; n <= B.length;) {
      if ((o = B[++n]) === e) return 1;
      if (o !== p) break;
    }
    if (r === p) for (n = t; 0 < n;) {
      var s = B[--n];
      if (Array.isArray(A) ? -1 !== A.indexOf(s) : A === s) for (var o, i = t; i <= B.length;) {
        if ((o = B[++i]) === e) return 1;
        if (o !== p) break;
      }
      if (s !== p) break;
    }
  }
  function C(A, e) {
    for (var t = A; 0 <= t;) {
      var B = e[t];
      if (B !== p) return B;
      t--;
    }
    return 0;
  }
  function U(t, A) {
    var e = (r = function (A, B) {
        void 0 === B && (B = "strict");
        var r = [],
          n = [],
          s = [];
        return A.forEach(function (A, e) {
          var t = j.get(A);
          if (50 < t ? (s.push(!0), t -= 50) : s.push(!1), -1 !== ["normal", "auto", "loose"].indexOf(B) && -1 !== [8208, 8211, 12316, 12448].indexOf(A)) return n.push(e), r.push(16);
          if (4 !== t && 11 !== t) return n.push(e), 31 === t ? r.push("strict" === B ? R : J) : t === W || 29 === t ? r.push(G) : 43 === t ? 131072 <= A && A <= 196605 || 196608 <= A && A <= 262141 ? r.push(J) : r.push(G) : void r.push(t);
          if (0 === e) return n.push(e), r.push(G);
          t = r[e - 1];
          return -1 === tA.indexOf(t) ? (n.push(n[e - 1]), r.push(t)) : (n.push(e), r.push(G));
        }), [n, r, s];
      }(t, (A = A || {
        lineBreak: "normal",
        wordBreak: "normal"
      }).lineBreak))[0],
      B = r[1],
      r = r[2];
    return [e, B = "break-all" === A.wordBreak || "break-word" === A.wordBreak ? B.map(function (A) {
      return -1 !== [T, G, W].indexOf(A) ? J : A;
    }) : B, "keep-all" === A.wordBreak ? r.map(function (A, e) {
      return A && 19968 <= t[e] && t[e] <= 40959;
    }) : void 0];
  }
  var l,
    F,
    u,
    f,
    I,
    p = 10,
    y = 13,
    K = 15,
    L = 17,
    m = 18,
    D = 19,
    b = 20,
    R = 21,
    O = 22,
    S = 24,
    T = 25,
    v = 26,
    M = 27,
    N = 28,
    G = 30,
    x = 32,
    V = 33,
    P = 34,
    k = 35,
    J = 37,
    X = 38,
    _ = 39,
    Y = 40,
    W = 42,
    Z = [9001, 65288],
    q = "×",
    j = (u = function (A) {
      var e,
        t,
        B,
        r,
        n = .75 * A.length,
        s = A.length,
        o = 0;
      "=" === A[A.length - 1] && (n--, "=" === A[A.length - 2] && n--);
      for (var n = new ("undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array && void 0 !== Uint8Array.prototype.slice ? ArrayBuffer : Array)(n), i = Array.isArray(n) ? n : new Uint8Array(n), Q = 0; Q < s; Q += 4) e = c[A.charCodeAt(Q)], t = c[A.charCodeAt(Q + 1)], B = c[A.charCodeAt(Q + 2)], r = c[A.charCodeAt(Q + 3)], i[o++] = e << 2 | t >> 4, i[o++] = (15 & t) << 4 | B >> 2, i[o++] = (3 & B) << 6 | 63 & r;
      return n;
    }(l = "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"), f = Array.isArray(u) ? function (A) {
      for (var e = A.length, t = [], B = 0; B < e; B += 4) t.push(A[B + 3] << 24 | A[B + 2] << 16 | A[B + 1] << 8 | A[B]);
      return t;
    }(u) : new Uint32Array(u), I = Array.isArray(u) ? function (A) {
      for (var e = A.length, t = [], B = 0; B < e; B += 2) t.push(A[B + 1] << 8 | A[B]);
      return t;
    }(u) : new Uint16Array(u), l = s(I, 12, f[4] / 2), F = 2 === f[5] ? s(I, (24 + f[4]) / 2) : (u = f, I = Math.ceil((24 + f[4]) / 4), u.slice ? u.slice(I, F) : new Uint32Array(Array.prototype.slice.call(u, I, F))), new o(f[0], f[1], f[2], f[3], l, F)),
    z = [G, 36],
    $ = [1, 2, 3, 5],
    AA = [p, 8],
    eA = [M, v],
    tA = $.concat(AA),
    BA = [X, _, Y, P, k],
    rA = [K, y],
    nA = (sA.prototype.slice = function () {
      return g.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, sA);
  function sA(A, e, t, B) {
    this.codePoints = A, this.required = "!" === e, this.start = t, this.end = B;
  }
  function oA(A, e) {
    var t = Q(A),
      B = (e = U(t, e))[0],
      r = e[1],
      n = e[2],
      s = t.length,
      o = 0,
      i = 0;
    return {
      next: function () {
        if (s <= i) return {
          done: !0,
          value: null
        };
        for (var A = q; i < s && (A = function (A, e, t, B, r) {
          if (0 === t[B]) return q;
          var n = B - 1;
          if (Array.isArray(r) && !0 === r[n]) return q;
          var s = n - 1,
            o = 1 + n,
            i = e[n],
            B = 0 <= s ? e[s] : 0,
            r = e[o];
          if (2 === i && 3 === r) return q;
          if (-1 !== $.indexOf(i)) return "!";
          if (-1 !== $.indexOf(r)) return q;
          if (-1 !== AA.indexOf(r)) return q;
          if (8 === C(n, e)) return "÷";
          if (11 === j.get(A[n])) return q;
          if ((i === x || i === V) && 11 === j.get(A[o])) return q;
          if (7 === i || 7 === r) return q;
          if (9 === i) return q;
          if (-1 === [p, y, K].indexOf(i) && 9 === r) return q;
          if (-1 !== [L, m, D, S, N].indexOf(r)) return q;
          if (C(n, e) === O) return q;
          if (w(23, O, n, e)) return q;
          if (w([L, m], R, n, e)) return q;
          if (w(12, 12, n, e)) return q;
          if (i === p) return "÷";
          if (23 === i || 23 === r) return q;
          if (16 === r || 16 === i) return "÷";
          if (-1 !== [y, K, R].indexOf(r) || 14 === i) return q;
          if (36 === B && -1 !== rA.indexOf(i)) return q;
          if (i === N && 36 === r) return q;
          if (r === b) return q;
          if (-1 !== z.indexOf(r) && i === T || -1 !== z.indexOf(i) && r === T) return q;
          if (i === M && -1 !== [J, x, V].indexOf(r) || -1 !== [J, x, V].indexOf(i) && r === v) return q;
          if (-1 !== z.indexOf(i) && -1 !== eA.indexOf(r) || -1 !== eA.indexOf(i) && -1 !== z.indexOf(r)) return q;
          if (-1 !== [M, v].indexOf(i) && (r === T || -1 !== [O, K].indexOf(r) && e[1 + o] === T) || -1 !== [O, K].indexOf(i) && r === T || i === T && -1 !== [T, N, S].indexOf(r)) return q;
          if (-1 !== [T, N, S, L, m].indexOf(r)) for (var Q = n; 0 <= Q;) {
            if ((c = e[Q]) === T) return q;
            if (-1 === [N, S].indexOf(c)) break;
            Q--;
          }
          if (-1 !== [M, v].indexOf(r)) for (var c, Q = -1 !== [L, m].indexOf(i) ? s : n; 0 <= Q;) {
            if ((c = e[Q]) === T) return q;
            if (-1 === [N, S].indexOf(c)) break;
            Q--;
          }
          if (X === i && -1 !== [X, _, P, k].indexOf(r) || -1 !== [_, P].indexOf(i) && -1 !== [_, Y].indexOf(r) || -1 !== [Y, k].indexOf(i) && r === Y) return q;
          if (-1 !== BA.indexOf(i) && -1 !== [b, v].indexOf(r) || -1 !== BA.indexOf(r) && i === M) return q;
          if (-1 !== z.indexOf(i) && -1 !== z.indexOf(r)) return q;
          if (i === S && -1 !== z.indexOf(r)) return q;
          if (-1 !== z.concat(T).indexOf(i) && r === O && -1 === Z.indexOf(A[o]) || -1 !== z.concat(T).indexOf(r) && i === m) return q;
          if (41 === i && 41 === r) {
            for (var a = t[n], g = 1; 0 < a && 41 === e[--a];) g++;
            if (g % 2 != 0) return q;
          }
          return i === x && r === V ? q : "÷";
        }(t, r, B, ++i, n)) === q;);
        if (A === q && i !== s) return {
          done: !0,
          value: null
        };
        var e = new nA(t, A, o, i);
        return o = i, {
          value: e,
          done: !1
        };
      }
    };
  }
  function iA(A) {
    return 48 <= A && A <= 57;
  }
  function QA(A) {
    return iA(A) || 65 <= A && A <= 70 || 97 <= A && A <= 102;
  }
  function cA(A) {
    return 10 === A || 9 === A || 32 === A;
  }
  function aA(A) {
    return 97 <= (t = e = A) && t <= 122 || 65 <= (e = e) && e <= 90 || 128 <= A || 95 === A;
    var e, t;
  }
  function gA(A) {
    return aA(A) || iA(A) || 45 === A;
  }
  function wA(A, e) {
    return 92 === A && 10 !== e;
  }
  function CA(A, e, t) {
    return 45 === A ? aA(e) || wA(e, t) : !!aA(A) || 92 === A && 10 !== e;
  }
  function UA(A, e, t) {
    return 43 === A || 45 === A ? !!iA(e) || 46 === e && iA(t) : iA(46 === A ? e : A);
  }
  var lA = {
      type: 2
    },
    FA = {
      type: 3
    },
    uA = {
      type: 4
    },
    hA = {
      type: 13
    },
    dA = {
      type: 8
    },
    EA = {
      type: 21
    },
    HA = {
      type: 9
    },
    fA = {
      type: 10
    },
    IA = {
      type: 11
    },
    pA = {
      type: 12
    },
    yA = {
      type: 14
    },
    KA = {
      type: 23
    },
    LA = {
      type: 1
    },
    mA = {
      type: 25
    },
    DA = {
      type: 24
    },
    bA = {
      type: 26
    },
    RA = {
      type: 27
    },
    OA = {
      type: 28
    },
    SA = {
      type: 29
    },
    TA = {
      type: 31
    },
    vA = {
      type: 32
    },
    MA = (NA.prototype.write = function (A) {
      this._value = this._value.concat(Q(A));
    }, NA.prototype.read = function () {
      for (var A = [], e = this.consumeToken(); e !== vA;) A.push(e), e = this.consumeToken();
      return A;
    }, NA.prototype.consumeToken = function () {
      var A = this.consumeCodePoint();
      switch (A) {
        case 34:
          return this.consumeStringToken(34);
        case 35:
          var e = this.peekCodePoint(0),
            t = this.peekCodePoint(1),
            B = this.peekCodePoint(2);
          if (gA(e) || wA(t, B)) {
            var r = CA(e, t, B) ? 2 : 1;
            return {
              type: 5,
              value: this.consumeName(),
              flags: r
            };
          }
          break;
        case 36:
          if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), hA;
          break;
        case 39:
          return this.consumeStringToken(39);
        case 40:
          return lA;
        case 41:
          return FA;
        case 42:
          if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), yA;
          break;
        case 43:
          if (UA(A, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case 44:
          return uA;
        case 45:
          var B = A,
            r = this.peekCodePoint(0),
            n = this.peekCodePoint(1);
          if (UA(B, r, n)) return this.reconsumeCodePoint(A), this.consumeNumericToken();
          if (CA(B, r, n)) return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          if (45 === r && 62 === n) return this.consumeCodePoint(), this.consumeCodePoint(), DA;
          break;
        case 46:
          if (UA(A, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case 47:
          if (42 === this.peekCodePoint(0)) for (this.consumeCodePoint();;) {
            var s = this.consumeCodePoint();
            if (42 === s && 47 === (s = this.consumeCodePoint())) return this.consumeToken();
            if (-1 === s) return this.consumeToken();
          }
          break;
        case 58:
          return bA;
        case 59:
          return RA;
        case 60:
          if (33 === this.peekCodePoint(0) && 45 === this.peekCodePoint(1) && 45 === this.peekCodePoint(2)) return this.consumeCodePoint(), this.consumeCodePoint(), mA;
          break;
        case 64:
          var n = this.peekCodePoint(0),
            o = this.peekCodePoint(1),
            i = this.peekCodePoint(2);
          if (CA(n, o, i)) return {
            type: 7,
            value: this.consumeName()
          };
          break;
        case 91:
          return OA;
        case 92:
          if (wA(A, this.peekCodePoint(0))) return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          break;
        case 93:
          return SA;
        case 61:
          if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), dA;
          break;
        case 123:
          return IA;
        case 125:
          return pA;
        case 117:
        case 85:
          o = this.peekCodePoint(0), i = this.peekCodePoint(1);
          return 43 !== o || !QA(i) && 63 !== i || (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
        case 124:
          if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), HA;
          if (124 === this.peekCodePoint(0)) return this.consumeCodePoint(), EA;
          break;
        case 126:
          if (61 === this.peekCodePoint(0)) return this.consumeCodePoint(), fA;
          break;
        case -1:
          return vA;
      }
      return cA(A) ? (this.consumeWhiteSpace(), TA) : iA(A) ? (this.reconsumeCodePoint(A), this.consumeNumericToken()) : aA(A) ? (this.reconsumeCodePoint(A), this.consumeIdentLikeToken()) : {
        type: 6,
        value: g(A)
      };
    }, NA.prototype.consumeCodePoint = function () {
      var A = this._value.shift();
      return void 0 === A ? -1 : A;
    }, NA.prototype.reconsumeCodePoint = function (A) {
      this._value.unshift(A);
    }, NA.prototype.peekCodePoint = function (A) {
      return A >= this._value.length ? -1 : this._value[A];
    }, NA.prototype.consumeUnicodeRangeToken = function () {
      for (var A = [], e = this.consumeCodePoint(); QA(e) && A.length < 6;) A.push(e), e = this.consumeCodePoint();
      for (var t = !1; 63 === e && A.length < 6;) A.push(e), e = this.consumeCodePoint(), t = !0;
      if (t) return {
        type: 30,
        start: parseInt(g.apply(void 0, A.map(function (A) {
          return 63 === A ? 48 : A;
        })), 16),
        end: parseInt(g.apply(void 0, A.map(function (A) {
          return 63 === A ? 70 : A;
        })), 16)
      };
      var B = parseInt(g.apply(void 0, A), 16);
      if (45 === this.peekCodePoint(0) && QA(this.peekCodePoint(1))) {
        this.consumeCodePoint();
        for (var e = this.consumeCodePoint(), r = []; QA(e) && r.length < 6;) r.push(e), e = this.consumeCodePoint();
        return {
          type: 30,
          start: B,
          end: parseInt(g.apply(void 0, r), 16)
        };
      }
      return {
        type: 30,
        start: B,
        end: B
      };
    }, NA.prototype.consumeIdentLikeToken = function () {
      var A = this.consumeName();
      return "url" === A.toLowerCase() && 40 === this.peekCodePoint(0) ? (this.consumeCodePoint(), this.consumeUrlToken()) : 40 === this.peekCodePoint(0) ? (this.consumeCodePoint(), {
        type: 19,
        value: A
      }) : {
        type: 20,
        value: A
      };
    }, NA.prototype.consumeUrlToken = function () {
      var A = [];
      if (this.consumeWhiteSpace(), -1 === this.peekCodePoint(0)) return {
        type: 22,
        value: ""
      };
      var e,
        t = this.peekCodePoint(0);
      if (39 === t || 34 === t) {
        t = this.consumeStringToken(this.consumeCodePoint());
        return 0 === t.type && (this.consumeWhiteSpace(), -1 === this.peekCodePoint(0) || 41 === this.peekCodePoint(0)) ? (this.consumeCodePoint(), {
          type: 22,
          value: t.value
        }) : (this.consumeBadUrlRemnants(), KA);
      }
      for (;;) {
        var B = this.consumeCodePoint();
        if (-1 === B || 41 === B) return {
          type: 22,
          value: g.apply(void 0, A)
        };
        if (cA(B)) return this.consumeWhiteSpace(), -1 === this.peekCodePoint(0) || 41 === this.peekCodePoint(0) ? (this.consumeCodePoint(), {
          type: 22,
          value: g.apply(void 0, A)
        }) : (this.consumeBadUrlRemnants(), KA);
        if (34 === B || 39 === B || 40 === B || 0 <= (e = B) && e <= 8 || 11 === e || 14 <= e && e <= 31 || 127 === e) return this.consumeBadUrlRemnants(), KA;
        if (92 === B) {
          if (!wA(B, this.peekCodePoint(0))) return this.consumeBadUrlRemnants(), KA;
          A.push(this.consumeEscapedCodePoint());
        } else A.push(B);
      }
    }, NA.prototype.consumeWhiteSpace = function () {
      for (; cA(this.peekCodePoint(0));) this.consumeCodePoint();
    }, NA.prototype.consumeBadUrlRemnants = function () {
      for (;;) {
        var A = this.consumeCodePoint();
        if (41 === A || -1 === A) return;
        wA(A, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, NA.prototype.consumeStringSlice = function (A) {
      for (var e = ""; 0 < A;) {
        var t = Math.min(6e4, A);
        e += g.apply(void 0, this._value.splice(0, t)), A -= t;
      }
      return this._value.shift(), e;
    }, NA.prototype.consumeStringToken = function (A) {
      for (var e = "", t = 0;;) {
        var B,
          r = this._value[t];
        if (-1 === r || void 0 === r || r === A) return {
          type: 0,
          value: e += this.consumeStringSlice(t)
        };
        if (10 === r) return this._value.splice(0, t), LA;
        92 !== r || -1 !== (B = this._value[t + 1]) && void 0 !== B && (10 === B ? (e += this.consumeStringSlice(t), t = -1, this._value.shift()) : wA(r, B) && (e += this.consumeStringSlice(t), e += g(this.consumeEscapedCodePoint()), t = -1)), t++;
      }
    }, NA.prototype.consumeNumber = function () {
      var A = [],
        e = 4;
      for (43 !== (t = this.peekCodePoint(0)) && 45 !== t || A.push(this.consumeCodePoint()); iA(this.peekCodePoint(0));) A.push(this.consumeCodePoint());
      var t = this.peekCodePoint(0),
        B = this.peekCodePoint(1);
      if (46 === t && iA(B)) for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), e = 8; iA(this.peekCodePoint(0));) A.push(this.consumeCodePoint());
      t = this.peekCodePoint(0);
      var B = this.peekCodePoint(1),
        r = this.peekCodePoint(2);
      if ((69 === t || 101 === t) && ((43 === B || 45 === B) && iA(r) || iA(B))) for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), e = 8; iA(this.peekCodePoint(0));) A.push(this.consumeCodePoint());
      return [function (A) {
        var e = 0,
          t = 1;
        43 !== A[e] && 45 !== A[e] || (45 === A[e] && (t = -1), e++);
        for (var B = []; iA(A[e]);) B.push(A[e++]);
        var r = B.length ? parseInt(g.apply(void 0, B), 10) : 0;
        46 === A[e] && e++;
        for (var n = []; iA(A[e]);) n.push(A[e++]);
        var s = n.length,
          o = s ? parseInt(g.apply(void 0, n), 10) : 0;
        69 !== A[e] && 101 !== A[e] || e++;
        var i = 1;
        43 !== A[e] && 45 !== A[e] || (45 === A[e] && (i = -1), e++);
        for (var Q = []; iA(A[e]);) Q.push(A[e++]);
        var c = Q.length ? parseInt(g.apply(void 0, Q), 10) : 0;
        return t * (r + o * Math.pow(10, -s)) * Math.pow(10, i * c);
      }(A), e];
    }, NA.prototype.consumeNumericToken = function () {
      var A = this.consumeNumber(),
        e = A[0],
        t = A[1],
        B = this.peekCodePoint(0),
        r = this.peekCodePoint(1),
        A = this.peekCodePoint(2);
      return CA(B, r, A) ? {
        type: 15,
        number: e,
        flags: t,
        unit: this.consumeName()
      } : 37 === B ? (this.consumeCodePoint(), {
        type: 16,
        number: e,
        flags: t
      }) : {
        type: 17,
        number: e,
        flags: t
      };
    }, NA.prototype.consumeEscapedCodePoint = function () {
      var A,
        e = this.consumeCodePoint();
      if (QA(e)) {
        for (var t = g(e); QA(this.peekCodePoint(0)) && t.length < 6;) t += g(this.consumeCodePoint());
        cA(this.peekCodePoint(0)) && this.consumeCodePoint();
        var B = parseInt(t, 16);
        return 0 === B || 55296 <= (A = B) && A <= 57343 || 1114111 < B ? 65533 : B;
      }
      return -1 === e ? 65533 : e;
    }, NA.prototype.consumeName = function () {
      for (var A = "";;) {
        var e = this.consumeCodePoint();
        if (gA(e)) A += g(e);else {
          if (!wA(e, this.peekCodePoint(0))) return this.reconsumeCodePoint(e), A;
          A += g(this.consumeEscapedCodePoint());
        }
      }
    }, NA);
  function NA() {
    this._value = [];
  }
  var GA = (xA.create = function (A) {
    var e = new MA();
    return e.write(A), new xA(e.read());
  }, xA.parseValue = function (A) {
    return xA.create(A).parseComponentValue();
  }, xA.parseValues = function (A) {
    return xA.create(A).parseComponentValues();
  }, xA.prototype.parseComponentValue = function () {
    for (var A = this.consumeToken(); 31 === A.type;) A = this.consumeToken();
    if (32 === A.type) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
    this.reconsumeToken(A);
    for (var e = this.consumeComponentValue(); 31 === (A = this.consumeToken()).type;);
    if (32 === A.type) return e;
    throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
  }, xA.prototype.parseComponentValues = function () {
    for (var A = [];;) {
      var e = this.consumeComponentValue();
      if (32 === e.type) return A;
      A.push(e), A.push();
    }
  }, xA.prototype.consumeComponentValue = function () {
    var A = this.consumeToken();
    switch (A.type) {
      case 11:
      case 28:
      case 2:
        return this.consumeSimpleBlock(A.type);
      case 19:
        return this.consumeFunction(A);
    }
    return A;
  }, xA.prototype.consumeSimpleBlock = function (A) {
    for (var e = {
        type: A,
        values: []
      }, t = this.consumeToken();;) {
      if (32 === t.type || re(t, A)) return e;
      this.reconsumeToken(t), e.values.push(this.consumeComponentValue()), t = this.consumeToken();
    }
  }, xA.prototype.consumeFunction = function (A) {
    for (var e = {
      name: A.value,
      values: [],
      type: 18
    };;) {
      var t = this.consumeToken();
      if (32 === t.type || 3 === t.type) return e;
      this.reconsumeToken(t), e.values.push(this.consumeComponentValue());
    }
  }, xA.prototype.consumeToken = function () {
    var A = this._tokens.shift();
    return void 0 === A ? vA : A;
  }, xA.prototype.reconsumeToken = function (A) {
    this._tokens.unshift(A);
  }, xA);
  function xA(A) {
    this._tokens = A;
  }
  function VA(A) {
    return 15 === A.type;
  }
  function PA(A) {
    return 17 === A.type;
  }
  function kA(A) {
    return 20 === A.type;
  }
  function JA(A) {
    return 0 === A.type;
  }
  function XA(A, e) {
    return kA(A) && A.value === e;
  }
  function _A(A) {
    return 31 !== A.type;
  }
  function YA(A) {
    return 31 !== A.type && 4 !== A.type;
  }
  function WA(A) {
    var e = [],
      t = [];
    return A.forEach(function (A) {
      if (4 === A.type) {
        if (0 === t.length) throw new Error("Error parsing function args, zero tokens for arg");
        return e.push(t), void (t = []);
      }
      31 !== A.type && t.push(A);
    }), t.length && e.push(t), e;
  }
  function ZA(A) {
    return 17 === A.type || 15 === A.type;
  }
  function qA(A) {
    return 16 === A.type || ZA(A);
  }
  function jA(A) {
    return 1 < A.length ? [A[0], A[1]] : [A[0]];
  }
  function zA(A, e, t) {
    var B = A[0],
      A = A[1];
    return [ie(B, e), ie(void 0 !== A ? A : B, t)];
  }
  function $A(A) {
    return 15 === A.type && ("deg" === A.unit || "grad" === A.unit || "rad" === A.unit || "turn" === A.unit);
  }
  function Ae(A) {
    switch (A.filter(kA).map(function (A) {
      return A.value;
    }).join(" ")) {
      case "to bottom right":
      case "to right bottom":
      case "left top":
      case "top left":
        return [ne, ne];
      case "to top":
      case "bottom":
        return ce(0);
      case "to bottom left":
      case "to left bottom":
      case "right top":
      case "top right":
        return [ne, oe];
      case "to right":
      case "left":
        return ce(90);
      case "to top left":
      case "to left top":
      case "right bottom":
      case "bottom right":
        return [oe, oe];
      case "to bottom":
      case "top":
        return ce(180);
      case "to top right":
      case "to right top":
      case "left bottom":
      case "bottom left":
        return [oe, ne];
      case "to left":
      case "right":
        return ce(270);
    }
    return 0;
  }
  function ee(A) {
    return 0 == (255 & A);
  }
  function te(A) {
    var e = 255 & A,
      t = 255 & A >> 8,
      B = 255 & A >> 16,
      A = 255 & A >> 24;
    return e < 255 ? "rgba(" + A + "," + B + "," + t + "," + e / 255 + ")" : "rgb(" + A + "," + B + "," + t + ")";
  }
  function Be(A, e) {
    if (17 === A.type) return A.number;
    if (16 !== A.type) return 0;
    var t = 3 === e ? 1 : 255;
    return 3 === e ? A.number / 100 * t : Math.round(A.number / 100 * t);
  }
  var re = function (A, e) {
      return 11 === e && 12 === A.type || 28 === e && 29 === A.type || 2 === e && 3 === A.type;
    },
    ne = {
      type: 17,
      number: 0,
      flags: 4
    },
    se = {
      type: 16,
      number: 50,
      flags: 4
    },
    oe = {
      type: 16,
      number: 100,
      flags: 4
    },
    ie = function (A, e) {
      if (16 === A.type) return A.number / 100 * e;
      if (VA(A)) switch (A.unit) {
        case "rem":
        case "em":
          return 16 * A.number;
        default:
          return A.number;
      }
      return A.number;
    },
    Qe = function (A, e) {
      if (15 === e.type) switch (e.unit) {
        case "deg":
          return Math.PI * e.number / 180;
        case "grad":
          return Math.PI / 200 * e.number;
        case "rad":
          return e.number;
        case "turn":
          return 2 * Math.PI * e.number;
      }
      throw new Error("Unsupported angle type");
    },
    ce = function (A) {
      return Math.PI * A / 180;
    },
    ae = function (A, e) {
      if (18 === e.type) {
        var t = ue[e.name];
        if (void 0 === t) throw new Error('Attempting to parse an unsupported color function "' + e.name + '"');
        return t(A, e.values);
      }
      if (5 === e.type) {
        if (3 === e.value.length) {
          var B = e.value.substring(0, 1),
            r = e.value.substring(1, 2),
            n = e.value.substring(2, 3);
          return ge(parseInt(B + B, 16), parseInt(r + r, 16), parseInt(n + n, 16), 1);
        }
        if (4 === e.value.length) {
          var B = e.value.substring(0, 1),
            r = e.value.substring(1, 2),
            n = e.value.substring(2, 3),
            s = e.value.substring(3, 4);
          return ge(parseInt(B + B, 16), parseInt(r + r, 16), parseInt(n + n, 16), parseInt(s + s, 16) / 255);
        }
        if (6 === e.value.length) {
          B = e.value.substring(0, 2), r = e.value.substring(2, 4), n = e.value.substring(4, 6);
          return ge(parseInt(B, 16), parseInt(r, 16), parseInt(n, 16), 1);
        }
        if (8 === e.value.length) {
          B = e.value.substring(0, 2), r = e.value.substring(2, 4), n = e.value.substring(4, 6), s = e.value.substring(6, 8);
          return ge(parseInt(B, 16), parseInt(r, 16), parseInt(n, 16), parseInt(s, 16) / 255);
        }
      }
      if (20 === e.type) {
        e = he[e.value.toUpperCase()];
        if (void 0 !== e) return e;
      }
      return he.TRANSPARENT;
    },
    ge = function (A, e, t, B) {
      return (A << 24 | e << 16 | t << 8 | Math.round(255 * B) << 0) >>> 0;
    },
    we = function (A, e) {
      e = e.filter(YA);
      if (3 === e.length) {
        var t = e.map(Be),
          B = t[0],
          r = t[1],
          t = t[2];
        return ge(B, r, t, 1);
      }
      if (4 !== e.length) return 0;
      e = e.map(Be), B = e[0], r = e[1], t = e[2], e = e[3];
      return ge(B, r, t, e);
    };
  function Ce(A, e, t) {
    return t < 0 && (t += 1), 1 <= t && --t, t < 1 / 6 ? (e - A) * t * 6 + A : t < .5 ? e : t < 2 / 3 ? 6 * (e - A) * (2 / 3 - t) + A : A;
  }
  function Ue(A, e) {
    return ae(A, GA.create(e).parseComponentValue());
  }
  var le,
    Fe = function (A, e) {
      var t = e.filter(YA),
        B = t[0],
        r = t[1],
        n = t[2],
        e = t[3],
        t = (17 === B.type ? ce(B.number) : Qe(A, B)) / (2 * Math.PI),
        A = qA(r) ? r.number / 100 : 0,
        B = qA(n) ? n.number / 100 : 0,
        r = void 0 !== e && qA(e) ? ie(e, 1) : 1;
      if (0 == A) return ge(255 * B, 255 * B, 255 * B, 1);
      n = B <= .5 ? B * (1 + A) : B + A - B * A, e = 2 * B - n, A = Ce(e, n, t + 1 / 3), B = Ce(e, n, t), t = Ce(e, n, t - 1 / 3);
      return ge(255 * A, 255 * B, 255 * t, r);
    },
    ue = {
      hsl: Fe,
      hsla: Fe,
      rgb: we,
      rgba: we
    },
    he = {
      ALICEBLUE: 4042850303,
      ANTIQUEWHITE: 4209760255,
      AQUA: 16777215,
      AQUAMARINE: 2147472639,
      AZURE: 4043309055,
      BEIGE: 4126530815,
      BISQUE: 4293182719,
      BLACK: 255,
      BLANCHEDALMOND: 4293643775,
      BLUE: 65535,
      BLUEVIOLET: 2318131967,
      BROWN: 2771004159,
      BURLYWOOD: 3736635391,
      CADETBLUE: 1604231423,
      CHARTREUSE: 2147418367,
      CHOCOLATE: 3530104575,
      CORAL: 4286533887,
      CORNFLOWERBLUE: 1687547391,
      CORNSILK: 4294499583,
      CRIMSON: 3692313855,
      CYAN: 16777215,
      DARKBLUE: 35839,
      DARKCYAN: 9145343,
      DARKGOLDENROD: 3095837695,
      DARKGRAY: 2846468607,
      DARKGREEN: 6553855,
      DARKGREY: 2846468607,
      DARKKHAKI: 3182914559,
      DARKMAGENTA: 2332068863,
      DARKOLIVEGREEN: 1433087999,
      DARKORANGE: 4287365375,
      DARKORCHID: 2570243327,
      DARKRED: 2332033279,
      DARKSALMON: 3918953215,
      DARKSEAGREEN: 2411499519,
      DARKSLATEBLUE: 1211993087,
      DARKSLATEGRAY: 793726975,
      DARKSLATEGREY: 793726975,
      DARKTURQUOISE: 13554175,
      DARKVIOLET: 2483082239,
      DEEPPINK: 4279538687,
      DEEPSKYBLUE: 12582911,
      DIMGRAY: 1768516095,
      DIMGREY: 1768516095,
      DODGERBLUE: 512819199,
      FIREBRICK: 2988581631,
      FLORALWHITE: 4294635775,
      FORESTGREEN: 579543807,
      FUCHSIA: 4278255615,
      GAINSBORO: 3705462015,
      GHOSTWHITE: 4177068031,
      GOLD: 4292280575,
      GOLDENROD: 3668254975,
      GRAY: 2155905279,
      GREEN: 8388863,
      GREENYELLOW: 2919182335,
      GREY: 2155905279,
      HONEYDEW: 4043305215,
      HOTPINK: 4285117695,
      INDIANRED: 3445382399,
      INDIGO: 1258324735,
      IVORY: 4294963455,
      KHAKI: 4041641215,
      LAVENDER: 3873897215,
      LAVENDERBLUSH: 4293981695,
      LAWNGREEN: 2096890111,
      LEMONCHIFFON: 4294626815,
      LIGHTBLUE: 2916673279,
      LIGHTCORAL: 4034953471,
      LIGHTCYAN: 3774873599,
      LIGHTGOLDENRODYELLOW: 4210742015,
      LIGHTGRAY: 3553874943,
      LIGHTGREEN: 2431553791,
      LIGHTGREY: 3553874943,
      LIGHTPINK: 4290167295,
      LIGHTSALMON: 4288707327,
      LIGHTSEAGREEN: 548580095,
      LIGHTSKYBLUE: 2278488831,
      LIGHTSLATEGRAY: 2005441023,
      LIGHTSLATEGREY: 2005441023,
      LIGHTSTEELBLUE: 2965692159,
      LIGHTYELLOW: 4294959359,
      LIME: 16711935,
      LIMEGREEN: 852308735,
      LINEN: 4210091775,
      MAGENTA: 4278255615,
      MAROON: 2147483903,
      MEDIUMAQUAMARINE: 1724754687,
      MEDIUMBLUE: 52735,
      MEDIUMORCHID: 3126187007,
      MEDIUMPURPLE: 2473647103,
      MEDIUMSEAGREEN: 1018393087,
      MEDIUMSLATEBLUE: 2070474495,
      MEDIUMSPRINGGREEN: 16423679,
      MEDIUMTURQUOISE: 1221709055,
      MEDIUMVIOLETRED: 3340076543,
      MIDNIGHTBLUE: 421097727,
      MINTCREAM: 4127193855,
      MISTYROSE: 4293190143,
      MOCCASIN: 4293178879,
      NAVAJOWHITE: 4292783615,
      NAVY: 33023,
      OLDLACE: 4260751103,
      OLIVE: 2155872511,
      OLIVEDRAB: 1804477439,
      ORANGE: 4289003775,
      ORANGERED: 4282712319,
      ORCHID: 3664828159,
      PALEGOLDENROD: 4008225535,
      PALEGREEN: 2566625535,
      PALETURQUOISE: 2951671551,
      PALEVIOLETRED: 3681588223,
      PAPAYAWHIP: 4293907967,
      PEACHPUFF: 4292524543,
      PERU: 3448061951,
      PINK: 4290825215,
      PLUM: 3718307327,
      POWDERBLUE: 2967529215,
      PURPLE: 2147516671,
      REBECCAPURPLE: 1714657791,
      RED: 4278190335,
      ROSYBROWN: 3163525119,
      ROYALBLUE: 1097458175,
      SADDLEBROWN: 2336560127,
      SALMON: 4202722047,
      SANDYBROWN: 4104413439,
      SEAGREEN: 780883967,
      SEASHELL: 4294307583,
      SIENNA: 2689740287,
      SILVER: 3233857791,
      SKYBLUE: 2278484991,
      SLATEBLUE: 1784335871,
      SLATEGRAY: 1887473919,
      SLATEGREY: 1887473919,
      SNOW: 4294638335,
      SPRINGGREEN: 16744447,
      STEELBLUE: 1182971135,
      TAN: 3535047935,
      TEAL: 8421631,
      THISTLE: 3636451583,
      TOMATO: 4284696575,
      TRANSPARENT: 0,
      TURQUOISE: 1088475391,
      VIOLET: 4001558271,
      WHEAT: 4125012991,
      WHITE: 4294967295,
      WHITESMOKE: 4126537215,
      YELLOW: 4294902015,
      YELLOWGREEN: 2597139199
    };
  (ve = le = le || {})[ve.BORDER_BOX = 0] = "BORDER_BOX", ve[ve.PADDING_BOX = 1] = "PADDING_BOX";
  function de(A, e) {
    return A = ae(A, e[0]), (e = e[1]) && qA(e) ? {
      color: A,
      stop: e
    } : {
      color: A,
      stop: null
    };
  }
  function Ee(A, t) {
    var e = A[0],
      B = A[A.length - 1];
    null === e.stop && (e.stop = ne), null === B.stop && (B.stop = oe);
    for (var r = [], n = 0, s = 0; s < A.length; s++) {
      var o = A[s].stop;
      null !== o ? (n < (o = ie(o, t)) ? r.push(o) : r.push(n), n = o) : r.push(null);
    }
    for (var i = null, s = 0; s < r.length; s++) {
      var Q = r[s];
      if (null === Q) null === i && (i = s);else if (null !== i) {
        for (var c = s - i, a = (Q - r[i - 1]) / (1 + c), g = 1; g <= c; g++) r[i + g - 1] = a * g;
        i = null;
      }
    }
    return A.map(function (A, e) {
      return {
        color: A.color,
        stop: Math.max(Math.min(1, r[e] / t), 0)
      };
    });
  }
  function He(A, e, t) {
    var B = "number" == typeof A ? A : (s = e / 2, B = (n = t) / 2, s = ie((r = A)[0], e) - s, n = B - ie(r[1], n), (Math.atan2(n, s) + 2 * Math.PI) % (2 * Math.PI)),
      r = Math.abs(e * Math.sin(B)) + Math.abs(t * Math.cos(B)),
      n = e / 2,
      s = t / 2,
      e = r / 2,
      t = Math.sin(B - Math.PI / 2) * e,
      e = Math.cos(B - Math.PI / 2) * e;
    return [r, n - e, n + e, s - t, s + t];
  }
  function fe(A, e) {
    return Math.sqrt(A * A + e * e);
  }
  function Ie(A, e, r, n, s) {
    return [[0, 0], [0, e], [A, 0], [A, e]].reduce(function (A, e) {
      var t = e[0],
        B = e[1],
        B = fe(r - t, n - B);
      return (s ? B < A.optimumDistance : B > A.optimumDistance) ? {
        optimumCorner: e,
        optimumDistance: B
      } : A;
    }, {
      optimumDistance: s ? 1 / 0 : -1 / 0,
      optimumCorner: null
    }).optimumCorner;
  }
  var pe,
    ye = {
      name: "background-clip",
      initialValue: "border-box",
      prefix: !(ve[ve.CONTENT_BOX = 2] = "CONTENT_BOX"),
      type: 1,
      parse: function (A, e) {
        return e.map(function (A) {
          if (kA(A)) switch (A.value) {
            case "padding-box":
              return le.PADDING_BOX;
            case "content-box":
              return le.CONTENT_BOX;
          }
          return le.BORDER_BOX;
        });
      }
    },
    Ke = {
      name: "background-color",
      initialValue: "transparent",
      prefix: !1,
      type: 3,
      format: "color"
    },
    Fe = function (t, A) {
      var B = ce(180),
        r = [];
      return WA(A).forEach(function (A, e) {
        if (0 === e) {
          e = A[0];
          if (20 === e.type && -1 !== ["top", "left", "right", "bottom"].indexOf(e.value)) return void (B = Ae(A));
          if ($A(e)) return void (B = (Qe(t, e) + ce(270)) % ce(360));
        }
        A = de(t, A);
        r.push(A);
      }), {
        angle: B,
        stops: r,
        type: pe.LINEAR_GRADIENT
      };
    },
    Le = "closest-side",
    me = "farthest-side",
    De = "closest-corner",
    be = "farthest-corner",
    Re = "ellipse",
    Oe = "contain",
    we = function (B, A) {
      var r = Se.CIRCLE,
        n = Te.FARTHEST_CORNER,
        s = [],
        o = [];
      return WA(A).forEach(function (A, e) {
        var t = !0;
        0 === e ? t = A.reduce(function (A, e) {
          if (kA(e)) switch (e.value) {
            case "center":
              return o.push(se), !1;
            case "top":
            case "left":
              return o.push(ne), !1;
            case "right":
            case "bottom":
              return o.push(oe), !1;
          } else if (qA(e) || ZA(e)) return o.push(e), !1;
          return A;
        }, t) : 1 === e && (t = A.reduce(function (A, e) {
          if (kA(e)) switch (e.value) {
            case "circle":
              return r = Se.CIRCLE, !1;
            case Re:
              return r = Se.ELLIPSE, !1;
            case Oe:
            case Le:
              return n = Te.CLOSEST_SIDE, !1;
            case me:
              return n = Te.FARTHEST_SIDE, !1;
            case De:
              return n = Te.CLOSEST_CORNER, !1;
            case "cover":
            case be:
              return n = Te.FARTHEST_CORNER, !1;
          } else if (ZA(e) || qA(e)) return (n = !Array.isArray(n) ? [] : n).push(e), !1;
          return A;
        }, t)), t && (A = de(B, A), s.push(A));
      }), {
        size: n,
        shape: r,
        stops: s,
        position: o,
        type: pe.RADIAL_GRADIENT
      };
    };
  (ve = pe = pe || {})[ve.URL = 0] = "URL", ve[ve.LINEAR_GRADIENT = 1] = "LINEAR_GRADIENT", ve[ve.RADIAL_GRADIENT = 2] = "RADIAL_GRADIENT";
  var Se, Te, ve;
  (ve = Se = Se || {})[ve.CIRCLE = 0] = "CIRCLE", ve[ve.ELLIPSE = 1] = "ELLIPSE", (ve = Te = Te || {})[ve.CLOSEST_SIDE = 0] = "CLOSEST_SIDE", ve[ve.FARTHEST_SIDE = 1] = "FARTHEST_SIDE", ve[ve.CLOSEST_CORNER = 2] = "CLOSEST_CORNER", ve[ve.FARTHEST_CORNER = 3] = "FARTHEST_CORNER";
  var Me = function (A, e) {
    if (22 === e.type) {
      var t = {
        url: e.value,
        type: pe.URL
      };
      return A.cache.addImage(e.value), t;
    }
    if (18 !== e.type) throw new Error("Unsupported image type " + e.type);
    t = Ge[e.name];
    if (void 0 === t) throw new Error('Attempting to parse an unsupported image function "' + e.name + '"');
    return t(A, e.values);
  };
  var Ne,
    Ge = {
      "linear-gradient": function (t, A) {
        var B = ce(180),
          r = [];
        return WA(A).forEach(function (A, e) {
          if (0 === e) {
            e = A[0];
            if (20 === e.type && "to" === e.value) return void (B = Ae(A));
            if ($A(e)) return void (B = Qe(t, e));
          }
          A = de(t, A);
          r.push(A);
        }), {
          angle: B,
          stops: r,
          type: pe.LINEAR_GRADIENT
        };
      },
      "-moz-linear-gradient": Fe,
      "-ms-linear-gradient": Fe,
      "-o-linear-gradient": Fe,
      "-webkit-linear-gradient": Fe,
      "radial-gradient": function (r, A) {
        var n = Se.CIRCLE,
          s = Te.FARTHEST_CORNER,
          o = [],
          i = [];
        return WA(A).forEach(function (A, e) {
          var t,
            B = !0;
          0 === e && (t = !1, B = A.reduce(function (A, e) {
            if (t) {
              if (kA(e)) switch (e.value) {
                case "center":
                  return i.push(se), A;
                case "top":
                case "left":
                  return i.push(ne), A;
                case "right":
                case "bottom":
                  return i.push(oe), A;
              } else (qA(e) || ZA(e)) && i.push(e);
            } else if (kA(e)) switch (e.value) {
              case "circle":
                return n = Se.CIRCLE, !1;
              case Re:
                return n = Se.ELLIPSE, !1;
              case "at":
                return !(t = !0);
              case Le:
                return s = Te.CLOSEST_SIDE, !1;
              case "cover":
              case me:
                return s = Te.FARTHEST_SIDE, !1;
              case Oe:
              case De:
                return s = Te.CLOSEST_CORNER, !1;
              case be:
                return s = Te.FARTHEST_CORNER, !1;
            } else if (ZA(e) || qA(e)) return (s = !Array.isArray(s) ? [] : s).push(e), !1;
            return A;
          }, B)), B && (A = de(r, A), o.push(A));
        }), {
          size: s,
          shape: n,
          stops: o,
          position: i,
          type: pe.RADIAL_GRADIENT
        };
      },
      "-moz-radial-gradient": we,
      "-ms-radial-gradient": we,
      "-o-radial-gradient": we,
      "-webkit-radial-gradient": we,
      "-webkit-gradient": function (B, A) {
        var e = ce(180),
          r = [],
          n = pe.LINEAR_GRADIENT,
          t = Se.CIRCLE,
          s = Te.FARTHEST_CORNER;
        return WA(A).forEach(function (A, e) {
          var t,
            A = A[0];
          if (0 === e) {
            if (kA(A) && "linear" === A.value) return void (n = pe.LINEAR_GRADIENT);
            if (kA(A) && "radial" === A.value) return void (n = pe.RADIAL_GRADIENT);
          }
          18 === A.type && ("from" === A.name ? (t = ae(B, A.values[0]), r.push({
            stop: ne,
            color: t
          })) : "to" === A.name ? (t = ae(B, A.values[0]), r.push({
            stop: oe,
            color: t
          })) : "color-stop" !== A.name || 2 === (A = A.values.filter(YA)).length && (t = ae(B, A[1]), A = A[0], PA(A) && r.push({
            stop: {
              type: 16,
              number: 100 * A.number,
              flags: A.flags
            },
            color: t
          })));
        }), n === pe.LINEAR_GRADIENT ? {
          angle: (e + ce(180)) % ce(360),
          stops: r,
          type: n
        } : {
          size: s,
          shape: t,
          stops: r,
          position: [],
          type: n
        };
      }
    },
    xe = {
      name: "background-image",
      initialValue: "none",
      type: 1,
      prefix: !1,
      parse: function (e, A) {
        if (0 === A.length) return [];
        var t = A[0];
        return 20 === t.type && "none" === t.value ? [] : A.filter(function (A) {
          return YA(A) && !(20 === (A = A).type && "none" === A.value || 18 === A.type && !Ge[A.name]);
        }).map(function (A) {
          return Me(e, A);
        });
      }
    },
    Ve = {
      name: "background-origin",
      initialValue: "border-box",
      prefix: !1,
      type: 1,
      parse: function (A, e) {
        return e.map(function (A) {
          if (kA(A)) switch (A.value) {
            case "padding-box":
              return 1;
            case "content-box":
              return 2;
          }
          return 0;
        });
      }
    },
    Pe = {
      name: "background-position",
      initialValue: "0% 0%",
      type: 1,
      prefix: !1,
      parse: function (A, e) {
        return WA(e).map(function (A) {
          return A.filter(qA);
        }).map(jA);
      }
    };
  (we = Ne = Ne || {})[we.REPEAT = 0] = "REPEAT", we[we.NO_REPEAT = 1] = "NO_REPEAT", we[we.REPEAT_X = 2] = "REPEAT_X";
  var ke,
    Je = {
      name: "background-repeat",
      initialValue: "repeat",
      prefix: !(we[we.REPEAT_Y = 3] = "REPEAT_Y"),
      type: 1,
      parse: function (A, e) {
        return WA(e).map(function (A) {
          return A.filter(kA).map(function (A) {
            return A.value;
          }).join(" ");
        }).map(Xe);
      }
    },
    Xe = function (A) {
      switch (A) {
        case "no-repeat":
          return Ne.NO_REPEAT;
        case "repeat-x":
        case "repeat no-repeat":
          return Ne.REPEAT_X;
        case "repeat-y":
        case "no-repeat repeat":
          return Ne.REPEAT_Y;
        default:
          return Ne.REPEAT;
      }
    };
  (we = ke = ke || {}).AUTO = "auto", we.CONTAIN = "contain";
  var _e,
    Ye = {
      name: "background-size",
      initialValue: "0",
      prefix: !(we.COVER = "cover"),
      type: 1,
      parse: function (A, e) {
        return WA(e).map(function (A) {
          return A.filter(We);
        });
      }
    },
    We = function (A) {
      return kA(A) || qA(A);
    },
    we = function (A) {
      return {
        name: "border-" + A + "-color",
        initialValue: "transparent",
        prefix: !1,
        type: 3,
        format: "color"
      };
    },
    Ze = we("top"),
    qe = we("right"),
    je = we("bottom"),
    ze = we("left"),
    we = function (A) {
      return {
        name: "border-radius-" + A,
        initialValue: "0 0",
        prefix: !1,
        type: 1,
        parse: function (A, e) {
          return jA(e.filter(qA));
        }
      };
    },
    $e = we("top-left"),
    At = we("top-right"),
    et = we("bottom-right"),
    tt = we("bottom-left");
  (we = _e = _e || {})[we.NONE = 0] = "NONE", we[we.SOLID = 1] = "SOLID", we[we.DASHED = 2] = "DASHED", we[we.DOTTED = 3] = "DOTTED", we[we.DOUBLE = 4] = "DOUBLE";
  var Bt,
    we = function (A) {
      return {
        name: "border-" + A + "-style",
        initialValue: "solid",
        prefix: !1,
        type: 2,
        parse: function (A, e) {
          switch (e) {
            case "none":
              return _e.NONE;
            case "dashed":
              return _e.DASHED;
            case "dotted":
              return _e.DOTTED;
            case "double":
              return _e.DOUBLE;
          }
          return _e.SOLID;
        }
      };
    },
    rt = we("top"),
    nt = we("right"),
    st = we("bottom"),
    ot = we("left"),
    we = function (A) {
      return {
        name: "border-" + A + "-width",
        initialValue: "0",
        type: 0,
        prefix: !1,
        parse: function (A, e) {
          return VA(e) ? e.number : 0;
        }
      };
    },
    it = we("top"),
    Qt = we("right"),
    ct = we("bottom"),
    at = we("left"),
    gt = {
      name: "color",
      initialValue: "transparent",
      prefix: !1,
      type: 3,
      format: "color"
    },
    wt = {
      name: "direction",
      initialValue: "ltr",
      prefix: !1,
      type: 2,
      parse: function (A, e) {
        return "rtl" !== e ? 0 : 1;
      }
    },
    Ct = {
      name: "display",
      initialValue: "inline-block",
      prefix: !1,
      type: 1,
      parse: function (A, e) {
        return e.filter(kA).reduce(function (A, e) {
          return A | Ut(e.value);
        }, 0);
      }
    },
    Ut = function (A) {
      switch (A) {
        case "block":
        case "-webkit-box":
          return 2;
        case "inline":
          return 4;
        case "run-in":
          return 8;
        case "flow":
          return 16;
        case "flow-root":
          return 32;
        case "table":
          return 64;
        case "flex":
        case "-webkit-flex":
          return 128;
        case "grid":
        case "-ms-grid":
          return 256;
        case "ruby":
          return 512;
        case "subgrid":
          return 1024;
        case "list-item":
          return 2048;
        case "table-row-group":
          return 4096;
        case "table-header-group":
          return 8192;
        case "table-footer-group":
          return 16384;
        case "table-row":
          return 32768;
        case "table-cell":
          return 65536;
        case "table-column-group":
          return 131072;
        case "table-column":
          return 262144;
        case "table-caption":
          return 524288;
        case "ruby-base":
          return 1048576;
        case "ruby-text":
          return 2097152;
        case "ruby-base-container":
          return 4194304;
        case "ruby-text-container":
          return 8388608;
        case "contents":
          return 16777216;
        case "inline-block":
          return 33554432;
        case "inline-list-item":
          return 67108864;
        case "inline-table":
          return 134217728;
        case "inline-flex":
          return 268435456;
        case "inline-grid":
          return 536870912;
      }
      return 0;
    };
  (we = Bt = Bt || {})[we.NONE = 0] = "NONE", we[we.LEFT = 1] = "LEFT", we[we.RIGHT = 2] = "RIGHT", we[we.INLINE_START = 3] = "INLINE_START";
  function lt(A, e) {
    return kA(A) && "normal" === A.value ? 1.2 * e : 17 === A.type ? e * A.number : qA(A) ? ie(A, e) : e;
  }
  var Ft,
    ut,
    ht = {
      name: "float",
      initialValue: "none",
      prefix: !(we[we.INLINE_END = 4] = "INLINE_END"),
      type: 2,
      parse: function (A, e) {
        switch (e) {
          case "left":
            return Bt.LEFT;
          case "right":
            return Bt.RIGHT;
          case "inline-start":
            return Bt.INLINE_START;
          case "inline-end":
            return Bt.INLINE_END;
        }
        return Bt.NONE;
      }
    },
    dt = {
      name: "letter-spacing",
      initialValue: "0",
      prefix: !1,
      type: 0,
      parse: function (A, e) {
        return !(20 === e.type && "normal" === e.value || 17 !== e.type && 15 !== e.type) ? e.number : 0;
      }
    },
    Et = {
      name: "line-break",
      initialValue: (we = Ft = Ft || {}).NORMAL = "normal",
      prefix: !(we.STRICT = "strict"),
      type: 2,
      parse: function (A, e) {
        return "strict" !== e ? Ft.NORMAL : Ft.STRICT;
      }
    },
    Ht = {
      name: "line-height",
      initialValue: "normal",
      prefix: !1,
      type: 4
    },
    ft = {
      name: "list-style-image",
      initialValue: "none",
      type: 0,
      prefix: !1,
      parse: function (A, e) {
        return 20 === e.type && "none" === e.value ? null : Me(A, e);
      }
    };
  (we = ut = ut || {})[we.INSIDE = 0] = "INSIDE";
  var It,
    pt = {
      name: "list-style-position",
      initialValue: "outside",
      prefix: !(we[we.OUTSIDE = 1] = "OUTSIDE"),
      type: 2,
      parse: function (A, e) {
        return "inside" !== e ? ut.OUTSIDE : ut.INSIDE;
      }
    };
  (we = It = It || {})[we.NONE = -1] = "NONE", we[we.DISC = 0] = "DISC", we[we.CIRCLE = 1] = "CIRCLE", we[we.SQUARE = 2] = "SQUARE", we[we.DECIMAL = 3] = "DECIMAL", we[we.CJK_DECIMAL = 4] = "CJK_DECIMAL", we[we.DECIMAL_LEADING_ZERO = 5] = "DECIMAL_LEADING_ZERO", we[we.LOWER_ROMAN = 6] = "LOWER_ROMAN", we[we.UPPER_ROMAN = 7] = "UPPER_ROMAN", we[we.LOWER_GREEK = 8] = "LOWER_GREEK", we[we.LOWER_ALPHA = 9] = "LOWER_ALPHA", we[we.UPPER_ALPHA = 10] = "UPPER_ALPHA", we[we.ARABIC_INDIC = 11] = "ARABIC_INDIC", we[we.ARMENIAN = 12] = "ARMENIAN", we[we.BENGALI = 13] = "BENGALI", we[we.CAMBODIAN = 14] = "CAMBODIAN", we[we.CJK_EARTHLY_BRANCH = 15] = "CJK_EARTHLY_BRANCH", we[we.CJK_HEAVENLY_STEM = 16] = "CJK_HEAVENLY_STEM", we[we.CJK_IDEOGRAPHIC = 17] = "CJK_IDEOGRAPHIC", we[we.DEVANAGARI = 18] = "DEVANAGARI", we[we.ETHIOPIC_NUMERIC = 19] = "ETHIOPIC_NUMERIC", we[we.GEORGIAN = 20] = "GEORGIAN", we[we.GUJARATI = 21] = "GUJARATI", we[we.GURMUKHI = 22] = "GURMUKHI", we[we.HEBREW = 22] = "HEBREW", we[we.HIRAGANA = 23] = "HIRAGANA", we[we.HIRAGANA_IROHA = 24] = "HIRAGANA_IROHA", we[we.JAPANESE_FORMAL = 25] = "JAPANESE_FORMAL", we[we.JAPANESE_INFORMAL = 26] = "JAPANESE_INFORMAL", we[we.KANNADA = 27] = "KANNADA", we[we.KATAKANA = 28] = "KATAKANA", we[we.KATAKANA_IROHA = 29] = "KATAKANA_IROHA", we[we.KHMER = 30] = "KHMER", we[we.KOREAN_HANGUL_FORMAL = 31] = "KOREAN_HANGUL_FORMAL", we[we.KOREAN_HANJA_FORMAL = 32] = "KOREAN_HANJA_FORMAL", we[we.KOREAN_HANJA_INFORMAL = 33] = "KOREAN_HANJA_INFORMAL", we[we.LAO = 34] = "LAO", we[we.LOWER_ARMENIAN = 35] = "LOWER_ARMENIAN", we[we.MALAYALAM = 36] = "MALAYALAM", we[we.MONGOLIAN = 37] = "MONGOLIAN", we[we.MYANMAR = 38] = "MYANMAR", we[we.ORIYA = 39] = "ORIYA", we[we.PERSIAN = 40] = "PERSIAN", we[we.SIMP_CHINESE_FORMAL = 41] = "SIMP_CHINESE_FORMAL", we[we.SIMP_CHINESE_INFORMAL = 42] = "SIMP_CHINESE_INFORMAL", we[we.TAMIL = 43] = "TAMIL", we[we.TELUGU = 44] = "TELUGU", we[we.THAI = 45] = "THAI", we[we.TIBETAN = 46] = "TIBETAN", we[we.TRAD_CHINESE_FORMAL = 47] = "TRAD_CHINESE_FORMAL", we[we.TRAD_CHINESE_INFORMAL = 48] = "TRAD_CHINESE_INFORMAL", we[we.UPPER_ARMENIAN = 49] = "UPPER_ARMENIAN", we[we.DISCLOSURE_OPEN = 50] = "DISCLOSURE_OPEN";
  var yt,
    Kt = {
      name: "list-style-type",
      initialValue: "none",
      prefix: !(we[we.DISCLOSURE_CLOSED = 51] = "DISCLOSURE_CLOSED"),
      type: 2,
      parse: function (A, e) {
        switch (e) {
          case "disc":
            return It.DISC;
          case "circle":
            return It.CIRCLE;
          case "square":
            return It.SQUARE;
          case "decimal":
            return It.DECIMAL;
          case "cjk-decimal":
            return It.CJK_DECIMAL;
          case "decimal-leading-zero":
            return It.DECIMAL_LEADING_ZERO;
          case "lower-roman":
            return It.LOWER_ROMAN;
          case "upper-roman":
            return It.UPPER_ROMAN;
          case "lower-greek":
            return It.LOWER_GREEK;
          case "lower-alpha":
            return It.LOWER_ALPHA;
          case "upper-alpha":
            return It.UPPER_ALPHA;
          case "arabic-indic":
            return It.ARABIC_INDIC;
          case "armenian":
            return It.ARMENIAN;
          case "bengali":
            return It.BENGALI;
          case "cambodian":
            return It.CAMBODIAN;
          case "cjk-earthly-branch":
            return It.CJK_EARTHLY_BRANCH;
          case "cjk-heavenly-stem":
            return It.CJK_HEAVENLY_STEM;
          case "cjk-ideographic":
            return It.CJK_IDEOGRAPHIC;
          case "devanagari":
            return It.DEVANAGARI;
          case "ethiopic-numeric":
            return It.ETHIOPIC_NUMERIC;
          case "georgian":
            return It.GEORGIAN;
          case "gujarati":
            return It.GUJARATI;
          case "gurmukhi":
            return It.GURMUKHI;
          case "hebrew":
            return It.HEBREW;
          case "hiragana":
            return It.HIRAGANA;
          case "hiragana-iroha":
            return It.HIRAGANA_IROHA;
          case "japanese-formal":
            return It.JAPANESE_FORMAL;
          case "japanese-informal":
            return It.JAPANESE_INFORMAL;
          case "kannada":
            return It.KANNADA;
          case "katakana":
            return It.KATAKANA;
          case "katakana-iroha":
            return It.KATAKANA_IROHA;
          case "khmer":
            return It.KHMER;
          case "korean-hangul-formal":
            return It.KOREAN_HANGUL_FORMAL;
          case "korean-hanja-formal":
            return It.KOREAN_HANJA_FORMAL;
          case "korean-hanja-informal":
            return It.KOREAN_HANJA_INFORMAL;
          case "lao":
            return It.LAO;
          case "lower-armenian":
            return It.LOWER_ARMENIAN;
          case "malayalam":
            return It.MALAYALAM;
          case "mongolian":
            return It.MONGOLIAN;
          case "myanmar":
            return It.MYANMAR;
          case "oriya":
            return It.ORIYA;
          case "persian":
            return It.PERSIAN;
          case "simp-chinese-formal":
            return It.SIMP_CHINESE_FORMAL;
          case "simp-chinese-informal":
            return It.SIMP_CHINESE_INFORMAL;
          case "tamil":
            return It.TAMIL;
          case "telugu":
            return It.TELUGU;
          case "thai":
            return It.THAI;
          case "tibetan":
            return It.TIBETAN;
          case "trad-chinese-formal":
            return It.TRAD_CHINESE_FORMAL;
          case "trad-chinese-informal":
            return It.TRAD_CHINESE_INFORMAL;
          case "upper-armenian":
            return It.UPPER_ARMENIAN;
          case "disclosure-open":
            return It.DISCLOSURE_OPEN;
          case "disclosure-closed":
            return It.DISCLOSURE_CLOSED;
          default:
            return It.NONE;
        }
      }
    },
    we = function (A) {
      return {
        name: "margin-" + A,
        initialValue: "0",
        prefix: !1,
        type: 4
      };
    },
    Lt = we("top"),
    mt = we("right"),
    Dt = we("bottom"),
    bt = we("left");
  (we = yt = yt || {})[we.VISIBLE = 0] = "VISIBLE", we[we.HIDDEN = 1] = "HIDDEN", we[we.SCROLL = 2] = "SCROLL", we[we.CLIP = 3] = "CLIP";
  var Rt,
    Ot = {
      name: "overflow",
      initialValue: "visible",
      prefix: !(we[we.AUTO = 4] = "AUTO"),
      type: 1,
      parse: function (A, e) {
        return e.filter(kA).map(function (A) {
          switch (A.value) {
            case "hidden":
              return yt.HIDDEN;
            case "scroll":
              return yt.SCROLL;
            case "clip":
              return yt.CLIP;
            case "auto":
              return yt.AUTO;
            default:
              return yt.VISIBLE;
          }
        });
      }
    },
    St = {
      name: "overflow-wrap",
      initialValue: "normal",
      prefix: !1,
      type: 2,
      parse: function (A, e) {
        return "break-word" !== e ? "normal" : "break-word";
      }
    },
    we = function (A) {
      return {
        name: "padding-" + A,
        initialValue: "0",
        prefix: !1,
        type: 3,
        format: "length-percentage"
      };
    },
    Tt = we("top"),
    vt = we("right"),
    Mt = we("bottom"),
    Nt = we("left");
  (we = Rt = Rt || {})[we.LEFT = 0] = "LEFT", we[we.CENTER = 1] = "CENTER";
  var Gt,
    xt = {
      name: "text-align",
      initialValue: "left",
      prefix: !(we[we.RIGHT = 2] = "RIGHT"),
      type: 2,
      parse: function (A, e) {
        switch (e) {
          case "right":
            return Rt.RIGHT;
          case "center":
          case "justify":
            return Rt.CENTER;
          default:
            return Rt.LEFT;
        }
      }
    };
  (we = Gt = Gt || {})[we.STATIC = 0] = "STATIC", we[we.RELATIVE = 1] = "RELATIVE", we[we.ABSOLUTE = 2] = "ABSOLUTE", we[we.FIXED = 3] = "FIXED";
  var Vt,
    Pt = {
      name: "position",
      initialValue: "static",
      prefix: !(we[we.STICKY = 4] = "STICKY"),
      type: 2,
      parse: function (A, e) {
        switch (e) {
          case "relative":
            return Gt.RELATIVE;
          case "absolute":
            return Gt.ABSOLUTE;
          case "fixed":
            return Gt.FIXED;
          case "sticky":
            return Gt.STICKY;
        }
        return Gt.STATIC;
      }
    },
    kt = {
      name: "text-shadow",
      initialValue: "none",
      type: 1,
      prefix: !1,
      parse: function (n, A) {
        return 1 === A.length && XA(A[0], "none") ? [] : WA(A).map(function (A) {
          for (var e = {
              color: he.TRANSPARENT,
              offsetX: ne,
              offsetY: ne,
              blur: ne
            }, t = 0, B = 0; B < A.length; B++) {
            var r = A[B];
            ZA(r) ? (0 === t ? e.offsetX = r : 1 === t ? e.offsetY = r : e.blur = r, t++) : e.color = ae(n, r);
          }
          return e;
        });
      }
    };
  (we = Vt = Vt || {})[we.NONE = 0] = "NONE", we[we.LOWERCASE = 1] = "LOWERCASE", we[we.UPPERCASE = 2] = "UPPERCASE";
  var Jt,
    Xt = {
      name: "text-transform",
      initialValue: "none",
      prefix: !(we[we.CAPITALIZE = 3] = "CAPITALIZE"),
      type: 2,
      parse: function (A, e) {
        switch (e) {
          case "uppercase":
            return Vt.UPPERCASE;
          case "lowercase":
            return Vt.LOWERCASE;
          case "capitalize":
            return Vt.CAPITALIZE;
        }
        return Vt.NONE;
      }
    },
    _t = {
      name: "transform",
      initialValue: "none",
      prefix: !0,
      type: 0,
      parse: function (A, e) {
        if (20 === e.type && "none" === e.value) return null;
        if (18 !== e.type) return null;
        var t = Yt[e.name];
        if (void 0 === t) throw new Error('Attempting to parse an unsupported transform function "' + e.name + '"');
        return t(e.values);
      }
    },
    Yt = {
      matrix: function (A) {
        A = A.filter(function (A) {
          return 17 === A.type;
        }).map(function (A) {
          return A.number;
        });
        return 6 === A.length ? A : null;
      },
      matrix3d: function (A) {
        var e = A.filter(function (A) {
            return 17 === A.type;
          }).map(function (A) {
            return A.number;
          }),
          t = e[0],
          B = e[1];
        e[2], e[3];
        var r = e[4],
          n = e[5];
        e[6], e[7], e[8], e[9], e[10], e[11];
        var s = e[12],
          A = e[13];
        return e[14], e[15], 16 === e.length ? [t, B, r, n, s, A] : null;
      }
    },
    we = {
      type: 16,
      number: 50,
      flags: 4
    },
    Wt = [we, we],
    Zt = {
      name: "transform-origin",
      initialValue: "50% 50%",
      prefix: !0,
      type: 1,
      parse: function (A, e) {
        e = e.filter(qA);
        return 2 !== e.length ? Wt : [e[0], e[1]];
      }
    };
  (we = Jt = Jt || {})[we.VISIBLE = 0] = "VISIBLE", we[we.HIDDEN = 1] = "HIDDEN";
  var qt,
    jt = {
      name: "visible",
      initialValue: "none",
      prefix: !(we[we.COLLAPSE = 2] = "COLLAPSE"),
      type: 2,
      parse: function (A, e) {
        switch (e) {
          case "hidden":
            return Jt.HIDDEN;
          case "collapse":
            return Jt.COLLAPSE;
          default:
            return Jt.VISIBLE;
        }
      }
    };
  (we = qt = qt || {}).NORMAL = "normal", we.BREAK_ALL = "break-all";
  var zt,
    $t = {
      name: "word-break",
      initialValue: "normal",
      prefix: !(we.KEEP_ALL = "keep-all"),
      type: 2,
      parse: function (A, e) {
        switch (e) {
          case "break-all":
            return qt.BREAK_ALL;
          case "keep-all":
            return qt.KEEP_ALL;
          default:
            return qt.NORMAL;
        }
      }
    },
    AB = {
      name: "z-index",
      initialValue: "auto",
      prefix: !1,
      type: 0,
      parse: function (A, e) {
        if (20 === e.type) return {
          auto: !0,
          order: 0
        };
        if (PA(e)) return {
          auto: !1,
          order: e.number
        };
        throw new Error("Invalid z-index number parsed");
      }
    },
    eB = function (A, e) {
      if (15 === e.type) switch (e.unit.toLowerCase()) {
        case "s":
          return 1e3 * e.number;
        case "ms":
          return e.number;
      }
      throw new Error("Unsupported time type");
    },
    tB = {
      name: "opacity",
      initialValue: "1",
      type: 0,
      prefix: !1,
      parse: function (A, e) {
        return PA(e) ? e.number : 1;
      }
    },
    BB = {
      name: "text-decoration-color",
      initialValue: "transparent",
      prefix: !1,
      type: 3,
      format: "color"
    },
    rB = {
      name: "text-decoration-line",
      initialValue: "none",
      prefix: !1,
      type: 1,
      parse: function (A, e) {
        return e.filter(kA).map(function (A) {
          switch (A.value) {
            case "underline":
              return 1;
            case "overline":
              return 2;
            case "line-through":
              return 3;
            case "none":
              return 4;
          }
          return 0;
        }).filter(function (A) {
          return 0 !== A;
        });
      }
    },
    nB = {
      name: "font-family",
      initialValue: "",
      prefix: !1,
      type: 1,
      parse: function (A, e) {
        var t = [],
          B = [];
        return e.forEach(function (A) {
          switch (A.type) {
            case 20:
            case 0:
              t.push(A.value);
              break;
            case 17:
              t.push(A.number.toString());
              break;
            case 4:
              B.push(t.join(" ")), t.length = 0;
          }
        }), t.length && B.push(t.join(" ")), B.map(function (A) {
          return -1 === A.indexOf(" ") ? A : "'" + A + "'";
        });
      }
    },
    sB = {
      name: "font-size",
      initialValue: "0",
      prefix: !1,
      type: 3,
      format: "length"
    },
    oB = {
      name: "font-weight",
      initialValue: "normal",
      type: 0,
      prefix: !1,
      parse: function (A, e) {
        return PA(e) ? e.number : !kA(e) || "bold" !== e.value ? 400 : 700;
      }
    },
    iB = {
      name: "font-variant",
      initialValue: "none",
      type: 1,
      prefix: !1,
      parse: function (A, e) {
        return e.filter(kA).map(function (A) {
          return A.value;
        });
      }
    };
  (we = zt = zt || {}).NORMAL = "normal", we.ITALIC = "italic";
  function QB(A, e) {
    return 0 != (A & e);
  }
  function cB(A, e, t) {
    return (A = A && A[Math.min(e, A.length - 1)]) ? t ? A.open : A.close : "";
  }
  var aB,
    gB = {
      name: "font-style",
      initialValue: "normal",
      prefix: !(we.OBLIQUE = "oblique"),
      type: 2,
      parse: function (A, e) {
        switch (e) {
          case "oblique":
            return zt.OBLIQUE;
          case "italic":
            return zt.ITALIC;
          default:
            return zt.NORMAL;
        }
      }
    },
    wB = {
      name: "content",
      initialValue: "none",
      type: 1,
      prefix: !1,
      parse: function (A, e) {
        if (0 === e.length) return [];
        var t = e[0];
        return 20 === t.type && "none" === t.value ? [] : e;
      }
    },
    CB = {
      name: "counter-increment",
      initialValue: "none",
      prefix: !0,
      type: 1,
      parse: function (A, e) {
        if (0 === e.length) return null;
        var t = e[0];
        if (20 === t.type && "none" === t.value) return null;
        for (var B = [], r = e.filter(_A), n = 0; n < r.length; n++) {
          var s = r[n],
            o = r[n + 1];
          20 === s.type && (o = o && PA(o) ? o.number : 1, B.push({
            counter: s.value,
            increment: o
          }));
        }
        return B;
      }
    },
    UB = {
      name: "counter-reset",
      initialValue: "none",
      prefix: !0,
      type: 1,
      parse: function (A, e) {
        if (0 === e.length) return [];
        for (var t = [], B = e.filter(_A), r = 0; r < B.length; r++) {
          var n = B[r],
            s = B[r + 1];
          kA(n) && "none" !== n.value && (s = s && PA(s) ? s.number : 0, t.push({
            counter: n.value,
            reset: s
          }));
        }
        return t;
      }
    },
    lB = {
      name: "duration",
      initialValue: "0s",
      prefix: !1,
      type: 1,
      parse: function (e, A) {
        return A.filter(VA).map(function (A) {
          return eB(e, A);
        });
      }
    },
    FB = {
      name: "quotes",
      initialValue: "none",
      prefix: !0,
      type: 1,
      parse: function (A, e) {
        if (0 === e.length) return null;
        var t = e[0];
        if (20 === t.type && "none" === t.value) return null;
        var B = [],
          r = e.filter(JA);
        if (r.length % 2 != 0) return null;
        for (var n = 0; n < r.length; n += 2) {
          var s = r[n].value,
            o = r[n + 1].value;
          B.push({
            open: s,
            close: o
          });
        }
        return B;
      }
    },
    uB = {
      name: "box-shadow",
      initialValue: "none",
      type: 1,
      prefix: !1,
      parse: function (n, A) {
        return 1 === A.length && XA(A[0], "none") ? [] : WA(A).map(function (A) {
          for (var e = {
              color: 255,
              offsetX: ne,
              offsetY: ne,
              blur: ne,
              spread: ne,
              inset: !1
            }, t = 0, B = 0; B < A.length; B++) {
            var r = A[B];
            XA(r, "inset") ? e.inset = !0 : ZA(r) ? (0 === t ? e.offsetX = r : 1 === t ? e.offsetY = r : 2 === t ? e.blur = r : e.spread = r, t++) : e.color = ae(n, r);
          }
          return e;
        });
      }
    };
  (we = aB = aB || {})[we.FILL = 0] = "FILL", we[we.STROKE = 1] = "STROKE";
  var hB = {
      name: "paint-order",
      initialValue: "normal",
      prefix: !(we[we.MARKERS = 2] = "MARKERS"),
      type: 1,
      parse: function (A, e) {
        var t = [aB.FILL, aB.STROKE, aB.MARKERS],
          B = [];
        return e.filter(kA).forEach(function (A) {
          switch (A.value) {
            case "stroke":
              B.push(aB.STROKE);
              break;
            case "fill":
              B.push(aB.FILL);
              break;
            case "markers":
              B.push(aB.MARKERS);
          }
        }), t.forEach(function (A) {
          -1 === B.indexOf(A) && B.push(A);
        }), B;
      }
    },
    dB = {
      name: "-webkit-text-stroke-color",
      initialValue: "currentcolor",
      prefix: !1,
      type: 3,
      format: "color"
    },
    EB = {
      name: "-webkit-text-stroke-width",
      initialValue: "0",
      type: 0,
      prefix: !1,
      parse: function (A, e) {
        return VA(e) ? e.number : 0;
      }
    },
    HB = (fB.prototype.isVisible = function () {
      return 0 < this.display && 0 < this.opacity && this.visibility === Jt.VISIBLE;
    }, fB.prototype.isTransparent = function () {
      return ee(this.backgroundColor);
    }, fB.prototype.isTransformed = function () {
      return null !== this.transform;
    }, fB.prototype.isPositioned = function () {
      return this.position !== Gt.STATIC;
    }, fB.prototype.isPositionedWithZIndex = function () {
      return this.isPositioned() && !this.zIndex.auto;
    }, fB.prototype.isFloating = function () {
      return this.float !== Bt.NONE;
    }, fB.prototype.isInlineLevel = function () {
      return QB(this.display, 4) || QB(this.display, 33554432) || QB(this.display, 268435456) || QB(this.display, 536870912) || QB(this.display, 67108864) || QB(this.display, 134217728);
    }, fB);
  function fB(A, e) {
    this.animationDuration = yB(A, lB, e.animationDuration), this.backgroundClip = yB(A, ye, e.backgroundClip), this.backgroundColor = yB(A, Ke, e.backgroundColor), this.backgroundImage = yB(A, xe, e.backgroundImage), this.backgroundOrigin = yB(A, Ve, e.backgroundOrigin), this.backgroundPosition = yB(A, Pe, e.backgroundPosition), this.backgroundRepeat = yB(A, Je, e.backgroundRepeat), this.backgroundSize = yB(A, Ye, e.backgroundSize), this.borderTopColor = yB(A, Ze, e.borderTopColor), this.borderRightColor = yB(A, qe, e.borderRightColor), this.borderBottomColor = yB(A, je, e.borderBottomColor), this.borderLeftColor = yB(A, ze, e.borderLeftColor), this.borderTopLeftRadius = yB(A, $e, e.borderTopLeftRadius), this.borderTopRightRadius = yB(A, At, e.borderTopRightRadius), this.borderBottomRightRadius = yB(A, et, e.borderBottomRightRadius), this.borderBottomLeftRadius = yB(A, tt, e.borderBottomLeftRadius), this.borderTopStyle = yB(A, rt, e.borderTopStyle), this.borderRightStyle = yB(A, nt, e.borderRightStyle), this.borderBottomStyle = yB(A, st, e.borderBottomStyle), this.borderLeftStyle = yB(A, ot, e.borderLeftStyle), this.borderTopWidth = yB(A, it, e.borderTopWidth), this.borderRightWidth = yB(A, Qt, e.borderRightWidth), this.borderBottomWidth = yB(A, ct, e.borderBottomWidth), this.borderLeftWidth = yB(A, at, e.borderLeftWidth), this.boxShadow = yB(A, uB, e.boxShadow), this.color = yB(A, gt, e.color), this.direction = yB(A, wt, e.direction), this.display = yB(A, Ct, e.display), this.float = yB(A, ht, e.cssFloat), this.fontFamily = yB(A, nB, e.fontFamily), this.fontSize = yB(A, sB, e.fontSize), this.fontStyle = yB(A, gB, e.fontStyle), this.fontVariant = yB(A, iB, e.fontVariant), this.fontWeight = yB(A, oB, e.fontWeight), this.letterSpacing = yB(A, dt, e.letterSpacing), this.lineBreak = yB(A, Et, e.lineBreak), this.lineHeight = yB(A, Ht, e.lineHeight), this.listStyleImage = yB(A, ft, e.listStyleImage), this.listStylePosition = yB(A, pt, e.listStylePosition), this.listStyleType = yB(A, Kt, e.listStyleType), this.marginTop = yB(A, Lt, e.marginTop), this.marginRight = yB(A, mt, e.marginRight), this.marginBottom = yB(A, Dt, e.marginBottom), this.marginLeft = yB(A, bt, e.marginLeft), this.opacity = yB(A, tB, e.opacity);
    var t = yB(A, Ot, e.overflow);
    this.overflowX = t[0], this.overflowY = t[1 < t.length ? 1 : 0], this.overflowWrap = yB(A, St, e.overflowWrap), this.paddingTop = yB(A, Tt, e.paddingTop), this.paddingRight = yB(A, vt, e.paddingRight), this.paddingBottom = yB(A, Mt, e.paddingBottom), this.paddingLeft = yB(A, Nt, e.paddingLeft), this.paintOrder = yB(A, hB, e.paintOrder), this.position = yB(A, Pt, e.position), this.textAlign = yB(A, xt, e.textAlign), this.textDecorationColor = yB(A, BB, null !== (t = e.textDecorationColor) && void 0 !== t ? t : e.color), this.textDecorationLine = yB(A, rB, null !== (t = e.textDecorationLine) && void 0 !== t ? t : e.textDecoration), this.textShadow = yB(A, kt, e.textShadow), this.textTransform = yB(A, Xt, e.textTransform), this.transform = yB(A, _t, e.transform), this.transformOrigin = yB(A, Zt, e.transformOrigin), this.visibility = yB(A, jt, e.visibility), this.webkitTextStrokeColor = yB(A, dB, e.webkitTextStrokeColor), this.webkitTextStrokeWidth = yB(A, EB, e.webkitTextStrokeWidth), this.wordBreak = yB(A, $t, e.wordBreak), this.zIndex = yB(A, AB, e.zIndex);
  }
  for (var IB = function (A, e) {
      this.content = yB(A, wB, e.content), this.quotes = yB(A, FB, e.quotes);
    }, pB = function (A, e) {
      this.counterIncrement = yB(A, CB, e.counterIncrement), this.counterReset = yB(A, UB, e.counterReset);
    }, yB = function (A, e, t) {
      var B = new MA(),
        t = null != t ? t.toString() : e.initialValue;
      B.write(t);
      var r = new GA(B.read());
      switch (e.type) {
        case 2:
          var n = r.parseComponentValue();
          return e.parse(A, kA(n) ? n.value : e.initialValue);
        case 0:
          return e.parse(A, r.parseComponentValue());
        case 1:
          return e.parse(A, r.parseComponentValues());
        case 4:
          return r.parseComponentValue();
        case 3:
          switch (e.format) {
            case "angle":
              return Qe(A, r.parseComponentValue());
            case "color":
              return ae(A, r.parseComponentValue());
            case "image":
              return Me(A, r.parseComponentValue());
            case "length":
              var s = r.parseComponentValue();
              return ZA(s) ? s : ne;
            case "length-percentage":
              s = r.parseComponentValue();
              return qA(s) ? s : ne;
            case "time":
              return eB(A, r.parseComponentValue());
          }
      }
    }, KB = function (A, e) {
      A = function (A) {
        switch (A.getAttribute("data-html2canvasV1-debug")) {
          case "all":
            return 1;
          case "clone":
            return 2;
          case "parse":
            return 3;
          case "render":
            return 4;
          default:
            return 0;
        }
      }(A);
      return 1 === A || e === A;
    }, LB = function (A, e) {
      this.context = A, this.textNodes = [], this.elements = [], this.flags = 0, KB(e, 3), this.styles = new HB(A, window.getComputedStyle(e, null)), en(e) && (this.styles.animationDuration.some(function (A) {
        return 0 < A;
      }) && (e.style.animationDuration = "0s"), null !== this.styles.transform && (e.style.transform = "none")), this.bounds = E(this.context, e), KB(e, 4) && (this.flags |= 16);
    }, mB = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", DB = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), bB = 0; bB < mB.length; bB++) DB[mB.charCodeAt(bB)] = bB;
  function RB(A, e, t) {
    return A.slice ? A.slice(e, t) : new Uint16Array(Array.prototype.slice.call(A, e, t));
  }
  var OB = (SB.prototype.get = function (A) {
    var e;
    if (0 <= A) {
      if (A < 55296 || 56319 < A && A <= 65535) return e = this.index[A >> 5], this.data[e = (e << 2) + (31 & A)];
      if (A <= 65535) return e = this.index[2048 + (A - 55296 >> 5)], this.data[e = (e << 2) + (31 & A)];
      if (A < this.highStart) return e = this.index[e = 2080 + (A >> 11)], e = this.index[e += A >> 5 & 63], this.data[e = (e << 2) + (31 & A)];
      if (A <= 1114111) return this.data[this.highValueIndex];
    }
    return this.errorValue;
  }, SB);
  function SB(A, e, t, B, r, n) {
    this.initialValue = A, this.errorValue = e, this.highStart = t, this.highValueIndex = B, this.index = r, this.data = n;
  }
  for (var TB = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", vB = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), MB = 0; MB < TB.length; MB++) vB[TB.charCodeAt(MB)] = MB;
  function NB(A) {
    return zB.get(A);
  }
  function GB(A) {
    var t = function (A) {
        for (var e = [], t = 0, B = A.length; t < B;) {
          var r,
            n = A.charCodeAt(t++);
          55296 <= n && n <= 56319 && t < B ? 56320 == (64512 & (r = A.charCodeAt(t++))) ? e.push(((1023 & n) << 10) + (1023 & r) + 65536) : (e.push(n), t--) : e.push(n);
        }
        return e;
      }(A),
      B = t.length,
      r = 0,
      n = 0,
      s = t.map(NB);
    return {
      next: function () {
        if (B <= r) return {
          done: !0,
          value: null
        };
        for (var A = $B; r < B && (A = function (A, e) {
          var t = e - 2,
            B = A[t],
            r = A[e - 1],
            e = A[e];
          if (2 === r && 3 === e) return $B;
          if (2 === r || 3 === r || 4 === r) return "÷";
          if (2 === e || 3 === e || 4 === e) return "÷";
          if (r === WB && -1 !== [WB, ZB, qB, jB].indexOf(e)) return $B;
          if (!(r !== qB && r !== ZB || e !== ZB && 10 !== e)) return $B;
          if ((r === jB || 10 === r) && 10 === e) return $B;
          if (13 === e || 5 === e) return $B;
          if (7 === e) return $B;
          if (1 === r) return $B;
          if (13 === r && 14 === e) {
            for (; 5 === B;) B = A[--t];
            if (14 === B) return $B;
          }
          if (15 === r && 15 === e) {
            for (var n = 0; 15 === B;) n++, B = A[--t];
            if (n % 2 == 0) return $B;
          }
          return "÷";
        }(s, ++r)) === $B;);
        if (A === $B && r !== B) return {
          done: !0,
          value: null
        };
        var e = function () {
          for (var A = [], e = 0; e < arguments.length; e++) A[e] = arguments[e];
          if (String.fromCodePoint) return String.fromCodePoint.apply(String, A);
          var t = A.length;
          if (!t) return "";
          for (var B = [], r = -1, n = ""; ++r < t;) {
            var s = A[r];
            s <= 65535 ? B.push(s) : (s -= 65536, B.push(55296 + (s >> 10), s % 1024 + 56320)), (r + 1 === t || 16384 < B.length) && (n += String.fromCharCode.apply(String, B), B.length = 0);
          }
          return n;
        }.apply(null, t.slice(n, r));
        return n = r, {
          value: e,
          done: !1
        };
      }
    };
  }
  function xB(A) {
    for (var e, t = GB(A), B = []; !(e = t.next()).done;) e.value && B.push(e.value.slice());
    return B;
  }
  function VB(A) {
    return 0 === A[0] && 255 === A[1] && 0 === A[2] && 255 === A[3];
  }
  var PB,
    kB,
    JB,
    XB,
    _B,
    YB,
    WB = 8,
    ZB = 9,
    qB = 11,
    jB = 12,
    zB = (JB = function (A) {
      var e,
        t,
        B,
        r,
        n = .75 * A.length,
        s = A.length,
        o = 0;
      "=" === A[A.length - 1] && (n--, "=" === A[A.length - 2] && n--);
      for (var n = new ("undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array && void 0 !== Uint8Array.prototype.slice ? ArrayBuffer : Array)(n), i = Array.isArray(n) ? n : new Uint8Array(n), Q = 0; Q < s; Q += 4) e = DB[A.charCodeAt(Q)], t = DB[A.charCodeAt(Q + 1)], B = DB[A.charCodeAt(Q + 2)], r = DB[A.charCodeAt(Q + 3)], i[o++] = e << 2 | t >> 4, i[o++] = (15 & t) << 4 | B >> 2, i[o++] = (3 & B) << 6 | 63 & r;
      return n;
    }(PB = "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"), XB = Array.isArray(JB) ? function (A) {
      for (var e = A.length, t = [], B = 0; B < e; B += 4) t.push(A[B + 3] << 24 | A[B + 2] << 16 | A[B + 1] << 8 | A[B]);
      return t;
    }(JB) : new Uint32Array(JB), _B = Array.isArray(JB) ? function (A) {
      for (var e = A.length, t = [], B = 0; B < e; B += 2) t.push(A[B + 1] << 8 | A[B]);
      return t;
    }(JB) : new Uint16Array(JB), PB = RB(_B, 12, XB[4] / 2), kB = 2 === XB[5] ? RB(_B, (24 + XB[4]) / 2) : (JB = XB, _B = Math.ceil((24 + XB[4]) / 4), JB.slice ? JB.slice(_B, kB) : new Uint32Array(Array.prototype.slice.call(JB, _B, kB))), new OB(XB[0], XB[1], XB[2], XB[3], PB, kB)),
    $B = "×",
    Ar = function (A, e, t, B, r) {
      var n = "http://www.w3.org/2000/svg",
        s = document.createElementNS(n, "svg"),
        n = document.createElementNS(n, "foreignObject");
      return s.setAttributeNS(null, "width", A.toString()), s.setAttributeNS(null, "height", e.toString()), n.setAttributeNS(null, "width", "100%"), n.setAttributeNS(null, "height", "100%"), n.setAttributeNS(null, "x", t.toString()), n.setAttributeNS(null, "y", B.toString()), n.setAttributeNS(null, "externalResourcesRequired", "true"), s.appendChild(n), n.appendChild(r), s;
    },
    er = function (B) {
      return new Promise(function (A, e) {
        var t = new Image();
        t.onload = function () {
          return A(t);
        }, t.onerror = e, t.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(B));
      });
    },
    tr = {
      get SUPPORT_RANGE_BOUNDS() {
        var A = function (A) {
          if (A.createRange) {
            var e = A.createRange();
            if (e.getBoundingClientRect) {
              var t = A.createElement("boundtest");
              t.style.height = "123px", t.style.display = "block", A.body.appendChild(t), e.selectNode(t);
              e = e.getBoundingClientRect(), e = Math.round(e.height);
              if (A.body.removeChild(t), 123 === e) return !0;
            }
          }
          return !1;
        }(document);
        return Object.defineProperty(tr, "SUPPORT_RANGE_BOUNDS", {
          value: A
        }), A;
      },
      get SUPPORT_WORD_BREAKING() {
        var A = tr.SUPPORT_RANGE_BOUNDS && function (A) {
          var e = A.createElement("boundtest");
          e.style.width = "50px", e.style.display = "block", e.style.fontSize = "12px", e.style.letterSpacing = "0px", e.style.wordSpacing = "0px", A.body.appendChild(e);
          var B = A.createRange();
          e.innerHTML = "function" == typeof "".repeat ? "&#128104;".repeat(10) : "";
          var r = e.firstChild,
            t = Q(r.data).map(function (A) {
              return g(A);
            }),
            n = 0,
            s = {},
            t = t.every(function (A, e) {
              B.setStart(r, n), B.setEnd(r, n + A.length);
              var t = B.getBoundingClientRect();
              n += A.length;
              A = t.x > s.x || t.y > s.y;
              return s = t, 0 === e || A;
            });
          return A.body.removeChild(e), t;
        }(document);
        return Object.defineProperty(tr, "SUPPORT_WORD_BREAKING", {
          value: A
        }), A;
      },
      get SUPPORT_SVG_DRAWING() {
        var A = function (A) {
          var e = new Image(),
            t = A.createElement("canvas"),
            A = t.getContext("2d");
          if (!A) return !1;
          e.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
          try {
            A.drawImage(e, 0, 0), t.toDataURL();
          } catch (A) {
            return !1;
          }
          return !0;
        }(document);
        return Object.defineProperty(tr, "SUPPORT_SVG_DRAWING", {
          value: A
        }), A;
      },
      get SUPPORT_FOREIGNOBJECT_DRAWING() {
        var A = "function" == typeof Array.from && "function" == typeof window.fetch ? function (t) {
          var A = t.createElement("canvas"),
            B = 100;
          A.width = B, A.height = B;
          var r = A.getContext("2d");
          if (!r) return Promise.reject(!1);
          r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, B, B);
          var e = new Image(),
            n = A.toDataURL();
          e.src = n;
          e = Ar(B, B, 0, 0, e);
          return r.fillStyle = "red", r.fillRect(0, 0, B, B), er(e).then(function (A) {
            r.drawImage(A, 0, 0);
            var e = r.getImageData(0, 0, B, B).data;
            r.fillStyle = "red", r.fillRect(0, 0, B, B);
            A = t.createElement("div");
            return A.style.backgroundImage = "url(" + n + ")", A.style.height = "100px", VB(e) ? er(Ar(B, B, 0, 0, A)) : Promise.reject(!1);
          }).then(function (A) {
            return r.drawImage(A, 0, 0), VB(r.getImageData(0, 0, B, B).data);
          }).catch(function () {
            return !1;
          });
        }(document) : Promise.resolve(!1);
        return Object.defineProperty(tr, "SUPPORT_FOREIGNOBJECT_DRAWING", {
          value: A
        }), A;
      },
      get SUPPORT_CORS_IMAGES() {
        var A = void 0 !== new Image().crossOrigin;
        return Object.defineProperty(tr, "SUPPORT_CORS_IMAGES", {
          value: A
        }), A;
      },
      get SUPPORT_RESPONSE_TYPE() {
        var A = "string" == typeof new XMLHttpRequest().responseType;
        return Object.defineProperty(tr, "SUPPORT_RESPONSE_TYPE", {
          value: A
        }), A;
      },
      get SUPPORT_CORS_XHR() {
        var A = ("withCredentials" in new XMLHttpRequest());
        return Object.defineProperty(tr, "SUPPORT_CORS_XHR", {
          value: A
        }), A;
      }
    },
    Br = function (A, e) {
      this.text = A, this.bounds = e;
    },
    rr = function (A, e) {
      var t = e.ownerDocument;
      if (t) {
        var B = t.createElement("html2canvasV1wrapper");
        B.appendChild(e.cloneNode(!0));
        t = e.parentNode;
        if (t) {
          t.replaceChild(B, e);
          A = E(A, B);
          return B.firstChild && t.replaceChild(B.firstChild, B), A;
        }
      }
      return d.EMPTY;
    },
    nr = function (A, e, t) {
      var B = A.ownerDocument;
      if (!B) throw new Error("Node has no owner document");
      B = B.createRange();
      return B.setStart(A, e), B.setEnd(A, e + t), B;
    },
    sr = function (A, e, t, B) {
      return d.fromClientRect(A, nr(e, t, B).getBoundingClientRect());
    },
    or = function (A, e) {
      return 0 !== e.letterSpacing ? xB(A) : Qr(A, e);
    },
    ir = [32, 160, 4961, 65792, 65793, 4153, 4241],
    Qr = function (A, e) {
      for (var t, B = oA(A, {
          lineBreak: e.lineBreak,
          wordBreak: "break-word" === e.overflowWrap ? "break-word" : e.wordBreak
        }), r = []; !(t = B.next()).done;) !function () {
        var A, e;
        t.value && (A = t.value.slice(), A = Q(A), e = "", A.forEach(function (A) {
          -1 === ir.indexOf(A) ? e += g(A) : (e.length && r.push(e), r.push(g(A)), e = "");
        }), e.length && r.push(e));
      }();
      return r;
    },
    cr = function (A, e, t) {
      var B, r, n, s, o;
      this.text = ar(e.data, t.textTransform), this.textBounds = (B = A, A = this.text, n = e, A = or(A, r = t), s = [], o = 0, A.forEach(function (A) {
        var e;
        r.textDecorationLine.length || 0 < A.trim().length ? tr.SUPPORT_RANGE_BOUNDS ? tr.SUPPORT_WORD_BREAKING ? s.push(new Br(A, sr(B, n, o, A.length))) : s.push(new Br(A, d.fromDOMRectList(B, nr(n, o, A.length).getClientRects()))) : (e = n.splitText(A.length), s.push(new Br(A, rr(B, n))), n = e) : tr.SUPPORT_RANGE_BOUNDS || (n = n.splitText(A.length)), o += A.length;
      }), s);
    },
    ar = function (A, e) {
      switch (e) {
        case Vt.LOWERCASE:
          return A.toLowerCase();
        case Vt.CAPITALIZE:
          return A.replace(gr, wr);
        case Vt.UPPERCASE:
          return A.toUpperCase();
        default:
          return A;
      }
    },
    gr = /(^|\s|:|-|\(|\))([a-z])/g,
    wr = function (A, e, t) {
      return 0 < A.length ? e + t.toUpperCase() : A;
    },
    Cr = (A(Ur, YB = LB), Ur);
  function Ur(A, e) {
    A = YB.call(this, A, e) || this;
    return A.src = e.currentSrc || e.src, A.intrinsicWidth = e.naturalWidth, A.intrinsicHeight = e.naturalHeight, A.context.cache.addImage(A.src), A;
  }
  var lr,
    Fr = (A(ur, lr = LB), ur);
  function ur(A, e) {
    A = lr.call(this, A, e) || this;
    return A.canvas = e, A.intrinsicWidth = e.width, A.intrinsicHeight = e.height, A;
  }
  var hr,
    dr = (A(Er, hr = LB), Er);
  function Er(A, e) {
    var t = hr.call(this, A, e) || this,
      B = new XMLSerializer(),
      A = E(A, e);
    return e.setAttribute("width", A.width + "px"), e.setAttribute("height", A.height + "px"), t.svg = "data:image/svg+xml," + encodeURIComponent(B.serializeToString(e)), t.intrinsicWidth = e.width.baseVal.value, t.intrinsicHeight = e.height.baseVal.value, t.context.cache.addImage(t.svg), t;
  }
  var Hr,
    fr = (A(Ir, Hr = LB), Ir);
  function Ir(A, e) {
    A = Hr.call(this, A, e) || this;
    return A.value = e.value, A;
  }
  var pr,
    yr = (A(Kr, pr = LB), Kr);
  function Kr(A, e) {
    A = pr.call(this, A, e) || this;
    return A.start = e.start, A.reversed = "boolean" == typeof e.reversed && !0 === e.reversed, A;
  }
  var Lr,
    mr = [{
      type: 15,
      flags: 0,
      unit: "px",
      number: 3
    }],
    Dr = [{
      type: 16,
      flags: 0,
      number: 50
    }],
    br = "checkbox",
    Rr = "radio",
    Or = "password",
    Sr = 707406591,
    Tr = (A(vr, Lr = LB), vr);
  function vr(A, e) {
    var t = Lr.call(this, A, e) || this;
    switch (t.type = e.type.toLowerCase(), t.checked = e.checked, t.value = 0 === (e = (A = e).type === Or ? new Array(A.value.length + 1).join("•") : A.value).length ? A.placeholder || "" : e, t.type !== br && t.type !== Rr || (t.styles.backgroundColor = 3739148031, t.styles.borderTopColor = t.styles.borderRightColor = t.styles.borderBottomColor = t.styles.borderLeftColor = 2779096575, t.styles.borderTopWidth = t.styles.borderRightWidth = t.styles.borderBottomWidth = t.styles.borderLeftWidth = 1, t.styles.borderTopStyle = t.styles.borderRightStyle = t.styles.borderBottomStyle = t.styles.borderLeftStyle = _e.SOLID, t.styles.backgroundClip = [le.BORDER_BOX], t.styles.backgroundOrigin = [0], t.bounds = (e = t.bounds).width > e.height ? new d(e.left + (e.width - e.height) / 2, e.top, e.height, e.height) : e.width < e.height ? new d(e.left, e.top + (e.height - e.width) / 2, e.width, e.width) : e), t.type) {
      case br:
        t.styles.borderTopRightRadius = t.styles.borderTopLeftRadius = t.styles.borderBottomRightRadius = t.styles.borderBottomLeftRadius = mr;
        break;
      case Rr:
        t.styles.borderTopRightRadius = t.styles.borderTopLeftRadius = t.styles.borderBottomRightRadius = t.styles.borderBottomLeftRadius = Dr;
    }
    return t;
  }
  var Mr,
    Nr = (A(Gr, Mr = LB), Gr);
  function Gr(A, e) {
    A = Mr.call(this, A, e) || this, e = e.options[e.selectedIndex || 0];
    return A.value = e && e.text || "", A;
  }
  var xr,
    Vr = (A(Pr, xr = LB), Pr);
  function Pr(A, e) {
    A = xr.call(this, A, e) || this;
    return A.value = e.value, A;
  }
  var kr,
    Jr = (A(Xr, kr = LB), Xr);
  function Xr(A, e) {
    var t,
      B,
      r = kr.call(this, A, e) || this;
    r.src = e.src, r.width = parseInt(e.width, 10) || 0, r.height = parseInt(e.height, 10) || 0, r.backgroundColor = r.styles.backgroundColor;
    try {
      e.contentWindow && e.contentWindow.document && e.contentWindow.document.documentElement && (r.tree = qr(A, e.contentWindow.document.documentElement), t = e.contentWindow.document.documentElement ? Ue(A, getComputedStyle(e.contentWindow.document.documentElement).backgroundColor) : he.TRANSPARENT, B = e.contentWindow.document.body ? Ue(A, getComputedStyle(e.contentWindow.document.body).backgroundColor) : he.TRANSPARENT, r.backgroundColor = ee(t) ? ee(B) ? r.styles.backgroundColor : B : t);
    } catch (A) {}
    return r;
  }
  function _r(A) {
    return "STYLE" === A.tagName;
  }
  var Yr = ["OL", "UL", "MENU"],
    Wr = function (e, A, t, B) {
      for (var r = A.firstChild; r; r = s) {
        var n,
          s = r.nextSibling;
        $r(r) && 0 < r.data.trim().length ? t.textNodes.push(new cr(e, r, t.styles)) : An(r) && (Cn(r) && r.assignedNodes ? r.assignedNodes().forEach(function (A) {
          return Wr(e, A, t, B);
        }) : (n = Zr(e, r)).styles.isVisible() && (jr(r, n, B) ? n.flags |= 4 : zr(n.styles) && (n.flags |= 2), -1 !== Yr.indexOf(r.tagName) && (n.flags |= 8), t.elements.push(n), r.slot, r.shadowRoot ? Wr(e, r.shadowRoot, n, B) : gn(r) || sn(r) || wn(r) || Wr(e, r, n, B)));
      }
    },
    Zr = function (A, e) {
      return new (cn(e) ? Cr : Qn(e) ? Fr : sn(e) ? dr : Bn(e) ? fr : rn(e) ? yr : nn(e) ? Tr : wn(e) ? Nr : gn(e) ? Vr : an(e) ? Jr : LB)(A, e);
    },
    qr = function (A, e) {
      var t = Zr(A, e);
      return t.flags |= 4, Wr(A, e, t, t), t;
    },
    jr = function (A, e, t) {
      return e.styles.isPositionedWithZIndex() || e.styles.opacity < 1 || e.styles.isTransformed() || on(A) && t.styles.isTransparent();
    },
    zr = function (A) {
      return A.isPositioned() || A.isFloating();
    },
    $r = function (A) {
      return A.nodeType === Node.TEXT_NODE;
    },
    An = function (A) {
      return A.nodeType === Node.ELEMENT_NODE;
    },
    en = function (A) {
      return An(A) && void 0 !== A.style && !tn(A);
    },
    tn = function (A) {
      return "object" == typeof A.className;
    },
    Bn = function (A) {
      return "LI" === A.tagName;
    },
    rn = function (A) {
      return "OL" === A.tagName;
    },
    nn = function (A) {
      return "INPUT" === A.tagName;
    },
    sn = function (A) {
      return "svg" === A.tagName;
    },
    on = function (A) {
      return "BODY" === A.tagName;
    },
    Qn = function (A) {
      return "CANVAS" === A.tagName;
    },
    cn = function (A) {
      return "IMG" === A.tagName;
    },
    an = function (A) {
      return "IFRAME" === A.tagName;
    },
    gn = function (A) {
      return "TEXTAREA" === A.tagName;
    },
    wn = function (A) {
      return "SELECT" === A.tagName;
    },
    Cn = function (A) {
      return "SLOT" === A.tagName;
    },
    Un = (ln.prototype.getCounterValue = function (A) {
      A = this.counters[A];
      return A && A.length ? A[A.length - 1] : 1;
    }, ln.prototype.getCounterValues = function (A) {
      A = this.counters[A];
      return A || [];
    }, ln.prototype.pop = function (A) {
      var e = this;
      A.forEach(function (A) {
        return e.counters[A].pop();
      });
    }, ln.prototype.parse = function (A) {
      var t = this,
        e = A.counterIncrement,
        A = A.counterReset,
        B = !0;
      null !== e && e.forEach(function (A) {
        var e = t.counters[A.counter];
        e && 0 !== A.increment && (B = !1, e.length || e.push(1), e[Math.max(0, e.length - 1)] += A.increment);
      });
      var r = [];
      return B && A.forEach(function (A) {
        var e = t.counters[A.counter];
        r.push(A.counter), (e = e || (t.counters[A.counter] = [])).push(A.reset);
      }), r;
    }, ln);
  function ln() {
    this.counters = {};
  }
  function Fn(B, A, e, r, t, n) {
    return B < A || e < B ? Ln(B, t, 0 < n.length) : r.integers.reduce(function (A, e, t) {
      for (; e <= B;) B -= e, A += r.values[t];
      return A;
    }, "") + n;
  }
  function un(A, e, t, B) {
    for (var r = ""; t || A--, r = B(A) + r, e <= (A /= e) * e;);
    return r;
  }
  function hn(A, e, t, B, r) {
    var n = t - e + 1;
    return (A < 0 ? "-" : "") + (un(Math.abs(A), n, B, function (A) {
      return g(Math.floor(A % n) + e);
    }) + r);
  }
  function dn(A, e, t) {
    void 0 === t && (t = ". ");
    var B = e.length;
    return un(Math.abs(A), B, !1, function (A) {
      return e[Math.floor(A % B)];
    }) + t;
  }
  function En(A, e, t, B, r, n) {
    if (A < -9999 || 9999 < A) return Ln(A, It.CJK_DECIMAL, 0 < r.length);
    var s = Math.abs(A),
      o = r;
    if (0 === s) return e[0] + o;
    for (var i = 0; 0 < s && i <= 4; i++) {
      var Q = s % 10;
      0 == Q && QB(n, 1) && "" !== o ? o = e[Q] + o : 1 < Q || 1 == Q && 0 === i || 1 == Q && 1 === i && QB(n, 2) || 1 == Q && 1 === i && QB(n, 4) && 100 < A || 1 == Q && 1 < i && QB(n, 8) ? o = e[Q] + (0 < i ? t[i - 1] : "") + o : 1 == Q && 0 < i && (o = t[i - 1] + o), s = Math.floor(s / 10);
    }
    return (A < 0 ? B : "") + o;
  }
  var Hn,
    fn = {
      integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
      values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
    },
    In = {
      integers: [9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      values: ["Ք", "Փ", "Ւ", "Ց", "�?", "�?", "Վ", "�?", "Ռ", "Ջ", "Պ", "Չ", "Ո", "Շ", "Ն", "Յ", "Մ", "Ճ", "Ղ", "�?", "Հ", "Կ", "Ծ", "Խ", "Լ", "Ի", "Ժ", "Թ", "Ը", "Է", "Զ", "Ե", "Դ", "Գ", "Բ", "Ա"]
    },
    pn = {
      integers: [1e4, 9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      values: ["י׳", "ט׳", "ח׳", "ז׳", "ו׳", "ה׳", "ד׳", "ג׳", "ב׳", "�?׳", "ת", "ש", "ר", "ק", "צ", "פ", "ע", "ס", "נ", "מ", "ל", "כ", "יט", "יח", "יז", "טז", "טו", "י", "ט", "ח", "ז", "ו", "ה", "ד", "ג", "ב", "�?"]
    },
    yn = {
      integers: [1e4, 9e3, 8e3, 7e3, 6e3, 5e3, 4e3, 3e3, 2e3, 1e3, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      values: ["ჵ", "ჰ", "ჯ", "ჴ", "ხ", "ჭ", "წ", "ძ", "ც", "ჩ", "შ", "ყ", "ღ", "ქ", "ფ", "ჳ", "ტ", "ს", "რ", "ჟ", "პ", "�?", "ჲ", "ნ", "მ", "ლ", "კ", "ი", "თ", "ჱ", "ზ", "ვ", "ე", "დ", "გ", "ბ", "�?"]
    },
    Kn = "마�?�너스",
    Ln = function (A, e, t) {
      var B = t ? ". " : "",
        r = t ? "�?" : "",
        n = t ? ", " : "",
        s = t ? " " : "";
      switch (e) {
        case It.DISC:
          return "•" + s;
        case It.CIRCLE:
          return "◦" + s;
        case It.SQUARE:
          return "◾" + s;
        case It.DECIMAL_LEADING_ZERO:
          var o = hn(A, 48, 57, !0, B);
          return o.length < 4 ? "0" + o : o;
        case It.CJK_DECIMAL:
          return dn(A, "〇一二三四五六七八�?", r);
        case It.LOWER_ROMAN:
          return Fn(A, 1, 3999, fn, It.DECIMAL, B).toLowerCase();
        case It.UPPER_ROMAN:
          return Fn(A, 1, 3999, fn, It.DECIMAL, B);
        case It.LOWER_GREEK:
          return hn(A, 945, 969, !1, B);
        case It.LOWER_ALPHA:
          return hn(A, 97, 122, !1, B);
        case It.UPPER_ALPHA:
          return hn(A, 65, 90, !1, B);
        case It.ARABIC_INDIC:
          return hn(A, 1632, 1641, !0, B);
        case It.ARMENIAN:
        case It.UPPER_ARMENIAN:
          return Fn(A, 1, 9999, In, It.DECIMAL, B);
        case It.LOWER_ARMENIAN:
          return Fn(A, 1, 9999, In, It.DECIMAL, B).toLowerCase();
        case It.BENGALI:
          return hn(A, 2534, 2543, !0, B);
        case It.CAMBODIAN:
        case It.KHMER:
          return hn(A, 6112, 6121, !0, B);
        case It.CJK_EARTHLY_BRANCH:
          return dn(A, "�?丑寅�?�辰巳�?�未申酉戌亥", r);
        case It.CJK_HEAVENLY_STEM:
          return dn(A, "甲乙丙�?戊己庚辛壬癸", r);
        case It.CJK_IDEOGRAPHIC:
        case It.TRAD_CHINESE_INFORMAL:
          return En(A, "零一二三四五六七八�?", "�??百�?��?�", "負", r, 14);
        case It.TRAD_CHINESE_FORMAL:
          return En(A, "零壹貳�?�肆�?陸柒�?�玖", "拾佰仟�?�", "負", r, 15);
        case It.SIMP_CHINESE_INFORMAL:
          return En(A, "零一二三四五六七八�?", "�??百�?��?�", "负", r, 14);
        case It.SIMP_CHINESE_FORMAL:
          return En(A, "零壹贰�??肆�?陆柒�?�玖", "拾佰仟�?�", "负", r, 15);
        case It.JAPANESE_INFORMAL:
          return En(A, "〇一二三四五六七八�?", "�??百�?�万", "マイナス", r, 0);
        case It.JAPANESE_FORMAL:
          return En(A, "零壱�?�?�四�?六七八�?", "拾百�?�万", "マイナス", r, 7);
        case It.KOREAN_HANGUL_FORMAL:
          return En(A, "�?�?��?�삼사오육칠팔구", "십백천만", Kn, n, 7);
        case It.KOREAN_HANJA_INFORMAL:
          return En(A, "零一二三四五六七八�?", "�??百�?��?�", Kn, n, 0);
        case It.KOREAN_HANJA_FORMAL:
          return En(A, "零壹貳�?�四五六七八�?", "拾百�?�", Kn, n, 7);
        case It.DEVANAGARI:
          return hn(A, 2406, 2415, !0, B);
        case It.GEORGIAN:
          return Fn(A, 1, 19999, yn, It.DECIMAL, B);
        case It.GUJARATI:
          return hn(A, 2790, 2799, !0, B);
        case It.GURMUKHI:
          return hn(A, 2662, 2671, !0, B);
        case It.HEBREW:
          return Fn(A, 1, 10999, pn, It.DECIMAL, B);
        case It.HIRAGANA:
          return dn(A, "�?��?��?��?��?��?��??�??�?��?��?��?��?��?��??�?��?��?��?��?��?��?��?��?��?��?��?��?��?��?��?��?�む�?もやゆよらりるれ�?�?�?ゑをん");
        case It.HIRAGANA_IROHA:
          return dn(A, "�?��?�?��?��?��?��?��?�り�?�るを�?�?�よ�?�れ�??�?��?��?�らむ�?��?�?��?��??や�?��?��?��?��?��?��?��?��??ゆ�?�?��?�ゑ�?�も�?��?�");
        case It.KANNADA:
          return hn(A, 3302, 3311, !0, B);
        case It.KATAKANA:
          return dn(A, "アイウエオカキクケコサシスセソタ�?ツテトナニヌ�?ノ�?ヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", r);
        case It.KATAKANA_IROHA:
          return dn(A, "イロ�?ニホヘト�?リヌルヲワカヨタレソツ�?ナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", r);
        case It.LAO:
          return hn(A, 3792, 3801, !0, B);
        case It.MONGOLIAN:
          return hn(A, 6160, 6169, !0, B);
        case It.MYANMAR:
          return hn(A, 4160, 4169, !0, B);
        case It.ORIYA:
          return hn(A, 2918, 2927, !0, B);
        case It.PERSIAN:
          return hn(A, 1776, 1785, !0, B);
        case It.TAMIL:
          return hn(A, 3046, 3055, !0, B);
        case It.TELUGU:
          return hn(A, 3174, 3183, !0, B);
        case It.THAI:
          return hn(A, 3664, 3673, !0, B);
        case It.TIBETAN:
          return hn(A, 3872, 3881, !0, B);
        default:
          It.DECIMAL;
          return hn(A, 48, 57, !0, B);
      }
    },
    mn = "data-html2canvasV1-ignore",
    Dn = (bn.prototype.toIFrame = function (A, B) {
      var e = this,
        r = On(A, B);
      if (!r.contentWindow) return Promise.reject("Unable to find iframe window");
      var t = A.defaultView.pageXOffset,
        n = A.defaultView.pageYOffset,
        s = r.contentWindow,
        o = s.document,
        A = Tn(r).then(function () {
          return a(e, void 0, void 0, function () {
            var e, t;
            return H(this, function (A) {
              switch (A.label) {
                case 0:
                  return this.scrolledElements.forEach(xn), s && (s.scrollTo(B.left, B.top), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || s.scrollY === B.top && s.scrollX === B.left || (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(s.scrollX - B.left, s.scrollY - B.top, 0, 0))), e = this.options.onclone, void 0 === (t = this.clonedReferenceElement) ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : o.fonts && o.fonts.ready ? [4, o.fonts.ready] : [3, 2];
                case 1:
                  A.sent(), A.label = 2;
                case 2:
                  return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, Sn(o)] : [3, 4];
                case 3:
                  A.sent(), A.label = 4;
                case 4:
                  return "function" == typeof e ? [2, Promise.resolve().then(function () {
                    return e(o, t);
                  }).then(function () {
                    return r;
                  })] : [2, r];
              }
            });
          });
        });
      return o.open(), o.write(Nn(document.doctype) + "<html></html>"), Gn(this.referenceElement.ownerDocument, t, n), o.replaceChild(o.adoptNode(this.documentElement), o.documentElement), o.close(), A;
    }, bn.prototype.createElementClone = function (A) {
      if (KB(A, 2), Qn(A)) return this.createCanvasClone(A);
      if (_r(A)) return this.createStyleClone(A);
      var e = A.cloneNode(!1);
      return cn(e) && (cn(A) && A.currentSrc && A.currentSrc !== A.src && (e.src = A.currentSrc, e.srcset = ""), "lazy" === e.loading && (e.loading = "eager")), e;
    }, bn.prototype.createStyleClone = function (A) {
      try {
        var e = A.sheet;
        if (e && e.cssRules) {
          var t = [].slice.call(e.cssRules, 0).reduce(function (A, e) {
              return e && "string" == typeof e.cssText ? A + e.cssText : A;
            }, ""),
            B = A.cloneNode(!1);
          return B.textContent = t, B;
        }
      } catch (A) {
        if (this.context.logger.error("Unable to access cssRules property", A), "SecurityError" !== A.name) throw A;
      }
      return A.cloneNode(!1);
    }, bn.prototype.createCanvasClone = function (e) {
      var A;
      if (this.options.inlineImages && e.ownerDocument) {
        var t = e.ownerDocument.createElement("img");
        try {
          return t.src = e.toDataURL(), t;
        } catch (A) {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", e);
        }
      }
      t = e.cloneNode(!1);
      try {
        t.width = e.width, t.height = e.height;
        var B,
          r,
          n = e.getContext("2d"),
          s = t.getContext("2d");
        return s && (!this.options.allowTaint && n ? s.putImageData(n.getImageData(0, 0, e.width, e.height), 0, 0) : (!(B = null !== (A = e.getContext("webgl2")) && void 0 !== A ? A : e.getContext("webgl")) || !1 === (null == (r = B.getContextAttributes()) ? void 0 : r.preserveDrawingBuffer) && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", e), s.drawImage(e, 0, 0))), t;
      } catch (A) {
        this.context.logger.info("Unable to clone canvas as it is tainted", e);
      }
      return t;
    }, bn.prototype.cloneNode = function (A) {
      if ($r(A)) return document.createTextNode(A.data);
      if (!A.ownerDocument) return A.cloneNode(!1);
      var e = A.ownerDocument.defaultView;
      if (e && An(A) && (en(A) || tn(A))) {
        var t = this.createElementClone(A);
        t.style.transitionProperty = "none";
        var B = e.getComputedStyle(A),
          r = e.getComputedStyle(A, ":before"),
          n = e.getComputedStyle(A, ":after");
        this.referenceElement === A && en(t) && (this.clonedReferenceElement = t), on(t) && Jn(t);
        for (var e = this.counters.parse(new pB(this.context, B)), r = this.resolvePseudoContent(A, t, r, Hn.BEFORE), s = A.firstChild; s; s = s.nextSibling) An(s) && ("SCRIPT" === s.tagName || s.hasAttribute(mn) || "function" == typeof this.options.ignoreElements && this.options.ignoreElements(s)) || this.options.copyStyles && An(s) && _r(s) || t.appendChild(this.cloneNode(s));
        r && t.insertBefore(r, t.firstChild);
        n = this.resolvePseudoContent(A, t, n, Hn.AFTER);
        return n && t.appendChild(n), this.counters.pop(e), B && (this.options.copyStyles || tn(A)) && !an(A) && Mn(B, t), 0 === A.scrollTop && 0 === A.scrollLeft || this.scrolledElements.push([t, A.scrollLeft, A.scrollTop]), (gn(A) || wn(A)) && (gn(t) || wn(t)) && (t.value = A.value), t;
      }
      return A.cloneNode(!1);
    }, bn.prototype.resolvePseudoContent = function (o, A, e, t) {
      var i = this;
      if (e) {
        var B = e.content,
          Q = A.ownerDocument;
        if (Q && B && "none" !== B && "-moz-alt-content" !== B && "none" !== e.display) {
          this.counters.parse(new pB(this.context, e));
          var c = new IB(this.context, e),
            a = Q.createElement("html2canvasV1pseudoelement");
          Mn(e, a), c.content.forEach(function (A) {
            if (0 === A.type) a.appendChild(Q.createTextNode(A.value));else if (22 === A.type) {
              var e = Q.createElement("img");
              e.src = A.value, e.style.opacity = "1", a.appendChild(e);
            } else if (18 === A.type) {
              var t, B, r, n, s;
              "attr" === A.name ? (e = A.values.filter(kA)).length && a.appendChild(Q.createTextNode(o.getAttribute(e[0].value) || "")) : "counter" === A.name ? (r = (B = A.values.filter(YA))[0], B = B[1], r && kA(r) && (t = i.counters.getCounterValue(r.value), s = B && kA(B) ? Kt.parse(i.context, B.value) : It.DECIMAL, a.appendChild(Q.createTextNode(Ln(t, s, !1))))) : "counters" === A.name && (r = (t = A.values.filter(YA))[0], s = t[1], B = t[2], r && kA(r) && (r = i.counters.getCounterValues(r.value), n = B && kA(B) ? Kt.parse(i.context, B.value) : It.DECIMAL, s = s && 0 === s.type ? s.value : "", s = r.map(function (A) {
                return Ln(A, n, !1);
              }).join(s), a.appendChild(Q.createTextNode(s))));
            } else if (20 === A.type) switch (A.value) {
              case "open-quote":
                a.appendChild(Q.createTextNode(cB(c.quotes, i.quoteDepth++, !0)));
                break;
              case "close-quote":
                a.appendChild(Q.createTextNode(cB(c.quotes, --i.quoteDepth, !1)));
                break;
              default:
                a.appendChild(Q.createTextNode(A.value));
            }
          }), a.className = Vn + " " + Pn;
          t = t === Hn.BEFORE ? " " + Vn : " " + Pn;
          return tn(A) ? A.className.baseValue += t : A.className += t, a;
        }
      }
    }, bn.destroy = function (A) {
      return !!A.parentNode && (A.parentNode.removeChild(A), !0);
    }, bn);
  function bn(A, e, t) {
    if (this.context = A, this.options = t, this.scrolledElements = [], this.referenceElement = e, this.counters = new Un(), this.quoteDepth = 0, !e.ownerDocument) throw new Error("Cloned element does not have an owner document");
    this.documentElement = this.cloneNode(e.ownerDocument.documentElement);
  }
  (we = Hn = Hn || {})[we.BEFORE = 0] = "BEFORE", we[we.AFTER = 1] = "AFTER";
  function Rn(e) {
    return new Promise(function (A) {
      !e.complete && e.src ? (e.onload = A, e.onerror = A) : A();
    });
  }
  var On = function (A, e) {
      var t = A.createElement("iframe");
      return t.className = "html2canvasV1-container", t.style.visibility = "hidden", t.style.position = "fixed", t.style.left = "-10000px", t.style.top = "0px", t.style.border = "0", t.width = e.width.toString(), t.height = e.height.toString(), t.scrolling = "no", t.setAttribute(mn, "true"), A.body.appendChild(t), t;
    },
    Sn = function (A) {
      return Promise.all([].slice.call(A.images, 0).map(Rn));
    },
    Tn = function (r) {
      return new Promise(function (e, A) {
        var t = r.contentWindow;
        if (!t) return A("No window assigned for iframe");
        var B = t.document;
        t.onload = r.onload = function () {
          t.onload = r.onload = null;
          var A = setInterval(function () {
            0 < B.body.childNodes.length && "complete" === B.readyState && (clearInterval(A), e(r));
          }, 50);
        };
      });
    },
    vn = ["all", "d", "content"],
    Mn = function (A, e) {
      for (var t = A.length - 1; 0 <= t; t--) {
        var B = A.item(t);
        -1 === vn.indexOf(B) && e.style.setProperty(B, A.getPropertyValue(B));
      }
      return e;
    },
    Nn = function (A) {
      var e = "";
      return A && (e += "<!DOCTYPE ", A.name && (e += A.name), A.internalSubset && (e += A.internalSubset), A.publicId && (e += '"' + A.publicId + '"'), A.systemId && (e += '"' + A.systemId + '"'), e += ">"), e;
    },
    Gn = function (A, e, t) {
      A && A.defaultView && (e !== A.defaultView.pageXOffset || t !== A.defaultView.pageYOffset) && A.defaultView.scrollTo(e, t);
    },
    xn = function (A) {
      var e = A[0],
        t = A[1],
        A = A[2];
      e.scrollLeft = t, e.scrollTop = A;
    },
    Vn = "___html2canvasV1___pseudoelement_before",
    Pn = "___html2canvasV1___pseudoelement_after",
    kn = '{\n    content: "" !important;\n    display: none !important;\n}',
    Jn = function (A) {
      Xn(A, "." + Vn + ":before" + kn + "\n         ." + Pn + ":after" + kn);
    },
    Xn = function (A, e) {
      var t = A.ownerDocument;
      t && ((t = t.createElement("style")).textContent = e, A.appendChild(t));
    },
    _n = (Yn.getOrigin = function (A) {
      var e = Yn._link;
      return e ? (e.href = A, e.href = e.href, e.protocol + e.hostname + e.port) : "about:blank";
    }, Yn.isSameOrigin = function (A) {
      return Yn.getOrigin(A) === Yn._origin;
    }, Yn.setContext = function (A) {
      Yn._link = A.document.createElement("a"), Yn._origin = Yn.getOrigin(A.location.href);
    }, Yn._origin = "about:blank", Yn);
  function Yn() {}
  var Wn = (Zn.prototype.addImage = function (A) {
    var e = Promise.resolve();
    return this.has(A) || (Bs(A) || As(A)) && (this._cache[A] = this.loadImage(A)).catch(function () {}), e;
  }, Zn.prototype.match = function (A) {
    return this._cache[A];
  }, Zn.prototype.loadImage = function (s) {
    return a(this, void 0, void 0, function () {
      var e,
        B,
        t,
        r,
        n = this;
      return H(this, function (A) {
        switch (A.label) {
          case 0:
            return (e = _n.isSameOrigin(s), B = !es(s) && !0 === this._options.useCORS && tr.SUPPORT_CORS_IMAGES && !e, t = !es(s) && !e && !Bs(s) && "string" == typeof this._options.proxy && tr.SUPPORT_CORS_XHR && !B, e || !1 !== this._options.allowTaint || es(s) || Bs(s) || t || B) ? (r = s, t ? [4, this.proxy(r)] : [3, 2]) : [2];
          case 1:
            r = A.sent(), A.label = 2;
          case 2:
            return this.context.logger.debug("Added image " + s.substring(0, 256)), [4, new Promise(function (A, e) {
              var t = new Image();
              t.onload = function () {
                return A(t);
              }, t.onerror = e, (ts(r) || B) && (t.crossOrigin = "anonymous"), t.src = r, !0 === t.complete && setTimeout(function () {
                return A(t);
              }, 500), 0 < n._options.imageTimeout && setTimeout(function () {
                return e("Timed out (" + n._options.imageTimeout + "ms) loading image");
              }, n._options.imageTimeout);
            })];
          case 3:
            return [2, A.sent()];
        }
      });
    });
  }, Zn.prototype.has = function (A) {
    return void 0 !== this._cache[A];
  }, Zn.prototype.keys = function () {
    return Promise.resolve(Object.keys(this._cache));
  }, Zn.prototype.proxy = function (s) {
    var o = this,
      i = this._options.proxy;
    if (!i) throw new Error("No proxy defined");
    var Q = s.substring(0, 256);
    return new Promise(function (e, t) {
      var B = tr.SUPPORT_RESPONSE_TYPE ? "blob" : "text",
        r = new XMLHttpRequest();
      r.onload = function () {
        var A;
        200 === r.status ? "text" == B ? e(r.response) : ((A = new FileReader()).addEventListener("load", function () {
          return e(A.result);
        }, !1), A.addEventListener("error", function (A) {
          return t(A);
        }, !1), A.readAsDataURL(r.response)) : t("Failed to proxy resource " + Q + " with status code " + r.status);
      }, r.onerror = t;
      var A,
        n = -1 < i.indexOf("?") ? "&" : "?";
      r.open("GET", i + n + "url=" + encodeURIComponent(s) + "&responseType=" + B), "text" != B && r instanceof XMLHttpRequest && (r.responseType = B), o._options.imageTimeout && (A = o._options.imageTimeout, r.timeout = A, r.ontimeout = function () {
        return t("Timed out (" + A + "ms) proxying " + Q);
      }), r.send();
    });
  }, Zn);
  function Zn(A, e) {
    this.context = A, this._options = e, this._cache = {};
  }
  var qn,
    jn = /^data:image\/svg\+xml/i,
    zn = /^data:image\/.*;base64,/i,
    $n = /^data:image\/.*/i,
    As = function (A) {
      return tr.SUPPORT_SVG_DRAWING || !rs(A);
    },
    es = function (A) {
      return $n.test(A);
    },
    ts = function (A) {
      return zn.test(A);
    },
    Bs = function (A) {
      return "blob" === A.substr(0, 4);
    },
    rs = function (A) {
      return "svg" === A.substr(-3).toLowerCase() || jn.test(A);
    };
  (we = qn = qn || {})[we.VECTOR = 0] = "VECTOR", we[we.BEZIER_CURVE = 1] = "BEZIER_CURVE";
  function ns(A, t) {
    return A.length === t.length && A.some(function (A, e) {
      return A === t[e];
    });
  }
  var ss = (os.prototype.add = function (A, e) {
    return new os(this.x + A, this.y + e);
  }, os);
  function os(A, e) {
    this.type = qn.VECTOR, this.x = A, this.y = e;
  }
  function is(A, e, t) {
    return new ss(A.x + (e.x - A.x) * t, A.y + (e.y - A.y) * t);
  }
  var Qs = (cs.prototype.subdivide = function (A, e) {
    var t = is(this.start, this.startControl, A),
      B = is(this.startControl, this.endControl, A),
      r = is(this.endControl, this.end, A),
      n = is(t, B, A),
      B = is(B, r, A),
      A = is(n, B, A);
    return e ? new cs(this.start, t, n, A) : new cs(A, B, r, this.end);
  }, cs.prototype.add = function (A, e) {
    return new cs(this.start.add(A, e), this.startControl.add(A, e), this.endControl.add(A, e), this.end.add(A, e));
  }, cs.prototype.reverse = function () {
    return new cs(this.end, this.endControl, this.startControl, this.start);
  }, cs);
  function cs(A, e, t, B) {
    this.type = qn.BEZIER_CURVE, this.start = A, this.startControl = e, this.endControl = t, this.end = B;
  }
  function as(A) {
    return A.type === qn.BEZIER_CURVE;
  }
  var gs,
    ws = function (A) {
      var e = A.styles,
        t = A.bounds,
        B = (l = zA(e.borderTopLeftRadius, t.width, t.height))[0],
        r = l[1],
        n = (F = zA(e.borderTopRightRadius, t.width, t.height))[0],
        s = F[1],
        o = (u = zA(e.borderBottomRightRadius, t.width, t.height))[0],
        i = u[1],
        Q = (h = zA(e.borderBottomLeftRadius, t.width, t.height))[0],
        c = h[1];
      (d = []).push((B + n) / t.width), d.push((Q + o) / t.width), d.push((r + c) / t.height), d.push((s + i) / t.height), 1 < (E = Math.max.apply(Math, d)) && (B /= E, r /= E, n /= E, s /= E, o /= E, i /= E, Q /= E, c /= E);
      var a = t.width - n,
        g = t.height - i,
        w = t.width - o,
        C = t.height - c,
        U = e.borderTopWidth,
        l = e.borderRightWidth,
        F = e.borderBottomWidth,
        u = e.borderLeftWidth,
        h = ie(e.paddingTop, A.bounds.width),
        d = ie(e.paddingRight, A.bounds.width),
        E = ie(e.paddingBottom, A.bounds.width),
        A = ie(e.paddingLeft, A.bounds.width);
      this.topLeftBorderDoubleOuterBox = 0 < B || 0 < r ? Fs(t.left + u / 3, t.top + U / 3, B - u / 3, r - U / 3, gs.TOP_LEFT) : new ss(t.left + u / 3, t.top + U / 3), this.topRightBorderDoubleOuterBox = 0 < B || 0 < r ? Fs(t.left + a, t.top + U / 3, n - l / 3, s - U / 3, gs.TOP_RIGHT) : new ss(t.left + t.width - l / 3, t.top + U / 3), this.bottomRightBorderDoubleOuterBox = 0 < o || 0 < i ? Fs(t.left + w, t.top + g, o - l / 3, i - F / 3, gs.BOTTOM_RIGHT) : new ss(t.left + t.width - l / 3, t.top + t.height - F / 3), this.bottomLeftBorderDoubleOuterBox = 0 < Q || 0 < c ? Fs(t.left + u / 3, t.top + C, Q - u / 3, c - F / 3, gs.BOTTOM_LEFT) : new ss(t.left + u / 3, t.top + t.height - F / 3), this.topLeftBorderDoubleInnerBox = 0 < B || 0 < r ? Fs(t.left + 2 * u / 3, t.top + 2 * U / 3, B - 2 * u / 3, r - 2 * U / 3, gs.TOP_LEFT) : new ss(t.left + 2 * u / 3, t.top + 2 * U / 3), this.topRightBorderDoubleInnerBox = 0 < B || 0 < r ? Fs(t.left + a, t.top + 2 * U / 3, n - 2 * l / 3, s - 2 * U / 3, gs.TOP_RIGHT) : new ss(t.left + t.width - 2 * l / 3, t.top + 2 * U / 3), this.bottomRightBorderDoubleInnerBox = 0 < o || 0 < i ? Fs(t.left + w, t.top + g, o - 2 * l / 3, i - 2 * F / 3, gs.BOTTOM_RIGHT) : new ss(t.left + t.width - 2 * l / 3, t.top + t.height - 2 * F / 3), this.bottomLeftBorderDoubleInnerBox = 0 < Q || 0 < c ? Fs(t.left + 2 * u / 3, t.top + C, Q - 2 * u / 3, c - 2 * F / 3, gs.BOTTOM_LEFT) : new ss(t.left + 2 * u / 3, t.top + t.height - 2 * F / 3), this.topLeftBorderStroke = 0 < B || 0 < r ? Fs(t.left + u / 2, t.top + U / 2, B - u / 2, r - U / 2, gs.TOP_LEFT) : new ss(t.left + u / 2, t.top + U / 2), this.topRightBorderStroke = 0 < B || 0 < r ? Fs(t.left + a, t.top + U / 2, n - l / 2, s - U / 2, gs.TOP_RIGHT) : new ss(t.left + t.width - l / 2, t.top + U / 2), this.bottomRightBorderStroke = 0 < o || 0 < i ? Fs(t.left + w, t.top + g, o - l / 2, i - F / 2, gs.BOTTOM_RIGHT) : new ss(t.left + t.width - l / 2, t.top + t.height - F / 2), this.bottomLeftBorderStroke = 0 < Q || 0 < c ? Fs(t.left + u / 2, t.top + C, Q - u / 2, c - F / 2, gs.BOTTOM_LEFT) : new ss(t.left + u / 2, t.top + t.height - F / 2), this.topLeftBorderBox = 0 < B || 0 < r ? Fs(t.left, t.top, B, r, gs.TOP_LEFT) : new ss(t.left, t.top), this.topRightBorderBox = 0 < n || 0 < s ? Fs(t.left + a, t.top, n, s, gs.TOP_RIGHT) : new ss(t.left + t.width, t.top), this.bottomRightBorderBox = 0 < o || 0 < i ? Fs(t.left + w, t.top + g, o, i, gs.BOTTOM_RIGHT) : new ss(t.left + t.width, t.top + t.height), this.bottomLeftBorderBox = 0 < Q || 0 < c ? Fs(t.left, t.top + C, Q, c, gs.BOTTOM_LEFT) : new ss(t.left, t.top + t.height), this.topLeftPaddingBox = 0 < B || 0 < r ? Fs(t.left + u, t.top + U, Math.max(0, B - u), Math.max(0, r - U), gs.TOP_LEFT) : new ss(t.left + u, t.top + U), this.topRightPaddingBox = 0 < n || 0 < s ? Fs(t.left + Math.min(a, t.width - l), t.top + U, a > t.width + l ? 0 : Math.max(0, n - l), Math.max(0, s - U), gs.TOP_RIGHT) : new ss(t.left + t.width - l, t.top + U), this.bottomRightPaddingBox = 0 < o || 0 < i ? Fs(t.left + Math.min(w, t.width - u), t.top + Math.min(g, t.height - F), Math.max(0, o - l), Math.max(0, i - F), gs.BOTTOM_RIGHT) : new ss(t.left + t.width - l, t.top + t.height - F), this.bottomLeftPaddingBox = 0 < Q || 0 < c ? Fs(t.left + u, t.top + Math.min(C, t.height - F), Math.max(0, Q - u), Math.max(0, c - F), gs.BOTTOM_LEFT) : new ss(t.left + u, t.top + t.height - F), this.topLeftContentBox = 0 < B || 0 < r ? Fs(t.left + u + A, t.top + U + h, Math.max(0, B - (u + A)), Math.max(0, r - (U + h)), gs.TOP_LEFT) : new ss(t.left + u + A, t.top + U + h), this.topRightContentBox = 0 < n || 0 < s ? Fs(t.left + Math.min(a, t.width + u + A), t.top + U + h, a > t.width + u + A ? 0 : n - u + A, s - (U + h), gs.TOP_RIGHT) : new ss(t.left + t.width - (l + d), t.top + U + h), this.bottomRightContentBox = 0 < o || 0 < i ? Fs(t.left + Math.min(w, t.width - (u + A)), t.top + Math.min(g, t.height + U + h), Math.max(0, o - (l + d)), i - (F + E), gs.BOTTOM_RIGHT) : new ss(t.left + t.width - (l + d), t.top + t.height - (F + E)), this.bottomLeftContentBox = 0 < Q || 0 < c ? Fs(t.left + u + A, t.top + C, Math.max(0, Q - (u + A)), c - (F + E), gs.BOTTOM_LEFT) : new ss(t.left + u + A, t.top + t.height - (F + E));
    };
  (we = gs = gs || {})[we.TOP_LEFT = 0] = "TOP_LEFT", we[we.TOP_RIGHT = 1] = "TOP_RIGHT", we[we.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", we[we.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
  function Cs(A) {
    return [A.topLeftBorderBox, A.topRightBorderBox, A.bottomRightBorderBox, A.bottomLeftBorderBox];
  }
  function Us(A) {
    return [A.topLeftPaddingBox, A.topRightPaddingBox, A.bottomRightPaddingBox, A.bottomLeftPaddingBox];
  }
  function ls(A) {
    return 1 === A.type;
  }
  var Fs = function (A, e, t, B, r) {
      var n = (Math.sqrt(2) - 1) / 3 * 4,
        s = t * n,
        o = B * n,
        i = A + t,
        Q = e + B;
      switch (r) {
        case gs.TOP_LEFT:
          return new Qs(new ss(A, Q), new ss(A, Q - o), new ss(i - s, e), new ss(i, e));
        case gs.TOP_RIGHT:
          return new Qs(new ss(A, e), new ss(A + s, e), new ss(i, Q - o), new ss(i, Q));
        case gs.BOTTOM_RIGHT:
          return new Qs(new ss(i, e), new ss(i, e + o), new ss(A + s, Q), new ss(A, Q));
        default:
          gs.BOTTOM_LEFT;
          return new Qs(new ss(i, Q), new ss(i - s, Q), new ss(A, e + o), new ss(A, e));
      }
    },
    us = function (A, e, t) {
      this.offsetX = A, this.offsetY = e, this.matrix = t, this.type = 0, this.target = 6;
    },
    hs = function (A, e) {
      this.path = A, this.target = e, this.type = 1;
    },
    ds = function (A) {
      this.opacity = A, this.type = 2, this.target = 6;
    },
    Es = function (A) {
      this.element = A, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    },
    Hs = (fs.prototype.getEffects = function (e) {
      for (var A = -1 === [Gt.ABSOLUTE, Gt.FIXED].indexOf(this.container.styles.position), t = this.parent, B = this.effects.slice(0); t;) {
        var r,
          n,
          s = t.effects.filter(function (A) {
            return !ls(A);
          });
        A || t.container.styles.position !== Gt.STATIC || !t.parent ? (B.unshift.apply(B, s), A = -1 === [Gt.ABSOLUTE, Gt.FIXED].indexOf(t.container.styles.position), t.container.styles.overflowX !== yt.VISIBLE && (r = Cs(t.curves), n = Us(t.curves), ns(r, n) || B.unshift(new hs(n, 6)))) : B.unshift.apply(B, s), t = t.parent;
      }
      return B.filter(function (A) {
        return QB(A.target, e);
      });
    }, fs);
  function fs(A, e) {
    var t, B;
    this.container = A, this.parent = e, this.effects = [], this.curves = new ws(this.container), this.container.styles.opacity < 1 && this.effects.push(new ds(this.container.styles.opacity)), null !== this.container.styles.transform && (e = this.container.bounds.left + this.container.styles.transformOrigin[0].number, t = this.container.bounds.top + this.container.styles.transformOrigin[1].number, B = this.container.styles.transform, this.effects.push(new us(e, t, B))), this.container.styles.overflowX !== yt.VISIBLE && (t = Cs(this.curves), B = Us(this.curves), ns(t, B) ? this.effects.push(new hs(t, 6)) : (this.effects.push(new hs(t, 2)), this.effects.push(new hs(B, 4))));
  }
  function Is(A, e) {
    switch (e) {
      case 0:
        return Os(A.topLeftBorderBox, A.topLeftPaddingBox, A.topRightBorderBox, A.topRightPaddingBox);
      case 1:
        return Os(A.topRightBorderBox, A.topRightPaddingBox, A.bottomRightBorderBox, A.bottomRightPaddingBox);
      case 2:
        return Os(A.bottomRightBorderBox, A.bottomRightPaddingBox, A.bottomLeftBorderBox, A.bottomLeftPaddingBox);
      default:
        return Os(A.bottomLeftBorderBox, A.bottomLeftPaddingBox, A.topLeftBorderBox, A.topLeftPaddingBox);
    }
  }
  function ps(A) {
    var e = A.bounds,
      A = A.styles;
    return e.add(A.borderLeftWidth, A.borderTopWidth, -(A.borderRightWidth + A.borderLeftWidth), -(A.borderTopWidth + A.borderBottomWidth));
  }
  function ys(A) {
    var e = A.styles,
      t = A.bounds,
      B = ie(e.paddingLeft, t.width),
      r = ie(e.paddingRight, t.width),
      n = ie(e.paddingTop, t.width),
      A = ie(e.paddingBottom, t.width);
    return t.add(B + e.borderLeftWidth, n + e.borderTopWidth, -(e.borderRightWidth + e.borderLeftWidth + B + r), -(e.borderTopWidth + e.borderBottomWidth + n + A));
  }
  function Ks(A, e, t) {
    var B = (r = Ts(A.styles.backgroundOrigin, e), n = A, 0 === r ? n.bounds : (2 === r ? ys : ps)(n)),
      r = (s = Ts(A.styles.backgroundClip, e), o = A, s === le.BORDER_BOX ? o.bounds : (s === le.CONTENT_BOX ? ys : ps)(o)),
      n = Ss(Ts(A.styles.backgroundSize, e), t, B),
      s = n[0],
      o = n[1],
      t = zA(Ts(A.styles.backgroundPosition, e), B.width - s, B.height - o);
    return [vs(Ts(A.styles.backgroundRepeat, e), t, n, B, r), Math.round(B.left + t[0]), Math.round(B.top + t[1]), s, o];
  }
  function Ls(A) {
    return kA(A) && A.value === ke.AUTO;
  }
  function ms(A) {
    return "number" == typeof A;
  }
  var Ds = function (Q, c, a, g) {
      Q.container.elements.forEach(function (A) {
        var e = QB(A.flags, 4),
          t = QB(A.flags, 2),
          B = new Hs(A, Q);
        QB(A.styles.display, 2048) && g.push(B);
        var r,
          n,
          s,
          o,
          i = QB(A.flags, 8) ? [] : g;
        e || t ? (r = e || A.styles.isPositioned() ? a : c, t = new Es(B), A.styles.isPositioned() || A.styles.opacity < 1 || A.styles.isTransformed() ? (n = A.styles.zIndex.order) < 0 ? (s = 0, r.negativeZIndex.some(function (A, e) {
          return n > A.element.container.styles.zIndex.order ? (s = e, !1) : 0 < s;
        }), r.negativeZIndex.splice(s, 0, t)) : 0 < n ? (o = 0, r.positiveZIndex.some(function (A, e) {
          return n >= A.element.container.styles.zIndex.order ? (o = e + 1, !1) : 0 < o;
        }), r.positiveZIndex.splice(o, 0, t)) : r.zeroOrAutoZIndexOrTransformedOrOpacity.push(t) : (A.styles.isFloating() ? r.nonPositionedFloats : r.nonPositionedInlineLevel).push(t), Ds(B, t, e ? t : a, i)) : ((A.styles.isInlineLevel() ? c.inlineLevel : c.nonInlineLevel).push(B), Ds(B, c, a, i)), QB(A.flags, 8) && bs(A, i);
      });
    },
    bs = function (A, e) {
      for (var t = A instanceof yr ? A.start : 1, B = A instanceof yr && A.reversed, r = 0; r < e.length; r++) {
        var n = e[r];
        n.container instanceof fr && "number" == typeof n.container.value && 0 !== n.container.value && (t = n.container.value), n.listValue = Ln(t, n.container.styles.listStyleType, !0), t += B ? -1 : 1;
      }
    },
    Rs = function (A, e) {
      var t = [];
      return as(A) ? t.push(A.subdivide(.5, !1)) : t.push(A), as(e) ? t.push(e.subdivide(.5, !0)) : t.push(e), t;
    },
    Os = function (A, e, t, B) {
      var r = [];
      return as(A) ? r.push(A.subdivide(.5, !1)) : r.push(A), as(t) ? r.push(t.subdivide(.5, !0)) : r.push(t), as(B) ? r.push(B.subdivide(.5, !0).reverse()) : r.push(B), as(e) ? r.push(e.subdivide(.5, !1).reverse()) : r.push(e), r;
    },
    Ss = function (A, e, t) {
      var B = e[0],
        r = e[1],
        n = e[2],
        s = A[0],
        o = A[1];
      if (!s) return [0, 0];
      if (qA(s) && o && qA(o)) return [ie(s, t.width), ie(o, t.height)];
      var i = ms(n);
      if (kA(s) && (s.value === ke.CONTAIN || s.value === ke.COVER)) return ms(n) ? t.width / t.height < n != (s.value === ke.COVER) ? [t.width, t.width / n] : [t.height * n, t.height] : [t.width, t.height];
      var Q = ms(B),
        e = ms(r),
        A = Q || e;
      if (Ls(s) && (!o || Ls(o))) return Q && e ? [B, r] : i || A ? A && i ? [Q ? B : r * n, e ? r : B / n] : [Q ? B : t.width, e ? r : t.height] : [t.width, t.height];
      if (i) {
        var c = 0,
          a = 0;
        return qA(s) ? c = ie(s, t.width) : qA(o) && (a = ie(o, t.height)), Ls(s) ? c = a * n : o && !Ls(o) || (a = c / n), [c, a];
      }
      c = null, a = null;
      if (qA(s) ? c = ie(s, t.width) : o && qA(o) && (a = ie(o, t.height)), null !== (c = null !== (a = null !== c && (!o || Ls(o)) ? Q && e ? c / B * r : t.height : a) && Ls(s) ? Q && e ? a / r * B : t.width : c) && null !== a) return [c, a];
      throw new Error("Unable to calculate background-size for element");
    },
    Ts = function (A, e) {
      e = A[e];
      return void 0 === e ? A[0] : e;
    },
    vs = function (A, e, t, B, r) {
      var n = e[0],
        s = e[1],
        o = t[0],
        i = t[1];
      switch (A) {
        case Ne.REPEAT_X:
          return [new ss(Math.round(B.left), Math.round(B.top + s)), new ss(Math.round(B.left + B.width), Math.round(B.top + s)), new ss(Math.round(B.left + B.width), Math.round(i + B.top + s)), new ss(Math.round(B.left), Math.round(i + B.top + s))];
        case Ne.REPEAT_Y:
          return [new ss(Math.round(B.left + n), Math.round(B.top)), new ss(Math.round(B.left + n + o), Math.round(B.top)), new ss(Math.round(B.left + n + o), Math.round(B.height + B.top)), new ss(Math.round(B.left + n), Math.round(B.height + B.top))];
        case Ne.NO_REPEAT:
          return [new ss(Math.round(B.left + n), Math.round(B.top + s)), new ss(Math.round(B.left + n + o), Math.round(B.top + s)), new ss(Math.round(B.left + n + o), Math.round(B.top + s + i)), new ss(Math.round(B.left + n), Math.round(B.top + s + i))];
        default:
          return [new ss(Math.round(r.left), Math.round(r.top)), new ss(Math.round(r.left + r.width), Math.round(r.top)), new ss(Math.round(r.left + r.width), Math.round(r.height + r.top)), new ss(Math.round(r.left), Math.round(r.height + r.top))];
      }
    },
    Ms = "Hidden Text",
    Ns = (Gs.prototype.parseMetrics = function (A, e) {
      var t = this._document.createElement("div"),
        B = this._document.createElement("img"),
        r = this._document.createElement("span"),
        n = this._document.body;
      t.style.visibility = "hidden", t.style.fontFamily = A, t.style.fontSize = e, t.style.margin = "0", t.style.padding = "0", n.appendChild(t), B.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", B.width = 1, B.height = 1, B.style.margin = "0", B.style.padding = "0", B.style.verticalAlign = "baseline", r.style.fontFamily = A, r.style.fontSize = e, r.style.margin = "0", r.style.padding = "0", r.appendChild(this._document.createTextNode(Ms)), t.appendChild(r), t.appendChild(B);
      e = B.offsetTop - r.offsetTop + 2;
      t.removeChild(r), t.appendChild(this._document.createTextNode(Ms)), t.style.lineHeight = "normal", B.style.verticalAlign = "super";
      B = B.offsetTop - t.offsetTop + 2;
      return n.removeChild(t), {
        baseline: e,
        middle: B
      };
    }, Gs.prototype.getMetrics = function (A, e) {
      var t = A + " " + e;
      return void 0 === this._data[t] && (this._data[t] = this.parseMetrics(A, e)), this._data[t];
    }, Gs);
  function Gs(A) {
    this._data = {}, this._document = A;
  }
  var xs,
    we = function (A, e) {
      this.context = A, this.options = e;
    },
    Vs = (A(Ps, xs = we), Ps.prototype.applyEffects = function (A) {
      for (var e = this; this._activeEffects.length;) this.popEffect();
      A.forEach(function (A) {
        return e.applyEffect(A);
      });
    }, Ps.prototype.applyEffect = function (A) {
      this.ctx.save(), 2 === A.type && (this.ctx.globalAlpha = A.opacity), 0 === A.type && (this.ctx.translate(A.offsetX, A.offsetY), this.ctx.transform(A.matrix[0], A.matrix[1], A.matrix[2], A.matrix[3], A.matrix[4], A.matrix[5]), this.ctx.translate(-A.offsetX, -A.offsetY)), ls(A) && (this.path(A.path), this.ctx.clip()), this._activeEffects.push(A);
    }, Ps.prototype.popEffect = function () {
      this._activeEffects.pop(), this.ctx.restore();
    }, Ps.prototype.renderStack = function (e) {
      return a(this, void 0, void 0, function () {
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              return e.element.container.styles.isVisible() ? [4, this.renderStackContent(e)] : [3, 2];
            case 1:
              A.sent(), A.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, Ps.prototype.renderNode = function (e) {
      return a(this, void 0, void 0, function () {
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              return QB(e.container.flags, 16), e.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(e)] : [3, 3];
            case 1:
              return A.sent(), [4, this.renderNodeContent(e)];
            case 2:
              A.sent(), A.label = 3;
            case 3:
              return [2];
          }
        });
      });
    }, Ps.prototype.renderTextWithLetterSpacing = function (t, A, B) {
      var r = this;
      0 === A ? this.ctx.fillText(t.text, t.bounds.left, t.bounds.top + B) : xB(t.text).reduce(function (A, e) {
        return r.ctx.fillText(e, A, t.bounds.top + B), A + r.ctx.measureText(e).width;
      }, t.bounds.left);
    }, Ps.prototype.createFontStyle = function (A) {
      var e = A.fontVariant.filter(function (A) {
          return "normal" === A || "small-caps" === A;
        }).join(""),
        t = A.fontFamily.join(", "),
        B = VA(A.fontSize) ? "" + A.fontSize.number + A.fontSize.unit : A.fontSize.number + "px";
      return [[A.fontStyle, e, A.fontWeight, B, t].join(" "), t, B];
    }, Ps.prototype.renderTextNode = function (i, Q) {
      return a(this, void 0, void 0, function () {
        var e,
          t,
          B,
          r,
          n,
          s,
          o = this;
        return H(this, function (A) {
          return B = this.createFontStyle(Q), e = B[0], t = B[1], B = B[2], this.ctx.font = e, this.ctx.direction = 1 === Q.direction ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", B = this.fontMetrics.getMetrics(t, B), r = B.baseline, n = B.middle, s = Q.paintOrder, i.textBounds.forEach(function (t) {
            s.forEach(function (A) {
              switch (A) {
                case aB.FILL:
                  o.ctx.fillStyle = te(Q.color), o.renderTextWithLetterSpacing(t, Q.letterSpacing, r);
                  var e = Q.textShadow;
                  e.length && t.text.trim().length && (e.slice(0).reverse().forEach(function (A) {
                    o.ctx.shadowColor = te(A.color), o.ctx.shadowOffsetX = A.offsetX.number * o.options.scale, o.ctx.shadowOffsetY = A.offsetY.number * o.options.scale, o.ctx.shadowBlur = A.blur.number, o.renderTextWithLetterSpacing(t, Q.letterSpacing, r);
                  }), o.ctx.shadowColor = "", o.ctx.shadowOffsetX = 0, o.ctx.shadowOffsetY = 0, o.ctx.shadowBlur = 0), Q.textDecorationLine.length && (o.ctx.fillStyle = te(Q.textDecorationColor || Q.color), Q.textDecorationLine.forEach(function (A) {
                    switch (A) {
                      case 1:
                        o.ctx.fillRect(t.bounds.left, Math.round(t.bounds.top + r), t.bounds.width, 1);
                        break;
                      case 2:
                        o.ctx.fillRect(t.bounds.left, Math.round(t.bounds.top), t.bounds.width, 1);
                        break;
                      case 3:
                        o.ctx.fillRect(t.bounds.left, Math.ceil(t.bounds.top + n), t.bounds.width, 1);
                    }
                  }));
                  break;
                case aB.STROKE:
                  Q.webkitTextStrokeWidth && t.text.trim().length && (o.ctx.strokeStyle = te(Q.webkitTextStrokeColor), o.ctx.lineWidth = Q.webkitTextStrokeWidth, o.ctx.lineJoin = window.chrome ? "miter" : "round", o.ctx.strokeText(t.text, t.bounds.left, t.bounds.top + r)), o.ctx.strokeStyle = "", o.ctx.lineWidth = 0, o.ctx.lineJoin = "miter";
              }
            });
          }), [2];
        });
      });
    }, Ps.prototype.renderReplacedElement = function (A, e, t) {
      var B;
      t && 0 < A.intrinsicWidth && 0 < A.intrinsicHeight && (B = ys(A), e = Us(e), this.path(e), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(t, 0, 0, A.intrinsicWidth, A.intrinsicHeight, B.left, B.top, B.width, B.height), this.ctx.restore());
    }, Ps.prototype.renderNodeContent = function (w) {
      return a(this, void 0, void 0, function () {
        var e, t, B, r, n, s, o, i, Q, c, a, g;
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              this.applyEffects(w.getEffects(4)), e = w.container, t = w.curves, B = e.styles, r = 0, n = e.textNodes, A.label = 1;
            case 1:
              return r < n.length ? (s = n[r], [4, this.renderTextNode(s, B)]) : [3, 4];
            case 2:
              A.sent(), A.label = 3;
            case 3:
              return r++, [3, 1];
            case 4:
              if (!(e instanceof Cr)) return [3, 8];
              A.label = 5;
            case 5:
              return A.trys.push([5, 7,, 8]), [4, this.context.cache.match(e.src)];
            case 6:
              return Q = A.sent(), this.renderReplacedElement(e, t, Q), [3, 8];
            case 7:
              return A.sent(), this.context.logger.error("Error loading image " + e.src), [3, 8];
            case 8:
              if (e instanceof Fr && this.renderReplacedElement(e, t, e.canvas), !(e instanceof dr)) return [3, 12];
              A.label = 9;
            case 9:
              return A.trys.push([9, 11,, 12]), [4, this.context.cache.match(e.svg)];
            case 10:
              return Q = A.sent(), this.renderReplacedElement(e, t, Q), [3, 12];
            case 11:
              return A.sent(), this.context.logger.error("Error loading svg " + e.svg.substring(0, 255)), [3, 12];
            case 12:
              return e instanceof Jr && e.tree ? [4, new Ps(this.context, {
                scale: this.options.scale,
                backgroundColor: e.backgroundColor,
                x: 0,
                y: 0,
                width: e.width,
                height: e.height
              }).render(e.tree)] : [3, 14];
            case 13:
              s = A.sent(), e.width && e.height && this.ctx.drawImage(s, 0, 0, e.width, e.height, e.bounds.left, e.bounds.top, e.bounds.width, e.bounds.height), A.label = 14;
            case 14:
              if (e instanceof Tr && (i = Math.min(e.bounds.width, e.bounds.height), e.type === br ? e.checked && (this.ctx.save(), this.path([new ss(e.bounds.left + .39363 * i, e.bounds.top + .79 * i), new ss(e.bounds.left + .16 * i, e.bounds.top + .5549 * i), new ss(e.bounds.left + .27347 * i, e.bounds.top + .44071 * i), new ss(e.bounds.left + .39694 * i, e.bounds.top + .5649 * i), new ss(e.bounds.left + .72983 * i, e.bounds.top + .23 * i), new ss(e.bounds.left + .84 * i, e.bounds.top + .34085 * i), new ss(e.bounds.left + .39363 * i, e.bounds.top + .79 * i)]), this.ctx.fillStyle = te(Sr), this.ctx.fill(), this.ctx.restore()) : e.type === Rr && e.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(e.bounds.left + i / 2, e.bounds.top + i / 2, i / 4, 0, 2 * Math.PI, !0), this.ctx.fillStyle = te(Sr), this.ctx.fill(), this.ctx.restore())), Js(e) && e.value.length) {
                switch (c = this.createFontStyle(B), a = c[0], i = c[1], c = this.fontMetrics.getMetrics(a, i).baseline, this.ctx.font = a, this.ctx.fillStyle = te(B.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = _s(e.styles.textAlign), g = ys(e), o = 0, e.styles.textAlign) {
                  case Rt.CENTER:
                    o += g.width / 2;
                    break;
                  case Rt.RIGHT:
                    o += g.width;
                }
                i = g.add(o, 0, 0, -g.height / 2 + 1), this.ctx.save(), this.path([new ss(g.left, g.top), new ss(g.left + g.width, g.top), new ss(g.left + g.width, g.top + g.height), new ss(g.left, g.top + g.height)]), this.ctx.clip(), this.renderTextWithLetterSpacing(new Br(e.value, i), B.letterSpacing, c), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
              }
              if (!QB(e.styles.display, 2048)) return [3, 20];
              if (null === e.styles.listStyleImage) return [3, 19];
              if ((c = e.styles.listStyleImage).type !== pe.URL) return [3, 18];
              Q = void 0, c = c.url, A.label = 15;
            case 15:
              return A.trys.push([15, 17,, 18]), [4, this.context.cache.match(c)];
            case 16:
              return Q = A.sent(), this.ctx.drawImage(Q, e.bounds.left - (Q.width + 10), e.bounds.top), [3, 18];
            case 17:
              return A.sent(), this.context.logger.error("Error loading list-style-image " + c), [3, 18];
            case 18:
              return [3, 20];
            case 19:
              w.listValue && e.styles.listStyleType !== It.NONE && (a = this.createFontStyle(B)[0], this.ctx.font = a, this.ctx.fillStyle = te(B.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", g = new d(e.bounds.left, e.bounds.top + ie(e.styles.paddingTop, e.bounds.width), e.bounds.width, lt(B.lineHeight, B.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new Br(w.listValue, g), B.letterSpacing, lt(B.lineHeight, B.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), A.label = 20;
            case 20:
              return [2];
          }
        });
      });
    }, Ps.prototype.renderStackContent = function (l) {
      return a(this, void 0, void 0, function () {
        var e, t, B, r, n, s, o, i, Q, c, a, g, w, C, U;
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              return QB(l.element.container.flags, 16), [4, this.renderNodeBackgroundAndBorders(l.element)];
            case 1:
              A.sent(), e = 0, t = l.negativeZIndex, A.label = 2;
            case 2:
              return e < t.length ? (U = t[e], [4, this.renderStack(U)]) : [3, 5];
            case 3:
              A.sent(), A.label = 4;
            case 4:
              return e++, [3, 2];
            case 5:
              return [4, this.renderNodeContent(l.element)];
            case 6:
              A.sent(), B = 0, r = l.nonInlineLevel, A.label = 7;
            case 7:
              return B < r.length ? (U = r[B], [4, this.renderNode(U)]) : [3, 10];
            case 8:
              A.sent(), A.label = 9;
            case 9:
              return B++, [3, 7];
            case 10:
              n = 0, s = l.nonPositionedFloats, A.label = 11;
            case 11:
              return n < s.length ? (U = s[n], [4, this.renderStack(U)]) : [3, 14];
            case 12:
              A.sent(), A.label = 13;
            case 13:
              return n++, [3, 11];
            case 14:
              o = 0, i = l.nonPositionedInlineLevel, A.label = 15;
            case 15:
              return o < i.length ? (U = i[o], [4, this.renderStack(U)]) : [3, 18];
            case 16:
              A.sent(), A.label = 17;
            case 17:
              return o++, [3, 15];
            case 18:
              Q = 0, c = l.inlineLevel, A.label = 19;
            case 19:
              return Q < c.length ? (U = c[Q], [4, this.renderNode(U)]) : [3, 22];
            case 20:
              A.sent(), A.label = 21;
            case 21:
              return Q++, [3, 19];
            case 22:
              a = 0, g = l.zeroOrAutoZIndexOrTransformedOrOpacity, A.label = 23;
            case 23:
              return a < g.length ? (U = g[a], [4, this.renderStack(U)]) : [3, 26];
            case 24:
              A.sent(), A.label = 25;
            case 25:
              return a++, [3, 23];
            case 26:
              w = 0, C = l.positiveZIndex, A.label = 27;
            case 27:
              return w < C.length ? (U = C[w], [4, this.renderStack(U)]) : [3, 30];
            case 28:
              A.sent(), A.label = 29;
            case 29:
              return w++, [3, 27];
            case 30:
              return [2];
          }
        });
      });
    }, Ps.prototype.mask = function (A) {
      this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(A.slice(0).reverse()), this.ctx.closePath();
    }, Ps.prototype.path = function (A) {
      this.ctx.beginPath(), this.formatPath(A), this.ctx.closePath();
    }, Ps.prototype.formatPath = function (A) {
      var B = this;
      A.forEach(function (A, e) {
        var t = as(A) ? A.start : A;
        0 === e ? B.ctx.moveTo(t.x, t.y) : B.ctx.lineTo(t.x, t.y), as(A) && B.ctx.bezierCurveTo(A.startControl.x, A.startControl.y, A.endControl.x, A.endControl.y, A.end.x, A.end.y);
      });
    }, Ps.prototype.renderRepeat = function (A, e, t, B) {
      this.path(A), this.ctx.fillStyle = e, this.ctx.translate(t, B), this.ctx.fill(), this.ctx.translate(-t, -B);
    }, Ps.prototype.resizeImage = function (A, e, t) {
      if (A.width === e && A.height === t) return A;
      var B = (null !== (B = this.canvas.ownerDocument) && void 0 !== B ? B : document).createElement("canvas");
      return B.width = Math.max(1, e), B.height = Math.max(1, t), B.getContext("2d").drawImage(A, 0, 0, A.width, A.height, 0, 0, e, t), B;
    }, Ps.prototype.renderBackgroundImage = function (E) {
      return a(this, void 0, void 0, function () {
        var h, e, d, t, B, r;
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              h = E.styles.backgroundImage.length - 1, e = function (e) {
                var t, B, r, n, s, o, i, Q, c, a, g, w, C, U, l, F, u;
                return H(this, function (A) {
                  switch (A.label) {
                    case 0:
                      if (e.type !== pe.URL) return [3, 5];
                      t = void 0, B = e.url, A.label = 1;
                    case 1:
                      return A.trys.push([1, 3,, 4]), [4, d.context.cache.match(B)];
                    case 2:
                      return t = A.sent(), [3, 4];
                    case 3:
                      return A.sent(), d.context.logger.error("Error loading background-image " + B), [3, 4];
                    case 4:
                      return t && (r = Ks(E, h, [t.width, t.height, t.width / t.height]), o = r[0], g = r[1], w = r[2], c = r[3], a = r[4], s = d.ctx.createPattern(d.resizeImage(t, c, a), "repeat"), d.renderRepeat(o, s, g, w)), [3, 6];
                    case 5:
                      e.type === pe.LINEAR_GRADIENT ? (u = Ks(E, h, [null, null, null]), o = u[0], g = u[1], w = u[2], c = u[3], a = u[4], l = He(e.angle, c, a), U = l[0], r = l[1], i = l[2], F = l[3], Q = l[4], (u = document.createElement("canvas")).width = c, u.height = a, l = u.getContext("2d"), n = l.createLinearGradient(r, F, i, Q), Ee(e.stops, U).forEach(function (A) {
                        return n.addColorStop(A.stop, te(A.color));
                      }), l.fillStyle = n, l.fillRect(0, 0, c, a), 0 < c && 0 < a && (s = d.ctx.createPattern(u, "repeat"), d.renderRepeat(o, s, g, w))) : e.type === pe.RADIAL_GRADIENT && (F = Ks(E, h, [null, null, null]), o = F[0], i = F[1], Q = F[2], c = F[3], a = F[4], U = 0 === e.position.length ? [se] : e.position, g = ie(U[0], c), w = ie(U[U.length - 1], a), l = function (A, e, t, B, r) {
                        var n,
                          s,
                          o,
                          i,
                          Q = 0,
                          c = 0;
                        switch (A.size) {
                          case Te.CLOSEST_SIDE:
                            A.shape === Se.CIRCLE ? Q = c = Math.min(Math.abs(e), Math.abs(e - B), Math.abs(t), Math.abs(t - r)) : A.shape === Se.ELLIPSE && (Q = Math.min(Math.abs(e), Math.abs(e - B)), c = Math.min(Math.abs(t), Math.abs(t - r)));
                            break;
                          case Te.CLOSEST_CORNER:
                            A.shape === Se.CIRCLE ? Q = c = Math.min(fe(e, t), fe(e, t - r), fe(e - B, t), fe(e - B, t - r)) : A.shape === Se.ELLIPSE && (n = Math.min(Math.abs(t), Math.abs(t - r)) / Math.min(Math.abs(e), Math.abs(e - B)), o = (s = Ie(B, r, e, t, !0))[0], i = s[1], c = n * (Q = fe(o - e, (i - t) / n)));
                            break;
                          case Te.FARTHEST_SIDE:
                            A.shape === Se.CIRCLE ? Q = c = Math.max(Math.abs(e), Math.abs(e - B), Math.abs(t), Math.abs(t - r)) : A.shape === Se.ELLIPSE && (Q = Math.max(Math.abs(e), Math.abs(e - B)), c = Math.max(Math.abs(t), Math.abs(t - r)));
                            break;
                          case Te.FARTHEST_CORNER:
                            A.shape === Se.CIRCLE ? Q = c = Math.max(fe(e, t), fe(e, t - r), fe(e - B, t), fe(e - B, t - r)) : A.shape === Se.ELLIPSE && (n = Math.max(Math.abs(t), Math.abs(t - r)) / Math.max(Math.abs(e), Math.abs(e - B)), o = (s = Ie(B, r, e, t, !1))[0], i = s[1], c = n * (Q = fe(o - e, (i - t) / n)));
                        }
                        return Array.isArray(A.size) && (Q = ie(A.size[0], B), c = 2 === A.size.length ? ie(A.size[1], r) : Q), [Q, c];
                      }(e, g, w, c, a), u = l[0], F = l[1], 0 < u && 0 < F && (C = d.ctx.createRadialGradient(i + g, Q + w, 0, i + g, Q + w, u), Ee(e.stops, 2 * u).forEach(function (A) {
                        return C.addColorStop(A.stop, te(A.color));
                      }), d.path(o), d.ctx.fillStyle = C, u !== F ? (U = E.bounds.left + .5 * E.bounds.width, l = E.bounds.top + .5 * E.bounds.height, u = 1 / (F = F / u), d.ctx.save(), d.ctx.translate(U, l), d.ctx.transform(1, 0, 0, F, 0, 0), d.ctx.translate(-U, -l), d.ctx.fillRect(i, u * (Q - l) + l, c, a * u), d.ctx.restore()) : d.ctx.fill())), A.label = 6;
                    case 6:
                      return h--, [2];
                  }
                });
              }, d = this, t = 0, B = E.styles.backgroundImage.slice(0).reverse(), A.label = 1;
            case 1:
              return t < B.length ? (r = B[t], [5, e(r)]) : [3, 4];
            case 2:
              A.sent(), A.label = 3;
            case 3:
              return t++, [3, 1];
            case 4:
              return [2];
          }
        });
      });
    }, Ps.prototype.renderSolidBorder = function (e, t, B) {
      return a(this, void 0, void 0, function () {
        return H(this, function (A) {
          return this.path(Is(B, t)), this.ctx.fillStyle = te(e), this.ctx.fill(), [2];
        });
      });
    }, Ps.prototype.renderDoubleBorder = function (t, B, r, n) {
      return a(this, void 0, void 0, function () {
        var e;
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              return B < 3 ? [4, this.renderSolidBorder(t, r, n)] : [3, 2];
            case 1:
              return A.sent(), [2];
            case 2:
              return e = function (A, e) {
                switch (e) {
                  case 0:
                    return Os(A.topLeftBorderBox, A.topLeftBorderDoubleOuterBox, A.topRightBorderBox, A.topRightBorderDoubleOuterBox);
                  case 1:
                    return Os(A.topRightBorderBox, A.topRightBorderDoubleOuterBox, A.bottomRightBorderBox, A.bottomRightBorderDoubleOuterBox);
                  case 2:
                    return Os(A.bottomRightBorderBox, A.bottomRightBorderDoubleOuterBox, A.bottomLeftBorderBox, A.bottomLeftBorderDoubleOuterBox);
                  default:
                    return Os(A.bottomLeftBorderBox, A.bottomLeftBorderDoubleOuterBox, A.topLeftBorderBox, A.topLeftBorderDoubleOuterBox);
                }
              }(n, r), this.path(e), this.ctx.fillStyle = te(t), this.ctx.fill(), e = function (A, e) {
                switch (e) {
                  case 0:
                    return Os(A.topLeftBorderDoubleInnerBox, A.topLeftPaddingBox, A.topRightBorderDoubleInnerBox, A.topRightPaddingBox);
                  case 1:
                    return Os(A.topRightBorderDoubleInnerBox, A.topRightPaddingBox, A.bottomRightBorderDoubleInnerBox, A.bottomRightPaddingBox);
                  case 2:
                    return Os(A.bottomRightBorderDoubleInnerBox, A.bottomRightPaddingBox, A.bottomLeftBorderDoubleInnerBox, A.bottomLeftPaddingBox);
                  default:
                    return Os(A.bottomLeftBorderDoubleInnerBox, A.bottomLeftPaddingBox, A.topLeftBorderDoubleInnerBox, A.topLeftPaddingBox);
                }
              }(n, r), this.path(e), this.ctx.fill(), [2];
          }
        });
      });
    }, Ps.prototype.renderNodeBackgroundAndBorders = function (c) {
      return a(this, void 0, void 0, function () {
        var e,
          t,
          B,
          r,
          n,
          s,
          o,
          i,
          Q = this;
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              return (this.applyEffects(c.getEffects(2)), e = c.container.styles, t = !ee(e.backgroundColor) || e.backgroundImage.length, B = [{
                style: e.borderTopStyle,
                color: e.borderTopColor,
                width: e.borderTopWidth
              }, {
                style: e.borderRightStyle,
                color: e.borderRightColor,
                width: e.borderRightWidth
              }, {
                style: e.borderBottomStyle,
                color: e.borderBottomColor,
                width: e.borderBottomWidth
              }, {
                style: e.borderLeftStyle,
                color: e.borderLeftColor,
                width: e.borderLeftWidth
              }], r = Xs(Ts(e.backgroundClip, 0), c.curves), t || e.boxShadow.length) ? (this.ctx.save(), this.path(r), this.ctx.clip(), ee(e.backgroundColor) || (this.ctx.fillStyle = te(e.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(c.container)]) : [3, 2];
            case 1:
              A.sent(), this.ctx.restore(), e.boxShadow.slice(0).reverse().forEach(function (A) {
                Q.ctx.save();
                var t,
                  B,
                  r,
                  n,
                  e = Cs(c.curves),
                  s = A.inset ? 0 : 1e4,
                  o = (t = -s + (A.inset ? 1 : -1) * A.spread.number, B = (A.inset ? 1 : -1) * A.spread.number, r = A.spread.number * (A.inset ? -2 : 2), n = A.spread.number * (A.inset ? -2 : 2), e.map(function (A, e) {
                    switch (e) {
                      case 0:
                        return A.add(t, B);
                      case 1:
                        return A.add(t + r, B);
                      case 2:
                        return A.add(t + r, B + n);
                      case 3:
                        return A.add(t, B + n);
                    }
                    return A;
                  }));
                A.inset ? (Q.path(e), Q.ctx.clip(), Q.mask(o)) : (Q.mask(e), Q.ctx.clip(), Q.path(o)), Q.ctx.shadowOffsetX = A.offsetX.number + s, Q.ctx.shadowOffsetY = A.offsetY.number, Q.ctx.shadowColor = te(A.color), Q.ctx.shadowBlur = A.blur.number, Q.ctx.fillStyle = A.inset ? te(A.color) : "rgba(0,0,0,1)", Q.ctx.fill(), Q.ctx.restore();
              }), A.label = 2;
            case 2:
              s = n = 0, o = B, A.label = 3;
            case 3:
              return s < o.length ? (i = o[s]).style !== _e.NONE && !ee(i.color) && 0 < i.width ? i.style !== _e.DASHED ? [3, 5] : [4, this.renderDashedDottedBorder(i.color, i.width, n, c.curves, _e.DASHED)] : [3, 11] : [3, 13];
            case 4:
              return A.sent(), [3, 11];
            case 5:
              return i.style !== _e.DOTTED ? [3, 7] : [4, this.renderDashedDottedBorder(i.color, i.width, n, c.curves, _e.DOTTED)];
            case 6:
              return A.sent(), [3, 11];
            case 7:
              return i.style !== _e.DOUBLE ? [3, 9] : [4, this.renderDoubleBorder(i.color, i.width, n, c.curves)];
            case 8:
              return A.sent(), [3, 11];
            case 9:
              return [4, this.renderSolidBorder(i.color, n, c.curves)];
            case 10:
              A.sent(), A.label = 11;
            case 11:
              n++, A.label = 12;
            case 12:
              return s++, [3, 3];
            case 13:
              return [2];
          }
        });
      });
    }, Ps.prototype.renderDashedDottedBorder = function (g, w, C, U, l) {
      return a(this, void 0, void 0, function () {
        var e, t, B, r, n, s, o, i, Q, c, a;
        return H(this, function (A) {
          return this.ctx.save(), Q = function (A, e) {
            switch (e) {
              case 0:
                return Rs(A.topLeftBorderStroke, A.topRightBorderStroke);
              case 1:
                return Rs(A.topRightBorderStroke, A.bottomRightBorderStroke);
              case 2:
                return Rs(A.bottomRightBorderStroke, A.bottomLeftBorderStroke);
              default:
                return Rs(A.bottomLeftBorderStroke, A.topLeftBorderStroke);
            }
          }(U, C), e = Is(U, C), l === _e.DASHED && (this.path(e), this.ctx.clip()), s = as(e[0]) ? (t = e[0].start.x, e[0].start.y) : (t = e[0].x, e[0].y), o = as(e[1]) ? (B = e[1].end.x, e[1].end.y) : (B = e[1].x, e[1].y), r = 0 === C || 2 === C ? Math.abs(t - B) : Math.abs(s - o), this.ctx.beginPath(), l === _e.DOTTED ? this.formatPath(Q) : this.formatPath(e.slice(0, 2)), n = w < 3 ? 3 * w : 2 * w, s = w < 3 ? 2 * w : w, l === _e.DOTTED && (s = n = w), o = !0, r <= 2 * n ? o = !1 : r <= 2 * n + s ? (n *= i = r / (2 * n + s), s *= i) : (Q = Math.floor((r + s) / (n + s)), i = (r - Q * n) / (Q - 1), s = (Q = (r - (Q + 1) * n) / Q) <= 0 || Math.abs(s - i) < Math.abs(s - Q) ? i : Q), o && (l === _e.DOTTED ? this.ctx.setLineDash([0, n + s]) : this.ctx.setLineDash([n, s])), l === _e.DOTTED ? (this.ctx.lineCap = "round", this.ctx.lineWidth = w) : this.ctx.lineWidth = 2 * w + 1.1, this.ctx.strokeStyle = te(g), this.ctx.stroke(), this.ctx.setLineDash([]), l === _e.DASHED && (as(e[0]) && (c = e[3], a = e[0], this.ctx.beginPath(), this.formatPath([new ss(c.end.x, c.end.y), new ss(a.start.x, a.start.y)]), this.ctx.stroke()), as(e[1]) && (c = e[1], a = e[2], this.ctx.beginPath(), this.formatPath([new ss(c.end.x, c.end.y), new ss(a.start.x, a.start.y)]), this.ctx.stroke())), this.ctx.restore(), [2];
        });
      });
    }, Ps.prototype.render = function (r) {
      return a(this, void 0, void 0, function () {
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              return this.options.backgroundColor && (this.ctx.fillStyle = te(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), t = new Hs(e = r, null), B = new Es(t), Ds(t, B, B, e = []), bs(t.container, e), [4, this.renderStack(B)];
            case 1:
              return A.sent(), this.applyEffects([]), [2, this.canvas];
          }
          var e, t, B;
        });
      });
    }, Ps);
  function Ps(A, e) {
    A = xs.call(this, A, e) || this;
    return A._activeEffects = [], A.canvas = e.canvas || document.createElement("canvas"), A.ctx = A.canvas.getContext("2d"), e.canvas || (A.canvas.width = Math.floor(e.width * e.scale), A.canvas.height = Math.floor(e.height * e.scale), A.canvas.style.width = e.width + "px", A.canvas.style.height = e.height + "px"), A.fontMetrics = new Ns(document), A.ctx.scale(A.options.scale, A.options.scale), A.ctx.translate(-e.x, -e.y), A.ctx.textBaseline = "bottom", A._activeEffects = [], A.context.logger.debug("Canvas renderer initialized (" + e.width + "x" + e.height + ") with scale " + e.scale), A;
  }
  var ks,
    Js = function (A) {
      return A instanceof Vr || A instanceof Nr || A instanceof Tr && A.type !== Rr && A.type !== br;
    },
    Xs = function (A, e) {
      switch (A) {
        case le.BORDER_BOX:
          return Cs(e);
        case le.CONTENT_BOX:
          return [e.topLeftContentBox, e.topRightContentBox, e.bottomRightContentBox, e.bottomLeftContentBox];
        default:
          le.PADDING_BOX;
          return Us(e);
      }
    },
    _s = function (A) {
      switch (A) {
        case Rt.CENTER:
          return "center";
        case Rt.RIGHT:
          return "right";
        default:
          Rt.LEFT;
          return "left";
      }
    },
    Ys = (A(Ws, ks = we), Ws.prototype.render = function (t) {
      return a(this, void 0, void 0, function () {
        var e;
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              return e = Ar(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, t), [4, Zs(e)];
            case 1:
              return e = A.sent(), this.options.backgroundColor && (this.ctx.fillStyle = te(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(e, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
          }
        });
      });
    }, Ws);
  function Ws(A, e) {
    A = ks.call(this, A, e) || this;
    return A.canvas = e.canvas || document.createElement("canvas"), A.ctx = A.canvas.getContext("2d"), A.options = e, A.canvas.width = Math.floor(e.width * e.scale), A.canvas.height = Math.floor(e.height * e.scale), A.canvas.style.width = e.width + "px", A.canvas.style.height = e.height + "px", A.ctx.scale(A.options.scale, A.options.scale), A.ctx.translate(-e.x, -e.y), A.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + e.width + "x" + e.height + " at " + e.x + "," + e.y + ") with scale " + e.scale), A;
  }
  var Zs = function (B) {
      return new Promise(function (A, e) {
        var t = new Image();
        t.onload = function () {
          A(t);
        }, t.onerror = e, t.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(B));
      });
    },
    qs = (js.prototype.debug = function () {
      for (var A = [], e = 0; e < arguments.length; e++) A[e] = arguments[e];
      this.enabled && ("undefined" != typeof window && window.console && "function" == typeof console.debug ? console.debug.apply(console, t([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, js.prototype.getTime = function () {
      return Date.now() - this.start;
    }, js.prototype.info = function () {
      for (var A = [], e = 0; e < arguments.length; e++) A[e] = arguments[e];
      this.enabled && "undefined" != typeof window && window.console && "function" == typeof console.info && console.info.apply(console, t([this.id, this.getTime() + "ms"], A));
    }, js.prototype.warn = function () {
      for (var A = [], e = 0; e < arguments.length; e++) A[e] = arguments[e];
      this.enabled && ("undefined" != typeof window && window.console && "function" == typeof console.warn ? console.warn.apply(console, t([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, js.prototype.error = function () {
      for (var A = [], e = 0; e < arguments.length; e++) A[e] = arguments[e];
      this.enabled && ("undefined" != typeof window && window.console && "function" == typeof console.error ? console.error.apply(console, t([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, js.instances = {}, js);
  function js(A) {
    var e = A.id,
      A = A.enabled;
    this.id = e, this.enabled = A, this.start = Date.now();
  }
  var zs = ($s.instanceCount = 1, $s);
  function $s(A, e) {
    this.windowBounds = e, this.instanceName = "#" + $s.instanceCount++, this.logger = new qs({
      id: this.instanceName,
      enabled: A.logging
    }), this.cache = null !== (e = A.cache) && void 0 !== e ? e : new Wn(this, A);
  }
  "undefined" != typeof window && _n.setContext(window);
  var Ao = function (F, u) {
      return a(void 0, void 0, void 0, function () {
        var e, t, B, r, n, s, o, i, Q, c, a, g, w, C, U, l;
        return H(this, function (A) {
          switch (A.label) {
            case 0:
              if (!F || "object" != typeof F) return [2, Promise.reject("Invalid element provided as first argument")];
              if (!(e = F.ownerDocument)) throw new Error("Element is not attached to a Document");
              if (!(t = e.defaultView)) throw new Error("Document is not attached to a Window");
              return w = {
                allowTaint: null !== (C = u.allowTaint) && void 0 !== C && C,
                imageTimeout: null !== (c = u.imageTimeout) && void 0 !== c ? c : 15e3,
                proxy: u.proxy,
                useCORS: null !== (a = u.useCORS) && void 0 !== a && a
              }, C = h({
                logging: null === (g = u.logging) || void 0 === g || g,
                cache: u.cache
              }, w), c = {
                windowWidth: null !== (c = u.windowWidth) && void 0 !== c ? c : t.innerWidth,
                windowHeight: null !== (a = u.windowHeight) && void 0 !== a ? a : t.innerHeight,
                scrollX: null !== (g = u.scrollX) && void 0 !== g ? g : t.pageXOffset,
                scrollY: null !== (w = u.scrollY) && void 0 !== w ? w : t.pageYOffset
              }, a = new d(c.scrollX, c.scrollY, c.windowWidth, c.windowHeight), g = new zs(C, a), c = null !== (w = u.foreignObjectRendering) && void 0 !== w && w, w = {
                allowTaint: null !== (C = u.allowTaint) && void 0 !== C && C,
                onclone: u.onclone,
                ignoreElements: u.ignoreElements,
                inlineImages: c,
                copyStyles: c
              }, g.logger.debug("Starting document clone with size " + a.width + "x" + a.height + " scrolled to " + -a.left + "," + -a.top), C = new Dn(g, F, w), (w = C.clonedReferenceElement) ? [4, C.toIFrame(e, a)] : [2, Promise.reject("Unable to find element in cloned iframe")];
            case 1:
              return (B = A.sent(), U = on(w) || "HTML" === w.tagName ? function (A) {
                var e = A.body,
                  t = A.documentElement;
                if (!e || !t) throw new Error("Unable to get document size");
                A = Math.max(Math.max(e.scrollWidth, t.scrollWidth), Math.max(e.offsetWidth, t.offsetWidth), Math.max(e.clientWidth, t.clientWidth)), t = Math.max(Math.max(e.scrollHeight, t.scrollHeight), Math.max(e.offsetHeight, t.offsetHeight), Math.max(e.clientHeight, t.clientHeight));
                return new d(0, 0, A, t);
              }(w.ownerDocument) : E(g, w), r = U.width, n = U.height, s = U.left, o = U.top, i = eo(g, w, u.backgroundColor), U = {
                canvas: u.canvas,
                backgroundColor: i,
                scale: null !== (U = null !== (U = u.scale) && void 0 !== U ? U : t.devicePixelRatio) && void 0 !== U ? U : 1,
                x: (null !== (U = u.x) && void 0 !== U ? U : 0) + s,
                y: (null !== (U = u.y) && void 0 !== U ? U : 0) + o,
                width: null !== (U = u.width) && void 0 !== U ? U : Math.ceil(r),
                height: null !== (U = u.height) && void 0 !== U ? U : Math.ceil(n)
              }, c) ? (g.logger.debug("Document cloned, using foreign object rendering"), [4, new Ys(g, U).render(w)]) : [3, 3];
            case 2:
              return Q = A.sent(), [3, 5];
            case 3:
              return g.logger.debug("Document cloned, element located at " + s + "," + o + " with size " + r + "x" + n + " using computed rendering"), g.logger.debug("Starting DOM parsing"), l = qr(g, w), i === l.styles.backgroundColor && (l.styles.backgroundColor = he.TRANSPARENT), g.logger.debug("Starting renderer for element at " + U.x + "," + U.y + " with size " + U.width + "x" + U.height), [4, new Vs(g, U).render(l)];
            case 4:
              Q = A.sent(), A.label = 5;
            case 5:
              return null !== (l = u.removeContainer) && void 0 !== l && !l || Dn.destroy(B) || g.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore"), g.logger.debug("Finished rendering"), [2, Q];
          }
        });
      });
    },
    eo = function (A, e, t) {
      var B = e.ownerDocument,
        r = B.documentElement ? Ue(A, getComputedStyle(B.documentElement).backgroundColor) : he.TRANSPARENT,
        n = B.body ? Ue(A, getComputedStyle(B.body).backgroundColor) : he.TRANSPARENT,
        t = "string" == typeof t ? Ue(A, t) : null === t ? he.TRANSPARENT : 4294967295;
      return e === B.documentElement ? ee(r) ? ee(n) ? t : n : r : t;
    };
  return function (A, e) {
    return Ao(A, e = void 0 === e ? {} : e);
  };
});
/** @license jsPDF v2.4.0 | Copyright (c) 2010-2021 James Hall <james@parall.ax>, [https://github.com/parallax/jsPDF] | MIT License [https://github.com/parallax/jsPDF/blob/master/LICENSE] */
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e((t = t || self).jspdf = {}) : "function" == typeof define && define.amd ? e((t = t || self).jspdf = {}) : e((t = t || self).jspdf = {});
}(window, function (t) {
  "use strict";

  function e(t) {
    return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  var r = function () {
    return "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this;
  }();
  function n() {
    r.console && "function" == typeof r.console.log && r.console.log.apply(r.console, arguments);
  }
  var i = {
    log: n,
    warn: function (t) {
      r.console && ("function" == typeof r.console.warn ? r.console.warn.apply(r.console, arguments) : n.call(null, arguments));
    },
    error: function (t) {
      r.console && ("function" == typeof r.console.error ? r.console.error.apply(r.console, arguments) : n(t));
    }
  };
  function a(t, e, r) {
    var n = new XMLHttpRequest();
    n.open("GET", t), n.responseType = "blob", n.onload = function () {
      h(n.response, e, r);
    }, n.onerror = function () {
      i.error("could not download file");
    }, n.send();
  }
  function o(t) {
    var e = new XMLHttpRequest();
    e.open("HEAD", t, !1);
    try {
      e.send();
    } catch (t) {}
    return e.status >= 200 && e.status <= 299;
  }
  function s(t) {
    try {
      t.dispatchEvent(new MouseEvent("click"));
    } catch (r) {
      var e = document.createEvent("MouseEvents");
      e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
  }
  var c,
    u,
    h = r.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : e(window)) || window !== r ? function () {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function (t, e, n) {
      var i = r.URL || r.webkitURL,
        c = document.createElement("a");
      e = e || t.name || "download", c.download = e, c.rel = "noopener", "string" == typeof t ? (c.href = t, c.origin !== location.origin ? o(c.href) ? a(t, e, n) : s(c, c.target = "_blank") : s(c)) : (c.href = i.createObjectURL(t), setTimeout(function () {
        i.revokeObjectURL(c.href);
      }, 4e4), setTimeout(function () {
        s(c);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function (t, r, n) {
      if (r = r || t.name || "download", "string" == typeof t) {
        if (o(t)) a(t, r, n);else {
          var c = document.createElement("a");
          c.href = t, c.target = "_blank", setTimeout(function () {
            s(c);
          });
        }
      } else navigator.msSaveOrOpenBlob(function (t, r) {
        return void 0 === r ? r = {
          autoBom: !1
        } : "object" !== e(r) && (i.warn("Deprecated: Expected third argument to be a object"), r = {
          autoBom: !r
        }), r.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([String.fromCharCode(65279), t], {
          type: t.type
        }) : t;
      }(t, n), r);
    } : function (t, n, i, o) {
      if ((o = o || open("", "_blank")) && (o.document.title = o.document.body.innerText = "downloading..."), "string" == typeof t) return a(t, n, i);
      var s = "application/octet-stream" === t.type,
        c = /constructor/i.test(r.HTMLElement) || r.safari,
        u = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((u || s && c) && "object" === ("undefined" == typeof FileReader ? "undefined" : e(FileReader))) {
        var h = new FileReader();
        h.onloadend = function () {
          var t = h.result;
          t = u ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), o ? o.location.href = t : location = t, o = null;
        }, h.readAsDataURL(t);
      } else {
        var l = r.URL || r.webkitURL,
          f = l.createObjectURL(t);
        o ? o.location = f : location.href = f, o = null, setTimeout(function () {
          l.revokeObjectURL(f);
        }, 4e4);
      }
    });
  /**
     * A class to parse color values
     * @author Stoyan Stefanov <sstoo@gmail.com>
     * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
     * @license Use it if you like it
     */
  function l(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6));
    t = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "00ffff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000000",
      blanchedalmond: "ffebcd",
      blue: "0000ff",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "00ffff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dodgerblue: "1e90ff",
      feldspar: "d19275",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "ff00ff",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgrey: "d3d3d3",
      lightgreen: "90ee90",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslateblue: "8470ff",
      lightslategray: "778899",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "00ff00",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "ff00ff",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370d8",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "d87093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      red: "ff0000",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      violetred: "d02090",
      wheat: "f5deb3",
      white: "ffffff",
      whitesmoke: "f5f5f5",
      yellow: "ffff00",
      yellowgreen: "9acd32"
    }[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for (var r = [{
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
        process: function (t) {
          return [parseInt(t[1]), parseInt(t[2]), parseInt(t[3])];
        }
      }, {
        re: /^(\w{2})(\w{2})(\w{2})$/,
        example: ["#00ff00", "336699"],
        process: function (t) {
          return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)];
        }
      }, {
        re: /^(\w{1})(\w{1})(\w{1})$/,
        example: ["#fb0", "f0f"],
        process: function (t) {
          return [parseInt(t[1] + t[1], 16), parseInt(t[2] + t[2], 16), parseInt(t[3] + t[3], 16)];
        }
      }], n = 0; n < r.length; n++) {
      var i = r[n].re,
        a = r[n].process,
        o = i.exec(t);
      o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function () {
      return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function () {
      var t = this.r.toString(16),
        e = this.g.toString(16),
        r = this.b.toString(16);
      return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == r.length && (r = "0" + r), "#" + t + e + r;
    };
  }
  /**
     * @license
     * Joseph Myers does not specify a particular license for his work.
     *
     * Author: Joseph Myers
     * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
     *
     * Modified by: Owen Leong
     */
  function f(t, e) {
    var r = t[0],
      n = t[1],
      i = t[2],
      a = t[3];
    r = p(r, n, i, a, e[0], 7, -680876936), a = p(a, r, n, i, e[1], 12, -389564586), i = p(i, a, r, n, e[2], 17, 606105819), n = p(n, i, a, r, e[3], 22, -1044525330), r = p(r, n, i, a, e[4], 7, -176418897), a = p(a, r, n, i, e[5], 12, 1200080426), i = p(i, a, r, n, e[6], 17, -1473231341), n = p(n, i, a, r, e[7], 22, -45705983), r = p(r, n, i, a, e[8], 7, 1770035416), a = p(a, r, n, i, e[9], 12, -1958414417), i = p(i, a, r, n, e[10], 17, -42063), n = p(n, i, a, r, e[11], 22, -1990404162), r = p(r, n, i, a, e[12], 7, 1804603682), a = p(a, r, n, i, e[13], 12, -40341101), i = p(i, a, r, n, e[14], 17, -1502002290), r = g(r, n = p(n, i, a, r, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = g(a, r, n, i, e[6], 9, -1069501632), i = g(i, a, r, n, e[11], 14, 643717713), n = g(n, i, a, r, e[0], 20, -373897302), r = g(r, n, i, a, e[5], 5, -701558691), a = g(a, r, n, i, e[10], 9, 38016083), i = g(i, a, r, n, e[15], 14, -660478335), n = g(n, i, a, r, e[4], 20, -405537848), r = g(r, n, i, a, e[9], 5, 568446438), a = g(a, r, n, i, e[14], 9, -1019803690), i = g(i, a, r, n, e[3], 14, -187363961), n = g(n, i, a, r, e[8], 20, 1163531501), r = g(r, n, i, a, e[13], 5, -1444681467), a = g(a, r, n, i, e[2], 9, -51403784), i = g(i, a, r, n, e[7], 14, 1735328473), r = m(r, n = g(n, i, a, r, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = m(a, r, n, i, e[8], 11, -2022574463), i = m(i, a, r, n, e[11], 16, 1839030562), n = m(n, i, a, r, e[14], 23, -35309556), r = m(r, n, i, a, e[1], 4, -1530992060), a = m(a, r, n, i, e[4], 11, 1272893353), i = m(i, a, r, n, e[7], 16, -155497632), n = m(n, i, a, r, e[10], 23, -1094730640), r = m(r, n, i, a, e[13], 4, 681279174), a = m(a, r, n, i, e[0], 11, -358537222), i = m(i, a, r, n, e[3], 16, -722521979), n = m(n, i, a, r, e[6], 23, 76029189), r = m(r, n, i, a, e[9], 4, -640364487), a = m(a, r, n, i, e[12], 11, -421815835), i = m(i, a, r, n, e[15], 16, 530742520), r = v(r, n = m(n, i, a, r, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = v(a, r, n, i, e[7], 10, 1126891415), i = v(i, a, r, n, e[14], 15, -1416354905), n = v(n, i, a, r, e[5], 21, -57434055), r = v(r, n, i, a, e[12], 6, 1700485571), a = v(a, r, n, i, e[3], 10, -1894986606), i = v(i, a, r, n, e[10], 15, -1051523), n = v(n, i, a, r, e[1], 21, -2054922799), r = v(r, n, i, a, e[8], 6, 1873313359), a = v(a, r, n, i, e[15], 10, -30611744), i = v(i, a, r, n, e[6], 15, -1560198380), n = v(n, i, a, r, e[13], 21, 1309151649), r = v(r, n, i, a, e[4], 6, -145523070), a = v(a, r, n, i, e[11], 10, -1120210379), i = v(i, a, r, n, e[2], 15, 718787259), n = v(n, i, a, r, e[9], 21, -343485551), t[0] = S(r, t[0]), t[1] = S(n, t[1]), t[2] = S(i, t[2]), t[3] = S(a, t[3]);
  }
  function d(t, e, r, n, i, a) {
    return e = S(S(e, t), S(n, a)), S(e << i | e >>> 32 - i, r);
  }
  function p(t, e, r, n, i, a, o) {
    return d(e & r | ~e & n, t, e, i, a, o);
  }
  function g(t, e, r, n, i, a, o) {
    return d(e & n | r & ~n, t, e, i, a, o);
  }
  function m(t, e, r, n, i, a, o) {
    return d(e ^ r ^ n, t, e, i, a, o);
  }
  function v(t, e, r, n, i, a, o) {
    return d(r ^ (e | ~n), t, e, i, a, o);
  }
  function b(t) {
    var e,
      r = t.length,
      n = [1732584193, -271733879, -1732584194, 271733878];
    for (e = 64; e <= t.length; e += 64) f(n, y(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (e = 0; e < t.length; e++) i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for (f(n, i), e = 0; e < 16; e++) i[e] = 0;
    return i[14] = 8 * r, f(n, i), n;
  }
  function y(t) {
    var e,
      r = [];
    for (e = 0; e < 64; e += 4) r[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return r;
  }
  c = r.atob.bind(r), u = r.btoa.bind(r);
  var w = "0123456789abcdef".split("");
  function N(t) {
    for (var e = "", r = 0; r < 4; r++) e += w[t >> 8 * r + 4 & 15] + w[t >> 8 * r & 15];
    return e;
  }
  function L(t) {
    return String.fromCharCode((255 & t) >> 0, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
  }
  function A(t) {
    return function (t) {
      return t.map(L).join("");
    }(b(t));
  }
  var x = "5d41402abc4b2a76b9719d911017c592" != function (t) {
    for (var e = 0; e < t.length; e++) t[e] = N(t[e]);
    return t.join("");
  }(b("hello"));
  function S(t, e) {
    if (x) {
      var r = (65535 & t) + (65535 & e);
      return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
    }
    return t + e & 4294967295;
  }
  /**
     * @license
     * FPDF is released under a permissive license: there is no usage restriction.
     * You may embed it freely in your application (commercial or not), with or
     * without modifications.
     *
     * Reference: http://www.fpdf.org/en/script/script37.php
     */
  function _(t, e) {
    var r, n, i, a;
    if (t !== r) {
      for (var o = (i = t, a = 1 + (256 / t.length >> 0), new Array(a + 1).join(i)), s = [], c = 0; c < 256; c++) s[c] = c;
      var u = 0;
      for (c = 0; c < 256; c++) {
        var h = s[c];
        u = (u + h + o.charCodeAt(c)) % 256, s[c] = s[u], s[u] = h;
      }
      r = t, n = s;
    } else s = n;
    var l = e.length,
      f = 0,
      d = 0,
      p = "";
    for (c = 0; c < l; c++) d = (d + (h = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = h, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(c) ^ o);
    return p;
  }
  /**
     * @license
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     * Author: Owen Leong (@owenl131)
     * Date: 15 Oct 2020
     * References:
     * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
     * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
     * http://www.fpdf.org/en/script/script37.php
     */
  var P = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
  };
  function k(t, e, r, n) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function (t) {
      if (void 0 !== P.perm) throw new Error("Invalid permission: " + t);
      i += P[t];
    }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶�?h>/\f©þdSiz";
    var a = (e + this.padding).substr(0, 32),
      o = (r + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = A(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n)).substr(0, 5), this.U = _(this.encryptionKey, this.padding);
  }
  function F(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for (var e = "", r = t.length, n = 0; n < r; n++) {
      var i = t.charCodeAt(n);
      if (i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126) e += "#" + ("0" + i.toString(16)).slice(-2);else e += t[n];
    }
    return e;
  }
  function I(t) {
    if ("object" !== e(t)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var n = {};
    this.subscribe = function (t, e, r) {
      if (r = r || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof r) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
      n.hasOwnProperty(t) || (n[t] = {});
      var i = Math.random().toString(35);
      return n[t][i] = [e, !!r], i;
    }, this.unsubscribe = function (t) {
      for (var e in n) if (n[e][t]) return delete n[e][t], 0 === Object.keys(n[e]).length && delete n[e], !0;
      return !1;
    }, this.publish = function (e) {
      if (n.hasOwnProperty(e)) {
        var a = Array.prototype.slice.call(arguments, 1),
          o = [];
        for (var s in n[e]) {
          var c = n[e][s];
          try {
            c[0].apply(t, a);
          } catch (t) {
            r.console && i.error("jsPDF PubSub Error", t.message, t);
          }
          c[1] && o.push(s);
        }
        o.length && o.forEach(this.unsubscribe);
      }
    }, this.getTopics = function () {
      return n;
    };
  }
  function C(t) {
    if (!(this instanceof C)) return new C(t);
    var e = "opacity,stroke-opacity".split(",");
    for (var r in t) t.hasOwnProperty(r) && e.indexOf(r) >= 0 && (this[r] = t[r]);
    this.id = "", this.objectNumber = -1;
  }
  function j(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
  }
  function O(t, e, r, n, i) {
    if (!(this instanceof O)) return new O(t, e, r, n, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = r, j.call(this, n, i);
  }
  function B(t, e, r, n, i) {
    if (!(this instanceof B)) return new B(t, e, r, n, i);
    this.boundingBox = t, this.xStep = e, this.yStep = r, this.stream = "", this.cloneIndex = 0, j.call(this, n, i);
  }
  function M(t) {
    var n,
      a = "string" == typeof arguments[0] ? arguments[0] : "p",
      o = arguments[1],
      s = arguments[2],
      c = arguments[3],
      f = [],
      d = 1,
      p = 16,
      g = "S",
      m = null;
    "object" === e(t = t || {}) && (a = t.orientation, o = t.unit || o, s = t.format || s, c = t.compress || t.compressPdf || c, null !== (m = t.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), d = "number" == typeof t.userUnit ? Math.abs(t.userUnit) : 1, void 0 !== t.precision && (n = t.precision), void 0 !== t.floatPrecision && (p = t.floatPrecision), g = t.defaultPathOperation || "S"), f = t.filters || (!0 === c ? ["FlateEncode"] : f), o = o || "mm", a = ("" + (a || "P")).toLowerCase();
    var v = t.putOnlyUsedFonts || !1,
      b = {},
      y = {
        internal: {},
        __private__: {}
      };
    y.__private__.PubSub = I;
    var w = "1.3",
      N = y.__private__.getPdfVersion = function () {
        return w;
      };
    y.__private__.setPdfVersion = function (t) {
      w = t;
    };
    var L = {
      a0: [2383.94, 3370.39],
      a1: [1683.78, 2383.94],
      a2: [1190.55, 1683.78],
      a3: [841.89, 1190.55],
      a4: [595.28, 841.89],
      a5: [419.53, 595.28],
      a6: [297.64, 419.53],
      a7: [209.76, 297.64],
      a8: [147.4, 209.76],
      a9: [104.88, 147.4],
      a10: [73.7, 104.88],
      b0: [2834.65, 4008.19],
      b1: [2004.09, 2834.65],
      b2: [1417.32, 2004.09],
      b3: [1000.63, 1417.32],
      b4: [708.66, 1000.63],
      b5: [498.9, 708.66],
      b6: [354.33, 498.9],
      b7: [249.45, 354.33],
      b8: [175.75, 249.45],
      b9: [124.72, 175.75],
      b10: [87.87, 124.72],
      c0: [2599.37, 3676.54],
      c1: [1836.85, 2599.37],
      c2: [1298.27, 1836.85],
      c3: [918.43, 1298.27],
      c4: [649.13, 918.43],
      c5: [459.21, 649.13],
      c6: [323.15, 459.21],
      c7: [229.61, 323.15],
      c8: [161.57, 229.61],
      c9: [113.39, 161.57],
      c10: [79.37, 113.39],
      dl: [311.81, 623.62],
      letter: [612, 792],
      "government-letter": [576, 756],
      legal: [612, 1008],
      "junior-legal": [576, 360],
      ledger: [1224, 792],
      tabloid: [792, 1224],
      "credit-card": [153, 243]
    };
    y.__private__.getPageFormats = function () {
      return L;
    };
    var A = y.__private__.getPageFormat = function (t) {
      return L[t];
    };
    s = s || "a4";
    var x = {
        COMPAT: "compat",
        ADVANCED: "advanced"
      },
      S = x.COMPAT;
    function _() {
      this.saveGraphicsState(), lt(new Vt(_t, 0, 0, -_t, 0, Dr() * _t).toString() + " cm"), this.setFontSize(this.getFontSize() / _t), g = "n", S = x.ADVANCED;
    }
    function P() {
      this.restoreGraphicsState(), g = "S", S = x.COMPAT;
    }
    var j = y.__private__.combineFontStyleAndFontWeight = function (t, e) {
      if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
      return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function (t) {
      var e = S === x.COMPAT;
      return e && _.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.compatAPI = function (t) {
      var e = S === x.ADVANCED;
      return e && P.call(this), "function" != typeof t || (t(this), e && _.call(this)), this;
    }, y.isAdvancedAPI = function () {
      return S === x.ADVANCED;
    };
    var E,
      q = function (t) {
        if (S !== x.ADVANCED) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
      },
      D = y.roundToPrecision = y.__private__.roundToPrecision = function (t, e) {
        var r = n || e;
        if (isNaN(t) || isNaN(r)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(r).replace(/0+$/, "");
      };
    E = y.hpf = y.__private__.hpf = "number" == typeof p ? function (t) {
      if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
      return D(t, p);
    } : "smart" === p ? function (t) {
      if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
      return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function (t) {
      if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
      return D(t, 16);
    };
    var R = y.f2 = y.__private__.f2 = function (t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
      },
      T = y.__private__.f3 = function (t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
      },
      U = y.scale = y.__private__.scale = function (t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return S === x.COMPAT ? t * _t : S === x.ADVANCED ? t : void 0;
      },
      z = function (t) {
        return S === x.COMPAT ? Dr() - t : S === x.ADVANCED ? t : void 0;
      },
      H = function (t) {
        return U(z(t));
      };
    y.__private__.setPrecision = y.setPrecision = function (t) {
      "number" == typeof parseInt(t, 10) && (n = parseInt(t, 10));
    };
    var W,
      V = "00000000000000000000000000000000",
      G = y.__private__.getFileId = function () {
        return V;
      },
      Y = y.__private__.setFileId = function (t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function () {
          return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (Ye = new k(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
      };
    y.setFileId = function (t) {
      return Y(t), this;
    }, y.getFileId = function () {
      return G();
    };
    var J = y.__private__.convertDateToPDFDate = function (t) {
        var e = t.getTimezoneOffset(),
          r = e < 0 ? "+" : "-",
          n = Math.floor(Math.abs(e / 60)),
          i = Math.abs(e % 60),
          a = [r, Q(n), "'", Q(i), "'"].join("");
        return ["D:", t.getFullYear(), Q(t.getMonth() + 1), Q(t.getDate()), Q(t.getHours()), Q(t.getMinutes()), Q(t.getSeconds()), a].join("");
      },
      X = y.__private__.convertPDFDateToDate = function (t) {
        var e = parseInt(t.substr(2, 4), 10),
          r = parseInt(t.substr(6, 2), 10) - 1,
          n = parseInt(t.substr(8, 2), 10),
          i = parseInt(t.substr(10, 2), 10),
          a = parseInt(t.substr(12, 2), 10),
          o = parseInt(t.substr(14, 2), 10);
        return new Date(e, r, n, i, a, o, 0);
      },
      K = y.__private__.setCreationDate = function (t) {
        var e;
        if (void 0 === t && (t = new Date()), t instanceof Date) e = J(t);else {
          if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
          e = t;
        }
        return W = e;
      },
      Z = y.__private__.getCreationDate = function (t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
      };
    y.setCreationDate = function (t) {
      return K(t), this;
    }, y.getCreationDate = function (t) {
      return Z(t);
    };
    var $,
      Q = y.__private__.padd2 = function (t) {
        return ("0" + parseInt(t)).slice(-2);
      },
      tt = y.__private__.padd2Hex = function (t) {
        return ("00" + (t = t.toString())).substr(t.length);
      },
      et = 0,
      rt = [],
      nt = [],
      it = 0,
      at = [],
      ot = [],
      st = !1,
      ct = nt,
      ut = function () {
        et = 0, it = 0, nt = [], rt = [], at = [], Qt = Kt(), te = Kt();
      };
    y.__private__.setCustomOutputDestination = function (t) {
      st = !0, ct = t;
    };
    var ht = function (t) {
      st || (ct = t);
    };
    y.__private__.resetCustomOutputDestination = function () {
      st = !1, ct = nt;
    };
    var lt = y.__private__.out = function (t) {
        return t = t.toString(), it += t.length + 1, ct.push(t), ct;
      },
      ft = y.__private__.write = function (t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
      },
      dt = y.__private__.getArrayBuffer = function (t) {
        for (var e = t.length, r = new ArrayBuffer(e), n = new Uint8Array(r); e--;) n[e] = t.charCodeAt(e);
        return r;
      },
      pt = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
    y.__private__.getStandardFonts = function () {
      return pt;
    };
    var gt = t.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function (t) {
      return gt = S === x.ADVANCED ? t / _t : t, this;
    };
    var mt,
      vt = y.__private__.getFontSize = y.getFontSize = function () {
        return S === x.COMPAT ? gt : gt * _t;
      },
      bt = t.R2L || !1;
    y.__private__.setR2L = y.setR2L = function (t) {
      return bt = t, this;
    }, y.__private__.getR2L = y.getR2L = function () {
      return bt;
    };
    var yt,
      wt = y.__private__.setZoomMode = function (t) {
        var e = [void 0, null, "fullwidth", "fullheight", "fullpage", "original"];
        if (/^\d*\.?\d*%$/.test(t)) mt = t;else if (isNaN(t)) {
          if (-1 === e.indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
          mt = t;
        } else mt = parseInt(t, 10);
      };
    y.__private__.getZoomMode = function () {
      return mt;
    };
    var Nt,
      Lt = y.__private__.setPageMode = function (t) {
        if (-1 == [void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        yt = t;
      };
    y.__private__.getPageMode = function () {
      return yt;
    };
    var At = y.__private__.setLayoutMode = function (t) {
      if (-1 == [void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
      Nt = t;
    };
    y.__private__.getLayoutMode = function () {
      return Nt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function (t, e, r) {
      return wt(t), At(e), Lt(r), this;
    };
    var xt = {
      title: "",
      subject: "",
      author: "",
      keywords: "",
      creator: ""
    };
    y.__private__.getDocumentProperty = function (t) {
      if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
      return xt[t];
    }, y.__private__.getDocumentProperties = function () {
      return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function (t) {
      for (var e in xt) xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
      return this;
    }, y.__private__.setDocumentProperty = function (t, e) {
      if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
      return xt[t] = e;
    };
    var St,
      _t,
      Pt,
      kt,
      Ft,
      It = {},
      Ct = {},
      jt = [],
      Ot = {},
      Bt = {},
      Mt = {},
      Et = {},
      qt = null,
      Dt = 0,
      Rt = [],
      Tt = new I(y),
      Ut = t.hotfixes || [],
      zt = {},
      Ht = {},
      Wt = [],
      Vt = function t(e, r, n, i, a, o) {
        if (!(this instanceof t)) return new t(e, r, n, i, a, o);
        isNaN(e) && (e = 1), isNaN(r) && (r = 0), isNaN(n) && (n = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [e, r, n, i, a, o];
      };
    Object.defineProperty(Vt.prototype, "sx", {
      get: function () {
        return this._matrix[0];
      },
      set: function (t) {
        this._matrix[0] = t;
      }
    }), Object.defineProperty(Vt.prototype, "shy", {
      get: function () {
        return this._matrix[1];
      },
      set: function (t) {
        this._matrix[1] = t;
      }
    }), Object.defineProperty(Vt.prototype, "shx", {
      get: function () {
        return this._matrix[2];
      },
      set: function (t) {
        this._matrix[2] = t;
      }
    }), Object.defineProperty(Vt.prototype, "sy", {
      get: function () {
        return this._matrix[3];
      },
      set: function (t) {
        this._matrix[3] = t;
      }
    }), Object.defineProperty(Vt.prototype, "tx", {
      get: function () {
        return this._matrix[4];
      },
      set: function (t) {
        this._matrix[4] = t;
      }
    }), Object.defineProperty(Vt.prototype, "ty", {
      get: function () {
        return this._matrix[5];
      },
      set: function (t) {
        this._matrix[5] = t;
      }
    }), Object.defineProperty(Vt.prototype, "a", {
      get: function () {
        return this._matrix[0];
      },
      set: function (t) {
        this._matrix[0] = t;
      }
    }), Object.defineProperty(Vt.prototype, "b", {
      get: function () {
        return this._matrix[1];
      },
      set: function (t) {
        this._matrix[1] = t;
      }
    }), Object.defineProperty(Vt.prototype, "c", {
      get: function () {
        return this._matrix[2];
      },
      set: function (t) {
        this._matrix[2] = t;
      }
    }), Object.defineProperty(Vt.prototype, "d", {
      get: function () {
        return this._matrix[3];
      },
      set: function (t) {
        this._matrix[3] = t;
      }
    }), Object.defineProperty(Vt.prototype, "e", {
      get: function () {
        return this._matrix[4];
      },
      set: function (t) {
        this._matrix[4] = t;
      }
    }), Object.defineProperty(Vt.prototype, "f", {
      get: function () {
        return this._matrix[5];
      },
      set: function (t) {
        this._matrix[5] = t;
      }
    }), Object.defineProperty(Vt.prototype, "rotation", {
      get: function () {
        return Math.atan2(this.shx, this.sx);
      }
    }), Object.defineProperty(Vt.prototype, "scaleX", {
      get: function () {
        return this.decompose().scale.sx;
      }
    }), Object.defineProperty(Vt.prototype, "scaleY", {
      get: function () {
        return this.decompose().scale.sy;
      }
    }), Object.defineProperty(Vt.prototype, "isIdentity", {
      get: function () {
        return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
      }
    }), Vt.prototype.join = function (t) {
      return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(E).join(t);
    }, Vt.prototype.multiply = function (t) {
      var e = t.sx * this.sx + t.shy * this.shx,
        r = t.sx * this.shy + t.shy * this.sy,
        n = t.shx * this.sx + t.sy * this.shx,
        i = t.shx * this.shy + t.sy * this.sy,
        a = t.tx * this.sx + t.ty * this.shx + this.tx,
        o = t.tx * this.shy + t.ty * this.sy + this.ty;
      return new Vt(e, r, n, i, a, o);
    }, Vt.prototype.decompose = function () {
      var t = this.sx,
        e = this.shy,
        r = this.shx,
        n = this.sy,
        i = this.tx,
        a = this.ty,
        o = Math.sqrt(t * t + e * e),
        s = (t /= o) * r + (e /= o) * n;
      r -= t * s, n -= e * s;
      var c = Math.sqrt(r * r + n * n);
      return s /= c, t * (n /= c) < e * (r /= c) && (t = -t, e = -e, s = -s, o = -o), {
        scale: new Vt(o, 0, 0, c, 0, 0),
        translate: new Vt(1, 0, 0, 1, i, a),
        rotate: new Vt(t, e, -e, t, 0, 0),
        skew: new Vt(1, 0, s, 1, 0, 0)
      };
    }, Vt.prototype.toString = function (t) {
      return this.join(" ");
    }, Vt.prototype.inversed = function () {
      var t = this.sx,
        e = this.shy,
        r = this.shx,
        n = this.sy,
        i = this.tx,
        a = this.ty,
        o = 1 / (t * n - e * r),
        s = n * o,
        c = -e * o,
        u = -r * o,
        h = t * o;
      return new Vt(s, c, u, h, -s * i - u * a, -c * i - h * a);
    }, Vt.prototype.applyToPoint = function (t) {
      var e = t.x * this.sx + t.y * this.shx + this.tx,
        r = t.x * this.shy + t.y * this.sy + this.ty;
      return new Ir(e, r);
    }, Vt.prototype.applyToRectangle = function (t) {
      var e = this.applyToPoint(t),
        r = this.applyToPoint(new Ir(t.x + t.w, t.y + t.h));
      return new Cr(e.x, e.y, r.x - e.x, r.y - e.y);
    }, Vt.prototype.clone = function () {
      var t = this.sx,
        e = this.shy,
        r = this.shx,
        n = this.sy,
        i = this.tx,
        a = this.ty;
      return new Vt(t, e, r, n, i, a);
    }, y.Matrix = Vt;
    var Gt = y.matrixMult = function (t, e) {
        return e.multiply(t);
      },
      Yt = new Vt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Yt;
    var Jt = function (t, e) {
      if (!Bt[t]) {
        var r = (e instanceof O ? "Sh" : "P") + (Object.keys(Ot).length + 1).toString(10);
        e.id = r, Bt[t] = r, Ot[r] = e, Tt.publish("addPattern", e);
      }
    };
    y.ShadingPattern = O, y.TilingPattern = B, y.addShadingPattern = function (t, e) {
      return q("addShadingPattern()"), Jt(t, e), this;
    }, y.beginTilingPattern = function (t) {
      q("beginTilingPattern()"), Or(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function (t, e) {
      q("endTilingPattern()"), e.stream = ot[$].join("\n"), Jt(t, e), Tt.publish("endTilingPattern", e), Wt.pop().restore();
    };
    var Xt = y.__private__.newObject = function () {
        var t = Kt();
        return Zt(t, !0), t;
      },
      Kt = y.__private__.newObjectDeferred = function () {
        return et++, rt[et] = function () {
          return it;
        }, et;
      },
      Zt = function (t, e) {
        return e = "boolean" == typeof e && e, rt[t] = it, e && lt(t + " 0 obj"), t;
      },
      $t = y.__private__.newAdditionalObject = function () {
        var t = {
          objId: Kt(),
          content: ""
        };
        return at.push(t), t;
      },
      Qt = Kt(),
      te = Kt(),
      ee = y.__private__.decodeColorString = function (t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) {
          if (5 === e.length && ("k" === e[4] || "K" === e[4])) {
            e = [(1 - e[0]) * (1 - e[3]), (1 - e[1]) * (1 - e[3]), (1 - e[2]) * (1 - e[3]), "r"];
          }
        } else {
          var r = parseFloat(e[0]);
          e = [r, r, r, "r"];
        }
        for (var n = "#", i = 0; i < 3; i++) n += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return n;
      },
      re = y.__private__.encodeColorString = function (t) {
        var r;
        "string" == typeof t && (t = {
          ch1: t
        });
        var n = t.ch1,
          i = t.ch2,
          a = t.ch3,
          o = t.ch4,
          s = "draw" === t.pdfColorType ? ["G", "RG", "K"] : ["g", "rg", "k"];
        if ("string" == typeof n && "#" !== n.charAt(0)) {
          var c = new l(n);
          if (c.ok) n = c.toHex();else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
          var u = parseInt(n.substr(1), 16);
          n = u >> 16 & 255, i = u >> 8 & 255, a = 255 & u;
        }
        if (void 0 === i || void 0 === o && n === i && i === a) {
          if ("string" == typeof n) r = n + " " + s[0];else switch (t.precision) {
            case 2:
              r = R(n / 255) + " " + s[0];
              break;
            case 3:
            default:
              r = T(n / 255) + " " + s[0];
          }
        } else if (void 0 === o || "object" === e(o)) {
          if (o && !isNaN(o.a) && 0 === o.a) return r = ["1.", "1.", "1.", s[1]].join(" ");
          if ("string" == typeof n) r = [n, i, a, s[1]].join(" ");else switch (t.precision) {
            case 2:
              r = [R(n / 255), R(i / 255), R(a / 255), s[1]].join(" ");
              break;
            default:
            case 3:
              r = [T(n / 255), T(i / 255), T(a / 255), s[1]].join(" ");
          }
        } else if ("string" == typeof n) r = [n, i, a, o, s[2]].join(" ");else switch (t.precision) {
          case 2:
            r = [R(n), R(i), R(a), R(o), s[2]].join(" ");
            break;
          case 3:
          default:
            r = [T(n), T(i), T(a), T(o), s[2]].join(" ");
        }
        return r;
      },
      ne = y.__private__.getFilters = function () {
        return f;
      },
      ie = y.__private__.putStream = function (t) {
        var e = (t = t || {}).data || "",
          r = t.filters || ne(),
          n = t.alreadyAppliedFilters || [],
          i = t.addLength1 || !1,
          a = e.length,
          o = t.objectId,
          s = function (t) {
            return t;
          };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = Ye.encryptor(o, 0));
        var c = {};
        !0 === r && (r = ["FlateEncode"]);
        var u = t.additionalKeyValues || [],
          h = (c = void 0 !== M.API.processDataByFilters ? M.API.processDataByFilters(e, r) : {
            data: e,
            reverseChain: []
          }).reverseChain + (Array.isArray(n) ? n.join(" ") : n.toString());
        if (0 !== c.data.length && (u.push({
          key: "Length",
          value: c.data.length
        }), !0 === i && u.push({
          key: "Length1",
          value: a
        })), 0 != h.length) if (h.split("/").length - 1 == 1) u.push({
          key: "Filter",
          value: h
        });else {
          u.push({
            key: "Filter",
            value: "[" + h + "]"
          });
          for (var l = 0; l < u.length; l += 1) if ("DecodeParms" === u[l].key) {
            for (var f = [], d = 0; d < c.reverseChain.split("/").length - 1; d += 1) f.push("null");
            f.push(u[l].value), u[l].value = "[" + f.join(" ") + "]";
          }
        }
        lt("<<");
        for (var p = 0; p < u.length; p++) lt("/" + u[p].key + " " + u[p].value);
        lt(">>"), 0 !== c.data.length && (lt("stream"), lt(s(c.data)), lt("endstream"));
      },
      ae = y.__private__.putPage = function (t) {
        var e = t.number,
          r = t.data,
          n = t.objId,
          i = t.contentsObjId;
        Zt(n, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(E(t.mediaBox.bottomLeftX)) + " " + parseFloat(E(t.mediaBox.bottomLeftY)) + " " + E(t.mediaBox.topRightX) + " " + E(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + E(t.cropBox.bottomLeftX) + " " + E(t.cropBox.bottomLeftY) + " " + E(t.cropBox.topRightX) + " " + E(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + E(t.bleedBox.bottomLeftX) + " " + E(t.bleedBox.bottomLeftY) + " " + E(t.bleedBox.topRightX) + " " + E(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + E(t.trimBox.bottomLeftX) + " " + E(t.trimBox.bottomLeftY) + " " + E(t.trimBox.topRightX) + " " + E(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + E(t.artBox.bottomLeftX) + " " + E(t.artBox.bottomLeftY) + " " + E(t.artBox.topRightX) + " " + E(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Tt.publish("putPage", {
          objId: n,
          pageContext: Rt[e],
          pageNumber: e,
          page: r
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = r.join("\n");
        return S === x.ADVANCED && (a += "\nQ"), Zt(i, !0), ie({
          data: a,
          filters: ne(),
          objectId: i
        }), lt("endobj"), n;
      },
      oe = y.__private__.putPages = function () {
        var t,
          e,
          r = [];
        for (t = 1; t <= Dt; t++) Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for (t = 1; t <= Dt; t++) r.push(ae({
          number: t,
          data: ot[t],
          objId: Rt[t].objId,
          contentsObjId: Rt[t].contentsObjId,
          mediaBox: Rt[t].mediaBox,
          cropBox: Rt[t].cropBox,
          bleedBox: Rt[t].bleedBox,
          trimBox: Rt[t].trimBox,
          artBox: Rt[t].artBox,
          userUnit: Rt[t].userUnit,
          rootDictionaryObjId: Qt,
          resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var n = "/Kids [";
        for (e = 0; e < Dt; e++) n += r[e] + " 0 R ";
        lt(n + "]"), lt("/Count " + Dt), lt(">>"), lt("endobj"), Tt.publish("postPutPages");
      },
      se = function (t) {
        Tt.publish("putFont", {
          font: t,
          out: lt,
          newObject: Xt,
          putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + F(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
      },
      ce = function () {
        for (var t in It) It.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(It[t]);
      },
      ue = function (t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
          key: "Type",
          value: "/XObject"
        }), e.push({
          key: "Subtype",
          value: "/Form"
        }), e.push({
          key: "BBox",
          value: "[" + [E(t.x), E(t.y), E(t.x + t.width), E(t.y + t.height)].join(" ") + "]"
        }), e.push({
          key: "Matrix",
          value: "[" + t.matrix.toString() + "]"
        });
        var r = t.pages[1].join("\n");
        ie({
          data: r,
          additionalKeyValues: e,
          objectId: t.objectNumber
        }), lt("endobj");
      },
      he = function () {
        for (var t in zt) zt.hasOwnProperty(t) && ue(zt[t]);
      },
      le = function (t, e) {
        var r,
          n = [],
          i = 1 / (e - 1);
        for (r = 0; r < 1; r += i) n.push(r);
        if (n.push(1), 0 != t[0].offset) {
          var a = {
            offset: 0,
            color: t[0].color
          };
          t.unshift(a);
        }
        if (1 != t[t.length - 1].offset) {
          var o = {
            offset: 1,
            color: t[t.length - 1].color
          };
          t.push(o);
        }
        for (var s = "", c = 0, u = 0; u < n.length; u++) {
          for (r = n[u]; r > t[c + 1].offset;) c++;
          var h = t[c].offset,
            l = (r - h) / (t[c + 1].offset - h),
            f = t[c].color,
            d = t[c + 1].color;
          s += tt(Math.round((1 - l) * f[0] + l * d[0]).toString(16)) + tt(Math.round((1 - l) * f[1] + l * d[1]).toString(16)) + tt(Math.round((1 - l) * f[2] + l * d[2]).toString(16));
        }
        return s.trim();
      },
      fe = function (t, e) {
        e || (e = 21);
        var r = Xt(),
          n = le(t.colors, e),
          i = [];
        i.push({
          key: "FunctionType",
          value: "0"
        }), i.push({
          key: "Domain",
          value: "[0.0 1.0]"
        }), i.push({
          key: "Size",
          value: "[" + e + "]"
        }), i.push({
          key: "BitsPerSample",
          value: "8"
        }), i.push({
          key: "Range",
          value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
          key: "Decode",
          value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
          data: n,
          additionalKeyValues: i,
          alreadyAppliedFilters: ["/ASCIIHexDecode"],
          objectId: r
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + E(parseFloat(t.coords[0])) + " " + E(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += E(parseFloat(t.coords[2])) + " " + E(parseFloat(t.coords[3])) : a += E(parseFloat(t.coords[2])) + " " + E(parseFloat(t.coords[3])) + " " + E(parseFloat(t.coords[4])) + " " + E(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + r + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
      },
      de = function (t, e) {
        var r = Kt(),
          n = Xt();
        e.push({
          resourcesOid: r,
          objectOid: n
        }), t.objectNumber = n;
        var i = [];
        i.push({
          key: "Type",
          value: "/Pattern"
        }), i.push({
          key: "PatternType",
          value: "1"
        }), i.push({
          key: "PaintType",
          value: "1"
        }), i.push({
          key: "TilingType",
          value: "1"
        }), i.push({
          key: "BBox",
          value: "[" + t.boundingBox.map(E).join(" ") + "]"
        }), i.push({
          key: "XStep",
          value: E(t.xStep)
        }), i.push({
          key: "YStep",
          value: E(t.yStep)
        }), i.push({
          key: "Resources",
          value: r + " 0 R"
        }), t.matrix && i.push({
          key: "Matrix",
          value: "[" + t.matrix.toString() + "]"
        }), ie({
          data: t.stream,
          additionalKeyValues: i,
          objectId: t.objectNumber
        }), lt("endobj");
      },
      pe = function (t) {
        var e;
        for (e in Ot) Ot.hasOwnProperty(e) && (Ot[e] instanceof O ? fe(Ot[e]) : Ot[e] instanceof B && de(Ot[e], t));
      },
      ge = function (t) {
        for (var e in t.objectNumber = Xt(), lt("<<"), t) switch (e) {
          case "opacity":
            lt("/ca " + R(t[e]));
            break;
          case "stroke-opacity":
            lt("/CA " + R(t[e]));
        }
        lt(">>"), lt("endobj");
      },
      me = function () {
        var t;
        for (t in Mt) Mt.hasOwnProperty(t) && ge(Mt[t]);
      },
      ve = function () {
        for (var t in lt("/XObject <<"), zt) zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
        Tt.publish("putXobjectDict"), lt(">>");
      },
      be = function () {
        Ye.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + Ye.v), lt("/R " + Ye.r), lt("/U <" + Ye.toHexString(Ye.U) + ">"), lt("/O <" + Ye.toHexString(Ye.O) + ">"), lt("/P " + Ye.P), lt(">>"), lt("endobj");
      },
      ye = function () {
        for (var t in lt("/Font <<"), It) It.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + It[t].objectNumber + " 0 R");
        lt(">>");
      },
      we = function () {
        if (Object.keys(Ot).length > 0) {
          for (var t in lt("/Shading <<"), Ot) Ot.hasOwnProperty(t) && Ot[t] instanceof O && Ot[t].objectNumber >= 0 && lt("/" + t + " " + Ot[t].objectNumber + " 0 R");
          Tt.publish("putShadingPatternDict"), lt(">>");
        }
      },
      Ne = function (t) {
        if (Object.keys(Ot).length > 0) {
          for (var e in lt("/Pattern <<"), Ot) Ot.hasOwnProperty(e) && Ot[e] instanceof y.TilingPattern && Ot[e].objectNumber >= 0 && Ot[e].objectNumber < t && lt("/" + e + " " + Ot[e].objectNumber + " 0 R");
          Tt.publish("putTilingPatternDict"), lt(">>");
        }
      },
      Le = function () {
        if (Object.keys(Mt).length > 0) {
          var t;
          for (t in lt("/ExtGState <<"), Mt) Mt.hasOwnProperty(t) && Mt[t].objectNumber >= 0 && lt("/" + t + " " + Mt[t].objectNumber + " 0 R");
          Tt.publish("putGStateDict"), lt(">>");
        }
      },
      Ae = function (t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ye(), we(), Ne(t.objectOid), Le(), ve(), lt(">>"), lt("endobj");
      },
      xe = function () {
        var t = [];
        ce(), me(), he(), pe(t), Tt.publish("putResources"), t.forEach(Ae), Ae({
          resourcesOid: te,
          objectOid: Number.MAX_SAFE_INTEGER
        }), Tt.publish("postPutResources");
      },
      Se = function () {
        Tt.publish("putAdditionalObjects");
        for (var t = 0; t < at.length; t++) {
          var e = at[t];
          Zt(e.objId, !0), lt(e.content), lt("endobj");
        }
        Tt.publish("postPutAdditionalObjects");
      },
      _e = function (t) {
        Ct[t.fontName] = Ct[t.fontName] || {}, Ct[t.fontName][t.fontStyle] = t.id;
      },
      Pe = function (t, e, r, n, i) {
        var a = {
          id: "F" + (Object.keys(It).length + 1).toString(10),
          postScriptName: t,
          fontName: e,
          fontStyle: r,
          encoding: n,
          isStandardFont: i || !1,
          metadata: {}
        };
        return Tt.publish("addFont", {
          font: a,
          instance: this
        }), It[a.id] = a, _e(a), a.id;
      },
      ke = function (t) {
        for (var e = 0, r = pt.length; e < r; e++) {
          var n = Pe.call(this, t[e][0], t[e][1], t[e][2], pt[e][3], !0);
          !1 === v && (b[n] = !0);
          var i = t[e][0].split("-");
          _e({
            id: n,
            fontName: i[0],
            fontStyle: i[1] || ""
          });
        }
        Tt.publish("addFonts", {
          fonts: It,
          dictionary: Ct
        });
      },
      Fe = function (t) {
        return t.foo = function () {
          try {
            return t.apply(this, arguments);
          } catch (t) {
            var e = t.stack || "";
            ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
            var n = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
            if (!r.console) throw new Error(n);
            r.console.error(n, t), r.alert && alert(n);
          }
        }, t.foo.bar = t, t.foo;
      },
      Ie = function (t, e) {
        var r, n, i, a, o, s, c, u, h;
        if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && It[St].metadata && It[St].metadata[i] && It[St].metadata[i].encoding && (a = It[St].metadata[i].encoding, !o && It[St].encoding && (o = It[St].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
          for (c = !1, s = [], r = 0, n = t.length; r < n; r++) (u = o[t.charCodeAt(r)]) ? s.push(String.fromCharCode(u)) : s.push(t[r]), s[r].charCodeAt(0) >> 8 && (c = !0);
          t = s.join("");
        }
        for (r = t.length; void 0 === c && 0 !== r;) t.charCodeAt(r - 1) >> 8 && (c = !0), r--;
        if (!c) return t;
        for (s = e.noBOM ? [] : [254, 255], r = 0, n = t.length; r < n; r++) {
          if ((h = (u = t.charCodeAt(r)) >> 8) >> 8) throw new Error("Character at position " + r + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
          s.push(h), s.push(u - (h << 8));
        }
        return String.fromCharCode.apply(void 0, s);
      },
      Ce = y.__private__.pdfEscape = y.pdfEscape = function (t, e) {
        return Ie(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
      },
      je = y.__private__.beginPage = function (t) {
        ot[++Dt] = [], Rt[Dt] = {
          objId: 0,
          contentsObjId: 0,
          userUnit: Number(d),
          artBox: null,
          bleedBox: null,
          cropBox: null,
          trimBox: null,
          mediaBox: {
            bottomLeftX: 0,
            bottomLeftY: 0,
            topRightX: Number(t[0]),
            topRightY: Number(t[1])
          }
        }, Me(Dt), ht(ot[$]);
      },
      Oe = function (t, e) {
        var r, n, o;
        switch (a = e || a, "string" == typeof t && (r = A(t.toLowerCase()), Array.isArray(r) && (n = r[0], o = r[1])), Array.isArray(t) && (n = t[0] * _t, o = t[1] * _t), isNaN(n) && (n = s[0], o = s[1]), (n > 14400 || o > 14400) && (i.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), n = Math.min(14400, n), o = Math.min(14400, o)), s = [n, o], a.substr(0, 1)) {
          case "l":
            o > n && (s = [o, n]);
            break;
          case "p":
            n > o && (s = [o, n]);
        }
        je(s), dr(fr), lt(Nr), 0 !== Pr && lt(Pr + " J"), 0 !== kr && lt(kr + " j"), Tt.publish("addPage", {
          pageNumber: Dt
        });
      },
      Be = function (t) {
        t > 0 && t <= Dt && (ot.splice(t, 1), Rt.splice(t, 1), Dt--, $ > Dt && ($ = Dt), this.setPage($));
      },
      Me = function (t) {
        t > 0 && t <= Dt && ($ = t);
      },
      Ee = y.__private__.getNumberOfPages = y.getNumberOfPages = function () {
        return ot.length - 1;
      },
      qe = function (t, e, r) {
        var n,
          a = void 0;
        return r = r || {}, t = void 0 !== t ? t : It[St].fontName, e = void 0 !== e ? e : It[St].fontStyle, n = t.toLowerCase(), void 0 !== Ct[n] && void 0 !== Ct[n][e] ? a = Ct[n][e] : void 0 !== Ct[t] && void 0 !== Ct[t][e] ? a = Ct[t][e] : !1 === r.disableWarning && i.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), a || r.noFallback || null == (a = Ct.times[e]) && (a = Ct.times.normal), a;
      },
      De = y.__private__.putInfo = function () {
        var t = Xt(),
          e = function (t) {
            return t;
          };
        for (var r in null !== m && (e = Ye.encryptor(t, 0)), lt("<<"), lt("/Producer (" + Ce(e("jsPDF " + M.version)) + ")"), xt) xt.hasOwnProperty(r) && xt[r] && lt("/" + r.substr(0, 1).toUpperCase() + r.substr(1) + " (" + Ce(e(xt[r])) + ")");
        lt("/CreationDate (" + Ce(e(W)) + ")"), lt(">>"), lt("endobj");
      },
      Re = y.__private__.putCatalog = function (t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch (Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), mt || (mt = "fullwidth"), mt) {
          case "fullwidth":
            lt("/OpenAction [3 0 R /FitH null]");
            break;
          case "fullheight":
            lt("/OpenAction [3 0 R /FitV null]");
            break;
          case "fullpage":
            lt("/OpenAction [3 0 R /Fit]");
            break;
          case "original":
            lt("/OpenAction [3 0 R /XYZ null null 1]");
            break;
          default:
            var r = "" + mt;
            "%" === r.substr(r.length - 1) && (mt = parseInt(mt) / 100), "number" == typeof mt && lt("/OpenAction [3 0 R /XYZ null null " + R(mt) + "]");
        }
        switch (Nt || (Nt = "continuous"), Nt) {
          case "continuous":
            lt("/PageLayout /OneColumn");
            break;
          case "single":
            lt("/PageLayout /SinglePage");
            break;
          case "two":
          case "twoleft":
            lt("/PageLayout /TwoColumnLeft");
            break;
          case "tworight":
            lt("/PageLayout /TwoColumnRight");
        }
        yt && lt("/PageMode /" + yt), Tt.publish("putCatalog"), lt(">>"), lt("endobj");
      },
      Te = y.__private__.putTrailer = function () {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + Ye.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
      },
      Ue = y.__private__.putHeader = function () {
        lt("%PDF-" + w), lt("%ºß¬à");
      },
      ze = y.__private__.putXRef = function () {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for (var e = 1; e <= et; e++) {
          "function" == typeof rt[e] ? lt((t + rt[e]()).slice(-10) + " 00000 n ") : void 0 !== rt[e] ? lt((t + rt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
        }
      },
      He = y.__private__.buildDocument = function () {
        ut(), ht(nt), Tt.publish("buildDocument"), Ue(), oe(), Se(), xe(), null !== m && be(), De(), Re();
        var t = it;
        return ze(), Te(), lt("startxref"), lt("" + t), lt("%%EOF"), ht(ot[$]), nt.join("\n");
      },
      We = y.__private__.getBlob = function (t) {
        return new Blob([dt(t)], {
          type: "application/pdf"
        });
      },
      Ve = y.output = y.__private__.output = Fe(function (t, e) {
        switch ("string" == typeof (e = e || {}) ? e = {
          filename: e
        } : e.filename = e.filename || "generated.pdf", t) {
          case void 0:
            return He();
          case "save":
            y.save(e.filename);
            break;
          case "arraybuffer":
            return dt(He());
          case "blob":
            return We(He());
          case "bloburi":
          case "bloburl":
            if (void 0 !== r.URL && "function" == typeof r.URL.createObjectURL) return r.URL && r.URL.createObjectURL(We(He())) || void 0;
            i.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
            break;
          case "datauristring":
          case "dataurlstring":
            var n = "",
              a = He();
            try {
              n = u(a);
            } catch (t) {
              n = u(unescape(encodeURIComponent(a)));
            }
            return "data:application/pdf;filename=" + e.filename + ";base64," + n;
          case "pdfobjectnewwindow":
            if ("[object Window]" === Object.prototype.toString.call(r)) {
              var o = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + (e.pdfObjectUrl || "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js") + '"><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>",
                s = r.open();
              return null !== s && s.document.write(o), s;
            }
            throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
          case "pdfjsnewwindow":
            if ("[object Window]" === Object.prototype.toString.call(r)) {
              var c = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>',
                h = r.open();
              if (null !== h) {
                h.document.write(c);
                var l = this;
                h.document.documentElement.querySelector("#pdfViewer").onload = function () {
                  h.document.title = e.filename, h.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(l.output("bloburl"));
                };
              }
              return h;
            }
            throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
          case "dataurlnewwindow":
            if ("[object Window]" !== Object.prototype.toString.call(r)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
            var f = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>',
              d = r.open();
            if (null !== d && (d.document.write(f), d.document.title = e.filename), d || "undefined" == typeof safari) return d;
            break;
          case "datauri":
          case "dataurl":
            return r.document.location.href = this.output("datauristring", e);
          default:
            return null;
        }
      }),
      Ge = function (t) {
        return !0 === Array.isArray(Ut) && Ut.indexOf(t) > -1;
      };
    switch (o) {
      case "pt":
        _t = 1;
        break;
      case "mm":
        _t = 72 / 25.4;
        break;
      case "cm":
        _t = 72 / 2.54;
        break;
      case "in":
        _t = 72;
        break;
      case "px":
        _t = 1 == Ge("px_scaling") ? .75 : 96 / 72;
        break;
      case "pc":
      case "em":
        _t = 12;
        break;
      case "ex":
        _t = 6;
        break;
      default:
        throw new Error("Invalid unit: " + o);
    }
    var Ye = null;
    K(), Y();
    var Je = function (t) {
        return null !== m ? Ye.encryptor(t, 0) : function (t) {
          return t;
        };
      },
      Xe = y.__private__.getPageInfo = y.getPageInfo = function (t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
          objId: Rt[t].objId,
          pageNumber: t,
          pageContext: Rt[t]
        };
      },
      Ke = y.__private__.getPageInfoByObjId = function (t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for (var e in Rt) if (Rt[e].objId === t) break;
        return Xe(e);
      },
      Ze = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function () {
        return {
          objId: Rt[$].objId,
          pageNumber: $,
          pageContext: Rt[$]
        };
      };
    y.addPage = function () {
      return Oe.apply(this, arguments), this;
    }, y.setPage = function () {
      return Me.apply(this, arguments), ht.call(this, ot[$]), this;
    }, y.insertPage = function (t) {
      return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function (t, e) {
      var r, n;
      if (t > e) {
        r = ot[t], n = Rt[t];
        for (var i = t; i > e; i--) ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
        ot[e] = r, Rt[e] = n, this.setPage(e);
      } else if (t < e) {
        r = ot[t], n = Rt[t];
        for (var a = t; a < e; a++) ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
        ot[e] = r, Rt[e] = n, this.setPage(e);
      }
      return this;
    }, y.deletePage = function () {
      return Be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function (t, r, n, i, a) {
      var o,
        s,
        c,
        u,
        h,
        l,
        f,
        d,
        p = (i = i || {}).scope || this;
      if ("number" == typeof t && "number" == typeof r && ("string" == typeof n || Array.isArray(n))) {
        var g = n;
        n = r, r = t, t = g;
      }
      if (arguments[3] instanceof Vt == !1 ? (c = arguments[4], u = arguments[5], "object" === e(f = arguments[3]) && null !== f || ("string" == typeof c && (u = c, c = null), "string" == typeof f && (u = f, f = null), "number" == typeof f && (c = f, f = null), i = {
        flags: f,
        angle: c,
        align: u
      })) : (q("The transform parameter of text() with a Matrix value"), d = a), isNaN(r) || isNaN(n) || null == t) throw new Error("Invalid arguments passed to jsPDF.text");
      if (0 === t.length) return p;
      var m = "",
        v = !1,
        y = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : lr,
        w = p.internal.scaleFactor;
      function N(t) {
        return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), Ce(t, f);
      }
      function L(t) {
        for (var e, r = t.concat(), n = [], i = r.length; i--;) "string" == typeof (e = r.shift()) ? n.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? n.push(e[0]) : n.push([e[0], e[1], e[2]]);
        return n;
      }
      function A(t, e) {
        var r;
        if ("string" == typeof t) r = e(t)[0];else if (Array.isArray(t)) {
          for (var n, i, a = t.concat(), o = [], s = a.length; s--;) "string" == typeof (n = a.shift()) ? o.push(e(n)[0]) : Array.isArray(n) && "string" == typeof n[0] && (i = e(n[0], n[1], n[2]), o.push([i[0], i[1], i[2]]));
          r = o;
        }
        return r;
      }
      var _ = !1,
        P = !0;
      if ("string" == typeof t) _ = !0;else if (Array.isArray(t)) {
        var k = t.concat();
        s = [];
        for (var F, I = k.length; I--;) ("string" != typeof (F = k.shift()) || Array.isArray(F) && "string" != typeof F[0]) && (P = !1);
        _ = P;
      }
      if (!1 === _) throw new Error('Type of text must be string or Array. "' + t + '" is not recognized.');
      "string" == typeof t && (t = t.match(/[\r?\n]/) ? t.split(/\r\n|\r|\n/g) : [t]);
      var C = gt / p.internal.scaleFactor,
        j = C * (lr - 1);
      switch (i.baseline) {
        case "bottom":
          n -= j;
          break;
        case "top":
          n += C - j;
          break;
        case "hanging":
          n += C - 2 * j;
          break;
        case "middle":
          n += C / 2 - j;
      }
      if ((l = i.maxWidth || 0) > 0 && ("string" == typeof t ? t = p.splitTextToSize(t, l) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function (t, e) {
        return t.concat(p.splitTextToSize(e, l));
      }, []))), o = {
        text: t,
        x: r,
        y: n,
        options: i,
        mutex: {
          pdfEscape: Ce,
          activeFontKey: St,
          fonts: It,
          activeFontSize: gt
        }
      }, Tt.publish("preProcessText", o), t = o.text, c = (i = o.options).angle, d instanceof Vt == !1 && c && "number" == typeof c) {
        c *= Math.PI / 180, 0 === i.rotationDirection && (c = -c), S === x.ADVANCED && (c = -c);
        var O = Math.cos(c),
          B = Math.sin(c);
        d = new Vt(O, B, -B, O, 0, 0);
      } else c && c instanceof Vt && (d = c);
      S !== x.ADVANCED || d || (d = Yt), void 0 !== (h = i.charSpace || Sr) && (m += E(U(h)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0));
      i.lang;
      var M = -1,
        D = void 0 !== i.renderingMode ? i.renderingMode : i.stroke,
        R = p.internal.getCurrentPageInfo().pageContext;
      switch (D) {
        case 0:
        case !1:
        case "fill":
          M = 0;
          break;
        case 1:
        case !0:
        case "stroke":
          M = 1;
          break;
        case 2:
        case "fillThenStroke":
          M = 2;
          break;
        case 3:
        case "invisible":
          M = 3;
          break;
        case 4:
        case "fillAndAddForClipping":
          M = 4;
          break;
        case 5:
        case "strokeAndAddPathForClipping":
          M = 5;
          break;
        case 6:
        case "fillThenStrokeAndAddToPathForClipping":
          M = 6;
          break;
        case 7:
        case "addToPathForClipping":
          M = 7;
      }
      var T = void 0 !== R.usedRenderingMode ? R.usedRenderingMode : -1;
      -1 !== M ? m += M + " Tr\n" : -1 !== T && (m += "0 Tr\n"), -1 !== M && (R.usedRenderingMode = M), u = i.align || "left";
      var z,
        H = gt * y,
        W = p.internal.pageSize.getWidth(),
        V = It[St];
      h = i.charSpace || Sr, l = i.maxWidth || 0, f = Object.assign({
        autoencode: !0,
        noBOM: !0
      }, i.flags);
      var G = [];
      if ("[object Array]" === Object.prototype.toString.call(t)) {
        var Y;
        s = L(t), "left" !== u && (z = s.map(function (t) {
          return p.getStringUnitWidth(t, {
            font: V,
            charSpace: h,
            fontSize: gt,
            doKerning: !1
          }) * gt / w;
        }));
        var J,
          X = 0;
        if ("right" === u) {
          r -= z[0], t = [], I = s.length;
          for (var K = 0; K < I; K++) 0 === K ? (J = vr(r), Y = br(n)) : (J = U(X - z[K]), Y = -H), t.push([s[K], J, Y]), X = z[K];
        } else if ("center" === u) {
          r -= z[0] / 2, t = [], I = s.length;
          for (var Z = 0; Z < I; Z++) 0 === Z ? (J = vr(r), Y = br(n)) : (J = U((X - z[Z]) / 2), Y = -H), t.push([s[Z], J, Y]), X = z[Z];
        } else if ("left" === u) {
          t = [], I = s.length;
          for (var $ = 0; $ < I; $++) t.push(s[$]);
        } else {
          if ("justify" !== u) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
          t = [], I = s.length, l = 0 !== l ? l : W;
          for (var Q = 0; Q < I; Q++) Y = 0 === Q ? br(n) : -H, J = 0 === Q ? vr(r) : 0, Q < I - 1 ? G.push(E(U((l - z[Q]) / (s[Q].split(" ").length - 1)))) : G.push(0), t.push([s[Q], J, Y]);
        }
      }
      var tt = "boolean" == typeof i.R2L ? i.R2L : bt;
      !0 === tt && (t = A(t, function (t, e, r) {
        return [t.split("").reverse().join(""), e, r];
      })), o = {
        text: t,
        x: r,
        y: n,
        options: i,
        mutex: {
          pdfEscape: Ce,
          activeFontKey: St,
          fonts: It,
          activeFontSize: gt
        }
      }, Tt.publish("postProcessText", o), t = o.text, v = o.mutex.isHex || !1;
      var et = It[St].encoding;
      "WinAnsiEncoding" !== et && "StandardEncoding" !== et || (t = A(t, function (t, e, r) {
        return [N(t), e, r];
      })), s = L(t), t = [];
      for (var rt, nt, it, at = 0, ot = 1, st = Array.isArray(s[0]) ? ot : at, ct = "", ut = function (t, e, r) {
          var n = "";
          return r instanceof Vt ? (r = "number" == typeof i.angle ? Gt(r, new Vt(1, 0, 0, 1, t, e)) : Gt(new Vt(1, 0, 0, 1, t, e), r), S === x.ADVANCED && (r = Gt(new Vt(1, 0, 0, -1, 0, 0), r)), n = r.join(" ") + " Tm\n") : n = E(t) + " " + E(e) + " Td\n", n;
        }, ht = 0; ht < s.length; ht++) {
        switch (ct = "", st) {
          case ot:
            it = (v ? "<" : "(") + s[ht][0] + (v ? ">" : ")"), rt = parseFloat(s[ht][1]), nt = parseFloat(s[ht][2]);
            break;
          case at:
            it = (v ? "<" : "(") + s[ht] + (v ? ">" : ")"), rt = vr(r), nt = br(n);
        }
        void 0 !== G && void 0 !== G[ht] && (ct = G[ht] + " Tw\n"), 0 === ht ? t.push(ct + ut(rt, nt, d) + it) : st === at ? t.push(ct + it) : st === ot && t.push(ct + ut(rt, nt, d) + it);
      }
      t = st === at ? t.join(" Tj\nT* ") : t.join(" Tj\n"), t += " Tj\n";
      var ft = "BT\n/";
      return ft += St + " " + gt + " Tf\n", ft += E(gt * y) + " TL\n", ft += Ar + "\n", ft += m, ft += t, lt(ft += "ET"), b[St] = !0, p;
    };
    var $e = y.__private__.clip = y.clip = function (t) {
      return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function () {
      return $e("evenodd");
    }, y.__private__.discardPath = y.discardPath = function () {
      return lt("n"), this;
    };
    var Qe = y.__private__.isValidStyle = function (t) {
      var e = !1;
      return -1 !== [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function (t) {
      return Qe(t) && (g = t), this;
    };
    var tr = y.__private__.getStyle = y.getStyle = function (t) {
        var e = g;
        switch (t) {
          case "D":
          case "S":
            e = "S";
            break;
          case "F":
            e = "f";
            break;
          case "FD":
          case "DF":
            e = "B";
            break;
          case "f":
          case "f*":
          case "B":
          case "B*":
            e = t;
        }
        return e;
      },
      er = y.close = function () {
        return lt("h"), this;
      };
    y.stroke = function () {
      return lt("S"), this;
    }, y.fill = function (t) {
      return rr("f", t), this;
    }, y.fillEvenOdd = function (t) {
      return rr("f*", t), this;
    }, y.fillStroke = function (t) {
      return rr("B", t), this;
    }, y.fillStrokeEvenOdd = function (t) {
      return rr("B*", t), this;
    };
    var rr = function (t, r) {
        "object" === e(r) ? ar(r, t) : lt(t);
      },
      nr = function (t) {
        null === t || S === x.ADVANCED && void 0 === t || (t = tr(t), lt(t));
      };
    function ir(t, e, r, n, i) {
      var a = new B(e || this.boundingBox, r || this.xStep, n || this.yStep, this.gState, i || this.matrix);
      a.stream = this.stream;
      var o = t + "$$" + this.cloneIndex++ + "$$";
      return Jt(o, a), a;
    }
    var ar = function (t, e) {
        var r = Bt[t.key],
          n = Ot[r];
        if (n instanceof O) lt("q"), lt(or(e)), n.gState && y.setGState(n.gState), lt(t.matrix.toString() + " cm"), lt("/" + r + " sh"), lt("Q");else if (n instanceof B) {
          var i = new Vt(1, 0, 0, -1, 0, Dr());
          t.matrix && (i = i.multiply(t.matrix || Yt), r = ir.call(n, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + r + " scn"), n.gState && y.setGState(n.gState), lt(e), lt("Q");
        }
      },
      or = function (t) {
        switch (t) {
          case "f":
          case "F":
            return "W n";
          case "f*":
            return "W* n";
          case "B":
            return "W S";
          case "B*":
            return "W* S";
          case "S":
            return "W S";
          case "n":
            return "W n";
        }
      },
      sr = y.moveTo = function (t, e) {
        return lt(E(U(t)) + " " + E(H(e)) + " m"), this;
      },
      cr = y.lineTo = function (t, e) {
        return lt(E(U(t)) + " " + E(H(e)) + " l"), this;
      },
      ur = y.curveTo = function (t, e, r, n, i, a) {
        return lt([E(U(t)), E(H(e)), E(U(r)), E(H(n)), E(U(i)), E(H(a)), "c"].join(" ")), this;
      };
    y.__private__.line = y.line = function (t, e, r, n, i) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
      return S === x.COMPAT ? this.lines([[r - t, n - e]], t, e, [1, 1], i || "S") : this.lines([[r - t, n - e]], t, e, [1, 1]).stroke();
    }, y.__private__.lines = y.lines = function (t, e, r, n, i, a) {
      var o, s, c, u, h, l, f, d, p, g, m, v;
      if ("number" == typeof t && (v = r, r = e, e = t, t = v), n = n || [1, 1], a = a || !1, isNaN(e) || isNaN(r) || !Array.isArray(t) || !Array.isArray(n) || !Qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
      for (sr(e, r), o = n[0], s = n[1], u = t.length, g = e, m = r, c = 0; c < u; c++) 2 === (h = t[c]).length ? (g = h[0] * o + g, m = h[1] * s + m, cr(g, m)) : (l = h[0] * o + g, f = h[1] * s + m, d = h[2] * o + g, p = h[3] * s + m, g = h[4] * o + g, m = h[5] * s + m, ur(l, f, d, p, g, m));
      return a && er(), nr(i), this;
    }, y.path = function (t) {
      for (var e = 0; e < t.length; e++) {
        var r = t[e],
          n = r.c;
        switch (r.op) {
          case "m":
            sr(n[0], n[1]);
            break;
          case "l":
            cr(n[0], n[1]);
            break;
          case "c":
            ur.apply(this, n);
            break;
          case "h":
            er();
        }
      }
      return this;
    }, y.__private__.rect = y.rect = function (t, e, r, n, i) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
      return S === x.COMPAT && (n = -n), lt([E(U(t)), E(H(e)), E(U(r)), E(U(n)), "re"].join(" ")), nr(i), this;
    }, y.__private__.triangle = y.triangle = function (t, e, r, n, i, a, o) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
      return this.lines([[r - t, n - e], [i - r, a - n], [t - i, e - a]], t, e, [1, 1], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function (t, e, r, n, i, a, o) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
      var s = 4 / 3 * (Math.SQRT2 - 1);
      return i = Math.min(i, .5 * r), a = Math.min(a, .5 * n), this.lines([[r - 2 * i, 0], [i * s, 0, i, a - a * s, i, a], [0, n - 2 * a], [0, a * s, -i * s, a, -i, a], [2 * i - r, 0], [-i * s, 0, -i, -a * s, -i, -a], [0, 2 * a - n], [0, -a * s, i * s, -a, i, -a]], t + i, e, [1, 1], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function (t, e, r, n, i) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
      var a = 4 / 3 * (Math.SQRT2 - 1) * r,
        o = 4 / 3 * (Math.SQRT2 - 1) * n;
      return sr(t + r, e), ur(t + r, e - o, t + a, e - n, t, e - n), ur(t - a, e - n, t - r, e - o, t - r, e), ur(t - r, e + o, t - a, e + n, t, e + n), ur(t + a, e + n, t + r, e + o, t + r, e), nr(i), this;
    }, y.__private__.circle = y.circle = function (t, e, r, n) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || !Qe(n)) throw new Error("Invalid arguments passed to jsPDF.circle");
      return this.ellipse(t, e, r, r, n);
    }, y.setFont = function (t, e, r) {
      return r && (e = j(e, r)), St = qe(t, e, {
        disableWarning: !1
      }), this;
    };
    var hr = y.__private__.getFont = y.getFont = function () {
      return It[qe.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function () {
      var t,
        e,
        r = {};
      for (t in Ct) if (Ct.hasOwnProperty(t)) for (e in r[t] = [], Ct[t]) Ct[t].hasOwnProperty(e) && r[t].push(e);
      return r;
    }, y.addFont = function (t, e, r, n, i) {
      var a = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
      return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (r = j(r, n)), i = i || "Identity-H", Pe.call(this, t, e, r, i);
    };
    var lr,
      fr = t.lineWidth || .200025,
      dr = y.__private__.setLineWidth = y.setLineWidth = function (t) {
        return lt(E(U(t)) + " w"), this;
      };
    y.__private__.setLineDash = M.API.setLineDash = M.API.setLineDashPattern = function (t, e) {
      if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
      return t = t.map(function (t) {
        return E(U(t));
      }).join(" "), e = E(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var pr = y.__private__.getLineHeight = y.getLineHeight = function () {
      return gt * lr;
    };
    y.__private__.getLineHeight = y.getLineHeight = function () {
      return gt * lr;
    };
    var gr = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function (t) {
        return "number" == typeof (t = t || 1.15) && (lr = t), this;
      },
      mr = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function () {
        return lr;
      };
    gr(t.lineHeight);
    var vr = y.__private__.getHorizontalCoordinate = function (t) {
        return U(t);
      },
      br = y.__private__.getVerticalCoordinate = function (t) {
        return S === x.ADVANCED ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
      },
      yr = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function (t) {
        return E(vr(t));
      },
      wr = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function (t) {
        return E(br(t));
      },
      Nr = t.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function () {
      return ee(Nr);
    }, y.__private__.setStrokeColor = y.setDrawColor = function (t, e, r, n) {
      return Nr = re({
        ch1: t,
        ch2: e,
        ch3: r,
        ch4: n,
        pdfColorType: "draw",
        precision: 2
      }), lt(Nr), this;
    };
    var Lr = t.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function () {
      return ee(Lr);
    }, y.__private__.setFillColor = y.setFillColor = function (t, e, r, n) {
      return Lr = re({
        ch1: t,
        ch2: e,
        ch3: r,
        ch4: n,
        pdfColorType: "fill",
        precision: 2
      }), lt(Lr), this;
    };
    var Ar = t.textColor || "0 g",
      xr = y.__private__.getTextColor = y.getTextColor = function () {
        return ee(Ar);
      };
    y.__private__.setTextColor = y.setTextColor = function (t, e, r, n) {
      return Ar = re({
        ch1: t,
        ch2: e,
        ch3: r,
        ch4: n,
        pdfColorType: "text",
        precision: 3
      }), this;
    };
    var Sr = t.charSpace,
      _r = y.__private__.getCharSpace = y.getCharSpace = function () {
        return parseFloat(Sr || 0);
      };
    y.__private__.setCharSpace = y.setCharSpace = function (t) {
      if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
      return Sr = t, this;
    };
    var Pr = 0;
    y.CapJoinStyles = {
      0: 0,
      butt: 0,
      but: 0,
      miter: 0,
      1: 1,
      round: 1,
      rounded: 1,
      circle: 1,
      2: 2,
      projecting: 2,
      project: 2,
      square: 2,
      bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function (t) {
      var e = y.CapJoinStyles[t];
      if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
      return Pr = e, lt(e + " J"), this;
    };
    var kr = 0;
    y.__private__.setLineJoin = y.setLineJoin = function (t) {
      var e = y.CapJoinStyles[t];
      if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
      return kr = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function (t) {
      if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
      return lt(E(U(t)) + " M"), this;
    }, y.GState = C, y.setGState = function (t) {
      (t = "string" == typeof t ? Mt[Et[t]] : Fr(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var Fr = function (t, e) {
      if (!t || !Et[t]) {
        var r = !1;
        for (var n in Mt) if (Mt.hasOwnProperty(n) && Mt[n].equals(e)) {
          r = !0;
          break;
        }
        if (r) e = Mt[n];else {
          var i = "GS" + (Object.keys(Mt).length + 1).toString(10);
          Mt[i] = e, e.id = i;
        }
        return t && (Et[t] = e.id), Tt.publish("addGState", e), e;
      }
    };
    y.addGState = function (t, e) {
      return Fr(t, e), this;
    }, y.saveGraphicsState = function () {
      return lt("q"), jt.push({
        key: St,
        size: gt,
        color: Ar
      }), this;
    }, y.restoreGraphicsState = function () {
      lt("Q");
      var t = jt.pop();
      return St = t.key, gt = t.size, Ar = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function (t) {
      return lt(t.toString() + " cm"), this;
    }, y.comment = function (t) {
      return lt("#" + t), this;
    };
    var Ir = function (t, e) {
        var r = t || 0;
        Object.defineProperty(this, "x", {
          enumerable: !0,
          get: function () {
            return r;
          },
          set: function (t) {
            isNaN(t) || (r = parseFloat(t));
          }
        });
        var n = e || 0;
        Object.defineProperty(this, "y", {
          enumerable: !0,
          get: function () {
            return n;
          },
          set: function (t) {
            isNaN(t) || (n = parseFloat(t));
          }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
          enumerable: !0,
          get: function () {
            return i;
          },
          set: function (t) {
            i = t.toString();
          }
        }), this;
      },
      Cr = function (t, e, r, n) {
        Ir.call(this, t, e), this.type = "rect";
        var i = r || 0;
        Object.defineProperty(this, "w", {
          enumerable: !0,
          get: function () {
            return i;
          },
          set: function (t) {
            isNaN(t) || (i = parseFloat(t));
          }
        });
        var a = n || 0;
        return Object.defineProperty(this, "h", {
          enumerable: !0,
          get: function () {
            return a;
          },
          set: function (t) {
            isNaN(t) || (a = parseFloat(t));
          }
        }), this;
      },
      jr = function () {
        this.page = Dt, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = Pt, this.y = kt, this.matrix = Ft, this.width = Er($), this.height = Dr($), this.outputDestination = ct, this.id = "", this.objectNumber = -1;
      };
    jr.prototype.restore = function () {
      Dt = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, Pt = this.x, kt = this.y, Ft = this.matrix, qr($, this.width), Rr($, this.height), ct = this.outputDestination;
    };
    var Or = function (t, e, r, n, i) {
        Wt.push(new jr()), Dt = $ = 0, ot = [], Pt = t, kt = e, Ft = i, je([r, n]);
      },
      Br = function (t) {
        if (Ht[t]) Wt.pop().restore();else {
          var e = new jr(),
            r = "Xo" + (Object.keys(zt).length + 1).toString(10);
          e.id = r, Ht[t] = r, zt[r] = e, Tt.publish("addFormObject", e), Wt.pop().restore();
        }
      };
    for (var Mr in y.beginFormObject = function (t, e, r, n, i) {
      return Or(t, e, r, n, i), this;
    }, y.endFormObject = function (t) {
      return Br(t), this;
    }, y.doFormObject = function (t, e) {
      var r = zt[Ht[t]];
      return lt("q"), lt(e.toString() + " cm"), lt("/" + r.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function (t) {
      var e = zt[Ht[t]];
      return {
        x: e.x,
        y: e.y,
        width: e.width,
        height: e.height,
        matrix: e.matrix
      };
    }, y.save = function (t, e) {
      return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? (h(We(He()), t), "function" == typeof h.unload && r.setTimeout && setTimeout(h.unload, 911), this) : new Promise(function (e, n) {
        try {
          var i = h(We(He()), t);
          "function" == typeof h.unload && r.setTimeout && setTimeout(h.unload, 911), e(i);
        } catch (t) {
          n(t.message);
        }
      });
    }, M.API) M.API.hasOwnProperty(Mr) && ("events" === Mr && M.API.events.length ? function (t, e) {
      var r, n, i;
      for (i = e.length - 1; -1 !== i; i--) r = e[i][0], n = e[i][1], t.subscribe.apply(t, [r].concat("function" == typeof n ? [n] : n));
    }(Tt, M.API.events) : y[Mr] = M.API[Mr]);
    var Er = y.getPageWidth = function (t) {
        return (Rt[t = t || $].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX) / _t;
      },
      qr = y.setPageWidth = function (t, e) {
        Rt[t].mediaBox.topRightX = e * _t + Rt[t].mediaBox.bottomLeftX;
      },
      Dr = y.getPageHeight = function (t) {
        return (Rt[t = t || $].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY) / _t;
      },
      Rr = y.setPageHeight = function (t, e) {
        Rt[t].mediaBox.topRightY = e * _t + Rt[t].mediaBox.bottomLeftY;
      };
    return y.internal = {
      pdfEscape: Ce,
      getStyle: tr,
      getFont: hr,
      getFontSize: vt,
      getCharSpace: _r,
      getTextColor: xr,
      getLineHeight: pr,
      getLineHeightFactor: mr,
      write: ft,
      getHorizontalCoordinate: vr,
      getVerticalCoordinate: br,
      getCoordinateString: yr,
      getVerticalCoordinateString: wr,
      collections: {},
      newObject: Xt,
      newAdditionalObject: $t,
      newObjectDeferred: Kt,
      newObjectDeferredBegin: Zt,
      getFilters: ne,
      putStream: ie,
      events: Tt,
      scaleFactor: _t,
      pageSize: {
        getWidth: function () {
          return Er($);
        },
        setWidth: function (t) {
          qr($, t);
        },
        getHeight: function () {
          return Dr($);
        },
        setHeight: function (t) {
          Rr($, t);
        }
      },
      encryptionOptions: m,
      encryption: Ye,
      getEncryptor: Je,
      output: Ve,
      getNumberOfPages: Ee,
      pages: ot,
      out: lt,
      f2: R,
      f3: T,
      getPageInfo: Xe,
      getPageInfoByObjId: Ke,
      getCurrentPageInfo: Ze,
      getPDFVersion: N,
      Point: Ir,
      Rectangle: Cr,
      Matrix: Vt,
      hasHotfix: Ge
    }, Object.defineProperty(y.internal.pageSize, "width", {
      get: function () {
        return Er($);
      },
      set: function (t) {
        qr($, t);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
      get: function () {
        return Dr($);
      },
      set: function (t) {
        Rr($, t);
      },
      enumerable: !0,
      configurable: !0
    }), ke.call(y, pt), St = "F1", Oe(s, a), Tt.publish("initialized"), y;
  }
  k.prototype.lsbFirstWord = function (t) {
    return String.fromCharCode(t >> 0 & 255, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
  }, k.prototype.toHexString = function (t) {
    return t.split("").map(function (t) {
      return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
  }, k.prototype.hexToBytes = function (t) {
    for (var e = [], r = 0; r < t.length; r += 2) e.push(String.fromCharCode(parseInt(t.substr(r, 2), 16)));
    return e.join("");
  }, k.prototype.processOwnerPassword = function (t, e) {
    return _(A(e).substr(0, 5), t);
  }, k.prototype.encryptor = function (t, e) {
    var r = A(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function (t) {
      return _(r, t);
    };
  }, C.prototype.equals = function (t) {
    var r,
      n = "id,objectNumber,equals";
    if (!t || e(t) !== e(this)) return !1;
    var i = 0;
    for (r in this) if (!(n.indexOf(r) >= 0)) {
      if (this.hasOwnProperty(r) && !t.hasOwnProperty(r)) return !1;
      if (this[r] !== t[r]) return !1;
      i++;
    }
    for (r in t) t.hasOwnProperty(r) && n.indexOf(r) < 0 && i--;
    return 0 === i;
  }, M.API = {
    events: []
  }, M.version = "2.4.0";
  var E = M.API,
    q = 1,
    D = function (t) {
      return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    },
    R = function (t) {
      return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
    },
    T = function (t) {
      return t.toFixed(2);
    },
    U = function (t) {
      return t.toFixed(5);
    };
  E.__acroform__ = {};
  var z = function (t, e) {
      t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
    },
    H = function (t) {
      return t * q;
    },
    W = function (t) {
      var e = new ct(),
        r = Lt.internal.getHeight(t) || 0,
        n = Lt.internal.getWidth(t) || 0;
      return e.BBox = [0, 0, Number(T(n)), Number(T(r))], e;
    },
    V = E.__acroform__.setBit = function (t, e) {
      if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
      return t |= 1 << e;
    },
    G = E.__acroform__.clearBit = function (t, e) {
      if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
      return t &= ~(1 << e);
    },
    Y = E.__acroform__.getBit = function (t, e) {
      if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
      return 0 == (t & 1 << e) ? 0 : 1;
    },
    J = E.__acroform__.getBitForPdf = function (t, e) {
      if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
      return Y(t, e - 1);
    },
    X = E.__acroform__.setBitForPdf = function (t, e) {
      if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
      return V(t, e - 1);
    },
    K = E.__acroform__.clearBitForPdf = function (t, e) {
      if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
      return G(t, e - 1);
    },
    Z = E.__acroform__.calculateCoordinates = function (t, e) {
      var r = e.internal.getHorizontalCoordinate,
        n = e.internal.getVerticalCoordinate,
        i = t[0],
        a = t[1],
        o = t[2],
        s = t[3],
        c = {};
      return c.lowerLeft_X = r(i) || 0, c.lowerLeft_Y = n(a + s) || 0, c.upperRight_X = r(i + o) || 0, c.upperRight_Y = n(a) || 0, [Number(T(c.lowerLeft_X)), Number(T(c.lowerLeft_Y)), Number(T(c.upperRight_X)), Number(T(c.upperRight_Y))];
    },
    $ = function (t) {
      if (t.appearanceStreamContent) return t.appearanceStreamContent;
      if (t.V || t.DV) {
        var e = [],
          r = t._V || t.DV,
          n = Q(t, r),
          i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + T(n.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(n.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = W(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
      }
    },
    Q = function (t, e) {
      var r = 0 === t.fontSize ? t.maxFontSize : t.fontSize,
        n = {
          text: "",
          fontSize: ""
        },
        i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" "),
        a = r,
        o = Lt.internal.getHeight(t) || 0;
      o = o < 0 ? -o : o;
      var s = Lt.internal.getWidth(t) || 0;
      s = s < 0 ? -s : s;
      var c = function (e, r, n) {
        if (e + 1 < i.length) {
          var a = r + " " + i[e + 1];
          return tt(a, t, n).width <= s - 4;
        }
        return !1;
      };
      a++;
      t: for (; a > 0;) {
        e = "", a--;
        var u,
          h,
          l = tt("3", t, a).height,
          f = t.multiline ? o - a : (o - l) / 2,
          d = f += 2,
          p = 0,
          g = 0;
        if (a <= 0) {
          e = "(...) Tj\n", e += "% Width of Text: " + tt(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
          break;
        }
        var m = "",
          v = 0;
        for (var b in i) if (i.hasOwnProperty(b)) {
          m = " " == (m += i[b] + " ").substr(m.length - 1) ? m.substr(0, m.length - 1) : m;
          var y = parseInt(b),
            w = c(y, m, a),
            N = b >= i.length - 1;
          if (w && !N) {
            m += " ";
            continue;
          }
          if (w || N) {
            if (N) g = y;else if (t.multiline && (l + 2) * (v + 2) + 2 > o) continue t;
          } else {
            if (!t.multiline) continue t;
            if ((l + 2) * (v + 2) + 2 > o) continue t;
            g = y;
          }
          for (var L = "", A = p; A <= g; A++) L += i[A] + " ";
          switch (L = " " == L.substr(L.length - 1) ? L.substr(0, L.length - 1) : L, h = tt(L, t, a).width, t.textAlign) {
            case "right":
              u = s - h - 2;
              break;
            case "center":
              u = (s - h) / 2;
              break;
            case "left":
            default:
              u = 2;
          }
          e += T(u) + " " + T(d) + " Td\n", e += "(" + D(L) + ") Tj\n", e += -T(u) + " 0 Td\n", d = -(a + 2), h = 0, p = g + 1, v++, m = "";
        } else ;
        break;
      }
      return n.text = e, n.fontSize = a, n;
    },
    tt = function (t, e, r) {
      var n = e.scope.internal.getFont(e.fontName, e.fontStyle),
        i = e.scope.getStringUnitWidth(t, {
          font: n,
          fontSize: parseFloat(r),
          charSpace: 0
        }) * parseFloat(r);
      return {
        height: e.scope.getStringUnitWidth("3", {
          font: n,
          fontSize: parseFloat(r),
          charSpace: 0
        }) * parseFloat(r) * 1.5,
        width: i
      };
    },
    et = {
      fields: [],
      xForms: [],
      acroFormDictionaryRoot: null,
      printedOut: !1,
      internal: null,
      isInitialized: !1
    },
    rt = function (t, e) {
      var r = {
        type: "reference",
        object: t
      };
      void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function (t) {
        return t.type === r.type && t.object === r.object;
      }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(r);
    },
    nt = function (t, r) {
      for (var n in t) if (t.hasOwnProperty(n)) {
        var i = n,
          a = t[n];
        r.internal.newObjectDeferredBegin(a.objId, !0), "object" === e(a) && "function" == typeof a.putStream && a.putStream(), delete t[i];
      }
    },
    it = function (t, r) {
      if (r.scope = t, void 0 !== t.internal && (void 0 === t.internal.acroformPlugin || !1 === t.internal.acroformPlugin.isInitialized)) {
        if (ht.FieldNum = 0, t.internal.acroformPlugin = JSON.parse(JSON.stringify(et)), t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        q = t.internal.scaleFactor, t.internal.acroformPlugin.acroFormDictionaryRoot = new ut(), t.internal.acroformPlugin.acroFormDictionaryRoot.scope = t, t.internal.acroformPlugin.acroFormDictionaryRoot._eventID = t.internal.events.subscribe("postPutResources", function () {
          !function (t) {
            t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
          }(t);
        }), t.internal.events.subscribe("buildDocument", function () {
          !function (t) {
            t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
            var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
            for (var r in e) if (e.hasOwnProperty(r)) {
              var n = e[r];
              n.objId = void 0, n.hasAnnotation && rt(n, t);
            }
          }(t);
        }), t.internal.events.subscribe("putCatalog", function () {
          !function (t) {
            if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
            t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
          }(t);
        }), t.internal.events.subscribe("postPutPages", function (r) {
          !function (t, r) {
            var n = !t;
            for (var i in t || (r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), t = t || r.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (t.hasOwnProperty(i)) {
              var a = t[i],
                o = [],
                s = a.Rect;
              if (a.Rect && (a.Rect = Z(a.Rect, r)), r.internal.newObjectDeferredBegin(a.objId, !0), a.DA = Lt.createDefaultAppearanceStream(a), "object" === e(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                var c = $(a);
                o.push({
                  key: "AP",
                  value: "<</N " + c + ">>"
                }), r.internal.acroformPlugin.xForms.push(c);
              }
              if (a.appearanceStreamContent) {
                var u = "";
                for (var h in a.appearanceStreamContent) if (a.appearanceStreamContent.hasOwnProperty(h)) {
                  var l = a.appearanceStreamContent[h];
                  if (u += "/" + h + " ", u += "<<", Object.keys(l).length >= 1 || Array.isArray(l)) {
                    for (var i in l) if (l.hasOwnProperty(i)) {
                      var f = l[i];
                      "function" == typeof f && (f = f.call(r, a)), u += "/" + i + " " + f + " ", r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                    }
                  } else "function" == typeof (f = l) && (f = f.call(r, a)), u += "/" + i + " " + f, r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                  u += ">>";
                }
                o.push({
                  key: "AP",
                  value: "<<\n" + u + ">>"
                });
              }
              r.internal.putStream({
                additionalKeyValues: o,
                objectId: a.objId
              }), r.internal.out("endobj");
            }
            n && nt(r.internal.acroformPlugin.xForms, r);
          }(r, t);
        }), t.internal.acroformPlugin.isInitialized = !0;
      }
    },
    at = E.__acroform__.arrayToPdfArray = function (t, r, n) {
      var i = function (t) {
        return t;
      };
      if (Array.isArray(t)) {
        for (var a = "[", o = 0; o < t.length; o++) switch (0 !== o && (a += " "), e(t[o])) {
          case "boolean":
          case "number":
          case "object":
            a += t[o].toString();
            break;
          case "string":
            "/" !== t[o].substr(0, 1) ? (void 0 !== r && n && (i = n.internal.getEncryptor(r)), a += "(" + D(i(t[o].toString())) + ")") : a += t[o].toString();
        }
        return a += "]";
      }
      throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
    };
  var ot = function (t, e, r) {
      var n = function (t) {
        return t;
      };
      return void 0 !== e && r && (n = r.internal.getEncryptor(e)), (t = t || "").toString(), t = "(" + D(n(t)) + ")";
    },
    st = function () {
      this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function () {
          if (void 0 === this._objId) {
            if (void 0 === this.scope) return;
            this._objId = this.scope.internal.newObjectDeferred();
          }
          return this._objId;
        },
        set: function (t) {
          this._objId = t;
        }
      }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
      });
    };
  st.prototype.toString = function () {
    return this.objId + " 0 R";
  }, st.prototype.putStream = function () {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
      data: this.stream,
      additionalKeyValues: t,
      objectId: this.objId
    }), this.scope.internal.out("endobj");
  }, st.prototype.getKeyValueListForStream = function () {
    var t = [],
      e = Object.getOwnPropertyNames(this).filter(function (t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
      });
    for (var r in e) if (!1 === Object.getOwnPropertyDescriptor(this, e[r]).configurable) {
      var n = e[r],
        i = this[n];
      i && (Array.isArray(i) ? t.push({
        key: n,
        value: at(i, this.objId, this.scope)
      }) : i instanceof st ? (i.scope = this.scope, t.push({
        key: n,
        value: i.objId + " 0 R"
      })) : "function" != typeof i && t.push({
        key: n,
        value: i
      }));
    }
    return t;
  };
  var ct = function () {
    st.call(this), Object.defineProperty(this, "Type", {
      value: "/XObject",
      configurable: !1,
      writable: !0
    }), Object.defineProperty(this, "Subtype", {
      value: "/Form",
      configurable: !1,
      writable: !0
    }), Object.defineProperty(this, "FormType", {
      value: 1,
      configurable: !1,
      writable: !0
    });
    var t,
      e = [];
    Object.defineProperty(this, "BBox", {
      configurable: !1,
      get: function () {
        return e;
      },
      set: function (t) {
        e = t;
      }
    }), Object.defineProperty(this, "Resources", {
      value: "2 0 R",
      configurable: !1,
      writable: !0
    }), Object.defineProperty(this, "stream", {
      enumerable: !1,
      configurable: !0,
      set: function (e) {
        t = e.trim();
      },
      get: function () {
        return t || null;
      }
    });
  };
  z(ct, st);
  var ut = function () {
    st.call(this);
    var t,
      e = [];
    Object.defineProperty(this, "Kids", {
      enumerable: !1,
      configurable: !0,
      get: function () {
        return e.length > 0 ? e : void 0;
      }
    }), Object.defineProperty(this, "Fields", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        return e;
      }
    }), Object.defineProperty(this, "DA", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        if (t) {
          var e = function (t) {
            return t;
          };
          return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + D(e(t)) + ")";
        }
      },
      set: function (e) {
        t = e;
      }
    });
  };
  z(ut, st);
  var ht = function t() {
    st.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        return e;
      },
      set: function (t) {
        if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
        e = t;
      }
    }), Object.defineProperty(this, "showWhenPrinted", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(e, 3));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.F = X(e, 3) : this.F = K(e, 3);
      }
    });
    var r = 0;
    Object.defineProperty(this, "Ff", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        return r;
      },
      set: function (t) {
        if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
        r = t;
      }
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        if (0 !== n.length) return n;
      },
      set: function (t) {
        n = void 0 !== t ? t : [];
      }
    }), Object.defineProperty(this, "x", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return !n || isNaN(n[0]) ? 0 : n[0];
      },
      set: function (t) {
        n[0] = t;
      }
    }), Object.defineProperty(this, "y", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return !n || isNaN(n[1]) ? 0 : n[1];
      },
      set: function (t) {
        n[1] = t;
      }
    }), Object.defineProperty(this, "width", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return !n || isNaN(n[2]) ? 0 : n[2];
      },
      set: function (t) {
        n[2] = t;
      }
    }), Object.defineProperty(this, "height", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return !n || isNaN(n[3]) ? 0 : n[3];
      },
      set: function (t) {
        n[3] = t;
      }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        return i;
      },
      set: function (t) {
        switch (t) {
          case "/Btn":
          case "/Tx":
          case "/Ch":
          case "/Sig":
            i = t;
            break;
          default:
            throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
        }
      }
    });
    var a = null;
    Object.defineProperty(this, "T", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        if (!a || a.length < 1) {
          if (this instanceof bt) return;
          a = "FieldObject" + t.FieldNum++;
        }
        var e = function (t) {
          return t;
        };
        return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + D(e(a)) + ")";
      },
      set: function (t) {
        a = t.toString();
      }
    }), Object.defineProperty(this, "fieldName", {
      configurable: !0,
      enumerable: !0,
      get: function () {
        return a;
      },
      set: function (t) {
        a = t;
      }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return o;
      },
      set: function (t) {
        o = t;
      }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return s;
      },
      set: function (t) {
        s = t;
      }
    });
    var c = 0;
    Object.defineProperty(this, "fontSize", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return c;
      },
      set: function (t) {
        c = t;
      }
    });
    var u = void 0;
    Object.defineProperty(this, "maxFontSize", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return void 0 === u ? 50 / q : u;
      },
      set: function (t) {
        u = t;
      }
    });
    var h = "black";
    Object.defineProperty(this, "color", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return h;
      },
      set: function (t) {
        h = t;
      }
    });
    var l = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        if (!(!l || this instanceof bt || this instanceof wt)) return ot(l, this.objId, this.scope);
      },
      set: function (t) {
        t = t.toString(), l = t;
      }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        if (f) return this instanceof gt == !1 ? ot(f, this.objId, this.scope) : f;
      },
      set: function (t) {
        t = t.toString(), f = this instanceof gt == !1 ? "(" === t.substr(0, 1) ? R(t.substr(1, t.length - 2)) : R(t) : t;
      }
    }), Object.defineProperty(this, "defaultValue", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return this instanceof gt == !0 ? R(f.substr(1, f.length - 1)) : f;
      },
      set: function (t) {
        t = t.toString(), f = this instanceof gt == !0 ? "/" + t : t;
      }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        if (d) return d;
      },
      set: function (t) {
        this.V = t;
      }
    }), Object.defineProperty(this, "V", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        if (d) return this instanceof gt == !1 ? ot(d, this.objId, this.scope) : d;
      },
      set: function (t) {
        t = t.toString(), d = this instanceof gt == !1 ? "(" === t.substr(0, 1) ? R(t.substr(1, t.length - 2)) : R(t) : t;
      }
    }), Object.defineProperty(this, "value", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return this instanceof gt == !0 ? R(d.substr(1, d.length - 1)) : d;
      },
      set: function (t) {
        t = t.toString(), d = this instanceof gt == !0 ? "/" + t : t;
      }
    }), Object.defineProperty(this, "hasAnnotation", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return this.Rect;
      }
    }), Object.defineProperty(this, "Type", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        return this.hasAnnotation ? "/Annot" : null;
      }
    }), Object.defineProperty(this, "Subtype", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        return this.hasAnnotation ? "/Widget" : null;
      }
    });
    var p,
      g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return g;
      },
      set: function (t) {
        t = Boolean(t), g = t;
      }
    }), Object.defineProperty(this, "page", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        if (p) return p;
      },
      set: function (t) {
        p = t;
      }
    }), Object.defineProperty(this, "readOnly", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 1));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 1) : this.Ff = K(this.Ff, 1);
      }
    }), Object.defineProperty(this, "required", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 2));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 2) : this.Ff = K(this.Ff, 2);
      }
    }), Object.defineProperty(this, "noExport", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 3));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 3) : this.Ff = K(this.Ff, 3);
      }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        if (null !== m) return m;
      },
      set: function (t) {
        if (-1 === [0, 1, 2].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
        m = t;
      }
    }), Object.defineProperty(this, "textAlign", {
      get: function () {
        var t;
        switch (m) {
          case 0:
          default:
            t = "left";
            break;
          case 1:
            t = "center";
            break;
          case 2:
            t = "right";
        }
        return t;
      },
      configurable: !0,
      enumerable: !0,
      set: function (t) {
        switch (t) {
          case "right":
          case 2:
            m = 2;
            break;
          case "center":
          case 1:
            m = 1;
            break;
          case "left":
          case 0:
          default:
            m = 0;
        }
      }
    });
  };
  z(ht, st);
  var lt = function () {
    ht.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        return t;
      },
      set: function (e) {
        t = e;
      }
    }), Object.defineProperty(this, "topIndex", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return t;
      },
      set: function (e) {
        t = e;
      }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        return at(e, this.objId, this.scope);
      },
      set: function (t) {
        var r, n;
        n = [], "string" == typeof (r = t) && (n = function (t, e, r) {
          r || (r = 1);
          for (var n, i = []; n = e.exec(t);) i.push(n[r]);
          return i;
        }(r, /\((.*?)\)/g)), e = n;
      }
    }), this.getOptions = function () {
      return e;
    }, this.setOptions = function (t) {
      e = t, this.sort && e.sort();
    }, this.addOption = function (t) {
      t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function (t, r) {
      for (r = r || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== r););
    }, Object.defineProperty(this, "combo", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 18));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 18) : this.Ff = K(this.Ff, 18);
      }
    }), Object.defineProperty(this, "edit", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 19));
      },
      set: function (t) {
        !0 === this.combo && (!0 === Boolean(t) ? this.Ff = X(this.Ff, 19) : this.Ff = K(this.Ff, 19));
      }
    }), Object.defineProperty(this, "sort", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 20));
      },
      set: function (t) {
        !0 === Boolean(t) ? (this.Ff = X(this.Ff, 20), e.sort()) : this.Ff = K(this.Ff, 20);
      }
    }), Object.defineProperty(this, "multiSelect", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 22));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 22) : this.Ff = K(this.Ff, 22);
      }
    }), Object.defineProperty(this, "doNotSpellCheck", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 23));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 23) : this.Ff = K(this.Ff, 23);
      }
    }), Object.defineProperty(this, "commitOnSelChange", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 27));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 27) : this.Ff = K(this.Ff, 27);
      }
    }), this.hasAppearanceStream = !1;
  };
  z(lt, ht);
  var ft = function () {
    lt.call(this), this.fontName = "helvetica", this.combo = !1;
  };
  z(ft, lt);
  var dt = function () {
    ft.call(this), this.combo = !0;
  };
  z(dt, ft);
  var pt = function () {
    dt.call(this), this.edit = !0;
  };
  z(pt, dt);
  var gt = function () {
    ht.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 15));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 15) : this.Ff = K(this.Ff, 15);
      }
    }), Object.defineProperty(this, "radio", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 16));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 16) : this.Ff = K(this.Ff, 16);
      }
    }), Object.defineProperty(this, "pushButton", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 17));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 17) : this.Ff = K(this.Ff, 17);
      }
    }), Object.defineProperty(this, "radioIsUnison", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 26));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 26) : this.Ff = K(this.Ff, 26);
      }
    });
    var t,
      r = {};
    Object.defineProperty(this, "MK", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        var t = function (t) {
          return t;
        };
        if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(r).length) {
          var e,
            n = [];
          for (e in n.push("<<"), r) n.push("/" + e + " (" + D(t(r[e])) + ")");
          return n.push(">>"), n.join("\n");
        }
      },
      set: function (t) {
        "object" === e(t) && (r = t);
      }
    }), Object.defineProperty(this, "caption", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return r.CA || "";
      },
      set: function (t) {
        "string" == typeof t && (r.CA = t);
      }
    }), Object.defineProperty(this, "AS", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        return t;
      },
      set: function (e) {
        t = e;
      }
    }), Object.defineProperty(this, "appearanceState", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return t.substr(1, t.length - 1);
      },
      set: function (e) {
        t = "/" + e;
      }
    });
  };
  z(gt, ht);
  var mt = function () {
    gt.call(this), this.pushButton = !0;
  };
  z(mt, gt);
  var vt = function () {
    gt.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        return t;
      },
      set: function (e) {
        t = void 0 !== e ? e : [];
      }
    });
  };
  z(vt, gt);
  var bt = function () {
    var t, r;
    ht.call(this), Object.defineProperty(this, "Parent", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        return t;
      },
      set: function (e) {
        t = e;
      }
    }), Object.defineProperty(this, "optionName", {
      enumerable: !1,
      configurable: !0,
      get: function () {
        return r;
      },
      set: function (t) {
        r = t;
      }
    });
    var n,
      i = {};
    Object.defineProperty(this, "MK", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        var t = function (t) {
          return t;
        };
        this.scope && (t = this.scope.internal.getEncryptor(this.objId));
        var e,
          r = [];
        for (e in r.push("<<"), i) r.push("/" + e + " (" + D(t(i[e])) + ")");
        return r.push(">>"), r.join("\n");
      },
      set: function (t) {
        "object" === e(t) && (i = t);
      }
    }), Object.defineProperty(this, "caption", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return i.CA || "";
      },
      set: function (t) {
        "string" == typeof t && (i.CA = t);
      }
    }), Object.defineProperty(this, "AS", {
      enumerable: !1,
      configurable: !1,
      get: function () {
        return n;
      },
      set: function (t) {
        n = t;
      }
    }), Object.defineProperty(this, "appearanceState", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return n.substr(1, n.length - 1);
      },
      set: function (t) {
        n = "/" + t;
      }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = Lt.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
  };
  z(bt, ht), vt.prototype.setAppearance = function (t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for (var e in this.Kids) if (this.Kids.hasOwnProperty(e)) {
      var r = this.Kids[e];
      r.appearanceStreamContent = t.createAppearanceStream(r.optionName), r.caption = t.getCA();
    }
  }, vt.prototype.createOption = function (t) {
    var e = new bt();
    return e.Parent = this, e.optionName = t, this.Kids.push(e), At.call(this.scope, e), e;
  };
  var yt = function () {
    gt.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = Lt.CheckBox.createAppearanceStream();
  };
  z(yt, gt);
  var wt = function () {
    ht.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 13));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 13) : this.Ff = K(this.Ff, 13);
      }
    }), Object.defineProperty(this, "fileSelect", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 21));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 21) : this.Ff = K(this.Ff, 21);
      }
    }), Object.defineProperty(this, "doNotSpellCheck", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 23));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 23) : this.Ff = K(this.Ff, 23);
      }
    }), Object.defineProperty(this, "doNotScroll", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 24));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 24) : this.Ff = K(this.Ff, 24);
      }
    }), Object.defineProperty(this, "comb", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 25));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 25) : this.Ff = K(this.Ff, 25);
      }
    }), Object.defineProperty(this, "richText", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 26));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 26) : this.Ff = K(this.Ff, 26);
      }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
      enumerable: !0,
      configurable: !1,
      get: function () {
        return t;
      },
      set: function (e) {
        t = e;
      }
    }), Object.defineProperty(this, "maxLength", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return t;
      },
      set: function (e) {
        Number.isInteger(e) && (t = e);
      }
    }), Object.defineProperty(this, "hasAppearanceStream", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return this.V || this.DV;
      }
    });
  };
  z(wt, ht);
  var Nt = function () {
    wt.call(this), Object.defineProperty(this, "password", {
      enumerable: !0,
      configurable: !0,
      get: function () {
        return Boolean(J(this.Ff, 14));
      },
      set: function (t) {
        !0 === Boolean(t) ? this.Ff = X(this.Ff, 14) : this.Ff = K(this.Ff, 14);
      }
    }), this.password = !0;
  };
  z(Nt, wt);
  var Lt = {
    CheckBox: {
      createAppearanceStream: function () {
        return {
          N: {
            On: Lt.CheckBox.YesNormal
          },
          D: {
            On: Lt.CheckBox.YesPushDown,
            Off: Lt.CheckBox.OffPushDown
          }
        };
      },
      YesPushDown: function (t) {
        var e = W(t);
        e.scope = t.scope;
        var r = [],
          n = t.scope.internal.getFont(t.fontName, t.fontStyle).id,
          i = t.scope.__private__.encodeColorString(t.color),
          a = Q(t, t.caption);
        return r.push("0.749023 g"), r.push("0 0 " + T(Lt.internal.getWidth(t)) + " " + T(Lt.internal.getHeight(t)) + " re"), r.push("f"), r.push("BMC"), r.push("q"), r.push("0 0 1 rg"), r.push("/" + n + " " + T(a.fontSize) + " Tf " + i), r.push("BT"), r.push(a.text), r.push("ET"), r.push("Q"), r.push("EMC"), e.stream = r.join("\n"), e;
      },
      YesNormal: function (t) {
        var e = W(t);
        e.scope = t.scope;
        var r = t.scope.internal.getFont(t.fontName, t.fontStyle).id,
          n = t.scope.__private__.encodeColorString(t.color),
          i = [],
          a = Lt.internal.getHeight(t),
          o = Lt.internal.getWidth(t),
          s = Q(t, t.caption);
        return i.push("1 g"), i.push("0 0 " + T(o) + " " + T(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + T(o - 1) + " " + T(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + r + " " + T(s.fontSize) + " Tf " + n), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
      },
      OffPushDown: function (t) {
        var e = W(t);
        e.scope = t.scope;
        var r = [];
        return r.push("0.749023 g"), r.push("0 0 " + T(Lt.internal.getWidth(t)) + " " + T(Lt.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
      }
    },
    RadioButton: {
      Circle: {
        createAppearanceStream: function (t) {
          var e = {
            D: {
              Off: Lt.RadioButton.Circle.OffPushDown
            },
            N: {}
          };
          return e.N[t] = Lt.RadioButton.Circle.YesNormal, e.D[t] = Lt.RadioButton.Circle.YesPushDown, e;
        },
        getCA: function () {
          return "l";
        },
        YesNormal: function (t) {
          var e = W(t);
          e.scope = t.scope;
          var r = [],
            n = Lt.internal.getWidth(t) <= Lt.internal.getHeight(t) ? Lt.internal.getWidth(t) / 4 : Lt.internal.getHeight(t) / 4;
          n = Number((.9 * n).toFixed(5));
          var i = Lt.internal.Bezier_C,
            a = Number((n * i).toFixed(5));
          return r.push("q"), r.push("1 0 0 1 " + U(Lt.internal.getWidth(t) / 2) + " " + U(Lt.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + a + " " + a + " " + n + " 0 " + n + " c"), r.push("-" + a + " " + n + " -" + n + " " + a + " -" + n + " 0 c"), r.push("-" + n + " -" + a + " -" + a + " -" + n + " 0 -" + n + " c"), r.push(a + " -" + n + " " + n + " -" + a + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
        },
        YesPushDown: function (t) {
          var e = W(t);
          e.scope = t.scope;
          var r = [],
            n = Lt.internal.getWidth(t) <= Lt.internal.getHeight(t) ? Lt.internal.getWidth(t) / 4 : Lt.internal.getHeight(t) / 4;
          n = Number((.9 * n).toFixed(5));
          var i = Number((2 * n).toFixed(5)),
            a = Number((i * Lt.internal.Bezier_C).toFixed(5)),
            o = Number((n * Lt.internal.Bezier_C).toFixed(5));
          return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + U(Lt.internal.getWidth(t) / 2) + " " + U(Lt.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), r.push("0 g"), r.push("q"), r.push("1 0 0 1 " + U(Lt.internal.getWidth(t) / 2) + " " + U(Lt.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + o + " " + o + " " + n + " 0 " + n + " c"), r.push("-" + o + " " + n + " -" + n + " " + o + " -" + n + " 0 c"), r.push("-" + n + " -" + o + " -" + o + " -" + n + " 0 -" + n + " c"), r.push(o + " -" + n + " " + n + " -" + o + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
        },
        OffPushDown: function (t) {
          var e = W(t);
          e.scope = t.scope;
          var r = [],
            n = Lt.internal.getWidth(t) <= Lt.internal.getHeight(t) ? Lt.internal.getWidth(t) / 4 : Lt.internal.getHeight(t) / 4;
          n = Number((.9 * n).toFixed(5));
          var i = Number((2 * n).toFixed(5)),
            a = Number((i * Lt.internal.Bezier_C).toFixed(5));
          return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + U(Lt.internal.getWidth(t) / 2) + " " + U(Lt.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
        }
      },
      Cross: {
        createAppearanceStream: function (t) {
          var e = {
            D: {
              Off: Lt.RadioButton.Cross.OffPushDown
            },
            N: {}
          };
          return e.N[t] = Lt.RadioButton.Cross.YesNormal, e.D[t] = Lt.RadioButton.Cross.YesPushDown, e;
        },
        getCA: function () {
          return "8";
        },
        YesNormal: function (t) {
          var e = W(t);
          e.scope = t.scope;
          var r = [],
            n = Lt.internal.calculateCross(t);
          return r.push("q"), r.push("1 1 " + T(Lt.internal.getWidth(t) - 2) + " " + T(Lt.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push(T(n.x1.x) + " " + T(n.x1.y) + " m"), r.push(T(n.x2.x) + " " + T(n.x2.y) + " l"), r.push(T(n.x4.x) + " " + T(n.x4.y) + " m"), r.push(T(n.x3.x) + " " + T(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
        },
        YesPushDown: function (t) {
          var e = W(t);
          e.scope = t.scope;
          var r = Lt.internal.calculateCross(t),
            n = [];
          return n.push("0.749023 g"), n.push("0 0 " + T(Lt.internal.getWidth(t)) + " " + T(Lt.internal.getHeight(t)) + " re"), n.push("f"), n.push("q"), n.push("1 1 " + T(Lt.internal.getWidth(t) - 2) + " " + T(Lt.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push(T(r.x1.x) + " " + T(r.x1.y) + " m"), n.push(T(r.x2.x) + " " + T(r.x2.y) + " l"), n.push(T(r.x4.x) + " " + T(r.x4.y) + " m"), n.push(T(r.x3.x) + " " + T(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
        },
        OffPushDown: function (t) {
          var e = W(t);
          e.scope = t.scope;
          var r = [];
          return r.push("0.749023 g"), r.push("0 0 " + T(Lt.internal.getWidth(t)) + " " + T(Lt.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
        }
      }
    },
    createDefaultAppearanceStream: function (t) {
      var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id,
        r = t.scope.__private__.encodeColorString(t.color);
      return "/" + e + " " + t.fontSize + " Tf " + r;
    }
  };
  Lt.internal = {
    Bezier_C: .551915024494,
    calculateCross: function (t) {
      var e = Lt.internal.getWidth(t),
        r = Lt.internal.getHeight(t),
        n = Math.min(e, r);
      return {
        x1: {
          x: (e - n) / 2,
          y: (r - n) / 2 + n
        },
        x2: {
          x: (e - n) / 2 + n,
          y: (r - n) / 2
        },
        x3: {
          x: (e - n) / 2,
          y: (r - n) / 2
        },
        x4: {
          x: (e - n) / 2 + n,
          y: (r - n) / 2 + n
        }
      };
    }
  }, Lt.internal.getWidth = function (t) {
    var r = 0;
    return "object" === e(t) && (r = H(t.Rect[2])), r;
  }, Lt.internal.getHeight = function (t) {
    var r = 0;
    return "object" === e(t) && (r = H(t.Rect[3])), r;
  };
  var At = E.addField = function (t) {
    if (it(this, t), !(t instanceof ht)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
  };
  E.AcroFormChoiceField = lt, E.AcroFormListBox = ft, E.AcroFormComboBox = dt, E.AcroFormEditBox = pt, E.AcroFormButton = gt, E.AcroFormPushButton = mt, E.AcroFormRadioButton = vt, E.AcroFormCheckBox = yt, E.AcroFormTextField = wt, E.AcroFormPasswordField = Nt, E.AcroFormAppearance = Lt, E.AcroForm = {
    ChoiceField: lt,
    ListBox: ft,
    ComboBox: dt,
    EditBox: pt,
    Button: gt,
    PushButton: mt,
    RadioButton: vt,
    CheckBox: yt,
    TextField: wt,
    PasswordField: Nt,
    Appearance: Lt
  }, M.AcroForm = {
    ChoiceField: lt,
    ListBox: ft,
    ComboBox: dt,
    EditBox: pt,
    Button: gt,
    PushButton: mt,
    RadioButton: vt,
    CheckBox: yt,
    TextField: wt,
    PasswordField: Nt,
    Appearance: Lt
  };
  var xt = M.AcroForm;
  function St(t) {
    return t.reduce(function (t, e, r) {
      return t[e] = r, t;
    }, {});
  }
  !function (t) {
    t.__addimage__ = {};
    var r = "UNKNOWN",
      n = {
        PNG: [[137, 80, 78, 71]],
        TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]],
        JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]],
        JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]],
        GIF87a: [[71, 73, 70, 56, 55, 97]],
        GIF89a: [[71, 73, 70, 56, 57, 97]],
        WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]],
        BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]]
      },
      i = t.__addimage__.getImageFileTypeByImageData = function (t, e) {
        var i,
          a,
          o,
          s,
          c,
          u = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (x(t)) for (c in n) for (o = n[c], i = 0; i < o.length; i += 1) {
          for (s = !0, a = 0; a < o[i].length; a += 1) if (void 0 !== o[i][a] && o[i][a] !== t[a]) {
            s = !1;
            break;
          }
          if (!0 === s) {
            u = c;
            break;
          }
        } else for (c in n) for (o = n[c], i = 0; i < o.length; i += 1) {
          for (s = !0, a = 0; a < o[i].length; a += 1) if (void 0 !== o[i][a] && o[i][a] !== t.charCodeAt(a)) {
            s = !1;
            break;
          }
          if (!0 === s) {
            u = c;
            break;
          }
        }
        return u === r && e !== r && (u = e), u;
      },
      a = function t(e) {
        for (var r = this.internal.write, n = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");) i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
          key: "Type",
          value: "/XObject"
        }), a.push({
          key: "Subtype",
          value: "/Image"
        }), a.push({
          key: "Width",
          value: e.width
        }), a.push({
          key: "Height",
          value: e.height
        }), e.colorSpace === b.INDEXED ? a.push({
          key: "ColorSpace",
          value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
          key: "ColorSpace",
          value: "/" + e.colorSpace
        }), e.colorSpace === b.DEVICE_CMYK && a.push({
          key: "Decode",
          value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
          key: "BitsPerComponent",
          value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
          key: "DecodeParms",
          value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency)) {
          for (var o = "", s = 0, c = e.transparency.length; s < c; s++) o += e.transparency[s] + " " + e.transparency[s] + " ";
          a.push({
            key: "Mask",
            value: "[" + o + "]"
          });
        }
        void 0 !== e.sMask && a.push({
          key: "SMask",
          value: e.objectId + 1 + " 0 R"
        });
        var u = void 0 !== e.filter ? ["/" + e.filter] : void 0;
        if (n({
          data: e.data,
          additionalKeyValues: a,
          alreadyAppliedFilters: u,
          objectId: e.objectId
        }), r("endobj"), "sMask" in e && void 0 !== e.sMask) {
          var h = "/Predictor " + e.predictor + " /Colors 1 /BitsPerComponent " + e.bitsPerComponent + " /Columns " + e.width,
            l = {
              width: e.width,
              height: e.height,
              colorSpace: "DeviceGray",
              bitsPerComponent: e.bitsPerComponent,
              decodeParameters: h,
              data: e.sMask
            };
          "filter" in e && (l.filter = e.filter), t.call(this, l);
        }
        if (e.colorSpace === b.INDEXED) {
          var f = this.internal.newObject();
          n({
            data: _(new Uint8Array(e.palette)),
            objectId: f
          }), r("endobj");
        }
      },
      o = function () {
        var t = this.internal.collections.addImage_images;
        for (var e in t) a.call(this, t[e]);
      },
      s = function () {
        var t,
          e = this.internal.collections.addImage_images,
          r = this.internal.write;
        for (var n in e) r("/I" + (t = e[n]).index, t.objectId, "0", "R");
      },
      u = function () {
        this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", o), this.internal.events.subscribe("putXobjectDict", s));
      },
      h = function () {
        var t = this.internal.collections.addImage_images;
        return u.call(this), t;
      },
      l = function () {
        return Object.keys(this.internal.collections.addImage_images).length;
      },
      f = function (e) {
        return "function" == typeof t["process" + e.toUpperCase()];
      },
      d = function (t) {
        return "object" === e(t) && 1 === t.nodeType;
      },
      p = function (e, r) {
        if ("IMG" === e.nodeName && e.hasAttribute("src")) {
          var n = "" + e.getAttribute("src");
          if (0 === n.indexOf("data:image/")) return c(unescape(n).split("base64,").pop());
          var i = t.loadFile(n, !0);
          if (void 0 !== i) return i;
        }
        if ("CANVAS" === e.nodeName) {
          if (0 === e.width || 0 === e.height) throw new Error("Given canvas must have data. Canvas width: " + e.width + ", height: " + e.height);
          var a;
          switch (r) {
            case "PNG":
              a = "image/png";
              break;
            case "WEBP":
              a = "image/webp";
              break;
            case "JPEG":
            case "JPG":
            default:
              a = "image/jpeg";
          }
          return c(e.toDataURL(a, 1).split("base64,").pop());
        }
      },
      g = function (t) {
        var e = this.internal.collections.addImage_images;
        if (e) for (var r in e) if (t === e[r].alias) return e[r];
      },
      m = function (t, e, r) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * r.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * r.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * r.width / r.height), 0 === e && (e = t * r.height / r.width), [t, e];
      },
      v = function (t, e, r, n, i, a) {
        var o = m.call(this, r, n, i),
          s = this.internal.getCoordinateString,
          c = this.internal.getVerticalCoordinateString,
          u = h.call(this);
        if (r = o[0], n = o[1], u[i.index] = i, a) {
          a *= Math.PI / 180;
          var l = Math.cos(a),
            f = Math.sin(a),
            d = function (t) {
              return t.toFixed(4);
            },
            p = [d(l), d(f), d(-1 * f), d(l), 0, 0, "cm"];
        }
        this.internal.write("q"), a ? (this.internal.write([1, "0", "0", 1, s(t), c(e + n), "cm"].join(" ")), this.internal.write(p.join(" ")), this.internal.write([s(r), "0", "0", s(n), "0", "0", "cm"].join(" "))) : this.internal.write([s(r), "0", "0", s(n), s(t), c(e + n), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
      },
      b = t.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
      };
    t.decode = {
      DCT_DECODE: "DCTDecode",
      FLATE_DECODE: "FlateDecode",
      LZW_DECODE: "LZWDecode",
      JPX_DECODE: "JPXDecode",
      JBIG2_DECODE: "JBIG2Decode",
      ASCII85_DECODE: "ASCII85Decode",
      ASCII_HEX_DECODE: "ASCIIHexDecode",
      RUN_LENGTH_DECODE: "RunLengthDecode",
      CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var y = t.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
      },
      w = t.__addimage__.sHashCode = function (t) {
        var e,
          r,
          n = 0;
        if ("string" == typeof t) for (r = t.length, e = 0; e < r; e++) n = (n << 5) - n + t.charCodeAt(e), n |= 0;else if (x(t)) for (r = t.byteLength / 2, e = 0; e < r; e++) n = (n << 5) - n + t[e], n |= 0;
        return n;
      },
      N = t.__addimage__.validateStringAsBase64 = function (t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
      },
      L = t.__addimage__.extractImageFromDataUrl = function (t) {
        var e = (t = t || "").split("base64,"),
          r = null;
        if (2 === e.length) {
          var n = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);
          Array.isArray(n) && (r = {
            mimeType: n[1],
            charset: n[2],
            data: e[1]
          });
        }
        return r;
      },
      A = t.__addimage__.supportsArrayBuffer = function () {
        return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
      };
    t.__addimage__.isArrayBuffer = function (t) {
      return A() && t instanceof ArrayBuffer;
    };
    var x = t.__addimage__.isArrayBufferView = function (t) {
        return A() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
      },
      S = t.__addimage__.binaryStringToUint8Array = function (t) {
        for (var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++) r[n] = t.charCodeAt(n);
        return r;
      },
      _ = t.__addimage__.arrayBufferToBinaryString = function (t) {
        for (var e = "", r = x(t) ? t : new Uint8Array(t), n = 0; n < r.length; n += 8192) e += String.fromCharCode.apply(null, r.subarray(n, n + 8192));
        return e;
      };
    t.addImage = function () {
      var t, n, i, a, o, s, c, h, l;
      if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], c = arguments[5], h = arguments[6], l = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], c = arguments[6], h = arguments[7], l = arguments[8]), "object" === e(t = arguments[0]) && !d(t) && "imageData" in t) {
        var f = t;
        t = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, c = f.alias || c, h = f.compression || h, l = f.rotation || f.angle || l;
      }
      var p = this.internal.getFilters();
      if (void 0 === h && -1 !== p.indexOf("FlateEncode") && (h = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
      u.call(this);
      var g = P.call(this, t, n, c, h);
      return v.call(this, i, a, o, s, g, l), this;
    };
    var P = function (e, n, a, o) {
        var s, c, u;
        if ("string" == typeof e && i(e) === r) {
          e = unescape(e);
          var h = k(e, !1);
          ("" !== h || void 0 !== (h = t.loadFile(e, !0))) && (e = h);
        }
        if (d(e) && (e = p(e, n)), n = i(e, n), !f(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (u = a) || 0 === u.length) && (a = function (t) {
          return "string" == typeof t || x(t) ? w(t) : x(t.data) ? w(t.data) : null;
        }(e)), (s = g.call(this, a)) || (A() && (e instanceof Uint8Array || "RGBA" === n || (c = e, e = S(e))), s = this["process" + n.toUpperCase()](e, l.call(this), a, function (e) {
          return e && "string" == typeof e && (e = e.toUpperCase()), e in t.image_compression ? e : y.NONE;
        }(o), c)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
      },
      k = t.__addimage__.convertBase64ToBinaryString = function (t, e) {
        var r;
        e = "boolean" != typeof e || e;
        var n,
          i = "";
        if ("string" == typeof t) {
          n = null !== (r = L(t)) ? r.data : t;
          try {
            i = c(n);
          } catch (t) {
            if (e) throw N(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + t.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
          }
        }
        return i;
      };
    t.getImageProperties = function (e) {
      var n,
        a,
        o = "";
      if (d(e) && (e = p(e)), "string" == typeof e && i(e) === r && ("" === (o = k(e, !1)) && (o = t.loadFile(e) || ""), e = o), a = i(e), !f(a)) throw new Error("addImage does not support files of type '" + a + "', please ensure that a plugin for '" + a + "' support is added.");
      if (!A() || e instanceof Uint8Array || (e = S(e)), !(n = this["process" + a.toUpperCase()](e))) throw new Error("An unknown error occurred whilst processing the image");
      return n.fileType = a, n;
    };
  }(M.API),
  /**
     * @license
     * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    var e = function (t) {
      if (void 0 !== t && "" != t) return !0;
    };
    M.API.events.push(["addPage", function (t) {
      this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
    }]), t.events.push(["putPage", function (t) {
      for (var r, n, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), c = t.pageContext.annotations, u = !1, h = 0; h < c.length && !u; h++) switch ((r = c[h]).type) {
        case "link":
          (e(r.options.url) || e(r.options.pageNumber)) && (u = !0);
          break;
        case "reference":
        case "text":
        case "freetext":
          u = !0;
      }
      if (0 != u) {
        this.internal.write("/Annots [");
        for (var l = 0; l < c.length; l++) {
          r = c[l];
          var f = this.internal.pdfEscape,
            d = this.internal.getEncryptor(t.objId);
          switch (r.type) {
            case "reference":
              this.internal.write(" " + r.object.objId + " 0 R ");
              break;
            case "text":
              var p = this.internal.newAdditionalObject(),
                g = this.internal.newAdditionalObject(),
                m = this.internal.getEncryptor(p.objId),
                v = r.title || "Note";
              i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y) + "] ") + "/Contents (" + f(m(r.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
              var b = p.objId + " 0 R";
              i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + a(r.bounds.x + 30) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w + 30) + " " + o(r.bounds.y) + "] ") + " /Parent " + b, r.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
              break;
            case "freetext":
              n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y + r.bounds.h) + "] ";
              var y = r.color || "#000000";
              i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + f(d(r.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
              break;
            case "link":
              if (r.options.name) {
                var w = this.annotations._nameMap[r.options.name];
                r.options.pageNumber = w.page, r.options.top = w.y;
              } else r.options.top || (r.options.top = 0);
              if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(r.options.url)) + ") >>";else if (r.options.pageNumber) {
                switch (i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor) {
                  case "Fit":
                    i += " /Fit]";
                    break;
                  case "FitH":
                    i += " /FitH " + r.options.top + "]";
                    break;
                  case "FitV":
                    r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                    break;
                  case "XYZ":
                  default:
                    var N = o(r.options.top);
                    r.options.left = r.options.left || 0, void 0 === r.options.zoom && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + N + " " + r.options.zoom + "]";
                }
              }
              "" != i && (i += " >>", this.internal.write(i));
          }
        }
        this.internal.write("]");
      }
    }]), t.createAnnotation = function (t) {
      var e = this.internal.getCurrentPageInfo();
      switch (t.type) {
        case "link":
          this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
          break;
        case "text":
        case "freetext":
          e.pageContext.annotations.push(t);
      }
    }, t.link = function (t, e, r, n, i) {
      var a = this.internal.getCurrentPageInfo(),
        o = this.internal.getCoordinateString,
        s = this.internal.getVerticalCoordinateString;
      a.pageContext.annotations.push({
        finalBounds: {
          x: o(t),
          y: s(e),
          w: o(t + r),
          h: s(e + n)
        },
        options: i,
        type: "link"
      });
    }, t.textWithLink = function (t, e, r, n) {
      var i = this.getTextWidth(t),
        a = this.internal.getLineHeight() / this.internal.scaleFactor;
      return this.text(t, e, r, n), r += .2 * a, "center" === n.align && (e -= i / 2), "right" === n.align && (e -= i), this.link(e, r - a, i, a, n), i;
    }, t.getTextWidth = function (t) {
      var e = this.internal.getFontSize();
      return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
  }(M.API),
  /**
     * @license
     * Copyright (c) 2017 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    var e = {
        1569: [65152],
        1570: [65153, 65154],
        1571: [65155, 65156],
        1572: [65157, 65158],
        1573: [65159, 65160],
        1574: [65161, 65162, 65163, 65164],
        1575: [65165, 65166],
        1576: [65167, 65168, 65169, 65170],
        1577: [65171, 65172],
        1578: [65173, 65174, 65175, 65176],
        1579: [65177, 65178, 65179, 65180],
        1580: [65181, 65182, 65183, 65184],
        1581: [65185, 65186, 65187, 65188],
        1582: [65189, 65190, 65191, 65192],
        1583: [65193, 65194],
        1584: [65195, 65196],
        1585: [65197, 65198],
        1586: [65199, 65200],
        1587: [65201, 65202, 65203, 65204],
        1588: [65205, 65206, 65207, 65208],
        1589: [65209, 65210, 65211, 65212],
        1590: [65213, 65214, 65215, 65216],
        1591: [65217, 65218, 65219, 65220],
        1592: [65221, 65222, 65223, 65224],
        1593: [65225, 65226, 65227, 65228],
        1594: [65229, 65230, 65231, 65232],
        1601: [65233, 65234, 65235, 65236],
        1602: [65237, 65238, 65239, 65240],
        1603: [65241, 65242, 65243, 65244],
        1604: [65245, 65246, 65247, 65248],
        1605: [65249, 65250, 65251, 65252],
        1606: [65253, 65254, 65255, 65256],
        1607: [65257, 65258, 65259, 65260],
        1608: [65261, 65262],
        1609: [65263, 65264, 64488, 64489],
        1610: [65265, 65266, 65267, 65268],
        1649: [64336, 64337],
        1655: [64477],
        1657: [64358, 64359, 64360, 64361],
        1658: [64350, 64351, 64352, 64353],
        1659: [64338, 64339, 64340, 64341],
        1662: [64342, 64343, 64344, 64345],
        1663: [64354, 64355, 64356, 64357],
        1664: [64346, 64347, 64348, 64349],
        1667: [64374, 64375, 64376, 64377],
        1668: [64370, 64371, 64372, 64373],
        1670: [64378, 64379, 64380, 64381],
        1671: [64382, 64383, 64384, 64385],
        1672: [64392, 64393],
        1676: [64388, 64389],
        1677: [64386, 64387],
        1678: [64390, 64391],
        1681: [64396, 64397],
        1688: [64394, 64395],
        1700: [64362, 64363, 64364, 64365],
        1702: [64366, 64367, 64368, 64369],
        1705: [64398, 64399, 64400, 64401],
        1709: [64467, 64468, 64469, 64470],
        1711: [64402, 64403, 64404, 64405],
        1713: [64410, 64411, 64412, 64413],
        1715: [64406, 64407, 64408, 64409],
        1722: [64414, 64415],
        1723: [64416, 64417, 64418, 64419],
        1726: [64426, 64427, 64428, 64429],
        1728: [64420, 64421],
        1729: [64422, 64423, 64424, 64425],
        1733: [64480, 64481],
        1734: [64473, 64474],
        1735: [64471, 64472],
        1736: [64475, 64476],
        1737: [64482, 64483],
        1739: [64478, 64479],
        1740: [64508, 64509, 64510, 64511],
        1744: [64484, 64485, 64486, 64487],
        1746: [64430, 64431],
        1747: [64432, 64433]
      },
      r = {
        65247: {
          65154: 65269,
          65156: 65271,
          65160: 65273,
          65166: 65275
        },
        65248: {
          65154: 65270,
          65156: 65272,
          65160: 65274,
          65166: 65276
        },
        65165: {
          65247: {
            65248: {
              65258: 65010
            }
          }
        },
        1617: {
          1612: 64606,
          1613: 64607,
          1614: 64608,
          1615: 64609,
          1616: 64610
        }
      },
      n = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
      },
      i = [1570, 1571, 1573, 1575];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function (t) {
        return void 0 !== e[t.charCodeAt(0)];
      },
      o = t.__arabicParser__.isArabicLetter = function (t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
      },
      s = t.__arabicParser__.isArabicEndLetter = function (t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
      },
      c = t.__arabicParser__.isArabicAlfLetter = function (t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
      };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function (t) {
      return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var u = t.__arabicParser__.arabicLetterHasFinalForm = function (t) {
      return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function (t) {
      return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var h = t.__arabicParser__.arabicLetterHasMedialForm = function (t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
      },
      l = t.__arabicParser__.resolveLigatures = function (t) {
        var e = 0,
          n = r,
          i = "",
          a = 0;
        for (e = 0; e < t.length; e += 1) void 0 !== n[t.charCodeAt(e)] ? (a++, "number" == typeof (n = n[t.charCodeAt(e)]) && (i += String.fromCharCode(n), n = r, a = 0), e === t.length - 1 && (n = r, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (n = r, i += t.charAt(e - a), e -= a, a = 0);
        return i;
      };
    t.__arabicParser__.isArabicDiacritic = function (t) {
      return void 0 !== t && void 0 !== n[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function (t, e, r) {
        return o(t) ? !1 === a(t) ? -1 : !u(t) || !o(e) && !o(r) || !o(r) && s(e) || s(t) && !o(e) || s(t) && c(e) || s(t) && s(e) ? 0 : h(t) && o(e) && !s(e) && o(r) && u(r) ? 3 : s(t) || !o(r) ? 1 : 2 : -1;
      },
      d = function (t) {
        var r = 0,
          n = 0,
          i = 0,
          a = "",
          s = "",
          c = "",
          u = (t = t || "").split("\\s+"),
          h = [];
        for (r = 0; r < u.length; r += 1) {
          for (h.push(""), n = 0; n < u[r].length; n += 1) a = u[r][n], s = u[r][n - 1], c = u[r][n + 1], o(a) ? (i = f(a, s, c), h[r] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : h[r] += a;
          h[r] = l(h[r]);
        }
        return h.join(" ");
      },
      p = t.__arabicParser__.processArabic = t.processArabic = function () {
        var t,
          e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text,
          r = [];
        if (Array.isArray(e)) {
          var n = 0;
          for (r = [], n = 0; n < e.length; n += 1) Array.isArray(e[n]) ? r.push([d(e[n][0]), e[n][1], e[n][2]]) : r.push([d(e[n])]);
          t = r;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
      };
    t.events.push(["preProcessText", p]);
  }(M.API),
  /** @license
     * jsPDF Autoprint Plugin
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    t.autoPrint = function (t) {
      var e;
      switch ((t = t || {}).variant = t.variant || "non-conform", t.variant) {
        case "javascript":
          this.addJS("print({});");
          break;
        case "non-conform":
        default:
          this.internal.events.subscribe("postPutResources", function () {
            e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
          }), this.internal.events.subscribe("putCatalog", function () {
            this.internal.out("/OpenAction " + e + " 0 R");
          });
      }
      return this;
    };
  }(M.API),
  /**
     * @license
     * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    var e = function () {
      var t = void 0;
      Object.defineProperty(this, "pdf", {
        get: function () {
          return t;
        },
        set: function (e) {
          t = e;
        }
      });
      var e = 150;
      Object.defineProperty(this, "width", {
        get: function () {
          return e;
        },
        set: function (t) {
          e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
        }
      });
      var r = 300;
      Object.defineProperty(this, "height", {
        get: function () {
          return r;
        },
        set: function (t) {
          r = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r + 1);
        }
      });
      var n = [];
      Object.defineProperty(this, "childNodes", {
        get: function () {
          return n;
        },
        set: function (t) {
          n = t;
        }
      });
      var i = {};
      Object.defineProperty(this, "style", {
        get: function () {
          return i;
        },
        set: function (t) {
          i = t;
        }
      }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function (t, e) {
      var r;
      if ("2d" !== (t = t || "2d")) return null;
      for (r in e) this.pdf.context2d.hasOwnProperty(r) && (this.pdf.context2d[r] = e[r]);
      return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function () {
      throw new Error("toDataURL is not implemented.");
    }, t.events.push(["initialized", function () {
      this.canvas = new e(), this.canvas.pdf = this;
    }]);
  }(M.API), function (t) {
    var r = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      },
      n = !1,
      i = function () {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, r), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
      },
      a = function () {
        this.internal.__cell__.lastCell = new o(), this.internal.__cell__.pages = 1;
      },
      o = function () {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
          enumerable: !0,
          get: function () {
            return t;
          },
          set: function (e) {
            t = e;
          }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
          enumerable: !0,
          get: function () {
            return e;
          },
          set: function (t) {
            e = t;
          }
        });
        var r = arguments[2];
        Object.defineProperty(this, "width", {
          enumerable: !0,
          get: function () {
            return r;
          },
          set: function (t) {
            r = t;
          }
        });
        var n = arguments[3];
        Object.defineProperty(this, "height", {
          enumerable: !0,
          get: function () {
            return n;
          },
          set: function (t) {
            n = t;
          }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
          enumerable: !0,
          get: function () {
            return i;
          },
          set: function (t) {
            i = t;
          }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
          enumerable: !0,
          get: function () {
            return a;
          },
          set: function (t) {
            a = t;
          }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
          enumerable: !0,
          get: function () {
            return o;
          },
          set: function (t) {
            o = t;
          }
        }), this;
      };
    o.prototype.clone = function () {
      return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function () {
      return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
    }, t.setHeaderFunction = function (t) {
      return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, t.getTextDimensions = function (t, e) {
      i.call(this);
      var r = (e = e || {}).fontSize || this.getFontSize(),
        n = e.font || this.getFont(),
        a = e.scaleFactor || this.internal.scaleFactor,
        o = 0,
        s = 0,
        c = 0,
        u = this;
      if (!Array.isArray(t) && "string" != typeof t) {
        if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
        t = String(t);
      }
      var h = e.maxWidth;
      h > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, h) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function (t, e) {
        return t.concat(u.splitTextToSize(e, h));
      }, [])) : t = Array.isArray(t) ? t : [t];
      for (var l = 0; l < t.length; l++) o < (c = this.getStringUnitWidth(t[l], {
        font: n
      }) * r) && (o = c);
      return 0 !== o && (s = t.length), {
        w: o /= a,
        h: Math.max((s * r * this.getLineHeightFactor() - r * (this.getLineHeightFactor() - 1)) / a, 0)
      };
    }, t.cellAddPage = function () {
      i.call(this), this.addPage();
      var t = this.internal.__cell__.margins || r;
      return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = t.cell = function () {
      var t;
      t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i.call(this);
      var e = this.internal.__cell__.lastCell,
        a = this.internal.__cell__.padding,
        s = this.internal.__cell__.margins || r,
        c = this.internal.__cell__.tableHeaderRow,
        u = this.internal.__cell__.printHeaders;
      return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, u && c && (this.printHeaderRow(t.lineNumber, !0), t.y += c[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === n ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
        align: "right",
        baseline: "top"
      }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
        align: "center",
        baseline: "top",
        maxWidth: t.width - a - a
      }) : this.text(t.text, t.x + a, t.y + a, {
        align: "left",
        baseline: "top",
        maxWidth: t.width - a - a
      })), this.internal.__cell__.lastCell = t, this;
    };
    t.table = function (t, n, u, h, l) {
      if (i.call(this), !u) throw new Error("No data for PDF table.");
      var f,
        d,
        p,
        g,
        m = [],
        v = [],
        b = [],
        y = {},
        w = {},
        N = [],
        L = [],
        A = (l = l || {}).autoSize || !1,
        x = !1 !== l.printHeaders,
        S = l.css && void 0 !== l.css["font-size"] ? 16 * l.css["font-size"] : l.fontSize || 12,
        _ = l.margins || Object.assign({
          width: this.getPageWidth()
        }, r),
        P = "number" == typeof l.padding ? l.padding : 3,
        k = l.headerBackgroundColor || "#c8c8c8",
        F = l.headerTextColor || "#000";
      if (a.call(this), this.internal.__cell__.printHeaders = x, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = F, this.setFontSize(S), null == h) v = m = Object.keys(u[0]), b = m.map(function () {
        return "left";
      });else if (Array.isArray(h) && "object" === e(h[0])) for (m = h.map(function (t) {
        return t.name;
      }), v = h.map(function (t) {
        return t.prompt || t.name || "";
      }), b = h.map(function (t) {
        return t.align || "left";
      }), f = 0; f < h.length; f += 1) w[h[f].name] = h[f].width * (19.049976 / 25.4);else Array.isArray(h) && "string" == typeof h[0] && (v = m = h, b = m.map(function () {
        return "left";
      }));
      if (A || Array.isArray(h) && "string" == typeof h[0]) for (f = 0; f < m.length; f += 1) {
        for (y[g = m[f]] = u.map(function (t) {
          return t[g];
        }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
          fontSize: this.internal.__cell__.table_font_size,
          scaleFactor: this.internal.scaleFactor
        }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1) N.push(this.getTextDimensions(d[p], {
          fontSize: this.internal.__cell__.table_font_size,
          scaleFactor: this.internal.scaleFactor
        }).w);
        w[g] = Math.max.apply(null, N) + P + P, N = [];
      }
      if (x) {
        var I = {};
        for (f = 0; f < m.length; f += 1) I[m[f]] = {}, I[m[f]].text = v[f], I[m[f]].align = b[f];
        var C = c.call(this, I, w);
        L = m.map(function (e) {
          return new o(t, n, w[e], C, I[e].text, void 0, I[e].align);
        }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
      }
      var j = h.reduce(function (t, e) {
        return t[e.name] = e.align, t;
      }, {});
      for (f = 0; f < u.length; f += 1) {
        "rowStart" in l && l.rowStart instanceof Function && l.rowStart({
          row: f,
          data: u[f]
        }, this);
        var O = c.call(this, u[f], w);
        for (p = 0; p < m.length; p += 1) {
          var B = u[f][m[p]];
          "cellStart" in l && l.cellStart instanceof Function && l.cellStart({
            row: f,
            col: p,
            data: B
          }, this), s.call(this, new o(t, n, w[m[p]], O, B, f + 2, j[m[p]]));
        }
      }
      return this.internal.__cell__.table_x = t, this.internal.__cell__.table_y = n, this;
    };
    var c = function (t, e) {
      var r = this.internal.__cell__.padding,
        n = this.internal.__cell__.table_font_size,
        i = this.internal.scaleFactor;
      return Object.keys(t).map(function (n) {
        var i = t[n];
        return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[n] - r - r);
      }, this).map(function (t) {
        return this.getLineHeightFactor() * t.length * n / i + r + r;
      }, this).reduce(function (t, e) {
        return Math.max(t, e);
      }, 0);
    };
    t.setTableHeaderRow = function (t) {
      i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, t.printHeaderRow = function (t, e) {
      if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
      var r;
      if (n = !0, "function" == typeof this.internal.__cell__.headerFunction) {
        var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
        this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
      }
      this.setFont(void 0, "bold");
      for (var c = [], u = 0; u < this.internal.__cell__.tableHeaderRow.length; u += 1) {
        r = this.internal.__cell__.tableHeaderRow[u].clone(), e && (r.y = this.internal.__cell__.margins.top || 0, c.push(r)), r.lineNumber = t;
        var h = this.getTextColor();
        this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, r), this.setTextColor(h);
      }
      c.length > 0 && this.setTableHeaderRow(c), this.setFont(void 0, "normal"), n = !1;
    };
  }(M.API);
  var _t = {
      italic: ["italic", "oblique", "normal"],
      oblique: ["oblique", "italic", "normal"],
      normal: ["normal", "oblique", "italic"]
    },
    Pt = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"],
    kt = St(Pt),
    Ft = [100, 200, 300, 400, 500, 600, 700, 800, 900],
    It = St(Ft);
  function Ct(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(),
      r = function (t) {
        return _t[t = t || "normal"] ? t : "normal";
      }(t.style),
      n = function (t) {
        if (!t) return 400;
        if ("number" == typeof t) return t >= 100 && t <= 900 && t % 100 == 0 ? t : 400;
        if (/^\d00$/.test(t)) return parseInt(t);
        switch (t) {
          case "bold":
            return 700;
          case "normal":
          default:
            return 400;
        }
      }(t.weight),
      i = function (t) {
        return "number" == typeof kt[t = t || "normal"] ? t : "normal";
      }(t.stretch);
    return {
      family: e,
      style: r,
      weight: n,
      stretch: i,
      src: t.src || [],
      ref: t.ref || {
        name: e,
        style: [i, r, n].join(" ")
      }
    };
  }
  function jt(t, e, r, n) {
    var i;
    for (i = r; i >= 0 && i < e.length; i += n) if (t[e[i]]) return t[e[i]];
    for (i = r; i >= 0 && i < e.length; i -= n) if (t[e[i]]) return t[e[i]];
  }
  var Ot = {
      "sans-serif": "helvetica",
      fixed: "courier",
      monospace: "courier",
      terminal: "courier",
      cursive: "times",
      fantasy: "times",
      serif: "times"
    },
    Bt = {
      caption: "times",
      icon: "times",
      menu: "times",
      "message-box": "times",
      "small-caption": "times",
      "status-bar": "times"
    };
  function Mt(t) {
    return [t.stretch, t.style, t.weight, t.family].join(" ");
  }
  function Et(t, e, r) {
    for (var n = (r = r || {}).defaultFontFamily || "times", i = Object.assign({}, Ot, r.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s) if (i[(a = Ct(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
      o = t[a.family];
      break;
    }
    if (!(o = o || t[n])) throw new Error("Could not find a font-family for the rule '" + Mt(a) + "' and default family '" + n + "'.");
    if (o = function (t, e) {
      if (e[t]) return e[t];
      var r = kt[t],
        n = r <= kt.normal ? -1 : 1,
        i = jt(e, Pt, r, n);
      if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
      return i;
    }(a.stretch, o), o = function (t, e) {
      if (e[t]) return e[t];
      for (var r = _t[t], n = 0; n < r.length; ++n) if (e[r[n]]) return e[r[n]];
      throw new Error("Could not find a matching font-style for " + t);
    }(a.style, o), !(o = function (t, e) {
      if (e[t]) return e[t];
      if (400 === t && e[500]) return e[500];
      if (500 === t && e[400]) return e[400];
      var r = It[t],
        n = jt(e, Ft, r, t < 400 ? -1 : 1);
      if (!n) throw new Error("Could not find a matching font-weight for value " + t);
      return n;
    }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + Mt(a) + "'.");
    return o;
  }
  function qt(t) {
    return t.trimLeft();
  }
  function Dt(t, e) {
    for (var r = 0; r < t.length;) {
      if (t.charAt(r) === e) return [t.substring(0, r), t.substring(r + 1)];
      r += 1;
    }
    return null;
  }
  function Rt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [e[0], t.substring(e[0].length)];
  }
  var Tt = ["times"];
  !function (t) {
    var r,
      n,
      a,
      o,
      s,
      c,
      u,
      h,
      f,
      d = function (t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new h(), this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new c(), this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new c(), this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
      };
    t.events.push(["initialized", function () {
      this.context2d = new p(this), r = this.internal.f2, n = this.internal.getCoordinateString, a = this.internal.getVerticalCoordinateString, o = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, c = this.internal.Point, u = this.internal.Rectangle, h = this.internal.Matrix, f = new d();
    }]);
    var p = function (t) {
      Object.defineProperty(this, "canvas", {
        get: function () {
          return {
            parentNode: !1,
            style: !1
          };
        }
      });
      var e = t;
      Object.defineProperty(this, "pdf", {
        get: function () {
          return e;
        }
      });
      var r = !1;
      Object.defineProperty(this, "pageWrapXEnabled", {
        get: function () {
          return r;
        },
        set: function (t) {
          r = Boolean(t);
        }
      });
      var n = !1;
      Object.defineProperty(this, "pageWrapYEnabled", {
        get: function () {
          return n;
        },
        set: function (t) {
          n = Boolean(t);
        }
      });
      var i = 0;
      Object.defineProperty(this, "posX", {
        get: function () {
          return i;
        },
        set: function (t) {
          isNaN(t) || (i = t);
        }
      });
      var a = 0;
      Object.defineProperty(this, "posY", {
        get: function () {
          return a;
        },
        set: function (t) {
          isNaN(t) || (a = t);
        }
      }), Object.defineProperty(this, "margin", {
        get: function () {
          return f.margin;
        },
        set: function (t) {
          var e;
          "number" == typeof t ? e = [t, t, t, t] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), f.margin = e;
        }
      });
      var o = !1;
      Object.defineProperty(this, "autoPaging", {
        get: function () {
          return o;
        },
        set: function (t) {
          o = t;
        }
      });
      var s = 0;
      Object.defineProperty(this, "lastBreak", {
        get: function () {
          return s;
        },
        set: function (t) {
          s = t;
        }
      });
      var c = [];
      Object.defineProperty(this, "pageBreaks", {
        get: function () {
          return c;
        },
        set: function (t) {
          c = t;
        }
      }), Object.defineProperty(this, "ctx", {
        get: function () {
          return f;
        },
        set: function (t) {
          t instanceof d && (f = t);
        }
      }), Object.defineProperty(this, "path", {
        get: function () {
          return f.path;
        },
        set: function (t) {
          f.path = t;
        }
      });
      var u = [];
      Object.defineProperty(this, "ctxStack", {
        get: function () {
          return u;
        },
        set: function (t) {
          u = t;
        }
      }), Object.defineProperty(this, "fillStyle", {
        get: function () {
          return this.ctx.fillStyle;
        },
        set: function (t) {
          var e;
          e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
            a: e.a
          }), this.pdf.setTextColor(e.r, e.g, e.b, {
            a: e.a
          });
        }
      }), Object.defineProperty(this, "strokeStyle", {
        get: function () {
          return this.ctx.strokeStyle;
        },
        set: function (t) {
          var e = g(t);
          this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
        }
      }), Object.defineProperty(this, "lineCap", {
        get: function () {
          return this.ctx.lineCap;
        },
        set: function (t) {
          -1 !== ["butt", "round", "square"].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
        }
      }), Object.defineProperty(this, "lineWidth", {
        get: function () {
          return this.ctx.lineWidth;
        },
        set: function (t) {
          isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
        }
      }), Object.defineProperty(this, "lineJoin", {
        get: function () {
          return this.ctx.lineJoin;
        },
        set: function (t) {
          -1 !== ["bevel", "round", "miter"].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
        }
      }), Object.defineProperty(this, "miterLimit", {
        get: function () {
          return this.ctx.miterLimit;
        },
        set: function (t) {
          isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
        }
      }), Object.defineProperty(this, "textBaseline", {
        get: function () {
          return this.ctx.textBaseline;
        },
        set: function (t) {
          this.ctx.textBaseline = t;
        }
      }), Object.defineProperty(this, "textAlign", {
        get: function () {
          return this.ctx.textAlign;
        },
        set: function (t) {
          -1 !== ["right", "end", "center", "left", "start"].indexOf(t) && (this.ctx.textAlign = t);
        }
      });
      var h = null;
      function l(t, e) {
        if (null === h) {
          var r = function (t) {
            var e = [];
            return Object.keys(t).forEach(function (r) {
              t[r].forEach(function (t) {
                var n = null;
                switch (t) {
                  case "bold":
                    n = {
                      family: r,
                      weight: "bold"
                    };
                    break;
                  case "italic":
                    n = {
                      family: r,
                      style: "italic"
                    };
                    break;
                  case "bolditalic":
                    n = {
                      family: r,
                      weight: "bold",
                      style: "italic"
                    };
                    break;
                  case "":
                  case "normal":
                    n = {
                      family: r
                    };
                }
                null !== n && (n.ref = {
                  name: r,
                  style: t
                }, e.push(n));
              });
            }), e;
          }(t.getFontList());
          h = function (t) {
            for (var e = {}, r = 0; r < t.length; ++r) {
              var n = Ct(t[r]),
                i = n.family,
                a = n.stretch,
                o = n.style,
                s = n.weight;
              e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = n;
            }
            return e;
          }(r.concat(e));
        }
        return h;
      }
      var p = null;
      Object.defineProperty(this, "fontFaces", {
        get: function () {
          return p;
        },
        set: function (t) {
          h = null, p = t;
        }
      }), Object.defineProperty(this, "font", {
        get: function () {
          return this.ctx.font;
        },
        set: function (t) {
          var e;
          if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
            var r = e[1],
              n = (e[2], e[3]),
              i = e[4],
              a = (e[5], e[6]),
              o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
            i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
            var s = function (t) {
              var e,
                r,
                n = [],
                i = t.trim();
              if ("" === i) return Tt;
              if (i in Bt) return [Bt[i]];
              for (; "" !== i;) {
                switch (r = null, e = (i = qt(i)).charAt(0)) {
                  case '"':
                  case "'":
                    r = Dt(i.substring(1), e);
                    break;
                  default:
                    r = Rt(i);
                }
                if (null === r) return Tt;
                if (n.push(r[0]), "" !== (i = qt(r[1])) && "," !== i.charAt(0)) return Tt;
                i = i.replace(/^,/, "");
              }
              return n;
            }(a);
            if (this.fontFaces) {
              var c = Et(l(this.pdf, this.fontFaces), s.map(function (t) {
                return {
                  family: t,
                  stretch: "normal",
                  weight: n,
                  style: r
                };
              }));
              this.pdf.setFont(c.ref.name, c.ref.style);
            } else {
              var u = "";
              ("bold" === n || parseInt(n, 10) >= 700 || "bold" === r) && (u = "bold"), "italic" === r && (u += "italic"), 0 === u.length && (u = "normal");
              for (var h = "", f = {
                  arial: "Helvetica",
                  Arial: "Helvetica",
                  verdana: "Helvetica",
                  Verdana: "Helvetica",
                  helvetica: "Helvetica",
                  Helvetica: "Helvetica",
                  "sans-serif": "Helvetica",
                  fixed: "Courier",
                  monospace: "Courier",
                  terminal: "Courier",
                  cursive: "Times",
                  fantasy: "Times",
                  serif: "Times"
                }, d = 0; d < s.length; d++) {
                if (void 0 !== this.pdf.internal.getFont(s[d], u, {
                  noFallback: !0,
                  disableWarning: !0
                })) {
                  h = s[d];
                  break;
                }
                if ("bolditalic" === u && void 0 !== this.pdf.internal.getFont(s[d], "bold", {
                  noFallback: !0,
                  disableWarning: !0
                })) h = s[d], u = "bold";else if (void 0 !== this.pdf.internal.getFont(s[d], "normal", {
                  noFallback: !0,
                  disableWarning: !0
                })) {
                  h = s[d], u = "normal";
                  break;
                }
              }
              if ("" === h) for (var p = 0; p < s.length; p++) if (f[s[p]]) {
                h = f[s[p]];
                break;
              }
              h = "" === h ? "Times" : h, this.pdf.setFont(h, u);
            }
          }
        }
      }), Object.defineProperty(this, "globalCompositeOperation", {
        get: function () {
          return this.ctx.globalCompositeOperation;
        },
        set: function (t) {
          this.ctx.globalCompositeOperation = t;
        }
      }), Object.defineProperty(this, "globalAlpha", {
        get: function () {
          return this.ctx.globalAlpha;
        },
        set: function (t) {
          this.ctx.globalAlpha = t;
        }
      }), Object.defineProperty(this, "lineDashOffset", {
        get: function () {
          return this.ctx.lineDashOffset;
        },
        set: function (t) {
          this.ctx.lineDashOffset = t, T.call(this);
        }
      }), Object.defineProperty(this, "lineDash", {
        get: function () {
          return this.ctx.lineDash;
        },
        set: function (t) {
          this.ctx.lineDash = t, T.call(this);
        }
      }), Object.defineProperty(this, "ignoreClearRect", {
        get: function () {
          return this.ctx.ignoreClearRect;
        },
        set: function (t) {
          this.ctx.ignoreClearRect = Boolean(t);
        }
      });
    };
    p.prototype.setLineDash = function (t) {
      this.lineDash = t;
    }, p.prototype.getLineDash = function () {
      return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function () {
      A.call(this, "fill", !1);
    }, p.prototype.stroke = function () {
      A.call(this, "stroke", !1);
    }, p.prototype.beginPath = function () {
      this.path = [{
        type: "begin"
      }];
    }, p.prototype.moveTo = function (t, e) {
      if (isNaN(t) || isNaN(e)) throw i.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
      var r = this.ctx.transform.applyToPoint(new c(t, e));
      this.path.push({
        type: "mt",
        x: r.x,
        y: r.y
      }), this.ctx.lastPoint = new c(t, e);
    }, p.prototype.closePath = function () {
      var t = new c(0, 0),
        r = 0;
      for (r = this.path.length - 1; -1 !== r; r--) if ("begin" === this.path[r].type && "object" === e(this.path[r + 1]) && "number" == typeof this.path[r + 1].x) {
        t = new c(this.path[r + 1].x, this.path[r + 1].y), this.path.push({
          type: "lt",
          x: t.x,
          y: t.y
        });
        break;
      }
      "object" === e(this.path[r + 2]) && "number" == typeof this.path[r + 2].x && this.path.push(JSON.parse(JSON.stringify(this.path[r + 2]))), this.path.push({
        type: "close"
      }), this.ctx.lastPoint = new c(t.x, t.y);
    }, p.prototype.lineTo = function (t, e) {
      if (isNaN(t) || isNaN(e)) throw i.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
      var r = this.ctx.transform.applyToPoint(new c(t, e));
      this.path.push({
        type: "lt",
        x: r.x,
        y: r.y
      }), this.ctx.lastPoint = new c(r.x, r.y);
    }, p.prototype.clip = function () {
      this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), A.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function (t, e, r, n) {
      if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e)) throw i.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
      var a = this.ctx.transform.applyToPoint(new c(r, n)),
        o = this.ctx.transform.applyToPoint(new c(t, e));
      this.path.push({
        type: "qct",
        x1: o.x,
        y1: o.y,
        x: a.x,
        y: a.y
      }), this.ctx.lastPoint = new c(a.x, a.y);
    }, p.prototype.bezierCurveTo = function (t, e, r, n, a, o) {
      if (isNaN(a) || isNaN(o) || isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw i.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
      var s = this.ctx.transform.applyToPoint(new c(a, o)),
        u = this.ctx.transform.applyToPoint(new c(t, e)),
        h = this.ctx.transform.applyToPoint(new c(r, n));
      this.path.push({
        type: "bct",
        x1: u.x,
        y1: u.y,
        x2: h.x,
        y2: h.y,
        x: s.x,
        y: s.y
      }), this.ctx.lastPoint = new c(s.x, s.y);
    }, p.prototype.arc = function (t, e, r, n, a, o) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(a)) throw i.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
      if (o = Boolean(o), !this.ctx.transform.isIdentity) {
        var s = this.ctx.transform.applyToPoint(new c(t, e));
        t = s.x, e = s.y;
        var u = this.ctx.transform.applyToPoint(new c(0, r)),
          h = this.ctx.transform.applyToPoint(new c(0, 0));
        r = Math.sqrt(Math.pow(u.x - h.x, 2) + Math.pow(u.y - h.y, 2));
      }
      Math.abs(a - n) >= 2 * Math.PI && (n = 0, a = 2 * Math.PI), this.path.push({
        type: "arc",
        x: t,
        y: e,
        radius: r,
        startAngle: n,
        endAngle: a,
        counterclockwise: o
      });
    }, p.prototype.arcTo = function (t, e, r, n, i) {
      throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function (t, e, r, n) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw i.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
      this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + n), this.lineTo(t, e + n), this.lineTo(t, e), this.lineTo(t + r, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function (t, e, r, n) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw i.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
      if (!m.call(this)) {
        var a = {};
        "butt" !== this.lineCap && (a.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (a.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, r, n), this.fill(), a.hasOwnProperty("lineCap") && (this.lineCap = a.lineCap), a.hasOwnProperty("lineJoin") && (this.lineJoin = a.lineJoin);
      }
    }, p.prototype.strokeRect = function (t, e, r, n) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw i.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
      v.call(this) || (this.beginPath(), this.rect(t, e, r, n), this.stroke());
    }, p.prototype.clearRect = function (t, e, r, n) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw i.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
      this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, r, n));
    }, p.prototype.save = function (t) {
      t = "boolean" != typeof t || t;
      for (var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++) this.pdf.setPage(r + 1), this.pdf.internal.out("q");
      if (this.pdf.setPage(e), t) {
        this.ctx.fontSize = this.pdf.internal.getFontSize();
        var n = new d(this.ctx);
        this.ctxStack.push(this.ctx), this.ctx = n;
      }
    }, p.prototype.restore = function (t) {
      t = "boolean" != typeof t || t;
      for (var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++) this.pdf.setPage(r + 1), this.pdf.internal.out("Q");
      this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function () {
      throw new Error("toDataUrl not implemented.");
    };
    var g = function (t) {
        var e, r, n, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
          style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, r = 0, n = 0, i = 0;else {
          var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
          if (null !== a) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = 1;else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = parseFloat(a[4]);else {
            if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
              var o = new l(t);
              t = o.ok ? o.toHex() : "#000000";
            }
            4 === t.length ? (e = t.substring(1, 2), e += e, r = t.substring(2, 3), r += r, n = t.substring(3, 4), n += n) : (e = t.substring(1, 3), r = t.substring(3, 5), n = t.substring(5, 7)), e = parseInt(e, 16), r = parseInt(r, 16), n = parseInt(n, 16);
          }
        }
        return {
          r: e,
          g: r,
          b: n,
          a: i,
          style: t
        };
      },
      m = function () {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
      },
      v = function () {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
      };
    p.prototype.fillText = function (t, e, r, n) {
      if (isNaN(e) || isNaN(r) || "string" != typeof t) throw i.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
      if (n = isNaN(n) ? void 0 : n, !m.call(this)) {
        var a = q(this.ctx.transform.rotation),
          o = this.ctx.transform.scaleX;
        C.call(this, {
          text: t,
          x: e,
          y: r,
          scale: o,
          angle: a,
          align: this.textAlign,
          maxWidth: n
        });
      }
    }, p.prototype.strokeText = function (t, e, r, n) {
      if (isNaN(e) || isNaN(r) || "string" != typeof t) throw i.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
      if (!v.call(this)) {
        n = isNaN(n) ? void 0 : n;
        var a = q(this.ctx.transform.rotation),
          o = this.ctx.transform.scaleX;
        C.call(this, {
          text: t,
          x: e,
          y: r,
          scale: o,
          renderingMode: "stroke",
          angle: a,
          align: this.textAlign,
          maxWidth: n
        });
      }
    }, p.prototype.measureText = function (t) {
      if ("string" != typeof t) throw i.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
      var e = this.pdf,
        r = this.pdf.internal.scaleFactor,
        n = e.internal.getFontSize(),
        a = e.getStringUnitWidth(t) * n / e.internal.scaleFactor,
        o = function (t) {
          var e = (t = t || {}).width || 0;
          return Object.defineProperty(this, "width", {
            get: function () {
              return e;
            }
          }), this;
        };
      return new o({
        width: a *= Math.round(96 * r / 72 * 1e4) / 1e4
      });
    }, p.prototype.scale = function (t, e) {
      if (isNaN(t) || isNaN(e)) throw i.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
      var r = new h(t, 0, 0, e, 0, 0);
      this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.rotate = function (t) {
      if (isNaN(t)) throw i.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
      var e = new h(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
      this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function (t, e) {
      if (isNaN(t) || isNaN(e)) throw i.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
      var r = new h(1, 0, 0, 1, t, e);
      this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.transform = function (t, e, r, n, a, o) {
      if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(a) || isNaN(o)) throw i.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
      var s = new h(t, e, r, n, a, o);
      this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function (t, e, r, n, i, a) {
      t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, r = isNaN(r) ? 0 : r, n = isNaN(n) ? 1 : n, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new h(t, e, r, n, i, a);
    };
    var b = function () {
      return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function (t, e, r, n, i, a, o, s, c) {
      var l = this.pdf.getImageProperties(t),
        f = 1,
        d = 1,
        p = 1,
        g = 1;
      void 0 !== n && void 0 !== s && (p = s / n, g = c / i, f = l.width / n * s / n, d = l.height / i * c / i), void 0 === a && (a = e, o = r, e = 0, r = 0), void 0 !== n && void 0 === s && (s = n, c = i), void 0 === n && void 0 === s && (s = l.width, c = l.height);
      for (var m, v = this.ctx.transform.decompose(), w = q(v.rotate.shx), A = new h(), S = (A = (A = (A = A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a - e * p, o - r * g, n * f, i * d)), _ = y.call(this, S), P = [], k = 0; k < _.length; k += 1) -1 === P.indexOf(_[k]) && P.push(_[k]);
      if (L(P), this.autoPaging) for (var F = P[0], I = P[P.length - 1], C = F; C < I + 1; C++) {
        this.pdf.setPage(C);
        var j = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1],
          O = 1 === C ? this.posY + this.margin[0] : this.margin[0],
          B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2],
          M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2],
          E = 1 === C ? 0 : B + (C - 2) * M;
        if (0 !== this.ctx.clip_path.length) {
          var D = this.path;
          m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(m, this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset), x.call(this, "fill", !0), this.path = D;
        }
        var R = JSON.parse(JSON.stringify(S));
        R = N([R], this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset)[0];
        var T = (C > F || C < I) && b.call(this);
        T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], j, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", R.x, R.y, R.w, R.h, null, null, w), T && this.pdf.restoreGraphicsState();
      } else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var y = function (t, e, r) {
        var n = [];
        e = e || this.pdf.internal.pageSize.width, r = r || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch (t.type) {
          default:
          case "mt":
          case "lt":
            n.push(Math.floor((t.y + i) / r) + 1);
            break;
          case "arc":
            n.push(Math.floor((t.y + i - t.radius) / r) + 1), n.push(Math.floor((t.y + i + t.radius) / r) + 1);
            break;
          case "qct":
            var a = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
            n.push(Math.floor((a.y + i) / r) + 1), n.push(Math.floor((a.y + a.h + i) / r) + 1);
            break;
          case "bct":
            var o = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
            n.push(Math.floor((o.y + i) / r) + 1), n.push(Math.floor((o.y + o.h + i) / r) + 1);
            break;
          case "rect":
            n.push(Math.floor((t.y + i) / r) + 1), n.push(Math.floor((t.y + t.h + i) / r) + 1);
        }
        for (var s = 0; s < n.length; s += 1) for (; this.pdf.internal.getNumberOfPages() < n[s];) w.call(this);
        return n;
      },
      w = function () {
        var t = this.fillStyle,
          e = this.strokeStyle,
          r = this.font,
          n = this.lineCap,
          i = this.lineWidth,
          a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = r, this.lineCap = n, this.lineWidth = i, this.lineJoin = a;
      },
      N = function (t, e, r) {
        for (var n = 0; n < t.length; n++) switch (t[n].type) {
          case "bct":
            t[n].x2 += e, t[n].y2 += r;
          case "qct":
            t[n].x1 += e, t[n].y1 += r;
          case "mt":
          case "lt":
          case "arc":
          default:
            t[n].x += e, t[n].y += r;
        }
        return t;
      },
      L = function (t) {
        return t.sort(function (t, e) {
          return t - e;
        });
      },
      A = function (t, e) {
        for (var r, n, i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, c = Math.abs(s * this.ctx.transform.scaleX), u = this.lineJoin, h = JSON.parse(JSON.stringify(this.path)), l = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < l.length; d++) if (void 0 !== l[d].x) for (var p = y.call(this, l[d]), g = 0; g < p.length; g += 1) -1 === f.indexOf(p[g]) && f.push(p[g]);
        for (var m = 0; m < f.length; m++) for (; this.pdf.internal.getNumberOfPages() < f[m];) w.call(this);
        if (L(f), this.autoPaging) for (var v = f[0], A = f[f.length - 1], S = v; S < A + 1; S++) {
          this.pdf.setPage(S), this.fillStyle = i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = c, this.lineJoin = u;
          var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1],
            P = 1 === S ? this.posY + this.margin[0] : this.margin[0],
            k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2],
            F = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2],
            I = 1 === S ? 0 : k + (S - 2) * F;
          if (0 !== this.ctx.clip_path.length) {
            var C = this.path;
            r = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(r, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), x.call(this, t, !0), this.path = C;
          }
          if (n = JSON.parse(JSON.stringify(h)), this.path = N(n, this.posX + this.margin[3], -I + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
            var j = (S > v || S < A) && b.call(this);
            j && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, F, null).clip().discardPath()), x.call(this, t, e), j && this.pdf.restoreGraphicsState();
          }
          this.lineWidth = s;
        } else this.lineWidth = c, x.call(this, t, e), this.lineWidth = s;
        this.path = h;
      },
      x = function (t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
          for (var r, n, i = [], a = this.path, o = 0; o < a.length; o++) {
            var s = a[o];
            switch (s.type) {
              case "begin":
                i.push({
                  begin: !0
                });
                break;
              case "close":
                i.push({
                  close: !0
                });
                break;
              case "mt":
                i.push({
                  start: s,
                  deltas: [],
                  abs: []
                });
                break;
              case "lt":
                var c = i.length;
                if (!isNaN(a[o - 1].x) && (r = [s.x - a[o - 1].x, s.y - a[o - 1].y], c > 0)) for (; c >= 0; c--) if (!0 !== i[c - 1].close && !0 !== i[c - 1].begin) {
                  i[c - 1].deltas.push(r), i[c - 1].abs.push(s);
                  break;
                }
                break;
              case "bct":
                r = [s.x1 - a[o - 1].x, s.y1 - a[o - 1].y, s.x2 - a[o - 1].x, s.y2 - a[o - 1].y, s.x - a[o - 1].x, s.y - a[o - 1].y], i[i.length - 1].deltas.push(r);
                break;
              case "qct":
                var u = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x),
                  h = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y),
                  l = s.x + 2 / 3 * (s.x1 - s.x),
                  f = s.y + 2 / 3 * (s.y1 - s.y),
                  d = s.x,
                  p = s.y;
                r = [u - a[o - 1].x, h - a[o - 1].y, l - a[o - 1].x, f - a[o - 1].y, d - a[o - 1].x, p - a[o - 1].y], i[i.length - 1].deltas.push(r);
                break;
              case "arc":
                i.push({
                  deltas: [],
                  abs: [],
                  arc: !0
                }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
            }
          }
          n = e ? null : "stroke" === t ? "stroke" : "fill";
          for (var g = 0; g < i.length; g++) {
            if (i[g].arc) {
              for (var b = i[g].abs, y = 0; y < b.length; y++) {
                var w = b[y];
                "arc" === w.type ? P.call(this, w.x, w.y, w.radius, w.startAngle, w.endAngle, w.counterclockwise, void 0, e) : j.call(this, w.x, w.y);
              }
              k.call(this, n), this.pdf.internal.out("h");
            }
            if (!i[g].arc && !0 !== i[g].close && !0 !== i[g].begin) {
              var N = i[g].start.x,
                L = i[g].start.y;
              O.call(this, i[g].deltas, N, L);
            }
          }
          n && k.call(this, n), e && F.call(this);
        }
      },
      S = function (t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor,
          r = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch (this.ctx.textBaseline) {
          case "bottom":
            return t - r;
          case "top":
            return t + e - r;
          case "hanging":
            return t + e - 2 * r;
          case "middle":
            return t + e / 2 - r;
          case "ideographic":
            return t;
          case "alphabetic":
          default:
            return t;
        }
      },
      _ = function (t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
      };
    p.prototype.createLinearGradient = function () {
      var t = function () {};
      return t.colorStops = [], t.addColorStop = function (t, e) {
        this.colorStops.push([t, e]);
      }, t.getColor = function () {
        return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
      }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function () {
      return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function () {
      return this.createLinearGradient();
    };
    var P = function (t, e, r, n, i, a, o, s) {
        for (var c = M.call(this, r, n, i, a), u = 0; u < c.length; u++) {
          var h = c[u];
          0 === u && I.call(this, h.x1 + t, h.y1 + e), B.call(this, t, e, h.x2, h.y2, h.x3, h.y3, h.x4, h.y4);
        }
        s ? F.call(this) : k.call(this, o);
      },
      k = function (t) {
        switch (t) {
          case "stroke":
            this.pdf.internal.out("S");
            break;
          case "fill":
            this.pdf.internal.out("f");
        }
      },
      F = function () {
        this.pdf.clip(), this.pdf.discardPath();
      },
      I = function (t, e) {
        this.pdf.internal.out(n(t) + " " + a(e) + " m");
      },
      C = function (t) {
        var e;
        switch (t.align) {
          case "right":
          case "end":
            e = "right";
            break;
          case "center":
            e = "center";
            break;
          case "left":
          case "start":
          default:
            e = "left";
        }
        var r = this.pdf.getTextDimensions(t.text),
          n = S.call(this, t.y),
          i = _.call(this, n) - r.h,
          a = this.ctx.transform.applyToPoint(new c(t.x, n)),
          o = this.ctx.transform.decompose(),
          s = new h();
        s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);
        for (var l, f, d, p = this.ctx.transform.applyToRectangle(new u(t.x, n, r.w, r.h)), g = s.applyToRectangle(new u(t.x, i, r.w, r.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1) -1 === v.indexOf(m[w]) && v.push(m[w]);
        if (L(v), this.autoPaging) for (var A = v[0], P = v[v.length - 1], k = A; k < P + 1; k++) {
          this.pdf.setPage(k);
          var F = 1 === k ? this.posY + this.margin[0] : this.margin[0],
            I = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2],
            C = this.pdf.internal.pageSize.height - this.margin[2],
            j = C - this.margin[0],
            O = this.pdf.internal.pageSize.width - this.margin[1],
            B = O - this.margin[3],
            M = 1 === k ? 0 : I + (k - 2) * j;
          if (0 !== this.ctx.clip_path.length) {
            var E = this.path;
            l = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(l, this.posX + this.margin[3], -1 * M + F), x.call(this, "fill", !0), this.path = E;
          }
          var q = N([JSON.parse(JSON.stringify(g))], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0];
          t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale);
          var D = "text" !== this.autoPaging;
          if (D || q.y + q.h <= C) {
            if (D || q.y >= F && q.x <= O) {
              var R = D ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - q.x)[0],
                T = N([JSON.parse(JSON.stringify(p))], this.posX + this.margin[3], -M + F + this.ctx.prevPageLastElemOffset)[0],
                U = D && (k > A || k < P) && b.call(this);
              U && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, j, null).clip().discardPath()), this.pdf.text(R, T.x, T.y, {
                angle: t.angle,
                align: e,
                renderingMode: t.renderingMode
              }), U && this.pdf.restoreGraphicsState();
            }
          } else q.y < C && (this.ctx.prevPageLastElemOffset += C - q.y);
          t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
        } else t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale), this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
          angle: t.angle,
          align: e,
          renderingMode: t.renderingMode,
          maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
      },
      j = function (t, e, r, i) {
        r = r || 0, i = i || 0, this.pdf.internal.out(n(t + r) + " " + a(e + i) + " l");
      },
      O = function (t, e, r) {
        return this.pdf.lines(t, e, r, null, null);
      },
      B = function (t, e, n, i, a, c, u, h) {
        this.pdf.internal.out([r(o(n + t)), r(s(i + e)), r(o(a + t)), r(s(c + e)), r(o(u + t)), r(s(h + e)), "c"].join(" "));
      },
      M = function (t, e, r, n) {
        for (var i = 2 * Math.PI, a = Math.PI / 2; e > r;) e -= i;
        var o = Math.abs(r - e);
        o < i && n && (o = i - o);
        for (var s = [], c = n ? -1 : 1, u = e; o > 1e-5;) {
          var h = u + c * Math.min(o, a);
          s.push(E.call(this, t, u, h)), o -= Math.abs(h - u), u = h;
        }
        return s;
      },
      E = function (t, e, r) {
        var n = (r - e) / 2,
          i = t * Math.cos(n),
          a = t * Math.sin(n),
          o = i,
          s = -a,
          c = o * o + s * s,
          u = c + o * i + s * a,
          h = 4 / 3 * (Math.sqrt(2 * c * u) - u) / (o * a - s * i),
          l = o - h * s,
          f = s + h * o,
          d = l,
          p = -f,
          g = n + e,
          m = Math.cos(g),
          v = Math.sin(g);
        return {
          x1: t * Math.cos(e),
          y1: t * Math.sin(e),
          x2: l * m - f * v,
          y2: l * v + f * m,
          x3: d * m - p * v,
          y3: d * v + p * m,
          x4: t * Math.cos(r),
          y4: t * Math.sin(r)
        };
      },
      q = function (t) {
        return 180 * t / Math.PI;
      },
      D = function (t, e, r, n, i, a) {
        var o = t + .5 * (r - t),
          s = e + .5 * (n - e),
          c = i + .5 * (r - i),
          h = a + .5 * (n - a),
          l = Math.min(t, i, o, c),
          f = Math.max(t, i, o, c),
          d = Math.min(e, a, s, h),
          p = Math.max(e, a, s, h);
        return new u(l, d, f - l, p - d);
      },
      R = function (t, e, r, n, i, a, o, s) {
        var c,
          h,
          l,
          f,
          d,
          p,
          g,
          m,
          v,
          b,
          y,
          w,
          N,
          L,
          A = r - t,
          x = n - e,
          S = i - r,
          _ = a - n,
          P = o - i,
          k = s - a;
        for (h = 0; h < 41; h++) v = (g = (l = t + (c = h / 40) * A) + c * ((d = r + c * S) - l)) + c * (d + c * (i + c * P - d) - g), b = (m = (f = e + c * x) + c * ((p = n + c * _) - f)) + c * (p + c * (a + c * k - p) - m), 0 == h ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new u(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
      },
      T = function () {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
          var t,
            e,
            r = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
              lineDash: t,
              lineDashOffset: e
            }));
          this.prevLineDash !== r && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = r);
        }
      };
  }(M.API);
  var Ut = Uint8Array,
    zt = Uint16Array,
    Ht = Uint32Array,
    Wt = new Ut([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]),
    Vt = new Ut([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]),
    Gt = new Ut([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
    Yt = function (t, e) {
      for (var r = new zt(31), n = 0; n < 31; ++n) r[n] = e += 1 << t[n - 1];
      var i = new Ht(r[30]);
      for (n = 1; n < 30; ++n) for (var a = r[n]; a < r[n + 1]; ++a) i[a] = a - r[n] << 5 | n;
      return [r, i];
    },
    Jt = Yt(Wt, 2),
    Xt = Jt[0],
    Kt = Jt[1];
  Xt[28] = 258, Kt[258] = 28;
  for (var Zt = Yt(Vt, 0), $t = Zt[0], Qt = Zt[1], te = new zt(32768), ee = 0; ee < 32768; ++ee) {
    var re = (43690 & ee) >>> 1 | (21845 & ee) << 1;
    re = (61680 & (re = (52428 & re) >>> 2 | (13107 & re) << 2)) >>> 4 | (3855 & re) << 4, te[ee] = ((65280 & re) >>> 8 | (255 & re) << 8) >>> 1;
  }
  var ne = function (t, e, r) {
      for (var n = t.length, i = 0, a = new zt(e); i < n; ++i) ++a[t[i] - 1];
      var o,
        s = new zt(e);
      for (i = 0; i < e; ++i) s[i] = s[i - 1] + a[i - 1] << 1;
      if (r) {
        o = new zt(1 << e);
        var c = 15 - e;
        for (i = 0; i < n; ++i) if (t[i]) for (var u = i << 4 | t[i], h = e - t[i], l = s[t[i] - 1]++ << h, f = l | (1 << h) - 1; l <= f; ++l) o[te[l] >>> c] = u;
      } else for (o = new zt(n), i = 0; i < n; ++i) o[i] = te[s[t[i] - 1]++] >>> 15 - t[i];
      return o;
    },
    ie = new Ut(288);
  for (ee = 0; ee < 144; ++ee) ie[ee] = 8;
  for (ee = 144; ee < 256; ++ee) ie[ee] = 9;
  for (ee = 256; ee < 280; ++ee) ie[ee] = 7;
  for (ee = 280; ee < 288; ++ee) ie[ee] = 8;
  var ae = new Ut(32);
  for (ee = 0; ee < 32; ++ee) ae[ee] = 5;
  var oe = ne(ie, 9, 0),
    se = ne(ie, 9, 1),
    ce = ne(ae, 5, 0),
    ue = ne(ae, 5, 1),
    he = function (t) {
      for (var e = t[0], r = 1; r < t.length; ++r) t[r] > e && (e = t[r]);
      return e;
    },
    le = function (t, e, r) {
      var n = e / 8 >> 0;
      return (t[n] | t[n + 1] << 8) >>> (7 & e) & r;
    },
    fe = function (t, e) {
      var r = e / 8 >> 0;
      return (t[r] | t[r + 1] << 8 | t[r + 2] << 16) >>> (7 & e);
    },
    de = function (t) {
      return (t / 8 >> 0) + (7 & t && 1);
    },
    pe = function (t, e, r) {
      (null == e || e < 0) && (e = 0), (null == r || r > t.length) && (r = t.length);
      var n = new (t instanceof zt ? zt : t instanceof Ht ? Ht : Ut)(r - e);
      return n.set(t.subarray(e, r)), n;
    },
    ge = function (t, e, r) {
      r <<= 7 & e;
      var n = e / 8 >> 0;
      t[n] |= r, t[n + 1] |= r >>> 8;
    },
    me = function (t, e, r) {
      r <<= 7 & e;
      var n = e / 8 >> 0;
      t[n] |= r, t[n + 1] |= r >>> 8, t[n + 2] |= r >>> 16;
    },
    ve = function (t, e) {
      for (var r = [], n = 0; n < t.length; ++n) t[n] && r.push({
        s: n,
        f: t[n]
      });
      var i = r.length,
        a = r.slice();
      if (!i) return [new Ut(0), 0];
      if (1 == i) {
        var o = new Ut(r[0].s + 1);
        return o[r[0].s] = 1, [o, 1];
      }
      r.sort(function (t, e) {
        return t.f - e.f;
      }), r.push({
        s: -1,
        f: 25001
      });
      var s = r[0],
        c = r[1],
        u = 0,
        h = 1,
        l = 2;
      for (r[0] = {
        s: -1,
        f: s.f + c.f,
        l: s,
        r: c
      }; h != i - 1;) s = r[r[u].f < r[l].f ? u++ : l++], c = r[u != h && r[u].f < r[l].f ? u++ : l++], r[h++] = {
        s: -1,
        f: s.f + c.f,
        l: s,
        r: c
      };
      var f = a[0].s;
      for (n = 1; n < i; ++n) a[n].s > f && (f = a[n].s);
      var d = new zt(f + 1),
        p = be(r[h - 1], d, 0);
      if (p > e) {
        n = 0;
        var g = 0,
          m = p - e,
          v = 1 << m;
        for (a.sort(function (t, e) {
          return d[e.s] - d[t.s] || t.f - e.f;
        }); n < i; ++n) {
          var b = a[n].s;
          if (!(d[b] > e)) break;
          g += v - (1 << p - d[b]), d[b] = e;
        }
        for (g >>>= m; g > 0;) {
          var y = a[n].s;
          d[y] < e ? g -= 1 << e - d[y]++ - 1 : ++n;
        }
        for (; n >= 0 && g; --n) {
          var w = a[n].s;
          d[w] == e && (--d[w], ++g);
        }
        p = e;
      }
      return [new Ut(d), p];
    },
    be = function (t, e, r) {
      return -1 == t.s ? Math.max(be(t.l, e, r + 1), be(t.r, e, r + 1)) : e[t.s] = r;
    },
    ye = function (t) {
      for (var e = t.length; e && !t[--e];);
      for (var r = new zt(++e), n = 0, i = t[0], a = 1, o = function (t) {
          r[n++] = t;
        }, s = 1; s <= e; ++s) if (t[s] == i && s != e) ++a;else {
        if (!i && a > 2) {
          for (; a > 138; a -= 138) o(32754);
          a > 2 && (o(a > 10 ? a - 11 << 5 | 28690 : a - 3 << 5 | 12305), a = 0);
        } else if (a > 3) {
          for (o(i), --a; a > 6; a -= 6) o(8304);
          a > 2 && (o(a - 3 << 5 | 8208), a = 0);
        }
        for (; a--;) o(i);
        a = 1, i = t[s];
      }
      return [r.subarray(0, n), e];
    },
    we = function (t, e) {
      for (var r = 0, n = 0; n < e.length; ++n) r += t[n] * e[n];
      return r;
    },
    Ne = function (t, e, r) {
      var n = r.length,
        i = de(e + 2);
      t[i] = 255 & n, t[i + 1] = n >>> 8, t[i + 2] = 255 ^ t[i], t[i + 3] = 255 ^ t[i + 1];
      for (var a = 0; a < n; ++a) t[i + a + 4] = r[a];
      return 8 * (i + 4 + n);
    },
    Le = function (t, e, r, n, i, a, o, s, c, u, h) {
      ge(e, h++, r), ++i[256];
      for (var l = ve(i, 15), f = l[0], d = l[1], p = ve(a, 15), g = p[0], m = p[1], v = ye(f), b = v[0], y = v[1], w = ye(g), N = w[0], L = w[1], A = new zt(19), x = 0; x < b.length; ++x) A[31 & b[x]]++;
      for (x = 0; x < N.length; ++x) A[31 & N[x]]++;
      for (var S = ve(A, 7), _ = S[0], P = S[1], k = 19; k > 4 && !_[Gt[k - 1]]; --k);
      var F,
        I,
        C,
        j,
        O = u + 5 << 3,
        B = we(i, ie) + we(a, ae) + o,
        M = we(i, f) + we(a, g) + o + 14 + 3 * k + we(A, _) + (2 * A[16] + 3 * A[17] + 7 * A[18]);
      if (O <= B && O <= M) return Ne(e, h, t.subarray(c, c + u));
      if (ge(e, h, 1 + (M < B)), h += 2, M < B) {
        F = ne(f, d, 0), I = f, C = ne(g, m, 0), j = g;
        var E = ne(_, P, 0);
        ge(e, h, y - 257), ge(e, h + 5, L - 1), ge(e, h + 10, k - 4), h += 14;
        for (x = 0; x < k; ++x) ge(e, h + 3 * x, _[Gt[x]]);
        h += 3 * k;
        for (var q = [b, N], D = 0; D < 2; ++D) {
          var R = q[D];
          for (x = 0; x < R.length; ++x) {
            var T = 31 & R[x];
            ge(e, h, E[T]), h += _[T], T > 15 && (ge(e, h, R[x] >>> 5 & 127), h += R[x] >>> 12);
          }
        }
      } else F = oe, I = ie, C = ce, j = ae;
      for (x = 0; x < s; ++x) if (n[x] > 255) {
        T = n[x] >>> 18 & 31;
        me(e, h, F[T + 257]), h += I[T + 257], T > 7 && (ge(e, h, n[x] >>> 23 & 31), h += Wt[T]);
        var U = 31 & n[x];
        me(e, h, C[U]), h += j[U], U > 3 && (me(e, h, n[x] >>> 5 & 8191), h += Vt[U]);
      } else me(e, h, F[n[x]]), h += I[n[x]];
      return me(e, h, F[256]), h + I[256];
    },
    Ae = new Ht([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]),
    xe = new Ut(0),
    Se = function (t, e, r, n, i) {
      return function (t, e, r, n, i, a) {
        var o = t.length,
          s = new Ut(n + o + 5 * (1 + Math.floor(o / 7e3)) + i),
          c = s.subarray(n, s.length - i),
          u = 0;
        if (!e || o < 8) for (var h = 0; h <= o; h += 65535) {
          var l = h + 65535;
          l < o ? u = Ne(c, u, t.subarray(h, l)) : (c[h] = a, u = Ne(c, u, t.subarray(h, o)));
        } else {
          for (var f = Ae[e - 1], d = f >>> 13, p = 8191 & f, g = (1 << r) - 1, m = new zt(32768), v = new zt(g + 1), b = Math.ceil(r / 3), y = 2 * b, w = function (e) {
              return (t[e] ^ t[e + 1] << b ^ t[e + 2] << y) & g;
            }, N = new Ht(25e3), L = new zt(288), A = new zt(32), x = 0, S = 0, _ = (h = 0, 0), P = 0, k = 0; h < o; ++h) {
            var F = w(h),
              I = 32767 & h,
              C = v[F];
            if (m[I] = C, v[F] = I, P <= h) {
              var j = o - h;
              if ((x > 7e3 || _ > 24576) && j > 423) {
                u = Le(t, c, 0, N, L, A, S, _, k, h - k, u), _ = x = S = 0, k = h;
                for (var O = 0; O < 286; ++O) L[O] = 0;
                for (O = 0; O < 30; ++O) A[O] = 0;
              }
              var B = 2,
                M = 0,
                E = p,
                q = I - C & 32767;
              if (j > 2 && F == w(h - q)) for (var D = Math.min(d, j) - 1, R = Math.min(32767, h), T = Math.min(258, j); q <= R && --E && I != C;) {
                if (t[h + B] == t[h + B - q]) {
                  for (var U = 0; U < T && t[h + U] == t[h + U - q]; ++U);
                  if (U > B) {
                    if (B = U, M = q, U > D) break;
                    var z = Math.min(q, U - 2),
                      H = 0;
                    for (O = 0; O < z; ++O) {
                      var W = h - q + O + 32768 & 32767,
                        V = W - m[W] + 32768 & 32767;
                      V > H && (H = V, C = W);
                    }
                  }
                }
                q += (I = C) - (C = m[I]) + 32768 & 32767;
              }
              if (M) {
                N[_++] = 268435456 | Kt[B] << 18 | Qt[M];
                var G = 31 & Kt[B],
                  Y = 31 & Qt[M];
                S += Wt[G] + Vt[Y], ++L[257 + G], ++A[Y], P = h + B, ++x;
              } else N[_++] = t[h], ++L[t[h]];
            }
          }
          u = Le(t, c, a, N, L, A, S, _, k, h - k, u), a || (u = Ne(c, u, xe));
        }
        return pe(s, 0, n + de(u) + i);
      }(t, null == e.level ? 6 : e.level, null == e.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + e.mem, r, n, !i);
    };
  function _e(t, e) {
    void 0 === e && (e = {});
    var r = function () {
      var t = 1,
        e = 0;
      return {
        p: function (r) {
          for (var n = t, i = e, a = r.length, o = 0; o != a;) {
            for (var s = Math.min(o + 5552, a); o < s; ++o) i += n += r[o];
            n %= 65521, i %= 65521;
          }
          t = n, e = i;
        },
        d: function () {
          return (t >>> 8 << 16 | (255 & e) << 8 | e >>> 8) + 2 * ((255 & t) << 23);
        }
      };
    }();
    r.p(t);
    var n = Se(t, e, 2, 4);
    return function (t, e) {
      var r = e.level,
        n = 0 == r ? 0 : r < 6 ? 1 : 9 == r ? 3 : 2;
      t[0] = 120, t[1] = n << 6 | (n ? 32 - 2 * n : 1);
    }(n, e), function (t, e, r) {
      for (; r; ++e) t[e] = r, r >>>= 8;
    }(n, n.length - 4, r.d()), n;
  }
  function Pe(t, e) {
    return function (t, e, r) {
      var n = t.length,
        i = !e || r,
        a = !r || r.i;
      r || (r = {}), e || (e = new Ut(3 * n));
      var o = function (t) {
          var r = e.length;
          if (t > r) {
            var n = new Ut(Math.max(2 * r, t));
            n.set(e), e = n;
          }
        },
        s = r.f || 0,
        c = r.p || 0,
        u = r.b || 0,
        h = r.l,
        l = r.d,
        f = r.m,
        d = r.n,
        p = 8 * n;
      do {
        if (!h) {
          r.f = s = le(t, c, 1);
          var g = le(t, c + 1, 3);
          if (c += 3, !g) {
            var m = t[(P = de(c) + 4) - 4] | t[P - 3] << 8,
              v = P + m;
            if (v > n) {
              if (a) throw "unexpected EOF";
              break;
            }
            i && o(u + m), e.set(t.subarray(P, v), u), r.b = u += m, r.p = c = 8 * v;
            continue;
          }
          if (1 == g) h = se, l = ue, f = 9, d = 5;else {
            if (2 != g) throw "invalid block type";
            var b = le(t, c, 31) + 257,
              y = le(t, c + 10, 15) + 4,
              w = b + le(t, c + 5, 31) + 1;
            c += 14;
            for (var N = new Ut(w), L = new Ut(19), A = 0; A < y; ++A) L[Gt[A]] = le(t, c + 3 * A, 7);
            c += 3 * y;
            var x = he(L),
              S = (1 << x) - 1;
            if (!a && c + w * (x + 7) > p) break;
            var _ = ne(L, x, 1);
            for (A = 0; A < w;) {
              var P,
                k = _[le(t, c, S)];
              if (c += 15 & k, (P = k >>> 4) < 16) N[A++] = P;else {
                var F = 0,
                  I = 0;
                for (16 == P ? (I = 3 + le(t, c, 3), c += 2, F = N[A - 1]) : 17 == P ? (I = 3 + le(t, c, 7), c += 3) : 18 == P && (I = 11 + le(t, c, 127), c += 7); I--;) N[A++] = F;
              }
            }
            var C = N.subarray(0, b),
              j = N.subarray(b);
            f = he(C), d = he(j), h = ne(C, f, 1), l = ne(j, d, 1);
          }
          if (c > p) throw "unexpected EOF";
        }
        i && o(u + 131072);
        for (var O = (1 << f) - 1, B = (1 << d) - 1, M = f + d + 18; a || c + M < p;) {
          var E = (F = h[fe(t, c) & O]) >>> 4;
          if ((c += 15 & F) > p) throw "unexpected EOF";
          if (!F) throw "invalid length/literal";
          if (E < 256) e[u++] = E;else {
            if (256 == E) {
              h = null;
              break;
            }
            var q = E - 254;
            if (E > 264) {
              var D = Wt[A = E - 257];
              q = le(t, c, (1 << D) - 1) + Xt[A], c += D;
            }
            var R = l[fe(t, c) & B],
              T = R >>> 4;
            if (!R) throw "invalid distance";
            c += 15 & R;
            j = $t[T];
            if (T > 3) {
              D = Vt[T];
              j += fe(t, c) & (1 << D) - 1, c += D;
            }
            if (c > p) throw "unexpected EOF";
            i && o(u + 131072);
            for (var U = u + q; u < U; u += 4) e[u] = e[u - j], e[u + 1] = e[u + 1 - j], e[u + 2] = e[u + 2 - j], e[u + 3] = e[u + 3 - j];
            u = U;
          }
        }
        r.l = h, r.p = c, r.b = u, h && (s = 1, r.m = f, r.d = l, r.n = d);
      } while (!s);
      return u == e.length ? e : pe(e, 0, u);
    }((function (t) {
      if (8 != (15 & t[0]) || t[0] >>> 4 > 7 || (t[0] << 8 | t[1]) % 31) throw "invalid zlib data";
      if (32 & t[1]) throw "invalid zlib data: preset dictionaries not supported";
    }(t), t.subarray(2, -4)), e);
  }
  /**
     * @license
     * jsPDF filters PlugIn
     * Copyright (c) 2014 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  !function (t) {
    var e = function (t) {
        var e, r, n, i, a, o, s, c, u, h;
        for (/[^\x00-\xFF]/.test(t), r = [], n = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > n; n += 4) 0 !== (a = (t.charCodeAt(n) << 24) + (t.charCodeAt(n + 1) << 16) + (t.charCodeAt(n + 2) << 8) + t.charCodeAt(n + 3)) ? (o = (a = ((a = ((a = ((a = (a - (h = a % 85)) / 85) - (u = a % 85)) / 85) - (c = a % 85)) / 85) - (s = a % 85)) / 85) % 85, r.push(o + 33, s + 33, c + 33, u + 33, h + 33)) : r.push(122);
        return function (t, e) {
          for (var r = e; r > 0; r--) t.pop();
        }(r, e.length), String.fromCharCode.apply(String, r) + "~>";
      },
      r = function (t) {
        var e,
          r,
          n,
          i,
          a,
          o = String,
          s = "length",
          c = 255,
          u = "charCodeAt",
          h = "slice",
          l = "replace";
        for (t[h](-2), t = t[h](0, -2)[l](/\s/g, "")[l]("z", "!!!!!"), n = [], i = 0, a = (t += e = "uuuuu"[h](t[s] % 5 || 5))[s]; a > i; i += 5) r = 52200625 * (t[u](i) - 33) + 614125 * (t[u](i + 1) - 33) + 7225 * (t[u](i + 2) - 33) + 85 * (t[u](i + 3) - 33) + (t[u](i + 4) - 33), n.push(c & r >> 24, c & r >> 16, c & r >> 8, c & r);
        return function (t, e) {
          for (var r = e; r > 0; r--) t.pop();
        }(n, e[s]), o.fromCharCode.apply(o, n);
      },
      n = function (t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for (var r = "", n = 0; n < t.length; n += 2) r += String.fromCharCode("0x" + (t[n] + t[n + 1]));
        return r;
      },
      i = function (t) {
        for (var e = new Uint8Array(t.length), r = t.length; r--;) e[r] = t.charCodeAt(r);
        return t = (e = _e(e)).reduce(function (t, e) {
          return t + String.fromCharCode(e);
        }, "");
      };
    t.processDataByFilters = function (t, a) {
      var o = 0,
        s = t || "",
        c = [];
      for ("string" == typeof (a = a || []) && (a = [a]), o = 0; o < a.length; o += 1) switch (a[o]) {
        case "ASCII85Decode":
        case "/ASCII85Decode":
          s = r(s), c.push("/ASCII85Encode");
          break;
        case "ASCII85Encode":
        case "/ASCII85Encode":
          s = e(s), c.push("/ASCII85Decode");
          break;
        case "ASCIIHexDecode":
        case "/ASCIIHexDecode":
          s = n(s), c.push("/ASCIIHexEncode");
          break;
        case "ASCIIHexEncode":
        case "/ASCIIHexEncode":
          s = s.split("").map(function (t) {
            return ("0" + t.charCodeAt().toString(16)).slice(-2);
          }).join("") + ">", c.push("/ASCIIHexDecode");
          break;
        case "FlateEncode":
        case "/FlateEncode":
          s = i(s), c.push("/FlateDecode");
          break;
        default:
          throw new Error('The filter: "' + a[o] + '" is not implemented');
      }
      return {
        data: s,
        reverseChain: c.reverse().join(" ")
      };
    };
  }(M.API),
  /**
     * @license
     * jsPDF fileloading PlugIn
     * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    t.loadFile = function (t, e, r) {
      return function (t, e, r) {
        e = !1 !== e, r = "function" == typeof r ? r : function () {};
        var n = void 0;
        try {
          n = function (t, e, r) {
            var n = new XMLHttpRequest(),
              i = 0,
              a = function (t) {
                var e = t.length,
                  r = [],
                  n = String.fromCharCode;
                for (i = 0; i < e; i += 1) r.push(n(255 & t.charCodeAt(i)));
                return r.join("");
              };
            if (n.open("GET", t, !e), n.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (n.onload = function () {
              200 === n.status ? r(a(this.responseText)) : r(void 0);
            }), n.send(null), e && 200 === n.status) return a(n.responseText);
          }(t, e, r);
        } catch (t) {}
        return n;
      }(t, e, r);
    }, t.loadImageFile = t.loadFile;
  }(M.API), function (n) {
    function i() {
      return (r.html2canvasV1 ? Promise.resolve(r.html2canvasV1) : Promise.reject(new Error("Could not load html2canvas"))).catch(function (t) {
        return Promise.reject(new Error("Could not load html2canvas: " + t));
      }).then(function (t) {
        return t.default ? t.default : t;
      });
    }
    function a() {
      return (r.DOMPurify ? Promise.resolve(r.DOMPurify) : Promise.reject(new Error("Could not load dompurify"))).catch(function (t) {
        return Promise.reject(new Error("Could not load dompurify: " + t));
      }).then(function (t) {
        return t.default ? t.default : t;
      });
    }
    var o = function (t) {
        var r = e(t);
        return "undefined" === r ? "undefined" : "string" === r || t instanceof String ? "string" : "number" === r || t instanceof Number ? "number" : "function" === r || t instanceof Function ? "function" : t && t.constructor === Array ? "array" : t && 1 === t.nodeType ? "element" : "object" === r ? "object" : "unknown";
      },
      s = function (t, e) {
        var r = document.createElement(t);
        for (var n in e.className && (r.className = e.className), e.innerHTML && e.dompurify && (r.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style) r.style[n] = e.style[n];
        return r;
      },
      c = function t(e) {
        var r = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))),
          n = t.convert(Promise.resolve(), r);
        return n = (n = n.setProgress(1, t, 1, [t])).set(e);
      };
    (c.prototype = Object.create(Promise.prototype)).constructor = c, c.convert = function (t, e) {
      return t.__proto__ = e || c.prototype, t;
    }, c.template = {
      prop: {
        src: null,
        container: null,
        overlay: null,
        canvas: null,
        img: null,
        pdf: null,
        pageSize: null,
        callback: function () {}
      },
      progress: {
        val: 0,
        state: null,
        n: 0,
        stack: []
      },
      opt: {
        filename: "file.pdf",
        margin: [0, 0, 0, 0],
        enableLinks: !0,
        x: 0,
        y: 0,
        html2canvas: {},
        jsPDF: {},
        backgroundColor: "transparent"
      }
    }, c.prototype.from = function (t, e) {
      return this.then(function () {
        switch (e = e || function (t) {
          switch (o(t)) {
            case "string":
              return "string";
            case "element":
              return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
            default:
              return "unknown";
          }
        }(t)) {
          case "string":
            return this.then(a).then(function (e) {
              return this.set({
                src: s("div", {
                  innerHTML: t,
                  dompurify: e
                })
              });
            });
          case "element":
            return this.set({
              src: t
            });
          case "canvas":
            return this.set({
              canvas: t
            });
          case "img":
            return this.set({
              img: t
            });
          default:
            return this.error("Unknown source type.");
        }
      });
    }, c.prototype.to = function (t) {
      switch (t) {
        case "container":
          return this.toContainer();
        case "canvas":
          return this.toCanvas();
        case "img":
          return this.toImg();
        case "pdf":
          return this.toPdf();
        default:
          return this.error("Invalid target.");
      }
    }, c.prototype.toContainer = function () {
      return this.thenList([function () {
        return this.prop.src || this.error("Cannot duplicate - no source HTML.");
      }, function () {
        return this.prop.pageSize || this.setPageSize();
      }]).then(function () {
        var t = {
            position: "relative",
            display: "inline-block",
            width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
            left: 0,
            right: 0,
            top: 0,
            margin: "auto",
            backgroundColor: this.opt.backgroundColor
          },
          e = function t(e, r) {
            for (var n = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling) !0 !== r && 1 === i.nodeType && "SCRIPT" === i.nodeName || n.appendChild(t(i, r));
            return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (n.width = e.width, n.height = e.height, n.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (n.value = e.value), n.addEventListener("load", function () {
              n.scrollTop = e.scrollTop, n.scrollLeft = e.scrollLeft;
            }, !0)), n;
          }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
        "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = s("div", {
          className: "html2pdf__overlay",
          style: {
            position: "fixed",
            overflow: "hidden",
            zIndex: 1e3,
            left: "-100000px",
            right: 0,
            bottom: 0,
            top: 0
          }
        }), this.prop.container = s("div", {
          className: "html2pdf__container",
          style: t
        }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(s("div", {
          style: {
            clear: "both",
            border: "0 none transparent",
            margin: 0,
            padding: 0,
            height: 0
          }
        })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
      });
    }, c.prototype.toCanvas = function () {
      var t = [function () {
        return document.body.contains(this.prop.container) || this.toContainer();
      }];
      return this.thenList(t).then(i).then(function (t) {
        var e = Object.assign({}, this.opt.html2canvas);
        return delete e.onrendered, t(this.prop.container, e);
      }).then(function (t) {
        (this.opt.html2canvas.onrendered || function () {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
      });
    }, c.prototype.toContext2d = function () {
      var t = [function () {
        return document.body.contains(this.prop.container) || this.toContainer();
      }];
      return this.thenList(t).then(i).then(function (t) {
        var e = this.opt.jsPDF,
          r = this.opt.fontFaces,
          n = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth,
          i = Object.assign({
            async: !0,
            allowTaint: !0,
            scale: n,
            scrollX: this.opt.scrollX || 0,
            scrollY: this.opt.scrollY || 0,
            backgroundColor: "#ffffff",
            imageTimeout: 15e3,
            logging: !0,
            proxy: null,
            removeContainer: !0,
            foreignObjectRendering: !1,
            useCORS: !1
          }, this.opt.html2canvas);
        if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = r, r) for (var a = 0; a < r.length; ++a) {
          var o = r[a],
            s = o.src.find(function (t) {
              return "truetype" === t.format;
            });
          s && e.addFont(s.url, o.ref.name, o.ref.style);
        }
        return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, t(this.prop.container, i);
      }).then(function (t) {
        (this.opt.html2canvas.onrendered || function () {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
      });
    }, c.prototype.toImg = function () {
      return this.thenList([function () {
        return this.prop.canvas || this.toCanvas();
      }]).then(function () {
        var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
        this.prop.img = document.createElement("img"), this.prop.img.src = t;
      });
    }, c.prototype.toPdf = function () {
      return this.thenList([function () {
        return this.toContext2d();
      }]).then(function () {
        this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
      });
    }, c.prototype.output = function (t, e, r) {
      return "img" === (r = r || "pdf").toLowerCase() || "image" === r.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, c.prototype.outputPdf = function (t, e) {
      return this.thenList([function () {
        return this.prop.pdf || this.toPdf();
      }]).then(function () {
        return this.prop.pdf.output(t, e);
      });
    }, c.prototype.outputImg = function (t) {
      return this.thenList([function () {
        return this.prop.img || this.toImg();
      }]).then(function () {
        switch (t) {
          case void 0:
          case "img":
            return this.prop.img;
          case "datauristring":
          case "dataurlstring":
            return this.prop.img.src;
          case "datauri":
          case "dataurl":
            return document.location.href = this.prop.img.src;
          default:
            throw 'Image output type "' + t + '" is not supported.';
        }
      });
    }, c.prototype.save = function (t) {
      return this.thenList([function () {
        return this.prop.pdf || this.toPdf();
      }]).set(t ? {
        filename: t
      } : null).then(function () {
        this.prop.pdf.save(this.opt.filename);
      });
    }, c.prototype.doCallback = function () {
      return this.thenList([function () {
        return this.prop.pdf || this.toPdf();
      }]).then(function () {
        this.prop.callback(this.prop.pdf);
      });
    }, c.prototype.set = function (t) {
      if ("object" !== o(t)) return this;
      var e = Object.keys(t || {}).map(function (e) {
        if (e in c.template.prop) return function () {
          this.prop[e] = t[e];
        };
        switch (e) {
          case "margin":
            return this.setMargin.bind(this, t.margin);
          case "jsPDF":
            return function () {
              return this.opt.jsPDF = t.jsPDF, this.setPageSize();
            };
          case "pageSize":
            return this.setPageSize.bind(this, t.pageSize);
          default:
            return function () {
              this.opt[e] = t[e];
            };
        }
      }, this);
      return this.then(function () {
        return this.thenList(e);
      });
    }, c.prototype.get = function (t, e) {
      return this.then(function () {
        var r = t in c.template.prop ? this.prop[t] : this.opt[t];
        return e ? e(r) : r;
      });
    }, c.prototype.setMargin = function (t) {
      return this.then(function () {
        switch (o(t)) {
          case "number":
            t = [t, t, t, t];
          case "array":
            if (2 === t.length && (t = [t[0], t[1], t[0], t[1]]), 4 === t.length) break;
          default:
            return this.error("Invalid margin array.");
        }
        this.opt.margin = t;
      }).then(this.setPageSize);
    }, c.prototype.setPageSize = function (t) {
      function e(t, e) {
        return Math.floor(t * e / 72 * 96);
      }
      return this.then(function () {
        (t = t || M.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
          width: t.width - this.opt.margin[1] - this.opt.margin[3],
          height: t.height - this.opt.margin[0] - this.opt.margin[2]
        }, t.inner.px = {
          width: e(t.inner.width, t.k),
          height: e(t.inner.height, t.k)
        }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
      });
    }, c.prototype.setProgress = function (t, e, r, n) {
      return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != r && (this.progress.n = r), null != n && (this.progress.stack = n), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, c.prototype.updateProgress = function (t, e, r, n) {
      return this.setProgress(t ? this.progress.val + t : null, e || null, r ? this.progress.n + r : null, n ? this.progress.stack.concat(n) : null);
    }, c.prototype.then = function (t, e) {
      var r = this;
      return this.thenCore(t, e, function (t, e) {
        return r.updateProgress(null, null, 1, [t]), Promise.prototype.then.call(this, function (e) {
          return r.updateProgress(null, t), e;
        }).then(t, e).then(function (t) {
          return r.updateProgress(1), t;
        });
      });
    }, c.prototype.thenCore = function (t, e, r) {
      r = r || Promise.prototype.then;
      t && (t = t.bind(this)), e && (e = e.bind(this));
      var n = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? this : c.convert(Object.assign({}, this), Promise.prototype),
        i = r.call(n, t, e);
      return c.convert(i, this.__proto__);
    }, c.prototype.thenExternal = function (t, e) {
      return Promise.prototype.then.call(this, t, e);
    }, c.prototype.thenList = function (t) {
      var e = this;
      return t.forEach(function (t) {
        e = e.thenCore(t);
      }), e;
    }, c.prototype.catch = function (t) {
      t && (t = t.bind(this));
      var e = Promise.prototype.catch.call(this, t);
      return c.convert(e, this);
    }, c.prototype.catchExternal = function (t) {
      return Promise.prototype.catch.call(this, t);
    }, c.prototype.error = function (t) {
      return this.then(function () {
        throw new Error(t);
      });
    }, c.prototype.using = c.prototype.set, c.prototype.saveAs = c.prototype.save, c.prototype.export = c.prototype.output, c.prototype.run = c.prototype.then, M.getPageSize = function (t, r, n) {
      if ("object" === e(t)) {
        var i = t;
        t = i.orientation, r = i.unit || r, n = i.format || n;
      }
      r = r || "mm", n = n || "a4", t = ("" + (t || "P")).toLowerCase();
      var a,
        o = ("" + n).toLowerCase(),
        s = {
          a0: [2383.94, 3370.39],
          a1: [1683.78, 2383.94],
          a2: [1190.55, 1683.78],
          a3: [841.89, 1190.55],
          a4: [595.28, 841.89],
          a5: [419.53, 595.28],
          a6: [297.64, 419.53],
          a7: [209.76, 297.64],
          a8: [147.4, 209.76],
          a9: [104.88, 147.4],
          a10: [73.7, 104.88],
          b0: [2834.65, 4008.19],
          b1: [2004.09, 2834.65],
          b2: [1417.32, 2004.09],
          b3: [1000.63, 1417.32],
          b4: [708.66, 1000.63],
          b5: [498.9, 708.66],
          b6: [354.33, 498.9],
          b7: [249.45, 354.33],
          b8: [175.75, 249.45],
          b9: [124.72, 175.75],
          b10: [87.87, 124.72],
          c0: [2599.37, 3676.54],
          c1: [1836.85, 2599.37],
          c2: [1298.27, 1836.85],
          c3: [918.43, 1298.27],
          c4: [649.13, 918.43],
          c5: [459.21, 649.13],
          c6: [323.15, 459.21],
          c7: [229.61, 323.15],
          c8: [161.57, 229.61],
          c9: [113.39, 161.57],
          c10: [79.37, 113.39],
          dl: [311.81, 623.62],
          letter: [612, 792],
          "government-letter": [576, 756],
          legal: [612, 1008],
          "junior-legal": [576, 360],
          ledger: [1224, 792],
          tabloid: [792, 1224],
          "credit-card": [153, 243]
        };
      switch (r) {
        case "pt":
          a = 1;
          break;
        case "mm":
          a = 72 / 25.4;
          break;
        case "cm":
          a = 72 / 2.54;
          break;
        case "in":
          a = 72;
          break;
        case "px":
          a = .75;
          break;
        case "pc":
        case "em":
          a = 12;
          break;
        case "ex":
          a = 6;
          break;
        default:
          throw "Invalid unit: " + r;
      }
      var c,
        u = 0,
        h = 0;
      if (s.hasOwnProperty(o)) u = s[o][1] / a, h = s[o][0] / a;else try {
        u = n[1], h = n[0];
      } catch (t) {
        throw new Error("Invalid format: " + n);
      }
      if ("p" === t || "portrait" === t) t = "p", h > u && (c = h, h = u, u = c);else {
        if ("l" !== t && "landscape" !== t) throw "Invalid orientation: " + t;
        t = "l", u > h && (c = h, h = u, u = c);
      }
      return {
        width: h,
        height: u,
        unit: r,
        k: a,
        orientation: t
      };
    }, n.html = function (t, e) {
      (e = e || {}).callback = e.callback || function () {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map(Ct) : null;
      var r = new c(e);
      return e.worker ? r : r.from(t).doCallback();
    };
  }(M.API),
  /**
     * @license
     * ====================================================================
     * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
     *
     * Permission is hereby granted, free of charge, to any person obtaining
     * a copy of this software and associated documentation files (the
     * "Software"), to deal in the Software without restriction, including
     * without limitation the rights to use, copy, modify, merge, publish,
     * distribute, sublicense, and/or sell copies of the Software, and to
     * permit persons to whom the Software is furnished to do so, subject to
     * the following conditions:
     *
     * The above copyright notice and this permission notice shall be
     * included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     * ====================================================================
     */
  function (t) {
    var e, r, n;
    t.addJS = function (t) {
      return n = t, this.internal.events.subscribe("postPutResources", function () {
        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (e + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), r = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + n + ")"), this.internal.out(">>"), this.internal.out("endobj");
      }), this.internal.events.subscribe("putCatalog", function () {
        void 0 !== e && void 0 !== r && this.internal.out("/Names <</JavaScript " + e + " 0 R>>");
      }), this;
    };
  }(M.API),
  /**
     * @license
     * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    var e;
    t.events.push(["postPutResources", function () {
      var t = this,
        r = /^(\d+) 0 obj$/;
      if (this.outline.root.children.length > 0) for (var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++) {
        var a = n[i],
          o = r.exec(a);
        if (null != o) {
          var s = o[1];
          t.internal.newObjectDeferredBegin(s, !1);
        }
        t.internal.write(a);
      }
      if (this.outline.createNamedDestinations) {
        var c = this.internal.pages.length,
          u = [];
        for (i = 0; i < c; i++) {
          var h = t.internal.newObject();
          u.push(h);
          var l = t.internal.getPageInfo(i + 1);
          t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
        }
        var f = t.internal.newObject();
        t.internal.write("<< /Names [ ");
        for (i = 0; i < u.length; i++) t.internal.write("(page_" + (i + 1) + ")" + u[i] + " 0 R");
        t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
      }
    }]), t.events.push(["putCatalog", function () {
      this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
    }]), t.events.push(["initialized", function () {
      var t = this;
      t.outline = {
        createNamedDestinations: !1,
        root: {
          children: []
        }
      }, t.outline.add = function (t, e, r) {
        var n = {
          title: e,
          options: r,
          children: []
        };
        return null == t && (t = this.root), t.children.push(n), n;
      }, t.outline.render = function () {
        return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
      }, t.outline.genIds_r = function (e) {
        e.id = t.internal.newObjectDeferred();
        for (var r = 0; r < e.children.length; r++) this.genIds_r(e.children[r]);
      }, t.outline.renderRoot = function (t) {
        this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
          count: 0
        }, t)), this.objEnd();
      }, t.outline.renderItems = function (e) {
        for (var r = this.ctx.pdf.internal.getVerticalCoordinateString, n = 0; n < e.children.length; n++) {
          var i = e.children[n];
          this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), n > 0 && this.line("/Prev " + this.makeRef(e.children[n - 1])), n < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[n + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
          var a = this.count = this.count_r({
            count: 0
          }, i);
          if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
            var o = t.internal.getPageInfo(i.options.pageNumber);
            this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + r(0) + " 0]");
          }
          this.objEnd();
        }
        for (var s = 0; s < e.children.length; s++) this.renderItems(e.children[s]);
      }, t.outline.line = function (t) {
        this.ctx.val += t + "\r\n";
      }, t.outline.makeRef = function (t) {
        return t.id + " 0 R";
      }, t.outline.makeString = function (e) {
        return "(" + t.internal.pdfEscape(e) + ")";
      }, t.outline.objStart = function (t) {
        this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
      }, t.outline.objEnd = function () {
        this.ctx.val += ">> \r\nendobj\r\n";
      }, t.outline.count_r = function (t, e) {
        for (var r = 0; r < e.children.length; r++) t.count++, this.count_r(t, e.children[r]);
        return t.count;
      };
    }]);
  }(M.API),
  /**
     * @license
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    var e = [192, 193, 194, 195, 196, 197, 198, 199];
    t.processJPEG = function (t, r, n, i, a, o) {
      var s,
        c = this.decode.DCT_DECODE,
        u = null;
      if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
        switch (t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, (s = function (t) {
          for (var r, n = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
              width: 0,
              height: 0,
              numcomponents: 1
            }, o = 4; o < i; o += 2) {
            if (o += n, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
              r = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                height: r,
                numcomponents: t.charCodeAt(o + 9)
              };
              break;
            }
            n = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
          }
          return a;
        }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t)).numcomponents) {
          case 1:
            o = this.color_spaces.DEVICE_GRAY;
            break;
          case 4:
            o = this.color_spaces.DEVICE_CMYK;
            break;
          case 3:
            o = this.color_spaces.DEVICE_RGB;
        }
        u = {
          data: t,
          width: s.width,
          height: s.height,
          colorSpace: o,
          bitsPerComponent: 8,
          filter: c,
          index: r,
          alias: n
        };
      }
      return u;
    };
  }(M.API);
  var ke,
    Fe,
    Ie,
    Ce,
    je,
    Oe = function () {
      var t, e, n;
      function i(t) {
        var e, r, n, i, a, o, s, c, u, h, l, f, d, p;
        for (this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, o = null;;) {
          switch (e = this.readUInt32(), u = function () {
            var t, e;
            for (e = [], t = 0; t < 4; ++t) e.push(String.fromCharCode(this.data[this.pos++]));
            return e;
          }.call(this).join("")) {
            case "IHDR":
              this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
              break;
            case "acTL":
              this.animation = {
                numFrames: this.readUInt32(),
                numPlays: this.readUInt32() || 1 / 0,
                frames: []
              };
              break;
            case "PLTE":
              this.palette = this.read(e);
              break;
            case "fcTL":
              o && this.animation.frames.push(o), this.pos += 4, o = {
                width: this.readUInt32(),
                height: this.readUInt32(),
                xOffset: this.readUInt32(),
                yOffset: this.readUInt32()
              }, a = this.readUInt16(), i = this.readUInt16() || 100, o.delay = 1e3 * a / i, o.disposeOp = this.data[this.pos++], o.blendOp = this.data[this.pos++], o.data = [];
              break;
            case "IDAT":
            case "fdAT":
              for ("fdAT" === u && (this.pos += 4, e -= 4), t = (null != o ? o.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : f > e; 0 <= e ? ++f : --f) t.push(this.data[this.pos++]);
              break;
            case "tRNS":
              switch (this.transparency = {}, this.colorType) {
                case 3:
                  if (n = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > n) throw new Error("More transparent colors than palette size");
                  if ((h = n - this.transparency.indexed.length) > 0) for (d = 0; 0 <= h ? d < h : d > h; 0 <= h ? ++d : --d) this.transparency.indexed.push(255);
                  break;
                case 0:
                  this.transparency.grayscale = this.read(e)[0];
                  break;
                case 2:
                  this.transparency.rgb = this.read(e);
              }
              break;
            case "tEXt":
              s = (l = this.read(e)).indexOf(0), c = String.fromCharCode.apply(String, l.slice(0, s)), this.text[c] = String.fromCharCode.apply(String, l.slice(s + 1));
              break;
            case "IEND":
              return o && this.animation.frames.push(o), this.colors = function () {
                switch (this.colorType) {
                  case 0:
                  case 3:
                  case 4:
                    return 1;
                  case 2:
                  case 6:
                    return 3;
                }
              }.call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, r = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * r, this.colorSpace = function () {
                switch (this.colors) {
                  case 1:
                    return "DeviceGray";
                  case 3:
                    return "DeviceRGB";
                }
              }.call(this), void (this.imgData = new Uint8Array(this.imgData));
            default:
              this.pos += e;
          }
          if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
      }
      i.prototype.read = function (t) {
        var e, r;
        for (r = [], e = 0; 0 <= t ? e < t : e > t; 0 <= t ? ++e : --e) r.push(this.data[this.pos++]);
        return r;
      }, i.prototype.readUInt32 = function () {
        return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
      }, i.prototype.readUInt16 = function () {
        return this.data[this.pos++] << 8 | this.data[this.pos++];
      }, i.prototype.decodePixels = function (t) {
        var e = this.pixelBitlength / 8,
          r = new Uint8Array(this.width * this.height * e),
          n = 0,
          i = this;
        if (null == t && (t = this.imgData), 0 === t.length) return new Uint8Array(0);
        function a(a, o, s, c) {
          var u,
            h,
            l,
            f,
            d,
            p,
            g,
            m,
            v,
            b,
            y,
            w,
            N,
            L,
            A,
            x,
            S,
            _,
            P,
            k,
            F,
            I = Math.ceil((i.width - a) / s),
            C = Math.ceil((i.height - o) / c),
            j = i.width == I && i.height == C;
          for (L = e * I, w = j ? r : new Uint8Array(L * C), p = t.length, N = 0, h = 0; N < C && n < p;) {
            switch (t[n++]) {
              case 0:
                for (f = S = 0; S < L; f = S += 1) w[h++] = t[n++];
                break;
              case 1:
                for (f = _ = 0; _ < L; f = _ += 1) u = t[n++], d = f < e ? 0 : w[h - e], w[h++] = (u + d) % 256;
                break;
              case 2:
                for (f = P = 0; P < L; f = P += 1) u = t[n++], l = (f - f % e) / e, A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (A + u) % 256;
                break;
              case 3:
                for (f = k = 0; k < L; f = k += 1) u = t[n++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (u + Math.floor((d + A) / 2)) % 256;
                break;
              case 4:
                for (f = F = 0; F < L; f = F += 1) u = t[n++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], 0 === N ? A = x = 0 : (A = w[(N - 1) * L + l * e + f % e], x = l && w[(N - 1) * L + (l - 1) * e + f % e]), g = d + A - x, m = Math.abs(g - d), b = Math.abs(g - A), y = Math.abs(g - x), v = m <= b && m <= y ? d : b <= y ? A : x, w[h++] = (u + v) % 256;
                break;
              default:
                throw new Error("Invalid filter algorithm: " + t[n - 1]);
            }
            if (!j) {
              var O = ((o + N * c) * i.width + a) * e,
                B = N * L;
              for (f = 0; f < I; f += 1) {
                for (var M = 0; M < e; M += 1) r[O++] = w[B++];
                O += (s - 1) * e;
              }
            }
            N++;
          }
        }
        return t = Pe(t), 1 == i.interlaceMethod ? (a(0, 0, 8, 8), a(4, 0, 8, 8), a(0, 4, 4, 8), a(2, 0, 4, 4), a(0, 2, 2, 4), a(1, 0, 2, 2), a(0, 1, 1, 2)) : a(0, 0, 1, 1), r;
      }, i.prototype.decodePalette = function () {
        var t, e, r, n, i, a, o, s, c;
        for (r = this.palette, a = this.transparency.indexed || [], i = new Uint8Array((a.length || 0) + r.length), n = 0, t = 0, e = o = 0, s = r.length; o < s; e = o += 3) i[n++] = r[e], i[n++] = r[e + 1], i[n++] = r[e + 2], i[n++] = null != (c = a[t++]) ? c : 255;
        return i;
      }, i.prototype.copyToImageData = function (t, e) {
        var r, n, i, a, o, s, c, u, h, l, f;
        if (n = this.colors, h = null, r = this.hasAlphaChannel, this.palette.length && (h = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), n = 4, r = !0), u = (i = t.data || t).length, o = h || e, a = s = 0, 1 === n) for (; a < u;) c = h ? 4 * e[a / 4] : s, l = o[c++], i[a++] = l, i[a++] = l, i[a++] = l, i[a++] = r ? o[c++] : 255, s = c;else for (; a < u;) c = h ? 4 * e[a / 4] : s, i[a++] = o[c++], i[a++] = o[c++], i[a++] = o[c++], i[a++] = r ? o[c++] : 255, s = c;
      }, i.prototype.decode = function () {
        var t;
        return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
      };
      var a = function () {
        if ("[object Window]" === Object.prototype.toString.call(r)) {
          try {
            e = r.document.createElement("canvas"), n = e.getContext("2d");
          } catch (t) {
            return !1;
          }
          return !0;
        }
        return !1;
      };
      return a(), t = function (t) {
        var r;
        if (!0 === a()) return n.width = t.width, n.height = t.height, n.clearRect(0, 0, t.width, t.height), n.putImageData(t, 0, 0), (r = new Image()).src = e.toDataURL(), r;
        throw new Error("This method requires a Browser with Canvas-capability.");
      }, i.prototype.decodeFrames = function (e) {
        var r, n, i, a, o, s, c, u;
        if (this.animation) {
          for (u = [], n = o = 0, s = (c = this.animation.frames).length; o < s; n = ++o) r = c[n], i = e.createImageData(r.width, r.height), a = this.decodePixels(new Uint8Array(r.data)), this.copyToImageData(i, a), r.imageData = i, u.push(r.image = t(i));
          return u;
        }
      }, i.prototype.renderFrame = function (t, e) {
        var r, n, i;
        return r = (n = this.animation.frames)[e], i = n[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === r.blendOp && t.clearRect(r.xOffset, r.yOffset, r.width, r.height), t.drawImage(r.image, r.xOffset, r.yOffset);
      }, i.prototype.animate = function (t) {
        var e,
          r,
          n,
          i,
          a,
          o,
          s = this;
        return r = 0, o = this.animation, i = o.numFrames, n = o.frames, a = o.numPlays, (e = function () {
          var o, c;
          if (o = r++ % i, c = n[o], s.renderFrame(t, o), i > 1 && r / i < a) return s.animation._timeout = setTimeout(e, c.delay);
        })();
      }, i.prototype.stopAnimation = function () {
        var t;
        return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
      }, i.prototype.render = function (t) {
        var e, r;
        return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (r = e.createImageData(this.width, this.height), this.copyToImageData(r, this.decodePixels()), e.putImageData(r, 0, 0));
      }, i;
    }();
  /**
     * @license
     *
     * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
     *
     * Permission is hereby granted, free of charge, to any person obtaining
     * a copy of this software and associated documentation files (the
     * "Software"), to deal in the Software without restriction, including
     * without limitation the rights to use, copy, modify, merge, publish,
     * distribute, sublicense, and/or sell copies of the Software, and to
     * permit persons to whom the Software is furnished to do so, subject to
     * the following conditions:
     *
     * The above copyright notice and this permission notice shall be
     * included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     * ====================================================================
     */
  /**
     * @license
     * (c) Dean McNamee <dean@gmail.com>, 2013.
     *
     * https://github.com/deanm/omggif
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to
     * deal in the Software without restriction, including without limitation the
     * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
     * sell copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
     * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
     * IN THE SOFTWARE.
     *
     * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
     * including animation and compression.  It does not rely on any specific
     * underlying system, so should run in the browser, Node, or Plask.
     */
  function Be(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var r = t[e++] | t[e++] << 8,
      n = t[e++] | t[e++] << 8,
      i = t[e++],
      a = i >> 7,
      o = 1 << (7 & i) + 1;
    t[e++];
    t[e++];
    var s = null,
      c = null;
    a && (s = e, c = o, e += 3 * o);
    var u = !0,
      h = [],
      l = 0,
      f = null,
      d = 0,
      p = null;
    for (this.width = r, this.height = n; u && e < t.length;) switch (t[e++]) {
      case 33:
        switch (t[e++]) {
          case 255:
            if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;else for (e += 12;;) {
              if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
              if (0 === P) break;
              e += P;
            }
            break;
          case 249:
            if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
            var g = t[e++];
            l = t[e++] | t[e++] << 8, f = t[e++], 0 == (1 & g) && (f = null), d = g >> 2 & 7, e++;
            break;
          case 254:
            for (;;) {
              if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
              if (0 === P) break;
              e += P;
            }
            break;
          default:
            throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
        }
        break;
      case 44:
        var m = t[e++] | t[e++] << 8,
          v = t[e++] | t[e++] << 8,
          b = t[e++] | t[e++] << 8,
          y = t[e++] | t[e++] << 8,
          w = t[e++],
          N = w >> 6 & 1,
          L = 1 << (7 & w) + 1,
          A = s,
          x = c,
          S = !1;
        if (w >> 7) {
          S = !0;
          A = e, x = L, e += 3 * L;
        }
        var _ = e;
        for (e++;;) {
          var P;
          if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
          if (0 === P) break;
          e += P;
        }
        h.push({
          x: m,
          y: v,
          width: b,
          height: y,
          has_local_palette: S,
          palette_offset: A,
          palette_size: x,
          data_offset: _,
          data_length: e - _,
          transparent_index: f,
          interlaced: !!N,
          delay: l,
          disposal: d
        });
        break;
      case 59:
        u = !1;
        break;
      default:
        throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function () {
      return h.length;
    }, this.loopCount = function () {
      return p;
    }, this.frameInfo = function (t) {
      if (t < 0 || t >= h.length) throw new Error("Frame index out of range.");
      return h[t];
    }, this.decodeAndBlitFrameBGRA = function (e, n) {
      var i = this.frameInfo(e),
        a = i.width * i.height,
        o = new Uint8Array(a);
      Me(t, i.data_offset, o, a);
      var s = i.palette_offset,
        c = i.transparent_index;
      null === c && (c = 256);
      var u = i.width,
        h = r - u,
        l = u,
        f = 4 * (i.y * r + i.x),
        d = 4 * ((i.y + i.height) * r + i.x),
        p = f,
        g = 4 * h;
      !0 === i.interlaced && (g += 4 * r * 7);
      for (var m = 8, v = 0, b = o.length; v < b; ++v) {
        var y = o[v];
        if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;else {
          var w = t[s + 3 * y],
            N = t[s + 3 * y + 1],
            L = t[s + 3 * y + 2];
          n[p++] = L, n[p++] = N, n[p++] = w, n[p++] = 255;
        }
        --l;
      }
    }, this.decodeAndBlitFrameRGBA = function (e, n) {
      var i = this.frameInfo(e),
        a = i.width * i.height,
        o = new Uint8Array(a);
      Me(t, i.data_offset, o, a);
      var s = i.palette_offset,
        c = i.transparent_index;
      null === c && (c = 256);
      var u = i.width,
        h = r - u,
        l = u,
        f = 4 * (i.y * r + i.x),
        d = 4 * ((i.y + i.height) * r + i.x),
        p = f,
        g = 4 * h;
      !0 === i.interlaced && (g += 4 * r * 7);
      for (var m = 8, v = 0, b = o.length; v < b; ++v) {
        var y = o[v];
        if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;else {
          var w = t[s + 3 * y],
            N = t[s + 3 * y + 1],
            L = t[s + 3 * y + 2];
          n[p++] = w, n[p++] = N, n[p++] = L, n[p++] = 255;
        }
        --l;
      }
    };
  }
  function Me(t, e, r, n) {
    for (var a = t[e++], o = 1 << a, s = o + 1, c = s + 1, u = a + 1, h = (1 << u) - 1, l = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;) {
      for (; l < 16 && 0 !== p;) f |= t[e++] << l, l += 8, 1 === p ? p = t[e++] : --p;
      if (l < u) break;
      var v = f & h;
      if (f >>= u, l -= u, v !== o) {
        if (v === s) break;
        for (var b = v < c ? v : m, y = 0, w = b; w > o;) w = g[w] >> 8, ++y;
        var N = w;
        if (d + y + (b !== v ? 1 : 0) > n) return void i.log("Warning, gif stream longer than expected.");
        r[d++] = N;
        var L = d += y;
        for (b !== v && (r[d++] = N), w = b; y--;) w = g[w], r[--L] = 255 & w, w >>= 8;
        null !== m && c < 4096 && (g[c++] = m << 8 | N, c >= h + 1 && u < 12 && (++u, h = h << 1 | 1)), m = v;
      } else c = s + 1, h = (1 << (u = a + 1)) - 1, m = null;
    }
    return d !== n && i.log("Warning, gif stream shorter than expected."), r;
  }
  /**
     * @license
      Copyright (c) 2008, Adobe Systems Incorporated
      All rights reserved.
  
      Redistribution and use in source and binary forms, with or without 
      modification, are permitted provided that the following conditions are
      met:
  
      * Redistributions of source code must retain the above copyright notice, 
        this list of conditions and the following disclaimer.
      
      * Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the 
        documentation and/or other materials provided with the distribution.
      
      * Neither the name of Adobe Systems Incorporated nor the names of its 
        contributors may be used to endorse or promote products derived from 
        this software without specific prior written permission.
  
      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
      IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
      THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
      PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
      CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
      EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
      PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
      PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
      LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
      SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
    */
  function Ee(t) {
    var e,
      r,
      n,
      i,
      a,
      o = Math.floor,
      s = new Array(64),
      c = new Array(64),
      u = new Array(64),
      h = new Array(64),
      l = new Array(65535),
      f = new Array(65535),
      d = new Array(64),
      p = new Array(64),
      g = [],
      m = 0,
      v = 7,
      b = new Array(64),
      y = new Array(64),
      w = new Array(64),
      N = new Array(256),
      L = new Array(2048),
      A = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63],
      x = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0],
      S = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      _ = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125],
      P = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250],
      k = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
      F = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      I = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119],
      C = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
    function j(t, e) {
      for (var r = 0, n = 0, i = new Array(), a = 1; a <= 16; a++) {
        for (var o = 1; o <= t[a]; o++) i[e[n]] = [], i[e[n]][0] = r, i[e[n]][1] = a, n++, r++;
        r *= 2;
      }
      return i;
    }
    function O(t) {
      for (var e = t[0], r = t[1] - 1; r >= 0;) e & 1 << r && (m |= 1 << v), r--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
      g.push(t);
    }
    function M(t) {
      B(t >> 8 & 255), B(255 & t);
    }
    function E(t, e, r, n, i) {
      for (var a, o = i[0], s = i[240], c = function (t, e) {
          var r,
            n,
            i,
            a,
            o,
            s,
            c,
            u,
            h,
            l,
            f = 0;
          for (h = 0; h < 8; ++h) {
            r = t[f], n = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], c = t[f + 6];
            var p = r + (u = t[f + 7]),
              g = r - u,
              m = n + c,
              v = n - c,
              b = i + s,
              y = i - s,
              w = a + o,
              N = a - o,
              L = p + w,
              A = p - w,
              x = m + b,
              S = m - b;
            t[f] = L + x, t[f + 4] = L - x;
            var _ = .707106781 * (S + A);
            t[f + 2] = A + _, t[f + 6] = A - _;
            var P = .382683433 * ((L = N + y) - (S = v + g)),
              k = .5411961 * L + P,
              F = 1.306562965 * S + P,
              I = .707106781 * (x = y + v),
              C = g + I,
              j = g - I;
            t[f + 5] = j + k, t[f + 3] = j - k, t[f + 1] = C + F, t[f + 7] = C - F, f += 8;
          }
          for (f = 0, h = 0; h < 8; ++h) {
            r = t[f], n = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], c = t[f + 48];
            var O = r + (u = t[f + 56]),
              B = r - u,
              M = n + c,
              E = n - c,
              q = i + s,
              D = i - s,
              R = a + o,
              T = a - o,
              U = O + R,
              z = O - R,
              H = M + q,
              W = M - q;
            t[f] = U + H, t[f + 32] = U - H;
            var V = .707106781 * (W + z);
            t[f + 16] = z + V, t[f + 48] = z - V;
            var G = .382683433 * ((U = T + D) - (W = E + B)),
              Y = .5411961 * U + G,
              J = 1.306562965 * W + G,
              X = .707106781 * (H = D + E),
              K = B + X,
              Z = B - X;
            t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
          }
          for (h = 0; h < 64; ++h) l = t[h] * e[h], d[h] = l > 0 ? l + .5 | 0 : l - .5 | 0;
          return d;
        }(t, e), u = 0; u < 64; ++u) p[A[u]] = c[u];
      var h = p[0] - r;
      r = p[0], 0 == h ? O(n[0]) : (O(n[f[a = 32767 + h]]), O(l[a]));
      for (var g = 63; g > 0 && 0 == p[g];) g--;
      if (0 == g) return O(o), r;
      for (var m, v = 1; v <= g;) {
        for (var b = v; 0 == p[v] && v <= g;) ++v;
        var y = v - b;
        if (y >= 16) {
          m = y >> 4;
          for (var w = 1; w <= m; ++w) O(s);
          y &= 15;
        }
        a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(l[a]), v++;
      }
      return 63 != g && O(o), r;
    }
    function q(t) {
      (t = Math.min(Math.max(t, 1), 100), a != t) && (!function (t) {
        for (var e = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], r = 0; r < 64; r++) {
          var n = o((e[r] * t + 50) / 100);
          n = Math.min(Math.max(n, 1), 255), s[A[r]] = n;
        }
        for (var i = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], a = 0; a < 64; a++) {
          var l = o((i[a] * t + 50) / 100);
          l = Math.min(Math.max(l, 1), 255), c[A[a]] = l;
        }
        for (var f = [1, 1.387039845, 1.306562965, 1.175875602, 1, .785694958, .5411961, .275899379], d = 0, p = 0; p < 8; p++) for (var g = 0; g < 8; g++) u[d] = 1 / (s[A[d]] * f[p] * f[g] * 8), h[d] = 1 / (c[A[d]] * f[p] * f[g] * 8), d++;
      }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function (t, a) {
      a && q(a), g = new Array(), m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function () {
        M(65499), M(132), B(0);
        for (var t = 0; t < 64; t++) B(s[t]);
        B(1);
        for (var e = 0; e < 64; e++) B(c[e]);
      }(), function (t, e) {
        M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
      }(t.width, t.height), function () {
        M(65476), M(418), B(0);
        for (var t = 0; t < 16; t++) B(x[t + 1]);
        for (var e = 0; e <= 11; e++) B(S[e]);
        B(16);
        for (var r = 0; r < 16; r++) B(_[r + 1]);
        for (var n = 0; n <= 161; n++) B(P[n]);
        B(1);
        for (var i = 0; i < 16; i++) B(k[i + 1]);
        for (var a = 0; a <= 11; a++) B(F[a]);
        B(17);
        for (var o = 0; o < 16; o++) B(I[o + 1]);
        for (var s = 0; s <= 161; s++) B(C[s]);
      }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
      var o = 0,
        l = 0,
        f = 0;
      m = 0, v = 7, this.encode.displayName = "_encode_";
      for (var d, p, N, A, j, D, R, T, U, z = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;) {
        for (d = 0; d < V;) {
          for (j = V * G + d, R = -1, T = 0, U = 0; U < 64; U++) D = j + (T = U >> 3) * V + (R = 4 * (7 & U)), G + T >= W && (D -= V * (G + 1 + T - W)), d + R >= V && (D -= d + R - V + 4), p = z[D++], N = z[D++], A = z[D++], b[U] = (L[p] + L[N + 256 >> 0] + L[A + 512 >> 0] >> 16) - 128, y[U] = (L[p + 768 >> 0] + L[N + 1024 >> 0] + L[A + 1280 >> 0] >> 16) - 128, w[U] = (L[p + 1280 >> 0] + L[N + 1536 >> 0] + L[A + 1792 >> 0] >> 16) - 128;
          o = E(b, u, o, e, n), l = E(y, h, l, r, i), f = E(w, h, f, r, i), d += 32;
        }
        G += 8;
      }
      if (v >= 0) {
        var Y = [];
        Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
      }
      return M(65497), new Uint8Array(g);
    }, t = t || 50, function () {
      for (var t = String.fromCharCode, e = 0; e < 256; e++) N[e] = t(e);
    }(), e = j(x, S), r = j(k, F), n = j(_, P), i = j(I, C), function () {
      for (var t = 1, e = 2, r = 1; r <= 15; r++) {
        for (var n = t; n < e; n++) f[32767 + n] = r, l[32767 + n] = [], l[32767 + n][1] = r, l[32767 + n][0] = n;
        for (var i = -(e - 1); i <= -t; i++) f[32767 + i] = r, l[32767 + i] = [], l[32767 + i][1] = r, l[32767 + i][0] = e - 1 + i;
        t <<= 1, e <<= 1;
      }
    }(), function () {
      for (var t = 0; t < 256; t++) L[t] = 19595 * t, L[t + 256 >> 0] = 38470 * t, L[t + 512 >> 0] = 7471 * t + 32768, L[t + 768 >> 0] = -11059 * t, L[t + 1024 >> 0] = -21709 * t, L[t + 1280 >> 0] = 32768 * t + 8421375, L[t + 1536 >> 0] = -27439 * t, L[t + 1792 >> 0] = -5329 * t;
    }(), q(t);
  }
  /**
     * @license
     * Copyright (c) 2017 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function qe(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
  }
  function De(t) {
    function e(t) {
      if (!t) throw Error("assert :P");
    }
    function r(t, e, r) {
      for (var n = 0; 4 > n; n++) if (t[e + n] != r.charCodeAt(n)) return !0;
      return !1;
    }
    function n(t, e, r, n, i) {
      for (var a = 0; a < i; a++) t[e + a] = r[n + a];
    }
    function i(t, e, r, n) {
      for (var i = 0; i < n; i++) t[e + i] = r;
    }
    function a(t) {
      return new Int32Array(t);
    }
    function o(t, e) {
      for (var r = [], n = 0; n < t; n++) r.push(new e());
      return r;
    }
    function s(t, e) {
      var r = [];
      return function t(r, n, i) {
        for (var a = i[n], o = 0; o < a && (r.push(i.length > n + 1 ? [] : new e()), !(i.length < n + 1)); o++) t(r[o], n + 1, i);
      }(r, 0, t), r;
    }
    var c = function () {
      var t = this;
      function c(t, e) {
        for (var r = 1 << e - 1 >>> 0; t & r;) r >>>= 1;
        return r ? (t & r - 1) + r : t;
      }
      function u(t, r, n, i, a) {
        e(!(i % n));
        do {
          t[r + (i -= n)] = a;
        } while (0 < i);
      }
      function h(t, r, n, i, o) {
        if (e(2328 >= o), 512 >= o) var s = a(512);else if (null == (s = a(o))) return 0;
        return function (t, r, n, i, o, s) {
          var h,
            f,
            d = r,
            p = 1 << n,
            g = a(16),
            m = a(16);
          for (e(0 != o), e(null != i), e(null != t), e(0 < n), f = 0; f < o; ++f) {
            if (15 < i[f]) return 0;
            ++g[i[f]];
          }
          if (g[0] == o) return 0;
          for (m[1] = 0, h = 1; 15 > h; ++h) {
            if (g[h] > 1 << h) return 0;
            m[h + 1] = m[h] + g[h];
          }
          for (f = 0; f < o; ++f) h = i[f], 0 < i[f] && (s[m[h]++] = f);
          if (1 == m[15]) return (i = new l()).g = 0, i.value = s[0], u(t, d, 1, p, i), p;
          var v,
            b = -1,
            y = p - 1,
            w = 0,
            N = 1,
            L = 1,
            A = 1 << n;
          for (f = 0, h = 1, o = 2; h <= n; ++h, o <<= 1) {
            if (N += L <<= 1, 0 > (L -= g[h])) return 0;
            for (; 0 < g[h]; --g[h]) (i = new l()).g = h, i.value = s[f++], u(t, d + w, o, A, i), w = c(w, h);
          }
          for (h = n + 1, o = 2; 15 >= h; ++h, o <<= 1) {
            if (N += L <<= 1, 0 > (L -= g[h])) return 0;
            for (; 0 < g[h]; --g[h]) {
              if (i = new l(), (w & y) != b) {
                for (d += A, v = 1 << (b = h) - n; 15 > b && !(0 >= (v -= g[b]));) ++b, v <<= 1;
                p += A = 1 << (v = b - n), t[r + (b = w & y)].g = v + n, t[r + b].value = d - r - b;
              }
              i.g = h - n, i.value = s[f++], u(t, d + (w >> n), o, A, i), w = c(w, h);
            }
          }
          return N != 2 * m[15] - 1 ? 0 : p;
        }(t, r, n, i, o, s);
      }
      function l() {
        this.value = this.g = 0;
      }
      function f() {
        this.value = this.g = 0;
      }
      function d() {
        this.G = o(5, l), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Dr, f);
      }
      function p(t, r, n, i) {
        e(null != t), e(null != r), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = r, t.pa = n, t.Jd = r, t.Yc = n + i, t.Zc = 4 <= i ? n + i - 4 + 1 : n, _(t);
      }
      function g(t, e) {
        for (var r = 0; 0 < e--;) r |= k(t, 128) << e;
        return r;
      }
      function m(t, e) {
        var r = g(t, e);
        return P(t) ? -r : r;
      }
      function v(t, r, n, i) {
        var a,
          o = 0;
        for (e(null != t), e(null != r), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a) o += r[n + a] << 8 * a;
        t.Ra = o, t.bb = i, t.oa = r, t.pa = n;
      }
      function b(t) {
        for (; 8 <= t.u && t.bb < t.Sb;) t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << Ur - 8 >>> 0, ++t.bb, t.u -= 8;
        A(t) && (t.h = 1, t.u = 0);
      }
      function y(t, r) {
        if (e(0 <= r), !t.h && r <= Tr) {
          var n = L(t) & Rr[r];
          return t.u += r, b(t), n;
        }
        return t.h = 1, t.u = 0;
      }
      function w() {
        this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
      }
      function N() {
        this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
      }
      function L(t) {
        return t.Ra >>> (t.u & Ur - 1) >>> 0;
      }
      function A(t) {
        return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > Ur;
      }
      function x(t, e) {
        t.u = e, t.h = A(t);
      }
      function S(t) {
        t.u >= zr && (e(t.u >= zr), b(t));
      }
      function _(t) {
        e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
      }
      function P(t) {
        return g(t, 1);
      }
      function k(t, e) {
        var r = t.Ca;
        0 > t.b && _(t);
        var n = t.b,
          i = r * e >>> 8,
          a = (t.I >>> n > i) + 0;
        for (a ? (r -= i, t.I -= i + 1 << n >>> 0) : r = i + 1, n = r, i = 0; 256 <= n;) i += 8, n >>= 8;
        return n = 7 ^ i + Hr[n], t.b -= n, t.Ca = (r << n) - 1, a;
      }
      function F(t, e, r) {
        t[e + 0] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = r >> 0 & 255;
      }
      function I(t, e) {
        return t[e + 0] << 0 | t[e + 1] << 8;
      }
      function C(t, e) {
        return I(t, e) | t[e + 2] << 16;
      }
      function j(t, e) {
        return I(t, e) | I(t, e + 2) << 16;
      }
      function O(t, r) {
        var n = 1 << r;
        return e(null != t), e(0 < r), t.X = a(n), null == t.X ? 0 : (t.Mb = 32 - r, t.Xa = r, 1);
      }
      function B(t, r) {
        e(null != t), e(null != r), e(t.Xa == r.Xa), n(r.X, 0, t.X, 0, 1 << r.Xa);
      }
      function M() {
        this.X = [], this.Xa = this.Mb = 0;
      }
      function E(t, r, n, i) {
        e(null != n), e(null != i);
        var a = n[0],
          o = i[0];
        return 0 == a && (a = (t * o + r / 2) / r), 0 == o && (o = (r * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (n[0] = a, i[0] = o, 1);
      }
      function q(t, e) {
        return t + (1 << e) - 1 >>> e;
      }
      function D(t, e) {
        return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
      }
      function R(e, r) {
        t[r] = function (r, n, i, a, o, s, c) {
          var u;
          for (u = 0; u < o; ++u) {
            var h = t[e](s[c + u - 1], i, a + u);
            s[c + u] = D(r[n + u], h);
          }
        };
      }
      function T() {
        this.ud = this.hd = this.jd = 0;
      }
      function U(t, e) {
        return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
      }
      function z(t) {
        return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
      }
      function H(t, e) {
        return z(t + (t - e + .5 >> 1));
      }
      function W(t, e, r) {
        return Math.abs(e - r) - Math.abs(t - r);
      }
      function V(t, e, r, n, i, a, o) {
        for (n = a[o - 1], r = 0; r < i; ++r) a[o + r] = n = D(t[e + r], n);
      }
      function G(t, e, r, n, i) {
        var a;
        for (a = 0; a < r; ++a) {
          var o = t[e + a],
            s = o >> 8 & 255,
            c = 16711935 & (c = (c = 16711935 & o) + ((s << 16) + s));
          n[i + a] = (4278255360 & o) + c >>> 0;
        }
      }
      function Y(t, e) {
        e.jd = t >> 0 & 255, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
      }
      function J(t, e, r, n, i, a) {
        var o;
        for (o = 0; o < n; ++o) {
          var s = e[r + o],
            c = s >>> 8,
            u = s,
            h = 255 & (h = (h = s >>> 16) + ((t.jd << 24 >> 24) * (c << 24 >> 24) >>> 5));
          u = 255 & (u = (u = u + ((t.hd << 24 >> 24) * (c << 24 >> 24) >>> 5)) + ((t.ud << 24 >> 24) * (h << 24 >> 24) >>> 5));
          i[a + o] = (4278255360 & s) + (h << 16) + u;
        }
      }
      function X(e, r, n, i, a) {
        t[r] = function (t, e, r, n, o, s, c, u, h) {
          for (n = c; n < u; ++n) for (c = 0; c < h; ++c) o[s++] = a(r[i(t[e++])]);
        }, t[e] = function (e, r, o, s, c, u, h) {
          var l = 8 >> e.b,
            f = e.Ea,
            d = e.K[0],
            p = e.w;
          if (8 > l) for (e = (1 << e.b) - 1, p = (1 << l) - 1; r < o; ++r) {
            var g,
              m = 0;
            for (g = 0; g < f; ++g) g & e || (m = i(s[c++])), u[h++] = a(d[m & p]), m >>= l;
          } else t["VP8LMapColor" + n](s, c, d, p, u, h, r, o, f);
        };
      }
      function K(t, e, r, n, i) {
        for (r = e + r; e < r;) {
          var a = t[e++];
          n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255;
        }
      }
      function Z(t, e, r, n, i) {
        for (r = e + r; e < r;) {
          var a = t[e++];
          n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255, n[i++] = a >> 24 & 255;
        }
      }
      function $(t, e, r, n, i) {
        for (r = e + r; e < r;) {
          var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15,
            o = o >> 0 & 240 | o >> 28 & 15;
          n[i++] = a, n[i++] = o;
        }
      }
      function Q(t, e, r, n, i) {
        for (r = e + r; e < r;) {
          var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7,
            o = o >> 5 & 224 | o >> 3 & 31;
          n[i++] = a, n[i++] = o;
        }
      }
      function tt(t, e, r, n, i) {
        for (r = e + r; e < r;) {
          var a = t[e++];
          n[i++] = a >> 0 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 16 & 255;
        }
      }
      function et(t, e, r, i, a, o) {
        if (0 == o) for (r = e + r; e < r;) F(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;else n(i, a, t, e, r);
      }
      function rt(e, r) {
        t[r][0] = t[e + "0"], t[r][1] = t[e + "1"], t[r][2] = t[e + "2"], t[r][3] = t[e + "3"], t[r][4] = t[e + "4"], t[r][5] = t[e + "5"], t[r][6] = t[e + "6"], t[r][7] = t[e + "7"], t[r][8] = t[e + "8"], t[r][9] = t[e + "9"], t[r][10] = t[e + "10"], t[r][11] = t[e + "11"], t[r][12] = t[e + "12"], t[r][13] = t[e + "13"], t[r][14] = t[e + "0"], t[r][15] = t[e + "0"];
      }
      function nt(t) {
        return t == Hn || t == Wn || t == Vn || t == Gn;
      }
      function it() {
        this.eb = [], this.size = this.A = this.fb = 0;
      }
      function at() {
        this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
      }
      function ot() {
        this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it(), this.f.kb = new at(), this.sd = null;
      }
      function st() {
        this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
      }
      function ct() {
        this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
      }
      function ut(t) {
        return alert("todo:WebPSamplerProcessPlane"), t.T;
      }
      function ht(t, e) {
        var r = t.T,
          i = e.ba.f.RGBA,
          a = i.eb,
          o = i.fb + t.ka * i.A,
          s = vi[e.ba.S],
          c = t.y,
          u = t.O,
          h = t.f,
          l = t.N,
          f = t.ea,
          d = t.W,
          p = e.cc,
          g = e.dc,
          m = e.Mc,
          v = e.Nc,
          b = t.ka,
          y = t.ka + t.T,
          w = t.U,
          N = w + 1 >> 1;
        for (0 == b ? s(c, u, null, null, h, l, f, d, h, l, f, d, a, o, null, null, w) : (s(e.ec, e.fc, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w), ++r); b + 2 < y; b += 2) p = h, g = l, m = f, v = d, l += t.Rc, d += t.Rc, o += 2 * i.A, s(c, (u += 2 * t.fa) - t.fa, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w);
        return u += t.fa, t.j + y < t.o ? (n(e.ec, e.fc, c, u, w), n(e.cc, e.dc, h, l, N), n(e.Mc, e.Nc, f, d, N), r--) : 1 & y || s(c, u, null, null, h, l, f, d, h, l, f, d, a, o + i.A, null, null, w), r;
      }
      function lt(t, r, n) {
        var i = t.F,
          a = [t.J];
        if (null != i) {
          var o = t.U,
            s = r.ba.S,
            c = s == Tn || s == Vn;
          r = r.ba.f.RGBA;
          var u = [0],
            h = t.ka;
          u[0] = t.T, t.Kb && (0 == h ? --u[0] : (--h, a[0] -= t.width), t.j + t.ka + t.T == t.o && (u[0] = t.o - t.j - h));
          var l = r.eb;
          h = r.fb + h * r.A;
          t = Sn(i, a[0], t.width, o, u, l, h + (c ? 0 : 3), r.A), e(n == u), t && nt(s) && An(l, h, c, o, u, r.A);
        }
        return 0;
      }
      function ft(t) {
        var e = t.ma,
          r = e.ba.S,
          n = 11 > r,
          i = r == qn || r == Rn || r == Tn || r == Un || 12 == r || nt(r);
        if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mr(e.Oa, t, i ? 11 : 12)) return 0;
        if (i && nt(r) && br(), t.da) alert("todo:use_scaling");else {
          if (n) {
            if (e.Ib = ut, t.Kb) {
              if (r = t.U + 1 >> 1, e.memory = a(t.U + 2 * r), null == e.memory) return 0;
              e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + r, e.Ib = ht, br();
            }
          } else alert("todo:EmitYUV");
          i && (e.Jb = lt, n && mr());
        }
        if (n && !Ci) {
          for (t = 0; 256 > t; ++t) ji[t] = 89858 * (t - 128) + _i >> Si, Mi[t] = -22014 * (t - 128) + _i, Bi[t] = -45773 * (t - 128), Oi[t] = 113618 * (t - 128) + _i >> Si;
          for (t = Pi; t < ki; ++t) e = 76283 * (t - 16) + _i >> Si, Ei[t - Pi] = Vt(e, 255), qi[t - Pi] = Vt(e + 8 >> 4, 15);
          Ci = 1;
        }
        return 1;
      }
      function dt(t) {
        var r = t.ma,
          n = t.U,
          i = t.T;
        return e(!(1 & t.ka)), 0 >= n || 0 >= i ? 0 : (n = r.Ib(t, r), null != r.Jb && r.Jb(t, r, n), r.Dc += n, 1);
      }
      function pt(t) {
        t.ma.memory = null;
      }
      function gt(t, e, r, n) {
        return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, r[0] = y(t, 14) + 1, n[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
      }
      function mt(t, e) {
        if (4 > t) return t + 1;
        var r = t - 2 >> 1;
        return (2 + (1 & t) << r) + y(e, r) + 1;
      }
      function vt(t, e) {
        return 120 < e ? e - 120 : 1 <= (r = ((r = $n[e - 1]) >> 4) * t + (8 - (15 & r))) ? r : 1;
        var r;
      }
      function bt(t, e, r) {
        var n = L(r),
          i = t[e += 255 & n].g - 8;
        return 0 < i && (x(r, r.u + 8), n = L(r), e += t[e].value, e += n & (1 << i) - 1), x(r, r.u + t[e].g), t[e].value;
      }
      function yt(t, r, n) {
        return n.g += t.g, n.value += t.value << r >>> 0, e(8 >= n.g), t.g;
      }
      function wt(t, r, n) {
        var i = t.xc;
        return e((r = 0 == i ? 0 : t.vc[t.md * (n >> i) + (r >> i)]) < t.Wb), t.Ya[r];
      }
      function Nt(t, r, i, a) {
        var o = t.ab,
          s = t.c * r,
          c = t.C;
        r = c + r;
        var u = i,
          h = a;
        for (a = t.Ta, i = t.Ua; 0 < o--;) {
          var l = t.gc[o],
            f = c,
            d = r,
            p = u,
            g = h,
            m = (h = a, u = i, l.Ea);
          switch (e(f < d), e(d <= l.nc), l.hc) {
            case 2:
              Gr(p, g, (d - f) * m, h, u);
              break;
            case 0:
              var v = f,
                b = d,
                y = h,
                w = u,
                N = (_ = l).Ea;
              0 == v && (Wr(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
              for (var L = 1 << _.b, A = L - 1, x = q(N, _.b), S = _.K, _ = _.w + (v >> _.b) * x; v < b;) {
                var P = S,
                  k = _,
                  F = 1;
                for (Vr(p, g, y, w - N, 1, y, w); F < N;) {
                  var I = (F & ~A) + L;
                  I > N && (I = N), (0, Zr[P[k++] >> 8 & 15])(p, g + +F, y, w + F - N, I - F, y, w + F), F = I;
                }
                g += N, w += N, ++v & A || (_ += x);
              }
              d != l.nc && n(h, u - m, h, u + (d - f - 1) * m, m);
              break;
            case 1:
              for (m = p, b = g, N = (p = l.Ea) - (w = p & ~(y = (g = 1 << l.b) - 1)), v = q(p, l.b), L = l.K, l = l.w + (f >> l.b) * v; f < d;) {
                for (A = L, x = l, S = new T(), _ = b + w, P = b + p; b < _;) Y(A[x++], S), $r(S, m, b, g, h, u), b += g, u += g;
                b < P && (Y(A[x++], S), $r(S, m, b, N, h, u), b += N, u += N), ++f & y || (l += v);
              }
              break;
            case 3:
              if (p == h && g == u && 0 < l.b) {
                for (b = h, p = m = u + (d - f) * m - (w = (d - f) * q(l.Ea, l.b)), g = h, y = u, v = [], w = (N = w) - 1; 0 <= w; --w) v[w] = g[y + w];
                for (w = N - 1; 0 <= w; --w) b[p + w] = v[w];
                Yr(l, f, d, h, m, h, u);
              } else Yr(l, f, d, p, g, h, u);
          }
          u = a, h = i;
        }
        h != i && n(a, i, u, h, s);
      }
      function Lt(t, r) {
        var n = t.V,
          i = t.Ba + t.c * t.C,
          a = r - t.C;
        if (e(r <= t.l.o), e(16 >= a), 0 < a) {
          var o = t.l,
            s = t.Ta,
            c = t.Ua,
            u = o.width;
          if (Nt(t, a, n, i), a = c = [c], e((n = t.C) < (i = r)), e(o.v < o.va), i > o.o && (i = o.o), n < o.j) {
            var h = o.j - n;
            n = o.j;
            a[0] += h * u;
          }
          if (n >= i ? n = 0 : (a[0] += 4 * o.v, o.ka = n - o.j, o.U = o.va - o.v, o.T = i - n, n = 1), n) {
            if (c = c[0], 11 > (n = t.ca).S) {
              var l = n.f.RGBA,
                f = (i = n.S, a = o.U, o = o.T, h = l.eb, l.A),
                d = o;
              for (l = l.fb + t.Ma * l.A; 0 < d--;) {
                var p = s,
                  g = c,
                  m = a,
                  v = h,
                  b = l;
                switch (i) {
                  case En:
                    Qr(p, g, m, v, b);
                    break;
                  case qn:
                    tn(p, g, m, v, b);
                    break;
                  case Hn:
                    tn(p, g, m, v, b), An(v, b, 0, m, 1, 0);
                    break;
                  case Dn:
                    nn(p, g, m, v, b);
                    break;
                  case Rn:
                    et(p, g, m, v, b, 1);
                    break;
                  case Wn:
                    et(p, g, m, v, b, 1), An(v, b, 0, m, 1, 0);
                    break;
                  case Tn:
                    et(p, g, m, v, b, 0);
                    break;
                  case Vn:
                    et(p, g, m, v, b, 0), An(v, b, 1, m, 1, 0);
                    break;
                  case Un:
                    en(p, g, m, v, b);
                    break;
                  case Gn:
                    en(p, g, m, v, b), xn(v, b, m, 1, 0);
                    break;
                  case zn:
                    rn(p, g, m, v, b);
                    break;
                  default:
                    e(0);
                }
                c += u, l += f;
              }
              t.Ma += o;
            } else alert("todo:EmitRescaledRowsYUVA");
            e(t.Ma <= n.height);
          }
        }
        t.C = r, e(t.C <= t.i);
      }
      function At(t) {
        var e;
        if (0 < t.ua) return 0;
        for (e = 0; e < t.Wb; ++e) {
          var r = t.Ya[e].G,
            n = t.Ya[e].H;
          if (0 < r[1][n[1] + 0].g || 0 < r[2][n[2] + 0].g || 0 < r[3][n[3] + 0].g) return 0;
        }
        return 1;
      }
      function xt(t, r, n, i, a, o) {
        if (0 != t.Z) {
          var s = t.qd,
            c = t.rd;
          for (e(null != mi[t.Z]); r < n; ++r) mi[t.Z](s, c, i, a, i, a, o), s = i, c = a, a += o;
          t.qd = s, t.rd = c;
        }
      }
      function St(t, r) {
        var n = t.l.ma,
          i = 0 == n.Z || 1 == n.Z ? t.l.j : t.C;
        i = t.C < i ? i : t.C;
        if (e(r <= t.l.o), r > i) {
          var a = t.l.width,
            o = n.ca,
            s = n.tb + a * i,
            c = t.V,
            u = t.Ba + t.c * i,
            h = t.gc;
          e(1 == t.ab), e(3 == h[0].hc), Xr(h[0], i, r, c, u, o, s), xt(n, i, r, o, s, a);
        }
        t.C = t.Ma = r;
      }
      function _t(t, r, n, i, a, o, s) {
        var c = t.$ / i,
          u = t.$ % i,
          h = t.m,
          l = t.s,
          f = n + t.$,
          d = f;
        a = n + i * a;
        var p = n + i * o,
          g = 280 + l.ua,
          m = t.Pb ? c : 16777216,
          v = 0 < l.ua ? l.Wa : null,
          b = l.wc,
          y = f < p ? wt(l, u, c) : null;
        e(t.C < o), e(p <= a);
        var w = !1;
        t: for (;;) {
          for (; w || f < p;) {
            var N = 0;
            if (c >= m) {
              var _ = f - n;
              e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = c + ti;
            }
            if (u & b || (y = wt(l, u, c)), e(null != y), y.Qb && (r[f] = y.qb, w = !0), !w) if (S(h), y.jc) {
              N = h, _ = r;
              var P = f,
                k = y.pd[L(N) & Dr - 1];
              e(y.jc), 256 > k.g ? (x(N, N.u + k.g), _[P] = k.value, N = 0) : (x(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
            } else N = bt(y.G[0], y.H[0], h);
            if (h.h) break;
            if (w || 256 > N) {
              if (!w) if (y.nd) r[f] = (y.qb | N << 8) >>> 0;else {
                if (S(h), w = bt(y.G[1], y.H[1], h), S(h), _ = bt(y.G[2], y.H[2], h), P = bt(y.G[3], y.H[3], h), h.h) break;
                r[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
              }
              if (w = !1, ++f, ++u >= i && (u = 0, ++c, null != s && c <= o && !(c % 16) && s(t, c), null != v)) for (; d < f;) N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
            } else if (280 > N) {
              if (N = mt(N - 256, h), _ = bt(y.G[4], y.H[4], h), S(h), _ = vt(i, _ = mt(_, h)), h.h) break;
              if (f - n < _ || a - f < N) break t;
              for (P = 0; P < N; ++P) r[f + P] = r[f + P - _];
              for (f += N, u += N; u >= i;) u -= i, ++c, null != s && c <= o && !(c % 16) && s(t, c);
              if (e(f <= a), u & b && (y = wt(l, u, c)), null != v) for (; d < f;) N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
            } else {
              if (!(N < g)) break t;
              for (w = N - 280, e(null != v); d < f;) N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
              N = f, e(!(w >>> (_ = v).Xa)), r[N] = _.X[w], w = !0;
            }
            w || e(h.h == A(h));
          }
          if (t.Pb && h.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);else {
            if (h.h) break t;
            null != s && s(t, c > o ? o : c), t.a = 0, t.$ = f - n;
          }
          return 1;
        }
        return t.a = 3, 0;
      }
      function Pt(t) {
        e(null != t), t.vc = null, t.yc = null, t.Ya = null;
        var r = t.Wa;
        null != r && (r.X = null), t.vb = null, e(null != t);
      }
      function kt() {
        var e = new or();
        return null == e ? null : (e.a = 0, e.xb = gi, rt("Predictor", "VP8LPredictors"), rt("Predictor", "VP8LPredictors_C"), rt("PredictorAdd", "VP8LPredictorsAdd"), rt("PredictorAdd", "VP8LPredictorsAdd_C"), Gr = G, $r = J, Qr = K, tn = Z, en = $, rn = Q, nn = tt, t.VP8LMapColor32b = Jr, t.VP8LMapColor8b = Kr, e);
      }
      function Ft(t, r, n, s, c) {
        var u = 1,
          f = [t],
          p = [r],
          g = s.m,
          m = s.s,
          v = null,
          b = 0;
        t: for (;;) {
          if (n) for (; u && y(g, 1);) {
            var w = f,
              N = p,
              A = s,
              _ = 1,
              P = A.m,
              k = A.gc[A.ab],
              F = y(P, 2);
            if (A.Oc & 1 << F) u = 0;else {
              switch (A.Oc |= 1 << F, k.hc = F, k.Ea = w[0], k.nc = N[0], k.K = [null], ++A.ab, e(4 >= A.ab), F) {
                case 0:
                case 1:
                  k.b = y(P, 3) + 2, _ = Ft(q(k.Ea, k.b), q(k.nc, k.b), 0, A, k.K), k.K = k.K[0];
                  break;
                case 3:
                  var I,
                    C = y(P, 8) + 1,
                    j = 16 < C ? 0 : 4 < C ? 1 : 2 < C ? 2 : 3;
                  if (w[0] = q(k.Ea, j), k.b = j, I = _ = Ft(C, 1, 0, A, k.K)) {
                    var B,
                      M = C,
                      E = k,
                      R = 1 << (8 >> E.b),
                      T = a(R);
                    if (null == T) I = 0;else {
                      var U = E.K[0],
                        z = E.w;
                      for (T[0] = E.K[0][0], B = 1; B < 1 * M; ++B) T[B] = D(U[z + B], T[B - 1]);
                      for (; B < 4 * R; ++B) T[B] = 0;
                      E.K[0] = null, E.K[0] = T, I = 1;
                    }
                  }
                  _ = I;
                  break;
                case 2:
                  break;
                default:
                  e(0);
              }
              u = _;
            }
          }
          if (f = f[0], p = p[0], u && y(g, 1) && !(u = 1 <= (b = y(g, 4)) && 11 >= b)) {
            s.a = 3;
            break t;
          }
          var H;
          if (H = u) e: {
            var W,
              V,
              G,
              Y = s,
              J = f,
              X = p,
              K = b,
              Z = n,
              $ = Y.m,
              Q = Y.s,
              tt = [null],
              et = 1,
              rt = 0,
              nt = Qn[K];
            r: for (;;) {
              if (Z && y($, 1)) {
                var it = y($, 3) + 2,
                  at = q(J, it),
                  ot = q(X, it),
                  st = at * ot;
                if (!Ft(at, ot, 0, Y, tt)) break r;
                for (tt = tt[0], Q.xc = it, W = 0; W < st; ++W) {
                  var ct = tt[W] >> 8 & 65535;
                  tt[W] = ct, ct >= et && (et = ct + 1);
                }
              }
              if ($.h) break r;
              for (V = 0; 5 > V; ++V) {
                var ut = Xn[V];
                !V && 0 < K && (ut += 1 << K), rt < ut && (rt = ut);
              }
              var ht = o(et * nt, l),
                lt = et,
                ft = o(lt, d);
              if (null == ft) var dt = null;else e(65536 >= lt), dt = ft;
              var pt = a(rt);
              if (null == dt || null == pt || null == ht) {
                Y.a = 1;
                break r;
              }
              var gt = ht;
              for (W = G = 0; W < et; ++W) {
                var mt = dt[W],
                  vt = mt.G,
                  bt = mt.H,
                  wt = 0,
                  Nt = 1,
                  Lt = 0;
                for (V = 0; 5 > V; ++V) {
                  ut = Xn[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ut += 1 << K);
                  n: {
                    var At,
                      xt = ut,
                      St = Y,
                      kt = pt,
                      It = gt,
                      Ct = G,
                      jt = 0,
                      Ot = St.m,
                      Bt = y(Ot, 1);
                    if (i(kt, 0, 0, xt), Bt) {
                      var Mt = y(Ot, 1) + 1,
                        Et = y(Ot, 1),
                        qt = y(Ot, 0 == Et ? 1 : 8);
                      kt[qt] = 1, 2 == Mt && (kt[qt = y(Ot, 8)] = 1);
                      var Dt = 1;
                    } else {
                      var Rt = a(19),
                        Tt = y(Ot, 4) + 4;
                      if (19 < Tt) {
                        St.a = 3;
                        var Ut = 0;
                        break n;
                      }
                      for (At = 0; At < Tt; ++At) Rt[Zn[At]] = y(Ot, 3);
                      var zt = void 0,
                        Ht = void 0,
                        Wt = St,
                        Vt = Rt,
                        Gt = xt,
                        Yt = kt,
                        Jt = 0,
                        Xt = Wt.m,
                        Kt = 8,
                        Zt = o(128, l);
                      i: for (; h(Zt, 0, 7, Vt, 19);) {
                        if (y(Xt, 1)) {
                          var $t = 2 + 2 * y(Xt, 3);
                          if ((zt = 2 + y(Xt, $t)) > Gt) break i;
                        } else zt = Gt;
                        for (Ht = 0; Ht < Gt && zt--;) {
                          S(Xt);
                          var Qt = Zt[0 + (127 & L(Xt))];
                          x(Xt, Xt.u + Qt.g);
                          var te = Qt.value;
                          if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);else {
                            var ee = 16 == te,
                              re = te - 16,
                              ne = Jn[re],
                              ie = y(Xt, Yn[re]) + ne;
                            if (Ht + ie > Gt) break i;
                            for (var ae = ee ? Kt : 0; 0 < ie--;) Yt[Ht++] = ae;
                          }
                        }
                        Jt = 1;
                        break i;
                      }
                      Jt || (Wt.a = 3), Dt = Jt;
                    }
                    (Dt = Dt && !Ot.h) && (jt = h(It, Ct, 8, kt, xt)), Dt && 0 != jt ? Ut = jt : (St.a = 3, Ut = 0);
                  }
                  if (0 == Ut) break r;
                  if (Nt && 1 == Kn[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += Ut, 3 >= V) {
                    var oe,
                      se = pt[0];
                    for (oe = 1; oe < ut; ++oe) pt[oe] > se && (se = pt[oe]);
                    Lt += se;
                  }
                }
                if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                  var ce,
                    ue = mt;
                  for (ce = 0; ce < Dr; ++ce) {
                    var he = ce,
                      le = ue.pd[he],
                      fe = ue.G[0][ue.H[0] + he];
                    256 <= fe.value ? (le.g = fe.g + 256, le.value = fe.value) : (le.g = 0, le.value = 0, he >>= yt(fe, 8, le), he >>= yt(ue.G[1][ue.H[1] + he], 16, le), he >>= yt(ue.G[2][ue.H[2] + he], 0, le), yt(ue.G[3][ue.H[3] + he], 24, le));
                  }
                }
              }
              Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = ht, H = 1;
              break e;
            }
            H = 0;
          }
          if (!(u = H)) {
            s.a = 3;
            break t;
          }
          if (0 < b) {
            if (m.ua = 1 << b, !O(m.Wa, b)) {
              s.a = 1, u = 0;
              break t;
            }
          } else m.ua = 0;
          var de = s,
            pe = f,
            ge = p,
            me = de.s,
            ve = me.xc;
          if (de.c = pe, de.i = ge, me.md = q(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, n) {
            s.xb = pi;
            break t;
          }
          if (null == (v = a(f * p))) {
            s.a = 1, u = 0;
            break t;
          }
          u = (u = _t(s, v, 0, f, p, p, null)) && !g.h;
          break t;
        }
        return u ? (null != c ? c[0] = v : (e(null == v), e(n)), s.$ = 0, n || Pt(m)) : Pt(m), u;
      }
      function It(t, r) {
        var n = t.c * t.i,
          i = n + r + 16 * r;
        return e(t.c <= r), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + n + r, 1);
      }
      function Ct(t, r) {
        var n = t.C,
          i = r - n,
          a = t.V,
          o = t.Ba + t.c * n;
        for (e(r <= t.l.o); 0 < i;) {
          var s = 16 < i ? 16 : i,
            c = t.l.ma,
            u = t.l.width,
            h = u * s,
            l = c.ca,
            f = c.tb + u * n,
            d = t.Ta,
            p = t.Ua;
          Nt(t, s, a, o), _n(d, p, l, f, h), xt(c, n, n + s, l, f, u), i -= s, a += s * t.c, n += s;
        }
        e(n == r), t.C = t.Ma = r;
      }
      function jt() {
        this.ub = this.yd = this.td = this.Rb = 0;
      }
      function Ot() {
        this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
      }
      function Bt() {
        this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
      }
      function Mt() {
        this.Yb = function () {
          var t = [];
          return function t(e, r, n) {
            for (var i = n[r], a = 0; a < i && (e.push(n.length > r + 1 ? [] : 0), !(n.length < r + 1)); a++) t(e[a], r + 1, n);
          }(t, 0, [3, 11]), t;
        }();
      }
      function Et() {
        this.jb = a(3), this.Wc = s([4, 8], Mt), this.Xc = s([4, 17], Mt);
      }
      function qt() {
        this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
      }
      function Dt() {
        this.ld = this.La = this.dd = this.tc = 0;
      }
      function Rt() {
        this.Na = this.la = 0;
      }
      function Tt() {
        this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
      }
      function Ut() {
        this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
      }
      function zt() {
        this.uc = this.M = this.Nb = 0, this.wa = Array(new Dt()), this.Y = 0, this.ya = Array(new Ut()), this.aa = 0, this.l = new Gt();
      }
      function Ht() {
        this.y = a(16), this.f = a(8), this.ea = a(8);
      }
      function Wt() {
        this.cb = this.a = 0, this.sc = "", this.m = new w(), this.Od = new jt(), this.Kc = new Ot(), this.ed = new qt(), this.Qa = new Bt(), this.Ic = this.$c = this.Aa = 0, this.D = new zt(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new Et(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new Ht()), this.Hd = 0, this.rb = Array(new Rt()), this.sb = 0, this.wa = Array(new Dt()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ut()), this.L = this.aa = 0, this.gd = s([4, 2], Dt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
      }
      function Vt(t, e) {
        return 0 > t ? 0 : t > e ? e : t;
      }
      function Gt() {
        this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
      }
      function Yt() {
        var t = new Wt();
        return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
      }
      function Jt(t, e, r) {
        return 0 == t.a && (t.a = e, t.sc = r, t.cb = 0), 0;
      }
      function Xt(t, e, r) {
        return 3 <= r && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
      }
      function Kt(t, r) {
        if (null == t) return 0;
        if (t.a = 0, t.sc = "OK", null == r) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
        var n = r.data,
          a = r.w,
          o = r.ha;
        if (4 > o) return Jt(t, 7, "Truncated header.");
        var s = n[a + 0] | n[a + 1] << 8 | n[a + 2] << 16,
          c = t.Od;
        if (c.Rb = !(1 & s), c.td = s >> 1 & 7, c.yd = s >> 4 & 1, c.ub = s >> 5, 3 < c.td) return Jt(t, 3, "Incorrect keyframe parameters.");
        if (!c.yd) return Jt(t, 4, "Frame not displayable.");
        a += 3, o -= 3;
        var u = t.Kc;
        if (c.Rb) {
          if (7 > o) return Jt(t, 7, "cannot parse picture header");
          if (!Xt(n, a, o)) return Jt(t, 3, "Bad code word");
          u.c = 16383 & (n[a + 4] << 8 | n[a + 3]), u.Td = n[a + 4] >> 6, u.i = 16383 & (n[a + 6] << 8 | n[a + 5]), u.Ud = n[a + 6] >> 6, a += 7, o -= 7, t.za = u.c + 15 >> 4, t.Ub = u.i + 15 >> 4, r.width = u.c, r.height = u.i, r.Da = 0, r.j = 0, r.v = 0, r.va = r.width, r.o = r.height, r.da = 0, r.ib = r.width, r.hb = r.height, r.U = r.width, r.T = r.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
        }
        if (c.ub > o) return Jt(t, 7, "bad partition length");
        p(s = t.m, n, a, c.ub), a += c.ub, o -= c.ub, c.Rb && (u.Ld = P(s), u.Kd = P(s)), u = t.Qa;
        var h,
          l = t.Pa;
        if (e(null != s), e(null != u), u.Cb = P(s), u.Cb) {
          if (u.Bb = P(s), P(s)) {
            for (u.Fb = P(s), h = 0; 4 > h; ++h) u.Zb[h] = P(s) ? m(s, 7) : 0;
            for (h = 0; 4 > h; ++h) u.Lb[h] = P(s) ? m(s, 6) : 0;
          }
          if (u.Bb) for (h = 0; 3 > h; ++h) l.jb[h] = P(s) ? g(s, 8) : 255;
        } else u.Bb = 0;
        if (s.Ka) return Jt(t, 3, "cannot parse segment header");
        if ((u = t.ed).zd = P(s), u.Tb = g(s, 6), u.wb = g(s, 3), u.Pc = P(s), u.Pc && P(s)) {
          for (l = 0; 4 > l; ++l) P(s) && (u.vd[l] = m(s, 6));
          for (l = 0; 4 > l; ++l) P(s) && (u.od[l] = m(s, 6));
        }
        if (t.L = 0 == u.Tb ? 0 : u.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
        var f = o;
        if (o = h = a, a = h + f, u = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (l = t.Xb)) n = 7;else {
          for (h += 3 * l, u -= 3 * l, f = 0; f < l; ++f) {
            var d = n[o + 0] | n[o + 1] << 8 | n[o + 2] << 16;
            d > u && (d = u), p(t.Jc[+f], n, h, d), h += d, u -= d, o += 3;
          }
          p(t.Jc[+l], n, h, u), n = h < a ? 0 : 5;
        }
        if (0 != n) return Jt(t, n, "cannot parse partitions");
        for (n = g(h = t.m, 7), o = P(h) ? m(h, 4) : 0, a = P(h) ? m(h, 4) : 0, u = P(h) ? m(h, 4) : 0, l = P(h) ? m(h, 4) : 0, h = P(h) ? m(h, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d) {
          if (f.Cb) {
            var v = f.Zb[d];
            f.Fb || (v += n);
          } else {
            if (0 < d) {
              t.pb[d] = t.pb[0];
              continue;
            }
            v = n;
          }
          var b = t.pb[d];
          b.Sc[0] = ei[Vt(v + o, 127)], b.Sc[1] = ri[Vt(v + 0, 127)], b.Eb[0] = 2 * ei[Vt(v + a, 127)], b.Eb[1] = 101581 * ri[Vt(v + u, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ei[Vt(v + l, 117)], b.Qc[1] = ri[Vt(v + h, 127)], b.lc = v + h;
        }
        if (!c.Rb) return Jt(t, 4, "Not a key frame.");
        for (P(s), c = t.Pa, n = 0; 4 > n; ++n) {
          for (o = 0; 8 > o; ++o) for (a = 0; 3 > a; ++a) for (u = 0; 11 > u; ++u) l = k(s, ui[n][o][a][u]) ? g(s, 8) : si[n][o][a][u], c.Wc[n][o].Yb[a][u] = l;
          for (o = 0; 17 > o; ++o) c.Xc[n][o] = c.Wc[n][hi[o]];
        }
        return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
      }
      function Zt(t, e, r, n, i, a, o) {
        var s = e[i].Yb[r];
        for (r = 0; 16 > i; ++i) {
          if (!k(t, s[r + 0])) return i;
          for (; !k(t, s[r + 1]);) if (s = e[++i].Yb[0], r = 0, 16 == i) return 16;
          var c = e[i + 1].Yb;
          if (k(t, s[r + 2])) {
            var u = t,
              h = 0;
            if (k(u, (f = s)[(l = r) + 3])) {
              if (k(u, f[l + 6])) {
                for (s = 0, l = 2 * (h = k(u, f[l + 8])) + (f = k(u, f[l + 9 + h])), h = 0, f = ii[l]; f[s]; ++s) h += h + k(u, f[s]);
                h += 3 + (8 << l);
              } else k(u, f[l + 7]) ? (h = 7 + 2 * k(u, 165), h += k(u, 145)) : h = 5 + k(u, 159);
            } else h = k(u, f[l + 4]) ? 3 + k(u, f[l + 5]) : 2;
            s = c[2];
          } else h = 1, s = c[1];
          c = o + ai[i], 0 > (u = t).b && _(u);
          var l,
            f = u.b,
            d = (l = u.Ca >> 1) - (u.I >> f) >> 31;
          --u.b, u.Ca += d, u.Ca |= 1, u.I -= (l + 1 & d) << f, a[c] = ((h ^ d) - d) * n[(0 < i) + 0];
        }
        return 16;
      }
      function $t(t) {
        var e = t.rb[t.sb - 1];
        e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
      }
      function Qt(t, r) {
        if (null == t) return 0;
        if (null == r) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
        if (!t.cb && !Kt(t, r)) return 0;
        if (e(t.cb), null == r.ac || r.ac(r)) {
          r.ob && (t.L = 0);
          var s = Ri[t.L];
          if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = r.v - s >> 4, t.zb = r.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = r.o + 15 + s >> 4, t.Hb = r.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
            var c = t.ed;
            for (s = 0; 4 > s; ++s) {
              var u;
              if (t.Qa.Cb) {
                var h = t.Qa.Lb[s];
                t.Qa.Fb || (h += c.Tb);
              } else h = c.Tb;
              for (u = 0; 1 >= u; ++u) {
                var l = t.gd[s][u],
                  f = h;
                if (c.Pc && (f += c.vd[0], u && (f += c.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                  var d = f;
                  0 < c.wb && (d = 4 < c.wb ? d >> 2 : d >> 1) > 9 - c.wb && (d = 9 - c.wb), 1 > d && (d = 1), l.dd = d, l.tc = 2 * f + d, l.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                } else l.tc = 0;
                l.La = u;
              }
            }
          }
          s = 0;
        } else Jt(t, 6, "Frame setup failed"), s = t.a;
        if (s = 0 == s) {
          if (s) {
            t.$c = 0, 0 < t.Aa || (t.Ic = Ui);
            t: {
              s = t.Ic;
              c = 4 * (d = t.za);
              var p = 32 * d,
                g = d + 1,
                m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0,
                v = (2 == t.Aa ? 2 : 1) * d;
              if ((l = c + 832 + (u = 3 * (16 * s + Ri[t.L]) / 2 * p) + (h = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != l) s = 0;else {
                if (l > t.Vb) {
                  if (t.Vb = 0, t.Ec = a(l), t.Fc = 0, null == t.Ec) {
                    s = Jt(t, 1, "no memory during frame initialization.");
                    break t;
                  }
                  t.Vb = l;
                }
                l = t.Ec, f = t.Fc, t.Ac = l, t.Bc = f, f += c, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Rt), t.sb = 1, t.wa = m ? o(m, Dt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = l, t.pc = f, f += 832, t.ya = o(v, Ut), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = l, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += u, t.mb = h ? l : null, t.nb = h ? f : null, e(f + h <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, c), s = 1;
              }
            }
            if (s) {
              if (r.ka = 0, r.y = t.sa, r.O = t.ta, r.f = t.qa, r.N = t.ra, r.ea = t.Ha, r.Vd = t.Ia, r.fa = t.R, r.Rc = t.B, r.F = null, r.J = 0, !Cn) {
                for (s = -255; 255 >= s; ++s) Pn[255 + s] = 0 > s ? -s : s;
                for (s = -1020; 1020 >= s; ++s) kn[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                for (s = -112; 112 >= s; ++s) Fn[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                for (s = -255; 510 >= s; ++s) In[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                Cn = 1;
              }
              an = ue, on = ae, cn = oe, un = se, hn = ce, sn = ie, ln = Je, fn = Xe, dn = $e, pn = Qe, gn = Ke, mn = Ze, vn = tr, bn = er, yn = ze, wn = He, Nn = We, Ln = Ve, fi[0] = xe, fi[1] = le, fi[2] = Le, fi[3] = Ae, fi[4] = Se, fi[5] = Pe, fi[6] = _e, fi[7] = ke, fi[8] = Ie, fi[9] = Fe, li[0] = ve, li[1] = de, li[2] = pe, li[3] = ge, li[4] = be, li[5] = ye, li[6] = we, di[0] = Be, di[1] = fe, di[2] = Ce, di[3] = je, di[4] = Ee, di[5] = Me, di[6] = qe, s = 1;
            } else s = 0;
          }
          s && (s = function (t, r) {
            for (t.M = 0; t.M < t.Va; ++t.M) {
              var o,
                s = t.Jc[t.M & t.Xb],
                c = t.m,
                u = t;
              for (o = 0; o < u.za; ++o) {
                var h = c,
                  l = u,
                  f = l.Ac,
                  d = l.Bc + 4 * o,
                  p = l.zc,
                  g = l.ya[l.aa + o];
                if (l.Qa.Bb ? g.$b = k(h, l.Pa.jb[0]) ? 2 + k(h, l.Pa.jb[2]) : k(h, l.Pa.jb[1]) : g.$b = 0, l.kc && (g.Ad = k(h, l.Bd)), g.Za = !k(h, 145) + 0, g.Za) {
                  var m = g.Ob,
                    v = 0;
                  for (l = 0; 4 > l; ++l) {
                    var b,
                      y = p[0 + l];
                    for (b = 0; 4 > b; ++b) {
                      y = ci[f[d + b]][y];
                      for (var w = oi[k(h, y[0])]; 0 < w;) w = oi[2 * w + k(h, y[w])];
                      y = -w, f[d + b] = y;
                    }
                    n(m, v, f, d, 4), v += 4, p[0 + l] = y;
                  }
                } else y = k(h, 156) ? k(h, 128) ? 1 : 3 : k(h, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                g.Dd = k(h, 142) ? k(h, 114) ? k(h, 183) ? 1 : 3 : 2 : 0;
              }
              if (u.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
              for (; t.ja < t.za; ++t.ja) {
                if (u = s, h = (c = t).rb[c.sb - 1], f = c.rb[c.sb + c.ja], o = c.ya[c.aa + c.ja], d = c.kc ? o.Ad : 0) h.la = f.la = 0, o.Za || (h.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;else {
                  var N, L;
                  h = f, f = u, d = c.Pa.Xc, p = c.ya[c.aa + c.ja], g = c.pb[p.$b];
                  if (l = p.ad, m = 0, v = c.rb[c.sb - 1], y = b = 0, i(l, m, 0, 384), p.Za) var A = 0,
                    x = d[3];else {
                    w = a(16);
                    var S = h.Na + v.Na;
                    if (S = ni(f, d[1], S, g.Eb, 0, w, 0), h.Na = v.Na = (0 < S) + 0, 1 < S) an(w, 0, l, m);else {
                      var _ = w[0] + 3 >> 3;
                      for (w = 0; 256 > w; w += 16) l[m + w] = _;
                    }
                    A = 1, x = d[0];
                  }
                  var P = 15 & h.la,
                    F = 15 & v.la;
                  for (w = 0; 4 > w; ++w) {
                    var I = 1 & F;
                    for (_ = L = 0; 4 > _; ++_) P = P >> 1 | (I = (S = ni(f, x, S = I + (1 & P), g.Sc, A, l, m)) > A) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                    P >>= 4, F = F >> 1 | I << 7, b = (b << 8 | L) >>> 0;
                  }
                  for (x = P, A = F >> 4, N = 0; 4 > N; N += 2) {
                    for (L = 0, P = h.la >> 4 + N, F = v.la >> 4 + N, w = 0; 2 > w; ++w) {
                      for (I = 1 & F, _ = 0; 2 > _; ++_) S = I + (1 & P), P = P >> 1 | (I = 0 < (S = ni(f, d[2], S, g.Qc, 0, l, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                      P >>= 2, F = F >> 1 | I << 5;
                    }
                    y |= L << 4 * N, x |= P << 4 << N, A |= (240 & F) << N;
                  }
                  h.la = x, v.la = A, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                }
                if (0 < c.L && (c.wa[c.Y + c.ja] = c.gd[o.$b][o.Za], c.wa[c.Y + c.ja].La |= !d), u.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
              }
              if ($t(t), c = r, u = 1, o = (s = t).D, h = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) t: {
                if (o.M = s.M, o.uc = h, Or(s, o), u = 1, o = (L = s.D).Nb, h = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - h + w, g = s.qa, l = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, F = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && Or(s, L), L.uc) for (I = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L) {
                  A = L, x = I;
                  var C = (j = (U = S).D).Nb;
                  N = U.R;
                  var j = j.wa[j.Y + A],
                    O = U.sa,
                    B = U.ta + 16 * C * N + 16 * A,
                    M = j.dd,
                    E = j.tc;
                  if (0 != E) if (e(3 <= E), 1 == U.L) 0 < A && wn(O, B, N, E + 4), j.La && Ln(O, B, N, E), 0 < x && yn(O, B, N, E + 4), j.La && Nn(O, B, N, E);else {
                    var q = U.B,
                      D = U.qa,
                      R = U.ra + 8 * C * q + 8 * A,
                      T = U.Ha,
                      U = U.Ia + 8 * C * q + 8 * A;
                    C = j.ld;
                    0 < A && (fn(O, B, N, E + 4, M, C), pn(D, R, T, U, q, E + 4, M, C)), j.La && (mn(O, B, N, E, M, C), bn(D, R, T, U, q, E, M, C)), 0 < x && (ln(O, B, N, E + 4, M, C), dn(D, R, T, U, q, E + 4, M, C)), j.La && (gn(O, B, N, E, M, C), vn(D, R, T, U, q, E, M, C));
                  }
                }
                if (s.ia && alert("todo:DitherRow"), null != c.put) {
                  if (L = 16 * P, P = 16 * (P + 1), F ? (c.y = s.sa, c.O = s.ta + w, c.f = s.qa, c.N = s.ra + _, c.ea = s.Ha, c.W = s.Ia + _) : (L -= y, c.y = d, c.O = p, c.f = g, c.N = l, c.ea = m, c.W = v), b || (P -= y), P > c.o && (P = c.o), c.F = null, c.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (c.J = lr(s, c, L, P - L), c.F = s.mb, null == c.F && 0 == c.F.length)) {
                    u = Jt(s, 3, "Could not decode alpha data.");
                    break t;
                  }
                  L < c.j && (y = c.j - L, L = c.j, e(!(1 & y)), c.O += s.R * y, c.N += s.B * (y >> 1), c.W += s.B * (y >> 1), null != c.F && (c.J += c.width * y)), L < P && (c.O += c.v, c.N += c.v >> 1, c.W += c.v >> 1, null != c.F && (c.J += c.v), c.ka = L - c.j, c.U = c.va - c.v, c.T = P - L, u = c.put(c));
                }
                o + 1 != s.Ic || b || (n(s.sa, s.ta - h, d, p + 16 * s.R, h), n(s.qa, s.ra - f, g, l + 8 * s.B, f), n(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
              }
              if (!u) return Jt(t, 6, "Output aborted.");
            }
            return 1;
          }(t, r)), null != r.bc && r.bc(r), s &= 1;
        }
        return s ? (t.cb = 0, s) : 0;
      }
      function te(t, e, r, n, i) {
        i = t[e + r + 32 * n] + (i >> 3), t[e + r + 32 * n] = -256 & i ? 0 > i ? 0 : 255 : i;
      }
      function ee(t, e, r, n, i, a) {
        te(t, e, 0, r, n + i), te(t, e, 1, r, n + a), te(t, e, 2, r, n - a), te(t, e, 3, r, n - i);
      }
      function re(t) {
        return (20091 * t >> 16) + t;
      }
      function ne(t, e, r, n) {
        var i,
          o = 0,
          s = a(16);
        for (i = 0; 4 > i; ++i) {
          var c = t[e + 0] + t[e + 8],
            u = t[e + 0] - t[e + 8],
            h = (35468 * t[e + 4] >> 16) - re(t[e + 12]),
            l = re(t[e + 4]) + (35468 * t[e + 12] >> 16);
          s[o + 0] = c + l, s[o + 1] = u + h, s[o + 2] = u - h, s[o + 3] = c - l, o += 4, e++;
        }
        for (i = o = 0; 4 > i; ++i) c = (t = s[o + 0] + 4) + s[o + 8], u = t - s[o + 8], h = (35468 * s[o + 4] >> 16) - re(s[o + 12]), te(r, n, 0, 0, c + (l = re(s[o + 4]) + (35468 * s[o + 12] >> 16))), te(r, n, 1, 0, u + h), te(r, n, 2, 0, u - h), te(r, n, 3, 0, c - l), o++, n += 32;
      }
      function ie(t, e, r, n) {
        var i = t[e + 0] + 4,
          a = 35468 * t[e + 4] >> 16,
          o = re(t[e + 4]),
          s = 35468 * t[e + 1] >> 16;
        ee(r, n, 0, i + o, t = re(t[e + 1]), s), ee(r, n, 1, i + a, t, s), ee(r, n, 2, i - a, t, s), ee(r, n, 3, i - o, t, s);
      }
      function ae(t, e, r, n, i) {
        ne(t, e, r, n), i && ne(t, e + 16, r, n + 4);
      }
      function oe(t, e, r, n) {
        on(t, e + 0, r, n, 1), on(t, e + 32, r, n + 128, 1);
      }
      function se(t, e, r, n) {
        var i;
        for (t = t[e + 0] + 4, i = 0; 4 > i; ++i) for (e = 0; 4 > e; ++e) te(r, n, e, i, t);
      }
      function ce(t, e, r, n) {
        t[e + 0] && un(t, e + 0, r, n), t[e + 16] && un(t, e + 16, r, n + 4), t[e + 32] && un(t, e + 32, r, n + 128), t[e + 48] && un(t, e + 48, r, n + 128 + 4);
      }
      function ue(t, e, r, n) {
        var i,
          o = a(16);
        for (i = 0; 4 > i; ++i) {
          var s = t[e + 0 + i] + t[e + 12 + i],
            c = t[e + 4 + i] + t[e + 8 + i],
            u = t[e + 4 + i] - t[e + 8 + i],
            h = t[e + 0 + i] - t[e + 12 + i];
          o[0 + i] = s + c, o[8 + i] = s - c, o[4 + i] = h + u, o[12 + i] = h - u;
        }
        for (i = 0; 4 > i; ++i) s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], c = o[1 + 4 * i] + o[2 + 4 * i], u = o[1 + 4 * i] - o[2 + 4 * i], h = t - o[3 + 4 * i], r[n + 0] = s + c >> 3, r[n + 16] = h + u >> 3, r[n + 32] = s - c >> 3, r[n + 48] = h - u >> 3, n += 64;
      }
      function he(t, e, r) {
        var n,
          i = e - 32,
          a = Bn,
          o = 255 - t[i - 1];
        for (n = 0; n < r; ++n) {
          var s,
            c = a,
            u = o + t[e - 1];
          for (s = 0; s < r; ++s) t[e + s] = c[u + t[i + s]];
          e += 32;
        }
      }
      function le(t, e) {
        he(t, e, 4);
      }
      function fe(t, e) {
        he(t, e, 8);
      }
      function de(t, e) {
        he(t, e, 16);
      }
      function pe(t, e) {
        var r;
        for (r = 0; 16 > r; ++r) n(t, e + 32 * r, t, e - 32, 16);
      }
      function ge(t, e) {
        var r;
        for (r = 16; 0 < r; --r) i(t, e, t[e - 1], 16), e += 32;
      }
      function me(t, e, r) {
        var n;
        for (n = 0; 16 > n; ++n) i(e, r + 32 * n, t, 16);
      }
      function ve(t, e) {
        var r,
          n = 16;
        for (r = 0; 16 > r; ++r) n += t[e - 1 + 32 * r] + t[e + r - 32];
        me(n >> 5, t, e);
      }
      function be(t, e) {
        var r,
          n = 8;
        for (r = 0; 16 > r; ++r) n += t[e - 1 + 32 * r];
        me(n >> 4, t, e);
      }
      function ye(t, e) {
        var r,
          n = 8;
        for (r = 0; 16 > r; ++r) n += t[e + r - 32];
        me(n >> 4, t, e);
      }
      function we(t, e) {
        me(128, t, e);
      }
      function Ne(t, e, r) {
        return t + 2 * e + r + 2 >> 2;
      }
      function Le(t, e) {
        var r,
          i = e - 32;
        i = new Uint8Array([Ne(t[i - 1], t[i + 0], t[i + 1]), Ne(t[i + 0], t[i + 1], t[i + 2]), Ne(t[i + 1], t[i + 2], t[i + 3]), Ne(t[i + 2], t[i + 3], t[i + 4])]);
        for (r = 0; 4 > r; ++r) n(t, e + 32 * r, i, 0, i.length);
      }
      function Ae(t, e) {
        var r = t[e - 1],
          n = t[e - 1 + 32],
          i = t[e - 1 + 64],
          a = t[e - 1 + 96];
        F(t, e + 0, 16843009 * Ne(t[e - 1 - 32], r, n)), F(t, e + 32, 16843009 * Ne(r, n, i)), F(t, e + 64, 16843009 * Ne(n, i, a)), F(t, e + 96, 16843009 * Ne(i, a, a));
      }
      function xe(t, e) {
        var r,
          n = 4;
        for (r = 0; 4 > r; ++r) n += t[e + r - 32] + t[e - 1 + 32 * r];
        for (n >>= 3, r = 0; 4 > r; ++r) i(t, e + 32 * r, n, 4);
      }
      function Se(t, e) {
        var r = t[e - 1 + 0],
          n = t[e - 1 + 32],
          i = t[e - 1 + 64],
          a = t[e - 1 - 32],
          o = t[e + 0 - 32],
          s = t[e + 1 - 32],
          c = t[e + 2 - 32],
          u = t[e + 3 - 32];
        t[e + 0 + 96] = Ne(n, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = Ne(r, n, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = Ne(a, r, n), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = Ne(o, a, r), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = Ne(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = Ne(c, s, o), t[e + 3 + 0] = Ne(u, c, s);
      }
      function _e(t, e) {
        var r = t[e + 1 - 32],
          n = t[e + 2 - 32],
          i = t[e + 3 - 32],
          a = t[e + 4 - 32],
          o = t[e + 5 - 32],
          s = t[e + 6 - 32],
          c = t[e + 7 - 32];
        t[e + 0 + 0] = Ne(t[e + 0 - 32], r, n), t[e + 1 + 0] = t[e + 0 + 32] = Ne(r, n, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = Ne(n, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = Ne(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, c);
      }
      function Pe(t, e) {
        var r = t[e - 1 + 0],
          n = t[e - 1 + 32],
          i = t[e - 1 + 64],
          a = t[e - 1 - 32],
          o = t[e + 0 - 32],
          s = t[e + 1 - 32],
          c = t[e + 2 - 32],
          u = t[e + 3 - 32];
        t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + c + 1 >> 1, t[e + 3 + 0] = c + u + 1 >> 1, t[e + 0 + 96] = Ne(i, n, r), t[e + 0 + 64] = Ne(n, r, a), t[e + 0 + 32] = t[e + 1 + 96] = Ne(r, a, o), t[e + 1 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = Ne(o, s, c), t[e + 3 + 32] = Ne(s, c, u);
      }
      function ke(t, e) {
        var r = t[e + 0 - 32],
          n = t[e + 1 - 32],
          i = t[e + 2 - 32],
          a = t[e + 3 - 32],
          o = t[e + 4 - 32],
          s = t[e + 5 - 32],
          c = t[e + 6 - 32],
          u = t[e + 7 - 32];
        t[e + 0 + 0] = r + n + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = n + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = Ne(r, n, i), t[e + 1 + 32] = t[e + 0 + 96] = Ne(n, i, a), t[e + 2 + 32] = t[e + 1 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 3 + 64] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, u);
      }
      function Fe(t, e) {
        var r = t[e - 1 + 0],
          n = t[e - 1 + 32],
          i = t[e - 1 + 64],
          a = t[e - 1 + 96];
        t[e + 0 + 0] = r + n + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = n + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = Ne(r, n, i), t[e + 3 + 0] = t[e + 1 + 32] = Ne(n, i, a), t[e + 3 + 32] = t[e + 1 + 64] = Ne(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
      }
      function Ie(t, e) {
        var r = t[e - 1 + 0],
          n = t[e - 1 + 32],
          i = t[e - 1 + 64],
          a = t[e - 1 + 96],
          o = t[e - 1 - 32],
          s = t[e + 0 - 32],
          c = t[e + 1 - 32],
          u = t[e + 2 - 32];
        t[e + 0 + 0] = t[e + 2 + 32] = r + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = n + r + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + n + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = Ne(s, c, u), t[e + 2 + 0] = Ne(o, s, c), t[e + 1 + 0] = t[e + 3 + 32] = Ne(r, o, s), t[e + 1 + 32] = t[e + 3 + 64] = Ne(n, r, o), t[e + 1 + 64] = t[e + 3 + 96] = Ne(i, n, r), t[e + 1 + 96] = Ne(a, i, n);
      }
      function Ce(t, e) {
        var r;
        for (r = 0; 8 > r; ++r) n(t, e + 32 * r, t, e - 32, 8);
      }
      function je(t, e) {
        var r;
        for (r = 0; 8 > r; ++r) i(t, e, t[e - 1], 8), e += 32;
      }
      function Oe(t, e, r) {
        var n;
        for (n = 0; 8 > n; ++n) i(e, r + 32 * n, t, 8);
      }
      function Be(t, e) {
        var r,
          n = 8;
        for (r = 0; 8 > r; ++r) n += t[e + r - 32] + t[e - 1 + 32 * r];
        Oe(n >> 4, t, e);
      }
      function Me(t, e) {
        var r,
          n = 4;
        for (r = 0; 8 > r; ++r) n += t[e + r - 32];
        Oe(n >> 3, t, e);
      }
      function Ee(t, e) {
        var r,
          n = 4;
        for (r = 0; 8 > r; ++r) n += t[e - 1 + 32 * r];
        Oe(n >> 3, t, e);
      }
      function qe(t, e) {
        Oe(128, t, e);
      }
      function De(t, e, r) {
        var n = t[e - r],
          i = t[e + 0],
          a = 3 * (i - n) + jn[1020 + t[e - 2 * r] - t[e + r]],
          o = On[112 + (a + 4 >> 3)];
        t[e - r] = Bn[255 + n + On[112 + (a + 3 >> 3)]], t[e + 0] = Bn[255 + i - o];
      }
      function Re(t, e, r, n) {
        var i = t[e + 0],
          a = t[e + r];
        return Mn[255 + t[e - 2 * r] - t[e - r]] > n || Mn[255 + a - i] > n;
      }
      function Te(t, e, r, n) {
        return 4 * Mn[255 + t[e - r] - t[e + 0]] + Mn[255 + t[e - 2 * r] - t[e + r]] <= n;
      }
      function Ue(t, e, r, n, i) {
        var a = t[e - 3 * r],
          o = t[e - 2 * r],
          s = t[e - r],
          c = t[e + 0],
          u = t[e + r],
          h = t[e + 2 * r],
          l = t[e + 3 * r];
        return 4 * Mn[255 + s - c] + Mn[255 + o - u] > n ? 0 : Mn[255 + t[e - 4 * r] - a] <= i && Mn[255 + a - o] <= i && Mn[255 + o - s] <= i && Mn[255 + l - h] <= i && Mn[255 + h - u] <= i && Mn[255 + u - c] <= i;
      }
      function ze(t, e, r, n) {
        var i = 2 * n + 1;
        for (n = 0; 16 > n; ++n) Te(t, e + n, r, i) && De(t, e + n, r);
      }
      function He(t, e, r, n) {
        var i = 2 * n + 1;
        for (n = 0; 16 > n; ++n) Te(t, e + n * r, 1, i) && De(t, e + n * r, 1);
      }
      function We(t, e, r, n) {
        var i;
        for (i = 3; 0 < i; --i) ze(t, e += 4 * r, r, n);
      }
      function Ve(t, e, r, n) {
        var i;
        for (i = 3; 0 < i; --i) He(t, e += 4, r, n);
      }
      function Ge(t, e, r, n, i, a, o, s) {
        for (a = 2 * a + 1; 0 < i--;) {
          if (Ue(t, e, r, a, o)) if (Re(t, e, r, s)) De(t, e, r);else {
            var c = t,
              u = e,
              h = r,
              l = c[u - 2 * h],
              f = c[u - h],
              d = c[u + 0],
              p = c[u + h],
              g = c[u + 2 * h],
              m = 27 * (b = jn[1020 + 3 * (d - f) + jn[1020 + l - p]]) + 63 >> 7,
              v = 18 * b + 63 >> 7,
              b = 9 * b + 63 >> 7;
            c[u - 3 * h] = Bn[255 + c[u - 3 * h] + b], c[u - 2 * h] = Bn[255 + l + v], c[u - h] = Bn[255 + f + m], c[u + 0] = Bn[255 + d - m], c[u + h] = Bn[255 + p - v], c[u + 2 * h] = Bn[255 + g - b];
          }
          e += n;
        }
      }
      function Ye(t, e, r, n, i, a, o, s) {
        for (a = 2 * a + 1; 0 < i--;) {
          if (Ue(t, e, r, a, o)) if (Re(t, e, r, s)) De(t, e, r);else {
            var c = t,
              u = e,
              h = r,
              l = c[u - h],
              f = c[u + 0],
              d = c[u + h],
              p = On[112 + ((g = 3 * (f - l)) + 4 >> 3)],
              g = On[112 + (g + 3 >> 3)],
              m = p + 1 >> 1;
            c[u - 2 * h] = Bn[255 + c[u - 2 * h] + m], c[u - h] = Bn[255 + l + g], c[u + 0] = Bn[255 + f - p], c[u + h] = Bn[255 + d - m];
          }
          e += n;
        }
      }
      function Je(t, e, r, n, i, a) {
        Ge(t, e, r, 1, 16, n, i, a);
      }
      function Xe(t, e, r, n, i, a) {
        Ge(t, e, 1, r, 16, n, i, a);
      }
      function Ke(t, e, r, n, i, a) {
        var o;
        for (o = 3; 0 < o; --o) Ye(t, e += 4 * r, r, 1, 16, n, i, a);
      }
      function Ze(t, e, r, n, i, a) {
        var o;
        for (o = 3; 0 < o; --o) Ye(t, e += 4, 1, r, 16, n, i, a);
      }
      function $e(t, e, r, n, i, a, o, s) {
        Ge(t, e, i, 1, 8, a, o, s), Ge(r, n, i, 1, 8, a, o, s);
      }
      function Qe(t, e, r, n, i, a, o, s) {
        Ge(t, e, 1, i, 8, a, o, s), Ge(r, n, 1, i, 8, a, o, s);
      }
      function tr(t, e, r, n, i, a, o, s) {
        Ye(t, e + 4 * i, i, 1, 8, a, o, s), Ye(r, n + 4 * i, i, 1, 8, a, o, s);
      }
      function er(t, e, r, n, i, a, o, s) {
        Ye(t, e + 4, 1, i, 8, a, o, s), Ye(r, n + 4, 1, i, 8, a, o, s);
      }
      function rr() {
        this.ba = new ot(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ct(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
      }
      function nr() {
        this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
      }
      function ir() {
        this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
      }
      function ar() {
        this.ua = 0, this.Wa = new M(), this.vb = new M(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d(), this.yc = new l();
      }
      function or() {
        this.xb = this.a = 0, this.l = new Gt(), this.ca = new ot(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N(), this.Pb = 0, this.wd = new N(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ar(), this.ab = 0, this.gc = o(4, ir), this.Oc = 0;
      }
      function sr() {
        this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
      }
      function cr(t, e, r, n, i, a, o) {
        for (t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e) i[a + e] = t + r[n + e] & 255, t = i[a + e];
      }
      function ur(t, e, r, n, i, a, o) {
        var s;
        if (null == t) cr(null, null, r, n, i, a, o);else for (s = 0; s < o; ++s) i[a + s] = t[e + s] + r[n + s] & 255;
      }
      function hr(t, e, r, n, i, a, o) {
        if (null == t) cr(null, null, r, n, i, a, o);else {
          var s,
            c = t[e + 0],
            u = c,
            h = c;
          for (s = 0; s < o; ++s) u = h + (c = t[e + s]) - u, h = r[n + s] + (-256 & u ? 0 > u ? 0 : 255 : u) & 255, u = c, i[a + s] = h;
        }
      }
      function lr(t, r, i, o) {
        var s = r.width,
          c = r.o;
        if (e(null != t && null != r), 0 > i || 0 >= o || i + o > c) return null;
        if (!t.Cc) {
          if (null == t.ga) {
            var u;
            if (t.ga = new sr(), (u = null == t.ga) || (u = r.width * r.o, e(0 == t.Gb.length), t.Gb = a(u), t.Uc = 0, null == t.Gb ? u = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, u = 1), u = !u), !u) {
              u = t.ga;
              var h = t.Fa,
                l = t.P,
                f = t.qc,
                d = t.mb,
                p = t.nb,
                g = l + 1,
                m = f - 1,
                b = u.l;
              if (e(null != h && null != d && null != r), mi[0] = null, mi[1] = cr, mi[2] = ur, mi[3] = hr, u.ca = d, u.tb = p, u.c = r.width, u.i = r.height, e(0 < u.c && 0 < u.i), 1 >= f) r = 0;else if (u.$a = h[l + 0] >> 0 & 3, u.Z = h[l + 0] >> 2 & 3, u.Lc = h[l + 0] >> 4 & 3, l = h[l + 0] >> 6 & 3, 0 > u.$a || 1 < u.$a || 4 <= u.Z || 1 < u.Lc || l) r = 0;else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = u, b.width = r.width, b.height = r.height, b.Da = r.Da, b.v = r.v, b.va = r.va, b.j = r.j, b.o = r.o, u.$a) t: {
                e(1 == u.$a), r = kt();
                e: for (;;) {
                  if (null == r) {
                    r = 0;
                    break t;
                  }
                  if (e(null != u), u.mc = r, r.c = u.c, r.i = u.i, r.l = u.l, r.l.ma = u, r.l.width = u.c, r.l.height = u.i, r.a = 0, v(r.m, h, g, m), !Ft(u.c, u.i, 1, r, null)) break e;
                  if (1 == r.ab && 3 == r.gc[0].hc && At(r.s) ? (u.ic = 1, h = r.c * r.i, r.Ta = null, r.Ua = 0, r.V = a(h), r.Ba = 0, null == r.V ? (r.a = 1, r = 0) : r = 1) : (u.ic = 0, r = It(r, u.c)), !r) break e;
                  r = 1;
                  break t;
                }
                u.mc = null, r = 0;
              } else r = m >= u.c * u.i;
              u = !r;
            }
            if (u) return null;
            1 != t.ga.Lc ? t.Ga = 0 : o = c - i;
          }
          e(null != t.ga), e(i + o <= c);
          t: {
            if (r = (h = t.ga).c, c = h.l.o, 0 == h.$a) {
              if (g = t.rc, m = t.Vc, b = t.Fa, l = t.P + 1 + i * r, f = t.mb, d = t.nb + i * r, e(l <= t.P + t.qc), 0 != h.Z) for (e(null != mi[h.Z]), u = 0; u < o; ++u) mi[h.Z](g, m, b, l, f, d, r), g = f, m = d, d += r, l += r;else for (u = 0; u < o; ++u) n(f, d, b, l, r), g = f, m = d, d += r, l += r;
              t.rc = g, t.Vc = m;
            } else {
              if (e(null != h.mc), r = i + o, e(null != (u = h.mc)), e(r <= u.i), u.C >= r) r = 1;else if (h.ic || mr(), h.ic) {
                h = u.V, g = u.Ba, m = u.c;
                var y = u.i,
                  w = (b = 1, l = u.$ / m, f = u.$ % m, d = u.m, p = u.s, u.$),
                  N = m * y,
                  L = m * r,
                  x = p.wc,
                  _ = w < L ? wt(p, f, l) : null;
                e(w <= N), e(r <= y), e(At(p));
                e: for (;;) {
                  for (; !d.h && w < L;) {
                    if (f & x || (_ = wt(p, f, l)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) h[g + w] = y, ++w, ++f >= m && (f = 0, ++l <= r && !(l % 16) && St(u, l));else {
                      if (!(280 > y)) {
                        b = 0;
                        break e;
                      }
                      y = mt(y - 256, d);
                      var P,
                        k = bt(_.G[4], _.H[4], d);
                      if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                        b = 0;
                        break e;
                      }
                      for (P = 0; P < y; ++P) h[g + w + P] = h[g + w + P - k];
                      for (w += y, f += y; f >= m;) f -= m, ++l <= r && !(l % 16) && St(u, l);
                      w < L && f & x && (_ = wt(p, f, l));
                    }
                    e(d.h == A(d));
                  }
                  St(u, l > r ? r : l);
                  break e;
                }
                !b || d.h && w < N ? (b = 0, u.a = d.h ? 5 : 3) : u.$ = w, r = b;
              } else r = _t(u, u.V, u.Ba, u.c, u.i, r, Ct);
              if (!r) {
                o = 0;
                break t;
              }
            }
            i + o >= c && (t.Cc = 1), o = 1;
          }
          if (!o) return null;
          if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
        }
        return t.nb + i * s;
      }
      function fr(t, e, r, n, i, a) {
        for (; 0 < i--;) {
          var o,
            s = t,
            c = e + (r ? 1 : 0),
            u = t,
            h = e + (r ? 0 : 3);
          for (o = 0; o < n; ++o) {
            var l = u[h + 4 * o];
            255 != l && (l *= 32897, s[c + 4 * o + 0] = s[c + 4 * o + 0] * l >> 23, s[c + 4 * o + 1] = s[c + 4 * o + 1] * l >> 23, s[c + 4 * o + 2] = s[c + 4 * o + 2] * l >> 23);
          }
          e += a;
        }
      }
      function dr(t, e, r, n, i) {
        for (; 0 < n--;) {
          var a;
          for (a = 0; a < r; ++a) {
            var o = t[e + 2 * a + 0],
              s = 15 & (u = t[e + 2 * a + 1]),
              c = 4369 * s,
              u = (240 & u | u >> 4) * c >> 16;
            t[e + 2 * a + 0] = (240 & o | o >> 4) * c >> 16 & 240 | (15 & o | o << 4) * c >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & u | s;
          }
          e += i;
        }
      }
      function pr(t, e, r, n, i, a, o, s) {
        var c,
          u,
          h = 255;
        for (u = 0; u < i; ++u) {
          for (c = 0; c < n; ++c) {
            var l = t[e + c];
            a[o + 4 * c] = l, h &= l;
          }
          e += r, o += s;
        }
        return 255 != h;
      }
      function gr(t, e, r, n, i) {
        var a;
        for (a = 0; a < i; ++a) r[n + a] = t[e + a] >> 8;
      }
      function mr() {
        An = fr, xn = dr, Sn = pr, _n = gr;
      }
      function vr(r, n, i) {
        t[r] = function (t, r, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y) {
          var w,
            N = y - 1 >> 1,
            L = s[c + 0] | u[h + 0] << 16,
            A = l[f + 0] | d[p + 0] << 16;
          e(null != t);
          var x = 3 * L + A + 131074 >> 2;
          for (n(t[r + 0], 255 & x, x >> 16, g, m), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + 0], 255 & x, x >> 16, v, b)), w = 1; w <= N; ++w) {
            var S = s[c + w] | u[h + w] << 16,
              _ = l[f + w] | d[p + w] << 16,
              P = L + S + A + _ + 524296,
              k = P + 2 * (S + A) >> 3;
            x = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, n(t[r + 2 * w - 1], 255 & x, x >> 16, g, m + (2 * w - 1) * i), n(t[r + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (x = P + A >> 1, L = k + _ >> 1, n(a[o + 2 * w - 1], 255 & x, x >> 16, v, b + (2 * w - 1) * i), n(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, A = _;
          }
          1 & y || (x = 3 * L + A + 131074 >> 2, n(t[r + y - 1], 255 & x, x >> 16, g, m + (y - 1) * i), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + y - 1], 255 & x, x >> 16, v, b + (y - 1) * i)));
        };
      }
      function br() {
        vi[En] = bi, vi[qn] = wi, vi[Dn] = yi, vi[Rn] = Ni, vi[Tn] = Li, vi[Un] = Ai, vi[zn] = xi, vi[Hn] = wi, vi[Wn] = Ni, vi[Vn] = Li, vi[Gn] = Ai;
      }
      function yr(t) {
        return t & ~Ii ? 0 > t ? 0 : 255 : t >> Fi;
      }
      function wr(t, e) {
        return yr((19077 * t >> 8) + (26149 * e >> 8) - 14234);
      }
      function Nr(t, e, r) {
        return yr((19077 * t >> 8) - (6419 * e >> 8) - (13320 * r >> 8) + 8708);
      }
      function Lr(t, e) {
        return yr((19077 * t >> 8) + (33050 * e >> 8) - 17685);
      }
      function Ar(t, e, r, n, i) {
        n[i + 0] = wr(t, r), n[i + 1] = Nr(t, e, r), n[i + 2] = Lr(t, e);
      }
      function xr(t, e, r, n, i) {
        n[i + 0] = Lr(t, e), n[i + 1] = Nr(t, e, r), n[i + 2] = wr(t, r);
      }
      function Sr(t, e, r, n, i) {
        var a = Nr(t, e, r);
        e = a << 3 & 224 | Lr(t, e) >> 3, n[i + 0] = 248 & wr(t, r) | a >> 5, n[i + 1] = e;
      }
      function _r(t, e, r, n, i) {
        var a = 240 & Lr(t, e) | 15;
        n[i + 0] = 240 & wr(t, r) | Nr(t, e, r) >> 4, n[i + 1] = a;
      }
      function Pr(t, e, r, n, i) {
        n[i + 0] = 255, Ar(t, e, r, n, i + 1);
      }
      function kr(t, e, r, n, i) {
        xr(t, e, r, n, i), n[i + 3] = 255;
      }
      function Fr(t, e, r, n, i) {
        Ar(t, e, r, n, i), n[i + 3] = 255;
      }
      function Vt(t, e) {
        return 0 > t ? 0 : t > e ? e : t;
      }
      function Ir(e, r, n) {
        t[e] = function (t, e, i, a, o, s, c, u, h) {
          for (var l = u + (-2 & h) * n; u != l;) r(t[e + 0], i[a + 0], o[s + 0], c, u), r(t[e + 1], i[a + 0], o[s + 0], c, u + n), e += 2, ++a, ++s, u += 2 * n;
          1 & h && r(t[e + 0], i[a + 0], o[s + 0], c, u);
        };
      }
      function Cr(t, e, r) {
        return 0 == r ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : r;
      }
      function jr(t, e, r, n, i) {
        switch (t >>> 30) {
          case 3:
            on(e, r, n, i, 0);
            break;
          case 2:
            sn(e, r, n, i);
            break;
          case 1:
            un(e, r, n, i);
        }
      }
      function Or(t, e) {
        var r,
          a,
          o = e.M,
          s = e.Nb,
          c = t.oc,
          u = t.pc + 40,
          h = t.oc,
          l = t.pc + 584,
          f = t.oc,
          d = t.pc + 600;
        for (r = 0; 16 > r; ++r) c[u + 32 * r - 1] = 129;
        for (r = 0; 8 > r; ++r) h[l + 32 * r - 1] = 129, f[d + 32 * r - 1] = 129;
        for (0 < o ? c[u - 1 - 32] = h[l - 1 - 32] = f[d - 1 - 32] = 129 : (i(c, u - 32 - 1, 127, 21), i(h, l - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a) {
          var p = e.ya[e.aa + a];
          if (0 < a) {
            for (r = -1; 16 > r; ++r) n(c, u + 32 * r - 4, c, u + 32 * r + 12, 4);
            for (r = -1; 8 > r; ++r) n(h, l + 32 * r - 4, h, l + 32 * r + 4, 4), n(f, d + 32 * r - 4, f, d + 32 * r + 4, 4);
          }
          var g = t.Gd,
            m = t.Hd + a,
            v = p.ad,
            b = p.Hc;
          if (0 < o && (n(c, u - 32, g[m].y, 0, 16), n(h, l - 32, g[m].f, 0, 8), n(f, d - 32, g[m].ea, 0, 8)), p.Za) {
            var y = c,
              w = u - 32 + 16;
            for (0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : n(y, w, g[m + 1].y, 0, 4)), r = 0; 4 > r; r++) y[w + 128 + r] = y[w + 256 + r] = y[w + 384 + r] = y[w + 0 + r];
            for (r = 0; 16 > r; ++r, b <<= 2) y = c, w = u + Di[r], fi[p.Ob[r]](y, w), jr(b, v, 16 * +r, y, w);
          } else if (y = Cr(a, o, p.Ob[0]), li[y](c, u), 0 != b) for (r = 0; 16 > r; ++r, b <<= 2) jr(b, v, 16 * +r, c, u + Di[r]);
          for (r = p.Gc, y = Cr(a, o, p.Dd), di[y](h, l), di[y](f, d), b = v, y = h, w = l, 255 & (p = r >> 0) && (170 & p ? cn(b, 256, y, w) : hn(b, 256, y, w)), p = f, b = d, 255 & (r >>= 8) && (170 & r ? cn(v, 320, p, b) : hn(v, 320, p, b)), o < t.Ub - 1 && (n(g[m].y, 0, c, u + 480, 16), n(g[m].f, 0, h, l + 224, 8), n(g[m].ea, 0, f, d + 224, 8)), r = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + r, b = t.Ha, y = t.Ia + 8 * a + r, r = 0; 16 > r; ++r) n(g, m + r * t.R, c, u + 32 * r, 16);
          for (r = 0; 8 > r; ++r) n(v, p + r * t.B, h, l + 32 * r, 8), n(b, y + r * t.B, f, d + 32 * r, 8);
        }
      }
      function Br(t, n, i, a, o, s, c, u, h) {
        var l = [0],
          f = [0],
          d = 0,
          p = null != h ? h.kd : 0,
          g = null != h ? h : new nr();
        if (null == t || 12 > i) return 7;
        g.data = t, g.w = n, g.ha = i, n = [n], i = [i], g.gb = [g.gb];
        t: {
          var m = n,
            b = i,
            y = g.gb;
          if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !r(t, m[0], "RIFF")) {
            if (r(t, m[0] + 8, "WEBP")) {
              y = 3;
              break t;
            }
            var w = j(t, m[0] + 4);
            if (12 > w || 4294967286 < w) {
              y = 3;
              break t;
            }
            if (p && w > b[0] - 8) {
              y = 7;
              break t;
            }
            y[0] = w, m[0] += 12, b[0] -= 12;
          }
          y = 0;
        }
        if (0 != y) return y;
        for (w = 0 < g.gb[0], i = i[0];;) {
          t: {
            var L = t;
            b = n, y = i;
            var A = l,
              x = f,
              S = m = [0];
            if ((k = d = [d])[0] = 0, 8 > y[0]) y = 7;else {
              if (!r(L, b[0], "VP8X")) {
                if (10 != j(L, b[0] + 4)) {
                  y = 3;
                  break t;
                }
                if (18 > y[0]) {
                  y = 7;
                  break t;
                }
                var _ = j(L, b[0] + 8),
                  P = 1 + C(L, b[0] + 12);
                if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                  y = 3;
                  break t;
                }
                null != S && (S[0] = _), null != A && (A[0] = P), null != x && (x[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
              }
              y = 0;
            }
          }
          if (d = d[0], m = m[0], 0 != y) return y;
          if (b = !!(2 & m), !w && d) return 3;
          if (null != s && (s[0] = !!(16 & m)), null != c && (c[0] = b), null != u && (u[0] = 0), c = l[0], m = f[0], d && b && null == h) {
            y = 0;
            break;
          }
          if (4 > i) {
            y = 7;
            break;
          }
          if (w && d || !w && !d && !r(t, n[0], "ALPH")) {
            i = [i], g.na = [g.na], g.P = [g.P], g.Sa = [g.Sa];
            t: {
              _ = t, y = n, w = i;
              var k = g.gb;
              A = g.na, x = g.P, S = g.Sa;
              P = 22, e(null != _), e(null != w), L = y[0];
              var F = w[0];
              for (e(null != A), e(null != S), A[0] = null, x[0] = null, S[0] = 0;;) {
                if (y[0] = L, w[0] = F, 8 > F) {
                  y = 7;
                  break t;
                }
                var I = j(_, L + 4);
                if (4294967286 < I) {
                  y = 3;
                  break t;
                }
                var O = 8 + I + 1 & -2;
                if (P += O, 0 < k && P > k) {
                  y = 3;
                  break t;
                }
                if (!r(_, L, "VP8 ") || !r(_, L, "VP8L")) {
                  y = 0;
                  break t;
                }
                if (F[0] < O) {
                  y = 7;
                  break t;
                }
                r(_, L, "ALPH") || (A[0] = _, x[0] = L + 8, S[0] = I), L += O, F -= O;
              }
            }
            if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
          }
          i = [i], g.Ja = [g.Ja], g.xa = [g.xa];
          t: if (k = t, y = n, w = i, A = g.gb[0], x = g.Ja, S = g.xa, _ = y[0], L = !r(k, _, "VP8 "), P = !r(k, _, "VP8L"), e(null != k), e(null != w), e(null != x), e(null != S), 8 > w[0]) y = 7;else {
            if (L || P) {
              if (k = j(k, _ + 4), 12 <= A && k > A - 12) {
                y = 3;
                break t;
              }
              if (p && k > w[0] - 8) {
                y = 7;
                break t;
              }
              x[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
            } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), x[0] = w[0];
            y = 0;
          }
          if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], n = n[0], 0 != y) break;
          if (4294967286 < g.Ja) return 3;
          if (null == u || b || (u[0] = g.xa ? 2 : 1), c = [c], m = [m], g.xa) {
            if (5 > i) {
              y = 7;
              break;
            }
            u = c, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[n + 0] && !(t[n + 4] >> 5) ? (w = [0], k = [0], A = [0], v(x = new N(), t, n, i), gt(x, w, k, A) ? (null != u && (u[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = A[0]), t = 1) : t = 0) : t = 0;
          } else {
            if (10 > i) {
              y = 7;
              break;
            }
            u = m, null == t || 10 > i || !Xt(t, n + 3, i - 3) ? t = 0 : (p = t[n + 0] | t[n + 1] << 8 | t[n + 2] << 16, b = 16383 & (t[n + 7] << 8 | t[n + 6]), t = 16383 & (t[n + 9] << 8 | t[n + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (c && (c[0] = b), u && (u[0] = t), t = 1));
          }
          if (!t) return 3;
          if (c = c[0], m = m[0], d && (l[0] != c || f[0] != m)) return 3;
          null != h && (h[0] = g, h.offset = n - h.w, e(4294967286 > n - h.w), e(h.offset == h.ha - i));
          break;
        }
        return 0 == y || 7 == y && d && null == h ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = c), null != o && (o[0] = m), 0) : y;
      }
      function Mr(t, e, r) {
        var n = e.width,
          i = e.height,
          a = 0,
          o = 0,
          s = n,
          c = i;
        if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, c = t.bd, a = t.v, o = t.j, 11 > r || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= c || a + s > n || o + c > i)) return 0;
        if (e.v = a, e.j = o, e.va = a + s, e.o = o + c, e.U = s, e.T = c, e.da = null != t && 0 < t.da, e.da) {
          if (!E(s, c, r = [t.ib], a = [t.hb])) return 0;
          e.ib = r[0], e.hb = a[0];
        }
        return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * n / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
      }
      function Er(t) {
        if (null == t) return 2;
        if (11 > t.S) {
          var e = t.f.RGBA;
          e.fb += (t.height - 1) * e.A, e.A = -e.A;
        } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
        return 0;
      }
      function qr(t, e, r, n) {
        if (null == n || 0 >= t || 0 >= e) return 2;
        if (null != r) {
          if (r.Da) {
            var i = r.cd,
              o = r.bd,
              s = -2 & r.v,
              c = -2 & r.j;
            if (0 > s || 0 > c || 0 >= i || 0 >= o || s + i > t || c + o > e) return 2;
            t = i, e = o;
          }
          if (r.da) {
            if (!E(t, e, i = [r.ib], o = [r.hb])) return 2;
            t = i[0], e = o[0];
          }
        }
        n.width = t, n.height = e;
        t: {
          var u = n.width,
            h = n.height;
          if (t = n.S, 0 >= u || 0 >= h || !(t >= En && 13 > t)) t = 2;else {
            if (0 >= n.Rd && null == n.sd) {
              s = o = i = e = 0;
              var l = (c = u * zi[t]) * h;
              if (11 > t || (o = (h + 1) / 2 * (e = (u + 1) / 2), 12 == t && (s = (i = u) * h)), null == (h = a(l + 2 * o + s))) {
                t = 1;
                break t;
              }
              n.sd = h, 11 > t ? ((u = n.f.RGBA).eb = h, u.fb = 0, u.A = c, u.size = l) : ((u = n.f.kb).y = h, u.O = 0, u.fa = c, u.Fd = l, u.f = h, u.N = 0 + l, u.Ab = e, u.Cd = o, u.ea = h, u.W = 0 + l + o, u.Db = e, u.Ed = o, 12 == t && (u.F = h, u.J = 0 + l + 2 * o), u.Tc = s, u.lb = i);
            }
            if (e = 1, i = n.S, o = n.width, s = n.height, i >= En && 13 > i) {
              if (11 > i) t = n.f.RGBA, e &= (c = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= c >= o * zi[i], e &= null != t.eb;else {
                t = n.f.kb, c = (o + 1) / 2, l = (s + 1) / 2, u = Math.abs(t.fa);
                h = Math.abs(t.Ab);
                var f = Math.abs(t.Db),
                  d = Math.abs(t.lb),
                  p = d * (s - 1) + o;
                e &= u * (s - 1) + o <= t.Fd, e &= h * (l - 1) + c <= t.Cd, e = (e &= f * (l - 1) + c <= t.Ed) & u >= o & h >= c & f >= c, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
              }
            } else e = 0;
            t = e ? 0 : 2;
          }
        }
        return 0 != t || null != r && r.fd && (t = Er(n)), t;
      }
      var Dr = 64,
        Rr = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215],
        Tr = 24,
        Ur = 32,
        zr = 8,
        Hr = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
      R("Predictor0", "PredictorAdd0"), t.Predictor0 = function () {
        return 4278190080;
      }, t.Predictor1 = function (t) {
        return t;
      }, t.Predictor2 = function (t, e, r) {
        return e[r + 0];
      }, t.Predictor3 = function (t, e, r) {
        return e[r + 1];
      }, t.Predictor4 = function (t, e, r) {
        return e[r - 1];
      }, t.Predictor5 = function (t, e, r) {
        return U(U(t, e[r + 1]), e[r + 0]);
      }, t.Predictor6 = function (t, e, r) {
        return U(t, e[r - 1]);
      }, t.Predictor7 = function (t, e, r) {
        return U(t, e[r + 0]);
      }, t.Predictor8 = function (t, e, r) {
        return U(e[r - 1], e[r + 0]);
      }, t.Predictor9 = function (t, e, r) {
        return U(e[r + 0], e[r + 1]);
      }, t.Predictor10 = function (t, e, r) {
        return U(U(t, e[r - 1]), U(e[r + 0], e[r + 1]));
      }, t.Predictor11 = function (t, e, r) {
        var n = e[r + 0];
        return 0 >= W(n >> 24 & 255, t >> 24 & 255, (e = e[r - 1]) >> 24 & 255) + W(n >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(n >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & n, 255 & t, 255 & e) ? n : t;
      }, t.Predictor12 = function (t, e, r) {
        var n = e[r + 0];
        return (z((t >> 24 & 255) + (n >> 24 & 255) - ((e = e[r - 1]) >> 24 & 255)) << 24 | z((t >> 16 & 255) + (n >> 16 & 255) - (e >> 16 & 255)) << 16 | z((t >> 8 & 255) + (n >> 8 & 255) - (e >> 8 & 255)) << 8 | z((255 & t) + (255 & n) - (255 & e))) >>> 0;
      }, t.Predictor13 = function (t, e, r) {
        var n = e[r - 1];
        return (H((t = U(t, e[r + 0])) >> 24 & 255, n >> 24 & 255) << 24 | H(t >> 16 & 255, n >> 16 & 255) << 16 | H(t >> 8 & 255, n >> 8 & 255) << 8 | H(t >> 0 & 255, n >> 0 & 255)) >>> 0;
      };
      var Wr = t.PredictorAdd0;
      t.PredictorAdd1 = V, R("Predictor2", "PredictorAdd2"), R("Predictor3", "PredictorAdd3"), R("Predictor4", "PredictorAdd4"), R("Predictor5", "PredictorAdd5"), R("Predictor6", "PredictorAdd6"), R("Predictor7", "PredictorAdd7"), R("Predictor8", "PredictorAdd8"), R("Predictor9", "PredictorAdd9"), R("Predictor10", "PredictorAdd10"), R("Predictor11", "PredictorAdd11"), R("Predictor12", "PredictorAdd12"), R("Predictor13", "PredictorAdd13");
      var Vr = t.PredictorAdd2;
      X("ColorIndexInverseTransform", "MapARGB", "32b", function (t) {
        return t >> 8 & 255;
      }, function (t) {
        return t;
      }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function (t) {
        return t;
      }, function (t) {
        return t >> 8 & 255;
      });
      var Gr,
        Yr = t.ColorIndexInverseTransform,
        Jr = t.MapARGB,
        Xr = t.VP8LColorIndexInverseTransformAlpha,
        Kr = t.MapAlpha,
        Zr = t.VP8LPredictorsAdd = [];
      Zr.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
      var $r,
        Qr,
        tn,
        en,
        rn,
        nn,
        an,
        on,
        sn,
        cn,
        un,
        hn,
        ln,
        fn,
        dn,
        pn,
        gn,
        mn,
        vn,
        bn,
        yn,
        wn,
        Nn,
        Ln,
        An,
        xn,
        Sn,
        _n,
        Pn = a(511),
        kn = a(2041),
        Fn = a(225),
        In = a(767),
        Cn = 0,
        jn = kn,
        On = Fn,
        Bn = In,
        Mn = Pn,
        En = 0,
        qn = 1,
        Dn = 2,
        Rn = 3,
        Tn = 4,
        Un = 5,
        zn = 6,
        Hn = 7,
        Wn = 8,
        Vn = 9,
        Gn = 10,
        Yn = [2, 3, 7],
        Jn = [3, 3, 11],
        Xn = [280, 256, 256, 256, 40],
        Kn = [0, 1, 1, 1, 0],
        Zn = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        $n = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112],
        Qn = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004],
        ti = 8,
        ei = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157],
        ri = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284],
        ni = null,
        ii = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]],
        ai = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15],
        oi = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9],
        si = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]],
        ci = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]],
        ui = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]],
        hi = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0],
        li = [],
        fi = [],
        di = [],
        pi = 1,
        gi = 2,
        mi = [],
        vi = [];
      vr("UpsampleRgbLinePair", Ar, 3), vr("UpsampleBgrLinePair", xr, 3), vr("UpsampleRgbaLinePair", Fr, 4), vr("UpsampleBgraLinePair", kr, 4), vr("UpsampleArgbLinePair", Pr, 4), vr("UpsampleRgba4444LinePair", _r, 2), vr("UpsampleRgb565LinePair", Sr, 2);
      var bi = t.UpsampleRgbLinePair,
        yi = t.UpsampleBgrLinePair,
        wi = t.UpsampleRgbaLinePair,
        Ni = t.UpsampleBgraLinePair,
        Li = t.UpsampleArgbLinePair,
        Ai = t.UpsampleRgba4444LinePair,
        xi = t.UpsampleRgb565LinePair,
        Si = 16,
        _i = 1 << Si - 1,
        Pi = -227,
        ki = 482,
        Fi = 6,
        Ii = (256 << Fi) - 1,
        Ci = 0,
        ji = a(256),
        Oi = a(256),
        Bi = a(256),
        Mi = a(256),
        Ei = a(ki - Pi),
        qi = a(ki - Pi);
      Ir("YuvToRgbRow", Ar, 3), Ir("YuvToBgrRow", xr, 3), Ir("YuvToRgbaRow", Fr, 4), Ir("YuvToBgraRow", kr, 4), Ir("YuvToArgbRow", Pr, 4), Ir("YuvToRgba4444Row", _r, 2), Ir("YuvToRgb565Row", Sr, 2);
      var Di = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396],
        Ri = [0, 2, 8],
        Ti = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1],
        Ui = 1;
      this.WebPDecodeRGBA = function (t, r, n, i, a) {
        var o = qn,
          s = new rr(),
          c = new ot();
        s.ba = c, c.S = o, c.width = [c.width], c.height = [c.height];
        var u = c.width,
          h = c.height,
          l = new st();
        if (null == l || null == t) var f = 2;else e(null != l), f = Br(t, r, n, l.width, l.height, l.Pd, l.Qd, l.format, null);
        if (0 != f ? u = 0 : (null != u && (u[0] = l.width[0]), null != h && (h[0] = l.height[0]), u = 1), u) {
          c.width = c.width[0], c.height = c.height[0], null != i && (i[0] = c.width), null != a && (a[0] = c.height);
          t: {
            if (i = new Gt(), (a = new nr()).data = t, a.w = r, a.ha = n, a.kd = 1, r = [0], e(null != a), (0 == (t = Br(a.data, a.w, a.ha, null, null, null, r, null, a)) || 7 == t) && r[0] && (t = 4), 0 == (r = t)) {
              if (e(null != s), i.data = a.data, i.w = a.w + a.offset, i.ha = a.ha - a.offset, i.put = dt, i.ac = ft, i.bc = pt, i.ma = s, a.xa) {
                if (null == (t = kt())) {
                  s = 1;
                  break t;
                }
                if (function (t, r) {
                  var n = [0],
                    i = [0],
                    a = [0];
                  e: for (;;) {
                    if (null == t) return 0;
                    if (null == r) return t.a = 2, 0;
                    if (t.l = r, t.a = 0, v(t.m, r.data, r.w, r.ha), !gt(t.m, n, i, a)) {
                      t.a = 3;
                      break e;
                    }
                    if (t.xb = gi, r.width = n[0], r.height = i[0], !Ft(n[0], i[0], 1, t, null)) break e;
                    return 1;
                  }
                  return e(0 != t.a), 0;
                }(t, i)) {
                  if (i = 0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                    e: {
                      i = t;
                      r: for (;;) {
                        if (null == i) {
                          i = 0;
                          break e;
                        }
                        if (e(null != i.s.yc), e(null != i.s.Ya), e(0 < i.s.Wb), e(null != (n = i.l)), e(null != (a = n.ma)), 0 != i.xb) {
                          if (i.ca = a.ba, i.tb = a.tb, e(null != i.ca), !Mr(a.Oa, n, Rn)) {
                            i.a = 2;
                            break r;
                          }
                          if (!It(i, n.width)) break r;
                          if (n.da) break r;
                          if ((n.da || nt(i.ca.S)) && mr(), 11 > i.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != i.ca.f.kb.F && mr()), i.Pb && 0 < i.s.ua && null == i.s.vb.X && !O(i.s.vb, i.s.Wa.Xa)) {
                            i.a = 1;
                            break r;
                          }
                          i.xb = 0;
                        }
                        if (!_t(i, i.V, i.Ba, i.c, i.i, n.o, Lt)) break r;
                        a.Dc = i.Ma, i = 1;
                        break e;
                      }
                      e(0 != i.a), i = 0;
                    }
                    i = !i;
                  }
                  i && (r = t.a);
                } else r = t.a;
              } else {
                if (null == (t = new Yt())) {
                  s = 1;
                  break t;
                }
                if (t.Fa = a.na, t.P = a.P, t.qc = a.Sa, Kt(t, i)) {
                  if (0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                    if (t.Aa = 0, n = s.Oa, e(null != (a = t)), null != n) {
                      if (0 < (u = 0 > (u = n.Md) ? 0 : 100 < u ? 255 : 255 * u / 100)) {
                        for (h = l = 0; 4 > h; ++h) 12 > (f = a.pb[h]).lc && (f.ia = u * Ti[0 > f.lc ? 0 : f.lc] >> 3), l |= f.ia;
                        l && (alert("todo:VP8InitRandom"), a.ia = 1);
                      }
                      a.Ga = n.Id, 100 < a.Ga ? a.Ga = 100 : 0 > a.Ga && (a.Ga = 0);
                    }
                    Qt(t, i) || (r = t.a);
                  }
                } else r = t.a;
              }
              0 == r && null != s.Oa && s.Oa.fd && (r = Er(s.ba));
            }
            s = r;
          }
          o = 0 != s ? null : 11 > o ? c.f.RGBA.eb : c.f.kb.y;
        } else o = null;
        return o;
      };
      var zi = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
    };
    function u(t, e) {
      for (var r = "", n = 0; n < 4; n++) r += String.fromCharCode(t[e++]);
      return r;
    }
    function h(t, e) {
      return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function l(t, e) {
      return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new c();
    var f = [0],
      d = [0],
      p = [],
      g = new c(),
      m = t,
      v = function (t, e) {
        var r = {},
          n = 0,
          i = !1,
          a = 0,
          o = 0;
        if (r.frames = [], !
        /** @license
             * Copyright (c) 2017 Dominik Homberger
            Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
            The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
            https://webpjs.appspot.com
            WebPRiffParser dominikhlbg@gmail.com
            */
        function (t, e, r, n) {
          for (var i = 0; i < n; i++) if (t[e + i] != r.charCodeAt(i)) return !0;
          return !1;
        }(t, e, "RIFF", 4)) {
          var s, c;
          l(t, e += 4);
          for (e += 8; e < t.length;) {
            var f = u(t, e),
              d = l(t, e += 4);
            e += 4;
            var p = d + (1 & d);
            switch (f) {
              case "VP8 ":
              case "VP8L":
                void 0 === r.frames[n] && (r.frames[n] = {});
                (v = r.frames[n]).src_off = i ? o : e - 8, v.src_size = a + d + 8, n++, i && (i = !1, a = 0, o = 0);
                break;
              case "VP8X":
                (v = r.header = {}).feature_flags = t[e];
                var g = e + 4;
                v.canvas_width = 1 + h(t, g);
                g += 3;
                v.canvas_height = 1 + h(t, g);
                g += 3;
                break;
              case "ALPH":
                i = !0, a = p + 8, o = e - 8;
                break;
              case "ANIM":
                (v = r.header).bgcolor = l(t, e);
                g = e + 4;
                v.loop_count = (s = t)[(c = g) + 0] << 0 | s[c + 1] << 8;
                g += 2;
                break;
              case "ANMF":
                var m, v;
                (v = r.frames[n] = {}).offset_x = 2 * h(t, e), e += 3, v.offset_y = 2 * h(t, e), e += 3, v.width = 1 + h(t, e), e += 3, v.height = 1 + h(t, e), e += 3, v.duration = h(t, e), e += 3, m = t[e++], v.dispose = 1 & m, v.blend = m >> 1 & 1;
            }
            "ANMF" != f && (e += p);
          }
          return r;
        }
      }(m, 0);
    v.response = m, v.rgbaoutput = !0, v.dataurl = !1;
    var b = v.header ? v.header : null,
      y = v.frames ? v.frames : null;
    if (b) {
      b.loop_counter = b.loop_count, f = [b.canvas_height], d = [b.canvas_width];
      for (var w = 0; w < y.length && 0 != y[w].blend; w++);
    }
    var N = y[0],
      L = g.WebPDecodeRGBA(m, N.src_off, N.src_size, d, f);
    N.rgba = L, N.imgwidth = d[0], N.imgheight = f[0];
    for (var A = 0; A < d[0] * f[0] * 4; A++) p[A] = L[A];
    return this.width = d, this.height = f, this.data = p, this;
  }
  !function (t) {
    var e = function () {
        return !0;
      },
      r = function (e, r, i, u) {
        var h = 4,
          l = o;
        switch (u) {
          case t.image_compression.FAST:
            h = 1, l = a;
            break;
          case t.image_compression.MEDIUM:
            h = 6, l = s;
            break;
          case t.image_compression.SLOW:
            h = 9, l = c;
        }
        var f = _e(e = n(e, r, i, l), {
          level: h
        });
        return t.__addimage__.arrayBufferToBinaryString(f);
      },
      n = function (t, e, r, n) {
        for (var i, a, o, s = t.length / e, c = new Uint8Array(t.length + s), u = h(), f = 0; f < s; f += 1) {
          if (o = f * e, i = t.subarray(o, o + e), n) c.set(n(i, r, a), o + f);else {
            for (var d, p = u.length, g = []; d < p; d += 1) g[d] = u[d](i, r, a);
            var m = l(g.concat());
            c.set(g[m], o + f);
          }
          a = i;
        }
        return c;
      },
      i = function (t) {
        var e = Array.apply([], t);
        return e.unshift(0), e;
      },
      a = function (t, e) {
        var r,
          n = [],
          i = t.length;
        n[0] = 1;
        for (var a = 0; a < i; a += 1) r = t[a - e] || 0, n[a + 1] = t[a] - r + 256 & 255;
        return n;
      },
      o = function (t, e, r) {
        var n,
          i = [],
          a = t.length;
        i[0] = 2;
        for (var o = 0; o < a; o += 1) n = r && r[o] || 0, i[o + 1] = t[o] - n + 256 & 255;
        return i;
      },
      s = function (t, e, r) {
        var n,
          i,
          a = [],
          o = t.length;
        a[0] = 3;
        for (var s = 0; s < o; s += 1) n = t[s - e] || 0, i = r && r[s] || 0, a[s + 1] = t[s] + 256 - (n + i >>> 1) & 255;
        return a;
      },
      c = function (t, e, r) {
        var n,
          i,
          a,
          o,
          s = [],
          c = t.length;
        s[0] = 4;
        for (var h = 0; h < c; h += 1) n = t[h - e] || 0, i = r && r[h] || 0, a = r && r[h - e] || 0, o = u(n, i, a), s[h + 1] = t[h] - o + 256 & 255;
        return s;
      },
      u = function (t, e, r) {
        if (t === e && e === r) return t;
        var n = Math.abs(e - r),
          i = Math.abs(t - r),
          a = Math.abs(t + e - r - r);
        return n <= i && n <= a ? t : i <= a ? e : r;
      },
      h = function () {
        return [i, a, o, s, c];
      },
      l = function (t) {
        var e = t.map(function (t) {
          return t.reduce(function (t, e) {
            return t + Math.abs(e);
          }, 0);
        });
        return e.indexOf(Math.min.apply(null, e));
      };
    t.processPNG = function (n, i, a, o) {
      var s,
        c,
        u,
        h,
        l,
        f,
        d,
        p,
        g,
        m,
        v,
        b,
        y,
        w,
        N,
        L = this.decode.FLATE_DECODE,
        A = "";
      if (this.__addimage__.isArrayBuffer(n) && (n = new Uint8Array(n)), this.__addimage__.isArrayBufferView(n)) {
        if (n = (u = new Oe(n)).imgData, c = u.bits, s = u.colorSpace, l = u.colors, -1 !== [4, 6].indexOf(u.colorType)) {
          if (8 === u.bits) {
            g = (p = 32 == u.pixelBitlength ? new Uint32Array(u.decodePixels().buffer) : 16 == u.pixelBitlength ? new Uint16Array(u.decodePixels().buffer) : new Uint8Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * u.colors), m = new Uint8Array(g);
            var x,
              S = u.pixelBitlength - u.bits;
            for (w = 0, N = 0; w < g; w++) {
              for (y = p[w], x = 0; x < S;) v[N++] = y >>> x & 255, x += u.bits;
              m[w] = y >>> x & 255;
            }
          }
          if (16 === u.bits) {
            g = (p = new Uint32Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * (32 / u.pixelBitlength) * u.colors), m = new Uint8Array(g * (32 / u.pixelBitlength)), b = u.colors > 1, w = 0, N = 0;
            for (var _ = 0; w < g;) y = p[w++], v[N++] = y >>> 0 & 255, b && (v[N++] = y >>> 16 & 255, y = p[w++], v[N++] = y >>> 0 & 255), m[_++] = y >>> 16 & 255;
            c = 8;
          }
          o !== t.image_compression.NONE && e() ? (n = r(v, u.width * u.colors, u.colors, o), d = r(m, u.width, 1, o)) : (n = v, d = m, L = void 0);
        }
        if (3 === u.colorType && (s = this.color_spaces.INDEXED, f = u.palette, u.transparency.indexed)) {
          var P = u.transparency.indexed,
            k = 0;
          for (w = 0, g = P.length; w < g; ++w) k += P[w];
          if ((k /= 255) === g - 1 && -1 !== P.indexOf(0)) h = [P.indexOf(0)];else if (k !== g) {
            for (p = u.decodePixels(), m = new Uint8Array(p.length), w = 0, g = p.length; w < g; w++) m[w] = P[p[w]];
            d = r(m, u.width, 1);
          }
        }
        var F = function (e) {
          var r;
          switch (e) {
            case t.image_compression.FAST:
              r = 11;
              break;
            case t.image_compression.MEDIUM:
              r = 13;
              break;
            case t.image_compression.SLOW:
              r = 14;
              break;
            default:
              r = 12;
          }
          return r;
        }(o);
        return L === this.decode.FLATE_DECODE && (A = "/Predictor " + F + " "), A += "/Colors " + l + " /BitsPerComponent " + c + " /Columns " + u.width, (this.__addimage__.isArrayBuffer(n) || this.__addimage__.isArrayBufferView(n)) && (n = this.__addimage__.arrayBufferToBinaryString(n)), (d && this.__addimage__.isArrayBuffer(d) || this.__addimage__.isArrayBufferView(d)) && (d = this.__addimage__.arrayBufferToBinaryString(d)), {
          alias: a,
          data: n,
          index: i,
          filter: L,
          decodeParameters: A,
          transparency: h,
          palette: f,
          sMask: d,
          predictor: F,
          width: u.width,
          height: u.height,
          bitsPerComponent: c,
          colorSpace: s
        };
      }
    };
  }(M.API), function (t) {
    t.processGIF89A = function (e, r, n, i) {
      var a = new Be(e),
        o = a.width,
        s = a.height,
        c = [];
      a.decodeAndBlitFrameRGBA(0, c);
      var u = {
          data: c,
          width: o,
          height: s
        },
        h = new Ee(100).encode(u, 100);
      return t.processJPEG.call(this, h, r, n, i);
    }, t.processGIF87A = t.processGIF89A;
  }(M.API), qe.prototype.parseHeader = function () {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
      var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
      this.palette = new Array(t);
      for (var e = 0; e < t; e++) {
        var r = this.datav.getUint8(this.pos++, !0),
          n = this.datav.getUint8(this.pos++, !0),
          i = this.datav.getUint8(this.pos++, !0),
          a = this.datav.getUint8(this.pos++, !0);
        this.palette[e] = {
          red: i,
          green: n,
          blue: r,
          quad: a
        };
      }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
  }, qe.prototype.parseBGR = function () {
    this.pos = this.offset;
    try {
      var t = "bit" + this.bitPP,
        e = this.width * this.height * 4;
      this.data = new Uint8Array(e), this[t]();
    } catch (t) {
      i.log("bit decode error:" + t);
    }
  }, qe.prototype.bit1 = function () {
    var t,
      e = Math.ceil(this.width / 8),
      r = e % 4;
    for (t = this.height - 1; t >= 0; t--) {
      for (var n = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++) for (var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++) {
        var c = this.palette[a >> 7 - s & 1];
        this.data[o + 4 * s] = c.blue, this.data[o + 4 * s + 1] = c.green, this.data[o + 4 * s + 2] = c.red, this.data[o + 4 * s + 3] = 255;
      }
      0 !== r && (this.pos += 4 - r);
    }
  }, qe.prototype.bit4 = function () {
    for (var t = Math.ceil(this.width / 2), e = t % 4, r = this.height - 1; r >= 0; r--) {
      for (var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < t; i++) {
        var a = this.datav.getUint8(this.pos++, !0),
          o = n * this.width * 4 + 2 * i * 4,
          s = a >> 4,
          c = 15 & a,
          u = this.palette[s];
        if (this.data[o] = u.blue, this.data[o + 1] = u.green, this.data[o + 2] = u.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
        u = this.palette[c], this.data[o + 4] = u.blue, this.data[o + 4 + 1] = u.green, this.data[o + 4 + 2] = u.red, this.data[o + 4 + 3] = 255;
      }
      0 !== e && (this.pos += 4 - e);
    }
  }, qe.prototype.bit8 = function () {
    for (var t = this.width % 4, e = this.height - 1; e >= 0; e--) {
      for (var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++) {
        var i = this.datav.getUint8(this.pos++, !0),
          a = r * this.width * 4 + 4 * n;
        if (i < this.palette.length) {
          var o = this.palette[i];
          this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
        } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
      }
      0 !== t && (this.pos += 4 - t);
    }
  }, qe.prototype.bit15 = function () {
    for (var t = this.width % 3, e = parseInt("11111", 2), r = this.height - 1; r >= 0; r--) {
      for (var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++) {
        var a = this.datav.getUint16(this.pos, !0);
        this.pos += 2;
        var o = (a & e) / e * 255 | 0,
          s = (a >> 5 & e) / e * 255 | 0,
          c = (a >> 10 & e) / e * 255 | 0,
          u = a >> 15 ? 255 : 0,
          h = n * this.width * 4 + 4 * i;
        this.data[h] = c, this.data[h + 1] = s, this.data[h + 2] = o, this.data[h + 3] = u;
      }
      this.pos += t;
    }
  }, qe.prototype.bit16 = function () {
    for (var t = this.width % 3, e = parseInt("11111", 2), r = parseInt("111111", 2), n = this.height - 1; n >= 0; n--) {
      for (var i = this.bottom_up ? n : this.height - 1 - n, a = 0; a < this.width; a++) {
        var o = this.datav.getUint16(this.pos, !0);
        this.pos += 2;
        var s = (o & e) / e * 255 | 0,
          c = (o >> 5 & r) / r * 255 | 0,
          u = (o >> 11) / e * 255 | 0,
          h = i * this.width * 4 + 4 * a;
        this.data[h] = u, this.data[h + 1] = c, this.data[h + 2] = s, this.data[h + 3] = 255;
      }
      this.pos += t;
    }
  }, qe.prototype.bit24 = function () {
    for (var t = this.height - 1; t >= 0; t--) {
      for (var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++) {
        var n = this.datav.getUint8(this.pos++, !0),
          i = this.datav.getUint8(this.pos++, !0),
          a = this.datav.getUint8(this.pos++, !0),
          o = e * this.width * 4 + 4 * r;
        this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = n, this.data[o + 3] = 255;
      }
      this.pos += this.width % 4;
    }
  }, qe.prototype.bit32 = function () {
    for (var t = this.height - 1; t >= 0; t--) for (var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++) {
      var n = this.datav.getUint8(this.pos++, !0),
        i = this.datav.getUint8(this.pos++, !0),
        a = this.datav.getUint8(this.pos++, !0),
        o = this.datav.getUint8(this.pos++, !0),
        s = e * this.width * 4 + 4 * r;
      this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = n, this.data[s + 3] = o;
    }
  }, qe.prototype.getData = function () {
    return this.data;
  },
  /**
     * @license
     * Copyright (c) 2018 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    t.processBMP = function (e, r, n, i) {
      var a = new qe(e, !1),
        o = a.width,
        s = a.height,
        c = {
          data: a.getData(),
          width: o,
          height: s
        },
        u = new Ee(100).encode(c, 100);
      return t.processJPEG.call(this, u, r, n, i);
    };
  }(M.API), De.prototype.getData = function () {
    return this.data;
  },
  /**
     * @license
     * Copyright (c) 2019 Aras Abbasi
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    t.processWEBP = function (e, r, n, i) {
      var a = new De(e, !1),
        o = a.width,
        s = a.height,
        c = {
          data: a.getData(),
          width: o,
          height: s
        },
        u = new Ee(100).encode(c, 100);
      return t.processJPEG.call(this, u, r, n, i);
    };
  }(M.API),
  /**
     * @license
     *
     * Copyright (c) 2021 Antti Palola, https://github.com/Pantura
     *
     * Permission is hereby granted, free of charge, to any person obtaining
     * a copy of this software and associated documentation files (the
     * "Software"), to deal in the Software without restriction, including
     * without limitation the rights to use, copy, modify, merge, publish,
     * distribute, sublicense, and/or sell copies of the Software, and to
     * permit persons to whom the Software is furnished to do so, subject to
     * the following conditions:
     *
     * The above copyright notice and this permission notice shall be
     * included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     * ====================================================================
     */
  function (t) {
    t.processRGBA = function (t, e, r) {
      for (var n = t.data, i = n.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, c = 0, u = 0; u < i; u += 4) {
        var h = n[u],
          l = n[u + 1],
          f = n[u + 2],
          d = n[u + 3];
        a[s++] = h, a[s++] = l, a[s++] = f, o[c++] = d;
      }
      var p = this.__addimage__.arrayBufferToBinaryString(a);
      return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: r,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
      };
    };
  }(M.API),
  /**
     * @license
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    t.setLanguage = function (t) {
      return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== {
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
      }[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function () {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
      }), this.internal.languageSettings.isSubscribed = !0)), this;
    };
  }(M.API), ke = M.API, Fe = ke.getCharWidthsArray = function (t, r) {
    var n,
      i,
      a = (r = r || {}).font || this.internal.getFont(),
      o = r.fontSize || this.internal.getFontSize(),
      s = r.charSpace || this.internal.getCharSpace(),
      c = r.widths ? r.widths : a.metadata.Unicode.widths,
      u = c.fof ? c.fof : 1,
      h = r.kerning ? r.kerning : a.metadata.Unicode.kerning,
      l = h.fof ? h.fof : 1,
      f = !1 !== r.doKerning,
      d = 0,
      p = t.length,
      g = 0,
      m = c[0] || u,
      v = [];
    for (n = 0; n < p; n++) i = t.charCodeAt(n), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === e(h[i]) && !isNaN(parseInt(h[i][g], 10)) ? h[i][g] / l : 0, v.push((c[i] || m) / u + d)), g = i;
    return v;
  }, Ie = ke.getStringUnitWidth = function (t, e) {
    var r = (e = e || {}).fontSize || this.internal.getFontSize(),
      n = e.font || this.internal.getFont(),
      i = e.charSpace || this.internal.getCharSpace();
    return ke.processArabic && (t = ke.processArabic(t)), "function" == typeof n.metadata.widthOfString ? n.metadata.widthOfString(t, r, i) / r : Fe.apply(this, arguments).reduce(function (t, e) {
      return t + e;
    }, 0);
  }, Ce = function (t, e, r, n) {
    for (var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < r;) s += e[a], a++;
    i.push(t.slice(0, a));
    var c = a;
    for (s = 0; a !== o;) s + e[a] > n && (i.push(t.slice(c, a)), s = 0, c = a), s += e[a], a++;
    return c !== a && i.push(t.slice(c, a)), i;
  }, je = function (t, e, r) {
    r || (r = {});
    var n,
      i,
      a,
      o,
      s,
      c,
      u,
      h = [],
      l = [h],
      f = r.textIndent || 0,
      d = 0,
      p = 0,
      g = t.split(" "),
      m = Fe.apply(this, [" ", r])[0];
    if (c = -1 === r.lineIndent ? g[0].length + 2 : r.lineIndent || 0) {
      var v = Array(c).join(" "),
        b = [];
      g.map(function (t) {
        (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function (t, e) {
          return (e && t.length ? "\n" : "") + t;
        })) : b.push(t[0]);
      }), g = b, c = Ie.apply(this, [v, r]);
    }
    for (a = 0, o = g.length; a < o; a++) {
      var y = 0;
      if (n = g[a], c && "\n" == n[0] && (n = n.substr(1), y = 1), f + d + (p = (i = Fe.apply(this, [n, r])).reduce(function (t, e) {
        return t + e;
      }, 0)) > e || y) {
        if (p > e) {
          for (s = Ce.apply(this, [n, i, e - (f + d), e]), h.push(s.shift()), h = [s.pop()]; s.length;) l.push([s.shift()]);
          p = i.slice(n.length - (h[0] ? h[0].length : 0)).reduce(function (t, e) {
            return t + e;
          }, 0);
        } else h = [n];
        l.push(h), f = p + c, d = m;
      } else h.push(n), f += d + p, d = m;
    }
    return u = c ? function (t, e) {
      return (e ? v : "") + t.join(" ");
    } : function (t) {
      return t.join(" ");
    }, l.map(u);
  }, ke.splitTextToSize = function (t, e, r) {
    var n,
      i = (r = r || {}).fontSize || this.internal.getFontSize(),
      a = function (t) {
        if (t.widths && t.kerning) return {
          widths: t.widths,
          kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle);
        return e.metadata.Unicode ? {
          widths: e.metadata.Unicode.widths || {
            0: 1
          },
          kerning: e.metadata.Unicode.kerning || {}
        } : {
          font: e.metadata,
          fontSize: this.internal.getFontSize(),
          charSpace: this.internal.getCharSpace()
        };
      }.call(this, r);
    n = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = r.textIndent ? 1 * r.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = r.lineIndent;
    var s,
      c,
      u = [];
    for (s = 0, c = n.length; s < c; s++) u = u.concat(je.apply(this, [n[s], o, a]));
    return u;
  }, function (t) {
    t.__fontmetrics__ = t.__fontmetrics__ || {};
    for (var r = "klmnopqrstuvwxyz", n = {}, i = {}, a = 0; a < r.length; a++) n[r[a]] = "0123456789abcdef"[a], i["0123456789abcdef"[a]] = r[a];
    var o = function (t) {
        return "0x" + parseInt(t, 10).toString(16);
      },
      s = t.__fontmetrics__.compress = function (t) {
        var r,
          n,
          a,
          c,
          u = ["{"];
        for (var h in t) {
          if (r = t[h], isNaN(parseInt(h, 10)) ? n = "'" + h + "'" : (h = parseInt(h, 10), n = (n = o(h).slice(2)).slice(0, -1) + i[n.slice(-1)]), "number" == typeof r) r < 0 ? (a = o(r).slice(3), c = "-") : (a = o(r).slice(2), c = ""), a = c + a.slice(0, -1) + i[a.slice(-1)];else {
            if ("object" !== e(r)) throw new Error("Don't know what to do with value type " + e(r) + ".");
            a = s(r);
          }
          u.push(n + a);
        }
        return u.push("}"), u.join("");
      },
      c = t.__fontmetrics__.uncompress = function (t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for (var e, r, i, a, o = {}, s = 1, c = o, u = [], h = "", l = "", f = t.length - 1, d = 1; d < f; d += 1) "'" == (a = t[d]) ? e ? (i = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (u.push([c, i]), c = {}, i = void 0) : "}" == a ? ((r = u.pop())[0][r[1]] = c, i = void 0, c = r[0]) : "-" == a ? s = -1 : void 0 === i ? n.hasOwnProperty(a) ? (h += n[a], i = parseInt(h, 16) * s, s = 1, h = "") : h += a : n.hasOwnProperty(a) ? (l += n[a], c[i] = parseInt(l, 16) * s, s = 1, i = void 0, l = "") : l += a;
        return o;
      },
      u = {
        codePages: ["WinAnsiEncoding"],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
      },
      h = {
        Unicode: {
          Courier: u,
          "Courier-Bold": u,
          "Courier-BoldOblique": u,
          "Courier-Oblique": u,
          Helvetica: u,
          "Helvetica-Bold": u,
          "Helvetica-BoldOblique": u,
          "Helvetica-Oblique": u,
          "Times-Roman": u,
          "Times-Bold": u,
          "Times-BoldItalic": u,
          "Times-Italic": u
        }
      },
      l = {
        Unicode: {
          "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
          "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
          "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
          Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
          "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
          "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
          Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
          Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
          "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
          ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
          "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
          "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
          "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
          "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
      };
    t.events.push(["addFont", function (t) {
      var e = t.font,
        r = l.Unicode[e.postScriptName];
      r && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = r.widths, e.metadata.Unicode.kerning = r.kerning);
      var n = h.Unicode[e.postScriptName];
      n && (e.metadata.Unicode.encoding = n, e.encoding = n.codePages[0]);
    }]);
  }(M.API),
  /**
     * @license
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    var e = function (t) {
      for (var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++) r[n] = t.charCodeAt(n);
      return r;
    };
    t.API.events.push(["addFont", function (r) {
      var n = void 0,
        i = r.font,
        a = r.instance;
      if (!i.isStandardFont) {
        if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
        if ("string" != typeof (n = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
        !function (r, n) {
          n = /^\x00\x01\x00\x00/.test(n) ? e(n) : e(c(n)), r.metadata = t.API.TTFFont.open(n), r.metadata.Unicode = r.metadata.Unicode || {
            encoding: {},
            kerning: {},
            widths: []
          }, r.metadata.glyIdsUsed = [0];
        }(i, n);
      }
    }]);
  }(M), function (n) {
    function a() {
      return (r.canvg ? Promise.resolve(r.canvg) : Promise.reject(new Error("Could not load canvg"))).catch(function (t) {
        return Promise.reject(new Error("Could not load canvg: " + t));
      }).then(function (t) {
        return t.default ? t.default : t;
      });
    }
    n.addSvgAsImage = function (t, e, r, n, o, s, c, u) {
      if (isNaN(e) || isNaN(r)) throw i.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
      if (isNaN(n) || isNaN(o)) throw i.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
      var h = document.createElement("canvas");
      h.width = n, h.height = o;
      var l = h.getContext("2d");
      l.fillStyle = "#fff", l.fillRect(0, 0, h.width, h.height);
      var f = {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0
        },
        d = this;
      return a().then(function (e) {
        return e.fromString(l, t, f);
      }, function () {
        return Promise.reject(new Error("Could not load canvg."));
      }).then(function (t) {
        return t.render(f);
      }).then(function () {
        d.addImage(h.toDataURL("image/jpeg", 1), e, r, n, o, c, u);
      });
    };
  }(M.API),
  /**
     * @license
     * ====================================================================
     * Copyright (c) 2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
     *
     * Permission is hereby granted, free of charge, to any person obtaining
     * a copy of this software and associated documentation files (the
     * "Software"), to deal in the Software without restriction, including
     * without limitation the rights to use, copy, modify, merge, publish,
     * distribute, sublicense, and/or sell copies of the Software, and to
     * permit persons to whom the Software is furnished to do so, subject to
     * the following conditions:
     *
     * The above copyright notice and this permission notice shall be
     * included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     * ====================================================================
     */
  function (t) {
    t.putTotalPages = function (t) {
      var e,
        r = 0;
      parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), r = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), r = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
      for (var n = 1; n <= this.internal.getNumberOfPages(); n++) for (var i = 0; i < this.internal.pages[n].length; i++) this.internal.pages[n][i] = this.internal.pages[n][i].replace(e, r);
      return this;
    };
  }(M.API), function (t) {
    t.viewerPreferences = function (t, r) {
      var n;
      t = t || {}, r = r || !1;
      var i,
        a,
        o,
        s = {
          HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [!0, !1],
            pdfVersion: 1.3
          },
          HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [!0, !1],
            pdfVersion: 1.3
          },
          HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [!0, !1],
            pdfVersion: 1.3
          },
          FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [!0, !1],
            pdfVersion: 1.3
          },
          CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [!0, !1],
            pdfVersion: 1.3
          },
          DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [!0, !1],
            pdfVersion: 1.4
          },
          NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"],
            pdfVersion: 1.3
          },
          Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: ["L2R", "R2L"],
            pdfVersion: 1.3
          },
          ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"],
            pdfVersion: 1.4
          },
          ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"],
            pdfVersion: 1.4
          },
          PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"],
            pdfVersion: 1.4
          },
          PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"],
            pdfVersion: 1.4
          },
          PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: ["AppDefault", "None"],
            pdfVersion: 1.6
          },
          Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"],
            pdfVersion: 1.7
          },
          PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [!0, !1],
            pdfVersion: 1.7
          },
          PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
          },
          NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
          }
        },
        c = Object.keys(s),
        u = [],
        h = 0,
        l = 0,
        f = 0;
      function d(t, e) {
        var r,
          n = !1;
        for (r = 0; r < t.length; r += 1) t[r] === e && (n = !0);
        return n;
      }
      if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === t || !0 === r) {
        var p = c.length;
        for (f = 0; f < p; f += 1) n[c[f]].value = n[c[f]].defaultValue, n[c[f]].explicitSet = !1;
      }
      if ("object" === e(t)) for (a in t) if (o = t[a], d(c, a) && void 0 !== o) {
        if ("boolean" === n[a].type && "boolean" == typeof o) n[a].value = o;else if ("name" === n[a].type && d(n[a].valueSet, o)) n[a].value = o;else if ("integer" === n[a].type && Number.isInteger(o)) n[a].value = o;else if ("array" === n[a].type) {
          for (h = 0; h < o.length; h += 1) if (i = !0, 1 === o[h].length && "number" == typeof o[h][0]) u.push(String(o[h] - 1));else if (o[h].length > 1) {
            for (l = 0; l < o[h].length; l += 1) "number" != typeof o[h][l] && (i = !1);
            !0 === i && u.push([o[h][0] - 1, o[h][1] - 1].join(" "));
          }
          n[a].value = "[" + u.join(" ") + "]";
        } else n[a].value = n[a].defaultValue;
        n[a].explicitSet = !0;
      }
      return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function () {
        var t,
          e = [];
        for (t in n) !0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
      }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
    };
  }(M.API),
  /** ====================================================================
     * @license
     * jsPDF XMP metadata plugin
     * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
     *
     * Permission is hereby granted, free of charge, to any person obtaining
     * a copy of this software and associated documentation files (the
     * "Software"), to deal in the Software without restriction, including
     * without limitation the rights to use, copy, modify, merge, publish,
     * distribute, sublicense, and/or sell copies of the Software, and to
     * permit persons to whom the Software is furnished to do so, subject to
     * the following conditions:
     *
     * The above copyright notice and this permission notice shall be
     * included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
     * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
     * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
     * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
     * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     * ====================================================================
     */
  function (t) {
    var e = function () {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>',
          e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),
          r = unescape(encodeURIComponent(t)),
          n = unescape(encodeURIComponent(this.internal.__metadata__.metadata)),
          i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),
          a = unescape(encodeURIComponent("</x:xmpmeta>")),
          o = r.length + n.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + r + n + i + a), this.internal.write("endstream"), this.internal.write("endobj");
      },
      r = function () {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
      };
    t.addMetadata = function (t, n) {
      return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
        metadata: t,
        namespaceuri: n || "http://jspdf.default.namespaceuri/"
      }, this.internal.events.subscribe("putCatalog", r), this.internal.events.subscribe("postPutResources", e)), this;
    };
  }(M.API), function (t) {
    var e = t.API,
      r = e.pdfEscape16 = function (t, e) {
        for (var r, n = e.metadata.Unicode.widths, i = ["", "0", "00", "000", "0000"], a = [""], o = 0, s = t.length; o < s; ++o) {
          if (r = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(r), e.metadata.toUnicode[r] = t.charCodeAt(o), -1 == n.indexOf(r) && (n.push(r), n.push([parseInt(e.metadata.widthOfGlyph(r), 10)])), "0" == r) return a.join("");
          r = r.toString(16), a.push(i[4 - r.length], r);
        }
        return a.join("");
      },
      n = function (t) {
        var e, r, n, i, a, o, s;
        for (a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", n = [], o = 0, s = (r = Object.keys(t).sort(function (t, e) {
          return t - e;
        })).length; o < s; o++) e = r[o], n.length >= 100 && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar", n = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), n.push("<" + e + "><" + i + ">"));
        return n.length && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar\n"), a += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
      };
    e.events.push(["putFont", function (e) {
      !function (e) {
        var r = e.font,
          i = e.out,
          a = e.newObject,
          o = e.putStream;
        if (r.metadata instanceof t.API.TTFFont && "Identity-H" === r.encoding) {
          for (var s = r.metadata.Unicode.widths, c = r.metadata.subset.encode(r.metadata.glyIdsUsed, 1), u = "", h = 0; h < c.length; h++) u += String.fromCharCode(c[h]);
          var l = a();
          o({
            data: u,
            addLength1: !0,
            objectId: l
          }), i("endobj");
          var f = a();
          o({
            data: n(r.metadata.toUnicode),
            addLength1: !0,
            objectId: f
          }), i("endobj");
          var d = a();
          i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + F(r.fontName)), i("/FontFile2 " + l + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/Flags " + r.metadata.flags), i("/StemV " + r.metadata.stemV), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i(">>"), i("endobj");
          var p = a();
          i("<<"), i("/Type /Font"), i("/BaseFont /" + F(r.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + r.encoding + ")"), i(">>"), i(">>"), i("endobj"), r.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + F(r.fontName)), i("/Encoding /" + r.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), r.isAlreadyPutted = !0;
        }
      }(e);
    }]);
    e.events.push(["putFont", function (e) {
      !function (e) {
        var r = e.font,
          i = e.out,
          a = e.newObject,
          o = e.putStream;
        if (r.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === r.encoding) {
          for (var s = r.metadata.rawData, c = "", u = 0; u < s.length; u++) c += String.fromCharCode(s[u]);
          var h = a();
          o({
            data: c,
            addLength1: !0,
            objectId: h
          }), i("endobj");
          var l = a();
          o({
            data: n(r.metadata.toUnicode),
            addLength1: !0,
            objectId: l
          }), i("endobj");
          var f = a();
          i("<<"), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i("/StemV " + r.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + h + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/FontName /" + F(r.fontName)), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i(">>"), i("endobj"), r.objectNumber = a();
          for (var d = 0; d < r.metadata.hmtx.widths.length; d++) r.metadata.hmtx.widths[d] = parseInt(r.metadata.hmtx.widths[d] * (1e3 / r.metadata.head.unitsPerEm));
          i("<</Subtype/TrueType/Type/Font/ToUnicode " + l + " 0 R/BaseFont/" + F(r.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + r.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(r.metadata.hmtx.widths) + ">>"), i("endobj"), r.isAlreadyPutted = !0;
        }
      }(e);
    }]);
    var i = function (t) {
      var e,
        n = t.text || "",
        i = t.x,
        a = t.y,
        o = t.options || {},
        s = t.mutex || {},
        c = s.pdfEscape,
        u = s.activeFontKey,
        h = s.fonts,
        l = u,
        f = "",
        d = 0,
        p = "",
        g = h[l].encoding;
      if ("Identity-H" !== h[l].encoding) return {
        text: n,
        x: i,
        y: a,
        options: o,
        mutex: s
      };
      for (p = n, l = u, Array.isArray(n) && (p = n[0]), d = 0; d < p.length; d += 1) h[l].metadata.hasOwnProperty("cmap") && (e = h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && h[l].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
      var m = "";
      return parseInt(l.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = c(f, l).split("").map(function (t) {
        return t.charCodeAt(0).toString(16);
      }).join("") : "Identity-H" === g && (m = r(f, h[l])), s.isHex = !0, {
        text: m,
        x: i,
        y: a,
        options: o,
        mutex: s
      };
    };
    e.events.push(["postProcessText", function (t) {
      var e = t.text || "",
        r = [],
        n = {
          text: e,
          x: t.x,
          y: t.y,
          options: t.options,
          mutex: t.mutex
        };
      if (Array.isArray(e)) {
        var a = 0;
        for (a = 0; a < e.length; a += 1) Array.isArray(e[a]) && 3 === e[a].length ? r.push([i(Object.assign({}, n, {
          text: e[a][0]
        })).text, e[a][1], e[a][2]]) : r.push(i(Object.assign({}, n, {
          text: e[a]
        })).text);
        t.text = r;
      } else t.text = i(Object.assign({}, n, {
        text: e
      })).text;
    }]);
  }(M),
  /**
     * @license
     * jsPDF virtual FileSystem functionality
     *
     * Licensed under the MIT License.
     * http://opensource.org/licenses/mit-license
     */
  function (t) {
    var e = function () {
      return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function (t) {
      return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function (t, r) {
      return e.call(this), this.internal.vFS[t] = r, this;
    }, t.getFileFromVFS = function (t) {
      return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
  }(M.API),
  /**
     * @license
     * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
     * MIT License
     */
  function (t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function (t) {
      var r,
        n,
        i,
        a,
        o,
        s,
        c,
        u = e,
        h = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]],
        l = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]],
        f = {
          L: 0,
          R: 1,
          EN: 2,
          AN: 3,
          N: 4,
          B: 5,
          S: 6
        },
        d = {
          0: 0,
          5: 1,
          6: 2,
          7: 3,
          32: 4,
          251: 5,
          254: 6,
          255: 7
        },
        p = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "�?�", "�?�", "�?�", "�?�", "�?�", "�?�", "�?", "₎", "�?", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "�?", "﹞", "�?", "﹤", "﹥", "﹤"],
        g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),
        m = !1,
        v = 0;
      this.__bidiEngine__ = {};
      var b = function (t) {
          var e = t.charCodeAt(),
            r = e >> 8,
            n = d[r];
          return void 0 !== n ? u[256 * n + (255 & e)] : 252 === r || 253 === r ? "AL" : g.test(r) ? "L" : 8 === r ? "R" : "N";
        },
        y = function (t) {
          for (var e, r = 0; r < t.length; r++) {
            if ("L" === (e = b(t.charAt(r)))) return !1;
            if ("R" === e) return !0;
          }
          return !1;
        },
        w = function (t, e, o, s) {
          var c,
            u,
            h,
            l,
            f = e[s];
          switch (f) {
            case "L":
            case "R":
              m = !1;
              break;
            case "N":
            case "AN":
              break;
            case "EN":
              m && (f = "AN");
              break;
            case "AL":
              m = !0, f = "R";
              break;
            case "WS":
              f = "N";
              break;
            case "CS":
              s < 1 || s + 1 >= e.length || "EN" !== (c = o[s - 1]) && "AN" !== c || "EN" !== (u = e[s + 1]) && "AN" !== u ? f = "N" : m && (u = "AN"), f = u === c ? u : "N";
              break;
            case "ES":
              f = "EN" === (c = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
              break;
            case "ET":
              if (s > 0 && "EN" === o[s - 1]) {
                f = "EN";
                break;
              }
              if (m) {
                f = "N";
                break;
              }
              for (h = s + 1, l = e.length; h < l && "ET" === e[h];) h++;
              f = h < l && "EN" === e[h] ? "EN" : "N";
              break;
            case "NSM":
              if (i && !a) {
                for (l = e.length, h = s + 1; h < l && "NSM" === e[h];) h++;
                if (h < l) {
                  var d = t[s],
                    p = d >= 1425 && d <= 2303 || 64286 === d;
                  if (c = e[h], p && ("R" === c || "AL" === c)) {
                    f = "R";
                    break;
                  }
                }
              }
              f = s < 1 || "B" === (c = e[s - 1]) ? "N" : o[s - 1];
              break;
            case "B":
              m = !1, r = !0, f = v;
              break;
            case "S":
              n = !0, f = "N";
              break;
            case "LRE":
            case "RLE":
            case "LRO":
            case "RLO":
            case "PDF":
              m = !1;
              break;
            case "BN":
              f = "N";
          }
          return f;
        },
        N = function (t, e, r) {
          var n = t.split("");
          return r && L(n, r, {
            hiLevel: v
          }), n.reverse(), e && e.reverse(), n.join("");
        },
        L = function (t, e, i) {
          var a,
            o,
            s,
            c,
            u,
            d = -1,
            p = t.length,
            g = 0,
            y = [],
            N = v ? l : h,
            L = [];
          for (m = !1, r = !1, n = !1, o = 0; o < p; o++) L[o] = b(t[o]);
          for (s = 0; s < p; s++) {
            if (u = g, y[s] = w(t, L, y, s), a = 240 & (g = N[u][f[y[s]]]), g &= 15, e[s] = c = N[g][5], a > 0) if (16 === a) {
              for (o = d; o < s; o++) e[o] = 1;
              d = -1;
            } else d = -1;
            if (N[g][6]) -1 === d && (d = s);else if (d > -1) {
              for (o = d; o < s; o++) e[o] = c;
              d = -1;
            }
            "B" === L[s] && (e[s] = 0), i.hiLevel |= c;
          }
          n && function (t, e, r) {
            for (var n = 0; n < r; n++) if ("S" === t[n]) {
              e[n] = v;
              for (var i = n - 1; i >= 0 && "WS" === t[i]; i--) e[i] = v;
            }
          }(L, e, p);
        },
        A = function (t, e, n, i, a) {
          if (!(a.hiLevel < t)) {
            if (1 === t && 1 === v && !r) return e.reverse(), void (n && n.reverse());
            for (var o, s, c, u, h = e.length, l = 0; l < h;) {
              if (i[l] >= t) {
                for (c = l + 1; c < h && i[c] >= t;) c++;
                for (u = l, s = c - 1; u < s; u++, s--) o = e[u], e[u] = e[s], e[s] = o, n && (o = n[u], n[u] = n[s], n[s] = o);
                l = c;
              }
              l++;
            }
          }
        },
        x = function (t, e, r) {
          var n = t.split(""),
            i = {
              hiLevel: v
            };
          return r || (r = []), L(n, r, i), function (t, e, r) {
            if (0 !== r.hiLevel && c) for (var n, i = 0; i < t.length; i++) 1 === e[i] && (n = p.indexOf(t[i])) >= 0 && (t[i] = p[n + 1]);
          }(n, r, i), A(2, n, e, r, i), A(1, n, e, r, i), n.join("");
        };
      return this.__bidiEngine__.doBidiReorder = function (t, e, r) {
        if (function (t, e) {
          if (e) for (var r = 0; r < t.length; r++) e[r] = r;
          void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
        }(t, e), i || !o || s) {
          if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, r);else if (!i && o && s) v = a ? 1 : 0, t = x(t, e, r), t = N(t, e);else if (!i || a || o || s) {
            if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = x(t, e, r)) : (v = 1, t = x(t, e, r), t = N(t, e));else if (i && a && !o && s) v = 1, t = x(t, e, r), t = N(t, e);else if (!i && !o && a ^ s) {
              var n = c;
              a ? (v = 1, t = x(t, e, r), v = 0, c = !1, t = x(t, e, r), c = n) : (v = 0, t = x(t, e, r), t = N(t, e), v = 1, c = !1, t = x(t, e, r), c = n, t = N(t, e));
            }
          } else v = 0, t = x(t, e, r);
        } else v = a ? 1 : 0, t = x(t, e, r);
        return t;
      }, this.__bidiEngine__.setOptions = function (t) {
        t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, c = t.isSymmetricSwapping);
      }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"],
      r = new t.__bidiEngine__({
        isInputVisual: !0
      });
    t.API.events.push(["postProcessText", function (t) {
      var e = t.text,
        n = (t.x, t.y, t.options || {}),
        i = (t.mutex, n.lang, []);
      if (n.isInputVisual = "boolean" != typeof n.isInputVisual || n.isInputVisual, r.setOptions(n), "[object Array]" === Object.prototype.toString.call(e)) {
        var a = 0;
        for (i = [], a = 0; a < e.length; a += 1) "[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([r.doBidiReorder(e[a][0]), e[a][1], e[a][2]]) : i.push([r.doBidiReorder(e[a])]);
        t.text = i;
      } else t.text = r.doBidiReorder(e);
      r.setOptions({
        isInputVisual: !0
      });
    }]);
  }(M), M.API.TTFFont = function () {
    function t(t) {
      var e;
      if (this.rawData = t, e = this.contents = new Te(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
      e.pos = 0, this.parse(), this.subset = new ar(this), this.registerTTF();
    }
    return t.open = function (e) {
      return new t(e);
    }, t.prototype.parse = function () {
      return this.directory = new Ue(this.contents), this.head = new We(this), this.name = new Ze(this), this.cmap = new Ge(this), this.toUnicode = {}, this.hhea = new Ye(this), this.maxp = new $e(this), this.hmtx = new Qe(this), this.post = new Xe(this), this.os2 = new Je(this), this.loca = new ir(this), this.glyf = new er(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
    }, t.prototype.registerTTF = function () {
      var t, e, r, n, i;
      if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = function () {
        var e, r, n, i;
        for (i = [], e = 0, r = (n = this.bbox).length; e < r; e++) t = n[e], i.push(Math.round(t * this.scaleFactor));
        return i;
      }.call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 0 != (32768 & (e = n >> 16)) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function (t) {
      var e;
      return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function (t) {
      var e;
      return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function (t, e, r) {
      var n, i, a, o;
      for (a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i) n = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
      return a * (e / 1e3);
    }, t.prototype.lineHeight = function (t, e) {
      var r;
      return null == e && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * t;
    }, t;
  }();
  var Re,
    Te = function () {
      function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
      }
      return t.prototype.readByte = function () {
        return this.data[this.pos++];
      }, t.prototype.writeByte = function (t) {
        return this.data[this.pos++] = t;
      }, t.prototype.readUInt32 = function () {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
      }, t.prototype.writeUInt32 = function (t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
      }, t.prototype.readInt32 = function () {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
      }, t.prototype.writeInt32 = function (t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
      }, t.prototype.readUInt16 = function () {
        return this.readByte() << 8 | this.readByte();
      }, t.prototype.writeUInt16 = function (t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
      }, t.prototype.readInt16 = function () {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
      }, t.prototype.writeInt16 = function (t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
      }, t.prototype.readString = function (t) {
        var e, r;
        for (r = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e) r[e] = String.fromCharCode(this.readByte());
        return r.join("");
      }, t.prototype.writeString = function (t) {
        var e, r, n;
        for (n = [], e = 0, r = t.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e) n.push(this.writeByte(t.charCodeAt(e)));
        return n;
      }, t.prototype.readShort = function () {
        return this.readInt16();
      }, t.prototype.writeShort = function (t) {
        return this.writeInt16(t);
      }, t.prototype.readLongLong = function () {
        var t, e, r, n, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * a + 256 * o + s;
      }, t.prototype.writeLongLong = function (t) {
        var e, r;
        return e = Math.floor(t / 4294967296), r = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
      }, t.prototype.readInt = function () {
        return this.readInt32();
      }, t.prototype.writeInt = function (t) {
        return this.writeInt32(t);
      }, t.prototype.read = function (t) {
        var e, r;
        for (e = [], r = 0; 0 <= t ? r < t : r > t; r = 0 <= t ? ++r : --r) e.push(this.readByte());
        return e;
      }, t.prototype.write = function (t) {
        var e, r, n, i;
        for (i = [], r = 0, n = t.length; r < n; r++) e = t[r], i.push(this.writeByte(e));
        return i;
      }, t;
    }(),
    Ue = function () {
      var t;
      function e(t) {
        var e, r, n;
        for (this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, r = 0, n = this.tableCount; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r) e = {
          tag: t.readString(4),
          checksum: t.readInt(),
          offset: t.readInt(),
          length: t.readInt()
        }, this.tables[e.tag] = e;
      }
      return e.prototype.encode = function (e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p;
        for (p in f = Object.keys(e).length, s = Math.log(2), h = 16 * Math.floor(Math.log(f) / s), a = Math.floor(h / s), u = 16 * f - h, (n = new Te()).writeInt(this.scalarType), n.writeShort(f), n.writeShort(h), n.writeShort(a), n.writeShort(u), i = 16 * f, c = n.pos + i, o = null, d = [], e) for (l = e[p], n.writeString(p), n.writeInt(t(l)), n.writeInt(c), n.writeInt(l.length), d = d.concat(l), "head" === p && (o = c), c += l.length; c % 4;) d.push(0), c++;
        return n.write(d), r = 2981146554 - t(n.data), n.pos = o + 8, n.writeUInt32(r), n.data;
      }, t = function (t) {
        var e, r, n, i;
        for (t = tr.call(t); t.length % 4;) t.push(0);
        for (n = new Te(t), r = 0, e = 0, i = t.length; e < i; e = e += 4) r += n.readUInt32();
        return 4294967295 & r;
      }, e;
    }(),
    ze = {}.hasOwnProperty,
    He = function (t, e) {
      for (var r in e) ze.call(e, r) && (t[r] = e[r]);
      function n() {
        this.constructor = t;
      }
      return n.prototype = e.prototype, t.prototype = new n(), t.__super__ = e.prototype, t;
    },
    We = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "head", e.prototype.parse = function (t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
      }, e.prototype.encode = function (t) {
        var e;
        return (e = new Te()).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
      }, e;
    }(Re = function () {
      function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
      }
      return t.prototype.parse = function () {}, t.prototype.encode = function () {}, t.prototype.raw = function () {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
      }, t;
    }()),
    Ve = function () {
      function t(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b;
        switch (this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), h = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format) {
          case 0:
            for (s = 0; s < 256; ++s) this.codeMap[s] = t.readByte();
            break;
          case 4:
            for (f = t.readUInt16(), l = f / 2, t.pos += 6, i = function () {
              var e, r;
              for (r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e) r.push(t.readUInt16());
              return r;
            }(), t.pos += 2, p = function () {
              var e, r;
              for (r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e) r.push(t.readUInt16());
              return r;
            }(), c = function () {
              var e, r;
              for (r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e) r.push(t.readUInt16());
              return r;
            }(), u = function () {
              var e, r;
              for (r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e) r.push(t.readUInt16());
              return r;
            }(), n = (this.length - t.pos + this.offset) / 2, o = function () {
              var e, r;
              for (r = [], s = e = 0; 0 <= n ? e < n : e > n; s = 0 <= n ? ++e : --e) r.push(t.readUInt16());
              return r;
            }(), s = m = 0, b = i.length; m < b; s = ++m) for (g = i[s], r = v = d = p[s]; d <= g ? v <= g : v >= g; r = d <= g ? ++v : --v) 0 === u[s] ? a = r + c[s] : 0 !== (a = o[u[s] / 2 + (r - d) - (l - s)] || 0) && (a += c[s]), this.codeMap[r] = 65535 & a;
        }
        t.pos = h;
      }
      return t.encode = function (t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, F, I, C, j, O, B, M, E, q, D, R, T, U, z, H, W, V, G, Y;
        switch (F = new Te(), a = Object.keys(t).sort(function (t, e) {
          return t - e;
        }), e) {
          case "macroman":
            for (p = 0, g = function () {
              var t = [];
              for (d = 0; d < 256; ++d) t.push(0);
              return t;
            }(), v = {
              0: 0
            }, i = {}, I = 0, B = a.length; I < B; I++) null == v[W = t[n = a[I]]] && (v[W] = ++p), i[n] = {
              old: t[n],
              new: v[t[n]]
            }, g[n] = v[t[n]];
            return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
              charMap: i,
              subtable: F.data,
              maxGlyphID: p + 1
            };
          case "unicode":
            for (P = [], h = [], b = 0, v = {}, r = {}, m = c = null, C = 0, M = a.length; C < M; C++) null == v[w = t[n = a[C]]] && (v[w] = ++b), r[n] = {
              old: w,
              new: v[w]
            }, o = v[w] - n, null != m && o === c || (m && h.push(m), P.push(n), c = o), m = n;
            for (m && h.push(m), h.push(65535), P.push(65535), S = 2 * (x = P.length), A = 2 * Math.pow(Math.log(x) / Math.LN2, 2), l = Math.log(A / 2) / Math.LN2, L = 2 * x - A, s = [], N = [], f = [], d = j = 0, E = P.length; j < E; d = ++j) {
              if (_ = P[d], u = h[d], 65535 === _) {
                s.push(0), N.push(0);
                break;
              }
              if (_ - (k = r[_].new) >= 32768) for (s.push(0), N.push(2 * (f.length + x - d)), n = O = _; _ <= u ? O <= u : O >= u; n = _ <= u ? ++O : --O) f.push(r[n].new);else s.push(k - _), N.push(0);
            }
            for (F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * x + 2 * f.length), F.writeUInt16(0), F.writeUInt16(S), F.writeUInt16(A), F.writeUInt16(l), F.writeUInt16(L), z = 0, q = h.length; z < q; z++) n = h[z], F.writeUInt16(n);
            for (F.writeUInt16(0), H = 0, D = P.length; H < D; H++) n = P[H], F.writeUInt16(n);
            for (V = 0, R = s.length; V < R; V++) o = s[V], F.writeUInt16(o);
            for (G = 0, T = N.length; G < T; G++) y = N[G], F.writeUInt16(y);
            for (Y = 0, U = f.length; Y < U; Y++) p = f[Y], F.writeUInt16(p);
            return {
              charMap: r,
              subtable: F.data,
              maxGlyphID: b + 1
            };
        }
      }, t;
    }(),
    Ge = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "cmap", e.prototype.parse = function (t) {
        var e, r, n;
        for (t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r) e = new Ve(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
      }, e.encode = function (t, e) {
        var r, n;
        return null == e && (e = "macroman"), r = Ve.encode(t, e), (n = new Te()).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
      }, e;
    }(Re),
    Ye = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "hhea", e.prototype.parse = function (t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
      }, e;
    }(Re),
    Je = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "OS/2", e.prototype.parse = function (t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function () {
          var e, r;
          for (r = [], e = 0; e < 10; ++e) r.push(t.readByte());
          return r;
        }(), this.charRange = function () {
          var e, r;
          for (r = [], e = 0; e < 4; ++e) r.push(t.readInt());
          return r;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function () {
          var e, r;
          for (r = [], e = 0; e < 2; e = ++e) r.push(t.readInt());
          return r;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
      }, e;
    }(Re),
    Xe = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "post", e.prototype.parse = function (t) {
        var e, r, n;
        switch (t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format) {
          case 65536:
            break;
          case 131072:
            var i;
            for (r = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= r ? i < r : i > r; i = 0 <= r ? ++i : --i) this.glyphNameIndex.push(t.readUInt16());
            for (this.names = [], n = []; t.pos < this.offset + this.length;) e = t.readByte(), n.push(this.names.push(t.readString(e)));
            return n;
          case 151552:
            return r = t.readUInt16(), this.offsets = t.read(r);
          case 196608:
            break;
          case 262144:
            return this.map = function () {
              var e, r, n;
              for (n = [], i = e = 0, r = this.file.maxp.numGlyphs; 0 <= r ? e < r : e > r; i = 0 <= r ? ++e : --e) n.push(t.readUInt32());
              return n;
            }.call(this);
        }
      }, e;
    }(Re),
    Ke = function (t, e) {
      this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
    },
    Ze = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "name", e.prototype.parse = function (t) {
        var e, r, n, i, a, o, s, c, u, h, l;
        for (t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), r = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i) r.push({
          platformID: t.readShort(),
          encodingID: t.readShort(),
          languageID: t.readShort(),
          nameID: t.readShort(),
          length: t.readShort(),
          offset: this.offset + o + t.readShort()
        });
        for (s = {}, i = u = 0, h = r.length; u < h; i = ++u) n = r[i], t.pos = n.offset, c = t.readString(n.length), a = new Ke(c, n), null == s[l = n.nameID] && (s[l] = []), s[n.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
          this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (t) {
          this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
      }, e;
    }(Re),
    $e = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "maxp", e.prototype.parse = function (t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
      }, e;
    }(Re),
    Qe = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "hmtx", e.prototype.parse = function (t) {
        var e, r, n, i, a, o, s;
        for (t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e) this.metrics.push({
          advance: t.readUInt16(),
          lsb: t.readInt16()
        });
        for (n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function () {
          var r, i;
          for (i = [], e = r = 0; 0 <= n ? r < n : r > n; e = 0 <= n ? ++r : --r) i.push(t.readInt16());
          return i;
        }(), this.widths = function () {
          var t, e, r, n;
          for (n = [], t = 0, e = (r = this.metrics).length; t < e; t++) i = r[t], n.push(i.advance);
          return n;
        }.call(this), r = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= n ? a < n : a > n; e = 0 <= n ? ++a : --a) s.push(this.widths.push(r));
        return s;
      }, e.prototype.forGlyph = function (t) {
        return t in this.metrics ? this.metrics[t] : {
          advance: this.metrics[this.metrics.length - 1].advance,
          lsb: this.leftSideBearings[t - this.metrics.length]
        };
      }, e;
    }(Re),
    tr = [].slice,
    er = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "glyf", e.prototype.parse = function () {
        return this.cache = {};
      }, e.prototype.glyphFor = function (t) {
        var e, r, n, i, a, o, s, c, u, h;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, r = i.indexOf(t), 0 === (n = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + r, a = (o = new Te(e.read(n))).readShort(), c = o.readShort(), h = o.readShort(), s = o.readShort(), u = o.readShort(), this.cache[t] = -1 === a ? new nr(o, c, h, s, u) : new rr(o, a, c, h, s, u), this.cache[t]));
      }, e.prototype.encode = function (t, e, r) {
        var n, i, a, o, s;
        for (a = [], i = [], o = 0, s = e.length; o < s; o++) n = t[e[o]], i.push(a.length), n && (a = a.concat(n.encode(r)));
        return i.push(a.length), {
          table: a,
          offsets: i
        };
      }, e;
    }(Re),
    rr = function () {
      function t(t, e, r, n, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = a, this.compound = !1;
      }
      return t.prototype.encode = function () {
        return this.raw.data;
      }, t;
    }(),
    nr = function () {
      function t(t, e, r, n, i) {
        var a, o;
        for (this.raw = t, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;) a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
      }
      return 1, 8, 32, 64, 128, t.prototype.encode = function () {
        var t, e, r;
        for (e = new Te(tr.call(this.raw.data)), t = 0, r = this.glyphIDs.length; t < r; ++t) e.pos = this.glyphOffsets[t];
        return e.data;
      }, t;
    }(),
    ir = function (t) {
      function e() {
        return e.__super__.constructor.apply(this, arguments);
      }
      return He(e, t), e.prototype.tag = "loca", e.prototype.parse = function (t) {
        var e, r;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? function () {
          var e, n;
          for (n = [], r = 0, e = this.length; r < e; r += 2) n.push(2 * t.readUInt16());
          return n;
        }.call(this) : function () {
          var e, n;
          for (n = [], r = 0, e = this.length; r < e; r += 4) n.push(t.readUInt32());
          return n;
        }.call(this);
      }, e.prototype.indexOf = function (t) {
        return this.offsets[t];
      }, e.prototype.lengthOf = function (t) {
        return this.offsets[t + 1] - this.offsets[t];
      }, e.prototype.encode = function (t, e) {
        for (var r = new Uint32Array(this.offsets.length), n = 0, i = 0, a = 0; a < r.length; ++a) if (r[a] = n, i < e.length && e[i] == a) {
          ++i, r[a] = n;
          var o = this.offsets[a],
            s = this.offsets[a + 1] - o;
          s > 0 && (n += s);
        }
        for (var c = new Array(4 * r.length), u = 0; u < r.length; ++u) c[4 * u + 3] = 255 & r[u], c[4 * u + 2] = (65280 & r[u]) >> 8, c[4 * u + 1] = (16711680 & r[u]) >> 16, c[4 * u] = (4278190080 & r[u]) >> 24;
        return c;
      }, e;
    }(Re),
    ar = function () {
      function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
      }
      return t.prototype.generateCmap = function () {
        var t, e, r, n, i;
        for (e in n = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset) r = i[e], t[e] = n[r];
        return t;
      }, t.prototype.glyphsFor = function (t) {
        var e, r, n, i, a, o, s;
        for (n = {}, a = 0, o = t.length; a < o; a++) n[i = t[a]] = this.font.glyf.glyphFor(i);
        for (i in e = [], n) (null != (r = n[i]) ? r.compound : void 0) && e.push.apply(e, r.glyphIDs);
        if (e.length > 0) for (i in s = this.glyphsFor(e)) r = s[i], n[i] = r;
        return n;
      }, t.prototype.encode = function (t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m;
        for (n in r = Ge.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
          0: 0
        }, m = r.charMap) f[(s = m[n]).old] = s.new;
        for (d in l = r.maxGlyphID, a) d in f || (f[d] = l++);
        return u = function (t) {
          var e, r;
          for (e in r = {}, t) r[t[e]] = e;
          return r;
        }(f), h = Object.keys(u).sort(function (t, e) {
          return t - e;
        }), p = function () {
          var t, e, r;
          for (r = [], t = 0, e = h.length; t < e; t++) o = h[t], r.push(u[o]);
          return r;
        }(), i = this.font.glyf.encode(a, p, f), c = this.font.loca.encode(i.offsets, p), g = {
          cmap: this.font.cmap.raw(),
          glyf: i.table,
          loca: c,
          hmtx: this.font.hmtx.raw(),
          hhea: this.font.hhea.raw(),
          maxp: this.font.maxp.raw(),
          post: this.font.post.raw(),
          name: this.font.name.raw(),
          head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
      }, t;
    }();
  M.API.PDFObject = function () {
    var t;
    function e() {}
    return t = function (t, e) {
      return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function (r) {
      var n, i, a, o;
      if (Array.isArray(r)) return "[" + function () {
        var t, i, a;
        for (a = [], t = 0, i = r.length; t < i; t++) n = r[t], a.push(e.convert(n));
        return a;
      }().join(" ") + "]";
      if ("string" == typeof r) return "/" + r;
      if (null != r ? r.isString : void 0) return "(" + r + ")";
      if (r instanceof Date) return "(D:" + t(r.getUTCFullYear(), 4) + t(r.getUTCMonth(), 2) + t(r.getUTCDate(), 2) + t(r.getUTCHours(), 2) + t(r.getUTCMinutes(), 2) + t(r.getUTCSeconds(), 2) + "Z)";
      if ("[object Object]" === {}.toString.call(r)) {
        for (i in a = ["<<"], r) o = r[i], a.push("/" + i + " " + e.convert(o));
        return a.push(">>"), a.join("\n");
      }
      return "" + r;
    }, e;
  }(), t.AcroForm = xt, t.AcroFormAppearance = Lt, t.AcroFormButton = gt, t.AcroFormCheckBox = yt, t.AcroFormChoiceField = lt, t.AcroFormComboBox = dt, t.AcroFormEditBox = pt, t.AcroFormListBox = ft, t.AcroFormPasswordField = Nt, t.AcroFormPushButton = mt, t.AcroFormRadioButton = vt, t.AcroFormTextField = wt, t.GState = C, t.ShadingPattern = O, t.TilingPattern = B, t.default = M, t.jsPDF = M, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});
/**
 * A JavaScript implementation of the SHA family of hashes - defined in FIPS PUB 180-4, FIPS PUB 202,
 * and SP 800-185 - as well as the corresponding HMAC implementation as defined in FIPS PUB 198-1.
 *
 * Copyright 2008-2020 Brian Turek, 1998-2009 Paul Johnston & Contributors
 * Distributed under the BSD License
 * See http://caligatio.github.com/jsSHA/ for more information
 *
 * Two ECMAScript polyfill functions carry the following license:
 *
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with
 * the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED,
 * INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
 * MERCHANTABLITY OR NON-INFRINGEMENT.
 *
 * See the Apache Version 2.0 License for specific language governing permissions and limitations under the License.
 */
!function (t, r) {
  "object" == typeof exports && "undefined" != typeof module ? t["jsSHA"] = r() : "function" == typeof define && define.amd ? define(r) : (t = "undefined" != typeof globalThis ? globalThis : t || self).jsSHA = r();
}(window, function () {
  "use strict";

  var t = function (r, n) {
    return (t = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, r) {
      t.__proto__ = r;
    } || function (t, r) {
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    })(r, n);
  };
  var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  function n(t, r, n, i) {
    var e,
      o,
      s,
      u = r || [0],
      f = (n = n || 0) >>> 3,
      h = -1 === i ? 3 : 0;
    for (e = 0; e < t.length; e += 1) o = (s = e + f) >>> 2, u.length <= o && u.push(0), u[o] |= t[e] << 8 * (h + i * (s % 4));
    return {
      value: u,
      binLen: 8 * t.length + n
    };
  }
  function i(t, i, e) {
    switch (i) {
      case "UTF8":
      case "UTF16BE":
      case "UTF16LE":
        break;
      default:
        throw new Error("encoding must be UTF8, UTF16BE, or UTF16LE");
    }
    switch (t) {
      case "HEX":
        return function (t, r, n) {
          return function (t, r, n, i) {
            var e, o, s, u;
            if (0 != t.length % 2) throw new Error("String of HEX type must be in byte increments");
            var f = r || [0],
              h = (n = n || 0) >>> 3,
              a = -1 === i ? 3 : 0;
            for (e = 0; e < t.length; e += 2) {
              if (o = parseInt(t.substr(e, 2), 16), isNaN(o)) throw new Error("String of HEX type contains invalid characters");
              for (s = (u = (e >>> 1) + h) >>> 2; f.length <= s;) f.push(0);
              f[s] |= o << 8 * (a + i * (u % 4));
            }
            return {
              value: f,
              binLen: 4 * t.length + n
            };
          }(t, r, n, e);
        };
      case "TEXT":
        return function (t, r, n) {
          return function (t, r, n, i, e) {
            var o,
              s,
              u,
              f,
              h,
              a,
              c,
              w,
              E = 0,
              v = n || [0],
              A = (i = i || 0) >>> 3;
            if ("UTF8" === r) for (c = -1 === e ? 3 : 0, u = 0; u < t.length; u += 1) for (s = [], 128 > (o = t.charCodeAt(u)) ? s.push(o) : 2048 > o ? (s.push(192 | o >>> 6), s.push(128 | 63 & o)) : 55296 > o || 57344 <= o ? s.push(224 | o >>> 12, 128 | o >>> 6 & 63, 128 | 63 & o) : (u += 1, o = 65536 + ((1023 & o) << 10 | 1023 & t.charCodeAt(u)), s.push(240 | o >>> 18, 128 | o >>> 12 & 63, 128 | o >>> 6 & 63, 128 | 63 & o)), f = 0; f < s.length; f += 1) {
              for (h = (a = E + A) >>> 2; v.length <= h;) v.push(0);
              v[h] |= s[f] << 8 * (c + e * (a % 4)), E += 1;
            } else for (c = -1 === e ? 2 : 0, w = "UTF16LE" === r && 1 !== e || "UTF16LE" !== r && 1 === e, u = 0; u < t.length; u += 1) {
              for (o = t.charCodeAt(u), !0 === w && (o = (f = 255 & o) << 8 | o >>> 8), h = (a = E + A) >>> 2; v.length <= h;) v.push(0);
              v[h] |= o << 8 * (c + e * (a % 4)), E += 2;
            }
            return {
              value: v,
              binLen: 8 * E + i
            };
          }(t, i, r, n, e);
        };
      case "B64":
        return function (t, n, i) {
          return function (t, n, i, e) {
            var o,
              s,
              u,
              f,
              h,
              a,
              c = 0,
              w = n || [0],
              E = (i = i || 0) >>> 3,
              v = -1 === e ? 3 : 0,
              A = t.indexOf("=");
            if (-1 === t.search(/^[a-zA-Z0-9=+/]+$/)) throw new Error("Invalid character in base-64 string");
            if (t = t.replace(/=/g, ""), -1 !== A && A < t.length) throw new Error("Invalid '=' found in base-64 string");
            for (o = 0; o < t.length; o += 4) {
              for (f = t.substr(o, 4), u = 0, s = 0; s < f.length; s += 1) u |= r.indexOf(f.charAt(s)) << 18 - 6 * s;
              for (s = 0; s < f.length - 1; s += 1) {
                for (h = (a = c + E) >>> 2; w.length <= h;) w.push(0);
                w[h] |= (u >>> 16 - 8 * s & 255) << 8 * (v + e * (a % 4)), c += 1;
              }
            }
            return {
              value: w,
              binLen: 8 * c + i
            };
          }(t, n, i, e);
        };
      case "BYTES":
        return function (t, r, n) {
          return function (t, r, n, i) {
            var e,
              o,
              s,
              u,
              f = r || [0],
              h = (n = n || 0) >>> 3,
              a = -1 === i ? 3 : 0;
            for (o = 0; o < t.length; o += 1) e = t.charCodeAt(o), s = (u = o + h) >>> 2, f.length <= s && f.push(0), f[s] |= e << 8 * (a + i * (u % 4));
            return {
              value: f,
              binLen: 8 * t.length + n
            };
          }(t, r, n, e);
        };
      case "ARRAYBUFFER":
        try {
          new ArrayBuffer(0);
        } catch (t) {
          throw new Error("ARRAYBUFFER not supported by this environment");
        }
        return function (t, r, i) {
          return function (t, r, i, e) {
            return n(new Uint8Array(t), r, i, e);
          }(t, r, i, e);
        };
      case "UINT8ARRAY":
        try {
          new Uint8Array(0);
        } catch (t) {
          throw new Error("UINT8ARRAY not supported by this environment");
        }
        return function (t, r, i) {
          return n(t, r, i, e);
        };
      default:
        throw new Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
    }
  }
  function e(t, n, i, e) {
    switch (t) {
      case "HEX":
        return function (t) {
          return function (t, r, n, i) {
            var e,
              o,
              s = "",
              u = r / 8,
              f = -1 === n ? 3 : 0;
            for (e = 0; e < u; e += 1) o = t[e >>> 2] >>> 8 * (f + n * (e % 4)), s += "0123456789abcdef".charAt(o >>> 4 & 15) + "0123456789abcdef".charAt(15 & o);
            return i.outputUpper ? s.toUpperCase() : s;
          }(t, n, i, e);
        };
      case "B64":
        return function (t) {
          return function (t, n, i, e) {
            var o,
              s,
              u,
              f,
              h,
              a = "",
              c = n / 8,
              w = -1 === i ? 3 : 0;
            for (o = 0; o < c; o += 3) for (f = o + 1 < c ? t[o + 1 >>> 2] : 0, h = o + 2 < c ? t[o + 2 >>> 2] : 0, u = (t[o >>> 2] >>> 8 * (w + i * (o % 4)) & 255) << 16 | (f >>> 8 * (w + i * ((o + 1) % 4)) & 255) << 8 | h >>> 8 * (w + i * ((o + 2) % 4)) & 255, s = 0; s < 4; s += 1) a += 8 * o + 6 * s <= n ? r.charAt(u >>> 6 * (3 - s) & 63) : e.b64Pad;
            return a;
          }(t, n, i, e);
        };
      case "BYTES":
        return function (t) {
          return function (t, r, n) {
            var i,
              e,
              o = "",
              s = r / 8,
              u = -1 === n ? 3 : 0;
            for (i = 0; i < s; i += 1) e = t[i >>> 2] >>> 8 * (u + n * (i % 4)) & 255, o += String.fromCharCode(e);
            return o;
          }(t, n, i);
        };
      case "ARRAYBUFFER":
        try {
          new ArrayBuffer(0);
        } catch (t) {
          throw new Error("ARRAYBUFFER not supported by this environment");
        }
        return function (t) {
          return function (t, r, n) {
            var i,
              e = r / 8,
              o = new ArrayBuffer(e),
              s = new Uint8Array(o),
              u = -1 === n ? 3 : 0;
            for (i = 0; i < e; i += 1) s[i] = t[i >>> 2] >>> 8 * (u + n * (i % 4)) & 255;
            return o;
          }(t, n, i);
        };
      case "UINT8ARRAY":
        try {
          new Uint8Array(0);
        } catch (t) {
          throw new Error("UINT8ARRAY not supported by this environment");
        }
        return function (t) {
          return function (t, r, n) {
            var i,
              e = r / 8,
              o = -1 === n ? 3 : 0,
              s = new Uint8Array(e);
            for (i = 0; i < e; i += 1) s[i] = t[i >>> 2] >>> 8 * (o + n * (i % 4)) & 255;
            return s;
          }(t, n, i);
        };
      default:
        throw new Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
    }
  }
  function o(t) {
    var r = {
        outputUpper: !1,
        b64Pad: "=",
        outputLen: -1
      },
      n = t || {},
      i = "Output length must be a multiple of 8";
    if (r.outputUpper = n.outputUpper || !1, n.b64Pad && (r.b64Pad = n.b64Pad), n.outputLen) {
      if (n.outputLen % 8 != 0) throw new Error(i);
      r.outputLen = n.outputLen;
    } else if (n.shakeLen) {
      if (n.shakeLen % 8 != 0) throw new Error(i);
      r.outputLen = n.shakeLen;
    }
    if ("boolean" != typeof r.outputUpper) throw new Error("Invalid outputUpper formatting option");
    if ("string" != typeof r.b64Pad) throw new Error("Invalid b64Pad formatting option");
    return r;
  }
  function s(t, r) {
    return t << r | t >>> 32 - r;
  }
  function u(t, r, n) {
    return t ^ r ^ n;
  }
  function f(t, r, n) {
    return t & r ^ t & n ^ r & n;
  }
  function h(t, r) {
    var n = (65535 & t) + (65535 & r);
    return (65535 & (t >>> 16) + (r >>> 16) + (n >>> 16)) << 16 | 65535 & n;
  }
  function a(t, r, n, i, e) {
    var o = (65535 & t) + (65535 & r) + (65535 & n) + (65535 & i) + (65535 & e);
    return (65535 & (t >>> 16) + (r >>> 16) + (n >>> 16) + (i >>> 16) + (e >>> 16) + (o >>> 16)) << 16 | 65535 & o;
  }
  function c(t) {
    return [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  }
  function w(t, r) {
    var n,
      i,
      e,
      o,
      c,
      w,
      E,
      v,
      A = [];
    for (n = r[0], i = r[1], e = r[2], o = r[3], c = r[4], E = 0; E < 80; E += 1) A[E] = E < 16 ? t[E] : s(A[E - 3] ^ A[E - 8] ^ A[E - 14] ^ A[E - 16], 1), w = E < 20 ? a(s(n, 5), (v = i) & e ^ ~v & o, c, 1518500249, A[E]) : E < 40 ? a(s(n, 5), u(i, e, o), c, 1859775393, A[E]) : E < 60 ? a(s(n, 5), f(i, e, o), c, 2400959708, A[E]) : a(s(n, 5), u(i, e, o), c, 3395469782, A[E]), c = o, o = e, e = s(i, 30), i = n, n = w;
    return r[0] = h(n, r[0]), r[1] = h(i, r[1]), r[2] = h(e, r[2]), r[3] = h(o, r[3]), r[4] = h(c, r[4]), r;
  }
  function E(t, r, n, i) {
    for (var e, o = 15 + (r + 65 >>> 9 << 4), s = r + n; t.length <= o;) t.push(0);
    for (t[r >>> 5] |= 128 << 24 - r % 32, t[o] = 4294967295 & s, t[o - 1] = s / 4294967296 | 0, e = 0; e < t.length; e += 16) i = w(t.slice(e, e + 16), i);
    return i;
  }
  return function (r) {
    function n(t, n, e) {
      var o = this;
      if ("SHA-1" !== t) throw new Error("Chosen SHA variant is not supported");
      var s = e || {};
      return (o = r.call(this, t, n, e) || this).t = !0, o.i = o.o, o.s = -1, o.u = i(o.h, o.v, o.s), o.A = w, o.p = function (t) {
        return t.slice();
      }, o.l = c, o.R = E, o.U = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], o.T = 512, o.m = 160, o.F = !1, s.hmacKey && o.B(function (t, r, n, e) {
        var o = t + " must include a value and format";
        if (!r) {
          if (!e) throw new Error(o);
          return e;
        }
        if (void 0 === r.value || !r.format) throw new Error(o);
        return i(r.format, r.encoding || "UTF8", n)(r.value);
      }("hmacKey", s.hmacKey, o.s)), o;
    }
    return function (r, n) {
      function i() {
        this.constructor = r;
      }
      t(r, n), r.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
    }(n, r), n;
  }(function () {
    function t(t, r, n) {
      var i = n || {};
      if (this.h = r, this.v = i.encoding || "UTF8", this.numRounds = i.numRounds || 1, isNaN(this.numRounds) || this.numRounds !== parseInt(this.numRounds, 10) || 1 > this.numRounds) throw new Error("numRounds must a integer >= 1");
      this.g = t, this.Y = [], this.I = 0, this.C = !1, this.H = 0, this.L = !1, this.N = [], this.S = [];
    }
    return t.prototype.update = function (t) {
      var r,
        n = 0,
        i = this.T >>> 5,
        e = this.u(t, this.Y, this.I),
        o = e.binLen,
        s = e.value,
        u = o >>> 5;
      for (r = 0; r < u; r += i) n + this.T <= o && (this.U = this.A(s.slice(r, r + i), this.U), n += this.T);
      this.H += n, this.Y = s.slice(n >>> 5), this.I = o % this.T, this.C = !0;
    }, t.prototype.getHash = function (t, r) {
      var n,
        i,
        s = this.m,
        u = o(r);
      if (this.F) {
        if (-1 === u.outputLen) throw new Error("Output length must be specified in options");
        s = u.outputLen;
      }
      var f = e(t, s, this.s, u);
      if (this.L && this.i) return f(this.i(u));
      for (i = this.R(this.Y.slice(), this.I, this.H, this.p(this.U), s), n = 1; n < this.numRounds; n += 1) this.F && s % 32 != 0 && (i[i.length - 1] &= 16777215 >>> 24 - s % 32), i = this.R(i, s, 0, this.l(this.g), s);
      return f(i);
    }, t.prototype.setHMACKey = function (t, r, n) {
      if (!this.t) throw new Error("Variant does not support HMAC");
      if (this.C) throw new Error("Cannot set MAC key after calling update");
      var e = i(r, (n || {}).encoding || "UTF8", this.s);
      this.B(e(t));
    }, t.prototype.B = function (t) {
      var r,
        n = this.T >>> 3,
        i = n / 4 - 1;
      if (1 !== this.numRounds) throw new Error("Cannot set numRounds with MAC");
      if (this.L) throw new Error("MAC key already set");
      for (n < t.binLen / 8 && (t.value = this.R(t.value, t.binLen, 0, this.l(this.g), this.m)); t.value.length <= i;) t.value.push(0);
      for (r = 0; r <= i; r += 1) this.N[r] = 909522486 ^ t.value[r], this.S[r] = 1549556828 ^ t.value[r];
      this.U = this.A(this.N, this.U), this.H = this.T, this.L = !0;
    }, t.prototype.getHMAC = function (t, r) {
      var n = o(r);
      return e(t, this.m, this.s, n)(this.o());
    }, t.prototype.o = function () {
      var t;
      if (!this.L) throw new Error("Cannot call getHMAC without first setting MAC key");
      var r = this.R(this.Y.slice(), this.I, this.H, this.p(this.U), this.m);
      return t = this.A(this.S, this.l(this.g)), t = this.R(r, this.m, this.T, t, this.m);
    }, t;
  }());
});
var FlexmonsterToolbar = function (a, b, c, d, l, k) {
  this.pivot = b;
  this.pivotContainer = a;
  this.width = "number" == typeof d || 0 > d.indexOf("px") && 0 > d.indexOf("%") ? d + "px" : d;
  this.Labels = l;
  this.dataSourceType = k || 5;
  this.singleAggregationFormatting = this.showShareReportTab = !1;
};
FlexmonsterToolbar.prototype.getTabs = function () {
  var a = [],
    b = this.Labels;
  a.push({
    title: b.connect,
    id: "fm-tab-connect",
    icon: this.icons.connect,
    menu: [{
      title: b.connect_local_csv,
      id: "fm-tab-connect-local-csv",
      handler: this.connectLocalCSVHandler,
      mobile: !1,
      icon: this.icons.connect_csv
    }, {
      title: b.connect_local_json,
      id: "fm-tab-connect-local-json",
      handler: this.connectLocalJSONHandler,
      mobile: !1,
      icon: this.icons.connect_json
    }, {
      title: this.osUtils.isMobile ? b.connect_remote_csv_mobile : b.connect_remote_csv,
      id: "fm-tab-connect-remote-csv",
      handler: this.connectRemoteCSV,
      icon: this.icons.connect_csv_remote
    }, {
      title: this.osUtils.isMobile ? b.connect_remote_json_mobile : b.connect_remote_json,
      id: "fm-tab-connect-remote-json",
      handler: this.connectRemoteJSON,
      icon: this.icons.connect_json_remote
    }, {
      title: this.osUtils.isMobile ? b.connect_olap_mobile : b.connect_olap,
      id: "fm-tab-connect-olap",
      handler: this.connectOLAP,
      flat: !1,
      icon: this.icons.connect_olap
    }, {
      title: this.osUtils.isMobile ? b.connect_elastic_mobile : b.connect_elastic,
      id: "fm-tab-connect-elastic",
      handler: this.connectElastic,
      flat: !1,
      icon: this.icons.connect_elastic
    }]
  });
  a.push({
    title: b.open,
    id: "fm-tab-open",
    icon: this.icons.open,
    menu: [{
      title: b.local_report,
      id: "fm-tab-open-local-report",
      handler: this.openLocalReport,
      mobile: !1,
      icon: this.icons.open_local
    }, {
      title: this.osUtils.isMobile ? b.remote_report_mobile : b.remote_report,
      id: "fm-tab-open-remote-report",
      handler: this.openRemoteReport,
      icon: this.icons.open_remote
    }]
  });
  a.push({
    title: b.save,
    id: "fm-tab-save",
    handler: this.saveHandler,
    mobile: !1,
    icon: this.icons.save
  });
  a.push({
    title: b.export,
    id: "fm-tab-export",
    mobile: !1,
    icon: this.icons.export,
    menu: [{
      title: b.export_print,
      id: "fm-tab-export-print",
      handler: this.printHandler,
      icon: this.icons.export_print
    }, {
      title: b.export_html,
      id: "fm-tab-export-html",
      handler: this.exportHandler,
      args: "html",
      icon: this.icons.export_html
    }, {
      title: b.export_csv,
      id: "fm-tab-export-csv",
      handler: this.exportHandler,
      args: "csv",
      icon: this.icons.export_csv
    }, {
      title: b.export_excel,
      id: "fm-tab-export-excel",
      handler: this.exportHandler,
      args: "excel",
      icon: this.icons.export_excel
    }, {
      title: b.export_image,
      id: "fm-tab-export-image",
      handler: this.exportHandler,
      args: "image",
      icon: this.icons.export_image
    }, {
      title: b.export_pdf,
      id: "fm-tab-export-pdf",
      handler: this.exportHandler,
      args: "pdf",
      icon: this.icons.export_pdf
    }]
  });
  a.push({
    title: b.share,
    id: "fm-tab-share",
    handler: this.shareReportHandler,
    icon: this.icons.share,
    visible: this.showShareReportTab
  });
  a.push({
    divider: !0
  });
  a.push({
    title: b.grid,
    id: "fm-tab-grid",
    handler: this.gridHandler,
    icon: this.icons.grid
  });
  a.push({
    title: b.charts,
    id: "fm-tab-charts",
    onShowHandler: this.checkChartMultipleMeasures,
    icon: this.icons.charts,
    menu: [{
      title: b.charts_column,
      id: "fm-tab-charts-column",
      handler: this.chartsHandler,
      args: "column",
      icon: this.icons.charts
    }, {
      title: b.charts_bar_horizontal,
      id: "fm-tab-charts-bar-horizontal",
      handler: this.chartsHandler,
      args: "bar_h",
      icon: this.icons.charts_bar
    }, {
      title: b.charts_line,
      id: "fm-tab-charts-line",
      handler: this.chartsHandler,
      args: "line",
      icon: this.icons.charts_line
    }, {
      title: b.charts_scatter,
      id: "fm-tab-charts-scatter",
      handler: this.chartsHandler,
      args: "scatter",
      icon: this.icons.charts_scatter
    }, {
      title: b.charts_pie,
      id: "fm-tab-charts-pie",
      handler: this.chartsHandler,
      args: "pie",
      icon: this.icons.charts_pie
    }, {
      title: b.charts_stacked_column,
      id: "fm-tab-charts-stacked-column",
      handler: this.chartsHandler,
      args: "stacked_column",
      flat: !1,
      icon: this.icons.charts_stacked_column
    }, {
      title: b.charts_column_line,
      id: "fm-tab-charts-column-line",
      handler: this.chartsHandler,
      args: "column_line",
      icon: this.icons.charts_column_line
    }, {
      title: b.charts_multiple,
      id: "fm-tab-charts-multiple",
      handler: this.chartsMultipleHandler,
      flat: !1,
      mobile: !1,
      type: "checkbox"
    }]
  });
  a.push({
    divider: !0
  });
  a.push({
    title: b.format,
    id: "fm-tab-format",
    icon: this.icons.format,
    rightGroup: !0,
    menu: [{
      title: this.osUtils.isMobile ? b.format_cells_mobile : b.format_cells,
      id: "fm-tab-format-cells",
      handler: this.formatCellsHandler,
      icon: this.icons.format_number
    }, {
      title: this.osUtils.isMobile ? b.conditional_formatting_mobile : b.conditional_formatting,
      id: "fm-tab-format-conditional",
      handler: this.conditionalFormattingHandler,
      icon: this.icons.format_conditional
    }]
  });
  a.push({
    title: b.options,
    id: "fm-tab-options",
    handler: this.optionsHandler,
    icon: this.icons.options,
    rightGroup: !0
  });
  a.push({
    title: b.fields,
    id: "fm-tab-fields",
    handler: this.fieldsHandler,
    icon: this.icons.fields,
    rightGroup: !0
  });
  void 0 != document.addEventListener && (a.push({
    divider: !0,
    rightGroup: !0
  }), a.push({
    title: b.fullscreen,
    id: "fm-tab-fullscreen",
    handler: this.fullscreenHandler,
    mobile: !1,
    icon: this.icons.fullscreen,
    rightGroup: !0
  }));
  return a;
};
FlexmonsterToolbar.prototype.create = function () {
  this.popupManager = new FlexmonsterToolbar.PopupManager(this);
  this.dataProvider = this.getTabs();
  5 != this.dataSourceType && this.filterConnectMenu();
  this.init();
};
FlexmonsterToolbar.prototype.dispose = function () {
  this.dataProvider = this.Labels = this.pivotContainer = this.pivot = this.popupManager = null;
  window.removeEventListener("resize", this._redrawToolbar);
};
FlexmonsterToolbar.prototype.responsiveBreakpoints = [700];
FlexmonsterToolbar.prototype.applyToolbarLayoutClasses = function () {
  if (!this.osUtils.isMobile) {
    var a = this;
    (function () {
      if (a.toolbarWrapper) {
        var b = a.toolbarWrapper.getBoundingClientRect().width;
        0 != b && a.responsiveBreakpoints.forEach(function (c) {
          b < c ? a.toolbarWrapper.classList.add("fm-layout-" + c) : a.toolbarWrapper.classList.remove("fm-layout-" + c);
        });
      }
    })();
  }
};
FlexmonsterToolbar.prototype.init = function () {
  var a = this;
  this.container = this.pivotContainer;
  var b = function () {
      a.container.style.position = "" == a.container.style.position ? "relative" : a.container.style.position;
      a.container.querySelector("#fm-toolbar-wrapper") || (a.toolbarWrapper = document.createElement("div"), a.toolbarWrapper.id = "fm-toolbar-wrapper");
      a.listWrapper = document.createElement("div");
      a.listWrapper.classList.add("fm-list-wrapper");
      a.listWrapper.style.width = "100%";
      a.toolbarWrapper.style.width = "100%";
      a.toolbarWrapper.appendChild(a.listWrapper);
      a.toolbar = document.createElement("ul");
      a.toolbar.setAttribute("role", "menubar");
      a.toolbar.setAttribute("aria-orientation", "horizontal");
      a.addClass(a.toolbarWrapper, "fm-toolbar-ui");
      a.toolbar.id = "fm-toolbar";
      if (!a.osUtils.isMobile) {
        var l = document.createElement("div");
        l.classList.add("fm-toolbar-group-left");
        a.toolbar.appendChild(l);
        var k = document.createElement("div");
        k.classList.add("fm-toolbar-group-right");
        a.toolbar.appendChild(k);
      }
      c(l, k, a.toolbar);
      a.listWrapper.appendChild(a.toolbar);
      a.container.insertBefore(a.toolbarWrapper, a.container.firstChild);
      a.applyToolbarLayoutClasses();
      !a.osUtils.isMobile && l.clientWidth + k.clientWidth > a.toolbar.clientWidth && (a.toolbar.removeChild(l), a.toolbar.removeChild(k), c(null, null, a.toolbar), a.toolbar.classList.add("fm-scroll-toolbar"));
      a.updateLabels(a.Labels);
      a.pivot.on("numberformatting", function (e) {
        a.formatCellsHandler(e.measureName, e.aggregation);
      });
      a.pivot.on("conditionalformatting", function (e) {
        a.conditionalFormattingHandler(e.measureName);
      });
      a.osUtils.isMobile && a.addClass(a.listWrapper, "fm-mobile");
    },
    c = function (l, k, e) {
      for (var g = 0; g < a.dataProvider.length; g++) if (!a.isDisabled(a.dataProvider[g])) if (a.osUtils.isMobile && null != a.dataProvider[g].menu && 1 != a.dataProvider[g].collapse) for (var q = 0; q < a.dataProvider[g].menu.length; q++) a.isDisabled(a.dataProvider[g].menu[q]) || e.appendChild(a.createTab(a.dataProvider[g].menu[q]));else q = a.dataProvider[g].divider ? a.createDivider(a.dataProvider[g]) : a.createTab(a.dataProvider[g]), k && a.dataProvider[g].rightGroup ? k.appendChild(q) : l ? l.appendChild(q) : e.appendChild(q);
    },
    d = function () {
      if (20 < a.toolbar.scrollWidth - a.toolbar.clientWidth) {
        a.leftScrollButton = document.createElement("div");
        a.leftScrollButton.classList.add("fm-left-scroll-button");
        a.rightScrollButton = document.createElement("div");
        a.rightScrollButton.classList.add("fm-right-scroll-button");
        a.addClass(a.rightScrollButton, "fm-scroll-arrow");
        a.addClass(a.listWrapper, "fm-one-arrow-scroll");
        var l = function (g) {
            "add" == g ? (a.listWrapper.classList.remove("fm-one-arrow-scroll"), a.listWrapper.classList.add("fm-two-arrow-scroll")) : (a.listWrapper.classList.remove("fm-two-arrow-scroll"), a.listWrapper.classList.add("fm-one-arrow-scroll"));
          },
          k = function () {
            var g = a.toolbar.scrollWidth - a.toolbar.clientWidth;
            0 < a.toolbar.scrollLeft && !a.leftScrollButton.classList.contains("fm-scroll-arrow") ? (l("add"), a.addClass(a.leftScrollButton, "fm-scroll-arrow")) : 0 >= a.toolbar.scrollLeft - 12 && a.leftScrollButton.classList.contains("fm-scroll-arrow") && (l("remove"), a.leftScrollButton.classList.remove("fm-scroll-arrow"));
            a.toolbar.scrollLeft + 12 >= g && a.rightScrollButton.classList.contains("fm-scroll-arrow") ? (l("remove"), a.rightScrollButton.classList.remove("fm-scroll-arrow")) : a.toolbar.scrollLeft + 12 < g && !a.rightScrollButton.classList.contains("fm-scroll-arrow") && (l("add"), a.addClass(a.rightScrollButton, "fm-scroll-arrow"));
          },
          e = function (g) {
            "left" == g ? a.toolbar.scrollLeft -= 40 : "right" == g && (a.toolbar.scrollLeft += 40);
            k();
          };
        a.toolbar.onscroll = function () {
          k();
        };
        a.leftScrollButton.onclick = function () {
          e("left");
        };
        a.rightScrollButton.onclick = function () {
          e("right");
        };
        a.toolbarWrapper.insertBefore(a.leftScrollButton, a.toolbarWrapper.firstChild);
        a.toolbarWrapper.appendChild(a.rightScrollButton);
      }
    };
  a._redrawToolbar = function () {
    if (a.toolbarWrapper) {
      for (var l = [], k = a.toolbarWrapper.childNodes, e = 0; e < k.length; e++) {
        var g = k[e].classList;
        g.contains("fm-popup") || g.contains("fm-modal-overlay") || g.contains("fm-popup-modal-overlay") || l.push(k[e]);
      }
      for (e = 0; e < l.length; e++) a.toolbarWrapper.removeChild(l[e]);
    }
    b();
    d();
    a.isFullscreen() && (a.pivotContainer.querySelector("#fm-tab-fullscreen > a > div").innerHTML = a.icons.minimize, a.setText(a.pivotContainer.querySelector("#fm-tab-fullscreen .fm-tab-label"), a.Labels.minimize));
  };
  a._redrawToolbar();
  window.addEventListener("resize", a._redrawToolbar);
};
FlexmonsterToolbar.prototype.updateLabels = function (a) {
  a = this.Labels = a;
  this.setText(this.pivotContainer.querySelector("#fm-tab-connect .fm-tab-label"), a.connect);
  this.setText(this.pivotContainer.querySelector("#fm-tab-connect-local-csv .fm-tab-label"), a.connect_local_csv);
  this.setText(this.pivotContainer.querySelector("#fm-tab-connect-local-json .fm-tab-label"), a.connect_local_json);
  this.setText(this.pivotContainer.querySelector("#fm-tab-connect-remote-csv .fm-tab-label"), this.osUtils.isMobile ? a.connect_remote_csv_mobile : a.connect_remote_csv);
  this.setText(this.pivotContainer.querySelector("#fm-tab-connect-remote-json .fm-tab-label"), this.osUtils.isMobile ? a.connect_remote_json_mobile : a.connect_remote_json);
  this.setText(this.pivotContainer.querySelector("#fm-tab-connect-olap .fm-tab-label"), this.osUtils.isMobile ? a.connect_olap_mobile : a.connect_olap);
  this.setText(this.pivotContainer.querySelector("#fm-tab-connect-elastic .fm-tab-label"), this.osUtils.isMobile ? a.connect_elastic_mobile : a.connect_elastic);
  this.setText(this.pivotContainer.querySelector("#fm-tab-open .fm-tab-label"), a.open);
  this.setText(this.pivotContainer.querySelector("#fm-tab-open-local-report .fm-tab-label"), a.local_report);
  this.setText(this.pivotContainer.querySelector("#fm-tab-open-remote-report .fm-tab-label"), this.osUtils.isMobile ? a.remote_report_mobile : a.remote_report);
  this.setText(this.pivotContainer.querySelector("#fm-tab-save .fm-tab-label"), a.save);
  this.setText(this.pivotContainer.querySelector("#fm-tab-share .fm-tab-label"), a.share);
  this.setText(this.pivotContainer.querySelector("#fm-tab-grid .fm-tab-label"), a.grid);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts .fm-tab-label"), a.charts);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts-column .fm-tab-label"), a.charts_column);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts-bar-horizontal .fm-tab-label"), a.charts_bar_horizontal);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts-line .fm-tab-label"), a.charts_line);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts-scatter .fm-tab-label"), a.charts_scatter);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts-pie .fm-tab-label"), a.charts_pie);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts-stacked-column .fm-tab-label"), a.charts_stacked_column);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts-column-line .fm-tab-label"), a.charts_column_line);
  this.setText(this.pivotContainer.querySelector("#fm-tab-charts-multiple .fm-tab-label"), a.charts_multiple);
  this.setText(this.pivotContainer.querySelector("#fm-tab-format .fm-tab-label"), a.format);
  this.setText(this.pivotContainer.querySelector("#fm-tab-format-cells .fm-tab-label"), this.osUtils.isMobile ? a.format_cells_mobile : a.format_cells);
  this.setText(this.pivotContainer.querySelector("#fm-tab-format-conditional .fm-tab-label"), this.osUtils.isMobile ? a.conditional_formatting_mobile : a.conditional_formatting);
  this.setText(this.pivotContainer.querySelector("#fm-tab-options .fm-tab-label"), a.options);
  this.setText(this.pivotContainer.querySelector("#fm-tab-fullscreen .fm-tab-label"), a.fullscreen);
  this.setText(this.pivotContainer.querySelector("#fm-tab-export .fm-tab-label"), a.export);
  this.setText(this.pivotContainer.querySelector("#fm-tab-export-print .fm-tab-label"), a.export_print);
  this.setText(this.pivotContainer.querySelector("#fm-tab-export-html .fm-tab-label"), a.export_html);
  this.setText(this.pivotContainer.querySelector("#fm-tab-export-csv .fm-tab-label"), a.export_csv);
  this.setText(this.pivotContainer.querySelector("#fm-tab-export-excel .fm-tab-label"), a.export_excel);
  this.setText(this.pivotContainer.querySelector("#fm-tab-export-image .fm-tab-label"), a.export_image);
  this.setText(this.pivotContainer.querySelector("#fm-tab-export-pdf .fm-tab-label"), a.export_pdf);
  this.setText(this.pivotContainer.querySelector("#fm-tab-fields .fm-tab-label"), a.fields);
};
FlexmonsterToolbar.prototype.icons = {
  connect: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 20.9C31.9036 20.9 37.5 18.5719 37.5 15.7C37.5 12.8281 31.9036 10.5 25 10.5C18.0964 10.5 12.5 12.8281 12.5 15.7C12.5 18.5719 18.0964 20.9 25 20.9Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 34.3002C13 34.8519 13.264 35.4186 13.8337 35.9799C14.4056 36.5434 15.2589 37.0721 16.3539 37.5258C18.5418 38.4323 21.5987 39.0002 25 39.0002C28.4013 39.0002 31.4582 38.4323 33.6461 37.5258C34.7411 37.0721 35.5944 36.5434 36.1663 35.9799C36.736 35.4186 37 34.8519 37 34.3002V15.7004C37 15.7004 37 15.7002 37.5 15.7002C38 15.7002 38 15.7004 38 15.7004V34.3002C38 35.1985 37.564 36.0067 36.8681 36.6923C36.1744 37.3757 35.1964 37.9658 34.0289 38.4496C31.6918 39.418 28.4987 40.0002 25 40.0002C21.5013 40.0002 18.3082 39.418 15.9711 38.4496C14.8036 37.9658 13.8256 37.3757 13.1319 36.6923C12.436 36.0067 12 35.1985 12 34.3002V15.7004C12 15.7004 12 15.7002 12.5 15.7002C13 15.7002 13 15.7004 13 15.7004V34.3002Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.8329 14.0324C13.2627 14.5933 13 15.1569 13 15.7004C13 16.2439 13.2627 16.8067 13.8329 17.3676C14.4049 17.9302 15.2583 18.4598 16.3532 18.9153C18.5408 19.8254 21.5976 20.4 25 20.4C28.4024 20.4 31.4592 19.8254 33.6468 18.9153C34.7417 18.4598 35.5951 17.9302 36.1671 17.3676C36.7373 16.8067 37 16.2439 37 15.7004C37 15.1569 36.7373 14.5933 36.1671 14.0324C35.5951 13.4698 34.7417 12.9402 33.6468 12.4847C31.4592 11.5746 28.4024 11 25 11C21.5976 11 18.5408 11.5746 16.3532 12.4847C15.2583 12.9402 14.4049 13.4698 13.8329 14.0324ZM15.9691 11.5614C18.3056 10.5894 21.4988 10 25 10C28.5012 10 31.6944 10.5894 34.0309 11.5614C35.198 12.0469 36.1752 12.6378 36.8683 13.3194C37.5631 14.0028 38 14.808 38 15.7004C38 16.5928 37.5631 17.3972 36.8683 18.0806C36.1752 18.7622 35.198 19.3531 34.0309 19.8386C31.6944 20.8106 28.5012 21.4 25 21.4C21.4988 21.4 18.3056 20.8106 15.9691 19.8386C14.802 19.3531 13.8248 18.7622 13.1317 18.0806C12.4369 17.3972 12 16.5928 12 15.7004C12 14.808 12.4369 14.0028 13.1317 13.3194C13.8248 12.6378 14.802 12.0469 15.9691 11.5614Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.3561 31.5894C18.5448 32.5084 21.6015 33.1004 25 33.1004C28.4013 33.1004 31.4582 32.5325 33.6461 31.626C34.7411 31.1723 35.5944 30.6436 36.1663 30.0801C36.736 29.5188 37 28.9521 37 28.4004H38C38 29.2987 37.564 30.1069 36.8681 30.7925C36.1744 31.4759 35.1964 32.066 34.0289 32.5498C31.6918 33.5182 28.4987 34.1004 25 34.1004C21.4985 34.1004 18.3052 33.4924 15.9689 32.5114C14.802 32.0214 13.8257 31.4287 13.1333 30.7516C12.4403 30.0741 12 29.2782 12 28.4004H13C13 28.9226 13.2597 29.4767 13.8324 30.0366C14.4056 30.5971 15.2605 31.1294 16.3561 31.5894Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.3539 25.126C18.5418 26.0325 21.5987 26.6004 25 26.6004C28.4013 26.6004 31.4582 26.0325 33.6461 25.126C34.7411 24.6722 35.5944 24.1436 36.1663 23.5801C36.736 23.0188 37 22.4521 37 21.9004H38C38 22.7987 37.564 23.6069 36.8681 24.2925C36.1744 24.9759 35.1964 25.566 34.0289 26.0498C31.6918 27.0182 28.4987 27.6004 25 27.6004C21.5013 27.6004 18.3082 27.0182 15.9711 26.0498C14.8036 25.566 13.8256 24.9759 13.1319 24.2925C12.436 23.6069 12 22.7987 12 21.9004H13C13 22.4521 13.264 23.0188 13.8337 23.5801C14.4056 24.1436 15.2589 24.6722 16.3539 25.126Z" class="fill-border"/></svg>',
  connect_olap: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.7 29.1004V22.1004L24.9 25.9004V32.8004L18.7 29.1004Z" class="fill-background"/><path d="M37.5 32.8004V25.8004L31.3 29.6004V36.5004L37.5 32.8004Z" class="fill-background"/><path d="M31.2 14.8004L24.8 11.4004L18.7 14.8004L24.7 18.4004L31.2 14.8004Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.9 25.4004C25.1762 25.4004 25.4 25.6242 25.4 25.9004V40.4004C25.4 40.6765 25.1762 40.9004 24.9 40.9004C24.6239 40.9004 24.4 40.6765 24.4 40.4004V25.9004C24.4 25.6242 24.6239 25.4004 24.9 25.4004Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.8 22.1006V36.6006H30.8V22.1006H31.8Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2 22.1006V36.6006H18.2V22.1006H19.2Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0715 18.2423C12.2139 18.0057 12.5211 17.9293 12.7577 18.0716L25.0577 25.4716C25.2943 25.614 25.3707 25.9212 25.2284 26.1578C25.086 26.3945 24.7788 26.4709 24.5422 26.3285L12.2422 18.9285C12.0056 18.7862 11.9292 18.4789 12.0715 18.2423Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.5499 10.9674C24.702 10.8796 24.8889 10.878 25.0424 10.9632L37.8424 18.0632C38.0024 18.1519 38.1012 18.3209 38.0999 18.5038L37.9999 33.0038C37.9987 33.1805 37.9043 33.3434 37.7516 33.4324L25.0516 40.8324C24.8944 40.924 24.6999 40.923 24.5437 40.8297L12.1437 33.4297C11.9914 33.3389 11.8987 33.1742 11.8999 32.9969L11.9999 18.4969C12.0011 18.3195 12.0963 18.1561 12.2499 18.0674L24.5499 10.9674ZM24.8048 11.9749L12.9979 18.7902L12.9019 32.7177L24.8029 39.8199L37.0019 32.7119L37.0979 18.7937L24.8048 11.9749Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M37.9302 18.2454C38.0709 18.483 37.9923 18.7897 37.7547 18.9303L25.2547 26.3303C25.017 26.471 24.7104 26.3924 24.5697 26.1548C24.429 25.9172 24.5076 25.6105 24.7452 25.4698L37.2452 18.0698C37.4829 17.9291 37.7895 18.0077 37.9302 18.2454Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.4453 21.7701L30.9453 14.3701L31.4547 15.2306L18.9547 22.6306L18.4453 21.7701Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.9547 14.3701L25.2047 18.0701L31.4547 21.7701L30.9453 22.6306L18.4453 15.2306L18.9547 14.3701Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6547 24.9697L25.1547 32.3697L24.6453 33.2302L12.1453 25.8302L12.6547 24.9697Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M37.6562 25.8294L25.2562 33.2294L24.7438 32.3707L37.1438 24.9707L37.6562 25.8294Z" class="fill-border"/></svg>',
  connect_csv: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.5 18.6502H29.3V11.4502" class="fill-background"/><path d="M27.9 36.4502H9.5C8.4 36.4502 7.5 35.5502 7.5 34.4502V27.9502C7.5 26.8502 8.4 25.9502 9.5 25.9502H27.9C29 25.9502 29.9 26.8502 29.9 27.9502V34.4502C29.9 35.5502 29 36.4502 27.9 36.4502Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2998 15.4502C18.0362 15.4502 17.7776 15.5403 17.5838 15.7341C17.3899 15.928 17.2998 16.1866 17.2998 16.4502V20.6502C17.2998 20.9138 17.3899 21.1724 17.5838 21.3662C17.7776 21.5601 18.0362 21.6502 18.2998 21.6502H21.1998V22.8506H20.3998C20.1236 22.8506 19.8998 23.0744 19.8998 23.3506C19.8998 23.6267 20.1236 23.8506 20.3998 23.8506H22.9998C23.2759 23.8506 23.4998 23.6267 23.4998 23.3506C23.4998 23.0744 23.2759 22.8506 22.9998 22.8506H22.1998V21.6502H24.9998C25.248 21.6502 25.5221 21.5701 25.7291 21.389C25.9403 21.2041 26.0722 20.9131 25.9998 20.5848V16.4502C25.9998 16.1866 25.9097 15.928 25.7159 15.7341C25.522 15.5403 25.2634 15.4502 24.9998 15.4502H18.2998ZM18.2998 20.6502V16.4502H24.9998V20.6502H18.2998Z" class="fill-border"/><path d="M23.9286 29.3014C24.0106 29.0962 24.2434 28.9965 24.4485 29.0785C24.6537 29.1606 24.7534 29.3934 24.6714 29.5985L23.2714 33.0985C23.2113 33.2487 23.0666 33.3479 22.9049 33.3499C22.7431 33.3519 22.5961 33.2562 22.5323 33.1075L21.0323 29.6075C20.9453 29.4044 21.0394 29.1693 21.2424 29.0823C21.4455 28.9952 21.6806 29.0893 21.7676 29.2923L22.8872 31.9047L23.9286 29.3014Z" class="fill-border"/><path d="M13.6 31.2498C13.6 30.7432 13.7662 30.4028 13.9896 30.1884C14.217 29.97 14.5377 29.8498 14.9 29.8498C15.17 29.8498 15.4733 29.9888 15.7172 30.2326C15.8734 30.3889 16.1267 30.3889 16.2829 30.2326C16.4391 30.0764 16.4391 29.8232 16.2829 29.667C15.9268 29.3108 15.4301 29.0498 14.9 29.0498C14.3624 29.0498 13.8331 29.2296 13.4355 29.6112C13.0339 29.9968 12.8 30.5564 12.8 31.2498C12.8 31.9278 12.9994 32.4898 13.3922 32.8826C13.7842 33.2746 14.3207 33.4498 14.9 33.4498C15.5172 33.4498 16.0161 33.1994 16.3829 32.8326C16.5391 32.6764 16.5391 32.4232 16.3829 32.267C16.2267 32.1108 15.9734 32.1108 15.8172 32.267C15.584 32.5002 15.2829 32.6498 14.9 32.6498C14.4794 32.6498 14.1659 32.525 13.9579 32.317C13.7507 32.1098 13.6 31.7718 13.6 31.2498Z" class="fill-border"/><path d="M18.8 29.6506C18.2146 29.6506 18 29.9646 18 30.1506C18 30.3815 18.0548 30.4754 18.1245 30.5358C18.2181 30.6169 18.4172 30.7056 18.8442 30.753C18.8557 30.7543 18.8671 30.7561 18.8785 30.7584C19.3939 30.8614 19.813 30.9999 20.1092 31.2138C20.4338 31.4482 20.6 31.7666 20.6 32.1506C20.6 32.5497 20.395 32.8913 20.0634 33.1182C19.7403 33.3392 19.304 33.4506 18.8 33.4506C18.0977 33.4506 17.6213 33.2122 17.2781 32.9834C17.0943 32.8609 17.0447 32.6125 17.1672 32.4287C17.2897 32.2449 17.5381 32.1952 17.7219 32.3178C17.9788 32.489 18.3023 32.6506 18.8 32.6506C19.196 32.6506 19.4597 32.5619 19.6116 32.458C19.755 32.3598 19.8 32.2515 19.8 32.1506C19.8 32.0345 19.7662 31.9529 19.6408 31.8624C19.4888 31.7526 19.2125 31.6423 18.738 31.5461C18.2727 31.4928 17.8784 31.3812 17.6005 31.1404C17.2952 30.8758 17.2 30.5197 17.2 30.1506C17.2 29.3366 17.9854 28.8506 18.8 28.8506C19.3769 28.8506 19.7383 28.9725 20.1789 29.1928C20.3765 29.2916 20.4566 29.5319 20.3578 29.7295C20.259 29.9271 20.0187 30.0072 19.8211 29.9084C19.4617 29.7286 19.2231 29.6506 18.8 29.6506Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 10.9502C14.1068 10.9502 13.1 12.0913 13.1 13.3502V25.4502H9.5C8.12386 25.4502 7 26.5741 7 27.9502V34.4502C7 35.8263 8.12386 36.9502 9.5 36.9502H13.1V38.4502C13.1 39.8433 14.2411 40.8502 15.5 40.8502H34.5C35.8931 40.8502 36.9 39.709 36.9 38.4502V18.4451L29.5091 10.9502H15.5ZM14.1 36.9502V38.4502C14.1 39.2571 14.7588 39.8502 15.5 39.8502H34.5C35.3069 39.8502 35.9 39.1913 35.9 38.4502V19.1502H29.3C29.0239 19.1502 28.8 18.9263 28.8 18.6502V11.9502H15.5C14.6931 11.9502 14.1 12.609 14.1 13.3502V25.4502H27.9C29.2761 25.4502 30.4 26.5741 30.4 27.9502V34.4502C30.4 35.8263 29.2761 36.9502 27.9 36.9502H14.1ZM29.8 18.1502V12.6694L35.2047 18.1502H29.8ZM8 27.9502C8 27.1263 8.67614 26.4502 9.5 26.4502H27.9C28.7239 26.4502 29.4 27.1263 29.4 27.9502V34.4502C29.4 35.2741 28.7239 35.9502 27.9 35.9502H9.5C8.67614 35.9502 8 35.2741 8 34.4502V27.9502Z" class="fill-border"/></svg>',
  connect_json: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.5 18.6502H29.3V11.4502" class="fill-background"/><path d="M27.9 36.4502H9.5C8.4 36.4502 7.5 35.5502 7.5 34.4502V27.9502C7.5 26.8502 8.4 25.9502 9.5 25.9502H27.9C29 25.9502 29.9 26.8502 29.9 27.9502V34.4502C29.9 35.5502 29 36.4502 27.9 36.4502Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2998 14.4502C18.0362 14.4502 17.7776 14.5403 17.5838 14.7341C17.3899 14.928 17.2998 15.1866 17.2998 15.4502V19.6502C17.2998 19.9138 17.3899 20.1724 17.5838 20.3662C17.7776 20.5601 18.0362 20.6502 18.2998 20.6502H21.1997V21.8506H20.3999C20.1238 21.8506 19.8999 22.0744 19.8999 22.3506C19.8999 22.6267 20.1238 22.8506 20.3999 22.8506H22.9999C23.276 22.8506 23.4999 22.6267 23.4999 22.3506C23.4999 22.0744 23.276 21.8506 22.9999 21.8506H22.1997V20.6502H24.9998C25.248 20.6502 25.5221 20.5701 25.7291 20.389C25.9403 20.2041 26.0722 19.9131 25.9998 19.5848V15.4502C25.9998 15.1866 25.9097 14.928 25.7159 14.7341C25.522 14.5403 25.2634 14.4502 24.9998 14.4502H18.2998ZM18.2998 19.6502V15.4502H24.9998V19.6502H18.2998Z" class="fill-border"/><path d="M15 30.1496C15 29.9636 15.2146 29.6496 15.8 29.6496C16.2231 29.6496 16.4617 29.7277 16.8211 29.9074C17.0187 30.0062 17.259 29.9261 17.3578 29.7285C17.4566 29.5309 17.3765 29.2906 17.1789 29.1918C16.7383 28.9715 16.3769 28.8496 15.8 28.8496C14.9854 28.8496 14.2 29.3356 14.2 30.1496C14.2 30.5187 14.2952 30.8748 14.6005 31.1394C14.8784 31.3802 15.2727 31.4918 15.738 31.5451C16.2125 31.6413 16.4888 31.7516 16.6408 31.8614C16.7662 31.952 16.8 32.0336 16.8 32.1496C16.8 32.2505 16.755 32.3589 16.6116 32.457C16.4597 32.561 16.196 32.6496 15.8 32.6496C15.3023 32.6496 14.9788 32.488 14.7219 32.3168C14.5381 32.1943 14.2897 32.2439 14.1672 32.4277C14.0447 32.6115 14.0943 32.8599 14.2781 32.9824C14.6213 33.2112 15.0977 33.4496 15.8 33.4496C16.304 33.4496 16.7403 33.3383 17.0634 33.1172C17.395 32.8903 17.6 32.5487 17.6 32.1496C17.6 31.7657 17.4338 31.4473 17.1092 31.2128C16.813 30.9989 16.3939 30.8605 15.8785 30.7574C15.8671 30.7551 15.8557 30.7533 15.8442 30.7521C15.4172 30.7046 15.2181 30.616 15.1245 30.5348C15.0548 30.4744 15 30.3805 15 30.1496Z" class="fill-border"/><path d="M13.0001 29.0498C13.221 29.0498 13.4001 29.2289 13.4001 29.4498V31.8498C13.4001 32.6932 12.6978 33.3498 11.8001 33.3498C11.2835 33.3498 10.7505 33.0966 10.4672 32.6717C10.3447 32.4879 10.3944 32.2395 10.5782 32.117C10.762 31.9944 11.0103 32.0441 11.1329 32.2279C11.2496 32.403 11.5166 32.5498 11.8001 32.5498C12.3023 32.5498 12.6001 32.2064 12.6001 31.8498V29.4498C12.6001 29.2289 12.7792 29.0498 13.0001 29.0498Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.2 29.0498C19.0189 29.0498 18.1 30.0566 18.1 31.2498C18.1 32.443 19.0189 33.4498 20.2 33.4498C21.381 33.4498 22.3 32.443 22.3 31.2498C22.3 30.0566 21.381 29.0498 20.2 29.0498ZM18.9 31.2498C18.9 30.4548 19.5032 29.8498 20.2 29.8498C20.8967 29.8498 21.5 30.4548 21.5 31.2498C21.5 32.0449 20.8967 32.6498 20.2 32.6498C19.5032 32.6498 18.9 32.0449 18.9 31.2498Z" class="fill-border"/><path d="M23.265 29.1729C23.424 29.1159 23.6016 29.1648 23.7089 29.2952L25.8001 31.8345V29.5494C25.8001 29.3285 25.9792 29.1494 26.2001 29.1494C26.421 29.1494 26.6001 29.3285 26.6001 29.5494V32.9494C26.6001 33.1183 26.4941 33.2689 26.3352 33.3259C26.1763 33.383 25.9987 33.334 25.8914 33.2037L23.8001 30.6644V32.9494C23.8001 33.1703 23.621 33.3494 23.4001 33.3494C23.1792 33.3494 23.0001 33.1703 23.0001 32.9494V29.5494C23.0001 29.3806 23.1061 29.2299 23.265 29.1729Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.1001 13.3502C13.1001 12.0913 14.107 10.9502 15.5001 10.9502H29.5093L36.9001 18.4451V38.4502C36.9001 39.709 35.8932 40.8502 34.5001 40.8502H15.5001C14.2413 40.8502 13.1001 39.8433 13.1001 38.4502V36.9502H9.5C8.12386 36.9502 7 35.8263 7 34.4502V27.9502C7 26.5741 8.12386 25.4502 9.5 25.4502H13.1001V13.3502ZM14.1001 38.4502V36.9502H27.9C29.2761 36.9502 30.4 35.8263 30.4 34.4502V27.9502C30.4 26.5741 29.2761 25.4502 27.9 25.4502H14.1001V13.3502C14.1001 12.609 14.6932 11.9502 15.5001 11.9502H28.8V18.6502C28.8 18.9263 29.0239 19.1502 29.3 19.1502H35.9001V38.4502C35.9001 39.1913 35.307 39.8502 34.5001 39.8502H15.5001C14.7589 39.8502 14.1001 39.2571 14.1001 38.4502ZM29.8 12.6693V18.1502H35.2048L29.8 12.6693ZM9.5 26.4502C8.67614 26.4502 8 27.1263 8 27.9502V34.4502C8 35.2741 8.67614 35.9502 9.5 35.9502H27.9C28.7239 35.9502 29.4 35.2741 29.4 34.4502V27.9502C29.4 27.1263 28.7239 26.4502 27.9 26.4502H9.5Z" class="fill-border"/></svg>',
  connect_csv_remote: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.5 18.6512H29.3V11.4512" class="fill-background"/><path d="M27.9 36.4512H9.5C8.4 36.4512 7.5 35.5512 7.5 34.4512V27.9512C7.5 26.8512 8.4 25.9512 9.5 25.9512H27.9C29 25.9512 29.9 26.8512 29.9 27.9512V34.4512C29.9 35.5512 29 36.4512 27.9 36.4512Z" class="fill-background"/><path d="M22.5 21.6514C22.5 22.2037 22.0523 22.6514 21.5 22.6514C20.9477 22.6514 20.5 22.2037 20.5 21.6514C20.5 21.0991 20.9477 20.6514 21.5 20.6514C22.0523 20.6514 22.5 21.0991 22.5 21.6514Z" class="fill-border"/><path d="M21.5 15.8516C19.7236 15.8516 18.1536 16.505 17.0535 17.6051C16.8582 17.8004 16.5417 17.8004 16.3464 17.6051C16.1511 17.4099 16.1511 17.0933 16.3464 16.898C17.6463 15.5981 19.4763 14.8516 21.5 14.8516C23.4276 14.8516 25.2563 15.6008 26.5535 16.898C26.7488 17.0933 26.7488 17.4099 26.5535 17.6051C26.3582 17.8004 26.0417 17.8004 25.8464 17.6051C24.7436 16.5023 23.1723 15.8516 21.5 15.8516Z" class="fill-border"/><path d="M18.4323 18.9251C19.2672 18.1829 20.3539 17.6514 21.5001 17.6514C22.6708 17.6514 23.7542 18.1018 24.5679 18.8251C24.7743 19.0085 25.0903 18.9899 25.2738 18.7835C25.4573 18.5772 25.4387 18.2611 25.2323 18.0777C24.246 17.2009 22.9294 16.6514 21.5001 16.6514C20.0463 16.6514 18.733 17.3198 17.7679 18.1777C17.5615 18.3611 17.5429 18.6772 17.7264 18.8835C17.9099 19.0899 18.2259 19.1085 18.4323 18.9251Z" class="fill-border"/><path d="M21.4999 19.4512C20.8353 19.4512 20.2454 19.6975 19.72 20.1353C19.5079 20.3121 19.1926 20.2834 19.0158 20.0713C18.839 19.8591 18.8677 19.5438 19.0798 19.3671C19.7544 18.8049 20.5645 18.4512 21.4999 18.4512C22.4283 18.4512 23.2568 18.8009 23.8535 19.3976C24.0487 19.5929 24.0487 19.9095 23.8535 20.1047C23.6582 20.3 23.3416 20.3 23.1464 20.1047C22.7431 19.7014 22.1715 19.4512 21.4999 19.4512Z" class="fill-border"/><path d="M24.7698 29.403C24.8539 29.1987 24.7565 28.9649 24.5523 28.8808C24.348 28.7967 24.1142 28.8941 24.0301 29.0984L22.9873 31.6309L21.8659 29.0892C21.7768 28.8871 21.5406 28.7956 21.3385 28.8847C21.1364 28.9739 21.0448 29.21 21.134 29.4121L22.634 32.8121C22.6987 32.9588 22.8447 33.0527 23.0049 33.0507C23.1652 33.0487 23.3088 32.9512 23.3698 32.803L24.7698 29.403Z" class="fill-border"/><path d="M14.0895 29.9891C13.8661 30.2036 13.7 30.544 13.7 31.0506C13.7 31.5726 13.8507 31.9105 14.0579 32.1177C14.2659 32.3258 14.5794 32.4506 15 32.4506C15.3828 32.4506 15.684 32.301 15.9172 32.0677C16.0734 31.9115 16.3267 31.9115 16.4829 32.0677C16.6391 32.224 16.6391 32.4772 16.4829 32.6334C16.1161 33.0002 15.6172 33.2506 15 33.2506C14.4206 33.2506 13.8842 33.0754 13.4922 32.6834C13.0994 32.2906 12.9 31.7286 12.9 31.0506C12.9 30.3572 13.1339 29.7976 13.5355 29.412C13.933 29.0304 14.4624 28.8506 15 28.8506C15.5301 28.8506 16.0267 29.1116 16.3829 29.4677C16.5391 29.624 16.5391 29.8772 16.3829 30.0334C16.2267 30.1896 15.9734 30.1896 15.8172 30.0334C15.5733 29.7896 15.2699 29.6506 15 29.6506C14.6377 29.6506 14.317 29.7708 14.0895 29.9891Z" class="fill-border"/><path d="M18.2 29.9504C18.2 29.7644 18.4146 29.4504 19 29.4504C19.4231 29.4504 19.6617 29.5285 20.0211 29.7082C20.2187 29.807 20.4589 29.7269 20.5577 29.5293C20.6565 29.3317 20.5764 29.0914 20.3789 28.9926C19.9383 28.7723 19.5769 28.6504 19 28.6504C18.1854 28.6504 17.4 29.1364 17.4 29.9504C17.4 30.3195 17.4952 30.6756 17.8005 30.9402C18.0784 31.181 18.4727 31.2926 18.9379 31.3459C19.4125 31.4421 19.6888 31.5524 19.8408 31.6622C19.9662 31.7527 20 31.8343 20 31.9504C20 32.0513 19.955 32.1597 19.8116 32.2578C19.6596 32.3617 19.396 32.4504 19 32.4504C18.5023 32.4504 18.1787 32.2888 17.9218 32.1176C17.738 31.995 17.4897 32.0447 17.3671 32.2285C17.2446 32.4123 17.2943 32.6607 17.4781 32.7832C17.8212 33.012 18.2977 33.2504 19 33.2504C19.504 33.2504 19.9403 33.139 20.2633 32.918C20.5949 32.6911 20.8 32.3495 20.8 31.9504C20.8 31.5664 20.6337 31.248 20.3092 31.0136C20.0129 30.7997 19.5938 30.6612 19.0784 30.5582C19.0671 30.5559 19.0556 30.5541 19.0441 30.5528C18.6172 30.5054 18.418 30.4167 18.3244 30.3356C18.2547 30.2752 18.2 30.1813 18.2 29.9504Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.1001 13.3512C13.1001 12.0923 14.107 10.9512 15.5001 10.9512H29.3001C29.4339 10.9512 29.5622 11.0048 29.6561 11.1001L36.7561 18.3001C36.8484 18.3937 36.9001 18.5198 36.9001 18.6512V38.4512C36.9001 39.71 35.8932 40.8512 34.5001 40.8512H15.5001C14.2413 40.8512 13.1001 39.8443 13.1001 38.4512V36.9512H9.5C8.12386 36.9512 7 35.8273 7 34.4512V27.9512C7 26.575 8.12386 25.4512 9.5 25.4512H13.1001V13.3512ZM14.1001 38.4512V36.9512H27.9C29.2761 36.9512 30.4 35.8273 30.4 34.4512V27.9512C30.4 26.575 29.2761 25.4512 27.9 25.4512H14.1001V13.3512C14.1001 12.61 14.6932 11.9512 15.5001 11.9512H28.8V18.6512C28.8 18.9273 29.0239 19.1512 29.3 19.1512H35.9001V38.4512C35.9001 39.1923 35.307 39.8512 34.5001 39.8512H15.5001C14.7589 39.8512 14.1001 39.258 14.1001 38.4512ZM29.8 12.6703V18.1512H35.2048L29.8 12.6703ZM9.5 26.4512C8.67614 26.4512 8 27.1273 8 27.9512V34.4512C8 35.275 8.67614 35.9512 9.5 35.9512H27.9C28.7239 35.9512 29.4 35.275 29.4 34.4512V27.9512C29.4 27.1273 28.7239 26.4512 27.9 26.4512H9.5Z" class="fill-border"/></svg>',
  connect_json_remote: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36.5 18.6502H29.3V11.4502" class="fill-background"/><path d="M27.9 36.4502H9.5C8.4 36.4502 7.5 35.5502 7.5 34.4502V27.9502C7.5 26.8502 8.4 25.9502 9.5 25.9502H27.9C29 25.9502 29.9 26.8502 29.9 27.9502V34.4502C29.9 35.5502 29 36.4502 27.9 36.4502Z" class="fill-background"/><path d="M21.5 22.6504C22.0523 22.6504 22.5 22.2027 22.5 21.6504C22.5 21.0981 22.0523 20.6504 21.5 20.6504C20.9477 20.6504 20.5 21.0981 20.5 21.6504C20.5 22.2027 20.9477 22.6504 21.5 22.6504Z" class="fill-border"/><path d="M17.0535 17.6041C18.1536 16.504 19.7236 15.8506 21.5 15.8506C23.1723 15.8506 24.7436 16.5014 25.8464 17.6041C26.0417 17.7994 26.3582 17.7994 26.5535 17.6041C26.7488 17.4089 26.7488 17.0923 26.5535 16.897C25.2563 15.5998 23.4276 14.8506 21.5 14.8506C19.4763 14.8506 17.6463 15.5971 16.3464 16.897C16.1511 17.0923 16.1511 17.4089 16.3464 17.6041C16.5417 17.7994 16.8582 17.7994 17.0535 17.6041Z" class="fill-border"/><path d="M21.5 17.6504C20.3538 17.6504 19.2671 18.1819 18.4322 18.9241C18.2258 19.1076 17.9097 19.089 17.7263 18.8826C17.5428 18.6762 17.5614 18.3601 17.7678 18.1767C18.7328 17.3189 20.0462 16.6504 21.5 16.6504C22.9292 16.6504 24.2459 17.2 25.2322 18.0767C25.4386 18.2601 25.4571 18.5762 25.2737 18.7826C25.0902 18.989 24.7742 19.0076 24.5678 18.8241C23.7541 18.1008 22.6707 17.6504 21.5 17.6504Z" class="fill-border"/><path d="M19.7201 20.1343C20.2455 19.6965 20.8354 19.4502 21.5 19.4502C22.1717 19.4502 22.7432 19.7005 23.1465 20.1037C23.3417 20.299 23.6583 20.299 23.8536 20.1037C24.0489 19.9085 24.0489 19.5919 23.8536 19.3966C23.2569 18.7999 22.4284 18.4502 21.5 18.4502C20.5647 18.4502 19.7546 18.8039 19.0799 19.3661C18.8678 19.5429 18.8391 19.8581 19.0159 20.0703C19.1927 20.2824 19.508 20.3111 19.7201 20.1343Z" class="fill-border"/><path d="M15.8 29.6506C15.2146 29.6506 15 29.9646 15 30.1506C15 30.3815 15.0548 30.4754 15.1245 30.5358C15.2181 30.6169 15.4172 30.7056 15.8442 30.753C15.8557 30.7543 15.8671 30.7561 15.8785 30.7584C16.3939 30.8614 16.813 30.9999 17.1092 31.2138C17.4338 31.4482 17.6 31.7666 17.6 32.1506C17.6 32.5497 17.395 32.8913 17.0634 33.1182C16.7403 33.3392 16.304 33.4506 15.8 33.4506C15.0977 33.4506 14.6213 33.2122 14.2781 32.9834C14.0943 32.8609 14.0447 32.6125 14.1672 32.4287C14.2897 32.2449 14.5381 32.1952 14.7219 32.3178C14.9788 32.489 15.3023 32.6506 15.8 32.6506C16.196 32.6506 16.4597 32.5619 16.6116 32.458C16.755 32.3598 16.8 32.2515 16.8 32.1506C16.8 32.0345 16.7662 31.9529 16.6408 31.8624C16.4888 31.7526 16.2125 31.6423 15.738 31.5461C15.2727 31.4928 14.8784 31.3812 14.6005 31.1404C14.2952 30.8758 14.2 30.5197 14.2 30.1506C14.2 29.3366 14.9854 28.8506 15.8 28.8506C16.3769 28.8506 16.7383 28.9725 17.1789 29.1928C17.3765 29.2916 17.4566 29.5319 17.3578 29.7295C17.259 29.9271 17.0187 30.0072 16.8211 29.9084C16.4617 29.7286 16.2231 29.6506 15.8 29.6506Z" class="fill-border"/><path d="M13.3999 29.4498C13.3999 29.2289 13.2209 29.0498 12.9999 29.0498C12.779 29.0498 12.5999 29.2289 12.5999 29.4498V31.8498C12.5999 32.2064 12.3022 32.5498 11.7999 32.5498C11.5165 32.5498 11.2495 32.403 11.1328 32.2279C11.0102 32.0441 10.7619 31.9944 10.5781 32.117C10.3943 32.2395 10.3446 32.4879 10.4671 32.6717C10.7504 33.0966 11.2834 33.3498 11.7999 33.3498C12.6977 33.3498 13.3999 32.6932 13.3999 31.8498V29.4498Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.1 31.2498C18.1 30.0566 19.0189 29.0498 20.2 29.0498C21.381 29.0498 22.3 30.0566 22.3 31.2498C22.3 32.443 21.381 33.4498 20.2 33.4498C19.0189 33.4498 18.1 32.443 18.1 31.2498ZM20.2 29.8498C19.5032 29.8498 18.9 30.4548 18.9 31.2498C18.9 32.0449 19.5032 32.6498 20.2 32.6498C20.8967 32.6498 21.5 32.0449 21.5 31.2498C21.5 30.4548 20.8967 29.8498 20.2 29.8498Z" class="fill-border"/><path d="M23.7088 29.2961C23.6014 29.1658 23.4238 29.1169 23.2649 29.1739C23.106 29.2309 23 29.3816 23 29.5504V32.9504C23 33.1713 23.1791 33.3504 23.4 33.3504C23.6209 33.3504 23.8 33.1713 23.8 32.9504V30.6653L25.8912 33.2047C25.9986 33.335 26.1762 33.3839 26.3351 33.3269C26.494 33.2699 26.6 33.1192 26.6 32.9504V29.5504C26.6 29.3295 26.4209 29.1504 26.2 29.1504C25.9791 29.1504 25.8 29.3295 25.8 29.5504V31.8355L23.7088 29.2961Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 10.9502C14.1068 10.9502 13.1 12.0913 13.1 13.3502V25.4502H9.5C8.12386 25.4502 7 26.5741 7 27.9502V34.4502C7 35.8263 8.12386 36.9502 9.5 36.9502H13.1V38.4502C13.1 39.8433 14.2411 40.8502 15.5 40.8502H34.5C35.8931 40.8502 36.9 39.709 36.9 38.4502V18.4451L29.5091 10.9502H15.5ZM14.1 36.9502V38.4502C14.1 39.2571 14.7588 39.8502 15.5 39.8502H34.5C35.3069 39.8502 35.9 39.1913 35.9 38.4502V19.1502H29.3C29.0239 19.1502 28.8 18.9263 28.8 18.6502V11.9502H15.5C14.6931 11.9502 14.1 12.609 14.1 13.3502V25.4502H27.9C29.2761 25.4502 30.4 26.5741 30.4 27.9502V34.4502C30.4 35.8263 29.2761 36.9502 27.9 36.9502H14.1ZM29.8 18.1502V12.6694L35.2047 18.1502H29.8ZM8 27.9502C8 27.1263 8.67614 26.4502 9.5 26.4502H27.9C28.7239 26.4502 29.4 27.1263 29.4 27.9502V34.4502C29.4 35.2741 28.7239 35.9502 27.9 35.9502H9.5C8.67614 35.9502 8 35.2741 8 34.4502V27.9502Z" class="fill-border"/></svg>',
  connect_elastic: '<svg width="50" height="50" viewBox="-14 -14 150 150" xmlns="http://www.w3.org/2000/svg"><path d="m53.2 68h-32.4c-1.2-3.8-1.8-7.8-1.8-12s0.6-8.2 1.8-12h53.2c6.7 0 12 5.4 12 12s-5.3 12-11.9 12h-20.9zm-1.5 4h-29.4c3.1 7.1 8.2 13.2 14.7 17.4 6.3 4.2 13.9 6.6 22 6.6 13.9 0 26.1-7.1 33.3-17.8-3.7-3.8-8.9-6.2-14.6-6.2h-26zm26-32c5.7 0 10.9-2.4 14.6-6.2-7.2-10.7-19.4-17.8-33.3-17.8-8.1 0-15.7 2.4-22 6.6-6.4 4.2-11.5 10.3-14.7 17.4h55.4z" class="fill-border" /></svg>',
  open: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M34.6 20.9H15.6V18.8C15.6 17.9 16.3 17.2 17.2 17.2H33C33.9 17.2 34.6 17.9 34.6 18.8V20.9Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.8 12V20.4031C10.7554 20.459 9.87391 21.386 10.0029 22.5542L10.0031 22.5556L11.8502 40.0004H38.1499L39.997 22.5556L39.9971 22.5543C40.1303 21.3489 39.1877 20.4004 38.1 20.4004L38.1 15.2C38.1 14.045 37.1969 13.1 36.1 13.1H23.9981L20.6981 10H13.7C12.5801 10 11.8 10.9698 11.8 12ZM13.7 11C13.22 11 12.8 11.4302 12.8 12V20.4004H15.1V18.8002C15.1 17.6241 16.0238 16.7002 17.2 16.7002H33C34.1761 16.7002 35.1 17.6241 35.1 18.8002V20.4004H37.1V15.2C37.1 14.555 36.6032 14.1 36.1 14.1H23.602L20.302 11H13.7ZM11.9 21.4004C11.3881 21.4004 10.931 21.8512 10.997 22.4452L10.9973 22.4477L12.7499 39.0004H37.2502L39.0028 22.4477L39.0031 22.4452C39.0691 21.8512 38.612 21.4004 38.1 21.4004H11.9ZM16.1 18.8002C16.1 18.1763 16.5761 17.7002 17.2 17.7002H33C33.6238 17.7002 34.1 18.1763 34.1 18.8002V20.4002H16.1V18.8002Z" class="fill-border"/></svg>',
  open_local: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4 18.1004V12.9004C12.4 12.1004 13 11.4004 13.8 11.4004H20.6L23.9 14.5004H36.2C37 14.5004 37.7 15.2004 37.7 16.1004V18.2004" class="fill-background"/><path d="M32.1 30.9004V32.2004C32.1 32.9004 31.5 33.5004 30.8 33.5004H19.2C18.5 33.5004 17.9 32.9004 17.9 32.2004V30.9004H32.1Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.5001 33.5006H19.2001C18.2239 33.5006 17.4001 32.6767 17.4001 31.7006V23.9006C17.4001 22.9244 18.2239 22.1006 19.2001 22.1006H30.8001C31.7762 22.1006 32.6001 22.9244 32.6001 23.9006V31.7006C32.6001 32.6767 31.7762 33.5006 30.8001 33.5006H25.5001V35.6006H27.4001C27.6762 35.6006 27.9001 35.8244 27.9001 36.1006C27.9001 36.3767 27.6762 36.6006 27.4001 36.6006H22.6001C22.3239 36.6006 22.1001 36.3767 22.1001 36.1006C22.1001 35.8244 22.3239 35.6006 22.6001 35.6006H24.5001V33.5006ZM19.2001 23.1006C18.7762 23.1006 18.4001 23.4767 18.4001 23.9006V30.4004H31.6001V23.9006C31.6001 23.4767 31.2239 23.1006 30.8001 23.1006H19.2001ZM18.4001 31.7006V31.4004H31.6001V31.7006C31.6001 32.1244 31.2239 32.5006 30.8001 32.5006H25.0245C25.0164 32.5002 25.0083 32.5 25.0001 32.5C24.9919 32.5 24.9837 32.5002 24.9756 32.5006H19.2001C18.7762 32.5006 18.4001 32.1244 18.4001 31.7006Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9001 12.9004V17.6006C10.8139 17.6006 9.87241 18.5465 10.0024 19.7495L11.8416 40.9006H38.1584L39.9977 19.7495C40.1237 18.5836 39.2433 17.6592 38.2001 17.6033V16.1004C38.2001 14.9454 37.2969 14.0004 36.2001 14.0004H24.0981L20.7981 10.9004H13.8001C12.6802 10.9004 11.9001 11.8702 11.9001 12.9004ZM13.8001 11.9004C13.32 11.9004 12.9001 12.3306 12.9001 12.9004V17.6006H37.2001V16.1004C37.2001 15.4554 36.7032 15.0004 36.2001 15.0004H23.7021L20.4021 11.9004H13.8001ZM11.9 18.6006C11.3881 18.6006 10.931 19.0514 10.997 19.6454L10.9983 19.6573L12.7584 39.9006H37.2416L39.003 19.6454C39.069 19.0513 38.612 18.6006 38.1 18.6006H11.9Z" class="fill-border"/></svg>',
  open_remote: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4 18.1005V12.9005C12.4 12.1005 13 11.4005 13.8 11.4005H20.6L23.9 14.5005H36.2C37 14.5005 37.7 15.2005 37.7 16.1005V18.2005" class="fill-background"/><path d="M25.0999 36.1004C26.094 36.1004 26.8999 35.2945 26.8999 34.3004C26.8999 33.3063 26.094 32.5004 25.0999 32.5004C24.1058 32.5004 23.2999 33.3063 23.2999 34.3004C23.2999 35.2945 24.1058 36.1004 25.0999 36.1004Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.7999 34.3C22.7999 33.0297 23.8296 32 25.0999 32C26.3702 32 27.3999 33.0297 27.3999 34.3C27.3999 35.5703 26.3702 36.6 25.0999 36.6C23.8296 36.6 22.7999 35.5703 22.7999 34.3ZM25.0999 33C24.3819 33 23.7999 33.582 23.7999 34.3C23.7999 35.018 24.3819 35.6 25.0999 35.6C25.8179 35.6 26.3999 35.018 26.3999 34.3C26.3999 33.582 25.8179 33 25.0999 33Z" class="fill-border"/><path d="M17.1616 26.646C19.1675 24.5446 21.9369 23.3008 25.0999 23.3008C28.1617 23.3008 30.9361 24.5441 32.9463 26.5543C33.1416 26.7496 33.4582 26.7496 33.6535 26.5543C33.8487 26.3591 33.8487 26.0425 33.6535 25.8472C31.4637 23.6575 28.4381 22.3008 25.0999 22.3008C21.6628 22.3008 18.6323 23.657 16.4382 25.9555C16.2475 26.1553 16.2549 26.4718 16.4547 26.6625C16.6544 26.8531 16.9709 26.8458 17.1616 26.646Z" class="fill-border"/><path d="M24.9999 26.5C22.8464 26.5 20.87 27.437 19.4535 28.8536C19.2582 29.0488 18.9416 29.0488 18.7464 28.8536C18.5511 28.6583 18.5511 28.3417 18.7464 28.1464C20.3298 26.563 22.5534 25.5 24.9999 25.5C27.428 25.5 29.6639 26.4501 31.1654 28.0588C31.3539 28.2607 31.3429 28.5771 31.1411 28.7655C30.9392 28.9539 30.6228 28.943 30.4344 28.7412C29.1359 27.3499 27.1718 26.5 24.9999 26.5Z" class="fill-border"/><path d="M21.8535 31.2539C22.666 30.4414 23.8412 29.9004 25.0999 29.9004C26.3481 29.9004 27.4256 30.4332 28.2464 31.2539C28.4416 31.4492 28.7582 31.4492 28.9535 31.2539C29.1487 31.0587 29.1487 30.7421 28.9535 30.5468C27.9742 29.5676 26.6517 28.9004 25.0999 28.9004C23.5586 28.9004 22.1338 29.5594 21.1464 30.5468C20.9511 30.7421 20.9511 31.0587 21.1464 31.2539C21.3416 31.4492 21.6582 31.4492 21.8535 31.2539Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.8999 17.6006V12.9004C11.8999 11.8702 12.68 10.9004 13.7999 10.9004H20.7979L24.0979 14.0004H36.1999C37.2968 14.0004 38.1999 14.9454 38.1999 16.1004V17.6033C39.2431 17.6591 40.1236 18.5836 39.9975 19.7495L38.1583 40.9006H11.8415L10.0023 19.7495C9.87228 18.5465 10.8138 17.6006 11.8999 17.6006ZM12.8999 12.9004C12.8999 12.3306 13.3198 11.9004 13.7999 11.9004H20.4019L23.7019 15.0004H36.1999C36.703 15.0004 37.1999 15.4554 37.1999 16.1004V17.6006H12.8999V12.9004ZM10.9969 19.6454C10.9309 19.0514 11.388 18.6006 11.8999 18.6006H38.0999C38.6119 18.6006 39.0688 19.0513 39.0028 19.6454L37.2415 39.9006H12.7583L10.9982 19.6573L10.9969 19.6454Z" class="fill-border"/></svg>',
  grid: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.5 20.2H10.5V12.6C10.5 11.4 11.4 10.5 12.6 10.5H37.4C38.6 10.5 39.5 11.4 39.5 12.6V20.2V20.2Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10 12.6V37.4C10 38.8761 11.1239 40 12.6 40H37.4C38.8761 40 40 38.8761 40 37.4V12.6C40 11.1239 38.8761 10 37.4 10H12.6C11.1239 10 10 11.1239 10 12.6ZM12.6 11C11.6761 11 11 11.6761 11 12.6V19.7H39V12.6C39 11.6761 38.3239 11 37.4 11H12.6ZM39 29.5996V20.7H30.3V29.5996H39ZM29.3 29.5996H20.7V20.7H29.3V29.5996ZM29.3 30.5996V39H20.7V30.5996H29.3ZM30.3 39V30.5996H39V37.4C39 38.3239 38.3239 39 37.4 39H30.3ZM19.7 29.5996V20.7H11V29.5996H19.7ZM11 30.5996H19.7V39H12.6C11.6761 39 11 38.3239 11 37.4V30.5996Z" class="fill-border"/></svg>',
  save: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.9496 18.5H20.9496C20.0496 18.5 19.3496 17.8 19.3496 16.9V10.5H31.5496V16.9C31.5496 17.8 30.8496 18.5 29.9496 18.5Z" class="fill-background"/><path d="M35.9496 39.5H14.8496V25.9C14.8496 24.6 15.9496 23.5 17.2496 23.5H33.4496C34.7496 23.5 35.8496 24.6 35.8496 25.9V39.5H35.9496Z" class="fill-background"/><path d="M31.55 29.4004H19.25V28.4004H31.55V29.4004Z" class="fill-border"/><path d="M19.25 34.5996H31.55V33.5996H19.25V34.5996Z" class="fill-border"/><path d="M28.5498 12.4004V16.4004H29.5498V12.4004H28.5498Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.7498 10C11.7737 10 10.0498 11.7239 10.0498 13.7V36.2C10.0498 38.2862 11.7839 39.9 13.7498 39.9H14.3496V40H35.9496V39.9H36.2498C38.336 39.9 39.9498 38.166 39.9498 36.2V17C39.9498 16.8757 39.9035 16.7559 39.82 16.6639L33.92 10.1639C33.8253 10.0595 33.6908 10 33.5498 10H13.7498ZM15.3496 38.9H35.3496V25.9C35.3496 24.8761 34.4735 24 33.4496 24H17.2496C16.2258 24 15.3496 24.8761 15.3496 25.9V38.9ZM36.3496 25.9V38.8982C37.8154 38.844 38.9498 37.6024 38.9498 36.2V17.1931L33.3284 11H32.0496V16.9C32.0496 18.0761 31.1258 19 29.9496 19H20.9496C19.7735 19 18.8496 18.0761 18.8496 16.9V11H13.7498C12.3259 11 11.0498 12.2761 11.0498 13.7V36.2C11.0498 37.7138 12.3158 38.9 13.7498 38.9H14.3496V25.9C14.3496 24.3239 15.6735 23 17.2496 23H33.4496C35.0257 23 36.3496 24.3239 36.3496 25.9ZM31.0496 11H19.8496V16.9C19.8496 17.5239 20.3258 18 20.9496 18H29.9496C30.5735 18 31.0496 17.5239 31.0496 16.9V11Z" class="fill-border"/></svg>',
  "export": '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33.6998 19.2L24.9998 10.5L16.2998 19.2H21.1998V31.8H28.7998V19.2H33.6998Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M25.3534 10.1464C25.1581 9.95118 24.8415 9.95118 24.6463 10.1464L15.9463 18.8464C15.8033 18.9894 15.7605 19.2045 15.8379 19.3913C15.9153 19.5782 16.0976 19.7 16.2998 19.7H20.6998V23H12.1C10.9239 23 10 23.9239 10 25.1V37.9C10 39.0761 10.9239 40 12.1 40H37.9C39.0761 40 40 39.0761 40 37.9V25.1C40 23.9239 39.0761 23 37.9 23H29.2998V19.7H33.6998C33.9021 19.7 34.0844 19.5782 34.1618 19.3913C34.2392 19.2045 34.1964 18.9894 34.0534 18.8464L25.3534 10.1464ZM29.2998 24V31.8C29.2998 32.0761 29.076 32.3 28.7998 32.3H21.1998C20.9237 32.3 20.6998 32.0761 20.6998 31.8V24H12.1C11.4761 24 11 24.4761 11 25.1V37.9C11 38.5239 11.4761 39 12.1 39H37.9C38.5239 39 39 38.5239 39 37.9V25.1C39 24.4761 38.5239 24 37.9 24H29.2998ZM17.5069 18.7L24.9998 11.2071L32.4927 18.7H28.7998C28.5237 18.7 28.2998 18.9239 28.2998 19.2V31.3H21.6998V19.2C21.6998 18.9239 21.476 18.7 21.1998 18.7H17.5069Z" class="fill-border"/></svg>',
  export_print: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M32.9462 33.5002H38.0463C39.1463 33.5002 40.0463 32.5002 39.9463 31.5002V22.2002C39.9463 21.1002 39.0463 20.2002 37.9463 20.2002H13.0463C11.9463 20.2002 11.0463 21.1002 11.0463 22.2002V31.5002C11.0463 32.6002 11.9463 33.5002 13.0463 33.5002H18.1462V27.8008H32.9462V33.5002Z" class="fill-background"/><path d="M32.9463 16.0004H28.3463V11.4004L32.9463 16.0004Z" class="fill-background"/><path d="M15.4462 22C15.1701 22 14.9462 22.2239 14.9462 22.5C14.9462 22.7761 15.1701 23 15.4462 23H18.1462C18.4224 23 18.6462 22.7761 18.6462 22.5C18.6462 22.2239 18.4224 22 18.1462 22H15.4462Z" class="fill-border"/><path d="M20.7463 33.5C20.7463 33.2239 20.9701 33 21.2463 33H29.9463C30.2224 33 30.4463 33.2239 30.4463 33.5C30.4463 33.7761 30.2224 34 29.9463 34H21.2463C20.9701 34 20.7463 33.7761 20.7463 33.5Z" class="fill-border"/><path d="M21.2463 35.7002C20.9701 35.7002 20.7463 35.9241 20.7463 36.2002C20.7463 36.4763 20.9701 36.7002 21.2463 36.7002H29.9463C30.2224 36.7002 30.4463 36.4763 30.4463 36.2002C30.4463 35.9241 30.2224 35.7002 29.9463 35.7002H21.2463Z" class="fill-border"/><path d="M20.7463 30.7002C20.7463 30.4241 20.9701 30.2002 21.2463 30.2002H29.9463C30.2224 30.2002 30.4463 30.4241 30.4463 30.7002C30.4463 30.9763 30.2224 31.2002 29.9463 31.2002H21.2463C20.9701 31.2002 20.7463 30.9763 20.7463 30.7002Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6462 12.7004C17.6462 11.7242 18.4701 10.9004 19.4462 10.9004L22.3618 11.9004H19.4462C19.0224 11.9004 18.6462 12.2765 18.6462 12.7004V19.7002H32.4462V16.5004H28.3463C28.0701 16.5004 27.8463 16.2765 27.8463 16.0004V13.7815L28.8463 14.1245V15.5004H31.7391L31.1552 14.9165L33.3075 15.6547C33.3964 15.7476 33.4462 15.8714 33.4462 16.0004V19.7002H37.9463C39.3224 19.7002 40.4463 20.8241 40.4463 22.2002V31.477C40.5592 32.7766 39.4174 34.0002 38.0463 34.0002H33.4462V40.4008C33.4462 40.6769 33.2224 40.9008 32.9462 40.9008H18.1462C17.8701 40.9008 17.6462 40.6769 17.6462 40.4008V34.0002H13.0463C11.6701 34.0002 10.5463 32.8763 10.5463 31.5002V22.2002C10.5463 20.8241 11.6701 19.7002 13.0463 19.7002H17.6462V12.7004ZM38.0463 33.0002H33.4462V28.3008H35.7462C36.0224 28.3008 36.2462 28.0769 36.2462 27.8008C36.2462 27.5246 36.0224 27.3008 35.7462 27.3008H15.4462C15.1701 27.3008 14.9462 27.5246 14.9462 27.8008C14.9462 28.0769 15.1701 28.3008 15.4462 28.3008H17.6462V33.0002H13.0463C12.2224 33.0002 11.5463 32.3241 11.5463 31.5002V22.2002C11.5463 21.3763 12.2224 20.7002 13.0463 20.7002H37.9463C38.7701 20.7002 39.4463 21.3763 39.4463 22.2002V31.5002C39.4463 31.5168 39.4471 31.5334 39.4487 31.5499C39.5178 32.2405 38.8658 33.0002 38.0463 33.0002ZM18.6462 28.3008V39.9008H32.4462V28.3008H18.6462Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.1485 14.9098L33.2998 15.6468L28.6998 11.0469C28.686 11.0331 28.6716 11.0202 28.6564 11.0083C28.6201 10.9795 28.58 10.956 28.5376 10.9385C28.5219 10.9319 28.5059 10.9262 28.4896 10.9214C28.4513 10.9099 28.4115 10.903 28.371 10.901C28.3628 10.9006 28.3545 10.9004 28.3462 10.9004H19.4462L22.365 11.9004H22.3618L27.8463 13.7815V13.7784L28.8463 14.121V14.1245L31.1552 14.9165L31.1485 14.9098ZM31.1485 14.9098L28.8463 12.6075V14.121L31.1485 14.9098ZM27.8463 13.7784L22.365 11.9004H27.8463V13.7784Z" class="fill-border"/></svg>',
  export_csv: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37 18.6502H29.8V11.4502" class="fill-background"/><path d="M28.4 36.4502H10C8.9 36.4502 8 35.5502 8 34.4502V27.9502C8 26.8502 8.9 25.9502 10 25.9502H28.4C29.5 25.9502 30.4 26.8502 30.4 27.9502V34.4502C30.4 35.5502 29.5 36.4502 28.4 36.4502Z" class="fill-background"/><path d="M25.5699 29.7028C25.654 29.4985 25.5566 29.2647 25.3523 29.1806C25.148 29.0965 24.9142 29.1939 24.8301 29.3982L23.7873 31.9308L22.666 29.389C22.5768 29.1869 22.3407 29.0954 22.1385 29.1845C21.9364 29.2737 21.8449 29.5098 21.934 29.712L23.434 33.112C23.4987 33.2586 23.6447 33.3525 23.805 33.3505C23.9652 33.3485 24.1088 33.251 24.1699 33.1028L25.5699 29.7028Z" class="fill-border"/><path d="M14.8895 30.1884C14.6661 30.4028 14.5 30.7432 14.5 31.2498C14.5 31.7718 14.6507 32.1098 14.8579 32.317C15.0659 32.525 15.3794 32.6498 15.8 32.6498C16.1828 32.6498 16.4839 32.5002 16.7172 32.267C16.8734 32.1108 17.1266 32.1108 17.2829 32.267C17.4391 32.4232 17.4391 32.6764 17.2829 32.8326C16.9161 33.1994 16.4172 33.4498 15.8 33.4498C15.2206 33.4498 14.6842 33.2746 14.2922 32.8826C13.8994 32.4898 13.7 31.9278 13.7 31.2498C13.7 30.5564 13.9339 29.9968 14.3355 29.6112C14.733 29.2296 15.2623 29.0498 15.8 29.0498C16.3301 29.0498 16.8267 29.3108 17.1829 29.667C17.3391 29.8232 17.3391 30.0764 17.1829 30.2326C17.0266 30.3889 16.7734 30.3889 16.6172 30.2326C16.3733 29.9888 16.0699 29.8498 15.8 29.8498C15.4377 29.8498 15.117 29.97 14.8895 30.1884Z" class="fill-border"/><path d="M19 30.1506C19 29.9646 19.2146 29.6506 19.8 29.6506C20.2231 29.6506 20.4617 29.7286 20.8211 29.9084C21.0187 30.0072 21.259 29.9271 21.3578 29.7295C21.4566 29.5319 21.3765 29.2916 21.1789 29.1928C20.7383 28.9725 20.3769 28.8506 19.8 28.8506C18.9854 28.8506 18.2 29.3366 18.2 30.1506C18.2 30.5197 18.2952 30.8758 18.6005 31.1404C18.8784 31.3812 19.2727 31.4928 19.738 31.5461C20.2125 31.6423 20.4888 31.7526 20.6408 31.8624C20.7662 31.9529 20.8 32.0345 20.8 32.1506C20.8 32.2515 20.755 32.3598 20.6116 32.458C20.4597 32.5619 20.196 32.6506 19.8 32.6506C19.3023 32.6506 18.9788 32.489 18.7219 32.3178C18.5381 32.1952 18.2897 32.2449 18.1672 32.4287C18.0447 32.6125 18.0943 32.8609 18.2781 32.9834C18.6213 33.2122 19.0977 33.4506 19.8 33.4506C20.304 33.4506 20.7403 33.3392 21.0634 33.1182C21.395 32.8913 21.6 32.5497 21.6 32.1506C21.6 31.7666 21.4338 31.4482 21.1092 31.2138C20.813 30.9999 20.3939 30.8614 19.8785 30.7584C19.8671 30.7561 19.8557 30.7543 19.8442 30.753C19.4172 30.7056 19.2181 30.6169 19.1245 30.5358C19.0548 30.4754 19 30.3815 19 30.1506Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6001 13.3502C13.6001 12.0913 14.607 10.9502 16.0001 10.9502H30.0093L37.4001 18.4451V38.4502C37.4001 39.709 36.3932 40.8502 35.0001 40.8502H16.0001C14.7413 40.8502 13.6001 39.8433 13.6001 38.4502V36.9502H10C8.62386 36.9502 7.5 35.8263 7.5 34.4502V27.9502C7.5 26.5741 8.62386 25.4502 10 25.4502H13.6001V13.3502ZM14.6001 38.4502V36.9502H28.4C29.7761 36.9502 30.9 35.8263 30.9 34.4502V27.9502C30.9 26.5741 29.7761 25.4502 28.4 25.4502H14.6001V13.3502C14.6001 12.609 15.1932 11.9502 16.0001 11.9502H29.3V18.6502C29.3 18.9263 29.5238 19.1502 29.8 19.1502H36.4001V38.4502C36.4001 39.1913 35.807 39.8502 35.0001 39.8502H16.0001C15.2589 39.8502 14.6001 39.2571 14.6001 38.4502ZM30.3 12.6692V18.1502H35.7048L30.3 12.6692ZM10 26.4502C9.17614 26.4502 8.5 27.1263 8.5 27.9502V34.4502C8.5 35.2741 9.17614 35.9502 10 35.9502H28.4C29.2239 35.9502 29.9 35.2741 29.9 34.4502V27.9502C29.9 27.1263 29.2239 26.4502 28.4 26.4502H10Z" class="fill-border"/></svg>',
  export_excel: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37 18.6502H29.8V11.4502" class="fill-background"/><path d="M28.4 36.4502H10C8.9 36.4502 8 35.5502 8 34.4502V27.9502C8 26.8502 8.9 25.9502 10 25.9502H28.4C29.5 25.9502 30.4 26.8502 30.4 27.9502V34.4502C30.4 35.5502 29.5 36.4502 28.4 36.4502Z" class="fill-background"/><path d="M22.7 29.55C22.1146 29.55 21.9 29.864 21.9 30.05C21.9 30.2809 21.9548 30.3748 22.0245 30.4352C22.1181 30.5163 22.3172 30.605 22.7442 30.6524C22.7557 30.6537 22.7671 30.6555 22.7784 30.6578C23.2938 30.7608 23.7129 30.8993 24.0092 31.1132C24.3338 31.3476 24.5 31.666 24.5 32.05C24.5 32.4491 24.295 32.7907 23.9634 33.0176C23.6403 33.2387 23.204 33.35 22.7 33.35C21.9977 33.35 21.5212 33.1116 21.1781 32.8828C20.9943 32.7603 20.9446 32.5119 21.0672 32.3281C21.1897 32.1443 21.4381 32.0946 21.6219 32.2172C21.8787 32.3884 22.2023 32.55 22.7 32.55C23.096 32.55 23.3597 32.4613 23.5116 32.3574C23.655 32.2593 23.7 32.1509 23.7 32.05C23.7 31.934 23.6662 31.8524 23.5408 31.7618C23.3888 31.652 23.1125 31.5417 22.638 31.4455C22.1727 31.3922 21.7784 31.2806 21.5005 31.0398C21.1952 30.7752 21.1 30.4191 21.1 30.05C21.1 29.236 21.8854 28.75 22.7 28.75C23.2769 28.75 23.6383 28.8719 24.0789 29.0922C24.2765 29.191 24.3565 29.4313 24.2578 29.6289C24.159 29.8265 23.9187 29.9066 23.7211 29.8078C23.3617 29.6281 23.1231 29.55 22.7 29.55Z" class="fill-border"/><path d="M18.6 29.2506C18.6 29.0297 18.4209 28.8506 18.2 28.8506C17.9791 28.8506 17.8 29.0297 17.8 29.2506V32.7506C17.8 32.9715 17.9791 33.1506 18.2 33.1506H20.2C20.4209 33.1506 20.6 32.9715 20.6 32.7506C20.6 32.5297 20.4209 32.3506 20.2 32.3506H18.6V29.2506Z" class="fill-border"/><path d="M13.8556 28.9339C14.0306 28.799 14.2817 28.8314 14.4167 29.0063L15.45 30.3457L16.4833 29.0063C16.6182 28.8314 16.8694 28.799 17.0443 28.9339C17.2192 29.0688 17.2516 29.32 17.1167 29.4949L15.9552 31.0006L17.1167 32.5063C17.2516 32.6812 17.2192 32.9324 17.0443 33.0673C16.8694 33.2023 16.6182 33.1698 16.4833 32.9949L15.45 31.6555L14.4167 32.9949C14.2817 33.1698 14.0306 33.2023 13.8556 33.0673C13.6807 32.9324 13.6483 32.6812 13.7833 32.5063L14.9448 31.0006L13.7833 29.4949C13.6483 29.32 13.6807 29.0688 13.8556 28.9339Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.0001 10.9502C14.607 10.9502 13.6001 12.0913 13.6001 13.3502V25.4502H10C8.62386 25.4502 7.5 26.5741 7.5 27.9502V34.4502C7.5 35.8263 8.62386 36.9502 10 36.9502H13.6001V38.4502C13.6001 39.8433 14.7413 40.8502 16.0001 40.8502H35.0001C36.3932 40.8502 37.4001 39.709 37.4001 38.4502V18.4451L30.0093 10.9502H16.0001ZM14.6001 36.9502V38.4502C14.6001 39.2571 15.2589 39.8502 16.0001 39.8502H35.0001C35.807 39.8502 36.4001 39.1913 36.4001 38.4502V19.1502H29.8C29.5238 19.1502 29.3 18.9263 29.3 18.6502V11.9502H16.0001C15.1932 11.9502 14.6001 12.609 14.6001 13.3502V25.4502H28.4C29.7761 25.4502 30.9 26.5741 30.9 27.9502V34.4502C30.9 35.8263 29.7761 36.9502 28.4 36.9502H14.6001ZM30.3 18.1502V12.6692L35.7048 18.1502H30.3ZM8.5 27.9502C8.5 27.1263 9.17614 26.4502 10 26.4502H28.4C29.2239 26.4502 29.9 27.1263 29.9 27.9502V34.4502C29.9 35.2741 29.2239 35.9502 28.4 35.9502H10C9.17614 35.9502 8.5 35.2741 8.5 34.4502V27.9502Z" class="fill-border"/></svg>',
  export_html: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37 18.6502H29.8V11.4502" class="fill-background"/><path d="M28.4 36.4502H10C8.9 36.4502 8 35.5502 8 34.4502V27.9502C8 26.8502 8.9 25.9502 10 25.9502H28.4C29.5 25.9502 30.4 26.8502 30.4 27.9502V34.4502C30.4 35.5502 29.5 36.4502 28.4 36.4502Z" class="fill-background"/><path d="M25.4 28.75C25.6209 28.75 25.8 28.9291 25.8 29.15V32.25H27.4C27.6209 32.25 27.8 32.4291 27.8 32.65C27.8 32.8709 27.6209 33.05 27.4 33.05H25.4C25.1791 33.05 25 32.8709 25 32.65V29.15C25 28.9291 25.1791 28.75 25.4 28.75Z" class="fill-border"/><path d="M20.1411 28.941C20.0475 28.7883 19.8638 28.7164 19.6914 28.7651C19.5191 28.8137 19.4 28.9709 19.4 29.15V32.65C19.4 32.8709 19.5791 33.05 19.8 33.05C20.0209 33.05 20.2 32.8709 20.2 32.65V30.5681L21.3537 32.4505C21.373 32.4838 21.3973 32.5147 21.4263 32.5418C21.4545 32.5683 21.4861 32.5902 21.5198 32.6072C21.6276 32.6614 21.7576 32.6658 21.8719 32.6113C21.9056 32.5953 21.9373 32.5744 21.9658 32.549C21.9959 32.5223 22.0213 32.4917 22.0416 32.4584L23.3 30.5079V32.65C23.3 32.8709 23.4791 33.05 23.7 33.05C23.9209 33.05 24.1 32.8709 24.1 32.65V29.15C24.1 28.9727 23.9832 28.8165 23.813 28.7663C23.6429 28.7162 23.46 28.7841 23.3639 28.9332L21.7087 31.4987L20.1411 28.941Z" class="fill-border"/><path d="M14.7 29.15C14.7 28.9291 14.5209 28.75 14.3 28.75C14.0791 28.75 13.9 28.9291 13.9 29.15V30.4502H12.1V29.15C12.1 28.9291 11.9209 28.75 11.7 28.75C11.4791 28.75 11.3 28.9291 11.3 29.15V32.65C11.3 32.8709 11.4791 33.05 11.7 33.05C11.9209 33.05 12.1 32.8709 12.1 32.65V31.2502H13.9V32.65C13.9 32.8709 14.0791 33.05 14.3 33.05C14.5209 33.05 14.7 32.8709 14.7 32.65V29.15Z" class="fill-border"/><path d="M17.4 29.55H18.3C18.5209 29.55 18.7 29.3709 18.7 29.15C18.7 28.9291 18.5209 28.75 18.3 28.75H15.7C15.4791 28.75 15.3 28.9291 15.3 29.15C15.3 29.3709 15.4791 29.55 15.7 29.55H16.6V32.65C16.6 32.8709 16.7791 33.05 17 33.05C17.2209 33.05 17.4 32.8709 17.4 32.65V29.55Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.0001 10.9502C14.607 10.9502 13.6001 12.0913 13.6001 13.3502V25.4502H10C8.62386 25.4502 7.5 26.5741 7.5 27.9502V34.4502C7.5 35.8263 8.62386 36.9502 10 36.9502H13.6001V38.4502C13.6001 39.8433 14.7413 40.8502 16.0001 40.8502H35.0001C36.3932 40.8502 37.4001 39.709 37.4001 38.4502V18.4451L30.0093 10.9502H16.0001ZM14.6001 36.9502V38.4502C14.6001 39.2571 15.2589 39.8502 16.0001 39.8502H35.0001C35.807 39.8502 36.4001 39.1913 36.4001 38.4502V19.1502H29.8C29.5238 19.1502 29.3 18.9263 29.3 18.6502V11.9502H16.0001C15.1932 11.9502 14.6001 12.609 14.6001 13.3502V25.4502H28.4C29.7761 25.4502 30.9 26.5741 30.9 27.9502V34.4502C30.9 35.8263 29.7761 36.9502 28.4 36.9502H14.6001ZM30.3 18.1502V12.6692L35.7048 18.1502H30.3ZM8.5 27.9502C8.5 27.1263 9.17614 26.4502 10 26.4502H28.4C29.2239 26.4502 29.9 27.1263 29.9 27.9502V34.4502C29.9 35.2741 29.2239 35.9502 28.4 35.9502H10C9.17614 35.9502 8.5 35.2741 8.5 34.4502V27.9502Z" class="fill-border"/></svg>',
  export_image: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.9 33.9512H17.5V19.8506C17.5 18.7506 18.4 17.8506 19.5 17.8506H33.5V13.3512C33.5 12.3512 32.7 11.4512 31.6 11.4512H12.9C11.9 11.4512 11 12.2512 11 13.3512V32.0512C11 33.0512 11.8 33.9512 12.9 33.9512Z" class="fill-background"/><path d="M33.5 25.6508C34.7702 25.6508 35.7999 24.621 35.7999 23.3508C35.7999 22.0805 34.7702 21.0508 33.5 21.0508C32.2297 21.0508 31.2 22.0805 31.2 23.3508C31.2 24.621 32.2297 25.6508 33.5 25.6508Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M33.5 20.5508C31.9536 20.5508 30.7 21.8044 30.7 23.3508C30.7 24.8972 31.9536 26.1508 33.5 26.1508C35.0464 26.1508 36.3 24.8972 36.3 23.3508C36.3 21.8044 35.0464 20.5508 33.5 20.5508ZM31.7 23.3508C31.7 22.3567 32.5059 21.5508 33.5 21.5508C34.4941 21.5508 35.3 22.3567 35.3 23.3508C35.3 24.3449 34.4941 25.1508 33.5 25.1508C32.5059 25.1508 31.7 24.3449 31.7 23.3508Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.9 34.4512H17V38.3506C17 39.7267 18.1239 40.8506 19.5 40.8506H38C39.3761 40.8506 40.5 39.7267 40.5 38.3506V19.8506C40.5 18.4744 39.3761 17.3506 38 17.3506H34V13.3512C34 12.0923 32.9931 10.9512 31.6 10.9512H12.9C11.6412 10.9512 10.5 11.958 10.5 13.3512V32.0512C10.5 33.31 11.5069 34.4512 12.9 34.4512ZM12.9 11.9512C12.1588 11.9512 11.5 12.5443 11.5 13.3512V32.0512C11.5 32.7923 12.0931 33.4512 12.9 33.4512H17V19.8506C17 18.4744 18.1239 17.3506 19.5 17.3506H33V13.3512C33 12.61 32.4069 11.9512 31.6 11.9512H12.9ZM19.5 18.3506C18.6761 18.3506 18 19.0267 18 19.8506V32.8735L25.7528 25.3912C25.9427 25.2079 26.2424 25.2038 26.4373 25.3818L33.4607 31.7989L36.1521 29.1917C36.3461 29.0037 36.6544 29.0038 36.8482 29.192L39.5 31.7658V19.8506C39.5 19.0267 38.8239 18.3506 38 18.3506H19.5ZM39.5 37.3169L34.2003 32.4747L36.4997 30.2472L39.5 33.1593V37.3169ZM39.4707 38.6447L26.1094 26.4368L18 34.2633V38.3506C18 39.1744 18.6761 39.8506 19.5 39.8506H38C38.7233 39.8506 39.3327 39.3294 39.4707 38.6447Z" class="fill-border"/></svg>',
  export_pdf: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37 18.6502H29.8V11.4502" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M30.3 18.1502V11.4502H29.3V18.6502C29.3 18.9263 29.5239 19.1502 29.8 19.1502H37V18.1502H30.3Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6001 13.3502C13.6001 12.0913 14.607 10.9502 16.0001 10.9502H30.0093L37.4001 18.4451V38.4502C37.4001 39.709 36.3932 40.8502 35.0001 40.8502H16.0001C14.7413 40.8502 13.6001 39.8433 13.6001 38.4502V13.3502ZM16.0001 11.9502C15.1932 11.9502 14.6001 12.609 14.6001 13.3502V38.4502C14.6001 39.2571 15.2589 39.8502 16.0001 39.8502H35.0001C35.807 39.8502 36.4001 39.1913 36.4001 38.4502V18.8553L29.5909 11.9502H16.0001Z" class="fill-border"/><path d="M28.4 36.4502H10C8.9 36.4502 8 35.5502 8 34.4502V27.9502C8 26.8502 8.9 25.9502 10 25.9502H28.4C29.5 25.9502 30.4 26.8502 30.4 27.9502V34.4502C30.4 35.5502 29.5 36.4502 28.4 36.4502Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10 26.4502C9.17614 26.4502 8.5 27.1263 8.5 27.9502V34.4502C8.5 35.2741 9.17614 35.9502 10 35.9502H28.4C29.2239 35.9502 29.9 35.2741 29.9 34.4502V27.9502C29.9 27.1263 29.2239 26.4502 28.4 26.4502H10ZM7.5 27.9502C7.5 26.5741 8.62386 25.4502 10 25.4502H28.4C29.7761 25.4502 30.9 26.5741 30.9 27.9502V34.4502C30.9 35.8263 29.7761 36.9502 28.4 36.9502H10C8.62386 36.9502 7.5 35.8263 7.5 34.4502V27.9502Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.1 28.8502C18.3209 28.8502 18.5 29.0293 18.5 29.2502V32.6502C18.5 32.8711 18.3209 33.0502 18.1 33.0502C17.879 33.0502 17.7 32.8711 17.7 32.6502V29.2502C17.7 29.0293 17.879 28.8502 18.1 28.8502Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.1 29.2502C22.1 29.0293 22.2791 28.8502 22.5 28.8502H24.3C24.5209 28.8502 24.7 29.0293 24.7 29.2502C24.7 29.4711 24.5209 29.6502 24.3 29.6502H22.9V32.6502C22.9 32.8711 22.7209 33.0502 22.5 33.0502C22.2791 33.0502 22.1 32.8711 22.1 32.6502V29.2502Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.3 28.8502C14.5209 28.8502 14.7 29.0293 14.7 29.2502V32.6502C14.7 32.8711 14.5209 33.0502 14.3 33.0502C14.0791 33.0502 13.9 32.8711 13.9 32.6502V29.2502C13.9 29.0293 14.0791 28.8502 14.3 28.8502Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.1 30.9502C22.1 30.7293 22.2791 30.5502 22.5 30.5502H24.3C24.5209 30.5502 24.7 30.7293 24.7 30.9502C24.7 31.1711 24.5209 31.3502 24.3 31.3502H22.5C22.2791 31.3502 22.1 31.1711 22.1 30.9502Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.9 29.1502C13.9 28.9293 14.0791 28.7502 14.3 28.7502H15.6C16.3097 28.7502 16.882 29.3114 16.8996 30.0166C16.9568 30.4095 16.8569 30.7768 16.6056 31.0474C16.3525 31.32 15.9871 31.4502 15.6 31.4502H14.3C14.0791 31.4502 13.9 31.2711 13.9 31.0502V29.1502ZM14.7 29.5502V30.6502H15.6C15.8129 30.6502 15.9476 30.5803 16.0194 30.503C16.0863 30.4309 16.138 30.3109 16.1055 30.1159C16.1018 30.0942 16.1 30.0722 16.1 30.0502C16.1 29.7711 15.8791 29.5502 15.6 29.5502H14.7Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6 29.2502C17.6 29.0293 17.7791 28.8502 18 28.8502H19C20.1209 28.8502 21.1 29.8293 21.1 30.9502C21.1 32.0556 20.2361 33.0502 19 33.0502H18C17.7791 33.0502 17.6 32.8711 17.6 32.6502V29.2502ZM18.4 29.6502V32.2502H19C19.7638 32.2502 20.3 31.6449 20.3 30.9502C20.3 30.2711 19.6791 29.6502 19 29.6502H18.4Z" class="fill-border"/></svg>',
  share: '<svg width="51" height="51" viewBox="0 0 51 51" xmlns="http://www.w3.org/2000/svg"><rect x="31.171" y="10.055" width="8.0442" height="8.0442" rx="4.0221" class="fill-background"/><rect x="10.055" y="21.116" width="8.0442" height="8.0442" rx="4.0221" class="fill-background"/><rect x="31.171" y="32.177" width="8.0442" height="8.0442" rx="4.0221" class="fill-background"/><path d="m35.194 9.5525c-2.4991 0-4.5249 2.0259-4.5249 4.5249 0 0.5791 0.1088 1.1328 0.3071 1.6418l-13.148 6.8869c-0.8133-1.2024-2.1897-1.9928-3.7506-1.9928-2.499 0-4.5249 2.0259-4.5249 4.5249s2.0259 4.5248 4.5249 4.5248c1.5609 0 2.9372-0.7903 3.7505-1.9926l13.148 6.8869c-0.1982 0.5089-0.307 1.0626-0.307 1.6417 0 2.499 2.0258 4.5248 4.5249 4.5248 2.499 0 4.5248-2.0258 4.5248-4.5248s-2.0258-4.5249-4.5248-4.5249c-1.561 0-2.9373 0.7904-3.7507 1.9928l-13.148-6.8869c0.1983-0.509 0.3071-1.0627 0.3071-1.6418s-0.1088-1.1328-0.3071-1.6417l13.148-6.8869c0.8134 1.2023 2.1897 1.9927 3.7506 1.9927 2.499 0 4.5248-2.0259 4.5248-4.5249s-2.0258-4.5249-4.5248-4.5249zm-3.5194 4.5249c0-1.9437 1.5757-3.5194 3.5194-3.5194 1.9436 0 3.5193 1.5757 3.5193 3.5194s-1.5757 3.5193-3.5193 3.5193c-1.9437 0-3.5194-1.5756-3.5194-3.5193zm-21.116 11.061c0-1.9437 1.5757-3.5194 3.5194-3.5194s3.5193 1.5757 3.5193 3.5194-1.5756 3.5193-3.5193 3.5193-3.5194-1.5756-3.5194-3.5193zm24.636 7.5414c-1.9437 0-3.5194 1.5757-3.5194 3.5194s1.5757 3.5193 3.5194 3.5193c1.9436 0 3.5193-1.5756 3.5193-3.5193s-1.5757-3.5194-3.5193-3.5194z" clip-rule="evenodd" class="fill-border" fill-rule="evenodd"/></svg>',
  charts: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.7001 27.0996H14.6001V39.4996H18.7001V27.0996Z" class="fill-background"/><path d="M26.9999 14.5996H22.8999V39.4996H26.9999V14.5996Z" class="fill-background"/><path d="M35.2999 22.9004H31.2V39.5004H35.2999V22.9004Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 10C11.1239 10 10 11.1239 10 12.5V37.5C10 38.8761 11.1239 40 12.5 40H31.18C31.1866 40.0003 31.1933 40.0004 31.2 40.0004H35.2999C35.3066 40.0004 35.3133 40.0003 35.3199 40H37.5C38.8761 40 40 38.8761 40 37.5V12.5C40 11.1239 38.8761 10 37.5 10H12.5ZM35.7999 39H37.5C38.3239 39 39 38.3239 39 37.5V12.5C39 11.6761 38.3239 11 37.5 11H12.5C11.6761 11 11 11.6761 11 12.5V37.5C11 38.3239 11.6761 39 12.5 39H14.1001V27.0996C14.1001 26.8235 14.324 26.5996 14.6001 26.5996H18.7001C18.9762 26.5996 19.2001 26.8235 19.2001 27.0996V39H22.3999V14.5996C22.3999 14.3235 22.6238 14.0996 22.8999 14.0996H26.9999C27.276 14.0996 27.4999 14.3235 27.4999 14.5996V39H30.7V22.9004C30.7 22.6242 30.9238 22.4004 31.2 22.4004H35.2999C35.5761 22.4004 35.7999 22.6242 35.7999 22.9004V39ZM34.7999 39H31.7V23.4004H34.7999V39ZM15.1001 38.9996V27.5996H18.2001V38.9996H15.1001ZM23.3999 15.0996V38.9996H26.4999V15.0996H23.3999Z" class="fill-border"/></svg>',
  charts_bar: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 33.9004H11V37.2004H17.5V33.9004Z" class="fill-background"/><path d="M27.1 27.6004H11V30.8004H27.1V27.6004Z" class="fill-background"/><path d="M33.5 21.0004H11V24.3004H33.5V21.0004Z" class="fill-background"/><path d="M23.8 14.6004H11V17.9004H23.8V14.6004Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 13.4004C10.5 12.0242 11.6239 10.9004 13 10.9004H38C39.3761 10.9004 40.5 12.0242 40.5 13.4004V38.4004C40.5 39.7765 39.3761 40.9004 38 40.9004H13C11.6239 40.9004 10.5 39.7765 10.5 38.4004V13.4004ZM13 11.9004C12.1761 11.9004 11.5 12.5765 11.5 13.4004V14.1006H23.8C24.0761 14.1006 24.3 14.3244 24.3 14.6006V17.9006C24.3 18.1767 24.0761 18.4006 23.8 18.4006H11.5V20.5H33.5C33.7761 20.5 34 20.7239 34 21V24.3C34 24.5761 33.7761 24.8 33.5 24.8H11.5V27.1006H27.1C27.3761 27.1006 27.6 27.3244 27.6 27.6006V30.8006C27.6 31.0767 27.3761 31.3006 27.1 31.3006H11.5V33.4004H17.5C17.7761 33.4004 18 33.6242 18 33.9004V37.2004C18 37.4765 17.7761 37.7004 17.5 37.7004H11.5V38.4004C11.5 39.2242 12.1761 39.9004 13 39.9004H38C38.8239 39.9004 39.5 39.2242 39.5 38.4004V13.4004C39.5 12.5765 38.8239 11.9004 38 11.9004H13ZM11.5 17.4006H23.3V15.1006H11.5V17.4006ZM11.5 23.8V21.5H33V23.8H11.5ZM11.5 30.3006H26.6V28.1006H11.5V30.3006ZM11.5 36.7004V34.4004H17V36.7004H11.5Z" class="fill-border"/></svg>',
  charts_column_line: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 37.2005H14.2V40.4005H17.5V37.2005Z" class="fill-background"/><path d="M23.8001 27.6005H20.6001V40.4005H23.8001V27.6005Z" class="fill-background"/><path d="M30.4001 30.7005H27.1001V40.4005H30.4001V30.7005Z" class="fill-background"/><path d="M36.8 24.4005H33.5V40.4005H36.8V24.4005Z" class="fill-background"/><path d="M15.9 30.7005C16.7837 30.7005 17.5 29.9841 17.5 29.1005C17.5 28.2168 16.7837 27.5005 15.9 27.5005C15.0164 27.5005 14.3 28.2168 14.3 29.1005C14.3 29.9841 15.0164 30.7005 15.9 30.7005Z" class="fill-background"/><path d="M22.3 21.0005C23.1836 21.0005 23.9 20.2841 23.9 19.4005C23.9 18.5168 23.1836 17.8005 22.3 17.8005C21.4163 17.8005 20.7 18.5168 20.7 19.4005C20.7 20.2841 21.4163 21.0005 22.3 21.0005Z" class="fill-background"/><path d="M28.7999 24.3005C29.6836 24.3005 30.4 23.5841 30.4 22.7005C30.4 21.8168 29.6836 21.1005 28.7999 21.1005C27.9163 21.1005 27.2 21.8168 27.2 22.7005C27.2 23.5841 27.9163 24.3005 28.7999 24.3005Z" class="fill-background"/><path d="M35.2001 17.8005C36.0838 17.8005 36.8001 17.0841 36.8001 16.2005C36.8001 15.3168 36.0838 14.6005 35.2001 14.6005C34.3164 14.6005 33.6001 15.3168 33.6001 16.2005C33.6001 17.0841 34.3164 17.8005 35.2001 17.8005Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.4095 27.6411C17.7751 28.019 18 28.5337 18 29.101C18 30.2608 17.0598 31.201 15.9 31.201C14.7402 31.201 13.8 30.2608 13.8 29.101C13.8 27.9412 14.7402 27.001 15.9 27.001C16.1317 27.001 16.3546 27.0385 16.5631 27.1078L20.7712 20.8404C20.417 20.4645 20.2 19.958 20.2 19.4008C20.2 18.241 21.1402 17.3008 22.3 17.3008C23.4598 17.3008 24.4 18.241 24.4 19.4008C24.4 19.575 24.3788 19.7443 24.3388 19.9061L27.2272 21.3091C27.6119 20.8745 28.174 20.6006 28.8 20.6006C29.1725 20.6006 29.5224 20.6976 29.8258 20.8677L33.404 17.2895C33.2111 16.972 33.1 16.5992 33.1 16.2006C33.1 15.0408 34.0402 14.1006 35.2 14.1006C36.3598 14.1006 37.3 15.0408 37.3 16.2006C37.3 17.3604 36.3598 18.3006 35.2 18.3006C34.8013 18.3006 34.4286 18.1895 34.1111 17.9966L30.5573 21.5504C30.774 21.8808 30.9 22.276 30.9 22.7006C30.9 23.8604 29.9598 24.8006 28.8 24.8006C27.6402 24.8006 26.7 23.8604 26.7 22.7006C26.7 22.5261 26.7213 22.3566 26.7614 22.1946L23.8733 20.7918C23.4886 21.2266 22.9263 21.5008 22.3 21.5008C22.0583 21.5008 21.8262 21.46 21.6101 21.3848L17.4095 27.6411ZM14.8 29.101C14.8 28.4935 15.2925 28.001 15.9 28.001C16.0323 28.001 16.1592 28.0243 16.2767 28.0672C16.3128 28.1247 16.3613 28.1757 16.4213 28.2159C16.4928 28.264 16.5723 28.2911 16.6525 28.2987C16.8664 28.4993 17 28.7846 17 29.101C17 29.7085 16.5075 30.201 15.9 30.201C15.2925 30.201 14.8 29.7085 14.8 29.101ZM22.3 18.3008C21.6925 18.3008 21.2 18.7933 21.2 19.4008C21.2 20.0083 21.6925 20.5008 22.3 20.5008C22.9075 20.5008 23.4 20.0083 23.4 19.4008C23.4 18.7933 22.9075 18.3008 22.3 18.3008ZM27.7 22.7006C27.7 22.0931 28.1925 21.6006 28.8 21.6006C29.4075 21.6006 29.9 22.0931 29.9 22.7006C29.9 23.3081 29.4075 23.8006 28.8 23.8006C28.1925 23.8006 27.7 23.3081 27.7 22.7006ZM35.2 15.1006C34.5925 15.1006 34.1 15.5931 34.1 16.2006C34.1 16.8081 34.5925 17.3006 35.2 17.3006C35.8075 17.3006 36.3 16.8081 36.3 16.2006C36.3 15.5931 35.8075 15.1006 35.2 15.1006Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 10.9004C11.6239 10.9004 10.5 12.0242 10.5 13.4004V38.4004C10.5 39.7765 11.6239 40.9004 13 40.9004H20.5859L20.6 40.9006H23.8L23.8141 40.9004H38C39.3761 40.9004 40.5 39.7765 40.5 38.4004V13.4004C40.5 12.0242 39.3761 10.9004 38 10.9004H13ZM36.3 39.9004H34V24.9004H36.3V39.9004ZM37.3 24.4004V39.9004H38C38.8239 39.9004 39.5 39.2242 39.5 38.4004V13.4004C39.5 12.5765 38.8239 11.9004 38 11.9004H13C12.1761 11.9004 11.5 12.5765 11.5 13.4004V38.4004C11.5 39.2242 12.1761 39.9004 13 39.9004H13.7V37.2002C13.7 36.9241 13.9239 36.7002 14.2 36.7002H17.5C17.7762 36.7002 18 36.9241 18 37.2002V39.9004H20.1V27.6006C20.1 27.3244 20.3239 27.1006 20.6 27.1006H23.8C24.0761 27.1006 24.3 27.3244 24.3 27.6006V39.9004H26.6V30.7002C26.6 30.4241 26.8239 30.2002 27.1 30.2002H30.4C30.6761 30.2002 30.9 30.4241 30.9 30.7002V39.9004H33V24.4004C33 24.1242 33.2239 23.9004 33.5 23.9004H36.8C37.0761 23.9004 37.3 24.1242 37.3 24.4004ZM21.1 39.9004H23.3V28.1006H21.1V39.9004ZM14.7 39.9002V37.7002H17V39.9002H14.7ZM27.6 39.9002V31.2002H29.9V39.9002H27.6Z" class="fill-border"/></svg>',
  charts_stacked_column: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 30.8004H14.2V40.4004H17.5V30.8004Z" class="fill-background"/><path d="M23.8001 24.3004H20.6001V40.4004H23.8001V24.3004Z" class="fill-background"/><path d="M30.4001 17.8004H27.1001V40.4004H30.4001V17.8004Z" class="fill-background"/><path d="M36.8 27.6004H33.5V40.4004H36.8V27.6004Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 10.9004C11.6239 10.9004 10.5 12.0242 10.5 13.4004V38.4004C10.5 39.7765 11.6239 40.9004 13 40.9004H14.1801C14.1867 40.9007 14.1933 40.9008 14.2 40.9008H17.5C17.5067 40.9008 17.5133 40.9007 17.52 40.9004H20.58C20.5867 40.9007 20.5933 40.9008 20.6 40.9008H23.8C23.8067 40.9008 23.8133 40.9007 23.82 40.9004H27.08C27.0867 40.9007 27.0933 40.9008 27.1 40.9008H30.4L30.412 40.9006L30.42 40.9004H33.4859L33.5 40.9006H36.8L36.8141 40.9004H38C39.3761 40.9004 40.5 39.7765 40.5 38.4004V13.4004C40.5 12.0242 39.3761 10.9004 38 10.9004H13ZM34 39.9004H36.3V31.2002H34V39.9004ZM33 39.9004H30.9V30.7026L30.9 30.7002L30.9 30.6978V17.8008C30.9 17.5246 30.6761 17.3008 30.4 17.3008H27.1C26.8239 17.3008 26.6 17.5246 26.6 17.8008V39.9004H24.3V24.3008C24.3 24.0246 24.0761 23.8008 23.8 23.8008H20.6C20.3239 23.8008 20.1 24.0246 20.1 24.3008V39.9004H18V30.8008C18 30.5246 17.7762 30.3008 17.5 30.3008H14.2C13.9239 30.3008 13.7 30.5246 13.7 30.8008V39.9004H13C12.1761 39.9004 11.5 39.2242 11.5 38.4004V13.4004C11.5 12.5765 12.1761 11.9004 13 11.9004H38C38.8239 11.9004 39.5 12.5765 39.5 13.4004V38.4004C39.5 39.2242 38.8239 39.9004 38 39.9004H37.3V27.6006C37.3 27.5836 37.2992 27.5668 37.2975 27.5503C37.2992 27.5338 37.3 27.517 37.3 27.5C37.3 27.2239 37.0761 27 36.8 27H33.5C33.2239 27 33 27.2239 33 27.5C33 27.517 33.0008 27.5338 33.0025 27.5503C33.0008 27.5668 33 27.5836 33 27.6006V39.9004ZM29.9 30.2002V24.8008H27.6V30.2002H29.9ZM27.6 31.2002V39.9004H29.9V31.2002H27.6ZM21.1 28.1006V39.9004H23.3V28.1006H21.1ZM23.3 27.1006H21.1V24.8008H23.3V27.1006ZM29.9 23.8008H27.6V21.5H29.9V23.8008ZM29.9 18.3008V20.5H27.6V18.3008H29.9ZM34 30.2002V28.1006H36.3V30.2002H34ZM17 39.9004H14.7V34.5H17V39.9004ZM14.7 33.5V31.3008H17V33.5H14.7Z" class="fill-border"/></svg>',
  charts_line: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9 34.8004C16.7837 34.8004 17.5 34.0841 17.5 33.2004C17.5 32.3167 16.7837 31.6004 15.9 31.6004C15.0164 31.6004 14.3 32.3167 14.3 33.2004C14.3 34.0841 15.0164 34.8004 15.9 34.8004Z" class="fill-background"/><path d="M22.3 25.1004C23.1836 25.1004 23.9 24.384 23.9 23.5004C23.9 22.6167 23.1836 21.9004 22.3 21.9004C21.4163 21.9004 20.7 22.6167 20.7 23.5004C20.7 24.384 21.4163 25.1004 22.3 25.1004Z" class="fill-background"/><path d="M28.7999 28.3004C29.6836 28.3004 30.4 27.5841 30.4 26.7004C30.4 25.8167 29.6836 25.1004 28.7999 25.1004C27.9163 25.1004 27.2 25.8167 27.2 26.7004C27.2 27.5841 27.9163 28.3004 28.7999 28.3004Z" class="fill-background"/><path d="M35.2001 21.9004C36.0838 21.9004 36.8001 21.184 36.8001 20.3004C36.8001 19.4167 36.0838 18.7004 35.2001 18.7004C34.3164 18.7004 33.6001 19.4167 33.6001 20.3004C33.6001 21.184 34.3164 21.9004 35.2001 21.9004Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.9 31.1006C14.7402 31.1006 13.8 32.0408 13.8 33.2006C13.8 34.3604 14.7402 35.3006 15.9 35.3006C17.0598 35.3006 18 34.3604 18 33.2006C18 32.6334 17.7751 32.1187 17.4097 31.7408L21.6103 25.4845C21.8263 25.5596 22.0584 25.6004 22.3 25.6004C22.9561 25.6004 23.542 25.2995 23.9271 24.8281L26.7429 26.2762C26.7148 26.4133 26.7 26.5552 26.7 26.7006C26.7 27.8604 27.6402 28.8006 28.8 28.8006C29.9598 28.8006 30.9 27.8604 30.9 26.7006C30.9 26.2995 30.7876 25.9247 30.5925 25.606L34.0513 22.0585C34.3814 22.2746 34.776 22.4002 35.2 22.4002C36.3598 22.4002 37.3 21.46 37.3 20.3002C37.3 19.1404 36.3598 18.2002 35.2 18.2002C34.0402 18.2002 33.1 19.1404 33.1 20.3002C33.1 20.6732 33.1973 21.0235 33.3678 21.3271L29.8831 24.9011C29.5669 24.7103 29.1963 24.6006 28.8 24.6006C28.1439 24.6006 27.558 24.9015 27.1729 25.3729L24.3571 23.9248C24.3852 23.7877 24.4 23.6458 24.4 23.5004C24.4 22.3406 23.4598 21.4004 22.3 21.4004C21.1402 21.4004 20.2 22.3406 20.2 23.5004C20.2 24.0577 20.4171 24.5643 20.7713 24.9402L16.5633 31.2075C16.3548 31.1381 16.1318 31.1006 15.9 31.1006ZM14.8 33.2006C14.8 32.5931 15.2925 32.1006 15.9 32.1006C16.5075 32.1006 17 32.5931 17 33.2006C17 33.8081 16.5075 34.3006 15.9 34.3006C15.2925 34.3006 14.8 33.8081 14.8 33.2006ZM22.3 22.4004C21.6925 22.4004 21.2 22.8929 21.2 23.5004C21.2 24.1079 21.6925 24.6004 22.3 24.6004C22.9075 24.6004 23.4 24.1079 23.4 23.5004C23.4 22.8929 22.9075 22.4004 22.3 22.4004ZM27.7 26.7006C27.7 26.0931 28.1925 25.6006 28.8 25.6006C29.4075 25.6006 29.9 26.0931 29.9 26.7006C29.9 27.3081 29.4075 27.8006 28.8 27.8006C28.1925 27.8006 27.7 27.3081 27.7 26.7006ZM35.2 19.2002C34.5925 19.2002 34.1 19.6927 34.1 20.3002C34.1 20.9077 34.5925 21.4002 35.2 21.4002C35.8075 21.4002 36.3 20.9077 36.3 20.3002C36.3 19.6927 35.8075 19.2002 35.2 19.2002Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13 10.9004C11.6239 10.9004 10.5 12.0242 10.5 13.4004V38.4004C10.5 39.7765 11.6239 40.9004 13 40.9004H38C39.3761 40.9004 40.5 39.7765 40.5 38.4004V13.4004C40.5 12.0242 39.3761 10.9004 38 10.9004H13ZM11.5 13.4004C11.5 12.5765 12.1761 11.9004 13 11.9004H38C38.8239 11.9004 39.5 12.5765 39.5 13.4004V38.4004C39.5 39.2242 38.8239 39.9004 38 39.9004H13C12.1761 39.9004 11.5 39.2242 11.5 38.4004V13.4004Z" class="fill-border"/></svg>',
  charts_pie: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.5 16.7004V25.9004L18 31.3004C19.7 33.6004 22.4 35.1004 25.5 35.1004C30.6 35.1004 34.7 31.0004 34.7 25.9004C34.7 20.9004 30.6 16.7004 25.5 16.7004Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.8 25.9002C15.8 20.543 20.1428 16.2002 25.5 16.2002C30.8572 16.2002 35.2 20.543 35.2 25.9002C35.2 31.2574 30.8572 35.6002 25.5 35.6002C20.1428 35.6002 15.8 31.2574 15.8 25.9002ZM25 17.2143C22.9265 17.3318 21.0472 18.1754 19.6124 19.4949L25 24.7192V17.2143ZM26 17.2143V25.9002C26 26.0733 25.9121 26.2258 25.7784 26.3156L18.7431 31.381C20.3382 33.3451 22.7725 34.6002 25.5 34.6002C30.3049 34.6002 34.2 30.7051 34.2 25.9002C34.2 21.2631 30.5722 17.4734 26 17.2143ZM16.8 25.9002C16.8 23.7259 17.5976 21.7379 18.9162 20.2128L24.7228 25.8434L18.1581 30.5699C17.2982 29.2208 16.8 27.6187 16.8 25.9002Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 13.4004C10.5 12.0242 11.6239 10.9004 13 10.9004H38C39.3761 10.9004 40.5 12.0242 40.5 13.4004V38.4004C40.5 39.7765 39.3761 40.9004 38 40.9004H13C11.6239 40.9004 10.5 39.7765 10.5 38.4004V13.4004ZM13 11.9004C12.1761 11.9004 11.5 12.5765 11.5 13.4004V38.4004C11.5 39.2242 12.1761 39.9004 13 39.9004H38C38.8239 39.9004 39.5 39.2242 39.5 38.4004V13.4004C39.5 12.5765 38.8239 11.9004 38 11.9004H13Z" class="fill-border"/></svg>',
  charts_scatter: '<svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9 34.0004C16.7837 34.0004 17.5 33.2841 17.5 32.4004C17.5 31.5168 16.7837 30.8004 15.9 30.8004C15.0164 30.8004 14.3 31.5168 14.3 32.4004C14.3 33.2841 15.0164 34.0004 15.9 34.0004Z" class="fill-background"/><path d="M22.3 24.3004C23.1836 24.3004 23.9 23.5841 23.9 22.7004C23.9 21.8167 23.1836 21.1004 22.3 21.1004C21.4163 21.1004 20.7 21.8167 20.7 22.7004C20.7 23.5841 21.4163 24.3004 22.3 24.3004Z" class="fill-background"/><path d="M28.7999 27.5004C29.6836 27.5004 30.4 26.7841 30.4 25.9004C30.4 25.0168 29.6836 24.3004 28.7999 24.3004C27.9163 24.3004 27.2 25.0168 27.2 25.9004C27.2 26.7841 27.9163 27.5004 28.7999 27.5004Z" class="fill-background"/><path d="M35.2001 21.1004C36.0838 21.1004 36.8001 20.384 36.8001 19.5004C36.8001 18.6167 36.0838 17.9004 35.2001 17.9004C34.3164 17.9004 33.6001 18.6167 33.6001 19.5004C33.6001 20.384 34.3164 21.1004 35.2001 21.1004Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.8 32.4008C13.8 31.241 14.7402 30.3008 15.9 30.3008C17.0598 30.3008 18 31.241 18 32.4008C18 33.5606 17.0598 34.5008 15.9 34.5008C14.7402 34.5008 13.8 33.5606 13.8 32.4008ZM15.9 31.3008C15.2925 31.3008 14.8 31.7933 14.8 32.4008C14.8 33.0083 15.2925 33.5008 15.9 33.5008C16.5075 33.5008 17 33.0083 17 32.4008C17 31.7933 16.5075 31.3008 15.9 31.3008Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.3 20.6006C21.1402 20.6006 20.2 21.5408 20.2 22.7006C20.2 23.8604 21.1402 24.8006 22.3 24.8006C23.4598 24.8006 24.4 23.8604 24.4 22.7006C24.4 21.5408 23.4598 20.6006 22.3 20.6006ZM21.2 22.7006C21.2 22.0931 21.6925 21.6006 22.3 21.6006C22.9075 21.6006 23.4 22.0931 23.4 22.7006C23.4 23.3081 22.9075 23.8006 22.3 23.8006C21.6925 23.8006 21.2 23.3081 21.2 22.7006Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M26.7 25.9008C26.7 24.741 27.6402 23.8008 28.8 23.8008C29.9598 23.8008 30.9 24.741 30.9 25.9008C30.9 27.0606 29.9598 28.0008 28.8 28.0008C27.6402 28.0008 26.7 27.0606 26.7 25.9008ZM28.8 24.8008C28.1925 24.8008 27.7 25.2933 27.7 25.9008C27.7 26.5083 28.1925 27.0008 28.8 27.0008C29.4075 27.0008 29.9 26.5083 29.9 25.9008C29.9 25.2933 29.4075 24.8008 28.8 24.8008Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M35.2 17.4004C34.0402 17.4004 33.1 18.3406 33.1 19.5004C33.1 20.6602 34.0402 21.6004 35.2 21.6004C36.3598 21.6004 37.3 20.6602 37.3 19.5004C37.3 18.3406 36.3598 17.4004 35.2 17.4004ZM34.1 19.5004C34.1 18.8929 34.5925 18.4004 35.2 18.4004C35.8075 18.4004 36.3 18.8929 36.3 19.5004C36.3 20.1079 35.8075 20.6004 35.2 20.6004C34.5925 20.6004 34.1 20.1079 34.1 19.5004Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 13.4004C10.5 12.0242 11.6239 10.9004 13 10.9004H38C39.3761 10.9004 40.5 12.0242 40.5 13.4004V38.4004C40.5 39.7765 39.3761 40.9004 38 40.9004H13C11.6239 40.9004 10.5 39.7765 10.5 38.4004V13.4004ZM13 11.9004C12.1761 11.9004 11.5 12.5765 11.5 13.4004V38.4004C11.5 39.2242 12.1761 39.9004 13 39.9004H38C38.8239 39.9004 39.5 39.2242 39.5 38.4004V13.4004C39.5 12.5765 38.8239 11.9004 38 11.9004H13Z" class="fill-border"/></svg>',
  format: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9126 23.5371H26.5126V28.04L22.0125 23.6377L20.8125 29.3377L26.5126 28.1584V31.5371H10.9126V23.5371Z" class="fill-background"/><path d="M22.0125 23.6375L24.4037 26.0787L26.5125 28.1375L38.5125 16.1375C39.8125 14.8375 39.8125 12.8375 38.5125 11.5375C37.2125 10.2375 35.2125 10.2375 33.9125 11.5375L22.0125 23.6375Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M33.559 11.1839C35.0542 9.68868 37.3708 9.68868 38.8661 11.1839C40.3613 12.6792 40.3613 14.9958 38.8661 16.4911L34.9125 20.4447V37.317C35.0262 38.8372 33.7568 39.9367 32.4125 39.9367H12.6125C11.1363 39.9367 10.0125 38.8129 10.0125 37.3367V17.7367C10.0125 16.2606 11.1363 15.1367 12.6125 15.1367H29.6715L33.556 11.1869L33.559 11.1839ZM28.688 16.1367H12.6125C11.6886 16.1367 11.0125 16.8129 11.0125 17.7367V23.0367H21.9021L28.688 16.1367ZM21.4175 24.0367H19.0125V31.2373H26.0125V28.7537L20.9155 29.8268C20.7502 29.8616 20.5784 29.8105 20.459 29.6911C20.3395 29.5716 20.2884 29.3998 20.3232 29.2345L21.4175 24.0367ZM27.0125 28.3447V31.2373H33.9125V24.0367H31.3204L27.0125 28.3447ZM32.3204 23.0367H33.9125V21.4447L32.3204 23.0367ZM34.2675 11.8897L22.7204 23.6307L26.558 27.3849L38.159 15.7839C39.2637 14.6792 39.2637 12.9958 38.159 11.8911C37.0547 10.7868 35.3722 10.7863 34.2675 11.8897ZM21.4597 28.6903L22.3141 24.6321L25.5765 27.8236L21.4597 28.6903ZM26.0125 32.2373V38.9367H19.0125V32.2373H26.0125ZM27.0125 38.9367V32.2373H33.9125V37.3367C33.9125 37.3506 33.913 37.3644 33.9142 37.3782C33.9866 38.2467 33.2616 38.9367 32.4125 38.9367H27.0125ZM18.0125 31.2373V24.0367H11.0125V31.2373H18.0125ZM11.0125 32.2373H18.0125V38.9367H12.6125C11.6886 38.9367 11.0125 38.2606 11.0125 37.3367V32.2373Z" class="fill-border"/></svg>',
  format_number: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.6001 11.4005H37.5001C38.6001 11.4005 39.5001 12.3005 39.5001 13.4005V38.3005C39.5001 39.4005 38.6001 40.3005 37.5001 40.3005H29.6001V11.4005Z" class="fill-background"/><path d="M16.9 22.6008C16.9 21.994 17.2189 21.4325 17.8066 21.0051C18.3972 20.5756 19.2407 20.3008 20.2 20.3008C21.1501 20.3008 21.9936 20.5955 22.5887 21.0392C23.1866 21.4849 23.5 22.0498 23.5 22.6008C23.5 22.8769 23.7239 23.1008 24 23.1008C24.2761 23.1008 24.5 22.8769 24.5 22.6008C24.5 21.6518 23.9634 20.8167 23.1863 20.2374C22.521 19.7414 21.6542 19.41 20.7 19.3234V17.1006C20.7 16.8244 20.4761 16.6006 20.2 16.6006C19.9239 16.6006 19.7 16.8244 19.7 17.1006V19.3219C18.7527 19.4023 17.8867 19.7104 17.2184 20.1964C16.431 20.769 15.9 21.6075 15.9 22.6008C15.9 23.6826 16.2794 24.5368 17.0539 25.1442C17.7968 25.7269 18.8528 26.042 20.1334 26.1964C21.4344 26.3899 22.2766 26.7428 22.7871 27.1804C23.2773 27.6006 23.5 28.1309 23.5 28.8008C23.5 29.3518 23.1866 29.9167 22.5887 30.3624C21.9936 30.806 21.1501 31.1008 20.2 31.1008C19.2407 31.1008 18.3972 30.826 17.8066 30.3964C17.2189 29.969 16.9 29.4075 16.9 28.8008C16.9 28.5246 16.6761 28.3008 16.4 28.3008C16.1239 28.3008 15.9 28.5246 15.9 28.8008C15.9 29.794 16.431 30.6325 17.2184 31.2052C17.8867 31.6912 18.7527 31.9992 19.7 32.0797V34.4002C19.7 34.6763 19.9239 34.9002 20.2 34.9002C20.4761 34.9002 20.7 34.6763 20.7 34.4002V32.0782C21.6542 31.9916 22.521 31.6602 23.1863 31.1642C23.9634 30.5849 24.5 29.7498 24.5 28.8008C24.5 27.8707 24.1727 27.051 23.4379 26.4212C22.7243 25.8095 21.6685 25.4129 20.2733 25.2062L20.2596 25.2043C19.0433 25.0584 18.2018 24.7736 17.6711 24.3574C17.1706 23.9648 16.9 23.419 16.9 22.6008Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6 10.9004C11.1239 10.9004 10 12.0242 10 13.5004V38.3004C10 39.7765 11.1239 40.9004 12.6 40.9004H37.4C38.8761 40.9004 40 39.7765 40 38.3004V13.5004C40 12.0242 38.8761 10.9004 37.4 10.9004H12.6ZM11 13.5004C11 12.5765 11.6761 11.9004 12.6 11.9004H29.3V39.9004H12.6C11.6761 39.9004 11 39.2242 11 38.3004V13.5004ZM30.3 18.2002V11.9004H37.4C38.3239 11.9004 39 12.5765 39 13.5004V18.2002H30.3ZM30.3 25.4004V19.2002H39V25.4004H30.3ZM30.3 32.6006V26.4004H39V32.6006H30.3ZM30.3 39.9004V33.6006H39V38.3004C39 39.2242 38.3239 39.9004 37.4 39.9004H30.3Z" class="fill-border"/></svg>',
  format_conditional: '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.2 40.4004H12.6C11.4 40.4004 10.5 39.5004 10.5 38.3004V13.5004C10.5 12.3004 11.4 11.4004 12.6 11.4004H37.4C38.6 11.4004 39.5 12.3004 39.5 13.5004L39.5 18.6006H20.2V40.4004Z" class="fill-background"/><path d="M28.8721 23.9195C29.1038 23.7693 29.1698 23.4596 29.0195 23.228C28.8692 22.9963 28.5596 22.9303 28.3279 23.0806L24.6279 25.4806C24.4858 25.5728 24.4 25.7307 24.4 25.9001C24.4 26.0695 24.4858 26.2274 24.6279 26.3195L28.3279 28.7195C28.5596 28.8698 28.8692 28.8038 29.0195 28.5722C29.1698 28.3405 29.1038 28.0309 28.8721 27.8806L25.8188 25.9001L28.8721 23.9195Z" class="fill-border"/><path d="M30.5773 30.4333C30.7247 30.1998 31.0335 30.1301 31.267 30.2775L35.067 32.6775C35.2107 32.7682 35.2984 32.9257 35.3 33.0956C35.3016 33.2655 35.2168 33.4246 35.0748 33.518L31.2748 36.018C31.0441 36.1697 30.7341 36.1058 30.5823 35.8751C30.4305 35.6444 30.4945 35.3343 30.7252 35.1826L33.8772 33.1088L30.733 31.123C30.4995 30.9755 30.4298 30.6667 30.5773 30.4333Z" class="fill-border"/><path d="M24.9 31.7002C24.6239 31.7002 24.4 31.9241 24.4 32.2002C24.4 32.4763 24.6239 32.7002 24.9 32.7002H28.6C28.8761 32.7002 29.1 32.4763 29.1 32.2002C29.1 31.9241 28.8761 31.7002 28.6 31.7002H24.9Z" class="fill-border"/><path d="M24.4 34.1006C24.4 33.8244 24.6239 33.6006 24.9 33.6006H28.6C28.8761 33.6006 29.1 33.8244 29.1 34.1006C29.1 34.3767 28.8761 34.6006 28.6 34.6006H24.9C24.6239 34.6006 24.4 34.3767 24.4 34.1006Z" class="fill-border"/><path d="M31 24.5C30.7239 24.5 30.5 24.7239 30.5 25C30.5 25.2761 30.7239 25.5 31 25.5H32.4629L32.1277 26.3008H31C30.7239 26.3008 30.5 26.5246 30.5 26.8008C30.5 27.0769 30.7239 27.3008 31 27.3008H31.7091L31.5388 27.7076C31.4321 27.9624 31.5522 28.2553 31.8069 28.3619C32.0617 28.4686 32.3546 28.3485 32.4612 28.0938L32.7932 27.3008H34.8C35.0761 27.3008 35.3 27.0769 35.3 26.8008C35.3 26.5246 35.0761 26.3008 34.8 26.3008H33.2118L33.547 25.5H34.8C35.0761 25.5 35.3 25.2761 35.3 25C35.3 24.7239 35.0761 24.5 34.8 24.5H33.9656L34.2612 23.7938C34.3678 23.5391 34.2478 23.2461 33.9931 23.1395C33.7383 23.0329 33.4454 23.1529 33.3388 23.4076L32.8815 24.5H31Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10 13.5004C10 12.0242 11.1239 10.9004 12.6 10.9004H37.4C38.8761 10.9004 40 12.0242 40 13.5004V38.3004C40 39.7765 38.8761 40.9004 37.4 40.9004H12.6C11.1239 40.9004 10 39.7765 10 38.3004V13.5004ZM12.6 11.9004C11.6761 11.9004 11 12.5765 11 13.5004V18.1006H19.7V11.9004H12.6ZM20.7 11.9004V18.1006H29.3V11.9004H20.7ZM39 18.1006H30.3V11.9004H37.4C38.3239 11.9004 39 12.5765 39 13.5004V18.1006ZM19.7 19.1006H11V25.4004H19.7V19.1006ZM19.7 26.4004H11V32.6006H19.7V26.4004ZM19.7 33.6006H11V38.3004C11 39.2242 11.6761 39.9004 12.6 39.9004H19.7V33.6006ZM20.7 39.9004V19.1006H39V38.3004C39 39.2242 38.3239 39.9004 37.4 39.9004H20.7Z" class="fill-border"/></svg>',
  options: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39 28.75C37.2 28.55 35.6 26.95 35.6 24.85C35.6 23.05 37.2 21.45 39 21.25C38.3 18.95 37.2 16.75 35.4 14.85C34.3 16.25 32 16.65 30.4 15.75C28.6 14.85 28.1 12.75 28.8 10.95C26.3 10.25 23.8 10.25 21.3 10.95C22 12.75 21.3 14.85 19.7 15.75C17.9 16.65 15.8 16.25 14.7 14.85C13.8 15.75 13.1 16.65 12.4 17.85C11.7 19.05 11.3 20.15 11 21.25C12.8 21.45 14.4 23.05 14.4 25.15C14.4 26.95 12.8 28.55 11 28.75C11.7 31.05 12.8 33.25 14.6 35.15C15.7 33.75 18 33.35 19.6 34.25C21.4 35.15 21.9 37.25 21.2 39.05C23.7 39.75 26.2 39.75 28.7 39.05C28 37.25 28.7 35.15 30.3 34.25C32.1 33.35 34.2 33.75 35.3 35.15C36.2 34.25 36.9 33.35 37.6 32.15C38.3 31.05 38.7 29.95 39 28.75ZM22.2 28.95C19.9 27.55 19 24.65 20.4 22.35C21.8 20.05 24.7 19.35 27.2 20.55C29.5 21.95 30.4 24.85 29 27.15C27.6 29.65 24.4 30.35 22.2 28.95Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.1652 10.4685C23.7534 9.74382 26.3466 9.74382 28.9348 10.4685C29.0707 10.5066 29.1842 10.6002 29.2473 10.7265C29.3103 10.8527 29.3171 10.9997 29.266 11.1312C28.6349 12.7541 29.1108 14.5464 30.6236 15.3028C30.6309 15.3064 30.6381 15.3102 30.6451 15.3142C31.3307 15.6998 32.1854 15.8153 32.9998 15.6702C33.8149 15.5251 34.5463 15.1273 35.0068 14.5411C35.0966 14.4268 35.2317 14.3572 35.3769 14.3505C35.5221 14.3438 35.663 14.4006 35.763 14.5061C37.6282 16.4749 38.7614 18.7488 39.4783 21.1044C39.5216 21.2467 39.4994 21.4008 39.4176 21.525C39.3358 21.6492 39.203 21.7305 39.0552 21.7469C37.476 21.9224 36.1 23.3361 36.1 24.85C36.1 26.6883 37.5015 28.0804 39.0552 28.253C39.1986 28.269 39.3281 28.3461 39.4105 28.4645C39.4929 28.583 39.5201 28.7313 39.4851 28.8713C39.1772 30.1026 38.7611 31.2543 38.027 32.4102C37.3073 33.6426 36.5823 34.5748 35.6536 35.5035C35.5524 35.6046 35.4129 35.6576 35.2702 35.6491C35.1274 35.6406 34.9952 35.5713 34.9068 35.4589C33.9761 34.2743 32.1507 33.8896 30.5346 34.6917C29.1756 35.4637 28.5507 37.2865 29.166 38.8688C29.2171 39.0003 29.2103 39.1473 29.1473 39.2735C29.0842 39.3997 28.9707 39.4934 28.8348 39.5315C26.2466 40.2562 23.6534 40.2562 21.0652 39.5315C20.9293 39.4934 20.8158 39.3997 20.7527 39.2735C20.6897 39.1473 20.6829 39.0003 20.734 38.8688C21.3651 37.2459 20.8892 35.4536 19.3764 34.6972C19.3734 34.6957 19.3703 34.6941 19.3673 34.6926C19.3631 34.6904 19.359 34.6881 19.3549 34.6858C18.6693 34.3001 17.8146 34.1847 17.0002 34.3297C16.1851 34.4749 15.4537 34.8727 14.9932 35.4589C14.9034 35.5732 14.7683 35.6427 14.6231 35.6495C14.4779 35.6562 14.337 35.5994 14.237 35.4939C12.3718 33.5251 11.2386 31.2512 10.5217 28.8956C10.4784 28.7533 10.5006 28.5992 10.5824 28.475C10.6642 28.3508 10.797 28.2695 10.9448 28.253C12.524 28.0776 13.9 26.6639 13.9 25.15C13.9 23.3117 12.4985 21.9196 10.9448 21.7469C10.7995 21.7308 10.6686 21.6519 10.5865 21.531C10.5043 21.4102 10.4792 21.2594 10.5176 21.1184C10.826 19.9878 11.2408 18.8449 11.9681 17.5981C12.6894 16.3616 13.4156 15.4273 14.3464 14.4964C14.4476 14.3953 14.5871 14.3423 14.7298 14.3509C14.8726 14.3594 15.0048 14.4286 15.0932 14.5411C16.0239 15.7256 17.8493 16.1104 19.4654 15.3083C20.8244 14.5363 21.4493 12.7135 20.834 11.1312C20.7829 10.9997 20.7897 10.8527 20.8527 10.7265C20.9158 10.6002 21.0293 10.5066 21.1652 10.4685ZM21.9353 11.301C22.4071 13.1847 21.6194 15.244 19.9451 16.1858C19.9381 16.1898 19.9309 16.1936 19.9236 16.1972C18.1275 17.0952 16.0133 16.8371 14.6898 15.5796C13.9903 16.3281 13.4129 17.1059 12.8319 18.1019C12.2686 19.0676 11.9069 19.9659 11.6329 20.8604C13.4284 21.3305 14.9 23.0137 14.9 25.15C14.9 27.0295 13.4193 28.6657 11.6481 29.1355C12.2818 31.0261 13.2088 32.8211 14.6038 34.4121C15.2148 33.8485 16.0063 33.491 16.8248 33.3452C17.8315 33.166 18.9222 33.2988 19.8344 33.8082C21.7292 34.7624 22.3295 36.8439 21.8389 38.6998C23.9153 39.2003 25.9883 39.2 28.0646 38.699C27.5929 36.8152 28.3806 34.7559 30.0549 33.8142C30.0597 33.8115 30.0646 33.8089 30.0695 33.8063C30.0718 33.8051 30.0741 33.8039 30.0764 33.8028C31.8725 32.9047 33.9867 33.1628 35.3102 34.4204C36.0097 33.6719 36.5871 32.8941 37.1681 31.8981C37.1706 31.8938 37.1731 31.8897 37.1757 31.8855C37.1765 31.8842 37.1773 31.8829 37.1782 31.8815C37.7421 30.9954 38.1032 30.1061 38.3779 29.1424C36.5775 28.6762 35.1 26.9906 35.1 24.85C35.1 22.9704 36.5807 21.3342 38.3519 20.8644C37.7183 18.9739 36.7912 17.1789 35.3962 15.5879C34.7852 16.1514 33.9937 16.509 33.1752 16.6547C32.1685 16.834 31.0778 16.7012 30.1655 16.1917C28.2708 15.2376 27.6705 13.156 28.1611 11.3001C26.0848 10.7997 24.0117 10.7999 21.9353 11.301ZM26.9612 20.99C24.6685 19.902 22.0729 20.5632 20.8271 22.61C19.5891 24.6438 20.3644 27.2473 22.46 28.5229L22.4685 28.5281L22.4684 28.5282C24.4276 29.7749 27.3049 29.1536 28.5637 26.9057C28.5667 26.9004 28.5698 26.8952 28.5729 26.89C29.8067 24.863 29.0408 22.2702 26.9612 20.99ZM19.9729 22.09C21.523 19.5434 24.7145 18.8023 27.4164 20.0992C27.4313 20.1064 27.4458 20.1143 27.46 20.1229C29.9619 21.6458 30.987 24.8374 29.4318 27.4022C27.8892 30.1463 24.3741 30.9227 21.9358 29.3745C19.4344 27.849 18.4118 24.6547 19.9729 22.09Z" class="fill-border"/></svg>',
  fields: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M34.2 18.4002H10.5V12.6002C10.5 11.4002 11.4 10.5002 12.6 10.5002H32.1C33.3 10.5002 34.2 11.4002 34.2 12.6002V18.4002V18.4002Z" class="fill-background"/><path d="M39.5 33.1998C38.4 33.0998 37.5 32.0998 37.5 30.9998C37.5 29.8998 38.4 28.9998 39.5 28.8998C39.1 27.5998 38.4 26.2998 37.4 25.1998C36.7 25.9998 35.4 26.2998 34.5 25.6998C33.4 25.1998 33.2 23.9998 33.6 22.8998C32.1 22.4998 30.7 22.4998 29.2 22.8998C29.6 23.9998 29.2 25.0998 28.3 25.6998C27.2 26.1998 26 25.9998 25.4 25.1998C24.9 25.6998 24.5 26.2998 24.1 26.8998C23.7 27.5998 23.4 28.1998 23.3 28.8998C24.4 28.9998 25.3 29.9998 25.3 31.0998C25.3 32.1998 24.4 33.0998 23.3 33.1998C23.7 34.4998 24.4 35.7998 25.4 36.8998C26.1 36.0998 27.4 35.7998 28.3 36.3998C29.4 36.8998 29.6 38.0998 29.2 39.1998C30.7 39.5998 32.1 39.5998 33.6 39.1998C33.2 38.0998 33.6 36.9998 34.5 36.3998C35.6 35.8998 36.8 36.0998 37.4 36.8998C37.9 36.3998 38.3 35.7998 38.7 35.1998C39.1 34.5998 39.2 33.8998 39.5 33.1998ZM29.7 33.3998C28.4 32.5998 27.8 30.8998 28.6 29.5998C29.4 28.2998 31.1 27.8998 32.6 28.4998C33.9 29.2998 34.5 30.9998 33.7 32.2998C32.9 33.7998 31 34.1998 29.7 33.3998Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10 12.6V32C10 33.4761 11.1239 34.6 12.6 34.6H23.299C23.7242 35.5321 24.3009 36.4338 25.0301 37.2359C25.126 37.3414 25.2623 37.4009 25.4048 37.3996C25.5473 37.3982 25.6825 37.3361 25.7763 37.2289C26.345 36.579 27.3716 36.3816 28.0227 36.8156C28.0451 36.8306 28.0687 36.8437 28.0931 36.8548C28.5015 37.0404 28.7303 37.3431 28.8304 37.7072C28.9346 38.0858 28.9032 38.553 28.7302 39.0287C28.6822 39.1606 28.6919 39.3064 28.7567 39.4308C28.8216 39.5552 28.9357 39.6466 29.0712 39.6827C30.6556 40.1052 32.1445 40.1052 33.7289 39.6827C33.8644 39.6466 33.9785 39.5552 34.0434 39.4308C34.1082 39.3064 34.1179 39.1606 34.0699 39.0287C33.7551 38.1628 34.0562 37.3168 34.7444 36.8381C35.6838 36.4275 36.5859 36.6474 37.0001 37.1996C37.087 37.3156 37.22 37.3881 37.3646 37.3984C37.5092 37.4086 37.6511 37.3557 37.7536 37.2532C38.2888 36.718 38.7119 36.0833 39.1032 35.4963L39.1161 35.477C39.3542 35.1198 39.4959 34.7431 39.6119 34.3952C39.6436 34.3 39.673 34.2085 39.7017 34.1194C39.7824 33.8681 39.8569 33.6362 39.9596 33.3966C40.0227 33.2495 40.0115 33.081 39.9295 32.9436C39.8476 32.8061 39.7047 32.7162 39.5453 32.7017C38.7063 32.6254 38.0001 31.8445 38.0001 30.9996C38.0001 30.1834 38.6769 29.4765 39.5453 29.3976C39.6954 29.3839 39.8313 29.3033 39.9153 29.1781C39.9992 29.053 40.0223 28.8966 39.9779 28.7526C39.5579 27.3874 38.8229 26.0215 37.77 24.8633C37.6741 24.7578 37.5378 24.6983 37.3953 24.6996C37.2528 24.701 37.1176 24.7631 37.0238 24.8704C36.4551 25.5202 35.4285 25.7176 34.7774 25.2836C34.755 25.2687 34.7315 25.2556 34.707 25.2444C34.7046 25.2434 34.7023 25.2423 34.7 25.2412V12.6C34.7 11.1239 33.5761 10 32.1 10H12.6C11.1239 10 10 11.1239 10 12.6ZM33.7 22.4088V18.9H26.8V25.4528C27.1789 25.508 27.6132 25.4545 28.0557 25.2611C28.7439 24.7824 29.045 23.9364 28.7302 23.0705C28.6822 22.9387 28.6919 22.7928 28.7567 22.6684C28.8216 22.544 28.9357 22.4526 29.0712 22.4165C30.646 21.9966 32.1264 21.994 33.7 22.4088ZM25.8 24.8996V18.9H18.9V25.9004H24.176C24.4367 25.5342 24.7209 25.1717 25.0465 24.8461C25.149 24.7436 25.2909 24.6906 25.4355 24.7009C25.5801 24.7111 25.713 24.7836 25.8 24.8996ZM23.5258 26.9004H18.9V33.6H22.9037C22.8753 33.5156 22.8482 33.4311 22.8222 33.3467C22.7778 33.2026 22.8009 33.0463 22.8848 32.9211C22.9688 32.7959 23.1047 32.7153 23.2548 32.7017C24.1232 32.6227 24.8001 31.9158 24.8001 31.0996C24.8001 30.2548 24.0938 29.4738 23.2548 29.3976C23.1183 29.3851 22.9929 29.3173 22.9079 29.2098C22.8229 29.1023 22.7857 28.9646 22.8051 28.8289C22.906 28.1227 23.1846 27.5178 23.5258 26.9004ZM12.6 11C11.6761 11 11 11.6761 11 12.6V17.9H33.7V12.6C33.7 11.6761 33.0239 11 32.1 11H12.6ZM17.9 25.9004V18.9H11V25.9004H17.9ZM11 26.9004H17.9V33.6H12.6C11.6761 33.6 11 32.9239 11 32V26.9004ZM28.5774 26.1156C29.5177 25.4888 30.0071 24.4028 29.8133 23.2675C30.8842 23.0442 31.9076 23.0436 32.9782 23.2657C32.8835 23.7315 32.8825 24.2103 33.0054 24.6572C33.1772 25.2818 33.5867 25.821 34.2568 26.1379C35.2293 26.7624 36.4935 26.5657 37.357 25.9167C38.0085 26.7202 38.5052 27.6166 38.8457 28.5282C37.7977 28.8736 37.0001 29.8334 37.0001 30.9996C37.0001 32.1403 37.775 33.1845 38.8319 33.5603C38.799 33.6588 38.7681 33.755 38.7386 33.847C38.7126 33.9279 38.6877 34.0056 38.6632 34.079C38.5542 34.4062 38.4459 34.6794 38.284 34.9223C37.9831 35.3737 37.6996 35.7973 37.3855 36.1735C36.562 35.5206 35.3451 35.4663 34.2931 35.9444C34.2687 35.9556 34.2451 35.9687 34.2227 35.9836C33.2824 36.6104 32.793 37.6964 32.9868 38.8317C31.9159 39.055 30.8925 39.0556 29.8219 38.8335C29.9166 38.3677 29.9176 37.889 29.7947 37.442C29.6229 36.8174 29.2134 36.2782 28.5433 35.9613C27.5708 35.3368 26.3066 35.5335 25.4431 36.1825C24.7916 35.379 24.2949 34.4826 23.9544 33.571C25.0024 33.2256 25.8001 32.2659 25.8001 31.0996C25.8001 29.933 24.9894 28.8672 23.8956 28.5143C24.022 28.0896 24.2363 27.6699 24.5257 27.1626C24.8231 26.7165 25.1039 26.2979 25.4146 25.9258C26.2381 26.5786 27.4551 26.6329 28.507 26.1548C28.5315 26.1437 28.555 26.1306 28.5774 26.1156ZM29.0259 29.8617C29.6646 28.8238 31.0596 28.4412 32.374 28.948C33.4669 29.6448 33.8912 31.0349 33.2742 32.0376C33.2688 32.0463 33.2637 32.0552 33.2589 32.0643C32.6016 33.2966 31.0296 33.6307 29.9621 32.9738C28.8425 32.2848 28.4021 30.8752 29.0259 29.8617ZM32.7857 28.0354C31.1118 27.3658 29.129 27.7861 28.1742 29.3376C27.198 30.924 27.9576 32.9144 29.438 33.8254C30.9665 34.7661 33.1871 34.305 34.134 32.5484C35.0979 30.9642 34.3384 28.9823 32.8621 28.0738C32.8378 28.0588 32.8122 28.046 32.7857 28.0354Z" class="fill-border"/></svg>',
  fullscreen: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.9 20.2002H20.2V29.9002H29.9V20.2002Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M18.7 10H10.5C10.2239 10 10 10.2239 10 10.5V18.7C10 18.9022 10.1218 19.0845 10.3087 19.1619C10.4955 19.2393 10.7106 19.1966 10.8536 19.0536L14.6002 15.3069L19.7 20.4066V29.5929L14.6001 34.6928L10.8536 30.9463C10.7106 30.8033 10.4955 30.7605 10.3087 30.8379C10.1218 30.9153 10 31.0976 10 31.2998V39.4998C10 39.776 10.2239 39.9998 10.5 39.9998H18.7C18.9022 39.9998 19.0845 39.878 19.1619 39.6912C19.2393 39.5043 19.1966 39.2893 19.0536 39.1463L15.3072 35.3999L20.3069 30.4002H29.6933L34.6929 35.3998L30.9465 39.1463C30.8035 39.2893 30.7607 39.5043 30.8381 39.6912C30.9155 39.878 31.0978 39.9998 31.3001 39.9998H39.5001C39.7762 39.9998 40.0001 39.776 40.0001 39.4998V31.2998C40.0001 31.0976 39.8782 30.9153 39.6914 30.8379C39.5046 30.7605 39.2895 30.8033 39.1465 30.9463L35.4 34.6927L30.4 29.6926V20.3069L35.3999 15.3069L39.1465 19.0536C39.2895 19.1966 39.5046 19.2393 39.6914 19.1619C39.8782 19.0845 40.0001 18.9022 40.0001 18.7V10.5C40.0001 10.2239 39.7762 10 39.5001 10H31.3001C31.0978 10 30.9155 10.1218 30.8381 10.3087C30.7607 10.4955 30.8035 10.7106 30.9465 10.8536L34.6928 14.5998L29.5924 19.7002H20.4078L15.3073 14.5998L19.0536 10.8536C19.1966 10.7106 19.2393 10.4955 19.1619 10.3087C19.0845 10.1218 18.9022 10 18.7 10ZM11 17.4929V11H17.4929L11 17.4929ZM20.7 20.7002V29.4002H29.4V20.7002H20.7ZM32.5072 38.9998H39.0001V32.5069L32.5072 38.9998ZM32.5072 11L39.0001 17.4929V11H32.5072ZM11 38.9998V32.5069L17.4929 38.9998H11Z" class="fill-border"/></svg>',
  minimize: '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.95 22.15H22.15V13.95L13.95 22.15Z" class="fill-background"/><path d="M36.0499 27.8504H27.8499V36.0504L36.0499 27.8504Z" class="fill-background"/><path d="M22.15 36.0504V27.8504H13.95L22.15 36.0504Z" class="fill-background"/><path d="M27.8499 13.95V22.15H36.0499L27.8499 13.95Z" class="fill-background"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8035 12.0966C12.6082 11.9014 12.2917 11.9014 12.0964 12.0966C11.9011 12.2919 11.9011 12.6085 12.0964 12.8037L17.3428 18.0502L13.5964 21.7967C13.4534 21.9397 13.4106 22.1547 13.488 22.3416C13.5654 22.5284 13.7477 22.6502 13.9499 22.6502H22.1499C22.4261 22.6502 22.6499 22.4264 22.6499 22.1502V13.9502C22.6499 13.748 22.5281 13.5657 22.3413 13.4883C22.1544 13.4109 21.9394 13.4537 21.7964 13.5967L18.05 17.3431L12.8035 12.0966ZM18.4043 18.4029L18.4035 18.4037L18.4027 18.4046L15.157 21.6502H21.6499V15.1573L18.4043 18.4029Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M32.6572 31.9503L36.4034 28.2041C36.5464 28.0611 36.5892 27.8461 36.5118 27.6592C36.4344 27.4724 36.2521 27.3506 36.0499 27.3506H27.8499C27.5737 27.3506 27.3499 27.5744 27.3499 27.8506V36.0506C27.3499 36.2528 27.4717 36.4351 27.6585 36.5125C27.8453 36.5899 28.0604 36.5471 28.2034 36.4041L31.9501 32.6574L37.1964 37.9037C37.3917 38.099 37.7082 38.099 37.9035 37.9037C38.0988 37.7085 38.0988 37.3919 37.9035 37.1966L32.6572 31.9503ZM31.5863 31.6071L28.3499 34.8435V28.3506H34.8427L31.6068 31.5865L31.5964 31.5966L31.5863 31.6071Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.3426 31.9504L12.0964 37.1966C11.9011 37.3919 11.9011 37.7085 12.0964 37.9037C12.2917 38.099 12.6082 38.099 12.8035 37.9037L18.0497 32.6575L21.7964 36.4041C21.9394 36.5471 22.1544 36.5899 22.3413 36.5125C22.5281 36.4351 22.6499 36.2528 22.6499 36.0506V27.8506C22.6499 27.5744 22.4261 27.3506 22.1499 27.3506H13.9499C13.7477 27.3506 13.5654 27.4724 13.488 27.6592C13.4106 27.8461 13.4534 28.0611 13.5964 28.2041L17.3426 31.9504ZM18.4154 31.609L18.4035 31.5966L18.3912 31.5847L15.157 28.3506H21.6499V34.8435L18.4154 31.609Z" class="fill-border"/><path fill-rule="evenodd" clip-rule="evenodd" d="M37.9035 12.0966C38.0988 12.2919 38.0988 12.6085 37.9035 12.8037L32.657 18.0503L36.4034 21.7967C36.5464 21.9397 36.5892 22.1547 36.5118 22.3416C36.4344 22.5284 36.2521 22.6502 36.0499 22.6502H27.8499C27.5737 22.6502 27.3499 22.4264 27.3499 22.1502V13.9502C27.3499 13.748 27.4717 13.5657 27.6585 13.4883C27.8453 13.4109 28.0604 13.4537 28.2034 13.5967L31.9499 17.3431L37.1964 12.0966C37.3917 11.9014 37.7082 11.9014 37.9035 12.0966ZM28.3499 21.6502V15.1573L34.8427 21.6502H28.3499Z" class="fill-border"/></svg>'
};
FlexmonsterToolbar.prototype.icons_v26 = {
  connect: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><style>.a{fill:none;}</style><path d="M9.9 18.4c2.1 0.9 5 1.4 8.1 1.4 3.1 0 6-0.5 8.1-1.4C27.9 17.7 29 16.7 29 15.8v-3.9c-1 0.5-1.3 0.9-2.1 1.2 -2.4 1.1-5.5 1.7-8.9 1.7 -3.3 0-6.5-0.6-8.9-1.7C8.3 12.8 8 12.3 7 11.9v3.9c0 0 0 0 0 0C7 16.7 8.1 17.7 9.9 18.4z" class="a"/><path d="M9.9 24.5c2.1 0.9 5 1.4 8.1 1.4 3.1 0 6-0.5 8.1-1.4C27.9 23.7 29 21.8 29 20.9v-2.7c-1 0.4-1.3 0.8-2.1 1.2 -2.4 1-5.5 1.6-8.9 1.6 -3.3 0-6.5-0.6-8.9-1.6C8.3 19 8 18.6 7 18.1v3.7c0 0 0 0 0 0C7 22.8 8.1 23.7 9.9 24.5z" class="a"/><path d="M29 24.2c-0.6 0.4-1.3 0.8-2.1 1.2 -2.4 1-5.5 1.6-8.9 1.6 -3.3 0-6.5-0.6-8.9-1.6C8.3 25 8 24.6 7 24.2v3.7c0 0.9 1.1 1.9 2.9 2.6 2.1 0.9 5 1.4 8.1 1.4 3.1 0 6-0.5 8.1-1.4C27.9 29.8 29 28.8 29 27.9h0V24.2z" class="a"/><path d="M26.9 4.7C24.5 3.6 21.3 3 18 3c-3.3 0-6.5 0.6-8.9 1.7C6.5 5.9 6 7.5 6 9.4c0 0 0 0 0 0C6 9.5 6 9.5 6 9.5v18.5c0 1.8 0.5 2.4 3.1 3.5C11.5 32.4 14.7 33 18 33c3.3 0 6.5-0.6 8.9-1.6C29.5 30.3 30 29.7 30 27.9V9.4c0 0 0 0 0 0C30 7.5 29.5 5.9 26.9 4.7zM7 15.8v-3.9c1 0.5 1.3 0.9 2.1 1.3 2.4 1.1 5.5 1.7 8.9 1.7 3.3 0 6.5-0.6 8.9-1.7C27.7 12.8 28 12.3 29 11.9v3.9c0 0.9-1.1 1.9-2.9 2.6 -2.1 0.9-5 1.4-8.1 1.4 -3.1 0-5.9-0.5-8.1-1.4C8.1 17.7 7 16.7 7 15.8 7 15.8 7 15.8 7 15.8zM7 18.1c1 0.4 1.3 0.8 2.1 1.2 2.4 1 5.5 1.6 8.9 1.6 3.3 0 6.5-0.6 8.9-1.6C27.7 19 28 18.6 29 18.1v2.7c0 0.9-1.1 2.9-2.9 3.6 -2.1 0.9-5 1.4-8.1 1.4 -3.1 0-6-0.5-8.1-1.4 -1.8-0.8-2.9-1.8-2.9-2.6 0 0 0 0 0 0V18.1zM26.1 30.6c-2.1 0.9-5 1.4-8.1 1.4 -3.1 0-5.9-0.5-8.1-1.4C8.1 29.8 7 28.8 7 27.9v-3.7c1 0.4 1.3 0.8 2.1 1.2 2.4 1 5.5 1.6 8.9 1.6 3.3 0 6.5-0.6 8.9-1.6 0.8-0.3 1.5-0.7 2.1-1.2v3.7h0C29 28.8 27.9 29.8 26.1 30.6z"/></svg>',
  connect_olap: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M30 10.9c0 0-0.1-0.3-0.2-0.3 0 0 0 0-0.1 0 0 0 0 0 0 0L17.8 4.1c-0.2-0.1-0.3-0.1-0.5 0L5.3 10.5c0 0 0 0 0 0C5.1 10.6 5 10.8 5 11V27l12 5c0 0 0.4-0.1 0.4-0.1 0.1 0.1 0.3 0.1 0.5 0C17.8 31.9 18 32 18 32l12-5 0-16L30 10.9zM22.4 7.7l-4.8 2.4 -4.8-2.4 4.8-2.4L22.4 7.7zM11 21l-5-2V12l5 3V21zM6.3 10.9l4.8-2.4L16 11l-5 2L6.3 10.9zM17 31l-5-2v-6l5 2V31zM17 24l-5-2v-6l5 2V24zM17.6 16.5L12 14l6-2 5 2L17.6 16.5zM23 29l-5 2v-6l5-2V29zM23 22l-5 2v-6l5-2V22zM29 26l-5 2v-6l5-2V26zM29 19l-5 2v-6l5-2V19z"/></svg>',
  connect_csv: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M11 24l6 0V27h-6V24z"/><path d="M12.8 22L12.8 22l1.2-2.5L15.1 22h1.9l-2-3.9L16.9 14h-1.8l-1 2.5L12.9 14h-1.8l1.9 3.9L11 22H12.8z"/><path d="M19 19h6v3h-6V19z"/><path d="M19 14h6v3L19 17V14z"/><path d="M19 24h6v3h-6V24z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
  connect_json: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/><path d="M19 24c0 0.6-0.4 1-1 1 -0.6 0-1-0.4-1-1v-2c0-0.6 0.4-1 1-1 0.6 0 1 0.4 1 1V24zM21 18v-2c0-0.6-0.4 0-1 0 -0.6 0-1-0.4-1-1 0-0.6 0.4-1 1-1 1.7 0 3 0.3 3 2v2c0 1.1 0.9 2 2 2 0.6 0 1 0.4 1 1 0 0.6-0.4 1-1 1 -1.1 0-2 0.9-2 2v2c0 1.7-1.3 2-3 2 -0.6 0-1-0.4-1-1s0.4-1 1-1c0.6 0 1 0.6 1 0v-2c0-1.2 0.5-2.3 1.4-3C21.5 20.3 21 19.2 21 18zM11 20c1.1 0 2-0.9 2-2v-2c0-1.7 1.3-2 3-2 0.6 0 1 0.4 1 1 0 0.6-0.4 1-1 1 -0.6 0-1-0.6-1 0v2c0 1.2-0.5 2.3-1.4 3 0.8 0.7 1.4 1.8 1.4 3v2c0 0.6 0.4 0 1 0 0.6 0 1 0.4 1 1s-0.4 1-1 1c-1.7 0-3-0.3-3-2v-2c0-1.1-0.9-2-2-2 -0.6 0-1-0.4-1-1C10 20.4 10.4 20 11 20z"/><path d="M18 17c0.6 0 1 0.4 1 1s-0.4 1-1 1 -1-0.4-1-1S17.4 17 18 17z"/></svg>',
  connect_csv_remote: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M11 24l6 0V27h-6V24z"/><path d="M12.8 22L12.8 22l1.2-2.5L15.1 22h1.9l-2-3.9L16.9 14h-1.8l-1 2.5L12.9 14h-1.8l1.9 3.9L11 22H12.8z"/><path d="M19 19h6v3h-6V19z"/><path d="M19 14h6v3L19 17V14z"/><path d="M19 24h6v3h-6V24z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
  connect_json_remote: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/><path d="M19 24c0 0.6-0.4 1-1 1 -0.6 0-1-0.4-1-1v-2c0-0.6 0.4-1 1-1 0.6 0 1 0.4 1 1V24zM21 18v-2c0-0.6-0.4 0-1 0 -0.6 0-1-0.4-1-1 0-0.6 0.4-1 1-1 1.7 0 3 0.3 3 2v2c0 1.1 0.9 2 2 2 0.6 0 1 0.4 1 1 0 0.6-0.4 1-1 1 -1.1 0-2 0.9-2 2v2c0 1.7-1.3 2-3 2 -0.6 0-1-0.4-1-1s0.4-1 1-1c0.6 0 1 0.6 1 0v-2c0-1.2 0.5-2.3 1.4-3C21.5 20.3 21 19.2 21 18zM11 20c1.1 0 2-0.9 2-2v-2c0-1.7 1.3-2 3-2 0.6 0 1 0.4 1 1 0 0.6-0.4 1-1 1 -0.6 0-1-0.6-1 0v2c0 1.2-0.5 2.3-1.4 3 0.8 0.7 1.4 1.8 1.4 3v2c0 0.6 0.4 0 1 0 0.6 0 1 0.4 1 1s-0.4 1-1 1c-1.7 0-3-0.3-3-2v-2c0-1.1-0.9-2-2-2 -0.6 0-1-0.4-1-1C10 20.4 10.4 20 11 20z"/><path d="M18 17c0.6 0 1 0.4 1 1s-0.4 1-1 1 -1-0.4-1-1S17.4 17 18 17z"/></svg>',
  connect_elastic: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 112 112"><style type="text/css">.st0{fill:#FFFFFF;}.st1{fill:#00A9E5;}.st2{fill:#353535;}.st3{fill:#00BFB3;}.st4{fill:#019B8F;}.st5{fill:#F9B110;}.st6{fill:#FED10A;}</style><path d="m53.2 68h-32.4c-1.2-3.8-1.8-7.8-1.8-12s0.6-8.2 1.8-12h53.2c6.7 0 12 5.4 12 12s-5.3 12-11.9 12h-20.9zm-1.5 4h-29.4c3.1 7.1 8.2 13.2 14.7 17.4 6.3 4.2 13.9 6.6 22 6.6 13.9 0 26.1-7.1 33.3-17.8-3.7-3.8-8.9-6.2-14.6-6.2h-26zm26-32c5.7 0 10.9-2.4 14.6-6.2-7.2-10.7-19.4-17.8-33.3-17.8-8.1 0-15.7 2.4-22 6.6-6.4 4.2-11.5 10.3-14.7 17.4h55.4z"/></svg>',
  open: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M34.4 16.5C34.3 16.4 34.7 16 34.5 16H31V8C32 7.4 31.1 6 29.5 6h-15l-2-2c-0.1-0.2-0.7 0-1 0h-6C4.9 4 4 5.3 4 6V16H1.5c-0.2 0 0.2 0.4 0.1 0.5 -0.1 0.1-0.2 0.3-0.1 0.5l3.2 14.5C4.8 31.8 5.2 32 5.5 32h25c0.3 0 1 0.3 1 0l3-15C34.5 16.8 34.5 16.7 34.4 16.5zM5 5h6.5l1.9 1.7C13.5 7 14.2 7 14.5 7H30v9h-4v-5H9v5H5V5zM25 16H10v-4h15V16z"/></svg>',
  open_local: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><style>.a{fill:none;}</style><path d="M30.9 10.6C30.8 10.4 30.2 10 30 10h-1V8c0-0.4-0.6-1-1-1H15l-1-2H8C7.6 5 7 5.6 7 6v4H6c-0.2 0-0.8 0.4-0.9 0.6 -0.1 0.1-0.2 0.3-0.1 0.5l2.1 19.5C7.2 30.8 7.7 31 8 31h20c0.3 0 0.8-0.2 0.9-0.5l2.1-19.5C31 10.9 31 10.7 30.9 10.6zM28 30H8L6 11h24L28 30z"/><line x1="11" y1="23" x2="11" y2="23" class="a"/><line x1="25" y1="23" x2="25" y2="23" class="a"/><polygon points="11 15 11 23 17 23 17 25 14 25 14 26 22 26 22 25 19 25 19 23 25 23 25 15 "/></svg>',
  open_remote: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M30.9 10.6C30.8 10.4 30.2 10 30 10h-1V8c0-0.4-0.6-1-1-1H15l-1-2H8C7.6 5 7 5.6 7 6v4H6c-0.2 0-0.8 0.4-0.9 0.6 -0.1 0.1-0.2 0.3-0.1 0.5l2.1 19.5C7.2 30.8 7.7 31 8 31h20c0.3 0 0.8-0.2 0.9-0.5l2.1-19.5C31 10.9 31 10.7 30.9 10.6zM28 30H8L6 11h24L28 30z"/><path d="M24.8 18.1l-0.8 1.5c-0.2 0.2-0.5 0.2-0.8 0 -1.3-1.2-3.2-1.9-5.3-1.9 -2.1 0-4 0.7-5.3 1.9 -0.2 0.2-0.5 0.2-0.8 0l-0.8-1.5c-0.1-0.1-0.2-0.2-0.2-0.3 0-0.1 0.1-0.2 0.2-0.3 1.7-1.5 4.1-2.5 6.8-2.5 2.7 0 5.1 0.9 6.8 2.5 0.1 0 0.2 0.2 0.2 0.3C25 17.9 24.9 18 24.8 18.1zM18 19.6c1.5 0 2.8 0.5 3.8 1.4 0.2 0.2 0.2 0.5 0 0.7l-0.8 1.5c-0.2 0.2-0.5 0.2-0.8 0 -0.6-0.5-1.4-0.8-2.3-0.8 -0.9 0-1.7 0.3-2.3 0.8 -0.2 0.2-0.5 0.2-0.8 0l-0.8-1.5c-0.2-0.2-0.2-0.5 0-0.7C15.2 20.1 16.5 19.6 18 19.6zM18 23.4c0.8 0 1.4 0.6 1.4 1.3 0 0.7-0.6 1.3-1.4 1.3 -0.8 0-1.4-0.6-1.4-1.3C16.6 24 17.2 23.4 18 23.4z"/></svg>',
  grid: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><style>.a{fill:none;}</style><polygon points="30 15 23 15 23 22 30 22 30 15 " class="a"/><polygon points="14 22 14 15 7 15 7 22 14 22 " class="a"/><polygon points="14 23 7 23 7 30 14 30 14 23 " class="a"/><polygon points="22 15 15 15 15 22 22 22 22 15 " class="a"/><polygon points="30 23 23 23 23 30 30 30 30 23 " class="a"/><polygon points="22 23 15 23 15 30 22 30 22 23 " class="a"/><path d="M30.5 6l-0.2 0L30 6H7L6.7 6 6.5 6 6 6.5v24L6.5 31l0.2 0L7 31h23.1l0.3 0L30.5 31l0.5-0.5v-24L30.5 6 30.5 6zM14 15v7H7v-7H14L14 15zM15 15h7v7h-7V15L15 15zM23 15h7v7h-7V15L23 15zM7 23h7v7H7V23L7 23zM15 23h7v7h-7V23L15 23zM23 23h7v7h-7V23L23 23z"/></svg>',
  save: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M30 10.9l-6-5.2 0 0 0 0 0 0L24 5.5l-0.1 0 0 0.2L23.8 6H6.1L5 6.1v23.7V31h24.5l0.1-0.3L30 29.5v-18L30 10.9 30 10.9zM22 26h-9v-2h9V26L22 26zM29 30h-3V19h-0.5 -15H9v11H6V7h6v5.5l1.5 1.5h9l0.5-1.5v-6l6 5V30L29 30z"/></svg>',
  export: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon points="14 27 22 27 22 15 27 15 18 5 9 15 14 15 "/><path d="M32.5 21h-5c-0.3 0-0.5 0.2-0.5 0.5s0.2 0.5 0.5 0.5H32v10H4V22h4.5C8.8 22 9 21.8 9 21.5S8.8 21 8.5 21h-5C3.2 21 3 21.2 3 21.5v11C3 32.8 3.2 33 3.5 33h29c0.3 0 0.5-0.2 0.5-0.5v-11C33 21.2 32.8 21 32.5 21z"/></svg>',
  export_print: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M23 23H13v1h10V23L23 23z"/><path d="M13 25v1h10v-1H13z"/><path d="M26 12V5H10v7H6v14h3v4h18v-4h3V12H26zM11 6h14v6H11V6zM26 29H10v-9h16V29zM26 17.8c-1.1 0-2-0.9-2-2s0.9-2 2-2c1.1 0 2 0.9 2 2S27.1 17.8 26 17.8z"/><path d="M26 14.6c0.7 0 1.2 0.5 1.2 1.2 0 0.7-0.5 1.2-1.2 1.2 -0.7 0-1.2-0.5-1.2-1.2C24.8 15.1 25.3 14.6 26 14.6z"/></svg>',
  export_excel: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M24.4 15h-3.8L18 18.6 15.3 15h-3.8l4.5 5.2L11 27h7.3L18 25h-2l2-3L21.1 27H25l-5.1-6.8L24.4 15z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
  export_html: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M25.7 20.8l-2.3-2.5c-0.2-0.2-0.4-0.3-0.6-0.3 -0.2 0-0.4 0.1-0.6 0.3 -0.3 0.4-0.3 1 0 1.4l1.7 1.9 -1.7 1.9c-0.2 0.2-0.3 0.4-0.3 0.7 0 0.3 0.1 0.5 0.3 0.7 0.2 0.2 0.4 0.3 0.6 0.3 0.2 0 0.4-0.1 0.6-0.3l2.3-2.5C26.1 21.8 26.1 21.2 25.7 20.8z"/><path d="M14 24c0-0.3-0.1-0.5-0.3-0.7l-1.7-1.9 1.7-1.9c0.3-0.4 0.3-1 0-1.4 -0.2-0.2-0.4-0.3-0.6-0.3 -0.2 0-0.4 0.1-0.6 0.3l-2.3 2.5c-0.3 0.4-0.3 1 0 1.4l2.3 2.5c0.2 0.2 0.4 0.3 0.6 0.3 0.2 0 0.4-0.1 0.6-0.3C13.9 24.5 14 24.3 14 24z"/><path d="M20.4 15.1c-0.1 0-0.2-0.1-0.3-0.1 -0.4 0-0.8 0.3-0.9 0.6l-4.1 11.1c-0.1 0.2-0.1 0.5 0 0.7 0.1 0.2 0.3 0.4 0.5 0.5C15.7 28 15.8 28 16 28c0.4 0 0.8-0.3 0.9-0.6l4.1-11.1C21.1 15.8 20.9 15.2 20.4 15.1z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
  export_image: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M25 21.5c0 1.9 0 3.7 0 5.6 0 0.5-0.4 0.9-1 0.9C20 28 16 28 12 28 11.4 28 11 27.7 11 27.1c0-3.2 0-6.4 0-9.5 0-0.6 0-1.1 0-1.7 0-0.4 0.3-0.7 0.7-0.8C11.8 15 11.9 15 11.9 15c4.1 0 8.1 0 12.2 0C24.6 15 25 15.3 25 15.9 25 17.7 25 19.6 25 21.5zM14 26h8c0 0-1.4-3.7-2.2-5.3 -0.8 1.1-1.5 2.1-2.3 3.2 -0.4-0.5-0.8-1-1.2-1.5C15.4 23.4 14 26 14 26zM14.5 17c-0.8 0-1.5 0.7-1.5 1.5 0 0.8 0.7 1.5 1.5 1.5C15.3 20 16 19.3 16 18.5 16 17.7 15.3 17 14.5 17z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
  export_pdf: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M17.2 17.1L17.2 17.1C17.3 17.1 17.3 17.1 17.2 17.1c0.1-0.5 0.2-0.7 0.2-1V15.8c0.1-0.6 0.1-1 0-1.1 0 0 0 0 0-0.1l-0.1-0.1 0 0 0 0c0 0 0 0.1-0.1 0.1C16.9 15.2 16.9 16 17.2 17.1L17.2 17.1zM13.8 24.8c-0.2 0.1-0.4 0.2-0.6 0.3 -0.8 0.7-1.3 1.5-1.5 1.8l0 0 0 0 0 0C12.5 26.9 13.1 26.2 13.8 24.8 13.9 24.8 13.9 24.8 13.8 24.8 13.9 24.8 13.8 24.8 13.8 24.8zM24.1 23.1c-0.1-0.1-0.6-0.5-2.1-0.5 -0.1 0-0.1 0-0.2 0l0 0c0 0 0 0 0 0.1 0.8 0.3 1.6 0.6 2.1 0.6 0.1 0 0.1 0 0.2 0l0 0h0.1c0 0 0 0 0-0.1l0 0C24.2 23.3 24.1 23.3 24.1 23.1zM24.6 24c-0.2 0.1-0.6 0.2-1 0.2 -0.9 0-2.2-0.2-3.4-0.8 -1.9 0.2-3.4 0.5-4.5 0.9 -0.1 0-0.1 0-0.2 0.1 -1.3 2.4-2.5 3.5-3.4 3.5 -0.2 0-0.3 0-0.4-0.1l-0.6-0.3v-0.1c-0.1-0.2-0.1-0.3-0.1-0.6 0.1-0.6 0.8-1.6 2.1-2.4 0.2-0.1 0.6-0.3 1-0.6 0.3-0.6 0.7-1.2 1.1-2 0.6-1.1 0.9-2.3 1.2-3.3l0 0c-0.4-1.4-0.7-2.1-0.2-3.7 0.1-0.5 0.4-0.9 0.9-0.9h0.2c0.2 0 0.4 0.1 0.7 0.2 0.8 0.8 0.4 2.6 0 4.1 0 0.1 0 0.1 0 0.1 0.4 1.2 1.1 2.3 1.8 2.9 0.3 0.2 0.6 0.5 1 0.7 0.6 0 1-0.1 1.5-0.1 1.3 0 2.2 0.2 2.6 0.8 0.1 0.2 0.1 0.5 0.1 0.7C24.9 23.5 24.8 23.8 24.6 24zM17.3 19.6c-0.2 0.8-0.7 1.7-1.1 2.7 -0.2 0.5-0.4 0.8-0.7 1.2h0.1 0.1l0 0c1.5-0.6 2.8-0.9 3.7-1 -0.2-0.1-0.3-0.2-0.4-0.3C18.4 21.6 17.7 20.7 17.3 19.6z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
  export_csv: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M11 24l6 0V27h-6V24z"/><path d="M12.8 22L12.8 22l1.2-2.5L15.1 22h1.9l-2-3.9L16.9 14h-1.8l-1 2.5L12.9 14h-1.8l1.9 3.9L11 22H12.8z"/><path d="M19 19h6v3h-6V19z"/><path d="M19 14h6v3L19 17V14z"/><path d="M19 24h6v3h-6V24z"/><path d="M23 4H7v28h22V11L23 4zM8 31V5h14v7h6v19H8L8 31z"/></svg>',
  charts: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon points="28 30 28 22 23 22 23 30 21 30 21 9 16 9 16 30 14 30 14 17 9 17 9 30 5 30 5 5 4 5 4 31 32 31 32 30 "/></svg>',
  charts_bar: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon points="32 30 5 30 5 26 18 26 18 21 5 21 5 19 26 19 26 14 5 14 5 12 13 12 13 7 5 7 5 3 4 3 4 31 32 31 "/></svg>',
  charts_column_line: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon points="32 30 29 30 29 17 26 17 26 30 23 30 23 19 20 19 20 30 17 30 17 14 14 14 14 30 11 30 11 20 8 20 8 30 5 30 5 3 4 3 4 31 32 31 32 30 "/><path d="M8.7 12.5c1 0 1.7-0.8 1.7-1.7 0-0.3 0-0.5-0.1-0.8l4.3-3.9c0.3 0.3 0.5 0.3 0.9 0.3 0.2 0 0.5 0 0.6-0.1l4.8 6c-0.3 0.3-0.4 0.6-0.4 1 0 0.9 0.7 1.6 1.8 1.6 0.9 0 1.7-0.8 1.7-1.6 0-0.3-0.1-0.5-0.3-0.8l4.3-3.8c0.3 0.2 0.6 0.3 0.9 0.3 1.1 0 1.8-0.8 1.8-1.7 0-0.4-0.2-0.9-0.5-1.2C30.2 6 30 5.8 29.6 5.8c0 0-0.2-0.1-0.4-0.1 -0.9 0-1.7 0.8-1.7 1.7 0 0.3 0.1 0.5 0.3 0.8l-4.3 3.7c-0.3-0.1-0.5-0.3-0.9-0.3 -0.3 0-0.5 0.1-0.7 0.2l-4.8-6.1c0.2-0.3 0.4-0.6 0.4-0.9 0-1-0.8-1.7-1.7-1.7 -0.9 0-1.7 0.8-1.7 1.7 0 0.3 0.1 0.6 0.1 0.8l-4.3 3.9C9.4 9.2 9.1 9.1 8.7 9.1c-0.9 0-1.7 0.7-1.7 1.6C7 11.7 7.8 12.5 8.7 12.5z"/></svg>',
  charts_stacked_column: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon points="32 30 28 30 28 27 23 27 23 30 21 30 21 14 16 14 16 30 14 30 14 22 9 22 9 30 5 30 5 3 4 3 4 31 32 31 32 30 "/><polygon points="14 15 9 15 9 21 14 21 14 15 "/><polygon points="21 9 16 9 16 13 21 13 21 9 "/><polygon points="28 22 23 22 23 26 28 26 28 22 "/></svg>',
  charts_line: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon points="32 30 5 30 5 3 4 3 4 31 32 31 32 30 "/><path d="M9.4 24c1.3 0 2.4-1.1 2.4-2.3 0-0.7-0.3-1.3-0.8-1.8l2.8-4.3c0.4 0.1 0.6 0.2 1 0.2 0.8 0 1.4-0.3 1.9-0.7l2.8 2.6c-0.2 0.4-0.2 0.6-0.2 0.9 0 1.2 1 2.2 2.1 2.2 1.3 0 2.2-1 2.2-2.2 0-0.2 0-0.5-0.1-0.8l2.9-8c0.6 0.5 1.3 0.7 2.1 0.7 1.6 0 3-1.3 3-3.1 0-1.7-1.3-3.1-3-3.1 -1.7 0-3.1 1.4-3.1 3.1 0 0.6 0.2 1.1 0.4 1.6l-2.8 8c-0.4-0.5-0.9-0.7-1.6-0.7 -0.5 0-1 0.2-1.4 0.6l-2.8-2.7c0.1-0.4 0.2-0.8 0.2-1.2 0-1.6-1.1-2.8-2.7-2.8 -1.4 0-2.7 1.3-2.7 2.8 0 0.8 0.4 1.5 0.9 2.1l-2.8 4.2c-0.2-0.1-0.5-0.1-0.8-0.1C8.1 19.2 7 20.3 7 21.7 7 22.9 8.1 24 9.4 24z"/></svg>',
  charts_pie: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M25.2 28.8c3.3-2.2 5.5-5.8 5.8-9.8h-12L25.2 28.8z"/><path d="M17 18v-13c-7 0.4-12 6.1-12 13 0 7.2 5.9 13 13 13 2.1 0 4-0.5 5.8-1.4C23.8 29.6 17 18.2 17 18z"/><path d="M18 5V18h13l0-0.9C30.6 10.6 25 5.4 18 5z"/></svg>',
  charts_scatter: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon points="32 30 5 30 5 3 4 3 4 31 32 31 "/><path d="M9.5 20c1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5S7 23.9 7 22.5C7 21.1 8.1 20 9.5 20z"/><path d="M21.5 17c1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5S19 20.9 19 19.5C19 18.1 20.1 17 21.5 17z"/><path d="M14 11c1.7 0 3 1.3 3 3s-1.3 3-3 3 -3-1.3-3-3S12.3 11 14 11z"/><path d="M28 6c1.7 0 3 1.3 3 3 0 1.7-1.3 3-3 3s-3-1.3-3-3C25 7.3 26.3 6 28 6z"/></svg>',
  format: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><rect x="18.8" y="12.9" transform="matrix(-0.7073 -0.7069 0.7069 -0.7073 21.6275 41.9551)" width="1.3" height="7.1" fill="none"/><polygon points="24 25 23 25 23 32 4 32 4 13 11 13 11 12 3 12 3 33 24 33 "/><path d="M28.3 3.5c-0.9 0-1.8 0.3-2.5 0.8l-1.7 1.7 5.9 5.9 1.7-1.7c0.5-0.7 0.8-1.6 0.8-2.5C32.5 5.4 30.6 3.5 28.3 3.5z"/><path d="M11.2 18.9L9.5 26.5l7.6-1.7 11.6-11.6 -5.9-5.9L11.2 18.9zM17.4 19.5l-0.9-0.9 5.1-5 0.9 0.9L17.4 19.5z"/></svg>',
  format_number: '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="36" viewBox="0 0 52 36"><path d="M31 19.2v-3.4l2.5-0.4c0.2-0.7 0.5-1.4 0.9-2.1l-1.4-2 2.4-2.4 2 1.4c0.7-0.4 1.4-0.7 2.1-0.9l0.4-2.5h3.4l0.4 2.5c0.7 0.2 1.4 0.5 2.1 0.9l2-1.4 2.4 2.4 -1.4 2c0.4 0.7 0.7 1.4 0.9 2.1L52 15.8v3.4l-2.5 0.4c-0.2 0.7-0.5 1.4-0.9 2.1l1.4 2 -2.4 2.4 -2-1.5c-0.7 0.4-1.4 0.7-2.1 0.9l-0.4 2.5h-3.4l-0.4-2.5c-0.7-0.2-1.4-0.5-2.1-0.9l-2 1.5 -2.4-2.4 1.4-2c-0.4-0.7-0.7-1.4-0.9-2.1L31 19.2zM41.5 21c1.9 0 3.5-1.6 3.5-3.5 0-1.9-1.6-3.5-3.5-3.5 -1.9 0-3.5 1.6-3.5 3.5C38 19.4 39.6 21 41.5 21z"/><path d="M38 30H1V6h36V5H0v26h38V30L38 30z"/><path d="M9.4 21.1c-0.3 0.3-0.7 0.4-1.2 0.4 -0.5 0-0.9-0.2-1.2-0.5s-0.4-0.8-0.4-1.4H5c0 0.9 0.2 1.7 0.7 2.2 0.5 0.6 1.2 0.9 2 1v1.3h1.1v-1.4c0.8-0.1 1.5-0.4 1.9-0.9 0.5-0.5 0.7-1.1 0.7-1.9 0-0.4-0.1-0.8-0.2-1.1 -0.1-0.3-0.3-0.6-0.5-0.8 -0.2-0.2-0.5-0.4-0.8-0.6 -0.3-0.2-0.8-0.4-1.4-0.6 -0.6-0.2-1-0.4-1.2-0.7s-0.4-0.6-0.4-1c0-0.4 0.1-0.8 0.4-1 0.2-0.2 0.6-0.4 1-0.4 0.4 0 0.8 0.2 1 0.5 0.3 0.3 0.4 0.8 0.4 1.4h1.6c0-0.9-0.2-1.6-0.6-2.2 -0.4-0.6-1-0.9-1.8-1v-1.5H7.9v1.5C7.1 12.6 6.5 12.9 6 13.4s-0.7 1.1-0.7 1.9c0 1.1 0.5 2 1.6 2.6 0.3 0.2 0.8 0.4 1.3 0.6 0.6 0.2 1 0.4 1.2 0.7s0.4 0.6 0.4 1C9.8 20.5 9.7 20.8 9.4 21.1z"/><path d="M16.3 12.6h-0.2l-3.8 1.5v1.4l2.4-0.8v8.1h1.6V12.6z"/><path d="M19.9 23.8c0.2-0.5 0.4-1 0.4-1.5l0-1.2h-1.5v1.3c0 0.3-0.1 0.6-0.2 1 -0.1 0.3-0.3 0.7-0.5 1.1l0.9 0.5C19.3 24.7 19.6 24.3 19.9 23.8z"/><path d="M27 16.7c0-1.4-0.3-2.5-0.8-3.2s-1.3-1.1-2.4-1.1c-1.1 0-1.9 0.4-2.4 1.1 -0.5 0.7-0.8 1.8-0.8 3.3v1.8c0 1.4 0.3 2.5 0.8 3.2s1.3 1.1 2.4 1.1c1.1 0 1.9-0.4 2.4-1.1 0.5-0.7 0.8-1.8 0.8-3.3V16.7zM25.4 18.9c0 0.9-0.1 1.6-0.4 2 -0.2 0.4-0.6 0.6-1.2 0.6 -0.5 0-0.9-0.2-1.2-0.7 -0.3-0.5-0.4-1.2-0.4-2.1v-2.3c0-0.9 0.1-1.5 0.4-2 0.3-0.4 0.6-0.6 1.2-0.6 0.5 0 0.9 0.2 1.2 0.7 0.3 0.4 0.4 1.1 0.4 2.1V18.9z"/></svg>',
  format_conditional: '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="36" viewBox="0 0 52 36"><polygon points="38 5 0 5 0 31 26 31 26 30 1 30 1 6 37 6 37 10 38 10 "/><path d="M9 13H8.6L5 14.4v1.4l2-0.8V23h2V13z"/><path d="M17 22h-4l2.4-2.9c0.6-0.7 1-1.3 1.3-1.8 0.3-0.5 0.4-1.1 0.4-1.5 0-0.8-0.3-1.5-0.8-2 -0.5-0.5-1.2-0.7-2.2-0.7 -0.6 0-1.2 0.1-1.7 0.4s-0.9 0.6-1.1 1C11.1 14.9 11 16 11 16h1.6c0 0 0.1-0.9 0.4-1.3s0.7-0.4 1.2-0.4c0.4 0 0.8 0.2 1 0.5 0.3 0.3 0.4 0.7 0.4 1.1 0 0.4-0.1 0.7-0.3 1.1 -0.2 0.4-0.6 0.8-1.1 1.3L11 21.9V23h6V22z"/><path d="M21 19h0.8c0.6 0 1-0.1 1.3 0.2 0.3 0.3 0.4 0.6 0.4 1.1 0 0.5-0.1 0.8-0.4 1.1 -0.3 0.3-0.6 0.4-1.1 0.4 -0.5 0-0.8-0.3-1.1-0.5C20.6 20.9 20.5 21 20.5 20h-1.5c0 1 0.3 1.6 0.8 2.1s1.3 0.8 2.1 0.8c0.9 0 1.6-0.2 2.2-0.7 0.6-0.5 0.8-1.2 0.8-2.1 0-0.5-0.1-1-0.4-1.4 -0.3-0.4-0.6-0.7-1.1-0.9 0.4-0.2 0.7-0.5 1-0.9 0.3-0.4 0.4-0.8 0.4-1.2 0-0.9-0.3-1.5-0.8-2 -0.5-0.5-1.2-0.7-2.1-0.7 -0.5 0-1 0.1-1.5 0.3 -0.4 0.2-0.8 0.7-1 1.1S19.1 15 19.1 16h1.5c0-1 0.1-0.9 0.4-1.1 0.3-0.3 0.6-0.5 1-0.5 0.5 0 0.8 0.1 1 0.3s0.3 0.6 0.3 1.1c0 0.5-0.1 0.7-0.4 1C22.7 17 22.3 17 21.9 17H21V19z"/><path d="M47.8 7C50.1 7 52 8.9 52 11.2c0 1-0.3 1.8-0.8 2.5l-1.7 1.7L43.6 9.5l1.7-1.7C46 7.3 46.8 7 47.8 7zM30.7 22.4L29 30l7.6-1.7 11.6-11.6 -5.9-5.9L30.7 22.4zM42 17.9l-5.1 5.1 -0.9-0.9 5.1-5L42 17.9z"/></svg>',
  options: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M19.8 34.5h-3.5c-0.5 0-0.7 0-2.5-4.5l-1.4-0.6c-3.7 1.7-4.2 1.7-4.3 1.7H7.9l-0.2-0.2 -2.5-2.5c-0.4-0.4-0.5-0.5 1.4-5l-0.6-1.4c-4.5-1.7-4.5-1.8-4.5-2.4v-3.5c0-0.5 0-0.7 4.5-2.5l0.6-1.4C4.5 8.1 4.7 8 5.1 7.6l2.6-2.6 0.3 0c0.4 0 1.9 0.6 4.4 1.6l1.4-0.6c1.7-4.5 1.9-4.5 2.4-4.5h3.5c0.5 0 0.7 0 2.5 4.5l1.4 0.6c3.7-1.7 4.2-1.7 4.3-1.7h0.3l0.2 0.2 2.5 2.5c0.4 0.4 0.5 0.5-1.4 5l0.6 1.4c4.5 1.6 4.5 1.8 4.5 2.4v3.5c0 0.5 0 0.7-4.5 2.5l-0.6 1.4c2 4.4 1.9 4.5 1.5 4.9l-2.7 2.7 -0.3 0c-0.4 0-1.9-0.6-4.4-1.6l-1.4 0.6C20.5 34.5 20.3 34.5 19.8 34.5zM16.7 33.1h2.7c0.3-0.7 1-2.4 1.5-3.9l0.1-0.3 2.5-1 0.3 0.1c1.5 0.6 3.2 1.4 3.9 1.6l1.9-1.9c-0.2-0.7-1-2.4-1.7-3.8l-0.1-0.3 1-2.5 0.3-0.1c1.5-0.6 3.2-1.3 3.9-1.6v-2.7c-0.7-0.3-2.4-1-3.9-1.5l-0.3-0.1 -1-2.5 0.1-0.3c0.6-1.5 1.3-3.2 1.6-3.9l-1.9-1.9c-0.6 0.2-2.4 1-3.8 1.7l-0.3 0.1L21.1 7.1l-0.1-0.3c-0.6-1.5-1.3-3.2-1.7-3.9h-2.7c-0.3 0.7-1 2.4-1.5 3.9l-0.1 0.3 -2.5 1 -0.3-0.1c-1.5-0.6-3.2-1.4-3.9-1.6l-1.9 1.9c0.2 0.7 1 2.4 1.6 3.8l0.1 0.3 -1 2.5 -0.3 0.1c-1.5 0.6-3.2 1.3-3.9 1.6v2.7c0.7 0.3 2.4 1 3.9 1.5l0.3 0.1 1 2.5 -0.1 0.3c-0.6 1.5-1.3 3.2-1.6 3.9l1.9 1.9c0.6-0.2 2.4-1 3.8-1.7l0.3-0.1 2.5 1 0.1 0.3C15.6 30.7 16.4 32.4 16.7 33.1zM18 23.8c-3.2 0-5.8-2.6-5.8-5.8 0-3.2 2.6-5.8 5.8-5.8 3.2 0 5.8 2.6 5.8 5.8C23.8 21.2 21.2 23.8 18 23.8z"/></svg>',
  fields: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><style>.a{fill:none;}</style><path d="M2 25.2v-3.4l2.5-0.4c0.2-0.7 0.5-1.4 0.9-2.1l-1.4-2 2.4-2.4 2 1.4c0.7-0.4 1.4-0.7 2.1-0.9L10.8 13h3.4l0.4 2.5c0.7 0.2 1.4 0.5 2.1 0.9l2-1.4 2.4 2.4 -1.4 2c0.4 0.7 0.7 1.4 0.9 2.1L23 21.8v3.4l-2.5 0.4c-0.2 0.7-0.5 1.4-0.9 2.1l1.4 2 -2.4 2.4 -2-1.5c-0.7 0.4-1.4 0.7-2.1 0.9L14.2 34h-3.4l-0.4-2.5c-0.7-0.2-1.4-0.5-2.1-0.9l-2 1.5 -2.4-2.4 1.4-2c-0.4-0.7-0.7-1.4-0.9-2.1L2 25.2zM12.5 27c1.9 0 3.5-1.6 3.5-3.5 0-1.9-1.6-3.5-3.5-3.5S9 21.6 9 23.5C9 25.4 10.6 27 12.5 27z"/><polygon points="24 18.9 24 12 17.3 12 24 18.9 " class="a"/><polygon points="32 27 32 20 25 20 25 24 25 27 32 27 " class="a"/><polygon points="16 4 9 4 9 11 12.5 11 16 11 16 4 " class="a"/><polygon points="17 11 24 11 24 4 17 4 17 11 " class="a"/><polygon points="25 19 32 19 32 12 25 12 25 19 " class="a"/><polygon points="25 11 32 11 32 4 25 4 25 11 " class="a"/><path d="M33 3H8v8.9L11 11H9V4h7v7h-2l3.3 1H24v6.9L25 22v-2h7v7h-7v-2l-1 3h9V3zM24 11h-7V4h7V11L24 11zM32 19h-7v-7h7V19L32 19zM32 11h-7V4h7V11L32 11z"/></svg>',
  fullscreen: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><polygon points="31 13 31 5 23 5 23 6 29.3 6 22.3 13 13.7 13 6.7 6 13 6 13 5 5 5 5 13 6 13 6 6.7 13 13.7 13 22.3 6 29.3 6 23 5 23 5 31 13 31 13 30 6.7 30 13.7 23 22.3 23 29.3 30 23 30 23 31 31 31 31 23 30 23 30 29.3 23 22.3 23 13.7 30 6.7 30 13 "/></svg>',
  minimize: '<svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" enable-background="new -0.5 0.5 36 36" version="1.1" viewBox="-0.5 0.5 36 36" xml:space="preserve"><polygon points="10.796 12.499 4.5 12.5 4.5 13.5 12.496 13.5 12.5 5.5 11.5 5.5 11.497 11.799 4.628 4.924 3.925 5.622"/><rect x="12.5" y="13.5" width="10" height="10"/><line x1="13" x2="13" y1="13.7" y2="13.7"/><line x1="13.7" x2="13.7" y1="13" y2="13"/><polygon points="11.492 25.2 11.5 31.497 12.5 31.496 12.491 23.5 4.491 23.506 4.492 24.506 10.791 24.501 3.924 31.378 4.623 32.08"/><polygon points="24.2 24.506 30.497 24.5 30.496 23.5 22.5 23.506 22.502 31.506 23.502 31.505 23.5 25.206 30.373 32.076 31.076 31.378"/><polygon points="23.506 11.8 23.5 5.503 22.5 5.504 22.506 13.5 30.506 13.498 30.505 12.498 24.206 12.5 31.076 5.627 30.378 4.924"/></svg>'
};
FlexmonsterToolbar.prototype.connectLocalCSVHandler = function () {
  this.pivot.connectTo({
    type: "csv",
    browseForFile: !0
  });
};
FlexmonsterToolbar.prototype.connectLocalJSONHandler = function () {
  this.pivot.connectTo({
    type: "json",
    browseForFile: !0
  });
};
FlexmonsterToolbar.prototype.connectRemoteCSV = function () {
  this.showConnectToRemoteCSVDialog();
};
FlexmonsterToolbar.prototype.connectRemoteJSON = function () {
  this.showConnectToRemoteJsonDialog();
};
FlexmonsterToolbar.prototype.connectOLAP = function () {
  this.showConnectToOLAPDialog();
};
FlexmonsterToolbar.prototype.connectElastic = function () {
  this.showConnectToElasticDialog();
};
FlexmonsterToolbar.prototype.openLocalReport = function () {
  this.pivot.open();
};
FlexmonsterToolbar.prototype.openRemoteReport = function () {
  this.showOpenRemoteReportDialog();
};
FlexmonsterToolbar.prototype.saveHandler = function () {
  this.pivot.save("report.json", "file");
};
FlexmonsterToolbar.prototype.gridHandler = function () {
  this.pivot.showGrid();
};
FlexmonsterToolbar.prototype.chartsHandler = function (a) {
  var b = ((this.pivot.getOptions() || {}).chart || {}).multipleMeasures,
    c = this.getElementById("fm-tab-charts-multiple");
  null != c && this.disableMultipleValues(a, b, c);
  this.pivot.showCharts(a, b);
};
FlexmonsterToolbar.prototype.chartsMultipleHandler = function () {
  var a = (this.pivot.getOptions() || {}).chart || {},
    b = a.type;
  a = !a.multipleMeasures;
  var c = this.getElementById("fm-tab-charts-multiple");
  a ? this.addClass(c, "fm-selected") : this.removeClass(c, "fm-selected");
  "pie" == b || "stacked_column" == b || "column_line" == b ? this.removeClass(c, "fm-selected") : this.pivot.showCharts(b, a);
};
FlexmonsterToolbar.prototype.checkChartMultipleMeasures = function () {
  var a = (this.pivot.getOptions() || {}).chart || {},
    b = a.multipleMeasures,
    c = this.getElementById("fm-tab-charts-multiple");
  null != c && this.disableMultipleValues(a.type, b, c);
};
FlexmonsterToolbar.prototype.disableMultipleValues = function (a, b, c) {
  var d = this.Labels;
  if ("pie" == a || "stacked_column" == a || "column_line" == a) {
    b = "";
    switch (a) {
      case "pie":
        b = d.charts_pie;
        break;
      case "stacked_column":
        b = d.charts_stacked_column;
        break;
      case "column_line":
        b = d.charts_column_line;
    }
    c.classList.remove("fm-selected");
    c.classList.add("fm-ui-disabled");
    c.setAttribute("aria-checked", "false");
    c.setAttribute("aria-disavled", "true");
    c.setAttribute("title", d.charts_multiple_disabled + b.toLocaleLowerCase() + " " + d.charts.toLocaleLowerCase());
  } else b ? (c.classList.add("fm-selected"), c.classList.remove("fm-ui-disabled"), c.removeAttribute("title"), c.setAttribute("aria-checked", "true")) : (c.classList.remove("fm-ui-disabled"), c.removeAttribute("title"), c.setAttribute("aria-checked", "false"));
};
FlexmonsterToolbar.prototype.formatCellsHandler = function (a, b) {
  this.showFormatCellsDialog(a, b);
};
FlexmonsterToolbar.prototype.conditionalFormattingHandler = function (a) {
  this.showConditionalFormattingDialog(a);
};
FlexmonsterToolbar.prototype.optionsHandler = function () {
  this.showOptionsDialog();
};
FlexmonsterToolbar.prototype.fieldsHandler = function () {
  this.pivot.openFieldsList();
};
FlexmonsterToolbar.prototype.printHandler = function () {
  this.pivot.print();
};
FlexmonsterToolbar.prototype.exportHandler = function (a) {
  "pdf" == a ? this.showExportPdfDialog() : this.pivot.exportTo(a);
};
FlexmonsterToolbar.prototype.shareReportHandler = function () {
  this.pivot.shareReport();
};
FlexmonsterToolbar.prototype.fullscreenHandler = function () {
  this.toggleFullscreen();
};
FlexmonsterToolbar.prototype.defaults = {};
FlexmonsterToolbar.prototype.showConnectToRemoteCSVDialog = function () {
  var a = this,
    b = this.Labels,
    c = this.popupManager.createPopup();
  c.content.classList.add("fm-popup-w500");
  c.setTitle(b.open_remote_csv);
  c.setToolbar([{
    id: "fm-btn-open",
    label: b.open,
    handler: function () {
      0 < d.value.length && a.pivot.connectTo({
        filename: d.value,
        type: "csv"
      });
    },
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: b.cancel
  }]);
  b = document.createElement("div");
  var d = document.createElement("input");
  d.classList.add("fm-inp-file-url");
  d.type = "text";
  d.value = "https://cdn.flexmonster.com/data/data.csv";
  d.setAttribute("aria-label", "URL");
  b.appendChild(d);
  c.setContent(b);
  c.initialFocusAt = d;
  this.popupManager.addPopup(c);
};
FlexmonsterToolbar.prototype.showConnectToRemoteJsonDialog = function () {
  var a = this,
    b = this.Labels,
    c = this.popupManager.createPopup();
  c.content.classList.add("fm-popup-w500");
  c.setTitle(b.open_remote_json);
  c.setToolbar([{
    id: "fm-btn-open",
    label: b.open,
    handler: function () {
      0 < d.value.length && a.pivot.connectTo({
        filename: d.value,
        type: "json"
      });
    },
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: b.cancel
  }]);
  b = document.createElement("div");
  var d = document.createElement("input");
  d.classList.add("fm-inp-file-url");
  d.type = "text";
  d.value = "https://cdn.flexmonster.com/data/data.json";
  d.setAttribute("aria-label", "URL");
  b.appendChild(d);
  c.setContent(b);
  c.initialFocusAt = d;
  this.popupManager.addPopup(c);
};
FlexmonsterToolbar.prototype.showConnectToElasticDialog = function () {
  var a = this,
    b = this.Labels,
    c = function (f, r) {
      f ? a.popupManager.removePopup() : (r = r.filter(function (u) {
        return 0 != u.indexOf("z_test_");
      }), h.setDataProvider(r), h.setEnabled(!0));
    },
    d = this.popupManager.createPopup();
  d.content.classList.add("fm-popup-olap");
  d.content.classList.add("fm-popup-w570");
  d.setTitle(b.connect_elastic_title);
  d.setToolbar([{
    id: "fm-btn-open",
    label: b.ok,
    handler: function () {
      a.pivot.connectTo({
        type: "elasticsearch",
        host: g.value,
        index: h.getValue()
      });
    },
    disabled: !0,
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: b.cancel
  }]);
  var l = document.createElement("div"),
    k = document.createElement("div");
  k.classList.add("fm-inp-group");
  l.appendChild(k);
  var e = document.createElement("div");
  e.classList.add("fm-inp-row");
  e.classList.add("fm-ir-horizontal");
  k.appendChild(e);
  var g = document.createElement("input");
  g.type = "text";
  g.classList.add("fm-inp");
  g.classList.add("fm-inp-proxy-url");
  g.id = this.guid();
  g.value = "https://olap.flexmonster.com:9200";
  var q = document.createElement("label");
  q.setAttribute("for", g.id);
  this.setText(q, b.host_url);
  var m = document.createElement("button");
  m.setAttribute("type", "button");
  m.classList.add("fm-ui-btn");
  m.classList.add("fm-ui-btn-dark");
  m.classList.add("fm-btn-connect");
  this.setText(m, b.connect);
  m.onclick = function () {
    0 != g.value.length && a.pivot.getElasticIndices({
      host: g.value
    }, c);
  };
  e.appendChild(q);
  e.appendChild(g);
  e.appendChild(m);
  e = document.createElement("div");
  e.classList.add("fm-inp-row");
  e.classList.add("fm-ir-horizontal");
  k.appendChild(e);
  var h = this.createSelect([], b.select_index);
  h.onchange = function () {
    a.setEnabled(a.getElementById("fm-btn-open"), !0);
  };
  h.setEnabled(!1);
  q = document.createElement("label");
  q.id = this.guid();
  h.dropdownButton.setAttribute("aria-labelledby", q.id);
  this.setText(q, b.index_name);
  e.appendChild(q);
  e.appendChild(h);
  d.setContent(l);
  d.initialFocusAt = g;
  this.popupManager.addPopup(d);
};
FlexmonsterToolbar.prototype.showConnectToOLAPDialog = function () {
  var a = this,
    b = this.Labels,
    c = this,
    d = function (t) {
      null != t && 0 < t.length ? (u.setDataProvider(t), u.setEnabled(!0)) : 0 == t.length && c.popupManager.removePopup();
    },
    l = function (t) {
      null != t && 0 < t.length && (w.setDataProvider(t), w.setEnabled(!0));
    },
    k = function (t) {
      null != t && 0 < t.length && (y.setDataProvider(t), y.setEnabled(!0));
    },
    e = this.popupManager.createPopup();
  e.content.classList.add("fm-popup-olap");
  e.content.classList.add("fm-popup-w570");
  e.setTitle(this.osUtils.isMobile ? b.connect_olap_mobile : b.olap_connection_tool);
  e.setToolbar([{
    id: "fm-btn-open",
    label: b.ok,
    handler: function () {
      var t = a.pivot.getXMLAProviderName(h.value, "");
      a.pivot.connectTo({
        type: t,
        proxyUrl: h.value,
        dataSourceInfo: u.getValue(),
        catalog: w.getValue(),
        cube: y.getValue()
      });
    },
    disabled: !0,
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: b.cancel
  }]);
  var g = document.createElement("div"),
    q = document.createElement("div");
  q.classList.add("fm-inp-group");
  g.appendChild(q);
  var m = document.createElement("div");
  m.classList.add("fm-inp-row");
  m.classList.add("fm-ir-horizontal");
  q.appendChild(m);
  var h = document.createElement("input");
  h.type = "text";
  h.id = this.guid();
  h.classList.add("fm-inp");
  h.classList.add("fm-inp-proxy-url");
  h.value = "https://olap.flexmonster.com/olap/msmdpump.dll";
  var f = document.createElement("label");
  f.setAttribute("for", h.id);
  this.setText(f, b.proxy_url);
  var r = document.createElement("button");
  r.setAttribute("type", "button");
  r.classList.add("fm-ui-btn");
  r.classList.add("fm-ui-btn-dark");
  r.classList.add("fm-btn-connect");
  this.setText(r, b.connect);
  r.onclick = function () {
    0 != h.value.length && a.pivot.getXMLADataSources(h.value, d);
  };
  m.appendChild(f);
  m.appendChild(h);
  m.appendChild(r);
  m = document.createElement("div");
  m.classList.add("fm-inp-row");
  m.classList.add("fm-ir-horizontal");
  q.appendChild(m);
  var u = this.createSelect([], b.select_data_source);
  u.setEnabled(!1);
  u.onchange = function () {
    a.pivot.getXMLACatalogs(h.value, u.getValue(), l);
  };
  f = document.createElement("label");
  f.id = this.guid();
  u.dropdownButton.setAttribute("aria-labelledby", f.id);
  this.setText(f, b.data_source_info);
  m.appendChild(f);
  m.appendChild(u);
  m = document.createElement("div");
  m.classList.add("fm-inp-row");
  m.classList.add("fm-ir-horizontal");
  q.appendChild(m);
  var w = this.createSelect([], b.select_catalog);
  w.setEnabled(!1);
  w.onchange = function () {
    a.pivot.getXMLACubes(h.value, u.getValue(), w.getValue(), k);
  };
  f = document.createElement("label");
  f.id = this.guid();
  w.dropdownButton.setAttribute("aria-labelledby", f.id);
  this.setText(f, b.catalog);
  m.appendChild(f);
  m.appendChild(w);
  m = document.createElement("div");
  m.classList.add("fm-inp-row");
  m.classList.add("fm-ir-horizontal");
  q.appendChild(m);
  var y = this.createSelect([], b.select_cube);
  y.setEnabled(!1);
  y.onchange = function () {
    a.setEnabled(a.getElementById("fm-btn-open"), !0);
  };
  f = document.createElement("label");
  f.id = this.guid();
  y.dropdownButton.setAttribute("aria-labelledby", f.id);
  this.setText(f, b.cube);
  m.appendChild(f);
  m.appendChild(y);
  e.setContent(g);
  e.initialFocusAt = h;
  this.popupManager.addPopup(e);
};
FlexmonsterToolbar.prototype.showOpenRemoteReportDialog = function () {
  var a = this,
    b = this.Labels,
    c = this.popupManager.createPopup();
  c.content.classList.add("fm-popup-w500");
  c.setTitle(b.open_remote_report);
  c.setToolbar([{
    id: "fm-btn-open",
    label: b.open,
    handler: function () {
      0 < d.value.length && a.pivot.load(d.value);
    },
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: b.cancel
  }]);
  b = document.createElement("div");
  var d = document.createElement("input");
  d.type = "text";
  d.setAttribute("aria-label", "URL");
  var l = a.pivot.getOptions() || {};
  d.value = l.grid && "flat" == l.grid.type ? "https://cdn.flexmonster.com/reports/report-flat.json" : "https://cdn.flexmonster.com/reports/report.json";
  b.appendChild(d);
  c.setContent(b);
  c.initialFocusAt = d;
  this.popupManager.addPopup(c);
};
FlexmonsterToolbar.prototype.defaults.numberFormatting = {
  textAligns: [{
    label: "align_left",
    value: "left"
  }, {
    label: "align_right",
    value: "right"
  }, {
    label: "align_center",
    value: "center"
  }],
  thousandsSeparators: [{
    label: "none",
    value: ""
  }, {
    label: "space",
    value: " "
  }, {
    label: ",",
    value: ","
  }, {
    label: ".",
    value: "."
  }],
  decimalSeparators: [{
    label: ",",
    value: ","
  }, {
    label: ".",
    value: "."
  }],
  decimalPlaces: [{
    label: "none",
    value: -1
  }, {
    label: "0",
    value: 0
  }, {
    label: "1",
    value: 1
  }, {
    label: "2",
    value: 2
  }, {
    label: "3",
    value: 3
  }, {
    label: "4",
    value: 4
  }, {
    label: "5",
    value: 5
  }, {
    label: "6",
    value: 6
  }, {
    label: "7",
    value: 7
  }, {
    label: "8",
    value: 8
  }, {
    label: "9",
    value: 9
  }],
  positiveCurrencyFormats: [{
    label: "$1",
    value: "$1"
  }, {
    label: "1$",
    value: "1$"
  }],
  negativeCurrencyFormats: [{
    label: "-$1",
    value: "-$1"
  }, {
    label: "-1$",
    value: "-1$"
  }, {
    label: "$-1",
    value: "$-1"
  }, {
    label: "$1-",
    value: "$1-"
  }, {
    label: "1-$",
    value: "1-$"
  }, {
    label: "1$-",
    value: "1$-"
  }, {
    label: "($1)",
    value: "($1)"
  }, {
    label: "(1$)",
    value: "(1$)"
  }, {
    label: "$(1)",
    value: "$(1)"
  }, {
    label: "(1)$",
    value: "(1)$"
  }],
  negativeNumberFormats: [{
    label: "-1",
    value: "-1"
  }, {
    label: "- 1",
    value: "- 1"
  }, {
    label: "1-",
    value: "1-"
  }, {
    label: "1 -",
    value: "1 -"
  }, {
    label: "(1)",
    value: "(1)"
  }],
  isPercent: [{
    label: "true_value",
    value: !0
  }, {
    label: "false_value",
    value: !1
  }]
};
FlexmonsterToolbar.prototype.ConfirmationPopUp = function () {};
FlexmonsterToolbar.prototype.showFormatCellsDialog = function (a, b) {
  function c(p, B) {
    B = B.replace(/\$/g, "$$$$");
    return p.map(function (G) {
      return {
        label: G.label.replace(/\$/g, B),
        value: G.value
      };
    });
  }
  function d(p) {
    q.textAlign != D.getValue() && (p.textAlign = D.getValue());
    q.thousandsSeparator != z.getValue() && (p.thousandsSeparator = z.getValue());
    q.decimalSeparator != K.getValue() && (p.decimalSeparator = K.getValue());
    q.decimalPlaces != F.getValue() && (p.decimalPlaces = F.getValue());
    q.currencySymbol != H.value && (p.currencySymbol = H.value);
    q.positiveCurrencyFormat != I.getValue() && "" != I.getValue() && (p.positiveCurrencyFormat = I.getValue());
    q.negativeCurrencyFormat != J.getValue() && "" != J.getValue() && (p.negativeCurrencyFormat = J.getValue());
    q.negativeNumberFormat != R.getValue() && "" != R.getValue() && (p.negativeNumberFormat = R.getValue());
    q.nullValue != Q.value && (p.nullValue = Q.value);
    q.isPercent != T.getValue() && (p.isPercent = T.getValue());
    return p;
  }
  function l() {}
  function k(p) {
    return p.map(function (B) {
      return {
        label: void 0 !== g[B.label] ? g[B.label] : B.label,
        value: B.value
      };
    });
  }
  var e = this,
    g = this.Labels,
    q = void 0;
  l.prototype.createPopUp = function () {
    null == this.dialog && (this.dialog = e.popupManager.createPopup(this), this.dialog.content.style.zIndex = 152);
  };
  l.prototype.addPopUp = function () {
    var p = this.dialog.content;
    this.modalOverlay = this.createModalOverlay();
    e.toolbarWrapper.appendChild(p);
    e.toolbarWrapper.appendChild(this.modalOverlay);
    e.popupManager.addLayoutClasses(p);
    e.popupManager.centerPopup(p);
    var B = this;
    p.resizeHandler = function () {
      p && (B.addLayoutClasses(p), B.centerPopup(p));
    };
    window.addEventListener("resize", p.resizeHandler);
  };
  l.prototype.initializePopUp = function () {
    this.dialog.setTitle(g.confirm_title);
    w.dialog.setToolbar([{
      id: "fm-btn-apply",
      label: g.ok,
      handler: f,
      isPositive: !0
    }, {
      id: "fm-btn-cancel",
      label: g.cancel,
      handler: h
    }], !1, this.removePopUp);
    var p = document.createElement("div"),
      B = document.createElement("label");
    B.innerHTML = g.confirm_message;
    B.style.fontSize = "14px";
    p.appendChild(B);
    this.dialog.setContent(p);
  };
  l.prototype.removePopUp = function (p) {
    p = p || w.dialog.content;
    null != w.modalOverlay && (e.toolbarWrapper.removeChild(w.modalOverlay), w.modalOverlay = null);
    null != p && (e.toolbarWrapper.removeChild(p), w.dialog = null, window.removeEventListener("resize", p.resizeHandler));
  };
  l.prototype.createModalOverlay = function () {
    var p = document.createElement("div");
    p.style.zIndex = 151;
    p.classList.add("fm-modal-overlay");
    p.classList.add("fm-popup-confirm-modal-overlay");
    var B = this;
    p.addEventListener("click", function (G) {
      B.removePopUp(B.dialog.content);
      h();
    });
    return p;
  };
  var m = void 0,
    h = function () {
      A.setValue(m);
    },
    f = function () {
      var p = null != A.getValue();
      D.setEnabled(p);
      z.setEnabled(p);
      K.setEnabled(p);
      F.setEnabled(p);
      I.setEnabled(p);
      J.setEnabled(p);
      R.setEnabled(p);
      T.setEnabled(p);
      e.setEnabled(H, p);
      e.setEnabled(Q, p);
      q = p = (p = (m = A.getValue()) ? m[0].split("_@@_@@_@@_", 2) : null) ? e.pivot.getFormat(p[0], p[1]) : e.pivot.getFormat(null);
      if ("flat" === e.pivot.getOptions({
        withDefaults: !0
      }).grid.type && m && 0 < m.length) {
        var B = e.pivot.getMeasures();
        for (var G = null, L = 0; L < B.length; L++) -1 !== m.indexOf(B[L].uniqueName) && (G = B[L]);
        B = null != G && "number" != G.type;
      } else B = !1;
      B ? (E.classList.add("fm-hide"), M.classList.add("fm-hide"), N.classList.add("fm-hide"), U.classList.add("fm-hide"), O.classList.add("fm-hide"), P.classList.add("fm-hide"), V.classList.add("fm-hide"), W.classList.add("fm-hide")) : (E.classList.remove("fm-hide"), M.classList.remove("fm-hide"), N.classList.remove("fm-hide"), U.classList.remove("fm-hide"), O.classList.remove("fm-hide"), P.classList.remove("fm-hide"), V.classList.remove("fm-hide"), W.classList.remove("fm-hide"));
      D.setValue(void 0 !== p.textAlign ? p.textAlign : "right");
      z.setValue(p.thousandsSeparator);
      K.setValue(p.decimalSeparator);
      F.setValue(p.decimalPlaces);
      H.value = p.currencySymbol;
      I.setDataProvider(c(e.defaults.numberFormatting.positiveCurrencyFormats, p.currencySymbol));
      I.setValue(p.positiveCurrencyFormat);
      J.setDataProvider(c(e.defaults.numberFormatting.negativeCurrencyFormats, p.currencySymbol));
      J.setValue(p.negativeCurrencyFormat);
      R.setValue(p.negativeNumberFormat);
      Q.value = p.nullValue;
      T.setValue(1 == p.isPercent ? !0 : !1);
      "" == p.currencySymbol || null == p.currencySymbol ? (O.classList.add("fm-hide"), P.classList.add("fm-hide"), S.classList.remove("fm-hide")) : (O.classList.remove("fm-hide"), P.classList.remove("fm-hide"), S.classList.add("fm-hide"));
    },
    r = function (p) {
      var B = p.availableAggregations.indexOf(p.aggregation);
      B = -1 === B || "none" === p.aggregation || p.calculated ? null : p.availableAggregationsCaptions[B];
      return null === B || e.singleAggregationFormatting ? p.name : p.name + " (" + B + ")";
    },
    u = this.popupManager.createPopup(),
    w = new l();
  u.content.classList.add("fm-popup-format-cells");
  u.setTitle(this.osUtils.isMobile ? g.format : g.format_cells);
  u.setToolbar([{
    id: "fm-btn-apply",
    label: g.apply,
    handler: function () {
      var p = "" != q.name || "" == A.getValue()[0] ? e.pivot.getReport() : {},
        B = void 0;
      if (p.hasOwnProperty("formats") && 0 < p.formats.length) for (var G = 0; G < p.formats.length; G++) if (q.name == p.formats[G].name) {
        B = p.formats[G];
        break;
      }
      void 0 === B && (B = {});
      "" === A.getValue()[0] && (B.name = "");
      B.name && "" !== B.name && delete B.name;
      d(B);
      q = void 0;
      p = A.getValue();
      for (G = 0; G < p.length; G++) {
        var L = p[G].split("_@@_@@_@@_", 2);
        e.pivot.setFormat(B, "" == L[0] ? null : L[0], e.singleAggregationFormatting ? void 0 : L[1]);
      }
      e.pivot.refresh();
    },
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: g.cancel
  }], !0);
  var y = document.createElement("div"),
    t = document.createElement("div");
  t.classList.add("fm-inp-group");
  y.appendChild(t);
  for (var C = [{
      value: "",
      label: g.default_value
    }], n = {}, x = e.pivot.getMeasures(), v = 0; v < x.length; v++) if (!n[x[v].uniqueName] || n[x[v].uniqueName] && !n[x[v].uniqueName][x[v].aggregation] && !this.singleAggregationFormatting) n[x[v].uniqueName] || (n[x[v].uniqueName] = {}), n[x[v].uniqueName][x[v].aggregation] = !0, C.push({
    value: x[v].uniqueName + "_@@_@@_@@_" + x[v].aggregation,
    label: r(x[v])
  });
  var A = this.createSelect(C, g.choose_value, !0);
  A.onchange = function () {
    var p = {};
    p = d(p);
    (p.hasOwnProperty("textAlign") || p.hasOwnProperty("thousandsSeparator") || p.hasOwnProperty("decimalSeparator") || p.hasOwnProperty("decimalPlaces") || p.hasOwnProperty("currencySymbol") || p.hasOwnProperty("positiveCurrencyFormat") || p.hasOwnProperty("negativeCurrencyFormat") || p.hasOwnProperty("nullValue") || p.hasOwnProperty("isPercent")) && m && 0 < m.length ? (w.createPopUp(), w.initializePopUp(), w.addPopUp()) : f();
  };
  a && b && A.setValue([a + "_@@_@@_@@_" + b]);
  a = this.createInputRow(g.choose_value, A);
  a.querySelector("label").classList.add("fm-uc");
  t.appendChild(a);
  t = document.createElement("div");
  t.classList.add("fm-inp-group");
  y.appendChild(t);
  var D = this.createSelect(k(this.defaults.numberFormatting.textAligns));
  t.appendChild(this.createInputRow(g.text_align, D));
  var z = this.createSelect(k(this.defaults.numberFormatting.thousandsSeparators)),
    E = this.createInputRow(g.thousands_separator, z);
  t.appendChild(E);
  var K = this.createSelect(k(this.defaults.numberFormatting.decimalSeparators)),
    M = this.createInputRow(g.decimal_separator, K);
  t.appendChild(M);
  var F = this.createSelect(k(this.defaults.numberFormatting.decimalPlaces)),
    N = this.createInputRow(g.decimal_places, F);
  t.appendChild(N);
  var H = document.createElement("input");
  H.classList.add("fm-inp");
  H.type = "text";
  var U = this.createInputRow(g.currency_symbol, H);
  t.appendChild(U);
  var I = this.createSelect(),
    O = this.createInputRow(g.positive_currency_format, I);
  O.classList.add("fm-popup-format-cells-positive-currency");
  t.appendChild(O);
  var J = this.createSelect(),
    P = this.createInputRow(g.negative_currency_format, J);
  P.classList.add("fm-popup-format-cells-negative-currency");
  t.appendChild(P);
  var R = this.createSelect(k(this.defaults.numberFormatting.negativeNumberFormats)),
    S = this.createInputRow(g.negative_number_format, R);
  S.classList.add("fm-popup-format-cells-negative-number");
  t.appendChild(S);
  H.addEventListener("input", function (p) {
    p = H.value;
    if (p.trim()) {
      O.classList.remove("fm-hide");
      P.classList.remove("fm-hide");
      S.classList.add("fm-hide");
      var B = I.getValue();
      I.setDataProvider(c(e.defaults.numberFormatting.positiveCurrencyFormats, p));
      I.setValue(B);
      B = J.getValue();
      J.setDataProvider(c(e.defaults.numberFormatting.negativeCurrencyFormats, p));
      J.setValue(B);
    } else O.classList.add("fm-hide"), P.classList.add("fm-hide"), S.classList.remove("fm-hide");
  });
  var Q = document.createElement("input");
  Q.classList.add("fm-inp");
  Q.type = "text";
  var V = this.createInputRow(g.null_value, Q);
  t.appendChild(V);
  var T = this.createSelect(k(this.defaults.numberFormatting.isPercent)),
    W = this.createInputRow(g.is_percent, T);
  t.appendChild(W);
  u.setContent(y);
  u.initialFocusAt = A.dropdownButton;
  this.popupManager.addPopup(u);
  f();
};
FlexmonsterToolbar.prototype.showConditionalFormattingDialog = function (a) {
  var b = this;
  a = this.Labels;
  var c = this.pivot.getAllConditions(),
    d = this.pivot.getReport().dataSource.type,
    l = "microsoft analysis services" === d || "mondrian" === d,
    k = b.pivot.getAllMeasures(),
    e = b.pivot.getMeasures(),
    g = {},
    q = [],
    m = {},
    h = [],
    f = function (t) {
      return t.uniqueName + "_@@_@@_@@_" + t.aggregation;
    };
  for (d = 0; d < c.length; d++) g[c[d].measure] = 1;
  for (d = 0; d < k.length; d++) {
    var r = l ? k[d].uniqueName : f(k[d]);
    1 === g[k[d].uniqueName] && void 0 === m[r] && (m[r] = 1, q.push(k[d].uniqueName), h.push(k[d]));
  }
  for (d = 0; d < e.length; d++) if (r = l ? e[d].uniqueName : f(e[d]), ("number" === e[d].type || "float" === e[d].type || "long" === e[d].type) && void 0 === m[r] || void 0 === e[d].type && void 0 === m[r]) m[r] = 1, h.push(e[d]);
  m = q = g = e = k = void 0;
  d = function () {
    var t = {
      sign: "<",
      value1: "0",
      measures: h,
      format: {
        fontFamily: "Arial",
        fontSize: "12px",
        color: "#000000",
        backgroundColor: "#FFFFFF"
      }
    };
    c.unshift(t);
    t = b.createConditionalFormattingItem(t, c, l);
    w.insertBefore(t, w.firstChild);
    t.focus();
    w.scrollTop = 0;
    0 < c.length && (y.style.display = "none");
    b.popupManager.centerPopup(u.content);
  };
  k = function (t) {
    for (var C = [], n = !1, x = "", v = 0; v < t.length; v++) '"' == t[v] || "'" == t[v] ? (n ? C.push(x) : x = "", n = !n) : n && (x += t[v]);
    n = t.match(/\W\d+\.*\d*/g);
    if (n) {
      x = [];
      for (v = 0; v < n.length; v++) isNaN(Number(n[v])) || x.push(n[v]);
      n = x;
    }
    t = t.match(/<=|>=|<|>|=|=|!=|isNaN/g);
    return null == n && null == C ? {} : {
      value1: null != n ? n[0].replace(/\s/, "") : C[0],
      value2: null != n && 1 < n.length ? n[1].replace(/\s/, "") : "",
      sign: t ? t.join("") : ""
    };
  };
  var u = this.popupManager.createPopup();
  u.content.classList.add("fm-popup-conditional");
  u.setTitle(this.osUtils.isMobile ? a.conditional : a.conditional_formatting);
  u.setToolbar([{
    id: "fm-btn-apply",
    label: a.apply,
    handler: function () {
      b.pivot.removeAllConditions();
      for (var t = 0; t < c.length; t++) {
        var C = c[t].sign;
        var n = c[t].value1,
          x = c[t].value2,
          v = "",
          A = null == x || 0 == x.length,
          D = "><" === C,
          z = "isNaN" === C;
        (null == n || 0 == n.length) && !z || D && A || (D && !A ? v = "AND(#value > " + n + ", #value < " + x + ")" : z ? v = "isNaN(#value)" : (isNaN(parseFloat(n)) && (n = "'" + n + "'"), v = "#value " + C + " " + n));
        C = v;
        if (null == C) return;
        c[t].formula = C;
        b.pivot.addCondition(c[t]);
      }
      b.pivot.refresh();
    },
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: a.cancel
  }], !0);
  e = document.createElement("button");
  e.setAttribute("type", "button");
  e.classList.add("fm-ui-btn");
  e.classList.add("fm-ui-btn-light");
  e.classList.add("fm-button-add");
  e.onclick = d;
  e.setAttribute("title", a.tooltips.add_condition);
  g = document.createElement("span");
  g.classList.add("fm-icon");
  g.classList.add("fm-icon-act_add");
  e.appendChild(g);
  u.toolbar.insertBefore(e, u.toolbar.firstChild);
  var w = document.createElement("div");
  w.classList.add("fm-popup-content");
  w.onclick = function (t) {
    t.target.classList.contains("fm-cr-delete") && (0 == c.length && (y.style.display = "block"), b.popupManager.centerPopup(u.content));
  };
  var y = document.createElement("div");
  y.classList.add("fm-popup-placeholder");
  w.appendChild(y);
  g = document.createElement("div");
  g.classList.add("fm-popup-placeholder-text");
  b.setText(g, a.no_active_conditions);
  y.appendChild(g);
  q = document.createElement("button");
  q.setAttribute("href", "javascript:void(0)");
  q.setAttribute("type", "button");
  q.classList.add("fm-ui-btn");
  q.classList.add("fm-ui-btn-light");
  q.classList.add("fm-button-add-large");
  q.onclick = d;
  b.setText(q, a.add_condition_button);
  g = document.createElement("span");
  g.classList.add("fm-icon");
  g.classList.add("fm-icon-act_add");
  q.insertBefore(g, q.firstChild);
  y.appendChild(q);
  for (d = 0; d < c.length; d++) a = k(c[d].formula), c[d].value1 = a.value1, c[d].value2 = a.value2, c[d].sign = a.sign, c[d].measures = h, w.appendChild(b.createConditionalFormattingItem(c[d], c, l));
  0 < c.length && (y.style.display = "none");
  u.initialFocusAt = e;
  u.setContent(w);
  this.popupManager.addPopup(u);
};
FlexmonsterToolbar.prototype.defaults.fontSizes = "8px 9px 10px 11px 12px 13px 14px".split(" ");
FlexmonsterToolbar.prototype.defaults.fonts = "Arial;Lucida Sans Unicode;Verdana;Courier New;Palatino Linotype;Tahoma;Impact;Trebuchet MS;Georgia;Times New Roman".split(";");
FlexmonsterToolbar.prototype.defaults.conditions = [{
  label: "less_than",
  value: "<"
}, {
  label: "less_than_or_equal",
  value: "<="
}, {
  label: "greater_than",
  value: ">"
}, {
  label: "greater_than_or_equal",
  value: ">="
}, {
  label: "equal_to",
  value: "="
}, {
  label: "not_equal_to",
  value: "!="
}, {
  label: "between",
  value: "><"
}, {
  label: "is_empty",
  value: "isNaN"
}];
FlexmonsterToolbar.prototype.createConditionalFormattingItem = function (a, b, c) {
  function d(z, E, K) {
    var M = l.pivot.getOptions() || {},
      F = z.filter(function (H) {
        return H.uniqueName === E;
      }).pop();
    M = M.grid && "flat" == M.grid.type;
    var N = [{
      label: k.all_values,
      value: ""
    }];
    E && "" === K && F && !F.calculated && !c && (F = z.filter(function (H) {
      return H.uniqueName === E;
    }), N.push({
      label: 0 < F.length ? F[0].name + " (" + k.all + ")" : E + " (" + k.all + ")",
      value: E
    }));
    for (F = 0; F < z.length; F++) M && 7 == z[F].type || (N.push({
      label: g(z[F]),
      value: e(z[F].uniqueName, z[F].aggregation)
    }), E == "[Measures].[" + z[F].uniqueName + "]" && (E = z[F].uniqueName));
    w.setDataProvider(N);
    w.setValue(E && void 0 !== K ? e(E, K) : E ? E : N[0].value);
  }
  var l = this,
    k = this.Labels,
    e = function (z, E) {
      return c || "none" === E || "" === E ? z : z + "_@@_@@_@@_" + E;
    },
    g = function (z) {
      var E = z.availableAggregations.indexOf(z.aggregation);
      E = -1 === E || "none" === z.aggregation || z.calculated ? null : z.availableAggregationsCaptions[E];
      return null === E || c ? z.name : z.name + " (" + E + ")";
    },
    q = function () {
      "sign" in a && "><" === a.sign ? (t.classList.remove("fm-width120"), t.classList.add("fm-width50"), t.style.display = "inline-block", n.value = "value2" in a ? a.value2 : "0", n.style.display = "inline-block", C.style.display = "inline-block") : ("sign" in a && "isNaN" === a.sign ? t.style.display = "none" : (t.classList.add("fm-width120"), t.classList.remove("fm-width50"), t.style.display = "inline-block"), n.style.display = "none", C.style.display = "none");
    },
    m = function () {
      var z = a.format;
      null != z && (D.style.backgroundColor = z.backgroundColor || "#fff", D.style.color = z.color || "#000", D.style.fontFamily = z.fontFamily || "Arial", D.style.fontSize = z.fontSize || "12px");
    },
    h = document.createElement("div");
  h.classList.add("fm-condition-row");
  var f = document.createElement("div");
  h.appendChild(f);
  var r = document.createElement("div");
  r.classList.add("fm-cr-inner");
  f.appendChild(r);
  var u = document.createElement("div");
  u.classList.add("fm-cr-lbl");
  u.classList.add("fm-width50");
  l.setText(u, k.value + ":");
  r.appendChild(u);
  var w = this.createSelect();
  w.classList.add("fm-values");
  a.measures && 0 < a.measures.length ? d(a.measures, a.measure, a.aggregation) : w.setEnabled(!1);
  w.onchange = function () {
    var z = w.getValue().split("_@@_@@_@@_", 2);
    a.measure = z[0];
    a.aggregation = z[1];
  };
  w.setAttribute("title", k.value);
  w.dropdownButton.setAttribute("aria-label", k.value);
  r.appendChild(w);
  var y = this.createSelect(function (z) {
    return z.map(function (E) {
      return {
        label: void 0 !== k[E.label] ? k[E.label] : E.label,
        value: E.value
      };
    });
  }(this.defaults.conditions));
  y.classList.add("fm-conditions");
  y.setValue(a.sign);
  y.onchange = function () {
    a.sign = y.getValue();
    "sign" in a && "><" === a.sign ? a.value2 = 0 : ("sign" in a && "isNaN" === a.sign && delete a.value1, delete a.value2);
    q();
  };
  y.setAttribute("title", k.tooltips.condition);
  y.dropdownButton.setAttribute("aria-label", k.tooltips.condition);
  r.appendChild(y);
  var t = document.createElement("input");
  t.classList.add("fm-number-inp");
  t.classList.add("fm-width50");
  t.type = "number";
  t.value = "value1" in a ? a.value1 : "0";
  t.onchange = function () {
    a.value1 = 0 == t.value.length ? "0" : t.value;
  };
  r.appendChild(t);
  var C = document.createElement("span");
  C.classList.add("fm-and-label");
  C.classList.add("fm-width20");
  l.setText(C, k.and_symbole);
  r.appendChild(C);
  var n = document.createElement("input");
  n.classList.add("fm-number-inp");
  n.classList.add("fm-width50");
  n.type = "number";
  n.value = "value2" in a ? a.value2 : "0";
  n.onchange = function () {
    a.value2 = 0 == n.value.length ? "0" : n.value;
  };
  r.appendChild(n);
  q();
  r = document.createElement("div");
  r.classList.add("fm-cr-inner");
  f.appendChild(r);
  u = document.createElement("div");
  u.classList.add("fm-cr-lbl");
  u.classList.add("fm-width50");
  l.setText(u, k.format + ":");
  r.appendChild(u);
  var x = this.createSelect(this.defaults.fonts);
  x.classList.add("fm-font-family");
  x.setValue(a.hasOwnProperty("format") && a.format.hasOwnProperty("fontFamily") ? a.format.fontFamily : this.defaults.fonts[0]);
  x.onchange = function () {
    null != a.format && (a.format.fontFamily = x.getValue(), m());
  };
  x.setAttribute("title", k.tooltips.font);
  x.dropdownButton.setAttribute("aria-label", k.tooltips.font);
  r.appendChild(x);
  var v = this.createSelect(this.defaults.fontSizes);
  v.classList.add("fm-font-size");
  v.setValue(a.hasOwnProperty("format") && a.format.hasOwnProperty("fontSize") ? a.format.fontSize : "12px");
  v.onchange = function () {
    null != a.format && (a.format.fontSize = v.getValue(), m());
  };
  v.setAttribute("title", k.tooltips.font_size);
  v.dropdownButton.setAttribute("aria-label", k.tooltips.font_size);
  r.appendChild(v);
  var A = new FlexmonsterToolbar.ColorPicker(this, h);
  A.setColor(a.hasOwnProperty("format") && a.format.hasOwnProperty("backgroundColor") ? a.format.backgroundColor : "0xFFFFFF", "bg");
  A.setColor(a.hasOwnProperty("format") && a.format.hasOwnProperty("color") ? a.format.color : "0x000000", "font");
  A.changeHandler = function () {
    null != a.format && (D.style.color = A.fontColor || "#000", D.style.backgroundColor = A.backgroundColor || "#fff");
  };
  A.applyHandler = function () {
    null != a.format && (a.format.color = A.fontColor, a.format.backgroundColor = A.backgroundColor, m());
  };
  A.cancelHandler = function () {
    null != a.format && (A.setColor(a.format.hasOwnProperty("backgroundColor") ? a.format.backgroundColor : "0xFFFFFF", "bg"), A.setColor(a.format.hasOwnProperty("color") ? a.format.color : "0x000000", "font"));
    m();
  };
  r.appendChild(A.element);
  var D = document.createElement("input");
  D.setAttribute("tabindex", "-1");
  D.classList.add("fm-sample");
  D.classList.add("fm-inp");
  D.type = "number";
  D.value = "73.93";
  D.style.pointerEvents = "none";
  r.appendChild(D);
  m();
  r = document.createElement("div");
  r.style.position = "relative";
  f.appendChild(r);
  f = document.createElement("a");
  f.href = "javascript:void(0);";
  f.classList.add("fm-cr-delete");
  f.classList.add("fm-icon");
  f.classList.add("fm-icon-act_trash");
  f.onclick = function () {
    var z = b.indexOf(a);
    -1 < z && b.splice(z, 1);
    h.parentNode.removeChild(h);
  };
  f.setAttribute("title", k.tooltips.remove_condition);
  f.setAttribute("role", "button");
  r.appendChild(f);
  this.makeSelectableByKeyboard(f);
  return h;
};
FlexmonsterToolbar.prototype.showOptionsDialog = function () {
  var a = this,
    b = this.Labels,
    c = this.popupManager.createPopup();
  c.content.classList.add("fm-popup-options");
  c.setTitle(this.osUtils.isMobile ? b.options : b.layout_options);
  c.setToolbar([{
    id: "fm-btn-apply",
    label: b.apply,
    handler: function () {
      var r = a.pivot.getOptions(),
        u = r.viewType,
        w = r.grid.type;
      r = {
        grid: {
          showGrandTotals: g.getValue(),
          showTotals: f.getValue(),
          type: h.getValue()
        }
      };
      r.viewType = w != r.grid.type && "charts" == u ? "grid" : u;
      a.pivot.setOptions(r);
      a.pivot.refresh();
    },
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: b.cancel
  }], !0);
  var d = document.createElement("div");
  d.classList.add("fm-popup-content");
  var l = document.createElement("div");
  l.classList.add("fm-ui-row");
  d.appendChild(l);
  var k = document.createElement("div");
  k.classList.add("fm-ui-col-2");
  l.appendChild(k);
  var e = document.createElement("div");
  e.id = this.guid();
  e.classList.add("fm-title-2");
  a.setText(e, b.grand_totals);
  k.appendChild(e);
  var g = this.createRadioGroup([{
    label: b.grand_totals_off,
    value: "off"
  }, {
    label: b.grand_totals_on,
    value: "on"
  }, {
    label: b.grand_totals_on_rows,
    value: "rows"
  }, {
    label: b.grand_totals_on_columns,
    value: "columns"
  }]);
  g.setAttribute("aria-labelledby", e.id);
  k.appendChild(g);
  e = document.createElement("div");
  e.id = this.guid();
  e.classList.add("fm-title-2");
  a.setText(e, b.layout);
  k.appendChild(e);
  var q = [{
      label: b.compact_view,
      value: "compact"
    }, {
      label: b.classic_view,
      value: "classic"
    }],
    m = a.pivot.getReport({
      withDefaults: !0,
      withGlobals: !0
    });
  null != m && m.hasOwnProperty("dataSource") && "microsoft analysis services" != m.dataSource.type && "mondrian" != m.dataSource.type && "elasticsearch" != m.dataSource.type && q.push({
    label: b.flat_view,
    value: "flat"
  });
  var h = this.createRadioGroup(q);
  h.setAttribute("aria-labelledby", e.id);
  k.appendChild(h);
  k = document.createElement("div");
  k.classList.add("fm-ui-col-2");
  l.appendChild(k);
  e = document.createElement("div");
  e.id = this.guid();
  e.classList.add("fm-title-2");
  a.setText(e, b.subtotals);
  k.appendChild(e);
  var f = this.createRadioGroup([{
    label: b.subtotals_off,
    value: "off"
  }, {
    label: b.subtotals_on,
    value: "on"
  }, {
    label: b.subtotals_on_rows,
    value: "rows"
  }, {
    label: b.subtotals_on_columns,
    value: "columns"
  }]);
  h.setAttribute("aria-labelledby", e.id);
  k.appendChild(f);
  c.setContent(d);
  c.initialFocusAt = g.querySelector("li");
  this.popupManager.addPopup(c);
  m = a.pivot.getOptions() || {};
  b = m.grid || {};
  g.setValue(b.showGrandTotals || "on");
  f.setValue(b.showTotals || "on");
  h.setValue(b.type || "compact");
};
FlexmonsterToolbar.prototype.showExportPdfDialog = function () {
  var a = this,
    b = this.Labels,
    c = this.popupManager.createPopup();
  c.setTitle(b.choose_page_orientation);
  c.setToolbar([{
    id: "fm-btn-apply",
    label: b.apply,
    handler: function () {
      a.pivot.exportTo("pdf", {
        pageOrientation: l.getValue()
      });
    },
    isPositive: !0
  }, {
    id: "fm-btn-cancel",
    label: b.cancel
  }]);
  var d = document.createElement("div"),
    l = this.createRadioGroup([{
      label: b.portrait,
      value: "portrait",
      checked: !0
    }, {
      label: b.landscape,
      value: "landscape"
    }]);
  d.appendChild(l);
  c.setContent(d);
  c.initialFocusAt = l.querySelector("li");
  this.popupManager.addPopup(c);
};
FlexmonsterToolbar.prototype.toggleFullscreen = function () {
  this.isFullscreen() ? this.exitFullscreen() : this.enterFullscreen(this.container);
};
FlexmonsterToolbar.prototype.isFullscreen = function () {
  return void 0 != document.fullScreenElement || void 0 != document.mozFullScreenElement || void 0 != document.webkitFullscreenElement || void 0 != document.msFullscreenElement;
};
FlexmonsterToolbar.prototype.enterFullscreen = function (a) {
  if (a.requestFullscreen || a.webkitRequestFullScreen || a.mozRequestFullScreen || a.msRequestFullscreen && window == top) {
    var b = this;
    if (a.requestFullscreen) a.requestFullscreen().then(function () {
      var l = function () {
        if (b.isFullscreen()) b.onFullscreenEntered();else b.exitFullscreen(), a.removeEventListener("fullscreenchange", l);
      }.bind(b);
      a.addEventListener("fullscreenchange", l, !1);
    }).catch(function () {
      b.onFullscreenError();
    });else if (a.webkitRequestFullScreen) {
      var c = navigator.userAgent;
      -1 < c.indexOf("Safari") && -1 == c.indexOf("Chrome") ? a.webkitRequestFullScreen() : a.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      var d = function () {
        if (this.isFullscreen()) this.onFullscreenEntered();else this.exitFullscreen(), a.removeEventListener("webkitfullscreenchange", d);
      }.bind(this);
      a.addEventListener("webkitfullscreenchange", d, !1);
    } else a.mozRequestFullScreen ? (a.mozRequestFullScreen(), d = function () {
      if (this.isFullscreen()) this.onFullscreenEntered();else this.exitFullscreen(), document.removeEventListener("mozfullscreenchange", d);
    }.bind(this), document.addEventListener("mozfullscreenchange", d, !1)) : a.msRequestFullscreen && (a.msRequestFullscreen(), d = function () {
      if (this.isFullscreen()) this.onFullscreenEntered();else this.exitFullscreen(), document.removeEventListener("MSFullscreenChange", d);
    }.bind(this), document.addEventListener("MSFullscreenChange", d, !1));
  } else a.msRequestFullscreen && window !== top && alert("Fullscreen mode in IE11 is not supported when Pivot is embedded in IFrame.");
};
FlexmonsterToolbar.prototype.onFullscreenEntered = function () {
  this.containerStyle = {
    width: this.container.style.width,
    height: this.container.style.height,
    position: this.container.style.position,
    top: this.container.style.top,
    bottom: this.container.style.bottom,
    left: this.container.style.left,
    right: this.container.style.right,
    marginTop: this.container.style.marginTop,
    marginLeft: this.container.style.marginLeft,
    zIndex: this.container.style.zIndex
  };
  this.container.style.width = "100%";
  this.container.style.height = "100%";
  this.container.style.position = "fixed";
  this.container.style.top = "0px";
  this.container.style.left = "0px";
  this.container.style.zIndex = 2147483647;
  this.toolbarWrapper.style.width = "100%";
  this._redrawToolbar();
};
FlexmonsterToolbar.prototype.onFullscreenError = function () {
  this.pivot.alert({
    title: this.Labels.fullscreenErrorTitle,
    message: this.Labels.fullscreenErrorMessage
  });
};
FlexmonsterToolbar.prototype.exitFullscreen = function () {
  this.container.style.width = this.containerStyle.width;
  this.container.style.height = this.containerStyle.height;
  this.container.style.position = this.containerStyle.position;
  this.container.style.top = this.containerStyle.top;
  this.container.style.left = this.containerStyle.left;
  this.container.style.marginTop = this.containerStyle.marginTop;
  this.container.style.marginLeft = this.containerStyle.marginLeft;
  this.container.style.zIndex = this.containerStyle.zIndex;
  document.exitFullscreen && document.fullScreenElement ? document.exitFullscreen() : document.cancelFullscreen && document.fullScreenElement ? document.cancelFullscreen() : document.mozCancelFullScreen && document.mozFullScreenElement ? document.mozCancelFullScreen() : document.webkitExitFullScreen && document.webkitFullscreenElement ? document.webkitExitFullScreen() : document.webkitCancelFullScreen && document.webkitFullscreenElement ? document.webkitCancelFullScreen() : document.msExitFullscreen && document.msFullscreenElement && document.msExitFullscreen();
  this._redrawToolbar();
  this.setText(document.querySelector("#fm-tab-fullscreen .fm-tab-label"), this.Labels.fullscreen);
  document.querySelector("#fm-tab-fullscreen .fm-svg-icon").innerHTML = this.icons.fullscreen;
};
FlexmonsterToolbar.prototype.nullOrUndefined = function (a) {
  return "undefined" === typeof a || null === a;
};
FlexmonsterToolbar.prototype.hasClass = function (a, b) {
  return a.className.match(new RegExp("(\\s|^)" + b + "(\\s|$)"));
};
FlexmonsterToolbar.prototype.addClass = function (a, b) {
  this.hasClass(a, b) || (a.className += " " + b);
};
FlexmonsterToolbar.prototype.removeClass = function (a, b) {
  this.hasClass(a, b) && (a.className = a.className.replace(new RegExp("(\\s|^)" + b + "(\\s|$)"), " "));
};
FlexmonsterToolbar.prototype.setEnabled = function (a, b) {
  b ? (this.removeClass(a, "fm-ui-disabled"), a.setAttribute("tabindex", "0"), a.removeAttribute("aria-disabled")) : (this.addClass(a, "fm-ui-disabled"), a.setAttribute("tabindex", "-1"), a.setAttribute("aria-disabled", "true"));
};
FlexmonsterToolbar.prototype.setText = function (a, b) {
  a && (void 0 !== a.innerText && (a.innerText = b), void 0 !== a.textContent && (a.textContent = b));
};
FlexmonsterToolbar.prototype.makeSelectableByKeyboard = function (a) {
  a.setAttribute("tabindex", "0");
  a.addEventListener("keyup", function (b) {
    document.activeElement !== a || 13 != b.which && 32 != b.which || (a.click(), (b = a.querySelector("input")) && b.click());
  });
};
FlexmonsterToolbar.prototype.createRadioGroup = function (a, b) {
  function c(h) {
    if (h = h.target.querySelector("input")) h.checked = !0;
    d();
  }
  function d() {
    for (var h = l.childNodes, f = 0; f < h.length; f++) {
      var r = h.item(f),
        u = r.querySelector("input");
      r.setAttribute("aria-checked", u.checked ? "true" : "false");
    }
  }
  var l = document.createElement("ul");
  l.setAttribute("role", "radiogroup");
  l.classList.add("fm-radiobtn-list");
  void 0 === b && (b = this.guid());
  for (var k = 0; k < a.length; k++) {
    var e = a[k],
      g = document.createElement("li");
    g.classList.add("fm-radio-wrap");
    g.setAttribute("role", "radio");
    g.setAttribute("aria-checked", e.checked ? "true" : "false");
    g.addEventListener("click", c);
    this.makeSelectableByKeyboard(g);
    var q = document.createElement("input");
    q.id = this.guid();
    q.type = "radio";
    q.name = b;
    q.value = e.value;
    q.checked = e.checked;
    g.appendChild(q);
    var m = document.createElement("label");
    m.setAttribute("for", q.id);
    this.setText(m, e.label);
    g.appendChild(m);
    l.appendChild(g);
  }
  l.getValue = function () {
    for (var h = l.childNodes, f = 0; f < h.length; f++) {
      var r = h.item(f).querySelector("input");
      if (r.checked) return r.value;
    }
    return null;
  };
  l.setValue = function (h) {
    for (var f = l.childNodes, r = 0; r < f.length; r++) {
      var u = f.item(r).querySelector("input");
      if (u.value == h) {
        u.checked = !0;
        d();
        break;
      }
    }
  };
  return l;
};
FlexmonsterToolbar.prototype.guid = function () {
  return "fm-" + Math.random().toString(36).substr(2, 9);
};
FlexmonsterToolbar.prototype.createInputRow = function (a, b) {
  var c = document.createElement("div");
  c.classList.add("fm-inp-row");
  c.classList.add("fm-ir-horizontal");
  var d = document.createElement("label");
  d.id = this.guid();
  this.setText(d, a);
  c.appendChild(d);
  b.dropdownButton ? b.dropdownButton.setAttribute("aria-labelledby", d.id) : b.setAttribute("aria-labelledby", d.id);
  c.appendChild(b);
  return c;
};
FlexmonsterToolbar.prototype.createSelect = function (a, b, c) {
  function d(n) {
    c ? l(n.target) : (k(n.target), q());
    if (w.onchange) w.onchange();
  }
  function l(n, x) {
    void 0 === x && (x = !n.classList.contains("fm-selected"));
    var v = parseInt(n.getAttribute("data-index"));
    x ? (n.classList.add("fm-selected"), n.setAttribute("aria-selected", "true"), 0 > f.indexOf(v) && f.push(v)) : (n.classList.remove("fm-selected"), n.setAttribute("aria-selected", "false"), x = f.indexOf(v), 0 <= x && f.splice(x, 1));
    v = parseInt(n.getAttribute("data-index"));
    g(v);
    e();
  }
  function k(n) {
    for (var x = C.children, v = 0; v < x.length; v++) x.item(v).classList.remove("fm-selected"), x.item(v).setAttribute("aria-selected", "false");
    n.classList.add("fm-selected");
    n.setAttribute("aria-selected", "true");
    x = parseInt(n.getAttribute("data-index"));
    f = [x];
    g(x);
    y.setAttribute("aria-activedescendant", n.id);
    e();
  }
  function e() {
    var n = b;
    if (0 < f.length) if (c) {
      f.sort();
      n = [];
      for (var x = 0; x < f.length; x++) {
        var v = h[f[x]];
        n.push("string" === typeof v ? v : v.label);
      }
      n = n.join(", ");
    } else v = h[f[0]], n = "string" === typeof v ? v : v.label;
    y.innerHTML = n;
  }
  function g(n) {
    r = Math.max(0, Math.min(C.children.length - 1, n));
    n = C.children;
    for (var x = 0; x < n.length; x++) n.item(x).classList.remove("fm-current");
    C.children.item(r).classList.add("fm-current");
  }
  function q() {
    u && (u = !1, w.classList.remove("fm-opened"), y.setAttribute("aria-expanded", "false"));
  }
  function m() {
    if (0 == u) {
      u = !0;
      w.classList.add("fm-opened");
      y.setAttribute("aria-expanded", "true");
      var n = y,
        x = void 0;
      void 0 === x && (x = n.offsetParent);
      var v = 0,
        A = 0;
      if (n.offsetParent) {
        v = n.offsetLeft;
        A = n.offsetTop;
        for (var D = n; (D = D.parentNode) && D != x;) {
          var z = D.scrollTop ? D.scrollTop : 0;
          v -= 0;
          A -= z;
        }
        for (; (n = n.offsetParent) && n != x;) v += n.offsetLeft, A += n.offsetTop;
      }
      t.style.top = A + y.clientHeight + "px";
      t.style.left = v + "px";
      t.style.width = y.clientWidth + 2 + "px";
      0 < f.length && g(f[0]);
    }
  }
  void 0 === a && (a = []);
  void 0 === b && (b = "");
  var h = a,
    f = [],
    r = -1,
    u = !1,
    w = document.createElement("div");
  w.classList.add("fm-ui");
  w.classList.add("fm-ui-element");
  w.classList.add("fm-ui-dropdown");
  var y = document.createElement("a");
  y.classList.add("fm-ui");
  y.classList.add("fm-ui-element");
  y.classList.add("fm-ui-toggle-btn");
  y.classList.add("fm-ui-dropdown-btn");
  y.setAttribute("tabindex", "0");
  y.setAttribute("role", "combobox");
  y.setAttribute("aria-haspopup", "listbox");
  y.setAttribute("aria-expanded", "false");
  y.addEventListener("click", function () {
    u ? q() : m();
  });
  y.addEventListener("keydown", function (n) {
    !u || 38 != n.keyCode && 40 != n.keyCode || (g(40 == n.keyCode ? r + 1 : r - 1), n.preventDefault());
    if (13 == n.keyCode || 32 == n.keyCode) {
      if (u) {
        if (-1 != r && (c ? l(C.children.item(r)) : (k(C.children.item(r)), q()), w.onchange)) w.onchange();
      } else m();
      n.preventDefault();
    }
    u && 27 == n.keyCode && (q(), n.stopImmediatePropagation());
  });
  y.addEventListener("blur", q);
  y.innerHTML = b;
  w.appendChild(y);
  w.dropdownButton = y;
  var t = document.createElement("div");
  t.classList.add("fm-ui");
  t.classList.add("fm-ui-element");
  t.classList.add("fm-ui-dropdown-list");
  t.addEventListener("mouseleave", q);
  w.appendChild(t);
  var C = document.createElement("ul");
  C.id = this.guid();
  C.classList.add("fm-ui");
  C.classList.add("fm-ui-element");
  C.classList.add("fm-ui-list");
  C.setAttribute("role", "listbox");
  t.appendChild(C);
  y.setAttribute("aria-controls", C.id);
  w.setDataProvider = function (n) {
    h = n;
    f.length = 0;
    C.innerHTML = "";
    for (var x = 0; x < n.length; x++) {
      var v = n[x],
        A = document.createElement("li");
      A.id = C.id + x;
      A.innerHTML = "string" === typeof v ? v : v.label;
      A.classList.add("fm-ui");
      A.classList.add("fm-ui-element");
      A.setAttribute("role", "option");
      A.setAttribute("data-index", x);
      A.setAttribute("aria-selected", "false");
      A.addEventListener("mousedown", d);
      C.appendChild(A);
    }
    C.firstChild && (y.setAttribute("aria-activedescendant", C.firstChild.id), g(0));
  };
  w.setEnabled = function (n) {
    n ? (w.classList.remove("fm-ui-disabled"), w.removeAttribute("aria-disabled"), y.setAttribute("tabindex", "0")) : (w.classList.add("fm-ui-disabled"), w.setAttribute("aria-disabled", "true"), y.setAttribute("tabindex", "-1"));
  };
  w.getValue = function () {
    return 0 == f.length ? null : c ? (f.sort(), f.map(function (n) {
      return "string" === typeof h[n] ? h[n] : h[n].value;
    })) : "string" === typeof h[f[0]] ? h[f[0]] : h[f[0]].value;
  };
  w.setValue = function (n) {
    var x = function (D) {
      for (var z = 0; z < h.length; z++) if ("string" === typeof h[z] && h[z] == D || "object" === typeof h[z] && h[z].value == D) return z;
      return -1;
    };
    if (c) for (var v = 0; v < n.length; v++) {
      var A = x(n[v]);
      0 <= A && l(C.children.item(A), !0);
    } else A = x(n), 0 <= A && k(C.children.item(A));
  };
  a && w.setDataProvider(a);
  return w;
};
FlexmonsterToolbar.prototype.createDivider = function (a) {
  a = document.createElement("li");
  a.className = "fm-divider";
  a.setAttribute("aria-hidden", "true");
  return a;
};
FlexmonsterToolbar.prototype.createTab = function (a, b) {
  b = document.createElement("li");
  b.id = a.id;
  var c = document.createElement("a");
  c.setAttribute("role", "menuitem");
  c.tabIndex = 0;
  a.hasOwnProperty("class_attr") && c.setAttribute("class", a.class_attr);
  c.setAttribute("href", "javascript:void(0)");
  if (a.icon) {
    var d = document.createElement("div");
    d.classList.add("fm-svg-icon");
    d.setAttribute("aria-hidden", "true");
    d.innerHTML = a.icon;
    c.appendChild(d);
  }
  d = document.createElement("span");
  d.classList.add("fm-tab-label");
  this.setText(d, a.title);
  c.appendChild(d);
  var l = this;
  d = "function" == typeof a.handler ? a.handler : this[a.handler];
  var k = "function" == typeof a.onShowHandler ? a.onShowHandler : this[a.onShowHandler];
  this.nullOrUndefined(d) || (c.onclick = function (e, g) {
    return function () {
      e.call(l, g);
    };
  }(d, a.args));
  this.nullOrUndefined(k) || (c.onmouseover = function (e) {
    return function () {
      e.call(l);
    };
  }(k));
  b.appendChild(c);
  null == a.menu || this.osUtils.isMobile && 1 != a.collapse || (a = this.createTabMenu(a.menu, b), a.querySelector("ul").id = this.guid(), c.setAttribute("aria-haspopup", "true"), c.setAttribute("aria-controls", a.querySelector("ul").id), b.appendChild(a));
  return b;
};
FlexmonsterToolbar.prototype.createSubmenuItem = function (a, b) {
  var c = document.createElement("li");
  c.setAttribute("role", "menuitem");
  c.id = a.id;
  a.hasOwnProperty("class_attr") && c.setAttribute("class", a.class_attr);
  var d = this,
    l = "function" == typeof a.handler ? a.handler : this[a.handler];
  this.nullOrUndefined(l) || c.addEventListener("mousedown", function (k, e) {
    return function () {
      k.call(d, e);
      b.classList.remove("fm-opened");
    };
  }(l, a.args));
  a.icon && (l = document.createElement("span"), l.classList.add("fm-svg-icon"), l.setAttribute("aria-hidden", "true"), l.innerHTML = a.icon, c.appendChild(l));
  "checkbox" === a.type && (l = document.createElement("span"), l.setAttribute("aria-hidden", "true"), l.classList.add("fm-tab-checkbox"), c.appendChild(l), c.setAttribute("role", "menuitemcheckbox"));
  l = document.createElement("span");
  l.classList.add("fm-tab-label");
  this.setText(l, a.title);
  c.appendChild(l);
  return c;
};
FlexmonsterToolbar.prototype.createTabMenu = function (a, b) {
  function c() {
    b.classList.add("fm-opened");
    e.classList.remove("fm-dropdown-scrollable-left");
    e.classList.remove("fm-dropdown-scrollable-right");
    k.style.right = k.style.left = null;
    var h = k.getBoundingClientRect(),
      f = b.getBoundingClientRect(),
      r = m.toolbarWrapper.getBoundingClientRect(),
      u = m.container.querySelector(".fm-left-scroll-button"),
      w = u ? u.getBoundingClientRect() : null,
      y = m.container.querySelector(".fm-right-scroll-button");
    u = (u ? u.offsetWidth : 0) + (y ? y.offsetWidth : 0);
    (h.left > f.right - u || h.left < f.left + u) && f.right + h.width < r.right && 0 < m.toolbar.scrollLeft ? (k.style.left = 0, h = k.getBoundingClientRect(), h = Math.round(f.right - h.left - .6 * f.width), k.style.left = h + "px", e.classList.add("fm-dropdown-scrollable-left")) : h.right > r.right - u && 0 < f.left + f.width / 2 - h.width ? (k.style.right = 0, h = k.getBoundingClientRect(), h = Math.round(h.right - f.left - .6 * f.width), k.style.right = h + "px", e.classList.add("fm-dropdown-scrollable-right")) : w && f.left < w.right && (k.style.left = 0, e.classList.add("fm-dropdown-scrollable-left"));
    l(-2);
    b.querySelector("a").setAttribute("aria-activedescendant", e.children.item(0).id);
  }
  function d() {
    b.classList.remove("fm-opened");
  }
  function l(h) {
    for (var f = e.children, r = 0; r < f.length; r++) f.item(r).classList.remove("fm-current");
    -1 <= h ? (q = Math.max(0, Math.min(e.children.length - 1, h)), e.children.item(q).classList.add("fm-current")) : q = -1;
  }
  var k = document.createElement("div");
  k.className = "fm-dropdown fm-shadow-container";
  var e = document.createElement("ul");
  e.setAttribute("role", "menu");
  e.setAttribute("aria-orientation", "vertical");
  e.className = "fm-dropdown-content";
  for (var g = 0; g < a.length; g++) this.isDisabled(a[g]) || e.appendChild(a[g].divider ? this.createMenuDivider() : this.createSubmenuItem(a[g], b));
  k.appendChild(e);
  var q = -1;
  b.querySelector("a").addEventListener("click", function () {
    b.classList.contains("fm-opened") ? d() : c();
  });
  b.querySelector("a").addEventListener("keydown", function (h) {
    var f = b.classList.contains("fm-opened");
    !f || 38 != h.keyCode && 40 != h.keyCode || (l(40 == h.keyCode ? q + 1 : q - 1), h.preventDefault());
    if (13 == h.keyCode || 32 == h.keyCode) {
      if (f) {
        if (0 <= q) {
          var r = a[q],
            u = "function" == typeof r.handler ? r.handler : m[r.handler];
          m.nullOrUndefined(u) || u.call(m, r.args);
        }
      } else c();
      h.preventDefault();
    }
    f && 27 == h.keyCode && (d(), h.stopImmediatePropagation());
  });
  b.querySelector("a").addEventListener("blur", d);
  b.addEventListener("mouseover", c);
  b.addEventListener("mouseleave", d);
  var m = this;
  return k;
};
FlexmonsterToolbar.prototype.createMenuDivider = function () {
  var a = document.createElement("li");
  a.className = "fm-v-divider";
  a.setAttribute("aria-hidden", "true");
  return a;
};
FlexmonsterToolbar.prototype.isDisabled = function (a) {
  return this.nullOrUndefined(a) ? !0 : !1 === a.visible || !1 === a.ios && this.osUtils.isIOS || !1 === a.android && this.osUtils.isAndroid || !1 === a.mobile && this.osUtils.isMobile;
};
FlexmonsterToolbar.prototype.filterConnectMenu = function () {
  var a = [],
    b = this.Labels;
  1 == this.dataSourceType || 2 == this.dataSourceType ? (a.push({
    title: b.connect_local_csv,
    id: "fm-tab-connect-local-csv",
    handler: this.connectLocalCSVHandler,
    mobile: !1,
    icon: this.icons.connect_csv
  }), a.push({
    title: b.connect_local_json,
    id: "fm-tab-connect-local-json",
    handler: this.connectLocalJSONHandler,
    mobile: !1,
    icon: this.icons.connect_json
  }), a.push({
    title: this.osUtils.isMobile ? b.connect_remote_csv_mobile : b.connect_remote_csv,
    id: "fm-tab-connect-remote-csv",
    handler: this.connectRemoteCSV,
    icon: this.icons.connect_csv
  }), a.push({
    title: this.osUtils.isMobile ? b.connect_remote_json_mobile : b.connect_remote_json,
    id: "fm-tab-connect-remote-json",
    handler: this.connectRemoteJSON,
    icon: this.icons.connect_json
  })) : 3 == this.dataSourceType || 4 == this.dataSourceType ? a.push({
    title: this.osUtils.isMobile ? b.connect_olap_mobile : b.connect_olap,
    id: "fm-tab-connect-olap",
    handler: this.connectOLAP,
    flat: !1,
    icon: this.icons.connect_olap
  }) : 6 == this.dataSourceType && a.push({
    title: this.osUtils.isMobile ? b.connect_elastic_mobile : b.connect_elastic,
    id: "fm-tab-connect-elastic",
    handler: this.connectElastic,
    flat: !1,
    icon: this.icons.connect_elastic
  });
  0 != this.dataSourceType && this.dataProvider[0] && "fm-tab-connect" == this.dataProvider[0].id && (this.dataProvider[0].menu = a);
};
FlexmonsterToolbar.prototype.getElementById = function (a, b) {
  var c = function (d, l) {
    for (var k = 0; k < d.childNodes.length; k++) {
      var e = d.childNodes[k];
      if (e.id == l) return e;
      e = c(e, l);
      if (null != e) return e;
    }
    return null;
  };
  return c(b || this.toolbarWrapper, a);
};
FlexmonsterToolbar.prototype.osUtils = {
  isIOS: navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.platform.match(/iPhone|iPad|iPod/i) ? !0 : !1,
  isMac: /Mac/i.test(navigator.platform),
  isAndroid: navigator.userAgent.match(/Android/i) ? !0 : !1,
  isBlackBerry: /BlackBerry/i.test(navigator.platform),
  isReactNative: /ReactNative/i.test(navigator.product),
  isMobile: navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.platform.match(/iPhone|iPad|iPod/i) || navigator.userAgent.match(/Android/i) || /BlackBerry/i.test(navigator.platform) || /ReactNative/i.test(navigator.product)
};
FlexmonsterToolbar.PopupManager = function (a) {
  this.toolbar = a;
  this.activePopup = null;
};
FlexmonsterToolbar.PopupManager.prototype.createPopup = function () {
  return new FlexmonsterToolbar.PopupManager.PopupWindow(this);
};
FlexmonsterToolbar.PopupManager.prototype.addPopup = function (a) {
  if (null != a) {
    this.removePopup();
    this.modalOverlay = this.createModalOverlay();
    this.activePopup = a;
    this.toolbar.toolbarWrapper.appendChild(a.content);
    this.toolbar.toolbarWrapper.appendChild(this.modalOverlay);
    this.addLayoutClasses(a.content);
    this.centerPopup(a.content);
    var b = this;
    a.resizeHandler = function () {
      a && (b.addLayoutClasses(a.content), b.centerPopup(a.content));
    };
    window.addEventListener("resize", a.resizeHandler);
    a.initialFocusAt && (a.prevActiveElement = document.activeElement, a.initialFocusAt.focus({
      preventScroll: !0
    }));
  }
};
FlexmonsterToolbar.PopupManager.prototype.addLayoutClasses = function (a) {
  a.classList.remove("fm-layout-tablet");
  a.classList.remove("fm-layout-mobile");
  a.classList.remove("fm-layout-mobile-small");
  var b = this.getBoundingRect(this.toolbar.container);
  768 > b.width && a.classList.add("fm-layout-tablet");
  580 > b.width && a.classList.add("fm-layout-mobile");
  460 > b.width && a.classList.add("fm-layout-mobile-small");
};
FlexmonsterToolbar.PopupManager.prototype.centerPopup = function (a) {
  if (null != this.modalOverlay) {
    var b = this.getBoundingRect(this.toolbar.container),
      c = this.getBoundingRect(a),
      d = this.getBoundingRect(this.toolbar.toolbarWrapper);
    a.style.zIndex = parseInt(this.modalOverlay.style.zIndex) + 1;
    this.modalOverlay.style.height = b.height + "px";
    a.style.left = Math.max(0, (d.width - c.width) / 2) + "px";
    a.style.top = Math.max(d.height, (b.height - d.height - c.height) / 2 + d.height) + "px";
  }
};
FlexmonsterToolbar.PopupManager.prototype.removePopup = function (a) {
  a = a || this.activePopup;
  null != this.modalOverlay && this.toolbar.toolbarWrapper.contains(this.modalOverlay) && (this.toolbar.toolbarWrapper.removeChild(this.modalOverlay), this.modalOverlay = null);
  null != a && this.toolbar.toolbarWrapper.contains(a.content) && (this.toolbar.toolbarWrapper.removeChild(a.content), this.activePopup = null, window.removeEventListener("resize", a.resizeHandler), a.prevActiveElement && a.prevActiveElement.focus && a.prevActiveElement.focus({
    preventScroll: !0
  }));
};
FlexmonsterToolbar.PopupManager.prototype.getBoundingRect = function (a) {
  var b = a.getBoundingClientRect();
  return {
    left: b.left,
    right: b.right,
    top: b.top,
    bottom: b.bottom,
    width: b.width || a.clientWidth,
    height: b.height || a.clientHeight
  };
};
FlexmonsterToolbar.PopupManager.prototype.createModalOverlay = function () {
  var a = document.createElement("div");
  a.classList.add("fm-modal-overlay");
  a.classList.add("fm-popup-modal-overlay");
  var b = this;
  a.addEventListener("click", function (c) {
    b.removePopup(b.activePopup);
  });
  return a;
};
FlexmonsterToolbar.PopupManager.PopupWindow = function (a) {
  function b(m) {
    m.relatedTarget && m.relatedTarget.focus && m.relatedTarget.focus();
  }
  this.popupManager = a;
  var c = document.createElement("div");
  c.className = "fm-panel-content";
  var d = document.createElement("div");
  d.className = "fm-title-bar";
  var l = document.createElement("div");
  l.className = "fm-title-text";
  l.id = "fm-popup-title-text";
  var k = document.createElement("div");
  k.className = "fm-toolbox";
  k.style.clear = "both";
  this.content = document.createElement("div");
  this.content.className = "fm-popup fm-panel fm-toolbar-ui fm-ui";
  this.content.setAttribute("role", "dialog");
  this.content.setAttribute("aria-labelledby", "fm-popup-title-text");
  this.content.appendChild(c);
  this.content.addEventListener("keydown", function (m) {
    27 == m.keyCode && a.removePopup();
  });
  c.appendChild(d);
  d.appendChild(l);
  var e = this,
    g = document.createElement("div");
  g.setAttribute("tabindex", "0");
  g.addEventListener("focus", b);
  c.insertBefore(g, c.firstChild);
  var q = document.createElement("div");
  q.setAttribute("tabindex", "0");
  q.addEventListener("focus", b);
  this.setTitle = function (m) {
    FlexmonsterToolbar.prototype.setText(l, m);
  };
  this.setContent = function (m) {
    c.insertBefore(m, d.nextSibling);
    c.appendChild(q);
  };
  this.setToolbar = function (m, h, f) {
    k.innerHTML = "";
    for (var r = m.length - 1; 0 <= r; r--) {
      var u = document.createElement("button");
      u.setAttribute("type", "button");
      u.className = "fm-ui-btn" + (m[r].isPositive ? " fm-ui-btn-dark" : "");
      m[r].id && (u.id = m[r].id);
      FlexmonsterToolbar.prototype.setText(u, m[r].label);
      u.onclick = function (w) {
        return function () {
          null != w && w.call();
          void 0 != f ? f.call() : e.popupManager.removePopup();
        };
      }(m[r].handler, f);
      FlexmonsterToolbar.prototype.setEnabled(u, !0 !== m[r].disabled);
      m[r].isPositive && (FlexmonsterToolbar.prototype.osUtils.isMac || FlexmonsterToolbar.prototype.osUtils.isIOS) ? k.appendChild(u) : k.insertBefore(u, k.firstChild);
    }
    h ? (k.classList.add("fm-ui-col"), d.appendChild(k), d.classList.add("fm-ui-row"), l.classList.add("fm-ui-col")) : c.appendChild(k);
  };
  this.toolbar = k;
  this.titleBar = d;
  this.title = l;
  return this;
};
FlexmonsterToolbar.ColorPicker = function (a, b) {
  function c(f) {
    f.relatedTarget && f.relatedTarget.focus && f.relatedTarget.focus();
  }
  function d(f) {
    f = f.target.getAttribute("data-c");
    e.drawShades(e.colors[f]);
    e.setColor(f, e.currentType, !0);
  }
  function l(f) {
    f = f.target.getAttribute("data-c");
    e.setColor(f, e.currentType, !0);
  }
  function k(f) {
    e.currentType = f;
    g.classList.remove("fm-current");
    q.classList.remove("fm-current");
    "bg" == f ? (q.classList.add("fm-current"), e.setColor(e.backgroundColor, f, !1)) : (g.classList.add("fm-current"), e.setColor(e.fontColor, f, !1));
  }
  var e = this;
  this.toolbar = a;
  this.element = document.createElement("div");
  this.element.classList.add("fm-colorpick-wrap");
  this.element.classList.add("fm-width40");
  this.colorPickerButton = document.createElement("div");
  this.colorPickerButton.classList.add("fm-colorpick-btn");
  this.colorPickerButton.setAttribute("title", a.Labels.tooltips.cp_text_color);
  this.element.appendChild(this.colorPickerButton);
  this.colorPickerIcon = document.createElement("span");
  this.colorPickerIcon.classList.add("fm-icon");
  this.colorPickerIcon.classList.add("fm-ui-icon-vam");
  this.colorPickerIcon.classList.add("fm-icon-act_font");
  this.colorPickerButton.appendChild(this.colorPickerIcon);
  a.makeSelectableByKeyboard(this.colorPickerButton);
  this.popup = document.createElement("div");
  this.popup.classList.add("fm-colorpick-popup");
  this.popup.addEventListener("click", function (f) {
    f.stopPropagation();
  });
  this.popup.addEventListener("keydown", function (f) {
    27 == f.keyCode && (e.closePopup(), f.stopImmediatePropagation());
  });
  b.appendChild(this.popup);
  b = document.createElement("div");
  b.setAttribute("tabindex", "0");
  b.addEventListener("focus", c);
  this.popup.insertBefore(b, this.popup.firstChild);
  b = document.createElement("div");
  b.classList.add("fm-color-targ-switch");
  this.popup.appendChild(b);
  var g = document.createElement("button");
  g.setAttribute("type", "button");
  g.classList.add("fm-cts-item");
  g.classList.add("fm-current");
  g.innerHTML = a.Labels.cp_text;
  g.onclick = function () {
    k("font");
  };
  b.appendChild(g);
  var q = document.createElement("button");
  q.setAttribute("type", "button");
  q.classList.add("fm-cts-item");
  q.innerHTML = a.Labels.cp_highlight;
  q.onclick = function () {
    k("bg");
  };
  b.appendChild(q);
  b = document.createElement("div");
  b.classList.add("fm-cp-sett-row");
  this.popup.appendChild(b);
  this.colorInput = document.createElement("input");
  this.colorInput.type = "text";
  this.colorInput.setAttribute("aria-label", a.Labels.cp_hex_value);
  this.colorInput.classList.add("fm-inp");
  this.colorInput.classList.add("fm-cp-2-colors-width");
  this.colorInput.classList.add("fm-tac");
  this.colorInput.onchange = function () {
    var f = e.colorInput.value;
    e.isColor(f) && e.setColor(f, e.currentType, !0);
  };
  b.appendChild(this.colorInput);
  this.colorPreview = document.createElement("div");
  this.colorPreview.classList.add("fm-cp-curr-color");
  this.colorPreview.classList.add("fm-cp-2-colors-width");
  b.appendChild(this.colorPreview);
  this.mainColors = document.createElement("div");
  this.mainColors.classList.add("fm-row-10colors");
  this.popup.appendChild(this.mainColors);
  for (var m in this.colors) {
    b = document.createElement("div");
    b.classList.add("fm-r10c-item");
    b.style.backgroundColor = m;
    b.setAttribute("tabindex", "0");
    b.setAttribute("role", "checkbox");
    b.setAttribute("aria-label", this.colorLabels[m]);
    this.toolbar.makeSelectableByKeyboard(b);
    b.setAttribute("data-c", m);
    b.addEventListener("click", d);
    this.mainColors.appendChild(b);
    var h = document.createElement("span");
    h.classList.add("fm-cp-currentmark");
    h.classList.add("fm-icon");
    h.classList.add("fm-icon-act_check");
    b.appendChild(h);
    h = document.createElement("span");
    "#FFFFFF" == m ? b.classList.add("fm-r10c-white-arrow") : h.classList.add("fm-r10c-arrow");
    h.style.borderTopColor = m;
    b.appendChild(h);
  }
  this.shadeColors = document.createElement("div");
  this.shadeColors.classList.add("fm-row-4colors");
  this.popup.appendChild(this.shadeColors);
  for (m = 0; 8 > m; m++) b = document.createElement("div"), b.classList.add("fm-r4c-item"), b.addEventListener("click", l), b.setAttribute("tabindex", "0"), b.setAttribute("role", "checkbox"), this.toolbar.makeSelectableByKeyboard(b), this.shadeColors.appendChild(b), h = document.createElement("span"), h.classList.add("fm-cp-currentmark"), h.classList.add("fm-icon"), h.classList.add("fm-icon-act_check"), b.appendChild(h);
  this.drawShades("#000000");
  b = document.createElement("div");
  b.classList.add("fm-cp-btns-row");
  this.popup.appendChild(b);
  m = document.createElement("button");
  m.setAttribute("type", "button");
  m.innerHTML = a.Labels.apply;
  m.classList.add("fm-ui-btn");
  m.classList.add("fm-ui-btn-dark");
  m.addEventListener("click", function (f) {
    e.closePopup();
    e.applyHandler && e.applyHandler();
    e.colorPickerButton.focus();
  });
  h = document.createElement("button");
  h.setAttribute("type", "button");
  h.innerHTML = a.Labels.cancel;
  h.classList.add("fm-ui-btn");
  h.addEventListener("click", function (f) {
    e.closePopup();
    e.cancelHandler && e.cancelHandler();
    e.colorPickerButton.focus();
  });
  FlexmonsterToolbar.prototype.osUtils.isMac || FlexmonsterToolbar.prototype.osUtils.isIOS ? (b.appendChild(h), b.appendChild(m)) : (b.appendChild(m), b.appendChild(h));
  a = document.createElement("div");
  a.setAttribute("tabindex", "0");
  a.addEventListener("focus", c);
  this.popup.appendChild(a);
  this.currentType = "font";
  this.colorPickerButton.addEventListener("click", function (f) {
    f.stopPropagation();
    e.isOpened() ? e.closePopup() : e.openPopup();
  });
  document.body.addEventListener("click", function (f) {
    e.isOpened() && e.closePopup();
  });
};
FlexmonsterToolbar.ColorPicker.prototype.colors = {
  "#000000": "#000000 #262626 #424242 #616161 #757575 #9E9E9E #BDBDBD #DEDEDE".split(" "),
  "#FFFFFF": "#FFFFFF #E6E6E6 #B5B5B5 #8F8F8F #737373 #525252 #404040 #383838".split(" "),
  "#F44336": "#D32F2F #E53935 #F44336 #EF5350 #E57373 #EF9A9A #FFCDD2 #FFEBEE".split(" "),
  "#FF9800": "#F57C00 #FB8C00 #FF9800 #FFA726 #FFB74D #FFCC80 #FFE0B2 #FFF3E0".split(" "),
  "#FFEB3B": "#FBC02D #FDD835 #FFEB3B #FFEE58 #FFF176 #FFF59D #FFF9C4 #FFFDE7".split(" "),
  "#8BC34A": "#689F38 #7CB342 #8BC34A #9CCC65 #AED581 #C5E1A5 #DCEDC8 #F1F8E9".split(" "),
  "#009688": "#00796B #00897B #009688 #26A69A #4DB6AC #80CBC4 #B2DFDB #E0F2F1".split(" "),
  "#03A9F4": "#0288D1 #039BE5 #03A9F4 #29B6F6 #4FC3F7 #81D4FA #B3E5FC #E1F5FE".split(" "),
  "#3F51B5": "#303F9F #3949AB #3F51B5 #5C6BC0 #7986CB #9FA8DA #C5CAE9 #E8EAF6".split(" "),
  "#9C27B0": "#7B1FA2 #8E24AA #9C27B0 #AB47BC #BA68C8 #CE93D8 #E1BEE7 #F3E5F5".split(" ")
};
FlexmonsterToolbar.ColorPicker.prototype.colorLabels = {
  "#000000": "black",
  "#FFFFFF": "white",
  "#F44336": "red",
  "#FF9800": "orange",
  "#FFEB3B": "yellow",
  "#8BC34A": "green",
  "#009688": "teal",
  "#03A9F4": "cyan",
  "#3F51B5": "blue",
  "#9C27B0": "purple"
};
FlexmonsterToolbar.ColorPicker.prototype.isOpened = function () {
  return this.popup.parentElement && this.popup.parentElement.classList.contains("fm-popup-opened");
};
FlexmonsterToolbar.ColorPicker.prototype.drawShades = function (a) {
  var b = this.colors[a];
  if (b) for (var c = this.shadeColors.children, d = 0; d < c.length; d++) {
    var l = c[d];
    l.setAttribute("aria-label", this.colorLabels[a] + " " + this.toolbar.Labels.cp_shade + " " + (d + 1));
    l.setAttribute("data-c", b[d]);
    l.style.backgroundColor = b[d];
    "#FFFFFF" == b[d] && l.classList.add("fm-white-shade");
  }
};
FlexmonsterToolbar.ColorPicker.prototype.setColor = function (a, b, c) {
  "string" === typeof a && 0 == a.indexOf("0x") && (a = "#" + a.substr(2));
  "bg" == b ? (this.backgroundColor = a, this.colorPickerButton.style.backgroundColor = a) : (this.fontColor = a, this.colorPickerIcon.style.color = a);
  this.colorInput.value = a;
  this.colorPreview.style.backgroundColor = a;
  this.drawSelected();
  c && this.changeHandler && this.changeHandler();
};
FlexmonsterToolbar.ColorPicker.prototype.drawSelected = function () {
  var a = "bg" == this.currentType ? this.backgroundColor : this.fontColor,
    b = this.findMain(a);
  this.drawShades(b);
  for (var c = this.mainColors.children, d = 0; d < c.length; d++) c[d].classList.remove("fm-current"), c[d].removeAttribute("aria-checked");
  if (b = this.mainColors.querySelector("[data-c='" + b + "']")) b.classList.add("fm-current"), b.setAttribute("aria-checked", "true");
  c = this.shadeColors.children;
  for (d = 0; d < c.length; d++) c[d].classList.remove("fm-current"), c[d].removeAttribute("aria-checked");
  if (a = this.shadeColors.querySelector("[data-c='" + a + "']")) a.classList.add("fm-current"), a.setAttribute("aria-checked", "true");
};
FlexmonsterToolbar.ColorPicker.prototype.findMain = function (a) {
  "string" === typeof a && 0 == a.indexOf("0x") && (a = "#" + a.substr(2));
  for (var b in this.colors) if (0 <= this.colors[b].indexOf(a)) return b;
};
FlexmonsterToolbar.ColorPicker.prototype.isColor = function (a) {
  return a.match(/^#?[0-9A-Fa-f]{6}$/g);
};
FlexmonsterToolbar.ColorPicker.prototype.closePopup = function () {
  if (this.popup.parentElement) {
    this.popup.parentElement.classList.remove("fm-popup-opened");
    this.justClosed = !0;
    var a = this;
    setTimeout(function () {
      a.justClosed = !1;
    }, 100);
  }
};
FlexmonsterToolbar.ColorPicker.prototype.openPopup = function () {
  if (!this.justClosed) {
    for (var a = this.toolbar.toolbarWrapper.querySelectorAll(".fm-colorpick-popup"), b = 0; b < a.length; b++) a[b].parentElement.classList.remove("fm-popup-opened");
    this.popup.parentElement && (this.popup.parentElement.classList.add("fm-popup-opened"), a = this.toolbar.toolbarWrapper.querySelector(".fm-popup-conditional .fm-panel-content"), b = this.getWhere(this.colorPickerButton, a), 0 > this.getWhere(this.colorPickerButton, document.body).top - this.popup.clientHeight ? (this.popup.classList.remove("fm-arrow-down"), this.popup.classList.add("fm-arrow-up"), this.popup.style.top = this.colorPickerButton.clientHeight + b.top + 11 + "px", this.popup.style.bottom = "") : (this.popup.classList.add("fm-arrow-down"), this.popup.classList.remove("fm-arrow-up"), this.popup.style.bottom = a.clientHeight - b.top + 5 + "px", this.popup.style.top = ""), this.popup.style.left = b.left + "px", this.popup.querySelector("button").focus());
  }
};
FlexmonsterToolbar.ColorPicker.prototype.getWhere = function (a, b) {
  var c = 0,
    d = 0;
  if (a.offsetParent) {
    c = a.offsetLeft;
    d = a.offsetTop;
    for (var l = a; (l = l.parentNode) && l != b;) {
      var k = l.scrollTop ? l.scrollTop : 0;
      c -= 0;
      d -= k;
    }
    for (; (a = a.offsetParent) && a != b;) c += a.offsetLeft, d += a.offsetTop;
  }
  return {
    top: d + 0,
    left: c + 0
  };
};
if ("object" === typeof module && module.exports) {
  module.exports = Flexmonster;
}
window["flexmonsterpivottablekey"] = "Z7P6-XD3D3V-531162-4P614X";
// SIG // Begin signature block
// SIG // MIIesQYJKoZIhvcNAQcCoIIeojCCHp4CAQExDzANBglg
// SIG // hkgBZQMEAgEFADB3BgorBgEEAYI3AgEEoGkwZzAyBgor
// SIG // BgEEAYI3AgEeMCQCAQEEEBDgyQbOONQRoqMAEEvTUJAC
// SIG // AQACAQACAQACAQACAQAwMTANBglghkgBZQMEAgEFAAQg
// SIG // VcUziLRi4XU/GYQkv75Lt3r46RCeG40r0eG9mWw1ffWg
// SIG // ggeZMIIDgjCCAwmgAwIBAgIQbt1PJecxfTmBVzE0z8Hc
// SIG // oDAKBggqhkjOPQQDAzB/MQswCQYDVQQGEwJVUzEOMAwG
// SIG // A1UECAwFVGV4YXMxEDAOBgNVBAcMB0hvdXN0b24xGDAW
// SIG // BgNVBAoMD1NTTCBDb3Jwb3JhdGlvbjE0MDIGA1UEAwwr
// SIG // U1NMLmNvbSBFViBSb290IENlcnRpZmljYXRpb24gQXV0
// SIG // aG9yaXR5IEVDQzAeFw0xOTAzMDcxOTM3NDVaFw0zNDAz
// SIG // MDMxOTM3NDVaMHsxCzAJBgNVBAYTAlVTMQ4wDAYDVQQI
// SIG // DAVUZXhhczEQMA4GA1UEBwwHSG91c3RvbjERMA8GA1UE
// SIG // CgwIU1NMIENvcnAxNzA1BgNVBAMMLlNTTC5jb20gRVYg
// SIG // Q29kZSBTaWduaW5nIEludGVybWVkaWF0ZSBDQSBFQ0Mg
// SIG // UjIwdjAQBgcqhkjOPQIBBgUrgQQAIgNiAAQ60OHak+K8
// SIG // VtFJNLiBLDRE0hslk6Ky/0+05B8zwSb7THpAhtrs5VRv
// SIG // 6JFzU5Apim4F0e63Drg7IAnoY4ygUaAU+xbjMiuOQqRB
// SIG // QHtQ6qKW53l4g1ywGcy/DiOgs+UUqbGjggFMMIIBSDAS
// SIG // BgNVHRMBAf8ECDAGAQH/AgEAMB8GA1UdIwQYMBaAFFvK
// SIG // XuXe0oGqzagtZFG22XKbl+ZPMHsGCCsGAQUFBwEBBG8w
// SIG // bTBJBggrBgEFBQcwAoY9aHR0cDovL3d3dy5zc2wuY29t
// SIG // L3JlcG9zaXRvcnkvU1NMY29tLVJvb3RDQS1FVi1FQ0Mt
// SIG // Mzg0LVIxLmNydDAgBggrBgEFBQcwAYYUaHR0cDovL29j
// SIG // c3BzLnNzbC5jb20wEQYDVR0gBAowCDAGBgRVHSAAMBMG
// SIG // A1UdJQQMMAoGCCsGAQUFBwMDMD0GA1UdHwQ2MDQwMqAw
// SIG // oC6GLGh0dHA6Ly9jcmxzLnNzbC5jb20vc3NsLmNvbS1F
// SIG // VmVjYy1Sb290Q0EuY3JsMB0GA1UdDgQWBBQBiZS5/rQz
// SIG // XfDx+oX5JEaEo1dpXjAOBgNVHQ8BAf8EBAMCAYYwCgYI
// SIG // KoZIzj0EAwMDZwAwZAIwSlvqgJ+6NpLPjDHt7KWZ7jIn
// SIG // vMMX64ePV1AwBb91lfc8+T8ZUoM0IOERVu45PrfuAjAC
// SIG // tbjZ+HgSR8HARf8V9qBmu0PiT0MOWHeXpKJVNCSEWlYZ
// SIG // z6ZVIBvZEJpTAPuJXnAwggQPMIIDlqADAgECAhAiRXDS
// SIG // 2H6p0M9A/Hkc/oZVMAoGCCqGSM49BAMDMHsxCzAJBgNV
// SIG // BAYTAlVTMQ4wDAYDVQQIDAVUZXhhczEQMA4GA1UEBwwH
// SIG // SG91c3RvbjERMA8GA1UECgwIU1NMIENvcnAxNzA1BgNV
// SIG // BAMMLlNTTC5jb20gRVYgQ29kZSBTaWduaW5nIEludGVy
// SIG // bWVkaWF0ZSBDQSBFQ0MgUjIwHhcNMjMwMTAyMDk0MDE3
// SIG // WhcNMjQwMTA3MDk0MDE3WjCB7zELMAkGA1UEBhMCVVMx
// SIG // EzARBgNVBAgMCkNhbGlmb3JuaWExGDAWBgNVBAcMD1Jh
// SIG // bmNobyBTYW50YSBGZTElMCMGA1UECgwcTm9ydGggQW1l
// SIG // cmljYW4gUmVzZWxsZXJzIExMQzEVMBMGA1UEBRMMTDA5
// SIG // MDAwMDU3MjExMSUwIwYDVQQDDBxOb3J0aCBBbWVyaWNh
// SIG // biBSZXNlbGxlcnMgTExDMR0wGwYDVQQPDBRQcml2YXRl
// SIG // IE9yZ2FuaXphdGlvbjEYMBYGCysGAQQBgjc8AgECDAdG
// SIG // bG9yaWRhMRMwEQYLKwYBBAGCNzwCAQMTAlVTMFkwEwYH
// SIG // KoZIzj0CAQYIKoZIzj0DAQcDQgAEBWPrI4MXBnyTORGk
// SIG // 4ZUquLJi6HABe8wvwLn7EdA1BiPqONh30847zyEviprF
// SIG // MFnqTlSBmRwXtSlj1IM/R3ZvNaOCAYUwggGBMAwGA1Ud
// SIG // EwEB/wQCMAAwHwYDVR0jBBgwFoAUAYmUuf60M13w8fqF
// SIG // +SRGhKNXaV4wWgYIKwYBBQUHAQEETjBMMEoGCCsGAQUF
// SIG // BzAChj5odHRwOi8vY2VydC5zc2wuY29tL1NTTGNvbS1T
// SIG // dWJDQS1FVi1jb2RlU2lnbmluZy1FQ0MtMzg0LVIyLmNl
// SIG // cjBfBgNVHSAEWDBWMAcGBWeBDAEDMA0GCyqEaAGG9ncC
// SIG // BQEHMDwGDCsGAQQBgqkwAQMDAjAsMCoGCCsGAQUFBwIB
// SIG // Fh5odHRwczovL3d3dy5zc2wuY29tL3JlcG9zaXRvcnkw
// SIG // EwYDVR0lBAwwCgYIKwYBBQUHAwMwTwYDVR0fBEgwRjBE
// SIG // oEKgQIY+aHR0cDovL2NybHMuc3NsLmNvbS9TU0xjb20t
// SIG // U3ViQ0EtRVYtY29kZVNpZ25pbmctRUNDLTM4NC1SMi5j
// SIG // cmwwHQYDVR0OBBYEFM5xc4XzKiDvtSJIQB1RVjQCWhzX
// SIG // MA4GA1UdDwEB/wQEAwIHgDAKBggqhkjOPQQDAwNnADBk
// SIG // AjAMbB5k2zW3KaJkfDDWPl5OaGMCHkNYEH6MMieQHep9
// SIG // UR/MpPbcvBLpL3SueBh1W8wCMGLVCJ716ZXmLlotSZ/A
// SIG // OSWNZvV/8LVvUHbryJku3qRGgnSjeBJlb+oo3Nzxq4lz
// SIG // CzGCFnAwghZsAgEBMIGPMHsxCzAJBgNVBAYTAlVTMQ4w
// SIG // DAYDVQQIDAVUZXhhczEQMA4GA1UEBwwHSG91c3RvbjER
// SIG // MA8GA1UECgwIU1NMIENvcnAxNzA1BgNVBAMMLlNTTC5j
// SIG // b20gRVYgQ29kZSBTaWduaW5nIEludGVybWVkaWF0ZSBD
// SIG // QSBFQ0MgUjICECJFcNLYfqnQz0D8eRz+hlUwDQYJYIZI
// SIG // AWUDBAIBBQCgfDAQBgorBgEEAYI3AgEMMQIwADAZBgkq
// SIG // hkiG9w0BCQMxDAYKKwYBBAGCNwIBBDAcBgorBgEEAYI3
// SIG // AgELMQ4wDAYKKwYBBAGCNwIBFTAvBgkqhkiG9w0BCQQx
// SIG // IgQg6fXAid2+5Qh395R7wY/wBsJBKe2VZDYRcJlOYvuO
// SIG // LU8wCwYHKoZIzj0CAQUABEgwRgIhAKH/bRpCT8/4pp1n
// SIG // 0ARmC+0SSY/ppCJT7/UW1tCC5/fdAiEAwl1n+gFqybpe
// SIG // UX5TCL08EU9wY/LIoV4WBQX77TXcZf6hghTvMIIU6wYK
// SIG // KwYBBAGCNwMDATGCFNswghTXBgkqhkiG9w0BBwKgghTI
// SIG // MIIUxAIBAzENMAsGCWCGSAFlAwQCATB3BgsqhkiG9w0B
// SIG // CRABBKBoBGYwZAIBAQYMKwYBBAGCqTABAwYBMDEwDQYJ
// SIG // YIZIAWUDBAIBBQAEIHs8RkpdJUihyw9DoL4Va66armvN
// SIG // gcZdfxMjO03Mc92oAggZIDUFLL2tyRgPMjAyMzAzMDYx
// SIG // NDQ2NDRaMAMCAQGgghHZMIIE+TCCAuGgAwIBAgIQGtYI
// SIG // p9Y0tc3el8ujzPDQSzANBgkqhkiG9w0BAQsFADBzMQsw
// SIG // CQYDVQQGEwJVUzEOMAwGA1UECAwFVGV4YXMxEDAOBgNV
// SIG // BAcMB0hvdXN0b24xETAPBgNVBAoMCFNTTCBDb3JwMS8w
// SIG // LQYDVQQDDCZTU0wuY29tIFRpbWVzdGFtcGluZyBJc3N1
// SIG // aW5nIFJTQSBDQSBSMTAeFw0yMjEyMDkxODMwNTFaFw0z
// SIG // MjEyMDYxODMwNTBaMGsxCzAJBgNVBAYTAlVTMQ4wDAYD
// SIG // VQQIDAVUZXhhczEQMA4GA1UEBwwHSG91c3RvbjERMA8G
// SIG // A1UECgwIU1NMIENvcnAxJzAlBgNVBAMMHlNTTC5jb20g
// SIG // VGltZXN0YW1waW5nIFVuaXQgMjAyMjBZMBMGByqGSM49
// SIG // AgEGCCqGSM49AwEHA0IABN58+pIllLLZNNnIXgaHKkSv
// SIG // 1gJjjgpCv7j9Hb7hA4fIDEIvJgwiiVUtDNqo7JJ4jqcj
// SIG // iP/4vVoHcm/0d4E9O7ijggFaMIIBVjAfBgNVHSMEGDAW
// SIG // gBQMnRAljpqnG5mHQ88IfuG9gZD0zzBRBggrBgEFBQcB
// SIG // AQRFMEMwQQYIKwYBBQUHMAKGNWh0dHA6Ly9jZXJ0LnNz
// SIG // bC5jb20vU1NMLmNvbS10aW1lU3RhbXBpbmctSS1SU0Et
// SIG // UjEuY2VyMFEGA1UdIARKMEgwPAYMKwYBBAGCqTABAwYB
// SIG // MCwwKgYIKwYBBQUHAgEWHmh0dHBzOi8vd3d3LnNzbC5j
// SIG // b20vcmVwb3NpdG9yeTAIBgZngQwBBAIwFgYDVR0lAQH/
// SIG // BAwwCgYIKwYBBQUHAwgwRgYDVR0fBD8wPTA7oDmgN4Y1
// SIG // aHR0cDovL2NybHMuc3NsLmNvbS9TU0wuY29tLXRpbWVT
// SIG // dGFtcGluZy1JLVJTQS1SMS5jcmwwHQYDVR0OBBYEFAW6
// SIG // k9Hf4hSsICqGWTF/KHIOraxfMA4GA1UdDwEB/wQEAwIH
// SIG // gDANBgkqhkiG9w0BAQsFAAOCAgEAWqi0lhBjDURozMeT
// SIG // k2UktonPEN/eeN5k1LeIys69k8AycnHM94hYaqd4jqvE
// SIG // Z07B7CpLeBhwI9koRqDZZVOOuEGkW03mgJ1udoJC5Zwk
// SIG // e9/cfXTg0GFiyqQKszBaijcTZR1rDj08F5mhkUzKQ+tp
// SIG // Mb8jdbvoWg/UG7Mj3GFIbnoPNGfeUjAiDzQmCKaxEBIk
// SIG // TBzDgrZSTRrVo7eEnz9EeFnsRnZtIRB/LKbrqRRu4ayS
// SIG // zHNuC0JJmmTvpct9P6tI4gvlJj5YIiJV34WtQ98uEUxL
// SIG // PGPBtW5EDkUt1wvv6n2S5KCClQj6bZ/PCuil1foYemnk
// SIG // R9h2lYZkN0H1H59sqIsLniBvN3a5sCsSfVAc7B7krWpe
// SIG // qNit6Vq0hs2UDk1RLsEmaZyOUu2IYx+rD9+ZJ8Y6+jWV
// SIG // 7UcWdEWPVAlhf2tiS7aJO2MZLqOJQCY/pDbKK6efyc1W
// SIG // 2BRgKisPk2yBuZUSrNxwgiQoiZb0jFYc5IUa7jVmzClI
// SIG // YoMAFx2r41xRVPCODpCW8aLetC0BVkppdbNttlKJHuEz
// SIG // QIO1w/Bc8p2Fu10aQma8K8F9ffnurv52aQHdcdgu16jE
// SIG // R8KXMxEwn0AoXSpKHqF/g9OD1ZsvAU0IKVZB4z0Je2mL
// SIG // kRYPfC7kOV8gOkic3BRkM86tU7QMa736ax3vadow9dlO
// SIG // X5y+u/0wggXYMIIEwKADAgECAhEA5CcElfaMkdbQ7HtJ
// SIG // TqTfHDANBgkqhkiG9w0BAQsFADB+MQswCQYDVQQGEwJQ
// SIG // TDEiMCAGA1UEChMZVW5pemV0byBUZWNobm9sb2dpZXMg
// SIG // Uy5BLjEnMCUGA1UECxMeQ2VydHVtIENlcnRpZmljYXRp
// SIG // b24gQXV0aG9yaXR5MSIwIAYDVQQDExlDZXJ0dW0gVHJ1
// SIG // c3RlZCBOZXR3b3JrIENBMB4XDTE4MDkxMTA5MjY0N1oX
// SIG // DTIzMDkxMTA5MjY0N1owfDELMAkGA1UEBhMCVVMxDjAM
// SIG // BgNVBAgMBVRleGFzMRAwDgYDVQQHDAdIb3VzdG9uMRgw
// SIG // FgYDVQQKDA9TU0wgQ29ycG9yYXRpb24xMTAvBgNVBAMM
// SIG // KFNTTC5jb20gUm9vdCBDZXJ0aWZpY2F0aW9uIEF1dGhv
// SIG // cml0eSBSU0EwggIiMA0GCSqGSIb3DQEBAQUAA4ICDwAw
// SIG // ggIKAoICAQD5D92jK33L0Cr+7GeFpucuG7p34eP1r6Ts
// SIG // +kpdkcRXR2sYd2t28v2T5D0PwhaeC2bDVpSeF4OFzlbv
// SIG // 8hb9AGL1IglU6GUXTkG54E9Gl6obyLhuYl5psV/bKgJ+
// SIG // /GzK80HY7dDo/D9hSO2wAxQdEA5LGeC7TuyGZf82815n
// SIG // AgudhlVh/Xo47f7iGQC3b6FQYnV0PKD6yCWStG56Isf4
// SIG // HqHjst2RMasrHQT/pUoEN+mFpDMr/eLWVTR8GaRKaMey
// SIG // qNO3yqGTiOvBl7yM+R3ZIoQkdMcEPWqpKZPM67hb4f5f
// SIG // Jao0WMjBI1SdG5gRwzicfj2GbKUPQIZ8AvRcAk8oy65x
// SIG // nw86yDP+ESU16vy6xWA92XwY1bKp03V4A3IiyjrDH+8s
// SIG // 5S6p+p4stlFG/a8D1upgaOqFFjZrhekewLPdxCTcgCqB
// SIG // QW2UPsjgyYFBAJ5ev3/FCJiiGCxCQLP5bzgnS06A9D2B
// SIG // R+CIfOoczrV1XFEuHCt/GnIo5wC10XTG1+SfrQeTtlM1
// SIG // Nfw35MP2XRa+IXPekgr4oGNqvJaSaj74vGVVm971DYkm
// SIG // BPwlGqYlacvCbcp84llfl6zr7y7IvNcbWTwrzPIZyJNr
// SIG // J2MZz/zpJvjKcZt/k/40Z4ROmev8s3gJM3C6ZqZ27Rtz
// SIG // 6xqlDcQiEyCUVgpOLGxOsf3PnAm6ojPthwIDAQABo4IB
// SIG // UTCCAU0wEgYDVR0TAQH/BAgwBgEB/wIBAjAdBgNVHQ4E
// SIG // FgQU3QQJB6L1en1SUxKSle44gCUNplkwHwYDVR0jBBgw
// SIG // FoAUCHbNywf/JPbFze27kLzihDdGdfcwDgYDVR0PAQH/
// SIG // BAQDAgEGMDYGA1UdHwQvMC0wK6ApoCeGJWh0dHA6Ly9z
// SIG // c2xjb20uY3JsLmNlcnR1bS5wbC9jdG5jYS5jcmwwcwYI
// SIG // KwYBBQUHAQEEZzBlMCkGCCsGAQUFBzABhh1odHRwOi8v
// SIG // c3NsY29tLm9jc3AtY2VydHVtLmNvbTA4BggrBgEFBQcw
// SIG // AoYsaHR0cDovL3NzbGNvbS5yZXBvc2l0b3J5LmNlcnR1
// SIG // bS5wbC9jdG5jYS5jZXIwOgYDVR0gBDMwMTAvBgRVHSAA
// SIG // MCcwJQYIKwYBBQUHAgEWGWh0dHBzOi8vd3d3LmNlcnR1
// SIG // bS5wbC9DUFMwDQYJKoZIhvcNAQELBQADggEBAB+VmiNU
// SIG // 7oXC89RvuekEj0Z/LPcywKdDrAcA7eCpRS39F+HtAEDI
// SIG // r5is9cAZrRuglzBAbOxb+6OTToyJYht88Dpfp0LPWMp1
// SIG // ZZwiTL92e5iTnBWDM7EO3FE4h3yVnBJplB4AeHR+3MAG
// SIG // d7pwLYcs12id47qFrUnzj2S0FQaDksaXpECTi63xZ5S0
// SIG // uVpnVDyoG9kFz+Sk+YgSAAaIJYXUXu7zk1fWgfgsrvf1
// SIG // UUirtmI6edvsLvI/FFY6yNnLpKJPJajRm6stMCBQBxpv
// SIG // 8fGUHTmDY+gf/UnQ6B1GskaCJr2cneGiaEFIUW56/DWW
// SIG // 9FTSvCtE5UfXd4KlSqtflzOrJBEwggb8MIIE5KADAgEC
// SIG // AhBtUhhwh+gjTYVgANCAj5NWMA0GCSqGSIb3DQEBCwUA
// SIG // MHwxCzAJBgNVBAYTAlVTMQ4wDAYDVQQIDAVUZXhhczEQ
// SIG // MA4GA1UEBwwHSG91c3RvbjEYMBYGA1UECgwPU1NMIENv
// SIG // cnBvcmF0aW9uMTEwLwYDVQQDDChTU0wuY29tIFJvb3Qg
// SIG // Q2VydGlmaWNhdGlvbiBBdXRob3JpdHkgUlNBMB4XDTE5
// SIG // MTExMzE4NTAwNVoXDTM0MTExMjE4NTAwNVowczELMAkG
// SIG // A1UEBhMCVVMxDjAMBgNVBAgMBVRleGFzMRAwDgYDVQQH
// SIG // DAdIb3VzdG9uMREwDwYDVQQKDAhTU0wgQ29ycDEvMC0G
// SIG // A1UEAwwmU1NMLmNvbSBUaW1lc3RhbXBpbmcgSXNzdWlu
// SIG // ZyBSU0EgQ0EgUjEwggIiMA0GCSqGSIb3DQEBAQUAA4IC
// SIG // DwAwggIKAoICAQCuURAT0vk8IKAghd7JUBxkyeH9xek0
// SIG // /wp/MUjoclrFXqhh/fGH91Fc+7fm0MHCE7A+wmOiqBj9
// SIG // ODrJAYGq3rm33jCnHSsCBNWAQYyoauLq8IjqsS1JlXL2
// SIG // 9qDNMMdwZ8UNzQS7vWZMDJ40JSGNphMGTIA2qn2bohGt
// SIG // gRc4p1395ESypUOaGvJ3t0FNL3BuKmb6YctMcQUF2sqo
// SIG // oMzd89h0E6ujdvBDo6ZwNnWoxj7YmfWjSXg33A5GuY9y
// SIG // m4QZM5OEVgo8ebz/B+gyhyCLNNhh4Mb/4xvCTCMVmNYr
// SIG // BviGgdPZYrym8Zb84TQCmSuX0JlLLa6WK1aO6qlwISbb
// SIG // 9bVGh866ekKblC/XRP20gAu1CjvcYciUgNTrGFg8f8AJ
// SIG // gQPOCc1/CCdaJSYwhJpSdheKOnQgESgNmYZPhFOC6IKa
// SIG // MAUXk5U1tjTcFCgFvvArXtK4azAWUOO1Y3fdldIBL6Lj
// SIG // kzLUCYJNkFXqhsBVcPMuB0nUDWvLJfPimstjJ8lF4S6E
// SIG // CxWnlWi7OElVwTnt1GtRqeY9ydvvGLntU+FecK7DbqHD
// SIG // Ud366UreMkSBtzevAc9aqoZPnjVMjvFqV1pYOjzmTiVH
// SIG // ZtAc80bAfFe5LLfJzPI6DntNyqobpwTevQpHqPDN9qqN
// SIG // O83r3kaw8A9j+HZiSw2AX5cGdQP0kG0vhzfgBwIDAQAB
// SIG // o4IBgTCCAX0wEgYDVR0TAQH/BAgwBgEB/wIBADAfBgNV
// SIG // HSMEGDAWgBTdBAkHovV6fVJTEpKV7jiAJQ2mWTCBgwYI
// SIG // KwYBBQUHAQEEdzB1MFEGCCsGAQUFBzAChkVodHRwOi8v
// SIG // d3d3LnNzbC5jb20vcmVwb3NpdG9yeS9TU0xjb21Sb290
// SIG // Q2VydGlmaWNhdGlvbkF1dGhvcml0eVJTQS5jcnQwIAYI
// SIG // KwYBBQUHMAGGFGh0dHA6Ly9vY3Nwcy5zc2wuY29tMD8G
// SIG // A1UdIAQ4MDYwNAYEVR0gADAsMCoGCCsGAQUFBwIBFh5o
// SIG // dHRwczovL3d3dy5zc2wuY29tL3JlcG9zaXRvcnkwEwYD
// SIG // VR0lBAwwCgYIKwYBBQUHAwgwOwYDVR0fBDQwMjAwoC6g
// SIG // LIYqaHR0cDovL2NybHMuc3NsLmNvbS9zc2wuY29tLXJz
// SIG // YS1Sb290Q0EuY3JsMB0GA1UdDgQWBBQMnRAljpqnG5mH
// SIG // Q88IfuG9gZD0zzAOBgNVHQ8BAf8EBAMCAYYwDQYJKoZI
// SIG // hvcNAQELBQADggIBAJIZdQ2mWkLPGQfZ8vyU+sCb8BXp
// SIG // RJZaL3Ez3VDlE3uZk3cPxPtybVfLuqaci0W6SB22JTMt
// SIG // tCiQMnIVOsXWnIuAbD/aFTcUkTLBI3xys+wEajzXaXJY
// SIG // WACDS47BRjDtYlDW14gLJxf8W6DQoH3jHDGGy8kGJFOl
// SIG // DKG7/YrK7UGfHtBAEDVe6lyZ+FtCsrk7dD/IiL/+Q3Q6
// SIG // SFASJLQ2XI89ihFugdYL77CiDNXrI2MFspQGswXEAGpH
// SIG // uaQDTHUp/LdR3TyrIsLlnzoLskUGswF/KF8+kpWUiKJN
// SIG // C4rPWtNrxlbXYRGgdEdx8SMjUTDClldcrknlFxbqHsVm
// SIG // r9xkT2QtFmG+dEq1v5fsIK0vHaHrWjMMmaJ9i+4qGJSD
// SIG // 0stYfQ6v0PddT7EpGxGd867Ada6FZyHwbuQSadMb0K0P
// SIG // 0OC2r7rwqBUe0BaMqTa6LWzWItgBjGcObXeMxmbQqlEz
// SIG // 2YtAcErkZvh0WABDDE4U8GyV/32FdaAvJgTfe9MiL2nS
// SIG // BioYe/g5mHUSWAay/Ip1RQmQCvmF9sNfqlhJwkjy/1U1
// SIG // ibUkTIUBX3HgymyQvqQTZLLys6pL2tCdWcjI9YuLw30r
// SIG // gZm8+K387L7ycUvqrmQ3ZJlujHl3r1hgV76s3WwMPgKk
// SIG // 1bAEFMj+rRXimSC+Ev30hXZdqyMdl/il5Ksd0vhGMYIC
// SIG // WDCCAlQCAQEwgYcwczELMAkGA1UEBhMCVVMxDjAMBgNV
// SIG // BAgMBVRleGFzMRAwDgYDVQQHDAdIb3VzdG9uMREwDwYD
// SIG // VQQKDAhTU0wgQ29ycDEvMC0GA1UEAwwmU1NMLmNvbSBU
// SIG // aW1lc3RhbXBpbmcgSXNzdWluZyBSU0EgQ0EgUjECEBrW
// SIG // CKfWNLXN3pfLo8zw0EswCwYJYIZIAWUDBAIBoIIBYTAa
// SIG // BgkqhkiG9w0BCQMxDQYLKoZIhvcNAQkQAQQwHAYJKoZI
// SIG // hvcNAQkFMQ8XDTIzMDMwNjE0NDY0NFowKAYJKoZIhvcN
// SIG // AQk0MRswGTALBglghkgBZQMEAgGhCgYIKoZIzj0EAwIw
// SIG // LwYJKoZIhvcNAQkEMSIEILt2wAG2pPK3dMm3ff0CACAA
// SIG // UJqRjZZNgaliq1TI6EXxMIHJBgsqhkiG9w0BCRACLzGB
// SIG // uTCBtjCBszCBsAQgjcXEJULSTxXP9cgZbtRag2jUyta9
// SIG // y+Qhqd4jUJ2L0yIwgYswd6R1MHMxCzAJBgNVBAYTAlVT
// SIG // MQ4wDAYDVQQIDAVUZXhhczEQMA4GA1UEBwwHSG91c3Rv
// SIG // bjERMA8GA1UECgwIU1NMIENvcnAxLzAtBgNVBAMMJlNT
// SIG // TC5jb20gVGltZXN0YW1waW5nIElzc3VpbmcgUlNBIENB
// SIG // IFIxAhAa1gin1jS1zd6Xy6PM8NBLMAoGCCqGSM49BAMC
// SIG // BEcwRQIhAIP2NIG3qcQxSrs95tAGr2Ax3KVyykkJr0U6
// SIG // mJpGV9k1AiAHoLtJGzCes2if6JmigWAmOgNRTnab0lls
// SIG // 9eYRRDli6A==
// SIG // End signature block